(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire96e8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire96e8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6l1Gi", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $49d6021879590dc9$export$a48f0734ac7c2329; }, function (v) { return $49d6021879590dc9$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $49d6021879590dc9$export$d622b2ad8d90c771; }, function (v) { return $49d6021879590dc9$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $49d6021879590dc9$export$6100ba28696e12de; }, function (v) { return $49d6021879590dc9$export$6100ba28696e12de = v; });
var $49d6021879590dc9$export$a48f0734ac7c2329;
var $49d6021879590dc9$export$d622b2ad8d90c771;
var $49d6021879590dc9$export$6100ba28696e12de;
"use strict";
$49d6021879590dc9$export$a48f0734ac7c2329 = $49d6021879590dc9$var$byteLength;
$49d6021879590dc9$export$d622b2ad8d90c771 = $49d6021879590dc9$var$toByteArray;
$49d6021879590dc9$export$6100ba28696e12de = $49d6021879590dc9$var$fromByteArray;
var $49d6021879590dc9$var$lookup = [];
var $49d6021879590dc9$var$revLookup = [];
var $49d6021879590dc9$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $49d6021879590dc9$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $49d6021879590dc9$var$i = 0, $49d6021879590dc9$var$len = $49d6021879590dc9$var$code.length; $49d6021879590dc9$var$i < $49d6021879590dc9$var$len; ++$49d6021879590dc9$var$i){
    $49d6021879590dc9$var$lookup[$49d6021879590dc9$var$i] = $49d6021879590dc9$var$code[$49d6021879590dc9$var$i];
    $49d6021879590dc9$var$revLookup[$49d6021879590dc9$var$code.charCodeAt($49d6021879590dc9$var$i)] = $49d6021879590dc9$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$49d6021879590dc9$var$revLookup["-".charCodeAt(0)] = 62;
$49d6021879590dc9$var$revLookup["_".charCodeAt(0)] = 63;
function $49d6021879590dc9$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $49d6021879590dc9$var$byteLength(b64) {
    var lens = $49d6021879590dc9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $49d6021879590dc9$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $49d6021879590dc9$var$toByteArray(b64) {
    var tmp;
    var lens = $49d6021879590dc9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $49d6021879590dc9$var$Arr($49d6021879590dc9$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $49d6021879590dc9$var$revLookup[b64.charCodeAt(i)] << 18 | $49d6021879590dc9$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $49d6021879590dc9$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $49d6021879590dc9$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $49d6021879590dc9$var$revLookup[b64.charCodeAt(i)] << 2 | $49d6021879590dc9$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $49d6021879590dc9$var$revLookup[b64.charCodeAt(i)] << 10 | $49d6021879590dc9$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $49d6021879590dc9$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $49d6021879590dc9$var$tripletToBase64(num) {
    return $49d6021879590dc9$var$lookup[num >> 18 & 0x3F] + $49d6021879590dc9$var$lookup[num >> 12 & 0x3F] + $49d6021879590dc9$var$lookup[num >> 6 & 0x3F] + $49d6021879590dc9$var$lookup[num & 0x3F];
}
function $49d6021879590dc9$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($49d6021879590dc9$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $49d6021879590dc9$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($49d6021879590dc9$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($49d6021879590dc9$var$lookup[tmp >> 2] + $49d6021879590dc9$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($49d6021879590dc9$var$lookup[tmp >> 10] + $49d6021879590dc9$var$lookup[tmp >> 4 & 0x3F] + $49d6021879590dc9$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("gHFi0", function(module, exports) {
"use strict";
var $03235db054fd8926$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $03235db054fd8926$var$ALPHABET_MAP = {};
for(var $03235db054fd8926$var$z = 0; $03235db054fd8926$var$z < $03235db054fd8926$var$ALPHABET.length; $03235db054fd8926$var$z++){
    var $03235db054fd8926$var$x = $03235db054fd8926$var$ALPHABET.charAt($03235db054fd8926$var$z);
    if ($03235db054fd8926$var$ALPHABET_MAP[$03235db054fd8926$var$x] !== undefined) throw new TypeError($03235db054fd8926$var$x + " is ambiguous");
    $03235db054fd8926$var$ALPHABET_MAP[$03235db054fd8926$var$x] = $03235db054fd8926$var$z;
}
function $03235db054fd8926$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $03235db054fd8926$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $03235db054fd8926$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $03235db054fd8926$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $03235db054fd8926$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $03235db054fd8926$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $03235db054fd8926$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $03235db054fd8926$var$polymodStep(chk) ^ x;
        result += $03235db054fd8926$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $03235db054fd8926$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $03235db054fd8926$var$ALPHABET.charAt(v);
    }
    return result;
}
function $03235db054fd8926$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $03235db054fd8926$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $03235db054fd8926$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $03235db054fd8926$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $03235db054fd8926$var$decodeUnsafe() {
    var res = $03235db054fd8926$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $03235db054fd8926$var$decode(str) {
    var res = $03235db054fd8926$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $03235db054fd8926$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $03235db054fd8926$var$toWordsUnsafe(bytes) {
    var res = $03235db054fd8926$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $03235db054fd8926$var$toWords(bytes) {
    var res = $03235db054fd8926$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $03235db054fd8926$var$fromWordsUnsafe(words) {
    var res = $03235db054fd8926$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $03235db054fd8926$var$fromWords(words) {
    var res = $03235db054fd8926$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $03235db054fd8926$var$decodeUnsafe,
    decode: $03235db054fd8926$var$decode,
    encode: $03235db054fd8926$var$encode,
    toWordsUnsafe: $03235db054fd8926$var$toWordsUnsafe,
    toWords: $03235db054fd8926$var$toWords,
    fromWordsUnsafe: $03235db054fd8926$var$fromWordsUnsafe,
    fromWords: $03235db054fd8926$var$fromWords
};

});

parcelRegister("ikOdQ", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var _$r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], _$a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < _$a.length; _++)"function" == typeof t["_" + _$r[_]] && (e[_$r[_]] = _$a[_]);
                var _$n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < _$n.length; _++)"function" == typeof (_$c = t["_" + _$n[_].toLowerCase()]) && (e[_$n[_]] = _$c());
                var _$s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < _$s.length; _++){
                    var _$c;
                    "function" == typeof (_$c = t["_" + _$s[_].toLowerCase()]) && (e[_$s[_]] = t.UTF8ToString(_$c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), _$n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), _$s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), _$c = e.crypto_secretbox_easy(_, _$n, _$s), o = e.crypto_secretbox_open_easy(_$c, _$n, _$s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var _$r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)_$r[t] = e.charCodeAt(t);
            return _$r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var _$r = 8192, t = Math.ceil(e.length / _$r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, _$n = 0; _$n < t; _$n++){
                var _$c = Array.prototype.slice.call(e, _$n * _$r + _, (_$n + 1) * _$r + _);
                if (0 != _$c.length) {
                    var o, h = _$c.length, _$p = 0;
                    do {
                        var y = _$c[--h];
                        y >= 240 ? (_$p = 4, o = !0) : y >= 224 ? (_$p = 3, o = !0) : y >= 192 ? (_$p = 2, o = !0) : y < 128 && (_$p = 1, o = !0);
                    }while (!o);
                    for(var i = _$p - (_$c.length - h), l = 0; l < i; l++)_--, _$c.pop();
                    a += s(_$c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var _$r, t, a, _ = "", _$n = 0; _$n < e.length; _$n++)a = 87 + (t = 15 & e[_$n]) + (t - 10 >> 8 & -39) << 8 | 87 + (_$r = e[_$n] >>> 4) + (_$r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], _$n = 0 | Math.floor(e.length / 3), _$c = e.length - 3 * _$n, o = 4 * _$n + (0 !== _$c ? 0 == (2 & r) ? 4 : 2 + (_$c >>> 1) : 0), _$p = new u(o + 1), y = d(e);
            return _.push(y), _.push(_$p.address), 0 === t._sodium_bin2base64(_$p.address, _$p.length, y, e.length, r) && b(_, "conversion failed"), _$p.length = o, a = s(_$p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), _$n = {}, h = 0; h < _.length; h++)_$n[_[h]] = y(e[_[h]], t);
                return _$n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var _$r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < _$r.length; t++)if (_$r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var _$r = v(e.length);
            return t.HEAPU8.set(e, _$r), _$r;
        }
        function v(e) {
            var _$r = t._malloc(e);
            if (0 === _$r) throw {
                message: "_malloc() failed",
                length: e
            };
            return _$r;
        }
        function g(e) {
            if (e) for(var _$r = 0; _$r < e.length; _$r++)a = e[_$r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(_$c, e, "secret_nonce")), e.length, _$c.push(o)), r = x(_$c, r, "ciphertext");
            var h, _$p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < _$p && f(_$c, "ciphertext is too short"), h = d(r), _$c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(_$c, a, "additional_data")), m = a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(_$c, "invalid public_nonce length"), E = d(_), _$c.push(E), n = x(_$c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(_$c, "invalid key length"), S = d(n), _$c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (_$c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var _$p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(_$p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, _$p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (_$c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(_$c), Y;
            }
            b(_$c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(0 | h), w = T.address;
            _$c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (_$c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(_$c), A;
            }
            b(_$c, "invalid usage");
        }
        function w(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Y(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(_$c, e, "secret_nonce")), e.length, _$c.push(o)), r = x(_$c, r, "ciphertext");
            var h, _$p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < _$p && f(_$c, "ciphertext is too short"), h = d(r), _$c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(_$c, a, "additional_data")), m = a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(_$c, "invalid public_nonce length"), E = d(_), _$c.push(E), n = x(_$c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(_$c, "invalid key length"), S = d(n), _$c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (_$c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var _$p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(_$p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, _$p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (_$c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(_$c), Y;
            }
            b(_$c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(0 | h), w = T.address;
            _$c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (_$c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(_$c), A;
            }
            b(_$c, "invalid usage");
        }
        function M(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_aead_aegis256_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function I(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(_$c, e, "secret_nonce")), e.length, _$c.push(o)), r = x(_$c, r, "ciphertext");
            var h, _$p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < _$p && f(_$c, "ciphertext is too short"), h = d(r), _$c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(_$c, a, "additional_data")), m = a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(_$c, "invalid public_nonce length"), E = d(_), _$c.push(E), n = x(_$c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(_$c, "invalid key length"), S = d(n), _$c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (_$c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var _$p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(_$p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, _$p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (_$c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(_$c), Y;
            }
            b(_$c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(0 | h), w = T.address;
            _$c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (_$c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(_$c), A;
            }
            b(_$c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(_$c, e, "secret_nonce")), e.length, _$c.push(o)), r = x(_$c, r, "ciphertext");
            var h, _$p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < _$p && f(_$c, "ciphertext is too short"), h = d(r), _$c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(_$c, a, "additional_data")), m = a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(_$c, "invalid public_nonce length"), E = d(_), _$c.push(E), n = x(_$c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(_$c, "invalid key length"), S = d(n), _$c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (_$c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var _$p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(_$p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, _$p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (_$c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(_$c), Y;
            }
            b(_$c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(0 | h), w = T.address;
            _$c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (_$c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(_$c), A;
            }
            b(_$c, "invalid usage");
        }
        function G(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function X(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function D(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(_$c, e, "secret_nonce")), e.length, _$c.push(o)), r = x(_$c, r, "ciphertext");
            var h, _$p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < _$p && f(_$c, "ciphertext is too short"), h = d(r), _$c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(_$c, a, "additional_data")), m = a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(_$c, "invalid public_nonce length"), E = d(_), _$c.push(E), n = x(_$c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(_$c, "invalid key length"), S = d(n), _$c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (_$c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var _$p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(_$p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, _$p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (_$c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(_$c), Y;
            }
            b(_$c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "message")), h = e.length;
            _$c.push(o);
            var _$p = null, i = 0;
            null != r && (_$p = d(r = x(_$c, r, "additional_data")), i = r.length, _$c.push(_$p));
            var v = null;
            null != a && (v = d(a = x(_$c, a, "secret_nonce")), a.length, _$c.push(v)), _ = x(_$c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(_$c, "invalid public_nonce length"), m = d(_), _$c.push(m), n = x(_$c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(_$c, "invalid key length"), k = d(n), _$c.push(k);
            var T = new u(0 | h), w = T.address;
            _$c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (_$c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, _$p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(_$c), A;
            }
            b(_$c, "invalid usage");
        }
        function q(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_auth_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_auth(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_auth_hmacsha256(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), _$n = _.address;
            if (a.push(_$n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, _$n))) {
                var _$s = (t._free(e), y(_, r));
                return g(a), _$s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, _$n = 0;
            null != e && (_ = d(e = x(a, e, "key")), _$n = e.length, a.push(_));
            var _$s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(_$s, _, _$n))) {
                var _$c = _$s;
                return g(a), _$c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, _$n, _$s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var _$n, _$s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== _$s && f(_, "invalid tag length"), _$n = d(e), _.push(_$n);
            var _$c = d(r = x(_, r, "message")), o = r.length;
            _.push(_$c), a = x(_, a, "key");
            var h, _$p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== _$p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(_$n, _$c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_auth_hmacsha512(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), _$n = _.address;
            if (a.push(_$n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, _$n))) {
                var _$s = (t._free(e), y(_, r));
                return g(a), _$s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, _$n = 0;
            null != e && (_ = d(e = x(a, e, "key")), _$n = e.length, a.push(_));
            var _$s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(_$s, _, _$n))) {
                var _$c = _$s;
                return g(a), _$c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, _$n, _$s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var _$n, _$s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== _$s && f(_, "invalid tag length"), _$n = d(e), _.push(_$n);
            var _$c = d(r = x(_, r, "message")), o = r.length;
            _.push(_$c), a = x(_, a, "key");
            var h, _$p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== _$p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(_$n, _$c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_auth_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var _$n, _$s = 0 | t._crypto_auth_bytes();
            e.length !== _$s && f(_, "invalid tag length"), _$n = d(e), _.push(_$n);
            var _$c = d(r = x(_, r, "message")), o = r.length;
            _.push(_$c), a = x(_, a, "key");
            var h, _$p = 0 | t._crypto_auth_keybytes();
            a.length !== _$p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(_$n, _$c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var _$n, _$s = 0 | t._crypto_box_publickeybytes();
            e.length !== _$s && f(_, "invalid publicKey length"), _$n = d(e), _.push(_$n), r = x(_, r, "privateKey");
            var _$c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_box_beforenm(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var _$n, _$s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== _$s && f(_, "invalid publicKey length"), _$n = d(e), _.push(_$n), r = x(_, r, "privateKey");
            var _$c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), a = x(_$s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(_$s, "invalid publicKey length"), i = d(a), _$s.push(i), _ = x(_$s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(_$s, "invalid privateKey length"), m = d(_), _$s.push(m);
            var k = new u(0 | o), S = k.address;
            _$s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (_$s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, _$c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(_$s), Y;
            }
            b(_$s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "sharedKey");
            var _$p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(_$n, "invalid sharedKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | _$c), m = v.address;
            _$n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (_$n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, _$s, _$c, 0, o, _$p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(_$n), S;
            }
            b(_$n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), a = x(_$s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(_$s, "invalid publicKey length"), i = d(a), _$s.push(i), _ = x(_$s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(_$s, "invalid privateKey length"), m = d(_), _$s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (_$s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, _$c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(_$s), T;
            }
            b(_$s, "invalid usage");
        }
        function le(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "sharedKey");
            var _$p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(_$n, "invalid sharedKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(_$c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (_$n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, _$s, _$c, 0, o, _$p))) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "invalid usage");
        }
        function ue(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            _$r.push(_);
            var _$n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), _$s = _$n.address;
            _$r.push(_$s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, _$s);
            var _$c = y({
                publicKey: a,
                privateKey: _$n,
                keyType: "curve25519"
            }, e);
            return g(_$r), _$c;
        }
        function de(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "ciphertext")), h = e.length;
            _$c.push(o), r = x(_$c, r, "mac");
            var _$p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(_$c, "invalid mac length"), _$p = d(r), _$c.push(_$p), a = x(_$c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(_$c, "invalid nonce length"), v = d(a), _$c.push(v), _ = x(_$c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(_$c, "invalid publicKey length"), E = d(_), _$c.push(E), n = x(_$c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(_$c, "invalid privateKey length"), S = d(n), _$c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (_$c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, _$p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "ciphertext")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "mac");
            var h, _$p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== _$p && f(_$s, "invalid mac length"), h = d(r), _$s.push(h), a = x(_$s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(_$s, "invalid nonce length"), i = d(a), _$s.push(i), _ = x(_$s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(_$s, "invalid sharedKey length"), m = d(_), _$s.push(m);
            var k = new u(0 | o), S = k.address;
            if (_$s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, _$c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(_$s), T;
            }
            b(_$s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var _$s = [];
            l(n), e = x(_$s, e, "ciphertext");
            var _$c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(_$s, "ciphertext is too short"), _$c = d(e), _$s.push(_$c), r = x(_$s, r, "nonce");
            var _$p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(_$s, "invalid nonce length"), _$p = d(r), _$s.push(_$p), a = x(_$s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(_$s, "invalid publicKey length"), v = d(a), _$s.push(v), _ = x(_$s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(_$s, "invalid privateKey length"), E = d(_), _$s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (_$s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, _$c, h, 0, _$p, v, E))) {
                var w = y(S, n);
                return g(_$s), w;
            }
            b(_$s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "ciphertext")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "sharedKey");
            var _$p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(_$n, "invalid sharedKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(_$c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (_$n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, _$s, _$c, 0, o, _$p))) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "publicKey");
            var _$c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), _$c = d(r), _.push(_$c);
            var h = new u(_$s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), _$p = h.address;
            _.push(_$p), t._crypto_box_curve25519xchacha20poly1305_seal(_$p, _$n, _$s, 0, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "ciphertext");
            var _$s, _$c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < _$c && f(_$n, "ciphertext is too short"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "publicKey");
            var h, _$p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== _$p && f(_$n, "invalid publicKey length"), h = d(r), _$n.push(h), a = x(_$n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(_$n, "invalid secretKey length"), i = d(a), _$n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            _$n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, _$s, o, 0, h, i);
            var E = y(b, _);
            return g(_$n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, _$n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== _$n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _$c = _$s.address;
            a.push(_$c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(_$c, h, _))) {
                var _$p = {
                    publicKey: y(_$s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), _$p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_box_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), a = x(_$s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(_$s, "invalid publicKey length"), i = d(a), _$s.push(i), _ = x(_$s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(_$s, "invalid privateKey length"), m = d(_), _$s.push(m);
            var k = new u(0 | o), S = k.address;
            _$s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (_$s.push(w), 0 == (0 | t._crypto_box_detached(S, w, _$c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(_$s), Y;
            }
            b(_$s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_box_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), a = x(_$s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(_$s, "invalid publicKey length"), i = d(a), _$s.push(i), _ = x(_$s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(_$s, "invalid privateKey length"), m = d(_), _$s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (_$s.push(S), 0 == (0 | t._crypto_box_easy(S, _$c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(_$s), T;
            }
            b(_$s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "sharedKey");
            var _$p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(_$n, "invalid sharedKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(_$c + t._crypto_box_macbytes() | 0), m = v.address;
            if (_$n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, _$s, _$c, 0, o, _$p))) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "invalid usage");
        }
        function Te(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            _$r.push(_);
            var _$n = new u(0 | t._crypto_box_secretkeybytes()), _$s = _$n.address;
            if (_$r.push(_$s), 0 == (0 | t._crypto_box_keypair(_, _$s))) {
                var _$c = {
                    publicKey: y(a, e),
                    privateKey: y(_$n, e),
                    keyType: "x25519"
                };
                return g(_$r), _$c;
            }
            b(_$r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var _$c = [];
            l(s);
            var o = d(e = x(_$c, e, "ciphertext")), h = e.length;
            _$c.push(o), r = x(_$c, r, "mac");
            var _$p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(_$c, "invalid mac length"), _$p = d(r), _$c.push(_$p), a = x(_$c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(_$c, "invalid nonce length"), v = d(a), _$c.push(v), _ = x(_$c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(_$c, "invalid publicKey length"), E = d(_), _$c.push(E), n = x(_$c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(_$c, "invalid privateKey length"), S = d(n), _$c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (_$c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, _$p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(_$c), B;
            }
            b(_$c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var _$s = [];
            l(n), e = x(_$s, e, "ciphertext");
            var _$c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(_$s, "ciphertext is too short"), _$c = d(e), _$s.push(_$c), r = x(_$s, r, "nonce");
            var _$p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(_$s, "invalid nonce length"), _$p = d(r), _$s.push(_$p), a = x(_$s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(_$s, "invalid publicKey length"), v = d(a), _$s.push(v), _ = x(_$s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(_$s, "invalid privateKey length"), E = d(_), _$s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (_$s.push(T), 0 == (0 | t._crypto_box_open_easy(T, _$c, h, 0, _$p, v, E))) {
                var w = y(S, n);
                return g(_$s), w;
            }
            b(_$s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "ciphertext")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "sharedKey");
            var _$p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(_$n, "invalid sharedKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(_$c - t._crypto_box_macbytes() | 0), m = v.address;
            if (_$n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, _$s, _$c, 0, o, _$p))) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "publicKey");
            var _$c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), _$c = d(r), _.push(_$c);
            var h = new u(_$s + t._crypto_box_sealbytes() | 0), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_box_seal(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "ciphertext");
            var _$s, _$c = t._crypto_box_sealbytes(), o = e.length;
            o < _$c && f(_$n, "ciphertext is too short"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "publicKey");
            var h, _$p = 0 | t._crypto_box_publickeybytes();
            r.length !== _$p && f(_$n, "invalid publicKey length"), h = d(r), _$n.push(h), a = x(_$n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(_$n, "invalid privateKey length"), i = d(a), _$n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (_$n.push(E), 0 == (0 | t._crypto_box_seal_open(E, _$s, o, 0, h, i))) {
                var k = y(m, _);
                return g(_$n), k;
            }
            b(_$n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, _$n = 0 | t._crypto_box_seedbytes();
            e.length !== _$n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_box_publickeybytes()), _$c = _$s.address;
            a.push(_$c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(_$c, h, _))) {
                var _$p = {
                    publicKey: y(_$s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), _$p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var _$n, _$s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== _$s && f(_, "invalid p length"), _$n = d(e), _.push(_$n), r = x(_, r, "q");
            var _$c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_core_ed25519_add(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var _$n = new u(0 | t._crypto_core_ed25519_bytes()), _$s = _$n.address;
            if (a.push(_$s), 0 == (0 | t._crypto_core_ed25519_from_hash(_$s, _))) {
                var _$c = y(_$n, r);
                return g(a), _$c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var _$n = new u(0 | t._crypto_core_ed25519_bytes()), _$s = _$n.address;
            if (a.push(_$s), 0 == (0 | t._crypto_core_ed25519_from_uniform(_$s, _))) {
                var _$c = y(_$n, r);
                return g(a), _$c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, _$n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== _$n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var _$s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), _$s;
        }
        function Oe(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            _$r.push(_), t._crypto_core_ed25519_random(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var _$n, _$s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== _$s && f(_, "invalid x length"), _$n = d(e), _.push(_$n), r = x(_, r, "y");
            var _$c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$p = h.address;
            _.push(_$p), t._crypto_core_ed25519_scalar_add(_$p, _$n, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, _$n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== _$n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$c = _$s.address;
            a.push(_$c), t._crypto_core_ed25519_scalar_complement(_$c, _);
            var o = y(_$s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, _$n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== _$n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var _$n, _$s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== _$s && f(_, "invalid x length"), _$n = d(e), _.push(_$n), r = x(_, r, "y");
            var _$c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$p = h.address;
            _.push(_$p), t._crypto_core_ed25519_scalar_mul(_$p, _$n, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, _$n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== _$n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$c = _$s.address;
            a.push(_$c), t._crypto_core_ed25519_scalar_negate(_$c, _);
            var o = y(_$s, r);
            return g(a), o;
        }
        function De(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            _$r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, _$n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== _$n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$c = _$s.address;
            a.push(_$c), t._crypto_core_ed25519_scalar_reduce(_$c, _);
            var o = y(_$s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var _$n, _$s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== _$s && f(_, "invalid x length"), _$n = d(e), _.push(_$n), r = x(_, r, "y");
            var _$c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), _$p = h.address;
            _.push(_$p), t._crypto_core_ed25519_scalar_sub(_$p, _$n, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var _$n, _$s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== _$s && f(_, "invalid p length"), _$n = d(e), _.push(_$n), r = x(_, r, "q");
            var _$c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_core_ed25519_sub(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "input");
            var _$s, _$c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== _$c && f(_$n, "invalid input length"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(_$n, "invalid privateKey length"), o = d(r), _$n.push(o);
            var _$p = null;
            null != a && (_$p = d(a = x(_$n, a, "constant")), a.length, _$n.push(_$p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (_$n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, _$s, o, _$p))) {
                var m = y(i, _);
                return g(_$n), m;
            }
            b(_$n, "invalid usage");
        }
        function je(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "input");
            var _$s, _$c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== _$c && f(_$n, "invalid input length"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(_$n, "invalid privateKey length"), o = d(r), _$n.push(o);
            var _$p = null;
            null != a && (_$p = d(a = x(_$n, a, "constant")), a.length, _$n.push(_$p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (_$n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, _$s, o, _$p))) {
                var m = y(i, _);
                return g(_$n), m;
            }
            b(_$n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var _$n, _$s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== _$s && f(_, "invalid p length"), _$n = d(e), _.push(_$n), r = x(_, r, "q");
            var _$c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_core_ristretto255_add(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var _$n = new u(0 | t._crypto_core_ristretto255_bytes()), _$s = _$n.address;
            if (a.push(_$s), 0 == (0 | t._crypto_core_ristretto255_from_hash(_$s, _))) {
                var _$c = y(_$n, r);
                return g(a), _$c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, _$n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== _$n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var _$s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), _$s;
        }
        function Qe(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            _$r.push(_), t._crypto_core_ristretto255_random(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var _$n, _$s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$s && f(_, "invalid x length"), _$n = d(e), _.push(_$n), r = x(_, r, "y");
            var _$c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$p = h.address;
            _.push(_$p), t._crypto_core_ristretto255_scalar_add(_$p, _$n, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, _$n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$c = _$s.address;
            a.push(_$c), t._crypto_core_ristretto255_scalar_complement(_$c, _);
            var o = y(_$s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, _$n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var _$n, _$s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$s && f(_, "invalid x length"), _$n = d(e), _.push(_$n), r = x(_, r, "y");
            var _$c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$p = h.address;
            _.push(_$p), t._crypto_core_ristretto255_scalar_mul(_$p, _$n, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, _$n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$c = _$s.address;
            a.push(_$c), t._crypto_core_ristretto255_scalar_negate(_$c, _);
            var o = y(_$s, r);
            return g(a), o;
        }
        function ar(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            _$r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, _$n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== _$n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$c = _$s.address;
            a.push(_$c), t._crypto_core_ristretto255_scalar_reduce(_$c, _);
            var o = y(_$s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var _$n, _$s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$s && f(_, "invalid x length"), _$n = d(e), _.push(_$n), r = x(_, r, "y");
            var _$c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _$p = h.address;
            _.push(_$p), t._crypto_core_ristretto255_scalar_sub(_$p, _$n, _$c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var _$n, _$s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== _$s && f(_, "invalid p length"), _$n = d(e), _.push(_$n), r = x(_, r, "q");
            var _$c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_core_ristretto255_sub(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var _$n = [];
            l(_), m(_$n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_$n, "hash_length must be an unsigned integer");
            var _$s = d(r = x(_$n, r, "message")), _$c = r.length;
            _$n.push(_$s);
            var o = null, h = 0;
            null != a && (o = d(a = x(_$n, a, "key")), h = a.length, _$n.push(o));
            var _$p = new u(e |= 0), i = _$p.address;
            if (_$n.push(i), 0 == (0 | t._crypto_generichash(i, e, _$s, _$c, 0, o, h))) {
                var v = y(_$p, _);
                return g(_$n), v;
            }
            b(_$n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var _$s = [];
            l(n), m(_$s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_$s, "subkey_len must be an unsigned integer");
            var _$c = null, o = 0;
            null != r && (_$c = d(r = x(_$s, r, "key")), o = r.length, _$s.push(_$c));
            var h = null, _$p = 0;
            null != a && (a = x(_$s, a, "id"), _$p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== _$p && f(_$s, "invalid id length"), h = d(a), _$s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(_$s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(_$s, "invalid ctx length"), i = d(_), _$s.push(i));
            var E = new u(0 | e), k = E.address;
            if (_$s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, _$c, o, h, i))) {
                var S = y(E, n);
                return g(_$s), S;
            }
            b(_$s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var _$n = new u(r |= 0), _$s = _$n.address;
            if (_.push(_$s), 0 == (0 | t._crypto_generichash_final(e, _$s, r))) {
                var _$c = (t._free(e), y(_$n, a));
                return g(_), _$c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var _$n = null, _$s = 0;
            null != e && (_$n = d(e = x(_, e, "key")), _$s = e.length, _.push(_$n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var _$c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(_$c, _$n, _$s, r))) {
                var o = _$c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_generichash_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_generichash_update(e, _$n, _$s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), _$n = e.length;
            a.push(_);
            var _$s = new u(0 | t._crypto_hash_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_hash(_$c, _, _$n, 0))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), _$n = e.length;
            a.push(_);
            var _$s = new u(0 | t._crypto_hash_sha256_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_hash_sha256(_$c, _, _$n, 0))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), _$n = _.address;
            if (a.push(_$n), 0 == (0 | t._crypto_hash_sha256_final(e, _$n))) {
                var _$s = (t._free(e), y(_, r));
                return g(a), _$s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var _$r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(_$r), _;
            }
            b(_$r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_hash_sha256_update(e, _$n, _$s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), _$n = e.length;
            a.push(_);
            var _$s = new u(0 | t._crypto_hash_sha512_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_hash_sha512(_$c, _, _$n, 0))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), _$n = _.address;
            if (a.push(_$n), 0 == (0 | t._crypto_hash_sha512_final(e, _$n))) {
                var _$s = (t._free(e), y(_, r));
                return g(a), _$s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var _$r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(_$r), _;
            }
            b(_$r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_hash_sha512_update(e, _$n, _$s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var _$c = [];
            l(s), m(_$c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_$c, "subkey_len must be an unsigned integer"), m(_$c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_$c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(_$c, "ctx must be a string"), a = n(a + "\x00"), null != h && a.length - 1 !== h && f(_$c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            _$c.push(o), _ = x(_$c, _, "key");
            var _$p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(_$c, "invalid key length"), _$p = d(_), _$c.push(_$p);
            var v = new u(0 | e), b = v.address;
            _$c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, _$p);
            var E = y(v, s);
            return g(_$c), E;
        }
        function kr(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_kdf_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Sr(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "clientPublicKey");
            var _$s, _$c = 0 | t._crypto_kx_publickeybytes();
            e.length !== _$c && f(_$n, "invalid clientPublicKey length"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(_$n, "invalid clientSecretKey length"), o = d(r), _$n.push(o), a = x(_$n, a, "serverPublicKey");
            var _$p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(_$n, "invalid serverPublicKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            _$n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (_$n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, _$s, o, _$p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(_$n), S;
            }
            b(_$n, "invalid usage");
        }
        function Tr(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            _$r.push(_);
            var _$n = new u(0 | t._crypto_kx_secretkeybytes()), _$s = _$n.address;
            if (_$r.push(_$s), 0 == (0 | t._crypto_kx_keypair(_, _$s))) {
                var _$c = {
                    publicKey: y(a, e),
                    privateKey: y(_$n, e),
                    keyType: "x25519"
                };
                return g(_$r), _$c;
            }
            b(_$r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, _$n = 0 | t._crypto_kx_seedbytes();
            e.length !== _$n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_kx_publickeybytes()), _$c = _$s.address;
            a.push(_$c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(_$c, h, _))) {
                var _$p = {
                    publicKey: y(_$s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), _$p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "serverPublicKey");
            var _$s, _$c = 0 | t._crypto_kx_publickeybytes();
            e.length !== _$c && f(_$n, "invalid serverPublicKey length"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(_$n, "invalid serverSecretKey length"), o = d(r), _$n.push(o), a = x(_$n, a, "clientPublicKey");
            var _$p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(_$n, "invalid clientPublicKey length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            _$n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (_$n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, _$s, o, _$p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(_$n), S;
            }
            b(_$n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_onetimeauth(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), _$n = _.address;
            if (a.push(_$n), 0 == (0 | t._crypto_onetimeauth_final(e, _$n))) {
                var _$s = (t._free(e), y(_, r));
                return g(a), _$s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var _$n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(_$n, _))) {
                var _$s = _$n;
                return g(a), _$s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_onetimeauth_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_onetimeauth_update(e, _$n, _$s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var _$n, _$s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== _$s && f(_, "invalid hash length"), _$n = d(e), _.push(_$n);
            var _$c = d(r = x(_, r, "message")), o = r.length;
            _.push(_$c), a = x(_, a, "key");
            var h, _$p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== _$p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(_$n, _$c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), _$p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, _$p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var _$c = [];
            l(s), m(_$c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_$c, "keyLength must be an unsigned integer");
            var o = d(r = x(_$c, r, "password")), h = r.length;
            _$c.push(o), a = x(_$c, a, "salt");
            var _$p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(_$c, "invalid salt length"), _$p = d(a), _$c.push(_$p), m(_$c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(_$c, "opsLimit must be an unsigned integer"), m(_$c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(_$c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (_$c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, _$p, _, 0, n))) {
                var k = y(v, s);
                return g(_$c), k;
            }
            b(_$c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), _$p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, _$p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "password")), _$c = e.length;
            _$n.push(_$s), m(_$n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_$n, "opsLimit must be an unsigned integer"), m(_$n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(_$n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (_$n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, _$s, _$c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(_$n), h;
            }
            b(_$n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != _$c && e.length - 1 !== _$c && f(_, "invalid hashed_password length");
            var _$s = d(e), _$c = e.length - 1;
            _.push(_$s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var _$p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(_$s, o, h, 0));
            return g(_), _$p;
        }
        function Pr(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "password")), _$c = e.length;
            _$n.push(_$s), m(_$n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_$n, "opsLimit must be an unsigned integer"), m(_$n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(_$n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (_$n.push(o), 0 == (0 | t._crypto_pwhash_str(o, _$s, _$c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(_$n), h;
            }
            b(_$n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var _$s = [];
            l(_), "string" != typeof e && f(_$s, "hashed_password must be a string"), e = n(e + "\x00"), null != o && e.length - 1 !== o && f(_$s, "invalid hashed_password length");
            var _$c = d(e), o = e.length - 1;
            _$s.push(_$c), m(_$s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_$s, "opsLimit must be an unsigned integer"), m(_$s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(_$s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(_$c, r, 0, a));
            return g(_$s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != _$c && e.length - 1 !== _$c && f(_, "invalid hashed_password length");
            var _$s = d(e), _$c = e.length - 1;
            _.push(_$s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var _$p = 0 == (0 | t._crypto_pwhash_str_verify(_$s, o, h, 0));
            return g(_), _$p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var _$n, _$s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== _$s && f(_, "invalid privateKey length"), _$n = d(e), _.push(_$n), r = x(_, r, "publicKey");
            var _$c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_scalarmult(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, _$n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== _$n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_scalarmult_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_scalarmult_base(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var _$n, _$s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== _$s && f(_, "invalid n length"), _$n = d(e), _.push(_$n), r = x(_, r, "p");
            var _$c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_scalarmult_ed25519(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, _$n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== _$n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_scalarmult_ed25519_base(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, _$n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== _$n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var _$n, _$s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== _$s && f(_, "invalid n length"), _$n = d(e), _.push(_$n), r = x(_, r, "p");
            var _$c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var _$n, _$s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== _$s && f(_, "invalid scalar length"), _$n = d(e), _.push(_$n), r = x(_, r, "element");
            var _$c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_scalarmult_ristretto255(_$p, _$n, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, _$n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== _$n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_core_ristretto255_bytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "key");
            var _$p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(_$n, "invalid key length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | _$c), m = v.address;
            _$n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (_$n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, _$s, _$c, 0, o, _$p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(_$n), S;
            }
            b(_$n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "key");
            var _$p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(_$n, "invalid key length"), _$p = d(a), _$n.push(_$p);
            var v = new u(_$c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (_$n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, _$s, _$c, 0, o, _$p))) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "invalid usage");
        }
        function Zr(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_secretbox_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function $r(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "ciphertext")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "mac");
            var h, _$p = 0 | t._crypto_secretbox_macbytes();
            r.length !== _$p && f(_$s, "invalid mac length"), h = d(r), _$s.push(h), a = x(_$s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(_$s, "invalid nonce length"), i = d(a), _$s.push(i), _ = x(_$s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(_$s, "invalid key length"), m = d(_), _$s.push(m);
            var k = new u(0 | o), S = k.address;
            if (_$s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, _$c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(_$s), T;
            }
            b(_$s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var _$n = [];
            l(_), e = x(_$n, e, "ciphertext");
            var _$s, _$c = t._crypto_secretbox_macbytes(), o = e.length;
            o < _$c && f(_$n, "ciphertext is too short"), _$s = d(e), _$n.push(_$s), r = x(_$n, r, "nonce");
            var h, _$p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== _$p && f(_$n, "invalid nonce length"), h = d(r), _$n.push(h), a = x(_$n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(_$n, "invalid key length"), i = d(a), _$n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (_$n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, _$s, o, 0, h, i))) {
                var k = y(m, _);
                return g(_$n), k;
            }
            b(_$n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var _$n, _$s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== _$s && f(_, "invalid header length"), _$n = d(e), _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, _$n, _$c))) {
                var _$p = h;
                return g(_), _$p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, _$n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== _$n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var _$s = new u(52).address, _$c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = _$c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(_$s, o, _))) {
                var h = {
                    state: _$s,
                    header: y(_$c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function _t(e, r, a, _) {
            var _$n = [];
            l(_), m(_$n, e, "state_address"), r = x(_$n, r, "cipher");
            var _$s, _$c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < _$c && f(_$n, "cipher is too short"), _$s = d(r), _$n.push(_$s);
            var h = null, _$p = 0;
            null != a && (h = d(a = x(_$n, a, "ad")), _$p = a.length, _$n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            _$n.push(b);
            var E, k = (E = v(1), _$n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, _$s, o, 0, h, _$p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(_$n), k;
        }
        function nt(e, r, a, _, n) {
            var _$s = [];
            l(n), m(_$s, e, "state_address");
            var _$c = d(r = x(_$s, r, "message_chunk")), o = r.length;
            _$s.push(_$c);
            var h = null, _$p = 0;
            null != a && (h = d(a = x(_$s, a, "ad")), _$p = a.length, _$s.push(h)), m(_$s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(_$s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (_$s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, _$c, o, 0, h, _$p, 0, _))) {
                var E = y(i, n);
                return g(_$s), E;
            }
            b(_$s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_shorthash_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_shorthash(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_shorthash_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "key");
            var _$c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_shorthash_siphashx24(_$p, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "privateKey");
            var _$c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), _$c = d(r), _.push(_$c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_sign(_$p, null, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var _$n = d(e = x(_, e, "message")), _$s = e.length;
            _.push(_$n), r = x(_, r, "privateKey");
            var _$c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), _$c = d(r), _.push(_$c);
            var h = new u(0 | t._crypto_sign_bytes()), _$p = h.address;
            if (_.push(_$p), 0 == (0 | t._crypto_sign_detached(_$p, null, _$n, _$s, 0, _$c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, _$n = 0 | t._crypto_sign_publickeybytes();
            e.length !== _$n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_scalarmult_scalarbytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, _$n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== _$n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_scalarmult_scalarbytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, _$n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== _$n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_sign_publickeybytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, _$n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== _$n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_sign_seedbytes()), _$c = _$s.address;
            if (a.push(_$c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(_$c, _))) {
                var o = y(_$s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var _$n, _$s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== _$s && f(_, "invalid privateKey length"), _$n = d(r), _.push(_$n);
            var _$c = new u(0 | t._crypto_sign_bytes()), o = _$c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, _$n))) {
                var h = (t._free(e), y(_$c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var _$n = [];
            l(_), m(_$n, e, "state_address"), r = x(_$n, r, "signature");
            var _$s, _$c = 0 | t._crypto_sign_bytes();
            r.length !== _$c && f(_$n, "invalid signature length"), _$s = d(r), _$n.push(_$s), a = x(_$n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(_$n, "invalid publicKey length"), o = d(a), _$n.push(o);
            var _$p = 0 == (0 | t._crypto_sign_final_verify(e, _$s, o));
            return g(_$n), _$p;
        }
        function bt(e) {
            var _$r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(_$r), _;
            }
            b(_$r, "internal error");
        }
        function ft(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            _$r.push(_);
            var _$n = new u(0 | t._crypto_sign_secretkeybytes()), _$s = _$n.address;
            if (_$r.push(_$s), 0 == (0 | t._crypto_sign_keypair(_, _$s))) {
                var _$c = {
                    publicKey: y(a, e),
                    privateKey: y(_$n, e),
                    keyType: "ed25519"
                };
                return g(_$r), _$c;
            }
            b(_$r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var _$n, _$s = t._crypto_sign_bytes(), _$c = e.length;
            _$c < _$s && f(_, "signedMessage is too short"), _$n = d(e), _.push(_$n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var _$p = new u(_$c - t._crypto_sign_bytes() | 0), i = _$p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, _$n, _$c, 0, o))) {
                var v = y(_$p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, _$n = 0 | t._crypto_sign_seedbytes();
            e.length !== _$n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var _$s = new u(0 | t._crypto_sign_publickeybytes()), _$c = _$s.address;
            a.push(_$c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(_$c, h, _))) {
                var _$p = {
                    publicKey: y(_$s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), _$p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var _$n = d(r = x(_, r, "message_chunk")), _$s = r.length;
            _.push(_$n), 0 != (0 | t._crypto_sign_update(e, _$n, _$s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var _$n, _$s = 0 | t._crypto_sign_bytes();
            e.length !== _$s && f(_, "invalid signature length"), _$n = d(e), _.push(_$n);
            var _$c = d(r = x(_, r, "message")), o = r.length;
            _.push(_$c), a = x(_, a, "publicKey");
            var h, _$p = 0 | t._crypto_sign_publickeybytes();
            a.length !== _$p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(_$n, _$c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var _$n = [];
            l(_), m(_$n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_$n, "outLength must be an unsigned integer"), r = x(_$n, r, "key");
            var _$s, _$c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== _$c && f(_$n, "invalid key length"), _$s = d(r), _$n.push(_$s), a = x(_$n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(_$n, "invalid nonce length"), o = d(a), _$n.push(o);
            var _$p = new u(0 | e), i = _$p.address;
            _$n.push(i), t._crypto_stream_chacha20(i, e, 0, o, _$s);
            var v = y(_$p, _);
            return g(_$n), v;
        }
        function Tt(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "input_message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "key");
            var _$p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(_$n, "invalid key length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | _$c), m = v.address;
            if (_$n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, _$s, _$c, 0, o, _$p)) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "input_message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), m(_$s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(_$s, "nonce_increment must be an unsigned integer"), _ = x(_$s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(_$s, "invalid key length"), i = d(_), _$s.push(i);
            var E = new u(0 | o), k = E.address;
            if (_$s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, _$c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(_$s), S;
            }
            b(_$s, "invalid usage");
        }
        function Yt(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_stream_chacha20_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Bt(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "input_message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "key");
            var _$p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(_$n, "invalid key length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | _$c), m = v.address;
            if (_$n.push(m), 0 === t._crypto_stream_chacha20_xor(m, _$s, _$c, 0, o, _$p)) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "input_message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), m(_$s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(_$s, "nonce_increment must be an unsigned integer"), _ = x(_$s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(_$s, "invalid key length"), i = d(_), _$s.push(i);
            var E = new u(0 | o), k = E.address;
            if (_$s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, _$c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(_$s), S;
            }
            b(_$s, "invalid usage");
        }
        function Kt(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_stream_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function Mt(e) {
            var _$r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            _$r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var _$n = y(a, e);
            return g(_$r), _$n;
        }
        function It(e, r, a, _) {
            var _$n = [];
            l(_);
            var _$s = d(e = x(_$n, e, "input_message")), _$c = e.length;
            _$n.push(_$s), r = x(_$n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(_$n, "invalid nonce length"), o = d(r), _$n.push(o), a = x(_$n, a, "key");
            var _$p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(_$n, "invalid key length"), _$p = d(a), _$n.push(_$p);
            var v = new u(0 | _$c), m = v.address;
            if (_$n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, _$s, _$c, 0, o, _$p)) {
                var E = y(v, _);
                return g(_$n), E;
            }
            b(_$n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var _$s = [];
            l(n);
            var _$c = d(e = x(_$s, e, "input_message")), o = e.length;
            _$s.push(_$c), r = x(_$s, r, "nonce");
            var h, _$p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== _$p && f(_$s, "invalid nonce length"), h = d(r), _$s.push(h), m(_$s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(_$s, "nonce_increment must be an unsigned integer"), _ = x(_$s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(_$s, "invalid key length"), i = d(_), _$s.push(i);
            var E = new u(0 | o), k = E.address;
            if (_$s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, _$c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(_$s), S;
            }
            b(_$s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), _$n = _.address;
            a.push(_$n), t._randombytes_buf(_$n, e);
            var _$s = y(_, r);
            return g(a), _$s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var _$n, _$s = 0 | t._randombytes_seedbytes();
            r.length !== _$s && f(_, "invalid seed length"), _$n = d(r), _.push(_$n);
            var _$c = new u(0 | e), o = _$c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, _$n);
            var h = y(_$c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var _$r = t._randombytes_random() >>> 0;
            return g([]), _$r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), _$n = 0; _$n < 6; _$n++)t.setValue(_ + 4 * _$n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][_$n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var _$e = t._sodium_version_string(), _$r = t.UTF8ToString(_$e);
            return g([]), _$r;
        }
        return u.prototype.to_Uint8Array = function() {
            var _$e = new Uint8Array(this.length);
            return _$e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), _$e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], _$n = new u(3 * (e = x(_, e, "input")).length / 4), _$s = d(e), _$c = v(4), o = v(4);
            return _.push(_$s), _.push(_$n.address), _.push(_$n.result_bin_len_p), _.push(_$n.b64_end_p), 0 !== t._sodium_base642bin(_$n.address, _$n.length, _$s, e.length, 0, _$c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - _$s !== e.length && b(_, "incomplete input"), _$n.length = t.getValue(_$c, "i32"), a = _$n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var _$r, a = [], _ = new u((e = x(a, e, "input")).length / 2), _$n = d(e), _$s = v(4);
            return a.push(_$n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, _$n, e.length, 0, 0, _$s) && b(a, "invalid input"), t.getValue(_$s, "i32") - _$n !== e.length && b(a, "incomplete input"), _$r = _.to_Uint8Array(), g(a), _$r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var _$r = 256, t = 0, a = e.length; t < a; t++)_$r >>= 8, _$r += e[t], e[t] = 255 & _$r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var _$r = 0, t = 0, a = e.length; t < a; t++)_$r |= e[t];
            return 0 === _$r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var _$r = 0, t = e.length; _$r < t; _$r++)e[_$r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], _$n = v(4), _$s = 1, _$c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(_$n), _.push(h.address);
            for(var _$p = h.address, y = h.address + o + r; _$p < y; _$p++)t.HEAPU8[_$p] = e[_$c], _$c += _$s = 1 & ~((65535 & ((o -= _$s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(_$n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(_$n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), _$n = v(4);
            return a.push(_), a.push(_$n), 0 !== t._sodium_unpad(_$n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(_$n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium-sumo"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("lfEQ7"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRegister("lfEQ7", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
var $f78aad968bcacc00$var$__dirname = "node_modules/libsodium-sumo/dist/modules-sumo";

var $ilnag = parcelRequire("ilnag");
var $f78aad968bcacc00$require$Buffer = $ilnag.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var _$I;
        void 0 === (_$I = A) && (_$I = {});
        var g = _$I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = _$I;
        return _$I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $4pbh3 && "object" == typeof $4pbh3.versions && "string" == typeof $4pbh3.versions.node, _ = "";
                    if (a) {
                        var c = (parcelRequire("24TKi")), t = (parcelRequire("24TKi"));
                        _ = E ? t.dirname(_) + "/" : $f78aad968bcacc00$var$__dirname + "/", g = function(A, I) {
                            return A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8");
                        }, B = function(A) {
                            var _$I = g(A, !0);
                            return _$I.buffer || (_$I = new Uint8Array(_$I)), _$I;
                        }, !Q.thisProgram && $4pbh3.argv.length > 1 && $4pbh3.argv[1].replace(/\\/g, "/"), $4pbh3.argv.slice(2), module.exports = Q, Q.inspect = function() {
                            return "[Emscripten Module object]";
                        };
                    } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = function(A) {
                        var _$I = new XMLHttpRequest;
                        return _$I.open("GET", A, !1), _$I.send(null), _$I.responseText;
                    }, E && (B = function(A) {
                        var _$I = new XMLHttpRequest;
                        return _$I.open("GET", A, !1), _$I.responseType = "arraybuffer", _$I.send(null), new Uint8Array(_$I.response);
                    }));
                    Q.print;
                    var r, e = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var y, s = {
                        Memory: function Memory(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function Module(A) {},
                        Instance: function Instance(A, I) {
                            this.exports = function(A) {
                                for(var _$I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, o = I, E = C.length, a = I + (3 * E >> 2) - ("=" == C[E - 2]) - ("=" == C[E - 1]); i < E; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[o++] = g[C.charCodeAt(i)] << 2 | B >> 4, o < a && (A[o++] = B << 4 | Q >> 2), o < a && (A[o++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | wB(), _$B = g + A | 0;
                                        if (g < _$B && _$B < 65536) {
                                            var Q = new ArrayBuffer(c(_$B, 65536));
                                            new Int8Array(Q).set(o), o = new Int8Array(Q), new Int16Array(Q), E = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), _ = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, _$I = a;
                                        }
                                        return g;
                                    };
                                    var o = new Int8Array(i), E = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), _ = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), t = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), e = g.c, y = g.d, s = g.e, h = 103648, D = 0, p = 0, w = 0;
                                    function f(A, I) {
                                        var g, C, _$B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0, _$yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, _$wA = 0, _$fA = 0, nA = 0, kA = 0, _$FA = 0, _$NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, _$yA = E = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, _$gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, sA = E = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, E = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, j = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = E, SA = E = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, S = E, EA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, _$wA = E = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, _$B = E = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, _$z = E, oA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, DA = E = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, _$X = E, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E = (_A = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + S | 0, P = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (_$cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, E = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > P >>> 0 ? E + 1 | 0 : E) | 0, E = (QA = (_ = P) >>> 0 > (P = P + QA | 0) >>> 0 ? E + 1 | 0 : E) + _$yA | 0, iA = _$eA = P + rA | 0, _$eA = E = _$eA >>> 0 < P >>> 0 ? E + 1 | 0 : E, P = KI(P ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), kA = E = w, E = E + 1013904242 | 0, QA = P, Z = E = (P = P - 23791573 | 0) >>> 0 < 4271175723 ? E + 1 | 0 : E, _A = KI(P ^ aA, E ^ _A, 40), E = (E = _$eA) + (_$eA = w) | 0, aA = KI(QA ^ (h = aA = _A + iA | 0), kA ^ (D = h >>> 0 < _A >>> 0 ? E + 1 | 0 : E), 48), E = Z + (v = w) | 0, k = E = (aA = P + (p = aA) | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, aA = E = KI(_A ^ (n = aA), _$eA ^ E, 1), Z = P = w, _$eA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, kA = E = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, tA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, P = (_A = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, E = (GA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (bA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, E = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (P >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (iA = (_ = P) >>> 0 > (P = P + tA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = P + _$eA | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, _ = KI(P ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), e = KI(QA ^ (c = _ - 2067093701 | 0), bA ^ (x = (J = P = w) - ((_ >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), E = (L = w) + E | 0, E = (_$d = (F = P = e + tA | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) + Z | 0, E = (F >>> 0 > (P = F + aA | 0) >>> 0 ? E + 1 | 0 : E) + _$X | 0, E = (QA = (t = P) >>> 0 > (P = P + oA | 0) >>> 0 ? E + 1 | 0 : E) + _$z | 0, _$m = _$z = P + g | 0, s = E = _$z >>> 0 < P >>> 0 ? E + 1 | 0 : E, f = aA, _$fA = Z, Z = P, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, P = E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, bA = E = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, _$X = E, E = (_$FA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, E = Q + ((_$z = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (t = _$z + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = (_$X = t + _$X | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + P | 0, pA = t = _$X + aA | 0, t = E = t >>> 0 < _$X >>> 0 ? E + 1 | 0 : E, y = _$z, _$z = KI(_$X ^ (a[0 | (E = A - -64 | 0)] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24) ^ -1377402159, tA ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24) ^ 1359893119, 32), tA = E = w, E = E + 1779033703 | 0, _$X = _$z, _$K = E = (_$z = _$z - 205731576 | 0) >>> 0 < 4089235720 ? E + 1 | 0 : E, r = KI(y ^ (_$N = _$z), E ^ r, 40), E = (l = w) + t | 0, y = KI(_$X ^ (t = _$z = r + pA | 0), tA ^ (G = r >>> 0 > t >>> 0 ? E + 1 | 0 : E), 48), E = KI(y ^ Z, (T = w) ^ iA, 32), V = _$z = w, u = E, C = E = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, tA = pA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, b = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, _$z = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (_$X = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, E = (_$NA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (_$U = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, E = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (_$z >>> 0 < _$X >>> 0 ? E + 1 | 0 : E) | 0, E = C + (Z = (M = _$z) >>> 0 > (_$z = b + _$z | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (b = _$z + tA | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E, Z = KI(_$z ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, Z ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), _$X = KI(_$X ^ (tA = Z + 1595750129 | 0), (M = _$U) ^ (_$U = (_$H = _$z = w) - ((Z >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), E = (IA = w) + E | 0, _$z = KI((b = _$z = _$X + b | 0) ^ Z, _$H ^ (M = b >>> 0 < _$X >>> 0 ? E + 1 | 0 : E), 48), E = _$U + ($ = w) | 0, Y = E = (_$z = tA + (_$U = _$z) | 0) >>> 0 < tA >>> 0 ? E + 1 | 0 : E, E = V + E | 0, O = f ^ (Z = u + (_$H = _$z) | 0), f = E = Z >>> 0 < _$H >>> 0 ? E + 1 | 0 : E, tA = KI(O, E ^ _$fA, 40), E = (_$fA = w) + s | 0, _$z = KI(_$m = u ^ (s = _$z = tA + _$m | 0), V ^ (u = s >>> 0 < tA >>> 0 ? E + 1 | 0 : E), 48), E = f + (CA = w) | 0, V = E = (f = Z + (_$m = _$z) | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, _$z = (R = KI(f ^ tA, _$fA ^ E, 1)) + (Z = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, E = (hA = w) + (_$fA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, nA = _$z, q = _$z >>> 0 < Z >>> 0 ? E + 1 | 0 : E, _$W = sA, _$z = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, tA = E = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, _$X = (E = h) + (h = KI(_$H ^ _$X, Y ^ IA, 1)) | 0, E = (_$H = w) + D | 0, E = (h >>> 0 > _$X >>> 0 ? E + 1 | 0 : E) + tA | 0, E = (D = (D = _$X) >>> 0 > (_$X = _$z + _$X | 0) >>> 0 ? E + 1 | 0 : E) + _$W | 0, O = Y = _$X + _$gA | 0, Y = E = Y >>> 0 < _$X >>> 0 ? E + 1 | 0 : E, F = KI(_ ^ F, _$d ^ J, 48), _$d = E = KI(F ^ _$X, (J = w) ^ D, 32), E = _$K + T | 0, E = (IA = _$X = w) + (_$N = (_$X = y + _$N | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, _$K = E = (D = _$X) >>> 0 > (y = D + _$d | 0) >>> 0 ? E + 1 | 0 : E, h = KI(y ^ h, _$H ^ E, 40), E = (T = w) + Y | 0, E = (_$H = h >>> 0 > (Y = _$X = h + O | 0) >>> 0 ? E + 1 | 0 : E) + q | 0, E = (_ = Y >>> 0 > (_$X = Y + nA | 0) >>> 0 ? E + 1 | 0 : E) + _$wA | 0, nA = q = _$X + EA | 0, q = E = q >>> 0 < _$X >>> 0 ? E + 1 | 0 : E, O = _$X, _$W = _, _$X = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = KI(r ^ D, _$N ^ l, 1), E = (l = w) + M | 0, E = ((_ = r + b | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) + _$X | 0, E = (D = (_$N = _) >>> 0 > (_ = I + _ | 0) >>> 0 ? E + 1 | 0 : E) + _$wA | 0, MA = _$N = _ + EA | 0, _$N = E = _$N >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ p, D ^ v, 32), _$AA = _ = w, p = E, D = _, E = J + x | 0, F = _ = c + F | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + D | 0, M = _ = _ + p | 0, v = E = F >>> 0 > _ >>> 0 ? E + 1 | 0 : E, D = KI(_ ^ r, l ^ E, 40), E = (l = w) + _$N | 0, p = KI((_ = D + MA | 0) ^ p, _$AA ^ (c = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(p ^ O, (MA = w) ^ _$W, 32), _$AA = r = w, _$N = E, O = r, e = KI(e ^ F, b ^ L, 1), E = G + (F = w) | 0, E = ((r = t) >>> 0 > (t = t + e | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, E = (t = (r = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + _$fA | 0, _$W = G = r + Z | 0, G = E = G >>> 0 < r >>> 0 ? E + 1 | 0 : E, b = e, r = KI(r ^ _$U, t ^ $, 32), E = (_$U = w) + k | 0, n = KI(b ^ (t = e = r + n | 0), (k = r >>> 0 > t >>> 0 ? E + 1 | 0 : E) ^ F, 40), E = ($ = w) + G | 0, F = e = n + _$W | 0, e = KI(r ^ e, _$U ^ (G = e >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = k + (i = w) | 0, k = e, _$U = E = (e = t + e | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + O | 0, E = (b = e) >>> 0 > (e = e + _$N | 0) >>> 0 ? E + 1 | 0 : E, O = e, e ^= R, R = E, r = KI(e, hA ^ E, 40), E = (hA = w) + q | 0, q = e = r + nA | 0, E = _$B + (_$W = r >>> 0 > e >>> 0 ? E + 1 | 0 : E) | 0, nA = e = e + g | 0, J = E = e >>> 0 < g >>> 0 ? E + 1 | 0 : E, e = _, x = _$gA, L = sA, _ = KI(_$d ^ Y, _$H ^ IA, 48), E = _$K + (IA = w) | 0, _$d = _, _$K = E = (t = y + _ | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ h, T ^ E, 1), E = (y = w) + L | 0, E = ((h = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) + c | 0, E = _$NA + (e = (c = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, Y = h = c + iA | 0, h = E = h >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ k, e ^ i, 32), E = V + (_$H = w) | 0, k = c, f = E = (c = f + c | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ c, E ^ y, 40), E = (E = h) + (h = w) | 0, y = _ = e + Y | 0, _ = KI(_ ^ k, _$H ^ (Y = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = f + (T = w) | 0, _$H = _, V = E = (f = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ f, h ^ E, 1), E = (h = w) + J | 0, E = C + (e = (c = _ + nA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, nA = k = c + pA | 0, k = E = k >>> 0 < pA >>> 0 ? E + 1 | 0 : E, J = _, x = h, E = v + MA | 0, E = (_ = p + M | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = _, M = E, E = KI(_ ^ D, l ^ E, 1), D = h = w, _ = E, E = G + _$X | 0, E = ((F = I + F | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + h | 0, E = DA + (F = (h = _ + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E) | 0, v = G = h + oA | 0, G = E = G >>> 0 < oA >>> 0 ? E + 1 | 0 : E, h = KI(h ^ _$m, F ^ CA, 32), E = _$K + (_$m = w) | 0, F = h, _$K = E = (_$K = t) >>> 0 > (t = t + h | 0) >>> 0 ? E + 1 | 0 : E, h = KI(_ ^ t, E ^ D, 40), E = (l = w) + G | 0, D = _ = h + v | 0, _ = KI(G = _ ^ F, _$m ^ (F = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = _$K + (CA = w) | 0, _$K = _, G = _ = t + _ | 0, _$m = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, v = c, L = e, _ = KI(n ^ b, _$U ^ $, 1), E = (t = w) + S | 0, E = u + ((c = _ + _$cA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (e = (c = c + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, u = s = c + j | 0, s = E = s >>> 0 < c >>> 0 ? E + 1 | 0 : E, n = _, _ = (c = KI(c ^ _$d, e ^ IA, 32)) + p | 0, E = (p = w) + M | 0, e = _, t = KI(_ ^ n, (_$d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ t, 40), E = (IA = w) + s | 0, s = _ = t + u | 0, b = KI(_ ^ c, p ^ (u = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), c = KI(b ^ v, (E = L) ^ (L = w), 32), E = (v = w) + _$m | 0, p = _ = c + G | 0, n = KI(_ ^ J, (M = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ x, 40), E = (J = w) + k | 0, k = _ = n + nA | 0, _ = KI(_ ^ c, v ^ (_$U = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = M + ($ = w) | 0, M = _, v = E = (c = p) >>> 0 > (p = p + _ | 0) >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ n, J ^ E, 1), E = _$wA + (nA = w) | 0, J = _, MA = _ = EA + _ | 0, n = E = _ >>> 0 < EA >>> 0 ? E + 1 | 0 : E, c = rA, _ = KI(h ^ G, l ^ _$m, 1), E = Y + (h = w) | 0, E = ((G = y) >>> 0 > (y = _ + y | 0) >>> 0 ? E + 1 | 0 : E) + _$yA | 0, E = (G = (c = c + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) + kA | 0, x = y = c + _$eA | 0, Y = E = y >>> 0 < c >>> 0 ? E + 1 | 0 : E, _$m = _, y = KI(_$N ^ q, _$W ^ _$AA, 48), E = KI(y ^ c, (l = w) ^ G, 32), _$AA = _ = w, _$N = E, c = _, E = _$d + L | 0, E = (_ = e + b | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _, _$d = E, E = E + c | 0, G = _ = _ + _$N | 0, b = E = e >>> 0 > _ >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ _$m, E ^ h, 40), E = (E = Y) + (Y = w) | 0, _$m = _ = c + x | 0, q = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + n | 0, _$W = E = (h = _ + MA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, n = E, _ = KI(t ^ e, _$d ^ IA, 1), E = P + (t = w) | 0, E = F + ((e = _ + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = tA + (D = (e = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, x = F = e + _$z | 0, F = E = F >>> 0 < _$z >>> 0 ? E + 1 | 0 : E, _$d = _, E = KI(e ^ _$H, D ^ T, 32), L = _ = w, e = E, D = _, E = l + R | 0, _$H = _ = y + O | 0, R = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + D | 0, E = (y = _ + e | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = y ^ _$d, _$d = E, D = KI(_, E ^ t, 40), E = (T = w) + F | 0, t = _ = D + x | 0, O = KI(_ ^ e, L ^ (F = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(O ^ h, (IA = w) ^ n, 32), MA = _ = w, x = E, n = _, _ = KI(r ^ _$H, R ^ hA, 1), E = u + (r = w) | 0, E = _$FA + ((e = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (e = e + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) + GA | 0, _$H = u = e + _A | 0, u = E = u >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(e ^ _$K, s ^ CA, 32), E = V + (R = w) | 0, _$K = e, s = r, r = E = (e = f + e | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ e, s ^ E, 40), E = (CA = w) + u | 0, f = _ = s + _$H | 0, _ = KI(_$H = _ ^ _$K, R ^ (_$K = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = r + (l = w) | 0, r = _, u = _ = e + _ | 0, _$H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + n | 0, V = E = (n = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, e = KI(n ^ J, nA ^ E, 40), E = _$W + (R = w) | 0, E = ((_ = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + sA | 0, h = _, _$W = _ = _ + _$gA | 0, J = E = h >>> 0 > _ >>> 0 ? E + 1 | 0 : E, L = BA, h = KI(_$N ^ _$m, q ^ _$AA, 48), E = (hA = w) + b | 0, _$N = _ = h + G | 0, E = KI(_ ^ c, (G = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E) ^ Y, 1), Y = c = w, _ = E, E = F + _$B | 0, E = ((t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = (t = (c = _ + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + L | 0, b = F = c + j | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = KI(c ^ r, t ^ l, 32), E = v + (_$m = w) | 0, p = E = (r = c + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ r, E ^ Y, 40), E = (q = w) + F | 0, F = _ = t + b | 0, c = KI(_ ^ c, _$m ^ (Y = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (b = w) | 0, _$m = E = (p = c + r | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ p, q ^ E, 1), E = (q = w) + J | 0, E = _$fA + ((r = _ + _$W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + S | 0, nA = S = r + _$cA | 0, S = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = _, L = r, l = t, r = rA, _ = KI(s ^ u, _$H ^ CA, 1), E = _$U + (s = w) | 0, E = ((t = k) >>> 0 > (k = _ + k | 0) >>> 0 ? E + 1 | 0 : E) + _$yA | 0, E = GA + (t = (r = r + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E) | 0, _$U = k = r + _A | 0, u = E = k >>> 0 < _A >>> 0 ? E + 1 | 0 : E, k = _, t = E = KI(r ^ h, t ^ hA, 32), E = _$d + IA | 0, E = (_$H = _ = w) + (y = (_ = y + O | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, _$d = E = (h = _ + t | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = KI(h ^ k, E ^ s, 40), E = (IA = w) + u | 0, u = KI(_$U = (r = k + _$U | 0) ^ t, _$H ^ (t = r >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = KI(u ^ L, (CA = w) ^ l, 32), hA = s = w, _$U = E, _$H = s, _ = KI(_ ^ D, y ^ T, 1), E = tA + (s = w) | 0, E = _$K + ((y = _ + _$z | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E) | 0, E = _$FA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = D = y + QA | 0, D = E = D >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _$K = _, O = s, y = KI(y ^ M, f ^ $, 32), E = (M = w) + G | 0, s = _ = y + _$N | 0, f = KI(_ ^ _$K, (_$N = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ O, 40), E = (T = w) + D | 0, _$K = _ = f + L | 0, _ = KI(_ ^ y, M ^ (G = _ >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = _$N + (L = w) | 0, D = _, _$N = _ = s + _ | 0, M = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = E + _$H | 0, _$H = _ = _ + _$U | 0, y = q, q = E = _$N >>> 0 > _ >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ v, y ^ E, 40), E = (E = S) + (S = w) | 0, O = _ = y + nA | 0, v = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = t, _ = KI(x ^ _$W, J ^ MA, 48), E = V + ($ = w) | 0, V = _, t = (_ = n + _ | 0) ^ e, e = E = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E, t = KI(t, E ^ R, 1), E = (R = w) + s | 0, E = C + ((r = t + r | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + P | 0, _$W = n = r + aA | 0, n = E = n >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = KI(r ^ D, s ^ L, 32), E = _$m + (J = w) | 0, _$m = r, p = E = (s = p + r | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, R ^ E, 40), E = (E = n) + (n = w) | 0, D = r = t + _$W | 0, r = KI(x = r ^ _$m, J ^ (_$m = r >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (nA = w) | 0, R = r, _$W = E = (p = s + r | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, r = KI(t ^ p, n ^ E, 1), E = (n = w) + v | 0, E = _$B + ((t = r + O | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = _$X + (s = (t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, MA = J = I + t | 0, J = E = J >>> 0 < I >>> 0 ? E + 1 | 0 : E, x = r, L = n, n = t, l = s, r = KI(f ^ _$N, M ^ T, 1), E = (s = w) + Y | 0, E = DA + ((t = r + F | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (f = (t = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + _$X | 0, Y = F = I + t | 0, F = E = F >>> 0 < t >>> 0 ? E + 1 | 0 : E, _$N = r, t = E = KI(t ^ V, f ^ $, 32), f = r = w, E = _$d + CA | 0, _$d = E = (r = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + f | 0, E = (h = r) >>> 0 > (r = r + t | 0) >>> 0 ? E + 1 | 0 : E, u = r, r ^= _$N, _$N = E, s = KI(r, E ^ s, 40), E = (T = w) + F | 0, f = KI(F = (r = s + Y | 0) ^ t, f ^ (t = r >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(f ^ n, (E = l) ^ (l = w), 32), $ = n = w, F = E, Y = e, e = c, E = KI(h ^ k, _$d ^ IA, 1), M = c = w, h = E, E = G + kA | 0, E = ((k = _$K + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) + c | 0, k = E = (c = h + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ b, 32), E = (E = Y) + (Y = w) | 0, h = KI((_ = e + _ | 0) ^ h, M ^ (_$d = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = k + (IA = w) | 0, _$K = h, E = _$NA + ((G = c) >>> 0 > (c = c + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, G = E = (h = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ h, Y ^ E, 48), E = _$d + (CA = w) | 0, b = _, e = c, _$d = _ = _ + c | 0, Y = E = b >>> 0 > _ >>> 0 ? E + 1 | 0 : E, E = E + n | 0, b = E = (n = _ + F | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = (k = KI(n ^ x, E ^ L, 40)) + MA | 0, E = (MA = w) + J | 0, M = _, V = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(_$U ^ O, v ^ hA, 48), E = (_$U = w) + q | 0, _$H = c = _ + _$H | 0, x = S, S = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(c ^ y, x ^ E, 1), O = c = w, y = E, E = t + C | 0, E = ((r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + c | 0, E = _$fA + (r = (c = r + y | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, v = t = c + Z | 0, t = E = t >>> 0 < Z >>> 0 ? E + 1 | 0 : E, c = KI(c ^ e, r ^ CA, 32), E = _$W + (J = w) | 0, q = c, c = (e = p + c | 0) ^ y, y = E = e >>> 0 < p >>> 0 ? E + 1 | 0 : E, r = KI(c, O ^ E, 40), E = (E = t) + (t = w) | 0, O = c = r + v | 0, c = KI(p = c ^ q, J ^ (q = c >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = y + (CA = w) | 0, _$W = c, e = E = (c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = KI(c ^ r, t ^ E, 1), E = (p = w) + V | 0, E = _$wA + ((t = r + M | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (y = (t = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + BA | 0, _$AA = v = t + j | 0, v = E = v >>> 0 < t >>> 0 ? E + 1 | 0 : E, J = r, x = t, L = y, r = KI(_$K ^ _$d, Y ^ IA, 1), E = (Y = w) + sA | 0, E = _$m + (r >>> 0 > (t = r + _$gA | 0) >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ t, E ^ _$U, 32), _$U = _ = w, D = E, E = _$N + l | 0, E = (_ = f + u | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, f = _, _$d = E, E = _$U + E | 0, _$N = _ = _ + D | 0, _$K = E = f >>> 0 > _ >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ r, Y ^ E, 40), E = y + (l = w) | 0, u = _, E = tA + ((_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (_ = _ + _$z | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E, Y = _, _ ^= D, D = E, y = KI(_, _$U ^ E, 48), E = KI(y ^ x, (E = L) ^ (L = w), 32), IA = _ = w, _$U = E, _$m = _, _ = KI(s ^ f, _$d ^ T, 1), E = kA + (t = w) | 0, E = G + ((r = _ + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + P | 0, G = f = r + aA | 0, f = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, h = _, _$d = t, _ = (r = KI(r ^ R, s ^ nA, 32)) + _$H | 0, E = (_$H = w) + S | 0, t = _, s = KI(s = _ ^ h, (h = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ _$d, 40), E = (T = w) + f | 0, f = _ = s + G | 0, r = KI(_ ^ r, _$H ^ (S = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (_$d = w) | 0, G = _ = r + t | 0, _$H = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + _$m | 0, _$m = E = (h = _ + _$U | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(h ^ J, E ^ p, 40), E = (R = w) + v | 0, v = _ = t + _$AA | 0, J = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, _ = c, p = e, e = r, c = KI(F ^ M, V ^ $, 48), E = b + (_$AA = w) | 0, F = c, n = E = (r = n + c | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, E = KI(r ^ k, MA ^ E, 1), b = c = w, k = E, E = D + SA | 0, E = ((D = Y + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) + c | 0, D = E = (c = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ _$d, 32), E = (Y = w) + p | 0, k = KI((_ = e + _ | 0) ^ k, b ^ (p = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = D + (M = w) | 0, E = _$FA + ((D = c) >>> 0 > (c = c + k | 0) >>> 0 ? E + 1 | 0 : E) | 0, _$d = E = (D = c + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ D, Y ^ E, 48), E = p + ($ = w) | 0, Y = c, b = E = (p = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ k, M ^ E, 1), E = (k = w) + J | 0, E = DA + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = _$wA + (e = (c = c + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, hA = M = c + EA | 0, M = E = M >>> 0 < EA >>> 0 ? E + 1 | 0 : E, V = _, x = c, _ = KI(s ^ G, _$H ^ T, 1), E = (s = w) + q | 0, E = GA + ((c = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = _$NA + (G = (c = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, O = _$H = c + iA | 0, _$H = E = _$H >>> 0 < iA >>> 0 ? E + 1 | 0 : E, q = _, E = KI(c ^ F, G ^ _$AA, 32), _$AA = _ = w, c = E, E = _$K + L | 0, _$N = _ = y + _$N | 0, F = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = _$AA + E | 0, _$K = E = (y = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(y ^ q, E ^ s, 40), E = (L = w) + _$H | 0, G = _ = s + O | 0, q = KI(_ ^ c, _$AA ^ (_$H = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(q ^ x, (_$AA = w) ^ e, 32), T = _ = w, O = E, e = _, c = rA, _ = KI(_$N ^ u, F ^ l, 1), E = S + (F = w) | 0, E = ((_$N = f) >>> 0 > (f = _ + f | 0) >>> 0 ? E + 1 | 0 : E) + _$yA | 0, E = DA + (f = (c = c + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, _$N = S = c + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ _$W, f ^ CA, 32), E = n + (u = w) | 0, n = c, E = (c = r + c | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = F, F = E, r = KI(_ ^ c, r ^ E, 40), E = (l = w) + S | 0, f = _ = r + _$N | 0, _ = KI(_ ^ n, u ^ (S = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = F + (x = w) | 0, F = _, _$N = _ = c + _ | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + e | 0, E = (n = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = n ^ V, V = E, k = KI(_, E ^ k, 40), E = (CA = w) + M | 0, M = _ = k + hA | 0, _$W = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(_$U ^ v, J ^ IA, 48), E = _$m + (IA = w) | 0, _$U = _, E = (_ = h + _ | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, _$m = E, E = KI(_ ^ t, E ^ R, 1), R = _ = w, e = E, E = _$H + _$fA | 0, E = ((c = G + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + _ | 0, E = _$FA + (c = (_ = c + e | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, G = t = _ + QA | 0, t = E = t >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ F, c ^ x, 32), E = b + (_$H = w) | 0, F = _, p = E = (c = p + _ | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, R ^ E, 40), E = (R = w) + t | 0, G = _ = e + G | 0, _ = KI(t = _ ^ F, _$H ^ (F = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = p + (hA = w) | 0, p = _, b = E = (t = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ e, R ^ E, 1), E = (_$H = w) + _$W | 0, E = kA + ((c = _ + M | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (e = (c = c + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) + sA | 0, nA = R = c + _$gA | 0, R = E = R >>> 0 < c >>> 0 ? E + 1 | 0 : E, v = _, J = c, x = e, _ = KI(r ^ _$N, l ^ u, 1), E = GA + (e = w) | 0, E = _$d + ((c = _ + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = SA + (r = (c = c + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, u = D = c + _$cA | 0, D = E = D >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E, _$d = _, _$N = e, E = KI(c ^ _$U, r ^ IA, 32), _$U = _ = w, r = E, c = _, E = _$K + _$AA | 0, E = (_ = y + q | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, y = _, _$K = E, E = E + c | 0, E = (e = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = e ^ _$d, _$d = E, _ = KI(_, E ^ _$N, 40), E = (E = D) + (D = w) | 0, _$N = c = _ + u | 0, u = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _$U = KI(c ^ r, _$U ^ E, 48), E = KI(_$U ^ J, (E = x) ^ (x = w), 32), l = c = w, q = E, c = KI(y ^ s, _$K ^ L, 1), E = (y = w) + _$yA | 0, E = S + ((r = c + rA | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, E = C + (s = (r = r + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = f = r + pA | 0, f = E = f >>> 0 < pA >>> 0 ? E + 1 | 0 : E, S = c, _$K = y, r = KI(r ^ Y, s ^ $, 32), E = (Y = w) + _$m | 0, y = c = r + h | 0, c = (s = KI(c ^ S, (h = c >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ _$K, 40)) + L | 0, E = (L = w) + f | 0, S = c, c = KI(c ^ r, Y ^ (_$K = c >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (_$AA = w) | 0, Y = c, _$m = c = y + c | 0, J = E = c >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = l + E | 0, E = (r = c + q | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = _$H, _$H = E, y = KI(r ^ v, c ^ E, 40), E = (IA = w) + R | 0, f = c = y + nA | 0, E = KI(c ^ q, l ^ (R = c >>> 0 < y >>> 0 ? E + 1 | 0 : E), 48), l = c = w, q = E, c = _, E = _$d + x | 0, _$d = _ = e + _$U | 0, _$U = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ c, E ^ D, 1), e = c = w, _ = E, E = _$K + _$B | 0, E = ((h = S + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = tA + (h = (c = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, x = D = c + _$z | 0, D = E = D >>> 0 < _$z >>> 0 ? E + 1 | 0 : E, S = _, _$K = e, _ = KI(M ^ O, _$W ^ T, 48), E = V + (T = w) | 0, M = _, E = (_ = n + _ | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, n = _, c = KI(c ^ p, h ^ hA, 32), V = E, E = E + (O = w) | 0, e = _ = c + _ | 0, h = KI(_ ^ S, (p = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ _$K, 40), E = (_$W = w) + D | 0, D = _ = h + x | 0, _ = KI(_ ^ c, O ^ (S = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, _$K = _, O = E = (p = e + _ | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ p, _$W ^ E, 1), E = _$FA + (x = w) | 0, _$W = _, hA = _ = QA + _ | 0, e = E = _ >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(k ^ n, V ^ CA, 1), E = (h = w) + u | 0, E = _$NA + ((c = _ + _$N | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (n = (c = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, V = k = c + j | 0, k = E = k >>> 0 < j >>> 0 ? E + 1 | 0 : E, _$N = h, c = KI(c ^ Y, n ^ _$AA, 32), E = b + (_$AA = w) | 0, u = c, E = (h = t + c | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = _$N, _$N = E, n = KI(_ ^ h, t ^ E, 40), E = (CA = w) + k | 0, Y = _ = n + V | 0, E = (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) + e | 0, k = E = (e = _ + hA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, V = E = KI(e ^ q, E ^ l, 32), v = _ = w, _ = KI(s ^ _$m, J ^ L, 1), E = (t = w) + F | 0, E = _$X + ((c = _ + G | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (c = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + P | 0, J = F = c + aA | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, G = _, _$m = t, c = KI(c ^ M, s ^ T, 32), E = (M = w) + _$U | 0, t = _ = c + _$d | 0, _ = (s = KI(_ ^ G, (_$d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ _$m, 40)) + J | 0, E = (J = w) + F | 0, F = _, _ = KI(_ ^ c, M ^ (G = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = _$d + (T = w) | 0, _$d = _, M = E = (_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + v | 0, _$U = E = (t = _) >>> 0 > (_ = _ + V | 0) >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ _$W, x ^ E, 40), E = k + (x = w) | 0, _$m = c, E = _$B + ((c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, _$W = c = c + g | 0, e = c ^ V, V = E = c >>> 0 < g >>> 0 ? E + 1 | 0 : E, c = KI(e, v ^ E, 48), E = _$U + (v = w) | 0, _$U = E = (k = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = E = KI(k ^ _$m, x ^ E, 1), _$m = e = w, e = KI(t ^ s, M ^ J, 1), E = S + (s = w) | 0, E = _$NA + ((t = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, E = DA + (D = (t = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, x = S = t + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, M = e, J = s, E = _$H + l | 0, E = (e = r + q | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, _$H = e, u = KI(Y ^ u, b ^ _$AA, 48), s = KI(t ^ u, D ^ (_$AA = w), 32), Y = E, E = E + (hA = w) | 0, D = e = s + e | 0, e = KI(e ^ M, (b = e >>> 0 < s >>> 0 ? E + 1 | 0 : E) ^ J, 40), E = (M = w) + S | 0, J = E = (r = e + x | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + _$m | 0, E = C + ((q = r) >>> 0 > (r = _ + r | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + _$yA | 0, nA = S = r + rA | 0, x = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, L = _, l = r, E = KI(y ^ _$H, Y ^ IA, 1), y = r = w, _ = E, E = G + GA | 0, E = ((S = F + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) + r | 0, E = tA + (S = (r = _ + S | 0) >>> 0 < S >>> 0 ? E + 1 | 0 : E) | 0, Y = F = r + _$z | 0, F = E = F >>> 0 < _$z >>> 0 ? E + 1 | 0 : E, G = _, E = KI(r ^ _$K, S ^ $, 32), _$H = _ = w, r = E, S = _, E = _$N + _$AA | 0, _$N = _ = h + u | 0, _$K = E = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + S | 0, E = (h = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E;
                                        _ = h ^ G, G = E, S = KI(_, E ^ y, 40), E = (_$AA = w) + F | 0, u = KI(F = (_ = S + Y | 0) ^ r, _$H ^ (r = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 48), E = KI(E = u ^ l, (l = w) ^ t, 32), IA = t = w, Y = E, F = t, t = KI(n ^ _$N, _$K ^ CA, 1), E = BA + (n = w) | 0, E = R + ((y = t + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, _$K = _$N = y + _$eA | 0, _$N = E = _$N >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E, y = KI(y ^ _$d, f ^ T, 32), E = O + (_$H = w) | 0, _$d = y, p = E = (y = p + y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, f = KI(t ^ y, E ^ n, 40), E = (T = w) + _$N | 0, n = t = f + _$K | 0, t = KI(_$N = t ^ _$d, _$H ^ (_$d = t >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, _$N = t, _$K = t = y + t | 0, _$H = E = t >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + F | 0, E = (y = t + Y | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = _$m, _$m = E, p = KI(y ^ L, t ^ E, 40), E = (R = w) + x | 0, F = t = p + nA | 0, t = KI(x = t ^ Y, IA ^ (Y = t >>> 0 < p >>> 0 ? E + 1 | 0 : E), 48), E = _$m + (IA = w) | 0, _$m = t, y = E = (t = y + t | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, R = E = KI(t ^ p, R ^ E, 1), CA = E, O = p = w, p = r, r = e, e = KI(s ^ q, J ^ hA, 48), E = b + (hA = w) | 0, b = e, E = (e = D + e | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _, _ = r ^ e, r = E, _ = KI(_, E ^ M, 1), E = (M = w) + p | 0, E = SA + (_ >>> 0 > (s = D + _ | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = sA + (D = (s = s + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) | 0, q = p = s + _$gA | 0, p = E = p >>> 0 < _$gA >>> 0 ? E + 1 | 0 : E, s = KI(s ^ _$N, D ^ $, 32), E = _$U + (J = w) | 0, _$N = E = (D = s + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(_ ^ D, M ^ E, 40), E = ($ = w) + p | 0, M = _ = k + q | 0, s = KI(_ ^ s, J ^ (_$U = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = _$N + (q = w) | 0, J = _ = s + D | 0, _$N = _, x = E = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = e, p = r, E = G + l | 0, E = (_ = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, _ ^= S, S = E, E = KI(_, _$AA ^ E, 1), L = _ = w, G = E, r = E, E = _$d + P | 0, E = ((e = n + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) + _ | 0, n = E = (_ = e) >>> 0 > (e = r + e | 0) >>> 0 ? E + 1 | 0 : E, r = KI(c ^ e, E ^ v, 32), E = (E = p) + (p = w) | 0, u = _ = r + D | 0, c = KI(c = _ ^ G, L ^ (G = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 40), E = n + (v = w) | 0, E = _$fA + ((_ = c + e | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, L = E = (D = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, p = KI(r ^ D, p ^ E, 48), nA = E = w, _ = KI(f ^ _$K, _$H ^ T, 1), E = (r = w) + V | 0, E = _$wA + ((e = _ + _$W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = _$X + (f = (e = e + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, V = n = I + e | 0, _$K = E = n >>> 0 < I >>> 0 ? E + 1 | 0 : E, _$H = _, n = KI(e ^ b, f ^ hA, 32), E = (T = w) + S | 0, S = _ = n + h | 0, e = KI(_ ^ _$H, (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ r, 40), E = (E = _$K) + (_$K = w) | 0, _$H = _ = e + V | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = E, E = _$X + O | 0, E = ((f = I + R | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + r | 0, _$d = E = (r = _ + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, nA ^ E, 32), E = (R = w) + x | 0, h = KI((f = _ + _$N | 0) ^ CA, (E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ O, 40), O = E, E = sA + (_$N = w) | 0, E = _$d + ((_$W = h + _$gA | 0) >>> 0 < _$gA >>> 0 ? E + 1 | 0 : E) | 0, E = (_$d = r + _$W | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = R, R = E, r = KI(_ ^ _$d, r ^ E, 48), E = (E = O) + (O = w) | 0, _ = h ^ (f = r + f | 0), h = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, _$W = E = KI(_, E ^ _$N, 1), CA = E, l = _ = w, _$N = t, _$AA = y, t = e, e = KI(n ^ _$H, V ^ T, 48), E = b + (_$H = w) | 0, n = _ = e + S | 0, S = E = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ _$K, 1), E = (V = w) + SA | 0, E = L + ((_ = t + _$cA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, D = E = (y = _ + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, _ = KI(y ^ s, E ^ q, 32), E = (_$K = w) + _$AA | 0, _$N = s = _ + _$N | 0, b = E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, E ^ V, 40), E = DA + (hA = w) | 0, V = t, E = D + ((t = oA + t | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ t, E ^ _$K, 48), E = (E = b) + (b = w) | 0, q = _ = s + _$N | 0, _$K = _, L = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = G + nA | 0, _$N = (_ = p + u | 0) ^ c, c = E = _ >>> 0 < p >>> 0 ? E + 1 | 0 : E, E = KI(_$N, E ^ v, 1), v = D = w, _$N = E, E = _$U + tA | 0, E = ((p = M + _$z | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E) + D | 0, G = E = (G = p) >>> 0 > (p = p + _$N | 0) >>> 0 ? E + 1 | 0 : E, u = D = KI(p ^ _$m, IA ^ E, 32), M = E = w, E = E + S | 0, _$U = D = D + n | 0, _$m = E = u >>> 0 > D >>> 0 ? E + 1 | 0 : E, D = KI(D ^ _$N, v ^ E, 40), E = _$yA + (v = w) | 0, E = G + ((n = D + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = E = (_$N = p) >>> 0 > (p = p + n | 0) >>> 0 ? E + 1 | 0 : E, _$N = KI(p ^ u, E ^ M, 48), IA = E = w, S = E, k = KI(k ^ J, x ^ $, 1), G = E = w, u = e, E = E + P | 0, E = Y + ((e = k + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (e = e + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = e ^ u, u = E, F = KI(F, E ^ _$H, 32), E = ($ = w) + c | 0, Y = _ = F + _ | 0, c = KI(_ ^ k, (c = G) ^ (G = _ >>> 0 < F >>> 0 ? E + 1 | 0 : E), 40), E = _$wA + (M = w) | 0, E = u + ((_ = c + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, u = _ = _ + e | 0, _$H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + _$NA | 0, E = ((k = _$W + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) + e | 0, _$W = E = (e = _ + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ _$N, E ^ S, 32), E = (J = w) + L | 0, S = KI((k = _ + _$K | 0) ^ CA, (E = k >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = _$K = w, l = E, E = _$K + kA | 0, E = _$W + ((_$K = S + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) | 0, _$W = E = (_$K = e + _$K | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ _$K, E ^ J, 48), E = (J = w) + l | 0, _ = (k = e + k | 0) ^ S, S = E = k >>> 0 < e >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, _$AA = f, T = s, s = c, c = KI(F ^ u, _$H ^ $, 48), E = (F = w) + G | 0, G = _ = c + Y | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, E ^ M, 1), E = (M = w) + _$FA | 0, E = ((_ = s + QA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) + n | 0, p = E = (f = _ + p | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(f ^ T, E ^ b, 32), E = (n = w) + h | 0, Y = h = _ + _$AA | 0, b = E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = C + (T = w) | 0, M = s, E = p + ((s = pA + s | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, _$H = E = (h = s + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ h, E ^ n, 48), E = (E = b) + (b = w) | 0, Y = _ = s + Y | 0, _$AA = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, p = r, f = t, E = _$m + IA | 0, r = E = (_ = _$N + _$U | 0) >>> 0 < _$N >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ D, E ^ v, 1), E = (D = w) + BA | 0, E = ((n = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + y | 0, y = KI(p ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ O, 32), n = E, _$N = t, E = (p = w) + u | 0, E = (t = y + G | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, G = t, t ^= _$N, _$N = E, t = KI(t, E ^ D, 40), E = _$B + (u = w) | 0, E = ((D = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + n | 0, _$U = E = (n = D) >>> 0 > (D = D + f | 0) >>> 0 ? E + 1 | 0 : E, p = KI(y ^ D, E ^ p, 48), IA = E = w, f = E, y = KI(q ^ V, L ^ hA, 1), _$m = E = w, V = r, E = E + _$fA | 0, E = R + ((r = y + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, n = F, F = E = (r = r + _$d | 0) >>> 0 < _$d >>> 0 ? E + 1 | 0 : E, n = KI(c ^ r, n ^ E, 32), E = ($ = w) + V | 0, _$d = _ = n + _ | 0, c = KI(_ ^ y, (c = _$m) ^ (_$m = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 40), E = GA + (V = w) | 0, E = F + ((_ = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, R = _ = _ + r | 0, q = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + tA | 0, E = ((y = _$z + x | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, E ^ f, 32), E = (O = w) + _$AA | 0, f = KI((y = _ + Y | 0) ^ x, (E = y >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = P + (v = w) | 0, E = F + ((L = f + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + L | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = O, O = E, r = KI(_ ^ F, r ^ E, 48), E = (E = x) + (x = w) | 0, _ = (y = r + y | 0) ^ f, f = E = y >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), L = _ = w, l = s, s = c, c = KI(n ^ R, q ^ $, 48), E = (E = _$m) + (_$m = w) | 0, _$d = _ = c + _$d | 0, n = V, V = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, n ^ E, 1), E = (R = w) + kA | 0, E = _$U + ((_ = s + _$eA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, n = D, D = _ + D | 0, _ = b, b = E = n >>> 0 > D >>> 0 ? E + 1 | 0 : E, _ = KI(D ^ l, _ ^ E, 32), E = (E = S) + (S = w) | 0, _$U = E = (n = _ + k | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = n, s = KI(s ^ n, E ^ R, 40), E = _$fA + ($ = w) | 0, R = s, E = b + ((s = Z + s | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, b = E = (n = s + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ n, E ^ S, 48), E = (E = _$U) + (_$U = w) | 0, q = _ = s + k | 0, l = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, k = e, E = _$N + IA | 0, e = E = (_ = p + G | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = sA + (p = w) | 0, E = _$H + ((D = t + _$gA | 0) >>> 0 < _$gA >>> 0 ? E + 1 | 0 : E) | 0, _$N = (D = h + D | 0) ^ k, k = E = D >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = KI(_$N, E ^ J, 32), S = E = w, _$N = t, E = E + V | 0, E = (t = h + _$d | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, G = t, t ^= _$N, _$N = E, t = KI(t, E ^ p, 40), E = _$B + (u = w) | 0, E = k + ((p = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, _$H = E = (p = D + p | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, k = KI(h ^ p, E ^ S, 48), IA = E = w, D = E, h = KI(M ^ Y, T ^ _$AA, 1), _$d = E = w, Y = e, E = E + C | 0, E = _$W + ((e = h + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, _$K = E = (e = e + _$K | 0) >>> 0 < _$K >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ _$m, 32), E = (CA = w) + Y | 0, Y = _ = S + _ | 0, c = KI(_ ^ h, (M = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E) ^ _$d, 40), E = _$X + (_$m = w) | 0, E = _$K + ((_ = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, _$K = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = L + _$wA | 0, E = ((h = v + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + e | 0, _$d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (_$W = w) + l | 0, D = KI((h = _ + q | 0) ^ v, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), J = E, E = SA + (v = w) | 0, E = _$d + ((L = D + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) | 0, E = (_$d = e + L | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _$W, _$W = E, e = KI(_ ^ _$d, e ^ E, 48), E = (E = J) + (J = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), hA = E, L = _ = w, _$AA = y, T = s, y = c, c = KI(S ^ _$K, V ^ CA, 48), E = (S = w) + M | 0, _$K = _ = c + Y | 0, Y = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ _$m, 1), E = (_$m = w) + _$yA | 0, E = _$H + ((_ = y + rA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ _$U, 32), E = (M = w) + f | 0, _$U = E = (f = _ + _$AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ _$m, 40), E = _$FA + (CA = w) | 0, _$H = y, E = p + ((y = QA + y | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = M, M = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = _$U) + (_$U = w) | 0, _$m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = _$N + IA | 0, r = E = (_ = k + G | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = (k = w) + GA | 0, E = b + ((f = t + _A | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, s = KI(s ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ x, 32), _$N = n = w, n = E, G = t, E = _$N + Y | 0, E = (t = s + _$K | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _$K = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = DA + (u = w) | 0, E = ((k = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + n | 0, b = _$N, _$N = E = (n = f + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, l ^ $, 1), Y = E = w, b = r, E = E + BA | 0, E = O + ((r = s + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + b | 0, b = _ = S + _ | 0, c = KI(_ ^ s, (c = Y) ^ (Y = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = _$NA + (R = w) | 0, E = F + ((_ = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = L + _$B | 0, E = ((s = v + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + _$m | 0) ^ hA, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), L = E, E = kA + (x = w) | 0, E = F + ((l = f + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, _$AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + Y | 0, Y = _ = c + b | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + _$FA | 0, E = _$N + ((_ = y + QA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ _$U, 32), E = (_$N = w) + D | 0, _$U = E = (D = _ + _$AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = BA + ($ = w) | 0, R = y, E = n + ((y = j + y | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = _$N, _$N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = _$U) + (_$U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + _$K | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = _$NA + (k = w) | 0, E = M + ((D = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ J, 32), _$K = E = w, G = t, E = E + b | 0, E = (t = h + Y | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = _$wA + (Y = w) | 0, E = p + ((k = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _$K, _$K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(_$H ^ _$m, V ^ CA, 1), b = E = w, M = e, E = E + _$X | 0, E = _$W + ((e = I + h | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, _$d = E = (e = e + _$d | 0) >>> 0 < _$d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = _$fA + (_$H = w) | 0, E = _$d + ((_ = c + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, _$m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + sA | 0, E = ((h = x + _$gA | 0) >>> 0 < _$gA >>> 0 ? E + 1 | 0 : E) + e | 0, _$d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (_$W = w) + O | 0, D = KI((h = _ + q | 0) ^ x, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = C + (J = w) | 0, E = _$d + ((l = D + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, E = (_$d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _$W, _$W = E, e = KI(_ ^ _$d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, _$AA = s, T = y, y = c, c = KI(S ^ _$m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ _$H, 1), E = (_$H = w) + tA | 0, E = _$K + ((_ = y + _$z | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ _$U, 32), E = (_$K = w) + f | 0, _$U = E = (f = _ + _$AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ _$H, 40), E = GA + (CA = w) | 0, _$H = y, E = p + ((y = _A + y | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = _$K, _$K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = _$U) + (_$U = w) | 0, _$m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + DA | 0, E = _$N + ((f = t + oA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), _$N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = _$yA + (Y = w) | 0, E = n + ((k = t + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, b = _$N, _$N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + P | 0, E = v + ((r = s + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (R = w) | 0, E = F + ((_ = c + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + C | 0, E = ((s = J + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + _$m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = _$NA + (J = w) | 0, E = F + ((l = f + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, _$AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + P | 0, E = _$N + ((_ = y + aA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ _$U, 32), E = (_$N = w) + D | 0, _$U = E = (D = _ + _$AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = _$yA + ($ = w) | 0, R = y, E = n + ((y = rA + y | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = _$N, _$N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = _$U) + (_$U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = DA + (k = w) | 0, E = _$K + ((D = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), _$K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = GA + (Y = w) | 0, E = p + ((k = t + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _$K, _$K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(_$H ^ _$m, V ^ CA, 1), b = E = w, M = e, E = E + BA | 0, E = _$W + ((e = h + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, _$d = E = (e = e + _$d | 0) >>> 0 < _$d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (_$H = w) | 0, E = _$d + ((_ = c + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) | 0, _$m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + _$fA | 0, E = ((h = J + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + e | 0, _$d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (_$W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = _$X + (J = w) | 0, E = _$d + ((l = I + D | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, E = (_$d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _$W, _$W = E, e = KI(_ ^ _$d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, _$AA = s, T = y, y = c, c = KI(S ^ _$m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ _$H, 1), E = (_$H = w) + _$wA | 0, E = _$K + ((_ = y + EA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ _$U, 32), E = (_$K = w) + f | 0, _$U = E = (f = _ + _$AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ _$H, 40), E = _$B + (CA = w) | 0, _$H = y, E = p + ((y = g + y | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = _$K, _$K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = _$U) + (_$U = w) | 0, _$m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + sA | 0, E = _$N + ((f = t + _$gA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), _$N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = _$FA + (Y = w) | 0, E = n + ((k = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, b = _$N, _$N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + kA | 0, E = v + ((r = s + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = tA + (R = w) | 0, E = F + ((_ = c + _$z | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + SA | 0, E = ((s = J + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + _$m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = _$yA + (J = w) | 0, E = F + ((l = f + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, _$AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + _$NA | 0, E = _$N + ((_ = y + iA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ _$U, 32), E = (_$N = w) + D | 0, _$U = E = (D = _ + _$AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = C + ($ = w) | 0, R = y, E = n + ((y = pA + y | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = _$N, _$N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = _$U) + (_$U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = _$FA + (k = w) | 0, E = _$K + ((D = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), _$K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = P + (Y = w) | 0, E = p + ((k = t + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _$K, _$K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(_$H ^ _$m, V ^ CA, 1), b = E = w, M = e, E = E + GA | 0, E = _$W + ((e = h + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, _$d = E = (e = e + _$d | 0) >>> 0 < _$d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = kA + (_$H = w) | 0, E = _$d + ((_ = c + _$eA | 0) >>> 0 < _$eA >>> 0 ? E + 1 | 0 : E) | 0, _$m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + DA | 0, E = ((h = J + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + e | 0, _$d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (_$W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = _$B + (J = w) | 0, E = _$d + ((l = D + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, E = (_$d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _$W, _$W = E, e = KI(_ ^ _$d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, _$AA = s, T = y, y = c, c = KI(S ^ _$m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ _$H, 1), E = (_$m = w) + BA | 0, E = _$K + ((_ = y + j | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ _$U, 32), E = (_$K = w) + f | 0, _$U = f = _ + _$AA | 0, _$H = E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ _$m, 40), E = _$fA + (_$AA = w) | 0, _$m = y, E = p + ((y = Z + y | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, f = y + s | 0, y = _$K, _$K = E = f >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ f, y ^ E, 48), E = (E = _$H) + (_$H = w) | 0, _$U = _ = y + _$U | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + _$X | 0, E = _$N + ((p = I + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (p = p + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _$N = s = KI(s ^ p, E ^ L, 32), G = E = w, u = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, Y = t, t ^= u, u = E, t = KI(t, E ^ k, 40), E = _$wA + (b = w) | 0, E = n + ((s = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, M = (s = s + p | 0) ^ _$N, _$N = E = s >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = KI(M, E ^ G, 48), L = E = w, k = E, G = n = KI(q ^ R, O ^ $, 1), M = E = w, R = r, E = E + tA | 0, E = v + ((r = n + _$z | 0) >>> 0 < _$z >>> 0 ? E + 1 | 0 : E) | 0, E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = S, S = E, n = KI(c ^ r, F ^ E, 32), E = (T = w) + R | 0, F = _ = n + _ | 0, c = KI(c = _ ^ G, (G = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ M, 40), E = sA + (M = w) | 0, E = S + ((_ = c + _$gA | 0) >>> 0 < _$gA >>> 0 ? E + 1 | 0 : E) | 0, S = _ = _ + r | 0, R = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + _$fA | 0, E = ((v = Z) >>> 0 > (Z = J + Z | 0) >>> 0 ? E + 1 | 0 : E) + r | 0, _$fA = E = (_ = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, Z = KI(_ ^ p, E ^ k, 32), E = (q = w) + V | 0, k = KI((r = _$U + Z | 0) ^ J, (E = r >>> 0 < Z >>> 0 ? E + 1 | 0 : E) ^ l, 40), v = E, E = _$wA + (O = w) | 0, E = _$fA + ((J = EA) >>> 0 > (EA = k + EA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (EA = _ + EA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = Z ^ EA, Z = E;
                                        _$wA = KI(_, E ^ q, 48), E = (_$fA = w) + v | 0, r = E = (_ = r + _$wA | 0) >>> 0 < _$wA >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ k, E ^ O, 1), k = w, q = E, O = h, h = _$gA, v = sA, sA = KI(n ^ S, R ^ T, 48), E = (n = w) + G | 0, G = h, F = E = (_$gA = F + sA | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E, h = KI(c ^ (S = _$gA), E ^ M, 1), E = (M = w) + v | 0, E = _$N + (h >>> 0 > (_$gA = G + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, c = E = (_$gA = s + _$gA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(y ^ _$gA, E ^ _$H, 32), E = (E = D) + (D = w) | 0, _$N = s = y + O | 0, G = E = s >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = (M = w) + _$NA | 0, E = (s >>> 0 > (iA = s + iA | 0) >>> 0 ? E + 1 | 0 : E) + c | 0, c = E = (c = iA) >>> 0 > (iA = _$gA + iA | 0) >>> 0 ? E + 1 | 0 : E, y = KI(y ^ iA, E ^ D, 48), E = (h = w) + G | 0, D = _$gA = y + _$N | 0, _$NA = E = _$gA >>> 0 < y >>> 0 ? E + 1 | 0 : E, _$N = I, G = _$X, E = u + L | 0, _$gA = E = (I = p + Y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _$X = KI(I ^ t, E ^ b, 1), E = (p = w) + G | 0, E = _$K + ((t = _$N + _$X | 0) >>> 0 < _$X >>> 0 ? E + 1 | 0 : E) | 0, e = KI((t = t + f | 0) ^ e, (E = t >>> 0 < f >>> 0 ? E + 1 | 0 : E) ^ x, 32), _$N = E, _$K = oA, oA = _$X, E = (f = w) + F | 0, F = p, p = E = (_$X = e + S | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, oA = KI(_$X ^ oA, F ^ E, 40), E = (S = w) + DA | 0, E = ((DA = _$K + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + _$N | 0, _$N = DA, t = e ^ (DA = t + DA | 0), e = E = _$N >>> 0 > DA >>> 0 ? E + 1 | 0 : E, E = KI(t, E ^ f, 48), u = t = w, f = E, F = j, _$N = BA, j = KI(_$U ^ _$m, V ^ _$AA, 1), G = E = w, E = E + SA | 0, E = _$W + ((j = (_$K = j) + _$cA | 0) >>> 0 < _$cA >>> 0 ? E + 1 | 0 : E) | 0, _$cA = E = (j = _$d + j | 0) >>> 0 < _$d >>> 0 ? E + 1 | 0 : E, BA = KI(j ^ sA, E ^ n, 32), E = (_$d = w) + _$gA | 0, _$gA = I = BA + I | 0, sA = KI(I ^ _$K, (n = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ G, 40), E = (E = _$N) + (_$N = w) | 0, E = _$cA + ((I = sA + F | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E) | 0, _$cA = I = I + j | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = E, E = k + _$FA | 0, E = ((_$K = QA) >>> 0 > (QA = q + QA | 0) >>> 0 ? E + 1 | 0 : E) + j | 0, _$FA = E = (j = I + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, QA = KI(f ^ j, E ^ t, 32), E = (_$K = w) + _$NA | 0, t = I = QA + D | 0, I = KI(I ^ q, (F = k) ^ (k = I >>> 0 < QA >>> 0 ? E + 1 | 0 : E), 40), E = GA + (G = w) | 0, GA = I, E = _$FA + ((I = _A + I | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, _$FA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, F = E, b = E ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), j = KI(BA ^ _$cA, _$d ^ SA, 48), E = (_$cA = w) + n | 0, n = I = j + _$gA | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, BA = rA, E = p + u | 0, rA = E = (I = f + _$X | 0) >>> 0 < _$X >>> 0 ? E + 1 | 0 : E, oA = KI(I ^ oA, E ^ S, 1), E = (f = w) + _$yA | 0, E = ((BA = oA + BA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + c | 0, BA = E = (_$yA = BA + iA | 0) >>> 0 < BA >>> 0 ? E + 1 | 0 : E, _$gA = KI(_$yA ^ _$wA, E ^ _$fA, 32), E = (_$X = w) + SA | 0, iA = E = (_A = _$gA + n | 0) >>> 0 < _$gA >>> 0 ? E + 1 | 0 : E, _$wA = _$gA, _$gA = KI(oA ^ _A, E ^ f, 40), E = (c = w) + kA | 0, E = (_$gA >>> 0 > (oA = _$gA + _$eA | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, p = _$X, _$X = E = (_$yA = oA + _$yA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, oA = KI(_$wA ^ (_$eA = _$yA), p ^ E, 48), E = (f = w) + iA | 0, E = (BA = oA + _A | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, _A = BA, BA ^= Y, o[A + 8 | 0] = BA, o[A + 9 | 0] = BA >>> 8, o[A + 10 | 0] = BA >>> 16, o[A + 11 | 0] = BA >>> 24, iA = E, E ^= b, o[A + 12 | 0] = E, o[A + 13 | 0] = E >>> 8, o[A + 14 | 0] = E >>> 16, o[A + 15 | 0] = E >>> 24, _$yA = I, BA = rA, I = j, j = KI(s ^ D, M ^ _$NA, 1), E = (kA = w) + _$B | 0, E = (j >>> 0 > (rA = j + g | 0) >>> 0 ? E + 1 | 0 : E) + Z | 0, EA = E = (D = rA) >>> 0 > (rA = EA + rA | 0) >>> 0 ? E + 1 | 0 : E, I = KI(I ^ rA, E ^ _$cA, 32), E = (E = BA) + (BA = w) | 0, _$cA = E = (_$yA = I + _$yA | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, _$wA = I, _$yA = KI(j ^ (Z = _$yA), E ^ kA, 40), E = (s = w) + C | 0, E = EA + ((I = _$yA + pA | 0) >>> 0 < _$yA >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E, EA = I, I ^= _$wA, _$wA = E, rA = KI(I, E ^ BA, 48), E = (D = w) + _$cA | 0, Z = I = rA + Z | 0, _$cA = I >>> 0 < rA >>> 0 ? E + 1 | 0 : E, sA = I = KI(n ^ sA, _$N ^ SA, 1), kA = E = w, E = E + P | 0, E = e + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, P = E = (j = I + DA | 0) >>> 0 < DA >>> 0 ? E + 1 | 0 : E, I = (BA = KI(y ^ j, E ^ h, 32)) + _ | 0, E = (_ = w) + r | 0, DA = I, I = (aA = KI(e = I ^ sA, (sA = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ kA, 40)) + _$z | 0, E = (_$z = w) + tA | 0, E = P + (I >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (P = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = P ^ bA ^ Z, o[0 | (I = A)] = j, o[I + 1 | 0] = j >>> 8, o[I + 2 | 0] = j >>> 16, o[I + 3 | 0] = j >>> 24, j = E ^ Q ^ _$cA, o[I + 4 | 0] = j, o[I + 5 | 0] = j >>> 8, o[I + 6 | 0] = j >>> 16, o[I + 7 | 0] = j >>> 24, j = (BA = KI(P ^ BA, E ^ _, 48)) + DA | 0, E = (DA = w) + sA | 0, E = (sA = j >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ _$wA, P = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ EA ^ j, o[I + 16 | 0] = P, o[I + 17 | 0] = P >>> 8, o[I + 18 | 0] = P >>> 16, o[I + 19 | 0] = P >>> 24, o[I + 20 | 0] = E, o[I + 21 | 0] = E >>> 8, o[I + 22 | 0] = E >>> 16, o[I + 23 | 0] = E >>> 24, I = KI(QA ^ _$FA, F ^ _$K, 48), P = w, EA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ KI(_$gA ^ _A, c ^ iA, 1) ^ I, o[A + 32 | 0] = E, o[A + 33 | 0] = E >>> 8, o[A + 34 | 0] = E >>> 16, o[A + 35 | 0] = E >>> 24, E = w ^ EA ^ P, o[A + 36 | 0] = E, o[A + 37 | 0] = E >>> 8, o[A + 38 | 0] = E >>> 16, o[A + 39 | 0] = E >>> 24, E = k + P | 0, E = (EA = I + t | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, _$gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ _$X ^ E, P = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ _$eA ^ EA, o[I + 24 | 0] = P, o[I + 25 | 0] = P >>> 8, o[I + 26 | 0] = P >>> 16, o[I + 27 | 0] = P >>> 24, o[I + 28 | 0] = _$gA, o[I + 29 | 0] = _$gA >>> 8, o[I + 30 | 0] = _$gA >>> 16, o[I + 31 | 0] = _$gA >>> 24, _$gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ KI(j ^ aA, _$z ^ sA, 1), o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, I = D ^ w ^ _$gA, o[A + 44 | 0] = I, o[A + 45 | 0] = I >>> 8, o[A + 46 | 0] = I >>> 16, o[A + 47 | 0] = I >>> 24, j = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ KI(Z ^ _$yA, s ^ _$cA, 1), o[A + 56 | 0] = I, o[A + 57 | 0] = I >>> 8, o[A + 58 | 0] = I >>> 16, o[A + 59 | 0] = I >>> 24, I = DA ^ w ^ j, o[A + 60 | 0] = I, o[A + 61 | 0] = I >>> 8, o[A + 62 | 0] = I >>> 16, o[A + 63 | 0] = I >>> 24, j = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = oA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ KI(EA ^ GA, E ^ G, 1), o[A + 48 | 0] = I, o[A + 49 | 0] = I >>> 8, o[A + 50 | 0] = I >>> 16, o[A + 51 | 0] = I >>> 24, I = f ^ w ^ j, o[A + 52 | 0] = I, o[A + 53 | 0] = I >>> 8, o[A + 54 | 0] = I >>> 16, o[A + 55 | 0] = I >>> 24;
                                    }
                                    function n(A, I, g, C, B, Q, i) {
                                        var _, c, t, r, e, y, s, D, p, f, n, k, F, S, G, M, b, _$K, _$H, Y, _$d, J, _$U, l, _$m, u, x, R, v, L, P, q, j, _$X, O, V, Z, _$W, T, $, _$AA, IA, _$gA, CA, BA, QA, iA, oA, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0, _$yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, _$wA = 0, _$fA = 0, _$FA = 0, _$NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, _$YA = 0, _$dA = 0, _$JA = 0, _$UA = 0, lA = 0, _$mA = 0, uA = 0, _$xA = 0, RA = 0, vA = 0, _$LA = 0, PA = 0, qA = 0, zA = 0, jA = 0, XA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, TA = 0, $A = 0, AI = 0, II = 0;
                                        return h = t = h - 560 | 0, SI(_A = t + 352 | 0), i && nA(_A, 35600, 34, 0), kI(t + 288 | 0, Q, 32, 0), nA(_$cA = t + 352 | 0, t + 320 | 0, 32, 0), nA(_$cA, g, C, B), z(_$cA, _$yA = t + 224 | 0), sA = a[(aA = Q) + 32 | 0] | a[aA + 33 | 0] << 8 | a[aA + 34 | 0] << 16 | a[aA + 35 | 0] << 24, DA = a[aA + 36 | 0] | a[aA + 37 | 0] << 8 | a[aA + 38 | 0] << 16 | a[aA + 39 | 0] << 24, tA = a[aA + 40 | 0] | a[aA + 41 | 0] << 8 | a[aA + 42 | 0] << 16 | a[aA + 43 | 0] << 24, EA = a[aA + 44 | 0] | a[aA + 45 | 0] << 8 | a[aA + 46 | 0] << 16 | a[aA + 47 | 0] << 24, _A = a[aA + 48 | 0] | a[aA + 49 | 0] << 8 | a[aA + 50 | 0] << 16 | a[aA + 51 | 0] << 24, Q = a[aA + 52 | 0] | a[aA + 53 | 0] << 8 | a[aA + 54 | 0] << 16 | a[aA + 55 | 0] << 24, rA = a[aA + 60 | 0] | a[aA + 61 | 0] << 8 | a[aA + 62 | 0] << 16 | a[aA + 63 | 0] << 24, aA = a[aA + 56 | 0] | a[aA + 57 | 0] << 8 | a[aA + 58 | 0] << 16 | a[aA + 59 | 0] << 24, o[A + 56 | 0] = aA, o[A + 57 | 0] = aA >>> 8, o[A + 58 | 0] = aA >>> 16, o[A + 59 | 0] = aA >>> 24, o[A + 60 | 0] = rA, o[A + 61 | 0] = rA >>> 8, o[A + 62 | 0] = rA >>> 16, o[A + 63 | 0] = rA >>> 24, o[A + 48 | 0] = _A, o[A + 49 | 0] = _A >>> 8, o[A + 50 | 0] = _A >>> 16, o[A + 51 | 0] = _A >>> 24, o[A + 52 | 0] = Q, o[A + 53 | 0] = Q >>> 8, o[A + 54 | 0] = Q >>> 16, o[A + 55 | 0] = Q >>> 24, o[A + 40 | 0] = tA, o[A + 41 | 0] = tA >>> 8, o[A + 42 | 0] = tA >>> 16, o[A + 43 | 0] = tA >>> 24, o[A + 44 | 0] = EA, o[A + 45 | 0] = EA >>> 8, o[A + 46 | 0] = EA >>> 16, o[A + 47 | 0] = EA >>> 24, o[0 | (Q = A + 32 | 0)] = sA, o[Q + 1 | 0] = sA >>> 8, o[Q + 2 | 0] = sA >>> 16, o[Q + 3 | 0] = sA >>> 24, o[Q + 4 | 0] = DA, o[Q + 5 | 0] = DA >>> 8, o[Q + 6 | 0] = DA >>> 16, o[Q + 7 | 0] = DA >>> 24, N(_$yA), kA(t, _$yA), tg(A, t), SI(_$cA), i && nA(_$cA, 35600, 34, 0), nA(i = t + 352 | 0, A, 64, 0), nA(i, g, C, B), z(i, _$eA = t + 160 | 0), N(_$eA), o[t + 288 | 0] = 248 & a[t + 288 | 0], o[t + 319 | 0] = 63 & a[t + 319 | 0] | 64, g = a[23 + (A = c = t + 288 | 0) | 0], tA = Ig(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, e = (a[_$eA + 28 | 0] | a[_$eA + 29 | 0] << 8 | a[_$eA + 30 | 0] << 16 | a[_$eA + 31 | 0] << 24) >>> 7 | 0, 0), _A = w, g = (A = a[_$eA + 27 | 0]) >>> 24 | 0, B = A << 8 | (EA = a[_$eA + 23 | 0] | a[_$eA + 24 | 0] << 8 | a[_$eA + 25 | 0] << 16 | a[_$eA + 26 | 0] << 24) >>> 24, A = Ig(y = 2097151 & ((3 & (DA = (A = (C = a[_$eA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, s = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = w + _A | 0, C = A >>> 0 > (B = A + tA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D = (g = a[_$eA + 23 | 0]) << 16 & 2031616 | a[_$eA + 21 | 0] | a[_$eA + 22 | 0] << 8, 0, p = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = w + C | 0, _A = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = Ig(f = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, n = EA >>> 5 & 2097151, 0), g = w + B | 0, aA = C = A + _A | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, EA = Ig(s, 0, n, 0), _A = w, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (SA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = Ig(k = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, DA = C >>> 3 | 0, e, 0), A = w + _A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = Ig(r, 0, y, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > (EA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[_$eA + 19 | 0]) >>> 24 | 0, _A = A << 8 | (_$NA = a[_$eA + 15 | 0] | a[_$eA + 16 | 0] << 8 | a[_$eA + 17 | 0] << 16 | a[_$eA + 18 | 0] << 24) >>> 24, A = Ig(F = (7 & (tA = (A = (i = a[_$eA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | _A) >>> 3, S = tA >>> 3 | 0, p, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D, 0, f, 0), g = w + g | 0, sA = g = A >>> 0 > (_$yA = A + C | 0) >>> 0 ? g + 1 | 0 : g, pA = A = g - ((_$yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, EA = C = (A = (2097151 & A) << 11 | (tA = _$yA - -1048576 | 0) >>> 21) >>> 0 > (aA = A + aA | 0) >>> 0 ? C + 1 | 0 : C, _$fA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & A) << 11 | (_A = aA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = Ig(p, 0, n, 0), g = w, C = A, A = Ig(e, 0, s, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, _$wA = (A = C) + (C = Ig(y, 0, f, 0)) | 0, A = w + g | 0, A = C >>> 0 > _$wA >>> 0 ? A + 1 | 0 : A, _$cA = _$wA - (g = -2097152 & (C = _$wA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((_$wA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > _$wA >>> 0) | 0) | 0) + i | 0, v = g = (A = _$cA + rA | 0) >>> 0 < _$cA >>> 0 ? g + 1 | 0 : g, L = A, _$cA = Ig(A, g, 470296, 0), rA = w, g = Ig(e, 0, f, 0), A = w, i = g, g = Ig(y, 0, p, 0), A = w + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, HA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, P = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, q = g = aA - (C = -2097152 & _A) | 0, j = B = EA - ((C >>> 0 > aA >>> 0) + _$fA | 0) | 0, _$X = A, C = Ig(A, i, 666643, 0), A = w + rA | 0, A = C >>> 0 > (i = C + _$cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(g, B, 654183, 0), g = w + A | 0, hA = B = C + i | 0, _A = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, _$wA = _$yA - (A = -2097152 & tA) | 0, pA = sA - ((A >>> 0 > _$yA >>> 0) + pA | 0) | 0, g = Ig(y, 0, k, DA), C = w, B = (A = g) + (g = Ig(G = SA >>> 6 & 2097151, 0, e, 0)) | 0, A = w + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, D, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, n, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, M = _$NA >>> 6 & 2097151, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, F, S), g = w + A | 0, _$yA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = Ig(b = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, e, 0), A = w, C = g, g = Ig(y, 0, G, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(n, 0, k, DA)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(s, 0, F, S), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, D, 0), g = w + g | 0, tA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[_$eA + 14 | 0]) >>> 24 | 0, EA = A << 8 | (aA = a[_$eA + 10 | 0] | a[_$eA + 11 | 0] << 8 | a[_$eA + 12 | 0] << 16 | a[_$eA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[_$eA + 15 | 0]) >>> 16 | 0, g = Ig(_$K = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | EA) >>> 1), 0, p, 0), A = w + B | 0, A = g >>> 0 > (C = g + tA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, M, 0), A = w + A | 0, EA = A = g >>> 0 > (tA = g + C | 0) >>> 0 ? A + 1 | 0 : A, _$YA = g = A - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, rA = C = (g = (2097151 & g) << 11 | (_$cA = tA - -1048576 | 0) >>> 21) >>> 0 > (_$fA = g + _$yA | 0) >>> 0 ? C + 1 | 0 : C, MA = g = C - ((_$fA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + pA | 0, O = A = (g = (C = (2097151 & g) << 11 | (_$yA = _$fA - -1048576 | 0) >>> 21) + _$wA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, V = g, A = Ig(g, A, -997805, -1), g = w + _A | 0, hA = C = A + hA | 0, _A = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, _$wA = (_$UA = a[23 + (_ = t + 224 | 0) | 0] | a[_ + 24 | 0] << 8 | a[_ + 25 | 0] << 16 | a[_ + 26 | 0] << 24) >>> 5 & 2097151, C = Ig(_$H = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, n, 0), g = w, B = (A = Ig(D, 0, Y = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(_$d = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, M, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(_$K, 0, J = sA >>> 4 & 2097151, 0), A = w + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = Ig(_$U = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, F, S), A = w + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(G, 0, l = (a[_$eA + 7 | 0] | a[_$eA + 8 | 0] << 8 | a[_$eA + 9 | 0] << 16 | a[_$eA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = Ig(b, 0, bA = aA >>> 4 & 2097151, 0), A = w + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[_$eA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (aA = a[_$eA + 2 | 0] | a[_$eA + 3 | 0] << 8 | a[_$eA + 4 | 0] << 16 | a[_$eA + 5 | 0] << 24) >>> 24, g = A, A = Ig(k, DA, _$m = 2097151 & ((3 & (g |= C = (A = a[_$eA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = w + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = Ig(u = (A = a[_$eA + 2 | 0]) << 16 & 2031616 | a[0 | _$eA] | a[_$eA + 1 | 0] << 8, 0, s, 0), A = w + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, x = aA >>> 5 & 2097151, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + _$wA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[_ + 21 | 0] | a[_ + 22 | 0] << 8, A = Ig(D, 0, _$H, 0), g = w, aA = (C = A) + (A = Ig(F, S, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(_$K, 0, _$d, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, bA, 0), g = w + g | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = C) + (C = Ig(M, 0, _$U, 0)) | 0, A = w + g | 0, A = C >>> 0 > aA >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, _$m, 0), A = w + A | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, aA = (g = Ig(b, 0, l, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, x, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, u, 0), g = w + g | 0, A = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[_ + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, _$eA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (aA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + _A | 0, A = (_A = i + hA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, SA = i - -1048576 | 0, _$FA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, GA = _A - (g = -2097152 & SA) | 0, _$dA = A - ((g >>> 0 > _A >>> 0) + i | 0) | 0, sA = B, _A = C, A = Ig(q, j, 470296, 0), g = w, C = A, A = Ig(L, v, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(V, O, 654183, 0)) | 0, A = w + g | 0, _$NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(F, S, _$H, 0), A = w, C = g, g = Ig(M, 0, Y, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(_$d, 0, bA, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, l, 0), C = w + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(_$K, 0, _$U, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(b, 0, _$m, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(k, DA, u, 0)) | 0, g = w + A | 0, _$wA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 19 | 0]) >>> 24 | 0, pA = A << 8 | (hA = a[_ + 15 | 0] | a[_ + 16 | 0] << 8 | a[_ + 17 | 0] << 16 | a[_ + 18 | 0] << 24) >>> 24, C = ((_$JA = (A = (B = a[_ + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, _$wA = B = (g = (7 & _$JA) << 29 | (g = (B <<= 16) | pA) >>> 3) + _$wA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, pA = hA >>> 6 & 2097151, A = Ig(M, 0, _$H, 0), g = w, C = A, A = Ig(_$K, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, hA = (A = C) + (C = Ig(_$d, 0, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > hA >>> 0 ? A + 1 | 0 : A, C = Ig(J, 0, _$m, 0), g = w + A | 0, g = C >>> 0 > (hA = C + hA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(_$U, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (hA = C + hA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, u, 0), C = w + A | 0, C = g >>> 0 > (hA = g + hA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, x, 0), g = w + C | 0, A = A >>> 0 > (hA = A + hA | 0) >>> 0 ? g + 1 | 0 : g, qA = A = (_$mA = hA + pA | 0) >>> 0 < hA >>> 0 ? A + 1 | 0 : A, WA = A = A - ((_$mA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_$LA = _$mA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, jA = A = C >>> 0 > (zA = C + _$wA | 0) >>> 0 ? A + 1 | 0 : A, TA = A = A - ((zA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_$xA = zA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + _$NA | 0) >>> 0 ? A + 1 | 0 : A) + _A | 0, _A = (C = B + sA | 0) - (A = -2097152 & aA) | 0, _$eA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + _$eA | 0) | 0, $A = A = A - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (RA = _A - -1048576 | 0) >>> 21, A = (A >> 21) + _$dA | 0, B = A = C >>> 0 > (i = C + GA | 0) >>> 0 ? A + 1 | 0 : A, ZA = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, vA = (2097151 & A) << 11 | (_$NA = i - -1048576 | 0) >>> 21, sA = A >> 21, _$JA = _$fA - (A = -2097152 & _$yA) | 0, MA = rA - ((A >>> 0 > _$fA >>> 0) + MA | 0) | 0, A = Ig(e, 0, p, 0), PA = g = w, GA = A, hA = A - -1048576 | 0, uA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, Z = A = g >>> 21 | 0, A = Ig(R = (2097151 & g) << 11 | hA >>> 21, A, -683901, -1), g = w + EA | 0, g = A >>> 0 > (C = A + tA | 0) >>> 0 ? g + 1 | 0 : g, _$yA = C - (A = -2097152 & _$cA) | 0, aA = g - ((A >>> 0 > C >>> 0) + _$YA | 0) | 0, g = Ig(n, 0, G, 0), A = w, C = g, g = Ig(e, 0, J, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, b, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = C) + (C = Ig(D, 0, k, DA)) | 0, g = w + A | 0, g = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, A = Ig(s, 0, M, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, F, S), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, _$K, 0), A = w + A | 0, tA = C = g + EA | 0, EA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = Ig(y, 0, J, 0), g = w, C = A, A = Ig(e, 0, _$d, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = Ig(D, 0, G, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = Ig(n, 0, b, 0), g = w + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(k, DA, F, S), A = w + g | 0, A = C >>> 0 > (rA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, _$K, 0), A = w + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = C) + (C = Ig(r, 0, M, 0)) | 0, g = w + A | 0, g = C >>> 0 > rA >>> 0 ? g + 1 | 0 : g, A = Ig(p, 0, l, 0), C = w + g | 0, C = A >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(f, 0, bA, 0), g = w + C | 0, pA = g = A >>> 0 > (_$wA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, OA = A = g - ((_$wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (_$fA = _$wA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, _$cA = A = g >>> 0 > (_$YA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, lA = A = A - ((_$YA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + aA | 0, _$yA = g = (A = (2097151 & A) << 11 | (rA = _$YA - -1048576 | 0) >>> 21) >>> 0 > (_$dA = A + _$yA | 0) >>> 0 ? g + 1 | 0 : g, XA = A = g - ((_$dA >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & A) << 11 | (aA = _$dA - -1048576 | 0) >>> 21, A = (A >> 21) + MA | 0, _$W = A = (g = EA + _$JA | 0) >>> 0 < EA >>> 0 ? A + 1 | 0 : A, T = g, A = Ig(g, A, -683901, -1), g = w + sA | 0, vA = C = A + vA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(y, 0, _$H, 0), g = w, C = A, A = Ig(n, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(F, S, _$d, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, J, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(D, 0, _$U, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(G, 0, bA, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(b, 0, _$K, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(k, DA, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, x, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(r, 0, _$m, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, u, 0), g = w + A | 0, MA = EA = C + EA | 0, C = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 27 | 0]) >>> 24 | 0, tA = A << 8 | _$UA >>> 24, EA = 2097151 & ((3 & (g |= A = (EA = a[_ + 28 | 0]) >>> 16 | 0)) << 30 | (A = (EA <<= 16) | tA) >>> 2), g = C, tA = A = EA + MA | 0, EA = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g, _$JA = Ig(_$X, P, 470296, 0), MA = w, A = (C = (2097151 & HA) << 11 | KA >>> 21) + (GA - (g = -2097152 & hA) | 0) | 0, g = PA - ((524287 & uA) + (g >>> 0 > GA >>> 0) | 0) + (HA >>> 21) | 0, $ = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, _$AA = A, g = Ig(A, g, 666643, 0), A = w + MA | 0, A = g >>> 0 > (C = g + _$JA | 0) >>> 0 ? A + 1 | 0 : A, hA = (g = Ig(L, v, 654183, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > hA >>> 0 ? C + 1 | 0 : C, g = Ig(q, j, -997805, -1), A = w + C | 0, A = g >>> 0 > (hA = g + hA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(V, O, 136657, 0), g = w + A | 0, SA = (A = (2097151 & _$FA) << 11 | SA >>> 21) + (hA = C + hA | 0) | 0, g = (_$FA >>> 21 | 0) + (C >>> 0 > hA >>> 0 ? g + 1 | 0 : g) | 0, uA = hA = EA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > SA >>> 0 ? g + 1 | 0 : g) + EA | 0, g = (EA = tA + SA | 0) - (C = -2097152 & (PA = tA - -1048576 | 0)) | 0, C = (A = (A = EA >>> 0 < SA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > EA >>> 0) + hA | 0) | 0) + sA | 0, _$JA = EA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, GA = (C = (tA = g + vA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (MA = g - -1048576 | 0)) >>> 0 > tA >>> 0) + EA | 0) | 0, _$UA = A = tA - g | 0, EA = i, i = B, VA = _$dA - (A = -2097152 & aA) | 0, hA = _$yA - ((A >>> 0 > _$dA >>> 0) + XA | 0) | 0, A = Ig(_$AA, $, -683901, -1), g = w, B = (C = A) + (A = Ig(R, Z, 136657, 0)) | 0, C = w + g | 0, g = _$cA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, rA = (C = B + _$YA | 0) - (A = -2097152 & rA) | 0, _$yA = (g = C >>> 0 < _$YA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + lA | 0) | 0, g = Ig(R, Z, -997805, -1), A = w + pA | 0, A = g >>> 0 > (C = g + _$wA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(_$AA, $, 136657, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(_$X, P, -683901, -1), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = B - (A = -2097152 & _$fA) | 0, sA = g - ((A >>> 0 > B >>> 0) + OA | 0) | 0, g = Ig(n, 0, J, 0), A = w, C = g, g = Ig(y, 0, _$d, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(e, 0, _$U, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(F, S, G, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(D, 0, b, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, M, 0), g = w + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, _$K, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(p, 0, _$m, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(f, 0, l, 0), A = w + g | 0, tA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(n, 0, _$d, 0), g = w, C = A, A = Ig(e, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, _$cA = (A = C) + (C = Ig(D, 0, J, 0)) | 0, A = w + g | 0, A = C >>> 0 > _$cA >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, _$U, 0), C = w + A | 0, C = g >>> 0 > (_$cA = g + _$cA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(G, 0, M, 0), g = w + C | 0, g = A >>> 0 > (_$cA = A + _$cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, b, 0), A = w + g | 0, A = C >>> 0 > (_$cA = C + _$cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, _$K, 0), g = w + A | 0, g = C >>> 0 > (_$cA = C + _$cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, l, 0), A = w + g | 0, A = C >>> 0 > (_$cA = C + _$cA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, bA, 0), C = w + A | 0, C = g >>> 0 > (_$cA = g + _$cA | 0) >>> 0 ? C + 1 | 0 : C, _$cA = (A = Ig(p, 0, x, 0)) + _$cA | 0, g = w + C | 0, C = Ig(f, 0, _$m, 0), A = w + (A >>> 0 > _$cA >>> 0 ? g + 1 | 0 : g) | 0, _$dA = A = C >>> 0 > (XA = C + _$cA | 0) >>> 0 ? A + 1 | 0 : A, _$gA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = XA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (vA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, CA = A = A - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_$FA = vA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, SA = A = C >>> 0 > (_$YA = C + aA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((_$YA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = _$YA - -1048576 | 0) >>> 21, A = (A >> 21) + _$yA | 0, B = A = C >>> 0 > (aA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, _$yA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = aA - -1048576 | 0) >>> 21, A = (A >> 21) + hA | 0, OA = A = (tA = sA + VA | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, lA = tA, A = Ig(tA, A, -683901, -1), g = w, tA = A, A = Ig(T, _$W, 136657, 0), g = w + g | 0, A = (A >>> 0 > (tA = tA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, AI = (i = EA + tA | 0) - (g = -2097152 & _$NA) | 0, II = (A = i >>> 0 < tA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + ZA | 0) | 0, sA = _A, tA = _$eA, _A = Ig(lA, OA, 136657, 0), i = w, VA = A = aA - (g = -2097152 & C) | 0, IA = B = B - ((g >>> 0 > aA >>> 0) + _$yA | 0) | 0, C = Ig(T, _$W, -997805, -1), g = w + i | 0, g = C >>> 0 > (_A = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(A, B, -683901, -1), A = w + g | 0, ZA = B = C + _A | 0, EA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(V, O, 470296, 0), g = w, B = (C = A) + (A = Ig(q, j, 666643, 0)) | 0, C = w + g | 0, g = jA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, hA = A = B + zA | 0, i = g = A >>> 0 < zA >>> 0 ? g + 1 | 0 : g, g = Ig(V, O, 666643, 0), A = w + qA | 0, A = g >>> 0 > (C = g + _$mA | 0) >>> 0 ? A + 1 | 0 : A, rA = C - (g = -2097152 & _$LA) | 0, _$wA = A - ((g >>> 0 > C >>> 0) + WA | 0) | 0, g = Ig(_$K, 0, _$H, 0), A = w, C = g, g = Ig(Y, 0, bA, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(_$d, 0, _$m, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(J, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(_$U, 0, l, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, u, 0), g = w + C | 0, aA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 14 | 0]) >>> 24 | 0, _A = A << 8 | (_$yA = a[_ + 10 | 0] | a[_ + 11 | 0] << 8 | a[_ + 12 | 0] << 16 | a[_ + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[_ + 15 | 0]) >>> 16 | 0)) << 31 | (A = _A | A << 16) >>> 1), A = B, aA = C = g + aA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, _A = _$yA >>> 4 & 2097151, A = Ig(_$H, 0, bA, 0), g = w, C = A, A = Ig(Y, 0, l, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(_$d, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, _$yA = (A = C) + (C = Ig(J, 0, u, 0)) | 0, A = w + g | 0, A = C >>> 0 > _$yA >>> 0 ? A + 1 | 0 : A, g = Ig(_$U, 0, _$m, 0), C = w + A | 0, A = g >>> 0 > (_$yA = g + _$yA | 0) >>> 0 ? C + 1 | 0 : C, _$eA = A = (_$LA = _A + _$yA | 0) >>> 0 < _$yA >>> 0 ? A + 1 | 0 : A, QA = A = A - ((_$LA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, _$fA = g = (A = (2097151 & A) << 11 | (_$NA = _$LA - -1048576 | 0) >>> 21) >>> 0 > (jA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, iA = A = g - ((jA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (_$cA = jA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + _$wA | 0, _$yA = A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, oA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, WA = g = (g = (A = (2097151 & A) << 11 | (aA = rA - -1048576 | 0) >>> 21) >>> 0 > (B = A + hA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & _$xA) >>> 0 > B >>> 0) + TA | 0) | 0, _$xA = A = B - C | 0, _A = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + EA | 0, g = ((A = (2097151 & A) << 11 | _A >>> 21) >>> 0 > (B = A + ZA | 0) >>> 0 ? C + 1 | 0 : C) + tA | 0, _$mA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & RA) >>> 0 > B >>> 0) + $A | 0) | 0, tA = A = B - C | 0, i = A - -1048576 | 0, qA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + II | 0, RA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (EA = A + AI | 0) >>> 0 ? C + 1 | 0 : C) - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, hA = _$UA - -1048576 | 0, _$wA = GA - ((_$UA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = EA - -1048576 | 0) >>> 21, A = (A >> 21) + GA | 0, $A = (_$UA = sA + _$UA | 0) - (g = -2097152 & hA) | 0, AI = (sA >>> 0 > _$UA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > _$UA >>> 0) + _$wA | 0) | 0, II = EA - (A = -2097152 & B) | 0, ZA = C - ((A >>> 0 > EA >>> 0) + RA | 0) | 0, zA = tA - (A = -2097152 & i) | 0, _$UA = _$mA - ((A >>> 0 > tA >>> 0) + qA | 0) | 0, A = Ig(lA, OA, -997805, -1), g = w, C = A, A = Ig(T, _$W, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(VA, IA, 136657, 0)) | 0, A = w + g | 0, g = WA + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, _$mA = (C = B + _$xA | 0) - (A = -2097152 & _A) | 0, qA = (g = C >>> 0 < _$xA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + TA | 0) | 0, _$xA = _$YA - (A = -2097152 & pA) | 0, GA = SA - ((A >>> 0 > _$YA >>> 0) + BA | 0) | 0, g = Ig(_$AA, $, -997805, -1), A = w, C = g, g = Ig(R, Z, 654183, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(_$X, P, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(L, v, -683901, -1), C = w + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = B + vA | 0) - (A = -2097152 & _$FA) | 0, SA = (g = C >>> 0 < vA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + CA | 0) | 0, g = Ig(_$AA, $, 654183, 0), A = w, C = g, g = Ig(R, Z, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(_$X, P, -997805, -1)) + C | 0, C = w + A | 0, g = _$dA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + XA | 0) >>> 0 < XA >>> 0 ? g + 1 | 0 : g, C = A, A = Ig(L, v, 136657, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(q, j, -683901, -1)) | 0, A = w + g | 0, _A = B - (g = -2097152 & HA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + _$gA | 0) | 0, B = (a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24) >>> 7 | 0, A = Ig(e, 0, _$H, 0), g = w, EA = (C = A) + (A = Ig(y, 0, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > EA >>> 0 ? C + 1 | 0 : C, A = Ig(D, 0, _$d, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, J, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(n, 0, _$U, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, _$K, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, b, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, bA, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, _$m, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(r, 0, l, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, u, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, x, 0), C = w + A | 0, g = C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & uA) << 11 | PA >>> 21) + (A = B + EA | 0) | 0, A = (uA >>> 21 | 0) + (g = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, RA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, tA = C = (g = (2097151 & g) << 11 | (DA = KA - -1048576 | 0) >>> 21) >>> 0 > (_$FA = g + _A | 0) >>> 0 ? C + 1 | 0 : C, PA = g = C - ((_$FA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + SA | 0, _A = A = (g = (2097151 & g) << 11 | (EA = _$FA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + pA | 0) >>> 0 ? A + 1 | 0 : A, HA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + GA | 0, uA = C = (g = (B = (2097151 & g) << 11 | (i = pA - -1048576 | 0) >>> 21) + _$xA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, GA = g, A = Ig(g, C, -683901, -1), g = w + qA | 0, SA = C = A + _$mA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = Ig(T, _$W, 470296, 0), A = w + _$yA | 0, A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(lA, OA, 654183, 0), A = w + (A - (((C = -2097152 & aA) >>> 0 > rA >>> 0) + oA | 0) | 0) | 0, A = g >>> 0 > (aA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(VA, IA, -997805, -1), g = w + A | 0, g = C >>> 0 > (aA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, _$dA = C = pA - (A = -2097152 & i) | 0, bA = _A = _A - ((A >>> 0 > pA >>> 0) + HA | 0) | 0, aA = (i = Ig(GA, uA, 136657, 0)) + aA | 0, A = w + g | 0, C = Ig(C, _A, -683901, -1), g = w + (i >>> 0 > aA >>> 0 ? A + 1 | 0 : A) | 0, _A = g = C >>> 0 > (_$yA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((_$yA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = _$yA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, pA = g = (A = g >>> 0 > (aA = g + SA | 0) >>> 0 ? A + 1 | 0 : A) - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & g) << 11 | (B = aA - -1048576 | 0) >>> 21, g = (g >> 21) + _$UA | 0, zA = SA = rA + zA | 0, SA = rA >>> 0 > SA >>> 0 ? g + 1 | 0 : g, _$UA = aA - (g = -2097152 & B) | 0, XA = A - ((g >>> 0 > aA >>> 0) + pA | 0) | 0, _$mA = _$yA - (A = -2097152 & i) | 0, qA = _A - ((A >>> 0 > _$yA >>> 0) + HA | 0) | 0, A = Ig(T, _$W, 666643, 0), C = _$fA + w | 0, C = (i = A + jA | 0) >>> 0 < jA >>> 0 ? C + 1 | 0 : C, B = (A = Ig(lA, OA, 470296, 0)) + (i - (g = -2097152 & _$cA) | 0) | 0, g = w + (C - ((g >>> 0 > i >>> 0) + iA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(VA, IA, 654183, 0), A = w + g | 0, aA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = _$FA - (A = -2097152 & EA) | 0, _A = tA - ((A >>> 0 > _$FA >>> 0) + PA | 0) | 0, A = Ig(_$AA, $, 470296, 0), g = w, C = A, A = Ig(R, Z, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(_$X, P, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(L, v, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(q, j, 136657, 0), A = w + A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = Ig(V, O, -683901, -1)) + C | 0, C = w + A | 0, g = sA + (g >>> 0 > EA >>> 0 ? C + 1 | 0 : C) | 0, _$FA = (C = (2097151 & _$JA) << 11 | MA >>> 21) + ((EA = EA + KA | 0) - (A = -2097152 & DA) | 0) | 0, A = ((g = EA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > EA >>> 0) + RA | 0) | 0) + (_$JA >> 21) | 0, pA = A = C >>> 0 > _$FA >>> 0 ? A + 1 | 0 : A, _$xA = A = A - ((_$FA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (_$cA = _$FA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, HA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = Ig(C, A, -683901, -1), g = w + B | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(GA, uA, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(_$dA, bA, 136657, 0), C = w + A | 0, MA = B = g + B | 0, tA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, aA = _$LA - (A = -2097152 & _$NA) | 0, sA = _$eA - ((A >>> 0 > _$LA >>> 0) + QA | 0) | 0, g = Ig(_$H, 0, l, 0), A = w, C = g, g = Ig(Y, 0, _$m, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(_$d, 0, u, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(_$U, 0, x, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, DA = C = (A = (a[_ + 7 | 0] | a[_ + 8 | 0] << 8 | a[_ + 9 | 0] << 16 | a[_ + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, EA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(_$H, 0, _$m, 0), g = w, C = A, A = Ig(Y, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(_$U, 0, u, 0)) | 0, A = w + g | 0, _A = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[_ + 6 | 0]) >>> 24 | 0, i = g << 8 | (RA = a[_ + 2 | 0] | a[_ + 3 | 0] << 8 | a[_ + 4 | 0] << 16 | a[_ + 5 | 0] << 24) >>> 24, C = A, g = (A = a[_ + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (_A = A + _A | 0) >>> 0 ? C + 1 | 0 : C, vA = A = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_$fA = _A - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, rA = A = C >>> 0 > (_$eA = C + DA | 0) >>> 0 ? A + 1 | 0 : A, PA = A = A - ((_$eA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (_$yA = _$eA - -1048576 | 0) >>> 21) >>> 0 > (B = A + aA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(lA, OA, 666643, 0), A = w + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(VA, IA, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(KA, HA, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = Ig(_$dA, bA, -997805, -1)) + C | 0, C = w + g | 0, sA = C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, _$JA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (DA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + tA | 0, MA = C = (A = C >>> 0 > (B = C + MA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & C) << 11 | (tA = B - -1048576 | 0) >>> 21, C = (C >> 21) + qA | 0, _$YA = _$NA = EA + _$mA | 0, _$NA = EA >>> 0 > _$NA >>> 0 ? C + 1 | 0 : C, EA = B, g = A, B = (_$FA - (A = -2097152 & _$cA) | 0) + (_$cA = (2097151 & _$wA) << 11 | hA >>> 21) | 0, A = (pA - ((A >>> 0 > _$FA >>> 0) + _$xA | 0) | 0) + (_$wA >> 21) | 0, hA = A = B >>> 0 < _$cA >>> 0 ? A + 1 | 0 : A, _$mA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, _$FA = C = A >> 21, A = Ig(lA = (2097151 & A) << 11 | (_$wA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, qA = C - (A = -2097152 & tA) | 0, _$LA = g - ((A >>> 0 > C >>> 0) + MA | 0) | 0, g = Ig(lA, _$FA, 136657, 0), A = w + sA | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, jA = C - (g = -2097152 & DA) | 0, _$JA = A - ((g >>> 0 > C >>> 0) + _$JA | 0) | 0, g = Ig(VA, IA, 666643, 0), A = w + (rA - (((C = -2097152 & _$yA) >>> 0 > _$eA >>> 0) + PA | 0) | 0) | 0, A = g >>> 0 > (EA = g + (_$eA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(KA, HA, -997805, -1), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 470296, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(_$dA, bA, 654183, 0), A = w + C | 0, MA = EA = g + EA | 0, sA = g >>> 0 > EA >>> 0 ? A + 1 | 0 : A, C = RA >>> 5 & 2097151, A = Ig(_$H, 0, x, 0), g = w, tA = A, A = Ig(Y, 0, u, 0), g = w + g | 0, A = A >>> 0 > (EA = tA + A | 0) >>> 0 ? g + 1 | 0 : g, tA = g = C + EA | 0, C = A = g >>> 0 < EA >>> 0 ? A + 1 | 0 : A, _$eA = (g = Ig(_$H, 0, u, 0)) + (A = (A = a[_ + 2 | 0]) << 16 & 2031616 | a[0 | _] | a[_ + 1 | 0] << 8) | 0, g = w, _$cA = g = A >>> 0 > _$eA >>> 0 ? g + 1 | 0 : g, _$xA = g = g - ((_$eA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, _$yA = A = (g = (2097151 & g) << 11 | (rA = _$eA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, RA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (aA = pA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (EA = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(KA, HA, 654183, 0), A = w + (g - (((i = -2097152 & _$fA) >>> 0 > EA >>> 0) + vA | 0) | 0) | 0, A = C >>> 0 > (_A = C + (EA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(GA, uA, 666643, 0), A = w + A | 0, A = g >>> 0 > (C = g + _A | 0) >>> 0 ? A + 1 | 0 : A, DA = (g = C) + (C = Ig(_$dA, bA, 470296, 0)) | 0, g = w + A | 0, tA = g = C >>> 0 > DA >>> 0 ? g + 1 | 0 : g, PA = g = g - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, _$fA = g = (C = (g = (2097151 & g) << 11 | (EA = DA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + MA | 0) >>> 0 ? C + 1 | 0 : C) - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = _A - -1048576 | 0) >>> 21, g = (g >> 21) + _$JA | 0, uA = GA = sA + jA | 0, sA = sA >>> 0 > GA >>> 0 ? g + 1 | 0 : g, A = Ig(lA, _$FA, -997805, -1), g = w + C | 0, g = A >>> 0 > (_A = A + _A | 0) >>> 0 ? g + 1 | 0 : g, _$JA = _A - (A = -2097152 & i) | 0, MA = g - ((A >>> 0 > _A >>> 0) + _$fA | 0) | 0, g = Ig(lA, _$FA, 654183, 0), A = w + tA | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, GA = C - (g = -2097152 & EA) | 0, _$fA = A - ((g >>> 0 > C >>> 0) + PA | 0) | 0, A = Ig(KA, HA, 470296, 0), C = w + (_$yA - (((g = -2097152 & aA) >>> 0 > pA >>> 0) + RA | 0) | 0) | 0, C = A >>> 0 > (i = A + (pA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(_$dA, bA, 666643, 0), A = w + C | 0, _A = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = Ig(KA, HA, 666643, 0), A = w + (_$cA - ((4095 & _$xA) + ((i = -2097152 & rA) >>> 0 > _$eA >>> 0) | 0) | 0) | 0, DA = A = g >>> 0 > (aA = g + (_$eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, _$cA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (tA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (EA = i + _A | 0) >>> 0 ? A + 1 | 0 : A, rA = A = A - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (_A = EA - -1048576 | 0) >>> 21, A = (A >> 21) + _$fA | 0, i = i >>> 0 > (_$yA = i + GA | 0) >>> 0 ? A + 1 | 0 : A, A = Ig(lA, _$FA, 470296, 0), C = w + C | 0, C = A >>> 0 > (g = A + EA | 0) >>> 0 ? C + 1 | 0 : C, EA = g - (A = -2097152 & _A) | 0, _A = C - ((A >>> 0 > g >>> 0) + rA | 0) | 0, g = Ig(lA, _$FA, 666643, 0), A = w + (DA - (((C = -2097152 & tA) >>> 0 > aA >>> 0) + _$cA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (pA = g + (aA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + _A | 0, A = (A = (g = (A = (2097151 & A) << 11 | pA >>> 21) >>> 0 > (_$fA = A + EA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | _$fA >>> 21) >>> 0 > (_$cA = g + _$yA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + MA | 0, C = (A = (g = (A = (2097151 & A) << 11 | _$cA >>> 21) >>> 0 > (i = A + _$JA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (rA = g + uA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + _$LA | 0, g = (C = (A = (C = (2097151 & C) << 11 | rA >>> 21) >>> 0 > (_$yA = C + qA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + _$NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | _$yA >>> 21) >>> 0 > (aA = A + _$YA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + XA | 0, g = (g = (A = (g = (2097151 & g) << 11 | aA >>> 21) >>> 0 > (sA = g + _$UA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + SA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (DA = A + zA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, A = (g = (C = (g = (2097151 & g) << 11 | DA >>> 21) >>> 0 > (tA = g + II | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + AI | 0, _A = (_$wA = B - (g = -2097152 & _$wA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | tA >>> 21) >>> 0 > (EA = C + $A | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | EA >>> 21) | 0, A = (hA - ((g >>> 0 > B >>> 0) + _$mA | 0) | 0) + (A >> 21) | 0, _$wA = g = (A = _A >>> 0 < _$wA >>> 0 ? A + 1 | 0 : A) >> 21, pA = (A = Ig(_$NA = (2097151 & A) << 11 | _A >>> 21, g, 666643, 0)) + (g = 2097151 & pA) | 0, A = w, B = A = g >>> 0 > pA >>> 0 ? A + 1 | 0 : A, o[0 | Q] = pA, o[Q + 1 | 0] = (255 & A) << 24 | pA >>> 8, A = 2097151 & _$fA, g = Ig(_$NA, _$wA, 470296, 0) + A | 0, C = w, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (hA = (2097151 & B) << 11 | pA >>> 21) >>> 0 > (_$fA = hA + g | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 4 | 0] = (2047 & A) << 21 | _$fA >>> 11, g = A, C = _$fA, o[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, o[Q + 2 | 0] = 31 & ((65535 & B) << 16 | pA >>> 16) | C << 5, B = 2097151 & _$cA, _$cA = Ig(_$NA, _$wA, 654183, 0) + B | 0, A = w, _$fA = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > _$cA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (_$cA = _$fA + _$cA | 0) >>> 0 < _$fA >>> 0 ? g + 1 | 0 : g, o[Q + 6 | 0] = (63 & A) << 26 | _$cA >>> 6, B = _$cA, _$cA = 0, o[Q + 5 | 0] = _$cA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = Ig(_$NA, _$wA, -997805, -1) + C | 0, g = w, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, _$cA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = _$cA + i | 0) >>> 0 < _$cA >>> 0 ? C + 1 | 0 : C, o[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, o[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, o[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & rA, B = Ig(_$NA, _$wA, 136657, 0) + g | 0, A = w, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, rA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = rA + B | 0) >>> 0 < rA >>> 0 ? g + 1 | 0 : g, o[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, o[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, o[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & _$yA, i = Ig(_$NA, _$wA, -683901, -1) + B | 0, A = w, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (_$yA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, o[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, o[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & aA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, o[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, o[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, o[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & DA) + (DA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < DA >>> 0 ? g + 1 | 0 : g, DA = B, o[Q + 21 | 0] = B, sA = 0, o[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, o[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & tA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, o[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, o[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, o[Q + 23 | 0] = 31 & ((65535 & g) << 16 | DA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & EA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, o[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & _A) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, o[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, o[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, o[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, o[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, XC(c, 64), XC(_, 64), I && (E[I >> 2] = 64, E[I + 4 >> 2] = 0), h = t + 560 | 0, 0;
                                    }
                                    function k(A, I, g) {
                                        var C, _$B, Q, i, E, _, c, t, r, e, y, s, h, D, p, f, n, k, F, _$N, S, G, M, b, _$K, _$H, Y, _$d, J, _$U, l, _$m, u, x, R, v, L, P, q, _$z, j, _$X, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0, _$yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, _$wA = 0, _$fA = 0, nA = 0, kA = 0, _$FA = 0, _$NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, _$YA = 0, _$dA = 0, _$JA = 0, _$UA = 0, lA = 0, _$mA = 0, uA = 0, _$xA = 0, RA = 0, vA = 0, _$LA = 0, PA = 0, qA = 0;
                                        _$W = Ig(C = (V = a[g + 2 | 0]) << 16 & 2031616 | a[0 | g] | a[g + 1 | 0] << 8, 0, _$B = (QA = a[I + 23 | 0] | a[I + 24 | 0] << 8 | a[I + 25 | 0] << 16 | a[I + 26 | 0] << 24) >>> 5 & 2097151, 0), Z = w, O = Ig(Q = (V = a[I + 23 | 0]) << 16 & 2031616 | a[I + 21 | 0] | a[I + 22 | 0] << 8, 0, i = (T = a[g + 2 | 0] | a[g + 3 | 0] << 8 | a[g + 4 | 0] << 16 | a[g + 5 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, V = O >>> 0 > (_$W = O + _$W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(E = (a[g + 7 | 0] | a[g + 8 | 0] << 8 | a[g + 9 | 0] << 16 | a[g + 10 | 0] << 24) >>> 7 & 2097151, 0, _ = (oA = a[I + 15 | 0] | a[I + 16 | 0] << 8 | a[I + 17 | 0] << 16 | a[I + 18 | 0] << 24) >>> 6 & 2097151, 0), O = w + V | 0, IA = _$W = Z + _$W | 0, Z = Z >>> 0 > _$W >>> 0 ? O + 1 | 0 : O, O = (V = a[I + 14 | 0]) >>> 24 | 0, $ = V << 8 | (_$gA = a[I + 10 | 0] | a[I + 11 | 0] << 8 | a[I + 12 | 0] << 16 | a[I + 13 | 0] << 24) >>> 24, O = Ig(c = 2097151 & ((1 & (CA = (V = O) | (O = (_$W = a[I + 15 | 0]) >>> 16 | 0))) << 31 | (V = (_$W <<= 16) | $) >>> 1), 0, t = (_$AA = a[g + 10 | 0] | a[g + 11 | 0] << 8 | a[g + 12 | 0] << 16 | a[g + 13 | 0] << 24) >>> 4 & 2097151, 0), Z = w + Z | 0, CA = V = O + IA | 0, _$W = V >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, Z = (O = a[g + 6 | 0]) >>> 24 | 0, IA = O << 8 | T >>> 24, T = r = 2097151 & ((3 & (Z |= O = (V = a[g + 7 | 0]) >>> 16 | 0)) << 30 | (V = IA | V << 16) >>> 2), IA = 0, $ = (V = a[I + 19 | 0]) << 8 | oA >>> 24, Z = O = V >>> 24 | 0, V = (O = a[I + 20 | 0]) >>> 16 | 0, G = Z = (V |= Z) >>> 3 | 0, O = Ig(T, IA, e = (7 & V) << 29 | (O = O << 16 | $) >>> 3, Z), V = w + _$W | 0, V = O >>> 0 > ($ = O + CA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y = (T = a[g + 15 | 0] | a[g + 16 | 0] << 8 | a[g + 17 | 0] << 16 | a[g + 18 | 0] << 24) >>> 6 & 2097151, 0, s = (a[I + 7 | 0] | a[I + 8 | 0] << 8 | a[I + 9 | 0] << 16 | a[I + 10 | 0] << 24) >>> 7 & 2097151, 0), O = w + V | 0, IA = _$W = Z + $ | 0, _$W = Z >>> 0 > _$W >>> 0 ? O + 1 | 0 : O, $ = (V = a[g + 14 | 0]) << 8 | _$AA >>> 24, V = O = V >>> 24 | 0, Z = (O = a[g + 15 | 0]) >>> 16 | 0, O = Ig(h = 2097151 & ((1 & (Z |= V)) << 31 | (V = (O <<= 16) | $) >>> 1), 0, D = _$gA >>> 4 & 2097151, 0), V = w + _$W | 0, _$AA = Z = O + IA | 0, IA = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, V = (O = a[g + 19 | 0]) >>> 24 | 0, _$W = O << 8 | T >>> 24, Z = (O = a[g + 20 | 0]) >>> 16 | 0, p = (7 & (Z |= V)) << 29 | (O = _$W | O << 16) >>> 3, _$eA = V = Z >>> 3 | 0, _$W = V, V = (O = a[I + 6 | 0]) >>> 24 | 0, T = O << 8 | (CA = a[I + 2 | 0] | a[I + 3 | 0] << 8 | a[I + 4 | 0] << 16 | a[I + 5 | 0] << 24) >>> 24, Z = V, V = (O = a[I + 7 | 0]) >>> 16 | 0, V = Ig(p, _$W, f = 2097151 & ((3 & (V |= Z)) << 30 | (O = O << 16 | T) >>> 2), 0), O = w + IA | 0, Z = V >>> 0 > (_$W = V + _$AA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(n = (V = a[g + 23 | 0]) << 16 & 2031616 | a[g + 21 | 0] | a[g + 22 | 0] << 8, 0, k = CA >>> 5 & 2097151, 0), O = w + Z | 0, Z = V >>> 0 > (_$W = V + _$W | 0) >>> 0 ? O + 1 | 0 : O, O = Ig(F = (V = a[I + 2 | 0]) << 16 & 2031616 | a[0 | I] | a[I + 1 | 0] << 8, 0, DA = (CA = a[g + 23 | 0] | a[g + 24 | 0] << 8 | a[g + 25 | 0] << 16 | a[g + 26 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, T = _$W = O + _$W | 0, IA = O >>> 0 > _$W >>> 0 ? V + 1 | 0 : V, O = Ig(Q, 0, C, 0), V = w, _$W = (Z = O) + (O = Ig(e, G, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > _$W >>> 0 ? Z + 1 | 0 : Z, O = Ig(E, 0, c, 0), V = w + Z | 0, V = O >>> 0 > (_$W = O + _$W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(t, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(_, 0, r, 0), O = w + O | 0, O = V >>> 0 > (Z = V + _$W | 0) >>> 0 ? O + 1 | 0 : O, _$W = (V = Z) + (Z = Ig(y, 0, f, 0)) | 0, V = w + O | 0, V = Z >>> 0 > _$W >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, s, 0), Z = w + V | 0, Z = O >>> 0 > (_$W = O + _$W | 0) >>> 0 ? Z + 1 | 0 : Z, _$W = (O = Ig(p, _$eA, k, 0)) + _$W | 0, V = w + Z | 0, Z = Ig(n, 0, F, 0), O = w + (O >>> 0 > _$W >>> 0 ? V + 1 | 0 : V) | 0, _$W = O = Z >>> 0 > ($ = Z + _$W | 0) >>> 0 ? O + 1 | 0 : O, EA = O = O - (($ >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >>> 21 | 0) + IA | 0, aA = Z = (V = (O = (2097151 & O) << 11 | (_$cA = $ - -1048576 | 0) >>> 21) >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, iA = T - (O = -2097152 & (tA = T - -1048576 | 0)) | 0, BA = V - ((O >>> 0 > T >>> 0) + Z | 0) | 0, IA = (V = a[g + 27 | 0]) << 8 | CA >>> 24, Z = O = V >>> 24 | 0, T = Ig(_$N = 2097151 & ((3 & (Z |= V = (O = a[g + 28 | 0]) >>> 16 | 0)) << 30 | (V = (O <<= 16) | IA) >>> 2), 0, _$wA = (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) >>> 7 | 0, 0), IA = w, V = (O = a[I + 27 | 0]) >>> 24 | 0, I = Ig(S = 2097151 & ((3 & (V |= Z = (I = a[I + 28 | 0]) >>> 16 | 0)) << 30 | (O = O << 8 | QA >>> 24 | I << 16) >>> 2), 0, _$fA = (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) >>> 7 | 0, 0), O = w + IA | 0, O = I >>> 0 > (g = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = g, I = Ig(_$B, 0, _$fA, 0), g = w, IA = (V = I) + (I = Ig(DA, 0, _$wA, 0)) | 0, V = w + g | 0, V = I >>> 0 > IA >>> 0 ? V + 1 | 0 : V, I = Ig(_$N, 0, S, 0), V = w + V | 0, IA = V = I >>> 0 > (CA = I + IA | 0) >>> 0 ? V + 1 | 0 : V, _$AA = I = V - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, V = I >>> 21 | 0, T = (I = (2097151 & I) << 11 | (g = CA - -1048576 | 0) >>> 21) + Z | 0, Z = V + O | 0, oA = V = (Z = I >>> 0 > T >>> 0 ? Z + 1 | 0 : Z) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, I = T - (O = -2097152 & (_$gA = T - -1048576 | 0)) | 0, b = O = Z - ((131071 & V) + (O >>> 0 > T >>> 0) | 0) | 0, _$K = I, I = Ig(I, O, 666643, 0), O = w + BA | 0, kA = V = I + iA | 0, T = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, iA = CA - (I = -2097152 & g) | 0, sA = IA - ((131071 & _$AA) + (I >>> 0 > CA >>> 0) | 0) | 0, I = Ig(n, 0, _$wA, 0), g = w, V = (O = I) + (I = Ig(DA, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, _$fA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(_$B, 0, _$N, 0), O = w + V | 0, _$AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, g = Ig(_$B, 0, DA, 0), O = w, Z = (V = g) + (g = Ig(p, _$eA, _$wA, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = (g = Ig(n, 0, S, 0)) + Z | 0, Z = w + V | 0, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(e, G, _$fA, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, BA = (g = Ig(Q, 0, _$N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > BA >>> 0 ? V + 1 | 0 : V, _A = g = V - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (O = g >>> 21 | 0) | 0, g = V = (g = (2097151 & g) << 11 | (IA = BA - -1048576 | 0) >>> 21) >>> 0 > (_$AA = g + _$AA | 0) >>> 0 ? V + 1 | 0 : V, QA = V = V - ((_$AA >>> 0 < 4293918720) - 1 | 0) | 0, O = iA, iA = (2097151 & V) << 11 | (I = _$AA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + sA | 0, _$H = V = (Z = O + iA | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, Y = I = _$AA - (O = -2097152 & I) | 0, _$d = _$AA = g - ((O >>> 0 > _$AA >>> 0) + QA | 0) | 0, J = Z, g = Ig(Z, V, 470296, 0), O = w + T | 0, O = g >>> 0 > (V = g + kA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(I, _$AA, 654183, 0), Z = w + O | 0, sA = g = I + V | 0, T = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, QA = BA - (I = -2097152 & IA) | 0, BA = CA - ((I >>> 0 > BA >>> 0) + _A | 0) | 0, I = Ig(p, _$eA, S, 0), g = w, V = (O = I) + (I = Ig(y, 0, _$wA, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, DA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(_$B, 0, n, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(_, 0, _$fA, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, _$N, 0), V = w + O | 0, CA = g = I + g | 0, IA = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, _$wA, 0), g = w, V = (O = I) + (I = Ig(y, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(_$B, 0, p, _$eA)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(e, G, DA, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, n, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(c, 0, _$fA, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(_, 0, _$N, 0), O = w + V | 0, I = O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, _$yA = O = O - ((g >>> 0 < 4293918720) - 1 | 0) | 0, Z = (V = O >>> 21 | 0) + IA | 0, iA = Z = (O = (2097151 & O) << 11 | (_A = g - -1048576 | 0) >>> 21) >>> 0 > (hA = O + CA | 0) >>> 0 ? Z + 1 | 0 : Z, _$dA = O = Z - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, IA = (2097151 & O) << 11 | (_$AA = hA - -1048576 | 0) >>> 21, O = (O >>> 21 | 0) + BA | 0, _$U = O = (Z = IA + QA | 0) >>> 0 < IA >>> 0 ? O + 1 | 0 : O, l = Z, O = Ig(Z, O, -997805, -1), V = w + T | 0, BA = Z = O + sA | 0, T = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = $, $ = _$W, O = Ig(C, 0, e, G), V = w, _$W = (Z = O) + (O = Ig(_, 0, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > _$W >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, D, 0), O = w + Z | 0, O = V >>> 0 > (_$W = V + _$W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, s, 0), V = w + O | 0, V = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(c, 0, r, 0), O = w + V | 0, O = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(y, 0, k, 0), V = w + O | 0, V = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, f, 0), Z = w + V | 0, Z = O >>> 0 > (_$W = O + _$W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(p, _$eA, F, 0), O = w + Z | 0, CA = _$W = V + _$W | 0, _$W = V >>> 0 > _$W >>> 0 ? O + 1 | 0 : O, O = Ig(C, 0, _, 0), V = w, Z = O, O = Ig(c, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, QA = (O = Z) + (Z = Ig(E, 0, s, 0)) | 0, O = w + V | 0, O = Z >>> 0 > QA >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, f, 0), V = w + O | 0, V = Z >>> 0 > (QA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(r, 0, D, 0), Z = w + V | 0, Z = O >>> 0 > (QA = O + QA | 0) >>> 0 ? Z + 1 | 0 : Z, QA = (V = Ig(y, 0, F, 0)) + QA | 0, O = w + Z | 0, Z = Ig(h, 0, k, 0), V = w + (V >>> 0 > QA >>> 0 ? O + 1 | 0 : O) | 0, GA = V = Z >>> 0 > (SA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, _$xA = V = V - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (_$NA = SA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + _$W | 0, rA = V = Z >>> 0 > (MA = Z + CA | 0) >>> 0 ? V + 1 | 0 : V, RA = V = V - ((MA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (kA = MA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + $ | 0, V = Z >>> 0 > (IA = Z + IA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(J, _$H, 666643, 0), V = w + (V - (((Z = -2097152 & _$cA) >>> 0 > IA >>> 0) + EA | 0) | 0) | 0, V = O >>> 0 > (_$W = O + (IA - Z | 0) | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(Y, _$d, 470296, 0), O = w + V | 0, O = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(l, _$U, 654183, 0), V = w + O | 0, sA = V = Z >>> 0 > (pA = Z + _$W | 0) >>> 0 ? V + 1 | 0 : V, lA = V = V - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, O = (O = V >> 21) + T | 0, BA = O = (V = (2097151 & V) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (EA = V + BA | 0) >>> 0 ? O + 1 | 0 : O, bA = V = O - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, _$JA = (2097151 & V) << 11 | (_$cA = EA - -1048576 | 0) >>> 21, CA = V >> 21, O = Ig(C, 0, S, 0), V = w, Z = O, O = Ig(_$B, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, _$W = (O = Ig(E, 0, e, G)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > _$W >>> 0 ? Z + 1 | 0 : Z, V = Ig(_, 0, t, 0), O = w + Z | 0, O = V >>> 0 > (_$W = V + _$W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(Q, 0, r, 0), V = w + O | 0, V = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(c, 0, h, 0), V = w + O | 0, V = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(s, 0, p, _$eA), Z = w + V | 0, Z = O >>> 0 > (_$W = O + _$W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(k, 0, DA, 0), O = w + Z | 0, O = V >>> 0 > (_$W = V + _$W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(f, 0, n, 0), V = w + O | 0, V = Z >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? V + 1 | 0 : V, Z = (O = _$W) + (_$W = Ig(_$N, 0, F, 0)) | 0, O = w + V | 0, T = Z, IA = Z >>> 0 < _$W >>> 0 ? O + 1 | 0 : O, _$FA = Ig(_$wA, 0, _$fA, 0), $ = Z = (KA = w) - ((_$FA >>> 0 < 4293918720) - 1 | 0) | 0, V = _$FA - (O = -2097152 & (_$W = _$FA - -1048576 | 0)) | 0, O = (oA >>> 21 | 0) + (O = KA - ((524287 & Z) + (O >>> 0 > _$FA >>> 0) | 0) | 0) | 0, _$m = O = (Z = (_$gA = (2097151 & oA) << 11 | _$gA >>> 21) + V | 0) >>> 0 < _$gA >>> 0 ? O + 1 | 0 : O, u = Z, V = (2097151 & aA) << 11 | tA >>> 21, _$gA = Ig(Z, O, 666643, 0) + V | 0, O = w + (aA >>> 21 | 0) | 0, O = V >>> 0 > _$gA >>> 0 ? O + 1 | 0 : O, Z = Ig(_$K, b, 470296, 0), V = w + O | 0, V = (Z >>> 0 > (_$gA = Z + _$gA | 0) >>> 0 ? V + 1 | 0 : V) + IA | 0, V = (O = T + _$gA | 0) >>> 0 < _$gA >>> 0 ? V + 1 | 0 : V, _$gA = (Z = Ig(J, _$H, 654183, 0)) + O | 0, O = w + V | 0, _$UA = T - -1048576 | 0, _$FA = IA = IA - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = Ig(Y, _$d, -997805, -1), Z = w + (Z >>> 0 > _$gA >>> 0 ? O + 1 | 0 : O) | 0, Z = V >>> 0 > (T = V + _$gA | 0) >>> 0 ? Z + 1 | 0 : Z, tA = (O = Ig(l, _$U, 136657, 0)) + (T - (V = -2097152 & _$UA) | 0) | 0, V = w + (Z - ((V >>> 0 > T >>> 0) + IA | 0) | 0) | 0, Z = (oA = O >>> 0 > tA >>> 0 ? V + 1 | 0 : V) + CA | 0, HA = O = tA + _$JA | 0, _$gA = Z = O >>> 0 < tA >>> 0 ? Z + 1 | 0 : Z, KA = hA - (O = -2097152 & _$AA) | 0, hA = iA - ((O >>> 0 > hA >>> 0) + _$dA | 0) | 0, x = Z = $ >>> 21 | 0, V = (O = g) + (g = Ig(M = (2097151 & $) << 11 | _$W >>> 21, Z, -683901, -1)) | 0, O = w + I | 0, iA = V - (I = -2097152 & _A) | 0, aA = (g >>> 0 > V >>> 0 ? O + 1 | 0 : O) - ((I >>> 0 > V >>> 0) + _$yA | 0) | 0, I = Ig(_$B, 0, y, 0), g = w, O = I, I = Ig(t, 0, _$wA, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, S, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, p, _$eA), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(_, 0, DA, 0), O = w + O | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, n, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(D, 0, _$fA, 0), V = w + V | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(c, 0, _$N, 0), Z = w + V | 0, _$W = g = I + g | 0, I = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, g = Ig(t, 0, S, 0), O = w, V = g, g = Ig(E, 0, _$wA, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, y, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (g = Ig(_$B, 0, h, 0)) + V | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(e, G, p, _$eA), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(c, 0, DA, 0), Z = w + V | 0, Z = g >>> 0 > (O = g + O | 0) >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(_, 0, n, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = Ig(s, 0, _$fA, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, _$AA = (g = Ig(D, 0, _$N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > _$AA >>> 0 ? V + 1 | 0 : V, _$YA = g = V - ((_$AA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (O = g >>> 21 | 0) | 0, IA = Z = (g = (2097151 & g) << 11 | (T = _$AA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + _$W | 0) >>> 0 ? Z + 1 | 0 : Z, _$yA = I = Z - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >>> 21 | 0) + aA | 0, _$W = V = (I = (2097151 & I) << 11 | ($ = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = I + iA | 0) >>> 0 ? V + 1 | 0 : V, aA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + hA | 0, R = Z = (g = (V = (2097151 & g) << 11 | (I = iA - -1048576 | 0) >>> 21) + KA | 0) >>> 0 < V >>> 0 ? Z + 1 | 0 : Z, _$dA = tA - -1048576 | 0, _$JA = V = oA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, _$mA = g, g = Ig(g, Z, -683901, -1), O = w + _$gA | 0, KA = O = (V = (O = g >>> 0 > (Z = g + HA | 0) >>> 0 ? O + 1 | 0 : O) - (((g = -2097152 & _$dA) >>> 0 > Z >>> 0) + V | 0) | 0) - (((_$gA = Z - g | 0) >>> 0 < 4293918720) - 1 | 0) | 0, P = _$gA - (g = -2097152 & (hA = _$gA - -1048576 | 0)) | 0, vA = V - ((g >>> 0 > _$gA >>> 0) + O | 0) | 0, g = Ig(_$mA, R, 136657, 0), V = w + (BA - (((O = -2097152 & _$cA) >>> 0 > EA >>> 0) + bA | 0) | 0) | 0, uA = Z = g + (EA - O | 0) | 0, g = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, nA = iA - (I &= -2097152) | 0, _$cA = _$W - ((I >>> 0 > iA >>> 0) + aA | 0) | 0, I = Ig(u, _$m, -683901, -1), O = w, V = I, I = Ig(M, x, 136657, 0), O = w + O | 0, V = IA + (I >>> 0 > (Z = V + I | 0) >>> 0 ? O + 1 | 0 : O) | 0, oA = (O = Z + _A | 0) - (I = -2097152 & $) | 0, _$gA = (V = O >>> 0 < _A >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 > O >>> 0) + _$yA | 0) | 0, I = Ig(M, x, -997805, -1), O = w + CA | 0, O = I >>> 0 > (V = I + _$AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(u, _$m, 136657, 0), O = w + O | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(_$K, b, -683901, -1)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = Z - (I = -2097152 & T) | 0, $ = V - ((I >>> 0 > Z >>> 0) + _$YA | 0) | 0, I = Ig(_$B, 0, t, 0), O = w, Z = (V = I) + (I = Ig(E, 0, S, 0)) | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, _$wA, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(y, 0, e, G), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(Q, 0, h, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, V = (I = Ig(_, 0, p, _$eA)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, O = (I = Ig(D, 0, DA, 0)) + V | 0, V = w + Z | 0, V = I >>> 0 > O >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(c, 0, n, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, I = Ig(f, 0, _$fA, 0), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(s, 0, _$N, 0), O = w + V | 0, _$W = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(_$B, 0, E, 0), V = w, T = (Z = O) + (O = Ig(i, 0, _$wA, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > T >>> 0 ? Z + 1 | 0 : Z, O = Ig(Q, 0, t, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, S, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(_, 0, y, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(e, G, h, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(c, 0, p, _$eA), Z = w + O | 0, Z = V >>> 0 > (T = V + T | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(s, 0, DA, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(D, 0, n, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(k, 0, _$fA, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(f, 0, _$N, 0), O = w + V | 0, EA = O = Z >>> 0 > (bA = Z + T | 0) >>> 0 ? O + 1 | 0 : O, q = O = O - ((bA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (V = O >>> 21 | 0) | 0, tA = V = (O = (2097151 & O) << 11 | (aA = bA - -1048576 | 0) >>> 21) >>> 0 > (HA = O + _$W | 0) >>> 0 ? V + 1 | 0 : V, _$z = I = V - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + $ | 0, iA = O = (I = (2097151 & I) << 11 | (_A = HA - -1048576 | 0) >>> 21) >>> 0 > (_$YA = I + IA | 0) >>> 0 ? O + 1 | 0 : O, j = I = O - ((_$YA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = I >> 21) + _$gA | 0, CA = V = (I = (2097151 & I) << 11 | (BA = _$YA - -1048576 | 0) >>> 21) >>> 0 > (_$yA = I + oA | 0) >>> 0 ? V + 1 | 0 : V, _$LA = I = V - ((_$yA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + _$cA | 0, v = O = (I = (Z = (2097151 & I) << 11 | (_$W = _$yA - -1048576 | 0) >>> 21) + nA | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, nA = I, I = Ig(I, O, -683901, -1), Z = w + g | 0, PA = O = I + uA | 0, T = I >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, qA = pA - (I = -2097152 & QA) | 0, lA = sA - ((I >>> 0 > pA >>> 0) + lA | 0) | 0, I = Ig(Y, _$d, 666643, 0), O = w + (rA - (((g = -2097152 & kA) >>> 0 > MA >>> 0) + RA | 0) | 0) | 0, O = I >>> 0 > (V = I + (MA - g | 0) | 0) >>> 0 ? O + 1 | 0 : O, g = (I = Ig(l, _$U, 470296, 0)) + V | 0, V = w + O | 0, kA = g, g = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, _$AA = SA - (I = -2097152 & _$NA) | 0, IA = GA - ((I >>> 0 > SA >>> 0) + _$xA | 0) | 0, I = Ig(C, 0, c, 0), O = w, V = I, I = Ig(i, 0, D, 0), Z = w + O | 0, Z = I >>> 0 > (V = V + I | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(E, 0, f, 0), O = w + Z | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(t, 0, k, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, s, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(h, 0, F, 0), V = w + O | 0, $ = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = Ig(C, 0, D, 0), V = w, _$gA = (Z = O) + (O = Ig(i, 0, s, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > _$gA >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, k, 0), O = w + Z | 0, O = V >>> 0 > (_$gA = V + _$gA | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, F, 0), V = w + O | 0, V = Z >>> 0 > (_$gA = Z + _$gA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, f, 0), O = w + V | 0, sA = O = Z >>> 0 > (pA = Z + _$gA | 0) >>> 0 ? O + 1 | 0 : O, _$X = O = O - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (V = O >>> 21 | 0) | 0, _$cA = Z = (O = (2097151 & O) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (GA = O + $ | 0) >>> 0 ? Z + 1 | 0 : Z, _$xA = I = Z - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (oA = GA - -1048576 | 0) >>> 21) >>> 0 > (Z = I + _$AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(l, _$U, 666643, 0), V = w + O | 0, _$gA = V = I >>> 0 > (_$NA = I + Z | 0) >>> 0 ? V + 1 | 0 : V, RA = I = V - ((_$NA >>> 0 < 4293918720) - 1 | 0) | 0, O = g + (O = I >> 21) | 0, IA = O = (I = (2097151 & I) << 11 | (_$AA = _$NA - -1048576 | 0) >>> 21) >>> 0 > (rA = I + kA | 0) >>> 0 ? O + 1 | 0 : O, uA = I = O - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >> 21) + lA | 0, V = (I = (2097151 & I) << 11 | ($ = rA - -1048576 | 0) >>> 21) >>> 0 > (g = I + qA | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(_$mA, R, -997805, -1), Z = w + V | 0, Z = I >>> 0 > (O = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, MA = I = _$yA - (g = -2097152 & _$W) | 0, L = V = CA - ((g >>> 0 > _$yA >>> 0) + _$LA | 0) | 0, _$W = (g = Ig(nA, v, 136657, 0)) + O | 0, O = w + Z | 0, I = Ig(I, V, -683901, -1), O = w + (g >>> 0 > _$W >>> 0 ? O + 1 | 0 : O) | 0, _$W = O = I >>> 0 > (CA = I + _$W | 0) >>> 0 ? O + 1 | 0 : O, SA = I = O - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + T | 0, g = O = (T = kA = (I = (2097151 & I) << 11 | (Z = CA - -1048576 | 0) >>> 21) + PA | 0) >>> 0 < I >>> 0 ? O + 1 | 0 : O, _$yA = O = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, kA = (2097151 & O) << 11 | (I = T - -1048576 | 0) >>> 21, O = (O >> 21) + vA | 0, vA = lA = kA + P | 0, kA = kA >>> 0 > lA >>> 0 ? O + 1 | 0 : O, _$LA = T - (I &= -2097152) | 0, PA = g - ((I >>> 0 > T >>> 0) + _$yA | 0) | 0, qA = CA - (I = -2097152 & Z) | 0, lA = _$W - ((I >>> 0 > CA >>> 0) + SA | 0) | 0, I = Ig(_$mA, R, 654183, 0), V = w + (IA - (((g = -2097152 & $) >>> 0 > rA >>> 0) + uA | 0) | 0) | 0, V = I >>> 0 > (O = I + (rA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = (I = Ig(nA, v, -997805, -1)) + O | 0, O = w + V | 0, O = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, I = Ig(MA, L, 136657, 0), O = w + O | 0, uA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, SA = _$YA - (g = -2097152 & BA) | 0, rA = iA - ((g >>> 0 > _$YA >>> 0) + j | 0) | 0, g = Ig(u, _$m, -997805, -1), O = w, Z = (V = g) + (g = Ig(M, x, 654183, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(_$K, b, 136657, 0), O = w + V | 0, O = g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(J, _$H, -683901, -1), O = w + O | 0, V = tA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, BA = (O = Z + HA | 0) - (g = -2097152 & _A) | 0, tA = (V = O >>> 0 < HA >>> 0 ? V + 1 | 0 : V) - ((g >>> 0 > O >>> 0) + _$z | 0) | 0, g = Ig(u, _$m, 654183, 0), O = w, Z = (V = g) + (g = Ig(M, x, 470296, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(_$K, b, -997805, -1), O = w + V | 0, V = EA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, V = (g = Z + bA | 0) >>> 0 < bA >>> 0 ? V + 1 | 0 : V, Z = (O = g) + (g = Ig(J, _$H, 136657, 0)) | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (g = Ig(Y, _$d, -683901, -1)) + Z | 0, Z = w + O | 0, Z = g >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, $ = V - (g = -2097152 & aA) | 0, _$W = Z - ((g >>> 0 > V >>> 0) + q | 0) | 0, g = Ig(C, 0, _$wA, 0), O = w, V = g, g = Ig(i, 0, S, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, E, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(e, G, t, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(_$B, 0, r, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(y, 0, c, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(_, 0, h, 0)) + O | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, g = Ig(D, 0, p, _$eA), O = w + O | 0, O = g >>> 0 > (V = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(f, 0, DA, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(s, 0, n, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(F, 0, _$fA, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(_$N, 0, k, 0)) + O | 0, O = w + V | 0, O = (_$FA >>> 21 | 0) + (O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O) | 0, CA = O = (g = (2097151 & _$FA) << 11 | _$UA >>> 21) >>> 0 > (_A = g + Z | 0) >>> 0 ? O + 1 | 0 : O, bA = g = O - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >>> 21 | 0) + _$W | 0, IA = V = (g = (2097151 & g) << 11 | (T = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = g + $ | 0) >>> 0 ? V + 1 | 0 : V, _$yA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >> 21) + tA | 0, _$W = O = (g = (2097151 & g) << 11 | ($ = iA - -1048576 | 0) >>> 21) >>> 0 > (BA = g + BA | 0) >>> 0 ? O + 1 | 0 : O, aA = O = O - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >> 21) + rA | 0, rA = V = (O = (Z = (2097151 & O) << 11 | (g = BA - -1048576 | 0) >>> 21) + SA | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, _$UA = O, V = Ig(O, V, -683901, -1), O = w + I | 0, tA = Z = V + uA | 0, I = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(_$mA, R, 470296, 0), Z = w + (_$gA - (((V = -2097152 & _$AA) >>> 0 > _$NA >>> 0) + RA | 0) | 0) | 0, Z = O >>> 0 > (_$AA = O + (_$NA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, v, 654183, 0), V = w + Z | 0, V = O >>> 0 > (_$AA = O + _$AA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(MA, L, -997805, -1), O = w + V | 0, O = Z >>> 0 > (_$AA = Z + _$AA | 0) >>> 0 ? O + 1 | 0 : O, _$FA = g = BA - (V = -2097152 & g) | 0, _$eA = _$W = _$W - ((V >>> 0 > BA >>> 0) + aA | 0) | 0, _$AA = (Z = Ig(_$UA, rA, 136657, 0)) + _$AA | 0, V = w + O | 0, g = Ig(g, _$W, -683901, -1), Z = w + (Z >>> 0 > _$AA >>> 0 ? V + 1 | 0 : V) | 0, _$W = Z = g >>> 0 > (_$gA = g + _$AA | 0) >>> 0 ? Z + 1 | 0 : Z, EA = V = Z - ((_$gA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (g = _$gA - -1048576 | 0) >>> 21, V = (V >> 21) + I | 0, aA = Z = (V = Z >>> 0 > (_$AA = Z + tA | 0) >>> 0 ? V + 1 | 0 : V) - ((_$AA >>> 0 < 4293918720) - 1 | 0) | 0, BA = (2097151 & Z) << 11 | (I = _$AA - -1048576 | 0) >>> 21, Z = (Z >> 21) + lA | 0, tA = BA >>> 0 > (DA = tA = BA + qA | 0) >>> 0 ? Z + 1 | 0 : Z, _$wA = _$AA - (I &= -2097152) | 0, _$fA = V - ((I >>> 0 > _$AA >>> 0) + aA | 0) | 0, HA = _$gA - (I = -2097152 & g) | 0, _$YA = _$W - ((I >>> 0 > _$gA >>> 0) + EA | 0) | 0, I = Ig(_$mA, R, 666643, 0), V = w + (_$cA - (((g = -2097152 & oA) >>> 0 > GA >>> 0) + _$xA | 0) | 0) | 0, V = I >>> 0 > (O = I + (GA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(nA, v, 470296, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(MA, L, 654183, 0), V = w + Z | 0, _$AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, $ = iA - (g = -2097152 & $) | 0, _$W = IA - ((g >>> 0 > iA >>> 0) + _$yA | 0) | 0, g = Ig(u, _$m, 470296, 0), O = w, V = g, g = Ig(M, x, 666643, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(_$K, b, 654183, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(J, _$H, -997805, -1)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(Y, _$d, 136657, 0), V = w + V | 0, O = CA + (g >>> 0 > (Z = g + O | 0) >>> 0 ? V + 1 | 0 : V) | 0, O = (g = Z + _A | 0) >>> 0 < _A >>> 0 ? O + 1 | 0 : O, V = g, g = Ig(l, _$U, -683901, -1), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, EA = (g = (2097151 & _$JA) << 11 | _$dA >>> 21) + (Z - (V = -2097152 & T) | 0) | 0, V = (O - ((V >>> 0 > Z >>> 0) + bA | 0) | 0) + (_$JA >> 21) | 0, iA = V = g >>> 0 > EA >>> 0 ? V + 1 | 0 : V, _$yA = g = V - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = g >> 21) + _$W | 0, _$dA = V = (g = (Z = (2097151 & g) << 11 | (BA = EA - -1048576 | 0) >>> 21) + $ | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, _$JA = g, g = Ig(g, V, -683901, -1), Z = w + I | 0, Z = g >>> 0 > (O = g + _$AA | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(_$UA, rA, -997805, -1), V = w + Z | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(_$FA, _$eA, 136657, 0), O = w + V | 0, _A = g = I + g | 0, $ = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, T = pA - (I = -2097152 & QA) | 0, IA = sA - ((I >>> 0 > pA >>> 0) + _$X | 0) | 0, I = Ig(C, 0, s, 0), g = w, O = I, I = Ig(i, 0, f, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(E, 0, F, 0), V = w + V | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, k, 0), O = w + V | 0, I = I >>> 0 > (V = g = I + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, f, 0), O = w, _$W = (Z = g) + (g = Ig(i, 0, k, 0)) | 0, Z = w + O | 0, Z = g >>> 0 > _$W >>> 0 ? Z + 1 | 0 : Z, g = Ig(r, 0, F, 0), O = w + Z | 0, g = O = g >>> 0 > (_$W = g + _$W | 0) >>> 0 ? O + 1 | 0 : O, _$mA = O = O - ((_$W >>> 0 < 4293918720) - 1 | 0) | 0, Z = O >>> 21 | 0, aA = (O = (2097151 & O) << 11 | (_$cA = _$W - -1048576 | 0) >>> 21) + V | 0, V = I + Z | 0, oA = V = O >>> 0 > aA >>> 0 ? V + 1 | 0 : V, pA = I = V - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, O = (Z = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (_$gA = aA - -1048576 | 0) >>> 21) >>> 0 > (V = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(nA, v, 666643, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(MA, L, 470296, 0), V = w + V | 0, V = I >>> 0 > (O = I + Z | 0) >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(_$JA, _$dA, 136657, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (I = Ig(_$UA, rA, 654183, 0)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, I = Ig(_$FA, _$eA, -997805, -1), O = w + Z | 0, CA = O = I >>> 0 > (_$AA = I + V | 0) >>> 0 ? O + 1 | 0 : O, GA = I = O - ((_$AA >>> 0 < 4293918720) - 1 | 0) | 0, V = (Z = I >> 21) + $ | 0, _$NA = O = (V = (I = (O = (2097151 & I) << 11 | (T = _$AA - -1048576 | 0) >>> 21) + _A | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 < 4293918720) - 1 | 0) | 0, $ = (2097151 & O) << 11 | (IA = I - -1048576 | 0) >>> 21, O = (O >> 21) + _$YA | 0, SA = QA = $ + HA | 0, _A = $ >>> 0 > QA >>> 0 ? O + 1 | 0 : O, $ = I, Z = V, V = (iA - (((O = -2097152 & BA) >>> 0 > EA >>> 0) + _$yA | 0) | 0) + (KA >> 21) | 0, sA = V = (I = (EA - O | 0) + (BA = (2097151 & KA) << 11 | hA >>> 21) | 0) >>> 0 < BA >>> 0 ? V + 1 | 0 : V, bA = V = V - ((I >>> 0 < 4293918720) - 1 | 0) | 0, EA = O = V >> 21, V = Ig(nA = (2097151 & V) << 11 | (QA = I - -1048576 | 0) >>> 21, O, -683901, -1), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, HA = $ - (V = -2097152 & IA) | 0, _$YA = O - ((V >>> 0 > $ >>> 0) + _$NA | 0) | 0, O = Ig(nA, EA, 136657, 0), V = w + CA | 0, V = O >>> 0 > (Z = O + _$AA | 0) >>> 0 ? V + 1 | 0 : V, _$yA = Z - (O = -2097152 & T) | 0, KA = V - ((O >>> 0 > Z >>> 0) + GA | 0) | 0, Z = (O = Ig(MA, L, 666643, 0)) + (aA - (V = -2097152 & _$gA) | 0) | 0, V = w + (oA - ((V >>> 0 > aA >>> 0) + pA | 0) | 0) | 0, V = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, $ = (O = Ig(_$JA, _$dA, -997805, -1)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > $ >>> 0 ? Z + 1 | 0 : Z, V = Ig(_$UA, rA, 470296, 0), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(_$FA, _$eA, 654183, 0), V = w + O | 0, hA = $ = Z + $ | 0, CA = Z >>> 0 > $ >>> 0 ? V + 1 | 0 : V, $ = _$W, _$W = g, g = Ig(i, 0, F, 0), O = w, V = g, g = Ig(C, 0, k, 0), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, F, 0), pA = V = w, iA = g, oA = g - -1048576 | 0, GA = g = V - ((g >>> 0 < 4293918720) - 1 | 0) | 0, V = g >>> 21 | 0, BA = (g = (2097151 & g) << 11 | oA >>> 21) + Z | 0, Z = V + O | 0, _$gA = Z = g >>> 0 > BA >>> 0 ? Z + 1 | 0 : Z, _$NA = g = Z - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >>> 21 | 0) + _$W | 0, O = (g = (2097151 & g) << 11 | (_$AA = BA - -1048576 | 0) >>> 21) >>> 0 > (Z = g + $ | 0) >>> 0 ? O + 1 | 0 : O, _$W = (g = Ig(_$JA, _$dA, 654183, 0)) + (Z - (V = -2097152 & _$cA) | 0) | 0, Z = w + (O - ((8191 & _$mA) + (V >>> 0 > Z >>> 0) | 0) | 0) | 0, Z = g >>> 0 > _$W >>> 0 ? Z + 1 | 0 : Z, g = Ig(_$UA, rA, 666643, 0), V = w + Z | 0, V = g >>> 0 > (O = g + _$W | 0) >>> 0 ? V + 1 | 0 : V, T = (g = Ig(_$FA, _$eA, 470296, 0)) + O | 0, O = w + V | 0, IA = O = g >>> 0 > T >>> 0 ? O + 1 | 0 : O, aA = g = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >> 21) + CA | 0, Z = V = (g = (2097151 & g) << 11 | ($ = T - -1048576 | 0) >>> 21) >>> 0 > (_$W = g + hA | 0) >>> 0 ? V + 1 | 0 : V, _$cA = O = V - ((_$W >>> 0 < 4293918720) - 1 | 0) | 0, CA = (2097151 & O) << 11 | (g = _$W - -1048576 | 0) >>> 21, O = (O >> 21) + KA | 0, CA = CA >>> 0 > (rA = hA = CA + _$yA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(nA, EA, -997805, -1), O = w + Z | 0, _$UA = (_$W = V + _$W | 0) - (g &= -2097152) | 0, KA = (V >>> 0 > _$W >>> 0 ? O + 1 | 0 : O) - ((g >>> 0 > _$W >>> 0) + _$cA | 0) | 0, g = Ig(nA, EA, 654183, 0), Z = w + IA | 0, Z = g >>> 0 > (O = g + T | 0) >>> 0 ? Z + 1 | 0 : Z, hA = O - (g = -2097152 & $) | 0, aA = Z - ((g >>> 0 > O >>> 0) + aA | 0) | 0, g = Ig(_$JA, _$dA, 470296, 0), V = w + (_$gA - ((8191 & _$NA) + ((O = -2097152 & _$AA) >>> 0 > BA >>> 0) | 0) | 0) | 0, V = g >>> 0 > (Z = g + (BA - O | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(_$FA, _$eA, 666643, 0), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, _$W = O, g = Ig(_$JA, _$dA, 666643, 0), Z = w + (pA - ((2047 & GA) + ((O = -2097152 & oA) >>> 0 > iA >>> 0) | 0) | 0) | 0, T = Z = g >>> 0 > (_$AA = g + (iA - O | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, _$cA = g = Z - ((_$AA >>> 0 < 4293918720) - 1 | 0) | 0, V = V + (O = g >> 21) | 0, oA = g = (V = (g = (2097151 & g) << 11 | (IA = _$AA - -1048576 | 0) >>> 21) >>> 0 > ($ = g + _$W | 0) >>> 0 ? V + 1 | 0 : V) - (($ >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + aA | 0, g = (g = (2097151 & g) << 11 | (_$W = $ - -1048576 | 0) >>> 21) >>> 0 > (_$gA = g + hA | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, EA, 470296, 0), V = w + V | 0, V = O >>> 0 > (Z = O + $ | 0) >>> 0 ? V + 1 | 0 : V, _$W = Z - (O = -2097152 & _$W) | 0, $ = V - ((O >>> 0 > Z >>> 0) + oA | 0) | 0, O = Ig(nA, EA, 666643, 0), Z = w + (T - (((V = -2097152 & IA) >>> 0 > _$AA >>> 0) + _$cA | 0) | 0) | 0, O = (V = (Z = O >>> 0 > (iA = O + (_$AA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + $ | 0, V = g + (Z = (O = (Z = (2097151 & Z) << 11 | iA >>> 21) >>> 0 > (_$W = Z + _$W | 0) >>> 0 ? O + 1 | 0 : O) >> 21) | 0, O = (O = (V = (g = $ = (O = (2097151 & O) << 11 | _$W >>> 21) + _$gA | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) >> 21) + KA | 0, V = (V = (O = (V = (2097151 & V) << 11 | g >>> 21) >>> 0 > (BA = V + _$UA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + CA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | BA >>> 21) >>> 0 > (_$cA = O + rA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + _$YA | 0, O = (V = (Z = (V = (2097151 & V) << 11 | _$cA >>> 21) >>> 0 > (oA = V + HA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + _A | 0, V = (Z = (O = (Z = (2097151 & Z) << 11 | oA >>> 21) >>> 0 > (_$gA = Z + SA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + _$fA | 0, O = (O = (V = (O = (2097151 & O) << 11 | _$gA >>> 21) >>> 0 > (_$AA = O + _$wA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + tA | 0, V = (V = (O = (V = (2097151 & V) << 11 | _$AA >>> 21) >>> 0 > (CA = V + DA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + PA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | CA >>> 21) >>> 0 > (T = O + _$LA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + kA | 0, V = (sA - ((I >>> 0 < (O = -2097152 & QA) >>> 0) + bA | 0) | 0) + ((Z = (V = (2097151 & V) << 11 | T >>> 21) >>> 0 > (IA = V + vA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) | 0, QA = O = (V = ($ = (QA = I - O | 0) + ((2097151 & Z) << 11 | IA >>> 21) | 0) >>> 0 < QA >>> 0 ? V + 1 | 0 : V) >> 21, I = (I = Ig(sA = (2097151 & V) << 11 | $ >>> 21, O, 666643, 0)) + (O = 2097151 & iA) | 0, Z = w, o[0 | A] = I, Z = I >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, o[A + 1 | 0] = (255 & Z) << 24 | I >>> 8, O = 2097151 & _$W, _$W = Ig(sA, QA, 470296, 0) + O | 0, V = w, V = (Z >> 21) + (V = O >>> 0 > _$W >>> 0 ? V + 1 | 0 : V) | 0, V = (_$W = (iA = (2097151 & Z) << 11 | I >>> 21) + _$W | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, o[A + 4 | 0] = (2047 & V) << 21 | _$W >>> 11;
                                        o[A + 3 | 0] = (7 & V) << 29 | _$W >>> 3, o[A + 2 | 0] = 31 & ((65535 & Z) << 16 | I >>> 16) | _$W << 5, I = 2097151 & g, g = Ig(sA, QA, 654183, 0) + I | 0, Z = w, Z = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, I = V, O = (V >>= 21) + Z | 0, I = O = (I = (2097151 & I) << 11 | _$W >>> 21) >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, o[A + 6 | 0] = (63 & O) << 26 | g >>> 6, V = 0, o[A + 5 | 0] = V << 13 | (1572864 & _$W) >>> 19 | g << 2, V = 2097151 & BA, Z = Ig(sA, QA, -997805, -1) + V | 0, O = w, O = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (V = I >> 21) + O | 0, V = (I = (_$W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, o[A + 9 | 0] = (511 & V) << 23 | I >>> 9, o[A + 8 | 0] = (1 & V) << 31 | I >>> 1, O = 0, o[A + 7 | 0] = O << 18 | (2080768 & g) >>> 14 | I << 7, g = 2097151 & _$cA, O = Ig(sA, QA, 136657, 0) + g | 0, Z = w, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, g = (_$W = (2097151 & (g = V)) << 11 | I >>> 21) + O | 0, O = (V >>= 21) + Z | 0, O = g >>> 0 < _$W >>> 0 ? O + 1 | 0 : O, o[A + 12 | 0] = (4095 & O) << 20 | g >>> 12, o[A + 11 | 0] = (15 & O) << 28 | g >>> 4, V = 0, o[A + 10 | 0] = V << 15 | (1966080 & I) >>> 17 | g << 4, I = 2097151 & oA, Z = Ig(sA, QA, -683901, -1) + I | 0, V = w, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = O, O = V + (O >>= 21) | 0, O = (I = (_$W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, o[A + 14 | 0] = (127 & O) << 25 | I >>> 7, V = 0, o[A + 13 | 0] = V << 12 | (1048576 & g) >>> 20 | I << 1, V = O >> 21, V = (g = (O = (2097151 & O) << 11 | I >>> 21) + (2097151 & _$gA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 17 | 0] = (1023 & V) << 22 | g >>> 10, o[A + 16 | 0] = (3 & V) << 30 | g >>> 2, O = 0, o[A + 15 | 0] = O << 17 | (2064384 & I) >>> 15 | g << 6, I = V, V >>= 21, Z = (I = (O = (2097151 & I) << 11 | g >>> 21) + (2097151 & _$AA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 20 | 0] = (8191 & Z) << 19 | I >>> 13, o[A + 19 | 0] = (31 & Z) << 27 | I >>> 5, O = Z >> 21, O = (V = (_$W = (2097151 & Z) << 11 | I >>> 21) + (2097151 & CA) | 0) >>> 0 < _$W >>> 0 ? O + 1 | 0 : O, _$W = V, o[A + 21 | 0] = V, V = 0, o[A + 18 | 0] = V << 14 | (1835008 & g) >>> 18 | I << 3, o[A + 22 | 0] = (255 & O) << 24 | _$W >>> 8, V = O >> 21, V = (I = (g = (2097151 & O) << 11 | _$W >>> 21) + (2097151 & T) | 0) >>> 0 < g >>> 0 ? V + 1 | 0 : V, o[A + 25 | 0] = (2047 & V) << 21 | I >>> 11, o[A + 24 | 0] = (7 & V) << 29 | I >>> 3, o[A + 23 | 0] = 31 & ((65535 & O) << 16 | _$W >>> 16) | I << 5, O = (2097151 & V) << 11 | I >>> 21, V >>= 21, V = (g = O + (2097151 & IA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 27 | 0] = (63 & V) << 26 | g >>> 6, O = 0, o[A + 26 | 0] = O << 13 | (1572864 & I) >>> 19 | g << 2, O = V >> 21, O = (I = (V = (2097151 & V) << 11 | g >>> 21) + (2097151 & $) | 0) >>> 0 < V >>> 0 ? O + 1 | 0 : O, o[A + 31 | 0] = (131071 & O) << 15 | I >>> 17, o[A + 30 | 0] = (511 & O) << 23 | I >>> 9, o[A + 29 | 0] = (1 & O) << 31 | I >>> 1, V = 0, o[A + 28 | 0] = V << 18 | (2080768 & g) >>> 14 | I << 7;
                                    }
                                    function F(A, I, g, C) {
                                        for(var _$B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0; i = (_$B = _ << 3) + g | 0, Q = a[0 | (_$B = I + _$B | 0)] | a[_$B + 1 | 0] << 8 | a[_$B + 2 | 0] << 16 | a[_$B + 3 | 0] << 24, G = a[_$B + 4 | 0] | a[_$B + 5 | 0] << 8 | a[_$B + 6 | 0] << 16 | a[_$B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, t = (o = 16711680 & Q) << 24, o = o >>> 8 | 0, _$B = (e = -16777216 & Q) >>> 24 | 0, E[i >> 2] = t | e << 8 | -16777216 & ((255 & G) << 24 | Q >>> 8) | 16711680 & ((16777215 & G) << 8 | Q >>> 24) | G >>> 8 & 65280 | G >>> 24, Q = _$B | o | c, _$B = 0, E[i + 4 >> 2] = Q | _$B | _$B, 16 != (0 | (_ = _ + 1 | 0)););
                                        for(I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I, I = E[A + 60 >> 2], E[C + 56 >> 2] = E[A + 56 >> 2], E[C + 60 >> 2] = I, I = E[A + 52 >> 2], E[C + 48 >> 2] = E[A + 48 >> 2], E[C + 52 >> 2] = I, I = E[A + 44 >> 2], E[C + 40 >> 2] = E[A + 40 >> 2], E[C + 44 >> 2] = I, I = E[A + 36 >> 2], E[C + 32 >> 2] = E[A + 32 >> 2], E[C + 36 >> 2] = I, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I; i = E[C + 56 >> 2], o = E[C + 60 >> 2], _$B = E[(I = G = (M = P << 3) + g | 0) >> 2], I = E[I + 4 >> 2], k = Q = E[C + 36 >> 2], Q = KI(p = E[C + 32 >> 2], Q, 50), _ = w, Q = KI(p, k, 46) ^ Q, _ ^= w, Q = KI(p, k, 23) ^ Q, I = (w ^ _) + I | 0, I = (_$B = Q + _$B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _$B = (_ = E[(Q = M + 34816 | 0) >> 2]) + _$B | 0, I = E[Q + 4 >> 2] + I | 0, I = _$B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = ((t = E[C + 48 >> 2]) ^ (y = E[C + 40 >> 2])) & p ^ t) + _$B | 0, _$B = (((f = E[C + 52 >> 2]) ^ (F = E[C + 44 >> 2])) & k ^ f) + I | 0, I = (Q >>> 0 < _ >>> 0 ? _$B + 1 | 0 : _$B) + o | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _ = (Q = E[C + 24 >> 2]) + i | 0, _$B = E[C + 28 >> 2] + I | 0, s = _$B = Q >>> 0 > _ >>> 0 ? _$B + 1 | 0 : _$B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = _$B, n = _$B = E[C + 4 >> 2], _$B = KI(Q = E[C >> 2], _$B, 36), o = w, _$B = KI(Q, n, 30) ^ _$B, o ^= w, e = i + (KI(Q, n, 25) ^ _$B) | 0, _$B = I + (w ^ o) | 0, _$B = i >>> 0 > e >>> 0 ? _$B + 1 | 0 : _$B, c = (I = e) + (e = Q & ((o = E[C + 16 >> 2]) | (i = E[C + 8 >> 2])) | i & o) | 0, I = (I = _$B) + (n & ((_$B = E[C + 20 >> 2]) | (h = E[C + 12 >> 2])) | _$B & h) | 0, e = I = c >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = c, E[C + 60 >> 2] = I, r = o, D = _$B, S = E[(I = _$m = (_$N = 8 | M) + g | 0) >> 2], _$K = E[I + 4 >> 2], _$B = ((k ^ F) & s ^ F) + f | 0, _$B = (I = (o = (y ^ p) & _ ^ y) + t | 0) >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, o = KI(_, s, 50), t = w, o = KI(_, s, 46) ^ o, t ^= w, o = (f = KI(_, s, 23) ^ o) + I | 0, I = (w ^ t) + _$B | 0, I = (o >>> 0 < f >>> 0 ? I + 1 | 0 : I) + _$K | 0, I = (_$B = o + S | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (o = _$B) + (t = E[(_$B = _$N + 34816 | 0) >> 2]) | 0, _$B = E[_$B + 4 >> 2] + I | 0, _$B = (I = o >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B) + D | 0, f = _$B = (t = o + r | 0) >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = _$B, I = I + ((h | n) & e | h & n) | 0, I = (_$B = o + ((Q | i) & c | Q & i) | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(c, e, 36), r = w, o = KI(c, e, 30) ^ o, r ^= w, D = _$B, _$B = KI(c, e, 25) ^ o, I = (w ^ r) + I | 0, r = I = _$B >>> 0 > (o = D + _$B | 0) >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = o, E[C + 52 >> 2] = I, D = i, _$N = h, I = (h = E[(_$B = _$d = (i = 16 | M) + g | 0) >> 2]) + y | 0, _$B = E[_$B + 4 >> 2] + F | 0, _$B = I >>> 0 < h >>> 0 ? _$B + 1 | 0 : _$B, i = (y = I) + (h = E[(I = i + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + _$B | 0, I = ((s ^ k) & f ^ k) + (I = i >>> 0 < h >>> 0 ? I + 1 | 0 : I) | 0, I = (_$B = (_$B = i) + (i = (_ ^ p) & t ^ p) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = KI(t, f, 50), h = w, i = KI(t, f, 46) ^ i, h ^= w, i = (y = KI(t, f, 23) ^ i) + _$B | 0, _$B = (w ^ h) + I | 0, _$B = (y = i >>> 0 < y >>> 0 ? _$B + 1 | 0 : _$B) + _$N | 0, _$N = _$B = (h = i) >>> 0 > (i = i + D | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[C + 8 >> 2] = i, E[C + 12 >> 2] = _$B, I = KI(o, r, 36), _$B = w, I = KI(o, r, 30) ^ I, _$B ^= w, F = KI(o, r, 25) ^ I, I = ((e | n) & r | e & n) + (w ^ _$B) | 0, _$B = y + ((D = F + ((Q | c) & o | Q & c) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) | 0, h = _$B = (y = h + D | 0) >>> 0 < h >>> 0 ? _$B + 1 | 0 : _$B, E[C + 40 >> 2] = y, E[C + 44 >> 2] = _$B, D = Q, _$B = (_$B = p) + (p = E[(I = u = (Q = 24 | M) + g | 0) >> 2]) | 0, I = E[I + 4 >> 2] + k | 0, I = _$B >>> 0 < p >>> 0 ? I + 1 | 0 : I, Q = (F = _$B) + (p = E[(_$B = Q + 34816 | 0) >> 2]) | 0, _$B = E[_$B + 4 >> 2] + I | 0, _$B = (s ^ (s ^ f) & _$N) + (_$B = Q >>> 0 < p >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (I = (I = Q) + (Q = _ ^ (_ ^ t) & i) | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = KI(i, _$N, 50), p = w, Q = KI(i, _$N, 46) ^ Q, p ^= w, Q = (k = KI(i, _$N, 23) ^ Q) + I | 0, I = (w ^ p) + _$B | 0, _$B = (I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) + n | 0, k = _$B = (n = Q + D | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, E[C >> 2] = n, E[C + 4 >> 2] = _$B, _$B = KI(y, h, 36), p = w, _$B = KI(y, h, 30) ^ _$B, D = w ^ p, F = KI(y, h, 25) ^ _$B, _$B = ((e | r) & h | e & r) + (w ^ D) | 0, I = I + ((p = F + ((o | c) & y | o & c) | 0) >>> 0 < F >>> 0 ? _$B + 1 | 0 : _$B) | 0, p = I = (D = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = D, E[C + 36 >> 2] = I, Q = E[(_$B = l = (I = 32 | M) + g | 0) >> 2], _$B = s + E[_$B + 4 >> 2] | 0, _$B = (Q = Q + _ | 0) >>> 0 < _ >>> 0 ? _$B + 1 | 0 : _$B, Q = (_ = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + _$B | 0, I = (f ^ (f ^ _$N) & k) + (I = Q >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, I = (_$B = (_$B = Q) + (Q = t ^ (i ^ t) & n) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(n, k, 50), _ = w, Q = KI(n, k, 46) ^ Q, _ ^= w, Q = (s = KI(n, k, 23) ^ Q) + _$B | 0, _$B = (w ^ _) + I | 0, F = _$B = Q >>> 0 < s >>> 0 ? _$B + 1 | 0 : _$B, I = _$B, _$B = KI(D, p, 36), _ = w, _$B = KI(D, p, 30) ^ _$B, s = w ^ _, S = KI(D, p, 25) ^ _$B, _$B = ((r | h) & p | r & h) + (w ^ s) | 0, I = ((_ = S + ((o | y) & D | o & y) | 0) >>> 0 < S >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, _ = I = (s = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[C + 24 >> 2] = s, E[C + 28 >> 2] = I, _$B = e + F | 0, F = _$B = (e = Q + c | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, E[C + 56 >> 2] = e, E[C + 60 >> 2] = _$B, Q = E[(I = J = (_$B = 40 | M) + g | 0) >> 2], I = f + E[I + 4 >> 2] | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, Q = (c = E[(_$B = _$B + 34816 | 0) >> 2]) + Q | 0, _$B = E[_$B + 4 >> 2] + I | 0, _$B = (_$N ^ (k ^ _$N) & F) + (_$B = Q >>> 0 < c >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (I = (I = Q) + (Q = i ^ (i ^ n) & e) | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = KI(e, F, 50), c = w, Q = KI(e, F, 46) ^ Q, c ^= w, Q = (t = KI(e, F, 23) ^ Q) + I | 0, I = (w ^ c) + _$B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, _$B = KI(s, _, 36), c = w, _$B = KI(s, _, 30) ^ _$B, t = w ^ c, f = KI(s, _, 25) ^ _$B, _$B = ((h | p) & _ | h & p) + (w ^ t) | 0, _$B = ((c = f + ((y | D) & s | y & D) | 0) >>> 0 < f >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, c = _$B = (t = Q + c | 0) >>> 0 < c >>> 0 ? _$B + 1 | 0 : _$B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = _$B, I = I + r | 0, S = I = (r = Q + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = r, E[C + 52 >> 2] = I, Q = E[(_$B = Y = (I = 48 | M) + g | 0) >> 2], _$B = _$N + E[_$B + 4 >> 2] | 0, _$B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? _$B + 1 | 0 : _$B, Q = (i = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + _$B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (_$B = (_$B = Q) + (Q = n ^ (e ^ n) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(r, S, 50), i = w, Q = KI(r, S, 46) ^ Q, i ^= w, Q = (o = KI(r, S, 23) ^ Q) + _$B | 0, _$B = (w ^ i) + I | 0, o = _$B = Q >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, I = _$B, _$B = KI(t, c, 36), i = w, _$B = KI(t, c, 30) ^ _$B, f = w ^ i, _$N = KI(t, c, 25) ^ _$B, _$B = ((_ | p) & c | _ & p) + (w ^ f) | 0, I = ((i = _$N + ((s | D) & t | s & D) | 0) >>> 0 < _$N >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, f = I = (_$B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, E[C + 8 >> 2] = i, E[C + 12 >> 2] = I, _$B = o + h | 0, _$N = _$B = (_$K = Q + y | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, E[C + 40 >> 2] = _$K, E[C + 44 >> 2] = _$B, Q = E[(I = _$U = (_$B = 56 | M) + g | 0) >> 2], I = k + E[I + 4 >> 2] | 0, I = (Q = Q + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, Q = (o = E[(_$B = _$B + 34816 | 0) >> 2]) + Q | 0, _$B = E[_$B + 4 >> 2] + I | 0, _$B = (F ^ (F ^ S) & _$N) + (_$B = Q >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (I = (I = Q) + (Q = e ^ (e ^ r) & _$K) | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = KI(_$K, _$N, 50), o = w, Q = KI(_$K, _$N, 46) ^ Q, o ^= w, Q = (h = KI(_$K, _$N, 23) ^ Q) + I | 0, I = (w ^ o) + _$B | 0, I = Q >>> 0 < h >>> 0 ? I + 1 | 0 : I, _$B = KI(i, f, 36), o = w, _$B = KI(i, f, 30) ^ _$B, h = w ^ o, y = KI(i, f, 25) ^ _$B, _$B = ((_ | c) & f | _ & c) + (w ^ h) | 0, _$B = ((o = y + ((t | s) & i | t & s) | 0) >>> 0 < y >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, h = _$B = (h = o) >>> 0 > (o = Q + o | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[C >> 2] = o, E[C + 4 >> 2] = _$B, I = I + p | 0, k = I = (y = Q + D | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = y, E[C + 36 >> 2] = I, Q = E[(_$B = x = (I = 64 | M) + g | 0) >> 2], _$B = F + E[_$B + 4 >> 2] | 0, _$B = (Q = Q + e | 0) >>> 0 < e >>> 0 ? _$B + 1 | 0 : _$B, Q = (e = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + _$B | 0, I = (S ^ (_$N ^ S) & k) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (_$B = (_$B = Q) + (Q = r ^ (r ^ _$K) & y) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(y, k, 50), e = w, Q = KI(y, k, 46) ^ Q, e ^= w, Q = (n = KI(y, k, 23) ^ Q) + _$B | 0, _$B = (w ^ e) + I | 0, p = _$B = Q >>> 0 < n >>> 0 ? _$B + 1 | 0 : _$B, I = _$B, _$B = KI(o, h, 36), e = w, _$B = KI(o, h, 30) ^ _$B, n = w ^ e, D = KI(o, h, 25) ^ _$B, _$B = ((c | f) & h | c & f) + (w ^ n) | 0, I = ((e = D + ((i | t) & o | i & t) | 0) >>> 0 < D >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = n, E[C + 60 >> 2] = I, _$B = _ + p | 0, F = _$B = (_ = Q + s | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = _$B, Q = E[(I = _$H = (_$B = 72 | M) + g | 0) >> 2], I = S + E[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = E[(_$B = _$B + 34816 | 0) >> 2]) + Q | 0, _$B = E[_$B + 4 >> 2] + I | 0, _$B = (_$N ^ (k ^ _$N) & F) + (_$B = Q >>> 0 < r >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (I = (I = Q) + (Q = _$K ^ (y ^ _$K) & _) | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = KI(_, F, 50), r = w, Q = KI(_, F, 46) ^ Q, r ^= w, Q = (p = KI(_, F, 23) ^ Q) + I | 0, I = (w ^ r) + _$B | 0, I = Q >>> 0 < p >>> 0 ? I + 1 | 0 : I, _$B = KI(n, e, 36), r = w, _$B = KI(n, e, 30) ^ _$B, p = w ^ r, D = KI(n, e, 25) ^ _$B, _$B = ((h | f) & e | h & f) + (w ^ p) | 0, _$B = ((r = D + ((i | o) & n | i & o) | 0) >>> 0 < D >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, r = _$B = (p = Q + r | 0) >>> 0 < r >>> 0 ? _$B + 1 | 0 : _$B, E[C + 48 >> 2] = p, E[C + 52 >> 2] = _$B, I = I + c | 0, S = I = (c = Q + t | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = c, E[C + 20 >> 2] = I, I = (I = _$K) + (t = E[(_$B = _$K = (Q = 80 | M) + g | 0) >> 2]) | 0, _$B = E[_$B + 4 >> 2] + _$N | 0, _$B = I >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B, Q = (s = I) + (t = E[(I = Q + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + _$B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I) | 0, I = (_$B = (_$B = Q) + (Q = y ^ (_ ^ y) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(c, S, 50), t = w, Q = KI(c, S, 46) ^ Q, t ^= w, Q = (D = KI(c, S, 23) ^ Q) + _$B | 0, _$B = (w ^ t) + I | 0, s = _$B = Q >>> 0 < D >>> 0 ? _$B + 1 | 0 : _$B, I = _$B, _$B = KI(p, r, 36), t = w, _$B = KI(p, r, 30) ^ _$B, D = w ^ t, _$N = KI(p, r, 25) ^ _$B, _$B = ((e | h) & r | e & h) + (w ^ D) | 0, I = ((t = _$N + ((o | n) & p | o & n) | 0) >>> 0 < _$N >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, t = I = (D = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C + 40 >> 2] = D, E[C + 44 >> 2] = I, _$B = s + f | 0, f = _$B = (s = Q + i | 0) >>> 0 < i >>> 0 ? _$B + 1 | 0 : _$B, E[C + 8 >> 2] = s, E[C + 12 >> 2] = _$B, _$B = 34816 + (I = 88 | M) | 0, i = E[(I = b = I + g | 0) >> 2], Q = E[_$B >> 2] + i | 0, I = E[_$B + 4 >> 2] + E[I + 4 >> 2] | 0, _$B = k + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, _$B = (F ^ (F ^ S) & f) + (_$B = (I = Q + y | 0) >>> 0 < y >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (I = (Q = _ ^ (_ ^ c) & s) + I | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = KI(s, f, 50), i = w, Q = KI(s, f, 46) ^ Q, i ^= w, Q = (y = KI(s, f, 23) ^ Q) + I | 0, I = (w ^ i) + _$B | 0, I = Q >>> 0 < y >>> 0 ? I + 1 | 0 : I, _$B = KI(D, t, 36), i = w, _$B = KI(D, t, 30) ^ _$B, y = w ^ i, _$N = KI(D, t, 25) ^ _$B, _$B = ((e | r) & t | e & r) + (w ^ y) | 0, _$B = ((i = _$N + ((p | n) & D | p & n) | 0) >>> 0 < _$N >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, y = _$B = (y = i) >>> 0 > (i = Q + i | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = _$B, I = I + h | 0, h = I = (_$B = o) >>> 0 > (o = Q + o | 0) >>> 0 ? I + 1 | 0 : I, E[C >> 2] = o, E[C + 4 >> 2] = I, _$B = 34816 + (I = 96 | M) | 0, _$N = E[(I = R = I + g | 0) >> 2], Q = E[_$B >> 2] + _$N | 0, _$B = E[_$B + 4 >> 2] + E[I + 4 >> 2] | 0, I = F + (Q >>> 0 < _$N >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (_$B = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = c ^ (c ^ s) & o) + _$B | 0, _$B = (S ^ (f ^ S) & h) + I | 0, _$B = Q >>> 0 < _ >>> 0 ? _$B + 1 | 0 : _$B, I = KI(o, h, 50), _ = w, I = KI(o, h, 46) ^ I, _ ^= w, F = Q, Q = KI(o, h, 23) ^ I, _$B = (w ^ _) + _$B | 0, k = _$B = (I = F + Q | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = I, I = KI(i, y, 36), _ = w, I = KI(i, y, 30) ^ I, _$N = w ^ _, F = KI(i, y, 25) ^ I, I = ((t | r) & y | t & r) + (w ^ _$N) | 0, _$B = ((_ = F + ((p | D) & i | p & D) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) + _$B | 0, _ = _$B = (_$N = Q + _ | 0) >>> 0 < _ >>> 0 ? _$B + 1 | 0 : _$B, E[C + 24 >> 2] = _$N, E[C + 28 >> 2] = _$B, _$B = e + k | 0, e = _$B = (n = Q + n | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, E[C + 56 >> 2] = n, E[C + 60 >> 2] = _$B, _$B = 34816 + (I = 104 | M) | 0, k = E[(I = L = I + g | 0) >> 2], Q = E[_$B >> 2] + k | 0, I = E[_$B + 4 >> 2] + E[I + 4 >> 2] | 0, _$B = S + (Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) | 0, _$B = (I = Q + c | 0) >>> 0 < c >>> 0 ? _$B + 1 | 0 : _$B, Q = (c = s ^ (o ^ s) & n) + I | 0, I = (f ^ (h ^ f) & e) + _$B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, _$B = KI(n, e, 50), c = w, _$B = KI(n, e, 46) ^ _$B, c ^= w, k = KI(n, e, 23) ^ _$B, _$B = (w ^ c) + I | 0, F = _$B = (Q = k + Q | 0) >>> 0 < k >>> 0 ? _$B + 1 | 0 : _$B, I = _$B, _$B = KI(_$N, _, 36), c = w, _$B = KI(_$N, _, 30) ^ _$B, k = w ^ c, S = KI(_$N, _, 25) ^ _$B, _$B = ((t | y) & _ | t & y) + (w ^ k) | 0, I = ((c = S + ((i | D) & _$N | i & D) | 0) >>> 0 < S >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, c = I = (k = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = k, E[C + 20 >> 2] = I, I = r + F | 0, r = I = (p = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = p, E[C + 52 >> 2] = I, _$B = 34816 + (I = 112 | M) | 0, F = E[(Q = S = I + g | 0) >> 2], I = E[_$B >> 2] + F | 0, _$B = E[_$B + 4 >> 2] + E[Q + 4 >> 2] | 0, _$B = f + (I >>> 0 < F >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (h ^ (e ^ h) & r) + (_$B = (I = I + s | 0) >>> 0 < s >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (I = (Q = o ^ (o ^ n) & p) + I | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = KI(p, r, 50), s = w, Q = KI(p, r, 46) ^ Q, s ^= w, Q = (f = KI(p, r, 23) ^ Q) + I | 0, I = (w ^ s) + _$B | 0, F = I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I, _$B = I, I = KI(k, c, 36), s = w, I = KI(k, c, 30) ^ I, f = w ^ s, v = KI(k, c, 25) ^ I, I = ((_ | y) & c | _ & y) + (w ^ f) | 0, _$B = ((s = v + ((i | _$N) & k | i & _$N) | 0) >>> 0 < v >>> 0 ? I + 1 | 0 : I) + _$B | 0, s = _$B = (f = Q + s | 0) >>> 0 < s >>> 0 ? _$B + 1 | 0 : _$B, E[C + 8 >> 2] = f, E[C + 12 >> 2] = _$B, _$B = t + F | 0, Q = _$B = (t = Q + D | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, E[C + 40 >> 2] = t, E[C + 44 >> 2] = _$B, _$B = 34816 + (I = 120 | M) | 0, M = E[(I = D = I + g | 0) >> 2], F = E[_$B >> 2] + M | 0, _$B = E[_$B + 4 >> 2] + E[I + 4 >> 2] | 0, I = h + (F >>> 0 < M >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (e ^ (e ^ r) & Q) + (I = (_$B = o + F | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I) | 0, I = (_$B = (o = n ^ (p ^ n) & t) + _$B | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(t, Q, 50), e = w, o = KI(t, Q, 46) ^ o, e ^= w, Q = (o = KI(t, Q, 23) ^ o) + _$B | 0, _$B = (w ^ e) + I | 0, _$B = Q >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, o = Q, e = _$B, I = _$B, _$B = KI(f, s, 36), t = w, _$B = KI(f, s, 30) ^ _$B, r = w ^ t, h = KI(f, s, 25) ^ _$B, _$B = ((_ | c) & s | _ & c) + (w ^ r) | 0, I = ((t = h + ((k | _$N) & f | k & _$N) | 0) >>> 0 < h >>> 0 ? _$B + 1 | 0 : _$B) + I | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C >> 2] = Q, E[C + 4 >> 2] = I, _$B = e + y | 0, _$B = (r = i) >>> 0 > (i = i + o | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = _$B, 64 != (0 | P);)c = ((P = P + 16 | 0) << 3) + g | 0, o = E[G >> 2], _ = E[G + 4 >> 2], v = E[_$H >> 2], e = I = E[_$H + 4 >> 2], _$B = I, Q = I = E[S + 4 >> 2], I = KI(_$N = E[S >> 2], I, 45), i = w, r = ((63 & Q) << 26 | _$N >>> 6) ^ (I = KI(_$N, Q, 3) ^ I), I = (Q >>> 6 ^ (t = w ^ i)) + _$B | 0, _$B = ((i = r + v | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + _ | 0, _$B = (I = i + o | 0) >>> 0 < i >>> 0 ? _$B + 1 | 0 : _$B, o = i = E[_$m + 4 >> 2], i = KI(_ = E[_$m >> 2], i, 63), t = w, i = ((127 & o) << 25 | _ >>> 7) ^ KI(_, o, 56) ^ i, _$B = (w ^ t ^ o >>> 7) + _$B | 0, i = _$B = i >>> 0 > (k = i + I | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[c >> 2] = k, E[c + 4 >> 2] = _$B, _ = (S = E[_$K >> 2]) + _ | 0, I = (c = E[_$K + 4 >> 2]) + o | 0, _$B = _ >>> 0 < S >>> 0 ? I + 1 | 0 : I, o = I = E[D + 4 >> 2], I = KI(F = E[D >> 2], I, 45), t = w, r = _, _ = ((63 & o) << 26 | F >>> 6) ^ KI(F, o, 3) ^ I, _$B = (w ^ t ^ o >>> 6) + _$B | 0, _ = _ >>> 0 > (r = r + _ | 0) >>> 0 ? _$B + 1 | 0 : _$B, _$B = KI(t = E[_$d >> 2], I = E[_$d + 4 >> 2], 63), h = w, s = r, r = ((127 & I) << 25 | t >>> 7) ^ KI(t, I, 56) ^ _$B, _$B = (w ^ h ^ I >>> 7) + _ | 0, _ = _$B = r >>> 0 > (f = s + r | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 136 >> 2] = f, E[G + 140 >> 2] = _$B, _$B = (_$K = E[b >> 2]) + t | 0, I = (t = E[b + 4 >> 2]) + I | 0, r = KI(k, i, 45), h = w, r = (y = ((63 & i) << 26 | k >>> 6) ^ KI(k, i, 3) ^ r) + _$B | 0, _$B = (w ^ h ^ i >>> 6) + (_$B >>> 0 < _$K >>> 0 ? I + 1 | 0 : I) | 0, _$B = r >>> 0 < y >>> 0 ? _$B + 1 | 0 : _$B, h = I = E[u + 4 >> 2], I = KI(y = E[u >> 2], I, 63), n = w, s = r, r = ((127 & h) << 25 | y >>> 7) ^ KI(y, h, 56) ^ I, _$B = (w ^ n ^ h >>> 7) + _$B | 0, r = _$B = r >>> 0 > (M = s + r | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 144 >> 2] = M, E[G + 148 >> 2] = _$B, y = (_$m = E[R >> 2]) + y | 0, I = (I = h) + (h = E[R + 4 >> 2]) | 0, _$B = y >>> 0 < _$m >>> 0 ? I + 1 | 0 : I, I = KI(f, _, 45), n = w, p = ((63 & _) << 26 | f >>> 6) ^ KI(f, _, 3) ^ I, _$B = (w ^ n ^ _ >>> 6) + _$B | 0, _$B = (y = p + y | 0) >>> 0 < p >>> 0 ? _$B + 1 | 0 : _$B, n = I = E[l + 4 >> 2], I = KI(p = E[l >> 2], I, 63), D = w, s = y, y = ((127 & n) << 25 | p >>> 7) ^ KI(p, n, 56) ^ I, _$B = (w ^ D ^ n >>> 7) + _$B | 0, y = _$B = y >>> 0 > (_$d = s + y | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 152 >> 2] = _$d, E[G + 156 >> 2] = _$B, I = (u = E[L >> 2]) + p | 0, _$B = (_$B = n) + (n = E[L + 4 >> 2]) | 0, p = KI(M, r, 45), D = w, p = ((63 & r) << 26 | M >>> 6) ^ KI(M, r, 3) ^ p, _$B = (w ^ D ^ r >>> 6) + (I >>> 0 < u >>> 0 ? _$B + 1 | 0 : _$B) | 0, p = (s = p + I | 0) >>> 0 < p >>> 0 ? _$B + 1 | 0 : _$B, _$B = KI(D = E[J >> 2], I = E[J + 4 >> 2], 63), l = w, b = s, s = ((127 & I) << 25 | D >>> 7) ^ (_$B = KI(D, I, 56) ^ _$B), _$B = (I >>> 7 ^ (J = w ^ l)) + p | 0, p = _$B = s >>> 0 > (l = b + s | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 160 >> 2] = l, E[G + 164 >> 2] = _$B, I = I + Q | 0, I = (_$B = D + _$N | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, D = KI(_$d, y, 45), s = w, D = (J = ((63 & y) << 26 | _$d >>> 6) ^ KI(_$d, y, 3) ^ D) + _$B | 0, _$B = (w ^ s ^ y >>> 6) + I | 0, _$B = D >>> 0 < J >>> 0 ? _$B + 1 | 0 : _$B, s = E[Y >> 2], Y = I = E[Y + 4 >> 2], I = KI(s, I, 63), J = w, I = KI(s, Y, 56) ^ I, b = D, _$B = (Y >>> 7 ^ (_$H = w ^ J)) + _$B | 0, D = _$B = (D = ((127 & Y) << 25 | s >>> 7) ^ I) >>> 0 > (J = b + D | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 168 >> 2] = J, E[G + 172 >> 2] = _$B, I = o + Y | 0, I = (_$B = s + F | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, b = s = E[_$U + 4 >> 2], s = KI(_$H = E[_$U >> 2], s, 63), Y = w, s = (_$U = ((127 & b) << 25 | _$H >>> 7) ^ KI(_$H, b, 56) ^ s) + _$B | 0, _$B = (w ^ Y ^ b >>> 7) + I | 0, I = s >>> 0 < _$U >>> 0 ? _$B + 1 | 0 : _$B, _$B = KI(l, p, 45), Y = w, _$B = KI(l, p, 3) ^ _$B, _$U = w ^ Y, Y = s, I = (p >>> 6 ^ _$U) + I | 0, s = I = (s = ((63 & p) << 26 | l >>> 6) ^ _$B) >>> 0 > (Y = Y + s | 0) >>> 0 ? I + 1 | 0 : I, E[G + 176 >> 2] = Y, E[G + 180 >> 2] = I, R = E[x >> 2], x = I = E[x + 4 >> 2], _$U = I, I = KI(v, e, 63), _$B = w, L = ((127 & e) << 25 | v >>> 7) ^ KI(v, e, 56) ^ I, I = (w ^ _$B ^ e >>> 7) + _ | 0, _$B = ((f = L + f | 0) >>> 0 < L >>> 0 ? I + 1 | 0 : I) + _$U | 0, _$B = (I = f + R | 0) >>> 0 < f >>> 0 ? _$B + 1 | 0 : _$B, _ = KI(Y, s, 45), f = w, _$U = (_ = ((63 & s) << 26 | Y >>> 6) ^ KI(Y, s, 3) ^ _) + I | 0, I = (w ^ f ^ s >>> 6) + _$B | 0, _ = I = _ >>> 0 > _$U >>> 0 ? I + 1 | 0 : I, E[G + 192 >> 2] = _$U, E[G + 196 >> 2] = I, _$B = i + b | 0, _$B = (I = k + _$H | 0) >>> 0 < _$H >>> 0 ? _$B + 1 | 0 : _$B, f = KI(R, x, 63), _$H = w, b = ((127 & x) << 25 | R >>> 7) ^ KI(R, x, 56) ^ f, _$B = (w ^ _$H ^ x >>> 7) + _$B | 0, I = (f = b + I | 0) >>> 0 < b >>> 0 ? _$B + 1 | 0 : _$B, _$B = KI(J, D, 45), _$H = w, _$B = KI(J, D, 3) ^ _$B, x = f, I = (D >>> 6 ^ (b = w ^ _$H)) + I | 0, f = I = (f = ((63 & D) << 26 | J >>> 6) ^ _$B) >>> 0 > (_$H = x + f | 0) >>> 0 ? I + 1 | 0 : I, E[G + 184 >> 2] = _$H, E[G + 188 >> 2] = I, I = KI(_$K, t, 63), _$B = w, I = ((127 & t) << 25 | _$K >>> 7) ^ KI(_$K, t, 56) ^ I, _$B = (w ^ _$B ^ t >>> 7) + c | 0, I = y + (I >>> 0 > (b = I + S | 0) >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (_$B = _$d + b | 0) >>> 0 < _$d >>> 0 ? I + 1 | 0 : I, y = KI(_$U, _, 45), _$d = w, y = KI(_$U, _, 3) ^ y, b = w ^ _$d, _$d = (y ^= (63 & _) << 26 | _$U >>> 6) + _$B | 0, _$B = (_ >>> 6 ^ b) + I | 0, y = _$B = y >>> 0 > _$d >>> 0 ? _$B + 1 | 0 : _$B, E[G + 208 >> 2] = _$d, E[G + 212 >> 2] = _$B, I = KI(S, c, 63), _$B = w, b = KI(S, c, 56) ^ I, _$B = ((I = c >>> 7 | 0) ^ w ^ _$B) + e | 0, I = r + ((c = (S = b ^ ((127 & c) << 25 | S >>> 7)) + v | 0) >>> 0 < S >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (_$B = c + M | 0) >>> 0 < M >>> 0 ? I + 1 | 0 : I, e = KI(_$H, f, 45), c = w, r = (e = ((63 & f) << 26 | _$H >>> 6) ^ KI(_$H, f, 3) ^ e) + _$B | 0, _$B = (w ^ c ^ f >>> 6) + I | 0, e = _$B = e >>> 0 > r >>> 0 ? _$B + 1 | 0 : _$B, E[G + 200 >> 2] = r, E[G + 204 >> 2] = _$B, I = KI(u, n, 63), _$B = w, S = ((127 & n) << 25 | u >>> 7) ^ KI(u, n, 56) ^ I, I = (w ^ _$B ^ n >>> 7) + h | 0, _$B = D + ((c = S + _$m | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, _$B = (I = c + J | 0) >>> 0 < J >>> 0 ? _$B + 1 | 0 : _$B, c = KI(_$d, y, 45), D = w, S = I, I = y >>> 6 | 0, c = ((63 & y) << 26 | _$d >>> 6) ^ KI(_$d, y, 3) ^ c, _$B = (I ^ w ^ D) + _$B | 0, c = _$B = c >>> 0 > (y = S + c | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 224 >> 2] = y, E[G + 228 >> 2] = _$B, I = KI(_$m, h, 63), _$B = w, I = KI(_$m, h, 56) ^ I, D = w ^ _$B, S = ((127 & h) << 25 | _$m >>> 7) ^ I, I = ((_$B = h >>> 7 | 0) ^ D) + t | 0, _$B = p + ((h = S + _$K | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, _$B = (I = h + l | 0) >>> 0 < l >>> 0 ? _$B + 1 | 0 : _$B, t = KI(r, e, 45), h = w, D = I, I = e >>> 6 | 0, e = ((63 & e) << 26 | r >>> 6) ^ KI(r, e, 3) ^ t, I = (I ^ w ^ h) + _$B | 0, e = I = (t = D + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[G + 216 >> 2] = t, E[G + 220 >> 2] = I, I = KI(F, o, 63), _$B = w, h = ((127 & o) << 25 | F >>> 7) ^ KI(F, o, 56) ^ I, _$B = (w ^ _$B ^ o >>> 7) + Q | 0, _$B = f + ((I = h + _$N | 0) >>> 0 < h >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (r = I + _$H | 0) >>> 0 < _$H >>> 0 ? _$B + 1 | 0 : _$B, _$B = KI(y, c, 45), h = w, D = r, r = KI(y, c, 3) ^ _$B, _$B = c >>> 6 | 0, c = D + (r ^= (63 & c) << 26 | y >>> 6) | 0, I = (_$B ^ w ^ h) + I | 0, E[G + 240 >> 2] = c, E[G + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = KI(_$N, Q, 63), _$B = w, I = KI(_$N, Q, 56) ^ I, c = w ^ _$B, _$B = ((_$B = Q >>> 7 | 0) ^ c) + n | 0, I = s + ((I ^= (127 & Q) << 25 | _$N >>> 7) >>> 0 > (Q = I + u | 0) >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (_$B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = KI(t, e, 45), c = w, r = _$B, _$B = e >>> 6 | 0, Q = ((63 & e) << 26 | t >>> 6) ^ KI(t, e, 3) ^ Q, _$B = (_$B ^ w ^ c) + I | 0, Q = _$B = Q >>> 0 > (e = r + Q | 0) >>> 0 ? _$B + 1 | 0 : _$B, E[G + 232 >> 2] = e, E[G + 236 >> 2] = _$B, I = KI(k, i, 63), _$B = w, r = KI(k, i, 56) ^ I, _$B = ((I = i >>> 7 | 0) ^ w ^ _$B) + o | 0, I = _ + ((i = (c = r ^ ((127 & i) << 25 | k >>> 7)) + F | 0) >>> 0 < c >>> 0 ? _$B + 1 | 0 : _$B) | 0, I = (_$B = i + _$U | 0) >>> 0 < _$U >>> 0 ? I + 1 | 0 : I, i = KI(e, Q, 45), o = w, r = _$B, _$B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | e >>> 6) ^ KI(e, Q, 3) ^ i) | 0, _$B = (_$B ^ w ^ o) + I | 0, E[G + 248 >> 2] = Q, E[G + 252 >> 2] = Q >>> 0 < i >>> 0 ? _$B + 1 | 0 : _$B;
                                        I = I + E[A + 4 >> 2] | 0, I = (g = Q + E[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[A >> 2] = g, E[A + 4 >> 2] = I, _$B = E[A + 12 >> 2] + E[C + 12 >> 2] | 0, I = (g = E[C + 8 >> 2]) + E[A + 8 >> 2] | 0, E[A + 8 >> 2] = I, E[A + 12 >> 2] = I >>> 0 < g >>> 0 ? _$B + 1 | 0 : _$B, _$B = E[A + 20 >> 2] + E[C + 20 >> 2] | 0, I = (g = E[C + 16 >> 2]) + E[A + 16 >> 2] | 0, E[A + 16 >> 2] = I, E[A + 20 >> 2] = I >>> 0 < g >>> 0 ? _$B + 1 | 0 : _$B, I = E[A + 28 >> 2] + E[C + 28 >> 2] | 0, g = (_$B = E[C + 24 >> 2]) + E[A + 24 >> 2] | 0, E[A + 24 >> 2] = g, E[A + 28 >> 2] = g >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = E[A + 36 >> 2] + E[C + 36 >> 2] | 0, I = (g = E[C + 32 >> 2]) + E[A + 32 >> 2] | 0, E[A + 32 >> 2] = I, E[A + 36 >> 2] = I >>> 0 < g >>> 0 ? _$B + 1 | 0 : _$B, I = E[A + 44 >> 2] + E[C + 44 >> 2] | 0, g = (_$B = E[C + 40 >> 2]) + E[A + 40 >> 2] | 0, E[A + 40 >> 2] = g, E[A + 44 >> 2] = g >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = E[A + 52 >> 2] + E[C + 52 >> 2] | 0, I = (g = E[C + 48 >> 2]) + E[A + 48 >> 2] | 0, E[A + 48 >> 2] = I, E[A + 52 >> 2] = I >>> 0 < g >>> 0 ? _$B + 1 | 0 : _$B, _$B = E[A + 60 >> 2] + E[C + 60 >> 2] | 0, I = (g = E[C + 56 >> 2]) + E[A + 56 >> 2] | 0, E[A + 56 >> 2] = I, E[A + 60 >> 2] = I >>> 0 < g >>> 0 ? _$B + 1 | 0 : _$B;
                                    }
                                    function N(A) {
                                        var _$I, g, C, _$B, Q, i, E, _, c, t, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0;
                                        s = (_$N = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, y = Ig(_$U = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), e = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = w, f = r = e >>> 0 > (n = y + e | 0) >>> 0 ? r + 1 | 0 : r, b = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, y = r >> 21, r = (e = s) + (s = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21) | 0, e = y, P = e = r >>> 0 < s >>> 0 ? e + 1 | 0 : e, q = r, Y = Ig(r, e, -683901, -1), k = w, p = Ig(_$I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), y = (r = a[A + 27 | 0]) >>> 24 | 0, s = r << 8 | (S = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, e = (r = a[A + 28 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = s | r << 16) >>> 2), r = w, r = e >>> 0 > (y = e + p | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(R = (G = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = w + r | 0, p = y = e + y | 0, y = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, h = (e = a[A + 48 | 0]) << 8 | _$N >>> 24, e = r = e >>> 24 | 0, r = Ig(g = 2097151 & ((3 & (_$N = (r = (s = a[A + 49 | 0]) >>> 16 | 0) | e)) << 30 | (e = (s <<= 16) | h) >>> 2), 0, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + p | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + e | 0, e = w + y | 0, p = s, y = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, e = (r = a[A + 56 | 0]) >>> 24 | 0, h = r << 8 | G >>> 24, e = Ig(_$B = 2097151 & ((1 & (G = (r = (s = a[A + 57 | 0]) >>> 16 | 0) | e)) << 31 | (e = (s <<= 16) | h) >>> 1), 0, 470296, 0), r = w + y | 0, e = (r = (y = s = e + p | 0) >>> 0 < e >>> 0 ? r + 1 | 0 : r) + k | 0, e = y >>> 0 > (s = y + Y | 0) >>> 0 ? e + 1 | 0 : e, _$K = y - -1048576 | 0, _$H = y = r - ((y >>> 0 < 4293918720) - 1 | 0) | 0, k = s - (r = -2097152 & _$K) | 0, Y = e - ((r >>> 0 > s >>> 0) + y | 0) | 0, e = Ig(_$I, 0, 654183, 0), r = w, r = e >>> 0 > (y = e + (S >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(R, 0, 470296, 0)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + s | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(_$B, _$X, 666643, 0)) | 0, r = w + e | 0, h = s, s = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, p = (y = Ig(_$I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, y = w, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, p = (e = Ig(R, 0, 666643, 0)) + p | 0, r = w + y | 0, y = Ig(g, j, 654183, 0), e = w + (e >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = e = y >>> 0 > (S = y + p | 0) >>> 0 ? e + 1 | 0 : e, x = e = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >>> 21 | 0) + s | 0, y = r = (e = (2097151 & e) << 11 | (p = S - -1048576 | 0) >>> 21) >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, F = e = r - ((h >>> 0 < 4293918720) - 1 | 0) | 0, r = k, k = (2097151 & e) << 11 | (s = h - -1048576 | 0) >>> 21, e = (e >> 21) + Y | 0, _$N = k = (e = k >>> 0 > (M = r + k | 0) >>> 0 ? e + 1 | 0 : e) - ((M >>> 0 < 4293918720) - 1 | 0) | 0, v = M - (r = -2097152 & (Y = M - -1048576 | 0)) | 0, O = e - ((r >>> 0 > M >>> 0) + k | 0) | 0, r = Ig(q, P, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, J = e - (r = -2097152 & s) | 0, L = y - ((r >>> 0 > e >>> 0) + F | 0) | 0, M = n - (r = -2097152 & D) | 0, b = f - ((r >>> 0 > n >>> 0) + b | 0) | 0, f = Ig(_$U, 0, 136657, 0), e = (r = a[A + 40 | 0]) >>> 24 | 0, s = r << 8 | (D = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, y = (r = a[A + 41 | 0]) >>> 16 | 0, e = (y |= e) >>> 3 | 0, y = (7 & y) << 29 | (r = s | r << 16) >>> 3, r = e + w | 0, r = y >>> 0 > (s = y + f | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(C, 0, -683901, -1), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, h = y, e = Ig(_$U, 0, -997805, -1), y = w, y = e >>> 0 > (s = e + (D >>> 6 & 2097151) | 0) >>> 0 ? y + 1 | 0 : y, D = (e = s) + (s = Ig(C, 0, 136657, 0)) | 0, e = w + y | 0, y = Ig(_$B, _$X, -683901, -1), e = w + (s >>> 0 > D >>> 0 ? e + 1 | 0 : e) | 0, k = e = y >>> 0 > (l = y + D | 0) >>> 0 ? e + 1 | 0 : e, V = y = e - ((l >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >> 21) | 0, D = r = (y = (2097151 & y) << 11 | (n = l - -1048576 | 0) >>> 21) >>> 0 > (F = y + h | 0) >>> 0 ? r + 1 | 0 : r, _$m = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >> 21) + b | 0, _$z = e = (r = (y = (2097151 & r) << 11 | (h = F - -1048576 | 0) >>> 21) + M | 0) >>> 0 < y >>> 0 ? e + 1 | 0 : e, u = r, e = Ig(r, e, -683901, -1), r = w + L | 0, _$d = y = e + J | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, L = S - (r = -2097152 & p) | 0, b = G - ((4095 & x) + (r >>> 0 > S >>> 0) | 0) | 0, S = Ig(_$I, 0, 666643, 0), r = (e = a[A + 19 | 0]) >>> 24 | 0, p = e << 8 | (G = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, y = r, e = (7 & (y |= e = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (e = (r <<= 16) | p) >>> 3, y = w + (y >>> 3 | 0) | 0, y = e >>> 0 > (p = e + S | 0) >>> 0 ? y + 1 | 0 : y, r = Ig(g, j, 470296, 0), e = w + y | 0, r = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, y = Ig(g, j, 666643, 0), e = w, S = e = y >>> 0 > (J = y + (G >>> 6 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, Z = y = e - ((J >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >>> 21 | 0) | 0, G = r = (y = (2097151 & y) << 11 | (f = J - -1048576 | 0) >>> 21) >>> 0 > (M = y + p | 0) >>> 0 ? r + 1 | 0 : r, _$W = r = r - ((M >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >>> 21 | 0) + b | 0, e = (r = (2097151 & r) << 11 | (p = M - -1048576 | 0) >>> 21) >>> 0 > (y = r + L | 0) >>> 0 ? e + 1 | 0 : e, b = (r = y) + (y = Ig(q, P, -997805, -1)) | 0, r = w + e | 0, r = y >>> 0 > b >>> 0 ? r + 1 | 0 : r, x = e = F - (y = -2097152 & h) | 0, Q = h = D - ((y >>> 0 > F >>> 0) + _$m | 0) | 0, y = Ig(u, _$z, 136657, 0), r = w + r | 0, r = y >>> 0 > (D = y + b | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(e, h, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (b = y + D | 0) >>> 0 ? e + 1 | 0 : e, _$m = r = e - ((b >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = b - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, _$d = e = (r = e >>> 0 > (F = e + _$d | 0) >>> 0 ? r + 1 | 0 : r) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, L = (2097151 & e) << 11 | (s = F - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, E = v = L + v | 0, L = v >>> 0 < L >>> 0 ? e + 1 | 0 : e, _ = F - (e = -2097152 & s) | 0, c = r - ((e >>> 0 > F >>> 0) + _$d | 0) | 0, v = b - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > b >>> 0) + _$m | 0) | 0, y = (r = Ig(q, P, 654183, 0)) + (M - (e = -2097152 & p) | 0) | 0, e = w + (G - ((2147483647 & _$W) + (e >>> 0 > M >>> 0) | 0) | 0) | 0, e = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, r = Ig(u, _$z, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(x, Q, 136657, 0)) | 0, r = w + e | 0, _$d = s, D = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, M = l - (r = -2097152 & n) | 0, F = k - ((r >>> 0 > l >>> 0) + V | 0) | 0, G = Ig(R, 0, -683901, -1), r = (e = a[A + 35 | 0]) >>> 24 | 0, s = e << 8 | (p = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, y = r, e = (r = a[A + 36 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + G | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(_$U, 0, 654183, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, y = Ig(C, 0, -997805, -1), r = w + e | 0, r = y >>> 0 > (s = y + s | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(_$B, _$X, 136657, 0), r = w + r | 0, h = y = e + s | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(_$I, 0, -683901, -1), e = w, e = r >>> 0 > (y = r + (p >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, p = (r = Ig(R, 0, 136657, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, r = Ig(_$U, 0, 470296, 0), e = w + y | 0, e = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, p = (y = Ig(C, 0, 654183, 0)) + p | 0, r = w + e | 0, e = Ig(_$B, _$X, -997805, -1), r = w + (y >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = r = e >>> 0 > (k = e + p | 0) >>> 0 ? r + 1 | 0 : r, t = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, y = (r = e >> 21) + s | 0, b = e = (y = (e = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21) >>> 0 > (n = e + h | 0) >>> 0 ? y + 1 | 0 : y) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >> 21) + F | 0, _$m = r = (e = (s = (2097151 & e) << 11 | (h = n - -1048576 | 0) >>> 21) + M | 0) >>> 0 < s >>> 0 ? r + 1 | 0 : r, s = _$d, _$d = e, r = Ig(e, r, -683901, -1), e = w + D | 0, F = s = s + r | 0, s = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, D = (r = Ig(q, P, 470296, 0)) + (J - (e = -2097152 & f) | 0) | 0, e = w + (S - ((2047 & Z) + (e >>> 0 > J >>> 0) | 0) | 0) | 0, e = r >>> 0 > D >>> 0 ? e + 1 | 0 : e, f = (r = D) + (D = Ig(u, _$z, 654183, 0)) | 0, r = w + e | 0, r = D >>> 0 > f >>> 0 ? r + 1 | 0 : r, D = Ig(x, Q, -997805, -1), e = w + r | 0, e = D >>> 0 > (f = D + f | 0) >>> 0 ? e + 1 | 0 : e, l = h = n - (r = -2097152 & h) | 0, i = D = y - ((r >>> 0 > n >>> 0) + b | 0) | 0, y = Ig(_$d, _$m, 136657, 0), r = w + e | 0, r = y >>> 0 > (f = y + f | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(h, D, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (S = y + f | 0) >>> 0 ? e + 1 | 0 : e, b = r = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = S - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, F = e = (r = e >>> 0 > (f = e + F | 0) >>> 0 ? r + 1 | 0 : r) - ((f >>> 0 < 4293918720) - 1 | 0) | 0, n = (2097151 & e) << 11 | (s = f - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, V = M = n + v | 0, M = n >>> 0 > M >>> 0 ? e + 1 | 0 : e, Z = f - (e = -2097152 & s) | 0, _$W = r - ((e >>> 0 > f >>> 0) + F | 0) | 0, v = S - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > S >>> 0) + b | 0) | 0, D = Ig(q, P, 666643, 0), r = (e = a[A + 14 | 0]) >>> 24 | 0, s = e << 8 | (b = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, y = r, e = (r = a[A + 15 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + D | 0) >>> 0 ? y + 1 | 0 : y, s = (r = e) + (e = Ig(u, _$z, 470296, 0)) | 0, r = w + y | 0, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, e = Ig(x, Q, 654183, 0), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(_$d, _$m, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 136657, 0), e = w + e | 0, S = y = r + s | 0, s = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, p = k - (r = -2097152 & p) | 0, D = G - ((r >>> 0 > k >>> 0) + t | 0) | 0, y = Ig(_$I, 0, 136657, 0), r = w, r = (e = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (y = e + y | 0) >>> 0 ? r + 1 | 0 : r, h = (e = y) + (y = Ig(R, 0, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -683901, -1), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = Ig(_$U, 0, 666643, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > h >>> 0 ? y + 1 | 0 : y, e = Ig(C, 0, 470296, 0), r = w + y | 0, r = e >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(_$B, _$X, 654183, 0), r = w + r | 0, e = (_$H >> 21) + (e >>> 0 > (y = e + h | 0) >>> 0 ? r + 1 | 0 : r) | 0, n = e = (h = (2097151 & _$H) << 11 | _$K >>> 21) >>> 0 > (_$K = h + y | 0) >>> 0 ? e + 1 | 0 : e, F = r = e - ((_$K >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (f = _$K - -1048576 | 0) >>> 21, r = (r >> 21) + D | 0, J = r = (e = h + p | 0) >>> 0 < h >>> 0 ? r + 1 | 0 : r, _$H = e, e = Ig(e, r, -683901, -1), r = w + s | 0, h = y = e + S | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(u, _$z, 666643, 0), e = w, e = r >>> 0 > (y = r + (b >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(x, Q, 470296, 0), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, D = (r = Ig(_$d, _$m, 654183, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(l, i, -997805, -1), r = w + y | 0, r = e >>> 0 > (D = e + D | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(_$H, J, 136657, 0), r = w + r | 0, G = r = e >>> 0 > (k = e + D | 0) >>> 0 ? r + 1 | 0 : r, P = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, r = h, h = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21, e = (e >> 21) + s | 0, u = s = (e = (y = r + h | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e) - ((y >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = s >> 21) + O | 0, q = h = (s = (2097151 & s) << 11 | (D = y - -1048576 | 0) >>> 21) + v | 0, S = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, h = y, y = e, s = (_$K - (e = -2097152 & f) | 0) + (f = (2097151 & _$N) << 11 | Y >>> 21) | 0, e = (n - ((e >>> 0 > _$K >>> 0) + F | 0) | 0) + (_$N >> 21) | 0, b = e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, R = e = e - ((s >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = e >> 21, r = Ig(_$U = (2097151 & e) << 11 | (F = s - -1048576 | 0) >>> 21, r, -683901, -1), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, j = e - (r = -2097152 & D) | 0, _$X = y - ((r >>> 0 > e >>> 0) + u | 0) | 0, r = Ig(_$U, Y, 136657, 0), e = G + w | 0, _$z = (y = r + k | 0) - (r = -2097152 & p) | 0, u = (e = y >>> 0 < k >>> 0 ? e + 1 | 0 : e) - ((r >>> 0 > y >>> 0) + P | 0) | 0, e = Ig(x, Q, 666643, 0), y = w, y = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (e = r + e | 0) >>> 0 ? y + 1 | 0 : y, h = (r = Ig(_$d, _$m, 470296, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 654183, 0), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = y) + (y = Ig(_$H, J, -997805, -1)) | 0, r = w + e | 0, f = h, h = y >>> 0 > h >>> 0 ? r + 1 | 0 : r, G = Ig(_$d, _$m, 666643, 0), r = (e = a[A + 6 | 0]) >>> 24 | 0, D = e << 8 | (_$K = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, y = r, e = (r = a[A + 7 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = r << 16 | D) >>> 2), r = w, r = e >>> 0 > (y = e + G | 0) >>> 0 ? r + 1 | 0 : r, D = (e = Ig(l, i, 470296, 0)) + y | 0, y = w + r | 0, y = e >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(_$H, J, 654183, 0), r = w + y | 0, G = r = e >>> 0 > (n = e + D | 0) >>> 0 ? r + 1 | 0 : r, _$N = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, e = (y = r >> 21) + h | 0, k = r = (e = (r = (2097151 & r) << 11 | (p = n - -1048576 | 0) >>> 21) >>> 0 > (D = r + f | 0) >>> 0 ? e + 1 | 0 : e) - ((D >>> 0 < 4293918720) - 1 | 0) | 0, f = (2097151 & r) << 11 | (h = D - -1048576 | 0) >>> 21, r = (r >> 21) + u | 0, u = _$d = f + _$z | 0, f = f >>> 0 > _$d >>> 0 ? r + 1 | 0 : r, r = Ig(_$U, Y, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + D | 0) >>> 0 ? e + 1 | 0 : e, x = y - (r = -2097152 & h) | 0, _$m = e - ((r >>> 0 > y >>> 0) + k | 0) | 0, e = Ig(_$U, Y, 654183, 0), r = G + w | 0, _$d = (y = e + n | 0) - (e = -2097152 & p) | 0, _$N = (r = y >>> 0 < n >>> 0 ? r + 1 | 0 : r) - ((e >>> 0 > y >>> 0) + _$N | 0) | 0, r = Ig(l, i, 666643, 0), e = w, e = r >>> 0 > (y = r + (_$K >>> 5 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(_$H, J, 470296, 0), e = w + e | 0, D = y = r + y | 0, y = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, h = Ig(_$H, J, 666643, 0), e = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = w, G = r = e >>> 0 > (k = h + e | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (p = k - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, y = r = h >>> 0 > (n = h + D | 0) >>> 0 ? r + 1 | 0 : r, _$K = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21, r = (r >> 21) + _$N | 0, h = h >>> 0 > (_$N = _$H = h + _$d | 0) >>> 0 ? r + 1 | 0 : r, r = Ig(_$U, Y, 470296, 0), y = y + w | 0, y = (e = r + n | 0) >>> 0 < n >>> 0 ? y + 1 | 0 : y, n = e - (r = -2097152 & D) | 0, D = y - ((r >>> 0 > e >>> 0) + _$K | 0) | 0, e = Ig(_$U, Y, 666643, 0), r = w + (G - (((y = -2097152 & p) >>> 0 > k >>> 0) + J | 0) | 0) | 0, e = (y = (r = e >>> 0 > (_$H = e + (k - y | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + D | 0, r = (r = (e = (r = (2097151 & r) << 11 | _$H >>> 21) >>> 0 > (_$K = r + n | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + h | 0, e = (e = (r = (e = (2097151 & e) << 11 | _$K >>> 21) >>> 0 > (_$N = e + _$N | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + _$m | 0, y = (r = (e = (r = (2097151 & r) << 11 | _$N >>> 21) >>> 0 > (h = r + x | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + f | 0, r = (e = (y = (e = (2097151 & e) << 11 | h >>> 21) >>> 0 > (Y = e + u | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + _$X | 0, e = (y = (r = (y = (2097151 & y) << 11 | Y >>> 21) >>> 0 > (k = y + j | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + S | 0, r = (r = (e = (r = (2097151 & r) << 11 | k >>> 21) >>> 0 > (n = r + q | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + _$W | 0, e = (e = (r = (e = (2097151 & e) << 11 | n >>> 21) >>> 0 > (S = e + Z | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + M | 0, y = (r = (e = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (f = r + V | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + c | 0, r = (e = (y = (e = (2097151 & e) << 11 | f >>> 21) >>> 0 > (G = e + _ | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + L | 0, D = (F = s - (e = -2097152 & F) | 0) + ((2097151 & (r = (y = (2097151 & y) << 11 | G >>> 21) >>> 0 > (p = y + E | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | p >>> 21) | 0, r = (b - ((e >>> 0 > s >>> 0) + R | 0) | 0) + (r >> 21) | 0, F = e = (r = D >>> 0 < F >>> 0 ? r + 1 | 0 : r) >> 21, _$H = (r = Ig(M = (2097151 & r) << 11 | D >>> 21, e, 666643, 0)) + (e = 2097151 & _$H) | 0, r = w, s = r = e >>> 0 > _$H >>> 0 ? r + 1 | 0 : r, o[0 | A] = _$H, o[A + 1 | 0] = (255 & r) << 24 | _$H >>> 8, r = 2097151 & _$K, e = Ig(M, F, 470296, 0) + r | 0, y = w, r = (s >> 21) + (r >>> 0 > e >>> 0 ? y + 1 | 0 : y) | 0, r = (b = (2097151 & s) << 11 | _$H >>> 21) >>> 0 > (_$K = b + e | 0) >>> 0 ? r + 1 | 0 : r, o[A + 4 | 0] = (2047 & r) << 21 | _$K >>> 11, e = r, y = _$K, o[A + 3 | 0] = (7 & r) << 29 | y >>> 3, o[A + 2 | 0] = 31 & ((65535 & s) << 16 | _$H >>> 16) | y << 5, s = 2097151 & _$N, _$N = Ig(M, F, 654183, 0) + s | 0, r = w, _$K = (2097151 & e) << 11 | y >>> 21, e = (e >> 21) + (s = s >>> 0 > _$N >>> 0 ? r + 1 | 0 : r) | 0, r = e = (_$N = _$K + _$N | 0) >>> 0 < _$K >>> 0 ? e + 1 | 0 : e, o[A + 6 | 0] = (63 & r) << 26 | _$N >>> 6, s = _$N, _$N = 0, o[A + 5 | 0] = _$N << 13 | (1572864 & y) >>> 19 | s << 2, y = 2097151 & h, h = Ig(M, F, -997805, -1) + y | 0, e = w, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, _$N = (2097151 & (y = r)) << 11 | s >>> 21, y = (r >>= 21) + e | 0, y = (h = _$N + h | 0) >>> 0 < _$N >>> 0 ? y + 1 | 0 : y, o[A + 9 | 0] = (511 & y) << 23 | h >>> 9, o[A + 8 | 0] = (1 & y) << 31 | h >>> 1, e = 0, o[A + 7 | 0] = e << 18 | (2080768 & s) >>> 14 | h << 7, e = 2097151 & Y, s = Ig(M, F, 136657, 0) + e | 0, r = w, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (e = y)) << 11 | h >>> 21, e = r + (y = e >> 21) | 0, e = (s = Y + s | 0) >>> 0 < Y >>> 0 ? e + 1 | 0 : e, o[A + 12 | 0] = (4095 & e) << 20 | s >>> 12, y = s, o[A + 11 | 0] = (15 & e) << 28 | y >>> 4, s = 0, o[A + 10 | 0] = s << 15 | (1966080 & h) >>> 17 | y << 4, s = 2097151 & k, h = Ig(M, F, -683901, -1) + s | 0, r = w, r = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, s = e, e = r + (e >>= 21) | 0, e = (s = (_$d = h) + (h = (2097151 & s) << 11 | y >>> 21) | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e, o[A + 14 | 0] = (127 & e) << 25 | s >>> 7, h = 0, o[A + 13 | 0] = h << 12 | (1048576 & y) >>> 20 | s << 1, r = e >> 21, y = (e = (2097151 & e) << 11 | s >>> 21) >>> 0 > (h = e + (2097151 & n) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 17 | 0] = (1023 & y) << 22 | h >>> 10, o[A + 16 | 0] = (3 & y) << 30 | h >>> 2, e = 0, o[A + 15 | 0] = e << 17 | (2064384 & s) >>> 15 | h << 6, r = y >> 21, r = (e = (2097151 & y) << 11 | h >>> 21) >>> 0 > (y = e + (2097151 & S) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 20 | 0] = (8191 & r) << 19 | y >>> 13, o[A + 19 | 0] = (31 & r) << 27 | y >>> 5, s = (e = 2097151 & f) + (f = (2097151 & r) << 11 | y >>> 21) | 0, e = r >> 21, e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, f = s, o[A + 21 | 0] = s, S = 0, o[A + 18 | 0] = S << 14 | (1835008 & h) >>> 18 | y << 3, o[A + 22 | 0] = (255 & e) << 24 | s >>> 8, y = e >> 21, y = (s = (h = (2097151 & e) << 11 | s >>> 21) + (2097151 & G) | 0) >>> 0 < h >>> 0 ? y + 1 | 0 : y, o[A + 25 | 0] = (2047 & y) << 21 | s >>> 11, o[A + 24 | 0] = (7 & y) << 29 | s >>> 3, o[A + 23 | 0] = 31 & ((65535 & e) << 16 | f >>> 16) | s << 5, r = y >> 21, r = (e = (2097151 & y) << 11 | s >>> 21) >>> 0 > (y = e + (2097151 & p) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 27 | 0] = (63 & r) << 26 | y >>> 6, h = 0, o[A + 26 | 0] = h << 13 | (1572864 & s) >>> 19 | y << 2, e = r >> 21, e = (r = (s = (2097151 & r) << 11 | y >>> 21) + (2097151 & D) | 0) >>> 0 < s >>> 0 ? e + 1 | 0 : e, o[A + 31 | 0] = (131071 & e) << 15 | r >>> 17, o[A + 30 | 0] = (511 & e) << 23 | r >>> 9, o[A + 29 | 0] = (1 & e) << 31 | r >>> 1, s = 0, o[A + 28 | 0] = s << 18 | (2080768 & y) >>> 14 | r << 7;
                                    }
                                    function S(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0;
                                        if (h = g = h - 4096 | 0, A) {
                                            A: {
                                                I: {
                                                    if (2 == (0 | (_ = E[A + 36 >> 2]))) {
                                                        if (iA = E[A + 4 >> 2], (T = E[I >> 2]) | (_$X = a[I + 8 | 0]) >>> 0 >= 2) break I;
                                                        T = 0;
                                                    } else _$X = a[I + 8 | 0], iA = E[A + 4 >> 2], T = E[I >> 2];
                                                    if (Hg(g + 3072 | 0, 0, 1024), Hg(g + 2104 | 0, 0, 968), E[g + 2048 >> 2] = T, E[g + 2052 >> 2] = 0, u = E[I + 4 >> 2], E[g + 2064 >> 2] = _$X, E[g + 2068 >> 2] = 0, E[g + 2056 >> 2] = u, E[g + 2060 >> 2] = 0, E[g + 2072 >> 2] = E[A + 16 >> 2], E[g + 2076 >> 2] = 0, u = E[A + 8 >> 2], E[g + 2088 >> 2] = _, E[g + 2092 >> 2] = 0, E[g + 2080 >> 2] = u, E[g + 2084 >> 2] = 0, !E[A + 20 >> 2]) break A;
                                                    for(u = 0; (_$N = 127 & r) || (u = (P = P + 1 | 0) ? u : u + 1 | 0, E[g + 2096 >> 2] = P, E[g + 2100 >> 2] = u, _ = Hg(g, 0, 1024), Hg(_ + 1024 | 0, 0, 1024), G(C = _ + 3072 | 0, _ + 2048 | 0, _), G(C, _, _ + 1024 | 0)), _$N = E[4 + (_ = (g + 1024 | 0) + (_$N << 3) | 0) >> 2], E[(C = (r << 3) + iA | 0) >> 2] = E[_ >> 2], E[C + 4 >> 2] = _$N, (_$N = E[A + 20 >> 2]) >>> 0 > (r = r + 1 | 0) >>> 0;);
                                                    break A;
                                                }
                                                _$N = E[A + 20 >> 2], _A = 1;
                                            }
                                            if (!((u = (EA = !(_$X | T)) << 1) >>> 0 >= _$N >>> 0)) for(_ = E[A + 24 >> 2], QA = E[I + 4 >> 2], r = (P = (c(_, QA) + u | 0) + c(_$N, _$X) | 0) + ((P >>> 0) % (_ >>> 0) | 0 ? -1 : _ - 1 | 0) | 0, _$cA = _$X + 1 | 0;;){
                                                C = E[A + 28 >> 2], oA = 1 == ((P >>> 0) % ((_ = E[A + 24 >> 2]) >>> 0) | 0) ? P - 1 | 0 : r, r = _A ? E[E[A >> 2] + 4 >> 2] + (oA << 10) | 0 : (u << 3) + iA | 0, _$B = E[r >> 2], r = E[r + 4 >> 2], E[I + 12 >> 2] = u, C = EA ? QA : (r >>> 0) % (C >>> 0) | 0;
                                                A: if (T) r = _ + ((0 | C) == (0 | QA) ? (-1 ^ _$N) + u | 0 : (u ? 0 : -1) - _$N | 0) | 0, i = 0, 3 != (0 | _$X) && (i = c(_$N, _$cA));
                                                else {
                                                    if (!_$X) {
                                                        r = u - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    if (r = c(_$N, _$X), (0 | C) == (0 | QA)) {
                                                        r = (r + u | 0) - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    r = r - !u | 0, i = 0;
                                                }
                                                if (e = (_$N = E[E[A >> 2] + 4 >> 2]) + (c(C, _) << 10) | 0, i = (o = C = r - 1 | 0) >>> 0 > (C = C + i | 0) >>> 0, Ig(_$B, 0, _$B, 0), Ig(r, 0, w, 0), oI(C - (r = w) | 0, i - (C >>> 0 < r >>> 0) | 0, _), w = p, r = (D << 10) + e | 0, _ = _$N + (oA << 10) | 0, aA = _$N + (P << 10) | 0, T) G(_, r, aA);
                                                else {
                                                    for(Sg(g + 3072 | 0, r, 1024), r = 0; i = E[(_$B = (_$N = r << 3) + (C = g + 3072 | 0) | 0) >> 2], s = E[(e = _ + _$N | 0) >> 2], e = E[_$B + 4 >> 2] ^ E[e + 4 >> 2], E[_$B >> 2] = i ^ s, E[_$B + 4 >> 2] = e, e = E[(_$B = (i = 8 | _$N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[_$B + 4 >> 2] ^ E[i + 4 >> 2], E[_$B >> 2] = e ^ s, E[_$B + 4 >> 2] = i, e = E[(_$B = (i = 16 | _$N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[_$B + 4 >> 2] ^ E[i + 4 >> 2], E[_$B >> 2] = e ^ s, E[_$B + 4 >> 2] = i, i = E[(_$N = (_$B = 24 | _$N) + C | 0) >> 2], e = E[(_$B = _$B + _ | 0) >> 2], _$B = E[_$N + 4 >> 2] ^ E[_$B + 4 >> 2], E[_$N >> 2] = i ^ e, E[_$N + 4 >> 2] = _$B, 128 != (0 | (r = r + 4 | 0)););
                                                    for(Sg(g + 2048 | 0, C, 1024), _$N = 0, r = 0; e = (i = E[56 + (_ = (g + 3072 | 0) + (r << 7) | 0) >> 2]) + (_$B = E[_ + 24 >> 2]) | 0, s = (o = E[_ + 60 >> 2]) + (C = E[_ + 28 >> 2]) | 0, t = Ig(_$B << 1 & -2, 1 & (C << 1 | _$B >>> 31), i, 0), _$B = w + (_$B >>> 0 > e >>> 0 ? s + 1 | 0 : s) | 0, e = (C = t + e | 0) >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B, t = (s = KI(C ^ E[_ + 120 >> 2], e ^ E[_ + 124 >> 2], 32)) + (_$B = E[_ + 88 >> 2]) | 0, Q = (n = w) + (_$U = E[_ + 92 >> 2]) | 0, y = i, _$U = Ig(s, 0, _$B << 1 & -2, 1 & (_$U << 1 | _$B >>> 31)), _$B = w + (_$B >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) | 0, J = KI(y ^ (i = _$U + t | 0), o ^ (R = i >>> 0 < _$U >>> 0 ? _$B + 1 | 0 : _$B), 40), t = 1 + (_$B = e + (_$gA = w) | 0) | 0, o = _$B, t = (_$B = C + J | 0) >>> 0 < C >>> 0 ? t : o, _$U = (C = Ig(J, 0, C << 1 & -2, 1 & (e << 1 | C >>> 31))) + _$B | 0, _$B = w + t | 0, k = KI(_$U ^ s, n ^ (_$z = C >>> 0 > _$U >>> 0 ? _$B + 1 | 0 : _$B), 48), _$H = y = w, e = (f = E[_ + 44 >> 2]) + (C = E[_ + 12 >> 2]) | 0, t = (s = E[_ + 40 >> 2]) + (_$B = E[_ + 8 >> 2]) | 0, Q = Ig(_$B << 1 & -2, 1 & (C << 1 | _$B >>> 31), s, 0), _$B = w + (_$B >>> 0 > t >>> 0 ? e + 1 | 0 : e) | 0, t = (C = t + Q | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, o = (Q = KI(C ^ E[_ + 104 >> 2], t ^ E[_ + 108 >> 2], 32)) + (e = E[_ + 72 >> 2]) | 0, n = (S = w) + (_$B = E[_ + 76 >> 2]) | 0, F = s, s = Ig(Q, 0, e << 1 & -2, 1 & (_$B << 1 | e >>> 31)), e = w + (e >>> 0 > o >>> 0 ? n + 1 | 0 : n) | 0, s = KI(F ^ (_$B = s + o | 0), f ^ (o = _$B >>> 0 < s >>> 0 ? e + 1 | 0 : e), 40), F = 1 + (e = t + (n = w) | 0) | 0, f = e, f = (e = C + s | 0) >>> 0 < C >>> 0 ? F : f, C = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31)), t = w + f | 0, f = KI((e = C + e | 0) ^ Q, S ^ (j = C >>> 0 > e >>> 0 ? t + 1 | 0 : t), 48), Q = 1 + (C = o + (CA = w) | 0) | 0, t = C, t = (C = _$B + f | 0) >>> 0 < _$B >>> 0 ? Q : t, Q = s, s = C, C = Ig(f, 0, _$B << 1 & -2, 1 & (o << 1 | _$B >>> 31)), _$B = w + t | 0, S = KI(Q ^ (s = s + C | 0), n ^ (O = C >>> 0 > s >>> 0 ? _$B + 1 | 0 : _$B), 1), $ = M = w, t = (_$d = E[_ + 36 >> 2]) + (C = E[_ + 4 >> 2]) | 0, o = (Q = E[_ + 32 >> 2]) + (_$B = E[_ >> 2]) | 0, n = Ig(_$B << 1 & -2, 1 & (C << 1 | _$B >>> 31), Q, 0), _$B = w + (_$B >>> 0 > o >>> 0 ? t + 1 | 0 : t) | 0, o = (C = o + n | 0) >>> 0 < n >>> 0 ? _$B + 1 | 0 : _$B, n = (V = KI(C ^ E[_ + 96 >> 2], o ^ E[_ + 100 >> 2], 32)) + (_$B = E[(t = q = _ - -64 | 0) >> 2]) | 0, F = (BA = w) + (t = E[t + 4 >> 2]) | 0, b = Q, Q = Ig(V, 0, _$B << 1 & -2, 1 & (t << 1 | _$B >>> 31)), _$B = w + (_$B >>> 0 > n >>> 0 ? F + 1 | 0 : F) | 0, F = KI(b ^ (t = Q + n | 0), _$d ^ (L = Q >>> 0 > t >>> 0 ? _$B + 1 | 0 : _$B), 40), n = 1 + (_$B = o + (Z = w) | 0) | 0, Q = _$B, Q = (_$B = C + F | 0) >>> 0 < C >>> 0 ? n : Q, n = _$B, _$B = Ig(F, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), Q = w + Q | 0, Q = 1 + (_$B = (x = (C = n + _$B | 0) >>> 0 < _$B >>> 0 ? Q + 1 | 0 : Q) + M | 0) | 0, o = _$B, o = (_$B = C + S | 0) >>> 0 < C >>> 0 ? Q : o, Q = _$B, _$B = Ig(S, 0, C << 1 & -2, 1 & (x << 1 | C >>> 31)), o = w + o | 0, y = KI((Q = Q + _$B | 0) ^ k, (_$m = _$B >>> 0 > Q >>> 0 ? o + 1 | 0 : o) ^ y, 32), _$W = w, n = (Y = E[_ + 52 >> 2]) + (_$B = E[_ + 20 >> 2]) | 0, _$d = (M = E[_ + 48 >> 2]) + (o = E[_ + 16 >> 2]) | 0, l = Ig(o << 1 & -2, 1 & (_$B << 1 | o >>> 31), M, 0), o = w + (o >>> 0 > _$d >>> 0 ? n + 1 | 0 : n) | 0, _$d = (_$B = _$d + l | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, v = (l = KI(_$B ^ E[_ + 112 >> 2], _$d ^ E[_ + 116 >> 2], 32)) + (n = E[_ + 80 >> 2]) | 0, b = (_$AA = w) + (o = E[_ + 84 >> 2]) | 0, _$K = M, M = Ig(l, 0, n << 1 & -2, 1 & (o << 1 | n >>> 31)), n = w + (n >>> 0 > v >>> 0 ? b + 1 | 0 : b) | 0, M = KI(_$K ^ (o = M + v | 0), Y ^ (v = o >>> 0 < M >>> 0 ? n + 1 | 0 : n), 40), _$K = 1 + (n = _$d + (Y = w) | 0) | 0, b = n, b = (n = _$B + M | 0) >>> 0 < _$B >>> 0 ? _$K : b, _$B = Ig(M, 0, _$B << 1 & -2, 1 & (_$d << 1 | _$B >>> 31)), _$d = w + b | 0, _$d = KI(_$K = (n = _$B + n | 0) ^ l, _$AA ^ (l = _$B >>> 0 > n >>> 0 ? _$d + 1 | 0 : _$d), 48), _$K = 1 + (_$B = v + (_$AA = w) | 0) | 0, b = _$B, b = (_$B = o + _$d | 0) >>> 0 < o >>> 0 ? _$K : b, o = Ig(_$d, 0, o << 1 & -2, 1 & (v << 1 | o >>> 31)), v = w + b | 0, _$K = 1 + (o = (v = (_$B = o + _$B | 0) >>> 0 < o >>> 0 ? v + 1 | 0 : v) + _$W | 0) | 0, b = o, b = (o = _$B + y | 0) >>> 0 < _$B >>> 0 ? _$K : b, _$K = S, S = Ig(y, 0, _$B << 1 & -2, 1 & (v << 1 | _$B >>> 31)), b = w + b | 0, S = KI(_$K ^ (o = S + o | 0), $ ^ (b = o >>> 0 < S >>> 0 ? b + 1 | 0 : b), 40), tA = 1 + (_$K = _$m + ($ = w) | 0) | 0, IA = _$K, IA = (_$K = Q + S | 0) >>> 0 < Q >>> 0 ? tA : IA, Q = (_$m = Ig(S, 0, Q << 1 & -2, 1 & (_$m << 1 | Q >>> 31))) + _$K | 0, E[_ >> 2] = Q, _$K = w + IA | 0, _$m = Q >>> 0 < _$m >>> 0 ? _$K + 1 | 0 : _$K, E[_ + 4 >> 2] = _$m, Q = KI(Q ^ y, _$m ^ _$W, 48), E[_ + 120 >> 2] = Q, y = w, E[_ + 124 >> 2] = y, IA = 1 + (y = y + b | 0) | 0, _$K = y, _$m = (y = Q + o | 0) >>> 0 < o >>> 0 ? IA : _$K, Q = (o = Ig(Q, 0, o << 1 & -2, 1 & (b << 1 | o >>> 31))) + y | 0, E[_ + 80 >> 2] = Q, y = w + _$m | 0, o = Q >>> 0 < o >>> 0 ? y + 1 | 0 : y, E[_ + 84 >> 2] = o, rA = _, _$eA = KI(Q ^ S, o ^ $, 1), E[rA + 40 >> 2] = _$eA, E[_ + 44 >> 2] = w, Q = KI(_$B ^ M, v ^ Y, 1), y = 1 + (_$B = j + (M = w) | 0) | 0, o = _$B, o = (_$B = Q + e | 0) >>> 0 < e >>> 0 ? y : o, _$B = _$B + (S = Ig(Q, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) | 0, e = w + o | 0, o = KI(C ^ V, x ^ BA, 48), e = KI(o ^ _$B, (S = _$B >>> 0 < S >>> 0 ? e + 1 | 0 : e) ^ (j = w), 32), V = y = w, b = 1 + (C = R + _$H | 0) | 0, _$H = C, x = (C = i + k | 0) >>> 0 < i >>> 0 ? b : _$H, i = Ig(k, 0, i << 1 & -2, 1 & (R << 1 | i >>> 31)), k = w + x | 0, _$H = 1 + (i = (k = (C = i + C | 0) >>> 0 < i >>> 0 ? k + 1 | 0 : k) + y | 0) | 0, y = i, y = (i = C + e | 0) >>> 0 < C >>> 0 ? _$H : y, _$H = Q, Q = Ig(e, 0, C << 1 & -2, 1 & (k << 1 | C >>> 31)), y = w + y | 0, Q = KI(_$H ^ (i = Q + i | 0), M ^ (y = i >>> 0 < Q >>> 0 ? y + 1 | 0 : y), 40), b = 1 + (R = S + (M = w) | 0) | 0, _$H = R, x = (R = _$B + Q | 0) >>> 0 < _$B >>> 0 ? b : _$H, _$H = e, e = Ig(Q, 0, _$B << 1 & -2, 1 & (S << 1 | _$B >>> 31)), S = w + x | 0, e = KI(_$H ^ (_$B = e + R | 0), V ^ (S = _$B >>> 0 < e >>> 0 ? S + 1 | 0 : S), 48), E[_ + 96 >> 2] = e, R = w, E[_ + 100 >> 2] = R, E[_ + 8 >> 2] = _$B, E[_ + 12 >> 2] = S, S = 1 + (_$B = y + R | 0) | 0, _$H = _$B, S = (_$B = i + e | 0) >>> 0 < i >>> 0 ? S : _$H, i = Ig(e, 0, i << 1 & -2, 1 & (y << 1 | i >>> 31)), e = w + S | 0, rA = _, _$eA = KI((_$B = i + _$B | 0) ^ Q, M ^ (i = _$B >>> 0 < i >>> 0 ? e + 1 | 0 : e), 1), E[rA + 48 >> 2] = _$eA, E[_ + 52 >> 2] = w, E[_ + 88 >> 2] = _$B, E[_ + 92 >> 2] = i, i = KI(C ^ J, k ^ _$gA, 1), e = 1 + (C = l + (J = w) | 0) | 0, _$B = C, e = (C = i + n | 0) >>> 0 < n >>> 0 ? e : _$B, _$B = C, C = Ig(i, 0, n << 1 & -2, 1 & (l << 1 | n >>> 31)), e = w + e | 0, e = KI((_$B = _$B + C | 0) ^ f, CA ^ (Q = C >>> 0 > _$B >>> 0 ? e + 1 | 0 : e), 32), k = n = w, f = 1 + (C = L + j | 0) | 0, y = C, f = (C = o + t | 0) >>> 0 < t >>> 0 ? f : y, t = Ig(o, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31)), o = w + f | 0, f = 1 + (t = (o = (C = t + C | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + n | 0) | 0, y = t, n = (t = C + e | 0) >>> 0 < C >>> 0 ? f : y, y = i, i = t, t = Ig(e, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), n = w + n | 0, t = KI(y ^ (i = i + t | 0), J ^ (n = i >>> 0 < t >>> 0 ? n + 1 | 0 : n), 40), M = 1 + (f = Q + (J = w) | 0) | 0, y = f, S = (f = _$B + t | 0) >>> 0 < _$B >>> 0 ? M : y, _$B = (Q = Ig(t, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31))) + f | 0, E[_ + 16 >> 2] = _$B, f = w + S | 0, Q = _$B >>> 0 < Q >>> 0 ? f + 1 | 0 : f, E[_ + 20 >> 2] = Q, _$B = KI(_$B ^ e, Q ^ k, 48), E[_ + 104 >> 2] = _$B, e = w, E[_ + 108 >> 2] = e, Q = 1 + (e = e + n | 0) | 0, y = e, Q = (e = _$B + i | 0) >>> 0 < i >>> 0 ? Q : y, i = (_$B = Ig(_$B, 0, i << 1 & -2, 1 & (n << 1 | i >>> 31))) + e | 0, e = w + Q | 0, n = _$B = _$B >>> 0 > i >>> 0 ? e + 1 | 0 : e, E[q >> 2] = i, E[q + 4 >> 2] = _$B, e = (_$B = KI(C ^ F, o ^ Z, 1)) + _$U | 0, Q = (k = w) + _$z | 0, C = (o = Ig(_$U << 1 & -2, 1 & (_$z << 1 | _$U >>> 31), _$B, 0)) + e | 0, e = w + (_$B >>> 0 > e >>> 0 ? Q + 1 | 0 : Q) | 0, e = KI(C ^ _$d, _$AA ^ (Q = C >>> 0 < o >>> 0 ? e + 1 | 0 : e), 32), f = 1 + (o = O + (_$U = w) | 0) | 0, y = o, f = (o = e + s | 0) >>> 0 < s >>> 0 ? f : y, y = _$B, _$B = (s = Ig(e, 0, s << 1 & -2, 1 & (O << 1 | s >>> 31))) + o | 0, o = w + f | 0, s = KI(y ^ _$B, k ^ (o = _$B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), F = 1 + (f = Q + (k = w) | 0) | 0, y = f, S = (f = C + s | 0) >>> 0 < C >>> 0 ? F : y, y = e, C = Ig(s, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), Q = w + S | 0, C = KI(y ^ (e = C + f | 0), _$U ^ (Q = C >>> 0 > e >>> 0 ? Q + 1 | 0 : Q), 48), F = 1 + (f = o + (_$U = w) | 0) | 0, y = f, S = (f = C + _$B | 0) >>> 0 < _$B >>> 0 ? F : y, _$B = (o = Ig(C, 0, _$B << 1 & -2, 1 & (o << 1 | _$B >>> 31))) + f | 0, E[_ + 72 >> 2] = _$B, f = w + S | 0, o = _$B >>> 0 < o >>> 0 ? f + 1 | 0 : f, E[_ + 76 >> 2] = o, E[_ + 112 >> 2] = C, E[_ + 116 >> 2] = _$U, E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = Q, rA = _, _$eA = KI(i ^ t, n ^ J, 1), E[rA + 56 >> 2] = _$eA, E[_ + 60 >> 2] = w, rA = _, _$eA = KI(_$B ^ s, o ^ k, 1), E[rA + 32 >> 2] = _$eA, E[_ + 36 >> 2] = w, 8 != (0 | (r = r + 1 | 0)););
                                                    for(; i = (_$B = E[392 + (_ = (g + 3072 | 0) + (_$N << 4) | 0) >> 2]) + (C = E[_ + 136 >> 2]) | 0, e = (Q = E[_ + 396 >> 2]) + (r = E[_ + 140 >> 2]) | 0, s = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), _$B, 0), C = w + (C >>> 0 > i >>> 0 ? e + 1 | 0 : e) | 0, i = (r = s + i | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C, s = (e = KI(r ^ E[_ + 904 >> 2], i ^ E[_ + 908 >> 2], 32)) + (C = E[_ + 648 >> 2]) | 0, t = (o = w) + (n = E[_ + 652 >> 2]) | 0, y = _$B, n = Ig(e, 0, C << 1 & -2, 1 & (n << 1 | C >>> 31)), C = w + (C >>> 0 > s >>> 0 ? t + 1 | 0 : t) | 0, _$U = KI(y ^ (_$B = n + s | 0), Q ^ (_$d = _$B >>> 0 < n >>> 0 ? C + 1 | 0 : C), 40), y = 1 + (C = i + (v = w) | 0) | 0, t = C, s = (C = r + _$U | 0) >>> 0 < r >>> 0 ? y : t, n = (r = Ig(_$U, 0, r << 1 & -2, 1 & (i << 1 | r >>> 31))) + C | 0, C = w + s | 0, J = KI(n ^ e, o ^ (R = r >>> 0 > n >>> 0 ? C + 1 | 0 : C), 48), b = F = w, i = (k = E[_ + 268 >> 2]) + (r = E[_ + 12 >> 2]) | 0, s = (e = E[_ + 264 >> 2]) + (C = E[_ + 8 >> 2]) | 0, t = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), e, 0), C = w + (C >>> 0 > s >>> 0 ? i + 1 | 0 : i) | 0, s = (r = s + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C, Q = (t = KI(r ^ E[_ + 776 >> 2], s ^ E[_ + 780 >> 2], 32)) + (i = E[_ + 520 >> 2]) | 0, o = (f = w) + (C = E[_ + 524 >> 2]) | 0, y = e, e = Ig(t, 0, i << 1 & -2, 1 & (C << 1 | i >>> 31)), i = w + (i >>> 0 > Q >>> 0 ? o + 1 | 0 : o) | 0, e = KI(y ^ (C = e + Q | 0), k ^ (Q = C >>> 0 < e >>> 0 ? i + 1 | 0 : i), 40), k = 1 + (i = s + (o = w) | 0) | 0, y = i, k = (i = r + e | 0) >>> 0 < r >>> 0 ? k : y, r = Ig(e, 0, r << 1 & -2, 1 & (s << 1 | r >>> 31)), s = w + k | 0, k = KI((i = r + i | 0) ^ t, f ^ (_$z = i >>> 0 < r >>> 0 ? s + 1 | 0 : s), 48), y = 1 + (r = Q + (_$gA = w) | 0) | 0, t = r, s = (r = C + k | 0) >>> 0 < C >>> 0 ? y : t, t = e, e = r, r = Ig(k, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), C = w + s | 0, f = KI(t ^ (e = e + r | 0), o ^ (j = r >>> 0 > e >>> 0 ? C + 1 | 0 : C), 1), _$H = y = w, s = (M = E[_ + 260 >> 2]) + (r = E[_ + 4 >> 2]) | 0, Q = (t = E[_ + 256 >> 2]) + (C = E[_ >> 2]) | 0, o = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), t, 0), C = w + (C >>> 0 > Q >>> 0 ? s + 1 | 0 : s) | 0, Q = (r = Q + o | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, o = (O = KI(r ^ E[_ + 768 >> 2], Q ^ E[_ + 772 >> 2], 32)) + (C = E[_ + 512 >> 2]) | 0, S = (CA = w) + (s = E[_ + 516 >> 2]) | 0, Y = t, t = Ig(O, 0, C << 1 & -2, 1 & (s << 1 | C >>> 31)), C = w + (C >>> 0 > o >>> 0 ? S + 1 | 0 : S) | 0, S = KI(Y ^ (s = t + o | 0), M ^ (V = t >>> 0 > s >>> 0 ? C + 1 | 0 : C), 40), t = 1 + (C = Q + ($ = w) | 0) | 0, o = C, t = (C = r + S | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(S, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), t = w + t | 0, t = 1 + (C = (q = C >>> 0 > (r = o + C | 0) >>> 0 ? t + 1 | 0 : t) + y | 0) | 0, o = C, Q = (C = r + f | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(f, 0, r << 1 & -2, 1 & (q << 1 | r >>> 31)), Q = w + Q | 0, F = KI((t = o + C | 0) ^ J, (L = C >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) ^ F, 32), BA = w, o = (Z = E[_ + 388 >> 2]) + (C = E[_ + 132 >> 2]) | 0, M = (y = E[_ + 384 >> 2]) + (Q = E[_ + 128 >> 2]) | 0, x = Ig(Q << 1 & -2, 1 & (C << 1 | Q >>> 31), y, 0), Q = w + (Q >>> 0 > M >>> 0 ? o + 1 | 0 : o) | 0, M = (C = M + x | 0) >>> 0 < x >>> 0 ? Q + 1 | 0 : Q, _$m = (x = KI(C ^ E[_ + 896 >> 2], M ^ E[_ + 900 >> 2], 32)) + (o = E[_ + 640 >> 2]) | 0, l = (_$W = w) + (Q = E[_ + 644 >> 2]) | 0, Y = y, y = Ig(x, 0, o << 1 & -2, 1 & (Q << 1 | o >>> 31)), o = w + (o >>> 0 > _$m >>> 0 ? l + 1 | 0 : l) | 0, y = KI(Y ^ (Q = y + _$m | 0), Z ^ (_$m = Q >>> 0 < y >>> 0 ? o + 1 | 0 : o), 40), _$K = 1 + (o = M + (Z = w) | 0) | 0, Y = o, l = (o = C + y | 0) >>> 0 < C >>> 0 ? _$K : Y, C = Ig(y, 0, C << 1 & -2, 1 & (M << 1 | C >>> 31)), M = w + l | 0, M = KI(Y = (o = C + o | 0) ^ x, _$W ^ (x = C >>> 0 > o >>> 0 ? M + 1 | 0 : M), 48), _$K = 1 + (C = _$m + (_$W = w) | 0) | 0, Y = C, l = (C = Q + M | 0) >>> 0 < Q >>> 0 ? _$K : Y, Q = Ig(M, 0, Q << 1 & -2, 1 & (_$m << 1 | Q >>> 31)), _$m = w + l | 0, _$K = 1 + (Q = (_$m = (C = Q + C | 0) >>> 0 < Q >>> 0 ? _$m + 1 | 0 : _$m) + BA | 0) | 0, Y = Q, l = (Q = C + F | 0) >>> 0 < C >>> 0 ? _$K : Y, Y = f, f = Ig(F, 0, C << 1 & -2, 1 & (_$m << 1 | C >>> 31)), l = w + l | 0, f = KI(Y ^ (Q = f + Q | 0), _$H ^ (l = Q >>> 0 < f >>> 0 ? l + 1 | 0 : l), 40), IA = 1 + (Y = L + (_$H = w) | 0) | 0, _$K = Y, _$AA = (Y = t + f | 0) >>> 0 < t >>> 0 ? IA : _$K, t = (L = Ig(f, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31))) + Y | 0, E[_ >> 2] = t, Y = w + _$AA | 0, L = t >>> 0 < L >>> 0 ? Y + 1 | 0 : Y, E[_ + 4 >> 2] = L, t = KI(t ^ F, L ^ BA, 48), E[_ + 904 >> 2] = t, F = w, E[_ + 908 >> 2] = F, _$K = 1 + (F = F + l | 0) | 0, Y = F, L = (F = Q + t | 0) >>> 0 < Q >>> 0 ? _$K : Y, t = (Q = Ig(t, 0, Q << 1 & -2, 1 & (l << 1 | Q >>> 31))) + F | 0, E[_ + 640 >> 2] = t, F = w + L | 0, Q = Q >>> 0 > t >>> 0 ? F + 1 | 0 : F, E[_ + 644 >> 2] = Q, rA = _, _$eA = KI(t ^ f, Q ^ _$H, 1), E[rA + 264 >> 2] = _$eA, E[_ + 268 >> 2] = w, t = KI(C ^ y, _$m ^ Z, 1), f = 1 + (C = _$z + (y = w) | 0) | 0, Q = C, Q = (C = i + t | 0) >>> 0 < i >>> 0 ? f : Q, C = C + (f = Ig(t, 0, i << 1 & -2, 1 & (_$z << 1 | i >>> 31))) | 0, i = w + Q | 0, Q = KI(r ^ O, q ^ CA, 48), i = KI(Q ^ C, (f = C >>> 0 < f >>> 0 ? i + 1 | 0 : i) ^ (_$z = w), 32), O = F = w, b = 1 + (r = _$d + b | 0) | 0, _$H = r, q = (r = _$B + J | 0) >>> 0 < _$B >>> 0 ? b : _$H, _$B = Ig(J, 0, _$B << 1 & -2, 1 & (_$d << 1 | _$B >>> 31)), J = w + q | 0, _$H = 1 + (_$B = (J = _$B >>> 0 > (r = _$B + r | 0) >>> 0 ? J + 1 | 0 : J) + F | 0) | 0, F = _$B, F = (_$B = i + r | 0) >>> 0 < r >>> 0 ? _$H : F, _$H = t, t = Ig(i, 0, r << 1 & -2, 1 & (J << 1 | r >>> 31)), F = w + F | 0, t = KI(_$H ^ (_$B = t + _$B | 0), y ^ (F = _$B >>> 0 < t >>> 0 ? F + 1 | 0 : F), 40), b = 1 + (_$d = f + (y = w) | 0) | 0, _$H = _$d, q = (_$d = C + t | 0) >>> 0 < C >>> 0 ? b : _$H, _$H = i, i = Ig(t, 0, C << 1 & -2, 1 & (f << 1 | C >>> 31)), f = w + q | 0, i = KI(_$H ^ (C = i + _$d | 0), O ^ (f = C >>> 0 < i >>> 0 ? f + 1 | 0 : f), 48), E[_ + 768 >> 2] = i, _$d = w, E[_ + 772 >> 2] = _$d, E[_ + 8 >> 2] = C, E[_ + 12 >> 2] = f, _$H = 1 + (C = F + _$d | 0) | 0, f = C, f = (C = _$B + i | 0) >>> 0 < _$B >>> 0 ? _$H : f, _$B = Ig(i, 0, _$B << 1 & -2, 1 & (F << 1 | _$B >>> 31)), i = w + f | 0, rA = _, _$eA = KI((C = _$B + C | 0) ^ t, y ^ (_$B = C >>> 0 < _$B >>> 0 ? i + 1 | 0 : i), 1), E[rA + 384 >> 2] = _$eA, E[_ + 388 >> 2] = w, E[_ + 648 >> 2] = C, E[_ + 652 >> 2] = _$B, _$B = KI(r ^ _$U, J ^ v, 1), i = 1 + (r = x + (_$U = w) | 0) | 0, C = r, i = (r = _$B + o | 0) >>> 0 < o >>> 0 ? i : C, C = r, r = Ig(_$B, 0, o << 1 & -2, 1 & (x << 1 | o >>> 31)), i = w + i | 0, i = KI((C = C + r | 0) ^ k, _$gA ^ (t = C >>> 0 < r >>> 0 ? i + 1 | 0 : i), 32), J = o = w, f = 1 + (r = _$z + V | 0) | 0, y = r, k = (r = Q + s | 0) >>> 0 < s >>> 0 ? f : y, s = Ig(Q, 0, s << 1 & -2, 1 & (V << 1 | s >>> 31)), Q = w + k | 0, y = 1 + (s = (Q = (r = s + r | 0) >>> 0 < s >>> 0 ? Q + 1 | 0 : Q) + o | 0) | 0, o = s, o = (s = i + r | 0) >>> 0 < r >>> 0 ? y : o, y = _$B, _$B = s, s = Ig(i, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), o = w + o | 0, s = KI(y ^ (_$B = _$B + s | 0), _$U ^ (o = _$B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), f = 1 + (k = t + (_$U = w) | 0) | 0, y = k, f = (k = C + s | 0) >>> 0 < C >>> 0 ? f : y, C = (t = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31))) + k | 0, E[_ + 128 >> 2] = C, k = w + f | 0, t = C >>> 0 < t >>> 0 ? k + 1 | 0 : k, E[_ + 132 >> 2] = t, C = KI(C ^ i, t ^ J, 48), E[_ + 776 >> 2] = C, i = w, E[_ + 780 >> 2] = i, y = 1 + (i = i + o | 0) | 0, t = i, t = (i = C + _$B | 0) >>> 0 < _$B >>> 0 ? y : t, _$B = (C = Ig(C, 0, _$B << 1 & -2, 1 & (o << 1 | _$B >>> 31))) + i | 0, i = w + t | 0, o = C = C >>> 0 > _$B >>> 0 ? i + 1 | 0 : i, E[_ + 512 >> 2] = _$B, E[_ + 516 >> 2] = C, i = (C = KI(r ^ S, Q ^ $, 1)) + n | 0, t = (J = w) + R | 0, r = (Q = Ig(n << 1 & -2, 1 & (R << 1 | n >>> 31), C, 0)) + i | 0, i = w + (C >>> 0 > i >>> 0 ? t + 1 | 0 : t) | 0, i = KI(r ^ M, _$W ^ (t = Q >>> 0 > r >>> 0 ? i + 1 | 0 : i), 32), f = 1 + (Q = j + (n = w) | 0) | 0, y = Q, k = (Q = i + e | 0) >>> 0 < e >>> 0 ? f : y, y = C, C = (e = Ig(i, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) + Q | 0, Q = w + k | 0, e = KI(y ^ C, J ^ (Q = C >>> 0 < e >>> 0 ? Q + 1 | 0 : Q), 40), f = 1 + (k = t + (J = w) | 0) | 0, y = k, f = (k = r + e | 0) >>> 0 < r >>> 0 ? f : y, y = i, r = Ig(e, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), t = w + f | 0, r = KI(y ^ (i = r + k | 0), n ^ (t = i >>> 0 < r >>> 0 ? t + 1 | 0 : t), 48), f = 1 + (k = Q + (n = w) | 0) | 0, y = k, f = (k = C + r | 0) >>> 0 < C >>> 0 ? f : y, C = (Q = Ig(r, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31))) + k | 0, E[_ + 520 >> 2] = C, k = w + f | 0, Q = C >>> 0 < Q >>> 0 ? k + 1 | 0 : k, E[_ + 524 >> 2] = Q, E[_ + 896 >> 2] = r, E[_ + 900 >> 2] = n, E[_ + 136 >> 2] = i, E[_ + 140 >> 2] = t, rA = _, _$eA = KI(_$B ^ s, o ^ _$U, 1), E[rA + 392 >> 2] = _$eA, E[_ + 396 >> 2] = w, rA = _, _$eA = KI(C ^ e, Q ^ J, 1), E[rA + 256 >> 2] = _$eA, E[_ + 260 >> 2] = w, 8 != (0 | (_$N = _$N + 1 | 0)););
                                                    for(_ = Sg(aA, g + 2048 | 0, 1024), r = 0; i = E[(C = (_$N = r << 3) + _ | 0) >> 2], s = E[(e = (_$B = g + 3072 | 0) + _$N | 0) >> 2], e = E[C + 4 >> 2] ^ E[e + 4 >> 2], E[C >> 2] = i ^ s, E[C + 4 >> 2] = e, e = E[(C = (i = 8 | _$N) + _ | 0) >> 2], s = E[(i = _$B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, e = E[(C = (i = 16 | _$N) + _ | 0) >> 2], s = E[(i = _$B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, i = E[(_$N = (C = 24 | _$N) + _ | 0) >> 2], _$B = E[(C = C + _$B | 0) >> 2], C = E[_$N + 4 >> 2] ^ E[C + 4 >> 2], E[_$N >> 2] = _$B ^ i, E[_$N + 4 >> 2] = C, 128 != (0 | (r = r + 4 | 0)););
                                                }
                                                if (r = oA + 1 | 0, P = P + 1 | 0, !((_$N = E[A + 20 >> 2]) >>> 0 > (u = u + 1 | 0) >>> 0)) break;
                                            }
                                        }
                                        h = g + 4096 | 0;
                                    }
                                    function G(A, I, g) {
                                        var C, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0;
                                        for(h = o = h - 2048 | 0, Sg(o + 1024 | 0, I, 1024), I = 0; Q = E[(_ = (i = o + 1024 | 0) + (_$B = I << 3) | 0) >> 2], a = E[(c = A + _$B | 0) >> 2], c = E[_ + 4 >> 2] ^ E[c + 4 >> 2], E[_ >> 2] = Q ^ a, E[_ + 4 >> 2] = c, c = E[(_ = (Q = 8 | _$B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, c = E[(_ = (Q = 16 | _$B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, Q = E[(_$B = (_ = 24 | _$B) + i | 0) >> 2], c = E[(_ = A + _ | 0) >> 2], _ = E[_$B + 4 >> 2] ^ E[_ + 4 >> 2], E[_$B >> 2] = Q ^ c, E[_$B + 4 >> 2] = _, 128 != (0 | (I = I + 4 | 0)););
                                        for(C = Sg(o, i, 1024), A = 0, I = 0; o = E[(_$B = (i = I << 3) + C | 0) >> 2], Q = E[(_ = g + i | 0) >> 2], _ = E[_$B + 4 >> 2] ^ E[_ + 4 >> 2], E[_$B >> 2] = Q ^ o, E[_$B + 4 >> 2] = _, _ = E[(_$B = (o = 8 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[_$B + 4 >> 2] ^ E[o + 4 >> 2], E[_$B >> 2] = Q ^ _, E[_$B + 4 >> 2] = o, _ = E[(_$B = (o = 16 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[_$B + 4 >> 2] ^ E[o + 4 >> 2], E[_$B >> 2] = Q ^ _, E[_$B + 4 >> 2] = o, o = E[(i = (_$B = 24 | i) + C | 0) >> 2], _ = E[(_$B = g + _$B | 0) >> 2], _$B = E[i + 4 >> 2] ^ E[_$B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = _$B, 128 != (0 | (I = I + 4 | 0)););
                                        for(; c = (Q = E[56 + (i = (C + 1024 | 0) + (A << 7) | 0) >> 2]) + (_$B = E[i + 24 >> 2]) | 0, I = (t = E[i + 60 >> 2]) + (o = E[i + 28 >> 2]) | 0, _ = _$B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(_$B << 1 & -2, 1 & (o << 1 | _$B >>> 31), Q, 0), I = w + _ | 0, _ = (_$B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 120 >> 2] ^ _$B, _ ^ E[i + 124 >> 2], 32)) + (o = E[i + 88 >> 2]) | 0, I = (y = w) + (a = E[i + 92 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (_$z = w) | 0, Q = (a = _$B + x | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(x, 0, _$B << 1 & -2, 1 & (_ << 1 | _$B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = _$B + a | 0), y ^ (_$H = _$B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), j = I = w, p = Y, e = I, a = (c = E[i + 40 >> 2]) + (_$B = E[i + 8 >> 2]) | 0, I = (_$d = E[i + 44 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = _$B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(_$B << 1 & -2, 1 & (_ << 1 | _$B >>> 31), c, 0), I = w + Q | 0, Q = (_$B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 104 >> 2] ^ _$B, Q ^ E[i + 108 >> 2], 32)) + (_ = E[i + 72 >> 2]) | 0, I = (f = w) + (r = E[i + 76 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, _$d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = _$B + r | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31)), I = w + t | 0, R = KI((_$B = Q + y | 0) ^ a, f ^ (y = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (v = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (_$d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), L = I = w, k = M, t = I, f = (r = E[i + 32 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 36 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (_$U = KI(E[i + 96 >> 2] ^ Q, a ^ E[i + 100 >> 2], 32)) + (c = E[(I = _$N = i - -64 | 0) >> 2]) | 0, I = (q = w) + (f = E[I + 4 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), _$U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (_$X = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), P = I = w, S = I, k = (p = E[i + 48 >> 2]) + (r = E[i + 16 >> 2]) | 0, I = (_$m = E[i + 52 >> 2]) + (e = E[i + 20 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = (k = KI(E[i + 112 >> 2] ^ r, t ^ E[i + 116 >> 2], 32)) + (e = E[i + 80 >> 2]) | 0, I = (u = w) + (b = E[i + 84 >> 2]) | 0, _$K = e >>> 0 > G >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + _$K | 0, b = KI(G = (e = b + G | 0) ^ p, _$m ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (_$m = w) | 0, _$K = (G = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + _$K | 0, _$K = KI(G = (r = t + G | 0) ^ k, u ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (u = w) | 0, t = (G = e + _$K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(_$K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + G | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = G + t | 0) ^ M, L ^ (M = t >>> 0 < G >>> 0 ? I + 1 | 0 : I), 40), I = D + (L = w) | 0, G = (O = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + O | 0, I = w + G | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ P, 48), E[i + 120 >> 2] = a, I = w, E[i + 124 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 80 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 84 >> 2] = I, V = i, Z = KI(a ^ S, I ^ L, 1), E[V + 40 >> 2] = Z, E[i + 44 >> 2] = w, I = s + j | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ _$m, 1), I = y + (p = w) | 0, s = (D = _$B + e | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (y = Ig(e, 0, _$B << 1 & -2, 1 & (y << 1 | _$B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ _$U, n ^ q, 48), y = KI(n ^ _$B, (Q = _$B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(S = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (_$U = _$B + s | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(s, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31)), I = w + p | 0, _$B = KI((Q = _$B + _$U | 0) ^ y, Y ^ (I = _$B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 96 >> 2] = _$B, y = w, E[i + 100 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = _$B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(_$B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((_$B = o + y | 0) ^ s, (I = _$B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 48 >> 2] = Z, E[i + 52 >> 2] = w, E[i + 88 >> 2] = _$B, E[i + 92 >> 2] = I, e = KI(t ^ x, a ^ _$z, 1), I = k + (s = w) | 0, o = (_$B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((_$B = Q + _$B | 0) ^ R, v ^ (a = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = _$B + e | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (a = Ig(e, 0, _$B << 1 & -2, 1 & (a << 1 | _$B >>> 31))) + n | 0, I = w + s | 0, E[i + 16 >> 2] = _$B, I = _$B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 20 >> 2] = I, _$B = KI(_$B ^ t, I ^ y, 48), E[i + 104 >> 2] = _$B, I = w, E[i + 108 >> 2] = I, a = _$N, I = I + r | 0, t = (s = _$B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(_$B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + t | 0, r = _$B = Q + s | 0, t = I = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[a >> 2] = _$B, E[a + 4 >> 2] = I, c = KI(o ^ J, c ^ _$X, 1), I = (y = w) + _$H | 0, o = (_$B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (_$H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((_$B = Q + _$B | 0) ^ _$K, u ^ (Q = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = _$d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (_$d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (_$H = w) | 0, s = (y = _$B + c | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31)), I = w + s | 0, I = (_$B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = _$B, _$B ^= a, a = I, _$B = KI(_$B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = _$B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(_$B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 72 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 76 >> 2] = I, E[i + 112 >> 2] = _$B, E[i + 116 >> 2] = F, E[i + 24 >> 2] = Q, E[i + 28 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 56 >> 2] = Z, E[i + 60 >> 2] = w, V = i, Z = KI(o ^ c, I ^ _$H, 1), E[V + 32 >> 2] = Z, E[i + 36 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(A = 0; c = (Q = E[392 + (i = (C + 1024 | 0) + (A << 4) | 0) >> 2]) + (_$B = E[i + 136 >> 2]) | 0, I = (t = E[i + 396 >> 2]) + (o = E[i + 140 >> 2]) | 0, _ = _$B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(_$B << 1 & -2, 1 & (o << 1 | _$B >>> 31), Q, 0), I = w + _ | 0, _ = (_$B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 904 >> 2] ^ _$B, _ ^ E[i + 908 >> 2], 32)) + (o = E[i + 648 >> 2]) | 0, I = (y = w) + (a = E[i + 652 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (G = w) | 0, Q = (a = _$B + x | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(x, 0, _$B << 1 & -2, 1 & (_ << 1 | _$B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = _$B + a | 0), y ^ (_$H = _$B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), _$z = I = w, p = Y, e = I, a = (c = E[i + 264 >> 2]) + (_$B = E[i + 8 >> 2]) | 0, I = (_$d = E[i + 268 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = _$B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(_$B << 1 & -2, 1 & (_ << 1 | _$B >>> 31), c, 0), I = w + Q | 0, Q = (_$B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 776 >> 2] ^ _$B, Q ^ E[i + 780 >> 2], 32)) + (_ = E[i + 520 >> 2]) | 0, I = (f = w) + (r = E[i + 524 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, _$d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = _$B + r | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31)), I = w + t | 0, R = KI((_$B = Q + y | 0) ^ a, f ^ (y = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (j = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (_$d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), v = I = w, k = M, t = I, f = (r = E[i + 256 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 260 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (_$U = KI(E[i + 768 >> 2] ^ Q, a ^ E[i + 772 >> 2], 32)) + (c = E[i + 512 >> 2]) | 0, I = (L = w) + (f = E[i + 516 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), _$U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (q = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), _$X = I = w, S = I, k = (p = E[i + 384 >> 2]) + (r = E[i + 128 >> 2]) | 0, I = (P = E[i + 388 >> 2]) + (e = E[i + 132 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, _$N = (k = KI(E[i + 896 >> 2] ^ r, t ^ E[i + 900 >> 2], 32)) + (e = E[i + 640 >> 2]) | 0, I = (_$m = w) + (b = E[i + 644 >> 2]) | 0, _$K = e >>> 0 > _$N >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + _$K | 0, b = KI(_$N = (e = b + _$N | 0) ^ p, P ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (P = w) | 0, _$K = (_$N = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + _$K | 0, _$K = KI(_$N = (r = t + _$N | 0) ^ k, _$m ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (_$m = w) | 0, t = (_$N = e + _$K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(_$K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + _$N | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, _$N = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = _$N + t | 0) ^ M, v ^ (M = t >>> 0 < _$N >>> 0 ? I + 1 | 0 : I), 40), I = D + (v = w) | 0, _$N = (u = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + u | 0, I = w + _$N | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ _$X, 48), E[i + 904 >> 2] = a, I = w, E[i + 908 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 640 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 644 >> 2] = I, V = i, Z = KI(a ^ S, I ^ v, 1), E[V + 264 >> 2] = Z, E[i + 268 >> 2] = w, I = s + _$z | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ P, 1), I = y + (p = w) | 0, s = (D = _$B + e | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (y = Ig(e, 0, _$B << 1 & -2, 1 & (y << 1 | _$B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ _$U, n ^ L, 48), y = KI(n ^ _$B, (Q = _$B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(_$N = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (_$U = _$B + s | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(s, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31)), I = w + p | 0, _$B = KI((Q = _$B + _$U | 0) ^ y, Y ^ (I = _$B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 768 >> 2] = _$B, y = w, E[i + 772 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = _$B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(_$B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((_$B = o + y | 0) ^ s, (I = _$B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 384 >> 2] = Z, E[i + 388 >> 2] = w, E[i + 648 >> 2] = _$B, E[i + 652 >> 2] = I, e = KI(t ^ x, a ^ G, 1), I = k + (s = w) | 0, o = (_$B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((_$B = Q + _$B | 0) ^ R, j ^ (a = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = _$B + e | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (a = Ig(e, 0, _$B << 1 & -2, 1 & (a << 1 | _$B >>> 31))) + n | 0, I = w + s | 0, E[i + 128 >> 2] = _$B, I = _$B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 132 >> 2] = I, _$B = KI(_$B ^ t, I ^ y, 48), E[i + 776 >> 2] = _$B, I = w, E[i + 780 >> 2] = I, I = I + r | 0, a = (t = _$B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(_$B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + a | 0, r = _$B = Q + t | 0, t = I = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[i + 512 >> 2] = _$B, E[i + 516 >> 2] = I, c = KI(o ^ J, c ^ q, 1), I = (y = w) + _$H | 0, o = (_$B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (_$H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((_$B = Q + _$B | 0) ^ _$K, _$m ^ (Q = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = _$d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (_$d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (_$H = w) | 0, s = (y = _$B + c | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, _$B << 1 & -2, 1 & (Q << 1 | _$B >>> 31)), I = w + s | 0, I = (_$B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = _$B, _$B ^= a, a = I, _$B = KI(_$B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = _$B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(_$B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 520 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 524 >> 2] = I, E[i + 896 >> 2] = _$B, E[i + 900 >> 2] = F, E[i + 136 >> 2] = Q, E[i + 140 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 392 >> 2] = Z, E[i + 396 >> 2] = w, V = i, Z = KI(o ^ c, I ^ _$H, 1), E[V + 256 >> 2] = Z, E[i + 260 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(I = Sg(g, C, 1024), A = 0; _$B = E[(i = (g = A << 3) + I | 0) >> 2], Q = E[(_ = (o = a = C + 1024 | 0) + g | 0) >> 2], _ = E[i + 4 >> 2] ^ E[_ + 4 >> 2], E[i >> 2] = _$B ^ Q, E[i + 4 >> 2] = _, _ = E[(i = (_$B = 8 | g) + I | 0) >> 2], o = E[(_$B = _$B + o | 0) >> 2], _$B = E[i + 4 >> 2] ^ E[_$B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = _$B, o = E[(i = (_$B = 16 | g) + I | 0) >> 2], _ = E[(_$B = _$B + a | 0) >> 2], _$B = E[i + 4 >> 2] ^ E[_$B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = _$B, _$B = E[(g = (i = 24 | g) + I | 0) >> 2], o = E[(i = i + a | 0) >> 2], i = E[g + 4 >> 2] ^ E[i + 4 >> 2], E[g >> 2] = _$B ^ o, E[g + 4 >> 2] = i, 128 != (0 | (A = A + 4 | 0)););
                                        h = C + 2048 | 0;
                                    }
                                    function M(A, I, g) {
                                        var C, _$B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0;
                                        for(h = C = h - 800 | 0, k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, _$N = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, f = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, b = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, _$K = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Q = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, i = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, _ = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, c = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, t = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, r = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g - -64 | 0, e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I >> 2] = 33620224 ^ e, E[g + 56 >> 2] = 1496785429, E[g + 60 >> 2] = 1652156816, E[(A = g + 48 | 0) >> 2] = 33620224, E[A + 4 >> 2] = 218629379, E[g + 40 >> 2] = 1110511904, E[g + 44 >> 2] = -584534669, E[(_$B = g + 32 | 0) >> 2] = 1427652059, E[_$B + 4 >> 2] = -248528275, y = n ^ e, E[g >> 2] = y, E[g + 92 >> 2] = -584534669 ^ r, E[g + 88 >> 2] = 1110511904 ^ t, E[g + 84 >> 2] = -248528275 ^ c, E[(n = g + 80 | 0) >> 2] = 1427652059 ^ _, E[g + 76 >> 2] = 1652156816 ^ o, E[g + 72 >> 2] = 1496785429 ^ i, E[g + 68 >> 2] = 218629379 ^ Q, _$K ^= r, E[g + 28 >> 2] = _$K, b ^= t, E[g + 24 >> 2] = b, s = f ^ c, E[g + 20 >> 2] = s, M ^= _, E[(f = g + 16 | 0) >> 2] = M, G ^= o, E[g + 12 >> 2] = G, D = _$N ^ i, E[g + 8 >> 2] = D, p = k ^ Q, E[g + 4 >> 2] = p, _$N = 0; k = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = k, k = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = k, k = E[I + 12 >> 2], E[C + 760 >> 2] = E[I + 8 >> 2], E[C + 764 >> 2] = k, k = E[I + 4 >> 2], E[C + 752 >> 2] = E[I >> 2], E[C + 756 >> 2] = k, k = E[n + 12 >> 2], E[C + 744 >> 2] = E[n + 8 >> 2], E[C + 748 >> 2] = k, k = E[n + 4 >> 2], E[C + 736 >> 2] = E[n >> 2], E[C + 740 >> 2] = k, $A(k = C + 768 | 0, C + 752 | 0, C + 736 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 728 >> 2] = E[A + 8 >> 2], E[C + 732 >> 2] = w, w = E[A + 4 >> 2], E[C + 720 >> 2] = E[A >> 2], E[C + 724 >> 2] = w, w = E[I + 12 >> 2], E[C + 712 >> 2] = E[I + 8 >> 2], E[C + 716 >> 2] = w, w = E[I + 4 >> 2], E[C + 704 >> 2] = E[I >> 2], E[C + 708 >> 2] = w, $A(k, C + 720 | 0, C + 704 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 696 >> 2] = E[_$B + 8 >> 2], E[C + 700 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 688 >> 2] = E[_$B >> 2], E[C + 692 >> 2] = w, w = E[A + 12 >> 2], E[C + 680 >> 2] = E[A + 8 >> 2], E[C + 684 >> 2] = w, w = E[A + 4 >> 2], E[C + 672 >> 2] = E[A >> 2], E[C + 676 >> 2] = w, $A(k, C + 688 | 0, C + 672 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 664 >> 2] = E[f + 8 >> 2], E[C + 668 >> 2] = w, w = E[f + 4 >> 2], E[C + 656 >> 2] = E[f >> 2], E[C + 660 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 648 >> 2] = E[_$B + 8 >> 2], E[C + 652 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 640 >> 2] = E[_$B >> 2], E[C + 644 >> 2] = w, $A(k, C + 656 | 0, C + 640 | 0), w = E[C + 780 >> 2], E[_$B + 8 >> 2] = E[C + 776 >> 2], E[_$B + 12 >> 2] = w, w = E[C + 772 >> 2], E[_$B >> 2] = E[C + 768 >> 2], E[_$B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 632 >> 2] = E[g + 8 >> 2], E[C + 636 >> 2] = w, w = E[g + 4 >> 2], E[C + 624 >> 2] = E[g >> 2], E[C + 628 >> 2] = w, w = E[f + 12 >> 2], E[C + 616 >> 2] = E[f + 8 >> 2], E[C + 620 >> 2] = w, w = E[f + 4 >> 2], E[C + 608 >> 2] = E[f >> 2], E[C + 612 >> 2] = w, $A(k, C + 624 | 0, C + 608 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 600 >> 2] = E[C + 792 >> 2], E[C + 604 >> 2] = w, w = E[C + 788 >> 2], E[C + 592 >> 2] = E[C + 784 >> 2], E[C + 596 >> 2] = w, w = E[g + 12 >> 2], E[C + 584 >> 2] = E[g + 8 >> 2], E[C + 588 >> 2] = w, w = E[g + 4 >> 2], E[C + 576 >> 2] = E[g >> 2], E[C + 580 >> 2] = w, $A(k, C + 592 | 0, C + 576 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ o, E[g + 8 >> 2] = S ^ i, E[g + 4 >> 2] = F ^ Q, E[g >> 2] = w ^ e, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 568 >> 2] = E[I + 8 >> 2], E[C + 572 >> 2] = w, w = E[I + 4 >> 2], E[C + 560 >> 2] = E[I >> 2], E[C + 564 >> 2] = w, w = E[n + 12 >> 2], E[C + 552 >> 2] = E[n + 8 >> 2], E[C + 556 >> 2] = w, w = E[n + 4 >> 2], E[C + 544 >> 2] = E[n >> 2], E[C + 548 >> 2] = w, $A(k, C + 560 | 0, C + 544 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 536 >> 2] = E[A + 8 >> 2], E[C + 540 >> 2] = w, w = E[A + 4 >> 2], E[C + 528 >> 2] = E[A >> 2], E[C + 532 >> 2] = w, w = E[I + 12 >> 2], E[C + 520 >> 2] = E[I + 8 >> 2], E[C + 524 >> 2] = w, w = E[I + 4 >> 2], E[C + 512 >> 2] = E[I >> 2], E[C + 516 >> 2] = w, $A(k, C + 528 | 0, C + 512 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 504 >> 2] = E[_$B + 8 >> 2], E[C + 508 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 496 >> 2] = E[_$B >> 2], E[C + 500 >> 2] = w, w = E[A + 12 >> 2], E[C + 488 >> 2] = E[A + 8 >> 2], E[C + 492 >> 2] = w, w = E[A + 4 >> 2], E[C + 480 >> 2] = E[A >> 2], E[C + 484 >> 2] = w, $A(k, C + 496 | 0, C + 480 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 472 >> 2] = E[f + 8 >> 2], E[C + 476 >> 2] = w, w = E[f + 4 >> 2], E[C + 464 >> 2] = E[f >> 2], E[C + 468 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 456 >> 2] = E[_$B + 8 >> 2], E[C + 460 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 448 >> 2] = E[_$B >> 2], E[C + 452 >> 2] = w, $A(k, C + 464 | 0, C + 448 | 0), w = E[C + 780 >> 2], E[_$B + 8 >> 2] = E[C + 776 >> 2], E[_$B + 12 >> 2] = w, w = E[C + 772 >> 2], E[_$B >> 2] = E[C + 768 >> 2], E[_$B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 440 >> 2] = E[g + 8 >> 2], E[C + 444 >> 2] = w, w = E[g + 4 >> 2], E[C + 432 >> 2] = E[g >> 2], E[C + 436 >> 2] = w, w = E[f + 12 >> 2], E[C + 424 >> 2] = E[f + 8 >> 2], E[C + 428 >> 2] = w, w = E[f + 4 >> 2], E[C + 416 >> 2] = E[f >> 2], E[C + 420 >> 2] = w, $A(k, C + 432 | 0, C + 416 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 408 >> 2] = E[C + 792 >> 2], E[C + 412 >> 2] = w, w = E[C + 788 >> 2], E[C + 400 >> 2] = E[C + 784 >> 2], E[C + 404 >> 2] = w, w = E[g + 12 >> 2], E[C + 392 >> 2] = E[g + 8 >> 2], E[C + 396 >> 2] = w, w = E[g + 4 >> 2], E[C + 384 >> 2] = E[g >> 2], E[C + 388 >> 2] = w, $A(k, C + 400 | 0, C + 384 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ r, E[g + 8 >> 2] = S ^ t, E[g + 4 >> 2] = F ^ c, E[g >> 2] = w ^ _, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 376 >> 2] = E[I + 8 >> 2], E[C + 380 >> 2] = w, w = E[I + 4 >> 2], E[C + 368 >> 2] = E[I >> 2], E[C + 372 >> 2] = w, w = E[n + 12 >> 2], E[C + 360 >> 2] = E[n + 8 >> 2], E[C + 364 >> 2] = w, w = E[n + 4 >> 2], E[C + 352 >> 2] = E[n >> 2], E[C + 356 >> 2] = w, $A(k, C + 368 | 0, C + 352 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 344 >> 2] = E[A + 8 >> 2], E[C + 348 >> 2] = w, w = E[A + 4 >> 2], E[C + 336 >> 2] = E[A >> 2], E[C + 340 >> 2] = w, w = E[I + 12 >> 2], E[C + 328 >> 2] = E[I + 8 >> 2], E[C + 332 >> 2] = w, w = E[I + 4 >> 2], E[C + 320 >> 2] = E[I >> 2], E[C + 324 >> 2] = w, $A(k, C + 336 | 0, C + 320 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 312 >> 2] = E[_$B + 8 >> 2], E[C + 316 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 304 >> 2] = E[_$B >> 2], E[C + 308 >> 2] = w, w = E[A + 12 >> 2], E[C + 296 >> 2] = E[A + 8 >> 2], E[C + 300 >> 2] = w, w = E[A + 4 >> 2], E[C + 288 >> 2] = E[A >> 2], E[C + 292 >> 2] = w, $A(k, C + 304 | 0, C + 288 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 280 >> 2] = E[f + 8 >> 2], E[C + 284 >> 2] = w, w = E[f + 4 >> 2], E[C + 272 >> 2] = E[f >> 2], E[C + 276 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 264 >> 2] = E[_$B + 8 >> 2], E[C + 268 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 256 >> 2] = E[_$B >> 2], E[C + 260 >> 2] = w, $A(k, C + 272 | 0, C + 256 | 0), w = E[C + 780 >> 2], E[_$B + 8 >> 2] = E[C + 776 >> 2], E[_$B + 12 >> 2] = w, w = E[C + 772 >> 2], E[_$B >> 2] = E[C + 768 >> 2], E[_$B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 248 >> 2] = E[g + 8 >> 2], E[C + 252 >> 2] = w, w = E[g + 4 >> 2], E[C + 240 >> 2] = E[g >> 2], E[C + 244 >> 2] = w, w = E[f + 12 >> 2], E[C + 232 >> 2] = E[f + 8 >> 2], E[C + 236 >> 2] = w, w = E[f + 4 >> 2], E[C + 224 >> 2] = E[f >> 2], E[C + 228 >> 2] = w, $A(k, C + 240 | 0, C + 224 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 216 >> 2] = E[C + 792 >> 2], E[C + 220 >> 2] = w, w = E[C + 788 >> 2], E[C + 208 >> 2] = E[C + 784 >> 2], E[C + 212 >> 2] = w, w = E[g + 12 >> 2], E[C + 200 >> 2] = E[g + 8 >> 2], E[C + 204 >> 2] = w, w = E[g + 4 >> 2], E[C + 192 >> 2] = E[g >> 2], E[C + 196 >> 2] = w, $A(k, C + 208 | 0, C + 192 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = G ^ E[C + 780 >> 2], E[g + 8 >> 2] = S ^ D, E[g + 4 >> 2] = F ^ p, E[g >> 2] = w ^ y, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 184 >> 2] = E[I + 8 >> 2], E[C + 188 >> 2] = w, w = E[I + 4 >> 2], E[C + 176 >> 2] = E[I >> 2], E[C + 180 >> 2] = w, w = E[n + 12 >> 2], E[C + 168 >> 2] = E[n + 8 >> 2], E[C + 172 >> 2] = w, w = E[n + 4 >> 2], E[C + 160 >> 2] = E[n >> 2], E[C + 164 >> 2] = w, $A(k, C + 176 | 0, C + 160 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 152 >> 2] = E[A + 8 >> 2], E[C + 156 >> 2] = w, w = E[A + 4 >> 2], E[C + 144 >> 2] = E[A >> 2], E[C + 148 >> 2] = w, w = E[I + 12 >> 2], E[C + 136 >> 2] = E[I + 8 >> 2], E[C + 140 >> 2] = w, w = E[I + 4 >> 2], E[C + 128 >> 2] = E[I >> 2], E[C + 132 >> 2] = w, $A(k, C + 144 | 0, C + 128 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 120 >> 2] = E[_$B + 8 >> 2], E[C + 124 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 112 >> 2] = E[_$B >> 2], E[C + 116 >> 2] = w, w = E[A + 12 >> 2], E[C + 104 >> 2] = E[A + 8 >> 2], E[C + 108 >> 2] = w, w = E[A + 4 >> 2], E[C + 96 >> 2] = E[A >> 2], E[C + 100 >> 2] = w, $A(k, C + 112 | 0, C + 96 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 88 >> 2] = E[f + 8 >> 2], E[C + 92 >> 2] = w, w = E[f + 4 >> 2], E[C + 80 >> 2] = E[f >> 2], E[C + 84 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 72 >> 2] = E[_$B + 8 >> 2], E[C + 76 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 64 >> 2] = E[_$B >> 2], E[C + 68 >> 2] = w, $A(k, C + 80 | 0, C - -64 | 0), w = E[C + 780 >> 2], E[_$B + 8 >> 2] = E[C + 776 >> 2], E[_$B + 12 >> 2] = w, w = E[C + 772 >> 2], E[_$B >> 2] = E[C + 768 >> 2], E[_$B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[f + 12 >> 2], E[C + 40 >> 2] = E[f + 8 >> 2], E[C + 44 >> 2] = w, w = E[f + 4 >> 2], E[C + 32 >> 2] = E[f >> 2], E[C + 36 >> 2] = w, $A(k, C + 48 | 0, C + 32 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 24 >> 2] = E[C + 792 >> 2], E[C + 28 >> 2] = w, w = E[C + 788 >> 2], E[C + 16 >> 2] = E[C + 784 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(k, C + 16 | 0, C), k = E[C + 768 >> 2], w = E[C + 772 >> 2], F = E[C + 776 >> 2], E[g + 12 >> 2] = _$K ^ E[C + 780 >> 2], E[g + 8 >> 2] = F ^ b, E[g + 4 >> 2] = w ^ s, E[g >> 2] = k ^ M, 4 != (0 | (_$N = _$N + 1 | 0)););
                                        h = C + 800 | 0;
                                    }
                                    function b(A, I) {
                                        var g, C, _$B, i, _, c, t, r, e, s, D, p, f, n, k, F, _$N, S, G, M, b, _$K, _$H = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0;
                                        for(h = g = h - 48 | 0, J = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, _$d = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[A + 24 | 0] = _$d, o[A + 25 | 0] = _$d >>> 8, o[A + 26 | 0] = _$d >>> 16, o[A + 27 | 0] = _$d >>> 24, o[A + 28 | 0] = J, o[A + 29 | 0] = J >>> 8, o[A + 30 | 0] = J >>> 16, o[A + 31 | 0] = J >>> 24, J = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, _$d = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[0 | A] = _$d, o[A + 1 | 0] = _$d >>> 8, o[A + 2 | 0] = _$d >>> 16, o[A + 3 | 0] = _$d >>> 24, o[A + 4 | 0] = J, o[A + 5 | 0] = J >>> 8, o[A + 6 | 0] = J >>> 16, o[A + 7 | 0] = J >>> 24, J = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, _$d = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 16 | 0] = _$d, o[A + 17 | 0] = _$d >>> 8, o[A + 18 | 0] = _$d >>> 16, o[A + 19 | 0] = _$d >>> 24, o[A + 20 | 0] = J, o[A + 21 | 0] = J >>> 8, o[A + 22 | 0] = J >>> 16, o[A + 23 | 0] = J >>> 24, _$d = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, o[A + 12 | 0] = _$d, o[A + 13 | 0] = _$d >>> 8, o[A + 14 | 0] = _$d >>> 16, o[A + 15 | 0] = _$d >>> 24, I = a[A + 31 | 0], o[A + 31 | 0] = 127 & I, pA(g, A), s = 128 & I, h = I = h - 960 | 0, R(_$d = I + 304 | 0, g), E[I + 304 >> 2] = E[I + 304 >> 2] + 1, vA(_$d, _$d), J = Ig(_$d = E[I + 340 >> 2], _$d >> 31, 486662, 0), _$d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? _$d + 1 | 0 : _$d, L = J - (-33554432 & q) | 0, _$H = Ig(_$d = E[I + 336 >> 2], _$d >> 31, 486662, 0), J = w, _$U = Ig(_$d = E[I + 332 >> 2], _$d >> 31, 486662, 0), _$d = w, x = _$H, _$H = (_$H = (_$d = (_$m = _$U + 16777216 | 0) >>> 0 < 16777216 ? _$d + 1 | 0 : _$d) >> 25) + J | 0, _$d = (_$d = (33554431 & _$d) << 7 | _$m >>> 25) >>> 0 > (l = x + _$d | 0) >>> 0 ? _$H + 1 | 0 : _$H, C = ((67108863 & (_$d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? _$d + 1 | 0 : _$d)) << 6 | J >>> 26) + L | 0, E[I + 292 >> 2] = 0 - C, Z = l - (-67108864 & J) | 0, E[I + 288 >> 2] = 0 - Z, L = _$U - (-33554432 & _$m) | 0, J = Ig(_$d = E[I + 328 >> 2], _$d >> 31, 486662, 0), _$d = w, _$m = Ig(_$H = E[I + 324 >> 2], _$H >> 31, 486662, 0), _$H = w, x = J, _$d = _$d + (J = (_$H = (l = _$m + 16777216 | 0) >>> 0 < 16777216 ? _$H + 1 | 0 : _$H) >> 25) | 0, _$d = (_$H = x + (_$U = (33554431 & _$H) << 7 | l >>> 25) | 0) >>> 0 < _$U >>> 0 ? _$d + 1 | 0 : _$d, _$B = ((67108863 & (_$d = (J = _$H + 33554432 | 0) >>> 0 < 33554432 ? _$d + 1 | 0 : _$d)) << 6 | J >>> 26) + L | 0, E[I + 284 >> 2] = 0 - _$B, i = _$H - (-67108864 & J) | 0, E[I + 280 >> 2] = 0 - i, L = _$m - (-33554432 & l) | 0, _$H = Ig(_$d = E[I + 320 >> 2], _$d >> 31, 486662, 0), _$d = w, _$m = Ig(J = E[I + 316 >> 2], J >> 31, 486662, 0), J = w, x = _$H, _$d = (_$H = (J = (l = _$m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + _$d | 0, _$H = _$d = (J = x + (_$U = (33554431 & J) << 7 | l >>> 25) | 0) >>> 0 < _$U >>> 0 ? _$d + 1 | 0 : _$d, _ = ((67108863 & (_$H = (_$U = J + 33554432 | 0) >>> 0 < 33554432 ? _$H + 1 | 0 : _$H)) << 6 | _$U >>> 26) + L | 0, E[I + 276 >> 2] = 0 - _, c = J - (-67108864 & _$U) | 0, E[I + 272 >> 2] = 0 - c, x = _$m - (-33554432 & l) | 0, _$d = Ig(_$d = E[I + 312 >> 2], _$d >> 31, 486662, 0), L = w, _$U = Ig(J = E[I + 308 >> 2], J >> 31, 486662, 0), _$H = w, J = (33554431 & (_$H = (_$m = _$U + 16777216 | 0) >>> 0 < 16777216 ? _$H + 1 | 0 : _$H)) << 7 | _$m >>> 25, _$H = (_$H >> 25) + L | 0, J = J >>> 0 > (l = J + _$d | 0) >>> 0 ? _$H + 1 | 0 : _$H, t = ((67108863 & (J = (_$d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | _$d >>> 26) + x | 0, E[I + 268 >> 2] = 0 - t, r = l - (-67108864 & _$d) | 0, E[I + 264 >> 2] = 0 - r, l = _$U - (-33554432 & _$m) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), _$d = w, _$U = J, J = Ig(_$H = E[I + 304 >> 2], _$H >> 31, 486662, 0), _$d = w + _$d | 0, J = (_$H = _$U + J | 0) >>> 0 < J >>> 0 ? _$d + 1 | 0 : _$d, e = ((67108863 & (J = (_$d = _$H + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | _$d >>> 26) + l | 0, E[I + 260 >> 2] = 0 - e, P = _$H - (-67108864 & _$d) | 0, E[I + 256 >> 2] = 0 - P, v(J = I + 208 | 0, _$d = I + 256 | 0), Y(I + 160 | 0, _$d, J), D = E[I + 196 >> 2], p = E[I + 160 >> 2], _$z = E[I + 208 >> 2], f = E[I + 164 >> 2], n = E[I + 168 >> 2], j = E[I + 212 >> 2], _$X = E[I + 216 >> 2], k = E[I + 172 >> 2], F = E[I + 176 >> 2], O = E[I + 220 >> 2], V = E[I + 224 >> 2], _$N = E[I + 180 >> 2], S = E[I + 184 >> 2], x = E[I + 228 >> 2], L = E[I + 232 >> 2], G = E[I + 188 >> 2], M = E[I + 192 >> 2], J = Ig(_$d = E[I + 244 >> 2], _$d >> 31, 486662, 0), _$d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? _$d + 1 | 0 : _$d, b = J - (-33554432 & q) | 0, _$d = Ig(_$d = E[I + 240 >> 2], _$d >> 31, 486662, 0), _$K = w, _$U = Ig(J = E[I + 236 >> 2], J >> 31, 486662, 0), _$H = w, J = _$d, _$d = (33554431 & (_$H = (_$m = _$U + 16777216 | 0) >>> 0 < 16777216 ? _$H + 1 | 0 : _$H)) << 7 | _$m >>> 25, _$H = (_$H >> 25) + _$K | 0, _$d = _$d >>> 0 > (l = J + _$d | 0) >>> 0 ? _$H + 1 | 0 : _$H, _$H = ((67108863 & (_$d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? _$d + 1 | 0 : _$d)) << 6 | J >>> 26) + b | 0, E[I + 244 >> 2] = _$H, E[I + 388 >> 2] = _$H + (D - C | 0), _$d = l - (-67108864 & J) | 0, E[I + 240 >> 2] = _$d, E[I + 384 >> 2] = _$d + (M - Z | 0), Z = _$U - (-33554432 & _$m) | 0, _$d = Ig(L, L >> 31, 486662, 0), _$U = w, _$m = Ig(x, x >> 31, 486662, 0), J = w, x = _$d, _$d = (_$d = (J = (l = _$m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + _$U | 0, _$H = _$d = (_$H = (33554431 & J) << 7 | l >>> 25) >>> 0 > (J = x + _$H | 0) >>> 0 ? _$d + 1 | 0 : _$d, _$U = ((67108863 & (_$H = (_$U = J + 33554432 | 0) >>> 0 < 33554432 ? _$H + 1 | 0 : _$H)) << 6 | (_$d = _$U) >>> 26) + Z | 0, E[I + 236 >> 2] = _$U, E[I + 380 >> 2] = _$U + (G - _$B | 0), _$d = J - (-67108864 & _$d) | 0, E[I + 232 >> 2] = _$d, E[I + 376 >> 2] = _$d + (S - i | 0), L = _$m - (-33554432 & l) | 0, _$H = Ig(V, V >> 31, 486662, 0), J = w, _$U = Ig(O, O >> 31, 486662, 0), _$d = w, x = _$H, _$H = (_$H = (_$d = (_$m = _$U + 16777216 | 0) >>> 0 < 16777216 ? _$d + 1 | 0 : _$d) >> 25) + J | 0, J = (_$d = (33554431 & _$d) << 7 | _$m >>> 25) >>> 0 > (l = x + _$d | 0) >>> 0 ? _$H + 1 | 0 : _$H, _$H = ((67108863 & (J = (_$d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | _$d >>> 26) + L | 0, E[I + 228 >> 2] = _$H, E[I + 372 >> 2] = _$H + (_$N - _ | 0), _$d = l - (-67108864 & _$d) | 0, E[I + 224 >> 2] = _$d, E[I + 368 >> 2] = _$d + (F - c | 0), L = _$U - (-33554432 & _$m) | 0, _$d = Ig(_$X, _$X >> 31, 486662, 0), J = w, _$m = Ig(j, j >> 31, 486662, 0), _$H = w, x = _$d, J = (_$d = (_$H = (l = _$m + 16777216 | 0) >>> 0 < 16777216 ? _$H + 1 | 0 : _$H) >> 25) + J | 0, _$d = J = (_$H = x + (_$U = (33554431 & _$H) << 7 | l >>> 25) | 0) >>> 0 < _$U >>> 0 ? J + 1 | 0 : J, _$U = ((67108863 & (_$d = (_$U = _$H + 33554432 | 0) >>> 0 < 33554432 ? _$d + 1 | 0 : _$d)) << 6 | (J = _$U) >>> 26) + L | 0, E[I + 220 >> 2] = _$U, E[I + 364 >> 2] = _$U + (k - t | 0), _$d = _$H - (-67108864 & J) | 0, E[I + 216 >> 2] = _$d, E[I + 360 >> 2] = _$d + (n - r | 0), l = _$m - (-33554432 & l) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), _$d = w, _$H = J, J = Ig(_$z, _$z >> 31, 486662, 0), _$d = w + _$d | 0, _$d = (_$H = _$H + J | 0) >>> 0 < J >>> 0 ? _$d + 1 | 0 : _$d, u = ((67108863 & (_$d = (J = _$H + 33554432 | 0) >>> 0 < 33554432 ? _$d + 1 | 0 : _$d)) << 6 | J >>> 26) + l | 0, E[I + 212 >> 2] = u, E[I + 356 >> 2] = u + (f - e | 0), _$d = _$H - (-67108864 & J) | 0, E[I + 208 >> 2] = _$d, E[I + 352 >> 2] = _$d + (p - P | 0), Y(_$d = I + 624 | 0, J = I + 352 | 0, J), Y(I, J, _$d), v(J = I + 784 | 0, I), v(J, J), Y(_$d = I + 912 | 0, I, J), v(J = I + 576 | 0, _$d), v(J, J), v(J, J), v(J, J), Y(_$H = I + 528 | 0, _$d, J), v(_$H, _$H), v(_$H, _$H), Y(_$H, _$H, I), _$d = E[I + 564 >> 2], E[I + 512 >> 2] = E[I + 560 >> 2], E[I + 516 >> 2] = _$d, _$d = E[I + 556 >> 2], E[I + 504 >> 2] = E[I + 552 >> 2], E[I + 508 >> 2] = _$d, _$d = E[I + 548 >> 2], E[I + 496 >> 2] = E[I + 544 >> 2], E[I + 500 >> 2] = _$d, _$d = E[I + 540 >> 2], E[I + 488 >> 2] = E[I + 536 >> 2], E[I + 492 >> 2] = _$d, _$d = E[I + 532 >> 2], E[I + 480 >> 2] = E[I + 528 >> 2], E[I + 484 >> 2] = _$d, v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), Y(_$H, _$H, _$d = I + 480 | 0), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), Y(_$H, _$H, _$d), _$d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = _$d, _$d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = _$d, _$d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = _$d, _$d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = _$d, _$d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = _$d, v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), Y(_$H, _$H, J = I + 432 | 0), _$d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = _$d, _$d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = _$d, _$d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = _$d, _$d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = _$d, _$d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = _$d, v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), v(_$H, _$H), Y(_$H, _$H, J), _$d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = _$d, _$d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = _$d, _$d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = _$d, _$d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = _$d, _$d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = _$d; v(_$d = I + 528 | 0, _$d), 120 != (0 | (_$W = _$W + 1 | 0)););
                                        Y(_$d, _$d, I + 432 | 0), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), Y(_$d, _$d, I + 480 | 0), v(_$d, _$d), v(_$d, _$d), v(_$d, _$d), Y(_$d, _$d, I), v(_$d, _$d), BI(I + 400 | 0, _$d), _$z = E[I + 256 >> 2], j = E[I + 260 >> 2], _$X = E[I + 264 >> 2], O = E[I + 268 >> 2], V = E[I + 272 >> 2], l = E[I + 276 >> 2], u = E[I + 280 >> 2], _$H = E[I + 284 >> 2], J = E[I + 288 >> 2], x = (P = 0 - (1 & o[I + 401 | 0]) | 0) & (0 - (_$d = E[I + 292 >> 2]) ^ _$d) ^ _$d, E[I + 660 >> 2] = x, L = J ^ P & (J ^ 0 - J), E[I + 656 >> 2] = L, q = _$H ^ P & (_$H ^ 0 - _$H), E[I + 652 >> 2] = q, _$U = u ^ P & (u ^ 0 - u), E[I + 648 >> 2] = _$U, _$m = l ^ P & (l ^ 0 - l), E[I + 644 >> 2] = _$m, l = V ^ P & (V ^ 0 - V), E[I + 640 >> 2] = l, u = O ^ P & (O ^ 0 - O), E[I + 636 >> 2] = u, _$H = _$X ^ P & (_$X ^ 0 - _$X), E[I + 632 >> 2] = _$H, J = j ^ P & (j ^ 0 - j), E[I + 628 >> 2] = J, _$d = (_$z ^ P & (_$z ^ 0 - _$z)) - (486662 & P) | 0, E[I + 624 >> 2] = _$d + 1, E[I + 820 >> 2] = x, E[I + 816 >> 2] = L, E[I + 812 >> 2] = q, E[I + 808 >> 2] = _$U, E[I + 804 >> 2] = _$m, E[I + 800 >> 2] = l, E[I + 796 >> 2] = u, E[I + 792 >> 2] = _$H, E[I + 788 >> 2] = J, E[I + 784 >> 2] = _$d - 1, vA(I, I + 624 | 0), Y(_$d = I + 912 | 0, I + 784 | 0, I), BI(A, _$d), o[A + 31 | 0] = a[A + 31 | 0] | s, bA(I, A) && (y(), Q()), _$d = E[I + 36 >> 2], E[I + 816 >> 2] = E[I + 32 >> 2], E[I + 820 >> 2] = _$d, _$d = E[I + 28 >> 2], E[I + 808 >> 2] = E[I + 24 >> 2], E[I + 812 >> 2] = _$d, _$d = E[I + 20 >> 2], E[I + 800 >> 2] = E[I + 16 >> 2], E[I + 804 >> 2] = _$d, _$d = E[I + 12 >> 2], E[I + 792 >> 2] = E[I + 8 >> 2], E[I + 796 >> 2] = _$d, _$d = E[I + 52 >> 2], E[I + 832 >> 2] = E[I + 48 >> 2], E[I + 836 >> 2] = _$d, _$d = E[I + 60 >> 2], E[I + 840 >> 2] = E[I + 56 >> 2], E[I + 844 >> 2] = _$d, _$d = E[4 + (J = I - -64 | 0) >> 2], E[I + 848 >> 2] = E[J >> 2], E[I + 852 >> 2] = _$d, _$d = E[I + 76 >> 2], E[I + 856 >> 2] = E[I + 72 >> 2], E[I + 860 >> 2] = _$d, _$d = E[I + 4 >> 2], E[I + 784 >> 2] = E[I >> 2], E[I + 788 >> 2] = _$d, _$d = E[I + 44 >> 2], E[I + 824 >> 2] = E[I + 40 >> 2], E[I + 828 >> 2] = _$d, _$d = E[I + 116 >> 2], E[I + 896 >> 2] = E[I + 112 >> 2], E[I + 900 >> 2] = _$d, _$d = E[I + 108 >> 2], E[I + 888 >> 2] = E[I + 104 >> 2], E[I + 892 >> 2] = _$d, _$d = E[I + 100 >> 2], E[I + 880 >> 2] = E[I + 96 >> 2], E[I + 884 >> 2] = _$d, _$d = E[I + 92 >> 2], E[I + 872 >> 2] = E[I + 88 >> 2], E[I + 876 >> 2] = _$d, _$d = E[I + 84 >> 2], E[I + 864 >> 2] = E[I + 80 >> 2], E[I + 868 >> 2] = _$d, KA(_$U = I + 624 | 0, _$m = I + 784 | 0), Y(_$m, _$U, l = I + 744 | 0), Y(J = I + 824 | 0, _$H = I + 664 | 0, u = I + 704 | 0), Y(_$d = I + 864 | 0, u, l), KA(_$U, _$m), Y(_$m, _$U, l), Y(J, _$H, u), Y(_$d, u, l), KA(_$U, _$m), Y(I, _$U, l), Y(J = I + 40 | 0, _$H, u), Y(_$d = I + 80 | 0, u, l), Y(I + 120 | 0, _$U, _$H), vA(_$U, _$d), Y(_$m, I, _$U), Y(_$d = I + 912 | 0, J, _$U), BI(A, _$d), BI(I + 576 | 0, _$m), o[A + 31 | 0] = a[A + 31 | 0] ^ a[I + 576 | 0] << 7, h = I + 960 | 0, h = g + 48 | 0;
                                    }
                                    function K(A) {
                                        var _$I, g = 0, C = 0, _$B = 0, Q = 0, i = 0, o = 0, c = 0, r = 0, e = 0, y = 0, s = 0, D = 0;
                                        h = _$I = h - 16 | 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            r: {
                                                                                                if ((A |= 0) >>> 0 <= 244) {
                                                                                                    if (3 & (g = (o = E[9393]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                        g = 37612 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, _$B = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[_$B + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (s = 37572, D = Lg(-2, C) & o, E[s >> 2] = D), A = _$B + 8 | 0, g = C << 3, E[_$B + 4 >> 2] = 3 | g, E[4 + (g = g + _$B | 0) >> 2] = 1 | E[g + 4 >> 2];
                                                                                                        break A;
                                                                                                    }
                                                                                                    if ((y = E[9395]) >>> 0 >= c >>> 0) break r;
                                                                                                    if (g) {
                                                                                                        g = 37612 + (A = (_$B = FC((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[Q + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (o = Lg(-2, _$B) & o, E[9393] = o), E[Q + 4 >> 2] = 3 | c, _$B = (A = _$B << 3) - c | 0, E[4 + (C = Q + c | 0) >> 2] = 1 | _$B, E[A + Q >> 2] = _$B, y && (g = 37612 + (-8 & y) | 0, i = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = i, E[A + 12 >> 2] = i, E[i + 12 >> 2] = g, E[i + 8 >> 2] = A), A = Q + 8 | 0, E[9398] = C, E[9395] = _$B;
                                                                                                        break A;
                                                                                                    }
                                                                                                    if (!(e = E[9394])) break r;
                                                                                                    for(C = E[37876 + (FC(e) << 2) >> 2], i = (-8 & E[C + 4 >> 2]) - c | 0, g = C; (A = E[g + 16 >> 2]) || (A = E[g + 20 >> 2]);)i = (_$B = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = _$B ? A : C, g = A;
                                                                                                    if (r = E[C + 24 >> 2], (0 | (_$B = E[C + 12 >> 2])) != (0 | C)) {
                                                                                                        A = E[C + 8 >> 2], E[A + 12 >> 2] = _$B, E[_$B + 8 >> 2] = A;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (!(A = E[(g = C + 20 | 0) >> 2])) {
                                                                                                        if (!(A = E[C + 16 >> 2])) break t;
                                                                                                        g = C + 16 | 0;
                                                                                                    }
                                                                                                    for(; Q = g, _$B = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = _$B + 16 | 0, A = E[_$B + 16 >> 2]););
                                                                                                    E[Q >> 2] = 0;
                                                                                                    break I;
                                                                                                }
                                                                                                if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), e = E[9394])) {
                                                                                                    i = 0 - c | 0, o = 0, c >>> 0 < 256 || (o = 31, c >>> 0 > 16777215 || (o = 62 + ((c >>> 38 - (A = t(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            if (g = E[37876 + (o << 2) >> 2]) for(A = 0, C = c << (31 != (0 | o) ? 25 - (o >>> 1 | 0) | 0 : 0);;){
                                                                                                                if (!((Q = (-8 & E[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (_$B = g, i = Q, Q))) {
                                                                                                                    i = 0, A = g;
                                                                                                                    break y;
                                                                                                                }
                                                                                                                if (Q = E[g + 20 >> 2], g = E[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                            }
                                                                                                            else A = 0;
                                                                                                            if (!(A | _$B)) {
                                                                                                                if (_$B = 0, !(A = (0 - (A = 2 << o) | A) & e)) break r;
                                                                                                                A = E[37876 + (FC(A) << 2) >> 2];
                                                                                                            }
                                                                                                            if (!A) break e;
                                                                                                        }
                                                                                                        for(; i = (C = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, _$B = C ? A : _$B, A = (g = E[A + 16 >> 2]) || E[A + 20 >> 2];);
                                                                                                    }
                                                                                                    if (!(!_$B | E[9395] - c >>> 0 <= i >>> 0)) {
                                                                                                        if (o = E[_$B + 24 >> 2], (0 | _$B) != (0 | (C = E[_$B + 12 >> 2]))) {
                                                                                                            A = E[_$B + 8 >> 2], E[A + 12 >> 2] = C, E[C + 8 >> 2] = A;
                                                                                                            break g;
                                                                                                        }
                                                                                                        if (!(A = E[(g = _$B + 20 | 0) >> 2])) {
                                                                                                            if (!(A = E[_$B + 16 >> 2])) break c;
                                                                                                            g = _$B + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, C = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = E[C + 16 >> 2]););
                                                                                                        E[Q >> 2] = 0;
                                                                                                        break g;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            if ((A = E[9395]) >>> 0 >= c >>> 0) {
                                                                                                _$B = E[9398], (g = A - c | 0) >>> 0 >= 16 ? (E[4 + (C = _$B + c | 0) >> 2] = 1 | g, E[A + _$B >> 2] = g, E[_$B + 4 >> 2] = 3 | c) : (E[_$B + 4 >> 2] = 3 | A, E[4 + (A = A + _$B | 0) >> 2] = 1 | E[A + 4 >> 2], C = 0, g = 0), E[9395] = g, E[9398] = C, A = _$B + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if ((r = E[9396]) >>> 0 > c >>> 0) {
                                                                                                g = r - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if (A = 0, e = c + 47 | 0, E[9511] ? C = E[9513] : (E[9514] = -1, E[9515] = -1, E[9512] = 4096, E[9513] = 4096, E[9511] = _$I + 12 & -16 ^ 1431655768, E[9516] = 0, E[9504] = 0, C = 4096), (g = (Q = e + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                            if ((_$B = E[9503]) && _$B >>> 0 < (o = (C = E[9501]) + g | 0) >>> 0 | C >>> 0 >= o >>> 0) break A;
                                                                                            r: {
                                                                                                if (!(4 & a[38016])) {
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            s: {
                                                                                                                h: {
                                                                                                                    if (_$B = E[9399]) for(A = 38020;;){
                                                                                                                        if ((C = E[A >> 2]) >>> 0 <= _$B >>> 0 & _$B >>> 0 < C + E[A + 4 >> 2] >>> 0) break h;
                                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                                    }
                                                                                                                    if (-1 == (0 | (C = cg(0)))) break e;
                                                                                                                    if (o = g, (A = (_$B = E[9512]) - 1 | 0) & C && (o = (g - C | 0) + (A + C & 0 - _$B) | 0), o >>> 0 <= c >>> 0) break e;
                                                                                                                    if ((_$B = E[9503]) && _$B >>> 0 < (i = (A = E[9501]) + o | 0) >>> 0 | A >>> 0 >= i >>> 0) break e;
                                                                                                                    if ((0 | C) != (0 | (A = cg(o)))) break s;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if ((0 | (C = cg(o = i & Q - r))) == (E[A >> 2] + E[A + 4 >> 2] | 0)) break y;
                                                                                                                A = C;
                                                                                                            }
                                                                                                            if (-1 == (0 | A)) break e;
                                                                                                            if (c + 48 >>> 0 <= o >>> 0) {
                                                                                                                C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 == (0 | cg(C = (C = E[9513]) + (e - o | 0) & 0 - C))) break e;
                                                                                                            o = C + o | 0, C = A;
                                                                                                            break r;
                                                                                                        }
                                                                                                        if (-1 != (0 | C)) break r;
                                                                                                    }
                                                                                                    E[9504] = 4 | E[9504];
                                                                                                }
                                                                                                if (-1 == (0 | (C = cg(g))) | -1 == (0 | (A = cg(0))) | A >>> 0 <= C >>> 0) break E;
                                                                                                if ((o = A - C | 0) >>> 0 <= c + 40 >>> 0) break E;
                                                                                            }
                                                                                            A = E[9501] + o | 0, E[9501] = A, A >>> 0 > _[9502] && (E[9502] = A);
                                                                                            r: {
                                                                                                if (Q = E[9399]) {
                                                                                                    for(A = 38020;;){
                                                                                                        if (((_$B = E[A >> 2]) + (g = E[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                    }
                                                                                                    break _;
                                                                                                }
                                                                                                for((A = E[9397]) >>> 0 <= C >>> 0 && A || (E[9397] = C), A = 0, E[9506] = o, E[9505] = C, E[9401] = -1, E[9402] = E[9511], E[9508] = 0; g = 37612 + (_$B = A << 3) | 0, E[_$B + 37620 >> 2] = g, E[_$B + 37624 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                g = (_$B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + _$B | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                                break a;
                                                                                            }
                                                                                            if (8 & E[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | _$B >>> 0 > Q >>> 0) break _;
                                                                                            E[A + 4 >> 2] = g + o, C = (A = -8 - Q & 7) + Q | 0, E[9399] = C, A = (g = E[9396] + o | 0) - A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[4 + (g + Q | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                            break a;
                                                                                        }
                                                                                        _$B = 0;
                                                                                        break I;
                                                                                    }
                                                                                    C = 0;
                                                                                    break g;
                                                                                }
                                                                                _[9397] > C >>> 0 && (E[9397] = C), g = C + o | 0, A = 38020;
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            for(;;){
                                                                                                if ((0 | g) != E[A >> 2]) {
                                                                                                    if (A = E[A + 8 >> 2]) continue;
                                                                                                    break t;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            if (!(8 & a[A + 12 | 0])) break c;
                                                                                        }
                                                                                        for(A = 38020;;){
                                                                                            if ((g = E[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + E[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break _;
                                                                                            A = E[A + 8 >> 2];
                                                                                        }
                                                                                    }
                                                                                    if (E[A >> 2] = C, E[A + 4 >> 2] = E[A + 4 >> 2] + o, E[4 + (e = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (o = g + (-8 - g & 7) | 0) - (r = c + e | 0) | 0, (0 | Q) == (0 | o)) {
                                                                                        E[9399] = r, A = E[9396] + A | 0, E[9396] = A, E[r + 4 >> 2] = 1 | A;
                                                                                        break C;
                                                                                    }
                                                                                    if (E[9398] == (0 | o)) {
                                                                                        E[9398] = r, A = E[9395] + A | 0, E[9395] = A, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A;
                                                                                        break C;
                                                                                    }
                                                                                    if (1 != (3 & (i = E[o + 4 >> 2]))) break B;
                                                                                    if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                        if ((0 | (C = E[o + 12 >> 2])) == (0 | (g = E[o + 8 >> 2]))) {
                                                                                            s = 37572, D = E[9393] & Lg(-2, i >>> 3 | 0), E[s >> 2] = D;
                                                                                            break Q;
                                                                                        }
                                                                                        E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break Q;
                                                                                    }
                                                                                    if (c = E[o + 24 >> 2], (0 | o) != (0 | (C = E[o + 12 >> 2]))) {
                                                                                        g = E[o + 8 >> 2], E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break i;
                                                                                    }
                                                                                    if (!(i = E[(g = o + 20 | 0) >> 2])) {
                                                                                        if (!(i = E[o + 16 >> 2])) break o;
                                                                                        g = o + 16 | 0;
                                                                                    }
                                                                                    for(; _$B = g, (i = E[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = E[C + 16 >> 2]););
                                                                                    E[_$B >> 2] = 0;
                                                                                    break i;
                                                                                }
                                                                                for(g = (_$B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + _$B | 0) >> 2] = 40, E[9400] = E[9515], E[(_$B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = E[9508], E[_$B + 16 >> 2] = E[9507], E[_$B + 20 >> 2] = A, A = E[9506], E[_$B + 8 >> 2] = E[9505], E[_$B + 12 >> 2] = A, E[9507] = _$B + 8, E[9506] = o, E[9505] = C, E[9508] = 0, A = _$B + 24 | 0; E[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                if ((0 | _$B) != (0 | Q)) {
                                                                                    if (E[_$B + 4 >> 2] = -2 & E[_$B + 4 >> 2], i = _$B - Q | 0, E[Q + 4 >> 2] = 1 | i, E[_$B >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    else {
                                                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                                                        _: {
                                                                                            if ((_$B = E[9394]) & (C = 1 << A)) {
                                                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), _$B = E[g >> 2];;){
                                                                                                    if ((0 | i) == (-8 & E[(g = _$B) + 4 >> 2])) break _;
                                                                                                    if (C = A >>> 29 | 0, A <<= 1, !(_$B = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                }
                                                                                                E[C + 16 >> 2] = Q;
                                                                                            } else E[9394] = C | _$B, E[g >> 2] = Q;
                                                                                            E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                                                            break a;
                                                                                        }
                                                                                        A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    }
                                                                                }
                                                                            }
                                                                            if (!((A = E[9396]) >>> 0 <= c >>> 0)) {
                                                                                g = A - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                break A;
                                                                            }
                                                                        }
                                                                        E[9392] = 48, A = 0;
                                                                        break A;
                                                                    }
                                                                    C = 0;
                                                                }
                                                                if (c) {
                                                                    _$B = E[o + 28 >> 2];
                                                                    i: {
                                                                        if (E[(g = 37876 + (_$B << 2) | 0) >> 2] == (0 | o)) {
                                                                            if (E[g >> 2] = C, C) break i;
                                                                            s = 37576, D = E[9394] & Lg(-2, _$B), E[s >> 2] = D;
                                                                            break Q;
                                                                        }
                                                                        if (E[c + (E[c + 16 >> 2] == (0 | o) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                    }
                                                                    E[C + 24 >> 2] = c, (g = E[o + 16 >> 2]) && (E[C + 16 >> 2] = g, E[g + 24 >> 2] = C), (g = E[o + 20 >> 2]) && (E[C + 20 >> 2] = g, E[g + 24 >> 2] = C);
                                                                }
                                                            }
                                                            A = A + Q | 0, i = E[4 + (o = Q + o | 0) >> 2];
                                                        }
                                                        if (E[o + 4 >> 2] = -2 & i, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A, A >>> 0 <= 255) g = 37612 + (-8 & A) | 0, (C = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = r, E[A + 12 >> 2] = r, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        else {
                                                            i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = t(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), E[r + 28 >> 2] = i, E[r + 16 >> 2] = 0, E[r + 20 >> 2] = 0, g = 37876 + (i << 2) | 0;
                                                            B: {
                                                                if ((_$B = E[9394]) & (C = 1 << i)) {
                                                                    for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = E[g >> 2];;){
                                                                        if (g = C, (-8 & E[C + 4 >> 2]) == (0 | A)) break B;
                                                                        if (_$B = i >>> 29 | 0, i <<= 1, !(C = E[16 + (_$B = (4 & _$B) + C | 0) >> 2])) break;
                                                                    }
                                                                    E[_$B + 16 >> 2] = r;
                                                                } else E[9394] = C | _$B, E[g >> 2] = r;
                                                                E[r + 24 >> 2] = g, E[r + 12 >> 2] = r, E[r + 8 >> 2] = r;
                                                                break C;
                                                            }
                                                            A = E[g + 8 >> 2], E[A + 12 >> 2] = r, E[g + 8 >> 2] = r, E[r + 24 >> 2] = 0, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        }
                                                    }
                                                    A = e + 8 | 0;
                                                    break A;
                                                }
                                                g: if (o) {
                                                    g = E[_$B + 28 >> 2];
                                                    C: {
                                                        if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | _$B)) {
                                                            if (E[A >> 2] = C, C) break C;
                                                            e = Lg(-2, g) & e, E[9394] = e;
                                                            break g;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | _$B) ? 16 : 20) >> 2] = C, !C) break g;
                                                    }
                                                    E[C + 24 >> 2] = o, (A = E[_$B + 16 >> 2]) && (E[C + 16 >> 2] = A, E[A + 24 >> 2] = C), (A = E[_$B + 20 >> 2]) && (E[C + 20 >> 2] = A, E[A + 24 >> 2] = C);
                                                }
                                                g: if (i >>> 0 <= 15) A = i + c | 0, E[_$B + 4 >> 2] = 3 | A, E[4 + (A = A + _$B | 0) >> 2] = 1 | E[A + 4 >> 2];
                                                else if (E[_$B + 4 >> 2] = 3 | c, E[4 + (Q = _$B + c | 0) >> 2] = 1 | i, E[Q + i >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                else {
                                                    A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                    C: {
                                                        if ((C = 1 << A) & e) {
                                                            for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = E[g >> 2];;){
                                                                if ((-8 & E[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                if (C = A >>> 29 | 0, A <<= 1, !(c = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                            }
                                                            E[C + 16 >> 2] = Q;
                                                        } else E[9394] = C | e, E[g >> 2] = Q;
                                                        E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                        break g;
                                                    }
                                                    A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                }
                                                A = _$B + 8 | 0;
                                                break A;
                                            }
                                            I: if (r) {
                                                g = E[C + 28 >> 2];
                                                g: {
                                                    if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                        if (E[A >> 2] = _$B, _$B) break g;
                                                        s = 37576, D = Lg(-2, g) & e, E[s >> 2] = D;
                                                        break I;
                                                    }
                                                    if (E[r + (E[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = _$B, !_$B) break I;
                                                }
                                                E[_$B + 24 >> 2] = r, (A = E[C + 16 >> 2]) && (E[_$B + 16 >> 2] = A, E[A + 24 >> 2] = _$B), (A = E[C + 20 >> 2]) && (E[_$B + 20 >> 2] = A, E[A + 24 >> 2] = _$B);
                                            }
                                            i >>> 0 <= 15 ? (A = i + c | 0, E[C + 4 >> 2] = 3 | A, E[4 + (A = A + C | 0) >> 2] = 1 | E[A + 4 >> 2]) : (E[C + 4 >> 2] = 3 | c, E[4 + (_$B = C + c | 0) >> 2] = 1 | i, E[_$B + i >> 2] = i, y && (g = 37612 + (-8 & y) | 0, Q = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A), E[9398] = _$B, E[9395] = i), A = C + 8 | 0;
                                        }
                                        return h = _$I + 16 | 0, 0 | A;
                                    }
                                    function H(A, I, g, C, B, Q) {
                                        var i, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0;
                                        if (h = i = h - 592 | 0, r = -1, ZI(t = A + 32 | 0) && !bI(A) && GI(B) && !bI(B) && !qA(y = i + 128 | 0, B)) {
                                            for(SI(r = i + 384 | 0), Q && nA(r, 35600, 34, 0), nA(r, A, 32, 0), nA(r, B, 32, 0), nA(r, I, g, C), z(I = r, r = i + 320 | 0), N(r), C = i + 8 | 0, g = t, B = 0, I = 0, h = _ = h - 2272 | 0; t = r + (B >>> 3 | 0) | 0, o[(Q = _ + 2016 | 0) + B | 0] = a[0 | t] >>> (6 & B) & 1, o[(e = Q) + (Q = 1 | B) | 0] = a[0 | t] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (Q = I) + 1 | 0;
                                                A: if (!(Q >>> 0 > 254) && a[0 | (D = (B = _ + 2016 | 0) + Q | 0)]) {
                                                    I: if (B = o[0 | (s = I + B | 0)]) {
                                                        if ((0 | (B = (r = B << 1) + (t = o[0 | D]) | 0)) <= 15) o[0 | D] = B, o[0 | s] = 0;
                                                        else {
                                                            if ((0 | (B = t - r | 0)) < -15) break A;
                                                            for(o[0 | D] = B, B = I;;){
                                                                if (!a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                    o[0 | t] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, !t) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(Q >>> 0 > 253)) {
                                                        I: if (t = o[0 | (e = (B = Q + 2 | 0) + (_ + 2016 | 0) | 0)]) {
                                                            if ((0 | (t = (s = t << 2) + (r = o[0 | D]) | 0)) >= 16) {
                                                                if ((0 | (t = r - s | 0)) < -15) break A;
                                                                for(o[0 | D] = t;;){
                                                                    if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                        if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | t] = 1;
                                                            } else o[0 | D] = t, o[0 | e] = 0;
                                                        }
                                                        if (!(Q >>> 0 > 252)) {
                                                            I: if (t = o[0 | (e = (B = Q + 3 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                if ((0 | (t = (s = t << 3) + (r = o[0 | D]) | 0)) >= 16) {
                                                                    if ((0 | (t = r - s | 0)) < -15) break A;
                                                                    for(o[0 | D] = t;;){
                                                                        if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                            if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | t] = 1;
                                                                } else o[0 | D] = t, o[0 | e] = 0;
                                                            }
                                                            if (!(Q >>> 0 > 251)) {
                                                                I: if (t = o[0 | (e = (B = Q + 4 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                    if ((0 | (t = (s = t << 4) + (r = o[0 | D]) | 0)) >= 16) {
                                                                        if ((0 | (t = r - s | 0)) < -15) break A;
                                                                        for(o[0 | D] = t;;){
                                                                            if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | t] = 1;
                                                                    } else o[0 | D] = t, o[0 | e] = 0;
                                                                }
                                                                if (!(Q >>> 0 > 250)) {
                                                                    I: if (t = o[0 | (e = (B = Q + 5 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                        if ((0 | (t = (s = t << 5) + (r = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (t = r - s | 0)) < -15) break A;
                                                                            for(o[0 | D] = t;;){
                                                                                if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | t] = 1;
                                                                        } else o[0 | D] = t, o[0 | e] = 0;
                                                                    }
                                                                    if (!(Q >>> 0 > 249) && (Q = o[0 | (s = (B = Q + 6 | 0) + (_ + 2016 | 0) | 0)])) {
                                                                        if ((0 | (Q = (r = Q << 6) + (t = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | D] = Q;;){
                                                                                if (a[0 | (Q = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | D] = Q, o[0 | s] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; Q = g + (B >>> 3 | 0) | 0, o[(I = _ + 1760 | 0) + B | 0] = a[0 | Q] >>> (6 & B) & 1, o[(t = I) + (I = 1 | B) | 0] = a[0 | Q] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                g = I, I = I + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (e = (B = _ + 1760 | 0) + g | 0)]) {
                                                    I: if (B = o[0 | (r = I + B | 0)]) {
                                                        if ((0 | (B = (t = B << 1) + (Q = o[0 | e]) | 0)) <= 15) o[0 | e] = B, o[0 | r] = 0;
                                                        else {
                                                            if ((0 | (B = Q - t | 0)) < -15) break A;
                                                            for(o[0 | e] = B, B = I;;){
                                                                if (!a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                    o[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = o[0 | (s = (B = g + 2 | 0) + (_ + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (r = Q << 2) + (t = o[0 | e]) | 0)) >= 16) {
                                                                if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                for(o[0 | e] = Q;;){
                                                                    if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                        if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | Q] = 1;
                                                            } else o[0 | e] = Q, o[0 | s] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = o[0 | (s = (B = g + 3 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (r = Q << 3) + (t = o[0 | e]) | 0)) >= 16) {
                                                                    if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                    for(o[0 | e] = Q;;){
                                                                        if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                            if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | Q] = 1;
                                                                } else o[0 | e] = Q, o[0 | s] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = o[0 | (s = (B = g + 4 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (r = Q << 4) + (t = o[0 | e]) | 0)) >= 16) {
                                                                        if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                        for(o[0 | e] = Q;;){
                                                                            if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | Q] = 1;
                                                                    } else o[0 | e] = Q, o[0 | s] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = o[0 | (s = (B = g + 5 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (r = Q << 5) + (t = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | e] = Q;;){
                                                                                if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | e] = Q, o[0 | s] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = o[0 | (r = (B = g + 6 | 0) + (_ + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (t = g << 6) + (Q = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - t | 0)) < -15) break A;
                                                                            for(o[0 | e] = g;;){
                                                                                if (a[0 | (g = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | g] = 1;
                                                                        } else o[0 | e] = g, o[0 | r] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(TA(B = _ + 480 | 0, y), I = E[y + 36 >> 2], E[_ + 192 >> 2] = E[y + 32 >> 2], E[_ + 196 >> 2] = I, I = E[y + 28 >> 2], E[_ + 184 >> 2] = E[y + 24 >> 2], E[_ + 188 >> 2] = I, I = E[y + 20 >> 2], E[_ + 176 >> 2] = E[y + 16 >> 2], E[_ + 180 >> 2] = I, I = E[y + 12 >> 2], E[_ + 168 >> 2] = E[y + 8 >> 2], E[_ + 172 >> 2] = I, I = E[y + 4 >> 2], E[_ + 160 >> 2] = E[y >> 2], E[_ + 164 >> 2] = I, I = E[y + 52 >> 2], E[_ + 208 >> 2] = E[y + 48 >> 2], E[_ + 212 >> 2] = I, I = E[y + 60 >> 2], E[_ + 216 >> 2] = E[y + 56 >> 2], E[_ + 220 >> 2] = I, I = E[4 + (g = y - -64 | 0) >> 2], E[_ + 224 >> 2] = E[g >> 2], E[_ + 228 >> 2] = I, I = E[y + 76 >> 2], E[_ + 232 >> 2] = E[y + 72 >> 2], E[_ + 236 >> 2] = I, I = E[y + 44 >> 2], E[_ + 200 >> 2] = E[y + 40 >> 2], E[_ + 204 >> 2] = I, I = E[y + 92 >> 2], E[_ + 248 >> 2] = E[y + 88 >> 2], E[_ + 252 >> 2] = I, I = E[y + 100 >> 2], E[_ + 256 >> 2] = E[y + 96 >> 2], E[_ + 260 >> 2] = I, I = E[y + 108 >> 2], E[_ + 264 >> 2] = E[y + 104 >> 2], E[_ + 268 >> 2] = I, I = E[y + 116 >> 2], E[_ + 272 >> 2] = E[y + 112 >> 2], E[_ + 276 >> 2] = I, I = E[y + 84 >> 2], E[_ + 240 >> 2] = E[y + 80 >> 2], E[_ + 244 >> 2] = I, KA(Q = _ + 320 | 0, g = _ + 160 | 0), Y(_, Q, p = _ + 440 | 0), Y(_ + 40 | 0, w = _ + 360 | 0, f = _ + 400 | 0), Y(_ + 80 | 0, f, p), Y(_ + 120 | 0, Q, w), sA(Q, _, B), Y(g, Q, p), Y(k = _ + 200 | 0, w, f), Y(F = _ + 240 | 0, f, p), Y(n = _ + 280 | 0, Q, w), TA(I = _ + 640 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 800 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 960 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1120 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1280 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1440 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(_ + 1600 | 0, g), E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, E[C + 8 >> 2] = 0, E[C + 12 >> 2] = 0, E[C >> 2] = 0, E[C + 4 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[(R = C + 40 | 0) >> 2] = 1, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = 0, E[C + 68 >> 2] = 0, E[C + 72 >> 2] = 0, E[C + 84 >> 2] = 0, E[C + 88 >> 2] = 0, E[C + 76 >> 2] = 0, E[C + 80 >> 2] = 1, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, O = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = _ + 2016 | 0) + I | 0] && !a[(B = _ + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; KA(B = _ + 320 | 0, C), g = I, (0 | (Q = o[I + (_ + 2016 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), sA(B, I, (_ + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), hA(B, I, (_ + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (u = o[g + (_ + 1760 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), DA(B, I, c((254 & u) >>> 1 | 0, 120) + 1744 | 0)) : (0 | u) >= 0 || (Y(_ + 160 | 0, x = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, x, w), S = E[_ + 160 >> 2], G = E[_ + 200 >> 2], M = E[_ + 164 >> 2], b = E[_ + 204 >> 2], _$K = E[_ + 168 >> 2], _$H = E[_ + 208 >> 2], _$d = E[_ + 172 >> 2], J = E[_ + 212 >> 2], _$U = E[_ + 176 >> 2], l = E[_ + 216 >> 2], _$m = E[_ + 180 >> 2], D = E[_ + 220 >> 2], e = E[_ + 184 >> 2], s = E[_ + 224 >> 2], r = E[_ + 188 >> 2], y = E[_ + 228 >> 2], t = E[_ + 192 >> 2], Q = E[_ + 232 >> 2], B = E[_ + 236 >> 2], I = E[_ + 196 >> 2], E[_ + 396 >> 2] = B - I, E[_ + 392 >> 2] = Q - t, E[_ + 388 >> 2] = y - r, E[_ + 384 >> 2] = s - e, E[_ + 380 >> 2] = D - _$m, E[_ + 376 >> 2] = l - _$U, E[_ + 372 >> 2] = J - _$d, E[_ + 368 >> 2] = _$H - _$K, E[_ + 364 >> 2] = b - M, E[_ + 360 >> 2] = G - S, E[_ + 356 >> 2] = I + B, E[_ + 352 >> 2] = Q + t, E[_ + 348 >> 2] = r + y, E[_ + 344 >> 2] = e + s, E[_ + 340 >> 2] = D + _$m, E[_ + 336 >> 2] = _$U + l, E[_ + 332 >> 2] = _$d + J, E[_ + 328 >> 2] = _$K + _$H, E[_ + 324 >> 2] = M + b, E[_ + 320 >> 2] = S + G, Y(f, x, 40 + (I = c((0 - u & 254) >>> 1 | 0, 120) + 1744 | 0) | 0), Y(w, w, I), Y(p, I + 80 | 0, n), V = E[_ + 276 >> 2], Z = E[_ + 272 >> 2], u = E[_ + 268 >> 2], x = E[_ + 264 >> 2], e = E[_ + 260 >> 2], s = E[_ + 256 >> 2], r = E[_ + 252 >> 2], y = E[_ + 248 >> 2], t = E[_ + 244 >> 2], Q = E[_ + 240 >> 2], v = E[_ + 360 >> 2], L = E[_ + 400 >> 2], P = E[_ + 364 >> 2], q = E[_ + 404 >> 2], j = E[_ + 368 >> 2], _$X = E[_ + 408 >> 2], S = E[_ + 372 >> 2], G = E[_ + 412 >> 2], M = E[_ + 376 >> 2], b = E[_ + 416 >> 2], _$K = E[_ + 380 >> 2], _$H = E[_ + 420 >> 2], _$d = E[_ + 384 >> 2], J = E[_ + 424 >> 2], _$U = E[_ + 388 >> 2], l = E[_ + 428 >> 2], _$m = E[_ + 392 >> 2], D = E[_ + 432 >> 2], B = E[_ + 396 >> 2], I = E[_ + 436 >> 2], E[_ + 396 >> 2] = B + I, E[_ + 392 >> 2] = D + _$m, E[_ + 388 >> 2] = _$U + l, E[_ + 384 >> 2] = _$d + J, E[_ + 380 >> 2] = _$K + _$H, E[_ + 376 >> 2] = M + b, E[_ + 372 >> 2] = S + G, E[_ + 368 >> 2] = j + _$X, E[_ + 364 >> 2] = P + q, E[_ + 360 >> 2] = v + L, E[_ + 356 >> 2] = I - B, E[_ + 352 >> 2] = D - _$m, E[_ + 348 >> 2] = l - _$U, E[_ + 344 >> 2] = J - _$d, E[_ + 340 >> 2] = _$H - _$K, E[_ + 336 >> 2] = b - M, E[_ + 332 >> 2] = G - S, E[_ + 328 >> 2] = _$X - j, E[_ + 324 >> 2] = q - P, E[_ + 320 >> 2] = L - v, S = Q << 1, G = E[_ + 440 >> 2], E[_ + 400 >> 2] = S - G, M = t << 1, b = E[_ + 444 >> 2], E[_ + 404 >> 2] = M - b, _$K = y << 1, _$H = E[_ + 448 >> 2], E[_ + 408 >> 2] = _$K - _$H, _$d = r << 1, J = E[_ + 452 >> 2], E[_ + 412 >> 2] = _$d - J, _$U = s << 1, l = E[_ + 456 >> 2], E[_ + 416 >> 2] = _$U - l, _$m = e << 1, D = E[_ + 460 >> 2], E[_ + 420 >> 2] = _$m - D, e = x << 1, s = E[_ + 464 >> 2], E[_ + 424 >> 2] = e - s, r = u << 1, y = E[_ + 468 >> 2], E[_ + 428 >> 2] = r - y, t = Z << 1, Q = E[_ + 472 >> 2], E[_ + 432 >> 2] = t - Q, B = V << 1, I = E[_ + 476 >> 2], E[_ + 436 >> 2] = B - I, E[_ + 440 >> 2] = S + G, E[_ + 444 >> 2] = M + b, E[_ + 448 >> 2] = _$K + _$H, E[_ + 452 >> 2] = _$d + J, E[_ + 456 >> 2] = _$U + l, E[_ + 460 >> 2] = D + _$m, E[_ + 464 >> 2] = e + s, E[_ + 468 >> 2] = r + y, E[_ + 472 >> 2] = Q + t, E[_ + 476 >> 2] = I + B), Y(C, _ + 320 | 0, p), Y(R, w, f), Y(O, f, p), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            h = _ + 2272 | 0, tg(I = i + 288 | 0, C), _$W = -1, T = SC(I, A), r = ((0 | A) == (0 | I) ? _$W : T) | MI(A, I, 32);
                                        }
                                        return h = i + 592 | 0, r;
                                    }
                                    function Y(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, _$N, S, G, M, b, _$K, _$H, Y, _$d, J, _$U, l, _$m, u, x, R, v, L, P, q, _$z, j, _$X, O, V, Z, _$W, T, $, _$AA, IA, _$gA, CA, BA, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0, _$yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, _$wA = 0, _$fA = 0, nA = 0, kA = 0, _$FA = 0, _$NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        QA = Ig(C = E[g + 4 >> 2], e = C >> 31, _$fA = (f = E[I + 20 >> 2]) << 1, l = _$fA >> 31), oA = w, iA = (hA = Ig(pA = E[g >> 2], Q = pA >> 31, _$B = E[I + 24 >> 2], i = _$B >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, rA = Ig(o = E[g + 8 >> 2], h = o >> 31, hA = E[I + 16 >> 2], a = hA >> 31), oA = w + QA | 0, oA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? oA + 1 | 0 : oA, QA = (rA = Ig(y = E[g + 12 >> 2], n = y >> 31, b = (k = E[I + 12 >> 2]) << 1, _$m = b >> 31)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, oA = (DA = Ig(D = E[g + 16 >> 2], _$K = D >> 31, rA = E[I + 8 >> 2], _ = rA >> 31)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < DA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(F = E[g + 20 >> 2], u = F >> 31, _$H = (_$N = E[I + 4 >> 2]) << 1, x = _$H >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, _$W = _$cA = E[g + 24 >> 2], oA = (_$eA = Ig(_$cA, V = _$cA >> 31, DA = E[I >> 2], t = DA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < _$eA >>> 0 ? iA + 1 | 0 : iA, R = E[g + 28 >> 2], QA = (_$eA = Ig(sA = c(R, 19), S = sA >> 31, Y = (G = E[I + 36 >> 2]) << 1, v = Y >> 31)) + oA | 0, oA = w + iA | 0, oA = QA >>> 0 < _$eA >>> 0 ? oA + 1 | 0 : oA, _$NA = E[g + 32 >> 2], iA = (tA = Ig(EA = c(_$NA, 19), p = EA >> 31, _$eA = E[I + 32 >> 2], r = _$eA >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, T = E[g + 36 >> 2], g = Ig(tA = c(T, 19), s = tA >> 31, _$d = (M = E[I + 28 >> 2]) << 1, L = _$d >> 31), QA = w + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = Ig(hA, a, C, e), QA = w, iA = Ig(pA, Q, f, P = f >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(o, h, k, q = k >> 31), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(rA, _, y, n), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(D, _$K, _$N, _$z = _$N >> 31), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(DA, t, F, u), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(_$cA = c(_$cA, 19), J = _$cA >> 31, G, j = G >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(_$eA, r, sA, S), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(EA, p, M, _$X = M >> 31), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(tA, s, _$B, i), QA = w + QA | 0, GA = I = iA + I | 0, nA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = Ig(C, e, b, _$m), QA = w, iA = Ig(pA, Q, hA, a), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(rA, _, o, h), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(y, n, _$H, x), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(DA, t, D, _$K), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(_$U = c(F, 19), O = _$U >> 31, Y, v), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(_$eA, r, _$cA, J), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(sA, S, _$d, L), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(EA, p, _$B, i), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(tA, s, _$fA, l), QA = w + iA | 0, $ = I = oA + I | 0, _$AA = QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, _$gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, oA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + nA | 0, GA = I = oA + GA | 0, QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (oA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (oA = (33554431 & oA) << 7 | I >>> 25) + aA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, kA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 24 >> 2] = iA - (-67108864 & g), g = Ig(C, e, _$H, x), QA = w, iA = Ig(pA, Q, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = (QA = g) + (g = Ig(DA, t, o, h)) | 0, QA = w + oA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(g = c(y, 19), _$FA = g >> 31, Y, v), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(_$eA, r, nA = c(D, 19), Z = nA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = Ig(_$d, L, _$U, O), QA = w + iA | 0, QA = (oA = aA + oA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = Ig(_$B, i, _$cA, J)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < aA >>> 0 ? oA + 1 | 0 : oA, aA = Ig(sA, S, _$fA, l), QA = w + oA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, hA, a), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(tA, s, b, _$m)) + iA | 0, iA = w + QA | 0, _$yA = oA, MA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(DA, t, C, e), iA = w, oA = (aA = Ig(pA, Q, _$N, _$z)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(o, 19), iA = (_A = Ig(iA, SA = iA >> 31, G, j)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(_$eA, r, g, _$FA), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(nA, Z, M, _$X), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (_A = Ig(_$B, i, _$U, O)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < _A >>> 0 ? iA + 1 | 0 : iA, _A = Ig(_$cA, J, f, P), QA = w + iA | 0, QA = (oA = _A + oA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, iA = (_A = Ig(hA, a, sA, S)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(EA, p, k, q), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(tA, s, rA, _), QA = w + QA | 0, bA = iA = oA + iA | 0, _A = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, QA = Ig(QA = c(C, 19), QA >> 31, Y, v), iA = w, oA = Ig(pA, Q, DA, t), iA = w + iA | 0, iA = (QA = oA + QA | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = (aA = Ig(_$eA, r, aA, SA)) + QA | 0, QA = w + iA | 0, g = (iA = Ig(g, _$FA, _$d, L)) + oA | 0, oA = w + (oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, oA = g >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(_$B, i, nA, Z), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(_$fA, l, _$U, O), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, _$cA, J), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(sA, S, b, _$m), QA = w + iA | 0, QA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(EA, p, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(tA, s, _$H, x), QA = w + oA | 0, aA = g = iA + g | 0, _$FA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, SA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (oA = QA >> 26) + _A | 0, _A = g = (QA = (67108863 & QA) << 6 | g >>> 26) + bA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, bA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + MA | 0, QA = (g = iA + _$yA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = iA = (oA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 8 >> 2] = oA - (-67108864 & iA), QA = Ig(_$B, i, C, e), oA = w, iA = (_$yA = Ig(pA, Q, M, _$X)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < _$yA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, f, P), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, y, n), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, _$yA = Ig(D, _$K, k, q), oA = w + QA | 0, oA = (iA = _$yA + iA | 0) >>> 0 < _$yA >>> 0 ? oA + 1 | 0 : oA, QA = (_$yA = Ig(rA, _, F, u)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < _$yA >>> 0 ? iA + 1 | 0 : iA, oA = (_$yA = Ig(_$N, _$z, _$W, V)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < _$yA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(DA, t, R, _$yA = R >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, G, j), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, _$wA = Ig(tA, s, _$eA, r), oA = w + QA | 0, QA = I >> 26, I = (kA = (67108863 & I) << 6 | kA >>> 26) + (iA = _$wA + iA | 0) | 0, iA = QA + (iA >>> 0 < _$wA >>> 0 ? oA + 1 | 0 : oA) | 0, QA = (oA = I) >>> 0 < kA >>> 0 ? iA + 1 | 0 : iA, kA = iA = oA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 28 >> 2] = oA - (-33554432 & iA), QA = Ig(rA, _, C, e), iA = w, _$wA = Ig(pA, Q, k, q), oA = w + iA | 0, oA = (QA = _$wA + QA | 0) >>> 0 < _$wA >>> 0 ? oA + 1 | 0 : oA, _$wA = Ig(o, h, _$N, _$z), iA = w + oA | 0, iA = (QA = _$wA + QA | 0) >>> 0 < _$wA >>> 0 ? iA + 1 | 0 : iA, oA = (_$wA = Ig(DA, t, y, n)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < _$wA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(nA, Z, G, j), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(_$eA, r, _$U, O), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (_$cA = Ig(_$cA, J, M, _$X)) + iA | 0, oA = w + QA | 0, QA = (sA = Ig(_$B, i, sA, S)) + iA | 0, iA = w + (iA >>> 0 < _$cA >>> 0 ? oA + 1 | 0 : oA) | 0, oA = (EA = Ig(EA, p, f, P)) + QA | 0, QA = w + (QA >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(tA, s, hA, a), QA = w + QA | 0, EA = iA = iA + oA | 0, QA = (QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, EA = g = EA + (oA = (67108863 & g) << 6 | MA >>> 26) | 0, QA = g >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, sA = iA = g + 16777216 | 0, g = oA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 12 >> 2] = EA - (-33554432 & iA), QA = Ig(C, e, _$d, L), oA = w, iA = (EA = Ig(pA, Q, _$eA, r)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(_$B, i, o, h), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = Ig(y, n, _$fA, l), oA = w + QA | 0, oA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? oA + 1 | 0 : oA, QA = (EA = Ig(hA, a, D, _$K)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, oA = (EA = Ig(b, _$m, F, u)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(rA, _, _$W, V), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(R, _$yA, _$H, x), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (_$fA = Ig(DA, t, EA = _$NA, _$cA = EA >> 31)) + iA | 0, oA = w + QA | 0, QA = (tA = Ig(tA, s, Y, v)) + iA | 0, iA = w + (iA >>> 0 < _$fA >>> 0 ? oA + 1 | 0 : oA) | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, _$NA = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = _$NA + (oA = (33554431 & I) << 7 | kA >>> 25) | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, tA = iA = (oA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 32 >> 2] = oA - (-67108864 & iA), iA = g >> 25, g = (sA = (33554431 & g) << 7 | sA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (_$AA - ((QA >>> 0 > $ >>> 0) + _$gA | 0) | 0) | 0, QA = g >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (oA = GA - (-33554432 & CA) | 0) | 0, E[A + 20 >> 2] = QA, E[A + 16 >> 2] = iA - (-67108864 & g), g = Ig(_$eA, r, C, e), QA = w, iA = Ig(pA, Q, G, j), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, M, _$X), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(_$B, i, y, n), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(D, _$K, f, P), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(hA, a, F, u), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(k, q, _$W, V), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(rA, _, R, _$yA), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(EA, _$cA, _$N, _$z), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(DA, t, T, T >> 31), QA = w + oA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (oA = g) + (g = (67108863 & I) << 6 | tA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 36 >> 2] = g - (-33554432 & I), oA = _A - (-33554432 & bA) | 0, iA = aA - (g = -67108864 & SA) | 0, pA = _$FA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = Ig((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = w + pA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + oA | 0, E[A + 4 >> 2] = QA, E[A >> 2] = g - (-67108864 & I);
                                    }
                                    function d(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0;
                                        for(h = Q = h - 288 | 0, D = (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ C >>> 29, p = (a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24) ^ C << 3, w = (a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24) ^ g >>> 29, C = (a[0 | (c = B + 32 | 0)] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24) ^ g << 3, y = B + 16 | 0, r = B + 48 | 0, _ = B - -64 | 0, e = B + 80 | 0, i = B + 96 | 0, t = B + 112 | 0; g = E[t + 12 >> 2], E[Q + 280 >> 2] = E[t + 8 >> 2], E[Q + 284 >> 2] = g, g = E[t + 4 >> 2], E[Q + 272 >> 2] = E[t >> 2], E[Q + 276 >> 2] = g, g = E[i + 12 >> 2], E[Q + 248 >> 2] = E[i + 8 >> 2], E[Q + 252 >> 2] = g, g = E[i + 4 >> 2], E[Q + 240 >> 2] = E[i >> 2], E[Q + 244 >> 2] = g, g = E[t + 12 >> 2], E[Q + 232 >> 2] = E[t + 8 >> 2], E[Q + 236 >> 2] = g, g = E[t + 4 >> 2], E[Q + 224 >> 2] = E[t >> 2], E[Q + 228 >> 2] = g, $A(s = Q + 256 | 0, Q + 240 | 0, Q + 224 | 0), g = E[Q + 268 >> 2], E[t + 8 >> 2] = E[Q + 264 >> 2], E[t + 12 >> 2] = g, g = E[Q + 260 >> 2], E[t >> 2] = E[Q + 256 >> 2], E[t + 4 >> 2] = g, g = E[e + 12 >> 2], E[Q + 216 >> 2] = E[e + 8 >> 2], E[Q + 220 >> 2] = g, g = E[e + 4 >> 2], E[Q + 208 >> 2] = E[e >> 2], E[Q + 212 >> 2] = g, g = E[i + 12 >> 2], E[Q + 200 >> 2] = E[i + 8 >> 2], E[Q + 204 >> 2] = g, g = E[i + 4 >> 2], E[Q + 192 >> 2] = E[i >> 2], E[Q + 196 >> 2] = g, $A(s, Q + 208 | 0, Q + 192 | 0), g = E[Q + 268 >> 2], E[i + 8 >> 2] = E[Q + 264 >> 2], E[i + 12 >> 2] = g, g = E[Q + 260 >> 2], E[i >> 2] = E[Q + 256 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 184 >> 2] = E[_ + 8 >> 2], E[Q + 188 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 176 >> 2] = E[_ >> 2], E[Q + 180 >> 2] = g, g = E[e + 12 >> 2], E[Q + 168 >> 2] = E[e + 8 >> 2], E[Q + 172 >> 2] = g, g = E[e + 4 >> 2], E[Q + 160 >> 2] = E[e >> 2], E[Q + 164 >> 2] = g, $A(s, Q + 176 | 0, Q + 160 | 0), g = E[Q + 268 >> 2], E[e + 8 >> 2] = E[Q + 264 >> 2], E[e + 12 >> 2] = g, g = E[Q + 260 >> 2], E[e >> 2] = E[Q + 256 >> 2], E[e + 4 >> 2] = g, g = E[r + 12 >> 2], E[Q + 152 >> 2] = E[r + 8 >> 2], E[Q + 156 >> 2] = g, g = E[r + 4 >> 2], E[Q + 144 >> 2] = E[r >> 2], E[Q + 148 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 136 >> 2] = E[_ + 8 >> 2], E[Q + 140 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 128 >> 2] = E[_ >> 2], E[Q + 132 >> 2] = g, $A(s, Q + 144 | 0, Q + 128 | 0), g = E[Q + 268 >> 2], E[_ + 8 >> 2] = E[Q + 264 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 260 >> 2], E[_ >> 2] = E[Q + 256 >> 2], E[_ + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[r + 12 >> 2], E[Q + 104 >> 2] = E[r + 8 >> 2], E[Q + 108 >> 2] = g, g = E[r + 4 >> 2], E[Q + 96 >> 2] = E[r >> 2], E[Q + 100 >> 2] = g, $A(s, Q + 112 | 0, Q + 96 | 0), g = E[Q + 268 >> 2], E[r + 8 >> 2] = E[Q + 264 >> 2], E[r + 12 >> 2] = g, g = E[Q + 260 >> 2], E[r >> 2] = E[Q + 256 >> 2], E[r + 4 >> 2] = g, g = E[y + 12 >> 2], E[Q + 88 >> 2] = E[y + 8 >> 2], E[Q + 92 >> 2] = g, g = E[y + 4 >> 2], E[Q + 80 >> 2] = E[y >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(s, Q + 80 | 0, Q - -64 | 0), g = E[Q + 268 >> 2], E[c + 8 >> 2] = E[Q + 264 >> 2], E[c + 12 >> 2] = g, g = E[Q + 260 >> 2], E[c >> 2] = E[Q + 256 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[y + 12 >> 2], E[Q + 40 >> 2] = E[y + 8 >> 2], E[Q + 44 >> 2] = g, g = E[y + 4 >> 2], E[Q + 32 >> 2] = E[y >> 2], E[Q + 36 >> 2] = g, $A(s, Q + 48 | 0, Q + 32 | 0), g = E[Q + 268 >> 2], E[y + 8 >> 2] = E[Q + 264 >> 2], E[y + 12 >> 2] = g, g = E[Q + 260 >> 2], E[y >> 2] = E[Q + 256 >> 2], E[y + 4 >> 2] = g, g = E[Q + 284 >> 2], E[Q + 24 >> 2] = E[Q + 280 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 276 >> 2], E[Q + 16 >> 2] = E[Q + 272 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(s, Q + 16 | 0, Q), g = E[Q + 268 >> 2], E[B + 8 >> 2] = E[Q + 264 >> 2], E[B + 12 >> 2] = g, g = E[Q + 260 >> 2], E[B >> 2] = E[Q + 256 >> 2], E[B + 4 >> 2] = g, n = D ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), E[B + 12 >> 2] = n, k = p ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), E[B + 8 >> 2] = k, F = w ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E[B + 4 >> 2] = F, _$N = C ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[B >> 2] = _$N, S = C ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), E[_ >> 2] = S, G = w ^ (a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24), E[B + 68 >> 2] = G, M = p ^ (a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24), E[B + 72 >> 2] = M, b = D ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), E[B + 76 >> 2] = b, 7 != (0 | (f = f + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    _ = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, c = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, y = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, r = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, e = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, t = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, s = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, D = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, p = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, w = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, f = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, I = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, B = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24) ^ b, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = w ^ f ^ C ^ I ^ g ^ M ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = i ^ t ^ s ^ D ^ p ^ G ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = _ ^ c ^ y ^ r ^ e ^ S ^ _$N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                t = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, s = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, D = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, p = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, w = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, f = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, g = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, I = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, i = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24), o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, I = C ^ I ^ g ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = p ^ w ^ f ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = t ^ s ^ D ^ _$N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, r = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[B + 112 | 0] | a[B + 113 | 0] << 8 | a[B + 114 | 0] << 16 | a[B + 115 | 0] << 24, t = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, s = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, D = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, p = a[B + 116 | 0] | a[B + 117 | 0] << 8 | a[B + 118 | 0] << 16 | a[B + 119 | 0] << 24, w = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, f = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, C = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, g = a[B + 120 | 0] | a[B + 121 | 0] << 8 | a[B + 122 | 0] << 16 | a[B + 123 | 0] << 24, I = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, B = (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24) ^ (a[B + 124 | 0] | a[B + 125 | 0] << 8 | a[B + 126 | 0] << 16 | a[B + 127 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = f ^ C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ p ^ w, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = r ^ e ^ i ^ t, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 288 | 0;
                                    }
                                    function J(A, I, g, C) {
                                        var _$B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0;
                                        for(_$B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g + 4 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 8 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 12 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 16 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 20 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 24 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 28 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 32 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 36 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 40 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 44 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 48 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 52 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, _$B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 56 >> 2] = _$B << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I, I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I; _ = E[C + 28 >> 2], _$B = (I = n << 2) + g | 0, i = E[C + 16 >> 2], c = E[_$B >> 2] + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0, r = (_ = ((Q = E[I + 34432 >> 2] + c | 0) + (i & ((c = E[C + 24 >> 2]) ^ (e = E[C + 20 >> 2])) ^ c) | 0) + _ | 0) + E[C + 12 >> 2] | 0, E[C + 12 >> 2] = r, _ = (s = _ + (Lg(t = E[C >> 2], 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) + (t & ((Q = E[C + 8 >> 2]) | (o = E[C + 4 >> 2])) | Q & o) | 0, E[C + 28 >> 2] = _, Q = (s = Q) + (c = (E[(D = (Q = 4 | I) + g | 0) >> 2] + ((c + (e ^ r & (i ^ e)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) | 0) + E[Q + 34432 >> 2] | 0) | 0, E[C + 8 >> 2] = Q, c = (c + (_ & (o | t) | o & t) | 0) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0, E[C + 24 >> 2] = c, e = (s = o) + (o = (((e + E[(f = (o = 8 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) | 0, E[C + 4 >> 2] = e, o = o + ((c & (_ | t) | _ & t) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 20 >> 2] = o, i = (s = t) + (t = (((i + E[(k = (t = 12 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (r ^ e & (Q ^ r)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) | 0, E[C >> 2] = i, t = t + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 16 >> 2] = t, r = (y = ((((s = r) + E[(F = (r = 16 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 12 >> 2] = r, y = _ + y | 0, E[C + 28 >> 2] = y, _ = (Q = (((Q + E[(_$N = (_ = 20 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 8 >> 2] = _, Q = Q + c | 0, E[C + 24 >> 2] = Q, c = (e = (((e + E[(S = (c = 24 | I) + g | 0) >> 2] | 0) + E[c + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 4 >> 2] = c, e = o + e | 0, E[C + 20 >> 2] = e, o = (i = (((i + E[(G = (o = 28 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C >> 2] = o, i = i + t | 0, E[C + 16 >> 2] = i, t = (y = (((y + E[(M = (t = 32 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 28 >> 2] = t, y = r + y | 0, E[C + 12 >> 2] = y, r = (Q = (((Q + E[(b = (r = 36 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 24 >> 2] = r, Q = Q + _ | 0, E[C + 8 >> 2] = Q, _ = (e = (((e + E[(_$K = (_ = 40 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 20 >> 2] = _, e = c + e | 0, E[C + 4 >> 2] = e, s = (c = 44 | I) + g | 0, c = (i = ((i + (E[c + 34432 >> 2] + E[s >> 2] | 0) | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 16 >> 2] = c, o = o + i | 0, E[C >> 2] = o, w = (i = 48 | I) + g | 0, i = (y = ((y + (E[i + 34432 >> 2] + E[w >> 2] | 0) | 0) + (Q ^ o & (Q ^ e)) | 0) + (Lg(o, 26) ^ Lg(o, 21) ^ Lg(o, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 12 >> 2] = i, t = t + y | 0, E[C + 28 >> 2] = t, p = (y = 52 | I) + g | 0, Q = (y = (((E[y + 34432 >> 2] + E[p >> 2] | 0) + Q | 0) + (e ^ t & (o ^ e)) | 0) + (Lg(t, 26) ^ Lg(t, 21) ^ Lg(t, 7)) | 0) + ((i & (_ | c) | _ & c) + (Lg(i, 30) ^ Lg(i, 19) ^ Lg(i, 10)) | 0) | 0, E[C + 8 >> 2] = Q, r = r + y | 0, E[C + 24 >> 2] = r, y = (h = 56 | I) + g | 0, e = (h = (((E[h + 34432 >> 2] + E[y >> 2] | 0) + e | 0) + (o ^ r & (o ^ t)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) + ((Q & (c | i) | c & i) + (Lg(Q, 30) ^ Lg(Q, 19) ^ Lg(Q, 10)) | 0) | 0, E[C + 4 >> 2] = e, _ = _ + h | 0, E[C + 20 >> 2] = _, h = (I |= 60) + g | 0, _ = (I = ((o + (E[I + 34432 >> 2] + E[h >> 2] | 0) | 0) + (t ^ _ & (t ^ r)) | 0) + (Lg(_, 26) ^ Lg(_, 21) ^ Lg(_, 7)) | 0) + ((e & (Q | i) | Q & i) + (Lg(e, 30) ^ Lg(e, 19) ^ Lg(e, 10)) | 0) | 0, E[C >> 2] = _, E[C + 16 >> 2] = I + c, 48 != (0 | n);)o = E[b >> 2], n = n + 16 | 0, I = E[y >> 2], _ = (Q = E[_$B >> 2] + (o + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0) | 0) + (Lg(c = E[D >> 2], 25) ^ Lg(c, 14) ^ c >>> 3) | 0, E[(n << 2) + g >> 2] = _, r = (i = (Q = (t = E[_$K >> 2]) + c | 0) + (Lg(c = E[h >> 2], 15) ^ Lg(c, 13) ^ c >>> 10) | 0) + (Lg(Q = E[f >> 2], 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0, E[_$B + 68 >> 2] = r, e = (s = ((i = Q) + (Q = E[s >> 2]) | 0) + (Lg(_, 15) ^ Lg(_, 13) ^ _ >>> 10) | 0) + (Lg(i = E[k >> 2], 25) ^ Lg(i, 14) ^ i >>> 3) | 0, E[_$B + 72 >> 2] = e, y = (h = ((s = i) + (i = E[w >> 2]) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0) + (Lg(s = E[F >> 2], 25) ^ Lg(s, 14) ^ s >>> 3) | 0, E[_$B + 76 >> 2] = y, w = (h = ((h = s) + (s = E[p >> 2]) | 0) + (Lg(e, 15) ^ Lg(e, 13) ^ e >>> 10) | 0) + (Lg(p = E[_$N >> 2], 25) ^ Lg(p, 14) ^ p >>> 3) | 0, E[_$B + 80 >> 2] = w, p = (D = (I + p | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0) + (Lg(h = E[S >> 2], 25) ^ Lg(h, 14) ^ h >>> 3) | 0, E[_$B + 84 >> 2] = p, h = ((c + h | 0) + (Lg(f = E[G >> 2], 25) ^ Lg(f, 14) ^ f >>> 3) | 0) + (Lg(w, 15) ^ Lg(w, 13) ^ w >>> 10) | 0, E[_$B + 88 >> 2] = h, r = ((D = E[M >> 2]) + (r + (Lg(o, 25) ^ Lg(o, 14) ^ o >>> 3) | 0) | 0) + (Lg(h, 15) ^ Lg(h, 13) ^ h >>> 10) | 0, E[_$B + 96 >> 2] = r, D = ((_ + f | 0) + (Lg(D, 25) ^ Lg(D, 14) ^ D >>> 3) | 0) + (Lg(p, 15) ^ Lg(p, 13) ^ p >>> 10) | 0, E[_$B + 92 >> 2] = D, y = (y + (t + (Lg(Q, 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0, E[_$B + 104 >> 2] = y, o = (e + (o + (Lg(t, 25) ^ Lg(t, 14) ^ t >>> 3) | 0) | 0) + (Lg(D, 15) ^ Lg(D, 13) ^ D >>> 10) | 0, E[_$B + 100 >> 2] = o, t = (p + (i + (Lg(s, 25) ^ Lg(s, 14) ^ s >>> 3) | 0) | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0, E[_$B + 112 >> 2] = t, o = (w + (Q + (Lg(i, 25) ^ Lg(i, 14) ^ i >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[_$B + 108 >> 2] = o, _$H = _$B, Y = (D + (I + (Lg(c, 25) ^ Lg(c, 14) ^ c >>> 3) | 0) | 0) + (Lg(t, 15) ^ Lg(t, 13) ^ t >>> 10) | 0, E[_$H + 120 >> 2] = Y, I = (h + (s + (Lg(I, 25) ^ Lg(I, 14) ^ I >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[_$B + 116 >> 2] = I, _$H = _$B, Y = (r + (c + (Lg(_, 25) ^ Lg(_, 14) ^ _ >>> 3) | 0) | 0) + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0, E[_$H + 124 >> 2] = Y;
                                        E[A >> 2] = _ + E[A >> 2], E[A + 4 >> 2] = E[A + 4 >> 2] + E[C + 4 >> 2], E[A + 8 >> 2] = E[A + 8 >> 2] + E[C + 8 >> 2], E[A + 12 >> 2] = E[A + 12 >> 2] + E[C + 12 >> 2], E[A + 16 >> 2] = E[A + 16 >> 2] + E[C + 16 >> 2], E[A + 20 >> 2] = E[A + 20 >> 2] + E[C + 20 >> 2], E[A + 24 >> 2] = E[A + 24 >> 2] + E[C + 24 >> 2], E[A + 28 >> 2] = E[A + 28 >> 2] + E[C + 28 >> 2];
                                    }
                                    function U(A, I, g) {
                                        var C, _$B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N, S, G, M, b, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0;
                                        h = C = h - 288 | 0, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, e = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, p = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, J = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, n = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, _$H = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, _$U = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, k = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, F = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, _$K = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, Y = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, l = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, _$N = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, S = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, Q = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, _$d = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, _$m = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, G = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, M = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, i = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, b = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, _$B = (_ = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (c = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24), o[A + 28 | 0] = _$B, o[A + 29 | 0] = _$B >>> 8, o[A + 30 | 0] = _$B >>> 16, o[A + 31 | 0] = _$B >>> 24, _$m = _$d ^ i & M ^ _$m ^ G, o[A + 24 | 0] = _$m, o[A + 25 | 0] = _$m >>> 8, o[A + 26 | 0] = _$m >>> 16, o[A + 27 | 0] = _$m >>> 24, l = Y ^ Q & S ^ l ^ _$N, o[A + 20 | 0] = l, o[A + 21 | 0] = l >>> 8, o[A + 22 | 0] = l >>> 16, o[A + 23 | 0] = l >>> 24, _$U = _$H ^ _$K & F ^ _$U ^ k, o[A + 16 | 0] = _$U, o[A + 17 | 0] = _$U >>> 8, o[A + 18 | 0] = _$U >>> 16, o[A + 19 | 0] = _$U >>> 24, J = n & _ ^ J ^ f ^ c, o[A + 12 | 0] = J, o[A + 13 | 0] = J >>> 8, o[A + 14 | 0] = J >>> 16, o[A + 15 | 0] = J >>> 24, _$d = _$d & w ^ D ^ p ^ i, o[A + 8 | 0] = _$d, o[A + 9 | 0] = _$d >>> 8, o[A + 10 | 0] = _$d >>> 16, o[A + 11 | 0] = _$d >>> 24, Y = Y & s ^ e ^ y ^ Q, o[A + 4 | 0] = Y, o[A + 5 | 0] = Y >>> 8, o[A + 6 | 0] = Y >>> 16, o[A + 7 | 0] = Y >>> 24, _$H = _$K ^ _$H & r ^ t ^ b, o[0 | A] = _$H, o[A + 1 | 0] = _$H >>> 8, o[A + 2 | 0] = _$H >>> 16, o[A + 3 | 0] = _$H >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, _$K = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = _$K, _$K = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = _$K, _$K = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = _$K, $A(I, C + 176 | 0, C + 160 | 0), _$K = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = _$K, _$K = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = _$K, _$K = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = _$K, _$K = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = _$K, _$K = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = _$K, _$K = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = _$K, $A(I, C + 144 | 0, C + 128 | 0), _$K = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = _$K, _$K = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = _$K, _$K = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = _$K, _$K = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = _$K, _$K = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = _$K, _$K = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = _$K, $A(I, C + 112 | 0, C + 96 | 0), _$K = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = _$K, _$K = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = _$K, _$K = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = _$K, _$K = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = _$K, _$K = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = _$K, _$K = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = _$K, $A(I, C + 80 | 0, C - -64 | 0), _$K = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = _$K, _$K = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = _$K, _$K = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = _$K, _$K = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = _$K, _$K = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = _$K, _$K = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = _$K, $A(I, C + 48 | 0, C + 32 | 0), _$K = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = _$K, _$K = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = _$K, _$K = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = _$K, _$K = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = _$K, _$K = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = _$K, _$K = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = _$K, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = J ^ (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24), E[g + 8 >> 2] = _$d ^ (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24), E[g + 4 >> 2] = Y ^ (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24), E[g >> 2] = _$H ^ (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24), E[A >> 2] = _$U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[g + 68 >> 2] = l ^ (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24), E[g + 72 >> 2] = _$m ^ (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24), E[g + 76 >> 2] = _$B ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function l(A, I, g) {
                                        var C, _$B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N, S, G, M, b, _$K, _$H, Y, _$d, J, _$U, l, _$m = 0;
                                        h = C = h - 288 | 0, k = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, F = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, _$B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, _$N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, M = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, b = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, _$K = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, _$m = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, _ = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, _$H = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Y = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, c = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, t = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, r = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, _$d = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, J = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, e = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, y = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, s = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, _$U = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, l = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, D = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (w = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (f = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ (n = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24), o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = D & l ^ _$U ^ s ^ y, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = e & J ^ _$d ^ r ^ t, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = _$m ^ c & Y ^ _$H ^ _, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = _$K & w ^ b ^ i ^ n, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = y & M ^ G ^ Q ^ D, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = t & S ^ _$N ^ _$B ^ e, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = _$m & F ^ k ^ p ^ c, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, _$m = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = _$m, _$m = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = _$m, _$m = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = _$m, $A(I, C + 176 | 0, C + 160 | 0), _$m = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = _$m, _$m = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = _$m, _$m = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = _$m, _$m = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = _$m, _$m = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = _$m, _$m = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = _$m, $A(I, C + 144 | 0, C + 128 | 0), _$m = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = _$m, _$m = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = _$m, _$m = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = _$m, _$m = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = _$m, _$m = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = _$m, _$m = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = _$m, $A(I, C + 112 | 0, C + 96 | 0), _$m = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = _$m, _$m = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = _$m, _$m = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = _$m, _$m = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = _$m, _$m = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = _$m, _$m = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = _$m, $A(I, C + 80 | 0, C - -64 | 0), _$m = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = _$m, _$m = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = _$m, _$m = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = _$m, _$m = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = _$m, _$m = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = _$m, _$m = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = _$m, $A(I, C + 48 | 0, C + 32 | 0), _$m = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = _$m, _$m = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = _$m, _$m = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = _$m, _$m = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = _$m, _$m = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = _$m, _$m = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = _$m, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ i, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ Q, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ _$B, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ _, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ r, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ s, E[g + 76 >> 2] = f ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function m(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0;
                                        for(h = Q = h - 224 | 0, p = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ C >>> 29, w = (a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24) ^ C << 3, e = (a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24) ^ g >>> 29, s = (a[0 | (i = B + 48 | 0)] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24) ^ g << 3, _ = B + 16 | 0, c = B + 32 | 0, t = B - -64 | 0, r = B + 80 | 0; g = E[r + 12 >> 2], E[Q + 216 >> 2] = E[r + 8 >> 2], E[Q + 220 >> 2] = g, g = E[r + 4 >> 2], E[Q + 208 >> 2] = E[r >> 2], E[Q + 212 >> 2] = g, g = E[t + 12 >> 2], E[Q + 184 >> 2] = E[t + 8 >> 2], E[Q + 188 >> 2] = g, g = E[t + 4 >> 2], E[Q + 176 >> 2] = E[t >> 2], E[Q + 180 >> 2] = g, g = E[r + 12 >> 2], E[Q + 168 >> 2] = E[r + 8 >> 2], E[Q + 172 >> 2] = g, g = E[r + 4 >> 2], E[Q + 160 >> 2] = E[r >> 2], E[Q + 164 >> 2] = g, $A(C = Q + 192 | 0, Q + 176 | 0, Q + 160 | 0), g = E[Q + 204 >> 2], E[r + 8 >> 2] = E[Q + 200 >> 2], E[r + 12 >> 2] = g, g = E[Q + 196 >> 2], E[r >> 2] = E[Q + 192 >> 2], E[r + 4 >> 2] = g, g = E[i + 12 >> 2], E[Q + 152 >> 2] = E[i + 8 >> 2], E[Q + 156 >> 2] = g, g = E[i + 4 >> 2], E[Q + 144 >> 2] = E[i >> 2], E[Q + 148 >> 2] = g, g = E[t + 12 >> 2], E[Q + 136 >> 2] = E[t + 8 >> 2], E[Q + 140 >> 2] = g, g = E[t + 4 >> 2], E[Q + 128 >> 2] = E[t >> 2], E[Q + 132 >> 2] = g, $A(C, Q + 144 | 0, Q + 128 | 0), g = E[Q + 204 >> 2], E[t + 8 >> 2] = E[Q + 200 >> 2], E[t + 12 >> 2] = g, g = E[Q + 196 >> 2], E[t >> 2] = E[Q + 192 >> 2], E[t + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[i + 12 >> 2], E[Q + 104 >> 2] = E[i + 8 >> 2], E[Q + 108 >> 2] = g, g = E[i + 4 >> 2], E[Q + 96 >> 2] = E[i >> 2], E[Q + 100 >> 2] = g, $A(C, Q + 112 | 0, Q + 96 | 0), g = E[Q + 204 >> 2], E[i + 8 >> 2] = E[Q + 200 >> 2], E[i + 12 >> 2] = g, g = E[Q + 196 >> 2], E[i >> 2] = E[Q + 192 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 88 >> 2] = E[_ + 8 >> 2], E[Q + 92 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 80 >> 2] = E[_ >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(C, Q + 80 | 0, Q - -64 | 0), g = E[Q + 204 >> 2], E[c + 8 >> 2] = E[Q + 200 >> 2], E[c + 12 >> 2] = g, g = E[Q + 196 >> 2], E[c >> 2] = E[Q + 192 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 40 >> 2] = E[_ + 8 >> 2], E[Q + 44 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 32 >> 2] = E[_ >> 2], E[Q + 36 >> 2] = g, $A(C, Q + 48 | 0, Q + 32 | 0), g = E[Q + 204 >> 2], E[_ + 8 >> 2] = E[Q + 200 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 196 >> 2], E[_ >> 2] = E[Q + 192 >> 2], E[_ + 4 >> 2] = g, g = E[Q + 220 >> 2], E[Q + 24 >> 2] = E[Q + 216 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 212 >> 2], E[Q + 16 >> 2] = E[Q + 208 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(C, Q + 16 | 0, Q), D = E[Q + 192 >> 2], C = E[Q + 196 >> 2], g = E[Q + 200 >> 2], f = p ^ E[Q + 204 >> 2], E[B + 12 >> 2] = f, n = g ^ w, E[B + 8 >> 2] = n, k = C ^ e, E[B + 4 >> 2] = k, F = s ^ D, E[B >> 2] = F, 7 != (0 | (y = y + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    _$N = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, i = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, _ = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, c = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, t = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, r = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, p = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, w = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, e = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, s = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, D = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, y = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = f ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = n ^ D ^ I ^ g ^ C ^ y, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ r ^ p ^ w ^ e ^ s, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ _$N ^ i ^ _ ^ c ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                s = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, D = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, y = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, g = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, e = f ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24), o[A + 12 | 0] = e, o[A + 13 | 0] = e >>> 8, o[A + 14 | 0] = e >>> 16, o[A + 15 | 0] = e >>> 24, I = n ^ I ^ g, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ C ^ y, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ s ^ D, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, p = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, w = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, s = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, D = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, y = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, C = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ y, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p ^ e ^ w, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 224 | 0;
                                    }
                                    function u(A, I, g) {
                                        var C, _$B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0;
                                        for(h = C = h - 4032 | 0, TA(C + 160 | 0, g), _ = E[g + 36 >> 2], E[(i = C + 3840 | 0) >> 2] = E[g + 32 >> 2], E[i + 4 >> 2] = _, c = E[g + 28 >> 2], E[(_ = C + 3832 | 0) >> 2] = E[g + 24 >> 2], E[_ + 4 >> 2] = c, r = E[g + 20 >> 2], E[(c = C + 3824 | 0) >> 2] = E[g + 16 >> 2], E[c + 4 >> 2] = r, e = E[g + 12 >> 2], E[(r = C + 3816 | 0) >> 2] = E[g + 8 >> 2], E[r + 4 >> 2] = e, e = E[g + 4 >> 2], E[C + 3808 >> 2] = E[g >> 2], E[C + 3812 >> 2] = e, D = E[g + 52 >> 2], E[(e = C + 3856 | 0) >> 2] = E[g + 48 >> 2], E[e + 4 >> 2] = D, p = E[g + 60 >> 2], E[(D = C + 3864 | 0) >> 2] = E[g + 56 >> 2], E[D + 4 >> 2] = p, y = E[4 + (w = g - -64 | 0) >> 2], E[(p = C + 3872 | 0) >> 2] = E[w >> 2], E[p + 4 >> 2] = y, y = E[g + 76 >> 2], E[(w = C + 3880 | 0) >> 2] = E[g + 72 >> 2], E[w + 4 >> 2] = y, y = E[g + 44 >> 2], E[C + 3848 >> 2] = E[g + 40 >> 2], E[C + 3852 >> 2] = y, n = E[g + 92 >> 2], E[(y = C + 3896 | 0) >> 2] = E[g + 88 >> 2], E[y + 4 >> 2] = n, k = E[g + 100 >> 2], E[(n = C + 3904 | 0) >> 2] = E[g + 96 >> 2], E[n + 4 >> 2] = k, F = E[g + 108 >> 2], E[(k = C + 3912 | 0) >> 2] = E[g + 104 >> 2], E[k + 4 >> 2] = F, _$N = E[g + 116 >> 2], E[(F = C + 3920 | 0) >> 2] = E[g + 112 >> 2], E[F + 4 >> 2] = _$N, _$N = E[g + 84 >> 2], E[C + 3888 >> 2] = E[g + 80 >> 2], E[C + 3892 >> 2] = _$N, KA(_$B = C + 3528 | 0, _$N = C + 3808 | 0), Y(Q = C + 2408 | 0, _$B, t = C + 3648 | 0), Y(C + 2448 | 0, s = C + 3568 | 0, f = C + 3608 | 0), Y(C + 2488 | 0, f, t), Y(C + 2528 | 0, _$B, s), TA(t = C + 320 | 0, Q), sA(_$B = C + 3368 | 0, g, t), Y(Q = C + 2248 | 0, _$B, t = C + 3488 | 0), Y(C + 2288 | 0, s = C + 3408 | 0, f = C + 3448 | 0), Y(C + 2328 | 0, f, t), Y(C + 2368 | 0, _$B, s), TA(C + 480 | 0, Q), Q = E[4 + (_$B = C + 2440 | 0) >> 2], E[i >> 2] = E[_$B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2432 | 0) >> 2], E[_ >> 2] = E[_$B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2424 | 0) >> 2], E[c >> 2] = E[_$B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2416 | 0) >> 2], E[r >> 2] = E[_$B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2456 | 0) >> 2], E[e >> 2] = E[_$B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2464 | 0) >> 2], E[D >> 2] = E[_$B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2472 | 0) >> 2], E[p >> 2] = E[_$B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2480 | 0) >> 2], E[w >> 2] = E[_$B >> 2], E[w + 4 >> 2] = Q, _$B = E[C + 2412 >> 2], E[C + 3808 >> 2] = E[C + 2408 >> 2], E[C + 3812 >> 2] = _$B, _$B = E[C + 2452 >> 2], E[C + 3848 >> 2] = E[C + 2448 >> 2], E[C + 3852 >> 2] = _$B, Q = E[4 + (_$B = C + 2520 | 0) >> 2], E[F >> 2] = E[_$B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2512 | 0) >> 2], E[k >> 2] = E[_$B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2504 | 0) >> 2], E[n >> 2] = E[_$B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2496 | 0) >> 2], E[y >> 2] = E[_$B >> 2], E[y + 4 >> 2] = Q, _$B = E[C + 2492 >> 2], E[C + 3888 >> 2] = E[C + 2488 >> 2], E[C + 3892 >> 2] = _$B, KA(_$B = C + 3208 | 0, _$N), Y(Q = C + 2088 | 0, _$B, t = C + 3328 | 0), Y(C + 2128 | 0, s = C + 3248 | 0, f = C + 3288 | 0), Y(C + 2168 | 0, f, t), Y(C + 2208 | 0, _$B, s), TA(t = C + 640 | 0, Q), sA(_$B = C + 3048 | 0, g, t), Y(Q = C + 1928 | 0, _$B, t = C + 3168 | 0), Y(C + 1968 | 0, s = C + 3088 | 0, f = C + 3128 | 0), Y(C + 2008 | 0, f, t), Y(C + 2048 | 0, _$B, s), TA(C + 800 | 0, Q), Q = E[4 + (_$B = C + 2280 | 0) >> 2], E[i >> 2] = E[_$B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2272 | 0) >> 2], E[_ >> 2] = E[_$B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2264 | 0) >> 2], E[c >> 2] = E[_$B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2256 | 0) >> 2], E[r >> 2] = E[_$B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2296 | 0) >> 2], E[e >> 2] = E[_$B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2304 | 0) >> 2], E[D >> 2] = E[_$B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2312 | 0) >> 2], E[p >> 2] = E[_$B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2320 | 0) >> 2], E[w >> 2] = E[_$B >> 2], E[w + 4 >> 2] = Q, _$B = E[C + 2252 >> 2], E[C + 3808 >> 2] = E[C + 2248 >> 2], E[C + 3812 >> 2] = _$B, _$B = E[C + 2292 >> 2], E[C + 3848 >> 2] = E[C + 2288 >> 2], E[C + 3852 >> 2] = _$B, Q = E[4 + (_$B = C + 2360 | 0) >> 2], E[F >> 2] = E[_$B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2352 | 0) >> 2], E[k >> 2] = E[_$B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2344 | 0) >> 2], E[n >> 2] = E[_$B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (_$B = C + 2336 | 0) >> 2], E[y >> 2] = E[_$B >> 2], E[y + 4 >> 2] = Q, _$B = E[C + 2332 >> 2], E[C + 3888 >> 2] = E[C + 2328 >> 2], E[C + 3892 >> 2] = _$B, KA(_$B = C + 2888 | 0, _$N), Y(Q = C + 1768 | 0, _$B, t = C + 3008 | 0), Y(C + 1808 | 0, s = C + 2928 | 0, f = C + 2968 | 0), Y(C + 1848 | 0, f, t), Y(C + 1888 | 0, _$B, s), TA(t = C + 960 | 0, Q), sA(_$B = C + 2728 | 0, g, t), Y(g = C + 1608 | 0, _$B, Q = C + 2848 | 0), Y(C + 1648 | 0, t = C + 2768 | 0, s = C + 2808 | 0), Y(C + 1688 | 0, s, Q), Y(C + 1728 | 0, _$B, t), TA(C + 1120 | 0, g), _$B = E[4 + (g = C + 2120 | 0) >> 2], E[i >> 2] = E[g >> 2], E[i + 4 >> 2] = _$B, i = E[4 + (g = C + 2112 | 0) >> 2], E[_ >> 2] = E[g >> 2], E[_ + 4 >> 2] = i, i = E[4 + (g = C + 2104 | 0) >> 2], E[c >> 2] = E[g >> 2], E[c + 4 >> 2] = i, i = E[4 + (g = C + 2096 | 0) >> 2], E[r >> 2] = E[g >> 2], E[r + 4 >> 2] = i, i = E[4 + (g = C + 2136 | 0) >> 2], E[e >> 2] = E[g >> 2], E[e + 4 >> 2] = i, i = E[4 + (g = C + 2144 | 0) >> 2], E[D >> 2] = E[g >> 2], E[D + 4 >> 2] = i, i = E[4 + (g = C + 2152 | 0) >> 2], E[p >> 2] = E[g >> 2], E[p + 4 >> 2] = i, i = E[4 + (g = C + 2160 | 0) >> 2], E[w >> 2] = E[g >> 2], E[w + 4 >> 2] = i, g = E[C + 2092 >> 2], E[C + 3808 >> 2] = E[C + 2088 >> 2], E[C + 3812 >> 2] = g, g = E[C + 2132 >> 2], E[C + 3848 >> 2] = E[C + 2128 >> 2], E[C + 3852 >> 2] = g, i = E[4 + (g = C + 2200 | 0) >> 2], E[F >> 2] = E[g >> 2], E[F + 4 >> 2] = i, i = E[4 + (g = C + 2192 | 0) >> 2], E[k >> 2] = E[g >> 2], E[k + 4 >> 2] = i, i = E[4 + (g = C + 2184 | 0) >> 2], E[n >> 2] = E[g >> 2], E[n + 4 >> 2] = i, i = E[4 + (g = C + 2176 | 0) >> 2], E[y >> 2] = E[g >> 2], E[y + 4 >> 2] = i, g = E[C + 2172 >> 2], E[C + 3888 >> 2] = E[C + 2168 >> 2], E[C + 3892 >> 2] = g, KA(g = C + 2568 | 0, _$N), Y(i = C + 1448 | 0, g, _ = C + 2688 | 0), Y(C + 1488 | 0, c = C + 2608 | 0, r = C + 2648 | 0), Y(C + 1528 | 0, r, _), Y(C + 1568 | 0, g, c), TA(C + 1280 | 0, i), i = 0, g = 0; c = (_ = C + 3968 | 0) + (g << 1) | 0, r = a[I + g | 0], o[c + 1 | 0] = r >>> 4, o[0 | c] = 15 & r, _ = _ + ((c = 1 | g) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (g = g + 2 | 0)););
                                        for(I = 0; g = 8 + (_ = (g = I) + a[0 | (I = (C + 3968 | 0) + i | 0)] | 0) | 0, o[0 | I] = _ - (240 & g), g = 8 + (_ = a[I + 1 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & g), g = 8 + (_ = a[I + 2 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & g), I = g << 24 >> 24 >> 4, 63 != (0 | (i = i + 3 | 0)););
                                        for(o[C + 4031 | 0] = a[C + 4031 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(p = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), w = A + 120 | 0, y = A + 80 | 0, r = C + 3768 | 0, g = C + 3888 | 0, _ = C + 3848 | 0, e = C + 3728 | 0, i = C + 3928 | 0, D = 63; HA(C, n = C + 160 | 0, o[(C + 3968 | 0) + D | 0]), sA(I = C + 3808 | 0, A, C), Y(c = C + 3688 | 0, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), D = D - 1 | 0;);
                                        HA(C, n, o[C + 3968 | 0]), sA(I, A, C), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), h = C + 4032 | 0;
                                    }
                                    function x(A, I, g, C) {
                                        var _$B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N, S, G, M, b, _$K, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0;
                                        h = _$B = h - 320 | 0, _$d = 32 - g | 0, _$H = Hg((Y = _$B + 256 | 0) + g | 0, 0, g >>> 0 <= 31 ? _$d : 0), Sg(Y, I, g), o = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, r = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, e = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, y = a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24, s = a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24, I = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, D = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, p = a[C + 112 | 0] | a[C + 113 | 0] << 8 | a[C + 114 | 0] << 16 | a[C + 115 | 0] << 24, J = a[C + 96 | 0] | a[C + 97 | 0] << 8 | a[C + 98 | 0] << 16 | a[C + 99 | 0] << 24, _$U = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, w = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, f = a[C + 116 | 0] | a[C + 117 | 0] << 8 | a[C + 118 | 0] << 16 | a[C + 119 | 0] << 24, l = a[C + 100 | 0] | a[C + 101 | 0] << 8 | a[C + 102 | 0] << 16 | a[C + 103 | 0] << 24, _$m = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, n = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, k = a[C + 120 | 0] | a[C + 121 | 0] << 8 | a[C + 122 | 0] << 16 | a[C + 123 | 0] << 24, u = a[C + 104 | 0] | a[C + 105 | 0] << 8 | a[C + 106 | 0] << 16 | a[C + 107 | 0] << 24, F = E[_$B + 256 >> 2], _$N = E[_$B + 260 >> 2], S = E[_$B + 264 >> 2], G = E[_$B + 268 >> 2], M = E[_$B + 272 >> 2], b = E[_$B + 276 >> 2], _$K = E[_$B + 280 >> 2], Q = a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24, i = a[C + 108 | 0] | a[C + 109 | 0] << 8 | a[C + 110 | 0] << 16 | a[C + 111 | 0] << 24, E[_$B + 284 >> 2] = Q ^ i & (a[C + 124 | 0] | a[C + 125 | 0] << 8 | a[C + 126 | 0] << 16 | a[C + 127 | 0] << 24) ^ E[_$B + 284 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[_$B + 280 >> 2] = _$m ^ u & k ^ n ^ _$K, E[_$B + 276 >> 2] = _$U ^ l & f ^ w ^ b, E[_$B + 272 >> 2] = I ^ J & p ^ D ^ M, E[_$B + 268 >> 2] = s & Q ^ y ^ G ^ i, E[_$B + 264 >> 2] = u ^ _$m & e ^ r ^ S, E[_$B + 260 >> 2] = l ^ _$U & t ^ c ^ _$N, E[_$B + 256 >> 2] = J ^ I & _ ^ o ^ F, Hg(_$H, 0, _$d), Sg(A, Y, g), g = E[_$B + 284 >> 2], Y = E[_$B + 280 >> 2], J = E[_$B + 276 >> 2], _$U = E[_$B + 272 >> 2], l = E[_$B + 256 >> 2], _$m = E[_$B + 260 >> 2], u = E[_$B + 264 >> 2], _$d = E[_$B + 268 >> 2], A = E[C + 124 >> 2], E[_$B + 312 >> 2] = E[C + 120 >> 2], E[_$B + 316 >> 2] = A, A = E[C + 116 >> 2], E[_$B + 304 >> 2] = E[C + 112 >> 2], E[_$B + 308 >> 2] = A, A = E[C + 108 >> 2], E[_$B + 248 >> 2] = E[C + 104 >> 2], E[_$B + 252 >> 2] = A, A = E[C + 100 >> 2], E[_$B + 240 >> 2] = E[C + 96 >> 2], E[_$B + 244 >> 2] = A, A = E[C + 124 >> 2], E[_$B + 232 >> 2] = E[C + 120 >> 2], E[_$B + 236 >> 2] = A, A = E[C + 116 >> 2], E[_$B + 224 >> 2] = E[C + 112 >> 2], E[_$B + 228 >> 2] = A, $A(I = _$B + 288 | 0, _$B + 240 | 0, _$B + 224 | 0), A = E[_$B + 300 >> 2], E[C + 120 >> 2] = E[_$B + 296 >> 2], E[C + 124 >> 2] = A, A = E[_$B + 292 >> 2], E[C + 112 >> 2] = E[_$B + 288 >> 2], E[C + 116 >> 2] = A, A = E[C + 92 >> 2], E[_$B + 216 >> 2] = E[C + 88 >> 2], E[_$B + 220 >> 2] = A, A = E[C + 84 >> 2], E[_$B + 208 >> 2] = E[C + 80 >> 2], E[_$B + 212 >> 2] = A, A = E[C + 108 >> 2], E[_$B + 200 >> 2] = E[C + 104 >> 2], E[_$B + 204 >> 2] = A, A = E[C + 100 >> 2], E[_$B + 192 >> 2] = E[C + 96 >> 2], E[_$B + 196 >> 2] = A, $A(I, _$B + 208 | 0, _$B + 192 | 0), A = E[_$B + 300 >> 2], E[C + 104 >> 2] = E[_$B + 296 >> 2], E[C + 108 >> 2] = A, A = E[_$B + 292 >> 2], E[C + 96 >> 2] = E[_$B + 288 >> 2], E[C + 100 >> 2] = A, A = E[C + 76 >> 2], E[_$B + 184 >> 2] = E[C + 72 >> 2], E[_$B + 188 >> 2] = A, _$H = E[4 + (A = C - -64 | 0) >> 2], E[_$B + 176 >> 2] = E[A >> 2], E[_$B + 180 >> 2] = _$H, _$H = E[C + 92 >> 2], E[_$B + 168 >> 2] = E[C + 88 >> 2], E[_$B + 172 >> 2] = _$H, _$H = E[C + 84 >> 2], E[_$B + 160 >> 2] = E[C + 80 >> 2], E[_$B + 164 >> 2] = _$H, $A(I, _$B + 176 | 0, _$B + 160 | 0), _$H = E[_$B + 300 >> 2], E[C + 88 >> 2] = E[_$B + 296 >> 2], E[C + 92 >> 2] = _$H, _$H = E[_$B + 292 >> 2], E[C + 80 >> 2] = E[_$B + 288 >> 2], E[C + 84 >> 2] = _$H, _$H = E[C + 60 >> 2], E[_$B + 152 >> 2] = E[C + 56 >> 2], E[_$B + 156 >> 2] = _$H, _$H = E[C + 52 >> 2], E[_$B + 144 >> 2] = E[C + 48 >> 2], E[_$B + 148 >> 2] = _$H, _$H = E[C + 76 >> 2], E[_$B + 136 >> 2] = E[C + 72 >> 2], E[_$B + 140 >> 2] = _$H, _$H = E[A + 4 >> 2], E[_$B + 128 >> 2] = E[A >> 2], E[_$B + 132 >> 2] = _$H, $A(I, _$B + 144 | 0, _$B + 128 | 0), _$H = E[_$B + 300 >> 2], E[C + 72 >> 2] = E[_$B + 296 >> 2], E[C + 76 >> 2] = _$H, _$H = E[_$B + 292 >> 2], E[A >> 2] = E[_$B + 288 >> 2], E[A + 4 >> 2] = _$H, _$H = E[C + 44 >> 2], E[_$B + 120 >> 2] = E[C + 40 >> 2], E[_$B + 124 >> 2] = _$H, _$H = E[C + 36 >> 2], E[_$B + 112 >> 2] = E[C + 32 >> 2], E[_$B + 116 >> 2] = _$H, _$H = E[C + 60 >> 2], E[_$B + 104 >> 2] = E[C + 56 >> 2], E[_$B + 108 >> 2] = _$H, _$H = E[C + 52 >> 2], E[_$B + 96 >> 2] = E[C + 48 >> 2], E[_$B + 100 >> 2] = _$H, $A(I, _$B + 112 | 0, _$B + 96 | 0), _$H = E[_$B + 300 >> 2], E[C + 56 >> 2] = E[_$B + 296 >> 2], E[C + 60 >> 2] = _$H, _$H = E[_$B + 292 >> 2], E[C + 48 >> 2] = E[_$B + 288 >> 2], E[C + 52 >> 2] = _$H, _$H = E[C + 28 >> 2], E[_$B + 88 >> 2] = E[C + 24 >> 2], E[_$B + 92 >> 2] = _$H, _$H = E[C + 20 >> 2], E[_$B + 80 >> 2] = E[C + 16 >> 2], E[_$B + 84 >> 2] = _$H, _$H = E[C + 44 >> 2], E[_$B + 72 >> 2] = E[C + 40 >> 2], E[_$B + 76 >> 2] = _$H, _$H = E[C + 36 >> 2], E[_$B + 64 >> 2] = E[C + 32 >> 2], E[_$B + 68 >> 2] = _$H, $A(I, _$B + 80 | 0, _$B - -64 | 0), _$H = E[_$B + 300 >> 2], E[C + 40 >> 2] = E[_$B + 296 >> 2], E[C + 44 >> 2] = _$H, _$H = E[_$B + 292 >> 2], E[C + 32 >> 2] = E[_$B + 288 >> 2], E[C + 36 >> 2] = _$H, _$H = E[C + 12 >> 2], E[_$B + 56 >> 2] = E[C + 8 >> 2], E[_$B + 60 >> 2] = _$H, _$H = E[C + 4 >> 2], E[_$B + 48 >> 2] = E[C >> 2], E[_$B + 52 >> 2] = _$H, _$H = E[C + 28 >> 2], E[_$B + 40 >> 2] = E[C + 24 >> 2], E[_$B + 44 >> 2] = _$H, _$H = E[C + 20 >> 2], E[_$B + 32 >> 2] = E[C + 16 >> 2], E[_$B + 36 >> 2] = _$H, $A(I, _$B + 48 | 0, _$B + 32 | 0), _$H = E[_$B + 300 >> 2], E[C + 24 >> 2] = E[_$B + 296 >> 2], E[C + 28 >> 2] = _$H, _$H = E[_$B + 292 >> 2], E[C + 16 >> 2] = E[_$B + 288 >> 2], E[C + 20 >> 2] = _$H, _$H = E[_$B + 316 >> 2], E[_$B + 24 >> 2] = E[_$B + 312 >> 2], E[_$B + 28 >> 2] = _$H, _$H = E[_$B + 308 >> 2], E[_$B + 16 >> 2] = E[_$B + 304 >> 2], E[_$B + 20 >> 2] = _$H, _$H = E[C + 12 >> 2], E[_$B + 8 >> 2] = E[C + 8 >> 2], E[_$B + 12 >> 2] = _$H, _$H = E[C + 4 >> 2], E[_$B >> 2] = E[C >> 2], E[_$B + 4 >> 2] = _$H, $A(I, _$B + 16 | 0, _$B), I = E[_$B + 300 >> 2], E[C + 8 >> 2] = E[_$B + 296 >> 2], E[C + 12 >> 2] = I, I = E[_$B + 292 >> 2], E[C >> 2] = E[_$B + 288 >> 2], E[C + 4 >> 2] = I, E[C + 12 >> 2] = _$d ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), E[C + 8 >> 2] = u ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), E[C + 4 >> 2] = _$m ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24), E[C >> 2] = l ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), E[A >> 2] = _$U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[C + 68 >> 2] = J ^ (a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24), E[C + 72 >> 2] = Y ^ (a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24), E[C + 76 >> 2] = g ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24), h = _$B + 320 | 0;
                                    }
                                    function R(A, I) {
                                        var g, C, _$B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, _$N, S, G, M, b, _$K, _$H, Y, _$d, J, _$U, l, _$m, u, x, R, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0;
                                        v = Ig(C = (D = E[I + 12 >> 2]) << 1, o = C >> 31, $ = (q = E[I + 4 >> 2]) << 1, _$B = $ >> 31), P = w, F = Z = E[I + 8 >> 2], L = (_$W = Ig(Z, p = Z >> 31, Z, p)) + v | 0, v = w + P | 0, v = L >>> 0 < _$W >>> 0 ? v + 1 | 0 : v, P = Ig(j = E[I + 16 >> 2], a = j >> 31, _$W = (_$z = E[I >> 2]) << 1, Q = _$W >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, e = E[I + 28 >> 2], P = Ig(BA = c(e, 38), f = BA >> 31, e, _$N = e >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, P = L, y = E[I + 32 >> 2], _$X = Ig(O = c(y, 19), _ = O >> 31, L = (g = E[I + 24 >> 2]) << 1, L >> 31), L = w + v | 0, L = (P = P + _$X | 0) >>> 0 < _$X >>> 0 ? L + 1 | 0 : L, Y = E[I + 36 >> 2], v = Ig(_$X = c(Y, 38), i = _$X >> 31, _$AA = (t = E[I + 20 >> 2]) << 1, s = _$AA >> 31), I = w + L | 0, J = v = (v >>> 0 > (P = v + P | 0) >>> 0 ? I + 1 | 0 : I) << 1 | P >>> 31, _$U = L = 33554432 + (S = P << 1) | 0, l = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, T = (67108863 & v) << 6 | L >>> 26, v = Ig($, _$B, j, a), P = w, L = (IA = Ig(Z <<= 1, h = Z >> 31, D, G = D >> 31)) + v | 0, v = w + P | 0, v = L >>> 0 < IA >>> 0 ? v + 1 | 0 : v, P = (IA = Ig(t, n = t >> 31, _$W, Q)) + L | 0, L = w + v | 0, L = P >>> 0 < IA >>> 0 ? L + 1 | 0 : L, iA = Ig(O, _, IA = e << 1, M = IA >> 31), v = w + L | 0, v = (P = iA + P | 0) >>> 0 < iA >>> 0 ? v + 1 | 0 : v, L = Ig(_$X, i, g, r = g >> 31), v = w + v | 0, I = I + (L = (L >>> 0 > (P = L + P | 0) >>> 0 ? v + 1 | 0 : v) << 1 | P >>> 31) | 0, iA = P = (v = P << 1) + T | 0, v = I = v >>> 0 > P >>> 0 ? I + 1 | 0 : I, _$m = P = P + 16777216 | 0, T = (33554431 & (v = P >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | P >>> 25, P = v >> 25, I = Ig(C, o, D, G), v = w, L = Ig(j, a, Z, h), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, _$B, _$AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (_$gA = Ig(_$W, Q, g, r)) + I | 0, I = w + v | 0, I = L >>> 0 < _$gA >>> 0 ? I + 1 | 0 : I, _$gA = Ig(O, _, y, k = y >> 31), v = w + I | 0, v = (L = _$gA + L | 0) >>> 0 < _$gA >>> 0 ? v + 1 | 0 : v, I = (_$gA = Ig(_$X, i, IA, M)) + L | 0, L = w + v | 0, I = ((v = I) >>> 0 < _$gA >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = T, T = v << 1, v = I + P | 0, v = (L = L + T | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, _$gA = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 24 >> 2] = L - (-67108864 & I), L = Ig(I = c(t, 38), I >> 31, t, n), T = w, I = (v = Ig(I = _$z, v = I >> 31, I, v)) + L | 0, L = w + T | 0, L = I >>> 0 < v >>> 0 ? L + 1 | 0 : L, CA = Ig(_$z = c(g, 19), b = _$z >> 31, T = j << 1, _$K = T >> 31), v = w + L | 0, v = (I = CA + I | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (CA = Ig(O, _, Z, h)) + I | 0, I = w + v | 0, I = L >>> 0 < CA >>> 0 ? I + 1 | 0 : I, CA = Ig($, _$B, _$X, i), v = w + I | 0, CA = v = ((L = CA + L | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v) << 1 | L >>> 31, u = I = 33554432 + (_$H = L << 1) | 0, x = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, QA = (67108863 & L) << 6 | I >>> 26, oA = L >> 26, I = Ig(_$z, b, _$AA, s), v = w, L = Ig(_$W, Q, q, _$d = q >> 31), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (V = Ig(j, a, BA, f)) + I | 0, I = w + v | 0, I = L >>> 0 < V >>> 0 ? I + 1 | 0 : I, V = Ig(O, _, C, o), v = w + I | 0, v = (L = V + L | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, V = (I = Ig(_$X, i, F, p)) + L | 0, L = w + v | 0, v = (I = (I >>> 0 > V >>> 0 ? L + 1 | 0 : L) << 1 | V >>> 31) + oA | 0, v = (L = (V <<= 1) + QA | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, oA = L, V = L = L + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, QA = v >> 25, I = Ig(_$W, Q, F, p), v = w, L = Ig($, _$B, q, _$d), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, q = Ig(_$z, b, g, r), L = w + v | 0, L = (I = q + I | 0) >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(_$AA, s, BA, f), v = w + L | 0, v = (I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, L = Ig(O, _, T, _$K), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (q = Ig(_$X, i, C, o)) + I | 0, I = w + v | 0, v = (v = (L >>> 0 < q >>> 0 ? I + 1 | 0 : I) << 1 | L >>> 31) + QA | 0, _$z = I = (L <<= 1) + R | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, QA = I = I + 33554432 | 0, q = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 8 >> 2] = _$z - (-67108864 & I), I = Ig(Z, h, t, n), L = w, v = (_$z = Ig(j, a, C, o)) + I | 0, I = w + L | 0, I = v >>> 0 < _$z >>> 0 ? I + 1 | 0 : I, L = (_$z = Ig($, _$B, g, r)) + v | 0, v = w + I | 0, v = L >>> 0 < _$z >>> 0 ? v + 1 | 0 : v, I = (_$z = Ig(_$W, Q, e, _$N)) + L | 0, L = w + v | 0, L = I >>> 0 < _$z >>> 0 ? L + 1 | 0 : L, _$z = Ig(_$X, i, y, k), v = w + L | 0, v = (v = ((I = _$z + I | 0) >>> 0 < _$z >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31) + (L = P >> 26) | 0, I = (L = P = (_$z = I << 1) + (I = (67108863 & P) << 6 | _$gA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, _$z = v = L + 16777216 | 0, P = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = L - (-33554432 & v), I = Ig(_$W, Q, D, G), v = w, L = Ig($, _$B, F, p), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(g, r, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (O = Ig(O, _, _$AA, s)) + I | 0, I = w + v | 0, I = L >>> 0 < O >>> 0 ? I + 1 | 0 : I, v = (O = Ig(_$X, i, j, a)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < O >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = q >> 26) + v | 0, v = (L = L + (q = (67108863 & q) << 6 | QA >>> 26) | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, O = I = L + 16777216 | 0, q = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, E[A + 12 >> 2] = L - (-33554432 & I), I = Ig(g, r, Z, h), v = w, L = Ig(j, a, j, a), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, _$AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, _$B, IA, M), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (j = Ig(_$W, Q, y, k)) + I | 0, I = w + v | 0, I = L >>> 0 < j >>> 0 ? I + 1 | 0 : I, v = (j = Ig(v = _$X, i, _$X = Y, _$AA = _$X >> 31)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < j >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = P >> 25) + v | 0, v = (L = L + (P = (33554431 & P) << 7 | _$z >>> 25) | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, j = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 32 >> 2] = L - (-67108864 & I), v = q >> 25, L = (q = (33554431 & q) << 7 | O >>> 25) + (S - (I = -67108864 & _$U) | 0) | 0, I = v + (J - ((I >>> 0 > S >>> 0) + l | 0) | 0) | 0, I = L >>> 0 < q >>> 0 ? I + 1 | 0 : I, q = L, v = I, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? v + 1 | 0 : v)) << 6 | L >>> 26) + (BA = iA - (-33554432 & _$m) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = q - (-67108864 & L), I = Ig(C, o, g, r), L = w, v = (q = Ig(t, n, T, _$K)) + I | 0, I = w + L | 0, I = v >>> 0 < q >>> 0 ? I + 1 | 0 : I, L = (q = Ig(Z, h, e, _$N)) + v | 0, v = w + I | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, I = (q = Ig($, _$B, y, k)) + L | 0, L = w + v | 0, L = I >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(_$W, Q, _$X, _$AA), v = w + L | 0, v = ((I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31, q = I << 1, v = v + (L = P >> 26) | 0, I = (I = (67108863 & P) << 6 | j >>> 26) >>> 0 > (P = q + I | 0) >>> 0 ? v + 1 | 0 : v, I = (v = P + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = P - (-33554432 & v), q = oA - (-33554432 & V) | 0, P = _$H - (L = -67108864 & u) | 0, $ = CA - ((L >>> 0 > _$H >>> 0) + x | 0) | 0, I = Ig((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), L = w + $ | 0, P = v = I + P | 0, I = I >>> 0 > v >>> 0 ? L + 1 | 0 : L, I = ((67108863 & (I = (v = v + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + q | 0, E[A + 4 >> 2] = I, E[A >> 2] = P - (-67108864 & v);
                                    }
                                    function v(A, I) {
                                        var g, C, _$B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, _$N, S, G, M, b, _$K, _$H, Y, _$d, J, _$U, l, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0, BA = 0;
                                        _$m = Ig(C = (p = E[I + 12 >> 2]) << 1, o = C >> 31, p, _$N = p >> 31), x = w, u = (_$z = Ig(v = E[I + 16 >> 2], a = v >> 31, _ = (R = E[I + 8 >> 2]) << 1, y = _ >> 31)) + _$m | 0, _$m = w + x | 0, _$m = u >>> 0 < _$z >>> 0 ? _$m + 1 | 0 : _$m, x = (j = Ig(V = (t = E[I + 20 >> 2]) << 1, s = V >> 31, _$z = (L = E[I + 4 >> 2]) << 1, _$B = _$z >> 31)) + u | 0, u = w + _$m | 0, u = x >>> 0 < j >>> 0 ? u + 1 | 0 : u, P = Ig(g = E[I + 24 >> 2], r = g >> 31, j = (T = E[I >> 2]) << 1, Q = j >> 31), _$m = w + u | 0, _$m = (x = P + x | 0) >>> 0 < P >>> 0 ? _$m + 1 | 0 : _$m, u = x, h = E[I + 32 >> 2], x = Ig(_$X = c(h, 19), e = _$X >> 31, h, n = h >> 31), _$m = w + _$m | 0, _$m = (u = u + x | 0) >>> 0 < x >>> 0 ? _$m + 1 | 0 : _$m, _$K = E[I + 36 >> 2], x = Ig(P = c(_$K, 38), i = P >> 31, k = (D = E[I + 28 >> 2]) << 1, S = k >> 31), I = w + _$m | 0, _$W = u = x + u | 0, x = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, I = Ig(_$z, _$B, v, a), _$m = w, u = Ig(_, y, p, _$N), _$m = w + _$m | 0, _$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, q = Ig(t, F = t >> 31, j, Q), u = w + _$m | 0, u = (I = q + I | 0) >>> 0 < q >>> 0 ? u + 1 | 0 : u, q = Ig(_$X, e, k, S), _$m = w + u | 0, _$m = (I = q + I | 0) >>> 0 < q >>> 0 ? _$m + 1 | 0 : _$m, u = Ig(P, i, g, r), _$m = w + _$m | 0, CA = I = u + I | 0, O = I >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, _$m = Ig(_$z, _$B, C, o), u = w, G = I = R, R = Ig(I, Z = I >> 31, I, Z), I = w + u | 0, I = (_$m = R + _$m | 0) >>> 0 < R >>> 0 ? I + 1 | 0 : I, u = (R = Ig(j, Q, v, a)) + _$m | 0, _$m = w + I | 0, _$m = u >>> 0 < R >>> 0 ? _$m + 1 | 0 : _$m, I = (R = Ig(q = c(D, 38), f = q >> 31, D, M = D >> 31)) + u | 0, u = w + _$m | 0, u = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, I = (_$m = I) + (R = Ig(_$X, e, I = g << 1, I >> 31)) | 0, _$m = w + u | 0, _$m = I >>> 0 < R >>> 0 ? _$m + 1 | 0 : _$m, u = I, I = Ig(P, i, V, s), _$m = w + _$m | 0, _$H = u = u + I | 0, Y = _$m = I >>> 0 > u >>> 0 ? _$m + 1 | 0 : _$m, I = _$m, _$d = u = u + 33554432 | 0, J = I = u >>> 0 < 33554432 ? I + 1 | 0 : I, _$m = (_$m = I >> 26) + O | 0, CA = I = (u = (67108863 & I) << 6 | u >>> 26) + CA | 0, _$m = I >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, _$U = I = I + 16777216 | 0, _$m = (_$m = (u = I >>> 0 < 16777216 ? _$m + 1 | 0 : _$m) >> 25) + x | 0, I = (I = (33554431 & u) << 7 | I >>> 25) >>> 0 > (u = I + _$W | 0) >>> 0 ? _$m + 1 | 0 : _$m, _$W = _$m = u + 33554432 | 0, R = I = _$m >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 24 >> 2] = u - (-67108864 & _$m), I = Ig(j, Q, G, Z), _$m = w, x = Ig(_$z, _$B, L, $ = L >> 31), u = w + _$m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, O = Ig(x = c(g, 19), _$gA = x >> 31, g, r), _$m = w + u | 0, _$m = (I = O + I | 0) >>> 0 < O >>> 0 ? _$m + 1 | 0 : _$m, u = (O = Ig(V, s, q, f)) + I | 0, I = w + _$m | 0, I = u >>> 0 < O >>> 0 ? I + 1 | 0 : I, _$AA = Ig(_$X, e, O = v << 1, b = O >> 31), _$m = w + I | 0, _$m = (u = _$AA + u | 0) >>> 0 < _$AA >>> 0 ? _$m + 1 | 0 : _$m, I = u, u = Ig(P, i, C, o), _$m = w + _$m | 0, IA = I = I + u | 0, _$AA = I >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, I = Ig(V, s, x, _$gA), _$m = w, L = Ig(j, Q, L, $), u = w + _$m | 0, u = (I = L + I | 0) >>> 0 < L >>> 0 ? u + 1 | 0 : u, L = Ig(v, a, q, f), _$m = w + u | 0, _$m = (I = L + I | 0) >>> 0 < L >>> 0 ? _$m + 1 | 0 : _$m, u = (L = Ig(_$X, e, C, o)) + I | 0, I = w + _$m | 0, I = u >>> 0 < L >>> 0 ? I + 1 | 0 : I, L = Ig(P, i, G, Z), _$m = w + I | 0, BA = u = L + u | 0, $ = u >>> 0 < L >>> 0 ? _$m + 1 | 0 : _$m, u = Ig(I = c(t, 38), I >> 31, t, F), L = w, I = T, T = u, u = Ig(I, _$m = I >> 31, I, _$m), _$m = w + L | 0, _$m = (I = T + u | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, x = Ig(x, _$gA, O, b), u = w + _$m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = Ig(C, o, q, f), _$m = w + u | 0, _$m = (I = x + I | 0) >>> 0 < x >>> 0 ? _$m + 1 | 0 : _$m, u = (x = Ig(_$X, e, _, y)) + I | 0, I = w + _$m | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = Ig(_$z, _$B, P, i), _$m = w + I | 0, L = u = x + u | 0, T = _$m = u >>> 0 < x >>> 0 ? _$m + 1 | 0 : _$m, _$gA = u = u + 33554432 | 0, l = _$m = u >>> 0 < 33554432 ? _$m + 1 | 0 : _$m, I = _$m >> 26, _$m = (67108863 & _$m) << 6 | u >>> 26, u = I + $ | 0, $ = x = _$m + BA | 0, _$m = _$m >>> 0 > x >>> 0 ? u + 1 | 0 : u, BA = u = x + 16777216 | 0, x = (33554431 & (_$m = u >>> 0 < 16777216 ? _$m + 1 | 0 : _$m)) << 7 | u >>> 25, _$m = (_$m >> 25) + _$AA | 0, _$m = (u = x + IA | 0) >>> 0 < x >>> 0 ? _$m + 1 | 0 : _$m, _$AA = I = u + 33554432 | 0, x = _$m = I >>> 0 < 33554432 ? _$m + 1 | 0 : _$m, E[A + 8 >> 2] = u - (-67108864 & I), I = Ig(_, y, t, F), _$m = w, u = Ig(v, a, C, o), _$m = w + _$m | 0, _$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, u = Ig(_$z, _$B, g, r), _$m = w + _$m | 0, _$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, u = Ig(j, Q, D, M), _$m = w + _$m | 0, _$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, IA = (u = Ig(P, i, h, n)) + I | 0, I = w + _$m | 0, u = (_$m = R >> 26) + (u = u >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, _$W = I = (R = (67108863 & R) << 6 | _$W >>> 26) + IA | 0, _$m = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, IA = I = I + 16777216 | 0, R = _$m = I >>> 0 < 16777216 ? _$m + 1 | 0 : _$m, E[A + 28 >> 2] = _$W - (-33554432 & I), I = Ig(j, Q, p, _$N), u = w, _$m = (Z = Ig(_$z, _$B, G, Z)) + I | 0, I = w + u | 0, I = _$m >>> 0 < Z >>> 0 ? I + 1 | 0 : I, _$m = (q = Ig(g, r, q, f)) + _$m | 0, u = w + I | 0, I = (_$X = Ig(_$X, e, V, s)) + _$m | 0, _$m = w + (_$m >>> 0 < q >>> 0 ? u + 1 | 0 : u) | 0, _$m = I >>> 0 < _$X >>> 0 ? _$m + 1 | 0 : _$m, u = Ig(P, i, v, a), _$m = w + _$m | 0, _$m = (_$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m) + (u = x >> 26) | 0, I = (u = x = (_$W = I) + (I = (67108863 & x) << 6 | _$AA >>> 26) | 0) >>> 0 < I >>> 0 ? _$m + 1 | 0 : _$m, _$X = _$m = u + 16777216 | 0, x = I = _$m >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 12 >> 2] = u - (-33554432 & _$m), I = Ig(g, r, _, y), _$m = w, u = Ig(v, a, v, a), _$m = w + _$m | 0, _$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, u = Ig(C, o, V, s), _$m = w + _$m | 0, _$m = (I = u + I | 0) >>> 0 < u >>> 0 ? _$m + 1 | 0 : _$m, u = (v = Ig(_$z, _$B, k, S)) + I | 0, I = w + _$m | 0, I = u >>> 0 < v >>> 0 ? I + 1 | 0 : I, _$m = (v = Ig(j, Q, h, n)) + u | 0, u = w + I | 0, u = _$m >>> 0 < v >>> 0 ? u + 1 | 0 : u, I = (v = Ig(I = P, i, P = _$K, V = P >> 31)) + _$m | 0, _$m = w + u | 0, _$m = I >>> 0 < v >>> 0 ? _$m + 1 | 0 : _$m, u = I, _$m = (I = R >> 25) + _$m | 0, _$m = (u = u + (R = (33554431 & R) << 7 | IA >>> 25) | 0) >>> 0 < R >>> 0 ? _$m + 1 | 0 : _$m, v = I = u + 33554432 | 0, R = _$m = I >>> 0 < 33554432 ? _$m + 1 | 0 : _$m, E[A + 32 >> 2] = u - (-67108864 & I), _$m = x >> 25, u = (x = (33554431 & x) << 7 | _$X >>> 25) + (_$H - (I = -67108864 & _$d) | 0) | 0, I = _$m + (Y - ((I >>> 0 > _$H >>> 0) + J | 0) | 0) | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = u, I = ((67108863 & (_$m = (u = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | u >>> 26) + (q = CA - (-33554432 & _$U) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = x - (-67108864 & u), I = Ig(C, o, g, r), u = w, _$m = (x = Ig(t, F, O, b)) + I | 0, I = w + u | 0, I = _$m >>> 0 < x >>> 0 ? I + 1 | 0 : I, u = (x = Ig(_, y, D, M)) + _$m | 0, _$m = w + I | 0, _$m = u >>> 0 < x >>> 0 ? _$m + 1 | 0 : _$m, I = (x = Ig(_$z, _$B, h, n)) + u | 0, u = w + _$m | 0, u = I >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = (_$m = I) + (I = Ig(j, Q, P, V)) | 0, _$m = w + u | 0, _$m = (I = I >>> 0 > x >>> 0 ? _$m + 1 | 0 : _$m) + (_$m = R >> 26) | 0, I = (u = (R = (67108863 & R) << 6 | v >>> 26) + x | 0) >>> 0 < R >>> 0 ? _$m + 1 | 0 : _$m, I = (_$m = u + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = u - (-33554432 & _$m), R = $ - (-33554432 & BA) | 0, x = L - (u = -67108864 & _$gA) | 0, _$z = T - ((u >>> 0 > L >>> 0) + l | 0) | 0, I = Ig((33554431 & I) << 7 | _$m >>> 25, I >> 25, 19, 0), _$m = w + _$z | 0, I = I >>> 0 > (u = I + x | 0) >>> 0 ? _$m + 1 | 0 : _$m, I = ((67108863 & (I = (_$m = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | _$m >>> 26) + R | 0, E[A + 4 >> 2] = I, E[A >> 2] = u - (-67108864 & _$m);
                                    }
                                    function L(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        if (h = g = h - 48 | 0, !((C = pI(A)) || (C = -26, I - 3 >>> 0 < 4294967294))) {
                                            Q = E[A + 44 >> 2], C = E[A + 48 >> 2], E[g + 4 >> 2] = 0, _$B = E[A + 40 >> 2], E[g + 32 >> 2] = C, E[g + 16 >> 2] = -1, E[g + 12 >> 2] = _$B, C = ((r = (_$B = C << 3) >>> 0 < Q >>> 0 ? Q : _$B) >>> 0) / ((Q = C << 2) >>> 0) | 0, E[g + 24 >> 2] = C, E[g + 28 >> 2] = C << 2, E[g + 20 >> 2] = c(C, Q), C = E[A + 52 >> 2], E[g + 40 >> 2] = I, E[g + 36 >> 2] = C, f = I = h, h = C = I - 1152 & -64, I = -25;
                                            A: {
                                                if (!(!(Q = g + 4 | 0) | !A) && (_$B = K(E[Q + 20 >> 2] << 3), E[Q + 4 >> 2] = _$B, I = -22, _$B)) {
                                                    I: {
                                                        if ((I = E[Q + 16 >> 2]) && 1024 == (((_$B = I << 10) >>> 0) / (I >>> 0) | 0) && (I = K(12), E[Q >> 2] = I, I)) {
                                                            if (E[I >> 2] = 0, E[I + 4 >> 2] = 0, I = _I(C + 128 | 0, _$B), E[9392] = I, I) E[C + 128 >> 2] = 0;
                                                            else if (I = E[C + 128 >> 2]) break I;
                                                            gA(E[Q >> 2]), E[Q >> 2] = 0;
                                                        }
                                                        VI(Q, E[A + 56 >> 2]), h = f, I = -22;
                                                        break A;
                                                    }
                                                    if (E[E[Q >> 2] >> 2] = I, E[E[Q >> 2] + 4 >> 2] = I, E[E[Q >> 2] + 8 >> 2] = _$B, D = E[Q + 36 >> 2], eA(I = C + 128 | 0, 0, 0, 64), E[C + 124 >> 2] = E[A + 48 >> 2], XA(I, _$B = C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 4 >> 2], XA(I, _$B, 4, 0), E[C + 124 >> 2] = E[A + 44 >> 2], XA(I, _$B, 4, 0), E[C + 124 >> 2] = E[A + 40 >> 2], XA(I, _$B, 4, 0), E[C + 124 >> 2] = 19, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = D, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 12 >> 2], XA(C + 128 | 0, C + 124 | 0, 4, 0), (_$B = E[A + 8 >> 2]) && (XA(I, _$B, E[A + 12 >> 2], 0), 1 & o[A + 56 | 0] && (XC(E[A + 8 >> 2], E[A + 12 >> 2]), E[A + 12 >> 2] = 0)), E[C + 124 >> 2] = E[A + 20 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (_$B = E[A + 16 >> 2]) && XA(I, _$B, E[A + 20 >> 2], 0), E[C + 124 >> 2] = E[A + 28 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (_$B = E[A + 24 >> 2]) && (XA(I, _$B, E[A + 28 >> 2], 0), 2 & a[A + 56 | 0] && (XC(E[A + 24 >> 2], E[A + 28 >> 2]), E[A + 28 >> 2] = 0)), E[C + 124 >> 2] = E[A + 36 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (_$B = E[A + 32 >> 2]) && XA(I, _$B, E[A + 36 >> 2], 0), Yg(C + 128 | 0, C + 48 | 0, 64), XC(C + 112 | 0, 8), E[Q + 28 >> 2]) for(_$B = 0;;){
                                                        for(E[C + 112 >> 2] = 0, E[C + 116 >> 2] = _$B, aA(C + 128 | 0, 1024, C + 48 | 0, 72), D = E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], _$B) << 10) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, e = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = e, 128 != (0 | (I = I + 4 | 0)););
                                                        for(E[C + 112 >> 2] = 1, aA(r, 1024, C + 48 | 0, 72), D = 1024 + (E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], _$B) << 10) | 0) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, r = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = r, 128 != (0 | (I = I + 4 | 0)););
                                                        if (!((_$B = _$B + 1 | 0) >>> 0 < _[Q + 28 >> 2])) break;
                                                    }
                                                    XC(C + 128 | 0, 1024), XC(C + 48 | 0, 72), I = 0;
                                                }
                                                h = f;
                                            }
                                            if (C = I, !I) {
                                                if (E[g + 12 >> 2]) for(;;){
                                                    if (h = I = h - 80 | 0, !(!(Q = g + 4 | 0) | !E[Q + 28 >> 2])) {
                                                        for(o[I + 72 | 0] = 0, E[I + 64 >> 2] = y, C = 0; E[I + 76 >> 2] = 0, _$B = E[I + 76 >> 2], E[I + 56 >> 2] = E[I + 72 >> 2], E[I + 60 >> 2] = _$B, E[I + 68 >> 2] = C, _$B = E[I + 68 >> 2], E[I + 48 >> 2] = E[I + 64 >> 2], E[I + 52 >> 2] = _$B, S(Q, I + 48 | 0), (C = C + 1 | 0) >>> 0 < (_$B = E[Q + 28 >> 2]) >>> 0;);
                                                        if (o[I + 72 | 0] = 1, _$B) {
                                                            for(C = 0; E[I + 76 >> 2] = 0, _$B = E[I + 76 >> 2], E[I + 40 >> 2] = E[I + 72 >> 2], E[I + 44 >> 2] = _$B, E[I + 68 >> 2] = C, _$B = E[I + 68 >> 2], E[I + 32 >> 2] = E[I + 64 >> 2], E[I + 36 >> 2] = _$B, S(Q, I + 32 | 0), (C = C + 1 | 0) >>> 0 < (_$B = E[Q + 28 >> 2]) >>> 0;);
                                                            if (o[I + 72 | 0] = 2, _$B) {
                                                                for(C = 0; E[I + 76 >> 2] = 0, _$B = E[I + 76 >> 2], E[I + 24 >> 2] = E[I + 72 >> 2], E[I + 28 >> 2] = _$B, E[I + 68 >> 2] = C, _$B = E[I + 68 >> 2], E[I + 16 >> 2] = E[I + 64 >> 2], E[I + 20 >> 2] = _$B, S(Q, I + 16 | 0), (C = C + 1 | 0) >>> 0 < (_$B = E[Q + 28 >> 2]) >>> 0;);
                                                                if (o[I + 72 | 0] = 3, _$B) for(C = 0; E[I + 76 >> 2] = 0, _$B = E[I + 76 >> 2], E[I + 8 >> 2] = E[I + 72 >> 2], E[I + 12 >> 2] = _$B, E[I + 68 >> 2] = C, _$B = E[I + 68 >> 2], E[I >> 2] = E[I + 64 >> 2], E[I + 4 >> 2] = _$B, S(Q, I), (C = C + 1 | 0) >>> 0 < _[Q + 28 >> 2];);
                                                            }
                                                        }
                                                    }
                                                    if (h = I + 80 | 0, !((y = y + 1 | 0) >>> 0 < _[g + 12 >> 2])) break;
                                                }
                                                if (h = I = h - 2048 | 0, !(!A | !(C = g + 4 | 0))) {
                                                    if (i = E[C >> 2], f = E[C + 24 >> 2], Sg(I + 1024 | 0, (E[i + 4 >> 2] + (f << 10) | 0) - 1024 | 0, 1024), (e = E[C + 28 >> 2]) >>> 0 >= 2) for(p = f - 1 | 0, D = 1;;){
                                                        for(Q = E[i + 4 >> 2] + (c(D, f) + p << 10) | 0, t = 0; s = E[(y = (_$B = t << 3) + (r = I + 1024 | 0) | 0) >> 2], n = E[(w = _$B + Q | 0) >> 2], w = E[y + 4 >> 2] ^ E[w + 4 >> 2], E[y >> 2] = s ^ n, E[y + 4 >> 2] = w, w = E[(y = (s = 8 | _$B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, w = E[(y = (s = 16 | _$B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, y = E[(_$B = (y = r) + (r = 24 | _$B) | 0) >> 2], s = E[(r = Q + r | 0) >> 2], r = E[_$B + 4 >> 2] ^ E[r + 4 >> 2], E[_$B >> 2] = y ^ s, E[_$B + 4 >> 2] = r, 128 != (0 | (t = t + 4 | 0)););
                                                        if ((0 | e) == (0 | (D = D + 1 | 0))) break;
                                                    }
                                                    Q = Sg(I, I + 1024 | 0, 1024), aA(E[A >> 2], E[A + 4 >> 2], Q, 1024), XC(Q + 1024 | 0, 1024), XC(Q, 1024), VI(C, E[A + 56 >> 2]);
                                                }
                                                h = I + 2048 | 0, C = 0;
                                            }
                                        }
                                        return h = g + 48 | 0, C;
                                    }
                                    function P(A, I, g) {
                                        var C, _$B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0;
                                        for(h = C = h - 288 | 0, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, D = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, c = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, t = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, r = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g + 112 | 0, A = 33620224 ^ (e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[I >> 2] = A, E[(o = g + 96 | 0) >> 2] = 1427652059 ^ e, E[(_ = g + 80 | 0) >> 2] = A, f = e ^ p, E[(A = g - -64 | 0) >> 2] = f, E[g + 56 >> 2] = 1110511904, E[g + 60 >> 2] = -584534669, E[(_$B = g + 48 | 0) >> 2] = 1427652059, E[_$B + 4 >> 2] = -248528275, E[g + 40 >> 2] = 1496785429, E[g + 44 >> 2] = 1652156816, E[(Q = g + 32 | 0) >> 2] = 33620224, E[Q + 4 >> 2] = 218629379, E[g + 24 >> 2] = 1110511904, E[g + 28 >> 2] = -584534669, E[(i = g + 16 | 0) >> 2] = 1427652059, E[i + 4 >> 2] = -248528275, E[g >> 2] = f, f = 1652156816 ^ r, E[g + 124 >> 2] = f, n = 1496785429 ^ t, E[g + 120 >> 2] = n, w = 218629379 ^ c, E[g + 116 >> 2] = w, E[g + 108 >> 2] = -584534669 ^ r, E[g + 104 >> 2] = 1110511904 ^ t, E[g + 100 >> 2] = -248528275 ^ c, E[g + 92 >> 2] = f, E[g + 88 >> 2] = n, E[g + 84 >> 2] = w, f = r ^ D, E[g + 76 >> 2] = f, n = t ^ s, E[g + 72 >> 2] = n, w = c ^ y, E[g + 68 >> 2] = w, E[g + 12 >> 2] = f, E[g + 8 >> 2] = n, E[g + 4 >> 2] = w, n = 0; f = E[I + 12 >> 2], E[C + 280 >> 2] = E[I + 8 >> 2], E[C + 284 >> 2] = f, f = E[I + 4 >> 2], E[C + 272 >> 2] = E[I >> 2], E[C + 276 >> 2] = f, f = E[o + 12 >> 2], E[C + 248 >> 2] = E[o + 8 >> 2], E[C + 252 >> 2] = f, f = E[o + 4 >> 2], E[C + 240 >> 2] = E[o >> 2], E[C + 244 >> 2] = f, f = E[I + 12 >> 2], E[C + 232 >> 2] = E[I + 8 >> 2], E[C + 236 >> 2] = f, f = E[I + 4 >> 2], E[C + 224 >> 2] = E[I >> 2], E[C + 228 >> 2] = f, $A(f = C + 256 | 0, C + 240 | 0, C + 224 | 0), w = E[C + 268 >> 2], E[I + 8 >> 2] = E[C + 264 >> 2], E[I + 12 >> 2] = w, w = E[C + 260 >> 2], E[I >> 2] = E[C + 256 >> 2], E[I + 4 >> 2] = w, w = E[_ + 12 >> 2], E[C + 216 >> 2] = E[_ + 8 >> 2], E[C + 220 >> 2] = w, w = E[_ + 4 >> 2], E[C + 208 >> 2] = E[_ >> 2], E[C + 212 >> 2] = w, w = E[o + 12 >> 2], E[C + 200 >> 2] = E[o + 8 >> 2], E[C + 204 >> 2] = w, w = E[o + 4 >> 2], E[C + 192 >> 2] = E[o >> 2], E[C + 196 >> 2] = w, $A(f, C + 208 | 0, C + 192 | 0), w = E[C + 268 >> 2], E[o + 8 >> 2] = E[C + 264 >> 2], E[o + 12 >> 2] = w, w = E[C + 260 >> 2], E[o >> 2] = E[C + 256 >> 2], E[o + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 184 >> 2] = E[A + 8 >> 2], E[C + 188 >> 2] = w, w = E[A + 4 >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = w, w = E[_ + 12 >> 2], E[C + 168 >> 2] = E[_ + 8 >> 2], E[C + 172 >> 2] = w, w = E[_ + 4 >> 2], E[C + 160 >> 2] = E[_ >> 2], E[C + 164 >> 2] = w, $A(f, C + 176 | 0, C + 160 | 0), w = E[C + 268 >> 2], E[_ + 8 >> 2] = E[C + 264 >> 2], E[_ + 12 >> 2] = w, w = E[C + 260 >> 2], E[_ >> 2] = E[C + 256 >> 2], E[_ + 4 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 152 >> 2] = E[_$B + 8 >> 2], E[C + 156 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 144 >> 2] = E[_$B >> 2], E[C + 148 >> 2] = w, w = E[A + 12 >> 2], E[C + 136 >> 2] = E[A + 8 >> 2], E[C + 140 >> 2] = w, w = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = w, $A(f, C + 144 | 0, C + 128 | 0), w = E[C + 268 >> 2], E[A + 8 >> 2] = E[C + 264 >> 2], E[A + 12 >> 2] = w, w = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = w, w = E[Q + 12 >> 2], E[C + 120 >> 2] = E[Q + 8 >> 2], E[C + 124 >> 2] = w, w = E[Q + 4 >> 2], E[C + 112 >> 2] = E[Q >> 2], E[C + 116 >> 2] = w, w = E[_$B + 12 >> 2], E[C + 104 >> 2] = E[_$B + 8 >> 2], E[C + 108 >> 2] = w, w = E[_$B + 4 >> 2], E[C + 96 >> 2] = E[_$B >> 2], E[C + 100 >> 2] = w, $A(f, C + 112 | 0, C + 96 | 0), w = E[C + 268 >> 2], E[_$B + 8 >> 2] = E[C + 264 >> 2], E[_$B + 12 >> 2] = w, w = E[C + 260 >> 2], E[_$B >> 2] = E[C + 256 >> 2], E[_$B + 4 >> 2] = w, w = E[i + 12 >> 2], E[C + 88 >> 2] = E[i + 8 >> 2], E[C + 92 >> 2] = w, w = E[i + 4 >> 2], E[C + 80 >> 2] = E[i >> 2], E[C + 84 >> 2] = w, w = E[Q + 12 >> 2], E[C + 72 >> 2] = E[Q + 8 >> 2], E[C + 76 >> 2] = w, w = E[Q + 4 >> 2], E[C + 64 >> 2] = E[Q >> 2], E[C + 68 >> 2] = w, $A(f, C + 80 | 0, C - -64 | 0), w = E[C + 268 >> 2], E[Q + 8 >> 2] = E[C + 264 >> 2], E[Q + 12 >> 2] = w, w = E[C + 260 >> 2], E[Q >> 2] = E[C + 256 >> 2], E[Q + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[i + 12 >> 2], E[C + 40 >> 2] = E[i + 8 >> 2], E[C + 44 >> 2] = w, w = E[i + 4 >> 2], E[C + 32 >> 2] = E[i >> 2], E[C + 36 >> 2] = w, $A(f, C + 48 | 0, C + 32 | 0), w = E[C + 268 >> 2], E[i + 8 >> 2] = E[C + 264 >> 2], E[i + 12 >> 2] = w, w = E[C + 260 >> 2], E[i >> 2] = E[C + 256 >> 2], E[i + 4 >> 2] = w, w = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = w, w = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(f, C + 16 | 0, C), f = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = f, f = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = f, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ D, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ s, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ y, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ e, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ c, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ t, E[g + 76 >> 2] = (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ r, 10 != (0 | (n = n + 1 | 0)););
                                        h = C + 288 | 0;
                                    }
                                    function q(A, I, g, C, B) {
                                        var Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0;
                                        for(Q = h + -64 | 0, i = E[A + 60 >> 2], _ = E[A + 56 >> 2], P = E[A + 52 >> 2], L = E[A + 48 >> 2], c = E[A + 44 >> 2], t = E[A + 40 >> 2], r = E[A + 36 >> 2], e = E[A + 32 >> 2], y = E[A + 28 >> 2], s = E[A + 24 >> 2], D = E[A + 20 >> 2], p = E[A + 16 >> 2], w = E[A + 12 >> 2], f = E[A + 8 >> 2], n = E[A + 4 >> 2], k = E[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) F = g;
                                            else {
                                                if (E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, E[Q + 8 >> 2] = 0, E[Q + 12 >> 2] = 0, E[Q >> 2] = 0, E[Q + 4 >> 2] = 0, S = 0, C | B) for(; o[S + Q | 0] = a[I + S | 0], !B & (S = S + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = F = Q, O = g;
                                            }
                                            for(q = 20, _$N = k, _$d = n, J = f, _$m = w, S = p, g = D, M = s, b = y, _$K = e, x = r, _$U = t, G = i, R = _, u = P, l = L, _$H = c; Y = S, _$N = Lg((S = _$N + S | 0) ^ l, 16), Y = l = Lg(Y ^ (_$K = _$N + _$K | 0), 12), l = Lg((v = S + l | 0) ^ _$N, 8), S = Lg(Y ^ (_$K = l + _$K | 0), 7), G = Lg((_$N = b + _$m | 0) ^ G, 16), b = Lg((_$H = G + _$H | 0) ^ b, 12), _$m = Lg((J = M + J | 0) ^ R, 16), M = Lg((_$U = _$m + _$U | 0) ^ M, 12), R = (_$z = _$N + b | 0) + S | 0, j = Lg((J = M + J | 0) ^ _$m, 8), _$N = Lg(R ^ j, 16), _$m = Lg((_$d = g + _$d | 0) ^ u, 16), g = Lg((x = _$m + x | 0) ^ g, 12), Y = S, u = Lg((_$d = g + _$d | 0) ^ _$m, 8), Y = Lg(Y ^ (S = (_$X = u + x | 0) + _$N | 0), 12), R = Lg(_$N ^ (_$m = Y + R | 0), 8), S = Lg((x = R + S | 0) ^ Y, 7), Y = _$K, _$K = J, _$N = Lg(G ^ _$z, 8), J = Lg((G = _$N + _$H | 0) ^ b, 7), u = Lg((_$K = _$K + J | 0) ^ u, 16), _$H = Lg((b = Y + u | 0) ^ J, 12), u = Lg(u ^ (J = _$H + _$K | 0), 8), b = Lg((_$K = b + u | 0) ^ _$H, 7), _$H = G, G = _$d, _$d = Lg((_$U = _$U + j | 0) ^ M, 7), M = _$H + (l = Lg((G = G + _$d | 0) ^ l, 16)) | 0, _$H = G, G = Lg(M ^ _$d, 12), l = Lg(l ^ (_$d = _$H + G | 0), 8), M = Lg((_$H = M + l | 0) ^ G, 7), Y = _$U, G = _$N, _$N = Lg(g ^ _$X, 7), G = Lg(G ^ (_$U = _$N + v | 0), 16), v = Lg((g = Y + G | 0) ^ _$N, 12), G = Lg(G ^ (_$N = v + _$U | 0), 8), g = Lg((_$U = g + G | 0) ^ v, 7), q = q - 2 | 0;);
                                            if (q = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, v = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, _$z = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, j = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, _$X = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, V = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Z = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, _$W = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, T = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, _$AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, _$gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, _$N = _$N + k ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[0 | F] = _$N, o[F + 1 | 0] = _$N >>> 8, o[F + 2 | 0] = _$N >>> 16, o[F + 3 | 0] = _$N >>> 24, _$N = G + i ^ CA, o[F + 60 | 0] = _$N, o[F + 61 | 0] = _$N >>> 8, o[F + 62 | 0] = _$N >>> 16, o[F + 63 | 0] = _$N >>> 24, _$N = R + _ ^ _$gA, o[F + 56 | 0] = _$N, o[F + 57 | 0] = _$N >>> 8, o[F + 58 | 0] = _$N >>> 16, o[F + 59 | 0] = _$N >>> 24, _$N = u + P ^ IA, o[F + 52 | 0] = _$N, o[F + 53 | 0] = _$N >>> 8, o[F + 54 | 0] = _$N >>> 16, o[F + 55 | 0] = _$N >>> 24, _$N = l + L ^ _$AA, o[F + 48 | 0] = _$N, o[F + 49 | 0] = _$N >>> 8, o[F + 50 | 0] = _$N >>> 16, o[F + 51 | 0] = _$N >>> 24, _$N = _$H + c ^ $, o[F + 44 | 0] = _$N, o[F + 45 | 0] = _$N >>> 8, o[F + 46 | 0] = _$N >>> 16, o[F + 47 | 0] = _$N >>> 24, _$N = _$U + t ^ T, o[F + 40 | 0] = _$N, o[F + 41 | 0] = _$N >>> 8, o[F + 42 | 0] = _$N >>> 16, o[F + 43 | 0] = _$N >>> 24, _$N = x + r ^ _$W, o[F + 36 | 0] = _$N, o[F + 37 | 0] = _$N >>> 8, o[F + 38 | 0] = _$N >>> 16, o[F + 39 | 0] = _$N >>> 24, _$N = _$K + e ^ Z, o[F + 32 | 0] = _$N, o[F + 33 | 0] = _$N >>> 8, o[F + 34 | 0] = _$N >>> 16, o[F + 35 | 0] = _$N >>> 24, b = b + y ^ V, o[F + 28 | 0] = b, o[F + 29 | 0] = b >>> 8, o[F + 30 | 0] = b >>> 16, o[F + 31 | 0] = b >>> 24, M = Y ^ M + s, o[F + 24 | 0] = M, o[F + 25 | 0] = M >>> 8, o[F + 26 | 0] = M >>> 16, o[F + 27 | 0] = M >>> 24, g = _$X ^ g + D, o[F + 20 | 0] = g, o[F + 21 | 0] = g >>> 8, o[F + 22 | 0] = g >>> 16, o[F + 23 | 0] = g >>> 24, g = j ^ S + p, o[F + 16 | 0] = g, o[F + 17 | 0] = g >>> 8, o[F + 18 | 0] = g >>> 16, o[F + 19 | 0] = g >>> 24, g = _$z ^ _$m + w, o[F + 12 | 0] = g, o[F + 13 | 0] = g >>> 8, o[F + 14 | 0] = g >>> 16, o[F + 15 | 0] = g >>> 24, g = v ^ J + f, o[F + 8 | 0] = g, o[F + 9 | 0] = g >>> 8, o[F + 10 | 0] = g >>> 16, o[F + 11 | 0] = g >>> 24, g = q ^ _$d + n, o[F + 4 | 0] = g, o[F + 5 | 0] = g >>> 8, o[F + 6 | 0] = g >>> 16, o[F + 7 | 0] = g >>> 24, P = !(L = L + 1 | 0) + P | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(S = 0; o[S + O | 0] = a[F + S | 0], C >>> 0 > (S = S + 1 | 0) >>> 0;);
                                                E[A + 52 >> 2] = P, E[A + 48 >> 2] = L;
                                                break;
                                            }
                                            I = I - -64 | 0, g = F - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function z(A, I) {
                                        I |= 0;
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, a = 0, _ = 0, c = 0;
                                        return h = g = h - 704 | 0, C = 80 + ((_$B = E[72 + (A |= 0) >> 2] >>> 3 & 127) + A | 0) | 0, _$B >>> 0 >= 112 ? (Sg(C, 35456, 128 - _$B | 0), F(A, _$B = A + 80 | 0, g, g + 640 | 0), Hg(_$B, 0, 112)) : Sg(C, 35456, 112 - _$B | 0), _ = (Q = E[A + 64 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 192 | 0] = C, o[A + 193 | 0] = C >>> 8, o[A + 194 | 0] = C >>> 16, o[A + 195 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[A + 196 | 0] = _$B, o[A + 197 | 0] = _$B >>> 8, o[A + 198 | 0] = _$B >>> 16, o[A + 199 | 0] = _$B >>> 24, _ = (Q = E[A + 72 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 200 | 0] = C, o[A + 201 | 0] = C >>> 8, o[A + 202 | 0] = C >>> 16, o[A + 203 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[A + 204 | 0] = _$B, o[A + 205 | 0] = _$B >>> 8, o[A + 206 | 0] = _$B >>> 16, o[A + 207 | 0] = _$B >>> 24, F(A, A + 80 | 0, g, g + 640 | 0), _ = (Q = E[A >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[0 | I] = C, o[I + 1 | 0] = C >>> 8, o[I + 2 | 0] = C >>> 16, o[I + 3 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 4 | 0] = _$B, o[I + 5 | 0] = _$B >>> 8, o[I + 6 | 0] = _$B >>> 16, o[I + 7 | 0] = _$B >>> 24, _ = (Q = E[A + 8 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 8 | 0] = C, o[I + 9 | 0] = C >>> 8, o[I + 10 | 0] = C >>> 16, o[I + 11 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 12 | 0] = _$B, o[I + 13 | 0] = _$B >>> 8, o[I + 14 | 0] = _$B >>> 16, o[I + 15 | 0] = _$B >>> 24, _ = (Q = E[A + 16 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 16 | 0] = C, o[I + 17 | 0] = C >>> 8, o[I + 18 | 0] = C >>> 16, o[I + 19 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 20 | 0] = _$B, o[I + 21 | 0] = _$B >>> 8, o[I + 22 | 0] = _$B >>> 16, o[I + 23 | 0] = _$B >>> 24, _ = (Q = E[A + 24 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 24 | 0] = C, o[I + 25 | 0] = C >>> 8, o[I + 26 | 0] = C >>> 16, o[I + 27 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 28 | 0] = _$B, o[I + 29 | 0] = _$B >>> 8, o[I + 30 | 0] = _$B >>> 16, o[I + 31 | 0] = _$B >>> 24, _ = (Q = E[A + 32 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 32 | 0] = C, o[I + 33 | 0] = C >>> 8, o[I + 34 | 0] = C >>> 16, o[I + 35 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 36 | 0] = _$B, o[I + 37 | 0] = _$B >>> 8, o[I + 38 | 0] = _$B >>> 16, o[I + 39 | 0] = _$B >>> 24, _ = (Q = E[A + 40 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 44 | 0] = _$B, o[I + 45 | 0] = _$B >>> 8, o[I + 46 | 0] = _$B >>> 16, o[I + 47 | 0] = _$B >>> 24, _ = (Q = E[A + 48 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 48 | 0] = C, o[I + 49 | 0] = C >>> 8, o[I + 50 | 0] = C >>> 16, o[I + 51 | 0] = C >>> 24, _$B = (C = _$B | i | _) | (_$B = 0) | _$B | 0, o[I + 52 | 0] = _$B, o[I + 53 | 0] = _$B >>> 8, o[I + 54 | 0] = _$B >>> 16, o[I + 55 | 0] = _$B >>> 24, _ = (Q = E[A + 56 >> 2]) << 24 | (65280 & Q) << 8, _$B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = E[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, o[C + 56 | 0] = I, o[C + 57 | 0] = I >>> 8, o[C + 58 | 0] = I >>> 16, o[C + 59 | 0] = I >>> 24, I = (I = _$B | i | _) | (_$B = 0) | _$B | 0, o[C + 60 | 0] = I, o[C + 61 | 0] = I >>> 8, o[C + 62 | 0] = I >>> 16, o[C + 63 | 0] = I >>> 24, XC(g, 704), XC(A, 208), h = g + 704 | 0, 0;
                                    }
                                    function j(A, I, g) {
                                        var C, _$B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N, S, G = 0;
                                        h = C = h - 224 | 0, c = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, t = a[0 | (G = g - -64 | 0)] | a[G + 1 | 0] << 8 | a[G + 2 | 0] << 16 | a[G + 3 | 0] << 24, r = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, e = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, y = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, _$B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, D = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, p = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, w = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, f = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, F = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, _$N = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, S = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (_ = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = _$N & S ^ k ^ F ^ n ^ Q, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = w & f ^ D ^ p ^ s ^ _$B, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = e & y ^ c ^ t ^ r ^ i, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[G + 4 >> 2], E[C + 176 >> 2] = E[G >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), I = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = I, I = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = I, I = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = I, I = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = I, I = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = I, I = E[G + 4 >> 2], E[C + 128 >> 2] = E[G >> 2], E[C + 132 >> 2] = I, $A(A, C + 144 | 0, C + 128 | 0), I = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = I, I = E[C + 196 >> 2], E[G >> 2] = E[C + 192 >> 2], E[G + 4 >> 2] = I, I = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = I, I = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = I, I = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = I, I = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = I, $A(A, C + 112 | 0, C + 96 | 0), I = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = I, I = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = I, I = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = I, I = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = I, I = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = I, $A(A, C + 80 | 0, C - -64 | 0), I = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = I, I = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = I, I = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = I, I = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = I, I = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = I, $A(A, C + 48 | 0, C + 32 | 0), I = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = I, I = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = I, I = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = I, I = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = I, I = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = I, I = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = I, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], I = E[C + 196 >> 2], G = E[C + 200 >> 2], E[g + 12 >> 2] = _ ^ E[C + 204 >> 2], E[g + 8 >> 2] = G ^ Q, E[g + 4 >> 2] = I ^ _$B, E[g >> 2] = A ^ i, h = C + 224 | 0;
                                    }
                                    function X(A, I, g) {
                                        var C, _$B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n = 0, k = 0, F = 0, _$N = 0, S = 0;
                                        h = C = h - 224 | 0, F = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, k = a[0 | (n = g - -64 | 0)] | a[n + 1 | 0] << 8 | a[n + 2 | 0] << 16 | a[n + 3 | 0] << 24, _$B = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Q = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, i = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, _$N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, _ = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, c = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, t = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, r = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, e = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, S = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, y = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, s = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, D = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, p = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, f = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, S = p & w ^ S ^ s ^ D ^ y, o[A + 8 | 0] = S, o[A + 9 | 0] = S >>> 8, o[A + 10 | 0] = S >>> 16, o[A + 11 | 0] = S >>> 24, _$N = r & e ^ _$N ^ c ^ t ^ _, o[A + 4 | 0] = _$N, o[A + 5 | 0] = _$N >>> 8, o[A + 6 | 0] = _$N >>> 16, o[A + 7 | 0] = _$N >>> 24, F = Q & i ^ F ^ k ^ _$B ^ f, o[0 | A] = F, o[A + 1 | 0] = F >>> 8, o[A + 2 | 0] = F >>> 16, o[A + 3 | 0] = F >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[n + 4 >> 2], E[C + 176 >> 2] = E[n >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), k = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = k, k = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = k, k = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = k, k = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = k, k = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = k, k = E[n + 4 >> 2], E[C + 128 >> 2] = E[n >> 2], E[C + 132 >> 2] = k, $A(A, C + 144 | 0, C + 128 | 0), k = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = k, k = E[C + 196 >> 2], E[n >> 2] = E[C + 192 >> 2], E[n + 4 >> 2] = k, n = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = n, n = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = n, n = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = n, n = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = n, $A(A, C + 112 | 0, C + 96 | 0), n = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = n, n = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = n, n = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = n, n = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = n, n = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = n, $A(A, C + 80 | 0, C - -64 | 0), n = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = n, n = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = n, n = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = n, n = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = n, n = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = n, $A(A, C + 48 | 0, C + 32 | 0), n = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = n, n = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = n, n = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = n, n = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = n, n = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = n, n = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = n, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], n = E[C + 196 >> 2], k = E[C + 200 >> 2], E[g + 12 >> 2] = I ^ E[C + 204 >> 2], E[g + 8 >> 2] = k ^ S, E[g + 4 >> 2] = n ^ _$N, E[g >> 2] = A ^ F, h = C + 224 | 0;
                                    }
                                    function O(A, I) {
                                        var g, C, _$B, Q, i, _, c, t, r, e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0;
                                        h = g = h - 800 | 0, y = E[(s = I + 40 | 0) >> 2], D = E[I + 80 >> 2], p = E[I + 44 >> 2], w = E[I + 84 >> 2], f = E[I + 48 >> 2], S = E[I + 88 >> 2], n = E[I + 52 >> 2], b = E[I + 92 >> 2], G = E[I + 56 >> 2], _$K = E[I + 96 >> 2], _$H = E[I + 60 >> 2], _$d = E[I + 100 >> 2], J = E[(k = I - -64 | 0) >> 2], _$U = E[I + 104 >> 2], l = E[I + 68 >> 2], _$m = E[I + 108 >> 2], u = E[I + 72 >> 2], x = E[I + 112 >> 2], F = E[I + 76 >> 2], _$N = E[I + 116 >> 2], E[g + 324 >> 2] = F + _$N, E[g + 320 >> 2] = u + x, E[g + 316 >> 2] = l + _$m, E[g + 312 >> 2] = J + _$U, E[g + 308 >> 2] = _$H + _$d, E[g + 304 >> 2] = G + _$K, E[g + 300 >> 2] = n + b, E[g + 296 >> 2] = f + S, E[g + 292 >> 2] = p + w, E[g + 288 >> 2] = y + D, E[g + 36 >> 2] = _$N - F, E[g + 32 >> 2] = x - u, E[g + 28 >> 2] = _$m - l, E[g + 24 >> 2] = _$U - J, E[g + 20 >> 2] = _$d - _$H, E[g + 16 >> 2] = _$K - G, E[g + 12 >> 2] = b - n, E[g + 8 >> 2] = S - f, E[g + 4 >> 2] = w - p, E[g >> 2] = D - y, Y(y = g + 288 | 0, y, g), Y(p = g + 240 | 0, I, s), v(D = g + 192 | 0, p), Y(D, y, D), E[g + 452 >> 2] = 0, E[g + 456 >> 2] = 0, E[g + 460 >> 2] = 0, E[g + 464 >> 2] = 0, E[g + 468 >> 2] = 0, E[g + 436 >> 2] = 0, E[g + 440 >> 2] = 0, E[g + 444 >> 2] = 0, E[g + 448 >> 2] = 0, E[g + 432 >> 2] = 1, GA(w = g + 576 | 0, g + 432 | 0, D), Y(D = g + 720 | 0, w, y), Y(b = g + 672 | 0, w, p), Y(n = g + 48 | 0, D, b), Y(n, n, y = I + 120 | 0), Y(g + 528 | 0, I, 1648), Y(g + 480 | 0, s, 1648), Y(g + 624 | 0, D, 2960), Y(D = g + 336 | 0, y, n), BI(S = g + 384 | 0, D), P = a[g + 384 | 0], D = E[I + 36 >> 2], y = E[I + 32 >> 2], E[g + 176 >> 2] = y, E[g + 180 >> 2] = D, p = E[I + 28 >> 2], D = E[I + 24 >> 2], E[g + 168 >> 2] = D, E[g + 172 >> 2] = p, w = E[I + 20 >> 2], p = E[I + 16 >> 2], E[g + 160 >> 2] = p, E[g + 164 >> 2] = w, f = E[I + 12 >> 2], w = E[I + 8 >> 2], E[g + 152 >> 2] = w, E[g + 156 >> 2] = f, G = E[I + 4 >> 2], f = E[I >> 2], E[g + 144 >> 2] = f, E[g + 148 >> 2] = G, G = E[s >> 2], _$K = E[I + 44 >> 2], _$H = E[I + 48 >> 2], _$d = E[I + 52 >> 2], J = E[I + 56 >> 2], _$U = E[I + 60 >> 2], l = E[k >> 2], _$m = E[I + 68 >> 2], u = E[I + 72 >> 2], x = E[I + 76 >> 2], q = E[g + 484 >> 2], k = E[g + 148 >> 2], _$z = E[g + 492 >> 2], F = E[g + 156 >> 2], j = E[g + 500 >> 2], _$N = E[g + 164 >> 2], _$X = E[g + 508 >> 2], M = E[g + 172 >> 2], O = E[g + 516 >> 2], L = E[g + 180 >> 2], V = E[g + 480 >> 2], Z = E[g + 488 >> 2], _$W = E[g + 496 >> 2], R = E[g + 504 >> 2], s = 0 - (1 & P) | 0, E[g + 176 >> 2] = y ^ s & (y ^ E[g + 512 >> 2]), E[g + 168 >> 2] = D ^ s & (D ^ R), E[g + 160 >> 2] = p ^ s & (p ^ _$W), E[g + 152 >> 2] = w ^ s & (w ^ Z), E[g + 144 >> 2] = f ^ s & (f ^ V), E[g + 180 >> 2] = L ^ s & (L ^ O), E[g + 172 >> 2] = M ^ s & (M ^ _$X), E[g + 164 >> 2] = _$N ^ s & (_$N ^ j), E[g + 156 >> 2] = F ^ s & (F ^ _$z), E[g + 148 >> 2] = k ^ s & (k ^ q), L = E[g + 528 >> 2], P = E[g + 532 >> 2], q = E[g + 536 >> 2], _$z = E[g + 540 >> 2], j = E[g + 544 >> 2], _$X = E[g + 548 >> 2], O = E[g + 552 >> 2], V = E[g + 556 >> 2], Z = E[g + 560 >> 2], _$W = E[g + 564 >> 2], y = E[g + 672 >> 2], R = E[g + 624 >> 2], D = E[g + 676 >> 2], _$B = E[g + 628 >> 2], p = E[g + 680 >> 2], Q = E[g + 632 >> 2], w = E[g + 684 >> 2], i = E[g + 636 >> 2], f = E[g + 688 >> 2], _ = E[g + 640 >> 2], k = E[g + 692 >> 2], c = E[g + 644 >> 2], F = E[g + 696 >> 2], t = E[g + 648 >> 2], _$N = E[g + 700 >> 2], r = E[g + 652 >> 2], M = E[g + 704 >> 2], e = E[g + 656 >> 2], C = E[g + 708 >> 2], E[g + 708 >> 2] = C ^ s & (E[g + 660 >> 2] ^ C), E[g + 704 >> 2] = M ^ s & (M ^ e), E[g + 700 >> 2] = _$N ^ s & (_$N ^ r), E[g + 696 >> 2] = F ^ s & (F ^ t), E[g + 692 >> 2] = k ^ s & (k ^ c), E[g + 688 >> 2] = f ^ s & (f ^ _), E[g + 684 >> 2] = w ^ s & (w ^ i), E[g + 680 >> 2] = p ^ s & (p ^ Q), E[g + 676 >> 2] = D ^ s & (D ^ _$B), E[g + 672 >> 2] = y ^ s & (y ^ R), Y(y = g + 96 | 0, g + 144 | 0, n), BI(S, y), D = E[I + 80 >> 2], p = E[I + 84 >> 2], w = E[I + 88 >> 2], f = E[I + 92 >> 2], n = E[I + 96 >> 2], k = E[I + 100 >> 2], F = E[I + 104 >> 2], _$N = E[I + 108 >> 2], M = E[I + 112 >> 2], R = E[I + 116 >> 2], I = 0 - (1 & o[g + 384 | 0]) | 0, y = x ^ s & (x ^ _$W), E[g + 420 >> 2] = R - (I & (0 - y ^ y) ^ y), y = u ^ s & (u ^ Z), E[g + 416 >> 2] = M - (I & (0 - y ^ y) ^ y), y = _$m ^ s & (_$m ^ V), E[g + 412 >> 2] = _$N - (I & (0 - y ^ y) ^ y), y = l ^ s & (l ^ O), E[g + 408 >> 2] = F - (I & (0 - y ^ y) ^ y), y = _$U ^ s & (_$U ^ _$X), E[g + 404 >> 2] = k - (I & (0 - y ^ y) ^ y), y = J ^ s & (J ^ j), E[g + 400 >> 2] = n - (I & (0 - y ^ y) ^ y), y = _$d ^ s & (_$d ^ _$z), E[g + 396 >> 2] = f - (I & (0 - y ^ y) ^ y), y = _$H ^ s & (_$H ^ q), E[g + 392 >> 2] = w - (I & (0 - y ^ y) ^ y), y = _$K ^ s & (_$K ^ P), E[g + 388 >> 2] = p - (I & (0 - y ^ y) ^ y), y = I, I = G ^ s & (G ^ L), E[g + 384 >> 2] = D - (y & (0 - I ^ I) ^ I), Y(S, b, S), BI(g + 768 | 0, S), I = 0 - (1 & o[g + 768 | 0]) | 0, y = E[g + 384 >> 2], E[g + 384 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 388 >> 2], E[g + 388 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 392 >> 2], E[g + 392 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 396 >> 2], E[g + 396 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 400 >> 2], E[g + 400 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 404 >> 2], E[g + 404 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 408 >> 2], E[g + 408 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 412 >> 2], E[g + 412 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 416 >> 2], E[g + 416 >> 2] = I & (0 - y ^ y) ^ y, y = I, I = E[g + 420 >> 2], E[g + 420 >> 2] = y & (0 - I ^ I) ^ I, BI(A, S), h = g + 800 | 0;
                                    }
                                    function V(A, I) {
                                        var g, C, _$B, Q, i, o, _, c, t, r = 0, e = 0;
                                        h = g = h - 288 | 0, C = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, _$B = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, Q = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, i = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, _ = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, c = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, t = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, A = E[I + 124 >> 2], E[g + 280 >> 2] = E[I + 120 >> 2], E[g + 284 >> 2] = A, A = E[I + 116 >> 2], E[g + 272 >> 2] = E[I + 112 >> 2], E[g + 276 >> 2] = A, A = E[I + 108 >> 2], E[g + 248 >> 2] = E[I + 104 >> 2], E[g + 252 >> 2] = A, A = E[I + 100 >> 2], E[g + 240 >> 2] = E[I + 96 >> 2], E[g + 244 >> 2] = A, A = E[I + 124 >> 2], E[g + 232 >> 2] = E[I + 120 >> 2], E[g + 236 >> 2] = A, A = E[I + 116 >> 2], E[g + 224 >> 2] = E[I + 112 >> 2], E[g + 228 >> 2] = A, $A(e = g + 256 | 0, g + 240 | 0, g + 224 | 0), A = E[g + 268 >> 2], E[I + 120 >> 2] = E[g + 264 >> 2], E[I + 124 >> 2] = A, A = E[g + 260 >> 2], E[I + 112 >> 2] = E[g + 256 >> 2], E[I + 116 >> 2] = A, A = E[I + 92 >> 2], E[g + 216 >> 2] = E[I + 88 >> 2], E[g + 220 >> 2] = A, A = E[I + 84 >> 2], E[g + 208 >> 2] = E[I + 80 >> 2], E[g + 212 >> 2] = A, A = E[I + 108 >> 2], E[g + 200 >> 2] = E[I + 104 >> 2], E[g + 204 >> 2] = A, A = E[I + 100 >> 2], E[g + 192 >> 2] = E[I + 96 >> 2], E[g + 196 >> 2] = A, $A(e, g + 208 | 0, g + 192 | 0), A = E[g + 268 >> 2], E[I + 104 >> 2] = E[g + 264 >> 2], E[I + 108 >> 2] = A, A = E[g + 260 >> 2], E[I + 96 >> 2] = E[g + 256 >> 2], E[I + 100 >> 2] = A, A = E[I + 76 >> 2], E[g + 184 >> 2] = E[I + 72 >> 2], E[g + 188 >> 2] = A, r = E[4 + (A = I - -64 | 0) >> 2], E[g + 176 >> 2] = E[A >> 2], E[g + 180 >> 2] = r, r = E[I + 92 >> 2], E[g + 168 >> 2] = E[I + 88 >> 2], E[g + 172 >> 2] = r, r = E[I + 84 >> 2], E[g + 160 >> 2] = E[I + 80 >> 2], E[g + 164 >> 2] = r, $A(e, g + 176 | 0, g + 160 | 0), r = E[g + 268 >> 2], E[I + 88 >> 2] = E[g + 264 >> 2], E[I + 92 >> 2] = r, r = E[g + 260 >> 2], E[I + 80 >> 2] = E[g + 256 >> 2], E[I + 84 >> 2] = r, r = E[I + 60 >> 2], E[g + 152 >> 2] = E[I + 56 >> 2], E[g + 156 >> 2] = r, r = E[I + 52 >> 2], E[g + 144 >> 2] = E[I + 48 >> 2], E[g + 148 >> 2] = r, r = E[I + 76 >> 2], E[g + 136 >> 2] = E[I + 72 >> 2], E[g + 140 >> 2] = r, r = E[A + 4 >> 2], E[g + 128 >> 2] = E[A >> 2], E[g + 132 >> 2] = r, $A(e, g + 144 | 0, g + 128 | 0), r = E[g + 268 >> 2], E[I + 72 >> 2] = E[g + 264 >> 2], E[I + 76 >> 2] = r, r = E[g + 260 >> 2], E[A >> 2] = E[g + 256 >> 2], E[A + 4 >> 2] = r, r = E[I + 44 >> 2], E[g + 120 >> 2] = E[I + 40 >> 2], E[g + 124 >> 2] = r, r = E[I + 36 >> 2], E[g + 112 >> 2] = E[I + 32 >> 2], E[g + 116 >> 2] = r, r = E[I + 60 >> 2], E[g + 104 >> 2] = E[I + 56 >> 2], E[g + 108 >> 2] = r, r = E[I + 52 >> 2], E[g + 96 >> 2] = E[I + 48 >> 2], E[g + 100 >> 2] = r, $A(e, g + 112 | 0, g + 96 | 0), r = E[g + 268 >> 2], E[I + 56 >> 2] = E[g + 264 >> 2], E[I + 60 >> 2] = r, r = E[g + 260 >> 2], E[I + 48 >> 2] = E[g + 256 >> 2], E[I + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 88 >> 2] = E[I + 24 >> 2], E[g + 92 >> 2] = r, r = E[I + 20 >> 2], E[g + 80 >> 2] = E[I + 16 >> 2], E[g + 84 >> 2] = r, r = E[I + 44 >> 2], E[g + 72 >> 2] = E[I + 40 >> 2], E[g + 76 >> 2] = r, r = E[I + 36 >> 2], E[g + 64 >> 2] = E[I + 32 >> 2], E[g + 68 >> 2] = r, $A(e, g + 80 | 0, g - -64 | 0), r = E[g + 268 >> 2], E[I + 40 >> 2] = E[g + 264 >> 2], E[I + 44 >> 2] = r, r = E[g + 260 >> 2], E[I + 32 >> 2] = E[g + 256 >> 2], E[I + 36 >> 2] = r, r = E[I + 12 >> 2], E[g + 56 >> 2] = E[I + 8 >> 2], E[g + 60 >> 2] = r, r = E[I + 4 >> 2], E[g + 48 >> 2] = E[I >> 2], E[g + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 40 >> 2] = E[I + 24 >> 2], E[g + 44 >> 2] = r, r = E[I + 20 >> 2], E[g + 32 >> 2] = E[I + 16 >> 2], E[g + 36 >> 2] = r, $A(e, g + 48 | 0, g + 32 | 0), r = E[g + 268 >> 2], E[I + 24 >> 2] = E[g + 264 >> 2], E[I + 28 >> 2] = r, r = E[g + 260 >> 2], E[I + 16 >> 2] = E[g + 256 >> 2], E[I + 20 >> 2] = r, r = E[g + 284 >> 2], E[g + 24 >> 2] = E[g + 280 >> 2], E[g + 28 >> 2] = r, r = E[g + 276 >> 2], E[g + 16 >> 2] = E[g + 272 >> 2], E[g + 20 >> 2] = r, r = E[I + 12 >> 2], E[g + 8 >> 2] = E[I + 8 >> 2], E[g + 12 >> 2] = r, r = E[I + 4 >> 2], E[g >> 2] = E[I >> 2], E[g + 4 >> 2] = r, $A(e, g + 16 | 0, g), e = E[g + 268 >> 2], E[I + 8 >> 2] = E[g + 264 >> 2], E[I + 12 >> 2] = e, e = E[g + 260 >> 2], E[I >> 2] = E[g + 256 >> 2], E[I + 4 >> 2] = e, E[I + 12 >> 2] = (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ c, E[I + 8 >> 2] = (a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24) ^ _, E[I + 4 >> 2] = (a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) ^ o, E[I >> 2] = (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) ^ t, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ i, E[I + 68 >> 2] = (a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24) ^ Q, E[I + 72 >> 2] = (a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) ^ _$B, E[I + 76 >> 2] = (a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) ^ C, h = g + 288 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var _$B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N = 0, S = 0, G = 0, M = 0;
                                        h = _$B = h - 240 | 0, G = 16 - g | 0, M = Hg((S = _$B + 192 | 0) + g | 0, 0, g >>> 0 <= 15 ? G : 0), Sg(S, I, g), _$N = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, Q = a[0 | (I = C - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, o = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24, r = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, e = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, y = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, s = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, D = a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24, p = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, w = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, f = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, n = E[_$B + 192 >> 2], k = E[_$B + 196 >> 2], F = E[_$B + 200 >> 2], E[_$B + 204 >> 2] = (a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24) & (a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24) ^ (a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24) ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24) ^ E[_$B + 204 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[_$B + 200 >> 2] = w & f ^ p ^ F ^ D ^ s, E[_$B + 196 >> 2] = e & y ^ r ^ k ^ t ^ c, E[_$B + 192 >> 2] = o & _ ^ _$N ^ Q ^ i ^ n, Hg(M, 0, G), Sg(A, S, g), g = E[_$B + 192 >> 2], S = E[_$B + 196 >> 2], G = E[_$B + 200 >> 2], M = E[_$B + 204 >> 2], A = E[C + 92 >> 2], E[_$B + 232 >> 2] = E[C + 88 >> 2], E[_$B + 236 >> 2] = A, A = E[C + 84 >> 2], E[_$B + 224 >> 2] = E[C + 80 >> 2], E[_$B + 228 >> 2] = A, A = E[C + 76 >> 2], E[_$B + 184 >> 2] = E[C + 72 >> 2], E[_$B + 188 >> 2] = A, A = E[I + 4 >> 2], E[_$B + 176 >> 2] = E[I >> 2], E[_$B + 180 >> 2] = A, A = E[C + 92 >> 2], E[_$B + 168 >> 2] = E[C + 88 >> 2], E[_$B + 172 >> 2] = A, A = E[C + 84 >> 2], E[_$B + 160 >> 2] = E[C + 80 >> 2], E[_$B + 164 >> 2] = A, $A(A = _$B + 208 | 0, _$B + 176 | 0, _$B + 160 | 0), _$N = E[_$B + 220 >> 2], E[C + 88 >> 2] = E[_$B + 216 >> 2], E[C + 92 >> 2] = _$N, _$N = E[_$B + 212 >> 2], E[C + 80 >> 2] = E[_$B + 208 >> 2], E[C + 84 >> 2] = _$N, _$N = E[C + 60 >> 2], E[_$B + 152 >> 2] = E[C + 56 >> 2], E[_$B + 156 >> 2] = _$N, _$N = E[C + 52 >> 2], E[_$B + 144 >> 2] = E[C + 48 >> 2], E[_$B + 148 >> 2] = _$N, _$N = E[C + 76 >> 2], E[_$B + 136 >> 2] = E[C + 72 >> 2], E[_$B + 140 >> 2] = _$N, _$N = E[I + 4 >> 2], E[_$B + 128 >> 2] = E[I >> 2], E[_$B + 132 >> 2] = _$N, $A(A, _$B + 144 | 0, _$B + 128 | 0), _$N = E[_$B + 220 >> 2], E[C + 72 >> 2] = E[_$B + 216 >> 2], E[C + 76 >> 2] = _$N, _$N = E[_$B + 212 >> 2], E[I >> 2] = E[_$B + 208 >> 2], E[I + 4 >> 2] = _$N, I = E[C + 44 >> 2], E[_$B + 120 >> 2] = E[C + 40 >> 2], E[_$B + 124 >> 2] = I, I = E[C + 36 >> 2], E[_$B + 112 >> 2] = E[C + 32 >> 2], E[_$B + 116 >> 2] = I, I = E[C + 60 >> 2], E[_$B + 104 >> 2] = E[C + 56 >> 2], E[_$B + 108 >> 2] = I, I = E[C + 52 >> 2], E[_$B + 96 >> 2] = E[C + 48 >> 2], E[_$B + 100 >> 2] = I, $A(A, _$B + 112 | 0, _$B + 96 | 0), I = E[_$B + 220 >> 2], E[C + 56 >> 2] = E[_$B + 216 >> 2], E[C + 60 >> 2] = I, I = E[_$B + 212 >> 2], E[C + 48 >> 2] = E[_$B + 208 >> 2], E[C + 52 >> 2] = I, I = E[C + 28 >> 2], E[_$B + 88 >> 2] = E[C + 24 >> 2], E[_$B + 92 >> 2] = I, I = E[C + 20 >> 2], E[_$B + 80 >> 2] = E[C + 16 >> 2], E[_$B + 84 >> 2] = I, I = E[C + 44 >> 2], E[_$B + 72 >> 2] = E[C + 40 >> 2], E[_$B + 76 >> 2] = I, I = E[C + 36 >> 2], E[_$B + 64 >> 2] = E[C + 32 >> 2], E[_$B + 68 >> 2] = I, $A(A, _$B + 80 | 0, _$B - -64 | 0), I = E[_$B + 220 >> 2], E[C + 40 >> 2] = E[_$B + 216 >> 2], E[C + 44 >> 2] = I, I = E[_$B + 212 >> 2], E[C + 32 >> 2] = E[_$B + 208 >> 2], E[C + 36 >> 2] = I, I = E[C + 12 >> 2], E[_$B + 56 >> 2] = E[C + 8 >> 2], E[_$B + 60 >> 2] = I, I = E[C + 4 >> 2], E[_$B + 48 >> 2] = E[C >> 2], E[_$B + 52 >> 2] = I, I = E[C + 28 >> 2], E[_$B + 40 >> 2] = E[C + 24 >> 2], E[_$B + 44 >> 2] = I, I = E[C + 20 >> 2], E[_$B + 32 >> 2] = E[C + 16 >> 2], E[_$B + 36 >> 2] = I, $A(A, _$B + 48 | 0, _$B + 32 | 0), I = E[_$B + 220 >> 2], E[C + 24 >> 2] = E[_$B + 216 >> 2], E[C + 28 >> 2] = I, I = E[_$B + 212 >> 2], E[C + 16 >> 2] = E[_$B + 208 >> 2], E[C + 20 >> 2] = I, I = E[_$B + 236 >> 2], E[_$B + 24 >> 2] = E[_$B + 232 >> 2], E[_$B + 28 >> 2] = I, I = E[_$B + 228 >> 2], E[_$B + 16 >> 2] = E[_$B + 224 >> 2], E[_$B + 20 >> 2] = I, I = E[C + 12 >> 2], E[_$B + 8 >> 2] = E[C + 8 >> 2], E[_$B + 12 >> 2] = I, I = E[C + 4 >> 2], E[_$B >> 2] = E[C >> 2], E[_$B + 4 >> 2] = I, $A(A, _$B + 16 | 0, _$B), A = E[_$B + 208 >> 2], I = E[_$B + 212 >> 2], _$N = E[_$B + 216 >> 2], E[C + 12 >> 2] = E[_$B + 220 >> 2] ^ M, E[C + 8 >> 2] = _$N ^ G, E[C + 4 >> 2] = I ^ S, E[C >> 2] = A ^ g, h = _$B + 240 | 0;
                                    }
                                    function W(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                        if (_ = 1886610805 ^ (C = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), i = 1936682341 ^ (Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), c = 1852142177 ^ C, E = 1819895653 ^ Q, Q = 1852075885 ^ (C = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), B = 1685025377 ^ (r = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = 2037671283 ^ C, r ^= 1952801890, (0 | (C = (I + g | 0) - (s = 7 & g) | 0)) != (0 | I)) {
                                            for(; c = c + (t ^= n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0, E = E + (e = r ^ (k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) | 0, E = c >>> 0 < t >>> 0 ? E + 1 | 0 : E, y = 1 + (i = B + i | 0) | 0, r = i, r = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? y : r, _ = c + (B = KI(Q, B, 13) ^ i) | 0, Q = E + (y = w ^ r) | 0, y = KI(B, y, 17) ^ _, f = KI(y, p = (D = B >>> 0 > _ >>> 0 ? Q + 1 | 0 : Q) ^ w, 13), h = w, B = KI(t, e, 16), Q = E ^ w, E = B ^ c, c = KI(i, r, 32), i = w + Q | 0, r = 1 + (c = p + (t = (B = E + c | 0) >>> 0 < c >>> 0 ? i + 1 | 0 : i) | 0) | 0, i = c, i = (c = B + y | 0) >>> 0 < B >>> 0 ? r : i, p = KI(r = c ^ f, e = i ^ h, 17), f = w, Q = KI(E, Q, 21), E = t ^ w, t = B ^ Q, B = KI(_, D, 32), Q = w + E | 0, B = (D = B >>> 0 > (_ = t + B | 0) >>> 0 ? Q + 1 | 0 : Q) + e | 0, Q = (e = _ + r | 0) ^ p, B = (y = e >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ f, E = KI(t, E, 16), r = t = D ^ w, E = KI(_ ^= E, t, 21), D = w, t = (_ = (c = KI(c, i, 32)) + _ | 0) ^ E, i = w + r | 0, r = (i = _ >>> 0 < c >>> 0 ? i + 1 | 0 : i) ^ D, c = KI(e, y, 32), E = w, _ ^= n, i ^= k, (0 | C) != (0 | (I = I + 8 | 0)););
                                            I = C;
                                        }
                                        switch(g <<= 24, C = 0, s - 1 | 0){
                                            case 6:
                                                g |= a[I + 6 | 0] << 16;
                                            case 5:
                                                g |= a[I + 5 | 0] << 8;
                                            case 4:
                                                g |= a[I + 4 | 0];
                                            case 3:
                                                e = (C = a[I + 3 | 0]) >>> 8 | 0, C <<= 24, g |= e;
                                            case 2:
                                                C |= (e = a[I + 2 | 0]) << 16, g |= y = e >>> 16 | 0;
                                            case 1:
                                                C |= (e = a[I + 1 | 0]) << 8, g |= y = e >>> 24 | 0;
                                            case 0:
                                                C = a[0 | I] | C;
                                        }
                                        return r = KI(I = C ^ t, t = g ^ r, 16), E = E + t | 0, c = (I = I + c | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, r = KI(E = I ^ r, t = c ^ w, 21), e = w, h = 1 + (i = B + i | 0) | 0, y = i, y = _ = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? h : y, s = KI(i, _, 32), t = w + t | 0, e = KI(E = r ^ (_ = E + s | 0), r = e ^ (t = _ >>> 0 < s >>> 0 ? t + 1 | 0 : t), 16), s = w, B = KI(Q, B, 13) ^ i, Q = (i = c) + (c = w ^ y) | 0, y = KI(I = I + B | 0, i = I >>> 0 < B >>> 0 ? Q + 1 | 0 : Q, 32), r = w + r | 0, y = KI(E = e ^ (Q = E + y | 0), e = (r = Q >>> 0 < y >>> 0 ? r + 1 | 0 : r) ^ s, 21), s = w, I = _ + (B = c = KI(B, c, 17) ^ I) | 0, _ = (i ^= w) + t | 0, t = B = I >>> 0 < B >>> 0 ? _ + 1 | 0 : _, h = y, _ = E + (y = KI(I, B, 32)) | 0, E = w + e | 0, y = KI(B = h ^ _, e = (E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ s, 16), s = w, h = Q, i = KI(c, i, 13) ^ I, c = (t ^= w) + r | 0, r = Q = (I = h + (Q = i) | 0) >>> 0 < Q >>> 0 ? c + 1 | 0 : c, Q = KI(I, Q, 32), c = e + w | 0, e = (h = B) >>> 0 > (B = B + (255 ^ Q) | 0) >>> 0 ? c + 1 | 0 : c, y = KI(c = B ^ y, Q = s ^ e, 21), s = w, i = KI(i, t, 17) ^ I, g = (t = r ^ w) + (g ^ E) | 0, g = KI(I = i + (C ^= _) | 0, E = g = I >>> 0 < C >>> 0 ? g + 1 | 0 : g, 32), C = Q + w | 0, c = KI(_ = (g = g + c | 0) ^ y, C = (Q = g >>> 0 < c >>> 0 ? C + 1 | 0 : C) ^ s, 16), r = w, i = KI(i, t, 13) ^ I, t = e + (E ^= w) | 0, t = B = (I = B + i | 0) >>> 0 < B >>> 0 ? t + 1 | 0 : t, B = KI(I, B, 32), y = r, h = 1 + (C = C + w | 0) | 0, r = C, r = (C = B + _ | 0) >>> 0 < _ >>> 0 ? h : r, c = KI(_ = C ^ c, B = y ^ r, 21), e = w, i = KI(i, E, 17), h = 1 + (Q = Q + (E = t ^ w) | 0) | 0, y = Q, i = I = (t = g) >>> 0 > (g = g + (Q = I ^ i) | 0) >>> 0 ? h : y, I = KI(g, I, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, Q = KI(Q, E, 13), E = r + (i ^= w) | 0, r = C, g = KI(C = C + (Q ^= g) | 0, E = g = r >>> 0 > C >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, r = (g = g + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = g ^ c, B = r ^ e, 21), e = w, Q = KI(Q, i, 17), y = 1 + (E = t + (i = E ^ w) | 0) | 0, t = E, I = KI(C = I + (E = C ^ Q) | 0, Q = C >>> 0 < I >>> 0 ? y : t, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, i = KI(E, i, 13), E = r + (Q ^= w) | 0, g = KI(C = g + (i ^= C) | 0, E = g = C >>> 0 < g >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, _ = KI((g = g + _ | 0) ^ c, (B = g >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ e, 21), c = w, C = KI(i, Q, 17) ^ C, i = KI(C, Q = E ^ w, 13), Q = Q + t | 0, I = w ^ (I >>> 0 > (C = I + C | 0) >>> 0 ? Q + 1 | 0 : Q), _ = KI(C ^= i, I, 17) ^ _, Q = w ^ c, i = 1 + (I = I + B | 0) | 0, B = I, I = KI(I = g + C | 0, g = g >>> 0 > I >>> 0 ? i : B, 32) ^ _ ^ I, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, I = g ^ w ^ Q, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                    }
                                    function T(A, I) {
                                        var g, C, _$B, Q, i, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, L = 0;
                                        h = g = h - 624 | 0, v(o = g + 480 | 0, I), Y(o, 1648, o), c = E[g + 516 >> 2], E[g + 276 >> 2] = c, t = E[g + 512 >> 2], E[g + 272 >> 2] = t, r = E[g + 508 >> 2], E[g + 268 >> 2] = r, e = E[g + 504 >> 2], E[g + 264 >> 2] = e, y = E[g + 500 >> 2], E[g + 260 >> 2] = y, s = E[g + 496 >> 2], E[g + 256 >> 2] = s, D = E[g + 492 >> 2], E[g + 252 >> 2] = D, p = E[g + 488 >> 2], E[g + 248 >> 2] = p, w = E[g + 484 >> 2], E[g + 244 >> 2] = w, n = E[g + 480 >> 2], E[g + 240 >> 2] = n + 1, Y(_ = g + 240 | 0, _, 33984), E[g + 468 >> 2] = c - 12055116, E[g + 464 >> 2] = t - 18696448, E[g + 460 >> 2] = r - 3247719, E[g + 456 >> 2] = e - 6275908, E[g + 452 >> 2] = y - 8787816, E[g + 448 >> 2] = s + 114729, E[g + 444 >> 2] = D + 6949391, E[g + 440 >> 2] = p - 15372611, E[g + 436 >> 2] = w + 13857413, E[g + 432 >> 2] = n - 10913610, Y(f = g + 192 | 0, o, 1600), E[g + 228 >> 2] = 0 - E[g + 228 >> 2], E[g + 224 >> 2] = 0 - E[g + 224 >> 2], E[g + 220 >> 2] = 0 - E[g + 220 >> 2], E[g + 216 >> 2] = 0 - E[g + 216 >> 2], E[g + 212 >> 2] = 0 - E[g + 212 >> 2], E[g + 208 >> 2] = 0 - E[g + 208 >> 2], E[g + 204 >> 2] = 0 - E[g + 204 >> 2], E[g + 200 >> 2] = 0 - E[g + 200 >> 2], E[g + 196 >> 2] = 0 - E[g + 196 >> 2], E[g + 192 >> 2] = -1 ^ E[g + 192 >> 2], Y(f, f, g + 432 | 0), o = GA(C = g + 384 | 0, _, f), Y(_ = g + 336 | 0, C, I), BI(_$B = g + 576 | 0, _), i = a[g + 576 | 0], _$d = E[g + 420 >> 2], _ = E[g + 372 >> 2], J = E[g + 416 >> 2], k = E[g + 368 >> 2], _$U = E[g + 412 >> 2], F = E[g + 364 >> 2], l = E[g + 408 >> 2], _$N = E[g + 360 >> 2], _$m = E[g + 404 >> 2], S = E[g + 356 >> 2], u = E[g + 400 >> 2], G = E[g + 352 >> 2], x = E[g + 396 >> 2], M = E[g + 348 >> 2], R = E[g + 392 >> 2], b = E[g + 344 >> 2], L = E[g + 388 >> 2], _$K = E[g + 340 >> 2], Q = E[g + 384 >> 2], _$H = E[g + 336 >> 2], I = o - 1 | 0, E[g + 612 >> 2] = I & c, E[g + 608 >> 2] = I & t, E[g + 604 >> 2] = I & r, E[g + 600 >> 2] = I & e, E[g + 596 >> 2] = I & y, E[g + 592 >> 2] = I & s, E[g + 588 >> 2] = I & D, E[g + 584 >> 2] = I & p, E[g + 580 >> 2] = I & w, E[g + 576 >> 2] = n | 0 - o, _$H = I & (0 - (_$H ^ (o = 0 - (1 & i) | 0) & (_$H ^ 0 - _$H)) ^ Q) ^ Q, E[g + 384 >> 2] = _$H, _$K = L ^ I & (L ^ 0 - (_$K ^ o & (_$K ^ 0 - _$K))), E[g + 388 >> 2] = _$K, b = R ^ I & (R ^ 0 - (b ^ o & (b ^ 0 - b))), E[g + 392 >> 2] = b, M = x ^ I & (x ^ 0 - (M ^ o & (M ^ 0 - M))), E[g + 396 >> 2] = M, G = u ^ I & (u ^ 0 - (G ^ o & (G ^ 0 - G))), E[g + 400 >> 2] = G, S = _$m ^ I & (_$m ^ 0 - (S ^ o & (S ^ 0 - S))), E[g + 404 >> 2] = S, _$N = l ^ I & (l ^ 0 - (_$N ^ o & (_$N ^ 0 - _$N))), E[g + 408 >> 2] = _$N, F = _$U ^ I & (_$U ^ 0 - (F ^ o & (F ^ 0 - F))), E[g + 412 >> 2] = F, k = J ^ I & (J ^ 0 - (k ^ o & (k ^ 0 - k))), E[g + 416 >> 2] = k, o = _$d ^ I & (_$d ^ 0 - (_ ^ o & (_ ^ 0 - _))), E[g + 420 >> 2] = o, E[g + 564 >> 2] = c, E[g + 560 >> 2] = t, E[g + 556 >> 2] = r, E[g + 552 >> 2] = e, E[g + 548 >> 2] = y, E[g + 544 >> 2] = s, E[g + 540 >> 2] = D, E[g + 536 >> 2] = p, E[g + 532 >> 2] = w, E[g + 528 >> 2] = n - 1, Y(I = g + 528 | 0, I, _$B), Y(I, I, 34032), c = E[g + 192 >> 2], t = E[g + 528 >> 2], r = E[g + 196 >> 2], e = E[g + 532 >> 2], y = E[g + 200 >> 2], s = E[g + 536 >> 2], D = E[g + 204 >> 2], p = E[g + 540 >> 2], w = E[g + 208 >> 2], n = E[g + 544 >> 2], _ = E[g + 212 >> 2], _$d = E[g + 548 >> 2], J = E[g + 216 >> 2], _$U = E[g + 552 >> 2], l = E[g + 220 >> 2], _$m = E[g + 556 >> 2], u = E[g + 224 >> 2], x = E[g + 560 >> 2], R = E[g + 228 >> 2], L = E[g + 564 >> 2], E[g + 180 >> 2] = o << 1, E[g + 176 >> 2] = k << 1, E[g + 172 >> 2] = F << 1, E[g + 168 >> 2] = _$N << 1, E[g + 164 >> 2] = S << 1, E[g + 160 >> 2] = G << 1, E[g + 156 >> 2] = M << 1, E[g + 152 >> 2] = b << 1, E[g + 148 >> 2] = _$K << 1, E[g + 144 >> 2] = _$H << 1, E[g + 564 >> 2] = L - R, E[g + 560 >> 2] = x - u, E[g + 556 >> 2] = _$m - l, E[g + 552 >> 2] = _$U - J, E[g + 548 >> 2] = _$d - _, E[g + 544 >> 2] = n - w, E[g + 540 >> 2] = p - D, E[g + 536 >> 2] = s - y, E[g + 532 >> 2] = e - r, E[g + 528 >> 2] = t - c, Y(o = g + 144 | 0, o, f), Y(f = g + 96 | 0, I, 34080), v(g + 288 | 0, C), I = E[g + 324 >> 2], E[g + 84 >> 2] = 0 - I, c = E[g + 320 >> 2], E[g + 80 >> 2] = 0 - c, t = E[g + 316 >> 2], E[g + 76 >> 2] = 0 - t, r = E[g + 312 >> 2], E[g + 72 >> 2] = 0 - r, e = E[g + 308 >> 2], E[g + 68 >> 2] = 0 - e, y = E[g + 304 >> 2], E[g + 64 >> 2] = 0 - y, s = E[g + 300 >> 2], E[g + 60 >> 2] = 0 - s, D = E[g + 296 >> 2], E[g + 56 >> 2] = 0 - D, p = E[g + 292 >> 2], E[g + 52 >> 2] = 0 - p, w = E[g + 288 >> 2], E[g + 48 >> 2] = 1 - w, E[g + 36 >> 2] = I, E[g + 32 >> 2] = c, E[g + 28 >> 2] = t, E[g + 24 >> 2] = r, E[g + 20 >> 2] = e, E[g + 16 >> 2] = y, E[g + 12 >> 2] = s, E[g + 8 >> 2] = D, E[g + 4 >> 2] = p, E[g >> 2] = w + 1, Y(A, o, g), Y(A + 40 | 0, I = g + 48 | 0, f), Y(A + 80 | 0, f, g), Y(A + 120 | 0, o, I), h = g + 624 | 0;
                                    }
                                    function $(A, I, g) {
                                        var C, _$B = 0, i = 0, _ = 0, c = 0, t = 0, r = 0;
                                        h = C = h + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (_$B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (_ = a[0 | (_$B = A - -64 | 0)] | a[_$B + 1 | 0] << 8 | a[_$B + 2 | 0] << 16 | a[_$B + 3 | 0] << 24, t = i = a[_$B + 4 | 0] | a[_$B + 5 | 0] << 8 | a[_$B + 6 | 0] << 16 | a[_$B + 7 | 0] << 24, i = (c = _ + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, o[0 | _$B] = c, o[_$B + 1 | 0] = c >>> 8, o[_$B + 2 | 0] = c >>> 16, o[_$B + 3 | 0] = c >>> 24, o[_$B + 4 | 0] = i, o[_$B + 5 | 0] = i >>> 8, o[_$B + 6 | 0] = i >>> 16, o[_$B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (_$B = -1 == (0 | t) & _ >>> 0 > 4294967167) >>> 0 > (_ = _$B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, f(A, i = A + 96 | 0), _$B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = _$B, o[A + 353 | 0] = _$B >>> 8, o[A + 354 | 0] = _$B >>> 16, o[A + 355 | 0] = _$B >>> 24, _$B >>> 0 >= 129) break A;
                                                        Sg(i, A + 224 | 0, _$B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (_$B = A - -64 | 0)] | a[_$B + 1 | 0] << 8 | a[_$B + 2 | 0] << 16 | a[_$B + 3 | 0] << 24, _ = r = a[_$B + 4 | 0] | a[_$B + 5 | 0] << 8 | a[_$B + 6 | 0] << 16 | a[_$B + 7 | 0] << 24, _ = (t = i + c | 0) >>> 0 < c >>> 0 ? _ + 1 | 0 : _, o[0 | _$B] = t, o[_$B + 1 | 0] = t >>> 8, o[_$B + 2 | 0] = t >>> 16, o[_$B + 3 | 0] = t >>> 24, o[_$B + 4 | 0] = _, o[_$B + 5 | 0] = _ >>> 8, o[_$B + 6 | 0] = _ >>> 16, o[_$B + 7 | 0] = _ >>> 24, _$B = (0 | _) == (0 | r) & i >>> 0 > t >>> 0 | _ >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (_ = _$B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < _$B >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (o[A + 88 | 0] = 255, o[A + 89 | 0] = 255, o[A + 90 | 0] = 255, o[A + 91 | 0] = 255, o[A + 92 | 0] = 255, o[A + 93 | 0] = 255, o[A + 94 | 0] = 255, o[A + 95 | 0] = 255), o[A + 80 | 0] = 255, o[A + 81 | 0] = 255, o[A + 82 | 0] = 255, o[A + 83 | 0] = 255, o[A + 84 | 0] = 255, o[A + 85 | 0] = 255, o[A + 86 | 0] = 255, o[A + 87 | 0] = 255, Hg((_$B = A + 96 | 0) + c | 0, 0, 256 - c | 0), f(A, _$B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, E[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, E[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, E[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, E[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, E[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, E[C + 60 >> 2] = i, Sg(I, C, g), XC(A, 64), XC(_$B, 256), _$B = 0;
                                                }
                                                return h = C - -64 | 0, _$B;
                                            }
                                            yC(), Q();
                                        }
                                        e(1369, 1217, 306, 1142), Q();
                                    }
                                    function AA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, _$B, Q, i = 0, _ = 0;
                                        h = C = h - 192 | 0, E[C + 144 >> 2] = 0, E[C + 148 >> 2] = 0, E[C + 152 >> 2] = 0, E[C + 156 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = E[8591], E[C + 168 >> 2] = E[8590], E[C + 172 >> 2] = i, i = E[8593], E[C + 176 >> 2] = E[8592], E[C + 180 >> 2] = i, i = E[8595], E[C + 184 >> 2] = E[8594], E[C + 188 >> 2] = i, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 136 >> 2] = 0, E[C + 140 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, i = E[8589], E[C + 160 >> 2] = E[8588], E[C + 164 >> 2] = i, i = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 80 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 88 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 92 >> 2] = i, i = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C + 64 >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 68 >> 2] = i, i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 72 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 76 >> 2] = i, Eg(g = C + 128 | 0, i = C - -64 | 0), N(g), _ = E[C + 156 >> 2], E[C + 24 >> 2] = E[C + 152 >> 2], E[C + 28 >> 2] = _, _ = E[C + 148 >> 2], E[C + 16 >> 2] = E[C + 144 >> 2], E[C + 20 >> 2] = _, _ = E[C + 140 >> 2], E[C + 8 >> 2] = E[C + 136 >> 2], E[C + 12 >> 2] = _, _ = E[C + 132 >> 2], E[C >> 2] = E[C + 128 >> 2], E[C + 4 >> 2] = _, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, _ = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = _, _ = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = _, _ = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, _$B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, Q = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 64 >> 2] = Q, E[C + 68 >> 2] = I, E[C + 72 >> 2] = _, E[C + 76 >> 2] = _$B, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, og(i, C), I = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = I, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(g), I = E[C + 156 >> 2], i = E[C + 152 >> 2], o[A + 24 | 0] = i, o[A + 25 | 0] = i >>> 8, o[A + 26 | 0] = i >>> 16, o[A + 27 | 0] = i >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[C + 148 >> 2], i = E[C + 144 >> 2], o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[C + 140 >> 2], i = E[C + 136 >> 2], o[A + 8 | 0] = i, o[A + 9 | 0] = i >>> 8, o[A + 10 | 0] = i >>> 16, o[A + 11 | 0] = i >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[C + 132 >> 2], i = E[C + 128 >> 2], o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = C + 192 | 0;
                                    }
                                    function IA(A) {
                                        var _$I, g, C, _$B, Q, i, a, _, t, r, e = 0, y = 0, s = 0, D = 0, p = 0;
                                        for(h = _$I = h - 2048 | 0, TA(D = _$I + 640 | 0, A), e = E[A + 36 >> 2], E[_$I + 352 >> 2] = E[A + 32 >> 2], E[_$I + 356 >> 2] = e, e = E[A + 28 >> 2], E[_$I + 344 >> 2] = E[A + 24 >> 2], E[_$I + 348 >> 2] = e, e = E[A + 20 >> 2], E[_$I + 336 >> 2] = E[A + 16 >> 2], E[_$I + 340 >> 2] = e, e = E[A + 12 >> 2], E[_$I + 328 >> 2] = E[A + 8 >> 2], E[_$I + 332 >> 2] = e, e = E[A + 4 >> 2], E[_$I + 320 >> 2] = E[A >> 2], E[_$I + 324 >> 2] = e, e = E[A + 52 >> 2], E[_$I + 368 >> 2] = E[A + 48 >> 2], E[_$I + 372 >> 2] = e, e = E[A + 60 >> 2], E[_$I + 376 >> 2] = E[A + 56 >> 2], E[_$I + 380 >> 2] = e, e = E[4 + (s = A - -64 | 0) >> 2], E[_$I + 384 >> 2] = E[s >> 2], E[_$I + 388 >> 2] = e, e = E[A + 76 >> 2], E[_$I + 392 >> 2] = E[A + 72 >> 2], E[_$I + 396 >> 2] = e, e = E[A + 44 >> 2], E[_$I + 360 >> 2] = E[A + 40 >> 2], E[_$I + 364 >> 2] = e, e = E[A + 92 >> 2], E[_$I + 408 >> 2] = E[A + 88 >> 2], E[_$I + 412 >> 2] = e, e = E[A + 100 >> 2], E[_$I + 416 >> 2] = E[A + 96 >> 2], E[_$I + 420 >> 2] = e, e = E[A + 108 >> 2], E[_$I + 424 >> 2] = E[A + 104 >> 2], E[_$I + 428 >> 2] = e, e = E[A + 116 >> 2], E[_$I + 432 >> 2] = E[A + 112 >> 2], E[_$I + 436 >> 2] = e, e = E[A + 84 >> 2], E[_$I + 400 >> 2] = E[A + 80 >> 2], E[_$I + 404 >> 2] = e, KA(y = _$I + 480 | 0, s = _$I + 320 | 0), Y(e = _$I + 160 | 0, y, g = _$I + 600 | 0), Y(_$I + 200 | 0, C = _$I + 520 | 0, _$B = _$I + 560 | 0), Y(_$I + 240 | 0, _$B, g), Y(_$I + 280 | 0, y, C), sA(y, e, D), Y(s, y, g), Y(a = _$I + 360 | 0, C, _$B), Y(_ = _$I + 400 | 0, _$B, g), Y(t = _$I + 440 | 0, y, C), TA(A = _$I + 800 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), TA(A = _$I + 960 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), TA(A = _$I + 1120 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), TA(A = _$I + 1280 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), TA(A = _$I + 1440 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), TA(A = _$I + 1600 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), TA(_$I + 1760 | 0, s), E[_$I + 32 >> 2] = 0, E[_$I + 36 >> 2] = 0, E[_$I + 24 >> 2] = 0, E[_$I + 28 >> 2] = 0, E[_$I + 16 >> 2] = 0, E[_$I + 20 >> 2] = 0, E[_$I + 8 >> 2] = 0, E[_$I + 12 >> 2] = 0, E[_$I + 44 >> 2] = 0, E[_$I + 48 >> 2] = 0, E[_$I + 52 >> 2] = 0, E[_$I + 56 >> 2] = 0, E[_$I + 60 >> 2] = 0, E[_$I + 64 >> 2] = 0, E[_$I + 68 >> 2] = 0, E[_$I + 72 >> 2] = 0, E[_$I + 76 >> 2] = 0, E[_$I + 80 >> 2] = 1, E[_$I >> 2] = 0, E[_$I + 4 >> 2] = 0, E[_$I + 40 >> 2] = 1, Hg(_$I + 84 | 0, 0, 76), r = _$I + 120 | 0, Q = _$I + 2008 | 0, i = _$I + 1968 | 0, D = _$I + 80 | 0, s = _$I + 40 | 0, A = 252; e = E[_$I + 36 >> 2], E[(y = _$I + 1960 | 0) >> 2] = E[_$I + 32 >> 2], E[y + 4 >> 2] = e, e = E[_$I + 28 >> 2], E[(y = _$I + 1952 | 0) >> 2] = E[_$I + 24 >> 2], E[y + 4 >> 2] = e, e = E[_$I + 20 >> 2], E[(y = _$I + 1944 | 0) >> 2] = E[_$I + 16 >> 2], E[y + 4 >> 2] = e, e = E[_$I + 12 >> 2], E[(y = _$I + 1936 | 0) >> 2] = E[_$I + 8 >> 2], E[y + 4 >> 2] = e, e = E[_$I + 4 >> 2], E[_$I + 1928 >> 2] = E[_$I >> 2], E[_$I + 1932 >> 2] = e, e = E[s + 36 >> 2], E[i + 32 >> 2] = E[s + 32 >> 2], E[i + 36 >> 2] = e, e = E[s + 28 >> 2], E[i + 24 >> 2] = E[s + 24 >> 2], E[i + 28 >> 2] = e, e = E[s + 20 >> 2], E[i + 16 >> 2] = E[s + 16 >> 2], E[i + 20 >> 2] = e, e = E[s + 12 >> 2], E[i + 8 >> 2] = E[s + 8 >> 2], E[i + 12 >> 2] = e, e = E[s + 4 >> 2], E[i >> 2] = E[s >> 2], E[i + 4 >> 2] = e, e = E[D + 36 >> 2], E[Q + 32 >> 2] = E[D + 32 >> 2], E[Q + 36 >> 2] = e, e = E[D + 28 >> 2], E[Q + 24 >> 2] = E[D + 24 >> 2], E[Q + 28 >> 2] = e, e = E[D + 20 >> 2], E[Q + 16 >> 2] = E[D + 16 >> 2], E[Q + 20 >> 2] = e, e = E[D + 12 >> 2], E[Q + 8 >> 2] = E[D + 8 >> 2], E[Q + 12 >> 2] = e, e = E[D + 4 >> 2], E[Q >> 2] = E[D >> 2], E[Q + 4 >> 2] = e, e = A, p = o[A + 33728 | 0], KA(y = _$I + 480 | 0, _$I + 1928 | 0), (0 | p) > 0 ? (Y(A = _$I + 320 | 0, y, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), sA(y, A, (_$I + 640 | 0) + c((254 & p) >>> 1 | 0, 160) | 0)) : (0 | p) >= 0 || (Y(A = _$I + 320 | 0, y = _$I + 480 | 0, g), Y(a, C, _$B), Y(_, _$B, g), Y(t, y, C), hA(y, A, (_$I + 640 | 0) + c((0 - p & 254) >>> 1 | 0, 160) | 0)), Y(_$I, A = _$I + 480 | 0, g), Y(s, C, _$B), Y(D, _$B, g), Y(r, A, C), A = e - 1 | 0, e;);
                                        return BI(A = _$I + 640 | 0, _$I), A = NI(A, 32), h = _$I + 2048 | 0, A;
                                    }
                                    function gA(A) {
                                        var _$I = 0, g = 0, C = 0, _$B = 0, Q = 0, i = 0, o = 0, a = 0, c = 0;
                                        A: if (A |= 0) {
                                            Q = (C = A - 8 | 0) + (A = -8 & (_$I = E[A - 4 >> 2])) | 0;
                                            I: if (!(1 & _$I)) {
                                                if (!(3 & _$I)) break A;
                                                if ((C = C - (_$I = E[C >> 2]) | 0) >>> 0 < _[9397]) break A;
                                                A = A + _$I | 0;
                                                g: {
                                                    C: {
                                                        if (E[9398] != (0 | C)) {
                                                            if (_$I >>> 0 <= 255) {
                                                                if (_$B = _$I >>> 3 | 0, (0 | (_$I = E[C + 12 >> 2])) == (0 | (g = E[C + 8 >> 2]))) {
                                                                    a = 37572, c = E[9393] & Lg(-2, _$B), E[a >> 2] = c;
                                                                    break I;
                                                                }
                                                                E[g + 12 >> 2] = _$I, E[_$I + 8 >> 2] = g;
                                                                break I;
                                                            }
                                                            if (o = E[C + 24 >> 2], (0 | C) != (0 | (_$I = E[C + 12 >> 2]))) {
                                                                g = E[C + 8 >> 2], E[g + 12 >> 2] = _$I, E[_$I + 8 >> 2] = g;
                                                                break g;
                                                            }
                                                            if (!(g = E[(_$B = C + 20 | 0) >> 2])) {
                                                                if (!(g = E[C + 16 >> 2])) break C;
                                                                _$B = C + 16 | 0;
                                                            }
                                                            for(; i = _$B, (g = E[(_$B = (_$I = g) + 20 | 0) >> 2]) || (_$B = _$I + 16 | 0, g = E[_$I + 16 >> 2]););
                                                            E[i >> 2] = 0;
                                                            break g;
                                                        }
                                                        if (3 != (3 & (_$I = E[Q + 4 >> 2]))) break I;
                                                        return E[9395] = A, E[Q + 4 >> 2] = -2 & _$I, E[C + 4 >> 2] = 1 | A, void (E[Q >> 2] = A);
                                                    }
                                                    _$I = 0;
                                                }
                                                if (o) {
                                                    g = E[C + 28 >> 2];
                                                    g: {
                                                        if (E[(_$B = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (E[_$B >> 2] = _$I, _$I) break g;
                                                            a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = _$I, !_$I) break I;
                                                    }
                                                    E[_$I + 24 >> 2] = o, (g = E[C + 16 >> 2]) && (E[_$I + 16 >> 2] = g, E[g + 24 >> 2] = _$I), (g = E[C + 20 >> 2]) && (E[_$I + 20 >> 2] = g, E[g + 24 >> 2] = _$I);
                                                }
                                            }
                                            if (!(C >>> 0 >= Q >>> 0) && 1 & (_$I = E[Q + 4 >> 2])) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!(2 & _$I)) {
                                                                    if (E[9399] == (0 | Q)) {
                                                                        if (E[9399] = C, A = E[9396] + A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[9398] != (0 | C)) break A;
                                                                        return E[9395] = 0, void (E[9398] = 0);
                                                                    }
                                                                    if (E[9398] == (0 | Q)) return E[9398] = C, A = E[9395] + A | 0, E[9395] = A, E[C + 4 >> 2] = 1 | A, void (E[A + C >> 2] = A);
                                                                    if (A = (-8 & _$I) + A | 0, _$I >>> 0 <= 255) {
                                                                        if (_$B = _$I >>> 3 | 0, (0 | (_$I = E[Q + 12 >> 2])) == (0 | (g = E[Q + 8 >> 2]))) {
                                                                            a = 37572, c = E[9393] & Lg(-2, _$B), E[a >> 2] = c;
                                                                            break g;
                                                                        }
                                                                        E[g + 12 >> 2] = _$I, E[_$I + 8 >> 2] = g;
                                                                        break g;
                                                                    }
                                                                    if (o = E[Q + 24 >> 2], (0 | Q) != (0 | (_$I = E[Q + 12 >> 2]))) {
                                                                        g = E[Q + 8 >> 2], E[g + 12 >> 2] = _$I, E[_$I + 8 >> 2] = g;
                                                                        break C;
                                                                    }
                                                                    if (!(g = E[(_$B = Q + 20 | 0) >> 2])) {
                                                                        if (!(g = E[Q + 16 >> 2])) break B;
                                                                        _$B = Q + 16 | 0;
                                                                    }
                                                                    for(; i = _$B, (g = E[(_$B = (_$I = g) + 20 | 0) >> 2]) || (_$B = _$I + 16 | 0, g = E[_$I + 16 >> 2]););
                                                                    E[i >> 2] = 0;
                                                                    break C;
                                                                }
                                                                E[Q + 4 >> 2] = -2 & _$I, E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A;
                                                                break I;
                                                            }
                                                            _$I = 0;
                                                        }
                                                        if (o) {
                                                            g = E[Q + 28 >> 2];
                                                            C: {
                                                                if (E[(_$B = 37876 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                    if (E[_$B >> 2] = _$I, _$I) break C;
                                                                    a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                                    break g;
                                                                }
                                                                if (E[o + (E[o + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = _$I, !_$I) break g;
                                                            }
                                                            E[_$I + 24 >> 2] = o, (g = E[Q + 16 >> 2]) && (E[_$I + 16 >> 2] = g, E[g + 24 >> 2] = _$I), (g = E[Q + 20 >> 2]) && (E[_$I + 20 >> 2] = g, E[g + 24 >> 2] = _$I);
                                                        }
                                                    }
                                                    if (E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A, E[9398] == (0 | C)) return void (E[9395] = A);
                                                }
                                                if (A >>> 0 <= 255) return _$I = 37612 + (-8 & A) | 0, (g = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[_$I + 8 >> 2] : (E[9393] = A | g, A = _$I), E[_$I + 8 >> 2] = C, E[A + 12 >> 2] = C, E[C + 12 >> 2] = _$I, void (E[C + 8 >> 2] = A);
                                                g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (_$I = t(A >>> 8 | 0)) & 1) - (_$I << 1) | 0) | 0), E[C + 28 >> 2] = g, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, _$I = 37876 + (g << 2) | 0;
                                                I: {
                                                    g: {
                                                        if ((_$B = E[9394]) & (i = 1 << g)) {
                                                            for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), _$I = E[_$I >> 2];;){
                                                                if (_$B = _$I, (-8 & E[_$I + 4 >> 2]) == (0 | A)) break g;
                                                                if (i = g >>> 29 | 0, g <<= 1, !(_$I = E[16 + (i = _$I + (4 & i) | 0) >> 2])) break;
                                                            }
                                                            E[i + 16 >> 2] = C, E[C + 24 >> 2] = _$B;
                                                        } else E[9394] = _$B | i, E[_$I >> 2] = C, E[C + 24 >> 2] = _$I;
                                                        E[C + 12 >> 2] = C, E[C + 8 >> 2] = C;
                                                        break I;
                                                    }
                                                    A = E[_$B + 8 >> 2], E[A + 12 >> 2] = C, E[_$B + 8 >> 2] = C, E[C + 24 >> 2] = 0, E[C + 12 >> 2] = _$B, E[C + 8 >> 2] = A;
                                                }
                                                A = E[9401] - 1 | 0, E[9401] = A || -1;
                                            }
                                        }
                                    }
                                    function CA(A, I, g, C, B) {
                                        var Q, i, E, _, c, t, r, e, y, s, h, D, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0;
                                        if (C ? (_$U = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, _$m = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, l = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, u = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24) : (_$U = 1797285236, l = 1634760805, _$m = 2036477234, u = 857760878), C = Q = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = i = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, _$K = E = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = _$U, _$N = _ = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, G = _$m, _$H = c = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = t = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = r = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, I = e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, b = u, p = y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = s = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, k = h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, g = D = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = l, (0 | B) > 0) for(; Y = Lg(g + b | 0, 7) ^ _$H, x = Lg(Y + b | 0, 9) ^ S, _$d = Lg(C + F | 0, 7) ^ p, R = Lg(_$d + F | 0, 9) ^ M, v = Lg(_$d + R | 0, 13) ^ C, J = Lg(f + _$N | 0, 7) ^ w, n = Lg(J + f | 0, 9) ^ n, w = Lg(n + J | 0, 13) ^ _$N, f = Lg(n + w | 0, 18) ^ f, p = Lg(I + G | 0, 7) ^ _$K, C = v ^ Lg(f + p | 0, 7), S = Lg(C + f | 0, 9) ^ x, _$K = Lg(C + S | 0, 13) ^ p, f = Lg(S + _$K | 0, 18) ^ f, k = Lg(p + G | 0, 9) ^ k, p = Lg(k + p | 0, 13) ^ I, I = Lg(p + k | 0, 18) ^ G, _$N = Lg(I + Y | 0, 7) ^ w, M = Lg(_$N + I | 0, 9) ^ R, _$H = Lg(_$N + M | 0, 13) ^ Y, G = Lg(M + _$H | 0, 18) ^ I, g = Lg(Y + x | 0, 13) ^ g, w = Lg(g + x | 0, 18) ^ b, I = Lg(w + _$d | 0, 7) ^ p, n = Lg(I + w | 0, 9) ^ n, p = Lg(I + n | 0, 13) ^ _$d, b = Lg(n + p | 0, 18) ^ w, F = Lg(R + v | 0, 18) ^ F, g = Lg(F + J | 0, 7) ^ g, k = Lg(g + F | 0, 9) ^ k, w = Lg(g + k | 0, 13) ^ J, F = Lg(k + w | 0, 18) ^ F, (0 | (L = L + 2 | 0)) < (0 | B););
                                        B = f + _$U | 0, o[A + 60 | 0] = B, o[A + 61 | 0] = B >>> 8, o[A + 62 | 0] = B >>> 16, o[A + 63 | 0] = B >>> 24, B = _$K + E | 0, o[A + 56 | 0] = B, o[A + 57 | 0] = B >>> 8, o[A + 58 | 0] = B >>> 16, o[A + 59 | 0] = B >>> 24, B = S + i | 0, o[A + 52 | 0] = B, o[A + 53 | 0] = B >>> 8, o[A + 54 | 0] = B >>> 16, o[A + 55 | 0] = B >>> 24, C = C + Q | 0, o[A + 48 | 0] = C, o[A + 49 | 0] = C >>> 8, o[A + 50 | 0] = C >>> 16, o[A + 51 | 0] = C >>> 24, C = _$N + _ | 0, o[A + 44 | 0] = C, o[A + 45 | 0] = C >>> 8, o[A + 46 | 0] = C >>> 16, o[A + 47 | 0] = C >>> 24, C = G + _$m | 0, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, C = _$H + c | 0, o[A + 36 | 0] = C, o[A + 37 | 0] = C >>> 8, o[A + 38 | 0] = C >>> 16, o[A + 39 | 0] = C >>> 24, C = M + t | 0, o[A + 32 | 0] = C, o[A + 33 | 0] = C >>> 8, o[A + 34 | 0] = C >>> 16, o[A + 35 | 0] = C >>> 24, C = n + r | 0, o[A + 28 | 0] = C, o[A + 29 | 0] = C >>> 8, o[A + 30 | 0] = C >>> 16, o[A + 31 | 0] = C >>> 24, I = I + e | 0, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = b + u | 0, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p + y | 0, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = w + s | 0, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = k + h | 0, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = g + D | 0, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F + l | 0, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                    }
                                    function BA(A, I, g, C, B, Q) {
                                        var i = 0;
                                        if (E[Q >> 2] = 8, !(I = (i = !I & A >>> 0 <= 32768) ? 0 : I) & g >>> 5 >>> 0 <= (A = i ? 32768 : A) >>> 0 | I) return i = 1, g >>> 0 < 4096 || (i = 2, g >>> 0 < 8192 || (i = 3, g >>> 0 < 16384 || (i = 4, g >>> 0 < 32768 || (i = 5, g >>> 0 < 65536 || (i = 6, g >>> 0 < 131072 || (i = 7, g >>> 0 < 262144 || (i = 8, g >>> 0 < 524288 || (i = 9, g >>> 0 < 1048576 || (i = 10, g >>> 0 < 2097152 || (i = 11, g >>> 0 < 4194304 || (i = 12, g >>> 0 < 8388608 || (i = 13, g >>> 0 < 16777216 || (i = 14, g >>> 0 < 33554432 || (i = 15, g >>> 0 < 67108864 || (i = 16, g >>> 0 < 134217728 || (i = 17, g >>> 0 < 268435456 || (i = 18, g >>> 0 < 536870912 || (i = 19, g >>> 0 < 1073741824 || (i = (0 | g) >= 0 ? 20 : 21))))))))))))))))))), g = i, E[C >> 2] = g, C = I >>> 2 | 0, I = (3 & I) << 30 | A >>> 2, A = 31 & g, (63 & g) >>> 0 >= 32 ? (g = 0, A = C >>> A | 0) : (g = C >>> A | 0, A = ((1 << A) - 1 & C) << 32 - A | I >>> A), void (E[B >> 2] = ((!g & A >>> 0 >= 1073741823 | g ? 1073741823 : A) >>> 0) / _[Q >> 2]);
                                        E[B >> 2] = 1, I = oI(A, I, E[Q >> 2] << 2), g = 1, !(A = w) & I >>> 0 < 4 || (g = 2, !A & I >>> 0 < 8 || (g = 3, !A & I >>> 0 < 16 || (g = 4, !A & I >>> 0 < 32 || (g = 5, !A & I >>> 0 < 64 || (g = 6, !A & I >>> 0 < 128 || (g = 7, !A & I >>> 0 < 256 || (g = 8, !A & I >>> 0 < 512 || (g = 9, !A & I >>> 0 < 1024 || (g = 10, !A & I >>> 0 < 2048 || (g = 11, !A & I >>> 0 < 4096 || (g = 12, !A & I >>> 0 < 8192 || (g = 13, !A & I >>> 0 < 16384 || (g = 14, !A & I >>> 0 < 32768 || (g = 15, !A & I >>> 0 < 65536 || (g = 16, !A & I >>> 0 < 131072 || (g = 17, !A & I >>> 0 < 262144 || (g = 18, !A & I >>> 0 < 524288 || (g = 19, !A & I >>> 0 < 1048576 || (g = 20, !A & I >>> 0 < 2097152 || (g = 21, !A & I >>> 0 < 4194304 || (g = 22, !A & I >>> 0 < 8388608 || (g = 23, !A & I >>> 0 < 16777216 || (g = 24, !A & I >>> 0 < 33554432 || (g = 25, !A & I >>> 0 < 67108864 || (g = 26, !A & I >>> 0 < 134217728 || (g = 27, !A & I >>> 0 < 268435456 || (g = 28, !A & I >>> 0 < 536870912 || (g = 29, !A & I >>> 0 < 1073741824 || (g = 30, !A & I >>> 0 < 2147483648 || (g = 31, A && (g = 32, A >>> 0 < 2 || (g = 33, A >>> 0 < 4 || (g = 34, A >>> 0 < 8 || (g = 35, A >>> 0 < 16 || (g = 36, A >>> 0 < 32 || (g = 37, A >>> 0 < 64 || (g = 38, A >>> 0 < 128 || (g = 39, A >>> 0 < 256 || (g = 40, A >>> 0 < 512 || (g = 41, A >>> 0 < 1024 || (g = 42, A >>> 0 < 2048 || (g = 43, A >>> 0 < 4096 || (g = 44, A >>> 0 < 8192 || (g = 45, A >>> 0 < 16384 || (g = 46, A >>> 0 < 32768 || (g = 47, A >>> 0 < 65536 || (g = 48, A >>> 0 < 131072 || (g = 49, A >>> 0 < 262144 || (g = 50, A >>> 0 < 524288 || (g = 51, A >>> 0 < 1048576 || (g = 52, A >>> 0 < 2097152 || (g = 53, A >>> 0 < 4194304 || (g = 54, A >>> 0 < 8388608 || (g = 55, A >>> 0 < 16777216 || (g = 56, A >>> 0 < 33554432 || (g = 57, A >>> 0 < 67108864 || (g = 58, A >>> 0 < 134217728 || (g = 59, A >>> 0 < 268435456 || (g = 60, A >>> 0 < 536870912 || (g = 61, A >>> 0 < 1073741824 || (g = (0 | A) > 0 | (0 | A) >= 0 ? 62 : 63))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), E[C >> 2] = g;
                                    }
                                    function QA(A, I, g, C, B, i, o, _, c) {
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            w = t = h, h = t = t - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((D = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), o = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), _ = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24)) : (r = 725511199, e = -1694144372, o = -1377402159, _ = 1359893119), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), p = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24), c = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24)) : (y = 327033209, s = 1541459225, p = -79577749, c = 528734635), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = p, E[t + 52 >> 2] = c, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = o, E[t + 36 >> 2] = _, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ (I << 8 | D), E[t + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = t + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(t + 96 | 0, o, 128), E[t + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), i = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24), I = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24)) : (r = 725511199, e = -1694144372, i = 1359893119, I = -1377402159), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), _ = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24), o = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24)) : (y = 327033209, s = 1541459225, _ = 528734635, o = -79577749), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = o, E[t + 52 >> 2] = _, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = I, E[t + 36 >> 2] = i, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ D, E[t + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(c = t + 224 | 0, _ = t + 96 | 0;;){
                                                        if (o = I + _ | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[t + 352 >> 2] = C + E[t + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[t + 352 >> 2] = i + E[t + 352 >> 2], r = I = E[t + 68 >> 2], I = (e = (o = E[t + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[t + 64 >> 2] = e, E[t + 68 >> 2] = I, I = E[t + 76 >> 2], I = (r = o = -1 == (0 | r) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[t + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[t + 72 >> 2] = o, E[t + 76 >> 2] = I, f(t, _), Sg(_, c, 128), I = E[t + 352 >> 2] - 128 | 0, E[t + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(t, A, D), h = w;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function iA(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0;
                                        g = A + I | 0;
                                        A: {
                                            I: if (!(1 & (C = E[A + 4 >> 2]))) {
                                                if (!(3 & C)) break A;
                                                I = (C = E[A >> 2]) + I | 0;
                                                g: {
                                                    C: {
                                                        B: {
                                                            if ((0 | (A = A - C | 0)) != E[9398]) {
                                                                if (C >>> 0 <= 255) {
                                                                    if ((0 | (_$B = E[A + 8 >> 2])) != (0 | (Q = E[A + 12 >> 2]))) break B;
                                                                    a = 37572, _ = E[9393] & Lg(-2, C >>> 3 | 0), E[a >> 2] = _;
                                                                    break I;
                                                                }
                                                                if (o = E[A + 24 >> 2], (0 | (C = E[A + 12 >> 2])) != (0 | A)) {
                                                                    _$B = E[A + 8 >> 2], E[_$B + 12 >> 2] = C, E[C + 8 >> 2] = _$B;
                                                                    break g;
                                                                }
                                                                if (!(_$B = E[(Q = A + 20 | 0) >> 2])) {
                                                                    if (!(_$B = E[A + 16 >> 2])) break C;
                                                                    Q = A + 16 | 0;
                                                                }
                                                                for(; i = Q, (_$B = E[(Q = (C = _$B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, _$B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (C = E[g + 4 >> 2]))) break I;
                                                            return E[9395] = I, E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, void (E[g >> 2] = I);
                                                        }
                                                        E[_$B + 12 >> 2] = Q, E[Q + 8 >> 2] = _$B;
                                                        break I;
                                                    }
                                                    C = 0;
                                                }
                                                if (o) {
                                                    _$B = E[A + 28 >> 2];
                                                    g: {
                                                        if (E[(Q = 37876 + (_$B << 2) | 0) >> 2] == (0 | A)) {
                                                            if (E[Q >> 2] = C, C) break g;
                                                            a = 37576, _ = E[9394] & Lg(-2, _$B), E[a >> 2] = _;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | A) ? 16 : 20) >> 2] = C, !C) break I;
                                                    }
                                                    E[C + 24 >> 2] = o, (_$B = E[A + 16 >> 2]) && (E[C + 16 >> 2] = _$B, E[_$B + 24 >> 2] = C), (_$B = E[A + 20 >> 2]) && (E[C + 20 >> 2] = _$B, E[_$B + 24 >> 2] = C);
                                                }
                                            }
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            if (!(2 & (C = E[g + 4 >> 2]))) {
                                                                if (E[9399] == (0 | g)) {
                                                                    if (E[9399] = A, I = E[9396] + I | 0, E[9396] = I, E[A + 4 >> 2] = 1 | I, E[9398] != (0 | A)) break A;
                                                                    return E[9395] = 0, void (E[9398] = 0);
                                                                }
                                                                if (E[9398] == (0 | g)) return E[9398] = A, I = E[9395] + I | 0, E[9395] = I, E[A + 4 >> 2] = 1 | I, void (E[A + I >> 2] = I);
                                                                if (I = (-8 & C) + I | 0, C >>> 0 <= 255) {
                                                                    if (Q = C >>> 3 | 0, (0 | (C = E[g + 12 >> 2])) == (0 | (_$B = E[g + 8 >> 2]))) {
                                                                        a = 37572, _ = E[9393] & Lg(-2, Q), E[a >> 2] = _;
                                                                        break g;
                                                                    }
                                                                    E[_$B + 12 >> 2] = C, E[C + 8 >> 2] = _$B;
                                                                    break g;
                                                                }
                                                                if (o = E[g + 24 >> 2], (0 | g) != (0 | (C = E[g + 12 >> 2]))) {
                                                                    _$B = E[g + 8 >> 2], E[_$B + 12 >> 2] = C, E[C + 8 >> 2] = _$B;
                                                                    break C;
                                                                }
                                                                if (!(_$B = E[(Q = g + 20 | 0) >> 2])) {
                                                                    if (!(_$B = E[g + 16 >> 2])) break B;
                                                                    Q = g + 16 | 0;
                                                                }
                                                                for(; i = Q, (_$B = E[(Q = (C = _$B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, _$B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break C;
                                                            }
                                                            E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I;
                                                            break I;
                                                        }
                                                        C = 0;
                                                    }
                                                    if (o) {
                                                        _$B = E[g + 28 >> 2];
                                                        C: {
                                                            if (E[(Q = 37876 + (_$B << 2) | 0) >> 2] == (0 | g)) {
                                                                if (E[Q >> 2] = C, C) break C;
                                                                a = 37576, _ = E[9394] & Lg(-2, _$B), E[a >> 2] = _;
                                                                break g;
                                                            }
                                                            if (E[o + (E[o + 16 >> 2] == (0 | g) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        E[C + 24 >> 2] = o, (_$B = E[g + 16 >> 2]) && (E[C + 16 >> 2] = _$B, E[_$B + 24 >> 2] = C), (_$B = E[g + 20 >> 2]) && (E[C + 20 >> 2] = _$B, E[_$B + 24 >> 2] = C);
                                                    }
                                                }
                                                if (E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I, E[9398] == (0 | A)) return void (E[9395] = I);
                                            }
                                            if (I >>> 0 <= 255) return C = 37612 + (-8 & I) | 0, (_$B = E[9393]) & (I = 1 << (I >>> 3)) ? I = E[C + 8 >> 2] : (E[9393] = I | _$B, I = C), E[C + 8 >> 2] = A, E[I + 12 >> 2] = A, E[A + 12 >> 2] = C, void (E[A + 8 >> 2] = I);
                                            _$B = 31, I >>> 0 <= 16777215 && (_$B = 62 + ((I >>> 38 - (C = t(I >>> 8 | 0)) & 1) - (C << 1) | 0) | 0), E[A + 28 >> 2] = _$B, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, C = 37876 + (_$B << 2) | 0;
                                            I: {
                                                if ((Q = E[9394]) & (i = 1 << _$B)) {
                                                    for(_$B = I << (31 != (0 | _$B) ? 25 - (_$B >>> 1 | 0) | 0 : 0), C = E[C >> 2];;){
                                                        if (Q = C, (-8 & E[C + 4 >> 2]) == (0 | I)) break I;
                                                        if (i = _$B >>> 29 | 0, _$B <<= 1, !(C = E[16 + (i = C + (4 & i) | 0) >> 2])) break;
                                                    }
                                                    E[i + 16 >> 2] = A, E[A + 24 >> 2] = Q;
                                                } else E[9394] = Q | i, E[C >> 2] = A, E[A + 24 >> 2] = C;
                                                return E[A + 12 >> 2] = A, void (E[A + 8 >> 2] = A);
                                            }
                                            I = E[Q + 8 >> 2], E[I + 12 >> 2] = A, E[Q + 8 >> 2] = A, E[A + 24 >> 2] = 0, E[A + 12 >> 2] = Q, E[A + 8 >> 2] = I;
                                        }
                                    }
                                    function oA(A, I, g, C, B, Q, i) {
                                        var _, t, r = 0, e = 0, y = 0;
                                        if (h = _ = h + -64 | 0, t = K(32)) {
                                            E[_ + 36 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 28 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 24 >> 2] = 16, E[_ + 20 >> 2] = B, E[_ + 16 >> 2] = C, E[_ + 12 >> 2] = g, E[_ + 8 >> 2] = 32, E[_ + 4 >> 2] = t, E[_ + 60 >> 2] = 0, E[_ + 56 >> 2] = 1, E[_ + 52 >> 2] = 1, E[_ + 48 >> 2] = I, E[_ + 44 >> 2] = A;
                                            A: if (A = L(_ + 4 | 0, i)) XC(t, 32);
                                            else {
                                                if (Q) {
                                                    r = _ + 4 | 0, h = B = h - 32 | 0, A = -31;
                                                    I: {
                                                        g: {
                                                            C: switch(i - 1 | 0){
                                                                case 1:
                                                                    A = a[1417] | a[1418] << 8 | a[1419] << 16 | a[1420] << 24, I = a[1413] | a[1414] << 8 | a[1415] << 16 | a[1416] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1422] | a[1423] << 8 | a[1424] << 16 | a[1425] << 24, I = a[1418] | a[1419] << 8 | a[1420] << 16 | a[1421] << 24, o[Q + 5 | 0] = I, o[Q + 6 | 0] = I >>> 8, o[Q + 7 | 0] = I >>> 16, o[Q + 8 | 0] = I >>> 24, o[Q + 9 | 0] = A, o[Q + 10 | 0] = A >>> 8, o[Q + 11 | 0] = A >>> 16, o[Q + 12 | 0] = A >>> 24, g = -12, I = 12;
                                                                    break g;
                                                                case 0:
                                                                    break C;
                                                                default:
                                                                    break I;
                                                            }
                                                            A = a[1405] | a[1406] << 8 | a[1407] << 16 | a[1408] << 24, I = a[1401] | a[1402] << 8 | a[1403] << 16 | a[1404] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1409] | a[1410] << 8 | a[1411] << 16 | a[1412] << 24, o[Q + 8 | 0] = A, o[Q + 9 | 0] = A >>> 8, o[Q + 10 | 0] = A >>> 16, o[Q + 11 | 0] = A >>> 24, g = -11, I = 11;
                                                        }
                                                        if (!(A = pI(r))) {
                                                            if (o[B + 13 | 0] = 0, o[B + 11 | 0] = 49, o[B + 12 | 0] = 57, (g = g + 128 | 0) >>> 0 <= (A = LI(B + 11 | 0)) >>> 0) A = -31;
                                                            else if (I = Sg(I + Q | 0, B + 11 | 0, A + 1 | 0), (e = g - A | 0) >>> 0 < 4) A = -31;
                                                            else {
                                                                for(o[0 | (i = A + I | 0)] = 36, o[i + 1 | 0] = 109, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 44 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                else {
                                                                    for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 116, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 40 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                    if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                    else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                    else {
                                                                        for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 112, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 48 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                        Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0 ? A = -31 : (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (C = I - A | 0) >>> 0 < 2 ? A = -31 : (o[0 | (A = A + g | 0)] = 36, o[A + 1 | 0] = 0, LA(I = A + 1 | 0, g = C - 1 | 0, E[r + 16 >> 2], E[r + 20 >> 2], 3) ? (A = -31, (C = (C = g) - (g = LI(I)) | 0) >>> 0 < 2 || (o[0 | (A = I + g | 0)] = 36, o[A + 1 | 0] = 0, A = LA(A + 1 | 0, C - 1 | 0, E[r >> 2], E[r + 4 >> 2], 3) ? 0 : -31)) : A = -31));
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if (h = B + 32 | 0, A) {
                                                        XC(t, 32), XC(Q, 128), A = -31;
                                                        break A;
                                                    }
                                                }
                                                XC(t, 32), A = 0;
                                            }
                                            gA(t);
                                        } else A = -22;
                                        return h = _ - -64 | 0, A;
                                    }
                                    function EA(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0;
                                        return h = g = h - 512 | 0, C = -1, Q = a[I + 31 | 0], _$B = a[0 | I], 1 & (((255 & (127 & (-1 ^ Q) | a[I + 1 | 0] & a[I + 2 | 0] & a[I + 3 | 0] & a[I + 4 | 0] & a[I + 5 | 0] & a[I + 6 | 0] & a[I + 7 | 0] & a[I + 8 | 0] & a[I + 9 | 0] & a[I + 10 | 0] & a[I + 11 | 0] & a[I + 12 | 0] & a[I + 13 | 0] & a[I + 14 | 0] & a[I + 15 | 0] & a[I + 16 | 0] & a[I + 17 | 0] & a[I + 18 | 0] & a[I + 19 | 0] & a[I + 20 | 0] & a[I + 21 | 0] & a[I + 22 | 0] & a[I + 23 | 0] & a[I + 24 | 0] & a[I + 25 | 0] & a[I + 26 | 0] & a[I + 27 | 0] & a[I + 28 | 0] & a[I + 29 | 0] & a[I + 30 | 0] ^ -1)) - 1 & 236 - _$B) >>> 8 | _$B | Q >>> 7) || (pA(Q = g + 336 | 0, I), v(g + 288 | 0, Q), I = E[g + 324 >> 2], E[g + 276 >> 2] = 0 - I, C = E[g + 320 >> 2], E[g + 272 >> 2] = 0 - C, _$B = E[g + 316 >> 2], E[g + 268 >> 2] = 0 - _$B, i = E[g + 312 >> 2], E[g + 264 >> 2] = 0 - i, _ = E[g + 308 >> 2], E[g + 260 >> 2] = 0 - _, c = E[g + 304 >> 2], E[g + 256 >> 2] = 0 - c, t = E[g + 300 >> 2], E[g + 252 >> 2] = 0 - t, r = E[g + 296 >> 2], E[g + 248 >> 2] = 0 - r, e = E[g + 292 >> 2], E[g + 244 >> 2] = 0 - e, y = E[g + 288 >> 2], E[g + 240 >> 2] = 1 - y, v(s = g + 144 | 0, w = g + 240 | 0), E[g + 228 >> 2] = I, E[g + 224 >> 2] = C, E[g + 220 >> 2] = _$B, E[g + 216 >> 2] = i, E[g + 212 >> 2] = _, E[g + 208 >> 2] = c, E[g + 204 >> 2] = t, E[g + 200 >> 2] = r, E[g + 196 >> 2] = e, E[g + 192 >> 2] = y + 1, v(C = g + 96 | 0, i = g + 192 | 0), Y(I = g + 48 | 0, 1600, s), _$B = E[g + 96 >> 2], _ = E[g + 48 >> 2], c = E[g + 100 >> 2], t = E[g + 52 >> 2], r = E[g + 104 >> 2], e = E[g + 56 >> 2], y = E[g + 108 >> 2], s = E[g + 60 >> 2], D = E[g + 112 >> 2], p = E[g + 64 >> 2], f = E[g + 116 >> 2], n = E[g + 68 >> 2], k = E[g + 120 >> 2], F = E[g + 72 >> 2], _$N = E[g + 124 >> 2], S = E[g + 76 >> 2], G = E[g + 128 >> 2], M = E[g + 80 >> 2], E[g + 84 >> 2] = 0 - (E[g + 84 >> 2] + E[g + 132 >> 2] | 0), E[g + 80 >> 2] = 0 - (G + M | 0), E[g + 76 >> 2] = 0 - (_$N + S | 0), E[g + 72 >> 2] = 0 - (k + F | 0), E[g + 68 >> 2] = 0 - (f + n | 0), E[g + 64 >> 2] = 0 - (D + p | 0), E[g + 60 >> 2] = 0 - (y + s | 0), E[g + 56 >> 2] = 0 - (r + e | 0), E[g + 52 >> 2] = 0 - (c + t | 0), E[g + 48 >> 2] = 0 - (_$B + _ | 0), Y(g, I, C), E[g + 404 >> 2] = 0, E[g + 408 >> 2] = 0, E[g + 412 >> 2] = 0, E[g + 416 >> 2] = 0, E[g + 420 >> 2] = 0, E[g + 388 >> 2] = 0, E[g + 392 >> 2] = 0, E[g + 384 >> 2] = 1, E[g + 396 >> 2] = 0, E[g + 400 >> 2] = 0, p = GA(_$B = g + 432 | 0, g + 384 | 0, g), Y(A, _$B, i), Y(C = A + 40 | 0, _$B, A), Y(C, C, I), Y(A, A, Q), Q = E[A + 36 >> 2] << 1, E[A + 36 >> 2] = Q, _$B = E[A + 32 >> 2] << 1, E[A + 32 >> 2] = _$B, i = E[A + 28 >> 2] << 1, E[A + 28 >> 2] = i, _ = E[A + 24 >> 2] << 1, E[A + 24 >> 2] = _, c = E[A + 20 >> 2] << 1, E[A + 20 >> 2] = c, t = E[A + 16 >> 2] << 1, E[A + 16 >> 2] = t, r = E[A + 12 >> 2] << 1, E[A + 12 >> 2] = r, e = E[A + 8 >> 2] << 1, E[A + 8 >> 2] = e, y = E[A + 4 >> 2] << 1, E[A + 4 >> 2] = y, s = E[A >> 2] << 1, E[A >> 2] = s, BI(D = g + 480 | 0, A), I = 0 - (1 & o[g + 480 | 0]) | 0, E[A + 36 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 32 >> 2] = _$B ^ I & (_$B ^ 0 - _$B), E[A + 28 >> 2] = i ^ I & (i ^ 0 - i), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = s ^ I & (s ^ 0 - s), Y(C, w, C), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, Y(I = A + 120 | 0, A, C), BI(D, I), A = a[g + 480 | 0], BI(D, C), C = 0 - (NI(D, 32) | 1 - p | 1 & A) | 0), h = g + 512 | 0, C;
                                    }
                                    function aA(A, I, g, C) {
                                        var _$B, Q = 0, i = 0;
                                        _$B = Q = h, h = Q = Q - 576 & -64, E[Q + 188 >> 2] = I;
                                        A: if (I >>> 0 <= 64) {
                                            if ((0 | eA(i = Q + 192 | 0, 0, 0, I)) < 0) break A;
                                            if ((0 | XA(i, Q + 188 | 0, 4, 0)) < 0) break A;
                                            if ((0 | XA(i, g, C, 0)) < 0) break A;
                                            Yg(i, A, I);
                                        } else if (!((0 | eA(i = Q + 192 | 0, 0, 0, 64)) < 0 || (0 | XA(i, Q + 188 | 0, 4, 0)) < 0 || (0 | XA(i, g, C, 0)) < 0 || (0 | Yg(i, Q + 112 | 0, 64)) < 0)) {
                                            if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, (I = I - 32 | 0) >>> 0 >= 65) for(;;){
                                                if (g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(Q + 112 | 0, 64, Q + 48 | 0, 64, 0, 0, 0)) < 0) break A;
                                                if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, !((I = I - 32 | 0) >>> 0 > 64)) break;
                                            }
                                            g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(g = Q + 112 | 0, I, Q + 48 | 0, 64, 0, 0, 0)) < 0 || Sg(A, g, I);
                                        }
                                        XC(Q + 192 | 0, 384), h = _$B;
                                    }
                                    function _A(A, I, g, C, B, Q, i, t, r, e, y) {
                                        var s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0;
                                        if (s = Ig(r, 0, t, 0), !(D = w) & s >>> 0 >= 1073741824 | D) return E[9392] = 22, -1;
                                        if (1 == (0 | i) | i >>> 0 > 1) return E[9392] = 22, -1;
                                        for(s = Q, f = i; s | f;)D = s, s &= s - 1, f &= f - !D, n = (k = k + 1 | 0) ? n : n + 1 | 0;
                                        if (!(!(w = n) & k >>> 0 < 2 & (!i & Q >>> 0 >= 2 | 0 != (0 | i)))) return E[9392] = 28, -1;
                                        if (!r || !t) return E[9392] = 28, -1;
                                        if (!(33554431 / (r >>> 0) >>> 0 < t >>> 0 | t >>> 0 > 16777215) & !i & Q >>> 0 <= 33554431 / (t >>> 0) >>> 0 && !((S = c(_$N = t << 7, r)) >>> 0 > (D = (k = c(Q, _$N)) + S | 0) >>> 0 || D >>> 0 > (s = (D + (t << 8) | 0) - -64 | 0) >>> 0)) {
                                            A: {
                                                if (s >>> 0 > _[A + 8 >> 2]) {
                                                    if (D = -1, vg(A)) break A;
                                                    if (h = f = h - 16 | 0, n = _I(f + 12 | 0, s), E[9392] = n, n = n ? 0 : E[f + 12 >> 2], E[A + 4 >> 2] = n, E[A >> 2] = n, E[A + 8 >> 2] = n ? s : 0, h = f + 16 | 0, !n) break A;
                                                }
                                                for(DI(I, g, C, B, M = E[A + 4 >> 2], S), _$d = (s = (G = S + M | 0) + k | 0) + (C = (A = t << 7) - 64 | 0) | 0, b = s + (t << 8) | 0, J = (f = A + s | 0) + C | 0, Y = Q - 1 | 0, n = t << 5;;){
                                                    for(k = c(_$N, _$H) + M | 0, D = 0; C = (A = D << 2) + k | 0, E[A + s >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 4 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 8 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = (A |= 12) + s | 0, A = A + k | 0, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, _$K = 0, C = 0, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    for(B = 0, A = 0; Sg(G + (c(B, n) << 2) | 0, s, _$N), tA(s, f, b, t), Sg(G + (c(n, 1 | B) << 2) | 0, f, _$N), tA(f, s, b, t), (0 | i) == (0 | (A = (B = B + 2 | 0) >>> 0 < 2 ? A + 1 | 0 : A)) & B >>> 0 < Q >>> 0 | A >>> 0 < i >>> 0;);
                                                    for(;;){
                                                        for(A = G + (c(n, Y & E[_$d >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        for(tA(s, f, b, t), A = G + (c(n, Y & E[J >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        if (tA(f, s, b, t), D = 0, C = A = (_$K = _$K + 2 | 0) >>> 0 < 2 ? C + 1 | 0 : C, !((0 | i) == (0 | A) & Q >>> 0 > _$K >>> 0 | A >>> 0 < i >>> 0)) break;
                                                    }
                                                    for(; C = (A = D << 2) + k | 0, B = E[A + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 4 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 8 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, A = (C = 12 | A) + k | 0, C = E[C + s >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    if ((0 | (_$H = _$H + 1 | 0)) == (0 | r)) break;
                                                }
                                                DI(I, g, M, S, e, y), D = 0;
                                            }
                                            return D;
                                        }
                                        return E[9392] = 48, -1;
                                    }
                                    function cA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, _$B, Q, i = 0;
                                        h = C = h - 192 | 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = i, _$B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = i, E[C + 68 >> 2] = I, E[C + 72 >> 2] = _$B, E[C + 76 >> 2] = Q, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, I = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 16 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 20 >> 2] = I, I = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 24 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 28 >> 2] = I, I = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 4 >> 2] = I, I = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 8 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 12 >> 2] = I, og(C - -64 | 0, C), g = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = g, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(I = C + 128 | 0), i = E[C + 156 >> 2], g = E[C + 152 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = i, o[A + 29 | 0] = i >>> 8, o[A + 30 | 0] = i >>> 16, o[A + 31 | 0] = i >>> 24, i = E[C + 148 >> 2], g = E[C + 144 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, i = E[C + 140 >> 2], g = E[C + 136 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, i = E[C + 132 >> 2], g = E[C + 128 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, XC(I, 64), h = C + 192 | 0;
                                    }
                                    function tA(A, I, g, C) {
                                        var _$B = 0, Q = 0, i = 0, o = 0, a = 0;
                                        if (i = E[4 + (_$B = ((C << 7) + A | 0) - 64 | 0) >> 2], E[g >> 2] = E[_$B >> 2], E[g + 4 >> 2] = i, i = E[_$B + 60 >> 2], E[g + 56 >> 2] = E[_$B + 56 >> 2], E[g + 60 >> 2] = i, i = E[_$B + 52 >> 2], E[g + 48 >> 2] = E[_$B + 48 >> 2], E[g + 52 >> 2] = i, i = E[_$B + 44 >> 2], E[g + 40 >> 2] = E[_$B + 40 >> 2], E[g + 44 >> 2] = i, i = E[_$B + 36 >> 2], E[g + 32 >> 2] = E[_$B + 32 >> 2], E[g + 36 >> 2] = i, i = E[_$B + 28 >> 2], E[g + 24 >> 2] = E[_$B + 24 >> 2], E[g + 28 >> 2] = i, i = E[_$B + 20 >> 2], E[g + 16 >> 2] = E[_$B + 16 >> 2], E[g + 20 >> 2] = i, i = E[_$B + 12 >> 2], E[g + 8 >> 2] = E[_$B + 8 >> 2], E[g + 12 >> 2] = i, C) for(i = C << 1, a = C << 4, C = 0; _$B = (Q = C << 6) + A | 0, E[g >> 2] = E[g >> 2] ^ E[_$B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[_$B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[_$B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[_$B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[_$B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[_$B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[_$B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[_$B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[_$B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[_$B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[_$B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[_$B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[_$B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[_$B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[_$B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[_$B + 60 >> 2], OA(g), o = E[g + 60 >> 2], E[56 + (_$B = (C << 5) + I | 0) >> 2] = E[g + 56 >> 2], E[_$B + 60 >> 2] = o, o = E[g + 52 >> 2], E[_$B + 48 >> 2] = E[g + 48 >> 2], E[_$B + 52 >> 2] = o, o = E[g + 44 >> 2], E[_$B + 40 >> 2] = E[g + 40 >> 2], E[_$B + 44 >> 2] = o, o = E[g + 36 >> 2], E[_$B + 32 >> 2] = E[g + 32 >> 2], E[_$B + 36 >> 2] = o, o = E[g + 28 >> 2], E[_$B + 24 >> 2] = E[g + 24 >> 2], E[_$B + 28 >> 2] = o, o = E[g + 20 >> 2], E[_$B + 16 >> 2] = E[g + 16 >> 2], E[_$B + 20 >> 2] = o, o = E[g + 12 >> 2], E[_$B + 8 >> 2] = E[g + 8 >> 2], E[_$B + 12 >> 2] = o, o = E[g + 4 >> 2], E[_$B >> 2] = E[g >> 2], E[_$B + 4 >> 2] = o, _$B = (64 | Q) + A | 0, E[g >> 2] = E[g >> 2] ^ E[_$B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[_$B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[_$B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[_$B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[_$B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[_$B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[_$B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[_$B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[_$B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[_$B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[_$B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[_$B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[_$B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[_$B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[_$B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[_$B + 60 >> 2], OA(g), Q = E[g + 60 >> 2], E[56 + (_$B = ((C << 3) + a << 2) + I | 0) >> 2] = E[g + 56 >> 2], E[_$B + 60 >> 2] = Q, Q = E[g + 52 >> 2], E[_$B + 48 >> 2] = E[g + 48 >> 2], E[_$B + 52 >> 2] = Q, Q = E[g + 44 >> 2], E[_$B + 40 >> 2] = E[g + 40 >> 2], E[_$B + 44 >> 2] = Q, Q = E[g + 36 >> 2], E[_$B + 32 >> 2] = E[g + 32 >> 2], E[_$B + 36 >> 2] = Q, Q = E[g + 28 >> 2], E[_$B + 24 >> 2] = E[g + 24 >> 2], E[_$B + 28 >> 2] = Q, Q = E[g + 20 >> 2], E[_$B + 16 >> 2] = E[g + 16 >> 2], E[_$B + 20 >> 2] = Q, Q = E[g + 12 >> 2], E[_$B + 8 >> 2] = E[g + 8 >> 2], E[_$B + 12 >> 2] = Q, Q = E[g + 4 >> 2], E[_$B >> 2] = E[g >> 2], E[_$B + 4 >> 2] = Q, i >>> 0 > (C = C + 2 | 0) >>> 0;);
                                    }
                                    function rA(A, I, g, C) {
                                        var _$B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0;
                                        if (h = E[A + 36 >> 2], y = E[A + 32 >> 2], s = E[A + 28 >> 2], r = E[A + 24 >> 2], e = E[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(M = !a[A + 80 | 0] << 24, p = E[A + 4 >> 2], b = c(p, 5), n = E[A + 8 >> 2], S = c(n, 5), F = E[A + 12 >> 2], _$N = c(F, 5), G = E[A + 16 >> 2], k = c(G, 5), f = E[A >> 2]; _$B = Ig(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, F, 0), _ = w, e = (o = Ig(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + e | 0, 0, G, 0)) + _$B | 0, _$B = w + _ | 0, _$B = o >>> 0 > e >>> 0 ? _$B + 1 | 0 : _$B, _ = Ig(s = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + s | 0, 0, n, 0), _$B = w + _$B | 0, _$B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? _$B + 1 | 0 : _$B, _ = Ig(y = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + y | 0, 0, p, 0), _$B = w + _$B | 0, _$B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? _$B + 1 | 0 : _$B, _ = Ig(h = h + M + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, f, 0), _$B = w + _$B | 0, _$K = e = _ + e | 0, e = _ >>> 0 > e >>> 0 ? _$B + 1 | 0 : _$B, _$B = Ig(i, 0, n, 0), _ = w, o = Ig(r, 0, F, 0), Q = w + _ | 0, Q = (_$B = o + _$B | 0) >>> 0 < o >>> 0 ? Q + 1 | 0 : Q, _ = (o = Ig(s, 0, p, 0)) + _$B | 0, _$B = w + Q | 0, _$B = o >>> 0 > _ >>> 0 ? _$B + 1 | 0 : _$B, o = Ig(y, 0, f, 0), _$B = w + _$B | 0, _$B = o >>> 0 > (_ = o + _ | 0) >>> 0 ? _$B + 1 | 0 : _$B, o = Ig(h, 0, k, 0), _$B = w + _$B | 0, _$H = _ = o + _ | 0, _ = o >>> 0 > _ >>> 0 ? _$B + 1 | 0 : _$B, _$B = Ig(i, 0, p, 0), t = w, o = (Q = Ig(r, 0, n, 0)) + _$B | 0, _$B = w + t | 0, _$B = Q >>> 0 > o >>> 0 ? _$B + 1 | 0 : _$B, t = Ig(s, 0, f, 0), Q = w + _$B | 0, Q = (o = t + o | 0) >>> 0 < t >>> 0 ? Q + 1 | 0 : Q, t = Ig(y, 0, k, 0), _$B = w + Q | 0, _$B = (o = t + o | 0) >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B, t = Ig(h, 0, _$N, 0), _$B = w + _$B | 0, Y = o = t + o | 0, o = o >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B, _$B = Ig(i, 0, f, 0), Q = w, t = (D = Ig(r, 0, p, 0)) + _$B | 0, _$B = w + Q | 0, _$B = t >>> 0 < D >>> 0 ? _$B + 1 | 0 : _$B, Q = Ig(s, 0, k, 0), _$B = w + _$B | 0, _$B = Q >>> 0 > (t = Q + t | 0) >>> 0 ? _$B + 1 | 0 : _$B, D = Ig(y, 0, _$N, 0), Q = w + _$B | 0, Q = (t = D + t | 0) >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, D = Ig(h, 0, S, 0), _$B = w + Q | 0, _$B = (t = D + t | 0) >>> 0 < D >>> 0 ? _$B + 1 | 0 : _$B, D = t, t = _$B, _$B = Ig(i, 0, k, 0), Q = w, i = (r = Ig(r, 0, f, 0)) + _$B | 0, _$B = w + Q | 0, _$B = i >>> 0 < r >>> 0 ? _$B + 1 | 0 : _$B, r = Ig(s, 0, _$N, 0), _$B = w + _$B | 0, _$B = (i = r + i | 0) >>> 0 < r >>> 0 ? _$B + 1 | 0 : _$B, r = Ig(y, 0, S, 0), _$B = w + _$B | 0, _$B = (i = r + i | 0) >>> 0 < r >>> 0 ? _$B + 1 | 0 : _$B, r = Ig(h, 0, b, 0), Q = w + _$B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, _$B = t, _$B = (i = (s = (67108863 & Q) << 6 | i >>> 26) + D | 0) >>> 0 < s >>> 0 ? _$B + 1 | 0 : _$B, s = i, y = (67108863 & _$B) << 6 | i >>> 26, _$B = o, _$B = (i = y + Y | 0) >>> 0 < y >>> 0 ? _$B + 1 | 0 : _$B, y = i, Q = _, h = _$B = (i = (67108863 & _$B) << 6 | i >>> 26) + _$H | 0, _ = (67108863 & (Q = _$B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | _$B >>> 26, _$B = e, r = (67108863 & s) + ((_$B = c((67108863 & ((i = _ + _$K | 0) >>> 0 < _ >>> 0 ? _$B + 1 | 0 : _$B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, s = 67108863 & y, y = 67108863 & h, h = 67108863 & i, e = 67108863 & _$B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        E[A + 20 >> 2] = e, E[A + 36 >> 2] = h, E[A + 32 >> 2] = y, E[A + 28 >> 2] = s, E[A + 24 >> 2] = r;
                                    }
                                    function eA(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var _$B = 0;
                                        return _$B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (h = _$B = h - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, Hg(g + _$B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = Sg(_$B, I, g), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (yC(), Q()), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I ^= -222443256, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106), _$B = 0), 0 | _$B;
                                    }
                                    function yA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var _$B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (Q = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, i = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, _$B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, t = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24) : (Q = 2036477234, i = 857760878, _$B = 1634760805, t = 1797285236), E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, e = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, _ = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, y = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, f = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, s = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, C = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, h = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, D = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; r = g, g = Lg((p = I) ^ (I = g + _$B | 0), 16), r = s = Lg(r ^ (_$B = g + s | 0), 12), w = Lg((p = I + s | 0) ^ g, 8), I = Lg(r ^ (s = w + _$B | 0), 7), E = Lg((g = C + t | 0) ^ E, 16), C = Lg((y = E + y | 0) ^ C, 12), r = h, Q = Lg((t = Q + h | 0) ^ e, 16), _$B = Lg(r ^ (h = Q + c | 0), 12), c = Lg((c = Q) ^ (Q = _$B + t | 0), 8), g = Lg(c ^ (t = (n = g + C | 0) + I | 0), 16), e = Lg((i = i + D | 0) ^ _, 16), D = Lg((_ = e + f | 0) ^ D, 12), r = I, I = Lg((i = D + i | 0) ^ e, 8), r = Lg(r ^ (_ = (k = I + _ | 0) + g | 0), 12), e = Lg(g ^ (t = r + t | 0), 8), g = Lg((f = e + _ | 0) ^ r, 7), E = Lg(E ^ n, 8), C = Lg((y = E + y | 0) ^ C, 7), _ = Lg((Q = C + Q | 0) ^ I, 16), C = Lg((I = _ + s | 0) ^ C, 12), _ = Lg(_ ^ (Q = C + Q | 0), 8), C = Lg((s = I + _ | 0) ^ C, 7), I = Lg((c = c + h | 0) ^ _$B, 7), h = Lg((i = I + i | 0) ^ w, 16), w = Lg(I ^ (_$B = h + y | 0), 12), I = Lg(h ^ (i = w + i | 0), 8), h = Lg((y = _$B + I | 0) ^ w, 7), r = c, c = E, _$B = Lg(D ^ k, 7), c = Lg(c ^ (E = _$B + p | 0), 16), p = Lg(_$B ^ (D = r + c | 0), 12), E = Lg(c ^ (_$B = p + E | 0), 8), D = Lg((c = D + E | 0) ^ p, 7), 10 != (0 | (F = F + 1 | 0)););
                                        return o[0 | A] = _$B, o[A + 1 | 0] = _$B >>> 8, o[A + 2 | 0] = _$B >>> 16, o[A + 3 | 0] = _$B >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 24 | 0] = e, o[A + 25 | 0] = e >>> 8, o[A + 26 | 0] = e >>> 16, o[A + 27 | 0] = e >>> 24, o[A + 20 | 0] = _, o[A + 21 | 0] = _ >>> 8, o[A + 22 | 0] = _ >>> 16, o[A + 23 | 0] = _ >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = t, o[A + 13 | 0] = t >>> 8, o[A + 14 | 0] = t >>> 16, o[A + 15 | 0] = t >>> 24, o[A + 8 | 0] = Q, o[A + 9 | 0] = Q >>> 8, o[A + 10 | 0] = Q >>> 16, o[A + 11 | 0] = Q >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, 0;
                                    }
                                    function sA(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], _$N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], _$K = E[I + 68 >> 2], _$H = E[I + 32 >> 2], _$d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = _$H + _$d, E[A + 28 >> 2] = b + _$K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = _$N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], _$N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], _$K = E[I + 32 >> 2], _$H = E[I + 72 >> 2], _$d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = _$H - _$K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = _$N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - _$d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], _$N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], _$K = E[A + 108 >> 2], _$H = E[A + 72 >> 2], _$d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], _$B = E[A + 116 >> 2], E[A + 76 >> 2] = C + _$B, E[A + 72 >> 2] = _$H + _$d, E[A + 68 >> 2] = b + _$K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + _$N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = _$B - C, E[A + 32 >> 2] = _$d - _$H, E[A + 28 >> 2] = _$K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = _$N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = r << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = t << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = c << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = _ << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = a << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = o << 1, _$N = E[A + 136 >> 2], E[A + 136 >> 2] = F - _$N, S = i << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = Q << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = J << 1, _$K = E[A + 124 >> 2], E[A + 124 >> 2] = b - _$K, _$H = e << 1, _$d = E[A + 120 >> 2], E[A + 120 >> 2] = _$H - _$d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + _$N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + _$K, E[A + 80 >> 2] = _$H + _$d, E[A + 116 >> 2] = I + g;
                                    }
                                    function hA(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], _$N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], _$K = E[I + 68 >> 2], _$H = E[I + 32 >> 2], _$d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = _$H + _$d, E[A + 28 >> 2] = b + _$K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = _$N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], _$N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], _$K = E[I + 32 >> 2], _$H = E[I + 72 >> 2], _$d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = _$H - _$K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = _$N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - _$d, Y(A + 80 | 0, A, g + 40 | 0), Y(y, y, g), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], _$N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], _$K = E[A + 108 >> 2], _$H = E[A + 72 >> 2], _$d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], _$B = E[A + 116 >> 2], E[A + 76 >> 2] = C + _$B, E[A + 72 >> 2] = _$H + _$d, E[A + 68 >> 2] = b + _$K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + _$N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = _$B - C, E[A + 32 >> 2] = _$d - _$H, E[A + 28 >> 2] = _$K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = _$N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = E[A + 156 >> 2], g = r << 1, E[A + 156 >> 2] = I + g, y = E[A + 152 >> 2], s = t << 1, E[A + 152 >> 2] = y + s, D = E[A + 148 >> 2], p = c << 1, E[A + 148 >> 2] = D + p, w = E[A + 144 >> 2], f = _ << 1, E[A + 144 >> 2] = w + f, n = E[A + 140 >> 2], k = a << 1, E[A + 140 >> 2] = n + k, F = E[A + 136 >> 2], _$N = o << 1, E[A + 136 >> 2] = F + _$N, S = E[A + 132 >> 2], G = i << 1, E[A + 132 >> 2] = S + G, h = E[A + 128 >> 2], M = Q << 1, E[A + 128 >> 2] = h + M, b = E[A + 124 >> 2], _$K = J << 1, E[A + 124 >> 2] = b + _$K, _$H = E[A + 120 >> 2], _$d = e << 1, E[A + 120 >> 2] = _$H + _$d, E[A + 112 >> 2] = s - y, E[A + 108 >> 2] = p - D, E[A + 104 >> 2] = f - w, E[A + 100 >> 2] = k - n, E[A + 96 >> 2] = _$N - F, E[A + 92 >> 2] = G - S, E[A + 88 >> 2] = M - h, E[A + 84 >> 2] = _$K - b, E[A + 80 >> 2] = _$d - _$H, E[A + 116 >> 2] = g - I;
                                    }
                                    function DA(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], _$N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], _$K = E[I + 68 >> 2], _$H = E[I + 32 >> 2], _$d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = _$H + _$d, E[A + 28 >> 2] = b + _$K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = _$N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], _$N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], _$K = E[I + 32 >> 2], _$H = E[I + 72 >> 2], _$d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = _$H - _$K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = _$N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - _$d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 80 | 0, I + 120 | 0), J = E[I + 80 >> 2], Q = E[I + 84 >> 2], i = E[I + 88 >> 2], o = E[I + 92 >> 2], a = E[I + 96 >> 2], _ = E[I + 100 >> 2], c = E[I + 104 >> 2], t = E[I + 108 >> 2], r = E[I + 112 >> 2], e = E[I + 116 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], _$N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], _$K = E[A + 108 >> 2], _$H = E[A + 72 >> 2], _$d = E[A + 112 >> 2], C = E[A + 76 >> 2], _$B = E[A + 116 >> 2], E[A + 76 >> 2] = C + _$B, E[A + 72 >> 2] = _$H + _$d, E[A + 68 >> 2] = b + _$K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + _$N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = _$B - C, E[A + 32 >> 2] = _$d - _$H, E[A + 28 >> 2] = _$K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = _$N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = e << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = r << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = t << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = c << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = _ << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = a << 1, _$N = E[A + 136 >> 2], E[A + 136 >> 2] = F - _$N, S = o << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = i << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = Q << 1, _$K = E[A + 124 >> 2], E[A + 124 >> 2] = b - _$K, _$H = J << 1, _$d = E[A + 120 >> 2], E[A + 120 >> 2] = _$H - _$d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + _$N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + _$K, E[A + 80 >> 2] = _$H + _$d, E[A + 116 >> 2] = I + g;
                                    }
                                    function pA(A, I) {
                                        var g, C, _$B, Q, i, o, _, c, t, r, e, y, s, h, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0;
                                        s = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], _$B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], o = a[I + 9 | 0], _ = a[I + 8 | 0], c = a[I + 7 | 0], t = a[I + 12 | 0], b = a[I + 11 | 0], _$K = a[I + 10 | 0], r = a[I + 15 | 0], _$H = a[I + 14 | 0], e = a[I + 13 | 0], _$N = a[I + 28 | 0], M = a[I + 27 | 0], S = a[I + 26 | 0], F = a[I + 25 | 0], n = a[I + 24 | 0], f = a[I + 23 | 0], h = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, k = (p = a[I + 21 | 0]) << 15, p = D = p >>> 17 | 0, G = k, G |= (k = a[I + 20 | 0]) << 7, k = (D = k >>> 25 | 0) | p, p = (D = a[I + 22 | 0]) >>> 9 | 0, D = D << 23 | G, p |= k, y = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, k = D, D = (33554431 & (I = (G = y + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | G >>> 25, I = (I >>> 25 | 0) + p | 0, D = (p = k = k + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, I = (k = p + 33554432 | 0) >>> 0 < 33554432 ? D + 1 | 0 : D, E[A + 24 >> 2] = p - (-67108864 & k), D = (p = f >>> 27 | 0) | n >>> 19 | F >>> 11, p = f = (n = F << 21 | (f = n << 13 | f << 5)) + (p = (67108863 & (p = I)) << 6 | k >>> 26) | 0, I = D, D = (f = n + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = p - (1040187392 & f), p = (D = (I = D) >>> 25 | 0) + (p = M >>> 20 | S >>> 28 | _$N >>> 12) | 0, I = p = (D = f = (I = (33554431 & I) << 7 | f >>> 25) + (M << 12 | S << 4 | _$N << 20) | 0) >>> 0 < I >>> 0 ? p + 1 | 0 : p, f = (_$N = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 32 >> 2] = D - (-67108864 & _$N), p = t >>> 13 | (D = b >>> 21 | _$K >>> 29), I = (p = (M = 16777216 + (b = b << 11 | _$K << 3 | t << 19) | 0) >>> 0 < 16777216 ? p + 1 | 0 : p) >>> 25 | 0, p = (D = n = _$H << 10 | e << 2 | r << 18) + (n = (33554431 & p) << 7 | M >>> 25) | 0, D = I + (F = _$H >>> 22 | e >>> 30 | r >>> 14) | 0, I = D = p >>> 0 < n >>> 0 ? D + 1 | 0 : D, n = ((67108863 & (I = (n = p + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (D = n) >>> 26) + (S = y - (-33554432 & G) | 0) | 0, E[A + 20 >> 2] = n, E[A + 16 >> 2] = p - (-67108864 & D), D = Q >>> 18 | i >>> 26 | _$B >>> 10, p = (D = (S = 16777216 + (_$K = Q << 14 | i << 6 | _$B << 22) | 0) >>> 0 < 16777216 ? D + 1 | 0 : D) >>> 25 | 0, D = (I = n = _ << 13 | c << 5 | o << 21) + (n = (33554431 & D) << 7 | S >>> 25) | 0, I = p + (F = _ >>> 19 | c >>> 27 | o >>> 11) | 0, I = D >>> 0 < n >>> 0 ? I + 1 | 0 : I, p = (F = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 8 >> 2] = D - (-67108864 & F), _$N = (f = (67108863 & f) << 6 | _$N >>> 26) + (_$H = s << 18 & 33292288 | g << 10 | C << 2) | 0, I = D = g >>> 22 | C >>> 30, D = (f = _$H + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = _$N - (33554432 & f), p = b + ((67108863 & p) << 6 | F >>> 26) | 0, E[A + 12 >> 2] = p - (234881024 & M), n = _$K - (2113929216 & S) | 0, p = Ig((33554431 & (I = D)) << 7 | f >>> 25, D = I >>> 25 | 0, 19, 0), I = w, p = (D = p + h | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, f = ((67108863 & (p = (I = D + 33554432 | 0) >>> 0 < 33554432 ? p + 1 | 0 : p)) << 6 | I >>> 26) + n | 0, E[A + 4 >> 2] = f, E[A >> 2] = D - (-67108864 & I);
                                    }
                                    function wA(A, I, g, C, B, i, _, c) {
                                        A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, _ |= 0;
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    if (1 == (-7 & (c |= 0))) {
                                                                                        if (e = 0, !C) break o;
                                                                                        if (4 & c) break _;
                                                                                        for(;;){
                                                                                            e = r;
                                                                                            c: {
                                                                                                t: {
                                                                                                    r: {
                                                                                                        e: {
                                                                                                            for(;;){
                                                                                                                if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16336 ^ y) ^ -1) >>> 8 & 63 | (1 + (16340 ^ y) ^ -1) >>> 8 & 62, 255 != (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) break e;
                                                                                                                if (t = 0, !B) break E;
                                                                                                                if (!FI(B, y)) break;
                                                                                                                if ((e = e + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                            }
                                                                                                            r = e;
                                                                                                            break E;
                                                                                                        }
                                                                                                        if (D = t + (D << 6) | 0, s >>> 0 > 1) break t;
                                                                                                        s = s + 6 | 0;
                                                                                                        break c;
                                                                                                    }
                                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                    break E;
                                                                                                }
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, !((r = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break E;
                                                                                    }
                                                                                    yC(), Q();
                                                                                }
                                                                                _: for(;;){
                                                                                    for(e = r;;){
                                                                                        c: {
                                                                                            if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16288 ^ y) ^ -1) >>> 8 & 63 | (1 + (16338 ^ y) ^ -1) >>> 8 & 62, 255 == (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) {
                                                                                                if (t = 0, !B) break E;
                                                                                                if (FI(B, y)) break c;
                                                                                                r = e;
                                                                                                break E;
                                                                                            }
                                                                                            if (D = t + (D << 6) | 0, s >>> 0 < 2) s = s + 6 | 0;
                                                                                            else {
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, (r = e + 1 | 0) >>> 0 < C >>> 0) continue _;
                                                                                            break E;
                                                                                        }
                                                                                        if (!((e = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                break E;
                                                                            }
                                                                            r = e, E[9392] = 68, t = 1;
                                                                        }
                                                                        if (s >>> 0 > 4) break i;
                                                                        e = r;
                                                                    }
                                                                    if (A = e, I = -1, t) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if ((-1 << s ^ -1) & D) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if (2 & c) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (s >>> 0 < 2) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (r = A >>> 0 > C >>> 0 ? A : C, e = s >>> 1 | 0, !B) break Q;
                                                                    for(c = A;;){
                                                                        if ((0 | c) == (0 | r)) {
                                                                            t = 68;
                                                                            break C;
                                                                        }
                                                                        if (61 != (0 | (A = o[g + c | 0]))) {
                                                                            if (!FI(B, A)) {
                                                                                t = 28, r = c;
                                                                                break C;
                                                                            }
                                                                        } else e = e - 1 | 0;
                                                                        if (c = c + 1 | 0, !e) break;
                                                                    }
                                                                    break B;
                                                                }
                                                                I = -1;
                                                                break A;
                                                            }
                                                            if (t = 68, A >>> 0 >= C >>> 0) break C;
                                                            if (61 != a[A + g | 0]) {
                                                                r = A, t = 28;
                                                                break C;
                                                            }
                                                            if (c = A + e | 0, 1 != (0 | e)) {
                                                                if ((0 | (s = A + 1 | 0)) == (0 | r)) break C;
                                                                if (61 != a[g + s | 0]) {
                                                                    r = s, t = 28;
                                                                    break C;
                                                                }
                                                                if (2 != (0 | e)) {
                                                                    if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                    if (t = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                }
                                                            }
                                                        }
                                                        if (I = 0, B) break g;
                                                        break I;
                                                    }
                                                    E[9392] = t;
                                                    break A;
                                                }
                                                if (!(C >>> 0 <= c >>> 0)) {
                                                    for(;;){
                                                        if (!FI(B, o[g + c | 0])) break I;
                                                        if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                    }
                                                    c = C;
                                                }
                                            }
                                            r = c, p = h;
                                        }
                                        return _ ? E[_ >> 2] = g + r : (0 | C) != (0 | r) && (E[9392] = 28, I = -1), i && (E[i >> 2] = p), 0 | I;
                                    }
                                    function fA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var _$B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (_$B = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, _ = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, c = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, C = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24) : (_$B = 1797285236, _ = 2036477234, c = 857760878, C = 1634760805), Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, p = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, w = 20, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, h = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, e = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, y = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; t = Lg(g + c | 0, 7) ^ Q, f = Lg(t + c | 0, 9) ^ D, r = Lg(C + s | 0, 7) ^ r, n = Lg(r + C | 0, 9) ^ E, k = Lg(n + r | 0, 13) ^ s, e = Lg(_$B + h | 0, 7) ^ e, i = Lg(e + _$B | 0, 9) ^ i, E = Lg(i + e | 0, 13) ^ h, _$B = Lg(i + E | 0, 18) ^ _$B, Q = Lg(I + _ | 0, 7) ^ p, s = k ^ Lg(_$B + Q | 0, 7), D = f ^ Lg(s + _$B | 0, 9), p = Lg(s + D | 0, 13) ^ Q, _$B = Lg(D + p | 0, 18) ^ _$B, y = Lg(Q + _ | 0, 9) ^ y, F = Lg(y + Q | 0, 13) ^ I, I = Lg(F + y | 0, 18) ^ _, h = Lg(I + t | 0, 7) ^ E, E = Lg(h + I | 0, 9) ^ n, Q = Lg(E + h | 0, 13) ^ t, _ = Lg(Q + E | 0, 18) ^ I, t = Lg(t + f | 0, 13) ^ g, g = Lg(t + f | 0, 18) ^ c, I = Lg(g + r | 0, 7) ^ F, i = Lg(I + g | 0, 9) ^ i, r = Lg(I + i | 0, 13) ^ r, c = Lg(i + r | 0, 18) ^ g, C = Lg(n + k | 0, 18) ^ C, g = Lg(C + e | 0, 7) ^ t, y = Lg(g + C | 0, 9) ^ y, e = Lg(g + y | 0, 13) ^ e, C = Lg(y + e | 0, 18) ^ C, t = w >>> 0 > 2, w = w - 2 | 0, t;);
                                        return o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 28 | 0] = Q, o[A + 29 | 0] = Q >>> 8, o[A + 30 | 0] = Q >>> 16, o[A + 31 | 0] = Q >>> 24, o[A + 24 | 0] = E, o[A + 25 | 0] = E >>> 8, o[A + 26 | 0] = E >>> 16, o[A + 27 | 0] = E >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = _$B, o[A + 13 | 0] = _$B >>> 8, o[A + 14 | 0] = _$B >>> 16, o[A + 15 | 0] = _$B >>> 24, o[A + 8 | 0] = _, o[A + 9 | 0] = _ >>> 8, o[A + 10 | 0] = _ >>> 16, o[A + 11 | 0] = _ >>> 24, o[A + 4 | 0] = c, o[A + 5 | 0] = c >>> 8, o[A + 6 | 0] = c >>> 16, o[A + 7 | 0] = c >>> 24, 0;
                                    }
                                    function nA(A, I, g, C) {
                                        var _$B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = _$B = h - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = _ = E[A + 76 >> 2]) | 0, t = (r = E[A + 72 >> 2]) + (c = g << 3) | 0, E[A + 72 >> 2] = t, Q = c >>> 0 > t >>> 0 ? Q + 1 | 0 : Q, E[A + 76 >> 2] = Q, _ = E[4 + (c = A - -64 | 0) >> 2], _ = (e = Q = (0 | Q) == (0 | i) & t >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + E[c >> 2] | 0) >>> 0 ? _ + 1 | 0 : _, t = (e = C >>> 29 | 0) + Q | 0, Q = _, E[c >> 2] = t, E[c + 4 >> 2] = t >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (_ = e = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (t = 128 - c | 0) >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(w = 252 & t, r = A + 80 | 0; o[(Q = i + c | 0) + r | 0] = a[I + i | 0], o[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | D) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (s = 3 & t)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | s) != (0 | y) | (0 | r) != (0 | Q););
                                                if (F(A, A + 80 | 0, _$B, i = _$B + 640 | 0), I = I + t | 0, !(C = C - ((g >>> 0 < t >>> 0) + e | 0) | 0) & (g = g - t | 0) >>> 0 > 127 | C) for(; F(A, I, _$B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (D = 3 & g, t = 0, y = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, s = A + 80 | 0, g = 0, C = 0; o[i + s | 0] = a[I + i | 0], o[(Q = 1 | i) + s | 0] = a[I + Q | 0], o[(Q = 2 | i) + s | 0] = a[I + Q | 0], o[(Q = 3 | i) + s | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (t | D) for(; o[80 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | D) | (0 | t) != (0 | Q););
                                                }
                                                XC(_$B, 704);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, C = A + 80 | 0; o[C + (Q = i + c | 0) | 0] = a[I + i | 0], o[C + (e = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | t) != (0 | D) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | y) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = _$B + 704 | 0, 0;
                                    }
                                    function kA(A, I) {
                                        var g, C, _$B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        for(h = g = h - 480 | 0; c = (_ = g + 288 | 0) + (i << 1) | 0, t = a[I + i | 0], o[c + 1 | 0] = t >>> 4, o[0 | c] = 15 & t, _ = _ + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (_ = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, o[0 | I] = _ - (240 & i), i = 8 + (_ = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & i), i = 8 + (_ = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(o[g + 351 | 0] = a[g + 351 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(I = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), _$B = A + 120 | 0, r = A + 80 | 0, _ = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(_$B, t, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        for(i = E[A + 36 >> 2], E[g + 392 >> 2] = E[A + 32 >> 2], E[g + 396 >> 2] = i, i = E[A + 28 >> 2], E[g + 384 >> 2] = E[A + 24 >> 2], E[g + 388 >> 2] = i, i = E[A + 20 >> 2], E[g + 376 >> 2] = E[A + 16 >> 2], E[g + 380 >> 2] = i, i = E[A + 12 >> 2], E[g + 368 >> 2] = E[A + 8 >> 2], E[g + 372 >> 2] = i, i = E[A + 4 >> 2], E[g + 360 >> 2] = E[A >> 2], E[g + 364 >> 2] = i, i = E[I + 12 >> 2], E[g + 408 >> 2] = E[I + 8 >> 2], E[g + 412 >> 2] = i, i = E[I + 20 >> 2], E[g + 416 >> 2] = E[I + 16 >> 2], E[g + 420 >> 2] = i, i = E[I + 28 >> 2], E[g + 424 >> 2] = E[I + 24 >> 2], E[g + 428 >> 2] = i, i = E[I + 36 >> 2], E[g + 432 >> 2] = E[I + 32 >> 2], E[g + 436 >> 2] = i, i = E[I + 4 >> 2], E[g + 400 >> 2] = E[I >> 2], E[g + 404 >> 2] = i, i = E[r + 12 >> 2], E[g + 448 >> 2] = E[r + 8 >> 2], E[g + 452 >> 2] = i, i = E[r + 20 >> 2], E[g + 456 >> 2] = E[r + 16 >> 2], E[g + 460 >> 2] = i, i = E[r + 28 >> 2], E[g + 464 >> 2] = E[r + 24 >> 2], E[g + 468 >> 2] = i, i = E[r + 36 >> 2], E[g + 472 >> 2] = E[r + 32 >> 2], E[g + 476 >> 2] = i, i = E[r + 4 >> 2], E[g + 440 >> 2] = E[r >> 2], E[g + 444 >> 2] = i, KA(t, i = g + 360 | 0), Y(i, t, c), Y(e = g + 400 | 0, C, _), Y(Q = g + 440 | 0, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(_$B, t, C), i = 0; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(_$B, t, C), t = i >>> 0 < 62, i = i + 2 | 0, t;);
                                        h = g + 480 | 0;
                                    }
                                    function FA(A, I) {
                                        A |= 0;
                                        var g, C, _$B, Q, i, o = 0, E = 0, a = 0, _ = 0, c = 0, t = 0;
                                        for(h = g = h - 736 | 0, k(c = g + 704 | 0, I |= 0, I), k(E = g + 224 | 0, I, c), k(_ = g + 672 | 0, I, E), k(a = g + 640 | 0, _, _), k(C = g + 416 | 0, c, a), k(c = g + 320 | 0, I, C), k(o = g + 608 | 0, a, a), k(a = g + 288 | 0, c, c), k(t = g + 576 | 0, C, a), k(i = g + 448 | 0, o, a), k(_$B = g + 544 | 0, t, t), k(t = g + 384 | 0, o, _$B), k(Q = g + 352 | 0, E, t), k(E = g + 192 | 0, o, Q), k(o = g + 160 | 0, _, E), k(g + 96 | 0, _, o), k(E = g + 512 | 0, _$B, Q), k(o = g + 480 | 0, _, E), k(E = g + 256 | 0, i, o), k(g + 128 | 0, a, E), k(a = g - -64 | 0, t, o), k(o = g + 32 | 0, _, a), k(g, C, o), k(A, c, g), _ = 0; k(A, A, A), 126 != (0 | (_ = _ + 1 | 0)););
                                        return k(A, A, g + 352 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 704 | 0), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 160 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 256 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g - -64 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 96 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 320 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 512 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 192 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 480 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 128 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 32 | 0), h = g + 736 | 0, 0 - NI(I, 32) | 0;
                                    }
                                    function NA(A, I, g) {
                                        A |= 0;
                                        var C, _$B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0;
                                        return h = Q = h - 160 | 0, kI(I |= 0, g |= 0, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(Q, I), tg(A, Q), _ = a[(_$B = g) + 8 | 0] | a[_$B + 9 | 0] << 8 | a[_$B + 10 | 0] << 16 | a[_$B + 11 | 0] << 24, E = a[_$B + 12 | 0] | a[_$B + 13 | 0] << 8 | a[_$B + 14 | 0] << 16 | a[_$B + 15 | 0] << 24, c = a[_$B + 16 | 0] | a[_$B + 17 | 0] << 8 | a[_$B + 18 | 0] << 16 | a[_$B + 19 | 0] << 24, t = a[_$B + 20 | 0] | a[_$B + 21 | 0] << 8 | a[_$B + 22 | 0] << 16 | a[_$B + 23 | 0] << 24, r = a[0 | _$B] | a[_$B + 1 | 0] << 8 | a[_$B + 2 | 0] << 16 | a[_$B + 3 | 0] << 24, g = a[_$B + 4 | 0] | a[_$B + 5 | 0] << 8 | a[_$B + 6 | 0] << 16 | a[_$B + 7 | 0] << 24, i = a[_$B + 28 | 0] | a[_$B + 29 | 0] << 8 | a[_$B + 30 | 0] << 16 | a[_$B + 31 | 0] << 24, C = I, I = a[_$B + 24 | 0] | a[_$B + 25 | 0] << 8 | a[_$B + 26 | 0] << 16 | a[_$B + 27 | 0] << 24, o[C + 24 | 0] = I, o[C + 25 | 0] = I >>> 8, o[C + 26 | 0] = I >>> 16, o[C + 27 | 0] = I >>> 24, o[C + 28 | 0] = i, o[C + 29 | 0] = i >>> 8, o[C + 30 | 0] = i >>> 16, o[C + 31 | 0] = i >>> 24, o[C + 16 | 0] = c, o[C + 17 | 0] = c >>> 8, o[C + 18 | 0] = c >>> 16, o[C + 19 | 0] = c >>> 24, o[C + 20 | 0] = t, o[C + 21 | 0] = t >>> 8, o[C + 22 | 0] = t >>> 16, o[C + 23 | 0] = t >>> 24, o[C + 8 | 0] = _, o[C + 9 | 0] = _ >>> 8, o[C + 10 | 0] = _ >>> 16, o[C + 11 | 0] = _ >>> 24, o[C + 12 | 0] = E, o[C + 13 | 0] = E >>> 8, o[C + 14 | 0] = E >>> 16, o[C + 15 | 0] = E >>> 24, o[0 | C] = r, o[C + 1 | 0] = r >>> 8, o[C + 2 | 0] = r >>> 16, o[C + 3 | 0] = r >>> 24, o[C + 4 | 0] = g, o[C + 5 | 0] = g >>> 8, o[C + 6 | 0] = g >>> 16, o[C + 7 | 0] = g >>> 24, c = a[(E = A) + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, t = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, r = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, g = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, I = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, A = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, _ = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, E = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[C + 56 | 0] = E, o[C + 57 | 0] = E >>> 8, o[C + 58 | 0] = E >>> 16, o[C + 59 | 0] = E >>> 24, o[C + 60 | 0] = _, o[C + 61 | 0] = _ >>> 8, o[C + 62 | 0] = _ >>> 16, o[C + 63 | 0] = _ >>> 24, o[C + 48 | 0] = r, o[C + 49 | 0] = r >>> 8, o[C + 50 | 0] = r >>> 16, o[C + 51 | 0] = r >>> 24, o[C + 52 | 0] = g, o[C + 53 | 0] = g >>> 8, o[C + 54 | 0] = g >>> 16, o[C + 55 | 0] = g >>> 24, o[C + 40 | 0] = c, o[C + 41 | 0] = c >>> 8, o[C + 42 | 0] = c >>> 16, o[C + 43 | 0] = c >>> 24, o[C + 44 | 0] = t, o[C + 45 | 0] = t >>> 8, o[C + 46 | 0] = t >>> 16, o[C + 47 | 0] = t >>> 24, o[C + 32 | 0] = I, o[C + 33 | 0] = I >>> 8, o[C + 34 | 0] = I >>> 16, o[C + 35 | 0] = I >>> 24, o[C + 36 | 0] = A, o[C + 37 | 0] = A >>> 8, o[C + 38 | 0] = A >>> 16, o[C + 39 | 0] = A >>> 24, h = Q + 160 | 0, 0;
                                    }
                                    function SA(A, I, g) {
                                        var C, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], _$B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], y = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, e = E[A >> 2], E[A >> 2] = g & (e ^ E[I >> 2]) ^ e, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ y), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = _$B ^ g & (_$B ^ s), _$B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(y = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], e = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ e), E[A + 68 >> 2] = t ^ g & (t ^ k), E[y >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = _$B ^ g & (_$B ^ s), _$B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], y = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], e = E[A + 116 >> 2], E[A + 116 >> 2] = g & (e ^ E[I + 116 >> 2]) ^ e, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ y), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = _$B ^ g & (_$B ^ s), _$B = E[A + 120 >> 2], s = E[I + 120 >> 2], Q = E[A + 124 >> 2], h = E[I + 124 >> 2], i = E[A + 128 >> 2], D = E[I + 128 >> 2], o = E[A + 132 >> 2], p = E[I + 132 >> 2], a = E[A + 136 >> 2], w = E[I + 136 >> 2], _ = E[A + 140 >> 2], f = E[I + 140 >> 2], c = E[A + 144 >> 2], y = E[I + 144 >> 2], t = E[A + 148 >> 2], n = E[I + 148 >> 2], r = E[A + 152 >> 2], k = E[I + 152 >> 2], e = E[I + 156 >> 2], I = E[A + 156 >> 2], E[A + 156 >> 2] = g & (e ^ I) ^ I, E[A + 152 >> 2] = r ^ g & (r ^ k), E[A + 148 >> 2] = t ^ g & (t ^ n), E[A + 144 >> 2] = c ^ g & (c ^ y), E[A + 140 >> 2] = _ ^ g & (_ ^ f), E[A + 136 >> 2] = a ^ g & (a ^ w), E[A + 132 >> 2] = o ^ g & (o ^ p), E[A + 128 >> 2] = i ^ g & (i ^ D), E[A + 124 >> 2] = Q ^ g & (Q ^ h), E[A + 120 >> 2] = _$B ^ g & (_$B ^ s);
                                    }
                                    function GA(A, I, g) {
                                        var C, _$B, Q = 0, i = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0;
                                        return h = C = h - 320 | 0, v(Q = C + 240 | 0, g), Y(Q, Q, g), v(A, Q), Y(A, A, g), Y(A, A, I), PA(A, A), Y(A, A, Q), Y(A, A, I), v(Q = C + 192 | 0, A), Y(Q, Q, g), i = E[I + 4 >> 2], s = E[I + 8 >> 2], p = E[I + 12 >> 2], w = E[I + 16 >> 2], f = E[I + 20 >> 2], n = E[I + 24 >> 2], k = E[I + 28 >> 2], F = E[I + 32 >> 2], _$N = E[I >> 2], g = E[C + 192 >> 2], Q = E[C + 196 >> 2], a = E[C + 200 >> 2], _ = E[C + 204 >> 2], c = E[C + 208 >> 2], t = E[C + 212 >> 2], r = E[C + 216 >> 2], e = E[C + 220 >> 2], y = E[C + 224 >> 2], D = E[C + 228 >> 2], S = E[I + 36 >> 2], E[C + 180 >> 2] = D - S, E[C + 176 >> 2] = y - F, E[C + 172 >> 2] = e - k, E[C + 168 >> 2] = r - n, E[C + 164 >> 2] = t - f, E[C + 160 >> 2] = c - w, E[C + 156 >> 2] = _ - p, E[C + 152 >> 2] = a - s, E[C + 148 >> 2] = Q - i, E[C + 144 >> 2] = g - _$N, E[C + 132 >> 2] = D + S, E[C + 128 >> 2] = y + F, E[C + 124 >> 2] = e + k, E[C + 120 >> 2] = r + n, E[C + 116 >> 2] = t + f, E[C + 112 >> 2] = c + w, E[C + 108 >> 2] = _ + p, E[C + 104 >> 2] = a + s, E[C + 100 >> 2] = Q + i, E[C + 96 >> 2] = g + _$N, Y(i = C + 48 | 0, I, 1648), E[C + 84 >> 2] = D + E[C + 84 >> 2], E[C + 80 >> 2] = y + E[C + 80 >> 2], E[C + 76 >> 2] = e + E[C + 76 >> 2], E[C + 72 >> 2] = r + E[C + 72 >> 2], E[C + 68 >> 2] = t + E[C + 68 >> 2], E[C + 64 >> 2] = c + E[C + 64 >> 2], E[C + 60 >> 2] = _ + E[C + 60 >> 2], E[C + 56 >> 2] = a + E[C + 56 >> 2], E[C + 52 >> 2] = Q + E[C + 52 >> 2], E[C + 48 >> 2] = g + E[C + 48 >> 2], BI(C, C + 144 | 0), p = NI(C, 32), BI(C, C + 96 | 0), s = NI(C, 32), BI(C, i), I = NI(C, 32), Y(C, A, 1648), y = E[A + 4 >> 2], e = E[A + 8 >> 2], r = E[A + 12 >> 2], t = E[A + 16 >> 2], c = E[A + 20 >> 2], _ = E[A + 24 >> 2], a = E[A + 28 >> 2], Q = E[A + 32 >> 2], i = E[A >> 2], w = E[C >> 2], f = E[C + 4 >> 2], n = E[C + 8 >> 2], k = E[C + 12 >> 2], F = E[C + 16 >> 2], _$N = E[C + 20 >> 2], D = E[C + 24 >> 2], S = E[C + 28 >> 2], _$B = E[C + 32 >> 2], g = (I = 0 - (I | s) | 0) & ((g = E[A + 36 >> 2]) ^ E[C + 36 >> 2]) ^ g, E[A + 36 >> 2] = g, Q ^= I & (Q ^ _$B), E[A + 32 >> 2] = Q, a ^= I & (a ^ S), E[A + 28 >> 2] = a, _ ^= I & (_ ^ D), E[A + 24 >> 2] = _, c ^= I & (c ^ _$N), E[A + 20 >> 2] = c, t ^= I & (t ^ F), E[A + 16 >> 2] = t, r ^= I & (r ^ k), E[A + 12 >> 2] = r, e ^= I & (e ^ n), E[A + 8 >> 2] = e, y ^= I & (y ^ f), E[A + 4 >> 2] = y, i ^= I & (i ^ w), E[A >> 2] = i, BI(C + 288 | 0, A), I = 0 - (1 & o[C + 288 | 0]) | 0, E[A + 36 >> 2] = g ^ I & (g ^ 0 - g), E[A + 32 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 28 >> 2] = a ^ I & (a ^ 0 - a), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = i ^ I & (i ^ 0 - i), h = C + 320 | 0, s | p;
                                    }
                                    function MA(A, I, g, C) {
                                        var _$B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = _$B = h - 288 | 0, g | C) {
                                            if (Q = (i = E[A + 36 >> 2]) + (C << 3 | g >>> 29) | 0, _ = (r = E[A + 32 >> 2]) + (c = g << 3) | 0, E[A + 32 >> 2] = _, E[A + 36 >> 2] = _ >>> 0 < c >>> 0 ? Q + 1 | 0 : Q, c = 64 - (_ = t = 63 & ((7 & i) << 29 | r >>> 3)) | 0, (0 | C) == (0 | (_ = D = 0 - ((Q = 0) + (_ >>> 0 > 64) | 0) | 0)) & g >>> 0 >= c >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (63 ^ t) >>> 0 >= 3 | Q) for(w = 124 & c, r = A + 40 | 0; o[(Q = i + t | 0) + r | 0] = a[I + i | 0], o[r + (t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | s) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & c)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | e) | (0 | r) != (0 | Q););
                                                if (J(A, A + 40 | 0, _$B, i = _$B + 256 | 0), I = I + c | 0, !(C = C - ((g >>> 0 < c >>> 0) + D | 0) | 0) & (g = g - c | 0) >>> 0 > 63 | C) for(; J(A, I, _$B, i), I = I - -64 | 0, Q = C - 1 | 0, !(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | C;);
                                                if (g | C) {
                                                    if (s = 3 & g, c = 0, e = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, y = A + 40 | 0, g = 0, C = 0; o[i + y | 0] = a[I + i | 0], o[(Q = 1 | i) + y | 0] = a[I + Q | 0], o[(Q = 2 | i) + y | 0] = a[I + Q | 0], o[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | t) | (0 | r) != (0 | Q););
                                                    if (c | s) for(; o[40 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | e) != (0 | s) | (0 | c) != (0 | Q););
                                                }
                                                XC(_$B, 288);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, C = A + 40 | 0; o[C + (Q = i + t | 0) | 0] = a[I + i | 0], o[C + (D = t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | c) != (0 | s) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | e) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = _$B + 288 | 0, 0;
                                    }
                                    function bA(A, I) {
                                        var g, C, _$B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0;
                                        return h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(i = g + 240 | 0, C), Y(_ = g + 192 | 0, i, 1600), E[g + 192 >> 2] = E[g + 192 >> 2] + 1, c = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = c, t = E[g + 244 >> 2], r = E[g + 248 >> 2], e = E[g + 252 >> 2], y = E[g + 256 >> 2], s = E[g + 260 >> 2], D = E[g + 264 >> 2], p = E[g + 268 >> 2], w = E[g + 272 >> 2], f = E[g + 276 >> 2], Y(A, i, _), PA(A, A), Y(A, i, A), v(i = g + 144 | 0, A), Y(i, i, _), i = E[g + 180 >> 2], E[g + 132 >> 2] = i - f, _ = E[g + 176 >> 2], E[g + 128 >> 2] = _ - w, n = E[g + 172 >> 2], E[g + 124 >> 2] = n - p, k = E[g + 168 >> 2], E[g + 120 >> 2] = k - D, F = E[g + 164 >> 2], E[g + 116 >> 2] = F - s, _$N = E[g + 160 >> 2], E[g + 112 >> 2] = _$N - y, S = E[g + 156 >> 2], E[g + 108 >> 2] = S - e, G = E[g + 152 >> 2], E[g + 104 >> 2] = G - r, M = E[g + 148 >> 2], E[g + 100 >> 2] = M - t, b = E[g + 144 >> 2], E[g + 96 >> 2] = b - c, E[g + 84 >> 2] = i + f, E[g + 80 >> 2] = _ + w, E[g + 76 >> 2] = p + n, E[g + 72 >> 2] = D + k, E[g + 68 >> 2] = s + F, E[g + 64 >> 2] = y + _$N, E[g + 60 >> 2] = e + S, E[g + 56 >> 2] = r + G, E[g + 52 >> 2] = t + M, E[g + 48 >> 2] = c + b, BI(g, g + 96 | 0), w = NI(g, 32), BI(g, g + 48 | 0), n = NI(g, 32), Y(g, A, 1648), p = E[A + 4 >> 2], D = E[A + 8 >> 2], s = E[A + 12 >> 2], y = E[A + 16 >> 2], e = E[A + 20 >> 2], r = E[A + 24 >> 2], t = E[A + 28 >> 2], c = E[A + 32 >> 2], f = E[A >> 2], k = E[g >> 2], F = E[g + 4 >> 2], _$N = E[g + 8 >> 2], S = E[g + 12 >> 2], G = E[g + 16 >> 2], M = E[g + 20 >> 2], b = E[g + 24 >> 2], _$B = E[g + 28 >> 2], Q = E[g + 32 >> 2], _ = (i = w - 1 | 0) & ((_ = E[A + 36 >> 2]) ^ E[g + 36 >> 2]) ^ _, E[A + 36 >> 2] = _, c ^= i & (c ^ Q), E[A + 32 >> 2] = c, t ^= i & (t ^ _$B), E[A + 28 >> 2] = t, r ^= i & (r ^ b), E[A + 24 >> 2] = r, e ^= i & (e ^ M), E[A + 20 >> 2] = e, y ^= i & (y ^ G), E[A + 16 >> 2] = y, s ^= i & (s ^ S), E[A + 12 >> 2] = s, D ^= i & (D ^ _$N), E[A + 8 >> 2] = D, p ^= i & (p ^ F), E[A + 4 >> 2] = p, i = f ^ i & (f ^ k), E[A >> 2] = i, BI(g + 288 | 0, A), I = 0 - (1 & o[g + 288 | 0] ^ a[I + 31 | 0] >>> 7) | 0, E[A + 36 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 32 >> 2] = c ^ I & (c ^ 0 - c), E[A + 28 >> 2] = t ^ I & (t ^ 0 - t), E[A + 24 >> 2] = r ^ I & (r ^ 0 - r), E[A + 20 >> 2] = e ^ I & (e ^ 0 - e), E[A + 16 >> 2] = y ^ I & (y ^ 0 - y), E[A + 12 >> 2] = s ^ I & (s ^ 0 - s), E[A + 8 >> 2] = D ^ I & (D ^ 0 - D), E[A + 4 >> 2] = p ^ I & (p ^ 0 - p), E[A >> 2] = i ^ I & (i ^ 0 - i), Y(A + 120 | 0, A, C), h = g + 320 | 0, (w | n) - 1 | 0;
                                    }
                                    function KA(A, I) {
                                        var g, C, _$B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0;
                                        h = g = h - 48 | 0, v(A, I), v(A + 80 | 0, I + 40 | 0), R(A + 120 | 0, I + 80 | 0), n = E[I + 40 >> 2], D = E[I + 44 >> 2], s = E[I + 4 >> 2], p = E[I + 48 >> 2], k = E[I + 8 >> 2], w = E[I + 52 >> 2], F = E[I + 12 >> 2], f = E[I + 56 >> 2], b = E[I + 16 >> 2], _$N = E[I + 60 >> 2], _$K = E[I + 20 >> 2], S = E[I - -64 >> 2], _$H = E[I + 24 >> 2], G = E[I + 68 >> 2], Y = E[I + 28 >> 2], M = E[I + 72 >> 2], _$d = E[I + 32 >> 2], _$U = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] + E[I + 36 >> 2], E[A + 72 >> 2] = M + _$d, E[A + 68 >> 2] = G + Y, E[(C = A - -64 | 0) >> 2] = S + _$H, E[A + 60 >> 2] = _$N + _$K, E[A + 56 >> 2] = f + b, E[A + 52 >> 2] = w + F, E[A + 48 >> 2] = p + k, E[A + 44 >> 2] = D + s, E[(I = A + 40 | 0) >> 2] = n + _$U, v(g, I), n = E[A + 80 >> 2], D = E[A + 4 >> 2], s = E[A + 84 >> 2], p = E[A + 8 >> 2], k = E[A + 88 >> 2], w = E[A + 12 >> 2], F = E[A + 92 >> 2], f = E[A + 16 >> 2], b = E[A + 96 >> 2], _$N = E[A + 20 >> 2], _$K = E[A + 100 >> 2], S = E[A + 24 >> 2], _$H = E[A + 104 >> 2], G = E[A + 28 >> 2], Y = E[A + 108 >> 2], M = E[A + 32 >> 2], _$d = E[A + 112 >> 2], _$U = E[A >> 2], Q = (J = E[A + 116 >> 2]) - (_$B = E[A + 36 >> 2]) | 0, E[A + 116 >> 2] = Q, i = _$d - M | 0, E[A + 112 >> 2] = i, o = Y - G | 0, E[A + 108 >> 2] = o, a = _$H - S | 0, E[A + 104 >> 2] = a, _ = _$K - _$N | 0, E[A + 100 >> 2] = _, c = b - f | 0, E[A + 96 >> 2] = c, t = F - w | 0, E[A + 92 >> 2] = t, r = k - p | 0, E[A + 88 >> 2] = r, e = s - D | 0, E[A + 84 >> 2] = e, y = n - _$U | 0, E[A + 80 >> 2] = y, J = J + _$B | 0, E[A + 76 >> 2] = J, M = M + _$d | 0, E[A + 72 >> 2] = M, G = G + Y | 0, E[A + 68 >> 2] = G, S = S + _$H | 0, E[C >> 2] = S, _$N = _$N + _$K | 0, E[A + 60 >> 2] = _$N, f = f + b | 0, E[A + 56 >> 2] = f, w = w + F | 0, E[A + 52 >> 2] = w, p = p + k | 0, E[A + 48 >> 2] = p, D = D + s | 0, E[A + 44 >> 2] = D, s = I, I = n + _$U | 0, E[s >> 2] = I, n = E[g >> 2], s = E[g + 4 >> 2], k = E[g + 8 >> 2], F = E[g + 12 >> 2], b = E[g + 16 >> 2], _$K = E[g + 20 >> 2], _$H = E[g + 24 >> 2], Y = E[g + 28 >> 2], _$d = E[g + 32 >> 2], E[A + 36 >> 2] = E[g + 36 >> 2] - J, E[A + 32 >> 2] = _$d - M, E[A + 28 >> 2] = Y - G, E[A + 24 >> 2] = _$H - S, E[A + 20 >> 2] = _$K - _$N, E[A + 16 >> 2] = b - f, E[A + 12 >> 2] = F - w, E[A + 8 >> 2] = k - p, E[A + 4 >> 2] = s - D, E[A >> 2] = n - I, I = E[A + 120 >> 2], n = E[A + 124 >> 2], D = E[A + 128 >> 2], s = E[A + 132 >> 2], p = E[A + 136 >> 2], k = E[A + 140 >> 2], w = E[A + 144 >> 2], F = E[A + 148 >> 2], f = E[A + 152 >> 2], E[A + 156 >> 2] = E[A + 156 >> 2] - Q, E[A + 152 >> 2] = f - i, E[A + 148 >> 2] = F - o, E[A + 144 >> 2] = w - a, E[A + 140 >> 2] = k - _, E[A + 136 >> 2] = p - c, E[A + 132 >> 2] = s - t, E[A + 128 >> 2] = D - r, E[A + 124 >> 2] = n - e, E[A + 120 >> 2] = I - y, h = g + 48 | 0;
                                    }
                                    function HA(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, c, t = 0;
                                        h = C = h - 160 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), SA(A, I, (255 & (1 ^ (t = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), SA(A, I + 160 | 0, (255 & (2 ^ t)) - 1 >>> 31 | 0), SA(A, I + 320 | 0, (255 & (3 ^ t)) - 1 >>> 31 | 0), SA(A, I + 480 | 0, (255 & (4 ^ t)) - 1 >>> 31 | 0), SA(A, I + 640 | 0, (255 & (5 ^ t)) - 1 >>> 31 | 0), SA(A, I + 800 | 0, (255 & (6 ^ t)) - 1 >>> 31 | 0), SA(A, I + 960 | 0, (255 & (7 ^ t)) - 1 >>> 31 | 0), SA(A, I + 1120 | 0, (255 & (8 ^ t)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 32 >> 2] = E[A + 72 >> 2], E[C + 36 >> 2] = I, t = E[4 + (I = A - -64 | 0) >> 2], E[C + 24 >> 2] = E[I >> 2], E[C + 28 >> 2] = t, I = E[A + 60 >> 2], E[C + 16 >> 2] = E[A + 56 >> 2], E[C + 20 >> 2] = I, I = E[A + 52 >> 2], E[C + 8 >> 2] = E[A + 48 >> 2], E[C + 12 >> 2] = I, I = E[A + 44 >> 2], E[C >> 2] = E[A + 40 >> 2], E[C + 4 >> 2] = I, I = E[A + 36 >> 2], E[C + 72 >> 2] = E[A + 32 >> 2], E[C + 76 >> 2] = I, t = E[A + 28 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 24 >> 2], E[I + 4 >> 2] = t, I = E[A + 20 >> 2], E[C + 56 >> 2] = E[A + 16 >> 2], E[C + 60 >> 2] = I, I = E[A + 12 >> 2], E[C + 48 >> 2] = E[A + 8 >> 2], E[C + 52 >> 2] = I, I = E[A + 4 >> 2], E[C + 40 >> 2] = E[A >> 2], E[C + 44 >> 2] = I, I = E[A + 92 >> 2], E[C + 88 >> 2] = E[A + 88 >> 2], E[C + 92 >> 2] = I, I = E[A + 100 >> 2], E[C + 96 >> 2] = E[A + 96 >> 2], E[C + 100 >> 2] = I, I = E[A + 108 >> 2], E[C + 104 >> 2] = E[A + 104 >> 2], E[C + 108 >> 2] = I, I = E[A + 116 >> 2], E[C + 112 >> 2] = E[A + 112 >> 2], E[C + 116 >> 2] = I, I = E[A + 84 >> 2], E[C + 80 >> 2] = E[A + 80 >> 2], E[C + 84 >> 2] = I, I = E[A + 120 >> 2], t = E[A + 124 >> 2], _$B = E[A + 128 >> 2], Q = E[A + 132 >> 2], i = E[A + 136 >> 2], o = E[A + 140 >> 2], a = E[A + 144 >> 2], _ = E[A + 148 >> 2], c = E[A + 152 >> 2], E[C + 156 >> 2] = 0 - E[A + 156 >> 2], E[C + 152 >> 2] = 0 - c, E[C + 148 >> 2] = 0 - _, E[C + 144 >> 2] = 0 - a, E[C + 140 >> 2] = 0 - o, E[C + 136 >> 2] = 0 - i, E[C + 132 >> 2] = 0 - Q, E[C + 128 >> 2] = 0 - _$B, E[C + 124 >> 2] = 0 - t, E[C + 120 >> 2] = 0 - I, SA(A, C, (128 & g) >>> 7 | 0), h = C + 160 | 0;
                                    }
                                    function YA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C, _$B, Q, i, _ = 0, c = 0, t = 0;
                                        return h = c = h - 192 | 0, ag(c, 32), kI(I, c, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(t = c + 32 | 0, I), tg(A, t), g = c, t = E[c + 28 >> 2], c = E[c + 24 >> 2], o[I + 24 | 0] = c, o[I + 25 | 0] = c >>> 8, o[I + 26 | 0] = c >>> 16, o[I + 27 | 0] = c >>> 24, o[I + 28 | 0] = t, o[I + 29 | 0] = t >>> 8, o[I + 30 | 0] = t >>> 16, o[I + 31 | 0] = t >>> 24, t = E[g + 20 >> 2], c = E[g + 16 >> 2], o[I + 16 | 0] = c, o[I + 17 | 0] = c >>> 8, o[I + 18 | 0] = c >>> 16, o[I + 19 | 0] = c >>> 24, o[I + 20 | 0] = t, o[I + 21 | 0] = t >>> 8, o[I + 22 | 0] = t >>> 16, o[I + 23 | 0] = t >>> 24, t = E[g + 12 >> 2], c = E[g + 8 >> 2], o[I + 8 | 0] = c, o[I + 9 | 0] = c >>> 8, o[I + 10 | 0] = c >>> 16, o[I + 11 | 0] = c >>> 24, o[I + 12 | 0] = t, o[I + 13 | 0] = t >>> 8, o[I + 14 | 0] = t >>> 16, o[I + 15 | 0] = t >>> 24, t = E[g + 4 >> 2], c = E[g >> 2], o[0 | I] = c, o[I + 1 | 0] = c >>> 8, o[I + 2 | 0] = c >>> 16, o[I + 3 | 0] = c >>> 24, o[I + 4 | 0] = t, o[I + 5 | 0] = t >>> 8, o[I + 6 | 0] = t >>> 16, o[I + 7 | 0] = t >>> 24, C = a[(_ = A) + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, _$B = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, Q = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, c = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, A = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, i = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[I + 56 | 0] = _, o[I + 57 | 0] = _ >>> 8, o[I + 58 | 0] = _ >>> 16, o[I + 59 | 0] = _ >>> 24, o[I + 60 | 0] = i, o[I + 61 | 0] = i >>> 8, o[I + 62 | 0] = i >>> 16, o[I + 63 | 0] = i >>> 24, o[I + 48 | 0] = Q, o[I + 49 | 0] = Q >>> 8, o[I + 50 | 0] = Q >>> 16, o[I + 51 | 0] = Q >>> 24, o[I + 52 | 0] = t, o[I + 53 | 0] = t >>> 8, o[I + 54 | 0] = t >>> 16, o[I + 55 | 0] = t >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, o[I + 44 | 0] = _$B, o[I + 45 | 0] = _$B >>> 8, o[I + 46 | 0] = _$B >>> 16, o[I + 47 | 0] = _$B >>> 24, o[I + 32 | 0] = c, o[I + 33 | 0] = c >>> 8, o[I + 34 | 0] = c >>> 16, o[I + 35 | 0] = c >>> 24, o[I + 36 | 0] = A, o[I + 37 | 0] = A >>> 8, o[I + 38 | 0] = A >>> 16, o[I + 39 | 0] = A >>> 24, XC(g, 32), h = g + 192 | 0, 0;
                                    }
                                    function dA(A, I) {
                                        I |= 0;
                                        var g, C, _$B = 0, Q = 0, i = 0, a = 0;
                                        return h = g = h - 288 | 0, Q = 40 + ((_$B = E[32 + (A |= 0) >> 2] >>> 3 & 63) + A | 0) | 0, _$B >>> 0 >= 56 ? (Sg(Q, 34688, 64 - _$B | 0), J(A, A + 40 | 0, g, g + 256 | 0), E[A + 88 >> 2] = 0, E[A + 92 >> 2] = 0, E[A + 80 >> 2] = 0, E[A + 84 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[(_$B = A - -64 | 0) >> 2] = 0, E[_$B + 4 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 52 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 44 >> 2] = 0) : Sg(Q, 34688, 56 - _$B | 0), i = (_$B = 16711680 & (Q = E[A + 32 >> 2])) >>> 8 | 0, a = _$B << 24, C = (_$B = -16777216 & Q) >>> 24 | 0, _$B = (a |= _$B << 8) | -16777216 & ((255 & (_$B = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & _$B) << 8 | Q >>> 24) | _$B >>> 8 & 65280 | _$B >>> 24, o[A + 96 | 0] = _$B, o[A + 97 | 0] = _$B >>> 8, o[A + 98 | 0] = _$B >>> 16, o[A + 99 | 0] = _$B >>> 24, _$B = (_$B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, o[A + 100 | 0] = _$B, o[A + 101 | 0] = _$B >>> 8, o[A + 102 | 0] = _$B >>> 16, o[A + 103 | 0] = _$B >>> 24, J(A, A + 40 | 0, g, g + 256 | 0), _$B = (_$B = E[A >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[0 | I] = _$B, o[I + 1 | 0] = _$B >>> 8, o[I + 2 | 0] = _$B >>> 16, o[I + 3 | 0] = _$B >>> 24, _$B = (_$B = E[A + 4 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 4 | 0] = _$B, o[I + 5 | 0] = _$B >>> 8, o[I + 6 | 0] = _$B >>> 16, o[I + 7 | 0] = _$B >>> 24, _$B = (_$B = E[A + 8 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 8 | 0] = _$B, o[I + 9 | 0] = _$B >>> 8, o[I + 10 | 0] = _$B >>> 16, o[I + 11 | 0] = _$B >>> 24, _$B = (_$B = E[A + 12 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 12 | 0] = _$B, o[I + 13 | 0] = _$B >>> 8, o[I + 14 | 0] = _$B >>> 16, o[I + 15 | 0] = _$B >>> 24, _$B = (_$B = E[A + 16 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 16 | 0] = _$B, o[I + 17 | 0] = _$B >>> 8, o[I + 18 | 0] = _$B >>> 16, o[I + 19 | 0] = _$B >>> 24, _$B = (_$B = E[A + 20 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 20 | 0] = _$B, o[I + 21 | 0] = _$B >>> 8, o[I + 22 | 0] = _$B >>> 16, o[I + 23 | 0] = _$B >>> 24, _$B = (_$B = E[A + 24 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 24 | 0] = _$B, o[I + 25 | 0] = _$B >>> 8, o[I + 26 | 0] = _$B >>> 16, o[I + 27 | 0] = _$B >>> 24, _$B = (_$B = E[A + 28 >> 2]) << 24 | (65280 & _$B) << 8 | _$B >>> 8 & 65280 | _$B >>> 24, o[I + 28 | 0] = _$B, o[I + 29 | 0] = _$B >>> 8, o[I + 30 | 0] = _$B >>> 16, o[I + 31 | 0] = _$B >>> 24, XC(g, 288), XC(A, 104), h = g + 288 | 0, 0;
                                    }
                                    function JA(A, I) {
                                        A |= 0;
                                        var g, C = 0;
                                        h = g = h + -64 | 0, C = a[60 + (I |= 0) | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 56 >> 2] = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 60 >> 2] = C, C = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 48 >> 2] = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 52 >> 2] = C, C = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 40 >> 2] = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 44 >> 2] = C, C = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 32 >> 2] = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 36 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, N(g), I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0;
                                    }
                                    function UA(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, _$B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        if (h = C = h - 96 | 0, (g |= 0) >>> 0 >= 65 && ($I(A), MA(A, I, g, 0), dA(A, C), g = 32, I = C), $I(A), E[C + 88 >> 2] = 909522486, E[C + 92 >> 2] = 909522486, E[C + 80 >> 2] = 909522486, E[C + 84 >> 2] = 909522486, E[C + 72 >> 2] = 909522486, E[C + 76 >> 2] = 909522486, E[(i = r = C - -64 | 0) >> 2] = 909522486, E[i + 4 >> 2] = 909522486, E[C + 56 >> 2] = 909522486, E[C + 60 >> 2] = 909522486, E[C + 48 >> 2] = 909522486, E[C + 52 >> 2] = 909522486, E[C + 40 >> 2] = 909522486, E[C + 44 >> 2] = 909522486, E[C + 32 >> 2] = 909522486, E[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(_ = 124 & g; o[0 | (Q = (i = C + 32 | 0) + _$B | 0)] = a[0 | Q] ^ a[I + _$B | 0], o[0 | (e = (Q = 1 | _$B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (e = (Q = 2 | _$B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (Q = (Q = i) + (i = 3 | _$B) | 0)] = a[0 | Q] ^ a[I + i | 0], _$B = _$B + 4 | 0, (0 | _) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; o[0 | (i = (C + 32 | 0) + _$B | 0)] = a[0 | i] ^ a[I + _$B | 0], _$B = _$B + 1 | 0, (0 | c) != (0 | (t = t + 1 | 0)););
                                        }
                                        if (MA(A, C + 32 | 0, 64, 0), $I(i = A + 104 | 0), E[C + 88 >> 2] = 1549556828, E[C + 92 >> 2] = 1549556828, E[C + 80 >> 2] = 1549556828, E[C + 84 >> 2] = 1549556828, E[C + 72 >> 2] = 1549556828, E[C + 76 >> 2] = 1549556828, E[r >> 2] = 1549556828, E[r + 4 >> 2] = 1549556828, E[C + 56 >> 2] = 1549556828, E[C + 60 >> 2] = 1549556828, E[C + 48 >> 2] = 1549556828, E[C + 52 >> 2] = 1549556828, E[C + 40 >> 2] = 1549556828, E[C + 44 >> 2] = 1549556828, E[C + 32 >> 2] = 1549556828, E[C + 36 >> 2] = 1549556828, g) {
                                            if (t = 0, _$B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; o[0 | (_ = (A = C + 32 | 0) + _$B | 0)] = a[0 | _] ^ a[I + _$B | 0], o[0 | (Q = (_ = 1 | _$B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (Q = (_ = 2 | _$B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (_ = (Q = A) + (A = 3 | _$B) | 0)] = a[0 | _] ^ a[A + I | 0], _$B = _$B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C + 32 | 0) + _$B | 0)] = a[0 | g] ^ a[I + _$B | 0], _$B = _$B + 1 | 0, (0 | A) != (0 | (t = t + 1 | 0)););
                                        }
                                        return MA(i, A = C + 32 | 0, 64, 0), XC(A, 64), XC(C, 32), h = C + 96 | 0, 0;
                                    }
                                    function lA(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            e = a = h, h = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((_ = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ (I << 8 | _), E[a + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = a + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(a + 96 | 0, o, 128), E[a + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ _, E[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(y = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (o = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[a + 352 >> 2] = C + E[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[a + 352 >> 2] = i + E[a + 352 >> 2], t = I = E[a + 68 >> 2], I = (r = (o = E[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[a + 64 >> 2] = r, E[a + 68 >> 2] = I, I = E[a + 76 >> 2], I = (t = o = -1 == (0 | t) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[a + 72 >> 2] = o, E[a + 76 >> 2] = I, f(a, c), Sg(c, y, 128), I = E[a + 352 >> 2] - 128 | 0, E[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(a, A, _), h = e;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function mA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, o[g + 64 | 0] = 1, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function uA(A, I, g, C) {
                                        var _$B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0;
                                        A: {
                                            if ((i = E[A + 56 >> 2]) | (_$B = E[A + 60 >> 2])) {
                                                if (y = Q = 16 - i | 0, c = (Q = (0 | (_ = 0 - ((i >>> 0 > 16) + _$B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > _ >>> 0) ? y : g, y = Q = Q ? _ : C, Q | c) {
                                                    if (Q = 0, i = 0, !y & c >>> 0 >= 4 | y) for(t = -4 & c, _ = A - -64 | 0; _$B = Q + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + Q | 0], _$B = (s = 1 | Q) + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + s | 0], _$B = (s = 2 | Q) + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + s | 0], _$B = (s = 3 | Q) + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + s | 0], _$B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? _$B + 1 | 0 : _$B, _$B = r, r = _$B = (e = e + 4 | 0) >>> 0 < 4 ? _$B + 1 | 0 : _$B, (0 | e) != (0 | t) | (0 | y) != (0 | _$B););
                                                    if (_ = _$B = 0, _$B | (r = 3 & c)) for(; e = Q + E[A + 56 >> 2] | 0, o[(A + e | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, _$B = D, D = _$B = (h = h + 1 | 0) ? _$B : _$B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | _$B););
                                                    i = E[A + 56 >> 2], _$B = E[A + 60 >> 2];
                                                }
                                                if (_$B = _$B + y | 0, _$B = (i = i + c | 0) >>> 0 < c >>> 0 ? _$B + 1 | 0 : _$B, E[A + 56 >> 2] = i, E[A + 60 >> 2] = _$B, !_$B & i >>> 0 < 16) break A;
                                                rA(A, A - -64 | 0, 16, 0), E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + y | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (rA(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (h = 0, D = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, y = 0, _ = A - -64 | 0, e = 0, r = 0; _$B = Q + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + Q | 0], _$B = (t = 1 | Q) + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + t | 0], _$B = (t = 2 | Q) + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + t | 0], _$B = (t = 3 | Q) + E[A + 56 >> 2] | 0, o[_$B + _ | 0] = a[I + t | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, _$B = r, r = _$B = (e = e + 4 | 0) >>> 0 < 4 ? _$B + 1 | 0 : _$B, (0 | c) != (0 | e) | (0 | y) != (0 | _$B););
                                                if (_ = _$B = 0, _$B | (r = 3 & g)) for(; _$B = Q + E[A + 56 >> 2] | 0, o[(A + _$B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, _$B = D, D = _$B = (h = h + 1 | 0) ? _$B : _$B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | _$B););
                                                i = C + E[A + 60 >> 2] | 0, i = (I = g + E[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, E[A + 56 >> 2] = I, E[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function xA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function RA(A, I, g) {
                                        var C, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], _$B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], e = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, y = E[A >> 2], E[A >> 2] = g & (y ^ E[I >> 2]) ^ y, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ e), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = _$B ^ g & (_$B ^ s), _$B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(e = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], y = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ y), E[A + 68 >> 2] = t ^ g & (t ^ k), E[e >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = _$B ^ g & (_$B ^ s), _$B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], e = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], y = E[I + 116 >> 2], I = E[A + 116 >> 2], E[A + 116 >> 2] = g & (y ^ I) ^ I, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ e), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = _$B ^ g & (_$B ^ s);
                                    }
                                    function vA(A, I) {
                                        var g, C, _$B = 0;
                                        for(h = g = h - 192 | 0, v(C = g + 144 | 0, I), v(_$B = g + 96 | 0, C), v(_$B, _$B), Y(_$B, I, _$B), Y(C, C, _$B), v(I = g + 48 | 0, C), Y(_$B, _$B, I), v(I, _$B), v(I, I), v(I, I), v(I, I), v(I, I), Y(_$B, I, _$B), v(I, _$B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, _$B), v(g, I), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(I, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(_$B, I, _$B), v(I, _$B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, _$B), v(g, I), I = 1; v(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        Y(I = g + 48 | 0, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(_$B = g + 96 | 0, I, _$B), v(_$B, _$B), v(_$B, _$B), v(_$B, _$B), v(_$B, _$B), v(_$B, _$B), Y(A, _$B, g + 144 | 0), h = g + 192 | 0;
                                    }
                                    function LA(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var i = 0, E = 0, _ = 0, t = 0, r = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    if (1 == (-7 & (B |= 0)) && (r = (E = (C >>> 0) / 3 | 0) << 2, (E = c(E, -3) + C | 0) && (r = 2 & B ? (2 | r) + (E >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                        if (!(4 & B)) {
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            B = 0;
                                                                            break i;
                                                                        }
                                                                        if (!C) {
                                                                            B = 0;
                                                                            break C;
                                                                        }
                                                                        for(B = 0;;){
                                                                            for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 45 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 32705 ^ -1) >>> 8 & 95 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                            if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                        }
                                                                        if (!t) break B;
                                                                        E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 32705 | 0, s = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                        break Q;
                                                                    }
                                                                    yC(), Q();
                                                                }
                                                                for(;;){
                                                                    for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 43 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 16321 ^ -1) >>> 8 & 47 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                    if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                }
                                                                if (!t) break B;
                                                                E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 16321 | 0, s = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                            }
                                                            o[A + B | 0] = g | (-1 ^ y) >>> 8 & s | E | t | C, B = B + 1 | 0;
                                                        }
                                                        if (B >>> 0 > r >>> 0) break g;
                                                    }
                                                    if (B >>> 0 < r >>> 0) break I;
                                                    r = B;
                                                    break A;
                                                }
                                                e(1104, 1201, 231, 1505), Q();
                                            }
                                            Hg(A + B | 0, 61, r - B | 0);
                                        }
                                        return Hg(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                    }
                                    function PA(A, I) {
                                        var g, C = 0, _$B = 0;
                                        for(h = g = h - 144 | 0, v(_$B = g + 96 | 0, I), v(C = g + 48 | 0, _$B), v(C, C), Y(C, I, C), Y(_$B, _$B, C), v(_$B, _$B), Y(_$B, C, _$B), v(C, _$B), v(C, C), v(C, C), v(C, C), v(C, C), Y(_$B, C, _$B), v(C, _$B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, _$B), v(g, C), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(C, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(_$B, C, _$B), v(C, _$B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, _$B), v(g, C), C = 1; v(g, g), 100 != (0 | (C = C + 1 | 0)););
                                        Y(C = g + 48 | 0, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(_$B = g + 96 | 0, C, _$B), v(_$B, _$B), v(_$B, _$B), Y(A, _$B, I), h = g + 144 | 0;
                                    }
                                    function qA(A, I) {
                                        var g, C, _$B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N = 0, S = 0, G = 0, M = 0;
                                        h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(G = g + 240 | 0, C), Y(S = g + 192 | 0, G, 1600), M = -1, _$B = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = _$B, E[g + 192 >> 2] = E[g + 192 >> 2] + 1, Q = E[g + 244 >> 2], i = E[g + 248 >> 2], _ = E[g + 252 >> 2], c = E[g + 256 >> 2], t = E[g + 260 >> 2], r = E[g + 264 >> 2], e = E[g + 268 >> 2], y = E[g + 272 >> 2], s = E[g + 276 >> 2], v(_$N = g + 144 | 0, S), Y(_$N, _$N, S), v(A, _$N), Y(A, A, S), Y(A, A, G), PA(A, A), Y(A, A, _$N), Y(A, A, G), v(_$N = g + 96 | 0, A), Y(_$N, _$N, S), S = E[g + 132 >> 2], E[g + 84 >> 2] = S - s, _$N = E[g + 128 >> 2], E[g + 80 >> 2] = _$N - y, G = E[g + 124 >> 2], E[g + 76 >> 2] = G - e, D = E[g + 120 >> 2], E[g + 72 >> 2] = D - r, p = E[g + 116 >> 2], E[g + 68 >> 2] = p - t, w = E[g + 112 >> 2], E[g + 64 >> 2] = w - c, f = E[g + 108 >> 2], E[g + 60 >> 2] = f - _, n = E[g + 104 >> 2], E[g + 56 >> 2] = n - i, k = E[g + 100 >> 2], E[g + 52 >> 2] = k - Q, F = E[g + 96 >> 2], E[g + 48 >> 2] = F - _$B, BI(g, g + 48 | 0);
                                        A: {
                                            if (!NI(g, 32)) {
                                                if (E[g + 36 >> 2] = S + s, E[g + 32 >> 2] = _$N + y, E[g + 28 >> 2] = G + e, E[g + 24 >> 2] = r + D, E[g + 20 >> 2] = t + p, E[g + 16 >> 2] = c + w, E[g + 12 >> 2] = _ + f, E[g + 8 >> 2] = i + n, E[g + 4 >> 2] = Q + k, E[g >> 2] = _$B + F, BI(S = g + 288 | 0, g), !NI(S, 32)) break A;
                                                Y(A, A, 1648);
                                            }
                                            BI(g + 288 | 0, A), (1 & o[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (E[A >> 2] = 0 - E[A >> 2], E[A + 36 >> 2] = 0 - E[A + 36 >> 2], E[A + 32 >> 2] = 0 - E[A + 32 >> 2], E[A + 28 >> 2] = 0 - E[A + 28 >> 2], E[A + 24 >> 2] = 0 - E[A + 24 >> 2], E[A + 20 >> 2] = 0 - E[A + 20 >> 2], E[A + 16 >> 2] = 0 - E[A + 16 >> 2], E[A + 12 >> 2] = 0 - E[A + 12 >> 2], E[A + 8 >> 2] = 0 - E[A + 8 >> 2], E[A + 4 >> 2] = 0 - E[A + 4 >> 2]), Y(A + 120 | 0, A, C), M = 0;
                                        }
                                        return h = g + 320 | 0, M;
                                    }
                                    function zA(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, t, r = 0;
                                        h = C = h - 128 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, Hg(A + 44 | 0, 0, 76), RA(A, I = c(I, 960) + 3008 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), RA(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), RA(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), RA(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), RA(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), RA(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), RA(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), RA(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 40 >> 2] = E[A + 72 >> 2], E[C + 44 >> 2] = I, r = E[4 + (I = A - -64 | 0) >> 2], E[C + 32 >> 2] = E[I >> 2], E[C + 36 >> 2] = r, I = E[A + 60 >> 2], E[C + 24 >> 2] = E[A + 56 >> 2], E[C + 28 >> 2] = I, I = E[A + 52 >> 2], E[C + 16 >> 2] = E[A + 48 >> 2], E[C + 20 >> 2] = I, I = E[A + 44 >> 2], E[C + 8 >> 2] = E[A + 40 >> 2], E[C + 12 >> 2] = I, I = E[A + 12 >> 2], E[C + 56 >> 2] = E[A + 8 >> 2], E[C + 60 >> 2] = I, r = E[A + 20 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 16 >> 2], E[I + 4 >> 2] = r, I = E[A + 28 >> 2], E[C + 72 >> 2] = E[A + 24 >> 2], E[C + 76 >> 2] = I, I = E[A + 36 >> 2], E[C + 80 >> 2] = E[A + 32 >> 2], E[C + 84 >> 2] = I, I = E[A + 4 >> 2], E[C + 48 >> 2] = E[A >> 2], E[C + 52 >> 2] = I, I = E[A + 80 >> 2], r = E[A + 84 >> 2], _$B = E[A + 88 >> 2], Q = E[A + 92 >> 2], i = E[A + 96 >> 2], o = E[A + 100 >> 2], a = E[A + 104 >> 2], _ = E[A + 108 >> 2], t = E[A + 112 >> 2], E[C + 124 >> 2] = 0 - E[A + 116 >> 2], E[C + 120 >> 2] = 0 - t, E[C + 116 >> 2] = 0 - _, E[C + 112 >> 2] = 0 - a, E[C + 108 >> 2] = 0 - o, E[C + 104 >> 2] = 0 - i, E[C + 100 >> 2] = 0 - Q, E[C + 96 >> 2] = 0 - _$B, E[C + 92 >> 2] = 0 - r, E[C + 88 >> 2] = 0 - I, RA(A, C + 8 | 0, (128 & g) >>> 7 | 0), h = C + 128 | 0;
                                    }
                                    function jA(A) {
                                        var _$I, g, C, _$B, Q, i, o, a, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0;
                                        return h = _$I = h - 320 | 0, v(c = _$I + 240 | 0, A), v(t = _$I + 192 | 0, A + 40 | 0), v(_ = _$I + 144 | 0, A + 80 | 0), A = E[_$I + 240 >> 2], r = E[_$I + 192 >> 2], e = E[_$I + 244 >> 2], y = E[_$I + 196 >> 2], s = E[_$I + 248 >> 2], D = E[_$I + 200 >> 2], p = E[_$I + 252 >> 2], w = E[_$I + 204 >> 2], f = E[_$I + 256 >> 2], n = E[_$I + 208 >> 2], k = E[_$I + 260 >> 2], F = E[_$I + 212 >> 2], _$N = E[_$I + 264 >> 2], S = E[_$I + 216 >> 2], G = E[_$I + 268 >> 2], M = E[_$I + 220 >> 2], b = E[_$I + 272 >> 2], _$K = E[_$I + 224 >> 2], E[_$I + 84 >> 2] = E[_$I + 228 >> 2] - E[_$I + 276 >> 2], E[_$I + 80 >> 2] = _$K - b, E[_$I + 76 >> 2] = M - G, E[_$I + 72 >> 2] = S - _$N, E[_$I + 68 >> 2] = F - k, E[_$I + 64 >> 2] = n - f, E[_$I + 60 >> 2] = w - p, E[_$I + 56 >> 2] = D - s, E[_$I + 52 >> 2] = y - e, E[_$I + 48 >> 2] = r - A, Y(A = _$I + 48 | 0, A, _), Y(_$I, c, t), Y(_$I, _$I, 1600), v(_$I + 96 | 0, _), _ = E[_$I + 48 >> 2], c = E[_$I + 96 >> 2], t = E[_$I >> 2], r = E[_$I + 52 >> 2], e = E[_$I + 100 >> 2], y = E[_$I + 4 >> 2], s = E[_$I + 56 >> 2], D = E[_$I + 104 >> 2], p = E[_$I + 8 >> 2], w = E[_$I + 60 >> 2], f = E[_$I + 108 >> 2], n = E[_$I + 12 >> 2], k = E[_$I + 64 >> 2], F = E[_$I + 112 >> 2], _$N = E[_$I + 16 >> 2], S = E[_$I + 68 >> 2], G = E[_$I + 116 >> 2], M = E[_$I + 20 >> 2], b = E[_$I + 72 >> 2], _$K = E[_$I + 120 >> 2], g = E[_$I + 24 >> 2], C = E[_$I + 76 >> 2], _$B = E[_$I + 124 >> 2], Q = E[_$I + 28 >> 2], i = E[_$I + 80 >> 2], o = E[_$I + 128 >> 2], a = E[_$I + 32 >> 2], E[_$I + 84 >> 2] = E[_$I + 84 >> 2] - (E[_$I + 132 >> 2] + E[_$I + 36 >> 2] | 0), E[_$I + 80 >> 2] = i - (o + a | 0), E[_$I + 76 >> 2] = C - (_$B + Q | 0), E[_$I + 72 >> 2] = b - (_$K + g | 0), E[_$I + 68 >> 2] = S - (G + M | 0), E[_$I + 64 >> 2] = k - (F + _$N | 0), E[_$I + 60 >> 2] = w - (f + n | 0), E[_$I + 56 >> 2] = s - (D + p | 0), E[_$I + 52 >> 2] = r - (e + y | 0), E[_$I + 48 >> 2] = _ - (c + t | 0), BI(_ = _$I + 288 | 0, A), A = NI(_, 32), h = _$I + 320 | 0, A;
                                    }
                                    function XA(A, I, g, C) {
                                        var _$B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (g | C) A: for(t = A + 224 | 0, _ = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (_$B = Q + _ | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                Sg(_$B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (Sg(_$B, I, i), _$B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, o[A + 352 | 0] = _$B, o[A + 353 | 0] = _$B >>> 8, o[A + 354 | 0] = _$B >>> 16, o[A + 355 | 0] = _$B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (E = 128 + (_$B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, o[A + 64 | 0] = E, o[A + 65 | 0] = E >>> 8, o[A + 66 | 0] = E >>> 16, o[A + 67 | 0] = E >>> 24, o[A + 68 | 0] = Q, o[A + 69 | 0] = Q >>> 8, o[A + 70 | 0] = Q >>> 16, o[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = _$B = -1 == (0 | c) & _$B >>> 0 > 4294967167) >>> 0 > (_$B = _$B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, o[A + 72 | 0] = _$B, o[A + 73 | 0] = _$B >>> 8, o[A + 74 | 0] = _$B >>> 16, o[A + 75 | 0] = _$B >>> 24, o[A + 76 | 0] = Q, o[A + 77 | 0] = Q >>> 8, o[A + 78 | 0] = Q >>> 16, o[A + 79 | 0] = Q >>> 24, f(A, _), Sg(_, t, 128), _$B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = _$B, o[A + 353 | 0] = _$B >>> 8, o[A + 354 | 0] = _$B >>> 16, o[A + 355 | 0] = _$B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function OA(A) {
                                        var _$I = 0, g = 0, C = 0, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        for(g = E[A + 60 >> 2], h = E[A + 56 >> 2], s = E[A + 52 >> 2], e = E[A + 48 >> 2], _$I = E[A + 44 >> 2], C = E[A + 40 >> 2], D = E[A + 36 >> 2], r = E[A + 32 >> 2], _$B = E[A + 28 >> 2], Q = E[A + 24 >> 2], i = E[A + 20 >> 2], o = E[A + 16 >> 2], a = E[A + 12 >> 2], _ = E[A + 8 >> 2], c = E[A + 4 >> 2], t = E[A >> 2]; y = Lg(i + c | 0, 7) ^ D, p = Lg(y + i | 0, 9) ^ s, o = Lg(t + e | 0, 7) ^ o, w = Lg(o + t | 0, 9) ^ r, f = Lg(w + o | 0, 13) ^ e, a = Lg(_$I + g | 0, 7) ^ a, _$B = Lg(a + g | 0, 9) ^ _$B, r = Lg(_$B + a | 0, 13) ^ _$I, g = Lg(_$B + r | 0, 18) ^ g, _$I = Lg(C + Q | 0, 7) ^ h, e = f ^ Lg(g + _$I | 0, 7), s = p ^ Lg(e + g | 0, 9), h = Lg(e + s | 0, 13) ^ _$I, g = Lg(s + h | 0, 18) ^ g, _ = Lg(_$I + C | 0, 9) ^ _, Q = Lg(_ + _$I | 0, 13) ^ Q, C = Lg(Q + _ | 0, 18) ^ C, _$I = Lg(C + y | 0, 7) ^ r, r = Lg(_$I + C | 0, 9) ^ w, D = Lg(_$I + r | 0, 13) ^ y, C = Lg(r + D | 0, 18) ^ C, c = Lg(y + p | 0, 13) ^ c, i = Lg(c + p | 0, 18) ^ i, Q = Lg(i + o | 0, 7) ^ Q, _$B = Lg(Q + i | 0, 9) ^ _$B, o = Lg(_$B + Q | 0, 13) ^ o, i = Lg(o + _$B | 0, 18) ^ i, t = Lg(w + f | 0, 18) ^ t, c = Lg(t + a | 0, 7) ^ c, _ = Lg(c + t | 0, 9) ^ _, a = Lg(_ + c | 0, 13) ^ a, t = Lg(a + _ | 0, 18) ^ t, y = n >>> 0 < 6, n = n + 2 | 0, y;);
                                        E[A >> 2] = E[A >> 2] + t, E[A + 4 >> 2] = E[A + 4 >> 2] + c, E[A + 8 >> 2] = E[A + 8 >> 2] + _, E[A + 12 >> 2] = E[A + 12 >> 2] + a, E[A + 16 >> 2] = E[A + 16 >> 2] + o, E[A + 20 >> 2] = E[A + 20 >> 2] + i, E[A + 24 >> 2] = E[A + 24 >> 2] + Q, E[A + 28 >> 2] = E[A + 28 >> 2] + _$B, E[A + 32 >> 2] = E[A + 32 >> 2] + r, E[A + 36 >> 2] = E[A + 36 >> 2] + D, E[A + 40 >> 2] = E[A + 40 >> 2] + C, E[A + 44 >> 2] = E[A + 44 >> 2] + _$I, E[A + 48 >> 2] = E[A + 48 >> 2] + e, E[A + 52 >> 2] = E[A + 52 >> 2] + s, E[A + 56 >> 2] = E[A + 56 >> 2] + h, E[A + 60 >> 2] = E[A + 60 >> 2] + g;
                                    }
                                    function VA(A, I, g, C) {
                                        var _$B, Q = 0;
                                        return h = _$B = h - 320 | 0, Q = -1, GI(g) && (bI(g) || bA(_$B, g) || IA(_$B) && (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], g = a[I + 31 | 0], C && (o[0 | A] = 248 & a[0 | A], g |= 64), o[A + 31 | 0] = 127 & g, u(g = _$B + 160 | 0, A, _$B), tg(A, g), (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (Q = NI(I, 32) ? -1 : 0))), h = _$B + 320 | 0, Q;
                                    }
                                    function ZA(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0;
                                        if (h = Q = h - 48 | 0, B && ag(B, 102), !(36 != a[0 | C] | 55 != a[C + 1 | 0] | 36 != a[C + 2 | 0]) && (r = uI(a[C + 3 | 0])) && (i = PI(Q + 12 | 0, C + 4 | 0)) && (t = PI(Q + 8 | 0, i))) {
                                            for(_ = LI(t) + 1 | 0; i = 0, _ && 36 != a[0 | (i = t + (_ = _ - 1 | 0) | 0)];);
                                            if (c = i - t | 0, i || (c = LI(t)), !((c = 45 + (_ = (i = c) + (t - C | 0) | 0) | 0) >>> 0 > 102 | i >>> 0 > c >>> 0 || (c = A, y = I, s = g, A = 31 & (r = r - 1024 | 0), (63 & r) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, _A(c, y, s, t, i, g, I, E[Q + 12 >> 2], E[Q + 8 >> 2], Q + 16 | 0, 32)))) {
                                                for(i = Sg(B, C, _), o[0 | (A = i + _ | 0)] = 36, e = (c = i + 102 | 0) - (B = A + 1 | 0) | 0, g = 0;;){
                                                    A: if ((I = g) >>> 0 > 31) C = B;
                                                    else if (A = B, g = (_ = I + 1 | 0) + (y = (g = 31 - I | 0) >>> 0 >= 2 ? 2 : g) | 0, C = 0, t = 0, B = a[(r = Q + 16 | 0) + I | 0], y && (B = a[_ + r | 0] << 8 | B, (0 | (I = I + 2 | 0)) != (0 | g) && (t = 1, B = a[I + r | 0] << 16 | B)), e && (o[0 | A] = a[1024 + (63 & B) | 0], 1 != (0 | e))) {
                                                        if (o[A + 1 | 0] = a[1024 + (B >>> 6 & 63) | 0], y = A + e | 0, I = A + 2 | 0, (0 | g) != (0 | _)) {
                                                            if (2 == (0 | e)) break A;
                                                            if (o[A + 2 | 0] = a[1024 + (B >>> 12 & 63) | 0], I = A + 3 | 0, t) {
                                                                if (3 == (0 | e)) break A;
                                                                o[A + 3 | 0] = a[1024 + (B >>> 18 | 0) | 0], I = A + 4 | 0;
                                                            }
                                                        }
                                                        if (e = y - (B = I) | 0, B) continue;
                                                    }
                                                    break;
                                                }
                                                XC(Q + 16 | 0, 32), e = 0, !C | C >>> 0 >= c >>> 0 || (o[0 | C] = 0, e = i);
                                            }
                                        }
                                        return h = Q + 48 | 0, e;
                                    }
                                    function WA(A, I, g) {
                                        var C, _$B, Q, i = 0, o = 0, _ = 0, t = 0;
                                        h = C = h - 16 | 0, _$B = E[A + 20 >> 2], E[A + 20 >> 2] = 0, Q = E[A + 4 >> 2], E[A + 4 >> 2] = 0, i = -26;
                                        A: {
                                            I: {
                                                g: {
                                                    C: switch(g - 1 | 0){
                                                        case 1:
                                                            if (i = -32, Cg(I, 1165, 9)) break A;
                                                            I = I + 9 | 0;
                                                            break g;
                                                        case 0:
                                                            break C;
                                                        default:
                                                            break A;
                                                    }
                                                    if (i = -32, Cg(I, 1156, 8)) break A;
                                                    I = I + 8 | 0;
                                                }
                                                if (!((i = Cg(I, 1422, 3)) || ((o = a[0 | (g = I + 3 | 0)]) - 58 & 255) >>> 0 < 246)) {
                                                    for(t = i ? I : g, I = 0, i = o;;){
                                                        if (_ = g, I >>> 0 > 429496729) break I;
                                                        if ((i = (255 & i) - 48 | 0) >>> 0 > (-1 ^ (I = c(I, 10))) >>> 0) break I;
                                                        if (I = I + i | 0, !(((i = a[0 | (g = g + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                                    }
                                                    if (!(48 == (0 | o) & (0 | t) != (0 | _) | (0 | g) == (0 | t))) {
                                                        if (i = -26, 19 != (0 | I)) break A;
                                                        if (!Cg(g, 1434, 3) && (g = mI(_ + 4 | 0, I = C + 12 | 0)) && (E[A + 44 >> 2] = E[C + 12 >> 2], !Cg(g, 1426, 3) && (g = mI(g + 3 | 0, I)) && (E[A + 40 >> 2] = E[C + 12 >> 2], !Cg(g, 1430, 3) && (g = mI(g + 3 | 0, I)) && (i = E[C + 12 >> 2], E[A + 48 >> 2] = i, E[A + 52 >> 2] = i, 36 == a[0 | g] && (E[C + 12 >> 2] = _$B, !wA(i = E[A + 16 >> 2], _$B, _ = g = g + 1 | 0, o = LI(g), 0, I, g = C + 8 | 0, 3) && (E[A + 20 >> 2] = E[C + 12 >> 2], i = E[C + 8 >> 2], 36 == a[0 | i] && (E[C + 12 >> 2] = Q, i = i + 1 | 0, !wA(E[A >> 2], Q, i, LI(i), 0, I, g, 3)))))))) {
                                                            if (E[A + 4 >> 2] = E[C + 12 >> 2], I = E[C + 8 >> 2], i = pI(A)) break A;
                                                            i = a[0 | I] ? -32 : 0;
                                                            break A;
                                                        }
                                                    }
                                                }
                                            }
                                            i = -32;
                                        }
                                        return h = C + 16 | 0, i;
                                    }
                                    function TA(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0;
                                        C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], h = E[(_$B = I - -64 | 0) >> 2], D = E[I + 28 >> 2], p = E[I + 68 >> 2], w = E[I + 32 >> 2], f = E[I + 72 >> 2], g = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = w + f, E[A + 28 >> 2] = D + p, E[A + 24 >> 2] = s + h, E[A + 20 >> 2] = e + y, E[A + 16 >> 2] = t + r, E[A + 12 >> 2] = _ + c, E[A + 8 >> 2] = o + a, E[A + 4 >> 2] = Q + i, E[A >> 2] = C + g, C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], _$B = E[_$B >> 2], h = E[I + 28 >> 2], D = E[I + 68 >> 2], p = E[I + 32 >> 2], w = E[I + 72 >> 2], f = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = w - p, E[A + 68 >> 2] = D - h, E[A - -64 >> 2] = _$B - s, E[A + 60 >> 2] = y - e, E[A + 56 >> 2] = r - t, E[A + 52 >> 2] = c - _, E[A + 48 >> 2] = a - o, E[A + 44 >> 2] = i - Q, E[A + 40 >> 2] = C - f, C = E[I + 84 >> 2], E[A + 80 >> 2] = E[I + 80 >> 2], E[A + 84 >> 2] = C, C = E[I + 92 >> 2], E[A + 88 >> 2] = E[I + 88 >> 2], E[A + 92 >> 2] = C, C = E[I + 100 >> 2], E[A + 96 >> 2] = E[I + 96 >> 2], E[A + 100 >> 2] = C, C = E[I + 108 >> 2], E[A + 104 >> 2] = E[I + 104 >> 2], E[A + 108 >> 2] = C, C = E[I + 116 >> 2], E[A + 112 >> 2] = E[I + 112 >> 2], E[A + 116 >> 2] = C, Y(A + 120 | 0, I + 120 | 0, 1696);
                                    }
                                    function $A(A, I, g) {
                                        var C, _$B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0;
                                        s = E[I + 12 >> 2], D = E[I + 8 >> 2], p = E[I + 4 >> 2], C = h + -64 & -64, I = E[I >> 2], E[C >> 2] = E[35760 + ((255 & I) << 2) >> 2], E[C + 4 >> 2] = E[35760 + (p >>> 6 & 1020) >> 2], E[C + 8 >> 2] = E[35760 + (D >>> 14 & 1020) >> 2], E[C + 12 >> 2] = E[35760 + (s >>> 22 & 1020) >> 2], E[C + 16 >> 2] = E[35760 + ((255 & p) << 2) >> 2], E[C + 20 >> 2] = E[35760 + (D >>> 6 & 1020) >> 2], E[C + 24 >> 2] = E[35760 + (s >>> 14 & 1020) >> 2], E[C + 28 >> 2] = E[35760 + (I >>> 22 & 1020) >> 2], E[C + 32 >> 2] = E[35760 + ((255 & D) << 2) >> 2], E[C + 36 >> 2] = E[35760 + (s >>> 6 & 1020) >> 2], E[C + 40 >> 2] = E[35760 + (I >>> 14 & 1020) >> 2], E[C + 44 >> 2] = E[35760 + (p >>> 22 & 1020) >> 2], E[C + 48 >> 2] = E[35760 + ((255 & s) << 2) >> 2], E[C + 52 >> 2] = E[35760 + (I >>> 6 & 1020) >> 2], E[C + 56 >> 2] = E[35760 + (p >>> 14 & 1020) >> 2], E[C + 60 >> 2] = E[35760 + (D >>> 22 & 1020) >> 2], I = E[C + 12 >> 2], s = E[C >> 2], D = E[C + 4 >> 2], p = E[C + 8 >> 2], _$B = E[C + 28 >> 2], Q = E[C + 16 >> 2], i = E[C + 20 >> 2], o = E[C + 24 >> 2], a = E[C + 44 >> 2], _ = E[C + 32 >> 2], c = E[C + 36 >> 2], t = E[C + 40 >> 2], r = E[g >> 2], e = E[g + 4 >> 2], y = E[g + 8 >> 2], w = A, f = E[g + 12 >> 2] ^ E[C + 48 >> 2] ^ Lg(E[C + 52 >> 2], 8) ^ Lg(E[C + 56 >> 2], 16) ^ Lg(E[C + 60 >> 2], 24), E[w + 12 >> 2] = f, w = A, f = Lg(c, 8) ^ _ ^ Lg(t, 16) ^ Lg(a, 24) ^ y, E[w + 8 >> 2] = f, w = A, f = Lg(i, 8) ^ Q ^ Lg(o, 16) ^ Lg(_$B, 24) ^ e, E[w + 4 >> 2] = f, w = A, f = Lg(D, 8) ^ s ^ Lg(p, 16) ^ Lg(I, 24) ^ r, E[w >> 2] = f;
                                    }
                                    function AI(A, I, g) {
                                        var C, _$B = 0;
                                        return h = C = h - 160 | 0, o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], _$B = a[I + 31 | 0], g && (o[0 | A] = 248 & a[0 | A], _$B |= 64), o[A + 31 | 0] = 127 & _$B, kA(C, A), tg(A, C), g = -1, (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (g = NI(I, 32) ? -1 : 0), h = C + 160 | 0, g;
                                    }
                                    function II(A, I) {
                                        var g, C, _$B, Q, i, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        (a = E[A + 56 >> 2]) | (_ = E[A + 60 >> 2]) && (o[(r = A - -64 | 0) + a | 0] = 1, !((p = a + 1 | 0) ? _ : _ + 1 | 0) & p >>> 0 <= 15 && Hg(65 + (A + a | 0) | 0, 0, 15 - a | 0), o[A + 80 | 0] = 1, rA(A, r, 16, 0)), p = E[A + 52 >> 2], h = E[A + 48 >> 2], r = E[A + 44 >> 2], a = E[A + 24 >> 2], e = E[A + 28 >> 2] + (a >>> 26 | 0) | 0, t = E[A + 32 >> 2] + (e >>> 26 | 0) | 0, g = E[A + 36 >> 2] + (t >>> 26 | 0) | 0, _ = (s = (a = (a = (67108863 & a) + ((y = E[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (e = (t = (i = (67108863 & g) + ((Q = (C = 67108863 & t) + ((_$B = (D = 67108863 & e) + ((y = a + ((_ = 5 + (s = 67108863 & y) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | y & (t = 67108863 & (y = (t >>> 31 | 0) - 1 | 0))) << 26 | _ & t | e & s) + E[A + 40 >> 2] | 0, o[0 | I] = _, o[I + 1 | 0] = _ >>> 8, o[I + 2 | 0] = _ >>> 16, o[I + 3 | 0] = _ >>> 24, s = _ >>> 0 < s >>> 0, _ = 0, _ = (a = (D = e & D | t & _$B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : _, _ = (r = a) >>> 0 > (a = a + s | 0) >>> 0 ? _ + 1 | 0 : _, o[I + 4 | 0] = a, o[I + 5 | 0] = a >>> 8, o[I + 6 | 0] = a >>> 16, o[I + 7 | 0] = a >>> 24, a = 0, r = (r = (t = e & C | t & Q) << 14 | D >>> 12) >>> 0 > (h = r + h | 0) >>> 0 ? 1 : a, a = h, h = _, a = a + _ | 0, _ = r, _ = a >>> 0 < h >>> 0 ? _ + 1 | 0 : _, o[I + 8 | 0] = a, o[I + 9 | 0] = a >>> 8, o[I + 10 | 0] = a >>> 16, o[I + 11 | 0] = a >>> 24, _ = (a = (a = (y & i | e & g) << 8 | t >>> 18) + p | 0) + _ | 0, o[I + 12 | 0] = _, o[I + 13 | 0] = _ >>> 8, o[I + 14 | 0] = _ >>> 16, o[I + 15 | 0] = _ >>> 24, XC(A, 88);
                                    }
                                    function gI(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, _$B = 0;
                                        return h = C = h - 16 | 0, o[C + 15 | 0] = 0, _$B = -1, 0 | pB[E[8934]](A, I, g) || (o[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], _$B = (a[C + 15 | 0] << 23) - 8388608 >> 31), h = C + 16 | 0, 0 | _$B;
                                    }
                                    function CI(A, I, g, C, B) {
                                        var Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0;
                                        A: {
                                            if (1 == (0 | C) | C >>> 0 > 1) E[9392] = 22;
                                            else {
                                                h = C = h - 128 | 0, E[C - -64 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, Q = LI(A), E[C + 28 >> 2] = Q, E[C + 44 >> 2] = Q, E[C + 12 >> 2] = Q, i = K(Q), E[C + 40 >> 2] = i, o = K(Q), E[C + 24 >> 2] = o, a = K(Q), E[C + 8 >> 2] = a;
                                                I: if (!a | !i | !o || !(Q = K(Q))) gA(i), gA(o), gA(a), A = -22;
                                                else {
                                                    if (A = WA(C + 8 | 0, A, B)) {
                                                        gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), gA(E[C + 8 >> 2]), gA(Q);
                                                        break I;
                                                    }
                                                    a = E[C + 28 >> 2], _ = E[C + 24 >> 2], A = E[C + 60 >> 2], c = E[C + 52 >> 2], t = E[C + 48 >> 2], ag(Q, i = E[C + 12 >> 2]), (o = K(i)) ? (E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 88 >> 2] = a, E[C + 84 >> 2] = _, E[C + 80 >> 2] = g, E[C + 76 >> 2] = I, E[C + 72 >> 2] = i, E[C + 68 >> 2] = o, E[C + 124 >> 2] = 0, E[C + 120 >> 2] = A, E[C + 116 >> 2] = A, E[C + 112 >> 2] = c, E[C + 108 >> 2] = t, (A = L(C + 68 | 0, B)) || Sg(Q, o, i), XC(o, i), gA(o)) : A = -22, gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), A || (A = MI(Q, E[C + 8 >> 2], E[C + 12 >> 2]) ? -35 : 0), gA(Q), gA(E[C + 8 >> 2]);
                                                }
                                                if (h = C + 128 | 0, I = A, !A) break A;
                                                -35 == (0 | A) && (E[9392] = 28);
                                            }
                                            I = -1;
                                        }
                                        return I;
                                    }
                                    function BI(A, I) {
                                        var g, C, _$B, Q, i, a, _, t = 0, r = 0;
                                        C = E[I + 32 >> 2], _$B = E[I + 28 >> 2], Q = E[I + 24 >> 2], i = E[I + 20 >> 2], a = E[I + 16 >> 2], _ = E[I + 12 >> 2], t = E[I + 4 >> 2], r = E[I >> 2], g = E[I + 36 >> 2], I = E[I + 8 >> 2], r = c((C + (_$B + (Q + (i + (a + (_ + ((t + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, o[0 | A] = r, o[A + 2 | 0] = r >>> 16, o[A + 1 | 0] = r >>> 8, t = t + (r >> 26) | 0, o[A + 5 | 0] = t >>> 14, o[A + 4 | 0] = t >>> 6, o[A + 3 | 0] = r >>> 24 & 3 | t << 2, I = I + (t >> 25) | 0, o[A + 8 | 0] = I >>> 13, o[A + 7 | 0] = I >>> 5, o[A + 6 | 0] = I << 3 | (29360128 & t) >>> 22, r = (I >> 26) + _ | 0, o[A + 11 | 0] = r >>> 11, o[A + 10 | 0] = r >>> 3, o[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, t = (r >> 25) + a | 0, o[A + 15 | 0] = t >>> 18, o[A + 14 | 0] = t >>> 10, o[A + 13 | 0] = t >>> 2, I = (t >> 26) + i | 0, o[A + 16 | 0] = I, o[A + 12 | 0] = t << 6 | (33030144 & r) >>> 19, o[A + 18 | 0] = I >>> 16, o[A + 17 | 0] = I >>> 8, t = (I >> 25) + Q | 0, o[A + 21 | 0] = t >>> 15, o[A + 20 | 0] = t >>> 7, o[A + 19 | 0] = I >>> 24 & 1 | t << 1, I = (t >> 26) + _$B | 0, o[A + 24 | 0] = I >>> 13, o[A + 23 | 0] = I >>> 5, o[A + 22 | 0] = I << 3 | (58720256 & t) >>> 23, t = (I >> 25) + C | 0, o[A + 27 | 0] = t >>> 12, o[A + 26 | 0] = t >>> 4, o[A + 25 | 0] = t << 4 | (31457280 & I) >>> 21, I = g + (t >> 26) | 0, o[A + 30 | 0] = I >>> 10, o[A + 29 | 0] = I >>> 2, o[A + 31 | 0] = (33292288 & I) >>> 18, o[A + 28 | 0] = I << 6 | (66060288 & t) >>> 20;
                                    }
                                    function QI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, _$B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (h = C = h - 192 | 0, (g |= 0) >>> 0 >= 129 && (SI(A), nA(A, I, g, 0), z(A, C), g = 64, I = C), SI(A), Hg(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(t = 252 & g; o[0 | (_$B = (i = C - -64 | 0) + Q | 0)] = a[0 | _$B] ^ a[I + Q | 0], o[0 | (E = (_$B = 1 | Q) + i | 0)] = a[0 | E] ^ a[I + _$B | 0], o[0 | (E = (_$B = 2 | Q) + i | 0)] = a[0 | E] ^ a[I + _$B | 0], o[0 | (_$B = (_$B = i) + (i = 3 | Q) | 0)] = a[0 | _$B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (_ = 3 & g) for(; o[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | _) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (nA(A, Q = C - -64 | 0, 128, 0), SI(i = A + 208 | 0), Hg(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(t = 252 & g, _ = 0; o[0 | (_$B = (A = C - -64 | 0) + Q | 0)] = a[0 | _$B] ^ a[I + Q | 0], o[0 | (E = (_$B = 1 | Q) + A | 0)] = a[0 | E] ^ a[I + _$B | 0], o[0 | (E = (_$B = 2 | Q) + A | 0)] = a[0 | E] ^ a[I + _$B | 0], o[0 | (_$B = (_$B = A) + (A = 3 | Q) | 0)] = a[0 | _$B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return nA(i, A = C - -64 | 0, 128, 0), XC(A, 128), XC(C, 64), h = C + 192 | 0, 0;
                                    }
                                    function iI(A, I) {
                                        var g;
                                        return A |= 0, I |= 0, E[12 + (g = h - 16 | 0) >> 2] = A, E[g + 8 >> 2] = I, E[g + 4 >> 2] = 0, E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2]] ^ a[E[g + 8 >> 2]], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 1 | 0] ^ a[E[g + 8 >> 2] + 1 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 2 | 0] ^ a[E[g + 8 >> 2] + 2 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 3 | 0] ^ a[E[g + 8 >> 2] + 3 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 4 | 0] ^ a[E[g + 8 >> 2] + 4 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 5 | 0] ^ a[E[g + 8 >> 2] + 5 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 6 | 0] ^ a[E[g + 8 >> 2] + 6 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 7 | 0] ^ a[E[g + 8 >> 2] + 7 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 8 | 0] ^ a[E[g + 8 >> 2] + 8 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 9 | 0] ^ a[E[g + 8 >> 2] + 9 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 10 | 0] ^ a[E[g + 8 >> 2] + 10 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 11 | 0] ^ a[E[g + 8 >> 2] + 11 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 12 | 0] ^ a[E[g + 8 >> 2] + 12 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 13 | 0] ^ a[E[g + 8 >> 2] + 13 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 14 | 0] ^ a[E[g + 8 >> 2] + 14 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 15 | 0] ^ a[E[g + 8 >> 2] + 15 | 0], (E[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function oI(A, I, g) {
                                        var C = 0, _$B = 0, Q = 0, i = 0, o = 0, E = 0, a = 0, _ = 0, r = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            if (I) {
                                                                                if (!g) break E;
                                                                                break o;
                                                                            }
                                                                            return D = (I = A) - c(A = (A >>> 0) / (g >>> 0) | 0, g) | 0, p = 0, w = 0, A;
                                                                        }
                                                                        if (!A) break i;
                                                                        break Q;
                                                                    }
                                                                    if (!((C = g - 1 | 0) & g)) break B;
                                                                    Q = 0 - (i = (t(g) + 33 | 0) - t(I) | 0) | 0;
                                                                    break g;
                                                                }
                                                                return D = 0, p = I - c(A = (I >>> 0) / 0 | 0, 0) | 0, w = 0, A;
                                                            }
                                                            if ((C = 32 - t(I) | 0) >>> 0 < 31) break C;
                                                            break I;
                                                        }
                                                        if (D = A & C, p = 0, 1 == (0 | g)) break A;
                                                        return g = 31 & (C = FC(g)), (63 & C) >>> 0 >= 32 ? A = I >>> g | 0 : (_$B = I >>> g | 0, A = ((1 << g) - 1 & I) << 32 - g | A >>> g), w = _$B, A;
                                                    }
                                                    i = C + 1 | 0, Q = 63 - C | 0;
                                                }
                                                if (C = 31 & (_$B = 63 & i), _$B >>> 0 >= 32 ? (_$B = 0, o = I >>> C | 0) : (_$B = I >>> C | 0, o = ((1 << C) - 1 & I) << 32 - C | A >>> C), C = 31 & (Q &= 63), Q >>> 0 >= 32 ? (I = A << C, A = 0) : (I = (1 << C) - 1 & A >>> 32 - C | I << C, A <<= C), i) for(_ = -1 == (0 | (C = g - 1 | 0)) ? -1 : 0; E = _$B << 1 | o >>> 31, o = (_$B = o << 1 | I >>> 31) - (a = g & (Q = _ - (E + (_$B >>> 0 > C >>> 0) | 0) >> 31)) | 0, _$B = E - (_$B >>> 0 < a >>> 0) | 0, I = I << 1 | A >>> 31, A = r | A << 1, r = E = 1 & Q, i = i - 1 | 0;);
                                                return D = o, p = _$B, w = I << 1 | A >>> 31, E | A << 1;
                                            }
                                            D = A, p = I, A = 0, I = 0;
                                        }
                                        return w = I, A;
                                    }
                                    function EI(A, I, g, C, B) {
                                        var Q;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), dC(Q, I, g, C), fg(Q, Q + 416 | 0), I = E[Q + 444 >> 2], g = E[Q + 440 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 436 >> 2], g = E[Q + 432 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 428 >> 2], g = E[Q + 424 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 420 >> 2], g = E[Q + 416 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = Q + 480 | 0, 0;
                                    }
                                    function aI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, _$B = 0;
                                        return h = C = h + -64 | 0, kI(C, g |= 0, 32, 0), g = E[C + 28 >> 2], _$B = E[C + 24 >> 2], o[I + 24 | 0] = _$B, o[I + 25 | 0] = _$B >>> 8, o[I + 26 | 0] = _$B >>> 16, o[I + 27 | 0] = _$B >>> 24, o[I + 28 | 0] = g, o[I + 29 | 0] = g >>> 8, o[I + 30 | 0] = g >>> 16, o[I + 31 | 0] = g >>> 24, g = E[C + 20 >> 2], _$B = E[C + 16 >> 2], o[I + 16 | 0] = _$B, o[I + 17 | 0] = _$B >>> 8, o[I + 18 | 0] = _$B >>> 16, o[I + 19 | 0] = _$B >>> 24, o[I + 20 | 0] = g, o[I + 21 | 0] = g >>> 8, o[I + 22 | 0] = g >>> 16, o[I + 23 | 0] = g >>> 24, g = E[C + 12 >> 2], _$B = E[C + 8 >> 2], o[I + 8 | 0] = _$B, o[I + 9 | 0] = _$B >>> 8, o[I + 10 | 0] = _$B >>> 16, o[I + 11 | 0] = _$B >>> 24, o[I + 12 | 0] = g, o[I + 13 | 0] = g >>> 8, o[I + 14 | 0] = g >>> 16, o[I + 15 | 0] = g >>> 24, g = E[C + 4 >> 2], _$B = E[C >> 2], o[0 | I] = _$B, o[I + 1 | 0] = _$B >>> 8, o[I + 2 | 0] = _$B >>> 16, o[I + 3 | 0] = _$B >>> 24, o[I + 4 | 0] = g, o[I + 5 | 0] = g >>> 8, o[I + 6 | 0] = g >>> 16, o[I + 7 | 0] = g >>> 24, XC(C, 64), A = wC(A, I), h = C - -64 | 0, 0 | A;
                                    }
                                    function _I(A, I) {
                                        var g = 0, C = 0, _$B = 0, Q = 0, i = 0, o = 0;
                                        if (I >>> 0 > 4294967168) A = 48;
                                        else {
                                            if (I >>> 0 >= 4294967168 ? (E[9392] = 48, g = 0) : (g = 0, (I = K(76 + (Q = I >>> 0 < 11 ? 16 : I + 11 & -8) | 0)) && (g = I - 8 | 0, 63 & I ? (_$B = (-8 & (o = E[(i = I - 4 | 0) >> 2])) - (C = (I = ((I = (I + 63 & -64) - 8 | 0) - g >>> 0 <= 15 ? 64 : 0) + I | 0) - g | 0) | 0, 3 & o ? (E[I + 4 >> 2] = _$B | 1 & E[I + 4 >> 2] | 2, E[4 + (_$B = I + _$B | 0) >> 2] = 1 | E[_$B + 4 >> 2], E[i >> 2] = C | 1 & E[i >> 2] | 2, E[4 + (_$B = g + C | 0) >> 2] = 1 | E[_$B + 4 >> 2], iA(g, C)) : (g = E[g >> 2], E[I + 4 >> 2] = _$B, E[I >> 2] = g + C)) : I = g, 3 & (g = E[I + 4 >> 2]) && ((C = -8 & g) >>> 0 <= Q + 16 >>> 0 || (E[I + 4 >> 2] = Q | 1 & g | 2, g = I + Q | 0, Q = C - Q | 0, E[g + 4 >> 2] = 3 | Q, E[4 + (C = I + C | 0) >> 2] = 1 | E[C + 4 >> 2], iA(g, Q))), g = I + 8 | 0)), !g) return 48;
                                            E[A >> 2] = g, A = 0;
                                        }
                                        return A;
                                    }
                                    function cI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!((!a & o >>> 0 >= 3 | 0 != (0 | a)) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 1 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 1)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function tI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!(!!(o | a) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 2 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 2)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function rI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, yA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), ug(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && Ug(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function eI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, fA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), aC(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && oC(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function yI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, fA(o, Q, i, 0), pC(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), XC(o + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || oC(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function sI(A, I, g, C, B, Q, i, o, _, c) {
                                        var t, r;
                                        return h = t = h - 400 | 0, E[t + 4 >> 2] = 0, yA(r = t + 16 | 0, _, c, 0), c = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[t + 8 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[t + 12 >> 2] = c, Xg(c = t + 80 | 0, 64, 0, t + 4 | 0, r), fC(_ = t + 144 | 0, c), XC(c, 64), NC(_, Q, i, o), NC(_, 35680, 0 - i & 15, 0), NC(_, I, g, C), NC(_, 35680, 0 - g & 15, 0), E[t + 72 >> 2] = i, E[t + 76 >> 2] = o, NC(_, Q = t + 72 | 0, 8, 0), E[t + 72 >> 2] = g, E[t + 76 >> 2] = C, NC(_, Q, 8, 0), nC(_, Q = t + 48 | 0), XC(_, 256), _ = iI(Q, B), XC(Q, 16), A && (_ ? (Hg(A, 0, g), _ = -1) : (Og(A, I, g, C, t + 4 | 0, t + 16 | 0), _ = 0)), XC(t + 16 | 0, 32), h = t + 400 | 0, _;
                                    }
                                    function hI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, yA(o, Q, i, 0), jg(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Q = 0, !B & C >>> 0 < 33 || Ug(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function DI(A, I, g, C, B, Q) {
                                        var i, a;
                                        if (h = i = h - 496 | 0, UA(a = i + 288 | 0, A, I), YC(a, g, C, 0), Q) for(A = 0, I = 0; g = (I = I + 1 | 0) << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, o[i + 76 | 0] = g, o[i + 77 | 0] = g >>> 8, o[i + 78 | 0] = g >>> 16, o[i + 79 | 0] = g >>> 24, Sg(g = i + 80 | 0, i + 288 | 0, 208), YC(g, i + 76 | 0, 4, 0), Fg(g, i + 32 | 0), g = E[i + 60 >> 2], E[i + 24 >> 2] = E[i + 56 >> 2], E[i + 28 >> 2] = g, g = E[i + 52 >> 2], E[i + 16 >> 2] = E[i + 48 >> 2], E[i + 20 >> 2] = g, g = E[i + 44 >> 2], E[i + 8 >> 2] = E[i + 40 >> 2], E[i + 12 >> 2] = g, g = E[i + 36 >> 2], E[i >> 2] = E[i + 32 >> 2], E[i + 4 >> 2] = g, Sg(g = A + B | 0, i, (A = Q - A | 0) >>> 0 >= 32 ? 32 : A), Q >>> 0 > (A = I << 5) >>> 0;);
                                        XC(i + 288 | 0, 208), h = i + 496 | 0;
                                    }
                                    function pI(A) {
                                        var _$I = 0, g = 0, C = 0;
                                        if (!A) return -25;
                                        if (!E[A >> 2]) return -1;
                                        if (_$I = -2, !(_[A + 4 >> 2] < 16) && (E[A + 8 >> 2] || (_$I = -18, !E[A + 12 >> 2]))) {
                                            if (g = E[A + 20 >> 2], !E[A + 16 >> 2]) return g ? -19 : -6;
                                            if (_$I = -6, !(g >>> 0 < 8) && (E[A + 24 >> 2] || (_$I = -20, !E[A + 28 >> 2])) && (E[A + 32 >> 2] || (_$I = -21, !E[A + 36 >> 2]))) {
                                                if (!(g = E[A + 48 >> 2])) return -16;
                                                if (_$I = -17, !(g >>> 0 > 16777215 || (_$I = -14, (C = E[A + 44 >> 2]) >>> 0 < 8 || (_$I = -15, C >>> 0 > 2097152 || (_$I = -14, g << 3 >>> 0 > C >>> 0))))) {
                                                    if (!E[A + 40 >> 2]) return -12;
                                                    if (!(A = E[A + 52 >> 2])) return -28;
                                                    _$I = A >>> 0 > 16777215 ? -29 : 0;
                                                }
                                            }
                                        }
                                        return _$I;
                                    }
                                    function wI(A, I, g, C, B, Q) {
                                        var i, E, a = 0;
                                        return h = i = h - 32 | 0, a = -1, (E = g >>> 0 < 32) & !C || (Kg(i, 32, 0, B, Q), DC(I + 16 | 0, I + 32 | 0, g - 32 | 0, C - E | 0, i) || (Gg(A, I, g, C, B, Q), o[A + 24 | 0] = 0, o[A + 25 | 0] = 0, o[A + 26 | 0] = 0, o[A + 27 | 0] = 0, o[A + 28 | 0] = 0, o[A + 29 | 0] = 0, o[A + 30 | 0] = 0, o[A + 31 | 0] = 0, o[A + 16 | 0] = 0, o[A + 17 | 0] = 0, o[A + 18 | 0] = 0, o[A + 19 | 0] = 0, o[A + 20 | 0] = 0, o[A + 21 | 0] = 0, o[A + 22 | 0] = 0, o[A + 23 | 0] = 0, o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, a = 0)), h = i + 32 | 0, a;
                                    }
                                    function fI(A, I, g, C, B, Q, i, o, _, c, t) {
                                        var r, e, y;
                                        return h = r = h - 384 | 0, E[r + 4 >> 2] = 0, yA(e = r + 16 | 0, c, t, 0), t = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, E[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, E[r + 12 >> 2] = t, Xg(t = r - -64 | 0, 64, 0, y = r + 4 | 0, e), fC(c = r + 128 | 0, t), XC(t, 64), NC(c, i, o, _), NC(c, 35680, 0 - o & 15, 0), Og(A, C, B, Q, y, e), NC(c, A, B, Q), NC(c, 35680, 0 - B & 15, 0), E[r + 56 >> 2] = o, E[r + 60 >> 2] = _, NC(c, A = r + 56 | 0, 8, 0), E[r + 56 >> 2] = B, E[r + 60 >> 2] = Q, NC(c, A, 8, 0), nC(c, I), XC(c, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), XC(r + 16 | 0, 32), h = r + 384 | 0, 0;
                                    }
                                    function nI(A, I, g, C, B) {
                                        var Q, i, o = 0;
                                        return h = Q = h + -64 | 0, !g & (i = LI(A)) >>> 0 < 128 ? (E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 56 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 48 >> 2] = 0, g = 0, i && (g = i, (1 | i) >>> 0 < 65536 || (g = i)), !(o = K(g)) | !(3 & a[o - 4 | 0]) || Hg(o, 0, g), o ? (E[Q + 36 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 12 >> 2] = o, E[Q + 20 >> 2] = o, E[Q + 24 >> 2] = i, E[Q + 4 >> 2] = o, E[Q + 16 >> 2] = i, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 8 >> 2] = i, WA(Q + 4 | 0, A, B) ? (E[9392] = 28, A = -1) : A = E[Q + 44 >> 2] != (0 | I) | E[Q + 48 >> 2] != (C >>> 10 | 0), gA(o)) : A = -1) : (E[9392] = 28, A = -1), h = Q - -64 | 0, A;
                                    }
                                    function kI(A, I, g, C) {
                                        var _$B, Q = 0;
                                        return h = _$B = h - 208 | 0, E[_$B + 72 >> 2] = 0, E[_$B + 76 >> 2] = 0, Q = E[8691], E[_$B + 8 >> 2] = E[8690], E[_$B + 12 >> 2] = Q, Q = E[8693], E[_$B + 16 >> 2] = E[8692], E[_$B + 20 >> 2] = Q, Q = E[8695], E[_$B + 24 >> 2] = E[8694], E[_$B + 28 >> 2] = Q, Q = E[8697], E[_$B + 32 >> 2] = E[8696], E[_$B + 36 >> 2] = Q, Q = E[8699], E[_$B + 40 >> 2] = E[8698], E[_$B + 44 >> 2] = Q, Q = E[8701], E[_$B + 48 >> 2] = E[8700], E[_$B + 52 >> 2] = Q, Q = E[8703], E[_$B + 56 >> 2] = E[8702], E[_$B + 60 >> 2] = Q, E[_$B + 64 >> 2] = 0, E[_$B + 68 >> 2] = 0, Q = E[8689], E[_$B >> 2] = E[8688], E[_$B + 4 >> 2] = Q, nA(_$B, I, g, C), z(_$B, A), h = _$B + 208 | 0, 0;
                                    }
                                    function FI(A, I) {
                                        var g = 0, C = 0;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(g = a[0 | A]) | (0 | g) == (255 & I)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (g = E[A >> 2])) & g - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (g ^= C)) & g - 16843009 & -2139062144) break I;
                                                if (g = E[A + 4 >> 2], A = A + 4 | 0, g - 16843009 & (-1 ^ g) & -2139062144) break;
                                            }
                                            for(; g = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & I)););
                                            A = g;
                                        } else A = LI(A) + A | 0;
                                        return a[0 | A] == (255 & I) ? A : 0;
                                    }
                                    function NI(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0;
                                        if (o[15 + (g = h - 16 | 0) | 0] = 0, I) {
                                            if (_$B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (_$B) for(I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | _$B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function SI(A) {
                                        var _$I = 0;
                                        return E[64 + (A |= 0) >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, _$I = E[8689], E[A >> 2] = E[8688], E[A + 4 >> 2] = _$I, _$I = E[8691], E[A + 8 >> 2] = E[8690], E[A + 12 >> 2] = _$I, _$I = E[8693], E[A + 16 >> 2] = E[8692], E[A + 20 >> 2] = _$I, _$I = E[8695], E[A + 24 >> 2] = E[8694], E[A + 28 >> 2] = _$I, _$I = E[8697], E[A + 32 >> 2] = E[8696], E[A + 36 >> 2] = _$I, _$I = E[8699], E[A + 40 >> 2] = E[8698], E[A + 44 >> 2] = _$I, _$I = E[8701], E[A + 48 >> 2] = E[8700], E[A + 52 >> 2] = _$I, _$I = E[8703], E[A + 56 >> 2] = E[8702], E[A + 60 >> 2] = _$I, 0;
                                    }
                                    function GI(A) {
                                        return ((127 & (-1 ^ a[A + 31 | 0]) | a[A + 1 | 0] & a[A + 2 | 0] & a[A + 3 | 0] & a[A + 4 | 0] & a[A + 5 | 0] & a[A + 6 | 0] & a[A + 7 | 0] & a[A + 8 | 0] & a[A + 9 | 0] & a[A + 10 | 0] & a[A + 11 | 0] & a[A + 12 | 0] & a[A + 13 | 0] & a[A + 14 | 0] & a[A + 15 | 0] & a[A + 16 | 0] & a[A + 17 | 0] & a[A + 18 | 0] & a[A + 19 | 0] & a[A + 20 | 0] & a[A + 21 | 0] & a[A + 22 | 0] & a[A + 23 | 0] & a[A + 24 | 0] & a[A + 25 | 0] & a[A + 26 | 0] & a[A + 27 | 0] & a[A + 28 | 0] & a[A + 30 | 0] & a[A + 29 | 0] ^ 255) - 1 & 236 - a[0 | A] ^ -1) >>> 8 & 1;
                                    }
                                    function MI(A, I, g) {
                                        var C, _$B = 0, Q = 0;
                                        if (E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, o[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], _$B = 1 | A, o[C + 7 | 0] = a[C + 7 | 0] | a[_$B + E[C + 12 >> 2] | 0] ^ a[E[C + 8 >> 2] + _$B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function bI(A) {
                                        for(var _$I = 0, g = 0, C = 0, _$B = 0, Q = 0, i = 0, o = 0, E = 0, _ = 0, c = 0; _$B = (g = a[A + C | 0]) ^ a[0 | (_$I = C + 2704 | 0)] | _$B, Q = g ^ a[_$I + 192 | 0] | Q, i = g ^ a[_$I + 160 | 0] | i, o = g ^ a[_$I + 128 | 0] | o, E = g ^ a[_$I + 96 | 0] | E, _ = g ^ a[_$I - -64 | 0] | _, c = g ^ a[_$I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((_$I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (_$I | i)) - 1 | (255 & (_$I | o)) - 1 | (255 & (122 ^ A | E)) - 1 | (255 & (5 ^ A | _)) - 1 | (255 & (A | c)) - 1 | (255 & (A | _$B)) - 1) >>> 8 & 1;
                                    }
                                    function KI(A, I, g) {
                                        var C = 0, _$B = 0, Q = 0, i = 0;
                                        return _$B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> _$B | 0 : (C = -1 >>> _$B | 0) | (1 << _$B) - 1 << 32 - _$B, Q &= A, C &= I, _$B = 31 & i, i >>> 0 >= 32 ? (C = Q << _$B, i = 0) : (C = (1 << _$B) - 1 & Q >>> 32 - _$B | C << _$B, i = Q << _$B), Q = C, C = 31 & (_$B = 0 - g & 63), _$B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & _$B, _$B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), w = g | Q, A | i;
                                    }
                                    function HI(A, I, g, C, B, Q) {
                                        A |= 0, I |= 0, g |= 0;
                                        var i = 0, o = 0;
                                        A: I: {
                                            g: {
                                                if (!(!(B |= 0) & (C |= 0) >>> 0 < 64 || (o = 1 + (B = B - 1 | 0) | 0, i = B, !(C = (B = C + -64 | 0) >>> 0 < 4294967232 ? o : i) & B >>> 0 > 4294967231 | C))) {
                                                    if (!H(i = g, g = g - -64 | 0, B, C, Q |= 0, 0)) break g;
                                                    A && Hg(A, 0, B);
                                                }
                                                if (C = -1, !I) break I;
                                                E[I >> 2] = 0, E[I + 4 >> 2] = 0, C = -1;
                                                break A;
                                            }
                                            I && (E[I >> 2] = B, E[I + 4 >> 2] = C), C = 0, A && yg(A, g, B);
                                        }
                                        return 0 | C;
                                    }
                                    function YI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, Xg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), NC(t, 35648, 0 - i & 15, 0), NC(t, I, g, C), NC(t, 35648, 0 - g & 15, 0), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (gg(A, I, g, C, a, 1, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function dI(A, I, g, C, B, Q) {
                                        var i, o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, h = i = h - 32 | 0, o = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 24 >> 2] = 0, E[i + 28 >> 2] = 0, E[i + 16 >> 2] = o, E[i + 20 >> 2] = B, E[i + 8 >> 2] = 0, E[i + 12 >> 2] = 0, E[i >> 2] = g, E[i + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (E[9392] = 28, A = -1) : A = QA(A, I, 0, 0, 0, Q, 32, i, i + 16 | 0), h = i + 32 | 0, 0 | A;
                                    }
                                    function JI(A, I, g, C, B) {
                                        var Q, i;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 512 | 0, QI(i = Q + 32 | 0, B |= 0, 32), dC(i, I, g, C), fg(i, Q + 448 | 0), I = E[Q + 476 >> 2], E[Q + 24 >> 2] = E[Q + 472 >> 2], E[Q + 28 >> 2] = I, I = E[Q + 468 >> 2], E[Q + 16 >> 2] = E[Q + 464 >> 2], E[Q + 20 >> 2] = I, I = E[Q + 460 >> 2], E[Q + 8 >> 2] = E[Q + 456 >> 2], E[Q + 12 >> 2] = I, I = E[Q + 452 >> 2], E[Q >> 2] = E[Q + 448 >> 2], E[Q + 4 >> 2] = I, I = SC(A, Q), g = MI(Q, A, 32), h = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                    }
                                    function UI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, jg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), NC(t, I, g, C), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (Ug(A, I, g, C, a, 1, 0, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function lI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, Xg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), NC(r, 35648, 0 - o & 15, 0), gg(A, C, B, Q, _, 1, c), NC(r, A, B, Q), NC(r, 35648, 0 - B & 15, 0), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, A = t + 8 | 0, 8, 0), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, A, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function mI(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0, o = 0;
                                        A: if (!(((g = a[0 | A]) - 58 & 255) >>> 0 < 246)) {
                                            for(C = g, _$B = A;;){
                                                if (i = _$B, Q >>> 0 > 429496729) break A;
                                                if ((C = (255 & C) - 48 | 0) >>> 0 > (-1 ^ (Q = c(Q, 10))) >>> 0) break A;
                                                if (Q = Q + C | 0, !(((C = a[0 | (_$B = _$B + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                            }
                                            48 == (0 | g) & (0 | A) != (0 | i) | (0 | A) == (0 | _$B) || (E[I >> 2] = Q, o = _$B);
                                        }
                                        return o;
                                    }
                                    function uI(A) {
                                        var _$I = 0, g = 0, C = 0, _$B = 0;
                                        _$I = 65, g = 1024;
                                        A: {
                                            I: {
                                                if ((0 | (C = 255 & A)) != a[1024]) for(C = c(C, 16843009);;){
                                                    if ((-1 ^ (_$B = C ^ E[g >> 2])) & _$B - 16843009 & -2139062144) break I;
                                                    if (g = g + 4 | 0, !((_$I = _$I - 4 | 0) >>> 0 > 3)) break;
                                                }
                                                if (!_$I) break A;
                                            }
                                            for(A &= 255;;){
                                                if ((0 | A) == a[0 | g]) return g;
                                                if (g = g + 1 | 0, !(_$I = _$I - 1 | 0)) break;
                                            }
                                        }
                                        return 0;
                                    }
                                    function xI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, jg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, i = t + 8 | 0, 8, 0), Ug(A, C, B, Q, _, 1, 0, c), NC(r, A, B, Q), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, i, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function RI(A, I, g, C, B, Q) {
                                        return !C & g >>> 0 >= 32 | C ? (Gg(A, I, g, C, B, Q), hC(A + 16 | 0, A + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, A), o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, A = 0) : A = -1, A;
                                    }
                                    function vI(A, I, g, C, B, Q) {
                                        I |= 0, B |= 0, Q |= 0;
                                        var i, o = 0;
                                        return h = i = h - 16 | 0, n(A |= 0, i + 8 | 0, yg(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), E[i + 12 >> 2] | 64 != E[i + 8 >> 2] ? (I && (E[I >> 2] = 0, E[I + 4 >> 2] = 0), Hg(A, 0, C - -64 | 0), o = -1) : I && (E[I >> 2] = C - -64, E[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), h = i + 16 | 0, 0 | o;
                                    }
                                    function LI(A) {
                                        var _$I = 0, g = 0, C = 0;
                                        A: {
                                            I: if (3 & (_$I = A)) {
                                                if (!a[0 | _$I]) return 0;
                                                for(;;){
                                                    if (!(3 & (_$I = _$I + 1 | 0))) break I;
                                                    if (!a[0 | _$I]) break;
                                                }
                                                break A;
                                            }
                                            for(; g = _$I, _$I = _$I + 4 | 0, !((-1 ^ (C = E[g >> 2])) & C - 16843009 & -2139062144););
                                            for(; g = (_$I = g) + 1 | 0, a[0 | _$I];);
                                        }
                                        return _$I - A | 0;
                                    }
                                    function PI(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0, i = 0;
                                        return (g = uI(a[0 | I])) && (C = uI(a[I + 1 | 0])) && (_$B = uI(a[I + 2 | 0])) && (Q = uI(a[I + 3 | 0])) && (i = uI(a[I + 4 | 0])) ? (E[A >> 2] = g - 1024 | C - 1024 << 6 | _$B - 1024 << 12 | Q - 1024 << 18 | i - 1024 << 24, I + 5 | 0) : (E[A >> 2] = 0, 0);
                                    }
                                    function qI(A, I, g) {
                                        var C;
                                        for(E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, E[C + 4 >> 2] = 0; E[C + 4 >> 2] = E[C + 4 >> 2] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], I = 1 | A, E[C + 4 >> 2] = E[C + 4 >> 2] | a[I + E[C + 12 >> 2] | 0] ^ a[I + E[C + 8 >> 2] | 0], (0 | g) != (0 | (A = A + 2 | 0)););
                                        return (E[C + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function zI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t = 0, r = 0, e = 0;
                                        return r = -1, (t = C >>> 0 < 32) & !B || !(t = B - t | 0) & (e = C - 32 | 0) >>> 0 > 4294967263 | t | !o & i >>> 0 > 4294967263 | o || (r = 0 | pB[E[c >> 2]](A, g, e, (g + C | 0) - 32 | 0, 32, Q, i, a, _)), I && (E[I >> 2] = r ? 0 : C - 32 | 0, E[I + 4 >> 2] = r ? 0 : B - (C >>> 0 < 32) | 0), r;
                                    }
                                    function jI(A, I) {
                                        var g, C = 0, _$B = 0, Q = 0;
                                        h = g = h - 896 | 0, pA(C = g + 848 | 0, I), pA(_$B = g + 800 | 0, I + 32 | 0), T(Q = g + 320 | 0, C), T(I = g + 160 | 0, _$B), TA(C = g + 640 | 0, I), sA(I = g + 480 | 0, Q, C), Y(g, I, C = g + 600 | 0), Y(g + 40 | 0, _$B = g + 520 | 0, Q = g + 560 | 0), Y(g + 80 | 0, Q, C), Y(g + 120 | 0, I, _$B), O(A, g), h = g + 896 | 0;
                                    }
                                    function XI(A) {
                                        var _$I = 0, g = 0, C = 0, _$B = 0;
                                        for(_$I = 1; _$I = a[0 | (g = A + C | 0)] + _$I | 0, o[0 | g] = _$I, _$I = a[0 | (g = (1 | C) + A | 0)] + (_$I >>> 8 | 0) | 0, o[0 | g] = _$I, _$I = a[0 | (g = (2 | C) + A | 0)] + (_$I >>> 8 | 0) | 0, o[0 | g] = _$I, _$I = a[0 | (g = (3 | C) + A | 0)] + (_$I >>> 8 | 0) | 0, o[0 | g] = _$I, _$I = _$I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (_$B = _$B + 4 | 0)););
                                    }
                                    function OI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? (!Q & B >>> 0 >= 3 | 0 != (0 | Q)) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 1) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function VI(A, I) {
                                        var g = 0;
                                        4 & I && ((I = E[A >> 2]) && XC(E[I + 4 >> 2], E[A + 16 >> 2] << 10), (I = E[A + 4 >> 2]) && XC(I, E[A + 20 >> 2] << 3)), gA(E[A + 4 >> 2]), E[A + 4 >> 2] = 0, (I = E[A >> 2]) && (g = E[I >> 2]) && gA(g), gA(I), E[A >> 2] = 0;
                                    }
                                    function ZI(A) {
                                        var _$I = 0, g = 0, C = 0, _$B = 0, Q = 0, i = 0, o = 0, E = 0;
                                        for(_$I = 32, g = 1; E = (_$B = a[(C = _$I - 2 | 0) + A | 0]) - (Q = a[C + 2928 | 0]) >> 8 & (_$I = ((i = a[2928 + (_$I = _$I - 1 | 0) | 0]) ^ (o = a[A + _$I | 0])) - 1 >> 8 & g) | 255 & (o - i >>> 8 & g | E), g = _$I & (_$B ^ Q) - 1 >> 8, _$I = C;);
                                        return 0 != (255 & E);
                                    }
                                    function WI(A, I, g, C, B, i, o, a, _, c, t) {
                                        return !B & C >>> 0 > 4294967263 | 0 != (0 | B) | !a & o >>> 0 >= 4294967264 | 0 != (0 | a) ? (yC(), Q()) : (A = 0 | pB[E[t >> 2]](A, A + C | 0, 32, g, C, i, o, _, c), I && (C = (g = C + 32 | 0) >>> 0 < 32 ? B + 1 | 0 : B, E[I >> 2] = A ? 0 : g, E[I + 4 >> 2] = A ? 0 : C)), A;
                                    }
                                    function TI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? !!(B | Q) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 2) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function $I(A) {
                                        var _$I = 0;
                                        return E[32 + (A |= 0) >> 2] = 0, E[A + 36 >> 2] = 0, _$I = E[8601], E[A >> 2] = E[8600], E[A + 4 >> 2] = _$I, _$I = E[8603], E[A + 8 >> 2] = E[8602], E[A + 12 >> 2] = _$I, _$I = E[8605], E[A + 16 >> 2] = E[8604], E[A + 20 >> 2] = _$I, _$I = E[8607], E[A + 24 >> 2] = E[8606], E[A + 28 >> 2] = _$I, 0;
                                    }
                                    function Ag(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0;
                                        return h = o = h + -64 | 0, a = -1, (E = g >>> 0 < 16) & !C || gI(_ = o + 32 | 0, i, Q) || yA(o, 35584, _, 0) || (a = hI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o - -64 | 0, a;
                                    }
                                    function Ig(A, I, g, C) {
                                        var _$B, Q, i, o, E = 0, a = 0;
                                        return o = c(E = g >>> 16 | 0, a = A >>> 16 | 0), E = (65535 & (a = ((i = c(_$B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, _$B) | 0)) + c(E, Q) | 0, w = (c(I, g) + o | 0) + c(A, C) + (a >>> 16) + (E >>> 16) | 0, 65535 & i | E << 16;
                                    }
                                    function gg(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0;
                                        if (a = C, !(1 == (((a = (_ = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | _ >>> 6))) | 0) & i >>> 0 > (_ = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1)) return 0 | pB[E[8928]](A, I, g, C, B, i, o);
                                        yC(), Q();
                                    }
                                    function Cg(A, I, g) {
                                        var C = 0, _$B = 0;
                                        if (!g) return 0;
                                        if (C = a[0 | A]) A: {
                                            for(;;){
                                                if ((0 | (_$B = a[0 | I])) != (0 | C) | !_$B) break A;
                                                if (!(g = g - 1 | 0)) break A;
                                                if (I = I + 1 | 0, C = a[A + 1 | 0], A = A + 1 | 0, !C) break;
                                            }
                                            C = 0;
                                        }
                                        else C = 0;
                                        return C - a[0 | I] | 0;
                                    }
                                    function Bg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = wI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function Qg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = RI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function ig(A, I, g, C, B, i, o) {
                                        var E;
                                        if (h = E = h + -64 | 0, !C & g >>> 0 < 4294967280) return gI(E + 32 | 0, o, i) ? o = -1 : (o = -1, yA(E, 35584, E + 32 | 0, 0) || (o = rI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32))), h = E - -64 | 0, o;
                                        yC(), Q();
                                    }
                                    function og(A, I) {
                                        for(var g = 0, C = 0, _$B = 0, Q = 0, i = 0; C = A + _$B | 0, g = a[I + _$B | 0] + (a[0 | C] + g | 0) | 0, o[0 | C] = g, Q = (C = 1 | _$B) + A | 0, g = a[I + C | 0] + (a[0 | Q] + (g >>> 8 | 0) | 0) | 0, o[0 | Q] = g, g = g >>> 8 | 0, _$B = _$B + 2 | 0, 32 != (0 | (i = i + 2 | 0)););
                                    }
                                    function Eg(A, I) {
                                        for(var g = 0, C = 0, _$B = 0, Q = 0, i = 0; g = (a[0 | (C = A + _$B | 0)] - a[I + _$B | 0] | 0) + g | 0, o[0 | C] = g, g = (a[0 | (Q = (C = 1 | _$B) + A | 0)] - a[I + C | 0] | 0) + (g >> 8) | 0, o[0 | Q] = g, g >>= 8, _$B = _$B + 2 | 0, 64 != (0 | (i = i + 2 | 0)););
                                    }
                                    function ag(A, I) {
                                        A |= 0;
                                        var g, C = 0, _$B = 0, Q = 0;
                                        if (h = g = h - 16 | 0, I |= 0) for(; o[g + 15 | 0] = 0, _$B = A + C | 0, Q = 0 | r(36800, g + 15 | 0, 0), o[0 | _$B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        h = g + 16 | 0;
                                    }
                                    function _g(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0;
                                        return h = o = h - 32 | 0, a = -1, (E = g >>> 0 < 16) & !C || cC(o, Q, i) || (a = yI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o + 32 | 0, a;
                                    }
                                    function cg(A) {
                                        var _$I, g;
                                        return (A = (_$I = E[8924]) + (g = A + 7 & -8) | 0) >>> 0 <= _$I >>> 0 && g || A >>> 0 > wB() << 16 >>> 0 && !(0 | s(0 | A)) ? (E[9392] = 48, -1) : (E[8924] = A, _$I);
                                    }
                                    function tg(A, I) {
                                        var g, C, _$B;
                                        h = g = h - 176 | 0, vA(C = g + 96 | 0, I + 80 | 0), Y(_$B = g + 48 | 0, I, C), Y(g, I + 40 | 0, C), BI(A, g), BI(g + 144 | 0, _$B), o[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, h = g + 176 | 0;
                                    }
                                    function rg(A, I, g, C, B, Q, i, o, E, a) {
                                        var _, c, t = 0, r = 0, e = 0;
                                        return h = _ = h - 16 | 0, t = -1, _C(c = _ + 4 | 0) || (r = -1, e = _A(c, A, I, g, C, B, Q, i, o, E, a), t = vg(c) ? r : e), h = _ + 16 | 0, t;
                                    }
                                    function eg(A, I, g, C, B, i, o, a, _, c, t, r) {
                                        return g && (E[g >> 2] = 32, E[g + 4 >> 2] = 0), !_ & a >>> 0 < 4294967264 & !i & B >>> 0 <= 4294967263 || (yC(), Q()), 0 | pB[E[r >> 2]](A, I, 32, C, B, o, a, c, t);
                                    }
                                    function yg(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return Sg(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, o[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function sg(A, I, g, C, B, i, o) {
                                        var E, a = 0;
                                        if (h = E = h - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, cC(E, i, o) || (a = eI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32)), h = E + 32 | 0, a;
                                        yC(), Q();
                                    }
                                    function hg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? yI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function Dg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? hI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function pg(A, I, g, C, B, Q, i, o, a, _, c) {
                                        return !C & g >>> 0 > 4294967263 | C | !o & i >>> 0 > 4294967263 | o ? -1 : 0 | pB[E[c >> 2]](A, I, g, B, 32, Q, i, a, _);
                                    }
                                    function wg(A, I, g) {
                                        A |= 0;
                                        var C, _$B = 0;
                                        return h = C = h - 32 | 0, _$B = -1, gI(C, g |= 0, I |= 0) || (_$B = fA(A, 35664, C, 0)), h = C + 32 | 0, 0 | _$B;
                                    }
                                    function fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h + -64 | 0, z(A |= 0, g), nA(A = A + 208 | 0, g, 64, 0), z(A, I), XC(g, 64), h = g - -64 | 0, 0;
                                    }
                                    function ng(A, I, g, C) {
                                        var _$B;
                                        return I |= 0, g |= 0, C |= 0, h = _$B = h + -64 | 0, z(A |= 0, _$B), A = n(I, g, _$B, 64, 0, C, 1), h = _$B - -64 | 0, 0 | A;
                                    }
                                    function kg(A, I) {
                                        var g, C, _$B;
                                        Y(A, I, g = I + 120 | 0), Y(A + 40 | 0, C = I + 40 | 0, _$B = I + 80 | 0), Y(A + 80 | 0, _$B, g), Y(A + 120 | 0, I, C);
                                    }
                                    function Fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h - 32 | 0, dA(A |= 0, g), MA(A = A + 104 | 0, g, 32, 0), dA(A, I), XC(g, 32), h = g + 32 | 0, 0;
                                    }
                                    function Ng(A, I, g, C, B, Q, i) {
                                        return 0 | TI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                    }
                                    function Sg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Gg(A, I, g, C, B, Q) {
                                        var i;
                                        return h = i = h - 32 | 0, fA(i, B, Q, 0), A = oC(A, I, g, C, B + 16 | 0, 0, 0, i), XC(i, 32), h = i + 32 | 0, A;
                                    }
                                    function Mg(A) {
                                        for(A |= 0; ag(A, 32), o[A + 31 | 0] = 31 & a[A + 31 | 0], !ZI(A) || NI(A, 32););
                                    }
                                    function bg(A, I, g) {
                                        var C;
                                        return I |= 0, g |= 0, h = C = h + -64 | 0, z(A |= 0, C), A = H(I, C, 64, 0, g, 1), h = C - -64 | 0, 0 | A;
                                    }
                                    function Kg(A, I, g, C, B) {
                                        var Q;
                                        return h = Q = h - 32 | 0, fA(Q, C, B, 0), A = pC(A, I, g, C + 16 | 0, Q), XC(Q, 32), h = Q + 32 | 0, A;
                                    }
                                    function Hg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Yg(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (e(1349, 1262, 107, 1123), Q()), 0 | $(A, I, 255 & g);
                                    }
                                    function dg(A, I, g, C, B, Q, i) {
                                        return 0 | eI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Jg(A, I, g, C, B, Q, i) {
                                        return 0 | yI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Ug(A, I, g, C, B, i, o, a) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, i, o, a);
                                    }
                                    function lg(A, I, g, C, B, Q, i) {
                                        return 0 | rI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function mg(A, I, g, C, B, Q, i) {
                                        return 0 | hI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function ug(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, 0, 0, i);
                                    }
                                    function xg(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8928]](A, I, g, C, B, 0, i);
                                    }
                                    function Rg(A, I, g, C, B, Q) {
                                        return n(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                    }
                                    function vg(A) {
                                        var _$I;
                                        return (_$I = E[A >> 2]) && gA(_$I), E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function Lg(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function Pg(A, I, g, C, B, Q) {
                                        return 0 | RI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function qg(A, I, g, C, B, Q) {
                                        return 0 | wI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function zg(A, I, g, C, B, Q) {
                                        return 0 | Gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function jg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8925]](A, I, g, C, B);
                                    }
                                    function Xg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8926]](A, I, g, C, B);
                                    }
                                    function Og(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), pB[E[8928]](A, I, g, C, B, 1, i);
                                    }
                                    function Vg(A, I, g, C, B) {
                                        return 0 | H(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                    }
                                    function Zg(A, I, g, C, B) {
                                        return 0 | hC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Wg(A, I, g, C, B) {
                                        return 0 | DC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Tg(A, I, g, C, B) {
                                        return 0 | Kg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function $g() {
                                        var _$A;
                                        h = _$A = h - 16 | 0, o[_$A + 15 | 0] = 0, r(36836, _$A + 15 | 0, 0), h = _$A + 16 | 0;
                                    }
                                    function AC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 20), 0;
                                    }
                                    function IC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 12), 0;
                                    }
                                    function gC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 8), 0;
                                    }
                                    function CC(A, I, g, C) {
                                        return 0 | kI(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function BC(A, I, g, C) {
                                        return 0 | NC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function QC(A, I, g, C) {
                                        return 0 | nA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function iC(A, I, g, C) {
                                        return 0 | eA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function oC(A, I, g, C, B, Q, i, o) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, Q, i, o);
                                    }
                                    function EC(A, I, g, C) {
                                        return 0 | dC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function aC(A, I, g, C, B, Q) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function _C(A) {
                                        return E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function cC(A, I, g) {
                                        return 0 | wg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function tC(A, I, g) {
                                        return 0 | gI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function rC(A, I, g) {
                                        return 0 | Yg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function eC(A, I, g) {
                                        return 0 | QI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function yC() {
                                        var _$A;
                                        (_$A = E[9526]) && pB[0 | _$A](), y(), Q();
                                    }
                                    function sC(A, I) {
                                        return A |= 0, ag(I |= 0, 32), 0 | wC(A, I);
                                    }
                                    function hC(A, I, g, C, B) {
                                        return 0 | pB[E[8929]](A, I, g, C, B);
                                    }
                                    function DC(A, I, g, C, B) {
                                        return 0 | pB[E[8930]](A, I, g, C, B);
                                    }
                                    function pC(A, I, g, C, B) {
                                        return 0 | pB[E[8936]](A, I, g, C, B);
                                    }
                                    function wC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8935]](A, I);
                                    }
                                    function fC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8931]](A, I);
                                    }
                                    function nC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8933]](A, I);
                                    }
                                    function kC(A, I, g, C, B, Q, i) {
                                        return lA(A, I, g, C, B, Q, i);
                                    }
                                    function FC(A) {
                                        return A ? 31 - t(A - 1 ^ A) | 0 : 32;
                                    }
                                    function NC(A, I, g, C) {
                                        return 0 | pB[E[8932]](A, I, g, C);
                                    }
                                    function SC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 32);
                                    }
                                    function GC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 64);
                                    }
                                    function MC(A, I, g) {
                                        k(A |= 0, I |= 0, g |= 0);
                                    }
                                    function bC(A, I) {
                                        return 0 | wC(A |= 0, I |= 0);
                                    }
                                    function KC(A, I) {
                                        return 0 | sC(A |= 0, I |= 0);
                                    }
                                    function HC(A, I, g, C) {
                                        return CI(A, I, g, C, 2);
                                    }
                                    function YC(A, I, g, C) {
                                        return MA(A, I, g, C), 0;
                                    }
                                    function dC(A, I, g, C) {
                                        return nA(A, I, g, C), 0;
                                    }
                                    function JC(A, I, g, C) {
                                        return CI(A, I, g, C, 1);
                                    }
                                    function UC(A, I, g, C) {
                                        return nI(A, I, g, C, 1);
                                    }
                                    function lC(A, I, g, C) {
                                        return nI(A, I, g, C, 2);
                                    }
                                    function mC(A, I, g, C) {
                                        return XA(A, I, g, C);
                                    }
                                    function uC(A) {
                                        return SI(A |= 0), 0;
                                    }
                                    function xC() {
                                        return 1073741824;
                                    }
                                    function RC() {
                                        return -2147483648;
                                    }
                                    function vC() {
                                        return 268435456;
                                    }
                                    function LC(A) {
                                        ag(A |= 0, 32);
                                    }
                                    function PC() {
                                        return 67108864;
                                    }
                                    function qC(A) {
                                        ag(A |= 0, 16);
                                    }
                                    function zC() {
                                        return 16777216;
                                    }
                                    function jC() {
                                        return 33554432;
                                    }
                                    function XC(A, I) {
                                        Hg(A, 0, I);
                                    }
                                    function OC() {
                                        return 1559;
                                    }
                                    function VC() {
                                        return 1321;
                                    }
                                    function ZC() {
                                        return 8192;
                                    }
                                    function WC() {
                                        return 384;
                                    }
                                    function TC() {
                                        return 416;
                                    }
                                    function $C() {
                                        return 256;
                                    }
                                    function AB() {
                                        return 128;
                                    }
                                    function IB() {
                                        return 208;
                                    }
                                    function gB() {
                                        return 64;
                                    }
                                    function CB() {
                                        return 16;
                                    }
                                    function BB() {
                                        return 32;
                                    }
                                    function QB() {
                                        return 12;
                                    }
                                    function iB() {
                                        return -65;
                                    }
                                    function oB() {
                                        return -17;
                                    }
                                    function EB() {
                                        return 48;
                                    }
                                    function aB() {
                                        return -33;
                                    }
                                    function _B() {
                                        return 24;
                                    }
                                    function cB() {
                                        return 4;
                                    }
                                    function tB() {
                                        return -1;
                                    }
                                    function rB() {
                                        return 1;
                                    }
                                    function eB() {
                                        return 2;
                                    }
                                    function yB() {
                                        return 3;
                                    }
                                    function sB() {
                                        return 8;
                                    }
                                    function hB() {
                                        return 0;
                                    }
                                    B(_$I = a, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAJGFyZ29uMmkAJGFyZ29uMmlkAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAeDI1NTE5Ymxha2UyYgBidWZfbGVuIDw9IFNJWkVfTUFYAG91dGxlbiA8PSBVSU5UOF9NQVgAUy0+YnVmbGVuIDw9IEJMQUtFMkJfQkxPQ0tCWVRFUwAkYXJnb24yaSR2PQAkYXJnb24yaWQkdj0ALHQ9ACxwPQAkbT0AY3VydmUyNTUxOQBlZDI1NTE5ADEuMC4xOQBobWFjc2hhNTEyMjU2AGN1cnZlMjU1MTl4c2Fsc2EyMHBvbHkxMzA1AHNvZGl1bV9iaW4yYmFzZTY0AHNpcGhhc2gyNABzaGE1MTIAeHNhbHNhMjAAJGFyZ29uMmkkACRhcmdvbjJpZCQAJDckAExpYnNvZGl1bURSRw=="), B(_$I, 1600, "tnhZ/4Vy0wC9bhX/DwpqACnAAQCY6Hn/vDyg/5lxzv8At+L+tA1I/wAAAAAAAAAAsKAO/tPJhv+eGI8Af2k1AGAMvQCn1/v/n0yA/mpl4f8e/AQAkgyu"), B(_$I, 1696, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(_$I, 1744, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(_$I, 2736, "AQ=="), B(_$I, 2768, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(_$I, 2959, "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"), B(_$I, 33980, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), B(_$I, 34032, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), B(_$I, 34160, "AQ=="), B(_$I, 34192, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(_$I, 34383, "EA=="), B(_$I, 34400, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(_$I, 34752, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(_$I, 35600, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(_$I, 35696, "4JQBAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0="), B(_$I, 35760, "xmNjpfh8fITud3eZ9nt7jf/y8g3Wa2u93m9vsZHFxVRgMDBQAgEBA85nZ6lWKyt95/7+GbXX12JNq6vm7HZ2mo/KykUfgoKdicnJQPp9fYfv+voVsllZ645HR8n78PALQa2t7LPU1GdfoqL9Ra+v6iOcnL9TpKT35HJylpvAwFt1t7fC4f39HD2Tk65MJiZqbDY2Wn4/P0H19/cCg8zMT2g0NFxRpaX00eXlNPnx8QjicXGTq9jYc2IxMVMqFRU/CAQEDJXHx1JGIyNlncPDXjAYGCg3lpahCgUFDy+amrUOBwcJJBISNhuAgJvf4uI9zevrJk4nJ2l/srLN6nV1nxIJCRsdg4OeWCwsdDQaGi42Gxst3G5usrRaWu5boKD7pFJS9nY7O0231tZhfbOzzlIpKXvd4+M+Xi8vcROEhJemU1P1udHRaAAAAADB7e0sQCAgYOP8/B95sbHItltb7dRqar6Ny8tGZ76+2XI5OUuUSkremExM1LBYWOiFz89Ku9DQa8Xv7ypPqqrl7fv7FoZDQ8WaTU3XZjMzVRGFhZSKRUXP6fn5EAQCAgb+f3+BoFBQ8Hg8PEQln5+6S6io46JRUfNdo6P+gEBAwAWPj4o/kpKtIZ2dvHA4OEjx9fUEY7y833e2tsGv2tp1QiEhYyAQEDDl//8a/fPzDr/S0m2Bzc1MGAwMFCYTEzXD7Owvvl9f4TWXl6KIRETMLhcXOZPExFdVp6fy/H5+gno9PUfIZGSsul1d5zIZGSvmc3OVwGBgoBmBgZieT0/Ro9zcf0QiImZUKip+O5CQqwuIiIOMRkbKx+7uKWu4uNMoFBQ8p97eebxeXuIWCwsdrdvbdtvg4DtkMjJWdDo6ThQKCh6SSUnbDAYGCkgkJGy4XFzkn8LCXb3T025DrKzvxGJipjmRkagxlZWk0+TkN/J5eYvV5+cyi8jIQ243N1nabW23AY2NjLHV1WScTk7SSamp4NhsbLSsVlb68/T0B8/q6iXKZWWv9Hp6jkeurukQCAgYb7q61fB4eIhKJSVvXC4ucjgcHCRXpqbxc7S0x5fGxlHL6Ogjod3dfOh0dJw+Hx8hlktL3WG9vdwNi4uGD4qKheBwcJB8Pj5CcbW1xMxmZqqQSEjYBgMDBff29gEcDg4SwmFho2o1NV+uV1f5abm50BeGhpGZwcFYOh0dJyeenrnZ4eE46/j4EyuYmLMiEREz0mlpu6nZ2XAHjo6JM5SUpy2bm7Y8Hh4iFYeHksnp6SCHzs5JqlVV/1AoKHil3996A4yMj1mhofgJiYmAGg0NF2W/v9rX5uYxhEJCxtBoaLiCQUHDKZmZsFotLXceDw8Re7Cwy6hUVPxtu7vWLBYWOg4AAAAPAAAAEAAAABE=");
                                    var DB, pB = (DB = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o) {
                                            var _;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, h = _ = h + -64 | 0, (g |= 0) | (C |= 0) && (E[_ + 8 >> 2] = 2036477234, E[_ + 12 >> 2] = 1797285236, E[_ >> 2] = 1634760805, E[_ + 4 >> 2] = 857760878, E[_ + 16 >> 2] = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, E[_ + 20 >> 2] = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, E[_ + 24 >> 2] = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, E[_ + 28 >> 2] = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, E[_ + 32 >> 2] = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, E[_ + 36 >> 2] = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, E[_ + 40 >> 2] = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[_ + 44 >> 2] = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, E[_ + 48 >> 2] = Q, E[_ + 52 >> 2] = i, E[_ + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[_ + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, q(_, I, A, g, C), XC(_, 64)), h = _ - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var o;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, h = o = h + -64 | 0, (g |= 0) | (C |= 0) && (E[o + 8 >> 2] = 2036477234, E[o + 12 >> 2] = 1797285236, E[o >> 2] = 1634760805, E[o + 4 >> 2] = 857760878, E[o + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, E[o + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, E[o + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, E[o + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, E[o + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, E[o + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, E[o + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, E[o + 48 >> 2] = Q, E[o + 44 >> 2] = i, E[o + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[o + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[o + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, q(o, I, A, g, C), XC(o, 64)), h = o - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 128 & -64, E[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 20 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 16 >> 2] = _ >>> 8 & 1048575, E[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 80 | 0] = 0, E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = B, uA(Q, I, g, C), II(Q, A), h = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 192 & -64, E[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 84 >> 2] = 0, E[Q + 88 >> 2] = 0, E[Q + 92 >> 2] = 0, E[Q + 96 >> 2] = 0, E[Q + 100 >> 2] = 0, E[Q + 80 >> 2] = _ >>> 8 & 1048575, E[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 144 | 0] = 0, E[Q + 120 >> 2] = 0, E[Q + 124 >> 2] = 0, E[Q + 116 >> 2] = B, uA(B = Q - -64 | 0, I, g, C), II(B, I = Q + 48 | 0), A = iI(A, I), h = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, E[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, E[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, E[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 16 >> 2] = g >>> 8 & 1048575, E[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[A + 80 | 0] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return uA(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return II(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, _$B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, IA = 0, _$gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0, _$yA = 0, sA = 0, hA = 0, DA = 0, _$wA = 0, _$fA = 0, nA = 0, kA = 0;
                                            for(h = C = h - 368 | 0; D = (i = a[g + _$B | 0]) ^ a[0 | (c = _$B + 34128 | 0)] | D, s = i ^ a[c + 192 | 0] | s, y = i ^ a[c + 160 | 0] | y, e = i ^ a[c + 128 | 0] | e, _ = i ^ a[c + 96 | 0] | _, t = i ^ a[c - -64 | 0] | t, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (_$B = _$B + 1 | 0)););
                                            if (_$B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | s)) - 1 | (255 & (i | y)) - 1 | (255 & (i | e)) - 1 | (255 & (87 ^ c | _)) - 1 | (255 & (t | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | D)) - 1))) {
                                                for(_$B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 360 >> 2] = a[_$B + 24 | 0] | a[_$B + 25 | 0] << 8 | a[_$B + 26 | 0] << 16 | a[_$B + 27 | 0] << 24, E[C + 364 >> 2] = I, I = a[_$B + 20 | 0] | a[_$B + 21 | 0] << 8 | a[_$B + 22 | 0] << 16 | a[_$B + 23 | 0] << 24, E[C + 352 >> 2] = a[_$B + 16 | 0] | a[_$B + 17 | 0] << 8 | a[_$B + 18 | 0] << 16 | a[_$B + 19 | 0] << 24, E[C + 356 >> 2] = I, Q = a[_$B + 4 | 0] | a[_$B + 5 | 0] << 8 | a[_$B + 6 | 0] << 16 | a[_$B + 7 | 0] << 24, I = a[0 | _$B] | a[_$B + 1 | 0] << 8 | a[_$B + 2 | 0] << 16 | a[_$B + 3 | 0] << 24, E[C + 336 >> 2] = I, E[C + 340 >> 2] = Q, Q = a[_$B + 12 | 0] | a[_$B + 13 | 0] << 8 | a[_$B + 14 | 0] << 16 | a[_$B + 15 | 0] << 24, E[C + 344 >> 2] = a[_$B + 8 | 0] | a[_$B + 9 | 0] << 8 | a[_$B + 10 | 0] << 16 | a[_$B + 11 | 0] << 24, E[C + 348 >> 2] = Q, o[C + 336 | 0] = 248 & I, o[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, pA(C + 288 | 0, g), E[C + 260 >> 2] = 0, E[C + 264 >> 2] = 0, E[C + 268 >> 2] = 0, E[C + 272 >> 2] = 0, E[C + 276 >> 2] = 0, E[C + 208 >> 2] = 0, E[C + 212 >> 2] = 0, E[C + 216 >> 2] = 0, E[C + 220 >> 2] = 0, E[C + 224 >> 2] = 0, E[C + 228 >> 2] = 0, I = E[C + 308 >> 2], E[C + 160 >> 2] = E[C + 304 >> 2], E[C + 164 >> 2] = I, I = E[C + 316 >> 2], E[C + 168 >> 2] = E[C + 312 >> 2], E[C + 172 >> 2] = I, I = E[C + 324 >> 2], E[C + 176 >> 2] = E[C + 320 >> 2], E[C + 180 >> 2] = I, E[C + 244 >> 2] = 0, E[C + 248 >> 2] = 0, E[C + 240 >> 2] = 1, E[C + 252 >> 2] = 0, E[C + 256 >> 2] = 0, E[C + 192 >> 2] = 0, E[C + 196 >> 2] = 0, E[C + 200 >> 2] = 0, E[C + 204 >> 2] = 0, I = E[C + 292 >> 2], E[C + 144 >> 2] = E[C + 288 >> 2], E[C + 148 >> 2] = I, I = E[C + 300 >> 2], E[C + 152 >> 2] = E[C + 296 >> 2], E[C + 156 >> 2] = I, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 96 >> 2] = 1, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, g = 254; _$W = E[C + 276 >> 2], i = E[C + 180 >> 2], T = E[C + 96 >> 2], $ = E[C + 192 >> 2], _$AA = E[C + 144 >> 2], IA = E[C + 240 >> 2], _$gA = E[C + 100 >> 2], CA = E[C + 196 >> 2], BA = E[C + 148 >> 2], QA = E[C + 244 >> 2], _$K = E[C + 104 >> 2], iA = E[C + 200 >> 2], _$H = E[C + 152 >> 2], oA = E[C + 248 >> 2], _$U = E[C + 108 >> 2], EA = E[C + 204 >> 2], l = E[C + 156 >> 2], aA = E[C + 252 >> 2], _$d = E[C + 112 >> 2], _A = E[C + 208 >> 2], M = E[C + 160 >> 2], _$cA = E[C + 256 >> 2], D = E[C + 116 >> 2], tA = E[C + 212 >> 2], r = E[C + 164 >> 2], rA = E[C + 260 >> 2], s = E[C + 120 >> 2], _$eA = E[C + 216 >> 2], y = E[C + 168 >> 2], _$yA = E[C + 264 >> 2], e = E[C + 124 >> 2], sA = E[C + 220 >> 2], _ = E[C + 172 >> 2], hA = E[C + 268 >> 2], t = E[C + 128 >> 2], DA = E[C + 224 >> 2], Q = E[C + 176 >> 2], G = E[C + 272 >> 2], _$wA = g, b = (F = (I = 0 - ((I = Z) ^ (Z = a[(_$fA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((_$B = E[C + 132 >> 2]) ^ (j = E[C + 228 >> 2]))) ^ _$B, E[C + 132 >> 2] = b, _$X = i ^ (_$N = I & (i ^ _$W)), E[C + 84 >> 2] = _$X - b, J = t ^ (f = I & (t ^ DA)), E[C + 128 >> 2] = J, O = (S = I & (Q ^ G)) ^ Q, E[C + 80 >> 2] = O - J, u = e ^ (n = I & (e ^ sA)), E[C + 124 >> 2] = u, nA = _ ^ (k = I & (_ ^ hA)), E[C + 76 >> 2] = nA - u, x = s ^ (p = I & (s ^ _$eA)), E[C + 120 >> 2] = x, kA = y ^ (c = I & (y ^ _$yA)), E[C + 72 >> 2] = kA - x, R = D ^ (i = I & (D ^ tA)), E[C + 116 >> 2] = R, L = r ^ (D = I & (r ^ rA)), E[C + 68 >> 2] = L - R, P = _$d ^ (s = I & (_$d ^ _A)), E[C + 112 >> 2] = P, _$m = M ^ (y = I & (M ^ _$cA)), E[C + 64 >> 2] = _$m - P, q = _$U ^ (e = I & (_$U ^ EA)), E[C + 108 >> 2] = q, V = l ^ (_ = I & (l ^ aA)), E[C + 60 >> 2] = V - q, _$z = _$K ^ (t = I & (_$K ^ iA)), E[C + 104 >> 2] = _$z, _$U = _$H ^ (Q = I & (_$H ^ oA)), E[C + 56 >> 2] = _$U - _$z, _$K = _$gA ^ (_$B = I & (_$gA ^ CA)), E[C + 100 >> 2] = _$K, l = BA ^ (g = I & (BA ^ QA)), E[C + 52 >> 2] = l - _$K, _$H = T ^ (_$d = I & (T ^ $)), E[C + 96 >> 2] = _$H, M = (I &= _$AA ^ IA) ^ _$AA, E[C + 48 >> 2] = M - _$H, r = _$N ^ _$W, F ^= j, E[C + 36 >> 2] = r - F, _$N = S ^ G, f ^= DA, E[C + 32 >> 2] = _$N - f, S = k ^ hA, n ^= sA, E[C + 28 >> 2] = S - n, k = c ^ _$yA, p ^= _$eA, E[C + 24 >> 2] = k - p, c = D ^ rA, i ^= tA, E[C + 20 >> 2] = c - i, D = y ^ _$cA, s ^= _A, E[C + 16 >> 2] = D - s, y = _ ^ aA, e ^= EA, E[C + 12 >> 2] = y - e, _ = Q ^ oA, t ^= iA, E[C + 8 >> 2] = _ - t, Q = g ^ QA, _$B ^= CA, E[C + 4 >> 2] = Q - _$B, g = I ^ IA, I = _$d ^ $, E[C >> 2] = g - I, E[C + 276 >> 2] = r + F, E[C + 272 >> 2] = _$N + f, E[C + 268 >> 2] = n + S, E[C + 264 >> 2] = p + k, E[C + 260 >> 2] = i + c, E[C + 256 >> 2] = s + D, E[C + 248 >> 2] = _ + t, E[C + 244 >> 2] = _$B + Q, E[C + 240 >> 2] = I + g, E[C + 252 >> 2] = e + y, E[C + 228 >> 2] = b + _$X, E[C + 224 >> 2] = J + O, E[C + 220 >> 2] = u + nA, E[C + 216 >> 2] = x + kA, E[C + 212 >> 2] = R + L, E[C + 208 >> 2] = _$m + P, E[C + 204 >> 2] = q + V, E[C + 200 >> 2] = _$U + _$z, E[C + 196 >> 2] = _$K + l, E[C + 192 >> 2] = M + _$H, Y(_$X = C + 96 | 0, J = C + 48 | 0, b = C + 240 | 0), Y(G = C + 192 | 0, G, C), v(J, C), v(C, b), r = E[C + 192 >> 2], F = E[C + 96 >> 2], _$N = E[C + 196 >> 2], f = E[C + 100 >> 2], S = E[C + 200 >> 2], n = E[C + 104 >> 2], k = E[C + 204 >> 2], p = E[C + 108 >> 2], c = E[C + 208 >> 2], i = E[C + 112 >> 2], D = E[C + 212 >> 2], s = E[C + 116 >> 2], y = E[C + 216 >> 2], e = E[C + 120 >> 2], _ = E[C + 220 >> 2], t = E[C + 124 >> 2], Q = E[C + 224 >> 2], _$B = E[C + 128 >> 2], g = E[C + 228 >> 2], I = E[C + 132 >> 2], E[C + 180 >> 2] = g + I, E[C + 176 >> 2] = _$B + Q, E[C + 172 >> 2] = _ + t, E[C + 168 >> 2] = e + y, E[C + 164 >> 2] = s + D, E[C + 160 >> 2] = i + c, E[C + 156 >> 2] = p + k, E[C + 152 >> 2] = n + S, E[C + 148 >> 2] = _$N + f, E[C + 144 >> 2] = r + F, E[C + 228 >> 2] = I - g, E[C + 224 >> 2] = _$B - Q, E[C + 220 >> 2] = t - _, E[C + 216 >> 2] = e - y, E[C + 212 >> 2] = s - D, E[C + 208 >> 2] = i - c, E[C + 204 >> 2] = p - k, E[C + 200 >> 2] = n - S, E[C + 196 >> 2] = f - _$N, E[C + 192 >> 2] = F - r, Y(b, C, J), u = E[C + 52 >> 2], p = E[C + 4 >> 2], x = E[C + 56 >> 2], c = E[C + 8 >> 2], R = E[C + 64 >> 2], y = E[C + 16 >> 2], P = E[C + 60 >> 2], e = E[C + 12 >> 2], q = E[C + 72 >> 2], _ = E[C + 24 >> 2], _$z = E[C + 68 >> 2], t = E[C + 20 >> 2], _$K = E[C + 80 >> 2], Q = E[C + 32 >> 2], _$H = E[C + 76 >> 2], _$B = E[C + 28 >> 2], j = E[C + 84 >> 2], I = E[C + 36 >> 2], O = E[C + 48 >> 2], g = E[C >> 2] - O | 0, E[C >> 2] = g, I = I - j | 0, E[C + 36 >> 2] = I, _$d = _$B - _$H | 0, E[C + 28 >> 2] = _$d, M = Q - _$K | 0, E[C + 32 >> 2] = M, i = t - _$z | 0, E[C + 20 >> 2] = i, D = _ - q | 0, E[C + 24 >> 2] = D, s = e - P | 0, E[C + 12 >> 2] = s, y = y - R | 0, E[C + 16 >> 2] = y, e = c - x | 0, E[C + 8 >> 2] = e, Q = p - u | 0, E[C + 4 >> 2] = Q, v(G, G), I = Ig(I, I >> 31, 121666, 0), _$B = w, V = I, I = Ig((33554431 & (_$B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? _$B + 1 | 0 : _$B)) << 7 | r >>> 25, _$B >> 25, 19, 0), t = w, _$B = I, I = Ig(g, g >> 31, 121666, 0), _$m = w + t | 0, I = I >>> 0 > (_$B = _$B + I | 0) >>> 0 ? _$m + 1 | 0 : _$m, g = (_ = _$B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, F = _$B - (-67108864 & _) | 0, E[C + 96 >> 2] = F, t = Ig(Q, Q >> 31, 121666, 0), _$B = w, _$B = (Q = t + 16777216 | 0) >>> 0 < 16777216 ? _$B + 1 | 0 : _$B, _$N = (t - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | _ >>> 26) | 0, E[C + 100 >> 2] = _$N, _$m = (I = _$B) >> 25, _$B = (33554431 & I) << 7 | Q >>> 25, g = Ig(e, e >> 31, 121666, 0) + _$B | 0, I = _$m + w | 0, I = g >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, t = (f = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, S = g - (-67108864 & f) | 0, E[C + 104 >> 2] = S, _$B = Ig(y, y >> 31, 121666, 0), Q = w, g = Ig(s, s >> 31, 121666, 0), I = w, L = _$B, _$U = g, _$B = (33554431 & (I = (n = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | n >>> 25, I = (I >> 25) + Q | 0, I = (g = L + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, Q = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, E[C + 112 >> 2] = p, _$B = Ig(D, D >> 31, 121666, 0), _ = w, g = Ig(i, i >> 31, 121666, 0), I = w, L = _$B, l = g, _$B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + _ | 0, I = (g = L + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = g - (-67108864 & i) | 0, E[C + 120 >> 2] = D, _ = Ig(M, M >> 31, 121666, 0), e = w, g = Ig(_$d, _$d >> 31, 121666, 0), I = w, M = g, g = (33554431 & (I = (s = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | s >>> 25, I = (I >> 25) + e | 0, I = g >>> 0 > (_ = g + _ | 0) >>> 0 ? I + 1 | 0 : I, g = (y = _ + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, e = _ - (-67108864 & y) | 0, E[C + 128 >> 2] = e, _ = (t = _$U + ((67108863 & t) << 6 | f >>> 26) | 0) - (-33554432 & n) | 0, E[C + 108 >> 2] = _, t = (Q = l + ((67108863 & Q) << 6 | k >>> 26) | 0) - (-33554432 & c) | 0, E[C + 116 >> 2] = t, Q = (I = M + ((67108863 & _$B) << 6 | i >>> 26) | 0) - (-33554432 & s) | 0, E[C + 124 >> 2] = Q, g = (g = V + ((67108863 & g) << 6 | y >>> 26) | 0) - (-33554432 & r) | 0, E[C + 132 >> 2] = g, v(I = C + 144 | 0, I), E[C + 84 >> 2] = g + j, E[C + 80 >> 2] = e + _$K, E[C + 76 >> 2] = Q + _$H, E[C + 72 >> 2] = D + q, E[C + 68 >> 2] = t + _$z, E[C + 64 >> 2] = p + R, E[C + 60 >> 2] = _ + P, E[C + 56 >> 2] = S + x, E[C + 52 >> 2] = _$N + u, E[C + 48 >> 2] = F + O, g = _$wA - 1 | 0, Y(_$X, C + 288 | 0, G), Y(G, C, J), _$wA;);
                                                D = E[C + 144 >> 2], F = E[C + 240 >> 2], s = E[C + 148 >> 2], _$N = E[C + 244 >> 2], y = E[C + 152 >> 2], f = E[C + 248 >> 2], e = E[C + 156 >> 2], S = E[C + 252 >> 2], _ = E[C + 160 >> 2], n = E[C + 256 >> 2], t = E[C + 164 >> 2], k = E[C + 260 >> 2], Q = E[C + 168 >> 2], p = E[C + 264 >> 2], _$B = E[C + 172 >> 2], c = E[C + 268 >> 2], g = E[C + 176 >> 2], i = E[C + 272 >> 2], r = 0 - Z | 0, I = E[C + 276 >> 2], E[C + 276 >> 2] = r & (I ^ E[C + 180 >> 2]) ^ I, E[C + 272 >> 2] = i ^ r & (g ^ i), E[C + 268 >> 2] = c ^ r & (_$B ^ c), E[C + 264 >> 2] = p ^ r & (Q ^ p), E[C + 260 >> 2] = k ^ r & (t ^ k), E[C + 256 >> 2] = n ^ r & (_ ^ n), E[C + 252 >> 2] = S ^ r & (e ^ S), E[C + 248 >> 2] = f ^ r & (y ^ f), E[C + 244 >> 2] = _$N ^ r & (s ^ _$N), E[C + 240 >> 2] = F ^ r & (D ^ F), F = E[C + 192 >> 2], D = E[C + 96 >> 2], _$N = E[C + 196 >> 2], s = E[C + 100 >> 2], f = E[C + 200 >> 2], y = E[C + 104 >> 2], S = E[C + 204 >> 2], e = E[C + 108 >> 2], n = E[C + 208 >> 2], _ = E[C + 112 >> 2], k = E[C + 212 >> 2], t = E[C + 116 >> 2], p = E[C + 216 >> 2], Q = E[C + 120 >> 2], c = E[C + 220 >> 2], _$B = E[C + 124 >> 2], i = E[C + 224 >> 2], g = E[C + 128 >> 2], I = E[C + 228 >> 2], E[C + 228 >> 2] = r & (I ^ E[C + 132 >> 2]) ^ I, E[C + 224 >> 2] = i ^ r & (g ^ i), E[C + 220 >> 2] = c ^ r & (_$B ^ c), E[C + 216 >> 2] = p ^ r & (Q ^ p), E[C + 212 >> 2] = k ^ r & (t ^ k), E[C + 208 >> 2] = n ^ r & (_ ^ n), E[C + 204 >> 2] = S ^ r & (e ^ S), E[C + 200 >> 2] = f ^ r & (y ^ f), E[C + 196 >> 2] = _$N ^ r & (s ^ _$N), E[C + 192 >> 2] = F ^ r & (D ^ F), vA(G, G), Y(b, b, G), BI(A, b), XC(_$fA, 32), _$B = 0;
                                            }
                                            return h = C + 368 | 0, 0 | _$B;
                                        },
                                        function(A, I) {
                                            var g, C, _$B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, _$N;
                                            return I |= 0, h = g = h - 304 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], o[0 | A] = 248 & a[0 | A], o[A + 31 | 0] = 63 & I | 64, kA(g + 48 | 0, A), I = E[g + 132 >> 2], C = E[g + 92 >> 2], _$B = E[g + 136 >> 2], Q = E[g + 96 >> 2], i = E[g + 140 >> 2], _ = E[g + 100 >> 2], c = E[g + 144 >> 2], t = E[g + 104 >> 2], r = E[g + 148 >> 2], e = E[g + 108 >> 2], y = E[g + 152 >> 2], s = E[g + 112 >> 2], D = E[g + 156 >> 2], p = E[g + 116 >> 2], w = E[g + 160 >> 2], f = E[g + 120 >> 2], n = E[g + 128 >> 2], k = E[g + 88 >> 2], F = E[g + 124 >> 2], _$N = E[g + 164 >> 2], E[g + 292 >> 2] = F + _$N, E[g + 288 >> 2] = w + f, E[g + 284 >> 2] = D + p, E[g + 280 >> 2] = y + s, E[g + 276 >> 2] = r + e, E[g + 272 >> 2] = c + t, E[g + 268 >> 2] = i + _, E[g + 264 >> 2] = _$B + Q, E[g + 260 >> 2] = I + C, E[g + 256 >> 2] = n + k, E[g + 244 >> 2] = _$N - F, E[g + 240 >> 2] = w - f, E[g + 236 >> 2] = D - p, E[g + 232 >> 2] = y - s, E[g + 228 >> 2] = r - e, E[g + 224 >> 2] = c - t, E[g + 220 >> 2] = i - _, E[g + 216 >> 2] = _$B - Q, E[g + 212 >> 2] = I - C, E[g + 208 >> 2] = n - k, vA(I = g + 208 | 0, I), Y(g, g + 256 | 0, I), BI(A, g), h = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = B, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; AC(A, Q + 96 | 0, Q, 0), C = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, o[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, o[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, o[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, o[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, o[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, o[Q + 110 | 0] = C, o[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, AC(Q + 32 | 0, Q + 96 | 0, Q, 0), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; _ = c = Q + 32 | 0, o[A + B | 0] = a[_ + B | 0], o[(t = 1 | B) + A | 0] = a[_ + t | 0], o[(_ = 2 | B) + A | 0] = a[_ + c | 0], o[(_ = 3 | B) + A | 0] = a[_ + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; o[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, _) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, _ |= 0;
                                            var c, t = 0;
                                            if (h = c = h - 112 | 0, (g |= 0) | (C |= 0)) {
                                                t = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, E[c + 24 >> 2] = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, E[c + 28 >> 2] = t, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[c + 16 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[c + 20 >> 2] = t, t = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E[c >> 2] = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, E[c + 4 >> 2] = t, t = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, E[c + 8 >> 2] = a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, E[c + 12 >> 2] = t, _ = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[c + 100 >> 2] = _, o[c + 104 | 0] = Q, o[c + 111 | 0] = i >>> 24, o[c + 110 | 0] = i >>> 16, o[c + 109 | 0] = i >>> 8, o[c + 108 | 0] = i, o[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, o[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, o[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0); Q = c + 32 | 0, o[A + _ | 0] = a[Q + _ | 0] ^ a[I + _ | 0], o[(B = 1 | _) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (_ = _ + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, o[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, o[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, o[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, o[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, o[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, o[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, o[c + 110 | 0] = B, o[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, o[A + _ | 0] = a[i + _ | 0] ^ a[I + _ | 0], o[(g = 1 | _) + A | 0] = a[g + i | 0] ^ a[I + g | 0], _ = _ + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (o[A + _ | 0] = a[(c + 32 | 0) + _ | 0] ^ a[I + _ | 0]);
                                                }
                                                XC(c + 32 | 0, 64), XC(c, 32);
                                            }
                                            return h = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 192 & -32, P(E |= 0, o |= 0, a - -64 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a - -64 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            if ((E = 31 & i) && (Hg((c = a + 32 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a - -64 | 0)), c = 32, o = 0, B >>> 0 < 32) E = 0;
                                            else for(; l(A + o | 0, C + o | 0, a - -64 | 0), o = E = c, (c = E + 32 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 31 & B) && (Hg((o = a + 32 | 0) | Q, 0, 32 - Q | 0), Sg(o, C + E | 0, Q), l(a, o, a - -64 | 0), Sg(A + E | 0, a, Q)), d(I, g, i, B, a - -64 | 0), h = _, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 224 & -32, P(E |= 0, o |= 0, a + 96 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            (E = 31 & i) && (Hg((c = a - -64 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a + 96 | 0));
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (c = 32, g >>> 0 < 32) break B;
                                                                    for(E = 0; U(A + E | 0, I + E | 0, a + 96 | 0), o = c, (c = (E = c) + 32 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (E = 32, g >>> 0 < 32) break g;
                                                                    for(c = 0; U(a + 32 | 0, I + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(E = 31 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(E = g)) break A;
                                                        }
                                                        x(A + o | 0, I + o | 0, E, a + 96 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(E = g)) break A;
                                                }
                                                x(a + 32 | 0, I + o | 0, E, a + 96 | 0);
                                            }
                                            d(a, B, i, g, a + 96 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(a, C);
                                                    break A;
                                                }
                                                o = SC(a, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = _, 0 | o;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 528 | 0, M(_ |= 0, o |= 0, c + 400 | 0), o = 0, i >>> 0 >= 16) for(r = c + 416 | 0, y = c + 432 | 0, s = c + 448 | 0, e = c + 464 | 0, D = c + 480 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 520 >> 2] = E[D + 8 >> 2], E[c + 524 >> 2] = o, o = E[D + 4 >> 2], E[c + 512 >> 2] = E[D >> 2], E[c + 516 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 496 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 508 >> 2], E[D + 8 >> 2] = E[c + 504 >> 2], E[D + 12 >> 2] = t, t = E[c + 500 >> 2], E[D >> 2] = E[c + 496 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 508 >> 2], E[e + 8 >> 2] = E[c + 504 >> 2], E[e + 12 >> 2] = t, t = E[c + 500 >> 2], E[e >> 2] = E[c + 496 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 508 >> 2], E[s + 8 >> 2] = E[c + 504 >> 2], E[s + 12 >> 2] = t, t = E[c + 500 >> 2], E[s >> 2] = E[c + 496 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 508 >> 2], E[y + 8 >> 2] = E[c + 504 >> 2], E[y + 12 >> 2] = t, t = E[c + 500 >> 2], E[y >> 2] = E[c + 496 >> 2], E[y + 4 >> 2] = t, t = E[c + 412 >> 2], E[c + 248 >> 2] = E[c + 408 >> 2], E[c + 252 >> 2] = t, t = E[c + 404 >> 2], E[c + 240 >> 2] = E[c + 400 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 508 >> 2], E[r + 8 >> 2] = E[c + 504 >> 2], E[r + 12 >> 2] = t, t = E[c + 500 >> 2], E[r >> 2] = E[c + 496 >> 2], E[r + 4 >> 2] = t, t = E[c + 524 >> 2], E[c + 216 >> 2] = E[c + 520 >> 2], E[c + 220 >> 2] = t, t = E[c + 412 >> 2], E[c + 200 >> 2] = E[c + 408 >> 2], E[c + 204 >> 2] = t, t = E[c + 516 >> 2], E[c + 208 >> 2] = E[c + 512 >> 2], E[c + 212 >> 2] = t, t = E[c + 404 >> 2], E[c + 192 >> 2] = E[c + 400 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 412 >> 2] = n ^ E[c + 508 >> 2], E[c + 408 >> 2] = E[c + 504 >> 2] ^ f, E[c + 404 >> 2] = E[c + 500 >> 2] ^ w, E[c + 400 >> 2] = E[c + 496 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            if ((_ = 15 & i) && (Hg((r = c + 384 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 384 >> 2], r = E[c + 388 >> 2], y = E[c + 392 >> 2], s = E[c + 396 >> 2], o = E[c + 492 >> 2], Q = E[c + 488 >> 2], E[c + 520 >> 2] = Q, E[c + 524 >> 2] = o, e = E[c + 476 >> 2], E[c + 184 >> 2] = E[c + 472 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 484 >> 2], Q = E[c + 480 >> 2], E[c + 512 >> 2] = Q, E[c + 516 >> 2] = o, e = E[c + 468 >> 2], E[c + 176 >> 2] = E[c + 464 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 496 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 508 >> 2], E[c + 488 >> 2] = E[c + 504 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 152 >> 2] = E[c + 456 >> 2], E[c + 156 >> 2] = o, o = E[c + 476 >> 2], E[c + 136 >> 2] = E[c + 472 >> 2], E[c + 140 >> 2] = o, o = E[c + 500 >> 2], E[c + 480 >> 2] = E[c + 496 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 144 >> 2] = E[c + 448 >> 2], E[c + 148 >> 2] = o, o = E[c + 468 >> 2], E[c + 128 >> 2] = E[c + 464 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 508 >> 2], E[c + 472 >> 2] = E[c + 504 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 120 >> 2] = E[c + 440 >> 2], E[c + 124 >> 2] = o, o = E[c + 460 >> 2], E[c + 104 >> 2] = E[c + 456 >> 2], E[c + 108 >> 2] = o, o = E[c + 500 >> 2], E[c + 464 >> 2] = E[c + 496 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 112 >> 2] = E[c + 432 >> 2], E[c + 116 >> 2] = o, o = E[c + 452 >> 2], E[c + 96 >> 2] = E[c + 448 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 508 >> 2], E[c + 456 >> 2] = E[c + 504 >> 2], E[c + 460 >> 2] = o, o = E[c + 428 >> 2], E[c + 88 >> 2] = E[c + 424 >> 2], E[c + 92 >> 2] = o, o = E[c + 444 >> 2], E[c + 72 >> 2] = E[c + 440 >> 2], E[c + 76 >> 2] = o, o = E[c + 500 >> 2], E[c + 448 >> 2] = E[c + 496 >> 2], E[c + 452 >> 2] = o, o = E[c + 420 >> 2], E[c + 80 >> 2] = E[c + 416 >> 2], E[c + 84 >> 2] = o, o = E[c + 436 >> 2], E[c + 64 >> 2] = E[c + 432 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 508 >> 2], E[c + 440 >> 2] = E[c + 504 >> 2], E[c + 444 >> 2] = o, o = E[c + 412 >> 2], E[c + 56 >> 2] = E[c + 408 >> 2], E[c + 60 >> 2] = o, o = E[c + 428 >> 2], E[c + 40 >> 2] = E[c + 424 >> 2], E[c + 44 >> 2] = o, o = E[c + 500 >> 2], E[c + 432 >> 2] = E[c + 496 >> 2], E[c + 436 >> 2] = o, o = E[c + 404 >> 2], E[c + 48 >> 2] = E[c + 400 >> 2], E[c + 52 >> 2] = o, o = E[c + 420 >> 2], E[c + 32 >> 2] = E[c + 416 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 508 >> 2], E[c + 424 >> 2] = E[c + 504 >> 2], E[c + 428 >> 2] = o, o = E[c + 524 >> 2], E[c + 24 >> 2] = E[c + 520 >> 2], E[c + 28 >> 2] = o, o = E[c + 412 >> 2], E[c + 8 >> 2] = E[c + 408 >> 2], E[c + 12 >> 2] = o, o = E[c + 500 >> 2], E[c + 416 >> 2] = E[c + 496 >> 2], E[c + 420 >> 2] = o, o = E[c + 516 >> 2], E[c + 16 >> 2] = E[c + 512 >> 2], E[c + 20 >> 2] = o, o = E[c + 404 >> 2], E[c >> 2] = E[c + 400 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 412 >> 2] = s ^ E[c + 508 >> 2], E[c + 408 >> 2] = y ^ E[c + 504 >> 2], E[c + 404 >> 2] = r ^ E[c + 500 >> 2], E[c + 400 >> 2] = _ ^ E[c + 496 >> 2]), Q = 16, o = 0, B >>> 0 < 16) _ = 0;
                                            else for(; j(A + o | 0, C + o | 0, c + 400 | 0), _ = Q, (Q = (o = Q) + 16 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 15 & B) && (Hg((o = c + 384 | 0) | Q, 0, 16 - Q | 0), Sg(o, C + _ | 0, Q), j(C = c + 512 | 0, o, c + 400 | 0), Sg(A + _ | 0, C, Q)), m(I, g, i, B, c + 400 | 0), h = c + 528 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 544 | 0, M(_ |= 0, o |= 0, c + 432 | 0), o = 0, i >>> 0 >= 16) for(r = c + 448 | 0, y = c + 464 | 0, s = c + 480 | 0, e = c + 496 | 0, D = c + 512 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 392 >> 2] = E[D + 8 >> 2], E[c + 396 >> 2] = o, o = E[D + 4 >> 2], E[c + 384 >> 2] = E[D >> 2], E[c + 388 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 528 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 540 >> 2], E[D + 8 >> 2] = E[c + 536 >> 2], E[D + 12 >> 2] = t, t = E[c + 532 >> 2], E[D >> 2] = E[c + 528 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 540 >> 2], E[e + 8 >> 2] = E[c + 536 >> 2], E[e + 12 >> 2] = t, t = E[c + 532 >> 2], E[e >> 2] = E[c + 528 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 540 >> 2], E[s + 8 >> 2] = E[c + 536 >> 2], E[s + 12 >> 2] = t, t = E[c + 532 >> 2], E[s >> 2] = E[c + 528 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 540 >> 2], E[y + 8 >> 2] = E[c + 536 >> 2], E[y + 12 >> 2] = t, t = E[c + 532 >> 2], E[y >> 2] = E[c + 528 >> 2], E[y + 4 >> 2] = t, t = E[c + 444 >> 2], E[c + 248 >> 2] = E[c + 440 >> 2], E[c + 252 >> 2] = t, t = E[c + 436 >> 2], E[c + 240 >> 2] = E[c + 432 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 540 >> 2], E[r + 8 >> 2] = E[c + 536 >> 2], E[r + 12 >> 2] = t, t = E[c + 532 >> 2], E[r >> 2] = E[c + 528 >> 2], E[r + 4 >> 2] = t, t = E[c + 396 >> 2], E[c + 216 >> 2] = E[c + 392 >> 2], E[c + 220 >> 2] = t, t = E[c + 444 >> 2], E[c + 200 >> 2] = E[c + 440 >> 2], E[c + 204 >> 2] = t, t = E[c + 388 >> 2], E[c + 208 >> 2] = E[c + 384 >> 2], E[c + 212 >> 2] = t, t = E[c + 436 >> 2], E[c + 192 >> 2] = E[c + 432 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 444 >> 2] = n ^ E[c + 540 >> 2], E[c + 440 >> 2] = E[c + 536 >> 2] ^ f, E[c + 436 >> 2] = E[c + 532 >> 2] ^ w, E[c + 432 >> 2] = E[c + 528 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            (_ = 15 & i) && (Hg((r = c + 416 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 416 >> 2], r = E[c + 420 >> 2], y = E[c + 424 >> 2], s = E[c + 428 >> 2], o = E[c + 524 >> 2], Q = E[c + 520 >> 2], E[c + 392 >> 2] = Q, E[c + 396 >> 2] = o, e = E[c + 508 >> 2], E[c + 184 >> 2] = E[c + 504 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 516 >> 2], Q = E[c + 512 >> 2], E[c + 384 >> 2] = Q, E[c + 388 >> 2] = o, e = E[c + 500 >> 2], E[c + 176 >> 2] = E[c + 496 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 528 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 540 >> 2], E[c + 520 >> 2] = E[c + 536 >> 2], E[c + 524 >> 2] = o, o = E[c + 492 >> 2], E[c + 152 >> 2] = E[c + 488 >> 2], E[c + 156 >> 2] = o, o = E[c + 508 >> 2], E[c + 136 >> 2] = E[c + 504 >> 2], E[c + 140 >> 2] = o, o = E[c + 532 >> 2], E[c + 512 >> 2] = E[c + 528 >> 2], E[c + 516 >> 2] = o, o = E[c + 484 >> 2], E[c + 144 >> 2] = E[c + 480 >> 2], E[c + 148 >> 2] = o, o = E[c + 500 >> 2], E[c + 128 >> 2] = E[c + 496 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 540 >> 2], E[c + 504 >> 2] = E[c + 536 >> 2], E[c + 508 >> 2] = o, o = E[c + 476 >> 2], E[c + 120 >> 2] = E[c + 472 >> 2], E[c + 124 >> 2] = o, o = E[c + 492 >> 2], E[c + 104 >> 2] = E[c + 488 >> 2], E[c + 108 >> 2] = o, o = E[c + 532 >> 2], E[c + 496 >> 2] = E[c + 528 >> 2], E[c + 500 >> 2] = o, o = E[c + 468 >> 2], E[c + 112 >> 2] = E[c + 464 >> 2], E[c + 116 >> 2] = o, o = E[c + 484 >> 2], E[c + 96 >> 2] = E[c + 480 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 540 >> 2], E[c + 488 >> 2] = E[c + 536 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 88 >> 2] = E[c + 456 >> 2], E[c + 92 >> 2] = o, o = E[c + 476 >> 2], E[c + 72 >> 2] = E[c + 472 >> 2], E[c + 76 >> 2] = o, o = E[c + 532 >> 2], E[c + 480 >> 2] = E[c + 528 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 80 >> 2] = E[c + 448 >> 2], E[c + 84 >> 2] = o, o = E[c + 468 >> 2], E[c + 64 >> 2] = E[c + 464 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 540 >> 2], E[c + 472 >> 2] = E[c + 536 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 56 >> 2] = E[c + 440 >> 2], E[c + 60 >> 2] = o, o = E[c + 460 >> 2], E[c + 40 >> 2] = E[c + 456 >> 2], E[c + 44 >> 2] = o, o = E[c + 532 >> 2], E[c + 464 >> 2] = E[c + 528 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 48 >> 2] = E[c + 432 >> 2], E[c + 52 >> 2] = o, o = E[c + 452 >> 2], E[c + 32 >> 2] = E[c + 448 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 540 >> 2], E[c + 456 >> 2] = E[c + 536 >> 2], E[c + 460 >> 2] = o, o = E[c + 396 >> 2], E[c + 24 >> 2] = E[c + 392 >> 2], E[c + 28 >> 2] = o, o = E[c + 444 >> 2], E[c + 8 >> 2] = E[c + 440 >> 2], E[c + 12 >> 2] = o, o = E[c + 532 >> 2], E[c + 448 >> 2] = E[c + 528 >> 2], E[c + 452 >> 2] = o, o = E[c + 388 >> 2], E[c + 16 >> 2] = E[c + 384 >> 2], E[c + 20 >> 2] = o, o = E[c + 436 >> 2], E[c >> 2] = E[c + 432 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 444 >> 2] = s ^ E[c + 540 >> 2], E[c + 440 >> 2] = y ^ E[c + 536 >> 2], E[c + 436 >> 2] = r ^ E[c + 532 >> 2], E[c + 432 >> 2] = _ ^ E[c + 528 >> 2]);
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (Q = 16, g >>> 0 < 16) break B;
                                                                    for(_ = 0; X(A + _ | 0, I + _ | 0, c + 432 | 0), _ = o = Q, (Q = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (_ = 16, g >>> 0 < 16) break g;
                                                                    for(Q = 0; X(c + 528 | 0, I + Q | 0, c + 432 | 0), Q = o = _, (_ = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(_ = 15 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(_ = g)) break A;
                                                        }
                                                        Z(A + o | 0, I + o | 0, _, c + 432 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(_ = g)) break A;
                                                }
                                                Z(c + 528 | 0, I + o | 0, _, c + 432 | 0);
                                            }
                                            m(c + 384 | 0, B, i, g, c + 432 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(c + 384 | 0, C);
                                                    break A;
                                                }
                                                o = SC(c + 384 | 0, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = c + 544 | 0, 0 | o;
                                        }
                                    ], DB.grow = function pB(A) {
                                        var _$I = this.length;
                                        return this.length = this.length + A, _$I;
                                    }, DB.set = function(A, I) {
                                        this[A] = I;
                                    }, DB.get = function(A) {
                                        return this[A];
                                    }, DB);
                                    function wB() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function f() {},
                                        g: CB,
                                        h: hB,
                                        i: CB,
                                        j: BB,
                                        k: aB,
                                        l: qC,
                                        m: function m(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36784);
                                        },
                                        n: function n(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36784);
                                        },
                                        o: function o(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        p: function p(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        q: BB,
                                        r: hB,
                                        s: BB,
                                        t: BB,
                                        u: aB,
                                        v: LC,
                                        w: function w(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36792);
                                        },
                                        x: function x(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36792);
                                        },
                                        y: function y(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        z: function z(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        A: function A(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | xI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        B: function B(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (xI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        C: function C(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | lI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        D: function D(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (lI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        E: function E(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | UI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        F: function F(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = UI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        G: function G(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | YI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        H: function H(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = YI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        I: BB,
                                        J: QB,
                                        K: hB,
                                        L: CB,
                                        M: oB,
                                        N: LC,
                                        O: BB,
                                        P: sB,
                                        Q: hB,
                                        R: CB,
                                        S: oB,
                                        T: LC,
                                        U: function U(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | fI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        V: function V(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (fI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        W: function W(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | sI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        X: function X(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = sI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        Y: BB,
                                        Z: _B,
                                        _: hB,
                                        $: CB,
                                        aa: oB,
                                        ba: LC,
                                        ca: BB,
                                        da: BB,
                                        ea: function ea() {
                                            return 1464;
                                        },
                                        fa: EI,
                                        ga: JI,
                                        ha: LC,
                                        ia: BB,
                                        ja: BB,
                                        ka: IB,
                                        la: LC,
                                        ma: UA,
                                        na: function na(A, I, g, C) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oa: Fg,
                                        pa: function pa(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 240 | 0, UA(Q, B |= 0, 32), MA(Q, I, g, C), dA(Q, I = Q + 208 | 0), MA(g = Q + 104 | 0, I, 32, 0), dA(g, A), XC(I, 32), h = Q + 240 | 0, 0;
                                        },
                                        qa: function qa(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 272 | 0, UA(i = Q + 32 | 0, B |= 0, 32), MA(i, I, g, C), dA(i, I = Q + 240 | 0), MA(g = Q + 136 | 0, I, 32, 0), dA(g, Q), XC(I, 32), I = SC(A, Q), g = MI(Q, A, 32), h = Q + 272 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        ra: gB,
                                        sa: BB,
                                        ta: TC,
                                        ua: LC,
                                        va: QI,
                                        wa: EC,
                                        xa: fg,
                                        ya: function ya(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), nA(Q, I, g, C), z(Q, I = Q + 416 | 0), nA(g = Q + 208 | 0, I, 64, 0), z(g, A), XC(I, 64), h = Q + 480 | 0, 0;
                                        },
                                        za: function za(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 544 | 0, QI(i = Q - -64 | 0, B |= 0, 32), nA(i, I, g, C), z(i, I = Q + 480 | 0), nA(g = Q + 272 | 0, I, 64, 0), z(g, Q), XC(I, 64), I = GC(A, Q), g = MI(Q, A, 64), h = Q + 544 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        Aa: BB,
                                        Ba: BB,
                                        Ca: TC,
                                        Da: LC,
                                        Ea: eC,
                                        Fa: EC,
                                        Ga: function Ga(A, I) {
                                            I |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, fg(A |= 0, g), C = E[g + 28 >> 2], A = E[g + 24 >> 2], o[I + 24 | 0] = A, o[I + 25 | 0] = A >>> 8, o[I + 26 | 0] = A >>> 16, o[I + 27 | 0] = A >>> 24, o[I + 28 | 0] = C, o[I + 29 | 0] = C >>> 8, o[I + 30 | 0] = C >>> 16, o[I + 31 | 0] = C >>> 24, C = E[g + 20 >> 2], A = E[g + 16 >> 2], o[I + 16 | 0] = A, o[I + 17 | 0] = A >>> 8, o[I + 18 | 0] = A >>> 16, o[I + 19 | 0] = A >>> 24, o[I + 20 | 0] = C, o[I + 21 | 0] = C >>> 8, o[I + 22 | 0] = C >>> 16, o[I + 23 | 0] = C >>> 24, C = E[g + 12 >> 2], A = E[g + 8 >> 2], o[I + 8 | 0] = A, o[I + 9 | 0] = A >>> 8, o[I + 10 | 0] = A >>> 16, o[I + 11 | 0] = A >>> 24, o[I + 12 | 0] = C, o[I + 13 | 0] = C >>> 8, o[I + 14 | 0] = C >>> 16, o[I + 15 | 0] = C >>> 24, C = E[g + 4 >> 2], A = E[g >> 2], o[0 | I] = A, o[I + 1 | 0] = A >>> 8, o[I + 2 | 0] = A >>> 16, o[I + 3 | 0] = A >>> 24, o[I + 4 | 0] = C, o[I + 5 | 0] = C >>> 8, o[I + 6 | 0] = C >>> 16, o[I + 7 | 0] = C >>> 24, h = g - -64 | 0, 0;
                                        },
                                        Ha: EI,
                                        Ia: JI,
                                        Ja: BB,
                                        Ka: BB,
                                        La: BB,
                                        Ma: BB,
                                        Na: _B,
                                        Oa: BB,
                                        Pa: CB,
                                        Qa: CB,
                                        Ra: oB,
                                        Sa: function Sa() {
                                            return 1478;
                                        },
                                        Ta: function Ta(A, I, g) {
                                            return 0 | aI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ua: KC,
                                        Va: cC,
                                        Wa: Pg,
                                        Xa: qg,
                                        Ya: Qg,
                                        Za: Bg,
                                        _a: dg,
                                        $a: function $a(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = eI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        ab: function ab(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | eI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        bb: function bb(A, I, g, C, B, Q, i) {
                                            return 0 | sg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        cb: Jg,
                                        db: function db(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = yI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        eb: hg,
                                        fb: function fb(A, I, g, C, B, Q, i) {
                                            return 0 | _g(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        gb: function gb(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, KC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = sg(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        hb: function hb(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = _g(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ib: EB,
                                        jb: aI,
                                        kb: sC,
                                        lb: wg,
                                        mb: Pg,
                                        nb: qg,
                                        ob: Qg,
                                        pb: Bg,
                                        qb: BB,
                                        rb: BB,
                                        sb: BB,
                                        tb: BB,
                                        ub: _B,
                                        vb: BB,
                                        wb: CB,
                                        xb: CB,
                                        yb: oB,
                                        zb: yA,
                                        Ab: BB,
                                        Bb: CB,
                                        Cb: BB,
                                        Db: CB,
                                        Eb: fA,
                                        Fb: BB,
                                        Gb: CB,
                                        Hb: BB,
                                        Ib: CB,
                                        Jb: AC,
                                        Kb: gB,
                                        Lb: CB,
                                        Mb: BB,
                                        Nb: CB,
                                        Ob: IC,
                                        Pb: gB,
                                        Qb: CB,
                                        Rb: BB,
                                        Sb: CB,
                                        Tb: gC,
                                        Ub: gB,
                                        Vb: CB,
                                        Wb: BB,
                                        Xb: CB,
                                        Yb: CB,
                                        Zb: gB,
                                        _b: BB,
                                        $b: CB,
                                        ac: gB,
                                        bc: BB,
                                        cc: VC,
                                        dc: WC,
                                        ec: function ec(A, I, g, C, B, Q, i) {
                                            return 0 | kC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fc: iC,
                                        gc: function gc(A, I, g, C) {
                                            return 0 | mC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        hc: rC,
                                        ic: LC,
                                        jc: CB,
                                        kc: gB,
                                        lc: BB,
                                        mc: CB,
                                        nc: gB,
                                        oc: BB,
                                        pc: CB,
                                        qc: CB,
                                        rc: WC,
                                        sc: LC,
                                        tc: kC,
                                        uc: function uc(A, I, g, C, B, Q, i, o, E) {
                                            return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0);
                                        },
                                        vc: eA,
                                        wc: function wc(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, B |= 0, i |= 0;
                                            var E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                            if (E = -1, !((C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64)) {
                                                A: {
                                                    if (!g || !I) {
                                                        if (((t = 255 & C) - 65 & 255) >>> 0 > 191) {
                                                            B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), I = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, I = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), E = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, E = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = E, o[A + 49 | 0] = E >>> 8, o[A + 50 | 0] = E >>> 16, o[A + 51 | 0] = E >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = I, o[A + 33 | 0] = I >>> 8, o[A + 34 | 0] = I >>> 16, o[A + 35 | 0] = I >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I = -222443256 ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106;
                                                            break A;
                                                        }
                                                        yC(), Q();
                                                    }
                                                    h = e = h - 128 | 0, !I | ((y = 255 & C) - 65 & 255) >>> 0 <= 191 | ((E = 255 & g) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, t = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), r = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, r = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = r, o[A + 49 | 0] = r >>> 8, o[A + 50 | 0] = r >>> 16, o[A + 51 | 0] = r >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = t, o[A + 33 | 0] = t >>> 8, o[A + 34 | 0] = t >>> 16, o[A + 35 | 0] = t >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, g = -222443256 ^ (E << 8 | y), o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, g = E >>> 24 ^ 1779033703, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, Hg(E + e | 0, 0, E << 24 >> 24 >= 0 ? 128 - E | 0 : 0), g = Sg(e, I, E), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0);
                                                }
                                                E = 0;
                                            }
                                            return 0 | E;
                                        },
                                        xc: mC,
                                        yc: Yg,
                                        zc: gB,
                                        Ac: CC,
                                        Bc: function Bc() {
                                            return 1533;
                                        },
                                        Cc: BB,
                                        Dc: function Dc() {
                                            return 104;
                                        },
                                        Ec: $I,
                                        Fc: function Fc(A, I, g, C) {
                                            return 0 | MA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Gc: dA,
                                        Hc: function Hc(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var _$B, Q = 0;
                                            return h = _$B = h - 112 | 0, Q = E[8603], E[_$B + 16 >> 2] = E[8602], E[_$B + 20 >> 2] = Q, Q = E[8605], E[_$B + 24 >> 2] = E[8604], E[_$B + 28 >> 2] = Q, Q = E[8607], E[_$B + 32 >> 2] = E[8606], E[_$B + 36 >> 2] = Q, E[_$B + 40 >> 2] = 0, E[_$B + 44 >> 2] = 0, Q = E[8601], E[_$B + 8 >> 2] = E[8600], E[_$B + 12 >> 2] = Q, MA(Q = _$B + 8 | 0, I, g, C), dA(Q, A), h = _$B + 112 | 0, 0;
                                        },
                                        Ic: gB,
                                        Jc: IB,
                                        Kc: SI,
                                        Lc: QC,
                                        Mc: z,
                                        Nc: CC,
                                        Oc: CB,
                                        Pc: gB,
                                        Qc: sB,
                                        Rc: BB,
                                        Sc: dI,
                                        Tc: VC,
                                        Uc: CB,
                                        Vc: gB,
                                        Wc: sB,
                                        Xc: BB,
                                        Yc: dI,
                                        Zc: LC,
                                        _c: function _c(A, I, g) {
                                            return 0 | UA(A |= 0, I |= 0, g |= 0);
                                        },
                                        $c: function $c(A, I, g) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        ad: function ad(A, I) {
                                            return Fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        bd: function bd(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 208 | 0, UA(Q, I |= 0, g |= 0), YC(Q, C, B, 0), Fg(Q, A), XC(Q, 4), h = Q + 208 | 0, 0;
                                        },
                                        cd: LC,
                                        dd: function dd(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 256 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, UA(i = Q + 48 | 0, B, 32), _ && YC(i, (A + _ | 0) - 32 | 0, 32, 0), YC(i = Q + 48 | 0, g, C, 0), YC(i, Q + 15 | 0, 1, 0), Fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 31 & I) && (UA(I = Q + 48 | 0, B, 32), c && YC(I, (A + c | 0) - 32 | 0, 32, 0), YC(I = Q + 48 | 0, g, C, 0), YC(I, Q + 15 | 0, 1, 0), Fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 32)), XC(Q + 48 | 0, 208), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 256 | 0, 0 | A;
                                        },
                                        ed: BB,
                                        fd: hB,
                                        gd: function gd() {
                                            return 8160;
                                        },
                                        hd: IB,
                                        id: eC,
                                        jd: function jd(A, I, g) {
                                            return 0 | dC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        kd: function kd(A, I) {
                                            return fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        ld: function ld(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 416 | 0, QI(Q, I |= 0, g |= 0), dC(Q, C, B, 0), fg(Q, A), XC(Q, 4), h = Q + 416 | 0, 0;
                                        },
                                        md: function md(A) {
                                            ag(A |= 0, 64);
                                        },
                                        nd: function nd(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 496 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, QI(i = Q + 80 | 0, B, 64), _ && dC(i, (A + _ | 0) - 64 | 0, 64, 0), dC(i = Q + 80 | 0, g, C, 0), dC(i, Q + 15 | 0, 1, 0), fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 63 & I) && (QI(I = Q + 80 | 0, B, 64), c && dC(I, (A + c | 0) - 64 | 0, 64, 0), dC(I = Q + 80 | 0, g, C, 0), dC(I, Q + 15 | 0, 1, 0), fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 64)), XC(Q + 80 | 0, 416), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 496 | 0, 0 | A;
                                        },
                                        od: gB,
                                        pd: hB,
                                        qd: function qd() {
                                            return 16320;
                                        },
                                        rd: function rd(A, I, g) {
                                            return A |= 0, kC(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | bC(A, I);
                                        },
                                        sd: function sd(A, I) {
                                            return A |= 0, ag(I |= 0, 32), 0 | bC(A, I);
                                        },
                                        td: function td(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, g, 32, 0), mC(I, B, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + i | 0] = a[0 | g], o[A + C | 0] = a[g + 32 | 0], o[(B = 1 | A) + i | 0] = a[I + B | 0], o[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        ud: function ud(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, B, 32, 0), mC(I, g, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + C | 0] = a[0 | g], o[A + i | 0] = a[g + 32 | 0], o[(B = 1 | A) + C | 0] = a[I + B | 0], o[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        vd: BB,
                                        wd: BB,
                                        xd: BB,
                                        yd: BB,
                                        zd: function zd() {
                                            return 1315;
                                        },
                                        Ad: $C,
                                        Bd: CB,
                                        Cd: BB,
                                        Dd: Zg,
                                        Ed: Wg,
                                        Fd: function Fd(A, I) {
                                            return 0 | fC(A |= 0, I |= 0);
                                        },
                                        Gd: BC,
                                        Hd: function Hd(A, I) {
                                            return 0 | nC(A |= 0, I |= 0);
                                        },
                                        Id: function Id() {
                                            return 1496;
                                        },
                                        Jd: LC,
                                        Kd: Zg,
                                        Ld: Wg,
                                        Md: fC,
                                        Nd: BC,
                                        Od: nC,
                                        Pd: CB,
                                        Qd: BB,
                                        Rd: $C,
                                        Sd: LC,
                                        Td: rB,
                                        Ud: CB,
                                        Vd: tB,
                                        Wd: hB,
                                        Xd: tB,
                                        Yd: CB,
                                        Zd: AB,
                                        _d: function _d() {
                                            return 1549;
                                        },
                                        $d: yB,
                                        ae: tB,
                                        be: ZC,
                                        ce: RC,
                                        de: cB,
                                        ee: jC,
                                        fe: function fe() {
                                            return 6;
                                        },
                                        ge: function ge() {
                                            return 134217728;
                                        },
                                        he: sB,
                                        ie: function ie() {
                                            return 536870912;
                                        },
                                        je: function je(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | cI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        ke: function ke(A, I, g, C, B, Q, i) {
                                            return 0 | OI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                        },
                                        le: function le(A, I, g, C) {
                                            return 0 | JC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        me: function me(A, I, g, C) {
                                            return 0 | UC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        ne: function ne(A, I, g, C) {
                                            return 0 | lC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oe: eB,
                                        pe: CB,
                                        qe: tB,
                                        re: hB,
                                        se: tB,
                                        te: CB,
                                        ue: AB,
                                        ve: OC,
                                        we: rB,
                                        xe: tB,
                                        ye: ZC,
                                        ze: RC,
                                        Ae: eB,
                                        Be: PC,
                                        Ce: yB,
                                        De: vC,
                                        Ee: cB,
                                        Fe: xC,
                                        Ge: function Ge(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | tI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        He: Ng,
                                        Ie: function Ie(A, I, g, C) {
                                            return 0 | HC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Je: rB,
                                        Ke: eB,
                                        Le: eB,
                                        Me: CB,
                                        Ne: tB,
                                        Oe: hB,
                                        Pe: tB,
                                        Qe: CB,
                                        Re: AB,
                                        Se: OC,
                                        Te: rB,
                                        Ue: tB,
                                        Ve: ZC,
                                        We: RC,
                                        Xe: eB,
                                        Ye: PC,
                                        Ze: yB,
                                        _e: vC,
                                        $e: cB,
                                        af: xC,
                                        bf: function bf(A, I, g, C, B, Q, i, o, a, _, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, I |= 0, B |= 0, o |= 0;
                                            A: {
                                                switch((c |= 0) - 1 | 0){
                                                    case 0:
                                                        A = cI(A, I, g, C, B, Q, i, o, a, _, 1);
                                                        break A;
                                                    case 1:
                                                        A = tI(A, I, g, C, B, Q, i, o, a, _, 2);
                                                        break A;
                                                }
                                                E[9392] = 28, A = -1;
                                            }
                                            return 0 | A;
                                        },
                                        cf: Ng,
                                        df: function df(A, I, g, C, B, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, o |= 0, g |= 0, B |= 0;
                                            A: {
                                                switch((E |= 0) - 1 | 0){
                                                    case 1:
                                                        A = TI(A, I, g, C, B, i, o);
                                                        break A;
                                                    default:
                                                        yC(), Q();
                                                    case 0:
                                                }
                                                A = OI(A, I, g, C, B, i, o);
                                            }
                                            return 0 | A;
                                        },
                                        ef: function ef(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = JC(A, I, g, C) : A = HC(A, I, g, C), 0 | A;
                                        },
                                        ff: function ff(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = UC(A, I, g, C) : A = lC(A, I, g, C), 0 | A;
                                        },
                                        gf: function gf() {
                                            return 1157;
                                        },
                                        hf: function hf() {
                                            return 1438;
                                        },
                                        jf: bC,
                                        kf: tC,
                                        lf: BB,
                                        mf: BB,
                                        nf: gI,
                                        of: wC,
                                        pf: BB,
                                        qf: BB,
                                        rf: BB,
                                        sf: _B,
                                        tf: BB,
                                        uf: CB,
                                        vf: CB,
                                        wf: oB,
                                        xf: function xf() {
                                            return 1488;
                                        },
                                        yf: Pg,
                                        zf: qg,
                                        Af: LC,
                                        Bf: dg,
                                        Cf: function Cf(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), eI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Df: Jg,
                                        Ef: hg,
                                        Ff: Pg,
                                        Gf: qg,
                                        Hf: BB,
                                        If: _B,
                                        Jf: BB,
                                        Kf: CB,
                                        Lf: CB,
                                        Mf: oB,
                                        Nf: LC,
                                        Of: LC,
                                        Pf: function Pf(A, I, g) {
                                            return A |= 0, g |= 0, ag(I |= 0, 24), yA(A, I, g, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Qf: function Qf(A, I, g) {
                                            return yA(A |= 0, I |= 0, g |= 0, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Rf: function Rf(A) {
                                            var _$I, g = 0, C = 0;
                                            h = _$I = h - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[_$I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[_$I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[_$I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[_$I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[_$I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[_$I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[_$I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[_$I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[_$I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[_$I + 36 >> 2] = g, xg(_$I, _$I, 40, 0, A + 32 | 0, A), g = E[_$I + 28 >> 2], C = E[_$I + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[_$I + 20 >> 2], C = E[_$I + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, g = E[_$I + 12 >> 2], C = E[_$I + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[_$I + 4 >> 2], C = E[_$I >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, C = E[_$I + 36 >> 2], g = E[_$I + 32 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, h = _$I + 48 | 0;
                                        },
                                        Sf: function Sf(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, _ |= 0, t |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0;
                                            return y = B |= 0, y |= B = 0, e = B | (c |= 0), h = B = h - 384 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), !i & y >>> 0 < 4294967279 ? (Xg(s = B + 16 | 0, 64, 0, D = A + 32 | 0, A), fC(c = B + 80 | 0, s), XC(s, 64), NC(c, _, e, t), NC(c, 34384, 0 - e & 15, 0), E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, E[(_ = B - -64 | 0) >> 2] = 0, E[_ + 4 >> 2] = 0, E[B + 56 >> 2] = 0, E[B + 60 >> 2] = 0, E[B + 48 >> 2] = 0, E[B + 52 >> 2] = 0, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, E[B + 32 >> 2] = 0, E[B + 36 >> 2] = 0, E[B + 16 >> 2] = 0, E[B + 20 >> 2] = 0, E[B + 24 >> 2] = 0, E[B + 28 >> 2] = 0, o[B + 16 | 0] = r, gg(s, s, 64, 0, D, 1, A), NC(c, s, 64, 0), o[0 | I] = a[B + 16 | 0], gg(I = I + 1 | 0, C, y, i, D, 2, A), NC(c, I, y, i), NC(c, 34384, 15 & y, 0), E[B + 8 >> 2] = e, E[B + 12 >> 2] = t, NC(c, C = B + 8 | 0, 8, 0), E[B + 8 >> 2] = y - -64, E[B + 12 >> 2] = i - ((y >>> 0 < 4294967232) - 1 | 0), NC(c, C, 8, 0), nC(c, I = I + y | 0), XC(c, 256), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], o[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], XI(D), (2 & r || NI(D, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[B + 372 >> 2] = I, xg(I = B + 336 | 0, I, 40, 0, D, A), I = E[B + 364 >> 2], C = E[B + 360 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[B + 356 >> 2], C = E[B + 352 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[B + 348 >> 2], C = E[B + 344 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[B + 340 >> 2], C = E[B + 336 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[B + 368 >> 2], C = E[B + 372 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24), g && (i = (A = y + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, E[g >> 2] = A, E[g + 4 >> 2] = i), h = B + 384 | 0) : (yC(), Q()), 0;
                                        },
                                        Tf: function Tf(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0;
                                            y = i |= 0, i = _ |= 0, s = 0 | y, e = t |= 0, h = _ = h - 400 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), C && (o[0 | C] = 255), f = -1;
                                            A: {
                                                I: {
                                                    if (!((t = s >>> 0 < 17) & !i)) {
                                                        if (w = y = i - t | 0, !y & (t = s - 17 | 0) >>> 0 >= 4294967279 | y) break I;
                                                        Xg(D = _ + 32 | 0, 64, 0, p = A + 32 | 0, A), fC(y = _ + 96 | 0, D), XC(D, 64), NC(y, c, e, r), NC(y, 34384, 0 - e & 15, 0), E[_ + 88 >> 2] = 0, E[_ + 92 >> 2] = 0, E[_ + 80 >> 2] = 0, E[_ + 84 >> 2] = 0, E[_ + 72 >> 2] = 0, E[_ + 76 >> 2] = 0, E[(c = _ - -64 | 0) >> 2] = 0, E[c + 4 >> 2] = 0, E[_ + 56 >> 2] = 0, E[_ + 60 >> 2] = 0, E[_ + 48 >> 2] = 0, E[_ + 52 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 44 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 36 >> 2] = 0, o[_ + 32 | 0] = a[0 | B], gg(D, D, 64, 0, p, 1, A), c = a[_ + 32 | 0], o[_ + 32 | 0] = a[0 | B], NC(y, D, 64, 0), NC(y, B = B + 1 | 0, t, w), NC(y, 34384, s - 1 & 15, 0), E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = r, NC(y, r = _ + 24 | 0, 8, 0), i = (s = s + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, E[_ + 24 >> 2] = s, E[_ + 28 >> 2] = i, NC(y, r, 8, 0), nC(y, _), XC(y, 256), MI(_, B + t | 0, 16) ? XC(_, 16) : (gg(I, B, t, w, p, 2, A), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | _], o[A + 37 | 0] = a[A + 37 | 0] ^ a[_ + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[_ + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[_ + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[_ + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[_ + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[_ + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[_ + 7 | 0], XI(p), (2 & c || NI(p, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[_ + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[_ + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[_ + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[_ + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[_ + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[_ + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[_ + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[_ + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[_ + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[_ + 388 >> 2] = I, xg(I = _ + 352 | 0, I, 40, 0, p, A), I = E[_ + 380 >> 2], B = E[_ + 376 >> 2], o[A + 24 | 0] = B, o[A + 25 | 0] = B >>> 8, o[A + 26 | 0] = B >>> 16, o[A + 27 | 0] = B >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[_ + 372 >> 2], B = E[_ + 368 >> 2], o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[_ + 364 >> 2], B = E[_ + 360 >> 2], o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[_ + 356 >> 2], B = E[_ + 352 >> 2], o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[_ + 384 >> 2], B = E[_ + 388 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = B, o[A + 41 | 0] = B >>> 8, o[A + 42 | 0] = B >>> 16, o[A + 43 | 0] = B >>> 24), g && (E[g >> 2] = t, E[g + 4 >> 2] = w), f = 0, C && (o[0 | C] = c));
                                                    }
                                                    h = _ + 400 | 0;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            return 0 | f;
                                        },
                                        Uf: function Uf() {
                                            return 52;
                                        },
                                        Vf: function Vf() {
                                            return 17;
                                        },
                                        Wf: _B,
                                        Xf: BB,
                                        Yf: function Yf() {
                                            return -18;
                                        },
                                        Zf: hB,
                                        _f: rB,
                                        $f: eB,
                                        ag: yB,
                                        bg: sB,
                                        cg: CB,
                                        dg: function dg() {
                                            return 1523;
                                        },
                                        eg: W,
                                        fg: qC,
                                        gg: sB,
                                        hg: CB,
                                        ig: W,
                                        jg: IB,
                                        kg: gB,
                                        lg: BB,
                                        mg: BB,
                                        ng: gB,
                                        og: iB,
                                        pg: function pg() {
                                            return 1449;
                                        },
                                        qg: function qg(A, I, g) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0);
                                        },
                                        rg: function rg(A, I) {
                                            return 0 | YA(A |= 0, I |= 0);
                                        },
                                        sg: vI,
                                        tg: HI,
                                        ug: Rg,
                                        vg: Vg,
                                        wg: function wg(A) {
                                            return 0 | uC(A |= 0);
                                        },
                                        xg: QC,
                                        yg: function yg(A, I, g, C) {
                                            return 0 | ng(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        zg: function zg(A, I, g) {
                                            return 0 | bg(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ag: IB,
                                        Bg: gB,
                                        Cg: BB,
                                        Dg: BB,
                                        Eg: gB,
                                        Fg: iB,
                                        Gg: function Gg(A, I) {
                                            A |= 0;
                                            var g, C, _$B, Q, i, E, _ = 0;
                                            return g = a[8 + (_ = I |= 0) | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, C = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, _$B = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, Q = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, i = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, I = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = _$B, o[A + 17 | 0] = _$B >>> 8, o[A + 18 | 0] = _$B >>> 16, o[A + 19 | 0] = _$B >>> 24, o[A + 20 | 0] = Q, o[A + 21 | 0] = Q >>> 8, o[A + 22 | 0] = Q >>> 16, o[A + 23 | 0] = Q >>> 24, o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = C, o[A + 13 | 0] = C >>> 8, o[A + 14 | 0] = C >>> 16, o[A + 15 | 0] = C >>> 24, o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                        },
                                        Hg: function Hg(A, I) {
                                            A |= 0;
                                            var g, C, _$B, Q, i, E, _ = 0;
                                            return g = a[32 + (_ = I |= 0) | 0] | a[_ + 33 | 0] << 8 | a[_ + 34 | 0] << 16 | a[_ + 35 | 0] << 24, C = a[_ + 36 | 0] | a[_ + 37 | 0] << 8 | a[_ + 38 | 0] << 16 | a[_ + 39 | 0] << 24, _$B = a[_ + 40 | 0] | a[_ + 41 | 0] << 8 | a[_ + 42 | 0] << 16 | a[_ + 43 | 0] << 24, Q = a[_ + 44 | 0] | a[_ + 45 | 0] << 8 | a[_ + 46 | 0] << 16 | a[_ + 47 | 0] << 24, i = a[_ + 48 | 0] | a[_ + 49 | 0] << 8 | a[_ + 50 | 0] << 16 | a[_ + 51 | 0] << 24, I = a[_ + 52 | 0] | a[_ + 53 | 0] << 8 | a[_ + 54 | 0] << 16 | a[_ + 55 | 0] << 24, E = a[_ + 60 | 0] | a[_ + 61 | 0] << 8 | a[_ + 62 | 0] << 16 | a[_ + 63 | 0] << 24, _ = a[_ + 56 | 0] | a[_ + 57 | 0] << 8 | a[_ + 58 | 0] << 16 | a[_ + 59 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, o[A + 8 | 0] = _$B, o[A + 9 | 0] = _$B >>> 8, o[A + 10 | 0] = _$B >>> 16, o[A + 11 | 0] = _$B >>> 24, o[A + 12 | 0] = Q, o[A + 13 | 0] = Q >>> 8, o[A + 14 | 0] = Q >>> 16, o[A + 15 | 0] = Q >>> 24, o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, 0;
                                        },
                                        Ig: uC,
                                        Jg: QC,
                                        Kg: ng,
                                        Lg: bg,
                                        Mg: NA,
                                        Ng: YA,
                                        Og: function Og(A, I) {
                                            A |= 0;
                                            var g, C = 0, _$B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, _$N = 0, S = 0, G = 0, M = 0, b = 0, _$K = 0, _$H = 0, Y = 0, _$d = 0, J = 0, _$U = 0, l = 0, _$m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, _$z = 0, j = 0, _$X = 0, O = 0, V = 0, Z = 0, _$W = 0, T = 0, $ = 0, _$AA = 0, _$gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, _$cA = 0, tA = 0, rA = 0, _$eA = 0, _$yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, _$wA = 0, _$fA = 0, nA = 0, kA = 0, _$FA = 0, _$NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, _$YA = 0, _$dA = 0;
                                            return h = g = h - 256 | 0, _$NA = -1, bI(I |= 0) || qA(C = g + 96 | 0, I) || IA(C) && (Q = E[g + 136 >> 2], E[g >> 2] = 1 - Q, _$NA = 0, u = E[g + 172 >> 2], E[g + 36 >> 2] = 0 - u, n = E[g + 168 >> 2], E[g + 32 >> 2] = 0 - n, x = E[g + 164 >> 2], E[g + 28 >> 2] = 0 - x, k = E[g + 160 >> 2], E[g + 24 >> 2] = 0 - k, R = E[g + 156 >> 2], E[g + 20 >> 2] = 0 - R, F = E[g + 152 >> 2], E[g + 16 >> 2] = 0 - F, v = E[g + 148 >> 2], E[g + 12 >> 2] = 0 - v, _$N = E[g + 144 >> 2], E[g + 8 >> 2] = 0 - _$N, L = E[g + 140 >> 2], E[g + 4 >> 2] = 0 - L, vA(g, g), I = Ig(S = E[g + 4 >> 2], _$U = S >> 31, G = R << 1, _$gA = G >> 31), C = w, _$B = Ig(p = E[g >> 2], M = p >> 31, k, b = k >> 31), C = w + C | 0, C = (I = _$B + I | 0) >>> 0 < _$B >>> 0 ? C + 1 | 0 : C, _$B = (i = Ig(_$K = E[g + 8 >> 2], P = _$K >> 31, F, _$H = F >> 31)) + I | 0, I = w + C | 0, I = _$B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(l = E[g + 12 >> 2], j = l >> 31, V = v << 1, CA = V >> 31), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(q = E[g + 16 >> 2], Z = q >> 31, _$N, Y = _$N >> 31), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, pA = i = E[g + 20 >> 2], s = Ig(i, BA = i >> 31, _$W = L << 1, QA = _$W >> 31), _$B = w + I | 0, _$B = (C = s + C | 0) >>> 0 < s >>> 0 ? _$B + 1 | 0 : _$B, _$wA = r = E[g + 24 >> 2], I = (Q = Ig(r, sA = r >> 31, s = Q + 1 | 0, _$d = s >> 31)) + C | 0, C = w + _$B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, iA = E[g + 28 >> 2], _$B = (Q = Ig(f = c(iA, 19), _$X = f >> 31, T = u << 1, oA = T >> 31)) + I | 0, I = w + C | 0, I = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = _$B, SA = E[g + 32 >> 2], _$B = Ig(a = c(SA, 19), _$z = a >> 31, n, J = n >> 31), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, GA = E[g + 36 >> 2], _$B = Ig(y = c(GA, 19), _$m = y >> 31, $ = x << 1, EA = $ >> 31), I = w + I | 0, _ = C = _$B + C | 0, Q = C >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, I = Ig(F, _$H, S, _$U), C = w, o = Ig(p, M, R, aA = R >> 31), _$B = w + C | 0, _$B = (I = o + I | 0) >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, o = Ig(_$K, P, v, _A = v >> 31), C = w + _$B | 0, C = (I = o + I | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, _$B = (o = Ig(_$N, Y, l, j)) + I | 0, I = w + C | 0, I = _$B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(q, Z, L, _$cA = L >> 31), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(s, _$d, i, BA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, o = Ig(r = c(r, 19), _$AA = r >> 31, u, tA = u >> 31), _$B = w + I | 0, _$B = (C = o + C | 0) >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, I = (o = Ig(n, J, f, _$X)) + C | 0, C = w + _$B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, _$B = (o = Ig(a, _$z, x, rA = x >> 31)) + I | 0, I = w + C | 0, I = _$B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(y, _$m, k, b), I = w + I | 0, _$fA = C = C + _$B | 0, O = C >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, I = Ig(S, _$U, V, CA), _$B = w, C = (o = Ig(p, M, F, _$H)) + I | 0, I = w + _$B | 0, I = C >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(_$N, Y, _$K, P), _$B = w + I | 0, _$B = (C = o + C | 0) >>> 0 < o >>> 0 ? _$B + 1 | 0 : _$B, I = (o = Ig(l, j, _$W, QA)) + C | 0, C = w + _$B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, _$B = (o = Ig(s, _$d, q, Z)) + I | 0, I = w + C | 0, I = _$B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(o = c(i, 19), _$eA = o >> 31, T, oA), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(n, J, r, _$AA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, i = Ig(f, _$X, $, EA), _$B = w + I | 0, _$B = (C = i + C | 0) >>> 0 < i >>> 0 ? _$B + 1 | 0 : _$B, I = (i = Ig(a, _$z, k, b)) + C | 0, C = w + _$B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, _$B = (i = Ig(y, _$m, G, _$gA)) + I | 0, I = w + C | 0, MA = _$B, bA = I = _$B >>> 0 < i >>> 0 ? I + 1 | 0 : I, KA = _$B = _$B + 33554432 | 0, HA = I = _$B >>> 0 < 33554432 ? I + 1 | 0 : I, _$B = (67108863 & I) << 6 | _$B >>> 26, I = (I >> 26) + O | 0, _$fA = i = _$B + _$fA | 0, I = _$B >>> 0 > i >>> 0 ? I + 1 | 0 : I, _$YA = i = i + 16777216 | 0, I = (C = (_$B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (_$B = (i = (33554431 & _$B) << 7 | i >>> 25) + _ | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, D = C = _$B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 72 >> 2] = _$B - (-67108864 & C), I = Ig(S, _$U, _$W, QA), C = w, Q = Ig(p, M, _$N, Y), _$B = w + C | 0, _$B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, C = (Q = Ig(s, _$d, _$K, P)) + I | 0, I = w + _$B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _$B = Ig(Q = c(l, 19), _$yA = Q >> 31, T, oA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (_ = Ig(O = c(q, 19), hA = O >> 31, n, J)) + C | 0, C = w + I | 0, C = _$B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = Ig($, EA, o, _$eA), I = w + C | 0, I = (_$B = _ + _$B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = Ig(k, b, r, _$AA)) + _$B | 0, _$B = w + I | 0, _$B = C >>> 0 < _ >>> 0 ? _$B + 1 | 0 : _$B, _ = Ig(f, _$X, G, _$gA), I = w + _$B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _$B = Ig(a, _$z, F, _$H), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (_ = Ig(y, _$m, V, CA)) + C | 0, C = w + I | 0, e = _$B, nA = _$B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, I = Ig(s, _$d, S, _$U), C = w, _$B = (_ = Ig(p, M, L, _$cA)) + I | 0, I = w + C | 0, I = _$B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = C = c(_$K, 19), C = (t = Ig(C, DA = C >> 31, u, tA)) + _$B | 0, _$B = w + I | 0, _$B = C >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B, t = Ig(n, J, Q, _$yA), I = w + _$B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, _$B = Ig(O, hA, x, rA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (t = Ig(k, b, o, _$eA)) + C | 0, C = w + I | 0, C = _$B >>> 0 < t >>> 0 ? C + 1 | 0 : C, t = Ig(r, _$AA, R, aA), I = w + C | 0, I = (_$B = t + _$B | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = (t = Ig(F, _$H, f, _$X)) + _$B | 0, _$B = w + I | 0, _$B = C >>> 0 < t >>> 0 ? _$B + 1 | 0 : _$B, t = Ig(a, _$z, v, _A), I = w + _$B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, _$B = Ig(y, _$m, _$N, Y), I = w + I | 0, kA = C = _$B + C | 0, t = C >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, I = Ig(I = c(S, 19), I >> 31, T, oA), C = w, _$B = Ig(p, M, s, _$d), C = w + C | 0, C = (I = _$B + I | 0) >>> 0 < _$B >>> 0 ? C + 1 | 0 : C, _$B = (_ = Ig(n, J, _, DA)) + I | 0, I = w + C | 0, C = (Q = Ig(Q, _$yA, $, EA)) + _$B | 0, _$B = w + (_$B >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, _$B = C >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = Ig(k, b, O, hA), I = w + _$B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _$B = Ig(G, _$gA, o, _$eA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (Q = Ig(F, _$H, r, _$AA)) + C | 0, C = w + I | 0, C = _$B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = Ig(f, _$X, V, CA), I = w + C | 0, I = (_$B = Q + _$B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = Ig(a, _$z, _$N, Y)) + _$B | 0, _$B = w + I | 0, _$B = C >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, Q = Ig(y, _$m, _$W, QA), I = w + _$B | 0, _ = C = Q + C | 0, _$yA = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, DA = C = C + 33554432 | 0, _$dA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, _$B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = _$B + t | 0, t = Q = I + kA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, kA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + nA | 0, I = (C = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _$B = C, nA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 56 >> 2] = _$B - (-67108864 & C), I = Ig(k, b, S, _$U), _$B = w, C = (e = Ig(p, M, x, rA)) + I | 0, I = w + _$B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, _$B = Ig(_$K, P, R, aA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(F, _$H, l, j), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, e = Ig(q, Z, v, _A), _$B = w + I | 0, _$B = (C = e + C | 0) >>> 0 < e >>> 0 ? _$B + 1 | 0 : _$B, I = (e = Ig(_$N, Y, pA, BA)) + C | 0, C = w + _$B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, _$B = (e = Ig(L, _$cA, _$wA, sA)) + I | 0, I = w + C | 0, I = _$B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(iA, _$FA = iA >> 31, s, _$d), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(a, _$z, u, tA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, e = (_$B = C) + (C = Ig(y, _$m, n, J)) | 0, _$B = w + I | 0, C = (I = i >> 26) + (C = C >>> 0 > e >>> 0 ? _$B + 1 | 0 : _$B) | 0, D = _$B = (i = (67108863 & i) << 6 | D >>> 26) + e | 0, I = C = _$B >>> 0 < i >>> 0 ? C + 1 | 0 : C, e = _$B = _$B + 16777216 | 0, i = I = _$B >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 76 >> 2] = D - (-33554432 & _$B), I = Ig(_$N, Y, S, _$U), C = w, D = Ig(p, M, v, _A), _$B = w + C | 0, _$B = (I = D + I | 0) >>> 0 < D >>> 0 ? _$B + 1 | 0 : _$B, D = Ig(_$K, P, L, _$cA), C = w + _$B | 0, C = (I = D + I | 0) >>> 0 < D >>> 0 ? C + 1 | 0 : C, _$B = (D = Ig(s, _$d, l, j)) + I | 0, I = w + C | 0, I = _$B >>> 0 < D >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(O, hA, u, tA), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(n, J, o, _$eA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, C = (r = Ig(r, _$AA, x, rA)) + C | 0, _$B = w + I | 0, I = (f = Ig(k, b, f, _$X)) + C | 0, C = w + (C >>> 0 < r >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = (a = Ig(a, _$z, R, aA)) + I | 0, I = w + (I >>> 0 < f >>> 0 ? C + 1 | 0 : C) | 0, I = _$B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(y, _$m, F, _$H), I = w + I | 0, D = C = C + _$B | 0, I = (I = C >>> 0 < _$B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, a = Q = D + (_$B = (67108863 & Q) << 6 | nA >>> 26) | 0, I = _$B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, f = C = Q + 16777216 | 0, Q = _$B = C >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 60 >> 2] = a - (-33554432 & C), I = Ig(S, _$U, $, EA), _$B = w, C = (a = Ig(p, M, n, J)) + I | 0, I = w + _$B | 0, I = C >>> 0 < a >>> 0 ? I + 1 | 0 : I, _$B = Ig(k, b, _$K, P), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, a = Ig(l, j, G, _$gA), _$B = w + I | 0, _$B = (C = a + C | 0) >>> 0 < a >>> 0 ? _$B + 1 | 0 : _$B, I = (a = Ig(F, _$H, q, Z)) + C | 0, C = w + _$B | 0, C = I >>> 0 < a >>> 0 ? C + 1 | 0 : C, _$B = (a = Ig(V, CA, pA, BA)) + I | 0, I = w + C | 0, I = _$B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = _$B, _$B = Ig(_$N, Y, _$wA, sA), I = w + I | 0, I = (C = C + _$B | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = C, C = Ig(iA, _$FA, _$W, QA), I = w + I | 0, I = C >>> 0 > (_$B = _$B + C | 0) >>> 0 ? I + 1 | 0 : I, a = C = SA, C = (G = Ig(C, r = C >> 31, s, _$d)) + _$B | 0, _$B = w + I | 0, I = (y = Ig(y, _$m, T, oA)) + C | 0, C = w + (C >>> 0 < G >>> 0 ? _$B + 1 | 0 : _$B) | 0, _$B = I >>> 0 < y >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + _$B | 0, I = (C = C + (i = (33554431 & i) << 7 | e >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, _$B = C, y = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 80 >> 2] = _$B - (-67108864 & C), C = Q >> 25, _$B = (Q = (33554431 & Q) << 7 | f >>> 25) + (MA - (I = -67108864 & KA) | 0) | 0, I = C + (bA - ((I >>> 0 > MA >>> 0) + HA | 0) | 0) | 0, I = _$B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = _$B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (G = _$fA - (-33554432 & _$YA) | 0) | 0, E[g + 68 >> 2] = I, E[g + 64 >> 2] = _$B - (-67108864 & C), I = Ig(n, J, S, _$U), _$B = w, C = (Q = Ig(p, M, u, tA)) + I | 0, I = w + _$B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _$B = (Q = Ig(_$K, P, x, rA)) + C | 0, C = w + I | 0, C = _$B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = Ig(k, b, l, j)) + _$B | 0, _$B = w + C | 0, _$B = I >>> 0 < Q >>> 0 ? _$B + 1 | 0 : _$B, C = (Q = Ig(q, Z, R, aA)) + I | 0, I = w + _$B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _$B = Ig(F, _$H, pA, BA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = Ig(v, _A, _$wA, sA), I = w + I | 0, I = (C = _$B + C | 0) >>> 0 < _$B >>> 0 ? I + 1 | 0 : I, _$B = (Q = Ig(_$N, Y, iA, _$FA)) + C | 0, C = w + I | 0, C = _$B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = Ig(a, r, L, _$cA)) + _$B | 0, _$B = w + C | 0, _$B = I >>> 0 > Q >>> 0 ? _$B + 1 | 0 : _$B, C = Q, Q = Ig(I = GA, I >> 31, s, _$d), I = w + _$B | 0, _$B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (_$B = _$B + (i = (67108863 & i) << 6 | y >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = _$B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 84 >> 2] = _$B - (-33554432 & C), i = t - (-33554432 & kA) | 0, Q = _ - (_$B = -67108864 & DA) | 0, p = _$yA - ((_$B >>> 0 > _ >>> 0) + _$dA | 0) | 0, I = Ig((33554431 & (_$B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = w + p | 0, I = I >>> 0 > (_$B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = _$B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, E[g + 52 >> 2] = I, E[g + 48 >> 2] = _$B - (-67108864 & C), BI(A, g + 48 | 0)), h = g + 256 | 0, 0 | _$NA;
                                        },
                                        Pg: function Pg(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, kI(g, I |= 0, 32, 0), o[0 | g] = 248 & a[0 | g], o[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0, 0;
                                        },
                                        Qg: Vg,
                                        Rg: HI,
                                        Sg: Rg,
                                        Tg: vI,
                                        Ug: BB,
                                        Vg: sB,
                                        Wg: tB,
                                        Xg: BB,
                                        Yg: QB,
                                        Zg: tB,
                                        _g: function _g(A, I, g, C, B) {
                                            return 0 | jg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        $g: function $g(A, I, g, C, B, Q, i, o) {
                                            return 0 | Ug(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        ah: function ah(A, I, g, C, B, Q) {
                                            return 0 | ug(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        bh: function bh(A, I, g, C, B) {
                                            return 0 | Xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        ch: function ch(A, I, g, C, B, Q, i) {
                                            return 0 | gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        dh: function dh(A, I, g, C, B, Q) {
                                            return 0 | xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        eh: LC,
                                        fh: LC,
                                        gh: BB,
                                        hh: _B,
                                        ih: tB,
                                        jh: function jh() {
                                            return 1540;
                                        },
                                        kh: Tg,
                                        lh: zg,
                                        mh: LC,
                                        nh: BB,
                                        oh: sB,
                                        ph: tB,
                                        qh: function qh(A, I, g, C, B) {
                                            return 0 | pC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        rh: function rh(A, I, g, C, B, Q, i, o) {
                                            return 0 | oC(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        sh: function sh(A, I, g, C, B, Q) {
                                            return 0 | aC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        th: LC,
                                        uh: Tg,
                                        vh: function vh(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, fA(E, B |= 0, o |= 0, 0), A = oC(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), XC(E, 32), h = E + 32 | 0, 0 | A;
                                        },
                                        wh: zg,
                                        xh: BB,
                                        yh: _B,
                                        zh: tB,
                                        Ah: LC,
                                        Bh: CB,
                                        Ch: BB,
                                        Dh: gB,
                                        Eh: iI,
                                        Fh: SC,
                                        Gh: GC,
                                        Hh: function Hh() {
                                            return 1089;
                                        },
                                        Ih: function Ih() {
                                            var _$A, _$I;
                                            return h = _$A = h - 16 | 0, o[_$A + 15 | 0] = 0, _$I = 0 | r(36800, _$A + 15 | 0, 0), h = _$A + 16 | 0, 0 | _$I;
                                        },
                                        Jh: $g,
                                        Kh: function Kh(A) {
                                            var _$I, g = 0, C = 0;
                                            if (h = _$I = h - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; o[_$I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(36800, _$I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return h = _$I + 16 | 0, 0 | g;
                                        },
                                        Lh: ag,
                                        Mh: function Mh(A, I, g) {
                                            Xg(A |= 0, I |= 0, 0, 1574, g |= 0);
                                        },
                                        Nh: BB,
                                        Oh: function Oh() {
                                            var _$A = 0, _$I = 0;
                                            return (_$A = E[9524]) && (_$A = E[_$A + 20 >> 2]) && (_$I = 0 | pB[0 | _$A]()), 0 | _$I;
                                        },
                                        Ph: function Ph(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, _$B = 0, i = 0, E = 0;
                                            if (h = C = h - 16 | 0, g |= 0) e(1329, 1175, 197, 1092), Q();
                                            else {
                                                if (I) for(; o[C + 15 | 0] = 0, i = A + _$B | 0, E = 0 | r(36800, C + 15 | 0, 0), o[0 | i] = E, (0 | I) != (0 | (_$B = _$B + 1 | 0)););
                                                h = C + 16 | 0;
                                            }
                                        },
                                        Qh: function Qh(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var _$B = 0, i = 0, E = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; _$B = (I << 1) + A | 0, i = 15 & (E = a[I + g | 0]), o[_$B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = _$B, _$B = E >>> 4 | 0, o[0 | i] = 87 + ((_$B + 65526 >>> 8 & 217) + _$B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return o[I + A | 0] = 0, 0 | A;
                                            }
                                            yC(), Q();
                                        },
                                        Rh: function Rh(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((s = (65526 + (t = (223 & (e = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (e ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                        if (t = t & s | e & h, 255 & r ? (o[A + y | 0] = B | t, y = y + 1 | 0) : B = t << 4, r ^= -1, (0 | (_ = _ + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    _ = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            o: {
                                                                                E: {
                                                                                    a: {
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = r = _ + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                                        if (c = t & e | s & h, !(255 & r)) break E;
                                                                                        o[A + y | 0] = c | p, y = y + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = _ + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break o;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= y >>> 0) break i;
                                                                                    c = t & e | s & h;
                                                                                }
                                                                                p = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            _ = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((_ = _ + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            E[9392] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    E[9392] = 28, D = -1, _ = _ - 1 | 0, y = 0;
                                                    break A;
                                                }
                                                c || (y = 0, D = -1);
                                            }
                                            return i ? E[i >> 2] = g + _ : (0 | C) != (0 | _) && (E[9392] = 28, D = -1), Q && (E[Q >> 2] = y), 0 | D;
                                        },
                                        Sh: function Sh(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (yC(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        Th: LA,
                                        Uh: wA,
                                        Vh: function Vh() {
                                            var _$A = 0;
                                            return E[9525] ? _$A = 1 : ($g(), ag(38080, 16), E[9525] = 1, _$A = 0), 0 | _$A;
                                        },
                                        Wh: function Wh(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, _ = 0, c = 0, t = 0;
                                            h = i = h - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((_ = C - 1 | 0) & C ? (c = -1 ^ g, _ = _ - ((g >>> 0) % (C >>> 0) | 0) | 0) : _ &= c = -1 ^ g, c >>> 0 <= _ >>> 0) break A;
                                                    if (c = -1, !((g = g + _ | 0) >>> 0 >= B >>> 0)) for(A && (E[A >> 2] = g + 1), A = I + g | 0, c = 0, o[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, t = a[0 | I] & a[i + 15 | 0], I = (g ^ _) - 1 >>> 24 | 0, o[0 | B] = t | 128 & I, o[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return h = i + 16 | 0, 0 | c;
                                            }
                                            yC(), Q();
                                        },
                                        Xh: function Xh(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var _$B, Q = 0, i = 0, o = 0, _ = 0, c = 0;
                                            if (E[12 + (_$B = h - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; _ = ((128 ^ (i = a[c - g | 0])) - 1 & E[_$B + 12 >> 2] - 1 & o - 1) >>> 8 & 1, E[_$B + 12 >> 2] = E[_$B + 12 >> 2] | 0 - _ & g, I |= _, o |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                E[A >> 2] = Q - E[_$B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        Yh: function Yh() {
                                            return 1457;
                                        },
                                        Zh: function Zh() {
                                            return 26;
                                        },
                                        _h: rB,
                                        $h: hB,
                                        ai: aI,
                                        bi: sC,
                                        ci: function ci(A, I, g) {
                                            A |= 0;
                                            var C, _$B = 0;
                                            return h = C = h - 32 | 0, _$B = -1, gI(C, g |= 0, I |= 0) || (_$B = yA(A, 35584, C, 0)), h = C + 32 | 0, 0 | _$B;
                                        },
                                        di: lg,
                                        ei: function ei(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = rI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        fi: function fi(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | rI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        gi: function gi(A, I, g, C, B, Q, i) {
                                            return 0 | ig(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        hi: mg,
                                        ii: function ii(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = hI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        ji: Dg,
                                        ki: function ki(A, I, g, C, B, Q, i) {
                                            return 0 | Ag(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        li: BB,
                                        mi: BB,
                                        ni: BB,
                                        oi: BB,
                                        pi: _B,
                                        qi: CB,
                                        ri: oB,
                                        si: function si(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, sC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = ig(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        ti: function ti(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = Ag(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ui: EB,
                                        vi: function vi(A) {
                                            var _$I, g = 0;
                                            return h = _$I = h - 160 | 0, GI(A |= 0) && (bI(A) || bA(_$I, A) || jA(_$I) && (g = 0 != (0 | IA(_$I)))), h = _$I + 160 | 0, 0 | g;
                                        },
                                        wi: function wi(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, _$B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(_$B = C + 640 | 0, I |= 0) || jA(_$B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), sA(I = C + 160 | 0, _$B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        xi: function xi(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, _$B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(_$B = C + 640 | 0, I |= 0) || jA(_$B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), hA(I = C + 160 | 0, _$B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        yi: function yi(A, I) {
                                            return b(A |= 0, I |= 0), 0;
                                        },
                                        zi: function zi(A) {
                                            var _$I;
                                            A |= 0, h = _$I = h - 32 | 0, ag(_$I, 32), b(A, _$I), h = _$I + 32 | 0;
                                        },
                                        Ai: Mg,
                                        Bi: FA,
                                        Ci: xA,
                                        Di: mA,
                                        Ei: cA,
                                        Fi: JA,
                                        Gi: AA,
                                        Hi: MC,
                                        Ii: BB,
                                        Ji: gB,
                                        Ki: BB,
                                        Li: gB,
                                        Mi: BB,
                                        Ni: function Ni(A) {
                                            var _$I;
                                            return h = _$I = h - 160 | 0, A = EA(_$I, A |= 0), h = _$I + 160 | 0, 0 | !A;
                                        },
                                        Oi: function Oi(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, _$B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(_$B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), sA(I = C + 160 | 0, _$B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Pi: function Pi(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, _$B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(_$B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), hA(I = C + 160 | 0, _$B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Qi: function Qi(A, I) {
                                            return jI(A |= 0, I |= 0), 0;
                                        },
                                        Ri: function Ri(A) {
                                            var _$I;
                                            A |= 0, h = _$I = h + -64 | 0, ag(_$I, 64), jI(A, _$I), h = _$I - -64 | 0;
                                        },
                                        Si: function Si(A) {
                                            Mg(A |= 0);
                                        },
                                        Ti: function Ti(A, I) {
                                            return 0 | FA(A |= 0, I |= 0);
                                        },
                                        Ui: function Ui(A, I) {
                                            xA(A |= 0, I |= 0);
                                        },
                                        Vi: function Vi(A, I) {
                                            mA(A |= 0, I |= 0);
                                        },
                                        Wi: function Wi(A, I, g) {
                                            cA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Xi: function Xi(A, I, g) {
                                            AA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Yi: MC,
                                        Zi: function Zi(A, I) {
                                            JA(A |= 0, I |= 0);
                                        },
                                        _i: BB,
                                        $i: gB,
                                        aj: gB,
                                        bj: BB,
                                        cj: function cj(A, I, g, C, B, Q, i, o, E, a) {
                                            return 0 | rg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0);
                                        },
                                        dj: CB,
                                        ej: tB,
                                        fj: hB,
                                        gj: tB,
                                        hj: BB,
                                        ij: function ij() {
                                            return 102;
                                        },
                                        jj: function jj() {
                                            return 1570;
                                        },
                                        kj: function kj() {
                                            return 32768;
                                        },
                                        lj: tB,
                                        mj: zC,
                                        nj: tB,
                                        oj: function oj() {
                                            return 524288;
                                        },
                                        pj: zC,
                                        qj: jC,
                                        rj: xC,
                                        sj: function sj(A, I, g, C, B, Q, i, o, a, _) {
                                            var c, t, r;
                                            I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, a |= 0, _ |= 0, t = 0 | (o |= 0), h = o = h - 16 | 0, r = I |= 0, c = Hg(A |= 0, 0, I), A = 0 | B;
                                            A: if (1 == (0 | (B = g | Q)) | B >>> 0 > 1) E[9392] = 22, A = -1;
                                            else if (!g & I >>> 0 >= 16 | g) {
                                                if (BA(t, a, _, o + 12 | 0, o + 8 | 0, o + 4 | 0), (0 | C) == (0 | c)) {
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                B = A, A = 31 & (I = E[o + 12 >> 2]), (63 & I) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, A = rg(C, B, i, 32, g, I, E[o + 4 >> 2], E[o + 8 >> 2], c, r);
                                            } else E[9392] = 28, A = -1;
                                            return h = o + 16 | 0, 0 | A;
                                        },
                                        tj: function tj(A, I, g, C, B, Q, i) {
                                            I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0;
                                            var _, c, t, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0;
                                            r = B |= 0, r |= B = 0, h = _ = h - 128 | 0, c = Hg(A |= 0, 0, 102), D = 22, t = g | B;
                                            A: {
                                                if (!C) {
                                                    BA(r, Q, i, _ + 16 | 0, _ + 12 | 0, _ + 8 | 0), ag(e = _ + 96 | 0, 32), D = 28, g = _ + 32 | 0, Q = E[_ + 16 >> 2], i = Ig(A = E[_ + 12 >> 2], 0, C = E[_ + 8 >> 2], 0);
                                                    I: if (!(!(r = w) & i >>> 0 > 1073741823 | r | Q >>> 0 > 63) && (o[0 | g] = 36, o[g + 1 | 0] = 55, o[g + 2 | 0] = 36, o[g + 3 | 0] = a[Q + 1024 | 0], o[g + 4 | 0] = a[1024 + (63 & C) | 0], o[g + 5 | 0] = a[1024 + (C >>> 6 & 63) | 0], o[g + 6 | 0] = a[1024 + (C >>> 12 & 63) | 0], o[g + 7 | 0] = a[1024 + (C >>> 18 & 63) | 0], o[g + 8 | 0] = a[1024 + (C >>> 24 & 63) | 0], (C = g + 9 | 0) && (0 | C) != (0 | (y = g + 58 | 0)) && (o[0 | C] = a[1024 + (63 & A) | 0], 1 != (0 | (C = y - C | 0)) && (o[g + 10 | 0] = a[1024 + (A >>> 6 & 63) | 0], 2 != (0 | C) && (o[g + 11 | 0] = a[1024 + (A >>> 12 & 63) | 0], 3 != (0 | C) && (o[g + 12 | 0] = a[1024 + (A >>> 18 & 63) | 0], 4 != (0 | C) && (o[g + 13 | 0] = a[1024 + (A >>> 24 & 63) | 0], Q = g + 14 | 0))))))) {
                                                        for(r = y - Q | 0, A = 0;;){
                                                            if (C = Q, !(A >>> 0 >= 32)) {
                                                                if (Q = a[A + e | 0], (p = (i = A + 1 | 0) >>> 0 >= 32) ? s = 0 : (Q = a[i + e | 0] << 8 | Q, (i = A + 2 | 0) >>> 0 >= 32 ? s = 0 : (Q = a[i + e | 0] << 16 | Q, s = 1, i = A + 3 | 0)), A = i, !r) break I;
                                                                if (o[0 | C] = a[1024 + (63 & Q) | 0], 1 == (0 | r)) break I;
                                                                if (o[C + 1 | 0] = a[1024 + (Q >>> 6 & 63) | 0], f = C + r | 0, i = C + 2 | 0, !p) {
                                                                    if (2 == (0 | r)) break I;
                                                                    if (o[C + 2 | 0] = a[1024 + (Q >>> 12 & 63) | 0], i = C + 3 | 0, s) {
                                                                        if (3 == (0 | r)) break I;
                                                                        o[C + 3 | 0] = a[1024 + (Q >>> 18 | 0) | 0], i = C + 4 | 0;
                                                                    }
                                                                }
                                                                if (r = f - (Q = i) | 0, Q) continue;
                                                                break I;
                                                            }
                                                            break;
                                                        }
                                                        C >>> 0 >= y >>> 0 || (o[0 | C] = 0, B = g);
                                                    }
                                                    if (B) {
                                                        if (A = -1, _C(C = _ + 20 | 0)) break A;
                                                        if (I = ZA(C, I, t, g, c), vg(C), A = 0, I) break A;
                                                    }
                                                }
                                                E[9392] = D, A = -1;
                                            }
                                            return h = _ + 128 | 0, 0 | A;
                                        },
                                        uj: function uj(A, I, g, C) {
                                            I |= 0, C |= 0;
                                            var _$B, Q, i = 0;
                                            _$B = A |= 0, Q = g |= 0, g = 0, h = C = h - 128 | 0;
                                            A: {
                                                I: {
                                                    for(;;){
                                                        if (!a[g + _$B | 0]) {
                                                            A = g;
                                                            break I;
                                                        }
                                                        if (!a[_$B + (A = g + 1 | 0) | 0]) break I;
                                                        if (!a[_$B + (A = g + 2 | 0) | 0]) break I;
                                                        if (102 == (0 | (g = g + 3 | 0))) break;
                                                    }
                                                    g = -1;
                                                    break A;
                                                }
                                                g = -1, 101 == (0 | A) && (_C(i = C + 4 | 0) || (Hg(A = C + 16 | 0, 0, 102), I = ZA(i, I, Q, _$B, A), vg(i), I && (g = MI(A, _$B, 102), XC(A, 102))));
                                            }
                                            return h = C + 128 | 0, 0 | g;
                                        },
                                        vj: function vj(A, I, g, C) {
                                            var _$B, Q;
                                            Q = A |= 0, h = _$B = h - 32 | 0, BA(I |= 0, g |= 0, C |= 0, _$B + 28 | 0, _$B + 20 | 0, _$B + 12 | 0), A = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        for(;;){
                                                            if (a[A + Q | 0]) {
                                                                if (a[Q + (I = A + 1 | 0) | 0] && a[Q + (I = A + 2 | 0) | 0]) {
                                                                    if (102 != (0 | (A = A + 3 | 0))) continue;
                                                                    break g;
                                                                }
                                                            } else I = A;
                                                            break;
                                                        }
                                                        if (101 == (0 | I)) {
                                                            if (g = _$B + 8 | 0, C = _$B + 16 | 0, A = 0, 36 != a[0 | Q] | 55 != a[Q + 1 | 0] | 36 != a[Q + 2 | 0] || (I = uI(a[Q + 3 | 0]), E[_$B + 24 >> 2] = I ? I - 1024 | 0 : 0, I && (I = PI(g, Q + 4 | 0)) && (A = PI(C, I))), A) break I;
                                                            E[9392] = 28, A = -1;
                                                            break A;
                                                        }
                                                    }
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                A = 1, E[_$B + 28 >> 2] != E[_$B + 24 >> 2] | E[_$B + 12 >> 2] != E[_$B + 8 >> 2] || (A = E[_$B + 20 >> 2] != E[_$B + 16 >> 2]);
                                            }
                                            return h = _$B + 32 | 0, 0 | A;
                                        },
                                        wj: function wj(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 1);
                                        },
                                        xj: function xj(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        yj: function yj(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 1);
                                        },
                                        zj: function zj(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 0);
                                        },
                                        Aj: BB,
                                        Bj: BB,
                                        Cj: function Cj(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, _$B = 0;
                                            return h = C = h - 320 | 0, _$B = -1, EA(C, g |= 0) || (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], u(I = C + 160 | 0, A, C), O(A, I), _$B = NI(A, 32) ? -1 : 0), h = C + 320 | 0, 0 | _$B;
                                        },
                                        Dj: function Dj(A, I) {
                                            var g;
                                            return I |= 0, h = g = h - 160 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], kA(g, A), O(A, g), A = NI(A, 32), h = g + 160 | 0, 0 | (A ? -1 : 0);
                                        },
                                        Ej: BB,
                                        Fj: BB,
                                        Gj: lg,
                                        Hj: function Hj(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), rI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Ij: mg,
                                        Jj: Dg,
                                        Kj: BB,
                                        Lj: _B,
                                        Mj: CB,
                                        Nj: oB,
                                        Oj: CB,
                                        Pj: CB,
                                        Qj: function Qj(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                            if (n = 1886610805 ^ (E = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), D = 1936682341 ^ (i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E ^= 1852142177, _ = 1819895653 ^ i, k = 1852075907 ^ (i = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), p = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), c = 2037671283 ^ i, i = 1952801890 ^ B, h = g, (0 | (r = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (s = i ^ (f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + _ | 0, c = C = E + (B = c ^ (e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, t = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, E = C, C = g, g = D + p | 0, g = (i = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, y = (_ = KI(k, p, 13) ^ i) + E | 0, C = (E = w ^ g) + C | 0, E = KI(_, E, 17) ^ y, p = KI(E, C = (_ = _ >>> 0 > y >>> 0 ? C + 1 | 0 : C) ^ w, 13), D = w, s = KI(B, s, 16), B = t ^ w, s ^= c, t = KI(i, g, 32), g = w + B | 0, g = (c = C) + (C = (i = s + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) | 0, t = g = (c = i + E | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, p = KI(E = c ^ p, g ^= D, 17), D = w, s = KI(s, B, 21), B = C ^ w, s ^= i, i = KI(y, _, 32), C = w + B | 0, g = (i = i >>> 0 > (_ = s + i | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, k = (E = E + _ | 0) ^ p, C = g = E >>> 0 < _ >>> 0 ? g + 1 | 0 : g, p = g ^ D, g = KI(s, B, 16), s = i ^= w, y = KI(g ^= _, i, 21), _ = w, t = (i = KI(c, t, 32)) + g | 0, g = w + s | 0, c = t ^ y, i = (g = i >>> 0 > t >>> 0 ? g + 1 | 0 : g) ^ _, E = KI(E, C, 32), _ = w, n = e ^ t, D = g ^ f, (0 | r) != (0 | (I = I + 8 | 0)););
                                                I = r;
                                            }
                                            switch(e = 0, B = h << 24, Q - 1 | 0){
                                                case 6:
                                                    B |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    B |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    B |= a[I + 4 | 0];
                                                case 3:
                                                    e |= (g = a[I + 3 | 0]) << 24, B |= C = g >>> 8 | 0;
                                                case 2:
                                                    e |= (C = a[I + 2 | 0]) << 16, B |= g = C >>> 16 | 0;
                                                case 1:
                                                    e |= (g = a[I + 1 | 0]) << 8, B |= C = g >>> 24 | 0;
                                                case 0:
                                                    e = a[0 | I] | e;
                                            }
                                            return y = B, I = B ^ i, C = KI(B = c ^ e, I, 16), I = I + _ | 0, t = I = (c = B + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, r = KI(B = C ^ c, I ^= g = w, 21), i = w, g = D + p | 0, C = g = (E = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, _ = B, B = KI(E, g, 32), g = w + I | 0, I = i, i = g = B >>> 0 > (_ = _ + B | 0) >>> 0 ? g + 1 | 0 : g, D = KI(B = _ ^ r, I ^= g, 16), s = w, g = (E = h = KI(k, p, 13) ^ E) + c | 0, C = (c = w ^ C) + t | 0, t = B, B = KI(g, C = g >>> 0 < E >>> 0 ? C + 1 | 0 : C, 32), I = w + I | 0, p = B = (E = B >>> 0 > (r = t + B | 0) >>> 0 ? I + 1 | 0 : I) ^ s, t = D ^= r, s = KI(h, c, 17) ^ g, g = (h = w ^ C) + i | 0, I = g = (C = _ = (I = s) + _ | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, i = KI(C, g, 32), g = w + B | 0, _ = (c = i + t | 0) ^ e, y ^= t = i >>> 0 > c >>> 0 ? g + 1 | 0 : g, B = KI(s, h, 13) ^ C, C = KI(B, I ^= w, 17), I = I + E | 0, B = C ^ (i = B + r | 0), C = I = i >>> 0 < r >>> 0 ? I + 1 | 0 : I, g = (I ^= g = w) + y | 0, g = B >>> 0 > (_ = B + _ | 0) >>> 0 ? g + 1 | 0 : g, B = KI(B, I, 13) ^ _, E = g, r = KI(B, I = g ^ w, 17), e = w, y = KI(D, p, 21), h = t ^ w, t = c ^ y, i = 238 ^ KI(i, C, 32), g = w + h | 0, g = (c = I) + (I = (C = t + i | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g) | 0, i = g = (c = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ r, g ^= e, 13), y = w, t = KI(t, h, 16), h = I ^ w, r = C ^ t, C = KI(_, E, 32), I = w + h | 0, C = (_ = g) + (g = C >>> 0 > (E = r + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, _ = C = (t = B + E | 0) >>> 0 < E >>> 0 ? C + 1 | 0 : C, e = KI(B = e ^ t, I = C ^ y, 17), y = w, C = KI(r, h, 21), h = g ^ w, r = C ^ E, C = KI(c, i, 32), g = w + h | 0, g = (C = C >>> 0 > (E = r + C | 0) >>> 0 ? g + 1 | 0 : g) + I | 0, i = g = (c = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ e, I = g ^ y, 13), y = w, g = KI(r, h, 16), h = C ^ w, r = g ^ E, g = KI(t, _, 32), C = w + h | 0, g = (C = g >>> 0 > (E = r + g | 0) >>> 0 ? C + 1 | 0 : C) + I | 0, _ = g = (t = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, I = g ^ y, 17), y = w, g = KI(r, h, 21), h = C ^ w, r = g ^ E, E = KI(c, i, 32), g = w + h | 0, I = (g = (C = r + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g) + I | 0, E = I = (i = C + B | 0) >>> 0 < C >>> 0 ? I + 1 | 0 : I, e = KI(B = i ^ e, I ^= y, 13), y = w, c = KI(r, h, 16), r = g ^ w, c ^= C, _ = KI(t, _, 32), g = w + r | 0, g = (t = I) + (I = (C = c + _ | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g) | 0, _ = g = (t = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, g ^= y, 17), y = w, c = KI(c, r, 21), r = I ^ w, c ^= C, C = KI(i, E, 32), I = w + r | 0, C = (E = g) + (g = C >>> 0 > (i = c + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, E = B = (C = (I = B + i | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C) ^ y, y = I ^ e, c = KI(c, r, 16), r = g ^ w, i = (c ^= i) + (_ = KI(t, _, 32)) | 0, g = w + r | 0, I = KI(I, C, 32), e = w, C = g = i >>> 0 < _ >>> 0 ? g + 1 | 0 : g, _ = A, c = (t = KI(c, r, 21) ^ i) ^ I ^ i ^ y, o[0 | _] = c, o[_ + 1 | 0] = c >>> 8, o[_ + 2 | 0] = c >>> 16, o[_ + 3 | 0] = c >>> 24, g = (c = g ^ w) ^ e ^ g ^ B, o[_ + 4 | 0] = g, o[_ + 5 | 0] = g >>> 8, o[_ + 6 | 0] = g >>> 16, o[_ + 7 | 0] = g >>> 24, B = _, g = c + e | 0, g = (A = I + t | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, e = A, _ = KI(t, c, 16) ^ A, c = g, r = I = g ^ w, C = E + C | 0, y = (C = KI(i = (g = t = 221 ^ y) + i | 0, g = C = g >>> 0 > i >>> 0 ? C + 1 | 0 : C, 32)) + _ | 0, I = w + I | 0, f = KI(_, r, 21) ^ y, p = I = (_ = C >>> 0 > y >>> 0 ? I + 1 | 0 : I) ^ w, D = KI(f, I, 16), s = w, g = c + (r = g ^ (C = E << 13 | t >>> 19)) | 0, I = g = (C = A = e + (h = i ^ (t << 13 | E >>> 19)) | 0) >>> 0 < e >>> 0 ? g + 1 | 0 : g, A = KI(C, g, 32), g = p + w | 0, g = (i = (A = A + f | 0) >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ s, t = A, e = KI(s = D ^ A, g, 21), E = w, A = KI(h, r, 17), I = _ + (h = I ^ w) | 0, A = KI(C = y + (c = A ^ C) | 0, I = C >>> 0 < y >>> 0 ? I + 1 | 0 : I, 32), g = g + w | 0, r = g = (_ = E) ^ (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g), e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), g = i + (h = I ^ w) | 0, A = KI(I = t + (c = A ^ C) | 0, g = I >>> 0 < t >>> 0 ? g + 1 | 0 : g, 32), C = r + w | 0, r = i = (C = (A = A + s | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C) ^ y, t = A, e = KI(s = e ^ A, i, 21), y = w, A = KI(c, h, 17), g = E + (h = g ^ w) | 0, I = g = (i = _ + (c = A ^ I) | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g, A = KI(i, g, 32), g = r + w | 0, r = g = (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g) ^ y, e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), C = C + (c = I ^ w) | 0, A = KI(g = t + (i ^= A) | 0, C = g >>> 0 < t >>> 0 ? C + 1 | 0 : C, 32), I = r + w | 0, e = KI((A = A + s | 0) ^ e, (I = A >>> 0 < s >>> 0 ? I + 1 | 0 : I) ^ y, 21), y = w, t = KI(i, c, 17), i = C ^ w, t = KI(C = g ^ t, i, 13), g = E + i | 0, E = KI(i = (C = C + _ | 0) ^ t, g = w ^ (C >>> 0 < _ >>> 0 ? g + 1 | 0 : g), 17) ^ e, C = w ^ y, g = I + g | 0, I = A, A = KI(A = A + i | 0, g = I >>> 0 > A >>> 0 ? g + 1 | 0 : g, 32) ^ E ^ A, o[B + 8 | 0] = A, o[B + 9 | 0] = A >>> 8, o[B + 10 | 0] = A >>> 16, o[B + 11 | 0] = A >>> 24, A = g ^ w ^ C, o[B + 12 | 0] = A, o[B + 13 | 0] = A >>> 8, o[B + 14 | 0] = A >>> 16, o[B + 15 | 0] = A >>> 24, 0;
                                        },
                                        Rj: function Rj(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; IC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, IC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Sj: function Sj(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Tj: BB,
                                        Uj: sB,
                                        Vj: tB,
                                        Wj: LC,
                                        Xj: function Xj(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; gC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, gC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Yj: function Yj(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Zj: BB,
                                        _j: sB,
                                        $j: tB,
                                        ak: LC,
                                        bk: BB,
                                        ck: _B,
                                        dk: tB,
                                        ek: function ek(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, h = Q = h - 32 | 0, yA(Q, C |= 0, B |= 0, 0), A = jg(A, I, g, C + 16 | 0, Q), h = Q + 32 | 0, 0 | A;
                                        },
                                        fk: function fk(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, yA(E, B |= 0, o |= 0, 0), A = Ug(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), h = E + 32 | 0, 0 | A;
                                        },
                                        gk: function gk(A, I, g, C, B, Q) {
                                            var i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = i = h - 32 | 0, yA(i, B |= 0, Q |= 0, 0), A = Ug(A, I, g, C, B + 16 | 0, 0, 0, i), h = i + 32 | 0, 0 | A;
                                        },
                                        hk: LC,
                                        ik: K,
                                        jk: gA,
                                        kk: pB
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function instantiate(A, I) {
                            return {
                                then: function then(g) {
                                    var C = new s.Module(A);
                                    g({
                                        instance: new s.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof s && d("no native wasm support detected");
                    var h, D, p, w, f, n, k, F = !1;
                    function N() {
                        var _$A = y.buffer;
                        Q.HEAP8 = h = new Int8Array(_$A), Q.HEAP16 = p = new Int16Array(_$A), Q.HEAPU8 = D = new Uint8Array(_$A), Q.HEAPU16 = new Uint16Array(_$A), Q.HEAP32 = w = new Int32Array(_$A), Q.HEAPU32 = f = new Uint32Array(_$A), Q.HEAPF32 = n = new Float32Array(_$A), Q.HEAPF64 = k = new Float64Array(_$A);
                    }
                    var S = Q.INITIAL_MEMORY || 50331648;
                    S >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + S + "! (STACK_SIZE=65536)"), y = Q.wasmMemory ? Q.wasmMemory : new s.Memory({
                        initial: S / 65536,
                        maximum: 32768
                    }), N(), S = y.buffer.byteLength;
                    var G = [], M = [], b = [], K = 0, _$H = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), e(A = "Aborted(" + A + ")"), F = !0, A += ". Build with -sASSERTIONS for more info.", new s.RuntimeError(A);
                    }
                    var J, _$U, l = "data:application/octet-stream;base64,";
                    function m(A) {
                        return A.startsWith(l);
                    }
                    m(J = "<<< WASM_BINARY_FILE >>>") || (_$U = J, J = Q.locateFile ? Q.locateFile(_$U, _) : _ + _$U);
                    var u, x = {
                        36800: function() {
                            return Q.getRandomValue();
                        },
                        36836: function() {
                            if (void 0 === Q.getRandomValue) try {
                                var _$A = "object" == typeof window ? window : self, _$I = void 0 !== _$A.crypto ? _$A.crypto : _$A.msCrypto, g = function g() {
                                    var _$A = new Uint32Array(1);
                                    return _$I.getRandomValues(_$A), _$A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("5xFHp")), B = function B() {
                                        var _$A = C.randomBytes(4);
                                        return (_$A[0] << 24 | _$A[1] << 16 | _$A[2] << 8 | _$A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, R = function(A) {
                        for(; A.length > 0;)A.shift()(Q);
                    }, v = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, L = function(A, I) {
                        return A ? function(A, I, g) {
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && v) return v.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var o = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var E = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | o);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        }(D, A, I) : "";
                    }, P = [], q = function(A) {
                        var _$I = (A - y.buffer.byteLength + 65535) / 65536;
                        try {
                            return y.grow(_$I), N(), 1;
                        } catch (A) {}
                    }, _$z = {
                        c: function(A, I, g, C) {
                            d("Assertion failed: ".concat(L(A), ", at: ") + [
                                I ? L(I) : "unknown filename",
                                g,
                                C ? L(C) : "unknown function"
                            ]);
                        },
                        d: function() {
                            d("");
                        },
                        b: function(A, I, g) {
                            return function(A, I, g) {
                                var C = function(A, I) {
                                    var _$g;
                                    for(P.length = 0; _$g = D[A++];)I += 105 != _$g && I % 8 ? 4 : 0, P.push(105 == _$g ? w[I >> 2] : k[I >> 3]), I += 105 == _$g ? 4 : 8;
                                    return P;
                                }(I, g);
                                return x[A].apply(null, C);
                            }(A, I, g);
                        },
                        e: function(A) {
                            var _$I = D.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = _$I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (q(i)) return !0;
                            }
                            return !1;
                        },
                        a: y
                    }, j = function() {
                        var _$A, _$I, g = {
                            a: _$z
                        };
                        function C(A, I) {
                            var g, _$C = A.exports;
                            return (j = _$C).kk, g = j.f, M.unshift(g), function(A) {
                                if (K--, Q.monitorRunDependencies && Q.monitorRunDependencies(K), 0 == K && (null !== _$H && (clearInterval(_$H), _$H = null), Y)) {
                                    var _$I = Y;
                                    Y = null, _$I();
                                }
                            }(), _$C;
                        }
                        if (K++, Q.monitorRunDependencies && Q.monitorRunDependencies(K), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return e("Module.instantiateWasm callback failed with error: ".concat(A)), !1;
                        }
                        return _$A = g, _$I = function I(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(function() {
                                return function(A) {
                                    if (A == J && r) return new Uint8Array(r);
                                    var _$I = function(A) {
                                        if (m(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var _$I = $f78aad968bcacc00$require$Buffer.from(A, "base64");
                                                return new Uint8Array(_$I.buffer, _$I.byteOffset, _$I.length);
                                            }
                                            try {
                                                for(var g = atob(A), _$C = new Uint8Array(g.length), B = 0; B < g.length; ++B)_$C[B] = g.charCodeAt(B);
                                                return _$C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(l.length));
                                    }(A);
                                    if (_$I) return _$I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                }(A);
                            });
                        })(J).then(function(I) {
                            return s.instantiate(I, _$A);
                        }).then(function(A) {
                            return A;
                        }).then(_$I, function(A) {
                            e("failed to asynchronously prepare wasm: ".concat(A)), d(A);
                        }), {};
                    }();
                    function X() {
                        function A() {
                            u || (u = !0, Q.calledRun = !0, F || (R(M), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)_$A = Q.postRun.shift(), b.unshift(_$A);
                                var _$A;
                                R(b);
                            }()));
                        }
                        K > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)_$A = Q.preRun.shift(), G.unshift(_$A);
                            var _$A;
                            R(G);
                        }(), K > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_aegis128l_keybytes = function() {
                        return (Q._crypto_aead_aegis128l_keybytes = j.g)();
                    }, Q._crypto_aead_aegis128l_nsecbytes = function() {
                        return (Q._crypto_aead_aegis128l_nsecbytes = j.h)();
                    }, Q._crypto_aead_aegis128l_npubbytes = function() {
                        return (Q._crypto_aead_aegis128l_npubbytes = j.i)();
                    }, Q._crypto_aead_aegis128l_abytes = function() {
                        return (Q._crypto_aead_aegis128l_abytes = j.j)();
                    }, Q._crypto_aead_aegis128l_messagebytes_max = function() {
                        return (Q._crypto_aead_aegis128l_messagebytes_max = j.k)();
                    }, Q._crypto_aead_aegis128l_keygen = function(A) {
                        return (Q._crypto_aead_aegis128l_keygen = j.l)(A);
                    }, Q._crypto_aead_aegis128l_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_aegis128l_encrypt = j.m)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_aegis128l_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                        return (Q._crypto_aead_aegis128l_encrypt_detached = j.n)(A, I, g, C, B, i, o, E, a, _, c, t);
                    }, Q._crypto_aead_aegis128l_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_aegis128l_decrypt = j.o)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_aegis128l_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_aegis128l_decrypt_detached = j.p)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_aegis256_keybytes = function() {
                        return (Q._crypto_aead_aegis256_keybytes = j.q)();
                    }, Q._crypto_aead_aegis256_nsecbytes = function() {
                        return (Q._crypto_aead_aegis256_nsecbytes = j.r)();
                    }, Q._crypto_aead_aegis256_npubbytes = function() {
                        return (Q._crypto_aead_aegis256_npubbytes = j.s)();
                    }, Q._crypto_aead_aegis256_abytes = function() {
                        return (Q._crypto_aead_aegis256_abytes = j.t)();
                    }, Q._crypto_aead_aegis256_messagebytes_max = function() {
                        return (Q._crypto_aead_aegis256_messagebytes_max = j.u)();
                    }, Q._crypto_aead_aegis256_keygen = function(A) {
                        return (Q._crypto_aead_aegis256_keygen = j.v)(A);
                    }, Q._crypto_aead_aegis256_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_aegis256_encrypt = j.w)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_aegis256_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                        return (Q._crypto_aead_aegis256_encrypt_detached = j.x)(A, I, g, C, B, i, o, E, a, _, c, t);
                    }, Q._crypto_aead_aegis256_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_aegis256_decrypt = j.y)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_aegis256_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_aegis256_decrypt_detached = j.z)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                        return (Q._crypto_aead_chacha20poly1305_encrypt_detached = j.A)(A, I, g, C, B, i, o, E, a, _, c, t);
                    }, Q._crypto_aead_chacha20poly1305_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_chacha20poly1305_encrypt = j.B)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                        return (Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = j.C)(A, I, g, C, B, i, o, E, a, _, c, t);
                    }, Q._crypto_aead_chacha20poly1305_ietf_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_chacha20poly1305_ietf_encrypt = j.D)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_chacha20poly1305_decrypt_detached = j.E)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_chacha20poly1305_decrypt = j.F)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = j.G)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_ietf_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_chacha20poly1305_ietf_decrypt = j.H)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_chacha20poly1305_ietf_keybytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_ietf_keybytes = j.I)();
                    }, Q._crypto_aead_chacha20poly1305_ietf_npubbytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_ietf_npubbytes = j.J)();
                    }, Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = j.K)();
                    }, Q._crypto_aead_chacha20poly1305_ietf_abytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_ietf_abytes = j.L)();
                    }, Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = function() {
                        return (Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = j.M)();
                    }, Q._crypto_aead_chacha20poly1305_ietf_keygen = function(A) {
                        return (Q._crypto_aead_chacha20poly1305_ietf_keygen = j.N)(A);
                    }, Q._crypto_aead_chacha20poly1305_keybytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_keybytes = j.O)();
                    }, Q._crypto_aead_chacha20poly1305_npubbytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_npubbytes = j.P)();
                    }, Q._crypto_aead_chacha20poly1305_nsecbytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_nsecbytes = j.Q)();
                    }, Q._crypto_aead_chacha20poly1305_abytes = function() {
                        return (Q._crypto_aead_chacha20poly1305_abytes = j.R)();
                    }, Q._crypto_aead_chacha20poly1305_messagebytes_max = function() {
                        return (Q._crypto_aead_chacha20poly1305_messagebytes_max = j.S)();
                    }, Q._crypto_aead_chacha20poly1305_keygen = function(A) {
                        return (Q._crypto_aead_chacha20poly1305_keygen = j.T)(A);
                    }, Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = j.U)(A, I, g, C, B, i, o, E, a, _, c, t);
                    }, Q._crypto_aead_xchacha20poly1305_ietf_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_encrypt = j.V)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = j.W)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_xchacha20poly1305_ietf_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_decrypt = j.X)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_aead_xchacha20poly1305_ietf_keybytes = function() {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_keybytes = j.Y)();
                    }, Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = function() {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = j.Z)();
                    }, Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = function() {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = j._)();
                    }, Q._crypto_aead_xchacha20poly1305_ietf_abytes = function() {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_abytes = j.$)();
                    }, Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = function() {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = j.aa)();
                    }, Q._crypto_aead_xchacha20poly1305_ietf_keygen = function(A) {
                        return (Q._crypto_aead_xchacha20poly1305_ietf_keygen = j.ba)(A);
                    }, Q._crypto_auth_bytes = function() {
                        return (Q._crypto_auth_bytes = j.ca)();
                    }, Q._crypto_auth_keybytes = function() {
                        return (Q._crypto_auth_keybytes = j.da)();
                    }, Q._crypto_auth_primitive = function() {
                        return (Q._crypto_auth_primitive = j.ea)();
                    }, Q._crypto_auth = function(A, I, g, C, B) {
                        return (Q._crypto_auth = j.fa)(A, I, g, C, B);
                    }, Q._crypto_auth_verify = function(A, I, g, C, B) {
                        return (Q._crypto_auth_verify = j.ga)(A, I, g, C, B);
                    }, Q._crypto_auth_keygen = function(A) {
                        return (Q._crypto_auth_keygen = j.ha)(A);
                    }, Q._crypto_auth_hmacsha256_bytes = function() {
                        return (Q._crypto_auth_hmacsha256_bytes = j.ia)();
                    }, Q._crypto_auth_hmacsha256_keybytes = function() {
                        return (Q._crypto_auth_hmacsha256_keybytes = j.ja)();
                    }, Q._crypto_auth_hmacsha256_statebytes = function() {
                        return (Q._crypto_auth_hmacsha256_statebytes = j.ka)();
                    }, Q._crypto_auth_hmacsha256_keygen = function(A) {
                        return (Q._crypto_auth_hmacsha256_keygen = j.la)(A);
                    }, Q._crypto_auth_hmacsha256_init = function(A, I, g) {
                        return (Q._crypto_auth_hmacsha256_init = j.ma)(A, I, g);
                    }, Q._crypto_auth_hmacsha256_update = function(A, I, g, C) {
                        return (Q._crypto_auth_hmacsha256_update = j.na)(A, I, g, C);
                    }, Q._crypto_auth_hmacsha256_final = function(A, I) {
                        return (Q._crypto_auth_hmacsha256_final = j.oa)(A, I);
                    }, Q._crypto_auth_hmacsha256 = function(A, I, g, C, B) {
                        return (Q._crypto_auth_hmacsha256 = j.pa)(A, I, g, C, B);
                    }, Q._crypto_auth_hmacsha256_verify = function(A, I, g, C, B) {
                        return (Q._crypto_auth_hmacsha256_verify = j.qa)(A, I, g, C, B);
                    }, Q._crypto_auth_hmacsha512_bytes = function() {
                        return (Q._crypto_auth_hmacsha512_bytes = j.ra)();
                    }, Q._crypto_auth_hmacsha512_keybytes = function() {
                        return (Q._crypto_auth_hmacsha512_keybytes = j.sa)();
                    }, Q._crypto_auth_hmacsha512_statebytes = function() {
                        return (Q._crypto_auth_hmacsha512_statebytes = j.ta)();
                    }, Q._crypto_auth_hmacsha512_keygen = function(A) {
                        return (Q._crypto_auth_hmacsha512_keygen = j.ua)(A);
                    }, Q._crypto_auth_hmacsha512_init = function(A, I, g) {
                        return (Q._crypto_auth_hmacsha512_init = j.va)(A, I, g);
                    }, Q._crypto_auth_hmacsha512_update = function(A, I, g, C) {
                        return (Q._crypto_auth_hmacsha512_update = j.wa)(A, I, g, C);
                    }, Q._crypto_auth_hmacsha512_final = function(A, I) {
                        return (Q._crypto_auth_hmacsha512_final = j.xa)(A, I);
                    }, Q._crypto_auth_hmacsha512 = function(A, I, g, C, B) {
                        return (Q._crypto_auth_hmacsha512 = j.ya)(A, I, g, C, B);
                    }, Q._crypto_auth_hmacsha512_verify = function(A, I, g, C, B) {
                        return (Q._crypto_auth_hmacsha512_verify = j.za)(A, I, g, C, B);
                    }, Q._crypto_auth_hmacsha512256_bytes = function() {
                        return (Q._crypto_auth_hmacsha512256_bytes = j.Aa)();
                    }, Q._crypto_auth_hmacsha512256_keybytes = function() {
                        return (Q._crypto_auth_hmacsha512256_keybytes = j.Ba)();
                    }, Q._crypto_auth_hmacsha512256_statebytes = function() {
                        return (Q._crypto_auth_hmacsha512256_statebytes = j.Ca)();
                    }, Q._crypto_auth_hmacsha512256_keygen = function(A) {
                        return (Q._crypto_auth_hmacsha512256_keygen = j.Da)(A);
                    }, Q._crypto_auth_hmacsha512256_init = function(A, I, g) {
                        return (Q._crypto_auth_hmacsha512256_init = j.Ea)(A, I, g);
                    }, Q._crypto_auth_hmacsha512256_update = function(A, I, g, C) {
                        return (Q._crypto_auth_hmacsha512256_update = j.Fa)(A, I, g, C);
                    }, Q._crypto_auth_hmacsha512256_final = function(A, I) {
                        return (Q._crypto_auth_hmacsha512256_final = j.Ga)(A, I);
                    }, Q._crypto_auth_hmacsha512256 = function(A, I, g, C, B) {
                        return (Q._crypto_auth_hmacsha512256 = j.Ha)(A, I, g, C, B);
                    }, Q._crypto_auth_hmacsha512256_verify = function(A, I, g, C, B) {
                        return (Q._crypto_auth_hmacsha512256_verify = j.Ia)(A, I, g, C, B);
                    }, Q._crypto_box_seedbytes = function() {
                        return (Q._crypto_box_seedbytes = j.Ja)();
                    }, Q._crypto_box_publickeybytes = function() {
                        return (Q._crypto_box_publickeybytes = j.Ka)();
                    }, Q._crypto_box_secretkeybytes = function() {
                        return (Q._crypto_box_secretkeybytes = j.La)();
                    }, Q._crypto_box_beforenmbytes = function() {
                        return (Q._crypto_box_beforenmbytes = j.Ma)();
                    }, Q._crypto_box_noncebytes = function() {
                        return (Q._crypto_box_noncebytes = j.Na)();
                    }, Q._crypto_box_zerobytes = function() {
                        return (Q._crypto_box_zerobytes = j.Oa)();
                    }, Q._crypto_box_boxzerobytes = function() {
                        return (Q._crypto_box_boxzerobytes = j.Pa)();
                    }, Q._crypto_box_macbytes = function() {
                        return (Q._crypto_box_macbytes = j.Qa)();
                    }, Q._crypto_box_messagebytes_max = function() {
                        return (Q._crypto_box_messagebytes_max = j.Ra)();
                    }, Q._crypto_box_primitive = function() {
                        return (Q._crypto_box_primitive = j.Sa)();
                    }, Q._crypto_box_seed_keypair = function(A, I, g) {
                        return (Q._crypto_box_seed_keypair = j.Ta)(A, I, g);
                    }, Q._crypto_box_keypair = function(A, I) {
                        return (Q._crypto_box_keypair = j.Ua)(A, I);
                    }, Q._crypto_box_beforenm = function(A, I, g) {
                        return (Q._crypto_box_beforenm = j.Va)(A, I, g);
                    }, Q._crypto_box_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_afternm = j.Wa)(A, I, g, C, B, i);
                    }, Q._crypto_box_open_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_open_afternm = j.Xa)(A, I, g, C, B, i);
                    }, Q._crypto_box = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box = j.Ya)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_open = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_open = j.Za)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_detached_afternm = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_detached_afternm = j._a)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_detached = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_box_detached = j.$a)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_box_easy_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_easy_afternm = j.ab)(A, I, g, C, B, i);
                    }, Q._crypto_box_easy = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_easy = j.bb)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_open_detached_afternm = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_open_detached_afternm = j.cb)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_open_detached = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_box_open_detached = j.db)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_box_open_easy_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_open_easy_afternm = j.eb)(A, I, g, C, B, i);
                    }, Q._crypto_box_open_easy = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_open_easy = j.fb)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_seal = function(A, I, g, C, B) {
                        return (Q._crypto_box_seal = j.gb)(A, I, g, C, B);
                    }, Q._crypto_box_seal_open = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_seal_open = j.hb)(A, I, g, C, B, i);
                    }, Q._crypto_box_sealbytes = function() {
                        return (Q._crypto_box_sealbytes = j.ib)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = function(A, I, g) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = j.jb)(A, I, g);
                    }, Q._crypto_box_curve25519xsalsa20poly1305_keypair = function(A, I) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_keypair = j.kb)(A, I);
                    }, Q._crypto_box_curve25519xsalsa20poly1305_beforenm = function(A, I, g) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_beforenm = j.lb)(A, I, g);
                    }, Q._crypto_box_curve25519xsalsa20poly1305_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_afternm = j.mb)(A, I, g, C, B, i);
                    }, Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = j.nb)(A, I, g, C, B, i);
                    }, Q._crypto_box_curve25519xsalsa20poly1305 = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305 = j.ob)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_curve25519xsalsa20poly1305_open = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_open = j.pb)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = j.qb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = j.rb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = j.sb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = j.tb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = j.ub)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = j.vb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = j.wb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_macbytes = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_macbytes = j.xb)();
                    }, Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = function() {
                        return (Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = j.yb)();
                    }, Q._crypto_core_hchacha20 = function(A, I, g, C) {
                        return (Q._crypto_core_hchacha20 = j.zb)(A, I, g, C);
                    }, Q._crypto_core_hchacha20_outputbytes = function() {
                        return (Q._crypto_core_hchacha20_outputbytes = j.Ab)();
                    }, Q._crypto_core_hchacha20_inputbytes = function() {
                        return (Q._crypto_core_hchacha20_inputbytes = j.Bb)();
                    }, Q._crypto_core_hchacha20_keybytes = function() {
                        return (Q._crypto_core_hchacha20_keybytes = j.Cb)();
                    }, Q._crypto_core_hchacha20_constbytes = function() {
                        return (Q._crypto_core_hchacha20_constbytes = j.Db)();
                    }, Q._crypto_core_hsalsa20 = function(A, I, g, C) {
                        return (Q._crypto_core_hsalsa20 = j.Eb)(A, I, g, C);
                    }, Q._crypto_core_hsalsa20_outputbytes = function() {
                        return (Q._crypto_core_hsalsa20_outputbytes = j.Fb)();
                    }, Q._crypto_core_hsalsa20_inputbytes = function() {
                        return (Q._crypto_core_hsalsa20_inputbytes = j.Gb)();
                    }, Q._crypto_core_hsalsa20_keybytes = function() {
                        return (Q._crypto_core_hsalsa20_keybytes = j.Hb)();
                    }, Q._crypto_core_hsalsa20_constbytes = function() {
                        return (Q._crypto_core_hsalsa20_constbytes = j.Ib)();
                    }, Q._crypto_core_salsa20 = function(A, I, g, C) {
                        return (Q._crypto_core_salsa20 = j.Jb)(A, I, g, C);
                    }, Q._crypto_core_salsa20_outputbytes = function() {
                        return (Q._crypto_core_salsa20_outputbytes = j.Kb)();
                    }, Q._crypto_core_salsa20_inputbytes = function() {
                        return (Q._crypto_core_salsa20_inputbytes = j.Lb)();
                    }, Q._crypto_core_salsa20_keybytes = function() {
                        return (Q._crypto_core_salsa20_keybytes = j.Mb)();
                    }, Q._crypto_core_salsa20_constbytes = function() {
                        return (Q._crypto_core_salsa20_constbytes = j.Nb)();
                    }, Q._crypto_core_salsa2012 = function(A, I, g, C) {
                        return (Q._crypto_core_salsa2012 = j.Ob)(A, I, g, C);
                    }, Q._crypto_core_salsa2012_outputbytes = function() {
                        return (Q._crypto_core_salsa2012_outputbytes = j.Pb)();
                    }, Q._crypto_core_salsa2012_inputbytes = function() {
                        return (Q._crypto_core_salsa2012_inputbytes = j.Qb)();
                    }, Q._crypto_core_salsa2012_keybytes = function() {
                        return (Q._crypto_core_salsa2012_keybytes = j.Rb)();
                    }, Q._crypto_core_salsa2012_constbytes = function() {
                        return (Q._crypto_core_salsa2012_constbytes = j.Sb)();
                    }, Q._crypto_core_salsa208 = function(A, I, g, C) {
                        return (Q._crypto_core_salsa208 = j.Tb)(A, I, g, C);
                    }, Q._crypto_core_salsa208_outputbytes = function() {
                        return (Q._crypto_core_salsa208_outputbytes = j.Ub)();
                    }, Q._crypto_core_salsa208_inputbytes = function() {
                        return (Q._crypto_core_salsa208_inputbytes = j.Vb)();
                    }, Q._crypto_core_salsa208_keybytes = function() {
                        return (Q._crypto_core_salsa208_keybytes = j.Wb)();
                    }, Q._crypto_core_salsa208_constbytes = function() {
                        return (Q._crypto_core_salsa208_constbytes = j.Xb)();
                    }, Q._crypto_generichash_bytes_min = function() {
                        return (Q._crypto_generichash_bytes_min = j.Yb)();
                    }, Q._crypto_generichash_bytes_max = function() {
                        return (Q._crypto_generichash_bytes_max = j.Zb)();
                    }, Q._crypto_generichash_bytes = function() {
                        return (Q._crypto_generichash_bytes = j._b)();
                    }, Q._crypto_generichash_keybytes_min = function() {
                        return (Q._crypto_generichash_keybytes_min = j.$b)();
                    }, Q._crypto_generichash_keybytes_max = function() {
                        return (Q._crypto_generichash_keybytes_max = j.ac)();
                    }, Q._crypto_generichash_keybytes = function() {
                        return (Q._crypto_generichash_keybytes = j.bc)();
                    }, Q._crypto_generichash_primitive = function() {
                        return (Q._crypto_generichash_primitive = j.cc)();
                    }, Q._crypto_generichash_statebytes = function() {
                        return (Q._crypto_generichash_statebytes = j.dc)();
                    }, Q._crypto_generichash = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_generichash = j.ec)(A, I, g, C, B, i, o);
                    }, Q._crypto_generichash_init = function(A, I, g, C) {
                        return (Q._crypto_generichash_init = j.fc)(A, I, g, C);
                    }, Q._crypto_generichash_update = function(A, I, g, C) {
                        return (Q._crypto_generichash_update = j.gc)(A, I, g, C);
                    }, Q._crypto_generichash_final = function(A, I, g) {
                        return (Q._crypto_generichash_final = j.hc)(A, I, g);
                    }, Q._crypto_generichash_keygen = function(A) {
                        return (Q._crypto_generichash_keygen = j.ic)(A);
                    }, Q._crypto_generichash_blake2b_bytes_min = function() {
                        return (Q._crypto_generichash_blake2b_bytes_min = j.jc)();
                    }, Q._crypto_generichash_blake2b_bytes_max = function() {
                        return (Q._crypto_generichash_blake2b_bytes_max = j.kc)();
                    }, Q._crypto_generichash_blake2b_bytes = function() {
                        return (Q._crypto_generichash_blake2b_bytes = j.lc)();
                    }, Q._crypto_generichash_blake2b_keybytes_min = function() {
                        return (Q._crypto_generichash_blake2b_keybytes_min = j.mc)();
                    }, Q._crypto_generichash_blake2b_keybytes_max = function() {
                        return (Q._crypto_generichash_blake2b_keybytes_max = j.nc)();
                    }, Q._crypto_generichash_blake2b_keybytes = function() {
                        return (Q._crypto_generichash_blake2b_keybytes = j.oc)();
                    }, Q._crypto_generichash_blake2b_saltbytes = function() {
                        return (Q._crypto_generichash_blake2b_saltbytes = j.pc)();
                    }, Q._crypto_generichash_blake2b_personalbytes = function() {
                        return (Q._crypto_generichash_blake2b_personalbytes = j.qc)();
                    }, Q._crypto_generichash_blake2b_statebytes = function() {
                        return (Q._crypto_generichash_blake2b_statebytes = j.rc)();
                    }, Q._crypto_generichash_blake2b_keygen = function(A) {
                        return (Q._crypto_generichash_blake2b_keygen = j.sc)(A);
                    }, Q._crypto_generichash_blake2b = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_generichash_blake2b = j.tc)(A, I, g, C, B, i, o);
                    }, Q._crypto_generichash_blake2b_salt_personal = function(A, I, g, C, B, i, o, E, a) {
                        return (Q._crypto_generichash_blake2b_salt_personal = j.uc)(A, I, g, C, B, i, o, E, a);
                    }, Q._crypto_generichash_blake2b_init = function(A, I, g, C) {
                        return (Q._crypto_generichash_blake2b_init = j.vc)(A, I, g, C);
                    }, Q._crypto_generichash_blake2b_init_salt_personal = function(A, I, g, C, B, i) {
                        return (Q._crypto_generichash_blake2b_init_salt_personal = j.wc)(A, I, g, C, B, i);
                    }, Q._crypto_generichash_blake2b_update = function(A, I, g, C) {
                        return (Q._crypto_generichash_blake2b_update = j.xc)(A, I, g, C);
                    }, Q._crypto_generichash_blake2b_final = function(A, I, g) {
                        return (Q._crypto_generichash_blake2b_final = j.yc)(A, I, g);
                    }, Q._crypto_hash_bytes = function() {
                        return (Q._crypto_hash_bytes = j.zc)();
                    }, Q._crypto_hash = function(A, I, g, C) {
                        return (Q._crypto_hash = j.Ac)(A, I, g, C);
                    }, Q._crypto_hash_primitive = function() {
                        return (Q._crypto_hash_primitive = j.Bc)();
                    }, Q._crypto_hash_sha256_bytes = function() {
                        return (Q._crypto_hash_sha256_bytes = j.Cc)();
                    }, Q._crypto_hash_sha256_statebytes = function() {
                        return (Q._crypto_hash_sha256_statebytes = j.Dc)();
                    }, Q._crypto_hash_sha256_init = function(A) {
                        return (Q._crypto_hash_sha256_init = j.Ec)(A);
                    }, Q._crypto_hash_sha256_update = function(A, I, g, C) {
                        return (Q._crypto_hash_sha256_update = j.Fc)(A, I, g, C);
                    }, Q._crypto_hash_sha256_final = function(A, I) {
                        return (Q._crypto_hash_sha256_final = j.Gc)(A, I);
                    }, Q._crypto_hash_sha256 = function(A, I, g, C) {
                        return (Q._crypto_hash_sha256 = j.Hc)(A, I, g, C);
                    }, Q._crypto_hash_sha512_bytes = function() {
                        return (Q._crypto_hash_sha512_bytes = j.Ic)();
                    }, Q._crypto_hash_sha512_statebytes = function() {
                        return (Q._crypto_hash_sha512_statebytes = j.Jc)();
                    }, Q._crypto_hash_sha512_init = function(A) {
                        return (Q._crypto_hash_sha512_init = j.Kc)(A);
                    }, Q._crypto_hash_sha512_update = function(A, I, g, C) {
                        return (Q._crypto_hash_sha512_update = j.Lc)(A, I, g, C);
                    }, Q._crypto_hash_sha512_final = function(A, I) {
                        return (Q._crypto_hash_sha512_final = j.Mc)(A, I);
                    }, Q._crypto_hash_sha512 = function(A, I, g, C) {
                        return (Q._crypto_hash_sha512 = j.Nc)(A, I, g, C);
                    }, Q._crypto_kdf_blake2b_bytes_min = function() {
                        return (Q._crypto_kdf_blake2b_bytes_min = j.Oc)();
                    }, Q._crypto_kdf_blake2b_bytes_max = function() {
                        return (Q._crypto_kdf_blake2b_bytes_max = j.Pc)();
                    }, Q._crypto_kdf_blake2b_contextbytes = function() {
                        return (Q._crypto_kdf_blake2b_contextbytes = j.Qc)();
                    }, Q._crypto_kdf_blake2b_keybytes = function() {
                        return (Q._crypto_kdf_blake2b_keybytes = j.Rc)();
                    }, Q._crypto_kdf_blake2b_derive_from_key = function(A, I, g, C, B, i) {
                        return (Q._crypto_kdf_blake2b_derive_from_key = j.Sc)(A, I, g, C, B, i);
                    }, Q._crypto_kdf_primitive = function() {
                        return (Q._crypto_kdf_primitive = j.Tc)();
                    }, Q._crypto_kdf_bytes_min = function() {
                        return (Q._crypto_kdf_bytes_min = j.Uc)();
                    }, Q._crypto_kdf_bytes_max = function() {
                        return (Q._crypto_kdf_bytes_max = j.Vc)();
                    }, Q._crypto_kdf_contextbytes = function() {
                        return (Q._crypto_kdf_contextbytes = j.Wc)();
                    }, Q._crypto_kdf_keybytes = function() {
                        return (Q._crypto_kdf_keybytes = j.Xc)();
                    }, Q._crypto_kdf_derive_from_key = function(A, I, g, C, B, i) {
                        return (Q._crypto_kdf_derive_from_key = j.Yc)(A, I, g, C, B, i);
                    }, Q._crypto_kdf_keygen = function(A) {
                        return (Q._crypto_kdf_keygen = j.Zc)(A);
                    }, Q._crypto_kdf_hkdf_sha256_extract_init = function(A, I, g) {
                        return (Q._crypto_kdf_hkdf_sha256_extract_init = j._c)(A, I, g);
                    }, Q._crypto_kdf_hkdf_sha256_extract_update = function(A, I, g) {
                        return (Q._crypto_kdf_hkdf_sha256_extract_update = j.$c)(A, I, g);
                    }, Q._crypto_kdf_hkdf_sha256_extract_final = function(A, I) {
                        return (Q._crypto_kdf_hkdf_sha256_extract_final = j.ad)(A, I);
                    }, Q._crypto_kdf_hkdf_sha256_extract = function(A, I, g, C, B) {
                        return (Q._crypto_kdf_hkdf_sha256_extract = j.bd)(A, I, g, C, B);
                    }, Q._crypto_kdf_hkdf_sha256_keygen = function(A) {
                        return (Q._crypto_kdf_hkdf_sha256_keygen = j.cd)(A);
                    }, Q._crypto_kdf_hkdf_sha256_expand = function(A, I, g, C, B) {
                        return (Q._crypto_kdf_hkdf_sha256_expand = j.dd)(A, I, g, C, B);
                    }, Q._crypto_kdf_hkdf_sha256_keybytes = function() {
                        return (Q._crypto_kdf_hkdf_sha256_keybytes = j.ed)();
                    }, Q._crypto_kdf_hkdf_sha256_bytes_min = function() {
                        return (Q._crypto_kdf_hkdf_sha256_bytes_min = j.fd)();
                    }, Q._crypto_kdf_hkdf_sha256_bytes_max = function() {
                        return (Q._crypto_kdf_hkdf_sha256_bytes_max = j.gd)();
                    }, Q._crypto_kdf_hkdf_sha256_statebytes = function() {
                        return (Q._crypto_kdf_hkdf_sha256_statebytes = j.hd)();
                    }, Q._crypto_kdf_hkdf_sha512_extract_init = function(A, I, g) {
                        return (Q._crypto_kdf_hkdf_sha512_extract_init = j.id)(A, I, g);
                    }, Q._crypto_kdf_hkdf_sha512_extract_update = function(A, I, g) {
                        return (Q._crypto_kdf_hkdf_sha512_extract_update = j.jd)(A, I, g);
                    }, Q._crypto_kdf_hkdf_sha512_extract_final = function(A, I) {
                        return (Q._crypto_kdf_hkdf_sha512_extract_final = j.kd)(A, I);
                    }, Q._crypto_kdf_hkdf_sha512_extract = function(A, I, g, C, B) {
                        return (Q._crypto_kdf_hkdf_sha512_extract = j.ld)(A, I, g, C, B);
                    }, Q._crypto_kdf_hkdf_sha512_keygen = function(A) {
                        return (Q._crypto_kdf_hkdf_sha512_keygen = j.md)(A);
                    }, Q._crypto_kdf_hkdf_sha512_expand = function(A, I, g, C, B) {
                        return (Q._crypto_kdf_hkdf_sha512_expand = j.nd)(A, I, g, C, B);
                    }, Q._crypto_kdf_hkdf_sha512_keybytes = function() {
                        return (Q._crypto_kdf_hkdf_sha512_keybytes = j.od)();
                    }, Q._crypto_kdf_hkdf_sha512_bytes_min = function() {
                        return (Q._crypto_kdf_hkdf_sha512_bytes_min = j.pd)();
                    }, Q._crypto_kdf_hkdf_sha512_bytes_max = function() {
                        return (Q._crypto_kdf_hkdf_sha512_bytes_max = j.qd)();
                    }, Q._crypto_kx_seed_keypair = function(A, I, g) {
                        return (Q._crypto_kx_seed_keypair = j.rd)(A, I, g);
                    }, Q._crypto_kx_keypair = function(A, I) {
                        return (Q._crypto_kx_keypair = j.sd)(A, I);
                    }, Q._crypto_kx_client_session_keys = function(A, I, g, C, B) {
                        return (Q._crypto_kx_client_session_keys = j.td)(A, I, g, C, B);
                    }, Q._crypto_kx_server_session_keys = function(A, I, g, C, B) {
                        return (Q._crypto_kx_server_session_keys = j.ud)(A, I, g, C, B);
                    }, Q._crypto_kx_publickeybytes = function() {
                        return (Q._crypto_kx_publickeybytes = j.vd)();
                    }, Q._crypto_kx_secretkeybytes = function() {
                        return (Q._crypto_kx_secretkeybytes = j.wd)();
                    }, Q._crypto_kx_seedbytes = function() {
                        return (Q._crypto_kx_seedbytes = j.xd)();
                    }, Q._crypto_kx_sessionkeybytes = function() {
                        return (Q._crypto_kx_sessionkeybytes = j.yd)();
                    }, Q._crypto_kx_primitive = function() {
                        return (Q._crypto_kx_primitive = j.zd)();
                    }, Q._crypto_onetimeauth_statebytes = function() {
                        return (Q._crypto_onetimeauth_statebytes = j.Ad)();
                    }, Q._crypto_onetimeauth_bytes = function() {
                        return (Q._crypto_onetimeauth_bytes = j.Bd)();
                    }, Q._crypto_onetimeauth_keybytes = function() {
                        return (Q._crypto_onetimeauth_keybytes = j.Cd)();
                    }, Q._crypto_onetimeauth = function(A, I, g, C, B) {
                        return (Q._crypto_onetimeauth = j.Dd)(A, I, g, C, B);
                    }, Q._crypto_onetimeauth_verify = function(A, I, g, C, B) {
                        return (Q._crypto_onetimeauth_verify = j.Ed)(A, I, g, C, B);
                    }, Q._crypto_onetimeauth_init = function(A, I) {
                        return (Q._crypto_onetimeauth_init = j.Fd)(A, I);
                    }, Q._crypto_onetimeauth_update = function(A, I, g, C) {
                        return (Q._crypto_onetimeauth_update = j.Gd)(A, I, g, C);
                    }, Q._crypto_onetimeauth_final = function(A, I) {
                        return (Q._crypto_onetimeauth_final = j.Hd)(A, I);
                    }, Q._crypto_onetimeauth_primitive = function() {
                        return (Q._crypto_onetimeauth_primitive = j.Id)();
                    }, Q._crypto_onetimeauth_keygen = function(A) {
                        return (Q._crypto_onetimeauth_keygen = j.Jd)(A);
                    }, Q._crypto_onetimeauth_poly1305 = function(A, I, g, C, B) {
                        return (Q._crypto_onetimeauth_poly1305 = j.Kd)(A, I, g, C, B);
                    }, Q._crypto_onetimeauth_poly1305_verify = function(A, I, g, C, B) {
                        return (Q._crypto_onetimeauth_poly1305_verify = j.Ld)(A, I, g, C, B);
                    }, Q._crypto_onetimeauth_poly1305_init = function(A, I) {
                        return (Q._crypto_onetimeauth_poly1305_init = j.Md)(A, I);
                    }, Q._crypto_onetimeauth_poly1305_update = function(A, I, g, C) {
                        return (Q._crypto_onetimeauth_poly1305_update = j.Nd)(A, I, g, C);
                    }, Q._crypto_onetimeauth_poly1305_final = function(A, I) {
                        return (Q._crypto_onetimeauth_poly1305_final = j.Od)(A, I);
                    }, Q._crypto_onetimeauth_poly1305_bytes = function() {
                        return (Q._crypto_onetimeauth_poly1305_bytes = j.Pd)();
                    }, Q._crypto_onetimeauth_poly1305_keybytes = function() {
                        return (Q._crypto_onetimeauth_poly1305_keybytes = j.Qd)();
                    }, Q._crypto_onetimeauth_poly1305_statebytes = function() {
                        return (Q._crypto_onetimeauth_poly1305_statebytes = j.Rd)();
                    }, Q._crypto_onetimeauth_poly1305_keygen = function(A) {
                        return (Q._crypto_onetimeauth_poly1305_keygen = j.Sd)(A);
                    }, Q._crypto_pwhash_argon2i_alg_argon2i13 = function() {
                        return (Q._crypto_pwhash_argon2i_alg_argon2i13 = j.Td)();
                    }, Q._crypto_pwhash_argon2i_bytes_min = function() {
                        return (Q._crypto_pwhash_argon2i_bytes_min = j.Ud)();
                    }, Q._crypto_pwhash_argon2i_bytes_max = function() {
                        return (Q._crypto_pwhash_argon2i_bytes_max = j.Vd)();
                    }, Q._crypto_pwhash_argon2i_passwd_min = function() {
                        return (Q._crypto_pwhash_argon2i_passwd_min = j.Wd)();
                    }, Q._crypto_pwhash_argon2i_passwd_max = function() {
                        return (Q._crypto_pwhash_argon2i_passwd_max = j.Xd)();
                    }, Q._crypto_pwhash_argon2i_saltbytes = function() {
                        return (Q._crypto_pwhash_argon2i_saltbytes = j.Yd)();
                    }, Q._crypto_pwhash_argon2i_strbytes = function() {
                        return (Q._crypto_pwhash_argon2i_strbytes = j.Zd)();
                    }, Q._crypto_pwhash_argon2i_strprefix = function() {
                        return (Q._crypto_pwhash_argon2i_strprefix = j._d)();
                    }, Q._crypto_pwhash_argon2i_opslimit_min = function() {
                        return (Q._crypto_pwhash_argon2i_opslimit_min = j.$d)();
                    }, Q._crypto_pwhash_argon2i_opslimit_max = function() {
                        return (Q._crypto_pwhash_argon2i_opslimit_max = j.ae)();
                    }, Q._crypto_pwhash_argon2i_memlimit_min = function() {
                        return (Q._crypto_pwhash_argon2i_memlimit_min = j.be)();
                    }, Q._crypto_pwhash_argon2i_memlimit_max = function() {
                        return (Q._crypto_pwhash_argon2i_memlimit_max = j.ce)();
                    }, Q._crypto_pwhash_argon2i_opslimit_interactive = function() {
                        return (Q._crypto_pwhash_argon2i_opslimit_interactive = j.de)();
                    }, Q._crypto_pwhash_argon2i_memlimit_interactive = function() {
                        return (Q._crypto_pwhash_argon2i_memlimit_interactive = j.ee)();
                    }, Q._crypto_pwhash_argon2i_opslimit_moderate = function() {
                        return (Q._crypto_pwhash_argon2i_opslimit_moderate = j.fe)();
                    }, Q._crypto_pwhash_argon2i_memlimit_moderate = function() {
                        return (Q._crypto_pwhash_argon2i_memlimit_moderate = j.ge)();
                    }, Q._crypto_pwhash_argon2i_opslimit_sensitive = function() {
                        return (Q._crypto_pwhash_argon2i_opslimit_sensitive = j.he)();
                    }, Q._crypto_pwhash_argon2i_memlimit_sensitive = function() {
                        return (Q._crypto_pwhash_argon2i_memlimit_sensitive = j.ie)();
                    }, Q._crypto_pwhash_argon2i = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_pwhash_argon2i = j.je)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_pwhash_argon2i_str = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_pwhash_argon2i_str = j.ke)(A, I, g, C, B, i, o);
                    }, Q._crypto_pwhash_argon2i_str_verify = function(A, I, g, C) {
                        return (Q._crypto_pwhash_argon2i_str_verify = j.le)(A, I, g, C);
                    }, Q._crypto_pwhash_argon2i_str_needs_rehash = function(A, I, g, C) {
                        return (Q._crypto_pwhash_argon2i_str_needs_rehash = j.me)(A, I, g, C);
                    }, Q._crypto_pwhash_argon2id_str_needs_rehash = function(A, I, g, C) {
                        return (Q._crypto_pwhash_argon2id_str_needs_rehash = j.ne)(A, I, g, C);
                    }, Q._crypto_pwhash_argon2id_alg_argon2id13 = function() {
                        return (Q._crypto_pwhash_argon2id_alg_argon2id13 = j.oe)();
                    }, Q._crypto_pwhash_argon2id_bytes_min = function() {
                        return (Q._crypto_pwhash_argon2id_bytes_min = j.pe)();
                    }, Q._crypto_pwhash_argon2id_bytes_max = function() {
                        return (Q._crypto_pwhash_argon2id_bytes_max = j.qe)();
                    }, Q._crypto_pwhash_argon2id_passwd_min = function() {
                        return (Q._crypto_pwhash_argon2id_passwd_min = j.re)();
                    }, Q._crypto_pwhash_argon2id_passwd_max = function() {
                        return (Q._crypto_pwhash_argon2id_passwd_max = j.se)();
                    }, Q._crypto_pwhash_argon2id_saltbytes = function() {
                        return (Q._crypto_pwhash_argon2id_saltbytes = j.te)();
                    }, Q._crypto_pwhash_argon2id_strbytes = function() {
                        return (Q._crypto_pwhash_argon2id_strbytes = j.ue)();
                    }, Q._crypto_pwhash_argon2id_strprefix = function() {
                        return (Q._crypto_pwhash_argon2id_strprefix = j.ve)();
                    }, Q._crypto_pwhash_argon2id_opslimit_min = function() {
                        return (Q._crypto_pwhash_argon2id_opslimit_min = j.we)();
                    }, Q._crypto_pwhash_argon2id_opslimit_max = function() {
                        return (Q._crypto_pwhash_argon2id_opslimit_max = j.xe)();
                    }, Q._crypto_pwhash_argon2id_memlimit_min = function() {
                        return (Q._crypto_pwhash_argon2id_memlimit_min = j.ye)();
                    }, Q._crypto_pwhash_argon2id_memlimit_max = function() {
                        return (Q._crypto_pwhash_argon2id_memlimit_max = j.ze)();
                    }, Q._crypto_pwhash_argon2id_opslimit_interactive = function() {
                        return (Q._crypto_pwhash_argon2id_opslimit_interactive = j.Ae)();
                    }, Q._crypto_pwhash_argon2id_memlimit_interactive = function() {
                        return (Q._crypto_pwhash_argon2id_memlimit_interactive = j.Be)();
                    }, Q._crypto_pwhash_argon2id_opslimit_moderate = function() {
                        return (Q._crypto_pwhash_argon2id_opslimit_moderate = j.Ce)();
                    }, Q._crypto_pwhash_argon2id_memlimit_moderate = function() {
                        return (Q._crypto_pwhash_argon2id_memlimit_moderate = j.De)();
                    }, Q._crypto_pwhash_argon2id_opslimit_sensitive = function() {
                        return (Q._crypto_pwhash_argon2id_opslimit_sensitive = j.Ee)();
                    }, Q._crypto_pwhash_argon2id_memlimit_sensitive = function() {
                        return (Q._crypto_pwhash_argon2id_memlimit_sensitive = j.Fe)();
                    }, Q._crypto_pwhash_argon2id = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_pwhash_argon2id = j.Ge)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_pwhash_argon2id_str = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_pwhash_argon2id_str = j.He)(A, I, g, C, B, i, o);
                    }, Q._crypto_pwhash_argon2id_str_verify = function(A, I, g, C) {
                        return (Q._crypto_pwhash_argon2id_str_verify = j.Ie)(A, I, g, C);
                    }, Q._crypto_pwhash_alg_argon2i13 = function() {
                        return (Q._crypto_pwhash_alg_argon2i13 = j.Je)();
                    }, Q._crypto_pwhash_alg_argon2id13 = function() {
                        return (Q._crypto_pwhash_alg_argon2id13 = j.Ke)();
                    }, Q._crypto_pwhash_alg_default = function() {
                        return (Q._crypto_pwhash_alg_default = j.Le)();
                    }, Q._crypto_pwhash_bytes_min = function() {
                        return (Q._crypto_pwhash_bytes_min = j.Me)();
                    }, Q._crypto_pwhash_bytes_max = function() {
                        return (Q._crypto_pwhash_bytes_max = j.Ne)();
                    }, Q._crypto_pwhash_passwd_min = function() {
                        return (Q._crypto_pwhash_passwd_min = j.Oe)();
                    }, Q._crypto_pwhash_passwd_max = function() {
                        return (Q._crypto_pwhash_passwd_max = j.Pe)();
                    }, Q._crypto_pwhash_saltbytes = function() {
                        return (Q._crypto_pwhash_saltbytes = j.Qe)();
                    }, Q._crypto_pwhash_strbytes = function() {
                        return (Q._crypto_pwhash_strbytes = j.Re)();
                    }, Q._crypto_pwhash_strprefix = function() {
                        return (Q._crypto_pwhash_strprefix = j.Se)();
                    }, Q._crypto_pwhash_opslimit_min = function() {
                        return (Q._crypto_pwhash_opslimit_min = j.Te)();
                    }, Q._crypto_pwhash_opslimit_max = function() {
                        return (Q._crypto_pwhash_opslimit_max = j.Ue)();
                    }, Q._crypto_pwhash_memlimit_min = function() {
                        return (Q._crypto_pwhash_memlimit_min = j.Ve)();
                    }, Q._crypto_pwhash_memlimit_max = function() {
                        return (Q._crypto_pwhash_memlimit_max = j.We)();
                    }, Q._crypto_pwhash_opslimit_interactive = function() {
                        return (Q._crypto_pwhash_opslimit_interactive = j.Xe)();
                    }, Q._crypto_pwhash_memlimit_interactive = function() {
                        return (Q._crypto_pwhash_memlimit_interactive = j.Ye)();
                    }, Q._crypto_pwhash_opslimit_moderate = function() {
                        return (Q._crypto_pwhash_opslimit_moderate = j.Ze)();
                    }, Q._crypto_pwhash_memlimit_moderate = function() {
                        return (Q._crypto_pwhash_memlimit_moderate = j._e)();
                    }, Q._crypto_pwhash_opslimit_sensitive = function() {
                        return (Q._crypto_pwhash_opslimit_sensitive = j.$e)();
                    }, Q._crypto_pwhash_memlimit_sensitive = function() {
                        return (Q._crypto_pwhash_memlimit_sensitive = j.af)();
                    }, Q._crypto_pwhash = function(A, I, g, C, B, i, o, E, a, _, c) {
                        return (Q._crypto_pwhash = j.bf)(A, I, g, C, B, i, o, E, a, _, c);
                    }, Q._crypto_pwhash_str = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_pwhash_str = j.cf)(A, I, g, C, B, i, o);
                    }, Q._crypto_pwhash_str_alg = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_pwhash_str_alg = j.df)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_pwhash_str_verify = function(A, I, g, C) {
                        return (Q._crypto_pwhash_str_verify = j.ef)(A, I, g, C);
                    }, Q._crypto_pwhash_str_needs_rehash = function(A, I, g, C) {
                        return (Q._crypto_pwhash_str_needs_rehash = j.ff)(A, I, g, C);
                    }, Q._crypto_pwhash_primitive = function() {
                        return (Q._crypto_pwhash_primitive = j.gf)();
                    }, Q._crypto_scalarmult_primitive = function() {
                        return (Q._crypto_scalarmult_primitive = j.hf)();
                    }, Q._crypto_scalarmult_base = function(A, I) {
                        return (Q._crypto_scalarmult_base = j.jf)(A, I);
                    }, Q._crypto_scalarmult = function(A, I, g) {
                        return (Q._crypto_scalarmult = j.kf)(A, I, g);
                    }, Q._crypto_scalarmult_bytes = function() {
                        return (Q._crypto_scalarmult_bytes = j.lf)();
                    }, Q._crypto_scalarmult_scalarbytes = function() {
                        return (Q._crypto_scalarmult_scalarbytes = j.mf)();
                    }, Q._crypto_scalarmult_curve25519 = function(A, I, g) {
                        return (Q._crypto_scalarmult_curve25519 = j.nf)(A, I, g);
                    }, Q._crypto_scalarmult_curve25519_base = function(A, I) {
                        return (Q._crypto_scalarmult_curve25519_base = j.of)(A, I);
                    }, Q._crypto_scalarmult_curve25519_bytes = function() {
                        return (Q._crypto_scalarmult_curve25519_bytes = j.pf)();
                    }, Q._crypto_scalarmult_curve25519_scalarbytes = function() {
                        return (Q._crypto_scalarmult_curve25519_scalarbytes = j.qf)();
                    }, Q._crypto_secretbox_keybytes = function() {
                        return (Q._crypto_secretbox_keybytes = j.rf)();
                    }, Q._crypto_secretbox_noncebytes = function() {
                        return (Q._crypto_secretbox_noncebytes = j.sf)();
                    }, Q._crypto_secretbox_zerobytes = function() {
                        return (Q._crypto_secretbox_zerobytes = j.tf)();
                    }, Q._crypto_secretbox_boxzerobytes = function() {
                        return (Q._crypto_secretbox_boxzerobytes = j.uf)();
                    }, Q._crypto_secretbox_macbytes = function() {
                        return (Q._crypto_secretbox_macbytes = j.vf)();
                    }, Q._crypto_secretbox_messagebytes_max = function() {
                        return (Q._crypto_secretbox_messagebytes_max = j.wf)();
                    }, Q._crypto_secretbox_primitive = function() {
                        return (Q._crypto_secretbox_primitive = j.xf)();
                    }, Q._crypto_secretbox = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox = j.yf)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_open = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_open = j.zf)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_keygen = function(A) {
                        return (Q._crypto_secretbox_keygen = j.Af)(A);
                    }, Q._crypto_secretbox_detached = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_secretbox_detached = j.Bf)(A, I, g, C, B, i, o);
                    }, Q._crypto_secretbox_easy = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_easy = j.Cf)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_open_detached = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_secretbox_open_detached = j.Df)(A, I, g, C, B, i, o);
                    }, Q._crypto_secretbox_open_easy = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_open_easy = j.Ef)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_xsalsa20poly1305 = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_xsalsa20poly1305 = j.Ff)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_xsalsa20poly1305_open = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_xsalsa20poly1305_open = j.Gf)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_xsalsa20poly1305_keybytes = function() {
                        return (Q._crypto_secretbox_xsalsa20poly1305_keybytes = j.Hf)();
                    }, Q._crypto_secretbox_xsalsa20poly1305_noncebytes = function() {
                        return (Q._crypto_secretbox_xsalsa20poly1305_noncebytes = j.If)();
                    }, Q._crypto_secretbox_xsalsa20poly1305_zerobytes = function() {
                        return (Q._crypto_secretbox_xsalsa20poly1305_zerobytes = j.Jf)();
                    }, Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = function() {
                        return (Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = j.Kf)();
                    }, Q._crypto_secretbox_xsalsa20poly1305_macbytes = function() {
                        return (Q._crypto_secretbox_xsalsa20poly1305_macbytes = j.Lf)();
                    }, Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = function() {
                        return (Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = j.Mf)();
                    }, Q._crypto_secretbox_xsalsa20poly1305_keygen = function(A) {
                        return (Q._crypto_secretbox_xsalsa20poly1305_keygen = j.Nf)(A);
                    }, Q._crypto_secretstream_xchacha20poly1305_keygen = function(A) {
                        return (Q._crypto_secretstream_xchacha20poly1305_keygen = j.Of)(A);
                    }, Q._crypto_secretstream_xchacha20poly1305_init_push = function(A, I, g) {
                        return (Q._crypto_secretstream_xchacha20poly1305_init_push = j.Pf)(A, I, g);
                    }, Q._crypto_secretstream_xchacha20poly1305_init_pull = function(A, I, g) {
                        return (Q._crypto_secretstream_xchacha20poly1305_init_pull = j.Qf)(A, I, g);
                    }, Q._crypto_secretstream_xchacha20poly1305_rekey = function(A) {
                        return (Q._crypto_secretstream_xchacha20poly1305_rekey = j.Rf)(A);
                    }, Q._crypto_secretstream_xchacha20poly1305_push = function(A, I, g, C, B, i, o, E, a, _) {
                        return (Q._crypto_secretstream_xchacha20poly1305_push = j.Sf)(A, I, g, C, B, i, o, E, a, _);
                    }, Q._crypto_secretstream_xchacha20poly1305_pull = function(A, I, g, C, B, i, o, E, a, _) {
                        return (Q._crypto_secretstream_xchacha20poly1305_pull = j.Tf)(A, I, g, C, B, i, o, E, a, _);
                    }, Q._crypto_secretstream_xchacha20poly1305_statebytes = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_statebytes = j.Uf)();
                    }, Q._crypto_secretstream_xchacha20poly1305_abytes = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_abytes = j.Vf)();
                    }, Q._crypto_secretstream_xchacha20poly1305_headerbytes = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_headerbytes = j.Wf)();
                    }, Q._crypto_secretstream_xchacha20poly1305_keybytes = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_keybytes = j.Xf)();
                    }, Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = j.Yf)();
                    }, Q._crypto_secretstream_xchacha20poly1305_tag_message = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_tag_message = j.Zf)();
                    }, Q._crypto_secretstream_xchacha20poly1305_tag_push = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_tag_push = j._f)();
                    }, Q._crypto_secretstream_xchacha20poly1305_tag_rekey = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_tag_rekey = j.$f)();
                    }, Q._crypto_secretstream_xchacha20poly1305_tag_final = function() {
                        return (Q._crypto_secretstream_xchacha20poly1305_tag_final = j.ag)();
                    }, Q._crypto_shorthash_bytes = function() {
                        return (Q._crypto_shorthash_bytes = j.bg)();
                    }, Q._crypto_shorthash_keybytes = function() {
                        return (Q._crypto_shorthash_keybytes = j.cg)();
                    }, Q._crypto_shorthash_primitive = function() {
                        return (Q._crypto_shorthash_primitive = j.dg)();
                    }, Q._crypto_shorthash = function(A, I, g, C, B) {
                        return (Q._crypto_shorthash = j.eg)(A, I, g, C, B);
                    }, Q._crypto_shorthash_keygen = function(A) {
                        return (Q._crypto_shorthash_keygen = j.fg)(A);
                    }, Q._crypto_shorthash_siphash24_bytes = function() {
                        return (Q._crypto_shorthash_siphash24_bytes = j.gg)();
                    }, Q._crypto_shorthash_siphash24_keybytes = function() {
                        return (Q._crypto_shorthash_siphash24_keybytes = j.hg)();
                    }, Q._crypto_shorthash_siphash24 = function(A, I, g, C, B) {
                        return (Q._crypto_shorthash_siphash24 = j.ig)(A, I, g, C, B);
                    }, Q._crypto_sign_statebytes = function() {
                        return (Q._crypto_sign_statebytes = j.jg)();
                    }, Q._crypto_sign_bytes = function() {
                        return (Q._crypto_sign_bytes = j.kg)();
                    }, Q._crypto_sign_seedbytes = function() {
                        return (Q._crypto_sign_seedbytes = j.lg)();
                    }, Q._crypto_sign_publickeybytes = function() {
                        return (Q._crypto_sign_publickeybytes = j.mg)();
                    }, Q._crypto_sign_secretkeybytes = function() {
                        return (Q._crypto_sign_secretkeybytes = j.ng)();
                    }, Q._crypto_sign_messagebytes_max = function() {
                        return (Q._crypto_sign_messagebytes_max = j.og)();
                    }, Q._crypto_sign_primitive = function() {
                        return (Q._crypto_sign_primitive = j.pg)();
                    }, Q._crypto_sign_seed_keypair = function(A, I, g) {
                        return (Q._crypto_sign_seed_keypair = j.qg)(A, I, g);
                    }, Q._crypto_sign_keypair = function(A, I) {
                        return (Q._crypto_sign_keypair = j.rg)(A, I);
                    }, Q._crypto_sign = function(A, I, g, C, B, i) {
                        return (Q._crypto_sign = j.sg)(A, I, g, C, B, i);
                    }, Q._crypto_sign_open = function(A, I, g, C, B, i) {
                        return (Q._crypto_sign_open = j.tg)(A, I, g, C, B, i);
                    }, Q._crypto_sign_detached = function(A, I, g, C, B, i) {
                        return (Q._crypto_sign_detached = j.ug)(A, I, g, C, B, i);
                    }, Q._crypto_sign_verify_detached = function(A, I, g, C, B) {
                        return (Q._crypto_sign_verify_detached = j.vg)(A, I, g, C, B);
                    }, Q._crypto_sign_init = function(A) {
                        return (Q._crypto_sign_init = j.wg)(A);
                    }, Q._crypto_sign_update = function(A, I, g, C) {
                        return (Q._crypto_sign_update = j.xg)(A, I, g, C);
                    }, Q._crypto_sign_final_create = function(A, I, g, C) {
                        return (Q._crypto_sign_final_create = j.yg)(A, I, g, C);
                    }, Q._crypto_sign_final_verify = function(A, I, g) {
                        return (Q._crypto_sign_final_verify = j.zg)(A, I, g);
                    }, Q._crypto_sign_ed25519ph_statebytes = function() {
                        return (Q._crypto_sign_ed25519ph_statebytes = j.Ag)();
                    }, Q._crypto_sign_ed25519_bytes = function() {
                        return (Q._crypto_sign_ed25519_bytes = j.Bg)();
                    }, Q._crypto_sign_ed25519_seedbytes = function() {
                        return (Q._crypto_sign_ed25519_seedbytes = j.Cg)();
                    }, Q._crypto_sign_ed25519_publickeybytes = function() {
                        return (Q._crypto_sign_ed25519_publickeybytes = j.Dg)();
                    }, Q._crypto_sign_ed25519_secretkeybytes = function() {
                        return (Q._crypto_sign_ed25519_secretkeybytes = j.Eg)();
                    }, Q._crypto_sign_ed25519_messagebytes_max = function() {
                        return (Q._crypto_sign_ed25519_messagebytes_max = j.Fg)();
                    }, Q._crypto_sign_ed25519_sk_to_seed = function(A, I) {
                        return (Q._crypto_sign_ed25519_sk_to_seed = j.Gg)(A, I);
                    }, Q._crypto_sign_ed25519_sk_to_pk = function(A, I) {
                        return (Q._crypto_sign_ed25519_sk_to_pk = j.Hg)(A, I);
                    }, Q._crypto_sign_ed25519ph_init = function(A) {
                        return (Q._crypto_sign_ed25519ph_init = j.Ig)(A);
                    }, Q._crypto_sign_ed25519ph_update = function(A, I, g, C) {
                        return (Q._crypto_sign_ed25519ph_update = j.Jg)(A, I, g, C);
                    }, Q._crypto_sign_ed25519ph_final_create = function(A, I, g, C) {
                        return (Q._crypto_sign_ed25519ph_final_create = j.Kg)(A, I, g, C);
                    }, Q._crypto_sign_ed25519ph_final_verify = function(A, I, g) {
                        return (Q._crypto_sign_ed25519ph_final_verify = j.Lg)(A, I, g);
                    }, Q._crypto_sign_ed25519_seed_keypair = function(A, I, g) {
                        return (Q._crypto_sign_ed25519_seed_keypair = j.Mg)(A, I, g);
                    }, Q._crypto_sign_ed25519_keypair = function(A, I) {
                        return (Q._crypto_sign_ed25519_keypair = j.Ng)(A, I);
                    }, Q._crypto_sign_ed25519_pk_to_curve25519 = function(A, I) {
                        return (Q._crypto_sign_ed25519_pk_to_curve25519 = j.Og)(A, I);
                    }, Q._crypto_sign_ed25519_sk_to_curve25519 = function(A, I) {
                        return (Q._crypto_sign_ed25519_sk_to_curve25519 = j.Pg)(A, I);
                    }, Q._crypto_sign_ed25519_verify_detached = function(A, I, g, C, B) {
                        return (Q._crypto_sign_ed25519_verify_detached = j.Qg)(A, I, g, C, B);
                    }, Q._crypto_sign_ed25519_open = function(A, I, g, C, B, i) {
                        return (Q._crypto_sign_ed25519_open = j.Rg)(A, I, g, C, B, i);
                    }, Q._crypto_sign_ed25519_detached = function(A, I, g, C, B, i) {
                        return (Q._crypto_sign_ed25519_detached = j.Sg)(A, I, g, C, B, i);
                    }, Q._crypto_sign_ed25519 = function(A, I, g, C, B, i) {
                        return (Q._crypto_sign_ed25519 = j.Tg)(A, I, g, C, B, i);
                    }, Q._crypto_stream_chacha20_keybytes = function() {
                        return (Q._crypto_stream_chacha20_keybytes = j.Ug)();
                    }, Q._crypto_stream_chacha20_noncebytes = function() {
                        return (Q._crypto_stream_chacha20_noncebytes = j.Vg)();
                    }, Q._crypto_stream_chacha20_messagebytes_max = function() {
                        return (Q._crypto_stream_chacha20_messagebytes_max = j.Wg)();
                    }, Q._crypto_stream_chacha20_ietf_keybytes = function() {
                        return (Q._crypto_stream_chacha20_ietf_keybytes = j.Xg)();
                    }, Q._crypto_stream_chacha20_ietf_noncebytes = function() {
                        return (Q._crypto_stream_chacha20_ietf_noncebytes = j.Yg)();
                    }, Q._crypto_stream_chacha20_ietf_messagebytes_max = function() {
                        return (Q._crypto_stream_chacha20_ietf_messagebytes_max = j.Zg)();
                    }, Q._crypto_stream_chacha20 = function(A, I, g, C, B) {
                        return (Q._crypto_stream_chacha20 = j._g)(A, I, g, C, B);
                    }, Q._crypto_stream_chacha20_xor_ic = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_stream_chacha20_xor_ic = j.$g)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_stream_chacha20_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_chacha20_xor = j.ah)(A, I, g, C, B, i);
                    }, Q._crypto_stream_chacha20_ietf = function(A, I, g, C, B) {
                        return (Q._crypto_stream_chacha20_ietf = j.bh)(A, I, g, C, B);
                    }, Q._crypto_stream_chacha20_ietf_xor_ic = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_stream_chacha20_ietf_xor_ic = j.ch)(A, I, g, C, B, i, o);
                    }, Q._crypto_stream_chacha20_ietf_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_chacha20_ietf_xor = j.dh)(A, I, g, C, B, i);
                    }, Q._crypto_stream_chacha20_ietf_keygen = function(A) {
                        return (Q._crypto_stream_chacha20_ietf_keygen = j.eh)(A);
                    }, Q._crypto_stream_chacha20_keygen = function(A) {
                        return (Q._crypto_stream_chacha20_keygen = j.fh)(A);
                    }, Q._crypto_stream_keybytes = function() {
                        return (Q._crypto_stream_keybytes = j.gh)();
                    }, Q._crypto_stream_noncebytes = function() {
                        return (Q._crypto_stream_noncebytes = j.hh)();
                    }, Q._crypto_stream_messagebytes_max = function() {
                        return (Q._crypto_stream_messagebytes_max = j.ih)();
                    }, Q._crypto_stream_primitive = function() {
                        return (Q._crypto_stream_primitive = j.jh)();
                    }, Q._crypto_stream = function(A, I, g, C, B) {
                        return (Q._crypto_stream = j.kh)(A, I, g, C, B);
                    }, Q._crypto_stream_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_xor = j.lh)(A, I, g, C, B, i);
                    }, Q._crypto_stream_keygen = function(A) {
                        return (Q._crypto_stream_keygen = j.mh)(A);
                    }, Q._crypto_stream_salsa20_keybytes = function() {
                        return (Q._crypto_stream_salsa20_keybytes = j.nh)();
                    }, Q._crypto_stream_salsa20_noncebytes = function() {
                        return (Q._crypto_stream_salsa20_noncebytes = j.oh)();
                    }, Q._crypto_stream_salsa20_messagebytes_max = function() {
                        return (Q._crypto_stream_salsa20_messagebytes_max = j.ph)();
                    }, Q._crypto_stream_salsa20 = function(A, I, g, C, B) {
                        return (Q._crypto_stream_salsa20 = j.qh)(A, I, g, C, B);
                    }, Q._crypto_stream_salsa20_xor_ic = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_stream_salsa20_xor_ic = j.rh)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_stream_salsa20_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_salsa20_xor = j.sh)(A, I, g, C, B, i);
                    }, Q._crypto_stream_salsa20_keygen = function(A) {
                        return (Q._crypto_stream_salsa20_keygen = j.th)(A);
                    }, Q._crypto_stream_xsalsa20 = function(A, I, g, C, B) {
                        return (Q._crypto_stream_xsalsa20 = j.uh)(A, I, g, C, B);
                    }, Q._crypto_stream_xsalsa20_xor_ic = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_stream_xsalsa20_xor_ic = j.vh)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_stream_xsalsa20_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_xsalsa20_xor = j.wh)(A, I, g, C, B, i);
                    }, Q._crypto_stream_xsalsa20_keybytes = function() {
                        return (Q._crypto_stream_xsalsa20_keybytes = j.xh)();
                    }, Q._crypto_stream_xsalsa20_noncebytes = function() {
                        return (Q._crypto_stream_xsalsa20_noncebytes = j.yh)();
                    }, Q._crypto_stream_xsalsa20_messagebytes_max = function() {
                        return (Q._crypto_stream_xsalsa20_messagebytes_max = j.zh)();
                    }, Q._crypto_stream_xsalsa20_keygen = function(A) {
                        return (Q._crypto_stream_xsalsa20_keygen = j.Ah)(A);
                    }, Q._crypto_verify_16_bytes = function() {
                        return (Q._crypto_verify_16_bytes = j.Bh)();
                    }, Q._crypto_verify_32_bytes = function() {
                        return (Q._crypto_verify_32_bytes = j.Ch)();
                    }, Q._crypto_verify_64_bytes = function() {
                        return (Q._crypto_verify_64_bytes = j.Dh)();
                    }, Q._crypto_verify_16 = function(A, I) {
                        return (Q._crypto_verify_16 = j.Eh)(A, I);
                    }, Q._crypto_verify_32 = function(A, I) {
                        return (Q._crypto_verify_32 = j.Fh)(A, I);
                    }, Q._crypto_verify_64 = function(A, I) {
                        return (Q._crypto_verify_64 = j.Gh)(A, I);
                    }, Q._randombytes_implementation_name = function() {
                        return (Q._randombytes_implementation_name = j.Hh)();
                    }, Q._randombytes_random = function() {
                        return (Q._randombytes_random = j.Ih)();
                    }, Q._randombytes_stir = function() {
                        return (Q._randombytes_stir = j.Jh)();
                    }, Q._randombytes_uniform = function(A) {
                        return (Q._randombytes_uniform = j.Kh)(A);
                    }, Q._randombytes_buf = function(A, I) {
                        return (Q._randombytes_buf = j.Lh)(A, I);
                    }, Q._randombytes_buf_deterministic = function(A, I, g) {
                        return (Q._randombytes_buf_deterministic = j.Mh)(A, I, g);
                    }, Q._randombytes_seedbytes = function() {
                        return (Q._randombytes_seedbytes = j.Nh)();
                    }, Q._randombytes_close = function() {
                        return (Q._randombytes_close = j.Oh)();
                    }, Q._randombytes = function(A, I, g) {
                        return (Q._randombytes = j.Ph)(A, I, g);
                    }, Q._sodium_bin2hex = function(A, I, g, C) {
                        return (Q._sodium_bin2hex = j.Qh)(A, I, g, C);
                    }, Q._sodium_hex2bin = function(A, I, g, C, B, i, o) {
                        return (Q._sodium_hex2bin = j.Rh)(A, I, g, C, B, i, o);
                    }, Q._sodium_base64_encoded_len = function(A, I) {
                        return (Q._sodium_base64_encoded_len = j.Sh)(A, I);
                    }, Q._sodium_bin2base64 = function(A, I, g, C, B) {
                        return (Q._sodium_bin2base64 = j.Th)(A, I, g, C, B);
                    }, Q._sodium_base642bin = function(A, I, g, C, B, i, o, E) {
                        return (Q._sodium_base642bin = j.Uh)(A, I, g, C, B, i, o, E);
                    }, Q._sodium_init = function() {
                        return (Q._sodium_init = j.Vh)();
                    }, Q._sodium_pad = function(A, I, g, C, B) {
                        return (Q._sodium_pad = j.Wh)(A, I, g, C, B);
                    }, Q._sodium_unpad = function(A, I, g, C) {
                        return (Q._sodium_unpad = j.Xh)(A, I, g, C);
                    }, Q._sodium_version_string = function() {
                        return (Q._sodium_version_string = j.Yh)();
                    }, Q._sodium_library_version_major = function() {
                        return (Q._sodium_library_version_major = j.Zh)();
                    }, Q._sodium_library_version_minor = function() {
                        return (Q._sodium_library_version_minor = j._h)();
                    }, Q._sodium_library_minimal = function() {
                        return (Q._sodium_library_minimal = j.$h)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = function(A, I, g) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = j.ai)(A, I, g);
                    }, Q._crypto_box_curve25519xchacha20poly1305_keypair = function(A, I) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_keypair = j.bi)(A, I);
                    }, Q._crypto_box_curve25519xchacha20poly1305_beforenm = function(A, I, g) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_beforenm = j.ci)(A, I, g);
                    }, Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = j.di)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_curve25519xchacha20poly1305_detached = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_detached = j.ei)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = j.fi)(A, I, g, C, B, i);
                    }, Q._crypto_box_curve25519xchacha20poly1305_easy = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_easy = j.gi)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = j.hi)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_curve25519xchacha20poly1305_open_detached = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_open_detached = j.ii)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = j.ji)(A, I, g, C, B, i);
                    }, Q._crypto_box_curve25519xchacha20poly1305_open_easy = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_open_easy = j.ki)(A, I, g, C, B, i, o);
                    }, Q._crypto_box_curve25519xchacha20poly1305_seedbytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_seedbytes = j.li)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = j.mi)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = j.ni)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = j.oi)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_noncebytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_noncebytes = j.pi)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_macbytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_macbytes = j.qi)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = j.ri)();
                    }, Q._crypto_box_curve25519xchacha20poly1305_seal = function(A, I, g, C, B) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_seal = j.si)(A, I, g, C, B);
                    }, Q._crypto_box_curve25519xchacha20poly1305_seal_open = function(A, I, g, C, B, i) {
                        return (Q._crypto_box_curve25519xchacha20poly1305_seal_open = j.ti)(A, I, g, C, B, i);
                    }, Q._crypto_box_curve25519xchacha20poly1305_sealbytes = function() {
                        return (Q._crypto_box_curve25519xchacha20poly1305_sealbytes = j.ui)();
                    }, Q._crypto_core_ed25519_is_valid_point = function(A) {
                        return (Q._crypto_core_ed25519_is_valid_point = j.vi)(A);
                    }, Q._crypto_core_ed25519_add = function(A, I, g) {
                        return (Q._crypto_core_ed25519_add = j.wi)(A, I, g);
                    }, Q._crypto_core_ed25519_sub = function(A, I, g) {
                        return (Q._crypto_core_ed25519_sub = j.xi)(A, I, g);
                    }, Q._crypto_core_ed25519_from_uniform = function(A, I) {
                        return (Q._crypto_core_ed25519_from_uniform = j.yi)(A, I);
                    }, Q._crypto_core_ed25519_random = function(A) {
                        return (Q._crypto_core_ed25519_random = j.zi)(A);
                    }, Q._crypto_core_ed25519_scalar_random = function(A) {
                        return (Q._crypto_core_ed25519_scalar_random = j.Ai)(A);
                    }, Q._crypto_core_ed25519_scalar_invert = function(A, I) {
                        return (Q._crypto_core_ed25519_scalar_invert = j.Bi)(A, I);
                    }, Q._crypto_core_ed25519_scalar_negate = function(A, I) {
                        return (Q._crypto_core_ed25519_scalar_negate = j.Ci)(A, I);
                    }, Q._crypto_core_ed25519_scalar_complement = function(A, I) {
                        return (Q._crypto_core_ed25519_scalar_complement = j.Di)(A, I);
                    }, Q._crypto_core_ed25519_scalar_add = function(A, I, g) {
                        return (Q._crypto_core_ed25519_scalar_add = j.Ei)(A, I, g);
                    }, Q._crypto_core_ed25519_scalar_reduce = function(A, I) {
                        return (Q._crypto_core_ed25519_scalar_reduce = j.Fi)(A, I);
                    }, Q._crypto_core_ed25519_scalar_sub = function(A, I, g) {
                        return (Q._crypto_core_ed25519_scalar_sub = j.Gi)(A, I, g);
                    }, Q._crypto_core_ed25519_scalar_mul = function(A, I, g) {
                        return (Q._crypto_core_ed25519_scalar_mul = j.Hi)(A, I, g);
                    }, Q._crypto_core_ed25519_bytes = function() {
                        return (Q._crypto_core_ed25519_bytes = j.Ii)();
                    }, Q._crypto_core_ed25519_nonreducedscalarbytes = function() {
                        return (Q._crypto_core_ed25519_nonreducedscalarbytes = j.Ji)();
                    }, Q._crypto_core_ed25519_uniformbytes = function() {
                        return (Q._crypto_core_ed25519_uniformbytes = j.Ki)();
                    }, Q._crypto_core_ed25519_hashbytes = function() {
                        return (Q._crypto_core_ed25519_hashbytes = j.Li)();
                    }, Q._crypto_core_ed25519_scalarbytes = function() {
                        return (Q._crypto_core_ed25519_scalarbytes = j.Mi)();
                    }, Q._crypto_core_ristretto255_is_valid_point = function(A) {
                        return (Q._crypto_core_ristretto255_is_valid_point = j.Ni)(A);
                    }, Q._crypto_core_ristretto255_add = function(A, I, g) {
                        return (Q._crypto_core_ristretto255_add = j.Oi)(A, I, g);
                    }, Q._crypto_core_ristretto255_sub = function(A, I, g) {
                        return (Q._crypto_core_ristretto255_sub = j.Pi)(A, I, g);
                    }, Q._crypto_core_ristretto255_from_hash = function(A, I) {
                        return (Q._crypto_core_ristretto255_from_hash = j.Qi)(A, I);
                    }, Q._crypto_core_ristretto255_random = function(A) {
                        return (Q._crypto_core_ristretto255_random = j.Ri)(A);
                    }, Q._crypto_core_ristretto255_scalar_random = function(A) {
                        return (Q._crypto_core_ristretto255_scalar_random = j.Si)(A);
                    }, Q._crypto_core_ristretto255_scalar_invert = function(A, I) {
                        return (Q._crypto_core_ristretto255_scalar_invert = j.Ti)(A, I);
                    }, Q._crypto_core_ristretto255_scalar_negate = function(A, I) {
                        return (Q._crypto_core_ristretto255_scalar_negate = j.Ui)(A, I);
                    }, Q._crypto_core_ristretto255_scalar_complement = function(A, I) {
                        return (Q._crypto_core_ristretto255_scalar_complement = j.Vi)(A, I);
                    }, Q._crypto_core_ristretto255_scalar_add = function(A, I, g) {
                        return (Q._crypto_core_ristretto255_scalar_add = j.Wi)(A, I, g);
                    }, Q._crypto_core_ristretto255_scalar_sub = function(A, I, g) {
                        return (Q._crypto_core_ristretto255_scalar_sub = j.Xi)(A, I, g);
                    }, Q._crypto_core_ristretto255_scalar_mul = function(A, I, g) {
                        return (Q._crypto_core_ristretto255_scalar_mul = j.Yi)(A, I, g);
                    }, Q._crypto_core_ristretto255_scalar_reduce = function(A, I) {
                        return (Q._crypto_core_ristretto255_scalar_reduce = j.Zi)(A, I);
                    }, Q._crypto_core_ristretto255_bytes = function() {
                        return (Q._crypto_core_ristretto255_bytes = j._i)();
                    }, Q._crypto_core_ristretto255_nonreducedscalarbytes = function() {
                        return (Q._crypto_core_ristretto255_nonreducedscalarbytes = j.$i)();
                    }, Q._crypto_core_ristretto255_hashbytes = function() {
                        return (Q._crypto_core_ristretto255_hashbytes = j.aj)();
                    }, Q._crypto_core_ristretto255_scalarbytes = function() {
                        return (Q._crypto_core_ristretto255_scalarbytes = j.bj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_ll = function(A, I, g, C, B, i, o, E, a, _) {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_ll = j.cj)(A, I, g, C, B, i, o, E, a, _);
                    }, Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = j.dj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = j.ej)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = j.fj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = j.gj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = j.hj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_strbytes = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_strbytes = j.ij)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_strprefix = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_strprefix = j.jj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = j.kj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = j.lj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = j.mj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = j.nj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = j.oj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = j.pj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = j.qj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = function() {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = j.rj)();
                    }, Q._crypto_pwhash_scryptsalsa208sha256 = function(A, I, g, C, B, i, o, E, a, _) {
                        return (Q._crypto_pwhash_scryptsalsa208sha256 = j.sj)(A, I, g, C, B, i, o, E, a, _);
                    }, Q._crypto_pwhash_scryptsalsa208sha256_str = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_str = j.tj)(A, I, g, C, B, i, o);
                    }, Q._crypto_pwhash_scryptsalsa208sha256_str_verify = function(A, I, g, C) {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_str_verify = j.uj)(A, I, g, C);
                    }, Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = function(A, I, g, C) {
                        return (Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = j.vj)(A, I, g, C);
                    }, Q._crypto_scalarmult_ed25519 = function(A, I, g) {
                        return (Q._crypto_scalarmult_ed25519 = j.wj)(A, I, g);
                    }, Q._crypto_scalarmult_ed25519_noclamp = function(A, I, g) {
                        return (Q._crypto_scalarmult_ed25519_noclamp = j.xj)(A, I, g);
                    }, Q._crypto_scalarmult_ed25519_base = function(A, I) {
                        return (Q._crypto_scalarmult_ed25519_base = j.yj)(A, I);
                    }, Q._crypto_scalarmult_ed25519_base_noclamp = function(A, I) {
                        return (Q._crypto_scalarmult_ed25519_base_noclamp = j.zj)(A, I);
                    }, Q._crypto_scalarmult_ed25519_bytes = function() {
                        return (Q._crypto_scalarmult_ed25519_bytes = j.Aj)();
                    }, Q._crypto_scalarmult_ed25519_scalarbytes = function() {
                        return (Q._crypto_scalarmult_ed25519_scalarbytes = j.Bj)();
                    }, Q._crypto_scalarmult_ristretto255 = function(A, I, g) {
                        return (Q._crypto_scalarmult_ristretto255 = j.Cj)(A, I, g);
                    }, Q._crypto_scalarmult_ristretto255_base = function(A, I) {
                        return (Q._crypto_scalarmult_ristretto255_base = j.Dj)(A, I);
                    }, Q._crypto_scalarmult_ristretto255_bytes = function() {
                        return (Q._crypto_scalarmult_ristretto255_bytes = j.Ej)();
                    }, Q._crypto_scalarmult_ristretto255_scalarbytes = function() {
                        return (Q._crypto_scalarmult_ristretto255_scalarbytes = j.Fj)();
                    }, Q._crypto_secretbox_xchacha20poly1305_detached = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_secretbox_xchacha20poly1305_detached = j.Gj)(A, I, g, C, B, i, o);
                    }, Q._crypto_secretbox_xchacha20poly1305_easy = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_xchacha20poly1305_easy = j.Hj)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_xchacha20poly1305_open_detached = function(A, I, g, C, B, i, o) {
                        return (Q._crypto_secretbox_xchacha20poly1305_open_detached = j.Ij)(A, I, g, C, B, i, o);
                    }, Q._crypto_secretbox_xchacha20poly1305_open_easy = function(A, I, g, C, B, i) {
                        return (Q._crypto_secretbox_xchacha20poly1305_open_easy = j.Jj)(A, I, g, C, B, i);
                    }, Q._crypto_secretbox_xchacha20poly1305_keybytes = function() {
                        return (Q._crypto_secretbox_xchacha20poly1305_keybytes = j.Kj)();
                    }, Q._crypto_secretbox_xchacha20poly1305_noncebytes = function() {
                        return (Q._crypto_secretbox_xchacha20poly1305_noncebytes = j.Lj)();
                    }, Q._crypto_secretbox_xchacha20poly1305_macbytes = function() {
                        return (Q._crypto_secretbox_xchacha20poly1305_macbytes = j.Mj)();
                    }, Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = function() {
                        return (Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = j.Nj)();
                    }, Q._crypto_shorthash_siphashx24_bytes = function() {
                        return (Q._crypto_shorthash_siphashx24_bytes = j.Oj)();
                    }, Q._crypto_shorthash_siphashx24_keybytes = function() {
                        return (Q._crypto_shorthash_siphashx24_keybytes = j.Pj)();
                    }, Q._crypto_shorthash_siphashx24 = function(A, I, g, C, B) {
                        return (Q._crypto_shorthash_siphashx24 = j.Qj)(A, I, g, C, B);
                    }, Q._crypto_stream_salsa2012 = function(A, I, g, C, B) {
                        return (Q._crypto_stream_salsa2012 = j.Rj)(A, I, g, C, B);
                    }, Q._crypto_stream_salsa2012_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_salsa2012_xor = j.Sj)(A, I, g, C, B, i);
                    }, Q._crypto_stream_salsa2012_keybytes = function() {
                        return (Q._crypto_stream_salsa2012_keybytes = j.Tj)();
                    }, Q._crypto_stream_salsa2012_noncebytes = function() {
                        return (Q._crypto_stream_salsa2012_noncebytes = j.Uj)();
                    }, Q._crypto_stream_salsa2012_messagebytes_max = function() {
                        return (Q._crypto_stream_salsa2012_messagebytes_max = j.Vj)();
                    }, Q._crypto_stream_salsa2012_keygen = function(A) {
                        return (Q._crypto_stream_salsa2012_keygen = j.Wj)(A);
                    }, Q._crypto_stream_salsa208 = function(A, I, g, C, B) {
                        return (Q._crypto_stream_salsa208 = j.Xj)(A, I, g, C, B);
                    }, Q._crypto_stream_salsa208_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_salsa208_xor = j.Yj)(A, I, g, C, B, i);
                    }, Q._crypto_stream_salsa208_keybytes = function() {
                        return (Q._crypto_stream_salsa208_keybytes = j.Zj)();
                    }, Q._crypto_stream_salsa208_noncebytes = function() {
                        return (Q._crypto_stream_salsa208_noncebytes = j._j)();
                    }, Q._crypto_stream_salsa208_messagebytes_max = function() {
                        return (Q._crypto_stream_salsa208_messagebytes_max = j.$j)();
                    }, Q._crypto_stream_salsa208_keygen = function(A) {
                        return (Q._crypto_stream_salsa208_keygen = j.ak)(A);
                    }, Q._crypto_stream_xchacha20_keybytes = function() {
                        return (Q._crypto_stream_xchacha20_keybytes = j.bk)();
                    }, Q._crypto_stream_xchacha20_noncebytes = function() {
                        return (Q._crypto_stream_xchacha20_noncebytes = j.ck)();
                    }, Q._crypto_stream_xchacha20_messagebytes_max = function() {
                        return (Q._crypto_stream_xchacha20_messagebytes_max = j.dk)();
                    }, Q._crypto_stream_xchacha20 = function(A, I, g, C, B) {
                        return (Q._crypto_stream_xchacha20 = j.ek)(A, I, g, C, B);
                    }, Q._crypto_stream_xchacha20_xor_ic = function(A, I, g, C, B, i, o, E) {
                        return (Q._crypto_stream_xchacha20_xor_ic = j.fk)(A, I, g, C, B, i, o, E);
                    }, Q._crypto_stream_xchacha20_xor = function(A, I, g, C, B, i) {
                        return (Q._crypto_stream_xchacha20_xor = j.gk)(A, I, g, C, B, i);
                    }, Q._crypto_stream_xchacha20_keygen = function(A) {
                        return (Q._crypto_stream_xchacha20_keygen = j.hk)(A);
                    }, Q._malloc = function(A) {
                        return (Q._malloc = j.ik)(A);
                    }, Q._free = function(A) {
                        return (Q._free = j.jk)(A);
                    }, Q.setValue = function(A, I) {
                        var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "i8";
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                h[A >> 0] = I;
                                break;
                            case "i16":
                                p[A >> 1] = I;
                                break;
                            case "i32":
                                w[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                n[A >> 2] = I;
                                break;
                            case "double":
                                k[A >> 3] = I;
                                break;
                            case "*":
                                f[A >> 2] = I;
                                break;
                            default:
                                d("invalid type for setValue: ".concat(g));
                        }
                    }, Q.getValue = function(A) {
                        var _$I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "i8";
                        switch(_$I.endsWith("*") && (_$I = "*"), _$I){
                            case "i1":
                            case "i8":
                                return h[A >> 0];
                            case "i16":
                                return p[A >> 1];
                            case "i32":
                                return w[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return n[A >> 2];
                            case "double":
                                return k[A >> 3];
                            case "*":
                                return f[A >> 2];
                            default:
                                d("invalid type for getValue: ".concat(_$I));
                        }
                    }, Q.UTF8ToString = L, Y = function A() {
                        u || X(), u || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    X();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $4pbh3 && "object" == typeof $4pbh3.versions && "string" == typeof $4pbh3.versions.node, _ = "";
            if (a) {
                var c = (parcelRequire("24TKi")), t = (parcelRequire("24TKi"));
                _ = E ? t.dirname(_) + "/" : $f78aad968bcacc00$var$__dirname + "/", g = function(A, I) {
                    return A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8");
                }, B = function(A) {
                    var _$I = g(A, !0);
                    return _$I.buffer || (_$I = new Uint8Array(_$I)), _$I;
                }, !Q.thisProgram && $4pbh3.argv.length > 1 && $4pbh3.argv[1].replace(/\\/g, "/"), $4pbh3.argv.slice(2), module.exports = Q, Q.inspect = function() {
                    return "[Emscripten Module object]";
                };
            } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = function(A) {
                var _$I = new XMLHttpRequest;
                return _$I.open("GET", A, !1), _$I.send(null), _$I.responseText;
            }, E && (B = function(A) {
                var _$I = new XMLHttpRequest;
                return _$I.open("GET", A, !1), _$I.responseType = "arraybuffer", _$I.send(null), new Uint8Array(_$I.response);
            }));
            Q.print;
            var r, e, y = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && H("no native wasm support detected");
            var s, h, D, p, w, f, n, k = !1;
            function F() {
                var _$A = e.buffer;
                Q.HEAP8 = s = new Int8Array(_$A), Q.HEAP16 = D = new Int16Array(_$A), Q.HEAPU8 = h = new Uint8Array(_$A), Q.HEAPU16 = new Uint16Array(_$A), Q.HEAP32 = p = new Int32Array(_$A), Q.HEAPU32 = w = new Uint32Array(_$A), Q.HEAPF32 = f = new Float32Array(_$A), Q.HEAPF64 = n = new Float64Array(_$A);
            }
            var N = [], S = [], G = [], M = 0, b = null, K = null;
            function H(A) {
                throw Q.onAbort && Q.onAbort(A), y(A = "Aborted(" + A + ")"), k = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, J = "data:application/octet-stream;base64,";
            function U(A) {
                return A.startsWith(J);
            }
            U(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, _) : _ + d);
            var l, m = {
                36800: function() {
                    return Q.getRandomValue();
                },
                36836: function() {
                    if (void 0 === Q.getRandomValue) try {
                        var _$A = "object" == typeof window ? window : self, _$I = void 0 !== _$A.crypto ? _$A.crypto : _$A.msCrypto, g = function g() {
                            var _$A = new Uint32Array(1);
                            return _$I.getRandomValues(_$A), _$A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("5xFHp")), B = function B() {
                                var _$A = C.randomBytes(4);
                                return (_$A[0] << 24 | _$A[1] << 16 | _$A[2] << 8 | _$A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, u = function(A) {
                for(; A.length > 0;)A.shift()(Q);
            }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, R = function(A, I) {
                return A ? function(A, I, g) {
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var o = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var E = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | o);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                }(h, A, I) : "";
            }, v = [], L = function(A) {
                var _$I = (A - e.buffer.byteLength + 65535) / 65536;
                try {
                    return e.grow(_$I), F(), 1;
                } catch (A) {}
            }, P = {
                b: function(A, I, g, C) {
                    H("Assertion failed: ".concat(R(A), ", at: ") + [
                        I ? R(I) : "unknown filename",
                        g,
                        C ? R(C) : "unknown function"
                    ]);
                },
                c: function() {
                    H("");
                },
                a: function(A, I, g) {
                    return function(A, I, g) {
                        var C = function(A, I) {
                            var _$g;
                            for(v.length = 0; _$g = h[A++];)I += 105 != _$g && I % 8 ? 4 : 0, v.push(105 == _$g ? p[I >> 2] : n[I >> 3]), I += 105 == _$g ? 4 : 8;
                            return v;
                        }(I, g);
                        return m[A].apply(null, C);
                    }(A, I, g);
                },
                e: function(A, I, g) {
                    return h.copyWithin(A, I, I + g);
                },
                d: function(A) {
                    var _$I = h.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = _$I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (L(i)) return !0;
                    }
                    return !1;
                }
            }, q = function() {
                var _$A, _$I, g = {
                    a: P
                };
                function C(A, I) {
                    var g = A.exports;
                    return e = (q = g).f, F(), q.kk, function(A) {
                        if (M--, Q.monitorRunDependencies && Q.monitorRunDependencies(M), 0 == M && (null !== b && (clearInterval(b), b = null), K)) {
                            var _$I = K;
                            K = null, _$I();
                        }
                    }(), g;
                }
                if (M++, Q.monitorRunDependencies && Q.monitorRunDependencies(M), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return y("Module.instantiateWasm callback failed with error: ".concat(A)), !1;
                }
                return _$A = g, _$I = function I(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(function() {
                        return function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var _$I = function(A) {
                                if (U(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var _$I = $f78aad968bcacc00$require$Buffer.from(A, "base64");
                                        return new Uint8Array(_$I.buffer, _$I.byteOffset, _$I.length);
                                    }
                                    try {
                                        for(var g = atob(A), _$C = new Uint8Array(g.length), B = 0; B < g.length; ++B)_$C[B] = g.charCodeAt(B);
                                        return _$C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(J.length));
                            }(A);
                            if (_$I) return _$I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        }(A);
                    });
                })(Y).then(function(I) {
                    return WebAssembly.instantiate(I, _$A);
                }).then(function(A) {
                    return A;
                }).then(_$I, function(A) {
                    y("failed to asynchronously prepare wasm: ".concat(A)), H(A);
                }), {};
            }();
            function z() {
                function A() {
                    l || (l = !0, Q.calledRun = !0, k || (u(S), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)_$A = Q.postRun.shift(), G.unshift(_$A);
                        var _$A;
                        u(G);
                    }()));
                }
                M > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)_$A = Q.preRun.shift(), N.unshift(_$A);
                    var _$A;
                    u(N);
                }(), M > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_aegis128l_keybytes = function() {
                return (Q._crypto_aead_aegis128l_keybytes = q.g)();
            }, Q._crypto_aead_aegis128l_nsecbytes = function() {
                return (Q._crypto_aead_aegis128l_nsecbytes = q.h)();
            }, Q._crypto_aead_aegis128l_npubbytes = function() {
                return (Q._crypto_aead_aegis128l_npubbytes = q.i)();
            }, Q._crypto_aead_aegis128l_abytes = function() {
                return (Q._crypto_aead_aegis128l_abytes = q.j)();
            }, Q._crypto_aead_aegis128l_messagebytes_max = function() {
                return (Q._crypto_aead_aegis128l_messagebytes_max = q.k)();
            }, Q._crypto_aead_aegis128l_keygen = function(A) {
                return (Q._crypto_aead_aegis128l_keygen = q.l)(A);
            }, Q._crypto_aead_aegis128l_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_aegis128l_encrypt = q.m)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_aegis128l_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                return (Q._crypto_aead_aegis128l_encrypt_detached = q.n)(A, I, g, C, B, i, o, E, a, _, c, t);
            }, Q._crypto_aead_aegis128l_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_aegis128l_decrypt = q.o)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_aegis128l_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_aegis128l_decrypt_detached = q.p)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_aegis256_keybytes = function() {
                return (Q._crypto_aead_aegis256_keybytes = q.q)();
            }, Q._crypto_aead_aegis256_nsecbytes = function() {
                return (Q._crypto_aead_aegis256_nsecbytes = q.r)();
            }, Q._crypto_aead_aegis256_npubbytes = function() {
                return (Q._crypto_aead_aegis256_npubbytes = q.s)();
            }, Q._crypto_aead_aegis256_abytes = function() {
                return (Q._crypto_aead_aegis256_abytes = q.t)();
            }, Q._crypto_aead_aegis256_messagebytes_max = function() {
                return (Q._crypto_aead_aegis256_messagebytes_max = q.u)();
            }, Q._crypto_aead_aegis256_keygen = function(A) {
                return (Q._crypto_aead_aegis256_keygen = q.v)(A);
            }, Q._crypto_aead_aegis256_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_aegis256_encrypt = q.w)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_aegis256_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                return (Q._crypto_aead_aegis256_encrypt_detached = q.x)(A, I, g, C, B, i, o, E, a, _, c, t);
            }, Q._crypto_aead_aegis256_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_aegis256_decrypt = q.y)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_aegis256_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_aegis256_decrypt_detached = q.z)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                return (Q._crypto_aead_chacha20poly1305_encrypt_detached = q.A)(A, I, g, C, B, i, o, E, a, _, c, t);
            }, Q._crypto_aead_chacha20poly1305_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_chacha20poly1305_encrypt = q.B)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                return (Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = q.C)(A, I, g, C, B, i, o, E, a, _, c, t);
            }, Q._crypto_aead_chacha20poly1305_ietf_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_chacha20poly1305_ietf_encrypt = q.D)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_chacha20poly1305_decrypt_detached = q.E)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_chacha20poly1305_decrypt = q.F)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = q.G)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_ietf_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_chacha20poly1305_ietf_decrypt = q.H)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_chacha20poly1305_ietf_keybytes = function() {
                return (Q._crypto_aead_chacha20poly1305_ietf_keybytes = q.I)();
            }, Q._crypto_aead_chacha20poly1305_ietf_npubbytes = function() {
                return (Q._crypto_aead_chacha20poly1305_ietf_npubbytes = q.J)();
            }, Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = function() {
                return (Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = q.K)();
            }, Q._crypto_aead_chacha20poly1305_ietf_abytes = function() {
                return (Q._crypto_aead_chacha20poly1305_ietf_abytes = q.L)();
            }, Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = function() {
                return (Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = q.M)();
            }, Q._crypto_aead_chacha20poly1305_ietf_keygen = function(A) {
                return (Q._crypto_aead_chacha20poly1305_ietf_keygen = q.N)(A);
            }, Q._crypto_aead_chacha20poly1305_keybytes = function() {
                return (Q._crypto_aead_chacha20poly1305_keybytes = q.O)();
            }, Q._crypto_aead_chacha20poly1305_npubbytes = function() {
                return (Q._crypto_aead_chacha20poly1305_npubbytes = q.P)();
            }, Q._crypto_aead_chacha20poly1305_nsecbytes = function() {
                return (Q._crypto_aead_chacha20poly1305_nsecbytes = q.Q)();
            }, Q._crypto_aead_chacha20poly1305_abytes = function() {
                return (Q._crypto_aead_chacha20poly1305_abytes = q.R)();
            }, Q._crypto_aead_chacha20poly1305_messagebytes_max = function() {
                return (Q._crypto_aead_chacha20poly1305_messagebytes_max = q.S)();
            }, Q._crypto_aead_chacha20poly1305_keygen = function(A) {
                return (Q._crypto_aead_chacha20poly1305_keygen = q.T)(A);
            }, Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c, t) {
                return (Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = q.U)(A, I, g, C, B, i, o, E, a, _, c, t);
            }, Q._crypto_aead_xchacha20poly1305_ietf_encrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_xchacha20poly1305_ietf_encrypt = q.V)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = q.W)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_xchacha20poly1305_ietf_decrypt = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_aead_xchacha20poly1305_ietf_decrypt = q.X)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_aead_xchacha20poly1305_ietf_keybytes = function() {
                return (Q._crypto_aead_xchacha20poly1305_ietf_keybytes = q.Y)();
            }, Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = function() {
                return (Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = q.Z)();
            }, Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = function() {
                return (Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = q._)();
            }, Q._crypto_aead_xchacha20poly1305_ietf_abytes = function() {
                return (Q._crypto_aead_xchacha20poly1305_ietf_abytes = q.$)();
            }, Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = function() {
                return (Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = q.aa)();
            }, Q._crypto_aead_xchacha20poly1305_ietf_keygen = function(A) {
                return (Q._crypto_aead_xchacha20poly1305_ietf_keygen = q.ba)(A);
            }, Q._crypto_auth_bytes = function() {
                return (Q._crypto_auth_bytes = q.ca)();
            }, Q._crypto_auth_keybytes = function() {
                return (Q._crypto_auth_keybytes = q.da)();
            }, Q._crypto_auth_primitive = function() {
                return (Q._crypto_auth_primitive = q.ea)();
            }, Q._crypto_auth = function(A, I, g, C, B) {
                return (Q._crypto_auth = q.fa)(A, I, g, C, B);
            }, Q._crypto_auth_verify = function(A, I, g, C, B) {
                return (Q._crypto_auth_verify = q.ga)(A, I, g, C, B);
            }, Q._crypto_auth_keygen = function(A) {
                return (Q._crypto_auth_keygen = q.ha)(A);
            }, Q._crypto_auth_hmacsha256_bytes = function() {
                return (Q._crypto_auth_hmacsha256_bytes = q.ia)();
            }, Q._crypto_auth_hmacsha256_keybytes = function() {
                return (Q._crypto_auth_hmacsha256_keybytes = q.ja)();
            }, Q._crypto_auth_hmacsha256_statebytes = function() {
                return (Q._crypto_auth_hmacsha256_statebytes = q.ka)();
            }, Q._crypto_auth_hmacsha256_keygen = function(A) {
                return (Q._crypto_auth_hmacsha256_keygen = q.la)(A);
            }, Q._crypto_auth_hmacsha256_init = function(A, I, g) {
                return (Q._crypto_auth_hmacsha256_init = q.ma)(A, I, g);
            }, Q._crypto_auth_hmacsha256_update = function(A, I, g, C) {
                return (Q._crypto_auth_hmacsha256_update = q.na)(A, I, g, C);
            }, Q._crypto_auth_hmacsha256_final = function(A, I) {
                return (Q._crypto_auth_hmacsha256_final = q.oa)(A, I);
            }, Q._crypto_auth_hmacsha256 = function(A, I, g, C, B) {
                return (Q._crypto_auth_hmacsha256 = q.pa)(A, I, g, C, B);
            }, Q._crypto_auth_hmacsha256_verify = function(A, I, g, C, B) {
                return (Q._crypto_auth_hmacsha256_verify = q.qa)(A, I, g, C, B);
            }, Q._crypto_auth_hmacsha512_bytes = function() {
                return (Q._crypto_auth_hmacsha512_bytes = q.ra)();
            }, Q._crypto_auth_hmacsha512_keybytes = function() {
                return (Q._crypto_auth_hmacsha512_keybytes = q.sa)();
            }, Q._crypto_auth_hmacsha512_statebytes = function() {
                return (Q._crypto_auth_hmacsha512_statebytes = q.ta)();
            }, Q._crypto_auth_hmacsha512_keygen = function(A) {
                return (Q._crypto_auth_hmacsha512_keygen = q.ua)(A);
            }, Q._crypto_auth_hmacsha512_init = function(A, I, g) {
                return (Q._crypto_auth_hmacsha512_init = q.va)(A, I, g);
            }, Q._crypto_auth_hmacsha512_update = function(A, I, g, C) {
                return (Q._crypto_auth_hmacsha512_update = q.wa)(A, I, g, C);
            }, Q._crypto_auth_hmacsha512_final = function(A, I) {
                return (Q._crypto_auth_hmacsha512_final = q.xa)(A, I);
            }, Q._crypto_auth_hmacsha512 = function(A, I, g, C, B) {
                return (Q._crypto_auth_hmacsha512 = q.ya)(A, I, g, C, B);
            }, Q._crypto_auth_hmacsha512_verify = function(A, I, g, C, B) {
                return (Q._crypto_auth_hmacsha512_verify = q.za)(A, I, g, C, B);
            }, Q._crypto_auth_hmacsha512256_bytes = function() {
                return (Q._crypto_auth_hmacsha512256_bytes = q.Aa)();
            }, Q._crypto_auth_hmacsha512256_keybytes = function() {
                return (Q._crypto_auth_hmacsha512256_keybytes = q.Ba)();
            }, Q._crypto_auth_hmacsha512256_statebytes = function() {
                return (Q._crypto_auth_hmacsha512256_statebytes = q.Ca)();
            }, Q._crypto_auth_hmacsha512256_keygen = function(A) {
                return (Q._crypto_auth_hmacsha512256_keygen = q.Da)(A);
            }, Q._crypto_auth_hmacsha512256_init = function(A, I, g) {
                return (Q._crypto_auth_hmacsha512256_init = q.Ea)(A, I, g);
            }, Q._crypto_auth_hmacsha512256_update = function(A, I, g, C) {
                return (Q._crypto_auth_hmacsha512256_update = q.Fa)(A, I, g, C);
            }, Q._crypto_auth_hmacsha512256_final = function(A, I) {
                return (Q._crypto_auth_hmacsha512256_final = q.Ga)(A, I);
            }, Q._crypto_auth_hmacsha512256 = function(A, I, g, C, B) {
                return (Q._crypto_auth_hmacsha512256 = q.Ha)(A, I, g, C, B);
            }, Q._crypto_auth_hmacsha512256_verify = function(A, I, g, C, B) {
                return (Q._crypto_auth_hmacsha512256_verify = q.Ia)(A, I, g, C, B);
            }, Q._crypto_box_seedbytes = function() {
                return (Q._crypto_box_seedbytes = q.Ja)();
            }, Q._crypto_box_publickeybytes = function() {
                return (Q._crypto_box_publickeybytes = q.Ka)();
            }, Q._crypto_box_secretkeybytes = function() {
                return (Q._crypto_box_secretkeybytes = q.La)();
            }, Q._crypto_box_beforenmbytes = function() {
                return (Q._crypto_box_beforenmbytes = q.Ma)();
            }, Q._crypto_box_noncebytes = function() {
                return (Q._crypto_box_noncebytes = q.Na)();
            }, Q._crypto_box_zerobytes = function() {
                return (Q._crypto_box_zerobytes = q.Oa)();
            }, Q._crypto_box_boxzerobytes = function() {
                return (Q._crypto_box_boxzerobytes = q.Pa)();
            }, Q._crypto_box_macbytes = function() {
                return (Q._crypto_box_macbytes = q.Qa)();
            }, Q._crypto_box_messagebytes_max = function() {
                return (Q._crypto_box_messagebytes_max = q.Ra)();
            }, Q._crypto_box_primitive = function() {
                return (Q._crypto_box_primitive = q.Sa)();
            }, Q._crypto_box_seed_keypair = function(A, I, g) {
                return (Q._crypto_box_seed_keypair = q.Ta)(A, I, g);
            }, Q._crypto_box_keypair = function(A, I) {
                return (Q._crypto_box_keypair = q.Ua)(A, I);
            }, Q._crypto_box_beforenm = function(A, I, g) {
                return (Q._crypto_box_beforenm = q.Va)(A, I, g);
            }, Q._crypto_box_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_afternm = q.Wa)(A, I, g, C, B, i);
            }, Q._crypto_box_open_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_open_afternm = q.Xa)(A, I, g, C, B, i);
            }, Q._crypto_box = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box = q.Ya)(A, I, g, C, B, i, o);
            }, Q._crypto_box_open = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_open = q.Za)(A, I, g, C, B, i, o);
            }, Q._crypto_box_detached_afternm = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_detached_afternm = q._a)(A, I, g, C, B, i, o);
            }, Q._crypto_box_detached = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_box_detached = q.$a)(A, I, g, C, B, i, o, E);
            }, Q._crypto_box_easy_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_easy_afternm = q.ab)(A, I, g, C, B, i);
            }, Q._crypto_box_easy = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_easy = q.bb)(A, I, g, C, B, i, o);
            }, Q._crypto_box_open_detached_afternm = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_open_detached_afternm = q.cb)(A, I, g, C, B, i, o);
            }, Q._crypto_box_open_detached = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_box_open_detached = q.db)(A, I, g, C, B, i, o, E);
            }, Q._crypto_box_open_easy_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_open_easy_afternm = q.eb)(A, I, g, C, B, i);
            }, Q._crypto_box_open_easy = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_open_easy = q.fb)(A, I, g, C, B, i, o);
            }, Q._crypto_box_seal = function(A, I, g, C, B) {
                return (Q._crypto_box_seal = q.gb)(A, I, g, C, B);
            }, Q._crypto_box_seal_open = function(A, I, g, C, B, i) {
                return (Q._crypto_box_seal_open = q.hb)(A, I, g, C, B, i);
            }, Q._crypto_box_sealbytes = function() {
                return (Q._crypto_box_sealbytes = q.ib)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = function(A, I, g) {
                return (Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = q.jb)(A, I, g);
            }, Q._crypto_box_curve25519xsalsa20poly1305_keypair = function(A, I) {
                return (Q._crypto_box_curve25519xsalsa20poly1305_keypair = q.kb)(A, I);
            }, Q._crypto_box_curve25519xsalsa20poly1305_beforenm = function(A, I, g) {
                return (Q._crypto_box_curve25519xsalsa20poly1305_beforenm = q.lb)(A, I, g);
            }, Q._crypto_box_curve25519xsalsa20poly1305_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_curve25519xsalsa20poly1305_afternm = q.mb)(A, I, g, C, B, i);
            }, Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = q.nb)(A, I, g, C, B, i);
            }, Q._crypto_box_curve25519xsalsa20poly1305 = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_curve25519xsalsa20poly1305 = q.ob)(A, I, g, C, B, i, o);
            }, Q._crypto_box_curve25519xsalsa20poly1305_open = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_curve25519xsalsa20poly1305_open = q.pb)(A, I, g, C, B, i, o);
            }, Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = q.qb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = q.rb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = q.sb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = q.tb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = q.ub)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = q.vb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = q.wb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_macbytes = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_macbytes = q.xb)();
            }, Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = function() {
                return (Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = q.yb)();
            }, Q._crypto_core_hchacha20 = function(A, I, g, C) {
                return (Q._crypto_core_hchacha20 = q.zb)(A, I, g, C);
            }, Q._crypto_core_hchacha20_outputbytes = function() {
                return (Q._crypto_core_hchacha20_outputbytes = q.Ab)();
            }, Q._crypto_core_hchacha20_inputbytes = function() {
                return (Q._crypto_core_hchacha20_inputbytes = q.Bb)();
            }, Q._crypto_core_hchacha20_keybytes = function() {
                return (Q._crypto_core_hchacha20_keybytes = q.Cb)();
            }, Q._crypto_core_hchacha20_constbytes = function() {
                return (Q._crypto_core_hchacha20_constbytes = q.Db)();
            }, Q._crypto_core_hsalsa20 = function(A, I, g, C) {
                return (Q._crypto_core_hsalsa20 = q.Eb)(A, I, g, C);
            }, Q._crypto_core_hsalsa20_outputbytes = function() {
                return (Q._crypto_core_hsalsa20_outputbytes = q.Fb)();
            }, Q._crypto_core_hsalsa20_inputbytes = function() {
                return (Q._crypto_core_hsalsa20_inputbytes = q.Gb)();
            }, Q._crypto_core_hsalsa20_keybytes = function() {
                return (Q._crypto_core_hsalsa20_keybytes = q.Hb)();
            }, Q._crypto_core_hsalsa20_constbytes = function() {
                return (Q._crypto_core_hsalsa20_constbytes = q.Ib)();
            }, Q._crypto_core_salsa20 = function(A, I, g, C) {
                return (Q._crypto_core_salsa20 = q.Jb)(A, I, g, C);
            }, Q._crypto_core_salsa20_outputbytes = function() {
                return (Q._crypto_core_salsa20_outputbytes = q.Kb)();
            }, Q._crypto_core_salsa20_inputbytes = function() {
                return (Q._crypto_core_salsa20_inputbytes = q.Lb)();
            }, Q._crypto_core_salsa20_keybytes = function() {
                return (Q._crypto_core_salsa20_keybytes = q.Mb)();
            }, Q._crypto_core_salsa20_constbytes = function() {
                return (Q._crypto_core_salsa20_constbytes = q.Nb)();
            }, Q._crypto_core_salsa2012 = function(A, I, g, C) {
                return (Q._crypto_core_salsa2012 = q.Ob)(A, I, g, C);
            }, Q._crypto_core_salsa2012_outputbytes = function() {
                return (Q._crypto_core_salsa2012_outputbytes = q.Pb)();
            }, Q._crypto_core_salsa2012_inputbytes = function() {
                return (Q._crypto_core_salsa2012_inputbytes = q.Qb)();
            }, Q._crypto_core_salsa2012_keybytes = function() {
                return (Q._crypto_core_salsa2012_keybytes = q.Rb)();
            }, Q._crypto_core_salsa2012_constbytes = function() {
                return (Q._crypto_core_salsa2012_constbytes = q.Sb)();
            }, Q._crypto_core_salsa208 = function(A, I, g, C) {
                return (Q._crypto_core_salsa208 = q.Tb)(A, I, g, C);
            }, Q._crypto_core_salsa208_outputbytes = function() {
                return (Q._crypto_core_salsa208_outputbytes = q.Ub)();
            }, Q._crypto_core_salsa208_inputbytes = function() {
                return (Q._crypto_core_salsa208_inputbytes = q.Vb)();
            }, Q._crypto_core_salsa208_keybytes = function() {
                return (Q._crypto_core_salsa208_keybytes = q.Wb)();
            }, Q._crypto_core_salsa208_constbytes = function() {
                return (Q._crypto_core_salsa208_constbytes = q.Xb)();
            }, Q._crypto_generichash_bytes_min = function() {
                return (Q._crypto_generichash_bytes_min = q.Yb)();
            }, Q._crypto_generichash_bytes_max = function() {
                return (Q._crypto_generichash_bytes_max = q.Zb)();
            }, Q._crypto_generichash_bytes = function() {
                return (Q._crypto_generichash_bytes = q._b)();
            }, Q._crypto_generichash_keybytes_min = function() {
                return (Q._crypto_generichash_keybytes_min = q.$b)();
            }, Q._crypto_generichash_keybytes_max = function() {
                return (Q._crypto_generichash_keybytes_max = q.ac)();
            }, Q._crypto_generichash_keybytes = function() {
                return (Q._crypto_generichash_keybytes = q.bc)();
            }, Q._crypto_generichash_primitive = function() {
                return (Q._crypto_generichash_primitive = q.cc)();
            }, Q._crypto_generichash_statebytes = function() {
                return (Q._crypto_generichash_statebytes = q.dc)();
            }, Q._crypto_generichash = function(A, I, g, C, B, i, o) {
                return (Q._crypto_generichash = q.ec)(A, I, g, C, B, i, o);
            }, Q._crypto_generichash_init = function(A, I, g, C) {
                return (Q._crypto_generichash_init = q.fc)(A, I, g, C);
            }, Q._crypto_generichash_update = function(A, I, g, C) {
                return (Q._crypto_generichash_update = q.gc)(A, I, g, C);
            }, Q._crypto_generichash_final = function(A, I, g) {
                return (Q._crypto_generichash_final = q.hc)(A, I, g);
            }, Q._crypto_generichash_keygen = function(A) {
                return (Q._crypto_generichash_keygen = q.ic)(A);
            }, Q._crypto_generichash_blake2b_bytes_min = function() {
                return (Q._crypto_generichash_blake2b_bytes_min = q.jc)();
            }, Q._crypto_generichash_blake2b_bytes_max = function() {
                return (Q._crypto_generichash_blake2b_bytes_max = q.kc)();
            }, Q._crypto_generichash_blake2b_bytes = function() {
                return (Q._crypto_generichash_blake2b_bytes = q.lc)();
            }, Q._crypto_generichash_blake2b_keybytes_min = function() {
                return (Q._crypto_generichash_blake2b_keybytes_min = q.mc)();
            }, Q._crypto_generichash_blake2b_keybytes_max = function() {
                return (Q._crypto_generichash_blake2b_keybytes_max = q.nc)();
            }, Q._crypto_generichash_blake2b_keybytes = function() {
                return (Q._crypto_generichash_blake2b_keybytes = q.oc)();
            }, Q._crypto_generichash_blake2b_saltbytes = function() {
                return (Q._crypto_generichash_blake2b_saltbytes = q.pc)();
            }, Q._crypto_generichash_blake2b_personalbytes = function() {
                return (Q._crypto_generichash_blake2b_personalbytes = q.qc)();
            }, Q._crypto_generichash_blake2b_statebytes = function() {
                return (Q._crypto_generichash_blake2b_statebytes = q.rc)();
            }, Q._crypto_generichash_blake2b_keygen = function(A) {
                return (Q._crypto_generichash_blake2b_keygen = q.sc)(A);
            }, Q._crypto_generichash_blake2b = function(A, I, g, C, B, i, o) {
                return (Q._crypto_generichash_blake2b = q.tc)(A, I, g, C, B, i, o);
            }, Q._crypto_generichash_blake2b_salt_personal = function(A, I, g, C, B, i, o, E, a) {
                return (Q._crypto_generichash_blake2b_salt_personal = q.uc)(A, I, g, C, B, i, o, E, a);
            }, Q._crypto_generichash_blake2b_init = function(A, I, g, C) {
                return (Q._crypto_generichash_blake2b_init = q.vc)(A, I, g, C);
            }, Q._crypto_generichash_blake2b_init_salt_personal = function(A, I, g, C, B, i) {
                return (Q._crypto_generichash_blake2b_init_salt_personal = q.wc)(A, I, g, C, B, i);
            }, Q._crypto_generichash_blake2b_update = function(A, I, g, C) {
                return (Q._crypto_generichash_blake2b_update = q.xc)(A, I, g, C);
            }, Q._crypto_generichash_blake2b_final = function(A, I, g) {
                return (Q._crypto_generichash_blake2b_final = q.yc)(A, I, g);
            }, Q._crypto_hash_bytes = function() {
                return (Q._crypto_hash_bytes = q.zc)();
            }, Q._crypto_hash = function(A, I, g, C) {
                return (Q._crypto_hash = q.Ac)(A, I, g, C);
            }, Q._crypto_hash_primitive = function() {
                return (Q._crypto_hash_primitive = q.Bc)();
            }, Q._crypto_hash_sha256_bytes = function() {
                return (Q._crypto_hash_sha256_bytes = q.Cc)();
            }, Q._crypto_hash_sha256_statebytes = function() {
                return (Q._crypto_hash_sha256_statebytes = q.Dc)();
            }, Q._crypto_hash_sha256_init = function(A) {
                return (Q._crypto_hash_sha256_init = q.Ec)(A);
            }, Q._crypto_hash_sha256_update = function(A, I, g, C) {
                return (Q._crypto_hash_sha256_update = q.Fc)(A, I, g, C);
            }, Q._crypto_hash_sha256_final = function(A, I) {
                return (Q._crypto_hash_sha256_final = q.Gc)(A, I);
            }, Q._crypto_hash_sha256 = function(A, I, g, C) {
                return (Q._crypto_hash_sha256 = q.Hc)(A, I, g, C);
            }, Q._crypto_hash_sha512_bytes = function() {
                return (Q._crypto_hash_sha512_bytes = q.Ic)();
            }, Q._crypto_hash_sha512_statebytes = function() {
                return (Q._crypto_hash_sha512_statebytes = q.Jc)();
            }, Q._crypto_hash_sha512_init = function(A) {
                return (Q._crypto_hash_sha512_init = q.Kc)(A);
            }, Q._crypto_hash_sha512_update = function(A, I, g, C) {
                return (Q._crypto_hash_sha512_update = q.Lc)(A, I, g, C);
            }, Q._crypto_hash_sha512_final = function(A, I) {
                return (Q._crypto_hash_sha512_final = q.Mc)(A, I);
            }, Q._crypto_hash_sha512 = function(A, I, g, C) {
                return (Q._crypto_hash_sha512 = q.Nc)(A, I, g, C);
            }, Q._crypto_kdf_blake2b_bytes_min = function() {
                return (Q._crypto_kdf_blake2b_bytes_min = q.Oc)();
            }, Q._crypto_kdf_blake2b_bytes_max = function() {
                return (Q._crypto_kdf_blake2b_bytes_max = q.Pc)();
            }, Q._crypto_kdf_blake2b_contextbytes = function() {
                return (Q._crypto_kdf_blake2b_contextbytes = q.Qc)();
            }, Q._crypto_kdf_blake2b_keybytes = function() {
                return (Q._crypto_kdf_blake2b_keybytes = q.Rc)();
            }, Q._crypto_kdf_blake2b_derive_from_key = function(A, I, g, C, B, i) {
                return (Q._crypto_kdf_blake2b_derive_from_key = q.Sc)(A, I, g, C, B, i);
            }, Q._crypto_kdf_primitive = function() {
                return (Q._crypto_kdf_primitive = q.Tc)();
            }, Q._crypto_kdf_bytes_min = function() {
                return (Q._crypto_kdf_bytes_min = q.Uc)();
            }, Q._crypto_kdf_bytes_max = function() {
                return (Q._crypto_kdf_bytes_max = q.Vc)();
            }, Q._crypto_kdf_contextbytes = function() {
                return (Q._crypto_kdf_contextbytes = q.Wc)();
            }, Q._crypto_kdf_keybytes = function() {
                return (Q._crypto_kdf_keybytes = q.Xc)();
            }, Q._crypto_kdf_derive_from_key = function(A, I, g, C, B, i) {
                return (Q._crypto_kdf_derive_from_key = q.Yc)(A, I, g, C, B, i);
            }, Q._crypto_kdf_keygen = function(A) {
                return (Q._crypto_kdf_keygen = q.Zc)(A);
            }, Q._crypto_kdf_hkdf_sha256_extract_init = function(A, I, g) {
                return (Q._crypto_kdf_hkdf_sha256_extract_init = q._c)(A, I, g);
            }, Q._crypto_kdf_hkdf_sha256_extract_update = function(A, I, g) {
                return (Q._crypto_kdf_hkdf_sha256_extract_update = q.$c)(A, I, g);
            }, Q._crypto_kdf_hkdf_sha256_extract_final = function(A, I) {
                return (Q._crypto_kdf_hkdf_sha256_extract_final = q.ad)(A, I);
            }, Q._crypto_kdf_hkdf_sha256_extract = function(A, I, g, C, B) {
                return (Q._crypto_kdf_hkdf_sha256_extract = q.bd)(A, I, g, C, B);
            }, Q._crypto_kdf_hkdf_sha256_keygen = function(A) {
                return (Q._crypto_kdf_hkdf_sha256_keygen = q.cd)(A);
            }, Q._crypto_kdf_hkdf_sha256_expand = function(A, I, g, C, B) {
                return (Q._crypto_kdf_hkdf_sha256_expand = q.dd)(A, I, g, C, B);
            }, Q._crypto_kdf_hkdf_sha256_keybytes = function() {
                return (Q._crypto_kdf_hkdf_sha256_keybytes = q.ed)();
            }, Q._crypto_kdf_hkdf_sha256_bytes_min = function() {
                return (Q._crypto_kdf_hkdf_sha256_bytes_min = q.fd)();
            }, Q._crypto_kdf_hkdf_sha256_bytes_max = function() {
                return (Q._crypto_kdf_hkdf_sha256_bytes_max = q.gd)();
            }, Q._crypto_kdf_hkdf_sha256_statebytes = function() {
                return (Q._crypto_kdf_hkdf_sha256_statebytes = q.hd)();
            }, Q._crypto_kdf_hkdf_sha512_extract_init = function(A, I, g) {
                return (Q._crypto_kdf_hkdf_sha512_extract_init = q.id)(A, I, g);
            }, Q._crypto_kdf_hkdf_sha512_extract_update = function(A, I, g) {
                return (Q._crypto_kdf_hkdf_sha512_extract_update = q.jd)(A, I, g);
            }, Q._crypto_kdf_hkdf_sha512_extract_final = function(A, I) {
                return (Q._crypto_kdf_hkdf_sha512_extract_final = q.kd)(A, I);
            }, Q._crypto_kdf_hkdf_sha512_extract = function(A, I, g, C, B) {
                return (Q._crypto_kdf_hkdf_sha512_extract = q.ld)(A, I, g, C, B);
            }, Q._crypto_kdf_hkdf_sha512_keygen = function(A) {
                return (Q._crypto_kdf_hkdf_sha512_keygen = q.md)(A);
            }, Q._crypto_kdf_hkdf_sha512_expand = function(A, I, g, C, B) {
                return (Q._crypto_kdf_hkdf_sha512_expand = q.nd)(A, I, g, C, B);
            }, Q._crypto_kdf_hkdf_sha512_keybytes = function() {
                return (Q._crypto_kdf_hkdf_sha512_keybytes = q.od)();
            }, Q._crypto_kdf_hkdf_sha512_bytes_min = function() {
                return (Q._crypto_kdf_hkdf_sha512_bytes_min = q.pd)();
            }, Q._crypto_kdf_hkdf_sha512_bytes_max = function() {
                return (Q._crypto_kdf_hkdf_sha512_bytes_max = q.qd)();
            }, Q._crypto_kx_seed_keypair = function(A, I, g) {
                return (Q._crypto_kx_seed_keypair = q.rd)(A, I, g);
            }, Q._crypto_kx_keypair = function(A, I) {
                return (Q._crypto_kx_keypair = q.sd)(A, I);
            }, Q._crypto_kx_client_session_keys = function(A, I, g, C, B) {
                return (Q._crypto_kx_client_session_keys = q.td)(A, I, g, C, B);
            }, Q._crypto_kx_server_session_keys = function(A, I, g, C, B) {
                return (Q._crypto_kx_server_session_keys = q.ud)(A, I, g, C, B);
            }, Q._crypto_kx_publickeybytes = function() {
                return (Q._crypto_kx_publickeybytes = q.vd)();
            }, Q._crypto_kx_secretkeybytes = function() {
                return (Q._crypto_kx_secretkeybytes = q.wd)();
            }, Q._crypto_kx_seedbytes = function() {
                return (Q._crypto_kx_seedbytes = q.xd)();
            }, Q._crypto_kx_sessionkeybytes = function() {
                return (Q._crypto_kx_sessionkeybytes = q.yd)();
            }, Q._crypto_kx_primitive = function() {
                return (Q._crypto_kx_primitive = q.zd)();
            }, Q._crypto_onetimeauth_statebytes = function() {
                return (Q._crypto_onetimeauth_statebytes = q.Ad)();
            }, Q._crypto_onetimeauth_bytes = function() {
                return (Q._crypto_onetimeauth_bytes = q.Bd)();
            }, Q._crypto_onetimeauth_keybytes = function() {
                return (Q._crypto_onetimeauth_keybytes = q.Cd)();
            }, Q._crypto_onetimeauth = function(A, I, g, C, B) {
                return (Q._crypto_onetimeauth = q.Dd)(A, I, g, C, B);
            }, Q._crypto_onetimeauth_verify = function(A, I, g, C, B) {
                return (Q._crypto_onetimeauth_verify = q.Ed)(A, I, g, C, B);
            }, Q._crypto_onetimeauth_init = function(A, I) {
                return (Q._crypto_onetimeauth_init = q.Fd)(A, I);
            }, Q._crypto_onetimeauth_update = function(A, I, g, C) {
                return (Q._crypto_onetimeauth_update = q.Gd)(A, I, g, C);
            }, Q._crypto_onetimeauth_final = function(A, I) {
                return (Q._crypto_onetimeauth_final = q.Hd)(A, I);
            }, Q._crypto_onetimeauth_primitive = function() {
                return (Q._crypto_onetimeauth_primitive = q.Id)();
            }, Q._crypto_onetimeauth_keygen = function(A) {
                return (Q._crypto_onetimeauth_keygen = q.Jd)(A);
            }, Q._crypto_onetimeauth_poly1305 = function(A, I, g, C, B) {
                return (Q._crypto_onetimeauth_poly1305 = q.Kd)(A, I, g, C, B);
            }, Q._crypto_onetimeauth_poly1305_verify = function(A, I, g, C, B) {
                return (Q._crypto_onetimeauth_poly1305_verify = q.Ld)(A, I, g, C, B);
            }, Q._crypto_onetimeauth_poly1305_init = function(A, I) {
                return (Q._crypto_onetimeauth_poly1305_init = q.Md)(A, I);
            }, Q._crypto_onetimeauth_poly1305_update = function(A, I, g, C) {
                return (Q._crypto_onetimeauth_poly1305_update = q.Nd)(A, I, g, C);
            }, Q._crypto_onetimeauth_poly1305_final = function(A, I) {
                return (Q._crypto_onetimeauth_poly1305_final = q.Od)(A, I);
            }, Q._crypto_onetimeauth_poly1305_bytes = function() {
                return (Q._crypto_onetimeauth_poly1305_bytes = q.Pd)();
            }, Q._crypto_onetimeauth_poly1305_keybytes = function() {
                return (Q._crypto_onetimeauth_poly1305_keybytes = q.Qd)();
            }, Q._crypto_onetimeauth_poly1305_statebytes = function() {
                return (Q._crypto_onetimeauth_poly1305_statebytes = q.Rd)();
            }, Q._crypto_onetimeauth_poly1305_keygen = function(A) {
                return (Q._crypto_onetimeauth_poly1305_keygen = q.Sd)(A);
            }, Q._crypto_pwhash_argon2i_alg_argon2i13 = function() {
                return (Q._crypto_pwhash_argon2i_alg_argon2i13 = q.Td)();
            }, Q._crypto_pwhash_argon2i_bytes_min = function() {
                return (Q._crypto_pwhash_argon2i_bytes_min = q.Ud)();
            }, Q._crypto_pwhash_argon2i_bytes_max = function() {
                return (Q._crypto_pwhash_argon2i_bytes_max = q.Vd)();
            }, Q._crypto_pwhash_argon2i_passwd_min = function() {
                return (Q._crypto_pwhash_argon2i_passwd_min = q.Wd)();
            }, Q._crypto_pwhash_argon2i_passwd_max = function() {
                return (Q._crypto_pwhash_argon2i_passwd_max = q.Xd)();
            }, Q._crypto_pwhash_argon2i_saltbytes = function() {
                return (Q._crypto_pwhash_argon2i_saltbytes = q.Yd)();
            }, Q._crypto_pwhash_argon2i_strbytes = function() {
                return (Q._crypto_pwhash_argon2i_strbytes = q.Zd)();
            }, Q._crypto_pwhash_argon2i_strprefix = function() {
                return (Q._crypto_pwhash_argon2i_strprefix = q._d)();
            }, Q._crypto_pwhash_argon2i_opslimit_min = function() {
                return (Q._crypto_pwhash_argon2i_opslimit_min = q.$d)();
            }, Q._crypto_pwhash_argon2i_opslimit_max = function() {
                return (Q._crypto_pwhash_argon2i_opslimit_max = q.ae)();
            }, Q._crypto_pwhash_argon2i_memlimit_min = function() {
                return (Q._crypto_pwhash_argon2i_memlimit_min = q.be)();
            }, Q._crypto_pwhash_argon2i_memlimit_max = function() {
                return (Q._crypto_pwhash_argon2i_memlimit_max = q.ce)();
            }, Q._crypto_pwhash_argon2i_opslimit_interactive = function() {
                return (Q._crypto_pwhash_argon2i_opslimit_interactive = q.de)();
            }, Q._crypto_pwhash_argon2i_memlimit_interactive = function() {
                return (Q._crypto_pwhash_argon2i_memlimit_interactive = q.ee)();
            }, Q._crypto_pwhash_argon2i_opslimit_moderate = function() {
                return (Q._crypto_pwhash_argon2i_opslimit_moderate = q.fe)();
            }, Q._crypto_pwhash_argon2i_memlimit_moderate = function() {
                return (Q._crypto_pwhash_argon2i_memlimit_moderate = q.ge)();
            }, Q._crypto_pwhash_argon2i_opslimit_sensitive = function() {
                return (Q._crypto_pwhash_argon2i_opslimit_sensitive = q.he)();
            }, Q._crypto_pwhash_argon2i_memlimit_sensitive = function() {
                return (Q._crypto_pwhash_argon2i_memlimit_sensitive = q.ie)();
            }, Q._crypto_pwhash_argon2i = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_pwhash_argon2i = q.je)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_pwhash_argon2i_str = function(A, I, g, C, B, i, o) {
                return (Q._crypto_pwhash_argon2i_str = q.ke)(A, I, g, C, B, i, o);
            }, Q._crypto_pwhash_argon2i_str_verify = function(A, I, g, C) {
                return (Q._crypto_pwhash_argon2i_str_verify = q.le)(A, I, g, C);
            }, Q._crypto_pwhash_argon2i_str_needs_rehash = function(A, I, g, C) {
                return (Q._crypto_pwhash_argon2i_str_needs_rehash = q.me)(A, I, g, C);
            }, Q._crypto_pwhash_argon2id_str_needs_rehash = function(A, I, g, C) {
                return (Q._crypto_pwhash_argon2id_str_needs_rehash = q.ne)(A, I, g, C);
            }, Q._crypto_pwhash_argon2id_alg_argon2id13 = function() {
                return (Q._crypto_pwhash_argon2id_alg_argon2id13 = q.oe)();
            }, Q._crypto_pwhash_argon2id_bytes_min = function() {
                return (Q._crypto_pwhash_argon2id_bytes_min = q.pe)();
            }, Q._crypto_pwhash_argon2id_bytes_max = function() {
                return (Q._crypto_pwhash_argon2id_bytes_max = q.qe)();
            }, Q._crypto_pwhash_argon2id_passwd_min = function() {
                return (Q._crypto_pwhash_argon2id_passwd_min = q.re)();
            }, Q._crypto_pwhash_argon2id_passwd_max = function() {
                return (Q._crypto_pwhash_argon2id_passwd_max = q.se)();
            }, Q._crypto_pwhash_argon2id_saltbytes = function() {
                return (Q._crypto_pwhash_argon2id_saltbytes = q.te)();
            }, Q._crypto_pwhash_argon2id_strbytes = function() {
                return (Q._crypto_pwhash_argon2id_strbytes = q.ue)();
            }, Q._crypto_pwhash_argon2id_strprefix = function() {
                return (Q._crypto_pwhash_argon2id_strprefix = q.ve)();
            }, Q._crypto_pwhash_argon2id_opslimit_min = function() {
                return (Q._crypto_pwhash_argon2id_opslimit_min = q.we)();
            }, Q._crypto_pwhash_argon2id_opslimit_max = function() {
                return (Q._crypto_pwhash_argon2id_opslimit_max = q.xe)();
            }, Q._crypto_pwhash_argon2id_memlimit_min = function() {
                return (Q._crypto_pwhash_argon2id_memlimit_min = q.ye)();
            }, Q._crypto_pwhash_argon2id_memlimit_max = function() {
                return (Q._crypto_pwhash_argon2id_memlimit_max = q.ze)();
            }, Q._crypto_pwhash_argon2id_opslimit_interactive = function() {
                return (Q._crypto_pwhash_argon2id_opslimit_interactive = q.Ae)();
            }, Q._crypto_pwhash_argon2id_memlimit_interactive = function() {
                return (Q._crypto_pwhash_argon2id_memlimit_interactive = q.Be)();
            }, Q._crypto_pwhash_argon2id_opslimit_moderate = function() {
                return (Q._crypto_pwhash_argon2id_opslimit_moderate = q.Ce)();
            }, Q._crypto_pwhash_argon2id_memlimit_moderate = function() {
                return (Q._crypto_pwhash_argon2id_memlimit_moderate = q.De)();
            }, Q._crypto_pwhash_argon2id_opslimit_sensitive = function() {
                return (Q._crypto_pwhash_argon2id_opslimit_sensitive = q.Ee)();
            }, Q._crypto_pwhash_argon2id_memlimit_sensitive = function() {
                return (Q._crypto_pwhash_argon2id_memlimit_sensitive = q.Fe)();
            }, Q._crypto_pwhash_argon2id = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_pwhash_argon2id = q.Ge)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_pwhash_argon2id_str = function(A, I, g, C, B, i, o) {
                return (Q._crypto_pwhash_argon2id_str = q.He)(A, I, g, C, B, i, o);
            }, Q._crypto_pwhash_argon2id_str_verify = function(A, I, g, C) {
                return (Q._crypto_pwhash_argon2id_str_verify = q.Ie)(A, I, g, C);
            }, Q._crypto_pwhash_alg_argon2i13 = function() {
                return (Q._crypto_pwhash_alg_argon2i13 = q.Je)();
            }, Q._crypto_pwhash_alg_argon2id13 = function() {
                return (Q._crypto_pwhash_alg_argon2id13 = q.Ke)();
            }, Q._crypto_pwhash_alg_default = function() {
                return (Q._crypto_pwhash_alg_default = q.Le)();
            }, Q._crypto_pwhash_bytes_min = function() {
                return (Q._crypto_pwhash_bytes_min = q.Me)();
            }, Q._crypto_pwhash_bytes_max = function() {
                return (Q._crypto_pwhash_bytes_max = q.Ne)();
            }, Q._crypto_pwhash_passwd_min = function() {
                return (Q._crypto_pwhash_passwd_min = q.Oe)();
            }, Q._crypto_pwhash_passwd_max = function() {
                return (Q._crypto_pwhash_passwd_max = q.Pe)();
            }, Q._crypto_pwhash_saltbytes = function() {
                return (Q._crypto_pwhash_saltbytes = q.Qe)();
            }, Q._crypto_pwhash_strbytes = function() {
                return (Q._crypto_pwhash_strbytes = q.Re)();
            }, Q._crypto_pwhash_strprefix = function() {
                return (Q._crypto_pwhash_strprefix = q.Se)();
            }, Q._crypto_pwhash_opslimit_min = function() {
                return (Q._crypto_pwhash_opslimit_min = q.Te)();
            }, Q._crypto_pwhash_opslimit_max = function() {
                return (Q._crypto_pwhash_opslimit_max = q.Ue)();
            }, Q._crypto_pwhash_memlimit_min = function() {
                return (Q._crypto_pwhash_memlimit_min = q.Ve)();
            }, Q._crypto_pwhash_memlimit_max = function() {
                return (Q._crypto_pwhash_memlimit_max = q.We)();
            }, Q._crypto_pwhash_opslimit_interactive = function() {
                return (Q._crypto_pwhash_opslimit_interactive = q.Xe)();
            }, Q._crypto_pwhash_memlimit_interactive = function() {
                return (Q._crypto_pwhash_memlimit_interactive = q.Ye)();
            }, Q._crypto_pwhash_opslimit_moderate = function() {
                return (Q._crypto_pwhash_opslimit_moderate = q.Ze)();
            }, Q._crypto_pwhash_memlimit_moderate = function() {
                return (Q._crypto_pwhash_memlimit_moderate = q._e)();
            }, Q._crypto_pwhash_opslimit_sensitive = function() {
                return (Q._crypto_pwhash_opslimit_sensitive = q.$e)();
            }, Q._crypto_pwhash_memlimit_sensitive = function() {
                return (Q._crypto_pwhash_memlimit_sensitive = q.af)();
            }, Q._crypto_pwhash = function(A, I, g, C, B, i, o, E, a, _, c) {
                return (Q._crypto_pwhash = q.bf)(A, I, g, C, B, i, o, E, a, _, c);
            }, Q._crypto_pwhash_str = function(A, I, g, C, B, i, o) {
                return (Q._crypto_pwhash_str = q.cf)(A, I, g, C, B, i, o);
            }, Q._crypto_pwhash_str_alg = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_pwhash_str_alg = q.df)(A, I, g, C, B, i, o, E);
            }, Q._crypto_pwhash_str_verify = function(A, I, g, C) {
                return (Q._crypto_pwhash_str_verify = q.ef)(A, I, g, C);
            }, Q._crypto_pwhash_str_needs_rehash = function(A, I, g, C) {
                return (Q._crypto_pwhash_str_needs_rehash = q.ff)(A, I, g, C);
            }, Q._crypto_pwhash_primitive = function() {
                return (Q._crypto_pwhash_primitive = q.gf)();
            }, Q._crypto_scalarmult_primitive = function() {
                return (Q._crypto_scalarmult_primitive = q.hf)();
            }, Q._crypto_scalarmult_base = function(A, I) {
                return (Q._crypto_scalarmult_base = q.jf)(A, I);
            }, Q._crypto_scalarmult = function(A, I, g) {
                return (Q._crypto_scalarmult = q.kf)(A, I, g);
            }, Q._crypto_scalarmult_bytes = function() {
                return (Q._crypto_scalarmult_bytes = q.lf)();
            }, Q._crypto_scalarmult_scalarbytes = function() {
                return (Q._crypto_scalarmult_scalarbytes = q.mf)();
            }, Q._crypto_scalarmult_curve25519 = function(A, I, g) {
                return (Q._crypto_scalarmult_curve25519 = q.nf)(A, I, g);
            }, Q._crypto_scalarmult_curve25519_base = function(A, I) {
                return (Q._crypto_scalarmult_curve25519_base = q.of)(A, I);
            }, Q._crypto_scalarmult_curve25519_bytes = function() {
                return (Q._crypto_scalarmult_curve25519_bytes = q.pf)();
            }, Q._crypto_scalarmult_curve25519_scalarbytes = function() {
                return (Q._crypto_scalarmult_curve25519_scalarbytes = q.qf)();
            }, Q._crypto_secretbox_keybytes = function() {
                return (Q._crypto_secretbox_keybytes = q.rf)();
            }, Q._crypto_secretbox_noncebytes = function() {
                return (Q._crypto_secretbox_noncebytes = q.sf)();
            }, Q._crypto_secretbox_zerobytes = function() {
                return (Q._crypto_secretbox_zerobytes = q.tf)();
            }, Q._crypto_secretbox_boxzerobytes = function() {
                return (Q._crypto_secretbox_boxzerobytes = q.uf)();
            }, Q._crypto_secretbox_macbytes = function() {
                return (Q._crypto_secretbox_macbytes = q.vf)();
            }, Q._crypto_secretbox_messagebytes_max = function() {
                return (Q._crypto_secretbox_messagebytes_max = q.wf)();
            }, Q._crypto_secretbox_primitive = function() {
                return (Q._crypto_secretbox_primitive = q.xf)();
            }, Q._crypto_secretbox = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox = q.yf)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_open = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_open = q.zf)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_keygen = function(A) {
                return (Q._crypto_secretbox_keygen = q.Af)(A);
            }, Q._crypto_secretbox_detached = function(A, I, g, C, B, i, o) {
                return (Q._crypto_secretbox_detached = q.Bf)(A, I, g, C, B, i, o);
            }, Q._crypto_secretbox_easy = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_easy = q.Cf)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_open_detached = function(A, I, g, C, B, i, o) {
                return (Q._crypto_secretbox_open_detached = q.Df)(A, I, g, C, B, i, o);
            }, Q._crypto_secretbox_open_easy = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_open_easy = q.Ef)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_xsalsa20poly1305 = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_xsalsa20poly1305 = q.Ff)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_xsalsa20poly1305_open = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_xsalsa20poly1305_open = q.Gf)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_xsalsa20poly1305_keybytes = function() {
                return (Q._crypto_secretbox_xsalsa20poly1305_keybytes = q.Hf)();
            }, Q._crypto_secretbox_xsalsa20poly1305_noncebytes = function() {
                return (Q._crypto_secretbox_xsalsa20poly1305_noncebytes = q.If)();
            }, Q._crypto_secretbox_xsalsa20poly1305_zerobytes = function() {
                return (Q._crypto_secretbox_xsalsa20poly1305_zerobytes = q.Jf)();
            }, Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = function() {
                return (Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = q.Kf)();
            }, Q._crypto_secretbox_xsalsa20poly1305_macbytes = function() {
                return (Q._crypto_secretbox_xsalsa20poly1305_macbytes = q.Lf)();
            }, Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = function() {
                return (Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = q.Mf)();
            }, Q._crypto_secretbox_xsalsa20poly1305_keygen = function(A) {
                return (Q._crypto_secretbox_xsalsa20poly1305_keygen = q.Nf)(A);
            }, Q._crypto_secretstream_xchacha20poly1305_keygen = function(A) {
                return (Q._crypto_secretstream_xchacha20poly1305_keygen = q.Of)(A);
            }, Q._crypto_secretstream_xchacha20poly1305_init_push = function(A, I, g) {
                return (Q._crypto_secretstream_xchacha20poly1305_init_push = q.Pf)(A, I, g);
            }, Q._crypto_secretstream_xchacha20poly1305_init_pull = function(A, I, g) {
                return (Q._crypto_secretstream_xchacha20poly1305_init_pull = q.Qf)(A, I, g);
            }, Q._crypto_secretstream_xchacha20poly1305_rekey = function(A) {
                return (Q._crypto_secretstream_xchacha20poly1305_rekey = q.Rf)(A);
            }, Q._crypto_secretstream_xchacha20poly1305_push = function(A, I, g, C, B, i, o, E, a, _) {
                return (Q._crypto_secretstream_xchacha20poly1305_push = q.Sf)(A, I, g, C, B, i, o, E, a, _);
            }, Q._crypto_secretstream_xchacha20poly1305_pull = function(A, I, g, C, B, i, o, E, a, _) {
                return (Q._crypto_secretstream_xchacha20poly1305_pull = q.Tf)(A, I, g, C, B, i, o, E, a, _);
            }, Q._crypto_secretstream_xchacha20poly1305_statebytes = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_statebytes = q.Uf)();
            }, Q._crypto_secretstream_xchacha20poly1305_abytes = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_abytes = q.Vf)();
            }, Q._crypto_secretstream_xchacha20poly1305_headerbytes = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_headerbytes = q.Wf)();
            }, Q._crypto_secretstream_xchacha20poly1305_keybytes = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_keybytes = q.Xf)();
            }, Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = q.Yf)();
            }, Q._crypto_secretstream_xchacha20poly1305_tag_message = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_tag_message = q.Zf)();
            }, Q._crypto_secretstream_xchacha20poly1305_tag_push = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_tag_push = q._f)();
            }, Q._crypto_secretstream_xchacha20poly1305_tag_rekey = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_tag_rekey = q.$f)();
            }, Q._crypto_secretstream_xchacha20poly1305_tag_final = function() {
                return (Q._crypto_secretstream_xchacha20poly1305_tag_final = q.ag)();
            }, Q._crypto_shorthash_bytes = function() {
                return (Q._crypto_shorthash_bytes = q.bg)();
            }, Q._crypto_shorthash_keybytes = function() {
                return (Q._crypto_shorthash_keybytes = q.cg)();
            }, Q._crypto_shorthash_primitive = function() {
                return (Q._crypto_shorthash_primitive = q.dg)();
            }, Q._crypto_shorthash = function(A, I, g, C, B) {
                return (Q._crypto_shorthash = q.eg)(A, I, g, C, B);
            }, Q._crypto_shorthash_keygen = function(A) {
                return (Q._crypto_shorthash_keygen = q.fg)(A);
            }, Q._crypto_shorthash_siphash24_bytes = function() {
                return (Q._crypto_shorthash_siphash24_bytes = q.gg)();
            }, Q._crypto_shorthash_siphash24_keybytes = function() {
                return (Q._crypto_shorthash_siphash24_keybytes = q.hg)();
            }, Q._crypto_shorthash_siphash24 = function(A, I, g, C, B) {
                return (Q._crypto_shorthash_siphash24 = q.ig)(A, I, g, C, B);
            }, Q._crypto_sign_statebytes = function() {
                return (Q._crypto_sign_statebytes = q.jg)();
            }, Q._crypto_sign_bytes = function() {
                return (Q._crypto_sign_bytes = q.kg)();
            }, Q._crypto_sign_seedbytes = function() {
                return (Q._crypto_sign_seedbytes = q.lg)();
            }, Q._crypto_sign_publickeybytes = function() {
                return (Q._crypto_sign_publickeybytes = q.mg)();
            }, Q._crypto_sign_secretkeybytes = function() {
                return (Q._crypto_sign_secretkeybytes = q.ng)();
            }, Q._crypto_sign_messagebytes_max = function() {
                return (Q._crypto_sign_messagebytes_max = q.og)();
            }, Q._crypto_sign_primitive = function() {
                return (Q._crypto_sign_primitive = q.pg)();
            }, Q._crypto_sign_seed_keypair = function(A, I, g) {
                return (Q._crypto_sign_seed_keypair = q.qg)(A, I, g);
            }, Q._crypto_sign_keypair = function(A, I) {
                return (Q._crypto_sign_keypair = q.rg)(A, I);
            }, Q._crypto_sign = function(A, I, g, C, B, i) {
                return (Q._crypto_sign = q.sg)(A, I, g, C, B, i);
            }, Q._crypto_sign_open = function(A, I, g, C, B, i) {
                return (Q._crypto_sign_open = q.tg)(A, I, g, C, B, i);
            }, Q._crypto_sign_detached = function(A, I, g, C, B, i) {
                return (Q._crypto_sign_detached = q.ug)(A, I, g, C, B, i);
            }, Q._crypto_sign_verify_detached = function(A, I, g, C, B) {
                return (Q._crypto_sign_verify_detached = q.vg)(A, I, g, C, B);
            }, Q._crypto_sign_init = function(A) {
                return (Q._crypto_sign_init = q.wg)(A);
            }, Q._crypto_sign_update = function(A, I, g, C) {
                return (Q._crypto_sign_update = q.xg)(A, I, g, C);
            }, Q._crypto_sign_final_create = function(A, I, g, C) {
                return (Q._crypto_sign_final_create = q.yg)(A, I, g, C);
            }, Q._crypto_sign_final_verify = function(A, I, g) {
                return (Q._crypto_sign_final_verify = q.zg)(A, I, g);
            }, Q._crypto_sign_ed25519ph_statebytes = function() {
                return (Q._crypto_sign_ed25519ph_statebytes = q.Ag)();
            }, Q._crypto_sign_ed25519_bytes = function() {
                return (Q._crypto_sign_ed25519_bytes = q.Bg)();
            }, Q._crypto_sign_ed25519_seedbytes = function() {
                return (Q._crypto_sign_ed25519_seedbytes = q.Cg)();
            }, Q._crypto_sign_ed25519_publickeybytes = function() {
                return (Q._crypto_sign_ed25519_publickeybytes = q.Dg)();
            }, Q._crypto_sign_ed25519_secretkeybytes = function() {
                return (Q._crypto_sign_ed25519_secretkeybytes = q.Eg)();
            }, Q._crypto_sign_ed25519_messagebytes_max = function() {
                return (Q._crypto_sign_ed25519_messagebytes_max = q.Fg)();
            }, Q._crypto_sign_ed25519_sk_to_seed = function(A, I) {
                return (Q._crypto_sign_ed25519_sk_to_seed = q.Gg)(A, I);
            }, Q._crypto_sign_ed25519_sk_to_pk = function(A, I) {
                return (Q._crypto_sign_ed25519_sk_to_pk = q.Hg)(A, I);
            }, Q._crypto_sign_ed25519ph_init = function(A) {
                return (Q._crypto_sign_ed25519ph_init = q.Ig)(A);
            }, Q._crypto_sign_ed25519ph_update = function(A, I, g, C) {
                return (Q._crypto_sign_ed25519ph_update = q.Jg)(A, I, g, C);
            }, Q._crypto_sign_ed25519ph_final_create = function(A, I, g, C) {
                return (Q._crypto_sign_ed25519ph_final_create = q.Kg)(A, I, g, C);
            }, Q._crypto_sign_ed25519ph_final_verify = function(A, I, g) {
                return (Q._crypto_sign_ed25519ph_final_verify = q.Lg)(A, I, g);
            }, Q._crypto_sign_ed25519_seed_keypair = function(A, I, g) {
                return (Q._crypto_sign_ed25519_seed_keypair = q.Mg)(A, I, g);
            }, Q._crypto_sign_ed25519_keypair = function(A, I) {
                return (Q._crypto_sign_ed25519_keypair = q.Ng)(A, I);
            }, Q._crypto_sign_ed25519_pk_to_curve25519 = function(A, I) {
                return (Q._crypto_sign_ed25519_pk_to_curve25519 = q.Og)(A, I);
            }, Q._crypto_sign_ed25519_sk_to_curve25519 = function(A, I) {
                return (Q._crypto_sign_ed25519_sk_to_curve25519 = q.Pg)(A, I);
            }, Q._crypto_sign_ed25519_verify_detached = function(A, I, g, C, B) {
                return (Q._crypto_sign_ed25519_verify_detached = q.Qg)(A, I, g, C, B);
            }, Q._crypto_sign_ed25519_open = function(A, I, g, C, B, i) {
                return (Q._crypto_sign_ed25519_open = q.Rg)(A, I, g, C, B, i);
            }, Q._crypto_sign_ed25519_detached = function(A, I, g, C, B, i) {
                return (Q._crypto_sign_ed25519_detached = q.Sg)(A, I, g, C, B, i);
            }, Q._crypto_sign_ed25519 = function(A, I, g, C, B, i) {
                return (Q._crypto_sign_ed25519 = q.Tg)(A, I, g, C, B, i);
            }, Q._crypto_stream_chacha20_keybytes = function() {
                return (Q._crypto_stream_chacha20_keybytes = q.Ug)();
            }, Q._crypto_stream_chacha20_noncebytes = function() {
                return (Q._crypto_stream_chacha20_noncebytes = q.Vg)();
            }, Q._crypto_stream_chacha20_messagebytes_max = function() {
                return (Q._crypto_stream_chacha20_messagebytes_max = q.Wg)();
            }, Q._crypto_stream_chacha20_ietf_keybytes = function() {
                return (Q._crypto_stream_chacha20_ietf_keybytes = q.Xg)();
            }, Q._crypto_stream_chacha20_ietf_noncebytes = function() {
                return (Q._crypto_stream_chacha20_ietf_noncebytes = q.Yg)();
            }, Q._crypto_stream_chacha20_ietf_messagebytes_max = function() {
                return (Q._crypto_stream_chacha20_ietf_messagebytes_max = q.Zg)();
            }, Q._crypto_stream_chacha20 = function(A, I, g, C, B) {
                return (Q._crypto_stream_chacha20 = q._g)(A, I, g, C, B);
            }, Q._crypto_stream_chacha20_xor_ic = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_stream_chacha20_xor_ic = q.$g)(A, I, g, C, B, i, o, E);
            }, Q._crypto_stream_chacha20_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_chacha20_xor = q.ah)(A, I, g, C, B, i);
            }, Q._crypto_stream_chacha20_ietf = function(A, I, g, C, B) {
                return (Q._crypto_stream_chacha20_ietf = q.bh)(A, I, g, C, B);
            }, Q._crypto_stream_chacha20_ietf_xor_ic = function(A, I, g, C, B, i, o) {
                return (Q._crypto_stream_chacha20_ietf_xor_ic = q.ch)(A, I, g, C, B, i, o);
            }, Q._crypto_stream_chacha20_ietf_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_chacha20_ietf_xor = q.dh)(A, I, g, C, B, i);
            }, Q._crypto_stream_chacha20_ietf_keygen = function(A) {
                return (Q._crypto_stream_chacha20_ietf_keygen = q.eh)(A);
            }, Q._crypto_stream_chacha20_keygen = function(A) {
                return (Q._crypto_stream_chacha20_keygen = q.fh)(A);
            }, Q._crypto_stream_keybytes = function() {
                return (Q._crypto_stream_keybytes = q.gh)();
            }, Q._crypto_stream_noncebytes = function() {
                return (Q._crypto_stream_noncebytes = q.hh)();
            }, Q._crypto_stream_messagebytes_max = function() {
                return (Q._crypto_stream_messagebytes_max = q.ih)();
            }, Q._crypto_stream_primitive = function() {
                return (Q._crypto_stream_primitive = q.jh)();
            }, Q._crypto_stream = function(A, I, g, C, B) {
                return (Q._crypto_stream = q.kh)(A, I, g, C, B);
            }, Q._crypto_stream_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_xor = q.lh)(A, I, g, C, B, i);
            }, Q._crypto_stream_keygen = function(A) {
                return (Q._crypto_stream_keygen = q.mh)(A);
            }, Q._crypto_stream_salsa20_keybytes = function() {
                return (Q._crypto_stream_salsa20_keybytes = q.nh)();
            }, Q._crypto_stream_salsa20_noncebytes = function() {
                return (Q._crypto_stream_salsa20_noncebytes = q.oh)();
            }, Q._crypto_stream_salsa20_messagebytes_max = function() {
                return (Q._crypto_stream_salsa20_messagebytes_max = q.ph)();
            }, Q._crypto_stream_salsa20 = function(A, I, g, C, B) {
                return (Q._crypto_stream_salsa20 = q.qh)(A, I, g, C, B);
            }, Q._crypto_stream_salsa20_xor_ic = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_stream_salsa20_xor_ic = q.rh)(A, I, g, C, B, i, o, E);
            }, Q._crypto_stream_salsa20_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_salsa20_xor = q.sh)(A, I, g, C, B, i);
            }, Q._crypto_stream_salsa20_keygen = function(A) {
                return (Q._crypto_stream_salsa20_keygen = q.th)(A);
            }, Q._crypto_stream_xsalsa20 = function(A, I, g, C, B) {
                return (Q._crypto_stream_xsalsa20 = q.uh)(A, I, g, C, B);
            }, Q._crypto_stream_xsalsa20_xor_ic = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_stream_xsalsa20_xor_ic = q.vh)(A, I, g, C, B, i, o, E);
            }, Q._crypto_stream_xsalsa20_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_xsalsa20_xor = q.wh)(A, I, g, C, B, i);
            }, Q._crypto_stream_xsalsa20_keybytes = function() {
                return (Q._crypto_stream_xsalsa20_keybytes = q.xh)();
            }, Q._crypto_stream_xsalsa20_noncebytes = function() {
                return (Q._crypto_stream_xsalsa20_noncebytes = q.yh)();
            }, Q._crypto_stream_xsalsa20_messagebytes_max = function() {
                return (Q._crypto_stream_xsalsa20_messagebytes_max = q.zh)();
            }, Q._crypto_stream_xsalsa20_keygen = function(A) {
                return (Q._crypto_stream_xsalsa20_keygen = q.Ah)(A);
            }, Q._crypto_verify_16_bytes = function() {
                return (Q._crypto_verify_16_bytes = q.Bh)();
            }, Q._crypto_verify_32_bytes = function() {
                return (Q._crypto_verify_32_bytes = q.Ch)();
            }, Q._crypto_verify_64_bytes = function() {
                return (Q._crypto_verify_64_bytes = q.Dh)();
            }, Q._crypto_verify_16 = function(A, I) {
                return (Q._crypto_verify_16 = q.Eh)(A, I);
            }, Q._crypto_verify_32 = function(A, I) {
                return (Q._crypto_verify_32 = q.Fh)(A, I);
            }, Q._crypto_verify_64 = function(A, I) {
                return (Q._crypto_verify_64 = q.Gh)(A, I);
            }, Q._randombytes_implementation_name = function() {
                return (Q._randombytes_implementation_name = q.Hh)();
            }, Q._randombytes_random = function() {
                return (Q._randombytes_random = q.Ih)();
            }, Q._randombytes_stir = function() {
                return (Q._randombytes_stir = q.Jh)();
            }, Q._randombytes_uniform = function(A) {
                return (Q._randombytes_uniform = q.Kh)(A);
            }, Q._randombytes_buf = function(A, I) {
                return (Q._randombytes_buf = q.Lh)(A, I);
            }, Q._randombytes_buf_deterministic = function(A, I, g) {
                return (Q._randombytes_buf_deterministic = q.Mh)(A, I, g);
            }, Q._randombytes_seedbytes = function() {
                return (Q._randombytes_seedbytes = q.Nh)();
            }, Q._randombytes_close = function() {
                return (Q._randombytes_close = q.Oh)();
            }, Q._randombytes = function(A, I, g) {
                return (Q._randombytes = q.Ph)(A, I, g);
            }, Q._sodium_bin2hex = function(A, I, g, C) {
                return (Q._sodium_bin2hex = q.Qh)(A, I, g, C);
            }, Q._sodium_hex2bin = function(A, I, g, C, B, i, o) {
                return (Q._sodium_hex2bin = q.Rh)(A, I, g, C, B, i, o);
            }, Q._sodium_base64_encoded_len = function(A, I) {
                return (Q._sodium_base64_encoded_len = q.Sh)(A, I);
            }, Q._sodium_bin2base64 = function(A, I, g, C, B) {
                return (Q._sodium_bin2base64 = q.Th)(A, I, g, C, B);
            }, Q._sodium_base642bin = function(A, I, g, C, B, i, o, E) {
                return (Q._sodium_base642bin = q.Uh)(A, I, g, C, B, i, o, E);
            }, Q._sodium_init = function() {
                return (Q._sodium_init = q.Vh)();
            }, Q._sodium_pad = function(A, I, g, C, B) {
                return (Q._sodium_pad = q.Wh)(A, I, g, C, B);
            }, Q._sodium_unpad = function(A, I, g, C) {
                return (Q._sodium_unpad = q.Xh)(A, I, g, C);
            }, Q._sodium_version_string = function() {
                return (Q._sodium_version_string = q.Yh)();
            }, Q._sodium_library_version_major = function() {
                return (Q._sodium_library_version_major = q.Zh)();
            }, Q._sodium_library_version_minor = function() {
                return (Q._sodium_library_version_minor = q._h)();
            }, Q._sodium_library_minimal = function() {
                return (Q._sodium_library_minimal = q.$h)();
            }, Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = function(A, I, g) {
                return (Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = q.ai)(A, I, g);
            }, Q._crypto_box_curve25519xchacha20poly1305_keypair = function(A, I) {
                return (Q._crypto_box_curve25519xchacha20poly1305_keypair = q.bi)(A, I);
            }, Q._crypto_box_curve25519xchacha20poly1305_beforenm = function(A, I, g) {
                return (Q._crypto_box_curve25519xchacha20poly1305_beforenm = q.ci)(A, I, g);
            }, Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = q.di)(A, I, g, C, B, i, o);
            }, Q._crypto_box_curve25519xchacha20poly1305_detached = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_box_curve25519xchacha20poly1305_detached = q.ei)(A, I, g, C, B, i, o, E);
            }, Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = q.fi)(A, I, g, C, B, i);
            }, Q._crypto_box_curve25519xchacha20poly1305_easy = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_curve25519xchacha20poly1305_easy = q.gi)(A, I, g, C, B, i, o);
            }, Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = q.hi)(A, I, g, C, B, i, o);
            }, Q._crypto_box_curve25519xchacha20poly1305_open_detached = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_box_curve25519xchacha20poly1305_open_detached = q.ii)(A, I, g, C, B, i, o, E);
            }, Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = function(A, I, g, C, B, i) {
                return (Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = q.ji)(A, I, g, C, B, i);
            }, Q._crypto_box_curve25519xchacha20poly1305_open_easy = function(A, I, g, C, B, i, o) {
                return (Q._crypto_box_curve25519xchacha20poly1305_open_easy = q.ki)(A, I, g, C, B, i, o);
            }, Q._crypto_box_curve25519xchacha20poly1305_seedbytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_seedbytes = q.li)();
            }, Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = q.mi)();
            }, Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = q.ni)();
            }, Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = q.oi)();
            }, Q._crypto_box_curve25519xchacha20poly1305_noncebytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_noncebytes = q.pi)();
            }, Q._crypto_box_curve25519xchacha20poly1305_macbytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_macbytes = q.qi)();
            }, Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = q.ri)();
            }, Q._crypto_box_curve25519xchacha20poly1305_seal = function(A, I, g, C, B) {
                return (Q._crypto_box_curve25519xchacha20poly1305_seal = q.si)(A, I, g, C, B);
            }, Q._crypto_box_curve25519xchacha20poly1305_seal_open = function(A, I, g, C, B, i) {
                return (Q._crypto_box_curve25519xchacha20poly1305_seal_open = q.ti)(A, I, g, C, B, i);
            }, Q._crypto_box_curve25519xchacha20poly1305_sealbytes = function() {
                return (Q._crypto_box_curve25519xchacha20poly1305_sealbytes = q.ui)();
            }, Q._crypto_core_ed25519_is_valid_point = function(A) {
                return (Q._crypto_core_ed25519_is_valid_point = q.vi)(A);
            }, Q._crypto_core_ed25519_add = function(A, I, g) {
                return (Q._crypto_core_ed25519_add = q.wi)(A, I, g);
            }, Q._crypto_core_ed25519_sub = function(A, I, g) {
                return (Q._crypto_core_ed25519_sub = q.xi)(A, I, g);
            }, Q._crypto_core_ed25519_from_uniform = function(A, I) {
                return (Q._crypto_core_ed25519_from_uniform = q.yi)(A, I);
            }, Q._crypto_core_ed25519_random = function(A) {
                return (Q._crypto_core_ed25519_random = q.zi)(A);
            }, Q._crypto_core_ed25519_scalar_random = function(A) {
                return (Q._crypto_core_ed25519_scalar_random = q.Ai)(A);
            }, Q._crypto_core_ed25519_scalar_invert = function(A, I) {
                return (Q._crypto_core_ed25519_scalar_invert = q.Bi)(A, I);
            }, Q._crypto_core_ed25519_scalar_negate = function(A, I) {
                return (Q._crypto_core_ed25519_scalar_negate = q.Ci)(A, I);
            }, Q._crypto_core_ed25519_scalar_complement = function(A, I) {
                return (Q._crypto_core_ed25519_scalar_complement = q.Di)(A, I);
            }, Q._crypto_core_ed25519_scalar_add = function(A, I, g) {
                return (Q._crypto_core_ed25519_scalar_add = q.Ei)(A, I, g);
            }, Q._crypto_core_ed25519_scalar_reduce = function(A, I) {
                return (Q._crypto_core_ed25519_scalar_reduce = q.Fi)(A, I);
            }, Q._crypto_core_ed25519_scalar_sub = function(A, I, g) {
                return (Q._crypto_core_ed25519_scalar_sub = q.Gi)(A, I, g);
            }, Q._crypto_core_ed25519_scalar_mul = function(A, I, g) {
                return (Q._crypto_core_ed25519_scalar_mul = q.Hi)(A, I, g);
            }, Q._crypto_core_ed25519_bytes = function() {
                return (Q._crypto_core_ed25519_bytes = q.Ii)();
            }, Q._crypto_core_ed25519_nonreducedscalarbytes = function() {
                return (Q._crypto_core_ed25519_nonreducedscalarbytes = q.Ji)();
            }, Q._crypto_core_ed25519_uniformbytes = function() {
                return (Q._crypto_core_ed25519_uniformbytes = q.Ki)();
            }, Q._crypto_core_ed25519_hashbytes = function() {
                return (Q._crypto_core_ed25519_hashbytes = q.Li)();
            }, Q._crypto_core_ed25519_scalarbytes = function() {
                return (Q._crypto_core_ed25519_scalarbytes = q.Mi)();
            }, Q._crypto_core_ristretto255_is_valid_point = function(A) {
                return (Q._crypto_core_ristretto255_is_valid_point = q.Ni)(A);
            }, Q._crypto_core_ristretto255_add = function(A, I, g) {
                return (Q._crypto_core_ristretto255_add = q.Oi)(A, I, g);
            }, Q._crypto_core_ristretto255_sub = function(A, I, g) {
                return (Q._crypto_core_ristretto255_sub = q.Pi)(A, I, g);
            }, Q._crypto_core_ristretto255_from_hash = function(A, I) {
                return (Q._crypto_core_ristretto255_from_hash = q.Qi)(A, I);
            }, Q._crypto_core_ristretto255_random = function(A) {
                return (Q._crypto_core_ristretto255_random = q.Ri)(A);
            }, Q._crypto_core_ristretto255_scalar_random = function(A) {
                return (Q._crypto_core_ristretto255_scalar_random = q.Si)(A);
            }, Q._crypto_core_ristretto255_scalar_invert = function(A, I) {
                return (Q._crypto_core_ristretto255_scalar_invert = q.Ti)(A, I);
            }, Q._crypto_core_ristretto255_scalar_negate = function(A, I) {
                return (Q._crypto_core_ristretto255_scalar_negate = q.Ui)(A, I);
            }, Q._crypto_core_ristretto255_scalar_complement = function(A, I) {
                return (Q._crypto_core_ristretto255_scalar_complement = q.Vi)(A, I);
            }, Q._crypto_core_ristretto255_scalar_add = function(A, I, g) {
                return (Q._crypto_core_ristretto255_scalar_add = q.Wi)(A, I, g);
            }, Q._crypto_core_ristretto255_scalar_sub = function(A, I, g) {
                return (Q._crypto_core_ristretto255_scalar_sub = q.Xi)(A, I, g);
            }, Q._crypto_core_ristretto255_scalar_mul = function(A, I, g) {
                return (Q._crypto_core_ristretto255_scalar_mul = q.Yi)(A, I, g);
            }, Q._crypto_core_ristretto255_scalar_reduce = function(A, I) {
                return (Q._crypto_core_ristretto255_scalar_reduce = q.Zi)(A, I);
            }, Q._crypto_core_ristretto255_bytes = function() {
                return (Q._crypto_core_ristretto255_bytes = q._i)();
            }, Q._crypto_core_ristretto255_nonreducedscalarbytes = function() {
                return (Q._crypto_core_ristretto255_nonreducedscalarbytes = q.$i)();
            }, Q._crypto_core_ristretto255_hashbytes = function() {
                return (Q._crypto_core_ristretto255_hashbytes = q.aj)();
            }, Q._crypto_core_ristretto255_scalarbytes = function() {
                return (Q._crypto_core_ristretto255_scalarbytes = q.bj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_ll = function(A, I, g, C, B, i, o, E, a, _) {
                return (Q._crypto_pwhash_scryptsalsa208sha256_ll = q.cj)(A, I, g, C, B, i, o, E, a, _);
            }, Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = q.dj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = q.ej)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = q.fj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = q.gj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = q.hj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_strbytes = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_strbytes = q.ij)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_strprefix = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_strprefix = q.jj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = q.kj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = q.lj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = q.mj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = q.nj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = q.oj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = q.pj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = q.qj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = function() {
                return (Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = q.rj)();
            }, Q._crypto_pwhash_scryptsalsa208sha256 = function(A, I, g, C, B, i, o, E, a, _) {
                return (Q._crypto_pwhash_scryptsalsa208sha256 = q.sj)(A, I, g, C, B, i, o, E, a, _);
            }, Q._crypto_pwhash_scryptsalsa208sha256_str = function(A, I, g, C, B, i, o) {
                return (Q._crypto_pwhash_scryptsalsa208sha256_str = q.tj)(A, I, g, C, B, i, o);
            }, Q._crypto_pwhash_scryptsalsa208sha256_str_verify = function(A, I, g, C) {
                return (Q._crypto_pwhash_scryptsalsa208sha256_str_verify = q.uj)(A, I, g, C);
            }, Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = function(A, I, g, C) {
                return (Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = q.vj)(A, I, g, C);
            }, Q._crypto_scalarmult_ed25519 = function(A, I, g) {
                return (Q._crypto_scalarmult_ed25519 = q.wj)(A, I, g);
            }, Q._crypto_scalarmult_ed25519_noclamp = function(A, I, g) {
                return (Q._crypto_scalarmult_ed25519_noclamp = q.xj)(A, I, g);
            }, Q._crypto_scalarmult_ed25519_base = function(A, I) {
                return (Q._crypto_scalarmult_ed25519_base = q.yj)(A, I);
            }, Q._crypto_scalarmult_ed25519_base_noclamp = function(A, I) {
                return (Q._crypto_scalarmult_ed25519_base_noclamp = q.zj)(A, I);
            }, Q._crypto_scalarmult_ed25519_bytes = function() {
                return (Q._crypto_scalarmult_ed25519_bytes = q.Aj)();
            }, Q._crypto_scalarmult_ed25519_scalarbytes = function() {
                return (Q._crypto_scalarmult_ed25519_scalarbytes = q.Bj)();
            }, Q._crypto_scalarmult_ristretto255 = function(A, I, g) {
                return (Q._crypto_scalarmult_ristretto255 = q.Cj)(A, I, g);
            }, Q._crypto_scalarmult_ristretto255_base = function(A, I) {
                return (Q._crypto_scalarmult_ristretto255_base = q.Dj)(A, I);
            }, Q._crypto_scalarmult_ristretto255_bytes = function() {
                return (Q._crypto_scalarmult_ristretto255_bytes = q.Ej)();
            }, Q._crypto_scalarmult_ristretto255_scalarbytes = function() {
                return (Q._crypto_scalarmult_ristretto255_scalarbytes = q.Fj)();
            }, Q._crypto_secretbox_xchacha20poly1305_detached = function(A, I, g, C, B, i, o) {
                return (Q._crypto_secretbox_xchacha20poly1305_detached = q.Gj)(A, I, g, C, B, i, o);
            }, Q._crypto_secretbox_xchacha20poly1305_easy = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_xchacha20poly1305_easy = q.Hj)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_xchacha20poly1305_open_detached = function(A, I, g, C, B, i, o) {
                return (Q._crypto_secretbox_xchacha20poly1305_open_detached = q.Ij)(A, I, g, C, B, i, o);
            }, Q._crypto_secretbox_xchacha20poly1305_open_easy = function(A, I, g, C, B, i) {
                return (Q._crypto_secretbox_xchacha20poly1305_open_easy = q.Jj)(A, I, g, C, B, i);
            }, Q._crypto_secretbox_xchacha20poly1305_keybytes = function() {
                return (Q._crypto_secretbox_xchacha20poly1305_keybytes = q.Kj)();
            }, Q._crypto_secretbox_xchacha20poly1305_noncebytes = function() {
                return (Q._crypto_secretbox_xchacha20poly1305_noncebytes = q.Lj)();
            }, Q._crypto_secretbox_xchacha20poly1305_macbytes = function() {
                return (Q._crypto_secretbox_xchacha20poly1305_macbytes = q.Mj)();
            }, Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = function() {
                return (Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = q.Nj)();
            }, Q._crypto_shorthash_siphashx24_bytes = function() {
                return (Q._crypto_shorthash_siphashx24_bytes = q.Oj)();
            }, Q._crypto_shorthash_siphashx24_keybytes = function() {
                return (Q._crypto_shorthash_siphashx24_keybytes = q.Pj)();
            }, Q._crypto_shorthash_siphashx24 = function(A, I, g, C, B) {
                return (Q._crypto_shorthash_siphashx24 = q.Qj)(A, I, g, C, B);
            }, Q._crypto_stream_salsa2012 = function(A, I, g, C, B) {
                return (Q._crypto_stream_salsa2012 = q.Rj)(A, I, g, C, B);
            }, Q._crypto_stream_salsa2012_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_salsa2012_xor = q.Sj)(A, I, g, C, B, i);
            }, Q._crypto_stream_salsa2012_keybytes = function() {
                return (Q._crypto_stream_salsa2012_keybytes = q.Tj)();
            }, Q._crypto_stream_salsa2012_noncebytes = function() {
                return (Q._crypto_stream_salsa2012_noncebytes = q.Uj)();
            }, Q._crypto_stream_salsa2012_messagebytes_max = function() {
                return (Q._crypto_stream_salsa2012_messagebytes_max = q.Vj)();
            }, Q._crypto_stream_salsa2012_keygen = function(A) {
                return (Q._crypto_stream_salsa2012_keygen = q.Wj)(A);
            }, Q._crypto_stream_salsa208 = function(A, I, g, C, B) {
                return (Q._crypto_stream_salsa208 = q.Xj)(A, I, g, C, B);
            }, Q._crypto_stream_salsa208_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_salsa208_xor = q.Yj)(A, I, g, C, B, i);
            }, Q._crypto_stream_salsa208_keybytes = function() {
                return (Q._crypto_stream_salsa208_keybytes = q.Zj)();
            }, Q._crypto_stream_salsa208_noncebytes = function() {
                return (Q._crypto_stream_salsa208_noncebytes = q._j)();
            }, Q._crypto_stream_salsa208_messagebytes_max = function() {
                return (Q._crypto_stream_salsa208_messagebytes_max = q.$j)();
            }, Q._crypto_stream_salsa208_keygen = function(A) {
                return (Q._crypto_stream_salsa208_keygen = q.ak)(A);
            }, Q._crypto_stream_xchacha20_keybytes = function() {
                return (Q._crypto_stream_xchacha20_keybytes = q.bk)();
            }, Q._crypto_stream_xchacha20_noncebytes = function() {
                return (Q._crypto_stream_xchacha20_noncebytes = q.ck)();
            }, Q._crypto_stream_xchacha20_messagebytes_max = function() {
                return (Q._crypto_stream_xchacha20_messagebytes_max = q.dk)();
            }, Q._crypto_stream_xchacha20 = function(A, I, g, C, B) {
                return (Q._crypto_stream_xchacha20 = q.ek)(A, I, g, C, B);
            }, Q._crypto_stream_xchacha20_xor_ic = function(A, I, g, C, B, i, o, E) {
                return (Q._crypto_stream_xchacha20_xor_ic = q.fk)(A, I, g, C, B, i, o, E);
            }, Q._crypto_stream_xchacha20_xor = function(A, I, g, C, B, i) {
                return (Q._crypto_stream_xchacha20_xor = q.gk)(A, I, g, C, B, i);
            }, Q._crypto_stream_xchacha20_keygen = function(A) {
                return (Q._crypto_stream_xchacha20_keygen = q.hk)(A);
            }, Q._malloc = function(A) {
                return (Q._malloc = q.ik)(A);
            }, Q._free = function(A) {
                return (Q._free = q.jk)(A);
            }, Q.setValue = function(A, I) {
                var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "i8";
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        s[A >> 0] = I;
                        break;
                    case "i16":
                        D[A >> 1] = I;
                        break;
                    case "i32":
                        p[A >> 2] = I;
                        break;
                    case "i64":
                        H("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        f[A >> 2] = I;
                        break;
                    case "double":
                        n[A >> 3] = I;
                        break;
                    case "*":
                        w[A >> 2] = I;
                        break;
                    default:
                        H("invalid type for setValue: ".concat(g));
                }
            }, Q.getValue = function(A) {
                var _$I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "i8";
                switch(_$I.endsWith("*") && (_$I = "*"), _$I){
                    case "i1":
                    case "i8":
                        return s[A >> 0];
                    case "i16":
                        return D[A >> 1];
                    case "i32":
                        return p[A >> 2];
                    case "i64":
                        H("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return f[A >> 2];
                    case "double":
                        return n[A >> 3];
                    case "*":
                        return w[A >> 2];
                    default:
                        H("invalid type for getValue: ".concat(_$I));
                }
            }, Q.UTF8ToString = R, K = function A() {
                l || z(), l || (K = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            z();
        }).catch(function() {
            return C.useBackupModule();
        }), _$I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});
parcelRegister("4pbh3", function(module, exports) {
// shim for using process in browser
var $33523e0b1ec05d61$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $33523e0b1ec05d61$var$cachedSetTimeout;
var $33523e0b1ec05d61$var$cachedClearTimeout;
function $33523e0b1ec05d61$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $33523e0b1ec05d61$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $33523e0b1ec05d61$var$cachedSetTimeout = setTimeout;
        else $33523e0b1ec05d61$var$cachedSetTimeout = $33523e0b1ec05d61$var$defaultSetTimout;
    } catch (e) {
        $33523e0b1ec05d61$var$cachedSetTimeout = $33523e0b1ec05d61$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $33523e0b1ec05d61$var$cachedClearTimeout = clearTimeout;
        else $33523e0b1ec05d61$var$cachedClearTimeout = $33523e0b1ec05d61$var$defaultClearTimeout;
    } catch (e) {
        $33523e0b1ec05d61$var$cachedClearTimeout = $33523e0b1ec05d61$var$defaultClearTimeout;
    }
})();
function $33523e0b1ec05d61$var$runTimeout(fun) {
    if ($33523e0b1ec05d61$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($33523e0b1ec05d61$var$cachedSetTimeout === $33523e0b1ec05d61$var$defaultSetTimout || !$33523e0b1ec05d61$var$cachedSetTimeout) && setTimeout) {
        $33523e0b1ec05d61$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $33523e0b1ec05d61$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $33523e0b1ec05d61$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $33523e0b1ec05d61$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $33523e0b1ec05d61$var$runClearTimeout(marker) {
    if ($33523e0b1ec05d61$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($33523e0b1ec05d61$var$cachedClearTimeout === $33523e0b1ec05d61$var$defaultClearTimeout || !$33523e0b1ec05d61$var$cachedClearTimeout) && clearTimeout) {
        $33523e0b1ec05d61$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $33523e0b1ec05d61$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $33523e0b1ec05d61$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $33523e0b1ec05d61$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $33523e0b1ec05d61$var$queue = [];
var $33523e0b1ec05d61$var$draining = false;
var $33523e0b1ec05d61$var$currentQueue;
var $33523e0b1ec05d61$var$queueIndex = -1;
function $33523e0b1ec05d61$var$cleanUpNextTick() {
    if (!$33523e0b1ec05d61$var$draining || !$33523e0b1ec05d61$var$currentQueue) return;
    $33523e0b1ec05d61$var$draining = false;
    if ($33523e0b1ec05d61$var$currentQueue.length) $33523e0b1ec05d61$var$queue = $33523e0b1ec05d61$var$currentQueue.concat($33523e0b1ec05d61$var$queue);
    else $33523e0b1ec05d61$var$queueIndex = -1;
    if ($33523e0b1ec05d61$var$queue.length) $33523e0b1ec05d61$var$drainQueue();
}
function $33523e0b1ec05d61$var$drainQueue() {
    if ($33523e0b1ec05d61$var$draining) return;
    var timeout = $33523e0b1ec05d61$var$runTimeout($33523e0b1ec05d61$var$cleanUpNextTick);
    $33523e0b1ec05d61$var$draining = true;
    var len = $33523e0b1ec05d61$var$queue.length;
    while(len){
        $33523e0b1ec05d61$var$currentQueue = $33523e0b1ec05d61$var$queue;
        $33523e0b1ec05d61$var$queue = [];
        while(++$33523e0b1ec05d61$var$queueIndex < len)if ($33523e0b1ec05d61$var$currentQueue) $33523e0b1ec05d61$var$currentQueue[$33523e0b1ec05d61$var$queueIndex].run();
        $33523e0b1ec05d61$var$queueIndex = -1;
        len = $33523e0b1ec05d61$var$queue.length;
    }
    $33523e0b1ec05d61$var$currentQueue = null;
    $33523e0b1ec05d61$var$draining = false;
    $33523e0b1ec05d61$var$runClearTimeout(timeout);
}
$33523e0b1ec05d61$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $33523e0b1ec05d61$var$queue.push(new $33523e0b1ec05d61$var$Item(fun, args));
    if ($33523e0b1ec05d61$var$queue.length === 1 && !$33523e0b1ec05d61$var$draining) $33523e0b1ec05d61$var$runTimeout($33523e0b1ec05d61$var$drainQueue);
};
// v8 likes predictible objects
function $33523e0b1ec05d61$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$33523e0b1ec05d61$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$33523e0b1ec05d61$var$process.title = "browser";
$33523e0b1ec05d61$var$process.browser = true;
$33523e0b1ec05d61$var$process.env = {};
$33523e0b1ec05d61$var$process.argv = [];
$33523e0b1ec05d61$var$process.version = ""; // empty string to avoid regexp issues
$33523e0b1ec05d61$var$process.versions = {};
function $33523e0b1ec05d61$var$noop() {}
$33523e0b1ec05d61$var$process.on = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.addListener = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.once = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.off = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.removeListener = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.removeAllListeners = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.emit = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.prependListener = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.prependOnceListener = $33523e0b1ec05d61$var$noop;
$33523e0b1ec05d61$var$process.listeners = function(name) {
    return [];
};
$33523e0b1ec05d61$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$33523e0b1ec05d61$var$process.cwd = function() {
    return "/";
};
$33523e0b1ec05d61$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$33523e0b1ec05d61$var$process.umask = function() {
    return 0;
};

});

parcelRegister("ilnag", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d5ac2822aafd9462$export$a143d493d941bafc; }, function (v) { return $d5ac2822aafd9462$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d5ac2822aafd9462$export$e4cf37d7f6fb9e0a; }, function (v) { return $d5ac2822aafd9462$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d5ac2822aafd9462$export$f99ded8fe4b79145; }, function (v) { return $d5ac2822aafd9462$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d5ac2822aafd9462$export$599f31c3813fae4d; }, function (v) { return $d5ac2822aafd9462$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $aVMuR = parcelRequire("aVMuR");

var $hKD8n = parcelRequire("hKD8n");
var $d5ac2822aafd9462$export$a143d493d941bafc;
var $d5ac2822aafd9462$export$e4cf37d7f6fb9e0a;
var $d5ac2822aafd9462$export$f99ded8fe4b79145;
var $d5ac2822aafd9462$export$599f31c3813fae4d;
"use strict";

var $6l1Gi = parcelRequire("6l1Gi");

var $eaIYP = parcelRequire("eaIYP");
var $d5ac2822aafd9462$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d5ac2822aafd9462$export$a143d493d941bafc = $d5ac2822aafd9462$var$Buffer;
$d5ac2822aafd9462$export$e4cf37d7f6fb9e0a = $d5ac2822aafd9462$var$SlowBuffer;
$d5ac2822aafd9462$export$f99ded8fe4b79145 = 50;
var $d5ac2822aafd9462$var$K_MAX_LENGTH = 0x7fffffff;
$d5ac2822aafd9462$export$599f31c3813fae4d = $d5ac2822aafd9462$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d5ac2822aafd9462$var$Buffer.TYPED_ARRAY_SUPPORT = $d5ac2822aafd9462$var$typedArraySupport();
if (!$d5ac2822aafd9462$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d5ac2822aafd9462$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d5ac2822aafd9462$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$d5ac2822aafd9462$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d5ac2822aafd9462$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$d5ac2822aafd9462$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d5ac2822aafd9462$var$createBuffer(length) {
    if (length > $d5ac2822aafd9462$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d5ac2822aafd9462$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d5ac2822aafd9462$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d5ac2822aafd9462$var$allocUnsafe(arg);
    }
    return $d5ac2822aafd9462$var$from(arg, encodingOrOffset, length);
}
$d5ac2822aafd9462$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d5ac2822aafd9462$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d5ac2822aafd9462$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d5ac2822aafd9462$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
    if ($d5ac2822aafd9462$var$isInstance(value, ArrayBuffer) || value && $d5ac2822aafd9462$var$isInstance(value.buffer, ArrayBuffer)) return $d5ac2822aafd9462$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d5ac2822aafd9462$var$isInstance(value, SharedArrayBuffer) || value && $d5ac2822aafd9462$var$isInstance(value.buffer, SharedArrayBuffer))) return $d5ac2822aafd9462$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d5ac2822aafd9462$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d5ac2822aafd9462$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d5ac2822aafd9462$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d5ac2822aafd9462$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d5ac2822aafd9462$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d5ac2822aafd9462$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d5ac2822aafd9462$var$Buffer, Uint8Array);
function $d5ac2822aafd9462$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d5ac2822aafd9462$var$alloc(size, fill, encoding) {
    $d5ac2822aafd9462$var$assertSize(size);
    if (size <= 0) return $d5ac2822aafd9462$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d5ac2822aafd9462$var$createBuffer(size).fill(fill, encoding) : $d5ac2822aafd9462$var$createBuffer(size).fill(fill);
    return $d5ac2822aafd9462$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d5ac2822aafd9462$var$Buffer.alloc = function(size, fill, encoding) {
    return $d5ac2822aafd9462$var$alloc(size, fill, encoding);
};
function $d5ac2822aafd9462$var$allocUnsafe(size) {
    $d5ac2822aafd9462$var$assertSize(size);
    return $d5ac2822aafd9462$var$createBuffer(size < 0 ? 0 : $d5ac2822aafd9462$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d5ac2822aafd9462$var$Buffer.allocUnsafe = function(size) {
    return $d5ac2822aafd9462$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d5ac2822aafd9462$var$Buffer.allocUnsafeSlow = function(size) {
    return $d5ac2822aafd9462$var$allocUnsafe(size);
};
function $d5ac2822aafd9462$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d5ac2822aafd9462$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d5ac2822aafd9462$var$byteLength(string, encoding) | 0;
    var buf = $d5ac2822aafd9462$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d5ac2822aafd9462$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d5ac2822aafd9462$var$checked(array.length) | 0;
    var buf = $d5ac2822aafd9462$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d5ac2822aafd9462$var$fromArrayView(arrayView) {
    if ($d5ac2822aafd9462$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d5ac2822aafd9462$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d5ac2822aafd9462$var$fromArrayLike(arrayView);
}
function $d5ac2822aafd9462$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d5ac2822aafd9462$var$Buffer.prototype);
    return buf;
}
function $d5ac2822aafd9462$var$fromObject(obj) {
    if ($d5ac2822aafd9462$var$Buffer.isBuffer(obj)) {
        var len = $d5ac2822aafd9462$var$checked(obj.length) | 0;
        var buf = $d5ac2822aafd9462$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d5ac2822aafd9462$var$numberIsNaN(obj.length)) return $d5ac2822aafd9462$var$createBuffer(0);
        return $d5ac2822aafd9462$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d5ac2822aafd9462$var$fromArrayLike(obj.data);
}
function $d5ac2822aafd9462$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d5ac2822aafd9462$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d5ac2822aafd9462$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d5ac2822aafd9462$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d5ac2822aafd9462$var$Buffer.alloc(+length);
}
$d5ac2822aafd9462$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d5ac2822aafd9462$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d5ac2822aafd9462$var$Buffer.compare = function compare(a, b) {
    if ($d5ac2822aafd9462$var$isInstance(a, Uint8Array)) a = $d5ac2822aafd9462$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d5ac2822aafd9462$var$isInstance(b, Uint8Array)) b = $d5ac2822aafd9462$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d5ac2822aafd9462$var$Buffer.isBuffer(a) || !$d5ac2822aafd9462$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d5ac2822aafd9462$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d5ac2822aafd9462$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d5ac2822aafd9462$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d5ac2822aafd9462$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d5ac2822aafd9462$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d5ac2822aafd9462$var$Buffer.isBuffer(buf)) buf = $d5ac2822aafd9462$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d5ac2822aafd9462$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d5ac2822aafd9462$var$byteLength(string, encoding) {
    if ($d5ac2822aafd9462$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d5ac2822aafd9462$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $aVMuR._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d5ac2822aafd9462$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d5ac2822aafd9462$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d5ac2822aafd9462$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d5ac2822aafd9462$var$Buffer.byteLength = $d5ac2822aafd9462$var$byteLength;
function $d5ac2822aafd9462$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d5ac2822aafd9462$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d5ac2822aafd9462$var$utf8Slice(this, start, end);
        case "ascii":
            return $d5ac2822aafd9462$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d5ac2822aafd9462$var$latin1Slice(this, start, end);
        case "base64":
            return $d5ac2822aafd9462$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d5ac2822aafd9462$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d5ac2822aafd9462$var$Buffer.prototype._isBuffer = true;
function $d5ac2822aafd9462$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d5ac2822aafd9462$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d5ac2822aafd9462$var$swap(this, i, i + 1);
    return this;
};
$d5ac2822aafd9462$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d5ac2822aafd9462$var$swap(this, i, i + 3);
        $d5ac2822aafd9462$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d5ac2822aafd9462$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d5ac2822aafd9462$var$swap(this, i, i + 7);
        $d5ac2822aafd9462$var$swap(this, i + 1, i + 6);
        $d5ac2822aafd9462$var$swap(this, i + 2, i + 5);
        $d5ac2822aafd9462$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d5ac2822aafd9462$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d5ac2822aafd9462$var$utf8Slice(this, 0, length);
    return $d5ac2822aafd9462$var$slowToString.apply(this, arguments);
};
$d5ac2822aafd9462$var$Buffer.prototype.toLocaleString = $d5ac2822aafd9462$var$Buffer.prototype.toString;
$d5ac2822aafd9462$var$Buffer.prototype.equals = function equals(b) {
    if (!$d5ac2822aafd9462$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d5ac2822aafd9462$var$Buffer.compare(this, b) === 0;
};
$d5ac2822aafd9462$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d5ac2822aafd9462$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d5ac2822aafd9462$var$customInspectSymbol) $d5ac2822aafd9462$var$Buffer.prototype[$d5ac2822aafd9462$var$customInspectSymbol] = $d5ac2822aafd9462$var$Buffer.prototype.inspect;
$d5ac2822aafd9462$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d5ac2822aafd9462$var$isInstance(target, Uint8Array)) target = $d5ac2822aafd9462$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d5ac2822aafd9462$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $aVMuR._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d5ac2822aafd9462$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d5ac2822aafd9462$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d5ac2822aafd9462$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d5ac2822aafd9462$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d5ac2822aafd9462$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d5ac2822aafd9462$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d5ac2822aafd9462$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d5ac2822aafd9462$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d5ac2822aafd9462$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d5ac2822aafd9462$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d5ac2822aafd9462$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d5ac2822aafd9462$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d5ac2822aafd9462$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d5ac2822aafd9462$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d5ac2822aafd9462$var$utf8Write(buf, string, offset, length) {
    return $d5ac2822aafd9462$var$blitBuffer($d5ac2822aafd9462$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d5ac2822aafd9462$var$asciiWrite(buf, string, offset, length) {
    return $d5ac2822aafd9462$var$blitBuffer($d5ac2822aafd9462$var$asciiToBytes(string), buf, offset, length);
}
function $d5ac2822aafd9462$var$base64Write(buf, string, offset, length) {
    return $d5ac2822aafd9462$var$blitBuffer($d5ac2822aafd9462$var$base64ToBytes(string), buf, offset, length);
}
function $d5ac2822aafd9462$var$ucs2Write(buf, string, offset, length) {
    return $d5ac2822aafd9462$var$blitBuffer($d5ac2822aafd9462$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d5ac2822aafd9462$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d5ac2822aafd9462$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d5ac2822aafd9462$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d5ac2822aafd9462$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d5ac2822aafd9462$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d5ac2822aafd9462$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d5ac2822aafd9462$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d5ac2822aafd9462$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6l1Gi.fromByteArray(buf);
    else return $6l1Gi.fromByteArray(buf.slice(start, end));
}
function $d5ac2822aafd9462$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d5ac2822aafd9462$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d5ac2822aafd9462$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d5ac2822aafd9462$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d5ac2822aafd9462$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d5ac2822aafd9462$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d5ac2822aafd9462$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d5ac2822aafd9462$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d5ac2822aafd9462$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d5ac2822aafd9462$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d5ac2822aafd9462$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d5ac2822aafd9462$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d5ac2822aafd9462$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d5ac2822aafd9462$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d5ac2822aafd9462$var$Buffer.prototype.readUintLE = $d5ac2822aafd9462$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d5ac2822aafd9462$var$Buffer.prototype.readUintBE = $d5ac2822aafd9462$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d5ac2822aafd9462$var$Buffer.prototype.readUint8 = $d5ac2822aafd9462$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d5ac2822aafd9462$var$Buffer.prototype.readUint16LE = $d5ac2822aafd9462$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d5ac2822aafd9462$var$Buffer.prototype.readUint16BE = $d5ac2822aafd9462$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d5ac2822aafd9462$var$Buffer.prototype.readUint32LE = $d5ac2822aafd9462$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d5ac2822aafd9462$var$Buffer.prototype.readUint32BE = $d5ac2822aafd9462$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d5ac2822aafd9462$var$Buffer.prototype.readBigUInt64LE = $d5ac2822aafd9462$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d5ac2822aafd9462$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d5ac2822aafd9462$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d5ac2822aafd9462$var$Buffer.prototype.readBigUInt64BE = $d5ac2822aafd9462$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d5ac2822aafd9462$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d5ac2822aafd9462$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d5ac2822aafd9462$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d5ac2822aafd9462$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d5ac2822aafd9462$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d5ac2822aafd9462$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d5ac2822aafd9462$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d5ac2822aafd9462$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d5ac2822aafd9462$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d5ac2822aafd9462$var$Buffer.prototype.readBigInt64LE = $d5ac2822aafd9462$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d5ac2822aafd9462$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d5ac2822aafd9462$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$d5ac2822aafd9462$var$Buffer.prototype.readBigInt64BE = $d5ac2822aafd9462$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d5ac2822aafd9462$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $d5ac2822aafd9462$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$d5ac2822aafd9462$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 4, this.length);
    return $eaIYP.read(this, offset, true, 23, 4);
};
$d5ac2822aafd9462$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 4, this.length);
    return $eaIYP.read(this, offset, false, 23, 4);
};
$d5ac2822aafd9462$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 8, this.length);
    return $eaIYP.read(this, offset, true, 52, 8);
};
$d5ac2822aafd9462$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkOffset(offset, 8, this.length);
    return $eaIYP.read(this, offset, false, 52, 8);
};
function $d5ac2822aafd9462$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d5ac2822aafd9462$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d5ac2822aafd9462$var$Buffer.prototype.writeUintLE = $d5ac2822aafd9462$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d5ac2822aafd9462$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeUintBE = $d5ac2822aafd9462$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d5ac2822aafd9462$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeUint8 = $d5ac2822aafd9462$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeUint16LE = $d5ac2822aafd9462$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeUint16BE = $d5ac2822aafd9462$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeUint32LE = $d5ac2822aafd9462$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeUint32BE = $d5ac2822aafd9462$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d5ac2822aafd9462$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d5ac2822aafd9462$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d5ac2822aafd9462$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d5ac2822aafd9462$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d5ac2822aafd9462$var$Buffer.prototype.writeBigUInt64LE = $d5ac2822aafd9462$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d5ac2822aafd9462$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d5ac2822aafd9462$var$Buffer.prototype.writeBigUInt64BE = $d5ac2822aafd9462$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d5ac2822aafd9462$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d5ac2822aafd9462$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d5ac2822aafd9462$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d5ac2822aafd9462$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d5ac2822aafd9462$var$Buffer.prototype.writeBigInt64LE = $d5ac2822aafd9462$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d5ac2822aafd9462$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$d5ac2822aafd9462$var$Buffer.prototype.writeBigInt64BE = $d5ac2822aafd9462$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $d5ac2822aafd9462$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $d5ac2822aafd9462$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d5ac2822aafd9462$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eaIYP.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d5ac2822aafd9462$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d5ac2822aafd9462$var$writeFloat(this, value, offset, true, noAssert);
};
$d5ac2822aafd9462$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d5ac2822aafd9462$var$writeFloat(this, value, offset, false, noAssert);
};
function $d5ac2822aafd9462$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d5ac2822aafd9462$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eaIYP.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d5ac2822aafd9462$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d5ac2822aafd9462$var$writeDouble(this, value, offset, true, noAssert);
};
$d5ac2822aafd9462$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d5ac2822aafd9462$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d5ac2822aafd9462$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d5ac2822aafd9462$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d5ac2822aafd9462$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d5ac2822aafd9462$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d5ac2822aafd9462$var$Buffer.isBuffer(val) ? val : $d5ac2822aafd9462$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $d5ac2822aafd9462$var$errors = {};
function $d5ac2822aafd9462$var$E(sym, getMessage, Base) {
    $d5ac2822aafd9462$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $cgJ2Y._)(NodeError, Base);
        var _super = (0, $hKD8n._)(NodeError);
        function NodeError() {
            (0, $7dKN1._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $b9zO9._)(_this), "message", {
                value: getMessage.apply((0, $b9zO9._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $eW5pA._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$d5ac2822aafd9462$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$d5ac2822aafd9462$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $aVMuR._)(actual));
}, TypeError);
$d5ac2822aafd9462$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $d5ac2822aafd9462$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $aVMuR._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $d5ac2822aafd9462$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $d5ac2822aafd9462$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $d5ac2822aafd9462$var$checkBounds(buf, offset, byteLength) {
    $d5ac2822aafd9462$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d5ac2822aafd9462$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d5ac2822aafd9462$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $aVMuR._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $d5ac2822aafd9462$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $d5ac2822aafd9462$var$checkBounds(buf, offset, byteLength);
}
function $d5ac2822aafd9462$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $d5ac2822aafd9462$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $d5ac2822aafd9462$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d5ac2822aafd9462$var$validateNumber(value, type);
        throw new $d5ac2822aafd9462$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $d5ac2822aafd9462$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d5ac2822aafd9462$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $d5ac2822aafd9462$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d5ac2822aafd9462$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d5ac2822aafd9462$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d5ac2822aafd9462$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d5ac2822aafd9462$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d5ac2822aafd9462$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d5ac2822aafd9462$var$base64ToBytes(str) {
    return $6l1Gi.toByteArray($d5ac2822aafd9462$var$base64clean(str));
}
function $d5ac2822aafd9462$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d5ac2822aafd9462$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d5ac2822aafd9462$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d5ac2822aafd9462$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d5ac2822aafd9462$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $d5ac2822aafd9462$var$BufferBigIntNotDefined : fn;
}
function $d5ac2822aafd9462$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("b9zO9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $81ec4fa96918e039$export$71511d61b312f219; });
function $81ec4fa96918e039$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("7dKN1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $541e0ac4fd1ad145$export$71511d61b312f219; });
function $541e0ac4fd1ad145$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eW5pA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $adfaae18e44dcd31$export$71511d61b312f219; });
function $adfaae18e44dcd31$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $adfaae18e44dcd31$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $adfaae18e44dcd31$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $adfaae18e44dcd31$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("cgJ2Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ee9ec05f932b728$export$71511d61b312f219; });

var $lJlHo = parcelRequire("lJlHo");
function $8ee9ec05f932b728$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $lJlHo._)(subClass, superClass);
}

});
parcelRegister("lJlHo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fd1ea1e0cf7fbc50$export$71511d61b312f219; });
function $fd1ea1e0cf7fbc50$export$71511d61b312f219(o, p) {
    $fd1ea1e0cf7fbc50$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fd1ea1e0cf7fbc50$export$71511d61b312f219(o, p);
}

});


parcelRegister("aVMuR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7f54d8ad3d20599d$export$71511d61b312f219; });
function $7f54d8ad3d20599d$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("hKD8n", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cec516c5cb7ae08f$export$71511d61b312f219; });

var $fG73q = parcelRequire("fG73q");

var $ecvIT = parcelRequire("ecvIT");

var $7ZqEM = parcelRequire("7ZqEM");
function $cec516c5cb7ae08f$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $ecvIT._)();
    return function _createSuperInternal() {
        var Super = (0, $fG73q._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $fG73q._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $7ZqEM._)(this, result);
    };
}

});
parcelRegister("fG73q", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6a040186e7cb765$export$71511d61b312f219; });
function $b6a040186e7cb765$export$71511d61b312f219(o) {
    $b6a040186e7cb765$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b6a040186e7cb765$export$71511d61b312f219(o);
}

});

parcelRegister("ecvIT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a56acb3b40d21e3d$export$71511d61b312f219; });
function $a56acb3b40d21e3d$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("7ZqEM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5d12e85b984811de$export$71511d61b312f219; });

var $b9zO9 = parcelRequire("b9zO9");

var $aVMuR = parcelRequire("aVMuR");
function $5d12e85b984811de$export$71511d61b312f219(self, call) {
    if (call && ((0, $aVMuR._)(call) === "object" || typeof call === "function")) return call;
    return (0, $b9zO9._)(self);
}

});


parcelRegister("eaIYP", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $a514e3f919594ebb$export$aafa59e2e03f2942; }, function (v) { return $a514e3f919594ebb$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $a514e3f919594ebb$export$68d8715fc104d294; }, function (v) { return $a514e3f919594ebb$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a514e3f919594ebb$export$aafa59e2e03f2942;
var $a514e3f919594ebb$export$68d8715fc104d294;
$a514e3f919594ebb$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a514e3f919594ebb$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("24TKi", function(module, exports) {
"use strict";

});

parcelRegister("5xFHp", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $40906166c99f8bb3$export$5f828d93ff035aa8; }, function (v) { return $40906166c99f8bb3$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $40906166c99f8bb3$export$cd94982b18c6332c; }, function (v) { return $40906166c99f8bb3$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $40906166c99f8bb3$export$1d518568e4f529b0; }, function (v) { return $40906166c99f8bb3$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $40906166c99f8bb3$export$5285b6d41c912b41; }, function (v) { return $40906166c99f8bb3$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $40906166c99f8bb3$export$2fb37efbf6ae0c0e; }, function (v) { return $40906166c99f8bb3$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $40906166c99f8bb3$export$ab85ecd77ce6a5cd; }, function (v) { return $40906166c99f8bb3$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $40906166c99f8bb3$export$da39cf97e1eb7c91; }, function (v) { return $40906166c99f8bb3$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $40906166c99f8bb3$export$52a9039d7177394f; }, function (v) { return $40906166c99f8bb3$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $40906166c99f8bb3$export$f7201db400317331; }, function (v) { return $40906166c99f8bb3$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $40906166c99f8bb3$export$448fa22aedc9dbca; }, function (v) { return $40906166c99f8bb3$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $40906166c99f8bb3$export$b80c7ba289c8fa56; }, function (v) { return $40906166c99f8bb3$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $40906166c99f8bb3$export$26e5786e8ac8e530; }, function (v) { return $40906166c99f8bb3$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $40906166c99f8bb3$export$bdd223f16383713e; }, function (v) { return $40906166c99f8bb3$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $40906166c99f8bb3$export$20533d26f07f1ee0; }, function (v) { return $40906166c99f8bb3$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $40906166c99f8bb3$export$2f64596b8cbf08b4; }, function (v) { return $40906166c99f8bb3$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $40906166c99f8bb3$export$2ce6d8d0e8b04e1a; }, function (v) { return $40906166c99f8bb3$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $40906166c99f8bb3$export$12ada9414fbc594c; }, function (v) { return $40906166c99f8bb3$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $40906166c99f8bb3$export$f5e7e39d57cd9700; }, function (v) { return $40906166c99f8bb3$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $40906166c99f8bb3$export$36b6d6ef312eab39; }, function (v) { return $40906166c99f8bb3$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $40906166c99f8bb3$export$58a258485f1e49f6; }, function (v) { return $40906166c99f8bb3$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $40906166c99f8bb3$export$dedd8dc3dc62b370; }, function (v) { return $40906166c99f8bb3$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $40906166c99f8bb3$export$971862a2fcb1bb40; }, function (v) { return $40906166c99f8bb3$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $40906166c99f8bb3$export$c6ff6a88acbeaf40; }, function (v) { return $40906166c99f8bb3$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $40906166c99f8bb3$export$fdc27893e98845cc; }, function (v) { return $40906166c99f8bb3$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $40906166c99f8bb3$export$6671fb9a1323bed; }, function (v) { return $40906166c99f8bb3$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $40906166c99f8bb3$export$d74daf141a551db; }, function (v) { return $40906166c99f8bb3$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $40906166c99f8bb3$export$45df7cae684751af; }, function (v) { return $40906166c99f8bb3$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $40906166c99f8bb3$export$1db683ad541682f6; }, function (v) { return $40906166c99f8bb3$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $40906166c99f8bb3$export$6f65485f87568e37; }, function (v) { return $40906166c99f8bb3$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $40906166c99f8bb3$export$91a8e56769aeb334; }, function (v) { return $40906166c99f8bb3$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $40906166c99f8bb3$export$2d4117e99c2179e4; }, function (v) { return $40906166c99f8bb3$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $40906166c99f8bb3$export$512823e338ddb1b7; }, function (v) { return $40906166c99f8bb3$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $40906166c99f8bb3$export$9d0e0c0c4a8d30f3; }, function (v) { return $40906166c99f8bb3$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $40906166c99f8bb3$export$b9d55ff329113abd; }, function (v) { return $40906166c99f8bb3$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $40906166c99f8bb3$export$7efb24e2fddf99b9; }, function (v) { return $40906166c99f8bb3$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $40906166c99f8bb3$export$bb1abf2ce84fc7e8; }, function (v) { return $40906166c99f8bb3$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $40906166c99f8bb3$export$2f7171e78e524d5e; }, function (v) { return $40906166c99f8bb3$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $40906166c99f8bb3$export$e1d879b482f37d98; }, function (v) { return $40906166c99f8bb3$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $40906166c99f8bb3$export$1a988e7317c65621; }, function (v) { return $40906166c99f8bb3$export$1a988e7317c65621 = v; });
var $40906166c99f8bb3$export$5f828d93ff035aa8;
var $40906166c99f8bb3$export$cd94982b18c6332c;
var $40906166c99f8bb3$export$1d518568e4f529b0;
var $40906166c99f8bb3$export$5285b6d41c912b41;
var $40906166c99f8bb3$export$2fb37efbf6ae0c0e;
var $40906166c99f8bb3$export$ab85ecd77ce6a5cd;
var $40906166c99f8bb3$export$da39cf97e1eb7c91;
var $40906166c99f8bb3$export$52a9039d7177394f;
var $40906166c99f8bb3$export$f7201db400317331;
var $40906166c99f8bb3$export$448fa22aedc9dbca;
var $40906166c99f8bb3$export$b80c7ba289c8fa56;
var $40906166c99f8bb3$export$26e5786e8ac8e530;
var $40906166c99f8bb3$export$bdd223f16383713e;
var $40906166c99f8bb3$export$20533d26f07f1ee0;
var $40906166c99f8bb3$export$2f64596b8cbf08b4;
var $40906166c99f8bb3$export$2ce6d8d0e8b04e1a;
var $40906166c99f8bb3$export$12ada9414fbc594c;
var $40906166c99f8bb3$export$f5e7e39d57cd9700;
var $40906166c99f8bb3$export$36b6d6ef312eab39;
var $40906166c99f8bb3$export$58a258485f1e49f6;
var $40906166c99f8bb3$export$dedd8dc3dc62b370;
var $40906166c99f8bb3$export$971862a2fcb1bb40;
var $40906166c99f8bb3$export$c6ff6a88acbeaf40;
var $40906166c99f8bb3$export$fdc27893e98845cc;
var $40906166c99f8bb3$export$6671fb9a1323bed;
var $40906166c99f8bb3$export$d74daf141a551db;
var $40906166c99f8bb3$export$45df7cae684751af;
var $40906166c99f8bb3$export$1db683ad541682f6;
var $40906166c99f8bb3$export$6f65485f87568e37;
var $40906166c99f8bb3$export$91a8e56769aeb334;
var $40906166c99f8bb3$export$2d4117e99c2179e4;
var $40906166c99f8bb3$export$512823e338ddb1b7;
var $40906166c99f8bb3$export$9d0e0c0c4a8d30f3;
var $40906166c99f8bb3$export$b9d55ff329113abd;
var $40906166c99f8bb3$export$7efb24e2fddf99b9;
var $40906166c99f8bb3$export$bb1abf2ce84fc7e8;
var $40906166c99f8bb3$export$2f7171e78e524d5e;
var $40906166c99f8bb3$export$e1d879b482f37d98;
var $40906166c99f8bb3$export$1a988e7317c65621;
"use strict";

$40906166c99f8bb3$export$5f828d93ff035aa8 = $40906166c99f8bb3$export$cd94982b18c6332c = $40906166c99f8bb3$export$1d518568e4f529b0 = $40906166c99f8bb3$export$5285b6d41c912b41 = (parcelRequire("2gcE5"));

$40906166c99f8bb3$export$2fb37efbf6ae0c0e = $40906166c99f8bb3$export$ab85ecd77ce6a5cd = (parcelRequire("jMOyI"));

$40906166c99f8bb3$export$da39cf97e1eb7c91 = $40906166c99f8bb3$export$52a9039d7177394f = (parcelRequire("c9AEc"));

var $hV0TQ = parcelRequire("hV0TQ");
var $40906166c99f8bb3$var$algoKeys = Object.keys($hV0TQ);
var $40906166c99f8bb3$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($40906166c99f8bb3$var$algoKeys);
$40906166c99f8bb3$export$f7201db400317331 = function() {
    return $40906166c99f8bb3$var$hashes;
};

var $aO3KN = parcelRequire("aO3KN");
$40906166c99f8bb3$export$448fa22aedc9dbca = $aO3KN.pbkdf2;
$40906166c99f8bb3$export$b80c7ba289c8fa56 = $aO3KN.pbkdf2Sync;

var $jErwR = parcelRequire("jErwR");
$40906166c99f8bb3$export$26e5786e8ac8e530 = $jErwR.Cipher;
$40906166c99f8bb3$export$bdd223f16383713e = $jErwR.createCipher;
$40906166c99f8bb3$export$20533d26f07f1ee0 = $jErwR.Cipheriv;
$40906166c99f8bb3$export$2f64596b8cbf08b4 = $jErwR.createCipheriv;
$40906166c99f8bb3$export$2ce6d8d0e8b04e1a = $jErwR.Decipher;
$40906166c99f8bb3$export$12ada9414fbc594c = $jErwR.createDecipher;
$40906166c99f8bb3$export$f5e7e39d57cd9700 = $jErwR.Decipheriv;
$40906166c99f8bb3$export$36b6d6ef312eab39 = $jErwR.createDecipheriv;
$40906166c99f8bb3$export$58a258485f1e49f6 = $jErwR.getCiphers;
$40906166c99f8bb3$export$dedd8dc3dc62b370 = $jErwR.listCiphers;

var $ey6om = parcelRequire("ey6om");
$40906166c99f8bb3$export$971862a2fcb1bb40 = $ey6om.DiffieHellmanGroup;
$40906166c99f8bb3$export$c6ff6a88acbeaf40 = $ey6om.createDiffieHellmanGroup;
$40906166c99f8bb3$export$fdc27893e98845cc = $ey6om.getDiffieHellman;
$40906166c99f8bb3$export$6671fb9a1323bed = $ey6om.createDiffieHellman;
$40906166c99f8bb3$export$d74daf141a551db = $ey6om.DiffieHellman;

var $5HF5h = parcelRequire("5HF5h");
$40906166c99f8bb3$export$45df7cae684751af = $5HF5h.createSign;
$40906166c99f8bb3$export$1db683ad541682f6 = $5HF5h.Sign;
$40906166c99f8bb3$export$6f65485f87568e37 = $5HF5h.createVerify;
$40906166c99f8bb3$export$91a8e56769aeb334 = $5HF5h.Verify;

$40906166c99f8bb3$export$2d4117e99c2179e4 = (parcelRequire("5UR9D"));

var $3Xg05 = parcelRequire("3Xg05");
$40906166c99f8bb3$export$512823e338ddb1b7 = $3Xg05.publicEncrypt;
$40906166c99f8bb3$export$9d0e0c0c4a8d30f3 = $3Xg05.privateEncrypt;
$40906166c99f8bb3$export$b9d55ff329113abd = $3Xg05.publicDecrypt;
$40906166c99f8bb3$export$7efb24e2fddf99b9 = $3Xg05.privateDecrypt;

var $bsRb8 = parcelRequire("bsRb8");
$40906166c99f8bb3$export$bb1abf2ce84fc7e8 = $bsRb8.randomFill;
$40906166c99f8bb3$export$2f7171e78e524d5e = $bsRb8.randomFillSync;
$40906166c99f8bb3$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$40906166c99f8bb3$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("2gcE5", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $1a56e28f52af264f$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $1a56e28f52af264f$var$MAX_UINT32 = 4294967295;
function $1a56e28f52af264f$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $b1nU2 = parcelRequire("b1nU2");
var $1a56e28f52af264f$require$Buffer = $b1nU2.Buffer;
var $1a56e28f52af264f$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($1a56e28f52af264f$var$crypto && $1a56e28f52af264f$var$crypto.getRandomValues) module.exports = $1a56e28f52af264f$var$randomBytes;
else module.exports = $1a56e28f52af264f$var$oldBrowser;
function $1a56e28f52af264f$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $1a56e28f52af264f$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $1a56e28f52af264f$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $1a56e28f52af264f$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $1a56e28f52af264f$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $1a56e28f52af264f$var$crypto.getRandomValues(bytes.slice(generated, generated + $1a56e28f52af264f$var$MAX_BYTES));
        else $1a56e28f52af264f$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $4pbh3.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("b1nU2", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ilnag = parcelRequire("ilnag");
var $8062544d967d2168$var$Buffer = $ilnag.Buffer;
// alternative to using Object.keys for old browsers
function $8062544d967d2168$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($8062544d967d2168$var$Buffer.from && $8062544d967d2168$var$Buffer.alloc && $8062544d967d2168$var$Buffer.allocUnsafe && $8062544d967d2168$var$Buffer.allocUnsafeSlow) module.exports = $ilnag;
else {
    // Copy properties from require('buffer')
    $8062544d967d2168$var$copyProps($ilnag, module.exports);
    module.exports.Buffer = $8062544d967d2168$var$SafeBuffer;
}
function $8062544d967d2168$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $8062544d967d2168$var$Buffer(arg, encodingOrOffset, length);
}
$8062544d967d2168$var$SafeBuffer.prototype = Object.create($8062544d967d2168$var$Buffer.prototype);
// Copy static methods from Buffer
$8062544d967d2168$var$copyProps($8062544d967d2168$var$Buffer, $8062544d967d2168$var$SafeBuffer);
$8062544d967d2168$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $8062544d967d2168$var$Buffer(arg, encodingOrOffset, length);
};
$8062544d967d2168$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $8062544d967d2168$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$8062544d967d2168$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $8062544d967d2168$var$Buffer(size);
};
$8062544d967d2168$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ilnag.SlowBuffer(size);
};

});


parcelRegister("jMOyI", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $1GvVx = parcelRequire("1GvVx");

var $aEC5U = parcelRequire("aEC5U");

var $fXOt1 = parcelRequire("fXOt1");

var $2dJLz = parcelRequire("2dJLz");
function $e679b7f78c13fa7c$var$Hash(hash) {
    $2dJLz.call(this, "digest");
    this._hash = hash;
}
$5PBAa($e679b7f78c13fa7c$var$Hash, $2dJLz);
$e679b7f78c13fa7c$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$e679b7f78c13fa7c$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $1GvVx();
    if (alg === "rmd160" || alg === "ripemd160") return new $aEC5U();
    return new $e679b7f78c13fa7c$var$Hash($fXOt1(alg));
};

});
parcelRegister("5PBAa", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("1GvVx", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $1je01 = parcelRequire("1je01");

var $b1nU2 = parcelRequire("b1nU2");
var $13a27aba8e891a84$require$Buffer = $b1nU2.Buffer;
var $13a27aba8e891a84$var$ARRAY16 = new Array(16);
function $13a27aba8e891a84$var$MD5() {
    $1je01.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$5PBAa($13a27aba8e891a84$var$MD5, $1je01);
$13a27aba8e891a84$var$MD5.prototype._update = function() {
    var M = $13a27aba8e891a84$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $13a27aba8e891a84$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $13a27aba8e891a84$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $13a27aba8e891a84$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $13a27aba8e891a84$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $13a27aba8e891a84$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $13a27aba8e891a84$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $13a27aba8e891a84$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $13a27aba8e891a84$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $13a27aba8e891a84$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $13a27aba8e891a84$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $13a27aba8e891a84$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $13a27aba8e891a84$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $13a27aba8e891a84$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $13a27aba8e891a84$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $13a27aba8e891a84$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $13a27aba8e891a84$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $13a27aba8e891a84$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $13a27aba8e891a84$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $13a27aba8e891a84$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $13a27aba8e891a84$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $13a27aba8e891a84$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $13a27aba8e891a84$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $13a27aba8e891a84$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $13a27aba8e891a84$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $13a27aba8e891a84$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $13a27aba8e891a84$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $13a27aba8e891a84$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $13a27aba8e891a84$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $13a27aba8e891a84$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $13a27aba8e891a84$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $13a27aba8e891a84$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $13a27aba8e891a84$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $13a27aba8e891a84$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $13a27aba8e891a84$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $13a27aba8e891a84$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $13a27aba8e891a84$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $13a27aba8e891a84$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $13a27aba8e891a84$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $13a27aba8e891a84$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $13a27aba8e891a84$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $13a27aba8e891a84$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $13a27aba8e891a84$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $13a27aba8e891a84$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $13a27aba8e891a84$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $13a27aba8e891a84$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $13a27aba8e891a84$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $13a27aba8e891a84$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $13a27aba8e891a84$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $13a27aba8e891a84$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $13a27aba8e891a84$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $13a27aba8e891a84$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $13a27aba8e891a84$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $13a27aba8e891a84$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $13a27aba8e891a84$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $13a27aba8e891a84$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $13a27aba8e891a84$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $13a27aba8e891a84$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $13a27aba8e891a84$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $13a27aba8e891a84$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $13a27aba8e891a84$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $13a27aba8e891a84$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $13a27aba8e891a84$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $13a27aba8e891a84$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $13a27aba8e891a84$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$13a27aba8e891a84$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $13a27aba8e891a84$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $13a27aba8e891a84$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $13a27aba8e891a84$var$fnF(a, b, c, d, m, k, s) {
    return $13a27aba8e891a84$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $13a27aba8e891a84$var$fnG(a, b, c, d, m, k, s) {
    return $13a27aba8e891a84$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $13a27aba8e891a84$var$fnH(a, b, c, d, m, k, s) {
    return $13a27aba8e891a84$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $13a27aba8e891a84$var$fnI(a, b, c, d, m, k, s) {
    return $13a27aba8e891a84$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $13a27aba8e891a84$var$MD5;

});
parcelRegister("1je01", function(module, exports) {
"use strict";

var $b1nU2 = parcelRequire("b1nU2");
var $0f426cc9673119ea$require$Buffer = $b1nU2.Buffer;

var $BxiJM = parcelRequire("BxiJM");
var $0f426cc9673119ea$require$Transform = $BxiJM.Transform;

var $5PBAa = parcelRequire("5PBAa");
function $0f426cc9673119ea$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$0f426cc9673119ea$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $0f426cc9673119ea$var$HashBase(blockSize) {
    $0f426cc9673119ea$require$Transform.call(this);
    this._block = $0f426cc9673119ea$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$5PBAa($0f426cc9673119ea$var$HashBase, $0f426cc9673119ea$require$Transform);
$0f426cc9673119ea$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0f426cc9673119ea$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0f426cc9673119ea$var$HashBase.prototype.update = function(data, encoding) {
    $0f426cc9673119ea$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$0f426cc9673119ea$require$Buffer.isBuffer(data)) data = $0f426cc9673119ea$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$0f426cc9673119ea$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$0f426cc9673119ea$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$0f426cc9673119ea$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $0f426cc9673119ea$var$HashBase;

});
parcelRegister("BxiJM", function(module, exports) {

exports = module.exports = (parcelRequire("9S2GU"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("34aEX"));

exports.Duplex = (parcelRequire("9TH5C"));

exports.Transform = (parcelRequire("i5CAu"));

exports.PassThrough = (parcelRequire("dRgqH"));

exports.finished = (parcelRequire("1s0OU"));

exports.pipeline = (parcelRequire("ieGMb"));

});
parcelRegister("9S2GU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
module.exports = $72fb3e969271b63d$var$Readable;
/*<replacement>*/ var $72fb3e969271b63d$var$Duplex;
/*</replacement>*/ $72fb3e969271b63d$var$Readable.ReadableState = $72fb3e969271b63d$var$ReadableState;

var $3eX0e = parcelRequire("3eX0e");
var $72fb3e969271b63d$require$EE = $3eX0e.EventEmitter;
var $72fb3e969271b63d$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $aSW6y = parcelRequire("aSW6y");

var $ilnag = parcelRequire("ilnag");
var $72fb3e969271b63d$require$Buffer = $ilnag.Buffer;
var $72fb3e969271b63d$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $72fb3e969271b63d$var$_uint8ArrayToBuffer(chunk) {
    return $72fb3e969271b63d$require$Buffer.from(chunk);
}
function $72fb3e969271b63d$var$_isUint8Array(obj) {
    return $72fb3e969271b63d$require$Buffer.isBuffer(obj) || obj instanceof $72fb3e969271b63d$var$OurUint8Array;
}

var $24TKi = parcelRequire("24TKi");
var $72fb3e969271b63d$var$debug;
if ($24TKi && $24TKi.debuglog) $72fb3e969271b63d$var$debug = $24TKi.debuglog("stream");
else $72fb3e969271b63d$var$debug = function debug() {};

var $49uTH = parcelRequire("49uTH");

var $bk9Vg = parcelRequire("bk9Vg");

var $6RY09 = parcelRequire("6RY09");
var $72fb3e969271b63d$var$getHighWaterMark = $6RY09.getHighWaterMark;

var $cQNMR = parcelRequire("cQNMR");
var $72fb3e969271b63d$require$_require$codes = $cQNMR.codes;
var $72fb3e969271b63d$var$ERR_INVALID_ARG_TYPE = $72fb3e969271b63d$require$_require$codes.ERR_INVALID_ARG_TYPE, $72fb3e969271b63d$var$ERR_STREAM_PUSH_AFTER_EOF = $72fb3e969271b63d$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $72fb3e969271b63d$var$ERR_METHOD_NOT_IMPLEMENTED = $72fb3e969271b63d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $72fb3e969271b63d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $72fb3e969271b63d$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $72fb3e969271b63d$var$StringDecoder;
var $72fb3e969271b63d$var$createReadableStreamAsyncIterator;
var $72fb3e969271b63d$var$from;

(parcelRequire("5PBAa"))($72fb3e969271b63d$var$Readable, $aSW6y);
var $72fb3e969271b63d$var$errorOrDestroy = $bk9Vg.errorOrDestroy;
var $72fb3e969271b63d$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $72fb3e969271b63d$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $72fb3e969271b63d$var$ReadableState(options, stream, isDuplex) {
    $72fb3e969271b63d$var$Duplex = $72fb3e969271b63d$var$Duplex || (parcelRequire("9TH5C"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $72fb3e969271b63d$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $72fb3e969271b63d$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $49uTH();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$72fb3e969271b63d$var$StringDecoder) $72fb3e969271b63d$var$StringDecoder = (parcelRequire("ePy3J")).StringDecoder;
        this.decoder = new $72fb3e969271b63d$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $72fb3e969271b63d$var$Readable(options) {
    $72fb3e969271b63d$var$Duplex = $72fb3e969271b63d$var$Duplex || (parcelRequire("9TH5C"));
    if (!(this instanceof $72fb3e969271b63d$var$Readable)) return new $72fb3e969271b63d$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $72fb3e969271b63d$var$Duplex;
    this._readableState = new $72fb3e969271b63d$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $aSW6y.call(this);
}
Object.defineProperty($72fb3e969271b63d$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$72fb3e969271b63d$var$Readable.prototype.destroy = $bk9Vg.destroy;
$72fb3e969271b63d$var$Readable.prototype._undestroy = $bk9Vg.undestroy;
$72fb3e969271b63d$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$72fb3e969271b63d$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $72fb3e969271b63d$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $72fb3e969271b63d$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$72fb3e969271b63d$var$Readable.prototype.unshift = function(chunk) {
    return $72fb3e969271b63d$var$readableAddChunk(this, chunk, null, true, false);
};
function $72fb3e969271b63d$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $72fb3e969271b63d$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $72fb3e969271b63d$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $72fb3e969271b63d$var$chunkInvalid(state, chunk);
        if (er) $72fb3e969271b63d$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $72fb3e969271b63d$require$Buffer.prototype) chunk = $72fb3e969271b63d$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $72fb3e969271b63d$var$errorOrDestroy(stream, new $72fb3e969271b63d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $72fb3e969271b63d$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $72fb3e969271b63d$var$errorOrDestroy(stream, new $72fb3e969271b63d$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $72fb3e969271b63d$var$addChunk(stream, state, chunk, false);
                    else $72fb3e969271b63d$var$maybeReadMore(stream, state);
                } else $72fb3e969271b63d$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $72fb3e969271b63d$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $72fb3e969271b63d$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $72fb3e969271b63d$var$emitReadable(stream);
    }
    $72fb3e969271b63d$var$maybeReadMore(stream, state);
}
function $72fb3e969271b63d$var$chunkInvalid(state, chunk) {
    var er;
    if (!$72fb3e969271b63d$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $72fb3e969271b63d$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$72fb3e969271b63d$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$72fb3e969271b63d$var$Readable.prototype.setEncoding = function(enc) {
    if (!$72fb3e969271b63d$var$StringDecoder) $72fb3e969271b63d$var$StringDecoder = (parcelRequire("ePy3J")).StringDecoder;
    var decoder = new $72fb3e969271b63d$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $72fb3e969271b63d$var$MAX_HWM = 0x40000000;
function $72fb3e969271b63d$var$computeNewHighWaterMark(n) {
    if (n >= $72fb3e969271b63d$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $72fb3e969271b63d$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $72fb3e969271b63d$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $72fb3e969271b63d$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$72fb3e969271b63d$var$Readable.prototype.read = function(n) {
    $72fb3e969271b63d$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $72fb3e969271b63d$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $72fb3e969271b63d$var$endReadable(this);
        else $72fb3e969271b63d$var$emitReadable(this);
        return null;
    }
    n = $72fb3e969271b63d$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $72fb3e969271b63d$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $72fb3e969271b63d$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $72fb3e969271b63d$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $72fb3e969271b63d$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $72fb3e969271b63d$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $72fb3e969271b63d$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $72fb3e969271b63d$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $72fb3e969271b63d$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $72fb3e969271b63d$var$onEofChunk(stream, state) {
    $72fb3e969271b63d$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $72fb3e969271b63d$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $72fb3e969271b63d$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $72fb3e969271b63d$var$emitReadable(stream) {
    var state = stream._readableState;
    $72fb3e969271b63d$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $72fb3e969271b63d$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $4pbh3.nextTick($72fb3e969271b63d$var$emitReadable_, stream);
    }
}
function $72fb3e969271b63d$var$emitReadable_(stream) {
    var state = stream._readableState;
    $72fb3e969271b63d$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $72fb3e969271b63d$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $72fb3e969271b63d$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4pbh3.nextTick($72fb3e969271b63d$var$maybeReadMore_, stream, state);
    }
}
function $72fb3e969271b63d$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $72fb3e969271b63d$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$72fb3e969271b63d$var$Readable.prototype._read = function(n) {
    $72fb3e969271b63d$var$errorOrDestroy(this, new $72fb3e969271b63d$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$72fb3e969271b63d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $72fb3e969271b63d$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4pbh3.stdout && dest !== $4pbh3.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4pbh3.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $72fb3e969271b63d$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $72fb3e969271b63d$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $72fb3e969271b63d$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $72fb3e969271b63d$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $72fb3e969271b63d$var$debug("ondata");
        var ret = dest.write(chunk);
        $72fb3e969271b63d$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $72fb3e969271b63d$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $72fb3e969271b63d$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $72fb3e969271b63d$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($72fb3e969271b63d$var$EElistenerCount(dest, "error") === 0) $72fb3e969271b63d$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $72fb3e969271b63d$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $72fb3e969271b63d$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $72fb3e969271b63d$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $72fb3e969271b63d$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $72fb3e969271b63d$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $72fb3e969271b63d$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $72fb3e969271b63d$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $72fb3e969271b63d$var$flow(src);
        }
    };
}
$72fb3e969271b63d$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $72fb3e969271b63d$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$72fb3e969271b63d$var$Readable.prototype.on = function(ev, fn) {
    var res = $aSW6y.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $72fb3e969271b63d$var$debug("on readable", state.length, state.reading);
            if (state.length) $72fb3e969271b63d$var$emitReadable(this);
            else if (!state.reading) $4pbh3.nextTick($72fb3e969271b63d$var$nReadingNextTick, this);
        }
    }
    return res;
};
$72fb3e969271b63d$var$Readable.prototype.addListener = $72fb3e969271b63d$var$Readable.prototype.on;
$72fb3e969271b63d$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $aSW6y.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4pbh3.nextTick($72fb3e969271b63d$var$updateReadableListening, this);
    return res;
};
$72fb3e969271b63d$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $aSW6y.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4pbh3.nextTick($72fb3e969271b63d$var$updateReadableListening, this);
    return res;
};
function $72fb3e969271b63d$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $72fb3e969271b63d$var$nReadingNextTick(self) {
    $72fb3e969271b63d$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$72fb3e969271b63d$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $72fb3e969271b63d$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $72fb3e969271b63d$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $72fb3e969271b63d$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4pbh3.nextTick($72fb3e969271b63d$var$resume_, stream, state);
    }
}
function $72fb3e969271b63d$var$resume_(stream, state) {
    $72fb3e969271b63d$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $72fb3e969271b63d$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$72fb3e969271b63d$var$Readable.prototype.pause = function() {
    $72fb3e969271b63d$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $72fb3e969271b63d$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $72fb3e969271b63d$var$flow(stream) {
    var state = stream._readableState;
    $72fb3e969271b63d$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$72fb3e969271b63d$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $72fb3e969271b63d$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $72fb3e969271b63d$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $72fb3e969271b63d$var$kProxyEvents.length; n++)stream.on($72fb3e969271b63d$var$kProxyEvents[n], this.emit.bind(this, $72fb3e969271b63d$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $72fb3e969271b63d$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $72fb3e969271b63d$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($72fb3e969271b63d$var$createReadableStreamAsyncIterator === undefined) $72fb3e969271b63d$var$createReadableStreamAsyncIterator = (parcelRequire("fTc5B"));
    return $72fb3e969271b63d$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($72fb3e969271b63d$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($72fb3e969271b63d$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($72fb3e969271b63d$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$72fb3e969271b63d$var$Readable._fromList = $72fb3e969271b63d$var$fromList;
Object.defineProperty($72fb3e969271b63d$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $72fb3e969271b63d$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $72fb3e969271b63d$var$endReadable(stream) {
    var state = stream._readableState;
    $72fb3e969271b63d$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4pbh3.nextTick($72fb3e969271b63d$var$endReadableNT, state, stream);
    }
}
function $72fb3e969271b63d$var$endReadableNT(state, stream) {
    $72fb3e969271b63d$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $72fb3e969271b63d$var$Readable.from = function(iterable, opts) {
    if ($72fb3e969271b63d$var$from === undefined) $72fb3e969271b63d$var$from = (parcelRequire("6o9nI"));
    return $72fb3e969271b63d$var$from($72fb3e969271b63d$var$Readable, iterable, opts);
};
function $72fb3e969271b63d$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("3eX0e", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aVMuR = parcelRequire("aVMuR");
"use strict";
var $25c072a353442b1a$var$R = typeof Reflect === "object" ? Reflect : null;
var $25c072a353442b1a$var$ReflectApply = $25c072a353442b1a$var$R && typeof $25c072a353442b1a$var$R.apply === "function" ? $25c072a353442b1a$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $25c072a353442b1a$var$ReflectOwnKeys;
if ($25c072a353442b1a$var$R && typeof $25c072a353442b1a$var$R.ownKeys === "function") $25c072a353442b1a$var$ReflectOwnKeys = $25c072a353442b1a$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $25c072a353442b1a$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $25c072a353442b1a$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $25c072a353442b1a$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $25c072a353442b1a$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $25c072a353442b1a$var$EventEmitter() {
    $25c072a353442b1a$var$EventEmitter.init.call(this);
}
module.exports = $25c072a353442b1a$var$EventEmitter;
module.exports.once = $25c072a353442b1a$var$once;
// Backwards-compat with node 0.10.x
$25c072a353442b1a$var$EventEmitter.EventEmitter = $25c072a353442b1a$var$EventEmitter;
$25c072a353442b1a$var$EventEmitter.prototype._events = undefined;
$25c072a353442b1a$var$EventEmitter.prototype._eventsCount = 0;
$25c072a353442b1a$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $25c072a353442b1a$var$defaultMaxListeners = 10;
function $25c072a353442b1a$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $aVMuR._)(listener)));
}
Object.defineProperty($25c072a353442b1a$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return $25c072a353442b1a$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || $25c072a353442b1a$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $25c072a353442b1a$var$defaultMaxListeners = arg;
    }
});
$25c072a353442b1a$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$25c072a353442b1a$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $25c072a353442b1a$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $25c072a353442b1a$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $25c072a353442b1a$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$25c072a353442b1a$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $25c072a353442b1a$var$_getMaxListeners(this);
};
$25c072a353442b1a$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $25c072a353442b1a$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $25c072a353442b1a$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$25c072a353442b1a$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $25c072a353442b1a$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $25c072a353442b1a$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $25c072a353442b1a$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $25c072a353442b1a$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$25c072a353442b1a$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $25c072a353442b1a$var$_addListener(this, type, listener, false);
};
$25c072a353442b1a$var$EventEmitter.prototype.on = $25c072a353442b1a$var$EventEmitter.prototype.addListener;
$25c072a353442b1a$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $25c072a353442b1a$var$_addListener(this, type, listener, true);
};
function $25c072a353442b1a$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $25c072a353442b1a$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $25c072a353442b1a$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$25c072a353442b1a$var$EventEmitter.prototype.once = function once(type, listener) {
    $25c072a353442b1a$var$checkListener(listener);
    this.on(type, $25c072a353442b1a$var$_onceWrap(this, type, listener));
    return this;
};
$25c072a353442b1a$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $25c072a353442b1a$var$checkListener(listener);
    this.prependListener(type, $25c072a353442b1a$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$25c072a353442b1a$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $25c072a353442b1a$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $25c072a353442b1a$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$25c072a353442b1a$var$EventEmitter.prototype.off = $25c072a353442b1a$var$EventEmitter.prototype.removeListener;
$25c072a353442b1a$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $25c072a353442b1a$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $25c072a353442b1a$var$unwrapListeners(evlistener) : $25c072a353442b1a$var$arrayClone(evlistener, evlistener.length);
}
$25c072a353442b1a$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $25c072a353442b1a$var$_listeners(this, type, true);
};
$25c072a353442b1a$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $25c072a353442b1a$var$_listeners(this, type, false);
};
$25c072a353442b1a$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $25c072a353442b1a$var$listenerCount.call(emitter, type);
};
$25c072a353442b1a$var$EventEmitter.prototype.listenerCount = $25c072a353442b1a$var$listenerCount;
function $25c072a353442b1a$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$25c072a353442b1a$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $25c072a353442b1a$var$ReflectOwnKeys(this._events) : [];
};
function $25c072a353442b1a$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $25c072a353442b1a$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $25c072a353442b1a$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $25c072a353442b1a$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $25c072a353442b1a$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $25c072a353442b1a$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $25c072a353442b1a$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $25c072a353442b1a$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $25c072a353442b1a$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $aVMuR._)(emitter)));
}

});

parcelRegister("aSW6y", function(module, exports) {

module.exports = (parcelRequire("3eX0e")).EventEmitter;

});

parcelRegister("49uTH", function(module, exports) {
"use strict";
function $305ff83f7c45a2a6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $305ff83f7c45a2a6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $305ff83f7c45a2a6$var$ownKeys(Object(source), true).forEach(function(key) {
            $305ff83f7c45a2a6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $305ff83f7c45a2a6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $305ff83f7c45a2a6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $305ff83f7c45a2a6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $305ff83f7c45a2a6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $305ff83f7c45a2a6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $305ff83f7c45a2a6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $305ff83f7c45a2a6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $ilnag = parcelRequire("ilnag");
var $305ff83f7c45a2a6$var$Buffer = $ilnag.Buffer;

var $24TKi = parcelRequire("24TKi");
var $305ff83f7c45a2a6$var$inspect = $24TKi.inspect;
var $305ff83f7c45a2a6$var$custom = $305ff83f7c45a2a6$var$inspect && $305ff83f7c45a2a6$var$inspect.custom || "inspect";
function $305ff83f7c45a2a6$var$copyBuffer(src, target, offset) {
    $305ff83f7c45a2a6$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $305ff83f7c45a2a6$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $305ff83f7c45a2a6$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $305ff83f7c45a2a6$var$Buffer.alloc(0);
                var ret = $305ff83f7c45a2a6$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $305ff83f7c45a2a6$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $305ff83f7c45a2a6$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $305ff83f7c45a2a6$var$custom,
            value: function value(_, options) {
                return $305ff83f7c45a2a6$var$inspect(this, $305ff83f7c45a2a6$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("bk9Vg", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $83e9425da88e9e16$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4pbh3.nextTick($83e9425da88e9e16$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4pbh3.nextTick($83e9425da88e9e16$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4pbh3.nextTick($83e9425da88e9e16$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4pbh3.nextTick($83e9425da88e9e16$var$emitErrorAndCloseNT, _this, err);
            } else $4pbh3.nextTick($83e9425da88e9e16$var$emitCloseNT, _this);
        } else if (cb) {
            $4pbh3.nextTick($83e9425da88e9e16$var$emitCloseNT, _this);
            cb(err);
        } else $4pbh3.nextTick($83e9425da88e9e16$var$emitCloseNT, _this);
    });
    return this;
}
function $83e9425da88e9e16$var$emitErrorAndCloseNT(self, err) {
    $83e9425da88e9e16$var$emitErrorNT(self, err);
    $83e9425da88e9e16$var$emitCloseNT(self);
}
function $83e9425da88e9e16$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $83e9425da88e9e16$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $83e9425da88e9e16$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $83e9425da88e9e16$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $83e9425da88e9e16$var$destroy,
    undestroy: $83e9425da88e9e16$var$undestroy,
    errorOrDestroy: $83e9425da88e9e16$var$errorOrDestroy
};

});

parcelRegister("6RY09", function(module, exports) {
"use strict";

var $50063c5fa4b409f8$var$ERR_INVALID_OPT_VALUE = (parcelRequire("cQNMR")).codes.ERR_INVALID_OPT_VALUE;
function $50063c5fa4b409f8$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $50063c5fa4b409f8$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $50063c5fa4b409f8$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $50063c5fa4b409f8$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $50063c5fa4b409f8$var$getHighWaterMark
};

});
parcelRegister("cQNMR", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $95b0f60daa5bc161$export$e45cb6485273080e; }, function (v) { return $95b0f60daa5bc161$export$e45cb6485273080e = v; });

var $aVMuR = parcelRequire("aVMuR");
var $95b0f60daa5bc161$export$e45cb6485273080e;
"use strict";
function $95b0f60daa5bc161$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $95b0f60daa5bc161$var$codes = {};
function $95b0f60daa5bc161$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $95b0f60daa5bc161$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $95b0f60daa5bc161$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $95b0f60daa5bc161$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $95b0f60daa5bc161$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $95b0f60daa5bc161$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $95b0f60daa5bc161$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$95b0f60daa5bc161$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$95b0f60daa5bc161$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $95b0f60daa5bc161$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($95b0f60daa5bc161$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($95b0f60daa5bc161$var$oneOf(expected, "type"));
    else {
        var type = $95b0f60daa5bc161$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($95b0f60daa5bc161$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $aVMuR._)(actual));
    return msg;
}, TypeError);
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$95b0f60daa5bc161$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$95b0f60daa5bc161$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$95b0f60daa5bc161$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$95b0f60daa5bc161$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$95b0f60daa5bc161$export$e45cb6485273080e = $95b0f60daa5bc161$var$codes;

});


parcelRegister("9TH5C", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
/*<replacement>*/ var $734aacd009da61e0$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $734aacd009da61e0$var$Duplex;

var $9S2GU = parcelRequire("9S2GU");

var $34aEX = parcelRequire("34aEX");

(parcelRequire("5PBAa"))($734aacd009da61e0$var$Duplex, $9S2GU);
// Allow the keys array to be GC'ed.
var $734aacd009da61e0$var$keys = $734aacd009da61e0$var$objectKeys($34aEX.prototype);
for(var $734aacd009da61e0$var$v = 0; $734aacd009da61e0$var$v < $734aacd009da61e0$var$keys.length; $734aacd009da61e0$var$v++){
    var $734aacd009da61e0$var$method = $734aacd009da61e0$var$keys[$734aacd009da61e0$var$v];
    if (!$734aacd009da61e0$var$Duplex.prototype[$734aacd009da61e0$var$method]) $734aacd009da61e0$var$Duplex.prototype[$734aacd009da61e0$var$method] = $34aEX.prototype[$734aacd009da61e0$var$method];
}
function $734aacd009da61e0$var$Duplex(options) {
    if (!(this instanceof $734aacd009da61e0$var$Duplex)) return new $734aacd009da61e0$var$Duplex(options);
    $9S2GU.call(this, options);
    $34aEX.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $734aacd009da61e0$var$onend);
        }
    }
}
Object.defineProperty($734aacd009da61e0$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($734aacd009da61e0$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($734aacd009da61e0$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $734aacd009da61e0$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $4pbh3.nextTick($734aacd009da61e0$var$onEndNT, this);
}
function $734aacd009da61e0$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($734aacd009da61e0$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("34aEX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
module.exports = $23ba0397c7df11af$var$Writable;
/* <replacement> */ function $23ba0397c7df11af$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $23ba0397c7df11af$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $23ba0397c7df11af$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $23ba0397c7df11af$var$Duplex;
/*</replacement>*/ $23ba0397c7df11af$var$Writable.WritableState = $23ba0397c7df11af$var$WritableState;

/*<replacement>*/ var $23ba0397c7df11af$var$internalUtil = {
    deprecate: (parcelRequire("2tHi3"))
};

var $aSW6y = parcelRequire("aSW6y");

var $ilnag = parcelRequire("ilnag");
var $23ba0397c7df11af$require$Buffer = $ilnag.Buffer;
var $23ba0397c7df11af$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $23ba0397c7df11af$var$_uint8ArrayToBuffer(chunk) {
    return $23ba0397c7df11af$require$Buffer.from(chunk);
}
function $23ba0397c7df11af$var$_isUint8Array(obj) {
    return $23ba0397c7df11af$require$Buffer.isBuffer(obj) || obj instanceof $23ba0397c7df11af$var$OurUint8Array;
}

var $bk9Vg = parcelRequire("bk9Vg");

var $6RY09 = parcelRequire("6RY09");
var $23ba0397c7df11af$var$getHighWaterMark = $6RY09.getHighWaterMark;

var $cQNMR = parcelRequire("cQNMR");
var $23ba0397c7df11af$require$_require$codes = $cQNMR.codes;
var $23ba0397c7df11af$var$ERR_INVALID_ARG_TYPE = $23ba0397c7df11af$require$_require$codes.ERR_INVALID_ARG_TYPE, $23ba0397c7df11af$var$ERR_METHOD_NOT_IMPLEMENTED = $23ba0397c7df11af$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $23ba0397c7df11af$var$ERR_MULTIPLE_CALLBACK = $23ba0397c7df11af$require$_require$codes.ERR_MULTIPLE_CALLBACK, $23ba0397c7df11af$var$ERR_STREAM_CANNOT_PIPE = $23ba0397c7df11af$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $23ba0397c7df11af$var$ERR_STREAM_DESTROYED = $23ba0397c7df11af$require$_require$codes.ERR_STREAM_DESTROYED, $23ba0397c7df11af$var$ERR_STREAM_NULL_VALUES = $23ba0397c7df11af$require$_require$codes.ERR_STREAM_NULL_VALUES, $23ba0397c7df11af$var$ERR_STREAM_WRITE_AFTER_END = $23ba0397c7df11af$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $23ba0397c7df11af$var$ERR_UNKNOWN_ENCODING = $23ba0397c7df11af$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $23ba0397c7df11af$var$errorOrDestroy = $bk9Vg.errorOrDestroy;

(parcelRequire("5PBAa"))($23ba0397c7df11af$var$Writable, $aSW6y);
function $23ba0397c7df11af$var$nop() {}

function $23ba0397c7df11af$var$WritableState(options, stream, isDuplex) {
    $23ba0397c7df11af$var$Duplex = $23ba0397c7df11af$var$Duplex || (parcelRequire("9TH5C"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $23ba0397c7df11af$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $23ba0397c7df11af$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $23ba0397c7df11af$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $23ba0397c7df11af$var$CorkedRequest(this);
}
$23ba0397c7df11af$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($23ba0397c7df11af$var$WritableState.prototype, "buffer", {
            get: $23ba0397c7df11af$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $23ba0397c7df11af$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $23ba0397c7df11af$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($23ba0397c7df11af$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($23ba0397c7df11af$var$realHasInstance.call(this, object)) return true;
            if (this !== $23ba0397c7df11af$var$Writable) return false;
            return object && object._writableState instanceof $23ba0397c7df11af$var$WritableState;
        }
    });
} else $23ba0397c7df11af$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $23ba0397c7df11af$var$Writable(options) {
    $23ba0397c7df11af$var$Duplex = $23ba0397c7df11af$var$Duplex || (parcelRequire("9TH5C")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $23ba0397c7df11af$var$Duplex;
    if (!isDuplex && !$23ba0397c7df11af$var$realHasInstance.call($23ba0397c7df11af$var$Writable, this)) return new $23ba0397c7df11af$var$Writable(options);
    this._writableState = new $23ba0397c7df11af$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $aSW6y.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$23ba0397c7df11af$var$Writable.prototype.pipe = function() {
    $23ba0397c7df11af$var$errorOrDestroy(this, new $23ba0397c7df11af$var$ERR_STREAM_CANNOT_PIPE());
};
function $23ba0397c7df11af$var$writeAfterEnd(stream, cb) {
    var er = new $23ba0397c7df11af$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $23ba0397c7df11af$var$errorOrDestroy(stream, er);
    $4pbh3.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $23ba0397c7df11af$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $23ba0397c7df11af$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $23ba0397c7df11af$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $23ba0397c7df11af$var$errorOrDestroy(stream, er);
        $4pbh3.nextTick(cb, er);
        return false;
    }
    return true;
}
$23ba0397c7df11af$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $23ba0397c7df11af$var$_isUint8Array(chunk);
    if (isBuf && !$23ba0397c7df11af$require$Buffer.isBuffer(chunk)) chunk = $23ba0397c7df11af$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $23ba0397c7df11af$var$nop;
    if (state.ending) $23ba0397c7df11af$var$writeAfterEnd(this, cb);
    else if (isBuf || $23ba0397c7df11af$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $23ba0397c7df11af$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$23ba0397c7df11af$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$23ba0397c7df11af$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $23ba0397c7df11af$var$clearBuffer(this, state);
    }
};
$23ba0397c7df11af$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $23ba0397c7df11af$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($23ba0397c7df11af$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $23ba0397c7df11af$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $23ba0397c7df11af$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($23ba0397c7df11af$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $23ba0397c7df11af$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $23ba0397c7df11af$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $23ba0397c7df11af$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $23ba0397c7df11af$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $23ba0397c7df11af$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $23ba0397c7df11af$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4pbh3.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $4pbh3.nextTick($23ba0397c7df11af$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $23ba0397c7df11af$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $23ba0397c7df11af$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $23ba0397c7df11af$var$finishMaybe(stream, state);
    }
}
function $23ba0397c7df11af$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $23ba0397c7df11af$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $23ba0397c7df11af$var$ERR_MULTIPLE_CALLBACK();
    $23ba0397c7df11af$var$onwriteStateUpdate(state);
    if (er) $23ba0397c7df11af$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $23ba0397c7df11af$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $23ba0397c7df11af$var$clearBuffer(stream, state);
        if (sync) $4pbh3.nextTick($23ba0397c7df11af$var$afterWrite, stream, state, finished, cb);
        else $23ba0397c7df11af$var$afterWrite(stream, state, finished, cb);
    }
}
function $23ba0397c7df11af$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $23ba0397c7df11af$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $23ba0397c7df11af$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $23ba0397c7df11af$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $23ba0397c7df11af$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $23ba0397c7df11af$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $23ba0397c7df11af$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $23ba0397c7df11af$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$23ba0397c7df11af$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $23ba0397c7df11af$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$23ba0397c7df11af$var$Writable.prototype._writev = null;
$23ba0397c7df11af$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $23ba0397c7df11af$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($23ba0397c7df11af$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $23ba0397c7df11af$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $23ba0397c7df11af$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $23ba0397c7df11af$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $23ba0397c7df11af$var$finishMaybe(stream, state);
    });
}
function $23ba0397c7df11af$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4pbh3.nextTick($23ba0397c7df11af$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $23ba0397c7df11af$var$finishMaybe(stream, state) {
    var need = $23ba0397c7df11af$var$needFinish(state);
    if (need) {
        $23ba0397c7df11af$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $23ba0397c7df11af$var$endWritable(stream, state, cb) {
    state.ending = true;
    $23ba0397c7df11af$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4pbh3.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $23ba0397c7df11af$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($23ba0397c7df11af$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$23ba0397c7df11af$var$Writable.prototype.destroy = $bk9Vg.destroy;
$23ba0397c7df11af$var$Writable.prototype._undestroy = $bk9Vg.undestroy;
$23ba0397c7df11af$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("2tHi3", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $1cdfdec2e35aa53d$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $1cdfdec2e35aa53d$var$deprecate(fn, msg) {
    if ($1cdfdec2e35aa53d$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1cdfdec2e35aa53d$var$config("throwDeprecation")) throw new Error(msg);
            else if ($1cdfdec2e35aa53d$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $1cdfdec2e35aa53d$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("ePy3J", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $acc03f88ce59d494$export$63a7aa211a91ed69; }, function (v) { return $acc03f88ce59d494$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $acc03f88ce59d494$export$63a7aa211a91ed69;
"use strict";

var $b1nU2 = parcelRequire("b1nU2");
var $acc03f88ce59d494$require$Buffer = $b1nU2.Buffer;
/*</replacement>*/ var $acc03f88ce59d494$var$isEncoding = $acc03f88ce59d494$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $acc03f88ce59d494$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $acc03f88ce59d494$var$normalizeEncoding(enc) {
    var nenc = $acc03f88ce59d494$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($acc03f88ce59d494$require$Buffer.isEncoding === $acc03f88ce59d494$var$isEncoding || !$acc03f88ce59d494$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$acc03f88ce59d494$export$63a7aa211a91ed69 = $acc03f88ce59d494$var$StringDecoder;
function $acc03f88ce59d494$var$StringDecoder(encoding) {
    this.encoding = $acc03f88ce59d494$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $acc03f88ce59d494$var$utf16Text;
            this.end = $acc03f88ce59d494$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $acc03f88ce59d494$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $acc03f88ce59d494$var$base64Text;
            this.end = $acc03f88ce59d494$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $acc03f88ce59d494$var$simpleWrite;
            this.end = $acc03f88ce59d494$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $acc03f88ce59d494$require$Buffer.allocUnsafe(nb);
}
$acc03f88ce59d494$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$acc03f88ce59d494$var$StringDecoder.prototype.end = $acc03f88ce59d494$var$utf8End;
// Returns only complete characters in a Buffer
$acc03f88ce59d494$var$StringDecoder.prototype.text = $acc03f88ce59d494$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$acc03f88ce59d494$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $acc03f88ce59d494$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $acc03f88ce59d494$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $acc03f88ce59d494$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $acc03f88ce59d494$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $acc03f88ce59d494$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $acc03f88ce59d494$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $acc03f88ce59d494$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $acc03f88ce59d494$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $acc03f88ce59d494$var$utf8Text(buf, i) {
    var total = $acc03f88ce59d494$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $acc03f88ce59d494$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $acc03f88ce59d494$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $acc03f88ce59d494$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $acc03f88ce59d494$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $acc03f88ce59d494$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $acc03f88ce59d494$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $acc03f88ce59d494$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("fTc5B", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
var $b9155ebe9be759df$var$_Object$setPrototypeO;
function $b9155ebe9be759df$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $1s0OU = parcelRequire("1s0OU");
var $b9155ebe9be759df$var$kLastResolve = Symbol("lastResolve");
var $b9155ebe9be759df$var$kLastReject = Symbol("lastReject");
var $b9155ebe9be759df$var$kError = Symbol("error");
var $b9155ebe9be759df$var$kEnded = Symbol("ended");
var $b9155ebe9be759df$var$kLastPromise = Symbol("lastPromise");
var $b9155ebe9be759df$var$kHandlePromise = Symbol("handlePromise");
var $b9155ebe9be759df$var$kStream = Symbol("stream");
function $b9155ebe9be759df$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $b9155ebe9be759df$var$readAndResolve(iter) {
    var resolve = iter[$b9155ebe9be759df$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$b9155ebe9be759df$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$b9155ebe9be759df$var$kLastPromise] = null;
            iter[$b9155ebe9be759df$var$kLastResolve] = null;
            iter[$b9155ebe9be759df$var$kLastReject] = null;
            resolve($b9155ebe9be759df$var$createIterResult(data, false));
        }
    }
}
function $b9155ebe9be759df$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4pbh3.nextTick($b9155ebe9be759df$var$readAndResolve, iter);
}
function $b9155ebe9be759df$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$b9155ebe9be759df$var$kEnded]) {
                resolve($b9155ebe9be759df$var$createIterResult(undefined, true));
                return;
            }
            iter[$b9155ebe9be759df$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $b9155ebe9be759df$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $b9155ebe9be759df$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($b9155ebe9be759df$var$_Object$setPrototypeO = {
    get stream () {
        return this[$b9155ebe9be759df$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$b9155ebe9be759df$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$b9155ebe9be759df$var$kEnded]) return Promise.resolve($b9155ebe9be759df$var$createIterResult(undefined, true));
        if (this[$b9155ebe9be759df$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4pbh3.nextTick(function() {
                if (_this[$b9155ebe9be759df$var$kError]) reject(_this[$b9155ebe9be759df$var$kError]);
                else resolve($b9155ebe9be759df$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$b9155ebe9be759df$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($b9155ebe9be759df$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$b9155ebe9be759df$var$kStream].read();
            if (data !== null) return Promise.resolve($b9155ebe9be759df$var$createIterResult(data, false));
            promise = new Promise(this[$b9155ebe9be759df$var$kHandlePromise]);
        }
        this[$b9155ebe9be759df$var$kLastPromise] = promise;
        return promise;
    }
}, $b9155ebe9be759df$var$_defineProperty($b9155ebe9be759df$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $b9155ebe9be759df$var$_defineProperty($b9155ebe9be759df$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$b9155ebe9be759df$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($b9155ebe9be759df$var$createIterResult(undefined, true));
        });
    });
}), $b9155ebe9be759df$var$_Object$setPrototypeO), $b9155ebe9be759df$var$AsyncIteratorPrototype);
var $b9155ebe9be759df$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($b9155ebe9be759df$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $b9155ebe9be759df$var$_defineProperty(_Object$create, $b9155ebe9be759df$var$kStream, {
        value: stream,
        writable: true
    }), $b9155ebe9be759df$var$_defineProperty(_Object$create, $b9155ebe9be759df$var$kLastResolve, {
        value: null,
        writable: true
    }), $b9155ebe9be759df$var$_defineProperty(_Object$create, $b9155ebe9be759df$var$kLastReject, {
        value: null,
        writable: true
    }), $b9155ebe9be759df$var$_defineProperty(_Object$create, $b9155ebe9be759df$var$kError, {
        value: null,
        writable: true
    }), $b9155ebe9be759df$var$_defineProperty(_Object$create, $b9155ebe9be759df$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $b9155ebe9be759df$var$_defineProperty(_Object$create, $b9155ebe9be759df$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$b9155ebe9be759df$var$kStream].read();
            if (data) {
                iterator[$b9155ebe9be759df$var$kLastPromise] = null;
                iterator[$b9155ebe9be759df$var$kLastResolve] = null;
                iterator[$b9155ebe9be759df$var$kLastReject] = null;
                resolve($b9155ebe9be759df$var$createIterResult(data, false));
            } else {
                iterator[$b9155ebe9be759df$var$kLastResolve] = resolve;
                iterator[$b9155ebe9be759df$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$b9155ebe9be759df$var$kLastPromise] = null;
    $1s0OU(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$b9155ebe9be759df$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$b9155ebe9be759df$var$kLastPromise] = null;
                iterator[$b9155ebe9be759df$var$kLastResolve] = null;
                iterator[$b9155ebe9be759df$var$kLastReject] = null;
                reject(err);
            }
            iterator[$b9155ebe9be759df$var$kError] = err;
            return;
        }
        var resolve = iterator[$b9155ebe9be759df$var$kLastResolve];
        if (resolve !== null) {
            iterator[$b9155ebe9be759df$var$kLastPromise] = null;
            iterator[$b9155ebe9be759df$var$kLastResolve] = null;
            iterator[$b9155ebe9be759df$var$kLastReject] = null;
            resolve($b9155ebe9be759df$var$createIterResult(undefined, true));
        }
        iterator[$b9155ebe9be759df$var$kEnded] = true;
    });
    stream.on("readable", $b9155ebe9be759df$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $b9155ebe9be759df$var$createReadableStreamAsyncIterator;

});
parcelRegister("1s0OU", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $10e90ad9d3b0dfe0$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("cQNMR")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $10e90ad9d3b0dfe0$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $10e90ad9d3b0dfe0$var$noop() {}
function $10e90ad9d3b0dfe0$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $10e90ad9d3b0dfe0$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $10e90ad9d3b0dfe0$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $10e90ad9d3b0dfe0$var$once(callback || $10e90ad9d3b0dfe0$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $10e90ad9d3b0dfe0$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $10e90ad9d3b0dfe0$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($10e90ad9d3b0dfe0$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $10e90ad9d3b0dfe0$var$eos;

});


parcelRegister("6o9nI", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("i5CAu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $d2b6a0503e9f4413$var$Transform;

var $cQNMR = parcelRequire("cQNMR");
var $d2b6a0503e9f4413$require$_require$codes = $cQNMR.codes;
var $d2b6a0503e9f4413$var$ERR_METHOD_NOT_IMPLEMENTED = $d2b6a0503e9f4413$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d2b6a0503e9f4413$var$ERR_MULTIPLE_CALLBACK = $d2b6a0503e9f4413$require$_require$codes.ERR_MULTIPLE_CALLBACK, $d2b6a0503e9f4413$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $d2b6a0503e9f4413$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $d2b6a0503e9f4413$var$ERR_TRANSFORM_WITH_LENGTH_0 = $d2b6a0503e9f4413$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $9TH5C = parcelRequire("9TH5C");

(parcelRequire("5PBAa"))($d2b6a0503e9f4413$var$Transform, $9TH5C);
function $d2b6a0503e9f4413$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $d2b6a0503e9f4413$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $d2b6a0503e9f4413$var$Transform(options) {
    if (!(this instanceof $d2b6a0503e9f4413$var$Transform)) return new $d2b6a0503e9f4413$var$Transform(options);
    $9TH5C.call(this, options);
    this._transformState = {
        afterTransform: $d2b6a0503e9f4413$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $d2b6a0503e9f4413$var$prefinish);
}
function $d2b6a0503e9f4413$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $d2b6a0503e9f4413$var$done(_this, er, data);
    });
    else $d2b6a0503e9f4413$var$done(this, null, null);
}
$d2b6a0503e9f4413$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $9TH5C.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$d2b6a0503e9f4413$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $d2b6a0503e9f4413$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$d2b6a0503e9f4413$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$d2b6a0503e9f4413$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$d2b6a0503e9f4413$var$Transform.prototype._destroy = function(err, cb) {
    $9TH5C.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $d2b6a0503e9f4413$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $d2b6a0503e9f4413$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $d2b6a0503e9f4413$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("dRgqH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $a16cf833a0ae730b$var$PassThrough;

var $i5CAu = parcelRequire("i5CAu");

(parcelRequire("5PBAa"))($a16cf833a0ae730b$var$PassThrough, $i5CAu);
function $a16cf833a0ae730b$var$PassThrough(options) {
    if (!(this instanceof $a16cf833a0ae730b$var$PassThrough)) return new $a16cf833a0ae730b$var$PassThrough(options);
    $i5CAu.call(this, options);
}
$a16cf833a0ae730b$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("ieGMb", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $d46ab73f040ff1c0$var$eos;
function $d46ab73f040ff1c0$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $cQNMR = parcelRequire("cQNMR");
var $d46ab73f040ff1c0$require$_require$codes = $cQNMR.codes;
var $d46ab73f040ff1c0$var$ERR_MISSING_ARGS = $d46ab73f040ff1c0$require$_require$codes.ERR_MISSING_ARGS, $d46ab73f040ff1c0$var$ERR_STREAM_DESTROYED = $d46ab73f040ff1c0$require$_require$codes.ERR_STREAM_DESTROYED;
function $d46ab73f040ff1c0$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $d46ab73f040ff1c0$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $d46ab73f040ff1c0$var$destroyer(stream, reading, writing, callback) {
    callback = $d46ab73f040ff1c0$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($d46ab73f040ff1c0$var$eos === undefined) $d46ab73f040ff1c0$var$eos = (parcelRequire("1s0OU"));
    $d46ab73f040ff1c0$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($d46ab73f040ff1c0$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $d46ab73f040ff1c0$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $d46ab73f040ff1c0$var$call(fn) {
    fn();
}
function $d46ab73f040ff1c0$var$pipe(from, to) {
    return from.pipe(to);
}
function $d46ab73f040ff1c0$var$popCallback(streams) {
    if (!streams.length) return $d46ab73f040ff1c0$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $d46ab73f040ff1c0$var$noop;
    return streams.pop();
}
function $d46ab73f040ff1c0$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $d46ab73f040ff1c0$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $d46ab73f040ff1c0$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $d46ab73f040ff1c0$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($d46ab73f040ff1c0$var$call);
            if (reading) return;
            destroys.forEach($d46ab73f040ff1c0$var$call);
            callback(error);
        });
    });
    return streams.reduce($d46ab73f040ff1c0$var$pipe);
}
module.exports = $d46ab73f040ff1c0$var$pipeline;

});




parcelRegister("aEC5U", function(module, exports) {
"use strict";

var $ilnag = parcelRequire("ilnag");
var $7c1b30893318ea6a$require$Buffer = $ilnag.Buffer;

var $5PBAa = parcelRequire("5PBAa");

var $1je01 = parcelRequire("1je01");
var $7c1b30893318ea6a$var$ARRAY16 = new Array(16);
var $7c1b30893318ea6a$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $7c1b30893318ea6a$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $7c1b30893318ea6a$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $7c1b30893318ea6a$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $7c1b30893318ea6a$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $7c1b30893318ea6a$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $7c1b30893318ea6a$var$RIPEMD160() {
    $1je01.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$5PBAa($7c1b30893318ea6a$var$RIPEMD160, $1je01);
$7c1b30893318ea6a$var$RIPEMD160.prototype._update = function() {
    var words = $7c1b30893318ea6a$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $7c1b30893318ea6a$var$fn1(al, bl, cl, dl, el, words[$7c1b30893318ea6a$var$zl[i]], $7c1b30893318ea6a$var$hl[0], $7c1b30893318ea6a$var$sl[i]);
            tr = $7c1b30893318ea6a$var$fn5(ar, br, cr, dr, er, words[$7c1b30893318ea6a$var$zr[i]], $7c1b30893318ea6a$var$hr[0], $7c1b30893318ea6a$var$sr[i]);
        } else if (i < 32) {
            tl = $7c1b30893318ea6a$var$fn2(al, bl, cl, dl, el, words[$7c1b30893318ea6a$var$zl[i]], $7c1b30893318ea6a$var$hl[1], $7c1b30893318ea6a$var$sl[i]);
            tr = $7c1b30893318ea6a$var$fn4(ar, br, cr, dr, er, words[$7c1b30893318ea6a$var$zr[i]], $7c1b30893318ea6a$var$hr[1], $7c1b30893318ea6a$var$sr[i]);
        } else if (i < 48) {
            tl = $7c1b30893318ea6a$var$fn3(al, bl, cl, dl, el, words[$7c1b30893318ea6a$var$zl[i]], $7c1b30893318ea6a$var$hl[2], $7c1b30893318ea6a$var$sl[i]);
            tr = $7c1b30893318ea6a$var$fn3(ar, br, cr, dr, er, words[$7c1b30893318ea6a$var$zr[i]], $7c1b30893318ea6a$var$hr[2], $7c1b30893318ea6a$var$sr[i]);
        } else if (i < 64) {
            tl = $7c1b30893318ea6a$var$fn4(al, bl, cl, dl, el, words[$7c1b30893318ea6a$var$zl[i]], $7c1b30893318ea6a$var$hl[3], $7c1b30893318ea6a$var$sl[i]);
            tr = $7c1b30893318ea6a$var$fn2(ar, br, cr, dr, er, words[$7c1b30893318ea6a$var$zr[i]], $7c1b30893318ea6a$var$hr[3], $7c1b30893318ea6a$var$sr[i]);
        } else {
            tl = $7c1b30893318ea6a$var$fn5(al, bl, cl, dl, el, words[$7c1b30893318ea6a$var$zl[i]], $7c1b30893318ea6a$var$hl[4], $7c1b30893318ea6a$var$sl[i]);
            tr = $7c1b30893318ea6a$var$fn1(ar, br, cr, dr, er, words[$7c1b30893318ea6a$var$zr[i]], $7c1b30893318ea6a$var$hr[4], $7c1b30893318ea6a$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $7c1b30893318ea6a$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $7c1b30893318ea6a$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$7c1b30893318ea6a$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $7c1b30893318ea6a$require$Buffer.alloc ? $7c1b30893318ea6a$require$Buffer.alloc(20) : new $7c1b30893318ea6a$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $7c1b30893318ea6a$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $7c1b30893318ea6a$var$fn1(a, b, c, d, e, m, k, s) {
    return $7c1b30893318ea6a$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $7c1b30893318ea6a$var$fn2(a, b, c, d, e, m, k, s) {
    return $7c1b30893318ea6a$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $7c1b30893318ea6a$var$fn3(a, b, c, d, e, m, k, s) {
    return $7c1b30893318ea6a$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $7c1b30893318ea6a$var$fn4(a, b, c, d, e, m, k, s) {
    return $7c1b30893318ea6a$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $7c1b30893318ea6a$var$fn5(a, b, c, d, e, m, k, s) {
    return $7c1b30893318ea6a$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $7c1b30893318ea6a$var$RIPEMD160;

});

parcelRegister("fXOt1", function(module, exports) {
var $b9f3836e763cc53c$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $b9f3836e763cc53c$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$b9f3836e763cc53c$var$exports.sha = (parcelRequire("ehOmQ"));

$b9f3836e763cc53c$var$exports.sha1 = (parcelRequire("3c53x"));

$b9f3836e763cc53c$var$exports.sha224 = (parcelRequire("f5Rkp"));

$b9f3836e763cc53c$var$exports.sha256 = (parcelRequire("8x9fY"));

$b9f3836e763cc53c$var$exports.sha384 = (parcelRequire("e0fPM"));

$b9f3836e763cc53c$var$exports.sha512 = (parcelRequire("k8T76"));

});
parcelRegister("ehOmQ", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $5PBAa = parcelRequire("5PBAa");

var $41K35 = parcelRequire("41K35");

var $b1nU2 = parcelRequire("b1nU2");
var $a669b922c582ac9b$require$Buffer = $b1nU2.Buffer;
var $a669b922c582ac9b$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a669b922c582ac9b$var$W = new Array(80);
function $a669b922c582ac9b$var$Sha() {
    this.init();
    this._w = $a669b922c582ac9b$var$W;
    $41K35.call(this, 64, 56);
}
$5PBAa($a669b922c582ac9b$var$Sha, $41K35);
$a669b922c582ac9b$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a669b922c582ac9b$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a669b922c582ac9b$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a669b922c582ac9b$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a669b922c582ac9b$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a669b922c582ac9b$var$rotl5(a) + $a669b922c582ac9b$var$ft(s, b, c, d) + e + W[j] + $a669b922c582ac9b$var$K[s] | 0;
        e = d;
        d = c;
        c = $a669b922c582ac9b$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a669b922c582ac9b$var$Sha.prototype._hash = function() {
    var H = $a669b922c582ac9b$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a669b922c582ac9b$var$Sha;

});
parcelRegister("41K35", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $2eeaf9c12d82b4d7$require$Buffer = $b1nU2.Buffer;
// prototype class for hash functions
function $2eeaf9c12d82b4d7$var$Hash(blockSize, finalSize) {
    this._block = $2eeaf9c12d82b4d7$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$2eeaf9c12d82b4d7$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $2eeaf9c12d82b4d7$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$2eeaf9c12d82b4d7$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$2eeaf9c12d82b4d7$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $2eeaf9c12d82b4d7$var$Hash;

});


parcelRegister("3c53x", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $5PBAa = parcelRequire("5PBAa");

var $41K35 = parcelRequire("41K35");

var $b1nU2 = parcelRequire("b1nU2");
var $25366a1fb74d24eb$require$Buffer = $b1nU2.Buffer;
var $25366a1fb74d24eb$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $25366a1fb74d24eb$var$W = new Array(80);
function $25366a1fb74d24eb$var$Sha1() {
    this.init();
    this._w = $25366a1fb74d24eb$var$W;
    $41K35.call(this, 64, 56);
}
$5PBAa($25366a1fb74d24eb$var$Sha1, $41K35);
$25366a1fb74d24eb$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $25366a1fb74d24eb$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $25366a1fb74d24eb$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $25366a1fb74d24eb$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $25366a1fb74d24eb$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$25366a1fb74d24eb$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $25366a1fb74d24eb$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $25366a1fb74d24eb$var$rotl5(a) + $25366a1fb74d24eb$var$ft(s, b, c, d) + e + W[j] + $25366a1fb74d24eb$var$K[s] | 0;
        e = d;
        d = c;
        c = $25366a1fb74d24eb$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$25366a1fb74d24eb$var$Sha1.prototype._hash = function() {
    var H = $25366a1fb74d24eb$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $25366a1fb74d24eb$var$Sha1;

});

parcelRegister("f5Rkp", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $5PBAa = parcelRequire("5PBAa");

var $8x9fY = parcelRequire("8x9fY");

var $41K35 = parcelRequire("41K35");

var $b1nU2 = parcelRequire("b1nU2");
var $afd0b085cfbf90ad$require$Buffer = $b1nU2.Buffer;
var $afd0b085cfbf90ad$var$W = new Array(64);
function $afd0b085cfbf90ad$var$Sha224() {
    this.init();
    this._w = $afd0b085cfbf90ad$var$W // new Array(64)
    ;
    $41K35.call(this, 64, 56);
}
$5PBAa($afd0b085cfbf90ad$var$Sha224, $8x9fY);
$afd0b085cfbf90ad$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$afd0b085cfbf90ad$var$Sha224.prototype._hash = function() {
    var H = $afd0b085cfbf90ad$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $afd0b085cfbf90ad$var$Sha224;

});
parcelRegister("8x9fY", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $5PBAa = parcelRequire("5PBAa");

var $41K35 = parcelRequire("41K35");

var $b1nU2 = parcelRequire("b1nU2");
var $636895f599ac218e$require$Buffer = $b1nU2.Buffer;
var $636895f599ac218e$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $636895f599ac218e$var$W = new Array(64);
function $636895f599ac218e$var$Sha256() {
    this.init();
    this._w = $636895f599ac218e$var$W // new Array(64)
    ;
    $41K35.call(this, 64, 56);
}
$5PBAa($636895f599ac218e$var$Sha256, $41K35);
$636895f599ac218e$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $636895f599ac218e$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $636895f599ac218e$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $636895f599ac218e$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $636895f599ac218e$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $636895f599ac218e$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $636895f599ac218e$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$636895f599ac218e$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $636895f599ac218e$var$gamma1(W[i - 2]) + W[i - 7] + $636895f599ac218e$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $636895f599ac218e$var$sigma1(e) + $636895f599ac218e$var$ch(e, f, g) + $636895f599ac218e$var$K[j] + W[j] | 0;
        var T2 = $636895f599ac218e$var$sigma0(a) + $636895f599ac218e$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$636895f599ac218e$var$Sha256.prototype._hash = function() {
    var H = $636895f599ac218e$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $636895f599ac218e$var$Sha256;

});


parcelRegister("e0fPM", function(module, exports) {

var $5PBAa = parcelRequire("5PBAa");

var $k8T76 = parcelRequire("k8T76");

var $41K35 = parcelRequire("41K35");

var $b1nU2 = parcelRequire("b1nU2");
var $a31d5916d35d24f3$require$Buffer = $b1nU2.Buffer;
var $a31d5916d35d24f3$var$W = new Array(160);
function $a31d5916d35d24f3$var$Sha384() {
    this.init();
    this._w = $a31d5916d35d24f3$var$W;
    $41K35.call(this, 128, 112);
}
$5PBAa($a31d5916d35d24f3$var$Sha384, $k8T76);
$a31d5916d35d24f3$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$a31d5916d35d24f3$var$Sha384.prototype._hash = function() {
    var H = $a31d5916d35d24f3$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $a31d5916d35d24f3$var$Sha384;

});
parcelRegister("k8T76", function(module, exports) {

var $5PBAa = parcelRequire("5PBAa");

var $41K35 = parcelRequire("41K35");

var $b1nU2 = parcelRequire("b1nU2");
var $ea9f4e6321033464$require$Buffer = $b1nU2.Buffer;
var $ea9f4e6321033464$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $ea9f4e6321033464$var$W = new Array(160);
function $ea9f4e6321033464$var$Sha512() {
    this.init();
    this._w = $ea9f4e6321033464$var$W;
    $41K35.call(this, 128, 112);
}
$5PBAa($ea9f4e6321033464$var$Sha512, $41K35);
$ea9f4e6321033464$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $ea9f4e6321033464$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $ea9f4e6321033464$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $ea9f4e6321033464$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $ea9f4e6321033464$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $ea9f4e6321033464$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $ea9f4e6321033464$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $ea9f4e6321033464$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $ea9f4e6321033464$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $ea9f4e6321033464$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$ea9f4e6321033464$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $ea9f4e6321033464$var$Gamma0(xh, xl);
        var gamma0l = $ea9f4e6321033464$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $ea9f4e6321033464$var$Gamma1(xh, xl);
        var gamma1l = $ea9f4e6321033464$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $ea9f4e6321033464$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $ea9f4e6321033464$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $ea9f4e6321033464$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $ea9f4e6321033464$var$maj(ah, bh, ch);
        var majl = $ea9f4e6321033464$var$maj(al, bl, cl);
        var sigma0h = $ea9f4e6321033464$var$sigma0(ah, al);
        var sigma0l = $ea9f4e6321033464$var$sigma0(al, ah);
        var sigma1h = $ea9f4e6321033464$var$sigma1(eh, el);
        var sigma1l = $ea9f4e6321033464$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $ea9f4e6321033464$var$K[j];
        var Kil = $ea9f4e6321033464$var$K[j + 1];
        var chh = $ea9f4e6321033464$var$Ch(eh, fh, gh);
        var chl = $ea9f4e6321033464$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $ea9f4e6321033464$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $ea9f4e6321033464$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $ea9f4e6321033464$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $ea9f4e6321033464$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $ea9f4e6321033464$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $ea9f4e6321033464$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $ea9f4e6321033464$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $ea9f4e6321033464$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $ea9f4e6321033464$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $ea9f4e6321033464$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $ea9f4e6321033464$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $ea9f4e6321033464$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $ea9f4e6321033464$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $ea9f4e6321033464$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $ea9f4e6321033464$var$getCarry(this._hl, hl) | 0;
};
$ea9f4e6321033464$var$Sha512.prototype._hash = function() {
    var H = $ea9f4e6321033464$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $ea9f4e6321033464$var$Sha512;

});



parcelRegister("2dJLz", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $19e04be8fda4eac9$require$Buffer = $b1nU2.Buffer;

var $68B9q = parcelRequire("68B9q");
var $19e04be8fda4eac9$require$Transform = $68B9q.Transform;

var $ePy3J = parcelRequire("ePy3J");
var $19e04be8fda4eac9$require$StringDecoder = $ePy3J.StringDecoder;

var $5PBAa = parcelRequire("5PBAa");
function $19e04be8fda4eac9$var$CipherBase(hashMode) {
    $19e04be8fda4eac9$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$5PBAa($19e04be8fda4eac9$var$CipherBase, $19e04be8fda4eac9$require$Transform);
$19e04be8fda4eac9$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $19e04be8fda4eac9$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$19e04be8fda4eac9$var$CipherBase.prototype.setAutoPadding = function() {};
$19e04be8fda4eac9$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$19e04be8fda4eac9$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$19e04be8fda4eac9$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$19e04be8fda4eac9$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$19e04be8fda4eac9$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$19e04be8fda4eac9$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $19e04be8fda4eac9$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$19e04be8fda4eac9$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $19e04be8fda4eac9$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $19e04be8fda4eac9$var$CipherBase;

});
parcelRegister("68B9q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $47804eda13f35c67$var$Stream;

var $3eX0e = parcelRequire("3eX0e");
var $47804eda13f35c67$require$EE = $3eX0e.EventEmitter;

var $5PBAa = parcelRequire("5PBAa");
$5PBAa($47804eda13f35c67$var$Stream, $47804eda13f35c67$require$EE);

$47804eda13f35c67$var$Stream.Readable = (parcelRequire("9S2GU"));

$47804eda13f35c67$var$Stream.Writable = (parcelRequire("34aEX"));

$47804eda13f35c67$var$Stream.Duplex = (parcelRequire("9TH5C"));

$47804eda13f35c67$var$Stream.Transform = (parcelRequire("i5CAu"));

$47804eda13f35c67$var$Stream.PassThrough = (parcelRequire("dRgqH"));

$47804eda13f35c67$var$Stream.finished = (parcelRequire("1s0OU"));

$47804eda13f35c67$var$Stream.pipeline = (parcelRequire("ieGMb"));
// Backwards-compat with node 0.4.x
$47804eda13f35c67$var$Stream.Stream = $47804eda13f35c67$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $47804eda13f35c67$var$Stream() {
    $47804eda13f35c67$require$EE.call(this);
}
$47804eda13f35c67$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($47804eda13f35c67$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("c9AEc", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $fDXUY = parcelRequire("fDXUY");

var $2dJLz = parcelRequire("2dJLz");

var $b1nU2 = parcelRequire("b1nU2");
var $8d92c0b1489f24dc$require$Buffer = $b1nU2.Buffer;

var $bnWNM = parcelRequire("bnWNM");

var $aEC5U = parcelRequire("aEC5U");

var $fXOt1 = parcelRequire("fXOt1");
var $8d92c0b1489f24dc$var$ZEROS = $8d92c0b1489f24dc$require$Buffer.alloc(128);
function $8d92c0b1489f24dc$var$Hmac(alg, key) {
    $2dJLz.call(this, "digest");
    if (typeof key === "string") key = $8d92c0b1489f24dc$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $aEC5U() : $fXOt1(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $8d92c0b1489f24dc$require$Buffer.concat([
        key,
        $8d92c0b1489f24dc$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $8d92c0b1489f24dc$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $8d92c0b1489f24dc$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $aEC5U() : $fXOt1(alg);
    this._hash.update(ipad);
}
$5PBAa($8d92c0b1489f24dc$var$Hmac, $2dJLz);
$8d92c0b1489f24dc$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$8d92c0b1489f24dc$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $aEC5U() : $fXOt1(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $8d92c0b1489f24dc$var$Hmac("rmd160", key);
    if (alg === "md5") return new $fDXUY($bnWNM, key);
    return new $8d92c0b1489f24dc$var$Hmac(alg, key);
};

});
parcelRegister("fDXUY", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $b1nU2 = parcelRequire("b1nU2");
var $b638f9f8e355004e$require$Buffer = $b1nU2.Buffer;

var $2dJLz = parcelRequire("2dJLz");
var $b638f9f8e355004e$var$ZEROS = $b638f9f8e355004e$require$Buffer.alloc(128);
var $b638f9f8e355004e$var$blocksize = 64;
function $b638f9f8e355004e$var$Hmac(alg, key) {
    $2dJLz.call(this, "digest");
    if (typeof key === "string") key = $b638f9f8e355004e$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $b638f9f8e355004e$var$blocksize) key = alg(key);
    else if (key.length < $b638f9f8e355004e$var$blocksize) key = $b638f9f8e355004e$require$Buffer.concat([
        key,
        $b638f9f8e355004e$var$ZEROS
    ], $b638f9f8e355004e$var$blocksize);
    var ipad = this._ipad = $b638f9f8e355004e$require$Buffer.allocUnsafe($b638f9f8e355004e$var$blocksize);
    var opad = this._opad = $b638f9f8e355004e$require$Buffer.allocUnsafe($b638f9f8e355004e$var$blocksize);
    for(var i = 0; i < $b638f9f8e355004e$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$5PBAa($b638f9f8e355004e$var$Hmac, $2dJLz);
$b638f9f8e355004e$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$b638f9f8e355004e$var$Hmac.prototype._final = function() {
    var h = this._alg($b638f9f8e355004e$require$Buffer.concat(this._hash));
    return this._alg($b638f9f8e355004e$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $b638f9f8e355004e$var$Hmac;

});

parcelRegister("bnWNM", function(module, exports) {

var $1GvVx = parcelRequire("1GvVx");
module.exports = function(buffer) {
    return new $1GvVx().update(buffer).digest();
};

});


parcelRegister("hV0TQ", function(module, exports) {

module.exports = (parcelRequire("j979H"));

});
parcelRegister("j979H", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("aO3KN", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $7de17c50b06d029f$export$448fa22aedc9dbca; }, function (v) { return $7de17c50b06d029f$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $7de17c50b06d029f$export$b80c7ba289c8fa56; }, function (v) { return $7de17c50b06d029f$export$b80c7ba289c8fa56 = v; });
var $7de17c50b06d029f$export$448fa22aedc9dbca;
var $7de17c50b06d029f$export$b80c7ba289c8fa56;

$7de17c50b06d029f$export$448fa22aedc9dbca = (parcelRequire("e97hB"));

$7de17c50b06d029f$export$b80c7ba289c8fa56 = (parcelRequire("5zjWD"));

});
parcelRegister("e97hB", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $a4c78e2961d90c11$require$Buffer = $b1nU2.Buffer;

var $2nj8b = parcelRequire("2nj8b");

var $hi4a7 = parcelRequire("hi4a7");

var $5zjWD = parcelRequire("5zjWD");

var $j8xvU = parcelRequire("j8xvU");
var $a4c78e2961d90c11$var$ZERO_BUF;
var $a4c78e2961d90c11$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $a4c78e2961d90c11$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $a4c78e2961d90c11$var$checks = [];
function $a4c78e2961d90c11$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$a4c78e2961d90c11$var$subtle || !$a4c78e2961d90c11$var$subtle.importKey || !$a4c78e2961d90c11$var$subtle.deriveBits) return Promise.resolve(false);
    if ($a4c78e2961d90c11$var$checks[algo] !== undefined) return $a4c78e2961d90c11$var$checks[algo];
    $a4c78e2961d90c11$var$ZERO_BUF = $a4c78e2961d90c11$var$ZERO_BUF || $a4c78e2961d90c11$require$Buffer.alloc(8);
    var prom = $a4c78e2961d90c11$var$browserPbkdf2($a4c78e2961d90c11$var$ZERO_BUF, $a4c78e2961d90c11$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $a4c78e2961d90c11$var$checks[algo] = prom;
    return prom;
}
var $a4c78e2961d90c11$var$nextTick;
function $a4c78e2961d90c11$var$getNextTick() {
    if ($a4c78e2961d90c11$var$nextTick) return $a4c78e2961d90c11$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $a4c78e2961d90c11$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $a4c78e2961d90c11$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $a4c78e2961d90c11$var$nextTick = $parcel$global.setImmediate;
    else $a4c78e2961d90c11$var$nextTick = $parcel$global.setTimeout;
    return $a4c78e2961d90c11$var$nextTick;
}
function $a4c78e2961d90c11$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $a4c78e2961d90c11$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $a4c78e2961d90c11$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $a4c78e2961d90c11$require$Buffer.from(res);
    });
}
function $a4c78e2961d90c11$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $a4c78e2961d90c11$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $a4c78e2961d90c11$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $a4c78e2961d90c11$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $a4c78e2961d90c11$var$getNextTick()(function() {
            var out;
            try {
                out = $5zjWD(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $2nj8b(iterations, keylen);
    password = $j8xvU(password, $hi4a7, "Password");
    salt = $j8xvU(salt, $hi4a7, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $a4c78e2961d90c11$var$resolvePromise($a4c78e2961d90c11$var$checkNative(algo).then(function(resp) {
        if (resp) return $a4c78e2961d90c11$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $5zjWD(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("2nj8b", function(module, exports) {
var $1bac91caef7c2fcb$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $1bac91caef7c2fcb$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("hi4a7", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
var $c96758a4319a42f4$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $c96758a4319a42f4$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $c96758a4319a42f4$var$pVersionMajor = parseInt($4pbh3.version.split(".")[0].slice(1), 10);
    $c96758a4319a42f4$var$defaultEncoding = $c96758a4319a42f4$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $c96758a4319a42f4$var$defaultEncoding = "utf-8";
module.exports = $c96758a4319a42f4$var$defaultEncoding;

});

parcelRegister("5zjWD", function(module, exports) {

var $bnWNM = parcelRequire("bnWNM");

var $aEC5U = parcelRequire("aEC5U");

var $fXOt1 = parcelRequire("fXOt1");

var $b1nU2 = parcelRequire("b1nU2");
var $40dfb13ad7a5c54d$require$Buffer = $b1nU2.Buffer;

var $2nj8b = parcelRequire("2nj8b");

var $hi4a7 = parcelRequire("hi4a7");

var $j8xvU = parcelRequire("j8xvU");
var $40dfb13ad7a5c54d$var$ZEROS = $40dfb13ad7a5c54d$require$Buffer.alloc(128);
var $40dfb13ad7a5c54d$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $40dfb13ad7a5c54d$var$Hmac(alg, key, saltLen) {
    var hash = $40dfb13ad7a5c54d$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $40dfb13ad7a5c54d$require$Buffer.concat([
        key,
        $40dfb13ad7a5c54d$var$ZEROS
    ], blocksize);
    var ipad = $40dfb13ad7a5c54d$require$Buffer.allocUnsafe(blocksize + $40dfb13ad7a5c54d$var$sizes[alg]);
    var opad = $40dfb13ad7a5c54d$require$Buffer.allocUnsafe(blocksize + $40dfb13ad7a5c54d$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $40dfb13ad7a5c54d$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $40dfb13ad7a5c54d$var$sizes[alg];
}
$40dfb13ad7a5c54d$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $40dfb13ad7a5c54d$var$getDigest(alg) {
    function shaFunc(data) {
        return $fXOt1(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $aEC5U().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $bnWNM;
    return shaFunc;
}
function $40dfb13ad7a5c54d$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $2nj8b(iterations, keylen);
    password = $j8xvU(password, $hi4a7, "Password");
    salt = $j8xvU(salt, $hi4a7, "Salt");
    digest = digest || "sha1";
    var hmac = new $40dfb13ad7a5c54d$var$Hmac(digest, password, salt.length);
    var DK = $40dfb13ad7a5c54d$require$Buffer.allocUnsafe(keylen);
    var block1 = $40dfb13ad7a5c54d$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $40dfb13ad7a5c54d$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $40dfb13ad7a5c54d$var$pbkdf2;

});
parcelRegister("j8xvU", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $dee8c2ca129dc3ea$require$Buffer = $b1nU2.Buffer;
module.exports = function(thing, encoding, name) {
    if ($dee8c2ca129dc3ea$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $dee8c2ca129dc3ea$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $dee8c2ca129dc3ea$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("jErwR", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $e4e71b715674356f$export$bdd223f16383713e; }, function (v) { return $e4e71b715674356f$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $e4e71b715674356f$export$26e5786e8ac8e530; }, function (v) { return $e4e71b715674356f$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $e4e71b715674356f$export$2f64596b8cbf08b4; }, function (v) { return $e4e71b715674356f$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $e4e71b715674356f$export$20533d26f07f1ee0; }, function (v) { return $e4e71b715674356f$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $e4e71b715674356f$export$12ada9414fbc594c; }, function (v) { return $e4e71b715674356f$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $e4e71b715674356f$export$2ce6d8d0e8b04e1a; }, function (v) { return $e4e71b715674356f$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e4e71b715674356f$export$36b6d6ef312eab39; }, function (v) { return $e4e71b715674356f$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $e4e71b715674356f$export$f5e7e39d57cd9700; }, function (v) { return $e4e71b715674356f$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $e4e71b715674356f$export$dedd8dc3dc62b370; }, function (v) { return $e4e71b715674356f$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e4e71b715674356f$export$58a258485f1e49f6; }, function (v) { return $e4e71b715674356f$export$58a258485f1e49f6 = v; });
var $e4e71b715674356f$export$bdd223f16383713e;
var $e4e71b715674356f$export$26e5786e8ac8e530;
var $e4e71b715674356f$export$2f64596b8cbf08b4;
var $e4e71b715674356f$export$20533d26f07f1ee0;
var $e4e71b715674356f$export$12ada9414fbc594c;
var $e4e71b715674356f$export$2ce6d8d0e8b04e1a;
var $e4e71b715674356f$export$36b6d6ef312eab39;
var $e4e71b715674356f$export$f5e7e39d57cd9700;
var $e4e71b715674356f$export$dedd8dc3dc62b370;
var $e4e71b715674356f$export$58a258485f1e49f6;

var $bqrIp = parcelRequire("bqrIp");

var $c2PdS = parcelRequire("c2PdS");

var $3xDRt = parcelRequire("3xDRt");

var $4apOq = parcelRequire("4apOq");

var $bwmjr = parcelRequire("bwmjr");
function $e4e71b715674356f$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($3xDRt[suite]) {
        keyLen = $3xDRt[suite].key;
        ivLen = $3xDRt[suite].iv;
    } else if ($4apOq[suite]) {
        keyLen = $4apOq[suite].key * 8;
        ivLen = $4apOq[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bwmjr(password, false, keyLen, ivLen);
    return $e4e71b715674356f$var$createCipheriv(suite, keys.key, keys.iv);
}
function $e4e71b715674356f$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($3xDRt[suite]) {
        keyLen = $3xDRt[suite].key;
        ivLen = $3xDRt[suite].iv;
    } else if ($4apOq[suite]) {
        keyLen = $4apOq[suite].key * 8;
        ivLen = $4apOq[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bwmjr(password, false, keyLen, ivLen);
    return $e4e71b715674356f$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $e4e71b715674356f$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($3xDRt[suite]) return $c2PdS.createCipheriv(suite, key, iv);
    if ($4apOq[suite]) return new $bqrIp({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $e4e71b715674356f$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($3xDRt[suite]) return $c2PdS.createDecipheriv(suite, key, iv);
    if ($4apOq[suite]) return new $bqrIp({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $e4e71b715674356f$var$getCiphers() {
    return Object.keys($4apOq).concat($c2PdS.getCiphers());
}
$e4e71b715674356f$export$bdd223f16383713e = $e4e71b715674356f$export$26e5786e8ac8e530 = $e4e71b715674356f$var$createCipher;
$e4e71b715674356f$export$2f64596b8cbf08b4 = $e4e71b715674356f$export$20533d26f07f1ee0 = $e4e71b715674356f$var$createCipheriv;
$e4e71b715674356f$export$12ada9414fbc594c = $e4e71b715674356f$export$2ce6d8d0e8b04e1a = $e4e71b715674356f$var$createDecipher;
$e4e71b715674356f$export$36b6d6ef312eab39 = $e4e71b715674356f$export$f5e7e39d57cd9700 = $e4e71b715674356f$var$createDecipheriv;
$e4e71b715674356f$export$dedd8dc3dc62b370 = $e4e71b715674356f$export$58a258485f1e49f6 = $e4e71b715674356f$var$getCiphers;

});
parcelRegister("bqrIp", function(module, exports) {

var $2dJLz = parcelRequire("2dJLz");

var $dvc9w = parcelRequire("dvc9w");

var $5PBAa = parcelRequire("5PBAa");

var $b1nU2 = parcelRequire("b1nU2");
var $85179f15500eef3c$require$Buffer = $b1nU2.Buffer;
var $85179f15500eef3c$var$modes = {
    "des-ede3-cbc": $dvc9w.CBC.instantiate($dvc9w.EDE),
    "des-ede3": $dvc9w.EDE,
    "des-ede-cbc": $dvc9w.CBC.instantiate($dvc9w.EDE),
    "des-ede": $dvc9w.EDE,
    "des-cbc": $dvc9w.CBC.instantiate($dvc9w.DES),
    "des-ecb": $dvc9w.DES
};
$85179f15500eef3c$var$modes.des = $85179f15500eef3c$var$modes["des-cbc"];
$85179f15500eef3c$var$modes.des3 = $85179f15500eef3c$var$modes["des-ede3-cbc"];
module.exports = $85179f15500eef3c$var$DES;
$5PBAa($85179f15500eef3c$var$DES, $2dJLz);
function $85179f15500eef3c$var$DES(opts) {
    $2dJLz.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $85179f15500eef3c$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$85179f15500eef3c$require$Buffer.isBuffer(key)) key = $85179f15500eef3c$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $85179f15500eef3c$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$85179f15500eef3c$require$Buffer.isBuffer(iv)) iv = $85179f15500eef3c$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$85179f15500eef3c$var$DES.prototype._update = function(data) {
    return $85179f15500eef3c$require$Buffer.from(this._des.update(data));
};
$85179f15500eef3c$var$DES.prototype._final = function() {
    return $85179f15500eef3c$require$Buffer.from(this._des.final());
};

});
parcelRegister("dvc9w", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $9d4798d64404d0ef$export$cc8859615686b300; }, function (v) { return $9d4798d64404d0ef$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $9d4798d64404d0ef$export$8ad3f227af08fcc5; }, function (v) { return $9d4798d64404d0ef$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $9d4798d64404d0ef$export$947646e34766044f; }, function (v) { return $9d4798d64404d0ef$export$947646e34766044f = v; });
var $9d4798d64404d0ef$export$eab97d15b1788b8d;
var $9d4798d64404d0ef$export$26e5786e8ac8e530;
var $9d4798d64404d0ef$export$cc8859615686b300;
var $9d4798d64404d0ef$export$8ad3f227af08fcc5;
var $9d4798d64404d0ef$export$947646e34766044f;
"use strict";

$9d4798d64404d0ef$export$eab97d15b1788b8d = (parcelRequire("bejoK"));

$9d4798d64404d0ef$export$26e5786e8ac8e530 = (parcelRequire("8ciD7"));

$9d4798d64404d0ef$export$cc8859615686b300 = (parcelRequire("4wejw"));

$9d4798d64404d0ef$export$8ad3f227af08fcc5 = (parcelRequire("eQHx3"));

$9d4798d64404d0ef$export$947646e34766044f = (parcelRequire("dsJEz"));

});
parcelRegister("bejoK", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $82d00c9820a6cb8c$export$cfaef8ed399428b0; }, function (v) { return $82d00c9820a6cb8c$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $82d00c9820a6cb8c$export$a80c7deaea7cbd80; }, function (v) { return $82d00c9820a6cb8c$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $82d00c9820a6cb8c$export$ed7577ae6e1cd0ef; }, function (v) { return $82d00c9820a6cb8c$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $82d00c9820a6cb8c$export$5dcbef3aa594f567; }, function (v) { return $82d00c9820a6cb8c$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $82d00c9820a6cb8c$export$5bc8001ca71ed9c5; }, function (v) { return $82d00c9820a6cb8c$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $82d00c9820a6cb8c$export$3e714e2c5d5d8cb2; }, function (v) { return $82d00c9820a6cb8c$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $82d00c9820a6cb8c$export$94c3e544fd062b7f; }, function (v) { return $82d00c9820a6cb8c$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $82d00c9820a6cb8c$export$9f77e0932fb78f72; }, function (v) { return $82d00c9820a6cb8c$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $82d00c9820a6cb8c$export$d865ce2836f5927f; }, function (v) { return $82d00c9820a6cb8c$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $82d00c9820a6cb8c$export$95e62ad65da8b7d2; }, function (v) { return $82d00c9820a6cb8c$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $82d00c9820a6cb8c$export$209139ff098c441a; }, function (v) { return $82d00c9820a6cb8c$export$209139ff098c441a = v; });
var $82d00c9820a6cb8c$export$cfaef8ed399428b0;
var $82d00c9820a6cb8c$export$a80c7deaea7cbd80;
var $82d00c9820a6cb8c$export$ed7577ae6e1cd0ef;
var $82d00c9820a6cb8c$export$5dcbef3aa594f567;
var $82d00c9820a6cb8c$export$5bc8001ca71ed9c5;
var $82d00c9820a6cb8c$export$3e714e2c5d5d8cb2;
var $82d00c9820a6cb8c$export$94c3e544fd062b7f;
var $82d00c9820a6cb8c$export$9f77e0932fb78f72;
var $82d00c9820a6cb8c$export$d865ce2836f5927f;
var $82d00c9820a6cb8c$export$95e62ad65da8b7d2;
var $82d00c9820a6cb8c$export$209139ff098c441a;
"use strict";
$82d00c9820a6cb8c$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$82d00c9820a6cb8c$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$82d00c9820a6cb8c$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$82d00c9820a6cb8c$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$82d00c9820a6cb8c$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$82d00c9820a6cb8c$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $82d00c9820a6cb8c$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$82d00c9820a6cb8c$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $82d00c9820a6cb8c$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $82d00c9820a6cb8c$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $82d00c9820a6cb8c$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $82d00c9820a6cb8c$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$82d00c9820a6cb8c$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $82d00c9820a6cb8c$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$82d00c9820a6cb8c$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $82d00c9820a6cb8c$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $82d00c9820a6cb8c$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $82d00c9820a6cb8c$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$82d00c9820a6cb8c$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $82d00c9820a6cb8c$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $82d00c9820a6cb8c$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$82d00c9820a6cb8c$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("8ciD7", function(module, exports) {
"use strict";

var $cnNYx = parcelRequire("cnNYx");
function $5f7de54077530d54$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $5f7de54077530d54$var$Cipher;
$5f7de54077530d54$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$5f7de54077530d54$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$5f7de54077530d54$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$5f7de54077530d54$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$5f7de54077530d54$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$5f7de54077530d54$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$5f7de54077530d54$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$5f7de54077530d54$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$5f7de54077530d54$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$5f7de54077530d54$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$5f7de54077530d54$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $cnNYx.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("cnNYx", function(module, exports) {
module.exports = $903e6619cc5e1c07$var$assert;
function $903e6619cc5e1c07$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$903e6619cc5e1c07$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("4wejw", function(module, exports) {
"use strict";

var $cnNYx = parcelRequire("cnNYx");

var $5PBAa = parcelRequire("5PBAa");

var $bejoK = parcelRequire("bejoK");

var $8ciD7 = parcelRequire("8ciD7");
function $34a5410273727182$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $34a5410273727182$var$DES(options) {
    $8ciD7.call(this, options);
    var state = new $34a5410273727182$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$5PBAa($34a5410273727182$var$DES, $8ciD7);
module.exports = $34a5410273727182$var$DES;
$34a5410273727182$var$DES.create = function create(options) {
    return new $34a5410273727182$var$DES(options);
};
var $34a5410273727182$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$34a5410273727182$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $cnNYx.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $bejoK.readUInt32BE(key, 0);
    var kR = $bejoK.readUInt32BE(key, 4);
    $bejoK.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $34a5410273727182$var$shiftTable[i >>> 1];
        kL = $bejoK.r28shl(kL, shift);
        kR = $bejoK.r28shl(kR, shift);
        $bejoK.pc2(kL, kR, state.keys, i);
    }
};
$34a5410273727182$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $bejoK.readUInt32BE(inp, inOff);
    var r = $bejoK.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $bejoK.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $bejoK.writeUInt32BE(out, l, outOff);
    $bejoK.writeUInt32BE(out, r, outOff + 4);
};
$34a5410273727182$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$34a5410273727182$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$cnNYx.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$34a5410273727182$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $bejoK.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $bejoK.substitute(keyL, keyR);
        var f = $bejoK.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $bejoK.rip(r, l, out, off);
};
$34a5410273727182$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $bejoK.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $bejoK.substitute(keyL, keyR);
        var f = $bejoK.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $bejoK.rip(l, r, out, off);
};

});

parcelRegister("eQHx3", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $02ca30448f60c6de$export$f9bb8d20ccc7477a; }, function (v) { return $02ca30448f60c6de$export$f9bb8d20ccc7477a = v; });
var $02ca30448f60c6de$export$f9bb8d20ccc7477a;
"use strict";

var $cnNYx = parcelRequire("cnNYx");

var $5PBAa = parcelRequire("5PBAa");
var $02ca30448f60c6de$var$proto = {};
function $02ca30448f60c6de$var$CBCState(iv) {
    $cnNYx.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $02ca30448f60c6de$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $5PBAa(CBC, Base);
    var keys = Object.keys($02ca30448f60c6de$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $02ca30448f60c6de$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$02ca30448f60c6de$export$f9bb8d20ccc7477a = $02ca30448f60c6de$var$instantiate;
$02ca30448f60c6de$var$proto._cbcInit = function _cbcInit() {
    var state = new $02ca30448f60c6de$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$02ca30448f60c6de$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("dsJEz", function(module, exports) {
"use strict";

var $cnNYx = parcelRequire("cnNYx");

var $5PBAa = parcelRequire("5PBAa");

var $8ciD7 = parcelRequire("8ciD7");

var $4wejw = parcelRequire("4wejw");
function $9cd14db07098f3e3$var$EDEState(type, key) {
    $cnNYx.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $4wejw.create({
            type: "encrypt",
            key: k1
        }),
        $4wejw.create({
            type: "decrypt",
            key: k2
        }),
        $4wejw.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $4wejw.create({
            type: "decrypt",
            key: k3
        }),
        $4wejw.create({
            type: "encrypt",
            key: k2
        }),
        $4wejw.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $9cd14db07098f3e3$var$EDE(options) {
    $8ciD7.call(this, options);
    var state = new $9cd14db07098f3e3$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$5PBAa($9cd14db07098f3e3$var$EDE, $8ciD7);
module.exports = $9cd14db07098f3e3$var$EDE;
$9cd14db07098f3e3$var$EDE.create = function create(options) {
    return new $9cd14db07098f3e3$var$EDE(options);
};
$9cd14db07098f3e3$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$9cd14db07098f3e3$var$EDE.prototype._pad = $4wejw.prototype._pad;
$9cd14db07098f3e3$var$EDE.prototype._unpad = $4wejw.prototype._unpad;

});



parcelRegister("c2PdS", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $8c4d67ba8bae7056$export$2f64596b8cbf08b4; }, function (v) { return $8c4d67ba8bae7056$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $8c4d67ba8bae7056$export$36b6d6ef312eab39; }, function (v) { return $8c4d67ba8bae7056$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $8c4d67ba8bae7056$export$58a258485f1e49f6; }, function (v) { return $8c4d67ba8bae7056$export$58a258485f1e49f6 = v; });
var $8c4d67ba8bae7056$export$bdd223f16383713e;
var $8c4d67ba8bae7056$export$26e5786e8ac8e530;
var $8c4d67ba8bae7056$export$2f64596b8cbf08b4;
var $8c4d67ba8bae7056$export$20533d26f07f1ee0;
var $8c4d67ba8bae7056$export$12ada9414fbc594c;
var $8c4d67ba8bae7056$export$2ce6d8d0e8b04e1a;
var $8c4d67ba8bae7056$export$36b6d6ef312eab39;
var $8c4d67ba8bae7056$export$f5e7e39d57cd9700;
var $8c4d67ba8bae7056$export$dedd8dc3dc62b370;
var $8c4d67ba8bae7056$export$58a258485f1e49f6;

var $612hy = parcelRequire("612hy");

var $lQ9l6 = parcelRequire("lQ9l6");

var $cP0Um = parcelRequire("cP0Um");
function $8c4d67ba8bae7056$var$getCiphers() {
    return Object.keys($cP0Um);
}
$8c4d67ba8bae7056$export$bdd223f16383713e = $8c4d67ba8bae7056$export$26e5786e8ac8e530 = $612hy.createCipher;
$8c4d67ba8bae7056$export$2f64596b8cbf08b4 = $8c4d67ba8bae7056$export$20533d26f07f1ee0 = $612hy.createCipheriv;
$8c4d67ba8bae7056$export$12ada9414fbc594c = $8c4d67ba8bae7056$export$2ce6d8d0e8b04e1a = $lQ9l6.createDecipher;
$8c4d67ba8bae7056$export$36b6d6ef312eab39 = $8c4d67ba8bae7056$export$f5e7e39d57cd9700 = $lQ9l6.createDecipheriv;
$8c4d67ba8bae7056$export$dedd8dc3dc62b370 = $8c4d67ba8bae7056$export$58a258485f1e49f6 = $8c4d67ba8bae7056$var$getCiphers;

});
parcelRegister("612hy", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $46149b4580efeee9$export$2f64596b8cbf08b4; }, function (v) { return $46149b4580efeee9$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $46149b4580efeee9$export$bdd223f16383713e; }, function (v) { return $46149b4580efeee9$export$bdd223f16383713e = v; });
var $46149b4580efeee9$export$2f64596b8cbf08b4;
var $46149b4580efeee9$export$bdd223f16383713e;

var $3xDRt = parcelRequire("3xDRt");

var $g4mlo = parcelRequire("g4mlo");

var $b1nU2 = parcelRequire("b1nU2");
var $46149b4580efeee9$require$Buffer = $b1nU2.Buffer;

var $g0Pbc = parcelRequire("g0Pbc");

var $2dJLz = parcelRequire("2dJLz");

var $lT4p1 = parcelRequire("lT4p1");

var $bwmjr = parcelRequire("bwmjr");

var $5PBAa = parcelRequire("5PBAa");
function $46149b4580efeee9$var$Cipher(mode, key, iv) {
    $2dJLz.call(this);
    this._cache = new $46149b4580efeee9$var$Splitter();
    this._cipher = new $lT4p1.AES(key);
    this._prev = $46149b4580efeee9$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$5PBAa($46149b4580efeee9$var$Cipher, $2dJLz);
$46149b4580efeee9$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $46149b4580efeee9$require$Buffer.concat(out);
};
var $46149b4580efeee9$var$PADDING = $46149b4580efeee9$require$Buffer.alloc(16, 0x10);
$46149b4580efeee9$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($46149b4580efeee9$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$46149b4580efeee9$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $46149b4580efeee9$var$Splitter() {
    this.cache = $46149b4580efeee9$require$Buffer.allocUnsafe(0);
}
$46149b4580efeee9$var$Splitter.prototype.add = function(data) {
    this.cache = $46149b4580efeee9$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$46149b4580efeee9$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$46149b4580efeee9$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $46149b4580efeee9$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $46149b4580efeee9$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $46149b4580efeee9$var$createCipheriv(suite, password, iv) {
    var config = $3xDRt[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $46149b4580efeee9$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $46149b4580efeee9$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $g0Pbc(config.module, password, iv);
    else if (config.type === "auth") return new $g4mlo(config.module, password, iv);
    return new $46149b4580efeee9$var$Cipher(config.module, password, iv);
}
function $46149b4580efeee9$var$createCipher(suite, password) {
    var config = $3xDRt[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bwmjr(password, false, config.key, config.iv);
    return $46149b4580efeee9$var$createCipheriv(suite, keys.key, keys.iv);
}
$46149b4580efeee9$export$2f64596b8cbf08b4 = $46149b4580efeee9$var$createCipheriv;
$46149b4580efeee9$export$bdd223f16383713e = $46149b4580efeee9$var$createCipher;

});
parcelRegister("3xDRt", function(module, exports) {








var $29435fce2e327635$var$modeModules = {
    ECB: (parcelRequire("2iopw")),
    CBC: (parcelRequire("gZUW2")),
    CFB: (parcelRequire("8AsTE")),
    CFB8: (parcelRequire("1ixoi")),
    CFB1: (parcelRequire("ixZPS")),
    OFB: (parcelRequire("10CQy")),
    CTR: (parcelRequire("jOeGa")),
    GCM: (parcelRequire("jOeGa"))
};

var $cP0Um = parcelRequire("cP0Um");
for(var $29435fce2e327635$var$key in $cP0Um)$cP0Um[$29435fce2e327635$var$key].module = $29435fce2e327635$var$modeModules[$cP0Um[$29435fce2e327635$var$key].mode];
module.exports = $cP0Um;

});
parcelRegister("2iopw", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1ac032a67b709e24$export$5b0f6292f11d1d18; }, function (v) { return $1ac032a67b709e24$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $1ac032a67b709e24$export$e85a0c9a1067c5d3; }, function (v) { return $1ac032a67b709e24$export$e85a0c9a1067c5d3 = v; });
var $1ac032a67b709e24$export$5b0f6292f11d1d18;
var $1ac032a67b709e24$export$e85a0c9a1067c5d3;
$1ac032a67b709e24$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$1ac032a67b709e24$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("gZUW2", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c5fe81f9211e70d6$export$5b0f6292f11d1d18; }, function (v) { return $c5fe81f9211e70d6$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $c5fe81f9211e70d6$export$e85a0c9a1067c5d3; }, function (v) { return $c5fe81f9211e70d6$export$e85a0c9a1067c5d3 = v; });
var $c5fe81f9211e70d6$export$5b0f6292f11d1d18;
var $c5fe81f9211e70d6$export$e85a0c9a1067c5d3;

var $j1yXU = parcelRequire("j1yXU");
$c5fe81f9211e70d6$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $j1yXU(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$c5fe81f9211e70d6$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $j1yXU(out, pad);
};

});
parcelRegister("j1yXU", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $dd993bb681afd8a6$require$Buffer = $ilnag.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $dd993bb681afd8a6$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("8AsTE", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $640819ca77629d65$export$5b0f6292f11d1d18; }, function (v) { return $640819ca77629d65$export$5b0f6292f11d1d18 = v; });
var $640819ca77629d65$export$5b0f6292f11d1d18;

var $b1nU2 = parcelRequire("b1nU2");
var $640819ca77629d65$require$Buffer = $b1nU2.Buffer;

var $j1yXU = parcelRequire("j1yXU");
function $640819ca77629d65$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $j1yXU(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $640819ca77629d65$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$640819ca77629d65$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $640819ca77629d65$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $640819ca77629d65$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $640819ca77629d65$require$Buffer.concat([
                out,
                $640819ca77629d65$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $640819ca77629d65$require$Buffer.concat([
                out,
                $640819ca77629d65$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("1ixoi", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0f215fa183cd3eaf$export$5b0f6292f11d1d18; }, function (v) { return $0f215fa183cd3eaf$export$5b0f6292f11d1d18 = v; });
var $0f215fa183cd3eaf$export$5b0f6292f11d1d18;

var $b1nU2 = parcelRequire("b1nU2");
var $0f215fa183cd3eaf$require$Buffer = $b1nU2.Buffer;
function $0f215fa183cd3eaf$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $0f215fa183cd3eaf$require$Buffer.concat([
        self._prev.slice(1),
        $0f215fa183cd3eaf$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$0f215fa183cd3eaf$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $0f215fa183cd3eaf$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $0f215fa183cd3eaf$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("ixZPS", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $d80b46593ec88936$export$5b0f6292f11d1d18; }, function (v) { return $d80b46593ec88936$export$5b0f6292f11d1d18 = v; });
var $d80b46593ec88936$export$5b0f6292f11d1d18;

var $b1nU2 = parcelRequire("b1nU2");
var $d80b46593ec88936$require$Buffer = $b1nU2.Buffer;
function $d80b46593ec88936$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $d80b46593ec88936$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $d80b46593ec88936$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $d80b46593ec88936$require$Buffer.allocUnsafe(buffer.length);
    buffer = $d80b46593ec88936$require$Buffer.concat([
        buffer,
        $d80b46593ec88936$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$d80b46593ec88936$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $d80b46593ec88936$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $d80b46593ec88936$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("10CQy", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0bc3eca49df6c1b5$export$5b0f6292f11d1d18; }, function (v) { return $0bc3eca49df6c1b5$export$5b0f6292f11d1d18 = v; });
var $0bc3eca49df6c1b5$export$5b0f6292f11d1d18;

var $ilnag = parcelRequire("ilnag");
var $0bc3eca49df6c1b5$require$Buffer = $ilnag.Buffer;

var $j1yXU = parcelRequire("j1yXU");
function $0bc3eca49df6c1b5$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$0bc3eca49df6c1b5$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $0bc3eca49df6c1b5$require$Buffer.concat([
        self._cache,
        $0bc3eca49df6c1b5$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $j1yXU(chunk, pad);
};

});

parcelRegister("jOeGa", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $e6be12cefff7a20a$export$5b0f6292f11d1d18; }, function (v) { return $e6be12cefff7a20a$export$5b0f6292f11d1d18 = v; });
var $e6be12cefff7a20a$export$5b0f6292f11d1d18;

var $j1yXU = parcelRequire("j1yXU");

var $b1nU2 = parcelRequire("b1nU2");
var $e6be12cefff7a20a$require$Buffer = $b1nU2.Buffer;

var $ecGgG = parcelRequire("ecGgG");
function $e6be12cefff7a20a$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $ecGgG(self._prev);
    return out;
}
var $e6be12cefff7a20a$var$blockSize = 16;
$e6be12cefff7a20a$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $e6be12cefff7a20a$var$blockSize);
    var start = self._cache.length;
    self._cache = $e6be12cefff7a20a$require$Buffer.concat([
        self._cache,
        $e6be12cefff7a20a$require$Buffer.allocUnsafe(chunkNum * $e6be12cefff7a20a$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $e6be12cefff7a20a$var$getBlock(self);
        var offset = start + i * $e6be12cefff7a20a$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $j1yXU(chunk, pad);
};

});
parcelRegister("ecGgG", function(module, exports) {
function $a572f93a74a4c356$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $a572f93a74a4c356$var$incr32;

});


parcelRegister("cP0Um", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("g4mlo", function(module, exports) {

var $lT4p1 = parcelRequire("lT4p1");

var $b1nU2 = parcelRequire("b1nU2");
var $bb2e5a1c2b77a423$require$Buffer = $b1nU2.Buffer;

var $2dJLz = parcelRequire("2dJLz");

var $5PBAa = parcelRequire("5PBAa");

var $2tO3U = parcelRequire("2tO3U");

var $j1yXU = parcelRequire("j1yXU");

var $ecGgG = parcelRequire("ecGgG");
function $bb2e5a1c2b77a423$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $bb2e5a1c2b77a423$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $bb2e5a1c2b77a423$require$Buffer.concat([
            iv,
            $bb2e5a1c2b77a423$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $bb2e5a1c2b77a423$require$Buffer.concat([
            iv,
            $bb2e5a1c2b77a423$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $2tO3U(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($bb2e5a1c2b77a423$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($bb2e5a1c2b77a423$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $bb2e5a1c2b77a423$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $bb2e5a1c2b77a423$require$Buffer.from(self._finID);
    $ecGgG(out);
    return out;
}
function $bb2e5a1c2b77a423$var$StreamCipher(mode, key, iv, decrypt) {
    $2dJLz.call(this);
    var h = $bb2e5a1c2b77a423$require$Buffer.alloc(4, 0);
    this._cipher = new $lT4p1.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $2tO3U(ck);
    iv = $bb2e5a1c2b77a423$var$calcIv(this, iv, ck);
    this._prev = $bb2e5a1c2b77a423$require$Buffer.from(iv);
    this._cache = $bb2e5a1c2b77a423$require$Buffer.allocUnsafe(0);
    this._secCache = $bb2e5a1c2b77a423$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$5PBAa($bb2e5a1c2b77a423$var$StreamCipher, $2dJLz);
$bb2e5a1c2b77a423$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $bb2e5a1c2b77a423$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$bb2e5a1c2b77a423$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $j1yXU(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $bb2e5a1c2b77a423$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$bb2e5a1c2b77a423$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$bb2e5a1c2b77a423$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$bb2e5a1c2b77a423$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$bb2e5a1c2b77a423$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $bb2e5a1c2b77a423$var$StreamCipher;

});
parcelRegister("lT4p1", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $fef22648b1f00716$export$b80fbe1c3a2b92b5; }, function (v) { return $fef22648b1f00716$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $fef22648b1f00716$export$b80fbe1c3a2b92b5;

var $b1nU2 = parcelRequire("b1nU2");
var $fef22648b1f00716$require$Buffer = $b1nU2.Buffer;
function $fef22648b1f00716$var$asUInt32Array(buf) {
    if (!$fef22648b1f00716$require$Buffer.isBuffer(buf)) buf = $fef22648b1f00716$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $fef22648b1f00716$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $fef22648b1f00716$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $fef22648b1f00716$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $fef22648b1f00716$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $fef22648b1f00716$var$AES(key) {
    this._key = $fef22648b1f00716$var$asUInt32Array(key);
    this._reset();
}
$fef22648b1f00716$var$AES.blockSize = 16;
$fef22648b1f00716$var$AES.keySize = 32;
$fef22648b1f00716$var$AES.prototype.blockSize = $fef22648b1f00716$var$AES.blockSize;
$fef22648b1f00716$var$AES.prototype.keySize = $fef22648b1f00716$var$AES.keySize;
$fef22648b1f00716$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $fef22648b1f00716$var$G.SBOX[t >>> 24] << 24 | $fef22648b1f00716$var$G.SBOX[t >>> 16 & 0xff] << 16 | $fef22648b1f00716$var$G.SBOX[t >>> 8 & 0xff] << 8 | $fef22648b1f00716$var$G.SBOX[t & 0xff];
            t ^= $fef22648b1f00716$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $fef22648b1f00716$var$G.SBOX[t >>> 24] << 24 | $fef22648b1f00716$var$G.SBOX[t >>> 16 & 0xff] << 16 | $fef22648b1f00716$var$G.SBOX[t >>> 8 & 0xff] << 8 | $fef22648b1f00716$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $fef22648b1f00716$var$G.INV_SUB_MIX[0][$fef22648b1f00716$var$G.SBOX[tt >>> 24]] ^ $fef22648b1f00716$var$G.INV_SUB_MIX[1][$fef22648b1f00716$var$G.SBOX[tt >>> 16 & 0xff]] ^ $fef22648b1f00716$var$G.INV_SUB_MIX[2][$fef22648b1f00716$var$G.SBOX[tt >>> 8 & 0xff]] ^ $fef22648b1f00716$var$G.INV_SUB_MIX[3][$fef22648b1f00716$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$fef22648b1f00716$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $fef22648b1f00716$var$asUInt32Array(M);
    return $fef22648b1f00716$var$cryptBlock(M, this._keySchedule, $fef22648b1f00716$var$G.SUB_MIX, $fef22648b1f00716$var$G.SBOX, this._nRounds);
};
$fef22648b1f00716$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $fef22648b1f00716$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$fef22648b1f00716$var$AES.prototype.decryptBlock = function(M) {
    M = $fef22648b1f00716$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $fef22648b1f00716$var$cryptBlock(M, this._invKeySchedule, $fef22648b1f00716$var$G.INV_SUB_MIX, $fef22648b1f00716$var$G.INV_SBOX, this._nRounds);
    var buf = $fef22648b1f00716$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$fef22648b1f00716$var$AES.prototype.scrub = function() {
    $fef22648b1f00716$var$scrubVec(this._keySchedule);
    $fef22648b1f00716$var$scrubVec(this._invKeySchedule);
    $fef22648b1f00716$var$scrubVec(this._key);
};
$fef22648b1f00716$export$b80fbe1c3a2b92b5 = $fef22648b1f00716$var$AES;

});

parcelRegister("2tO3U", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $1ce51f8174a08b44$require$Buffer = $b1nU2.Buffer;
var $1ce51f8174a08b44$var$ZEROES = $1ce51f8174a08b44$require$Buffer.alloc(16, 0);
function $1ce51f8174a08b44$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $1ce51f8174a08b44$var$fromArray(out) {
    var buf = $1ce51f8174a08b44$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $1ce51f8174a08b44$var$GHASH(key) {
    this.h = key;
    this.state = $1ce51f8174a08b44$require$Buffer.alloc(16, 0);
    this.cache = $1ce51f8174a08b44$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$1ce51f8174a08b44$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$1ce51f8174a08b44$var$GHASH.prototype._multiply = function() {
    var Vi = $1ce51f8174a08b44$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $1ce51f8174a08b44$var$fromArray(Zi);
};
$1ce51f8174a08b44$var$GHASH.prototype.update = function(buf) {
    this.cache = $1ce51f8174a08b44$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$1ce51f8174a08b44$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($1ce51f8174a08b44$require$Buffer.concat([
        this.cache,
        $1ce51f8174a08b44$var$ZEROES
    ], 16));
    this.ghash($1ce51f8174a08b44$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $1ce51f8174a08b44$var$GHASH;

});


parcelRegister("g0Pbc", function(module, exports) {

var $lT4p1 = parcelRequire("lT4p1");

var $b1nU2 = parcelRequire("b1nU2");
var $ba8458a828d89f91$require$Buffer = $b1nU2.Buffer;

var $2dJLz = parcelRequire("2dJLz");

var $5PBAa = parcelRequire("5PBAa");
function $ba8458a828d89f91$var$StreamCipher(mode, key, iv, decrypt) {
    $2dJLz.call(this);
    this._cipher = new $lT4p1.AES(key);
    this._prev = $ba8458a828d89f91$require$Buffer.from(iv);
    this._cache = $ba8458a828d89f91$require$Buffer.allocUnsafe(0);
    this._secCache = $ba8458a828d89f91$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$5PBAa($ba8458a828d89f91$var$StreamCipher, $2dJLz);
$ba8458a828d89f91$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ba8458a828d89f91$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ba8458a828d89f91$var$StreamCipher;

});

parcelRegister("bwmjr", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $8633fda80bee62f5$require$Buffer = $b1nU2.Buffer;

var $1GvVx = parcelRequire("1GvVx");
/* eslint-disable camelcase */ function $8633fda80bee62f5$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8633fda80bee62f5$require$Buffer.isBuffer(password)) password = $8633fda80bee62f5$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8633fda80bee62f5$require$Buffer.isBuffer(salt)) salt = $8633fda80bee62f5$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8633fda80bee62f5$require$Buffer.alloc(keyLen);
    var iv = $8633fda80bee62f5$require$Buffer.alloc(ivLen || 0);
    var tmp = $8633fda80bee62f5$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $1GvVx();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8633fda80bee62f5$var$EVP_BytesToKey;

});


parcelRegister("lQ9l6", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $fe65b2ecbd63fad6$export$12ada9414fbc594c; }, function (v) { return $fe65b2ecbd63fad6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $fe65b2ecbd63fad6$export$36b6d6ef312eab39; }, function (v) { return $fe65b2ecbd63fad6$export$36b6d6ef312eab39 = v; });
var $fe65b2ecbd63fad6$export$12ada9414fbc594c;
var $fe65b2ecbd63fad6$export$36b6d6ef312eab39;

var $g4mlo = parcelRequire("g4mlo");

var $b1nU2 = parcelRequire("b1nU2");
var $fe65b2ecbd63fad6$require$Buffer = $b1nU2.Buffer;

var $3xDRt = parcelRequire("3xDRt");

var $g0Pbc = parcelRequire("g0Pbc");

var $2dJLz = parcelRequire("2dJLz");

var $lT4p1 = parcelRequire("lT4p1");

var $bwmjr = parcelRequire("bwmjr");

var $5PBAa = parcelRequire("5PBAa");
function $fe65b2ecbd63fad6$var$Decipher(mode, key, iv) {
    $2dJLz.call(this);
    this._cache = new $fe65b2ecbd63fad6$var$Splitter();
    this._last = void 0;
    this._cipher = new $lT4p1.AES(key);
    this._prev = $fe65b2ecbd63fad6$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$5PBAa($fe65b2ecbd63fad6$var$Decipher, $2dJLz);
$fe65b2ecbd63fad6$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $fe65b2ecbd63fad6$require$Buffer.concat(out);
};
$fe65b2ecbd63fad6$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $fe65b2ecbd63fad6$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$fe65b2ecbd63fad6$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $fe65b2ecbd63fad6$var$Splitter() {
    this.cache = $fe65b2ecbd63fad6$require$Buffer.allocUnsafe(0);
}
$fe65b2ecbd63fad6$var$Splitter.prototype.add = function(data) {
    this.cache = $fe65b2ecbd63fad6$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$fe65b2ecbd63fad6$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$fe65b2ecbd63fad6$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $fe65b2ecbd63fad6$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $fe65b2ecbd63fad6$var$createDecipheriv(suite, password, iv) {
    var config = $3xDRt[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $fe65b2ecbd63fad6$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $fe65b2ecbd63fad6$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $g0Pbc(config.module, password, iv, true);
    else if (config.type === "auth") return new $g4mlo(config.module, password, iv, true);
    return new $fe65b2ecbd63fad6$var$Decipher(config.module, password, iv);
}
function $fe65b2ecbd63fad6$var$createDecipher(suite, password) {
    var config = $3xDRt[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bwmjr(password, false, config.key, config.iv);
    return $fe65b2ecbd63fad6$var$createDecipheriv(suite, keys.key, keys.iv);
}
$fe65b2ecbd63fad6$export$12ada9414fbc594c = $fe65b2ecbd63fad6$var$createDecipher;
$fe65b2ecbd63fad6$export$36b6d6ef312eab39 = $fe65b2ecbd63fad6$var$createDecipheriv;

});


parcelRegister("4apOq", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $308c1e661e86469f$export$116f8a5cee447347; }, function (v) { return $308c1e661e86469f$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $308c1e661e86469f$export$7483c4066bfb7ae9; }, function (v) { return $308c1e661e86469f$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $308c1e661e86469f$export$e7a565d2e588bb06; }, function (v) { return $308c1e661e86469f$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $308c1e661e86469f$export$aaa2f54a426f3eb8; }, function (v) { return $308c1e661e86469f$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $308c1e661e86469f$export$eba20568dde4ada; }, function (v) { return $308c1e661e86469f$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $308c1e661e86469f$export$d3b5e5996938f5ae; }, function (v) { return $308c1e661e86469f$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $308c1e661e86469f$export$57c08356130bc99b; }, function (v) { return $308c1e661e86469f$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $308c1e661e86469f$export$c7169791d5c1e65d; }, function (v) { return $308c1e661e86469f$export$c7169791d5c1e65d = v; });
var $308c1e661e86469f$export$116f8a5cee447347;
var $308c1e661e86469f$export$7483c4066bfb7ae9;
var $308c1e661e86469f$export$e7a565d2e588bb06;
var $308c1e661e86469f$export$aaa2f54a426f3eb8;
var $308c1e661e86469f$export$eba20568dde4ada;
var $308c1e661e86469f$export$d3b5e5996938f5ae;
var $308c1e661e86469f$export$57c08356130bc99b;
var $308c1e661e86469f$export$c7169791d5c1e65d;
$308c1e661e86469f$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$308c1e661e86469f$export$7483c4066bfb7ae9 = $308c1e661e86469f$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$308c1e661e86469f$export$aaa2f54a426f3eb8 = $308c1e661e86469f$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$308c1e661e86469f$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$308c1e661e86469f$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$308c1e661e86469f$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("ey6om", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $a97932f2752c8bbf$export$971862a2fcb1bb40; }, function (v) { return $a97932f2752c8bbf$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $a97932f2752c8bbf$export$c6ff6a88acbeaf40; }, function (v) { return $a97932f2752c8bbf$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $a97932f2752c8bbf$export$fdc27893e98845cc; }, function (v) { return $a97932f2752c8bbf$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $a97932f2752c8bbf$export$6671fb9a1323bed; }, function (v) { return $a97932f2752c8bbf$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $a97932f2752c8bbf$export$d74daf141a551db; }, function (v) { return $a97932f2752c8bbf$export$d74daf141a551db = v; });
var $a97932f2752c8bbf$export$971862a2fcb1bb40;
var $a97932f2752c8bbf$export$c6ff6a88acbeaf40;
var $a97932f2752c8bbf$export$fdc27893e98845cc;
var $a97932f2752c8bbf$export$6671fb9a1323bed;
var $a97932f2752c8bbf$export$d74daf141a551db;

var $ilnag = parcelRequire("ilnag");
var $a97932f2752c8bbf$require$Buffer = $ilnag.Buffer;

var $7epUi = parcelRequire("7epUi");

var $egPrR = parcelRequire("egPrR");

var $kh4C4 = parcelRequire("kh4C4");
function $a97932f2752c8bbf$var$getDiffieHellman(mod) {
    var prime = new $a97932f2752c8bbf$require$Buffer($egPrR[mod].prime, "hex");
    var gen = new $a97932f2752c8bbf$require$Buffer($egPrR[mod].gen, "hex");
    return new $kh4C4(prime, gen);
}
var $a97932f2752c8bbf$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $a97932f2752c8bbf$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($a97932f2752c8bbf$require$Buffer.isBuffer(enc) || $a97932f2752c8bbf$var$ENCODINGS[enc] === undefined) return $a97932f2752c8bbf$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $a97932f2752c8bbf$require$Buffer([
        2
    ]);
    if (!$a97932f2752c8bbf$require$Buffer.isBuffer(generator)) generator = new $a97932f2752c8bbf$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $kh4C4($7epUi(prime, generator), generator, true);
    if (!$a97932f2752c8bbf$require$Buffer.isBuffer(prime)) prime = new $a97932f2752c8bbf$require$Buffer(prime, enc);
    return new $kh4C4(prime, generator, true);
}
$a97932f2752c8bbf$export$971862a2fcb1bb40 = $a97932f2752c8bbf$export$c6ff6a88acbeaf40 = $a97932f2752c8bbf$export$fdc27893e98845cc = $a97932f2752c8bbf$var$getDiffieHellman;
$a97932f2752c8bbf$export$6671fb9a1323bed = $a97932f2752c8bbf$export$d74daf141a551db = $a97932f2752c8bbf$var$createDiffieHellman;

});
parcelRegister("7epUi", function(module, exports) {

var $2gcE5 = parcelRequire("2gcE5");
module.exports = $543defcd98a7926a$var$findPrime;
$543defcd98a7926a$var$findPrime.simpleSieve = $543defcd98a7926a$var$simpleSieve;
$543defcd98a7926a$var$findPrime.fermatTest = $543defcd98a7926a$var$fermatTest;

var $42mVo = parcelRequire("42mVo");
var $543defcd98a7926a$var$TWENTYFOUR = new $42mVo(24);

var $ifXzs = parcelRequire("ifXzs");
var $543defcd98a7926a$var$millerRabin = new $ifXzs();
var $543defcd98a7926a$var$ONE = new $42mVo(1);
var $543defcd98a7926a$var$TWO = new $42mVo(2);
var $543defcd98a7926a$var$FIVE = new $42mVo(5);
var $543defcd98a7926a$var$SIXTEEN = new $42mVo(16);
var $543defcd98a7926a$var$EIGHT = new $42mVo(8);
var $543defcd98a7926a$var$TEN = new $42mVo(10);
var $543defcd98a7926a$var$THREE = new $42mVo(3);
var $543defcd98a7926a$var$SEVEN = new $42mVo(7);
var $543defcd98a7926a$var$ELEVEN = new $42mVo(11);
var $543defcd98a7926a$var$FOUR = new $42mVo(4);
var $543defcd98a7926a$var$TWELVE = new $42mVo(12);
var $543defcd98a7926a$var$primes = null;
function $543defcd98a7926a$var$_getPrimes() {
    if ($543defcd98a7926a$var$primes !== null) return $543defcd98a7926a$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $543defcd98a7926a$var$primes = res;
    return res;
}
function $543defcd98a7926a$var$simpleSieve(p) {
    var primes = $543defcd98a7926a$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $543defcd98a7926a$var$fermatTest(p) {
    var red = $42mVo.mont(p);
    return $543defcd98a7926a$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $543defcd98a7926a$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $42mVo([
            0x8c,
            0x7b
        ]);
        else return new $42mVo([
            0x8c,
            0x27
        ]);
    }
    gen = new $42mVo(gen);
    var num, n2;
    while(true){
        num = new $42mVo($2gcE5(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($543defcd98a7926a$var$ONE);
        if (!num.testn(1)) num.iadd($543defcd98a7926a$var$TWO);
        if (!gen.cmp($543defcd98a7926a$var$TWO)) while(num.mod($543defcd98a7926a$var$TWENTYFOUR).cmp($543defcd98a7926a$var$ELEVEN))num.iadd($543defcd98a7926a$var$FOUR);
        else if (!gen.cmp($543defcd98a7926a$var$FIVE)) while(num.mod($543defcd98a7926a$var$TEN).cmp($543defcd98a7926a$var$THREE))num.iadd($543defcd98a7926a$var$FOUR);
        n2 = num.shrn(1);
        if ($543defcd98a7926a$var$simpleSieve(n2) && $543defcd98a7926a$var$simpleSieve(num) && $543defcd98a7926a$var$fermatTest(n2) && $543defcd98a7926a$var$fermatTest(num) && $543defcd98a7926a$var$millerRabin.test(n2) && $543defcd98a7926a$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("42mVo", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("ifXzs", function(module, exports) {

var $42mVo = parcelRequire("42mVo");

var $ht5yF = parcelRequire("ht5yF");
function $d4a7d643fc05795c$var$MillerRabin(rand) {
    this.rand = rand || new $ht5yF.Rand();
}
module.exports = $d4a7d643fc05795c$var$MillerRabin;
$d4a7d643fc05795c$var$MillerRabin.create = function create(rand) {
    return new $d4a7d643fc05795c$var$MillerRabin(rand);
};
$d4a7d643fc05795c$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $42mVo(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$d4a7d643fc05795c$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$d4a7d643fc05795c$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $42mVo.mont(n);
    var rone = new $42mVo(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $42mVo(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$d4a7d643fc05795c$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $42mVo.mont(n);
    var rone = new $42mVo(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $42mVo(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("ht5yF", function(module, exports) {
var $cb7974d99d8d016e$var$r;
module.exports = function rand(len) {
    if (!$cb7974d99d8d016e$var$r) $cb7974d99d8d016e$var$r = new $cb7974d99d8d016e$var$Rand(null);
    return $cb7974d99d8d016e$var$r.generate(len);
};
function $cb7974d99d8d016e$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $cb7974d99d8d016e$var$Rand;
$cb7974d99d8d016e$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$cb7974d99d8d016e$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $cb7974d99d8d016e$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $cb7974d99d8d016e$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $cb7974d99d8d016e$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $cb7974d99d8d016e$var$crypto = (parcelRequire("24TKi"));
    if (typeof $cb7974d99d8d016e$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $cb7974d99d8d016e$var$Rand.prototype._rand = function _rand(n) {
        return $cb7974d99d8d016e$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("egPrR", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("kh4C4", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $ec28f93bac4fdefe$require$Buffer = $ilnag.Buffer;

var $42mVo = parcelRequire("42mVo");

var $ifXzs = parcelRequire("ifXzs");
var $ec28f93bac4fdefe$var$millerRabin = new $ifXzs();
var $ec28f93bac4fdefe$var$TWENTYFOUR = new $42mVo(24);
var $ec28f93bac4fdefe$var$ELEVEN = new $42mVo(11);
var $ec28f93bac4fdefe$var$TEN = new $42mVo(10);
var $ec28f93bac4fdefe$var$THREE = new $42mVo(3);
var $ec28f93bac4fdefe$var$SEVEN = new $42mVo(7);

var $7epUi = parcelRequire("7epUi");

var $2gcE5 = parcelRequire("2gcE5");
module.exports = $ec28f93bac4fdefe$var$DH;
function $ec28f93bac4fdefe$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$ec28f93bac4fdefe$require$Buffer.isBuffer(pub)) pub = new $ec28f93bac4fdefe$require$Buffer(pub, enc);
    this._pub = new $42mVo(pub);
    return this;
}
function $ec28f93bac4fdefe$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$ec28f93bac4fdefe$require$Buffer.isBuffer(priv)) priv = new $ec28f93bac4fdefe$require$Buffer(priv, enc);
    this._priv = new $42mVo(priv);
    return this;
}
var $ec28f93bac4fdefe$var$primeCache = {};
function $ec28f93bac4fdefe$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $ec28f93bac4fdefe$var$primeCache) return $ec28f93bac4fdefe$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7epUi.simpleSieve || !$7epUi.fermatTest(prime) || !$ec28f93bac4fdefe$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $ec28f93bac4fdefe$var$primeCache[hex] = error;
        return error;
    }
    if (!$ec28f93bac4fdefe$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($ec28f93bac4fdefe$var$TWENTYFOUR).cmp($ec28f93bac4fdefe$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($ec28f93bac4fdefe$var$TEN);
            if (rem.cmp($ec28f93bac4fdefe$var$THREE) && rem.cmp($ec28f93bac4fdefe$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $ec28f93bac4fdefe$var$primeCache[hex] = error;
    return error;
}
function $ec28f93bac4fdefe$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $42mVo(prime);
    this._prime = $42mVo.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $ec28f93bac4fdefe$var$setPublicKey;
        this.setPrivateKey = $ec28f93bac4fdefe$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($ec28f93bac4fdefe$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function get() {
        if (typeof this._primeCode !== "number") this._primeCode = $ec28f93bac4fdefe$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$ec28f93bac4fdefe$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $42mVo($2gcE5(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$ec28f93bac4fdefe$var$DH.prototype.computeSecret = function(other) {
    other = new $42mVo(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $ec28f93bac4fdefe$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $ec28f93bac4fdefe$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $ec28f93bac4fdefe$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$ec28f93bac4fdefe$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $ec28f93bac4fdefe$var$formatReturnValue(this._pub, enc);
};
$ec28f93bac4fdefe$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $ec28f93bac4fdefe$var$formatReturnValue(this._priv, enc);
};
$ec28f93bac4fdefe$var$DH.prototype.getPrime = function(enc) {
    return $ec28f93bac4fdefe$var$formatReturnValue(this.__prime, enc);
};
$ec28f93bac4fdefe$var$DH.prototype.getGenerator = function(enc) {
    return $ec28f93bac4fdefe$var$formatReturnValue(this._gen, enc);
};
$ec28f93bac4fdefe$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$ec28f93bac4fdefe$require$Buffer.isBuffer(gen)) gen = new $ec28f93bac4fdefe$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $42mVo(gen);
    return this;
};
function $ec28f93bac4fdefe$var$formatReturnValue(bn, enc) {
    var buf = new $ec28f93bac4fdefe$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("5HF5h", function(module, exports) {

var $b1nU2 = parcelRequire("b1nU2");
var $4270d65a8106b725$require$Buffer = $b1nU2.Buffer;

var $jMOyI = parcelRequire("jMOyI");

var $BxiJM = parcelRequire("BxiJM");

var $5PBAa = parcelRequire("5PBAa");

var $7l313 = parcelRequire("7l313");

var $boMzq = parcelRequire("boMzq");

var $j979H = parcelRequire("j979H");
Object.keys($j979H).forEach(function(key) {
    $j979H[key].id = $4270d65a8106b725$require$Buffer.from($j979H[key].id, "hex");
    $j979H[key.toLowerCase()] = $j979H[key];
});
function $4270d65a8106b725$var$Sign(algorithm) {
    $BxiJM.Writable.call(this);
    var data = $j979H[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $jMOyI(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$5PBAa($4270d65a8106b725$var$Sign, $BxiJM.Writable);
$4270d65a8106b725$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$4270d65a8106b725$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $4270d65a8106b725$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$4270d65a8106b725$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $7l313(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $4270d65a8106b725$var$Verify(algorithm) {
    $BxiJM.Writable.call(this);
    var data = $j979H[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $jMOyI(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$5PBAa($4270d65a8106b725$var$Verify, $BxiJM.Writable);
$4270d65a8106b725$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$4270d65a8106b725$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $4270d65a8106b725$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$4270d65a8106b725$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $4270d65a8106b725$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $boMzq(sig, hash, key, this._signType, this._tag);
};
function $4270d65a8106b725$var$createSign(algorithm) {
    return new $4270d65a8106b725$var$Sign(algorithm);
}
function $4270d65a8106b725$var$createVerify(algorithm) {
    return new $4270d65a8106b725$var$Verify(algorithm);
}
module.exports = {
    Sign: $4270d65a8106b725$var$createSign,
    Verify: $4270d65a8106b725$var$createVerify,
    createSign: $4270d65a8106b725$var$createSign,
    createVerify: $4270d65a8106b725$var$createVerify
};

});
parcelRegister("7l313", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $b1nU2 = parcelRequire("b1nU2");
var $557cd575a9e6e195$require$Buffer = $b1nU2.Buffer;

var $c9AEc = parcelRequire("c9AEc");

var $58VOR = parcelRequire("58VOR");

var $aW3Sp = parcelRequire("aW3Sp");
var $557cd575a9e6e195$require$EC = $aW3Sp.ec;

var $h2Lk1 = parcelRequire("h2Lk1");

var $lbG4j = parcelRequire("lbG4j");

var $6U3Hg = parcelRequire("6U3Hg");
function $557cd575a9e6e195$var$sign(hash, key, hashType, signType, tag) {
    var priv = $lbG4j(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $557cd575a9e6e195$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $557cd575a9e6e195$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $557cd575a9e6e195$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $58VOR(pad, priv);
    return out;
}
function $557cd575a9e6e195$var$ecSign(hash, priv) {
    var curveId = $6U3Hg[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $557cd575a9e6e195$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $557cd575a9e6e195$require$Buffer.from(out.toDER());
}
function $557cd575a9e6e195$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $h2Lk1(0);
    var k;
    var H = $557cd575a9e6e195$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $557cd575a9e6e195$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $557cd575a9e6e195$var$makeKey(q, kv, algo);
        r = $557cd575a9e6e195$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $h2Lk1(0);
        }
    }
    return $557cd575a9e6e195$var$toDER(r, s);
}
function $557cd575a9e6e195$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $557cd575a9e6e195$require$Buffer.from(res);
}
function $557cd575a9e6e195$var$getKey(x, q, hash, algo) {
    x = $557cd575a9e6e195$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $557cd575a9e6e195$require$Buffer.alloc(q.byteLength() - x.length);
        x = $557cd575a9e6e195$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $557cd575a9e6e195$var$bits2octets(hash, q);
    var v = $557cd575a9e6e195$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $557cd575a9e6e195$require$Buffer.alloc(hlen);
    k = $c9AEc(algo, k).update(v).update($557cd575a9e6e195$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $c9AEc(algo, k).update(v).digest();
    k = $c9AEc(algo, k).update(v).update($557cd575a9e6e195$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $c9AEc(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $557cd575a9e6e195$var$bits2int(obits, q) {
    var bits = new $h2Lk1(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $557cd575a9e6e195$var$bits2octets(bits, q) {
    bits = $557cd575a9e6e195$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $557cd575a9e6e195$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $557cd575a9e6e195$require$Buffer.alloc(q.byteLength() - out.length);
        out = $557cd575a9e6e195$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $557cd575a9e6e195$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $557cd575a9e6e195$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $c9AEc(algo, kv.k).update(kv.v).digest();
            t = $557cd575a9e6e195$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $557cd575a9e6e195$var$bits2int(t, q);
        kv.k = $c9AEc(algo, kv.k).update(kv.v).update($557cd575a9e6e195$require$Buffer.from([
            0
        ])).digest();
        kv.v = $c9AEc(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $557cd575a9e6e195$var$makeR(g, k, p, q) {
    return g.toRed($h2Lk1.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $557cd575a9e6e195$var$sign;
module.exports.getKey = $557cd575a9e6e195$var$getKey;
module.exports.makeKey = $557cd575a9e6e195$var$makeKey;

});
parcelRegister("58VOR", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $3bea8cd5648a92ac$require$Buffer = $ilnag.Buffer;

var $jJnl8 = parcelRequire("jJnl8");

var $2gcE5 = parcelRequire("2gcE5");
function $3bea8cd5648a92ac$var$blind(priv) {
    var r = $3bea8cd5648a92ac$var$getr(priv);
    var blinder = r.toRed($jJnl8.mont(priv.modulus)).redPow(new $jJnl8(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $3bea8cd5648a92ac$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $jJnl8($2gcE5(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $3bea8cd5648a92ac$var$crt(msg, priv) {
    var blinds = $3bea8cd5648a92ac$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $jJnl8(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($jJnl8.mont(priv.prime1));
    var c2 = blinded.toRed($jJnl8.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($3bea8cd5648a92ac$require$Buffer, "be", len);
}
$3bea8cd5648a92ac$var$crt.getr = $3bea8cd5648a92ac$var$getr;
module.exports = $3bea8cd5648a92ac$var$crt;

});
parcelRegister("jJnl8", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("aW3Sp", function(module, exports) {
"use strict";
var $7f6253faa34ae61f$var$elliptic = module.exports;

$7f6253faa34ae61f$var$elliptic.version = (parcelRequire("j7Zog")).version;

$7f6253faa34ae61f$var$elliptic.utils = (parcelRequire("d6YwF"));

$7f6253faa34ae61f$var$elliptic.rand = (parcelRequire("ht5yF"));

$7f6253faa34ae61f$var$elliptic.curve = (parcelRequire("fBDjk"));

$7f6253faa34ae61f$var$elliptic.curves = (parcelRequire("bWOUM"));

// Protocols
$7f6253faa34ae61f$var$elliptic.ec = (parcelRequire("go2aX"));

$7f6253faa34ae61f$var$elliptic.eddsa = (parcelRequire("df7YM"));

});
parcelRegister("j7Zog", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("d6YwF", function(module, exports) {
"use strict";
var $98bac91038f92b88$var$utils = module.exports;

var $42mVo = parcelRequire("42mVo");

var $cnNYx = parcelRequire("cnNYx");

var $aR6RB = parcelRequire("aR6RB");
$98bac91038f92b88$var$utils.assert = $cnNYx;
$98bac91038f92b88$var$utils.toArray = $aR6RB.toArray;
$98bac91038f92b88$var$utils.zero2 = $aR6RB.zero2;
$98bac91038f92b88$var$utils.toHex = $aR6RB.toHex;
$98bac91038f92b88$var$utils.encode = $aR6RB.encode;
// Represent num in a w-NAF form
function $98bac91038f92b88$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$98bac91038f92b88$var$utils.getNAF = $98bac91038f92b88$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $98bac91038f92b88$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$98bac91038f92b88$var$utils.getJSF = $98bac91038f92b88$var$getJSF;
function $98bac91038f92b88$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$98bac91038f92b88$var$utils.cachedProperty = $98bac91038f92b88$var$cachedProperty;
function $98bac91038f92b88$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $98bac91038f92b88$var$utils.toArray(bytes, "hex") : bytes;
}
$98bac91038f92b88$var$utils.parseBytes = $98bac91038f92b88$var$parseBytes;
function $98bac91038f92b88$var$intFromLE(bytes) {
    return new $42mVo(bytes, "hex", "le");
}
$98bac91038f92b88$var$utils.intFromLE = $98bac91038f92b88$var$intFromLE;

});
parcelRegister("aR6RB", function(module, exports) {
"use strict";
var $7e742d96e367986d$var$utils = module.exports;
function $7e742d96e367986d$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$7e742d96e367986d$var$utils.toArray = $7e742d96e367986d$var$toArray;
function $7e742d96e367986d$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$7e742d96e367986d$var$utils.zero2 = $7e742d96e367986d$var$zero2;
function $7e742d96e367986d$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $7e742d96e367986d$var$zero2(msg[i].toString(16));
    return res;
}
$7e742d96e367986d$var$utils.toHex = $7e742d96e367986d$var$toHex;
$7e742d96e367986d$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $7e742d96e367986d$var$toHex(arr);
    else return arr;
};

});


parcelRegister("fBDjk", function(module, exports) {
"use strict";
var $b5c8ce06b3474a62$var$curve = module.exports;

$b5c8ce06b3474a62$var$curve.base = (parcelRequire("b0izf"));

$b5c8ce06b3474a62$var$curve.short = (parcelRequire("15Go8"));

$b5c8ce06b3474a62$var$curve.mont = (parcelRequire("lHS6r"));

$b5c8ce06b3474a62$var$curve.edwards = (parcelRequire("hGbNn"));

});
parcelRegister("b0izf", function(module, exports) {
"use strict";

var $42mVo = parcelRequire("42mVo");

var $d6YwF = parcelRequire("d6YwF");
var $802e18ef4a850a7b$var$getNAF = $d6YwF.getNAF;
var $802e18ef4a850a7b$var$getJSF = $d6YwF.getJSF;
var $802e18ef4a850a7b$var$assert = $d6YwF.assert;
function $802e18ef4a850a7b$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $42mVo(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $42mVo.red(conf.prime) : $42mVo.mont(this.p);
    // Useful for many curves
    this.zero = new $42mVo(0).toRed(this.red);
    this.one = new $42mVo(1).toRed(this.red);
    this.two = new $42mVo(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $42mVo(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $802e18ef4a850a7b$var$BaseCurve;
$802e18ef4a850a7b$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$802e18ef4a850a7b$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$802e18ef4a850a7b$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $802e18ef4a850a7b$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $802e18ef4a850a7b$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$802e18ef4a850a7b$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $802e18ef4a850a7b$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $802e18ef4a850a7b$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$802e18ef4a850a7b$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $802e18ef4a850a7b$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $802e18ef4a850a7b$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $802e18ef4a850a7b$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $802e18ef4a850a7b$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$802e18ef4a850a7b$var$BaseCurve.BasePoint = $802e18ef4a850a7b$var$BasePoint;
$802e18ef4a850a7b$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$802e18ef4a850a7b$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$802e18ef4a850a7b$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $d6YwF.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $802e18ef4a850a7b$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $802e18ef4a850a7b$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$802e18ef4a850a7b$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$802e18ef4a850a7b$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$802e18ef4a850a7b$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $d6YwF.encode(this._encode(compact), enc);
};
$802e18ef4a850a7b$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$802e18ef4a850a7b$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$802e18ef4a850a7b$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$802e18ef4a850a7b$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$802e18ef4a850a7b$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$802e18ef4a850a7b$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("15Go8", function(module, exports) {
"use strict";

var $d6YwF = parcelRequire("d6YwF");

var $42mVo = parcelRequire("42mVo");

var $5PBAa = parcelRequire("5PBAa");

var $b0izf = parcelRequire("b0izf");
var $0cb723805609d789$var$assert = $d6YwF.assert;
function $0cb723805609d789$var$ShortCurve(conf) {
    $b0izf.call(this, "short", conf);
    this.a = new $42mVo(conf.a, 16).toRed(this.red);
    this.b = new $42mVo(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$5PBAa($0cb723805609d789$var$ShortCurve, $b0izf);
module.exports = $0cb723805609d789$var$ShortCurve;
$0cb723805609d789$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $42mVo(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $42mVo(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $0cb723805609d789$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $42mVo(vec.a, 16),
            b: new $42mVo(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$0cb723805609d789$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $42mVo.mont(num);
    var tinv = new $42mVo(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $42mVo(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$0cb723805609d789$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $42mVo(1);
    var y1 = new $42mVo(0);
    var x2 = new $42mVo(0);
    var y2 = new $42mVo(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$0cb723805609d789$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$0cb723805609d789$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $42mVo(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$0cb723805609d789$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$0cb723805609d789$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $0cb723805609d789$var$Point(curve, x, y, isRed) {
    $b0izf.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $42mVo(x, 16);
        this.y = new $42mVo(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$5PBAa($0cb723805609d789$var$Point, $b0izf.BasePoint);
$0cb723805609d789$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $0cb723805609d789$var$Point(this, x, y, isRed);
};
$0cb723805609d789$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $0cb723805609d789$var$Point.fromJSON(this, obj, red);
};
$0cb723805609d789$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$0cb723805609d789$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$0cb723805609d789$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$0cb723805609d789$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$0cb723805609d789$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$0cb723805609d789$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0cb723805609d789$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0cb723805609d789$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$0cb723805609d789$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$0cb723805609d789$var$Point.prototype.mul = function mul(k) {
    k = new $42mVo(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$0cb723805609d789$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$0cb723805609d789$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$0cb723805609d789$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$0cb723805609d789$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$0cb723805609d789$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $0cb723805609d789$var$JPoint(curve, x, y, z) {
    $b0izf.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $42mVo(0);
    } else {
        this.x = new $42mVo(x, 16);
        this.y = new $42mVo(y, 16);
        this.z = new $42mVo(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$5PBAa($0cb723805609d789$var$JPoint, $b0izf.BasePoint);
$0cb723805609d789$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $0cb723805609d789$var$JPoint(this, x, y, z);
};
$0cb723805609d789$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$0cb723805609d789$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$0cb723805609d789$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0cb723805609d789$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0cb723805609d789$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$0cb723805609d789$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$0cb723805609d789$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0cb723805609d789$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0cb723805609d789$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$0cb723805609d789$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$0cb723805609d789$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $42mVo(k, kbase);
    return this.curve._wnafMul(this, k);
};
$0cb723805609d789$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$0cb723805609d789$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$0cb723805609d789$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$0cb723805609d789$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("lHS6r", function(module, exports) {
"use strict";

var $42mVo = parcelRequire("42mVo");

var $5PBAa = parcelRequire("5PBAa");

var $b0izf = parcelRequire("b0izf");

var $d6YwF = parcelRequire("d6YwF");
function $fcd794cf1d446b28$var$MontCurve(conf) {
    $b0izf.call(this, "mont", conf);
    this.a = new $42mVo(conf.a, 16).toRed(this.red);
    this.b = new $42mVo(conf.b, 16).toRed(this.red);
    this.i4 = new $42mVo(4).toRed(this.red).redInvm();
    this.two = new $42mVo(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$5PBAa($fcd794cf1d446b28$var$MontCurve, $b0izf);
module.exports = $fcd794cf1d446b28$var$MontCurve;
$fcd794cf1d446b28$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $fcd794cf1d446b28$var$Point(curve, x, z) {
    $b0izf.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $42mVo(x, 16);
        this.z = new $42mVo(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$5PBAa($fcd794cf1d446b28$var$Point, $b0izf.BasePoint);
$fcd794cf1d446b28$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($d6YwF.toArray(bytes, enc), 1);
};
$fcd794cf1d446b28$var$MontCurve.prototype.point = function point(x, z) {
    return new $fcd794cf1d446b28$var$Point(this, x, z);
};
$fcd794cf1d446b28$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $fcd794cf1d446b28$var$Point.fromJSON(this, obj);
};
$fcd794cf1d446b28$var$Point.prototype.precompute = function precompute() {
// No-op
};
$fcd794cf1d446b28$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$fcd794cf1d446b28$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $fcd794cf1d446b28$var$Point(curve, obj[0], obj[1] || curve.one);
};
$fcd794cf1d446b28$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$fcd794cf1d446b28$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$fcd794cf1d446b28$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$fcd794cf1d446b28$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$fcd794cf1d446b28$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$fcd794cf1d446b28$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$fcd794cf1d446b28$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$fcd794cf1d446b28$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$fcd794cf1d446b28$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$fcd794cf1d446b28$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$fcd794cf1d446b28$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("hGbNn", function(module, exports) {
"use strict";

var $d6YwF = parcelRequire("d6YwF");

var $42mVo = parcelRequire("42mVo");

var $5PBAa = parcelRequire("5PBAa");

var $b0izf = parcelRequire("b0izf");
var $cdef823caebfdd0f$var$assert = $d6YwF.assert;
function $cdef823caebfdd0f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $b0izf.call(this, "edwards", conf);
    this.a = new $42mVo(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $42mVo(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $42mVo(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $cdef823caebfdd0f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$5PBAa($cdef823caebfdd0f$var$EdwardsCurve, $b0izf);
module.exports = $cdef823caebfdd0f$var$EdwardsCurve;
$cdef823caebfdd0f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$cdef823caebfdd0f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$cdef823caebfdd0f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$cdef823caebfdd0f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $42mVo(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$cdef823caebfdd0f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $42mVo(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$cdef823caebfdd0f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $cdef823caebfdd0f$var$Point(curve, x, y, z, t) {
    $b0izf.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $42mVo(x, 16);
        this.y = new $42mVo(y, 16);
        this.z = z ? new $42mVo(z, 16) : this.curve.one;
        this.t = t && new $42mVo(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$5PBAa($cdef823caebfdd0f$var$Point, $b0izf.BasePoint);
$cdef823caebfdd0f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $cdef823caebfdd0f$var$Point.fromJSON(this, obj);
};
$cdef823caebfdd0f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $cdef823caebfdd0f$var$Point(this, x, y, z, t);
};
$cdef823caebfdd0f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $cdef823caebfdd0f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$cdef823caebfdd0f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$cdef823caebfdd0f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$cdef823caebfdd0f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$cdef823caebfdd0f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$cdef823caebfdd0f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$cdef823caebfdd0f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$cdef823caebfdd0f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$cdef823caebfdd0f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$cdef823caebfdd0f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$cdef823caebfdd0f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$cdef823caebfdd0f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$cdef823caebfdd0f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$cdef823caebfdd0f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$cdef823caebfdd0f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$cdef823caebfdd0f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$cdef823caebfdd0f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$cdef823caebfdd0f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$cdef823caebfdd0f$var$Point.prototype.toP = $cdef823caebfdd0f$var$Point.prototype.normalize;
$cdef823caebfdd0f$var$Point.prototype.mixedAdd = $cdef823caebfdd0f$var$Point.prototype.add;

});


parcelRegister("bWOUM", function(module, exports) {
"use strict";
var $8b2c9b169e44a016$var$curves = module.exports;

var $kZo2m = parcelRequire("kZo2m");

var $fBDjk = parcelRequire("fBDjk");

var $d6YwF = parcelRequire("d6YwF");
var $8b2c9b169e44a016$var$assert = $d6YwF.assert;
function $8b2c9b169e44a016$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $fBDjk.short(options);
    else if (options.type === "edwards") this.curve = new $fBDjk.edwards(options);
    else this.curve = new $fBDjk.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $8b2c9b169e44a016$var$assert(this.g.validate(), "Invalid curve");
    $8b2c9b169e44a016$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$8b2c9b169e44a016$var$curves.PresetCurve = $8b2c9b169e44a016$var$PresetCurve;
function $8b2c9b169e44a016$var$defineCurve(name, options) {
    Object.defineProperty($8b2c9b169e44a016$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var curve = new $8b2c9b169e44a016$var$PresetCurve(options);
            Object.defineProperty($8b2c9b169e44a016$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$8b2c9b169e44a016$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kZo2m.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$8b2c9b169e44a016$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kZo2m.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$8b2c9b169e44a016$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kZo2m.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$8b2c9b169e44a016$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kZo2m.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$8b2c9b169e44a016$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kZo2m.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$8b2c9b169e44a016$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kZo2m.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$8b2c9b169e44a016$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kZo2m.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $8b2c9b169e44a016$var$pre;

try {
    $8b2c9b169e44a016$var$pre = (parcelRequire("g8avG"));
} catch (e) {
    $8b2c9b169e44a016$var$pre = undefined;
}
$8b2c9b169e44a016$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kZo2m.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $8b2c9b169e44a016$var$pre
    ]
});

});
parcelRegister("kZo2m", function(module, exports) {
var $f47c2666bb412d3a$var$hash = module.exports;

$f47c2666bb412d3a$var$hash.utils = (parcelRequire("4EFth"));

$f47c2666bb412d3a$var$hash.common = (parcelRequire("5ufUm"));

$f47c2666bb412d3a$var$hash.sha = (parcelRequire("iNSMm"));

$f47c2666bb412d3a$var$hash.ripemd = (parcelRequire("gFSGF"));

$f47c2666bb412d3a$var$hash.hmac = (parcelRequire("ggtr3"));
// Proxy hash functions to the main object
$f47c2666bb412d3a$var$hash.sha1 = $f47c2666bb412d3a$var$hash.sha.sha1;
$f47c2666bb412d3a$var$hash.sha256 = $f47c2666bb412d3a$var$hash.sha.sha256;
$f47c2666bb412d3a$var$hash.sha224 = $f47c2666bb412d3a$var$hash.sha.sha224;
$f47c2666bb412d3a$var$hash.sha384 = $f47c2666bb412d3a$var$hash.sha.sha384;
$f47c2666bb412d3a$var$hash.sha512 = $f47c2666bb412d3a$var$hash.sha.sha512;
$f47c2666bb412d3a$var$hash.ripemd160 = $f47c2666bb412d3a$var$hash.ripemd.ripemd160;

});
parcelRegister("4EFth", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $363b1128810c36fa$export$69f1b2dcda23c5f8; }, function (v) { return $363b1128810c36fa$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $363b1128810c36fa$export$45b10814cc054894; }, function (v) { return $363b1128810c36fa$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $363b1128810c36fa$export$7ea66e3774a60b67; }, function (v) { return $363b1128810c36fa$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $363b1128810c36fa$export$34a52f00f601f6f1; }, function (v) { return $363b1128810c36fa$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $363b1128810c36fa$export$812b0cbd5e8a72ab; }, function (v) { return $363b1128810c36fa$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $363b1128810c36fa$export$f24f9e11d63bb314; }, function (v) { return $363b1128810c36fa$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $363b1128810c36fa$export$b71357c7e07ca1f1; }, function (v) { return $363b1128810c36fa$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $363b1128810c36fa$export$2e58a4b541fdcbe8; }, function (v) { return $363b1128810c36fa$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $363b1128810c36fa$export$183b950bde9faab8; }, function (v) { return $363b1128810c36fa$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $363b1128810c36fa$export$4785c77169fea59e; }, function (v) { return $363b1128810c36fa$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $363b1128810c36fa$export$242a185dfcffac5b; }, function (v) { return $363b1128810c36fa$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $363b1128810c36fa$export$58c04ae0ae31877d; }, function (v) { return $363b1128810c36fa$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $363b1128810c36fa$export$d058ca695f8c6f11; }, function (v) { return $363b1128810c36fa$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $363b1128810c36fa$export$a1efd7fc3e986367; }, function (v) { return $363b1128810c36fa$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $363b1128810c36fa$export$bbfea4a2b5abaab4; }, function (v) { return $363b1128810c36fa$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $363b1128810c36fa$export$97ad4afc7de86152; }, function (v) { return $363b1128810c36fa$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $363b1128810c36fa$export$ce4673d9a79f6a4b; }, function (v) { return $363b1128810c36fa$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $363b1128810c36fa$export$786cc99fc6eedc0b; }, function (v) { return $363b1128810c36fa$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $363b1128810c36fa$export$45c59b9a1848dd0; }, function (v) { return $363b1128810c36fa$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $363b1128810c36fa$export$50d8f613e76d3034; }, function (v) { return $363b1128810c36fa$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $363b1128810c36fa$export$b8e83683c60ee162; }, function (v) { return $363b1128810c36fa$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $363b1128810c36fa$export$aeeb51790d1bcc4a; }, function (v) { return $363b1128810c36fa$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $363b1128810c36fa$export$bb7c616f719ad9c; }, function (v) { return $363b1128810c36fa$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $363b1128810c36fa$export$4d63290824f9d7df; }, function (v) { return $363b1128810c36fa$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $363b1128810c36fa$export$2f64ceb90ef28ea1; }, function (v) { return $363b1128810c36fa$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $363b1128810c36fa$export$8d2089d465f6d10d; }, function (v) { return $363b1128810c36fa$export$8d2089d465f6d10d = v; });
var $363b1128810c36fa$export$69f1b2dcda23c5f8;
var $363b1128810c36fa$export$45b10814cc054894;
var $363b1128810c36fa$export$7ea66e3774a60b67;
var $363b1128810c36fa$export$34a52f00f601f6f1;
var $363b1128810c36fa$export$812b0cbd5e8a72ab;
var $363b1128810c36fa$export$f24f9e11d63bb314;
var $363b1128810c36fa$export$b71357c7e07ca1f1;
var $363b1128810c36fa$export$2e58a4b541fdcbe8;
var $363b1128810c36fa$export$183b950bde9faab8;
var $363b1128810c36fa$export$4785c77169fea59e;
var $363b1128810c36fa$export$242a185dfcffac5b;
var $363b1128810c36fa$export$58c04ae0ae31877d;
var $363b1128810c36fa$export$d058ca695f8c6f11;
var $363b1128810c36fa$export$a1efd7fc3e986367;
var $363b1128810c36fa$export$bbfea4a2b5abaab4;
var $363b1128810c36fa$export$97ad4afc7de86152;
var $363b1128810c36fa$export$ce4673d9a79f6a4b;
var $363b1128810c36fa$export$786cc99fc6eedc0b;
var $363b1128810c36fa$export$45c59b9a1848dd0;
var $363b1128810c36fa$export$50d8f613e76d3034;
var $363b1128810c36fa$export$b8e83683c60ee162;
var $363b1128810c36fa$export$aeeb51790d1bcc4a;
var $363b1128810c36fa$export$bb7c616f719ad9c;
var $363b1128810c36fa$export$4d63290824f9d7df;
var $363b1128810c36fa$export$2f64ceb90ef28ea1;
var $363b1128810c36fa$export$8d2089d465f6d10d;
"use strict";

var $cnNYx = parcelRequire("cnNYx");

var $5PBAa = parcelRequire("5PBAa");
$363b1128810c36fa$export$69f1b2dcda23c5f8 = $5PBAa;
function $363b1128810c36fa$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $363b1128810c36fa$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($363b1128810c36fa$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$363b1128810c36fa$export$45b10814cc054894 = $363b1128810c36fa$var$toArray;
function $363b1128810c36fa$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $363b1128810c36fa$var$zero2(msg[i].toString(16));
    return res;
}
$363b1128810c36fa$export$7ea66e3774a60b67 = $363b1128810c36fa$var$toHex;
function $363b1128810c36fa$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$363b1128810c36fa$export$34a52f00f601f6f1 = $363b1128810c36fa$var$htonl;
function $363b1128810c36fa$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $363b1128810c36fa$var$htonl(w);
        res += $363b1128810c36fa$var$zero8(w.toString(16));
    }
    return res;
}
$363b1128810c36fa$export$812b0cbd5e8a72ab = $363b1128810c36fa$var$toHex32;
function $363b1128810c36fa$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$363b1128810c36fa$export$f24f9e11d63bb314 = $363b1128810c36fa$var$zero2;
function $363b1128810c36fa$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$363b1128810c36fa$export$b71357c7e07ca1f1 = $363b1128810c36fa$var$zero8;
function $363b1128810c36fa$var$join32(msg, start, end, endian) {
    var len = end - start;
    $cnNYx(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$363b1128810c36fa$export$2e58a4b541fdcbe8 = $363b1128810c36fa$var$join32;
function $363b1128810c36fa$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$363b1128810c36fa$export$183b950bde9faab8 = $363b1128810c36fa$var$split32;
function $363b1128810c36fa$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$363b1128810c36fa$export$4785c77169fea59e = $363b1128810c36fa$var$rotr32;
function $363b1128810c36fa$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$363b1128810c36fa$export$242a185dfcffac5b = $363b1128810c36fa$var$rotl32;
function $363b1128810c36fa$var$sum32(a, b) {
    return a + b >>> 0;
}
$363b1128810c36fa$export$58c04ae0ae31877d = $363b1128810c36fa$var$sum32;
function $363b1128810c36fa$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$363b1128810c36fa$export$d058ca695f8c6f11 = $363b1128810c36fa$var$sum32_3;
function $363b1128810c36fa$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$363b1128810c36fa$export$a1efd7fc3e986367 = $363b1128810c36fa$var$sum32_4;
function $363b1128810c36fa$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$363b1128810c36fa$export$bbfea4a2b5abaab4 = $363b1128810c36fa$var$sum32_5;
function $363b1128810c36fa$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$363b1128810c36fa$export$97ad4afc7de86152 = $363b1128810c36fa$var$sum64;
function $363b1128810c36fa$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$363b1128810c36fa$export$ce4673d9a79f6a4b = $363b1128810c36fa$var$sum64_hi;
function $363b1128810c36fa$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$363b1128810c36fa$export$786cc99fc6eedc0b = $363b1128810c36fa$var$sum64_lo;
function $363b1128810c36fa$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$363b1128810c36fa$export$45c59b9a1848dd0 = $363b1128810c36fa$var$sum64_4_hi;
function $363b1128810c36fa$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$363b1128810c36fa$export$50d8f613e76d3034 = $363b1128810c36fa$var$sum64_4_lo;
function $363b1128810c36fa$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$363b1128810c36fa$export$b8e83683c60ee162 = $363b1128810c36fa$var$sum64_5_hi;
function $363b1128810c36fa$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$363b1128810c36fa$export$aeeb51790d1bcc4a = $363b1128810c36fa$var$sum64_5_lo;
function $363b1128810c36fa$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$363b1128810c36fa$export$bb7c616f719ad9c = $363b1128810c36fa$var$rotr64_hi;
function $363b1128810c36fa$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$363b1128810c36fa$export$4d63290824f9d7df = $363b1128810c36fa$var$rotr64_lo;
function $363b1128810c36fa$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$363b1128810c36fa$export$2f64ceb90ef28ea1 = $363b1128810c36fa$var$shr64_hi;
function $363b1128810c36fa$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$363b1128810c36fa$export$8d2089d465f6d10d = $363b1128810c36fa$var$shr64_lo;

});

parcelRegister("5ufUm", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $3fec1812ec27dc79$export$8687658379b577e6; }, function (v) { return $3fec1812ec27dc79$export$8687658379b577e6 = v; });
var $3fec1812ec27dc79$export$8687658379b577e6;
"use strict";

var $4EFth = parcelRequire("4EFth");

var $cnNYx = parcelRequire("cnNYx");
function $3fec1812ec27dc79$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$3fec1812ec27dc79$export$8687658379b577e6 = $3fec1812ec27dc79$var$BlockHash;
$3fec1812ec27dc79$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $4EFth.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $4EFth.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$3fec1812ec27dc79$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $cnNYx(this.pending === null);
    return this._digest(enc);
};
$3fec1812ec27dc79$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("iNSMm", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $0388602fca4df6d6$export$5091bdda49ba90f5; }, function (v) { return $0388602fca4df6d6$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $0388602fca4df6d6$export$97b70509d4e397ea; }, function (v) { return $0388602fca4df6d6$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $0388602fca4df6d6$export$bced8d2aada2d1c9; }, function (v) { return $0388602fca4df6d6$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $0388602fca4df6d6$export$612d47d55dedde45; }, function (v) { return $0388602fca4df6d6$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $0388602fca4df6d6$export$a888d2532e6dc7bb; }, function (v) { return $0388602fca4df6d6$export$a888d2532e6dc7bb = v; });
var $0388602fca4df6d6$export$5091bdda49ba90f5;
var $0388602fca4df6d6$export$97b70509d4e397ea;
var $0388602fca4df6d6$export$bced8d2aada2d1c9;
var $0388602fca4df6d6$export$612d47d55dedde45;
var $0388602fca4df6d6$export$a888d2532e6dc7bb;
"use strict";

$0388602fca4df6d6$export$5091bdda49ba90f5 = (parcelRequire("hv1oO"));

$0388602fca4df6d6$export$97b70509d4e397ea = (parcelRequire("7nsB6"));

$0388602fca4df6d6$export$bced8d2aada2d1c9 = (parcelRequire("fLO6h"));

$0388602fca4df6d6$export$612d47d55dedde45 = (parcelRequire("8doH5"));

$0388602fca4df6d6$export$a888d2532e6dc7bb = (parcelRequire("k2Nhi"));

});
parcelRegister("hv1oO", function(module, exports) {
"use strict";

var $4EFth = parcelRequire("4EFth");

var $5ufUm = parcelRequire("5ufUm");

var $98ptF = parcelRequire("98ptF");
var $cbd66ac23fb0d4b7$var$rotl32 = $4EFth.rotl32;
var $cbd66ac23fb0d4b7$var$sum32 = $4EFth.sum32;
var $cbd66ac23fb0d4b7$var$sum32_5 = $4EFth.sum32_5;
var $cbd66ac23fb0d4b7$var$ft_1 = $98ptF.ft_1;
var $cbd66ac23fb0d4b7$var$BlockHash = $5ufUm.BlockHash;
var $cbd66ac23fb0d4b7$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $cbd66ac23fb0d4b7$var$SHA1() {
    if (!(this instanceof $cbd66ac23fb0d4b7$var$SHA1)) return new $cbd66ac23fb0d4b7$var$SHA1();
    $cbd66ac23fb0d4b7$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$4EFth.inherits($cbd66ac23fb0d4b7$var$SHA1, $cbd66ac23fb0d4b7$var$BlockHash);
module.exports = $cbd66ac23fb0d4b7$var$SHA1;
$cbd66ac23fb0d4b7$var$SHA1.blockSize = 512;
$cbd66ac23fb0d4b7$var$SHA1.outSize = 160;
$cbd66ac23fb0d4b7$var$SHA1.hmacStrength = 80;
$cbd66ac23fb0d4b7$var$SHA1.padLength = 64;
$cbd66ac23fb0d4b7$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $cbd66ac23fb0d4b7$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $cbd66ac23fb0d4b7$var$sum32_5($cbd66ac23fb0d4b7$var$rotl32(a, 5), $cbd66ac23fb0d4b7$var$ft_1(s, b, c, d), e, W[i], $cbd66ac23fb0d4b7$var$sha1_K[s]);
        e = d;
        d = c;
        c = $cbd66ac23fb0d4b7$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $cbd66ac23fb0d4b7$var$sum32(this.h[0], a);
    this.h[1] = $cbd66ac23fb0d4b7$var$sum32(this.h[1], b);
    this.h[2] = $cbd66ac23fb0d4b7$var$sum32(this.h[2], c);
    this.h[3] = $cbd66ac23fb0d4b7$var$sum32(this.h[3], d);
    this.h[4] = $cbd66ac23fb0d4b7$var$sum32(this.h[4], e);
};
$cbd66ac23fb0d4b7$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $4EFth.toHex32(this.h, "big");
    else return $4EFth.split32(this.h, "big");
};

});
parcelRegister("98ptF", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $6a689fb2cb4b1a4f$export$5a92649d7ddb9f63; }, function (v) { return $6a689fb2cb4b1a4f$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $6a689fb2cb4b1a4f$export$c6d0d020c3a6269; }, function (v) { return $6a689fb2cb4b1a4f$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $6a689fb2cb4b1a4f$export$eb90c27fca05f956; }, function (v) { return $6a689fb2cb4b1a4f$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $6a689fb2cb4b1a4f$export$14a4a98e063b1999; }, function (v) { return $6a689fb2cb4b1a4f$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $6a689fb2cb4b1a4f$export$d20cecfa1564c686; }, function (v) { return $6a689fb2cb4b1a4f$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $6a689fb2cb4b1a4f$export$44fd472a12fc6db; }, function (v) { return $6a689fb2cb4b1a4f$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $6a689fb2cb4b1a4f$export$1ed238bb6ea1dd47; }, function (v) { return $6a689fb2cb4b1a4f$export$1ed238bb6ea1dd47 = v; });
var $6a689fb2cb4b1a4f$export$5a92649d7ddb9f63;
var $6a689fb2cb4b1a4f$export$c6d0d020c3a6269;
var $6a689fb2cb4b1a4f$export$eb90c27fca05f956;
var $6a689fb2cb4b1a4f$export$cc992891a14496a1;
var $6a689fb2cb4b1a4f$export$14a4a98e063b1999;
var $6a689fb2cb4b1a4f$export$d20cecfa1564c686;
var $6a689fb2cb4b1a4f$export$44fd472a12fc6db;
var $6a689fb2cb4b1a4f$export$1ed238bb6ea1dd47;
"use strict";

var $4EFth = parcelRequire("4EFth");
var $6a689fb2cb4b1a4f$var$rotr32 = $4EFth.rotr32;
function $6a689fb2cb4b1a4f$var$ft_1(s, x, y, z) {
    if (s === 0) return $6a689fb2cb4b1a4f$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $6a689fb2cb4b1a4f$var$p32(x, y, z);
    if (s === 2) return $6a689fb2cb4b1a4f$var$maj32(x, y, z);
}
$6a689fb2cb4b1a4f$export$5a92649d7ddb9f63 = $6a689fb2cb4b1a4f$var$ft_1;
function $6a689fb2cb4b1a4f$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$6a689fb2cb4b1a4f$export$c6d0d020c3a6269 = $6a689fb2cb4b1a4f$var$ch32;
function $6a689fb2cb4b1a4f$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$6a689fb2cb4b1a4f$export$eb90c27fca05f956 = $6a689fb2cb4b1a4f$var$maj32;
function $6a689fb2cb4b1a4f$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$6a689fb2cb4b1a4f$export$cc992891a14496a1 = $6a689fb2cb4b1a4f$var$p32;
function $6a689fb2cb4b1a4f$var$s0_256(x) {
    return $6a689fb2cb4b1a4f$var$rotr32(x, 2) ^ $6a689fb2cb4b1a4f$var$rotr32(x, 13) ^ $6a689fb2cb4b1a4f$var$rotr32(x, 22);
}
$6a689fb2cb4b1a4f$export$14a4a98e063b1999 = $6a689fb2cb4b1a4f$var$s0_256;
function $6a689fb2cb4b1a4f$var$s1_256(x) {
    return $6a689fb2cb4b1a4f$var$rotr32(x, 6) ^ $6a689fb2cb4b1a4f$var$rotr32(x, 11) ^ $6a689fb2cb4b1a4f$var$rotr32(x, 25);
}
$6a689fb2cb4b1a4f$export$d20cecfa1564c686 = $6a689fb2cb4b1a4f$var$s1_256;
function $6a689fb2cb4b1a4f$var$g0_256(x) {
    return $6a689fb2cb4b1a4f$var$rotr32(x, 7) ^ $6a689fb2cb4b1a4f$var$rotr32(x, 18) ^ x >>> 3;
}
$6a689fb2cb4b1a4f$export$44fd472a12fc6db = $6a689fb2cb4b1a4f$var$g0_256;
function $6a689fb2cb4b1a4f$var$g1_256(x) {
    return $6a689fb2cb4b1a4f$var$rotr32(x, 17) ^ $6a689fb2cb4b1a4f$var$rotr32(x, 19) ^ x >>> 10;
}
$6a689fb2cb4b1a4f$export$1ed238bb6ea1dd47 = $6a689fb2cb4b1a4f$var$g1_256;

});


parcelRegister("7nsB6", function(module, exports) {
"use strict";

var $4EFth = parcelRequire("4EFth");

var $fLO6h = parcelRequire("fLO6h");
function $55f0dd43a0fa0c0c$var$SHA224() {
    if (!(this instanceof $55f0dd43a0fa0c0c$var$SHA224)) return new $55f0dd43a0fa0c0c$var$SHA224();
    $fLO6h.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$4EFth.inherits($55f0dd43a0fa0c0c$var$SHA224, $fLO6h);
module.exports = $55f0dd43a0fa0c0c$var$SHA224;
$55f0dd43a0fa0c0c$var$SHA224.blockSize = 512;
$55f0dd43a0fa0c0c$var$SHA224.outSize = 224;
$55f0dd43a0fa0c0c$var$SHA224.hmacStrength = 192;
$55f0dd43a0fa0c0c$var$SHA224.padLength = 64;
$55f0dd43a0fa0c0c$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $4EFth.toHex32(this.h.slice(0, 7), "big");
    else return $4EFth.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("fLO6h", function(module, exports) {
"use strict";

var $4EFth = parcelRequire("4EFth");

var $5ufUm = parcelRequire("5ufUm");

var $98ptF = parcelRequire("98ptF");

var $cnNYx = parcelRequire("cnNYx");
var $b7b21ba7931adac0$var$sum32 = $4EFth.sum32;
var $b7b21ba7931adac0$var$sum32_4 = $4EFth.sum32_4;
var $b7b21ba7931adac0$var$sum32_5 = $4EFth.sum32_5;
var $b7b21ba7931adac0$var$ch32 = $98ptF.ch32;
var $b7b21ba7931adac0$var$maj32 = $98ptF.maj32;
var $b7b21ba7931adac0$var$s0_256 = $98ptF.s0_256;
var $b7b21ba7931adac0$var$s1_256 = $98ptF.s1_256;
var $b7b21ba7931adac0$var$g0_256 = $98ptF.g0_256;
var $b7b21ba7931adac0$var$g1_256 = $98ptF.g1_256;
var $b7b21ba7931adac0$var$BlockHash = $5ufUm.BlockHash;
var $b7b21ba7931adac0$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $b7b21ba7931adac0$var$SHA256() {
    if (!(this instanceof $b7b21ba7931adac0$var$SHA256)) return new $b7b21ba7931adac0$var$SHA256();
    $b7b21ba7931adac0$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $b7b21ba7931adac0$var$sha256_K;
    this.W = new Array(64);
}
$4EFth.inherits($b7b21ba7931adac0$var$SHA256, $b7b21ba7931adac0$var$BlockHash);
module.exports = $b7b21ba7931adac0$var$SHA256;
$b7b21ba7931adac0$var$SHA256.blockSize = 512;
$b7b21ba7931adac0$var$SHA256.outSize = 256;
$b7b21ba7931adac0$var$SHA256.hmacStrength = 192;
$b7b21ba7931adac0$var$SHA256.padLength = 64;
$b7b21ba7931adac0$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $b7b21ba7931adac0$var$sum32_4($b7b21ba7931adac0$var$g1_256(W[i - 2]), W[i - 7], $b7b21ba7931adac0$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $cnNYx(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $b7b21ba7931adac0$var$sum32_5(h, $b7b21ba7931adac0$var$s1_256(e), $b7b21ba7931adac0$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $b7b21ba7931adac0$var$sum32($b7b21ba7931adac0$var$s0_256(a), $b7b21ba7931adac0$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $b7b21ba7931adac0$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $b7b21ba7931adac0$var$sum32(T1, T2);
    }
    this.h[0] = $b7b21ba7931adac0$var$sum32(this.h[0], a);
    this.h[1] = $b7b21ba7931adac0$var$sum32(this.h[1], b);
    this.h[2] = $b7b21ba7931adac0$var$sum32(this.h[2], c);
    this.h[3] = $b7b21ba7931adac0$var$sum32(this.h[3], d);
    this.h[4] = $b7b21ba7931adac0$var$sum32(this.h[4], e);
    this.h[5] = $b7b21ba7931adac0$var$sum32(this.h[5], f);
    this.h[6] = $b7b21ba7931adac0$var$sum32(this.h[6], g);
    this.h[7] = $b7b21ba7931adac0$var$sum32(this.h[7], h);
};
$b7b21ba7931adac0$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $4EFth.toHex32(this.h, "big");
    else return $4EFth.split32(this.h, "big");
};

});


parcelRegister("8doH5", function(module, exports) {
"use strict";

var $4EFth = parcelRequire("4EFth");

var $k2Nhi = parcelRequire("k2Nhi");
function $5fb2b156fa1cdfaf$var$SHA384() {
    if (!(this instanceof $5fb2b156fa1cdfaf$var$SHA384)) return new $5fb2b156fa1cdfaf$var$SHA384();
    $k2Nhi.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$4EFth.inherits($5fb2b156fa1cdfaf$var$SHA384, $k2Nhi);
module.exports = $5fb2b156fa1cdfaf$var$SHA384;
$5fb2b156fa1cdfaf$var$SHA384.blockSize = 1024;
$5fb2b156fa1cdfaf$var$SHA384.outSize = 384;
$5fb2b156fa1cdfaf$var$SHA384.hmacStrength = 192;
$5fb2b156fa1cdfaf$var$SHA384.padLength = 128;
$5fb2b156fa1cdfaf$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $4EFth.toHex32(this.h.slice(0, 12), "big");
    else return $4EFth.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("k2Nhi", function(module, exports) {
"use strict";

var $4EFth = parcelRequire("4EFth");

var $5ufUm = parcelRequire("5ufUm");

var $cnNYx = parcelRequire("cnNYx");
var $e97a381e713d94db$var$rotr64_hi = $4EFth.rotr64_hi;
var $e97a381e713d94db$var$rotr64_lo = $4EFth.rotr64_lo;
var $e97a381e713d94db$var$shr64_hi = $4EFth.shr64_hi;
var $e97a381e713d94db$var$shr64_lo = $4EFth.shr64_lo;
var $e97a381e713d94db$var$sum64 = $4EFth.sum64;
var $e97a381e713d94db$var$sum64_hi = $4EFth.sum64_hi;
var $e97a381e713d94db$var$sum64_lo = $4EFth.sum64_lo;
var $e97a381e713d94db$var$sum64_4_hi = $4EFth.sum64_4_hi;
var $e97a381e713d94db$var$sum64_4_lo = $4EFth.sum64_4_lo;
var $e97a381e713d94db$var$sum64_5_hi = $4EFth.sum64_5_hi;
var $e97a381e713d94db$var$sum64_5_lo = $4EFth.sum64_5_lo;
var $e97a381e713d94db$var$BlockHash = $5ufUm.BlockHash;
var $e97a381e713d94db$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $e97a381e713d94db$var$SHA512() {
    if (!(this instanceof $e97a381e713d94db$var$SHA512)) return new $e97a381e713d94db$var$SHA512();
    $e97a381e713d94db$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $e97a381e713d94db$var$sha512_K;
    this.W = new Array(160);
}
$4EFth.inherits($e97a381e713d94db$var$SHA512, $e97a381e713d94db$var$BlockHash);
module.exports = $e97a381e713d94db$var$SHA512;
$e97a381e713d94db$var$SHA512.blockSize = 1024;
$e97a381e713d94db$var$SHA512.outSize = 512;
$e97a381e713d94db$var$SHA512.hmacStrength = 192;
$e97a381e713d94db$var$SHA512.padLength = 128;
$e97a381e713d94db$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $e97a381e713d94db$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $e97a381e713d94db$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $e97a381e713d94db$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $e97a381e713d94db$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $e97a381e713d94db$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $e97a381e713d94db$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$e97a381e713d94db$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $cnNYx(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $e97a381e713d94db$var$s1_512_hi(eh, el);
        var c1_lo = $e97a381e713d94db$var$s1_512_lo(eh, el);
        var c2_hi = $e97a381e713d94db$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $e97a381e713d94db$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $e97a381e713d94db$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $e97a381e713d94db$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $e97a381e713d94db$var$s0_512_hi(ah, al);
        c0_lo = $e97a381e713d94db$var$s0_512_lo(ah, al);
        c1_hi = $e97a381e713d94db$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $e97a381e713d94db$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $e97a381e713d94db$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $e97a381e713d94db$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $e97a381e713d94db$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $e97a381e713d94db$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $e97a381e713d94db$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $e97a381e713d94db$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $e97a381e713d94db$var$sum64(this.h, 0, ah, al);
    $e97a381e713d94db$var$sum64(this.h, 2, bh, bl);
    $e97a381e713d94db$var$sum64(this.h, 4, ch, cl);
    $e97a381e713d94db$var$sum64(this.h, 6, dh, dl);
    $e97a381e713d94db$var$sum64(this.h, 8, eh, el);
    $e97a381e713d94db$var$sum64(this.h, 10, fh, fl);
    $e97a381e713d94db$var$sum64(this.h, 12, gh, gl);
    $e97a381e713d94db$var$sum64(this.h, 14, hh, hl);
};
$e97a381e713d94db$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $4EFth.toHex32(this.h, "big");
    else return $4EFth.split32(this.h, "big");
};
function $e97a381e713d94db$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$s0_512_hi(xh, xl) {
    var c0_hi = $e97a381e713d94db$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $e97a381e713d94db$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $e97a381e713d94db$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$s0_512_lo(xh, xl) {
    var c0_lo = $e97a381e713d94db$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $e97a381e713d94db$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $e97a381e713d94db$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$s1_512_hi(xh, xl) {
    var c0_hi = $e97a381e713d94db$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $e97a381e713d94db$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $e97a381e713d94db$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$s1_512_lo(xh, xl) {
    var c0_lo = $e97a381e713d94db$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $e97a381e713d94db$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $e97a381e713d94db$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$g0_512_hi(xh, xl) {
    var c0_hi = $e97a381e713d94db$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $e97a381e713d94db$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $e97a381e713d94db$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$g0_512_lo(xh, xl) {
    var c0_lo = $e97a381e713d94db$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $e97a381e713d94db$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $e97a381e713d94db$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$g1_512_hi(xh, xl) {
    var c0_hi = $e97a381e713d94db$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $e97a381e713d94db$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $e97a381e713d94db$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e97a381e713d94db$var$g1_512_lo(xh, xl) {
    var c0_lo = $e97a381e713d94db$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $e97a381e713d94db$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $e97a381e713d94db$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("gFSGF", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $c23ae56bc3259ef1$export$d1cea0ee4e3f0d3e; }, function (v) { return $c23ae56bc3259ef1$export$d1cea0ee4e3f0d3e = v; });
var $c23ae56bc3259ef1$export$d1cea0ee4e3f0d3e;
"use strict";

var $4EFth = parcelRequire("4EFth");

var $5ufUm = parcelRequire("5ufUm");
var $c23ae56bc3259ef1$var$rotl32 = $4EFth.rotl32;
var $c23ae56bc3259ef1$var$sum32 = $4EFth.sum32;
var $c23ae56bc3259ef1$var$sum32_3 = $4EFth.sum32_3;
var $c23ae56bc3259ef1$var$sum32_4 = $4EFth.sum32_4;
var $c23ae56bc3259ef1$var$BlockHash = $5ufUm.BlockHash;
function $c23ae56bc3259ef1$var$RIPEMD160() {
    if (!(this instanceof $c23ae56bc3259ef1$var$RIPEMD160)) return new $c23ae56bc3259ef1$var$RIPEMD160();
    $c23ae56bc3259ef1$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$4EFth.inherits($c23ae56bc3259ef1$var$RIPEMD160, $c23ae56bc3259ef1$var$BlockHash);
$c23ae56bc3259ef1$export$d1cea0ee4e3f0d3e = $c23ae56bc3259ef1$var$RIPEMD160;
$c23ae56bc3259ef1$var$RIPEMD160.blockSize = 512;
$c23ae56bc3259ef1$var$RIPEMD160.outSize = 160;
$c23ae56bc3259ef1$var$RIPEMD160.hmacStrength = 192;
$c23ae56bc3259ef1$var$RIPEMD160.padLength = 64;
$c23ae56bc3259ef1$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $c23ae56bc3259ef1$var$sum32($c23ae56bc3259ef1$var$rotl32($c23ae56bc3259ef1$var$sum32_4(A, $c23ae56bc3259ef1$var$f(j, B, C, D), msg[$c23ae56bc3259ef1$var$r[j] + start], $c23ae56bc3259ef1$var$K(j)), $c23ae56bc3259ef1$var$s[j]), E);
        A = E;
        E = D;
        D = $c23ae56bc3259ef1$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $c23ae56bc3259ef1$var$sum32($c23ae56bc3259ef1$var$rotl32($c23ae56bc3259ef1$var$sum32_4(Ah, $c23ae56bc3259ef1$var$f(79 - j, Bh, Ch, Dh), msg[$c23ae56bc3259ef1$var$rh[j] + start], $c23ae56bc3259ef1$var$Kh(j)), $c23ae56bc3259ef1$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $c23ae56bc3259ef1$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $c23ae56bc3259ef1$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $c23ae56bc3259ef1$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $c23ae56bc3259ef1$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $c23ae56bc3259ef1$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $c23ae56bc3259ef1$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$c23ae56bc3259ef1$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $4EFth.toHex32(this.h, "little");
    else return $4EFth.split32(this.h, "little");
};
function $c23ae56bc3259ef1$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $c23ae56bc3259ef1$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $c23ae56bc3259ef1$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $c23ae56bc3259ef1$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $c23ae56bc3259ef1$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $c23ae56bc3259ef1$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $c23ae56bc3259ef1$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ggtr3", function(module, exports) {
"use strict";

var $4EFth = parcelRequire("4EFth");

var $cnNYx = parcelRequire("cnNYx");
function $bd74f930459d0659$var$Hmac(hash, key, enc) {
    if (!(this instanceof $bd74f930459d0659$var$Hmac)) return new $bd74f930459d0659$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($4EFth.toArray(key, enc));
}
module.exports = $bd74f930459d0659$var$Hmac;
$bd74f930459d0659$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $cnNYx(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$bd74f930459d0659$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$bd74f930459d0659$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("g8avG", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("go2aX", function(module, exports) {
"use strict";

var $42mVo = parcelRequire("42mVo");

var $1kXDa = parcelRequire("1kXDa");

var $d6YwF = parcelRequire("d6YwF");

var $bWOUM = parcelRequire("bWOUM");

var $ht5yF = parcelRequire("ht5yF");
var $bee09347fd4221c1$var$assert = $d6YwF.assert;

var $arN9W = parcelRequire("arN9W");

var $hqyW5 = parcelRequire("hqyW5");
function $bee09347fd4221c1$var$EC(options) {
    if (!(this instanceof $bee09347fd4221c1$var$EC)) return new $bee09347fd4221c1$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $bee09347fd4221c1$var$assert(Object.prototype.hasOwnProperty.call($bWOUM, options), "Unknown curve " + options);
        options = $bWOUM[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $bWOUM.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $bee09347fd4221c1$var$EC;
$bee09347fd4221c1$var$EC.prototype.keyPair = function keyPair(options) {
    return new $arN9W(this, options);
};
$bee09347fd4221c1$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $arN9W.fromPrivate(this, priv, enc);
};
$bee09347fd4221c1$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $arN9W.fromPublic(this, pub, enc);
};
$bee09347fd4221c1$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $1kXDa({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $ht5yF(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $42mVo(2));
    for(;;){
        var priv = new $42mVo(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$bee09347fd4221c1$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$bee09347fd4221c1$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $42mVo(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $1kXDa({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $42mVo(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $42mVo(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $hqyW5({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$bee09347fd4221c1$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $42mVo(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $hqyW5(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$bee09347fd4221c1$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $bee09347fd4221c1$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $hqyW5(signature, enc);
    var n = this.n;
    var e = new $42mVo(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$bee09347fd4221c1$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $hqyW5(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("1kXDa", function(module, exports) {
"use strict";

var $kZo2m = parcelRequire("kZo2m");

var $aR6RB = parcelRequire("aR6RB");

var $cnNYx = parcelRequire("cnNYx");
function $0f95ea22f66227d7$var$HmacDRBG(options) {
    if (!(this instanceof $0f95ea22f66227d7$var$HmacDRBG)) return new $0f95ea22f66227d7$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $aR6RB.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $aR6RB.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $aR6RB.toArray(options.pers, options.persEnc || "hex");
    $cnNYx(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $0f95ea22f66227d7$var$HmacDRBG;
$0f95ea22f66227d7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$0f95ea22f66227d7$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kZo2m.hmac(this.hash, this.K);
};
$0f95ea22f66227d7$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$0f95ea22f66227d7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $aR6RB.toArray(entropy, entropyEnc);
    add = $aR6RB.toArray(add, addEnc);
    $cnNYx(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$0f95ea22f66227d7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $aR6RB.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $aR6RB.encode(res, enc);
};

});

parcelRegister("arN9W", function(module, exports) {
"use strict";

var $42mVo = parcelRequire("42mVo");

var $d6YwF = parcelRequire("d6YwF");
var $79b28f0a01de933f$var$assert = $d6YwF.assert;
function $79b28f0a01de933f$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $79b28f0a01de933f$var$KeyPair;
$79b28f0a01de933f$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $79b28f0a01de933f$var$KeyPair) return pub;
    return new $79b28f0a01de933f$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$79b28f0a01de933f$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $79b28f0a01de933f$var$KeyPair) return priv;
    return new $79b28f0a01de933f$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$79b28f0a01de933f$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$79b28f0a01de933f$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$79b28f0a01de933f$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$79b28f0a01de933f$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $42mVo(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$79b28f0a01de933f$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $79b28f0a01de933f$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $79b28f0a01de933f$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$79b28f0a01de933f$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $79b28f0a01de933f$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$79b28f0a01de933f$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$79b28f0a01de933f$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$79b28f0a01de933f$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("hqyW5", function(module, exports) {
"use strict";

var $42mVo = parcelRequire("42mVo");

var $d6YwF = parcelRequire("d6YwF");
var $cafff6e93e444cff$var$assert = $d6YwF.assert;
function $cafff6e93e444cff$var$Signature(options, enc) {
    if (options instanceof $cafff6e93e444cff$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $cafff6e93e444cff$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $42mVo(options.r, 16);
    this.s = new $42mVo(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $cafff6e93e444cff$var$Signature;
function $cafff6e93e444cff$var$Position() {
    this.place = 0;
}
function $cafff6e93e444cff$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $cafff6e93e444cff$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$cafff6e93e444cff$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $d6YwF.toArray(data, enc);
    var p = new $cafff6e93e444cff$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $cafff6e93e444cff$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $cafff6e93e444cff$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $cafff6e93e444cff$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $42mVo(r);
    this.s = new $42mVo(s);
    this.recoveryParam = null;
    return true;
};
function $cafff6e93e444cff$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$cafff6e93e444cff$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $cafff6e93e444cff$var$rmPadding(r);
    s = $cafff6e93e444cff$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $cafff6e93e444cff$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $cafff6e93e444cff$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $cafff6e93e444cff$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $d6YwF.encode(res, enc);
};

});


parcelRegister("df7YM", function(module, exports) {
"use strict";

var $kZo2m = parcelRequire("kZo2m");

var $bWOUM = parcelRequire("bWOUM");

var $d6YwF = parcelRequire("d6YwF");
var $9a42dd9fad227fa2$var$assert = $d6YwF.assert;
var $9a42dd9fad227fa2$var$parseBytes = $d6YwF.parseBytes;

var $KzbMf = parcelRequire("KzbMf");

var $7ZIwX = parcelRequire("7ZIwX");
function $9a42dd9fad227fa2$var$EDDSA(curve) {
    $9a42dd9fad227fa2$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $9a42dd9fad227fa2$var$EDDSA)) return new $9a42dd9fad227fa2$var$EDDSA(curve);
    curve = $bWOUM[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kZo2m.sha512;
}
module.exports = $9a42dd9fad227fa2$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $9a42dd9fad227fa2$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $9a42dd9fad227fa2$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $9a42dd9fad227fa2$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $9a42dd9fad227fa2$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $d6YwF.intFromLE(hash.digest()).umod(this.curve.n);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $KzbMf.fromPublic(this, pub);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $KzbMf.fromSecret(this, secret);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7ZIwX) return sig;
    return new $7ZIwX(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $9a42dd9fad227fa2$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$9a42dd9fad227fa2$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $d6YwF.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $d6YwF.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $d6YwF.intFromLE(bytes);
};
$9a42dd9fad227fa2$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("KzbMf", function(module, exports) {
"use strict";

var $d6YwF = parcelRequire("d6YwF");
var $08bf97c9333b6caa$var$assert = $d6YwF.assert;
var $08bf97c9333b6caa$var$parseBytes = $d6YwF.parseBytes;
var $08bf97c9333b6caa$var$cachedProperty = $d6YwF.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $08bf97c9333b6caa$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $08bf97c9333b6caa$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $08bf97c9333b6caa$var$parseBytes(params.pub);
}
$08bf97c9333b6caa$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $08bf97c9333b6caa$var$KeyPair) return pub;
    return new $08bf97c9333b6caa$var$KeyPair(eddsa, {
        pub: pub
    });
};
$08bf97c9333b6caa$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $08bf97c9333b6caa$var$KeyPair) return secret;
    return new $08bf97c9333b6caa$var$KeyPair(eddsa, {
        secret: secret
    });
};
$08bf97c9333b6caa$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$08bf97c9333b6caa$var$cachedProperty($08bf97c9333b6caa$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$08bf97c9333b6caa$var$cachedProperty($08bf97c9333b6caa$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$08bf97c9333b6caa$var$cachedProperty($08bf97c9333b6caa$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$08bf97c9333b6caa$var$cachedProperty($08bf97c9333b6caa$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$08bf97c9333b6caa$var$cachedProperty($08bf97c9333b6caa$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$08bf97c9333b6caa$var$cachedProperty($08bf97c9333b6caa$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$08bf97c9333b6caa$var$KeyPair.prototype.sign = function sign(message) {
    $08bf97c9333b6caa$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$08bf97c9333b6caa$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$08bf97c9333b6caa$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $08bf97c9333b6caa$var$assert(this._secret, "KeyPair is public only");
    return $d6YwF.encode(this.secret(), enc);
};
$08bf97c9333b6caa$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $d6YwF.encode(this.pubBytes(), enc);
};
module.exports = $08bf97c9333b6caa$var$KeyPair;

});

parcelRegister("7ZIwX", function(module, exports) {
"use strict";

var $42mVo = parcelRequire("42mVo");

var $d6YwF = parcelRequire("d6YwF");
var $5d20c5c42dcd3e2f$var$assert = $d6YwF.assert;
var $5d20c5c42dcd3e2f$var$cachedProperty = $d6YwF.cachedProperty;
var $5d20c5c42dcd3e2f$var$parseBytes = $d6YwF.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5d20c5c42dcd3e2f$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5d20c5c42dcd3e2f$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5d20c5c42dcd3e2f$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $42mVo) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5d20c5c42dcd3e2f$var$cachedProperty($5d20c5c42dcd3e2f$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5d20c5c42dcd3e2f$var$cachedProperty($5d20c5c42dcd3e2f$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5d20c5c42dcd3e2f$var$cachedProperty($5d20c5c42dcd3e2f$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5d20c5c42dcd3e2f$var$cachedProperty($5d20c5c42dcd3e2f$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5d20c5c42dcd3e2f$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5d20c5c42dcd3e2f$var$Signature.prototype.toHex = function toHex() {
    return $d6YwF.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5d20c5c42dcd3e2f$var$Signature;

});



parcelRegister("h2Lk1", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lbG4j", function(module, exports) {

var $2JJfd = parcelRequire("2JJfd");

var $2qeZr = parcelRequire("2qeZr");

var $e087Y = parcelRequire("e087Y");

var $c2PdS = parcelRequire("c2PdS");

var $aO3KN = parcelRequire("aO3KN");

var $b1nU2 = parcelRequire("b1nU2");
var $f6cb4201da5bf4f7$require$Buffer = $b1nU2.Buffer;
module.exports = $f6cb4201da5bf4f7$var$parseKeys;
function $f6cb4201da5bf4f7$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$f6cb4201da5bf4f7$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $f6cb4201da5bf4f7$require$Buffer.from(buffer);
    var stripped = $e087Y(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $2JJfd.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $2JJfd.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2JJfd.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $2JJfd.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $2JJfd.EncryptedPrivateKey.decode(data, "der");
            data = $f6cb4201da5bf4f7$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $2JJfd.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2JJfd.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $2JJfd.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $2JJfd.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $2JJfd.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $2JJfd.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $2JJfd.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $2JJfd.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$f6cb4201da5bf4f7$var$parseKeys.signature = $2JJfd.signature;
function $f6cb4201da5bf4f7$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $2qeZr[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $aO3KN.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $c2PdS.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $f6cb4201da5bf4f7$require$Buffer.concat(out);
}

});
parcelRegister("2JJfd", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $1fe2e156080f9926$export$c98397a6eb8d0678; }, function (v) { return $1fe2e156080f9926$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $1fe2e156080f9926$export$f4aab6816f64fa6b; }, function (v) { return $1fe2e156080f9926$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $1fe2e156080f9926$export$4471f5c65d097c11; }, function (v) { return $1fe2e156080f9926$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $1fe2e156080f9926$export$ca8b6604d6ce14de; }, function (v) { return $1fe2e156080f9926$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $1fe2e156080f9926$export$8f54525b330fd87b; }, function (v) { return $1fe2e156080f9926$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $1fe2e156080f9926$export$23cd2842b44ca3e7; }, function (v) { return $1fe2e156080f9926$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $1fe2e156080f9926$export$245c9aaa9f5ce4ce; }, function (v) { return $1fe2e156080f9926$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $1fe2e156080f9926$export$8ad762e3e6399afe; }, function (v) { return $1fe2e156080f9926$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $1fe2e156080f9926$export$32ef6f92e22c6ab0; }, function (v) { return $1fe2e156080f9926$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $1fe2e156080f9926$export$c9cd164b539ebb63; }, function (v) { return $1fe2e156080f9926$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $1fe2e156080f9926$export$c98397a6eb8d0678;
var $1fe2e156080f9926$export$f4aab6816f64fa6b;
var $1fe2e156080f9926$export$4471f5c65d097c11;
var $1fe2e156080f9926$export$ca8b6604d6ce14de;
var $1fe2e156080f9926$export$8f54525b330fd87b;
var $1fe2e156080f9926$export$23cd2842b44ca3e7;
var $1fe2e156080f9926$export$245c9aaa9f5ce4ce;
var $1fe2e156080f9926$export$8ad762e3e6399afe;
var $1fe2e156080f9926$export$32ef6f92e22c6ab0;
var $1fe2e156080f9926$export$c9cd164b539ebb63;
"use strict";

var $1pbxL = parcelRequire("1pbxL");

$1fe2e156080f9926$export$c98397a6eb8d0678 = (parcelRequire("dlrA2"));
var $1fe2e156080f9926$var$RSAPrivateKey = $1pbxL.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$1fe2e156080f9926$export$f4aab6816f64fa6b = $1fe2e156080f9926$var$RSAPrivateKey;
var $1fe2e156080f9926$var$RSAPublicKey = $1pbxL.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$1fe2e156080f9926$export$4471f5c65d097c11 = $1fe2e156080f9926$var$RSAPublicKey;
var $1fe2e156080f9926$var$PublicKey = $1pbxL.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($1fe2e156080f9926$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$1fe2e156080f9926$export$ca8b6604d6ce14de = $1fe2e156080f9926$var$PublicKey;
var $1fe2e156080f9926$var$AlgorithmIdentifier = $1pbxL.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $1fe2e156080f9926$var$PrivateKeyInfo = $1pbxL.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($1fe2e156080f9926$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$1fe2e156080f9926$export$8f54525b330fd87b = $1fe2e156080f9926$var$PrivateKeyInfo;
var $1fe2e156080f9926$var$EncryptedPrivateKeyInfo = $1pbxL.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$1fe2e156080f9926$export$23cd2842b44ca3e7 = $1fe2e156080f9926$var$EncryptedPrivateKeyInfo;
var $1fe2e156080f9926$var$DSAPrivateKey = $1pbxL.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$1fe2e156080f9926$export$245c9aaa9f5ce4ce = $1fe2e156080f9926$var$DSAPrivateKey;
$1fe2e156080f9926$export$8ad762e3e6399afe = $1pbxL.define("DSAparam", function() {
    this.int();
});
var $1fe2e156080f9926$var$ECPrivateKey = $1pbxL.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($1fe2e156080f9926$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$1fe2e156080f9926$export$32ef6f92e22c6ab0 = $1fe2e156080f9926$var$ECPrivateKey;
var $1fe2e156080f9926$var$ECParameters = $1pbxL.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$1fe2e156080f9926$export$c9cd164b539ebb63 = $1pbxL.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("1pbxL", function(module, exports) {
"use strict";
var $1061148ff062a6cd$var$asn1 = module.exports;

$1061148ff062a6cd$var$asn1.bignum = (parcelRequire("42mVo"));

$1061148ff062a6cd$var$asn1.define = (parcelRequire("lDtQR")).define;

$1061148ff062a6cd$var$asn1.base = (parcelRequire("dAHv4"));

$1061148ff062a6cd$var$asn1.constants = (parcelRequire("5qseC"));

$1061148ff062a6cd$var$asn1.decoders = (parcelRequire("40ecg"));

$1061148ff062a6cd$var$asn1.encoders = (parcelRequire("lrVvW"));

});
parcelRegister("lDtQR", function(module, exports) {
"use strict";

var $lrVvW = parcelRequire("lrVvW");

var $40ecg = parcelRequire("40ecg");

var $5PBAa = parcelRequire("5PBAa");
var $fc04656a727cc82a$var$api = module.exports;
$fc04656a727cc82a$var$api.define = function define(name, body) {
    return new $fc04656a727cc82a$var$Entity(name, body);
};
function $fc04656a727cc82a$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$fc04656a727cc82a$var$Entity.prototype._createNamed = function createNamed(Base) {
    var name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $5PBAa(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$fc04656a727cc82a$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($40ecg[enc]);
    return this.decoders[enc];
};
$fc04656a727cc82a$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$fc04656a727cc82a$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($lrVvW[enc]);
    return this.encoders[enc];
};
$fc04656a727cc82a$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("lrVvW", function(module, exports) {
"use strict";
var $f9d8bbb9abf2f3fc$var$encoders = module.exports;

$f9d8bbb9abf2f3fc$var$encoders.der = (parcelRequire("evwNd"));

$f9d8bbb9abf2f3fc$var$encoders.pem = (parcelRequire("2OHFy"));

});
parcelRegister("evwNd", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $kfeo7 = parcelRequire("kfeo7");
var $a8fd65e4690f6d5d$require$Buffer = $kfeo7.Buffer;

var $h2lGF = parcelRequire("h2lGF");

var $jewlx = parcelRequire("jewlx");
function $a8fd65e4690f6d5d$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $a8fd65e4690f6d5d$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $a8fd65e4690f6d5d$var$DEREncoder;
$a8fd65e4690f6d5d$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $a8fd65e4690f6d5d$var$DERNode(parent) {
    $h2lGF.call(this, "der", parent);
}
$5PBAa($a8fd65e4690f6d5d$var$DERNode, $h2lGF);
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $a8fd65e4690f6d5d$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = $a8fd65e4690f6d5d$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header1 = $a8fd65e4690f6d5d$require$Buffer.alloc(2 + lenOctets);
    header1[0] = encodedTag;
    header1[1] = 0x80 | lenOctets;
    for(var i1 = 1 + lenOctets, j = content.length; j > 0; i1--, j >>= 8)header1[i1] = j & 0xff;
    return this._createEncoderBuffer([
        header1,
        content
    ]);
};
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = $a8fd65e4690f6d5d$require$Buffer.alloc(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i1 = 0; i1 < id.length; i1++)id[i1] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i2 = 0; i2 < id.length; i2++){
        var ident = id[i2];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = $a8fd65e4690f6d5d$require$Buffer.alloc(size);
    var offset = objid.length - 1;
    for(var i3 = id.length - 1; i3 >= 0; i3--){
        var ident1 = id[i3];
        objid[offset--] = ident1 & 0x7f;
        while((ident1 >>= 7) > 0)objid[offset--] = 0x80 | ident1 & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $a8fd65e4690f6d5d$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        $a8fd65e4690f6d5d$var$two(date.getUTCFullYear()),
        $a8fd65e4690f6d5d$var$two(date.getUTCMonth() + 1),
        $a8fd65e4690f6d5d$var$two(date.getUTCDate()),
        $a8fd65e4690f6d5d$var$two(date.getUTCHours()),
        $a8fd65e4690f6d5d$var$two(date.getUTCMinutes()),
        $a8fd65e4690f6d5d$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $a8fd65e4690f6d5d$var$two(date.getUTCFullYear() % 100),
        $a8fd65e4690f6d5d$var$two(date.getUTCMonth() + 1),
        $a8fd65e4690f6d5d$var$two(date.getUTCDate()),
        $a8fd65e4690f6d5d$var$two(date.getUTCHours()),
        $a8fd65e4690f6d5d$var$two(date.getUTCMinutes()),
        $a8fd65e4690f6d5d$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$a8fd65e4690f6d5d$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $a8fd65e4690f6d5d$require$Buffer.from(numArray);
    }
    if ($a8fd65e4690f6d5d$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = $a8fd65e4690f6d5d$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size1 = 1;
    for(var i = num; i >= 0x100; i >>= 8)size1++;
    var out1 = new Array(size1);
    for(var i1 = out1.length - 1; i1 >= 0; i1--){
        out1[i1] = num & 0xff;
        num >>= 8;
    }
    if (out1[0] & 0x80) out1.unshift(0);
    return this._createEncoderBuffer($a8fd65e4690f6d5d$require$Buffer.from(out1));
};
$a8fd65e4690f6d5d$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$a8fd65e4690f6d5d$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$a8fd65e4690f6d5d$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $a8fd65e4690f6d5d$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($jewlx.tagByName.hasOwnProperty(tag)) res = $jewlx.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $jewlx.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("kfeo7", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $aVMuR = parcelRequire("aVMuR");

var $4pbh3 = parcelRequire("4pbh3");
"use strict";

var $ilnag = parcelRequire("ilnag");
var $ebd05e82bae74990$var$Buffer = $ilnag.Buffer;
var $ebd05e82bae74990$var$safer = {};
var $ebd05e82bae74990$var$key;
for($ebd05e82bae74990$var$key in $ilnag){
    if (!$ilnag.hasOwnProperty($ebd05e82bae74990$var$key)) continue;
    if ($ebd05e82bae74990$var$key === "SlowBuffer" || $ebd05e82bae74990$var$key === "Buffer") continue;
    $ebd05e82bae74990$var$safer[$ebd05e82bae74990$var$key] = $ilnag[$ebd05e82bae74990$var$key];
}
var $ebd05e82bae74990$var$Safer = $ebd05e82bae74990$var$safer.Buffer = {};
for($ebd05e82bae74990$var$key in $ebd05e82bae74990$var$Buffer){
    if (!$ebd05e82bae74990$var$Buffer.hasOwnProperty($ebd05e82bae74990$var$key)) continue;
    if ($ebd05e82bae74990$var$key === "allocUnsafe" || $ebd05e82bae74990$var$key === "allocUnsafeSlow") continue;
    $ebd05e82bae74990$var$Safer[$ebd05e82bae74990$var$key] = $ebd05e82bae74990$var$Buffer[$ebd05e82bae74990$var$key];
}
$ebd05e82bae74990$var$safer.Buffer.prototype = $ebd05e82bae74990$var$Buffer.prototype;
if (!$ebd05e82bae74990$var$Safer.from || $ebd05e82bae74990$var$Safer.from === Uint8Array.from) $ebd05e82bae74990$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
    return $ebd05e82bae74990$var$Buffer(value, encodingOrOffset, length);
};
if (!$ebd05e82bae74990$var$Safer.alloc) $ebd05e82bae74990$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + (typeof size === "undefined" ? "undefined" : (0, $aVMuR._)(size)));
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $ebd05e82bae74990$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$ebd05e82bae74990$var$safer.kStringMaxLength) try {
    $ebd05e82bae74990$var$safer.kStringMaxLength = $4pbh3.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$ebd05e82bae74990$var$safer.constants) {
    $ebd05e82bae74990$var$safer.constants = {
        MAX_LENGTH: $ebd05e82bae74990$var$safer.kMaxLength
    };
    if ($ebd05e82bae74990$var$safer.kStringMaxLength) $ebd05e82bae74990$var$safer.constants.MAX_STRING_LENGTH = $ebd05e82bae74990$var$safer.kStringMaxLength;
}
module.exports = $ebd05e82bae74990$var$safer;

});

parcelRegister("h2lGF", function(module, exports) {
"use strict";

var $E8uQx = parcelRequire("E8uQx");
var $c6737233305720d3$require$Reporter = $E8uQx.Reporter;

var $8Lncl = parcelRequire("8Lncl");
var $c6737233305720d3$require$EncoderBuffer = $8Lncl.EncoderBuffer;

var $8Lncl = parcelRequire("8Lncl");
var $c6737233305720d3$require$DecoderBuffer = $8Lncl.DecoderBuffer;

var $cnNYx = parcelRequire("cnNYx");
// Supported tags
var $c6737233305720d3$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var $c6737233305720d3$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6737233305720d3$var$tags);
// Overrided methods list
var $c6737233305720d3$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6737233305720d3$var$Node(enc, parent, name) {
    var state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6737233305720d3$var$Node;
var $c6737233305720d3$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6737233305720d3$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6737233305720d3$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6737233305720d3$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6737233305720d3$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6737233305720d3$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $cnNYx(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $cnNYx.equal(state.children.length, 1, "Root node can have only one child");
};
$c6737233305720d3$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $cnNYx(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $cnNYx(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6737233305720d3$var$overrided.forEach(function(method) {
    $c6737233305720d3$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6737233305720d3$var$tags.forEach(function(tag) {
    $c6737233305720d3$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $cnNYx(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6737233305720d3$var$Node.prototype.use = function use(item) {
    $cnNYx(item);
    var state = this._baseState;
    $cnNYx(state.use === null);
    state.use = item;
    return this;
};
$c6737233305720d3$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6737233305720d3$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $cnNYx(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6737233305720d3$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $cnNYx(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6737233305720d3$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $cnNYx(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6737233305720d3$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6737233305720d3$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $cnNYx(state.key === null);
    state.key = newKey;
    return this;
};
$c6737233305720d3$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6737233305720d3$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $cnNYx(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6737233305720d3$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $cnNYx(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6737233305720d3$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            var save1;
            if (state.any) save1 = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save1);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new $c6737233305720d3$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6737233305720d3$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6737233305720d3$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $cnNYx(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6737233305720d3$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6737233305720d3$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6737233305720d3$require$EncoderBuffer(data, this.reporter);
};
$c6737233305720d3$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6737233305720d3$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6737233305720d3$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6737233305720d3$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $cnNYx(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6737233305720d3$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6737233305720d3$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6737233305720d3$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("E8uQx", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $078a53c60b568067$export$957313a2f485e5ed; }, function (v) { return $078a53c60b568067$export$957313a2f485e5ed = v; });
var $078a53c60b568067$export$957313a2f485e5ed;
"use strict";

var $5PBAa = parcelRequire("5PBAa");
function $078a53c60b568067$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$078a53c60b568067$export$957313a2f485e5ed = $078a53c60b568067$var$Reporter;
$078a53c60b568067$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $078a53c60b568067$var$ReporterError;
};
$078a53c60b568067$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$078a53c60b568067$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$078a53c60b568067$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$078a53c60b568067$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$078a53c60b568067$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$078a53c60b568067$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$078a53c60b568067$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$078a53c60b568067$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$078a53c60b568067$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $078a53c60b568067$var$ReporterError;
    if (inherited) err = msg;
    else err = new $078a53c60b568067$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$078a53c60b568067$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $078a53c60b568067$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$5PBAa($078a53c60b568067$var$ReporterError, Error);
$078a53c60b568067$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $078a53c60b568067$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("8Lncl", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $6614b532ceaeddbd$export$bf9f79cdc4a49163; }, function (v) { return $6614b532ceaeddbd$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $6614b532ceaeddbd$export$8ff24f7760c7a78e; }, function (v) { return $6614b532ceaeddbd$export$8ff24f7760c7a78e = v; });

var $aVMuR = parcelRequire("aVMuR");
var $6614b532ceaeddbd$export$bf9f79cdc4a49163;
var $6614b532ceaeddbd$export$8ff24f7760c7a78e;
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $E8uQx = parcelRequire("E8uQx");
var $6614b532ceaeddbd$require$Reporter = $E8uQx.Reporter;

var $kfeo7 = parcelRequire("kfeo7");
var $6614b532ceaeddbd$require$Buffer = $kfeo7.Buffer;
function $6614b532ceaeddbd$var$DecoderBuffer(base, options) {
    $6614b532ceaeddbd$require$Reporter.call(this, options);
    if (!$6614b532ceaeddbd$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$5PBAa($6614b532ceaeddbd$var$DecoderBuffer, $6614b532ceaeddbd$require$Reporter);
$6614b532ceaeddbd$export$bf9f79cdc4a49163 = $6614b532ceaeddbd$var$DecoderBuffer;
$6614b532ceaeddbd$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $6614b532ceaeddbd$var$DecoderBuffer) return true;
    // Or accept compatible API
    var isCompatible = typeof data === "object" && $6614b532ceaeddbd$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$6614b532ceaeddbd$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $6614b532ceaeddbd$require$Reporter.prototype.save.call(this)
    };
};
$6614b532ceaeddbd$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $6614b532ceaeddbd$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $6614b532ceaeddbd$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$6614b532ceaeddbd$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$6614b532ceaeddbd$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$6614b532ceaeddbd$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new $6614b532ceaeddbd$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$6614b532ceaeddbd$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $6614b532ceaeddbd$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$6614b532ceaeddbd$var$EncoderBuffer.isEncoderBuffer(item)) item = new $6614b532ceaeddbd$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $6614b532ceaeddbd$require$Buffer.byteLength(value);
    } else if ($6614b532ceaeddbd$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
}
$6614b532ceaeddbd$export$8ff24f7760c7a78e = $6614b532ceaeddbd$var$EncoderBuffer;
$6614b532ceaeddbd$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $6614b532ceaeddbd$var$EncoderBuffer) return true;
    // Or accept compatible API
    var isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$6614b532ceaeddbd$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $6614b532ceaeddbd$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($6614b532ceaeddbd$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("jewlx", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $e0086a73336c8b93$export$3584c46ed60baee8; }, function (v) { return $e0086a73336c8b93$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $e0086a73336c8b93$export$f18596ef8d632e49; }, function (v) { return $e0086a73336c8b93$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $e0086a73336c8b93$export$2b067c6666111485; }, function (v) { return $e0086a73336c8b93$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $e0086a73336c8b93$export$f17df38a421ab9e3; }, function (v) { return $e0086a73336c8b93$export$f17df38a421ab9e3 = v; });
var $e0086a73336c8b93$export$3584c46ed60baee8;
var $e0086a73336c8b93$export$f18596ef8d632e49;
var $e0086a73336c8b93$export$2b067c6666111485;
var $e0086a73336c8b93$export$f17df38a421ab9e3;
"use strict";
// Helper
function $e0086a73336c8b93$var$reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
}
$e0086a73336c8b93$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$e0086a73336c8b93$export$f18596ef8d632e49 = $e0086a73336c8b93$var$reverse($e0086a73336c8b93$export$3584c46ed60baee8);
$e0086a73336c8b93$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$e0086a73336c8b93$export$f17df38a421ab9e3 = $e0086a73336c8b93$var$reverse($e0086a73336c8b93$export$2b067c6666111485);

});


parcelRegister("2OHFy", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $evwNd = parcelRequire("evwNd");
function $20d22011d7222952$var$PEMEncoder(entity) {
    $evwNd.call(this, entity);
    this.enc = "pem";
}
$5PBAa($20d22011d7222952$var$PEMEncoder, $evwNd);
module.exports = $20d22011d7222952$var$PEMEncoder;
$20d22011d7222952$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $evwNd.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("40ecg", function(module, exports) {
"use strict";
var $2ea22cb218ac7f60$var$decoders = module.exports;

$2ea22cb218ac7f60$var$decoders.der = (parcelRequire("gR1Ud"));

$2ea22cb218ac7f60$var$decoders.pem = (parcelRequire("5Ud6C"));

});
parcelRegister("gR1Ud", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $42mVo = parcelRequire("42mVo");

var $8Lncl = parcelRequire("8Lncl");
var $c45312fca1cfabff$require$DecoderBuffer = $8Lncl.DecoderBuffer;

var $h2lGF = parcelRequire("h2lGF");

var $jewlx = parcelRequire("jewlx");
function $c45312fca1cfabff$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c45312fca1cfabff$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c45312fca1cfabff$var$DERDecoder;
$c45312fca1cfabff$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$c45312fca1cfabff$require$DecoderBuffer.isDecoderBuffer(data)) data = new $c45312fca1cfabff$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $c45312fca1cfabff$var$DERNode(parent) {
    $h2lGF.call(this, "der", parent);
}
$5PBAa($c45312fca1cfabff$var$DERNode, $h2lGF);
$c45312fca1cfabff$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $c45312fca1cfabff$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$c45312fca1cfabff$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $c45312fca1cfabff$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $c45312fca1cfabff$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$c45312fca1cfabff$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        var tag = $c45312fca1cfabff$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $c45312fca1cfabff$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res = void 0;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$c45312fca1cfabff$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$c45312fca1cfabff$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$c45312fca1cfabff$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    var subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$c45312fca1cfabff$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    var year;
    var mon;
    var day;
    var hour;
    var min;
    var sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$c45312fca1cfabff$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$c45312fca1cfabff$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$c45312fca1cfabff$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $42mVo(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$c45312fca1cfabff$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $c45312fca1cfabff$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $jewlx.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $jewlx.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $c45312fca1cfabff$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("5Ud6C", function(module, exports) {
"use strict";

var $5PBAa = parcelRequire("5PBAa");

var $kfeo7 = parcelRequire("kfeo7");
var $44cc593a011b37d3$require$Buffer = $kfeo7.Buffer;

var $gR1Ud = parcelRequire("gR1Ud");
function $44cc593a011b37d3$var$PEMDecoder(entity) {
    $gR1Ud.call(this, entity);
    this.enc = "pem";
}
$5PBAa($44cc593a011b37d3$var$PEMDecoder, $gR1Ud);
module.exports = $44cc593a011b37d3$var$PEMDecoder;
$44cc593a011b37d3$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    var input = $44cc593a011b37d3$require$Buffer.from(base64, "base64");
    return $gR1Ud.prototype.decode.call(this, input, options);
};

});



parcelRegister("dAHv4", function(module, exports) {
"use strict";
var $9e506164d7bc5fd6$var$base = module.exports;

$9e506164d7bc5fd6$var$base.Reporter = (parcelRequire("E8uQx")).Reporter;

$9e506164d7bc5fd6$var$base.DecoderBuffer = (parcelRequire("8Lncl")).DecoderBuffer;

$9e506164d7bc5fd6$var$base.EncoderBuffer = (parcelRequire("8Lncl")).EncoderBuffer;

$9e506164d7bc5fd6$var$base.Node = (parcelRequire("h2lGF"));

});

parcelRegister("5qseC", function(module, exports) {
"use strict";
var $3f35484922a47ba9$var$constants = module.exports;
// Helper
$3f35484922a47ba9$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$3f35484922a47ba9$var$constants.der = (parcelRequire("jewlx"));

});


parcelRegister("dlrA2", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $1pbxL = parcelRequire("1pbxL");
var $9b72a15ea1064425$var$Time = $1pbxL.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $9b72a15ea1064425$var$AttributeTypeValue = $1pbxL.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $9b72a15ea1064425$var$AlgorithmIdentifier = $1pbxL.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $9b72a15ea1064425$var$SubjectPublicKeyInfo = $1pbxL.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($9b72a15ea1064425$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $9b72a15ea1064425$var$RelativeDistinguishedName = $1pbxL.define("RelativeDistinguishedName", function() {
    this.setof($9b72a15ea1064425$var$AttributeTypeValue);
});
var $9b72a15ea1064425$var$RDNSequence = $1pbxL.define("RDNSequence", function() {
    this.seqof($9b72a15ea1064425$var$RelativeDistinguishedName);
});
var $9b72a15ea1064425$var$Name = $1pbxL.define("Name", function() {
    this.choice({
        rdnSequence: this.use($9b72a15ea1064425$var$RDNSequence)
    });
});
var $9b72a15ea1064425$var$Validity = $1pbxL.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($9b72a15ea1064425$var$Time), this.key("notAfter").use($9b72a15ea1064425$var$Time));
});
var $9b72a15ea1064425$var$Extension = $1pbxL.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $9b72a15ea1064425$var$TBSCertificate = $1pbxL.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($9b72a15ea1064425$var$AlgorithmIdentifier), this.key("issuer").use($9b72a15ea1064425$var$Name), this.key("validity").use($9b72a15ea1064425$var$Validity), this.key("subject").use($9b72a15ea1064425$var$Name), this.key("subjectPublicKeyInfo").use($9b72a15ea1064425$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($9b72a15ea1064425$var$Extension).optional());
});
var $9b72a15ea1064425$var$X509Certificate = $1pbxL.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($9b72a15ea1064425$var$TBSCertificate), this.key("signatureAlgorithm").use($9b72a15ea1064425$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $9b72a15ea1064425$var$X509Certificate;

});


parcelRegister("2qeZr", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("e087Y", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $a3175ebec4d72d2e$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $a3175ebec4d72d2e$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $a3175ebec4d72d2e$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bwmjr = parcelRequire("bwmjr");

var $c2PdS = parcelRequire("c2PdS");

var $b1nU2 = parcelRequire("b1nU2");
var $a3175ebec4d72d2e$require$Buffer = $b1nU2.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($a3175ebec4d72d2e$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($a3175ebec4d72d2e$var$fullRegex);
        decrypted = $a3175ebec4d72d2e$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $a3175ebec4d72d2e$require$Buffer.from(match[2], "hex");
        var cipherText = $a3175ebec4d72d2e$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bwmjr(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $c2PdS.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $a3175ebec4d72d2e$require$Buffer.concat(out);
    }
    var tag = key.match($a3175ebec4d72d2e$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("6U3Hg", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("boMzq", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $b1nU2 = parcelRequire("b1nU2");
var $84c79cadc8f87e0e$require$Buffer = $b1nU2.Buffer;

var $h2Lk1 = parcelRequire("h2Lk1");

var $aW3Sp = parcelRequire("aW3Sp");
var $84c79cadc8f87e0e$require$EC = $aW3Sp.ec;

var $lbG4j = parcelRequire("lbG4j");

var $6U3Hg = parcelRequire("6U3Hg");
function $84c79cadc8f87e0e$var$verify(sig, hash, key, signType, tag) {
    var pub = $lbG4j(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $84c79cadc8f87e0e$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $84c79cadc8f87e0e$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $84c79cadc8f87e0e$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $84c79cadc8f87e0e$require$Buffer.from(pad);
    var red = $h2Lk1.mont(pub.modulus);
    sig = new $h2Lk1(sig).toRed(red);
    sig = sig.redPow(new $h2Lk1(pub.publicExponent));
    sig = $84c79cadc8f87e0e$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $84c79cadc8f87e0e$var$ecVerify(sig, hash, pub) {
    var curveId = $6U3Hg[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $84c79cadc8f87e0e$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $84c79cadc8f87e0e$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $lbG4j.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $84c79cadc8f87e0e$var$checkValue(s, q);
    $84c79cadc8f87e0e$var$checkValue(r, q);
    var montp = $h2Lk1.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $h2Lk1(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $84c79cadc8f87e0e$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $84c79cadc8f87e0e$var$verify;

});


parcelRegister("5UR9D", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $44eb6a113b9054ca$require$Buffer = $ilnag.Buffer;

var $aW3Sp = parcelRequire("aW3Sp");

var $42mVo = parcelRequire("42mVo");
module.exports = function createECDH(curve) {
    return new $44eb6a113b9054ca$var$ECDH(curve);
};
var $44eb6a113b9054ca$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$44eb6a113b9054ca$var$aliases.p224 = $44eb6a113b9054ca$var$aliases.secp224r1;
$44eb6a113b9054ca$var$aliases.p256 = $44eb6a113b9054ca$var$aliases.secp256r1 = $44eb6a113b9054ca$var$aliases.prime256v1;
$44eb6a113b9054ca$var$aliases.p192 = $44eb6a113b9054ca$var$aliases.secp192r1 = $44eb6a113b9054ca$var$aliases.prime192v1;
$44eb6a113b9054ca$var$aliases.p384 = $44eb6a113b9054ca$var$aliases.secp384r1;
$44eb6a113b9054ca$var$aliases.p521 = $44eb6a113b9054ca$var$aliases.secp521r1;
function $44eb6a113b9054ca$var$ECDH(curve) {
    this.curveType = $44eb6a113b9054ca$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $aW3Sp.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$44eb6a113b9054ca$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$44eb6a113b9054ca$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$44eb6a113b9054ca$require$Buffer.isBuffer(other)) other = new $44eb6a113b9054ca$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $44eb6a113b9054ca$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$44eb6a113b9054ca$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $44eb6a113b9054ca$var$formatReturnValue(key, enc);
};
$44eb6a113b9054ca$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $44eb6a113b9054ca$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$44eb6a113b9054ca$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$44eb6a113b9054ca$require$Buffer.isBuffer(pub)) pub = new $44eb6a113b9054ca$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$44eb6a113b9054ca$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$44eb6a113b9054ca$require$Buffer.isBuffer(priv)) priv = new $44eb6a113b9054ca$require$Buffer(priv, enc);
    var _priv = new $42mVo(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $44eb6a113b9054ca$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $44eb6a113b9054ca$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $44eb6a113b9054ca$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $44eb6a113b9054ca$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("3Xg05", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $2e134b2744e7d391$export$512823e338ddb1b7; }, function (v) { return $2e134b2744e7d391$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $2e134b2744e7d391$export$7efb24e2fddf99b9; }, function (v) { return $2e134b2744e7d391$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $2e134b2744e7d391$export$9d0e0c0c4a8d30f3; }, function (v) { return $2e134b2744e7d391$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $2e134b2744e7d391$export$b9d55ff329113abd; }, function (v) { return $2e134b2744e7d391$export$b9d55ff329113abd = v; });
var $2e134b2744e7d391$export$512823e338ddb1b7;
var $2e134b2744e7d391$export$7efb24e2fddf99b9;
var $2e134b2744e7d391$export$9d0e0c0c4a8d30f3;
var $2e134b2744e7d391$export$b9d55ff329113abd;

$2e134b2744e7d391$export$512823e338ddb1b7 = (parcelRequire("9aUzd"));

$2e134b2744e7d391$export$7efb24e2fddf99b9 = (parcelRequire("ifeT7"));
$2e134b2744e7d391$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $2e134b2744e7d391$export$512823e338ddb1b7(key, buf, true);
};
$2e134b2744e7d391$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $2e134b2744e7d391$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("9aUzd", function(module, exports) {

var $lbG4j = parcelRequire("lbG4j");

var $2gcE5 = parcelRequire("2gcE5");

var $jMOyI = parcelRequire("jMOyI");

var $1Cequ = parcelRequire("1Cequ");

var $6X77V = parcelRequire("6X77V");

var $42mVo = parcelRequire("42mVo");

var $jrcRy = parcelRequire("jrcRy");

var $58VOR = parcelRequire("58VOR");

var $b1nU2 = parcelRequire("b1nU2");
var $6ae0ed4417a76faa$require$Buffer = $b1nU2.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lbG4j(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6ae0ed4417a76faa$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6ae0ed4417a76faa$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $42mVo(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $58VOR(paddedMsg, key);
    else return $jrcRy(paddedMsg, key);
};
function $6ae0ed4417a76faa$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $jMOyI("sha1").update($6ae0ed4417a76faa$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6ae0ed4417a76faa$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $2gcE5(hLen);
    var maskedDb = $6X77V($6ae0ed4417a76faa$require$Buffer.concat([
        iHash,
        ps,
        $6ae0ed4417a76faa$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $1Cequ(seed, dblen));
    var maskedSeed = $6X77V(seed, $1Cequ(maskedDb, hLen));
    return new $42mVo($6ae0ed4417a76faa$require$Buffer.concat([
        $6ae0ed4417a76faa$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6ae0ed4417a76faa$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6ae0ed4417a76faa$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6ae0ed4417a76faa$var$nonZero(k - mLen - 3);
    return new $42mVo($6ae0ed4417a76faa$require$Buffer.concat([
        $6ae0ed4417a76faa$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6ae0ed4417a76faa$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6ae0ed4417a76faa$var$nonZero(len) {
    var out = $6ae0ed4417a76faa$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $2gcE5(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $2gcE5(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("1Cequ", function(module, exports) {

var $jMOyI = parcelRequire("jMOyI");

var $b1nU2 = parcelRequire("b1nU2");
var $12d487c9697e4033$require$Buffer = $b1nU2.Buffer;
module.exports = function(seed, len) {
    var t = $12d487c9697e4033$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $12d487c9697e4033$var$i2ops(i++);
        t = $12d487c9697e4033$require$Buffer.concat([
            t,
            $jMOyI("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $12d487c9697e4033$var$i2ops(c) {
    var out = $12d487c9697e4033$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6X77V", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("jrcRy", function(module, exports) {

var $42mVo = parcelRequire("42mVo");

var $b1nU2 = parcelRequire("b1nU2");
var $e26a84341e6e1cf4$require$Buffer = $b1nU2.Buffer;
function $e26a84341e6e1cf4$var$withPublic(paddedMsg, key) {
    return $e26a84341e6e1cf4$require$Buffer.from(paddedMsg.toRed($42mVo.mont(key.modulus)).redPow(new $42mVo(key.publicExponent)).fromRed().toArray());
}
module.exports = $e26a84341e6e1cf4$var$withPublic;

});


parcelRegister("ifeT7", function(module, exports) {

var $lbG4j = parcelRequire("lbG4j");

var $1Cequ = parcelRequire("1Cequ");

var $6X77V = parcelRequire("6X77V");

var $42mVo = parcelRequire("42mVo");

var $58VOR = parcelRequire("58VOR");

var $jMOyI = parcelRequire("jMOyI");

var $jrcRy = parcelRequire("jrcRy");

var $b1nU2 = parcelRequire("b1nU2");
var $d4852d281b7d9a9a$require$Buffer = $b1nU2.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lbG4j(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $42mVo(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $jrcRy(new $42mVo(enc), key);
    else msg = $58VOR(enc, key);
    var zBuffer = $d4852d281b7d9a9a$require$Buffer.alloc(k - msg.length);
    msg = $d4852d281b7d9a9a$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $d4852d281b7d9a9a$var$oaep(key, msg);
    else if (padding === 1) return $d4852d281b7d9a9a$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $d4852d281b7d9a9a$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $jMOyI("sha1").update($d4852d281b7d9a9a$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6X77V(maskedSeed, $1Cequ(maskedDb, hLen));
    var db = $6X77V(maskedDb, $1Cequ(seed, k - hLen - 1));
    if ($d4852d281b7d9a9a$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $d4852d281b7d9a9a$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $d4852d281b7d9a9a$var$compare(a, b) {
    a = $d4852d281b7d9a9a$require$Buffer.from(a);
    b = $d4852d281b7d9a9a$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("bsRb8", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $858b8f64e21026b0$export$bb1abf2ce84fc7e8; }, function (v) { return $858b8f64e21026b0$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $858b8f64e21026b0$export$2f7171e78e524d5e; }, function (v) { return $858b8f64e21026b0$export$2f7171e78e524d5e = v; });
var $858b8f64e21026b0$export$bb1abf2ce84fc7e8;
var $858b8f64e21026b0$export$2f7171e78e524d5e;

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
function $858b8f64e21026b0$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $b1nU2 = parcelRequire("b1nU2");

var $2gcE5 = parcelRequire("2gcE5");
var $858b8f64e21026b0$var$Buffer = $b1nU2.Buffer;
var $858b8f64e21026b0$var$kBufferMaxLength = $b1nU2.kMaxLength;
var $858b8f64e21026b0$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $858b8f64e21026b0$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $858b8f64e21026b0$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $858b8f64e21026b0$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $858b8f64e21026b0$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $858b8f64e21026b0$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $858b8f64e21026b0$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $858b8f64e21026b0$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($858b8f64e21026b0$var$crypto && $858b8f64e21026b0$var$crypto.getRandomValues || false) {
    $858b8f64e21026b0$export$bb1abf2ce84fc7e8 = $858b8f64e21026b0$var$randomFill;
    $858b8f64e21026b0$export$2f7171e78e524d5e = $858b8f64e21026b0$var$randomFillSync;
} else {
    $858b8f64e21026b0$export$bb1abf2ce84fc7e8 = $858b8f64e21026b0$var$oldBrowser;
    $858b8f64e21026b0$export$2f7171e78e524d5e = $858b8f64e21026b0$var$oldBrowser;
}
function $858b8f64e21026b0$var$randomFill(buf, offset, size, cb) {
    if (!$858b8f64e21026b0$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $858b8f64e21026b0$var$assertOffset(offset, buf.length);
    $858b8f64e21026b0$var$assertSize(size, offset, buf.length);
    return $858b8f64e21026b0$var$actualFill(buf, offset, size, cb);
}
function $858b8f64e21026b0$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $858b8f64e21026b0$var$crypto.getRandomValues(uint);
    if (cb) {
        $4pbh3.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $2gcE5(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $2gcE5(size);
    bytes.copy(buf, offset);
    return buf;
}
function $858b8f64e21026b0$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$858b8f64e21026b0$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $858b8f64e21026b0$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $858b8f64e21026b0$var$assertSize(size, offset, buf.length);
    return $858b8f64e21026b0$var$actualFill(buf, offset, size);
}

});




parcelRegister("iGt81", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("5g2av", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("hjb8Q", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("lYaBw"));

});
parcelRegister("lYaBw", function(module, exports) {
"use strict";
var $ffe76d5bf1d76177$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $ffe76d5bf1d76177$var$protobuf.build = "minimal";

// Serialization
$ffe76d5bf1d76177$var$protobuf.Writer = (parcelRequire("lqVDl"));

$ffe76d5bf1d76177$var$protobuf.BufferWriter = (parcelRequire("3DO47"));

$ffe76d5bf1d76177$var$protobuf.Reader = (parcelRequire("4LeT3"));

$ffe76d5bf1d76177$var$protobuf.BufferReader = (parcelRequire("6cr6i"));

// Utility
$ffe76d5bf1d76177$var$protobuf.util = (parcelRequire("i5FuJ"));

$ffe76d5bf1d76177$var$protobuf.rpc = (parcelRequire("iwblW"));

$ffe76d5bf1d76177$var$protobuf.roots = (parcelRequire("5hexN"));
$ffe76d5bf1d76177$var$protobuf.configure = $ffe76d5bf1d76177$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $ffe76d5bf1d76177$var$configure() {
    $ffe76d5bf1d76177$var$protobuf.util._configure();
    $ffe76d5bf1d76177$var$protobuf.Writer._configure($ffe76d5bf1d76177$var$protobuf.BufferWriter);
    $ffe76d5bf1d76177$var$protobuf.Reader._configure($ffe76d5bf1d76177$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$ffe76d5bf1d76177$var$configure();

});
parcelRegister("lqVDl", function(module, exports) {
"use strict";
module.exports = $f9a8bb7dae0dbe05$var$Writer;

var $i5FuJ = parcelRequire("i5FuJ");
var $f9a8bb7dae0dbe05$var$BufferWriter; // cyclic
var $f9a8bb7dae0dbe05$var$LongBits = $i5FuJ.LongBits, $f9a8bb7dae0dbe05$var$base64 = $i5FuJ.base64, $f9a8bb7dae0dbe05$var$utf8 = $i5FuJ.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $f9a8bb7dae0dbe05$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $f9a8bb7dae0dbe05$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $f9a8bb7dae0dbe05$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $f9a8bb7dae0dbe05$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $f9a8bb7dae0dbe05$var$Op($f9a8bb7dae0dbe05$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $f9a8bb7dae0dbe05$var$create = function create() {
    return $i5FuJ.Buffer ? function create_buffer_setup() {
        return ($f9a8bb7dae0dbe05$var$Writer.create = function create_buffer() {
            return new $f9a8bb7dae0dbe05$var$BufferWriter();
        })();
    } : function create_array() {
        return new $f9a8bb7dae0dbe05$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $f9a8bb7dae0dbe05$var$Writer.create = $f9a8bb7dae0dbe05$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $f9a8bb7dae0dbe05$var$Writer.alloc = function alloc(size) {
    return new $i5FuJ.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($i5FuJ.Array !== Array) $f9a8bb7dae0dbe05$var$Writer.alloc = $i5FuJ.pool($f9a8bb7dae0dbe05$var$Writer.alloc, $i5FuJ.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $f9a8bb7dae0dbe05$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $f9a8bb7dae0dbe05$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $f9a8bb7dae0dbe05$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $f9a8bb7dae0dbe05$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $f9a8bb7dae0dbe05$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$f9a8bb7dae0dbe05$var$VarintOp.prototype = Object.create($f9a8bb7dae0dbe05$var$Op.prototype);
$f9a8bb7dae0dbe05$var$VarintOp.prototype.fn = $f9a8bb7dae0dbe05$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $f9a8bb7dae0dbe05$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($f9a8bb7dae0dbe05$var$writeVarint64, 10, $f9a8bb7dae0dbe05$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $f9a8bb7dae0dbe05$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $f9a8bb7dae0dbe05$var$LongBits.from(value);
    return this._push($f9a8bb7dae0dbe05$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.int64 = $f9a8bb7dae0dbe05$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $f9a8bb7dae0dbe05$var$LongBits.from(value).zzEncode();
    return this._push($f9a8bb7dae0dbe05$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($f9a8bb7dae0dbe05$var$writeByte, 1, value ? 1 : 0);
};
function $f9a8bb7dae0dbe05$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($f9a8bb7dae0dbe05$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.sfixed32 = $f9a8bb7dae0dbe05$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $f9a8bb7dae0dbe05$var$LongBits.from(value);
    return this._push($f9a8bb7dae0dbe05$var$writeFixed32, 4, bits.lo)._push($f9a8bb7dae0dbe05$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.sfixed64 = $f9a8bb7dae0dbe05$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.float = function write_float(value) {
    return this._push($i5FuJ.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.double = function write_double(value) {
    return this._push($i5FuJ.float.writeDoubleLE, 8, value);
};
var $f9a8bb7dae0dbe05$var$writeBytes = $i5FuJ.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($f9a8bb7dae0dbe05$var$writeByte, 1, 0);
    if ($i5FuJ.isString(value)) {
        var buf = $f9a8bb7dae0dbe05$var$Writer.alloc(len = $f9a8bb7dae0dbe05$var$base64.length(value));
        $f9a8bb7dae0dbe05$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($f9a8bb7dae0dbe05$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.string = function write_string(value) {
    var len = $f9a8bb7dae0dbe05$var$utf8.length(value);
    return len ? this.uint32(len)._push($f9a8bb7dae0dbe05$var$utf8.write, len, value) : this._push($f9a8bb7dae0dbe05$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.fork = function fork() {
    this.states = new $f9a8bb7dae0dbe05$var$State(this);
    this.head = this.tail = new $f9a8bb7dae0dbe05$var$Op($f9a8bb7dae0dbe05$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $f9a8bb7dae0dbe05$var$Op($f9a8bb7dae0dbe05$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $f9a8bb7dae0dbe05$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$f9a8bb7dae0dbe05$var$Writer._configure = function(BufferWriter_) {
    $f9a8bb7dae0dbe05$var$BufferWriter = BufferWriter_;
    $f9a8bb7dae0dbe05$var$Writer.create = $f9a8bb7dae0dbe05$var$create();
    $f9a8bb7dae0dbe05$var$BufferWriter._configure();
};

});
parcelRegister("i5FuJ", function(module, exports) {
"use strict";
var $d2b8e1937e440607$var$util = module.exports;

// used to return a Promise where callback is omitted
$d2b8e1937e440607$var$util.asPromise = (parcelRequire("dYDcG"));

// converts to / from base64 encoded strings
$d2b8e1937e440607$var$util.base64 = (parcelRequire("21ZPc"));

// base class of rpc.Service
$d2b8e1937e440607$var$util.EventEmitter = (parcelRequire("fNECB"));

// float handling accross browsers
$d2b8e1937e440607$var$util.float = (parcelRequire("8ED1Q"));

// requires modules optionally and hides the call from bundlers
$d2b8e1937e440607$var$util.inquire = (parcelRequire("7TITA"));

// converts to / from utf8 encoded strings
$d2b8e1937e440607$var$util.utf8 = (parcelRequire("aMar9"));

// provides a node-like buffer pool in the browser
$d2b8e1937e440607$var$util.pool = (parcelRequire("hUSRn"));

// utility to work with the low and high bits of a 64 bit value
$d2b8e1937e440607$var$util.LongBits = (parcelRequire("6flqM"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $d2b8e1937e440607$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $d2b8e1937e440607$var$util.global = $d2b8e1937e440607$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $d2b8e1937e440607$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $d2b8e1937e440607$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $d2b8e1937e440607$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $d2b8e1937e440607$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $d2b8e1937e440607$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $d2b8e1937e440607$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $d2b8e1937e440607$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $d2b8e1937e440607$var$util.Buffer = function() {
    try {
        var Buffer = $d2b8e1937e440607$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$d2b8e1937e440607$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$d2b8e1937e440607$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $d2b8e1937e440607$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $d2b8e1937e440607$var$util.Buffer ? $d2b8e1937e440607$var$util._Buffer_allocUnsafe(sizeOrArray) : new $d2b8e1937e440607$var$util.Array(sizeOrArray) : $d2b8e1937e440607$var$util.Buffer ? $d2b8e1937e440607$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $d2b8e1937e440607$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $d2b8e1937e440607$var$util.Long = /* istanbul ignore next */ $d2b8e1937e440607$var$util.global.dcodeIO && /* istanbul ignore next */ $d2b8e1937e440607$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $d2b8e1937e440607$var$util.global.Long || $d2b8e1937e440607$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $d2b8e1937e440607$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $d2b8e1937e440607$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $d2b8e1937e440607$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $d2b8e1937e440607$var$util.longToHash = function longToHash(value) {
    return value ? $d2b8e1937e440607$var$util.LongBits.from(value).toHash() : $d2b8e1937e440607$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $d2b8e1937e440607$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $d2b8e1937e440607$var$util.LongBits.fromHash(hash);
    if ($d2b8e1937e440607$var$util.Long) return $d2b8e1937e440607$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $d2b8e1937e440607$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$d2b8e1937e440607$var$util.merge = $d2b8e1937e440607$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $d2b8e1937e440607$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $d2b8e1937e440607$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function get() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $d2b8e1937e440607$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function get() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$d2b8e1937e440607$var$util.newError = $d2b8e1937e440607$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $d2b8e1937e440607$var$util.ProtocolError = $d2b8e1937e440607$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $d2b8e1937e440607$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $d2b8e1937e440607$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $d2b8e1937e440607$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$d2b8e1937e440607$var$util._configure = function() {
    var Buffer = $d2b8e1937e440607$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $d2b8e1937e440607$var$util._Buffer_from = $d2b8e1937e440607$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $d2b8e1937e440607$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $d2b8e1937e440607$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("dYDcG", function(module, exports) {
"use strict";
module.exports = $a2cf49f8e5590fe7$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $a2cf49f8e5590fe7$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("21ZPc", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $17aba1e062642f4f$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $17aba1e062642f4f$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $17aba1e062642f4f$var$b64 = new Array(64);
// Base64 decoding table
var $17aba1e062642f4f$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $17aba1e062642f4f$var$i = 0; $17aba1e062642f4f$var$i < 64;)$17aba1e062642f4f$var$s64[$17aba1e062642f4f$var$b64[$17aba1e062642f4f$var$i] = $17aba1e062642f4f$var$i < 26 ? $17aba1e062642f4f$var$i + 65 : $17aba1e062642f4f$var$i < 52 ? $17aba1e062642f4f$var$i + 71 : $17aba1e062642f4f$var$i < 62 ? $17aba1e062642f4f$var$i - 4 : $17aba1e062642f4f$var$i - 59 | 43] = $17aba1e062642f4f$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $17aba1e062642f4f$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $17aba1e062642f4f$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $17aba1e062642f4f$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $17aba1e062642f4f$var$b64[t | b >> 6];
                chunk[i++] = $17aba1e062642f4f$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $17aba1e062642f4f$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $17aba1e062642f4f$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $17aba1e062642f4f$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $17aba1e062642f4f$var$s64[c]) === undefined) throw Error($17aba1e062642f4f$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($17aba1e062642f4f$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $17aba1e062642f4f$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("fNECB", function(module, exports) {
"use strict";
module.exports = $b80af1403349cf42$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $b80af1403349cf42$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $b80af1403349cf42$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $b80af1403349cf42$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $b80af1403349cf42$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("8ED1Q", function(module, exports) {
"use strict";
module.exports = $64d0557743689845$var$factory($64d0557743689845$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $64d0557743689845$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $64d0557743689845$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $64d0557743689845$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $64d0557743689845$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $64d0557743689845$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $64d0557743689845$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $64d0557743689845$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $64d0557743689845$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $64d0557743689845$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $64d0557743689845$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $64d0557743689845$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $64d0557743689845$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $64d0557743689845$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("7TITA", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRegister("aMar9", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $7d867ba587d56c94$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $7d867ba587d56c94$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $7d867ba587d56c94$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $7d867ba587d56c94$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("hUSRn", function(module, exports) {
"use strict";
module.exports = $d0b238af826c5e9d$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $d0b238af826c5e9d$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("6flqM", function(module, exports) {
"use strict";
module.exports = $48c4c48408b22307$var$LongBits;

var $i5FuJ = parcelRequire("i5FuJ");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $48c4c48408b22307$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $48c4c48408b22307$var$zero = $48c4c48408b22307$var$LongBits.zero = new $48c4c48408b22307$var$LongBits(0, 0);
$48c4c48408b22307$var$zero.toNumber = function() {
    return 0;
};
$48c4c48408b22307$var$zero.zzEncode = $48c4c48408b22307$var$zero.zzDecode = function() {
    return this;
};
$48c4c48408b22307$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $48c4c48408b22307$var$zeroHash = $48c4c48408b22307$var$LongBits.zeroHash = "\x00\x00\x00\x00\x00\x00\x00\x00";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $48c4c48408b22307$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $48c4c48408b22307$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $48c4c48408b22307$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $48c4c48408b22307$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $48c4c48408b22307$var$LongBits.fromNumber(value);
    if ($i5FuJ.isString(value)) {
        /* istanbul ignore else */ if ($i5FuJ.Long) value = $i5FuJ.Long.fromString(value);
        else return $48c4c48408b22307$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $48c4c48408b22307$var$LongBits(value.low >>> 0, value.high >>> 0) : $48c4c48408b22307$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $48c4c48408b22307$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $48c4c48408b22307$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $i5FuJ.Long ? new $i5FuJ.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $48c4c48408b22307$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $48c4c48408b22307$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $48c4c48408b22307$var$zeroHash) return $48c4c48408b22307$var$zero;
    return new $48c4c48408b22307$var$LongBits(($48c4c48408b22307$var$charCodeAt.call(hash, 0) | $48c4c48408b22307$var$charCodeAt.call(hash, 1) << 8 | $48c4c48408b22307$var$charCodeAt.call(hash, 2) << 16 | $48c4c48408b22307$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($48c4c48408b22307$var$charCodeAt.call(hash, 4) | $48c4c48408b22307$var$charCodeAt.call(hash, 5) << 8 | $48c4c48408b22307$var$charCodeAt.call(hash, 6) << 16 | $48c4c48408b22307$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $48c4c48408b22307$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $48c4c48408b22307$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $48c4c48408b22307$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $48c4c48408b22307$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("3DO47", function(module, exports) {
"use strict";
module.exports = $2a6bd98da5ec731f$var$BufferWriter;

var $lqVDl = parcelRequire("lqVDl");
($2a6bd98da5ec731f$var$BufferWriter.prototype = Object.create($lqVDl.prototype)).constructor = $2a6bd98da5ec731f$var$BufferWriter;

var $i5FuJ = parcelRequire("i5FuJ");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $2a6bd98da5ec731f$var$BufferWriter() {
    $lqVDl.call(this);
}
$2a6bd98da5ec731f$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $2a6bd98da5ec731f$var$BufferWriter.alloc = $i5FuJ._Buffer_allocUnsafe;
    $2a6bd98da5ec731f$var$BufferWriter.writeBytesBuffer = $i5FuJ.Buffer && $i5FuJ.Buffer.prototype instanceof Uint8Array && $i5FuJ.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $2a6bd98da5ec731f$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($i5FuJ.isString(value)) value = $i5FuJ._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($2a6bd98da5ec731f$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $2a6bd98da5ec731f$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $i5FuJ.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $2a6bd98da5ec731f$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $i5FuJ.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($2a6bd98da5ec731f$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $2a6bd98da5ec731f$var$BufferWriter._configure();

});

parcelRegister("4LeT3", function(module, exports) {
"use strict";
module.exports = $37771975f1d438d1$var$Reader;

var $i5FuJ = parcelRequire("i5FuJ");
var $37771975f1d438d1$var$BufferReader; // cyclic
var $37771975f1d438d1$var$LongBits = $i5FuJ.LongBits, $37771975f1d438d1$var$utf8 = $i5FuJ.utf8;
/* istanbul ignore next */ function $37771975f1d438d1$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $37771975f1d438d1$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $37771975f1d438d1$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $37771975f1d438d1$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $37771975f1d438d1$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $37771975f1d438d1$var$create = function create() {
    return $i5FuJ.Buffer ? function create_buffer_setup(buffer) {
        return ($37771975f1d438d1$var$Reader.create = function create_buffer(buffer) {
            return $i5FuJ.Buffer.isBuffer(buffer) ? new $37771975f1d438d1$var$BufferReader(buffer) : $37771975f1d438d1$var$create_array(buffer);
        })(buffer);
    } : $37771975f1d438d1$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $37771975f1d438d1$var$Reader.create = $37771975f1d438d1$var$create();
$37771975f1d438d1$var$Reader.prototype._slice = $i5FuJ.Array.prototype.subarray || /* istanbul ignore next */ $i5FuJ.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $37771975f1d438d1$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $37771975f1d438d1$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $37771975f1d438d1$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $37771975f1d438d1$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $37771975f1d438d1$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $37771975f1d438d1$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $37771975f1d438d1$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, 4);
    return $37771975f1d438d1$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, 4);
    return $37771975f1d438d1$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $37771975f1d438d1$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, 8);
    return new $37771975f1d438d1$var$LongBits($37771975f1d438d1$var$readFixed32_end(this.buf, this.pos += 4), $37771975f1d438d1$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, 4);
    var value = $i5FuJ.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $37771975f1d438d1$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, 4);
    var value = $i5FuJ.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $37771975f1d438d1$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $37771975f1d438d1$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $37771975f1d438d1$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $37771975f1d438d1$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $37771975f1d438d1$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $37771975f1d438d1$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $37771975f1d438d1$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$37771975f1d438d1$var$Reader._configure = function(BufferReader_) {
    $37771975f1d438d1$var$BufferReader = BufferReader_;
    $37771975f1d438d1$var$Reader.create = $37771975f1d438d1$var$create();
    $37771975f1d438d1$var$BufferReader._configure();
    var fn = $i5FuJ.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $i5FuJ.merge($37771975f1d438d1$var$Reader.prototype, {
        int64: function read_int64() {
            return $37771975f1d438d1$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $37771975f1d438d1$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $37771975f1d438d1$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $37771975f1d438d1$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $37771975f1d438d1$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("6cr6i", function(module, exports) {
"use strict";
module.exports = $4838e2b056975fc3$var$BufferReader;

var $4LeT3 = parcelRequire("4LeT3");
($4838e2b056975fc3$var$BufferReader.prototype = Object.create($4LeT3.prototype)).constructor = $4838e2b056975fc3$var$BufferReader;

var $i5FuJ = parcelRequire("i5FuJ");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $4838e2b056975fc3$var$BufferReader(buffer) {
    $4LeT3.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$4838e2b056975fc3$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($i5FuJ.Buffer) $4838e2b056975fc3$var$BufferReader.prototype._slice = $i5FuJ.Buffer.prototype.slice;
};
/**
 * @override
 */ $4838e2b056975fc3$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $4838e2b056975fc3$var$BufferReader._configure();

});

parcelRegister("iwblW", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $d7b4059e03ac1255$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $d7b4059e03ac1255$var$rpc.Service = (parcelRequire("hFjYs"));

});
parcelRegister("hFjYs", function(module, exports) {
"use strict";
module.exports = $cdc5c271a6cebc44$var$Service;

var $i5FuJ = parcelRequire("i5FuJ");
// Extends EventEmitter
($cdc5c271a6cebc44$var$Service.prototype = Object.create($i5FuJ.EventEmitter.prototype)).constructor = $cdc5c271a6cebc44$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $cdc5c271a6cebc44$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $i5FuJ.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $cdc5c271a6cebc44$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $i5FuJ.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $cdc5c271a6cebc44$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("5hexN", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});



parcelRegister("l6G6L", function(module, exports) {
module.exports = $f5dad24a1eddf046$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $f5dad24a1eddf046$var$wasm = null;
try {
    $f5dad24a1eddf046$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $f5dad24a1eddf046$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $f5dad24a1eddf046$var$Long.prototype.__isLong__;
Object.defineProperty($f5dad24a1eddf046$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $f5dad24a1eddf046$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$Long.isLong = $f5dad24a1eddf046$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $f5dad24a1eddf046$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $f5dad24a1eddf046$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $f5dad24a1eddf046$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $f5dad24a1eddf046$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $f5dad24a1eddf046$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $f5dad24a1eddf046$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $f5dad24a1eddf046$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $f5dad24a1eddf046$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $f5dad24a1eddf046$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromInt = $f5dad24a1eddf046$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $f5dad24a1eddf046$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $f5dad24a1eddf046$var$UZERO : $f5dad24a1eddf046$var$ZERO;
    if (unsigned) {
        if (value < 0) return $f5dad24a1eddf046$var$UZERO;
        if (value >= $f5dad24a1eddf046$var$TWO_PWR_64_DBL) return $f5dad24a1eddf046$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$f5dad24a1eddf046$var$TWO_PWR_63_DBL) return $f5dad24a1eddf046$var$MIN_VALUE;
        if (value + 1 >= $f5dad24a1eddf046$var$TWO_PWR_63_DBL) return $f5dad24a1eddf046$var$MAX_VALUE;
    }
    if (value < 0) return $f5dad24a1eddf046$var$fromNumber(-value, unsigned).neg();
    return $f5dad24a1eddf046$var$fromBits(value % $f5dad24a1eddf046$var$TWO_PWR_32_DBL | 0, value / $f5dad24a1eddf046$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromNumber = $f5dad24a1eddf046$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $f5dad24a1eddf046$var$fromBits(lowBits, highBits, unsigned) {
    return new $f5dad24a1eddf046$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromBits = $f5dad24a1eddf046$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $f5dad24a1eddf046$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $f5dad24a1eddf046$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $f5dad24a1eddf046$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $f5dad24a1eddf046$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $f5dad24a1eddf046$var$fromNumber($f5dad24a1eddf046$var$pow_dbl(radix, 8));
    var result = $f5dad24a1eddf046$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $f5dad24a1eddf046$var$fromNumber($f5dad24a1eddf046$var$pow_dbl(radix, size));
            result = result.mul(power).add($f5dad24a1eddf046$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($f5dad24a1eddf046$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromString = $f5dad24a1eddf046$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $f5dad24a1eddf046$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $f5dad24a1eddf046$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $f5dad24a1eddf046$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $f5dad24a1eddf046$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $f5dad24a1eddf046$var$Long.fromValue = $f5dad24a1eddf046$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $f5dad24a1eddf046$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $f5dad24a1eddf046$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $f5dad24a1eddf046$var$TWO_PWR_32_DBL = $f5dad24a1eddf046$var$TWO_PWR_16_DBL * $f5dad24a1eddf046$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $f5dad24a1eddf046$var$TWO_PWR_64_DBL = $f5dad24a1eddf046$var$TWO_PWR_32_DBL * $f5dad24a1eddf046$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $f5dad24a1eddf046$var$TWO_PWR_63_DBL = $f5dad24a1eddf046$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $f5dad24a1eddf046$var$TWO_PWR_24 = $f5dad24a1eddf046$var$fromInt($f5dad24a1eddf046$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$ZERO = $f5dad24a1eddf046$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.ZERO = $f5dad24a1eddf046$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$UZERO = $f5dad24a1eddf046$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.UZERO = $f5dad24a1eddf046$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$ONE = $f5dad24a1eddf046$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.ONE = $f5dad24a1eddf046$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$UONE = $f5dad24a1eddf046$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.UONE = $f5dad24a1eddf046$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$NEG_ONE = $f5dad24a1eddf046$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.NEG_ONE = $f5dad24a1eddf046$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$MAX_VALUE = $f5dad24a1eddf046$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.MAX_VALUE = $f5dad24a1eddf046$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$MAX_UNSIGNED_VALUE = $f5dad24a1eddf046$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.MAX_UNSIGNED_VALUE = $f5dad24a1eddf046$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $f5dad24a1eddf046$var$MIN_VALUE = $f5dad24a1eddf046$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $f5dad24a1eddf046$var$Long.MIN_VALUE = $f5dad24a1eddf046$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $f5dad24a1eddf046$var$LongPrototype = $f5dad24a1eddf046$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $f5dad24a1eddf046$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $f5dad24a1eddf046$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $f5dad24a1eddf046$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $f5dad24a1eddf046$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $f5dad24a1eddf046$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($f5dad24a1eddf046$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $f5dad24a1eddf046$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $f5dad24a1eddf046$var$fromNumber($f5dad24a1eddf046$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $f5dad24a1eddf046$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $f5dad24a1eddf046$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $f5dad24a1eddf046$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $f5dad24a1eddf046$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $f5dad24a1eddf046$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($f5dad24a1eddf046$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.eqz = $f5dad24a1eddf046$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.equals = function equals(other) {
    if (!$f5dad24a1eddf046$var$isLong(other)) other = $f5dad24a1eddf046$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.eq = $f5dad24a1eddf046$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.neq = $f5dad24a1eddf046$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.ne = $f5dad24a1eddf046$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.lt = $f5dad24a1eddf046$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.lte = $f5dad24a1eddf046$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.le = $f5dad24a1eddf046$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.gt = $f5dad24a1eddf046$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.gte = $f5dad24a1eddf046$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $f5dad24a1eddf046$var$LongPrototype.ge = $f5dad24a1eddf046$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $f5dad24a1eddf046$var$LongPrototype.compare = function compare(other) {
    if (!$f5dad24a1eddf046$var$isLong(other)) other = $f5dad24a1eddf046$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $f5dad24a1eddf046$var$LongPrototype.comp = $f5dad24a1eddf046$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $f5dad24a1eddf046$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($f5dad24a1eddf046$var$MIN_VALUE)) return $f5dad24a1eddf046$var$MIN_VALUE;
    return this.not().add($f5dad24a1eddf046$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $f5dad24a1eddf046$var$LongPrototype.neg = $f5dad24a1eddf046$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $f5dad24a1eddf046$var$LongPrototype.add = function add(addend) {
    if (!$f5dad24a1eddf046$var$isLong(addend)) addend = $f5dad24a1eddf046$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $f5dad24a1eddf046$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $f5dad24a1eddf046$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$f5dad24a1eddf046$var$isLong(subtrahend)) subtrahend = $f5dad24a1eddf046$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $f5dad24a1eddf046$var$LongPrototype.sub = $f5dad24a1eddf046$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $f5dad24a1eddf046$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $f5dad24a1eddf046$var$ZERO;
    if (!$f5dad24a1eddf046$var$isLong(multiplier)) multiplier = $f5dad24a1eddf046$var$fromValue(multiplier);
    // use wasm support if present
    if ($f5dad24a1eddf046$var$wasm) {
        var low = $f5dad24a1eddf046$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $f5dad24a1eddf046$var$fromBits(low, $f5dad24a1eddf046$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $f5dad24a1eddf046$var$ZERO;
    if (this.eq($f5dad24a1eddf046$var$MIN_VALUE)) return multiplier.isOdd() ? $f5dad24a1eddf046$var$MIN_VALUE : $f5dad24a1eddf046$var$ZERO;
    if (multiplier.eq($f5dad24a1eddf046$var$MIN_VALUE)) return this.isOdd() ? $f5dad24a1eddf046$var$MIN_VALUE : $f5dad24a1eddf046$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($f5dad24a1eddf046$var$TWO_PWR_24) && multiplier.lt($f5dad24a1eddf046$var$TWO_PWR_24)) return $f5dad24a1eddf046$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $f5dad24a1eddf046$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $f5dad24a1eddf046$var$LongPrototype.mul = $f5dad24a1eddf046$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $f5dad24a1eddf046$var$LongPrototype.divide = function divide(divisor) {
    if (!$f5dad24a1eddf046$var$isLong(divisor)) divisor = $f5dad24a1eddf046$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($f5dad24a1eddf046$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $f5dad24a1eddf046$var$wasm.div_u : $f5dad24a1eddf046$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $f5dad24a1eddf046$var$fromBits(low, $f5dad24a1eddf046$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $f5dad24a1eddf046$var$UZERO : $f5dad24a1eddf046$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($f5dad24a1eddf046$var$MIN_VALUE)) {
            if (divisor.eq($f5dad24a1eddf046$var$ONE) || divisor.eq($f5dad24a1eddf046$var$NEG_ONE)) return $f5dad24a1eddf046$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($f5dad24a1eddf046$var$MIN_VALUE)) return $f5dad24a1eddf046$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($f5dad24a1eddf046$var$ZERO)) return divisor.isNegative() ? $f5dad24a1eddf046$var$ONE : $f5dad24a1eddf046$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($f5dad24a1eddf046$var$MIN_VALUE)) return this.unsigned ? $f5dad24a1eddf046$var$UZERO : $f5dad24a1eddf046$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $f5dad24a1eddf046$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $f5dad24a1eddf046$var$UZERO;
        if (divisor.gt(this.shru(1))) return $f5dad24a1eddf046$var$UONE;
        res = $f5dad24a1eddf046$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $f5dad24a1eddf046$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $f5dad24a1eddf046$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $f5dad24a1eddf046$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $f5dad24a1eddf046$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $f5dad24a1eddf046$var$LongPrototype.div = $f5dad24a1eddf046$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $f5dad24a1eddf046$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$f5dad24a1eddf046$var$isLong(divisor)) divisor = $f5dad24a1eddf046$var$fromValue(divisor);
    // use wasm support if present
    if ($f5dad24a1eddf046$var$wasm) {
        var low = (this.unsigned ? $f5dad24a1eddf046$var$wasm.rem_u : $f5dad24a1eddf046$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $f5dad24a1eddf046$var$fromBits(low, $f5dad24a1eddf046$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $f5dad24a1eddf046$var$LongPrototype.mod = $f5dad24a1eddf046$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $f5dad24a1eddf046$var$LongPrototype.rem = $f5dad24a1eddf046$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $f5dad24a1eddf046$var$LongPrototype.not = function not() {
    return $f5dad24a1eddf046$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $f5dad24a1eddf046$var$LongPrototype.and = function and(other) {
    if (!$f5dad24a1eddf046$var$isLong(other)) other = $f5dad24a1eddf046$var$fromValue(other);
    return $f5dad24a1eddf046$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $f5dad24a1eddf046$var$LongPrototype.or = function or(other) {
    if (!$f5dad24a1eddf046$var$isLong(other)) other = $f5dad24a1eddf046$var$fromValue(other);
    return $f5dad24a1eddf046$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $f5dad24a1eddf046$var$LongPrototype.xor = function xor(other) {
    if (!$f5dad24a1eddf046$var$isLong(other)) other = $f5dad24a1eddf046$var$fromValue(other);
    return $f5dad24a1eddf046$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($f5dad24a1eddf046$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $f5dad24a1eddf046$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $f5dad24a1eddf046$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shl = $f5dad24a1eddf046$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($f5dad24a1eddf046$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $f5dad24a1eddf046$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $f5dad24a1eddf046$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shr = $f5dad24a1eddf046$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($f5dad24a1eddf046$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $f5dad24a1eddf046$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $f5dad24a1eddf046$var$fromBits(high, 0, this.unsigned);
        else return $f5dad24a1eddf046$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shru = $f5dad24a1eddf046$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $f5dad24a1eddf046$var$LongPrototype.shr_u = $f5dad24a1eddf046$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $f5dad24a1eddf046$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $f5dad24a1eddf046$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $f5dad24a1eddf046$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $f5dad24a1eddf046$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $f5dad24a1eddf046$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $f5dad24a1eddf046$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $f5dad24a1eddf046$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $f5dad24a1eddf046$var$Long.fromBytesLE(bytes, unsigned) : $f5dad24a1eddf046$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $f5dad24a1eddf046$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $f5dad24a1eddf046$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $f5dad24a1eddf046$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("3C2w0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseRawLog = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $gMk5u = parcelRequire("gMk5u");
function $2a16df31f8b5fe1d$var$parseAttribute(input) {
    if (!(0, $gMk5u.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    var key = input.key, value = input.value;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $2a16df31f8b5fe1d$var$parseAttribute;
function $2a16df31f8b5fe1d$var$parseEvent(input) {
    if (!(0, $gMk5u.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    var type = input.type, attributes = input.attributes;
    if (typeof type !== "string" || type === "") throw new Error("Event type must be a non-empty string");
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($2a16df31f8b5fe1d$var$parseAttribute)
    };
}
module.exports.parseEvent = $2a16df31f8b5fe1d$var$parseEvent;
function $2a16df31f8b5fe1d$var$parseLog(input) {
    if (!(0, $gMk5u.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    var msg_index = input.msg_index, log = input.log, events = input.events;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($2a16df31f8b5fe1d$var$parseEvent)
    };
}
module.exports.parseLog = $2a16df31f8b5fe1d$var$parseLog;
function $2a16df31f8b5fe1d$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($2a16df31f8b5fe1d$var$parseLog);
}
module.exports.parseLogs = $2a16df31f8b5fe1d$var$parseLogs;
function $2a16df31f8b5fe1d$var$parseRawLog() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "[]";
    var logsToParse = JSON.parse(input).map(function(param, i) {
        var events = param.events;
        return {
            msg_index: i,
            events: events,
            log: ""
        };
    });
    return $2a16df31f8b5fe1d$var$parseLogs(logsToParse);
}
module.exports.parseRawLog = $2a16df31f8b5fe1d$var$parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $2a16df31f8b5fe1d$var$findAttribute(logs, eventType, attrKey) {
    var _firstLogs_events_find;
    var firstLogs = logs.find(function() {
        return true;
    });
    var out = firstLogs === null || firstLogs === void 0 ? void 0 : (_firstLogs_events_find = firstLogs.events.find(function(event) {
        return event.type === eventType;
    })) === null || _firstLogs_events_find === void 0 ? void 0 : _firstLogs_events_find.attributes.find(function(attr) {
        return attr.key === attrKey;
    });
    if (!out) throw new Error("Could not find attribute '".concat(attrKey, "' in first event of type '").concat(eventType, "' in first log."));
    return out;
}
module.exports.findAttribute = $2a16df31f8b5fe1d$var$findAttribute;

});
parcelRegister("gMk5u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.isDefined = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $fjVtU = parcelRequire("fjVtU");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function get() {
        return $fjVtU.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function get() {
        return $fjVtU.arrayContentStartsWith;
    }
});

var $7zmEL = parcelRequire("7zmEL");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function get() {
        return $7zmEL.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function get() {
        return $7zmEL.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function get() {
        return $7zmEL.assertDefinedAndNotNull;
    }
});

var $heuJv = parcelRequire("heuJv");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function get() {
        return $heuJv.sleep;
    }
});

var $3aZHU = parcelRequire("3aZHU");
Object.defineProperty(module.exports, "isDefined", {
    enumerable: true,
    get: function get() {
        return $3aZHU.isDefined;
    }
});
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function get() {
        return $3aZHU.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function get() {
        return $3aZHU.isUint8Array;
    }
});

});
parcelRegister("fjVtU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $b27537f859672063$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $b27537f859672063$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $b27537f859672063$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(var i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $b27537f859672063$var$arrayContentStartsWith;

});

parcelRegister("7zmEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $582d605fa68d59d6$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $582d605fa68d59d6$var$assert;
function $582d605fa68d59d6$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $582d605fa68d59d6$var$assertDefined;
function $582d605fa68d59d6$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $582d605fa68d59d6$var$assertDefinedAndNotNull;

});

parcelRegister("heuJv", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
function $c8bb95619bac448e$var$sleep(ms) {
    return $c8bb95619bac448e$var$_sleep.apply(this, arguments);
}
function $c8bb95619bac448e$var$_sleep() {
    $c8bb95619bac448e$var$_sleep = (0, $6rBFC._)(function(ms) {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return setTimeout(resolve, ms);
                })
            ];
        });
    });
    return $c8bb95619bac448e$var$_sleep.apply(this, arguments);
}
module.exports.sleep = $c8bb95619bac448e$var$sleep;

});
parcelRegister("6rBFC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b127c37be80c3ce$export$71511d61b312f219; });
function $4b127c37be80c3ce$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $4b127c37be80c3ce$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $4b127c37be80c3ce$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $4b127c37be80c3ce$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("6qu4b", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $4adc7e59f6bac78f$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $4adc7e59f6bac78f$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $4adc7e59f6bac78f$var$extendStatics = function extendStatics1(d, b) {
    $4adc7e59f6bac78f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4adc7e59f6bac78f$var$extendStatics(d, b);
};
function $4adc7e59f6bac78f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4adc7e59f6bac78f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4adc7e59f6bac78f$export$18ce0697a983be9b = function __assign1() {
    $4adc7e59f6bac78f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4adc7e59f6bac78f$export$18ce0697a983be9b.apply(this, arguments);
};
function $4adc7e59f6bac78f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4adc7e59f6bac78f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4adc7e59f6bac78f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4adc7e59f6bac78f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4adc7e59f6bac78f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4adc7e59f6bac78f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4adc7e59f6bac78f$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4adc7e59f6bac78f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4adc7e59f6bac78f$export$45d3717a4c69092e(o, m, p);
}
function $4adc7e59f6bac78f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4adc7e59f6bac78f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4adc7e59f6bac78f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4adc7e59f6bac78f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4adc7e59f6bac78f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4adc7e59f6bac78f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4adc7e59f6bac78f$export$10c90e4f7922046c(v) {
    return this instanceof $4adc7e59f6bac78f$export$10c90e4f7922046c ? (this.v = v, this) : new $4adc7e59f6bac78f$export$10c90e4f7922046c(v);
}
function $4adc7e59f6bac78f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4adc7e59f6bac78f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4adc7e59f6bac78f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4adc7e59f6bac78f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $4adc7e59f6bac78f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4adc7e59f6bac78f$export$19a8beecd37a4c45 === "function" ? $4adc7e59f6bac78f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4adc7e59f6bac78f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4adc7e59f6bac78f$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4adc7e59f6bac78f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4adc7e59f6bac78f$export$45d3717a4c69092e(result, mod, k);
    }
    $4adc7e59f6bac78f$var$__setModuleDefault(result, mod);
    return result;
}
function $4adc7e59f6bac78f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4adc7e59f6bac78f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4adc7e59f6bac78f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4adc7e59f6bac78f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});


parcelRegister("3aZHU", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $25022c0d8a0729e5$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefined = module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $25022c0d8a0729e5$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $25022c0d8a0729e5$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $25022c0d8a0729e5$var$isUint8Array(data) {
    if (!$25022c0d8a0729e5$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $25022c0d8a0729e5$require$Buffer !== "undefined" && typeof $25022c0d8a0729e5$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($25022c0d8a0729e5$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $25022c0d8a0729e5$var$isUint8Array;
/**
 * Checks if input is not undefined in a TypeScript-friendly way.
 *
 * This is convenient to use in e.g. `Array.filter` as it will convert
 * the type of a `Array<Foo | undefined>` to `Array<Foo>`.
 */ function $25022c0d8a0729e5$var$isDefined(value) {
    return value !== undefined;
}
module.exports.isDefined = $25022c0d8a0729e5$var$isDefined;

});



parcelRegister("hS2fe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d029389416f382db$var$symbolObservablePonyfill;
function $d029389416f382db$var$symbolObservablePonyfill(root) {
    var result;
    var _Symbol = root.Symbol;
    if (typeof _Symbol === "function") {
        if (_Symbol.observable) result = _Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = _Symbol["for"]("https://github.com/benlesh/symbol-observable");
            try {
                _Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});

parcelRegister("cTULJ", function(module, exports) {
"use strict";
var $9646a83876c57f51$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $9646a83876c57f51$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $9646a83876c57f51$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("csPz0", function(module, exports) {
"use strict";
var $91301900d9f3ec32$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $91301900d9f3ec32$var$has = Object.prototype.hasOwnProperty;
    var $91301900d9f3ec32$var$toStr = Object.prototype.toString;
    var $91301900d9f3ec32$var$isArgs = (parcelRequire("cTULJ")); // eslint-disable-line global-require
    var $91301900d9f3ec32$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $91301900d9f3ec32$var$hasDontEnumBug = !$91301900d9f3ec32$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $91301900d9f3ec32$var$hasProtoEnumBug = $91301900d9f3ec32$var$isEnumerable.call(function() {}, "prototype");
    var $91301900d9f3ec32$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $91301900d9f3ec32$var$equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $91301900d9f3ec32$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $91301900d9f3ec32$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$91301900d9f3ec32$var$excludedKeys["$" + k] && $91301900d9f3ec32$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $91301900d9f3ec32$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $91301900d9f3ec32$var$equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === "undefined" || !$91301900d9f3ec32$var$hasAutomationEqualityBug) return $91301900d9f3ec32$var$equalsConstructorPrototype(o);
        try {
            return $91301900d9f3ec32$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $91301900d9f3ec32$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $91301900d9f3ec32$var$toStr.call(object) === "[object Function]";
        var isArguments = $91301900d9f3ec32$var$isArgs(object);
        var isString = isObject && $91301900d9f3ec32$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $91301900d9f3ec32$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$91301900d9f3ec32$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $91301900d9f3ec32$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($91301900d9f3ec32$var$hasDontEnumBug) {
            var skipConstructor = $91301900d9f3ec32$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $91301900d9f3ec32$var$dontEnums.length; ++k)if (!(skipConstructor && $91301900d9f3ec32$var$dontEnums[k] === "constructor") && $91301900d9f3ec32$var$has.call(object, $91301900d9f3ec32$var$dontEnums[k])) theKeys.push($91301900d9f3ec32$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $91301900d9f3ec32$var$keysShim;

});

parcelRegister("k95OQ", function(module, exports) {
"use strict";

var $5MXtI = parcelRequire("5MXtI");
var $eaa9297071544176$var$$defineProperty = $5MXtI("%Object.defineProperty%", true);
var $eaa9297071544176$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($eaa9297071544176$var$$defineProperty) try {
        $eaa9297071544176$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$eaa9297071544176$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$eaa9297071544176$var$hasPropertyDescriptors()) return null;
    try {
        return $eaa9297071544176$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $eaa9297071544176$var$hasPropertyDescriptors;

});
parcelRegister("5MXtI", function(module, exports) {
"use strict";
var $436f929ac3855d6d$var$_$undefined;
var $436f929ac3855d6d$var$$SyntaxError = SyntaxError;
var $436f929ac3855d6d$var$$Function = Function;
var $436f929ac3855d6d$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $436f929ac3855d6d$var$getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $436f929ac3855d6d$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $436f929ac3855d6d$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($436f929ac3855d6d$var$$gOPD) try {
    $436f929ac3855d6d$var$$gOPD({}, "");
} catch (e) {
    $436f929ac3855d6d$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $436f929ac3855d6d$var$throwTypeError = function throwTypeError() {
    throw new $436f929ac3855d6d$var$$TypeError();
};
var $436f929ac3855d6d$var$ThrowTypeError = $436f929ac3855d6d$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $436f929ac3855d6d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $436f929ac3855d6d$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $436f929ac3855d6d$var$throwTypeError;
        }
    }
}() : $436f929ac3855d6d$var$throwTypeError;

var $436f929ac3855d6d$var$hasSymbols = (parcelRequire("aiZ3e"))();

var $436f929ac3855d6d$var$hasProto = (parcelRequire("bDsub"))();
var $436f929ac3855d6d$var$getProto = Object.getPrototypeOf || ($436f929ac3855d6d$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $436f929ac3855d6d$var$needsEval = {};
var $436f929ac3855d6d$var$TypedArray = typeof Uint8Array === "undefined" || !$436f929ac3855d6d$var$getProto ? undefined : $436f929ac3855d6d$var$getProto(Uint8Array);
var $436f929ac3855d6d$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $436f929ac3855d6d$var$hasSymbols && $436f929ac3855d6d$var$getProto ? $436f929ac3855d6d$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $436f929ac3855d6d$var$needsEval,
    "%AsyncGenerator%": $436f929ac3855d6d$var$needsEval,
    "%AsyncGeneratorFunction%": $436f929ac3855d6d$var$needsEval,
    "%AsyncIteratorPrototype%": $436f929ac3855d6d$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $436f929ac3855d6d$var$$Function,
    "%GeneratorFunction%": $436f929ac3855d6d$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $436f929ac3855d6d$var$hasSymbols && $436f929ac3855d6d$var$getProto ? $436f929ac3855d6d$var$getProto($436f929ac3855d6d$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$436f929ac3855d6d$var$hasSymbols || !$436f929ac3855d6d$var$getProto ? undefined : $436f929ac3855d6d$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$436f929ac3855d6d$var$hasSymbols || !$436f929ac3855d6d$var$getProto ? undefined : $436f929ac3855d6d$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $436f929ac3855d6d$var$hasSymbols && $436f929ac3855d6d$var$getProto ? $436f929ac3855d6d$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $436f929ac3855d6d$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $436f929ac3855d6d$var$$SyntaxError,
    "%ThrowTypeError%": $436f929ac3855d6d$var$ThrowTypeError,
    "%TypedArray%": $436f929ac3855d6d$var$TypedArray,
    "%TypeError%": $436f929ac3855d6d$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($436f929ac3855d6d$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $436f929ac3855d6d$var$errorProto = $436f929ac3855d6d$var$getProto($436f929ac3855d6d$var$getProto(e));
    $436f929ac3855d6d$var$INTRINSICS["%Error.prototype%"] = $436f929ac3855d6d$var$errorProto;
}
var $436f929ac3855d6d$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $436f929ac3855d6d$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $436f929ac3855d6d$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $436f929ac3855d6d$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $436f929ac3855d6d$var$getProto) value = $436f929ac3855d6d$var$getProto(gen.prototype);
    }
    $436f929ac3855d6d$var$INTRINSICS[name] = value;
    return value;
};
var $436f929ac3855d6d$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $iOo7T = parcelRequire("iOo7T");

var $fqDFa = parcelRequire("fqDFa");
var $436f929ac3855d6d$var$$concat = $iOo7T.call(Function.call, Array.prototype.concat);
var $436f929ac3855d6d$var$$spliceApply = $iOo7T.call(Function.apply, Array.prototype.splice);
var $436f929ac3855d6d$var$$replace = $iOo7T.call(Function.call, String.prototype.replace);
var $436f929ac3855d6d$var$$strSlice = $iOo7T.call(Function.call, String.prototype.slice);
var $436f929ac3855d6d$var$$exec = $iOo7T.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $436f929ac3855d6d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $436f929ac3855d6d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $436f929ac3855d6d$var$stringToPath = function stringToPath(string) {
    var first = $436f929ac3855d6d$var$$strSlice(string, 0, 1);
    var last = $436f929ac3855d6d$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $436f929ac3855d6d$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $436f929ac3855d6d$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $436f929ac3855d6d$var$$replace(string, $436f929ac3855d6d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $436f929ac3855d6d$var$$replace(subString, $436f929ac3855d6d$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $436f929ac3855d6d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($fqDFa($436f929ac3855d6d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $436f929ac3855d6d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($fqDFa($436f929ac3855d6d$var$INTRINSICS, intrinsicName)) {
        var value = $436f929ac3855d6d$var$INTRINSICS[intrinsicName];
        if (value === $436f929ac3855d6d$var$needsEval) value = $436f929ac3855d6d$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $436f929ac3855d6d$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $436f929ac3855d6d$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $436f929ac3855d6d$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $436f929ac3855d6d$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($436f929ac3855d6d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $436f929ac3855d6d$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $436f929ac3855d6d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $436f929ac3855d6d$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $436f929ac3855d6d$var$$spliceApply(parts, $436f929ac3855d6d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $436f929ac3855d6d$var$$strSlice(part, 0, 1);
        var last = $436f929ac3855d6d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $436f929ac3855d6d$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($fqDFa($436f929ac3855d6d$var$INTRINSICS, intrinsicRealName)) value = $436f929ac3855d6d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $436f929ac3855d6d$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($436f929ac3855d6d$var$$gOPD && i + 1 >= parts.length) {
                var desc = $436f929ac3855d6d$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $fqDFa(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $436f929ac3855d6d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aiZ3e", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");
"use strict";
var $780af14958ae5801$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $40F3S = parcelRequire("40F3S");
module.exports = function hasNativeSymbols() {
    if (typeof $780af14958ae5801$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if ((0, $aVMuR._)($780af14958ae5801$var$origSymbol("foo")) !== "symbol") return false;
    if ((0, $aVMuR._)(Symbol("bar")) !== "symbol") return false;
    return $40F3S();
};

});
parcelRegister("40F3S", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if ((0, $aVMuR._)(Symbol.iterator) === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("bDsub", function(module, exports) {
"use strict";
var $87896eee058784fc$var$test = {
    foo: {}
};
var $87896eee058784fc$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $87896eee058784fc$var$test
    }).foo === $87896eee058784fc$var$test.foo && !(({
        __proto__: null
    }) instanceof $87896eee058784fc$var$$Object);
};

});

parcelRegister("iOo7T", function(module, exports) {
"use strict";

var $6aLay = parcelRequire("6aLay");
module.exports = Function.prototype.bind || $6aLay;

});
parcelRegister("6aLay", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $47e84410d0928509$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $47e84410d0928509$var$slice = Array.prototype.slice;
var $47e84410d0928509$var$toStr = Object.prototype.toString;
var $47e84410d0928509$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $47e84410d0928509$var$toStr.call(target) !== $47e84410d0928509$var$funcType) throw new TypeError($47e84410d0928509$var$ERROR_MESSAGE + target);
    var args = $47e84410d0928509$var$slice.call(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($47e84410d0928509$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($47e84410d0928509$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("fqDFa", function(module, exports) {
"use strict";

var $iOo7T = parcelRequire("iOo7T");
module.exports = $iOo7T.call(Function.call, Object.prototype.hasOwnProperty);

});



parcelRegister("55he3", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lastValue = module.exports.asArray = module.exports.countStream = module.exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
var $3b3ac80a7d5101df$var$Reducer = /*#__PURE__*/ function() {
    function Reducer(stream, reducer, initState) {
        var _this = this;
        (0, $7dKN1._)(this, Reducer);
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise(function(resolve, reject) {
            var subscription = _this.stream.subscribe({
                next: function(evt) {
                    _this.state = _this.reducer(_this.state, evt);
                },
                complete: function() {
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: function(err) {
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                }
            });
        });
    }
    (0, $eW5pA._)(Reducer, [
        {
            // value returns current materialized state
            key: "value",
            value: function value() {
                return this.state;
            }
        },
        {
            key: "finished",
            value: // finished resolves on completed stream, rejects on stream error
            function finished() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.completed
                        ];
                    });
                })();
            }
        }
    ]);
    return Reducer;
}();
module.exports.Reducer = $3b3ac80a7d5101df$var$Reducer;
function $3b3ac80a7d5101df$var$increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function $3b3ac80a7d5101df$var$countStream(stream) {
    return new $3b3ac80a7d5101df$var$Reducer(stream, $3b3ac80a7d5101df$var$increment, 0);
}
module.exports.countStream = $3b3ac80a7d5101df$var$countStream;
function $3b3ac80a7d5101df$var$append(list, evt) {
    return (0, $gF0bR._)(list).concat([
        evt
    ]);
}
// asArray maintains an array containing all events that have
// occurred on the stream
function $3b3ac80a7d5101df$var$asArray(stream) {
    return new $3b3ac80a7d5101df$var$Reducer(stream, $3b3ac80a7d5101df$var$append, []);
}
module.exports.asArray = $3b3ac80a7d5101df$var$asArray;
function $3b3ac80a7d5101df$var$last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function $3b3ac80a7d5101df$var$lastValue(stream) {
    return new $3b3ac80a7d5101df$var$Reducer(stream, $3b3ac80a7d5101df$var$last, undefined);
}
module.exports.lastValue = $3b3ac80a7d5101df$var$lastValue;

});
parcelRegister("gF0bR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c2109f71ba703dd0$export$71511d61b312f219; });

var $1c7r5 = parcelRequire("1c7r5");

var $gdcCC = parcelRequire("gdcCC");

var $3jaJM = parcelRequire("3jaJM");

var $iJGZg = parcelRequire("iJGZg");
function $c2109f71ba703dd0$export$71511d61b312f219(arr) {
    return (0, $1c7r5._)(arr) || (0, $gdcCC._)(arr) || (0, $iJGZg._)(arr) || (0, $3jaJM._)();
}

});
parcelRegister("1c7r5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0decae0bccf407d7$export$71511d61b312f219; });

var $2Veib = parcelRequire("2Veib");
function $0decae0bccf407d7$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2Veib._)(arr);
}

});
parcelRegister("2Veib", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $220bfdc77a1dc1da$export$71511d61b312f219; });
function $220bfdc77a1dc1da$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gdcCC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcd7a6aed5420f82$export$71511d61b312f219; });
function $bcd7a6aed5420f82$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("3jaJM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $268b79ae08466039$export$71511d61b312f219; });
function $268b79ae08466039$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("iJGZg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $da3dc65137cef842$export$71511d61b312f219; });

var $2Veib = parcelRequire("2Veib");
function $da3dc65137cef842$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2Veib._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2Veib._)(o, minLen);
}

});



parcelRegister("fmEYq", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var __createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MsgClientImpl = exports.MsgLeaveGroupResponse = exports.MsgLeaveGroup = exports.MsgExecResponse = exports.MsgExec = exports.MsgVoteResponse = exports.MsgVote = exports.MsgWithdrawProposalResponse = exports.MsgWithdrawProposal = exports.MsgSubmitProposalResponse = exports.MsgSubmitProposal = exports.MsgUpdateGroupPolicyMetadataResponse = exports.MsgUpdateGroupPolicyMetadata = exports.MsgUpdateGroupPolicyDecisionPolicyResponse = exports.MsgUpdateGroupPolicyDecisionPolicy = exports.MsgCreateGroupWithPolicyResponse = exports.MsgCreateGroupWithPolicy = exports.MsgUpdateGroupPolicyAdminResponse = exports.MsgUpdateGroupPolicyAdmin = exports.MsgCreateGroupPolicyResponse = exports.MsgCreateGroupPolicy = exports.MsgUpdateGroupMetadataResponse = exports.MsgUpdateGroupMetadata = exports.MsgUpdateGroupAdminResponse = exports.MsgUpdateGroupAdmin = exports.MsgUpdateGroupMembersResponse = exports.MsgUpdateGroupMembers = exports.MsgCreateGroupResponse = exports.MsgCreateGroup = exports.execToJSON = exports.execFromJSON = exports.Exec = exports.protobufPackage = void 0;

var $c5E5U = parcelRequire("c5E5U");

var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var _m0 = __importStar((parcelRequire("hjb8Q")));
exports.protobufPackage = "cosmos.group.v1";
/** Exec defines modes of execution of a proposal on creation or on new vote. */ var Exec;
(function(Exec) {
    /**
     * EXEC_UNSPECIFIED - An empty value means that there should be a separate
     * MsgExec request for the proposal to execute.
     */ Exec[Exec["EXEC_UNSPECIFIED"] = 0] = "EXEC_UNSPECIFIED";
    /**
     * EXEC_TRY - Try to execute the proposal immediately.
     * If the proposal is not allowed per the DecisionPolicy,
     * the proposal will still be open and could
     * be executed at a later point.
     */ Exec[Exec["EXEC_TRY"] = 1] = "EXEC_TRY";
    Exec[Exec["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Exec = exports.Exec || (exports.Exec = {}));
function execFromJSON(object) {
    switch(object){
        case 0:
        case "EXEC_UNSPECIFIED":
            return Exec.EXEC_UNSPECIFIED;
        case 1:
        case "EXEC_TRY":
            return Exec.EXEC_TRY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Exec.UNRECOGNIZED;
    }
}
exports.execFromJSON = execFromJSON;
function execToJSON(object) {
    switch(object){
        case Exec.EXEC_UNSPECIFIED:
            return "EXEC_UNSPECIFIED";
        case Exec.EXEC_TRY:
            return "EXEC_TRY";
        case Exec.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.execToJSON = execToJSON;
function createBaseMsgCreateGroup() {
    return {
        admin: "",
        members: [],
        metadata: ""
    };
}
exports.MsgCreateGroup = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $c5E5U.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCreateGroup();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($c5E5U.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object === null || object === void 0 ? void 0 : object.members) ? object.members.map(function(e) {
                return $c5E5U.MemberRequest.fromJSON(e);
            }) : [],
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map(function(e) {
            return e ? $c5E5U.MemberRequest.toJSON(e) : undefined;
        });
        else obj.members = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var _object_members;
        var message = createBaseMsgCreateGroup();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.members = ((_object_members = object.members) === null || _object_members === void 0 ? void 0 : _object_members.map(function(e) {
            return $c5E5U.MemberRequest.fromPartial(e);
        })) || [];
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function createBaseMsgCreateGroupResponse() {
    return {
        groupId: $7iZIe.Long.UZERO
    };
}
exports.MsgCreateGroupResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCreateGroupResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgCreateGroupResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function createBaseMsgUpdateGroupMembers() {
    return {
        admin: "",
        groupId: $7iZIe.Long.UZERO,
        memberUpdates: []
    };
}
exports.MsgUpdateGroupMembers = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.memberUpdates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $c5E5U.MemberRequest.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupMembers();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.memberUpdates.push($c5E5U.MemberRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            memberUpdates: Array.isArray(object === null || object === void 0 ? void 0 : object.memberUpdates) ? object.memberUpdates.map(function(e) {
                return $c5E5U.MemberRequest.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        if (message.memberUpdates) obj.memberUpdates = message.memberUpdates.map(function(e) {
            return e ? $c5E5U.MemberRequest.toJSON(e) : undefined;
        });
        else obj.memberUpdates = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_memberUpdates;
        var message = createBaseMsgUpdateGroupMembers();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        message.memberUpdates = ((_object_memberUpdates = object.memberUpdates) === null || _object_memberUpdates === void 0 ? void 0 : _object_memberUpdates.map(function(e) {
            return $c5E5U.MemberRequest.fromPartial(e);
        })) || [];
        return message;
    }
};
function createBaseMsgUpdateGroupMembersResponse() {
    return {};
}
exports.MsgUpdateGroupMembersResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupMembersResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgUpdateGroupMembersResponse();
        return message;
    }
};
function createBaseMsgUpdateGroupAdmin() {
    return {
        admin: "",
        groupId: $7iZIe.Long.UZERO,
        newAdmin: ""
    };
}
exports.MsgUpdateGroupAdmin = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupAdmin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            newAdmin: (0, $7iZIe.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgUpdateGroupAdmin();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        var _object_newAdmin;
        message.newAdmin = (_object_newAdmin = object.newAdmin) !== null && _object_newAdmin !== void 0 ? _object_newAdmin : "";
        return message;
    }
};
function createBaseMsgUpdateGroupAdminResponse() {
    return {};
}
exports.MsgUpdateGroupAdminResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupAdminResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgUpdateGroupAdminResponse();
        return message;
    }
};
function createBaseMsgUpdateGroupMetadata() {
    return {
        admin: "",
        groupId: $7iZIe.Long.UZERO,
        metadata: ""
    };
}
exports.MsgUpdateGroupMetadata = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupMetadata();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgUpdateGroupMetadata();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function createBaseMsgUpdateGroupMetadataResponse() {
    return {};
}
exports.MsgUpdateGroupMetadataResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupMetadataResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgUpdateGroupMetadataResponse();
        return message;
    }
};
function createBaseMsgCreateGroupPolicy() {
    return {
        admin: "",
        groupId: $7iZIe.Long.UZERO,
        metadata: "",
        decisionPolicy: undefined
    };
}
exports.MsgCreateGroupPolicy = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.decisionPolicy !== undefined) $DM7bi.Any.encode(message.decisionPolicy, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCreateGroupPolicy();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.decisionPolicy = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            decisionPolicy: (0, $7iZIe.isSet)(object.decisionPolicy) ? $DM7bi.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $DM7bi.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgCreateGroupPolicy();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $DM7bi.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function createBaseMsgCreateGroupPolicyResponse() {
    return {
        address: ""
    };
}
exports.MsgCreateGroupPolicyResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCreateGroupPolicyResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgCreateGroupPolicyResponse();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        return message;
    }
};
function createBaseMsgUpdateGroupPolicyAdmin() {
    return {
        admin: "",
        groupPolicyAddress: "",
        newAdmin: ""
    };
}
exports.MsgUpdateGroupPolicyAdmin = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupPolicyAdmin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $7iZIe.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            newAdmin: (0, $7iZIe.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgUpdateGroupPolicyAdmin();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        var _object_groupPolicyAddress;
        message.groupPolicyAddress = (_object_groupPolicyAddress = object.groupPolicyAddress) !== null && _object_groupPolicyAddress !== void 0 ? _object_groupPolicyAddress : "";
        var _object_newAdmin;
        message.newAdmin = (_object_newAdmin = object.newAdmin) !== null && _object_newAdmin !== void 0 ? _object_newAdmin : "";
        return message;
    }
};
function createBaseMsgUpdateGroupPolicyAdminResponse() {
    return {};
}
exports.MsgUpdateGroupPolicyAdminResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupPolicyAdminResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgUpdateGroupPolicyAdminResponse();
        return message;
    }
};
function createBaseMsgCreateGroupWithPolicy() {
    return {
        admin: "",
        members: [],
        groupMetadata: "",
        groupPolicyMetadata: "",
        groupPolicyAsAdmin: false,
        decisionPolicy: undefined
    };
}
exports.MsgCreateGroupWithPolicy = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $c5E5U.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.groupMetadata !== "") writer.uint32(26).string(message.groupMetadata);
        if (message.groupPolicyMetadata !== "") writer.uint32(34).string(message.groupPolicyMetadata);
        if (message.groupPolicyAsAdmin === true) writer.uint32(40).bool(message.groupPolicyAsAdmin);
        if (message.decisionPolicy !== undefined) $DM7bi.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCreateGroupWithPolicy();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($c5E5U.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.groupMetadata = reader.string();
                    break;
                case 4:
                    message.groupPolicyMetadata = reader.string();
                    break;
                case 5:
                    message.groupPolicyAsAdmin = reader.bool();
                    break;
                case 6:
                    message.decisionPolicy = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object === null || object === void 0 ? void 0 : object.members) ? object.members.map(function(e) {
                return $c5E5U.MemberRequest.fromJSON(e);
            }) : [],
            groupMetadata: (0, $7iZIe.isSet)(object.groupMetadata) ? String(object.groupMetadata) : "",
            groupPolicyMetadata: (0, $7iZIe.isSet)(object.groupPolicyMetadata) ? String(object.groupPolicyMetadata) : "",
            groupPolicyAsAdmin: (0, $7iZIe.isSet)(object.groupPolicyAsAdmin) ? Boolean(object.groupPolicyAsAdmin) : false,
            decisionPolicy: (0, $7iZIe.isSet)(object.decisionPolicy) ? $DM7bi.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map(function(e) {
            return e ? $c5E5U.MemberRequest.toJSON(e) : undefined;
        });
        else obj.members = [];
        message.groupMetadata !== undefined && (obj.groupMetadata = message.groupMetadata);
        message.groupPolicyMetadata !== undefined && (obj.groupPolicyMetadata = message.groupPolicyMetadata);
        message.groupPolicyAsAdmin !== undefined && (obj.groupPolicyAsAdmin = message.groupPolicyAsAdmin);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $DM7bi.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_members;
        var message = createBaseMsgCreateGroupWithPolicy();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.members = ((_object_members = object.members) === null || _object_members === void 0 ? void 0 : _object_members.map(function(e) {
            return $c5E5U.MemberRequest.fromPartial(e);
        })) || [];
        var _object_groupMetadata;
        message.groupMetadata = (_object_groupMetadata = object.groupMetadata) !== null && _object_groupMetadata !== void 0 ? _object_groupMetadata : "";
        var _object_groupPolicyMetadata;
        message.groupPolicyMetadata = (_object_groupPolicyMetadata = object.groupPolicyMetadata) !== null && _object_groupPolicyMetadata !== void 0 ? _object_groupPolicyMetadata : "";
        var _object_groupPolicyAsAdmin;
        message.groupPolicyAsAdmin = (_object_groupPolicyAsAdmin = object.groupPolicyAsAdmin) !== null && _object_groupPolicyAsAdmin !== void 0 ? _object_groupPolicyAsAdmin : false;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $DM7bi.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function createBaseMsgCreateGroupWithPolicyResponse() {
    return {
        groupId: $7iZIe.Long.UZERO,
        groupPolicyAddress: ""
    };
}
exports.MsgCreateGroupWithPolicyResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgCreateGroupWithPolicyResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            groupPolicyAddress: (0, $7iZIe.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgCreateGroupWithPolicyResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        var _object_groupPolicyAddress;
        message.groupPolicyAddress = (_object_groupPolicyAddress = object.groupPolicyAddress) !== null && _object_groupPolicyAddress !== void 0 ? _object_groupPolicyAddress : "";
        return message;
    }
};
function createBaseMsgUpdateGroupPolicyDecisionPolicy() {
    return {
        admin: "",
        groupPolicyAddress: "",
        decisionPolicy: undefined
    };
}
exports.MsgUpdateGroupPolicyDecisionPolicy = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.decisionPolicy !== undefined) $DM7bi.Any.encode(message.decisionPolicy, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupPolicyDecisionPolicy();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.decisionPolicy = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $7iZIe.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            decisionPolicy: (0, $7iZIe.isSet)(object.decisionPolicy) ? $DM7bi.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $DM7bi.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgUpdateGroupPolicyDecisionPolicy();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        var _object_groupPolicyAddress;
        message.groupPolicyAddress = (_object_groupPolicyAddress = object.groupPolicyAddress) !== null && _object_groupPolicyAddress !== void 0 ? _object_groupPolicyAddress : "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $DM7bi.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function createBaseMsgUpdateGroupPolicyDecisionPolicyResponse() {
    return {};
}
exports.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        return message;
    }
};
function createBaseMsgUpdateGroupPolicyMetadata() {
    return {
        admin: "",
        groupPolicyAddress: "",
        metadata: ""
    };
}
exports.MsgUpdateGroupPolicyMetadata = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupPolicyMetadata();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $7iZIe.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgUpdateGroupPolicyMetadata();
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        var _object_groupPolicyAddress;
        message.groupPolicyAddress = (_object_groupPolicyAddress = object.groupPolicyAddress) !== null && _object_groupPolicyAddress !== void 0 ? _object_groupPolicyAddress : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function createBaseMsgUpdateGroupPolicyMetadataResponse() {
    return {};
}
exports.MsgUpdateGroupPolicyMetadataResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateGroupPolicyMetadataResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgUpdateGroupPolicyMetadataResponse();
        return message;
    }
};
function createBaseMsgSubmitProposal() {
    return {
        groupPolicyAddress: "",
        proposers: [],
        metadata: "",
        messages: [],
        exec: 0,
        title: "",
        summary: ""
    };
}
exports.MsgSubmitProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.groupPolicyAddress !== "") writer.uint32(10).string(message.groupPolicyAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.proposers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(18).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.messages[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $DM7bi.Any.encode(v1, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        if (message.title !== "") writer.uint32(50).string(message.title);
        if (message.summary !== "") writer.uint32(58).string(message.summary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgSubmitProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 2:
                    message.proposers.push(reader.string());
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.messages.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                case 6:
                    message.title = reader.string();
                    break;
                case 7:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            groupPolicyAddress: (0, $7iZIe.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            proposers: Array.isArray(object === null || object === void 0 ? void 0 : object.proposers) ? object.proposers.map(function(e) {
                return String(e);
            }) : [],
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            exec: (0, $7iZIe.isSet)(object.exec) ? execFromJSON(object.exec) : 0,
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $7iZIe.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        if (message.proposers) obj.proposers = message.proposers.map(function(e) {
            return e;
        });
        else obj.proposers = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.messages) obj.messages = message.messages.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.messages = [];
        message.exec !== undefined && (obj.exec = execToJSON(message.exec));
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial: function(object) {
        var _object_proposers, _object_messages;
        var message = createBaseMsgSubmitProposal();
        var _object_groupPolicyAddress;
        message.groupPolicyAddress = (_object_groupPolicyAddress = object.groupPolicyAddress) !== null && _object_groupPolicyAddress !== void 0 ? _object_groupPolicyAddress : "";
        message.proposers = ((_object_proposers = object.proposers) === null || _object_proposers === void 0 ? void 0 : _object_proposers.map(function(e) {
            return e;
        })) || [];
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.messages = ((_object_messages = object.messages) === null || _object_messages === void 0 ? void 0 : _object_messages.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        var _object_exec;
        message.exec = (_object_exec = object.exec) !== null && _object_exec !== void 0 ? _object_exec : 0;
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_summary;
        message.summary = (_object_summary = object.summary) !== null && _object_summary !== void 0 ? _object_summary : "";
        return message;
    }
};
function createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $7iZIe.Long.UZERO
    };
}
exports.MsgSubmitProposalResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function createBaseMsgWithdrawProposal() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        address: ""
    };
}
exports.MsgWithdrawProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgWithdrawProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgWithdrawProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        return message;
    }
};
function createBaseMsgWithdrawProposalResponse() {
    return {};
}
exports.MsgWithdrawProposalResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgWithdrawProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgWithdrawProposalResponse();
        return message;
    }
};
function createBaseMsgVote() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        exec: 0
    };
}
exports.MsgVote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $7iZIe.isSet)(object.option) ? (0, $c5E5U.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            exec: (0, $7iZIe.isSet)(object.exec) ? execFromJSON(object.exec) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $c5E5U.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.exec !== undefined && (obj.exec = execToJSON(message.exec));
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        var _object_exec;
        message.exec = (_object_exec = object.exec) !== null && _object_exec !== void 0 ? _object_exec : 0;
        return message;
    }
};
function createBaseMsgVoteResponse() {
    return {};
}
exports.MsgVoteResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgVoteResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgVoteResponse();
        return message;
    }
};
function createBaseMsgExec() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        executor: ""
    };
}
exports.MsgExec = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.executor !== "") writer.uint32(18).string(message.executor);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgExec();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            executor: (0, $7iZIe.isSet)(object.executor) ? String(object.executor) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.executor !== undefined && (obj.executor = message.executor);
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgExec();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_executor;
        message.executor = (_object_executor = object.executor) !== null && _object_executor !== void 0 ? _object_executor : "";
        return message;
    }
};
function createBaseMsgExecResponse() {
    return {
        result: 0
    };
}
exports.MsgExecResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.result !== 0) writer.uint32(16).int32(message.result);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgExecResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? (0, $c5E5U.proposalExecutorResultFromJSON)(object.result) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = (0, $c5E5U.proposalExecutorResultToJSON)(message.result));
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgExecResponse();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        return message;
    }
};
function createBaseMsgLeaveGroup() {
    return {
        address: "",
        groupId: $7iZIe.Long.UZERO
    };
}
exports.MsgLeaveGroup = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgLeaveGroup();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = createBaseMsgLeaveGroup();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function createBaseMsgLeaveGroupResponse() {
    return {};
}
exports.MsgLeaveGroupResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgLeaveGroupResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = createBaseMsgLeaveGroupResponse();
        return message;
    }
};
var MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.CreateGroup = this.CreateGroup.bind(this);
        this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this);
        this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this);
        this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this);
        this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this);
        this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this);
        this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this);
        this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this);
        this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this);
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.WithdrawProposal = this.WithdrawProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Exec = this.Exec.bind(this);
        this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "CreateGroup",
            value: function CreateGroup(request) {
                var data = exports.MsgCreateGroup.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", data);
                return promise.then(function(data) {
                    return exports.MsgCreateGroupResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateGroupMembers",
            value: function UpdateGroupMembers(request) {
                var data = exports.MsgUpdateGroupMembers.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", data);
                return promise.then(function(data) {
                    return exports.MsgUpdateGroupMembersResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateGroupAdmin",
            value: function UpdateGroupAdmin(request) {
                var data = exports.MsgUpdateGroupAdmin.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", data);
                return promise.then(function(data) {
                    return exports.MsgUpdateGroupAdminResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateGroupMetadata",
            value: function UpdateGroupMetadata(request) {
                var data = exports.MsgUpdateGroupMetadata.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", data);
                return promise.then(function(data) {
                    return exports.MsgUpdateGroupMetadataResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "CreateGroupPolicy",
            value: function CreateGroupPolicy(request) {
                var data = exports.MsgCreateGroupPolicy.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", data);
                return promise.then(function(data) {
                    return exports.MsgCreateGroupPolicyResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "CreateGroupWithPolicy",
            value: function CreateGroupWithPolicy(request) {
                var data = exports.MsgCreateGroupWithPolicy.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", data);
                return promise.then(function(data) {
                    return exports.MsgCreateGroupWithPolicyResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateGroupPolicyAdmin",
            value: function UpdateGroupPolicyAdmin(request) {
                var data = exports.MsgUpdateGroupPolicyAdmin.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", data);
                return promise.then(function(data) {
                    return exports.MsgUpdateGroupPolicyAdminResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateGroupPolicyDecisionPolicy",
            value: function UpdateGroupPolicyDecisionPolicy(request) {
                var data = exports.MsgUpdateGroupPolicyDecisionPolicy.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", data);
                return promise.then(function(data) {
                    return exports.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateGroupPolicyMetadata",
            value: function UpdateGroupPolicyMetadata(request) {
                var data = exports.MsgUpdateGroupPolicyMetadata.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", data);
                return promise.then(function(data) {
                    return exports.MsgUpdateGroupPolicyMetadataResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "SubmitProposal",
            value: function SubmitProposal(request) {
                var data = exports.MsgSubmitProposal.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", data);
                return promise.then(function(data) {
                    return exports.MsgSubmitProposalResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "WithdrawProposal",
            value: function WithdrawProposal(request) {
                var data = exports.MsgWithdrawProposal.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", data);
                return promise.then(function(data) {
                    return exports.MsgWithdrawProposalResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "Vote",
            value: function Vote(request) {
                var data = exports.MsgVote.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "Vote", data);
                return promise.then(function(data) {
                    return exports.MsgVoteResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "Exec",
            value: function Exec(request) {
                var data = exports.MsgExec.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "Exec", data);
                return promise.then(function(data) {
                    return exports.MsgExecResponse.decode(new _m0.Reader(data));
                });
            }
        },
        {
            key: "LeaveGroup",
            value: function LeaveGroup(request) {
                var data = exports.MsgLeaveGroup.encode(request).finish();
                var promise = this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", data);
                return promise.then(function(data) {
                    return exports.MsgLeaveGroupResponse.decode(new _m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
exports.MsgClientImpl = MsgClientImpl;

});
parcelRegister("c5E5U", function(module, exports) {
"use strict";
var $8cd50d942532d4af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8cd50d942532d4af$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8cd50d942532d4af$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8cd50d942532d4af$var$__createBinding(result, mod, k);
    }
    $8cd50d942532d4af$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.GroupPolicyInfo = module.exports.GroupMember = module.exports.GroupInfo = module.exports.DecisionPolicyWindows = module.exports.PercentageDecisionPolicy = module.exports.ThresholdDecisionPolicy = module.exports.MemberRequest = module.exports.Member = module.exports.proposalExecutorResultToJSON = module.exports.proposalExecutorResultFromJSON = module.exports.ProposalExecutorResult = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

var $ib0XJ = parcelRequire("ib0XJ");

var $i8V5u = parcelRequire("i8V5u");

var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $8cd50d942532d4af$var$_m0 = $8cd50d942532d4af$var$__importStar((parcelRequire("hjb8Q")));
module.exports.protobufPackage = "cosmos.group.v1";
/** VoteOption enumerates the valid vote options for a given proposal. */ var $8cd50d942532d4af$var$VoteOption;
(function(VoteOption) {
    /**
     * VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines an unspecified vote option which will
     * return an error.
     */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($8cd50d942532d4af$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $8cd50d942532d4af$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $8cd50d942532d4af$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $8cd50d942532d4af$var$voteOptionFromJSON;
function $8cd50d942532d4af$var$voteOptionToJSON(object) {
    switch(object){
        case $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $8cd50d942532d4af$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $8cd50d942532d4af$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.voteOptionToJSON = $8cd50d942532d4af$var$voteOptionToJSON;
/** ProposalStatus defines proposal statuses. */ var $8cd50d942532d4af$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - An empty value is invalid and not allowed. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /** PROPOSAL_STATUS_SUBMITTED - Initial status of a proposal when submitted. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_SUBMITTED"] = 1] = "PROPOSAL_STATUS_SUBMITTED";
    /**
     * PROPOSAL_STATUS_ACCEPTED - Final status of a proposal when the final tally is done and the outcome
     * passes the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ACCEPTED"] = 2] = "PROPOSAL_STATUS_ACCEPTED";
    /**
     * PROPOSAL_STATUS_REJECTED - Final status of a proposal when the final tally is done and the outcome
     * is rejected by the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 3] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_ABORTED - Final status of a proposal when the group policy is modified before the
     * final tally.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ABORTED"] = 4] = "PROPOSAL_STATUS_ABORTED";
    /**
     * PROPOSAL_STATUS_WITHDRAWN - A proposal can be withdrawn before the voting start time by the owner.
     * When this happens the final status is Withdrawn.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_WITHDRAWN"] = 5] = "PROPOSAL_STATUS_WITHDRAWN";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($8cd50d942532d4af$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $8cd50d942532d4af$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_SUBMITTED":
            return $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED;
        case 2:
        case "PROPOSAL_STATUS_ACCEPTED":
            return $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED;
        case 3:
        case "PROPOSAL_STATUS_REJECTED":
            return $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 4:
        case "PROPOSAL_STATUS_ABORTED":
            return $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_ABORTED;
        case 5:
        case "PROPOSAL_STATUS_WITHDRAWN":
            return $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $8cd50d942532d4af$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $8cd50d942532d4af$var$proposalStatusFromJSON;
function $8cd50d942532d4af$var$proposalStatusToJSON(object) {
    switch(object){
        case $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED:
            return "PROPOSAL_STATUS_SUBMITTED";
        case $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED:
            return "PROPOSAL_STATUS_ACCEPTED";
        case $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_ABORTED:
            return "PROPOSAL_STATUS_ABORTED";
        case $8cd50d942532d4af$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN:
            return "PROPOSAL_STATUS_WITHDRAWN";
        case $8cd50d942532d4af$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalStatusToJSON = $8cd50d942532d4af$var$proposalStatusToJSON;
/** ProposalExecutorResult defines types of proposal executor results. */ var $8cd50d942532d4af$var$ProposalExecutorResult;
(function(ProposalExecutorResult) {
    /** PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED - An empty value is not allowed. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED"] = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
    /** PROPOSAL_EXECUTOR_RESULT_NOT_RUN - We have not yet run the executor. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_NOT_RUN"] = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
    /** PROPOSAL_EXECUTOR_RESULT_SUCCESS - The executor was successful and proposed action updated state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_SUCCESS"] = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
    /** PROPOSAL_EXECUTOR_RESULT_FAILURE - The executor returned an error and proposed action didn't update state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_FAILURE"] = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE";
    ProposalExecutorResult[ProposalExecutorResult["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($8cd50d942532d4af$var$ProposalExecutorResult = module.exports.ProposalExecutorResult || (module.exports.ProposalExecutorResult = {}));
function $8cd50d942532d4af$var$proposalExecutorResultFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
            return $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
        case 1:
        case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
            return $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
        case 2:
        case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
            return $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
        case 3:
        case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
            return $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $8cd50d942532d4af$var$ProposalExecutorResult.UNRECOGNIZED;
    }
}
module.exports.proposalExecutorResultFromJSON = $8cd50d942532d4af$var$proposalExecutorResultFromJSON;
function $8cd50d942532d4af$var$proposalExecutorResultToJSON(object) {
    switch(object){
        case $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
            return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
        case $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
            return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
        case $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
            return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
        case $8cd50d942532d4af$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE:
            return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
        case $8cd50d942532d4af$var$ProposalExecutorResult.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalExecutorResultToJSON = $8cd50d942532d4af$var$proposalExecutorResultToJSON;
function $8cd50d942532d4af$var$createBaseMember() {
    return {
        address: "",
        weight: "",
        metadata: "",
        addedAt: undefined
    };
}
module.exports.Member = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.addedAt !== undefined) $ib0XJ.Timestamp.encode(message.addedAt, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseMember();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.addedAt = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $7iZIe.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            addedAt: (0, $7iZIe.isSet)(object.addedAt) ? (0, $7iZIe.fromJsonTimestamp)(object.addedAt) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.addedAt !== undefined && (obj.addedAt = (0, $7iZIe.fromTimestamp)(message.addedAt).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseMember();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_weight;
        message.weight = (_object_weight = object.weight) !== null && _object_weight !== void 0 ? _object_weight : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.addedAt = object.addedAt !== undefined && object.addedAt !== null ? $ib0XJ.Timestamp.fromPartial(object.addedAt) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseMemberRequest() {
    return {
        address: "",
        weight: "",
        metadata: ""
    };
}
module.exports.MemberRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseMemberRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $7iZIe.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseMemberRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_weight;
        message.weight = (_object_weight = object.weight) !== null && _object_weight !== void 0 ? _object_weight : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseThresholdDecisionPolicy() {
    return {
        threshold: "",
        windows: undefined
    };
}
module.exports.ThresholdDecisionPolicy = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.threshold !== "") writer.uint32(10).string(message.threshold);
        if (message.windows !== undefined) module.exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseThresholdDecisionPolicy();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.string();
                    break;
                case 2:
                    message.windows = module.exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            threshold: (0, $7iZIe.isSet)(object.threshold) ? String(object.threshold) : "",
            windows: (0, $7iZIe.isSet)(object.windows) ? module.exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.windows !== undefined && (obj.windows = message.windows ? module.exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseThresholdDecisionPolicy();
        var _object_threshold;
        message.threshold = (_object_threshold = object.threshold) !== null && _object_threshold !== void 0 ? _object_threshold : "";
        message.windows = object.windows !== undefined && object.windows !== null ? module.exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBasePercentageDecisionPolicy() {
    return {
        percentage: "",
        windows: undefined
    };
}
module.exports.PercentageDecisionPolicy = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.percentage !== "") writer.uint32(10).string(message.percentage);
        if (message.windows !== undefined) module.exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBasePercentageDecisionPolicy();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.percentage = reader.string();
                    break;
                case 2:
                    message.windows = module.exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            percentage: (0, $7iZIe.isSet)(object.percentage) ? String(object.percentage) : "",
            windows: (0, $7iZIe.isSet)(object.windows) ? module.exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.percentage !== undefined && (obj.percentage = message.percentage);
        message.windows !== undefined && (obj.windows = message.windows ? module.exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBasePercentageDecisionPolicy();
        var _object_percentage;
        message.percentage = (_object_percentage = object.percentage) !== null && _object_percentage !== void 0 ? _object_percentage : "";
        message.windows = object.windows !== undefined && object.windows !== null ? module.exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseDecisionPolicyWindows() {
    return {
        votingPeriod: undefined,
        minExecutionPeriod: undefined
    };
}
module.exports.DecisionPolicyWindows = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.votingPeriod !== undefined) $i8V5u.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        if (message.minExecutionPeriod !== undefined) $i8V5u.Duration.encode(message.minExecutionPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseDecisionPolicyWindows();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.minExecutionPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            votingPeriod: (0, $7iZIe.isSet)(object.votingPeriod) ? $i8V5u.Duration.fromJSON(object.votingPeriod) : undefined,
            minExecutionPeriod: (0, $7iZIe.isSet)(object.minExecutionPeriod) ? $i8V5u.Duration.fromJSON(object.minExecutionPeriod) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $i8V5u.Duration.toJSON(message.votingPeriod) : undefined);
        message.minExecutionPeriod !== undefined && (obj.minExecutionPeriod = message.minExecutionPeriod ? $i8V5u.Duration.toJSON(message.minExecutionPeriod) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseDecisionPolicyWindows();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $i8V5u.Duration.fromPartial(object.votingPeriod) : undefined;
        message.minExecutionPeriod = object.minExecutionPeriod !== undefined && object.minExecutionPeriod !== null ? $i8V5u.Duration.fromPartial(object.minExecutionPeriod) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseGroupInfo() {
    return {
        id: $7iZIe.Long.UZERO,
        admin: "",
        metadata: "",
        version: $7iZIe.Long.UZERO,
        totalWeight: "",
        createdAt: undefined
    };
}
module.exports.GroupInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(32).uint64(message.version);
        if (message.totalWeight !== "") writer.uint32(42).string(message.totalWeight);
        if (message.createdAt !== undefined) $ib0XJ.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseGroupInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.version = reader.uint64();
                    break;
                case 5:
                    message.totalWeight = reader.string();
                    break;
                case 6:
                    message.createdAt = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            id: (0, $7iZIe.isSet)(object.id) ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.UZERO,
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $7iZIe.isSet)(object.version) ? $7iZIe.Long.fromValue(object.version) : $7iZIe.Long.UZERO,
            totalWeight: (0, $7iZIe.isSet)(object.totalWeight) ? String(object.totalWeight) : "",
            createdAt: (0, $7iZIe.isSet)(object.createdAt) ? (0, $7iZIe.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.id !== undefined && (obj.id = (message.id || $7iZIe.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $7iZIe.Long.UZERO).toString());
        message.totalWeight !== undefined && (obj.totalWeight = message.totalWeight);
        message.createdAt !== undefined && (obj.createdAt = (0, $7iZIe.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseGroupInfo();
        message.id = object.id !== undefined && object.id !== null ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.UZERO;
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.version = object.version !== undefined && object.version !== null ? $7iZIe.Long.fromValue(object.version) : $7iZIe.Long.UZERO;
        var _object_totalWeight;
        message.totalWeight = (_object_totalWeight = object.totalWeight) !== null && _object_totalWeight !== void 0 ? _object_totalWeight : "";
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $ib0XJ.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseGroupMember() {
    return {
        groupId: $7iZIe.Long.UZERO,
        member: undefined
    };
}
module.exports.GroupMember = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.member !== undefined) module.exports.Member.encode(message.member, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseGroupMember();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.member = module.exports.Member.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            member: (0, $7iZIe.isSet)(object.member) ? module.exports.Member.fromJSON(object.member) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        message.member !== undefined && (obj.member = message.member ? module.exports.Member.toJSON(message.member) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseGroupMember();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        message.member = object.member !== undefined && object.member !== null ? module.exports.Member.fromPartial(object.member) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseGroupPolicyInfo() {
    return {
        address: "",
        groupId: $7iZIe.Long.UZERO,
        admin: "",
        metadata: "",
        version: $7iZIe.Long.UZERO,
        decisionPolicy: undefined,
        createdAt: undefined
    };
}
module.exports.GroupPolicyInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(40).uint64(message.version);
        if (message.decisionPolicy !== undefined) $DM7bi.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        if (message.createdAt !== undefined) $ib0XJ.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseGroupPolicyInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.version = reader.uint64();
                    break;
                case 6:
                    message.decisionPolicy = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.createdAt = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $7iZIe.isSet)(object.groupId) ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO,
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $7iZIe.isSet)(object.version) ? $7iZIe.Long.fromValue(object.version) : $7iZIe.Long.UZERO,
            decisionPolicy: (0, $7iZIe.isSet)(object.decisionPolicy) ? $DM7bi.Any.fromJSON(object.decisionPolicy) : undefined,
            createdAt: (0, $7iZIe.isSet)(object.createdAt) ? (0, $7iZIe.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $7iZIe.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $7iZIe.Long.UZERO).toString());
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $DM7bi.Any.toJSON(message.decisionPolicy) : undefined);
        message.createdAt !== undefined && (obj.createdAt = (0, $7iZIe.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseGroupPolicyInfo();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $7iZIe.Long.fromValue(object.groupId) : $7iZIe.Long.UZERO;
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.version = object.version !== undefined && object.version !== null ? $7iZIe.Long.fromValue(object.version) : $7iZIe.Long.UZERO;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $DM7bi.Any.fromPartial(object.decisionPolicy) : undefined;
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $ib0XJ.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseProposal() {
    return {
        id: $7iZIe.Long.UZERO,
        groupPolicyAddress: "",
        metadata: "",
        proposers: [],
        submitTime: undefined,
        groupVersion: $7iZIe.Long.UZERO,
        groupPolicyVersion: $7iZIe.Long.UZERO,
        status: 0,
        finalTallyResult: undefined,
        votingPeriodEnd: undefined,
        executorResult: 0,
        messages: [],
        title: "",
        summary: ""
    };
}
module.exports.Proposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.proposers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(34).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.submitTime !== undefined) $ib0XJ.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (!message.groupVersion.isZero()) writer.uint32(48).uint64(message.groupVersion);
        if (!message.groupPolicyVersion.isZero()) writer.uint32(56).uint64(message.groupPolicyVersion);
        if (message.status !== 0) writer.uint32(64).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(74).fork()).ldelim();
        if (message.votingPeriodEnd !== undefined) $ib0XJ.Timestamp.encode(message.votingPeriodEnd, writer.uint32(82).fork()).ldelim();
        if (message.executorResult !== 0) writer.uint32(88).int32(message.executorResult);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.messages[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $DM7bi.Any.encode(v1, writer.uint32(98).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.title !== "") writer.uint32(106).string(message.title);
        if (message.summary !== "") writer.uint32(114).string(message.summary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.proposers.push(reader.string());
                    break;
                case 5:
                    message.submitTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.groupVersion = reader.uint64();
                    break;
                case 7:
                    message.groupPolicyVersion = reader.uint64();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.votingPeriodEnd = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.executorResult = reader.int32();
                    break;
                case 12:
                    message.messages.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.title = reader.string();
                    break;
                case 14:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            id: (0, $7iZIe.isSet)(object.id) ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.UZERO,
            groupPolicyAddress: (0, $7iZIe.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            proposers: Array.isArray(object === null || object === void 0 ? void 0 : object.proposers) ? object.proposers.map(function(e) {
                return String(e);
            }) : [],
            submitTime: (0, $7iZIe.isSet)(object.submitTime) ? (0, $7iZIe.fromJsonTimestamp)(object.submitTime) : undefined,
            groupVersion: (0, $7iZIe.isSet)(object.groupVersion) ? $7iZIe.Long.fromValue(object.groupVersion) : $7iZIe.Long.UZERO,
            groupPolicyVersion: (0, $7iZIe.isSet)(object.groupPolicyVersion) ? $7iZIe.Long.fromValue(object.groupPolicyVersion) : $7iZIe.Long.UZERO,
            status: (0, $7iZIe.isSet)(object.status) ? $8cd50d942532d4af$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $7iZIe.isSet)(object.finalTallyResult) ? module.exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            votingPeriodEnd: (0, $7iZIe.isSet)(object.votingPeriodEnd) ? (0, $7iZIe.fromJsonTimestamp)(object.votingPeriodEnd) : undefined,
            executorResult: (0, $7iZIe.isSet)(object.executorResult) ? $8cd50d942532d4af$var$proposalExecutorResultFromJSON(object.executorResult) : 0,
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $7iZIe.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.id !== undefined && (obj.id = (message.id || $7iZIe.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.proposers) obj.proposers = message.proposers.map(function(e) {
            return e;
        });
        else obj.proposers = [];
        message.submitTime !== undefined && (obj.submitTime = (0, $7iZIe.fromTimestamp)(message.submitTime).toISOString());
        message.groupVersion !== undefined && (obj.groupVersion = (message.groupVersion || $7iZIe.Long.UZERO).toString());
        message.groupPolicyVersion !== undefined && (obj.groupPolicyVersion = (message.groupPolicyVersion || $7iZIe.Long.UZERO).toString());
        message.status !== undefined && (obj.status = $8cd50d942532d4af$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.votingPeriodEnd !== undefined && (obj.votingPeriodEnd = (0, $7iZIe.fromTimestamp)(message.votingPeriodEnd).toISOString());
        message.executorResult !== undefined && (obj.executorResult = $8cd50d942532d4af$var$proposalExecutorResultToJSON(message.executorResult));
        if (message.messages) obj.messages = message.messages.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.messages = [];
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial: function(object) {
        var _object_proposers, _object_messages;
        var message = $8cd50d942532d4af$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.UZERO;
        var _object_groupPolicyAddress;
        message.groupPolicyAddress = (_object_groupPolicyAddress = object.groupPolicyAddress) !== null && _object_groupPolicyAddress !== void 0 ? _object_groupPolicyAddress : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.proposers = ((_object_proposers = object.proposers) === null || _object_proposers === void 0 ? void 0 : _object_proposers.map(function(e) {
            return e;
        })) || [];
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $ib0XJ.Timestamp.fromPartial(object.submitTime) : undefined;
        message.groupVersion = object.groupVersion !== undefined && object.groupVersion !== null ? $7iZIe.Long.fromValue(object.groupVersion) : $7iZIe.Long.UZERO;
        message.groupPolicyVersion = object.groupPolicyVersion !== undefined && object.groupPolicyVersion !== null ? $7iZIe.Long.fromValue(object.groupPolicyVersion) : $7iZIe.Long.UZERO;
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? module.exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.votingPeriodEnd = object.votingPeriodEnd !== undefined && object.votingPeriodEnd !== null ? $ib0XJ.Timestamp.fromPartial(object.votingPeriodEnd) : undefined;
        var _object_executorResult;
        message.executorResult = (_object_executorResult = object.executorResult) !== null && _object_executorResult !== void 0 ? _object_executorResult : 0;
        message.messages = ((_object_messages = object.messages) === null || _object_messages === void 0 ? void 0 : _object_messages.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_summary;
        message.summary = (_object_summary = object.summary) !== null && _object_summary !== void 0 ? _object_summary : "";
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
module.exports.TallyResult = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseTallyResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            yesCount: (0, $7iZIe.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $7iZIe.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $7iZIe.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $7iZIe.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseTallyResult();
        var _object_yesCount;
        message.yesCount = (_object_yesCount = object.yesCount) !== null && _object_yesCount !== void 0 ? _object_yesCount : "";
        var _object_abstainCount;
        message.abstainCount = (_object_abstainCount = object.abstainCount) !== null && _object_abstainCount !== void 0 ? _object_abstainCount : "";
        var _object_noCount;
        message.noCount = (_object_noCount = object.noCount) !== null && _object_noCount !== void 0 ? _object_noCount : "";
        var _object_noWithVetoCount;
        message.noWithVetoCount = (_object_noWithVetoCount = object.noWithVetoCount) !== null && _object_noWithVetoCount !== void 0 ? _object_noWithVetoCount : "";
        return message;
    }
};
function $8cd50d942532d4af$var$createBaseVote() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        submitTime: undefined
    };
}
module.exports.Vote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8cd50d942532d4af$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.submitTime !== undefined) $ib0XJ.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8cd50d942532d4af$var$_m0.Reader ? input : new $8cd50d942532d4af$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8cd50d942532d4af$var$createBaseVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.submitTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $7iZIe.isSet)(object.option) ? $8cd50d942532d4af$var$voteOptionFromJSON(object.option) : 0,
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            submitTime: (0, $7iZIe.isSet)(object.submitTime) ? (0, $7iZIe.fromJsonTimestamp)(object.submitTime) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $8cd50d942532d4af$var$voteOptionToJSON(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.submitTime !== undefined && (obj.submitTime = (0, $7iZIe.fromTimestamp)(message.submitTime).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8cd50d942532d4af$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $ib0XJ.Timestamp.fromPartial(object.submitTime) : undefined;
        return message;
    }
};

});
parcelRegister("ib0XJ", function(module, exports) {
"use strict";
var $d3ba0034e661c146$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d3ba0034e661c146$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d3ba0034e661c146$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d3ba0034e661c146$var$__createBinding(result, mod, k);
    }
    $d3ba0034e661c146$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timestamp = module.exports.protobufPackage = void 0;

var $7iZIe = parcelRequire("7iZIe");

var $d3ba0034e661c146$var$_m0 = $d3ba0034e661c146$var$__importStar((parcelRequire("hjb8Q")));
module.exports.protobufPackage = "google.protobuf";
function $d3ba0034e661c146$var$createBaseTimestamp() {
    return {
        seconds: $7iZIe.Long.ZERO,
        nanos: 0
    };
}
module.exports.Timestamp = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d3ba0034e661c146$var$_m0.Writer.create();
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d3ba0034e661c146$var$_m0.Reader ? input : new $d3ba0034e661c146$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d3ba0034e661c146$var$createBaseTimestamp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            seconds: (0, $7iZIe.isSet)(object.seconds) ? $7iZIe.Long.fromValue(object.seconds) : $7iZIe.Long.ZERO,
            nanos: (0, $7iZIe.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $7iZIe.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial: function(object) {
        var message = $d3ba0034e661c146$var$createBaseTimestamp();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $7iZIe.Long.fromValue(object.seconds) : $7iZIe.Long.ZERO;
        var _object_nanos;
        message.nanos = (_object_nanos = object.nanos) !== null && _object_nanos !== void 0 ? _object_nanos : 0;
        return message;
    }
};

});
parcelRegister("7iZIe", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");

var $ilnag = parcelRequire("ilnag");
var $551a15ab31bc1d5c$require$Buffer = $ilnag.Buffer;
"use strict";
/* eslint-disable */ /**
 * This file and any referenced files were automatically generated by @osmonauts/telescope@0.94.1
 * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
 * and run the transpile command or yarn proto command to regenerate this bundle.
 */ var $551a15ab31bc1d5c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $551a15ab31bc1d5c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $551a15ab31bc1d5c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $551a15ab31bc1d5c$var$__createBinding(result, mod, k);
    }
    $551a15ab31bc1d5c$var$__setModuleDefault(result, mod);
    return result;
};
var $551a15ab31bc1d5c$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromJsonTimestamp = module.exports.fromTimestamp = module.exports.toTimestamp = module.exports.setPaginationParams = module.exports.isObject = module.exports.isSet = module.exports.fromDuration = module.exports.toDuration = module.exports.omitDefault = module.exports.base64FromBytes = module.exports.bytesFromBase64 = module.exports.Long = void 0;

var $551a15ab31bc1d5c$var$_m0 = $551a15ab31bc1d5c$var$__importStar((parcelRequire("hjb8Q")));

var $551a15ab31bc1d5c$var$long_1 = $551a15ab31bc1d5c$var$__importDefault((parcelRequire("l6G6L")));
module.exports.Long = $551a15ab31bc1d5c$var$long_1.default;
// @ts-ignore
if ($551a15ab31bc1d5c$var$_m0.util.Long !== $551a15ab31bc1d5c$var$long_1.default) {
    $551a15ab31bc1d5c$var$_m0.util.Long = $551a15ab31bc1d5c$var$long_1.default;
    $551a15ab31bc1d5c$var$_m0.configure();
}
var $551a15ab31bc1d5c$var$_$globalThis = function() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
}();
var $551a15ab31bc1d5c$var$atob = globalThis.atob || function(b64) {
    return globalThis.Buffer.from(b64, "base64").toString("binary");
};
function $551a15ab31bc1d5c$var$bytesFromBase64(b64) {
    var bin = $551a15ab31bc1d5c$var$atob(b64);
    var arr = new Uint8Array(bin.length);
    for(var i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
module.exports.bytesFromBase64 = $551a15ab31bc1d5c$var$bytesFromBase64;
var $551a15ab31bc1d5c$var$btoa = globalThis.btoa || function(bin) {
    return globalThis.Buffer.from(bin, "binary").toString("base64");
};
function $551a15ab31bc1d5c$var$base64FromBytes(arr) {
    var bin = [];
    arr.forEach(function(byte) {
        bin.push(String.fromCharCode(byte));
    });
    return $551a15ab31bc1d5c$var$btoa(bin.join(""));
}
module.exports.base64FromBytes = $551a15ab31bc1d5c$var$base64FromBytes;
function $551a15ab31bc1d5c$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($551a15ab31bc1d5c$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error("Got unsupported type ".concat(typeof input === "undefined" ? "undefined" : (0, $aVMuR._)(input)));
}
module.exports.omitDefault = $551a15ab31bc1d5c$var$omitDefault;
function $551a15ab31bc1d5c$var$toDuration(duration) {
    return {
        seconds: $551a15ab31bc1d5c$var$long_1.default.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
        nanos: parseInt(duration) % 1000000000
    };
}
module.exports.toDuration = $551a15ab31bc1d5c$var$toDuration;
function $551a15ab31bc1d5c$var$fromDuration(duration) {
    return (parseInt(duration.seconds.toString()) * 1000000000 + duration.nanos).toString();
}
module.exports.fromDuration = $551a15ab31bc1d5c$var$fromDuration;
function $551a15ab31bc1d5c$var$isSet(value) {
    return value !== null && value !== undefined;
}
module.exports.isSet = $551a15ab31bc1d5c$var$isSet;
function $551a15ab31bc1d5c$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
module.exports.isObject = $551a15ab31bc1d5c$var$isObject;
var $551a15ab31bc1d5c$var$setPaginationParams = function(options, pagination) {
    if (!pagination) return options;
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.countTotal) !== "undefined") options.params["pagination.count_total"] = pagination.countTotal;
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.key) !== "undefined") // String to Uint8Array
    // let uint8arr = new Uint8Array(Buffer.from(data,'base64'));
    // Uint8Array to String
    options.params["pagination.key"] = $551a15ab31bc1d5c$require$Buffer.from(pagination.key).toString("base64");
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.limit) !== "undefined") options.params["pagination.limit"] = pagination.limit.toString();
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.offset) !== "undefined") options.params["pagination.offset"] = pagination.offset.toString();
    if (typeof (pagination === null || pagination === void 0 ? void 0 : pagination.reverse) !== "undefined") options.params["pagination.reverse"] = pagination.reverse;
    return options;
};
module.exports.setPaginationParams = $551a15ab31bc1d5c$var$setPaginationParams;
function $551a15ab31bc1d5c$var$toTimestamp(date) {
    var seconds = $551a15ab31bc1d5c$var$numberToLong(date.getTime() / 1000);
    var nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
module.exports.toTimestamp = $551a15ab31bc1d5c$var$toTimestamp;
function $551a15ab31bc1d5c$var$fromTimestamp(t) {
    var millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
module.exports.fromTimestamp = $551a15ab31bc1d5c$var$fromTimestamp;
var $551a15ab31bc1d5c$var$fromJSON = function(object) {
    return {
        seconds: $551a15ab31bc1d5c$var$isSet(object.seconds) ? $551a15ab31bc1d5c$var$long_1.default.fromString(object.seconds) : $551a15ab31bc1d5c$var$long_1.default.ZERO,
        nanos: $551a15ab31bc1d5c$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
var $551a15ab31bc1d5c$var$timestampFromJSON = function(object) {
    return {
        seconds: $551a15ab31bc1d5c$var$isSet(object.seconds) ? $551a15ab31bc1d5c$var$long_1.default.fromValue(object.seconds) : $551a15ab31bc1d5c$var$long_1.default.ZERO,
        nanos: $551a15ab31bc1d5c$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
function $551a15ab31bc1d5c$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $551a15ab31bc1d5c$var$toTimestamp(o);
    else if (typeof o === "string") return $551a15ab31bc1d5c$var$toTimestamp(new Date(o));
    else return $551a15ab31bc1d5c$var$timestampFromJSON(o);
}
module.exports.fromJsonTimestamp = $551a15ab31bc1d5c$var$fromJsonTimestamp;
function $551a15ab31bc1d5c$var$numberToLong(number) {
    return $551a15ab31bc1d5c$var$long_1.default.fromNumber(number);
}

});


parcelRegister("i8V5u", function(module, exports) {
"use strict";
var $d35541c1fab47cab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d35541c1fab47cab$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d35541c1fab47cab$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d35541c1fab47cab$var$__createBinding(result, mod, k);
    }
    $d35541c1fab47cab$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = module.exports.protobufPackage = void 0;

var $7iZIe = parcelRequire("7iZIe");

var $d35541c1fab47cab$var$_m0 = $d35541c1fab47cab$var$__importStar((parcelRequire("hjb8Q")));
module.exports.protobufPackage = "google.protobuf";
function $d35541c1fab47cab$var$createBaseDuration() {
    return {
        seconds: $7iZIe.Long.ZERO,
        nanos: 0
    };
}
module.exports.Duration = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d35541c1fab47cab$var$_m0.Writer.create();
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d35541c1fab47cab$var$_m0.Reader ? input : new $d35541c1fab47cab$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d35541c1fab47cab$var$createBaseDuration();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            seconds: (0, $7iZIe.isSet)(object.seconds) ? $7iZIe.Long.fromValue(object.seconds) : $7iZIe.Long.ZERO,
            nanos: (0, $7iZIe.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $7iZIe.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial: function(object) {
        var message = $d35541c1fab47cab$var$createBaseDuration();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $7iZIe.Long.fromValue(object.seconds) : $7iZIe.Long.ZERO;
        var _object_nanos;
        message.nanos = (_object_nanos = object.nanos) !== null && _object_nanos !== void 0 ? _object_nanos : 0;
        return message;
    }
};

});

parcelRegister("DM7bi", function(module, exports) {
"use strict";
var $0778f73c453c42c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0778f73c453c42c4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0778f73c453c42c4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0778f73c453c42c4$var$__createBinding(result, mod, k);
    }
    $0778f73c453c42c4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $0778f73c453c42c4$var$_m0 = $0778f73c453c42c4$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
module.exports.protobufPackage = "google.protobuf";
function $0778f73c453c42c4$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
module.exports.Any = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $0778f73c453c42c4$var$_m0.Writer.create();
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0778f73c453c42c4$var$_m0.Reader ? input : new $0778f73c453c42c4$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0778f73c453c42c4$var$createBaseAny();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            typeUrl: (0, $7iZIe.isSet)(object.typeUrl) ? String(object.typeUrl) : "",
            value: (0, $7iZIe.isSet)(object.value) ? (0, $7iZIe.bytesFromBase64)(object.value) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = (0, $7iZIe.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $0778f73c453c42c4$var$createBaseAny();
        var _object_typeUrl;
        message.typeUrl = (_object_typeUrl = object.typeUrl) !== null && _object_typeUrl !== void 0 ? _object_typeUrl : "";
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : new Uint8Array();
        return message;
    }
};

});



parcelRegister("1jrnB", function(module, exports) {

module.exports = (parcelRequire("7thU1"));

});
parcelRegister("7thU1", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");

var $kB1dj = parcelRequire("kB1dj");

var $3gNMj = parcelRequire("3gNMj");

var $3jFJy = parcelRequire("3jFJy");

var $kTll4 = parcelRequire("kTll4");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $570920ede4c16b2c$var$createInstance(defaultConfig) {
    var context = new $3gNMj(defaultConfig);
    var instance = $kB1dj($3gNMj.prototype.request, context);
    // Copy axios.prototype to instance
    $anvhP.extend(instance, $3gNMj.prototype, context);
    // Copy context to instance
    $anvhP.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $570920ede4c16b2c$var$axios = $570920ede4c16b2c$var$createInstance($kTll4);
// Expose Axios class to allow class inheritance
$570920ede4c16b2c$var$axios.Axios = $3gNMj;
// Factory for creating new instances
$570920ede4c16b2c$var$axios.create = function create(instanceConfig) {
    return $570920ede4c16b2c$var$createInstance($3jFJy($570920ede4c16b2c$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$570920ede4c16b2c$var$axios.Cancel = (parcelRequire("9hnEc"));

$570920ede4c16b2c$var$axios.CancelToken = (parcelRequire("dq0Cc"));

$570920ede4c16b2c$var$axios.isCancel = (parcelRequire("96ksC"));
// Expose all/spread
$570920ede4c16b2c$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$570920ede4c16b2c$var$axios.spread = (parcelRequire("67JVd"));

// Expose isAxiosError
$570920ede4c16b2c$var$axios.isAxiosError = (parcelRequire("3fCH2"));
module.exports = $570920ede4c16b2c$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $570920ede4c16b2c$var$axios;

});
parcelRegister("anvhP", function(module, exports) {
"use strict";

var $kB1dj = parcelRequire("kB1dj");
// utils is a library of generic helper functions non-specific to axios
var $78e452333a5d9537$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $78e452333a5d9537$var$isArray(val) {
    return $78e452333a5d9537$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $78e452333a5d9537$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $78e452333a5d9537$var$isBuffer(val) {
    return val !== null && !$78e452333a5d9537$var$isUndefined(val) && val.constructor !== null && !$78e452333a5d9537$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $78e452333a5d9537$var$isArrayBuffer(val) {
    return $78e452333a5d9537$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $78e452333a5d9537$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $78e452333a5d9537$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $78e452333a5d9537$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $78e452333a5d9537$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $78e452333a5d9537$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $78e452333a5d9537$var$isPlainObject(val) {
    if ($78e452333a5d9537$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $78e452333a5d9537$var$isDate(val) {
    return $78e452333a5d9537$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $78e452333a5d9537$var$isFile(val) {
    return $78e452333a5d9537$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $78e452333a5d9537$var$isBlob(val) {
    return $78e452333a5d9537$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $78e452333a5d9537$var$isFunction(val) {
    return $78e452333a5d9537$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $78e452333a5d9537$var$isStream(val) {
    return $78e452333a5d9537$var$isObject(val) && $78e452333a5d9537$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $78e452333a5d9537$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $78e452333a5d9537$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $78e452333a5d9537$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $78e452333a5d9537$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($78e452333a5d9537$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $78e452333a5d9537$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($78e452333a5d9537$var$isPlainObject(result[key]) && $78e452333a5d9537$var$isPlainObject(val)) result[key] = $78e452333a5d9537$var$merge(result[key], val);
        else if ($78e452333a5d9537$var$isPlainObject(val)) result[key] = $78e452333a5d9537$var$merge({}, val);
        else if ($78e452333a5d9537$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$78e452333a5d9537$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $78e452333a5d9537$var$extend(a, b, thisArg) {
    $78e452333a5d9537$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $kB1dj(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $78e452333a5d9537$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $78e452333a5d9537$var$isArray,
    isArrayBuffer: $78e452333a5d9537$var$isArrayBuffer,
    isBuffer: $78e452333a5d9537$var$isBuffer,
    isFormData: $78e452333a5d9537$var$isFormData,
    isArrayBufferView: $78e452333a5d9537$var$isArrayBufferView,
    isString: $78e452333a5d9537$var$isString,
    isNumber: $78e452333a5d9537$var$isNumber,
    isObject: $78e452333a5d9537$var$isObject,
    isPlainObject: $78e452333a5d9537$var$isPlainObject,
    isUndefined: $78e452333a5d9537$var$isUndefined,
    isDate: $78e452333a5d9537$var$isDate,
    isFile: $78e452333a5d9537$var$isFile,
    isBlob: $78e452333a5d9537$var$isBlob,
    isFunction: $78e452333a5d9537$var$isFunction,
    isStream: $78e452333a5d9537$var$isStream,
    isURLSearchParams: $78e452333a5d9537$var$isURLSearchParams,
    isStandardBrowserEnv: $78e452333a5d9537$var$isStandardBrowserEnv,
    forEach: $78e452333a5d9537$var$forEach,
    merge: $78e452333a5d9537$var$merge,
    extend: $78e452333a5d9537$var$extend,
    trim: $78e452333a5d9537$var$trim,
    stripBOM: $78e452333a5d9537$var$stripBOM
};

});
parcelRegister("kB1dj", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("3gNMj", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");

var $eCd0L = parcelRequire("eCd0L");

var $5yH3i = parcelRequire("5yH3i");

var $7Pv6d = parcelRequire("7Pv6d");

var $3jFJy = parcelRequire("3jFJy");

var $9r0kT = parcelRequire("9r0kT");
var $26197a9d8df40a6f$var$validators = $9r0kT.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $26197a9d8df40a6f$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $5yH3i(),
        response: new $5yH3i()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $26197a9d8df40a6f$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $3jFJy(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $9r0kT.assertOptions(transitional, {
        silentJSONParsing: $26197a9d8df40a6f$var$validators.transitional($26197a9d8df40a6f$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $26197a9d8df40a6f$var$validators.transitional($26197a9d8df40a6f$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $26197a9d8df40a6f$var$validators.transitional($26197a9d8df40a6f$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $7Pv6d,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $7Pv6d(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$26197a9d8df40a6f$var$Axios.prototype.getUri = function getUri(config) {
    config = $3jFJy(this.defaults, config);
    return $eCd0L(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$anvhP.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $26197a9d8df40a6f$var$Axios.prototype[method] = function(url, config) {
        return this.request($3jFJy(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$anvhP.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $26197a9d8df40a6f$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($3jFJy(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $26197a9d8df40a6f$var$Axios;

});
parcelRegister("eCd0L", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
function $aa3eb5102354267d$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($anvhP.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $anvhP.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($anvhP.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $anvhP.forEach(val, function parseValue(v) {
                if ($anvhP.isDate(v)) v = v.toISOString();
                else if ($anvhP.isObject(v)) v = JSON.stringify(v);
                parts.push($aa3eb5102354267d$var$encode(key) + "=" + $aa3eb5102354267d$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("5yH3i", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
function $40c185fae355700f$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $40c185fae355700f$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $40c185fae355700f$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $40c185fae355700f$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $anvhP.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $40c185fae355700f$var$InterceptorManager;

});

parcelRegister("7Pv6d", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");

var $cwiKW = parcelRequire("cwiKW");

var $96ksC = parcelRequire("96ksC");

var $kTll4 = parcelRequire("kTll4");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $5b356b810e2d37c6$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $5b356b810e2d37c6$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $cwiKW.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $anvhP.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $anvhP.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $kTll4.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $5b356b810e2d37c6$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $cwiKW.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$96ksC(reason)) {
            $5b356b810e2d37c6$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $cwiKW.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("cwiKW", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");

var $kTll4 = parcelRequire("kTll4");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $kTll4;
    /*eslint no-param-reassign:0*/ $anvhP.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("kTll4", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
"use strict";

var $anvhP = parcelRequire("anvhP");

var $gs37i = parcelRequire("gs37i");

var $aAtiV = parcelRequire("aAtiV");
var $f3597f232fc4a9f6$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $f3597f232fc4a9f6$var$setContentTypeIfUnset(headers, value) {
    if (!$anvhP.isUndefined(headers) && $anvhP.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $f3597f232fc4a9f6$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("gcYlp"));
    else if (typeof $4pbh3 !== "undefined" && Object.prototype.toString.call($4pbh3) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("gcYlp"));
    return adapter;
}
function $f3597f232fc4a9f6$var$stringifySafely(rawValue, parser, encoder) {
    if ($anvhP.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $anvhP.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $f3597f232fc4a9f6$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $f3597f232fc4a9f6$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $gs37i(headers, "Accept");
            $gs37i(headers, "Content-Type");
            if ($anvhP.isFormData(data) || $anvhP.isArrayBuffer(data) || $anvhP.isBuffer(data) || $anvhP.isStream(data) || $anvhP.isFile(data) || $anvhP.isBlob(data)) return data;
            if ($anvhP.isArrayBufferView(data)) return data.buffer;
            if ($anvhP.isURLSearchParams(data)) {
                $f3597f232fc4a9f6$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($anvhP.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $f3597f232fc4a9f6$var$setContentTypeIfUnset(headers, "application/json");
                return $f3597f232fc4a9f6$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $anvhP.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $aAtiV(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$f3597f232fc4a9f6$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$anvhP.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $f3597f232fc4a9f6$var$defaults.headers[method] = {};
});
$anvhP.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $f3597f232fc4a9f6$var$defaults.headers[method] = $anvhP.merge($f3597f232fc4a9f6$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $f3597f232fc4a9f6$var$defaults;

});
parcelRegister("gs37i", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $anvhP.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("aAtiV", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("gcYlp", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");

var $5czBo = parcelRequire("5czBo");

var $bVkIz = parcelRequire("bVkIz");

var $eCd0L = parcelRequire("eCd0L");

var $bEpLH = parcelRequire("bEpLH");

var $bXGWX = parcelRequire("bXGWX");

var $2ovHy = parcelRequire("2ovHy");

var $lcNNL = parcelRequire("lcNNL");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($anvhP.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $bEpLH(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $eCd0L(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $bXGWX(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $5czBo(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($lcNNL("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($lcNNL("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($lcNNL(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($anvhP.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $2ovHy(fullPath)) && config.xsrfCookieName ? $bVkIz.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $anvhP.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$anvhP.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("5czBo", function(module, exports) {
"use strict";

var $lcNNL = parcelRequire("lcNNL");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($lcNNL("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("lcNNL", function(module, exports) {
"use strict";

var $aAtiV = parcelRequire("aAtiV");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $aAtiV(error, config, code, request, response);
};

});


parcelRegister("bVkIz", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
module.exports = $anvhP.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($anvhP.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($anvhP.isString(path)) cookie.push("path=" + path);
            if ($anvhP.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("bEpLH", function(module, exports) {
"use strict";

var $4YZaB = parcelRequire("4YZaB");

var $aV02k = parcelRequire("aV02k");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$4YZaB(requestedURL)) return $aV02k(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("4YZaB", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("aV02k", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("bXGWX", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $8b56855f409812d6$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $anvhP.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $anvhP.trim(line.substr(0, i)).toLowerCase();
        val = $anvhP.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $8b56855f409812d6$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("2ovHy", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
module.exports = $anvhP.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $anvhP.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("96ksC", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("3jFJy", function(module, exports) {
"use strict";

var $anvhP = parcelRequire("anvhP");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($anvhP.isPlainObject(target) && $anvhP.isPlainObject(source)) return $anvhP.merge(target, source);
        else if ($anvhP.isPlainObject(source)) return $anvhP.merge({}, source);
        else if ($anvhP.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$anvhP.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$anvhP.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $anvhP.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$anvhP.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $anvhP.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $anvhP.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$anvhP.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$anvhP.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $anvhP.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $anvhP.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("9r0kT", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");
"use strict";

var $54XWb = parcelRequire("54XWb");
var $6de6e56487841a60$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $6de6e56487841a60$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $aVMuR._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $6de6e56487841a60$var$deprecatedWarnings = {};
var $6de6e56487841a60$var$currentVerArr = $54XWb.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $6de6e56487841a60$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $6de6e56487841a60$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $6de6e56487841a60$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $6de6e56487841a60$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $54XWb.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$6de6e56487841a60$var$deprecatedWarnings[opt]) {
            $6de6e56487841a60$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $6de6e56487841a60$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $6de6e56487841a60$var$isOlderVersion,
    assertOptions: $6de6e56487841a60$var$assertOptions,
    validators: $6de6e56487841a60$var$validators
};

});
parcelRegister("54XWb", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("9hnEc", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $6c180b7b39e6be9f$var$Cancel(message) {
    this.message = message;
}
$6c180b7b39e6be9f$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$6c180b7b39e6be9f$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $6c180b7b39e6be9f$var$Cancel;

});

parcelRegister("dq0Cc", function(module, exports) {
"use strict";

var $9hnEc = parcelRequire("9hnEc");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $9c4e2e323c704b5b$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $9hnEc(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $9c4e2e323c704b5b$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $9c4e2e323c704b5b$var$CancelToken.source = function source() {
    var cancel;
    var token = new $9c4e2e323c704b5b$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $9c4e2e323c704b5b$var$CancelToken;

});

parcelRegister("67JVd", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("3fCH2", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRegister("6pgsi", function(module, exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $4aa1d78d22832e8b$var$ws = null;
if (typeof WebSocket !== "undefined") $4aa1d78d22832e8b$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $4aa1d78d22832e8b$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $4aa1d78d22832e8b$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $4aa1d78d22832e8b$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $4aa1d78d22832e8b$var$ws = self.WebSocket || self.MozWebSocket;
module.exports = $4aa1d78d22832e8b$var$ws;

});

parcelRegister("2Xz7H", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $9tkUv = parcelRequire("9tkUv");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function get() {
        return $9tkUv.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function get() {
        return $9tkUv.SubscriptionEventType;
    }
});

var $aat7p = parcelRequire("aat7p");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function get() {
        return $aat7p.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function get() {
        return $aat7p.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function get() {
        return $aat7p.VoteType;
    }
});

var $iKROW = parcelRequire("iKROW");
Object.defineProperty(module.exports, "Tendermint34Client", {
    enumerable: true,
    get: function get() {
        return $iKROW.Tendermint34Client;
    }
});

});
parcelRegister("9tkUv", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $6e570ae15700e68b$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($6e570ae15700e68b$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $6e570ae15700e68b$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($6e570ae15700e68b$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $6e570ae15700e68b$var$buildQuery(components) {
    var tags = components.tags ? components.tags : [];
    var tagComponents = tags.map(function(tag) {
        return "".concat(tag.key, "='").concat(tag.value, "'");
    });
    var rawComponents = components.raw ? [
        components.raw
    ] : [];
    return (0, $gF0bR._)(tagComponents).concat((0, $gF0bR._)(rawComponents)).join(" AND ");
}
module.exports.buildQuery = $6e570ae15700e68b$var$buildQuery;

});

parcelRegister("aat7p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $76716ce2190a24e8$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $76716ce2190a24e8$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $76716ce2190a24e8$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $76716ce2190a24e8$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $76716ce2190a24e8$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($76716ce2190a24e8$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("iKROW", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $da7645848bf3e049$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $da7645848bf3e049$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $da7645848bf3e049$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $da7645848bf3e049$var$__createBinding(result, mod, k);
    }
    $da7645848bf3e049$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = void 0;

var $5WHTi = parcelRequire("5WHTi");

var $1GCRg = parcelRequire("1GCRg");

var $4Yljk = parcelRequire("4Yljk");

var $da7645848bf3e049$var$requests = $da7645848bf3e049$var$__importStar((parcelRequire("9tkUv")));
var $da7645848bf3e049$var$Tendermint34Client = /*#__PURE__*/ function() {
    function Tendermint34Client(client) {
        (0, $7dKN1._)(this, Tendermint34Client);
        this.client = client;
        this.p = $4Yljk.adaptor34.params;
        this.r = $4Yljk.adaptor34.responses;
    }
    (0, $eW5pA._)(Tendermint34Client, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.client.disconnect();
            }
        },
        {
            key: "abciInfo",
            value: function abciInfo() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.AbciInfo
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeAbciInfo, _this.r.decodeAbciInfo)
                        ];
                    });
                })();
            }
        },
        {
            key: "abciQuery",
            value: function abciQuery(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $da7645848bf3e049$var$requests.Method.AbciQuery
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeAbciQuery, _this.r.decodeAbciQuery)
                        ];
                    });
                })();
            }
        },
        {
            key: "block",
            value: function block(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Block,
                            params: {
                                height: height
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBlock, _this.r.decodeBlock)
                        ];
                    });
                })();
            }
        },
        {
            key: "blockResults",
            value: function blockResults(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.BlockResults,
                            params: {
                                height: height
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBlockResults, _this.r.decodeBlockResults)
                        ];
                    });
                })();
            }
        },
        {
            key: "blockSearch",
            value: /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ function blockSearch(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query, resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                query = {
                                    params: params,
                                    method: $da7645848bf3e049$var$requests.Method.BlockSearch
                                };
                                return [
                                    4,
                                    _this.doCall(query, _this.p.encodeBlockSearch, _this.r.decodeBlockSearch)
                                ];
                            case 1:
                                resp = _state.sent();
                                return [
                                    2,
                                    (0, $gddcW._)((0, $4JCw4._)({}, resp), {
                                        // make sure we sort by height, as tendermint may be sorting by string value of the height
                                        blocks: (0, $gF0bR._)(resp.blocks).sort(function(a, b) {
                                            return a.block.header.height - b.block.header.height;
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "blockSearchAll",
            value: // this should paginate through all blockSearch options to ensure it returns all results.
            // starts with page 1 or whatever was provided (eg. to start on page 7)
            //
            // NOTE
            // This method will error on any node that is running a Tendermint version lower than 0.34.9.
            function blockSearchAll(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var page, blocks, done, _blocks, resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page = params.page || 1;
                                blocks = [];
                                done = false;
                                _state.label = 1;
                            case 1:
                                if (!!done) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.blockSearch((0, $gddcW._)((0, $4JCw4._)({}, params), {
                                        page: page
                                    }))
                                ];
                            case 2:
                                resp = _state.sent();
                                (_blocks = blocks).push.apply(_blocks, (0, $gF0bR._)(resp.blocks));
                                if (blocks.length < resp.totalCount) page++;
                                else done = true;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                // make sure we sort by height, as tendermint may be sorting by string value of the height
                                // and the earlier items may be in a higher page than the later items
                                blocks.sort(function(a, b) {
                                    return a.block.header.height - b.block.header.height;
                                });
                                return [
                                    2,
                                    {
                                        totalCount: blocks.length,
                                        blocks: blocks
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "blockchain",
            value: /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ function blockchain(minHeight, maxHeight) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Blockchain,
                            params: {
                                minHeight: minHeight,
                                maxHeight: maxHeight
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBlockchain, _this.r.decodeBlockchain)
                        ];
                    });
                })();
            }
        },
        {
            key: "broadcastTxSync",
            value: /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ function broadcastTxSync(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $da7645848bf3e049$var$requests.Method.BroadcastTxSync
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBroadcastTx, _this.r.decodeBroadcastTxSync)
                        ];
                    });
                })();
            }
        },
        {
            key: "broadcastTxAsync",
            value: /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ function broadcastTxAsync(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $da7645848bf3e049$var$requests.Method.BroadcastTxAsync
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBroadcastTx, _this.r.decodeBroadcastTxAsync)
                        ];
                    });
                })();
            }
        },
        {
            key: "broadcastTxCommit",
            value: /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ function broadcastTxCommit(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $da7645848bf3e049$var$requests.Method.BroadcastTxCommit
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBroadcastTx, _this.r.decodeBroadcastTxCommit)
                        ];
                    });
                })();
            }
        },
        {
            key: "commit",
            value: function commit(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Commit,
                            params: {
                                height: height
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeCommit, _this.r.decodeCommit)
                        ];
                    });
                })();
            }
        },
        {
            key: "genesis",
            value: function genesis() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Genesis
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeGenesis, _this.r.decodeGenesis)
                        ];
                    });
                })();
            }
        },
        {
            key: "health",
            value: function health() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Health
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeHealth, _this.r.decodeHealth)
                        ];
                    });
                })();
            }
        },
        {
            key: "numUnconfirmedTxs",
            value: function numUnconfirmedTxs() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.NumUnconfirmedTxs
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeNumUnconfirmedTxs, _this.r.decodeNumUnconfirmedTxs)
                        ];
                    });
                })();
            }
        },
        {
            key: "status",
            value: function status() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Status
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeStatus, _this.r.decodeStatus)
                        ];
                    });
                })();
            }
        },
        {
            key: "subscribeNewBlock",
            value: function subscribeNewBlock() {
                var request = {
                    method: $da7645848bf3e049$var$requests.Method.Subscribe,
                    query: {
                        type: $da7645848bf3e049$var$requests.SubscriptionEventType.NewBlock
                    }
                };
                return this.subscribe(request, this.r.decodeNewBlockEvent);
            }
        },
        {
            key: "subscribeNewBlockHeader",
            value: function subscribeNewBlockHeader() {
                var request = {
                    method: $da7645848bf3e049$var$requests.Method.Subscribe,
                    query: {
                        type: $da7645848bf3e049$var$requests.SubscriptionEventType.NewBlockHeader
                    }
                };
                return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
            }
        },
        {
            key: "subscribeTx",
            value: function subscribeTx(query) {
                var request = {
                    method: $da7645848bf3e049$var$requests.Method.Subscribe,
                    query: {
                        type: $da7645848bf3e049$var$requests.SubscriptionEventType.Tx,
                        raw: query
                    }
                };
                return this.subscribe(request, this.r.decodeTxEvent);
            }
        },
        {
            key: "tx",
            value: /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ function tx(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $da7645848bf3e049$var$requests.Method.Tx
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeTx, _this.r.decodeTx)
                        ];
                    });
                })();
            }
        },
        {
            key: "txSearch",
            value: /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ function txSearch(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $da7645848bf3e049$var$requests.Method.TxSearch
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeTxSearch, _this.r.decodeTxSearch)
                        ];
                    });
                })();
            }
        },
        {
            key: "txSearchAll",
            value: // this should paginate through all txSearch options to ensure it returns all results.
            // starts with page 1 or whatever was provided (eg. to start on page 7)
            function txSearchAll(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var page, txs, done, _txs, resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page = params.page || 1;
                                txs = [];
                                done = false;
                                _state.label = 1;
                            case 1:
                                if (!!done) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.txSearch((0, $gddcW._)((0, $4JCw4._)({}, params), {
                                        page: page
                                    }))
                                ];
                            case 2:
                                resp = _state.sent();
                                (_txs = txs).push.apply(_txs, (0, $gF0bR._)(resp.txs));
                                if (txs.length < resp.totalCount) page++;
                                else done = true;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2,
                                    {
                                        totalCount: txs.length,
                                        txs: txs
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "validators",
            value: function validators(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $da7645848bf3e049$var$requests.Method.Validators,
                            params: params
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeValidators, _this.r.decodeValidators)
                        ];
                    });
                })();
            }
        },
        {
            key: "validatorsAll",
            value: function validatorsAll(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var validators, page, done, blockHeight, _validators, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                validators = [];
                                page = 1;
                                done = false;
                                blockHeight = height;
                                _state.label = 1;
                            case 1:
                                if (!!done) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.validators({
                                        per_page: 50,
                                        height: blockHeight,
                                        page: page
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_validators = validators).push.apply(_validators, (0, $gF0bR._)(response.validators));
                                blockHeight = blockHeight || response.blockHeight;
                                if (validators.length < response.total) page++;
                                else done = true;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2,
                                    {
                                        // NOTE: Default value is for type safety but this should always be set
                                        blockHeight: blockHeight !== null && blockHeight !== void 0 ? blockHeight : 0,
                                        count: validators.length,
                                        total: validators.length,
                                        validators: validators
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "doCall",
            value: // doCall is a helper to handle the encode/call/decode logic
            function doCall(request, encode, decode) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var req, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                req = encode(request);
                                return [
                                    4,
                                    _this.client.execute(req)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    decode(result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "subscribe",
            value: function subscribe(request, decode) {
                if (!(0, $1GCRg.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
                var req = this.p.encodeSubscribe(request);
                var eventStream = this.client.listen(req);
                return eventStream.map(function(event) {
                    return decode(event);
                });
            }
        }
    ], [
        {
            key: "connect",
            value: /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ function connect(endpoint) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var rpcClient, useHttp, _version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof endpoint === "object") rpcClient = new $1GCRg.HttpClient(endpoint);
                                else {
                                    useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
                                    rpcClient = useHttp ? new $1GCRg.HttpClient(endpoint) : new $1GCRg.WebsocketClient(endpoint);
                                }
                                return [
                                    4,
                                    _this.detectVersion(rpcClient)
                                ];
                            case 1:
                                _version = _state.sent();
                                return [
                                    2,
                                    Tendermint34Client.create(rpcClient)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: /**
     * Creates a new Tendermint client given an RPC client.
     */ function create(rpcClient) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new Tendermint34Client(rpcClient)
                        ];
                    });
                })();
            }
        },
        {
            key: "detectVersion",
            value: function detectVersion(client) {
                return (0, $6rBFC._)(function() {
                    var req, response, result, version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                req = (0, $5WHTi.createJsonRpcRequest)($da7645848bf3e049$var$requests.Method.Status);
                                return [
                                    4,
                                    client.execute(req)
                                ];
                            case 1:
                                response = _state.sent();
                                result = response.result;
                                if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
                                version = result.node_info.version;
                                if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
                                return [
                                    2,
                                    version
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Tendermint34Client;
}();
module.exports.Tendermint34Client = $da7645848bf3e049$var$Tendermint34Client;

});
parcelRegister("4JCw4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $37293dee53d8c93a$export$71511d61b312f219; });

var $a7gqy = parcelRequire("a7gqy");
function $37293dee53d8c93a$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $a7gqy._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("a7gqy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $01e691c1c6175a08$export$71511d61b312f219; });
function $01e691c1c6175a08$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("gddcW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcd81b09159582e1$export$71511d61b312f219; });
function $bcd81b09159582e1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bcd81b09159582e1$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $bcd81b09159582e1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("5WHTi", function(module, exports) {

var $4JCw4 = parcelRequire("4JCw4");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJsonRpcRequest = void 0;
var $45446a53563c341a$var$numbersWithoutZero = "123456789";
/** generates a random numeric character  */ function $45446a53563c341a$var$randomNumericChar() {
    return $45446a53563c341a$var$numbersWithoutZero[Math.floor(Math.random() * $45446a53563c341a$var$numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */ function $45446a53563c341a$var$randomId() {
    return parseInt(Array.from({
        length: 12
    }).map(function() {
        return $45446a53563c341a$var$randomNumericChar();
    }).join(""), 10);
}
/** Creates a JSON-RPC request with random ID */ // eslint-disable-next-line @typescript-eslint/ban-types
function $45446a53563c341a$var$createJsonRpcRequest(method, params) {
    var paramsCopy = params ? (0, $4JCw4._)({}, params) : {};
    return {
        jsonrpc: "2.0",
        id: $45446a53563c341a$var$randomId(),
        method: method,
        params: paramsCopy
    };
}
module.exports.createJsonRpcRequest = $45446a53563c341a$var$createJsonRpcRequest;

});

parcelRegister("1GCRg", function(module, exports) {
"use strict";
// This folder contains Tendermint-specific RPC clients
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = module.exports.instanceOfRpcStreamingClient = module.exports.HttpClient = module.exports.HttpBatchClient = void 0;

var $3XWrI = parcelRequire("3XWrI");
Object.defineProperty(module.exports, "HttpBatchClient", {
    enumerable: true,
    get: function get() {
        return $3XWrI.HttpBatchClient;
    }
});

var $4ZhaX = parcelRequire("4ZhaX");
Object.defineProperty(module.exports, "HttpClient", {
    enumerable: true,
    get: function get() {
        return $4ZhaX.HttpClient;
    }
});

var $gfCZp = parcelRequire("gfCZp");
Object.defineProperty(module.exports, "instanceOfRpcStreamingClient", {
    enumerable: true,
    get: function get() {
        return $gfCZp.instanceOfRpcStreamingClient;
    }
});

var $eqzvm = parcelRequire("eqzvm");
Object.defineProperty(module.exports, "WebsocketClient", {
    enumerable: true,
    get: function get() {
        return $eqzvm.WebsocketClient;
    }
});

});
parcelRegister("3XWrI", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpBatchClient = void 0;

var $j8Lpw = parcelRequire("j8Lpw");

var $fcHu6 = parcelRequire("fcHu6");

var $gfCZp = parcelRequire("gfCZp");
// Those values are private and can change any time.
// Does a user need to know them? I don't think so. You either set
// a custom value or leave the option field unset.
var $2e3437f9441d7700$var$defaultHttpBatchClientOptions = {
    dispatchInterval: 20,
    batchSizeLimit: 20
};
var $2e3437f9441d7700$var$HttpBatchClient = /*#__PURE__*/ function() {
    function HttpBatchClient(endpoint) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _this = this;
        (0, $7dKN1._)(this, HttpBatchClient);
        this.queue = [];
        var _options_batchSizeLimit, _options_dispatchInterval;
        this.options = {
            batchSizeLimit: (_options_batchSizeLimit = options.batchSizeLimit) !== null && _options_batchSizeLimit !== void 0 ? _options_batchSizeLimit : $2e3437f9441d7700$var$defaultHttpBatchClientOptions.batchSizeLimit,
            dispatchInterval: (_options_dispatchInterval = options.dispatchInterval) !== null && _options_dispatchInterval !== void 0 ? _options_dispatchInterval : $2e3437f9441d7700$var$defaultHttpBatchClientOptions.dispatchInterval
        };
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $gfCZp.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
        this.timer = setInterval(function() {
            return _this.tick();
        }, options.dispatchInterval);
        this.validate();
    }
    (0, $eW5pA._)(HttpBatchClient, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.timer && clearInterval(this.timer);
                this.timer = undefined;
            }
        },
        {
            key: "execute",
            value: function execute(request) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                _this.queue.push({
                                    request: request,
                                    resolve: resolve,
                                    reject: reject
                                });
                                if (_this.queue.length >= _this.options.batchSizeLimit) // this train is full, let's go
                                _this.tick();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1) throw new Error("batchSizeLimit must be a safe integer >= 1");
            }
        },
        {
            /**
     * This is called in an interval where promise rejections cannot be handled.
     * So this is not async and HTTP errors need to be handled by the queued promises.
     */ key: "tick",
            value: function tick() {
                // Avoid race conditions
                var batch = this.queue.splice(0, this.options.batchSizeLimit);
                if (!batch.length) return;
                var requests = batch.map(function(s) {
                    return s.request;
                });
                var requestIds = requests.map(function(request) {
                    return request.id;
                });
                (0, $fcHu6.http)("POST", this.url, this.headers, requests).then(function(raw) {
                    // Requests with a single entry return as an object
                    var arr = Array.isArray(raw) ? raw : [
                        raw
                    ];
                    arr.forEach(function(el) {
                        var req = batch.find(function(s) {
                            return s.request.id === el.id;
                        });
                        if (!req) return;
                        var reject = req.reject, resolve = req.resolve;
                        var response = (0, $j8Lpw.parseJsonRpcResponse)(el);
                        if ((0, $j8Lpw.isJsonRpcErrorResponse)(response)) reject(new Error(JSON.stringify(response.error)));
                        else resolve(response);
                    });
                }, function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var requestId = _step.value;
                            var req = batch.find(function(s) {
                                return s.request.id === requestId;
                            });
                            if (!req) return {
                                v: void void 0
                            };
                            req.reject(error);
                        };
                        for(var _iterator = requestIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _ret = _loop();
                            if ((0, $aVMuR._)(_ret) === "object") return _ret.v;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        }
    ]);
    return HttpBatchClient;
}();
module.exports.HttpBatchClient = $2e3437f9441d7700$var$HttpBatchClient;

});
parcelRegister("j8Lpw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = module.exports.parseJsonRpcErrorResponse = module.exports.JsonRpcClient = module.exports.makeJsonRpcId = void 0;

var $km8xq = parcelRequire("km8xq");
Object.defineProperty(module.exports, "makeJsonRpcId", {
    enumerable: true,
    get: function get() {
        return $km8xq.makeJsonRpcId;
    }
});

var $34JEg = parcelRequire("34JEg");
Object.defineProperty(module.exports, "JsonRpcClient", {
    enumerable: true,
    get: function get() {
        return $34JEg.JsonRpcClient;
    }
});

var $iZxqB = parcelRequire("iZxqB");
Object.defineProperty(module.exports, "parseJsonRpcErrorResponse", {
    enumerable: true,
    get: function get() {
        return $iZxqB.parseJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcId", {
    enumerable: true,
    get: function get() {
        return $iZxqB.parseJsonRpcId;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcRequest", {
    enumerable: true,
    get: function get() {
        return $iZxqB.parseJsonRpcRequest;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcResponse", {
    enumerable: true,
    get: function get() {
        return $iZxqB.parseJsonRpcResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcSuccessResponse", {
    enumerable: true,
    get: function get() {
        return $iZxqB.parseJsonRpcSuccessResponse;
    }
});

var $755i0 = parcelRequire("755i0");
Object.defineProperty(module.exports, "isJsonRpcErrorResponse", {
    enumerable: true,
    get: function get() {
        return $755i0.isJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "isJsonRpcSuccessResponse", {
    enumerable: true,
    get: function get() {
        return $755i0.isJsonRpcSuccessResponse;
    }
});
Object.defineProperty(module.exports, "jsonRpcCode", {
    enumerable: true,
    get: function get() {
        return $755i0.jsonRpcCode;
    }
});

});
parcelRegister("km8xq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
var $ed1c7c369629f656$var$counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */ function $ed1c7c369629f656$var$makeJsonRpcId() {
    return $ed1c7c369629f656$var$counter += 1;
}
module.exports.makeJsonRpcId = $ed1c7c369629f656$var$makeJsonRpcId;

});

parcelRegister("34JEg", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcClient = void 0;

var $lB6jI = parcelRequire("lB6jI");

var $755i0 = parcelRequire("755i0");
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */ var $23d527ab51da938d$var$JsonRpcClient = /*#__PURE__*/ function() {
    function JsonRpcClient(connection) {
        (0, $7dKN1._)(this, JsonRpcClient);
        this.connection = connection;
    }
    (0, $eW5pA._)(JsonRpcClient, [
        {
            key: "run",
            value: function run(request) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var filteredStream, pendingResponses, response, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                filteredStream = _this.connection.responseStream.filter(function(r) {
                                    return r.id === request.id;
                                });
                                pendingResponses = (0, $lB6jI.firstEvent)(filteredStream);
                                _this.connection.sendRequest(request);
                                return [
                                    4,
                                    pendingResponses
                                ];
                            case 1:
                                response = _state.sent();
                                if ((0, $755i0.isJsonRpcErrorResponse)(response)) {
                                    error = response.error;
                                    throw new Error("JSON RPC error: code=".concat(error.code, "; message='").concat(error.message, "'"));
                                }
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return JsonRpcClient;
}();
module.exports.JsonRpcClient = $23d527ab51da938d$var$JsonRpcClient;

});
parcelRegister("lB6jI", function(module, exports) {
"use strict";
var $fb91f41a86bd52d4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb91f41a86bd52d4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb91f41a86bd52d4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = module.exports.toListPromise = module.exports.fromListPromise = module.exports.firstEvent = module.exports.dropDuplicates = module.exports.DefaultValueProducer = module.exports.concat = void 0;

var $bIe6J = parcelRequire("bIe6J");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function get() {
        return $bIe6J.concat;
    }
});

var $dKcsF = parcelRequire("dKcsF");
Object.defineProperty(module.exports, "DefaultValueProducer", {
    enumerable: true,
    get: function get() {
        return $dKcsF.DefaultValueProducer;
    }
});

var $59vjz = parcelRequire("59vjz");
Object.defineProperty(module.exports, "dropDuplicates", {
    enumerable: true,
    get: function get() {
        return $59vjz.dropDuplicates;
    }
});

var $9LXrQ = parcelRequire("9LXrQ");
Object.defineProperty(module.exports, "firstEvent", {
    enumerable: true,
    get: function get() {
        return $9LXrQ.firstEvent;
    }
});
Object.defineProperty(module.exports, "fromListPromise", {
    enumerable: true,
    get: function get() {
        return $9LXrQ.fromListPromise;
    }
});
Object.defineProperty(module.exports, "toListPromise", {
    enumerable: true,
    get: function get() {
        return $9LXrQ.toListPromise;
    }
});

$fb91f41a86bd52d4$var$__exportStar((parcelRequire("55he3")), module.exports);

var $7OQnl = parcelRequire("7OQnl");
Object.defineProperty(module.exports, "ValueAndUpdates", {
    enumerable: true,
    get: function get() {
        return $7OQnl.ValueAndUpdates;
    }
});

});
parcelRegister("bIe6J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $7Tj2d = parcelRequire("7Tj2d");
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */ function $886ebf432a48e726$var$concat() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++){
        streams[_key] = arguments[_key];
    }
    var subscriptions = new Array();
    var queues = new Array(); // one queue per stream
    var completedStreams = new Set();
    var activeStreamIndex = 0;
    function reset() {
        while(subscriptions.length > 0){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    var producer = {
        start: function(listener) {
            streams.forEach(function(_) {
                return queues.push([]);
            });
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while(true){
                    var element = queues[streamIndex].shift();
                    if (element === undefined) return;
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach(function(stream, index) {
                subscriptions.push(stream.subscribe({
                    next: function(value) {
                        if (index === activeStreamIndex) listener.next(value);
                        else queues[index].push(value);
                    },
                    complete: function() {
                        completedStreams.add(index);
                        while(completedStreams.has(activeStreamIndex)){
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) listener.complete();
                        else // now active stream can have some events queued but did not yet complete
                        emitAllQueuesEvents(activeStreamIndex);
                    },
                    error: function(error) {
                        listener.error(error);
                        reset();
                    }
                }));
            });
        },
        stop: function() {
            reset();
        }
    };
    return $7Tj2d.Stream.create(producer);
}
module.exports.concat = $886ebf432a48e726$var$concat;

});
parcelRegister("7Tj2d", function(module, exports) {
"use strict";
var $5bec6f56e3f47681$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NO_IL = module.exports.NO = module.exports.MemoryStream = module.exports.Stream = void 0;

var $jBNLL = parcelRequire("jBNLL");

var $aQAiV = parcelRequire("aQAiV");
var $5bec6f56e3f47681$var$$$observable = $jBNLL.default($aQAiV.getPolyfill());
var $5bec6f56e3f47681$var$NO = {};
module.exports.NO = $5bec6f56e3f47681$var$NO;
function $5bec6f56e3f47681$var$noop() {}
function $5bec6f56e3f47681$var$cp(a) {
    var l = a.length;
    var b = Array(l);
    for(var i = 0; i < l; ++i)b[i] = a[i];
    return b;
}
function $5bec6f56e3f47681$var$and(f1, f2) {
    return function andFn(t) {
        return f1(t) && f2(t);
    };
}
function $5bec6f56e3f47681$var$_try(c, t, u) {
    try {
        return c.f(t);
    } catch (e) {
        u._e(e);
        return $5bec6f56e3f47681$var$NO;
    }
}
var $5bec6f56e3f47681$var$NO_IL = {
    _n: $5bec6f56e3f47681$var$noop,
    _e: $5bec6f56e3f47681$var$noop,
    _c: $5bec6f56e3f47681$var$noop
};
module.exports.NO_IL = $5bec6f56e3f47681$var$NO_IL;
// mutates the input
function $5bec6f56e3f47681$var$internalizeProducer(producer) {
    producer._start = function _start(il) {
        il.next = il._n;
        il.error = il._e;
        il.complete = il._c;
        this.start(il);
    };
    producer._stop = producer.stop;
}
var $5bec6f56e3f47681$var$StreamSub = /** @class */ function() {
    function StreamSub(_stream, _listener) {
        this._stream = _stream;
        this._listener = _listener;
    }
    StreamSub.prototype.unsubscribe = function() {
        this._stream._remove(this._listener);
    };
    return StreamSub;
}();
var $5bec6f56e3f47681$var$Observer = /** @class */ function() {
    function Observer(_listener) {
        this._listener = _listener;
    }
    Observer.prototype.next = function(value) {
        this._listener._n(value);
    };
    Observer.prototype.error = function(err) {
        this._listener._e(err);
    };
    Observer.prototype.complete = function() {
        this._listener._c();
    };
    return Observer;
}();
var $5bec6f56e3f47681$var$FromObservable = /** @class */ function() {
    function FromObservable(observable) {
        this.type = "fromObservable";
        this.ins = observable;
        this.active = false;
    }
    FromObservable.prototype._start = function(out) {
        this.out = out;
        this.active = true;
        this._sub = this.ins.subscribe(new $5bec6f56e3f47681$var$Observer(out));
        if (!this.active) this._sub.unsubscribe();
    };
    FromObservable.prototype._stop = function() {
        if (this._sub) this._sub.unsubscribe();
        this.active = false;
    };
    return FromObservable;
}();
var $5bec6f56e3f47681$var$Merge = /** @class */ function() {
    function Merge(insArr) {
        this.type = "merge";
        this.insArr = insArr;
        this.out = $5bec6f56e3f47681$var$NO;
        this.ac = 0;
    }
    Merge.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var L = s.length;
        this.ac = L;
        for(var i = 0; i < L; i++)s[i]._add(this);
    };
    Merge.prototype._stop = function() {
        var s = this.insArr;
        var L = s.length;
        for(var i = 0; i < L; i++)s[i]._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    Merge.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._n(t);
    };
    Merge.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Merge.prototype._c = function() {
        if (--this.ac <= 0) {
            var u = this.out;
            if (u === $5bec6f56e3f47681$var$NO) return;
            u._c();
        }
    };
    return Merge;
}();
var $5bec6f56e3f47681$var$CombineListener = /** @class */ function() {
    function CombineListener(i, out, p) {
        this.i = i;
        this.out = out;
        this.p = p;
        p.ils.push(this);
    }
    CombineListener.prototype._n = function(t) {
        var p = this.p, out = this.out;
        if (out === $5bec6f56e3f47681$var$NO) return;
        if (p.up(t, this.i)) {
            var b = $5bec6f56e3f47681$var$cp(p.vals);
            out._n(b);
        }
    };
    CombineListener.prototype._e = function(err) {
        var out = this.out;
        if (out === $5bec6f56e3f47681$var$NO) return;
        out._e(err);
    };
    CombineListener.prototype._c = function() {
        var p = this.p;
        if (p.out === $5bec6f56e3f47681$var$NO) return;
        if (--p.Nc === 0) p.out._c();
    };
    return CombineListener;
}();
var $5bec6f56e3f47681$var$Combine = /** @class */ function() {
    function Combine(insArr) {
        this.type = "combine";
        this.insArr = insArr;
        this.out = $5bec6f56e3f47681$var$NO;
        this.ils = [];
        this.Nc = this.Nn = 0;
        this.vals = [];
    }
    Combine.prototype.up = function(t, i) {
        var v = this.vals[i];
        var Nn = !this.Nn ? 0 : v === $5bec6f56e3f47681$var$NO ? --this.Nn : this.Nn;
        this.vals[i] = t;
        return Nn === 0;
    };
    Combine.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var n = this.Nc = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        if (n === 0) {
            out._n([]);
            out._c();
        } else for(var i = 0; i < n; i++){
            vals[i] = $5bec6f56e3f47681$var$NO;
            s[i]._add(new $5bec6f56e3f47681$var$CombineListener(i, out, this));
        }
    };
    Combine.prototype._stop = function() {
        var s = this.insArr;
        var n = s.length;
        var ils = this.ils;
        for(var i = 0; i < n; i++)s[i]._remove(ils[i]);
        this.out = $5bec6f56e3f47681$var$NO;
        this.ils = [];
        this.vals = [];
    };
    return Combine;
}();
var $5bec6f56e3f47681$var$FromArray = /** @class */ function() {
    function FromArray(a) {
        this.type = "fromArray";
        this.a = a;
    }
    FromArray.prototype._start = function(out) {
        var a = this.a;
        for(var i = 0, n = a.length; i < n; i++)out._n(a[i]);
        out._c();
    };
    FromArray.prototype._stop = function() {};
    return FromArray;
}();
var $5bec6f56e3f47681$var$FromPromise = /** @class */ function() {
    function FromPromise(p) {
        this.type = "fromPromise";
        this.on = false;
        this.p = p;
    }
    FromPromise.prototype._start = function(out) {
        var prod = this;
        this.on = true;
        this.p.then(function(v) {
            if (prod.on) {
                out._n(v);
                out._c();
            }
        }, function(e) {
            out._e(e);
        }).then($5bec6f56e3f47681$var$noop, function(err) {
            setTimeout(function() {
                throw err;
            });
        });
    };
    FromPromise.prototype._stop = function() {
        this.on = false;
    };
    return FromPromise;
}();
var $5bec6f56e3f47681$var$Periodic = /** @class */ function() {
    function Periodic(period) {
        this.type = "periodic";
        this.period = period;
        this.intervalID = -1;
        this.i = 0;
    }
    Periodic.prototype._start = function(out) {
        var self = this;
        function intervalHandler() {
            out._n(self.i++);
        }
        this.intervalID = setInterval(intervalHandler, this.period);
    };
    Periodic.prototype._stop = function() {
        if (this.intervalID !== -1) clearInterval(this.intervalID);
        this.intervalID = -1;
        this.i = 0;
    };
    return Periodic;
}();
var $5bec6f56e3f47681$var$Debug = /** @class */ function() {
    function Debug(ins, arg) {
        this.type = "debug";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.s = $5bec6f56e3f47681$var$noop;
        this.l = "";
        if (typeof arg === "string") this.l = arg;
        else if (typeof arg === "function") this.s = arg;
    }
    Debug.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Debug.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    Debug.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        var s = this.s, l = this.l;
        if (s !== $5bec6f56e3f47681$var$noop) try {
            s(t);
        } catch (e) {
            u._e(e);
        }
        else if (l) console.log(l + ":", t);
        else console.log(t);
        u._n(t);
    };
    Debug.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Debug.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return Debug;
}();
var $5bec6f56e3f47681$var$Drop = /** @class */ function() {
    function Drop(max, ins) {
        this.type = "drop";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.max = max;
        this.dropped = 0;
    }
    Drop.prototype._start = function(out) {
        this.out = out;
        this.dropped = 0;
        this.ins._add(this);
    };
    Drop.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    Drop.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        if (this.dropped++ >= this.max) u._n(t);
    };
    Drop.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Drop.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return Drop;
}();
var $5bec6f56e3f47681$var$EndWhenListener = /** @class */ function() {
    function EndWhenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    EndWhenListener.prototype._n = function() {
        this.op.end();
    };
    EndWhenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    EndWhenListener.prototype._c = function() {
        this.op.end();
    };
    return EndWhenListener;
}();
var $5bec6f56e3f47681$var$EndWhen = /** @class */ function() {
    function EndWhen(o, ins) {
        this.type = "endWhen";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.o = o;
        this.oil = $5bec6f56e3f47681$var$NO_IL;
    }
    EndWhen.prototype._start = function(out) {
        this.out = out;
        this.o._add(this.oil = new $5bec6f56e3f47681$var$EndWhenListener(out, this));
        this.ins._add(this);
    };
    EndWhen.prototype._stop = function() {
        this.ins._remove(this);
        this.o._remove(this.oil);
        this.out = $5bec6f56e3f47681$var$NO;
        this.oil = $5bec6f56e3f47681$var$NO_IL;
    };
    EndWhen.prototype.end = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    EndWhen.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._n(t);
    };
    EndWhen.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    EndWhen.prototype._c = function() {
        this.end();
    };
    return EndWhen;
}();
var $5bec6f56e3f47681$var$Filter = /** @class */ function() {
    function Filter(passes, ins) {
        this.type = "filter";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.f = passes;
    }
    Filter.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Filter.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    Filter.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        var r = $5bec6f56e3f47681$var$_try(this, t, u);
        if (r === $5bec6f56e3f47681$var$NO || !r) return;
        u._n(t);
    };
    Filter.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Filter.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return Filter;
}();
var $5bec6f56e3f47681$var$FlattenListener = /** @class */ function() {
    function FlattenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    FlattenListener.prototype._n = function(t) {
        this.out._n(t);
    };
    FlattenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    FlattenListener.prototype._c = function() {
        this.op.inner = $5bec6f56e3f47681$var$NO;
        this.op.less();
    };
    return FlattenListener;
}();
var $5bec6f56e3f47681$var$Flatten = /** @class */ function() {
    function Flatten(ins) {
        this.type = "flatten";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.open = true;
        this.inner = $5bec6f56e3f47681$var$NO;
        this.il = $5bec6f56e3f47681$var$NO_IL;
    }
    Flatten.prototype._start = function(out) {
        this.out = out;
        this.open = true;
        this.inner = $5bec6f56e3f47681$var$NO;
        this.il = $5bec6f56e3f47681$var$NO_IL;
        this.ins._add(this);
    };
    Flatten.prototype._stop = function() {
        this.ins._remove(this);
        if (this.inner !== $5bec6f56e3f47681$var$NO) this.inner._remove(this.il);
        this.out = $5bec6f56e3f47681$var$NO;
        this.open = true;
        this.inner = $5bec6f56e3f47681$var$NO;
        this.il = $5bec6f56e3f47681$var$NO_IL;
    };
    Flatten.prototype.less = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        if (!this.open && this.inner === $5bec6f56e3f47681$var$NO) u._c();
    };
    Flatten.prototype._n = function(s) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        var _a = this, inner = _a.inner, il = _a.il;
        if (inner !== $5bec6f56e3f47681$var$NO && il !== $5bec6f56e3f47681$var$NO_IL) inner._remove(il);
        (this.inner = s)._add(this.il = new $5bec6f56e3f47681$var$FlattenListener(u, this));
    };
    Flatten.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Flatten.prototype._c = function() {
        this.open = false;
        this.less();
    };
    return Flatten;
}();
var $5bec6f56e3f47681$var$Fold = /** @class */ function() {
    function Fold(f, seed, ins) {
        var _this = this;
        this.type = "fold";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.f = function(t) {
            return f(_this.acc, t);
        };
        this.acc = this.seed = seed;
    }
    Fold.prototype._start = function(out) {
        this.out = out;
        this.acc = this.seed;
        out._n(this.acc);
        this.ins._add(this);
    };
    Fold.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
        this.acc = this.seed;
    };
    Fold.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        var r = $5bec6f56e3f47681$var$_try(this, t, u);
        if (r === $5bec6f56e3f47681$var$NO) return;
        u._n(this.acc = r);
    };
    Fold.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Fold.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return Fold;
}();
var $5bec6f56e3f47681$var$Last = /** @class */ function() {
    function Last(ins) {
        this.type = "last";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.has = false;
        this.val = $5bec6f56e3f47681$var$NO;
    }
    Last.prototype._start = function(out) {
        this.out = out;
        this.has = false;
        this.ins._add(this);
    };
    Last.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
        this.val = $5bec6f56e3f47681$var$NO;
    };
    Last.prototype._n = function(t) {
        this.has = true;
        this.val = t;
    };
    Last.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Last.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        if (this.has) {
            u._n(this.val);
            u._c();
        } else u._e(new Error("last() failed because input stream completed"));
    };
    return Last;
}();
var $5bec6f56e3f47681$var$MapOp = /** @class */ function() {
    function MapOp(project, ins) {
        this.type = "map";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.f = project;
    }
    MapOp.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    MapOp.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    MapOp.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        var r = $5bec6f56e3f47681$var$_try(this, t, u);
        if (r === $5bec6f56e3f47681$var$NO) return;
        u._n(r);
    };
    MapOp.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    MapOp.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return MapOp;
}();
var $5bec6f56e3f47681$var$Remember = /** @class */ function() {
    function Remember(ins) {
        this.type = "remember";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
    }
    Remember.prototype._start = function(out) {
        this.out = out;
        this.ins._add(out);
    };
    Remember.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    return Remember;
}();
var $5bec6f56e3f47681$var$ReplaceError = /** @class */ function() {
    function ReplaceError(replacer, ins) {
        this.type = "replaceError";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.f = replacer;
    }
    ReplaceError.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    ReplaceError.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    ReplaceError.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._n(t);
    };
    ReplaceError.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        try {
            this.ins._remove(this);
            (this.ins = this.f(err))._add(this);
        } catch (e) {
            u._e(e);
        }
    };
    ReplaceError.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return ReplaceError;
}();
var $5bec6f56e3f47681$var$StartWith = /** @class */ function() {
    function StartWith(ins, val) {
        this.type = "startWith";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.val = val;
    }
    StartWith.prototype._start = function(out) {
        this.out = out;
        this.out._n(this.val);
        this.ins._add(out);
    };
    StartWith.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    return StartWith;
}();
var $5bec6f56e3f47681$var$Take = /** @class */ function() {
    function Take(max, ins) {
        this.type = "take";
        this.ins = ins;
        this.out = $5bec6f56e3f47681$var$NO;
        this.max = max;
        this.taken = 0;
    }
    Take.prototype._start = function(out) {
        this.out = out;
        this.taken = 0;
        if (this.max <= 0) out._c();
        else this.ins._add(this);
    };
    Take.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $5bec6f56e3f47681$var$NO;
    };
    Take.prototype._n = function(t) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        var m = ++this.taken;
        if (m < this.max) u._n(t);
        else if (m === this.max) {
            u._n(t);
            u._c();
        }
    };
    Take.prototype._e = function(err) {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._e(err);
    };
    Take.prototype._c = function() {
        var u = this.out;
        if (u === $5bec6f56e3f47681$var$NO) return;
        u._c();
    };
    return Take;
}();
var $5bec6f56e3f47681$var$Stream = /** @class */ function() {
    function Stream(producer) {
        this._prod = producer || $5bec6f56e3f47681$var$NO;
        this._ils = [];
        this._stopID = $5bec6f56e3f47681$var$NO;
        this._dl = $5bec6f56e3f47681$var$NO;
        this._d = false;
        this._target = null;
        this._err = $5bec6f56e3f47681$var$NO;
    }
    Stream.prototype._n = function(t) {
        var a = this._ils;
        var L = a.length;
        if (this._d) this._dl._n(t);
        if (L == 1) a[0]._n(t);
        else if (L == 0) return;
        else {
            var b = $5bec6f56e3f47681$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._n(t);
        }
    };
    Stream.prototype._e = function(err) {
        if (this._err !== $5bec6f56e3f47681$var$NO) return;
        this._err = err;
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._e(err);
        if (L == 1) a[0]._e(err);
        else if (L == 0) return;
        else {
            var b = $5bec6f56e3f47681$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._e(err);
        }
        if (!this._d && L == 0) throw this._err;
    };
    Stream.prototype._c = function() {
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._c();
        if (L == 1) a[0]._c();
        else if (L == 0) return;
        else {
            var b = $5bec6f56e3f47681$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._c();
        }
    };
    Stream.prototype._x = function() {
        if (this._ils.length === 0) return;
        if (this._prod !== $5bec6f56e3f47681$var$NO) this._prod._stop();
        this._err = $5bec6f56e3f47681$var$NO;
        this._ils = [];
    };
    Stream.prototype._stopNow = function() {
        // WARNING: code that calls this method should
        // first check if this._prod is valid (not `NO`)
        this._prod._stop();
        this._err = $5bec6f56e3f47681$var$NO;
        this._stopID = $5bec6f56e3f47681$var$NO;
    };
    Stream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) return;
        if (this._stopID !== $5bec6f56e3f47681$var$NO) {
            clearTimeout(this._stopID);
            this._stopID = $5bec6f56e3f47681$var$NO;
        } else {
            var p = this._prod;
            if (p !== $5bec6f56e3f47681$var$NO) p._start(this);
        }
    };
    Stream.prototype._remove = function(il) {
        var _this = this;
        var ta = this._target;
        if (ta) return ta._remove(il);
        var a = this._ils;
        var i = a.indexOf(il);
        if (i > -1) {
            a.splice(i, 1);
            if (this._prod !== $5bec6f56e3f47681$var$NO && a.length <= 0) {
                this._err = $5bec6f56e3f47681$var$NO;
                this._stopID = setTimeout(function() {
                    return _this._stopNow();
                });
            } else if (a.length === 1) this._pruneCycles();
        }
    };
    // If all paths stemming from `this` stream eventually end at `this`
    // stream, then we remove the single listener of `this` stream, to
    // force it to end its execution and dispose resources. This method
    // assumes as a precondition that this._ils has just one listener.
    Stream.prototype._pruneCycles = function() {
        if (this._hasNoSinks(this, [])) this._remove(this._ils[0]);
    };
    // Checks whether *there is no* path starting from `x` that leads to an end
    // listener (sink) in the stream graph, following edges A->B where B is a
    // listener of A. This means these paths constitute a cycle somehow. Is given
    // a trace of all visited nodes so far.
    Stream.prototype._hasNoSinks = function(x, trace) {
        if (trace.indexOf(x) !== -1) return true;
        else if (x.out === this) return true;
        else if (x.out && x.out !== $5bec6f56e3f47681$var$NO) return this._hasNoSinks(x.out, trace.concat(x));
        else if (x._ils) {
            for(var i = 0, N = x._ils.length; i < N; i++)if (!this._hasNoSinks(x._ils[i], trace.concat(x))) return false;
            return true;
        } else return false;
    };
    Stream.prototype.ctor = function() {
        return this instanceof $5bec6f56e3f47681$var$MemoryStream ? $5bec6f56e3f47681$var$MemoryStream : Stream;
    };
    /**
     * Adds a Listener to the Stream.
     *
     * @param {Listener} listener
     */ Stream.prototype.addListener = function(listener) {
        listener._n = listener.next || $5bec6f56e3f47681$var$noop;
        listener._e = listener.error || $5bec6f56e3f47681$var$noop;
        listener._c = listener.complete || $5bec6f56e3f47681$var$noop;
        this._add(listener);
    };
    /**
     * Removes a Listener from the Stream, assuming the Listener was added to it.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.removeListener = function(listener) {
        this._remove(listener);
    };
    /**
     * Adds a Listener to the Stream returning a Subscription to remove that
     * listener.
     *
     * @param {Listener} listener
     * @returns {Subscription}
     */ Stream.prototype.subscribe = function(listener) {
        this.addListener(listener);
        return new $5bec6f56e3f47681$var$StreamSub(this, listener);
    };
    /**
     * Add interop between most.js and RxJS 5
     *
     * @returns {Stream}
     */ Stream.prototype[$5bec6f56e3f47681$var$$$observable] = function() {
        return this;
    };
    /**
     * Creates a new Stream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {Stream}
     */ Stream.create = function(producer) {
        if (producer) {
            if (typeof producer.start !== "function" || typeof producer.stop !== "function") throw new Error("producer requires both start and stop functions");
            $5bec6f56e3f47681$var$internalizeProducer(producer); // mutates the input
        }
        return new Stream(producer);
    };
    /**
     * Creates a new MemoryStream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {MemoryStream}
     */ Stream.createWithMemory = function(producer) {
        if (producer) $5bec6f56e3f47681$var$internalizeProducer(producer); // mutates the input
        return new $5bec6f56e3f47681$var$MemoryStream(producer);
    };
    /**
     * Creates a Stream that does nothing when started. It never emits any event.
     *
     * Marble diagram:
     *
     * ```text
     *          never
     * -----------------------
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.never = function() {
        return new Stream({
            _start: $5bec6f56e3f47681$var$noop,
            _stop: $5bec6f56e3f47681$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits the "complete" notification when
     * started, and that's it.
     *
     * Marble diagram:
     *
     * ```text
     * empty
     * -|
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.empty = function() {
        return new Stream({
            _start: function _start(il) {
                il._c();
            },
            _stop: $5bec6f56e3f47681$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits an "error" notification with the
     * value you passed as the `error` argument when the stream starts, and that's
     * it.
     *
     * Marble diagram:
     *
     * ```text
     * throw(X)
     * -X
     * ```
     *
     * @factory true
     * @param error The error event to emit on the created stream.
     * @return {Stream}
     */ Stream.throw = function(error) {
        return new Stream({
            _start: function _start(il) {
                il._e(error);
            },
            _stop: $5bec6f56e3f47681$var$noop
        });
    };
    /**
     * Creates a stream from an Array, Promise, or an Observable.
     *
     * @factory true
     * @param {Array|PromiseLike|Observable} input The input to make a stream from.
     * @return {Stream}
     */ Stream.from = function(input) {
        if (typeof input[$5bec6f56e3f47681$var$$$observable] === "function") return Stream.fromObservable(input);
        else if (typeof input.then === "function") return Stream.fromPromise(input);
        else if (Array.isArray(input)) return Stream.fromArray(input);
        throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    };
    /**
     * Creates a Stream that immediately emits the arguments that you give to
     * *of*, then completes.
     *
     * Marble diagram:
     *
     * ```text
     * of(1,2,3)
     * 123|
     * ```
     *
     * @factory true
     * @param a The first value you want to emit as an event on the stream.
     * @param b The second value you want to emit as an event on the stream. One
     * or more of these values may be given as arguments.
     * @return {Stream}
     */ Stream.of = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        return Stream.fromArray(items);
    };
    /**
     * Converts an array to a stream. The returned stream will emit synchronously
     * all the items in the array, and then complete.
     *
     * Marble diagram:
     *
     * ```text
     * fromArray([1,2,3])
     * 123|
     * ```
     *
     * @factory true
     * @param {Array} array The array to be converted as a stream.
     * @return {Stream}
     */ Stream.fromArray = function(array) {
        return new Stream(new $5bec6f56e3f47681$var$FromArray(array));
    };
    /**
     * Converts a promise to a stream. The returned stream will emit the resolved
     * value of the promise, and then complete. However, if the promise is
     * rejected, the stream will emit the corresponding error.
     *
     * Marble diagram:
     *
     * ```text
     * fromPromise( ----42 )
     * -----------------42|
     * ```
     *
     * @factory true
     * @param {PromiseLike} promise The promise to be converted as a stream.
     * @return {Stream}
     */ Stream.fromPromise = function(promise) {
        return new Stream(new $5bec6f56e3f47681$var$FromPromise(promise));
    };
    /**
     * Converts an Observable into a Stream.
     *
     * @factory true
     * @param {any} observable The observable to be converted as a stream.
     * @return {Stream}
     */ Stream.fromObservable = function(obs) {
        if (obs.endWhen !== undefined) return obs;
        var o = typeof obs[$5bec6f56e3f47681$var$$$observable] === "function" ? obs[$5bec6f56e3f47681$var$$$observable]() : obs;
        return new Stream(new $5bec6f56e3f47681$var$FromObservable(o));
    };
    /**
     * Creates a stream that periodically emits incremental numbers, every
     * `period` milliseconds.
     *
     * Marble diagram:
     *
     * ```text
     *     periodic(1000)
     * ---0---1---2---3---4---...
     * ```
     *
     * @factory true
     * @param {number} period The interval in milliseconds to use as a rate of
     * emission.
     * @return {Stream}
     */ Stream.periodic = function(period) {
        return new Stream(new $5bec6f56e3f47681$var$Periodic(period));
    };
    Stream.prototype._map = function(project) {
        return new (this.ctor())(new $5bec6f56e3f47681$var$MapOp(project, this));
    };
    /**
     * Transforms each event from the input Stream through a `project` function,
     * to get a Stream that emits those transformed events.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7------
     *    map(i => i * 10)
     * --10--30-50----70-----
     * ```
     *
     * @param {Function} project A function of type `(t: T) => U` that takes event
     * `t` of type `T` from the input Stream and produces an event of type `U`, to
     * be emitted on the output Stream.
     * @return {Stream}
     */ Stream.prototype.map = function(project) {
        return this._map(project);
    };
    /**
     * It's like `map`, but transforms each input event to always the same
     * constant value on the output Stream.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7-----
     *       mapTo(10)
     * --10--10-10----10----
     * ```
     *
     * @param projectedValue A value to emit on the output Stream whenever the
     * input Stream emits any value.
     * @return {Stream}
     */ Stream.prototype.mapTo = function(projectedValue) {
        var s = this.map(function() {
            return projectedValue;
        });
        var op = s._prod;
        op.type = "mapTo";
        return s;
    };
    /**
     * Only allows events that pass the test given by the `passes` argument.
     *
     * Each event from the input stream is given to the `passes` function. If the
     * function returns `true`, the event is forwarded to the output stream,
     * otherwise it is ignored and not forwarded.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2--3-----4-----5---6--7-8--
     *     filter(i => i % 2 === 0)
     * ------2--------4---------6----8--
     * ```
     *
     * @param {Function} passes A function of type `(t: T) => boolean` that takes
     * an event from the input stream and checks if it passes, by returning a
     * boolean.
     * @return {Stream}
     */ Stream.prototype.filter = function(passes) {
        var p = this._prod;
        if (p instanceof $5bec6f56e3f47681$var$Filter) return new Stream(new $5bec6f56e3f47681$var$Filter($5bec6f56e3f47681$var$and(p.f, passes), p.ins));
        return new Stream(new $5bec6f56e3f47681$var$Filter(passes, this));
    };
    /**
     * Lets the first `amount` many events from the input stream pass to the
     * output stream, then makes the output stream complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *    take(3)
     * --a---b--c|
     * ```
     *
     * @param {number} amount How many events to allow from the input stream
     * before completing the output stream.
     * @return {Stream}
     */ Stream.prototype.take = function(amount) {
        return new (this.ctor())(new $5bec6f56e3f47681$var$Take(amount, this));
    };
    /**
     * Ignores the first `amount` many events from the input stream, and then
     * after that starts forwarding events from the input stream to the output
     * stream.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *       drop(3)
     * --------------d---e--
     * ```
     *
     * @param {number} amount How many events to ignore from the input stream
     * before forwarding all events from the input stream to the output stream.
     * @return {Stream}
     */ Stream.prototype.drop = function(amount) {
        return new Stream(new $5bec6f56e3f47681$var$Drop(amount, this));
    };
    /**
     * When the input stream completes, the output stream will emit the last event
     * emitted by the input stream, and then will also complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c--d----|
     *       last()
     * -----------------d|
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.last = function() {
        return new Stream(new $5bec6f56e3f47681$var$Last(this));
    };
    /**
     * Prepends the given `initial` value to the sequence of events emitted by the
     * input stream. The returned stream is a MemoryStream, which means it is
     * already `remember()`'d.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3---
     *   startWith(0)
     * 0--1---2-----3---
     * ```
     *
     * @param initial The value or event to prepend.
     * @return {MemoryStream}
     */ Stream.prototype.startWith = function(initial) {
        return new $5bec6f56e3f47681$var$MemoryStream(new $5bec6f56e3f47681$var$StartWith(this, initial));
    };
    /**
     * Uses another stream to determine when to complete the current stream.
     *
     * When the given `other` stream emits an event or completes, the output
     * stream will complete. Before that happens, the output stream will behaves
     * like the input stream.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3--4----5----6---
     *   endWhen( --------a--b--| )
     * ---1---2-----3--4--|
     * ```
     *
     * @param other Some other stream that is used to know when should the output
     * stream of this operator complete.
     * @return {Stream}
     */ Stream.prototype.endWhen = function(other) {
        return new (this.ctor())(new $5bec6f56e3f47681$var$EndWhen(other, this));
    };
    /**
     * "Folds" the stream onto itself.
     *
     * Combines events from the past throughout
     * the entire execution of the input stream, allowing you to accumulate them
     * together. It's essentially like `Array.prototype.reduce`. The returned
     * stream is a MemoryStream, which means it is already `remember()`'d.
     *
     * The output stream starts by emitting the `seed` which you give as argument.
     * Then, when an event happens on the input stream, it is combined with that
     * seed value through the `accumulate` function, and the output value is
     * emitted on the output stream. `fold` remembers that output value as `acc`
     * ("accumulator"), and then when a new input event `t` happens, `acc` will be
     * combined with that to produce the new `acc` and so forth.
     *
     * Marble diagram:
     *
     * ```text
     * ------1-----1--2----1----1------
     *   fold((acc, x) => acc + x, 3)
     * 3-----4-----5--7----8----9------
     * ```
     *
     * @param {Function} accumulate A function of type `(acc: R, t: T) => R` that
     * takes the previous accumulated value `acc` and the incoming event from the
     * input stream and produces the new accumulated value.
     * @param seed The initial accumulated value, of type `R`.
     * @return {MemoryStream}
     */ Stream.prototype.fold = function(accumulate, seed) {
        return new $5bec6f56e3f47681$var$MemoryStream(new $5bec6f56e3f47681$var$Fold(accumulate, seed, this));
    };
    /**
     * Replaces an error with another stream.
     *
     * When (and if) an error happens on the input stream, instead of forwarding
     * that error to the output stream, *replaceError* will call the `replace`
     * function which returns the stream that the output stream will replicate.
     * And, in case that new stream also emits an error, `replace` will be called
     * again to get another stream to start replicating.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2-----3--4-----X
     *   replaceError( () => --10--| )
     * --1---2-----3--4--------10--|
     * ```
     *
     * @param {Function} replace A function of type `(err) => Stream` that takes
     * the error that occurred on the input stream or on the previous replacement
     * stream and returns a new stream. The output stream will behave like the
     * stream that this function returns.
     * @return {Stream}
     */ Stream.prototype.replaceError = function(replace) {
        return new (this.ctor())(new $5bec6f56e3f47681$var$ReplaceError(replace, this));
    };
    /**
     * Flattens a "stream of streams", handling only one nested stream at a time
     * (no concurrency).
     *
     * If the input stream is a stream that emits streams, then this operator will
     * return an output stream which is a flat stream: emits regular events. The
     * flattening happens without concurrency. It works like this: when the input
     * stream emits a nested stream, *flatten* will start imitating that nested
     * one. However, as soon as the next nested stream is emitted on the input
     * stream, *flatten* will forget the previous nested one it was imitating, and
     * will start imitating the new nested one.
     *
     * Marble diagram:
     *
     * ```text
     * --+--------+---------------
     *   \        \
     *    \       ----1----2---3--
     *    --a--b----c----d--------
     *           flatten
     * -----a--b------1----2---3--
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.flatten = function() {
        return new Stream(new $5bec6f56e3f47681$var$Flatten(this));
    };
    /**
     * Passes the input stream to a custom operator, to produce an output stream.
     *
     * *compose* is a handy way of using an existing function in a chained style.
     * Instead of writing `outStream = f(inStream)` you can write
     * `outStream = inStream.compose(f)`.
     *
     * @param {function} operator A function that takes a stream as input and
     * returns a stream as well.
     * @return {Stream}
     */ Stream.prototype.compose = function(operator) {
        return operator(this);
    };
    /**
     * Returns an output stream that behaves like the input stream, but also
     * remembers the most recent event that happens on the input stream, so that a
     * newly added listener will immediately receive that memorised event.
     *
     * @return {MemoryStream}
     */ Stream.prototype.remember = function() {
        return new $5bec6f56e3f47681$var$MemoryStream(new $5bec6f56e3f47681$var$Remember(this));
    };
    /**
     * Returns an output stream that identically behaves like the input stream,
     * but also runs a `spy` function for each event, to help you debug your app.
     *
     * *debug* takes a `spy` function as argument, and runs that for each event
     * happening on the input stream. If you don't provide the `spy` argument,
     * then *debug* will just `console.log` each event. This helps you to
     * understand the flow of events through some operator chain.
     *
     * Please note that if the output stream has no listeners, then it will not
     * start, which means `spy` will never run because no actual event happens in
     * that case.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3-----4--
     *         debug
     * --1----2-----3-----4--
     * ```
     *
     * @param {function} labelOrSpy A string to use as the label when printing
     * debug information on the console, or a 'spy' function that takes an event
     * as argument, and does not need to return anything.
     * @return {Stream}
     */ Stream.prototype.debug = function(labelOrSpy) {
        return new (this.ctor())(new $5bec6f56e3f47681$var$Debug(this, labelOrSpy));
    };
    /**
     * *imitate* changes this current Stream to emit the same events that the
     * `other` given Stream does. This method returns nothing.
     *
     * This method exists to allow one thing: **circular dependency of streams**.
     * For instance, let's imagine that for some reason you need to create a
     * circular dependency where stream `first$` depends on stream `second$`
     * which in turn depends on `first$`:
     *
     * <!-- skip-example -->
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var first$ = second$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * ```
     *
     * However, that is invalid JavaScript, because `second$` is undefined
     * on the first line. This is how *imitate* can help solve it:
     *
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var secondProxy$ = xs.create();
     * var first$ = secondProxy$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * secondProxy$.imitate(second$);
     * ```
     *
     * We create `secondProxy$` before the others, so it can be used in the
     * declaration of `first$`. Then, after both `first$` and `second$` are
     * defined, we hook `secondProxy$` with `second$` with `imitate()` to tell
     * that they are "the same". `imitate` will not trigger the start of any
     * stream, it just binds `secondProxy$` and `second$` together.
     *
     * The following is an example where `imitate()` is important in Cycle.js
     * applications. A parent component contains some child components. A child
     * has an action stream which is given to the parent to define its state:
     *
     * <!-- skip-example -->
     * ```js
     * const childActionProxy$ = xs.create();
     * const parent = Parent({...sources, childAction$: childActionProxy$});
     * const childAction$ = parent.state$.map(s => s.child.action$).flatten();
     * childActionProxy$.imitate(childAction$);
     * ```
     *
     * Note, though, that **`imitate()` does not support MemoryStreams**. If we
     * would attempt to imitate a MemoryStream in a circular dependency, we would
     * either get a race condition (where the symptom would be "nothing happens")
     * or an infinite cyclic emission of values. It's useful to think about
     * MemoryStreams as cells in a spreadsheet. It doesn't make any sense to
     * define a spreadsheet cell `A1` with a formula that depends on `B1` and
     * cell `B1` defined with a formula that depends on `A1`.
     *
     * If you find yourself wanting to use `imitate()` with a
     * MemoryStream, you should rework your code around `imitate()` to use a
     * Stream instead. Look for the stream in the circular dependency that
     * represents an event stream, and that would be a candidate for creating a
     * proxy Stream which then imitates the target Stream.
     *
     * @param {Stream} target The other stream to imitate on the current one. Must
     * not be a MemoryStream.
     */ Stream.prototype.imitate = function(target) {
        if (target instanceof $5bec6f56e3f47681$var$MemoryStream) throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
        this._target = target;
        for(var ils = this._ils, N = ils.length, i = 0; i < N; i++)target._add(ils[i]);
        this._ils = [];
    };
    /**
     * Forces the Stream to emit the given value to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param value The "next" value you want to broadcast to all listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendNext = function(value) {
        this._n(value);
    };
    /**
     * Forces the Stream to emit the given error to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param {any} error The error you want to broadcast to all the listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendError = function(error) {
        this._e(error);
    };
    /**
     * Forces the Stream to emit the "completed" event to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     */ Stream.prototype.shamefullySendComplete = function() {
        this._c();
    };
    /**
     * Adds a "debug" listener to the stream. There can only be one debug
     * listener, that's why this is 'setDebugListener'. To remove the debug
     * listener, just call setDebugListener(null).
     *
     * A debug listener is like any other listener. The only difference is that a
     * debug listener is "stealthy": its presence/absence does not trigger the
     * start/stop of the stream (or the producer inside the stream). This is
     * useful so you can inspect what is going on without changing the behavior
     * of the program. If you have an idle stream and you add a normal listener to
     * it, the stream will start executing. But if you set a debug listener on an
     * idle stream, it won't start executing (not until the first normal listener
     * is added).
     *
     * As the name indicates, we don't recommend using this method to build app
     * logic. In fact, in most cases the debug operator works just fine. Only use
     * this one if you know what you're doing.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.setDebugListener = function(listener) {
        if (!listener) {
            this._d = false;
            this._dl = $5bec6f56e3f47681$var$NO;
        } else {
            this._d = true;
            listener._n = listener.next || $5bec6f56e3f47681$var$noop;
            listener._e = listener.error || $5bec6f56e3f47681$var$noop;
            listener._c = listener.complete || $5bec6f56e3f47681$var$noop;
            this._dl = listener;
        }
    };
    /**
     * Blends multiple streams together, emitting events from all of them
     * concurrently.
     *
     * *merge* takes multiple streams as arguments, and creates a stream that
     * behaves like each of the argument streams, in parallel.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b----c---d------
     *            merge
     * --1-a--2--b--3-c---d--4---
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to merge together with other streams.
     * @param {Stream} stream2 A stream to merge together with other streams. Two
     * or more streams may be given as arguments.
     * @return {Stream}
     */ Stream.merge = function merge() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $5bec6f56e3f47681$var$Merge(streams));
    };
    /**
     * Combines multiple input streams together to return a stream whose events
     * are arrays that collect the latest events from each input stream.
     *
     * *combine* internally remembers the most recent event from each of the input
     * streams. When any of the input streams emits an event, that event together
     * with all the other saved events are combined into an array. That array will
     * be emitted on the output stream. It's essentially a way of joining together
     * the events from multiple streams.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b-----c--d------
     *          combine
     * ----1a-2a-2b-3b-3c-3d-4d--
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to combine together with other streams.
     * @param {Stream} stream2 A stream to combine together with other streams.
     * Multiple streams, not just two, may be given as arguments.
     * @return {Stream}
     */ Stream.combine = function combine() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $5bec6f56e3f47681$var$Combine(streams));
    };
    return Stream;
}();
module.exports.Stream = $5bec6f56e3f47681$var$Stream;
var $5bec6f56e3f47681$var$MemoryStream = /** @class */ function(_super) {
    $5bec6f56e3f47681$var$__extends(MemoryStream, _super);
    function MemoryStream(producer) {
        var _this = _super.call(this, producer) || this;
        _this._has = false;
        return _this;
    }
    MemoryStream.prototype._n = function(x) {
        this._v = x;
        this._has = true;
        _super.prototype._n.call(this, x);
    };
    MemoryStream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) {
            if (this._has) il._n(this._v);
            return;
        }
        if (this._stopID !== $5bec6f56e3f47681$var$NO) {
            if (this._has) il._n(this._v);
            clearTimeout(this._stopID);
            this._stopID = $5bec6f56e3f47681$var$NO;
        } else if (this._has) il._n(this._v);
        else {
            var p = this._prod;
            if (p !== $5bec6f56e3f47681$var$NO) p._start(this);
        }
    };
    MemoryStream.prototype._stopNow = function() {
        this._has = false;
        _super.prototype._stopNow.call(this);
    };
    MemoryStream.prototype._x = function() {
        this._has = false;
        _super.prototype._x.call(this);
    };
    MemoryStream.prototype.map = function(project) {
        return this._map(project);
    };
    MemoryStream.prototype.mapTo = function(projectedValue) {
        return _super.prototype.mapTo.call(this, projectedValue);
    };
    MemoryStream.prototype.take = function(amount) {
        return _super.prototype.take.call(this, amount);
    };
    MemoryStream.prototype.endWhen = function(other) {
        return _super.prototype.endWhen.call(this, other);
    };
    MemoryStream.prototype.replaceError = function(replace) {
        return _super.prototype.replaceError.call(this, replace);
    };
    MemoryStream.prototype.remember = function() {
        return this;
    };
    MemoryStream.prototype.debug = function(labelOrSpy) {
        return _super.prototype.debug.call(this, labelOrSpy);
    };
    return MemoryStream;
}($5bec6f56e3f47681$var$Stream);
module.exports.MemoryStream = $5bec6f56e3f47681$var$MemoryStream;
var $5bec6f56e3f47681$var$xs = $5bec6f56e3f47681$var$Stream;
module.exports.default = $5bec6f56e3f47681$var$xs;

});
parcelRegister("jBNLL", function(module, exports) {

module.exports = (parcelRequire("hS2fe"));

});

parcelRegister("aQAiV", function(module, exports) {
"use strict";

var $3J2lV = parcelRequire("3J2lV");

var $8ubDX = parcelRequire("8ubDX");

var $1bVW7 = parcelRequire("1bVW7");

var $hBeaH = parcelRequire("hBeaH");
var $7e5aebfe4cac87df$var$polyfill = $1bVW7();
var $7e5aebfe4cac87df$var$getGlobal = function getGlobal() {
    return $7e5aebfe4cac87df$var$polyfill;
};
$3J2lV($7e5aebfe4cac87df$var$getGlobal, {
    getPolyfill: $1bVW7,
    implementation: $8ubDX,
    shim: $hBeaH
});
module.exports = $7e5aebfe4cac87df$var$getGlobal;

});
parcelRegister("3J2lV", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");
"use strict";

var $7sbsd = parcelRequire("7sbsd");
var $2b67663c1ddaf2fb$var$hasSymbols = typeof Symbol === "function" && (0, $aVMuR._)(Symbol("foo")) === "symbol";
var $2b67663c1ddaf2fb$var$toStr = Object.prototype.toString;
var $2b67663c1ddaf2fb$var$concat = Array.prototype.concat;
var $2b67663c1ddaf2fb$var$origDefineProperty = Object.defineProperty;
var $2b67663c1ddaf2fb$var$isFunction = function isFunction(fn) {
    return typeof fn === "function" && $2b67663c1ddaf2fb$var$toStr.call(fn) === "[object Function]";
};

var $2b67663c1ddaf2fb$var$hasPropertyDescriptors = (parcelRequire("k95OQ"))();
var $2b67663c1ddaf2fb$var$supportsDescriptors = $2b67663c1ddaf2fb$var$origDefineProperty && $2b67663c1ddaf2fb$var$hasPropertyDescriptors;
var $2b67663c1ddaf2fb$var$defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$2b67663c1ddaf2fb$var$isFunction(predicate) || !predicate()) return;
    }
    if ($2b67663c1ddaf2fb$var$supportsDescriptors) $2b67663c1ddaf2fb$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $2b67663c1ddaf2fb$var$defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $7sbsd(map);
    if ($2b67663c1ddaf2fb$var$hasSymbols) props = $2b67663c1ddaf2fb$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$2b67663c1ddaf2fb$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$2b67663c1ddaf2fb$var$defineProperties.supportsDescriptors = !!$2b67663c1ddaf2fb$var$supportsDescriptors;
module.exports = $2b67663c1ddaf2fb$var$defineProperties;

});
parcelRegister("7sbsd", function(module, exports) {
"use strict";
var $56d40876d10adc06$var$slice = Array.prototype.slice;

var $cTULJ = parcelRequire("cTULJ");
var $56d40876d10adc06$var$origKeys = Object.keys;

var $56d40876d10adc06$var$keysShim = $56d40876d10adc06$var$origKeys ? function keys(o) {
    return $56d40876d10adc06$var$origKeys(o);
} : (parcelRequire("csPz0"));
var $56d40876d10adc06$var$originalKeys = Object.keys;
$56d40876d10adc06$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($cTULJ(object)) return $56d40876d10adc06$var$originalKeys($56d40876d10adc06$var$slice.call(object));
            return $56d40876d10adc06$var$originalKeys(object);
        };
    } else Object.keys = $56d40876d10adc06$var$keysShim;
    return Object.keys || $56d40876d10adc06$var$keysShim;
};
module.exports = $56d40876d10adc06$var$keysShim;

});


parcelRegister("8ubDX", function(module, exports) {
/* eslint no-negated-condition: 0, no-new-func: 0 */ "use strict";
if (typeof self !== "undefined") module.exports = self;
else if (typeof window !== "undefined") module.exports = window;
else module.exports = Function("return this")();

});

parcelRegister("1bVW7", function(module, exports) {
"use strict";

var $8ubDX = parcelRequire("8ubDX");
module.exports = function getPolyfill() {
    if (typeof $parcel$global !== "object" || !$parcel$global || $parcel$global.Math !== Math || $parcel$global.Array !== Array) return $8ubDX;
    return $parcel$global;
};

});

parcelRegister("hBeaH", function(module, exports) {
"use strict";

var $3J2lV = parcelRequire("3J2lV");

var $1bVW7 = parcelRequire("1bVW7");
module.exports = function shimGlobal() {
    var polyfill = $1bVW7();
    if ($3J2lV.supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(polyfill, "globalThis");
        if (!descriptor || descriptor.configurable && (descriptor.enumerable || !descriptor.writable || globalThis !== polyfill)) Object.defineProperty(polyfill, "globalThis", {
            configurable: true,
            enumerable: false,
            value: polyfill,
            writable: true
        });
    } else if (typeof globalThis !== "object" || globalThis !== polyfill) polyfill.globalThis = polyfill;
    return polyfill;
};

});




parcelRegister("dKcsF", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
var $a0193cd29a8bed94$var$DefaultValueProducer = /*#__PURE__*/ function() {
    function DefaultValueProducer(value, callbacks) {
        (0, $7dKN1._)(this, DefaultValueProducer);
        this.callbacks = callbacks;
        this.internalValue = value;
    }
    (0, $eW5pA._)(DefaultValueProducer, [
        {
            key: "value",
            get: function get() {
                return this.internalValue;
            }
        },
        {
            /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */ key: "update",
            value: function update(value) {
                this.internalValue = value;
                if (this.listener) this.listener.next(value);
            }
        },
        {
            /**
     * Produce an error
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
            key: "error",
            value: function error(error) {
                if (this.listener) this.listener.error(error);
            }
        },
        {
            /**
     * Called by the stream. Do not call this directly.
     */ key: "start",
            value: function start(listener) {
                this.listener = listener;
                listener.next(this.internalValue);
                if (this.callbacks) this.callbacks.onStarted();
            }
        },
        {
            /**
     * Called by the stream. Do not call this directly.
     */ key: "stop",
            value: function stop() {
                if (this.callbacks) this.callbacks.onStop();
                this.listener = undefined;
            }
        }
    ]);
    return DefaultValueProducer;
}();
module.exports.DefaultValueProducer = $a0193cd29a8bed94$var$DefaultValueProducer;

});

parcelRegister("59vjz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */ function $3c061577703ef4c9$var$dropDuplicates(valueToKey) {
    var operand = function(instream) {
        var emittedKeys = new Set();
        var deduplicatedStream = instream.filter(function(value) {
            return !emittedKeys.has(valueToKey(value));
        }).debug(function(value) {
            return emittedKeys.add(valueToKey(value));
        });
        return deduplicatedStream;
    };
    return operand;
}
module.exports.dropDuplicates = $3c061577703ef4c9$var$dropDuplicates;

});

parcelRegister("9LXrQ", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firstEvent = module.exports.toListPromise = module.exports.fromListPromise = void 0;

var $7Tj2d = parcelRequire("7Tj2d");
/**
 * Emits one event for each list element as soon as the promise resolves
 */ function $71d69dfbf8c5e888$var$fromListPromise(promise) {
    var producer = {
        start: function(listener) {
            // the code in `start` runs as soon as anyone listens to the stream
            promise.then(function(iterable) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        listener.next(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                listener.complete();
            }).catch(function(error) {
                return listener.error(error);
            });
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: function() {}
    };
    return $7Tj2d.Stream.create(producer);
}
module.exports.fromListPromise = $71d69dfbf8c5e888$var$fromListPromise;
function $71d69dfbf8c5e888$var$toListPromise(stream, count) {
    return $71d69dfbf8c5e888$var$_toListPromise.apply(this, arguments);
}
function $71d69dfbf8c5e888$var$_toListPromise() {
    $71d69dfbf8c5e888$var$_toListPromise = /**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */ (0, $6rBFC._)(function(stream, count) {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (count === 0) {
                        resolve([]);
                        return;
                    }
                    var events = new Array();
                    // take() unsubscribes from source stream automatically
                    stream.take(count).subscribe({
                        next: function(event) {
                            events.push(event);
                            if (events.length === count) resolve(events);
                        },
                        complete: function() {
                            reject("Stream completed before all events could be collected. " + "Collected ".concat(events.length, ", expected ").concat(count));
                        },
                        error: function(error) {
                            return reject(error);
                        }
                    });
                })
            ];
        });
    });
    return $71d69dfbf8c5e888$var$_toListPromise.apply(this, arguments);
}
module.exports.toListPromise = $71d69dfbf8c5e888$var$toListPromise;
function $71d69dfbf8c5e888$var$firstEvent(stream) {
    return $71d69dfbf8c5e888$var$_firstEvent.apply(this, arguments);
}
function $71d69dfbf8c5e888$var$_firstEvent() {
    $71d69dfbf8c5e888$var$_firstEvent = /**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */ (0, $6rBFC._)(function(stream) {
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $71d69dfbf8c5e888$var$toListPromise(stream, 1)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()[0]
                    ];
            }
        });
    });
    return $71d69dfbf8c5e888$var$_firstEvent.apply(this, arguments);
}
module.exports.firstEvent = $71d69dfbf8c5e888$var$firstEvent;

});

parcelRegister("7OQnl", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = void 0;

var $7Tj2d = parcelRequire("7Tj2d");
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */ var $5b15d49a69f1259b$var$ValueAndUpdates = /*#__PURE__*/ function() {
    function ValueAndUpdates(producer) {
        (0, $7dKN1._)(this, ValueAndUpdates);
        this.producer = producer;
        this.updates = $7Tj2d.MemoryStream.createWithMemory(this.producer);
    }
    (0, $eW5pA._)(ValueAndUpdates, [
        {
            key: "value",
            get: function get() {
                return this.producer.value;
            }
        },
        {
            key: "waitFor",
            value: /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */ function waitFor(search) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var searchImplementation;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        searchImplementation = typeof search === "function" ? search : function(value) {
                            return value === search;
                        };
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var subscription = _this.updates.subscribe({
                                    next: function(newValue) {
                                        if (searchImplementation(newValue)) {
                                            resolve(newValue);
                                            // MemoryStream.subscribe() calls next with the last value.
                                            // Make async to ensure the subscription exists
                                            setTimeout(function() {
                                                return subscription.unsubscribe();
                                            }, 0);
                                        }
                                    },
                                    complete: function() {
                                        subscription.unsubscribe();
                                        reject("Update stream completed without expected value");
                                    },
                                    error: function(error) {
                                        reject(error);
                                    }
                                });
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return ValueAndUpdates;
}();
module.exports.ValueAndUpdates = $5b15d49a69f1259b$var$ValueAndUpdates;

});


parcelRegister("755i0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = void 0;
function $527d1a6b00918b61$var$isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
module.exports.isJsonRpcErrorResponse = $527d1a6b00918b61$var$isJsonRpcErrorResponse;
function $527d1a6b00918b61$var$isJsonRpcSuccessResponse(response) {
    return !$527d1a6b00918b61$var$isJsonRpcErrorResponse(response);
}
module.exports.isJsonRpcSuccessResponse = $527d1a6b00918b61$var$isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */ module.exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000
    }
};

});


parcelRegister("iZxqB", function(module, exports) {

var $4JCw4 = parcelRequire("4JCw4");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcErrorResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = void 0;

var $g1I7I = parcelRequire("g1I7I");
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */ function $dd37daa019357138$var$parseJsonRpcId(data) {
    if (!(0, $g1I7I.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    var id = data.id;
    if (typeof id !== "number" && typeof id !== "string") return null;
    return id;
}
module.exports.parseJsonRpcId = $dd37daa019357138$var$parseJsonRpcId;
function $dd37daa019357138$var$parseJsonRpcRequest(data) {
    if (!(0, $g1I7I.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error("Got unexpected jsonrpc version: ".concat(data.jsonrpc));
    var id = $dd37daa019357138$var$parseJsonRpcId(data);
    if (id === null) throw new Error("Invalid id field");
    var method = data.method;
    if (typeof method !== "string") throw new Error("Invalid method field");
    if (!(0, $g1I7I.isJsonCompatibleArray)(data.params) && !(0, $g1I7I.isJsonCompatibleDictionary)(data.params)) throw new Error("Invalid params field");
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params
    };
}
module.exports.parseJsonRpcRequest = $dd37daa019357138$var$parseJsonRpcRequest;
function $dd37daa019357138$var$parseError(error) {
    if (typeof error.code !== "number") throw new Error("Error property 'code' is not a number");
    if (typeof error.message !== "string") throw new Error("Error property 'message' is not a string");
    var maybeUndefinedData;
    if (error.data === undefined) maybeUndefinedData = undefined;
    else if ((0, $g1I7I.isJsonCompatibleValue)(error.data)) maybeUndefinedData = error.data;
    else throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    return (0, $4JCw4._)({
        code: error.code,
        message: error.message
    }, maybeUndefinedData !== undefined ? {
        data: maybeUndefinedData
    } : {});
}
/** Throws if data is not a JsonRpcErrorResponse */ function $dd37daa019357138$var$parseJsonRpcErrorResponse(data) {
    if (!(0, $g1I7I.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error("Got unexpected jsonrpc version: ".concat(JSON.stringify(data)));
    var id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) throw new Error("Invalid id field");
    if (typeof data.error === "undefined" || !(0, $g1I7I.isJsonCompatibleDictionary)(data.error)) throw new Error("Invalid error field");
    return {
        jsonrpc: "2.0",
        id: id,
        error: $dd37daa019357138$var$parseError(data.error)
    };
}
module.exports.parseJsonRpcErrorResponse = $dd37daa019357138$var$parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */ function $dd37daa019357138$var$parseJsonRpcSuccessResponse(data) {
    if (!(0, $g1I7I.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error("Got unexpected jsonrpc version: ".concat(JSON.stringify(data)));
    var id = data.id;
    if (typeof id !== "number" && typeof id !== "string") throw new Error("Invalid id field");
    if (typeof data.result === "undefined") throw new Error("Invalid result field");
    var result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result
    };
}
module.exports.parseJsonRpcSuccessResponse = $dd37daa019357138$var$parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */ function $dd37daa019357138$var$parseJsonRpcResponse(data) {
    var response;
    try {
        response = $dd37daa019357138$var$parseJsonRpcErrorResponse(data);
    } catch (_) {
        response = $dd37daa019357138$var$parseJsonRpcSuccessResponse(data);
    }
    return response;
}
module.exports.parseJsonRpcResponse = $dd37daa019357138$var$parseJsonRpcResponse;

});
parcelRegister("g1I7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJsonCompatibleDictionary = module.exports.isJsonCompatibleArray = module.exports.isJsonCompatibleValue = void 0;
function $baaef756230eccb9$var$isJsonCompatibleValue(value) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $baaef756230eccb9$var$isJsonCompatibleArray(value) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $baaef756230eccb9$var$isJsonCompatibleDictionary(value)) return true;
    else return false;
}
module.exports.isJsonCompatibleValue = $baaef756230eccb9$var$isJsonCompatibleValue;
function $baaef756230eccb9$var$isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!$baaef756230eccb9$var$isJsonCompatibleValue(item)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // all items okay
    return true;
}
module.exports.isJsonCompatibleArray = $baaef756230eccb9$var$isJsonCompatibleArray;
function $baaef756230eccb9$var$isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) // data must be a non-null object
    return false;
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") return false;
    return Object.values(data).every($baaef756230eccb9$var$isJsonCompatibleValue);
}
module.exports.isJsonCompatibleDictionary = $baaef756230eccb9$var$isJsonCompatibleDictionary;

});



parcelRegister("fcHu6", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $4JCw4 = parcelRequire("4JCw4");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $b119b51a1a046dc6$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.http = void 0;

var $b119b51a1a046dc6$var$axios_1 = $b119b51a1a046dc6$var$__importDefault((parcelRequire("1jrnB")));
function $b119b51a1a046dc6$var$filterBadStatus(res) {
    if (res.status >= 400) throw new Error("Bad status on response: ".concat(res.status));
    return res;
}
/**
 * Node.js 18 comes with exprimental fetch support (https://nodejs.org/de/blog/announcements/v18-release-announce/).
 * This is nice, but the implementation does not yet work wekk for us. We
 * can just stick with axios on those systems for now.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b119b51a1a046dc6$var$isExperimental(nodeJsFunc) {
    // This works because we get this info in node 18:
    //
    // > fetch.toString()
    // 'async function fetch(input, init = undefined) {\n' +
    // "    emitExperimentalWarning('The Fetch API');\n" +
    // '    return lazyUndici().fetch(input, init);\n' +
    // '  }'
    return nodeJsFunc.toString().includes("emitExperimentalWarning");
}
function $b119b51a1a046dc6$var$http(method, url, headers, request) {
    return $b119b51a1a046dc6$var$_http.apply(this, arguments);
}
function $b119b51a1a046dc6$var$_http() {
    $b119b51a1a046dc6$var$_http = /**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    (0, $6rBFC._)(function(method, url, headers, request) {
        var settings;
        return (0, $6qu4b.__generator)(this, function(_state) {
            if (typeof fetch === "function" && !$b119b51a1a046dc6$var$isExperimental(fetch)) {
                settings = {
                    method: method,
                    body: request ? JSON.stringify(request) : undefined,
                    headers: (0, $4JCw4._)({
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        "Content-Type": "application/json"
                    }, headers)
                };
                return [
                    2,
                    fetch(url, settings).then($b119b51a1a046dc6$var$filterBadStatus).then(function(res) {
                        return res.json();
                    })
                ];
            } else return [
                2,
                $b119b51a1a046dc6$var$axios_1.default.request({
                    url: url,
                    method: method,
                    data: request,
                    headers: headers
                }).then(function(res) {
                    return res.data;
                })
            ];
            return [
                2
            ];
        });
    });
    return $b119b51a1a046dc6$var$_http.apply(this, arguments);
}
module.exports.http = $b119b51a1a046dc6$var$http;

});

parcelRegister("gfCZp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasProtocol = module.exports.instanceOfRpcStreamingClient = void 0;
function $bd4c4a889569f16f$var$instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
module.exports.instanceOfRpcStreamingClient = $bd4c4a889569f16f$var$instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function $bd4c4a889569f16f$var$hasProtocol(url) {
    return url.search("://") !== -1;
}
module.exports.hasProtocol = $bd4c4a889569f16f$var$hasProtocol;

});


parcelRegister("4ZhaX", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpClient = void 0;

var $j8Lpw = parcelRequire("j8Lpw");

var $fcHu6 = parcelRequire("fcHu6");

var $gfCZp = parcelRequire("gfCZp");
var $3a1a2ea62e22d41e$var$HttpClient = /*#__PURE__*/ function() {
    function HttpClient(endpoint) {
        (0, $7dKN1._)(this, HttpClient);
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $gfCZp.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
    (0, $eW5pA._)(HttpClient, [
        {
            key: "disconnect",
            value: function disconnect() {
            // nothing to be done
            }
        },
        {
            key: "execute",
            value: function execute(request) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response, _;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = (0, $j8Lpw.parseJsonRpcResponse);
                                return [
                                    4,
                                    (0, $fcHu6.http)("POST", _this.url, _this.headers, request)
                                ];
                            case 1:
                                response = _.apply(void 0, [
                                    _state.sent()
                                ]);
                                if ((0, $j8Lpw.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HttpClient;
}();
module.exports.HttpClient = $3a1a2ea62e22d41e$var$HttpClient;

});

parcelRegister("eqzvm", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = void 0;

var $j8Lpw = parcelRequire("j8Lpw");

var $9BtWE = parcelRequire("9BtWE");

var $lB6jI = parcelRequire("lB6jI");

var $7Tj2d = parcelRequire("7Tj2d");

var $gfCZp = parcelRequire("gfCZp");
function $a80f08efefd6ab46$var$defaultErrorHandler(error) {
    throw error;
}
function $a80f08efefd6ab46$var$toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") throw new Error("Unexcepted message type on websocket: ".concat(message.type));
    var jsonRpcEvent = (0, $j8Lpw.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
var $a80f08efefd6ab46$var$RpcEventProducer = /*#__PURE__*/ function() {
    function RpcEventProducer(request, socket) {
        (0, $7dKN1._)(this, RpcEventProducer);
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
    (0, $eW5pA._)(RpcEventProducer, [
        {
            /**
     * Implementation of Producer.start
     */ key: "start",
            value: function start(listener) {
                if (this.running) throw Error("Already started. Please stop first before restarting.");
                this.running = true;
                this.connectToClient(listener);
                this.socket.queueRequest(JSON.stringify(this.request));
            }
        },
        {
            /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */ key: "stop",
            value: function stop() {
                this.running = false;
                // Tell the server we are done in order to save resources. We cannot wait for the result.
                // This may fail when socket connection is not open, thus ignore errors in queueRequest
                var endRequest = (0, $gddcW._)((0, $4JCw4._)({}, this.request), {
                    method: "unsubscribe"
                });
                try {
                    this.socket.queueRequest(JSON.stringify(endRequest));
                } catch (error) {
                    if (error instanceof Error && error.message.match(/socket has disconnected/i)) ;
                    else throw error;
                }
            }
        },
        {
            key: "connectToClient",
            value: function connectToClient(listener) {
                var _this = this;
                var responseStream = this.socket.events.map($a80f08efefd6ab46$var$toJsonRpcResponse);
                // this should unsubscribe itself, so doesn't need to be removed explicitly
                var idSubscription = responseStream.filter(function(response) {
                    return response.id === _this.request.id;
                }).subscribe({
                    next: function(response) {
                        if ((0, $j8Lpw.isJsonRpcErrorResponse)(response)) {
                            _this.closeSubscriptions();
                            listener.error(JSON.stringify(response.error));
                        }
                        idSubscription.unsubscribe();
                    }
                });
                // this will fire on a response (success or error)
                // Tendermint adds an "#event" suffix for events that follow a previous subscription
                // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
                var idEventSubscription = responseStream.filter(function(response) {
                    return response.id === _this.request.id;
                }).subscribe({
                    next: function(response) {
                        if ((0, $j8Lpw.isJsonRpcErrorResponse)(response)) {
                            _this.closeSubscriptions();
                            listener.error(JSON.stringify(response.error));
                        } else listener.next(response.result);
                    }
                });
                // this will fire in case the websocket disconnects cleanly
                var nonResponseSubscription = responseStream.subscribe({
                    error: function(error) {
                        _this.closeSubscriptions();
                        listener.error(error);
                    },
                    complete: function() {
                        _this.closeSubscriptions();
                        listener.complete();
                    }
                });
                this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
            }
        },
        {
            key: "closeSubscriptions",
            value: function closeSubscriptions() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.subscriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var subscription = _step.value;
                        subscription.unsubscribe();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // clear unused subscriptions
                this.subscriptions = [];
            }
        }
    ]);
    return RpcEventProducer;
}();
var $a80f08efefd6ab46$var$WebsocketClient = /*#__PURE__*/ function() {
    function WebsocketClient(baseUrl) {
        var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a80f08efefd6ab46$var$defaultErrorHandler;
        (0, $7dKN1._)(this, WebsocketClient);
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        var path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        var cleanBaseUrl = (0, $gfCZp.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new $9BtWE.ReconnectingSocket(this.url);
        var errorSubscription = this.socket.events.subscribe({
            error: function(error) {
                onError(error);
                errorSubscription.unsubscribe();
            }
        });
        this.jsonRpcResponseStream = this.socket.events.map($a80f08efefd6ab46$var$toJsonRpcResponse);
        this.socket.connect();
    }
    (0, $eW5pA._)(WebsocketClient, [
        {
            key: "execute",
            value: function execute(request) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var pendingResponse, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                pendingResponse = _this.responseForRequestId(request.id);
                                _this.socket.queueRequest(JSON.stringify(request));
                                return [
                                    4,
                                    pendingResponse
                                ];
                            case 1:
                                response = _state.sent();
                                if ((0, $j8Lpw.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listen",
            value: function listen(request) {
                if (request.method !== "subscribe") throw new Error('Request method must be "subscribe" to start event listening');
                var query = request.params.query;
                if (typeof query !== "string") throw new Error("request.params.query must be a string");
                if (!this.subscriptionStreams.has(query)) {
                    var producer = new $a80f08efefd6ab46$var$RpcEventProducer(request, this.socket);
                    var stream = $7Tj2d.Stream.create(producer);
                    this.subscriptionStreams.set(query, stream);
                }
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return this.subscriptionStreams.get(query).filter(function(response) {
                    return response.query !== undefined;
                });
            }
        },
        {
            key: "connected",
            value: /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */ function connected() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.socket.connectionStatus.waitFor($9BtWE.ConnectionStatus.Connected)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.socket.disconnect();
            }
        },
        {
            key: "responseForRequestId",
            value: function responseForRequestId(id) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $lB6jI.firstEvent)(_this.jsonRpcResponseStream.filter(function(r) {
                                return r.id === id;
                            }))
                        ];
                    });
                })();
            }
        }
    ]);
    return WebsocketClient;
}();
module.exports.WebsocketClient = $a80f08efefd6ab46$var$WebsocketClient;

});
parcelRegister("9BtWE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = module.exports.SocketWrapper = module.exports.ReconnectingSocket = module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $2DBbL = parcelRequire("2DBbL");
Object.defineProperty(module.exports, "ConnectionStatus", {
    enumerable: true,
    get: function get() {
        return $2DBbL.ConnectionStatus;
    }
});
Object.defineProperty(module.exports, "QueueingStreamingSocket", {
    enumerable: true,
    get: function get() {
        return $2DBbL.QueueingStreamingSocket;
    }
});

var $ihYVb = parcelRequire("ihYVb");
Object.defineProperty(module.exports, "ReconnectingSocket", {
    enumerable: true,
    get: function get() {
        return $ihYVb.ReconnectingSocket;
    }
});

var $3jWy9 = parcelRequire("3jWy9");
Object.defineProperty(module.exports, "SocketWrapper", {
    enumerable: true,
    get: function get() {
        return $3jWy9.SocketWrapper;
    }
});

var $lFxG7 = parcelRequire("lFxG7");
Object.defineProperty(module.exports, "StreamingSocket", {
    enumerable: true,
    get: function get() {
        return $lFxG7.StreamingSocket;
    }
});

});
parcelRegister("2DBbL", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $lB6jI = parcelRequire("lB6jI");

var $7Tj2d = parcelRequire("7Tj2d");

var $lFxG7 = parcelRequire("lFxG7");
var $1ebc122dbb43f262$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})($1ebc122dbb43f262$var$ConnectionStatus = module.exports.ConnectionStatus || (module.exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */ var $1ebc122dbb43f262$var$QueueingStreamingSocket = /*#__PURE__*/ function() {
    function QueueingStreamingSocket(url) {
        var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10000, reconnectedHandler = arguments.length > 2 ? arguments[2] : void 0;
        var _this = this;
        (0, $7dKN1._)(this, QueueingStreamingSocket);
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        var eventProducer = {
            start: function(listener) {
                return _this.eventProducerListener = listener;
            },
            stop: function() {
                return _this.eventProducerListener = undefined;
            }
        };
        this.events = $7Tj2d.Stream.create(eventProducer);
        this.connectionStatusProducer = new $lB6jI.DefaultValueProducer($1ebc122dbb43f262$var$ConnectionStatus.Unconnected);
        this.connectionStatus = new $lB6jI.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new $lFxG7.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: function(event) {
                if (!_this.eventProducerListener) throw new Error("No event producer listener set");
                _this.eventProducerListener.next(event);
            },
            error: function() {
                return _this.connectionStatusProducer.update($1ebc122dbb43f262$var$ConnectionStatus.Disconnected);
            }
        });
    }
    (0, $eW5pA._)(QueueingStreamingSocket, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                this.connectionStatusProducer.update($1ebc122dbb43f262$var$ConnectionStatus.Connecting);
                var _this1 = this;
                this.socket.connected.then(/*#__PURE__*/ (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        _this1.connectionStatusProducer.update($1ebc122dbb43f262$var$ConnectionStatus.Connected);
                        return [
                            2,
                            _this1.processQueue()
                        ];
                    });
                }), function() {
                    return _this.connectionStatusProducer.update($1ebc122dbb43f262$var$ConnectionStatus.Disconnected);
                });
                this.socket.connect();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.connectionStatusProducer.update($1ebc122dbb43f262$var$ConnectionStatus.Disconnected);
                this.socket.disconnect();
            }
        },
        {
            key: "reconnect",
            value: function reconnect() {
                var _this = this;
                this.socket = new $lFxG7.StreamingSocket(this.url, this.timeout);
                this.socket.events.subscribe({
                    next: function(event) {
                        if (!_this.eventProducerListener) throw new Error("No event producer listener set");
                        _this.eventProducerListener.next(event);
                    },
                    error: function() {
                        return _this.connectionStatusProducer.update($1ebc122dbb43f262$var$ConnectionStatus.Disconnected);
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.socket.connected.then(function() {
                    if (_this.reconnectedHandler) _this.reconnectedHandler();
                });
                this.connect();
            }
        },
        {
            key: "getQueueLength",
            value: function getQueueLength() {
                return this.queue.length;
            }
        },
        {
            key: "queueRequest",
            value: function queueRequest(request) {
                this.queue.push(request);
                // We don’t need to wait for the queue to be processed.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.processQueue();
            }
        },
        {
            key: "processQueue",
            value: function processQueue() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var request, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isProcessingQueue || _this.connectionStatus.value !== $1ebc122dbb43f262$var$ConnectionStatus.Connected) return [
                                    2
                                ];
                                _this.isProcessingQueue = true;
                                _state.label = 1;
                            case 1:
                                if (!(request = _this.queue.shift())) return [
                                    3,
                                    6
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.socket.send(request)
                                ];
                            case 3:
                                _state.sent();
                                _this.isProcessingQueue = false;
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                // Probably the connection is down; will try again automatically when reconnected.
                                _this.queue.unshift(request);
                                _this.isProcessingQueue = false;
                                return [
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return QueueingStreamingSocket;
}();
module.exports.QueueingStreamingSocket = $1ebc122dbb43f262$var$QueueingStreamingSocket;

});
parcelRegister("lFxG7", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = void 0;

var $7Tj2d = parcelRequire("7Tj2d");

var $3jWy9 = parcelRequire("3jWy9");
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */ var $fc678d224e306662$var$StreamingSocket = /*#__PURE__*/ function() {
    function StreamingSocket(url) {
        var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10000;
        var _this = this;
        (0, $7dKN1._)(this, StreamingSocket);
        this.socket = new $3jWy9.SocketWrapper(url, function(event) {
            if (_this.eventProducerListener) _this.eventProducerListener.next(event);
        }, function(errorEvent) {
            if (_this.eventProducerListener) _this.eventProducerListener.error(errorEvent);
        }, function() {
        // socket opened
        }, function(closeEvent) {
            if (_this.eventProducerListener) {
                if (closeEvent.wasClean) _this.eventProducerListener.complete();
                else _this.eventProducerListener.error("Socket was closed unclean");
            }
        }, timeout);
        this.connected = this.socket.connected;
        var eventProducer = {
            start: function(listener) {
                return _this.eventProducerListener = listener;
            },
            stop: function() {
                return _this.eventProducerListener = undefined;
            }
        };
        this.events = $7Tj2d.Stream.create(eventProducer);
    }
    (0, $eW5pA._)(StreamingSocket, [
        {
            key: "connect",
            value: function connect() {
                this.socket.connect();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.socket.disconnect();
            }
        },
        {
            key: "send",
            value: function send(data) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.socket.send(data)
                        ];
                    });
                })();
            }
        }
    ]);
    return StreamingSocket;
}();
module.exports.StreamingSocket = $fc678d224e306662$var$StreamingSocket;

});
parcelRegister("3jWy9", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");

var $4pbh3 = parcelRequire("4pbh3");
"use strict";
var $26b0903c90f8cc48$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SocketWrapper = void 0;

var $26b0903c90f8cc48$var$isomorphic_ws_1 = $26b0903c90f8cc48$var$__importDefault((parcelRequire("6pgsi")));
function $26b0903c90f8cc48$var$environmentIsNodeJs() {
    return typeof $4pbh3 !== "undefined" && typeof $4pbh3.versions !== "undefined" && typeof $4pbh3.versions.node !== "undefined";
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */ var $26b0903c90f8cc48$var$SocketWrapper = /*#__PURE__*/ function() {
    "use strict";
    function SocketWrapper(url, messageHandler, errorHandler, openHandler, closeHandler) {
        var timeout = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 10000;
        var _this = this;
        (0, $7dKN1._)(this, SocketWrapper);
        this.closed = false;
        this.connected = new Promise(function(resolve, reject) {
            _this.connectedResolver = resolve;
            _this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
    (0, $eW5pA._)(SocketWrapper, [
        {
            /**
     * returns a promise that resolves when connection is open
     */ key: "connect",
            value: function connect() {
                var _this = this;
                var socket = new $26b0903c90f8cc48$var$isomorphic_ws_1.default(this.url);
                socket.onerror = function(error) {
                    _this.clearTimeout();
                    if (_this.errorHandler) _this.errorHandler(error);
                };
                socket.onmessage = function(messageEvent) {
                    _this.messageHandler({
                        type: messageEvent.type,
                        data: messageEvent.data
                    });
                };
                socket.onopen = function(_) {
                    _this.clearTimeout();
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _this.connectedResolver();
                    if (_this.openHandler) _this.openHandler();
                };
                socket.onclose = function(closeEvent) {
                    _this.closed = true;
                    if (_this.closeHandler) _this.closeHandler(closeEvent);
                };
                var started = Date.now();
                this.timeoutId = setTimeout(function() {
                    socket.onmessage = function() {
                        return 0;
                    };
                    socket.onerror = function() {
                        return 0;
                    };
                    socket.onopen = function() {
                        return 0;
                    };
                    socket.onclose = function() {
                        return 0;
                    };
                    socket.close();
                    _this.socket = undefined;
                    var elapsed = Math.floor(Date.now() - started);
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _this.connectedRejecter("Connection attempt timed out after ".concat(elapsed, " ms"));
                }, this.timeout);
                this.socket = socket;
            }
        },
        {
            /**
     * Closes an established connection and aborts other connection states
     */ key: "disconnect",
            value: function disconnect() {
                if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
                this.clearTimeout();
                switch(this.socket.readyState){
                    case $26b0903c90f8cc48$var$isomorphic_ws_1.default.OPEN:
                        this.socket.close(1000 /* Normal Closure */ );
                        break;
                    case $26b0903c90f8cc48$var$isomorphic_ws_1.default.CLOSED:
                        break;
                    case $26b0903c90f8cc48$var$isomorphic_ws_1.default.CONNECTING:
                        // imitate missing abort API
                        this.socket.onopen = function() {
                            return 0;
                        };
                        this.socket.onclose = function() {
                            return 0;
                        };
                        this.socket.onerror = function() {
                            return 0;
                        };
                        this.socket.onmessage = function() {
                            return 0;
                        };
                        this.socket = undefined;
                        if (this.closeHandler) this.closeHandler({
                            wasClean: false,
                            code: 4001
                        });
                        break;
                    case $26b0903c90f8cc48$var$isomorphic_ws_1.default.CLOSING:
                        break;
                    default:
                        throw new Error("Unknown readyState: ".concat(this.socket.readyState));
                }
            }
        },
        {
            key: "send",
            value: function send(data) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                if (!_this.socket) throw new Error("Socket undefined. This must be called after connecting.");
                                if (_this.closed) throw new Error("Socket was closed, so no data can be sent anymore.");
                                // this exception should be thrown by send() automatically according to
                                // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
                                if (_this.socket.readyState !== $26b0903c90f8cc48$var$isomorphic_ws_1.default.OPEN) throw new Error("Websocket is not open");
                                if ($26b0903c90f8cc48$var$environmentIsNodeJs()) _this.socket.send(data, function(err) {
                                    return err ? reject(err) : resolve();
                                });
                                else {
                                    // Browser websocket send method does not accept a callback
                                    _this.socket.send(data);
                                    resolve();
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */ key: "clearTimeout",
            value: function clearTimeout1() {
                if (!this.timeoutId) throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
                // Note: do not unset this.timeoutId to allow multiple calls to this function
                clearTimeout(this.timeoutId);
            }
        }
    ]);
    return SocketWrapper;
}();
module.exports.SocketWrapper = $26b0903c90f8cc48$var$SocketWrapper;

});



parcelRegister("ihYVb", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReconnectingSocket = void 0;

var $7Tj2d = parcelRequire("7Tj2d");

var $2DBbL = parcelRequire("2DBbL");
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */ var $d509123c6342bbe4$var$ReconnectingSocket = /*#__PURE__*/ function() {
    function ReconnectingSocket(url) {
        var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10000, reconnectedHandler = arguments.length > 2 ? arguments[2] : void 0;
        var _this = this;
        (0, $7dKN1._)(this, ReconnectingSocket);
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        var eventProducer = {
            start: function(listener) {
                return _this.eventProducerListener = listener;
            },
            stop: function() {
                return _this.eventProducerListener = undefined;
            }
        };
        this.events = $7Tj2d.Stream.create(eventProducer);
        this.socket = new $2DBbL.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: function(event) {
                if (_this.eventProducerListener) _this.eventProducerListener.next(event);
            },
            error: function(error) {
                if (_this.eventProducerListener) _this.eventProducerListener.error(error);
            }
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: function(status) {
                if (status === $2DBbL.ConnectionStatus.Connected) _this.timeoutIndex = 0;
                if (status === $2DBbL.ConnectionStatus.Disconnected) {
                    if (_this.reconnectTimeout) {
                        clearTimeout(_this.reconnectTimeout);
                        _this.reconnectTimeout = null;
                    }
                    _this.reconnectTimeout = setTimeout(function() {
                        return _this.socket.reconnect();
                    }, ReconnectingSocket.calculateTimeout(_this.timeoutIndex++));
                }
            }
        });
    }
    (0, $eW5pA._)(ReconnectingSocket, [
        {
            key: "connect",
            value: function connect() {
                if (!this.unconnected) throw new Error("Cannot connect: socket has already connected");
                this.socket.connect();
                this.unconnected = false;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.unconnected) throw new Error("Cannot disconnect: socket has not yet connected");
                this.socket.disconnect();
                if (this.eventProducerListener) this.eventProducerListener.complete();
                this.disconnected = true;
            }
        },
        {
            key: "queueRequest",
            value: function queueRequest(request) {
                if (this.disconnected) throw new Error("Cannot queue request: socket has disconnected");
                this.socket.queueRequest(request);
            }
        }
    ], [
        {
            key: "calculateTimeout",
            value: /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */ function calculateTimeout(index) {
                return Math.min(Math.pow(2, index) * 100, 5000);
            }
        }
    ]);
    return ReconnectingSocket;
}();
module.exports.ReconnectingSocket = $d509123c6342bbe4$var$ReconnectingSocket;

});




parcelRegister("4Yljk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor34 = void 0;

var $hx5Va = parcelRequire("hx5Va");

var $lzZvp = parcelRequire("lzZvp");

var $8Xkjk = parcelRequire("8Xkjk");
module.exports.adaptor34 = {
    params: $lzZvp.Params,
    responses: $8Xkjk.Responses,
    hashTx: $hx5Va.hashTx,
    hashBlock: $hx5Va.hashBlock
};

});
parcelRegister("hx5Va", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $7frLr = parcelRequire("7frLr");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $cc3a1c8c966f1e4a$var$hashTx(tx) {
    return (0, $3d6bA.sha256)(tx);
}
module.exports.hashTx = $cc3a1c8c966f1e4a$var$hashTx;
function $cc3a1c8c966f1e4a$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    var largestPowerOf2 = Math.pow(2, Math.floor(Math.log2(n)));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $cc3a1c8c966f1e4a$var$hashLeaf(leaf) {
    var hash = new $3d6bA.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $cc3a1c8c966f1e4a$var$hashInner(left, right) {
    var hash = new $3d6bA.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $cc3a1c8c966f1e4a$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $cc3a1c8c966f1e4a$var$hashLeaf(hashes[0]);
        default:
            {
                var slicePoint = $cc3a1c8c966f1e4a$var$getSplitPoint(hashes.length);
                var left = $cc3a1c8c966f1e4a$var$hashTree(hashes.slice(0, slicePoint));
                var right = $cc3a1c8c966f1e4a$var$hashTree(hashes.slice(slicePoint));
                return $cc3a1c8c966f1e4a$var$hashInner(left, right);
            }
    }
}
function $cc3a1c8c966f1e4a$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    var encodedFields = [
        (0, $7frLr.encodeVersion)(header.version),
        (0, $7frLr.encodeString)(header.chainId),
        (0, $7frLr.encodeUvarint)(header.height),
        (0, $7frLr.encodeTime)(header.time),
        (0, $7frLr.encodeBlockId)(header.lastBlockId),
        (0, $7frLr.encodeBytes)(header.lastCommitHash),
        (0, $7frLr.encodeBytes)(header.dataHash),
        (0, $7frLr.encodeBytes)(header.validatorsHash),
        (0, $7frLr.encodeBytes)(header.nextValidatorsHash),
        (0, $7frLr.encodeBytes)(header.consensusHash),
        (0, $7frLr.encodeBytes)(header.appHash),
        (0, $7frLr.encodeBytes)(header.lastResultsHash),
        (0, $7frLr.encodeBytes)(header.evidenceHash),
        (0, $7frLr.encodeBytes)(header.proposerAddress)
    ];
    return $cc3a1c8c966f1e4a$var$hashTree(encodedFields);
}
module.exports.hashBlock = $cc3a1c8c966f1e4a$var$hashBlock;

});
parcelRegister("3d6bA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.isArgon2idOptions = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.Argon2id = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $3tW3g = parcelRequire("3tW3g");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function get() {
        return $3tW3g.Bip39;
    }
});
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function get() {
        return $3tW3g.EnglishMnemonic;
    }
});

var $e4tLI = parcelRequire("e4tLI");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function get() {
        return $e4tLI.Hmac;
    }
});

var $bgVZN = parcelRequire("bgVZN");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function get() {
        return $bgVZN.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function get() {
        return $bgVZN.keccak256;
    }
});

var $jrVM7 = parcelRequire("jrVM7");
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function get() {
        return $jrVM7.Argon2id;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function get() {
        return $jrVM7.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function get() {
        return $jrVM7.Ed25519Keypair;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function get() {
        return $jrVM7.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function get() {
        return $jrVM7.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function get() {
        return $jrVM7.Xchacha20poly1305Ietf;
    }
});

var $b8Qwm = parcelRequire("b8Qwm");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function get() {
        return $b8Qwm.Random;
    }
});

var $dJoXC = parcelRequire("dJoXC");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function get() {
        return $dJoXC.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function get() {
        return $dJoXC.ripemd160;
    }
});

var $1Mxbk = parcelRequire("1Mxbk");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function get() {
        return $1Mxbk.Secp256k1;
    }
});

var $7TimK = parcelRequire("7TimK");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function get() {
        return $7TimK.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function get() {
        return $7TimK.Secp256k1Signature;
    }
});

var $380Qt = parcelRequire("380Qt");
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function get() {
        return $380Qt.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function get() {
        return $380Qt.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function get() {
        return $380Qt.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function get() {
        return $380Qt.sha512;
    }
});

var $fJaAw = parcelRequire("fJaAw");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function get() {
        return $fJaAw.pathToString;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function get() {
        return $fJaAw.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function get() {
        return $fJaAw.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function get() {
        return $fJaAw.slip10CurveFromString;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function get() {
        return $fJaAw.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function get() {
        return $fJaAw.stringToPath;
    }
});

});
parcelRegister("3tW3g", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = module.exports.EnglishMnemonic = module.exports.mnemonicToEntropy = module.exports.entropyToMnemonic = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $k4qjL = parcelRequire("k4qjL");

var $380Qt = parcelRequire("380Qt");
var $28911c63a9393b7b$var$wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
function $28911c63a9393b7b$var$bytesToBitstring(bytes) {
    return Array.from(bytes).map(function(byte) {
        return byte.toString(2).padStart(8, "0");
    }).join("");
}
function $28911c63a9393b7b$var$deriveChecksumBits(entropy) {
    var entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    var checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    var hash = (0, $380Qt.sha256)(entropy);
    return $28911c63a9393b7b$var$bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function $28911c63a9393b7b$var$bitstringToByte(bin) {
    return parseInt(bin, 2);
}
var $28911c63a9393b7b$var$allowedEntropyLengths = [
    16,
    20,
    24,
    28,
    32
];
var $28911c63a9393b7b$var$allowedWordLengths = [
    12,
    15,
    18,
    21,
    24
];
function $28911c63a9393b7b$var$entropyToMnemonic(entropy) {
    if ($28911c63a9393b7b$var$allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
    var entropyBits = $28911c63a9393b7b$var$bytesToBitstring(entropy);
    var checksumBits = $28911c63a9393b7b$var$deriveChecksumBits(entropy);
    var bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var chunks = bits.match(/(.{11})/g);
    var words = chunks.map(function(binary) {
        var index = $28911c63a9393b7b$var$bitstringToByte(binary);
        return $28911c63a9393b7b$var$wordlist[index];
    });
    return words.join(" ");
}
module.exports.entropyToMnemonic = $28911c63a9393b7b$var$entropyToMnemonic;
var $28911c63a9393b7b$var$invalidNumberOfWorks = "Invalid number of words";
var $28911c63a9393b7b$var$wordNotInWordlist = "Found word that is not in the wordlist";
var $28911c63a9393b7b$var$invalidEntropy = "Invalid entropy";
var $28911c63a9393b7b$var$invalidChecksum = "Invalid mnemonic checksum";
function $28911c63a9393b7b$var$normalize(str) {
    return str.normalize("NFKD");
}
function $28911c63a9393b7b$var$mnemonicToEntropy(mnemonic) {
    var words = $28911c63a9393b7b$var$normalize(mnemonic).split(" ");
    if (!$28911c63a9393b7b$var$allowedWordLengths.includes(words.length)) throw new Error($28911c63a9393b7b$var$invalidNumberOfWorks);
    // convert word indices to 11 bit binary strings
    var bits = words.map(function(word) {
        var index = $28911c63a9393b7b$var$wordlist.indexOf(word);
        if (index === -1) throw new Error($28911c63a9393b7b$var$wordNotInWordlist);
        return index.toString(2).padStart(11, "0");
    }).join("");
    // split the binary string into ENT/CS
    var dividerIndex = Math.floor(bits.length / 33) * 32;
    var entropyBits = bits.slice(0, dividerIndex);
    var checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var entropyBytes = entropyBits.match(/(.{1,8})/g).map($28911c63a9393b7b$var$bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) throw new Error($28911c63a9393b7b$var$invalidEntropy);
    var entropy = Uint8Array.from(entropyBytes);
    var newChecksum = $28911c63a9393b7b$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($28911c63a9393b7b$var$invalidChecksum);
    return entropy;
}
module.exports.mnemonicToEntropy = $28911c63a9393b7b$var$mnemonicToEntropy;
var $28911c63a9393b7b$var$EnglishMnemonic = /*#__PURE__*/ function() {
    function EnglishMnemonic(mnemonic) {
        (0, $7dKN1._)(this, EnglishMnemonic);
        if (!EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        var words = mnemonic.split(" ");
        var allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error("Invalid word count in mnemonic (allowed: ".concat(allowedWordsLengths, " got: ").concat(words.length, ")"));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = words[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var word = _step.value;
                if (EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Throws with informative error message if mnemonic is not valid
        $28911c63a9393b7b$var$mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    (0, $eW5pA._)(EnglishMnemonic, [
        {
            key: "toString",
            value: function toString() {
                return this.data;
            }
        }
    ]);
    return EnglishMnemonic;
}();
module.exports.EnglishMnemonic = $28911c63a9393b7b$var$EnglishMnemonic;
$28911c63a9393b7b$var$EnglishMnemonic.wordlist = $28911c63a9393b7b$var$wordlist;
// list of space separated lower case words (1 or more)
$28911c63a9393b7b$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
var $28911c63a9393b7b$var$Bip39 = /*#__PURE__*/ function() {
    function Bip39() {
        (0, $7dKN1._)(this, Bip39);
    }
    (0, $eW5pA._)(Bip39, null, [
        {
            key: "encode",
            value: /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ function encode(entropy) {
                return new $28911c63a9393b7b$var$EnglishMnemonic($28911c63a9393b7b$var$entropyToMnemonic(entropy));
            }
        },
        {
            key: "decode",
            value: function decode(mnemonic) {
                return $28911c63a9393b7b$var$mnemonicToEntropy(mnemonic.toString());
            }
        },
        {
            key: "mnemonicToSeed",
            value: function mnemonicToSeed(mnemonic, password) {
                return (0, $6rBFC._)(function() {
                    var mnemonicBytes, salt, saltBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        mnemonicBytes = (0, $lSA9E.toUtf8)($28911c63a9393b7b$var$normalize(mnemonic.toString()));
                        salt = "mnemonic" + (password ? $28911c63a9393b7b$var$normalize(password) : "");
                        saltBytes = (0, $lSA9E.toUtf8)(salt);
                        return [
                            2,
                            (0, $k4qjL.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64)
                        ];
                    });
                })();
            }
        }
    ]);
    return Bip39;
}();
module.exports.Bip39 = $28911c63a9393b7b$var$Bip39;

});
parcelRegister("lSA9E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.toBech32 = module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $dG20x = parcelRequire("dG20x");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function get() {
        return $dG20x.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function get() {
        return $dG20x.toAscii;
    }
});

var $e7UmU = parcelRequire("e7UmU");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function get() {
        return $e7UmU.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function get() {
        return $e7UmU.toBase64;
    }
});

var $e6LMI = parcelRequire("e6LMI");
Object.defineProperty(module.exports, "fromBech32", {
    enumerable: true,
    get: function get() {
        return $e6LMI.fromBech32;
    }
});
Object.defineProperty(module.exports, "normalizeBech32", {
    enumerable: true,
    get: function get() {
        return $e6LMI.normalizeBech32;
    }
});
Object.defineProperty(module.exports, "toBech32", {
    enumerable: true,
    get: function get() {
        return $e6LMI.toBech32;
    }
});

var $ghvYs = parcelRequire("ghvYs");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function get() {
        return $ghvYs.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function get() {
        return $ghvYs.toHex;
    }
});

var $g7cPy = parcelRequire("g7cPy");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function get() {
        return $g7cPy.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function get() {
        return $g7cPy.toRfc3339;
    }
});

var $kAPD1 = parcelRequire("kAPD1");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function get() {
        return $kAPD1.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function get() {
        return $kAPD1.toUtf8;
    }
});

});
parcelRegister("dG20x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $9f50c14845f6ef8b$var$toAscii(input) {
    var toNums = function(str) {
        return str.split("").map(function(x) {
            var charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    };
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $9f50c14845f6ef8b$var$toAscii;
function $9f50c14845f6ef8b$var$fromAscii(data) {
    var fromNums = function(listOfNumbers) {
        return listOfNumbers.map(function(x) {
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    };
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $9f50c14845f6ef8b$var$fromAscii;

});

parcelRegister("e7UmU", function(module, exports) {
"use strict";
var $a48d71ba91c8028d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a48d71ba91c8028d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a48d71ba91c8028d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a48d71ba91c8028d$var$__createBinding(result, mod, k);
    }
    $a48d71ba91c8028d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

var $a48d71ba91c8028d$var$base64js = $a48d71ba91c8028d$var$__importStar((parcelRequire("6l1Gi")));
function $a48d71ba91c8028d$var$toBase64(data) {
    return $a48d71ba91c8028d$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $a48d71ba91c8028d$var$toBase64;
function $a48d71ba91c8028d$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $a48d71ba91c8028d$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $a48d71ba91c8028d$var$fromBase64;

});

parcelRegister("e6LMI", function(module, exports) {
"use strict";
var $a456b14a1d59461e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a456b14a1d59461e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a456b14a1d59461e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a456b14a1d59461e$var$__createBinding(result, mod, k);
    }
    $a456b14a1d59461e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBech32 = void 0;

var $a456b14a1d59461e$var$bech32 = $a456b14a1d59461e$var$__importStar((parcelRequire("gHFi0")));
function $a456b14a1d59461e$var$toBech32(prefix, data, limit) {
    var address = $a456b14a1d59461e$var$bech32.encode(prefix, $a456b14a1d59461e$var$bech32.toWords(data), limit);
    return address;
}
module.exports.toBech32 = $a456b14a1d59461e$var$toBech32;
function $a456b14a1d59461e$var$fromBech32(address) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity;
    var decodedAddress = $a456b14a1d59461e$var$bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array($a456b14a1d59461e$var$bech32.fromWords(decodedAddress.words))
    };
}
module.exports.fromBech32 = $a456b14a1d59461e$var$fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */ function $a456b14a1d59461e$var$normalizeBech32(address) {
    var _fromBech32 = $a456b14a1d59461e$var$fromBech32(address), prefix = _fromBech32.prefix, data = _fromBech32.data;
    return $a456b14a1d59461e$var$toBech32(prefix, data);
}
module.exports.normalizeBech32 = $a456b14a1d59461e$var$normalizeBech32;

});

parcelRegister("ghvYs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $bda709469df4c430$var$toHex(data) {
    var out = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var byte = _step.value;
            out += ("0" + byte.toString(16)).slice(-2);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
module.exports.toHex = $bda709469df4c430$var$toHex;
function $bda709469df4c430$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    var out = new Uint8Array(hexstring.length / 2);
    for(var i = 0; i < out.length; i++){
        var j = 2 * i;
        var hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
module.exports.fromHex = $bda709469df4c430$var$fromHex;

});

parcelRegister("g7cPy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
var $bbb740a942930ff8$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $bbb740a942930ff8$var$padded(integer) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return integer.toString().padStart(length, "0");
}
function $bbb740a942930ff8$var$fromRfc3339(str) {
    var matches = $bbb740a942930ff8$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    var hour = +matches[4];
    var minute = +matches[5];
    var second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    var milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    var tzOffsetSign;
    var tzOffsetHours;
    var tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    var tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    var timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $bbb740a942930ff8$var$fromRfc3339;
function $bbb740a942930ff8$var$toRfc3339(date) {
    var year = date.getUTCFullYear();
    var month = $bbb740a942930ff8$var$padded(date.getUTCMonth() + 1);
    var day = $bbb740a942930ff8$var$padded(date.getUTCDate());
    var hour = $bbb740a942930ff8$var$padded(date.getUTCHours());
    var minute = $bbb740a942930ff8$var$padded(date.getUTCMinutes());
    var second = $bbb740a942930ff8$var$padded(date.getUTCSeconds());
    var ms = $bbb740a942930ff8$var$padded(date.getUTCMilliseconds(), 3);
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second, ".").concat(ms, "Z");
}
module.exports.toRfc3339 = $bbb740a942930ff8$var$toRfc3339;

});

parcelRegister("kAPD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $efdf37c34b293d72$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
module.exports.toUtf8 = $efdf37c34b293d72$var$toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */ function $efdf37c34b293d72$var$fromUtf8(data) {
    var lossy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var fatal = !lossy;
    return new TextDecoder("utf-8", {
        fatal: fatal
    }).decode(data);
}
module.exports.fromUtf8 = $efdf37c34b293d72$var$fromUtf8;

});


parcelRegister("k4qjL", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $e9c89885c95168e7$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9c89885c95168e7$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e9c89885c95168e7$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e9c89885c95168e7$var$__createBinding(result, mod, k);
    }
    $e9c89885c95168e7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Sha512 = module.exports.pbkdf2Sha512Noble = module.exports.pbkdf2Sha512NodeCrypto = module.exports.pbkdf2Sha512Subtle = module.exports.getSubtle = module.exports.getNodeCrypto = void 0;

var $gMk5u = parcelRequire("gMk5u");

var $gUoaD = parcelRequire("gUoaD");

var $aFeN5 = parcelRequire("aFeN5");
function $e9c89885c95168e7$var$getNodeCrypto() {
    return $e9c89885c95168e7$var$_getNodeCrypto.apply(this, arguments);
}

function $e9c89885c95168e7$var$_getNodeCrypto() {
    $e9c89885c95168e7$var$_getNodeCrypto = /**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */ (0, $6rBFC._)(function() {
        var nodeCrypto, e;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.resolve().then(function() {
                            return Promise.resolve((parcelRequire("5xFHp")));
                        }).then(function(res) {
                            return $e9c89885c95168e7$var$__importStar(res);
                        })
                    ];
                case 1:
                    nodeCrypto = _state.sent();
                    // We get `Object{default: Object{}}` as a fallback when using
                    // `crypto: false` in Webpack 5, which we interprete as unavailable.
                    if (typeof nodeCrypto === "object" && Object.keys(nodeCrypto).length <= 1) return [
                        2,
                        undefined
                    ];
                    return [
                        2,
                        nodeCrypto
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $e9c89885c95168e7$var$_getNodeCrypto.apply(this, arguments);
}
module.exports.getNodeCrypto = $e9c89885c95168e7$var$getNodeCrypto;
function $e9c89885c95168e7$var$getSubtle() {
    return $e9c89885c95168e7$var$_getSubtle.apply(this, arguments);
}
function $e9c89885c95168e7$var$_getSubtle() {
    $e9c89885c95168e7$var$_getSubtle = (0, $6rBFC._)(function() {
        var _globalThis_crypto, _globalThis, _globalThis_crypto_webcrypto, _globalThis_crypto1, _globalThis1, subtle;
        return (0, $6qu4b.__generator)(this, function(_state) {
            // From Node.js 15 onwards, webcrypto is available in globalThis.
            // In version 15 and 16 this was stored under the webcrypto key.
            // With Node.js 17 it was moved to the same locations where browsers
            // make it available.
            // Loading `require("crypto")` here seems unnecessary since it only
            // causes issues with bundlers and does not increase compatibility.
            // Browsers and Node.js 17+
            subtle = (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_crypto = _globalThis.crypto) === null || _globalThis_crypto === void 0 ? void 0 : _globalThis_crypto.subtle;
            // Node.js 15+
            if (!subtle) subtle = (_globalThis1 = globalThis) === null || _globalThis1 === void 0 ? void 0 : (_globalThis_crypto1 = _globalThis1.crypto) === null || _globalThis_crypto1 === void 0 ? void 0 : (_globalThis_crypto_webcrypto = _globalThis_crypto1.webcrypto) === null || _globalThis_crypto_webcrypto === void 0 ? void 0 : _globalThis_crypto_webcrypto.subtle;
            return [
                2,
                subtle
            ];
        });
    });
    return $e9c89885c95168e7$var$_getSubtle.apply(this, arguments);
}
module.exports.getSubtle = $e9c89885c95168e7$var$getSubtle;
function $e9c89885c95168e7$var$pbkdf2Sha512Subtle(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    return $e9c89885c95168e7$var$_pbkdf2Sha512Subtle.apply(this, arguments);
}
function $e9c89885c95168e7$var$_pbkdf2Sha512Subtle() {
    $e9c89885c95168e7$var$_pbkdf2Sha512Subtle = (0, $6rBFC._)(function(subtle, secret, salt, iterations, keylen) {
        return (0, $6qu4b.__generator)(this, function(_state) {
            (0, $gMk5u.assert)(subtle, "Argument subtle is falsy");
            (0, $gMk5u.assert)(typeof subtle === "object", "Argument subtle is not of type object");
            (0, $gMk5u.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
            (0, $gMk5u.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
            return [
                2,
                subtle.importKey("raw", secret, {
                    name: "PBKDF2"
                }, false, [
                    "deriveBits"
                ]).then(function(key) {
                    return subtle.deriveBits({
                        name: "PBKDF2",
                        salt: salt,
                        iterations: iterations,
                        hash: {
                            name: "SHA-512"
                        }
                    }, key, keylen * 8).then(function(buffer) {
                        return new Uint8Array(buffer);
                    });
                })
            ];
        });
    });
    return $e9c89885c95168e7$var$_pbkdf2Sha512Subtle.apply(this, arguments);
}
module.exports.pbkdf2Sha512Subtle = $e9c89885c95168e7$var$pbkdf2Sha512Subtle;
function $e9c89885c95168e7$var$pbkdf2Sha512NodeCrypto(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
nodeCrypto, secret, salt, iterations, keylen) {
    return $e9c89885c95168e7$var$_pbkdf2Sha512NodeCrypto.apply(this, arguments);
}
function $e9c89885c95168e7$var$_pbkdf2Sha512NodeCrypto() {
    $e9c89885c95168e7$var$_pbkdf2Sha512NodeCrypto = /**
 * Implements pbkdf2-sha512 using the Node.js crypro module (`import "crypto"`).
 * This does not use subtle from [Crypto](https://developer.mozilla.org/en-US/docs/Web/API/Crypto).
 */ (0, $6rBFC._)(function(nodeCrypto, secret, salt, iterations, keylen) {
        return (0, $6qu4b.__generator)(this, function(_state) {
            (0, $gMk5u.assert)(nodeCrypto, "Argument nodeCrypto is falsy");
            (0, $gMk5u.assert)(typeof nodeCrypto === "object", "Argument nodeCrypto is not of type object");
            (0, $gMk5u.assert)(typeof nodeCrypto.pbkdf2 === "function", "nodeCrypto.pbkdf2 is not a function");
            return [
                2,
                new Promise(function(resolve, reject) {
                    nodeCrypto.pbkdf2(secret, salt, iterations, keylen, "sha512", function(error, result) {
                        if (error) reject(error);
                        else resolve(Uint8Array.from(result));
                    });
                })
            ];
        });
    });
    return $e9c89885c95168e7$var$_pbkdf2Sha512NodeCrypto.apply(this, arguments);
}
module.exports.pbkdf2Sha512NodeCrypto = $e9c89885c95168e7$var$pbkdf2Sha512NodeCrypto;
function $e9c89885c95168e7$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return $e9c89885c95168e7$var$_pbkdf2Sha512Noble.apply(this, arguments);
}
function $e9c89885c95168e7$var$_pbkdf2Sha512Noble() {
    $e9c89885c95168e7$var$_pbkdf2Sha512Noble = (0, $6rBFC._)(function(secret, salt, iterations, keylen) {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2,
                (0, $gUoaD.pbkdf2Async)($aFeN5.sha512, secret, salt, {
                    c: iterations,
                    dkLen: keylen
                })
            ];
        });
    });
    return $e9c89885c95168e7$var$_pbkdf2Sha512Noble.apply(this, arguments);
}
module.exports.pbkdf2Sha512Noble = $e9c89885c95168e7$var$pbkdf2Sha512Noble;
function $e9c89885c95168e7$var$pbkdf2Sha512(secret, salt, iterations, keylen) {
    return $e9c89885c95168e7$var$_pbkdf2Sha512.apply(this, arguments);
}
function $e9c89885c95168e7$var$_pbkdf2Sha512() {
    $e9c89885c95168e7$var$_pbkdf2Sha512 = /**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */ (0, $6rBFC._)(function(secret, salt, iterations, keylen) {
        var subtle, nodeCrypto;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e9c89885c95168e7$var$getSubtle()
                    ];
                case 1:
                    subtle = _state.sent();
                    if (!subtle) return [
                        3,
                        2
                    ];
                    return [
                        2,
                        $e9c89885c95168e7$var$pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen)
                    ];
                case 2:
                    return [
                        4,
                        $e9c89885c95168e7$var$getNodeCrypto()
                    ];
                case 3:
                    nodeCrypto = _state.sent();
                    if (nodeCrypto) return [
                        2,
                        $e9c89885c95168e7$var$pbkdf2Sha512NodeCrypto(nodeCrypto, secret, salt, iterations, keylen)
                    ];
                    else return [
                        2,
                        $e9c89885c95168e7$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen)
                    ];
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $e9c89885c95168e7$var$_pbkdf2Sha512.apply(this, arguments);
}
module.exports.pbkdf2Sha512 = $e9c89885c95168e7$var$pbkdf2Sha512;

});
parcelRegister("gUoaD", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $kaKuv = parcelRequire("kaKuv");

var $ilXeP = parcelRequire("ilXeP");

var $eJ6Uk = parcelRequire("eJ6Uk");
// Common prologue and epilogue for sync/async functions
function $c4f4a013ff701948$var$pbkdf2Init(hash, _password, _salt, _opts) {
    $kaKuv.default.hash(hash);
    var opts = (0, $eJ6Uk.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    var c = opts.c, dkLen = opts.dkLen, asyncTick = opts.asyncTick;
    $kaKuv.default.number(c);
    $kaKuv.default.number(dkLen);
    $kaKuv.default.number(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    var password = (0, $eJ6Uk.toBytes)(_password);
    var salt = (0, $eJ6Uk.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    var DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    var PRF = $ilXeP.hmac.create(hash, password);
    var PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $c4f4a013ff701948$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $c4f4a013ff701948$var$pbkdf2(hash, password, salt, opts) {
    var _pbkdf2Init = $c4f4a013ff701948$var$pbkdf2Init(hash, password, salt, opts), c = _pbkdf2Init.c, dkLen = _pbkdf2Init.dkLen, DK = _pbkdf2Init.DK, PRF = _pbkdf2Init.PRF, PRFSalt = _pbkdf2Init.PRFSalt;
    var prfW; // Working copy
    var arr = new Uint8Array(4);
    var view = (0, $eJ6Uk.createView)(arr);
    var u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(var ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        var Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(var ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(var i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $c4f4a013ff701948$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $c4f4a013ff701948$var$pbkdf2;
function $c4f4a013ff701948$var$pbkdf2Async(hash, password, salt, opts) {
    return $c4f4a013ff701948$var$_pbkdf2Async.apply(this, arguments);
}
function $c4f4a013ff701948$var$_pbkdf2Async() {
    $c4f4a013ff701948$var$_pbkdf2Async = (0, $6rBFC._)(function(hash, password, salt, opts) {
        var _loop, _pbkdf2Init, c, dkLen, asyncTick, DK, PRF, PRFSalt, prfW, arr, view, u, ti, pos;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(ti, pos) {
                        var Ti;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // Ti = F(Password, Salt, c, i)
                                    Ti = DK.subarray(pos, pos + PRF.outputLen);
                                    view.setInt32(0, ti, false);
                                    // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
                                    // U1 = PRF(Password, Salt + INT_32_BE(i))
                                    (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
                                    Ti.set(u.subarray(0, Ti.length));
                                    return [
                                        4,
                                        (0, $eJ6Uk.asyncLoop)(c - 1, asyncTick, function(i) {
                                            // Uc = PRF(Password, Uc−1)
                                            PRF._cloneInto(prfW).update(u).digestInto(u);
                                            for(var i1 = 0; i1 < Ti.length; i1++)Ti[i1] ^= u[i1];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _pbkdf2Init = $c4f4a013ff701948$var$pbkdf2Init(hash, password, salt, opts), c = _pbkdf2Init.c, dkLen = _pbkdf2Init.dkLen, asyncTick = _pbkdf2Init.asyncTick, DK = _pbkdf2Init.DK, PRF = _pbkdf2Init.PRF, PRFSalt = _pbkdf2Init.PRFSalt;
                    arr = new Uint8Array(4);
                    view = (0, $eJ6Uk.createView)(arr);
                    u = new Uint8Array(PRF.outputLen);
                    ti = 1, pos = 0;
                    _state.label = 1;
                case 1:
                    if (!(pos < dkLen)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $6qu4b.__values)(_loop(ti, pos))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    ti++, pos += PRF.outputLen;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2,
                        $c4f4a013ff701948$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u)
                    ];
            }
        });
    });
    return $c4f4a013ff701948$var$_pbkdf2Async.apply(this, arguments);
}
module.exports.pbkdf2Async = $c4f4a013ff701948$var$pbkdf2Async;

});
parcelRegister("kaKuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $eaf8cdf2e90e9f70$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("Wrong positive integer: ".concat(n));
}
module.exports.number = $eaf8cdf2e90e9f70$var$number;
function $eaf8cdf2e90e9f70$var$bool(b) {
    if (typeof b !== "boolean") throw new Error("Expected boolean, not ".concat(b));
}
module.exports.bool = $eaf8cdf2e90e9f70$var$bool;
function $eaf8cdf2e90e9f70$var$bytes(b) {
    for(var _len = arguments.length, lengths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        lengths[_key - 1] = arguments[_key];
    }
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Expected Uint8Array of length ".concat(lengths, ", not of length=").concat(b.length));
}
module.exports.bytes = $eaf8cdf2e90e9f70$var$bytes;
function $eaf8cdf2e90e9f70$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $eaf8cdf2e90e9f70$var$number(hash.outputLen);
    $eaf8cdf2e90e9f70$var$number(hash.blockLen);
}
module.exports.hash = $eaf8cdf2e90e9f70$var$hash;
function $eaf8cdf2e90e9f70$var$exists(instance) {
    var checkFinished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $eaf8cdf2e90e9f70$var$exists;
function $eaf8cdf2e90e9f70$var$output(out, instance) {
    $eaf8cdf2e90e9f70$var$bytes(out);
    var min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least ".concat(min));
}
module.exports.output = $eaf8cdf2e90e9f70$var$output;
var $eaf8cdf2e90e9f70$var$assert = {
    number: $eaf8cdf2e90e9f70$var$number,
    bool: $eaf8cdf2e90e9f70$var$bool,
    bytes: $eaf8cdf2e90e9f70$var$bytes,
    hash: $eaf8cdf2e90e9f70$var$hash,
    exists: $eaf8cdf2e90e9f70$var$exists,
    output: $eaf8cdf2e90e9f70$var$output
};
module.exports.default = $eaf8cdf2e90e9f70$var$assert;

});

parcelRegister("ilXeP", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $kaKuv = parcelRequire("kaKuv");

var $eJ6Uk = parcelRequire("eJ6Uk");
// HMAC (RFC 2104)
var $0372b6409986917f$var$HMAC = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(HMAC, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(HMAC);
    function HMAC(hash, _key) {
        (0, $7dKN1._)(this, HMAC);
        var _this;
        _this = _super.call(this);
        _this.finished = false;
        _this.destroyed = false;
        $kaKuv.default.hash(hash);
        var key = (0, $eJ6Uk.toBytes)(_key);
        _this.iHash = hash.create();
        if (typeof _this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        _this.blockLen = _this.iHash.blockLen;
        _this.outputLen = _this.iHash.outputLen;
        var blockLen = _this.blockLen;
        var pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        _this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        _this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(var i1 = 0; i1 < pad.length; i1++)pad[i1] ^= 106;
        _this.oHash.update(pad);
        pad.fill(0);
        return _this;
    }
    (0, $eW5pA._)(HMAC, [
        {
            key: "update",
            value: function update(buf) {
                $kaKuv.default.exists(this);
                this.iHash.update(buf);
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                $kaKuv.default.exists(this);
                $kaKuv.default.bytes(out, this.outputLen);
                this.finished = true;
                this.iHash.digestInto(out);
                this.oHash.update(out);
                this.oHash.digestInto(out);
                this.destroy();
            }
        },
        {
            key: "digest",
            value: function digest() {
                var out = new Uint8Array(this.oHash.outputLen);
                this.digestInto(out);
                return out;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                // Create new instance without calling constructor since key already in state and we don't know it.
                to || (to = Object.create(Object.getPrototypeOf(this), {}));
                var _this = this, oHash = _this.oHash, iHash = _this.iHash, finished = _this.finished, destroyed = _this.destroyed, blockLen = _this.blockLen, outputLen = _this.outputLen;
                to;
                to.finished = finished;
                to.destroyed = destroyed;
                to.blockLen = blockLen;
                to.outputLen = outputLen;
                to.oHash = oHash._cloneInto(to.oHash);
                to.iHash = iHash._cloneInto(to.iHash);
                return to;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.oHash.destroy();
                this.iHash.destroy();
            }
        }
    ]);
    return HMAC;
}($eJ6Uk.Hash);
module.exports.HMAC = $0372b6409986917f$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ var $0372b6409986917f$var$hmac = function(hash, key, message) {
    return new $0372b6409986917f$var$HMAC(hash, key).update(message).digest();
};
module.exports.hmac = $0372b6409986917f$var$hmac;
module.exports.hmac.create = function(hash, key) {
    return new $0372b6409986917f$var$HMAC(hash, key);
};

});
parcelRegister("eJ6Uk", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $6wP5S = parcelRequire("6wP5S");
var $ab8aa05af6675c0f$var$u8a = function(a) {
    return a instanceof Uint8Array;
};
// Cast array to different type
var $ab8aa05af6675c0f$var$u8 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
module.exports.u8 = $ab8aa05af6675c0f$var$u8;
var $ab8aa05af6675c0f$var$u32 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
module.exports.u32 = $ab8aa05af6675c0f$var$u32;
// Cast array to view
var $ab8aa05af6675c0f$var$createView = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
module.exports.createView = $ab8aa05af6675c0f$var$createView;
// The rotate right (circular right shift) operation for uint32
var $ab8aa05af6675c0f$var$rotr = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
module.exports.rotr = $ab8aa05af6675c0f$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
var $ab8aa05af6675c0f$var$hexes = Array.from({
    length: 256
}, function(v, i) {
    return i.toString(16).padStart(2, "0");
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $ab8aa05af6675c0f$var$bytesToHex(bytes) {
    if (!$ab8aa05af6675c0f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $ab8aa05af6675c0f$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $ab8aa05af6675c0f$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $ab8aa05af6675c0f$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $aVMuR._)(hex)));
    var len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    var array = new Uint8Array(len / 2);
    for(var i = 0; i < array.length; i++){
        var j = i * 2;
        var hexByte = hex.slice(j, j + 2);
        var byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $ab8aa05af6675c0f$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
var $ab8aa05af6675c0f$var$nextTick = function() {
    var _ref = (0, $6rBFC._)(function() {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function nextTick() {
        return _ref.apply(this, arguments);
    };
}();
module.exports.nextTick = $ab8aa05af6675c0f$var$nextTick;
function $ab8aa05af6675c0f$var$asyncLoop(iters, tick, cb) {
    return $ab8aa05af6675c0f$var$_asyncLoop.apply(this, arguments);
}
function $ab8aa05af6675c0f$var$_asyncLoop() {
    $ab8aa05af6675c0f$var$_asyncLoop = // Returns control to thread each 'tick' ms to avoid blocking
    (0, $6rBFC._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, module.exports.nextTick)()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $ab8aa05af6675c0f$var$_asyncLoop.apply(this, arguments);
}
module.exports.asyncLoop = $ab8aa05af6675c0f$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $ab8aa05af6675c0f$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $ab8aa05af6675c0f$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $ab8aa05af6675c0f$var$toBytes(data) {
    if (typeof data === "string") data = $ab8aa05af6675c0f$var$utf8ToBytes(data);
    if (!$ab8aa05af6675c0f$var$u8a(data)) throw new Error("expected Uint8Array, got ".concat(typeof data === "undefined" ? "undefined" : (0, $aVMuR._)(data)));
    return data;
}
module.exports.toBytes = $ab8aa05af6675c0f$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $ab8aa05af6675c0f$var$concatBytes() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var r = new Uint8Array(arrays.reduce(function(sum, a) {
        return sum + a.length;
    }, 0));
    var pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach(function(a) {
        if (!$ab8aa05af6675c0f$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $ab8aa05af6675c0f$var$concatBytes;
// For runtime check if class implements interface
var $ab8aa05af6675c0f$var$Hash = /*#__PURE__*/ function() {
    function Hash() {
        (0, $7dKN1._)(this, Hash);
    }
    (0, $eW5pA._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
module.exports.Hash = $ab8aa05af6675c0f$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
var $ab8aa05af6675c0f$var$isPlainObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
};
function $ab8aa05af6675c0f$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$ab8aa05af6675c0f$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    var merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $ab8aa05af6675c0f$var$checkOpts;
function $ab8aa05af6675c0f$var$wrapConstructor(hashCons) {
    var hashC = function(msg) {
        return hashCons().update($ab8aa05af6675c0f$var$toBytes(msg)).digest();
    };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashCons();
    };
    return hashC;
}
module.exports.wrapConstructor = $ab8aa05af6675c0f$var$wrapConstructor;
function $ab8aa05af6675c0f$var$wrapConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($ab8aa05af6675c0f$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
module.exports.wrapConstructorWithOpts = $ab8aa05af6675c0f$var$wrapConstructorWithOpts;
function $ab8aa05af6675c0f$var$wrapXOFConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($ab8aa05af6675c0f$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $ab8aa05af6675c0f$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $ab8aa05af6675c0f$var$randomBytes() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ($6wP5S.crypto && typeof $6wP5S.crypto.getRandomValues === "function") return $6wP5S.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $ab8aa05af6675c0f$var$randomBytes;

});
parcelRegister("6wP5S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("aFeN5", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $98BOh = parcelRequire("98BOh");

var $l0YXc = parcelRequire("l0YXc");

var $eJ6Uk = parcelRequire("eJ6Uk");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
var $7c3934d94a6a1848$var$_u64_js_1_default_split = (0, $5OlIx._)($l0YXc.default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
].map(function(n) {
    return BigInt(n);
})), 2), $7c3934d94a6a1848$var$SHA512_Kh = $7c3934d94a6a1848$var$_u64_js_1_default_split[0], $7c3934d94a6a1848$var$SHA512_Kl = $7c3934d94a6a1848$var$_u64_js_1_default_split[1];
// Temporary buffer, not used to store anything between runs
var $7c3934d94a6a1848$var$SHA512_W_H = new Uint32Array(80);
var $7c3934d94a6a1848$var$SHA512_W_L = new Uint32Array(80);
var $7c3934d94a6a1848$var$SHA512 = /*#__PURE__*/ function(_sha2_js_1_SHA2) {
    (0, $cgJ2Y._)(SHA512, _sha2_js_1_SHA2);
    var _super = (0, $hKD8n._)(SHA512);
    function SHA512() {
        (0, $7dKN1._)(this, SHA512);
        var _this;
        _this = _super.call(this, 128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 1779033703;
        _this.Al = -205731576;
        _this.Bh = -1150833019;
        _this.Bl = -2067093701;
        _this.Ch = 1013904242;
        _this.Cl = -23791573;
        _this.Dh = -1521486534;
        _this.Dl = 1595750129;
        _this.Eh = 1359893119;
        _this.El = -1377402159;
        _this.Fh = -1694144372;
        _this.Fl = 725511199;
        _this.Gh = 528734635;
        _this.Gl = -79577749;
        _this.Hh = 1541459225;
        _this.Hl = 327033209;
        return _this;
    }
    (0, $eW5pA._)(SHA512, [
        {
            // prettier-ignore
            key: "get",
            value: function get() {
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                return [
                    Ah,
                    Al,
                    Bh,
                    Bl,
                    Ch,
                    Cl,
                    Dh,
                    Dl,
                    Eh,
                    El,
                    Fh,
                    Fl,
                    Gh,
                    Gl,
                    Hh,
                    Hl
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
                this.Ah = Ah | 0;
                this.Al = Al | 0;
                this.Bh = Bh | 0;
                this.Bl = Bl | 0;
                this.Ch = Ch | 0;
                this.Cl = Cl | 0;
                this.Dh = Dh | 0;
                this.Dl = Dl | 0;
                this.Eh = Eh | 0;
                this.El = El | 0;
                this.Fh = Fh | 0;
                this.Fl = Fl | 0;
                this.Gh = Gh | 0;
                this.Gl = Gl | 0;
                this.Hh = Hh | 0;
                this.Hl = Hl | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4){
                    $7c3934d94a6a1848$var$SHA512_W_H[i] = view.getUint32(offset);
                    $7c3934d94a6a1848$var$SHA512_W_L[i] = view.getUint32(offset += 4);
                }
                for(var i1 = 16; i1 < 80; i1++){
                    // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
                    var W15h = $7c3934d94a6a1848$var$SHA512_W_H[i1 - 15] | 0;
                    var W15l = $7c3934d94a6a1848$var$SHA512_W_L[i1 - 15] | 0;
                    var s0h = $l0YXc.default.rotrSH(W15h, W15l, 1) ^ $l0YXc.default.rotrSH(W15h, W15l, 8) ^ $l0YXc.default.shrSH(W15h, W15l, 7);
                    var s0l = $l0YXc.default.rotrSL(W15h, W15l, 1) ^ $l0YXc.default.rotrSL(W15h, W15l, 8) ^ $l0YXc.default.shrSL(W15h, W15l, 7);
                    // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
                    var W2h = $7c3934d94a6a1848$var$SHA512_W_H[i1 - 2] | 0;
                    var W2l = $7c3934d94a6a1848$var$SHA512_W_L[i1 - 2] | 0;
                    var s1h = $l0YXc.default.rotrSH(W2h, W2l, 19) ^ $l0YXc.default.rotrBH(W2h, W2l, 61) ^ $l0YXc.default.shrSH(W2h, W2l, 6);
                    var s1l = $l0YXc.default.rotrSL(W2h, W2l, 19) ^ $l0YXc.default.rotrBL(W2h, W2l, 61) ^ $l0YXc.default.shrSL(W2h, W2l, 6);
                    // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
                    var SUMl = $l0YXc.default.add4L(s0l, s1l, $7c3934d94a6a1848$var$SHA512_W_L[i1 - 7], $7c3934d94a6a1848$var$SHA512_W_L[i1 - 16]);
                    var SUMh = $l0YXc.default.add4H(SUMl, s0h, s1h, $7c3934d94a6a1848$var$SHA512_W_H[i1 - 7], $7c3934d94a6a1848$var$SHA512_W_H[i1 - 16]);
                    $7c3934d94a6a1848$var$SHA512_W_H[i1] = SUMh | 0;
                    $7c3934d94a6a1848$var$SHA512_W_L[i1] = SUMl | 0;
                }
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                // Compression function main loop, 80 rounds
                for(var i2 = 0; i2 < 80; i2++){
                    // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
                    var sigma1h = $l0YXc.default.rotrSH(Eh, El, 14) ^ $l0YXc.default.rotrSH(Eh, El, 18) ^ $l0YXc.default.rotrBH(Eh, El, 41);
                    var sigma1l = $l0YXc.default.rotrSL(Eh, El, 14) ^ $l0YXc.default.rotrSL(Eh, El, 18) ^ $l0YXc.default.rotrBL(Eh, El, 41);
                    //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
                    var CHIh = Eh & Fh ^ ~Eh & Gh;
                    var CHIl = El & Fl ^ ~El & Gl;
                    // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
                    // prettier-ignore
                    var T1ll = $l0YXc.default.add5L(Hl, sigma1l, CHIl, $7c3934d94a6a1848$var$SHA512_Kl[i2], $7c3934d94a6a1848$var$SHA512_W_L[i2]);
                    var T1h = $l0YXc.default.add5H(T1ll, Hh, sigma1h, CHIh, $7c3934d94a6a1848$var$SHA512_Kh[i2], $7c3934d94a6a1848$var$SHA512_W_H[i2]);
                    var T1l = T1ll | 0;
                    // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
                    var sigma0h = $l0YXc.default.rotrSH(Ah, Al, 28) ^ $l0YXc.default.rotrBH(Ah, Al, 34) ^ $l0YXc.default.rotrBH(Ah, Al, 39);
                    var sigma0l = $l0YXc.default.rotrSL(Ah, Al, 28) ^ $l0YXc.default.rotrBL(Ah, Al, 34) ^ $l0YXc.default.rotrBL(Ah, Al, 39);
                    var MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
                    var MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
                    Hh = Gh | 0;
                    Hl = Gl | 0;
                    Gh = Fh | 0;
                    Gl = Fl | 0;
                    Fh = Eh | 0;
                    Fl = El | 0;
                    var ref;
                    ref = $l0YXc.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0), Eh = ref.h, El = ref.l, ref;
                    Dh = Ch | 0;
                    Dl = Cl | 0;
                    Ch = Bh | 0;
                    Cl = Bl | 0;
                    Bh = Ah | 0;
                    Bl = Al | 0;
                    var All = $l0YXc.default.add3L(T1l, sigma0l, MAJl);
                    Ah = $l0YXc.default.add3H(All, T1h, sigma0h, MAJh);
                    Al = All | 0;
                }
                var ref1;
                // Add the compressed chunk to the current hash value
                ref1 = $l0YXc.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0), Ah = ref1.h, Al = ref1.l, ref1;
                var ref2;
                ref2 = $l0YXc.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0), Bh = ref2.h, Bl = ref2.l, ref2;
                var ref3;
                ref3 = $l0YXc.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0), Ch = ref3.h, Cl = ref3.l, ref3;
                var ref4;
                ref4 = $l0YXc.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0), Dh = ref4.h, Dl = ref4.l, ref4;
                var ref5;
                ref5 = $l0YXc.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0), Eh = ref5.h, El = ref5.l, ref5;
                var ref6;
                ref6 = $l0YXc.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0), Fh = ref6.h, Fl = ref6.l, ref6;
                var ref7;
                ref7 = $l0YXc.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0), Gh = ref7.h, Gl = ref7.l, ref7;
                var ref8;
                ref8 = $l0YXc.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0), Hh = ref8.h, Hl = ref8.l, ref8;
                this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $7c3934d94a6a1848$var$SHA512_W_H.fill(0);
                $7c3934d94a6a1848$var$SHA512_W_L.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
        }
    ]);
    return SHA512;
}($98BOh.SHA2);
module.exports.SHA512 = $7c3934d94a6a1848$var$SHA512;
var $7c3934d94a6a1848$var$SHA512_224 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA512_224, SHA512);
    var _super = (0, $hKD8n._)(SHA512_224);
    function SHA512_224() {
        (0, $7dKN1._)(this, SHA512_224);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -1942145080;
        _this.Al = 424955298;
        _this.Bh = 1944164710;
        _this.Bl = -1982016298;
        _this.Ch = 502970286;
        _this.Cl = 855612546;
        _this.Dh = 1738396948;
        _this.Dl = 1479516111;
        _this.Eh = 258812777;
        _this.El = 2077511080;
        _this.Fh = 2011393907;
        _this.Fl = 79989058;
        _this.Gh = 1067287976;
        _this.Gl = 1780299464;
        _this.Hh = 286451373;
        _this.Hl = -1848208735;
        _this.outputLen = 28;
        return _this;
    }
    return SHA512_224;
}($7c3934d94a6a1848$var$SHA512);
var $7c3934d94a6a1848$var$SHA512_256 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA512_256, SHA512);
    var _super = (0, $hKD8n._)(SHA512_256);
    function SHA512_256() {
        (0, $7dKN1._)(this, SHA512_256);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 573645204;
        _this.Al = -64227540;
        _this.Bh = -1621794909;
        _this.Bl = -934517566;
        _this.Ch = 596883563;
        _this.Cl = 1867755857;
        _this.Dh = -1774684391;
        _this.Dl = 1497426621;
        _this.Eh = -1775747358;
        _this.El = -1467023389;
        _this.Fh = -1101128155;
        _this.Fl = 1401305490;
        _this.Gh = 721525244;
        _this.Gl = 746961066;
        _this.Hh = 246885852;
        _this.Hl = -2117784414;
        _this.outputLen = 32;
        return _this;
    }
    return SHA512_256;
}($7c3934d94a6a1848$var$SHA512);
var $7c3934d94a6a1848$var$SHA384 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA384, SHA512);
    var _super = (0, $hKD8n._)(SHA384);
    function SHA384() {
        (0, $7dKN1._)(this, SHA384);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -876896931;
        _this.Al = -1056596264;
        _this.Bh = 1654270250;
        _this.Bl = 914150663;
        _this.Ch = -1856437926;
        _this.Cl = 812702999;
        _this.Dh = 355462360;
        _this.Dl = -150054599;
        _this.Eh = 1731405415;
        _this.El = -4191439;
        _this.Fh = -1900787065;
        _this.Fl = 1750603025;
        _this.Gh = -619958771;
        _this.Gl = 1694076839;
        _this.Hh = 1203062813;
        _this.Hl = -1090891868;
        _this.outputLen = 48;
        return _this;
    }
    return SHA384;
}($7c3934d94a6a1848$var$SHA512);
module.exports.sha512 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $7c3934d94a6a1848$var$SHA512();
});
module.exports.sha512_224 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $7c3934d94a6a1848$var$SHA512_224();
});
module.exports.sha512_256 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $7c3934d94a6a1848$var$SHA512_256();
});
module.exports.sha384 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $7c3934d94a6a1848$var$SHA384();
});

});
parcelRegister("5OlIx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $43b277e30ec9692d$export$71511d61b312f219; });

var $5oE3w = parcelRequire("5oE3w");

var $12u3w = parcelRequire("12u3w");

var $kT97Q = parcelRequire("kT97Q");

var $iJGZg = parcelRequire("iJGZg");
function $43b277e30ec9692d$export$71511d61b312f219(arr, i) {
    return (0, $5oE3w._)(arr) || (0, $12u3w._)(arr, i) || (0, $iJGZg._)(arr, i) || (0, $kT97Q._)();
}

});
parcelRegister("5oE3w", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3ede43e715757a1b$export$71511d61b312f219; });
function $3ede43e715757a1b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("12u3w", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0c1d4ad0d1cee854$export$71511d61b312f219; });
function $0c1d4ad0d1cee854$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("kT97Q", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f35005daba77ce0a$export$71511d61b312f219; });
function $f35005daba77ce0a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("98BOh", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $kaKuv = parcelRequire("kaKuv");

var $eJ6Uk = parcelRequire("eJ6Uk");
// Polyfill for Safari 14
function $6a7230b3ab3fe2c0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number(value >> _32n & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
var $6a7230b3ab3fe2c0$var$SHA2 = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(SHA2, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(SHA2);
    function SHA2(blockLen, outputLen, padOffset, isLE) {
        (0, $7dKN1._)(this, SHA2);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, $eJ6Uk.createView)(_this.buffer);
        return _this;
    }
    (0, $eW5pA._)(SHA2, [
        {
            key: "update",
            value: function update(data) {
                $kaKuv.default.exists(this);
                var _this = this, view = _this.view, buffer = _this.buffer, blockLen = _this.blockLen;
                data = (0, $eJ6Uk.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    // Fast path: we have at least one block in input, cast it to view and process
                    if (take === blockLen) {
                        var dataView = (0, $eJ6Uk.createView)(data);
                        for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    pos += take;
                    if (this.pos === blockLen) {
                        this.process(view, 0);
                        this.pos = 0;
                    }
                }
                this.length += data.length;
                this.roundClean();
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                $kaKuv.default.exists(this);
                $kaKuv.default.output(out, this);
                this.finished = true;
                // Padding
                // We can avoid allocation of buffer for padding completely if it
                // was previously not allocated here. But it won't change performance.
                var _this = this, buffer = _this.buffer, view = _this.view, blockLen = _this.blockLen, isLE = _this.isLE;
                var pos = this.pos;
                // append the bit '1' to the message
                buffer[pos++] = 128;
                this.buffer.subarray(pos).fill(0);
                // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
                if (this.padOffset > blockLen - pos) {
                    this.process(view, 0);
                    pos = 0;
                }
                // Pad until full block byte with zeros
                for(var i = pos; i < blockLen; i++)buffer[i] = 0;
                // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
                // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
                // So we just write lowest 64 bits of that value.
                $6a7230b3ab3fe2c0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
                this.process(view, 0);
                var oview = (0, $eJ6Uk.createView)(out);
                var len = this.outputLen;
                // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
                if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                var outLen = len / 4;
                var state = this.get();
                if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
                for(var i1 = 0; i1 < outLen; i1++)oview.setUint32(4 * i1, state[i1], isLE);
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                to || (to = new this.constructor());
                (_to = to).set.apply(_to, (0, $gF0bR._)(this.get()));
                var _this = this, blockLen = _this.blockLen, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, pos = _this.pos;
                to.length = length;
                to.pos = pos;
                to.finished = finished;
                to.destroyed = destroyed;
                if (length % blockLen) to.buffer.set(buffer);
                return to;
            }
        }
    ]);
    return SHA2;
}($eJ6Uk.Hash);
module.exports.SHA2 = $6a7230b3ab3fe2c0$var$SHA2;

});

parcelRegister("l0YXc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
var $f4c8e13ccef94236$var$U32_MASK64 = BigInt(Math.pow(2, 32) - 1);
var $f4c8e13ccef94236$var$_32n = BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $f4c8e13ccef94236$var$fromBig(n) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (le) return {
        h: Number(n & $f4c8e13ccef94236$var$U32_MASK64),
        l: Number(n >> $f4c8e13ccef94236$var$_32n & $f4c8e13ccef94236$var$U32_MASK64)
    };
    return {
        h: Number(n >> $f4c8e13ccef94236$var$_32n & $f4c8e13ccef94236$var$U32_MASK64) | 0,
        l: Number(n & $f4c8e13ccef94236$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $f4c8e13ccef94236$var$fromBig;
function $f4c8e13ccef94236$var$split(lst) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for(var i = 0; i < lst.length; i++){
        var _fromBig = $f4c8e13ccef94236$var$fromBig(lst[i], le), h = _fromBig.h, l = _fromBig.l;
        var ref;
        ref = [
            h,
            l
        ], Ah[i] = ref[0], Al[i] = ref[1], ref;
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $f4c8e13ccef94236$var$split;
var $f4c8e13ccef94236$var$toBig = function(h, l) {
    return BigInt(h >>> 0) << $f4c8e13ccef94236$var$_32n | BigInt(l >>> 0);
};
module.exports.toBig = $f4c8e13ccef94236$var$toBig;
// for Shift in [0, 32)
var $f4c8e13ccef94236$var$shrSH = function(h, l, s) {
    return h >>> s;
};
var $f4c8e13ccef94236$var$shrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in [1, 32)
var $f4c8e13ccef94236$var$rotrSH = function(h, l, s) {
    return h >>> s | l << 32 - s;
};
var $f4c8e13ccef94236$var$rotrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var $f4c8e13ccef94236$var$rotrBH = function(h, l, s) {
    return h << 64 - s | l >>> s - 32;
};
var $f4c8e13ccef94236$var$rotrBL = function(h, l, s) {
    return h >>> s - 32 | l << 64 - s;
};
// Right rotate for shift===32 (just swaps l&h)
var $f4c8e13ccef94236$var$rotr32H = function(h, l) {
    return l;
};
var $f4c8e13ccef94236$var$rotr32L = function(h, l) {
    return h;
};
// Left rotate for Shift in [1, 32)
var $f4c8e13ccef94236$var$rotlSH = function(h, l, s) {
    return h << s | l >>> 32 - s;
};
var $f4c8e13ccef94236$var$rotlSL = function(h, l, s) {
    return l << s | h >>> 32 - s;
};
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var $f4c8e13ccef94236$var$rotlBH = function(h, l, s) {
    return l << s - 32 | h >>> 64 - s;
};
var $f4c8e13ccef94236$var$rotlBL = function(h, l, s) {
    return h << s - 32 | l >>> 64 - s;
};
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-
function $f4c8e13ccef94236$var$add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $f4c8e13ccef94236$var$add;
// Addition with more than 2 elements
var $f4c8e13ccef94236$var$add3L = function(Al, Bl, Cl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};
var $f4c8e13ccef94236$var$add3H = function(low, Ah, Bh, Ch) {
    return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};
var $f4c8e13ccef94236$var$add4L = function(Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
var $f4c8e13ccef94236$var$add4H = function(low, Ah, Bh, Ch, Dh) {
    return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};
var $f4c8e13ccef94236$var$add5L = function(Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
var $f4c8e13ccef94236$var$add5H = function(low, Ah, Bh, Ch, Dh, Eh) {
    return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};
// prettier-ignore
var $f4c8e13ccef94236$var$u64 = {
    fromBig: $f4c8e13ccef94236$var$fromBig,
    split: $f4c8e13ccef94236$var$split,
    toBig: module.exports.toBig,
    shrSH: $f4c8e13ccef94236$var$shrSH,
    shrSL: $f4c8e13ccef94236$var$shrSL,
    rotrSH: $f4c8e13ccef94236$var$rotrSH,
    rotrSL: $f4c8e13ccef94236$var$rotrSL,
    rotrBH: $f4c8e13ccef94236$var$rotrBH,
    rotrBL: $f4c8e13ccef94236$var$rotrBL,
    rotr32H: $f4c8e13ccef94236$var$rotr32H,
    rotr32L: $f4c8e13ccef94236$var$rotr32L,
    rotlSH: $f4c8e13ccef94236$var$rotlSH,
    rotlSL: $f4c8e13ccef94236$var$rotlSL,
    rotlBH: $f4c8e13ccef94236$var$rotlBH,
    rotlBL: $f4c8e13ccef94236$var$rotlBL,
    add: $f4c8e13ccef94236$var$add,
    add3L: $f4c8e13ccef94236$var$add3L,
    add3H: $f4c8e13ccef94236$var$add3H,
    add4L: $f4c8e13ccef94236$var$add4L,
    add4H: $f4c8e13ccef94236$var$add4H,
    add5H: $f4c8e13ccef94236$var$add5H,
    add5L: $f4c8e13ccef94236$var$add5L
};
module.exports.default = $f4c8e13ccef94236$var$u64;

});



parcelRegister("380Qt", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = void 0;

var $hqiua = parcelRequire("hqiua");

var $aFeN5 = parcelRequire("aFeN5");

var $b5yb1 = parcelRequire("b5yb1");
var $2472c653406a3a05$var$Sha256 = /*#__PURE__*/ function() {
    function Sha256(firstData) {
        (0, $7dKN1._)(this, Sha256);
        this.blockSize = 64;
        this.impl = $hqiua.sha256.create();
        if (firstData) this.update(firstData);
    }
    (0, $eW5pA._)(Sha256, [
        {
            key: "update",
            value: function update(data) {
                this.impl.update((0, $b5yb1.toRealUint8Array)(data));
                return this;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.impl.digest();
            }
        }
    ]);
    return Sha256;
}();
module.exports.Sha256 = $2472c653406a3a05$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $2472c653406a3a05$var$sha256(data) {
    return new $2472c653406a3a05$var$Sha256(data).digest();
}
module.exports.sha256 = $2472c653406a3a05$var$sha256;
var $2472c653406a3a05$var$Sha512 = /*#__PURE__*/ function() {
    function Sha512(firstData) {
        (0, $7dKN1._)(this, Sha512);
        this.blockSize = 128;
        this.impl = $aFeN5.sha512.create();
        if (firstData) this.update(firstData);
    }
    (0, $eW5pA._)(Sha512, [
        {
            key: "update",
            value: function update(data) {
                this.impl.update((0, $b5yb1.toRealUint8Array)(data));
                return this;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.impl.digest();
            }
        }
    ]);
    return Sha512;
}();
module.exports.Sha512 = $2472c653406a3a05$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $2472c653406a3a05$var$sha512(data) {
    return new $2472c653406a3a05$var$Sha512(data).digest();
}
module.exports.sha512 = $2472c653406a3a05$var$sha512;

});
parcelRegister("hqiua", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $98BOh = parcelRequire("98BOh");

var $eJ6Uk = parcelRequire("eJ6Uk");
// Choice: a ? b : c
var $caf3343c3af9e514$var$Chi = function(a, b, c) {
    return a & b ^ ~a & c;
};
// Majority function, true if any two inpust is true
var $caf3343c3af9e514$var$Maj = function(a, b, c) {
    return a & b ^ a & c ^ b & c;
};
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var $caf3343c3af9e514$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
var $caf3343c3af9e514$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var $caf3343c3af9e514$var$SHA256_W = new Uint32Array(64);
var $caf3343c3af9e514$var$SHA256 = /*#__PURE__*/ function(_sha2_js_1_SHA2) {
    (0, $cgJ2Y._)(SHA256, _sha2_js_1_SHA2);
    var _super = (0, $hKD8n._)(SHA256);
    function SHA256() {
        (0, $7dKN1._)(this, SHA256);
        var _this;
        _this = _super.call(this, 64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = $caf3343c3af9e514$var$IV[0] | 0;
        _this.B = $caf3343c3af9e514$var$IV[1] | 0;
        _this.C = $caf3343c3af9e514$var$IV[2] | 0;
        _this.D = $caf3343c3af9e514$var$IV[3] | 0;
        _this.E = $caf3343c3af9e514$var$IV[4] | 0;
        _this.F = $caf3343c3af9e514$var$IV[5] | 0;
        _this.G = $caf3343c3af9e514$var$IV[6] | 0;
        _this.H = $caf3343c3af9e514$var$IV[7] | 0;
        return _this;
    }
    (0, $eW5pA._)(SHA256, [
        {
            key: "get",
            value: function get() {
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                return [
                    A,
                    B,
                    C,
                    D,
                    E,
                    F,
                    G,
                    H
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(A, B, C, D, E, F, G, H) {
                this.A = A | 0;
                this.B = B | 0;
                this.C = C | 0;
                this.D = D | 0;
                this.E = E | 0;
                this.F = F | 0;
                this.G = G | 0;
                this.H = H | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4)$caf3343c3af9e514$var$SHA256_W[i] = view.getUint32(offset, false);
                for(var i1 = 16; i1 < 64; i1++){
                    var W15 = $caf3343c3af9e514$var$SHA256_W[i1 - 15];
                    var W2 = $caf3343c3af9e514$var$SHA256_W[i1 - 2];
                    var s0 = (0, $eJ6Uk.rotr)(W15, 7) ^ (0, $eJ6Uk.rotr)(W15, 18) ^ W15 >>> 3;
                    var s1 = (0, $eJ6Uk.rotr)(W2, 17) ^ (0, $eJ6Uk.rotr)(W2, 19) ^ W2 >>> 10;
                    $caf3343c3af9e514$var$SHA256_W[i1] = s1 + $caf3343c3af9e514$var$SHA256_W[i1 - 7] + s0 + $caf3343c3af9e514$var$SHA256_W[i1 - 16] | 0;
                }
                // Compression function main loop, 64 rounds
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                for(var i2 = 0; i2 < 64; i2++){
                    var sigma1 = (0, $eJ6Uk.rotr)(E, 6) ^ (0, $eJ6Uk.rotr)(E, 11) ^ (0, $eJ6Uk.rotr)(E, 25);
                    var T1 = H + sigma1 + $caf3343c3af9e514$var$Chi(E, F, G) + $caf3343c3af9e514$var$SHA256_K[i2] + $caf3343c3af9e514$var$SHA256_W[i2] | 0;
                    var sigma0 = (0, $eJ6Uk.rotr)(A, 2) ^ (0, $eJ6Uk.rotr)(A, 13) ^ (0, $eJ6Uk.rotr)(A, 22);
                    var T2 = sigma0 + $caf3343c3af9e514$var$Maj(A, B, C) | 0;
                    H = G;
                    G = F;
                    F = E;
                    E = D + T1 | 0;
                    D = C;
                    C = B;
                    B = A;
                    A = T1 + T2 | 0;
                }
                // Add the compressed chunk to the current hash value
                A = A + this.A | 0;
                B = B + this.B | 0;
                C = C + this.C | 0;
                D = D + this.D | 0;
                E = E + this.E | 0;
                F = F + this.F | 0;
                G = G + this.G | 0;
                H = H + this.H | 0;
                this.set(A, B, C, D, E, F, G, H);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $caf3343c3af9e514$var$SHA256_W.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.set(0, 0, 0, 0, 0, 0, 0, 0);
                this.buffer.fill(0);
            }
        }
    ]);
    return SHA256;
}($98BOh.SHA2);
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var $caf3343c3af9e514$var$SHA224 = /*#__PURE__*/ function(SHA256) {
    (0, $cgJ2Y._)(SHA224, SHA256);
    var _super = (0, $hKD8n._)(SHA224);
    function SHA224() {
        (0, $7dKN1._)(this, SHA224);
        var _this;
        _this = _super.call(this);
        _this.A = -1056596264;
        _this.B = 914150663;
        _this.C = 812702999;
        _this.D = -150054599;
        _this.E = -4191439;
        _this.F = 1750603025;
        _this.G = 1694076839;
        _this.H = -1090891868;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}($caf3343c3af9e514$var$SHA256);
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $caf3343c3af9e514$var$SHA256();
});
module.exports.sha224 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $caf3343c3af9e514$var$SHA224();
});

});

parcelRegister("b5yb1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function $812aac1d4de24b79$var$toRealUint8Array(data) {
    if (data instanceof Uint8Array) return data;
    else return Uint8Array.from(data);
}
module.exports.toRealUint8Array = $812aac1d4de24b79$var$toRealUint8Array;

});



parcelRegister("e4tLI", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
var $a3e887d6d6230eb9$var$Hmac = /*#__PURE__*/ function() {
    function Hmac(hashFunctionConstructor, originalKey) {
        (0, $7dKN1._)(this, Hmac);
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        var blockSize = new hashFunctionConstructor().blockSize;
        this.hash = function(data) {
            return new hashFunctionConstructor().update(data).digest();
        };
        var key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            var zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array((0, $gF0bR._)(key).concat((0, $gF0bR._)(zeroPadding)));
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map(function(keyByte) {
            return keyByte ^ 0x5c;
        });
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map(function(keyByte) {
            return keyByte ^ 0x36;
        });
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    (0, $eW5pA._)(Hmac, [
        {
            key: "update",
            value: function update(data) {
                this.messageHasher.update(data);
                return this;
            }
        },
        {
            key: "digest",
            value: function digest() {
                var innerHash = this.messageHasher.digest();
                return this.hash(new Uint8Array((0, $gF0bR._)(this.oKeyPad).concat((0, $gF0bR._)(innerHash))));
            }
        }
    ]);
    return Hmac;
}();
module.exports.Hmac = $a3e887d6d6230eb9$var$Hmac;

});

parcelRegister("bgVZN", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

var $3b3yF = parcelRequire("3b3yF");

var $b5yb1 = parcelRequire("b5yb1");
var $834e2d0db6e327f6$var$Keccak256 = /*#__PURE__*/ function() {
    function Keccak256(firstData) {
        (0, $7dKN1._)(this, Keccak256);
        this.blockSize = 64;
        this.impl = $3b3yF.keccak_256.create();
        if (firstData) this.update(firstData);
    }
    (0, $eW5pA._)(Keccak256, [
        {
            key: "update",
            value: function update(data) {
                this.impl.update((0, $b5yb1.toRealUint8Array)(data));
                return this;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.impl.digest();
            }
        }
    ]);
    return Keccak256;
}();
module.exports.Keccak256 = $834e2d0db6e327f6$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $834e2d0db6e327f6$var$keccak256(data) {
    return new $834e2d0db6e327f6$var$Keccak256(data).digest();
}
module.exports.keccak256 = $834e2d0db6e327f6$var$keccak256;

});
parcelRegister("3b3yF", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $kaKuv = parcelRequire("kaKuv");

var $l0YXc = parcelRequire("l0YXc");

var $eJ6Uk = parcelRequire("eJ6Uk");
// Various per round constants calculations
var $250528c6d7008e13$var$SHA3_PI = [], $250528c6d7008e13$var$SHA3_ROTL = [], $250528c6d7008e13$var$_SHA3_IOTA = [];
var $250528c6d7008e13$var$_0n = BigInt(0);
var $250528c6d7008e13$var$_1n = BigInt(1);
var $250528c6d7008e13$var$_2n = BigInt(2);
var $250528c6d7008e13$var$_7n = BigInt(7);
var $250528c6d7008e13$var$_256n = BigInt(256);
var $250528c6d7008e13$var$_0x71n = BigInt(0x71);
for(var $250528c6d7008e13$var$round = 0, $250528c6d7008e13$var$R = $250528c6d7008e13$var$_1n, $250528c6d7008e13$var$x = 1, $250528c6d7008e13$var$y = 0; $250528c6d7008e13$var$round < 24; $250528c6d7008e13$var$round++){
    var $250528c6d7008e13$var$ref;
    // Pi
    $250528c6d7008e13$var$ref = [
        $250528c6d7008e13$var$y,
        (2 * $250528c6d7008e13$var$x + 3 * $250528c6d7008e13$var$y) % 5
    ], $250528c6d7008e13$var$x = $250528c6d7008e13$var$ref[0], $250528c6d7008e13$var$y = $250528c6d7008e13$var$ref[1], $250528c6d7008e13$var$ref;
    $250528c6d7008e13$var$SHA3_PI.push(2 * (5 * $250528c6d7008e13$var$y + $250528c6d7008e13$var$x));
    // Rotational
    $250528c6d7008e13$var$SHA3_ROTL.push(($250528c6d7008e13$var$round + 1) * ($250528c6d7008e13$var$round + 2) / 2 % 64);
    // Iota
    var $250528c6d7008e13$var$t = $250528c6d7008e13$var$_0n;
    for(var $250528c6d7008e13$var$j = 0; $250528c6d7008e13$var$j < 7; $250528c6d7008e13$var$j++){
        $250528c6d7008e13$var$R = ($250528c6d7008e13$var$R << $250528c6d7008e13$var$_1n ^ ($250528c6d7008e13$var$R >> $250528c6d7008e13$var$_7n) * $250528c6d7008e13$var$_0x71n) % $250528c6d7008e13$var$_256n;
        if ($250528c6d7008e13$var$R & $250528c6d7008e13$var$_2n) $250528c6d7008e13$var$t ^= $250528c6d7008e13$var$_1n << ($250528c6d7008e13$var$_1n << BigInt($250528c6d7008e13$var$j)) - $250528c6d7008e13$var$_1n;
    }
    $250528c6d7008e13$var$_SHA3_IOTA.push($250528c6d7008e13$var$t);
}
var $250528c6d7008e13$var$_u64_js_1_default_split = (0, $5OlIx._)($l0YXc.default.split($250528c6d7008e13$var$_SHA3_IOTA, true), 2), $250528c6d7008e13$var$SHA3_IOTA_H = $250528c6d7008e13$var$_u64_js_1_default_split[0], $250528c6d7008e13$var$SHA3_IOTA_L = $250528c6d7008e13$var$_u64_js_1_default_split[1];
// Left rotation (without 0, 32, 64)
var $250528c6d7008e13$var$rotlH = function(h, l, s) {
    return s > 32 ? $l0YXc.default.rotlBH(h, l, s) : $l0YXc.default.rotlSH(h, l, s);
};
var $250528c6d7008e13$var$rotlL = function(h, l, s) {
    return s > 32 ? $l0YXc.default.rotlBL(h, l, s) : $l0YXc.default.rotlSL(h, l, s);
};
// Same as keccakf1600, but allows to skip some rounds
function $250528c6d7008e13$var$keccakP(s) {
    var rounds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(var round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(var x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(var x1 = 0; x1 < 10; x1 += 2){
            var idx1 = (x1 + 8) % 10;
            var idx0 = (x1 + 2) % 10;
            var B0 = B[idx0];
            var B1 = B[idx0 + 1];
            var Th = $250528c6d7008e13$var$rotlH(B0, B1, 1) ^ B[idx1];
            var Tl = $250528c6d7008e13$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(var y = 0; y < 50; y += 10){
                s[x1 + y] ^= Th;
                s[x1 + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        var curH = s[2];
        var curL = s[3];
        for(var t = 0; t < 24; t++){
            var shift = $250528c6d7008e13$var$SHA3_ROTL[t];
            var Th1 = $250528c6d7008e13$var$rotlH(curH, curL, shift);
            var Tl1 = $250528c6d7008e13$var$rotlL(curH, curL, shift);
            var PI = $250528c6d7008e13$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th1;
            s[PI + 1] = Tl1;
        }
        // Chi (χ)
        for(var y1 = 0; y1 < 50; y1 += 10){
            for(var x2 = 0; x2 < 10; x2++)B[x2] = s[y1 + x2];
            for(var x3 = 0; x3 < 10; x3++)s[y1 + x3] ^= ~B[(x3 + 2) % 10] & B[(x3 + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $250528c6d7008e13$var$SHA3_IOTA_H[round];
        s[1] ^= $250528c6d7008e13$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $250528c6d7008e13$var$keccakP;
var $250528c6d7008e13$var$Keccak = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(Keccak, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(Keccak);
    function Keccak(blockLen, suffix, outputLen) {
        var enableXOF = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, rounds = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 24;
        (0, $7dKN1._)(this, Keccak);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.suffix = suffix;
        _this.outputLen = outputLen;
        _this.enableXOF = enableXOF;
        _this.rounds = rounds;
        _this.pos = 0;
        _this.posOut = 0;
        _this.finished = false;
        _this.destroyed = false;
        // Can be passed from user as dkLen
        $kaKuv.default.number(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= _this.blockLen || _this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        _this.state = new Uint8Array(200);
        _this.state32 = (0, $eJ6Uk.u32)(_this.state);
        return _this;
    }
    (0, $eW5pA._)(Keccak, [
        {
            key: "keccak",
            value: function keccak() {
                $250528c6d7008e13$var$keccakP(this.state32, this.rounds);
                this.posOut = 0;
                this.pos = 0;
            }
        },
        {
            key: "update",
            value: function update(data) {
                $kaKuv.default.exists(this);
                var _this = this, blockLen = _this.blockLen, state = _this.state;
                data = (0, $eJ6Uk.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    for(var i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
                    if (this.pos === blockLen) this.keccak();
                }
                return this;
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.finished) return;
                this.finished = true;
                var _this = this, state = _this.state, suffix = _this.suffix, pos = _this.pos, blockLen = _this.blockLen;
                // Do the padding
                state[pos] ^= suffix;
                if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
                state[blockLen - 1] ^= 0x80;
                this.keccak();
            }
        },
        {
            key: "writeInto",
            value: function writeInto(out) {
                $kaKuv.default.exists(this, false);
                $kaKuv.default.bytes(out);
                this.finish();
                var bufferOut = this.state;
                var blockLen = this.blockLen;
                for(var pos = 0, len = out.length; pos < len;){
                    if (this.posOut >= blockLen) this.keccak();
                    var take = Math.min(blockLen - this.posOut, len - pos);
                    out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
                    this.posOut += take;
                    pos += take;
                }
                return out;
            }
        },
        {
            key: "xofInto",
            value: function xofInto(out) {
                // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
                if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                return this.writeInto(out);
            }
        },
        {
            key: "xof",
            value: function xof(bytes) {
                $kaKuv.default.number(bytes);
                return this.xofInto(new Uint8Array(bytes));
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                $kaKuv.default.output(out, this);
                if (this.finished) throw new Error("digest() was already called");
                this.writeInto(out);
                this.destroy();
                return out;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.digestInto(new Uint8Array(this.outputLen));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.state.fill(0);
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _this = this, blockLen = _this.blockLen, suffix = _this.suffix, outputLen = _this.outputLen, rounds = _this.rounds, enableXOF = _this.enableXOF;
                to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
                to.state32.set(this.state32);
                to.pos = this.pos;
                to.posOut = this.posOut;
                to.finished = this.finished;
                to.rounds = rounds;
                // Suffix can change in cSHAKE
                to.suffix = suffix;
                to.outputLen = outputLen;
                to.enableXOF = enableXOF;
                to.destroyed = this.destroyed;
                return to;
            }
        }
    ]);
    return Keccak;
}($eJ6Uk.Hash);
module.exports.Keccak = $250528c6d7008e13$var$Keccak;
var $250528c6d7008e13$var$gen = function(suffix, blockLen, outputLen) {
    return (0, $eJ6Uk.wrapConstructor)(function() {
        return new $250528c6d7008e13$var$Keccak(blockLen, suffix, outputLen);
    });
};
module.exports.sha3_224 = $250528c6d7008e13$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $250528c6d7008e13$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $250528c6d7008e13$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $250528c6d7008e13$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $250528c6d7008e13$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $250528c6d7008e13$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $250528c6d7008e13$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $250528c6d7008e13$var$gen(0x01, 72, 64);
var $250528c6d7008e13$var$genShake = function(suffix, blockLen, outputLen) {
    return (0, $eJ6Uk.wrapXOFConstructorWithOpts)(function() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new $250528c6d7008e13$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true);
    });
};
module.exports.shake128 = $250528c6d7008e13$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $250528c6d7008e13$var$genShake(0x1f, 136, 32);

});


parcelRegister("jrVM7", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $e28d5ae13f33c7ef$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $gMk5u = parcelRequire("gMk5u");

// Using crypto_pwhash requires sumo. Once we migrate to a standalone
// Argon2 implementation, we can use the normal libsodium-wrappers
// again: https://github.com/cosmos/cosmjs/issues/1031
var $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1 = $e28d5ae13f33c7ef$var$__importDefault((parcelRequire("ikOdQ")));
function $e28d5ae13f33c7ef$var$isArgon2idOptions(thing) {
    if (!(0, $gMk5u.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $e28d5ae13f33c7ef$var$isArgon2idOptions;
var $e28d5ae13f33c7ef$var$Argon2id = /*#__PURE__*/ function() {
    function Argon2id() {
        (0, $7dKN1._)(this, Argon2id);
    }
    (0, $eW5pA._)(Argon2id, null, [
        {
            key: "execute",
            value: function execute(password, salt, options) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.ready
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Argon2id;
}();
module.exports.Argon2id = $e28d5ae13f33c7ef$var$Argon2id;
var $e28d5ae13f33c7ef$var$Ed25519Keypair = /*#__PURE__*/ function() {
    function Ed25519Keypair(privkey, pubkey) {
        (0, $7dKN1._)(this, Ed25519Keypair);
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    (0, $eW5pA._)(Ed25519Keypair, [
        {
            key: "toLibsodiumPrivkey",
            value: function toLibsodiumPrivkey() {
                return new Uint8Array((0, $gF0bR._)(this.privkey).concat((0, $gF0bR._)(this.pubkey)));
            }
        }
    ], [
        {
            key: "fromLibsodiumPrivkey",
            value: // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
            function fromLibsodiumPrivkey(libsodiumPrivkey) {
                if (libsodiumPrivkey.length !== 64) throw new Error("Unexpected key length ".concat(libsodiumPrivkey.length, ". Must be 64."));
                return new Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
            }
        }
    ]);
    return Ed25519Keypair;
}();
module.exports.Ed25519Keypair = $e28d5ae13f33c7ef$var$Ed25519Keypair;
var $e28d5ae13f33c7ef$var$Ed25519 = /*#__PURE__*/ function() {
    function Ed25519() {
        (0, $7dKN1._)(this, Ed25519);
    }
    (0, $eW5pA._)(Ed25519, null, [
        {
            key: "makeKeypair",
            value: /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ function makeKeypair(seed) {
                return (0, $6rBFC._)(function() {
                    var keypair;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.ready
                                ];
                            case 1:
                                _state.sent();
                                keypair = $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(seed);
                                return [
                                    2,
                                    $e28d5ae13f33c7ef$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createSignature",
            value: function createSignature(message, keyPair) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.ready
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifySignature",
            value: function verifySignature(signature, message, pubkey) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.ready
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(signature, message, pubkey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Ed25519;
}();
module.exports.Ed25519 = $e28d5ae13f33c7ef$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
var $e28d5ae13f33c7ef$var$Xchacha20poly1305Ietf = /*#__PURE__*/ function() {
    function Xchacha20poly1305Ietf() {
        (0, $7dKN1._)(this, Xchacha20poly1305Ietf);
    }
    (0, $eW5pA._)(Xchacha20poly1305Ietf, null, [
        {
            key: "encrypt",
            value: function encrypt(message, key, nonce) {
                return (0, $6rBFC._)(function() {
                    var additionalData;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.ready
                                ];
                            case 1:
                                _state.sent();
                                additionalData = null;
                                return [
                                    2,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "decrypt",
            value: function decrypt(ciphertext, key, nonce) {
                return (0, $6rBFC._)(function() {
                    var additionalData;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.ready
                                ];
                            case 1:
                                _state.sent();
                                additionalData = null;
                                return [
                                    2,
                                    $e28d5ae13f33c7ef$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Xchacha20poly1305Ietf;
}();
module.exports.Xchacha20poly1305Ietf = $e28d5ae13f33c7ef$var$Xchacha20poly1305Ietf;

});

parcelRegister("b8Qwm", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

var $81c92ea1c41eb48b$var$Random = /*#__PURE__*/ function() {
    function Random() {
        (0, $7dKN1._)(this, Random);
    }
    (0, $eW5pA._)(Random, null, [
        {
            key: "getBytes",
            value: /**
     * Returns `count` cryptographically secure random bytes
     */ function getBytes(count) {
                try {
                    var globalObject = typeof window === "object" ? window : self;
                    var cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
                    var out = new Uint8Array(count);
                    cryptoApi.getRandomValues(out);
                    return out;
                } catch (e) {
                    try {
                        // eslint-disable-next-line @typescript-eslint/no-var-requires
                        var crypto = (parcelRequire("5xFHp"));
                        return new Uint8Array((0, $gF0bR._)(crypto.randomBytes(count)));
                    } catch (e) {
                        throw new Error("No secure random number generator found");
                    }
                }
            }
        }
    ]);
    return Random;
}();
module.exports.Random = $81c92ea1c41eb48b$var$Random;

});

parcelRegister("dJoXC", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

var $loZR7 = parcelRequire("loZR7");

var $b5yb1 = parcelRequire("b5yb1");
var $9ff2d701ffe3f51e$var$Ripemd160 = /*#__PURE__*/ function() {
    function Ripemd160(firstData) {
        (0, $7dKN1._)(this, Ripemd160);
        this.blockSize = 64;
        this.impl = $loZR7.ripemd160.create();
        if (firstData) this.update(firstData);
    }
    (0, $eW5pA._)(Ripemd160, [
        {
            key: "update",
            value: function update(data) {
                this.impl.update((0, $b5yb1.toRealUint8Array)(data));
                return this;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.impl.digest();
            }
        }
    ]);
    return Ripemd160;
}();
module.exports.Ripemd160 = $9ff2d701ffe3f51e$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $9ff2d701ffe3f51e$var$ripemd160(data) {
    return new $9ff2d701ffe3f51e$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $9ff2d701ffe3f51e$var$ripemd160;

});
parcelRegister("loZR7", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $98BOh = parcelRequire("98BOh");

var $eJ6Uk = parcelRequire("eJ6Uk");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
var $04055a1956d9ca0b$var$Rho = new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
var $04055a1956d9ca0b$var$Id = Uint8Array.from({
    length: 16
}, function(_, i) {
    return i;
});
var $04055a1956d9ca0b$var$Pi = $04055a1956d9ca0b$var$Id.map(function(i) {
    return (9 * i + 5) % 16;
});
var $04055a1956d9ca0b$var$idxL = [
    $04055a1956d9ca0b$var$Id
];
var $04055a1956d9ca0b$var$idxR = [
    $04055a1956d9ca0b$var$Pi
];
for(var $04055a1956d9ca0b$var$i = 0; $04055a1956d9ca0b$var$i < 4; $04055a1956d9ca0b$var$i++)for(var $04055a1956d9ca0b$var$_i = 0, $04055a1956d9ca0b$var$_iter = [
    $04055a1956d9ca0b$var$idxL,
    $04055a1956d9ca0b$var$idxR
]; $04055a1956d9ca0b$var$_i < $04055a1956d9ca0b$var$_iter.length; $04055a1956d9ca0b$var$_i++){
    var $04055a1956d9ca0b$var$j = $04055a1956d9ca0b$var$_iter[$04055a1956d9ca0b$var$_i];
    $04055a1956d9ca0b$var$j.push($04055a1956d9ca0b$var$j[$04055a1956d9ca0b$var$i].map(function(k) {
        return $04055a1956d9ca0b$var$Rho[k];
    }));
}
var $04055a1956d9ca0b$var$shifts = [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map(function(i) {
    return new Uint8Array(i);
});
var $04055a1956d9ca0b$var$shiftsL = $04055a1956d9ca0b$var$idxL.map(function(idx, i) {
    return idx.map(function(j) {
        return $04055a1956d9ca0b$var$shifts[i][j];
    });
});
var $04055a1956d9ca0b$var$shiftsR = $04055a1956d9ca0b$var$idxR.map(function(idx, i) {
    return idx.map(function(j) {
        return $04055a1956d9ca0b$var$shifts[i][j];
    });
});
var $04055a1956d9ca0b$var$Kl = new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
var $04055a1956d9ca0b$var$Kr = new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
var $04055a1956d9ca0b$var$rotl = function(word, shift) {
    return word << shift | word >>> 32 - shift;
};
// It's called f() in spec.
function $04055a1956d9ca0b$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
var $04055a1956d9ca0b$var$BUF = new Uint32Array(16);
var $04055a1956d9ca0b$var$RIPEMD160 = /*#__PURE__*/ function(_sha2_js_1_SHA2) {
    (0, $cgJ2Y._)(RIPEMD160, _sha2_js_1_SHA2);
    var _super = (0, $hKD8n._)(RIPEMD160);
    function RIPEMD160() {
        (0, $7dKN1._)(this, RIPEMD160);
        var _this;
        _this = _super.call(this, 64, 20, 8, true);
        _this.h0 = 1732584193;
        _this.h1 = -271733879;
        _this.h2 = -1732584194;
        _this.h3 = 271733878;
        _this.h4 = -1009589776;
        return _this;
    }
    (0, $eW5pA._)(RIPEMD160, [
        {
            key: "get",
            value: function get() {
                var _this = this, h0 = _this.h0, h1 = _this.h1, h2 = _this.h2, h3 = _this.h3, h4 = _this.h4;
                return [
                    h0,
                    h1,
                    h2,
                    h3,
                    h4
                ];
            }
        },
        {
            key: "set",
            value: function set(h0, h1, h2, h3, h4) {
                this.h0 = h0 | 0;
                this.h1 = h1 | 0;
                this.h2 = h2 | 0;
                this.h3 = h3 | 0;
                this.h4 = h4 | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                for(var i = 0; i < 16; i++, offset += 4)$04055a1956d9ca0b$var$BUF[i] = view.getUint32(offset, true);
                // prettier-ignore
                var al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
                // Instead of iterating 0 to 80, we split it into 5 groups
                // And use the groups in constants, functions, etc. Much simpler
                for(var group = 0; group < 5; group++){
                    var rGroup = 4 - group;
                    var hbl = $04055a1956d9ca0b$var$Kl[group], hbr = $04055a1956d9ca0b$var$Kr[group]; // prettier-ignore
                    var rl = $04055a1956d9ca0b$var$idxL[group], rr = $04055a1956d9ca0b$var$idxR[group]; // prettier-ignore
                    var sl = $04055a1956d9ca0b$var$shiftsL[group], sr = $04055a1956d9ca0b$var$shiftsR[group]; // prettier-ignore
                    for(var i1 = 0; i1 < 16; i1++){
                        var tl = $04055a1956d9ca0b$var$rotl(al + $04055a1956d9ca0b$var$f(group, bl, cl, dl) + $04055a1956d9ca0b$var$BUF[rl[i1]] + hbl, sl[i1]) + el | 0;
                        al = el, el = dl, dl = $04055a1956d9ca0b$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
                    }
                    // 2 loops are 10% faster
                    for(var i2 = 0; i2 < 16; i2++){
                        var tr = $04055a1956d9ca0b$var$rotl(ar + $04055a1956d9ca0b$var$f(rGroup, br, cr, dr) + $04055a1956d9ca0b$var$BUF[rr[i2]] + hbr, sr[i2]) + er | 0;
                        ar = er, er = dr, dr = $04055a1956d9ca0b$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
                    }
                }
                // Add the compressed chunk to the current hash value
                this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $04055a1956d9ca0b$var$BUF.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0);
            }
        }
    ]);
    return RIPEMD160;
}($98BOh.SHA2);
module.exports.RIPEMD160 = $04055a1956d9ca0b$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $eJ6Uk.wrapConstructor)(function() {
    return new $04055a1956d9ca0b$var$RIPEMD160();
});

});


parcelRegister("1Mxbk", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $14c403577e42d01f$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $14c403577e42d01f$var$bn_js_1 = $14c403577e42d01f$var$__importDefault((parcelRequire("iGt81")));

var $14c403577e42d01f$var$elliptic_1 = $14c403577e42d01f$var$__importDefault((parcelRequire("aW3Sp")));

var $7TimK = parcelRequire("7TimK");
var $14c403577e42d01f$var$secp256k1 = new $14c403577e42d01f$var$elliptic_1.default.ec("secp256k1");
var $14c403577e42d01f$var$secp256k1N = new $14c403577e42d01f$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
var $14c403577e42d01f$var$Secp256k1 = /*#__PURE__*/ function() {
    function Secp256k1() {
        (0, $7dKN1._)(this, Secp256k1);
    }
    (0, $eW5pA._)(Secp256k1, null, [
        {
            key: "makeKeypair",
            value: /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */ function makeKeypair(privkey) {
                return (0, $6rBFC._)(function() {
                    var keypair, privkeyAsBigInteger, out;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
                        // https://github.com/bitjson/bitcoin-ts/issues/4
                        throw new Error("input data is not a valid secp256k1 private key");
                        keypair = $14c403577e42d01f$var$secp256k1.keyFromPrivate(privkey);
                        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
                        // range test that is not part of the elliptic implementation
                        privkeyAsBigInteger = new $14c403577e42d01f$var$bn_js_1.default(privkey);
                        if (privkeyAsBigInteger.gte($14c403577e42d01f$var$secp256k1N)) // not strictly smaller than N
                        throw new Error("input data is not a valid secp256k1 private key");
                        out = {
                            privkey: (0, $lSA9E.fromHex)(keypair.getPrivate("hex")),
                            // encodes uncompressed as
                            // - 1-byte prefix "04"
                            // - 32-byte x coordinate
                            // - 32-byte y coordinate
                            pubkey: Uint8Array.from(keypair.getPublic("array"))
                        };
                        return [
                            2,
                            out
                        ];
                    });
                })();
            }
        },
        {
            key: "createSignature",
            value: /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */ function createSignature(messageHash, privkey) {
                return (0, $6rBFC._)(function() {
                    var keypair, _keypair_sign, r, s, recoveryParam;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
                        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
                        keypair = $14c403577e42d01f$var$secp256k1.keyFromPrivate(privkey);
                        // the `canonical` option ensures creation of lowS signature representations
                        _keypair_sign = keypair.sign(messageHash, {
                            canonical: true
                        }), r = _keypair_sign.r, s = _keypair_sign.s, recoveryParam = _keypair_sign.recoveryParam;
                        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
                        return [
                            2,
                            new $7TimK.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam)
                        ];
                    });
                })();
            }
        },
        {
            key: "verifySignature",
            value: function verifySignature(signature, messageHash, pubkey) {
                return (0, $6rBFC._)(function() {
                    var keypair;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
                        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
                        keypair = $14c403577e42d01f$var$secp256k1.keyFromPublic(pubkey);
                        // From https://github.com/indutny/elliptic:
                        //
                        //     Sign the message's hash (input must be an array, or a hex-string)
                        //
                        //     Signature MUST be either:
                        //     1) DER-encoded signature as hex-string; or
                        //     2) DER-encoded signature as buffer; or
                        //     3) object with two hex-string properties (r and s); or
                        //     4) object with two buffer properties (r and s)
                        //
                        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
                        // common to both types. Uint8Array is not an array of ints but the interface is
                        // similar
                        try {
                            return [
                                2,
                                keypair.verify(messageHash, signature.toDer())
                            ];
                        } catch (error) {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "recoverPubkey",
            value: function recoverPubkey(signature, messageHash) {
                var signatureForElliptic = {
                    r: (0, $lSA9E.toHex)(signature.r()),
                    s: (0, $lSA9E.toHex)(signature.s())
                };
                var point = $14c403577e42d01f$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
                var keypair = $14c403577e42d01f$var$secp256k1.keyFromPublic(point);
                return (0, $lSA9E.fromHex)(keypair.getPublic(false, "hex"));
            }
        },
        {
            key: "compressPubkey",
            value: /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */ function compressPubkey(pubkey) {
                switch(pubkey.length){
                    case 33:
                        return pubkey;
                    case 65:
                        return Uint8Array.from($14c403577e42d01f$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
                    default:
                        throw new Error("Invalid pubkey length");
                }
            }
        },
        {
            key: "uncompressPubkey",
            value: /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */ function uncompressPubkey(pubkey) {
                switch(pubkey.length){
                    case 33:
                        return Uint8Array.from($14c403577e42d01f$var$secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
                    case 65:
                        return pubkey;
                    default:
                        throw new Error("Invalid pubkey length");
                }
            }
        },
        {
            key: "trimRecoveryByte",
            value: function trimRecoveryByte(signature) {
                switch(signature.length){
                    case 64:
                        return signature;
                    case 65:
                        return signature.slice(0, 64);
                    default:
                        throw new Error("Invalid signature length");
                }
            }
        }
    ]);
    return Secp256k1;
}();
module.exports.Secp256k1 = $14c403577e42d01f$var$Secp256k1;

});
parcelRegister("7TimK", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $5bebea855f5cf50b$var$trimLeadingNullBytes(inData) {
    var numberOfLeadingNullBytes = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var byte = _step.value;
            if (byte === 0x00) numberOfLeadingNullBytes++;
            else break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return inData.slice(numberOfLeadingNullBytes);
}
var $5bebea855f5cf50b$var$derTagInteger = 0x02;
var $5bebea855f5cf50b$var$Secp256k1Signature = /*#__PURE__*/ function() {
    function Secp256k1Signature(r, s) {
        (0, $7dKN1._)(this, Secp256k1Signature);
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    (0, $eW5pA._)(Secp256k1Signature, [
        {
            key: "r",
            value: function r(length) {
                if (length === undefined) return this.data.r;
                else {
                    var paddingLength = length - this.data.r.length;
                    if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
                    var padding = new Uint8Array(paddingLength);
                    return new Uint8Array((0, $gF0bR._)(padding).concat((0, $gF0bR._)(this.data.r)));
                }
            }
        },
        {
            key: "s",
            value: function s(length) {
                if (length === undefined) return this.data.s;
                else {
                    var paddingLength = length - this.data.s.length;
                    if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
                    var padding = new Uint8Array(paddingLength);
                    return new Uint8Array((0, $gF0bR._)(padding).concat((0, $gF0bR._)(this.data.s)));
                }
            }
        },
        {
            key: "toFixedLength",
            value: function toFixedLength() {
                return new Uint8Array((0, $gF0bR._)(this.r(32)).concat((0, $gF0bR._)(this.s(32))));
            }
        },
        {
            key: "toDer",
            value: function toDer() {
                // DER supports negative integers but our data is unsigned. Thus we need to prepend
                // a leading 0 byte when the higest bit is set to differentiate nagative values
                var rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
                    0
                ].concat((0, $gF0bR._)(this.data.r))) : this.data.r;
                var sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
                    0
                ].concat((0, $gF0bR._)(this.data.s))) : this.data.s;
                var rLength = rEncoded.length;
                var sLength = sEncoded.length;
                var data = new Uint8Array([
                    $5bebea855f5cf50b$var$derTagInteger,
                    rLength
                ].concat((0, $gF0bR._)(rEncoded), [
                    $5bebea855f5cf50b$var$derTagInteger,
                    sLength
                ], (0, $gF0bR._)(sEncoded)));
                return new Uint8Array([
                    0x30,
                    data.length
                ].concat((0, $gF0bR._)(data)));
            }
        }
    ], [
        {
            key: "fromFixedLength",
            value: /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ function fromFixedLength(data) {
                if (data.length !== 64) throw new Error("Got invalid data length: ".concat(data.length, ". Expected 2x 32 bytes for the pair (r, s)"));
                return new Secp256k1Signature($5bebea855f5cf50b$var$trimLeadingNullBytes(data.slice(0, 32)), $5bebea855f5cf50b$var$trimLeadingNullBytes(data.slice(32, 64)));
            }
        },
        {
            key: "fromDer",
            value: function fromDer(data) {
                var pos = 0;
                if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
                var bodyLength = data[pos++];
                if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
                // r
                var rTag = data[pos++];
                if (rTag !== $5bebea855f5cf50b$var$derTagInteger) throw new Error("INTEGER tag expected");
                var rLength = data[pos++];
                if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
                var rData = data.slice(pos, pos + rLength);
                pos += rLength;
                // s
                var sTag = data[pos++];
                if (sTag !== $5bebea855f5cf50b$var$derTagInteger) throw new Error("INTEGER tag expected");
                var sLength = data[pos++];
                if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
                var sData = data.slice(pos, pos + sLength);
                pos += sLength;
                return new Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
                $5bebea855f5cf50b$var$trimLeadingNullBytes(rData), $5bebea855f5cf50b$var$trimLeadingNullBytes(sData));
            }
        }
    ]);
    return Secp256k1Signature;
}();
module.exports.Secp256k1Signature = $5bebea855f5cf50b$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ var $5bebea855f5cf50b$var$ExtendedSecp256k1Signature = /*#__PURE__*/ function(Secp256k1Signature) {
    (0, $cgJ2Y._)(ExtendedSecp256k1Signature, Secp256k1Signature);
    var _super = (0, $hKD8n._)(ExtendedSecp256k1Signature);
    function ExtendedSecp256k1Signature(r, s, recovery) {
        (0, $7dKN1._)(this, ExtendedSecp256k1Signature);
        var _this;
        _this = _super.call(this, r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        _this.recovery = recovery;
        return _this;
    }
    (0, $eW5pA._)(ExtendedSecp256k1Signature, [
        {
            /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ key: "toFixedLength",
            value: function toFixedLength() {
                return new Uint8Array((0, $gF0bR._)(this.r(32)).concat((0, $gF0bR._)(this.s(32)), [
                    this.recovery
                ]));
            }
        }
    ], [
        {
            key: "fromFixedLength",
            value: /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ function fromFixedLength(data) {
                if (data.length !== 65) throw new Error("Got invalid data length ".concat(data.length, ". Expected 32 + 32 + 1"));
                return new ExtendedSecp256k1Signature($5bebea855f5cf50b$var$trimLeadingNullBytes(data.slice(0, 32)), $5bebea855f5cf50b$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
            }
        }
    ]);
    return ExtendedSecp256k1Signature;
}($5bebea855f5cf50b$var$Secp256k1Signature);
module.exports.ExtendedSecp256k1Signature = $5bebea855f5cf50b$var$ExtendedSecp256k1Signature;

});


parcelRegister("fJaAw", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
var $b733458f2515d174$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");

var $b733458f2515d174$var$bn_js_1 = $b733458f2515d174$var$__importDefault((parcelRequire("iGt81")));

var $b733458f2515d174$var$elliptic_1 = $b733458f2515d174$var$__importDefault((parcelRequire("aW3Sp")));

var $e4tLI = parcelRequire("e4tLI");

var $380Qt = parcelRequire("380Qt");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $b733458f2515d174$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($b733458f2515d174$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $b733458f2515d174$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $b733458f2515d174$var$Slip10Curve.Ed25519:
            return $b733458f2515d174$var$Slip10Curve.Ed25519;
        case $b733458f2515d174$var$Slip10Curve.Secp256k1:
            return $b733458f2515d174$var$Slip10Curve.Secp256k1;
        default:
            throw new Error("Unknown curve string: '".concat(curveString, "'"));
    }
}
module.exports.slip10CurveFromString = $b733458f2515d174$var$slip10CurveFromString;
var $b733458f2515d174$var$Slip10RawIndex = /*#__PURE__*/ function(_math_1_Uint32) {
    (0, $cgJ2Y._)(Slip10RawIndex, _math_1_Uint32);
    var _super = (0, $hKD8n._)(Slip10RawIndex);
    function Slip10RawIndex() {
        (0, $7dKN1._)(this, Slip10RawIndex);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(Slip10RawIndex, [
        {
            key: "isHardened",
            value: function isHardened() {
                return this.data >= Math.pow(2, 31);
            }
        }
    ], [
        {
            key: "hardened",
            value: function hardened(hardenedIndex) {
                return new Slip10RawIndex(hardenedIndex + Math.pow(2, 31));
            }
        },
        {
            key: "normal",
            value: function normal(normalIndex) {
                return new Slip10RawIndex(normalIndex);
            }
        }
    ]);
    return Slip10RawIndex;
}($kTbgy.Uint32);
module.exports.Slip10RawIndex = $b733458f2515d174$var$Slip10RawIndex;
var $b733458f2515d174$var$secp256k1 = new $b733458f2515d174$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
var $b733458f2515d174$var$Slip10 = /*#__PURE__*/ function() {
    function Slip10() {
        (0, $7dKN1._)(this, Slip10);
    }
    (0, $eW5pA._)(Slip10, null, [
        {
            key: "derivePath",
            value: function derivePath(curve, seed, path) {
                var result = this.master(curve, seed);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var rawIndex = _step.value;
                        result = this.child(curve, result.privkey, result.chainCode, rawIndex);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "master",
            value: function master(curve, seed) {
                var i = new $e4tLI.Hmac($380Qt.Sha512, (0, $lSA9E.toAscii)(curve)).update(seed).digest();
                var il = i.slice(0, 32);
                var ir = i.slice(32, 64);
                if (curve !== $b733458f2515d174$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
                return {
                    chainCode: ir,
                    privkey: il
                };
            }
        },
        {
            key: "child",
            value: function child(curve, parentPrivkey, parentChainCode, rawIndex) {
                var i;
                if (rawIndex.isHardened()) {
                    var payload = new Uint8Array([
                        0x00
                    ].concat((0, $gF0bR._)(parentPrivkey), (0, $gF0bR._)(rawIndex.toBytesBigEndian())));
                    i = new $e4tLI.Hmac($380Qt.Sha512, parentChainCode).update(payload).digest();
                } else {
                    if (curve === $b733458f2515d174$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
                    else {
                        // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                        // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                        // where the functions point() and ser_p() are defined in BIP-0032
                        var data = new Uint8Array((0, $gF0bR._)(Slip10.serializedPoint(curve, new $b733458f2515d174$var$bn_js_1.default(parentPrivkey))).concat((0, $gF0bR._)(rawIndex.toBytesBigEndian())));
                        i = new $e4tLI.Hmac($380Qt.Sha512, parentChainCode).update(data).digest();
                    }
                }
                return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
            }
        },
        {
            key: "serializedPoint",
            value: /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ function serializedPoint(curve, p) {
                switch(curve){
                    case $b733458f2515d174$var$Slip10Curve.Secp256k1:
                        return (0, $lSA9E.fromHex)($b733458f2515d174$var$secp256k1.g.mul(p).encodeCompressed("hex"));
                    default:
                        throw new Error("curve not supported");
                }
            }
        },
        {
            key: "childImpl",
            value: function childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
                // step 2 (of the Private parent key → private child key algorithm)
                var il = i.slice(0, 32);
                var ir = i.slice(32, 64);
                // step 3
                var returnChainCode = ir;
                // step 4
                if (curve === $b733458f2515d174$var$Slip10Curve.Ed25519) return {
                    chainCode: returnChainCode,
                    privkey: il
                };
                // step 5
                var n = this.n(curve);
                var returnChildKeyAsNumber = new $b733458f2515d174$var$bn_js_1.default(il).add(new $b733458f2515d174$var$bn_js_1.default(parentPrivkey)).mod(n);
                var returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
                // step 6
                if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
                    var newI = new $e4tLI.Hmac($380Qt.Sha512, parentChainCode).update(new Uint8Array([
                        0x01
                    ].concat((0, $gF0bR._)(ir), (0, $gF0bR._)(rawIndex.toBytesBigEndian())))).digest();
                    return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
                }
                // step 7
                return {
                    chainCode: returnChainCode,
                    privkey: returnChildKey
                };
            }
        },
        {
            key: "isZero",
            value: function isZero(privkey) {
                return privkey.every(function(byte) {
                    return byte === 0;
                });
            }
        },
        {
            key: "isGteN",
            value: function isGteN(curve, privkey) {
                var keyAsNumber = new $b733458f2515d174$var$bn_js_1.default(privkey);
                return keyAsNumber.gte(this.n(curve));
            }
        },
        {
            key: "n",
            value: function n(curve) {
                switch(curve){
                    case $b733458f2515d174$var$Slip10Curve.Secp256k1:
                        return new $b733458f2515d174$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
                    default:
                        throw new Error("curve not supported");
                }
            }
        }
    ]);
    return Slip10;
}();
module.exports.Slip10 = $b733458f2515d174$var$Slip10;
function $b733458f2515d174$var$pathToString(path) {
    return path.reduce(function(current, component) {
        var componentString = component.isHardened() ? "".concat(component.toNumber() - Math.pow(2, 31), "'") : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $b733458f2515d174$var$pathToString;
function $b733458f2515d174$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    var rest = input.slice(1);
    var out = new Array();
    while(rest){
        var match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        var _match = (0, $5OlIx._)(match, 3), fullMatch = _match[0], numberString = _match[1], apostrophe = _match[2];
        var value = $kTbgy.Uint53.fromString(numberString).toNumber();
        if (value >= Math.pow(2, 31)) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($b733458f2515d174$var$Slip10RawIndex.hardened(value));
        else out.push($b733458f2515d174$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $b733458f2515d174$var$stringToPath;

});
parcelRegister("kTbgy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $8pPDx = parcelRequire("8pPDx");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function get() {
        return $8pPDx.Decimal;
    }
});

var $eVb8U = parcelRequire("eVb8U");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function get() {
        return $eVb8U.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function get() {
        return $eVb8U.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function get() {
        return $eVb8U.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function get() {
        return $eVb8U.Uint64;
    }
});

});
parcelRegister("8pPDx", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $6208b684fe153dd1$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

var $6208b684fe153dd1$var$bn_js_1 = $6208b684fe153dd1$var$__importDefault((parcelRequire("5g2av")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
var $6208b684fe153dd1$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ var $6208b684fe153dd1$var$Decimal = /*#__PURE__*/ function() {
    function Decimal(atomics, fractionalDigits) {
        (0, $7dKN1._)(this, Decimal);
        if (!atomics.match(/^[0-9]+$/)) throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
        this.data = {
            atomics: new $6208b684fe153dd1$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    (0, $eW5pA._)(Decimal, [
        {
            key: "atomics",
            get: function get() {
                return this.data.atomics.toString();
            }
        },
        {
            key: "fractionalDigits",
            get: function get() {
                return this.data.fractionalDigits;
            }
        },
        {
            /** Creates a new instance with the same value */ key: "clone",
            value: function clone() {
                return new Decimal(this.atomics, this.fractionalDigits);
            }
        },
        {
            /** Returns the greatest decimal <= this which has no fractional part (rounding down) */ key: "floor",
            value: function floor() {
                var factor = new $6208b684fe153dd1$var$bn_js_1.default(10).pow(new $6208b684fe153dd1$var$bn_js_1.default(this.data.fractionalDigits));
                var whole = this.data.atomics.div(factor);
                var fractional = this.data.atomics.mod(factor);
                if (fractional.isZero()) return this.clone();
                else return Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
            }
        },
        {
            /** Returns the smallest decimal >= this which has no fractional part (rounding up) */ key: "ceil",
            value: function ceil() {
                var factor = new $6208b684fe153dd1$var$bn_js_1.default(10).pow(new $6208b684fe153dd1$var$bn_js_1.default(this.data.fractionalDigits));
                var whole = this.data.atomics.div(factor);
                var fractional = this.data.atomics.mod(factor);
                if (fractional.isZero()) return this.clone();
                else return Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
            }
        },
        {
            key: "toString",
            value: function toString() {
                var factor = new $6208b684fe153dd1$var$bn_js_1.default(10).pow(new $6208b684fe153dd1$var$bn_js_1.default(this.data.fractionalDigits));
                var whole = this.data.atomics.div(factor);
                var fractional = this.data.atomics.mod(factor);
                if (fractional.isZero()) return whole.toString();
                else {
                    var fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
                    var trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
                    return "".concat(whole.toString(), ".").concat(trimmedFractionalPart);
                }
            }
        },
        {
            /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ key: "toFloatApproximation",
            value: function toFloatApproximation() {
                var out = Number(this.toString());
                if (Number.isNaN(out)) throw new Error("Conversion to number failed");
                return out;
            }
        },
        {
            /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ key: "plus",
            value: function plus(b) {
                if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
                var sum = this.data.atomics.add(new $6208b684fe153dd1$var$bn_js_1.default(b.atomics));
                return new Decimal(sum.toString(), this.fractionalDigits);
            }
        },
        {
            /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ key: "minus",
            value: function minus(b) {
                if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
                var difference = this.data.atomics.sub(new $6208b684fe153dd1$var$bn_js_1.default(b.atomics));
                if (difference.ltn(0)) throw new Error("Difference must not be negative");
                return new Decimal(difference.toString(), this.fractionalDigits);
            }
        },
        {
            /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ key: "multiply",
            value: function multiply(b) {
                var product = this.data.atomics.mul(new $6208b684fe153dd1$var$bn_js_1.default(b.toString()));
                return new Decimal(product.toString(), this.fractionalDigits);
            }
        },
        {
            key: "equals",
            value: function equals(b) {
                return Decimal.compare(this, b) === 0;
            }
        },
        {
            key: "isLessThan",
            value: function isLessThan(b) {
                return Decimal.compare(this, b) < 0;
            }
        },
        {
            key: "isLessThanOrEqual",
            value: function isLessThanOrEqual(b) {
                return Decimal.compare(this, b) <= 0;
            }
        },
        {
            key: "isGreaterThan",
            value: function isGreaterThan(b) {
                return Decimal.compare(this, b) > 0;
            }
        },
        {
            key: "isGreaterThanOrEqual",
            value: function isGreaterThanOrEqual(b) {
                return Decimal.compare(this, b) >= 0;
            }
        }
    ], [
        {
            key: "fromUserInput",
            value: function fromUserInput(input, fractionalDigits) {
                Decimal.verifyFractionalDigits(fractionalDigits);
                var badCharacter = input.match(/[^0-9.]/);
                if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                throw new Error("Invalid character at position ".concat(badCharacter.index + 1));
                var whole;
                var fractional;
                if (input === "") {
                    whole = "0";
                    fractional = "";
                } else if (input.search(/\./) === -1) {
                    // integer format, no separator
                    whole = input;
                    fractional = "";
                } else {
                    var parts = input.split(".");
                    switch(parts.length){
                        case 0:
                        case 1:
                            throw new Error("Fewer than two elements in split result. This must not happen here.");
                        case 2:
                            if (!parts[1]) throw new Error("Fractional part missing");
                            whole = parts[0];
                            fractional = parts[1].replace(/0+$/, "");
                            break;
                        default:
                            throw new Error("More than one separator found");
                    }
                }
                if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
                var quantity = "".concat(whole).concat(fractional.padEnd(fractionalDigits, "0"));
                return new Decimal(quantity, fractionalDigits);
            }
        },
        {
            key: "fromAtomics",
            value: function fromAtomics(atomics, fractionalDigits) {
                Decimal.verifyFractionalDigits(fractionalDigits);
                return new Decimal(atomics, fractionalDigits);
            }
        },
        {
            key: "zero",
            value: /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ function zero(fractionalDigits) {
                Decimal.verifyFractionalDigits(fractionalDigits);
                return new Decimal("0", fractionalDigits);
            }
        },
        {
            key: "one",
            value: /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ function one(fractionalDigits) {
                Decimal.verifyFractionalDigits(fractionalDigits);
                return new Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
            }
        },
        {
            key: "verifyFractionalDigits",
            value: function verifyFractionalDigits(fractionalDigits) {
                if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
                if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
                if (fractionalDigits > $6208b684fe153dd1$var$maxFractionalDigits) throw new Error("Fractional digits must not exceed ".concat($6208b684fe153dd1$var$maxFractionalDigits));
            }
        },
        {
            key: "compare",
            value: function compare(a, b) {
                if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
                return a.data.atomics.cmp(new $6208b684fe153dd1$var$bn_js_1.default(b.atomics));
            }
        }
    ]);
    return Decimal;
}();
module.exports.Decimal = $6208b684fe153dd1$var$Decimal;

});

parcelRegister("eVb8U", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $adcf084047f3041a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ var $adcf084047f3041a$var$bn_js_1 = $adcf084047f3041a$var$__importDefault((parcelRequire("5g2av")));
var $adcf084047f3041a$var$uint64MaxValue = new $adcf084047f3041a$var$bn_js_1.default("18446744073709551615", 10, "be");
var $adcf084047f3041a$var$Uint32 = /*#__PURE__*/ function() {
    function Uint32(input) {
        (0, $7dKN1._)(this, Uint32);
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    (0, $eW5pA._)(Uint32, [
        {
            key: "toBytesBigEndian",
            value: function toBytesBigEndian() {
                // Use division instead of shifting since bitwise operators are defined
                // on SIGNED int32 in JavaScript and we don't want to risk surprises
                return new Uint8Array([
                    Math.floor(this.data / Math.pow(2, 24)) & 0xff,
                    Math.floor(this.data / Math.pow(2, 16)) & 0xff,
                    Math.floor(this.data / 256) & 0xff,
                    Math.floor(this.data / 1) & 0xff
                ]);
            }
        },
        {
            key: "toBytesLittleEndian",
            value: function toBytesLittleEndian() {
                // Use division instead of shifting since bitwise operators are defined
                // on SIGNED int32 in JavaScript and we don't want to risk surprises
                return new Uint8Array([
                    Math.floor(this.data / 1) & 0xff,
                    Math.floor(this.data / 256) & 0xff,
                    Math.floor(this.data / Math.pow(2, 16)) & 0xff,
                    Math.floor(this.data / Math.pow(2, 24)) & 0xff
                ]);
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.data;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                return BigInt(this.toNumber());
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.data.toString();
            }
        }
    ], [
        {
            key: "fromBigEndianBytes",
            value: /** @deprecated use Uint32.fromBytes */ function fromBigEndianBytes(bytes) {
                return Uint32.fromBytes(bytes);
            }
        },
        {
            key: "fromBytes",
            value: /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ function fromBytes(bytes) {
                var endianess = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "be";
                if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
                for(var i = 0; i < bytes.length; ++i){
                    if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
                }
                var beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
                // Use mulitiplication instead of shifting since bitwise operators are defined
                // on SIGNED int32 in JavaScript and we don't want to risk surprises
                return new Uint32(beBytes[0] * Math.pow(2, 24) + beBytes[1] * Math.pow(2, 16) + beBytes[2] * 256 + beBytes[3]);
            }
        },
        {
            key: "fromString",
            value: function fromString(str) {
                if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
                return new Uint32(Number.parseInt(str, 10));
            }
        }
    ]);
    return Uint32;
}();
module.exports.Uint32 = $adcf084047f3041a$var$Uint32;
var $adcf084047f3041a$var$Int53 = /*#__PURE__*/ function() {
    function Int53(input) {
        (0, $7dKN1._)(this, Int53);
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    (0, $eW5pA._)(Int53, [
        {
            key: "toNumber",
            value: function toNumber() {
                return this.data;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                return BigInt(this.toNumber());
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.data.toString();
            }
        }
    ], [
        {
            key: "fromString",
            value: function fromString(str) {
                if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
                return new Int53(Number.parseInt(str, 10));
            }
        }
    ]);
    return Int53;
}();
module.exports.Int53 = $adcf084047f3041a$var$Int53;
var $adcf084047f3041a$var$Uint53 = /*#__PURE__*/ function() {
    function Uint53(input) {
        (0, $7dKN1._)(this, Uint53);
        var signed = new $adcf084047f3041a$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    (0, $eW5pA._)(Uint53, [
        {
            key: "toNumber",
            value: function toNumber() {
                return this.data.toNumber();
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                return BigInt(this.toNumber());
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.data.toString();
            }
        }
    ], [
        {
            key: "fromString",
            value: function fromString(str) {
                var signed = $adcf084047f3041a$var$Int53.fromString(str);
                return new Uint53(signed.toNumber());
            }
        }
    ]);
    return Uint53;
}();
module.exports.Uint53 = $adcf084047f3041a$var$Uint53;
var $adcf084047f3041a$var$Uint64 = /*#__PURE__*/ function() {
    function Uint64(data) {
        (0, $7dKN1._)(this, Uint64);
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($adcf084047f3041a$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    (0, $eW5pA._)(Uint64, [
        {
            key: "toBytesBigEndian",
            value: function toBytesBigEndian() {
                return Uint8Array.from(this.data.toArray("be", 8));
            }
        },
        {
            key: "toBytesLittleEndian",
            value: function toBytesLittleEndian() {
                return Uint8Array.from(this.data.toArray("le", 8));
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.data.toString(10);
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                return BigInt(this.toString());
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.data.toNumber();
            }
        }
    ], [
        {
            key: "fromBytesBigEndian",
            value: /** @deprecated use Uint64.fromBytes */ function fromBytesBigEndian(bytes) {
                return Uint64.fromBytes(bytes);
            }
        },
        {
            key: "fromBytes",
            value: /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ function fromBytes(bytes) {
                var endianess = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "be";
                if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
                for(var i = 0; i < bytes.length; ++i){
                    if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
                }
                var beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
                return new Uint64(new $adcf084047f3041a$var$bn_js_1.default(beBytes));
            }
        },
        {
            key: "fromString",
            value: function fromString(str) {
                if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
                return new Uint64(new $adcf084047f3041a$var$bn_js_1.default(str, 10, "be"));
            }
        },
        {
            key: "fromNumber",
            value: function fromNumber(input) {
                if (Number.isNaN(input)) throw new Error("Input is not a number");
                if (!Number.isInteger(input)) throw new Error("Input is not an integer");
                var bigint;
                try {
                    bigint = new $adcf084047f3041a$var$bn_js_1.default(input);
                } catch (e) {
                    throw new Error("Input is not a safe integer");
                }
                return new Uint64(bigint);
            }
        }
    ]);
    return Uint64;
}();
module.exports.Uint64 = $adcf084047f3041a$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
var $adcf084047f3041a$var$_int53Class = $adcf084047f3041a$var$Int53;
var $adcf084047f3041a$var$_uint53Class = $adcf084047f3041a$var$Uint53;
var $adcf084047f3041a$var$_uint32Class = $adcf084047f3041a$var$Uint32;
var $adcf084047f3041a$var$_uint64Class = $adcf084047f3041a$var$Uint64;

});




parcelRegister("7frLr", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $lSA9E = parcelRequire("lSA9E");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $546f788575109a04$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $546f788575109a04$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $546f788575109a04$var$assertBoolean(value) {
    $546f788575109a04$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $546f788575109a04$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $546f788575109a04$var$assertString(value) {
    $546f788575109a04$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $546f788575109a04$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $546f788575109a04$var$assertNumber(value) {
    $546f788575109a04$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $546f788575109a04$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $546f788575109a04$var$assertArray(value) {
    $546f788575109a04$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $546f788575109a04$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $546f788575109a04$var$assertObject(value) {
    $546f788575109a04$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $546f788575109a04$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $546f788575109a04$var$assertNotEmpty(value) {
    $546f788575109a04$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $546f788575109a04$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $546f788575109a04$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $546f788575109a04$var$may;
function $546f788575109a04$var$dictionaryToStringMap(obj) {
    var out = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = obj[key];
            if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
            out.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
module.exports.dictionaryToStringMap = $546f788575109a04$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $546f788575109a04$var$encodeString(s) {
    var utf8 = (0, $lSA9E.toUtf8)(s);
    return Uint8Array.from([
        utf8.length
    ].concat((0, $gF0bR._)(utf8)));
}
module.exports.encodeString = $546f788575109a04$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $546f788575109a04$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80
    ].concat((0, $gF0bR._)($546f788575109a04$var$encodeUvarint(n >> 7)))) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $546f788575109a04$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $546f788575109a04$var$encodeTime(time) {
    var milliseconds = time.getTime();
    var seconds = Math.floor(milliseconds / 1000);
    var secondsArray = seconds ? [
        0x08
    ].concat((0, $gF0bR._)($546f788575109a04$var$encodeUvarint(seconds))) : new Uint8Array();
    var nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    var nanosecondsArray = nanoseconds ? [
        0x10
    ].concat((0, $gF0bR._)($546f788575109a04$var$encodeUvarint(nanoseconds))) : new Uint8Array();
    return Uint8Array.from((0, $gF0bR._)(secondsArray).concat((0, $gF0bR._)(nanosecondsArray)));
}
module.exports.encodeTime = $546f788575109a04$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $546f788575109a04$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length
    ].concat((0, $gF0bR._)(bytes))) : new Uint8Array();
}
module.exports.encodeBytes = $546f788575109a04$var$encodeBytes;
function $546f788575109a04$var$encodeVersion(version) {
    var blockArray = version.block ? Uint8Array.from([
        0x08
    ].concat((0, $gF0bR._)($546f788575109a04$var$encodeUvarint(version.block)))) : new Uint8Array();
    var appArray = version.app ? Uint8Array.from([
        0x10
    ].concat((0, $gF0bR._)($546f788575109a04$var$encodeUvarint(version.app)))) : new Uint8Array();
    return Uint8Array.from((0, $gF0bR._)(blockArray).concat((0, $gF0bR._)(appArray)));
}
module.exports.encodeVersion = $546f788575109a04$var$encodeVersion;
function $546f788575109a04$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length
    ].concat((0, $gF0bR._)(blockId.hash), [
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length
    ], (0, $gF0bR._)(blockId.parts.hash)));
}
module.exports.encodeBlockId = $546f788575109a04$var$encodeBlockId;

});


parcelRegister("lzZvp", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $fb5c93914a8012ef$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb5c93914a8012ef$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fb5c93914a8012ef$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fb5c93914a8012ef$var$__createBinding(result, mod, k);
    }
    $fb5c93914a8012ef$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $g8v8F = parcelRequire("g8v8F");

var $5WHTi = parcelRequire("5WHTi");

var $7frLr = parcelRequire("7frLr");

var $fb5c93914a8012ef$var$requests = $fb5c93914a8012ef$var$__importStar((parcelRequire("9tkUv")));
function $fb5c93914a8012ef$var$encodeHeightParam(param) {
    return {
        height: (0, $7frLr.may)($g8v8F.smallIntToApi, param.height)
    };
}
function $fb5c93914a8012ef$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $7frLr.may)($g8v8F.smallIntToApi, param.minHeight),
        maxHeight: (0, $7frLr.may)($g8v8F.smallIntToApi, param.maxHeight)
    };
}
function $fb5c93914a8012ef$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $7frLr.may)($g8v8F.smallIntToApi, params.page),
        per_page: (0, $7frLr.may)($g8v8F.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $fb5c93914a8012ef$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $7frLr.assertNotEmpty)(params.path),
        data: (0, $lSA9E.toHex)(params.data),
        height: (0, $7frLr.may)($g8v8F.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $fb5c93914a8012ef$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $lSA9E.toBase64)((0, $7frLr.assertNotEmpty)(params.tx))
    };
}
function $fb5c93914a8012ef$var$encodeTxParams(params) {
    return {
        hash: (0, $lSA9E.toBase64)((0, $7frLr.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $fb5c93914a8012ef$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $7frLr.may)($g8v8F.smallIntToApi, params.page),
        per_page: (0, $7frLr.may)($g8v8F.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $fb5c93914a8012ef$var$encodeValidatorsParams(params) {
    return {
        height: (0, $7frLr.may)($g8v8F.smallIntToApi, params.height),
        page: (0, $7frLr.may)($g8v8F.smallIntToApi, params.page),
        per_page: (0, $7frLr.may)($g8v8F.smallIntToApi, params.per_page)
    };
}
var $fb5c93914a8012ef$var$Params = /*#__PURE__*/ function() {
    function Params() {
        (0, $7dKN1._)(this, Params);
    }
    (0, $eW5pA._)(Params, null, [
        {
            key: "encodeAbciInfo",
            value: function encodeAbciInfo(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeAbciQuery",
            value: function encodeAbciQuery(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeAbciQueryParams(req.params));
            }
        },
        {
            key: "encodeBlock",
            value: function encodeBlock(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeHeightParam(req.params));
            }
        },
        {
            key: "encodeBlockchain",
            value: function encodeBlockchain(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeBlockchainRequestParams(req.params));
            }
        },
        {
            key: "encodeBlockResults",
            value: function encodeBlockResults(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeHeightParam(req.params));
            }
        },
        {
            key: "encodeBlockSearch",
            value: function encodeBlockSearch(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeBlockSearchParams(req.params));
            }
        },
        {
            key: "encodeBroadcastTx",
            value: function encodeBroadcastTx(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeBroadcastTxParams(req.params));
            }
        },
        {
            key: "encodeCommit",
            value: function encodeCommit(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeHeightParam(req.params));
            }
        },
        {
            key: "encodeGenesis",
            value: function encodeGenesis(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeHealth",
            value: function encodeHealth(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeNumUnconfirmedTxs",
            value: function encodeNumUnconfirmedTxs(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeStatus",
            value: function encodeStatus(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeSubscribe",
            value: function encodeSubscribe(req) {
                var eventTag = {
                    key: "tm.event",
                    value: req.query.type
                };
                var query = $fb5c93914a8012ef$var$requests.buildQuery({
                    tags: [
                        eventTag
                    ],
                    raw: req.query.raw
                });
                return (0, $5WHTi.createJsonRpcRequest)("subscribe", {
                    query: query
                });
            }
        },
        {
            key: "encodeTx",
            value: function encodeTx(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeTxParams(req.params));
            }
        },
        {
            key: "encodeTxSearch",
            value: // TODO: encode params for query string???
            function encodeTxSearch(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeTxSearchParams(req.params));
            }
        },
        {
            key: "encodeValidators",
            value: function encodeValidators(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $fb5c93914a8012ef$var$encodeValidatorsParams(req.params));
            }
        }
    ]);
    return Params;
}();
module.exports.Params = $fb5c93914a8012ef$var$Params;

});
parcelRegister("g8v8F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smallIntToApi = module.exports.apiToBigInt = module.exports.apiToSmallInt = void 0;

var $kTbgy = parcelRequire("kTbgy");

var $7frLr = parcelRequire("7frLr");
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as number.
 *
 * Only works within the safe integer range.
 */ function $bbf58c3c7e08dedf$var$apiToSmallInt(input) {
    var asInt = typeof input === "number" ? new $kTbgy.Int53(input) : $kTbgy.Int53.fromString(input);
    return asInt.toNumber();
}
module.exports.apiToSmallInt = $bbf58c3c7e08dedf$var$apiToSmallInt;
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as BigInt.
 *
 * This supports the full uint64 and int64 ranges.
 */ function $bbf58c3c7e08dedf$var$apiToBigInt(input) {
    (0, $7frLr.assertString)(input); // Runtime check on top of TypeScript just to be safe for semi-trusted API types
    if (!input.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
    return BigInt(input);
}
module.exports.apiToBigInt = $bbf58c3c7e08dedf$var$apiToBigInt;
/**
 * Takes an integer in the safe integer range and returns
 * a string representation to be used in the Tendermint RPC API.
 */ function $bbf58c3c7e08dedf$var$smallIntToApi(num) {
    return new $kTbgy.Int53(num).toString();
}
module.exports.smallIntToApi = $bbf58c3c7e08dedf$var$smallIntToApi;

});


parcelRegister("8Xkjk", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $5OlIx = parcelRequire("5OlIx");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $gMk5u = parcelRequire("gMk5u");

var $bCIvL = parcelRequire("bCIvL");

var $g8v8F = parcelRequire("g8v8F");

var $3yHgT = parcelRequire("3yHgT");

var $7frLr = parcelRequire("7frLr");

var $hx5Va = parcelRequire("hx5Va");
function $685396babbe44893$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $7frLr.may)($g8v8F.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $7frLr.may)($lSA9E.fromBase64, data.last_block_app_hash)
    };
}
function $685396babbe44893$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map(function(op) {
            return {
                type: op.type,
                key: (0, $lSA9E.fromBase64)(op.key),
                data: (0, $lSA9E.fromBase64)(op.data)
            };
        })
    };
}
function $685396babbe44893$var$decodeAbciQuery(data) {
    var _data_key, _data_value, _data_codespace, _data_info;
    return {
        key: (0, $lSA9E.fromBase64)((0, $7frLr.assertString)((_data_key = data.key) !== null && _data_key !== void 0 ? _data_key : "")),
        value: (0, $lSA9E.fromBase64)((0, $7frLr.assertString)((_data_value = data.value) !== null && _data_value !== void 0 ? _data_value : "")),
        proof: (0, $7frLr.may)($685396babbe44893$var$decodeQueryProof, data.proofOps),
        height: (0, $7frLr.may)($g8v8F.apiToSmallInt, data.height),
        code: (0, $7frLr.may)($g8v8F.apiToSmallInt, data.code),
        codespace: (0, $7frLr.assertString)((_data_codespace = data.codespace) !== null && _data_codespace !== void 0 ? _data_codespace : ""),
        index: (0, $7frLr.may)($g8v8F.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $7frLr.assertString)((_data_info = data.info) !== null && _data_info !== void 0 ? _data_info : "")
    };
}
function $685396babbe44893$var$decodeAttribute(attribute) {
    var _attribute_value;
    return {
        key: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(attribute.key)),
        value: (0, $lSA9E.fromBase64)((0, $7frLr.assertString)((_attribute_value = attribute.value) !== null && _attribute_value !== void 0 ? _attribute_value : ""))
    };
}
function $685396babbe44893$var$decodeAttributes(attributes) {
    return (0, $7frLr.assertArray)(attributes).map($685396babbe44893$var$decodeAttribute);
}
function $685396babbe44893$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $685396babbe44893$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $685396babbe44893$var$decodeEvent;
function $685396babbe44893$var$decodeEvents(events) {
    return (0, $7frLr.assertArray)(events).map($685396babbe44893$var$decodeEvent);
}
function $685396babbe44893$var$decodeTxData(data) {
    var _data_code, _data_gas_wanted, _data_gas_used;
    return {
        code: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNumber)((_data_code = data.code) !== null && _data_code !== void 0 ? _data_code : 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $7frLr.may)($lSA9E.fromBase64, data.data),
        events: data.events ? $685396babbe44893$var$decodeEvents(data.events) : [],
        gasWanted: (0, $g8v8F.apiToSmallInt)((_data_gas_wanted = data.gas_wanted) !== null && _data_gas_wanted !== void 0 ? _data_gas_wanted : "0"),
        gasUsed: (0, $g8v8F.apiToSmallInt)((_data_gas_used = data.gas_used) !== null && _data_gas_used !== void 0 ? _data_gas_used : "0")
    };
}
function $685396babbe44893$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        var _Object_entries = (0, $5OlIx._)(Object.entries(data.Sum.value), 1), _Object_entries_ = (0, $5OlIx._)(_Object_entries[0], 2), algorithm = _Object_entries_[0], value = _Object_entries_[1];
        (0, $gMk5u.assert)(algorithm === "ed25519" || algorithm === "secp256k1", "unknown pubkey type: ".concat(algorithm));
        return {
            algorithm: algorithm,
            data: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(data.value))
            };
        default:
            throw new Error("unknown pubkey type: ".concat(data.type));
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $685396babbe44893$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.max_gas))
    };
}
function $685396babbe44893$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.max_age_duration))
    };
}
function $685396babbe44893$var$decodeConsensusParams(data) {
    return {
        block: $685396babbe44893$var$decodeBlockParams((0, $7frLr.assertObject)(data.block)),
        evidence: $685396babbe44893$var$decodeEvidenceParams((0, $7frLr.assertObject)(data.evidence))
    };
}
function $685396babbe44893$var$decodeValidatorUpdate(data) {
    var _data_power;
    return {
        pubkey: $685396babbe44893$var$decodePubkey((0, $7frLr.assertObject)(data.pub_key)),
        votingPower: (0, $g8v8F.apiToBigInt)((_data_power = data.power) !== null && _data_power !== void 0 ? _data_power : "0")
    };
}
module.exports.decodeValidatorUpdate = $685396babbe44893$var$decodeValidatorUpdate;
function $685396babbe44893$var$decodeBlockResults(data) {
    return {
        height: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($685396babbe44893$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($685396babbe44893$var$decodeValidatorUpdate),
        consensusUpdates: (0, $7frLr.may)($685396babbe44893$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $685396babbe44893$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $685396babbe44893$var$decodeEvents(data.end_block_events || [])
    };
}
function $685396babbe44893$var$decodeBlockId(data) {
    return {
        hash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $7frLr.assertNotEmpty)(data.parts.total),
            hash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $685396babbe44893$var$decodeBlockVersion(data) {
    var _data_app;
    return {
        block: (0, $g8v8F.apiToSmallInt)(data.block),
        app: (0, $g8v8F.apiToSmallInt)((_data_app = data.app) !== null && _data_app !== void 0 ? _data_app : 0)
    };
}
function $685396babbe44893$var$decodeHeader(data) {
    return {
        version: $685396babbe44893$var$decodeBlockVersion(data.version),
        chainId: (0, $7frLr.assertNotEmpty)(data.chain_id),
        height: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.height)),
        time: (0, $bCIvL.fromRfc3339WithNanoseconds)((0, $7frLr.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $685396babbe44893$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.last_commit_hash)),
        dataHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.data_hash)),
        validatorsHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.consensus_hash)),
        appHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.app_hash)),
        lastResultsHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.proposer_address))
    };
}
function $685396babbe44893$var$decodeBlockMeta(data) {
    return {
        blockId: $685396babbe44893$var$decodeBlockId(data.block_id),
        blockSize: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.block_size)),
        header: $685396babbe44893$var$decodeHeader(data.header),
        numTxs: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.num_txs))
    };
}
function $685396babbe44893$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $7frLr.assertArray)(data.block_metas).map($685396babbe44893$var$decodeBlockMeta)
    };
}
function $685396babbe44893$var$decodeBroadcastTxSync(data) {
    return (0, $gddcW._)((0, $4JCw4._)({}, $685396babbe44893$var$decodeTxData(data)), {
        hash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.hash))
    });
}
function $685396babbe44893$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $g8v8F.apiToSmallInt)(data.height),
        hash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.hash)),
        checkTx: $685396babbe44893$var$decodeTxData((0, $7frLr.assertObject)(data.check_tx)),
        deliverTx: (0, $7frLr.may)($685396babbe44893$var$decodeTxData, data.deliver_tx)
    };
}
function $685396babbe44893$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $gMk5u.assert)(blockIdFlag in $3yHgT.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $685396babbe44893$var$decodeOptionalTime(timestamp) {
    var nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $bCIvL.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $685396babbe44893$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $685396babbe44893$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $lSA9E.fromHex)(data.validator_address) : undefined,
        timestamp: $685396babbe44893$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $lSA9E.fromBase64)(data.signature) : undefined
    };
}
function $685396babbe44893$var$decodeCommit(data) {
    return {
        blockId: $685396babbe44893$var$decodeBlockId((0, $7frLr.assertObject)(data.block_id)),
        height: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.height)),
        round: (0, $g8v8F.apiToSmallInt)(data.round),
        signatures: (0, $7frLr.assertArray)(data.signatures).map($685396babbe44893$var$decodeCommitSignature)
    };
}
function $685396babbe44893$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $7frLr.assertBoolean)(data.canonical),
        header: $685396babbe44893$var$decodeHeader(data.signed_header.header),
        commit: $685396babbe44893$var$decodeCommit(data.signed_header.commit)
    };
}
function $685396babbe44893$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.address)),
        pubkey: $685396babbe44893$var$decodePubkey((0, $7frLr.assertObject)(data.pub_key)),
        votingPower: (0, $g8v8F.apiToBigInt)((0, $7frLr.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $685396babbe44893$var$decodeValidatorGenesis;
function $685396babbe44893$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $bCIvL.fromRfc3339WithNanoseconds)((0, $7frLr.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $7frLr.assertNotEmpty)(data.chain_id),
        consensusParams: $685396babbe44893$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $7frLr.assertArray)(data.validators).map($685396babbe44893$var$decodeValidatorGenesis) : [],
        appHash: (0, $lSA9E.fromHex)((0, $7frLr.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $685396babbe44893$var$decodeValidatorInfo(data) {
    return {
        pubkey: $685396babbe44893$var$decodePubkey((0, $7frLr.assertObject)(data.pub_key)),
        votingPower: (0, $g8v8F.apiToBigInt)((0, $7frLr.assertNotEmpty)(data.voting_power)),
        address: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $g8v8F.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $685396babbe44893$var$decodeValidatorInfo;
function $685396babbe44893$var$decodeNodeInfo(data) {
    return {
        id: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.id)),
        listenAddr: (0, $7frLr.assertNotEmpty)(data.listen_addr),
        network: (0, $7frLr.assertNotEmpty)(data.network),
        version: (0, $7frLr.assertString)(data.version),
        channels: (0, $7frLr.assertNotEmpty)(data.channels),
        moniker: (0, $7frLr.assertNotEmpty)(data.moniker),
        other: (0, $7frLr.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $685396babbe44893$var$decodeSyncInfo(data) {
    var earliestBlockHeight = data.earliest_block_height ? (0, $g8v8F.apiToSmallInt)(data.earliest_block_height) : undefined;
    var earliestBlockTime = data.earliest_block_time ? (0, $bCIvL.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $lSA9E.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $lSA9E.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: (earliestBlockTime === null || earliestBlockTime === void 0 ? void 0 : earliestBlockTime.getTime()) ? earliestBlockTime : undefined,
        latestBlockHash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $bCIvL.fromRfc3339WithNanoseconds)((0, $7frLr.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $7frLr.assertBoolean)(data.catching_up)
    };
}
function $685396babbe44893$var$decodeStatus(data) {
    return {
        nodeInfo: $685396babbe44893$var$decodeNodeInfo(data.node_info),
        syncInfo: $685396babbe44893$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $685396babbe44893$var$decodeValidatorInfo(data.validator_info)
    };
}
function $685396babbe44893$var$decodeTxProof(data) {
    return {
        data: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(data.data)),
        rootHash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.proof.total)),
            index: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $7frLr.assertArray)(data.proof.aunts).map($lSA9E.fromBase64)
        }
    };
}
function $685396babbe44893$var$decodeTxResponse(data) {
    return {
        tx: (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(data.tx)),
        result: $685396babbe44893$var$decodeTxData((0, $7frLr.assertObject)(data.tx_result)),
        height: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.height)),
        index: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNumber)(data.index)),
        hash: (0, $lSA9E.fromHex)((0, $7frLr.assertNotEmpty)(data.hash)),
        proof: (0, $7frLr.may)($685396babbe44893$var$decodeTxProof, data.proof)
    };
}
function $685396babbe44893$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.total_count)),
        txs: (0, $7frLr.assertArray)(data.txs).map($685396babbe44893$var$decodeTxResponse)
    };
}
function $685396babbe44893$var$decodeTxEvent(data) {
    var tx = (0, $lSA9E.fromBase64)((0, $7frLr.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $hx5Va.hashTx)(tx),
        result: $685396babbe44893$var$decodeTxData(data.result),
        height: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.height))
    };
}
function $685396babbe44893$var$decodeValidators(data) {
    return {
        blockHeight: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.block_height)),
        validators: (0, $7frLr.assertArray)(data.validators).map($685396babbe44893$var$decodeValidatorInfo),
        count: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.count)),
        total: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.total))
    };
}
function $685396babbe44893$var$decodeBlock(data) {
    var _data_evidence;
    var _data_evidence_evidence;
    return {
        header: $685396babbe44893$var$decodeHeader((0, $7frLr.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $685396babbe44893$var$decodeCommit((0, $7frLr.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $7frLr.assertArray)(data.data.txs).map($lSA9E.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: (_data_evidence_evidence = (_data_evidence = data.evidence) === null || _data_evidence === void 0 ? void 0 : _data_evidence.evidence) !== null && _data_evidence_evidence !== void 0 ? _data_evidence_evidence : []
    };
}
function $685396babbe44893$var$decodeBlockResponse(data) {
    return {
        blockId: $685396babbe44893$var$decodeBlockId(data.block_id),
        block: $685396babbe44893$var$decodeBlock(data.block)
    };
}
function $685396babbe44893$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.total_count)),
        blocks: (0, $7frLr.assertArray)(data.blocks).map($685396babbe44893$var$decodeBlockResponse)
    };
}
function $685396babbe44893$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.total)),
        totalBytes: (0, $g8v8F.apiToSmallInt)((0, $7frLr.assertNotEmpty)(data.total_bytes))
    };
}
var $685396babbe44893$var$Responses = /*#__PURE__*/ function() {
    function Responses() {
        (0, $7dKN1._)(this, Responses);
    }
    (0, $eW5pA._)(Responses, null, [
        {
            key: "decodeAbciInfo",
            value: function decodeAbciInfo1(response) {
                return $685396babbe44893$var$decodeAbciInfo((0, $7frLr.assertObject)(response.result.response));
            }
        },
        {
            key: "decodeAbciQuery",
            value: function decodeAbciQuery1(response) {
                return $685396babbe44893$var$decodeAbciQuery((0, $7frLr.assertObject)(response.result.response));
            }
        },
        {
            key: "decodeBlock",
            value: function decodeBlock(response) {
                return $685396babbe44893$var$decodeBlockResponse(response.result);
            }
        },
        {
            key: "decodeBlockResults",
            value: function decodeBlockResults1(response) {
                return $685396babbe44893$var$decodeBlockResults(response.result);
            }
        },
        {
            key: "decodeBlockSearch",
            value: function decodeBlockSearch1(response) {
                return $685396babbe44893$var$decodeBlockSearch(response.result);
            }
        },
        {
            key: "decodeBlockchain",
            value: function decodeBlockchain1(response) {
                return $685396babbe44893$var$decodeBlockchain(response.result);
            }
        },
        {
            key: "decodeBroadcastTxSync",
            value: function decodeBroadcastTxSync1(response) {
                return $685396babbe44893$var$decodeBroadcastTxSync(response.result);
            }
        },
        {
            key: "decodeBroadcastTxAsync",
            value: function decodeBroadcastTxAsync(response) {
                return Responses.decodeBroadcastTxSync(response);
            }
        },
        {
            key: "decodeBroadcastTxCommit",
            value: function decodeBroadcastTxCommit1(response) {
                return $685396babbe44893$var$decodeBroadcastTxCommit(response.result);
            }
        },
        {
            key: "decodeCommit",
            value: function decodeCommit(response) {
                return $685396babbe44893$var$decodeCommitResponse(response.result);
            }
        },
        {
            key: "decodeGenesis",
            value: function decodeGenesis1(response) {
                return $685396babbe44893$var$decodeGenesis((0, $7frLr.assertObject)(response.result.genesis));
            }
        },
        {
            key: "decodeHealth",
            value: function decodeHealth() {
                return null;
            }
        },
        {
            key: "decodeNumUnconfirmedTxs",
            value: function decodeNumUnconfirmedTxs1(response) {
                return $685396babbe44893$var$decodeNumUnconfirmedTxs(response.result);
            }
        },
        {
            key: "decodeStatus",
            value: function decodeStatus1(response) {
                return $685396babbe44893$var$decodeStatus(response.result);
            }
        },
        {
            key: "decodeNewBlockEvent",
            value: function decodeNewBlockEvent(event) {
                return $685396babbe44893$var$decodeBlock(event.data.value.block);
            }
        },
        {
            key: "decodeNewBlockHeaderEvent",
            value: function decodeNewBlockHeaderEvent(event) {
                return $685396babbe44893$var$decodeHeader(event.data.value.header);
            }
        },
        {
            key: "decodeTxEvent",
            value: function decodeTxEvent1(event) {
                return $685396babbe44893$var$decodeTxEvent(event.data.value.TxResult);
            }
        },
        {
            key: "decodeTx",
            value: function decodeTx(response) {
                return $685396babbe44893$var$decodeTxResponse(response.result);
            }
        },
        {
            key: "decodeTxSearch",
            value: function decodeTxSearch1(response) {
                return $685396babbe44893$var$decodeTxSearch(response.result);
            }
        },
        {
            key: "decodeValidators",
            value: function decodeValidators1(response) {
                return $685396babbe44893$var$decodeValidators(response.result);
            }
        }
    ]);
    return Responses;
}();
module.exports.Responses = $685396babbe44893$var$Responses;

});
parcelRegister("bCIvL", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTime = module.exports.toSeconds = module.exports.fromSeconds = module.exports.toRfc3339WithNanoseconds = module.exports.fromRfc3339WithNanoseconds = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");
function $8765c55c09b20e45$var$fromRfc3339WithNanoseconds(dateTimeString) {
    var out = (0, $lSA9E.fromRfc3339)(dateTimeString);
    var nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    var nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
module.exports.fromRfc3339WithNanoseconds = $8765c55c09b20e45$var$fromRfc3339WithNanoseconds;
function $8765c55c09b20e45$var$toRfc3339WithNanoseconds(dateTime) {
    var _dateTime_nanoseconds;
    var millisecondIso = dateTime.toISOString();
    var _dateTime_nanoseconds_toString;
    var nanoseconds = (_dateTime_nanoseconds_toString = (_dateTime_nanoseconds = dateTime.nanoseconds) === null || _dateTime_nanoseconds === void 0 ? void 0 : _dateTime_nanoseconds.toString()) !== null && _dateTime_nanoseconds_toString !== void 0 ? _dateTime_nanoseconds_toString : "";
    return "".concat(millisecondIso.slice(0, -1)).concat(nanoseconds.padStart(6, "0"), "Z");
}
module.exports.toRfc3339WithNanoseconds = $8765c55c09b20e45$var$toRfc3339WithNanoseconds;
function $8765c55c09b20e45$var$fromSeconds(seconds) {
    var nanos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var checkedNanos = new $kTbgy.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) throw new Error("Nano seconds must not exceed 999999999");
    var out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
module.exports.fromSeconds = $8765c55c09b20e45$var$fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */ function $8765c55c09b20e45$var$toSeconds(date) {
    var _date_nanoseconds;
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: date.getTime() % 1000 * 1000000 + ((_date_nanoseconds = date.nanoseconds) !== null && _date_nanoseconds !== void 0 ? _date_nanoseconds : 0)
    };
}
module.exports.toSeconds = $8765c55c09b20e45$var$toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */ var $8765c55c09b20e45$var$DateTime = /*#__PURE__*/ function() {
    function DateTime() {
        (0, $7dKN1._)(this, DateTime);
    }
    (0, $eW5pA._)(DateTime, null, [
        {
            key: "decode",
            value: /** @deprecated Use fromRfc3339WithNanoseconds instead */ function decode(dateTimeString) {
                return $8765c55c09b20e45$var$fromRfc3339WithNanoseconds(dateTimeString);
            }
        },
        {
            key: "encode",
            value: /** @deprecated Use toRfc3339WithNanoseconds instead */ function encode(dateTime) {
                return $8765c55c09b20e45$var$toRfc3339WithNanoseconds(dateTime);
            }
        }
    ]);
    return DateTime;
}();
module.exports.DateTime = $8765c55c09b20e45$var$DateTime;

});

parcelRegister("3yHgT", function(module, exports) {
"use strict";
// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockIdFlag = void 0;
var $29761ce7cdad47c1$var$BlockIdFlag;
(function(BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})($29761ce7cdad47c1$var$BlockIdFlag = module.exports.BlockIdFlag || (module.exports.BlockIdFlag = {}));

});





parcelRegister("dK1Ew", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint37 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $4QZMw = parcelRequire("4QZMw");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function get() {
        return $4QZMw.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function get() {
        return $4QZMw.SubscriptionEventType;
    }
});

var $30nmZ = parcelRequire("30nmZ");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function get() {
        return $30nmZ.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function get() {
        return $30nmZ.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function get() {
        return $30nmZ.VoteType;
    }
});

var $idM1k = parcelRequire("idM1k");
Object.defineProperty(module.exports, "Tendermint37Client", {
    enumerable: true,
    get: function get() {
        return $idM1k.Tendermint37Client;
    }
});

});
parcelRegister("4QZMw", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $388bf14589b4bd5e$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($388bf14589b4bd5e$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $388bf14589b4bd5e$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($388bf14589b4bd5e$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $388bf14589b4bd5e$var$buildQuery(components) {
    var tags = components.tags ? components.tags : [];
    var tagComponents = tags.map(function(tag) {
        return "".concat(tag.key, "='").concat(tag.value, "'");
    });
    var rawComponents = components.raw ? [
        components.raw
    ] : [];
    return (0, $gF0bR._)(tagComponents).concat((0, $gF0bR._)(rawComponents)).join(" AND ");
}
module.exports.buildQuery = $388bf14589b4bd5e$var$buildQuery;

});

parcelRegister("30nmZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $23037ff236ed9bde$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $23037ff236ed9bde$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $23037ff236ed9bde$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $23037ff236ed9bde$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $23037ff236ed9bde$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($23037ff236ed9bde$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("idM1k", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $d43eb0babef69136$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d43eb0babef69136$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d43eb0babef69136$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d43eb0babef69136$var$__createBinding(result, mod, k);
    }
    $d43eb0babef69136$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = void 0;

var $5WHTi = parcelRequire("5WHTi");

var $1GCRg = parcelRequire("1GCRg");

var $aRytt = parcelRequire("aRytt");

var $d43eb0babef69136$var$requests = $d43eb0babef69136$var$__importStar((parcelRequire("4QZMw")));
var $d43eb0babef69136$var$Tendermint37Client = /*#__PURE__*/ function() {
    function Tendermint37Client(client) {
        (0, $7dKN1._)(this, Tendermint37Client);
        this.client = client;
        this.p = $aRytt.adaptor37.params;
        this.r = $aRytt.adaptor37.responses;
    }
    (0, $eW5pA._)(Tendermint37Client, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.client.disconnect();
            }
        },
        {
            key: "abciInfo",
            value: function abciInfo() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.AbciInfo
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeAbciInfo, _this.r.decodeAbciInfo)
                        ];
                    });
                })();
            }
        },
        {
            key: "abciQuery",
            value: function abciQuery(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $d43eb0babef69136$var$requests.Method.AbciQuery
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeAbciQuery, _this.r.decodeAbciQuery)
                        ];
                    });
                })();
            }
        },
        {
            key: "block",
            value: function block(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Block,
                            params: {
                                height: height
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBlock, _this.r.decodeBlock)
                        ];
                    });
                })();
            }
        },
        {
            key: "blockResults",
            value: function blockResults(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.BlockResults,
                            params: {
                                height: height
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBlockResults, _this.r.decodeBlockResults)
                        ];
                    });
                })();
            }
        },
        {
            key: "blockSearch",
            value: /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ function blockSearch(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query, resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                query = {
                                    params: params,
                                    method: $d43eb0babef69136$var$requests.Method.BlockSearch
                                };
                                return [
                                    4,
                                    _this.doCall(query, _this.p.encodeBlockSearch, _this.r.decodeBlockSearch)
                                ];
                            case 1:
                                resp = _state.sent();
                                return [
                                    2,
                                    (0, $gddcW._)((0, $4JCw4._)({}, resp), {
                                        // make sure we sort by height, as tendermint may be sorting by string value of the height
                                        blocks: (0, $gF0bR._)(resp.blocks).sort(function(a, b) {
                                            return a.block.header.height - b.block.header.height;
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "blockSearchAll",
            value: // this should paginate through all blockSearch options to ensure it returns all results.
            // starts with page 1 or whatever was provided (eg. to start on page 7)
            //
            // NOTE
            // This method will error on any node that is running a Tendermint version lower than 0.34.9.
            function blockSearchAll(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var page, blocks, done, _blocks, resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page = params.page || 1;
                                blocks = [];
                                done = false;
                                _state.label = 1;
                            case 1:
                                if (!!done) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.blockSearch((0, $gddcW._)((0, $4JCw4._)({}, params), {
                                        page: page
                                    }))
                                ];
                            case 2:
                                resp = _state.sent();
                                (_blocks = blocks).push.apply(_blocks, (0, $gF0bR._)(resp.blocks));
                                if (blocks.length < resp.totalCount) page++;
                                else done = true;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                // make sure we sort by height, as tendermint may be sorting by string value of the height
                                // and the earlier items may be in a higher page than the later items
                                blocks.sort(function(a, b) {
                                    return a.block.header.height - b.block.header.height;
                                });
                                return [
                                    2,
                                    {
                                        totalCount: blocks.length,
                                        blocks: blocks
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "blockchain",
            value: /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ function blockchain(minHeight, maxHeight) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Blockchain,
                            params: {
                                minHeight: minHeight,
                                maxHeight: maxHeight
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBlockchain, _this.r.decodeBlockchain)
                        ];
                    });
                })();
            }
        },
        {
            key: "broadcastTxSync",
            value: /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ function broadcastTxSync(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $d43eb0babef69136$var$requests.Method.BroadcastTxSync
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBroadcastTx, _this.r.decodeBroadcastTxSync)
                        ];
                    });
                })();
            }
        },
        {
            key: "broadcastTxAsync",
            value: /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ function broadcastTxAsync(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $d43eb0babef69136$var$requests.Method.BroadcastTxAsync
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBroadcastTx, _this.r.decodeBroadcastTxAsync)
                        ];
                    });
                })();
            }
        },
        {
            key: "broadcastTxCommit",
            value: /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ function broadcastTxCommit(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $d43eb0babef69136$var$requests.Method.BroadcastTxCommit
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeBroadcastTx, _this.r.decodeBroadcastTxCommit)
                        ];
                    });
                })();
            }
        },
        {
            key: "commit",
            value: function commit(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Commit,
                            params: {
                                height: height
                            }
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeCommit, _this.r.decodeCommit)
                        ];
                    });
                })();
            }
        },
        {
            key: "genesis",
            value: function genesis() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Genesis
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeGenesis, _this.r.decodeGenesis)
                        ];
                    });
                })();
            }
        },
        {
            key: "health",
            value: function health() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Health
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeHealth, _this.r.decodeHealth)
                        ];
                    });
                })();
            }
        },
        {
            key: "numUnconfirmedTxs",
            value: function numUnconfirmedTxs() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.NumUnconfirmedTxs
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeNumUnconfirmedTxs, _this.r.decodeNumUnconfirmedTxs)
                        ];
                    });
                })();
            }
        },
        {
            key: "status",
            value: function status() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Status
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeStatus, _this.r.decodeStatus)
                        ];
                    });
                })();
            }
        },
        {
            key: "subscribeNewBlock",
            value: function subscribeNewBlock() {
                var request = {
                    method: $d43eb0babef69136$var$requests.Method.Subscribe,
                    query: {
                        type: $d43eb0babef69136$var$requests.SubscriptionEventType.NewBlock
                    }
                };
                return this.subscribe(request, this.r.decodeNewBlockEvent);
            }
        },
        {
            key: "subscribeNewBlockHeader",
            value: function subscribeNewBlockHeader() {
                var request = {
                    method: $d43eb0babef69136$var$requests.Method.Subscribe,
                    query: {
                        type: $d43eb0babef69136$var$requests.SubscriptionEventType.NewBlockHeader
                    }
                };
                return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
            }
        },
        {
            key: "subscribeTx",
            value: function subscribeTx(query) {
                var request = {
                    method: $d43eb0babef69136$var$requests.Method.Subscribe,
                    query: {
                        type: $d43eb0babef69136$var$requests.SubscriptionEventType.Tx,
                        raw: query
                    }
                };
                return this.subscribe(request, this.r.decodeTxEvent);
            }
        },
        {
            key: "tx",
            value: /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ function tx(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $d43eb0babef69136$var$requests.Method.Tx
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeTx, _this.r.decodeTx)
                        ];
                    });
                })();
            }
        },
        {
            key: "txSearch",
            value: /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ function txSearch(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            params: params,
                            method: $d43eb0babef69136$var$requests.Method.TxSearch
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeTxSearch, _this.r.decodeTxSearch)
                        ];
                    });
                })();
            }
        },
        {
            key: "txSearchAll",
            value: // this should paginate through all txSearch options to ensure it returns all results.
            // starts with page 1 or whatever was provided (eg. to start on page 7)
            function txSearchAll(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var page, txs, done, _txs, resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                page = params.page || 1;
                                txs = [];
                                done = false;
                                _state.label = 1;
                            case 1:
                                if (!!done) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.txSearch((0, $gddcW._)((0, $4JCw4._)({}, params), {
                                        page: page
                                    }))
                                ];
                            case 2:
                                resp = _state.sent();
                                (_txs = txs).push.apply(_txs, (0, $gF0bR._)(resp.txs));
                                if (txs.length < resp.totalCount) page++;
                                else done = true;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2,
                                    {
                                        totalCount: txs.length,
                                        txs: txs
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "validators",
            value: function validators(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var query;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        query = {
                            method: $d43eb0babef69136$var$requests.Method.Validators,
                            params: params
                        };
                        return [
                            2,
                            _this.doCall(query, _this.p.encodeValidators, _this.r.decodeValidators)
                        ];
                    });
                })();
            }
        },
        {
            key: "validatorsAll",
            value: function validatorsAll(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var validators, page, done, blockHeight, _validators, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                validators = [];
                                page = 1;
                                done = false;
                                blockHeight = height;
                                _state.label = 1;
                            case 1:
                                if (!!done) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.validators({
                                        per_page: 50,
                                        height: blockHeight,
                                        page: page
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_validators = validators).push.apply(_validators, (0, $gF0bR._)(response.validators));
                                blockHeight = blockHeight || response.blockHeight;
                                if (validators.length < response.total) page++;
                                else done = true;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                return [
                                    2,
                                    {
                                        // NOTE: Default value is for type safety but this should always be set
                                        blockHeight: blockHeight !== null && blockHeight !== void 0 ? blockHeight : 0,
                                        count: validators.length,
                                        total: validators.length,
                                        validators: validators
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "doCall",
            value: // doCall is a helper to handle the encode/call/decode logic
            function doCall(request, encode, decode) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var req, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                req = encode(request);
                                return [
                                    4,
                                    _this.client.execute(req)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    decode(result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "subscribe",
            value: function subscribe(request, decode) {
                if (!(0, $1GCRg.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
                var req = this.p.encodeSubscribe(request);
                var eventStream = this.client.listen(req);
                return eventStream.map(function(event) {
                    return decode(event);
                });
            }
        }
    ], [
        {
            key: "connect",
            value: /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ function connect(endpoint) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var rpcClient, useHttp, _version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof endpoint === "object") rpcClient = new $1GCRg.HttpClient(endpoint);
                                else {
                                    useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
                                    rpcClient = useHttp ? new $1GCRg.HttpClient(endpoint) : new $1GCRg.WebsocketClient(endpoint);
                                }
                                return [
                                    4,
                                    _this.detectVersion(rpcClient)
                                ];
                            case 1:
                                _version = _state.sent();
                                return [
                                    2,
                                    Tendermint37Client.create(rpcClient)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: /**
     * Creates a new Tendermint client given an RPC client.
     */ function create(rpcClient) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new Tendermint37Client(rpcClient)
                        ];
                    });
                })();
            }
        },
        {
            key: "detectVersion",
            value: function detectVersion(client) {
                return (0, $6rBFC._)(function() {
                    var req, response, result, version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                req = (0, $5WHTi.createJsonRpcRequest)($d43eb0babef69136$var$requests.Method.Status);
                                return [
                                    4,
                                    client.execute(req)
                                ];
                            case 1:
                                response = _state.sent();
                                result = response.result;
                                if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
                                version = result.node_info.version;
                                if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
                                return [
                                    2,
                                    version
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Tendermint37Client;
}();
module.exports.Tendermint37Client = $d43eb0babef69136$var$Tendermint37Client;

});
parcelRegister("aRytt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor37 = void 0;

var $abhoP = parcelRequire("abhoP");

var $rMuaY = parcelRequire("rMuaY");

var $ic21n = parcelRequire("ic21n");
module.exports.adaptor37 = {
    params: $rMuaY.Params,
    responses: $ic21n.Responses,
    hashTx: $abhoP.hashTx,
    hashBlock: $abhoP.hashBlock
};

});
parcelRegister("abhoP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $eMVz6 = parcelRequire("eMVz6");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $76986d9c624470b9$var$hashTx(tx) {
    return (0, $3d6bA.sha256)(tx);
}
module.exports.hashTx = $76986d9c624470b9$var$hashTx;
function $76986d9c624470b9$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    var largestPowerOf2 = Math.pow(2, Math.floor(Math.log2(n)));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $76986d9c624470b9$var$hashLeaf(leaf) {
    var hash = new $3d6bA.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $76986d9c624470b9$var$hashInner(left, right) {
    var hash = new $3d6bA.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $76986d9c624470b9$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $76986d9c624470b9$var$hashLeaf(hashes[0]);
        default:
            {
                var slicePoint = $76986d9c624470b9$var$getSplitPoint(hashes.length);
                var left = $76986d9c624470b9$var$hashTree(hashes.slice(0, slicePoint));
                var right = $76986d9c624470b9$var$hashTree(hashes.slice(slicePoint));
                return $76986d9c624470b9$var$hashInner(left, right);
            }
    }
}
function $76986d9c624470b9$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    var encodedFields = [
        (0, $eMVz6.encodeVersion)(header.version),
        (0, $eMVz6.encodeString)(header.chainId),
        (0, $eMVz6.encodeUvarint)(header.height),
        (0, $eMVz6.encodeTime)(header.time),
        (0, $eMVz6.encodeBlockId)(header.lastBlockId),
        (0, $eMVz6.encodeBytes)(header.lastCommitHash),
        (0, $eMVz6.encodeBytes)(header.dataHash),
        (0, $eMVz6.encodeBytes)(header.validatorsHash),
        (0, $eMVz6.encodeBytes)(header.nextValidatorsHash),
        (0, $eMVz6.encodeBytes)(header.consensusHash),
        (0, $eMVz6.encodeBytes)(header.appHash),
        (0, $eMVz6.encodeBytes)(header.lastResultsHash),
        (0, $eMVz6.encodeBytes)(header.evidenceHash),
        (0, $eMVz6.encodeBytes)(header.proposerAddress)
    ];
    return $76986d9c624470b9$var$hashTree(encodedFields);
}
module.exports.hashBlock = $76986d9c624470b9$var$hashBlock;

});
parcelRegister("eMVz6", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $lSA9E = parcelRequire("lSA9E");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $ac42339d02a920ac$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $ac42339d02a920ac$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $ac42339d02a920ac$var$assertBoolean(value) {
    $ac42339d02a920ac$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $ac42339d02a920ac$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $ac42339d02a920ac$var$assertString(value) {
    $ac42339d02a920ac$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $ac42339d02a920ac$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $ac42339d02a920ac$var$assertNumber(value) {
    $ac42339d02a920ac$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $ac42339d02a920ac$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $ac42339d02a920ac$var$assertArray(value) {
    $ac42339d02a920ac$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $ac42339d02a920ac$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $ac42339d02a920ac$var$assertObject(value) {
    $ac42339d02a920ac$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $ac42339d02a920ac$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $ac42339d02a920ac$var$assertNotEmpty(value) {
    $ac42339d02a920ac$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $ac42339d02a920ac$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $ac42339d02a920ac$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $ac42339d02a920ac$var$may;
function $ac42339d02a920ac$var$dictionaryToStringMap(obj) {
    var out = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = obj[key];
            if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
            out.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
module.exports.dictionaryToStringMap = $ac42339d02a920ac$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $ac42339d02a920ac$var$encodeString(s) {
    var utf8 = (0, $lSA9E.toUtf8)(s);
    return Uint8Array.from([
        utf8.length
    ].concat((0, $gF0bR._)(utf8)));
}
module.exports.encodeString = $ac42339d02a920ac$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $ac42339d02a920ac$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80
    ].concat((0, $gF0bR._)($ac42339d02a920ac$var$encodeUvarint(n >> 7)))) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $ac42339d02a920ac$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $ac42339d02a920ac$var$encodeTime(time) {
    var milliseconds = time.getTime();
    var seconds = Math.floor(milliseconds / 1000);
    var secondsArray = seconds ? [
        0x08
    ].concat((0, $gF0bR._)($ac42339d02a920ac$var$encodeUvarint(seconds))) : new Uint8Array();
    var nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    var nanosecondsArray = nanoseconds ? [
        0x10
    ].concat((0, $gF0bR._)($ac42339d02a920ac$var$encodeUvarint(nanoseconds))) : new Uint8Array();
    return Uint8Array.from((0, $gF0bR._)(secondsArray).concat((0, $gF0bR._)(nanosecondsArray)));
}
module.exports.encodeTime = $ac42339d02a920ac$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $ac42339d02a920ac$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length
    ].concat((0, $gF0bR._)(bytes))) : new Uint8Array();
}
module.exports.encodeBytes = $ac42339d02a920ac$var$encodeBytes;
function $ac42339d02a920ac$var$encodeVersion(version) {
    var blockArray = version.block ? Uint8Array.from([
        0x08
    ].concat((0, $gF0bR._)($ac42339d02a920ac$var$encodeUvarint(version.block)))) : new Uint8Array();
    var appArray = version.app ? Uint8Array.from([
        0x10
    ].concat((0, $gF0bR._)($ac42339d02a920ac$var$encodeUvarint(version.app)))) : new Uint8Array();
    return Uint8Array.from((0, $gF0bR._)(blockArray).concat((0, $gF0bR._)(appArray)));
}
module.exports.encodeVersion = $ac42339d02a920ac$var$encodeVersion;
function $ac42339d02a920ac$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length
    ].concat((0, $gF0bR._)(blockId.hash), [
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length
    ], (0, $gF0bR._)(blockId.parts.hash)));
}
module.exports.encodeBlockId = $ac42339d02a920ac$var$encodeBlockId;

});


parcelRegister("rMuaY", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $053821fbb14d5306$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $053821fbb14d5306$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $053821fbb14d5306$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $053821fbb14d5306$var$__createBinding(result, mod, k);
    }
    $053821fbb14d5306$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $g8v8F = parcelRequire("g8v8F");

var $5WHTi = parcelRequire("5WHTi");

var $eMVz6 = parcelRequire("eMVz6");

var $053821fbb14d5306$var$requests = $053821fbb14d5306$var$__importStar((parcelRequire("4QZMw")));
function $053821fbb14d5306$var$encodeHeightParam(param) {
    return {
        height: (0, $eMVz6.may)($g8v8F.smallIntToApi, param.height)
    };
}
function $053821fbb14d5306$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $eMVz6.may)($g8v8F.smallIntToApi, param.minHeight),
        maxHeight: (0, $eMVz6.may)($g8v8F.smallIntToApi, param.maxHeight)
    };
}
function $053821fbb14d5306$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.page),
        per_page: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $053821fbb14d5306$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $eMVz6.assertNotEmpty)(params.path),
        data: (0, $lSA9E.toHex)(params.data),
        height: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $053821fbb14d5306$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $lSA9E.toBase64)((0, $eMVz6.assertNotEmpty)(params.tx))
    };
}
function $053821fbb14d5306$var$encodeTxParams(params) {
    return {
        hash: (0, $lSA9E.toBase64)((0, $eMVz6.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $053821fbb14d5306$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.page),
        per_page: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $053821fbb14d5306$var$encodeValidatorsParams(params) {
    return {
        height: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.height),
        page: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.page),
        per_page: (0, $eMVz6.may)($g8v8F.smallIntToApi, params.per_page)
    };
}
var $053821fbb14d5306$var$Params = /*#__PURE__*/ function() {
    function Params() {
        (0, $7dKN1._)(this, Params);
    }
    (0, $eW5pA._)(Params, null, [
        {
            key: "encodeAbciInfo",
            value: function encodeAbciInfo(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeAbciQuery",
            value: function encodeAbciQuery(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeAbciQueryParams(req.params));
            }
        },
        {
            key: "encodeBlock",
            value: function encodeBlock(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeHeightParam(req.params));
            }
        },
        {
            key: "encodeBlockchain",
            value: function encodeBlockchain(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeBlockchainRequestParams(req.params));
            }
        },
        {
            key: "encodeBlockResults",
            value: function encodeBlockResults(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeHeightParam(req.params));
            }
        },
        {
            key: "encodeBlockSearch",
            value: function encodeBlockSearch(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeBlockSearchParams(req.params));
            }
        },
        {
            key: "encodeBroadcastTx",
            value: function encodeBroadcastTx(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeBroadcastTxParams(req.params));
            }
        },
        {
            key: "encodeCommit",
            value: function encodeCommit(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeHeightParam(req.params));
            }
        },
        {
            key: "encodeGenesis",
            value: function encodeGenesis(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeHealth",
            value: function encodeHealth(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeNumUnconfirmedTxs",
            value: function encodeNumUnconfirmedTxs(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeStatus",
            value: function encodeStatus(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method);
            }
        },
        {
            key: "encodeSubscribe",
            value: function encodeSubscribe(req) {
                var eventTag = {
                    key: "tm.event",
                    value: req.query.type
                };
                var query = $053821fbb14d5306$var$requests.buildQuery({
                    tags: [
                        eventTag
                    ],
                    raw: req.query.raw
                });
                return (0, $5WHTi.createJsonRpcRequest)("subscribe", {
                    query: query
                });
            }
        },
        {
            key: "encodeTx",
            value: function encodeTx(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeTxParams(req.params));
            }
        },
        {
            key: "encodeTxSearch",
            value: // TODO: encode params for query string???
            function encodeTxSearch(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeTxSearchParams(req.params));
            }
        },
        {
            key: "encodeValidators",
            value: function encodeValidators(req) {
                return (0, $5WHTi.createJsonRpcRequest)(req.method, $053821fbb14d5306$var$encodeValidatorsParams(req.params));
            }
        }
    ]);
    return Params;
}();
module.exports.Params = $053821fbb14d5306$var$Params;

});

parcelRegister("ic21n", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $5OlIx = parcelRequire("5OlIx");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $gMk5u = parcelRequire("gMk5u");

var $bCIvL = parcelRequire("bCIvL");

var $g8v8F = parcelRequire("g8v8F");

var $3yHgT = parcelRequire("3yHgT");

var $eMVz6 = parcelRequire("eMVz6");

var $abhoP = parcelRequire("abhoP");
function $d3eaea5e2f64a2f4$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $eMVz6.may)($g8v8F.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $eMVz6.may)($lSA9E.fromBase64, data.last_block_app_hash)
    };
}
function $d3eaea5e2f64a2f4$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map(function(op) {
            return {
                type: op.type,
                key: (0, $lSA9E.fromBase64)(op.key),
                data: (0, $lSA9E.fromBase64)(op.data)
            };
        })
    };
}
function $d3eaea5e2f64a2f4$var$decodeAbciQuery(data) {
    var _data_key, _data_value, _data_codespace, _data_info;
    return {
        key: (0, $lSA9E.fromBase64)((0, $eMVz6.assertString)((_data_key = data.key) !== null && _data_key !== void 0 ? _data_key : "")),
        value: (0, $lSA9E.fromBase64)((0, $eMVz6.assertString)((_data_value = data.value) !== null && _data_value !== void 0 ? _data_value : "")),
        proof: (0, $eMVz6.may)($d3eaea5e2f64a2f4$var$decodeQueryProof, data.proofOps),
        height: (0, $eMVz6.may)($g8v8F.apiToSmallInt, data.height),
        code: (0, $eMVz6.may)($g8v8F.apiToSmallInt, data.code),
        codespace: (0, $eMVz6.assertString)((_data_codespace = data.codespace) !== null && _data_codespace !== void 0 ? _data_codespace : ""),
        index: (0, $eMVz6.may)($g8v8F.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $eMVz6.assertString)((_data_info = data.info) !== null && _data_info !== void 0 ? _data_info : "")
    };
}
function $d3eaea5e2f64a2f4$var$decodeEventAttribute(attribute) {
    var _attribute_value;
    return {
        key: (0, $eMVz6.assertNotEmpty)(attribute.key),
        value: (_attribute_value = attribute.value) !== null && _attribute_value !== void 0 ? _attribute_value : ""
    };
}
function $d3eaea5e2f64a2f4$var$decodeAttributes(attributes) {
    return (0, $eMVz6.assertArray)(attributes).map($d3eaea5e2f64a2f4$var$decodeEventAttribute);
}
function $d3eaea5e2f64a2f4$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $d3eaea5e2f64a2f4$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $d3eaea5e2f64a2f4$var$decodeEvent;
function $d3eaea5e2f64a2f4$var$decodeEvents(events) {
    return (0, $eMVz6.assertArray)(events).map($d3eaea5e2f64a2f4$var$decodeEvent);
}
function $d3eaea5e2f64a2f4$var$decodeTxData(data) {
    var _data_code, _data_gas_wanted, _data_gas_used;
    return {
        code: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNumber)((_data_code = data.code) !== null && _data_code !== void 0 ? _data_code : 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $eMVz6.may)($lSA9E.fromBase64, data.data),
        events: data.events ? $d3eaea5e2f64a2f4$var$decodeEvents(data.events) : [],
        gasWanted: (0, $g8v8F.apiToSmallInt)((_data_gas_wanted = data.gas_wanted) !== null && _data_gas_wanted !== void 0 ? _data_gas_wanted : "0"),
        gasUsed: (0, $g8v8F.apiToSmallInt)((_data_gas_used = data.gas_used) !== null && _data_gas_used !== void 0 ? _data_gas_used : "0")
    };
}
function $d3eaea5e2f64a2f4$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        var _Object_entries = (0, $5OlIx._)(Object.entries(data.Sum.value), 1), _Object_entries_ = (0, $5OlIx._)(_Object_entries[0], 2), algorithm = _Object_entries_[0], value = _Object_entries_[1];
        (0, $gMk5u.assert)(algorithm === "ed25519" || algorithm === "secp256k1", "unknown pubkey type: ".concat(algorithm));
        return {
            algorithm: algorithm,
            data: (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(data.value))
            };
        default:
            throw new Error("unknown pubkey type: ".concat(data.type));
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $d3eaea5e2f64a2f4$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.max_gas))
    };
}
function $d3eaea5e2f64a2f4$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.max_age_duration))
    };
}
function $d3eaea5e2f64a2f4$var$decodeConsensusParams(data) {
    return {
        block: $d3eaea5e2f64a2f4$var$decodeBlockParams((0, $eMVz6.assertObject)(data.block)),
        evidence: $d3eaea5e2f64a2f4$var$decodeEvidenceParams((0, $eMVz6.assertObject)(data.evidence))
    };
}
function $d3eaea5e2f64a2f4$var$decodeValidatorUpdate(data) {
    var _data_power;
    return {
        pubkey: $d3eaea5e2f64a2f4$var$decodePubkey((0, $eMVz6.assertObject)(data.pub_key)),
        votingPower: (0, $g8v8F.apiToBigInt)((_data_power = data.power) !== null && _data_power !== void 0 ? _data_power : "0")
    };
}
module.exports.decodeValidatorUpdate = $d3eaea5e2f64a2f4$var$decodeValidatorUpdate;
function $d3eaea5e2f64a2f4$var$decodeBlockResults(data) {
    return {
        height: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($d3eaea5e2f64a2f4$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($d3eaea5e2f64a2f4$var$decodeValidatorUpdate),
        consensusUpdates: (0, $eMVz6.may)($d3eaea5e2f64a2f4$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $d3eaea5e2f64a2f4$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $d3eaea5e2f64a2f4$var$decodeEvents(data.end_block_events || [])
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockId(data) {
    return {
        hash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $eMVz6.assertNotEmpty)(data.parts.total),
            hash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockVersion(data) {
    var _data_app;
    return {
        block: (0, $g8v8F.apiToSmallInt)(data.block),
        app: (0, $g8v8F.apiToSmallInt)((_data_app = data.app) !== null && _data_app !== void 0 ? _data_app : 0)
    };
}
function $d3eaea5e2f64a2f4$var$decodeHeader(data) {
    return {
        version: $d3eaea5e2f64a2f4$var$decodeBlockVersion(data.version),
        chainId: (0, $eMVz6.assertNotEmpty)(data.chain_id),
        height: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.height)),
        time: (0, $bCIvL.fromRfc3339WithNanoseconds)((0, $eMVz6.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $d3eaea5e2f64a2f4$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.last_commit_hash)),
        dataHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.data_hash)),
        validatorsHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.consensus_hash)),
        appHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.app_hash)),
        lastResultsHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.proposer_address))
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockMeta(data) {
    return {
        blockId: $d3eaea5e2f64a2f4$var$decodeBlockId(data.block_id),
        blockSize: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.block_size)),
        header: $d3eaea5e2f64a2f4$var$decodeHeader(data.header),
        numTxs: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.num_txs))
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $eMVz6.assertArray)(data.block_metas).map($d3eaea5e2f64a2f4$var$decodeBlockMeta)
    };
}
function $d3eaea5e2f64a2f4$var$decodeBroadcastTxSync(data) {
    return (0, $gddcW._)((0, $4JCw4._)({}, $d3eaea5e2f64a2f4$var$decodeTxData(data)), {
        hash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.hash))
    });
}
function $d3eaea5e2f64a2f4$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $g8v8F.apiToSmallInt)(data.height),
        hash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.hash)),
        checkTx: $d3eaea5e2f64a2f4$var$decodeTxData((0, $eMVz6.assertObject)(data.check_tx)),
        deliverTx: (0, $eMVz6.may)($d3eaea5e2f64a2f4$var$decodeTxData, data.deliver_tx)
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $gMk5u.assert)(blockIdFlag in $3yHgT.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $d3eaea5e2f64a2f4$var$decodeOptionalTime(timestamp) {
    var nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $bCIvL.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $d3eaea5e2f64a2f4$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $d3eaea5e2f64a2f4$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $lSA9E.fromHex)(data.validator_address) : undefined,
        timestamp: $d3eaea5e2f64a2f4$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $lSA9E.fromBase64)(data.signature) : undefined
    };
}
function $d3eaea5e2f64a2f4$var$decodeCommit(data) {
    return {
        blockId: $d3eaea5e2f64a2f4$var$decodeBlockId((0, $eMVz6.assertObject)(data.block_id)),
        height: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.height)),
        round: (0, $g8v8F.apiToSmallInt)(data.round),
        signatures: (0, $eMVz6.assertArray)(data.signatures).map($d3eaea5e2f64a2f4$var$decodeCommitSignature)
    };
}
function $d3eaea5e2f64a2f4$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $eMVz6.assertBoolean)(data.canonical),
        header: $d3eaea5e2f64a2f4$var$decodeHeader(data.signed_header.header),
        commit: $d3eaea5e2f64a2f4$var$decodeCommit(data.signed_header.commit)
    };
}
function $d3eaea5e2f64a2f4$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.address)),
        pubkey: $d3eaea5e2f64a2f4$var$decodePubkey((0, $eMVz6.assertObject)(data.pub_key)),
        votingPower: (0, $g8v8F.apiToBigInt)((0, $eMVz6.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $d3eaea5e2f64a2f4$var$decodeValidatorGenesis;
function $d3eaea5e2f64a2f4$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $bCIvL.fromRfc3339WithNanoseconds)((0, $eMVz6.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $eMVz6.assertNotEmpty)(data.chain_id),
        consensusParams: $d3eaea5e2f64a2f4$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $eMVz6.assertArray)(data.validators).map($d3eaea5e2f64a2f4$var$decodeValidatorGenesis) : [],
        appHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $d3eaea5e2f64a2f4$var$decodeValidatorInfo(data) {
    return {
        pubkey: $d3eaea5e2f64a2f4$var$decodePubkey((0, $eMVz6.assertObject)(data.pub_key)),
        votingPower: (0, $g8v8F.apiToBigInt)((0, $eMVz6.assertNotEmpty)(data.voting_power)),
        address: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $g8v8F.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $d3eaea5e2f64a2f4$var$decodeValidatorInfo;
function $d3eaea5e2f64a2f4$var$decodeNodeInfo(data) {
    return {
        id: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.id)),
        listenAddr: (0, $eMVz6.assertNotEmpty)(data.listen_addr),
        network: (0, $eMVz6.assertNotEmpty)(data.network),
        version: (0, $eMVz6.assertString)(data.version),
        channels: (0, $eMVz6.assertNotEmpty)(data.channels),
        moniker: (0, $eMVz6.assertNotEmpty)(data.moniker),
        other: (0, $eMVz6.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $d3eaea5e2f64a2f4$var$decodeSyncInfo(data) {
    var earliestBlockHeight = data.earliest_block_height ? (0, $g8v8F.apiToSmallInt)(data.earliest_block_height) : undefined;
    var earliestBlockTime = data.earliest_block_time ? (0, $bCIvL.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $lSA9E.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $lSA9E.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: (earliestBlockTime === null || earliestBlockTime === void 0 ? void 0 : earliestBlockTime.getTime()) ? earliestBlockTime : undefined,
        latestBlockHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $bCIvL.fromRfc3339WithNanoseconds)((0, $eMVz6.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $eMVz6.assertBoolean)(data.catching_up)
    };
}
function $d3eaea5e2f64a2f4$var$decodeStatus(data) {
    return {
        nodeInfo: $d3eaea5e2f64a2f4$var$decodeNodeInfo(data.node_info),
        syncInfo: $d3eaea5e2f64a2f4$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $d3eaea5e2f64a2f4$var$decodeValidatorInfo(data.validator_info)
    };
}
function $d3eaea5e2f64a2f4$var$decodeTxProof(data) {
    return {
        data: (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(data.data)),
        rootHash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.proof.total)),
            index: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $eMVz6.assertArray)(data.proof.aunts).map($lSA9E.fromBase64)
        }
    };
}
function $d3eaea5e2f64a2f4$var$decodeTxResponse(data) {
    return {
        tx: (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(data.tx)),
        result: $d3eaea5e2f64a2f4$var$decodeTxData((0, $eMVz6.assertObject)(data.tx_result)),
        height: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.height)),
        index: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNumber)(data.index)),
        hash: (0, $lSA9E.fromHex)((0, $eMVz6.assertNotEmpty)(data.hash)),
        proof: (0, $eMVz6.may)($d3eaea5e2f64a2f4$var$decodeTxProof, data.proof)
    };
}
function $d3eaea5e2f64a2f4$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.total_count)),
        txs: (0, $eMVz6.assertArray)(data.txs).map($d3eaea5e2f64a2f4$var$decodeTxResponse)
    };
}
function $d3eaea5e2f64a2f4$var$decodeTxEvent(data) {
    var tx = (0, $lSA9E.fromBase64)((0, $eMVz6.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $abhoP.hashTx)(tx),
        result: $d3eaea5e2f64a2f4$var$decodeTxData(data.result),
        height: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.height))
    };
}
function $d3eaea5e2f64a2f4$var$decodeValidators(data) {
    return {
        blockHeight: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.block_height)),
        validators: (0, $eMVz6.assertArray)(data.validators).map($d3eaea5e2f64a2f4$var$decodeValidatorInfo),
        count: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.count)),
        total: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.total))
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlock(data) {
    var _data_evidence;
    var _data_evidence_evidence;
    return {
        header: $d3eaea5e2f64a2f4$var$decodeHeader((0, $eMVz6.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $d3eaea5e2f64a2f4$var$decodeCommit((0, $eMVz6.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $eMVz6.assertArray)(data.data.txs).map($lSA9E.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: (_data_evidence_evidence = (_data_evidence = data.evidence) === null || _data_evidence === void 0 ? void 0 : _data_evidence.evidence) !== null && _data_evidence_evidence !== void 0 ? _data_evidence_evidence : []
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockResponse(data) {
    return {
        blockId: $d3eaea5e2f64a2f4$var$decodeBlockId(data.block_id),
        block: $d3eaea5e2f64a2f4$var$decodeBlock(data.block)
    };
}
function $d3eaea5e2f64a2f4$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.total_count)),
        blocks: (0, $eMVz6.assertArray)(data.blocks).map($d3eaea5e2f64a2f4$var$decodeBlockResponse)
    };
}
function $d3eaea5e2f64a2f4$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.total)),
        totalBytes: (0, $g8v8F.apiToSmallInt)((0, $eMVz6.assertNotEmpty)(data.total_bytes))
    };
}
var $d3eaea5e2f64a2f4$var$Responses = /*#__PURE__*/ function() {
    function Responses() {
        (0, $7dKN1._)(this, Responses);
    }
    (0, $eW5pA._)(Responses, null, [
        {
            key: "decodeAbciInfo",
            value: function decodeAbciInfo1(response) {
                return $d3eaea5e2f64a2f4$var$decodeAbciInfo((0, $eMVz6.assertObject)(response.result.response));
            }
        },
        {
            key: "decodeAbciQuery",
            value: function decodeAbciQuery1(response) {
                return $d3eaea5e2f64a2f4$var$decodeAbciQuery((0, $eMVz6.assertObject)(response.result.response));
            }
        },
        {
            key: "decodeBlock",
            value: function decodeBlock(response) {
                return $d3eaea5e2f64a2f4$var$decodeBlockResponse(response.result);
            }
        },
        {
            key: "decodeBlockResults",
            value: function decodeBlockResults1(response) {
                return $d3eaea5e2f64a2f4$var$decodeBlockResults(response.result);
            }
        },
        {
            key: "decodeBlockSearch",
            value: function decodeBlockSearch1(response) {
                return $d3eaea5e2f64a2f4$var$decodeBlockSearch(response.result);
            }
        },
        {
            key: "decodeBlockchain",
            value: function decodeBlockchain1(response) {
                return $d3eaea5e2f64a2f4$var$decodeBlockchain(response.result);
            }
        },
        {
            key: "decodeBroadcastTxSync",
            value: function decodeBroadcastTxSync1(response) {
                return $d3eaea5e2f64a2f4$var$decodeBroadcastTxSync(response.result);
            }
        },
        {
            key: "decodeBroadcastTxAsync",
            value: function decodeBroadcastTxAsync(response) {
                return Responses.decodeBroadcastTxSync(response);
            }
        },
        {
            key: "decodeBroadcastTxCommit",
            value: function decodeBroadcastTxCommit1(response) {
                return $d3eaea5e2f64a2f4$var$decodeBroadcastTxCommit(response.result);
            }
        },
        {
            key: "decodeCommit",
            value: function decodeCommit(response) {
                return $d3eaea5e2f64a2f4$var$decodeCommitResponse(response.result);
            }
        },
        {
            key: "decodeGenesis",
            value: function decodeGenesis1(response) {
                return $d3eaea5e2f64a2f4$var$decodeGenesis((0, $eMVz6.assertObject)(response.result.genesis));
            }
        },
        {
            key: "decodeHealth",
            value: function decodeHealth() {
                return null;
            }
        },
        {
            key: "decodeNumUnconfirmedTxs",
            value: function decodeNumUnconfirmedTxs1(response) {
                return $d3eaea5e2f64a2f4$var$decodeNumUnconfirmedTxs(response.result);
            }
        },
        {
            key: "decodeStatus",
            value: function decodeStatus1(response) {
                return $d3eaea5e2f64a2f4$var$decodeStatus(response.result);
            }
        },
        {
            key: "decodeNewBlockEvent",
            value: function decodeNewBlockEvent(event) {
                return $d3eaea5e2f64a2f4$var$decodeBlock(event.data.value.block);
            }
        },
        {
            key: "decodeNewBlockHeaderEvent",
            value: function decodeNewBlockHeaderEvent(event) {
                return $d3eaea5e2f64a2f4$var$decodeHeader(event.data.value.header);
            }
        },
        {
            key: "decodeTxEvent",
            value: function decodeTxEvent1(event) {
                return $d3eaea5e2f64a2f4$var$decodeTxEvent(event.data.value.TxResult);
            }
        },
        {
            key: "decodeTx",
            value: function decodeTx(response) {
                return $d3eaea5e2f64a2f4$var$decodeTxResponse(response.result);
            }
        },
        {
            key: "decodeTxSearch",
            value: function decodeTxSearch1(response) {
                return $d3eaea5e2f64a2f4$var$decodeTxSearch(response.result);
            }
        },
        {
            key: "decodeValidators",
            value: function decodeValidators1(response) {
                return $d3eaea5e2f64a2f4$var$decodeValidators(response.result);
            }
        }
    ]);
    return Responses;
}();
module.exports.Responses = $d3eaea5e2f64a2f4$var$Responses;

});




parcelRegister("3sALI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Deflate", function () { return $9fadf46538cad625$export$ae157b6234afe138; });
$parcel$export(module.exports, "deflate", function () { return $9fadf46538cad625$export$2316623ecd1285ab; });
$parcel$export(module.exports, "deflateRaw", function () { return $9fadf46538cad625$export$e95d6a8f69fb340a; });
$parcel$export(module.exports, "gzip", function () { return $9fadf46538cad625$export$69f0ea7cf3a331a8; });
$parcel$export(module.exports, "Inflate", function () { return $9fadf46538cad625$export$d1de70a877d6e43c; });
$parcel$export(module.exports, "inflate", function () { return $9fadf46538cad625$export$cae1ce83fe4a1782; });
$parcel$export(module.exports, "inflateRaw", function () { return $9fadf46538cad625$export$d0f0aa2d05c905c5; });
$parcel$export(module.exports, "ungzip", function () { return $9fadf46538cad625$export$95adf9d270383091; });
$parcel$export(module.exports, "constants", function () { return $9fadf46538cad625$export$1a988e7317c65621; });
$parcel$export(module.exports, "default", function () { return $9fadf46538cad625$export$2e2bcd8739ae039; });
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
var $9fadf46538cad625$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $9fadf46538cad625$var$Z_BINARY = 0;
var $9fadf46538cad625$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
var $9fadf46538cad625$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $9fadf46538cad625$var$zero$1(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $9fadf46538cad625$var$STORED_BLOCK = 0;
var $9fadf46538cad625$var$STATIC_TREES = 1;
var $9fadf46538cad625$var$DYN_TREES = 2;
/* The three kinds of block type */ var $9fadf46538cad625$var$MIN_MATCH$1 = 3;
var $9fadf46538cad625$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $9fadf46538cad625$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $9fadf46538cad625$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ var $9fadf46538cad625$var$L_CODES$1 = $9fadf46538cad625$var$LITERALS$1 + 1 + $9fadf46538cad625$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ var $9fadf46538cad625$var$D_CODES$1 = 30;
/* number of distance codes */ var $9fadf46538cad625$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ var $9fadf46538cad625$var$HEAP_SIZE$1 = 2 * $9fadf46538cad625$var$L_CODES$1 + 1;
/* maximum heap size */ var $9fadf46538cad625$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ var $9fadf46538cad625$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $9fadf46538cad625$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $9fadf46538cad625$var$END_BLOCK = 256;
/* end of block literal code */ var $9fadf46538cad625$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $9fadf46538cad625$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $9fadf46538cad625$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $9fadf46538cad625$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
var $9fadf46538cad625$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
var $9fadf46538cad625$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
var $9fadf46538cad625$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $9fadf46538cad625$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $9fadf46538cad625$var$static_ltree = new Array(($9fadf46538cad625$var$L_CODES$1 + 2) * 2);
$9fadf46538cad625$var$zero$1($9fadf46538cad625$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $9fadf46538cad625$var$static_dtree = new Array($9fadf46538cad625$var$D_CODES$1 * 2);
$9fadf46538cad625$var$zero$1($9fadf46538cad625$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $9fadf46538cad625$var$_dist_code = new Array($9fadf46538cad625$var$DIST_CODE_LEN);
$9fadf46538cad625$var$zero$1($9fadf46538cad625$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $9fadf46538cad625$var$_length_code = new Array($9fadf46538cad625$var$MAX_MATCH$1 - $9fadf46538cad625$var$MIN_MATCH$1 + 1);
$9fadf46538cad625$var$zero$1($9fadf46538cad625$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $9fadf46538cad625$var$base_length = new Array($9fadf46538cad625$var$LENGTH_CODES$1);
$9fadf46538cad625$var$zero$1($9fadf46538cad625$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $9fadf46538cad625$var$base_dist = new Array($9fadf46538cad625$var$D_CODES$1);
$9fadf46538cad625$var$zero$1($9fadf46538cad625$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $9fadf46538cad625$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $9fadf46538cad625$var$static_l_desc;
var $9fadf46538cad625$var$static_d_desc;
var $9fadf46538cad625$var$static_bl_desc;
function $9fadf46538cad625$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
var $9fadf46538cad625$var$d_code = function(dist) {
    return dist < 256 ? $9fadf46538cad625$var$_dist_code[dist] : $9fadf46538cad625$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ var $9fadf46538cad625$var$put_short = function(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ var $9fadf46538cad625$var$send_bits = function(s, value, length) {
    if (s.bi_valid > $9fadf46538cad625$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $9fadf46538cad625$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $9fadf46538cad625$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $9fadf46538cad625$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
var $9fadf46538cad625$var$send_code = function(s, c, tree) {
    $9fadf46538cad625$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ var $9fadf46538cad625$var$bi_reverse = function(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ var $9fadf46538cad625$var$bi_flush = function(s) {
    if (s.bi_valid === 16) {
        $9fadf46538cad625$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ var $9fadf46538cad625$var$gen_bitlen = function(s, desc) {
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $9fadf46538cad625$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $9fadf46538cad625$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ var $9fadf46538cad625$var$gen_codes = function(tree, max_code, bl_count) {
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    var next_code = new Array($9fadf46538cad625$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $9fadf46538cad625$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $9fadf46538cad625$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ var $9fadf46538cad625$var$tr_static_init = function() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($9fadf46538cad625$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $9fadf46538cad625$var$LENGTH_CODES$1 - 1; code++){
        $9fadf46538cad625$var$base_length[code] = length;
        for(n = 0; n < 1 << $9fadf46538cad625$var$extra_lbits[code]; n++)$9fadf46538cad625$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $9fadf46538cad625$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $9fadf46538cad625$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $9fadf46538cad625$var$extra_dbits[code]; n++)$9fadf46538cad625$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $9fadf46538cad625$var$D_CODES$1; code++){
        $9fadf46538cad625$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $9fadf46538cad625$var$extra_dbits[code] - 7; n++)$9fadf46538cad625$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $9fadf46538cad625$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $9fadf46538cad625$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $9fadf46538cad625$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $9fadf46538cad625$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $9fadf46538cad625$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $9fadf46538cad625$var$gen_codes($9fadf46538cad625$var$static_ltree, $9fadf46538cad625$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $9fadf46538cad625$var$D_CODES$1; n++){
        $9fadf46538cad625$var$static_dtree[n * 2 + 1] = 5;
        $9fadf46538cad625$var$static_dtree[n * 2] = $9fadf46538cad625$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $9fadf46538cad625$var$static_l_desc = new $9fadf46538cad625$var$StaticTreeDesc($9fadf46538cad625$var$static_ltree, $9fadf46538cad625$var$extra_lbits, $9fadf46538cad625$var$LITERALS$1 + 1, $9fadf46538cad625$var$L_CODES$1, $9fadf46538cad625$var$MAX_BITS$1);
    $9fadf46538cad625$var$static_d_desc = new $9fadf46538cad625$var$StaticTreeDesc($9fadf46538cad625$var$static_dtree, $9fadf46538cad625$var$extra_dbits, 0, $9fadf46538cad625$var$D_CODES$1, $9fadf46538cad625$var$MAX_BITS$1);
    $9fadf46538cad625$var$static_bl_desc = new $9fadf46538cad625$var$StaticTreeDesc(new Array(0), $9fadf46538cad625$var$extra_blbits, 0, $9fadf46538cad625$var$BL_CODES$1, $9fadf46538cad625$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ var $9fadf46538cad625$var$init_block = function(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $9fadf46538cad625$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $9fadf46538cad625$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $9fadf46538cad625$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$9fadf46538cad625$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ var $9fadf46538cad625$var$bi_windup = function(s) {
    if (s.bi_valid > 8) $9fadf46538cad625$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ var $9fadf46538cad625$var$smaller = function(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ var $9fadf46538cad625$var$pqdownheap = function(s, tree, k) {
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $9fadf46538cad625$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($9fadf46538cad625$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ var $9fadf46538cad625$var$compress_block = function(s, ltree, dtree) {
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var sx = 0; /* running index in sym_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $9fadf46538cad625$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $9fadf46538cad625$var$_length_code[lc];
            $9fadf46538cad625$var$send_code(s, code + $9fadf46538cad625$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $9fadf46538cad625$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $9fadf46538cad625$var$base_length[code];
                $9fadf46538cad625$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $9fadf46538cad625$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $9fadf46538cad625$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $9fadf46538cad625$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $9fadf46538cad625$var$base_dist[code];
                $9fadf46538cad625$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $9fadf46538cad625$var$send_code(s, $9fadf46538cad625$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ var $9fadf46538cad625$var$build_tree = function(s, desc) {
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $9fadf46538cad625$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$9fadf46538cad625$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $9fadf46538cad625$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $9fadf46538cad625$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $9fadf46538cad625$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $9fadf46538cad625$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ var $9fadf46538cad625$var$scan_tree = function(s, tree, max_code) {
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$9fadf46538cad625$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$9fadf46538cad625$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$9fadf46538cad625$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ var $9fadf46538cad625$var$send_tree = function(s, tree, max_code) {
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $9fadf46538cad625$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $9fadf46538cad625$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $9fadf46538cad625$var$send_code(s, $9fadf46538cad625$var$REP_3_6, s.bl_tree);
            $9fadf46538cad625$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $9fadf46538cad625$var$send_code(s, $9fadf46538cad625$var$REPZ_3_10, s.bl_tree);
            $9fadf46538cad625$var$send_bits(s, count - 3, 3);
        } else {
            $9fadf46538cad625$var$send_code(s, $9fadf46538cad625$var$REPZ_11_138, s.bl_tree);
            $9fadf46538cad625$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ var $9fadf46538cad625$var$build_bl_tree = function(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $9fadf46538cad625$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $9fadf46538cad625$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $9fadf46538cad625$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $9fadf46538cad625$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$9fadf46538cad625$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ var $9fadf46538cad625$var$send_all_trees = function(s, lcodes, dcodes, blcodes) {
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $9fadf46538cad625$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $9fadf46538cad625$var$send_bits(s, dcodes - 1, 5);
    $9fadf46538cad625$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $9fadf46538cad625$var$send_bits(s, s.bl_tree[$9fadf46538cad625$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $9fadf46538cad625$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $9fadf46538cad625$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ var $9fadf46538cad625$var$detect_data_type = function(s) {
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var block_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $9fadf46538cad625$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $9fadf46538cad625$var$Z_TEXT;
    for(n = 32; n < $9fadf46538cad625$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $9fadf46538cad625$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $9fadf46538cad625$var$Z_BINARY;
};
var $9fadf46538cad625$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ var $9fadf46538cad625$var$_tr_init$1 = function(s) {
    if (!$9fadf46538cad625$var$static_init_done) {
        $9fadf46538cad625$var$tr_static_init();
        $9fadf46538cad625$var$static_init_done = true;
    }
    s.l_desc = new $9fadf46538cad625$var$TreeDesc(s.dyn_ltree, $9fadf46538cad625$var$static_l_desc);
    s.d_desc = new $9fadf46538cad625$var$TreeDesc(s.dyn_dtree, $9fadf46538cad625$var$static_d_desc);
    s.bl_desc = new $9fadf46538cad625$var$TreeDesc(s.bl_tree, $9fadf46538cad625$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $9fadf46538cad625$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ var $9fadf46538cad625$var$_tr_stored_block$1 = function(s, buf, stored_len, last) {
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $9fadf46538cad625$var$send_bits(s, ($9fadf46538cad625$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $9fadf46538cad625$var$bi_windup(s); /* align on byte boundary */ 
    $9fadf46538cad625$var$put_short(s, stored_len);
    $9fadf46538cad625$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ var $9fadf46538cad625$var$_tr_align$1 = function(s) {
    $9fadf46538cad625$var$send_bits(s, $9fadf46538cad625$var$STATIC_TREES << 1, 3);
    $9fadf46538cad625$var$send_code(s, $9fadf46538cad625$var$END_BLOCK, $9fadf46538cad625$var$static_ltree);
    $9fadf46538cad625$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ var $9fadf46538cad625$var$_tr_flush_block$1 = function(s, buf, stored_len, last) {
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $9fadf46538cad625$var$Z_UNKNOWN$1) s.strm.data_type = $9fadf46538cad625$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $9fadf46538cad625$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $9fadf46538cad625$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $9fadf46538cad625$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $9fadf46538cad625$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $9fadf46538cad625$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $9fadf46538cad625$var$send_bits(s, ($9fadf46538cad625$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $9fadf46538cad625$var$compress_block(s, $9fadf46538cad625$var$static_ltree, $9fadf46538cad625$var$static_dtree);
    } else {
        $9fadf46538cad625$var$send_bits(s, ($9fadf46538cad625$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $9fadf46538cad625$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $9fadf46538cad625$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $9fadf46538cad625$var$init_block(s);
    if (last) $9fadf46538cad625$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ var $9fadf46538cad625$var$_tr_tally$1 = function(s, dist, lc) {
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($9fadf46538cad625$var$_length_code[lc] + $9fadf46538cad625$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$9fadf46538cad625$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $9fadf46538cad625$var$_tr_init_1 = $9fadf46538cad625$var$_tr_init$1;
var $9fadf46538cad625$var$_tr_stored_block_1 = $9fadf46538cad625$var$_tr_stored_block$1;
var $9fadf46538cad625$var$_tr_flush_block_1 = $9fadf46538cad625$var$_tr_flush_block$1;
var $9fadf46538cad625$var$_tr_tally_1 = $9fadf46538cad625$var$_tr_tally$1;
var $9fadf46538cad625$var$_tr_align_1 = $9fadf46538cad625$var$_tr_align$1;
var $9fadf46538cad625$var$trees = {
    _tr_init: $9fadf46538cad625$var$_tr_init_1,
    _tr_stored_block: $9fadf46538cad625$var$_tr_stored_block_1,
    _tr_flush_block: $9fadf46538cad625$var$_tr_flush_block_1,
    _tr_tally: $9fadf46538cad625$var$_tr_tally_1,
    _tr_align: $9fadf46538cad625$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $9fadf46538cad625$var$adler32 = function(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $9fadf46538cad625$var$adler32_1 = $9fadf46538cad625$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
var $9fadf46538cad625$var$makeTable = function() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
var $9fadf46538cad625$var$crcTable = new Uint32Array($9fadf46538cad625$var$makeTable());
var $9fadf46538cad625$var$crc32 = function(crc, buf, len, pos) {
    var t = $9fadf46538cad625$var$crcTable;
    var end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $9fadf46538cad625$var$crc32_1 = $9fadf46538cad625$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $9fadf46538cad625$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $9fadf46538cad625$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $9fadf46538cad625$var$_tr_init = $9fadf46538cad625$var$trees._tr_init, $9fadf46538cad625$var$_tr_stored_block = $9fadf46538cad625$var$trees._tr_stored_block, $9fadf46538cad625$var$_tr_flush_block = $9fadf46538cad625$var$trees._tr_flush_block, $9fadf46538cad625$var$_tr_tally = $9fadf46538cad625$var$trees._tr_tally, $9fadf46538cad625$var$_tr_align = $9fadf46538cad625$var$trees._tr_align;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $9fadf46538cad625$var$Z_NO_FLUSH$2 = $9fadf46538cad625$var$constants$2.Z_NO_FLUSH, $9fadf46538cad625$var$Z_PARTIAL_FLUSH = $9fadf46538cad625$var$constants$2.Z_PARTIAL_FLUSH, $9fadf46538cad625$var$Z_FULL_FLUSH$1 = $9fadf46538cad625$var$constants$2.Z_FULL_FLUSH, $9fadf46538cad625$var$Z_FINISH$3 = $9fadf46538cad625$var$constants$2.Z_FINISH, $9fadf46538cad625$var$Z_BLOCK$1 = $9fadf46538cad625$var$constants$2.Z_BLOCK, $9fadf46538cad625$var$Z_OK$3 = $9fadf46538cad625$var$constants$2.Z_OK, $9fadf46538cad625$var$Z_STREAM_END$3 = $9fadf46538cad625$var$constants$2.Z_STREAM_END, $9fadf46538cad625$var$Z_STREAM_ERROR$2 = $9fadf46538cad625$var$constants$2.Z_STREAM_ERROR, $9fadf46538cad625$var$Z_DATA_ERROR$2 = $9fadf46538cad625$var$constants$2.Z_DATA_ERROR, $9fadf46538cad625$var$Z_BUF_ERROR$1 = $9fadf46538cad625$var$constants$2.Z_BUF_ERROR, $9fadf46538cad625$var$Z_DEFAULT_COMPRESSION$1 = $9fadf46538cad625$var$constants$2.Z_DEFAULT_COMPRESSION, $9fadf46538cad625$var$Z_FILTERED = $9fadf46538cad625$var$constants$2.Z_FILTERED, $9fadf46538cad625$var$Z_HUFFMAN_ONLY = $9fadf46538cad625$var$constants$2.Z_HUFFMAN_ONLY, $9fadf46538cad625$var$Z_RLE = $9fadf46538cad625$var$constants$2.Z_RLE, $9fadf46538cad625$var$Z_FIXED = $9fadf46538cad625$var$constants$2.Z_FIXED, $9fadf46538cad625$var$Z_DEFAULT_STRATEGY$1 = $9fadf46538cad625$var$constants$2.Z_DEFAULT_STRATEGY, $9fadf46538cad625$var$Z_UNKNOWN = $9fadf46538cad625$var$constants$2.Z_UNKNOWN, $9fadf46538cad625$var$Z_DEFLATED$2 = $9fadf46538cad625$var$constants$2.Z_DEFLATED;
/*============================================================================*/ var $9fadf46538cad625$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $9fadf46538cad625$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ var $9fadf46538cad625$var$DEF_MEM_LEVEL = 8;
var $9fadf46538cad625$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $9fadf46538cad625$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $9fadf46538cad625$var$L_CODES = $9fadf46538cad625$var$LITERALS + 1 + $9fadf46538cad625$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $9fadf46538cad625$var$D_CODES = 30;
/* number of distance codes */ var $9fadf46538cad625$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $9fadf46538cad625$var$HEAP_SIZE = 2 * $9fadf46538cad625$var$L_CODES + 1;
/* maximum heap size */ var $9fadf46538cad625$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $9fadf46538cad625$var$MIN_MATCH = 3;
var $9fadf46538cad625$var$MAX_MATCH = 258;
var $9fadf46538cad625$var$MIN_LOOKAHEAD = $9fadf46538cad625$var$MAX_MATCH + $9fadf46538cad625$var$MIN_MATCH + 1;
var $9fadf46538cad625$var$PRESET_DICT = 0x20;
var $9fadf46538cad625$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
var $9fadf46538cad625$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
var $9fadf46538cad625$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
var $9fadf46538cad625$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
var $9fadf46538cad625$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
var $9fadf46538cad625$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
var $9fadf46538cad625$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
var $9fadf46538cad625$var$FINISH_STATE = 666; /* stream complete */ 
var $9fadf46538cad625$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $9fadf46538cad625$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $9fadf46538cad625$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $9fadf46538cad625$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $9fadf46538cad625$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
var $9fadf46538cad625$var$err = function(strm, errorCode) {
    strm.msg = $9fadf46538cad625$var$messages[errorCode];
    return errorCode;
};
var $9fadf46538cad625$var$rank = function(f) {
    return f * 2 - (f > 4 ? 9 : 0);
};
var $9fadf46538cad625$var$zero = function(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ var $9fadf46538cad625$var$slide_hash = function(s) {
    var n, m;
    var p;
    var wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ var $9fadf46538cad625$var$HASH_ZLIB = function(s, prev, data) {
    return (prev << s.hash_shift ^ data) & s.hash_mask;
};
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
var $9fadf46538cad625$var$HASH = $9fadf46538cad625$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ var $9fadf46538cad625$var$flush_pending = function(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
var $9fadf46538cad625$var$flush_block_only = function(s, last) {
    $9fadf46538cad625$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $9fadf46538cad625$var$flush_pending(s.strm);
};
var $9fadf46538cad625$var$put_byte = function(s, b) {
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ var $9fadf46538cad625$var$putShortMSB = function(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ var $9fadf46538cad625$var$read_buf = function(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $9fadf46538cad625$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ var $9fadf46538cad625$var$longest_match = function(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $9fadf46538cad625$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $9fadf46538cad625$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $9fadf46538cad625$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $9fadf46538cad625$var$MAX_MATCH - (strend - scan);
        scan = strend - $9fadf46538cad625$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ var $9fadf46538cad625$var$fill_window = function(s) {
    var _w_size = s.w_size;
    var n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $9fadf46538cad625$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $9fadf46538cad625$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $9fadf46538cad625$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $9fadf46538cad625$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[str + $9fadf46538cad625$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $9fadf46538cad625$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $9fadf46538cad625$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ var $9fadf46538cad625$var$deflate_stored = function(s, flush) {
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ var min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ var len, left, have, last = 0;
    var used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $9fadf46538cad625$var$Z_FINISH$3 || flush === $9fadf46538cad625$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $9fadf46538cad625$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $9fadf46538cad625$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $9fadf46538cad625$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $9fadf46538cad625$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $9fadf46538cad625$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $9fadf46538cad625$var$Z_NO_FLUSH$2 && flush !== $9fadf46538cad625$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $9fadf46538cad625$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $9fadf46538cad625$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $9fadf46538cad625$var$Z_FINISH$3) && flush !== $9fadf46538cad625$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $9fadf46538cad625$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $9fadf46538cad625$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $9fadf46538cad625$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $9fadf46538cad625$var$BS_FINISH_STARTED : $9fadf46538cad625$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ var $9fadf46538cad625$var$deflate_fast = function(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $9fadf46538cad625$var$MIN_LOOKAHEAD) {
            $9fadf46538cad625$var$fill_window(s);
            if (s.lookahead < $9fadf46538cad625$var$MIN_LOOKAHEAD && flush === $9fadf46538cad625$var$Z_NO_FLUSH$2) return $9fadf46538cad625$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $9fadf46538cad625$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[s.strstart + $9fadf46538cad625$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $9fadf46538cad625$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $9fadf46538cad625$var$longest_match(s, hash_head);
        if (s.match_length >= $9fadf46538cad625$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $9fadf46538cad625$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $9fadf46538cad625$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[s.strstart + $9fadf46538cad625$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $9fadf46538cad625$var$MIN_MATCH - 1 ? s.strstart : $9fadf46538cad625$var$MIN_MATCH - 1;
    if (flush === $9fadf46538cad625$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $9fadf46538cad625$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_FINISH_STARTED;
        /***/ return $9fadf46538cad625$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
    /***/ }
    return $9fadf46538cad625$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ var $9fadf46538cad625$var$deflate_slow = function(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $9fadf46538cad625$var$MIN_LOOKAHEAD) {
            $9fadf46538cad625$var$fill_window(s);
            if (s.lookahead < $9fadf46538cad625$var$MIN_LOOKAHEAD && flush === $9fadf46538cad625$var$Z_NO_FLUSH$2) return $9fadf46538cad625$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $9fadf46538cad625$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[s.strstart + $9fadf46538cad625$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $9fadf46538cad625$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $9fadf46538cad625$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $9fadf46538cad625$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $9fadf46538cad625$var$Z_FILTERED || s.match_length === $9fadf46538cad625$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $9fadf46538cad625$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $9fadf46538cad625$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $9fadf46538cad625$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $9fadf46538cad625$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $9fadf46538cad625$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[s.strstart + $9fadf46538cad625$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $9fadf46538cad625$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $9fadf46538cad625$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $9fadf46538cad625$var$MIN_MATCH - 1 ? s.strstart : $9fadf46538cad625$var$MIN_MATCH - 1;
    if (flush === $9fadf46538cad625$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $9fadf46538cad625$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_FINISH_STARTED;
        /***/ return $9fadf46538cad625$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
    /***/ }
    return $9fadf46538cad625$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ var $9fadf46538cad625$var$deflate_rle = function(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $9fadf46538cad625$var$MAX_MATCH) {
            $9fadf46538cad625$var$fill_window(s);
            if (s.lookahead <= $9fadf46538cad625$var$MAX_MATCH && flush === $9fadf46538cad625$var$Z_NO_FLUSH$2) return $9fadf46538cad625$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $9fadf46538cad625$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $9fadf46538cad625$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $9fadf46538cad625$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $9fadf46538cad625$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, 1, s.match_length - $9fadf46538cad625$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $9fadf46538cad625$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $9fadf46538cad625$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_FINISH_STARTED;
        /***/ return $9fadf46538cad625$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
    /***/ }
    return $9fadf46538cad625$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ var $9fadf46538cad625$var$deflate_huff = function(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $9fadf46538cad625$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $9fadf46538cad625$var$Z_NO_FLUSH$2) return $9fadf46538cad625$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $9fadf46538cad625$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $9fadf46538cad625$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $9fadf46538cad625$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_FINISH_STARTED;
        /***/ return $9fadf46538cad625$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $9fadf46538cad625$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $9fadf46538cad625$var$BS_NEED_MORE;
    /***/ }
    return $9fadf46538cad625$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $9fadf46538cad625$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $9fadf46538cad625$var$configuration_table = [
    /*      good lazy nice chain */ new $9fadf46538cad625$var$Config(0, 0, 0, 0, $9fadf46538cad625$var$deflate_stored),
    /* 0 store only */ new $9fadf46538cad625$var$Config(4, 4, 8, 4, $9fadf46538cad625$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $9fadf46538cad625$var$Config(4, 5, 16, 8, $9fadf46538cad625$var$deflate_fast),
    /* 2 */ new $9fadf46538cad625$var$Config(4, 6, 32, 32, $9fadf46538cad625$var$deflate_fast),
    /* 3 */ new $9fadf46538cad625$var$Config(4, 4, 16, 16, $9fadf46538cad625$var$deflate_slow),
    /* 4 lazy matches */ new $9fadf46538cad625$var$Config(8, 16, 32, 32, $9fadf46538cad625$var$deflate_slow),
    /* 5 */ new $9fadf46538cad625$var$Config(8, 16, 128, 128, $9fadf46538cad625$var$deflate_slow),
    /* 6 */ new $9fadf46538cad625$var$Config(8, 32, 128, 256, $9fadf46538cad625$var$deflate_slow),
    /* 7 */ new $9fadf46538cad625$var$Config(32, 128, 258, 1024, $9fadf46538cad625$var$deflate_slow),
    /* 8 */ new $9fadf46538cad625$var$Config(32, 258, 258, 4096, $9fadf46538cad625$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ var $9fadf46538cad625$var$lm_init = function(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $9fadf46538cad625$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $9fadf46538cad625$var$configuration_table[s.level].max_lazy;
    s.good_match = $9fadf46538cad625$var$configuration_table[s.level].good_length;
    s.nice_match = $9fadf46538cad625$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $9fadf46538cad625$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $9fadf46538cad625$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $9fadf46538cad625$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $9fadf46538cad625$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($9fadf46538cad625$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $9fadf46538cad625$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $9fadf46538cad625$var$BL_CODES + 1) * 2);
    $9fadf46538cad625$var$zero(this.dyn_ltree);
    $9fadf46538cad625$var$zero(this.dyn_dtree);
    $9fadf46538cad625$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($9fadf46538cad625$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $9fadf46538cad625$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $9fadf46538cad625$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $9fadf46538cad625$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $9fadf46538cad625$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ var $9fadf46538cad625$var$deflateStateCheck = function(strm) {
    if (!strm) return 1;
    var s = strm.state;
    if (!s || s.strm !== strm || s.status !== $9fadf46538cad625$var$INIT_STATE && //#ifdef GZIP
    s.status !== $9fadf46538cad625$var$GZIP_STATE && //#endif
    s.status !== $9fadf46538cad625$var$EXTRA_STATE && s.status !== $9fadf46538cad625$var$NAME_STATE && s.status !== $9fadf46538cad625$var$COMMENT_STATE && s.status !== $9fadf46538cad625$var$HCRC_STATE && s.status !== $9fadf46538cad625$var$BUSY_STATE && s.status !== $9fadf46538cad625$var$FINISH_STATE) return 1;
    return 0;
};
var $9fadf46538cad625$var$deflateResetKeep = function(strm) {
    if ($9fadf46538cad625$var$deflateStateCheck(strm)) return $9fadf46538cad625$var$err(strm, $9fadf46538cad625$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $9fadf46538cad625$var$Z_UNKNOWN;
    var s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $9fadf46538cad625$var$GZIP_STATE : //#endif
    s.wrap ? $9fadf46538cad625$var$INIT_STATE : $9fadf46538cad625$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $9fadf46538cad625$var$_tr_init(s);
    return $9fadf46538cad625$var$Z_OK$3;
};
var $9fadf46538cad625$var$deflateReset = function(strm) {
    var ret = $9fadf46538cad625$var$deflateResetKeep(strm);
    if (ret === $9fadf46538cad625$var$Z_OK$3) $9fadf46538cad625$var$lm_init(strm.state);
    return ret;
};
var $9fadf46538cad625$var$deflateSetHeader = function(strm, head) {
    if ($9fadf46538cad625$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $9fadf46538cad625$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $9fadf46538cad625$var$Z_OK$3;
};
var $9fadf46538cad625$var$deflateInit2 = function(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $9fadf46538cad625$var$Z_STREAM_ERROR$2;
    var wrap = 1;
    if (level === $9fadf46538cad625$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $9fadf46538cad625$var$MAX_MEM_LEVEL || method !== $9fadf46538cad625$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $9fadf46538cad625$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $9fadf46538cad625$var$err(strm, $9fadf46538cad625$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $9fadf46538cad625$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $9fadf46538cad625$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $9fadf46538cad625$var$MIN_MATCH - 1) / $9fadf46538cad625$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $9fadf46538cad625$var$deflateReset(strm);
};
var $9fadf46538cad625$var$deflateInit = function(strm, level) {
    return $9fadf46538cad625$var$deflateInit2(strm, level, $9fadf46538cad625$var$Z_DEFLATED$2, $9fadf46538cad625$var$MAX_WBITS$1, $9fadf46538cad625$var$DEF_MEM_LEVEL, $9fadf46538cad625$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ var $9fadf46538cad625$var$deflate$2 = function(strm, flush) {
    if ($9fadf46538cad625$var$deflateStateCheck(strm) || flush > $9fadf46538cad625$var$Z_BLOCK$1 || flush < 0) return strm ? $9fadf46538cad625$var$err(strm, $9fadf46538cad625$var$Z_STREAM_ERROR$2) : $9fadf46538cad625$var$Z_STREAM_ERROR$2;
    var s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $9fadf46538cad625$var$FINISH_STATE && flush !== $9fadf46538cad625$var$Z_FINISH$3) return $9fadf46538cad625$var$err(strm, strm.avail_out === 0 ? $9fadf46538cad625$var$Z_BUF_ERROR$1 : $9fadf46538cad625$var$Z_STREAM_ERROR$2);
    var old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $9fadf46538cad625$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $9fadf46538cad625$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $9fadf46538cad625$var$rank(flush) <= $9fadf46538cad625$var$rank(old_flush) && flush !== $9fadf46538cad625$var$Z_FINISH$3) return $9fadf46538cad625$var$err(strm, $9fadf46538cad625$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $9fadf46538cad625$var$FINISH_STATE && strm.avail_in !== 0) return $9fadf46538cad625$var$err(strm, $9fadf46538cad625$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $9fadf46538cad625$var$INIT_STATE && s.wrap === 0) s.status = $9fadf46538cad625$var$BUSY_STATE;
    if (s.status === $9fadf46538cad625$var$INIT_STATE) {
        /* zlib header */ var header = $9fadf46538cad625$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        var level_flags = -1;
        if (s.strategy >= $9fadf46538cad625$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $9fadf46538cad625$var$PRESET_DICT;
        header += 31 - header % 31;
        $9fadf46538cad625$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $9fadf46538cad625$var$putShortMSB(s, strm.adler >>> 16);
            $9fadf46538cad625$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $9fadf46538cad625$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $9fadf46538cad625$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $9fadf46538cad625$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $9fadf46538cad625$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $9fadf46538cad625$var$put_byte(s, 31);
        $9fadf46538cad625$var$put_byte(s, 139);
        $9fadf46538cad625$var$put_byte(s, 8);
        if (!s.gzhead) {
            $9fadf46538cad625$var$put_byte(s, 0);
            $9fadf46538cad625$var$put_byte(s, 0);
            $9fadf46538cad625$var$put_byte(s, 0);
            $9fadf46538cad625$var$put_byte(s, 0);
            $9fadf46538cad625$var$put_byte(s, 0);
            $9fadf46538cad625$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $9fadf46538cad625$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $9fadf46538cad625$var$put_byte(s, $9fadf46538cad625$var$OS_CODE);
            s.status = $9fadf46538cad625$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $9fadf46538cad625$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $9fadf46538cad625$var$Z_OK$3;
            }
        } else {
            $9fadf46538cad625$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $9fadf46538cad625$var$put_byte(s, s.gzhead.time & 0xff);
            $9fadf46538cad625$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $9fadf46538cad625$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $9fadf46538cad625$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $9fadf46538cad625$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $9fadf46538cad625$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $9fadf46538cad625$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $9fadf46538cad625$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $9fadf46538cad625$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $9fadf46538cad625$var$EXTRA_STATE;
        }
    }
    if (s.status === $9fadf46538cad625$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            var beg = s.pending; /* start of bytes to update crc */ 
            var left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                var copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $9fadf46538cad625$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $9fadf46538cad625$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            var gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $9fadf46538cad625$var$NAME_STATE;
    }
    if (s.status === $9fadf46538cad625$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            var beg1 = s.pending; /* start of bytes to update crc */ 
            var val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg1) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg1, beg1);
                    //---//
                    $9fadf46538cad625$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $9fadf46538cad625$var$Z_OK$3;
                    }
                    beg1 = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $9fadf46538cad625$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg1) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg1, beg1);
            //---//
            s.gzindex = 0;
        }
        s.status = $9fadf46538cad625$var$COMMENT_STATE;
    }
    if (s.status === $9fadf46538cad625$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            var beg2 = s.pending; /* start of bytes to update crc */ 
            var val1;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg2) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg2, beg2);
                    //---//
                    $9fadf46538cad625$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $9fadf46538cad625$var$Z_OK$3;
                    }
                    beg2 = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val1 = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val1 = 0;
                $9fadf46538cad625$var$put_byte(s, val1);
            }while (val1 !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg2) strm.adler = $9fadf46538cad625$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg2, beg2);
        //---//
        }
        s.status = $9fadf46538cad625$var$HCRC_STATE;
    }
    if (s.status === $9fadf46538cad625$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $9fadf46538cad625$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $9fadf46538cad625$var$Z_OK$3;
                }
            }
            $9fadf46538cad625$var$put_byte(s, strm.adler & 0xff);
            $9fadf46538cad625$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $9fadf46538cad625$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $9fadf46538cad625$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $9fadf46538cad625$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $9fadf46538cad625$var$Z_NO_FLUSH$2 && s.status !== $9fadf46538cad625$var$FINISH_STATE) {
        var bstate = s.level === 0 ? $9fadf46538cad625$var$deflate_stored(s, flush) : s.strategy === $9fadf46538cad625$var$Z_HUFFMAN_ONLY ? $9fadf46538cad625$var$deflate_huff(s, flush) : s.strategy === $9fadf46538cad625$var$Z_RLE ? $9fadf46538cad625$var$deflate_rle(s, flush) : $9fadf46538cad625$var$configuration_table[s.level].func(s, flush);
        if (bstate === $9fadf46538cad625$var$BS_FINISH_STARTED || bstate === $9fadf46538cad625$var$BS_FINISH_DONE) s.status = $9fadf46538cad625$var$FINISH_STATE;
        if (bstate === $9fadf46538cad625$var$BS_NEED_MORE || bstate === $9fadf46538cad625$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $9fadf46538cad625$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $9fadf46538cad625$var$BS_BLOCK_DONE) {
            if (flush === $9fadf46538cad625$var$Z_PARTIAL_FLUSH) $9fadf46538cad625$var$_tr_align(s);
            else if (flush !== $9fadf46538cad625$var$Z_BLOCK$1) {
                $9fadf46538cad625$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $9fadf46538cad625$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $9fadf46538cad625$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $9fadf46538cad625$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $9fadf46538cad625$var$Z_OK$3;
            }
        }
    }
    if (flush !== $9fadf46538cad625$var$Z_FINISH$3) return $9fadf46538cad625$var$Z_OK$3;
    if (s.wrap <= 0) return $9fadf46538cad625$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $9fadf46538cad625$var$put_byte(s, strm.adler & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.adler >> 8 & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.adler >> 16 & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.adler >> 24 & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.total_in & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $9fadf46538cad625$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $9fadf46538cad625$var$putShortMSB(s, strm.adler >>> 16);
        $9fadf46538cad625$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $9fadf46538cad625$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $9fadf46538cad625$var$Z_OK$3 : $9fadf46538cad625$var$Z_STREAM_END$3;
};
var $9fadf46538cad625$var$deflateEnd = function(strm) {
    if ($9fadf46538cad625$var$deflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$2;
    var status = strm.state.status;
    strm.state = null;
    return status === $9fadf46538cad625$var$BUSY_STATE ? $9fadf46538cad625$var$err(strm, $9fadf46538cad625$var$Z_DATA_ERROR$2) : $9fadf46538cad625$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ var $9fadf46538cad625$var$deflateSetDictionary = function(strm, dictionary) {
    var dictLength = dictionary.length;
    if ($9fadf46538cad625$var$deflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$2;
    var s = strm.state;
    var wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $9fadf46538cad625$var$INIT_STATE || s.lookahead) return $9fadf46538cad625$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $9fadf46538cad625$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $9fadf46538cad625$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        var tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ var avail = strm.avail_in;
    var next = strm.next_in;
    var input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $9fadf46538cad625$var$fill_window(s);
    while(s.lookahead >= $9fadf46538cad625$var$MIN_MATCH){
        var str = s.strstart;
        var n = s.lookahead - ($9fadf46538cad625$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $9fadf46538cad625$var$HASH(s, s.ins_h, s.window[str + $9fadf46538cad625$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $9fadf46538cad625$var$MIN_MATCH - 1;
        $9fadf46538cad625$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $9fadf46538cad625$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $9fadf46538cad625$var$Z_OK$3;
};
var $9fadf46538cad625$var$deflateInit_1 = $9fadf46538cad625$var$deflateInit;
var $9fadf46538cad625$var$deflateInit2_1 = $9fadf46538cad625$var$deflateInit2;
var $9fadf46538cad625$var$deflateReset_1 = $9fadf46538cad625$var$deflateReset;
var $9fadf46538cad625$var$deflateResetKeep_1 = $9fadf46538cad625$var$deflateResetKeep;
var $9fadf46538cad625$var$deflateSetHeader_1 = $9fadf46538cad625$var$deflateSetHeader;
var $9fadf46538cad625$var$deflate_2$1 = $9fadf46538cad625$var$deflate$2;
var $9fadf46538cad625$var$deflateEnd_1 = $9fadf46538cad625$var$deflateEnd;
var $9fadf46538cad625$var$deflateSetDictionary_1 = $9fadf46538cad625$var$deflateSetDictionary;
var $9fadf46538cad625$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $9fadf46538cad625$var$deflate_1$2 = {
    deflateInit: $9fadf46538cad625$var$deflateInit_1,
    deflateInit2: $9fadf46538cad625$var$deflateInit2_1,
    deflateReset: $9fadf46538cad625$var$deflateReset_1,
    deflateResetKeep: $9fadf46538cad625$var$deflateResetKeep_1,
    deflateSetHeader: $9fadf46538cad625$var$deflateSetHeader_1,
    deflate: $9fadf46538cad625$var$deflate_2$1,
    deflateEnd: $9fadf46538cad625$var$deflateEnd_1,
    deflateSetDictionary: $9fadf46538cad625$var$deflateSetDictionary_1,
    deflateInfo: $9fadf46538cad625$var$deflateInfo
};
var $9fadf46538cad625$var$_has = function(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $9fadf46538cad625$var$assign = function assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($9fadf46538cad625$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $9fadf46538cad625$var$flattenChunks = function(chunks) {
    // calculate data length
    var len = 0;
    for(var i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    var result = new Uint8Array(len);
    for(var i1 = 0, pos = 0, l1 = chunks.length; i1 < l1; i1++){
        var chunk = chunks[i1];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $9fadf46538cad625$var$common = {
    assign: $9fadf46538cad625$var$assign,
    flattenChunks: $9fadf46538cad625$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $9fadf46538cad625$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $9fadf46538cad625$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $9fadf46538cad625$var$_utf8len = new Uint8Array(256);
for(var $9fadf46538cad625$var$q = 0; $9fadf46538cad625$var$q < 256; $9fadf46538cad625$var$q++)$9fadf46538cad625$var$_utf8len[$9fadf46538cad625$var$q] = $9fadf46538cad625$var$q >= 252 ? 6 : $9fadf46538cad625$var$q >= 248 ? 5 : $9fadf46538cad625$var$q >= 240 ? 4 : $9fadf46538cad625$var$q >= 224 ? 3 : $9fadf46538cad625$var$q >= 192 ? 2 : 1;
$9fadf46538cad625$var$_utf8len[254] = $9fadf46538cad625$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $9fadf46538cad625$var$string2buf = function(str) {
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
var $9fadf46538cad625$var$buf2binstring = function(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $9fadf46538cad625$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $9fadf46538cad625$var$buf2string = function(buf, max) {
    var len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    var i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        var c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        var c_len = $9fadf46538cad625$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $9fadf46538cad625$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $9fadf46538cad625$var$utf8border = function(buf, max) {
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    var pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $9fadf46538cad625$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $9fadf46538cad625$var$strings = {
    string2buf: $9fadf46538cad625$var$string2buf,
    buf2string: $9fadf46538cad625$var$buf2string,
    utf8border: $9fadf46538cad625$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $9fadf46538cad625$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $9fadf46538cad625$var$zstream = $9fadf46538cad625$var$ZStream;
var $9fadf46538cad625$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $9fadf46538cad625$var$Z_NO_FLUSH$1 = $9fadf46538cad625$var$constants$2.Z_NO_FLUSH, $9fadf46538cad625$var$Z_SYNC_FLUSH = $9fadf46538cad625$var$constants$2.Z_SYNC_FLUSH, $9fadf46538cad625$var$Z_FULL_FLUSH = $9fadf46538cad625$var$constants$2.Z_FULL_FLUSH, $9fadf46538cad625$var$Z_FINISH$2 = $9fadf46538cad625$var$constants$2.Z_FINISH, $9fadf46538cad625$var$Z_OK$2 = $9fadf46538cad625$var$constants$2.Z_OK, $9fadf46538cad625$var$Z_STREAM_END$2 = $9fadf46538cad625$var$constants$2.Z_STREAM_END, $9fadf46538cad625$var$Z_DEFAULT_COMPRESSION = $9fadf46538cad625$var$constants$2.Z_DEFAULT_COMPRESSION, $9fadf46538cad625$var$Z_DEFAULT_STRATEGY = $9fadf46538cad625$var$constants$2.Z_DEFAULT_STRATEGY, $9fadf46538cad625$var$Z_DEFLATED$1 = $9fadf46538cad625$var$constants$2.Z_DEFLATED;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $9fadf46538cad625$var$Deflate$1(options) {
    this.options = $9fadf46538cad625$var$common.assign({
        level: $9fadf46538cad625$var$Z_DEFAULT_COMPRESSION,
        method: $9fadf46538cad625$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $9fadf46538cad625$var$Z_DEFAULT_STRATEGY
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9fadf46538cad625$var$zstream();
    this.strm.avail_out = 0;
    var status = $9fadf46538cad625$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $9fadf46538cad625$var$Z_OK$2) throw new Error($9fadf46538cad625$var$messages[status]);
    if (opt.header) $9fadf46538cad625$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $9fadf46538cad625$var$strings.string2buf(opt.dictionary);
        else if ($9fadf46538cad625$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $9fadf46538cad625$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $9fadf46538cad625$var$Z_OK$2) throw new Error($9fadf46538cad625$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $9fadf46538cad625$var$Deflate$1.prototype.push = function(data, flush_mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $9fadf46538cad625$var$Z_FINISH$2 : $9fadf46538cad625$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $9fadf46538cad625$var$strings.string2buf(data);
    else if ($9fadf46538cad625$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $9fadf46538cad625$var$Z_SYNC_FLUSH || _flush_mode === $9fadf46538cad625$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $9fadf46538cad625$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $9fadf46538cad625$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $9fadf46538cad625$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $9fadf46538cad625$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $9fadf46538cad625$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $9fadf46538cad625$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $9fadf46538cad625$var$Z_OK$2) this.result = $9fadf46538cad625$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $9fadf46538cad625$var$deflate$1(input, options) {
    var deflator = new $9fadf46538cad625$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $9fadf46538cad625$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $9fadf46538cad625$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $9fadf46538cad625$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $9fadf46538cad625$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $9fadf46538cad625$var$deflate$1(input, options);
}
var $9fadf46538cad625$var$Deflate_1$1 = $9fadf46538cad625$var$Deflate$1;
var $9fadf46538cad625$var$deflate_2 = $9fadf46538cad625$var$deflate$1;
var $9fadf46538cad625$var$deflateRaw_1$1 = $9fadf46538cad625$var$deflateRaw$1;
var $9fadf46538cad625$var$gzip_1$1 = $9fadf46538cad625$var$gzip$1;
var $9fadf46538cad625$var$constants$1 = $9fadf46538cad625$var$constants$2;
var $9fadf46538cad625$var$deflate_1$1 = {
    Deflate: $9fadf46538cad625$var$Deflate_1$1,
    deflate: $9fadf46538cad625$var$deflate_2,
    deflateRaw: $9fadf46538cad625$var$deflateRaw_1$1,
    gzip: $9fadf46538cad625$var$gzip_1$1,
    constants: $9fadf46538cad625$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $9fadf46538cad625$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
var $9fadf46538cad625$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $9fadf46538cad625$var$inffast = function inflate_fast(strm, start) {
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ var state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $9fadf46538cad625$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $9fadf46538cad625$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $9fadf46538cad625$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $9fadf46538cad625$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $9fadf46538cad625$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $9fadf46538cad625$var$MAXBITS = 15;
var $9fadf46538cad625$var$ENOUGH_LENS$1 = 852;
var $9fadf46538cad625$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $9fadf46538cad625$var$CODES$1 = 0;
var $9fadf46538cad625$var$LENS$1 = 1;
var $9fadf46538cad625$var$DISTS$1 = 2;
var $9fadf46538cad625$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
var $9fadf46538cad625$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
var $9fadf46538cad625$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
var $9fadf46538cad625$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
var $9fadf46538cad625$var$inflate_table = function(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    var match; /* use base and extra for symbol >= match */ 
    var count = new Uint16Array($9fadf46538cad625$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new Uint16Array($9fadf46538cad625$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $9fadf46538cad625$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $9fadf46538cad625$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $9fadf46538cad625$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $9fadf46538cad625$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $9fadf46538cad625$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $9fadf46538cad625$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $9fadf46538cad625$var$LENS$1) {
        base = $9fadf46538cad625$var$lbase;
        extra = $9fadf46538cad625$var$lext;
        match = 257;
    } else {
        base = $9fadf46538cad625$var$dbase;
        extra = $9fadf46538cad625$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $9fadf46538cad625$var$LENS$1 && used > $9fadf46538cad625$var$ENOUGH_LENS$1 || type === $9fadf46538cad625$var$DISTS$1 && used > $9fadf46538cad625$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $9fadf46538cad625$var$LENS$1 && used > $9fadf46538cad625$var$ENOUGH_LENS$1 || type === $9fadf46538cad625$var$DISTS$1 && used > $9fadf46538cad625$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $9fadf46538cad625$var$inftrees = $9fadf46538cad625$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $9fadf46538cad625$var$CODES = 0;
var $9fadf46538cad625$var$LENS = 1;
var $9fadf46538cad625$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $9fadf46538cad625$var$Z_FINISH$1 = $9fadf46538cad625$var$constants$2.Z_FINISH, $9fadf46538cad625$var$Z_BLOCK = $9fadf46538cad625$var$constants$2.Z_BLOCK, $9fadf46538cad625$var$Z_TREES = $9fadf46538cad625$var$constants$2.Z_TREES, $9fadf46538cad625$var$Z_OK$1 = $9fadf46538cad625$var$constants$2.Z_OK, $9fadf46538cad625$var$Z_STREAM_END$1 = $9fadf46538cad625$var$constants$2.Z_STREAM_END, $9fadf46538cad625$var$Z_NEED_DICT$1 = $9fadf46538cad625$var$constants$2.Z_NEED_DICT, $9fadf46538cad625$var$Z_STREAM_ERROR$1 = $9fadf46538cad625$var$constants$2.Z_STREAM_ERROR, $9fadf46538cad625$var$Z_DATA_ERROR$1 = $9fadf46538cad625$var$constants$2.Z_DATA_ERROR, $9fadf46538cad625$var$Z_MEM_ERROR$1 = $9fadf46538cad625$var$constants$2.Z_MEM_ERROR, $9fadf46538cad625$var$Z_BUF_ERROR = $9fadf46538cad625$var$constants$2.Z_BUF_ERROR, $9fadf46538cad625$var$Z_DEFLATED = $9fadf46538cad625$var$constants$2.Z_DEFLATED;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $9fadf46538cad625$var$HEAD = 16180; /* i: waiting for magic header */ 
var $9fadf46538cad625$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
var $9fadf46538cad625$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
var $9fadf46538cad625$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
var $9fadf46538cad625$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
var $9fadf46538cad625$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
var $9fadf46538cad625$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
var $9fadf46538cad625$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
var $9fadf46538cad625$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
var $9fadf46538cad625$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
var $9fadf46538cad625$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
var $9fadf46538cad625$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
var $9fadf46538cad625$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
var $9fadf46538cad625$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
var $9fadf46538cad625$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
var $9fadf46538cad625$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
var $9fadf46538cad625$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
var $9fadf46538cad625$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
var $9fadf46538cad625$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
var $9fadf46538cad625$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
var $9fadf46538cad625$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
var $9fadf46538cad625$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
var $9fadf46538cad625$var$DIST = 16202; /* i: waiting for distance code */ 
var $9fadf46538cad625$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
var $9fadf46538cad625$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
var $9fadf46538cad625$var$LIT = 16205; /* o: waiting for output space to write literal */ 
var $9fadf46538cad625$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
var $9fadf46538cad625$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
var $9fadf46538cad625$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
var $9fadf46538cad625$var$BAD = 16209; /* got a data error -- remain here until reset */ 
var $9fadf46538cad625$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
var $9fadf46538cad625$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $9fadf46538cad625$var$ENOUGH_LENS = 852;
var $9fadf46538cad625$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $9fadf46538cad625$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $9fadf46538cad625$var$DEF_WBITS = $9fadf46538cad625$var$MAX_WBITS;
var $9fadf46538cad625$var$zswap32 = function(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $9fadf46538cad625$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
var $9fadf46538cad625$var$inflateStateCheck = function(strm) {
    if (!strm) return 1;
    var state = strm.state;
    if (!state || state.strm !== strm || state.mode < $9fadf46538cad625$var$HEAD || state.mode > $9fadf46538cad625$var$SYNC) return 1;
    return 0;
};
var $9fadf46538cad625$var$inflateResetKeep = function(strm) {
    if ($9fadf46538cad625$var$inflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $9fadf46538cad625$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($9fadf46538cad625$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($9fadf46538cad625$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $9fadf46538cad625$var$Z_OK$1;
};
var $9fadf46538cad625$var$inflateReset = function(strm) {
    if ($9fadf46538cad625$var$inflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $9fadf46538cad625$var$inflateResetKeep(strm);
};
var $9fadf46538cad625$var$inflateReset2 = function(strm, windowBits) {
    var wrap;
    /* get the state */ if ($9fadf46538cad625$var$inflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $9fadf46538cad625$var$inflateReset(strm);
};
var $9fadf46538cad625$var$inflateInit2 = function(strm, windowBits) {
    if (!strm) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    var state = new $9fadf46538cad625$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $9fadf46538cad625$var$HEAD; /* to pass state test in inflateReset2() */ 
    var ret = $9fadf46538cad625$var$inflateReset2(strm, windowBits);
    if (ret !== $9fadf46538cad625$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
var $9fadf46538cad625$var$inflateInit = function(strm) {
    return $9fadf46538cad625$var$inflateInit2(strm, $9fadf46538cad625$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $9fadf46538cad625$var$virgin = true;
var $9fadf46538cad625$var$lenfix, $9fadf46538cad625$var$distfix; // We have no pointers in JS, so keep tables separate
var $9fadf46538cad625$var$fixedtables = function(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($9fadf46538cad625$var$virgin) {
        $9fadf46538cad625$var$lenfix = new Int32Array(512);
        $9fadf46538cad625$var$distfix = new Int32Array(32);
        /* literal/length table */ var sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $9fadf46538cad625$var$inftrees($9fadf46538cad625$var$LENS, state.lens, 0, 288, $9fadf46538cad625$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $9fadf46538cad625$var$inftrees($9fadf46538cad625$var$DISTS, state.lens, 0, 32, $9fadf46538cad625$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $9fadf46538cad625$var$virgin = false;
    }
    state.lencode = $9fadf46538cad625$var$lenfix;
    state.lenbits = 9;
    state.distcode = $9fadf46538cad625$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ var $9fadf46538cad625$var$updatewindow = function(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
var $9fadf46538cad625$var$inflate$2 = function(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary variable for NEED_BITS
    var order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($9fadf46538cad625$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $9fadf46538cad625$var$TYPE) state.mode = $9fadf46538cad625$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $9fadf46538cad625$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $9fadf46538cad625$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $9fadf46538cad625$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $9fadf46538cad625$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $9fadf46538cad625$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $9fadf46538cad625$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $9fadf46538cad625$var$DICTID : $9fadf46538cad625$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $9fadf46538cad625$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $9fadf46538cad625$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $9fadf46538cad625$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $9fadf46538cad625$var$TIME;
        /* falls through */ case $9fadf46538cad625$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $9fadf46538cad625$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $9fadf46538cad625$var$OS;
        /* falls through */ case $9fadf46538cad625$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $9fadf46538cad625$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $9fadf46538cad625$var$EXLEN;
        /* falls through */ case $9fadf46538cad625$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $9fadf46538cad625$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $9fadf46538cad625$var$EXTRA;
        /* falls through */ case $9fadf46538cad625$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $9fadf46538cad625$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $9fadf46538cad625$var$NAME;
        /* falls through */ case $9fadf46538cad625$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $9fadf46538cad625$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $9fadf46538cad625$var$COMMENT;
        /* falls through */ case $9fadf46538cad625$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $9fadf46538cad625$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $9fadf46538cad625$var$HCRC;
        /* falls through */ case $9fadf46538cad625$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $9fadf46538cad625$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $9fadf46538cad625$var$TYPE;
            break;
        case $9fadf46538cad625$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $9fadf46538cad625$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $9fadf46538cad625$var$DICT;
        /* falls through */ case $9fadf46538cad625$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $9fadf46538cad625$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $9fadf46538cad625$var$TYPE;
        /* falls through */ case $9fadf46538cad625$var$TYPE:
            if (flush === $9fadf46538cad625$var$Z_BLOCK || flush === $9fadf46538cad625$var$Z_TREES) break inf_leave;
        /* falls through */ case $9fadf46538cad625$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $9fadf46538cad625$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $9fadf46538cad625$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $9fadf46538cad625$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $9fadf46538cad625$var$LEN_; /* decode codes */ 
                    if (flush === $9fadf46538cad625$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $9fadf46538cad625$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $9fadf46538cad625$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $9fadf46538cad625$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $9fadf46538cad625$var$COPY_;
            if (flush === $9fadf46538cad625$var$Z_TREES) break inf_leave;
        /* falls through */ case $9fadf46538cad625$var$COPY_:
            state.mode = $9fadf46538cad625$var$COPY;
        /* falls through */ case $9fadf46538cad625$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $9fadf46538cad625$var$TYPE;
            break;
        case $9fadf46538cad625$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $9fadf46538cad625$var$LENLENS;
        /* falls through */ case $9fadf46538cad625$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $9fadf46538cad625$var$inftrees($9fadf46538cad625$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $9fadf46538cad625$var$CODELENS;
        /* falls through */ case $9fadf46538cad625$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $9fadf46538cad625$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $9fadf46538cad625$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $9fadf46538cad625$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $9fadf46538cad625$var$inftrees($9fadf46538cad625$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $9fadf46538cad625$var$inftrees($9fadf46538cad625$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $9fadf46538cad625$var$LEN_;
            if (flush === $9fadf46538cad625$var$Z_TREES) break inf_leave;
        /* falls through */ case $9fadf46538cad625$var$LEN_:
            state.mode = $9fadf46538cad625$var$LEN;
        /* falls through */ case $9fadf46538cad625$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $9fadf46538cad625$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $9fadf46538cad625$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $9fadf46538cad625$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $9fadf46538cad625$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $9fadf46538cad625$var$LENEXT;
        /* falls through */ case $9fadf46538cad625$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $9fadf46538cad625$var$DIST;
        /* falls through */ case $9fadf46538cad625$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $9fadf46538cad625$var$DISTEXT;
        /* falls through */ case $9fadf46538cad625$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $9fadf46538cad625$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $9fadf46538cad625$var$MATCH;
        /* falls through */ case $9fadf46538cad625$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $9fadf46538cad625$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $9fadf46538cad625$var$LEN;
            break;
        case $9fadf46538cad625$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $9fadf46538cad625$var$LEN;
            break;
        case $9fadf46538cad625$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $9fadf46538cad625$var$crc32_1(state.check, output, _out, put - _out) : $9fadf46538cad625$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $9fadf46538cad625$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $9fadf46538cad625$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $9fadf46538cad625$var$LENGTH;
        /* falls through */ case $9fadf46538cad625$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $9fadf46538cad625$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $9fadf46538cad625$var$DONE;
        /* falls through */ case $9fadf46538cad625$var$DONE:
            ret = $9fadf46538cad625$var$Z_STREAM_END$1;
            break inf_leave;
        case $9fadf46538cad625$var$BAD:
            ret = $9fadf46538cad625$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $9fadf46538cad625$var$MEM:
            return $9fadf46538cad625$var$Z_MEM_ERROR$1;
        case $9fadf46538cad625$var$SYNC:
        /* falls through */ default:
            return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $9fadf46538cad625$var$BAD && (state.mode < $9fadf46538cad625$var$CHECK || flush !== $9fadf46538cad625$var$Z_FINISH$1)) $9fadf46538cad625$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $9fadf46538cad625$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $9fadf46538cad625$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $9fadf46538cad625$var$TYPE ? 128 : 0) + (state.mode === $9fadf46538cad625$var$LEN_ || state.mode === $9fadf46538cad625$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $9fadf46538cad625$var$Z_FINISH$1) && ret === $9fadf46538cad625$var$Z_OK$1) ret = $9fadf46538cad625$var$Z_BUF_ERROR;
    return ret;
};
var $9fadf46538cad625$var$inflateEnd = function(strm) {
    if ($9fadf46538cad625$var$inflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $9fadf46538cad625$var$Z_OK$1;
};
var $9fadf46538cad625$var$inflateGetHeader = function(strm, head) {
    /* check state */ if ($9fadf46538cad625$var$inflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    var state = strm.state;
    if ((state.wrap & 2) === 0) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $9fadf46538cad625$var$Z_OK$1;
};
var $9fadf46538cad625$var$inflateSetDictionary = function(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if ($9fadf46538cad625$var$inflateStateCheck(strm)) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $9fadf46538cad625$var$DICT) return $9fadf46538cad625$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $9fadf46538cad625$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $9fadf46538cad625$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $9fadf46538cad625$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $9fadf46538cad625$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $9fadf46538cad625$var$MEM;
        return $9fadf46538cad625$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $9fadf46538cad625$var$Z_OK$1;
};
var $9fadf46538cad625$var$inflateReset_1 = $9fadf46538cad625$var$inflateReset;
var $9fadf46538cad625$var$inflateReset2_1 = $9fadf46538cad625$var$inflateReset2;
var $9fadf46538cad625$var$inflateResetKeep_1 = $9fadf46538cad625$var$inflateResetKeep;
var $9fadf46538cad625$var$inflateInit_1 = $9fadf46538cad625$var$inflateInit;
var $9fadf46538cad625$var$inflateInit2_1 = $9fadf46538cad625$var$inflateInit2;
var $9fadf46538cad625$var$inflate_2$1 = $9fadf46538cad625$var$inflate$2;
var $9fadf46538cad625$var$inflateEnd_1 = $9fadf46538cad625$var$inflateEnd;
var $9fadf46538cad625$var$inflateGetHeader_1 = $9fadf46538cad625$var$inflateGetHeader;
var $9fadf46538cad625$var$inflateSetDictionary_1 = $9fadf46538cad625$var$inflateSetDictionary;
var $9fadf46538cad625$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $9fadf46538cad625$var$inflate_1$2 = {
    inflateReset: $9fadf46538cad625$var$inflateReset_1,
    inflateReset2: $9fadf46538cad625$var$inflateReset2_1,
    inflateResetKeep: $9fadf46538cad625$var$inflateResetKeep_1,
    inflateInit: $9fadf46538cad625$var$inflateInit_1,
    inflateInit2: $9fadf46538cad625$var$inflateInit2_1,
    inflate: $9fadf46538cad625$var$inflate_2$1,
    inflateEnd: $9fadf46538cad625$var$inflateEnd_1,
    inflateGetHeader: $9fadf46538cad625$var$inflateGetHeader_1,
    inflateSetDictionary: $9fadf46538cad625$var$inflateSetDictionary_1,
    inflateInfo: $9fadf46538cad625$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $9fadf46538cad625$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $9fadf46538cad625$var$gzheader = $9fadf46538cad625$var$GZheader;
var $9fadf46538cad625$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $9fadf46538cad625$var$Z_NO_FLUSH = $9fadf46538cad625$var$constants$2.Z_NO_FLUSH, $9fadf46538cad625$var$Z_FINISH = $9fadf46538cad625$var$constants$2.Z_FINISH, $9fadf46538cad625$var$Z_OK = $9fadf46538cad625$var$constants$2.Z_OK, $9fadf46538cad625$var$Z_STREAM_END = $9fadf46538cad625$var$constants$2.Z_STREAM_END, $9fadf46538cad625$var$Z_NEED_DICT = $9fadf46538cad625$var$constants$2.Z_NEED_DICT, $9fadf46538cad625$var$Z_STREAM_ERROR = $9fadf46538cad625$var$constants$2.Z_STREAM_ERROR, $9fadf46538cad625$var$Z_DATA_ERROR = $9fadf46538cad625$var$constants$2.Z_DATA_ERROR, $9fadf46538cad625$var$Z_MEM_ERROR = $9fadf46538cad625$var$constants$2.Z_MEM_ERROR;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $9fadf46538cad625$var$Inflate$1(options) {
    this.options = $9fadf46538cad625$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9fadf46538cad625$var$zstream();
    this.strm.avail_out = 0;
    var status = $9fadf46538cad625$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $9fadf46538cad625$var$Z_OK) throw new Error($9fadf46538cad625$var$messages[status]);
    this.header = new $9fadf46538cad625$var$gzheader();
    $9fadf46538cad625$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $9fadf46538cad625$var$strings.string2buf(opt.dictionary);
        else if ($9fadf46538cad625$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $9fadf46538cad625$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $9fadf46538cad625$var$Z_OK) throw new Error($9fadf46538cad625$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $9fadf46538cad625$var$Inflate$1.prototype.push = function(data, flush_mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $9fadf46538cad625$var$Z_FINISH : $9fadf46538cad625$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($9fadf46538cad625$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $9fadf46538cad625$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $9fadf46538cad625$var$Z_NEED_DICT && dictionary) {
            status = $9fadf46538cad625$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $9fadf46538cad625$var$Z_OK) status = $9fadf46538cad625$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $9fadf46538cad625$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $9fadf46538cad625$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $9fadf46538cad625$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $9fadf46538cad625$var$inflate_1$2.inflateReset(strm);
            status = $9fadf46538cad625$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $9fadf46538cad625$var$Z_STREAM_ERROR:
            case $9fadf46538cad625$var$Z_DATA_ERROR:
            case $9fadf46538cad625$var$Z_NEED_DICT:
            case $9fadf46538cad625$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $9fadf46538cad625$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    var next_out_utf8 = $9fadf46538cad625$var$strings.utf8border(strm.output, strm.next_out);
                    var tail = strm.next_out - next_out_utf8;
                    var utf8str = $9fadf46538cad625$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $9fadf46538cad625$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $9fadf46538cad625$var$Z_STREAM_END) {
            status = $9fadf46538cad625$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $9fadf46538cad625$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $9fadf46538cad625$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $9fadf46538cad625$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $9fadf46538cad625$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $9fadf46538cad625$var$inflate$1(input, options) {
    var inflator = new $9fadf46538cad625$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $9fadf46538cad625$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $9fadf46538cad625$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $9fadf46538cad625$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $9fadf46538cad625$var$Inflate_1$1 = $9fadf46538cad625$var$Inflate$1;
var $9fadf46538cad625$var$inflate_2 = $9fadf46538cad625$var$inflate$1;
var $9fadf46538cad625$var$inflateRaw_1$1 = $9fadf46538cad625$var$inflateRaw$1;
var $9fadf46538cad625$var$ungzip$1 = $9fadf46538cad625$var$inflate$1;
var $9fadf46538cad625$var$constants = $9fadf46538cad625$var$constants$2;
var $9fadf46538cad625$var$inflate_1$1 = {
    Inflate: $9fadf46538cad625$var$Inflate_1$1,
    inflate: $9fadf46538cad625$var$inflate_2,
    inflateRaw: $9fadf46538cad625$var$inflateRaw_1$1,
    ungzip: $9fadf46538cad625$var$ungzip$1,
    constants: $9fadf46538cad625$var$constants
};
var $9fadf46538cad625$var$Deflate = $9fadf46538cad625$var$deflate_1$1.Deflate, $9fadf46538cad625$var$deflate = $9fadf46538cad625$var$deflate_1$1.deflate, $9fadf46538cad625$var$deflateRaw = $9fadf46538cad625$var$deflate_1$1.deflateRaw, $9fadf46538cad625$var$gzip = $9fadf46538cad625$var$deflate_1$1.gzip;
var $9fadf46538cad625$var$Inflate = $9fadf46538cad625$var$inflate_1$1.Inflate, $9fadf46538cad625$var$inflate = $9fadf46538cad625$var$inflate_1$1.inflate, $9fadf46538cad625$var$inflateRaw = $9fadf46538cad625$var$inflate_1$1.inflateRaw, $9fadf46538cad625$var$ungzip = $9fadf46538cad625$var$inflate_1$1.ungzip;
var $9fadf46538cad625$export$ae157b6234afe138 = $9fadf46538cad625$var$Deflate;
var $9fadf46538cad625$export$2316623ecd1285ab = $9fadf46538cad625$var$deflate;
var $9fadf46538cad625$export$e95d6a8f69fb340a = $9fadf46538cad625$var$deflateRaw;
var $9fadf46538cad625$export$69f0ea7cf3a331a8 = $9fadf46538cad625$var$gzip;
var $9fadf46538cad625$export$d1de70a877d6e43c = $9fadf46538cad625$var$Inflate;
var $9fadf46538cad625$export$cae1ce83fe4a1782 = $9fadf46538cad625$var$inflate;
var $9fadf46538cad625$export$d0f0aa2d05c905c5 = $9fadf46538cad625$var$inflateRaw;
var $9fadf46538cad625$export$95adf9d270383091 = $9fadf46538cad625$var$ungzip;
var $9fadf46538cad625$export$1a988e7317c65621 = $9fadf46538cad625$var$constants$2;
var $9fadf46538cad625$export$2e2bcd8739ae039 = {
    Deflate: $9fadf46538cad625$export$ae157b6234afe138,
    deflate: $9fadf46538cad625$export$2316623ecd1285ab,
    deflateRaw: $9fadf46538cad625$export$e95d6a8f69fb340a,
    gzip: $9fadf46538cad625$export$69f0ea7cf3a331a8,
    Inflate: $9fadf46538cad625$export$d1de70a877d6e43c,
    inflate: $9fadf46538cad625$export$cae1ce83fe4a1782,
    inflateRaw: $9fadf46538cad625$export$d0f0aa2d05c905c5,
    ungzip: $9fadf46538cad625$export$95adf9d270383091,
    constants: $9fadf46538cad625$export$1a988e7317c65621
};

});

parcelRegister("jUfIR", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $e7df716f569e4e90$require$Buffer = $ilnag.Buffer;
"use strict";

var $7xj12 = parcelRequire("7xj12");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7df716f569e4e90$var$_regenerator = $7xj12((parcelRequire("di9Cq")));

var $e7df716f569e4e90$var$_asyncToGenerator2 = $7xj12((parcelRequire("heZSA")));

var $e7df716f569e4e90$var$_classCallCheck2 = $7xj12((parcelRequire("gsyQ1")));

var $e7df716f569e4e90$var$_createClass2 = $7xj12((parcelRequire("foZcD")));

var $e7df716f569e4e90$var$_crypto = $7xj12((parcelRequire("5xFHp")));

var $e7df716f569e4e90$var$_ripemd = $7xj12((parcelRequire("aEC5U")));

var $e7df716f569e4e90$var$_bech = $7xj12((parcelRequire("gHFi0")));

var $bR8yT = parcelRequire("bR8yT");

var $gsjjR = parcelRequire("gsjjR");

var $8sfjp = parcelRequire("8sfjp");
/** ******************************************************************************
 *  (c) 2019 ZondaX GmbH
 *  (c) 2016-2017 Ledger
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */ var $e7df716f569e4e90$var$CosmosApp = /*#__PURE__*/ function() {
    function CosmosApp(transport) {
        var scrambleKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8sfjp.APP_KEY;
        (0, $e7df716f569e4e90$var$_classCallCheck2.default)(this, CosmosApp);
        if (!transport) throw new Error("Transport has not been defined");
        this.transport = transport;
        transport.decorateAppAPIMethods(this, [
            "getVersion",
            "sign",
            "getAddressAndPubKey",
            "appInfo",
            "deviceInfo",
            "getBech32FromPK"
        ], scrambleKey);
    }
    (0, $e7df716f569e4e90$var$_createClass2.default)(CosmosApp, [
        {
            key: "serializePath",
            value: function() {
                var _serializePath = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee(path) {
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, $8sfjp.getVersion)(this.transport);
                            case 2:
                                this.versionResponse = _context.sent;
                                if (!(this.versionResponse.return_code !== $8sfjp.ERROR_CODE.NoError)) {
                                    _context.next = 5;
                                    break;
                                }
                                throw this.versionResponse;
                            case 5:
                                _context.t0 = this.versionResponse.major;
                                _context.next = _context.t0 === 1 ? 8 : _context.t0 === 2 ? 9 : 10;
                                break;
                            case 8:
                                return _context.abrupt("return", (0, $bR8yT.serializePathv1)(path));
                            case 9:
                                return _context.abrupt("return", (0, $gsjjR.serializePathv2)(path));
                            case 10:
                                return _context.abrupt("return", {
                                    return_code: 0x6400,
                                    error_message: "App Version is not supported"
                                });
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function serializePath(_x) {
                    return _serializePath.apply(this, arguments);
                }
                return serializePath;
            }()
        },
        {
            key: "signGetChunks",
            value: function() {
                var _signGetChunks = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee2(path, message) {
                    var serializedPath, chunks, buffer, i, end;
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.serializePath(path);
                            case 2:
                                serializedPath = _context2.sent;
                                chunks = [];
                                chunks.push(serializedPath);
                                buffer = $e7df716f569e4e90$require$Buffer.from(message);
                                for(i = 0; i < buffer.length; i += $8sfjp.CHUNK_SIZE){
                                    end = i + $8sfjp.CHUNK_SIZE;
                                    if (i > buffer.length) end = buffer.length;
                                    chunks.push(buffer.slice(i, end));
                                }
                                return _context2.abrupt("return", chunks);
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function signGetChunks(_x2, _x3) {
                    return _signGetChunks.apply(this, arguments);
                }
                return signGetChunks;
            }()
        },
        {
            key: "getVersion",
            value: function() {
                var _getVersion2 = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee3() {
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return (0, $8sfjp.getVersion)(this.transport);
                            case 3:
                                this.versionResponse = _context3.sent;
                                return _context3.abrupt("return", this.versionResponse);
                            case 7:
                                _context3.prev = 7;
                                _context3.t0 = _context3["catch"](0);
                                return _context3.abrupt("return", (0, $8sfjp.processErrorResponse)(_context3.t0));
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function getVersion() {
                    return _getVersion2.apply(this, arguments);
                }
                return getVersion;
            }()
        },
        {
            key: "appInfo",
            value: function() {
                var _appInfo = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee4() {
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.transport.send(0xb0, 0x01, 0, 0).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    var result = {};
                                    var appName = "err";
                                    var appVersion = "err";
                                    var flagLen = 0;
                                    var flagsValue = 0;
                                    if (response[0] !== 1) {
                                        // Ledger responds with format ID 1. There is no spec for any format != 1
                                        result.error_message = "response format ID not recognized";
                                        result.return_code = 0x9001;
                                    } else {
                                        var appNameLen = response[1];
                                        appName = response.slice(2, 2 + appNameLen).toString("ascii");
                                        var idx = 2 + appNameLen;
                                        var appVersionLen = response[idx];
                                        idx += 1;
                                        appVersion = response.slice(idx, idx + appVersionLen).toString("ascii");
                                        idx += appVersionLen;
                                        var appFlagsLen = response[idx];
                                        idx += 1;
                                        flagLen = appFlagsLen;
                                        flagsValue = response[idx];
                                    }
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, $8sfjp.errorCodeToString)(returnCode),
                                        // //
                                        appName: appName,
                                        appVersion: appVersion,
                                        flagLen: flagLen,
                                        flagsValue: flagsValue,
                                        // eslint-disable-next-line no-bitwise
                                        flag_recovery: (flagsValue & 1) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_signed_mcu_code: (flagsValue & 2) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_onboarded: (flagsValue & 4) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_pin_validated: (flagsValue & 128) !== 0
                                    };
                                }, $8sfjp.processErrorResponse));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function appInfo() {
                    return _appInfo.apply(this, arguments);
                }
                return appInfo;
            }()
        },
        {
            key: "deviceInfo",
            value: function() {
                var _deviceInfo = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee5() {
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.transport.send(0xe0, 0x01, 0, 0, $e7df716f569e4e90$require$Buffer.from([]), [
                                    $8sfjp.ERROR_CODE.NoError,
                                    0x6e00
                                ]).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    if (returnCode === 0x6e00) return {
                                        return_code: returnCode,
                                        error_message: "This command is only available in the Dashboard"
                                    };
                                    var targetId = response.slice(0, 4).toString("hex");
                                    var pos = 4;
                                    var secureElementVersionLen = response[pos];
                                    pos += 1;
                                    var seVersion = response.slice(pos, pos + secureElementVersionLen).toString();
                                    pos += secureElementVersionLen;
                                    var flagsLen = response[pos];
                                    pos += 1;
                                    var flag = response.slice(pos, pos + flagsLen).toString("hex");
                                    pos += flagsLen;
                                    var mcuVersionLen = response[pos];
                                    pos += 1; // Patch issue in mcu version
                                    var tmp = response.slice(pos, pos + mcuVersionLen);
                                    if (tmp[mcuVersionLen - 1] === 0) tmp = response.slice(pos, pos + mcuVersionLen - 1);
                                    var mcuVersion = tmp.toString();
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, $8sfjp.errorCodeToString)(returnCode),
                                        // //
                                        targetId: targetId,
                                        seVersion: seVersion,
                                        flag: flag,
                                        mcuVersion: mcuVersion
                                    };
                                }, $8sfjp.processErrorResponse));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function deviceInfo() {
                    return _deviceInfo.apply(this, arguments);
                }
                return deviceInfo;
            }()
        },
        {
            key: "publicKey",
            value: function() {
                var _publicKey = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee6(path) {
                    var serializedPath, data;
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                _context6.prev = 0;
                                _context6.next = 3;
                                return this.serializePath(path);
                            case 3:
                                serializedPath = _context6.sent;
                                _context6.t0 = this.versionResponse.major;
                                _context6.next = _context6.t0 === 1 ? 7 : _context6.t0 === 2 ? 8 : 10;
                                break;
                            case 7:
                                return _context6.abrupt("return", (0, $bR8yT.publicKeyv1)(this, serializedPath));
                            case 8:
                                data = $e7df716f569e4e90$require$Buffer.concat([
                                    CosmosApp.serializeHRP("cosmos"),
                                    serializedPath
                                ]);
                                return _context6.abrupt("return", (0, $gsjjR.publicKeyv2)(this, data));
                            case 10:
                                return _context6.abrupt("return", {
                                    return_code: 0x6400,
                                    error_message: "App Version is not supported"
                                });
                            case 11:
                                _context6.next = 16;
                                break;
                            case 13:
                                _context6.prev = 13;
                                _context6.t1 = _context6["catch"](0);
                                return _context6.abrupt("return", (0, $8sfjp.processErrorResponse)(_context6.t1));
                            case 16:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function publicKey(_x4) {
                    return _publicKey.apply(this, arguments);
                }
                return publicKey;
            }()
        },
        {
            key: "getAddressAndPubKey",
            value: function() {
                var _getAddressAndPubKey = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee7(path, hrp) {
                    var _this = this;
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.prev = 0;
                                return _context7.abrupt("return", this.serializePath(path).then(function(serializedPath) {
                                    var data = $e7df716f569e4e90$require$Buffer.concat([
                                        CosmosApp.serializeHRP(hrp),
                                        serializedPath
                                    ]);
                                    return _this.transport.send($8sfjp.CLA, $8sfjp.INS.GET_ADDR_SECP256K1, $8sfjp.P1_VALUES.ONLY_RETRIEVE, 0, data, [
                                        $8sfjp.ERROR_CODE.NoError
                                    ]).then(function(response) {
                                        var errorCodeData = response.slice(-2);
                                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                        var compressedPk = $e7df716f569e4e90$require$Buffer.from(response.slice(0, 33));
                                        var bech32Address = $e7df716f569e4e90$require$Buffer.from(response.slice(33, -2)).toString();
                                        return {
                                            bech32_address: bech32Address,
                                            compressed_pk: compressedPk,
                                            return_code: returnCode,
                                            error_message: (0, $8sfjp.errorCodeToString)(returnCode)
                                        };
                                    }, $8sfjp.processErrorResponse);
                                }).catch(function(err) {
                                    return (0, $8sfjp.processErrorResponse)(err);
                                }));
                            case 4:
                                _context7.prev = 4;
                                _context7.t0 = _context7["catch"](0);
                                return _context7.abrupt("return", (0, $8sfjp.processErrorResponse)(_context7.t0));
                            case 7:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            0,
                            4
                        ]
                    ]);
                }));
                function getAddressAndPubKey(_x5, _x6) {
                    return _getAddressAndPubKey.apply(this, arguments);
                }
                return getAddressAndPubKey;
            }()
        },
        {
            key: "showAddressAndPubKey",
            value: function() {
                var _showAddressAndPubKey = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee8(path, hrp) {
                    var _this2 = this;
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.prev = 0;
                                return _context8.abrupt("return", this.serializePath(path).then(function(serializedPath) {
                                    var data = $e7df716f569e4e90$require$Buffer.concat([
                                        CosmosApp.serializeHRP(hrp),
                                        serializedPath
                                    ]);
                                    return _this2.transport.send($8sfjp.CLA, $8sfjp.INS.GET_ADDR_SECP256K1, $8sfjp.P1_VALUES.SHOW_ADDRESS_IN_DEVICE, 0, data, [
                                        $8sfjp.ERROR_CODE.NoError
                                    ]).then(function(response) {
                                        var errorCodeData = response.slice(-2);
                                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                        var compressedPk = $e7df716f569e4e90$require$Buffer.from(response.slice(0, 33));
                                        var bech32Address = $e7df716f569e4e90$require$Buffer.from(response.slice(33, -2)).toString();
                                        return {
                                            bech32_address: bech32Address,
                                            compressed_pk: compressedPk,
                                            return_code: returnCode,
                                            error_message: (0, $8sfjp.errorCodeToString)(returnCode)
                                        };
                                    }, $8sfjp.processErrorResponse);
                                }).catch(function(err) {
                                    return (0, $8sfjp.processErrorResponse)(err);
                                }));
                            case 4:
                                _context8.prev = 4;
                                _context8.t0 = _context8["catch"](0);
                                return _context8.abrupt("return", (0, $8sfjp.processErrorResponse)(_context8.t0));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            0,
                            4
                        ]
                    ]);
                }));
                function showAddressAndPubKey(_x7, _x8) {
                    return _showAddressAndPubKey.apply(this, arguments);
                }
                return showAddressAndPubKey;
            }()
        },
        {
            key: "signSendChunk",
            value: function() {
                var _signSendChunk = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee9(chunkIdx, chunkNum, chunk) {
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                _context9.t0 = this.versionResponse.major;
                                _context9.next = _context9.t0 === 1 ? 3 : _context9.t0 === 2 ? 4 : 5;
                                break;
                            case 3:
                                return _context9.abrupt("return", (0, $bR8yT.signSendChunkv1)(this, chunkIdx, chunkNum, chunk));
                            case 4:
                                return _context9.abrupt("return", (0, $gsjjR.signSendChunkv2)(this, chunkIdx, chunkNum, chunk));
                            case 5:
                                return _context9.abrupt("return", {
                                    return_code: 0x6400,
                                    error_message: "App Version is not supported"
                                });
                            case 6:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function signSendChunk(_x9, _x10, _x11) {
                    return _signSendChunk.apply(this, arguments);
                }
                return signSendChunk;
            }()
        },
        {
            key: "sign",
            value: function() {
                var _sign = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee11(path, message) {
                    var _this3 = this;
                    return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                return _context11.abrupt("return", this.signGetChunks(path, message).then(function(chunks) {
                                    return _this3.signSendChunk(1, chunks.length, chunks[0], [
                                        $8sfjp.ERROR_CODE.NoError
                                    ]).then(/*#__PURE__*/ function() {
                                        var _ref = (0, $e7df716f569e4e90$var$_asyncToGenerator2.default)(/*#__PURE__*/ $e7df716f569e4e90$var$_regenerator.default.mark(function _callee10(response) {
                                            var result, i;
                                            return $e7df716f569e4e90$var$_regenerator.default.wrap(function _callee10$(_context10) {
                                                while(true)switch(_context10.prev = _context10.next){
                                                    case 0:
                                                        result = {
                                                            return_code: response.return_code,
                                                            error_message: response.error_message,
                                                            signature: null
                                                        };
                                                        i = 1;
                                                    case 2:
                                                        if (!(i < chunks.length)) {
                                                            _context10.next = 11;
                                                            break;
                                                        }
                                                        _context10.next = 5;
                                                        return _this3.signSendChunk(1 + i, chunks.length, chunks[i]);
                                                    case 5:
                                                        result = _context10.sent;
                                                        if (!(result.return_code !== $8sfjp.ERROR_CODE.NoError)) {
                                                            _context10.next = 8;
                                                            break;
                                                        }
                                                        return _context10.abrupt("break", 11);
                                                    case 8:
                                                        i += 1;
                                                        _context10.next = 2;
                                                        break;
                                                    case 11:
                                                        return _context10.abrupt("return", {
                                                            return_code: result.return_code,
                                                            error_message: result.error_message,
                                                            // ///
                                                            signature: result.signature
                                                        });
                                                    case 12:
                                                    case "end":
                                                        return _context10.stop();
                                                }
                                            }, _callee10);
                                        }));
                                        return function(_x14) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(), $8sfjp.processErrorResponse);
                                }, $8sfjp.processErrorResponse));
                            case 1:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function sign(_x12, _x13) {
                    return _sign.apply(this, arguments);
                }
                return sign;
            }()
        }
    ], [
        {
            key: "serializeHRP",
            value: function serializeHRP(hrp) {
                if (hrp == null || hrp.length < 3 || hrp.length > 83) throw new Error("Invalid HRP");
                var buf = $e7df716f569e4e90$require$Buffer.alloc(1 + hrp.length);
                buf.writeUInt8(hrp.length, 0);
                buf.write(hrp, 1);
                return buf;
            }
        },
        {
            key: "getBech32FromPK",
            value: function getBech32FromPK(hrp, pk) {
                if (pk.length !== 33) throw new Error("expected compressed public key [31 bytes]");
                var hashSha256 = $e7df716f569e4e90$var$_crypto.default.createHash("sha256").update(pk).digest();
                var hashRip = new $e7df716f569e4e90$var$_ripemd.default().update(hashSha256).digest();
                return $e7df716f569e4e90$var$_bech.default.encode(hrp, $e7df716f569e4e90$var$_bech.default.toWords(hashRip));
            }
        }
    ]);
    return CosmosApp;
}();
module.exports.default = $e7df716f569e4e90$var$CosmosApp;

});
parcelRegister("7xj12", function(module, exports) {
function $57ca5d9d11b6e767$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $57ca5d9d11b6e767$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("di9Cq", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $9ad46ae1b8c6d5aa$var$runtime = (parcelRequire("fMOH5"))();
module.exports = $9ad46ae1b8c6d5aa$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $9ad46ae1b8c6d5aa$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $9ad46ae1b8c6d5aa$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9ad46ae1b8c6d5aa$var$runtime);
}

});
parcelRegister("fMOH5", function(module, exports) {

var $9EpyG = parcelRequire("9EpyG");
var $b7e2a974ca5d8b48$var$_typeof = $9EpyG.default;
function $b7e2a974ca5d8b48$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $b7e2a974ca5d8b48$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $b7e2a974ca5d8b48$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $b7e2a974ca5d8b48$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9EpyG", function(module, exports) {
function $706bacdb05eca3ae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $706bacdb05eca3ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $706bacdb05eca3ae$var$_typeof(obj);
}
module.exports = $706bacdb05eca3ae$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("heZSA", function(module, exports) {
function $c8d3be6adb0ff102$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $c8d3be6adb0ff102$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $c8d3be6adb0ff102$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $c8d3be6adb0ff102$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $c8d3be6adb0ff102$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gsyQ1", function(module, exports) {
function $bfba48f62d39e979$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $bfba48f62d39e979$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("foZcD", function(module, exports) {

var $cRgQi = parcelRequire("cRgQi");
function $b3689286006530db$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cRgQi(descriptor.key), descriptor);
    }
}
function $b3689286006530db$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b3689286006530db$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b3689286006530db$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $b3689286006530db$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cRgQi", function(module, exports) {

var $9EpyG = parcelRequire("9EpyG");
var $95c77fd27c586683$var$_typeof = $9EpyG.default;

var $1ubyh = parcelRequire("1ubyh");
function $95c77fd27c586683$var$_toPropertyKey(arg) {
    var key = $1ubyh(arg, "string");
    return $95c77fd27c586683$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $95c77fd27c586683$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ubyh", function(module, exports) {

var $9EpyG = parcelRequire("9EpyG");
var $11518dc19feae9bb$var$_typeof = $9EpyG.default;
function $11518dc19feae9bb$var$_toPrimitive(input, hint) {
    if ($11518dc19feae9bb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($11518dc19feae9bb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $11518dc19feae9bb$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bR8yT", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $8a1b4921afbe6d6c$require$Buffer = $ilnag.Buffer;
"use strict";

var $7xj12 = parcelRequire("7xj12");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializePathv1 = $8a1b4921afbe6d6c$var$serializePathv1;
module.exports.signSendChunkv1 = $8a1b4921afbe6d6c$var$signSendChunkv1;
module.exports.publicKeyv1 = $8a1b4921afbe6d6c$var$publicKeyv1;

var $8a1b4921afbe6d6c$var$_regenerator = $7xj12((parcelRequire("di9Cq")));

var $8a1b4921afbe6d6c$var$_asyncToGenerator2 = $7xj12((parcelRequire("heZSA")));

var $8sfjp = parcelRequire("8sfjp");
function $8a1b4921afbe6d6c$var$serializePathv1(path) {
    if (path == null || path.length < 3) throw new Error("Invalid path.");
    if (path.length > 10) throw new Error("Invalid path. Length should be <= 10");
    var buf = $8a1b4921afbe6d6c$require$Buffer.alloc(1 + 4 * path.length);
    buf.writeUInt8(path.length, 0);
    for(var i = 0; i < path.length; i += 1){
        var v = path[i];
        if (i < 3) // eslint-disable-next-line no-bitwise
        v |= 0x80000000; // Harden
        buf.writeInt32LE(v, 1 + i * 4);
    }
    return buf;
}
function $8a1b4921afbe6d6c$var$signSendChunkv1(_x, _x2, _x3, _x4) {
    return $8a1b4921afbe6d6c$var$_signSendChunkv.apply(this, arguments);
}
function $8a1b4921afbe6d6c$var$_signSendChunkv() {
    $8a1b4921afbe6d6c$var$_signSendChunkv = (0, $8a1b4921afbe6d6c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $8a1b4921afbe6d6c$var$_regenerator.default.mark(function _callee(app, chunkIdx, chunkNum, chunk) {
        return $8a1b4921afbe6d6c$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", app.transport.send($8sfjp.CLA, $8sfjp.INS.SIGN_SECP256K1, chunkIdx, chunkNum, chunk, [
                        $8sfjp.ERROR_CODE.NoError,
                        0x6984,
                        0x6a80
                    ]).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var errorMessage = (0, $8sfjp.errorCodeToString)(returnCode);
                        if (returnCode === 0x6a80 || returnCode === 0x6984) errorMessage = "".concat(errorMessage, " : ").concat(response.slice(0, response.length - 2).toString("ascii"));
                        var signature = null;
                        if (response.length > 2) signature = response.slice(0, response.length - 2);
                        return {
                            signature: signature,
                            return_code: returnCode,
                            error_message: errorMessage
                        };
                    }, $8sfjp.processErrorResponse));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $8a1b4921afbe6d6c$var$_signSendChunkv.apply(this, arguments);
}
function $8a1b4921afbe6d6c$var$compressPublicKey(publicKey) {
    if (publicKey.length !== 65) throw new Error("decompressed public key length should be 65 bytes");
    var y = publicKey.slice(33, 65); // eslint-disable-next-line no-bitwise
    var z = $8a1b4921afbe6d6c$require$Buffer.from([
        2 + (y[y.length - 1] & 1)
    ]);
    return $8a1b4921afbe6d6c$require$Buffer.concat([
        z,
        publicKey.slice(1, 33)
    ]);
}
function $8a1b4921afbe6d6c$var$publicKeyv1(_x5, _x6) {
    return $8a1b4921afbe6d6c$var$_publicKeyv.apply(this, arguments);
}
function $8a1b4921afbe6d6c$var$_publicKeyv() {
    $8a1b4921afbe6d6c$var$_publicKeyv = (0, $8a1b4921afbe6d6c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $8a1b4921afbe6d6c$var$_regenerator.default.mark(function _callee2(app, data) {
        return $8a1b4921afbe6d6c$var$_regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", app.transport.send($8sfjp.CLA, $8sfjp.INS.INS_PUBLIC_KEY_SECP256K1, 0, 0, data, [
                        $8sfjp.ERROR_CODE.NoError
                    ]).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var pk = $8a1b4921afbe6d6c$require$Buffer.from(response.slice(0, 65));
                        return {
                            pk: pk,
                            compressed_pk: $8a1b4921afbe6d6c$var$compressPublicKey(pk),
                            return_code: returnCode,
                            error_message: (0, $8sfjp.errorCodeToString)(returnCode)
                        };
                    }, $8sfjp.processErrorResponse));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $8a1b4921afbe6d6c$var$_publicKeyv.apply(this, arguments);
}

});
parcelRegister("8sfjp", function(module, exports) {
"use strict";

var $7xj12 = parcelRequire("7xj12");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorCodeToString = $627cd0e350b5a26a$var$errorCodeToString;
module.exports.processErrorResponse = $627cd0e350b5a26a$var$processErrorResponse;
module.exports.getVersion = $627cd0e350b5a26a$var$getVersion;
module.exports.ERROR_CODE = module.exports.P1_VALUES = module.exports.PAYLOAD_TYPE = module.exports.INS = module.exports.APP_KEY = module.exports.CHUNK_SIZE = module.exports.CLA = void 0;

var $627cd0e350b5a26a$var$_regenerator = $7xj12((parcelRequire("di9Cq")));

var $627cd0e350b5a26a$var$_asyncToGenerator2 = $7xj12((parcelRequire("heZSA")));

var $627cd0e350b5a26a$var$_typeof2 = $7xj12((parcelRequire("9EpyG")));
var $627cd0e350b5a26a$var$CLA = 0x55;
module.exports.CLA = $627cd0e350b5a26a$var$CLA;
var $627cd0e350b5a26a$var$CHUNK_SIZE = 250;
module.exports.CHUNK_SIZE = $627cd0e350b5a26a$var$CHUNK_SIZE;
var $627cd0e350b5a26a$var$APP_KEY = "CSM";
module.exports.APP_KEY = $627cd0e350b5a26a$var$APP_KEY;
var $627cd0e350b5a26a$var$INS = {
    GET_VERSION: 0x00,
    INS_PUBLIC_KEY_SECP256K1: 0x01,
    // Obsolete
    SIGN_SECP256K1: 0x02,
    GET_ADDR_SECP256K1: 0x04
};
module.exports.INS = $627cd0e350b5a26a$var$INS;
var $627cd0e350b5a26a$var$PAYLOAD_TYPE = {
    INIT: 0x00,
    ADD: 0x01,
    LAST: 0x02
};
module.exports.PAYLOAD_TYPE = $627cd0e350b5a26a$var$PAYLOAD_TYPE;
var $627cd0e350b5a26a$var$P1_VALUES = {
    ONLY_RETRIEVE: 0x00,
    SHOW_ADDRESS_IN_DEVICE: 0x01
};
module.exports.P1_VALUES = $627cd0e350b5a26a$var$P1_VALUES;
var $627cd0e350b5a26a$var$ERROR_CODE = {
    NoError: 0x9000
};
module.exports.ERROR_CODE = $627cd0e350b5a26a$var$ERROR_CODE;
var $627cd0e350b5a26a$var$ERROR_DESCRIPTION = {
    1: "U2F: Unknown",
    2: "U2F: Bad request",
    3: "U2F: Configuration unsupported",
    4: "U2F: Device Ineligible",
    5: "U2F: Timeout",
    14: "Timeout",
    0x9000: "No errors",
    0x9001: "Device is busy",
    0x6802: "Error deriving keys",
    0x6400: "Execution Error",
    0x6700: "Wrong Length",
    0x6982: "Empty Buffer",
    0x6983: "Output buffer too small",
    0x6984: "Data is invalid",
    0x6985: "Conditions not satisfied",
    0x6986: "Transaction rejected",
    0x6a80: "Bad key handle",
    0x6b00: "Invalid P1/P2",
    0x6d00: "Instruction not supported",
    0x6e00: "App does not seem to be open",
    0x6f00: "Unknown error",
    0x6f01: "Sign/verify error"
};
function $627cd0e350b5a26a$var$errorCodeToString(statusCode) {
    if (statusCode in $627cd0e350b5a26a$var$ERROR_DESCRIPTION) return $627cd0e350b5a26a$var$ERROR_DESCRIPTION[statusCode];
    return "Unknown Status Code: ".concat(statusCode);
}
function $627cd0e350b5a26a$var$isDict(v) {
    return (0, $627cd0e350b5a26a$var$_typeof2.default)(v) === "object" && v !== null && !(v instanceof Array) && !(v instanceof Date);
}
function $627cd0e350b5a26a$var$processErrorResponse(response) {
    if (response) {
        if ($627cd0e350b5a26a$var$isDict(response)) {
            if (Object.prototype.hasOwnProperty.call(response, "statusCode")) return {
                return_code: response.statusCode,
                error_message: $627cd0e350b5a26a$var$errorCodeToString(response.statusCode)
            };
            if (Object.prototype.hasOwnProperty.call(response, "return_code") && Object.prototype.hasOwnProperty.call(response, "error_message")) return response;
        }
        return {
            return_code: 0xffff,
            error_message: response.toString()
        };
    }
    return {
        return_code: 0xffff,
        error_message: response.toString()
    };
}
function $627cd0e350b5a26a$var$getVersion(_x) {
    return $627cd0e350b5a26a$var$_getVersion.apply(this, arguments);
}
function $627cd0e350b5a26a$var$_getVersion() {
    $627cd0e350b5a26a$var$_getVersion = (0, $627cd0e350b5a26a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $627cd0e350b5a26a$var$_regenerator.default.mark(function _callee(transport) {
        return $627cd0e350b5a26a$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", transport.send($627cd0e350b5a26a$var$CLA, $627cd0e350b5a26a$var$INS.GET_VERSION, 0, 0).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var targetId = 0;
                        if (response.length >= 9) /* eslint-disable no-bitwise */ targetId = (response[5] << 24) + (response[6] << 16) + (response[7] << 8) + (response[8] << 0);
                        return {
                            return_code: returnCode,
                            error_message: $627cd0e350b5a26a$var$errorCodeToString(returnCode),
                            // ///
                            test_mode: response[0] !== 0,
                            major: response[1],
                            minor: response[2],
                            patch: response[3],
                            device_locked: response[4] === 1,
                            target_id: targetId.toString(16)
                        };
                    }, $627cd0e350b5a26a$var$processErrorResponse));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $627cd0e350b5a26a$var$_getVersion.apply(this, arguments);
}

});


parcelRegister("gsjjR", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $bfae3f4733290e5e$require$Buffer = $ilnag.Buffer;
"use strict";

var $7xj12 = parcelRequire("7xj12");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializePathv2 = $bfae3f4733290e5e$var$serializePathv2;
module.exports.signSendChunkv2 = $bfae3f4733290e5e$var$signSendChunkv2;
module.exports.publicKeyv2 = $bfae3f4733290e5e$var$publicKeyv2;

var $bfae3f4733290e5e$var$_regenerator = $7xj12((parcelRequire("di9Cq")));

var $bfae3f4733290e5e$var$_asyncToGenerator2 = $7xj12((parcelRequire("heZSA")));

var $bR8yT = parcelRequire("bR8yT");

var $8sfjp = parcelRequire("8sfjp");
function $bfae3f4733290e5e$var$serializePathv2(path) {
    if (!path || path.length !== 5) throw new Error("Invalid path.");
    var buf = $bfae3f4733290e5e$require$Buffer.alloc(20);
    buf.writeUInt32LE(0x80000000 + path[0], 0);
    buf.writeUInt32LE(0x80000000 + path[1], 4);
    buf.writeUInt32LE(0x80000000 + path[2], 8);
    buf.writeUInt32LE(path[3], 12);
    buf.writeUInt32LE(path[4], 16);
    return buf;
}
function $bfae3f4733290e5e$var$signSendChunkv2(_x, _x2, _x3, _x4) {
    return $bfae3f4733290e5e$var$_signSendChunkv.apply(this, arguments);
}
function $bfae3f4733290e5e$var$_signSendChunkv() {
    $bfae3f4733290e5e$var$_signSendChunkv = (0, $bfae3f4733290e5e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $bfae3f4733290e5e$var$_regenerator.default.mark(function _callee(app, chunkIdx, chunkNum, chunk) {
        var payloadType;
        return $bfae3f4733290e5e$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    payloadType = $8sfjp.PAYLOAD_TYPE.ADD;
                    if (chunkIdx === 1) payloadType = $8sfjp.PAYLOAD_TYPE.INIT;
                    if (chunkIdx === chunkNum) payloadType = $8sfjp.PAYLOAD_TYPE.LAST;
                    return _context.abrupt("return", (0, $bR8yT.signSendChunkv1)(app, payloadType, 0, chunk));
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $bfae3f4733290e5e$var$_signSendChunkv.apply(this, arguments);
}
function $bfae3f4733290e5e$var$publicKeyv2(_x5, _x6) {
    return $bfae3f4733290e5e$var$_publicKeyv.apply(this, arguments);
}
function $bfae3f4733290e5e$var$_publicKeyv() {
    $bfae3f4733290e5e$var$_publicKeyv = (0, $bfae3f4733290e5e$var$_asyncToGenerator2.default)(/*#__PURE__*/ $bfae3f4733290e5e$var$_regenerator.default.mark(function _callee2(app, data) {
        return $bfae3f4733290e5e$var$_regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", app.transport.send($8sfjp.CLA, $8sfjp.INS.GET_ADDR_SECP256K1, 0, 0, data, [
                        $8sfjp.ERROR_CODE.NoError
                    ]).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var compressedPk = $bfae3f4733290e5e$require$Buffer.from(response.slice(0, 33));
                        return {
                            pk: "OBSOLETE PROPERTY",
                            compressed_pk: compressedPk,
                            return_code: returnCode,
                            error_message: (0, $8sfjp.errorCodeToString)(returnCode)
                        };
                    }, $8sfjp.processErrorResponse));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $bfae3f4733290e5e$var$_publicKeyv.apply(this, arguments);
}

});


parcelRegister("kvw3m", function(module, exports) {
// just pre-load all the stuff that index.js lazily exports

var $iSzNM = parcelRequire("iSzNM");

var $8IJfp = parcelRequire("8IJfp");

var $lr447 = parcelRequire("lr447");

var $94X3o = parcelRequire("94X3o");

var $74Via = parcelRequire("74Via");

var $jk26C = parcelRequire("jk26C");

var $cugaO = parcelRequire("cugaO");

var $6CJAI = parcelRequire("6CJAI");

var $39cM5 = parcelRequire("39cM5");

var $3ZMk6 = parcelRequire("3ZMk6");

var $5B4LA = parcelRequire("5B4LA");

var $11RE5 = parcelRequire("11RE5");

var $cCtzY = parcelRequire("cCtzY");

var $bgeIt = parcelRequire("bgeIt");

var $1M0i9 = parcelRequire("1M0i9");

var $6JVCT = parcelRequire("6JVCT");

var $lH86F = parcelRequire("lH86F");

var $hdMpb = parcelRequire("hdMpb");

var $5veM9 = parcelRequire("5veM9");

var $hKfSC = parcelRequire("hKfSC");

var $5THum = parcelRequire("5THum");

var $76TaM = parcelRequire("76TaM");

var $9khtf = parcelRequire("9khtf");

var $5Taub = parcelRequire("5Taub");

var $11CoZ = parcelRequire("11CoZ");

var $2EyQV = parcelRequire("2EyQV");

var $heBzj = parcelRequire("heBzj");

var $756jO = parcelRequire("756jO");

var $6Nzdk = parcelRequire("6Nzdk");

var $bQKGF = parcelRequire("bQKGF");

var $fFzzv = parcelRequire("fFzzv");

var $kB0Je = parcelRequire("kB0Je");

var $a1kUx = parcelRequire("a1kUx");

var $9afig = parcelRequire("9afig");

var $khpN1 = parcelRequire("khpN1");

var $d4mZ6 = parcelRequire("d4mZ6");

var $g9ZCB = parcelRequire("g9ZCB");

var $awdTf = parcelRequire("awdTf");

var $e6bFV = parcelRequire("e6bFV");

var $5LeZz = parcelRequire("5LeZz");

var $gDPfD = parcelRequire("gDPfD");
module.exports = {
    parse: $74Via,
    valid: $jk26C,
    clean: $cugaO,
    inc: $6CJAI,
    diff: $39cM5,
    major: $3ZMk6,
    minor: $5B4LA,
    patch: $11RE5,
    prerelease: $cCtzY,
    compare: $bgeIt,
    rcompare: $1M0i9,
    compareLoose: $6JVCT,
    compareBuild: $lH86F,
    sort: $hdMpb,
    rsort: $5veM9,
    gt: $hKfSC,
    lt: $5THum,
    eq: $76TaM,
    neq: $9khtf,
    gte: $5Taub,
    lte: $11CoZ,
    cmp: $2EyQV,
    coerce: $heBzj,
    Comparator: $756jO,
    Range: $6Nzdk,
    satisfies: $bQKGF,
    toComparators: $fFzzv,
    maxSatisfying: $kB0Je,
    minSatisfying: $a1kUx,
    minVersion: $9afig,
    validRange: $khpN1,
    outside: $d4mZ6,
    gtr: $g9ZCB,
    ltr: $awdTf,
    intersects: $e6bFV,
    simplifyRange: $5LeZz,
    subset: $gDPfD,
    SemVer: $lr447,
    re: $iSzNM.re,
    src: $iSzNM.src,
    tokens: $iSzNM.t,
    SEMVER_SPEC_VERSION: $8IJfp.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $8IJfp.RELEASE_TYPES,
    compareIdentifiers: $94X3o.compareIdentifiers,
    rcompareIdentifiers: $94X3o.rcompareIdentifiers
};

});
parcelRegister("iSzNM", function(module, exports) {

var $5OlIx = parcelRequire("5OlIx");

var $8IJfp = parcelRequire("8IJfp");
var MAX_SAFE_COMPONENT_LENGTH = $8IJfp.MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH = $8IJfp.MAX_SAFE_BUILD_LENGTH, MAX_LENGTH = $8IJfp.MAX_LENGTH;

var $6mZK1 = parcelRequire("6mZK1");
exports = module.exports = {};
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var t = exports.t = {};
var R = 0;
var LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
var makeSafeRegex = function(value) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = safeRegexReplacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $5OlIx._)(_step.value, 2), token = _step_value[0], max = _step_value[1];
            value = value.split("".concat(token, "*")).join("".concat(token, "{0,").concat(max, "}")).split("".concat(token, "+")).join("".concat(token, "{1,").concat(max, "}"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return value;
};
var createToken = function(name, value, isGlobal) {
    var safe = makeSafeRegex(value);
    var index = R++;
    $6mZK1(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-]".concat(LETTERDASHNUMBER, "*"));
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")"));
createToken("MAINVERSIONLOOSE", "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")"));
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", "(?:".concat(src[t.NUMERICIDENTIFIER], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
createToken("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(src[t.NUMERICIDENTIFIERLOOSE], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", "(?:-(".concat(src[t.PRERELEASEIDENTIFIER], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIER], ")*))"));
createToken("PRERELEASELOOSE", "(?:-?(".concat(src[t.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIERLOOSE], ")*))"));
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", "".concat(LETTERDASHNUMBER, "+"));
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", "(?:\\+(".concat(src[t.BUILDIDENTIFIER], "(?:\\.").concat(src[t.BUILDIDENTIFIER], ")*))"));
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", "v?".concat(src[t.MAINVERSION]).concat(src[t.PRERELEASE], "?").concat(src[t.BUILD], "?"));
createToken("FULL", "^".concat(src[t.FULLPLAIN], "$"));
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", "[v=\\s]*".concat(src[t.MAINVERSIONLOOSE]).concat(src[t.PRERELEASELOOSE], "?").concat(src[t.BUILD], "?"));
createToken("LOOSE", "^".concat(src[t.LOOSEPLAIN], "$"));
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", "".concat(src[t.NUMERICIDENTIFIERLOOSE], "|x|X|\\*"));
createToken("XRANGEIDENTIFIER", "".concat(src[t.NUMERICIDENTIFIER], "|x|X|\\*"));
createToken("XRANGEPLAIN", "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:".concat(src[t.PRERELEASE], ")?").concat(src[t.BUILD], "?") + ")?)?");
createToken("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(src[t.PRERELEASELOOSE], ")?").concat(src[t.BUILD], "?") + ")?)?");
createToken("XRANGE", "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAIN], "$"));
createToken("XRANGELOOSE", "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAINLOOSE], "$"));
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", "(^|[^\\d])(\\d{1,".concat(MAX_SAFE_COMPONENT_LENGTH, "})") + "(?:\\.(\\d{1,".concat(MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:\\.(\\d{1,".concat(MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:$|[^\\d])");
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", "(\\s*)".concat(src[t.LONETILDE], "\\s+"), true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAIN], "$"));
createToken("TILDELOOSE", "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAINLOOSE], "$"));
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", "(\\s*)".concat(src[t.LONECARET], "\\s+"), true);
exports.caretTrimReplace = "$1^";
createToken("CARET", "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAIN], "$"));
createToken("CARETLOOSE", "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAINLOOSE], "$"));
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", "^".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], ")$|^$"));
createToken("COMPARATOR", "^".concat(src[t.GTLT], "\\s*(").concat(src[t.FULLPLAIN], ")$|^$"));
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", "(\\s*)".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], "|").concat(src[t.XRANGEPLAIN], ")"), true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", "^\\s*(".concat(src[t.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAIN], ")") + "\\s*$");
createToken("HYPHENRANGELOOSE", "^\\s*(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s*$");
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("8IJfp", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
var $65958804bdcad886$var$SEMVER_SPEC_VERSION = "2.0.0";
var $65958804bdcad886$var$MAX_LENGTH = 256;
var $65958804bdcad886$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var $65958804bdcad886$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
var $65958804bdcad886$var$MAX_SAFE_BUILD_LENGTH = $65958804bdcad886$var$MAX_LENGTH - 6;
var $65958804bdcad886$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $65958804bdcad886$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $65958804bdcad886$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $65958804bdcad886$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $65958804bdcad886$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $65958804bdcad886$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $65958804bdcad886$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("6mZK1", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
var $4a34b0b0b1386133$var$debug = (typeof $4pbh3 === "object" && $4pbh3.env && undefined, function() {});
module.exports = $4a34b0b0b1386133$var$debug;

});


parcelRegister("lr447", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6mZK1 = parcelRequire("6mZK1");

var $8IJfp = parcelRequire("8IJfp");
var $f9af45e698517e28$var$MAX_LENGTH = $8IJfp.MAX_LENGTH, $f9af45e698517e28$var$MAX_SAFE_INTEGER = $8IJfp.MAX_SAFE_INTEGER;

var $iSzNM = parcelRequire("iSzNM");
var $f9af45e698517e28$var$re = $iSzNM.safeRe, $f9af45e698517e28$var$t = $iSzNM.t;

var $5TUY3 = parcelRequire("5TUY3");

var $94X3o = parcelRequire("94X3o");
var $f9af45e698517e28$require$compareIdentifiers = $94X3o.compareIdentifiers;
var $f9af45e698517e28$var$SemVer = /*#__PURE__*/ function() {
    "use strict";
    function SemVer(version, options) {
        (0, $7dKN1._)(this, SemVer);
        options = $5TUY3(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError('Invalid version. Must be a string. Got type "'.concat(typeof version === "undefined" ? "undefined" : (0, $aVMuR._)(version), '".'));
        if (version.length > $f9af45e698517e28$var$MAX_LENGTH) throw new TypeError("version is longer than ".concat($f9af45e698517e28$var$MAX_LENGTH, " characters"));
        $6mZK1("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        var m = version.trim().match(options.loose ? $f9af45e698517e28$var$re[$f9af45e698517e28$var$t.LOOSE] : $f9af45e698517e28$var$re[$f9af45e698517e28$var$t.FULL]);
        if (!m) throw new TypeError("Invalid Version: ".concat(version));
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $f9af45e698517e28$var$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $f9af45e698517e28$var$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $f9af45e698517e28$var$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map(function(id) {
            if (/^[0-9]+$/.test(id)) {
                var num = +id;
                if (num >= 0 && num < $f9af45e698517e28$var$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    (0, $eW5pA._)(SemVer, [
        {
            key: "format",
            value: function format() {
                this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch);
                if (this.prerelease.length) this.version += "-".concat(this.prerelease.join("."));
                return this.version;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.version;
            }
        },
        {
            key: "compare",
            value: function compare(other) {
                $6mZK1("SemVer.compare", this.version, this.options, other);
                if (!(other instanceof SemVer)) {
                    if (typeof other === "string" && other === this.version) return 0;
                    other = new SemVer(other, this.options);
                }
                if (other.version === this.version) return 0;
                return this.compareMain(other) || this.comparePre(other);
            }
        },
        {
            key: "compareMain",
            value: function compareMain(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                return $f9af45e698517e28$require$compareIdentifiers(this.major, other.major) || $f9af45e698517e28$require$compareIdentifiers(this.minor, other.minor) || $f9af45e698517e28$require$compareIdentifiers(this.patch, other.patch);
            }
        },
        {
            key: "comparePre",
            value: function comparePre(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                // NOT having a prerelease is > having one
                if (this.prerelease.length && !other.prerelease.length) return -1;
                else if (!this.prerelease.length && other.prerelease.length) return 1;
                else if (!this.prerelease.length && !other.prerelease.length) return 0;
                var i = 0;
                do {
                    var a = this.prerelease[i];
                    var b = other.prerelease[i];
                    $6mZK1("prerelease compare", i, a, b);
                    if (a === undefined && b === undefined) return 0;
                    else if (b === undefined) return 1;
                    else if (a === undefined) return -1;
                    else if (a === b) continue;
                    else return $f9af45e698517e28$require$compareIdentifiers(a, b);
                }while (++i);
            }
        },
        {
            key: "compareBuild",
            value: function compareBuild(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                var i = 0;
                do {
                    var a = this.build[i];
                    var b = other.build[i];
                    $6mZK1("prerelease compare", i, a, b);
                    if (a === undefined && b === undefined) return 0;
                    else if (b === undefined) return 1;
                    else if (a === undefined) return -1;
                    else if (a === b) continue;
                    else return $f9af45e698517e28$require$compareIdentifiers(a, b);
                }while (++i);
            }
        },
        {
            // preminor will bump the version up to the next minor release, and immediately
            // down to pre-release. premajor and prepatch work the same way.
            key: "inc",
            value: function inc(release, identifier, identifierBase) {
                switch(release){
                    case "premajor":
                        this.prerelease.length = 0;
                        this.patch = 0;
                        this.minor = 0;
                        this.major++;
                        this.inc("pre", identifier, identifierBase);
                        break;
                    case "preminor":
                        this.prerelease.length = 0;
                        this.patch = 0;
                        this.minor++;
                        this.inc("pre", identifier, identifierBase);
                        break;
                    case "prepatch":
                        // If this is already a prerelease, it will bump to the next version
                        // drop any prereleases that might already exist, since they are not
                        // relevant at this point.
                        this.prerelease.length = 0;
                        this.inc("patch", identifier, identifierBase);
                        this.inc("pre", identifier, identifierBase);
                        break;
                    // If the input is a non-prerelease version, this acts the same as
                    // prepatch.
                    case "prerelease":
                        if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                        this.inc("pre", identifier, identifierBase);
                        break;
                    case "major":
                        // If this is a pre-major version, bump up to the same major version.
                        // Otherwise increment major.
                        // 1.0.0-5 bumps to 1.0.0
                        // 1.1.0 bumps to 2.0.0
                        if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                        this.minor = 0;
                        this.patch = 0;
                        this.prerelease = [];
                        break;
                    case "minor":
                        // If this is a pre-minor version, bump up to the same minor version.
                        // Otherwise increment minor.
                        // 1.2.0-5 bumps to 1.2.0
                        // 1.2.1 bumps to 1.3.0
                        if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                        this.patch = 0;
                        this.prerelease = [];
                        break;
                    case "patch":
                        // If this is not a pre-release version, it will increment the patch.
                        // If it is a pre-release it will bump up to the same patch version.
                        // 1.2.0-5 patches to 1.2.0
                        // 1.2.0 patches to 1.2.1
                        if (this.prerelease.length === 0) this.patch++;
                        this.prerelease = [];
                        break;
                    // This probably shouldn't be used publicly.
                    // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
                    case "pre":
                        {
                            var base = Number(identifierBase) ? 1 : 0;
                            if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                            if (this.prerelease.length === 0) this.prerelease = [
                                base
                            ];
                            else {
                                var i = this.prerelease.length;
                                while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                                    this.prerelease[i]++;
                                    i = -2;
                                }
                                if (i === -1) {
                                    // didn't increment anything
                                    if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                                    this.prerelease.push(base);
                                }
                            }
                            if (identifier) {
                                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                                var prerelease = [
                                    identifier,
                                    base
                                ];
                                if (identifierBase === false) prerelease = [
                                    identifier
                                ];
                                if ($f9af45e698517e28$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                                    if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                                } else this.prerelease = prerelease;
                            }
                            break;
                        }
                    default:
                        throw new Error("invalid increment argument: ".concat(release));
                }
                this.raw = this.format();
                if (this.build.length) this.raw += "+".concat(this.build.join("."));
                return this;
            }
        }
    ]);
    return SemVer;
}();
module.exports = $f9af45e698517e28$var$SemVer;

});
parcelRegister("5TUY3", function(module, exports) {
// parse out just the options we care about
var $44be4760c61d1a16$var$looseOption = Object.freeze({
    loose: true
});
var $44be4760c61d1a16$var$emptyOpts = Object.freeze({});
var $44be4760c61d1a16$var$parseOptions = function(options) {
    if (!options) return $44be4760c61d1a16$var$emptyOpts;
    if (typeof options !== "object") return $44be4760c61d1a16$var$looseOption;
    return options;
};
module.exports = $44be4760c61d1a16$var$parseOptions;

});

parcelRegister("94X3o", function(module, exports) {
var $69c24b9d558ebda8$var$numeric = /^[0-9]+$/;
var $69c24b9d558ebda8$var$compareIdentifiers = function(a, b) {
    var anum = $69c24b9d558ebda8$var$numeric.test(a);
    var bnum = $69c24b9d558ebda8$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
var $69c24b9d558ebda8$var$rcompareIdentifiers = function(a, b) {
    return $69c24b9d558ebda8$var$compareIdentifiers(b, a);
};
module.exports = {
    compareIdentifiers: $69c24b9d558ebda8$var$compareIdentifiers,
    rcompareIdentifiers: $69c24b9d558ebda8$var$rcompareIdentifiers
};

});


parcelRegister("74Via", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $52755926203f444a$var$parse = function(version, options) {
    var throwErrors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (version instanceof $lr447) return version;
    try {
        return new $lr447(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = $52755926203f444a$var$parse;

});

parcelRegister("jk26C", function(module, exports) {

var $74Via = parcelRequire("74Via");
var $e11184bd4654338e$var$valid = function(version, options) {
    var v = $74Via(version, options);
    return v ? v.version : null;
};
module.exports = $e11184bd4654338e$var$valid;

});

parcelRegister("cugaO", function(module, exports) {

var $74Via = parcelRequire("74Via");
var $9174d50ed0fea293$var$clean = function(version, options) {
    var s = $74Via(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
module.exports = $9174d50ed0fea293$var$clean;

});

parcelRegister("6CJAI", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $4d29a8203fcdf094$var$inc = function(version, release, options, identifier, identifierBase) {
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $lr447(version instanceof $lr447 ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = $4d29a8203fcdf094$var$inc;

});

parcelRegister("39cM5", function(module, exports) {

var $74Via = parcelRequire("74Via");
var $24ac1f245c860e9f$var$diff = function(version1, version2) {
    var v1 = $74Via(version1, null, true);
    var v2 = $74Via(version2, null, true);
    var comparison = v1.compare(v2);
    if (comparison === 0) return null;
    var v1Higher = comparison > 0;
    var highVersion = v1Higher ? v1 : v2;
    var lowVersion = v1Higher ? v2 : v1;
    var highHasPre = !!highVersion.prerelease.length;
    var lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    var prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
module.exports = $24ac1f245c860e9f$var$diff;

});

parcelRegister("3ZMk6", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $2e8c8d9baf35aba0$var$major = function(a, loose) {
    return new $lr447(a, loose).major;
};
module.exports = $2e8c8d9baf35aba0$var$major;

});

parcelRegister("5B4LA", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $41341af8e9127d56$var$minor = function(a, loose) {
    return new $lr447(a, loose).minor;
};
module.exports = $41341af8e9127d56$var$minor;

});

parcelRegister("11RE5", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $0bff7f579eab57e4$var$patch = function(a, loose) {
    return new $lr447(a, loose).patch;
};
module.exports = $0bff7f579eab57e4$var$patch;

});

parcelRegister("cCtzY", function(module, exports) {

var $74Via = parcelRequire("74Via");
var $92fffa7b11663924$var$prerelease = function(version, options) {
    var parsed = $74Via(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $92fffa7b11663924$var$prerelease;

});

parcelRegister("bgeIt", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $832c9ab1fe663303$var$compare = function(a, b, loose) {
    return new $lr447(a, loose).compare(new $lr447(b, loose));
};
module.exports = $832c9ab1fe663303$var$compare;

});

parcelRegister("1M0i9", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $14aa8013548c6fd6$var$rcompare = function(a, b, loose) {
    return $bgeIt(b, a, loose);
};
module.exports = $14aa8013548c6fd6$var$rcompare;

});

parcelRegister("6JVCT", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $4e83a56992e79b8e$var$compareLoose = function(a, b) {
    return $bgeIt(a, b, true);
};
module.exports = $4e83a56992e79b8e$var$compareLoose;

});

parcelRegister("lH86F", function(module, exports) {

var $lr447 = parcelRequire("lr447");
var $fcb3e6eaa5123083$var$compareBuild = function(a, b, loose) {
    var versionA = new $lr447(a, loose);
    var versionB = new $lr447(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $fcb3e6eaa5123083$var$compareBuild;

});

parcelRegister("hdMpb", function(module, exports) {

var $lH86F = parcelRequire("lH86F");
var $c89932d27b58d9ae$var$sort = function(list, loose) {
    return list.sort(function(a, b) {
        return $lH86F(a, b, loose);
    });
};
module.exports = $c89932d27b58d9ae$var$sort;

});

parcelRegister("5veM9", function(module, exports) {

var $lH86F = parcelRequire("lH86F");
var $401b4f1bc285f29b$var$rsort = function(list, loose) {
    return list.sort(function(a, b) {
        return $lH86F(b, a, loose);
    });
};
module.exports = $401b4f1bc285f29b$var$rsort;

});

parcelRegister("hKfSC", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $ceb30cfe4bf89628$var$gt = function(a, b, loose) {
    return $bgeIt(a, b, loose) > 0;
};
module.exports = $ceb30cfe4bf89628$var$gt;

});

parcelRegister("5THum", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $011bacb08239084e$var$lt = function(a, b, loose) {
    return $bgeIt(a, b, loose) < 0;
};
module.exports = $011bacb08239084e$var$lt;

});

parcelRegister("76TaM", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $52d3e422e0c5830a$var$eq = function(a, b, loose) {
    return $bgeIt(a, b, loose) === 0;
};
module.exports = $52d3e422e0c5830a$var$eq;

});

parcelRegister("9khtf", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $6ca388a518376c2e$var$neq = function(a, b, loose) {
    return $bgeIt(a, b, loose) !== 0;
};
module.exports = $6ca388a518376c2e$var$neq;

});

parcelRegister("5Taub", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $449a3913e5441c0d$var$gte = function(a, b, loose) {
    return $bgeIt(a, b, loose) >= 0;
};
module.exports = $449a3913e5441c0d$var$gte;

});

parcelRegister("11CoZ", function(module, exports) {

var $bgeIt = parcelRequire("bgeIt");
var $0bf3ac464e5ddbd7$var$lte = function(a, b, loose) {
    return $bgeIt(a, b, loose) <= 0;
};
module.exports = $0bf3ac464e5ddbd7$var$lte;

});

parcelRegister("2EyQV", function(module, exports) {

var $76TaM = parcelRequire("76TaM");

var $9khtf = parcelRequire("9khtf");

var $hKfSC = parcelRequire("hKfSC");

var $5Taub = parcelRequire("5Taub");

var $5THum = parcelRequire("5THum");

var $11CoZ = parcelRequire("11CoZ");
var $1eea5a3a300733ce$var$cmp = function(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $76TaM(a, b, loose);
        case "!=":
            return $9khtf(a, b, loose);
        case ">":
            return $hKfSC(a, b, loose);
        case ">=":
            return $5Taub(a, b, loose);
        case "<":
            return $5THum(a, b, loose);
        case "<=":
            return $11CoZ(a, b, loose);
        default:
            throw new TypeError("Invalid operator: ".concat(op));
    }
};
module.exports = $1eea5a3a300733ce$var$cmp;

});

parcelRegister("heBzj", function(module, exports) {

var $lr447 = parcelRequire("lr447");

var $74Via = parcelRequire("74Via");

var $iSzNM = parcelRequire("iSzNM");
var $c8c0e2c83c785a6a$var$re = $iSzNM.safeRe, $c8c0e2c83c785a6a$var$t = $iSzNM.t;
var $c8c0e2c83c785a6a$var$coerce = function(version, options) {
    if (version instanceof $lr447) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    var match = null;
    if (!options.rtl) match = version.match($c8c0e2c83c785a6a$var$re[$c8c0e2c83c785a6a$var$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        var next;
        while((next = $c8c0e2c83c785a6a$var$re[$c8c0e2c83c785a6a$var$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $c8c0e2c83c785a6a$var$re[$c8c0e2c83c785a6a$var$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $c8c0e2c83c785a6a$var$re[$c8c0e2c83c785a6a$var$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $74Via("".concat(match[2], ".").concat(match[3] || "0", ".").concat(match[4] || "0"), options);
};
module.exports = $c8c0e2c83c785a6a$var$coerce;

});

parcelRegister("756jO", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $527de6c56dfa01ab$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
var $527de6c56dfa01ab$var$Comparator = /*#__PURE__*/ function() {
    "use strict";
    function Comparator(comp, options) {
        (0, $7dKN1._)(this, Comparator);
        options = $5TUY3(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $6mZK1("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $527de6c56dfa01ab$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $6mZK1("comp", this);
    }
    (0, $eW5pA._)(Comparator, [
        {
            key: "parse",
            value: function parse(comp) {
                var r = this.options.loose ? $527de6c56dfa01ab$var$re[$527de6c56dfa01ab$var$t.COMPARATORLOOSE] : $527de6c56dfa01ab$var$re[$527de6c56dfa01ab$var$t.COMPARATOR];
                var m = comp.match(r);
                if (!m) throw new TypeError("Invalid comparator: ".concat(comp));
                this.operator = m[1] !== undefined ? m[1] : "";
                if (this.operator === "=") this.operator = "";
                // if it literally is just '>' or '' then allow anything.
                if (!m[2]) this.semver = $527de6c56dfa01ab$var$ANY;
                else this.semver = new $lr447(m[2], this.options.loose);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.value;
            }
        },
        {
            key: "test",
            value: function test(version) {
                $6mZK1("Comparator.test", version, this.options.loose);
                if (this.semver === $527de6c56dfa01ab$var$ANY || version === $527de6c56dfa01ab$var$ANY) return true;
                if (typeof version === "string") try {
                    version = new $lr447(version, this.options);
                } catch (er) {
                    return false;
                }
                return $2EyQV(version, this.operator, this.semver, this.options);
            }
        },
        {
            key: "intersects",
            value: function intersects(comp, options) {
                if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
                if (this.operator === "") {
                    if (this.value === "") return true;
                    return new $6Nzdk(comp.value, options).test(this.value);
                } else if (comp.operator === "") {
                    if (comp.value === "") return true;
                    return new $6Nzdk(this.value, options).test(comp.semver);
                }
                options = $5TUY3(options);
                // Special cases where nothing can possibly be lower
                if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
                if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
                // Same direction increasing (> or >=)
                if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
                // Same direction decreasing (< or <=)
                if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
                // same SemVer and both sides are inclusive (<= or >=)
                if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
                // opposite directions less than
                if ($2EyQV(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
                // opposite directions greater than
                if ($2EyQV(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
                return false;
            }
        }
    ], [
        {
            key: "ANY",
            get: function get() {
                return $527de6c56dfa01ab$var$ANY;
            }
        }
    ]);
    return Comparator;
}();
module.exports = $527de6c56dfa01ab$var$Comparator;

var $5TUY3 = parcelRequire("5TUY3");

var $iSzNM = parcelRequire("iSzNM");
var $527de6c56dfa01ab$var$re = $iSzNM.safeRe, $527de6c56dfa01ab$var$t = $iSzNM.t;

var $2EyQV = parcelRequire("2EyQV");

var $6mZK1 = parcelRequire("6mZK1");

var $lr447 = parcelRequire("lr447");

var $6Nzdk = parcelRequire("6Nzdk");

});
parcelRegister("6Nzdk", function(module, exports) {
// hoisted class for cyclic dependency

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");
var $4f32a26fdf868561$var$Range = /*#__PURE__*/ function() {
    "use strict";
    function Range(range, options) {
        var _this = this;
        (0, $7dKN1._)(this, Range);
        options = $5TUY3(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof $756jO) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(" ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map(function(r) {
            return _this.parseRange(r.trim());
        })// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter(function(c) {
            return c.length;
        });
        if (!this.set.length) throw new TypeError("Invalid SemVer Range: ".concat(this.raw));
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            var first = this.set[0];
            this.set = this.set.filter(function(c) {
                return !$4f32a26fdf868561$var$isNullSet(c[0]);
            });
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // if we have any that are *, then the range is just *
                    for(var _iterator = this.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var c = _step.value;
                        if (c.length === 1 && $4f32a26fdf868561$var$isAny(c[0])) {
                            this.set = [
                                c
                            ];
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        this.format();
    }
    (0, $eW5pA._)(Range, [
        {
            key: "format",
            value: function format() {
                this.range = this.set.map(function(comps) {
                    return comps.join(" ").trim();
                }).join("||").trim();
                return this.range;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.range;
            }
        },
        {
            key: "parseRange",
            value: function parseRange(range) {
                var _this = this;
                // memoize range parsing for performance.
                // this is a very hot path, and fully deterministic.
                var memoOpts = (this.options.includePrerelease && $4f32a26fdf868561$var$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $4f32a26fdf868561$var$FLAG_LOOSE);
                var memoKey = memoOpts + ":" + range;
                var cached = $4f32a26fdf868561$var$cache.get(memoKey);
                if (cached) return cached;
                var loose = this.options.loose;
                // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
                var hr = loose ? $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.HYPHENRANGELOOSE] : $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.HYPHENRANGE];
                range = range.replace(hr, $4f32a26fdf868561$var$hyphenReplace(this.options.includePrerelease));
                $6mZK1("hyphen replace", range);
                // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
                range = range.replace($4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.COMPARATORTRIM], $4f32a26fdf868561$var$comparatorTrimReplace);
                $6mZK1("comparator trim", range);
                // `~ 1.2.3` => `~1.2.3`
                range = range.replace($4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.TILDETRIM], $4f32a26fdf868561$var$tildeTrimReplace);
                $6mZK1("tilde trim", range);
                // `^ 1.2.3` => `^1.2.3`
                range = range.replace($4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.CARETTRIM], $4f32a26fdf868561$var$caretTrimReplace);
                $6mZK1("caret trim", range);
                // At this point, the range is completely trimmed and
                // ready to be split into comparators.
                var rangeList = range.split(" ").map(function(comp) {
                    return $4f32a26fdf868561$var$parseComparator(comp, _this.options);
                }).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
                .map(function(comp) {
                    return $4f32a26fdf868561$var$replaceGTE0(comp, _this.options);
                });
                if (loose) // in loose mode, throw out any that are not valid comparators
                rangeList = rangeList.filter(function(comp) {
                    $6mZK1("loose invalid filter", comp, _this.options);
                    return !!comp.match($4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.COMPARATORLOOSE]);
                });
                $6mZK1("range list", rangeList);
                // if any comparators are the null set, then replace with JUST null set
                // if more than one comparator, remove any * comparators
                // also, don't include the same comparator more than once
                var rangeMap = new Map();
                var comparators = rangeList.map(function(comp) {
                    return new $756jO(comp, _this.options);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = comparators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var comp = _step.value;
                        if ($4f32a26fdf868561$var$isNullSet(comp)) return [
                            comp
                        ];
                        rangeMap.set(comp.value, comp);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
                var result = (0, $gF0bR._)(rangeMap.values());
                $4f32a26fdf868561$var$cache.set(memoKey, result);
                return result;
            }
        },
        {
            key: "intersects",
            value: function intersects(range, options) {
                if (!(range instanceof Range)) throw new TypeError("a Range is required");
                return this.set.some(function(thisComparators) {
                    return $4f32a26fdf868561$var$isSatisfiable(thisComparators, options) && range.set.some(function(rangeComparators) {
                        return $4f32a26fdf868561$var$isSatisfiable(rangeComparators, options) && thisComparators.every(function(thisComparator) {
                            return rangeComparators.every(function(rangeComparator) {
                                return thisComparator.intersects(rangeComparator, options);
                            });
                        });
                    });
                });
            }
        },
        {
            // if ANY of the sets match ALL of its comparators, then pass
            key: "test",
            value: function test(version) {
                if (!version) return false;
                if (typeof version === "string") try {
                    version = new $lr447(version, this.options);
                } catch (er) {
                    return false;
                }
                for(var i = 0; i < this.set.length; i++){
                    if ($4f32a26fdf868561$var$testSet(this.set[i], version, this.options)) return true;
                }
                return false;
            }
        }
    ]);
    return Range;
}();
module.exports = $4f32a26fdf868561$var$Range;

var $3DfNU = parcelRequire("3DfNU");
var $4f32a26fdf868561$var$cache = new $3DfNU({
    max: 1000
});

var $5TUY3 = parcelRequire("5TUY3");

var $756jO = parcelRequire("756jO");

var $6mZK1 = parcelRequire("6mZK1");

var $lr447 = parcelRequire("lr447");

var $iSzNM = parcelRequire("iSzNM");
var $4f32a26fdf868561$var$re = $iSzNM.safeRe, $4f32a26fdf868561$var$t = $iSzNM.t, $4f32a26fdf868561$var$comparatorTrimReplace = $iSzNM.comparatorTrimReplace, $4f32a26fdf868561$var$tildeTrimReplace = $iSzNM.tildeTrimReplace, $4f32a26fdf868561$var$caretTrimReplace = $iSzNM.caretTrimReplace;

var $8IJfp = parcelRequire("8IJfp");
var $4f32a26fdf868561$var$FLAG_INCLUDE_PRERELEASE = $8IJfp.FLAG_INCLUDE_PRERELEASE, $4f32a26fdf868561$var$FLAG_LOOSE = $8IJfp.FLAG_LOOSE;
var $4f32a26fdf868561$var$isNullSet = function(c) {
    return c.value === "<0.0.0-0";
};
var $4f32a26fdf868561$var$isAny = function(c) {
    return c.value === "";
};
// take a set of comparators and determine whether there
// exists a version which can satisfy it
var $4f32a26fdf868561$var$isSatisfiable = function(comparators, options) {
    var result = true;
    var remainingComparators = comparators.slice();
    var testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every(function(otherComparator) {
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
var $4f32a26fdf868561$var$parseComparator = function(comp, options) {
    $6mZK1("comp", comp, options);
    comp = $4f32a26fdf868561$var$replaceCarets(comp, options);
    $6mZK1("caret", comp);
    comp = $4f32a26fdf868561$var$replaceTildes(comp, options);
    $6mZK1("tildes", comp);
    comp = $4f32a26fdf868561$var$replaceXRanges(comp, options);
    $6mZK1("xrange", comp);
    comp = $4f32a26fdf868561$var$replaceStars(comp, options);
    $6mZK1("stars", comp);
    return comp;
};
var $4f32a26fdf868561$var$isX = function(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
};
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
var $4f32a26fdf868561$var$replaceTildes = function(comp, options) {
    return comp.trim().split(/\s+/).map(function(c) {
        return $4f32a26fdf868561$var$replaceTilde(c, options);
    }).join(" ");
};
var $4f32a26fdf868561$var$replaceTilde = function(comp, options) {
    var r = options.loose ? $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.TILDELOOSE] : $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        $6mZK1("tilde", comp, _, M, m, p, pr);
        var ret;
        if ($4f32a26fdf868561$var$isX(M)) ret = "";
        else if ($4f32a26fdf868561$var$isX(m)) ret = ">=".concat(M, ".0.0 <").concat(+M + 1, ".0.0-0");
        else if ($4f32a26fdf868561$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = ">=".concat(M, ".").concat(m, ".0 <").concat(M, ".").concat(+m + 1, ".0-0");
        else if (pr) {
            $6mZK1("replaceTilde pr", pr);
            ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(M, ".").concat(+m + 1, ".0-0");
        $6mZK1("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
var $4f32a26fdf868561$var$replaceCarets = function(comp, options) {
    return comp.trim().split(/\s+/).map(function(c) {
        return $4f32a26fdf868561$var$replaceCaret(c, options);
    }).join(" ");
};
var $4f32a26fdf868561$var$replaceCaret = function(comp, options) {
    $6mZK1("caret", comp, options);
    var r = options.loose ? $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.CARETLOOSE] : $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.CARET];
    var z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, function(_, M, m, p, pr) {
        $6mZK1("caret", comp, _, M, m, p, pr);
        var ret;
        if ($4f32a26fdf868561$var$isX(M)) ret = "";
        else if ($4f32a26fdf868561$var$isX(m)) ret = ">=".concat(M, ".0.0").concat(z, " <").concat(+M + 1, ".0.0-0");
        else if ($4f32a26fdf868561$var$isX(p)) {
            if (M === "0") ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
            else ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(+M + 1, ".0.0-0");
        } else if (pr) {
            $6mZK1("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                else ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
            } else ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(+M + 1, ".0.0-0");
        } else {
            $6mZK1("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                else ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
            } else ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(+M + 1, ".0.0-0");
        }
        $6mZK1("caret return", ret);
        return ret;
    });
};
var $4f32a26fdf868561$var$replaceXRanges = function(comp, options) {
    $6mZK1("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(c) {
        return $4f32a26fdf868561$var$replaceXRange(c, options);
    }).join(" ");
};
var $4f32a26fdf868561$var$replaceXRange = function(comp, options) {
    comp = comp.trim();
    var r = options.loose ? $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.XRANGELOOSE] : $4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        $6mZK1("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = $4f32a26fdf868561$var$isX(M);
        var xm = xM || $4f32a26fdf868561$var$isX(m);
        var xp = xm || $4f32a26fdf868561$var$isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = "".concat(gtlt + M, ".").concat(m, ".").concat(p).concat(pr);
        } else if (xm) ret = ">=".concat(M, ".0.0").concat(pr, " <").concat(+M + 1, ".0.0-0");
        else if (xp) ret = ">=".concat(M, ".").concat(m, ".0").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
        $6mZK1("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
var $4f32a26fdf868561$var$replaceStars = function(comp, options) {
    $6mZK1("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($4f32a26fdf868561$var$re[$4f32a26fdf868561$var$t.STAR], "");
};
var $4f32a26fdf868561$var$replaceGTE0 = function(comp, options) {
    $6mZK1("replaceGTE0", comp, options);
    return comp.trim().replace($4f32a26fdf868561$var$re[options.includePrerelease ? $4f32a26fdf868561$var$t.GTE0PRE : $4f32a26fdf868561$var$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
var $4f32a26fdf868561$var$hyphenReplace = function(incPr) {
    return function($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
        if ($4f32a26fdf868561$var$isX(fM)) from = "";
        else if ($4f32a26fdf868561$var$isX(fm)) from = ">=".concat(fM, ".0.0").concat(incPr ? "-0" : "");
        else if ($4f32a26fdf868561$var$isX(fp)) from = ">=".concat(fM, ".").concat(fm, ".0").concat(incPr ? "-0" : "");
        else if (fpr) from = ">=".concat(from);
        else from = ">=".concat(from).concat(incPr ? "-0" : "");
        if ($4f32a26fdf868561$var$isX(tM)) to = "";
        else if ($4f32a26fdf868561$var$isX(tm)) to = "<".concat(+tM + 1, ".0.0-0");
        else if ($4f32a26fdf868561$var$isX(tp)) to = "<".concat(tM, ".").concat(+tm + 1, ".0-0");
        else if (tpr) to = "<=".concat(tM, ".").concat(tm, ".").concat(tp, "-").concat(tpr);
        else if (incPr) to = "<".concat(tM, ".").concat(tm, ".").concat(+tp + 1, "-0");
        else to = "<=".concat(to);
        return "".concat(from, " ").concat(to).trim();
    };
};
var $4f32a26fdf868561$var$testSet = function(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(var i1 = 0; i1 < set.length; i1++){
            $6mZK1(set[i1].semver);
            if (set[i1].semver === $756jO.ANY) continue;
            if (set[i1].semver.prerelease.length > 0) {
                var allowed = set[i1].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});
parcelRegister("3DfNU", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";

var $3c1Bp = parcelRequire("3c1Bp");
var $2a5145facbf1d3df$var$MAX = Symbol("max");
var $2a5145facbf1d3df$var$LENGTH = Symbol("length");
var $2a5145facbf1d3df$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
var $2a5145facbf1d3df$var$ALLOW_STALE = Symbol("allowStale");
var $2a5145facbf1d3df$var$MAX_AGE = Symbol("maxAge");
var $2a5145facbf1d3df$var$DISPOSE = Symbol("dispose");
var $2a5145facbf1d3df$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
var $2a5145facbf1d3df$var$LRU_LIST = Symbol("lruList");
var $2a5145facbf1d3df$var$CACHE = Symbol("cache");
var $2a5145facbf1d3df$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
var $2a5145facbf1d3df$var$naiveLength = function() {
    return 1;
};
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
var $2a5145facbf1d3df$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(options) {
        (0, $7dKN1._)(this, LRUCache);
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        var max = this[$2a5145facbf1d3df$var$MAX] = options.max || Infinity;
        var lc = options.length || $2a5145facbf1d3df$var$naiveLength;
        this[$2a5145facbf1d3df$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $2a5145facbf1d3df$var$naiveLength : lc;
        this[$2a5145facbf1d3df$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$2a5145facbf1d3df$var$MAX_AGE] = options.maxAge || 0;
        this[$2a5145facbf1d3df$var$DISPOSE] = options.dispose;
        this[$2a5145facbf1d3df$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$2a5145facbf1d3df$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    (0, $eW5pA._)(LRUCache, [
        {
            key: "max",
            get: function get() {
                return this[$2a5145facbf1d3df$var$MAX];
            },
            set: // resize the cache when the max changes.
            function set(mL) {
                if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
                this[$2a5145facbf1d3df$var$MAX] = mL || Infinity;
                $2a5145facbf1d3df$var$trim(this);
            }
        },
        {
            key: "allowStale",
            get: function get() {
                return this[$2a5145facbf1d3df$var$ALLOW_STALE];
            },
            set: function set(allowStale) {
                this[$2a5145facbf1d3df$var$ALLOW_STALE] = !!allowStale;
            }
        },
        {
            key: "maxAge",
            get: function get() {
                return this[$2a5145facbf1d3df$var$MAX_AGE];
            },
            set: function set(mA) {
                if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
                this[$2a5145facbf1d3df$var$MAX_AGE] = mA;
                $2a5145facbf1d3df$var$trim(this);
            }
        },
        {
            key: "lengthCalculator",
            get: function get() {
                return this[$2a5145facbf1d3df$var$LENGTH_CALCULATOR];
            },
            set: // resize the cache when the lengthCalculator changes.
            function set(lC) {
                var _this = this;
                if (typeof lC !== "function") lC = $2a5145facbf1d3df$var$naiveLength;
                if (lC !== this[$2a5145facbf1d3df$var$LENGTH_CALCULATOR]) {
                    this[$2a5145facbf1d3df$var$LENGTH_CALCULATOR] = lC;
                    this[$2a5145facbf1d3df$var$LENGTH] = 0;
                    this[$2a5145facbf1d3df$var$LRU_LIST].forEach(function(hit) {
                        hit.length = _this[$2a5145facbf1d3df$var$LENGTH_CALCULATOR](hit.value, hit.key);
                        _this[$2a5145facbf1d3df$var$LENGTH] += hit.length;
                    });
                }
                $2a5145facbf1d3df$var$trim(this);
            }
        },
        {
            key: "length",
            get: function get() {
                return this[$2a5145facbf1d3df$var$LENGTH];
            }
        },
        {
            key: "itemCount",
            get: function get() {
                return this[$2a5145facbf1d3df$var$LRU_LIST].length;
            }
        },
        {
            key: "rforEach",
            value: function rforEach(fn, thisp) {
                thisp = thisp || this;
                for(var walker = this[$2a5145facbf1d3df$var$LRU_LIST].tail; walker !== null;){
                    var prev = walker.prev;
                    $2a5145facbf1d3df$var$forEachStep(this, fn, walker, thisp);
                    walker = prev;
                }
            }
        },
        {
            key: "forEach",
            value: function forEach(fn, thisp) {
                thisp = thisp || this;
                for(var walker = this[$2a5145facbf1d3df$var$LRU_LIST].head; walker !== null;){
                    var next = walker.next;
                    $2a5145facbf1d3df$var$forEachStep(this, fn, walker, thisp);
                    walker = next;
                }
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this[$2a5145facbf1d3df$var$LRU_LIST].toArray().map(function(k) {
                    return k.key;
                });
            }
        },
        {
            key: "values",
            value: function values() {
                return this[$2a5145facbf1d3df$var$LRU_LIST].toArray().map(function(k) {
                    return k.value;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                if (this[$2a5145facbf1d3df$var$DISPOSE] && this[$2a5145facbf1d3df$var$LRU_LIST] && this[$2a5145facbf1d3df$var$LRU_LIST].length) this[$2a5145facbf1d3df$var$LRU_LIST].forEach(function(hit) {
                    return _this[$2a5145facbf1d3df$var$DISPOSE](hit.key, hit.value);
                });
                this[$2a5145facbf1d3df$var$CACHE] = new Map() // hash of items by key
                ;
                this[$2a5145facbf1d3df$var$LRU_LIST] = new $3c1Bp() // list of items in order of use recency
                ;
                this[$2a5145facbf1d3df$var$LENGTH] = 0 // length of items in the list
                ;
            }
        },
        {
            key: "dump",
            value: function dump() {
                var _this = this;
                return this[$2a5145facbf1d3df$var$LRU_LIST].map(function(hit) {
                    return $2a5145facbf1d3df$var$isStale(_this, hit) ? false : {
                        k: hit.key,
                        v: hit.value,
                        e: hit.now + (hit.maxAge || 0)
                    };
                }).toArray().filter(function(h) {
                    return h;
                });
            }
        },
        {
            key: "dumpLru",
            value: function dumpLru() {
                return this[$2a5145facbf1d3df$var$LRU_LIST];
            }
        },
        {
            key: "set",
            value: function set(key, value, maxAge) {
                maxAge = maxAge || this[$2a5145facbf1d3df$var$MAX_AGE];
                if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
                var now = maxAge ? Date.now() : 0;
                var len = this[$2a5145facbf1d3df$var$LENGTH_CALCULATOR](value, key);
                if (this[$2a5145facbf1d3df$var$CACHE].has(key)) {
                    if (len > this[$2a5145facbf1d3df$var$MAX]) {
                        $2a5145facbf1d3df$var$del(this, this[$2a5145facbf1d3df$var$CACHE].get(key));
                        return false;
                    }
                    var node = this[$2a5145facbf1d3df$var$CACHE].get(key);
                    var item = node.value;
                    // dispose of the old one before overwriting
                    // split out into 2 ifs for better coverage tracking
                    if (this[$2a5145facbf1d3df$var$DISPOSE]) {
                        if (!this[$2a5145facbf1d3df$var$NO_DISPOSE_ON_SET]) this[$2a5145facbf1d3df$var$DISPOSE](key, item.value);
                    }
                    item.now = now;
                    item.maxAge = maxAge;
                    item.value = value;
                    this[$2a5145facbf1d3df$var$LENGTH] += len - item.length;
                    item.length = len;
                    this.get(key);
                    $2a5145facbf1d3df$var$trim(this);
                    return true;
                }
                var hit = new $2a5145facbf1d3df$var$Entry(key, value, len, now, maxAge);
                // oversized objects fall out of cache automatically.
                if (hit.length > this[$2a5145facbf1d3df$var$MAX]) {
                    if (this[$2a5145facbf1d3df$var$DISPOSE]) this[$2a5145facbf1d3df$var$DISPOSE](key, value);
                    return false;
                }
                this[$2a5145facbf1d3df$var$LENGTH] += hit.length;
                this[$2a5145facbf1d3df$var$LRU_LIST].unshift(hit);
                this[$2a5145facbf1d3df$var$CACHE].set(key, this[$2a5145facbf1d3df$var$LRU_LIST].head);
                $2a5145facbf1d3df$var$trim(this);
                return true;
            }
        },
        {
            key: "has",
            value: function has(key) {
                if (!this[$2a5145facbf1d3df$var$CACHE].has(key)) return false;
                var hit = this[$2a5145facbf1d3df$var$CACHE].get(key).value;
                return !$2a5145facbf1d3df$var$isStale(this, hit);
            }
        },
        {
            key: "get",
            value: function get1(key) {
                return $2a5145facbf1d3df$var$get(this, key, true);
            }
        },
        {
            key: "peek",
            value: function peek(key) {
                return $2a5145facbf1d3df$var$get(this, key, false);
            }
        },
        {
            key: "pop",
            value: function pop() {
                var node = this[$2a5145facbf1d3df$var$LRU_LIST].tail;
                if (!node) return null;
                $2a5145facbf1d3df$var$del(this, node);
                return node.value;
            }
        },
        {
            key: "del",
            value: function del1(key) {
                $2a5145facbf1d3df$var$del(this, this[$2a5145facbf1d3df$var$CACHE].get(key));
            }
        },
        {
            key: "load",
            value: function load(arr) {
                // reset the cache
                this.reset();
                var now = Date.now();
                // A previous serialized cache has the most recent items first
                for(var l = arr.length - 1; l >= 0; l--){
                    var hit = arr[l];
                    var expiresAt = hit.e || 0;
                    if (expiresAt === 0) // the item was created without expiration in a non aged cache
                    this.set(hit.k, hit.v);
                    else {
                        var maxAge = expiresAt - now;
                        // dont add already expired items
                        if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
                    }
                }
            }
        },
        {
            key: "prune",
            value: function prune() {
                var _this = this;
                this[$2a5145facbf1d3df$var$CACHE].forEach(function(value, key) {
                    return $2a5145facbf1d3df$var$get(_this, key, false);
                });
            }
        }
    ]);
    return LRUCache;
}();
var $2a5145facbf1d3df$var$get = function(self, key, doUse) {
    var node = self[$2a5145facbf1d3df$var$CACHE].get(key);
    if (node) {
        var hit = node.value;
        if ($2a5145facbf1d3df$var$isStale(self, hit)) {
            $2a5145facbf1d3df$var$del(self, node);
            if (!self[$2a5145facbf1d3df$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$2a5145facbf1d3df$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$2a5145facbf1d3df$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
var $2a5145facbf1d3df$var$isStale = function(self, hit) {
    if (!hit || !hit.maxAge && !self[$2a5145facbf1d3df$var$MAX_AGE]) return false;
    var diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$2a5145facbf1d3df$var$MAX_AGE] && diff > self[$2a5145facbf1d3df$var$MAX_AGE];
};
var $2a5145facbf1d3df$var$trim = function(self) {
    if (self[$2a5145facbf1d3df$var$LENGTH] > self[$2a5145facbf1d3df$var$MAX]) for(var walker = self[$2a5145facbf1d3df$var$LRU_LIST].tail; self[$2a5145facbf1d3df$var$LENGTH] > self[$2a5145facbf1d3df$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        var prev = walker.prev;
        $2a5145facbf1d3df$var$del(self, walker);
        walker = prev;
    }
};
var $2a5145facbf1d3df$var$del = function(self, node) {
    if (node) {
        var hit = node.value;
        if (self[$2a5145facbf1d3df$var$DISPOSE]) self[$2a5145facbf1d3df$var$DISPOSE](hit.key, hit.value);
        self[$2a5145facbf1d3df$var$LENGTH] -= hit.length;
        self[$2a5145facbf1d3df$var$CACHE].delete(hit.key);
        self[$2a5145facbf1d3df$var$LRU_LIST].removeNode(node);
    }
};
var $2a5145facbf1d3df$var$Entry = function Entry(key, value, length, now, maxAge) {
    (0, $7dKN1._)(this, Entry);
    this.key = key;
    this.value = value;
    this.length = length;
    this.now = now;
    this.maxAge = maxAge || 0;
};
var $2a5145facbf1d3df$var$forEachStep = function(self, fn, node, thisp) {
    var hit = node.value;
    if ($2a5145facbf1d3df$var$isStale(self, hit)) {
        $2a5145facbf1d3df$var$del(self, node);
        if (!self[$2a5145facbf1d3df$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = $2a5145facbf1d3df$var$LRUCache;

});
parcelRegister("3c1Bp", function(module, exports) {
"use strict";
module.exports = $2533bc4ee58b3e22$var$Yallist;
$2533bc4ee58b3e22$var$Yallist.Node = $2533bc4ee58b3e22$var$Node;
$2533bc4ee58b3e22$var$Yallist.create = $2533bc4ee58b3e22$var$Yallist;
function $2533bc4ee58b3e22$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $2533bc4ee58b3e22$var$Yallist)) self = new $2533bc4ee58b3e22$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$2533bc4ee58b3e22$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$2533bc4ee58b3e22$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$2533bc4ee58b3e22$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$2533bc4ee58b3e22$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$2533bc4ee58b3e22$var$push(this, arguments[i]);
    return this.length;
};
$2533bc4ee58b3e22$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$2533bc4ee58b3e22$var$unshift(this, arguments[i]);
    return this.length;
};
$2533bc4ee58b3e22$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$2533bc4ee58b3e22$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$2533bc4ee58b3e22$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$2533bc4ee58b3e22$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$2533bc4ee58b3e22$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$2533bc4ee58b3e22$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$2533bc4ee58b3e22$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $2533bc4ee58b3e22$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$2533bc4ee58b3e22$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $2533bc4ee58b3e22$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$2533bc4ee58b3e22$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$2533bc4ee58b3e22$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$2533bc4ee58b3e22$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$2533bc4ee58b3e22$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$2533bc4ee58b3e22$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $2533bc4ee58b3e22$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$2533bc4ee58b3e22$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $2533bc4ee58b3e22$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$2533bc4ee58b3e22$var$Yallist.prototype.splice = function(start, deleteCount) {
    for(var _len = arguments.length, nodes = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        nodes[_key - 2] = arguments[_key];
    }
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = $2533bc4ee58b3e22$var$insert(this, walker, nodes[i]);
    return ret;
};
$2533bc4ee58b3e22$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $2533bc4ee58b3e22$var$insert(self, node, value) {
    var inserted = node === self.head ? new $2533bc4ee58b3e22$var$Node(value, null, node, self) : new $2533bc4ee58b3e22$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $2533bc4ee58b3e22$var$push(self, item) {
    self.tail = new $2533bc4ee58b3e22$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $2533bc4ee58b3e22$var$unshift(self, item) {
    self.head = new $2533bc4ee58b3e22$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $2533bc4ee58b3e22$var$Node(value, prev, next, list) {
    if (!(this instanceof $2533bc4ee58b3e22$var$Node)) return new $2533bc4ee58b3e22$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("5yA2Z"))($2533bc4ee58b3e22$var$Yallist);
} catch (er) {}

});
parcelRegister("5yA2Z", function(module, exports) {

var $6qu4b = parcelRequire("6qu4b");
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function() {
        var walker;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    walker = this.head;
                    _state.label = 1;
                case 1:
                    if (!walker) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        walker.value
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    walker = walker.next;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    };
};

});





parcelRegister("bQKGF", function(module, exports) {

var $6Nzdk = parcelRequire("6Nzdk");
var $8a08c41deac4bfb1$var$satisfies = function(version, range, options) {
    try {
        range = new $6Nzdk(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $8a08c41deac4bfb1$var$satisfies;

});

parcelRegister("fFzzv", function(module, exports) {

var $6Nzdk = parcelRequire("6Nzdk");
// Mostly just for testing and legacy API reasons
var $b68647274e3ce5fd$var$toComparators = function(range, options) {
    return new $6Nzdk(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
};
module.exports = $b68647274e3ce5fd$var$toComparators;

});

parcelRegister("kB0Je", function(module, exports) {

var $lr447 = parcelRequire("lr447");

var $6Nzdk = parcelRequire("6Nzdk");
var $efe7d40929a484f9$var$maxSatisfying = function(versions, range, options) {
    var max = null;
    var maxSV = null;
    var rangeObj = null;
    try {
        rangeObj = new $6Nzdk(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $lr447(max, options);
            }
        }
    });
    return max;
};
module.exports = $efe7d40929a484f9$var$maxSatisfying;

});

parcelRegister("a1kUx", function(module, exports) {

var $lr447 = parcelRequire("lr447");

var $6Nzdk = parcelRequire("6Nzdk");
var $74ba37d3fbe6559e$var$minSatisfying = function(versions, range, options) {
    var min = null;
    var minSV = null;
    var rangeObj = null;
    try {
        rangeObj = new $6Nzdk(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $lr447(min, options);
            }
        }
    });
    return min;
};
module.exports = $74ba37d3fbe6559e$var$minSatisfying;

});

parcelRegister("9afig", function(module, exports) {

var $lr447 = parcelRequire("lr447");

var $6Nzdk = parcelRequire("6Nzdk");

var $hKfSC = parcelRequire("hKfSC");
var $6ac0e936aa3c5498$var$minVersion = function(range, loose) {
    var _loop = function(i) {
        var comparators = range.set[i];
        var setMin = null;
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new $lr447(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $hKfSC(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: ".concat(comparator.operator));
            }
        });
        if (setMin && (!minver || $hKfSC(minver, setMin))) minver = setMin;
    };
    range = new $6Nzdk(range, loose);
    var minver = new $lr447("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $lr447("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i)_loop(i);
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $6ac0e936aa3c5498$var$minVersion;

});

parcelRegister("khpN1", function(module, exports) {

var $6Nzdk = parcelRequire("6Nzdk");
var $ec39667afd925a75$var$validRange = function(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $6Nzdk(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
module.exports = $ec39667afd925a75$var$validRange;

});

parcelRegister("d4mZ6", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");

var $lr447 = parcelRequire("lr447");

var $756jO = parcelRequire("756jO");
var $983d7a513dc6f08c$var$ANY = $756jO.ANY;

var $6Nzdk = parcelRequire("6Nzdk");

var $bQKGF = parcelRequire("bQKGF");

var $hKfSC = parcelRequire("hKfSC");

var $5THum = parcelRequire("5THum");

var $11CoZ = parcelRequire("11CoZ");

var $5Taub = parcelRequire("5Taub");
var $983d7a513dc6f08c$var$outside = function(version, range, hilo, options) {
    var _loop = function(i) {
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === $983d7a513dc6f08c$var$ANY) comparator = new $756jO(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return {
            v: false
        };
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return {
            v: false
        };
        else if (low.operator === ecomp && ltfn(version, low.semver)) return {
            v: false
        };
    };
    version = new $lr447(version, options);
    range = new $6Nzdk(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $hKfSC;
            ltefn = $11CoZ;
            ltfn = $5THum;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $5THum;
            ltefn = $5Taub;
            ltfn = $hKfSC;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($bQKGF(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var _ret = _loop(i);
        if ((0, $aVMuR._)(_ret) === "object") return _ret.v;
    }
    return true;
};
module.exports = $983d7a513dc6f08c$var$outside;

});

parcelRegister("g9ZCB", function(module, exports) {
// Determine if version is greater than all the versions possible in the range.

var $d4mZ6 = parcelRequire("d4mZ6");
var $bc3d4960a601ab9d$var$gtr = function(version, range, options) {
    return $d4mZ6(version, range, ">", options);
};
module.exports = $bc3d4960a601ab9d$var$gtr;

});

parcelRegister("awdTf", function(module, exports) {

var $d4mZ6 = parcelRequire("d4mZ6");
// Determine if version is less than all the versions possible in the range
var $7a87aad9b9ba4f9a$var$ltr = function(version, range, options) {
    return $d4mZ6(version, range, "<", options);
};
module.exports = $7a87aad9b9ba4f9a$var$ltr;

});

parcelRegister("e6bFV", function(module, exports) {

var $6Nzdk = parcelRequire("6Nzdk");
var $a43aaea8f3f69b7f$var$intersects = function(r1, r2, options) {
    r1 = new $6Nzdk(r1, options);
    r2 = new $6Nzdk(r2, options);
    return r1.intersects(r2, options);
};
module.exports = $a43aaea8f3f69b7f$var$intersects;

});

parcelRegister("5LeZz", function(module, exports) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.

var $5OlIx = parcelRequire("5OlIx");

var $bQKGF = parcelRequire("bQKGF");

var $bgeIt = parcelRequire("bgeIt");
module.exports = function(versions, range, options) {
    var set = [];
    var first = null;
    var prev = null;
    var v = versions.sort(function(a, b) {
        return $bgeIt(a, b, options);
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var version = _step.value;
            var included = $bQKGF(version, range, options);
            if (included) {
                prev = version;
                if (!first) first = version;
            } else {
                if (prev) set.push([
                    first,
                    prev
                ]);
                prev = null;
                first = null;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    var ranges = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $5OlIx._)(_step1.value, 2), min = _step_value[0], max = _step_value[1];
            if (min === max) ranges.push(min);
            else if (!max && min === v[0]) ranges.push("*");
            else if (!max) ranges.push(">=".concat(min));
            else if (min === v[0]) ranges.push("<=".concat(max));
            else ranges.push("".concat(min, " - ").concat(max));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var simplified = ranges.join(" || ");
    var original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("gDPfD", function(module, exports) {

var $6Nzdk = parcelRequire("6Nzdk");

var $756jO = parcelRequire("756jO");
var $c1d80b4b57b35db0$var$ANY = $756jO.ANY;

var $bQKGF = parcelRequire("bQKGF");

var $bgeIt = parcelRequire("bgeIt");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
var $c1d80b4b57b35db0$var$subset = function(sub, dom) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (sub === dom) return true;
    sub = new $6Nzdk(sub, options);
    dom = new $6Nzdk(dom, options);
    var sawNonNull = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        OUTER: for(var _iterator = sub.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var simpleSub = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = dom.set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var simpleDom = _step1.value;
                    var isSub = $c1d80b4b57b35db0$var$simpleSubset(simpleSub, simpleDom, options);
                    sawNonNull = sawNonNull || isSub !== null;
                    if (isSub) continue OUTER;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // the null set is a subset of everything, but null simple ranges in
            // a complex range should be ignored.  so if we saw a non-null range,
            // then we know this isn't a subset, but if EVERY simple range was null,
            // then it is a subset.
            if (sawNonNull) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
var $c1d80b4b57b35db0$var$minimumVersionWithPreRelease = [
    new $756jO(">=0.0.0-0")
];
var $c1d80b4b57b35db0$var$minimumVersion = [
    new $756jO(">=0.0.0")
];
var $c1d80b4b57b35db0$var$simpleSubset = function(sub, dom, options) {
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $c1d80b4b57b35db0$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $c1d80b4b57b35db0$var$ANY) return true;
        else if (options.includePrerelease) sub = $c1d80b4b57b35db0$var$minimumVersionWithPreRelease;
        else sub = $c1d80b4b57b35db0$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $c1d80b4b57b35db0$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $c1d80b4b57b35db0$var$minimumVersion;
    }
    var eqSet = new Set();
    var gt, lt;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sub[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (c.operator === ">" || c.operator === ">=") gt = $c1d80b4b57b35db0$var$higherGT(gt, c, options);
            else if (c.operator === "<" || c.operator === "<=") lt = $c1d80b4b57b35db0$var$lowerLT(lt, c, options);
            else eqSet.add(c.semver);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (eqSet.size > 1) return null;
    var gtltComp;
    if (gt && lt) {
        gtltComp = $bgeIt(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // will iterate one or zero times
        for(var _iterator1 = eqSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var eq = _step1.value;
            if (gt && !$bQKGF(eq, String(gt), options)) return null;
            if (lt && !$bQKGF(eq, String(lt), options)) return null;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = dom[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var c1 = _step2.value;
                    if (!$bQKGF(eq, String(c1), options)) return false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            return true;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var higher, lower;
    var hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    var needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    var needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = dom[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var c2 = _step3.value;
            hasDomGT = hasDomGT || c2.operator === ">" || c2.operator === ">=";
            hasDomLT = hasDomLT || c2.operator === "<" || c2.operator === "<=";
            if (gt) {
                if (needDomGTPre) {
                    if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomGTPre.major && c2.semver.minor === needDomGTPre.minor && c2.semver.patch === needDomGTPre.patch) needDomGTPre = false;
                }
                if (c2.operator === ">" || c2.operator === ">=") {
                    higher = $c1d80b4b57b35db0$var$higherGT(gt, c2, options);
                    if (higher === c2 && higher !== gt) return false;
                } else if (gt.operator === ">=" && !$bQKGF(gt.semver, String(c2), options)) return false;
            }
            if (lt) {
                if (needDomLTPre) {
                    if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomLTPre.major && c2.semver.minor === needDomLTPre.minor && c2.semver.patch === needDomLTPre.patch) needDomLTPre = false;
                }
                if (c2.operator === "<" || c2.operator === "<=") {
                    lower = $c1d80b4b57b35db0$var$lowerLT(lt, c2, options);
                    if (lower === c2 && lower !== lt) return false;
                } else if (lt.operator === "<=" && !$bQKGF(lt.semver, String(c2), options)) return false;
            }
            if (!c2.operator && (lt || gt) && gtltComp !== 0) return false;
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
var $c1d80b4b57b35db0$var$higherGT = function(a, b, options) {
    if (!a) return b;
    var comp = $bgeIt(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
var $c1d80b4b57b35db0$var$lowerLT = function(a, b, options) {
    if (!a) return b;
    var comp = $bgeIt(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
module.exports = $c1d80b4b57b35db0$var$subset;

});


parcelRegister("kkCxI", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");

var $5QMMm = parcelRequire("5QMMm");

var $bZhLR = parcelRequire("bZhLR");

var $6gFRs = parcelRequire("6gFRs");

var $1ABZ2 = parcelRequire("1ABZ2");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $ecd392ae0d92303f$var$createInstance(defaultConfig) {
    var context = new $bZhLR(defaultConfig);
    var instance = $5QMMm($bZhLR.prototype.request, context);
    // Copy axios.prototype to instance
    $7EHfF.extend(instance, $bZhLR.prototype, context);
    // Copy context to instance
    $7EHfF.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $ecd392ae0d92303f$var$createInstance($6gFRs(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $ecd392ae0d92303f$var$axios = $ecd392ae0d92303f$var$createInstance($1ABZ2);
// Expose Axios class to allow class inheritance
$ecd392ae0d92303f$var$axios.Axios = $bZhLR;

// Expose Cancel & CancelToken
$ecd392ae0d92303f$var$axios.Cancel = (parcelRequire("5o2ps"));

$ecd392ae0d92303f$var$axios.CancelToken = (parcelRequire("bcNzs"));

$ecd392ae0d92303f$var$axios.isCancel = (parcelRequire("gtvwV"));

$ecd392ae0d92303f$var$axios.VERSION = (parcelRequire("fygSD")).version;
// Expose all/spread
$ecd392ae0d92303f$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$ecd392ae0d92303f$var$axios.spread = (parcelRequire("k3WCE"));

// Expose isAxiosError
$ecd392ae0d92303f$var$axios.isAxiosError = (parcelRequire("1pQUd"));
module.exports = $ecd392ae0d92303f$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $ecd392ae0d92303f$var$axios;

});
parcelRegister("7EHfF", function(module, exports) {
"use strict";

var $5QMMm = parcelRequire("5QMMm");
// utils is a library of generic helper functions non-specific to axios
var $592dd1b1936f3c82$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $592dd1b1936f3c82$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $592dd1b1936f3c82$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $592dd1b1936f3c82$var$isBuffer(val) {
    return val !== null && !$592dd1b1936f3c82$var$isUndefined(val) && val.constructor !== null && !$592dd1b1936f3c82$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $592dd1b1936f3c82$var$isArrayBuffer(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $592dd1b1936f3c82$var$isFormData(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $592dd1b1936f3c82$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $592dd1b1936f3c82$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $592dd1b1936f3c82$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $592dd1b1936f3c82$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $592dd1b1936f3c82$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $592dd1b1936f3c82$var$isPlainObject(val) {
    if ($592dd1b1936f3c82$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $592dd1b1936f3c82$var$isDate(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $592dd1b1936f3c82$var$isFile(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $592dd1b1936f3c82$var$isBlob(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $592dd1b1936f3c82$var$isFunction(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $592dd1b1936f3c82$var$isStream(val) {
    return $592dd1b1936f3c82$var$isObject(val) && $592dd1b1936f3c82$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $592dd1b1936f3c82$var$isURLSearchParams(val) {
    return $592dd1b1936f3c82$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $592dd1b1936f3c82$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $592dd1b1936f3c82$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $592dd1b1936f3c82$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($592dd1b1936f3c82$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $592dd1b1936f3c82$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($592dd1b1936f3c82$var$isPlainObject(result[key]) && $592dd1b1936f3c82$var$isPlainObject(val)) result[key] = $592dd1b1936f3c82$var$merge(result[key], val);
        else if ($592dd1b1936f3c82$var$isPlainObject(val)) result[key] = $592dd1b1936f3c82$var$merge({}, val);
        else if ($592dd1b1936f3c82$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$592dd1b1936f3c82$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $592dd1b1936f3c82$var$extend(a, b, thisArg) {
    $592dd1b1936f3c82$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $5QMMm(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $592dd1b1936f3c82$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $592dd1b1936f3c82$var$isArray,
    isArrayBuffer: $592dd1b1936f3c82$var$isArrayBuffer,
    isBuffer: $592dd1b1936f3c82$var$isBuffer,
    isFormData: $592dd1b1936f3c82$var$isFormData,
    isArrayBufferView: $592dd1b1936f3c82$var$isArrayBufferView,
    isString: $592dd1b1936f3c82$var$isString,
    isNumber: $592dd1b1936f3c82$var$isNumber,
    isObject: $592dd1b1936f3c82$var$isObject,
    isPlainObject: $592dd1b1936f3c82$var$isPlainObject,
    isUndefined: $592dd1b1936f3c82$var$isUndefined,
    isDate: $592dd1b1936f3c82$var$isDate,
    isFile: $592dd1b1936f3c82$var$isFile,
    isBlob: $592dd1b1936f3c82$var$isBlob,
    isFunction: $592dd1b1936f3c82$var$isFunction,
    isStream: $592dd1b1936f3c82$var$isStream,
    isURLSearchParams: $592dd1b1936f3c82$var$isURLSearchParams,
    isStandardBrowserEnv: $592dd1b1936f3c82$var$isStandardBrowserEnv,
    forEach: $592dd1b1936f3c82$var$forEach,
    merge: $592dd1b1936f3c82$var$merge,
    extend: $592dd1b1936f3c82$var$extend,
    trim: $592dd1b1936f3c82$var$trim,
    stripBOM: $592dd1b1936f3c82$var$stripBOM
};

});
parcelRegister("5QMMm", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("bZhLR", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");

var $3JqN5 = parcelRequire("3JqN5");

var $eTIjZ = parcelRequire("eTIjZ");

var $kv76v = parcelRequire("kv76v");

var $6gFRs = parcelRequire("6gFRs");

var $jKUia = parcelRequire("jKUia");
var $8ba32d23b5485d9e$var$validators = $jKUia.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $8ba32d23b5485d9e$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $eTIjZ(),
        response: new $eTIjZ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $8ba32d23b5485d9e$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $6gFRs(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $jKUia.assertOptions(transitional, {
        silentJSONParsing: $8ba32d23b5485d9e$var$validators.transitional($8ba32d23b5485d9e$var$validators.boolean),
        forcedJSONParsing: $8ba32d23b5485d9e$var$validators.transitional($8ba32d23b5485d9e$var$validators.boolean),
        clarifyTimeoutError: $8ba32d23b5485d9e$var$validators.transitional($8ba32d23b5485d9e$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $kv76v,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $kv76v(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$8ba32d23b5485d9e$var$Axios.prototype.getUri = function getUri(config) {
    config = $6gFRs(this.defaults, config);
    return $3JqN5(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$7EHfF.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $8ba32d23b5485d9e$var$Axios.prototype[method] = function(url, config) {
        return this.request($6gFRs(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$7EHfF.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $8ba32d23b5485d9e$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($6gFRs(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $8ba32d23b5485d9e$var$Axios;

});
parcelRegister("3JqN5", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
function $2b7a5b2aef245094$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($7EHfF.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $7EHfF.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($7EHfF.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $7EHfF.forEach(val, function parseValue(v) {
                if ($7EHfF.isDate(v)) v = v.toISOString();
                else if ($7EHfF.isObject(v)) v = JSON.stringify(v);
                parts.push($2b7a5b2aef245094$var$encode(key) + "=" + $2b7a5b2aef245094$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("eTIjZ", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
function $ad88950957044607$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ad88950957044607$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ad88950957044607$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ad88950957044607$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $7EHfF.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ad88950957044607$var$InterceptorManager;

});

parcelRegister("kv76v", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");

var $jLx23 = parcelRequire("jLx23");

var $gtvwV = parcelRequire("gtvwV");

var $1ABZ2 = parcelRequire("1ABZ2");

var $5o2ps = parcelRequire("5o2ps");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $eecc369c5d86d52b$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $5o2ps("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $eecc369c5d86d52b$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $jLx23.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $7EHfF.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $7EHfF.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1ABZ2.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $eecc369c5d86d52b$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $jLx23.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$gtvwV(reason)) {
            $eecc369c5d86d52b$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $jLx23.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("jLx23", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");

var $1ABZ2 = parcelRequire("1ABZ2");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $1ABZ2;
    /*eslint no-param-reassign:0*/ $7EHfF.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("1ABZ2", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
"use strict";

var $7EHfF = parcelRequire("7EHfF");

var $4vvLl = parcelRequire("4vvLl");

var $7HodB = parcelRequire("7HodB");

var $8KgIX = parcelRequire("8KgIX");
var $12869dfc0a092734$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $12869dfc0a092734$var$setContentTypeIfUnset(headers, value) {
    if (!$7EHfF.isUndefined(headers) && $7EHfF.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $12869dfc0a092734$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("i6Wn4"));
    else if (typeof $4pbh3 !== "undefined" && Object.prototype.toString.call($4pbh3) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("i6Wn4"));
    return adapter;
}
function $12869dfc0a092734$var$stringifySafely(rawValue, parser, encoder) {
    if ($7EHfF.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $7EHfF.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $12869dfc0a092734$var$defaults = {
    transitional: $8KgIX,
    adapter: $12869dfc0a092734$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $4vvLl(headers, "Accept");
            $4vvLl(headers, "Content-Type");
            if ($7EHfF.isFormData(data) || $7EHfF.isArrayBuffer(data) || $7EHfF.isBuffer(data) || $7EHfF.isStream(data) || $7EHfF.isFile(data) || $7EHfF.isBlob(data)) return data;
            if ($7EHfF.isArrayBufferView(data)) return data.buffer;
            if ($7EHfF.isURLSearchParams(data)) {
                $12869dfc0a092734$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($7EHfF.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $12869dfc0a092734$var$setContentTypeIfUnset(headers, "application/json");
                return $12869dfc0a092734$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $12869dfc0a092734$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $7EHfF.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $7HodB(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$7EHfF.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $12869dfc0a092734$var$defaults.headers[method] = {};
});
$7EHfF.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $12869dfc0a092734$var$defaults.headers[method] = $7EHfF.merge($12869dfc0a092734$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $12869dfc0a092734$var$defaults;

});
parcelRegister("4vvLl", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $7EHfF.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("7HodB", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("8KgIX", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("i6Wn4", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");

var $44whk = parcelRequire("44whk");

var $8WbZ9 = parcelRequire("8WbZ9");

var $3JqN5 = parcelRequire("3JqN5");

var $lsbiD = parcelRequire("lsbiD");

var $45gbq = parcelRequire("45gbq");

var $cbkYS = parcelRequire("cbkYS");

var $jFsiO = parcelRequire("jFsiO");

var $8KgIX = parcelRequire("8KgIX");

var $5o2ps = parcelRequire("5o2ps");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($7EHfF.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $lsbiD(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $3JqN5(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $45gbq(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $44whk(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($jFsiO("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($jFsiO("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $8KgIX;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($jFsiO(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($7EHfF.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $cbkYS(fullPath)) && config.xsrfCookieName ? $8WbZ9.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $7EHfF.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$7EHfF.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function onCanceled(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $5o2ps("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("44whk", function(module, exports) {
"use strict";

var $jFsiO = parcelRequire("jFsiO");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($jFsiO("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("jFsiO", function(module, exports) {
"use strict";

var $7HodB = parcelRequire("7HodB");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $7HodB(error, config, code, request, response);
};

});


parcelRegister("8WbZ9", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
module.exports = $7EHfF.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($7EHfF.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($7EHfF.isString(path)) cookie.push("path=" + path);
            if ($7EHfF.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("lsbiD", function(module, exports) {
"use strict";

var $fheca = parcelRequire("fheca");

var $atK96 = parcelRequire("atK96");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$fheca(requestedURL)) return $atK96(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("fheca", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("atK96", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("45gbq", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $2f942eb84b9ff773$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $7EHfF.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $7EHfF.trim(line.substr(0, i)).toLowerCase();
        val = $7EHfF.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $2f942eb84b9ff773$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("cbkYS", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
module.exports = $7EHfF.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $7EHfF.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("5o2ps", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $3ec11020e8df7c11$var$Cancel(message) {
    this.message = message;
}
$3ec11020e8df7c11$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$3ec11020e8df7c11$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $3ec11020e8df7c11$var$Cancel;

});




parcelRegister("gtvwV", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("6gFRs", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($7EHfF.isPlainObject(target) && $7EHfF.isPlainObject(source)) return $7EHfF.merge(target, source);
        else if ($7EHfF.isPlainObject(source)) return $7EHfF.merge({}, source);
        else if ($7EHfF.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$7EHfF.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$7EHfF.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$7EHfF.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$7EHfF.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$7EHfF.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $7EHfF.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $7EHfF.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("jKUia", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");
"use strict";

var $fygSD = parcelRequire("fygSD");
var $e61dfa9eac74d93f$require$VERSION = $fygSD.version;
var $e61dfa9eac74d93f$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $e61dfa9eac74d93f$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $aVMuR._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $e61dfa9eac74d93f$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $e61dfa9eac74d93f$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $e61dfa9eac74d93f$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$e61dfa9eac74d93f$var$deprecatedWarnings[opt]) {
            $e61dfa9eac74d93f$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $e61dfa9eac74d93f$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $e61dfa9eac74d93f$var$assertOptions,
    validators: $e61dfa9eac74d93f$var$validators
};

});
parcelRegister("fygSD", function(module, exports) {
module.exports = {
    "version": "0.26.1"
};

});



parcelRegister("bcNzs", function(module, exports) {
"use strict";

var $5o2ps = parcelRequire("5o2ps");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $82874471c38f4aab$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $5o2ps(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $82874471c38f4aab$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $82874471c38f4aab$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $82874471c38f4aab$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $82874471c38f4aab$var$CancelToken.source = function source() {
    var cancel;
    var token = new $82874471c38f4aab$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $82874471c38f4aab$var$CancelToken;

});

parcelRegister("k3WCE", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1pQUd", function(module, exports) {
"use strict";

var $7EHfF = parcelRequire("7EHfF");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $7EHfF.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("zGv1L", function(module, exports) {
"use strict";
/**
 * Generate a character map.
 * @param {string} alphabet e.g. "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"
 * @param {object} mappings map overrides from key to value
 * @method
 */ var charmap = function charmap(alphabet, mappings) {
    mappings || (mappings = {});
    alphabet.split("").forEach(function(c, i) {
        if (!(c in mappings)) mappings[c] = i;
    });
    return mappings;
};
/**
 * The RFC 4648 base 32 alphabet and character map.
 * @see {@link https://tools.ietf.org/html/rfc4648}
 */ var rfc4648 = {
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    charmap: {
        0: 14,
        1: 8
    }
};
rfc4648.charmap = charmap(rfc4648.alphabet, rfc4648.charmap);
/**
 * The Crockford base 32 alphabet and character map.
 * @see {@link http://www.crockford.com/wrmg/base32.html}
 */ var crockford = {
    alphabet: "0123456789ABCDEFGHJKMNPQRSTVWXYZ",
    charmap: {
        O: 0,
        I: 1,
        L: 1
    }
};
crockford.charmap = charmap(crockford.alphabet, crockford.charmap);
/**
 * base32hex
 * @see {@link https://en.wikipedia.org/wiki/Base32#base32hex}
 */ var base32hex = {
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    charmap: {}
};
base32hex.charmap = charmap(base32hex.alphabet, base32hex.charmap);
/**
 * Create a new `Decoder` with the given options.
 *
 * @param {object} [options]
 *   @param {string} [type] Supported Base-32 variants are "rfc4648" and
 *     "crockford".
 *   @param {object} [charmap] Override the character map used in decoding.
 * @constructor
 */ function Decoder(options) {
    this.buf = [];
    this.shift = 8;
    this.carry = 0;
    if (options) {
        switch(options.type){
            case "rfc4648":
                this.charmap = exports.rfc4648.charmap;
                break;
            case "crockford":
                this.charmap = exports.crockford.charmap;
                break;
            case "base32hex":
                this.charmap = exports.base32hex.charmap;
                break;
            default:
                throw new Error("invalid type");
        }
        if (options.charmap) this.charmap = options.charmap;
    }
}
/**
 * The default character map coresponds to RFC4648.
 */ Decoder.prototype.charmap = rfc4648.charmap;
/**
 * Decode a string, continuing from the previous state.
 *
 * @param {string} str
 * @return {Decoder} this
 */ Decoder.prototype.write = function(str) {
    var charmap = this.charmap;
    var buf = this.buf;
    var shift = this.shift;
    var carry = this.carry;
    // decode string
    str.toUpperCase().split("").forEach(function(char) {
        // ignore padding
        if (char == "=") return;
        // lookup symbol
        var symbol = charmap[char] & 0xff;
        // 1: 00000 000
        // 2:          00 00000 0
        // 3:                    0000 0000
        // 4:                             0 00000 00
        // 5:                                       000 00000
        // 6:                                                00000 000
        // 7:                                                         00 00000 0
        shift -= 5;
        if (shift > 0) carry |= symbol << shift;
        else if (shift < 0) {
            buf.push(carry | symbol >> -shift);
            shift += 8;
            carry = symbol << shift & 0xff;
        } else {
            buf.push(carry | symbol);
            shift = 8;
            carry = 0;
        }
    });
    // save state
    this.shift = shift;
    this.carry = carry;
    // for chaining
    return this;
};
/**
 * Finish decoding.
 *
 * @param {string} [str] The final string to decode.
 * @return {Array} Decoded byte array.
 */ Decoder.prototype.finalize = function(str) {
    if (str) this.write(str);
    if (this.shift !== 8 && this.carry !== 0) {
        this.buf.push(this.carry);
        this.shift = 8;
        this.carry = 0;
    }
    return this.buf;
};
/**
 * Create a new `Encoder` with the given options.
 *
 * @param {object} [options]
 *   @param {string} [type] Supported Base-32 variants are "rfc4648" and
 *     "crockford".
 *   @param {object} [alphabet] Override the alphabet used in encoding.
 * @constructor
 */ function Encoder(options) {
    this.buf = "";
    this.shift = 3;
    this.carry = 0;
    if (options) {
        switch(options.type){
            case "rfc4648":
                this.alphabet = exports.rfc4648.alphabet;
                break;
            case "crockford":
                this.alphabet = exports.crockford.alphabet;
                break;
            case "base32hex":
                this.alphabet = exports.base32hex.alphabet;
                break;
            default:
                throw new Error("invalid type");
        }
        if (options.alphabet) this.alphabet = options.alphabet;
        else if (options.lc) this.alphabet = this.alphabet.toLowerCase();
    }
}
/**
 * The default alphabet coresponds to RFC4648.
 */ Encoder.prototype.alphabet = rfc4648.alphabet;
/**
 * Encode a byte array, continuing from the previous state.
 *
 * @param {byte[]} buf The byte array to encode.
 * @return {Encoder} this
 */ Encoder.prototype.write = function(buf) {
    var shift = this.shift;
    var carry = this.carry;
    var symbol;
    var byte;
    var i;
    // encode each byte in buf
    for(i = 0; i < buf.length; i++){
        byte = buf[i];
        // 1: 00000 000
        // 2:          00 00000 0
        // 3:                    0000 0000
        // 4:                             0 00000 00
        // 5:                                       000 00000
        // 6:                                                00000 000
        // 7:                                                         00 00000 0
        symbol = carry | byte >> shift;
        this.buf += this.alphabet[symbol & 0x1f];
        if (shift > 5) {
            shift -= 5;
            symbol = byte >> shift;
            this.buf += this.alphabet[symbol & 0x1f];
        }
        shift = 5 - shift;
        carry = byte << shift;
        shift = 8 - shift;
    }
    // save state
    this.shift = shift;
    this.carry = carry;
    // for chaining
    return this;
};
/**
 * Finish encoding.
 *
 * @param {byte[]} [buf] The final byte array to encode.
 * @return {string} The encoded byte array.
 */ Encoder.prototype.finalize = function(buf) {
    if (buf) this.write(buf);
    if (this.shift !== 3) {
        this.buf += this.alphabet[this.carry & 0x1f];
        this.shift = 3;
        this.carry = 0;
    }
    return this.buf;
};
/**
 * Convenience encoder.
 *
 * @param {byte[]} buf The byte array to encode.
 * @param {object} [options] Options to pass to the encoder.
 * @return {string} The encoded string.
 */ exports.encode = function(buf, options) {
    return new Encoder(options).finalize(buf);
};
/**
 * Convenience decoder.
 *
 * @param {string} str The string to decode.
 * @param {object} [options] Options to pass to the decoder.
 * @return {byte[]} The decoded byte array.
 */ exports.decode = function(str, options) {
    return new Decoder(options).finalize(str);
};
// Exports.
exports.Decoder = Decoder;
exports.Encoder = Encoder;
exports.charmap = charmap;
exports.crockford = crockford;
exports.rfc4648 = rfc4648;
exports.base32hex = base32hex;

});

parcelRegister("b8irb", function(module, exports) {

(function(nacl) {
    "use strict";
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function gf(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function randombytes() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function poly1305(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = (parcelRequire("24TKi"));
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

});

parcelRegister("iKDDq", function(module, exports) {

var $cu7qF = parcelRequire("cu7qF");
var $da6b4487d6905956$require$MAX_SAFE_COMPONENT_LENGTH = $cu7qF.MAX_SAFE_COMPONENT_LENGTH;

var $4s6oU = parcelRequire("4s6oU");
exports = module.exports = {};
// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var t = exports.t = {};
var R = 0;
var createToken = function(name, value, isGlobal) {
    var index = R++;
    $4s6oU(index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "[0-9]+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*");
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")"));
createToken("MAINVERSIONLOOSE", "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")"));
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", "(?:".concat(src[t.NUMERICIDENTIFIER], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
createToken("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(src[t.NUMERICIDENTIFIERLOOSE], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", "(?:-(".concat(src[t.PRERELEASEIDENTIFIER], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIER], ")*))"));
createToken("PRERELEASELOOSE", "(?:-?(".concat(src[t.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIERLOOSE], ")*))"));
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", "[0-9A-Za-z-]+");
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", "(?:\\+(".concat(src[t.BUILDIDENTIFIER], "(?:\\.").concat(src[t.BUILDIDENTIFIER], ")*))"));
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", "v?".concat(src[t.MAINVERSION]).concat(src[t.PRERELEASE], "?").concat(src[t.BUILD], "?"));
createToken("FULL", "^".concat(src[t.FULLPLAIN], "$"));
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", "[v=\\s]*".concat(src[t.MAINVERSIONLOOSE]).concat(src[t.PRERELEASELOOSE], "?").concat(src[t.BUILD], "?"));
createToken("LOOSE", "^".concat(src[t.LOOSEPLAIN], "$"));
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", "".concat(src[t.NUMERICIDENTIFIERLOOSE], "|x|X|\\*"));
createToken("XRANGEIDENTIFIER", "".concat(src[t.NUMERICIDENTIFIER], "|x|X|\\*"));
createToken("XRANGEPLAIN", "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:".concat(src[t.PRERELEASE], ")?").concat(src[t.BUILD], "?") + ")?)?");
createToken("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(src[t.PRERELEASELOOSE], ")?").concat(src[t.BUILD], "?") + ")?)?");
createToken("XRANGE", "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAIN], "$"));
createToken("XRANGELOOSE", "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAINLOOSE], "$"));
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", "(^|[^\\d])(\\d{1,".concat($da6b4487d6905956$require$MAX_SAFE_COMPONENT_LENGTH, "})") + "(?:\\.(\\d{1,".concat($da6b4487d6905956$require$MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:\\.(\\d{1,".concat($da6b4487d6905956$require$MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:$|[^\\d])");
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", "(\\s*)".concat(src[t.LONETILDE], "\\s+"), true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAIN], "$"));
createToken("TILDELOOSE", "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAINLOOSE], "$"));
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", "(\\s*)".concat(src[t.LONECARET], "\\s+"), true);
exports.caretTrimReplace = "$1^";
createToken("CARET", "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAIN], "$"));
createToken("CARETLOOSE", "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAINLOOSE], "$"));
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", "^".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], ")$|^$"));
createToken("COMPARATOR", "^".concat(src[t.GTLT], "\\s*(").concat(src[t.FULLPLAIN], ")$|^$"));
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", "(\\s*)".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], "|").concat(src[t.XRANGEPLAIN], ")"), true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", "^\\s*(".concat(src[t.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAIN], ")") + "\\s*$");
createToken("HYPHENRANGELOOSE", "^\\s*(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s*$");
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0.0.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");

});
parcelRegister("cu7qF", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
var $02587c1328f895a6$var$SEMVER_SPEC_VERSION = "2.0.0";
var $02587c1328f895a6$var$MAX_LENGTH = 256;
var $02587c1328f895a6$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var $02587c1328f895a6$var$MAX_SAFE_COMPONENT_LENGTH = 16;
module.exports = {
    SEMVER_SPEC_VERSION: $02587c1328f895a6$var$SEMVER_SPEC_VERSION,
    MAX_LENGTH: $02587c1328f895a6$var$MAX_LENGTH,
    MAX_SAFE_INTEGER: $02587c1328f895a6$var$MAX_SAFE_INTEGER,
    MAX_SAFE_COMPONENT_LENGTH: $02587c1328f895a6$var$MAX_SAFE_COMPONENT_LENGTH
};

});

parcelRegister("4s6oU", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
var $33debdfda618695e$var$debug = (typeof $4pbh3 === "object" && $4pbh3.env && undefined, function() {});
module.exports = $33debdfda618695e$var$debug;

});


parcelRegister("fhQ3r", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4s6oU = parcelRequire("4s6oU");

var $cu7qF = parcelRequire("cu7qF");
var $b210d27a1084446c$var$MAX_LENGTH = $cu7qF.MAX_LENGTH, $b210d27a1084446c$var$MAX_SAFE_INTEGER = $cu7qF.MAX_SAFE_INTEGER;

var $iKDDq = parcelRequire("iKDDq");
var $b210d27a1084446c$var$re = $iKDDq.re, $b210d27a1084446c$var$t = $iKDDq.t;

var $9b9Yr = parcelRequire("9b9Yr");

var $2adro = parcelRequire("2adro");
var $b210d27a1084446c$require$compareIdentifiers = $2adro.compareIdentifiers;
var $b210d27a1084446c$var$SemVer = /*#__PURE__*/ function() {
    "use strict";
    function SemVer(version, options) {
        (0, $7dKN1._)(this, SemVer);
        options = $9b9Yr(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError("Invalid Version: ".concat(version));
        if (version.length > $b210d27a1084446c$var$MAX_LENGTH) throw new TypeError("version is longer than ".concat($b210d27a1084446c$var$MAX_LENGTH, " characters"));
        $4s6oU("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        var m = version.trim().match(options.loose ? $b210d27a1084446c$var$re[$b210d27a1084446c$var$t.LOOSE] : $b210d27a1084446c$var$re[$b210d27a1084446c$var$t.FULL]);
        if (!m) throw new TypeError("Invalid Version: ".concat(version));
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $b210d27a1084446c$var$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $b210d27a1084446c$var$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $b210d27a1084446c$var$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map(function(id) {
            if (/^[0-9]+$/.test(id)) {
                var num = +id;
                if (num >= 0 && num < $b210d27a1084446c$var$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    (0, $eW5pA._)(SemVer, [
        {
            key: "format",
            value: function format() {
                this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch);
                if (this.prerelease.length) this.version += "-".concat(this.prerelease.join("."));
                return this.version;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.version;
            }
        },
        {
            key: "compare",
            value: function compare(other) {
                $4s6oU("SemVer.compare", this.version, this.options, other);
                if (!(other instanceof SemVer)) {
                    if (typeof other === "string" && other === this.version) return 0;
                    other = new SemVer(other, this.options);
                }
                if (other.version === this.version) return 0;
                return this.compareMain(other) || this.comparePre(other);
            }
        },
        {
            key: "compareMain",
            value: function compareMain(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                return $b210d27a1084446c$require$compareIdentifiers(this.major, other.major) || $b210d27a1084446c$require$compareIdentifiers(this.minor, other.minor) || $b210d27a1084446c$require$compareIdentifiers(this.patch, other.patch);
            }
        },
        {
            key: "comparePre",
            value: function comparePre(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                // NOT having a prerelease is > having one
                if (this.prerelease.length && !other.prerelease.length) return -1;
                else if (!this.prerelease.length && other.prerelease.length) return 1;
                else if (!this.prerelease.length && !other.prerelease.length) return 0;
                var i = 0;
                do {
                    var a = this.prerelease[i];
                    var b = other.prerelease[i];
                    $4s6oU("prerelease compare", i, a, b);
                    if (a === undefined && b === undefined) return 0;
                    else if (b === undefined) return 1;
                    else if (a === undefined) return -1;
                    else if (a === b) continue;
                    else return $b210d27a1084446c$require$compareIdentifiers(a, b);
                }while (++i);
            }
        },
        {
            key: "compareBuild",
            value: function compareBuild(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                var i = 0;
                do {
                    var a = this.build[i];
                    var b = other.build[i];
                    $4s6oU("prerelease compare", i, a, b);
                    if (a === undefined && b === undefined) return 0;
                    else if (b === undefined) return 1;
                    else if (a === undefined) return -1;
                    else if (a === b) continue;
                    else return $b210d27a1084446c$require$compareIdentifiers(a, b);
                }while (++i);
            }
        },
        {
            // preminor will bump the version up to the next minor release, and immediately
            // down to pre-release. premajor and prepatch work the same way.
            key: "inc",
            value: function inc(release, identifier) {
                switch(release){
                    case "premajor":
                        this.prerelease.length = 0;
                        this.patch = 0;
                        this.minor = 0;
                        this.major++;
                        this.inc("pre", identifier);
                        break;
                    case "preminor":
                        this.prerelease.length = 0;
                        this.patch = 0;
                        this.minor++;
                        this.inc("pre", identifier);
                        break;
                    case "prepatch":
                        // If this is already a prerelease, it will bump to the next version
                        // drop any prereleases that might already exist, since they are not
                        // relevant at this point.
                        this.prerelease.length = 0;
                        this.inc("patch", identifier);
                        this.inc("pre", identifier);
                        break;
                    // If the input is a non-prerelease version, this acts the same as
                    // prepatch.
                    case "prerelease":
                        if (this.prerelease.length === 0) this.inc("patch", identifier);
                        this.inc("pre", identifier);
                        break;
                    case "major":
                        // If this is a pre-major version, bump up to the same major version.
                        // Otherwise increment major.
                        // 1.0.0-5 bumps to 1.0.0
                        // 1.1.0 bumps to 2.0.0
                        if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                        this.minor = 0;
                        this.patch = 0;
                        this.prerelease = [];
                        break;
                    case "minor":
                        // If this is a pre-minor version, bump up to the same minor version.
                        // Otherwise increment minor.
                        // 1.2.0-5 bumps to 1.2.0
                        // 1.2.1 bumps to 1.3.0
                        if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                        this.patch = 0;
                        this.prerelease = [];
                        break;
                    case "patch":
                        // If this is not a pre-release version, it will increment the patch.
                        // If it is a pre-release it will bump up to the same patch version.
                        // 1.2.0-5 patches to 1.2.0
                        // 1.2.0 patches to 1.2.1
                        if (this.prerelease.length === 0) this.patch++;
                        this.prerelease = [];
                        break;
                    // This probably shouldn't be used publicly.
                    // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
                    case "pre":
                        if (this.prerelease.length === 0) this.prerelease = [
                            0
                        ];
                        else {
                            var i = this.prerelease.length;
                            while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                                this.prerelease[i]++;
                                i = -2;
                            }
                            if (i === -1) // didn't increment anything
                            this.prerelease.push(0);
                        }
                        if (identifier) {
                            // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                            // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                            if (this.prerelease[0] === identifier) {
                                if (isNaN(this.prerelease[1])) this.prerelease = [
                                    identifier,
                                    0
                                ];
                            } else this.prerelease = [
                                identifier,
                                0
                            ];
                        }
                        break;
                    default:
                        throw new Error("invalid increment argument: ".concat(release));
                }
                this.format();
                this.raw = this.version;
                return this;
            }
        }
    ]);
    return SemVer;
}();
module.exports = $b210d27a1084446c$var$SemVer;

});
parcelRegister("9b9Yr", function(module, exports) {
// parse out just the options we care about so we always get a consistent
// obj with keys in a consistent order.
var $6aece0c261375177$var$opts = [
    "includePrerelease",
    "loose",
    "rtl"
];
var $6aece0c261375177$var$parseOptions = function(options) {
    return !options ? {} : typeof options !== "object" ? {
        loose: true
    } : $6aece0c261375177$var$opts.filter(function(k) {
        return options[k];
    }).reduce(function(options, k) {
        options[k] = true;
        return options;
    }, {});
};
module.exports = $6aece0c261375177$var$parseOptions;

});

parcelRegister("2adro", function(module, exports) {
var $1936f0ffa219144d$var$numeric = /^[0-9]+$/;
var $1936f0ffa219144d$var$compareIdentifiers = function(a, b) {
    var anum = $1936f0ffa219144d$var$numeric.test(a);
    var bnum = $1936f0ffa219144d$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
var $1936f0ffa219144d$var$rcompareIdentifiers = function(a, b) {
    return $1936f0ffa219144d$var$compareIdentifiers(b, a);
};
module.exports = {
    compareIdentifiers: $1936f0ffa219144d$var$compareIdentifiers,
    rcompareIdentifiers: $1936f0ffa219144d$var$rcompareIdentifiers
};

});


parcelRegister("89yo3", function(module, exports) {

var $cu7qF = parcelRequire("cu7qF");
var $5ef9d68c2cea4e11$require$MAX_LENGTH = $cu7qF.MAX_LENGTH;

var $iKDDq = parcelRequire("iKDDq");
var $5ef9d68c2cea4e11$var$re = $iKDDq.re, $5ef9d68c2cea4e11$var$t = $iKDDq.t;

var $fhQ3r = parcelRequire("fhQ3r");

var $9b9Yr = parcelRequire("9b9Yr");
var $5ef9d68c2cea4e11$var$parse = function(version, options) {
    options = $9b9Yr(options);
    if (version instanceof $fhQ3r) return version;
    if (typeof version !== "string") return null;
    if (version.length > $5ef9d68c2cea4e11$require$MAX_LENGTH) return null;
    var r = options.loose ? $5ef9d68c2cea4e11$var$re[$5ef9d68c2cea4e11$var$t.LOOSE] : $5ef9d68c2cea4e11$var$re[$5ef9d68c2cea4e11$var$t.FULL];
    if (!r.test(version)) return null;
    try {
        return new $fhQ3r(version, options);
    } catch (er) {
        return null;
    }
};
module.exports = $5ef9d68c2cea4e11$var$parse;

});

parcelRegister("cU1KI", function(module, exports) {

var $89yo3 = parcelRequire("89yo3");
var $964c12fc3edf8a67$var$valid = function(version, options) {
    var v = $89yo3(version, options);
    return v ? v.version : null;
};
module.exports = $964c12fc3edf8a67$var$valid;

});

parcelRegister("tGB4i", function(module, exports) {

var $89yo3 = parcelRequire("89yo3");
var $0593c06678ea3a14$var$clean = function(version, options) {
    var s = $89yo3(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
module.exports = $0593c06678ea3a14$var$clean;

});

parcelRegister("e89SQ", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");
var $a4997ab6c4769f0d$var$inc = function(version, release, options, identifier) {
    if (typeof options === "string") {
        identifier = options;
        options = undefined;
    }
    try {
        return new $fhQ3r(version, options).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
};
module.exports = $a4997ab6c4769f0d$var$inc;

});

parcelRegister("8vn9F", function(module, exports) {

var $89yo3 = parcelRequire("89yo3");

var $1yJ7B = parcelRequire("1yJ7B");
var $63132e0a4cb0e001$var$diff = function(version1, version2) {
    if ($1yJ7B(version1, version2)) return null;
    else {
        var v1 = $89yo3(version1);
        var v2 = $89yo3(version2);
        var hasPre = v1.prerelease.length || v2.prerelease.length;
        var prefix = hasPre ? "pre" : "";
        var defaultResult = hasPre ? "prerelease" : "";
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
};
module.exports = $63132e0a4cb0e001$var$diff;

});
parcelRegister("1yJ7B", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $122bf79c6aeee95e$var$eq = function(a, b, loose) {
    return $gn47S(a, b, loose) === 0;
};
module.exports = $122bf79c6aeee95e$var$eq;

});
parcelRegister("gn47S", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");
var $beb1feb0b76d9e43$var$compare = function(a, b, loose) {
    return new $fhQ3r(a, loose).compare(new $fhQ3r(b, loose));
};
module.exports = $beb1feb0b76d9e43$var$compare;

});



parcelRegister("dsuoG", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");
var $9cc57822e031648c$var$major = function(a, loose) {
    return new $fhQ3r(a, loose).major;
};
module.exports = $9cc57822e031648c$var$major;

});

parcelRegister("eLH0Y", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");
var $ac06d248c160dc1b$var$minor = function(a, loose) {
    return new $fhQ3r(a, loose).minor;
};
module.exports = $ac06d248c160dc1b$var$minor;

});

parcelRegister("dV01e", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");
var $a2209cf53610c3e1$var$patch = function(a, loose) {
    return new $fhQ3r(a, loose).patch;
};
module.exports = $a2209cf53610c3e1$var$patch;

});

parcelRegister("bRYnC", function(module, exports) {

var $89yo3 = parcelRequire("89yo3");
var $8a437b23faa8ef33$var$prerelease = function(version, options) {
    var parsed = $89yo3(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $8a437b23faa8ef33$var$prerelease;

});

parcelRegister("dslSA", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $0287351bb14c3670$var$rcompare = function(a, b, loose) {
    return $gn47S(b, a, loose);
};
module.exports = $0287351bb14c3670$var$rcompare;

});

parcelRegister("aiY67", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $780a33f833ab06dd$var$compareLoose = function(a, b) {
    return $gn47S(a, b, true);
};
module.exports = $780a33f833ab06dd$var$compareLoose;

});

parcelRegister("hUEHc", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");
var $d0a73bfb82284121$var$compareBuild = function(a, b, loose) {
    var versionA = new $fhQ3r(a, loose);
    var versionB = new $fhQ3r(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $d0a73bfb82284121$var$compareBuild;

});

parcelRegister("2RmpA", function(module, exports) {

var $hUEHc = parcelRequire("hUEHc");
var $2151ea86d72a0ab1$var$sort = function(list, loose) {
    return list.sort(function(a, b) {
        return $hUEHc(a, b, loose);
    });
};
module.exports = $2151ea86d72a0ab1$var$sort;

});

parcelRegister("4VEN0", function(module, exports) {

var $hUEHc = parcelRequire("hUEHc");
var $396c203a0addabd8$var$rsort = function(list, loose) {
    return list.sort(function(a, b) {
        return $hUEHc(b, a, loose);
    });
};
module.exports = $396c203a0addabd8$var$rsort;

});

parcelRegister("9na5M", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $6d2e1727e241205f$var$gt = function(a, b, loose) {
    return $gn47S(a, b, loose) > 0;
};
module.exports = $6d2e1727e241205f$var$gt;

});

parcelRegister("5wPAk", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $4067f49b21b21d8a$var$lt = function(a, b, loose) {
    return $gn47S(a, b, loose) < 0;
};
module.exports = $4067f49b21b21d8a$var$lt;

});

parcelRegister("52O0B", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $3ac3ee5e307e5d55$var$neq = function(a, b, loose) {
    return $gn47S(a, b, loose) !== 0;
};
module.exports = $3ac3ee5e307e5d55$var$neq;

});

parcelRegister("8QHW3", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $671542b70fe87939$var$gte = function(a, b, loose) {
    return $gn47S(a, b, loose) >= 0;
};
module.exports = $671542b70fe87939$var$gte;

});

parcelRegister("iVLRd", function(module, exports) {

var $gn47S = parcelRequire("gn47S");
var $dc82ac57e092247a$var$lte = function(a, b, loose) {
    return $gn47S(a, b, loose) <= 0;
};
module.exports = $dc82ac57e092247a$var$lte;

});

parcelRegister("bYOEb", function(module, exports) {

var $1yJ7B = parcelRequire("1yJ7B");

var $52O0B = parcelRequire("52O0B");

var $9na5M = parcelRequire("9na5M");

var $8QHW3 = parcelRequire("8QHW3");

var $5wPAk = parcelRequire("5wPAk");

var $iVLRd = parcelRequire("iVLRd");
var $8b8c95c5beef6656$var$cmp = function(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $1yJ7B(a, b, loose);
        case "!=":
            return $52O0B(a, b, loose);
        case ">":
            return $9na5M(a, b, loose);
        case ">=":
            return $8QHW3(a, b, loose);
        case "<":
            return $5wPAk(a, b, loose);
        case "<=":
            return $iVLRd(a, b, loose);
        default:
            throw new TypeError("Invalid operator: ".concat(op));
    }
};
module.exports = $8b8c95c5beef6656$var$cmp;

});

parcelRegister("d3reA", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");

var $89yo3 = parcelRequire("89yo3");

var $iKDDq = parcelRequire("iKDDq");
var $9810ae5540aa67b6$var$re = $iKDDq.re, $9810ae5540aa67b6$var$t = $iKDDq.t;
var $9810ae5540aa67b6$var$coerce = function(version, options) {
    if (version instanceof $fhQ3r) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    var match = null;
    if (!options.rtl) match = version.match($9810ae5540aa67b6$var$re[$9810ae5540aa67b6$var$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        var next;
        while((next = $9810ae5540aa67b6$var$re[$9810ae5540aa67b6$var$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $9810ae5540aa67b6$var$re[$9810ae5540aa67b6$var$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $9810ae5540aa67b6$var$re[$9810ae5540aa67b6$var$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $89yo3("".concat(match[2], ".").concat(match[3] || "0", ".").concat(match[4] || "0"), options);
};
module.exports = $9810ae5540aa67b6$var$coerce;

});

parcelRegister("1sSb8", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $11126eb0ca66d2ea$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
var $11126eb0ca66d2ea$var$Comparator = /*#__PURE__*/ function() {
    "use strict";
    function Comparator(comp, options) {
        (0, $7dKN1._)(this, Comparator);
        options = $9b9Yr(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        $4s6oU("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $11126eb0ca66d2ea$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $4s6oU("comp", this);
    }
    (0, $eW5pA._)(Comparator, [
        {
            key: "parse",
            value: function parse(comp) {
                var r = this.options.loose ? $11126eb0ca66d2ea$var$re[$11126eb0ca66d2ea$var$t.COMPARATORLOOSE] : $11126eb0ca66d2ea$var$re[$11126eb0ca66d2ea$var$t.COMPARATOR];
                var m = comp.match(r);
                if (!m) throw new TypeError("Invalid comparator: ".concat(comp));
                this.operator = m[1] !== undefined ? m[1] : "";
                if (this.operator === "=") this.operator = "";
                // if it literally is just '>' or '' then allow anything.
                if (!m[2]) this.semver = $11126eb0ca66d2ea$var$ANY;
                else this.semver = new $fhQ3r(m[2], this.options.loose);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.value;
            }
        },
        {
            key: "test",
            value: function test(version) {
                $4s6oU("Comparator.test", version, this.options.loose);
                if (this.semver === $11126eb0ca66d2ea$var$ANY || version === $11126eb0ca66d2ea$var$ANY) return true;
                if (typeof version === "string") try {
                    version = new $fhQ3r(version, this.options);
                } catch (er) {
                    return false;
                }
                return $bYOEb(version, this.operator, this.semver, this.options);
            }
        },
        {
            key: "intersects",
            value: function intersects(comp, options) {
                if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
                if (!options || typeof options !== "object") options = {
                    loose: !!options,
                    includePrerelease: false
                };
                if (this.operator === "") {
                    if (this.value === "") return true;
                    return new $i08Aw(comp.value, options).test(this.value);
                } else if (comp.operator === "") {
                    if (comp.value === "") return true;
                    return new $i08Aw(this.value, options).test(comp.semver);
                }
                var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
                var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
                var sameSemVer = this.semver.version === comp.semver.version;
                var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
                var oppositeDirectionsLessThan = $bYOEb(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
                var oppositeDirectionsGreaterThan = $bYOEb(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
                return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
            }
        }
    ], [
        {
            key: "ANY",
            get: function get() {
                return $11126eb0ca66d2ea$var$ANY;
            }
        }
    ]);
    return Comparator;
}();
module.exports = $11126eb0ca66d2ea$var$Comparator;

var $9b9Yr = parcelRequire("9b9Yr");

var $iKDDq = parcelRequire("iKDDq");
var $11126eb0ca66d2ea$var$re = $iKDDq.re, $11126eb0ca66d2ea$var$t = $iKDDq.t;

var $bYOEb = parcelRequire("bYOEb");

var $4s6oU = parcelRequire("4s6oU");

var $fhQ3r = parcelRequire("fhQ3r");

var $i08Aw = parcelRequire("i08Aw");

});
parcelRegister("i08Aw", function(module, exports) {
// hoisted class for cyclic dependency

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");
var $d1aee37906824e81$var$Range = /*#__PURE__*/ function() {
    "use strict";
    function Range(range, options) {
        var _this = this;
        (0, $7dKN1._)(this, Range);
        options = $9b9Yr(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof $1sSb8) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First, split based on boolean or ||
        this.raw = range;
        this.set = range.split(/\s*\|\|\s*/)// map the range to a 2d array of comparators
        .map(function(range) {
            return _this.parseRange(range.trim());
        })// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter(function(c) {
            return c.length;
        });
        if (!this.set.length) throw new TypeError("Invalid SemVer Range: ".concat(range));
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            var first = this.set[0];
            this.set = this.set.filter(function(c) {
                return !$d1aee37906824e81$var$isNullSet(c[0]);
            });
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // if we have any that are *, then the range is just *
                    for(var _iterator = this.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var c = _step.value;
                        if (c.length === 1 && $d1aee37906824e81$var$isAny(c[0])) {
                            this.set = [
                                c
                            ];
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        this.format();
    }
    (0, $eW5pA._)(Range, [
        {
            key: "format",
            value: function format() {
                this.range = this.set.map(function(comps) {
                    return comps.join(" ").trim();
                }).join("||").trim();
                return this.range;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.range;
            }
        },
        {
            key: "parseRange",
            value: function parseRange(range) {
                var _this = this;
                range = range.trim();
                // memoize range parsing for performance.
                // this is a very hot path, and fully deterministic.
                var memoOpts = Object.keys(this.options).join(",");
                var memoKey = "parseRange:".concat(memoOpts, ":").concat(range);
                var cached = $d1aee37906824e81$var$cache.get(memoKey);
                if (cached) return cached;
                var loose = this.options.loose;
                // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
                var hr = loose ? $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.HYPHENRANGELOOSE] : $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.HYPHENRANGE];
                range = range.replace(hr, $d1aee37906824e81$var$hyphenReplace(this.options.includePrerelease));
                $4s6oU("hyphen replace", range);
                // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
                range = range.replace($d1aee37906824e81$var$re[$d1aee37906824e81$var$t.COMPARATORTRIM], $d1aee37906824e81$var$comparatorTrimReplace);
                $4s6oU("comparator trim", range, $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.COMPARATORTRIM]);
                // `~ 1.2.3` => `~1.2.3`
                range = range.replace($d1aee37906824e81$var$re[$d1aee37906824e81$var$t.TILDETRIM], $d1aee37906824e81$var$tildeTrimReplace);
                // `^ 1.2.3` => `^1.2.3`
                range = range.replace($d1aee37906824e81$var$re[$d1aee37906824e81$var$t.CARETTRIM], $d1aee37906824e81$var$caretTrimReplace);
                // normalize spaces
                range = range.split(/\s+/).join(" ");
                // At this point, the range is completely trimmed and
                // ready to be split into comparators.
                var compRe = loose ? $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.COMPARATORLOOSE] : $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.COMPARATOR];
                var rangeList = range.split(" ").map(function(comp) {
                    return $d1aee37906824e81$var$parseComparator(comp, _this.options);
                }).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
                .map(function(comp) {
                    return $d1aee37906824e81$var$replaceGTE0(comp, _this.options);
                })// in loose mode, throw out any that are not valid comparators
                .filter(this.options.loose ? function(comp) {
                    return !!comp.match(compRe);
                } : function() {
                    return true;
                }).map(function(comp) {
                    return new $1sSb8(comp, _this.options);
                });
                // if any comparators are the null set, then replace with JUST null set
                // if more than one comparator, remove any * comparators
                // also, don't include the same comparator more than once
                var l = rangeList.length;
                var rangeMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = rangeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var comp = _step.value;
                        if ($d1aee37906824e81$var$isNullSet(comp)) return [
                            comp
                        ];
                        rangeMap.set(comp.value, comp);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
                var result = (0, $gF0bR._)(rangeMap.values());
                $d1aee37906824e81$var$cache.set(memoKey, result);
                return result;
            }
        },
        {
            key: "intersects",
            value: function intersects(range, options) {
                if (!(range instanceof Range)) throw new TypeError("a Range is required");
                return this.set.some(function(thisComparators) {
                    return $d1aee37906824e81$var$isSatisfiable(thisComparators, options) && range.set.some(function(rangeComparators) {
                        return $d1aee37906824e81$var$isSatisfiable(rangeComparators, options) && thisComparators.every(function(thisComparator) {
                            return rangeComparators.every(function(rangeComparator) {
                                return thisComparator.intersects(rangeComparator, options);
                            });
                        });
                    });
                });
            }
        },
        {
            // if ANY of the sets match ALL of its comparators, then pass
            key: "test",
            value: function test(version) {
                if (!version) return false;
                if (typeof version === "string") try {
                    version = new $fhQ3r(version, this.options);
                } catch (er) {
                    return false;
                }
                for(var i = 0; i < this.set.length; i++){
                    if ($d1aee37906824e81$var$testSet(this.set[i], version, this.options)) return true;
                }
                return false;
            }
        }
    ]);
    return Range;
}();
module.exports = $d1aee37906824e81$var$Range;

var $3DfNU = parcelRequire("3DfNU");
var $d1aee37906824e81$var$cache = new $3DfNU({
    max: 1000
});

var $9b9Yr = parcelRequire("9b9Yr");

var $1sSb8 = parcelRequire("1sSb8");

var $4s6oU = parcelRequire("4s6oU");

var $fhQ3r = parcelRequire("fhQ3r");

var $iKDDq = parcelRequire("iKDDq");
var $d1aee37906824e81$var$re = $iKDDq.re, $d1aee37906824e81$var$t = $iKDDq.t, $d1aee37906824e81$var$comparatorTrimReplace = $iKDDq.comparatorTrimReplace, $d1aee37906824e81$var$tildeTrimReplace = $iKDDq.tildeTrimReplace, $d1aee37906824e81$var$caretTrimReplace = $iKDDq.caretTrimReplace;
var $d1aee37906824e81$var$isNullSet = function(c) {
    return c.value === "<0.0.0-0";
};
var $d1aee37906824e81$var$isAny = function(c) {
    return c.value === "";
};
// take a set of comparators and determine whether there
// exists a version which can satisfy it
var $d1aee37906824e81$var$isSatisfiable = function(comparators, options) {
    var result = true;
    var remainingComparators = comparators.slice();
    var testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every(function(otherComparator) {
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
var $d1aee37906824e81$var$parseComparator = function(comp, options) {
    $4s6oU("comp", comp, options);
    comp = $d1aee37906824e81$var$replaceCarets(comp, options);
    $4s6oU("caret", comp);
    comp = $d1aee37906824e81$var$replaceTildes(comp, options);
    $4s6oU("tildes", comp);
    comp = $d1aee37906824e81$var$replaceXRanges(comp, options);
    $4s6oU("xrange", comp);
    comp = $d1aee37906824e81$var$replaceStars(comp, options);
    $4s6oU("stars", comp);
    return comp;
};
var $d1aee37906824e81$var$isX = function(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
};
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
var $d1aee37906824e81$var$replaceTildes = function(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return $d1aee37906824e81$var$replaceTilde(comp, options);
    }).join(" ");
};
var $d1aee37906824e81$var$replaceTilde = function(comp, options) {
    var r = options.loose ? $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.TILDELOOSE] : $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        $4s6oU("tilde", comp, _, M, m, p, pr);
        var ret;
        if ($d1aee37906824e81$var$isX(M)) ret = "";
        else if ($d1aee37906824e81$var$isX(m)) ret = ">=".concat(M, ".0.0 <").concat(+M + 1, ".0.0-0");
        else if ($d1aee37906824e81$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = ">=".concat(M, ".").concat(m, ".0 <").concat(M, ".").concat(+m + 1, ".0-0");
        else if (pr) {
            $4s6oU("replaceTilde pr", pr);
            ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(M, ".").concat(+m + 1, ".0-0");
        $4s6oU("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
var $d1aee37906824e81$var$replaceCarets = function(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return $d1aee37906824e81$var$replaceCaret(comp, options);
    }).join(" ");
};
var $d1aee37906824e81$var$replaceCaret = function(comp, options) {
    $4s6oU("caret", comp, options);
    var r = options.loose ? $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.CARETLOOSE] : $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.CARET];
    var z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, function(_, M, m, p, pr) {
        $4s6oU("caret", comp, _, M, m, p, pr);
        var ret;
        if ($d1aee37906824e81$var$isX(M)) ret = "";
        else if ($d1aee37906824e81$var$isX(m)) ret = ">=".concat(M, ".0.0").concat(z, " <").concat(+M + 1, ".0.0-0");
        else if ($d1aee37906824e81$var$isX(p)) {
            if (M === "0") ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
            else ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(+M + 1, ".0.0-0");
        } else if (pr) {
            $4s6oU("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                else ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
            } else ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(+M + 1, ".0.0-0");
        } else {
            $4s6oU("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                else ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
            } else ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(+M + 1, ".0.0-0");
        }
        $4s6oU("caret return", ret);
        return ret;
    });
};
var $d1aee37906824e81$var$replaceXRanges = function(comp, options) {
    $4s6oU("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return $d1aee37906824e81$var$replaceXRange(comp, options);
    }).join(" ");
};
var $d1aee37906824e81$var$replaceXRange = function(comp, options) {
    comp = comp.trim();
    var r = options.loose ? $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.XRANGELOOSE] : $d1aee37906824e81$var$re[$d1aee37906824e81$var$t.XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        $4s6oU("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = $d1aee37906824e81$var$isX(M);
        var xm = xM || $d1aee37906824e81$var$isX(m);
        var xp = xm || $d1aee37906824e81$var$isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = "".concat(gtlt + M, ".").concat(m, ".").concat(p).concat(pr);
        } else if (xm) ret = ">=".concat(M, ".0.0").concat(pr, " <").concat(+M + 1, ".0.0-0");
        else if (xp) ret = ">=".concat(M, ".").concat(m, ".0").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
        $4s6oU("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
var $d1aee37906824e81$var$replaceStars = function(comp, options) {
    $4s6oU("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($d1aee37906824e81$var$re[$d1aee37906824e81$var$t.STAR], "");
};
var $d1aee37906824e81$var$replaceGTE0 = function(comp, options) {
    $4s6oU("replaceGTE0", comp, options);
    return comp.trim().replace($d1aee37906824e81$var$re[options.includePrerelease ? $d1aee37906824e81$var$t.GTE0PRE : $d1aee37906824e81$var$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
var $d1aee37906824e81$var$hyphenReplace = function(incPr) {
    return function($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
        if ($d1aee37906824e81$var$isX(fM)) from = "";
        else if ($d1aee37906824e81$var$isX(fm)) from = ">=".concat(fM, ".0.0").concat(incPr ? "-0" : "");
        else if ($d1aee37906824e81$var$isX(fp)) from = ">=".concat(fM, ".").concat(fm, ".0").concat(incPr ? "-0" : "");
        else if (fpr) from = ">=".concat(from);
        else from = ">=".concat(from).concat(incPr ? "-0" : "");
        if ($d1aee37906824e81$var$isX(tM)) to = "";
        else if ($d1aee37906824e81$var$isX(tm)) to = "<".concat(+tM + 1, ".0.0-0");
        else if ($d1aee37906824e81$var$isX(tp)) to = "<".concat(tM, ".").concat(+tm + 1, ".0-0");
        else if (tpr) to = "<=".concat(tM, ".").concat(tm, ".").concat(tp, "-").concat(tpr);
        else if (incPr) to = "<".concat(tM, ".").concat(tm, ".").concat(+tp + 1, "-0");
        else to = "<=".concat(to);
        return "".concat(from, " ").concat(to).trim();
    };
};
var $d1aee37906824e81$var$testSet = function(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(var i1 = 0; i1 < set.length; i1++){
            $4s6oU(set[i1].semver);
            if (set[i1].semver === $1sSb8.ANY) continue;
            if (set[i1].semver.prerelease.length > 0) {
                var allowed = set[i1].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});


parcelRegister("B9qRr", function(module, exports) {

var $i08Aw = parcelRequire("i08Aw");
var $06fac5dce5c2b974$var$satisfies = function(version, range, options) {
    try {
        range = new $i08Aw(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $06fac5dce5c2b974$var$satisfies;

});

parcelRegister("60tE2", function(module, exports) {

var $i08Aw = parcelRequire("i08Aw");
// Mostly just for testing and legacy API reasons
var $45f9bd0144155403$var$toComparators = function(range, options) {
    return new $i08Aw(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
};
module.exports = $45f9bd0144155403$var$toComparators;

});

parcelRegister("3hIaE", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");

var $i08Aw = parcelRequire("i08Aw");
var $2645390c6e3cc47e$var$maxSatisfying = function(versions, range, options) {
    var max = null;
    var maxSV = null;
    var rangeObj = null;
    try {
        rangeObj = new $i08Aw(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $fhQ3r(max, options);
            }
        }
    });
    return max;
};
module.exports = $2645390c6e3cc47e$var$maxSatisfying;

});

parcelRegister("fftIS", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");

var $i08Aw = parcelRequire("i08Aw");
var $b19f500fd1539b7e$var$minSatisfying = function(versions, range, options) {
    var min = null;
    var minSV = null;
    var rangeObj = null;
    try {
        rangeObj = new $i08Aw(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $fhQ3r(min, options);
            }
        }
    });
    return min;
};
module.exports = $b19f500fd1539b7e$var$minSatisfying;

});

parcelRegister("dZtqZ", function(module, exports) {

var $fhQ3r = parcelRequire("fhQ3r");

var $i08Aw = parcelRequire("i08Aw");

var $9na5M = parcelRequire("9na5M");
var $a2f7cde3e2b4f8bf$var$minVersion = function(range, loose) {
    var _loop = function(i) {
        var comparators = range.set[i];
        var setMin = null;
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new $fhQ3r(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $9na5M(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: ".concat(comparator.operator));
            }
        });
        if (setMin && (!minver || $9na5M(minver, setMin))) minver = setMin;
    };
    range = new $i08Aw(range, loose);
    var minver = new $fhQ3r("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $fhQ3r("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i)_loop(i);
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $a2f7cde3e2b4f8bf$var$minVersion;

});

parcelRegister("6IbnX", function(module, exports) {

var $i08Aw = parcelRequire("i08Aw");
var $4e2faf09f2cf625b$var$validRange = function(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $i08Aw(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
module.exports = $4e2faf09f2cf625b$var$validRange;

});

parcelRegister("4pFRl", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");

var $fhQ3r = parcelRequire("fhQ3r");

var $1sSb8 = parcelRequire("1sSb8");
var $3369f79f038052a3$var$ANY = $1sSb8.ANY;

var $i08Aw = parcelRequire("i08Aw");

var $B9qRr = parcelRequire("B9qRr");

var $9na5M = parcelRequire("9na5M");

var $5wPAk = parcelRequire("5wPAk");

var $iVLRd = parcelRequire("iVLRd");

var $8QHW3 = parcelRequire("8QHW3");
var $3369f79f038052a3$var$outside = function(version, range, hilo, options) {
    var _loop = function(i) {
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === $3369f79f038052a3$var$ANY) comparator = new $1sSb8(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return {
            v: false
        };
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return {
            v: false
        };
        else if (low.operator === ecomp && ltfn(version, low.semver)) return {
            v: false
        };
    };
    version = new $fhQ3r(version, options);
    range = new $i08Aw(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $9na5M;
            ltefn = $iVLRd;
            ltfn = $5wPAk;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $5wPAk;
            ltefn = $8QHW3;
            ltfn = $9na5M;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($B9qRr(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var _ret = _loop(i);
        if ((0, $aVMuR._)(_ret) === "object") return _ret.v;
    }
    return true;
};
module.exports = $3369f79f038052a3$var$outside;

});

parcelRegister("hTmzP", function(module, exports) {
// Determine if version is greater than all the versions possible in the range.

var $4pFRl = parcelRequire("4pFRl");
var $d069160b4c0b52f6$var$gtr = function(version, range, options) {
    return $4pFRl(version, range, ">", options);
};
module.exports = $d069160b4c0b52f6$var$gtr;

});

parcelRegister("f1Vlz", function(module, exports) {

var $4pFRl = parcelRequire("4pFRl");
// Determine if version is less than all the versions possible in the range
var $af136ee62ea15abd$var$ltr = function(version, range, options) {
    return $4pFRl(version, range, "<", options);
};
module.exports = $af136ee62ea15abd$var$ltr;

});

parcelRegister("fqkAs", function(module, exports) {

var $i08Aw = parcelRequire("i08Aw");
var $b3a940dd9795c73a$var$intersects = function(r1, r2, options) {
    r1 = new $i08Aw(r1, options);
    r2 = new $i08Aw(r2, options);
    return r1.intersects(r2);
};
module.exports = $b3a940dd9795c73a$var$intersects;

});

parcelRegister("fgwwn", function(module, exports) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.

var $5OlIx = parcelRequire("5OlIx");

var $B9qRr = parcelRequire("B9qRr");

var $gn47S = parcelRequire("gn47S");
module.exports = function(versions, range, options) {
    var set = [];
    var min = null;
    var prev = null;
    var v = versions.sort(function(a, b) {
        return $gn47S(a, b, options);
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var version = _step.value;
            var included = $B9qRr(version, range, options);
            if (included) {
                prev = version;
                if (!min) min = version;
            } else {
                if (prev) set.push([
                    min,
                    prev
                ]);
                prev = null;
                min = null;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (min) set.push([
        min,
        null
    ]);
    var ranges = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $5OlIx._)(_step1.value, 2), min1 = _step_value[0], max = _step_value[1];
            if (min1 === max) ranges.push(min1);
            else if (!max && min1 === v[0]) ranges.push("*");
            else if (!max) ranges.push(">=".concat(min1));
            else if (min1 === v[0]) ranges.push("<=".concat(max));
            else ranges.push("".concat(min1, " - ").concat(max));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var simplified = ranges.join(" || ");
    var original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("4GVuP", function(module, exports) {

var $i08Aw = parcelRequire("i08Aw");

var $1sSb8 = parcelRequire("1sSb8");
var $36a7af3799ce87cf$var$ANY = $1sSb8.ANY;

var $B9qRr = parcelRequire("B9qRr");

var $gn47S = parcelRequire("gn47S");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
var $36a7af3799ce87cf$var$subset = function(sub, dom) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (sub === dom) return true;
    sub = new $i08Aw(sub, options);
    dom = new $i08Aw(dom, options);
    var sawNonNull = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        OUTER: for(var _iterator = sub.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var simpleSub = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = dom.set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var simpleDom = _step1.value;
                    var isSub = $36a7af3799ce87cf$var$simpleSubset(simpleSub, simpleDom, options);
                    sawNonNull = sawNonNull || isSub !== null;
                    if (isSub) continue OUTER;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // the null set is a subset of everything, but null simple ranges in
            // a complex range should be ignored.  so if we saw a non-null range,
            // then we know this isn't a subset, but if EVERY simple range was null,
            // then it is a subset.
            if (sawNonNull) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
var $36a7af3799ce87cf$var$simpleSubset = function(sub, dom, options) {
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $36a7af3799ce87cf$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $36a7af3799ce87cf$var$ANY) return true;
        else if (options.includePrerelease) sub = [
            new $1sSb8(">=0.0.0-0")
        ];
        else sub = [
            new $1sSb8(">=0.0.0")
        ];
    }
    if (dom.length === 1 && dom[0].semver === $36a7af3799ce87cf$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = [
            new $1sSb8(">=0.0.0")
        ];
    }
    var eqSet = new Set();
    var gt, lt;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sub[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (c.operator === ">" || c.operator === ">=") gt = $36a7af3799ce87cf$var$higherGT(gt, c, options);
            else if (c.operator === "<" || c.operator === "<=") lt = $36a7af3799ce87cf$var$lowerLT(lt, c, options);
            else eqSet.add(c.semver);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (eqSet.size > 1) return null;
    var gtltComp;
    if (gt && lt) {
        gtltComp = $gn47S(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // will iterate one or zero times
        for(var _iterator1 = eqSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var eq = _step1.value;
            if (gt && !$B9qRr(eq, String(gt), options)) return null;
            if (lt && !$B9qRr(eq, String(lt), options)) return null;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = dom[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var c1 = _step2.value;
                    if (!$B9qRr(eq, String(c1), options)) return false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            return true;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var higher, lower;
    var hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    var needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    var needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = dom[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var c2 = _step3.value;
            hasDomGT = hasDomGT || c2.operator === ">" || c2.operator === ">=";
            hasDomLT = hasDomLT || c2.operator === "<" || c2.operator === "<=";
            if (gt) {
                if (needDomGTPre) {
                    if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomGTPre.major && c2.semver.minor === needDomGTPre.minor && c2.semver.patch === needDomGTPre.patch) needDomGTPre = false;
                }
                if (c2.operator === ">" || c2.operator === ">=") {
                    higher = $36a7af3799ce87cf$var$higherGT(gt, c2, options);
                    if (higher === c2 && higher !== gt) return false;
                } else if (gt.operator === ">=" && !$B9qRr(gt.semver, String(c2), options)) return false;
            }
            if (lt) {
                if (needDomLTPre) {
                    if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomLTPre.major && c2.semver.minor === needDomLTPre.minor && c2.semver.patch === needDomLTPre.patch) needDomLTPre = false;
                }
                if (c2.operator === "<" || c2.operator === "<=") {
                    lower = $36a7af3799ce87cf$var$lowerLT(lt, c2, options);
                    if (lower === c2 && lower !== lt) return false;
                } else if (lt.operator === "<=" && !$B9qRr(lt.semver, String(c2), options)) return false;
            }
            if (!c2.operator && (lt || gt) && gtltComp !== 0) return false;
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
var $36a7af3799ce87cf$var$higherGT = function(a, b, options) {
    if (!a) return b;
    var comp = $gn47S(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
var $36a7af3799ce87cf$var$lowerLT = function(a, b, options) {
    if (!a) return b;
    var comp = $gn47S(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
module.exports = $36a7af3799ce87cf$var$subset;

});

parcelRegister("gYRJ8", function(module, exports) {

var $kOoDP = parcelRequire("kOoDP");
var $c5cbed00870b8e7d$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $kOoDP($c5cbed00870b8e7d$var$ALPHABET);

});
parcelRegister("kOoDP", function(module, exports) {
"use strict";

var $b1nU2 = parcelRequire("b1nU2");
var $f26b976adc799454$require$_Buffer = $b1nU2.Buffer;
function $f26b976adc799454$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $f26b976adc799454$require$_Buffer.from(source);
        if (!$f26b976adc799454$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $f26b976adc799454$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip leading spaces.
        if (source[psz] === " ") return;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip trailing spaces.
        if (source[psz] === " ") return;
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $f26b976adc799454$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $f26b976adc799454$var$base;

});


parcelRegister("e9ZU4", function(module, exports) {

var $2oThn = parcelRequire("2oThn");

var $bMoKo = parcelRequire("bMoKo");
// short-hand
var $a4f1ecaa783b7bea$var$tfJSON = $2oThn.tfJSON;
var $a4f1ecaa783b7bea$var$TfTypeError = $2oThn.TfTypeError;
var $a4f1ecaa783b7bea$var$TfPropertyTypeError = $2oThn.TfPropertyTypeError;
var $a4f1ecaa783b7bea$var$tfSubError = $2oThn.tfSubError;
var $a4f1ecaa783b7bea$var$getValueTypeName = $2oThn.getValueTypeName;
var $a4f1ecaa783b7bea$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $a4f1ecaa783b7bea$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$bMoKo.Array(array)) return false;
            if ($bMoKo.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $a4f1ecaa783b7bea$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $a4f1ecaa783b7bea$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $a4f1ecaa783b7bea$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $a4f1ecaa783b7bea$var$compile(type);
        function _maybe(value, strict) {
            return $bMoKo.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $a4f1ecaa783b7bea$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $a4f1ecaa783b7bea$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $a4f1ecaa783b7bea$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$bMoKo.Object(value)) return false;
            if ($bMoKo.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $a4f1ecaa783b7bea$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $a4f1ecaa783b7bea$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $a4f1ecaa783b7bea$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $a4f1ecaa783b7bea$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $a4f1ecaa783b7bea$var$tfJSON(propertyKeyType) + ": " + $a4f1ecaa783b7bea$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $a4f1ecaa783b7bea$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $a4f1ecaa783b7bea$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$bMoKo.Object(value)) return false;
            if ($bMoKo.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $a4f1ecaa783b7bea$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $a4f1ecaa783b7bea$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $a4f1ecaa783b7bea$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $a4f1ecaa783b7bea$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($a4f1ecaa783b7bea$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $a4f1ecaa783b7bea$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($a4f1ecaa783b7bea$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($a4f1ecaa783b7bea$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $a4f1ecaa783b7bea$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($a4f1ecaa783b7bea$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $a4f1ecaa783b7bea$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($a4f1ecaa783b7bea$var$compile);
        function _tuple(values, strict) {
            if ($bMoKo.Nil(values)) return false;
            if ($bMoKo.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $a4f1ecaa783b7bea$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $a4f1ecaa783b7bea$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($a4f1ecaa783b7bea$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$a4f1ecaa783b7bea$var$TYPES.oneOf = $a4f1ecaa783b7bea$var$TYPES.anyOf;
function $a4f1ecaa783b7bea$var$compile(type) {
    if ($bMoKo.String(type)) {
        if (type[0] === "?") return $a4f1ecaa783b7bea$var$TYPES.maybe(type.slice(1));
        return $bMoKo[type] || $a4f1ecaa783b7bea$var$TYPES.quacksLike(type);
    } else if (type && $bMoKo.Object(type)) {
        if ($bMoKo.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $a4f1ecaa783b7bea$var$TYPES.arrayOf(type[0]);
        }
        return $a4f1ecaa783b7bea$var$TYPES.object(type);
    } else if ($bMoKo.Function(type)) return type;
    return $a4f1ecaa783b7bea$var$TYPES.value(type);
}
function $a4f1ecaa783b7bea$var$typeforce(type, value, strict, surrogate) {
    if ($bMoKo.Function(type)) {
        if (type(value, strict)) return true;
        throw new $a4f1ecaa783b7bea$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $a4f1ecaa783b7bea$var$typeforce($a4f1ecaa783b7bea$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $a4f1ecaa783b7bea$var$typeName in $bMoKo)$a4f1ecaa783b7bea$var$typeforce[$a4f1ecaa783b7bea$var$typeName] = $bMoKo[$a4f1ecaa783b7bea$var$typeName];
for($a4f1ecaa783b7bea$var$typeName in $a4f1ecaa783b7bea$var$TYPES)$a4f1ecaa783b7bea$var$typeforce[$a4f1ecaa783b7bea$var$typeName] = $a4f1ecaa783b7bea$var$TYPES[$a4f1ecaa783b7bea$var$typeName];

var $5Rkej = parcelRequire("5Rkej");
for($a4f1ecaa783b7bea$var$typeName in $5Rkej)$a4f1ecaa783b7bea$var$typeforce[$a4f1ecaa783b7bea$var$typeName] = $5Rkej[$a4f1ecaa783b7bea$var$typeName];
$a4f1ecaa783b7bea$var$typeforce.compile = $a4f1ecaa783b7bea$var$compile;
$a4f1ecaa783b7bea$var$typeforce.TfTypeError = $a4f1ecaa783b7bea$var$TfTypeError;
$a4f1ecaa783b7bea$var$typeforce.TfPropertyTypeError = $a4f1ecaa783b7bea$var$TfPropertyTypeError;
module.exports = $a4f1ecaa783b7bea$var$typeforce;

});
parcelRegister("2oThn", function(module, exports) {

var $bMoKo = parcelRequire("bMoKo");
function $1bf8b3f854f759f2$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $1bf8b3f854f759f2$var$getValueTypeName(value) {
    return $bMoKo.Nil(value) ? "" : $1bf8b3f854f759f2$var$getTypeName(value.constructor);
}
function $1bf8b3f854f759f2$var$getValue(value) {
    if ($bMoKo.Function(value)) return "";
    if ($bMoKo.String(value)) return JSON.stringify(value);
    if (value && $bMoKo.Object(value)) return "";
    return value;
}
function $1bf8b3f854f759f2$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $1bf8b3f854f759f2$var$tfJSON(type) {
    if ($bMoKo.Function(type)) return type.toJSON ? type.toJSON() : $1bf8b3f854f759f2$var$getTypeName(type);
    if ($bMoKo.Array(type)) return "Array";
    if (type && $bMoKo.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $1bf8b3f854f759f2$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $1bf8b3f854f759f2$var$getValue(value);
    return "Expected " + $1bf8b3f854f759f2$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $1bf8b3f854f759f2$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $1bf8b3f854f759f2$var$getValueTypeName(value);
    this.message = $1bf8b3f854f759f2$var$tfErrorString(type, value, valueTypeName);
    $1bf8b3f854f759f2$var$captureStackTrace(this, $1bf8b3f854f759f2$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$1bf8b3f854f759f2$var$TfTypeError.prototype = Object.create(Error.prototype);
$1bf8b3f854f759f2$var$TfTypeError.prototype.constructor = $1bf8b3f854f759f2$var$TfTypeError;
function $1bf8b3f854f759f2$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $1bf8b3f854f759f2$var$tfErrorString('property "' + $1bf8b3f854f759f2$var$tfJSON(name) + description + $1bf8b3f854f759f2$var$tfJSON(type), value, valueTypeName);
}
function $1bf8b3f854f759f2$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $1bf8b3f854f759f2$var$getValueTypeName(value);
        this.message = $1bf8b3f854f759f2$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $1bf8b3f854f759f2$var$captureStackTrace(this, $1bf8b3f854f759f2$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$1bf8b3f854f759f2$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$1bf8b3f854f759f2$var$TfPropertyTypeError.prototype.constructor = $1bf8b3f854f759f2$var$TfTypeError;
function $1bf8b3f854f759f2$var$tfCustomError(expected, actual) {
    return new $1bf8b3f854f759f2$var$TfTypeError(expected, {}, actual);
}
function $1bf8b3f854f759f2$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $1bf8b3f854f759f2$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $1bf8b3f854f759f2$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $1bf8b3f854f759f2$var$TfTypeError) e = new $1bf8b3f854f759f2$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $1bf8b3f854f759f2$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $1bf8b3f854f759f2$var$TfTypeError,
    TfPropertyTypeError: $1bf8b3f854f759f2$var$TfPropertyTypeError,
    tfCustomError: $1bf8b3f854f759f2$var$tfCustomError,
    tfSubError: $1bf8b3f854f759f2$var$tfSubError,
    tfJSON: $1bf8b3f854f759f2$var$tfJSON,
    getValueTypeName: $1bf8b3f854f759f2$var$getValueTypeName
};

});
parcelRegister("bMoKo", function(module, exports) {
var $89375fb7cc2e14a5$var$types = {
    Array: function Array1(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function Boolean(value) {
        return typeof value === "boolean";
    },
    Function: function Function(value) {
        return typeof value === "function";
    },
    Nil: function Nil(value) {
        return value === undefined || value === null;
    },
    Number: function Number(value) {
        return typeof value === "number";
    },
    Object: function Object(value) {
        return typeof value === "object";
    },
    String: function String(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$89375fb7cc2e14a5$var$types.Null = $89375fb7cc2e14a5$var$types.Nil;
for(var $89375fb7cc2e14a5$var$typeName in $89375fb7cc2e14a5$var$types)$89375fb7cc2e14a5$var$types[$89375fb7cc2e14a5$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $89375fb7cc2e14a5$var$typeName);
module.exports = $89375fb7cc2e14a5$var$types;

});


parcelRegister("5Rkej", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $44419833c5687da2$require$Buffer = $ilnag.Buffer;

var $bMoKo = parcelRequire("bMoKo");

var $2oThn = parcelRequire("2oThn");
function $44419833c5687da2$var$_Buffer(value) {
    return $44419833c5687da2$require$Buffer.isBuffer(value);
}
function $44419833c5687da2$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $44419833c5687da2$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $2oThn.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $44419833c5687da2$var$_ArrayN = $44419833c5687da2$var$_LengthN.bind(null, $bMoKo.Array);
var $44419833c5687da2$var$_BufferN = $44419833c5687da2$var$_LengthN.bind(null, $44419833c5687da2$var$_Buffer);
var $44419833c5687da2$var$_HexN = $44419833c5687da2$var$_LengthN.bind(null, $44419833c5687da2$var$Hex);
var $44419833c5687da2$var$_StringN = $44419833c5687da2$var$_LengthN.bind(null, $bMoKo.String);
function $44419833c5687da2$var$Range(a, b, f) {
    f = f || $bMoKo.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return "".concat(f.toJSON(), " between [").concat(a, ", ").concat(b, "]");
    };
    return _range;
}
var $44419833c5687da2$var$INT53_MAX = Math.pow(2, 53) - 1;
function $44419833c5687da2$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $44419833c5687da2$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $44419833c5687da2$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $44419833c5687da2$var$Int32(value) {
    return (value | 0) === value;
}
function $44419833c5687da2$var$Int53(value) {
    return typeof value === "number" && value >= -$44419833c5687da2$var$INT53_MAX && value <= $44419833c5687da2$var$INT53_MAX && Math.floor(value) === value;
}
function $44419833c5687da2$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $44419833c5687da2$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $44419833c5687da2$var$UInt32(value) {
    return value >>> 0 === value;
}
function $44419833c5687da2$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $44419833c5687da2$var$INT53_MAX && Math.floor(value) === value;
}
var $44419833c5687da2$var$types = {
    ArrayN: $44419833c5687da2$var$_ArrayN,
    Buffer: $44419833c5687da2$var$_Buffer,
    BufferN: $44419833c5687da2$var$_BufferN,
    Finite: $44419833c5687da2$var$Finite,
    Hex: $44419833c5687da2$var$Hex,
    HexN: $44419833c5687da2$var$_HexN,
    Int8: $44419833c5687da2$var$Int8,
    Int16: $44419833c5687da2$var$Int16,
    Int32: $44419833c5687da2$var$Int32,
    Int53: $44419833c5687da2$var$Int53,
    Range: $44419833c5687da2$var$Range,
    StringN: $44419833c5687da2$var$_StringN,
    UInt8: $44419833c5687da2$var$UInt8,
    UInt16: $44419833c5687da2$var$UInt16,
    UInt32: $44419833c5687da2$var$UInt32,
    UInt53: $44419833c5687da2$var$UInt53
};
for(var $44419833c5687da2$var$typeName in $44419833c5687da2$var$types)$44419833c5687da2$var$types[$44419833c5687da2$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $44419833c5687da2$var$typeName);
module.exports = $44419833c5687da2$var$types;

});


parcelRegister("26CEw", function(module, exports) {
module.exports = JSON.parse('{"OP_FALSE":0,"OP_0":0,"OP_PUSHDATA1":76,"OP_PUSHDATA2":77,"OP_PUSHDATA4":78,"OP_1NEGATE":79,"OP_RESERVED":80,"OP_TRUE":81,"OP_1":81,"OP_2":82,"OP_3":83,"OP_4":84,"OP_5":85,"OP_6":86,"OP_7":87,"OP_8":88,"OP_9":89,"OP_10":90,"OP_11":91,"OP_12":92,"OP_13":93,"OP_14":94,"OP_15":95,"OP_16":96,"OP_NOP":97,"OP_VER":98,"OP_IF":99,"OP_NOTIF":100,"OP_VERIF":101,"OP_VERNOTIF":102,"OP_ELSE":103,"OP_ENDIF":104,"OP_VERIFY":105,"OP_RETURN":106,"OP_TOALTSTACK":107,"OP_FROMALTSTACK":108,"OP_2DROP":109,"OP_2DUP":110,"OP_3DUP":111,"OP_2OVER":112,"OP_2ROT":113,"OP_2SWAP":114,"OP_IFDUP":115,"OP_DEPTH":116,"OP_DROP":117,"OP_DUP":118,"OP_NIP":119,"OP_OVER":120,"OP_PICK":121,"OP_ROLL":122,"OP_ROT":123,"OP_SWAP":124,"OP_TUCK":125,"OP_CAT":126,"OP_SUBSTR":127,"OP_LEFT":128,"OP_RIGHT":129,"OP_SIZE":130,"OP_INVERT":131,"OP_AND":132,"OP_OR":133,"OP_XOR":134,"OP_EQUAL":135,"OP_EQUALVERIFY":136,"OP_RESERVED1":137,"OP_RESERVED2":138,"OP_1ADD":139,"OP_1SUB":140,"OP_2MUL":141,"OP_2DIV":142,"OP_NEGATE":143,"OP_ABS":144,"OP_NOT":145,"OP_0NOTEQUAL":146,"OP_ADD":147,"OP_SUB":148,"OP_MUL":149,"OP_DIV":150,"OP_MOD":151,"OP_LSHIFT":152,"OP_RSHIFT":153,"OP_BOOLAND":154,"OP_BOOLOR":155,"OP_NUMEQUAL":156,"OP_NUMEQUALVERIFY":157,"OP_NUMNOTEQUAL":158,"OP_LESSTHAN":159,"OP_GREATERTHAN":160,"OP_LESSTHANOREQUAL":161,"OP_GREATERTHANOREQUAL":162,"OP_MIN":163,"OP_MAX":164,"OP_WITHIN":165,"OP_RIPEMD160":166,"OP_SHA1":167,"OP_SHA256":168,"OP_HASH160":169,"OP_HASH256":170,"OP_CODESEPARATOR":171,"OP_CHECKSIG":172,"OP_CHECKSIGVERIFY":173,"OP_CHECKMULTISIG":174,"OP_CHECKMULTISIGVERIFY":175,"OP_NOP1":176,"OP_NOP2":177,"OP_CHECKLOCKTIMEVERIFY":177,"OP_NOP3":178,"OP_CHECKSEQUENCEVERIFY":178,"OP_NOP4":179,"OP_NOP5":180,"OP_NOP6":181,"OP_NOP7":182,"OP_NOP8":183,"OP_NOP9":184,"OP_NOP10":185,"OP_PUBKEYHASH":253,"OP_PUBKEY":254,"OP_INVALIDOPCODE":255}');

});

parcelRegister("7xZy0", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $57eb5b82864124f9$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXO7v = parcelRequire("lXO7v");

var $barY9 = parcelRequire("barY9");

var $d1BPf = parcelRequire("d1BPf");

var $iUuQV = parcelRequire("iUuQV");
function $57eb5b82864124f9$var$psbtFromBuffer(buffer, txGetter) {
    var offset = 0;
    function varSlice() {
        var keyLen = $d1BPf.decode(buffer, offset);
        offset += $d1BPf.encodingLength(keyLen);
        var key = buffer.slice(offset, offset + keyLen);
        offset += keyLen;
        return key;
    }
    function readUInt32BE() {
        var num = buffer.readUInt32BE(offset);
        offset += 4;
        return num;
    }
    function readUInt8() {
        var num = buffer.readUInt8(offset);
        offset += 1;
        return num;
    }
    function getKeyValue() {
        var key = varSlice();
        var value = varSlice();
        return {
            key: key,
            value: value
        };
    }
    function checkEndOfKeyValPairs() {
        if (offset >= buffer.length) throw new Error("Format Error: Unexpected End of PSBT");
        var isEnd = buffer.readUInt8(offset) === 0;
        if (isEnd) offset++;
        return isEnd;
    }
    if (readUInt32BE() !== 0x70736274) throw new Error("Format Error: Invalid Magic Number");
    if (readUInt8() !== 0xff) throw new Error("Format Error: Magic Number must be followed by 0xff separator");
    var globalMapKeyVals = [];
    var globalKeyIndex = {};
    while(!checkEndOfKeyValPairs()){
        var keyVal = getKeyValue();
        var hexKey = keyVal.key.toString("hex");
        if (globalKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for global keymap: key " + hexKey);
        globalKeyIndex[hexKey] = 1;
        globalMapKeyVals.push(keyVal);
    }
    var unsignedTxMaps = globalMapKeyVals.filter(function(keyVal) {
        return keyVal.key[0] === $iUuQV.GlobalTypes.UNSIGNED_TX;
    });
    if (unsignedTxMaps.length !== 1) throw new Error("Format Error: Only one UNSIGNED_TX allowed");
    var unsignedTx = txGetter(unsignedTxMaps[0].value);
    // Get input and output counts to loop the respective fields
    var _unsignedTx_getInputOutputCounts = unsignedTx.getInputOutputCounts(), inputCount = _unsignedTx_getInputOutputCounts.inputCount, outputCount = _unsignedTx_getInputOutputCounts.outputCount;
    var inputKeyVals = [];
    var outputKeyVals = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Get input fields
        for(var _iterator = $barY9.range(inputCount)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            var inputKeyIndex = {};
            var input = [];
            while(!checkEndOfKeyValPairs()){
                var keyVal1 = getKeyValue();
                var hexKey1 = keyVal1.key.toString("hex");
                if (inputKeyIndex[hexKey1]) throw new Error("Format Error: Keys must be unique for each input: input index " + index + " key " + hexKey1);
                inputKeyIndex[hexKey1] = 1;
                input.push(keyVal1);
            }
            inputKeyVals.push(input);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = $barY9.range(outputCount)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var index1 = _step1.value;
            var outputKeyIndex = {};
            var output = [];
            while(!checkEndOfKeyValPairs()){
                var keyVal2 = getKeyValue();
                var hexKey2 = keyVal2.key.toString("hex");
                if (outputKeyIndex[hexKey2]) throw new Error("Format Error: Keys must be unique for each output: output index " + index1 + " key " + hexKey2);
                outputKeyIndex[hexKey2] = 1;
                output.push(keyVal2);
            }
            outputKeyVals.push(output);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return $57eb5b82864124f9$var$psbtFromKeyVals(unsignedTx, {
        globalMapKeyVals: globalMapKeyVals,
        inputKeyVals: inputKeyVals,
        outputKeyVals: outputKeyVals
    });
}
module.exports.psbtFromBuffer = $57eb5b82864124f9$var$psbtFromBuffer;
function $57eb5b82864124f9$var$checkKeyBuffer(type, keyBuf, keyNum) {
    if (!keyBuf.equals($57eb5b82864124f9$require$Buffer.from([
        keyNum
    ]))) throw new Error("Format Error: Invalid ".concat(type, " key: ").concat(keyBuf.toString("hex")));
}
module.exports.checkKeyBuffer = $57eb5b82864124f9$var$checkKeyBuffer;
function $57eb5b82864124f9$var$psbtFromKeyVals(unsignedTx, param) {
    var globalMapKeyVals = param.globalMapKeyVals, inputKeyVals = param.inputKeyVals, outputKeyVals = param.outputKeyVals;
    // That was easy :-)
    var globalMap = {
        unsignedTx: unsignedTx
    };
    var txCount = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = globalMapKeyVals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var keyVal = _step.value;
            // If a globalMap item needs pubkey, uncomment
            // const pubkey = convert.globals.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $iUuQV.GlobalTypes.UNSIGNED_TX:
                    $57eb5b82864124f9$var$checkKeyBuffer("global", keyVal.key, $iUuQV.GlobalTypes.UNSIGNED_TX);
                    if (txCount > 0) throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
                    txCount++;
                    break;
                case $iUuQV.GlobalTypes.GLOBAL_XPUB:
                    if (globalMap.globalXpub === undefined) globalMap.globalXpub = [];
                    globalMap.globalXpub.push($lXO7v.globals.globalXpub.decode(keyVal));
                    break;
                default:
                    // This will allow inclusion during serialization.
                    if (!globalMap.unknownKeyVals) globalMap.unknownKeyVals = [];
                    globalMap.unknownKeyVals.push(keyVal);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Get input and output counts to loop the respective fields
    var inputCount = inputKeyVals.length;
    var outputCount = outputKeyVals.length;
    var inputs = [];
    var outputs = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // Get input fields
        for(var _iterator1 = $barY9.range(inputCount)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var index = _step1.value;
            var input = {};
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = inputKeyVals[index][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var keyVal1 = _step2.value;
                    $lXO7v.inputs.checkPubkey(keyVal1);
                    switch(keyVal1.key[0]){
                        case $iUuQV.InputTypes.NON_WITNESS_UTXO:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.NON_WITNESS_UTXO);
                            if (input.nonWitnessUtxo !== undefined) throw new Error("Format Error: Input has multiple NON_WITNESS_UTXO");
                            input.nonWitnessUtxo = $lXO7v.inputs.nonWitnessUtxo.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.WITNESS_UTXO:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.WITNESS_UTXO);
                            if (input.witnessUtxo !== undefined) throw new Error("Format Error: Input has multiple WITNESS_UTXO");
                            input.witnessUtxo = $lXO7v.inputs.witnessUtxo.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.PARTIAL_SIG:
                            if (input.partialSig === undefined) input.partialSig = [];
                            input.partialSig.push($lXO7v.inputs.partialSig.decode(keyVal1));
                            break;
                        case $iUuQV.InputTypes.SIGHASH_TYPE:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.SIGHASH_TYPE);
                            if (input.sighashType !== undefined) throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
                            input.sighashType = $lXO7v.inputs.sighashType.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.REDEEM_SCRIPT:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.REDEEM_SCRIPT);
                            if (input.redeemScript !== undefined) throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
                            input.redeemScript = $lXO7v.inputs.redeemScript.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.WITNESS_SCRIPT:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.WITNESS_SCRIPT);
                            if (input.witnessScript !== undefined) throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
                            input.witnessScript = $lXO7v.inputs.witnessScript.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.BIP32_DERIVATION:
                            if (input.bip32Derivation === undefined) input.bip32Derivation = [];
                            input.bip32Derivation.push($lXO7v.inputs.bip32Derivation.decode(keyVal1));
                            break;
                        case $iUuQV.InputTypes.FINAL_SCRIPTSIG:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.FINAL_SCRIPTSIG);
                            input.finalScriptSig = $lXO7v.inputs.finalScriptSig.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.FINAL_SCRIPTWITNESS:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.FINAL_SCRIPTWITNESS);
                            input.finalScriptWitness = $lXO7v.inputs.finalScriptWitness.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.POR_COMMITMENT:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.POR_COMMITMENT);
                            input.porCommitment = $lXO7v.inputs.porCommitment.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.TAP_KEY_SIG:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.TAP_KEY_SIG);
                            input.tapKeySig = $lXO7v.inputs.tapKeySig.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.TAP_SCRIPT_SIG:
                            if (input.tapScriptSig === undefined) input.tapScriptSig = [];
                            input.tapScriptSig.push($lXO7v.inputs.tapScriptSig.decode(keyVal1));
                            break;
                        case $iUuQV.InputTypes.TAP_LEAF_SCRIPT:
                            if (input.tapLeafScript === undefined) input.tapLeafScript = [];
                            input.tapLeafScript.push($lXO7v.inputs.tapLeafScript.decode(keyVal1));
                            break;
                        case $iUuQV.InputTypes.TAP_BIP32_DERIVATION:
                            if (input.tapBip32Derivation === undefined) input.tapBip32Derivation = [];
                            input.tapBip32Derivation.push($lXO7v.inputs.tapBip32Derivation.decode(keyVal1));
                            break;
                        case $iUuQV.InputTypes.TAP_INTERNAL_KEY:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.TAP_INTERNAL_KEY);
                            input.tapInternalKey = $lXO7v.inputs.tapInternalKey.decode(keyVal1);
                            break;
                        case $iUuQV.InputTypes.TAP_MERKLE_ROOT:
                            $57eb5b82864124f9$var$checkKeyBuffer("input", keyVal1.key, $iUuQV.InputTypes.TAP_MERKLE_ROOT);
                            input.tapMerkleRoot = $lXO7v.inputs.tapMerkleRoot.decode(keyVal1);
                            break;
                        default:
                            // This will allow inclusion during serialization.
                            if (!input.unknownKeyVals) input.unknownKeyVals = [];
                            input.unknownKeyVals.push(keyVal1);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            inputs.push(input);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = $barY9.range(outputCount)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var index1 = _step3.value;
            var output = {};
            var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
            try {
                for(var _iterator4 = outputKeyVals[index1][Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                    var keyVal2 = _step4.value;
                    $lXO7v.outputs.checkPubkey(keyVal2);
                    switch(keyVal2.key[0]){
                        case $iUuQV.OutputTypes.REDEEM_SCRIPT:
                            $57eb5b82864124f9$var$checkKeyBuffer("output", keyVal2.key, $iUuQV.OutputTypes.REDEEM_SCRIPT);
                            if (output.redeemScript !== undefined) throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
                            output.redeemScript = $lXO7v.outputs.redeemScript.decode(keyVal2);
                            break;
                        case $iUuQV.OutputTypes.WITNESS_SCRIPT:
                            $57eb5b82864124f9$var$checkKeyBuffer("output", keyVal2.key, $iUuQV.OutputTypes.WITNESS_SCRIPT);
                            if (output.witnessScript !== undefined) throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
                            output.witnessScript = $lXO7v.outputs.witnessScript.decode(keyVal2);
                            break;
                        case $iUuQV.OutputTypes.BIP32_DERIVATION:
                            if (output.bip32Derivation === undefined) output.bip32Derivation = [];
                            output.bip32Derivation.push($lXO7v.outputs.bip32Derivation.decode(keyVal2));
                            break;
                        case $iUuQV.OutputTypes.TAP_INTERNAL_KEY:
                            $57eb5b82864124f9$var$checkKeyBuffer("output", keyVal2.key, $iUuQV.OutputTypes.TAP_INTERNAL_KEY);
                            output.tapInternalKey = $lXO7v.outputs.tapInternalKey.decode(keyVal2);
                            break;
                        case $iUuQV.OutputTypes.TAP_TREE:
                            $57eb5b82864124f9$var$checkKeyBuffer("output", keyVal2.key, $iUuQV.OutputTypes.TAP_TREE);
                            output.tapTree = $lXO7v.outputs.tapTree.decode(keyVal2);
                            break;
                        case $iUuQV.OutputTypes.TAP_BIP32_DERIVATION:
                            if (output.tapBip32Derivation === undefined) output.tapBip32Derivation = [];
                            output.tapBip32Derivation.push($lXO7v.outputs.tapBip32Derivation.decode(keyVal2));
                            break;
                        default:
                            if (!output.unknownKeyVals) output.unknownKeyVals = [];
                            output.unknownKeyVals.push(keyVal2);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                        _iterator4.return();
                    }
                } finally{
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
            outputs.push(output);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    return {
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    };
}
module.exports.psbtFromKeyVals = $57eb5b82864124f9$var$psbtFromKeyVals;

});
parcelRegister("lXO7v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");

var $8oJG6 = parcelRequire("8oJG6");

var $eYm0W = parcelRequire("eYm0W");

var $9M7zi = parcelRequire("9M7zi");

var $gSGL6 = parcelRequire("gSGL6");

var $88kOl = parcelRequire("88kOl");

var $1yYJP = parcelRequire("1yYJP");

var $4lAoP = parcelRequire("4lAoP");

var $4mjpt = parcelRequire("4mjpt");

var $aWvKd = parcelRequire("aWvKd");

var $3MIna = parcelRequire("3MIna");

var $dwzoG = parcelRequire("dwzoG");

var $5XBjz = parcelRequire("5XBjz");

var $hVaTe = parcelRequire("hVaTe");

var $lEzL7 = parcelRequire("lEzL7");

var $fOMCa = parcelRequire("fOMCa");

var $JRjHi = parcelRequire("JRjHi");

var $jA5Og = parcelRequire("jA5Og");

var $hmx7W = parcelRequire("hmx7W");

var $jqCmy = parcelRequire("jqCmy");

var $kweOW = parcelRequire("kweOW");
var $ffd5fc77d2fd9671$var$globals = {
    unsignedTx: $eYm0W,
    globalXpub: $8oJG6,
    // pass an Array of key bytes that require pubkey beside the key
    checkPubkey: $JRjHi.makeChecker([])
};
module.exports.globals = $ffd5fc77d2fd9671$var$globals;
var $ffd5fc77d2fd9671$var$inputs = {
    nonWitnessUtxo: $88kOl,
    partialSig: $1yYJP,
    sighashType: $4mjpt,
    finalScriptSig: $9M7zi,
    finalScriptWitness: $gSGL6,
    porCommitment: $4lAoP,
    witnessUtxo: $hVaTe,
    bip32Derivation: $fOMCa.makeConverter($iUuQV.InputTypes.BIP32_DERIVATION),
    redeemScript: $jA5Og.makeConverter($iUuQV.InputTypes.REDEEM_SCRIPT),
    witnessScript: $kweOW.makeConverter($iUuQV.InputTypes.WITNESS_SCRIPT),
    checkPubkey: $JRjHi.makeChecker([
        $iUuQV.InputTypes.PARTIAL_SIG,
        $iUuQV.InputTypes.BIP32_DERIVATION
    ]),
    tapKeySig: $aWvKd,
    tapScriptSig: $5XBjz,
    tapLeafScript: $3MIna,
    tapBip32Derivation: $hmx7W.makeConverter($iUuQV.InputTypes.TAP_BIP32_DERIVATION),
    tapInternalKey: $jqCmy.makeConverter($iUuQV.InputTypes.TAP_INTERNAL_KEY),
    tapMerkleRoot: $dwzoG
};
module.exports.inputs = $ffd5fc77d2fd9671$var$inputs;
var $ffd5fc77d2fd9671$var$outputs = {
    bip32Derivation: $fOMCa.makeConverter($iUuQV.OutputTypes.BIP32_DERIVATION),
    redeemScript: $jA5Og.makeConverter($iUuQV.OutputTypes.REDEEM_SCRIPT),
    witnessScript: $kweOW.makeConverter($iUuQV.OutputTypes.WITNESS_SCRIPT),
    checkPubkey: $JRjHi.makeChecker([
        $iUuQV.OutputTypes.BIP32_DERIVATION
    ]),
    tapBip32Derivation: $hmx7W.makeConverter($iUuQV.OutputTypes.TAP_BIP32_DERIVATION),
    tapTree: $lEzL7,
    tapInternalKey: $jqCmy.makeConverter($iUuQV.OutputTypes.TAP_INTERNAL_KEY)
};
module.exports.outputs = $ffd5fc77d2fd9671$var$outputs;

});
parcelRegister("iUuQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dc4563a296230633$var$GlobalTypes;
(function(GlobalTypes) {
    GlobalTypes[GlobalTypes["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    GlobalTypes[GlobalTypes["GLOBAL_XPUB"] = 1] = "GLOBAL_XPUB";
})($dc4563a296230633$var$GlobalTypes = module.exports.GlobalTypes || (module.exports.GlobalTypes = {}));
module.exports.GLOBAL_TYPE_NAMES = [
    "unsignedTx",
    "globalXpub"
];
var $dc4563a296230633$var$InputTypes;
(function(InputTypes) {
    InputTypes[InputTypes["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    InputTypes[InputTypes["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    InputTypes[InputTypes["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    InputTypes[InputTypes["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    InputTypes[InputTypes["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    InputTypes[InputTypes["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    InputTypes[InputTypes["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    InputTypes[InputTypes["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    InputTypes[InputTypes["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    InputTypes[InputTypes["POR_COMMITMENT"] = 9] = "POR_COMMITMENT";
    InputTypes[InputTypes["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    InputTypes[InputTypes["TAP_SCRIPT_SIG"] = 20] = "TAP_SCRIPT_SIG";
    InputTypes[InputTypes["TAP_LEAF_SCRIPT"] = 21] = "TAP_LEAF_SCRIPT";
    InputTypes[InputTypes["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
    InputTypes[InputTypes["TAP_INTERNAL_KEY"] = 23] = "TAP_INTERNAL_KEY";
    InputTypes[InputTypes["TAP_MERKLE_ROOT"] = 24] = "TAP_MERKLE_ROOT";
})($dc4563a296230633$var$InputTypes = module.exports.InputTypes || (module.exports.InputTypes = {}));
module.exports.INPUT_TYPE_NAMES = [
    "nonWitnessUtxo",
    "witnessUtxo",
    "partialSig",
    "sighashType",
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "finalScriptSig",
    "finalScriptWitness",
    "porCommitment",
    "tapKeySig",
    "tapScriptSig",
    "tapLeafScript",
    "tapBip32Derivation",
    "tapInternalKey",
    "tapMerkleRoot"
];
var $dc4563a296230633$var$OutputTypes;
(function(OutputTypes) {
    OutputTypes[OutputTypes["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    OutputTypes[OutputTypes["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    OutputTypes[OutputTypes["BIP32_DERIVATION"] = 2] = "BIP32_DERIVATION";
    OutputTypes[OutputTypes["TAP_INTERNAL_KEY"] = 5] = "TAP_INTERNAL_KEY";
    OutputTypes[OutputTypes["TAP_TREE"] = 6] = "TAP_TREE";
    OutputTypes[OutputTypes["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($dc4563a296230633$var$OutputTypes = module.exports.OutputTypes || (module.exports.OutputTypes = {}));
module.exports.OUTPUT_TYPE_NAMES = [
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "tapInternalKey",
    "tapTree",
    "tapBip32Derivation"
];

});

parcelRegister("8oJG6", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $61d3ff590106584e$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
var $61d3ff590106584e$var$range = function(n) {
    return (0, $gF0bR._)(Array(n).keys());
};
function $61d3ff590106584e$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.GlobalTypes.GLOBAL_XPUB) throw new Error("Decode Error: could not decode globalXpub with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 79 || ![
        2,
        3
    ].includes(keyVal.key[46])) throw new Error("Decode Error: globalXpub has invalid extended pubkey in key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Global GLOBAL_XPUB value length should be multiple of 4");
    var extendedPubkey = keyVal.key.slice(1);
    var data = {
        masterFingerprint: keyVal.value.slice(0, 4),
        extendedPubkey: extendedPubkey,
        path: "m"
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $61d3ff590106584e$var$range(keyVal.value.length / 4 - 1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            var val = keyVal.value.readUInt32LE(i * 4 + 4);
            var isHard = !!(val & 0x80000000);
            var idx = val & 0x7fffffff;
            data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
module.exports.decode = $61d3ff590106584e$var$decode;
function $61d3ff590106584e$var$encode(data) {
    var head = $61d3ff590106584e$require$Buffer.from([
        $iUuQV.GlobalTypes.GLOBAL_XPUB
    ]);
    var key = $61d3ff590106584e$require$Buffer.concat([
        head,
        data.extendedPubkey
    ]);
    var splitPath = data.path.split("/");
    var value = $61d3ff590106584e$require$Buffer.allocUnsafe(splitPath.length * 4);
    data.masterFingerprint.copy(value, 0);
    var offset = 4;
    splitPath.slice(1).forEach(function(level) {
        var isHard = level.slice(-1) === "'";
        var num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
        if (isHard) num += 0x80000000;
        value.writeUInt32LE(num, offset);
        offset += 4;
    });
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $61d3ff590106584e$var$encode;
module.exports.expected = "{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }";
function $61d3ff590106584e$var$check(data) {
    var epk = data.extendedPubkey;
    var mfp = data.masterFingerprint;
    var p = data.path;
    return $61d3ff590106584e$require$Buffer.isBuffer(epk) && epk.length === 78 && [
        2,
        3
    ].indexOf(epk[45]) > -1 && $61d3ff590106584e$require$Buffer.isBuffer(mfp) && mfp.length === 4 && typeof p === "string" && !!p.match(/^m(\/\d+'?)*$/);
}
module.exports.check = $61d3ff590106584e$var$check;
function $61d3ff590106584e$var$canAddToArray(array, item, dupeSet) {
    var dupeString = item.extendedPubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter(function(v) {
        return v.extendedPubkey.equals(item.extendedPubkey);
    }).length === 0;
}
module.exports.canAddToArray = $61d3ff590106584e$var$canAddToArray;

});

parcelRegister("eYm0W", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $ae67bed346f71451$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $ae67bed346f71451$var$encode(data) {
    return {
        key: $ae67bed346f71451$require$Buffer.from([
            $iUuQV.GlobalTypes.UNSIGNED_TX
        ]),
        value: data.toBuffer()
    };
}
module.exports.encode = $ae67bed346f71451$var$encode;

});

parcelRegister("9M7zi", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $71de77a791ce86f3$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $71de77a791ce86f3$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.FINAL_SCRIPTSIG) throw new Error("Decode Error: could not decode finalScriptSig with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $71de77a791ce86f3$var$decode;
function $71de77a791ce86f3$var$encode(data) {
    var key = $71de77a791ce86f3$require$Buffer.from([
        $iUuQV.InputTypes.FINAL_SCRIPTSIG
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $71de77a791ce86f3$var$encode;
module.exports.expected = "Buffer";
function $71de77a791ce86f3$var$check(data) {
    return $71de77a791ce86f3$require$Buffer.isBuffer(data);
}
module.exports.check = $71de77a791ce86f3$var$check;
function $71de77a791ce86f3$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptSig === undefined;
}
module.exports.canAdd = $71de77a791ce86f3$var$canAdd;

});

parcelRegister("gSGL6", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $c4a2db7f85e49dc5$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $c4a2db7f85e49dc5$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.FINAL_SCRIPTWITNESS) throw new Error("Decode Error: could not decode finalScriptWitness with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $c4a2db7f85e49dc5$var$decode;
function $c4a2db7f85e49dc5$var$encode(data) {
    var key = $c4a2db7f85e49dc5$require$Buffer.from([
        $iUuQV.InputTypes.FINAL_SCRIPTWITNESS
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $c4a2db7f85e49dc5$var$encode;
module.exports.expected = "Buffer";
function $c4a2db7f85e49dc5$var$check(data) {
    return $c4a2db7f85e49dc5$require$Buffer.isBuffer(data);
}
module.exports.check = $c4a2db7f85e49dc5$var$check;
function $c4a2db7f85e49dc5$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptWitness === undefined;
}
module.exports.canAdd = $c4a2db7f85e49dc5$var$canAdd;

});

parcelRegister("88kOl", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $5ebf36b33c56a39a$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $5ebf36b33c56a39a$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.NON_WITNESS_UTXO) throw new Error("Decode Error: could not decode nonWitnessUtxo with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $5ebf36b33c56a39a$var$decode;
function $5ebf36b33c56a39a$var$encode(data) {
    return {
        key: $5ebf36b33c56a39a$require$Buffer.from([
            $iUuQV.InputTypes.NON_WITNESS_UTXO
        ]),
        value: data
    };
}
module.exports.encode = $5ebf36b33c56a39a$var$encode;
module.exports.expected = "Buffer";
function $5ebf36b33c56a39a$var$check(data) {
    return $5ebf36b33c56a39a$require$Buffer.isBuffer(data);
}
module.exports.check = $5ebf36b33c56a39a$var$check;
function $5ebf36b33c56a39a$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.nonWitnessUtxo === undefined;
}
module.exports.canAdd = $5ebf36b33c56a39a$var$canAdd;

});

parcelRegister("1yYJP", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $123814bdc4d90385$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $123814bdc4d90385$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.PARTIAL_SIG) throw new Error("Decode Error: could not decode partialSig with key 0x" + keyVal.key.toString("hex"));
    if (!(keyVal.key.length === 34 || keyVal.key.length === 66) || ![
        2,
        3,
        4
    ].includes(keyVal.key[1])) throw new Error("Decode Error: partialSig has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
    var pubkey = keyVal.key.slice(1);
    return {
        pubkey: pubkey,
        signature: keyVal.value
    };
}
module.exports.decode = $123814bdc4d90385$var$decode;
function $123814bdc4d90385$var$encode(pSig) {
    var head = $123814bdc4d90385$require$Buffer.from([
        $iUuQV.InputTypes.PARTIAL_SIG
    ]);
    return {
        key: $123814bdc4d90385$require$Buffer.concat([
            head,
            pSig.pubkey
        ]),
        value: pSig.signature
    };
}
module.exports.encode = $123814bdc4d90385$var$encode;
module.exports.expected = "{ pubkey: Buffer; signature: Buffer; }";
function $123814bdc4d90385$var$check(data) {
    return $123814bdc4d90385$require$Buffer.isBuffer(data.pubkey) && $123814bdc4d90385$require$Buffer.isBuffer(data.signature) && [
        33,
        65
    ].includes(data.pubkey.length) && [
        2,
        3,
        4
    ].includes(data.pubkey[0]) && $123814bdc4d90385$var$isDerSigWithSighash(data.signature);
}
module.exports.check = $123814bdc4d90385$var$check;
function $123814bdc4d90385$var$isDerSigWithSighash(buf) {
    if (!$123814bdc4d90385$require$Buffer.isBuffer(buf) || buf.length < 9) return false;
    if (buf[0] !== 0x30) return false;
    if (buf.length !== buf[1] + 3) return false;
    if (buf[2] !== 0x02) return false;
    var rLen = buf[3];
    if (rLen > 33 || rLen < 1) return false;
    if (buf[3 + rLen + 1] !== 0x02) return false;
    var sLen = buf[3 + rLen + 2];
    if (sLen > 33 || sLen < 1) return false;
    if (buf.length !== 3 + rLen + 2 + sLen + 2) return false;
    return true;
}
function $123814bdc4d90385$var$canAddToArray(array, item, dupeSet) {
    var dupeString = item.pubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter(function(v) {
        return v.pubkey.equals(item.pubkey);
    }).length === 0;
}
module.exports.canAddToArray = $123814bdc4d90385$var$canAddToArray;

});

parcelRegister("4lAoP", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $32a55bc2ce37ad01$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $32a55bc2ce37ad01$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.POR_COMMITMENT) throw new Error("Decode Error: could not decode porCommitment with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.toString("utf8");
}
module.exports.decode = $32a55bc2ce37ad01$var$decode;
function $32a55bc2ce37ad01$var$encode(data) {
    var key = $32a55bc2ce37ad01$require$Buffer.from([
        $iUuQV.InputTypes.POR_COMMITMENT
    ]);
    return {
        key: key,
        value: $32a55bc2ce37ad01$require$Buffer.from(data, "utf8")
    };
}
module.exports.encode = $32a55bc2ce37ad01$var$encode;
module.exports.expected = "string";
function $32a55bc2ce37ad01$var$check(data) {
    return typeof data === "string";
}
module.exports.check = $32a55bc2ce37ad01$var$check;
function $32a55bc2ce37ad01$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.porCommitment === undefined;
}
module.exports.canAdd = $32a55bc2ce37ad01$var$canAdd;

});

parcelRegister("4mjpt", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $32c845e04c8d4afa$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $32c845e04c8d4afa$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.SIGHASH_TYPE) throw new Error("Decode Error: could not decode sighashType with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.readUInt32LE(0);
}
module.exports.decode = $32c845e04c8d4afa$var$decode;
function $32c845e04c8d4afa$var$encode(data) {
    var key = $32c845e04c8d4afa$require$Buffer.from([
        $iUuQV.InputTypes.SIGHASH_TYPE
    ]);
    var value = $32c845e04c8d4afa$require$Buffer.allocUnsafe(4);
    value.writeUInt32LE(data, 0);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $32c845e04c8d4afa$var$encode;
module.exports.expected = "number";
function $32c845e04c8d4afa$var$check(data) {
    return typeof data === "number";
}
module.exports.check = $32c845e04c8d4afa$var$check;
function $32c845e04c8d4afa$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.sighashType === undefined;
}
module.exports.canAdd = $32c845e04c8d4afa$var$canAdd;

});

parcelRegister("aWvKd", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $020e525aa5bf840d$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $020e525aa5bf840d$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.TAP_KEY_SIG || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapKeySig with key 0x" + keyVal.key.toString("hex"));
    if (!$020e525aa5bf840d$var$check(keyVal.value)) throw new Error("Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature");
    return keyVal.value;
}
module.exports.decode = $020e525aa5bf840d$var$decode;
function $020e525aa5bf840d$var$encode(value) {
    var key = $020e525aa5bf840d$require$Buffer.from([
        $iUuQV.InputTypes.TAP_KEY_SIG
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $020e525aa5bf840d$var$encode;
module.exports.expected = "Buffer";
function $020e525aa5bf840d$var$check(data) {
    return $020e525aa5bf840d$require$Buffer.isBuffer(data) && (data.length === 64 || data.length === 65);
}
module.exports.check = $020e525aa5bf840d$var$check;
function $020e525aa5bf840d$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapKeySig === undefined;
}
module.exports.canAdd = $020e525aa5bf840d$var$canAdd;

});

parcelRegister("3MIna", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $2c18464c12e051b0$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $2c18464c12e051b0$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.TAP_LEAF_SCRIPT) throw new Error("Decode Error: could not decode tapLeafScript with key 0x" + keyVal.key.toString("hex"));
    if ((keyVal.key.length - 2) % 32 !== 0) throw new Error("Decode Error: tapLeafScript has invalid control block in key 0x" + keyVal.key.toString("hex"));
    var leafVersion = keyVal.value[keyVal.value.length - 1];
    if ((keyVal.key[1] & 0xfe) !== leafVersion) throw new Error("Decode Error: tapLeafScript bad leaf version in key 0x" + keyVal.key.toString("hex"));
    var script = keyVal.value.slice(0, -1);
    var controlBlock = keyVal.key.slice(1);
    return {
        controlBlock: controlBlock,
        script: script,
        leafVersion: leafVersion
    };
}
module.exports.decode = $2c18464c12e051b0$var$decode;
function $2c18464c12e051b0$var$encode(tScript) {
    var head = $2c18464c12e051b0$require$Buffer.from([
        $iUuQV.InputTypes.TAP_LEAF_SCRIPT
    ]);
    var verBuf = $2c18464c12e051b0$require$Buffer.from([
        tScript.leafVersion
    ]);
    return {
        key: $2c18464c12e051b0$require$Buffer.concat([
            head,
            tScript.controlBlock
        ]),
        value: $2c18464c12e051b0$require$Buffer.concat([
            tScript.script,
            verBuf
        ])
    };
}
module.exports.encode = $2c18464c12e051b0$var$encode;
module.exports.expected = "{ controlBlock: Buffer; leafVersion: number, script: Buffer; }";
function $2c18464c12e051b0$var$check(data) {
    return $2c18464c12e051b0$require$Buffer.isBuffer(data.controlBlock) && (data.controlBlock.length - 1) % 32 === 0 && (data.controlBlock[0] & 0xfe) === data.leafVersion && $2c18464c12e051b0$require$Buffer.isBuffer(data.script);
}
module.exports.check = $2c18464c12e051b0$var$check;
function $2c18464c12e051b0$var$canAddToArray(array, item, dupeSet) {
    var dupeString = item.controlBlock.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter(function(v) {
        return v.controlBlock.equals(item.controlBlock);
    }).length === 0;
}
module.exports.canAddToArray = $2c18464c12e051b0$var$canAddToArray;

});

parcelRegister("dwzoG", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $9d89b8a2efc29027$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $9d89b8a2efc29027$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.TAP_MERKLE_ROOT || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapMerkleRoot with key 0x" + keyVal.key.toString("hex"));
    if (!$9d89b8a2efc29027$var$check(keyVal.value)) throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
    return keyVal.value;
}
module.exports.decode = $9d89b8a2efc29027$var$decode;
function $9d89b8a2efc29027$var$encode(value) {
    var key = $9d89b8a2efc29027$require$Buffer.from([
        $iUuQV.InputTypes.TAP_MERKLE_ROOT
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $9d89b8a2efc29027$var$encode;
module.exports.expected = "Buffer";
function $9d89b8a2efc29027$var$check(data) {
    return $9d89b8a2efc29027$require$Buffer.isBuffer(data) && data.length === 32;
}
module.exports.check = $9d89b8a2efc29027$var$check;
function $9d89b8a2efc29027$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapMerkleRoot === undefined;
}
module.exports.canAdd = $9d89b8a2efc29027$var$canAdd;

});

parcelRegister("5XBjz", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $456f685586114957$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");
function $456f685586114957$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.TAP_SCRIPT_SIG) throw new Error("Decode Error: could not decode tapScriptSig with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length !== 64 && keyVal.value.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid signature in key 0x" + keyVal.key.toString("hex"));
    var pubkey = keyVal.key.slice(1, 33);
    var leafHash = keyVal.key.slice(33);
    return {
        pubkey: pubkey,
        leafHash: leafHash,
        signature: keyVal.value
    };
}
module.exports.decode = $456f685586114957$var$decode;
function $456f685586114957$var$encode(tSig) {
    var head = $456f685586114957$require$Buffer.from([
        $iUuQV.InputTypes.TAP_SCRIPT_SIG
    ]);
    return {
        key: $456f685586114957$require$Buffer.concat([
            head,
            tSig.pubkey,
            tSig.leafHash
        ]),
        value: tSig.signature
    };
}
module.exports.encode = $456f685586114957$var$encode;
module.exports.expected = "{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }";
function $456f685586114957$var$check(data) {
    return $456f685586114957$require$Buffer.isBuffer(data.pubkey) && $456f685586114957$require$Buffer.isBuffer(data.leafHash) && $456f685586114957$require$Buffer.isBuffer(data.signature) && data.pubkey.length === 32 && data.leafHash.length === 32 && (data.signature.length === 64 || data.signature.length === 65);
}
module.exports.check = $456f685586114957$var$check;
function $456f685586114957$var$canAddToArray(array, item, dupeSet) {
    var dupeString = item.pubkey.toString("hex") + item.leafHash.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter(function(v) {
        return v.pubkey.equals(item.pubkey) && v.leafHash.equals(item.leafHash);
    }).length === 0;
}
module.exports.canAddToArray = $456f685586114957$var$canAddToArray;

});

parcelRegister("hVaTe", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $d0c03504bdca4b26$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");

var $barY9 = parcelRequire("barY9");

var $d1BPf = parcelRequire("d1BPf");
function $d0c03504bdca4b26$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.InputTypes.WITNESS_UTXO) throw new Error("Decode Error: could not decode witnessUtxo with key 0x" + keyVal.key.toString("hex"));
    var value = $barY9.readUInt64LE(keyVal.value, 0);
    var _offset = 8;
    var scriptLen = $d1BPf.decode(keyVal.value, _offset);
    _offset += $d1BPf.encodingLength(scriptLen);
    var script = keyVal.value.slice(_offset);
    if (script.length !== scriptLen) throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
    return {
        script: script,
        value: value
    };
}
module.exports.decode = $d0c03504bdca4b26$var$decode;
function $d0c03504bdca4b26$var$encode(data) {
    var script = data.script, value = data.value;
    var varintLen = $d1BPf.encodingLength(script.length);
    var result = $d0c03504bdca4b26$require$Buffer.allocUnsafe(8 + varintLen + script.length);
    $barY9.writeUInt64LE(result, value, 0);
    $d1BPf.encode(script.length, result, 8);
    script.copy(result, 8 + varintLen);
    return {
        key: $d0c03504bdca4b26$require$Buffer.from([
            $iUuQV.InputTypes.WITNESS_UTXO
        ]),
        value: result
    };
}
module.exports.encode = $d0c03504bdca4b26$var$encode;
module.exports.expected = "{ script: Buffer; value: number; }";
function $d0c03504bdca4b26$var$check(data) {
    return $d0c03504bdca4b26$require$Buffer.isBuffer(data.script) && typeof data.value === "number";
}
module.exports.check = $d0c03504bdca4b26$var$check;
function $d0c03504bdca4b26$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.witnessUtxo === undefined;
}
module.exports.canAdd = $d0c03504bdca4b26$var$canAdd;

});
parcelRegister("barY9", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $821652fe792a76d8$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d1BPf = parcelRequire("d1BPf");
module.exports.range = function(n) {
    return (0, $gF0bR._)(Array(n).keys());
};
function $821652fe792a76d8$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    var j = buffer.length - 1;
    var tmp = 0;
    for(var i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $821652fe792a76d8$var$reverseBuffer;
function $821652fe792a76d8$var$keyValsToBuffer(keyVals) {
    var buffers = keyVals.map($821652fe792a76d8$var$keyValToBuffer);
    buffers.push($821652fe792a76d8$require$Buffer.from([
        0
    ]));
    return $821652fe792a76d8$require$Buffer.concat(buffers);
}
module.exports.keyValsToBuffer = $821652fe792a76d8$var$keyValsToBuffer;
function $821652fe792a76d8$var$keyValToBuffer(keyVal) {
    var keyLen = keyVal.key.length;
    var valLen = keyVal.value.length;
    var keyVarIntLen = $d1BPf.encodingLength(keyLen);
    var valVarIntLen = $d1BPf.encodingLength(valLen);
    var buffer = $821652fe792a76d8$require$Buffer.allocUnsafe(keyVarIntLen + keyLen + valVarIntLen + valLen);
    $d1BPf.encode(keyLen, buffer, 0);
    keyVal.key.copy(buffer, keyVarIntLen);
    $d1BPf.encode(valLen, buffer, keyVarIntLen + keyLen);
    keyVal.value.copy(buffer, keyVarIntLen + keyLen + valVarIntLen);
    return buffer;
}
module.exports.keyValToBuffer = $821652fe792a76d8$var$keyValToBuffer;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $821652fe792a76d8$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $821652fe792a76d8$var$readUInt64LE(buffer, offset) {
    var a = buffer.readUInt32LE(offset);
    var b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $821652fe792a76d8$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $821652fe792a76d8$var$readUInt64LE;
function $821652fe792a76d8$var$writeUInt64LE(buffer, value, offset) {
    $821652fe792a76d8$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $821652fe792a76d8$var$writeUInt64LE;

});
parcelRegister("d1BPf", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $97b8b5b4db4afa15$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Number.MAX_SAFE_INTEGER
var $97b8b5b4db4afa15$var$MAX_SAFE_INTEGER = 9007199254740991;
function $97b8b5b4db4afa15$var$checkUInt53(n) {
    if (n < 0 || n > $97b8b5b4db4afa15$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $97b8b5b4db4afa15$var$encode(_number, buffer, offset) {
    $97b8b5b4db4afa15$var$checkUInt53(_number);
    if (!buffer) buffer = $97b8b5b4db4afa15$require$Buffer.allocUnsafe($97b8b5b4db4afa15$var$encodingLength(_number));
    if (!$97b8b5b4db4afa15$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (_number < 0xfd) {
        buffer.writeUInt8(_number, offset);
        Object.assign($97b8b5b4db4afa15$var$encode, {
            bytes: 1
        });
    // 16 bit
    } else if (_number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(_number, offset + 1);
        Object.assign($97b8b5b4db4afa15$var$encode, {
            bytes: 3
        });
    // 32 bit
    } else if (_number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(_number, offset + 1);
        Object.assign($97b8b5b4db4afa15$var$encode, {
            bytes: 5
        });
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(_number >>> 0, offset + 1);
        buffer.writeUInt32LE(_number / 0x100000000 | 0, offset + 5);
        Object.assign($97b8b5b4db4afa15$var$encode, {
            bytes: 9
        });
    }
    return buffer;
}
module.exports.encode = $97b8b5b4db4afa15$var$encode;
function $97b8b5b4db4afa15$var$decode(buffer, offset) {
    if (!$97b8b5b4db4afa15$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    var first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        Object.assign($97b8b5b4db4afa15$var$decode, {
            bytes: 1
        });
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        Object.assign($97b8b5b4db4afa15$var$decode, {
            bytes: 3
        });
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        Object.assign($97b8b5b4db4afa15$var$decode, {
            bytes: 5
        });
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        Object.assign($97b8b5b4db4afa15$var$decode, {
            bytes: 9
        });
        var lo = buffer.readUInt32LE(offset + 1);
        var hi = buffer.readUInt32LE(offset + 5);
        var _number = hi * 0x0100000000 + lo;
        $97b8b5b4db4afa15$var$checkUInt53(_number);
        return _number;
    }
}
module.exports.decode = $97b8b5b4db4afa15$var$decode;
function $97b8b5b4db4afa15$var$encodingLength(_number) {
    $97b8b5b4db4afa15$var$checkUInt53(_number);
    return _number < 0xfd ? 1 : _number <= 0xffff ? 3 : _number <= 0xffffffff ? 5 : 9;
}
module.exports.encodingLength = $97b8b5b4db4afa15$var$encodingLength;

});



parcelRegister("lEzL7", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $fc39126359c5f5c5$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUuQV = parcelRequire("iUuQV");

var $d1BPf = parcelRequire("d1BPf");
function $fc39126359c5f5c5$var$decode(keyVal) {
    if (keyVal.key[0] !== $iUuQV.OutputTypes.TAP_TREE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapTree with key 0x" + keyVal.key.toString("hex"));
    var _offset = 0;
    var data = [];
    while(_offset < keyVal.value.length){
        var depth = keyVal.value[_offset++];
        var leafVersion = keyVal.value[_offset++];
        var scriptLen = $d1BPf.decode(keyVal.value, _offset);
        _offset += $d1BPf.encodingLength(scriptLen);
        data.push({
            depth: depth,
            leafVersion: leafVersion,
            script: keyVal.value.slice(_offset, _offset + scriptLen)
        });
        _offset += scriptLen;
    }
    return {
        leaves: data
    };
}
module.exports.decode = $fc39126359c5f5c5$var$decode;
function $fc39126359c5f5c5$var$encode(tree) {
    var _instance;
    var key = $fc39126359c5f5c5$require$Buffer.from([
        $iUuQV.OutputTypes.TAP_TREE
    ]);
    var bufs = (_instance = []).concat.apply(_instance, (0, $gF0bR._)(tree.leaves.map(function(tapLeaf) {
        return [
            $fc39126359c5f5c5$require$Buffer.of(tapLeaf.depth, tapLeaf.leafVersion),
            $d1BPf.encode(tapLeaf.script.length),
            tapLeaf.script
        ];
    })));
    return {
        key: key,
        value: $fc39126359c5f5c5$require$Buffer.concat(bufs)
    };
}
module.exports.encode = $fc39126359c5f5c5$var$encode;
module.exports.expected = "{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }";
function $fc39126359c5f5c5$var$check(data) {
    return Array.isArray(data.leaves) && data.leaves.every(function(tapLeaf) {
        return tapLeaf.depth >= 0 && tapLeaf.depth <= 128 && (tapLeaf.leafVersion & 0xfe) === tapLeaf.leafVersion && $fc39126359c5f5c5$require$Buffer.isBuffer(tapLeaf.script);
    });
}
module.exports.check = $fc39126359c5f5c5$var$check;
function $fc39126359c5f5c5$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapTree === undefined;
}
module.exports.canAdd = $fc39126359c5f5c5$var$canAdd;

});

parcelRegister("fOMCa", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $b8413c5b2d1126d2$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b8413c5b2d1126d2$var$range = function(n) {
    return (0, $gF0bR._)(Array(n).keys());
};
var $b8413c5b2d1126d2$var$isValidDERKey = function(pubkey) {
    return pubkey.length === 33 && [
        2,
        3
    ].includes(pubkey[0]) || pubkey.length === 65 && 4 === pubkey[0];
};
function $b8413c5b2d1126d2$var$makeConverter(TYPE_BYTE) {
    var isValidPubkey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b8413c5b2d1126d2$var$isValidDERKey;
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode bip32Derivation with key 0x" + keyVal.key.toString("hex"));
        var pubkey = keyVal.key.slice(1);
        if (!isValidPubkey(pubkey)) throw new Error("Decode Error: bip32Derivation has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Input BIP32_DERIVATION value length should be multiple of 4");
        var data = {
            masterFingerprint: keyVal.value.slice(0, 4),
            pubkey: pubkey,
            path: "m"
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $b8413c5b2d1126d2$var$range(keyVal.value.length / 4 - 1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                var val = keyVal.value.readUInt32LE(i * 4 + 4);
                var isHard = !!(val & 0x80000000);
                var idx = val & 0x7fffffff;
                data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return data;
    }
    function encode(data) {
        var head = $b8413c5b2d1126d2$require$Buffer.from([
            TYPE_BYTE
        ]);
        var key = $b8413c5b2d1126d2$require$Buffer.concat([
            head,
            data.pubkey
        ]);
        var splitPath = data.path.split("/");
        var value = $b8413c5b2d1126d2$require$Buffer.allocUnsafe(splitPath.length * 4);
        data.masterFingerprint.copy(value, 0);
        var offset = 4;
        splitPath.slice(1).forEach(function(level) {
            var isHard = level.slice(-1) === "'";
            var num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
            if (isHard) num += 0x80000000;
            value.writeUInt32LE(num, offset);
            offset += 4;
        });
        return {
            key: key,
            value: value
        };
    }
    var expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }";
    function check(data) {
        return $b8413c5b2d1126d2$require$Buffer.isBuffer(data.pubkey) && $b8413c5b2d1126d2$require$Buffer.isBuffer(data.masterFingerprint) && typeof data.path === "string" && isValidPubkey(data.pubkey) && data.masterFingerprint.length === 4;
    }
    function canAddToArray(array, item, dupeSet) {
        var dupeString = item.pubkey.toString("hex");
        if (dupeSet.has(dupeString)) return false;
        dupeSet.add(dupeString);
        return array.filter(function(v) {
            return v.pubkey.equals(item.pubkey);
        }).length === 0;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: canAddToArray
    };
}
module.exports.makeConverter = $b8413c5b2d1126d2$var$makeConverter;

});

parcelRegister("JRjHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $089d8fab7ca41421$var$makeChecker(pubkeyTypes) {
    return checkPubkey;
    function checkPubkey(keyVal) {
        var pubkey;
        if (pubkeyTypes.includes(keyVal.key[0])) {
            pubkey = keyVal.key.slice(1);
            if (!(pubkey.length === 33 || pubkey.length === 65) || ![
                2,
                3,
                4
            ].includes(pubkey[0])) throw new Error("Format Error: invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        }
        return pubkey;
    }
}
module.exports.makeChecker = $089d8fab7ca41421$var$makeChecker;

});

parcelRegister("jA5Og", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $e415e2c84faab66c$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $e415e2c84faab66c$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode redeemScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        var key = $e415e2c84faab66c$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    var expected = "Buffer";
    function check(data) {
        return $e415e2c84faab66c$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.redeemScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $e415e2c84faab66c$var$makeConverter;

});

parcelRegister("hmx7W", function(module, exports) {

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $ca3e30173087c1bf$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d1BPf = parcelRequire("d1BPf");

var $fOMCa = parcelRequire("fOMCa");
var $ca3e30173087c1bf$var$isValidBIP340Key = function(pubkey) {
    return pubkey.length === 32;
};
function $ca3e30173087c1bf$var$makeConverter(TYPE_BYTE) {
    var parent = $fOMCa.makeConverter(TYPE_BYTE, $ca3e30173087c1bf$var$isValidBIP340Key);
    function decode(keyVal) {
        var nHashes = $d1BPf.decode(keyVal.value);
        var nHashesLen = $d1BPf.encodingLength(nHashes);
        var base = parent.decode({
            key: keyVal.key,
            value: keyVal.value.slice(nHashesLen + nHashes * 32)
        });
        var leafHashes = new Array(nHashes);
        for(var i = 0, _offset = nHashesLen; i < nHashes; i++, _offset += 32)leafHashes[i] = keyVal.value.slice(_offset, _offset + 32);
        return Object.assign({}, base, {
            leafHashes: leafHashes
        });
    }
    function encode(data) {
        var base = parent.encode(data);
        var nHashesLen = $d1BPf.encodingLength(data.leafHashes.length);
        var nHashesBuf = $ca3e30173087c1bf$require$Buffer.allocUnsafe(nHashesLen);
        $d1BPf.encode(data.leafHashes.length, nHashesBuf);
        var value = $ca3e30173087c1bf$require$Buffer.concat([
            nHashesBuf
        ].concat((0, $gF0bR._)(data.leafHashes), [
            base.value
        ]));
        return Object.assign({}, base, {
            value: value
        });
    }
    var expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
    function check(data) {
        return Array.isArray(data.leafHashes) && data.leafHashes.every(function(leafHash) {
            return $ca3e30173087c1bf$require$Buffer.isBuffer(leafHash) && leafHash.length === 32;
        }) && parent.check(data);
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: parent.canAddToArray
    };
}
module.exports.makeConverter = $ca3e30173087c1bf$var$makeConverter;

});

parcelRegister("jqCmy", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $e24e3417a41ca30f$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $e24e3417a41ca30f$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapInternalKey with key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length !== 32) throw new Error("Decode Error: tapInternalKey not a 32-byte x-only pubkey");
        return keyVal.value;
    }
    function encode(value) {
        var key = $e24e3417a41ca30f$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: value
        };
    }
    var expected = "Buffer";
    function check(data) {
        return $e24e3417a41ca30f$require$Buffer.isBuffer(data) && data.length === 32;
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.tapInternalKey === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $e24e3417a41ca30f$var$makeConverter;

});

parcelRegister("kweOW", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $ef024adc221545f5$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ef024adc221545f5$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode witnessScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        var key = $ef024adc221545f5$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    var expected = "Buffer";
    function check(data) {
        return $ef024adc221545f5$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.witnessScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $ef024adc221545f5$var$makeConverter;

});



parcelRegister("2D2Ay", function(module, exports) {

var $5OlIx = parcelRequire("5OlIx");

var $ilnag = parcelRequire("ilnag");
var $1ea13b51ade7e92e$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXO7v = parcelRequire("lXO7v");

var $barY9 = parcelRequire("barY9");
function $1ea13b51ade7e92e$var$psbtToBuffer(param) {
    var globalMap = param.globalMap, inputs = param.inputs, outputs = param.outputs;
    var _psbtToKeyVals = $1ea13b51ade7e92e$var$psbtToKeyVals({
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    }), globalKeyVals = _psbtToKeyVals.globalKeyVals, inputKeyVals = _psbtToKeyVals.inputKeyVals, outputKeyVals = _psbtToKeyVals.outputKeyVals;
    var globalBuffer = $barY9.keyValsToBuffer(globalKeyVals);
    var keyValsOrEmptyToBuffer = function(keyVals) {
        return keyVals.length === 0 ? [
            $1ea13b51ade7e92e$require$Buffer.from([
                0
            ])
        ] : keyVals.map($barY9.keyValsToBuffer);
    };
    var inputBuffers = keyValsOrEmptyToBuffer(inputKeyVals);
    var outputBuffers = keyValsOrEmptyToBuffer(outputKeyVals);
    var header = $1ea13b51ade7e92e$require$Buffer.allocUnsafe(5);
    header.writeUIntBE(0x70736274ff, 0, 5);
    return $1ea13b51ade7e92e$require$Buffer.concat([
        header,
        globalBuffer
    ].concat(inputBuffers, outputBuffers));
}
module.exports.psbtToBuffer = $1ea13b51ade7e92e$var$psbtToBuffer;
var $1ea13b51ade7e92e$var$sortKeyVals = function(a, b) {
    return a.key.compare(b.key);
};
function $1ea13b51ade7e92e$var$keyValsFromMap(keyValMap, converterFactory) {
    var keyHexSet = new Set();
    var keyVals = Object.entries(keyValMap).reduce(function(result, param) {
        var _param = (0, $5OlIx._)(param, 2), key = _param[0], value = _param[1];
        if (key === "unknownKeyVals") return result;
        // We are checking for undefined anyways. So ignore TS error
        // @ts-ignore
        var converter = converterFactory[key];
        if (converter === undefined) return result;
        var encodedKeyVals = (Array.isArray(value) ? value : [
            value
        ]).map(converter.encode);
        var keyHexes = encodedKeyVals.map(function(kv) {
            return kv.key.toString("hex");
        });
        keyHexes.forEach(function(hex) {
            if (keyHexSet.has(hex)) throw new Error("Serialize Error: Duplicate key: " + hex);
            keyHexSet.add(hex);
        });
        return result.concat(encodedKeyVals);
    }, []);
    // Get other keyVals that have not yet been gotten
    var otherKeyVals = keyValMap.unknownKeyVals ? keyValMap.unknownKeyVals.filter(function(keyVal) {
        return !keyHexSet.has(keyVal.key.toString("hex"));
    }) : [];
    return keyVals.concat(otherKeyVals).sort($1ea13b51ade7e92e$var$sortKeyVals);
}
function $1ea13b51ade7e92e$var$psbtToKeyVals(param) {
    var globalMap = param.globalMap, inputs = param.inputs, outputs = param.outputs;
    // First parse the global keyVals
    // Get any extra keyvals to pass along
    return {
        globalKeyVals: $1ea13b51ade7e92e$var$keyValsFromMap(globalMap, $lXO7v.globals),
        inputKeyVals: inputs.map(function(i) {
            return $1ea13b51ade7e92e$var$keyValsFromMap(i, $lXO7v.inputs);
        }),
        outputKeyVals: outputs.map(function(o) {
            return $1ea13b51ade7e92e$var$keyValsFromMap(o, $lXO7v.outputs);
        })
    };
}
module.exports.psbtToKeyVals = $1ea13b51ade7e92e$var$psbtToKeyVals;

});

parcelRegister("hSLu6", function(module, exports) {
"use strict";
var $d04c50400640a34c$var$__defProp = Object.defineProperty;
var $d04c50400640a34c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d04c50400640a34c$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d04c50400640a34c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d04c50400640a34c$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$d04c50400640a34c$var$__hasOwnProp.call(to, key) && key !== except) $d04c50400640a34c$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $d04c50400640a34c$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $d04c50400640a34c$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $d04c50400640a34c$var$__toCommonJS = function(mod) {
    return $d04c50400640a34c$var$__copyProps($d04c50400640a34c$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $d04c50400640a34c$var$types_exports = {};
module.exports = $d04c50400640a34c$var$__toCommonJS($d04c50400640a34c$var$types_exports);

});

parcelRegister("hr76e", function(module, exports) {
"use strict";
module.exports = $cb1a771fc6c5952f$var$API;

var $frfEn = parcelRequire("frfEn");
// Feature detection (yes really)
var $cb1a771fc6c5952f$var$isBrowser = typeof navigator !== "undefined" && !!navigator.userAgent;
var $cb1a771fc6c5952f$var$isSafari = $cb1a771fc6c5952f$var$isBrowser && navigator.userAgent.match(/Safari\//) && !navigator.userAgent.match(/Chrome\//);
var $cb1a771fc6c5952f$var$isEDGE = $cb1a771fc6c5952f$var$isBrowser && navigator.userAgent.match(/Edge\/1[2345]/);
var $cb1a771fc6c5952f$var$_backend = null;
function $cb1a771fc6c5952f$var$getBackend(Promise) {
    if (!$cb1a771fc6c5952f$var$_backend) $cb1a771fc6c5952f$var$_backend = new Promise(function(resolve, reject) {
        function notSupported() {
            // Note; {native: true} means *not* using Google's hack
            resolve({
                u2f: null,
                native: true
            });
        }
        if (!$cb1a771fc6c5952f$var$isBrowser) return notSupported();
        if ($cb1a771fc6c5952f$var$isSafari) // Safari doesn't support U2F, and the Safari-FIDO-U2F
        // extension lacks full support (Multi-facet apps), so we
        // block it until proper support.
        return notSupported();
        var hasNativeSupport = typeof window.u2f !== "undefined" && typeof window.u2f.sign === "function";
        if (hasNativeSupport) resolve({
            u2f: window.u2f,
            native: true
        });
        if ($cb1a771fc6c5952f$var$isEDGE) // We don't want to check for Google's extension hack on EDGE
        // as it'll cause trouble (popups, etc)
        return notSupported();
        if (location.protocol === "http:") // U2F isn't supported over http, only https
        return notSupported();
        if (typeof MessageChannel === "undefined") // Unsupported browser, the chrome hack would throw
        return notSupported();
        // Test for google extension support
        $frfEn.isSupported(function(ok) {
            if (ok) resolve({
                u2f: $frfEn,
                native: false
            });
            else notSupported();
        });
    });
    return $cb1a771fc6c5952f$var$_backend;
}
function $cb1a771fc6c5952f$var$API(Promise) {
    return {
        isSupported: $cb1a771fc6c5952f$var$isSupported.bind(Promise),
        ensureSupport: $cb1a771fc6c5952f$var$ensureSupport.bind(Promise),
        register: $cb1a771fc6c5952f$var$register.bind(Promise),
        sign: $cb1a771fc6c5952f$var$sign.bind(Promise),
        ErrorCodes: $cb1a771fc6c5952f$var$API.ErrorCodes,
        ErrorNames: $cb1a771fc6c5952f$var$API.ErrorNames
    };
}
$cb1a771fc6c5952f$var$API.ErrorCodes = {
    CANCELLED: -1,
    OK: 0,
    OTHER_ERROR: 1,
    BAD_REQUEST: 2,
    CONFIGURATION_UNSUPPORTED: 3,
    DEVICE_INELIGIBLE: 4,
    TIMEOUT: 5
};
$cb1a771fc6c5952f$var$API.ErrorNames = {
    "-1": "CANCELLED",
    "0": "OK",
    "1": "OTHER_ERROR",
    "2": "BAD_REQUEST",
    "3": "CONFIGURATION_UNSUPPORTED",
    "4": "DEVICE_INELIGIBLE",
    "5": "TIMEOUT"
};
function $cb1a771fc6c5952f$var$makeError(msg, err) {
    var code = err != null ? err.errorCode : 1; // Default to OTHER_ERROR
    var type = $cb1a771fc6c5952f$var$API.ErrorNames["" + code];
    var error = new Error(msg);
    error.metaData = {
        type: type,
        code: code
    };
    return error;
}
function $cb1a771fc6c5952f$var$deferPromise(Promise, promise) {
    var ret = {};
    ret.promise = new Promise(function(resolve, reject) {
        ret.resolve = resolve;
        ret.reject = reject;
        promise.then(resolve, reject);
    });
    /**
	 * Reject request promise and disconnect port if 'disconnect' flag is true
	 * @param {string} msg
	 * @param {boolean} disconnect
	 */ ret.promise.cancel = function(msg, disconnect) {
        $cb1a771fc6c5952f$var$getBackend(Promise).then(function(backend) {
            if (disconnect && !backend.native) backend.u2f.disconnect();
            ret.reject($cb1a771fc6c5952f$var$makeError(msg, {
                errorCode: -1
            }));
        });
    };
    return ret;
}
function $cb1a771fc6c5952f$var$defer(Promise, fun) {
    return $cb1a771fc6c5952f$var$deferPromise(Promise, new Promise(function(resolve, reject) {
        try {
            fun && fun(resolve, reject);
        } catch (err) {
            reject(err);
        }
    }));
}
function $cb1a771fc6c5952f$var$isSupported() {
    var Promise = this;
    return $cb1a771fc6c5952f$var$getBackend(Promise).then(function(backend) {
        return !!backend.u2f;
    });
}
function $cb1a771fc6c5952f$var$_ensureSupport(backend) {
    if (!backend.u2f) {
        if (location.protocol === "http:") throw new Error("U2F isn't supported over http, only https");
        throw new Error("U2F not supported");
    }
}
function $cb1a771fc6c5952f$var$ensureSupport() {
    var Promise = this;
    return $cb1a771fc6c5952f$var$getBackend(Promise).then($cb1a771fc6c5952f$var$_ensureSupport);
}
function $cb1a771fc6c5952f$var$register(registerRequests, signRequests /* = null */ , timeout) {
    var Promise = this;
    if (!Array.isArray(registerRequests)) registerRequests = [
        registerRequests
    ];
    if (typeof signRequests === "number" && typeof timeout === "undefined") {
        timeout = signRequests;
        signRequests = null;
    }
    if (!signRequests) signRequests = [];
    return $cb1a771fc6c5952f$var$deferPromise(Promise, $cb1a771fc6c5952f$var$getBackend(Promise).then(function(backend) {
        $cb1a771fc6c5952f$var$_ensureSupport(backend);
        var native = backend.native;
        var u2f = backend.u2f;
        return new Promise(function(resolve, reject) {
            function cbNative(response) {
                if (response.errorCode) reject($cb1a771fc6c5952f$var$makeError("Registration failed", response));
                else {
                    delete response.errorCode;
                    resolve(response);
                }
            }
            function cbChrome(err, response) {
                if (err) reject(err);
                else if (response.errorCode) reject($cb1a771fc6c5952f$var$makeError("Registration failed", response));
                else resolve(response);
            }
            if (native) {
                var appId = registerRequests[0].appId;
                u2f.register(appId, registerRequests, signRequests, cbNative, timeout);
            } else u2f.register(registerRequests, signRequests, cbChrome, timeout);
        });
    })).promise;
}
function $cb1a771fc6c5952f$var$sign(signRequests, timeout) {
    var Promise = this;
    if (!Array.isArray(signRequests)) signRequests = [
        signRequests
    ];
    return $cb1a771fc6c5952f$var$deferPromise(Promise, $cb1a771fc6c5952f$var$getBackend(Promise).then(function(backend) {
        $cb1a771fc6c5952f$var$_ensureSupport(backend);
        var native = backend.native;
        var u2f = backend.u2f;
        return new Promise(function(resolve, reject) {
            function cbNative(response) {
                if (response.errorCode) reject($cb1a771fc6c5952f$var$makeError("Sign failed", response));
                else {
                    delete response.errorCode;
                    resolve(response);
                }
            }
            function cbChrome(err, response) {
                if (err) reject(err);
                else if (response.errorCode) reject($cb1a771fc6c5952f$var$makeError("Sign failed", response));
                else resolve(response);
            }
            if (native) {
                var appId = signRequests[0].appId;
                var challenge = signRequests[0].challenge;
                u2f.sign(appId, challenge, signRequests, cbNative, timeout);
            } else u2f.sign(signRequests, cbChrome, timeout);
        });
    })).promise;
}
function $cb1a771fc6c5952f$var$makeDefault(func) {
    $cb1a771fc6c5952f$var$API[func] = function() {
        if (!$parcel$global.Promise) // This is very unlikely to ever happen, since browsers
        // supporting U2F will most likely support Promises.
        throw new Error("The platform doesn't natively support promises");
        var args = [].slice.call(arguments);
        return $cb1a771fc6c5952f$var$API($parcel$global.Promise)[func].apply(null, args);
    };
}
// Provide default functions using the built-in Promise if available.
$cb1a771fc6c5952f$var$makeDefault("isSupported");
$cb1a771fc6c5952f$var$makeDefault("ensureSupport");
$cb1a771fc6c5952f$var$makeDefault("register");
$cb1a771fc6c5952f$var$makeDefault("sign");

});
parcelRegister("frfEn", function(module, exports) {
// Copyright 2014 Google Inc. All rights reserved
//
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file or at
// https://developers.google.com/open-source/licenses/bsd
/**
 * @fileoverview The U2F api.
 */ "use strict";
/** Namespace for the U2F api.
 * @type {Object}
 */ var $b3d58473fece0170$var$u2f = $b3d58473fece0170$var$u2f || {};
module.exports = $b3d58473fece0170$var$u2f; // Adaptation for u2f-api package
/**
 * The U2F extension id
 * @type {string}
 * @const
 */ $b3d58473fece0170$var$u2f.EXTENSION_ID = "kmendfapggjehodndflmmgagdbamhnfd";
/**
 * Message types for messsages to/from the extension
 * @const
 * @enum {string}
 */ $b3d58473fece0170$var$u2f.MessageTypes = {
    "U2F_REGISTER_REQUEST": "u2f_register_request",
    "U2F_SIGN_REQUEST": "u2f_sign_request",
    "U2F_REGISTER_RESPONSE": "u2f_register_response",
    "U2F_SIGN_RESPONSE": "u2f_sign_response"
};
/**
 * Response status codes
 * @const
 * @enum {number}
 */ $b3d58473fece0170$var$u2f.ErrorCodes = {
    "OK": 0,
    "OTHER_ERROR": 1,
    "BAD_REQUEST": 2,
    "CONFIGURATION_UNSUPPORTED": 3,
    "DEVICE_INELIGIBLE": 4,
    "TIMEOUT": 5
};
/**
 * A message type for registration requests
 * @typedef {{
 *   type: u2f.MessageTypes,
 *   signRequests: Array.<u2f.SignRequest>,
 *   registerRequests: ?Array.<u2f.RegisterRequest>,
 *   timeoutSeconds: ?number,
 *   requestId: ?number
 * }}
 */ $b3d58473fece0170$var$u2f.Request;
/**
 * A message for registration responses
 * @typedef {{
 *   type: u2f.MessageTypes,
 *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
 *   requestId: ?number
 * }}
 */ $b3d58473fece0170$var$u2f.Response;
/**
 * An error object for responses
 * @typedef {{
 *   errorCode: u2f.ErrorCodes,
 *   errorMessage: ?string
 * }}
 */ $b3d58473fece0170$var$u2f.Error;
/**
 * Data object for a single sign request.
 * @typedef {{
 *   version: string,
 *   challenge: string,
 *   keyHandle: string,
 *   appId: string
 * }}
 */ $b3d58473fece0170$var$u2f.SignRequest;
/**
 * Data object for a sign response.
 * @typedef {{
 *   keyHandle: string,
 *   signatureData: string,
 *   clientData: string
 * }}
 */ $b3d58473fece0170$var$u2f.SignResponse;
/**
 * Data object for a registration request.
 * @typedef {{
 *   version: string,
 *   challenge: string,
 *   appId: string
 * }}
 */ $b3d58473fece0170$var$u2f.RegisterRequest;
/**
 * Data object for a registration response.
 * @typedef {{
 *   registrationData: string,
 *   clientData: string
 * }}
 */ $b3d58473fece0170$var$u2f.RegisterResponse;
// Low level MessagePort API support
/**
 * Call MessagePort disconnect
 */ $b3d58473fece0170$var$u2f.disconnect = function() {
    if ($b3d58473fece0170$var$u2f.port_ && $b3d58473fece0170$var$u2f.port_.port_) {
        $b3d58473fece0170$var$u2f.port_.port_.disconnect();
        $b3d58473fece0170$var$u2f.port_ = null;
    }
};
/**
 * Sets up a MessagePort to the U2F extension using the
 * available mechanisms.
 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
 */ $b3d58473fece0170$var$u2f.getMessagePort = function(callback) {
    if (typeof chrome != "undefined" && chrome.runtime) {
        // The actual message here does not matter, but we need to get a reply
        // for the callback to run. Thus, send an empty signature request
        // in order to get a failure response.
        var msg = {
            type: $b3d58473fece0170$var$u2f.MessageTypes.U2F_SIGN_REQUEST,
            signRequests: []
        };
        chrome.runtime.sendMessage($b3d58473fece0170$var$u2f.EXTENSION_ID, msg, function() {
            if (!chrome.runtime.lastError) // We are on a whitelisted origin and can talk directly
            // with the extension.
            $b3d58473fece0170$var$u2f.getChromeRuntimePort_(callback);
            else // chrome.runtime was available, but we couldn't message
            // the extension directly, use iframe
            $b3d58473fece0170$var$u2f.getIframePort_(callback);
        });
    } else // chrome.runtime was not available at all, which is normal
    // when this origin doesn't have access to any extensions.
    $b3d58473fece0170$var$u2f.getIframePort_(callback);
};
/**
 * Connects directly to the extension via chrome.runtime.connect
 * @param {function(u2f.WrappedChromeRuntimePort_)} callback
 * @private
 */ $b3d58473fece0170$var$u2f.getChromeRuntimePort_ = function(callback) {
    var port = chrome.runtime.connect($b3d58473fece0170$var$u2f.EXTENSION_ID, {
        "includeTlsChannelId": true
    });
    setTimeout(function() {
        callback(null, new $b3d58473fece0170$var$u2f.WrappedChromeRuntimePort_(port));
    }, 0);
};
/**
 * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
 * @param {Port} port
 * @constructor
 * @private
 */ $b3d58473fece0170$var$u2f.WrappedChromeRuntimePort_ = function(port) {
    this.port_ = port;
};
/**
 * Posts a message on the underlying channel.
 * @param {Object} message
 */ $b3d58473fece0170$var$u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
    this.port_.postMessage(message);
};
/**
 * Emulates the HTML 5 addEventListener interface. Works only for the
 * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
 * @param {string} eventName
 * @param {function({data: Object})} handler
 */ $b3d58473fece0170$var$u2f.WrappedChromeRuntimePort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == "message" || name == "onmessage") this.port_.onMessage.addListener(function(message) {
        // Emulate a minimal MessageEvent object
        handler({
            "data": message
        });
    });
    else console.error("WrappedChromeRuntimePort only supports onMessage");
};
/**
 * Sets up an embedded trampoline iframe, sourced from the extension.
 * @param {function(MessagePort)} callback
 * @private
 */ $b3d58473fece0170$var$u2f.getIframePort_ = function(callback) {
    // Create the iframe
    var iframeOrigin = "chrome-extension://" + $b3d58473fece0170$var$u2f.EXTENSION_ID;
    var iframe = document.createElement("iframe");
    iframe.src = iframeOrigin + "/u2f-comms.html";
    iframe.setAttribute("style", "display:none");
    document.body.appendChild(iframe);
    var hasCalledBack = false;
    var channel = new MessageChannel();
    var ready = function ready1(message) {
        if (message.data == "ready") {
            channel.port1.removeEventListener("message", ready);
            if (!hasCalledBack) {
                hasCalledBack = true;
                callback(null, channel.port1);
            }
        } else console.error('First event on iframe port was not "ready"');
    };
    channel.port1.addEventListener("message", ready);
    channel.port1.start();
    iframe.addEventListener("load", function() {
        // Deliver the port to the iframe and initialize
        iframe.contentWindow.postMessage("init", iframeOrigin, [
            channel.port2
        ]);
    });
    // Give this 200ms to initialize, after that, we treat this method as failed
    setTimeout(function() {
        if (!hasCalledBack) {
            hasCalledBack = true;
            callback(new Error("IFrame extension not supported"));
        }
    }, 200);
};
// High-level JS API
/**
 * Default extension response timeout in seconds.
 * @const
 */ $b3d58473fece0170$var$u2f.EXTENSION_TIMEOUT_SEC = 30;
/**
 * A singleton instance for a MessagePort to the extension.
 * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
 * @private
 */ $b3d58473fece0170$var$u2f.port_ = null;
/**
 * Callbacks waiting for a port
 * @type {Array.<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
 * @private
 */ $b3d58473fece0170$var$u2f.waitingForPort_ = [];
/**
 * A counter for requestIds.
 * @type {number}
 * @private
 */ $b3d58473fece0170$var$u2f.reqCounter_ = 0;
/**
 * A map from requestIds to client callbacks
 * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
 *                       |function((u2f.Error|u2f.SignResponse)))>}
 * @private
 */ $b3d58473fece0170$var$u2f.callbackMap_ = {};
/**
 * Creates or retrieves the MessagePort singleton to use.
 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
 * @private
 */ $b3d58473fece0170$var$u2f.getPortSingleton_ = function(callback) {
    if ($b3d58473fece0170$var$u2f.port_) callback(null, $b3d58473fece0170$var$u2f.port_);
    else {
        if ($b3d58473fece0170$var$u2f.waitingForPort_.length == 0) $b3d58473fece0170$var$u2f.getMessagePort(function(err, port) {
            if (!err) {
                $b3d58473fece0170$var$u2f.port_ = port;
                $b3d58473fece0170$var$u2f.port_.addEventListener("message", /** @type {function(Event)} */ $b3d58473fece0170$var$u2f.responseHandler_);
            }
            // Careful, here be async callbacks. Maybe.
            while($b3d58473fece0170$var$u2f.waitingForPort_.length)$b3d58473fece0170$var$u2f.waitingForPort_.shift()(err, port);
        });
        $b3d58473fece0170$var$u2f.waitingForPort_.push(callback);
    }
};
/**
 * Handles response messages from the extension.
 * @param {MessageEvent.<u2f.Response>} message
 * @private
 */ $b3d58473fece0170$var$u2f.responseHandler_ = function(message) {
    var response = message.data;
    var reqId = response["requestId"];
    if (!reqId || !$b3d58473fece0170$var$u2f.callbackMap_[reqId]) {
        console.error("Unknown or missing requestId in response.");
        return;
    }
    var cb = $b3d58473fece0170$var$u2f.callbackMap_[reqId];
    delete $b3d58473fece0170$var$u2f.callbackMap_[reqId];
    cb(null, response["responseData"]);
};
/**
 * Calls the callback with true or false as first and only argument
 * @param {Function} callback
 */ $b3d58473fece0170$var$u2f.isSupported = function(callback) {
    $b3d58473fece0170$var$u2f.getPortSingleton_(function(err, port) {
        callback(!err);
    });
};
/**
 * Dispatches an array of sign requests to available U2F tokens.
 * @param {Array.<u2f.SignRequest>} signRequests
 * @param {function((u2f.Error|u2f.SignResponse))} callback
 * @param {number=} opt_timeoutSeconds
 */ $b3d58473fece0170$var$u2f.sign = function(signRequests, callback, opt_timeoutSeconds) {
    $b3d58473fece0170$var$u2f.getPortSingleton_(function(err, port) {
        if (err) return callback(err);
        var reqId = ++$b3d58473fece0170$var$u2f.reqCounter_;
        $b3d58473fece0170$var$u2f.callbackMap_[reqId] = callback;
        var req = {
            type: $b3d58473fece0170$var$u2f.MessageTypes.U2F_SIGN_REQUEST,
            signRequests: signRequests,
            timeoutSeconds: typeof opt_timeoutSeconds !== "undefined" ? opt_timeoutSeconds : $b3d58473fece0170$var$u2f.EXTENSION_TIMEOUT_SEC,
            requestId: reqId
        };
        port.postMessage(req);
    });
};
/**
 * Dispatches register requests to available U2F tokens. An array of sign
 * requests identifies already registered tokens.
 * @param {Array.<u2f.RegisterRequest>} registerRequests
 * @param {Array.<u2f.SignRequest>} signRequests
 * @param {function((u2f.Error|u2f.RegisterResponse))} callback
 * @param {number=} opt_timeoutSeconds
 */ $b3d58473fece0170$var$u2f.register = function(registerRequests, signRequests, callback, opt_timeoutSeconds) {
    $b3d58473fece0170$var$u2f.getPortSingleton_(function(err, port) {
        if (err) return callback(err);
        var reqId = ++$b3d58473fece0170$var$u2f.reqCounter_;
        $b3d58473fece0170$var$u2f.callbackMap_[reqId] = callback;
        var req = {
            type: $b3d58473fece0170$var$u2f.MessageTypes.U2F_REGISTER_REQUEST,
            signRequests: signRequests,
            registerRequests: registerRequests,
            timeoutSeconds: typeof opt_timeoutSeconds !== "undefined" ? opt_timeoutSeconds : $b3d58473fece0170$var$u2f.EXTENSION_TIMEOUT_SEC,
            requestId: reqId
        };
        port.postMessage(req);
    });
};

});


parcelRegister("ib1AC", function(module, exports) {

var $58Fx4 = parcelRequire("58Fx4");
var $d3ba7cbf82760325$require$MAX_SAFE_COMPONENT_LENGTH = $58Fx4.MAX_SAFE_COMPONENT_LENGTH;

var $eF215 = parcelRequire("eF215");
exports = module.exports = {};
// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var t = exports.t = {};
var R = 0;
var createToken = function(name, value, isGlobal) {
    var index = R++;
    $eF215(index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "[0-9]+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*");
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIER], ")"));
createToken("MAINVERSIONLOOSE", "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(src[t.NUMERICIDENTIFIERLOOSE], ")"));
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", "(?:".concat(src[t.NUMERICIDENTIFIER], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
createToken("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(src[t.NUMERICIDENTIFIERLOOSE], "|").concat(src[t.NONNUMERICIDENTIFIER], ")"));
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", "(?:-(".concat(src[t.PRERELEASEIDENTIFIER], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIER], ")*))"));
createToken("PRERELEASELOOSE", "(?:-?(".concat(src[t.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(src[t.PRERELEASEIDENTIFIERLOOSE], ")*))"));
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", "[0-9A-Za-z-]+");
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", "(?:\\+(".concat(src[t.BUILDIDENTIFIER], "(?:\\.").concat(src[t.BUILDIDENTIFIER], ")*))"));
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", "v?".concat(src[t.MAINVERSION]).concat(src[t.PRERELEASE], "?").concat(src[t.BUILD], "?"));
createToken("FULL", "^".concat(src[t.FULLPLAIN], "$"));
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", "[v=\\s]*".concat(src[t.MAINVERSIONLOOSE]).concat(src[t.PRERELEASELOOSE], "?").concat(src[t.BUILD], "?"));
createToken("LOOSE", "^".concat(src[t.LOOSEPLAIN], "$"));
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", "".concat(src[t.NUMERICIDENTIFIERLOOSE], "|x|X|\\*"));
createToken("XRANGEIDENTIFIER", "".concat(src[t.NUMERICIDENTIFIER], "|x|X|\\*"));
createToken("XRANGEPLAIN", "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIER], ")") + "(?:".concat(src[t.PRERELEASE], ")?").concat(src[t.BUILD], "?") + ")?)?");
createToken("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(src[t.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(src[t.PRERELEASELOOSE], ")?").concat(src[t.BUILD], "?") + ")?)?");
createToken("XRANGE", "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAIN], "$"));
createToken("XRANGELOOSE", "^".concat(src[t.GTLT], "\\s*").concat(src[t.XRANGEPLAINLOOSE], "$"));
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", "(^|[^\\d])(\\d{1,".concat($d3ba7cbf82760325$require$MAX_SAFE_COMPONENT_LENGTH, "})") + "(?:\\.(\\d{1,".concat($d3ba7cbf82760325$require$MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:\\.(\\d{1,".concat($d3ba7cbf82760325$require$MAX_SAFE_COMPONENT_LENGTH, "}))?") + "(?:$|[^\\d])");
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", "(\\s*)".concat(src[t.LONETILDE], "\\s+"), true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAIN], "$"));
createToken("TILDELOOSE", "^".concat(src[t.LONETILDE]).concat(src[t.XRANGEPLAINLOOSE], "$"));
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", "(\\s*)".concat(src[t.LONECARET], "\\s+"), true);
exports.caretTrimReplace = "$1^";
createToken("CARET", "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAIN], "$"));
createToken("CARETLOOSE", "^".concat(src[t.LONECARET]).concat(src[t.XRANGEPLAINLOOSE], "$"));
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", "^".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], ")$|^$"));
createToken("COMPARATOR", "^".concat(src[t.GTLT], "\\s*(").concat(src[t.FULLPLAIN], ")$|^$"));
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", "(\\s*)".concat(src[t.GTLT], "\\s*(").concat(src[t.LOOSEPLAIN], "|").concat(src[t.XRANGEPLAIN], ")"), true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", "^\\s*(".concat(src[t.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAIN], ")") + "\\s*$");
createToken("HYPHENRANGELOOSE", "^\\s*(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(src[t.XRANGEPLAINLOOSE], ")") + "\\s*$");
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0.0.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");

});
parcelRegister("58Fx4", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
var $3bddea950410525c$var$SEMVER_SPEC_VERSION = "2.0.0";
var $3bddea950410525c$var$MAX_LENGTH = 256;
var $3bddea950410525c$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var $3bddea950410525c$var$MAX_SAFE_COMPONENT_LENGTH = 16;
module.exports = {
    SEMVER_SPEC_VERSION: $3bddea950410525c$var$SEMVER_SPEC_VERSION,
    MAX_LENGTH: $3bddea950410525c$var$MAX_LENGTH,
    MAX_SAFE_INTEGER: $3bddea950410525c$var$MAX_SAFE_INTEGER,
    MAX_SAFE_COMPONENT_LENGTH: $3bddea950410525c$var$MAX_SAFE_COMPONENT_LENGTH
};

});

parcelRegister("eF215", function(module, exports) {

var $4pbh3 = parcelRequire("4pbh3");
var $aac6757b2bb4e354$var$debug = (typeof $4pbh3 === "object" && $4pbh3.env && undefined, function() {});
module.exports = $aac6757b2bb4e354$var$debug;

});


parcelRegister("gwDzE", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $eF215 = parcelRequire("eF215");

var $58Fx4 = parcelRequire("58Fx4");
var $c07e55166324ace4$var$MAX_LENGTH = $58Fx4.MAX_LENGTH, $c07e55166324ace4$var$MAX_SAFE_INTEGER = $58Fx4.MAX_SAFE_INTEGER;

var $ib1AC = parcelRequire("ib1AC");
var $c07e55166324ace4$var$re = $ib1AC.re, $c07e55166324ace4$var$t = $ib1AC.t;

var $dVRkM = parcelRequire("dVRkM");

var $c1LTT = parcelRequire("c1LTT");
var $c07e55166324ace4$require$compareIdentifiers = $c1LTT.compareIdentifiers;
var $c07e55166324ace4$var$SemVer = /*#__PURE__*/ function() {
    "use strict";
    function SemVer(version, options) {
        (0, $7dKN1._)(this, SemVer);
        options = $dVRkM(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError("Invalid Version: ".concat(version));
        if (version.length > $c07e55166324ace4$var$MAX_LENGTH) throw new TypeError("version is longer than ".concat($c07e55166324ace4$var$MAX_LENGTH, " characters"));
        $eF215("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        var m = version.trim().match(options.loose ? $c07e55166324ace4$var$re[$c07e55166324ace4$var$t.LOOSE] : $c07e55166324ace4$var$re[$c07e55166324ace4$var$t.FULL]);
        if (!m) throw new TypeError("Invalid Version: ".concat(version));
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $c07e55166324ace4$var$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $c07e55166324ace4$var$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $c07e55166324ace4$var$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map(function(id) {
            if (/^[0-9]+$/.test(id)) {
                var num = +id;
                if (num >= 0 && num < $c07e55166324ace4$var$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    (0, $eW5pA._)(SemVer, [
        {
            key: "format",
            value: function format() {
                this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch);
                if (this.prerelease.length) this.version += "-".concat(this.prerelease.join("."));
                return this.version;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.version;
            }
        },
        {
            key: "compare",
            value: function compare(other) {
                $eF215("SemVer.compare", this.version, this.options, other);
                if (!(other instanceof SemVer)) {
                    if (typeof other === "string" && other === this.version) return 0;
                    other = new SemVer(other, this.options);
                }
                if (other.version === this.version) return 0;
                return this.compareMain(other) || this.comparePre(other);
            }
        },
        {
            key: "compareMain",
            value: function compareMain(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                return $c07e55166324ace4$require$compareIdentifiers(this.major, other.major) || $c07e55166324ace4$require$compareIdentifiers(this.minor, other.minor) || $c07e55166324ace4$require$compareIdentifiers(this.patch, other.patch);
            }
        },
        {
            key: "comparePre",
            value: function comparePre(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                // NOT having a prerelease is > having one
                if (this.prerelease.length && !other.prerelease.length) return -1;
                else if (!this.prerelease.length && other.prerelease.length) return 1;
                else if (!this.prerelease.length && !other.prerelease.length) return 0;
                var i = 0;
                do {
                    var a = this.prerelease[i];
                    var b = other.prerelease[i];
                    $eF215("prerelease compare", i, a, b);
                    if (a === undefined && b === undefined) return 0;
                    else if (b === undefined) return 1;
                    else if (a === undefined) return -1;
                    else if (a === b) continue;
                    else return $c07e55166324ace4$require$compareIdentifiers(a, b);
                }while (++i);
            }
        },
        {
            key: "compareBuild",
            value: function compareBuild(other) {
                if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
                var i = 0;
                do {
                    var a = this.build[i];
                    var b = other.build[i];
                    $eF215("prerelease compare", i, a, b);
                    if (a === undefined && b === undefined) return 0;
                    else if (b === undefined) return 1;
                    else if (a === undefined) return -1;
                    else if (a === b) continue;
                    else return $c07e55166324ace4$require$compareIdentifiers(a, b);
                }while (++i);
            }
        },
        {
            // preminor will bump the version up to the next minor release, and immediately
            // down to pre-release. premajor and prepatch work the same way.
            key: "inc",
            value: function inc(release, identifier) {
                switch(release){
                    case "premajor":
                        this.prerelease.length = 0;
                        this.patch = 0;
                        this.minor = 0;
                        this.major++;
                        this.inc("pre", identifier);
                        break;
                    case "preminor":
                        this.prerelease.length = 0;
                        this.patch = 0;
                        this.minor++;
                        this.inc("pre", identifier);
                        break;
                    case "prepatch":
                        // If this is already a prerelease, it will bump to the next version
                        // drop any prereleases that might already exist, since they are not
                        // relevant at this point.
                        this.prerelease.length = 0;
                        this.inc("patch", identifier);
                        this.inc("pre", identifier);
                        break;
                    // If the input is a non-prerelease version, this acts the same as
                    // prepatch.
                    case "prerelease":
                        if (this.prerelease.length === 0) this.inc("patch", identifier);
                        this.inc("pre", identifier);
                        break;
                    case "major":
                        // If this is a pre-major version, bump up to the same major version.
                        // Otherwise increment major.
                        // 1.0.0-5 bumps to 1.0.0
                        // 1.1.0 bumps to 2.0.0
                        if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                        this.minor = 0;
                        this.patch = 0;
                        this.prerelease = [];
                        break;
                    case "minor":
                        // If this is a pre-minor version, bump up to the same minor version.
                        // Otherwise increment minor.
                        // 1.2.0-5 bumps to 1.2.0
                        // 1.2.1 bumps to 1.3.0
                        if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                        this.patch = 0;
                        this.prerelease = [];
                        break;
                    case "patch":
                        // If this is not a pre-release version, it will increment the patch.
                        // If it is a pre-release it will bump up to the same patch version.
                        // 1.2.0-5 patches to 1.2.0
                        // 1.2.0 patches to 1.2.1
                        if (this.prerelease.length === 0) this.patch++;
                        this.prerelease = [];
                        break;
                    // This probably shouldn't be used publicly.
                    // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
                    case "pre":
                        if (this.prerelease.length === 0) this.prerelease = [
                            0
                        ];
                        else {
                            var i = this.prerelease.length;
                            while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                                this.prerelease[i]++;
                                i = -2;
                            }
                            if (i === -1) // didn't increment anything
                            this.prerelease.push(0);
                        }
                        if (identifier) {
                            // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                            // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                            if (this.prerelease[0] === identifier) {
                                if (isNaN(this.prerelease[1])) this.prerelease = [
                                    identifier,
                                    0
                                ];
                            } else this.prerelease = [
                                identifier,
                                0
                            ];
                        }
                        break;
                    default:
                        throw new Error("invalid increment argument: ".concat(release));
                }
                this.format();
                this.raw = this.version;
                return this;
            }
        }
    ]);
    return SemVer;
}();
module.exports = $c07e55166324ace4$var$SemVer;

});
parcelRegister("dVRkM", function(module, exports) {
// parse out just the options we care about so we always get a consistent
// obj with keys in a consistent order.
var $a249f84fa2d7f88c$var$opts = [
    "includePrerelease",
    "loose",
    "rtl"
];
var $a249f84fa2d7f88c$var$parseOptions = function(options) {
    return !options ? {} : typeof options !== "object" ? {
        loose: true
    } : $a249f84fa2d7f88c$var$opts.filter(function(k) {
        return options[k];
    }).reduce(function(options, k) {
        options[k] = true;
        return options;
    }, {});
};
module.exports = $a249f84fa2d7f88c$var$parseOptions;

});

parcelRegister("c1LTT", function(module, exports) {
var $8c1abc17b6804e2d$var$numeric = /^[0-9]+$/;
var $8c1abc17b6804e2d$var$compareIdentifiers = function(a, b) {
    var anum = $8c1abc17b6804e2d$var$numeric.test(a);
    var bnum = $8c1abc17b6804e2d$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
var $8c1abc17b6804e2d$var$rcompareIdentifiers = function(a, b) {
    return $8c1abc17b6804e2d$var$compareIdentifiers(b, a);
};
module.exports = {
    compareIdentifiers: $8c1abc17b6804e2d$var$compareIdentifiers,
    rcompareIdentifiers: $8c1abc17b6804e2d$var$rcompareIdentifiers
};

});


parcelRegister("hkVtd", function(module, exports) {

var $58Fx4 = parcelRequire("58Fx4");
var $c9f0e254d1130f7a$require$MAX_LENGTH = $58Fx4.MAX_LENGTH;

var $ib1AC = parcelRequire("ib1AC");
var $c9f0e254d1130f7a$var$re = $ib1AC.re, $c9f0e254d1130f7a$var$t = $ib1AC.t;

var $gwDzE = parcelRequire("gwDzE");

var $dVRkM = parcelRequire("dVRkM");
var $c9f0e254d1130f7a$var$parse = function(version, options) {
    options = $dVRkM(options);
    if (version instanceof $gwDzE) return version;
    if (typeof version !== "string") return null;
    if (version.length > $c9f0e254d1130f7a$require$MAX_LENGTH) return null;
    var r = options.loose ? $c9f0e254d1130f7a$var$re[$c9f0e254d1130f7a$var$t.LOOSE] : $c9f0e254d1130f7a$var$re[$c9f0e254d1130f7a$var$t.FULL];
    if (!r.test(version)) return null;
    try {
        return new $gwDzE(version, options);
    } catch (er) {
        return null;
    }
};
module.exports = $c9f0e254d1130f7a$var$parse;

});

parcelRegister("5r19k", function(module, exports) {

var $hkVtd = parcelRequire("hkVtd");
var $3f505d9bb5c3c52b$var$valid = function(version, options) {
    var v = $hkVtd(version, options);
    return v ? v.version : null;
};
module.exports = $3f505d9bb5c3c52b$var$valid;

});

parcelRegister("3X1yG", function(module, exports) {

var $hkVtd = parcelRequire("hkVtd");
var $2e0817453e2f6d53$var$clean = function(version, options) {
    var s = $hkVtd(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
module.exports = $2e0817453e2f6d53$var$clean;

});

parcelRegister("ciEIn", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");
var $8f46bf920eb47354$var$inc = function(version, release, options, identifier) {
    if (typeof options === "string") {
        identifier = options;
        options = undefined;
    }
    try {
        return new $gwDzE(version, options).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
};
module.exports = $8f46bf920eb47354$var$inc;

});

parcelRegister("aRzGx", function(module, exports) {

var $hkVtd = parcelRequire("hkVtd");

var $dnnWP = parcelRequire("dnnWP");
var $7e8a88f0ac46491f$var$diff = function(version1, version2) {
    if ($dnnWP(version1, version2)) return null;
    else {
        var v1 = $hkVtd(version1);
        var v2 = $hkVtd(version2);
        var hasPre = v1.prerelease.length || v2.prerelease.length;
        var prefix = hasPre ? "pre" : "";
        var defaultResult = hasPre ? "prerelease" : "";
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
};
module.exports = $7e8a88f0ac46491f$var$diff;

});
parcelRegister("dnnWP", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $9bcfffe8cb3dce2e$var$eq = function(a, b, loose) {
    return $1gCWi(a, b, loose) === 0;
};
module.exports = $9bcfffe8cb3dce2e$var$eq;

});
parcelRegister("1gCWi", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");
var $0ec57d9c34df53bb$var$compare = function(a, b, loose) {
    return new $gwDzE(a, loose).compare(new $gwDzE(b, loose));
};
module.exports = $0ec57d9c34df53bb$var$compare;

});



parcelRegister("lS2mz", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");
var $fec0795cb04c6071$var$major = function(a, loose) {
    return new $gwDzE(a, loose).major;
};
module.exports = $fec0795cb04c6071$var$major;

});

parcelRegister("izrOF", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");
var $d85112935b63a15d$var$minor = function(a, loose) {
    return new $gwDzE(a, loose).minor;
};
module.exports = $d85112935b63a15d$var$minor;

});

parcelRegister("c2m8w", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");
var $8c36d7ca30db4d29$var$patch = function(a, loose) {
    return new $gwDzE(a, loose).patch;
};
module.exports = $8c36d7ca30db4d29$var$patch;

});

parcelRegister("8wcJT", function(module, exports) {

var $hkVtd = parcelRequire("hkVtd");
var $633b319e93a14b85$var$prerelease = function(version, options) {
    var parsed = $hkVtd(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $633b319e93a14b85$var$prerelease;

});

parcelRegister("jhv0l", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $e097a7b77dba57d0$var$rcompare = function(a, b, loose) {
    return $1gCWi(b, a, loose);
};
module.exports = $e097a7b77dba57d0$var$rcompare;

});

parcelRegister("i1Epj", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $d1f7aa06eb229195$var$compareLoose = function(a, b) {
    return $1gCWi(a, b, true);
};
module.exports = $d1f7aa06eb229195$var$compareLoose;

});

parcelRegister("6JgXS", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");
var $4e641ae96cd00fc5$var$compareBuild = function(a, b, loose) {
    var versionA = new $gwDzE(a, loose);
    var versionB = new $gwDzE(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $4e641ae96cd00fc5$var$compareBuild;

});

parcelRegister("4TpM6", function(module, exports) {

var $6JgXS = parcelRequire("6JgXS");
var $39004acfa9e4f3a5$var$sort = function(list, loose) {
    return list.sort(function(a, b) {
        return $6JgXS(a, b, loose);
    });
};
module.exports = $39004acfa9e4f3a5$var$sort;

});

parcelRegister("h7HZJ", function(module, exports) {

var $6JgXS = parcelRequire("6JgXS");
var $033791697b0e59fe$var$rsort = function(list, loose) {
    return list.sort(function(a, b) {
        return $6JgXS(b, a, loose);
    });
};
module.exports = $033791697b0e59fe$var$rsort;

});

parcelRegister("6vAgh", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $4bd1c424c52e6108$var$gt = function(a, b, loose) {
    return $1gCWi(a, b, loose) > 0;
};
module.exports = $4bd1c424c52e6108$var$gt;

});

parcelRegister("6dKLA", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $48783bd56e475f50$var$lt = function(a, b, loose) {
    return $1gCWi(a, b, loose) < 0;
};
module.exports = $48783bd56e475f50$var$lt;

});

parcelRegister("9tBKZ", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $6e641c38dfb6335f$var$neq = function(a, b, loose) {
    return $1gCWi(a, b, loose) !== 0;
};
module.exports = $6e641c38dfb6335f$var$neq;

});

parcelRegister("66BFD", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $4720863806fe8222$var$gte = function(a, b, loose) {
    return $1gCWi(a, b, loose) >= 0;
};
module.exports = $4720863806fe8222$var$gte;

});

parcelRegister("ioCQv", function(module, exports) {

var $1gCWi = parcelRequire("1gCWi");
var $d64899dec170c2bf$var$lte = function(a, b, loose) {
    return $1gCWi(a, b, loose) <= 0;
};
module.exports = $d64899dec170c2bf$var$lte;

});

parcelRegister("9iuUs", function(module, exports) {

var $dnnWP = parcelRequire("dnnWP");

var $9tBKZ = parcelRequire("9tBKZ");

var $6vAgh = parcelRequire("6vAgh");

var $66BFD = parcelRequire("66BFD");

var $6dKLA = parcelRequire("6dKLA");

var $ioCQv = parcelRequire("ioCQv");
var $01bf309ae8de3f32$var$cmp = function(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $dnnWP(a, b, loose);
        case "!=":
            return $9tBKZ(a, b, loose);
        case ">":
            return $6vAgh(a, b, loose);
        case ">=":
            return $66BFD(a, b, loose);
        case "<":
            return $6dKLA(a, b, loose);
        case "<=":
            return $ioCQv(a, b, loose);
        default:
            throw new TypeError("Invalid operator: ".concat(op));
    }
};
module.exports = $01bf309ae8de3f32$var$cmp;

});

parcelRegister("lRNOe", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");

var $hkVtd = parcelRequire("hkVtd");

var $ib1AC = parcelRequire("ib1AC");
var $feb52f4b8d960cb3$var$re = $ib1AC.re, $feb52f4b8d960cb3$var$t = $ib1AC.t;
var $feb52f4b8d960cb3$var$coerce = function(version, options) {
    if (version instanceof $gwDzE) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    var match = null;
    if (!options.rtl) match = version.match($feb52f4b8d960cb3$var$re[$feb52f4b8d960cb3$var$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        var next;
        while((next = $feb52f4b8d960cb3$var$re[$feb52f4b8d960cb3$var$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $feb52f4b8d960cb3$var$re[$feb52f4b8d960cb3$var$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $feb52f4b8d960cb3$var$re[$feb52f4b8d960cb3$var$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $hkVtd("".concat(match[2], ".").concat(match[3] || "0", ".").concat(match[4] || "0"), options);
};
module.exports = $feb52f4b8d960cb3$var$coerce;

});

parcelRegister("ijfhR", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $d545dc03c4e19da5$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
var $d545dc03c4e19da5$var$Comparator = /*#__PURE__*/ function() {
    "use strict";
    function Comparator(comp, options) {
        (0, $7dKN1._)(this, Comparator);
        options = $dVRkM(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        $eF215("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $d545dc03c4e19da5$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $eF215("comp", this);
    }
    (0, $eW5pA._)(Comparator, [
        {
            key: "parse",
            value: function parse(comp) {
                var r = this.options.loose ? $d545dc03c4e19da5$var$re[$d545dc03c4e19da5$var$t.COMPARATORLOOSE] : $d545dc03c4e19da5$var$re[$d545dc03c4e19da5$var$t.COMPARATOR];
                var m = comp.match(r);
                if (!m) throw new TypeError("Invalid comparator: ".concat(comp));
                this.operator = m[1] !== undefined ? m[1] : "";
                if (this.operator === "=") this.operator = "";
                // if it literally is just '>' or '' then allow anything.
                if (!m[2]) this.semver = $d545dc03c4e19da5$var$ANY;
                else this.semver = new $gwDzE(m[2], this.options.loose);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.value;
            }
        },
        {
            key: "test",
            value: function test(version) {
                $eF215("Comparator.test", version, this.options.loose);
                if (this.semver === $d545dc03c4e19da5$var$ANY || version === $d545dc03c4e19da5$var$ANY) return true;
                if (typeof version === "string") try {
                    version = new $gwDzE(version, this.options);
                } catch (er) {
                    return false;
                }
                return $9iuUs(version, this.operator, this.semver, this.options);
            }
        },
        {
            key: "intersects",
            value: function intersects(comp, options) {
                if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
                if (!options || typeof options !== "object") options = {
                    loose: !!options,
                    includePrerelease: false
                };
                if (this.operator === "") {
                    if (this.value === "") return true;
                    return new $8J7OE(comp.value, options).test(this.value);
                } else if (comp.operator === "") {
                    if (comp.value === "") return true;
                    return new $8J7OE(this.value, options).test(comp.semver);
                }
                var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
                var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
                var sameSemVer = this.semver.version === comp.semver.version;
                var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
                var oppositeDirectionsLessThan = $9iuUs(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
                var oppositeDirectionsGreaterThan = $9iuUs(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
                return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
            }
        }
    ], [
        {
            key: "ANY",
            get: function get() {
                return $d545dc03c4e19da5$var$ANY;
            }
        }
    ]);
    return Comparator;
}();
module.exports = $d545dc03c4e19da5$var$Comparator;

var $dVRkM = parcelRequire("dVRkM");

var $ib1AC = parcelRequire("ib1AC");
var $d545dc03c4e19da5$var$re = $ib1AC.re, $d545dc03c4e19da5$var$t = $ib1AC.t;

var $9iuUs = parcelRequire("9iuUs");

var $eF215 = parcelRequire("eF215");

var $gwDzE = parcelRequire("gwDzE");

var $8J7OE = parcelRequire("8J7OE");

});
parcelRegister("8J7OE", function(module, exports) {
// hoisted class for cyclic dependency

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");
var $65a896c41a8adba8$var$Range = /*#__PURE__*/ function() {
    "use strict";
    function Range(range, options) {
        var _this = this;
        (0, $7dKN1._)(this, Range);
        options = $dVRkM(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof $ijfhR) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First, split based on boolean or ||
        this.raw = range;
        this.set = range.split(/\s*\|\|\s*/)// map the range to a 2d array of comparators
        .map(function(range) {
            return _this.parseRange(range.trim());
        })// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter(function(c) {
            return c.length;
        });
        if (!this.set.length) throw new TypeError("Invalid SemVer Range: ".concat(range));
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            var first = this.set[0];
            this.set = this.set.filter(function(c) {
                return !$65a896c41a8adba8$var$isNullSet(c[0]);
            });
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // if we have any that are *, then the range is just *
                    for(var _iterator = this.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var c = _step.value;
                        if (c.length === 1 && $65a896c41a8adba8$var$isAny(c[0])) {
                            this.set = [
                                c
                            ];
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
        this.format();
    }
    (0, $eW5pA._)(Range, [
        {
            key: "format",
            value: function format() {
                this.range = this.set.map(function(comps) {
                    return comps.join(" ").trim();
                }).join("||").trim();
                return this.range;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.range;
            }
        },
        {
            key: "parseRange",
            value: function parseRange(range) {
                var _this = this;
                range = range.trim();
                // memoize range parsing for performance.
                // this is a very hot path, and fully deterministic.
                var memoOpts = Object.keys(this.options).join(",");
                var memoKey = "parseRange:".concat(memoOpts, ":").concat(range);
                var cached = $65a896c41a8adba8$var$cache.get(memoKey);
                if (cached) return cached;
                var loose = this.options.loose;
                // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
                var hr = loose ? $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.HYPHENRANGELOOSE] : $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.HYPHENRANGE];
                range = range.replace(hr, $65a896c41a8adba8$var$hyphenReplace(this.options.includePrerelease));
                $eF215("hyphen replace", range);
                // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
                range = range.replace($65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.COMPARATORTRIM], $65a896c41a8adba8$var$comparatorTrimReplace);
                $eF215("comparator trim", range, $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.COMPARATORTRIM]);
                // `~ 1.2.3` => `~1.2.3`
                range = range.replace($65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.TILDETRIM], $65a896c41a8adba8$var$tildeTrimReplace);
                // `^ 1.2.3` => `^1.2.3`
                range = range.replace($65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.CARETTRIM], $65a896c41a8adba8$var$caretTrimReplace);
                // normalize spaces
                range = range.split(/\s+/).join(" ");
                // At this point, the range is completely trimmed and
                // ready to be split into comparators.
                var compRe = loose ? $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.COMPARATORLOOSE] : $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.COMPARATOR];
                var rangeList = range.split(" ").map(function(comp) {
                    return $65a896c41a8adba8$var$parseComparator(comp, _this.options);
                }).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
                .map(function(comp) {
                    return $65a896c41a8adba8$var$replaceGTE0(comp, _this.options);
                })// in loose mode, throw out any that are not valid comparators
                .filter(this.options.loose ? function(comp) {
                    return !!comp.match(compRe);
                } : function() {
                    return true;
                }).map(function(comp) {
                    return new $ijfhR(comp, _this.options);
                });
                // if any comparators are the null set, then replace with JUST null set
                // if more than one comparator, remove any * comparators
                // also, don't include the same comparator more than once
                var l = rangeList.length;
                var rangeMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = rangeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var comp = _step.value;
                        if ($65a896c41a8adba8$var$isNullSet(comp)) return [
                            comp
                        ];
                        rangeMap.set(comp.value, comp);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
                var result = (0, $gF0bR._)(rangeMap.values());
                $65a896c41a8adba8$var$cache.set(memoKey, result);
                return result;
            }
        },
        {
            key: "intersects",
            value: function intersects(range, options) {
                if (!(range instanceof Range)) throw new TypeError("a Range is required");
                return this.set.some(function(thisComparators) {
                    return $65a896c41a8adba8$var$isSatisfiable(thisComparators, options) && range.set.some(function(rangeComparators) {
                        return $65a896c41a8adba8$var$isSatisfiable(rangeComparators, options) && thisComparators.every(function(thisComparator) {
                            return rangeComparators.every(function(rangeComparator) {
                                return thisComparator.intersects(rangeComparator, options);
                            });
                        });
                    });
                });
            }
        },
        {
            // if ANY of the sets match ALL of its comparators, then pass
            key: "test",
            value: function test(version) {
                if (!version) return false;
                if (typeof version === "string") try {
                    version = new $gwDzE(version, this.options);
                } catch (er) {
                    return false;
                }
                for(var i = 0; i < this.set.length; i++){
                    if ($65a896c41a8adba8$var$testSet(this.set[i], version, this.options)) return true;
                }
                return false;
            }
        }
    ]);
    return Range;
}();
module.exports = $65a896c41a8adba8$var$Range;

var $3DfNU = parcelRequire("3DfNU");
var $65a896c41a8adba8$var$cache = new $3DfNU({
    max: 1000
});

var $dVRkM = parcelRequire("dVRkM");

var $ijfhR = parcelRequire("ijfhR");

var $eF215 = parcelRequire("eF215");

var $gwDzE = parcelRequire("gwDzE");

var $ib1AC = parcelRequire("ib1AC");
var $65a896c41a8adba8$var$re = $ib1AC.re, $65a896c41a8adba8$var$t = $ib1AC.t, $65a896c41a8adba8$var$comparatorTrimReplace = $ib1AC.comparatorTrimReplace, $65a896c41a8adba8$var$tildeTrimReplace = $ib1AC.tildeTrimReplace, $65a896c41a8adba8$var$caretTrimReplace = $ib1AC.caretTrimReplace;
var $65a896c41a8adba8$var$isNullSet = function(c) {
    return c.value === "<0.0.0-0";
};
var $65a896c41a8adba8$var$isAny = function(c) {
    return c.value === "";
};
// take a set of comparators and determine whether there
// exists a version which can satisfy it
var $65a896c41a8adba8$var$isSatisfiable = function(comparators, options) {
    var result = true;
    var remainingComparators = comparators.slice();
    var testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every(function(otherComparator) {
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
var $65a896c41a8adba8$var$parseComparator = function(comp, options) {
    $eF215("comp", comp, options);
    comp = $65a896c41a8adba8$var$replaceCarets(comp, options);
    $eF215("caret", comp);
    comp = $65a896c41a8adba8$var$replaceTildes(comp, options);
    $eF215("tildes", comp);
    comp = $65a896c41a8adba8$var$replaceXRanges(comp, options);
    $eF215("xrange", comp);
    comp = $65a896c41a8adba8$var$replaceStars(comp, options);
    $eF215("stars", comp);
    return comp;
};
var $65a896c41a8adba8$var$isX = function(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
};
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
var $65a896c41a8adba8$var$replaceTildes = function(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return $65a896c41a8adba8$var$replaceTilde(comp, options);
    }).join(" ");
};
var $65a896c41a8adba8$var$replaceTilde = function(comp, options) {
    var r = options.loose ? $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.TILDELOOSE] : $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        $eF215("tilde", comp, _, M, m, p, pr);
        var ret;
        if ($65a896c41a8adba8$var$isX(M)) ret = "";
        else if ($65a896c41a8adba8$var$isX(m)) ret = ">=".concat(M, ".0.0 <").concat(+M + 1, ".0.0-0");
        else if ($65a896c41a8adba8$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = ">=".concat(M, ".").concat(m, ".0 <").concat(M, ".").concat(+m + 1, ".0-0");
        else if (pr) {
            $eF215("replaceTilde pr", pr);
            ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(M, ".").concat(+m + 1, ".0-0");
        $eF215("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
var $65a896c41a8adba8$var$replaceCarets = function(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return $65a896c41a8adba8$var$replaceCaret(comp, options);
    }).join(" ");
};
var $65a896c41a8adba8$var$replaceCaret = function(comp, options) {
    $eF215("caret", comp, options);
    var r = options.loose ? $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.CARETLOOSE] : $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.CARET];
    var z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, function(_, M, m, p, pr) {
        $eF215("caret", comp, _, M, m, p, pr);
        var ret;
        if ($65a896c41a8adba8$var$isX(M)) ret = "";
        else if ($65a896c41a8adba8$var$isX(m)) ret = ">=".concat(M, ".0.0").concat(z, " <").concat(+M + 1, ".0.0-0");
        else if ($65a896c41a8adba8$var$isX(p)) {
            if (M === "0") ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
            else ret = ">=".concat(M, ".").concat(m, ".0").concat(z, " <").concat(+M + 1, ".0.0-0");
        } else if (pr) {
            $eF215("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                else ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
            } else ret = ">=".concat(M, ".").concat(m, ".").concat(p, "-").concat(pr, " <").concat(+M + 1, ".0.0-0");
        } else {
            $eF215("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(m, ".").concat(+p + 1, "-0");
                else ret = ">=".concat(M, ".").concat(m, ".").concat(p).concat(z, " <").concat(M, ".").concat(+m + 1, ".0-0");
            } else ret = ">=".concat(M, ".").concat(m, ".").concat(p, " <").concat(+M + 1, ".0.0-0");
        }
        $eF215("caret return", ret);
        return ret;
    });
};
var $65a896c41a8adba8$var$replaceXRanges = function(comp, options) {
    $eF215("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return $65a896c41a8adba8$var$replaceXRange(comp, options);
    }).join(" ");
};
var $65a896c41a8adba8$var$replaceXRange = function(comp, options) {
    comp = comp.trim();
    var r = options.loose ? $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.XRANGELOOSE] : $65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        $eF215("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = $65a896c41a8adba8$var$isX(M);
        var xm = xM || $65a896c41a8adba8$var$isX(m);
        var xp = xm || $65a896c41a8adba8$var$isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = "".concat(gtlt + M, ".").concat(m, ".").concat(p).concat(pr);
        } else if (xm) ret = ">=".concat(M, ".0.0").concat(pr, " <").concat(+M + 1, ".0.0-0");
        else if (xp) ret = ">=".concat(M, ".").concat(m, ".0").concat(pr, " <").concat(M, ".").concat(+m + 1, ".0-0");
        $eF215("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
var $65a896c41a8adba8$var$replaceStars = function(comp, options) {
    $eF215("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($65a896c41a8adba8$var$re[$65a896c41a8adba8$var$t.STAR], "");
};
var $65a896c41a8adba8$var$replaceGTE0 = function(comp, options) {
    $eF215("replaceGTE0", comp, options);
    return comp.trim().replace($65a896c41a8adba8$var$re[options.includePrerelease ? $65a896c41a8adba8$var$t.GTE0PRE : $65a896c41a8adba8$var$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
var $65a896c41a8adba8$var$hyphenReplace = function(incPr) {
    return function($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
        if ($65a896c41a8adba8$var$isX(fM)) from = "";
        else if ($65a896c41a8adba8$var$isX(fm)) from = ">=".concat(fM, ".0.0").concat(incPr ? "-0" : "");
        else if ($65a896c41a8adba8$var$isX(fp)) from = ">=".concat(fM, ".").concat(fm, ".0").concat(incPr ? "-0" : "");
        else if (fpr) from = ">=".concat(from);
        else from = ">=".concat(from).concat(incPr ? "-0" : "");
        if ($65a896c41a8adba8$var$isX(tM)) to = "";
        else if ($65a896c41a8adba8$var$isX(tm)) to = "<".concat(+tM + 1, ".0.0-0");
        else if ($65a896c41a8adba8$var$isX(tp)) to = "<".concat(tM, ".").concat(+tm + 1, ".0-0");
        else if (tpr) to = "<=".concat(tM, ".").concat(tm, ".").concat(tp, "-").concat(tpr);
        else if (incPr) to = "<".concat(tM, ".").concat(tm, ".").concat(+tp + 1, "-0");
        else to = "<=".concat(to);
        return "".concat(from, " ").concat(to).trim();
    };
};
var $65a896c41a8adba8$var$testSet = function(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(var i1 = 0; i1 < set.length; i1++){
            $eF215(set[i1].semver);
            if (set[i1].semver === $ijfhR.ANY) continue;
            if (set[i1].semver.prerelease.length > 0) {
                var allowed = set[i1].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});


parcelRegister("7DhOR", function(module, exports) {

var $8J7OE = parcelRequire("8J7OE");
var $58e9ff747dd1e981$var$satisfies = function(version, range, options) {
    try {
        range = new $8J7OE(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $58e9ff747dd1e981$var$satisfies;

});

parcelRegister("5jM8E", function(module, exports) {

var $8J7OE = parcelRequire("8J7OE");
// Mostly just for testing and legacy API reasons
var $3df4116854c9efda$var$toComparators = function(range, options) {
    return new $8J7OE(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
};
module.exports = $3df4116854c9efda$var$toComparators;

});

parcelRegister("8RqiC", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");

var $8J7OE = parcelRequire("8J7OE");
var $6737ac794ccb11c6$var$maxSatisfying = function(versions, range, options) {
    var max = null;
    var maxSV = null;
    var rangeObj = null;
    try {
        rangeObj = new $8J7OE(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $gwDzE(max, options);
            }
        }
    });
    return max;
};
module.exports = $6737ac794ccb11c6$var$maxSatisfying;

});

parcelRegister("9Y9Js", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");

var $8J7OE = parcelRequire("8J7OE");
var $742144421e5a0115$var$minSatisfying = function(versions, range, options) {
    var min = null;
    var minSV = null;
    var rangeObj = null;
    try {
        rangeObj = new $8J7OE(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $gwDzE(min, options);
            }
        }
    });
    return min;
};
module.exports = $742144421e5a0115$var$minSatisfying;

});

parcelRegister("4zclB", function(module, exports) {

var $gwDzE = parcelRequire("gwDzE");

var $8J7OE = parcelRequire("8J7OE");

var $6vAgh = parcelRequire("6vAgh");
var $353402457eddfd7c$var$minVersion = function(range, loose) {
    var _loop = function(i) {
        var comparators = range.set[i];
        var setMin = null;
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new $gwDzE(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $6vAgh(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: ".concat(comparator.operator));
            }
        });
        if (setMin && (!minver || $6vAgh(minver, setMin))) minver = setMin;
    };
    range = new $8J7OE(range, loose);
    var minver = new $gwDzE("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $gwDzE("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i)_loop(i);
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $353402457eddfd7c$var$minVersion;

});

parcelRegister("ekRHf", function(module, exports) {

var $8J7OE = parcelRequire("8J7OE");
var $a6fc95fa0d66fcc7$var$validRange = function(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $8J7OE(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
module.exports = $a6fc95fa0d66fcc7$var$validRange;

});

parcelRegister("1U3F9", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");

var $gwDzE = parcelRequire("gwDzE");

var $ijfhR = parcelRequire("ijfhR");
var $162ddcbd2064a05c$var$ANY = $ijfhR.ANY;

var $8J7OE = parcelRequire("8J7OE");

var $7DhOR = parcelRequire("7DhOR");

var $6vAgh = parcelRequire("6vAgh");

var $6dKLA = parcelRequire("6dKLA");

var $ioCQv = parcelRequire("ioCQv");

var $66BFD = parcelRequire("66BFD");
var $162ddcbd2064a05c$var$outside = function(version, range, hilo, options) {
    var _loop = function(i) {
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === $162ddcbd2064a05c$var$ANY) comparator = new $ijfhR(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return {
            v: false
        };
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return {
            v: false
        };
        else if (low.operator === ecomp && ltfn(version, low.semver)) return {
            v: false
        };
    };
    version = new $gwDzE(version, options);
    range = new $8J7OE(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $6vAgh;
            ltefn = $ioCQv;
            ltfn = $6dKLA;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $6dKLA;
            ltefn = $66BFD;
            ltfn = $6vAgh;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($7DhOR(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var _ret = _loop(i);
        if ((0, $aVMuR._)(_ret) === "object") return _ret.v;
    }
    return true;
};
module.exports = $162ddcbd2064a05c$var$outside;

});

parcelRegister("1IwIP", function(module, exports) {
// Determine if version is greater than all the versions possible in the range.

var $1U3F9 = parcelRequire("1U3F9");
var $14034867d29aeaad$var$gtr = function(version, range, options) {
    return $1U3F9(version, range, ">", options);
};
module.exports = $14034867d29aeaad$var$gtr;

});

parcelRegister("Nnt5Q", function(module, exports) {

var $1U3F9 = parcelRequire("1U3F9");
// Determine if version is less than all the versions possible in the range
var $0946c805e4362872$var$ltr = function(version, range, options) {
    return $1U3F9(version, range, "<", options);
};
module.exports = $0946c805e4362872$var$ltr;

});

parcelRegister("kQfnz", function(module, exports) {

var $8J7OE = parcelRequire("8J7OE");
var $f2c497fb112f1928$var$intersects = function(r1, r2, options) {
    r1 = new $8J7OE(r1, options);
    r2 = new $8J7OE(r2, options);
    return r1.intersects(r2);
};
module.exports = $f2c497fb112f1928$var$intersects;

});

parcelRegister("6RKuc", function(module, exports) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.

var $5OlIx = parcelRequire("5OlIx");

var $7DhOR = parcelRequire("7DhOR");

var $1gCWi = parcelRequire("1gCWi");
module.exports = function(versions, range, options) {
    var set = [];
    var min = null;
    var prev = null;
    var v = versions.sort(function(a, b) {
        return $1gCWi(a, b, options);
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var version = _step.value;
            var included = $7DhOR(version, range, options);
            if (included) {
                prev = version;
                if (!min) min = version;
            } else {
                if (prev) set.push([
                    min,
                    prev
                ]);
                prev = null;
                min = null;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (min) set.push([
        min,
        null
    ]);
    var ranges = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $5OlIx._)(_step1.value, 2), min1 = _step_value[0], max = _step_value[1];
            if (min1 === max) ranges.push(min1);
            else if (!max && min1 === v[0]) ranges.push("*");
            else if (!max) ranges.push(">=".concat(min1));
            else if (min1 === v[0]) ranges.push("<=".concat(max));
            else ranges.push("".concat(min1, " - ").concat(max));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var simplified = ranges.join(" || ");
    var original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("gtK9J", function(module, exports) {

var $8J7OE = parcelRequire("8J7OE");

var $ijfhR = parcelRequire("ijfhR");
var $bff32863928c7387$var$ANY = $ijfhR.ANY;

var $7DhOR = parcelRequire("7DhOR");

var $1gCWi = parcelRequire("1gCWi");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
var $bff32863928c7387$var$subset = function(sub, dom) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (sub === dom) return true;
    sub = new $8J7OE(sub, options);
    dom = new $8J7OE(dom, options);
    var sawNonNull = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        OUTER: for(var _iterator = sub.set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var simpleSub = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = dom.set[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var simpleDom = _step1.value;
                    var isSub = $bff32863928c7387$var$simpleSubset(simpleSub, simpleDom, options);
                    sawNonNull = sawNonNull || isSub !== null;
                    if (isSub) continue OUTER;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // the null set is a subset of everything, but null simple ranges in
            // a complex range should be ignored.  so if we saw a non-null range,
            // then we know this isn't a subset, but if EVERY simple range was null,
            // then it is a subset.
            if (sawNonNull) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
var $bff32863928c7387$var$simpleSubset = function(sub, dom, options) {
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $bff32863928c7387$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $bff32863928c7387$var$ANY) return true;
        else if (options.includePrerelease) sub = [
            new $ijfhR(">=0.0.0-0")
        ];
        else sub = [
            new $ijfhR(">=0.0.0")
        ];
    }
    if (dom.length === 1 && dom[0].semver === $bff32863928c7387$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = [
            new $ijfhR(">=0.0.0")
        ];
    }
    var eqSet = new Set();
    var gt, lt;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sub[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (c.operator === ">" || c.operator === ">=") gt = $bff32863928c7387$var$higherGT(gt, c, options);
            else if (c.operator === "<" || c.operator === "<=") lt = $bff32863928c7387$var$lowerLT(lt, c, options);
            else eqSet.add(c.semver);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (eqSet.size > 1) return null;
    var gtltComp;
    if (gt && lt) {
        gtltComp = $1gCWi(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // will iterate one or zero times
        for(var _iterator1 = eqSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var eq = _step1.value;
            if (gt && !$7DhOR(eq, String(gt), options)) return null;
            if (lt && !$7DhOR(eq, String(lt), options)) return null;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = dom[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var c1 = _step2.value;
                    if (!$7DhOR(eq, String(c1), options)) return false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            return true;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var higher, lower;
    var hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    var needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    var needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = dom[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var c2 = _step3.value;
            hasDomGT = hasDomGT || c2.operator === ">" || c2.operator === ">=";
            hasDomLT = hasDomLT || c2.operator === "<" || c2.operator === "<=";
            if (gt) {
                if (needDomGTPre) {
                    if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomGTPre.major && c2.semver.minor === needDomGTPre.minor && c2.semver.patch === needDomGTPre.patch) needDomGTPre = false;
                }
                if (c2.operator === ">" || c2.operator === ">=") {
                    higher = $bff32863928c7387$var$higherGT(gt, c2, options);
                    if (higher === c2 && higher !== gt) return false;
                } else if (gt.operator === ">=" && !$7DhOR(gt.semver, String(c2), options)) return false;
            }
            if (lt) {
                if (needDomLTPre) {
                    if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomLTPre.major && c2.semver.minor === needDomLTPre.minor && c2.semver.patch === needDomLTPre.patch) needDomLTPre = false;
                }
                if (c2.operator === "<" || c2.operator === "<=") {
                    lower = $bff32863928c7387$var$lowerLT(lt, c2, options);
                    if (lower === c2 && lower !== lt) return false;
                } else if (lt.operator === "<=" && !$7DhOR(lt.semver, String(c2), options)) return false;
            }
            if (!c2.operator && (lt || gt) && gtltComp !== 0) return false;
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
var $bff32863928c7387$var$higherGT = function(a, b, options) {
    if (!a) return b;
    var comp = $1gCWi(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
var $bff32863928c7387$var$lowerLT = function(a, b, options) {
    if (!a) return b;
    var comp = $1gCWi(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
module.exports = $bff32863928c7387$var$subset;

});

parcelRegister("1OlAV", function(module, exports) {

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BLAKE2 = module.exports.SIGMA = void 0;

var $1bB2U = parcelRequire("1bB2U");
// prettier-ignore
module.exports.SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    // For BLAKE2b, the two extra permutations for rounds 10 and 11 are SIGMA[10..11] = SIGMA[0..1].
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
]);
var $151b363566ac7a6f$var$BLAKE2 = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(BLAKE2, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(BLAKE2);
    function BLAKE2(blockLen, outputLen) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, keyLen = arguments.length > 3 ? arguments[3] : void 0, saltLen = arguments.length > 4 ? arguments[4] : void 0, persLen = arguments.length > 5 ? arguments[5] : void 0;
        (0, $7dKN1._)(this, BLAKE2);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.length = 0;
        _this.pos = 0;
        _this.finished = false;
        _this.destroyed = false;
        (0, $1bB2U.assertNumber)(blockLen);
        (0, $1bB2U.assertNumber)(outputLen);
        (0, $1bB2U.assertNumber)(keyLen);
        if (outputLen < 0 || outputLen > keyLen) throw new Error("Blake2: outputLen bigger than keyLen");
        if (opts.key !== undefined && (opts.key.length < 1 || opts.key.length > keyLen)) throw new Error("Key should be up 1..".concat(keyLen, " byte long or undefined"));
        if (opts.salt !== undefined && opts.salt.length !== saltLen) throw new Error("Salt should be ".concat(saltLen, " byte long or undefined"));
        if (opts.personalization !== undefined && opts.personalization.length !== persLen) throw new Error("Personalization should be ".concat(persLen, " byte long or undefined"));
        _this.buffer32 = (0, $1bB2U.u32)(_this.buffer = new Uint8Array(blockLen));
        return _this;
    }
    (0, $eW5pA._)(BLAKE2, [
        {
            key: "update",
            value: function update(data) {
                if (this.destroyed) throw new Error("instance is destroyed");
                // Main difference with other hashes: there is flag for last block,
                // so we cannot process current block before we know that there
                // is the next one. This significantly complicates logic and reduces ability
                // to do zero-copy processing
                var _this = this, finished = _this.finished, blockLen = _this.blockLen, buffer = _this.buffer, buffer32 = _this.buffer32;
                if (finished) throw new Error("digest() was already called");
                data = (0, $1bB2U.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    // If buffer is full and we still have input (don't process last block, same as blake2s)
                    if (this.pos === blockLen) {
                        this.compress(buffer32, 0, false);
                        this.pos = 0;
                    }
                    var take = Math.min(blockLen - this.pos, len - pos);
                    var dataOffset = data.byteOffset + pos;
                    // full block && aligned to 4 bytes && not last in input
                    if (take === blockLen && !(dataOffset % 4) && pos + take < len) {
                        var data32 = new Uint32Array(data.buffer, dataOffset, Math.floor((len - pos) / 4));
                        for(var pos32 = 0; pos + blockLen < len; pos32 += buffer32.length, pos += blockLen){
                            this.length += blockLen;
                            this.compress(data32, pos32, false);
                        }
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    this.length += take;
                    pos += take;
                }
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                if (this.destroyed) throw new Error("instance is destroyed");
                if (!(out instanceof Uint8Array) || out.length < this.outputLen) throw new Error("_Blake2: Invalid output buffer");
                var _this = this, finished = _this.finished, pos = _this.pos, buffer32 = _this.buffer32;
                if (finished) throw new Error("digest() was already called");
                this.finished = true;
                // Padding
                this.buffer.subarray(pos).fill(0);
                this.compress(buffer32, 0, true);
                var out32 = (0, $1bB2U.u32)(out);
                this.get().forEach(function(v, i) {
                    return out32[i] = v;
                });
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                var _this = this, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, outputLen = _this.outputLen, pos = _this.pos;
                to || (to = new this.constructor({
                    dkLen: outputLen
                }));
                (_to = to).set.apply(_to, (0, $gF0bR._)(this.get()));
                to.length = length;
                to.finished = finished;
                to.destroyed = destroyed;
                to.outputLen = outputLen;
                to.buffer.set(buffer);
                to.pos = pos;
                return to;
            }
        }
    ]);
    return BLAKE2;
}($1bB2U.Hash);
module.exports.BLAKE2 = $151b363566ac7a6f$var$BLAKE2;

});
parcelRegister("1bB2U", function(module, exports) {

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
/*! noble-hashes - MIT License (c) 2021 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.assertHash = exports.assertBool = exports.assertNumber = exports.toBytes = exports.asyncLoop = exports.nextTick = exports.bytesToHex = exports.isLE = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;

var $d6hEv = parcelRequire("d6hEv");
// Cast array to different type
var u8 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
exports.u8 = u8;
var u32 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
exports.u32 = u32;
// Cast array to view
var createView = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
var rotr = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
exports.rotr = rotr;
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// There is almost no big endian hardware, but js typed arrays uses platform specific endianess.
// So, just to be sure not to corrupt anything.
if (!exports.isLE) throw new Error("Non little-endian hardware is not supported");
var hexes = Array.from({
    length: 256
}, function(v, i) {
    return i.toString(16).padStart(2, "0");
});
function bytesToHex(uint8a) {
    // pre-caching chars could speed this up 6x.
    var hex = "";
    for(var i = 0; i < uint8a.length; i++)hex += hexes[uint8a[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
// Currently avoid insertion of polyfills with packers (browserify/webpack/etc)
// But setTimeout is pretty slow, maybe worth to investigate howto do minimal polyfill here
exports.nextTick = function() {
    var nodeRequire = typeof module.require === "function" && module.require.bind(module);
    try {
        if (nodeRequire) {
            var setImmediate = nodeRequire("timers").setImmediate;
            return function() {
                return new Promise(function(resolve) {
                    return setImmediate(resolve);
                });
            };
        }
    } catch (e) {}
    return function() {
        return new Promise(function(resolve) {
            return setTimeout(resolve, 0);
        });
    };
}();
function asyncLoop(iters, tick, cb) {
    return _asyncLoop.apply(this, arguments);
}
function _asyncLoop() {
    _asyncLoop = // Returns control to thread each 'tick' ms to avoid blocking
    (0, $6rBFC._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, exports.nextTick)()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _asyncLoop.apply(this, arguments);
}
exports.asyncLoop = asyncLoop;
function toBytes(data) {
    if (typeof data === "string") data = new TextEncoder().encode(data);
    if (!(data instanceof Uint8Array)) throw new TypeError("Expected input type is Uint8Array (got ".concat(typeof data === "undefined" ? "undefined" : (0, $aVMuR._)(data), ")"));
    return data;
}
exports.toBytes = toBytes;
function assertNumber(n) {
    if (!Number.isSafeInteger(n)) throw new Error("Wrong integer: ".concat(n));
}
exports.assertNumber = assertNumber;
function assertBool(b) {
    if (typeof b !== "boolean") throw new Error("Expected boolean, not ".concat(b));
}
exports.assertBool = assertBool;
function assertHash(hash) {
    if (typeof hash !== "function" || typeof hash.init !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    assertNumber(hash.outputLen);
    assertNumber(hash.blockLen);
}
exports.assertHash = assertHash;
// For runtime check if class implements interface
var Hash = /*#__PURE__*/ function() {
    function Hash() {
        (0, $7dKN1._)(this, Hash);
    }
    (0, $eW5pA._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
exports.Hash = Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
var isPlainObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
};
function checkOpts(def, _opts) {
    if (_opts !== undefined && (typeof _opts !== "object" || !isPlainObject(_opts))) throw new TypeError("Options should be object or undefined");
    var opts = Object.assign(def, _opts);
    return opts;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashConstructor) {
    var hashC = function(message) {
        return hashConstructor().update(toBytes(message)).digest();
    };
    var tmp = hashConstructor();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashConstructor();
    };
    hashC.init = hashC.create;
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update(toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    hashC.init = hashC.create;
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function randomBytes() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ($d6hEv.crypto.web) return $d6hEv.crypto.web.getRandomValues(new Uint8Array(bytesLength));
    else if ($d6hEv.crypto.node) return new Uint8Array($d6hEv.crypto.node.randomBytes(bytesLength).buffer);
    else throw new Error("The environment doesn't have randomBytes function");
}
exports.randomBytes = randomBytes;

});
parcelRegister("d6hEv", function(module, exports) {
"use strict";
var $9899874851eeba92$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;

var $9899874851eeba92$var$crypto_1 = $9899874851eeba92$var$__importDefault((parcelRequire("24TKi")));
module.exports.crypto = {
    node: $9899874851eeba92$var$crypto_1.default,
    web: undefined
};

});



parcelRegister("5zObe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5H = module.exports.add5L = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
var $40f7255d9f63f357$var$U32_MASK64 = BigInt(Math.pow(2, 32) - 1);
var $40f7255d9f63f357$var$_32n = BigInt(32);
function $40f7255d9f63f357$var$fromBig(n) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (le) return {
        h: Number(n & $40f7255d9f63f357$var$U32_MASK64),
        l: Number(n >> $40f7255d9f63f357$var$_32n & $40f7255d9f63f357$var$U32_MASK64)
    };
    return {
        h: Number(n >> $40f7255d9f63f357$var$_32n & $40f7255d9f63f357$var$U32_MASK64) | 0,
        l: Number(n & $40f7255d9f63f357$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $40f7255d9f63f357$var$fromBig;
function $40f7255d9f63f357$var$split(lst) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for(var i = 0; i < lst.length; i++){
        var _fromBig = $40f7255d9f63f357$var$fromBig(lst[i], le), h = _fromBig.h, l = _fromBig.l;
        var ref;
        ref = [
            h,
            l
        ], Ah[i] = ref[0], Al[i] = ref[1], ref;
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $40f7255d9f63f357$var$split;
var $40f7255d9f63f357$var$toBig = function(h, l) {
    return BigInt(h >>> 0) << $40f7255d9f63f357$var$_32n | BigInt(l >>> 0);
};
module.exports.toBig = $40f7255d9f63f357$var$toBig;
// for Shift in [0, 32)
var $40f7255d9f63f357$var$shrSH = function(h, l, s) {
    return h >>> s;
};
module.exports.shrSH = $40f7255d9f63f357$var$shrSH;
var $40f7255d9f63f357$var$shrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
module.exports.shrSL = $40f7255d9f63f357$var$shrSL;
// Right rotate for Shift in [1, 32)
var $40f7255d9f63f357$var$rotrSH = function(h, l, s) {
    return h >>> s | l << 32 - s;
};
module.exports.rotrSH = $40f7255d9f63f357$var$rotrSH;
var $40f7255d9f63f357$var$rotrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
module.exports.rotrSL = $40f7255d9f63f357$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var $40f7255d9f63f357$var$rotrBH = function(h, l, s) {
    return h << 64 - s | l >>> s - 32;
};
module.exports.rotrBH = $40f7255d9f63f357$var$rotrBH;
var $40f7255d9f63f357$var$rotrBL = function(h, l, s) {
    return h >>> s - 32 | l << 64 - s;
};
module.exports.rotrBL = $40f7255d9f63f357$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
var $40f7255d9f63f357$var$rotr32H = function(h, l) {
    return l;
};
module.exports.rotr32H = $40f7255d9f63f357$var$rotr32H;
var $40f7255d9f63f357$var$rotr32L = function(h, l) {
    return h;
};
module.exports.rotr32L = $40f7255d9f63f357$var$rotr32L;
// Left rotate for Shift in [1, 32)
var $40f7255d9f63f357$var$rotlSH = function(h, l, s) {
    return h << s | l >>> 32 - s;
};
module.exports.rotlSH = $40f7255d9f63f357$var$rotlSH;
var $40f7255d9f63f357$var$rotlSL = function(h, l, s) {
    return l << s | h >>> 32 - s;
};
module.exports.rotlSL = $40f7255d9f63f357$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var $40f7255d9f63f357$var$rotlBH = function(h, l, s) {
    return l << s - 32 | h >>> 64 - s;
};
module.exports.rotlBH = $40f7255d9f63f357$var$rotlBH;
var $40f7255d9f63f357$var$rotlBL = function(h, l, s) {
    return h << s - 32 | l >>> 64 - s;
};
module.exports.rotlBL = $40f7255d9f63f357$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $40f7255d9f63f357$var$add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $40f7255d9f63f357$var$add;
// Addition with more than 2 elements
var $40f7255d9f63f357$var$add3L = function(Al, Bl, Cl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};
module.exports.add3L = $40f7255d9f63f357$var$add3L;
var $40f7255d9f63f357$var$add3H = function(low, Ah, Bh, Ch) {
    return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};
module.exports.add3H = $40f7255d9f63f357$var$add3H;
var $40f7255d9f63f357$var$add4L = function(Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
module.exports.add4L = $40f7255d9f63f357$var$add4L;
var $40f7255d9f63f357$var$add4H = function(low, Ah, Bh, Ch, Dh) {
    return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};
module.exports.add4H = $40f7255d9f63f357$var$add4H;
var $40f7255d9f63f357$var$add5L = function(Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
module.exports.add5L = $40f7255d9f63f357$var$add5L;
var $40f7255d9f63f357$var$add5H = function(low, Ah, Bh, Ch, Dh, Eh) {
    return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};
module.exports.add5H = $40f7255d9f63f357$var$add5H;

});

parcelRegister("e1Yck", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $a36fdab9f5d49b6f$require$Buffer = $ilnag.Buffer;
"use strict";
var $a36fdab9f5d49b6f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a36fdab9f5d49b6f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
module.exports.__esModule = true;
module.exports.CosmosApp = void 0;

var $knz6U = parcelRequire("knz6U");

var $jBMDz = parcelRequire("jBMDz");

var $fbo4B = parcelRequire("fbo4B");

var $5xFHp = parcelRequire("5xFHp");

var $gHFi0 = parcelRequire("gHFi0");

var $aEC5U = parcelRequire("aEC5U");
var $a36fdab9f5d49b6f$var$CosmosApp = /** @class */ function() {
    function CosmosApp(transport) {
        if (!transport) throw new Error("Transport has not been defined");
        this.transport = transport;
    }
    CosmosApp.serializeHRP = function(hrp) {
        if (hrp == null || hrp.length < 3 || hrp.length > 83) throw new Error("Invalid HRP");
        var buf = $a36fdab9f5d49b6f$require$Buffer.alloc(1 + hrp.length);
        buf.writeUInt8(hrp.length, 0);
        buf.write(hrp, 1);
        return buf;
    };
    CosmosApp.getBech32FromPK = function(hrp, pk) {
        if (pk.length !== 33) throw new Error("expected compressed public key [31 bytes]");
        var hashSha256 = $5xFHp.createHash("sha256").update(pk).digest();
        var hashRip = new $aEC5U().update(hashSha256).digest();
        return $gHFi0.encode(hrp, $gHFi0.toWords(hashRip));
    };
    CosmosApp.prototype.serializePath = function(path) {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $a36fdab9f5d49b6f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, $knz6U.getVersion)(this.transport)
                        ];
                    case 1:
                        _a.versionResponse = _b.sent();
                        if (this.versionResponse.return_code !== $knz6U.ERROR_CODE.NoError) throw this.versionResponse;
                        switch(this.versionResponse.major){
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    (0, $jBMDz.serializePathv1)(path)
                                ];
                            case 2:
                                return [
                                    2 /*return*/ ,
                                    (0, $fbo4B.serializePathv2)(path)
                                ];
                            default:
                                return [
                                    2 /*return*/ ,
                                    $a36fdab9f5d49b6f$require$Buffer.alloc(0)
                                ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CosmosApp.prototype.signGetChunks = function(path, buffer) {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            var serializedPath, chunks, i, end;
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.serializePath(path)
                        ];
                    case 1:
                        serializedPath = _a.sent();
                        chunks = [];
                        chunks.push(serializedPath);
                        for(i = 0; i < buffer.length; i += $knz6U.CHUNK_SIZE){
                            end = i + $knz6U.CHUNK_SIZE;
                            if (i > buffer.length) end = buffer.length;
                            chunks.push(buffer.slice(i, end));
                        }
                        return [
                            2 /*return*/ ,
                            chunks
                        ];
                }
            });
        });
    };
    CosmosApp.prototype.getVersion = function() {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            var _a, e_1;
            return $a36fdab9f5d49b6f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, $knz6U.getVersion)(this.transport)
                        ];
                    case 1:
                        _a.versionResponse = _b.sent();
                        return [
                            2 /*return*/ ,
                            this.versionResponse
                        ];
                    case 2:
                        e_1 = _b.sent();
                        return [
                            2 /*return*/ ,
                            (0, $knz6U.processErrorResponse)(e_1)
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CosmosApp.prototype.appInfo = function() {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.transport.send(0xb0, 0x01, 0, 0).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var appName = "";
                        var appVersion = "";
                        var flagLen = 0;
                        var flagsValue = 0;
                        if (response[0] !== 1) // Ledger responds with format ID 1. There is no spec for any format != 1
                        return {
                            return_code: 0x9001,
                            error_message: "response format ID not recognized"
                        };
                        else {
                            var appNameLen = response[1];
                            appName = response.slice(2, 2 + appNameLen).toString("ascii");
                            var idx = 2 + appNameLen;
                            var appVersionLen = response[idx];
                            idx += 1;
                            appVersion = response.slice(idx, idx + appVersionLen).toString("ascii");
                            idx += appVersionLen;
                            var appFlagsLen = response[idx];
                            idx += 1;
                            flagLen = appFlagsLen;
                            flagsValue = response[idx];
                        }
                        return {
                            return_code: returnCode,
                            error_message: (0, $knz6U.errorCodeToString)(returnCode),
                            // //
                            appName: appName,
                            appVersion: appVersion,
                            flagLen: flagLen,
                            flagsValue: flagsValue,
                            // eslint-disable-next-line no-bitwise
                            flag_recovery: (flagsValue & 1) !== 0,
                            // eslint-disable-next-line no-bitwise
                            flag_signed_mcu_code: (flagsValue & 2) !== 0,
                            // eslint-disable-next-line no-bitwise
                            flag_onboarded: (flagsValue & 4) !== 0,
                            // eslint-disable-next-line no-bitwise
                            flag_pin_validated: (flagsValue & 128) !== 0
                        };
                    }, $knz6U.processErrorResponse)
                ];
            });
        });
    };
    CosmosApp.prototype.deviceInfo = function() {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.transport.send(0xe0, 0x01, 0, 0, $a36fdab9f5d49b6f$require$Buffer.from([]), [
                        $knz6U.ERROR_CODE.NoError,
                        0x6e00
                    ]).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        if (returnCode === 0x6e00) return {
                            return_code: returnCode,
                            error_message: "This command is only available in the Dashboard"
                        };
                        var targetId = response.slice(0, 4).toString("hex");
                        var pos = 4;
                        var secureElementVersionLen = response[pos];
                        pos += 1;
                        var seVersion = response.slice(pos, pos + secureElementVersionLen).toString();
                        pos += secureElementVersionLen;
                        var flagsLen = response[pos];
                        pos += 1;
                        var flag = response.slice(pos, pos + flagsLen).toString("hex");
                        pos += flagsLen;
                        var mcuVersionLen = response[pos];
                        pos += 1;
                        // Patch issue in mcu version
                        var tmp = response.slice(pos, pos + mcuVersionLen);
                        if (tmp[mcuVersionLen - 1] === 0) tmp = response.slice(pos, pos + mcuVersionLen - 1);
                        var mcuVersion = tmp.toString();
                        return {
                            return_code: returnCode,
                            error_message: (0, $knz6U.errorCodeToString)(returnCode),
                            // //
                            targetId: targetId,
                            seVersion: seVersion,
                            flag: flag,
                            mcuVersion: mcuVersion
                        };
                    }, $knz6U.processErrorResponse)
                ];
            });
        });
    };
    CosmosApp.prototype.publicKey = function(path) {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            var serializedPath, data, e_2;
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.serializePath(path)
                        ];
                    case 1:
                        serializedPath = _a.sent();
                        switch(this.versionResponse.major){
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    (0, $jBMDz.publicKeyv1)(this, serializedPath)
                                ];
                            case 2:
                                data = $a36fdab9f5d49b6f$require$Buffer.concat([
                                    CosmosApp.serializeHRP("cosmos"),
                                    serializedPath
                                ]);
                                return [
                                    2 /*return*/ ,
                                    (0, $fbo4B.publicKeyv2)(this, data)
                                ];
                            default:
                                return [
                                    2 /*return*/ ,
                                    {
                                        return_code: 0x6400,
                                        error_message: "App Version is not supported"
                                    }
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_2 = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $knz6U.processErrorResponse)(e_2)
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CosmosApp.prototype.getAddressAndPubKey = function(path, hrp, showInDevice) {
        if (showInDevice === void 0) showInDevice = false;
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.serializePath(path).then(function(serializedPath) {
                        var data = $a36fdab9f5d49b6f$require$Buffer.concat([
                            CosmosApp.serializeHRP(hrp),
                            serializedPath
                        ]);
                        return _this.transport.send($knz6U.CLA, $knz6U.INS.GET_ADDR_SECP256K1, showInDevice ? $knz6U.P1_VALUES.SHOW_ADDRESS_IN_DEVICE : $knz6U.P1_VALUES.ONLY_RETRIEVE, 0, data, [
                            $knz6U.ERROR_CODE.NoError
                        ]).then(function(response) {
                            var errorCodeData = response.slice(-2);
                            var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                            var compressedPk = $a36fdab9f5d49b6f$require$Buffer.from(response.slice(0, 33));
                            var bech32Address = $a36fdab9f5d49b6f$require$Buffer.from(response.slice(33, -2)).toString();
                            return {
                                bech32_address: bech32Address,
                                compressed_pk: compressedPk,
                                return_code: returnCode,
                                error_message: (0, $knz6U.errorCodeToString)(returnCode)
                            };
                        }, $knz6U.processErrorResponse);
                    })["catch"](function(err) {
                        return (0, $knz6U.processErrorResponse)(err);
                    })
                ];
            });
        });
    };
    CosmosApp.prototype.showAddressAndPubKey = function(path, hrp) {
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.getAddressAndPubKey(path, hrp, true)
                ];
            });
        });
    };
    CosmosApp.prototype.signSendChunk = function(chunkIdx, chunkNum, chunk, txType) {
        if (txType === void 0) txType = $knz6U.P2_VALUES.JSON;
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                switch(this.versionResponse.major){
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, $jBMDz.signSendChunkv1)(this, chunkIdx, chunkNum, chunk, txType)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            (0, $fbo4B.signSendChunkv2)(this, chunkIdx, chunkNum, chunk, txType)
                        ];
                    default:
                        return [
                            2 /*return*/ ,
                            {
                                return_code: 0x6400,
                                error_message: "App Version is not supported"
                            }
                        ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CosmosApp.prototype.sign = function(path, buffer, txType) {
        if (txType === void 0) txType = $knz6U.P2_VALUES.JSON;
        return $a36fdab9f5d49b6f$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.signGetChunks(path, buffer).then(function(chunks) {
                        return _this.signSendChunk(1, chunks.length, chunks[0], txType).then(function(response) {
                            return $a36fdab9f5d49b6f$var$__awaiter(_this, void 0, void 0, function() {
                                var result, i;
                                return $a36fdab9f5d49b6f$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            result = {
                                                return_code: response.return_code,
                                                error_message: response.error_message,
                                                signature: null
                                            };
                                            i = 1;
                                            _a.label = 1;
                                        case 1:
                                            if (!(i < chunks.length)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.signSendChunk(1 + i, chunks.length, chunks[i], txType)
                                            ];
                                        case 2:
                                            // eslint-disable-next-line no-await-in-loop
                                            result = _a.sent();
                                            if (result.return_code !== $knz6U.ERROR_CODE.NoError) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            _a.label = 3;
                                        case 3:
                                            i += 1;
                                            return [
                                                3 /*break*/ ,
                                                1
                                            ];
                                        case 4:
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    return_code: result.return_code,
                                                    error_message: result.error_message,
                                                    // ///
                                                    signature: result.signature
                                                }
                                            ];
                                    }
                                });
                            });
                        }, $knz6U.processErrorResponse);
                    }, $knz6U.processErrorResponse)
                ];
            });
        });
    };
    return CosmosApp;
}();
module.exports.CosmosApp = $a36fdab9f5d49b6f$var$CosmosApp;

});
parcelRegister("knz6U", function(module, exports) {
"use strict";
/** ******************************************************************************
 *  (c) 2018 - 2022 Zondax AG
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */ var $ed6130db3957b9e0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ed6130db3957b9e0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
module.exports.__esModule = true;
module.exports.getVersion = module.exports.processErrorResponse = module.exports.errorCodeToString = module.exports.ERROR_CODE = module.exports.P2_VALUES = module.exports.P1_VALUES = module.exports.PAYLOAD_TYPE = module.exports.INS = module.exports.APP_KEY = module.exports.CHUNK_SIZE = module.exports.CLA = void 0;
module.exports.CLA = 0x55;
module.exports.CHUNK_SIZE = 250;
module.exports.APP_KEY = "CSM";
module.exports.INS = {
    GET_VERSION: 0x00,
    INS_PUBLIC_KEY_SECP256K1: 0x01,
    SIGN_SECP256K1: 0x02,
    GET_ADDR_SECP256K1: 0x04
};
module.exports.PAYLOAD_TYPE = {
    INIT: 0x00,
    ADD: 0x01,
    LAST: 0x02
};
module.exports.P1_VALUES = {
    ONLY_RETRIEVE: 0x00,
    SHOW_ADDRESS_IN_DEVICE: 0x01
};
module.exports.P2_VALUES = {
    JSON: 0x0,
    TEXTUAL: 0x1
};
module.exports.ERROR_CODE = {
    NoError: 0x9000
};
var $ed6130db3957b9e0$var$ERROR_DESCRIPTION = {
    1: "U2F: Unknown",
    2: "U2F: Bad request",
    3: "U2F: Configuration unsupported",
    4: "U2F: Device Ineligible",
    5: "U2F: Timeout",
    14: "Timeout",
    0x9000: "No errors",
    0x9001: "Device is busy",
    0x6802: "Error deriving keys",
    0x6400: "Execution Error",
    0x6700: "Wrong Length",
    0x6982: "Empty Buffer",
    0x6983: "Output buffer too small",
    0x6984: "Data is invalid",
    0x6985: "Conditions not satisfied",
    0x6986: "Transaction rejected",
    0x6a80: "Bad key handle",
    0x6b00: "Invalid P1/P2",
    0x6d00: "Instruction not supported",
    0x6e00: "App does not seem to be open",
    0x6f00: "Unknown error",
    0x6f01: "Sign/verify error"
};
function $ed6130db3957b9e0$var$errorCodeToString(statusCode) {
    if (statusCode in $ed6130db3957b9e0$var$ERROR_DESCRIPTION) return $ed6130db3957b9e0$var$ERROR_DESCRIPTION[statusCode];
    return "Unknown Status Code: ".concat(statusCode);
}
module.exports.errorCodeToString = $ed6130db3957b9e0$var$errorCodeToString;
function $ed6130db3957b9e0$var$isDict(v) {
    return typeof v === "object" && v !== null && !(v instanceof Array) && !(v instanceof Date);
}
function $ed6130db3957b9e0$var$processErrorResponse(response) {
    if (response) {
        if ($ed6130db3957b9e0$var$isDict(response)) {
            if (Object.prototype.hasOwnProperty.call(response, "statusCode")) return {
                return_code: response.statusCode,
                error_message: $ed6130db3957b9e0$var$errorCodeToString(response.statusCode)
            };
            if (Object.prototype.hasOwnProperty.call(response, "return_code") && Object.prototype.hasOwnProperty.call(response, "error_message")) return response;
        }
        return {
            return_code: 0xffff,
            error_message: response.toString()
        };
    }
    return {
        return_code: 0xffff,
        error_message: response.toString()
    };
}
module.exports.processErrorResponse = $ed6130db3957b9e0$var$processErrorResponse;
function $ed6130db3957b9e0$var$getVersion(transport) {
    return $ed6130db3957b9e0$var$__awaiter(this, void 0, void 0, function() {
        return $ed6130db3957b9e0$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                transport.send(module.exports.CLA, module.exports.INS.GET_VERSION, 0, 0).then(function(response) {
                    var errorCodeData = response.slice(-2);
                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                    var targetId = 0;
                    if (response.length >= 9) /* eslint-disable no-bitwise */ targetId = (response[5] << 24) + (response[6] << 16) + (response[7] << 8) + (response[8] << 0);
                    return {
                        return_code: returnCode,
                        error_message: $ed6130db3957b9e0$var$errorCodeToString(returnCode),
                        // ///
                        test_mode: response[0] !== 0,
                        major: response[1],
                        minor: response[2],
                        patch: response[3],
                        device_locked: response[4] === 1,
                        target_id: targetId.toString(16)
                    };
                }, $ed6130db3957b9e0$var$processErrorResponse)
            ];
        });
    });
}
module.exports.getVersion = $ed6130db3957b9e0$var$getVersion;

});

parcelRegister("jBMDz", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $e4673362fc507e28$require$Buffer = $ilnag.Buffer;
"use strict";
var $e4673362fc507e28$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e4673362fc507e28$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
module.exports.__esModule = true;
module.exports.publicKeyv1 = module.exports.signSendChunkv1 = module.exports.serializePathv1 = void 0;

var $knz6U = parcelRequire("knz6U");
function $e4673362fc507e28$var$serializePathv1(path) {
    if (path == null || path.length < 3) throw new Error("Invalid path.");
    if (path.length > 10) throw new Error("Invalid path. Length should be <= 10");
    var buf = $e4673362fc507e28$require$Buffer.alloc(1 + 4 * path.length);
    buf.writeUInt8(path.length, 0);
    for(var i = 0; i < path.length; i += 1){
        var v = path[i];
        if (i < 3) // eslint-disable-next-line no-bitwise
        v |= 0x80000000; // Harden
        buf.writeInt32LE(v, 1 + i * 4);
    }
    return buf;
}
module.exports.serializePathv1 = $e4673362fc507e28$var$serializePathv1;
function $e4673362fc507e28$var$signSendChunkv1(app, chunkIdx, chunkNum, chunk, txType) {
    if (txType === void 0) txType = $knz6U.P2_VALUES.JSON;
    return $e4673362fc507e28$var$__awaiter(this, void 0, void 0, function() {
        return $e4673362fc507e28$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                app.transport.send($knz6U.CLA, $knz6U.INS.SIGN_SECP256K1, chunkIdx, txType, chunk, [
                    $knz6U.ERROR_CODE.NoError,
                    0x6984,
                    0x6a80
                ]).then(function(response) {
                    var errorCodeData = response.slice(-2);
                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                    var errorMessage = (0, $knz6U.errorCodeToString)(returnCode);
                    if (returnCode === 0x6a80 || returnCode === 0x6984) errorMessage = "".concat(errorMessage, " : ").concat(response.slice(0, response.length - 2).toString("ascii"));
                    var signature = null;
                    if (response.length > 2) signature = response.slice(0, response.length - 2);
                    return {
                        signature: signature,
                        return_code: returnCode,
                        error_message: errorMessage
                    };
                }, $knz6U.processErrorResponse)
            ];
        });
    });
}
module.exports.signSendChunkv1 = $e4673362fc507e28$var$signSendChunkv1;
function $e4673362fc507e28$var$compressPublicKey(publicKey) {
    if (publicKey.length !== 65) throw new Error("decompressed public key length should be 65 bytes");
    var y = publicKey.slice(33, 65);
    // eslint-disable-next-line no-bitwise
    var z = $e4673362fc507e28$require$Buffer.from([
        2 + (y[y.length - 1] & 1)
    ]);
    return $e4673362fc507e28$require$Buffer.concat([
        z,
        publicKey.slice(1, 33)
    ]);
}
function $e4673362fc507e28$var$publicKeyv1(app, data) {
    return $e4673362fc507e28$var$__awaiter(this, void 0, void 0, function() {
        return $e4673362fc507e28$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                app.transport.send($knz6U.CLA, $knz6U.INS.INS_PUBLIC_KEY_SECP256K1, 0, 0, data, [
                    $knz6U.ERROR_CODE.NoError
                ]).then(function(response) {
                    var errorCodeData = response.slice(-2);
                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                    var pk = $e4673362fc507e28$require$Buffer.from(response.slice(0, 65));
                    return {
                        pk: pk,
                        compressed_pk: $e4673362fc507e28$var$compressPublicKey(pk),
                        return_code: returnCode,
                        error_message: (0, $knz6U.errorCodeToString)(returnCode)
                    };
                }, $knz6U.processErrorResponse)
            ];
        });
    });
}
module.exports.publicKeyv1 = $e4673362fc507e28$var$publicKeyv1;

});

parcelRegister("fbo4B", function(module, exports) {

var $ilnag = parcelRequire("ilnag");
var $b0da8e860d1e561e$require$Buffer = $ilnag.Buffer;
"use strict";
var $b0da8e860d1e561e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b0da8e860d1e561e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
module.exports.__esModule = true;
module.exports.publicKeyv2 = module.exports.signSendChunkv2 = module.exports.serializePathv2 = void 0;

var $jBMDz = parcelRequire("jBMDz");

var $knz6U = parcelRequire("knz6U");
function $b0da8e860d1e561e$var$serializePathv2(path) {
    if (!path || path.length !== 5) throw new Error("Invalid path.");
    var buf = $b0da8e860d1e561e$require$Buffer.alloc(20);
    buf.writeUInt32LE(0x80000000 + path[0], 0);
    buf.writeUInt32LE(0x80000000 + path[1], 4);
    buf.writeUInt32LE(0x80000000 + path[2], 8);
    buf.writeUInt32LE(path[3], 12);
    buf.writeUInt32LE(path[4], 16);
    return buf;
}
module.exports.serializePathv2 = $b0da8e860d1e561e$var$serializePathv2;
function $b0da8e860d1e561e$var$signSendChunkv2(app, chunkIdx, chunkNum, chunk, txType) {
    if (txType === void 0) txType = $knz6U.P2_VALUES.JSON;
    return $b0da8e860d1e561e$var$__awaiter(this, void 0, void 0, function() {
        var payloadType;
        return $b0da8e860d1e561e$var$__generator(this, function(_a) {
            payloadType = $knz6U.PAYLOAD_TYPE.ADD;
            if (chunkIdx === 1) payloadType = $knz6U.PAYLOAD_TYPE.INIT;
            if (chunkIdx === chunkNum) payloadType = $knz6U.PAYLOAD_TYPE.LAST;
            return [
                2 /*return*/ ,
                (0, $jBMDz.signSendChunkv1)(app, payloadType, 0, chunk, txType)
            ];
        });
    });
}
module.exports.signSendChunkv2 = $b0da8e860d1e561e$var$signSendChunkv2;
function $b0da8e860d1e561e$var$publicKeyv2(app, data) {
    return $b0da8e860d1e561e$var$__awaiter(this, void 0, void 0, function() {
        return $b0da8e860d1e561e$var$__generator(this, function(_a) {
            return [
                2 /*return*/ ,
                app.transport.send($knz6U.CLA, $knz6U.INS.GET_ADDR_SECP256K1, 0, 0, data, [
                    $knz6U.ERROR_CODE.NoError
                ]).then(function(response) {
                    var errorCodeData = response.slice(-2);
                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                    var compressedPk = $b0da8e860d1e561e$require$Buffer.from(response.slice(0, 33));
                    return {
                        pk: "OBSOLETE PROPERTY",
                        compressed_pk: compressedPk,
                        return_code: returnCode,
                        error_message: (0, $knz6U.errorCodeToString)(returnCode)
                    };
                }, $knz6U.processErrorResponse)
            ];
        });
    });
}
module.exports.publicKeyv2 = $b0da8e860d1e561e$var$publicKeyv2;

});


parcelRegister("67h2x", function(module, exports) {

module.exports = (parcelRequire("7PYug"));

});
parcelRegister("7PYug", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5b4c3754755cd725$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function() {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
        return this;
    };
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator["return"]) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
        return this;
    };
    Gp.toString = function() {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $5b4c3754755cd725$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")($5b4c3754755cd725$var$runtime);
}

});


parcelRegister("4hJjN", function(module, exports) {

var $9t8kw = parcelRequire("9t8kw");

var $id3hJ = parcelRequire("id3hJ");

var $1N0fs = parcelRequire("1N0fs");

var $kE3F1 = parcelRequire("kE3F1");
function $31ebe73915ad665d$var$_toConsumableArray(arr) {
    return $9t8kw(arr) || $id3hJ(arr) || $1N0fs(arr) || $kE3F1();
}
module.exports = $31ebe73915ad665d$var$_toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("9t8kw", function(module, exports) {

var $lvqYM = parcelRequire("lvqYM");
function $6e4d48a850e3bd28$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $lvqYM(arr);
}
module.exports = $6e4d48a850e3bd28$var$_arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});
parcelRegister("lvqYM", function(module, exports) {
function $fa816bbb1c3e92d6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $fa816bbb1c3e92d6$var$_arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("id3hJ", function(module, exports) {
function $d41bfd340a0604fa$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = $d41bfd340a0604fa$var$_iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("1N0fs", function(module, exports) {

var $lvqYM = parcelRequire("lvqYM");
function $14da8f5d9e2df0d8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $lvqYM(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $lvqYM(o, minLen);
}
module.exports = $14da8f5d9e2df0d8$var$_unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("kE3F1", function(module, exports) {
function $f07a61fbd33f9973$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $f07a61fbd33f9973$var$_nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});


parcelRegister("aasQN", function(module, exports) {
function $767137a7be7985bb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $767137a7be7985bb$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $767137a7be7985bb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $767137a7be7985bb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $767137a7be7985bb$var$_asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("5DYAP", function(module, exports) {
function $41bf98cc94b41eb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $41bf98cc94b41eb7$var$_classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("jEeEI", function(module, exports) {
function $e4dd1f0ff36d5c26$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e4dd1f0ff36d5c26$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e4dd1f0ff36d5c26$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e4dd1f0ff36d5c26$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = $e4dd1f0ff36d5c26$var$_createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("bOCFh", function(module, exports) {
function $89a25b4021712fe5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = $89a25b4021712fe5$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $89a25b4021712fe5$var$_typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $89a25b4021712fe5$var$_typeof(obj);
}
module.exports = $89a25b4021712fe5$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("6uziT", function(module, exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

});

parcelRegister("dUcoq", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("iEGT8", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("6Wih2", function(module, exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

});

parcelRegister("4t7kS", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

});

parcelRegister("kd8bJ", function(module, exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

});

parcelRegister("95oK7", function(module, exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRegister("603gt", function(module, exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

});

parcelRegister("cjHVk", function(module, exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

});

parcelRegister("1CxPl", function(module, exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

});

parcelRegister("dItct", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("kbOln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb2be2f3b2aa3690$export$2e2bcd8739ae039; });

var $eaQXQ = parcelRequire("eaQXQ");

var $64t2S = parcelRequire("64t2S");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $eaQXQ.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $64t2S.default);
var $eb2be2f3b2aa3690$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("eaQXQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a51b1575ccc06a2b$export$2e2bcd8739ae039; });

var $2f6Cf = parcelRequire("2f6Cf");
/** Detect free variable `self`. */ var $a51b1575ccc06a2b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a51b1575ccc06a2b$var$root = (0, $2f6Cf.default) || $a51b1575ccc06a2b$var$freeSelf || Function("return this")();
var $a51b1575ccc06a2b$export$2e2bcd8739ae039 = $a51b1575ccc06a2b$var$root;

});
parcelRegister("2f6Cf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a221d40dd3921ad$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $1a221d40dd3921ad$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $1a221d40dd3921ad$export$2e2bcd8739ae039 = $1a221d40dd3921ad$var$freeGlobal;

});


parcelRegister("64t2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b9a59fa9888c4d$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $46b9a59fa9888c4d$var$stubFalse() {
    return false;
}
var $46b9a59fa9888c4d$export$2e2bcd8739ae039 = $46b9a59fa9888c4d$var$stubFalse;

});


parcelRegister("7gJxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ad59ee68a6bf2d$export$2e2bcd8739ae039; });

var $2f6Cf = parcelRequire("2f6Cf");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $2f6Cf.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $54ad59ee68a6bf2d$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("4bXmX", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3YqWF", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("bUKt0", function(module, exports) {

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.validateBasic = validateBasic;

var $ev04Q = parcelRequire("ev04Q");

var $1YtXk = parcelRequire("1YtXk");
var _0n = BigInt(0);
var _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    var constTimeNegate = function(condition, item) {
        var neg = item.negate();
        return condition ? neg : item;
    };
    var opts = function(W) {
        var windows = Math.ceil(bits / W) + 1; // +1, because
        var windowSize = Math.pow(2, W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder: function(elm, n) {
            var p = c.ZERO;
            var d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow: function(elm, W) {
            var _opts = opts(W), windows = _opts.windows, windowSize = _opts.windowSize;
            var points = [];
            var p = elm;
            var base = p;
            for(var window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(var i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF: function(W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            var _opts = opts(W), windows = _opts.windows, windowSize = _opts.windowSize;
            var p = c.ZERO;
            var f = c.BASE;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for(var window = 0; window < windows; window++){
                var offset = window * windowSize;
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                var offset1 = offset;
                var offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                var cond1 = window % 2 !== 0;
                var cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached: function(P, precomputesMap, n, transform) {
            // @ts-ignore
            var W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            var comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $ev04Q.validateField)(curve.Fp);
    (0, $1YtXk.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze((0, $gddcW._)((0, $4JCw4._)({}, (0, $ev04Q.nLength)(curve.n, curve.nBitLength), curve), {
        p: curve.Fp.ORDER
    }));
}

});
parcelRegister("ev04Q", function(module, exports) {

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNegativeLE = void 0;
module.exports.mod = $a8e40545709e7048$var$mod;
module.exports.pow = $a8e40545709e7048$var$pow;
module.exports.pow2 = $a8e40545709e7048$var$pow2;
module.exports.invert = $a8e40545709e7048$var$invert;
module.exports.tonelliShanks = $a8e40545709e7048$var$tonelliShanks;
module.exports.FpSqrt = $a8e40545709e7048$var$FpSqrt;
module.exports.validateField = $a8e40545709e7048$var$validateField;
module.exports.FpPow = $a8e40545709e7048$var$FpPow;
module.exports.FpInvertBatch = $a8e40545709e7048$var$FpInvertBatch;
module.exports.FpDiv = $a8e40545709e7048$var$FpDiv;
module.exports.FpIsSquare = $a8e40545709e7048$var$FpIsSquare;
module.exports.nLength = $a8e40545709e7048$var$nLength;
module.exports.Field = $a8e40545709e7048$var$Field;
module.exports.FpSqrtOdd = $a8e40545709e7048$var$FpSqrtOdd;
module.exports.FpSqrtEven = $a8e40545709e7048$var$FpSqrtEven;
module.exports.hashToPrivateScalar = $a8e40545709e7048$var$hashToPrivateScalar;
module.exports.getFieldBytesLength = $a8e40545709e7048$var$getFieldBytesLength;
module.exports.getMinHashLength = $a8e40545709e7048$var$getMinHashLength;
module.exports.mapHashToField = $a8e40545709e7048$var$mapHashToField;

var $1YtXk = parcelRequire("1YtXk");
// prettier-ignore
var $a8e40545709e7048$var$_0n = BigInt(0), $a8e40545709e7048$var$_1n = BigInt(1), $a8e40545709e7048$var$_2n = BigInt(2), $a8e40545709e7048$var$_3n = BigInt(3);
// prettier-ignore
var $a8e40545709e7048$var$_4n = BigInt(4), $a8e40545709e7048$var$_5n = BigInt(5), $a8e40545709e7048$var$_8n = BigInt(8);
// prettier-ignore
var $a8e40545709e7048$var$_9n = BigInt(9), $a8e40545709e7048$var$_16n = BigInt(16);
// Calculates a modulo b
function $a8e40545709e7048$var$mod(a, b) {
    var result = a % b;
    return result >= $a8e40545709e7048$var$_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $a8e40545709e7048$var$pow(num, power, modulo) {
    if (modulo <= $a8e40545709e7048$var$_0n || power < $a8e40545709e7048$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $a8e40545709e7048$var$_1n) return $a8e40545709e7048$var$_0n;
    var res = $a8e40545709e7048$var$_1n;
    while(power > $a8e40545709e7048$var$_0n){
        if (power & $a8e40545709e7048$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $a8e40545709e7048$var$_1n;
    }
    return res;
}
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $a8e40545709e7048$var$pow2(x, power, modulo) {
    var res = x;
    while(power-- > $a8e40545709e7048$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
// Inverses number over modulo
function $a8e40545709e7048$var$invert(number, modulo) {
    if (number === $a8e40545709e7048$var$_0n || modulo <= $a8e40545709e7048$var$_0n) throw new Error("invert: expected positive integers, got n=".concat(number, " mod=").concat(modulo));
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    var a = $a8e40545709e7048$var$mod(number, modulo);
    var b = modulo;
    // prettier-ignore
    var x = $a8e40545709e7048$var$_0n, y = $a8e40545709e7048$var$_1n, u = $a8e40545709e7048$var$_1n, v = $a8e40545709e7048$var$_0n;
    while(a !== $a8e40545709e7048$var$_0n){
        // JIT applies optimization if those two lines follow each other
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    var gcd = b;
    if (gcd !== $a8e40545709e7048$var$_1n) throw new Error("invert: does not exist");
    return $a8e40545709e7048$var$mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $a8e40545709e7048$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreC = (P - $a8e40545709e7048$var$_1n) / $a8e40545709e7048$var$_2n;
    var Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $a8e40545709e7048$var$_1n, S = 0; Q % $a8e40545709e7048$var$_2n === $a8e40545709e7048$var$_0n; Q /= $a8e40545709e7048$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $a8e40545709e7048$var$_2n; Z < P && $a8e40545709e7048$var$pow(Z, legendreC, P) !== P - $a8e40545709e7048$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        var p1div4 = (P + $a8e40545709e7048$var$_1n) / $a8e40545709e7048$var$_4n;
        return function tonelliFast(Fp, n) {
            var root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    var Q1div2 = (Q + $a8e40545709e7048$var$_1n) / $a8e40545709e7048$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        var r = S;
        // TODO: will fail at Fp2/etc
        var g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        var x = Fp.pow(n, Q1div2); // first guess at the square root
        var b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            var m = 1;
            for(var t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            var ge = Fp.pow(g, $a8e40545709e7048$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $a8e40545709e7048$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $a8e40545709e7048$var$_4n === $a8e40545709e7048$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        var p1div4 = (P + $a8e40545709e7048$var$_1n) / $a8e40545709e7048$var$_4n;
        return function sqrt3mod4(Fp, n) {
            var root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $a8e40545709e7048$var$_8n === $a8e40545709e7048$var$_5n) {
        var c1 = (P - $a8e40545709e7048$var$_5n) / $a8e40545709e7048$var$_8n;
        return function sqrt5mod8(Fp, n) {
            var n2 = Fp.mul(n, $a8e40545709e7048$var$_2n);
            var v = Fp.pow(n2, c1);
            var nv = Fp.mul(n, v);
            var i = Fp.mul(Fp.mul(nv, $a8e40545709e7048$var$_2n), v);
            var root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $a8e40545709e7048$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $a8e40545709e7048$var$tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
var $a8e40545709e7048$var$isNegativeLE = function(num, modulo) {
    return ($a8e40545709e7048$var$mod(num, modulo) & $a8e40545709e7048$var$_1n) === $a8e40545709e7048$var$_1n;
};
module.exports.isNegativeLE = $a8e40545709e7048$var$isNegativeLE;
// prettier-ignore
var $a8e40545709e7048$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $a8e40545709e7048$var$validateField(field) {
    var initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    var opts = $a8e40545709e7048$var$FIELD_FIELDS.reduce(function(map, val) {
        map[val] = "function";
        return map;
    }, initial);
    return (0, $1YtXk.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $a8e40545709e7048$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $a8e40545709e7048$var$_0n) throw new Error("Expected power > 0");
    if (power === $a8e40545709e7048$var$_0n) return f.ONE;
    if (power === $a8e40545709e7048$var$_1n) return num;
    var p = f.ONE;
    var d = num;
    while(power > $a8e40545709e7048$var$_0n){
        if (power & $a8e40545709e7048$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $a8e40545709e7048$var$_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $a8e40545709e7048$var$FpInvertBatch(f, nums) {
    var tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    var lastMultiplied = nums.reduce(function(acc, num, i) {
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    var inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight(function(acc, num, i) {
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $a8e40545709e7048$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, (typeof rhs === "undefined" ? "undefined" : (0, $aVMuR._)(rhs)) === "bigint" ? $a8e40545709e7048$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
// This function returns True whenever the value x is a square in the field F.
function $a8e40545709e7048$var$FpIsSquare(f) {
    var legendreConst = (f.ORDER - $a8e40545709e7048$var$_1n) / $a8e40545709e7048$var$_2n; // Integer arithmetic
    return function(x) {
        var p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
// CURVE.n lengths
function $a8e40545709e7048$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    var _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    var nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $a8e40545709e7048$var$Field(ORDER, bitLen) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, redef = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (ORDER <= $a8e40545709e7048$var$_0n) throw new Error("Expected Field ORDER > 0, got ".concat(ORDER));
    var _nLength = $a8e40545709e7048$var$nLength(ORDER, bitLen), BITS = _nLength.nBitLength, BYTES = _nLength.nByteLength;
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    var sqrtP = $a8e40545709e7048$var$FpSqrt(ORDER);
    var f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $1YtXk.bitMask)(BITS),
        ZERO: $a8e40545709e7048$var$_0n,
        ONE: $a8e40545709e7048$var$_1n,
        create: function(num) {
            return $a8e40545709e7048$var$mod(num, ORDER);
        },
        isValid: function(num) {
            if ((typeof num === "undefined" ? "undefined" : (0, $aVMuR._)(num)) !== "bigint") throw new Error("Invalid field element: expected bigint, got ".concat(typeof num === "undefined" ? "undefined" : (0, $aVMuR._)(num)));
            return $a8e40545709e7048$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: function(num) {
            return num === $a8e40545709e7048$var$_0n;
        },
        isOdd: function(num) {
            return (num & $a8e40545709e7048$var$_1n) === $a8e40545709e7048$var$_1n;
        },
        neg: function(num) {
            return $a8e40545709e7048$var$mod(-num, ORDER);
        },
        eql: function(lhs, rhs) {
            return lhs === rhs;
        },
        sqr: function(num) {
            return $a8e40545709e7048$var$mod(num * num, ORDER);
        },
        add: function(lhs, rhs) {
            return $a8e40545709e7048$var$mod(lhs + rhs, ORDER);
        },
        sub: function(lhs, rhs) {
            return $a8e40545709e7048$var$mod(lhs - rhs, ORDER);
        },
        mul: function(lhs, rhs) {
            return $a8e40545709e7048$var$mod(lhs * rhs, ORDER);
        },
        pow: function(num, power) {
            return $a8e40545709e7048$var$FpPow(f, num, power);
        },
        div: function(lhs, rhs) {
            return $a8e40545709e7048$var$mod(lhs * $a8e40545709e7048$var$invert(rhs, ORDER), ORDER);
        },
        // Same as above, but doesn't normalize
        sqrN: function(num) {
            return num * num;
        },
        addN: function(lhs, rhs) {
            return lhs + rhs;
        },
        subN: function(lhs, rhs) {
            return lhs - rhs;
        },
        mulN: function(lhs, rhs) {
            return lhs * rhs;
        },
        inv: function(num) {
            return $a8e40545709e7048$var$invert(num, ORDER);
        },
        sqrt: redef.sqrt || function(n) {
            return sqrtP(f, n);
        },
        invertBatch: function(lst) {
            return $a8e40545709e7048$var$FpInvertBatch(f, lst);
        },
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: function(a, b, c) {
            return c ? b : a;
        },
        toBytes: function(num) {
            return isLE ? (0, $1YtXk.numberToBytesLE)(num, BYTES) : (0, $1YtXk.numberToBytesBE)(num, BYTES);
        },
        fromBytes: function(bytes) {
            if (bytes.length !== BYTES) throw new Error("Fp.fromBytes: expected ".concat(BYTES, ", got ").concat(bytes.length));
            return isLE ? (0, $1YtXk.bytesToNumberLE)(bytes) : (0, $1YtXk.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $a8e40545709e7048$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $a8e40545709e7048$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $a8e40545709e7048$var$hashToPrivateScalar(hash, groupOrder) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    hash = (0, $1YtXk.ensureBytes)("privateHash", hash);
    var hashLen = hash.length;
    var minLen = $a8e40545709e7048$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected ".concat(minLen, "-1024 bytes of input, got ").concat(hashLen));
    var num = isLE ? (0, $1YtXk.bytesToNumberLE)(hash) : (0, $1YtXk.bytesToNumberBE)(hash);
    return $a8e40545709e7048$var$mod(num, groupOrder - $a8e40545709e7048$var$_1n) + $a8e40545709e7048$var$_1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $a8e40545709e7048$var$getFieldBytesLength(fieldOrder) {
    if ((typeof fieldOrder === "undefined" ? "undefined" : (0, $aVMuR._)(fieldOrder)) !== "bigint") throw new Error("field order must be bigint");
    var bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $a8e40545709e7048$var$getMinHashLength(fieldOrder) {
    var length = $a8e40545709e7048$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $a8e40545709e7048$var$mapHashToField(key, fieldOrder) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var len = key.length;
    var fieldLen = $a8e40545709e7048$var$getFieldBytesLength(fieldOrder);
    var minLen = $a8e40545709e7048$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected ".concat(minLen, "-1024 bytes of input, got ").concat(len));
    var num = isLE ? (0, $1YtXk.bytesToNumberBE)(key) : (0, $1YtXk.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    var reduced = $a8e40545709e7048$var$mod(num, fieldOrder - $a8e40545709e7048$var$_1n) + $a8e40545709e7048$var$_1n;
    return isLE ? (0, $1YtXk.numberToBytesLE)(reduced, fieldLen) : (0, $1YtXk.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("1YtXk", function(module, exports) {

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bitMask = void 0;
module.exports.isBytes = $1702a1abb4cdb9db$var$isBytes;
module.exports.abytes = $1702a1abb4cdb9db$var$abytes;
module.exports.bytesToHex = $1702a1abb4cdb9db$var$bytesToHex;
module.exports.numberToHexUnpadded = $1702a1abb4cdb9db$var$numberToHexUnpadded;
module.exports.hexToNumber = $1702a1abb4cdb9db$var$hexToNumber;
module.exports.hexToBytes = $1702a1abb4cdb9db$var$hexToBytes;
module.exports.bytesToNumberBE = $1702a1abb4cdb9db$var$bytesToNumberBE;
module.exports.bytesToNumberLE = $1702a1abb4cdb9db$var$bytesToNumberLE;
module.exports.numberToBytesBE = $1702a1abb4cdb9db$var$numberToBytesBE;
module.exports.numberToBytesLE = $1702a1abb4cdb9db$var$numberToBytesLE;
module.exports.numberToVarBytesBE = $1702a1abb4cdb9db$var$numberToVarBytesBE;
module.exports.ensureBytes = $1702a1abb4cdb9db$var$ensureBytes;
module.exports.concatBytes = $1702a1abb4cdb9db$var$concatBytes;
module.exports.equalBytes = $1702a1abb4cdb9db$var$equalBytes;
module.exports.utf8ToBytes = $1702a1abb4cdb9db$var$utf8ToBytes;
module.exports.bitLen = $1702a1abb4cdb9db$var$bitLen;
module.exports.bitGet = $1702a1abb4cdb9db$var$bitGet;
module.exports.bitSet = $1702a1abb4cdb9db$var$bitSet;
module.exports.createHmacDrbg = $1702a1abb4cdb9db$var$createHmacDrbg;
module.exports.validateObject = $1702a1abb4cdb9db$var$validateObject;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
var $1702a1abb4cdb9db$var$_0n = /* @__PURE__ */ BigInt(0);
var $1702a1abb4cdb9db$var$_1n = /* @__PURE__ */ BigInt(1);
var $1702a1abb4cdb9db$var$_2n = /* @__PURE__ */ BigInt(2);
function $1702a1abb4cdb9db$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $1702a1abb4cdb9db$var$abytes(item) {
    if (!$1702a1abb4cdb9db$var$isBytes(item)) throw new Error("Uint8Array expected");
}
// Array where index 0xf0 (240) is mapped to string 'f0'
var $1702a1abb4cdb9db$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, function(_, i) {
    return i.toString(16).padStart(2, "0");
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $1702a1abb4cdb9db$var$bytesToHex(bytes) {
    $1702a1abb4cdb9db$var$abytes(bytes);
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $1702a1abb4cdb9db$var$hexes[bytes[i]];
    return hex;
}
function $1702a1abb4cdb9db$var$numberToHexUnpadded(num) {
    var hex = num.toString(16);
    return hex.length & 1 ? "0".concat(hex) : hex;
}
function $1702a1abb4cdb9db$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $aVMuR._)(hex)));
    // Big Endian
    return BigInt(hex === "" ? "0" : "0x".concat(hex));
}
// We use optimized technique to convert hex string to byte array
var $1702a1abb4cdb9db$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $1702a1abb4cdb9db$var$asciiToBase16(char) {
    if (char >= $1702a1abb4cdb9db$var$asciis._0 && char <= $1702a1abb4cdb9db$var$asciis._9) return char - $1702a1abb4cdb9db$var$asciis._0;
    if (char >= $1702a1abb4cdb9db$var$asciis._A && char <= $1702a1abb4cdb9db$var$asciis._F) return char - ($1702a1abb4cdb9db$var$asciis._A - 10);
    if (char >= $1702a1abb4cdb9db$var$asciis._a && char <= $1702a1abb4cdb9db$var$asciis._f) return char - ($1702a1abb4cdb9db$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $1702a1abb4cdb9db$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $aVMuR._)(hex)));
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    var array = new Uint8Array(al);
    for(var ai = 0, hi = 0; ai < al; ai++, hi += 2){
        var n1 = $1702a1abb4cdb9db$var$asciiToBase16(hex.charCodeAt(hi));
        var n2 = $1702a1abb4cdb9db$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function $1702a1abb4cdb9db$var$bytesToNumberBE(bytes) {
    return $1702a1abb4cdb9db$var$hexToNumber($1702a1abb4cdb9db$var$bytesToHex(bytes));
}
function $1702a1abb4cdb9db$var$bytesToNumberLE(bytes) {
    $1702a1abb4cdb9db$var$abytes(bytes);
    return $1702a1abb4cdb9db$var$hexToNumber($1702a1abb4cdb9db$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
function $1702a1abb4cdb9db$var$numberToBytesBE(n, len) {
    return $1702a1abb4cdb9db$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
function $1702a1abb4cdb9db$var$numberToBytesLE(n, len) {
    return $1702a1abb4cdb9db$var$numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function $1702a1abb4cdb9db$var$numberToVarBytesBE(n) {
    return $1702a1abb4cdb9db$var$hexToBytes($1702a1abb4cdb9db$var$numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $1702a1abb4cdb9db$var$ensureBytes(title, hex, expectedLength) {
    var res;
    if (typeof hex === "string") try {
        res = $1702a1abb4cdb9db$var$hexToBytes(hex);
    } catch (e) {
        throw new Error("".concat(title, ' must be valid hex string, got "').concat(hex, '". Cause: ').concat(e));
    }
    else if ($1702a1abb4cdb9db$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error("".concat(title, " must be hex string or Uint8Array"));
    var len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error("".concat(title, " expected ").concat(expectedLength, " bytes, got ").concat(len));
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $1702a1abb4cdb9db$var$concatBytes() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var sum = 0;
    for(var i = 0; i < arrays.length; i++){
        var a = arrays[i];
        $1702a1abb4cdb9db$var$abytes(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for(var i1 = 0, pad = 0; i1 < arrays.length; i1++){
        var a1 = arrays[i1];
        res.set(a1, pad);
        pad += a1.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function $1702a1abb4cdb9db$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    var diff = 0;
    for(var i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $1702a1abb4cdb9db$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $1702a1abb4cdb9db$var$bitLen(n) {
    var len;
    for(len = 0; n > $1702a1abb4cdb9db$var$_0n; n >>= $1702a1abb4cdb9db$var$_1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $1702a1abb4cdb9db$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $1702a1abb4cdb9db$var$_1n;
}
/**
 * Sets single bit at position.
 */ function $1702a1abb4cdb9db$var$bitSet(n, pos, value) {
    return n | (value ? $1702a1abb4cdb9db$var$_1n : $1702a1abb4cdb9db$var$_0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ var $1702a1abb4cdb9db$var$bitMask = function(n) {
    return ($1702a1abb4cdb9db$var$_2n << BigInt(n - 1)) - $1702a1abb4cdb9db$var$_1n;
};
module.exports.bitMask = $1702a1abb4cdb9db$var$bitMask;
// DRBG
var $1702a1abb4cdb9db$var$u8n = function(data) {
    return new Uint8Array(data);
}; // creates Uint8Array
var $1702a1abb4cdb9db$var$u8fr = function(arr) {
    return Uint8Array.from(arr);
}; // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $1702a1abb4cdb9db$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    var v = $1702a1abb4cdb9db$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    var k = $1702a1abb4cdb9db$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    var i = 0; // Iterations counter, will throw when over 1000
    var reset = function() {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    var h = function() {
        for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
            b[_key] = arguments[_key];
        }
        return hmacFn.apply(void 0, [
            k,
            v
        ].concat((0, $gF0bR._)(b)));
    }; // hmac(k)(v, ...values)
    var reseed = function() {
        var seed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $1702a1abb4cdb9db$var$u8n();
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($1702a1abb4cdb9db$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($1702a1abb4cdb9db$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    var gen = function() {
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        var len = 0;
        var out = [];
        while(len < qByteLen){
            v = h();
            var sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $1702a1abb4cdb9db$var$concatBytes.apply(void 0, (0, $gF0bR._)(out));
    };
    var genUntil = function(seed, pred) {
        reset();
        reseed(seed); // Steps D-G
        var res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
var $1702a1abb4cdb9db$var$validatorFns = {
    bigint: function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $aVMuR._)(val)) === "bigint";
    },
    function: function(val) {
        return typeof val === "function";
    },
    boolean: function(val) {
        return typeof val === "boolean";
    },
    string: function(val) {
        return typeof val === "string";
    },
    stringOrUint8Array: function(val) {
        return typeof val === "string" || $1702a1abb4cdb9db$var$isBytes(val);
    },
    isSafeInteger: function(val) {
        return Number.isSafeInteger(val);
    },
    array: function(val) {
        return Array.isArray(val);
    },
    field: function(val, object) {
        return object.Fp.isValid(val);
    },
    hash: function(val) {
        return typeof val === "function" && Number.isSafeInteger(val.outputLen);
    }
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $1702a1abb4cdb9db$var$validateObject(object, validators) {
    var optValidators = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var checkField = function(fieldName, type, isOptional) {
        var checkVal = $1702a1abb4cdb9db$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error('Invalid validator "'.concat(type, '", expected function'));
        var val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("Invalid param ".concat(String(fieldName), "=").concat(val, " (").concat(typeof val === "undefined" ? "undefined" : (0, $aVMuR._)(val), "), expected ").concat(type));
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(validators)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $5OlIx._)(_step.value, 2), fieldName = _step_value[0], type = _step_value[1];
            checkField(fieldName, type, false);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.entries(optValidators)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $5OlIx._)(_step1.value, 2), fieldName1 = _step_value1[0], type1 = _step_value1[1];
            checkField(fieldName1, type1, true);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("fzie2", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("ar2eu", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("24TKi")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lV5eT", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $ff52fc4391f6a3e8$export$88fb0cfd153261a7; }, function (v) { return $ff52fc4391f6a3e8$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $ff52fc4391f6a3e8$export$9c6b53e35bc51b5c; }, function (v) { return $ff52fc4391f6a3e8$export$9c6b53e35bc51b5c = v; });
var $ff52fc4391f6a3e8$export$88fb0cfd153261a7;
var $ff52fc4391f6a3e8$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $ff52fc4391f6a3e8$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $ff52fc4391f6a3e8$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $ff52fc4391f6a3e8$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $ff52fc4391f6a3e8$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $ff52fc4391f6a3e8$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $ff52fc4391f6a3e8$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$ff52fc4391f6a3e8$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function endOfStream() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function read() {
        if (!this.tokens.length) return $ff52fc4391f6a3e8$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function prepend(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function push(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $ff52fc4391f6a3e8$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $ff52fc4391f6a3e8$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $ff52fc4391f6a3e8$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $ff52fc4391f6a3e8$var$TextDecoder(encoding, options) {
    if (!(this instanceof $ff52fc4391f6a3e8$var$TextDecoder)) return new $ff52fc4391f6a3e8$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $ff52fc4391f6a3e8$var$DEFAULT_ENCODING;
    if (encoding !== $ff52fc4391f6a3e8$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $ff52fc4391f6a3e8$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$ff52fc4391f6a3e8$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $ff52fc4391f6a3e8$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $ff52fc4391f6a3e8$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $ff52fc4391f6a3e8$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $ff52fc4391f6a3e8$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $ff52fc4391f6a3e8$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $ff52fc4391f6a3e8$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $ff52fc4391f6a3e8$var$TextEncoder(encoding, options) {
    if (!(this instanceof $ff52fc4391f6a3e8$var$TextEncoder)) return new $ff52fc4391f6a3e8$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $ff52fc4391f6a3e8$var$DEFAULT_ENCODING;
    if (encoding !== $ff52fc4391f6a3e8$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $ff52fc4391f6a3e8$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$ff52fc4391f6a3e8$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $ff52fc4391f6a3e8$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $ff52fc4391f6a3e8$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $ff52fc4391f6a3e8$var$Stream($ff52fc4391f6a3e8$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $ff52fc4391f6a3e8$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $ff52fc4391f6a3e8$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $ff52fc4391f6a3e8$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $ff52fc4391f6a3e8$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $ff52fc4391f6a3e8$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $ff52fc4391f6a3e8$var$end_of_stream) return $ff52fc4391f6a3e8$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($ff52fc4391f6a3e8$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($ff52fc4391f6a3e8$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($ff52fc4391f6a3e8$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($ff52fc4391f6a3e8$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $ff52fc4391f6a3e8$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$ff52fc4391f6a3e8$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $ff52fc4391f6a3e8$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $ff52fc4391f6a3e8$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $ff52fc4391f6a3e8$var$end_of_stream) return $ff52fc4391f6a3e8$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($ff52fc4391f6a3e8$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($ff52fc4391f6a3e8$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($ff52fc4391f6a3e8$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($ff52fc4391f6a3e8$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$ff52fc4391f6a3e8$export$88fb0cfd153261a7 = $ff52fc4391f6a3e8$var$TextEncoder;
$ff52fc4391f6a3e8$export$9c6b53e35bc51b5c = $ff52fc4391f6a3e8$var$TextDecoder;

});

parcelRegister("i4x6j", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ 
var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.s16 = exports.s8 = exports.nu64be = exports.u48be = exports.u40be = exports.u32be = exports.u24be = exports.u16be = exports.nu64 = exports.u48 = exports.u40 = exports.u32 = exports.u24 = exports.u16 = exports.u8 = exports.offset = exports.greedy = exports.Constant = exports.UTF8 = exports.CString = exports.Blob = exports.Boolean = exports.BitField = exports.BitStructure = exports.VariantLayout = exports.Union = exports.UnionLayoutDiscriminator = exports.UnionDiscriminator = exports.Structure = exports.Sequence = exports.DoubleBE = exports.Double = exports.FloatBE = exports.Float = exports.NearInt64BE = exports.NearInt64 = exports.NearUInt64BE = exports.NearUInt64 = exports.IntBE = exports.Int = exports.UIntBE = exports.UInt = exports.OffsetLayout = exports.GreedyCount = exports.ExternalLayout = exports.bindConstructorLayout = exports.nameWithProperty = exports.Layout = exports.uint8ArrayToBuffer = exports.checkUint8Array = void 0;
exports.constant = exports.utf8 = exports.cstr = exports.blob = exports.unionLayoutDiscriminator = exports.union = exports.seq = exports.bits = exports.struct = exports.f64be = exports.f64 = exports.f32be = exports.f32 = exports.ns64be = exports.s48be = exports.s40be = exports.s32be = exports.s24be = exports.s16be = exports.ns64 = exports.s48 = exports.s40 = exports.s32 = exports.s24 = void 0;

var $ilnag = parcelRequire("ilnag");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
exports.checkUint8Array = checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function uint8ArrayToBuffer(b) {
    checkUint8Array(b);
    return $ilnag.Buffer.from(b.buffer, b.byteOffset, b.length);
}
exports.uint8ArrayToBuffer = uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ var Layout = /*#__PURE__*/ function() {
    function Layout(span, property) {
        (0, $7dKN1._)(this, Layout);
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    (0, $eW5pA._)(Layout, [
        {
            /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ key: "makeDestinationObject",
            value: function makeDestinationObject() {
                return {};
            }
        },
        {
            /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ key: "getSpan",
            value: function getSpan(b, offset) {
                if (0 > this.span) throw new RangeError("indeterminate span");
                return this.span;
            }
        },
        {
            /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ key: "replicate",
            value: function replicate(property) {
                var rv = Object.create(this.constructor.prototype);
                Object.assign(rv, this);
                rv.property = property;
                return rv;
            }
        },
        {
            /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ key: "fromArray",
            value: function fromArray(values) {
                return undefined;
            }
        }
    ]);
    return Layout;
}();
exports.Layout = Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
exports.nameWithProperty = nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = function() {
        return new Class();
    };
    Object.defineProperty(Class.prototype, "encode", {
        value: function(b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value: function(b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
exports.bindConstructorLayout = bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ var ExternalLayout = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(ExternalLayout, Layout);
    var _super = (0, $hKD8n._)(ExternalLayout);
    function ExternalLayout() {
        (0, $7dKN1._)(this, ExternalLayout);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(ExternalLayout, [
        {
            /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ key: "isCount",
            value: function isCount() {
                throw new Error("ExternalLayout is abstract");
            }
        }
    ]);
    return ExternalLayout;
}(Layout);
exports.ExternalLayout = ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ var GreedyCount = /*#__PURE__*/ function(ExternalLayout) {
    (0, $cgJ2Y._)(GreedyCount, ExternalLayout);
    var _super = (0, $hKD8n._)(GreedyCount);
    function GreedyCount() {
        var elementSpan = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, property = arguments.length > 1 ? arguments[1] : void 0;
        (0, $7dKN1._)(this, GreedyCount);
        var _this;
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        _this = _super.call(this, -1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ _this.elementSpan = elementSpan;
        return _this;
    }
    (0, $eW5pA._)(GreedyCount, [
        {
            /** @override */ key: "isCount",
            value: function isCount() {
                return true;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                var rem = b.length - offset;
                return Math.floor(rem / this.elementSpan);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b, offset) {
                return 0;
            }
        }
    ]);
    return GreedyCount;
}(ExternalLayout);
exports.GreedyCount = GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ var OffsetLayout = /*#__PURE__*/ function(ExternalLayout) {
    (0, $cgJ2Y._)(OffsetLayout, ExternalLayout);
    var _super = (0, $hKD8n._)(OffsetLayout);
    function OffsetLayout(layout) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, property = arguments.length > 2 ? arguments[2] : void 0;
        (0, $7dKN1._)(this, OffsetLayout);
        var _this;
        if (!(layout instanceof Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        _this = _super.call(this, layout.span, property || layout.property);
        /** The subordinated layout. */ _this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ _this.offset = offset;
        return _this;
    }
    (0, $eW5pA._)(OffsetLayout, [
        {
            /** @override */ key: "isCount",
            value: function isCount() {
                return this.layout instanceof UInt || this.layout instanceof UIntBE;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return this.layout.decode(b, offset + this.offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                return this.layout.encode(src, b, offset + this.offset);
            }
        }
    ]);
    return OffsetLayout;
}(ExternalLayout);
exports.OffsetLayout = OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var UInt = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(UInt, Layout);
    var _super = (0, $hKD8n._)(UInt);
    function UInt(span, property) {
        (0, $7dKN1._)(this, UInt);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $eW5pA._)(UInt, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return UInt;
}(Layout);
exports.UInt = UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var UIntBE = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(UIntBE, Layout);
    var _super = (0, $hKD8n._)(UIntBE);
    function UIntBE(span, property) {
        (0, $7dKN1._)(this, UIntBE);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $eW5pA._)(UIntBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return UIntBE;
}(Layout);
exports.UIntBE = UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Int = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(Int, Layout);
    var _super = (0, $hKD8n._)(Int);
    function Int(span, property) {
        (0, $7dKN1._)(this, Int);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $eW5pA._)(Int, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readIntLE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return Int;
}(Layout);
exports.Int = Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var IntBE = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(IntBE, Layout);
    var _super = (0, $hKD8n._)(IntBE);
    function IntBE(span, property) {
        (0, $7dKN1._)(this, IntBE);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $eW5pA._)(IntBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readIntBE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return IntBE;
}(Layout);
exports.IntBE = IntBE;
var V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function divmodInt64(src) {
    var hi32 = Math.floor(src / V2E32);
    var lo32 = src - hi32 * V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function roundedInt64(hi32, lo32) {
    return hi32 * V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearUInt64 = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(NearUInt64, Layout);
    var _super = (0, $hKD8n._)(NearUInt64);
    function NearUInt64(property) {
        (0, $7dKN1._)(this, NearUInt64);
        return _super.call(this, 8, property);
    }
    (0, $eW5pA._)(NearUInt64, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var lo32 = buffer.readUInt32LE(offset);
                var hi32 = buffer.readUInt32LE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeUInt32LE(split.lo32, offset);
                buffer.writeUInt32LE(split.hi32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearUInt64;
}(Layout);
exports.NearUInt64 = NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearUInt64BE = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(NearUInt64BE, Layout);
    var _super = (0, $hKD8n._)(NearUInt64BE);
    function NearUInt64BE(property) {
        (0, $7dKN1._)(this, NearUInt64BE);
        return _super.call(this, 8, property);
    }
    (0, $eW5pA._)(NearUInt64BE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var hi32 = buffer.readUInt32BE(offset);
                var lo32 = buffer.readUInt32BE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeUInt32BE(split.hi32, offset);
                buffer.writeUInt32BE(split.lo32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearUInt64BE;
}(Layout);
exports.NearUInt64BE = NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearInt64 = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(NearInt64, Layout);
    var _super = (0, $hKD8n._)(NearInt64);
    function NearInt64(property) {
        (0, $7dKN1._)(this, NearInt64);
        return _super.call(this, 8, property);
    }
    (0, $eW5pA._)(NearInt64, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var lo32 = buffer.readUInt32LE(offset);
                var hi32 = buffer.readInt32LE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeUInt32LE(split.lo32, offset);
                buffer.writeInt32LE(split.hi32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearInt64;
}(Layout);
exports.NearInt64 = NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearInt64BE = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(NearInt64BE, Layout);
    var _super = (0, $hKD8n._)(NearInt64BE);
    function NearInt64BE(property) {
        (0, $7dKN1._)(this, NearInt64BE);
        return _super.call(this, 8, property);
    }
    (0, $eW5pA._)(NearInt64BE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var hi32 = buffer.readInt32BE(offset);
                var lo32 = buffer.readUInt32BE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeInt32BE(split.hi32, offset);
                buffer.writeUInt32BE(split.lo32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearInt64BE;
}(Layout);
exports.NearInt64BE = NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Float = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(Float, Layout);
    var _super = (0, $hKD8n._)(Float);
    function Float(property) {
        (0, $7dKN1._)(this, Float);
        return _super.call(this, 4, property);
    }
    (0, $eW5pA._)(Float, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readFloatLE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeFloatLE(src, offset);
                return 4;
            }
        }
    ]);
    return Float;
}(Layout);
exports.Float = Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var FloatBE = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(FloatBE, Layout);
    var _super = (0, $hKD8n._)(FloatBE);
    function FloatBE(property) {
        (0, $7dKN1._)(this, FloatBE);
        return _super.call(this, 4, property);
    }
    (0, $eW5pA._)(FloatBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readFloatBE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeFloatBE(src, offset);
                return 4;
            }
        }
    ]);
    return FloatBE;
}(Layout);
exports.FloatBE = FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Double = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(Double, Layout);
    var _super = (0, $hKD8n._)(Double);
    function Double(property) {
        (0, $7dKN1._)(this, Double);
        return _super.call(this, 8, property);
    }
    (0, $eW5pA._)(Double, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readDoubleLE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
                return 8;
            }
        }
    ]);
    return Double;
}(Layout);
exports.Double = Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var DoubleBE = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(DoubleBE, Layout);
    var _super = (0, $hKD8n._)(DoubleBE);
    function DoubleBE(property) {
        (0, $7dKN1._)(this, DoubleBE);
        return _super.call(this, 8, property);
    }
    (0, $eW5pA._)(DoubleBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readDoubleBE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
                return 8;
            }
        }
    ]);
    return DoubleBE;
}(Layout);
exports.DoubleBE = DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Sequence = /*#__PURE__*/ function(Layout1) {
    (0, $cgJ2Y._)(Sequence, Layout1);
    var _super = (0, $hKD8n._)(Sequence);
    function Sequence(elementLayout, count, property) {
        (0, $7dKN1._)(this, Sequence);
        var _this;
        if (!(elementLayout instanceof Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        var span = -1;
        if (!(count instanceof ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        _this = _super.call(this, span, property);
        /** The layout for individual elements of the sequence. */ _this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ _this.count = count;
        return _this;
    }
    (0, $eW5pA._)(Sequence, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) return this.span;
                var span = 0;
                var count = this.count;
                if (count instanceof ExternalLayout) count = count.decode(b, offset);
                if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
                else {
                    var idx = 0;
                    while(idx < count){
                        span += this.elementLayout.getSpan(b, offset + span);
                        ++idx;
                    }
                }
                return span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var rv = [];
                var i = 0;
                var count = this.count;
                if (count instanceof ExternalLayout) count = count.decode(b, offset);
                while(i < count){
                    rv.push(this.elementLayout.decode(b, offset));
                    offset += this.elementLayout.getSpan(b, offset);
                    i += 1;
                }
                return rv;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var elo = this.elementLayout;
                var span = src.reduce(function(span, v) {
                    return span + elo.encode(v, b, offset + span);
                }, 0);
                if (this.count instanceof ExternalLayout) this.count.encode(src.length, b, offset);
                return span;
            }
        }
    ]);
    return Sequence;
}(Layout);
exports.Sequence = Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ var Structure = /*#__PURE__*/ function(Layout1) {
    (0, $cgJ2Y._)(Structure, Layout1);
    var _super = (0, $hKD8n._)(Structure);
    function Structure(fields, property, decodePrefixes) {
        (0, $7dKN1._)(this, Structure);
        var _this;
        if (!(Array.isArray(fields) && fields.reduce(function(acc, v) {
            return acc && v instanceof Layout;
        }, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            /* Verify absence of unnamed variable-length fields. */ for(var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fd = _step.value;
                if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var span = -1;
        try {
            span = fields.reduce(function(span, fd) {
                return span + fd.getSpan();
            }, 0);
        } catch (e) {
        // ignore error
        }
        _this = _super.call(this, span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ _this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ _this.decodePrefixes = !!decodePrefixes;
        return _this;
    }
    (0, $eW5pA._)(Structure, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) return this.span;
                var span = 0;
                try {
                    span = this.fields.reduce(function(span, fd) {
                        var fsp = fd.getSpan(b, offset);
                        offset += fsp;
                        return span + fsp;
                    }, 0);
                } catch (e) {
                    throw new RangeError("indeterminate span");
                }
                return span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                var dest = this.makeDestinationObject();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
                        offset += fd.getSpan(b, offset);
                        if (this.decodePrefixes && b.length === offset) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return dest;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var firstOffset = offset;
                var lastOffset = 0;
                var lastWrote = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        var span = fd.span;
                        lastWrote = 0 < span ? span : 0;
                        if (undefined !== fd.property) {
                            var fv = src[fd.property];
                            if (undefined !== fv) {
                                lastWrote = fd.encode(fv, b, offset);
                                if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                            }
                        }
                        lastOffset = offset;
                        offset += span;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
            }
        },
        {
            /** @override */ key: "fromArray",
            value: function fromArray(values) {
                var dest = this.makeDestinationObject();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return dest;
            }
        },
        {
            /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ key: "layoutFor",
            value: function layoutFor(property) {
                if ("string" !== typeof property) throw new TypeError("property must be string");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (fd.property === property) return fd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        },
        {
            /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ key: "offsetOf",
            value: function offsetOf(property) {
                if ("string" !== typeof property) throw new TypeError("property must be string");
                var offset = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (fd.property === property) return offset;
                        if (0 > fd.span) offset = -1;
                        else if (0 <= offset) offset += fd.span;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        }
    ]);
    return Structure;
}(Layout);
exports.Structure = Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ var UnionDiscriminator = /*#__PURE__*/ function() {
    function UnionDiscriminator(property) {
        (0, $7dKN1._)(this, UnionDiscriminator);
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    (0, $eW5pA._)(UnionDiscriminator, [
        {
            /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ key: "decode",
            value: function decode(b, offset) {
                throw new Error("UnionDiscriminator is abstract");
            }
        },
        {
            /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ key: "encode",
            value: function encode(src, b, offset) {
                throw new Error("UnionDiscriminator is abstract");
            }
        }
    ]);
    return UnionDiscriminator;
}();
exports.UnionDiscriminator = UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ var UnionLayoutDiscriminator = /*#__PURE__*/ function(UnionDiscriminator) {
    (0, $cgJ2Y._)(UnionLayoutDiscriminator, UnionDiscriminator);
    var _super = (0, $hKD8n._)(UnionLayoutDiscriminator);
    function UnionLayoutDiscriminator(layout, property) {
        (0, $7dKN1._)(this, UnionLayoutDiscriminator);
        var _this;
        if (!(layout instanceof ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        _this = _super.call(this, property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ _this.layout = layout;
        return _this;
    }
    (0, $eW5pA._)(UnionLayoutDiscriminator, [
        {
            /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ key: "decode",
            value: function decode(b, offset) {
                return this.layout.decode(b, offset);
            }
        },
        {
            /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ key: "encode",
            value: function encode(src, b, offset) {
                return this.layout.encode(src, b, offset);
            }
        }
    ]);
    return UnionLayoutDiscriminator;
}(UnionDiscriminator);
exports.UnionLayoutDiscriminator = UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Union = /*#__PURE__*/ function(Layout1) {
    (0, $cgJ2Y._)(Union, Layout1);
    var _super = (0, $hKD8n._)(Union);
    function Union(discr, defaultLayout, property) {
        (0, $7dKN1._)(this, Union);
        var _this;
        var discriminator;
        if (discr instanceof UInt || discr instanceof UIntBE) discriminator = new UnionLayoutDiscriminator(new OffsetLayout(discr));
        else if (discr instanceof ExternalLayout && discr.isCount()) discriminator = new UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ var span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof UInt || discr instanceof UIntBE)) span += discriminator.layout.span;
        }
        _this = _super.call(this, span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ _this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ _this.usesPrefixDiscriminator = discr instanceof UInt || discr instanceof UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ _this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ _this.registry = {};
        /* Private variable used when invoking getSourceVariant */ var boundGetSourceVariant = _this.defaultGetSourceVariant.bind((0, $b9zO9._)(_this));
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ _this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ _this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
        return _this;
    }
    (0, $eW5pA._)(Union, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) return this.span;
                /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ var vlo = this.getVariant(b, offset);
                if (!vlo) throw new Error("unable to determine span for unrecognized variant");
                return vlo.getSpan(b, offset);
            }
        },
        {
            /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ key: "defaultGetSourceVariant",
            value: function defaultGetSourceVariant(src) {
                if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
                    if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
                    var vlo = this.registry[src[this.discriminator.property]];
                    if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
                } else for(var tag in this.registry){
                    var vlo1 = this.registry[tag];
                    if (vlo1.property && Object.prototype.hasOwnProperty.call(src, vlo1.property)) return vlo1;
                }
                throw new Error("unable to infer src variant");
            }
        },
        {
            /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var dest;
                var dlo = this.discriminator;
                var discr = dlo.decode(b, offset);
                var clo = this.registry[discr];
                if (undefined === clo) {
                    var defaultLayout = this.defaultLayout;
                    var contentOffset = 0;
                    if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
                    dest = this.makeDestinationObject();
                    dest[dlo.property] = discr;
                    // defaultLayout.property can be undefined, but this is allowed by buffer-layout
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
                } else dest = clo.decode(b, offset);
                return dest;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var vlo = this.getSourceVariant(src);
                if (undefined === vlo) {
                    var dlo = this.discriminator;
                    // this.defaultLayout is not undefined when vlo is undefined
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var clo = this.defaultLayout;
                    var contentOffset = 0;
                    if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
                    dlo.encode(src[dlo.property], b, offset);
                    // clo.property is not undefined when vlo is undefined
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
                }
                return vlo.encode(src, b, offset);
            }
        },
        {
            /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ key: "addVariant",
            value: function addVariant(variant, layout, property) {
                var rv = new VariantLayout(this, variant, layout, property);
                this.registry[variant] = rv;
                return rv;
            }
        },
        {
            /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ key: "getVariant",
            value: function getVariant(vb) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var variant;
                if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
                else variant = vb;
                return this.registry[variant];
            }
        }
    ]);
    return Union;
}(Layout);
exports.Union = Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ var VariantLayout = /*#__PURE__*/ function(Layout1) {
    (0, $cgJ2Y._)(VariantLayout, Layout1);
    var _super = (0, $hKD8n._)(VariantLayout);
    function VariantLayout(union, variant, layout, property) {
        (0, $7dKN1._)(this, VariantLayout);
        var _this;
        if (!(union instanceof Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        var span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        _this = _super.call(this, span, property);
        /** The {@link Union} to which this variant belongs. */ _this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ _this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ _this.layout = layout || null;
        return _this;
    }
    (0, $eW5pA._)(VariantLayout, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
                var contentOffset = 0;
                if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
                /* Span is defined solely by the variant (and prefix discriminator) */ var span = 0;
                if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
                return contentOffset + span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var dest = this.makeDestinationObject();
                if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
                var contentOffset = 0;
                if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
                if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
                else if (this.property) dest[this.property] = true;
                else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
                return dest;
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var contentOffset = 0;
                if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
                if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
                this.union.discriminator.encode(this.variant, b, offset);
                var span = contentOffset;
                if (this.layout) {
                    this.layout.encode(src[this.property], b, offset + contentOffset);
                    span += this.layout.getSpan(b, offset + contentOffset);
                    if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
                }
                return span;
            }
        },
        {
            /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ key: "fromArray",
            value: function fromArray(values) {
                if (this.layout) return this.layout.fromArray(values);
                return undefined;
            }
        }
    ]);
    return VariantLayout;
}(Layout);
exports.VariantLayout = VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var BitStructure = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(BitStructure, Layout);
    var _super = (0, $hKD8n._)(BitStructure);
    function BitStructure(word, msb, property) {
        (0, $7dKN1._)(this, BitStructure);
        var _this;
        if (!(word instanceof UInt || word instanceof UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        _this = _super.call(this, word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ _this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ _this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ _this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ var value = 0;
        _this._packedSetValue = function(v) {
            value = fixBitwiseResult(v);
            return this;
        };
        _this._packedGetValue = function() {
            return value;
        };
        return _this;
    }
    (0, $eW5pA._)(BitStructure, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var dest = this.makeDestinationObject();
                var value = this.word.decode(b, offset);
                this._packedSetValue(value);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return dest;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var value = this.word.decode(b, offset);
                this._packedSetValue(value);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property) {
                            var fv = src[fd.property];
                            if (undefined !== fv) fd.encode(fv);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.word.encode(this._packedGetValue(), b, offset);
            }
        },
        {
            /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ key: "addField",
            value: function addField(bits, property) {
                var bf = new BitField(this, bits, property);
                this.fields.push(bf);
                return bf;
            }
        },
        {
            /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
            // eslint-disable-next-line @typescript-eslint/ban-types
            key: "addBoolean",
            value: function addBoolean(property) {
                // This is my Boolean, not the Javascript one.
                var bf = new Boolean(this, property);
                this.fields.push(bf);
                return bf;
            }
        },
        {
            /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ key: "fieldFor",
            value: function fieldFor(property) {
                if ("string" !== typeof property) throw new TypeError("property must be string");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (fd.property === property) return fd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        }
    ]);
    return BitStructure;
}(Layout);
exports.BitStructure = BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ var BitField = /*#__PURE__*/ function() {
    function BitField(container, bits, property) {
        (0, $7dKN1._)(this, BitField);
        if (!(container instanceof BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        var totalBits = 8 * container.span;
        var usedBits = container.fields.reduce(function(sum, fd) {
            return sum + fd.bits;
        }, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    (0, $eW5pA._)(BitField, [
        {
            /** Store a value into the corresponding subsequence of the containing
     * bit field. */ key: "decode",
            value: function decode(b, offset) {
                var word = this.container._packedGetValue();
                var wordValue = fixBitwiseResult(word & this.wordMask);
                var value = wordValue >>> this.start;
                return value;
            }
        },
        {
            /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ key: "encode",
            value: function encode(value) {
                if ("number" !== typeof value || !Number.isInteger(value) || value !== fixBitwiseResult(value & this.valueMask)) throw new TypeError(nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
                var word = this.container._packedGetValue();
                var wordValue = fixBitwiseResult(value << this.start);
                this.container._packedSetValue(fixBitwiseResult(word & ~this.wordMask) | wordValue);
            }
        }
    ]);
    return BitField;
}();
exports.BitField = BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ var Boolean = /*#__PURE__*/ function(BitField) {
    (0, $cgJ2Y._)(Boolean, BitField);
    var _super = (0, $hKD8n._)(Boolean);
    function Boolean(container, property) {
        (0, $7dKN1._)(this, Boolean);
        return _super.call(this, container, 1, property);
    }
    (0, $eW5pA._)(Boolean, [
        {
            /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ key: "decode",
            value: function decode(b, offset) {
                return !!(0, $2Nfql._)((0, $fG73q._)(Boolean.prototype), "decode", this).call(this, b, offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(value) {
                if ("boolean" === typeof value) // BitField requires integer values
                value = +value;
                (0, $2Nfql._)((0, $fG73q._)(Boolean.prototype), "encode", this).call(this, value);
            }
        }
    ]);
    return Boolean;
}(BitField);
exports.Boolean = Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Blob = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(Blob, Layout);
    var _super = (0, $hKD8n._)(Blob);
    function Blob(length, property) {
        (0, $7dKN1._)(this, Blob);
        var _this;
        if (!(length instanceof ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        var span = -1;
        if (!(length instanceof ExternalLayout)) span = length;
        _this = _super.call(this, span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ _this.length = length;
        return _this;
    }
    (0, $eW5pA._)(Blob, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b, offset) {
                var span = this.span;
                if (0 > span) span = this.length.decode(b, offset);
                return span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var span = this.span;
                if (0 > span) span = this.length.decode(b, offset);
                return uint8ArrayToBuffer(b).slice(offset, offset + span);
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ key: "encode",
            value: function encode(src, b, offset) {
                var span = this.length;
                if (this.length instanceof ExternalLayout) span = src.length;
                if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError(nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
                if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
                var srcBuffer = uint8ArrayToBuffer(src);
                uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
                if (this.length instanceof ExternalLayout) this.length.encode(span, b, offset);
                return span;
            }
        }
    ]);
    return Blob;
}(Layout);
exports.Blob = Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var CString = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(CString, Layout);
    var _super = (0, $hKD8n._)(CString);
    function CString(property) {
        (0, $7dKN1._)(this, CString);
        return _super.call(this, -1, property);
    }
    (0, $eW5pA._)(CString, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                var idx = offset;
                while(idx < b.length && 0 !== b[idx])idx += 1;
                return 1 + idx - offset;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var span = this.getSpan(b, offset);
                return uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
                var srcb = $ilnag.Buffer.from(src, "utf8");
                var span = srcb.length;
                if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
                var buffer = uint8ArrayToBuffer(b);
                srcb.copy(buffer, offset);
                buffer[offset + span] = 0;
                return span + 1;
            }
        }
    ]);
    return CString;
}(Layout);
exports.CString = CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var UTF8 = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(UTF8, Layout);
    var _super = (0, $hKD8n._)(UTF8);
    function UTF8(maxSpan, property) {
        (0, $7dKN1._)(this, UTF8);
        var _this;
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        _this = _super.call(this, -1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ _this.maxSpan = maxSpan;
        return _this;
    }
    (0, $eW5pA._)(UTF8, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                return b.length - offset;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var span = this.getSpan(b, offset);
                if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
                return uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
                var srcb = $ilnag.Buffer.from(src, "utf8");
                var span = srcb.length;
                if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
                if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
                srcb.copy(uint8ArrayToBuffer(b), offset);
                return span;
            }
        }
    ]);
    return UTF8;
}(Layout);
exports.UTF8 = UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Constant = /*#__PURE__*/ function(Layout) {
    (0, $cgJ2Y._)(Constant, Layout);
    var _super = (0, $hKD8n._)(Constant);
    function Constant(value, property) {
        (0, $7dKN1._)(this, Constant);
        var _this;
        _this = _super.call(this, 0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ _this.value = value;
        return _this;
    }
    (0, $eW5pA._)(Constant, [
        {
            /** @override */ key: "decode",
            value: function decode(b, offset) {
                return this.value;
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b, offset) {
                /* Constants take no space */ return 0;
            }
        }
    ]);
    return Constant;
}(Layout);
exports.Constant = Constant;
/** Factory for {@link GreedyCount}. */ exports.greedy = function(elementSpan, property) {
    return new GreedyCount(elementSpan, property);
};
/** Factory for {@link OffsetLayout}. */ exports.offset = function(layout, offset, property) {
    return new OffsetLayout(layout, offset, property);
};
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ exports.u8 = function(property) {
    return new UInt(1, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ exports.u16 = function(property) {
    return new UInt(2, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ exports.u24 = function(property) {
    return new UInt(3, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ exports.u32 = function(property) {
    return new UInt(4, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ exports.u40 = function(property) {
    return new UInt(5, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ exports.u48 = function(property) {
    return new UInt(6, property);
};
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ exports.nu64 = function(property) {
    return new NearUInt64(property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ exports.u16be = function(property) {
    return new UIntBE(2, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ exports.u24be = function(property) {
    return new UIntBE(3, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ exports.u32be = function(property) {
    return new UIntBE(4, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ exports.u40be = function(property) {
    return new UIntBE(5, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ exports.u48be = function(property) {
    return new UIntBE(6, property);
};
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ exports.nu64be = function(property) {
    return new NearUInt64BE(property);
};
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ exports.s8 = function(property) {
    return new Int(1, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ exports.s16 = function(property) {
    return new Int(2, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ exports.s24 = function(property) {
    return new Int(3, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ exports.s32 = function(property) {
    return new Int(4, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ exports.s40 = function(property) {
    return new Int(5, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ exports.s48 = function(property) {
    return new Int(6, property);
};
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ exports.ns64 = function(property) {
    return new NearInt64(property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ exports.s16be = function(property) {
    return new IntBE(2, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ exports.s24be = function(property) {
    return new IntBE(3, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ exports.s32be = function(property) {
    return new IntBE(4, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ exports.s40be = function(property) {
    return new IntBE(5, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ exports.s48be = function(property) {
    return new IntBE(6, property);
};
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ exports.ns64be = function(property) {
    return new NearInt64BE(property);
};
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ exports.f32 = function(property) {
    return new Float(property);
};
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ exports.f32be = function(property) {
    return new FloatBE(property);
};
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ exports.f64 = function(property) {
    return new Double(property);
};
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ exports.f64be = function(property) {
    return new DoubleBE(property);
};
/** Factory for {@link Structure} values. */ exports.struct = function(fields, property, decodePrefixes) {
    return new Structure(fields, property, decodePrefixes);
};
/** Factory for {@link BitStructure} values. */ exports.bits = function(word, msb, property) {
    return new BitStructure(word, msb, property);
};
/** Factory for {@link Sequence} values. */ exports.seq = function(elementLayout, count, property) {
    return new Sequence(elementLayout, count, property);
};
/** Factory for {@link Union} values. */ exports.union = function(discr, defaultLayout, property) {
    return new Union(discr, defaultLayout, property);
};
/** Factory for {@link UnionLayoutDiscriminator} values. */ exports.unionLayoutDiscriminator = function(layout, property) {
    return new UnionLayoutDiscriminator(layout, property);
};
/** Factory for {@link Blob} values. */ exports.blob = function(length, property) {
    return new Blob(length, property);
};
/** Factory for {@link CString} values. */ exports.cstr = function(property) {
    return new CString(property);
};
/** Factory for {@link UTF8} values. */ exports.utf8 = function(maxSpan, property) {
    return new UTF8(maxSpan, property);
};
/** Factory for {@link Constant} values. */ exports.constant = function(value, property) {
    return new Constant(value, property);
};

});
parcelRegister("2Nfql", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $208c1f3f2eacda76$export$71511d61b312f219; });

var $8rCCV = parcelRequire("8rCCV");
function $208c1f3f2eacda76$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $208c1f3f2eacda76$export$71511d61b312f219 = Reflect.get;
    else $208c1f3f2eacda76$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $8rCCV._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $208c1f3f2eacda76$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("8rCCV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $625eced09d27bbd3$export$71511d61b312f219; });

var $fG73q = parcelRequire("fG73q");
function $625eced09d27bbd3$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $fG73q._)(object);
        if (object === null) break;
    }
    return object;
}

});



parcelRegister("91bj2", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return assert; });
$parcel$export(module.exports, "create", function () { return create; });
$parcel$export(module.exports, "type", function () { return type; });
$parcel$export(module.exports, "optional", function () { return optional; });
$parcel$export(module.exports, "any", function () { return any; });
$parcel$export(module.exports, "array", function () { return array; });
$parcel$export(module.exports, "boolean", function () { return boolean; });
$parcel$export(module.exports, "instance", function () { return instance; });
$parcel$export(module.exports, "literal", function () { return literal; });
$parcel$export(module.exports, "nullable", function () { return nullable; });
$parcel$export(module.exports, "number", function () { return number; });
$parcel$export(module.exports, "record", function () { return record; });
$parcel$export(module.exports, "string", function () { return string; });
$parcel$export(module.exports, "tuple", function () { return tuple; });
$parcel$export(module.exports, "union", function () { return union; });
$parcel$export(module.exports, "unknown", function () { return unknown; });
$parcel$export(module.exports, "coerce", function () { return coerce; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ 
var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $bL8uU = parcelRequire("bL8uU");

var $5OlIx = parcelRequire("5OlIx");

var $dXE6R = parcelRequire("dXE6R");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");

var $6qu4b = parcelRequire("6qu4b");
var StructError = /*#__PURE__*/ function(TypeError1) {
    "use strict";
    (0, $cgJ2Y._)(StructError, TypeError1);
    var _super = (0, $hKD8n._)(StructError);
    function StructError(failure, failures) {
        (0, $7dKN1._)(this, StructError);
        var _this;
        var cached;
        var message = failure.message, explanation = failure.explanation, rest = (0, $bL8uU._)(failure, [
            "message",
            "explanation"
        ]);
        var path = failure.path;
        var msg = path.length === 0 ? message : "At path: ".concat(path.join("."), " -- ").concat(message);
        _this = _super.call(this, explanation !== null && explanation !== void 0 ? explanation : msg);
        if (explanation != null) _this.cause = msg;
        Object.assign((0, $b9zO9._)(_this), rest);
        _this.name = _this.constructor.name;
        _this.failures = function() {
            return cached !== null && cached !== void 0 ? cached : cached = [
                failure
            ].concat((0, $gF0bR._)(failures()));
        };
        return _this;
    }
    return StructError;
}((0, $jShW9._)(TypeError));
/**
 * Check if a value is an iterator.
 */ function isIterable(x) {
    return isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function isNonArrayObject(x) {
    return isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function print(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : "".concat(value);
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function shiftIterator(input) {
    var _input_next = input.next(), done = _input_next.done, value = _input_next.value;
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    var path = context.path, branch = context.branch;
    var type = struct.type;
    var refinement = result.refinement, _result_message = result.message, message = _result_message === void 0 ? "Expected a value of type `".concat(type, "`").concat(refinement ? " with refinement `".concat(refinement, "`") : "", ", but received: `").concat(print(value), "`") : _result_message;
    return (0, $gddcW._)((0, $4JCw4._)({
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch
    }, result), {
        message: message
    });
}
/**
 * Convert a validation result to an iterable of failures.
 */ function toFailures(result, context, struct, value) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, failure, err;
    return (0, $6qu4b.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!isIterable(result)) result = [
                    result
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = result[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                r = _step.value;
                failure = toFailure(r, context, struct, value);
                if (!failure) return [
                    3,
                    4
                ];
                return [
                    4,
                    failure
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function run(value, struct) {
    var options, _options_path, path, _options_branch, branch, _options_coerce, coerce, _options_mask, mask, ctx, status, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, k, v, s, ts, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, t, err, err, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, failure1, err;
    var _arguments = arguments;
    return (0, $6qu4b.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                _options_path = options.path, path = _options_path === void 0 ? [] : _options_path, _options_branch = options.branch, branch = _options_branch === void 0 ? [
                    value
                ] : _options_branch, _options_coerce = options.coerce, coerce = _options_coerce === void 0 ? false : _options_coerce, _options_mask = options.mask, mask = _options_mask === void 0 ? false : _options_mask;
                ctx = {
                    path: path,
                    branch: branch,
                    mask: mask
                };
                if (coerce) value = struct.coercer(value, ctx);
                status = "valid";
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = struct.validator(value, ctx)[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                failure = _step.value;
                failure.explanation = options.message;
                status = "not_valid";
                return [
                    4,
                    [
                        failure,
                        undefined
                    ]
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 9;
            case 9:
                _state.trys.push([
                    9,
                    21,
                    22,
                    23
                ]);
                _iterator1 = struct.entries(value, ctx)[Symbol.iterator]();
                _state.label = 10;
            case 10:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    20
                ];
                _step_value = (0, $5OlIx._)(_step1.value, 3), k = _step_value[0], v = _step_value[1], s = _step_value[2];
                ts = run(v, s, {
                    path: k === undefined ? path : (0, $gF0bR._)(path).concat([
                        k
                    ]),
                    branch: k === undefined ? branch : (0, $gF0bR._)(branch).concat([
                        v
                    ]),
                    coerce: coerce,
                    mask: mask,
                    message: options.message
                });
                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                _state.label = 11;
            case 11:
                _state.trys.push([
                    11,
                    17,
                    18,
                    19
                ]);
                _iterator2 = ts[Symbol.iterator]();
                _state.label = 12;
            case 12:
                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                    3,
                    16
                ];
                t = _step2.value;
                if (!t[0]) return [
                    3,
                    14
                ];
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                return [
                    4,
                    [
                        t[0],
                        undefined
                    ]
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 14:
                if (coerce) {
                    v = t[1];
                    if (k === undefined) value = v;
                    else if (value instanceof Map) value.set(k, v);
                    else if (value instanceof Set) value.add(v);
                    else if (isObject(value)) {
                        if (v !== undefined || k in value) value[k] = v;
                    }
                }
                _state.label = 15;
            case 15:
                _iteratorNormalCompletion2 = true;
                return [
                    3,
                    12
                ];
            case 16:
                return [
                    3,
                    19
                ];
            case 17:
                err = _state.sent();
                _didIteratorError2 = true;
                _iteratorError2 = err;
                return [
                    3,
                    19
                ];
            case 18:
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
                return [
                    7
                ];
            case 19:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    10
                ];
            case 20:
                return [
                    3,
                    23
                ];
            case 21:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    23
                ];
            case 22:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 23:
                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                if (!(status !== "not_valid")) return [
                    3,
                    31
                ];
                _state.label = 24;
            case 24:
                _state.trys.push([
                    24,
                    29,
                    30,
                    31
                ]);
                _iterator3 = struct.refiner(value, ctx)[Symbol.iterator]();
                _state.label = 25;
            case 25:
                if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                    3,
                    28
                ];
                failure1 = _step3.value;
                failure1.explanation = options.message;
                status = "not_refined";
                return [
                    4,
                    [
                        failure1,
                        undefined
                    ]
                ];
            case 26:
                _state.sent();
                _state.label = 27;
            case 27:
                _iteratorNormalCompletion3 = true;
                return [
                    3,
                    25
                ];
            case 28:
                return [
                    3,
                    31
                ];
            case 29:
                err = _state.sent();
                _didIteratorError3 = true;
                _iteratorError3 = err;
                return [
                    3,
                    31
                ];
            case 30:
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
                return [
                    7
                ];
            case 31:
                if (!(status === "valid")) return [
                    3,
                    33
                ];
                return [
                    4,
                    [
                        undefined,
                        value
                    ]
                ];
            case 32:
                _state.sent();
                _state.label = 33;
            case 33:
                return [
                    2
                ];
        }
    });
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ var Struct = /*#__PURE__*/ function() {
    "use strict";
    function Struct(props) {
        var _this = this;
        (0, $7dKN1._)(this, Struct);
        var type = props.type, schema = props.schema, validator = props.validator, refiner = props.refiner, _props_coercer = props.coercer, coercer = _props_coercer === void 0 ? function(value) {
            return value;
        } : _props_coercer, _props_entries = props.entries, entries = _props_entries === void 0 ? function() {
            return (0, $6qu4b.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        } : _props_entries;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = function(value, context) {
            var result = validator(value, context);
            return toFailures(result, context, _this, value);
        };
        else this.validator = function() {
            return [];
        };
        if (refiner) this.refiner = function(value, context) {
            var result = refiner(value, context);
            return toFailures(result, context, _this, value);
        };
        else this.refiner = function() {
            return [];
        };
    }
    (0, $eW5pA._)(Struct, [
        {
            /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ key: "assert",
            value: function assert1(value, message) {
                return assert(value, this, message);
            }
        },
        {
            /**
     * Create a value with the struct's coercion logic, then validate it.
     */ key: "create",
            value: function create1(value, message) {
                return create(value, this, message);
            }
        },
        {
            /**
     * Check if a value passes the struct's validation.
     */ key: "is",
            value: function is1(value) {
                return is(value, this);
            }
        },
        {
            /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ key: "mask",
            value: function mask1(value, message) {
                return mask(value, this, message);
            }
        },
        {
            /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ key: "validate",
            value: function validate1(value) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return validate(value, this, options);
            }
        }
    ]);
    return Struct;
}();
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function assert(value, struct, message) {
    var result = validate(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function create(value, struct, message) {
    var result = validate(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function mask(value, struct, message) {
    var result = validate(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function is(value, struct) {
    var result = validate(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function validate(value, struct) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var tuples = run(value, struct, options);
    var tuple = shiftIterator(tuples);
    if (tuple[0]) {
        var error = new StructError(tuple[0], function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = tuples[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        t = _step.value;
                        if (!t[0]) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t[0]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return [
            error,
            undefined
        ];
    } else {
        var v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function assign() {
    for(var _len = arguments.length, Structs = new Array(_len), _key = 0; _key < _len; _key++){
        Structs[_key] = arguments[_key];
    }
    var _Object;
    var isType = Structs[0].type === "type";
    var schemas = Structs.map(function(s) {
        return s.schema;
    });
    var schema = (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, $gF0bR._)(schemas)));
    return isType ? type(schema) : object(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function define(name, validator) {
    return new Struct({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function deprecated(struct, log) {
    return new Struct((0, $gddcW._)((0, $4JCw4._)({}, struct), {
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        },
        validator: function(value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    }));
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function dynamic(fn) {
    return new Struct({
        type: "dynamic",
        schema: null,
        entries: function(value, ctx) {
            var struct;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct = fn(value, ctx);
                        return [
                            5,
                            (0, $6qu4b.__values)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function lazy(fn) {
    var struct;
    return new Struct({
        type: "lazy",
        schema: null,
        entries: function(value, ctx) {
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct !== null && struct !== void 0 ? struct : struct = fn();
                        return [
                            5,
                            (0, $6qu4b.__values)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function omit(struct, keys) {
    var schema = struct.schema;
    var subschema = (0, $4JCw4._)({}, schema);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            delete subschema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return type(subschema);
        default:
            return object(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function partial(struct) {
    var isStruct = struct instanceof Struct;
    var schema = isStruct ? (0, $4JCw4._)({}, struct.schema) : (0, $4JCw4._)({}, struct);
    for(var key in schema)schema[key] = optional(schema[key]);
    if (isStruct && struct.type === "type") return type(schema);
    return object(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function pick(struct, keys) {
    var schema = struct.schema;
    var subschema = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            subschema[key] = schema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return type(subschema);
        default:
            return object(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function struct(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return define(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function any() {
    return define("any", function() {
        return true;
    });
}
function array(Element) {
    return new Struct({
        type: "array",
        schema: Element,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, v, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && Array.isArray(value))) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        _step_value = (0, $5OlIx._)(_step.value, 2), i = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                i,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array value, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function bigint() {
    return define("bigint", function(value) {
        return (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function boolean() {
    return define("boolean", function(value) {
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function date() {
    return define("date", function(value) {
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: ".concat(print(value));
    });
}
function enums(values) {
    var schema = {};
    var description = values.map(function(v) {
        return print(v);
    }).join();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            schema[key] = key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new Struct({
        type: "enums",
        schema: schema,
        validator: function(value) {
            return values.includes(value) || "Expected one of `".concat(description, "`, but received: ").concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function func() {
    return define("func", function(value) {
        return typeof value === "function" || "Expected a function, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function instance(Class) {
    return define("instance", function(value) {
        return value instanceof Class || "Expected a `".concat(Class.name, "` instance, but received: ").concat(print(value));
    });
}
/**
 * Ensure that a value is an integer.
 */ function integer() {
    return define("integer", function(value) {
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function intersection(Structs) {
    return new Struct({
        type: "intersection",
        schema: null,
        entries: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $6qu4b.__values)(S.entries(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $6qu4b.__values)(S.validator(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        refiner: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $6qu4b.__values)(S.refiner(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        }
    });
}
function literal(constant) {
    var description = print(constant);
    var t = typeof constant === "undefined" ? "undefined" : (0, $aVMuR._)(constant);
    return new Struct({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator: function(value) {
            return value === constant || "Expected the literal `".concat(description, "`, but received: ").concat(print(value));
        }
    });
}
function map(Key, Value) {
    return new Struct({
        type: "map",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, k, v, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Key && Value && value instanceof Map)) return [
                            3,
                            9
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        _step_value = (0, $5OlIx._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator: function(value) {
            return value instanceof Map || "Expected a `Map` object, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function never() {
    return define("never", function() {
        return false;
    });
}
/**
 * Augment an existing struct to allow `null` values.
 */ function nullable(struct) {
    return new Struct((0, $gddcW._)((0, $4JCw4._)({}, struct), {
        validator: function(value, ctx) {
            return value === null || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === null || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is a number.
 */ function number() {
    return define("number", function(value) {
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: ".concat(print(value));
    });
}
function object(schema) {
    var knowns = schema ? Object.keys(schema) : [];
    var Never = never();
    return new Struct({
        type: "object",
        schema: schema ? schema : null,
        entries: function(value) {
            var unknowns, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(schema && isObject(value))) return [
                            3,
                            16
                        ];
                        unknowns = new Set(Object.keys(value));
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = knowns[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        key = _step.value;
                        unknowns.delete(key);
                        return [
                            4,
                            [
                                key,
                                value[key],
                                schema[key]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        _iterator1 = unknowns[Symbol.iterator]();
                        _state.label = 10;
                    case 10:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            13
                        ];
                        key1 = _step1.value;
                        return [
                            4,
                            [
                                key1,
                                value[key1],
                                Never
                            ]
                        ];
                    case 11:
                        _state.sent();
                        _state.label = 12;
                    case 12:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            10
                        ];
                    case 13:
                        return [
                            3,
                            16
                        ];
                    case 14:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            16
                        ];
                    case 15:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value, ctx) {
            if (!isNonArrayObject(value)) return value;
            var coerced = (0, $4JCw4._)({}, value);
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(var key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function optional(struct) {
    return new Struct((0, $gddcW._)((0, $4JCw4._)({}, struct), {
        validator: function(value, ctx) {
            return value === undefined || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function record(Key, Value) {
    return new Struct({
        type: "record",
        schema: null,
        entries: function(value) {
            var _tmp, _tmp1, _i, k, v;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isObject(value)) return [
                            3,
                            5
                        ];
                        _tmp = [];
                        for(_tmp1 in value)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            5
                        ];
                        k = _tmp[_i];
                        v = value[k];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return isNonArrayObject(value) ? (0, $4JCw4._)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function regexp() {
    return define("regexp", function(value) {
        return value instanceof RegExp;
    });
}
function set(Element) {
    return new Struct({
        type: "set",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && value instanceof Set)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        v = _step.value;
                        return [
                            4,
                            [
                                v,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator: function(value) {
            return value instanceof Set || "Expected a `Set` object, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function string() {
    return define("string", function(value) {
        return typeof value === "string" || "Expected a string, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function tuple(Structs) {
    var Never = never();
    return new Struct({
        type: "tuple",
        schema: null,
        entries: function(value) {
            var length, i;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!Array.isArray(value)) return [
                            3,
                            4
                        ];
                        length = Math.max(Structs.length, value.length);
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < length)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            [
                                i,
                                value[i],
                                Structs[i] || Never
                            ]
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function type(schema) {
    var keys = Object.keys(schema);
    return new Struct({
        type: "type",
        schema: schema,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!isObject(value)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = keys[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        k = _step.value;
                        return [
                            4,
                            [
                                k,
                                value[k],
                                schema[k]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return isNonArrayObject(value) ? (0, $4JCw4._)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function union(Structs) {
    var description = Structs.map(function(s) {
        return s.type;
    }).join(" | ");
    return new Struct({
        type: "union",
        schema: null,
        coercer: function(value, ctx) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _S_validate = (0, $5OlIx._)(S.validate(value, {
                        coerce: true,
                        mask: ctx.mask
                    }), 2), error = _S_validate[0], coerced = _S_validate[1];
                    if (!error) return coerced;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return value;
        },
        validator: function(value, ctx) {
            var failures = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _run = (0, $dXE6R._)(run(value, S, ctx)), tuples = _run.slice(0);
                    var _tuples = (0, $5OlIx._)(tuples, 1), first = _tuples[0];
                    if (!first[0]) return [];
                    else {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = tuples[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, $5OlIx._)(_step1.value, 1), failure = _step_value[0];
                                if (failure) failures.push(failure);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                "Expected the value to satisfy a union of `".concat(description, "`, but received: ").concat(print(value))
            ].concat((0, $gF0bR._)(failures));
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function unknown() {
    return define("unknown", function() {
        return true;
    });
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function coerce(struct, condition, coercer) {
    return new Struct((0, $gddcW._)((0, $4JCw4._)({}, struct), {
        coercer: function(value, ctx) {
            return is(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    }));
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function defaulted(struct, fallback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return coerce(struct, unknown(), function(x) {
        var f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && isPlainObject(x) && isPlainObject(f)) {
            var ret = (0, $4JCw4._)({}, x);
            var changed = false;
            for(var key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function trimmed(struct) {
    return coerce(struct, string(), function(x) {
        return x.trim();
    });
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function empty(struct) {
    return refine(struct, "empty", function(value) {
        var size = getSize(value);
        return size === 0 || "Expected an empty ".concat(struct.type, " but received one with a size of `").concat(size, "`");
    });
}
function getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function max(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return refine(struct, "max", function(value) {
        return exclusive ? value < threshold : value <= threshold || "Expected a ".concat(struct.type, " less than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function min(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return refine(struct, "min", function(value) {
        return exclusive ? value > threshold : value >= threshold || "Expected a ".concat(struct.type, " greater than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function nonempty(struct) {
    return refine(struct, "nonempty", function(value) {
        var size = getSize(value);
        return size > 0 || "Expected a nonempty ".concat(struct.type, " but received an empty one");
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function pattern(struct, regexp) {
    return refine(struct, "pattern", function(value) {
        return regexp.test(value) || "Expected a ".concat(struct.type, " matching `/").concat(regexp.source, '/` but received "').concat(value, '"');
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function size(struct, min) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : min;
    var expected = "Expected a ".concat(struct.type);
    var of = min === max ? "of `".concat(min, "`") : "between `".concat(min, "` and `").concat(max, "`");
    return refine(struct, "size", function(value) {
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || "".concat(expected, " ").concat(of, " but received `").concat(value, "`");
        else if (value instanceof Map || value instanceof Set) {
            var size = value.size;
            return min <= size && size <= max || "".concat(expected, " with a size ").concat(of, " but received one with a size of `").concat(size, "`");
        } else {
            var length = value.length;
            return min <= length && length <= max || "".concat(expected, " with a length ").concat(of, " but received one with a length of `").concat(length, "`");
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function refine(struct, name, refiner) {
    return new Struct((0, $gddcW._)((0, $4JCw4._)({}, struct), {
        refiner: function(value, ctx) {
            var result, failures, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            5,
                            (0, $6qu4b.__values)(struct.refiner(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        result = refiner(value, ctx);
                        failures = toFailures(result, ctx, struct, value);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = failures[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        failure = _step.value;
                        return [
                            4,
                            (0, $gddcW._)((0, $4JCw4._)({}, failure), {
                                refinement: name
                            })
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        }
    }));
}

});
parcelRegister("bL8uU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $88faacf36f30b3d7$export$71511d61b312f219; });

var $iwUnq = parcelRequire("iwUnq");
function $88faacf36f30b3d7$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $iwUnq._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("iwUnq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d7d6f26f39f46a89$export$71511d61b312f219; });
function $d7d6f26f39f46a89$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("dXE6R", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a29fe5f7d584c6b8$export$71511d61b312f219; });

var $5oE3w = parcelRequire("5oE3w");

var $gdcCC = parcelRequire("gdcCC");

var $kT97Q = parcelRequire("kT97Q");

var $iJGZg = parcelRequire("iJGZg");
function $a29fe5f7d584c6b8$export$71511d61b312f219(arr) {
    return (0, $5oE3w._)(arr) || (0, $gdcCC._)(arr) || (0, $iJGZg._)(arr) || (0, $kT97Q._)();
}

});

parcelRegister("jShW9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e780f95782abbe7b$export$71511d61b312f219; });

var $juUd4 = parcelRequire("juUd4");

var $fG73q = parcelRequire("fG73q");

var $fYerd = parcelRequire("fYerd");

var $lJlHo = parcelRequire("lJlHo");
function $e780f95782abbe7b$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e780f95782abbe7b$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $fYerd._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $juUd4._)(Class, arguments, (0, $fG73q._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $lJlHo._)(Wrapper, Class);
    };
    return $e780f95782abbe7b$export$71511d61b312f219(Class);
}

});
parcelRegister("juUd4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e31c6bc2fd2d0110$export$71511d61b312f219; });

var $ecvIT = parcelRequire("ecvIT");

var $lJlHo = parcelRequire("lJlHo");
function $e31c6bc2fd2d0110$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $ecvIT._)()) $e31c6bc2fd2d0110$export$71511d61b312f219 = Reflect.construct;
    else $e31c6bc2fd2d0110$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $lJlHo._)(instance, Class.prototype);
        return instance;
    };
    return $e31c6bc2fd2d0110$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("fYerd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba07a8ad4783c460$export$71511d61b312f219; });
function $ba07a8ad4783c460$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});




var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");

var $6rBFC = parcelRequire("6rBFC");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $5OlIx = parcelRequire("5OlIx");

var $6qu4b = parcelRequire("6qu4b");
function $7bb7588d65550050$export$5c069c93d2b7493f() {
    var ms = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}


var $c9b9a1a428003423$exports = {};
"use strict";
Object.defineProperty($c9b9a1a428003423$exports, "__esModule", {
    value: true
});
$c9b9a1a428003423$exports.executeKdf = $c9b9a1a428003423$exports.makeStdTx = $c9b9a1a428003423$exports.isStdTx = $c9b9a1a428003423$exports.serializeSignDoc = $c9b9a1a428003423$exports.makeSignDoc = $c9b9a1a428003423$exports.encodeSecp256k1Signature = $c9b9a1a428003423$exports.decodeSignature = $c9b9a1a428003423$exports.Secp256k1Wallet = $c9b9a1a428003423$exports.Secp256k1HdWallet = $c9b9a1a428003423$exports.extractKdfConfiguration = $c9b9a1a428003423$exports.pubkeyType = $c9b9a1a428003423$exports.isSinglePubkey = $c9b9a1a428003423$exports.isSecp256k1Pubkey = $c9b9a1a428003423$exports.isMultisigThresholdPubkey = $c9b9a1a428003423$exports.isEd25519Pubkey = $c9b9a1a428003423$exports.makeCosmoshubPath = $c9b9a1a428003423$exports.createMultisigThresholdPubkey = $c9b9a1a428003423$exports.encodeSecp256k1Pubkey = $c9b9a1a428003423$exports.encodeEd25519Pubkey = $c9b9a1a428003423$exports.encodeBech32Pubkey = $c9b9a1a428003423$exports.encodeAminoPubkey = $c9b9a1a428003423$exports.decodeBech32Pubkey = $c9b9a1a428003423$exports.decodeAminoPubkey = $c9b9a1a428003423$exports.parseCoins = $c9b9a1a428003423$exports.coins = $c9b9a1a428003423$exports.coin = $c9b9a1a428003423$exports.addCoins = $c9b9a1a428003423$exports.rawSecp256k1PubkeyToRawAddress = $c9b9a1a428003423$exports.rawEd25519PubkeyToRawAddress = $c9b9a1a428003423$exports.pubkeyToRawAddress = $c9b9a1a428003423$exports.pubkeyToAddress = void 0;
var $c32fd5e1269323d5$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($c32fd5e1269323d5$exports, "__esModule", {
    value: true
});
$c32fd5e1269323d5$exports.pubkeyToAddress = $c32fd5e1269323d5$exports.pubkeyToRawAddress = $c32fd5e1269323d5$exports.rawSecp256k1PubkeyToRawAddress = $c32fd5e1269323d5$exports.rawEd25519PubkeyToRawAddress = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");
var $e844b074451f4752$exports = {};

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($e844b074451f4752$exports, "__esModule", {
    value: true
});
$e844b074451f4752$exports.encodeBech32Pubkey = $e844b074451f4752$exports.encodeAminoPubkey = $e844b074451f4752$exports.decodeBech32Pubkey = $e844b074451f4752$exports.decodeAminoPubkey = $e844b074451f4752$exports.encodeEd25519Pubkey = $e844b074451f4752$exports.encodeSecp256k1Pubkey = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");

var $gMk5u = parcelRequire("gMk5u");
var $1bc5b2872e2c7023$exports = {};
"use strict";
Object.defineProperty($1bc5b2872e2c7023$exports, "__esModule", {
    value: true
});
$1bc5b2872e2c7023$exports.isMultisigThresholdPubkey = $1bc5b2872e2c7023$exports.isSinglePubkey = $1bc5b2872e2c7023$exports.pubkeyType = $1bc5b2872e2c7023$exports.isSecp256k1Pubkey = $1bc5b2872e2c7023$exports.isEd25519Pubkey = void 0;
function $1bc5b2872e2c7023$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$1bc5b2872e2c7023$exports.isEd25519Pubkey = $1bc5b2872e2c7023$var$isEd25519Pubkey;
function $1bc5b2872e2c7023$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$1bc5b2872e2c7023$exports.isSecp256k1Pubkey = $1bc5b2872e2c7023$var$isSecp256k1Pubkey;
$1bc5b2872e2c7023$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $1bc5b2872e2c7023$var$isSinglePubkey(pubkey) {
    var singPubkeyTypes = [
        $1bc5b2872e2c7023$exports.pubkeyType.ed25519,
        $1bc5b2872e2c7023$exports.pubkeyType.secp256k1,
        $1bc5b2872e2c7023$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$1bc5b2872e2c7023$exports.isSinglePubkey = $1bc5b2872e2c7023$var$isSinglePubkey;
function $1bc5b2872e2c7023$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$1bc5b2872e2c7023$exports.isMultisigThresholdPubkey = $1bc5b2872e2c7023$var$isMultisigThresholdPubkey;


/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $e844b074451f4752$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $1bc5b2872e2c7023$exports.pubkeyType.secp256k1,
        value: (0, $lSA9E.toBase64)(pubkey)
    };
}
$e844b074451f4752$exports.encodeSecp256k1Pubkey = $e844b074451f4752$var$encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $e844b074451f4752$var$encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) throw new Error("Ed25519 public key must be 32 bytes long");
    return {
        type: $1bc5b2872e2c7023$exports.pubkeyType.ed25519,
        value: (0, $lSA9E.toBase64)(pubkey)
    };
}
$e844b074451f4752$exports.encodeEd25519Pubkey = $e844b074451f4752$var$encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
var $e844b074451f4752$var$pubkeyAminoPrefixSecp256k1 = (0, $lSA9E.fromHex)("eb5ae98721" /* fixed length */ );
var $e844b074451f4752$var$pubkeyAminoPrefixEd25519 = (0, $lSA9E.fromHex)("1624de6420" /* fixed length */ );
var $e844b074451f4752$var$pubkeyAminoPrefixSr25519 = (0, $lSA9E.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ var $e844b074451f4752$var$pubkeyAminoPrefixMultisigThreshold = (0, $lSA9E.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $e844b074451f4752$var$decodeAminoPubkey(data) {
    if ((0, $gMk5u.arrayContentStartsWith)(data, $e844b074451f4752$var$pubkeyAminoPrefixSecp256k1)) {
        var rest = data.slice($e844b074451f4752$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $1bc5b2872e2c7023$exports.pubkeyType.secp256k1,
            value: (0, $lSA9E.toBase64)(rest)
        };
    } else if ((0, $gMk5u.arrayContentStartsWith)(data, $e844b074451f4752$var$pubkeyAminoPrefixEd25519)) {
        var rest1 = data.slice($e844b074451f4752$var$pubkeyAminoPrefixEd25519.length);
        if (rest1.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $1bc5b2872e2c7023$exports.pubkeyType.ed25519,
            value: (0, $lSA9E.toBase64)(rest1)
        };
    } else if ((0, $gMk5u.arrayContentStartsWith)(data, $e844b074451f4752$var$pubkeyAminoPrefixSr25519)) {
        var rest2 = data.slice($e844b074451f4752$var$pubkeyAminoPrefixSr25519.length);
        if (rest2.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $1bc5b2872e2c7023$exports.pubkeyType.sr25519,
            value: (0, $lSA9E.toBase64)(rest2)
        };
    } else if ((0, $gMk5u.arrayContentStartsWith)(data, $e844b074451f4752$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $e844b074451f4752$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $lSA9E.toHex)(data.slice(0, 5)));
}
$e844b074451f4752$exports.decodeAminoPubkey = $e844b074451f4752$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $e844b074451f4752$var$decodeBech32Pubkey(bechEncoded) {
    var data = (0, $lSA9E.fromBech32)(bechEncoded).data;
    return $e844b074451f4752$var$decodeAminoPubkey(data);
}
$e844b074451f4752$exports.decodeBech32Pubkey = $e844b074451f4752$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $e844b074451f4752$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $e844b074451f4752$var$decodeMultisigPubkey(data) {
    var reader = Array.from(data);
    // remove multisig amino prefix;
    var prefixFromReader = reader.splice(0, $e844b074451f4752$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $gMk5u.arrayContentStartsWith)(prefixFromReader, $e844b074451f4752$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    var _decodeUvarint = (0, $5OlIx._)($e844b074451f4752$var$decodeUvarint(reader), 2), threshold = _decodeUvarint[0], thresholdBytesLength = _decodeUvarint[1];
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    var pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        var _decodeUvarint1 = (0, $5OlIx._)($e844b074451f4752$var$decodeUvarint(reader), 2), pubkeyLength = _decodeUvarint1[0], pubkeyLengthBytesSize = _decodeUvarint1[1];
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        var encodedPubkey = reader.splice(0, pubkeyLength);
        var pubkey = $e844b074451f4752$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $1bc5b2872e2c7023$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $e844b074451f4752$var$encodeUvarint(value) {
    var checked = $kTbgy.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $e844b074451f4752$var$encodeAminoPubkey(pubkey) {
    if ((0, $1bc5b2872e2c7023$exports.isMultisigThresholdPubkey)(pubkey)) {
        var _out;
        var out = Array.from($e844b074451f4752$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        (_out = out).push.apply(_out, (0, $gF0bR._)($e844b074451f4752$var$encodeUvarint(pubkey.value.threshold)));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = pubkey.value.pubkeys.map(function(p) {
                return $e844b074451f4752$var$encodeAminoPubkey(p);
            })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var pubkeyData = _step.value;
                var _out1, _out2;
                out.push(0x12); // TODO: What is this?
                (_out1 = out).push.apply(_out1, (0, $gF0bR._)($e844b074451f4752$var$encodeUvarint(pubkeyData.length)));
                (_out2 = out).push.apply(_out2, (0, $gF0bR._)(pubkeyData));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new Uint8Array(out);
    } else if ((0, $1bc5b2872e2c7023$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array((0, $gF0bR._)($e844b074451f4752$var$pubkeyAminoPrefixEd25519).concat((0, $gF0bR._)((0, $lSA9E.fromBase64)(pubkey.value))));
    else if ((0, $1bc5b2872e2c7023$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array((0, $gF0bR._)($e844b074451f4752$var$pubkeyAminoPrefixSecp256k1).concat((0, $gF0bR._)((0, $lSA9E.fromBase64)(pubkey.value))));
    else throw new Error("Unsupported pubkey type");
}
$e844b074451f4752$exports.encodeAminoPubkey = $e844b074451f4752$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $e844b074451f4752$var$encodeBech32Pubkey(pubkey, prefix) {
    return (0, $lSA9E.toBech32)(prefix, $e844b074451f4752$var$encodeAminoPubkey(pubkey));
}
$e844b074451f4752$exports.encodeBech32Pubkey = $e844b074451f4752$var$encodeBech32Pubkey;



function $c32fd5e1269323d5$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error("Invalid Ed25519 pubkey length: ".concat(pubkeyData.length));
    return (0, $3d6bA.sha256)(pubkeyData).slice(0, 20);
}
$c32fd5e1269323d5$exports.rawEd25519PubkeyToRawAddress = $c32fd5e1269323d5$var$rawEd25519PubkeyToRawAddress;
function $c32fd5e1269323d5$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error("Invalid Secp256k1 pubkey length (compressed): ".concat(pubkeyData.length));
    return (0, $3d6bA.ripemd160)((0, $3d6bA.sha256)(pubkeyData));
}
$c32fd5e1269323d5$exports.rawSecp256k1PubkeyToRawAddress = $c32fd5e1269323d5$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $c32fd5e1269323d5$var$pubkeyToRawAddress(pubkey) {
    if ((0, $1bc5b2872e2c7023$exports.isSecp256k1Pubkey)(pubkey)) {
        var pubkeyData = (0, $lSA9E.fromBase64)(pubkey.value);
        return $c32fd5e1269323d5$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $1bc5b2872e2c7023$exports.isEd25519Pubkey)(pubkey)) {
        var pubkeyData1 = (0, $lSA9E.fromBase64)(pubkey.value);
        return $c32fd5e1269323d5$var$rawEd25519PubkeyToRawAddress(pubkeyData1);
    } else if ((0, $1bc5b2872e2c7023$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        var pubkeyData2 = (0, $e844b074451f4752$exports.encodeAminoPubkey)(pubkey);
        return (0, $3d6bA.sha256)(pubkeyData2).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$c32fd5e1269323d5$exports.pubkeyToRawAddress = $c32fd5e1269323d5$var$pubkeyToRawAddress;
function $c32fd5e1269323d5$var$pubkeyToAddress(pubkey, prefix) {
    return (0, $lSA9E.toBech32)(prefix, $c32fd5e1269323d5$var$pubkeyToRawAddress(pubkey));
}
$c32fd5e1269323d5$exports.pubkeyToAddress = $c32fd5e1269323d5$var$pubkeyToAddress;


Object.defineProperty($c9b9a1a428003423$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function get() {
        return $c32fd5e1269323d5$exports.pubkeyToAddress;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function get() {
        return $c32fd5e1269323d5$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function get() {
        return $c32fd5e1269323d5$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function get() {
        return $c32fd5e1269323d5$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $9eb9f4477dab0b94$exports = {};
"use strict";
Object.defineProperty($9eb9f4477dab0b94$exports, "__esModule", {
    value: true
});
$9eb9f4477dab0b94$exports.addCoins = $9eb9f4477dab0b94$exports.parseCoins = $9eb9f4477dab0b94$exports.coins = $9eb9f4477dab0b94$exports.coin = void 0;

var $kTbgy = parcelRequire("kTbgy");
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $9eb9f4477dab0b94$var$coin(amount, denom) {
    var outAmount;
    if (typeof amount === "number") try {
        outAmount = new $kTbgy.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$9eb9f4477dab0b94$exports.coin = $9eb9f4477dab0b94$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $9eb9f4477dab0b94$var$coins(amount, denom) {
    return [
        $9eb9f4477dab0b94$var$coin(amount, denom)
    ];
}
$9eb9f4477dab0b94$exports.coins = $9eb9f4477dab0b94$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $9eb9f4477dab0b94$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map(function(part) {
        var match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
$9eb9f4477dab0b94$exports.parseCoins = $9eb9f4477dab0b94$var$parseCoins;
/**
 * Function to sum up coins with type Coin
 */ function $9eb9f4477dab0b94$var$addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom) throw new Error("Trying to add two coins with different denoms");
    return {
        amount: $kTbgy.Decimal.fromAtomics(lhs.amount, 0).plus($kTbgy.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom
    };
}
$9eb9f4477dab0b94$exports.addCoins = $9eb9f4477dab0b94$var$addCoins;


Object.defineProperty($c9b9a1a428003423$exports, "addCoins", {
    enumerable: true,
    get: function get() {
        return $9eb9f4477dab0b94$exports.addCoins;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "coin", {
    enumerable: true,
    get: function get() {
        return $9eb9f4477dab0b94$exports.coin;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "coins", {
    enumerable: true,
    get: function get() {
        return $9eb9f4477dab0b94$exports.coins;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "parseCoins", {
    enumerable: true,
    get: function get() {
        return $9eb9f4477dab0b94$exports.parseCoins;
    }
});

Object.defineProperty($c9b9a1a428003423$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function get() {
        return $e844b074451f4752$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function get() {
        return $e844b074451f4752$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function get() {
        return $e844b074451f4752$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function get() {
        return $e844b074451f4752$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "encodeEd25519Pubkey", {
    enumerable: true,
    get: function get() {
        return $e844b074451f4752$exports.encodeEd25519Pubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function get() {
        return $e844b074451f4752$exports.encodeSecp256k1Pubkey;
    }
});
var $34631ad3ef612261$exports = {};
"use strict";
Object.defineProperty($34631ad3ef612261$exports, "__esModule", {
    value: true
});
$34631ad3ef612261$exports.createMultisigThresholdPubkey = $34631ad3ef612261$exports.compareArrays = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");

/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $34631ad3ef612261$var$compareArrays(a, b) {
    var aHex = (0, $lSA9E.toHex)(a);
    var bHex = (0, $lSA9E.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$34631ad3ef612261$exports.compareArrays = $34631ad3ef612261$var$compareArrays;
function $34631ad3ef612261$var$createMultisigThresholdPubkey(pubkeys, threshold) {
    var nosort = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var uintThreshold = new $kTbgy.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error("Threshold k = ".concat(uintThreshold.toNumber(), " exceeds number of keys n = ").concat(pubkeys.length));
    var outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort(function(lhs, rhs) {
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        var addressLhs = (0, $c32fd5e1269323d5$exports.pubkeyToRawAddress)(lhs);
        var addressRhs = (0, $c32fd5e1269323d5$exports.pubkeyToRawAddress)(rhs);
        return $34631ad3ef612261$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$34631ad3ef612261$exports.createMultisigThresholdPubkey = $34631ad3ef612261$var$createMultisigThresholdPubkey;


Object.defineProperty($c9b9a1a428003423$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function get() {
        return $34631ad3ef612261$exports.createMultisigThresholdPubkey;
    }
});
var $1c91cbf6e4c52cd6$exports = {};
"use strict";
Object.defineProperty($1c91cbf6e4c52cd6$exports, "__esModule", {
    value: true
});
$1c91cbf6e4c52cd6$exports.makeCosmoshubPath = void 0;

var $3d6bA = parcelRequire("3d6bA");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $1c91cbf6e4c52cd6$var$makeCosmoshubPath(a) {
    return [
        $3d6bA.Slip10RawIndex.hardened(44),
        $3d6bA.Slip10RawIndex.hardened(118),
        $3d6bA.Slip10RawIndex.hardened(0),
        $3d6bA.Slip10RawIndex.normal(0),
        $3d6bA.Slip10RawIndex.normal(a)
    ];
}
$1c91cbf6e4c52cd6$exports.makeCosmoshubPath = $1c91cbf6e4c52cd6$var$makeCosmoshubPath;


Object.defineProperty($c9b9a1a428003423$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function get() {
        return $1c91cbf6e4c52cd6$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($c9b9a1a428003423$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function get() {
        return $1bc5b2872e2c7023$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function get() {
        return $1bc5b2872e2c7023$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function get() {
        return $1bc5b2872e2c7023$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "isSinglePubkey", {
    enumerable: true,
    get: function get() {
        return $1bc5b2872e2c7023$exports.isSinglePubkey;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "pubkeyType", {
    enumerable: true,
    get: function get() {
        return $1bc5b2872e2c7023$exports.pubkeyType;
    }
});
var $73cae90be3154127$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($73cae90be3154127$exports, "__esModule", {
    value: true
});
$73cae90be3154127$exports.Secp256k1HdWallet = $73cae90be3154127$exports.extractKdfConfiguration = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");

var $gMk5u = parcelRequire("gMk5u");


var $6839f22adca35848$exports = {};
"use strict";
Object.defineProperty($6839f22adca35848$exports, "__esModule", {
    value: true
});
$6839f22adca35848$exports.decodeSignature = $6839f22adca35848$exports.encodeSecp256k1Signature = void 0;

var $lSA9E = parcelRequire("lSA9E");


/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $6839f22adca35848$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $e844b074451f4752$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $lSA9E.toBase64)(signature)
    };
}
$6839f22adca35848$exports.encodeSecp256k1Signature = $6839f22adca35848$var$encodeSecp256k1Signature;
function $6839f22adca35848$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $1bc5b2872e2c7023$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $lSA9E.fromBase64)(signature.pub_key.value),
                signature: (0, $lSA9E.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$6839f22adca35848$exports.decodeSignature = $6839f22adca35848$var$decodeSignature;


var $f574a085b8fba5c8$exports = {};
"use strict";
Object.defineProperty($f574a085b8fba5c8$exports, "__esModule", {
    value: true
});
$f574a085b8fba5c8$exports.serializeSignDoc = $f574a085b8fba5c8$exports.escapeCharacters = $f574a085b8fba5c8$exports.makeSignDoc = $f574a085b8fba5c8$exports.sortedJsonStringify = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");
function $f574a085b8fba5c8$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($f574a085b8fba5c8$var$sortedObject);
    var sortedKeys = Object.keys(obj).sort();
    var result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach(function(key) {
        result[key] = $f574a085b8fba5c8$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $f574a085b8fba5c8$var$sortedJsonStringify(obj) {
    return JSON.stringify($f574a085b8fba5c8$var$sortedObject(obj));
}
$f574a085b8fba5c8$exports.sortedJsonStringify = $f574a085b8fba5c8$var$sortedJsonStringify;
function $f574a085b8fba5c8$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $kTbgy.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $kTbgy.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$f574a085b8fba5c8$exports.makeSignDoc = $f574a085b8fba5c8$var$makeSignDoc;
/**
 * Takes a valid JSON document and performs the following escapings in string values:
 *
 * `&` -> `\u0026`
 * `<` -> `\u003c`
 * `>` -> `\u003e`
 *
 * Since those characters do not occur in other places of the JSON document, only
 * string values are affected.
 *
 * If the input is invalid JSON, the behaviour is undefined.
 */ function $f574a085b8fba5c8$var$escapeCharacters(input) {
    // When we migrate to target es2021 or above, we can use replaceAll instead of global patterns.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
    var amp = /&/g;
    var lt = /</g;
    var gt = />/g;
    return input.replace(amp, "\\u0026").replace(lt, "\\u003c").replace(gt, "\\u003e");
}
$f574a085b8fba5c8$exports.escapeCharacters = $f574a085b8fba5c8$var$escapeCharacters;
function $f574a085b8fba5c8$var$serializeSignDoc(signDoc) {
    var serialized = $f574a085b8fba5c8$var$escapeCharacters($f574a085b8fba5c8$var$sortedJsonStringify(signDoc));
    return (0, $lSA9E.toUtf8)(serialized);
}
$f574a085b8fba5c8$exports.serializeSignDoc = $f574a085b8fba5c8$var$serializeSignDoc;


var $4a3e0f7d8f5f26e8$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($4a3e0f7d8f5f26e8$exports, "__esModule", {
    value: true
});
$4a3e0f7d8f5f26e8$exports.decrypt = $4a3e0f7d8f5f26e8$exports.encrypt = $4a3e0f7d8f5f26e8$exports.supportedAlgorithms = $4a3e0f7d8f5f26e8$exports.executeKdf = $4a3e0f7d8f5f26e8$exports.cosmjsSalt = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $4a3e0f7d8f5f26e8$exports.cosmjsSalt = (0, $lSA9E.toAscii)("The CosmJS salt.");
function $4a3e0f7d8f5f26e8$var$executeKdf(password, configuration) {
    return $4a3e0f7d8f5f26e8$var$_executeKdf.apply(this, arguments);
}
function $4a3e0f7d8f5f26e8$var$_executeKdf() {
    $4a3e0f7d8f5f26e8$var$_executeKdf = (0, $6rBFC._)(function(password, configuration) {
        var options;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(configuration.algorithm){
                case "argon2id":
                    {
                        options = configuration.params;
                        if (!(0, $3d6bA.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                        return [
                            2,
                            $3d6bA.Argon2id.execute(password, $4a3e0f7d8f5f26e8$exports.cosmjsSalt, options)
                        ];
                    }
                default:
                    throw new Error("Unsupported KDF algorithm");
            }
            return [
                2
            ];
        });
    });
    return $4a3e0f7d8f5f26e8$var$_executeKdf.apply(this, arguments);
}
$4a3e0f7d8f5f26e8$exports.executeKdf = $4a3e0f7d8f5f26e8$var$executeKdf;
$4a3e0f7d8f5f26e8$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
function $4a3e0f7d8f5f26e8$var$encrypt(plaintext, encryptionKey, config) {
    return $4a3e0f7d8f5f26e8$var$_encrypt.apply(this, arguments);
}
function $4a3e0f7d8f5f26e8$var$_encrypt() {
    $4a3e0f7d8f5f26e8$var$_encrypt = (0, $6rBFC._)(function(plaintext, encryptionKey, config) {
        var _, nonce, _1, _2, _3;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = config.algorithm;
                    switch(_){
                        case $4a3e0f7d8f5f26e8$exports.supportedAlgorithms.xchacha20poly1305Ietf:
                            return [
                                3,
                                1
                            ];
                    }
                    return [
                        3,
                        3
                    ];
                case 1:
                    nonce = $3d6bA.Random.getBytes($3d6bA.xchacha20NonceLength);
                    _1 = Uint8Array.bind;
                    _3 = (_2 = (0, $gF0bR._)(nonce)).concat;
                    return [
                        4,
                        $3d6bA.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                    ];
                case 2:
                    // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                    return [
                        2,
                        new (_1.apply(Uint8Array, [
                            void 0,
                            _3.apply(_2, [
                                (0, $gF0bR._).apply(void 0, [
                                    _state.sent()
                                ])
                            ])
                        ]))
                    ];
                case 3:
                    throw new Error("Unsupported encryption algorithm: '".concat(config.algorithm, "'"));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $4a3e0f7d8f5f26e8$var$_encrypt.apply(this, arguments);
}
$4a3e0f7d8f5f26e8$exports.encrypt = $4a3e0f7d8f5f26e8$var$encrypt;
function $4a3e0f7d8f5f26e8$var$decrypt(ciphertext, encryptionKey, config) {
    return $4a3e0f7d8f5f26e8$var$_decrypt.apply(this, arguments);
}
function $4a3e0f7d8f5f26e8$var$_decrypt() {
    $4a3e0f7d8f5f26e8$var$_decrypt = (0, $6rBFC._)(function(ciphertext, encryptionKey, config) {
        var nonce;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(config.algorithm){
                case $4a3e0f7d8f5f26e8$exports.supportedAlgorithms.xchacha20poly1305Ietf:
                    {
                        nonce = ciphertext.slice(0, $3d6bA.xchacha20NonceLength);
                        return [
                            2,
                            $3d6bA.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($3d6bA.xchacha20NonceLength), encryptionKey, nonce)
                        ];
                    }
                default:
                    throw new Error("Unsupported encryption algorithm: '".concat(config.algorithm, "'"));
            }
            return [
                2
            ];
        });
    });
    return $4a3e0f7d8f5f26e8$var$_decrypt.apply(this, arguments);
}
$4a3e0f7d8f5f26e8$exports.decrypt = $4a3e0f7d8f5f26e8$var$decrypt;


var $73cae90be3154127$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ var $73cae90be3154127$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $73cae90be3154127$var$isDerivationJson(thing) {
    if (!(0, $gMk5u.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $73cae90be3154127$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $73cae90be3154127$var$extractKdfConfiguration(serialization) {
    var root = JSON.parse(serialization);
    if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $73cae90be3154127$var$serializationTypeV1:
            return $73cae90be3154127$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$73cae90be3154127$exports.extractKdfConfiguration = $73cae90be3154127$var$extractKdfConfiguration;
var $73cae90be3154127$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $1c91cbf6e4c52cd6$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
var $73cae90be3154127$var$Secp256k1HdWallet = /*#__PURE__*/ function() {
    function Secp256k1HdWallet(mnemonic, options) {
        (0, $7dKN1._)(this, Secp256k1HdWallet);
        var _options_hdPaths;
        var hdPaths = (_options_hdPaths = options.hdPaths) !== null && _options_hdPaths !== void 0 ? _options_hdPaths : $73cae90be3154127$var$defaultOptions.hdPaths;
        var _options_prefix;
        var prefix = (_options_prefix = options.prefix) !== null && _options_prefix !== void 0 ? _options_prefix : $73cae90be3154127$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map(function(hdPath) {
            return {
                hdPath: hdPath,
                prefix: prefix
            };
        });
    }
    (0, $eW5pA._)(Secp256k1HdWallet, [
        {
            key: "mnemonic",
            get: function get() {
                return this.secret.toString();
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accountsWithPrivkeys;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountsWithPrivkeys()
                                ];
                            case 1:
                                accountsWithPrivkeys = _state.sent();
                                return [
                                    2,
                                    accountsWithPrivkeys.map(function(param) {
                                        var algo = param.algo, pubkey = param.pubkey, address = param.address;
                                        return {
                                            algo: algo,
                                            pubkey: pubkey,
                                            address: address
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAmino",
            value: function signAmino(signerAddress, signDoc) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accounts, account, privkey, pubkey, message, signature, signatureBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountsWithPrivkeys()
                                ];
                            case 1:
                                accounts = _state.sent();
                                account = accounts.find(function(param) {
                                    var address = param.address;
                                    return address === signerAddress;
                                });
                                if (account === undefined) throw new Error("Address ".concat(signerAddress, " not found in wallet"));
                                privkey = account.privkey, pubkey = account.pubkey;
                                message = (0, $3d6bA.sha256)((0, $f574a085b8fba5c8$exports.serializeSignDoc)(signDoc));
                                return [
                                    4,
                                    $3d6bA.Secp256k1.createSignature(message, privkey)
                                ];
                            case 2:
                                signature = _state.sent();
                                signatureBytes = new Uint8Array((0, $gF0bR._)(signature.r(32)).concat((0, $gF0bR._)(signature.s(32))));
                                return [
                                    2,
                                    {
                                        signed: signDoc,
                                        signature: (0, $6839f22adca35848$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "serialize",
            value: /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ function serialize(password) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var kdfConfiguration, encryptionKey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                kdfConfiguration = $73cae90be3154127$var$basicPasswordHashingOptions;
                                return [
                                    4,
                                    (0, $4a3e0f7d8f5f26e8$exports.executeKdf)(password, kdfConfiguration)
                                ];
                            case 1:
                                encryptionKey = _state.sent();
                                return [
                                    2,
                                    _this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "serializeWithEncryptionKey",
            value: /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ function serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var dataToEncrypt, dataToEncryptRaw, encryptionConfiguration, encryptedData, out;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataToEncrypt = {
                                    mnemonic: _this.mnemonic,
                                    accounts: _this.accounts.map(function(param) {
                                        var hdPath = param.hdPath, prefix = param.prefix;
                                        return {
                                            hdPath: (0, $3d6bA.pathToString)(hdPath),
                                            prefix: prefix
                                        };
                                    })
                                };
                                dataToEncryptRaw = (0, $lSA9E.toUtf8)(JSON.stringify(dataToEncrypt));
                                encryptionConfiguration = {
                                    algorithm: $4a3e0f7d8f5f26e8$exports.supportedAlgorithms.xchacha20poly1305Ietf
                                };
                                return [
                                    4,
                                    (0, $4a3e0f7d8f5f26e8$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration)
                                ];
                            case 1:
                                encryptedData = _state.sent();
                                out = {
                                    type: $73cae90be3154127$var$serializationTypeV1,
                                    kdf: kdfConfiguration,
                                    encryption: encryptionConfiguration,
                                    data: (0, $lSA9E.toBase64)(encryptedData)
                                };
                                return [
                                    2,
                                    JSON.stringify(out)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getKeyPair",
            value: function getKeyPair(hdPath) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var privkey, pubkey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                privkey = $3d6bA.Slip10.derivePath($3d6bA.Slip10Curve.Secp256k1, _this.seed, hdPath).privkey;
                                return [
                                    4,
                                    $3d6bA.Secp256k1.makeKeypair(privkey)
                                ];
                            case 1:
                                pubkey = _state.sent().pubkey;
                                return [
                                    2,
                                    {
                                        privkey: privkey,
                                        pubkey: $3d6bA.Secp256k1.compressPubkey(pubkey)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountsWithPrivkeys",
            value: function getAccountsWithPrivkeys() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            Promise.all(_this.accounts.map(function() {
                                var _ref = (0, $6rBFC._)(function(param) {
                                    var hdPath, prefix, _ref, privkey, pubkey, address;
                                    return (0, $6qu4b.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                hdPath = param.hdPath, prefix = param.prefix;
                                                return [
                                                    4,
                                                    _this.getKeyPair(hdPath)
                                                ];
                                            case 1:
                                                _ref = _state.sent(), privkey = _ref.privkey, pubkey = _ref.pubkey;
                                                address = (0, $lSA9E.toBech32)(prefix, (0, $c32fd5e1269323d5$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
                                                return [
                                                    2,
                                                    {
                                                        algo: "secp256k1",
                                                        privkey: privkey,
                                                        pubkey: pubkey,
                                                        address: address
                                                    }
                                                ];
                                        }
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "fromMnemonic",
            value: /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ function fromMnemonic(mnemonic) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    var mnemonicChecked, seed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mnemonicChecked = new $3d6bA.EnglishMnemonic(mnemonic);
                                return [
                                    4,
                                    $3d6bA.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password)
                                ];
                            case 1:
                                seed = _state.sent();
                                return [
                                    2,
                                    new Secp256k1HdWallet(mnemonicChecked, (0, $gddcW._)((0, $4JCw4._)({}, options), {
                                        seed: seed
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generate",
            value: /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ function generate() {
                var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 12, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    var entropyLength, entropy, mnemonic;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        entropyLength = 4 * Math.floor(11 * length / 33);
                        entropy = $3d6bA.Random.getBytes(entropyLength);
                        mnemonic = $3d6bA.Bip39.encode(entropy);
                        return [
                            2,
                            Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options)
                        ];
                    });
                })();
            }
        },
        {
            key: "deserialize",
            value: /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ function deserialize(serialization, password) {
                return (0, $6rBFC._)(function() {
                    var root;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        root = JSON.parse(serialization);
                        if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
                        switch(root.type){
                            case $73cae90be3154127$var$serializationTypeV1:
                                return [
                                    2,
                                    Secp256k1HdWallet.deserializeTypeV1(serialization, password)
                                ];
                            default:
                                throw new Error("Unsupported serialization type");
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "deserializeWithEncryptionKey",
            value: /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ function deserializeWithEncryptionKey(serialization, encryptionKey) {
                return (0, $6rBFC._)(function() {
                    var root, untypedRoot, _, decryptedBytes, decryptedDocument, mnemonic, accounts, firstPrefix, hdPaths;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                root = JSON.parse(serialization);
                                if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
                                untypedRoot = root;
                                _ = untypedRoot.type;
                                switch(_){
                                    case $73cae90be3154127$var$serializationTypeV1:
                                        return [
                                            3,
                                            1
                                        ];
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    (0, $4a3e0f7d8f5f26e8$exports.decrypt)((0, $lSA9E.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption)
                                ];
                            case 2:
                                decryptedBytes = _state.sent();
                                decryptedDocument = JSON.parse((0, $lSA9E.fromUtf8)(decryptedBytes));
                                mnemonic = decryptedDocument.mnemonic, accounts = decryptedDocument.accounts;
                                (0, $gMk5u.assert)(typeof mnemonic === "string");
                                if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                                if (!accounts.every(function(account) {
                                    return $73cae90be3154127$var$isDerivationJson(account);
                                })) throw new Error("Account is not in the correct format.");
                                firstPrefix = accounts[0].prefix;
                                if (!accounts.every(function(param) {
                                    var prefix = param.prefix;
                                    return prefix === firstPrefix;
                                })) throw new Error("Accounts do not all have the same prefix");
                                hdPaths = accounts.map(function(param) {
                                    var hdPath = param.hdPath;
                                    return (0, $3d6bA.stringToPath)(hdPath);
                                });
                                return [
                                    2,
                                    Secp256k1HdWallet.fromMnemonic(mnemonic, {
                                        hdPaths: hdPaths,
                                        prefix: firstPrefix
                                    })
                                ];
                            case 3:
                                throw new Error("Unsupported serialization type");
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deserializeTypeV1",
            value: function deserializeTypeV1(serialization, password) {
                return (0, $6rBFC._)(function() {
                    var root, encryptionKey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                root = JSON.parse(serialization);
                                if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
                                return [
                                    4,
                                    (0, $4a3e0f7d8f5f26e8$exports.executeKdf)(password, root.kdf)
                                ];
                            case 1:
                                encryptionKey = _state.sent();
                                return [
                                    2,
                                    Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Secp256k1HdWallet;
}();
$73cae90be3154127$exports.Secp256k1HdWallet = $73cae90be3154127$var$Secp256k1HdWallet;


Object.defineProperty($c9b9a1a428003423$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function get() {
        return $73cae90be3154127$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function get() {
        return $73cae90be3154127$exports.Secp256k1HdWallet;
    }
});
var $e1364bd6289fb7cf$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($e1364bd6289fb7cf$exports, "__esModule", {
    value: true
});
$e1364bd6289fb7cf$exports.Secp256k1Wallet = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");



/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ var $e1364bd6289fb7cf$var$Secp256k1Wallet = /*#__PURE__*/ function() {
    function Secp256k1Wallet(privkey, pubkey, prefix) {
        (0, $7dKN1._)(this, Secp256k1Wallet);
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    (0, $eW5pA._)(Secp256k1Wallet, [
        {
            key: "address",
            get: function get() {
                return (0, $lSA9E.toBech32)(this.prefix, (0, $c32fd5e1269323d5$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            [
                                {
                                    algo: "secp256k1",
                                    address: _this.address,
                                    pubkey: _this.pubkey
                                }
                            ]
                        ];
                    });
                })();
            }
        },
        {
            key: "signAmino",
            value: function signAmino(signerAddress, signDoc) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var message, signature, signatureBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (signerAddress !== _this.address) throw new Error("Address ".concat(signerAddress, " not found in wallet"));
                                message = new $3d6bA.Sha256((0, $f574a085b8fba5c8$exports.serializeSignDoc)(signDoc)).digest();
                                return [
                                    4,
                                    $3d6bA.Secp256k1.createSignature(message, _this.privkey)
                                ];
                            case 1:
                                signature = _state.sent();
                                signatureBytes = new Uint8Array((0, $gF0bR._)(signature.r(32)).concat((0, $gF0bR._)(signature.s(32))));
                                return [
                                    2,
                                    {
                                        signed: signDoc,
                                        signature: (0, $6839f22adca35848$exports.encodeSecp256k1Signature)(_this.pubkey, signatureBytes)
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "fromKey",
            value: /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ function fromKey(privkey) {
                var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cosmos";
                return (0, $6rBFC._)(function() {
                    var uncompressed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $3d6bA.Secp256k1.makeKeypair(privkey)
                                ];
                            case 1:
                                uncompressed = _state.sent().pubkey;
                                return [
                                    2,
                                    new Secp256k1Wallet(privkey, $3d6bA.Secp256k1.compressPubkey(uncompressed), prefix)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Secp256k1Wallet;
}();
$e1364bd6289fb7cf$exports.Secp256k1Wallet = $e1364bd6289fb7cf$var$Secp256k1Wallet;


Object.defineProperty($c9b9a1a428003423$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function get() {
        return $e1364bd6289fb7cf$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($c9b9a1a428003423$exports, "decodeSignature", {
    enumerable: true,
    get: function get() {
        return $6839f22adca35848$exports.decodeSignature;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function get() {
        return $6839f22adca35848$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($c9b9a1a428003423$exports, "makeSignDoc", {
    enumerable: true,
    get: function get() {
        return $f574a085b8fba5c8$exports.makeSignDoc;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "serializeSignDoc", {
    enumerable: true,
    get: function get() {
        return $f574a085b8fba5c8$exports.serializeSignDoc;
    }
});
var $93e5355998bdac1d$exports = {};
"use strict";
Object.defineProperty($93e5355998bdac1d$exports, "__esModule", {
    value: true
});
$93e5355998bdac1d$exports.makeStdTx = $93e5355998bdac1d$exports.isStdTx = void 0;
function $93e5355998bdac1d$var$isStdTx(txValue) {
    var memo = txValue.memo, msg = txValue.msg, fee = txValue.fee, signatures = txValue.signatures;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$93e5355998bdac1d$exports.isStdTx = $93e5355998bdac1d$var$isStdTx;
function $93e5355998bdac1d$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$93e5355998bdac1d$exports.makeStdTx = $93e5355998bdac1d$var$makeStdTx;


Object.defineProperty($c9b9a1a428003423$exports, "isStdTx", {
    enumerable: true,
    get: function get() {
        return $93e5355998bdac1d$exports.isStdTx;
    }
});
Object.defineProperty($c9b9a1a428003423$exports, "makeStdTx", {
    enumerable: true,
    get: function get() {
        return $93e5355998bdac1d$exports.makeStdTx;
    }
});

Object.defineProperty($c9b9a1a428003423$exports, "executeKdf", {
    enumerable: true,
    get: function get() {
        return $4a3e0f7d8f5f26e8$exports.executeKdf;
    }
});


var $5806cdd0880cf151$exports = {};
"use strict";
Object.defineProperty($5806cdd0880cf151$exports, "__esModule", {
    value: true
});
$5806cdd0880cf151$exports.SigningCosmWasmClient = $5806cdd0880cf151$exports.wasmTypes = $5806cdd0880cf151$exports.setupWasmExtension = $5806cdd0880cf151$exports.isMsgUpdateAdminEncodeObject = $5806cdd0880cf151$exports.isMsgStoreCodeEncodeObject = $5806cdd0880cf151$exports.isMsgMigrateEncodeObject = $5806cdd0880cf151$exports.isMsgInstantiateContractEncodeObject = $5806cdd0880cf151$exports.isMsgInstantiateContract2EncodeObject = $5806cdd0880cf151$exports.isMsgExecuteEncodeObject = $5806cdd0880cf151$exports.isMsgClearAdminEncodeObject = $5806cdd0880cf151$exports.createWasmAminoConverters = $5806cdd0880cf151$exports.instantiate2Address = $5806cdd0880cf151$exports._instantiate2AddressIntermediate = $5806cdd0880cf151$exports.toBinary = $5806cdd0880cf151$exports.fromBinary = $5806cdd0880cf151$exports.CosmWasmClient = void 0;
var $874883cdc389d04f$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $a7gqy = parcelRequire("a7gqy");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($874883cdc389d04f$exports, "__esModule", {
    value: true
});
$874883cdc389d04f$exports.CosmWasmClient = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");
var $3e8bd88d734bad5a$exports = {};
"use strict";
var $3e8bd88d734bad5a$var$__createBinding = $3e8bd88d734bad5a$exports && $3e8bd88d734bad5a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3e8bd88d734bad5a$var$__setModuleDefault = $3e8bd88d734bad5a$exports && $3e8bd88d734bad5a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3e8bd88d734bad5a$var$__importStar = $3e8bd88d734bad5a$exports && $3e8bd88d734bad5a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3e8bd88d734bad5a$var$__createBinding(result, mod, k);
    }
    $3e8bd88d734bad5a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3e8bd88d734bad5a$exports, "__esModule", {
    value: true
});
$3e8bd88d734bad5a$exports.isMsgWithdrawDelegatorRewardEncodeObject = $3e8bd88d734bad5a$exports.isMsgVoteWeightedEncodeObject = $3e8bd88d734bad5a$exports.isMsgVoteEncodeObject = $3e8bd88d734bad5a$exports.isMsgUndelegateEncodeObject = $3e8bd88d734bad5a$exports.isMsgTransferEncodeObject = $3e8bd88d734bad5a$exports.isMsgSubmitProposalEncodeObject = $3e8bd88d734bad5a$exports.isMsgSendEncodeObject = $3e8bd88d734bad5a$exports.isMsgEditValidatorEncodeObject = $3e8bd88d734bad5a$exports.isMsgDepositEncodeObject = $3e8bd88d734bad5a$exports.isMsgDelegateEncodeObject = $3e8bd88d734bad5a$exports.isMsgCreateValidatorEncodeObject = $3e8bd88d734bad5a$exports.isMsgBeginRedelegateEncodeObject = $3e8bd88d734bad5a$exports.isAminoMsgWithdrawValidatorCommission = $3e8bd88d734bad5a$exports.isAminoMsgWithdrawDelegatorReward = $3e8bd88d734bad5a$exports.isAminoMsgVoteWeighted = $3e8bd88d734bad5a$exports.isAminoMsgVote = $3e8bd88d734bad5a$exports.isAminoMsgVerifyInvariant = $3e8bd88d734bad5a$exports.isAminoMsgUnjail = $3e8bd88d734bad5a$exports.isAminoMsgUndelegate = $3e8bd88d734bad5a$exports.isAminoMsgTransfer = $3e8bd88d734bad5a$exports.isAminoMsgSubmitProposal = $3e8bd88d734bad5a$exports.isAminoMsgSubmitEvidence = $3e8bd88d734bad5a$exports.isAminoMsgSetWithdrawAddress = $3e8bd88d734bad5a$exports.isAminoMsgSend = $3e8bd88d734bad5a$exports.isAminoMsgMultiSend = $3e8bd88d734bad5a$exports.isAminoMsgFundCommunityPool = $3e8bd88d734bad5a$exports.isAminoMsgEditValidator = $3e8bd88d734bad5a$exports.isAminoMsgDeposit = $3e8bd88d734bad5a$exports.isAminoMsgDelegate = $3e8bd88d734bad5a$exports.isAminoMsgCreateVestingAccount = $3e8bd88d734bad5a$exports.isAminoMsgCreateValidator = $3e8bd88d734bad5a$exports.isAminoMsgBeginRedelegate = $3e8bd88d734bad5a$exports.createVestingAminoConverters = $3e8bd88d734bad5a$exports.createStakingAminoConverters = $3e8bd88d734bad5a$exports.createSlashingAminoConverters = $3e8bd88d734bad5a$exports.createIbcAminoConverters = $3e8bd88d734bad5a$exports.createGroupAminoConverters = $3e8bd88d734bad5a$exports.createGovAminoConverters = $3e8bd88d734bad5a$exports.createFeegrantAminoConverters = $3e8bd88d734bad5a$exports.createEvidenceAminoConverters = $3e8bd88d734bad5a$exports.createDistributionAminoConverters = $3e8bd88d734bad5a$exports.createCrysisAminoConverters = $3e8bd88d734bad5a$exports.createBankAminoConverters = $3e8bd88d734bad5a$exports.createAuthzAminoConverters = $3e8bd88d734bad5a$exports.logs = $3e8bd88d734bad5a$exports.GasPrice = $3e8bd88d734bad5a$exports.calculateFee = $3e8bd88d734bad5a$exports.fromTendermintEvent = $3e8bd88d734bad5a$exports.AminoTypes = $3e8bd88d734bad5a$exports.accountFromAny = void 0;
$3e8bd88d734bad5a$exports.parseCoins = $3e8bd88d734bad5a$exports.makeCosmoshubPath = $3e8bd88d734bad5a$exports.coins = $3e8bd88d734bad5a$exports.coin = $3e8bd88d734bad5a$exports.TimeoutError = $3e8bd88d734bad5a$exports.StargateClient = $3e8bd88d734bad5a$exports.isDeliverTxSuccess = $3e8bd88d734bad5a$exports.isDeliverTxFailure = $3e8bd88d734bad5a$exports.BroadcastTxError = $3e8bd88d734bad5a$exports.assertIsDeliverTxSuccess = $3e8bd88d734bad5a$exports.assertIsDeliverTxFailure = $3e8bd88d734bad5a$exports.SigningStargateClient = $3e8bd88d734bad5a$exports.defaultRegistryTypes = $3e8bd88d734bad5a$exports.createDefaultAminoConverters = $3e8bd88d734bad5a$exports.QueryClient = $3e8bd88d734bad5a$exports.decodeCosmosSdkDecFromProto = $3e8bd88d734bad5a$exports.createProtobufRpcClient = $3e8bd88d734bad5a$exports.createPagination = $3e8bd88d734bad5a$exports.makeMultisignedTxBytes = $3e8bd88d734bad5a$exports.makeMultisignedTx = $3e8bd88d734bad5a$exports.setupTxExtension = $3e8bd88d734bad5a$exports.setupStakingExtension = $3e8bd88d734bad5a$exports.setupSlashingExtension = $3e8bd88d734bad5a$exports.setupMintExtension = $3e8bd88d734bad5a$exports.setupIbcExtension = $3e8bd88d734bad5a$exports.setupGovExtension = $3e8bd88d734bad5a$exports.setupFeegrantExtension = $3e8bd88d734bad5a$exports.setupDistributionExtension = $3e8bd88d734bad5a$exports.setupBankExtension = $3e8bd88d734bad5a$exports.setupAuthzExtension = $3e8bd88d734bad5a$exports.setupAuthExtension = void 0;
var $99afcd2e4c2331d7$exports = {};
"use strict";
Object.defineProperty($99afcd2e4c2331d7$exports, "__esModule", {
    value: true
});
$99afcd2e4c2331d7$exports.accountFromAny = void 0;

var $kTbgy = parcelRequire("kTbgy");
var $ff811d56e12ad916$exports = {};
"use strict";
Object.defineProperty($ff811d56e12ad916$exports, "__esModule", {
    value: true
});
$ff811d56e12ad916$exports.coins = $ff811d56e12ad916$exports.coin = $ff811d56e12ad916$exports.executeKdf = $ff811d56e12ad916$exports.makeSignDoc = $ff811d56e12ad916$exports.makeSignBytes = $ff811d56e12ad916$exports.makeAuthInfoBytes = $ff811d56e12ad916$exports.isOfflineDirectSigner = $ff811d56e12ad916$exports.Registry = $ff811d56e12ad916$exports.isTxBodyEncodeObject = $ff811d56e12ad916$exports.isTsProtoGeneratedType = $ff811d56e12ad916$exports.isPbjsGeneratedType = $ff811d56e12ad916$exports.encodePubkey = $ff811d56e12ad916$exports.decodePubkey = $ff811d56e12ad916$exports.anyToSinglePubkey = $ff811d56e12ad916$exports.makeCosmoshubPath = $ff811d56e12ad916$exports.DirectSecp256k1Wallet = $ff811d56e12ad916$exports.extractKdfConfiguration = $ff811d56e12ad916$exports.DirectSecp256k1HdWallet = $ff811d56e12ad916$exports.decodeTxRaw = $ff811d56e12ad916$exports.parseCoins = void 0;
var $fabc64088900d067$exports = {};
"use strict";
Object.defineProperty($fabc64088900d067$exports, "__esModule", {
    value: true
});
$fabc64088900d067$exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */ function $fabc64088900d067$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map(function(part) {
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        var match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
$fabc64088900d067$exports.parseCoins = $fabc64088900d067$var$parseCoins;


Object.defineProperty($ff811d56e12ad916$exports, "parseCoins", {
    enumerable: true,
    get: function get() {
        return $fabc64088900d067$exports.parseCoins;
    }
});
var $40675ea885c231a3$exports = {};
"use strict";
Object.defineProperty($40675ea885c231a3$exports, "__esModule", {
    value: true
});
$40675ea885c231a3$exports.decodeTxRaw = void 0;
var $540f96552e476ffb$exports = {};
"use strict";
var $540f96552e476ffb$var$__createBinding = $540f96552e476ffb$exports && $540f96552e476ffb$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $540f96552e476ffb$var$__setModuleDefault = $540f96552e476ffb$exports && $540f96552e476ffb$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $540f96552e476ffb$var$__importStar = $540f96552e476ffb$exports && $540f96552e476ffb$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $540f96552e476ffb$var$__createBinding(result, mod, k);
    }
    $540f96552e476ffb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($540f96552e476ffb$exports, "__esModule", {
    value: true
});
$540f96552e476ffb$exports.AuxSignerData = $540f96552e476ffb$exports.Tip = $540f96552e476ffb$exports.Fee = $540f96552e476ffb$exports.ModeInfo_Multi = $540f96552e476ffb$exports.ModeInfo_Single = $540f96552e476ffb$exports.ModeInfo = $540f96552e476ffb$exports.SignerInfo = $540f96552e476ffb$exports.AuthInfo = $540f96552e476ffb$exports.TxBody = $540f96552e476ffb$exports.SignDocDirectAux = $540f96552e476ffb$exports.SignDoc = $540f96552e476ffb$exports.TxRaw = $540f96552e476ffb$exports.Tx = $540f96552e476ffb$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");
var $82c22db8b6bc5755$exports = {};
"use strict";
var $82c22db8b6bc5755$var$__createBinding = $82c22db8b6bc5755$exports && $82c22db8b6bc5755$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $82c22db8b6bc5755$var$__setModuleDefault = $82c22db8b6bc5755$exports && $82c22db8b6bc5755$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $82c22db8b6bc5755$var$__importStar = $82c22db8b6bc5755$exports && $82c22db8b6bc5755$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $82c22db8b6bc5755$var$__createBinding(result, mod, k);
    }
    $82c22db8b6bc5755$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($82c22db8b6bc5755$exports, "__esModule", {
    value: true
});
$82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi = $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single = $82c22db8b6bc5755$exports.SignatureDescriptor_Data = $82c22db8b6bc5755$exports.SignatureDescriptor = $82c22db8b6bc5755$exports.SignatureDescriptors = $82c22db8b6bc5755$exports.signModeToJSON = $82c22db8b6bc5755$exports.signModeFromJSON = $82c22db8b6bc5755$exports.SignMode = $82c22db8b6bc5755$exports.protobufPackage = void 0;
var $8a18a2241640c168$exports = {};
"use strict";
var $8a18a2241640c168$var$__createBinding = $8a18a2241640c168$exports && $8a18a2241640c168$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a18a2241640c168$var$__setModuleDefault = $8a18a2241640c168$exports && $8a18a2241640c168$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8a18a2241640c168$var$__importStar = $8a18a2241640c168$exports && $8a18a2241640c168$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8a18a2241640c168$var$__createBinding(result, mod, k);
    }
    $8a18a2241640c168$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8a18a2241640c168$exports, "__esModule", {
    value: true
});
$8a18a2241640c168$exports.CompactBitArray = $8a18a2241640c168$exports.MultiSignature = $8a18a2241640c168$exports.protobufPackage = void 0;

/* eslint-disable */ var $8a18a2241640c168$var$_m0 = $8a18a2241640c168$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$8a18a2241640c168$exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function $8a18a2241640c168$var$createBaseMultiSignature() {
    return {
        signatures: []
    };
}
$8a18a2241640c168$exports.MultiSignature = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8a18a2241640c168$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8a18a2241640c168$var$_m0.Reader ? input : new $8a18a2241640c168$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8a18a2241640c168$var$createBaseMultiSignature();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.signatures) obj.signatures = message.signatures.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.signatures = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_signatures;
        var message = $8a18a2241640c168$var$createBaseMultiSignature();
        message.signatures = ((_object_signatures = object.signatures) === null || _object_signatures === void 0 ? void 0 : _object_signatures.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $8a18a2241640c168$var$createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array()
    };
}
$8a18a2241640c168$exports.CompactBitArray = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8a18a2241640c168$var$_m0.Writer.create();
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8a18a2241640c168$var$_m0.Reader ? input : new $8a18a2241640c168$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8a18a2241640c168$var$createBaseCompactBitArray();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            extraBitsStored: (0, $7iZIe.isSet)(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: (0, $7iZIe.isSet)(object.elems) ? (0, $7iZIe.bytesFromBase64)(object.elems) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined && (obj.elems = (0, $7iZIe.base64FromBytes)(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $8a18a2241640c168$var$createBaseCompactBitArray();
        var _object_extraBitsStored;
        message.extraBitsStored = (_object_extraBitsStored = object.extraBitsStored) !== null && _object_extraBitsStored !== void 0 ? _object_extraBitsStored : 0;
        var _object_elems;
        message.elems = (_object_elems = object.elems) !== null && _object_elems !== void 0 ? _object_elems : new Uint8Array();
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $82c22db8b6bc5755$var$_m0 = $82c22db8b6bc5755$var$__importStar((parcelRequire("hjb8Q")));
$82c22db8b6bc5755$exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/**
 * SignMode represents a signing mode with its own security guarantees.
 *
 * This enum should be considered a registry of all known sign modes
 * in the Cosmos ecosystem. Apps are not expected to support all known
 * sign modes. Apps that would like to support custom  sign modes are
 * encouraged to open a small PR against this file to add a new case
 * to this SignMode enum describing their sign mode so that different
 * apps have a consistent version of this enum.
 */ var $82c22db8b6bc5755$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected.
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx.
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT. It is currently not supported.
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_DIRECT_AUX - SIGN_MODE_DIRECT_AUX specifies a signing mode which uses
     * SignDocDirectAux. As opposed to SIGN_MODE_DIRECT, this sign mode does not
     * require signers signing over other signers' `signer_info`. It also allows
     * for adding Tips in transactions.
     *
     * Since: cosmos-sdk 0.46
     */ SignMode[SignMode["SIGN_MODE_DIRECT_AUX"] = 3] = "SIGN_MODE_DIRECT_AUX";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future.
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */ SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($82c22db8b6bc5755$var$SignMode = $82c22db8b6bc5755$exports.SignMode || ($82c22db8b6bc5755$exports.SignMode = {}));
function $82c22db8b6bc5755$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $82c22db8b6bc5755$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $82c22db8b6bc5755$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $82c22db8b6bc5755$var$SignMode.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
            return $82c22db8b6bc5755$var$SignMode.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $82c22db8b6bc5755$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return $82c22db8b6bc5755$var$SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $82c22db8b6bc5755$var$SignMode.UNRECOGNIZED;
    }
}
$82c22db8b6bc5755$exports.signModeFromJSON = $82c22db8b6bc5755$var$signModeFromJSON;
function $82c22db8b6bc5755$var$signModeToJSON(object) {
    switch(object){
        case $82c22db8b6bc5755$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $82c22db8b6bc5755$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $82c22db8b6bc5755$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $82c22db8b6bc5755$var$SignMode.SIGN_MODE_DIRECT_AUX:
            return "SIGN_MODE_DIRECT_AUX";
        case $82c22db8b6bc5755$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case $82c22db8b6bc5755$var$SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        case $82c22db8b6bc5755$var$SignMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$82c22db8b6bc5755$exports.signModeToJSON = $82c22db8b6bc5755$var$signModeToJSON;
function $82c22db8b6bc5755$var$createBaseSignatureDescriptors() {
    return {
        signatures: []
    };
}
$82c22db8b6bc5755$exports.SignatureDescriptors = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $82c22db8b6bc5755$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $82c22db8b6bc5755$exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $82c22db8b6bc5755$var$_m0.Reader ? input : new $82c22db8b6bc5755$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptors();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push($82c22db8b6bc5755$exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(function(e) {
                return $82c22db8b6bc5755$exports.SignatureDescriptor.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.signatures) obj.signatures = message.signatures.map(function(e) {
            return e ? $82c22db8b6bc5755$exports.SignatureDescriptor.toJSON(e) : undefined;
        });
        else obj.signatures = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_signatures;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptors();
        message.signatures = ((_object_signatures = object.signatures) === null || _object_signatures === void 0 ? void 0 : _object_signatures.map(function(e) {
            return $82c22db8b6bc5755$exports.SignatureDescriptor.fromPartial(e);
        })) || [];
        return message;
    }
};
function $82c22db8b6bc5755$var$createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: $7iZIe.Long.UZERO
    };
}
$82c22db8b6bc5755$exports.SignatureDescriptor = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $82c22db8b6bc5755$var$_m0.Writer.create();
        if (message.publicKey !== undefined) $DM7bi.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $82c22db8b6bc5755$exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $82c22db8b6bc5755$var$_m0.Reader ? input : new $82c22db8b6bc5755$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $82c22db8b6bc5755$exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            publicKey: (0, $7iZIe.isSet)(object.publicKey) ? $DM7bi.Any.fromJSON(object.publicKey) : undefined,
            data: (0, $7iZIe.isSet)(object.data) ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $DM7bi.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $DM7bi.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined
    };
}
$82c22db8b6bc5755$exports.SignatureDescriptor_Data = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $82c22db8b6bc5755$var$_m0.Writer.create();
        if (message.single !== undefined) $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $82c22db8b6bc5755$var$_m0.Reader ? input : new $82c22db8b6bc5755$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            single: (0, $7iZIe.isSet)(object.single) ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: (0, $7iZIe.isSet)(object.multi) ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.single !== undefined && (obj.single = message.single ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data();
        message.single = object.single !== undefined && object.single !== null ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array()
    };
}
$82c22db8b6bc5755$exports.SignatureDescriptor_Data_Single = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $82c22db8b6bc5755$var$_m0.Writer.create();
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $82c22db8b6bc5755$var$_m0.Reader ? input : new $82c22db8b6bc5755$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data_Single();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            mode: (0, $7iZIe.isSet)(object.mode) ? $82c22db8b6bc5755$var$signModeFromJSON(object.mode) : 0,
            signature: (0, $7iZIe.isSet)(object.signature) ? (0, $7iZIe.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.mode !== undefined && (obj.mode = $82c22db8b6bc5755$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = (0, $7iZIe.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data_Single();
        var _object_mode;
        message.mode = (_object_mode = object.mode) !== null && _object_mode !== void 0 ? _object_mode : 0;
        var _object_signature;
        message.signature = (_object_signature = object.signature) !== null && _object_signature !== void 0 ? _object_signature : new Uint8Array();
        return message;
    }
};
function $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: []
    };
}
$82c22db8b6bc5755$exports.SignatureDescriptor_Data_Multi = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $82c22db8b6bc5755$var$_m0.Writer.create();
        if (message.bitarray !== undefined) $8a18a2241640c168$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $82c22db8b6bc5755$exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $82c22db8b6bc5755$var$_m0.Reader ? input : new $82c22db8b6bc5755$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data_Multi();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $8a18a2241640c168$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push($82c22db8b6bc5755$exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            bitarray: (0, $7iZIe.isSet)(object.bitarray) ? $8a18a2241640c168$exports.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(function(e) {
                return $82c22db8b6bc5755$exports.SignatureDescriptor_Data.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $8a18a2241640c168$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map(function(e) {
            return e ? $82c22db8b6bc5755$exports.SignatureDescriptor_Data.toJSON(e) : undefined;
        });
        else obj.signatures = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_signatures;
        var message = $82c22db8b6bc5755$var$createBaseSignatureDescriptor_Data_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $8a18a2241640c168$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = ((_object_signatures = object.signatures) === null || _object_signatures === void 0 ? void 0 : _object_signatures.map(function(e) {
            return $82c22db8b6bc5755$exports.SignatureDescriptor_Data.fromPartial(e);
        })) || [];
        return message;
    }
};



var $5bc8eb379b028930$exports = {};
"use strict";
var $5bc8eb379b028930$var$__createBinding = $5bc8eb379b028930$exports && $5bc8eb379b028930$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5bc8eb379b028930$var$__setModuleDefault = $5bc8eb379b028930$exports && $5bc8eb379b028930$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5bc8eb379b028930$var$__importStar = $5bc8eb379b028930$exports && $5bc8eb379b028930$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5bc8eb379b028930$var$__createBinding(result, mod, k);
    }
    $5bc8eb379b028930$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5bc8eb379b028930$exports, "__esModule", {
    value: true
});
$5bc8eb379b028930$exports.DecProto = $5bc8eb379b028930$exports.IntProto = $5bc8eb379b028930$exports.DecCoin = $5bc8eb379b028930$exports.Coin = $5bc8eb379b028930$exports.protobufPackage = void 0;

/* eslint-disable */ var $5bc8eb379b028930$var$_m0 = $5bc8eb379b028930$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$5bc8eb379b028930$exports.protobufPackage = "cosmos.base.v1beta1";
function $5bc8eb379b028930$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$5bc8eb379b028930$exports.Coin = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5bc8eb379b028930$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5bc8eb379b028930$var$_m0.Reader ? input : new $5bc8eb379b028930$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5bc8eb379b028930$var$createBaseCoin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5bc8eb379b028930$var$createBaseCoin();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        var _object_amount;
        message.amount = (_object_amount = object.amount) !== null && _object_amount !== void 0 ? _object_amount : "";
        return message;
    }
};
function $5bc8eb379b028930$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$5bc8eb379b028930$exports.DecCoin = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5bc8eb379b028930$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5bc8eb379b028930$var$_m0.Reader ? input : new $5bc8eb379b028930$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5bc8eb379b028930$var$createBaseDecCoin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5bc8eb379b028930$var$createBaseDecCoin();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        var _object_amount;
        message.amount = (_object_amount = object.amount) !== null && _object_amount !== void 0 ? _object_amount : "";
        return message;
    }
};
function $5bc8eb379b028930$var$createBaseIntProto() {
    return {
        int: ""
    };
}
$5bc8eb379b028930$exports.IntProto = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5bc8eb379b028930$var$_m0.Writer.create();
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5bc8eb379b028930$var$_m0.Reader ? input : new $5bc8eb379b028930$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5bc8eb379b028930$var$createBaseIntProto();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            int: (0, $7iZIe.isSet)(object.int) ? String(object.int) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5bc8eb379b028930$var$createBaseIntProto();
        var _object_int;
        message.int = (_object_int = object.int) !== null && _object_int !== void 0 ? _object_int : "";
        return message;
    }
};
function $5bc8eb379b028930$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
$5bc8eb379b028930$exports.DecProto = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5bc8eb379b028930$var$_m0.Writer.create();
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5bc8eb379b028930$var$_m0.Reader ? input : new $5bc8eb379b028930$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5bc8eb379b028930$var$createBaseDecProto();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            dec: (0, $7iZIe.isSet)(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5bc8eb379b028930$var$createBaseDecProto();
        var _object_dec;
        message.dec = (_object_dec = object.dec) !== null && _object_dec !== void 0 ? _object_dec : "";
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $540f96552e476ffb$var$_m0 = $540f96552e476ffb$var$__importStar((parcelRequire("hjb8Q")));
$540f96552e476ffb$exports.protobufPackage = "cosmos.tx.v1beta1";
function $540f96552e476ffb$var$createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: []
    };
}
$540f96552e476ffb$exports.Tx = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.body !== undefined) $540f96552e476ffb$exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) $540f96552e476ffb$exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(26).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseTx();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = $540f96552e476ffb$exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = $540f96552e476ffb$exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            body: (0, $7iZIe.isSet)(object.body) ? $540f96552e476ffb$exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: (0, $7iZIe.isSet)(object.authInfo) ? $540f96552e476ffb$exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.body !== undefined && (obj.body = message.body ? $540f96552e476ffb$exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? $540f96552e476ffb$exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.signatures = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_signatures;
        var message = $540f96552e476ffb$var$createBaseTx();
        message.body = object.body !== undefined && object.body !== null ? $540f96552e476ffb$exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? $540f96552e476ffb$exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = ((_object_signatures = object.signatures) === null || _object_signatures === void 0 ? void 0 : _object_signatures.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $540f96552e476ffb$var$createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
    };
}
$540f96552e476ffb$exports.TxRaw = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(26).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseTxRaw();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            bodyBytes: (0, $7iZIe.isSet)(object.bodyBytes) ? (0, $7iZIe.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $7iZIe.isSet)(object.authInfoBytes) ? (0, $7iZIe.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $7iZIe.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $7iZIe.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.signatures = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_signatures;
        var message = $540f96552e476ffb$var$createBaseTxRaw();
        var _object_bodyBytes;
        message.bodyBytes = (_object_bodyBytes = object.bodyBytes) !== null && _object_bodyBytes !== void 0 ? _object_bodyBytes : new Uint8Array();
        var _object_authInfoBytes;
        message.authInfoBytes = (_object_authInfoBytes = object.authInfoBytes) !== null && _object_authInfoBytes !== void 0 ? _object_authInfoBytes : new Uint8Array();
        message.signatures = ((_object_signatures = object.signatures) === null || _object_signatures === void 0 ? void 0 : _object_signatures.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $540f96552e476ffb$var$createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: $7iZIe.Long.UZERO
    };
}
$540f96552e476ffb$exports.SignDoc = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseSignDoc();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            bodyBytes: (0, $7iZIe.isSet)(object.bodyBytes) ? (0, $7iZIe.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $7iZIe.isSet)(object.authInfoBytes) ? (0, $7iZIe.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            chainId: (0, $7iZIe.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $7iZIe.isSet)(object.accountNumber) ? $7iZIe.Long.fromValue(object.accountNumber) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $7iZIe.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $7iZIe.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $540f96552e476ffb$var$createBaseSignDoc();
        var _object_bodyBytes;
        message.bodyBytes = (_object_bodyBytes = object.bodyBytes) !== null && _object_bodyBytes !== void 0 ? _object_bodyBytes : new Uint8Array();
        var _object_authInfoBytes;
        message.authInfoBytes = (_object_authInfoBytes = object.authInfoBytes) !== null && _object_authInfoBytes !== void 0 ? _object_authInfoBytes : new Uint8Array();
        var _object_chainId;
        message.chainId = (_object_chainId = object.chainId) !== null && _object_chainId !== void 0 ? _object_chainId : "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $7iZIe.Long.fromValue(object.accountNumber) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $540f96552e476ffb$var$createBaseSignDocDirectAux() {
    return {
        bodyBytes: new Uint8Array(),
        publicKey: undefined,
        chainId: "",
        accountNumber: $7iZIe.Long.UZERO,
        sequence: $7iZIe.Long.UZERO,
        tip: undefined
    };
}
$540f96552e476ffb$exports.SignDocDirectAux = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.publicKey !== undefined) $DM7bi.Any.encode(message.publicKey, writer.uint32(18).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(40).uint64(message.sequence);
        if (message.tip !== undefined) $540f96552e476ffb$exports.Tip.encode(message.tip, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseSignDocDirectAux();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.publicKey = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                case 5:
                    message.sequence = reader.uint64();
                    break;
                case 6:
                    message.tip = $540f96552e476ffb$exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            bodyBytes: (0, $7iZIe.isSet)(object.bodyBytes) ? (0, $7iZIe.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            publicKey: (0, $7iZIe.isSet)(object.publicKey) ? $DM7bi.Any.fromJSON(object.publicKey) : undefined,
            chainId: (0, $7iZIe.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $7iZIe.isSet)(object.accountNumber) ? $7iZIe.Long.fromValue(object.accountNumber) : $7iZIe.Long.UZERO,
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO,
            tip: (0, $7iZIe.isSet)(object.tip) ? $540f96552e476ffb$exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $7iZIe.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $DM7bi.Any.toJSON(message.publicKey) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $7iZIe.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        message.tip !== undefined && (obj.tip = message.tip ? $540f96552e476ffb$exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $540f96552e476ffb$var$createBaseSignDocDirectAux();
        var _object_bodyBytes;
        message.bodyBytes = (_object_bodyBytes = object.bodyBytes) !== null && _object_bodyBytes !== void 0 ? _object_bodyBytes : new Uint8Array();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $DM7bi.Any.fromPartial(object.publicKey) : undefined;
        var _object_chainId;
        message.chainId = (_object_chainId = object.chainId) !== null && _object_chainId !== void 0 ? _object_chainId : "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $7iZIe.Long.fromValue(object.accountNumber) : $7iZIe.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        message.tip = object.tip !== undefined && object.tip !== null ? $540f96552e476ffb$exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $540f96552e476ffb$var$createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: $7iZIe.Long.UZERO,
        extensionOptions: [],
        nonCriticalExtensionOptions: []
    };
}
$540f96552e476ffb$exports.TxBody = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.extensionOptions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $DM7bi.Any.encode(v1, writer.uint32(8186).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = message.nonCriticalExtensionOptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var v2 = _step2.value;
                $DM7bi.Any.encode(v2, writer.uint32(16378).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseTxBody();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            memo: (0, $7iZIe.isSet)(object.memo) ? String(object.memo) : "",
            timeoutHeight: (0, $7iZIe.isSet)(object.timeoutHeight) ? $7iZIe.Long.fromValue(object.timeoutHeight) : $7iZIe.Long.UZERO,
            extensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.extensionOptions) ? object.extensionOptions.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            nonCriticalExtensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.nonCriticalExtensionOptions) ? object.nonCriticalExtensionOptions.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.messages) obj.messages = message.messages.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $7iZIe.Long.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_messages, _object_extensionOptions, _object_nonCriticalExtensionOptions;
        var message = $540f96552e476ffb$var$createBaseTxBody();
        message.messages = ((_object_messages = object.messages) === null || _object_messages === void 0 ? void 0 : _object_messages.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        var _object_memo;
        message.memo = (_object_memo = object.memo) !== null && _object_memo !== void 0 ? _object_memo : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $7iZIe.Long.fromValue(object.timeoutHeight) : $7iZIe.Long.UZERO;
        message.extensionOptions = ((_object_extensionOptions = object.extensionOptions) === null || _object_extensionOptions === void 0 ? void 0 : _object_extensionOptions.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        message.nonCriticalExtensionOptions = ((_object_nonCriticalExtensionOptions = object.nonCriticalExtensionOptions) === null || _object_nonCriticalExtensionOptions === void 0 ? void 0 : _object_nonCriticalExtensionOptions.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        return message;
    }
};
function $540f96552e476ffb$var$createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined,
        tip: undefined
    };
}
$540f96552e476ffb$exports.AuthInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signerInfos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $540f96552e476ffb$exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.fee !== undefined) $540f96552e476ffb$exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        if (message.tip !== undefined) $540f96552e476ffb$exports.Tip.encode(message.tip, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseAuthInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push($540f96552e476ffb$exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = $540f96552e476ffb$exports.Fee.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tip = $540f96552e476ffb$exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            signerInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.signerInfos) ? object.signerInfos.map(function(e) {
                return $540f96552e476ffb$exports.SignerInfo.fromJSON(e);
            }) : [],
            fee: (0, $7iZIe.isSet)(object.fee) ? $540f96552e476ffb$exports.Fee.fromJSON(object.fee) : undefined,
            tip: (0, $7iZIe.isSet)(object.tip) ? $540f96552e476ffb$exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map(function(e) {
            return e ? $540f96552e476ffb$exports.SignerInfo.toJSON(e) : undefined;
        });
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? $540f96552e476ffb$exports.Fee.toJSON(message.fee) : undefined);
        message.tip !== undefined && (obj.tip = message.tip ? $540f96552e476ffb$exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_signerInfos;
        var message = $540f96552e476ffb$var$createBaseAuthInfo();
        message.signerInfos = ((_object_signerInfos = object.signerInfos) === null || _object_signerInfos === void 0 ? void 0 : _object_signerInfos.map(function(e) {
            return $540f96552e476ffb$exports.SignerInfo.fromPartial(e);
        })) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? $540f96552e476ffb$exports.Fee.fromPartial(object.fee) : undefined;
        message.tip = object.tip !== undefined && object.tip !== null ? $540f96552e476ffb$exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $540f96552e476ffb$var$createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: $7iZIe.Long.UZERO
    };
}
$540f96552e476ffb$exports.SignerInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.publicKey !== undefined) $DM7bi.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) $540f96552e476ffb$exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseSignerInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = $540f96552e476ffb$exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            publicKey: (0, $7iZIe.isSet)(object.publicKey) ? $DM7bi.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: (0, $7iZIe.isSet)(object.modeInfo) ? $540f96552e476ffb$exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $DM7bi.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? $540f96552e476ffb$exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $540f96552e476ffb$var$createBaseSignerInfo();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $DM7bi.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? $540f96552e476ffb$exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $540f96552e476ffb$var$createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined
    };
}
$540f96552e476ffb$exports.ModeInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.single !== undefined) $540f96552e476ffb$exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $540f96552e476ffb$exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseModeInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $540f96552e476ffb$exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $540f96552e476ffb$exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            single: (0, $7iZIe.isSet)(object.single) ? $540f96552e476ffb$exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: (0, $7iZIe.isSet)(object.multi) ? $540f96552e476ffb$exports.ModeInfo_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.single !== undefined && (obj.single = message.single ? $540f96552e476ffb$exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $540f96552e476ffb$exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $540f96552e476ffb$var$createBaseModeInfo();
        message.single = object.single !== undefined && object.single !== null ? $540f96552e476ffb$exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $540f96552e476ffb$exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $540f96552e476ffb$var$createBaseModeInfo_Single() {
    return {
        mode: 0
    };
}
$540f96552e476ffb$exports.ModeInfo_Single = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseModeInfo_Single();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            mode: (0, $7iZIe.isSet)(object.mode) ? (0, $82c22db8b6bc5755$exports.signModeFromJSON)(object.mode) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.mode !== undefined && (obj.mode = (0, $82c22db8b6bc5755$exports.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial: function(object) {
        var message = $540f96552e476ffb$var$createBaseModeInfo_Single();
        var _object_mode;
        message.mode = (_object_mode = object.mode) !== null && _object_mode !== void 0 ? _object_mode : 0;
        return message;
    }
};
function $540f96552e476ffb$var$createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: []
    };
}
$540f96552e476ffb$exports.ModeInfo_Multi = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.bitarray !== undefined) $8a18a2241640c168$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.modeInfos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $540f96552e476ffb$exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseModeInfo_Multi();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $8a18a2241640c168$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push($540f96552e476ffb$exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            bitarray: (0, $7iZIe.isSet)(object.bitarray) ? $8a18a2241640c168$exports.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.modeInfos) ? object.modeInfos.map(function(e) {
                return $540f96552e476ffb$exports.ModeInfo.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $8a18a2241640c168$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map(function(e) {
            return e ? $540f96552e476ffb$exports.ModeInfo.toJSON(e) : undefined;
        });
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_modeInfos;
        var message = $540f96552e476ffb$var$createBaseModeInfo_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $8a18a2241640c168$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = ((_object_modeInfos = object.modeInfos) === null || _object_modeInfos === void 0 ? void 0 : _object_modeInfos.map(function(e) {
            return $540f96552e476ffb$exports.ModeInfo.fromPartial(e);
        })) || [];
        return message;
    }
};
function $540f96552e476ffb$var$createBaseFee() {
    return {
        amount: [],
        gasLimit: $7iZIe.Long.UZERO,
        payer: "",
        granter: ""
    };
}
$540f96552e476ffb$exports.Fee = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseFee();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            gasLimit: (0, $7iZIe.isSet)(object.gasLimit) ? $7iZIe.Long.fromValue(object.gasLimit) : $7iZIe.Long.UZERO,
            payer: (0, $7iZIe.isSet)(object.payer) ? String(object.payer) : "",
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $7iZIe.Long.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $540f96552e476ffb$var$createBaseFee();
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? $7iZIe.Long.fromValue(object.gasLimit) : $7iZIe.Long.UZERO;
        var _object_payer;
        message.payer = (_object_payer = object.payer) !== null && _object_payer !== void 0 ? _object_payer : "";
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        return message;
    }
};
function $540f96552e476ffb$var$createBaseTip() {
    return {
        amount: [],
        tipper: ""
    };
}
$540f96552e476ffb$exports.Tip = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.tipper !== "") writer.uint32(18).string(message.tipper);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseTip();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tipper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            tipper: (0, $7iZIe.isSet)(object.tipper) ? String(object.tipper) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        message.tipper !== undefined && (obj.tipper = message.tipper);
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $540f96552e476ffb$var$createBaseTip();
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        var _object_tipper;
        message.tipper = (_object_tipper = object.tipper) !== null && _object_tipper !== void 0 ? _object_tipper : "";
        return message;
    }
};
function $540f96552e476ffb$var$createBaseAuxSignerData() {
    return {
        address: "",
        signDoc: undefined,
        mode: 0,
        sig: new Uint8Array()
    };
}
$540f96552e476ffb$exports.AuxSignerData = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $540f96552e476ffb$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.signDoc !== undefined) $540f96552e476ffb$exports.SignDocDirectAux.encode(message.signDoc, writer.uint32(18).fork()).ldelim();
        if (message.mode !== 0) writer.uint32(24).int32(message.mode);
        if (message.sig.length !== 0) writer.uint32(34).bytes(message.sig);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $540f96552e476ffb$var$_m0.Reader ? input : new $540f96552e476ffb$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $540f96552e476ffb$var$createBaseAuxSignerData();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.signDoc = $540f96552e476ffb$exports.SignDocDirectAux.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.mode = reader.int32();
                    break;
                case 4:
                    message.sig = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            signDoc: (0, $7iZIe.isSet)(object.signDoc) ? $540f96552e476ffb$exports.SignDocDirectAux.fromJSON(object.signDoc) : undefined,
            mode: (0, $7iZIe.isSet)(object.mode) ? (0, $82c22db8b6bc5755$exports.signModeFromJSON)(object.mode) : 0,
            sig: (0, $7iZIe.isSet)(object.sig) ? (0, $7iZIe.bytesFromBase64)(object.sig) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.signDoc !== undefined && (obj.signDoc = message.signDoc ? $540f96552e476ffb$exports.SignDocDirectAux.toJSON(message.signDoc) : undefined);
        message.mode !== undefined && (obj.mode = (0, $82c22db8b6bc5755$exports.signModeToJSON)(message.mode));
        message.sig !== undefined && (obj.sig = (0, $7iZIe.base64FromBytes)(message.sig !== undefined ? message.sig : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $540f96552e476ffb$var$createBaseAuxSignerData();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.signDoc = object.signDoc !== undefined && object.signDoc !== null ? $540f96552e476ffb$exports.SignDocDirectAux.fromPartial(object.signDoc) : undefined;
        var _object_mode;
        message.mode = (_object_mode = object.mode) !== null && _object_mode !== void 0 ? _object_mode : 0;
        var _object_sig;
        message.sig = (_object_sig = object.sig) !== null && _object_sig !== void 0 ? _object_sig : new Uint8Array();
        return message;
    }
};


/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */ function $40675ea885c231a3$var$decodeTxRaw(tx) {
    var txRaw = $540f96552e476ffb$exports.TxRaw.decode(tx);
    return {
        authInfo: $540f96552e476ffb$exports.AuthInfo.decode(txRaw.authInfoBytes),
        body: $540f96552e476ffb$exports.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures
    };
}
$40675ea885c231a3$exports.decodeTxRaw = $40675ea885c231a3$var$decodeTxRaw;


Object.defineProperty($ff811d56e12ad916$exports, "decodeTxRaw", {
    enumerable: true,
    get: function get() {
        return $40675ea885c231a3$exports.decodeTxRaw;
    }
});
var $7440774b7c4d5d8d$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($7440774b7c4d5d8d$exports, "__esModule", {
    value: true
});
$7440774b7c4d5d8d$exports.DirectSecp256k1HdWallet = $7440774b7c4d5d8d$exports.extractKdfConfiguration = void 0;


var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");

var $gMk5u = parcelRequire("gMk5u");
var $f83140bf11d5189d$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
var $f83140bf11d5189d$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f83140bf11d5189d$exports, "__esModule", {
    value: true
});
$f83140bf11d5189d$exports.makeSignBytes = $f83140bf11d5189d$exports.makeSignDoc = $f83140bf11d5189d$exports.makeAuthInfoBytes = void 0;

var $gMk5u = parcelRequire("gMk5u");



var $f83140bf11d5189d$var$long_1 = $f83140bf11d5189d$var$__importDefault((parcelRequire("l6G6L")));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $f83140bf11d5189d$var$makeSignerInfos(signers, signMode) {
    return signers.map(function(param) {
        var pubkey = param.pubkey, sequence = param.sequence;
        return {
            publicKey: pubkey,
            modeInfo: {
                single: {
                    mode: signMode
                }
            },
            sequence: $f83140bf11d5189d$var$long_1.default.fromNumber(sequence)
        };
    });
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $f83140bf11d5189d$var$makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer) {
    var signMode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $82c22db8b6bc5755$exports.SignMode.SIGN_MODE_DIRECT;
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, $gMk5u.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, $gMk5u.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    var authInfo = $540f96552e476ffb$exports.AuthInfo.fromPartial({
        signerInfos: $f83140bf11d5189d$var$makeSignerInfos(signers, signMode),
        fee: {
            amount: (0, $gF0bR._)(feeAmount),
            gasLimit: $f83140bf11d5189d$var$long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer
        }
    });
    return $540f96552e476ffb$exports.AuthInfo.encode(authInfo).finish();
}
$f83140bf11d5189d$exports.makeAuthInfoBytes = $f83140bf11d5189d$var$makeAuthInfoBytes;
function $f83140bf11d5189d$var$makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: $f83140bf11d5189d$var$long_1.default.fromNumber(accountNumber)
    };
}
$f83140bf11d5189d$exports.makeSignDoc = $f83140bf11d5189d$var$makeSignDoc;
function $f83140bf11d5189d$var$makeSignBytes(param) {
    var accountNumber = param.accountNumber, authInfoBytes = param.authInfoBytes, bodyBytes = param.bodyBytes, chainId = param.chainId;
    var signDoc = $540f96552e476ffb$exports.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId
    });
    return $540f96552e476ffb$exports.SignDoc.encode(signDoc).finish();
}
$f83140bf11d5189d$exports.makeSignBytes = $f83140bf11d5189d$var$makeSignBytes;


var $7e370796687cd2fb$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($7e370796687cd2fb$exports, "__esModule", {
    value: true
});
$7e370796687cd2fb$exports.decrypt = $7e370796687cd2fb$exports.encrypt = $7e370796687cd2fb$exports.supportedAlgorithms = $7e370796687cd2fb$exports.executeKdf = $7e370796687cd2fb$exports.cosmjsSalt = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $7e370796687cd2fb$exports.cosmjsSalt = (0, $lSA9E.toAscii)("The CosmJS salt.");
function $7e370796687cd2fb$var$executeKdf(password, configuration) {
    return $7e370796687cd2fb$var$_executeKdf.apply(this, arguments);
}
function $7e370796687cd2fb$var$_executeKdf() {
    $7e370796687cd2fb$var$_executeKdf = (0, $6rBFC._)(function(password, configuration) {
        var options;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(configuration.algorithm){
                case "argon2id":
                    {
                        options = configuration.params;
                        if (!(0, $3d6bA.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                        return [
                            2,
                            $3d6bA.Argon2id.execute(password, $7e370796687cd2fb$exports.cosmjsSalt, options)
                        ];
                    }
                default:
                    throw new Error("Unsupported KDF algorithm");
            }
            return [
                2
            ];
        });
    });
    return $7e370796687cd2fb$var$_executeKdf.apply(this, arguments);
}
$7e370796687cd2fb$exports.executeKdf = $7e370796687cd2fb$var$executeKdf;
$7e370796687cd2fb$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
function $7e370796687cd2fb$var$encrypt(plaintext, encryptionKey, config) {
    return $7e370796687cd2fb$var$_encrypt.apply(this, arguments);
}
function $7e370796687cd2fb$var$_encrypt() {
    $7e370796687cd2fb$var$_encrypt = (0, $6rBFC._)(function(plaintext, encryptionKey, config) {
        var _, nonce, _1, _2, _3;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = config.algorithm;
                    switch(_){
                        case $7e370796687cd2fb$exports.supportedAlgorithms.xchacha20poly1305Ietf:
                            return [
                                3,
                                1
                            ];
                    }
                    return [
                        3,
                        3
                    ];
                case 1:
                    nonce = $3d6bA.Random.getBytes($3d6bA.xchacha20NonceLength);
                    _1 = Uint8Array.bind;
                    _3 = (_2 = (0, $gF0bR._)(nonce)).concat;
                    return [
                        4,
                        $3d6bA.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                    ];
                case 2:
                    // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                    return [
                        2,
                        new (_1.apply(Uint8Array, [
                            void 0,
                            _3.apply(_2, [
                                (0, $gF0bR._).apply(void 0, [
                                    _state.sent()
                                ])
                            ])
                        ]))
                    ];
                case 3:
                    throw new Error("Unsupported encryption algorithm: '".concat(config.algorithm, "'"));
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $7e370796687cd2fb$var$_encrypt.apply(this, arguments);
}
$7e370796687cd2fb$exports.encrypt = $7e370796687cd2fb$var$encrypt;
function $7e370796687cd2fb$var$decrypt(ciphertext, encryptionKey, config) {
    return $7e370796687cd2fb$var$_decrypt.apply(this, arguments);
}
function $7e370796687cd2fb$var$_decrypt() {
    $7e370796687cd2fb$var$_decrypt = (0, $6rBFC._)(function(ciphertext, encryptionKey, config) {
        var nonce;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(config.algorithm){
                case $7e370796687cd2fb$exports.supportedAlgorithms.xchacha20poly1305Ietf:
                    {
                        nonce = ciphertext.slice(0, $3d6bA.xchacha20NonceLength);
                        return [
                            2,
                            $3d6bA.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($3d6bA.xchacha20NonceLength), encryptionKey, nonce)
                        ];
                    }
                default:
                    throw new Error("Unsupported encryption algorithm: '".concat(config.algorithm, "'"));
            }
            return [
                2
            ];
        });
    });
    return $7e370796687cd2fb$var$_decrypt.apply(this, arguments);
}
$7e370796687cd2fb$exports.decrypt = $7e370796687cd2fb$var$decrypt;


var $7440774b7c4d5d8d$var$serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ var $7440774b7c4d5d8d$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $7440774b7c4d5d8d$var$isDerivationJson(thing) {
    if (!(0, $gMk5u.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $7440774b7c4d5d8d$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $7440774b7c4d5d8d$var$extractKdfConfiguration(serialization) {
    var root = JSON.parse(serialization);
    if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $7440774b7c4d5d8d$var$serializationTypeV1:
            return $7440774b7c4d5d8d$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$7440774b7c4d5d8d$exports.extractKdfConfiguration = $7440774b7c4d5d8d$var$extractKdfConfiguration;
var $7440774b7c4d5d8d$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $c9b9a1a428003423$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */ var $7440774b7c4d5d8d$var$DirectSecp256k1HdWallet = /*#__PURE__*/ function() {
    function DirectSecp256k1HdWallet(mnemonic, options) {
        (0, $7dKN1._)(this, DirectSecp256k1HdWallet);
        var _options_prefix;
        var prefix = (_options_prefix = options.prefix) !== null && _options_prefix !== void 0 ? _options_prefix : $7440774b7c4d5d8d$var$defaultOptions.prefix;
        var _options_hdPaths;
        var hdPaths = (_options_hdPaths = options.hdPaths) !== null && _options_hdPaths !== void 0 ? _options_hdPaths : $7440774b7c4d5d8d$var$defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map(function(hdPath) {
            return {
                hdPath: hdPath,
                prefix: prefix
            };
        });
    }
    (0, $eW5pA._)(DirectSecp256k1HdWallet, [
        {
            key: "mnemonic",
            get: function get() {
                return this.secret.toString();
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accountsWithPrivkeys;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountsWithPrivkeys()
                                ];
                            case 1:
                                accountsWithPrivkeys = _state.sent();
                                return [
                                    2,
                                    accountsWithPrivkeys.map(function(param) {
                                        var algo = param.algo, pubkey = param.pubkey, address = param.address;
                                        return {
                                            algo: algo,
                                            pubkey: pubkey,
                                            address: address
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signDirect",
            value: function signDirect(signerAddress, signDoc) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accounts, account, privkey, pubkey, signBytes, hashedMessage, signature, signatureBytes, stdSignature;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountsWithPrivkeys()
                                ];
                            case 1:
                                accounts = _state.sent();
                                account = accounts.find(function(param) {
                                    var address = param.address;
                                    return address === signerAddress;
                                });
                                if (account === undefined) throw new Error("Address ".concat(signerAddress, " not found in wallet"));
                                privkey = account.privkey, pubkey = account.pubkey;
                                signBytes = (0, $f83140bf11d5189d$exports.makeSignBytes)(signDoc);
                                hashedMessage = (0, $3d6bA.sha256)(signBytes);
                                return [
                                    4,
                                    $3d6bA.Secp256k1.createSignature(hashedMessage, privkey)
                                ];
                            case 2:
                                signature = _state.sent();
                                signatureBytes = new Uint8Array((0, $gF0bR._)(signature.r(32)).concat((0, $gF0bR._)(signature.s(32))));
                                stdSignature = (0, $c9b9a1a428003423$exports.encodeSecp256k1Signature)(pubkey, signatureBytes);
                                return [
                                    2,
                                    {
                                        signed: signDoc,
                                        signature: stdSignature
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "serialize",
            value: /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ function serialize(password) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var kdfConfiguration, encryptionKey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                kdfConfiguration = $7440774b7c4d5d8d$var$basicPasswordHashingOptions;
                                return [
                                    4,
                                    (0, $7e370796687cd2fb$exports.executeKdf)(password, kdfConfiguration)
                                ];
                            case 1:
                                encryptionKey = _state.sent();
                                return [
                                    2,
                                    _this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "serializeWithEncryptionKey",
            value: /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ function serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var dataToEncrypt, dataToEncryptRaw, encryptionConfiguration, encryptedData, out;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dataToEncrypt = {
                                    mnemonic: _this.mnemonic,
                                    accounts: _this.accounts.map(function(param) {
                                        var hdPath = param.hdPath, prefix = param.prefix;
                                        return {
                                            hdPath: (0, $3d6bA.pathToString)(hdPath),
                                            prefix: prefix
                                        };
                                    })
                                };
                                dataToEncryptRaw = (0, $lSA9E.toUtf8)(JSON.stringify(dataToEncrypt));
                                encryptionConfiguration = {
                                    algorithm: $7e370796687cd2fb$exports.supportedAlgorithms.xchacha20poly1305Ietf
                                };
                                return [
                                    4,
                                    (0, $7e370796687cd2fb$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration)
                                ];
                            case 1:
                                encryptedData = _state.sent();
                                out = {
                                    type: $7440774b7c4d5d8d$var$serializationTypeV1,
                                    kdf: kdfConfiguration,
                                    encryption: encryptionConfiguration,
                                    data: (0, $lSA9E.toBase64)(encryptedData)
                                };
                                return [
                                    2,
                                    JSON.stringify(out)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getKeyPair",
            value: function getKeyPair(hdPath) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var privkey, pubkey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                privkey = $3d6bA.Slip10.derivePath($3d6bA.Slip10Curve.Secp256k1, _this.seed, hdPath).privkey;
                                return [
                                    4,
                                    $3d6bA.Secp256k1.makeKeypair(privkey)
                                ];
                            case 1:
                                pubkey = _state.sent().pubkey;
                                return [
                                    2,
                                    {
                                        privkey: privkey,
                                        pubkey: $3d6bA.Secp256k1.compressPubkey(pubkey)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountsWithPrivkeys",
            value: function getAccountsWithPrivkeys() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            Promise.all(_this.accounts.map(function() {
                                var _ref = (0, $6rBFC._)(function(param) {
                                    var hdPath, prefix, _ref, privkey, pubkey, address;
                                    return (0, $6qu4b.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                hdPath = param.hdPath, prefix = param.prefix;
                                                return [
                                                    4,
                                                    _this.getKeyPair(hdPath)
                                                ];
                                            case 1:
                                                _ref = _state.sent(), privkey = _ref.privkey, pubkey = _ref.pubkey;
                                                address = (0, $lSA9E.toBech32)(prefix, (0, $c9b9a1a428003423$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
                                                return [
                                                    2,
                                                    {
                                                        algo: "secp256k1",
                                                        privkey: privkey,
                                                        pubkey: pubkey,
                                                        address: address
                                                    }
                                                ];
                                        }
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "fromMnemonic",
            value: /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ function fromMnemonic(mnemonic) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    var mnemonicChecked, seed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mnemonicChecked = new $3d6bA.EnglishMnemonic(mnemonic);
                                return [
                                    4,
                                    $3d6bA.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password)
                                ];
                            case 1:
                                seed = _state.sent();
                                return [
                                    2,
                                    new DirectSecp256k1HdWallet(mnemonicChecked, (0, $gddcW._)((0, $4JCw4._)({}, options), {
                                        seed: seed
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generate",
            value: /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ function generate() {
                var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 12, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    var entropyLength, entropy, mnemonic;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        entropyLength = 4 * Math.floor(11 * length / 33);
                        entropy = $3d6bA.Random.getBytes(entropyLength);
                        mnemonic = $3d6bA.Bip39.encode(entropy);
                        return [
                            2,
                            DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options)
                        ];
                    });
                })();
            }
        },
        {
            key: "deserialize",
            value: /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ function deserialize(serialization, password) {
                return (0, $6rBFC._)(function() {
                    var root;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        root = JSON.parse(serialization);
                        if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
                        switch(root.type){
                            case $7440774b7c4d5d8d$var$serializationTypeV1:
                                return [
                                    2,
                                    DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password)
                                ];
                            default:
                                throw new Error("Unsupported serialization type");
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "deserializeWithEncryptionKey",
            value: /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ function deserializeWithEncryptionKey(serialization, encryptionKey) {
                return (0, $6rBFC._)(function() {
                    var root, untypedRoot, _, decryptedBytes, decryptedDocument, mnemonic, accounts, firstPrefix, hdPaths;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                root = JSON.parse(serialization);
                                if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
                                untypedRoot = root;
                                _ = untypedRoot.type;
                                switch(_){
                                    case $7440774b7c4d5d8d$var$serializationTypeV1:
                                        return [
                                            3,
                                            1
                                        ];
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    (0, $7e370796687cd2fb$exports.decrypt)((0, $lSA9E.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption)
                                ];
                            case 2:
                                decryptedBytes = _state.sent();
                                decryptedDocument = JSON.parse((0, $lSA9E.fromUtf8)(decryptedBytes));
                                mnemonic = decryptedDocument.mnemonic, accounts = decryptedDocument.accounts;
                                (0, $gMk5u.assert)(typeof mnemonic === "string");
                                if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                                if (!accounts.every(function(account) {
                                    return $7440774b7c4d5d8d$var$isDerivationJson(account);
                                })) throw new Error("Account is not in the correct format.");
                                firstPrefix = accounts[0].prefix;
                                if (!accounts.every(function(param) {
                                    var prefix = param.prefix;
                                    return prefix === firstPrefix;
                                })) throw new Error("Accounts do not all have the same prefix");
                                hdPaths = accounts.map(function(param) {
                                    var hdPath = param.hdPath;
                                    return (0, $3d6bA.stringToPath)(hdPath);
                                });
                                return [
                                    2,
                                    DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                                        hdPaths: hdPaths,
                                        prefix: firstPrefix
                                    })
                                ];
                            case 3:
                                throw new Error("Unsupported serialization type");
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deserializeTypeV1",
            value: function deserializeTypeV1(serialization, password) {
                return (0, $6rBFC._)(function() {
                    var root, encryptionKey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                root = JSON.parse(serialization);
                                if (!(0, $gMk5u.isNonNullObject)(root)) throw new Error("Root document is not an object.");
                                return [
                                    4,
                                    (0, $7e370796687cd2fb$exports.executeKdf)(password, root.kdf)
                                ];
                            case 1:
                                encryptionKey = _state.sent();
                                return [
                                    2,
                                    DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DirectSecp256k1HdWallet;
}();
$7440774b7c4d5d8d$exports.DirectSecp256k1HdWallet = $7440774b7c4d5d8d$var$DirectSecp256k1HdWallet;


Object.defineProperty($ff811d56e12ad916$exports, "DirectSecp256k1HdWallet", {
    enumerable: true,
    get: function get() {
        return $7440774b7c4d5d8d$exports.DirectSecp256k1HdWallet;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function get() {
        return $7440774b7c4d5d8d$exports.extractKdfConfiguration;
    }
});
var $fcf01f3ffef3c076$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($fcf01f3ffef3c076$exports, "__esModule", {
    value: true
});
$fcf01f3ffef3c076$exports.DirectSecp256k1Wallet = void 0;


var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");

/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */ var $fcf01f3ffef3c076$var$DirectSecp256k1Wallet = /*#__PURE__*/ function() {
    function DirectSecp256k1Wallet(privkey, pubkey, prefix) {
        (0, $7dKN1._)(this, DirectSecp256k1Wallet);
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    (0, $eW5pA._)(DirectSecp256k1Wallet, [
        {
            key: "address",
            get: function get() {
                return (0, $lSA9E.toBech32)(this.prefix, (0, $c9b9a1a428003423$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            [
                                {
                                    algo: "secp256k1",
                                    address: _this.address,
                                    pubkey: _this.pubkey
                                }
                            ]
                        ];
                    });
                })();
            }
        },
        {
            key: "signDirect",
            value: function signDirect(address, signDoc) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var signBytes, hashedMessage, signature, signatureBytes, stdSignature;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                signBytes = (0, $f83140bf11d5189d$exports.makeSignBytes)(signDoc);
                                if (address !== _this.address) throw new Error("Address ".concat(address, " not found in wallet"));
                                hashedMessage = (0, $3d6bA.sha256)(signBytes);
                                return [
                                    4,
                                    $3d6bA.Secp256k1.createSignature(hashedMessage, _this.privkey)
                                ];
                            case 1:
                                signature = _state.sent();
                                signatureBytes = new Uint8Array((0, $gF0bR._)(signature.r(32)).concat((0, $gF0bR._)(signature.s(32))));
                                stdSignature = (0, $c9b9a1a428003423$exports.encodeSecp256k1Signature)(_this.pubkey, signatureBytes);
                                return [
                                    2,
                                    {
                                        signed: signDoc,
                                        signature: stdSignature
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "fromKey",
            value: /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ function fromKey(privkey) {
                var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cosmos";
                return (0, $6rBFC._)(function() {
                    var uncompressed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $3d6bA.Secp256k1.makeKeypair(privkey)
                                ];
                            case 1:
                                uncompressed = _state.sent().pubkey;
                                return [
                                    2,
                                    new DirectSecp256k1Wallet(privkey, $3d6bA.Secp256k1.compressPubkey(uncompressed), prefix)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DirectSecp256k1Wallet;
}();
$fcf01f3ffef3c076$exports.DirectSecp256k1Wallet = $fcf01f3ffef3c076$var$DirectSecp256k1Wallet;


Object.defineProperty($ff811d56e12ad916$exports, "DirectSecp256k1Wallet", {
    enumerable: true,
    get: function get() {
        return $fcf01f3ffef3c076$exports.DirectSecp256k1Wallet;
    }
});
var $4f2f0486bd7de8b1$exports = {};
"use strict";
Object.defineProperty($4f2f0486bd7de8b1$exports, "__esModule", {
    value: true
});
$4f2f0486bd7de8b1$exports.makeCosmoshubPath = void 0;

var $3d6bA = parcelRequire("3d6bA");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $4f2f0486bd7de8b1$var$makeCosmoshubPath(a) {
    return [
        $3d6bA.Slip10RawIndex.hardened(44),
        $3d6bA.Slip10RawIndex.hardened(118),
        $3d6bA.Slip10RawIndex.hardened(0),
        $3d6bA.Slip10RawIndex.normal(0),
        $3d6bA.Slip10RawIndex.normal(a)
    ];
}
$4f2f0486bd7de8b1$exports.makeCosmoshubPath = $4f2f0486bd7de8b1$var$makeCosmoshubPath;


Object.defineProperty($ff811d56e12ad916$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function get() {
        return $4f2f0486bd7de8b1$exports.makeCosmoshubPath;
    }
});
var $b0b0e835f69f0a1e$exports = {};
"use strict";
Object.defineProperty($b0b0e835f69f0a1e$exports, "__esModule", {
    value: true
});
$b0b0e835f69f0a1e$exports.decodePubkey = $b0b0e835f69f0a1e$exports.anyToSinglePubkey = $b0b0e835f69f0a1e$exports.encodePubkey = void 0;


var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");
var $3d84a57d16966560$exports = {};
"use strict";
var $3d84a57d16966560$var$__createBinding = $3d84a57d16966560$exports && $3d84a57d16966560$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3d84a57d16966560$var$__setModuleDefault = $3d84a57d16966560$exports && $3d84a57d16966560$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3d84a57d16966560$var$__importStar = $3d84a57d16966560$exports && $3d84a57d16966560$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3d84a57d16966560$var$__createBinding(result, mod, k);
    }
    $3d84a57d16966560$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3d84a57d16966560$exports, "__esModule", {
    value: true
});
$3d84a57d16966560$exports.PrivKey = $3d84a57d16966560$exports.PubKey = $3d84a57d16966560$exports.protobufPackage = void 0;

/* eslint-disable */ var $3d84a57d16966560$var$_m0 = $3d84a57d16966560$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$3d84a57d16966560$exports.protobufPackage = "cosmos.crypto.ed25519";
function $3d84a57d16966560$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
$3d84a57d16966560$exports.PubKey = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d84a57d16966560$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d84a57d16966560$var$_m0.Reader ? input : new $3d84a57d16966560$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d84a57d16966560$var$createBasePubKey();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $3d84a57d16966560$var$createBasePubKey();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        return message;
    }
};
function $3d84a57d16966560$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
$3d84a57d16966560$exports.PrivKey = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d84a57d16966560$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d84a57d16966560$var$_m0.Reader ? input : new $3d84a57d16966560$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d84a57d16966560$var$createBasePrivKey();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $3d84a57d16966560$var$createBasePrivKey();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        return message;
    }
};


var $077ab77789416c17$exports = {};
"use strict";
var $077ab77789416c17$var$__createBinding = $077ab77789416c17$exports && $077ab77789416c17$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $077ab77789416c17$var$__setModuleDefault = $077ab77789416c17$exports && $077ab77789416c17$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $077ab77789416c17$var$__importStar = $077ab77789416c17$exports && $077ab77789416c17$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $077ab77789416c17$var$__createBinding(result, mod, k);
    }
    $077ab77789416c17$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($077ab77789416c17$exports, "__esModule", {
    value: true
});
$077ab77789416c17$exports.LegacyAminoPubKey = $077ab77789416c17$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $077ab77789416c17$var$_m0 = $077ab77789416c17$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$077ab77789416c17$exports.protobufPackage = "cosmos.crypto.multisig";
function $077ab77789416c17$var$createBaseLegacyAminoPubKey() {
    return {
        threshold: 0,
        publicKeys: []
    };
}
$077ab77789416c17$exports.LegacyAminoPubKey = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $077ab77789416c17$var$_m0.Writer.create();
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.publicKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $077ab77789416c17$var$_m0.Reader ? input : new $077ab77789416c17$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $077ab77789416c17$var$createBaseLegacyAminoPubKey();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            threshold: (0, $7iZIe.isSet)(object.threshold) ? Number(object.threshold) : 0,
            publicKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.publicKeys) ? object.publicKeys.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.threshold !== undefined && (obj.threshold = Math.round(message.threshold));
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_publicKeys;
        var message = $077ab77789416c17$var$createBaseLegacyAminoPubKey();
        var _object_threshold;
        message.threshold = (_object_threshold = object.threshold) !== null && _object_threshold !== void 0 ? _object_threshold : 0;
        message.publicKeys = ((_object_publicKeys = object.publicKeys) === null || _object_publicKeys === void 0 ? void 0 : _object_publicKeys.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        return message;
    }
};


var $fd9dce7a359d5dd1$exports = {};
"use strict";
var $fd9dce7a359d5dd1$var$__createBinding = $fd9dce7a359d5dd1$exports && $fd9dce7a359d5dd1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd9dce7a359d5dd1$var$__setModuleDefault = $fd9dce7a359d5dd1$exports && $fd9dce7a359d5dd1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fd9dce7a359d5dd1$var$__importStar = $fd9dce7a359d5dd1$exports && $fd9dce7a359d5dd1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fd9dce7a359d5dd1$var$__createBinding(result, mod, k);
    }
    $fd9dce7a359d5dd1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fd9dce7a359d5dd1$exports, "__esModule", {
    value: true
});
$fd9dce7a359d5dd1$exports.PrivKey = $fd9dce7a359d5dd1$exports.PubKey = $fd9dce7a359d5dd1$exports.protobufPackage = void 0;

/* eslint-disable */ var $fd9dce7a359d5dd1$var$_m0 = $fd9dce7a359d5dd1$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$fd9dce7a359d5dd1$exports.protobufPackage = "cosmos.crypto.secp256k1";
function $fd9dce7a359d5dd1$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
$fd9dce7a359d5dd1$exports.PubKey = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fd9dce7a359d5dd1$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fd9dce7a359d5dd1$var$_m0.Reader ? input : new $fd9dce7a359d5dd1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fd9dce7a359d5dd1$var$createBasePubKey();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $fd9dce7a359d5dd1$var$createBasePubKey();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        return message;
    }
};
function $fd9dce7a359d5dd1$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
$fd9dce7a359d5dd1$exports.PrivKey = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fd9dce7a359d5dd1$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fd9dce7a359d5dd1$var$_m0.Reader ? input : new $fd9dce7a359d5dd1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fd9dce7a359d5dd1$var$createBasePrivKey();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $fd9dce7a359d5dd1$var$createBasePrivKey();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");
/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */ function $b0b0e835f69f0a1e$var$encodePubkey(pubkey) {
    if ((0, $c9b9a1a428003423$exports.isSecp256k1Pubkey)(pubkey)) {
        var pubkeyProto = $fd9dce7a359d5dd1$exports.PubKey.fromPartial({
            key: (0, $lSA9E.fromBase64)(pubkey.value)
        });
        return $DM7bi.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from($fd9dce7a359d5dd1$exports.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $c9b9a1a428003423$exports.isEd25519Pubkey)(pubkey)) {
        var pubkeyProto1 = $3d84a57d16966560$exports.PubKey.fromPartial({
            key: (0, $lSA9E.fromBase64)(pubkey.value)
        });
        return $DM7bi.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from($3d84a57d16966560$exports.PubKey.encode(pubkeyProto1).finish())
        });
    } else if ((0, $c9b9a1a428003423$exports.isMultisigThresholdPubkey)(pubkey)) {
        var pubkeyProto2 = $077ab77789416c17$exports.LegacyAminoPubKey.fromPartial({
            threshold: $kTbgy.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map($b0b0e835f69f0a1e$var$encodePubkey)
        });
        return $DM7bi.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from($077ab77789416c17$exports.LegacyAminoPubKey.encode(pubkeyProto2).finish())
        });
    } else throw new Error("Pubkey type ".concat(pubkey.type, " not recognized"));
}
$b0b0e835f69f0a1e$exports.encodePubkey = $b0b0e835f69f0a1e$var$encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`.
 */ function $b0b0e835f69f0a1e$var$anyToSinglePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            {
                var key = $fd9dce7a359d5dd1$exports.PubKey.decode(pubkey.value).key;
                return (0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(key);
            }
        case "/cosmos.crypto.ed25519.PubKey":
            {
                var key1 = $3d84a57d16966560$exports.PubKey.decode(pubkey.value).key;
                return (0, $c9b9a1a428003423$exports.encodeEd25519Pubkey)(key1);
            }
        default:
            throw new Error("Pubkey type_url ".concat(pubkey.typeUrl, " not recognized as single public key type"));
    }
}
$b0b0e835f69f0a1e$exports.anyToSinglePubkey = $b0b0e835f69f0a1e$var$anyToSinglePubkey;
/**
 * Decodes a pubkey from a protobuf `Any` into `Pubkey`.
 * This supports single pubkeys such as Cosmos ed25519 and secp256k1 keys
 * as well as multisig threshold pubkeys.
 */ function $b0b0e835f69f0a1e$var$decodePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey":
            return $b0b0e835f69f0a1e$var$anyToSinglePubkey(pubkey);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
            {
                var _keys_2_LegacyAminoPubKey_decode = $077ab77789416c17$exports.LegacyAminoPubKey.decode(pubkey.value), threshold = _keys_2_LegacyAminoPubKey_decode.threshold, publicKeys = _keys_2_LegacyAminoPubKey_decode.publicKeys;
                var out = {
                    type: "tendermint/PubKeyMultisigThreshold",
                    value: {
                        threshold: threshold.toString(),
                        pubkeys: publicKeys.map($b0b0e835f69f0a1e$var$anyToSinglePubkey)
                    }
                };
                return out;
            }
        default:
            throw new Error("Pubkey type_url ".concat(pubkey.typeUrl, " not recognized"));
    }
}
$b0b0e835f69f0a1e$exports.decodePubkey = $b0b0e835f69f0a1e$var$decodePubkey;


Object.defineProperty($ff811d56e12ad916$exports, "anyToSinglePubkey", {
    enumerable: true,
    get: function get() {
        return $b0b0e835f69f0a1e$exports.anyToSinglePubkey;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "decodePubkey", {
    enumerable: true,
    get: function get() {
        return $b0b0e835f69f0a1e$exports.decodePubkey;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "encodePubkey", {
    enumerable: true,
    get: function get() {
        return $b0b0e835f69f0a1e$exports.encodePubkey;
    }
});
var $bab49d397fbc580a$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $bab49d397fbc580a$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($bab49d397fbc580a$exports, "__esModule", {
    value: true
});
$bab49d397fbc580a$exports.Registry = $bab49d397fbc580a$exports.isTxBodyEncodeObject = $bab49d397fbc580a$exports.isPbjsGeneratedType = $bab49d397fbc580a$exports.isTsProtoGeneratedType = void 0;
var $ff872d712a668d44$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $ff872d712a668d44$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ff872d712a668d44$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ff872d712a668d44$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ff872d712a668d44$var$__createBinding(result, mod, k);
    }
    $ff872d712a668d44$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ff872d712a668d44$exports, "__esModule", {
    value: true
});
$ff872d712a668d44$exports.MsgClientImpl = $ff872d712a668d44$exports.MsgSetSendEnabledResponse = $ff872d712a668d44$exports.MsgSetSendEnabled = $ff872d712a668d44$exports.MsgUpdateParamsResponse = $ff872d712a668d44$exports.MsgUpdateParams = $ff872d712a668d44$exports.MsgMultiSendResponse = $ff872d712a668d44$exports.MsgMultiSend = $ff872d712a668d44$exports.MsgSendResponse = $ff872d712a668d44$exports.MsgSend = $ff872d712a668d44$exports.protobufPackage = void 0;

var $fbc4fefeee7baa98$exports = {};
"use strict";
var $fbc4fefeee7baa98$var$__createBinding = $fbc4fefeee7baa98$exports && $fbc4fefeee7baa98$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fbc4fefeee7baa98$var$__setModuleDefault = $fbc4fefeee7baa98$exports && $fbc4fefeee7baa98$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fbc4fefeee7baa98$var$__importStar = $fbc4fefeee7baa98$exports && $fbc4fefeee7baa98$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fbc4fefeee7baa98$var$__createBinding(result, mod, k);
    }
    $fbc4fefeee7baa98$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fbc4fefeee7baa98$exports, "__esModule", {
    value: true
});
$fbc4fefeee7baa98$exports.Metadata = $fbc4fefeee7baa98$exports.DenomUnit = $fbc4fefeee7baa98$exports.Supply = $fbc4fefeee7baa98$exports.Output = $fbc4fefeee7baa98$exports.Input = $fbc4fefeee7baa98$exports.SendEnabled = $fbc4fefeee7baa98$exports.Params = $fbc4fefeee7baa98$exports.protobufPackage = void 0;


var $fbc4fefeee7baa98$var$_m0 = $fbc4fefeee7baa98$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$fbc4fefeee7baa98$exports.protobufPackage = "cosmos.bank.v1beta1";
function $fbc4fefeee7baa98$var$createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false
    };
}
$fbc4fefeee7baa98$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.sendEnabled[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $fbc4fefeee7baa98$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($fbc4fefeee7baa98$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.sendEnabled) ? object.sendEnabled.map(function(e) {
                return $fbc4fefeee7baa98$exports.SendEnabled.fromJSON(e);
            }) : [],
            defaultSendEnabled: (0, $7iZIe.isSet)(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.SendEnabled.toJSON(e) : undefined;
        });
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial: function(object) {
        var _object_sendEnabled;
        var message = $fbc4fefeee7baa98$var$createBaseParams();
        message.sendEnabled = ((_object_sendEnabled = object.sendEnabled) === null || _object_sendEnabled === void 0 ? void 0 : _object_sendEnabled.map(function(e) {
            return $fbc4fefeee7baa98$exports.SendEnabled.fromPartial(e);
        })) || [];
        var _object_defaultSendEnabled;
        message.defaultSendEnabled = (_object_defaultSendEnabled = object.defaultSendEnabled) !== null && _object_defaultSendEnabled !== void 0 ? _object_defaultSendEnabled : false;
        return message;
    }
};
function $fbc4fefeee7baa98$var$createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false
    };
}
$fbc4fefeee7baa98$exports.SendEnabled = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseSendEnabled();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : "",
            enabled: (0, $7iZIe.isSet)(object.enabled) ? Boolean(object.enabled) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial: function(object) {
        var message = $fbc4fefeee7baa98$var$createBaseSendEnabled();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        var _object_enabled;
        message.enabled = (_object_enabled = object.enabled) !== null && _object_enabled !== void 0 ? _object_enabled : false;
        return message;
    }
};
function $fbc4fefeee7baa98$var$createBaseInput() {
    return {
        address: "",
        coins: []
    };
}
$fbc4fefeee7baa98$exports.Input = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.coins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseInput();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.coins = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_coins;
        var message = $fbc4fefeee7baa98$var$createBaseInput();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.coins = ((_object_coins = object.coins) === null || _object_coins === void 0 ? void 0 : _object_coins.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $fbc4fefeee7baa98$var$createBaseOutput() {
    return {
        address: "",
        coins: []
    };
}
$fbc4fefeee7baa98$exports.Output = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.coins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseOutput();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.coins = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_coins;
        var message = $fbc4fefeee7baa98$var$createBaseOutput();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.coins = ((_object_coins = object.coins) === null || _object_coins === void 0 ? void 0 : _object_coins.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $fbc4fefeee7baa98$var$createBaseSupply() {
    return {
        total: []
    };
}
$fbc4fefeee7baa98$exports.Supply = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.total[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseSupply();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.total) obj.total = message.total.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.total = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_total;
        var message = $fbc4fefeee7baa98$var$createBaseSupply();
        message.total = ((_object_total = object.total) === null || _object_total === void 0 ? void 0 : _object_total.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $fbc4fefeee7baa98$var$createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: []
    };
}
$fbc4fefeee7baa98$exports.DenomUnit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.aliases[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(26).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseDenomUnit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : "",
            exponent: (0, $7iZIe.isSet)(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object === null || object === void 0 ? void 0 : object.aliases) ? object.aliases.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) obj.aliases = message.aliases.map(function(e) {
            return e;
        });
        else obj.aliases = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_aliases;
        var message = $fbc4fefeee7baa98$var$createBaseDenomUnit();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        var _object_exponent;
        message.exponent = (_object_exponent = object.exponent) !== null && _object_exponent !== void 0 ? _object_exponent : 0;
        message.aliases = ((_object_aliases = object.aliases) === null || _object_aliases === void 0 ? void 0 : _object_aliases.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $fbc4fefeee7baa98$var$createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: "",
        uri: "",
        uriHash: ""
    };
}
$fbc4fefeee7baa98$exports.Metadata = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fbc4fefeee7baa98$var$_m0.Writer.create();
        if (message.description !== "") writer.uint32(10).string(message.description);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.denomUnits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $fbc4fefeee7baa98$exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        if (message.uri !== "") writer.uint32(58).string(message.uri);
        if (message.uriHash !== "") writer.uint32(66).string(message.uriHash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fbc4fefeee7baa98$var$_m0.Reader ? input : new $fbc4fefeee7baa98$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fbc4fefeee7baa98$var$createBaseMetadata();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push($fbc4fefeee7baa98$exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                case 7:
                    message.uri = reader.string();
                    break;
                case 8:
                    message.uriHash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object === null || object === void 0 ? void 0 : object.denomUnits) ? object.denomUnits.map(function(e) {
                return $fbc4fefeee7baa98$exports.DenomUnit.fromJSON(e);
            }) : [],
            base: (0, $7iZIe.isSet)(object.base) ? String(object.base) : "",
            display: (0, $7iZIe.isSet)(object.display) ? String(object.display) : "",
            name: (0, $7iZIe.isSet)(object.name) ? String(object.name) : "",
            symbol: (0, $7iZIe.isSet)(object.symbol) ? String(object.symbol) : "",
            uri: (0, $7iZIe.isSet)(object.uri) ? String(object.uri) : "",
            uriHash: (0, $7iZIe.isSet)(object.uriHash) ? String(object.uriHash) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.DenomUnit.toJSON(e) : undefined;
        });
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.uri !== undefined && (obj.uri = message.uri);
        message.uriHash !== undefined && (obj.uriHash = message.uriHash);
        return obj;
    },
    fromPartial: function(object) {
        var _object_denomUnits;
        var message = $fbc4fefeee7baa98$var$createBaseMetadata();
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        message.denomUnits = ((_object_denomUnits = object.denomUnits) === null || _object_denomUnits === void 0 ? void 0 : _object_denomUnits.map(function(e) {
            return $fbc4fefeee7baa98$exports.DenomUnit.fromPartial(e);
        })) || [];
        var _object_base;
        message.base = (_object_base = object.base) !== null && _object_base !== void 0 ? _object_base : "";
        var _object_display;
        message.display = (_object_display = object.display) !== null && _object_display !== void 0 ? _object_display : "";
        var _object_name;
        message.name = (_object_name = object.name) !== null && _object_name !== void 0 ? _object_name : "";
        var _object_symbol;
        message.symbol = (_object_symbol = object.symbol) !== null && _object_symbol !== void 0 ? _object_symbol : "";
        var _object_uri;
        message.uri = (_object_uri = object.uri) !== null && _object_uri !== void 0 ? _object_uri : "";
        var _object_uriHash;
        message.uriHash = (_object_uriHash = object.uriHash) !== null && _object_uriHash !== void 0 ? _object_uriHash : "";
        return message;
    }
};



var $ff872d712a668d44$var$_m0 = $ff872d712a668d44$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$ff872d712a668d44$exports.protobufPackage = "cosmos.bank.v1beta1";
function $ff872d712a668d44$var$createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
$ff872d712a668d44$exports.MsgSend = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgSend();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            fromAddress: (0, $7iZIe.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $7iZIe.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $ff872d712a668d44$var$createBaseMsgSend();
        var _object_fromAddress;
        message.fromAddress = (_object_fromAddress = object.fromAddress) !== null && _object_fromAddress !== void 0 ? _object_fromAddress : "";
        var _object_toAddress;
        message.toAddress = (_object_toAddress = object.toAddress) !== null && _object_toAddress !== void 0 ? _object_toAddress : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgSendResponse() {
    return {};
}
$ff872d712a668d44$exports.MsgSendResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgSendResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $ff872d712a668d44$var$createBaseMsgSendResponse();
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: []
    };
}
$ff872d712a668d44$exports.MsgMultiSend = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $fbc4fefeee7baa98$exports.Input.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.outputs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $fbc4fefeee7baa98$exports.Output.encode(v1, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgMultiSend();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($fbc4fefeee7baa98$exports.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($fbc4fefeee7baa98$exports.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            inputs: Array.isArray(object === null || object === void 0 ? void 0 : object.inputs) ? object.inputs.map(function(e) {
                return $fbc4fefeee7baa98$exports.Input.fromJSON(e);
            }) : [],
            outputs: Array.isArray(object === null || object === void 0 ? void 0 : object.outputs) ? object.outputs.map(function(e) {
                return $fbc4fefeee7baa98$exports.Output.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.inputs) obj.inputs = message.inputs.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.Input.toJSON(e) : undefined;
        });
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.Output.toJSON(e) : undefined;
        });
        else obj.outputs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_inputs, _object_outputs;
        var message = $ff872d712a668d44$var$createBaseMsgMultiSend();
        message.inputs = ((_object_inputs = object.inputs) === null || _object_inputs === void 0 ? void 0 : _object_inputs.map(function(e) {
            return $fbc4fefeee7baa98$exports.Input.fromPartial(e);
        })) || [];
        message.outputs = ((_object_outputs = object.outputs) === null || _object_outputs === void 0 ? void 0 : _object_outputs.map(function(e) {
            return $fbc4fefeee7baa98$exports.Output.fromPartial(e);
        })) || [];
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgMultiSendResponse() {
    return {};
}
$ff872d712a668d44$exports.MsgMultiSendResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgMultiSendResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $ff872d712a668d44$var$createBaseMsgMultiSendResponse();
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$ff872d712a668d44$exports.MsgUpdateParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $fbc4fefeee7baa98$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $fbc4fefeee7baa98$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $7iZIe.isSet)(object.params) ? $fbc4fefeee7baa98$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $fbc4fefeee7baa98$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $ff872d712a668d44$var$createBaseMsgUpdateParams();
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        message.params = object.params !== undefined && object.params !== null ? $fbc4fefeee7baa98$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$ff872d712a668d44$exports.MsgUpdateParamsResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $ff872d712a668d44$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgSetSendEnabled() {
    return {
        authority: "",
        sendEnabled: [],
        useDefaultFor: []
    };
}
$ff872d712a668d44$exports.MsgSetSendEnabled = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.sendEnabled[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $fbc4fefeee7baa98$exports.SendEnabled.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.useDefaultFor[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                writer.uint32(26).string(v1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgSetSendEnabled();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.sendEnabled.push($fbc4fefeee7baa98$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.useDefaultFor.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : "",
            sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.sendEnabled) ? object.sendEnabled.map(function(e) {
                return $fbc4fefeee7baa98$exports.SendEnabled.fromJSON(e);
            }) : [],
            useDefaultFor: Array.isArray(object === null || object === void 0 ? void 0 : object.useDefaultFor) ? object.useDefaultFor.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.SendEnabled.toJSON(e) : undefined;
        });
        else obj.sendEnabled = [];
        if (message.useDefaultFor) obj.useDefaultFor = message.useDefaultFor.map(function(e) {
            return e;
        });
        else obj.useDefaultFor = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_sendEnabled, _object_useDefaultFor;
        var message = $ff872d712a668d44$var$createBaseMsgSetSendEnabled();
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        message.sendEnabled = ((_object_sendEnabled = object.sendEnabled) === null || _object_sendEnabled === void 0 ? void 0 : _object_sendEnabled.map(function(e) {
            return $fbc4fefeee7baa98$exports.SendEnabled.fromPartial(e);
        })) || [];
        message.useDefaultFor = ((_object_useDefaultFor = object.useDefaultFor) === null || _object_useDefaultFor === void 0 ? void 0 : _object_useDefaultFor.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $ff872d712a668d44$var$createBaseMsgSetSendEnabledResponse() {
    return {};
}
$ff872d712a668d44$exports.MsgSetSendEnabledResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ff872d712a668d44$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ff872d712a668d44$var$_m0.Reader ? input : new $ff872d712a668d44$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ff872d712a668d44$var$createBaseMsgSetSendEnabledResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $ff872d712a668d44$var$createBaseMsgSetSendEnabledResponse();
        return message;
    }
};
var $ff872d712a668d44$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "Send",
            value: function Send(request) {
                var data = $ff872d712a668d44$exports.MsgSend.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
                return promise.then(function(data) {
                    return $ff872d712a668d44$exports.MsgSendResponse.decode(new $ff872d712a668d44$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "MultiSend",
            value: function MultiSend(request) {
                var data = $ff872d712a668d44$exports.MsgMultiSend.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
                return promise.then(function(data) {
                    return $ff872d712a668d44$exports.MsgMultiSendResponse.decode(new $ff872d712a668d44$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateParams",
            value: function UpdateParams(request) {
                var data = $ff872d712a668d44$exports.MsgUpdateParams.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", data);
                return promise.then(function(data) {
                    return $ff872d712a668d44$exports.MsgUpdateParamsResponse.decode(new $ff872d712a668d44$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SetSendEnabled",
            value: function SetSendEnabled(request) {
                var data = $ff872d712a668d44$exports.MsgSetSendEnabled.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", data);
                return promise.then(function(data) {
                    return $ff872d712a668d44$exports.MsgSetSendEnabledResponse.decode(new $ff872d712a668d44$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$ff872d712a668d44$exports.MsgClientImpl = $ff872d712a668d44$var$MsgClientImpl;





var $DM7bi = parcelRequire("DM7bi");
function $bab49d397fbc580a$var$isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
$bab49d397fbc580a$exports.isTsProtoGeneratedType = $bab49d397fbc580a$var$isTsProtoGeneratedType;
function $bab49d397fbc580a$var$isPbjsGeneratedType(type) {
    return !$bab49d397fbc580a$var$isTsProtoGeneratedType(type);
}
$bab49d397fbc580a$exports.isPbjsGeneratedType = $bab49d397fbc580a$var$isPbjsGeneratedType;
var $bab49d397fbc580a$var$defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any"
};
function $bab49d397fbc580a$var$isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
$bab49d397fbc580a$exports.isTxBodyEncodeObject = $bab49d397fbc580a$var$isTxBodyEncodeObject;
var $bab49d397fbc580a$var$Registry = /*#__PURE__*/ function() {
    "use strict";
    function Registry(customTypes) {
        (0, $7dKN1._)(this, Registry);
        var cosmosCoin = $bab49d397fbc580a$var$defaultTypeUrls.cosmosCoin, cosmosMsgSend = $bab49d397fbc580a$var$defaultTypeUrls.cosmosMsgSend;
        this.types = customTypes ? new Map((0, $gF0bR._)(customTypes)) : new Map([
            [
                cosmosCoin,
                $5bc8eb379b028930$exports.Coin
            ],
            [
                cosmosMsgSend,
                $ff872d712a668d44$exports.MsgSend
            ]
        ]);
    }
    (0, $eW5pA._)(Registry, [
        {
            key: "register",
            value: function register(typeUrl, type) {
                this.types.set(typeUrl, type);
            }
        },
        {
            /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */ key: "lookupType",
            value: function lookupType(typeUrl) {
                return this.types.get(typeUrl);
            }
        },
        {
            key: "lookupTypeWithError",
            value: function lookupTypeWithError(typeUrl) {
                var type = this.lookupType(typeUrl);
                if (!type) throw new Error("Unregistered type url: ".concat(typeUrl));
                return type;
            }
        },
        {
            /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */ key: "encode",
            value: function encode(encodeObject) {
                var value = encodeObject.value, typeUrl = encodeObject.typeUrl;
                if ($bab49d397fbc580a$var$isTxBodyEncodeObject(encodeObject)) return this.encodeTxBody(value);
                var type = this.lookupTypeWithError(typeUrl);
                var instance = $bab49d397fbc580a$var$isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
                return type.encode(instance).finish();
            }
        },
        {
            /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */ key: "encodeAsAny",
            value: function encodeAsAny(encodeObject) {
                var binaryValue = this.encode(encodeObject);
                return $DM7bi.Any.fromPartial({
                    typeUrl: encodeObject.typeUrl,
                    value: binaryValue
                });
            }
        },
        {
            key: "encodeTxBody",
            value: function encodeTxBody(txBodyFields) {
                var _this = this;
                var wrappedMessages = txBodyFields.messages.map(function(message) {
                    return _this.encodeAsAny(message);
                });
                var txBody = $540f96552e476ffb$exports.TxBody.fromPartial((0, $gddcW._)((0, $4JCw4._)({}, txBodyFields), {
                    messages: wrappedMessages
                }));
                return $540f96552e476ffb$exports.TxBody.encode(txBody).finish();
            }
        },
        {
            key: "decode",
            value: function decode(param) {
                var typeUrl = param.typeUrl, value = param.value;
                if (typeUrl === $bab49d397fbc580a$var$defaultTypeUrls.cosmosTxBody) return this.decodeTxBody(value);
                var type = this.lookupTypeWithError(typeUrl);
                var decoded = type.decode(value);
                Object.entries(decoded).forEach(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), key = _param[0], val = _param[1];
                    if (typeof $bab49d397fbc580a$require$Buffer !== "undefined" && typeof $bab49d397fbc580a$require$Buffer.isBuffer !== "undefined" && $bab49d397fbc580a$require$Buffer.isBuffer(val)) decoded[key] = Uint8Array.from(val);
                });
                return decoded;
            }
        },
        {
            key: "decodeTxBody",
            value: function decodeTxBody(txBody) {
                var _this = this;
                var decodedTxBody = $540f96552e476ffb$exports.TxBody.decode(txBody);
                return (0, $gddcW._)((0, $4JCw4._)({}, decodedTxBody), {
                    messages: decodedTxBody.messages.map(function(param) {
                        var typeUrl = param.typeUrl, value = param.value;
                        if (!typeUrl) throw new Error("Missing type_url in Any");
                        if (!value) throw new Error("Missing value in Any");
                        return _this.decode({
                            typeUrl: typeUrl,
                            value: value
                        });
                    })
                });
            }
        }
    ]);
    return Registry;
}();
$bab49d397fbc580a$exports.Registry = $bab49d397fbc580a$var$Registry;


Object.defineProperty($ff811d56e12ad916$exports, "isPbjsGeneratedType", {
    enumerable: true,
    get: function get() {
        return $bab49d397fbc580a$exports.isPbjsGeneratedType;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "isTsProtoGeneratedType", {
    enumerable: true,
    get: function get() {
        return $bab49d397fbc580a$exports.isTsProtoGeneratedType;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "isTxBodyEncodeObject", {
    enumerable: true,
    get: function get() {
        return $bab49d397fbc580a$exports.isTxBodyEncodeObject;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "Registry", {
    enumerable: true,
    get: function get() {
        return $bab49d397fbc580a$exports.Registry;
    }
});
var $d237dd201bf6fe90$exports = {};
"use strict";
Object.defineProperty($d237dd201bf6fe90$exports, "__esModule", {
    value: true
});
$d237dd201bf6fe90$exports.isOfflineDirectSigner = void 0;
function $d237dd201bf6fe90$var$isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
$d237dd201bf6fe90$exports.isOfflineDirectSigner = $d237dd201bf6fe90$var$isOfflineDirectSigner;


Object.defineProperty($ff811d56e12ad916$exports, "isOfflineDirectSigner", {
    enumerable: true,
    get: function get() {
        return $d237dd201bf6fe90$exports.isOfflineDirectSigner;
    }
});

Object.defineProperty($ff811d56e12ad916$exports, "makeAuthInfoBytes", {
    enumerable: true,
    get: function get() {
        return $f83140bf11d5189d$exports.makeAuthInfoBytes;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "makeSignBytes", {
    enumerable: true,
    get: function get() {
        return $f83140bf11d5189d$exports.makeSignBytes;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "makeSignDoc", {
    enumerable: true,
    get: function get() {
        return $f83140bf11d5189d$exports.makeSignDoc;
    }
});

Object.defineProperty($ff811d56e12ad916$exports, "executeKdf", {
    enumerable: true,
    get: function get() {
        return $7e370796687cd2fb$exports.executeKdf;
    }
});

Object.defineProperty($ff811d56e12ad916$exports, "coin", {
    enumerable: true,
    get: function get() {
        return $c9b9a1a428003423$exports.coin;
    }
});
Object.defineProperty($ff811d56e12ad916$exports, "coins", {
    enumerable: true,
    get: function get() {
        return $c9b9a1a428003423$exports.coins;
    }
});



var $gMk5u = parcelRequire("gMk5u");
var $9d74bd5a035f28b2$exports = {};
"use strict";
var $9d74bd5a035f28b2$var$__createBinding = $9d74bd5a035f28b2$exports && $9d74bd5a035f28b2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9d74bd5a035f28b2$var$__setModuleDefault = $9d74bd5a035f28b2$exports && $9d74bd5a035f28b2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9d74bd5a035f28b2$var$__importStar = $9d74bd5a035f28b2$exports && $9d74bd5a035f28b2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9d74bd5a035f28b2$var$__createBinding(result, mod, k);
    }
    $9d74bd5a035f28b2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($9d74bd5a035f28b2$exports, "__esModule", {
    value: true
});
$9d74bd5a035f28b2$exports.Params = $9d74bd5a035f28b2$exports.ModuleCredential = $9d74bd5a035f28b2$exports.ModuleAccount = $9d74bd5a035f28b2$exports.BaseAccount = $9d74bd5a035f28b2$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $9d74bd5a035f28b2$var$_m0 = $9d74bd5a035f28b2$var$__importStar((parcelRequire("hjb8Q")));
$9d74bd5a035f28b2$exports.protobufPackage = "cosmos.auth.v1beta1";
function $9d74bd5a035f28b2$var$createBaseBaseAccount() {
    return {
        address: "",
        pubKey: undefined,
        accountNumber: $7iZIe.Long.UZERO,
        sequence: $7iZIe.Long.UZERO
    };
}
$9d74bd5a035f28b2$exports.BaseAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9d74bd5a035f28b2$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $DM7bi.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $9d74bd5a035f28b2$var$_m0.Reader ? input : new $9d74bd5a035f28b2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $9d74bd5a035f28b2$var$createBaseBaseAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            pubKey: (0, $7iZIe.isSet)(object.pubKey) ? $DM7bi.Any.fromJSON(object.pubKey) : undefined,
            accountNumber: (0, $7iZIe.isSet)(object.accountNumber) ? $7iZIe.Long.fromValue(object.accountNumber) : $7iZIe.Long.UZERO,
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $DM7bi.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $7iZIe.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $9d74bd5a035f28b2$var$createBaseBaseAccount();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $DM7bi.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $7iZIe.Long.fromValue(object.accountNumber) : $7iZIe.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $9d74bd5a035f28b2$var$createBaseModuleAccount() {
    return {
        baseAccount: undefined,
        name: "",
        permissions: []
    };
}
$9d74bd5a035f28b2$exports.ModuleAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9d74bd5a035f28b2$var$_m0.Writer.create();
        if (message.baseAccount !== undefined) $9d74bd5a035f28b2$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.permissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(26).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $9d74bd5a035f28b2$var$_m0.Reader ? input : new $9d74bd5a035f28b2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $9d74bd5a035f28b2$var$createBaseModuleAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $9d74bd5a035f28b2$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            baseAccount: (0, $7iZIe.isSet)(object.baseAccount) ? $9d74bd5a035f28b2$exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            name: (0, $7iZIe.isSet)(object.name) ? String(object.name) : "",
            permissions: Array.isArray(object === null || object === void 0 ? void 0 : object.permissions) ? object.permissions.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $9d74bd5a035f28b2$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map(function(e) {
            return e;
        });
        else obj.permissions = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_permissions;
        var message = $9d74bd5a035f28b2$var$createBaseModuleAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $9d74bd5a035f28b2$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        var _object_name;
        message.name = (_object_name = object.name) !== null && _object_name !== void 0 ? _object_name : "";
        message.permissions = ((_object_permissions = object.permissions) === null || _object_permissions === void 0 ? void 0 : _object_permissions.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $9d74bd5a035f28b2$var$createBaseModuleCredential() {
    return {
        moduleName: "",
        derivationKeys: []
    };
}
$9d74bd5a035f28b2$exports.ModuleCredential = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9d74bd5a035f28b2$var$_m0.Writer.create();
        if (message.moduleName !== "") writer.uint32(10).string(message.moduleName);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.derivationKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(18).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $9d74bd5a035f28b2$var$_m0.Reader ? input : new $9d74bd5a035f28b2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $9d74bd5a035f28b2$var$createBaseModuleCredential();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moduleName = reader.string();
                    break;
                case 2:
                    message.derivationKeys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            moduleName: (0, $7iZIe.isSet)(object.moduleName) ? String(object.moduleName) : "",
            derivationKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.derivationKeys) ? object.derivationKeys.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.moduleName !== undefined && (obj.moduleName = message.moduleName);
        if (message.derivationKeys) obj.derivationKeys = message.derivationKeys.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.derivationKeys = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_derivationKeys;
        var message = $9d74bd5a035f28b2$var$createBaseModuleCredential();
        var _object_moduleName;
        message.moduleName = (_object_moduleName = object.moduleName) !== null && _object_moduleName !== void 0 ? _object_moduleName : "";
        message.derivationKeys = ((_object_derivationKeys = object.derivationKeys) === null || _object_derivationKeys === void 0 ? void 0 : _object_derivationKeys.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $9d74bd5a035f28b2$var$createBaseParams() {
    return {
        maxMemoCharacters: $7iZIe.Long.UZERO,
        txSigLimit: $7iZIe.Long.UZERO,
        txSizeCostPerByte: $7iZIe.Long.UZERO,
        sigVerifyCostEd25519: $7iZIe.Long.UZERO,
        sigVerifyCostSecp256k1: $7iZIe.Long.UZERO
    };
}
$9d74bd5a035f28b2$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9d74bd5a035f28b2$var$_m0.Writer.create();
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $9d74bd5a035f28b2$var$_m0.Reader ? input : new $9d74bd5a035f28b2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $9d74bd5a035f28b2$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            maxMemoCharacters: (0, $7iZIe.isSet)(object.maxMemoCharacters) ? $7iZIe.Long.fromValue(object.maxMemoCharacters) : $7iZIe.Long.UZERO,
            txSigLimit: (0, $7iZIe.isSet)(object.txSigLimit) ? $7iZIe.Long.fromValue(object.txSigLimit) : $7iZIe.Long.UZERO,
            txSizeCostPerByte: (0, $7iZIe.isSet)(object.txSizeCostPerByte) ? $7iZIe.Long.fromValue(object.txSizeCostPerByte) : $7iZIe.Long.UZERO,
            sigVerifyCostEd25519: (0, $7iZIe.isSet)(object.sigVerifyCostEd25519) ? $7iZIe.Long.fromValue(object.sigVerifyCostEd25519) : $7iZIe.Long.UZERO,
            sigVerifyCostSecp256k1: (0, $7iZIe.isSet)(object.sigVerifyCostSecp256k1) ? $7iZIe.Long.fromValue(object.sigVerifyCostSecp256k1) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $7iZIe.Long.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $7iZIe.Long.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $7iZIe.Long.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $7iZIe.Long.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $9d74bd5a035f28b2$var$createBaseParams();
        message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? $7iZIe.Long.fromValue(object.maxMemoCharacters) : $7iZIe.Long.UZERO;
        message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? $7iZIe.Long.fromValue(object.txSigLimit) : $7iZIe.Long.UZERO;
        message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? $7iZIe.Long.fromValue(object.txSizeCostPerByte) : $7iZIe.Long.UZERO;
        message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? $7iZIe.Long.fromValue(object.sigVerifyCostEd25519) : $7iZIe.Long.UZERO;
        message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? $7iZIe.Long.fromValue(object.sigVerifyCostSecp256k1) : $7iZIe.Long.UZERO;
        return message;
    }
};


var $b4b5bd98e8da940b$exports = {};
"use strict";
var $b4b5bd98e8da940b$var$__createBinding = $b4b5bd98e8da940b$exports && $b4b5bd98e8da940b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b4b5bd98e8da940b$var$__setModuleDefault = $b4b5bd98e8da940b$exports && $b4b5bd98e8da940b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b4b5bd98e8da940b$var$__importStar = $b4b5bd98e8da940b$exports && $b4b5bd98e8da940b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b4b5bd98e8da940b$var$__createBinding(result, mod, k);
    }
    $b4b5bd98e8da940b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b4b5bd98e8da940b$exports, "__esModule", {
    value: true
});
$b4b5bd98e8da940b$exports.PermanentLockedAccount = $b4b5bd98e8da940b$exports.PeriodicVestingAccount = $b4b5bd98e8da940b$exports.Period = $b4b5bd98e8da940b$exports.DelayedVestingAccount = $b4b5bd98e8da940b$exports.ContinuousVestingAccount = $b4b5bd98e8da940b$exports.BaseVestingAccount = $b4b5bd98e8da940b$exports.protobufPackage = void 0;



var $7iZIe = parcelRequire("7iZIe");

var $b4b5bd98e8da940b$var$_m0 = $b4b5bd98e8da940b$var$__importStar((parcelRequire("hjb8Q")));
$b4b5bd98e8da940b$exports.protobufPackage = "cosmos.vesting.v1beta1";
function $b4b5bd98e8da940b$var$createBaseBaseVestingAccount() {
    return {
        baseAccount: undefined,
        originalVesting: [],
        delegatedFree: [],
        delegatedVesting: [],
        endTime: $7iZIe.Long.ZERO
    };
}
$b4b5bd98e8da940b$exports.BaseVestingAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b4b5bd98e8da940b$var$_m0.Writer.create();
        if (message.baseAccount !== undefined) $9d74bd5a035f28b2$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.originalVesting[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.delegatedFree[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $5bc8eb379b028930$exports.Coin.encode(v1, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = message.delegatedVesting[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var v2 = _step2.value;
                $5bc8eb379b028930$exports.Coin.encode(v2, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b4b5bd98e8da940b$var$_m0.Reader ? input : new $b4b5bd98e8da940b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b4b5bd98e8da940b$var$createBaseBaseVestingAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $9d74bd5a035f28b2$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            baseAccount: (0, $7iZIe.isSet)(object.baseAccount) ? $9d74bd5a035f28b2$exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            originalVesting: Array.isArray(object === null || object === void 0 ? void 0 : object.originalVesting) ? object.originalVesting.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            delegatedFree: Array.isArray(object === null || object === void 0 ? void 0 : object.delegatedFree) ? object.delegatedFree.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            delegatedVesting: Array.isArray(object === null || object === void 0 ? void 0 : object.delegatedVesting) ? object.delegatedVesting.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            endTime: (0, $7iZIe.isSet)(object.endTime) ? $7iZIe.Long.fromValue(object.endTime) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $9d74bd5a035f28b2$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_originalVesting, _object_delegatedFree, _object_delegatedVesting;
        var message = $b4b5bd98e8da940b$var$createBaseBaseVestingAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $9d74bd5a035f28b2$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.originalVesting = ((_object_originalVesting = object.originalVesting) === null || _object_originalVesting === void 0 ? void 0 : _object_originalVesting.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.delegatedFree = ((_object_delegatedFree = object.delegatedFree) === null || _object_delegatedFree === void 0 ? void 0 : _object_delegatedFree.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.delegatedVesting = ((_object_delegatedVesting = object.delegatedVesting) === null || _object_delegatedVesting === void 0 ? void 0 : _object_delegatedVesting.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $7iZIe.Long.fromValue(object.endTime) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $b4b5bd98e8da940b$var$createBaseContinuousVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $7iZIe.Long.ZERO
    };
}
$b4b5bd98e8da940b$exports.ContinuousVestingAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b4b5bd98e8da940b$var$_m0.Writer.create();
        if (message.baseVestingAccount !== undefined) $b4b5bd98e8da940b$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b4b5bd98e8da940b$var$_m0.Reader ? input : new $b4b5bd98e8da940b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b4b5bd98e8da940b$var$createBaseContinuousVestingAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $b4b5bd98e8da940b$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            baseVestingAccount: (0, $7iZIe.isSet)(object.baseVestingAccount) ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $7iZIe.isSet)(object.startTime) ? $7iZIe.Long.fromValue(object.startTime) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $b4b5bd98e8da940b$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $b4b5bd98e8da940b$var$createBaseContinuousVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $7iZIe.Long.fromValue(object.startTime) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $b4b5bd98e8da940b$var$createBaseDelayedVestingAccount() {
    return {
        baseVestingAccount: undefined
    };
}
$b4b5bd98e8da940b$exports.DelayedVestingAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b4b5bd98e8da940b$var$_m0.Writer.create();
        if (message.baseVestingAccount !== undefined) $b4b5bd98e8da940b$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b4b5bd98e8da940b$var$_m0.Reader ? input : new $b4b5bd98e8da940b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b4b5bd98e8da940b$var$createBaseDelayedVestingAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $b4b5bd98e8da940b$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            baseVestingAccount: (0, $7iZIe.isSet)(object.baseVestingAccount) ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $b4b5bd98e8da940b$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b4b5bd98e8da940b$var$createBaseDelayedVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};
function $b4b5bd98e8da940b$var$createBasePeriod() {
    return {
        length: $7iZIe.Long.ZERO,
        amount: []
    };
}
$b4b5bd98e8da940b$exports.Period = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b4b5bd98e8da940b$var$_m0.Writer.create();
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b4b5bd98e8da940b$var$_m0.Reader ? input : new $b4b5bd98e8da940b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b4b5bd98e8da940b$var$createBasePeriod();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            length: (0, $7iZIe.isSet)(object.length) ? $7iZIe.Long.fromValue(object.length) : $7iZIe.Long.ZERO,
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.length !== undefined && (obj.length = (message.length || $7iZIe.Long.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $b4b5bd98e8da940b$var$createBasePeriod();
        message.length = object.length !== undefined && object.length !== null ? $7iZIe.Long.fromValue(object.length) : $7iZIe.Long.ZERO;
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $b4b5bd98e8da940b$var$createBasePeriodicVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $7iZIe.Long.ZERO,
        vestingPeriods: []
    };
}
$b4b5bd98e8da940b$exports.PeriodicVestingAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b4b5bd98e8da940b$var$_m0.Writer.create();
        if (message.baseVestingAccount !== undefined) $b4b5bd98e8da940b$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.vestingPeriods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $b4b5bd98e8da940b$exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b4b5bd98e8da940b$var$_m0.Reader ? input : new $b4b5bd98e8da940b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b4b5bd98e8da940b$var$createBasePeriodicVestingAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $b4b5bd98e8da940b$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push($b4b5bd98e8da940b$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            baseVestingAccount: (0, $7iZIe.isSet)(object.baseVestingAccount) ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $7iZIe.isSet)(object.startTime) ? $7iZIe.Long.fromValue(object.startTime) : $7iZIe.Long.ZERO,
            vestingPeriods: Array.isArray(object === null || object === void 0 ? void 0 : object.vestingPeriods) ? object.vestingPeriods.map(function(e) {
                return $b4b5bd98e8da940b$exports.Period.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $b4b5bd98e8da940b$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $7iZIe.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map(function(e) {
            return e ? $b4b5bd98e8da940b$exports.Period.toJSON(e) : undefined;
        });
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_vestingPeriods;
        var message = $b4b5bd98e8da940b$var$createBasePeriodicVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $7iZIe.Long.fromValue(object.startTime) : $7iZIe.Long.ZERO;
        message.vestingPeriods = ((_object_vestingPeriods = object.vestingPeriods) === null || _object_vestingPeriods === void 0 ? void 0 : _object_vestingPeriods.map(function(e) {
            return $b4b5bd98e8da940b$exports.Period.fromPartial(e);
        })) || [];
        return message;
    }
};
function $b4b5bd98e8da940b$var$createBasePermanentLockedAccount() {
    return {
        baseVestingAccount: undefined
    };
}
$b4b5bd98e8da940b$exports.PermanentLockedAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b4b5bd98e8da940b$var$_m0.Writer.create();
        if (message.baseVestingAccount !== undefined) $b4b5bd98e8da940b$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b4b5bd98e8da940b$var$_m0.Reader ? input : new $b4b5bd98e8da940b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b4b5bd98e8da940b$var$createBasePermanentLockedAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $b4b5bd98e8da940b$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            baseVestingAccount: (0, $7iZIe.isSet)(object.baseVestingAccount) ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $b4b5bd98e8da940b$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b4b5bd98e8da940b$var$createBasePermanentLockedAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $b4b5bd98e8da940b$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};


function $99afcd2e4c2331d7$var$uint64FromProto(input) {
    return $kTbgy.Uint64.fromString(input.toString());
}
function $99afcd2e4c2331d7$var$accountFromBaseAccount(input) {
    var address = input.address, pubKey = input.pubKey, accountNumber = input.accountNumber, sequence = input.sequence;
    var pubkey = pubKey ? (0, $ff811d56e12ad916$exports.decodePubkey)(pubKey) : null;
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: $99afcd2e4c2331d7$var$uint64FromProto(accountNumber).toNumber(),
        sequence: $99afcd2e4c2331d7$var$uint64FromProto(sequence).toNumber()
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */ function $99afcd2e4c2331d7$var$accountFromAny(input) {
    var typeUrl = input.typeUrl, value = input.value;
    switch(typeUrl){
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return $99afcd2e4c2331d7$var$accountFromBaseAccount($9d74bd5a035f28b2$exports.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount":
            {
                var baseAccount = $9d74bd5a035f28b2$exports.ModuleAccount.decode(value).baseAccount;
                (0, $gMk5u.assert)(baseAccount);
                return $99afcd2e4c2331d7$var$accountFromBaseAccount(baseAccount);
            }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
            {
                var _vesting_1_BaseVestingAccount_decode;
                var baseAccount1 = (_vesting_1_BaseVestingAccount_decode = $b4b5bd98e8da940b$exports.BaseVestingAccount.decode(value)) === null || _vesting_1_BaseVestingAccount_decode === void 0 ? void 0 : _vesting_1_BaseVestingAccount_decode.baseAccount;
                (0, $gMk5u.assert)(baseAccount1);
                return $99afcd2e4c2331d7$var$accountFromBaseAccount(baseAccount1);
            }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
            {
                var _vesting_1_ContinuousVestingAccount_decode_baseVestingAccount, _vesting_1_ContinuousVestingAccount_decode;
                var baseAccount2 = (_vesting_1_ContinuousVestingAccount_decode = $b4b5bd98e8da940b$exports.ContinuousVestingAccount.decode(value)) === null || _vesting_1_ContinuousVestingAccount_decode === void 0 ? void 0 : (_vesting_1_ContinuousVestingAccount_decode_baseVestingAccount = _vesting_1_ContinuousVestingAccount_decode.baseVestingAccount) === null || _vesting_1_ContinuousVestingAccount_decode_baseVestingAccount === void 0 ? void 0 : _vesting_1_ContinuousVestingAccount_decode_baseVestingAccount.baseAccount;
                (0, $gMk5u.assert)(baseAccount2);
                return $99afcd2e4c2331d7$var$accountFromBaseAccount(baseAccount2);
            }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
            {
                var _vesting_1_DelayedVestingAccount_decode_baseVestingAccount, _vesting_1_DelayedVestingAccount_decode;
                var baseAccount3 = (_vesting_1_DelayedVestingAccount_decode = $b4b5bd98e8da940b$exports.DelayedVestingAccount.decode(value)) === null || _vesting_1_DelayedVestingAccount_decode === void 0 ? void 0 : (_vesting_1_DelayedVestingAccount_decode_baseVestingAccount = _vesting_1_DelayedVestingAccount_decode.baseVestingAccount) === null || _vesting_1_DelayedVestingAccount_decode_baseVestingAccount === void 0 ? void 0 : _vesting_1_DelayedVestingAccount_decode_baseVestingAccount.baseAccount;
                (0, $gMk5u.assert)(baseAccount3);
                return $99afcd2e4c2331d7$var$accountFromBaseAccount(baseAccount3);
            }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
            {
                var _vesting_1_PeriodicVestingAccount_decode_baseVestingAccount, _vesting_1_PeriodicVestingAccount_decode;
                var baseAccount4 = (_vesting_1_PeriodicVestingAccount_decode = $b4b5bd98e8da940b$exports.PeriodicVestingAccount.decode(value)) === null || _vesting_1_PeriodicVestingAccount_decode === void 0 ? void 0 : (_vesting_1_PeriodicVestingAccount_decode_baseVestingAccount = _vesting_1_PeriodicVestingAccount_decode.baseVestingAccount) === null || _vesting_1_PeriodicVestingAccount_decode_baseVestingAccount === void 0 ? void 0 : _vesting_1_PeriodicVestingAccount_decode_baseVestingAccount.baseAccount;
                (0, $gMk5u.assert)(baseAccount4);
                return $99afcd2e4c2331d7$var$accountFromBaseAccount(baseAccount4);
            }
        default:
            throw new Error("Unsupported type: '".concat(typeUrl, "'"));
    }
}
$99afcd2e4c2331d7$exports.accountFromAny = $99afcd2e4c2331d7$var$accountFromAny;


Object.defineProperty($3e8bd88d734bad5a$exports, "accountFromAny", {
    enumerable: true,
    get: function get() {
        return $99afcd2e4c2331d7$exports.accountFromAny;
    }
});
var $0d8e1021775d5d34$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");
"use strict";
Object.defineProperty($0d8e1021775d5d34$exports, "__esModule", {
    value: true
});
$0d8e1021775d5d34$exports.AminoTypes = void 0;
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */ var $0d8e1021775d5d34$var$AminoTypes = /*#__PURE__*/ function() {
    function AminoTypes(types) {
        (0, $7dKN1._)(this, AminoTypes);
        this.register = types;
    }
    (0, $eW5pA._)(AminoTypes, [
        {
            key: "toAmino",
            value: function toAmino(param) {
                var typeUrl = param.typeUrl, value = param.value;
                var converter = this.register[typeUrl];
                if (!converter) throw new Error("Type URL '".concat(typeUrl, "' does not exist in the Amino message type register. ") + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
                return {
                    type: converter.aminoType,
                    value: converter.toAmino(value)
                };
            }
        },
        {
            key: "fromAmino",
            value: function fromAmino(param) {
                var type = param.type, value = param.value;
                var matches = Object.entries(this.register).filter(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), _typeUrl = _param[0], aminoType = _param[1].aminoType;
                    return aminoType === type;
                });
                switch(matches.length){
                    case 0:
                        throw new Error("Amino type identifier '".concat(type, "' does not exist in the Amino message type register. ") + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
                    case 1:
                        {
                            var _matches_ = (0, $5OlIx._)(matches[0], 2), typeUrl = _matches_[0], converter = _matches_[1];
                            return {
                                typeUrl: typeUrl,
                                value: converter.fromAmino(value)
                            };
                        }
                    default:
                        throw new Error("Multiple types are registered with Amino type identifier '".concat(type, "': '") + matches.map(function(param) {
                            var _param = (0, $5OlIx._)(param, 2), key = _param[0], _value = _param[1];
                            return key;
                        }).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
                }
            }
        }
    ]);
    return AminoTypes;
}();
$0d8e1021775d5d34$exports.AminoTypes = $0d8e1021775d5d34$var$AminoTypes;


Object.defineProperty($3e8bd88d734bad5a$exports, "AminoTypes", {
    enumerable: true,
    get: function get() {
        return $0d8e1021775d5d34$exports.AminoTypes;
    }
});
var $27f242075526edb1$exports = {};
"use strict";
Object.defineProperty($27f242075526edb1$exports, "__esModule", {
    value: true
});
$27f242075526edb1$exports.fromTendermintEvent = void 0;

var $lSA9E = parcelRequire("lSA9E");
/**
 * Takes a Tendermint 0.34 or 0.37 event with binary encoded key and value
 * and converts it into an `Event` with string attributes.
 */ function $27f242075526edb1$var$fromTendermintEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes.map(function(attr) {
            return {
                key: typeof attr.key == "string" ? attr.key : (0, $lSA9E.fromUtf8)(attr.key, true),
                value: typeof attr.value == "string" ? attr.value : (0, $lSA9E.fromUtf8)(attr.value, true)
            };
        })
    };
}
$27f242075526edb1$exports.fromTendermintEvent = $27f242075526edb1$var$fromTendermintEvent;


Object.defineProperty($3e8bd88d734bad5a$exports, "fromTendermintEvent", {
    enumerable: true,
    get: function get() {
        return $27f242075526edb1$exports.fromTendermintEvent;
    }
});
var $fdc4d1c1d72f53dc$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");
"use strict";
Object.defineProperty($fdc4d1c1d72f53dc$exports, "__esModule", {
    value: true
});
$fdc4d1c1d72f53dc$exports.calculateFee = $fdc4d1c1d72f53dc$exports.GasPrice = void 0;

var $kTbgy = parcelRequire("kTbgy");

/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */ function $fdc4d1c1d72f53dc$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) throw new Error("Denom must be between 3 and 128 characters");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ var $fdc4d1c1d72f53dc$var$GasPrice = /*#__PURE__*/ function() {
    function GasPrice(amount, denom) {
        (0, $7dKN1._)(this, GasPrice);
        this.amount = amount;
        this.denom = denom;
    }
    (0, $eW5pA._)(GasPrice, [
        {
            /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */ key: "toString",
            value: function toString() {
                return this.amount.toString() + this.denom;
            }
        }
    ], [
        {
            key: "fromString",
            value: /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */ function fromString(gasPrice) {
                // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
                var matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
                if (!matchResult) throw new Error("Invalid gas price string");
                var _matchResult = (0, $5OlIx._)(matchResult, 3), _ = _matchResult[0], amount = _matchResult[1], denom = _matchResult[2];
                $fdc4d1c1d72f53dc$var$checkDenom(denom);
                var fractionalDigits = 18;
                var decimalAmount = $kTbgy.Decimal.fromUserInput(amount, fractionalDigits);
                return new GasPrice(decimalAmount, denom);
            }
        }
    ]);
    return GasPrice;
}();
$fdc4d1c1d72f53dc$exports.GasPrice = $fdc4d1c1d72f53dc$var$GasPrice;
function $fdc4d1c1d72f53dc$var$calculateFee(gasLimit, gasPrice) {
    var processedGasPrice = typeof gasPrice === "string" ? $fdc4d1c1d72f53dc$var$GasPrice.fromString(gasPrice) : gasPrice;
    var denom = processedGasPrice.denom, gasPriceAmount = processedGasPrice.amount;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    var amount = gasPriceAmount.multiply(new $kTbgy.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, $ff811d56e12ad916$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
$fdc4d1c1d72f53dc$exports.calculateFee = $fdc4d1c1d72f53dc$var$calculateFee;


Object.defineProperty($3e8bd88d734bad5a$exports, "calculateFee", {
    enumerable: true,
    get: function get() {
        return $fdc4d1c1d72f53dc$exports.calculateFee;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "GasPrice", {
    enumerable: true,
    get: function get() {
        return $fdc4d1c1d72f53dc$exports.GasPrice;
    }
});

$3e8bd88d734bad5a$exports.logs = $3e8bd88d734bad5a$var$__importStar((parcelRequire("3C2w0")));
var $0aaecf7be71ff9a4$exports = {};
"use strict";
Object.defineProperty($0aaecf7be71ff9a4$exports, "__esModule", {
    value: true
});
$0aaecf7be71ff9a4$exports.isAminoMsgCreateValidator = $0aaecf7be71ff9a4$exports.isAminoMsgBeginRedelegate = $0aaecf7be71ff9a4$exports.createStakingAminoConverters = $0aaecf7be71ff9a4$exports.setupSlashingExtension = $0aaecf7be71ff9a4$exports.isAminoMsgUnjail = $0aaecf7be71ff9a4$exports.createSlashingAminoConverters = $0aaecf7be71ff9a4$exports.setupMintExtension = $0aaecf7be71ff9a4$exports.setupIbcExtension = $0aaecf7be71ff9a4$exports.isMsgTransferEncodeObject = $0aaecf7be71ff9a4$exports.ibcTypes = $0aaecf7be71ff9a4$exports.isAminoMsgTransfer = $0aaecf7be71ff9a4$exports.createIbcAminoConverters = $0aaecf7be71ff9a4$exports.groupTypes = $0aaecf7be71ff9a4$exports.createGroupAminoConverters = $0aaecf7be71ff9a4$exports.setupGovExtension = $0aaecf7be71ff9a4$exports.isMsgVoteWeightedEncodeObject = $0aaecf7be71ff9a4$exports.isMsgVoteEncodeObject = $0aaecf7be71ff9a4$exports.isMsgSubmitProposalEncodeObject = $0aaecf7be71ff9a4$exports.isMsgDepositEncodeObject = $0aaecf7be71ff9a4$exports.govTypes = $0aaecf7be71ff9a4$exports.isAminoMsgVoteWeighted = $0aaecf7be71ff9a4$exports.isAminoMsgVote = $0aaecf7be71ff9a4$exports.isAminoMsgSubmitProposal = $0aaecf7be71ff9a4$exports.isAminoMsgDeposit = $0aaecf7be71ff9a4$exports.createGovAminoConverters = $0aaecf7be71ff9a4$exports.setupFeegrantExtension = $0aaecf7be71ff9a4$exports.feegrantTypes = $0aaecf7be71ff9a4$exports.createFeegrantAminoConverters = $0aaecf7be71ff9a4$exports.isAminoMsgSubmitEvidence = $0aaecf7be71ff9a4$exports.createEvidenceAminoConverters = $0aaecf7be71ff9a4$exports.setupDistributionExtension = $0aaecf7be71ff9a4$exports.isMsgWithdrawDelegatorRewardEncodeObject = $0aaecf7be71ff9a4$exports.distributionTypes = $0aaecf7be71ff9a4$exports.isAminoMsgWithdrawValidatorCommission = $0aaecf7be71ff9a4$exports.isAminoMsgWithdrawDelegatorReward = $0aaecf7be71ff9a4$exports.isAminoMsgSetWithdrawAddress = $0aaecf7be71ff9a4$exports.isAminoMsgFundCommunityPool = $0aaecf7be71ff9a4$exports.createDistributionAminoConverters = $0aaecf7be71ff9a4$exports.isAminoMsgVerifyInvariant = $0aaecf7be71ff9a4$exports.createCrysisAminoConverters = $0aaecf7be71ff9a4$exports.setupBankExtension = $0aaecf7be71ff9a4$exports.isMsgSendEncodeObject = $0aaecf7be71ff9a4$exports.bankTypes = $0aaecf7be71ff9a4$exports.isAminoMsgSend = $0aaecf7be71ff9a4$exports.isAminoMsgMultiSend = $0aaecf7be71ff9a4$exports.createBankAminoConverters = $0aaecf7be71ff9a4$exports.setupAuthzExtension = $0aaecf7be71ff9a4$exports.authzTypes = $0aaecf7be71ff9a4$exports.createAuthzAminoConverters = $0aaecf7be71ff9a4$exports.setupAuthExtension = void 0;
$0aaecf7be71ff9a4$exports.vestingTypes = $0aaecf7be71ff9a4$exports.isAminoMsgCreateVestingAccount = $0aaecf7be71ff9a4$exports.createVestingAminoConverters = $0aaecf7be71ff9a4$exports.setupTxExtension = $0aaecf7be71ff9a4$exports.setupStakingExtension = $0aaecf7be71ff9a4$exports.stakingTypes = $0aaecf7be71ff9a4$exports.isMsgUndelegateEncodeObject = $0aaecf7be71ff9a4$exports.isMsgEditValidatorEncodeObject = $0aaecf7be71ff9a4$exports.isMsgDelegateEncodeObject = $0aaecf7be71ff9a4$exports.isMsgCreateValidatorEncodeObject = $0aaecf7be71ff9a4$exports.isMsgBeginRedelegateEncodeObject = $0aaecf7be71ff9a4$exports.isAminoMsgUndelegate = $0aaecf7be71ff9a4$exports.isAminoMsgEditValidator = $0aaecf7be71ff9a4$exports.isAminoMsgDelegate = void 0;
var $2154cdbd010fe181$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($2154cdbd010fe181$exports, "__esModule", {
    value: true
});
$2154cdbd010fe181$exports.setupAuthExtension = void 0;
var $2616eb2bd5b22c20$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $2616eb2bd5b22c20$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2616eb2bd5b22c20$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2616eb2bd5b22c20$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2616eb2bd5b22c20$var$__createBinding(result, mod, k);
    }
    $2616eb2bd5b22c20$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2616eb2bd5b22c20$exports, "__esModule", {
    value: true
});
$2616eb2bd5b22c20$exports.QueryClientImpl = $2616eb2bd5b22c20$exports.QueryAccountInfoResponse = $2616eb2bd5b22c20$exports.QueryAccountInfoRequest = $2616eb2bd5b22c20$exports.QueryAccountAddressByIDResponse = $2616eb2bd5b22c20$exports.QueryAccountAddressByIDRequest = $2616eb2bd5b22c20$exports.AddressStringToBytesResponse = $2616eb2bd5b22c20$exports.AddressStringToBytesRequest = $2616eb2bd5b22c20$exports.AddressBytesToStringResponse = $2616eb2bd5b22c20$exports.AddressBytesToStringRequest = $2616eb2bd5b22c20$exports.Bech32PrefixResponse = $2616eb2bd5b22c20$exports.Bech32PrefixRequest = $2616eb2bd5b22c20$exports.QueryModuleAccountByNameResponse = $2616eb2bd5b22c20$exports.QueryModuleAccountByNameRequest = $2616eb2bd5b22c20$exports.QueryModuleAccountsResponse = $2616eb2bd5b22c20$exports.QueryModuleAccountsRequest = $2616eb2bd5b22c20$exports.QueryParamsResponse = $2616eb2bd5b22c20$exports.QueryParamsRequest = $2616eb2bd5b22c20$exports.QueryAccountResponse = $2616eb2bd5b22c20$exports.QueryAccountRequest = $2616eb2bd5b22c20$exports.QueryAccountsResponse = $2616eb2bd5b22c20$exports.QueryAccountsRequest = $2616eb2bd5b22c20$exports.protobufPackage = void 0;
var $95b9a3aa411e7c5d$exports = {};
"use strict";
var $95b9a3aa411e7c5d$var$__createBinding = $95b9a3aa411e7c5d$exports && $95b9a3aa411e7c5d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $95b9a3aa411e7c5d$var$__setModuleDefault = $95b9a3aa411e7c5d$exports && $95b9a3aa411e7c5d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $95b9a3aa411e7c5d$var$__importStar = $95b9a3aa411e7c5d$exports && $95b9a3aa411e7c5d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $95b9a3aa411e7c5d$var$__createBinding(result, mod, k);
    }
    $95b9a3aa411e7c5d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($95b9a3aa411e7c5d$exports, "__esModule", {
    value: true
});
$95b9a3aa411e7c5d$exports.PageResponse = $95b9a3aa411e7c5d$exports.PageRequest = $95b9a3aa411e7c5d$exports.protobufPackage = void 0;

var $7iZIe = parcelRequire("7iZIe");

var $95b9a3aa411e7c5d$var$_m0 = $95b9a3aa411e7c5d$var$__importStar((parcelRequire("hjb8Q")));
$95b9a3aa411e7c5d$exports.protobufPackage = "cosmos.base.query.v1beta1";
function $95b9a3aa411e7c5d$var$createBasePageRequest() {
    return {
        key: new Uint8Array(),
        offset: $7iZIe.Long.UZERO,
        limit: $7iZIe.Long.UZERO,
        countTotal: false,
        reverse: false
    };
}
$95b9a3aa411e7c5d$exports.PageRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $95b9a3aa411e7c5d$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (!message.offset.isZero()) writer.uint32(16).uint64(message.offset);
        if (!message.limit.isZero()) writer.uint32(24).uint64(message.limit);
        if (message.countTotal === true) writer.uint32(32).bool(message.countTotal);
        if (message.reverse === true) writer.uint32(40).bool(message.reverse);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $95b9a3aa411e7c5d$var$_m0.Reader ? input : new $95b9a3aa411e7c5d$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $95b9a3aa411e7c5d$var$createBasePageRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            offset: (0, $7iZIe.isSet)(object.offset) ? $7iZIe.Long.fromValue(object.offset) : $7iZIe.Long.UZERO,
            limit: (0, $7iZIe.isSet)(object.limit) ? $7iZIe.Long.fromValue(object.limit) : $7iZIe.Long.UZERO,
            countTotal: (0, $7iZIe.isSet)(object.countTotal) ? Boolean(object.countTotal) : false,
            reverse: (0, $7iZIe.isSet)(object.reverse) ? Boolean(object.reverse) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || $7iZIe.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $7iZIe.Long.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial: function(object) {
        var message = $95b9a3aa411e7c5d$var$createBasePageRequest();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        message.offset = object.offset !== undefined && object.offset !== null ? $7iZIe.Long.fromValue(object.offset) : $7iZIe.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $7iZIe.Long.fromValue(object.limit) : $7iZIe.Long.UZERO;
        var _object_countTotal;
        message.countTotal = (_object_countTotal = object.countTotal) !== null && _object_countTotal !== void 0 ? _object_countTotal : false;
        var _object_reverse;
        message.reverse = (_object_reverse = object.reverse) !== null && _object_reverse !== void 0 ? _object_reverse : false;
        return message;
    }
};
function $95b9a3aa411e7c5d$var$createBasePageResponse() {
    return {
        nextKey: new Uint8Array(),
        total: $7iZIe.Long.UZERO
    };
}
$95b9a3aa411e7c5d$exports.PageResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $95b9a3aa411e7c5d$var$_m0.Writer.create();
        if (message.nextKey.length !== 0) writer.uint32(10).bytes(message.nextKey);
        if (!message.total.isZero()) writer.uint32(16).uint64(message.total);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $95b9a3aa411e7c5d$var$_m0.Reader ? input : new $95b9a3aa411e7c5d$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $95b9a3aa411e7c5d$var$createBasePageResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            nextKey: (0, $7iZIe.isSet)(object.nextKey) ? (0, $7iZIe.bytesFromBase64)(object.nextKey) : new Uint8Array(),
            total: (0, $7iZIe.isSet)(object.total) ? $7iZIe.Long.fromValue(object.total) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.nextKey !== undefined && (obj.nextKey = (0, $7iZIe.base64FromBytes)(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $95b9a3aa411e7c5d$var$createBasePageResponse();
        var _object_nextKey;
        message.nextKey = (_object_nextKey = object.nextKey) !== null && _object_nextKey !== void 0 ? _object_nextKey : new Uint8Array();
        message.total = object.total !== undefined && object.total !== null ? $7iZIe.Long.fromValue(object.total) : $7iZIe.Long.UZERO;
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");


var $7iZIe = parcelRequire("7iZIe");

var $2616eb2bd5b22c20$var$_m0 = $2616eb2bd5b22c20$var$__importStar((parcelRequire("hjb8Q")));
$2616eb2bd5b22c20$exports.protobufPackage = "cosmos.auth.v1beta1";
function $2616eb2bd5b22c20$var$createBaseQueryAccountsRequest() {
    return {
        pagination: undefined
    };
}
$2616eb2bd5b22c20$exports.QueryAccountsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountsResponse() {
    return {
        accounts: [],
        pagination: undefined
    };
}
$2616eb2bd5b22c20$exports.QueryAccountsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.accounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.accounts) obj.accounts = message.accounts.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.accounts = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_accounts;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountsResponse();
        message.accounts = ((_object_accounts = object.accounts) === null || _object_accounts === void 0 ? void 0 : _object_accounts.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountRequest() {
    return {
        address: ""
    };
}
$2616eb2bd5b22c20$exports.QueryAccountRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountResponse() {
    return {
        account: undefined
    };
}
$2616eb2bd5b22c20$exports.QueryAccountResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.account !== undefined) $DM7bi.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            account: (0, $7iZIe.isSet)(object.account) ? $DM7bi.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.account !== undefined && (obj.account = message.account ? $DM7bi.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountResponse();
        message.account = object.account !== undefined && object.account !== null ? $DM7bi.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryParamsRequest() {
    return {};
}
$2616eb2bd5b22c20$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$2616eb2bd5b22c20$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.params !== undefined) $9d74bd5a035f28b2$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $9d74bd5a035f28b2$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $9d74bd5a035f28b2$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $9d74bd5a035f28b2$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $9d74bd5a035f28b2$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryModuleAccountsRequest() {
    return {};
}
$2616eb2bd5b22c20$exports.QueryModuleAccountsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountsRequest();
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryModuleAccountsResponse() {
    return {
        accounts: []
    };
}
$2616eb2bd5b22c20$exports.QueryModuleAccountsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.accounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            accounts: Array.isArray(object === null || object === void 0 ? void 0 : object.accounts) ? object.accounts.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.accounts) obj.accounts = message.accounts.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.accounts = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_accounts;
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountsResponse();
        message.accounts = ((_object_accounts = object.accounts) === null || _object_accounts === void 0 ? void 0 : _object_accounts.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryModuleAccountByNameRequest() {
    return {
        name: ""
    };
}
$2616eb2bd5b22c20$exports.QueryModuleAccountByNameRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.name !== "") writer.uint32(10).string(message.name);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountByNameRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            name: (0, $7iZIe.isSet)(object.name) ? String(object.name) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountByNameRequest();
        var _object_name;
        message.name = (_object_name = object.name) !== null && _object_name !== void 0 ? _object_name : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryModuleAccountByNameResponse() {
    return {
        account: undefined
    };
}
$2616eb2bd5b22c20$exports.QueryModuleAccountByNameResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.account !== undefined) $DM7bi.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountByNameResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            account: (0, $7iZIe.isSet)(object.account) ? $DM7bi.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.account !== undefined && (obj.account = message.account ? $DM7bi.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryModuleAccountByNameResponse();
        message.account = object.account !== undefined && object.account !== null ? $DM7bi.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseBech32PrefixRequest() {
    return {};
}
$2616eb2bd5b22c20$exports.Bech32PrefixRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseBech32PrefixRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $2616eb2bd5b22c20$var$createBaseBech32PrefixRequest();
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseBech32PrefixResponse() {
    return {
        bech32Prefix: ""
    };
}
$2616eb2bd5b22c20$exports.Bech32PrefixResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.bech32Prefix !== "") writer.uint32(10).string(message.bech32Prefix);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseBech32PrefixResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bech32Prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            bech32Prefix: (0, $7iZIe.isSet)(object.bech32Prefix) ? String(object.bech32Prefix) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.bech32Prefix !== undefined && (obj.bech32Prefix = message.bech32Prefix);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseBech32PrefixResponse();
        var _object_bech32Prefix;
        message.bech32Prefix = (_object_bech32Prefix = object.bech32Prefix) !== null && _object_bech32Prefix !== void 0 ? _object_bech32Prefix : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseAddressBytesToStringRequest() {
    return {
        addressBytes: new Uint8Array()
    };
}
$2616eb2bd5b22c20$exports.AddressBytesToStringRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseAddressBytesToStringRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            addressBytes: (0, $7iZIe.isSet)(object.addressBytes) ? (0, $7iZIe.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $7iZIe.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseAddressBytesToStringRequest();
        var _object_addressBytes;
        message.addressBytes = (_object_addressBytes = object.addressBytes) !== null && _object_addressBytes !== void 0 ? _object_addressBytes : new Uint8Array();
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseAddressBytesToStringResponse() {
    return {
        addressString: ""
    };
}
$2616eb2bd5b22c20$exports.AddressBytesToStringResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseAddressBytesToStringResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            addressString: (0, $7iZIe.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseAddressBytesToStringResponse();
        var _object_addressString;
        message.addressString = (_object_addressString = object.addressString) !== null && _object_addressString !== void 0 ? _object_addressString : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseAddressStringToBytesRequest() {
    return {
        addressString: ""
    };
}
$2616eb2bd5b22c20$exports.AddressStringToBytesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseAddressStringToBytesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            addressString: (0, $7iZIe.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseAddressStringToBytesRequest();
        var _object_addressString;
        message.addressString = (_object_addressString = object.addressString) !== null && _object_addressString !== void 0 ? _object_addressString : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseAddressStringToBytesResponse() {
    return {
        addressBytes: new Uint8Array()
    };
}
$2616eb2bd5b22c20$exports.AddressStringToBytesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseAddressStringToBytesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            addressBytes: (0, $7iZIe.isSet)(object.addressBytes) ? (0, $7iZIe.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $7iZIe.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseAddressStringToBytesResponse();
        var _object_addressBytes;
        message.addressBytes = (_object_addressBytes = object.addressBytes) !== null && _object_addressBytes !== void 0 ? _object_addressBytes : new Uint8Array();
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountAddressByIDRequest() {
    return {
        id: $7iZIe.Long.ZERO,
        accountId: $7iZIe.Long.UZERO
    };
}
$2616eb2bd5b22c20$exports.QueryAccountAddressByIDRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (!message.id.isZero()) writer.uint32(8).int64(message.id);
        if (!message.accountId.isZero()) writer.uint32(16).uint64(message.accountId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountAddressByIDRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.int64();
                    break;
                case 2:
                    message.accountId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            id: (0, $7iZIe.isSet)(object.id) ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.ZERO,
            accountId: (0, $7iZIe.isSet)(object.accountId) ? $7iZIe.Long.fromValue(object.accountId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.id !== undefined && (obj.id = (message.id || $7iZIe.Long.ZERO).toString());
        message.accountId !== undefined && (obj.accountId = (message.accountId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountAddressByIDRequest();
        message.id = object.id !== undefined && object.id !== null ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.ZERO;
        message.accountId = object.accountId !== undefined && object.accountId !== null ? $7iZIe.Long.fromValue(object.accountId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountAddressByIDResponse() {
    return {
        accountAddress: ""
    };
}
$2616eb2bd5b22c20$exports.QueryAccountAddressByIDResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.accountAddress !== "") writer.uint32(10).string(message.accountAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountAddressByIDResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accountAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            accountAddress: (0, $7iZIe.isSet)(object.accountAddress) ? String(object.accountAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.accountAddress !== undefined && (obj.accountAddress = message.accountAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountAddressByIDResponse();
        var _object_accountAddress;
        message.accountAddress = (_object_accountAddress = object.accountAddress) !== null && _object_accountAddress !== void 0 ? _object_accountAddress : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountInfoRequest() {
    return {
        address: ""
    };
}
$2616eb2bd5b22c20$exports.QueryAccountInfoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountInfoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountInfoRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        return message;
    }
};
function $2616eb2bd5b22c20$var$createBaseQueryAccountInfoResponse() {
    return {
        info: undefined
    };
}
$2616eb2bd5b22c20$exports.QueryAccountInfoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2616eb2bd5b22c20$var$_m0.Writer.create();
        if (message.info !== undefined) $9d74bd5a035f28b2$exports.BaseAccount.encode(message.info, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2616eb2bd5b22c20$var$_m0.Reader ? input : new $2616eb2bd5b22c20$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountInfoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info = $9d74bd5a035f28b2$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            info: (0, $7iZIe.isSet)(object.info) ? $9d74bd5a035f28b2$exports.BaseAccount.fromJSON(object.info) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.info !== undefined && (obj.info = message.info ? $9d74bd5a035f28b2$exports.BaseAccount.toJSON(message.info) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2616eb2bd5b22c20$var$createBaseQueryAccountInfoResponse();
        message.info = object.info !== undefined && object.info !== null ? $9d74bd5a035f28b2$exports.BaseAccount.fromPartial(object.info) : undefined;
        return message;
    }
};
var $2616eb2bd5b22c20$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.AccountAddressByID = this.AccountAddressByID.bind(this);
        this.Params = this.Params.bind(this);
        this.ModuleAccounts = this.ModuleAccounts.bind(this);
        this.ModuleAccountByName = this.ModuleAccountByName.bind(this);
        this.Bech32Prefix = this.Bech32Prefix.bind(this);
        this.AddressBytesToString = this.AddressBytesToString.bind(this);
        this.AddressStringToBytes = this.AddressStringToBytes.bind(this);
        this.AccountInfo = this.AccountInfo.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Accounts",
            value: function Accounts() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $2616eb2bd5b22c20$exports.QueryAccountsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryAccountsResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Account",
            value: function Account(request) {
                var data = $2616eb2bd5b22c20$exports.QueryAccountRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryAccountResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AccountAddressByID",
            value: function AccountAddressByID(request) {
                var data = $2616eb2bd5b22c20$exports.QueryAccountAddressByIDRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryAccountAddressByIDResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $2616eb2bd5b22c20$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryParamsResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ModuleAccounts",
            value: function ModuleAccounts() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $2616eb2bd5b22c20$exports.QueryModuleAccountsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryModuleAccountsResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ModuleAccountByName",
            value: function ModuleAccountByName(request) {
                var data = $2616eb2bd5b22c20$exports.QueryModuleAccountByNameRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryModuleAccountByNameResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Bech32Prefix",
            value: function Bech32Prefix() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $2616eb2bd5b22c20$exports.Bech32PrefixRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.Bech32PrefixResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AddressBytesToString",
            value: function AddressBytesToString(request) {
                var data = $2616eb2bd5b22c20$exports.AddressBytesToStringRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.AddressBytesToStringResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AddressStringToBytes",
            value: function AddressStringToBytes(request) {
                var data = $2616eb2bd5b22c20$exports.AddressStringToBytesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.AddressStringToBytesResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AccountInfo",
            value: function AccountInfo(request) {
                var data = $2616eb2bd5b22c20$exports.QueryAccountInfoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", data);
                return promise.then(function(data) {
                    return $2616eb2bd5b22c20$exports.QueryAccountInfoResponse.decode(new $2616eb2bd5b22c20$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$2616eb2bd5b22c20$exports.QueryClientImpl = $2616eb2bd5b22c20$var$QueryClientImpl;


var $0f41f7d88b60184b$exports = {};
"use strict";
Object.defineProperty($0f41f7d88b60184b$exports, "__esModule", {
    value: true
});
$0f41f7d88b60184b$exports.longify = $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto = $0f41f7d88b60184b$exports.createProtobufRpcClient = $0f41f7d88b60184b$exports.createPagination = $0f41f7d88b60184b$exports.QueryClient = void 0;
var $39e675a90528da1c$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($39e675a90528da1c$exports, "__esModule", {
    value: true
});
$39e675a90528da1c$exports.QueryClient = void 0;
var $ab96c954d31ce75d$exports = {};
"use strict";
Object.defineProperty($ab96c954d31ce75d$exports, "__esModule", {
    value: true
});
$ab96c954d31ce75d$exports.verifyNonExistence = $ab96c954d31ce75d$exports.verifyExistence = $ab96c954d31ce75d$exports.tendermintSpec = $ab96c954d31ce75d$exports.iavlSpec = $ab96c954d31ce75d$exports.calculateExistenceRoot = $ab96c954d31ce75d$exports.verifyNonMembership = $ab96c954d31ce75d$exports.verifyMembership = $ab96c954d31ce75d$exports.ics23 = void 0;
var $972bbf554730909d$exports = {};
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";

var $hjb8Q = parcelRequire("hjb8Q");
// Common aliases
var $972bbf554730909d$var$$Reader = $hjb8Q.Reader, $972bbf554730909d$var$$Writer = $hjb8Q.Writer, $972bbf554730909d$var$$util = $hjb8Q.util;
// Exported root namespace
var $972bbf554730909d$var$$root = $hjb8Q.roots["default"] || ($hjb8Q.roots["default"] = {});
$972bbf554730909d$var$$root.ics23 = function() {
    /**
     * Namespace ics23.
     * @exports ics23
     * @namespace
     */ var ics23 = {};
    /**
     * HashOp enum.
     * @name ics23.HashOp
     * @enum {string}
     * @property {number} NO_HASH=0 NO_HASH value
     * @property {number} SHA256=1 SHA256 value
     * @property {number} SHA512=2 SHA512 value
     * @property {number} KECCAK=3 KECCAK value
     * @property {number} RIPEMD160=4 RIPEMD160 value
     * @property {number} BITCOIN=5 BITCOIN value
     * @property {number} SHA512_256=6 SHA512_256 value
     */ ics23.HashOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_HASH"] = 0;
        values[valuesById[1] = "SHA256"] = 1;
        values[valuesById[2] = "SHA512"] = 2;
        values[valuesById[3] = "KECCAK"] = 3;
        values[valuesById[4] = "RIPEMD160"] = 4;
        values[valuesById[5] = "BITCOIN"] = 5;
        values[valuesById[6] = "SHA512_256"] = 6;
        return values;
    }();
    /**
     * LengthOp defines how to process the key and value of the LeafOp
     * to include length information. After encoding the length with the given
     * algorithm, the length will be prepended to the key and value bytes.
     * (Each one with it's own encoded length)
     * @name ics23.LengthOp
     * @enum {string}
     * @property {number} NO_PREFIX=0 NO_PREFIX value
     * @property {number} VAR_PROTO=1 VAR_PROTO value
     * @property {number} VAR_RLP=2 VAR_RLP value
     * @property {number} FIXED32_BIG=3 FIXED32_BIG value
     * @property {number} FIXED32_LITTLE=4 FIXED32_LITTLE value
     * @property {number} FIXED64_BIG=5 FIXED64_BIG value
     * @property {number} FIXED64_LITTLE=6 FIXED64_LITTLE value
     * @property {number} REQUIRE_32_BYTES=7 REQUIRE_32_BYTES value
     * @property {number} REQUIRE_64_BYTES=8 REQUIRE_64_BYTES value
     */ ics23.LengthOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_PREFIX"] = 0;
        values[valuesById[1] = "VAR_PROTO"] = 1;
        values[valuesById[2] = "VAR_RLP"] = 2;
        values[valuesById[3] = "FIXED32_BIG"] = 3;
        values[valuesById[4] = "FIXED32_LITTLE"] = 4;
        values[valuesById[5] = "FIXED64_BIG"] = 5;
        values[valuesById[6] = "FIXED64_LITTLE"] = 6;
        values[valuesById[7] = "REQUIRE_32_BYTES"] = 7;
        values[valuesById[8] = "REQUIRE_64_BYTES"] = 8;
        return values;
    }();
    ics23.ExistenceProof = function() {
        /**
         * Properties of an ExistenceProof.
         * @memberof ics23
         * @interface IExistenceProof
         * @property {Uint8Array|null} [key] ExistenceProof key
         * @property {Uint8Array|null} [value] ExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] ExistenceProof leaf
         * @property {Array.<ics23.IInnerOp>|null} [path] ExistenceProof path
         */ /**
         * Constructs a new ExistenceProof.
         * @memberof ics23
         * @classdesc ExistenceProof takes a key and a value and a set of steps to perform on it.
         * The result of peforming all these steps will provide a "root hash", which can
         * be compared to the value in a header.
         * 
         * Since it is computationally infeasible to produce a hash collission for any of the used
         * cryptographic hash functions, if someone can provide a series of operations to transform
         * a given key and value into a root hash that matches some trusted root, these key and values
         * must be in the referenced merkle tree.
         * 
         * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
         * which should be controlled by a spec. Eg. with lengthOp as NONE,
         * prefix = FOO, key = BAR, value = CHOICE
         * and
         * prefix = F, key = OOBAR, value = CHOICE
         * would produce the same value.
         * 
         * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
         * in the ProofSpec is valuable to prevent this mutability. And why all trees should
         * length-prefix the data before hashing it.
         * @implements IExistenceProof
         * @constructor
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         */ function ExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.key = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * ExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.value = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * ExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.leaf = null;
        /**
         * ExistenceProof path.
         * @member {Array.<ics23.IInnerOp>} path
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.path = $972bbf554730909d$var$$util.emptyArray;
        /**
         * Creates a new ExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         * @returns {ics23.ExistenceProof} ExistenceProof instance
         */ ExistenceProof.create = function create(properties) {
            return new ExistenceProof(properties);
        };
        /**
         * Encodes the specified ExistenceProof message. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $972bbf554730909d$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) for(var i = 0; i < message.path.length; ++i)$972bbf554730909d$var$$root.ics23.InnerOp.encode(message.path[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified ExistenceProof message, length delimited. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.ExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $972bbf554730909d$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        message.path.push($972bbf554730909d$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an ExistenceProof message.
         * @function verify
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $972bbf554730909d$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $972bbf554730909d$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $972bbf554730909d$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i){
                    var error = $972bbf554730909d$var$$root.ics23.InnerOp.verify(message.path[i]);
                    if (error) return "path." + error;
                }
            }
            return null;
        };
        /**
         * Creates an ExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ExistenceProof} ExistenceProof
         */ ExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.ExistenceProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.ExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $972bbf554730909d$var$$util.base64.decode(object.key, message.key = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $972bbf554730909d$var$$util.base64.decode(object.value, message.value = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.ExistenceProof.leaf: object expected");
                message.leaf = $972bbf554730909d$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.ExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i){
                    if (typeof object.path[i] !== "object") throw TypeError(".ics23.ExistenceProof.path: object expected");
                    message.path[i] = $972bbf554730909d$var$$root.ics23.InnerOp.fromObject(object.path[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from an ExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.ExistenceProof} message ExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $972bbf554730909d$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $972bbf554730909d$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $972bbf554730909d$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = $972bbf554730909d$var$$root.ics23.InnerOp.toObject(message.path[j], options);
            }
            return object;
        };
        /**
         * Converts this ExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.ExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return ExistenceProof;
    }();
    ics23.NonExistenceProof = function() {
        /**
         * Properties of a NonExistenceProof.
         * @memberof ics23
         * @interface INonExistenceProof
         * @property {Uint8Array|null} [key] NonExistenceProof key
         * @property {ics23.IExistenceProof|null} [left] NonExistenceProof left
         * @property {ics23.IExistenceProof|null} [right] NonExistenceProof right
         */ /**
         * Constructs a new NonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a NonExistenceProof.
         * @implements INonExistenceProof
         * @constructor
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         */ function NonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * NonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.key = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * NonExistenceProof left.
         * @member {ics23.IExistenceProof|null|undefined} left
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.left = null;
        /**
         * NonExistenceProof right.
         * @member {ics23.IExistenceProof|null|undefined} right
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.right = null;
        /**
         * Creates a new NonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         * @returns {ics23.NonExistenceProof} NonExistenceProof instance
         */ NonExistenceProof.create = function create(properties) {
            return new NonExistenceProof(properties);
        };
        /**
         * Encodes the specified NonExistenceProof message. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $972bbf554730909d$var$$root.ics23.ExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $972bbf554730909d$var$$root.ics23.ExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified NonExistenceProof message, length delimited. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.NonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $972bbf554730909d$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $972bbf554730909d$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a NonExistenceProof message.
         * @function verify
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ NonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $972bbf554730909d$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $972bbf554730909d$var$$root.ics23.ExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $972bbf554730909d$var$$root.ics23.ExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a NonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         */ NonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.NonExistenceProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.NonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $972bbf554730909d$var$$util.base64.decode(object.key, message.key = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.NonExistenceProof.left: object expected");
                message.left = $972bbf554730909d$var$$root.ics23.ExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.NonExistenceProof.right: object expected");
                message.right = $972bbf554730909d$var$$root.ics23.ExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a NonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.NonExistenceProof} message NonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ NonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $972bbf554730909d$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $972bbf554730909d$var$$root.ics23.ExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $972bbf554730909d$var$$root.ics23.ExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this NonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.NonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ NonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return NonExistenceProof;
    }();
    ics23.CommitmentProof = function() {
        /**
         * Properties of a CommitmentProof.
         * @memberof ics23
         * @interface ICommitmentProof
         * @property {ics23.IExistenceProof|null} [exist] CommitmentProof exist
         * @property {ics23.INonExistenceProof|null} [nonexist] CommitmentProof nonexist
         * @property {ics23.IBatchProof|null} [batch] CommitmentProof batch
         * @property {ics23.ICompressedBatchProof|null} [compressed] CommitmentProof compressed
         */ /**
         * Constructs a new CommitmentProof.
         * @memberof ics23
         * @classdesc Represents a CommitmentProof.
         * @implements ICommitmentProof
         * @constructor
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         */ function CommitmentProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CommitmentProof exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.exist = null;
        /**
         * CommitmentProof nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.nonexist = null;
        /**
         * CommitmentProof batch.
         * @member {ics23.IBatchProof|null|undefined} batch
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.batch = null;
        /**
         * CommitmentProof compressed.
         * @member {ics23.ICompressedBatchProof|null|undefined} compressed
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.compressed = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CommitmentProof proof.
         * @member {"exist"|"nonexist"|"batch"|"compressed"|undefined} proof
         * @memberof ics23.CommitmentProof
         * @instance
         */ Object.defineProperty(CommitmentProof.prototype, "proof", {
            get: $972bbf554730909d$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist",
                "batch",
                "compressed"
            ]),
            set: $972bbf554730909d$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CommitmentProof instance using the specified properties.
         * @function create
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         * @returns {ics23.CommitmentProof} CommitmentProof instance
         */ CommitmentProof.create = function create(properties) {
            return new CommitmentProof(properties);
        };
        /**
         * Encodes the specified CommitmentProof message. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $972bbf554730909d$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $972bbf554730909d$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.batch != null && message.hasOwnProperty("batch")) $972bbf554730909d$var$$root.ics23.BatchProof.encode(message.batch, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.compressed != null && message.hasOwnProperty("compressed")) $972bbf554730909d$var$$root.ics23.CompressedBatchProof.encode(message.compressed, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CommitmentProof message, length delimited. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.CommitmentProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $972bbf554730909d$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $972bbf554730909d$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.batch = $972bbf554730909d$var$$root.ics23.BatchProof.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.compressed = $972bbf554730909d$var$$root.ics23.CompressedBatchProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CommitmentProof message.
         * @function verify
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CommitmentProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.BatchProof.verify(message.batch);
                if (error) return "batch." + error;
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.CompressedBatchProof.verify(message.compressed);
                if (error) return "compressed." + error;
            }
            return null;
        };
        /**
         * Creates a CommitmentProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CommitmentProof} CommitmentProof
         */ CommitmentProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.CommitmentProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.CommitmentProof();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CommitmentProof.exist: object expected");
                message.exist = $972bbf554730909d$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
                message.nonexist = $972bbf554730909d$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            if (object.batch != null) {
                if (typeof object.batch !== "object") throw TypeError(".ics23.CommitmentProof.batch: object expected");
                message.batch = $972bbf554730909d$var$$root.ics23.BatchProof.fromObject(object.batch);
            }
            if (object.compressed != null) {
                if (typeof object.compressed !== "object") throw TypeError(".ics23.CommitmentProof.compressed: object expected");
                message.compressed = $972bbf554730909d$var$$root.ics23.CompressedBatchProof.fromObject(object.compressed);
            }
            return message;
        };
        /**
         * Creates a plain object from a CommitmentProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.CommitmentProof} message CommitmentProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CommitmentProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $972bbf554730909d$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $972bbf554730909d$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                object.batch = $972bbf554730909d$var$$root.ics23.BatchProof.toObject(message.batch, options);
                if (options.oneofs) object.proof = "batch";
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                object.compressed = $972bbf554730909d$var$$root.ics23.CompressedBatchProof.toObject(message.compressed, options);
                if (options.oneofs) object.proof = "compressed";
            }
            return object;
        };
        /**
         * Converts this CommitmentProof to JSON.
         * @function toJSON
         * @memberof ics23.CommitmentProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CommitmentProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return CommitmentProof;
    }();
    ics23.LeafOp = function() {
        /**
         * Properties of a LeafOp.
         * @memberof ics23
         * @interface ILeafOp
         * @property {ics23.HashOp|null} [hash] LeafOp hash
         * @property {ics23.HashOp|null} [prehashKey] LeafOp prehashKey
         * @property {ics23.HashOp|null} [prehashValue] LeafOp prehashValue
         * @property {ics23.LengthOp|null} [length] LeafOp length
         * @property {Uint8Array|null} [prefix] LeafOp prefix
         */ /**
         * Constructs a new LeafOp.
         * @memberof ics23
         * @classdesc LeafOp represents the raw key-value data we wish to prove, and
         * must be flexible to represent the internal transformation from
         * the original key-value pairs into the basis hash, for many existing
         * merkle trees.
         * 
         * key and value are passed in. So that the signature of this operation is:
         * leafOp(key, value) -> output
         * 
         * To process this, first prehash the keys and values if needed (ANY means no hash in this case):
         * hkey = prehashKey(key)
         * hvalue = prehashValue(value)
         * 
         * Then combine the bytes, and hash it
         * output = hash(prefix || length(hkey) || hkey || length(hvalue) || hvalue)
         * @implements ILeafOp
         * @constructor
         * @param {ics23.ILeafOp=} [properties] Properties to set
         */ function LeafOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * LeafOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.hash = 0;
        /**
         * LeafOp prehashKey.
         * @member {ics23.HashOp} prehashKey
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashKey = 0;
        /**
         * LeafOp prehashValue.
         * @member {ics23.HashOp} prehashValue
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashValue = 0;
        /**
         * LeafOp length.
         * @member {ics23.LengthOp} length
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.length = 0;
        /**
         * LeafOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prefix = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * Creates a new LeafOp instance using the specified properties.
         * @function create
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp=} [properties] Properties to set
         * @returns {ics23.LeafOp} LeafOp instance
         */ LeafOp.create = function create(properties) {
            return new LeafOp(properties);
        };
        /**
         * Encodes the specified LeafOp message. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.prehashKey);
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.prehashValue);
            if (message.length != null && message.hasOwnProperty("length")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.length);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.prefix);
            return writer;
        };
        /**
         * Encodes the specified LeafOp message, length delimited. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.LeafOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prehashKey = reader.int32();
                        break;
                    case 3:
                        message.prehashValue = reader.int32();
                        break;
                    case 4:
                        message.length = reader.int32();
                        break;
                    case 5:
                        message.prefix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a LeafOp message.
         * @function verify
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ LeafOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) switch(message.prehashKey){
                default:
                    return "prehashKey: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) switch(message.prehashValue){
                default:
                    return "prehashValue: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.length != null && message.hasOwnProperty("length")) switch(message.length){
                default:
                    return "length: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $972bbf554730909d$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            return null;
        };
        /**
         * Creates a LeafOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.LeafOp} LeafOp
         */ LeafOp.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.LeafOp) return object;
            var message = new $972bbf554730909d$var$$root.ics23.LeafOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            switch(object.prehashKey){
                case "NO_HASH":
                case 0:
                    message.prehashKey = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashKey = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashKey = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashKey = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashKey = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashKey = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashKey = 6;
                    break;
            }
            switch(object.prehashValue){
                case "NO_HASH":
                case 0:
                    message.prehashValue = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashValue = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashValue = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashValue = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashValue = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashValue = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashValue = 6;
                    break;
            }
            switch(object.length){
                case "NO_PREFIX":
                case 0:
                    message.length = 0;
                    break;
                case "VAR_PROTO":
                case 1:
                    message.length = 1;
                    break;
                case "VAR_RLP":
                case 2:
                    message.length = 2;
                    break;
                case "FIXED32_BIG":
                case 3:
                    message.length = 3;
                    break;
                case "FIXED32_LITTLE":
                case 4:
                    message.length = 4;
                    break;
                case "FIXED64_BIG":
                case 5:
                    message.length = 5;
                    break;
                case "FIXED64_LITTLE":
                case 6:
                    message.length = 6;
                    break;
                case "REQUIRE_32_BYTES":
                case 7:
                    message.length = 7;
                    break;
                case "REQUIRE_64_BYTES":
                case 8:
                    message.length = 8;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $972bbf554730909d$var$$util.base64.decode(object.prefix, message.prefix = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            return message;
        };
        /**
         * Creates a plain object from a LeafOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.LeafOp} message LeafOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ LeafOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                object.prehashKey = options.enums === String ? "NO_HASH" : 0;
                object.prehashValue = options.enums === String ? "NO_HASH" : 0;
                object.length = options.enums === String ? "NO_PREFIX" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $972bbf554730909d$var$$util.newBuffer(object.prefix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $972bbf554730909d$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) object.prehashKey = options.enums === String ? $972bbf554730909d$var$$root.ics23.HashOp[message.prehashKey] : message.prehashKey;
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) object.prehashValue = options.enums === String ? $972bbf554730909d$var$$root.ics23.HashOp[message.prehashValue] : message.prehashValue;
            if (message.length != null && message.hasOwnProperty("length")) object.length = options.enums === String ? $972bbf554730909d$var$$root.ics23.LengthOp[message.length] : message.length;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            return object;
        };
        /**
         * Converts this LeafOp to JSON.
         * @function toJSON
         * @memberof ics23.LeafOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ LeafOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return LeafOp;
    }();
    ics23.InnerOp = function() {
        /**
         * Properties of an InnerOp.
         * @memberof ics23
         * @interface IInnerOp
         * @property {ics23.HashOp|null} [hash] InnerOp hash
         * @property {Uint8Array|null} [prefix] InnerOp prefix
         * @property {Uint8Array|null} [suffix] InnerOp suffix
         */ /**
         * Constructs a new InnerOp.
         * @memberof ics23
         * @classdesc InnerOp represents a merkle-proof step that is not a leaf.
         * It represents concatenating two children and hashing them to provide the next result.
         * 
         * The result of the previous step is passed in, so the signature of this op is:
         * innerOp(child) -> output
         * 
         * The result of applying InnerOp should be:
         * output = op.hash(op.prefix || child || op.suffix)
         * 
         * where the || operator is concatenation of binary data,
         * and child is the result of hashing all the tree below this step.
         * 
         * Any special data, like prepending child with the length, or prepending the entire operation with
         * some value to differentiate from leaf nodes, should be included in prefix and suffix.
         * If either of prefix or suffix is empty, we just treat it as an empty string
         * @implements IInnerOp
         * @constructor
         * @param {ics23.IInnerOp=} [properties] Properties to set
         */ function InnerOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.hash = 0;
        /**
         * InnerOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.prefix = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * InnerOp suffix.
         * @member {Uint8Array} suffix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.suffix = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * Creates a new InnerOp instance using the specified properties.
         * @function create
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp=} [properties] Properties to set
         * @returns {ics23.InnerOp} InnerOp instance
         */ InnerOp.create = function create(properties) {
            return new InnerOp(properties);
        };
        /**
         * Encodes the specified InnerOp message. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.prefix);
            if (message.suffix != null && message.hasOwnProperty("suffix")) writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.suffix);
            return writer;
        };
        /**
         * Encodes the specified InnerOp message, length delimited. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.InnerOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prefix = reader.bytes();
                        break;
                    case 3:
                        message.suffix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerOp message.
         * @function verify
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $972bbf554730909d$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            if (message.suffix != null && message.hasOwnProperty("suffix")) {
                if (!(message.suffix && typeof message.suffix.length === "number" || $972bbf554730909d$var$$util.isString(message.suffix))) return "suffix: buffer expected";
            }
            return null;
        };
        /**
         * Creates an InnerOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerOp} InnerOp
         */ InnerOp.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.InnerOp) return object;
            var message = new $972bbf554730909d$var$$root.ics23.InnerOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $972bbf554730909d$var$$util.base64.decode(object.prefix, message.prefix = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            if (object.suffix != null) {
                if (typeof object.suffix === "string") $972bbf554730909d$var$$util.base64.decode(object.suffix, message.suffix = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.suffix)), 0);
                else if (object.suffix.length) message.suffix = object.suffix;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.InnerOp} message InnerOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $972bbf554730909d$var$$util.newBuffer(object.prefix);
                }
                if (options.bytes === String) object.suffix = "";
                else {
                    object.suffix = [];
                    if (options.bytes !== Array) object.suffix = $972bbf554730909d$var$$util.newBuffer(object.suffix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $972bbf554730909d$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            if (message.suffix != null && message.hasOwnProperty("suffix")) object.suffix = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.suffix, 0, message.suffix.length) : options.bytes === Array ? Array.prototype.slice.call(message.suffix) : message.suffix;
            return object;
        };
        /**
         * Converts this InnerOp to JSON.
         * @function toJSON
         * @memberof ics23.InnerOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return InnerOp;
    }();
    ics23.ProofSpec = function() {
        /**
         * Properties of a ProofSpec.
         * @memberof ics23
         * @interface IProofSpec
         * @property {ics23.ILeafOp|null} [leafSpec] ProofSpec leafSpec
         * @property {ics23.IInnerSpec|null} [innerSpec] ProofSpec innerSpec
         * @property {number|null} [maxDepth] ProofSpec maxDepth
         * @property {number|null} [minDepth] ProofSpec minDepth
         */ /**
         * Constructs a new ProofSpec.
         * @memberof ics23
         * @classdesc ProofSpec defines what the expected parameters are for a given proof type.
         * This can be stored in the client and used to validate any incoming proofs.
         * 
         * verify(ProofSpec, Proof) -> Proof | Error
         * 
         * As demonstrated in tests, if we don't fix the algorithm used to calculate the
         * LeafHash for a given tree, there are many possible key-value pairs that can
         * generate a given hash (by interpretting the preimage differently).
         * We need this for proper security, requires client knows a priori what
         * tree format server uses. But not in code, rather a configuration object.
         * @implements IProofSpec
         * @constructor
         * @param {ics23.IProofSpec=} [properties] Properties to set
         */ function ProofSpec(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ProofSpec leafSpec.
         * @member {ics23.ILeafOp|null|undefined} leafSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.leafSpec = null;
        /**
         * ProofSpec innerSpec.
         * @member {ics23.IInnerSpec|null|undefined} innerSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.innerSpec = null;
        /**
         * ProofSpec maxDepth.
         * @member {number} maxDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.maxDepth = 0;
        /**
         * ProofSpec minDepth.
         * @member {number} minDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.minDepth = 0;
        /**
         * Creates a new ProofSpec instance using the specified properties.
         * @function create
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec=} [properties] Properties to set
         * @returns {ics23.ProofSpec} ProofSpec instance
         */ ProofSpec.create = function create(properties) {
            return new ProofSpec(properties);
        };
        /**
         * Encodes the specified ProofSpec message. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) $972bbf554730909d$var$$root.ics23.LeafOp.encode(message.leafSpec, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) $972bbf554730909d$var$$root.ics23.InnerSpec.encode(message.innerSpec, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.maxDepth);
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.minDepth);
            return writer;
        };
        /**
         * Encodes the specified ProofSpec message, length delimited. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.ProofSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.leafSpec = $972bbf554730909d$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.innerSpec = $972bbf554730909d$var$$root.ics23.InnerSpec.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.maxDepth = reader.int32();
                        break;
                    case 4:
                        message.minDepth = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a ProofSpec message.
         * @function verify
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ProofSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) {
                var error = $972bbf554730909d$var$$root.ics23.LeafOp.verify(message.leafSpec);
                if (error) return "leafSpec." + error;
            }
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) {
                var error = $972bbf554730909d$var$$root.ics23.InnerSpec.verify(message.innerSpec);
                if (error) return "innerSpec." + error;
            }
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) {
                if (!$972bbf554730909d$var$$util.isInteger(message.maxDepth)) return "maxDepth: integer expected";
            }
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) {
                if (!$972bbf554730909d$var$$util.isInteger(message.minDepth)) return "minDepth: integer expected";
            }
            return null;
        };
        /**
         * Creates a ProofSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ProofSpec} ProofSpec
         */ ProofSpec.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.ProofSpec) return object;
            var message = new $972bbf554730909d$var$$root.ics23.ProofSpec();
            if (object.leafSpec != null) {
                if (typeof object.leafSpec !== "object") throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
                message.leafSpec = $972bbf554730909d$var$$root.ics23.LeafOp.fromObject(object.leafSpec);
            }
            if (object.innerSpec != null) {
                if (typeof object.innerSpec !== "object") throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
                message.innerSpec = $972bbf554730909d$var$$root.ics23.InnerSpec.fromObject(object.innerSpec);
            }
            if (object.maxDepth != null) message.maxDepth = object.maxDepth | 0;
            if (object.minDepth != null) message.minDepth = object.minDepth | 0;
            return message;
        };
        /**
         * Creates a plain object from a ProofSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.ProofSpec} message ProofSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ProofSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.leafSpec = null;
                object.innerSpec = null;
                object.maxDepth = 0;
                object.minDepth = 0;
            }
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) object.leafSpec = $972bbf554730909d$var$$root.ics23.LeafOp.toObject(message.leafSpec, options);
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) object.innerSpec = $972bbf554730909d$var$$root.ics23.InnerSpec.toObject(message.innerSpec, options);
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) object.maxDepth = message.maxDepth;
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) object.minDepth = message.minDepth;
            return object;
        };
        /**
         * Converts this ProofSpec to JSON.
         * @function toJSON
         * @memberof ics23.ProofSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ProofSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return ProofSpec;
    }();
    ics23.InnerSpec = function() {
        /**
         * Properties of an InnerSpec.
         * @memberof ics23
         * @interface IInnerSpec
         * @property {Array.<number>|null} [childOrder] InnerSpec childOrder
         * @property {number|null} [childSize] InnerSpec childSize
         * @property {number|null} [minPrefixLength] InnerSpec minPrefixLength
         * @property {number|null} [maxPrefixLength] InnerSpec maxPrefixLength
         * @property {Uint8Array|null} [emptyChild] InnerSpec emptyChild
         * @property {ics23.HashOp|null} [hash] InnerSpec hash
         */ /**
         * Constructs a new InnerSpec.
         * @memberof ics23
         * @classdesc Represents an InnerSpec.
         * @implements IInnerSpec
         * @constructor
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         */ function InnerSpec(properties) {
            this.childOrder = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerSpec childOrder.
         * @member {Array.<number>} childOrder
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childOrder = $972bbf554730909d$var$$util.emptyArray;
        /**
         * InnerSpec childSize.
         * @member {number} childSize
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childSize = 0;
        /**
         * InnerSpec minPrefixLength.
         * @member {number} minPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.minPrefixLength = 0;
        /**
         * InnerSpec maxPrefixLength.
         * @member {number} maxPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.maxPrefixLength = 0;
        /**
         * InnerSpec emptyChild.
         * @member {Uint8Array} emptyChild
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.emptyChild = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * InnerSpec hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.hash = 0;
        /**
         * Creates a new InnerSpec instance using the specified properties.
         * @function create
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         * @returns {ics23.InnerSpec} InnerSpec instance
         */ InnerSpec.create = function create(properties) {
            return new InnerSpec(properties);
        };
        /**
         * Encodes the specified InnerSpec message. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.childOrder != null && message.childOrder.length) {
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
                for(var i = 0; i < message.childOrder.length; ++i)writer.int32(message.childOrder[i]);
                writer.ldelim();
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.childSize);
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.minPrefixLength);
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.maxPrefixLength);
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.emptyChild);
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.hash);
            return writer;
        };
        /**
         * Encodes the specified InnerSpec message, length delimited. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.InnerSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.childOrder && message.childOrder.length)) message.childOrder = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.childOrder.push(reader.int32());
                        } else message.childOrder.push(reader.int32());
                        break;
                    case 2:
                        message.childSize = reader.int32();
                        break;
                    case 3:
                        message.minPrefixLength = reader.int32();
                        break;
                    case 4:
                        message.maxPrefixLength = reader.int32();
                        break;
                    case 5:
                        message.emptyChild = reader.bytes();
                        break;
                    case 6:
                        message.hash = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerSpec message.
         * @function verify
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.childOrder != null && message.hasOwnProperty("childOrder")) {
                if (!Array.isArray(message.childOrder)) return "childOrder: array expected";
                for(var i = 0; i < message.childOrder.length; ++i)if (!$972bbf554730909d$var$$util.isInteger(message.childOrder[i])) return "childOrder: integer[] expected";
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) {
                if (!$972bbf554730909d$var$$util.isInteger(message.childSize)) return "childSize: integer expected";
            }
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) {
                if (!$972bbf554730909d$var$$util.isInteger(message.minPrefixLength)) return "minPrefixLength: integer expected";
            }
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) {
                if (!$972bbf554730909d$var$$util.isInteger(message.maxPrefixLength)) return "maxPrefixLength: integer expected";
            }
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) {
                if (!(message.emptyChild && typeof message.emptyChild.length === "number" || $972bbf554730909d$var$$util.isString(message.emptyChild))) return "emptyChild: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            return null;
        };
        /**
         * Creates an InnerSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerSpec} InnerSpec
         */ InnerSpec.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.InnerSpec) return object;
            var message = new $972bbf554730909d$var$$root.ics23.InnerSpec();
            if (object.childOrder) {
                if (!Array.isArray(object.childOrder)) throw TypeError(".ics23.InnerSpec.childOrder: array expected");
                message.childOrder = [];
                for(var i = 0; i < object.childOrder.length; ++i)message.childOrder[i] = object.childOrder[i] | 0;
            }
            if (object.childSize != null) message.childSize = object.childSize | 0;
            if (object.minPrefixLength != null) message.minPrefixLength = object.minPrefixLength | 0;
            if (object.maxPrefixLength != null) message.maxPrefixLength = object.maxPrefixLength | 0;
            if (object.emptyChild != null) {
                if (typeof object.emptyChild === "string") $972bbf554730909d$var$$util.base64.decode(object.emptyChild, message.emptyChild = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.emptyChild)), 0);
                else if (object.emptyChild.length) message.emptyChild = object.emptyChild;
            }
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.InnerSpec} message InnerSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.childOrder = [];
            if (options.defaults) {
                object.childSize = 0;
                object.minPrefixLength = 0;
                object.maxPrefixLength = 0;
                if (options.bytes === String) object.emptyChild = "";
                else {
                    object.emptyChild = [];
                    if (options.bytes !== Array) object.emptyChild = $972bbf554730909d$var$$util.newBuffer(object.emptyChild);
                }
                object.hash = options.enums === String ? "NO_HASH" : 0;
            }
            if (message.childOrder && message.childOrder.length) {
                object.childOrder = [];
                for(var j = 0; j < message.childOrder.length; ++j)object.childOrder[j] = message.childOrder[j];
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) object.childSize = message.childSize;
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) object.minPrefixLength = message.minPrefixLength;
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) object.maxPrefixLength = message.maxPrefixLength;
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) object.emptyChild = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.emptyChild, 0, message.emptyChild.length) : options.bytes === Array ? Array.prototype.slice.call(message.emptyChild) : message.emptyChild;
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $972bbf554730909d$var$$root.ics23.HashOp[message.hash] : message.hash;
            return object;
        };
        /**
         * Converts this InnerSpec to JSON.
         * @function toJSON
         * @memberof ics23.InnerSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return InnerSpec;
    }();
    ics23.BatchProof = function() {
        /**
         * Properties of a BatchProof.
         * @memberof ics23
         * @interface IBatchProof
         * @property {Array.<ics23.IBatchEntry>|null} [entries] BatchProof entries
         */ /**
         * Constructs a new BatchProof.
         * @memberof ics23
         * @classdesc Represents a BatchProof.
         * @implements IBatchProof
         * @constructor
         * @param {ics23.IBatchProof=} [properties] Properties to set
         */ function BatchProof(properties) {
            this.entries = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchProof entries.
         * @member {Array.<ics23.IBatchEntry>} entries
         * @memberof ics23.BatchProof
         * @instance
         */ BatchProof.prototype.entries = $972bbf554730909d$var$$util.emptyArray;
        /**
         * Creates a new BatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof=} [properties] Properties to set
         * @returns {ics23.BatchProof} BatchProof instance
         */ BatchProof.create = function create(properties) {
            return new BatchProof(properties);
        };
        /**
         * Encodes the specified BatchProof message. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$972bbf554730909d$var$$root.ics23.BatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchProof message, length delimited. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.BatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($972bbf554730909d$var$$root.ics23.BatchEntry.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchProof message.
         * @function verify
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $972bbf554730909d$var$$root.ics23.BatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            return null;
        };
        /**
         * Creates a BatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchProof} BatchProof
         */ BatchProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.BatchProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.BatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.BatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.BatchProof.entries: object expected");
                    message.entries[i] = $972bbf554730909d$var$$root.ics23.BatchEntry.fromObject(object.entries[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.BatchProof} message BatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.entries = [];
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $972bbf554730909d$var$$root.ics23.BatchEntry.toObject(message.entries[j], options);
            }
            return object;
        };
        /**
         * Converts this BatchProof to JSON.
         * @function toJSON
         * @memberof ics23.BatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return BatchProof;
    }();
    ics23.BatchEntry = function() {
        /**
         * Properties of a BatchEntry.
         * @memberof ics23
         * @interface IBatchEntry
         * @property {ics23.IExistenceProof|null} [exist] BatchEntry exist
         * @property {ics23.INonExistenceProof|null} [nonexist] BatchEntry nonexist
         */ /**
         * Constructs a new BatchEntry.
         * @memberof ics23
         * @classdesc Represents a BatchEntry.
         * @implements IBatchEntry
         * @constructor
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         */ function BatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchEntry exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.exist = null;
        /**
         * BatchEntry nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * BatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.BatchEntry
         * @instance
         */ Object.defineProperty(BatchEntry.prototype, "proof", {
            get: $972bbf554730909d$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $972bbf554730909d$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new BatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         * @returns {ics23.BatchEntry} BatchEntry instance
         */ BatchEntry.create = function create(properties) {
            return new BatchEntry(properties);
        };
        /**
         * Encodes the specified BatchEntry message. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $972bbf554730909d$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $972bbf554730909d$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchEntry message, length delimited. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.BatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $972bbf554730909d$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $972bbf554730909d$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchEntry message.
         * @function verify
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a BatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchEntry} BatchEntry
         */ BatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.BatchEntry) return object;
            var message = new $972bbf554730909d$var$$root.ics23.BatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.BatchEntry.exist: object expected");
                message.exist = $972bbf554730909d$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.BatchEntry.nonexist: object expected");
                message.nonexist = $972bbf554730909d$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.BatchEntry} message BatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $972bbf554730909d$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $972bbf554730909d$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this BatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.BatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return BatchEntry;
    }();
    ics23.CompressedBatchProof = function() {
        /**
         * Properties of a CompressedBatchProof.
         * @memberof ics23
         * @interface ICompressedBatchProof
         * @property {Array.<ics23.ICompressedBatchEntry>|null} [entries] CompressedBatchProof entries
         * @property {Array.<ics23.IInnerOp>|null} [lookupInners] CompressedBatchProof lookupInners
         */ /**
         * Constructs a new CompressedBatchProof.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchProof.
         * @implements ICompressedBatchProof
         * @constructor
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         */ function CompressedBatchProof(properties) {
            this.entries = [];
            this.lookupInners = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchProof entries.
         * @member {Array.<ics23.ICompressedBatchEntry>} entries
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.entries = $972bbf554730909d$var$$util.emptyArray;
        /**
         * CompressedBatchProof lookupInners.
         * @member {Array.<ics23.IInnerOp>} lookupInners
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.lookupInners = $972bbf554730909d$var$$util.emptyArray;
        /**
         * Creates a new CompressedBatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof instance
         */ CompressedBatchProof.create = function create(properties) {
            return new CompressedBatchProof(properties);
        };
        /**
         * Encodes the specified CompressedBatchProof message. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$972bbf554730909d$var$$root.ics23.CompressedBatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.lookupInners != null && message.lookupInners.length) for(var i = 0; i < message.lookupInners.length; ++i)$972bbf554730909d$var$$root.ics23.InnerOp.encode(message.lookupInners[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchProof message, length delimited. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.CompressedBatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($972bbf554730909d$var$$root.ics23.CompressedBatchEntry.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message.lookupInners && message.lookupInners.length)) message.lookupInners = [];
                        message.lookupInners.push($972bbf554730909d$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchProof message.
         * @function verify
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $972bbf554730909d$var$$root.ics23.CompressedBatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            if (message.lookupInners != null && message.hasOwnProperty("lookupInners")) {
                if (!Array.isArray(message.lookupInners)) return "lookupInners: array expected";
                for(var i = 0; i < message.lookupInners.length; ++i){
                    var error = $972bbf554730909d$var$$root.ics23.InnerOp.verify(message.lookupInners[i]);
                    if (error) return "lookupInners." + error;
                }
            }
            return null;
        };
        /**
         * Creates a CompressedBatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         */ CompressedBatchProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.CompressedBatchProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.CompressedBatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
                    message.entries[i] = $972bbf554730909d$var$$root.ics23.CompressedBatchEntry.fromObject(object.entries[i]);
                }
            }
            if (object.lookupInners) {
                if (!Array.isArray(object.lookupInners)) throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
                message.lookupInners = [];
                for(var i = 0; i < object.lookupInners.length; ++i){
                    if (typeof object.lookupInners[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
                    message.lookupInners[i] = $972bbf554730909d$var$$root.ics23.InnerOp.fromObject(object.lookupInners[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.CompressedBatchProof} message CompressedBatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.lookupInners = [];
            }
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $972bbf554730909d$var$$root.ics23.CompressedBatchEntry.toObject(message.entries[j], options);
            }
            if (message.lookupInners && message.lookupInners.length) {
                object.lookupInners = [];
                for(var j = 0; j < message.lookupInners.length; ++j)object.lookupInners[j] = $972bbf554730909d$var$$root.ics23.InnerOp.toObject(message.lookupInners[j], options);
            }
            return object;
        };
        /**
         * Converts this CompressedBatchProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return CompressedBatchProof;
    }();
    ics23.CompressedBatchEntry = function() {
        /**
         * Properties of a CompressedBatchEntry.
         * @memberof ics23
         * @interface ICompressedBatchEntry
         * @property {ics23.ICompressedExistenceProof|null} [exist] CompressedBatchEntry exist
         * @property {ics23.ICompressedNonExistenceProof|null} [nonexist] CompressedBatchEntry nonexist
         */ /**
         * Constructs a new CompressedBatchEntry.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchEntry.
         * @implements ICompressedBatchEntry
         * @constructor
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         */ function CompressedBatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchEntry exist.
         * @member {ics23.ICompressedExistenceProof|null|undefined} exist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.exist = null;
        /**
         * CompressedBatchEntry nonexist.
         * @member {ics23.ICompressedNonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CompressedBatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ Object.defineProperty(CompressedBatchEntry.prototype, "proof", {
            get: $972bbf554730909d$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $972bbf554730909d$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CompressedBatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry instance
         */ CompressedBatchEntry.create = function create(properties) {
            return new CompressedBatchEntry(properties);
        };
        /**
         * Encodes the specified CompressedBatchEntry message. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchEntry message, length delimited. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.CompressedBatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchEntry message.
         * @function verify
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedBatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         */ CompressedBatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.CompressedBatchEntry) return object;
            var message = new $972bbf554730909d$var$$root.ics23.CompressedBatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
                message.exist = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
                message.nonexist = $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.CompressedBatchEntry} message CompressedBatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this CompressedBatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return CompressedBatchEntry;
    }();
    ics23.CompressedExistenceProof = function() {
        /**
         * Properties of a CompressedExistenceProof.
         * @memberof ics23
         * @interface ICompressedExistenceProof
         * @property {Uint8Array|null} [key] CompressedExistenceProof key
         * @property {Uint8Array|null} [value] CompressedExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] CompressedExistenceProof leaf
         * @property {Array.<number>|null} [path] CompressedExistenceProof path
         */ /**
         * Constructs a new CompressedExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedExistenceProof.
         * @implements ICompressedExistenceProof
         * @constructor
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         */ function CompressedExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.key = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.value = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.leaf = null;
        /**
         * CompressedExistenceProof path.
         * @member {Array.<number>} path
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.path = $972bbf554730909d$var$$util.emptyArray;
        /**
         * Creates a new CompressedExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof instance
         */ CompressedExistenceProof.create = function create(properties) {
            return new CompressedExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedExistenceProof message. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $972bbf554730909d$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) {
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
                for(var i = 0; i < message.path.length; ++i)writer.int32(message.path[i]);
                writer.ldelim();
            }
            return writer;
        };
        /**
         * Encodes the specified CompressedExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.CompressedExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $972bbf554730909d$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.path.push(reader.int32());
                        } else message.path.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $972bbf554730909d$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $972bbf554730909d$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $972bbf554730909d$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i)if (!$972bbf554730909d$var$$util.isInteger(message.path[i])) return "path: integer[] expected";
            }
            return null;
        };
        /**
         * Creates a CompressedExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         */ CompressedExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.CompressedExistenceProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.CompressedExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $972bbf554730909d$var$$util.base64.decode(object.key, message.key = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $972bbf554730909d$var$$util.base64.decode(object.value, message.value = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
                message.leaf = $972bbf554730909d$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i)message.path[i] = object.path[i] | 0;
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.CompressedExistenceProof} message CompressedExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $972bbf554730909d$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $972bbf554730909d$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $972bbf554730909d$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = message.path[j];
            }
            return object;
        };
        /**
         * Converts this CompressedExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return CompressedExistenceProof;
    }();
    ics23.CompressedNonExistenceProof = function() {
        /**
         * Properties of a CompressedNonExistenceProof.
         * @memberof ics23
         * @interface ICompressedNonExistenceProof
         * @property {Uint8Array|null} [key] CompressedNonExistenceProof key
         * @property {ics23.ICompressedExistenceProof|null} [left] CompressedNonExistenceProof left
         * @property {ics23.ICompressedExistenceProof|null} [right] CompressedNonExistenceProof right
         */ /**
         * Constructs a new CompressedNonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedNonExistenceProof.
         * @implements ICompressedNonExistenceProof
         * @constructor
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         */ function CompressedNonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedNonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.key = $972bbf554730909d$var$$util.newBuffer([]);
        /**
         * CompressedNonExistenceProof left.
         * @member {ics23.ICompressedExistenceProof|null|undefined} left
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.left = null;
        /**
         * CompressedNonExistenceProof right.
         * @member {ics23.ICompressedExistenceProof|null|undefined} right
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.right = null;
        /**
         * Creates a new CompressedNonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof instance
         */ CompressedNonExistenceProof.create = function create(properties) {
            return new CompressedNonExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $972bbf554730909d$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = $972bbf554730909d$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $972bbf554730909d$var$$Reader)) reader = new $972bbf554730909d$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedNonExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedNonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $972bbf554730909d$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedNonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         */ CompressedNonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof) return object;
            var message = new $972bbf554730909d$var$$root.ics23.CompressedNonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $972bbf554730909d$var$$util.base64.decode(object.key, message.key = $972bbf554730909d$var$$util.newBuffer($972bbf554730909d$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
                message.left = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
                message.right = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedNonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.CompressedNonExistenceProof} message CompressedNonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedNonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $972bbf554730909d$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $972bbf554730909d$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $972bbf554730909d$var$$root.ics23.CompressedExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this CompressedNonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedNonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $hjb8Q.util.toJSONOptions);
        };
        return CompressedNonExistenceProof;
    }();
    return ics23;
}();
$972bbf554730909d$exports = $972bbf554730909d$var$$root;


Object.defineProperty($ab96c954d31ce75d$exports, "ics23", {
    enumerable: true,
    get: function get() {
        return $972bbf554730909d$exports.ics23;
    }
});
var $3c2e805f181f4402$exports = {};

var $5OlIx = parcelRequire("5OlIx");
"use strict";
Object.defineProperty($3c2e805f181f4402$exports, "__esModule", {
    value: true
});
$3c2e805f181f4402$exports.batchVerifyNonMembership = $3c2e805f181f4402$exports.batchVerifyMembership = $3c2e805f181f4402$exports.verifyNonMembership = $3c2e805f181f4402$exports.verifyMembership = void 0;
var $a8abb5bef4dc9b74$exports = {};
"use strict";
Object.defineProperty($a8abb5bef4dc9b74$exports, "__esModule", {
    value: true
});
$a8abb5bef4dc9b74$exports.decompress = $a8abb5bef4dc9b74$exports.compress = void 0;

function $a8abb5bef4dc9b74$var$compress(proof) {
    if (!proof.batch) return proof;
    return {
        compressed: $a8abb5bef4dc9b74$var$compressBatch(proof.batch)
    };
}
$a8abb5bef4dc9b74$exports.compress = $a8abb5bef4dc9b74$var$compress;
function $a8abb5bef4dc9b74$var$decompress(proof) {
    if (!proof.compressed) return proof;
    return {
        batch: $a8abb5bef4dc9b74$var$decompressBatch(proof.compressed)
    };
}
$a8abb5bef4dc9b74$exports.decompress = $a8abb5bef4dc9b74$var$decompress;
function $a8abb5bef4dc9b74$var$compressBatch(proof) {
    var centries = [];
    var lookup = [];
    var registry = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = proof.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry.exist) {
                var centry = {
                    exist: $a8abb5bef4dc9b74$var$compressExist(entry.exist, lookup, registry)
                };
                centries.push(centry);
            } else if (entry.nonexist) {
                var non = entry.nonexist;
                var centry1 = {
                    nonexist: {
                        key: non.key,
                        left: $a8abb5bef4dc9b74$var$compressExist(non.left, lookup, registry),
                        right: $a8abb5bef4dc9b74$var$compressExist(non.right, lookup, registry)
                    }
                };
                centries.push(centry1);
            } else throw new Error("Unexpected batch entry during compress");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        entries: centries,
        lookupInners: lookup
    };
}
function $a8abb5bef4dc9b74$var$compressExist(exist, lookup, registry) {
    if (!exist) return undefined;
    var path = exist.path.map(function(inner) {
        var sig = $972bbf554730909d$exports.ics23.InnerOp.encode(inner).finish();
        var idx = registry.get(sig);
        if (idx === undefined) {
            idx = lookup.length;
            lookup.push(inner);
            registry.set(sig, idx);
        }
        return idx;
    });
    return {
        key: exist.key,
        value: exist.value,
        leaf: exist.leaf,
        path: path
    };
}
function $a8abb5bef4dc9b74$var$decompressBatch(proof) {
    var lookup = proof.lookupInners;
    var entries = proof.entries.map(function(comp) {
        if (comp.exist) return {
            exist: $a8abb5bef4dc9b74$var$decompressExist(comp.exist, lookup)
        };
        else if (comp.nonexist) {
            var non = comp.nonexist;
            return {
                nonexist: {
                    key: non.key,
                    left: $a8abb5bef4dc9b74$var$decompressExist(non.left, lookup),
                    right: $a8abb5bef4dc9b74$var$decompressExist(non.right, lookup)
                }
            };
        } else throw new Error("Unexpected batch entry during compress");
    });
    return {
        entries: entries
    };
}
function $a8abb5bef4dc9b74$var$decompressExist(exist, lookup) {
    if (!exist) return undefined;
    var key = exist.key, value = exist.value, leaf = exist.leaf, path = exist.path;
    var newPath = (path || []).map(function(idx) {
        return lookup[idx];
    });
    return {
        key: key,
        value: value,
        leaf: leaf,
        path: newPath
    };
}


var $6258ba66330487ac$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($6258ba66330487ac$exports, "__esModule", {
    value: true
});
$6258ba66330487ac$exports.ensureLeftNeighbor = $6258ba66330487ac$exports.ensureSpec = $6258ba66330487ac$exports.calculateExistenceRoot = $6258ba66330487ac$exports.verifyNonExistence = $6258ba66330487ac$exports.verifyExistence = $6258ba66330487ac$exports.smtSpec = $6258ba66330487ac$exports.tendermintSpec = $6258ba66330487ac$exports.iavlSpec = void 0;

var $9f095a5b85707460$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($9f095a5b85707460$exports, "__esModule", {
    value: true
});
$9f095a5b85707460$exports.doHash = $9f095a5b85707460$exports.applyInner = $9f095a5b85707460$exports.applyLeaf = void 0;
var $0e2dc89f69dcedbc$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($0e2dc89f69dcedbc$exports, "__esModule", {
    value: true
});
$0e2dc89f69dcedbc$exports.ripemd160 = $0e2dc89f69dcedbc$exports.RIPEMD160 = void 0;
var $8f315d73d3ea4ce3$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($8f315d73d3ea4ce3$exports, "__esModule", {
    value: true
});
$8f315d73d3ea4ce3$exports.SHA2 = void 0;
var $a6ce48b3ab48b9ab$exports = {};
"use strict";
Object.defineProperty($a6ce48b3ab48b9ab$exports, "__esModule", {
    value: true
});
$a6ce48b3ab48b9ab$exports.output = $a6ce48b3ab48b9ab$exports.exists = $a6ce48b3ab48b9ab$exports.hash = $a6ce48b3ab48b9ab$exports.bytes = $a6ce48b3ab48b9ab$exports.bool = $a6ce48b3ab48b9ab$exports.number = void 0;
function $a6ce48b3ab48b9ab$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("Wrong positive integer: ".concat(n));
}
$a6ce48b3ab48b9ab$exports.number = $a6ce48b3ab48b9ab$var$number;
function $a6ce48b3ab48b9ab$var$bool(b) {
    if (typeof b !== "boolean") throw new Error("Expected boolean, not ".concat(b));
}
$a6ce48b3ab48b9ab$exports.bool = $a6ce48b3ab48b9ab$var$bool;
function $a6ce48b3ab48b9ab$var$bytes(b) {
    for(var _len = arguments.length, lengths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        lengths[_key - 1] = arguments[_key];
    }
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Expected Uint8Array of length ".concat(lengths, ", not of length=").concat(b.length));
}
$a6ce48b3ab48b9ab$exports.bytes = $a6ce48b3ab48b9ab$var$bytes;
function $a6ce48b3ab48b9ab$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a6ce48b3ab48b9ab$var$number(hash.outputLen);
    $a6ce48b3ab48b9ab$var$number(hash.blockLen);
}
$a6ce48b3ab48b9ab$exports.hash = $a6ce48b3ab48b9ab$var$hash;
function $a6ce48b3ab48b9ab$var$exists(instance) {
    var checkFinished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$a6ce48b3ab48b9ab$exports.exists = $a6ce48b3ab48b9ab$var$exists;
function $a6ce48b3ab48b9ab$var$output(out, instance) {
    $a6ce48b3ab48b9ab$var$bytes(out);
    var min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least ".concat(min));
}
$a6ce48b3ab48b9ab$exports.output = $a6ce48b3ab48b9ab$var$output;
var $a6ce48b3ab48b9ab$var$assert = {
    number: $a6ce48b3ab48b9ab$var$number,
    bool: $a6ce48b3ab48b9ab$var$bool,
    bytes: $a6ce48b3ab48b9ab$var$bytes,
    hash: $a6ce48b3ab48b9ab$var$hash,
    exists: $a6ce48b3ab48b9ab$var$exists,
    output: $a6ce48b3ab48b9ab$var$output
};
$a6ce48b3ab48b9ab$exports.default = $a6ce48b3ab48b9ab$var$assert;


var $49471a2e0f4c8b04$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($49471a2e0f4c8b04$exports, "__esModule", {
    value: true
});
$49471a2e0f4c8b04$exports.randomBytes = $49471a2e0f4c8b04$exports.wrapXOFConstructorWithOpts = $49471a2e0f4c8b04$exports.wrapConstructorWithOpts = $49471a2e0f4c8b04$exports.wrapConstructor = $49471a2e0f4c8b04$exports.checkOpts = $49471a2e0f4c8b04$exports.Hash = $49471a2e0f4c8b04$exports.concatBytes = $49471a2e0f4c8b04$exports.toBytes = $49471a2e0f4c8b04$exports.utf8ToBytes = $49471a2e0f4c8b04$exports.asyncLoop = $49471a2e0f4c8b04$exports.nextTick = $49471a2e0f4c8b04$exports.hexToBytes = $49471a2e0f4c8b04$exports.bytesToHex = $49471a2e0f4c8b04$exports.isLE = $49471a2e0f4c8b04$exports.rotr = $49471a2e0f4c8b04$exports.createView = $49471a2e0f4c8b04$exports.u32 = $49471a2e0f4c8b04$exports.u8 = void 0;
var $9e65935f521c6842$exports = {};
"use strict";
Object.defineProperty($9e65935f521c6842$exports, "__esModule", {
    value: true
});
$9e65935f521c6842$exports.crypto = void 0;
$9e65935f521c6842$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


var $49471a2e0f4c8b04$var$u8a = function(a) {
    return a instanceof Uint8Array;
};
// Cast array to different type
var $49471a2e0f4c8b04$var$u8 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
$49471a2e0f4c8b04$exports.u8 = $49471a2e0f4c8b04$var$u8;
var $49471a2e0f4c8b04$var$u32 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
$49471a2e0f4c8b04$exports.u32 = $49471a2e0f4c8b04$var$u32;
// Cast array to view
var $49471a2e0f4c8b04$var$createView = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
$49471a2e0f4c8b04$exports.createView = $49471a2e0f4c8b04$var$createView;
// The rotate right (circular right shift) operation for uint32
var $49471a2e0f4c8b04$var$rotr = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
$49471a2e0f4c8b04$exports.rotr = $49471a2e0f4c8b04$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$49471a2e0f4c8b04$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$49471a2e0f4c8b04$exports.isLE) throw new Error("Non little-endian hardware is not supported");
var $49471a2e0f4c8b04$var$hexes = Array.from({
    length: 256
}, function(v, i) {
    return i.toString(16).padStart(2, "0");
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $49471a2e0f4c8b04$var$bytesToHex(bytes) {
    if (!$49471a2e0f4c8b04$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $49471a2e0f4c8b04$var$hexes[bytes[i]];
    return hex;
}
$49471a2e0f4c8b04$exports.bytesToHex = $49471a2e0f4c8b04$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $49471a2e0f4c8b04$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $aVMuR._)(hex)));
    var len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    var array = new Uint8Array(len / 2);
    for(var i = 0; i < array.length; i++){
        var j = i * 2;
        var hexByte = hex.slice(j, j + 2);
        var byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$49471a2e0f4c8b04$exports.hexToBytes = $49471a2e0f4c8b04$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
var $49471a2e0f4c8b04$var$nextTick = function() {
    var _ref = (0, $6rBFC._)(function() {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function nextTick() {
        return _ref.apply(this, arguments);
    };
}();
$49471a2e0f4c8b04$exports.nextTick = $49471a2e0f4c8b04$var$nextTick;
function $49471a2e0f4c8b04$var$asyncLoop(iters, tick, cb) {
    return $49471a2e0f4c8b04$var$_asyncLoop.apply(this, arguments);
}
function $49471a2e0f4c8b04$var$_asyncLoop() {
    $49471a2e0f4c8b04$var$_asyncLoop = // Returns control to thread each 'tick' ms to avoid blocking
    (0, $6rBFC._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, $49471a2e0f4c8b04$exports.nextTick)()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $49471a2e0f4c8b04$var$_asyncLoop.apply(this, arguments);
}
$49471a2e0f4c8b04$exports.asyncLoop = $49471a2e0f4c8b04$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $49471a2e0f4c8b04$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$49471a2e0f4c8b04$exports.utf8ToBytes = $49471a2e0f4c8b04$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $49471a2e0f4c8b04$var$toBytes(data) {
    if (typeof data === "string") data = $49471a2e0f4c8b04$var$utf8ToBytes(data);
    if (!$49471a2e0f4c8b04$var$u8a(data)) throw new Error("expected Uint8Array, got ".concat(typeof data === "undefined" ? "undefined" : (0, $aVMuR._)(data)));
    return data;
}
$49471a2e0f4c8b04$exports.toBytes = $49471a2e0f4c8b04$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $49471a2e0f4c8b04$var$concatBytes() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var r = new Uint8Array(arrays.reduce(function(sum, a) {
        return sum + a.length;
    }, 0));
    var pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach(function(a) {
        if (!$49471a2e0f4c8b04$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$49471a2e0f4c8b04$exports.concatBytes = $49471a2e0f4c8b04$var$concatBytes;
// For runtime check if class implements interface
var $49471a2e0f4c8b04$var$Hash = /*#__PURE__*/ function() {
    function Hash() {
        (0, $7dKN1._)(this, Hash);
    }
    (0, $eW5pA._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
$49471a2e0f4c8b04$exports.Hash = $49471a2e0f4c8b04$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
var $49471a2e0f4c8b04$var$isPlainObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
};
function $49471a2e0f4c8b04$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$49471a2e0f4c8b04$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    var merged = Object.assign(defaults, opts);
    return merged;
}
$49471a2e0f4c8b04$exports.checkOpts = $49471a2e0f4c8b04$var$checkOpts;
function $49471a2e0f4c8b04$var$wrapConstructor(hashCons) {
    var hashC = function(msg) {
        return hashCons().update($49471a2e0f4c8b04$var$toBytes(msg)).digest();
    };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashCons();
    };
    return hashC;
}
$49471a2e0f4c8b04$exports.wrapConstructor = $49471a2e0f4c8b04$var$wrapConstructor;
function $49471a2e0f4c8b04$var$wrapConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($49471a2e0f4c8b04$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
$49471a2e0f4c8b04$exports.wrapConstructorWithOpts = $49471a2e0f4c8b04$var$wrapConstructorWithOpts;
function $49471a2e0f4c8b04$var$wrapXOFConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($49471a2e0f4c8b04$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
$49471a2e0f4c8b04$exports.wrapXOFConstructorWithOpts = $49471a2e0f4c8b04$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $49471a2e0f4c8b04$var$randomBytes() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ($9e65935f521c6842$exports.crypto && typeof $9e65935f521c6842$exports.crypto.getRandomValues === "function") return $9e65935f521c6842$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$49471a2e0f4c8b04$exports.randomBytes = $49471a2e0f4c8b04$var$randomBytes;


// Polyfill for Safari 14
function $8f315d73d3ea4ce3$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number(value >> _32n & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
var $8f315d73d3ea4ce3$var$SHA2 = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(SHA2, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(SHA2);
    function SHA2(blockLen, outputLen, padOffset, isLE) {
        (0, $7dKN1._)(this, SHA2);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, $49471a2e0f4c8b04$exports.createView)(_this.buffer);
        return _this;
    }
    (0, $eW5pA._)(SHA2, [
        {
            key: "update",
            value: function update(data) {
                $a6ce48b3ab48b9ab$exports.default.exists(this);
                var _this = this, view = _this.view, buffer = _this.buffer, blockLen = _this.blockLen;
                data = (0, $49471a2e0f4c8b04$exports.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    // Fast path: we have at least one block in input, cast it to view and process
                    if (take === blockLen) {
                        var dataView = (0, $49471a2e0f4c8b04$exports.createView)(data);
                        for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    pos += take;
                    if (this.pos === blockLen) {
                        this.process(view, 0);
                        this.pos = 0;
                    }
                }
                this.length += data.length;
                this.roundClean();
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                $a6ce48b3ab48b9ab$exports.default.exists(this);
                $a6ce48b3ab48b9ab$exports.default.output(out, this);
                this.finished = true;
                // Padding
                // We can avoid allocation of buffer for padding completely if it
                // was previously not allocated here. But it won't change performance.
                var _this = this, buffer = _this.buffer, view = _this.view, blockLen = _this.blockLen, isLE = _this.isLE;
                var pos = this.pos;
                // append the bit '1' to the message
                buffer[pos++] = 128;
                this.buffer.subarray(pos).fill(0);
                // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
                if (this.padOffset > blockLen - pos) {
                    this.process(view, 0);
                    pos = 0;
                }
                // Pad until full block byte with zeros
                for(var i = pos; i < blockLen; i++)buffer[i] = 0;
                // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
                // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
                // So we just write lowest 64 bits of that value.
                $8f315d73d3ea4ce3$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
                this.process(view, 0);
                var oview = (0, $49471a2e0f4c8b04$exports.createView)(out);
                var len = this.outputLen;
                // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
                if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                var outLen = len / 4;
                var state = this.get();
                if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
                for(var i1 = 0; i1 < outLen; i1++)oview.setUint32(4 * i1, state[i1], isLE);
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                to || (to = new this.constructor());
                (_to = to).set.apply(_to, (0, $gF0bR._)(this.get()));
                var _this = this, blockLen = _this.blockLen, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, pos = _this.pos;
                to.length = length;
                to.pos = pos;
                to.finished = finished;
                to.destroyed = destroyed;
                if (length % blockLen) to.buffer.set(buffer);
                return to;
            }
        }
    ]);
    return SHA2;
}($49471a2e0f4c8b04$exports.Hash);
$8f315d73d3ea4ce3$exports.SHA2 = $8f315d73d3ea4ce3$var$SHA2;



// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
var $0e2dc89f69dcedbc$var$Rho = new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
var $0e2dc89f69dcedbc$var$Id = Uint8Array.from({
    length: 16
}, function(_, i) {
    return i;
});
var $0e2dc89f69dcedbc$var$Pi = $0e2dc89f69dcedbc$var$Id.map(function(i) {
    return (9 * i + 5) % 16;
});
var $0e2dc89f69dcedbc$var$idxL = [
    $0e2dc89f69dcedbc$var$Id
];
var $0e2dc89f69dcedbc$var$idxR = [
    $0e2dc89f69dcedbc$var$Pi
];
for(var $0e2dc89f69dcedbc$var$i = 0; $0e2dc89f69dcedbc$var$i < 4; $0e2dc89f69dcedbc$var$i++)for(var $0e2dc89f69dcedbc$var$_i = 0, $0e2dc89f69dcedbc$var$_iter = [
    $0e2dc89f69dcedbc$var$idxL,
    $0e2dc89f69dcedbc$var$idxR
]; $0e2dc89f69dcedbc$var$_i < $0e2dc89f69dcedbc$var$_iter.length; $0e2dc89f69dcedbc$var$_i++){
    var $0e2dc89f69dcedbc$var$j = $0e2dc89f69dcedbc$var$_iter[$0e2dc89f69dcedbc$var$_i];
    $0e2dc89f69dcedbc$var$j.push($0e2dc89f69dcedbc$var$j[$0e2dc89f69dcedbc$var$i].map(function(k) {
        return $0e2dc89f69dcedbc$var$Rho[k];
    }));
}
var $0e2dc89f69dcedbc$var$shifts = [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map(function(i) {
    return new Uint8Array(i);
});
var $0e2dc89f69dcedbc$var$shiftsL = $0e2dc89f69dcedbc$var$idxL.map(function(idx, i) {
    return idx.map(function(j) {
        return $0e2dc89f69dcedbc$var$shifts[i][j];
    });
});
var $0e2dc89f69dcedbc$var$shiftsR = $0e2dc89f69dcedbc$var$idxR.map(function(idx, i) {
    return idx.map(function(j) {
        return $0e2dc89f69dcedbc$var$shifts[i][j];
    });
});
var $0e2dc89f69dcedbc$var$Kl = new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
var $0e2dc89f69dcedbc$var$Kr = new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
var $0e2dc89f69dcedbc$var$rotl = function(word, shift) {
    return word << shift | word >>> 32 - shift;
};
// It's called f() in spec.
function $0e2dc89f69dcedbc$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
var $0e2dc89f69dcedbc$var$BUF = new Uint32Array(16);
var $0e2dc89f69dcedbc$var$RIPEMD160 = /*#__PURE__*/ function(_sha2_js_1_SHA2) {
    (0, $cgJ2Y._)(RIPEMD160, _sha2_js_1_SHA2);
    var _super = (0, $hKD8n._)(RIPEMD160);
    function RIPEMD160() {
        (0, $7dKN1._)(this, RIPEMD160);
        var _this;
        _this = _super.call(this, 64, 20, 8, true);
        _this.h0 = 1732584193;
        _this.h1 = -271733879;
        _this.h2 = -1732584194;
        _this.h3 = 271733878;
        _this.h4 = -1009589776;
        return _this;
    }
    (0, $eW5pA._)(RIPEMD160, [
        {
            key: "get",
            value: function get() {
                var _this = this, h0 = _this.h0, h1 = _this.h1, h2 = _this.h2, h3 = _this.h3, h4 = _this.h4;
                return [
                    h0,
                    h1,
                    h2,
                    h3,
                    h4
                ];
            }
        },
        {
            key: "set",
            value: function set(h0, h1, h2, h3, h4) {
                this.h0 = h0 | 0;
                this.h1 = h1 | 0;
                this.h2 = h2 | 0;
                this.h3 = h3 | 0;
                this.h4 = h4 | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                for(var i = 0; i < 16; i++, offset += 4)$0e2dc89f69dcedbc$var$BUF[i] = view.getUint32(offset, true);
                // prettier-ignore
                var al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
                // Instead of iterating 0 to 80, we split it into 5 groups
                // And use the groups in constants, functions, etc. Much simpler
                for(var group = 0; group < 5; group++){
                    var rGroup = 4 - group;
                    var hbl = $0e2dc89f69dcedbc$var$Kl[group], hbr = $0e2dc89f69dcedbc$var$Kr[group]; // prettier-ignore
                    var rl = $0e2dc89f69dcedbc$var$idxL[group], rr = $0e2dc89f69dcedbc$var$idxR[group]; // prettier-ignore
                    var sl = $0e2dc89f69dcedbc$var$shiftsL[group], sr = $0e2dc89f69dcedbc$var$shiftsR[group]; // prettier-ignore
                    for(var i1 = 0; i1 < 16; i1++){
                        var tl = $0e2dc89f69dcedbc$var$rotl(al + $0e2dc89f69dcedbc$var$f(group, bl, cl, dl) + $0e2dc89f69dcedbc$var$BUF[rl[i1]] + hbl, sl[i1]) + el | 0;
                        al = el, el = dl, dl = $0e2dc89f69dcedbc$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
                    }
                    // 2 loops are 10% faster
                    for(var i2 = 0; i2 < 16; i2++){
                        var tr = $0e2dc89f69dcedbc$var$rotl(ar + $0e2dc89f69dcedbc$var$f(rGroup, br, cr, dr) + $0e2dc89f69dcedbc$var$BUF[rr[i2]] + hbr, sr[i2]) + er | 0;
                        ar = er, er = dr, dr = $0e2dc89f69dcedbc$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
                    }
                }
                // Add the compressed chunk to the current hash value
                this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $0e2dc89f69dcedbc$var$BUF.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0);
            }
        }
    ]);
    return RIPEMD160;
}($8f315d73d3ea4ce3$exports.SHA2);
$0e2dc89f69dcedbc$exports.RIPEMD160 = $0e2dc89f69dcedbc$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $0e2dc89f69dcedbc$exports.ripemd160 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $0e2dc89f69dcedbc$var$RIPEMD160();
});


var $aa0c05887ec187ee$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($aa0c05887ec187ee$exports, "__esModule", {
    value: true
});
$aa0c05887ec187ee$exports.sha224 = $aa0c05887ec187ee$exports.sha256 = void 0;


// Choice: a ? b : c
var $aa0c05887ec187ee$var$Chi = function(a, b, c) {
    return a & b ^ ~a & c;
};
// Majority function, true if any two inpust is true
var $aa0c05887ec187ee$var$Maj = function(a, b, c) {
    return a & b ^ a & c ^ b & c;
};
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var $aa0c05887ec187ee$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
var $aa0c05887ec187ee$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var $aa0c05887ec187ee$var$SHA256_W = new Uint32Array(64);
var $aa0c05887ec187ee$var$SHA256 = /*#__PURE__*/ function(_sha2_js_1_SHA2) {
    (0, $cgJ2Y._)(SHA256, _sha2_js_1_SHA2);
    var _super = (0, $hKD8n._)(SHA256);
    function SHA256() {
        (0, $7dKN1._)(this, SHA256);
        var _this;
        _this = _super.call(this, 64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = $aa0c05887ec187ee$var$IV[0] | 0;
        _this.B = $aa0c05887ec187ee$var$IV[1] | 0;
        _this.C = $aa0c05887ec187ee$var$IV[2] | 0;
        _this.D = $aa0c05887ec187ee$var$IV[3] | 0;
        _this.E = $aa0c05887ec187ee$var$IV[4] | 0;
        _this.F = $aa0c05887ec187ee$var$IV[5] | 0;
        _this.G = $aa0c05887ec187ee$var$IV[6] | 0;
        _this.H = $aa0c05887ec187ee$var$IV[7] | 0;
        return _this;
    }
    (0, $eW5pA._)(SHA256, [
        {
            key: "get",
            value: function get() {
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                return [
                    A,
                    B,
                    C,
                    D,
                    E,
                    F,
                    G,
                    H
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(A, B, C, D, E, F, G, H) {
                this.A = A | 0;
                this.B = B | 0;
                this.C = C | 0;
                this.D = D | 0;
                this.E = E | 0;
                this.F = F | 0;
                this.G = G | 0;
                this.H = H | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4)$aa0c05887ec187ee$var$SHA256_W[i] = view.getUint32(offset, false);
                for(var i1 = 16; i1 < 64; i1++){
                    var W15 = $aa0c05887ec187ee$var$SHA256_W[i1 - 15];
                    var W2 = $aa0c05887ec187ee$var$SHA256_W[i1 - 2];
                    var s0 = (0, $49471a2e0f4c8b04$exports.rotr)(W15, 7) ^ (0, $49471a2e0f4c8b04$exports.rotr)(W15, 18) ^ W15 >>> 3;
                    var s1 = (0, $49471a2e0f4c8b04$exports.rotr)(W2, 17) ^ (0, $49471a2e0f4c8b04$exports.rotr)(W2, 19) ^ W2 >>> 10;
                    $aa0c05887ec187ee$var$SHA256_W[i1] = s1 + $aa0c05887ec187ee$var$SHA256_W[i1 - 7] + s0 + $aa0c05887ec187ee$var$SHA256_W[i1 - 16] | 0;
                }
                // Compression function main loop, 64 rounds
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                for(var i2 = 0; i2 < 64; i2++){
                    var sigma1 = (0, $49471a2e0f4c8b04$exports.rotr)(E, 6) ^ (0, $49471a2e0f4c8b04$exports.rotr)(E, 11) ^ (0, $49471a2e0f4c8b04$exports.rotr)(E, 25);
                    var T1 = H + sigma1 + $aa0c05887ec187ee$var$Chi(E, F, G) + $aa0c05887ec187ee$var$SHA256_K[i2] + $aa0c05887ec187ee$var$SHA256_W[i2] | 0;
                    var sigma0 = (0, $49471a2e0f4c8b04$exports.rotr)(A, 2) ^ (0, $49471a2e0f4c8b04$exports.rotr)(A, 13) ^ (0, $49471a2e0f4c8b04$exports.rotr)(A, 22);
                    var T2 = sigma0 + $aa0c05887ec187ee$var$Maj(A, B, C) | 0;
                    H = G;
                    G = F;
                    F = E;
                    E = D + T1 | 0;
                    D = C;
                    C = B;
                    B = A;
                    A = T1 + T2 | 0;
                }
                // Add the compressed chunk to the current hash value
                A = A + this.A | 0;
                B = B + this.B | 0;
                C = C + this.C | 0;
                D = D + this.D | 0;
                E = E + this.E | 0;
                F = F + this.F | 0;
                G = G + this.G | 0;
                H = H + this.H | 0;
                this.set(A, B, C, D, E, F, G, H);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $aa0c05887ec187ee$var$SHA256_W.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.set(0, 0, 0, 0, 0, 0, 0, 0);
                this.buffer.fill(0);
            }
        }
    ]);
    return SHA256;
}($8f315d73d3ea4ce3$exports.SHA2);
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var $aa0c05887ec187ee$var$SHA224 = /*#__PURE__*/ function(SHA256) {
    (0, $cgJ2Y._)(SHA224, SHA256);
    var _super = (0, $hKD8n._)(SHA224);
    function SHA224() {
        (0, $7dKN1._)(this, SHA224);
        var _this;
        _this = _super.call(this);
        _this.A = -1056596264;
        _this.B = 914150663;
        _this.C = 812702999;
        _this.D = -150054599;
        _this.E = -4191439;
        _this.F = 1750603025;
        _this.G = 1694076839;
        _this.H = -1090891868;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}($aa0c05887ec187ee$var$SHA256);
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $aa0c05887ec187ee$exports.sha256 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $aa0c05887ec187ee$var$SHA256();
});
$aa0c05887ec187ee$exports.sha224 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $aa0c05887ec187ee$var$SHA224();
});


var $08a08558924ad90a$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($08a08558924ad90a$exports, "__esModule", {
    value: true
});
$08a08558924ad90a$exports.sha384 = $08a08558924ad90a$exports.sha512_256 = $08a08558924ad90a$exports.sha512_224 = $08a08558924ad90a$exports.sha512 = $08a08558924ad90a$exports.SHA512 = void 0;

var $a04092e4f35f76d8$exports = {};
"use strict";
Object.defineProperty($a04092e4f35f76d8$exports, "__esModule", {
    value: true
});
$a04092e4f35f76d8$exports.add = $a04092e4f35f76d8$exports.toBig = $a04092e4f35f76d8$exports.split = $a04092e4f35f76d8$exports.fromBig = void 0;
var $a04092e4f35f76d8$var$U32_MASK64 = BigInt(Math.pow(2, 32) - 1);
var $a04092e4f35f76d8$var$_32n = BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $a04092e4f35f76d8$var$fromBig(n) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (le) return {
        h: Number(n & $a04092e4f35f76d8$var$U32_MASK64),
        l: Number(n >> $a04092e4f35f76d8$var$_32n & $a04092e4f35f76d8$var$U32_MASK64)
    };
    return {
        h: Number(n >> $a04092e4f35f76d8$var$_32n & $a04092e4f35f76d8$var$U32_MASK64) | 0,
        l: Number(n & $a04092e4f35f76d8$var$U32_MASK64) | 0
    };
}
$a04092e4f35f76d8$exports.fromBig = $a04092e4f35f76d8$var$fromBig;
function $a04092e4f35f76d8$var$split(lst) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for(var i = 0; i < lst.length; i++){
        var _fromBig = $a04092e4f35f76d8$var$fromBig(lst[i], le), h = _fromBig.h, l = _fromBig.l;
        var ref;
        ref = [
            h,
            l
        ], Ah[i] = ref[0], Al[i] = ref[1], ref;
    }
    return [
        Ah,
        Al
    ];
}
$a04092e4f35f76d8$exports.split = $a04092e4f35f76d8$var$split;
var $a04092e4f35f76d8$var$toBig = function(h, l) {
    return BigInt(h >>> 0) << $a04092e4f35f76d8$var$_32n | BigInt(l >>> 0);
};
$a04092e4f35f76d8$exports.toBig = $a04092e4f35f76d8$var$toBig;
// for Shift in [0, 32)
var $a04092e4f35f76d8$var$shrSH = function(h, l, s) {
    return h >>> s;
};
var $a04092e4f35f76d8$var$shrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in [1, 32)
var $a04092e4f35f76d8$var$rotrSH = function(h, l, s) {
    return h >>> s | l << 32 - s;
};
var $a04092e4f35f76d8$var$rotrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var $a04092e4f35f76d8$var$rotrBH = function(h, l, s) {
    return h << 64 - s | l >>> s - 32;
};
var $a04092e4f35f76d8$var$rotrBL = function(h, l, s) {
    return h >>> s - 32 | l << 64 - s;
};
// Right rotate for shift===32 (just swaps l&h)
var $a04092e4f35f76d8$var$rotr32H = function(h, l) {
    return l;
};
var $a04092e4f35f76d8$var$rotr32L = function(h, l) {
    return h;
};
// Left rotate for Shift in [1, 32)
var $a04092e4f35f76d8$var$rotlSH = function(h, l, s) {
    return h << s | l >>> 32 - s;
};
var $a04092e4f35f76d8$var$rotlSL = function(h, l, s) {
    return l << s | h >>> 32 - s;
};
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var $a04092e4f35f76d8$var$rotlBH = function(h, l, s) {
    return l << s - 32 | h >>> 64 - s;
};
var $a04092e4f35f76d8$var$rotlBL = function(h, l, s) {
    return h << s - 32 | l >>> 64 - s;
};
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-
function $a04092e4f35f76d8$var$add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
        l: l | 0
    };
}
$a04092e4f35f76d8$exports.add = $a04092e4f35f76d8$var$add;
// Addition with more than 2 elements
var $a04092e4f35f76d8$var$add3L = function(Al, Bl, Cl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};
var $a04092e4f35f76d8$var$add3H = function(low, Ah, Bh, Ch) {
    return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};
var $a04092e4f35f76d8$var$add4L = function(Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
var $a04092e4f35f76d8$var$add4H = function(low, Ah, Bh, Ch, Dh) {
    return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};
var $a04092e4f35f76d8$var$add5L = function(Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
var $a04092e4f35f76d8$var$add5H = function(low, Ah, Bh, Ch, Dh, Eh) {
    return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};
// prettier-ignore
var $a04092e4f35f76d8$var$u64 = {
    fromBig: $a04092e4f35f76d8$var$fromBig,
    split: $a04092e4f35f76d8$var$split,
    toBig: $a04092e4f35f76d8$exports.toBig,
    shrSH: $a04092e4f35f76d8$var$shrSH,
    shrSL: $a04092e4f35f76d8$var$shrSL,
    rotrSH: $a04092e4f35f76d8$var$rotrSH,
    rotrSL: $a04092e4f35f76d8$var$rotrSL,
    rotrBH: $a04092e4f35f76d8$var$rotrBH,
    rotrBL: $a04092e4f35f76d8$var$rotrBL,
    rotr32H: $a04092e4f35f76d8$var$rotr32H,
    rotr32L: $a04092e4f35f76d8$var$rotr32L,
    rotlSH: $a04092e4f35f76d8$var$rotlSH,
    rotlSL: $a04092e4f35f76d8$var$rotlSL,
    rotlBH: $a04092e4f35f76d8$var$rotlBH,
    rotlBL: $a04092e4f35f76d8$var$rotlBL,
    add: $a04092e4f35f76d8$var$add,
    add3L: $a04092e4f35f76d8$var$add3L,
    add3H: $a04092e4f35f76d8$var$add3H,
    add4L: $a04092e4f35f76d8$var$add4L,
    add4H: $a04092e4f35f76d8$var$add4H,
    add5H: $a04092e4f35f76d8$var$add5H,
    add5L: $a04092e4f35f76d8$var$add5L
};
$a04092e4f35f76d8$exports.default = $a04092e4f35f76d8$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
var $08a08558924ad90a$var$_u64_js_1_default_split = (0, $5OlIx._)($a04092e4f35f76d8$exports.default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
].map(function(n) {
    return BigInt(n);
})), 2), $08a08558924ad90a$var$SHA512_Kh = $08a08558924ad90a$var$_u64_js_1_default_split[0], $08a08558924ad90a$var$SHA512_Kl = $08a08558924ad90a$var$_u64_js_1_default_split[1];
// Temporary buffer, not used to store anything between runs
var $08a08558924ad90a$var$SHA512_W_H = new Uint32Array(80);
var $08a08558924ad90a$var$SHA512_W_L = new Uint32Array(80);
var $08a08558924ad90a$var$SHA512 = /*#__PURE__*/ function(_sha2_js_1_SHA2) {
    (0, $cgJ2Y._)(SHA512, _sha2_js_1_SHA2);
    var _super = (0, $hKD8n._)(SHA512);
    function SHA512() {
        (0, $7dKN1._)(this, SHA512);
        var _this;
        _this = _super.call(this, 128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 1779033703;
        _this.Al = -205731576;
        _this.Bh = -1150833019;
        _this.Bl = -2067093701;
        _this.Ch = 1013904242;
        _this.Cl = -23791573;
        _this.Dh = -1521486534;
        _this.Dl = 1595750129;
        _this.Eh = 1359893119;
        _this.El = -1377402159;
        _this.Fh = -1694144372;
        _this.Fl = 725511199;
        _this.Gh = 528734635;
        _this.Gl = -79577749;
        _this.Hh = 1541459225;
        _this.Hl = 327033209;
        return _this;
    }
    (0, $eW5pA._)(SHA512, [
        {
            // prettier-ignore
            key: "get",
            value: function get() {
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                return [
                    Ah,
                    Al,
                    Bh,
                    Bl,
                    Ch,
                    Cl,
                    Dh,
                    Dl,
                    Eh,
                    El,
                    Fh,
                    Fl,
                    Gh,
                    Gl,
                    Hh,
                    Hl
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
                this.Ah = Ah | 0;
                this.Al = Al | 0;
                this.Bh = Bh | 0;
                this.Bl = Bl | 0;
                this.Ch = Ch | 0;
                this.Cl = Cl | 0;
                this.Dh = Dh | 0;
                this.Dl = Dl | 0;
                this.Eh = Eh | 0;
                this.El = El | 0;
                this.Fh = Fh | 0;
                this.Fl = Fl | 0;
                this.Gh = Gh | 0;
                this.Gl = Gl | 0;
                this.Hh = Hh | 0;
                this.Hl = Hl | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4){
                    $08a08558924ad90a$var$SHA512_W_H[i] = view.getUint32(offset);
                    $08a08558924ad90a$var$SHA512_W_L[i] = view.getUint32(offset += 4);
                }
                for(var i1 = 16; i1 < 80; i1++){
                    // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
                    var W15h = $08a08558924ad90a$var$SHA512_W_H[i1 - 15] | 0;
                    var W15l = $08a08558924ad90a$var$SHA512_W_L[i1 - 15] | 0;
                    var s0h = $a04092e4f35f76d8$exports.default.rotrSH(W15h, W15l, 1) ^ $a04092e4f35f76d8$exports.default.rotrSH(W15h, W15l, 8) ^ $a04092e4f35f76d8$exports.default.shrSH(W15h, W15l, 7);
                    var s0l = $a04092e4f35f76d8$exports.default.rotrSL(W15h, W15l, 1) ^ $a04092e4f35f76d8$exports.default.rotrSL(W15h, W15l, 8) ^ $a04092e4f35f76d8$exports.default.shrSL(W15h, W15l, 7);
                    // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
                    var W2h = $08a08558924ad90a$var$SHA512_W_H[i1 - 2] | 0;
                    var W2l = $08a08558924ad90a$var$SHA512_W_L[i1 - 2] | 0;
                    var s1h = $a04092e4f35f76d8$exports.default.rotrSH(W2h, W2l, 19) ^ $a04092e4f35f76d8$exports.default.rotrBH(W2h, W2l, 61) ^ $a04092e4f35f76d8$exports.default.shrSH(W2h, W2l, 6);
                    var s1l = $a04092e4f35f76d8$exports.default.rotrSL(W2h, W2l, 19) ^ $a04092e4f35f76d8$exports.default.rotrBL(W2h, W2l, 61) ^ $a04092e4f35f76d8$exports.default.shrSL(W2h, W2l, 6);
                    // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
                    var SUMl = $a04092e4f35f76d8$exports.default.add4L(s0l, s1l, $08a08558924ad90a$var$SHA512_W_L[i1 - 7], $08a08558924ad90a$var$SHA512_W_L[i1 - 16]);
                    var SUMh = $a04092e4f35f76d8$exports.default.add4H(SUMl, s0h, s1h, $08a08558924ad90a$var$SHA512_W_H[i1 - 7], $08a08558924ad90a$var$SHA512_W_H[i1 - 16]);
                    $08a08558924ad90a$var$SHA512_W_H[i1] = SUMh | 0;
                    $08a08558924ad90a$var$SHA512_W_L[i1] = SUMl | 0;
                }
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                // Compression function main loop, 80 rounds
                for(var i2 = 0; i2 < 80; i2++){
                    // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
                    var sigma1h = $a04092e4f35f76d8$exports.default.rotrSH(Eh, El, 14) ^ $a04092e4f35f76d8$exports.default.rotrSH(Eh, El, 18) ^ $a04092e4f35f76d8$exports.default.rotrBH(Eh, El, 41);
                    var sigma1l = $a04092e4f35f76d8$exports.default.rotrSL(Eh, El, 14) ^ $a04092e4f35f76d8$exports.default.rotrSL(Eh, El, 18) ^ $a04092e4f35f76d8$exports.default.rotrBL(Eh, El, 41);
                    //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
                    var CHIh = Eh & Fh ^ ~Eh & Gh;
                    var CHIl = El & Fl ^ ~El & Gl;
                    // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
                    // prettier-ignore
                    var T1ll = $a04092e4f35f76d8$exports.default.add5L(Hl, sigma1l, CHIl, $08a08558924ad90a$var$SHA512_Kl[i2], $08a08558924ad90a$var$SHA512_W_L[i2]);
                    var T1h = $a04092e4f35f76d8$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $08a08558924ad90a$var$SHA512_Kh[i2], $08a08558924ad90a$var$SHA512_W_H[i2]);
                    var T1l = T1ll | 0;
                    // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
                    var sigma0h = $a04092e4f35f76d8$exports.default.rotrSH(Ah, Al, 28) ^ $a04092e4f35f76d8$exports.default.rotrBH(Ah, Al, 34) ^ $a04092e4f35f76d8$exports.default.rotrBH(Ah, Al, 39);
                    var sigma0l = $a04092e4f35f76d8$exports.default.rotrSL(Ah, Al, 28) ^ $a04092e4f35f76d8$exports.default.rotrBL(Ah, Al, 34) ^ $a04092e4f35f76d8$exports.default.rotrBL(Ah, Al, 39);
                    var MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
                    var MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
                    Hh = Gh | 0;
                    Hl = Gl | 0;
                    Gh = Fh | 0;
                    Gl = Fl | 0;
                    Fh = Eh | 0;
                    Fl = El | 0;
                    var ref;
                    ref = $a04092e4f35f76d8$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0), Eh = ref.h, El = ref.l, ref;
                    Dh = Ch | 0;
                    Dl = Cl | 0;
                    Ch = Bh | 0;
                    Cl = Bl | 0;
                    Bh = Ah | 0;
                    Bl = Al | 0;
                    var All = $a04092e4f35f76d8$exports.default.add3L(T1l, sigma0l, MAJl);
                    Ah = $a04092e4f35f76d8$exports.default.add3H(All, T1h, sigma0h, MAJh);
                    Al = All | 0;
                }
                var ref1;
                // Add the compressed chunk to the current hash value
                ref1 = $a04092e4f35f76d8$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0), Ah = ref1.h, Al = ref1.l, ref1;
                var ref2;
                ref2 = $a04092e4f35f76d8$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0), Bh = ref2.h, Bl = ref2.l, ref2;
                var ref3;
                ref3 = $a04092e4f35f76d8$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0), Ch = ref3.h, Cl = ref3.l, ref3;
                var ref4;
                ref4 = $a04092e4f35f76d8$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0), Dh = ref4.h, Dl = ref4.l, ref4;
                var ref5;
                ref5 = $a04092e4f35f76d8$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0), Eh = ref5.h, El = ref5.l, ref5;
                var ref6;
                ref6 = $a04092e4f35f76d8$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0), Fh = ref6.h, Fl = ref6.l, ref6;
                var ref7;
                ref7 = $a04092e4f35f76d8$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0), Gh = ref7.h, Gl = ref7.l, ref7;
                var ref8;
                ref8 = $a04092e4f35f76d8$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0), Hh = ref8.h, Hl = ref8.l, ref8;
                this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $08a08558924ad90a$var$SHA512_W_H.fill(0);
                $08a08558924ad90a$var$SHA512_W_L.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
        }
    ]);
    return SHA512;
}($8f315d73d3ea4ce3$exports.SHA2);
$08a08558924ad90a$exports.SHA512 = $08a08558924ad90a$var$SHA512;
var $08a08558924ad90a$var$SHA512_224 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA512_224, SHA512);
    var _super = (0, $hKD8n._)(SHA512_224);
    function SHA512_224() {
        (0, $7dKN1._)(this, SHA512_224);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -1942145080;
        _this.Al = 424955298;
        _this.Bh = 1944164710;
        _this.Bl = -1982016298;
        _this.Ch = 502970286;
        _this.Cl = 855612546;
        _this.Dh = 1738396948;
        _this.Dl = 1479516111;
        _this.Eh = 258812777;
        _this.El = 2077511080;
        _this.Fh = 2011393907;
        _this.Fl = 79989058;
        _this.Gh = 1067287976;
        _this.Gl = 1780299464;
        _this.Hh = 286451373;
        _this.Hl = -1848208735;
        _this.outputLen = 28;
        return _this;
    }
    return SHA512_224;
}($08a08558924ad90a$var$SHA512);
var $08a08558924ad90a$var$SHA512_256 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA512_256, SHA512);
    var _super = (0, $hKD8n._)(SHA512_256);
    function SHA512_256() {
        (0, $7dKN1._)(this, SHA512_256);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 573645204;
        _this.Al = -64227540;
        _this.Bh = -1621794909;
        _this.Bl = -934517566;
        _this.Ch = 596883563;
        _this.Cl = 1867755857;
        _this.Dh = -1774684391;
        _this.Dl = 1497426621;
        _this.Eh = -1775747358;
        _this.El = -1467023389;
        _this.Fh = -1101128155;
        _this.Fl = 1401305490;
        _this.Gh = 721525244;
        _this.Gl = 746961066;
        _this.Hh = 246885852;
        _this.Hl = -2117784414;
        _this.outputLen = 32;
        return _this;
    }
    return SHA512_256;
}($08a08558924ad90a$var$SHA512);
var $08a08558924ad90a$var$SHA384 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA384, SHA512);
    var _super = (0, $hKD8n._)(SHA384);
    function SHA384() {
        (0, $7dKN1._)(this, SHA384);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -876896931;
        _this.Al = -1056596264;
        _this.Bh = 1654270250;
        _this.Bl = 914150663;
        _this.Ch = -1856437926;
        _this.Cl = 812702999;
        _this.Dh = 355462360;
        _this.Dl = -150054599;
        _this.Eh = 1731405415;
        _this.El = -4191439;
        _this.Fh = -1900787065;
        _this.Fl = 1750603025;
        _this.Gh = -619958771;
        _this.Gl = 1694076839;
        _this.Hh = 1203062813;
        _this.Hl = -1090891868;
        _this.outputLen = 48;
        return _this;
    }
    return SHA384;
}($08a08558924ad90a$var$SHA512);
$08a08558924ad90a$exports.sha512 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $08a08558924ad90a$var$SHA512();
});
$08a08558924ad90a$exports.sha512_224 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $08a08558924ad90a$var$SHA512_224();
});
$08a08558924ad90a$exports.sha512_256 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $08a08558924ad90a$var$SHA512_256();
});
$08a08558924ad90a$exports.sha384 = (0, $49471a2e0f4c8b04$exports.wrapConstructor)(function() {
    return new $08a08558924ad90a$var$SHA384();
});



function $9f095a5b85707460$var$applyLeaf(leaf, key, value) {
    if (key.length === 0) throw new Error("Missing key");
    if (value.length === 0) throw new Error("Missing value");
    var pkey = $9f095a5b85707460$var$prepareLeafData($9f095a5b85707460$var$ensureHash(leaf.prehashKey), $9f095a5b85707460$var$ensureLength(leaf.length), key);
    var pvalue = $9f095a5b85707460$var$prepareLeafData($9f095a5b85707460$var$ensureHash(leaf.prehashValue), $9f095a5b85707460$var$ensureLength(leaf.length), value);
    var data = new Uint8Array((0, $gF0bR._)($9f095a5b85707460$var$ensureBytes(leaf.prefix)).concat((0, $gF0bR._)(pkey), (0, $gF0bR._)(pvalue)));
    return $9f095a5b85707460$var$doHash($9f095a5b85707460$var$ensureHash(leaf.hash), data);
}
$9f095a5b85707460$exports.applyLeaf = $9f095a5b85707460$var$applyLeaf;
function $9f095a5b85707460$var$applyInner(inner, child) {
    if (child.length === 0) throw new Error("Inner op needs child value");
    var preimage = new Uint8Array((0, $gF0bR._)($9f095a5b85707460$var$ensureBytes(inner.prefix)).concat((0, $gF0bR._)(child), (0, $gF0bR._)($9f095a5b85707460$var$ensureBytes(inner.suffix))));
    return $9f095a5b85707460$var$doHash($9f095a5b85707460$var$ensureHash(inner.hash), preimage);
}
$9f095a5b85707460$exports.applyInner = $9f095a5b85707460$var$applyInner;
function $9f095a5b85707460$var$ensure(maybe, value) {
    return maybe === undefined || maybe === null ? value : maybe;
}
var $9f095a5b85707460$var$ensureHash = function(h) {
    return $9f095a5b85707460$var$ensure(h, $972bbf554730909d$exports.ics23.HashOp.NO_HASH);
};
var $9f095a5b85707460$var$ensureLength = function(l) {
    return $9f095a5b85707460$var$ensure(l, $972bbf554730909d$exports.ics23.LengthOp.NO_PREFIX);
};
var $9f095a5b85707460$var$ensureBytes = function(b) {
    return $9f095a5b85707460$var$ensure(b, new Uint8Array([]));
};
function $9f095a5b85707460$var$prepareLeafData(hashOp, lengthOp, data) {
    var h = $9f095a5b85707460$var$doHashOrNoop(hashOp, data);
    return $9f095a5b85707460$var$doLengthOp(lengthOp, h);
}
// doHashOrNoop will return the preimage untouched if hashOp == NONE,
// otherwise, perform doHash
function $9f095a5b85707460$var$doHashOrNoop(hashOp, preimage) {
    if (hashOp === $972bbf554730909d$exports.ics23.HashOp.NO_HASH) return preimage;
    return $9f095a5b85707460$var$doHash(hashOp, preimage);
}
// doHash will preform the specified hash on the preimage.
// if hashOp == NONE, it will return an error (use doHashOrNoop if you want different behavior)
function $9f095a5b85707460$var$doHash(hashOp, preimage) {
    switch(hashOp){
        case $972bbf554730909d$exports.ics23.HashOp.SHA256:
            return (0, $aa0c05887ec187ee$exports.sha256)(preimage);
        case $972bbf554730909d$exports.ics23.HashOp.SHA512:
            return (0, $08a08558924ad90a$exports.sha512)(preimage);
        case $972bbf554730909d$exports.ics23.HashOp.RIPEMD160:
            return (0, $0e2dc89f69dcedbc$exports.ripemd160)(preimage);
        case $972bbf554730909d$exports.ics23.HashOp.BITCOIN:
            return (0, $0e2dc89f69dcedbc$exports.ripemd160)((0, $aa0c05887ec187ee$exports.sha256)(preimage));
        case $972bbf554730909d$exports.ics23.HashOp.SHA512_256:
            return (0, $08a08558924ad90a$exports.sha512_256)(preimage);
    }
    throw new Error("Unsupported hashop: ".concat(hashOp));
}
$9f095a5b85707460$exports.doHash = $9f095a5b85707460$var$doHash;
// doLengthOp will calculate the proper prefix and return it prepended
//   doLengthOp(op, data) -> length(data) || data
function $9f095a5b85707460$var$doLengthOp(lengthOp, data) {
    switch(lengthOp){
        case $972bbf554730909d$exports.ics23.LengthOp.NO_PREFIX:
            return data;
        case $972bbf554730909d$exports.ics23.LengthOp.VAR_PROTO:
            return new Uint8Array((0, $gF0bR._)($9f095a5b85707460$var$encodeVarintProto(data.length)).concat((0, $gF0bR._)(data)));
        case $972bbf554730909d$exports.ics23.LengthOp.REQUIRE_32_BYTES:
            if (data.length !== 32) throw new Error("Length is ".concat(data.length, ", not 32 bytes"));
            return data;
        case $972bbf554730909d$exports.ics23.LengthOp.REQUIRE_64_BYTES:
            if (data.length !== 64) throw new Error("Length is ".concat(data.length, ", not 64 bytes"));
            return data;
        case $972bbf554730909d$exports.ics23.LengthOp.FIXED32_LITTLE:
            return new Uint8Array((0, $gF0bR._)($9f095a5b85707460$var$encodeFixed32Le(data.length)).concat((0, $gF0bR._)(data)));
    }
    throw new Error("Unsupported lengthop: ".concat(lengthOp));
}
function $9f095a5b85707460$var$encodeVarintProto(n) {
    var enc = [];
    var l = n;
    while(l >= 128){
        var b = l % 128 + 128;
        enc = (0, $gF0bR._)(enc).concat([
            b
        ]);
        l = l / 128;
    }
    enc = (0, $gF0bR._)(enc).concat([
        l
    ]);
    return new Uint8Array(enc);
}
function $9f095a5b85707460$var$encodeFixed32Le(n) {
    var enc = new Uint8Array(4);
    var l = n;
    for(var i = enc.length; i > 0; i--){
        enc[Math.abs(i - enc.length)] = l % 256;
        l = Math.floor(l / 256);
    }
    return enc;
}


var $da727980b9183ef4$exports = {};
"use strict";
Object.defineProperty($da727980b9183ef4$exports, "__esModule", {
    value: true
});
$da727980b9183ef4$exports.bytesBefore = $da727980b9183ef4$exports.ensureBytesBefore = $da727980b9183ef4$exports.bytesEqual = $da727980b9183ef4$exports.ensureBytesEqual = $da727980b9183ef4$exports.ensureInner = $da727980b9183ef4$exports.ensureLeaf = void 0;
function $da727980b9183ef4$var$ensureLeaf(leaf, spec) {
    if (leaf.hash !== spec.hash) throw new Error("Unexpected hashOp: ".concat(leaf.hash));
    if (leaf.prehashKey !== spec.prehashKey) throw new Error("Unexpected prehashKey: ".concat(leaf.prehashKey));
    if (leaf.prehashValue !== spec.prehashValue) throw new Error("Unexpected prehashValue: ".concat(leaf.prehashValue));
    if (leaf.length !== spec.length) throw new Error("Unexpected length op: ".concat(leaf.length));
    $da727980b9183ef4$var$ensurePrefix(leaf.prefix, spec.prefix);
}
$da727980b9183ef4$exports.ensureLeaf = $da727980b9183ef4$var$ensureLeaf;
function $da727980b9183ef4$var$ensureInner(inner, prefix, spec) {
    if (inner.hash !== spec.hash) throw new Error("Unexpected hashOp: ".concat(inner.hash));
    if (!inner.prefix) throw new Error("No prefix set for inner node");
    if ($da727980b9183ef4$var$hasPrefix(inner.prefix, prefix)) throw new Error("Inner node has leaf prefix");
    if (inner.prefix.length < (spec.minPrefixLength || 0)) throw new Error("Prefix too short: ".concat(inner.prefix.length, " bytes"));
    var maxLeftChildBytes = (spec.childOrder.length - 1) * spec.childSize;
    if (inner.prefix.length > (spec.maxPrefixLength || 0) + maxLeftChildBytes) throw new Error("Prefix too long: ".concat(inner.prefix.length, " bytes"));
}
$da727980b9183ef4$exports.ensureInner = $da727980b9183ef4$var$ensureInner;
function $da727980b9183ef4$var$ensurePrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return;
    if (!check) throw new Error("Target bytes missing");
    $da727980b9183ef4$var$ensureBytesEqual(prefix, check.slice(0, prefix.length));
}
// ensureBytesEqual throws an error if the arrays are different
function $da727980b9183ef4$var$ensureBytesEqual(a, b) {
    if (a.length !== b.length) throw new Error("Different lengths ".concat(a.length, " vs ").concat(b.length));
    for(var i = 0; i < a.length; i++){
        if (a[i] !== b[i]) throw new Error("Arrays differ at index ".concat(i, ": ").concat(a[i], " vs ").concat(b[i]));
    }
}
$da727980b9183ef4$exports.ensureBytesEqual = $da727980b9183ef4$var$ensureBytesEqual;
function $da727980b9183ef4$var$bytesEqual(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$da727980b9183ef4$exports.bytesEqual = $da727980b9183ef4$var$bytesEqual;
function $da727980b9183ef4$var$hasPrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return false;
    if (!check) return false;
    if (check.length <= prefix.length) return false;
    for(var i = 0; i < prefix.length; i++){
        if (check[i] !== prefix[i]) return false;
    }
    throw true;
}
// ensureBytesBefore throws an error if first >= last
// we compare byte by byte
function $da727980b9183ef4$var$ensureBytesBefore(first, last) {
    if (!$da727980b9183ef4$var$bytesBefore(first, last)) throw new Error("first is after last");
}
$da727980b9183ef4$exports.ensureBytesBefore = $da727980b9183ef4$var$ensureBytesBefore;
function $da727980b9183ef4$var$bytesBefore(first, last) {
    var min = first.length < last.length ? first.length : last.length;
    for(var i = 0; i < min; i++){
        if (first[i] < last[i]) return true;
        if (first[i] > last[i]) return false;
    // if they are equal, continue to next step
    }
    // if they match, ensure that last is longer than first..
    return first.length < last.length;
}
$da727980b9183ef4$exports.bytesBefore = $da727980b9183ef4$var$bytesBefore;


$6258ba66330487ac$exports.iavlSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $972bbf554730909d$exports.ics23.HashOp.SHA256,
        prehashValue: $972bbf554730909d$exports.ics23.HashOp.SHA256,
        prehashKey: $972bbf554730909d$exports.ics23.HashOp.NO_HASH,
        length: $972bbf554730909d$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 4,
        maxPrefixLength: 12,
        childSize: 33,
        hash: $972bbf554730909d$exports.ics23.HashOp.SHA256
    }
};
$6258ba66330487ac$exports.tendermintSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $972bbf554730909d$exports.ics23.HashOp.SHA256,
        prehashValue: $972bbf554730909d$exports.ics23.HashOp.SHA256,
        prehashKey: $972bbf554730909d$exports.ics23.HashOp.NO_HASH,
        length: $972bbf554730909d$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 1,
        maxPrefixLength: 1,
        childSize: 32,
        hash: $972bbf554730909d$exports.ics23.HashOp.SHA256
    }
};
$6258ba66330487ac$exports.smtSpec = {
    leafSpec: {
        hash: $972bbf554730909d$exports.ics23.HashOp.SHA256,
        prehashKey: $972bbf554730909d$exports.ics23.HashOp.NO_HASH,
        prehashValue: $972bbf554730909d$exports.ics23.HashOp.SHA256,
        length: $972bbf554730909d$exports.ics23.LengthOp.NO_PREFIX,
        prefix: Uint8Array.from([
            0
        ])
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        childSize: 32,
        minPrefixLength: 1,
        maxPrefixLength: 1,
        emptyChild: new Uint8Array(32),
        hash: $972bbf554730909d$exports.ics23.HashOp.SHA256
    },
    maxDepth: 256
};
// verifyExistence will throw an error if the proof doesn't link key, value -> root
// or if it doesn't fulfill the spec
function $6258ba66330487ac$var$verifyExistence(proof, spec, root, key, value) {
    $6258ba66330487ac$var$ensureSpec(proof, spec);
    var calc = $6258ba66330487ac$var$calculateExistenceRoot(proof);
    (0, $da727980b9183ef4$exports.ensureBytesEqual)(calc, root);
    (0, $da727980b9183ef4$exports.ensureBytesEqual)(key, proof.key);
    (0, $da727980b9183ef4$exports.ensureBytesEqual)(value, proof.value);
}
$6258ba66330487ac$exports.verifyExistence = $6258ba66330487ac$var$verifyExistence;
// Verify does all checks to ensure the proof has valid non-existence proofs,
// and they ensure the given key is not in the CommitmentState,
// throwing an error if there is an issue
function $6258ba66330487ac$var$verifyNonExistence(proof, spec, root, key) {
    var leftKey;
    var rightKey;
    if (proof.left) {
        $6258ba66330487ac$var$verifyExistence(proof.left, spec, root, proof.left.key, proof.left.value);
        leftKey = proof.left.key;
    }
    if (proof.right) {
        $6258ba66330487ac$var$verifyExistence(proof.right, spec, root, proof.right.key, proof.right.value);
        rightKey = proof.right.key;
    }
    if (!leftKey && !rightKey) throw new Error("neither left nor right proof defined");
    if (leftKey) (0, $da727980b9183ef4$exports.ensureBytesBefore)(leftKey, key);
    if (rightKey) (0, $da727980b9183ef4$exports.ensureBytesBefore)(key, rightKey);
    if (!spec.innerSpec) throw new Error("no inner spec");
    if (!leftKey) $6258ba66330487ac$var$ensureLeftMost(spec.innerSpec, proof.right.path);
    else if (!rightKey) $6258ba66330487ac$var$ensureRightMost(spec.innerSpec, proof.left.path);
    else $6258ba66330487ac$var$ensureLeftNeighbor(spec.innerSpec, proof.left.path, proof.right.path);
    return;
}
$6258ba66330487ac$exports.verifyNonExistence = $6258ba66330487ac$var$verifyNonExistence;
// Calculate determines the root hash that matches the given proof.
// You must validate the result is what you have in a header.
// Returns error if the calculations cannot be performed.
function $6258ba66330487ac$var$calculateExistenceRoot(proof) {
    if (!proof.key || !proof.value) throw new Error("Existence proof needs key and value set");
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    var path = proof.path || [];
    var res = (0, $9f095a5b85707460$exports.applyLeaf)(proof.leaf, proof.key, proof.value);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var inner = _step.value;
            res = (0, $9f095a5b85707460$exports.applyInner)(inner, res);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
}
$6258ba66330487ac$exports.calculateExistenceRoot = $6258ba66330487ac$var$calculateExistenceRoot;
// ensureSpec throws an Error if proof doesn't fulfill spec
function $6258ba66330487ac$var$ensureSpec(proof, spec) {
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    if (!spec.leafSpec) throw new Error("Spec must include leafSpec");
    if (!spec.innerSpec) throw new Error("Spec must include innerSpec");
    (0, $da727980b9183ef4$exports.ensureLeaf)(proof.leaf, spec.leafSpec);
    var path = proof.path || [];
    if (spec.minDepth && path.length < spec.minDepth) throw new Error("Too few inner nodes ".concat(path.length));
    if (spec.maxDepth && path.length > spec.maxDepth) throw new Error("Too many inner nodes ".concat(path.length));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var inner = _step.value;
            (0, $da727980b9183ef4$exports.ensureInner)(inner, spec.leafSpec.prefix, spec.innerSpec);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
$6258ba66330487ac$exports.ensureSpec = $6258ba66330487ac$var$ensureSpec;
function $6258ba66330487ac$var$ensureLeftMost(spec, path) {
    var _getPadding = $6258ba66330487ac$var$getPadding(spec, 0), minPrefix = _getPadding.minPrefix, maxPrefix = _getPadding.maxPrefix, suffix = _getPadding.suffix;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // ensure every step has a prefix and suffix defined to be leftmost
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var step = _step.value;
            if (!$6258ba66330487ac$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $6258ba66330487ac$var$ensureRightMost(spec, path) {
    var len = spec.childOrder.length - 1;
    var _getPadding = $6258ba66330487ac$var$getPadding(spec, len), minPrefix = _getPadding.minPrefix, maxPrefix = _getPadding.maxPrefix, suffix = _getPadding.suffix;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // ensure every step has a prefix and suffix defined to be leftmost
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var step = _step.value;
            if (!$6258ba66330487ac$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $6258ba66330487ac$var$ensureLeftNeighbor(spec, left, right) {
    var mutleft = (0, $gF0bR._)(left);
    var mutright = (0, $gF0bR._)(right);
    var topleft = mutleft.pop();
    var topright = mutright.pop();
    while((0, $da727980b9183ef4$exports.bytesEqual)(topleft.prefix, topright.prefix) && (0, $da727980b9183ef4$exports.bytesEqual)(topleft.suffix, topright.suffix)){
        topleft = mutleft.pop();
        topright = mutright.pop();
    }
    // now topleft and topright are the first divergent nodes
    // make sure they are left and right of each other
    if (!$6258ba66330487ac$var$isLeftStep(spec, topleft, topright)) throw new Error("Not left neightbor at first divergent step");
    // make sure the paths are left and right most possibilities respectively
    $6258ba66330487ac$var$ensureRightMost(spec, mutleft);
    $6258ba66330487ac$var$ensureLeftMost(spec, mutright);
}
$6258ba66330487ac$exports.ensureLeftNeighbor = $6258ba66330487ac$var$ensureLeftNeighbor;
// isLeftStep assumes left and right have common parents
// checks if left is exactly one slot to the left of right
function $6258ba66330487ac$var$isLeftStep(spec, left, right) {
    var leftidx = $6258ba66330487ac$var$orderFromPadding(spec, left);
    var rightidx = $6258ba66330487ac$var$orderFromPadding(spec, right);
    return rightidx === leftidx + 1;
}
function $6258ba66330487ac$var$orderFromPadding(spec, inner) {
    for(var branch = 0; branch < spec.childOrder.length; branch++){
        var _getPadding = $6258ba66330487ac$var$getPadding(spec, branch), minPrefix = _getPadding.minPrefix, maxPrefix = _getPadding.maxPrefix, suffix = _getPadding.suffix;
        if ($6258ba66330487ac$var$hasPadding(inner, minPrefix, maxPrefix, suffix)) return branch;
    }
    throw new Error("Cannot find any valid spacing for this node");
}
function $6258ba66330487ac$var$hasPadding(op, minPrefix, maxPrefix, suffix) {
    if ((op.prefix || []).length < minPrefix) return false;
    if ((op.prefix || []).length > maxPrefix) return false;
    return (op.suffix || []).length === suffix;
}
function $6258ba66330487ac$var$getPadding(spec, branch) {
    var idx = $6258ba66330487ac$var$getPosition(spec.childOrder, branch);
    // count how many children are in the prefix
    var prefix = idx * spec.childSize;
    var minPrefix = prefix + spec.minPrefixLength;
    var maxPrefix = prefix + spec.maxPrefixLength;
    // count how many children are in the suffix
    var suffix = (spec.childOrder.length - 1 - idx) * spec.childSize;
    return {
        minPrefix: minPrefix,
        maxPrefix: maxPrefix,
        suffix: suffix
    };
}
function $6258ba66330487ac$var$getPosition(order, branch) {
    if (branch < 0 || branch >= order.length) throw new Error("Invalid branch: ".concat(branch));
    return order.findIndex(function(val) {
        return val === branch;
    });
}



/*
This implements the client side functions as specified in
https://github.com/cosmos/ics/tree/master/spec/ics-023-vector-commitments

In particular:

  // Assumes ExistenceProof
  type verifyMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key, value: Value) => boolean

  // Assumes NonExistenceProof
  type verifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key) => boolean

  // Assumes BatchProof - required ExistenceProofs may be a subset of all items proven
  type batchVerifyMembership = (root: CommitmentRoot, proof: CommitmentProof, items: Map<Key, Value>) => boolean

  // Assumes BatchProof - required NonExistenceProofs may be a subset of all items proven
  type batchVerifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, keys: Set<Key>) => boolean

We make an adjustment to accept a Spec to ensure the provided proof is in the format of the expected merkle store.
This can avoid an range of attacks on fake preimages, as we need to be careful on how to map key, value -> leaf
and determine neighbors
*/ /**
 * verifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $3c2e805f181f4402$var$verifyMembership(proof, spec, root, key, value) {
    var norm = (0, $a8abb5bef4dc9b74$exports.decompress)(proof);
    var exist = $3c2e805f181f4402$var$getExistForKey(norm, key);
    if (!exist) return false;
    try {
        (0, $6258ba66330487ac$exports.verifyExistence)(exist, spec, root, key, value);
        return true;
    } catch (_a) {
        return false;
    }
}
$3c2e805f181f4402$exports.verifyMembership = $3c2e805f181f4402$var$verifyMembership;
/**
 * verifyNonMembership ensures proof is (contains) a valid non-existence proof for the given key
 */ function $3c2e805f181f4402$var$verifyNonMembership(proof, spec, root, key) {
    var norm = (0, $a8abb5bef4dc9b74$exports.decompress)(proof);
    var nonexist = $3c2e805f181f4402$var$getNonExistForKey(norm, key);
    if (!nonexist) return false;
    try {
        (0, $6258ba66330487ac$exports.verifyNonExistence)(nonexist, spec, root, key);
        return true;
    } catch (_a) {
        return false;
    }
}
$3c2e805f181f4402$exports.verifyNonMembership = $3c2e805f181f4402$var$verifyNonMembership;
/**
 * batchVerifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $3c2e805f181f4402$var$batchVerifyMembership(proof, spec, root, items) {
    var norm = (0, $a8abb5bef4dc9b74$exports.decompress)(proof);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $5OlIx._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (!$3c2e805f181f4402$var$verifyMembership(norm, spec, root, key, value)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
$3c2e805f181f4402$exports.batchVerifyMembership = $3c2e805f181f4402$var$batchVerifyMembership;
/**
 * batchVerifyNonMembership ensures proof is (contains) a valid existence proof for the given
 */ function $3c2e805f181f4402$var$batchVerifyNonMembership(proof, spec, root, keys) {
    var norm = (0, $a8abb5bef4dc9b74$exports.decompress)(proof);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!$3c2e805f181f4402$var$verifyNonMembership(norm, spec, root, key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
$3c2e805f181f4402$exports.batchVerifyNonMembership = $3c2e805f181f4402$var$batchVerifyNonMembership;
function $3c2e805f181f4402$var$getExistForKey(proof, key) {
    var match = function(p) {
        return !!p && (0, $da727980b9183ef4$exports.bytesEqual)(key, p.key);
    };
    if (match(proof.exist)) return proof.exist;
    else if (proof.batch) return proof.batch.entries.map(function(x) {
        return x.exist || null;
    }).find(match);
    return undefined;
}
function $3c2e805f181f4402$var$getNonExistForKey(proof, key) {
    var match = function(p) {
        return !!p && (!p.left || (0, $da727980b9183ef4$exports.bytesBefore)(p.left.key, key)) && (!p.right || (0, $da727980b9183ef4$exports.bytesBefore)(key, p.right.key));
    };
    if (match(proof.nonexist)) return proof.nonexist;
    else if (proof.batch) return proof.batch.entries.map(function(x) {
        return x.nonexist || null;
    }).find(match);
    return undefined;
}


Object.defineProperty($ab96c954d31ce75d$exports, "verifyMembership", {
    enumerable: true,
    get: function get() {
        return $3c2e805f181f4402$exports.verifyMembership;
    }
});
Object.defineProperty($ab96c954d31ce75d$exports, "verifyNonMembership", {
    enumerable: true,
    get: function get() {
        return $3c2e805f181f4402$exports.verifyNonMembership;
    }
});

Object.defineProperty($ab96c954d31ce75d$exports, "calculateExistenceRoot", {
    enumerable: true,
    get: function get() {
        return $6258ba66330487ac$exports.calculateExistenceRoot;
    }
});
Object.defineProperty($ab96c954d31ce75d$exports, "iavlSpec", {
    enumerable: true,
    get: function get() {
        return $6258ba66330487ac$exports.iavlSpec;
    }
});
Object.defineProperty($ab96c954d31ce75d$exports, "tendermintSpec", {
    enumerable: true,
    get: function get() {
        return $6258ba66330487ac$exports.tendermintSpec;
    }
});
Object.defineProperty($ab96c954d31ce75d$exports, "verifyExistence", {
    enumerable: true,
    get: function get() {
        return $6258ba66330487ac$exports.verifyExistence;
    }
});
Object.defineProperty($ab96c954d31ce75d$exports, "verifyNonExistence", {
    enumerable: true,
    get: function get() {
        return $6258ba66330487ac$exports.verifyNonExistence;
    }
});



var $lSA9E = parcelRequire("lSA9E");

var $lB6jI = parcelRequire("lB6jI");

var $gMk5u = parcelRequire("gMk5u");
function $39e675a90528da1c$var$checkAndParseOp(op, kind, key) {
    if (op.type !== kind) throw new Error("Op expected to be ".concat(kind, ', got "').concat(op.type));
    if (!(0, $gMk5u.arrayContentEquals)(key, op.key)) throw new Error("Proven key different than queried key.\nQuery: ".concat((0, $lSA9E.toHex)(key), "\nProven: ").concat((0, $lSA9E.toHex)(op.key)));
    return $ab96c954d31ce75d$exports.ics23.CommitmentProof.decode(op.data);
}
var $39e675a90528da1c$var$QueryClient = /*#__PURE__*/ function() {
    function QueryClient(tmClient) {
        (0, $7dKN1._)(this, QueryClient);
        this.tmClient = tmClient;
    }
    (0, $eW5pA._)(QueryClient, [
        {
            key: "queryStoreVerified",
            value: /**
     * Queries the database store with a proof, which is then verified.
     *
     * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
     */ function queryStoreVerified(store, queryKey, desiredHeight) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, height, proof, key, value, subProof, storeProof, header;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.queryRawProof(store, queryKey, desiredHeight)
                                ];
                            case 1:
                                _ref = _state.sent(), height = _ref.height, proof = _ref.proof, key = _ref.key, value = _ref.value;
                                subProof = $39e675a90528da1c$var$checkAndParseOp(proof.ops[0], "ics23:iavl", queryKey);
                                storeProof = $39e675a90528da1c$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $lSA9E.toAscii)(store));
                                // this must always be existence, if the store is not a typo
                                (0, $gMk5u.assert)(storeProof.exist);
                                (0, $gMk5u.assert)(storeProof.exist.value);
                                // this may be exist or non-exist, depends on response
                                if (!value || value.length === 0) {
                                    // non-existence check
                                    (0, $gMk5u.assert)(subProof.nonexist);
                                    // the subproof must map the desired key to the "value" of the storeProof
                                    (0, $ab96c954d31ce75d$exports.verifyNonExistence)(subProof.nonexist, $ab96c954d31ce75d$exports.iavlSpec, storeProof.exist.value, queryKey);
                                } else {
                                    // existence check
                                    (0, $gMk5u.assert)(subProof.exist);
                                    (0, $gMk5u.assert)(subProof.exist.value);
                                    // the subproof must map the desired key to the "value" of the storeProof
                                    (0, $ab96c954d31ce75d$exports.verifyExistence)(subProof.exist, $ab96c954d31ce75d$exports.iavlSpec, storeProof.exist.value, queryKey, value);
                                }
                                return [
                                    4,
                                    _this.getNextHeader(height)
                                ];
                            case 2:
                                header = _state.sent();
                                (0, $ab96c954d31ce75d$exports.verifyExistence)(storeProof.exist, $ab96c954d31ce75d$exports.tendermintSpec, header.appHash, (0, $lSA9E.toAscii)(store), storeProof.exist.value);
                                return [
                                    2,
                                    {
                                        key: key,
                                        value: value,
                                        height: height
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queryRawProof",
            value: function queryRawProof(store, queryKey, desiredHeight) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, key, value, height, proof, code, log, _proof_ops_length;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.tmClient.abciQuery({
                                        // we need the StoreKey for the module, not the module name
                                        // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
                                        path: "/store/".concat(store, "/key"),
                                        data: queryKey,
                                        prove: true,
                                        height: desiredHeight
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), key = _ref.key, value = _ref.value, height = _ref.height, proof = _ref.proof, code = _ref.code, log = _ref.log;
                                if (code) throw new Error("Query failed with (".concat(code, "): ").concat(log));
                                if (!(0, $gMk5u.arrayContentEquals)(queryKey, key)) throw new Error("Response key ".concat((0, $lSA9E.toHex)(key), " doesn't match query key ").concat((0, $lSA9E.toHex)(queryKey)));
                                if (!height) throw new Error("No query height returned");
                                if (!proof || proof.ops.length !== 2) throw new Error("Expected 2 proof ops, got ".concat((_proof_ops_length = proof === null || proof === void 0 ? void 0 : proof.ops.length) !== null && _proof_ops_length !== void 0 ? _proof_ops_length : 0, ". Are you using stargate?"));
                                // we don't need the results, but we can ensure the data is the proper format
                                $39e675a90528da1c$var$checkAndParseOp(proof.ops[0], "ics23:iavl", key);
                                $39e675a90528da1c$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $lSA9E.toAscii)(store));
                                return [
                                    2,
                                    {
                                        key: key,
                                        value: value,
                                        height: height,
                                        // need to clone this: readonly input / writeable output
                                        proof: {
                                            ops: (0, $gF0bR._)(proof.ops)
                                        }
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queryAbci",
            value: /**
     * Performs an ABCI query to Tendermint without requesting a proof.
     *
     * If the `desiredHeight` is set, a particular height is requested. Otherwise
     * the latest height is requested. The response contains the actual height of
     * the query.
     */ function queryAbci(path, request, desiredHeight) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.tmClient.abciQuery({
                                        path: path,
                                        data: request,
                                        prove: false,
                                        height: desiredHeight
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.code) throw new Error("Query failed with (".concat(response.code, "): ").concat(response.log));
                                if (!response.height) throw new Error("No query height returned");
                                return [
                                    2,
                                    {
                                        value: response.value,
                                        height: response.height
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNextHeader",
            value: // this must return the header for height+1
            // throws an error if height is 0 or undefined
            function getNextHeader(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var searchHeight, nextHeader, headersSubscription, firstHeader, correctHeader;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $gMk5u.assertDefined)(height);
                                if (height === 0) throw new Error("Query returned height 0, cannot prove it");
                                searchHeight = height + 1;
                                try {
                                    headersSubscription = _this.tmClient.subscribeNewBlockHeader();
                                } catch (e) {
                                // Ignore exception caused by non-WebSocket Tendermint clients
                                }
                                if (!headersSubscription) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $lB6jI.firstEvent)(headersSubscription)
                                ];
                            case 1:
                                firstHeader = _state.sent();
                                // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
                                if (firstHeader.height === searchHeight) nextHeader = firstHeader;
                                _state.label = 2;
                            case 2:
                                if (!!nextHeader) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.tmClient.blockchain(height, searchHeight)
                                ];
                            case 3:
                                correctHeader = _state.sent().blockMetas.map(function(meta) {
                                    return meta.header;
                                }).find(function(h) {
                                    return h.height === searchHeight;
                                });
                                if (!correctHeader) return [
                                    3,
                                    4
                                ];
                                nextHeader = correctHeader;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    (0, $gMk5u.sleep)(1000)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                (0, $gMk5u.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
                                return [
                                    2,
                                    nextHeader
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "withExtensions",
            value: function withExtensions(tmClient) {
                for(var _len = arguments.length, extensionSetups = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    extensionSetups[_key - 1] = arguments[_key];
                }
                var client = new QueryClient(tmClient);
                var extensions = extensionSetups.map(function(setupExtension) {
                    return setupExtension(client);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = extensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var extension = _step.value;
                        (0, $gMk5u.assert)((0, $gMk5u.isNonNullObject)(extension), "Extension must be a non-null object");
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = Object.entries(extension)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, $5OlIx._)(_step1.value, 2), moduleKey = _step_value[0], moduleValue = _step_value[1];
                                (0, $gMk5u.assert)((0, $gMk5u.isNonNullObject)(moduleValue), "Module must be a non-null object. Found type ".concat(typeof moduleValue === "undefined" ? "undefined" : (0, $aVMuR._)(moduleValue), ' for module "').concat(moduleKey, '".'));
                                var current = client[moduleKey] || {};
                                client[moduleKey] = (0, $4JCw4._)({}, current, moduleValue);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return client;
            }
        }
    ]);
    return QueryClient;
}();
$39e675a90528da1c$exports.QueryClient = $39e675a90528da1c$var$QueryClient;


Object.defineProperty($0f41f7d88b60184b$exports, "QueryClient", {
    enumerable: true,
    get: function get() {
        return $39e675a90528da1c$exports.QueryClient;
    }
});
var $4598c55270a822fd$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $4598c55270a822fd$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4598c55270a822fd$exports, "__esModule", {
    value: true
});
$4598c55270a822fd$exports.decodeCosmosSdkDecFromProto = $4598c55270a822fd$exports.longify = $4598c55270a822fd$exports.createProtobufRpcClient = $4598c55270a822fd$exports.createPagination = $4598c55270a822fd$exports.toAccAddress = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");


var $4598c55270a822fd$var$long_1 = $4598c55270a822fd$var$__importDefault((parcelRequire("l6G6L")));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */ function $4598c55270a822fd$var$toAccAddress(address) {
    return (0, $lSA9E.fromBech32)(address).data;
}
$4598c55270a822fd$exports.toAccAddress = $4598c55270a822fd$var$toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */ function $4598c55270a822fd$var$createPagination(paginationKey) {
    return paginationKey ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial({
        key: paginationKey
    }) : undefined;
}
$4598c55270a822fd$exports.createPagination = $4598c55270a822fd$var$createPagination;
function $4598c55270a822fd$var$createProtobufRpcClient(base) {
    return {
        request: function() {
            var _ref = (0, $6rBFC._)(function(service, method, data) {
                var path, response;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            path = "/".concat(service, "/").concat(method);
                            return [
                                4,
                                base.queryAbci(path, data, undefined)
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response.value
                            ];
                    }
                });
            });
            return function(service, method, data) {
                return _ref.apply(this, arguments);
            };
        }()
    };
}
$4598c55270a822fd$exports.createProtobufRpcClient = $4598c55270a822fd$var$createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */ function $4598c55270a822fd$var$longify(value) {
    var checkedValue = $kTbgy.Uint64.fromString(value.toString());
    return $4598c55270a822fd$var$long_1.default.fromBytesBE((0, $gF0bR._)(checkedValue.toBytesBigEndian()), true);
}
$4598c55270a822fd$exports.longify = $4598c55270a822fd$var$longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */ function $4598c55270a822fd$var$decodeCosmosSdkDecFromProto(input) {
    var asString = typeof input === "string" ? input : (0, $lSA9E.fromAscii)(input);
    return $kTbgy.Decimal.fromAtomics(asString, 18);
}
$4598c55270a822fd$exports.decodeCosmosSdkDecFromProto = $4598c55270a822fd$var$decodeCosmosSdkDecFromProto;


Object.defineProperty($0f41f7d88b60184b$exports, "createPagination", {
    enumerable: true,
    get: function get() {
        return $4598c55270a822fd$exports.createPagination;
    }
});
Object.defineProperty($0f41f7d88b60184b$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function get() {
        return $4598c55270a822fd$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($0f41f7d88b60184b$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function get() {
        return $4598c55270a822fd$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($0f41f7d88b60184b$exports, "longify", {
    enumerable: true,
    get: function get() {
        return $4598c55270a822fd$exports.longify;
    }
});


function $2154cdbd010fe181$var$setupAuthExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var queryService = new $2616eb2bd5b22c20$exports.QueryClientImpl(rpc);
    return {
        auth: {
            account: function() {
                var _ref = (0, $6rBFC._)(function(address) {
                    var account;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Account({
                                        address: address
                                    })
                                ];
                            case 1:
                                account = _state.sent().account;
                                return [
                                    2,
                                    account !== null && account !== void 0 ? account : null
                                ];
                        }
                    });
                });
                return function(address) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$2154cdbd010fe181$exports.setupAuthExtension = $2154cdbd010fe181$var$setupAuthExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupAuthExtension", {
    enumerable: true,
    get: function get() {
        return $2154cdbd010fe181$exports.setupAuthExtension;
    }
});
var $7874dd7ada7f9cac$exports = {};
"use strict";
Object.defineProperty($7874dd7ada7f9cac$exports, "__esModule", {
    value: true
});
$7874dd7ada7f9cac$exports.createAuthzAminoConverters = void 0;
function $7874dd7ada7f9cac$var$createAuthzAminoConverters() {
    return {
    };
}
$7874dd7ada7f9cac$exports.createAuthzAminoConverters = $7874dd7ada7f9cac$var$createAuthzAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function get() {
        return $7874dd7ada7f9cac$exports.createAuthzAminoConverters;
    }
});
var $e3695e9b7d0faee8$exports = {};
"use strict";
Object.defineProperty($e3695e9b7d0faee8$exports, "__esModule", {
    value: true
});
$e3695e9b7d0faee8$exports.authzTypes = void 0;
var $ac8d90c803716555$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $ac8d90c803716555$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac8d90c803716555$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ac8d90c803716555$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ac8d90c803716555$var$__createBinding(result, mod, k);
    }
    $ac8d90c803716555$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ac8d90c803716555$exports, "__esModule", {
    value: true
});
$ac8d90c803716555$exports.MsgClientImpl = $ac8d90c803716555$exports.MsgRevokeResponse = $ac8d90c803716555$exports.MsgRevoke = $ac8d90c803716555$exports.MsgGrantResponse = $ac8d90c803716555$exports.MsgExec = $ac8d90c803716555$exports.MsgExecResponse = $ac8d90c803716555$exports.MsgGrant = $ac8d90c803716555$exports.protobufPackage = void 0;
var $8012beb45f965f3e$exports = {};
"use strict";
var $8012beb45f965f3e$var$__createBinding = $8012beb45f965f3e$exports && $8012beb45f965f3e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8012beb45f965f3e$var$__setModuleDefault = $8012beb45f965f3e$exports && $8012beb45f965f3e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8012beb45f965f3e$var$__importStar = $8012beb45f965f3e$exports && $8012beb45f965f3e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8012beb45f965f3e$var$__createBinding(result, mod, k);
    }
    $8012beb45f965f3e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8012beb45f965f3e$exports, "__esModule", {
    value: true
});
$8012beb45f965f3e$exports.GrantQueueItem = $8012beb45f965f3e$exports.GrantAuthorization = $8012beb45f965f3e$exports.Grant = $8012beb45f965f3e$exports.GenericAuthorization = $8012beb45f965f3e$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $ib0XJ = parcelRequire("ib0XJ");

var $8012beb45f965f3e$var$_m0 = $8012beb45f965f3e$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$8012beb45f965f3e$exports.protobufPackage = "cosmos.authz.v1beta1";
function $8012beb45f965f3e$var$createBaseGenericAuthorization() {
    return {
        msg: ""
    };
}
$8012beb45f965f3e$exports.GenericAuthorization = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8012beb45f965f3e$var$_m0.Writer.create();
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8012beb45f965f3e$var$_m0.Reader ? input : new $8012beb45f965f3e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8012beb45f965f3e$var$createBaseGenericAuthorization();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            msg: (0, $7iZIe.isSet)(object.msg) ? String(object.msg) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8012beb45f965f3e$var$createBaseGenericAuthorization();
        var _object_msg;
        message.msg = (_object_msg = object.msg) !== null && _object_msg !== void 0 ? _object_msg : "";
        return message;
    }
};
function $8012beb45f965f3e$var$createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined
    };
}
$8012beb45f965f3e$exports.Grant = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8012beb45f965f3e$var$_m0.Writer.create();
        if (message.authorization !== undefined) $DM7bi.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $ib0XJ.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8012beb45f965f3e$var$_m0.Reader ? input : new $8012beb45f965f3e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8012beb45f965f3e$var$createBaseGrant();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authorization: (0, $7iZIe.isSet)(object.authorization) ? $DM7bi.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $7iZIe.isSet)(object.expiration) ? (0, $7iZIe.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $DM7bi.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $7iZIe.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8012beb45f965f3e$var$createBaseGrant();
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $DM7bi.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $ib0XJ.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $8012beb45f965f3e$var$createBaseGrantAuthorization() {
    return {
        granter: "",
        grantee: "",
        authorization: undefined,
        expiration: undefined
    };
}
$8012beb45f965f3e$exports.GrantAuthorization = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8012beb45f965f3e$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.authorization !== undefined) $DM7bi.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        if (message.expiration !== undefined) $ib0XJ.Timestamp.encode(message.expiration, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8012beb45f965f3e$var$_m0.Reader ? input : new $8012beb45f965f3e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8012beb45f965f3e$var$createBaseGrantAuthorization();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            authorization: (0, $7iZIe.isSet)(object.authorization) ? $DM7bi.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $7iZIe.isSet)(object.expiration) ? (0, $7iZIe.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined && (obj.authorization = message.authorization ? $DM7bi.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $7iZIe.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8012beb45f965f3e$var$createBaseGrantAuthorization();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $DM7bi.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $ib0XJ.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $8012beb45f965f3e$var$createBaseGrantQueueItem() {
    return {
        msgTypeUrls: []
    };
}
$8012beb45f965f3e$exports.GrantQueueItem = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8012beb45f965f3e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.msgTypeUrls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8012beb45f965f3e$var$_m0.Reader ? input : new $8012beb45f965f3e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8012beb45f965f3e$var$createBaseGrantQueueItem();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgTypeUrls.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            msgTypeUrls: Array.isArray(object === null || object === void 0 ? void 0 : object.msgTypeUrls) ? object.msgTypeUrls.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.msgTypeUrls) obj.msgTypeUrls = message.msgTypeUrls.map(function(e) {
            return e;
        });
        else obj.msgTypeUrls = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_msgTypeUrls;
        var message = $8012beb45f965f3e$var$createBaseGrantQueueItem();
        message.msgTypeUrls = ((_object_msgTypeUrls = object.msgTypeUrls) === null || _object_msgTypeUrls === void 0 ? void 0 : _object_msgTypeUrls.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");

var $ac8d90c803716555$var$_m0 = $ac8d90c803716555$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$ac8d90c803716555$exports.protobufPackage = "cosmos.authz.v1beta1";
function $ac8d90c803716555$var$createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined
    };
}
$ac8d90c803716555$exports.MsgGrant = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ac8d90c803716555$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $8012beb45f965f3e$exports.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ac8d90c803716555$var$_m0.Reader ? input : new $ac8d90c803716555$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ac8d90c803716555$var$createBaseMsgGrant();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $8012beb45f965f3e$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            grant: (0, $7iZIe.isSet)(object.grant) ? $8012beb45f965f3e$exports.Grant.fromJSON(object.grant) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $8012beb45f965f3e$exports.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $ac8d90c803716555$var$createBaseMsgGrant();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.grant = object.grant !== undefined && object.grant !== null ? $8012beb45f965f3e$exports.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
function $ac8d90c803716555$var$createBaseMsgExecResponse() {
    return {
        results: []
    };
}
$ac8d90c803716555$exports.MsgExecResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ac8d90c803716555$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ac8d90c803716555$var$_m0.Reader ? input : new $ac8d90c803716555$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ac8d90c803716555$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            results: Array.isArray(object === null || object === void 0 ? void 0 : object.results) ? object.results.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.results) obj.results = message.results.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.results = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_results;
        var message = $ac8d90c803716555$var$createBaseMsgExecResponse();
        message.results = ((_object_results = object.results) === null || _object_results === void 0 ? void 0 : _object_results.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $ac8d90c803716555$var$createBaseMsgExec() {
    return {
        grantee: "",
        msgs: []
    };
}
$ac8d90c803716555$exports.MsgExec = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ac8d90c803716555$var$_m0.Writer.create();
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.msgs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ac8d90c803716555$var$_m0.Reader ? input : new $ac8d90c803716555$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ac8d90c803716555$var$createBaseMsgExec();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object === null || object === void 0 ? void 0 : object.msgs) ? object.msgs.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.msgs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_msgs;
        var message = $ac8d90c803716555$var$createBaseMsgExec();
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.msgs = ((_object_msgs = object.msgs) === null || _object_msgs === void 0 ? void 0 : _object_msgs.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        return message;
    }
};
function $ac8d90c803716555$var$createBaseMsgGrantResponse() {
    return {};
}
$ac8d90c803716555$exports.MsgGrantResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ac8d90c803716555$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ac8d90c803716555$var$_m0.Reader ? input : new $ac8d90c803716555$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ac8d90c803716555$var$createBaseMsgGrantResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $ac8d90c803716555$var$createBaseMsgGrantResponse();
        return message;
    }
};
function $ac8d90c803716555$var$createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: ""
    };
}
$ac8d90c803716555$exports.MsgRevoke = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ac8d90c803716555$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ac8d90c803716555$var$_m0.Reader ? input : new $ac8d90c803716555$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ac8d90c803716555$var$createBaseMsgRevoke();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $7iZIe.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial: function(object) {
        var message = $ac8d90c803716555$var$createBaseMsgRevoke();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        var _object_msgTypeUrl;
        message.msgTypeUrl = (_object_msgTypeUrl = object.msgTypeUrl) !== null && _object_msgTypeUrl !== void 0 ? _object_msgTypeUrl : "";
        return message;
    }
};
function $ac8d90c803716555$var$createBaseMsgRevokeResponse() {
    return {};
}
$ac8d90c803716555$exports.MsgRevokeResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ac8d90c803716555$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $ac8d90c803716555$var$_m0.Reader ? input : new $ac8d90c803716555$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $ac8d90c803716555$var$createBaseMsgRevokeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $ac8d90c803716555$var$createBaseMsgRevokeResponse();
        return message;
    }
};
var $ac8d90c803716555$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "Grant",
            value: function Grant(request) {
                var data = $ac8d90c803716555$exports.MsgGrant.encode(request).finish();
                var promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
                return promise.then(function(data) {
                    return $ac8d90c803716555$exports.MsgGrantResponse.decode(new $ac8d90c803716555$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Exec",
            value: function Exec(request) {
                var data = $ac8d90c803716555$exports.MsgExec.encode(request).finish();
                var promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
                return promise.then(function(data) {
                    return $ac8d90c803716555$exports.MsgExecResponse.decode(new $ac8d90c803716555$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Revoke",
            value: function Revoke(request) {
                var data = $ac8d90c803716555$exports.MsgRevoke.encode(request).finish();
                var promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
                return promise.then(function(data) {
                    return $ac8d90c803716555$exports.MsgRevokeResponse.decode(new $ac8d90c803716555$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$ac8d90c803716555$exports.MsgClientImpl = $ac8d90c803716555$var$MsgClientImpl;


$e3695e9b7d0faee8$exports.authzTypes = [
    [
        "/cosmos.authz.v1beta1.MsgExec",
        $ac8d90c803716555$exports.MsgExec
    ],
    [
        "/cosmos.authz.v1beta1.MsgGrant",
        $ac8d90c803716555$exports.MsgGrant
    ],
    [
        "/cosmos.authz.v1beta1.MsgRevoke",
        $ac8d90c803716555$exports.MsgRevoke
    ]
];


Object.defineProperty($0aaecf7be71ff9a4$exports, "authzTypes", {
    enumerable: true,
    get: function get() {
        return $e3695e9b7d0faee8$exports.authzTypes;
    }
});
var $61dec385b80406f0$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($61dec385b80406f0$exports, "__esModule", {
    value: true
});
$61dec385b80406f0$exports.setupAuthzExtension = void 0;
var $eaff5721b49b461c$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $eaff5721b49b461c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eaff5721b49b461c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eaff5721b49b461c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eaff5721b49b461c$var$__createBinding(result, mod, k);
    }
    $eaff5721b49b461c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($eaff5721b49b461c$exports, "__esModule", {
    value: true
});
$eaff5721b49b461c$exports.QueryClientImpl = $eaff5721b49b461c$exports.QueryGranteeGrantsResponse = $eaff5721b49b461c$exports.QueryGranteeGrantsRequest = $eaff5721b49b461c$exports.QueryGranterGrantsResponse = $eaff5721b49b461c$exports.QueryGranterGrantsRequest = $eaff5721b49b461c$exports.QueryGrantsResponse = $eaff5721b49b461c$exports.QueryGrantsRequest = $eaff5721b49b461c$exports.protobufPackage = void 0;



var $eaff5721b49b461c$var$_m0 = $eaff5721b49b461c$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$eaff5721b49b461c$exports.protobufPackage = "cosmos.authz.v1beta1";
function $eaff5721b49b461c$var$createBaseQueryGrantsRequest() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: "",
        pagination: undefined
    };
}
$eaff5721b49b461c$exports.QueryGrantsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $eaff5721b49b461c$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $eaff5721b49b461c$var$_m0.Reader ? input : new $eaff5721b49b461c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $eaff5721b49b461c$var$createBaseQueryGrantsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                case 4:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $7iZIe.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $eaff5721b49b461c$var$createBaseQueryGrantsRequest();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        var _object_msgTypeUrl;
        message.msgTypeUrl = (_object_msgTypeUrl = object.msgTypeUrl) !== null && _object_msgTypeUrl !== void 0 ? _object_msgTypeUrl : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $eaff5721b49b461c$var$createBaseQueryGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$eaff5721b49b461c$exports.QueryGrantsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $eaff5721b49b461c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.grants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $8012beb45f965f3e$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $eaff5721b49b461c$var$_m0.Reader ? input : new $eaff5721b49b461c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $eaff5721b49b461c$var$createBaseQueryGrantsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($8012beb45f965f3e$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(function(e) {
                return $8012beb45f965f3e$exports.Grant.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.grants) obj.grants = message.grants.map(function(e) {
            return e ? $8012beb45f965f3e$exports.Grant.toJSON(e) : undefined;
        });
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_grants;
        var message = $eaff5721b49b461c$var$createBaseQueryGrantsResponse();
        message.grants = ((_object_grants = object.grants) === null || _object_grants === void 0 ? void 0 : _object_grants.map(function(e) {
            return $8012beb45f965f3e$exports.Grant.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $eaff5721b49b461c$var$createBaseQueryGranterGrantsRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
$eaff5721b49b461c$exports.QueryGranterGrantsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $eaff5721b49b461c$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $eaff5721b49b461c$var$_m0.Reader ? input : new $eaff5721b49b461c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $eaff5721b49b461c$var$createBaseQueryGranterGrantsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $eaff5721b49b461c$var$createBaseQueryGranterGrantsRequest();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $eaff5721b49b461c$var$createBaseQueryGranterGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$eaff5721b49b461c$exports.QueryGranterGrantsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $eaff5721b49b461c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.grants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $8012beb45f965f3e$exports.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $eaff5721b49b461c$var$_m0.Reader ? input : new $eaff5721b49b461c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $eaff5721b49b461c$var$createBaseQueryGranterGrantsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($8012beb45f965f3e$exports.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(function(e) {
                return $8012beb45f965f3e$exports.GrantAuthorization.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.grants) obj.grants = message.grants.map(function(e) {
            return e ? $8012beb45f965f3e$exports.GrantAuthorization.toJSON(e) : undefined;
        });
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_grants;
        var message = $eaff5721b49b461c$var$createBaseQueryGranterGrantsResponse();
        message.grants = ((_object_grants = object.grants) === null || _object_grants === void 0 ? void 0 : _object_grants.map(function(e) {
            return $8012beb45f965f3e$exports.GrantAuthorization.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $eaff5721b49b461c$var$createBaseQueryGranteeGrantsRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
$eaff5721b49b461c$exports.QueryGranteeGrantsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $eaff5721b49b461c$var$_m0.Writer.create();
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $eaff5721b49b461c$var$_m0.Reader ? input : new $eaff5721b49b461c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $eaff5721b49b461c$var$createBaseQueryGranteeGrantsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $eaff5721b49b461c$var$createBaseQueryGranteeGrantsRequest();
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $eaff5721b49b461c$var$createBaseQueryGranteeGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$eaff5721b49b461c$exports.QueryGranteeGrantsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $eaff5721b49b461c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.grants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $8012beb45f965f3e$exports.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $eaff5721b49b461c$var$_m0.Reader ? input : new $eaff5721b49b461c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $eaff5721b49b461c$var$createBaseQueryGranteeGrantsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($8012beb45f965f3e$exports.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            grants: Array.isArray(object === null || object === void 0 ? void 0 : object.grants) ? object.grants.map(function(e) {
                return $8012beb45f965f3e$exports.GrantAuthorization.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.grants) obj.grants = message.grants.map(function(e) {
            return e ? $8012beb45f965f3e$exports.GrantAuthorization.toJSON(e) : undefined;
        });
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_grants;
        var message = $eaff5721b49b461c$var$createBaseQueryGranteeGrantsResponse();
        message.grants = ((_object_grants = object.grants) === null || _object_grants === void 0 ? void 0 : _object_grants.map(function(e) {
            return $8012beb45f965f3e$exports.GrantAuthorization.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
var $eaff5721b49b461c$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Grants = this.Grants.bind(this);
        this.GranterGrants = this.GranterGrants.bind(this);
        this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Grants",
            value: function Grants(request) {
                var data = $eaff5721b49b461c$exports.QueryGrantsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
                return promise.then(function(data) {
                    return $eaff5721b49b461c$exports.QueryGrantsResponse.decode(new $eaff5721b49b461c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "GranterGrants",
            value: function GranterGrants(request) {
                var data = $eaff5721b49b461c$exports.QueryGranterGrantsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
                return promise.then(function(data) {
                    return $eaff5721b49b461c$exports.QueryGranterGrantsResponse.decode(new $eaff5721b49b461c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "GranteeGrants",
            value: function GranteeGrants(request) {
                var data = $eaff5721b49b461c$exports.QueryGranteeGrantsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
                return promise.then(function(data) {
                    return $eaff5721b49b461c$exports.QueryGranteeGrantsResponse.decode(new $eaff5721b49b461c$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$eaff5721b49b461c$exports.QueryClientImpl = $eaff5721b49b461c$var$QueryClientImpl;



function $61dec385b80406f0$var$setupAuthzExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    var queryService = new $eaff5721b49b461c$exports.QueryClientImpl(rpc);
    return {
        authz: {
            grants: function() {
                var _ref = (0, $6rBFC._)(function(granter, grantee, msgTypeUrl, paginationKey) {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Grants({
                                        granter: granter,
                                        grantee: grantee,
                                        msgTypeUrl: msgTypeUrl,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function(granter, grantee, msgTypeUrl, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            granteeGrants: function() {
                var _ref = (0, $6rBFC._)(function(grantee, paginationKey) {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.GranteeGrants({
                                        grantee: grantee,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function(grantee, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            granterGrants: function() {
                var _ref = (0, $6rBFC._)(function(granter, paginationKey) {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.GranterGrants({
                                        granter: granter,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function(granter, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$61dec385b80406f0$exports.setupAuthzExtension = $61dec385b80406f0$var$setupAuthzExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupAuthzExtension", {
    enumerable: true,
    get: function get() {
        return $61dec385b80406f0$exports.setupAuthzExtension;
    }
});
var $83942b8e5f11c0cd$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($83942b8e5f11c0cd$exports, "__esModule", {
    value: true
});
$83942b8e5f11c0cd$exports.createBankAminoConverters = $83942b8e5f11c0cd$exports.isAminoMsgMultiSend = $83942b8e5f11c0cd$exports.isAminoMsgSend = void 0;
function $83942b8e5f11c0cd$var$isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$83942b8e5f11c0cd$exports.isAminoMsgSend = $83942b8e5f11c0cd$var$isAminoMsgSend;
function $83942b8e5f11c0cd$var$isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$83942b8e5f11c0cd$exports.isAminoMsgMultiSend = $83942b8e5f11c0cd$var$isAminoMsgMultiSend;
function $83942b8e5f11c0cd$var$createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: function(param) {
                var fromAddress = param.fromAddress, toAddress = param.toAddress, amount = param.amount;
                return {
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: (0, $gF0bR._)(amount)
                };
            },
            fromAmino: function(param) {
                var from_address = param.from_address, to_address = param.to_address, amount = param.amount;
                return {
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: (0, $gF0bR._)(amount)
                };
            }
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: function(param) {
                var inputs = param.inputs, outputs = param.outputs;
                return {
                    inputs: inputs.map(function(input) {
                        return {
                            address: input.address,
                            coins: (0, $gF0bR._)(input.coins)
                        };
                    }),
                    outputs: outputs.map(function(output) {
                        return {
                            address: output.address,
                            coins: (0, $gF0bR._)(output.coins)
                        };
                    })
                };
            },
            fromAmino: function(param) {
                var inputs = param.inputs, outputs = param.outputs;
                return {
                    inputs: inputs.map(function(input) {
                        return {
                            address: input.address,
                            coins: (0, $gF0bR._)(input.coins)
                        };
                    }),
                    outputs: outputs.map(function(output) {
                        return {
                            address: output.address,
                            coins: (0, $gF0bR._)(output.coins)
                        };
                    })
                };
            }
        }
    };
}
$83942b8e5f11c0cd$exports.createBankAminoConverters = $83942b8e5f11c0cd$var$createBankAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function get() {
        return $83942b8e5f11c0cd$exports.createBankAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function get() {
        return $83942b8e5f11c0cd$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function get() {
        return $83942b8e5f11c0cd$exports.isAminoMsgSend;
    }
});
var $aa2a133ba8342ad2$exports = {};
"use strict";
Object.defineProperty($aa2a133ba8342ad2$exports, "__esModule", {
    value: true
});
$aa2a133ba8342ad2$exports.isMsgSendEncodeObject = $aa2a133ba8342ad2$exports.bankTypes = void 0;

$aa2a133ba8342ad2$exports.bankTypes = [
    [
        "/cosmos.bank.v1beta1.MsgMultiSend",
        $ff872d712a668d44$exports.MsgMultiSend
    ],
    [
        "/cosmos.bank.v1beta1.MsgSend",
        $ff872d712a668d44$exports.MsgSend
    ]
];
function $aa2a133ba8342ad2$var$isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
$aa2a133ba8342ad2$exports.isMsgSendEncodeObject = $aa2a133ba8342ad2$var$isMsgSendEncodeObject;


Object.defineProperty($0aaecf7be71ff9a4$exports, "bankTypes", {
    enumerable: true,
    get: function get() {
        return $aa2a133ba8342ad2$exports.bankTypes;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function get() {
        return $aa2a133ba8342ad2$exports.isMsgSendEncodeObject;
    }
});
var $80e9a8e30425a423$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($80e9a8e30425a423$exports, "__esModule", {
    value: true
});
$80e9a8e30425a423$exports.setupBankExtension = void 0;

var $gMk5u = parcelRequire("gMk5u");
var $f31275ea6135cb18$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $f31275ea6135cb18$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f31275ea6135cb18$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f31275ea6135cb18$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f31275ea6135cb18$var$__createBinding(result, mod, k);
    }
    $f31275ea6135cb18$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f31275ea6135cb18$exports, "__esModule", {
    value: true
});
$f31275ea6135cb18$exports.QueryClientImpl = $f31275ea6135cb18$exports.QuerySendEnabledResponse = $f31275ea6135cb18$exports.QuerySendEnabledRequest = $f31275ea6135cb18$exports.QueryDenomOwnersResponse = $f31275ea6135cb18$exports.DenomOwner = $f31275ea6135cb18$exports.QueryDenomOwnersRequest = $f31275ea6135cb18$exports.QueryDenomMetadataResponse = $f31275ea6135cb18$exports.QueryDenomMetadataRequest = $f31275ea6135cb18$exports.QueryDenomsMetadataResponse = $f31275ea6135cb18$exports.QueryDenomsMetadataRequest = $f31275ea6135cb18$exports.QueryParamsResponse = $f31275ea6135cb18$exports.QueryParamsRequest = $f31275ea6135cb18$exports.QuerySupplyOfResponse = $f31275ea6135cb18$exports.QuerySupplyOfRequest = $f31275ea6135cb18$exports.QueryTotalSupplyResponse = $f31275ea6135cb18$exports.QueryTotalSupplyRequest = $f31275ea6135cb18$exports.QuerySpendableBalanceByDenomResponse = $f31275ea6135cb18$exports.QuerySpendableBalanceByDenomRequest = $f31275ea6135cb18$exports.QuerySpendableBalancesResponse = $f31275ea6135cb18$exports.QuerySpendableBalancesRequest = $f31275ea6135cb18$exports.QueryAllBalancesResponse = $f31275ea6135cb18$exports.QueryAllBalancesRequest = $f31275ea6135cb18$exports.QueryBalanceResponse = $f31275ea6135cb18$exports.QueryBalanceRequest = $f31275ea6135cb18$exports.protobufPackage = void 0;




var $f31275ea6135cb18$var$_m0 = $f31275ea6135cb18$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$f31275ea6135cb18$exports.protobufPackage = "cosmos.bank.v1beta1";
function $f31275ea6135cb18$var$createBaseQueryBalanceRequest() {
    return {
        address: "",
        denom: ""
    };
}
$f31275ea6135cb18$exports.QueryBalanceRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryBalanceRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryBalanceRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryBalanceResponse() {
    return {
        balance: undefined
    };
}
$f31275ea6135cb18$exports.QueryBalanceResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.balance !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryBalanceResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            balance: (0, $7iZIe.isSet)(object.balance) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $5bc8eb379b028930$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryBalanceResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryAllBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryAllBalancesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryAllBalancesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryAllBalancesRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryAllBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryAllBalancesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.balances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryAllBalancesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            balances: Array.isArray(object === null || object === void 0 ? void 0 : object.balances) ? object.balances.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.balances) obj.balances = message.balances.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_balances;
        var message = $f31275ea6135cb18$var$createBaseQueryAllBalancesResponse();
        message.balances = ((_object_balances = object.balances) === null || _object_balances === void 0 ? void 0 : _object_balances.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySpendableBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QuerySpendableBalancesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalancesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalancesRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySpendableBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QuerySpendableBalancesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.balances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalancesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            balances: Array.isArray(object === null || object === void 0 ? void 0 : object.balances) ? object.balances.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.balances) obj.balances = message.balances.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_balances;
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalancesResponse();
        message.balances = ((_object_balances = object.balances) === null || _object_balances === void 0 ? void 0 : _object_balances.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySpendableBalanceByDenomRequest() {
    return {
        address: "",
        denom: ""
    };
}
$f31275ea6135cb18$exports.QuerySpendableBalanceByDenomRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalanceByDenomRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalanceByDenomRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySpendableBalanceByDenomResponse() {
    return {
        balance: undefined
    };
}
$f31275ea6135cb18$exports.QuerySpendableBalanceByDenomResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.balance !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalanceByDenomResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            balance: (0, $7iZIe.isSet)(object.balance) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $5bc8eb379b028930$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQuerySpendableBalanceByDenomResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryTotalSupplyRequest() {
    return {
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryTotalSupplyRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryTotalSupplyRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryTotalSupplyRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryTotalSupplyResponse() {
    return {
        supply: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryTotalSupplyResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.supply[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryTotalSupplyResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.supply.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            supply: Array.isArray(object === null || object === void 0 ? void 0 : object.supply) ? object.supply.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.supply) obj.supply = message.supply.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.supply = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_supply;
        var message = $f31275ea6135cb18$var$createBaseQueryTotalSupplyResponse();
        message.supply = ((_object_supply = object.supply) === null || _object_supply === void 0 ? void 0 : _object_supply.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySupplyOfRequest() {
    return {
        denom: ""
    };
}
$f31275ea6135cb18$exports.QuerySupplyOfRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySupplyOfRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQuerySupplyOfRequest();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySupplyOfResponse() {
    return {
        amount: undefined
    };
}
$f31275ea6135cb18$exports.QuerySupplyOfResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.amount !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySupplyOfResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            amount: (0, $7iZIe.isSet)(object.amount) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $5bc8eb379b028930$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQuerySupplyOfResponse();
        message.amount = object.amount !== undefined && object.amount !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryParamsRequest() {
    return {};
}
$f31275ea6135cb18$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $f31275ea6135cb18$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$f31275ea6135cb18$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.params !== undefined) $fbc4fefeee7baa98$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $fbc4fefeee7baa98$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $fbc4fefeee7baa98$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $fbc4fefeee7baa98$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $fbc4fefeee7baa98$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryDenomsMetadataRequest() {
    return {
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryDenomsMetadataRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomsMetadataRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryDenomsMetadataRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryDenomsMetadataResponse() {
    return {
        metadatas: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryDenomsMetadataResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.metadatas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $fbc4fefeee7baa98$exports.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomsMetadataResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadatas.push($fbc4fefeee7baa98$exports.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            metadatas: Array.isArray(object === null || object === void 0 ? void 0 : object.metadatas) ? object.metadatas.map(function(e) {
                return $fbc4fefeee7baa98$exports.Metadata.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.metadatas) obj.metadatas = message.metadatas.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.Metadata.toJSON(e) : undefined;
        });
        else obj.metadatas = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_metadatas;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomsMetadataResponse();
        message.metadatas = ((_object_metadatas = object.metadatas) === null || _object_metadatas === void 0 ? void 0 : _object_metadatas.map(function(e) {
            return $fbc4fefeee7baa98$exports.Metadata.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryDenomMetadataRequest() {
    return {
        denom: ""
    };
}
$f31275ea6135cb18$exports.QueryDenomMetadataRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomMetadataRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryDenomMetadataRequest();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryDenomMetadataResponse() {
    return {
        metadata: undefined
    };
}
$f31275ea6135cb18$exports.QueryDenomMetadataResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.metadata !== undefined) $fbc4fefeee7baa98$exports.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomMetadataResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadata = $fbc4fefeee7baa98$exports.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            metadata: (0, $7iZIe.isSet)(object.metadata) ? $fbc4fefeee7baa98$exports.Metadata.fromJSON(object.metadata) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.metadata !== undefined && (obj.metadata = message.metadata ? $fbc4fefeee7baa98$exports.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryDenomMetadataResponse();
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $fbc4fefeee7baa98$exports.Metadata.fromPartial(object.metadata) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryDenomOwnersRequest() {
    return {
        denom: "",
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryDenomOwnersRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomOwnersRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: (0, $7iZIe.isSet)(object.denom) ? String(object.denom) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseQueryDenomOwnersRequest();
        var _object_denom;
        message.denom = (_object_denom = object.denom) !== null && _object_denom !== void 0 ? _object_denom : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseDenomOwner() {
    return {
        address: "",
        balance: undefined
    };
}
$f31275ea6135cb18$exports.DenomOwner = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.balance !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseDenomOwner();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.balance = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            balance: (0, $7iZIe.isSet)(object.balance) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.balance !== undefined && (obj.balance = message.balance ? $5bc8eb379b028930$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f31275ea6135cb18$var$createBaseDenomOwner();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.balance = object.balance !== undefined && object.balance !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQueryDenomOwnersResponse() {
    return {
        denomOwners: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QueryDenomOwnersResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.denomOwners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $f31275ea6135cb18$exports.DenomOwner.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomOwnersResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomOwners.push($f31275ea6135cb18$exports.DenomOwner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denomOwners: Array.isArray(object === null || object === void 0 ? void 0 : object.denomOwners) ? object.denomOwners.map(function(e) {
                return $f31275ea6135cb18$exports.DenomOwner.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.denomOwners) obj.denomOwners = message.denomOwners.map(function(e) {
            return e ? $f31275ea6135cb18$exports.DenomOwner.toJSON(e) : undefined;
        });
        else obj.denomOwners = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_denomOwners;
        var message = $f31275ea6135cb18$var$createBaseQueryDenomOwnersResponse();
        message.denomOwners = ((_object_denomOwners = object.denomOwners) === null || _object_denomOwners === void 0 ? void 0 : _object_denomOwners.map(function(e) {
            return $f31275ea6135cb18$exports.DenomOwner.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySendEnabledRequest() {
    return {
        denoms: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QuerySendEnabledRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.denoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySendEnabledRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denoms.push(reader.string());
                    break;
                case 99:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denoms: Array.isArray(object === null || object === void 0 ? void 0 : object.denoms) ? object.denoms.map(function(e) {
                return String(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.denoms) obj.denoms = message.denoms.map(function(e) {
            return e;
        });
        else obj.denoms = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_denoms;
        var message = $f31275ea6135cb18$var$createBaseQuerySendEnabledRequest();
        message.denoms = ((_object_denoms = object.denoms) === null || _object_denoms === void 0 ? void 0 : _object_denoms.map(function(e) {
            return e;
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $f31275ea6135cb18$var$createBaseQuerySendEnabledResponse() {
    return {
        sendEnabled: [],
        pagination: undefined
    };
}
$f31275ea6135cb18$exports.QuerySendEnabledResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f31275ea6135cb18$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.sendEnabled[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $fbc4fefeee7baa98$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f31275ea6135cb18$var$_m0.Reader ? input : new $f31275ea6135cb18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f31275ea6135cb18$var$createBaseQuerySendEnabledResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($fbc4fefeee7baa98$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 99:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.sendEnabled) ? object.sendEnabled.map(function(e) {
                return $fbc4fefeee7baa98$exports.SendEnabled.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map(function(e) {
            return e ? $fbc4fefeee7baa98$exports.SendEnabled.toJSON(e) : undefined;
        });
        else obj.sendEnabled = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_sendEnabled;
        var message = $f31275ea6135cb18$var$createBaseQuerySendEnabledResponse();
        message.sendEnabled = ((_object_sendEnabled = object.sendEnabled) === null || _object_sendEnabled === void 0 ? void 0 : _object_sendEnabled.map(function(e) {
            return $fbc4fefeee7baa98$exports.SendEnabled.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
var $f31275ea6135cb18$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.SpendableBalances = this.SpendableBalances.bind(this);
        this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
        this.DenomOwners = this.DenomOwners.bind(this);
        this.SendEnabled = this.SendEnabled.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Balance",
            value: function Balance(request) {
                var data = $f31275ea6135cb18$exports.QueryBalanceRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryBalanceResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AllBalances",
            value: function AllBalances(request) {
                var data = $f31275ea6135cb18$exports.QueryAllBalancesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryAllBalancesResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SpendableBalances",
            value: function SpendableBalances(request) {
                var data = $f31275ea6135cb18$exports.QuerySpendableBalancesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QuerySpendableBalancesResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SpendableBalanceByDenom",
            value: function SpendableBalanceByDenom(request) {
                var data = $f31275ea6135cb18$exports.QuerySpendableBalanceByDenomRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QuerySpendableBalanceByDenomResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TotalSupply",
            value: function TotalSupply() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $f31275ea6135cb18$exports.QueryTotalSupplyRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryTotalSupplyResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SupplyOf",
            value: function SupplyOf(request) {
                var data = $f31275ea6135cb18$exports.QuerySupplyOfRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QuerySupplyOfResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $f31275ea6135cb18$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryParamsResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DenomMetadata",
            value: function DenomMetadata(request) {
                var data = $f31275ea6135cb18$exports.QueryDenomMetadataRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryDenomMetadataResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DenomsMetadata",
            value: function DenomsMetadata() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $f31275ea6135cb18$exports.QueryDenomsMetadataRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryDenomsMetadataResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DenomOwners",
            value: function DenomOwners(request) {
                var data = $f31275ea6135cb18$exports.QueryDenomOwnersRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QueryDenomOwnersResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SendEnabled",
            value: function SendEnabled(request) {
                var data = $f31275ea6135cb18$exports.QuerySendEnabledRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", data);
                return promise.then(function(data) {
                    return $f31275ea6135cb18$exports.QuerySendEnabledResponse.decode(new $f31275ea6135cb18$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$f31275ea6135cb18$exports.QueryClientImpl = $f31275ea6135cb18$var$QueryClientImpl;



function $80e9a8e30425a423$var$setupBankExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var queryService = new $f31275ea6135cb18$exports.QueryClientImpl(rpc);
    return {
        bank: {
            balance: function() {
                var _ref = (0, $6rBFC._)(function(address, denom) {
                    var balance;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Balance({
                                        address: address,
                                        denom: denom
                                    })
                                ];
                            case 1:
                                balance = _state.sent().balance;
                                (0, $gMk5u.assert)(balance);
                                return [
                                    2,
                                    balance
                                ];
                        }
                    });
                });
                return function(address, denom) {
                    return _ref.apply(this, arguments);
                };
            }(),
            allBalances: function() {
                var _ref = (0, $6rBFC._)(function(address) {
                    var balances;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.AllBalances({
                                        address: address
                                    })
                                ];
                            case 1:
                                balances = _state.sent().balances;
                                return [
                                    2,
                                    balances
                                ];
                        }
                    });
                });
                return function(address) {
                    return _ref.apply(this, arguments);
                };
            }(),
            totalSupply: function() {
                var _ref = (0, $6rBFC._)(function(paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.TotalSupply({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            supplyOf: function() {
                var _ref = (0, $6rBFC._)(function(denom) {
                    var amount;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.SupplyOf({
                                        denom: denom
                                    })
                                ];
                            case 1:
                                amount = _state.sent().amount;
                                (0, $gMk5u.assert)(amount);
                                return [
                                    2,
                                    amount
                                ];
                        }
                    });
                });
                return function(denom) {
                    return _ref.apply(this, arguments);
                };
            }(),
            denomMetadata: function() {
                var _ref = (0, $6rBFC._)(function(denom) {
                    var metadata;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DenomMetadata({
                                        denom: denom
                                    })
                                ];
                            case 1:
                                metadata = _state.sent().metadata;
                                (0, $gMk5u.assert)(metadata);
                                return [
                                    2,
                                    metadata
                                ];
                        }
                    });
                });
                return function(denom) {
                    return _ref.apply(this, arguments);
                };
            }(),
            denomsMetadata: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var metadatas;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.DenomsMetadata({
                                    pagination: undefined
                                })
                            ];
                        case 1:
                            metadatas = _state.sent().metadatas;
                            return [
                                2,
                                metadatas
                            ];
                    }
                });
            })
        }
    };
}
$80e9a8e30425a423$exports.setupBankExtension = $80e9a8e30425a423$var$setupBankExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupBankExtension", {
    enumerable: true,
    get: function get() {
        return $80e9a8e30425a423$exports.setupBankExtension;
    }
});
var $28976dcd2084aa52$exports = {};
"use strict";
Object.defineProperty($28976dcd2084aa52$exports, "__esModule", {
    value: true
});
$28976dcd2084aa52$exports.createCrysisAminoConverters = $28976dcd2084aa52$exports.isAminoMsgVerifyInvariant = void 0;
function $28976dcd2084aa52$var$isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$28976dcd2084aa52$exports.isAminoMsgVerifyInvariant = $28976dcd2084aa52$var$isAminoMsgVerifyInvariant;
function $28976dcd2084aa52$var$createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
$28976dcd2084aa52$exports.createCrysisAminoConverters = $28976dcd2084aa52$var$createCrysisAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function get() {
        return $28976dcd2084aa52$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function get() {
        return $28976dcd2084aa52$exports.isAminoMsgVerifyInvariant;
    }
});
var $54c88ca63e60114c$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($54c88ca63e60114c$exports, "__esModule", {
    value: true
});
$54c88ca63e60114c$exports.createDistributionAminoConverters = $54c88ca63e60114c$exports.isAminoMsgFundCommunityPool = $54c88ca63e60114c$exports.isAminoMsgWithdrawValidatorCommission = $54c88ca63e60114c$exports.isAminoMsgWithdrawDelegatorReward = $54c88ca63e60114c$exports.isAminoMsgSetWithdrawAddress = void 0;
function $54c88ca63e60114c$var$isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$54c88ca63e60114c$exports.isAminoMsgSetWithdrawAddress = $54c88ca63e60114c$var$isAminoMsgSetWithdrawAddress;
function $54c88ca63e60114c$var$isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$54c88ca63e60114c$exports.isAminoMsgWithdrawDelegatorReward = $54c88ca63e60114c$var$isAminoMsgWithdrawDelegatorReward;
function $54c88ca63e60114c$var$isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$54c88ca63e60114c$exports.isAminoMsgWithdrawValidatorCommission = $54c88ca63e60114c$var$isAminoMsgWithdrawValidatorCommission;
function $54c88ca63e60114c$var$isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$54c88ca63e60114c$exports.isAminoMsgFundCommunityPool = $54c88ca63e60114c$var$isAminoMsgFundCommunityPool;
function $54c88ca63e60114c$var$createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: function(param) {
                var amount = param.amount, depositor = param.depositor;
                return {
                    amount: (0, $gF0bR._)(amount),
                    depositor: depositor
                };
            },
            fromAmino: function(param) {
                var amount = param.amount, depositor = param.depositor;
                return {
                    amount: (0, $gF0bR._)(amount),
                    depositor: depositor
                };
            }
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: function(param) {
                var delegatorAddress = param.delegatorAddress, withdrawAddress = param.withdrawAddress;
                return {
                    delegator_address: delegatorAddress,
                    withdraw_address: withdrawAddress
                };
            },
            fromAmino: function(param) {
                var delegator_address = param.delegator_address, withdraw_address = param.withdraw_address;
                return {
                    delegatorAddress: delegator_address,
                    withdrawAddress: withdraw_address
                };
            }
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: function(param) {
                var delegatorAddress = param.delegatorAddress, validatorAddress = param.validatorAddress;
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress
                };
            },
            fromAmino: function(param) {
                var delegator_address = param.delegator_address, validator_address = param.validator_address;
                return {
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address
                };
            }
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: function(param) {
                var validatorAddress = param.validatorAddress;
                return {
                    validator_address: validatorAddress
                };
            },
            fromAmino: function(param) {
                var validator_address = param.validator_address;
                return {
                    validatorAddress: validator_address
                };
            }
        }
    };
}
$54c88ca63e60114c$exports.createDistributionAminoConverters = $54c88ca63e60114c$var$createDistributionAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function get() {
        return $54c88ca63e60114c$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function get() {
        return $54c88ca63e60114c$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function get() {
        return $54c88ca63e60114c$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function get() {
        return $54c88ca63e60114c$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function get() {
        return $54c88ca63e60114c$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
var $26cb303d0ece2fd1$exports = {};
"use strict";
Object.defineProperty($26cb303d0ece2fd1$exports, "__esModule", {
    value: true
});
$26cb303d0ece2fd1$exports.isMsgWithdrawDelegatorRewardEncodeObject = $26cb303d0ece2fd1$exports.distributionTypes = void 0;
var $87cae70f73bd5cdd$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $87cae70f73bd5cdd$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $87cae70f73bd5cdd$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $87cae70f73bd5cdd$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $87cae70f73bd5cdd$var$__createBinding(result, mod, k);
    }
    $87cae70f73bd5cdd$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($87cae70f73bd5cdd$exports, "__esModule", {
    value: true
});
$87cae70f73bd5cdd$exports.MsgClientImpl = $87cae70f73bd5cdd$exports.MsgCommunityPoolSpendResponse = $87cae70f73bd5cdd$exports.MsgCommunityPoolSpend = $87cae70f73bd5cdd$exports.MsgUpdateParamsResponse = $87cae70f73bd5cdd$exports.MsgUpdateParams = $87cae70f73bd5cdd$exports.MsgFundCommunityPoolResponse = $87cae70f73bd5cdd$exports.MsgFundCommunityPool = $87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommissionResponse = $87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommission = $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorRewardResponse = $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorReward = $87cae70f73bd5cdd$exports.MsgSetWithdrawAddressResponse = $87cae70f73bd5cdd$exports.MsgSetWithdrawAddress = $87cae70f73bd5cdd$exports.protobufPackage = void 0;

var $a9c94cbd65eace7e$exports = {};
"use strict";
var $a9c94cbd65eace7e$var$__createBinding = $a9c94cbd65eace7e$exports && $a9c94cbd65eace7e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9c94cbd65eace7e$var$__setModuleDefault = $a9c94cbd65eace7e$exports && $a9c94cbd65eace7e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a9c94cbd65eace7e$var$__importStar = $a9c94cbd65eace7e$exports && $a9c94cbd65eace7e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a9c94cbd65eace7e$var$__createBinding(result, mod, k);
    }
    $a9c94cbd65eace7e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a9c94cbd65eace7e$exports, "__esModule", {
    value: true
});
$a9c94cbd65eace7e$exports.CommunityPoolSpendProposalWithDeposit = $a9c94cbd65eace7e$exports.DelegationDelegatorReward = $a9c94cbd65eace7e$exports.DelegatorStartingInfo = $a9c94cbd65eace7e$exports.CommunityPoolSpendProposal = $a9c94cbd65eace7e$exports.FeePool = $a9c94cbd65eace7e$exports.ValidatorSlashEvents = $a9c94cbd65eace7e$exports.ValidatorSlashEvent = $a9c94cbd65eace7e$exports.ValidatorOutstandingRewards = $a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission = $a9c94cbd65eace7e$exports.ValidatorCurrentRewards = $a9c94cbd65eace7e$exports.ValidatorHistoricalRewards = $a9c94cbd65eace7e$exports.Params = $a9c94cbd65eace7e$exports.protobufPackage = void 0;


var $7iZIe = parcelRequire("7iZIe");

var $a9c94cbd65eace7e$var$_m0 = $a9c94cbd65eace7e$var$__importStar((parcelRequire("hjb8Q")));
$a9c94cbd65eace7e$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $a9c94cbd65eace7e$var$createBaseParams() {
    return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: false
    };
}
$a9c94cbd65eace7e$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        if (message.communityTax !== "") writer.uint32(10).string(message.communityTax);
        if (message.baseProposerReward !== "") writer.uint32(18).string(message.baseProposerReward);
        if (message.bonusProposerReward !== "") writer.uint32(26).string(message.bonusProposerReward);
        if (message.withdrawAddrEnabled === true) writer.uint32(32).bool(message.withdrawAddrEnabled);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            communityTax: (0, $7iZIe.isSet)(object.communityTax) ? String(object.communityTax) : "",
            baseProposerReward: (0, $7iZIe.isSet)(object.baseProposerReward) ? String(object.baseProposerReward) : "",
            bonusProposerReward: (0, $7iZIe.isSet)(object.bonusProposerReward) ? String(object.bonusProposerReward) : "",
            withdrawAddrEnabled: (0, $7iZIe.isSet)(object.withdrawAddrEnabled) ? Boolean(object.withdrawAddrEnabled) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a9c94cbd65eace7e$var$createBaseParams();
        var _object_communityTax;
        message.communityTax = (_object_communityTax = object.communityTax) !== null && _object_communityTax !== void 0 ? _object_communityTax : "";
        var _object_baseProposerReward;
        message.baseProposerReward = (_object_baseProposerReward = object.baseProposerReward) !== null && _object_baseProposerReward !== void 0 ? _object_baseProposerReward : "";
        var _object_bonusProposerReward;
        message.bonusProposerReward = (_object_bonusProposerReward = object.bonusProposerReward) !== null && _object_bonusProposerReward !== void 0 ? _object_bonusProposerReward : "";
        var _object_withdrawAddrEnabled;
        message.withdrawAddrEnabled = (_object_withdrawAddrEnabled = object.withdrawAddrEnabled) !== null && _object_withdrawAddrEnabled !== void 0 ? _object_withdrawAddrEnabled : false;
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseValidatorHistoricalRewards() {
    return {
        cumulativeRewardRatio: [],
        referenceCount: 0
    };
}
$a9c94cbd65eace7e$exports.ValidatorHistoricalRewards = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.cumulativeRewardRatio[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.referenceCount !== 0) writer.uint32(16).uint32(message.referenceCount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorHistoricalRewards();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.cumulativeRewardRatio.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            cumulativeRewardRatio: Array.isArray(object === null || object === void 0 ? void 0 : object.cumulativeRewardRatio) ? object.cumulativeRewardRatio.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : [],
            referenceCount: (0, $7iZIe.isSet)(object.referenceCount) ? Number(object.referenceCount) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.cumulativeRewardRatio) obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.cumulativeRewardRatio = [];
        message.referenceCount !== undefined && (obj.referenceCount = Math.round(message.referenceCount));
        return obj;
    },
    fromPartial: function(object) {
        var _object_cumulativeRewardRatio;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorHistoricalRewards();
        message.cumulativeRewardRatio = ((_object_cumulativeRewardRatio = object.cumulativeRewardRatio) === null || _object_cumulativeRewardRatio === void 0 ? void 0 : _object_cumulativeRewardRatio.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        var _object_referenceCount;
        message.referenceCount = (_object_referenceCount = object.referenceCount) !== null && _object_referenceCount !== void 0 ? _object_referenceCount : 0;
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseValidatorCurrentRewards() {
    return {
        rewards: [],
        period: $7iZIe.Long.UZERO
    };
}
$a9c94cbd65eace7e$exports.ValidatorCurrentRewards = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.rewards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!message.period.isZero()) writer.uint32(16).uint64(message.period);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorCurrentRewards();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : [],
            period: (0, $7iZIe.isSet)(object.period) ? $7iZIe.Long.fromValue(object.period) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.rewards) obj.rewards = message.rewards.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.rewards = [];
        message.period !== undefined && (obj.period = (message.period || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_rewards;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorCurrentRewards();
        message.rewards = ((_object_rewards = object.rewards) === null || _object_rewards === void 0 ? void 0 : _object_rewards.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        message.period = object.period !== undefined && object.period !== null ? $7iZIe.Long.fromValue(object.period) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseValidatorAccumulatedCommission() {
    return {
        commission: []
    };
}
$a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.commission[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorAccumulatedCommission();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            commission: Array.isArray(object === null || object === void 0 ? void 0 : object.commission) ? object.commission.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.commission) obj.commission = message.commission.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.commission = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_commission;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorAccumulatedCommission();
        message.commission = ((_object_commission = object.commission) === null || _object_commission === void 0 ? void 0 : _object_commission.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseValidatorOutstandingRewards() {
    return {
        rewards: []
    };
}
$a9c94cbd65eace7e$exports.ValidatorOutstandingRewards = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.rewards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorOutstandingRewards();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.rewards) obj.rewards = message.rewards.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.rewards = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_rewards;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorOutstandingRewards();
        message.rewards = ((_object_rewards = object.rewards) === null || _object_rewards === void 0 ? void 0 : _object_rewards.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseValidatorSlashEvent() {
    return {
        validatorPeriod: $7iZIe.Long.UZERO,
        fraction: ""
    };
}
$a9c94cbd65eace7e$exports.ValidatorSlashEvent = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        if (!message.validatorPeriod.isZero()) writer.uint32(8).uint64(message.validatorPeriod);
        if (message.fraction !== "") writer.uint32(18).string(message.fraction);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorSlashEvent();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorPeriod: (0, $7iZIe.isSet)(object.validatorPeriod) ? $7iZIe.Long.fromValue(object.validatorPeriod) : $7iZIe.Long.UZERO,
            fraction: (0, $7iZIe.isSet)(object.fraction) ? String(object.fraction) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorPeriod !== undefined && (obj.validatorPeriod = (message.validatorPeriod || $7iZIe.Long.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a9c94cbd65eace7e$var$createBaseValidatorSlashEvent();
        message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? $7iZIe.Long.fromValue(object.validatorPeriod) : $7iZIe.Long.UZERO;
        var _object_fraction;
        message.fraction = (_object_fraction = object.fraction) !== null && _object_fraction !== void 0 ? _object_fraction : "";
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseValidatorSlashEvents() {
    return {
        validatorSlashEvents: []
    };
}
$a9c94cbd65eace7e$exports.ValidatorSlashEvents = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validatorSlashEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a9c94cbd65eace7e$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorSlashEvents();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorSlashEvents.push($a9c94cbd65eace7e$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorSlashEvents: Array.isArray(object === null || object === void 0 ? void 0 : object.validatorSlashEvents) ? object.validatorSlashEvents.map(function(e) {
                return $a9c94cbd65eace7e$exports.ValidatorSlashEvent.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.validatorSlashEvents) obj.validatorSlashEvents = message.validatorSlashEvents.map(function(e) {
            return e ? $a9c94cbd65eace7e$exports.ValidatorSlashEvent.toJSON(e) : undefined;
        });
        else obj.validatorSlashEvents = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_validatorSlashEvents;
        var message = $a9c94cbd65eace7e$var$createBaseValidatorSlashEvents();
        message.validatorSlashEvents = ((_object_validatorSlashEvents = object.validatorSlashEvents) === null || _object_validatorSlashEvents === void 0 ? void 0 : _object_validatorSlashEvents.map(function(e) {
            return $a9c94cbd65eace7e$exports.ValidatorSlashEvent.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseFeePool() {
    return {
        communityPool: []
    };
}
$a9c94cbd65eace7e$exports.FeePool = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.communityPool[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseFeePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityPool.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            communityPool: Array.isArray(object === null || object === void 0 ? void 0 : object.communityPool) ? object.communityPool.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.communityPool) obj.communityPool = message.communityPool.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.communityPool = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_communityPool;
        var message = $a9c94cbd65eace7e$var$createBaseFeePool();
        message.communityPool = ((_object_communityPool = object.communityPool) === null || _object_communityPool === void 0 ? void 0 : _object_communityPool.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseCommunityPoolSpendProposal() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: []
    };
}
$a9c94cbd65eace7e$exports.CommunityPoolSpendProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseCommunityPoolSpendProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $7iZIe.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $a9c94cbd65eace7e$var$createBaseCommunityPoolSpendProposal();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        var _object_recipient;
        message.recipient = (_object_recipient = object.recipient) !== null && _object_recipient !== void 0 ? _object_recipient : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseDelegatorStartingInfo() {
    return {
        previousPeriod: $7iZIe.Long.UZERO,
        stake: "",
        height: $7iZIe.Long.UZERO
    };
}
$a9c94cbd65eace7e$exports.DelegatorStartingInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        if (!message.previousPeriod.isZero()) writer.uint32(8).uint64(message.previousPeriod);
        if (message.stake !== "") writer.uint32(18).string(message.stake);
        if (!message.height.isZero()) writer.uint32(24).uint64(message.height);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseDelegatorStartingInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            previousPeriod: (0, $7iZIe.isSet)(object.previousPeriod) ? $7iZIe.Long.fromValue(object.previousPeriod) : $7iZIe.Long.UZERO,
            stake: (0, $7iZIe.isSet)(object.stake) ? String(object.stake) : "",
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.previousPeriod !== undefined && (obj.previousPeriod = (message.previousPeriod || $7iZIe.Long.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $a9c94cbd65eace7e$var$createBaseDelegatorStartingInfo();
        message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? $7iZIe.Long.fromValue(object.previousPeriod) : $7iZIe.Long.UZERO;
        var _object_stake;
        message.stake = (_object_stake = object.stake) !== null && _object_stake !== void 0 ? _object_stake : "";
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseDelegationDelegatorReward() {
    return {
        validatorAddress: "",
        reward: []
    };
}
$a9c94cbd65eace7e$exports.DelegationDelegatorReward = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.reward[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseDelegationDelegatorReward();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            reward: Array.isArray(object === null || object === void 0 ? void 0 : object.reward) ? object.reward.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) obj.reward = message.reward.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.reward = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_reward;
        var message = $a9c94cbd65eace7e$var$createBaseDelegationDelegatorReward();
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.reward = ((_object_reward = object.reward) === null || _object_reward === void 0 ? void 0 : _object_reward.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a9c94cbd65eace7e$var$createBaseCommunityPoolSpendProposalWithDeposit() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: ""
    };
}
$a9c94cbd65eace7e$exports.CommunityPoolSpendProposalWithDeposit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a9c94cbd65eace7e$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        if (message.amount !== "") writer.uint32(34).string(message.amount);
        if (message.deposit !== "") writer.uint32(42).string(message.deposit);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a9c94cbd65eace7e$var$_m0.Reader ? input : new $a9c94cbd65eace7e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a9c94cbd65eace7e$var$createBaseCommunityPoolSpendProposalWithDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $7iZIe.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? String(object.amount) : "",
            deposit: (0, $7iZIe.isSet)(object.deposit) ? String(object.deposit) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a9c94cbd65eace7e$var$createBaseCommunityPoolSpendProposalWithDeposit();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        var _object_recipient;
        message.recipient = (_object_recipient = object.recipient) !== null && _object_recipient !== void 0 ? _object_recipient : "";
        var _object_amount;
        message.amount = (_object_amount = object.amount) !== null && _object_amount !== void 0 ? _object_amount : "";
        var _object_deposit;
        message.deposit = (_object_deposit = object.deposit) !== null && _object_deposit !== void 0 ? _object_deposit : "";
        return message;
    }
};



var $87cae70f73bd5cdd$var$_m0 = $87cae70f73bd5cdd$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$87cae70f73bd5cdd$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $87cae70f73bd5cdd$var$createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: ""
    };
}
$87cae70f73bd5cdd$exports.MsgSetWithdrawAddress = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgSetWithdrawAddress();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: (0, $7iZIe.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgSetWithdrawAddress();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_withdrawAddress;
        message.withdrawAddress = (_object_withdrawAddress = object.withdrawAddress) !== null && _object_withdrawAddress !== void 0 ? _object_withdrawAddress : "";
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
$87cae70f73bd5cdd$exports.MsgSetWithdrawAddressResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgSetWithdrawAddressResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgSetWithdrawAddressResponse();
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$87cae70f73bd5cdd$exports.MsgWithdrawDelegatorReward = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawDelegatorReward();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawDelegatorReward();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgWithdrawDelegatorRewardResponse() {
    return {
        amount: []
    };
}
$87cae70f73bd5cdd$exports.MsgWithdrawDelegatorRewardResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawDelegatorRewardResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawDelegatorRewardResponse();
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: ""
    };
}
$87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommission = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawValidatorCommission();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawValidatorCommission();
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgWithdrawValidatorCommissionResponse() {
    return {
        amount: []
    };
}
$87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommissionResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawValidatorCommissionResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $87cae70f73bd5cdd$var$createBaseMsgWithdrawValidatorCommissionResponse();
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: ""
    };
}
$87cae70f73bd5cdd$exports.MsgFundCommunityPool = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgFundCommunityPool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $87cae70f73bd5cdd$var$createBaseMsgFundCommunityPool();
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgFundCommunityPoolResponse() {
    return {};
}
$87cae70f73bd5cdd$exports.MsgFundCommunityPoolResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgFundCommunityPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgFundCommunityPoolResponse();
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$87cae70f73bd5cdd$exports.MsgUpdateParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $a9c94cbd65eace7e$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $a9c94cbd65eace7e$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $7iZIe.isSet)(object.params) ? $a9c94cbd65eace7e$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $a9c94cbd65eace7e$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgUpdateParams();
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        message.params = object.params !== undefined && object.params !== null ? $a9c94cbd65eace7e$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$87cae70f73bd5cdd$exports.MsgUpdateParamsResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgCommunityPoolSpend() {
    return {
        authority: "",
        recipient: "",
        amount: []
    };
}
$87cae70f73bd5cdd$exports.MsgCommunityPoolSpend = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.recipient !== "") writer.uint32(18).string(message.recipient);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgCommunityPoolSpend();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.recipient = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : "",
            recipient: (0, $7iZIe.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $87cae70f73bd5cdd$var$createBaseMsgCommunityPoolSpend();
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        var _object_recipient;
        message.recipient = (_object_recipient = object.recipient) !== null && _object_recipient !== void 0 ? _object_recipient : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $87cae70f73bd5cdd$var$createBaseMsgCommunityPoolSpendResponse() {
    return {};
}
$87cae70f73bd5cdd$exports.MsgCommunityPoolSpendResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87cae70f73bd5cdd$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87cae70f73bd5cdd$var$_m0.Reader ? input : new $87cae70f73bd5cdd$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87cae70f73bd5cdd$var$createBaseMsgCommunityPoolSpendResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $87cae70f73bd5cdd$var$createBaseMsgCommunityPoolSpendResponse();
        return message;
    }
};
var $87cae70f73bd5cdd$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "SetWithdrawAddress",
            value: function SetWithdrawAddress(request) {
                var data = $87cae70f73bd5cdd$exports.MsgSetWithdrawAddress.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
                return promise.then(function(data) {
                    return $87cae70f73bd5cdd$exports.MsgSetWithdrawAddressResponse.decode(new $87cae70f73bd5cdd$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "WithdrawDelegatorReward",
            value: function WithdrawDelegatorReward(request) {
                var data = $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorReward.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
                return promise.then(function(data) {
                    return $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorRewardResponse.decode(new $87cae70f73bd5cdd$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "WithdrawValidatorCommission",
            value: function WithdrawValidatorCommission(request) {
                var data = $87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommission.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
                return promise.then(function(data) {
                    return $87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommissionResponse.decode(new $87cae70f73bd5cdd$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "FundCommunityPool",
            value: function FundCommunityPool(request) {
                var data = $87cae70f73bd5cdd$exports.MsgFundCommunityPool.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
                return promise.then(function(data) {
                    return $87cae70f73bd5cdd$exports.MsgFundCommunityPoolResponse.decode(new $87cae70f73bd5cdd$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateParams",
            value: function UpdateParams(request) {
                var data = $87cae70f73bd5cdd$exports.MsgUpdateParams.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", data);
                return promise.then(function(data) {
                    return $87cae70f73bd5cdd$exports.MsgUpdateParamsResponse.decode(new $87cae70f73bd5cdd$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "CommunityPoolSpend",
            value: function CommunityPoolSpend(request) {
                var data = $87cae70f73bd5cdd$exports.MsgCommunityPoolSpend.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", data);
                return promise.then(function(data) {
                    return $87cae70f73bd5cdd$exports.MsgCommunityPoolSpendResponse.decode(new $87cae70f73bd5cdd$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$87cae70f73bd5cdd$exports.MsgClientImpl = $87cae70f73bd5cdd$var$MsgClientImpl;


$26cb303d0ece2fd1$exports.distributionTypes = [
    [
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        $87cae70f73bd5cdd$exports.MsgFundCommunityPool
    ],
    [
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        $87cae70f73bd5cdd$exports.MsgSetWithdrawAddress
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorReward
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        $87cae70f73bd5cdd$exports.MsgWithdrawValidatorCommission
    ]
];
function $26cb303d0ece2fd1$var$isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return object.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
$26cb303d0ece2fd1$exports.isMsgWithdrawDelegatorRewardEncodeObject = $26cb303d0ece2fd1$var$isMsgWithdrawDelegatorRewardEncodeObject;


Object.defineProperty($0aaecf7be71ff9a4$exports, "distributionTypes", {
    enumerable: true,
    get: function get() {
        return $26cb303d0ece2fd1$exports.distributionTypes;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function get() {
        return $26cb303d0ece2fd1$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
var $2d811f50becbe55a$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $2d811f50becbe55a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2d811f50becbe55a$exports, "__esModule", {
    value: true
});
$2d811f50becbe55a$exports.setupDistributionExtension = void 0;
var $28ab98148c56c974$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $28ab98148c56c974$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $28ab98148c56c974$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $28ab98148c56c974$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $28ab98148c56c974$var$__createBinding(result, mod, k);
    }
    $28ab98148c56c974$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($28ab98148c56c974$exports, "__esModule", {
    value: true
});
$28ab98148c56c974$exports.QueryClientImpl = $28ab98148c56c974$exports.QueryCommunityPoolResponse = $28ab98148c56c974$exports.QueryCommunityPoolRequest = $28ab98148c56c974$exports.QueryDelegatorWithdrawAddressResponse = $28ab98148c56c974$exports.QueryDelegatorWithdrawAddressRequest = $28ab98148c56c974$exports.QueryDelegatorValidatorsResponse = $28ab98148c56c974$exports.QueryDelegatorValidatorsRequest = $28ab98148c56c974$exports.QueryDelegationTotalRewardsResponse = $28ab98148c56c974$exports.QueryDelegationTotalRewardsRequest = $28ab98148c56c974$exports.QueryDelegationRewardsResponse = $28ab98148c56c974$exports.QueryDelegationRewardsRequest = $28ab98148c56c974$exports.QueryValidatorSlashesResponse = $28ab98148c56c974$exports.QueryValidatorSlashesRequest = $28ab98148c56c974$exports.QueryValidatorCommissionResponse = $28ab98148c56c974$exports.QueryValidatorCommissionRequest = $28ab98148c56c974$exports.QueryValidatorOutstandingRewardsResponse = $28ab98148c56c974$exports.QueryValidatorOutstandingRewardsRequest = $28ab98148c56c974$exports.QueryValidatorDistributionInfoResponse = $28ab98148c56c974$exports.QueryValidatorDistributionInfoRequest = $28ab98148c56c974$exports.QueryParamsResponse = $28ab98148c56c974$exports.QueryParamsRequest = $28ab98148c56c974$exports.protobufPackage = void 0;




var $7iZIe = parcelRequire("7iZIe");

var $28ab98148c56c974$var$_m0 = $28ab98148c56c974$var$__importStar((parcelRequire("hjb8Q")));
$28ab98148c56c974$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $28ab98148c56c974$var$createBaseQueryParamsRequest() {
    return {};
}
$28ab98148c56c974$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $28ab98148c56c974$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$28ab98148c56c974$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.params !== undefined) $a9c94cbd65eace7e$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $a9c94cbd65eace7e$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $a9c94cbd65eace7e$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $a9c94cbd65eace7e$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $a9c94cbd65eace7e$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorDistributionInfoRequest() {
    return {
        validatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryValidatorDistributionInfoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorDistributionInfoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryValidatorDistributionInfoRequest();
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorDistributionInfoResponse() {
    return {
        operatorAddress: "",
        selfBondRewards: [],
        commission: []
    };
}
$28ab98148c56c974$exports.QueryValidatorDistributionInfoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.selfBondRewards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.commission[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v1, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorDistributionInfoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.selfBondRewards.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.commission.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            operatorAddress: (0, $7iZIe.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            selfBondRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.selfBondRewards) ? object.selfBondRewards.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : [],
            commission: Array.isArray(object === null || object === void 0 ? void 0 : object.commission) ? object.commission.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        if (message.selfBondRewards) obj.selfBondRewards = message.selfBondRewards.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.selfBondRewards = [];
        if (message.commission) obj.commission = message.commission.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.commission = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_selfBondRewards, _object_commission;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorDistributionInfoResponse();
        var _object_operatorAddress;
        message.operatorAddress = (_object_operatorAddress = object.operatorAddress) !== null && _object_operatorAddress !== void 0 ? _object_operatorAddress : "";
        message.selfBondRewards = ((_object_selfBondRewards = object.selfBondRewards) === null || _object_selfBondRewards === void 0 ? void 0 : _object_selfBondRewards.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        message.commission = ((_object_commission = object.commission) === null || _object_commission === void 0 ? void 0 : _object_commission.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorOutstandingRewardsRequest() {
    return {
        validatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryValidatorOutstandingRewardsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorOutstandingRewardsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryValidatorOutstandingRewardsRequest();
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorOutstandingRewardsResponse() {
    return {
        rewards: undefined
    };
}
$28ab98148c56c974$exports.QueryValidatorOutstandingRewardsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.rewards !== undefined) $a9c94cbd65eace7e$exports.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorOutstandingRewardsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards = $a9c94cbd65eace7e$exports.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rewards: (0, $7iZIe.isSet)(object.rewards) ? $a9c94cbd65eace7e$exports.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.rewards !== undefined && (obj.rewards = message.rewards ? $a9c94cbd65eace7e$exports.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryValidatorOutstandingRewardsResponse();
        message.rewards = object.rewards !== undefined && object.rewards !== null ? $a9c94cbd65eace7e$exports.ValidatorOutstandingRewards.fromPartial(object.rewards) : undefined;
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorCommissionRequest() {
    return {
        validatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryValidatorCommissionRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorCommissionRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryValidatorCommissionRequest();
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorCommissionResponse() {
    return {
        commission: undefined
    };
}
$28ab98148c56c974$exports.QueryValidatorCommissionResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.commission !== undefined) $a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorCommissionResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission = $a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            commission: (0, $7iZIe.isSet)(object.commission) ? $a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission.fromJSON(object.commission) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.commission !== undefined && (obj.commission = message.commission ? $a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission.toJSON(message.commission) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryValidatorCommissionResponse();
        message.commission = object.commission !== undefined && object.commission !== null ? $a9c94cbd65eace7e$exports.ValidatorAccumulatedCommission.fromPartial(object.commission) : undefined;
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorSlashesRequest() {
    return {
        validatorAddress: "",
        startingHeight: $7iZIe.Long.UZERO,
        endingHeight: $7iZIe.Long.UZERO,
        pagination: undefined
    };
}
$28ab98148c56c974$exports.QueryValidatorSlashesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        if (!message.startingHeight.isZero()) writer.uint32(16).uint64(message.startingHeight);
        if (!message.endingHeight.isZero()) writer.uint32(24).uint64(message.endingHeight);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorSlashesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            startingHeight: (0, $7iZIe.isSet)(object.startingHeight) ? $7iZIe.Long.fromValue(object.startingHeight) : $7iZIe.Long.UZERO,
            endingHeight: (0, $7iZIe.isSet)(object.endingHeight) ? $7iZIe.Long.fromValue(object.endingHeight) : $7iZIe.Long.UZERO,
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined && (obj.startingHeight = (message.startingHeight || $7iZIe.Long.UZERO).toString());
        message.endingHeight !== undefined && (obj.endingHeight = (message.endingHeight || $7iZIe.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryValidatorSlashesRequest();
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? $7iZIe.Long.fromValue(object.startingHeight) : $7iZIe.Long.UZERO;
        message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? $7iZIe.Long.fromValue(object.endingHeight) : $7iZIe.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryValidatorSlashesResponse() {
    return {
        slashes: [],
        pagination: undefined
    };
}
$28ab98148c56c974$exports.QueryValidatorSlashesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.slashes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a9c94cbd65eace7e$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorSlashesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.slashes.push($a9c94cbd65eace7e$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            slashes: Array.isArray(object === null || object === void 0 ? void 0 : object.slashes) ? object.slashes.map(function(e) {
                return $a9c94cbd65eace7e$exports.ValidatorSlashEvent.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.slashes) obj.slashes = message.slashes.map(function(e) {
            return e ? $a9c94cbd65eace7e$exports.ValidatorSlashEvent.toJSON(e) : undefined;
        });
        else obj.slashes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_slashes;
        var message = $28ab98148c56c974$var$createBaseQueryValidatorSlashesResponse();
        message.slashes = ((_object_slashes = object.slashes) === null || _object_slashes === void 0 ? void 0 : _object_slashes.map(function(e) {
            return $a9c94cbd65eace7e$exports.ValidatorSlashEvent.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegationRewardsRequest() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryDelegationRewardsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegationRewardsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryDelegationRewardsRequest();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegationRewardsResponse() {
    return {
        rewards: []
    };
}
$28ab98148c56c974$exports.QueryDelegationRewardsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.rewards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegationRewardsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.rewards) obj.rewards = message.rewards.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.rewards = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_rewards;
        var message = $28ab98148c56c974$var$createBaseQueryDelegationRewardsResponse();
        message.rewards = ((_object_rewards = object.rewards) === null || _object_rewards === void 0 ? void 0 : _object_rewards.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegationTotalRewardsRequest() {
    return {
        delegatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryDelegationTotalRewardsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegationTotalRewardsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryDelegationTotalRewardsRequest();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegationTotalRewardsResponse() {
    return {
        rewards: [],
        total: []
    };
}
$28ab98148c56c974$exports.QueryDelegationTotalRewardsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.rewards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a9c94cbd65eace7e$exports.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.total[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v1, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegationTotalRewardsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($a9c94cbd65eace7e$exports.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rewards: Array.isArray(object === null || object === void 0 ? void 0 : object.rewards) ? object.rewards.map(function(e) {
                return $a9c94cbd65eace7e$exports.DelegationDelegatorReward.fromJSON(e);
            }) : [],
            total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.rewards) obj.rewards = message.rewards.map(function(e) {
            return e ? $a9c94cbd65eace7e$exports.DelegationDelegatorReward.toJSON(e) : undefined;
        });
        else obj.rewards = [];
        if (message.total) obj.total = message.total.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.total = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_rewards, _object_total;
        var message = $28ab98148c56c974$var$createBaseQueryDelegationTotalRewardsResponse();
        message.rewards = ((_object_rewards = object.rewards) === null || _object_rewards === void 0 ? void 0 : _object_rewards.map(function(e) {
            return $a9c94cbd65eace7e$exports.DelegationDelegatorReward.fromPartial(e);
        })) || [];
        message.total = ((_object_total = object.total) === null || _object_total === void 0 ? void 0 : _object_total.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryDelegatorValidatorsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorValidatorsRequest();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: []
    };
}
$28ab98148c56c974$exports.QueryDelegatorValidatorsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.validators) obj.validators = message.validators.map(function(e) {
            return e;
        });
        else obj.validators = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_validators;
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = ((_object_validators = object.validators) === null || _object_validators === void 0 ? void 0 : _object_validators.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegatorWithdrawAddressRequest() {
    return {
        delegatorAddress: ""
    };
}
$28ab98148c56c974$exports.QueryDelegatorWithdrawAddressRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorWithdrawAddressRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorWithdrawAddressRequest();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryDelegatorWithdrawAddressResponse() {
    return {
        withdrawAddress: ""
    };
}
$28ab98148c56c974$exports.QueryDelegatorWithdrawAddressResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        if (message.withdrawAddress !== "") writer.uint32(10).string(message.withdrawAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorWithdrawAddressResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            withdrawAddress: (0, $7iZIe.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $28ab98148c56c974$var$createBaseQueryDelegatorWithdrawAddressResponse();
        var _object_withdrawAddress;
        message.withdrawAddress = (_object_withdrawAddress = object.withdrawAddress) !== null && _object_withdrawAddress !== void 0 ? _object_withdrawAddress : "";
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryCommunityPoolRequest() {
    return {};
}
$28ab98148c56c974$exports.QueryCommunityPoolRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryCommunityPoolRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $28ab98148c56c974$var$createBaseQueryCommunityPoolRequest();
        return message;
    }
};
function $28ab98148c56c974$var$createBaseQueryCommunityPoolResponse() {
    return {
        pool: []
    };
}
$28ab98148c56c974$exports.QueryCommunityPoolResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $28ab98148c56c974$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.pool[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $28ab98148c56c974$var$_m0.Reader ? input : new $28ab98148c56c974$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $28ab98148c56c974$var$createBaseQueryCommunityPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool.push($5bc8eb379b028930$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pool: Array.isArray(object === null || object === void 0 ? void 0 : object.pool) ? object.pool.map(function(e) {
                return $5bc8eb379b028930$exports.DecCoin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.pool) obj.pool = message.pool.map(function(e) {
            return e ? $5bc8eb379b028930$exports.DecCoin.toJSON(e) : undefined;
        });
        else obj.pool = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_pool;
        var message = $28ab98148c56c974$var$createBaseQueryCommunityPoolResponse();
        message.pool = ((_object_pool = object.pool) === null || _object_pool === void 0 ? void 0 : _object_pool.map(function(e) {
            return $5bc8eb379b028930$exports.DecCoin.fromPartial(e);
        })) || [];
        return message;
    }
};
var $28ab98148c56c974$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $28ab98148c56c974$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryParamsResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ValidatorDistributionInfo",
            value: function ValidatorDistributionInfo(request) {
                var data = $28ab98148c56c974$exports.QueryValidatorDistributionInfoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryValidatorDistributionInfoResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ValidatorOutstandingRewards",
            value: function ValidatorOutstandingRewards(request) {
                var data = $28ab98148c56c974$exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryValidatorOutstandingRewardsResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ValidatorCommission",
            value: function ValidatorCommission(request) {
                var data = $28ab98148c56c974$exports.QueryValidatorCommissionRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryValidatorCommissionResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ValidatorSlashes",
            value: function ValidatorSlashes(request) {
                var data = $28ab98148c56c974$exports.QueryValidatorSlashesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryValidatorSlashesResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegationRewards",
            value: function DelegationRewards(request) {
                var data = $28ab98148c56c974$exports.QueryDelegationRewardsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryDelegationRewardsResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegationTotalRewards",
            value: function DelegationTotalRewards(request) {
                var data = $28ab98148c56c974$exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryDelegationTotalRewardsResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegatorValidators",
            value: function DelegatorValidators(request) {
                var data = $28ab98148c56c974$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryDelegatorValidatorsResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegatorWithdrawAddress",
            value: function DelegatorWithdrawAddress(request) {
                var data = $28ab98148c56c974$exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryDelegatorWithdrawAddressResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "CommunityPool",
            value: function CommunityPool() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $28ab98148c56c974$exports.QueryCommunityPoolRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
                return promise.then(function(data) {
                    return $28ab98148c56c974$exports.QueryCommunityPoolResponse.decode(new $28ab98148c56c974$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$28ab98148c56c974$exports.QueryClientImpl = $28ab98148c56c974$var$QueryClientImpl;



var $2d811f50becbe55a$var$long_1 = $2d811f50becbe55a$var$__importDefault((parcelRequire("l6G6L")));

function $2d811f50becbe55a$var$setupDistributionExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var queryService = new $28ab98148c56c974$exports.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var response;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.CommunityPool({})
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response
                            ];
                    }
                });
            }),
            delegationRewards: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegationRewards({
                                        delegatorAddress: delegatorAddress,
                                        validatorAddress: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegationTotalRewards: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegationTotalRewards({
                                        delegatorAddress: delegatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegatorValidators: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegatorValidators({
                                        delegatorAddress: delegatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegatorWithdrawAddress: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegatorWithdrawAddress({
                                        delegatorAddress: delegatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            params: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var response;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.Params({})
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response
                            ];
                    }
                });
            }),
            validatorCommission: function() {
                var _ref = (0, $6rBFC._)(function(validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.ValidatorCommission({
                                        validatorAddress: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            validatorOutstandingRewards: function() {
                var _ref = (0, $6rBFC._)(function(validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.ValidatorOutstandingRewards({
                                        validatorAddress: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            validatorSlashes: function() {
                var _ref = (0, $6rBFC._)(function(validatorAddress, startingHeight, endingHeight, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.ValidatorSlashes({
                                        validatorAddress: validatorAddress,
                                        startingHeight: $2d811f50becbe55a$var$long_1.default.fromNumber(startingHeight, true),
                                        endingHeight: $2d811f50becbe55a$var$long_1.default.fromNumber(endingHeight, true),
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(validatorAddress, startingHeight, endingHeight, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$2d811f50becbe55a$exports.setupDistributionExtension = $2d811f50becbe55a$var$setupDistributionExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function get() {
        return $2d811f50becbe55a$exports.setupDistributionExtension;
    }
});
var $97ae24875ecfac3a$exports = {};
"use strict";
Object.defineProperty($97ae24875ecfac3a$exports, "__esModule", {
    value: true
});
$97ae24875ecfac3a$exports.createEvidenceAminoConverters = $97ae24875ecfac3a$exports.isAminoMsgSubmitEvidence = void 0;
function $97ae24875ecfac3a$var$isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$97ae24875ecfac3a$exports.isAminoMsgSubmitEvidence = $97ae24875ecfac3a$var$isAminoMsgSubmitEvidence;
function $97ae24875ecfac3a$var$createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
$97ae24875ecfac3a$exports.createEvidenceAminoConverters = $97ae24875ecfac3a$var$createEvidenceAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function get() {
        return $97ae24875ecfac3a$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function get() {
        return $97ae24875ecfac3a$exports.isAminoMsgSubmitEvidence;
    }
});
var $93123588556c3dc3$exports = {};
"use strict";
Object.defineProperty($93123588556c3dc3$exports, "__esModule", {
    value: true
});
$93123588556c3dc3$exports.createFeegrantAminoConverters = void 0;
function $93123588556c3dc3$var$createFeegrantAminoConverters() {
    return {
    };
}
$93123588556c3dc3$exports.createFeegrantAminoConverters = $93123588556c3dc3$var$createFeegrantAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function get() {
        return $93123588556c3dc3$exports.createFeegrantAminoConverters;
    }
});
var $f2422813b7368d41$exports = {};
"use strict";
Object.defineProperty($f2422813b7368d41$exports, "__esModule", {
    value: true
});
$f2422813b7368d41$exports.feegrantTypes = void 0;
var $425dfab1083f0ac2$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $425dfab1083f0ac2$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $425dfab1083f0ac2$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $425dfab1083f0ac2$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $425dfab1083f0ac2$var$__createBinding(result, mod, k);
    }
    $425dfab1083f0ac2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($425dfab1083f0ac2$exports, "__esModule", {
    value: true
});
$425dfab1083f0ac2$exports.MsgClientImpl = $425dfab1083f0ac2$exports.MsgRevokeAllowanceResponse = $425dfab1083f0ac2$exports.MsgRevokeAllowance = $425dfab1083f0ac2$exports.MsgGrantAllowanceResponse = $425dfab1083f0ac2$exports.MsgGrantAllowance = $425dfab1083f0ac2$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $425dfab1083f0ac2$var$_m0 = $425dfab1083f0ac2$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$425dfab1083f0ac2$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $425dfab1083f0ac2$var$createBaseMsgGrantAllowance() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
$425dfab1083f0ac2$exports.MsgGrantAllowance = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $425dfab1083f0ac2$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $DM7bi.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $425dfab1083f0ac2$var$_m0.Reader ? input : new $425dfab1083f0ac2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $425dfab1083f0ac2$var$createBaseMsgGrantAllowance();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $7iZIe.isSet)(object.allowance) ? $DM7bi.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $DM7bi.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $425dfab1083f0ac2$var$createBaseMsgGrantAllowance();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $DM7bi.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $425dfab1083f0ac2$var$createBaseMsgGrantAllowanceResponse() {
    return {};
}
$425dfab1083f0ac2$exports.MsgGrantAllowanceResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $425dfab1083f0ac2$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $425dfab1083f0ac2$var$_m0.Reader ? input : new $425dfab1083f0ac2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $425dfab1083f0ac2$var$createBaseMsgGrantAllowanceResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $425dfab1083f0ac2$var$createBaseMsgGrantAllowanceResponse();
        return message;
    }
};
function $425dfab1083f0ac2$var$createBaseMsgRevokeAllowance() {
    return {
        granter: "",
        grantee: ""
    };
}
$425dfab1083f0ac2$exports.MsgRevokeAllowance = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $425dfab1083f0ac2$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $425dfab1083f0ac2$var$_m0.Reader ? input : new $425dfab1083f0ac2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $425dfab1083f0ac2$var$createBaseMsgRevokeAllowance();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial: function(object) {
        var message = $425dfab1083f0ac2$var$createBaseMsgRevokeAllowance();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        return message;
    }
};
function $425dfab1083f0ac2$var$createBaseMsgRevokeAllowanceResponse() {
    return {};
}
$425dfab1083f0ac2$exports.MsgRevokeAllowanceResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $425dfab1083f0ac2$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $425dfab1083f0ac2$var$_m0.Reader ? input : new $425dfab1083f0ac2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $425dfab1083f0ac2$var$createBaseMsgRevokeAllowanceResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $425dfab1083f0ac2$var$createBaseMsgRevokeAllowanceResponse();
        return message;
    }
};
var $425dfab1083f0ac2$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "GrantAllowance",
            value: function GrantAllowance(request) {
                var data = $425dfab1083f0ac2$exports.MsgGrantAllowance.encode(request).finish();
                var promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
                return promise.then(function(data) {
                    return $425dfab1083f0ac2$exports.MsgGrantAllowanceResponse.decode(new $425dfab1083f0ac2$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "RevokeAllowance",
            value: function RevokeAllowance(request) {
                var data = $425dfab1083f0ac2$exports.MsgRevokeAllowance.encode(request).finish();
                var promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
                return promise.then(function(data) {
                    return $425dfab1083f0ac2$exports.MsgRevokeAllowanceResponse.decode(new $425dfab1083f0ac2$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$425dfab1083f0ac2$exports.MsgClientImpl = $425dfab1083f0ac2$var$MsgClientImpl;


$f2422813b7368d41$exports.feegrantTypes = [
    [
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        $425dfab1083f0ac2$exports.MsgGrantAllowance
    ],
    [
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        $425dfab1083f0ac2$exports.MsgRevokeAllowance
    ]
];


Object.defineProperty($0aaecf7be71ff9a4$exports, "feegrantTypes", {
    enumerable: true,
    get: function get() {
        return $f2422813b7368d41$exports.feegrantTypes;
    }
});
var $ca79024fdf010f3e$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($ca79024fdf010f3e$exports, "__esModule", {
    value: true
});
$ca79024fdf010f3e$exports.setupFeegrantExtension = void 0;
var $7d2e856be53ef652$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $7d2e856be53ef652$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7d2e856be53ef652$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7d2e856be53ef652$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7d2e856be53ef652$var$__createBinding(result, mod, k);
    }
    $7d2e856be53ef652$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($7d2e856be53ef652$exports, "__esModule", {
    value: true
});
$7d2e856be53ef652$exports.QueryClientImpl = $7d2e856be53ef652$exports.QueryAllowancesByGranterResponse = $7d2e856be53ef652$exports.QueryAllowancesByGranterRequest = $7d2e856be53ef652$exports.QueryAllowancesResponse = $7d2e856be53ef652$exports.QueryAllowancesRequest = $7d2e856be53ef652$exports.QueryAllowanceResponse = $7d2e856be53ef652$exports.QueryAllowanceRequest = $7d2e856be53ef652$exports.protobufPackage = void 0;

var $a278738c72d325e1$exports = {};
"use strict";
var $a278738c72d325e1$var$__createBinding = $a278738c72d325e1$exports && $a278738c72d325e1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a278738c72d325e1$var$__setModuleDefault = $a278738c72d325e1$exports && $a278738c72d325e1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a278738c72d325e1$var$__importStar = $a278738c72d325e1$exports && $a278738c72d325e1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a278738c72d325e1$var$__createBinding(result, mod, k);
    }
    $a278738c72d325e1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a278738c72d325e1$exports, "__esModule", {
    value: true
});
$a278738c72d325e1$exports.Grant = $a278738c72d325e1$exports.AllowedMsgAllowance = $a278738c72d325e1$exports.PeriodicAllowance = $a278738c72d325e1$exports.BasicAllowance = $a278738c72d325e1$exports.protobufPackage = void 0;


var $ib0XJ = parcelRequire("ib0XJ");

var $i8V5u = parcelRequire("i8V5u");

var $DM7bi = parcelRequire("DM7bi");

var $a278738c72d325e1$var$_m0 = $a278738c72d325e1$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$a278738c72d325e1$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $a278738c72d325e1$var$createBaseBasicAllowance() {
    return {
        spendLimit: [],
        expiration: undefined
    };
}
$a278738c72d325e1$exports.BasicAllowance = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a278738c72d325e1$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.spendLimit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.expiration !== undefined) $ib0XJ.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a278738c72d325e1$var$_m0.Reader ? input : new $a278738c72d325e1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a278738c72d325e1$var$createBaseBasicAllowance();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            spendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.spendLimit) ? object.spendLimit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            expiration: (0, $7iZIe.isSet)(object.expiration) ? (0, $7iZIe.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.spendLimit = [];
        message.expiration !== undefined && (obj.expiration = (0, $7iZIe.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_spendLimit;
        var message = $a278738c72d325e1$var$createBaseBasicAllowance();
        message.spendLimit = ((_object_spendLimit = object.spendLimit) === null || _object_spendLimit === void 0 ? void 0 : _object_spendLimit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $ib0XJ.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $a278738c72d325e1$var$createBasePeriodicAllowance() {
    return {
        basic: undefined,
        period: undefined,
        periodSpendLimit: [],
        periodCanSpend: [],
        periodReset: undefined
    };
}
$a278738c72d325e1$exports.PeriodicAllowance = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a278738c72d325e1$var$_m0.Writer.create();
        if (message.basic !== undefined) $a278738c72d325e1$exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        if (message.period !== undefined) $i8V5u.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.periodSpendLimit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.periodCanSpend[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $5bc8eb379b028930$exports.Coin.encode(v1, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.periodReset !== undefined) $ib0XJ.Timestamp.encode(message.periodReset, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a278738c72d325e1$var$_m0.Reader ? input : new $a278738c72d325e1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a278738c72d325e1$var$createBasePeriodicAllowance();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.basic = $a278738c72d325e1$exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            basic: (0, $7iZIe.isSet)(object.basic) ? $a278738c72d325e1$exports.BasicAllowance.fromJSON(object.basic) : undefined,
            period: (0, $7iZIe.isSet)(object.period) ? $i8V5u.Duration.fromJSON(object.period) : undefined,
            periodSpendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.periodSpendLimit) ? object.periodSpendLimit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            periodCanSpend: Array.isArray(object === null || object === void 0 ? void 0 : object.periodCanSpend) ? object.periodCanSpend.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            periodReset: (0, $7iZIe.isSet)(object.periodReset) ? (0, $7iZIe.fromJsonTimestamp)(object.periodReset) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.basic !== undefined && (obj.basic = message.basic ? $a278738c72d325e1$exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined && (obj.period = message.period ? $i8V5u.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) obj.periodSpendLimit = message.periodSpendLimit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.periodSpendLimit = [];
        if (message.periodCanSpend) obj.periodCanSpend = message.periodCanSpend.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.periodCanSpend = [];
        message.periodReset !== undefined && (obj.periodReset = (0, $7iZIe.fromTimestamp)(message.periodReset).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_periodSpendLimit, _object_periodCanSpend;
        var message = $a278738c72d325e1$var$createBasePeriodicAllowance();
        message.basic = object.basic !== undefined && object.basic !== null ? $a278738c72d325e1$exports.BasicAllowance.fromPartial(object.basic) : undefined;
        message.period = object.period !== undefined && object.period !== null ? $i8V5u.Duration.fromPartial(object.period) : undefined;
        message.periodSpendLimit = ((_object_periodSpendLimit = object.periodSpendLimit) === null || _object_periodSpendLimit === void 0 ? void 0 : _object_periodSpendLimit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.periodCanSpend = ((_object_periodCanSpend = object.periodCanSpend) === null || _object_periodCanSpend === void 0 ? void 0 : _object_periodCanSpend.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.periodReset = object.periodReset !== undefined && object.periodReset !== null ? $ib0XJ.Timestamp.fromPartial(object.periodReset) : undefined;
        return message;
    }
};
function $a278738c72d325e1$var$createBaseAllowedMsgAllowance() {
    return {
        allowance: undefined,
        allowedMessages: []
    };
}
$a278738c72d325e1$exports.AllowedMsgAllowance = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a278738c72d325e1$var$_m0.Writer.create();
        if (message.allowance !== undefined) $DM7bi.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.allowedMessages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(18).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a278738c72d325e1$var$_m0.Reader ? input : new $a278738c72d325e1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a278738c72d325e1$var$createBaseAllowedMsgAllowance();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            allowance: (0, $7iZIe.isSet)(object.allowance) ? $DM7bi.Any.fromJSON(object.allowance) : undefined,
            allowedMessages: Array.isArray(object === null || object === void 0 ? void 0 : object.allowedMessages) ? object.allowedMessages.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $DM7bi.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) obj.allowedMessages = message.allowedMessages.map(function(e) {
            return e;
        });
        else obj.allowedMessages = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_allowedMessages;
        var message = $a278738c72d325e1$var$createBaseAllowedMsgAllowance();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $DM7bi.Any.fromPartial(object.allowance) : undefined;
        message.allowedMessages = ((_object_allowedMessages = object.allowedMessages) === null || _object_allowedMessages === void 0 ? void 0 : _object_allowedMessages.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $a278738c72d325e1$var$createBaseGrant() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
$a278738c72d325e1$exports.Grant = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a278738c72d325e1$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $DM7bi.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a278738c72d325e1$var$_m0.Reader ? input : new $a278738c72d325e1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a278738c72d325e1$var$createBaseGrant();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $7iZIe.isSet)(object.allowance) ? $DM7bi.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $DM7bi.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a278738c72d325e1$var$createBaseGrant();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $DM7bi.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};



var $7d2e856be53ef652$var$_m0 = $7d2e856be53ef652$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$7d2e856be53ef652$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $7d2e856be53ef652$var$createBaseQueryAllowanceRequest() {
    return {
        granter: "",
        grantee: ""
    };
}
$7d2e856be53ef652$exports.QueryAllowanceRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7d2e856be53ef652$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7d2e856be53ef652$var$_m0.Reader ? input : new $7d2e856be53ef652$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowanceRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7d2e856be53ef652$var$createBaseQueryAllowanceRequest();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        return message;
    }
};
function $7d2e856be53ef652$var$createBaseQueryAllowanceResponse() {
    return {
        allowance: undefined
    };
}
$7d2e856be53ef652$exports.QueryAllowanceResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7d2e856be53ef652$var$_m0.Writer.create();
        if (message.allowance !== undefined) $a278738c72d325e1$exports.Grant.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7d2e856be53ef652$var$_m0.Reader ? input : new $7d2e856be53ef652$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowanceResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $a278738c72d325e1$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            allowance: (0, $7iZIe.isSet)(object.allowance) ? $a278738c72d325e1$exports.Grant.fromJSON(object.allowance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $a278738c72d325e1$exports.Grant.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7d2e856be53ef652$var$createBaseQueryAllowanceResponse();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $a278738c72d325e1$exports.Grant.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $7d2e856be53ef652$var$createBaseQueryAllowancesRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
$7d2e856be53ef652$exports.QueryAllowancesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7d2e856be53ef652$var$_m0.Writer.create();
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7d2e856be53ef652$var$_m0.Reader ? input : new $7d2e856be53ef652$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            grantee: (0, $7iZIe.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesRequest();
        var _object_grantee;
        message.grantee = (_object_grantee = object.grantee) !== null && _object_grantee !== void 0 ? _object_grantee : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7d2e856be53ef652$var$createBaseQueryAllowancesResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
$7d2e856be53ef652$exports.QueryAllowancesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7d2e856be53ef652$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.allowances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a278738c72d325e1$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7d2e856be53ef652$var$_m0.Reader ? input : new $7d2e856be53ef652$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($a278738c72d325e1$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            allowances: Array.isArray(object === null || object === void 0 ? void 0 : object.allowances) ? object.allowances.map(function(e) {
                return $a278738c72d325e1$exports.Grant.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.allowances) obj.allowances = message.allowances.map(function(e) {
            return e ? $a278738c72d325e1$exports.Grant.toJSON(e) : undefined;
        });
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_allowances;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesResponse();
        message.allowances = ((_object_allowances = object.allowances) === null || _object_allowances === void 0 ? void 0 : _object_allowances.map(function(e) {
            return $a278738c72d325e1$exports.Grant.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7d2e856be53ef652$var$createBaseQueryAllowancesByGranterRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
$7d2e856be53ef652$exports.QueryAllowancesByGranterRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7d2e856be53ef652$var$_m0.Writer.create();
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7d2e856be53ef652$var$_m0.Reader ? input : new $7d2e856be53ef652$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesByGranterRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            granter: (0, $7iZIe.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesByGranterRequest();
        var _object_granter;
        message.granter = (_object_granter = object.granter) !== null && _object_granter !== void 0 ? _object_granter : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7d2e856be53ef652$var$createBaseQueryAllowancesByGranterResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
$7d2e856be53ef652$exports.QueryAllowancesByGranterResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7d2e856be53ef652$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.allowances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a278738c72d325e1$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7d2e856be53ef652$var$_m0.Reader ? input : new $7d2e856be53ef652$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesByGranterResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($a278738c72d325e1$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            allowances: Array.isArray(object === null || object === void 0 ? void 0 : object.allowances) ? object.allowances.map(function(e) {
                return $a278738c72d325e1$exports.Grant.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.allowances) obj.allowances = message.allowances.map(function(e) {
            return e ? $a278738c72d325e1$exports.Grant.toJSON(e) : undefined;
        });
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_allowances;
        var message = $7d2e856be53ef652$var$createBaseQueryAllowancesByGranterResponse();
        message.allowances = ((_object_allowances = object.allowances) === null || _object_allowances === void 0 ? void 0 : _object_allowances.map(function(e) {
            return $a278738c72d325e1$exports.Grant.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
var $7d2e856be53ef652$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Allowance = this.Allowance.bind(this);
        this.Allowances = this.Allowances.bind(this);
        this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Allowance",
            value: function Allowance(request) {
                var data = $7d2e856be53ef652$exports.QueryAllowanceRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", data);
                return promise.then(function(data) {
                    return $7d2e856be53ef652$exports.QueryAllowanceResponse.decode(new $7d2e856be53ef652$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Allowances",
            value: function Allowances(request) {
                var data = $7d2e856be53ef652$exports.QueryAllowancesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", data);
                return promise.then(function(data) {
                    return $7d2e856be53ef652$exports.QueryAllowancesResponse.decode(new $7d2e856be53ef652$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AllowancesByGranter",
            value: function AllowancesByGranter(request) {
                var data = $7d2e856be53ef652$exports.QueryAllowancesByGranterRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", data);
                return promise.then(function(data) {
                    return $7d2e856be53ef652$exports.QueryAllowancesByGranterResponse.decode(new $7d2e856be53ef652$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$7d2e856be53ef652$exports.QueryClientImpl = $7d2e856be53ef652$var$QueryClientImpl;



function $ca79024fdf010f3e$var$setupFeegrantExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    var queryService = new $7d2e856be53ef652$exports.QueryClientImpl(rpc);
    return {
        feegrant: {
            allowance: function() {
                var _ref = (0, $6rBFC._)(function(granter, grantee) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Allowance({
                                        granter: granter,
                                        grantee: grantee
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(granter, grantee) {
                    return _ref.apply(this, arguments);
                };
            }(),
            allowances: function() {
                var _ref = (0, $6rBFC._)(function(grantee, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Allowances({
                                        grantee: grantee,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(grantee, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$ca79024fdf010f3e$exports.setupFeegrantExtension = $ca79024fdf010f3e$var$setupFeegrantExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function get() {
        return $ca79024fdf010f3e$exports.setupFeegrantExtension;
    }
});
var $191ed9ff1698f7ee$exports = {};
"use strict";
var $191ed9ff1698f7ee$var$__importDefault = $191ed9ff1698f7ee$exports && $191ed9ff1698f7ee$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($191ed9ff1698f7ee$exports, "__esModule", {
    value: true
});
$191ed9ff1698f7ee$exports.createGovAminoConverters = $191ed9ff1698f7ee$exports.isAminoMsgDeposit = $191ed9ff1698f7ee$exports.isAminoMsgVoteWeighted = $191ed9ff1698f7ee$exports.isAminoMsgVote = $191ed9ff1698f7ee$exports.isAminoMsgSubmitProposal = void 0;

var $kTbgy = parcelRequire("kTbgy");

var $gMk5u = parcelRequire("gMk5u");
var $7ad2593f4c87d86c$exports = {};
"use strict";
var $7ad2593f4c87d86c$var$__createBinding = $7ad2593f4c87d86c$exports && $7ad2593f4c87d86c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7ad2593f4c87d86c$var$__setModuleDefault = $7ad2593f4c87d86c$exports && $7ad2593f4c87d86c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7ad2593f4c87d86c$var$__importStar = $7ad2593f4c87d86c$exports && $7ad2593f4c87d86c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7ad2593f4c87d86c$var$__createBinding(result, mod, k);
    }
    $7ad2593f4c87d86c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($7ad2593f4c87d86c$exports, "__esModule", {
    value: true
});
$7ad2593f4c87d86c$exports.TallyParams = $7ad2593f4c87d86c$exports.VotingParams = $7ad2593f4c87d86c$exports.DepositParams = $7ad2593f4c87d86c$exports.Vote = $7ad2593f4c87d86c$exports.TallyResult = $7ad2593f4c87d86c$exports.Proposal = $7ad2593f4c87d86c$exports.Deposit = $7ad2593f4c87d86c$exports.TextProposal = $7ad2593f4c87d86c$exports.WeightedVoteOption = $7ad2593f4c87d86c$exports.proposalStatusToJSON = $7ad2593f4c87d86c$exports.proposalStatusFromJSON = $7ad2593f4c87d86c$exports.ProposalStatus = $7ad2593f4c87d86c$exports.voteOptionToJSON = $7ad2593f4c87d86c$exports.voteOptionFromJSON = $7ad2593f4c87d86c$exports.VoteOption = $7ad2593f4c87d86c$exports.protobufPackage = void 0;


var $DM7bi = parcelRequire("DM7bi");

var $ib0XJ = parcelRequire("ib0XJ");

var $i8V5u = parcelRequire("i8V5u");

var $7iZIe = parcelRequire("7iZIe");

var $7ad2593f4c87d86c$var$_m0 = $7ad2593f4c87d86c$var$__importStar((parcelRequire("hjb8Q")));
$7ad2593f4c87d86c$exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $7ad2593f4c87d86c$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7ad2593f4c87d86c$var$VoteOption = $7ad2593f4c87d86c$exports.VoteOption || ($7ad2593f4c87d86c$exports.VoteOption = {}));
function $7ad2593f4c87d86c$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7ad2593f4c87d86c$var$VoteOption.UNRECOGNIZED;
    }
}
$7ad2593f4c87d86c$exports.voteOptionFromJSON = $7ad2593f4c87d86c$var$voteOptionFromJSON;
function $7ad2593f4c87d86c$var$voteOptionToJSON(object) {
    switch(object){
        case $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $7ad2593f4c87d86c$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $7ad2593f4c87d86c$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$7ad2593f4c87d86c$exports.voteOptionToJSON = $7ad2593f4c87d86c$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $7ad2593f4c87d86c$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7ad2593f4c87d86c$var$ProposalStatus = $7ad2593f4c87d86c$exports.ProposalStatus || ($7ad2593f4c87d86c$exports.ProposalStatus = {}));
function $7ad2593f4c87d86c$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7ad2593f4c87d86c$var$ProposalStatus.UNRECOGNIZED;
    }
}
$7ad2593f4c87d86c$exports.proposalStatusFromJSON = $7ad2593f4c87d86c$var$proposalStatusFromJSON;
function $7ad2593f4c87d86c$var$proposalStatusToJSON(object) {
    switch(object){
        case $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $7ad2593f4c87d86c$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $7ad2593f4c87d86c$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$7ad2593f4c87d86c$exports.proposalStatusToJSON = $7ad2593f4c87d86c$var$proposalStatusToJSON;
function $7ad2593f4c87d86c$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
$7ad2593f4c87d86c$exports.WeightedVoteOption = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            option: (0, $7iZIe.isSet)(object.option) ? $7ad2593f4c87d86c$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $7iZIe.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.option !== undefined && (obj.option = $7ad2593f4c87d86c$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7ad2593f4c87d86c$var$createBaseWeightedVoteOption();
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        var _object_weight;
        message.weight = (_object_weight = object.weight) !== null && _object_weight !== void 0 ? _object_weight : "";
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseTextProposal() {
    return {
        title: "",
        description: ""
    };
}
$7ad2593f4c87d86c$exports.TextProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseTextProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7ad2593f4c87d86c$var$createBaseTextProposal();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseDeposit() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$7ad2593f4c87d86c$exports.Deposit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $7ad2593f4c87d86c$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseProposal() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined
    };
}
$7ad2593f4c87d86c$exports.Proposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $DM7bi.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $7ad2593f4c87d86c$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $ib0XJ.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $ib0XJ.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.totalDeposit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(58).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.votingStartTime !== undefined) $ib0XJ.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $ib0XJ.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $7ad2593f4c87d86c$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            content: (0, $7iZIe.isSet)(object.content) ? $DM7bi.Any.fromJSON(object.content) : undefined,
            status: (0, $7iZIe.isSet)(object.status) ? $7ad2593f4c87d86c$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $7iZIe.isSet)(object.finalTallyResult) ? $7ad2593f4c87d86c$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $7iZIe.isSet)(object.submitTime) ? (0, $7iZIe.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $7iZIe.isSet)(object.depositEndTime) ? (0, $7iZIe.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDeposit) ? object.totalDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            votingStartTime: (0, $7iZIe.isSet)(object.votingStartTime) ? (0, $7iZIe.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $7iZIe.isSet)(object.votingEndTime) ? (0, $7iZIe.fromJsonTimestamp)(object.votingEndTime) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.content !== undefined && (obj.content = message.content ? $DM7bi.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $7ad2593f4c87d86c$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $7ad2593f4c87d86c$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $7iZIe.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $7iZIe.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $7iZIe.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $7iZIe.fromTimestamp)(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_totalDeposit;
        var message = $7ad2593f4c87d86c$var$createBaseProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        message.content = object.content !== undefined && object.content !== null ? $DM7bi.Any.fromPartial(object.content) : undefined;
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $7ad2593f4c87d86c$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $ib0XJ.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $ib0XJ.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = ((_object_totalDeposit = object.totalDeposit) === null || _object_totalDeposit === void 0 ? void 0 : _object_totalDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $ib0XJ.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $ib0XJ.Timestamp.fromPartial(object.votingEndTime) : undefined;
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: ""
    };
}
$7ad2593f4c87d86c$exports.TallyResult = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseTallyResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            yes: (0, $7iZIe.isSet)(object.yes) ? String(object.yes) : "",
            abstain: (0, $7iZIe.isSet)(object.abstain) ? String(object.abstain) : "",
            no: (0, $7iZIe.isSet)(object.no) ? String(object.no) : "",
            noWithVeto: (0, $7iZIe.isSet)(object.noWithVeto) ? String(object.noWithVeto) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7ad2593f4c87d86c$var$createBaseTallyResult();
        var _object_yes;
        message.yes = (_object_yes = object.yes) !== null && _object_yes !== void 0 ? _object_yes : "";
        var _object_abstain;
        message.abstain = (_object_abstain = object.abstain) !== null && _object_abstain !== void 0 ? _object_abstain : "";
        var _object_no;
        message.no = (_object_no = object.no) !== null && _object_no !== void 0 ? _object_no : "";
        var _object_noWithVeto;
        message.noWithVeto = (_object_noWithVeto = object.noWithVeto) !== null && _object_noWithVeto !== void 0 ? _object_noWithVeto : "";
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseVote() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        option: 0,
        options: []
    };
}
$7ad2593f4c87d86c$exports.Vote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $7ad2593f4c87d86c$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push($7ad2593f4c87d86c$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $7iZIe.isSet)(object.option) ? $7ad2593f4c87d86c$var$voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function(e) {
                return $7ad2593f4c87d86c$exports.WeightedVoteOption.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $7ad2593f4c87d86c$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map(function(e) {
            return e ? $7ad2593f4c87d86c$exports.WeightedVoteOption.toJSON(e) : undefined;
        });
        else obj.options = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_options;
        var message = $7ad2593f4c87d86c$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        message.options = ((_object_options = object.options) === null || _object_options === void 0 ? void 0 : _object_options.map(function(e) {
            return $7ad2593f4c87d86c$exports.WeightedVoteOption.fromPartial(e);
        })) || [];
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
$7ad2593f4c87d86c$exports.DepositParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.minDeposit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.maxDepositPeriod !== undefined) $i8V5u.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseDepositParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.minDeposit) ? object.minDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            maxDepositPeriod: (0, $7iZIe.isSet)(object.maxDepositPeriod) ? $i8V5u.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $i8V5u.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_minDeposit;
        var message = $7ad2593f4c87d86c$var$createBaseDepositParams();
        message.minDeposit = ((_object_minDeposit = object.minDeposit) === null || _object_minDeposit === void 0 ? void 0 : _object_minDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $i8V5u.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
$7ad2593f4c87d86c$exports.VotingParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (message.votingPeriod !== undefined) $i8V5u.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseVotingParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            votingPeriod: (0, $7iZIe.isSet)(object.votingPeriod) ? $i8V5u.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $i8V5u.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7ad2593f4c87d86c$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $i8V5u.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $7ad2593f4c87d86c$var$createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array()
    };
}
$7ad2593f4c87d86c$exports.TallyParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ad2593f4c87d86c$var$_m0.Writer.create();
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7ad2593f4c87d86c$var$_m0.Reader ? input : new $7ad2593f4c87d86c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7ad2593f4c87d86c$var$createBaseTallyParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            quorum: (0, $7iZIe.isSet)(object.quorum) ? (0, $7iZIe.bytesFromBase64)(object.quorum) : new Uint8Array(),
            threshold: (0, $7iZIe.isSet)(object.threshold) ? (0, $7iZIe.bytesFromBase64)(object.threshold) : new Uint8Array(),
            vetoThreshold: (0, $7iZIe.isSet)(object.vetoThreshold) ? (0, $7iZIe.bytesFromBase64)(object.vetoThreshold) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.quorum !== undefined && (obj.quorum = (0, $7iZIe.base64FromBytes)(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = (0, $7iZIe.base64FromBytes)(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = (0, $7iZIe.base64FromBytes)(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $7ad2593f4c87d86c$var$createBaseTallyParams();
        var _object_quorum;
        message.quorum = (_object_quorum = object.quorum) !== null && _object_quorum !== void 0 ? _object_quorum : new Uint8Array();
        var _object_threshold;
        message.threshold = (_object_threshold = object.threshold) !== null && _object_threshold !== void 0 ? _object_threshold : new Uint8Array();
        var _object_vetoThreshold;
        message.vetoThreshold = (_object_vetoThreshold = object.vetoThreshold) !== null && _object_vetoThreshold !== void 0 ? _object_vetoThreshold : new Uint8Array();
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");

var $191ed9ff1698f7ee$var$long_1 = $191ed9ff1698f7ee$var$__importDefault((parcelRequire("l6G6L")));

function $191ed9ff1698f7ee$var$isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$191ed9ff1698f7ee$exports.isAminoMsgSubmitProposal = $191ed9ff1698f7ee$var$isAminoMsgSubmitProposal;
function $191ed9ff1698f7ee$var$isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$191ed9ff1698f7ee$exports.isAminoMsgVote = $191ed9ff1698f7ee$var$isAminoMsgVote;
function $191ed9ff1698f7ee$var$isAminoMsgVoteWeighted(msg) {
    return msg.type === "cosmos-sdk/MsgVoteWeighted";
}
$191ed9ff1698f7ee$exports.isAminoMsgVoteWeighted = $191ed9ff1698f7ee$var$isAminoMsgVoteWeighted;
function $191ed9ff1698f7ee$var$isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$191ed9ff1698f7ee$exports.isAminoMsgDeposit = $191ed9ff1698f7ee$var$isAminoMsgDeposit;
function $191ed9ff1698f7ee$var$createGovAminoConverters() {
    // Gov v1 types missing, see
    // https://github.com/cosmos/cosmjs/issues/1442
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: function(param) {
                var amount = param.amount, depositor = param.depositor, proposalId = param.proposalId;
                return {
                    amount: amount,
                    depositor: depositor,
                    proposal_id: proposalId.toString()
                };
            },
            fromAmino: function(param) {
                var amount = param.amount, depositor = param.depositor, proposal_id = param.proposal_id;
                return {
                    amount: Array.from(amount),
                    depositor: depositor,
                    proposalId: $191ed9ff1698f7ee$var$long_1.default.fromString(proposal_id)
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: function(param) {
                var option = param.option, proposalId = param.proposalId, voter = param.voter;
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: function(param) {
                var option = param.option, proposal_id = param.proposal_id, voter = param.voter;
                return {
                    option: (0, $7ad2593f4c87d86c$exports.voteOptionFromJSON)(option),
                    proposalId: $191ed9ff1698f7ee$var$long_1.default.fromString(proposal_id),
                    voter: voter
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVoteWeighted": {
            aminoType: "cosmos-sdk/MsgVoteWeighted",
            toAmino: function(param) {
                var options = param.options, proposalId = param.proposalId, voter = param.voter;
                return {
                    options: options.map(function(o) {
                        return {
                            option: o.option,
                            // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
                            // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
                            weight: (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(o.weight).toString().padEnd(20, "0")
                        };
                    }),
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: function(param) {
                var options = param.options, proposal_id = param.proposal_id, voter = param.voter;
                return {
                    proposalId: $191ed9ff1698f7ee$var$long_1.default.fromString(proposal_id),
                    voter: voter,
                    options: options.map(function(o) {
                        return {
                            option: (0, $7ad2593f4c87d86c$exports.voteOptionFromJSON)(o.option),
                            weight: $kTbgy.Decimal.fromUserInput(o.weight, 18).atomics
                        };
                    })
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: function(param) {
                var initialDeposit = param.initialDeposit, proposer = param.proposer, content = param.content;
                (0, $gMk5u.assertDefinedAndNotNull)(content);
                var proposal;
                switch(content.typeUrl){
                    case "/cosmos.gov.v1beta1.TextProposal":
                        {
                            var textProposal = $7ad2593f4c87d86c$exports.TextProposal.decode(content.value);
                            proposal = {
                                type: "cosmos-sdk/TextProposal",
                                value: {
                                    description: textProposal.description,
                                    title: textProposal.title
                                }
                            };
                            break;
                        }
                    default:
                        throw new Error("Unsupported proposal type: '".concat(content.typeUrl, "'"));
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal
                };
            },
            fromAmino: function(param) {
                var initial_deposit = param.initial_deposit, proposer = param.proposer, content = param.content;
                var any_content;
                switch(content.type){
                    case "cosmos-sdk/TextProposal":
                        {
                            var value = content.value;
                            (0, $gMk5u.assert)((0, $gMk5u.isNonNullObject)(value));
                            var title = value.title, description = value.description;
                            (0, $gMk5u.assert)(typeof title === "string");
                            (0, $gMk5u.assert)(typeof description === "string");
                            any_content = $DM7bi.Any.fromPartial({
                                typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                                value: $7ad2593f4c87d86c$exports.TextProposal.encode($7ad2593f4c87d86c$exports.TextProposal.fromPartial({
                                    title: title,
                                    description: description
                                })).finish()
                            });
                            break;
                        }
                    default:
                        throw new Error("Unsupported proposal type: '".concat(content.type, "'"));
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content
                };
            }
        }
    };
}
$191ed9ff1698f7ee$exports.createGovAminoConverters = $191ed9ff1698f7ee$var$createGovAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function get() {
        return $191ed9ff1698f7ee$exports.createGovAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function get() {
        return $191ed9ff1698f7ee$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function get() {
        return $191ed9ff1698f7ee$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function get() {
        return $191ed9ff1698f7ee$exports.isAminoMsgVote;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function get() {
        return $191ed9ff1698f7ee$exports.isAminoMsgVoteWeighted;
    }
});
var $e1866a24eeb8390d$exports = {};
"use strict";
Object.defineProperty($e1866a24eeb8390d$exports, "__esModule", {
    value: true
});
$e1866a24eeb8390d$exports.isMsgVoteWeightedEncodeObject = $e1866a24eeb8390d$exports.isMsgVoteEncodeObject = $e1866a24eeb8390d$exports.isMsgSubmitProposalEncodeObject = $e1866a24eeb8390d$exports.isMsgDepositEncodeObject = $e1866a24eeb8390d$exports.govTypes = void 0;
var $21a6ecc8e88bd90c$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $21a6ecc8e88bd90c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21a6ecc8e88bd90c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $21a6ecc8e88bd90c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $21a6ecc8e88bd90c$var$__createBinding(result, mod, k);
    }
    $21a6ecc8e88bd90c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($21a6ecc8e88bd90c$exports, "__esModule", {
    value: true
});
$21a6ecc8e88bd90c$exports.MsgClientImpl = $21a6ecc8e88bd90c$exports.MsgUpdateParamsResponse = $21a6ecc8e88bd90c$exports.MsgUpdateParams = $21a6ecc8e88bd90c$exports.MsgDepositResponse = $21a6ecc8e88bd90c$exports.MsgDeposit = $21a6ecc8e88bd90c$exports.MsgVoteWeightedResponse = $21a6ecc8e88bd90c$exports.MsgVoteWeighted = $21a6ecc8e88bd90c$exports.MsgVoteResponse = $21a6ecc8e88bd90c$exports.MsgVote = $21a6ecc8e88bd90c$exports.MsgExecLegacyContentResponse = $21a6ecc8e88bd90c$exports.MsgExecLegacyContent = $21a6ecc8e88bd90c$exports.MsgSubmitProposalResponse = $21a6ecc8e88bd90c$exports.MsgSubmitProposal = $21a6ecc8e88bd90c$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $87da393bff737a36$exports = {};
"use strict";
var $87da393bff737a36$var$__createBinding = $87da393bff737a36$exports && $87da393bff737a36$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $87da393bff737a36$var$__setModuleDefault = $87da393bff737a36$exports && $87da393bff737a36$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $87da393bff737a36$var$__importStar = $87da393bff737a36$exports && $87da393bff737a36$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $87da393bff737a36$var$__createBinding(result, mod, k);
    }
    $87da393bff737a36$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($87da393bff737a36$exports, "__esModule", {
    value: true
});
$87da393bff737a36$exports.Params = $87da393bff737a36$exports.TallyParams = $87da393bff737a36$exports.VotingParams = $87da393bff737a36$exports.DepositParams = $87da393bff737a36$exports.Vote = $87da393bff737a36$exports.TallyResult = $87da393bff737a36$exports.Proposal = $87da393bff737a36$exports.Deposit = $87da393bff737a36$exports.WeightedVoteOption = $87da393bff737a36$exports.proposalStatusToJSON = $87da393bff737a36$exports.proposalStatusFromJSON = $87da393bff737a36$exports.ProposalStatus = $87da393bff737a36$exports.voteOptionToJSON = $87da393bff737a36$exports.voteOptionFromJSON = $87da393bff737a36$exports.VoteOption = $87da393bff737a36$exports.protobufPackage = void 0;


var $DM7bi = parcelRequire("DM7bi");

var $ib0XJ = parcelRequire("ib0XJ");

var $i8V5u = parcelRequire("i8V5u");

var $7iZIe = parcelRequire("7iZIe");

var $87da393bff737a36$var$_m0 = $87da393bff737a36$var$__importStar((parcelRequire("hjb8Q")));
$87da393bff737a36$exports.protobufPackage = "cosmos.gov.v1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $87da393bff737a36$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($87da393bff737a36$var$VoteOption = $87da393bff737a36$exports.VoteOption || ($87da393bff737a36$exports.VoteOption = {}));
function $87da393bff737a36$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $87da393bff737a36$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $87da393bff737a36$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $87da393bff737a36$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $87da393bff737a36$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $87da393bff737a36$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $87da393bff737a36$var$VoteOption.UNRECOGNIZED;
    }
}
$87da393bff737a36$exports.voteOptionFromJSON = $87da393bff737a36$var$voteOptionFromJSON;
function $87da393bff737a36$var$voteOptionToJSON(object) {
    switch(object){
        case $87da393bff737a36$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $87da393bff737a36$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $87da393bff737a36$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $87da393bff737a36$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $87da393bff737a36$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $87da393bff737a36$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$87da393bff737a36$exports.voteOptionToJSON = $87da393bff737a36$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $87da393bff737a36$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($87da393bff737a36$var$ProposalStatus = $87da393bff737a36$exports.ProposalStatus || ($87da393bff737a36$exports.ProposalStatus = {}));
function $87da393bff737a36$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $87da393bff737a36$var$ProposalStatus.UNRECOGNIZED;
    }
}
$87da393bff737a36$exports.proposalStatusFromJSON = $87da393bff737a36$var$proposalStatusFromJSON;
function $87da393bff737a36$var$proposalStatusToJSON(object) {
    switch(object){
        case $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $87da393bff737a36$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $87da393bff737a36$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$87da393bff737a36$exports.proposalStatusToJSON = $87da393bff737a36$var$proposalStatusToJSON;
function $87da393bff737a36$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
$87da393bff737a36$exports.WeightedVoteOption = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            option: (0, $7iZIe.isSet)(object.option) ? $87da393bff737a36$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $7iZIe.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.option !== undefined && (obj.option = $87da393bff737a36$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87da393bff737a36$var$createBaseWeightedVoteOption();
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        var _object_weight;
        message.weight = (_object_weight = object.weight) !== null && _object_weight !== void 0 ? _object_weight : "";
        return message;
    }
};
function $87da393bff737a36$var$createBaseDeposit() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$87da393bff737a36$exports.Deposit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $87da393bff737a36$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $87da393bff737a36$var$createBaseProposal() {
    return {
        id: $7iZIe.Long.UZERO,
        messages: [],
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
        metadata: "",
        title: "",
        summary: "",
        proposer: ""
    };
}
$87da393bff737a36$exports.Proposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $87da393bff737a36$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $ib0XJ.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $ib0XJ.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.totalDeposit[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $5bc8eb379b028930$exports.Coin.encode(v1, writer.uint32(58).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.votingStartTime !== undefined) $ib0XJ.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $ib0XJ.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(82).string(message.metadata);
        if (message.title !== "") writer.uint32(90).string(message.title);
        if (message.summary !== "") writer.uint32(98).string(message.summary);
        if (message.proposer !== "") writer.uint32(106).string(message.proposer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.messages.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $87da393bff737a36$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.metadata = reader.string();
                    break;
                case 11:
                    message.title = reader.string();
                    break;
                case 12:
                    message.summary = reader.string();
                    break;
                case 13:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            id: (0, $7iZIe.isSet)(object.id) ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.UZERO,
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            status: (0, $7iZIe.isSet)(object.status) ? $87da393bff737a36$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $7iZIe.isSet)(object.finalTallyResult) ? $87da393bff737a36$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $7iZIe.isSet)(object.submitTime) ? (0, $7iZIe.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $7iZIe.isSet)(object.depositEndTime) ? (0, $7iZIe.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDeposit) ? object.totalDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            votingStartTime: (0, $7iZIe.isSet)(object.votingStartTime) ? (0, $7iZIe.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $7iZIe.isSet)(object.votingEndTime) ? (0, $7iZIe.fromJsonTimestamp)(object.votingEndTime) : undefined,
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $7iZIe.isSet)(object.summary) ? String(object.summary) : "",
            proposer: (0, $7iZIe.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.id !== undefined && (obj.id = (message.id || $7iZIe.Long.UZERO).toString());
        if (message.messages) obj.messages = message.messages.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.messages = [];
        message.status !== undefined && (obj.status = $87da393bff737a36$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $87da393bff737a36$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $7iZIe.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $7iZIe.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $7iZIe.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $7iZIe.fromTimestamp)(message.votingEndTime).toISOString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial: function(object) {
        var _object_messages, _object_totalDeposit;
        var message = $87da393bff737a36$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $7iZIe.Long.fromValue(object.id) : $7iZIe.Long.UZERO;
        message.messages = ((_object_messages = object.messages) === null || _object_messages === void 0 ? void 0 : _object_messages.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $87da393bff737a36$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $ib0XJ.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $ib0XJ.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = ((_object_totalDeposit = object.totalDeposit) === null || _object_totalDeposit === void 0 ? void 0 : _object_totalDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $ib0XJ.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $ib0XJ.Timestamp.fromPartial(object.votingEndTime) : undefined;
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_summary;
        message.summary = (_object_summary = object.summary) !== null && _object_summary !== void 0 ? _object_summary : "";
        var _object_proposer;
        message.proposer = (_object_proposer = object.proposer) !== null && _object_proposer !== void 0 ? _object_proposer : "";
        return message;
    }
};
function $87da393bff737a36$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
$87da393bff737a36$exports.TallyResult = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseTallyResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            yesCount: (0, $7iZIe.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $7iZIe.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $7iZIe.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $7iZIe.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87da393bff737a36$var$createBaseTallyResult();
        var _object_yesCount;
        message.yesCount = (_object_yesCount = object.yesCount) !== null && _object_yesCount !== void 0 ? _object_yesCount : "";
        var _object_abstainCount;
        message.abstainCount = (_object_abstainCount = object.abstainCount) !== null && _object_abstainCount !== void 0 ? _object_abstainCount : "";
        var _object_noCount;
        message.noCount = (_object_noCount = object.noCount) !== null && _object_noCount !== void 0 ? _object_noCount : "";
        var _object_noWithVetoCount;
        message.noWithVetoCount = (_object_noWithVetoCount = object.noWithVetoCount) !== null && _object_noWithVetoCount !== void 0 ? _object_noWithVetoCount : "";
        return message;
    }
};
function $87da393bff737a36$var$createBaseVote() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
$87da393bff737a36$exports.Vote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $87da393bff737a36$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.metadata !== "") writer.uint32(42).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 4:
                    message.options.push($87da393bff737a36$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function(e) {
                return $87da393bff737a36$exports.WeightedVoteOption.fromJSON(e);
            }) : [],
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map(function(e) {
            return e ? $87da393bff737a36$exports.WeightedVoteOption.toJSON(e) : undefined;
        });
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var _object_options;
        var message = $87da393bff737a36$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        message.options = ((_object_options = object.options) === null || _object_options === void 0 ? void 0 : _object_options.map(function(e) {
            return $87da393bff737a36$exports.WeightedVoteOption.fromPartial(e);
        })) || [];
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function $87da393bff737a36$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
$87da393bff737a36$exports.DepositParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.minDeposit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.maxDepositPeriod !== undefined) $i8V5u.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseDepositParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.minDeposit) ? object.minDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            maxDepositPeriod: (0, $7iZIe.isSet)(object.maxDepositPeriod) ? $i8V5u.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $i8V5u.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_minDeposit;
        var message = $87da393bff737a36$var$createBaseDepositParams();
        message.minDeposit = ((_object_minDeposit = object.minDeposit) === null || _object_minDeposit === void 0 ? void 0 : _object_minDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $i8V5u.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $87da393bff737a36$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
$87da393bff737a36$exports.VotingParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (message.votingPeriod !== undefined) $i8V5u.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseVotingParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            votingPeriod: (0, $7iZIe.isSet)(object.votingPeriod) ? $i8V5u.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $i8V5u.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87da393bff737a36$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $i8V5u.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $87da393bff737a36$var$createBaseTallyParams() {
    return {
        quorum: "",
        threshold: "",
        vetoThreshold: ""
    };
}
$87da393bff737a36$exports.TallyParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        if (message.quorum !== "") writer.uint32(10).string(message.quorum);
        if (message.threshold !== "") writer.uint32(18).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(26).string(message.vetoThreshold);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseTallyParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.string();
                    break;
                case 2:
                    message.threshold = reader.string();
                    break;
                case 3:
                    message.vetoThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            quorum: (0, $7iZIe.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $7iZIe.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $7iZIe.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        return obj;
    },
    fromPartial: function(object) {
        var message = $87da393bff737a36$var$createBaseTallyParams();
        var _object_quorum;
        message.quorum = (_object_quorum = object.quorum) !== null && _object_quorum !== void 0 ? _object_quorum : "";
        var _object_threshold;
        message.threshold = (_object_threshold = object.threshold) !== null && _object_threshold !== void 0 ? _object_threshold : "";
        var _object_vetoThreshold;
        message.vetoThreshold = (_object_vetoThreshold = object.vetoThreshold) !== null && _object_vetoThreshold !== void 0 ? _object_vetoThreshold : "";
        return message;
    }
};
function $87da393bff737a36$var$createBaseParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
        votingPeriod: undefined,
        quorum: "",
        threshold: "",
        vetoThreshold: "",
        minInitialDepositRatio: "",
        burnVoteQuorum: false,
        burnProposalDepositPrevote: false,
        burnVoteVeto: false
    };
}
$87da393bff737a36$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $87da393bff737a36$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.minDeposit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.maxDepositPeriod !== undefined) $i8V5u.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        if (message.votingPeriod !== undefined) $i8V5u.Duration.encode(message.votingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.quorum !== "") writer.uint32(34).string(message.quorum);
        if (message.threshold !== "") writer.uint32(42).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(50).string(message.vetoThreshold);
        if (message.minInitialDepositRatio !== "") writer.uint32(58).string(message.minInitialDepositRatio);
        if (message.burnVoteQuorum === true) writer.uint32(104).bool(message.burnVoteQuorum);
        if (message.burnProposalDepositPrevote === true) writer.uint32(112).bool(message.burnProposalDepositPrevote);
        if (message.burnVoteVeto === true) writer.uint32(120).bool(message.burnVoteVeto);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $87da393bff737a36$var$_m0.Reader ? input : new $87da393bff737a36$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $87da393bff737a36$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.quorum = reader.string();
                    break;
                case 5:
                    message.threshold = reader.string();
                    break;
                case 6:
                    message.vetoThreshold = reader.string();
                    break;
                case 7:
                    message.minInitialDepositRatio = reader.string();
                    break;
                case 13:
                    message.burnVoteQuorum = reader.bool();
                    break;
                case 14:
                    message.burnProposalDepositPrevote = reader.bool();
                    break;
                case 15:
                    message.burnVoteVeto = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.minDeposit) ? object.minDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            maxDepositPeriod: (0, $7iZIe.isSet)(object.maxDepositPeriod) ? $i8V5u.Duration.fromJSON(object.maxDepositPeriod) : undefined,
            votingPeriod: (0, $7iZIe.isSet)(object.votingPeriod) ? $i8V5u.Duration.fromJSON(object.votingPeriod) : undefined,
            quorum: (0, $7iZIe.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $7iZIe.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $7iZIe.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : "",
            minInitialDepositRatio: (0, $7iZIe.isSet)(object.minInitialDepositRatio) ? String(object.minInitialDepositRatio) : "",
            burnVoteQuorum: (0, $7iZIe.isSet)(object.burnVoteQuorum) ? Boolean(object.burnVoteQuorum) : false,
            burnProposalDepositPrevote: (0, $7iZIe.isSet)(object.burnProposalDepositPrevote) ? Boolean(object.burnProposalDepositPrevote) : false,
            burnVoteVeto: (0, $7iZIe.isSet)(object.burnVoteVeto) ? Boolean(object.burnVoteVeto) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $i8V5u.Duration.toJSON(message.maxDepositPeriod) : undefined);
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $i8V5u.Duration.toJSON(message.votingPeriod) : undefined);
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        message.minInitialDepositRatio !== undefined && (obj.minInitialDepositRatio = message.minInitialDepositRatio);
        message.burnVoteQuorum !== undefined && (obj.burnVoteQuorum = message.burnVoteQuorum);
        message.burnProposalDepositPrevote !== undefined && (obj.burnProposalDepositPrevote = message.burnProposalDepositPrevote);
        message.burnVoteVeto !== undefined && (obj.burnVoteVeto = message.burnVoteVeto);
        return obj;
    },
    fromPartial: function(object) {
        var _object_minDeposit;
        var message = $87da393bff737a36$var$createBaseParams();
        message.minDeposit = ((_object_minDeposit = object.minDeposit) === null || _object_minDeposit === void 0 ? void 0 : _object_minDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $i8V5u.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $i8V5u.Duration.fromPartial(object.votingPeriod) : undefined;
        var _object_quorum;
        message.quorum = (_object_quorum = object.quorum) !== null && _object_quorum !== void 0 ? _object_quorum : "";
        var _object_threshold;
        message.threshold = (_object_threshold = object.threshold) !== null && _object_threshold !== void 0 ? _object_threshold : "";
        var _object_vetoThreshold;
        message.vetoThreshold = (_object_vetoThreshold = object.vetoThreshold) !== null && _object_vetoThreshold !== void 0 ? _object_vetoThreshold : "";
        var _object_minInitialDepositRatio;
        message.minInitialDepositRatio = (_object_minInitialDepositRatio = object.minInitialDepositRatio) !== null && _object_minInitialDepositRatio !== void 0 ? _object_minInitialDepositRatio : "";
        var _object_burnVoteQuorum;
        message.burnVoteQuorum = (_object_burnVoteQuorum = object.burnVoteQuorum) !== null && _object_burnVoteQuorum !== void 0 ? _object_burnVoteQuorum : false;
        var _object_burnProposalDepositPrevote;
        message.burnProposalDepositPrevote = (_object_burnProposalDepositPrevote = object.burnProposalDepositPrevote) !== null && _object_burnProposalDepositPrevote !== void 0 ? _object_burnProposalDepositPrevote : false;
        var _object_burnVoteVeto;
        message.burnVoteVeto = (_object_burnVoteVeto = object.burnVoteVeto) !== null && _object_burnVoteVeto !== void 0 ? _object_burnVoteVeto : false;
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $21a6ecc8e88bd90c$var$_m0 = $21a6ecc8e88bd90c$var$__importStar((parcelRequire("hjb8Q")));
$21a6ecc8e88bd90c$exports.protobufPackage = "cosmos.gov.v1";
function $21a6ecc8e88bd90c$var$createBaseMsgSubmitProposal() {
    return {
        messages: [],
        initialDeposit: [],
        proposer: "",
        metadata: "",
        title: "",
        summary: ""
    };
}
$21a6ecc8e88bd90c$exports.MsgSubmitProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $DM7bi.Any.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.initialDeposit[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $5bc8eb379b028930$exports.Coin.encode(v1, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.title !== "") writer.uint32(42).string(message.title);
        if (message.summary !== "") writer.uint32(50).string(message.summary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.initialDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.title = reader.string();
                    break;
                case 6:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : [],
            initialDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.initialDeposit) ? object.initialDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            proposer: (0, $7iZIe.isSet)(object.proposer) ? String(object.proposer) : "",
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $7iZIe.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.messages) obj.messages = message.messages.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.messages = [];
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial: function(object) {
        var _object_messages, _object_initialDeposit;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgSubmitProposal();
        message.messages = ((_object_messages = object.messages) === null || _object_messages === void 0 ? void 0 : _object_messages.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        message.initialDeposit = ((_object_initialDeposit = object.initialDeposit) === null || _object_initialDeposit === void 0 ? void 0 : _object_initialDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        var _object_proposer;
        message.proposer = (_object_proposer = object.proposer) !== null && _object_proposer !== void 0 ? _object_proposer : "";
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_summary;
        message.summary = (_object_summary = object.summary) !== null && _object_summary !== void 0 ? _object_summary : "";
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $7iZIe.Long.UZERO
    };
}
$21a6ecc8e88bd90c$exports.MsgSubmitProposalResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgExecLegacyContent() {
    return {
        content: undefined,
        authority: ""
    };
}
$21a6ecc8e88bd90c$exports.MsgExecLegacyContent = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        if (message.content !== undefined) $DM7bi.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        if (message.authority !== "") writer.uint32(18).string(message.authority);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgExecLegacyContent();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authority = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            content: (0, $7iZIe.isSet)(object.content) ? $DM7bi.Any.fromJSON(object.content) : undefined,
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.content !== undefined && (obj.content = message.content ? $DM7bi.Any.toJSON(message.content) : undefined);
        message.authority !== undefined && (obj.authority = message.authority);
        return obj;
    },
    fromPartial: function(object) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgExecLegacyContent();
        message.content = object.content !== undefined && object.content !== null ? $DM7bi.Any.fromPartial(object.content) : undefined;
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgExecLegacyContentResponse() {
    return {};
}
$21a6ecc8e88bd90c$exports.MsgExecLegacyContentResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgExecLegacyContentResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgExecLegacyContentResponse();
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgVote() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        option: 0,
        metadata: ""
    };
}
$21a6ecc8e88bd90c$exports.MsgVote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $7iZIe.isSet)(object.option) ? (0, $87da393bff737a36$exports.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $87da393bff737a36$exports.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgVoteResponse() {
    return {};
}
$21a6ecc8e88bd90c$exports.MsgVoteResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
$21a6ecc8e88bd90c$exports.MsgVoteWeighted = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $87da393bff737a36$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($87da393bff737a36$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function(e) {
                return $87da393bff737a36$exports.WeightedVoteOption.fromJSON(e);
            }) : [],
            metadata: (0, $7iZIe.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map(function(e) {
            return e ? $87da393bff737a36$exports.WeightedVoteOption.toJSON(e) : undefined;
        });
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial: function(object) {
        var _object_options;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        message.options = ((_object_options = object.options) === null || _object_options === void 0 ? void 0 : _object_options.map(function(e) {
            return $87da393bff737a36$exports.WeightedVoteOption.fromPartial(e);
        })) || [];
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : "";
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
$21a6ecc8e88bd90c$exports.MsgVoteWeightedResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgDeposit() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$21a6ecc8e88bd90c$exports.MsgDeposit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgDepositResponse() {
    return {};
}
$21a6ecc8e88bd90c$exports.MsgDepositResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$21a6ecc8e88bd90c$exports.MsgUpdateParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $87da393bff737a36$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $87da393bff737a36$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $7iZIe.isSet)(object.params) ? $87da393bff737a36$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $87da393bff737a36$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgUpdateParams();
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        message.params = object.params !== undefined && object.params !== null ? $87da393bff737a36$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $21a6ecc8e88bd90c$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$21a6ecc8e88bd90c$exports.MsgUpdateParamsResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $21a6ecc8e88bd90c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $21a6ecc8e88bd90c$var$_m0.Reader ? input : new $21a6ecc8e88bd90c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $21a6ecc8e88bd90c$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $21a6ecc8e88bd90c$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
var $21a6ecc8e88bd90c$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.ExecLegacyContent = this.ExecLegacyContent.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "SubmitProposal",
            value: function SubmitProposal(request) {
                var data = $21a6ecc8e88bd90c$exports.MsgSubmitProposal.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", data);
                return promise.then(function(data) {
                    return $21a6ecc8e88bd90c$exports.MsgSubmitProposalResponse.decode(new $21a6ecc8e88bd90c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ExecLegacyContent",
            value: function ExecLegacyContent(request) {
                var data = $21a6ecc8e88bd90c$exports.MsgExecLegacyContent.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", data);
                return promise.then(function(data) {
                    return $21a6ecc8e88bd90c$exports.MsgExecLegacyContentResponse.decode(new $21a6ecc8e88bd90c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Vote",
            value: function Vote(request) {
                var data = $21a6ecc8e88bd90c$exports.MsgVote.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1.Msg", "Vote", data);
                return promise.then(function(data) {
                    return $21a6ecc8e88bd90c$exports.MsgVoteResponse.decode(new $21a6ecc8e88bd90c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "VoteWeighted",
            value: function VoteWeighted(request) {
                var data = $21a6ecc8e88bd90c$exports.MsgVoteWeighted.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", data);
                return promise.then(function(data) {
                    return $21a6ecc8e88bd90c$exports.MsgVoteWeightedResponse.decode(new $21a6ecc8e88bd90c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Deposit",
            value: function Deposit(request) {
                var data = $21a6ecc8e88bd90c$exports.MsgDeposit.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1.Msg", "Deposit", data);
                return promise.then(function(data) {
                    return $21a6ecc8e88bd90c$exports.MsgDepositResponse.decode(new $21a6ecc8e88bd90c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateParams",
            value: function UpdateParams(request) {
                var data = $21a6ecc8e88bd90c$exports.MsgUpdateParams.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", data);
                return promise.then(function(data) {
                    return $21a6ecc8e88bd90c$exports.MsgUpdateParamsResponse.decode(new $21a6ecc8e88bd90c$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$21a6ecc8e88bd90c$exports.MsgClientImpl = $21a6ecc8e88bd90c$var$MsgClientImpl;


var $c0469013f6d2f9ce$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $c0469013f6d2f9ce$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0469013f6d2f9ce$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c0469013f6d2f9ce$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c0469013f6d2f9ce$var$__createBinding(result, mod, k);
    }
    $c0469013f6d2f9ce$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c0469013f6d2f9ce$exports, "__esModule", {
    value: true
});
$c0469013f6d2f9ce$exports.MsgClientImpl = $c0469013f6d2f9ce$exports.MsgDepositResponse = $c0469013f6d2f9ce$exports.MsgDeposit = $c0469013f6d2f9ce$exports.MsgVoteWeightedResponse = $c0469013f6d2f9ce$exports.MsgVoteWeighted = $c0469013f6d2f9ce$exports.MsgVoteResponse = $c0469013f6d2f9ce$exports.MsgVote = $c0469013f6d2f9ce$exports.MsgSubmitProposalResponse = $c0469013f6d2f9ce$exports.MsgSubmitProposal = $c0469013f6d2f9ce$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");



var $7iZIe = parcelRequire("7iZIe");

var $c0469013f6d2f9ce$var$_m0 = $c0469013f6d2f9ce$var$__importStar((parcelRequire("hjb8Q")));
$c0469013f6d2f9ce$exports.protobufPackage = "cosmos.gov.v1beta1";
function $c0469013f6d2f9ce$var$createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: ""
    };
}
$c0469013f6d2f9ce$exports.MsgSubmitProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        if (message.content !== undefined) $DM7bi.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.initialDeposit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            content: (0, $7iZIe.isSet)(object.content) ? $DM7bi.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.initialDeposit) ? object.initialDeposit.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            proposer: (0, $7iZIe.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.content !== undefined && (obj.content = message.content ? $DM7bi.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial: function(object) {
        var _object_initialDeposit;
        var message = $c0469013f6d2f9ce$var$createBaseMsgSubmitProposal();
        message.content = object.content !== undefined && object.content !== null ? $DM7bi.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = ((_object_initialDeposit = object.initialDeposit) === null || _object_initialDeposit === void 0 ? void 0 : _object_initialDeposit.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        var _object_proposer;
        message.proposer = (_object_proposer = object.proposer) !== null && _object_proposer !== void 0 ? _object_proposer : "";
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $7iZIe.Long.UZERO
    };
}
$c0469013f6d2f9ce$exports.MsgSubmitProposalResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $c0469013f6d2f9ce$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgVote() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        option: 0
    };
}
$c0469013f6d2f9ce$exports.MsgVote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $7iZIe.isSet)(object.option) ? (0, $7ad2593f4c87d86c$exports.voteOptionFromJSON)(object.option) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $7ad2593f4c87d86c$exports.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial: function(object) {
        var message = $c0469013f6d2f9ce$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        var _object_option;
        message.option = (_object_option = object.option) !== null && _object_option !== void 0 ? _object_option : 0;
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgVoteResponse() {
    return {};
}
$c0469013f6d2f9ce$exports.MsgVoteResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $c0469013f6d2f9ce$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: "",
        options: []
    };
}
$c0469013f6d2f9ce$exports.MsgVoteWeighted = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $7ad2593f4c87d86c$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($7ad2593f4c87d86c$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function(e) {
                return $7ad2593f4c87d86c$exports.WeightedVoteOption.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map(function(e) {
            return e ? $7ad2593f4c87d86c$exports.WeightedVoteOption.toJSON(e) : undefined;
        });
        else obj.options = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_options;
        var message = $c0469013f6d2f9ce$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        message.options = ((_object_options = object.options) === null || _object_options === void 0 ? void 0 : _object_options.map(function(e) {
            return $7ad2593f4c87d86c$exports.WeightedVoteOption.fromPartial(e);
        })) || [];
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
$c0469013f6d2f9ce$exports.MsgVoteWeightedResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $c0469013f6d2f9ce$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgDeposit() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$c0469013f6d2f9ce$exports.MsgDeposit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $c0469013f6d2f9ce$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $c0469013f6d2f9ce$var$createBaseMsgDepositResponse() {
    return {};
}
$c0469013f6d2f9ce$exports.MsgDepositResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c0469013f6d2f9ce$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c0469013f6d2f9ce$var$_m0.Reader ? input : new $c0469013f6d2f9ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c0469013f6d2f9ce$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $c0469013f6d2f9ce$var$createBaseMsgDepositResponse();
        return message;
    }
};
var $c0469013f6d2f9ce$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "SubmitProposal",
            value: function SubmitProposal(request) {
                var data = $c0469013f6d2f9ce$exports.MsgSubmitProposal.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
                return promise.then(function(data) {
                    return $c0469013f6d2f9ce$exports.MsgSubmitProposalResponse.decode(new $c0469013f6d2f9ce$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Vote",
            value: function Vote(request) {
                var data = $c0469013f6d2f9ce$exports.MsgVote.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
                return promise.then(function(data) {
                    return $c0469013f6d2f9ce$exports.MsgVoteResponse.decode(new $c0469013f6d2f9ce$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "VoteWeighted",
            value: function VoteWeighted(request) {
                var data = $c0469013f6d2f9ce$exports.MsgVoteWeighted.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
                return promise.then(function(data) {
                    return $c0469013f6d2f9ce$exports.MsgVoteWeightedResponse.decode(new $c0469013f6d2f9ce$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Deposit",
            value: function Deposit(request) {
                var data = $c0469013f6d2f9ce$exports.MsgDeposit.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
                return promise.then(function(data) {
                    return $c0469013f6d2f9ce$exports.MsgDepositResponse.decode(new $c0469013f6d2f9ce$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$c0469013f6d2f9ce$exports.MsgClientImpl = $c0469013f6d2f9ce$var$MsgClientImpl;


$e1866a24eeb8390d$exports.govTypes = [
    [
        "/cosmos.gov.v1.MsgDeposit",
        $21a6ecc8e88bd90c$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1.MsgSubmitProposal",
        $21a6ecc8e88bd90c$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1.MsgUpdateParams",
        $21a6ecc8e88bd90c$exports.MsgUpdateParams
    ],
    [
        "/cosmos.gov.v1.MsgVote",
        $21a6ecc8e88bd90c$exports.MsgVote
    ],
    [
        "/cosmos.gov.v1.MsgVoteWeighted",
        $21a6ecc8e88bd90c$exports.MsgVoteWeighted
    ],
    [
        "/cosmos.gov.v1beta1.MsgDeposit",
        $c0469013f6d2f9ce$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1beta1.MsgSubmitProposal",
        $c0469013f6d2f9ce$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1beta1.MsgVote",
        $c0469013f6d2f9ce$exports.MsgVote
    ],
    [
        "/cosmos.gov.v1beta1.MsgVoteWeighted",
        $c0469013f6d2f9ce$exports.MsgVoteWeighted
    ]
];
function $e1866a24eeb8390d$var$isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
$e1866a24eeb8390d$exports.isMsgDepositEncodeObject = $e1866a24eeb8390d$var$isMsgDepositEncodeObject;
function $e1866a24eeb8390d$var$isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
$e1866a24eeb8390d$exports.isMsgSubmitProposalEncodeObject = $e1866a24eeb8390d$var$isMsgSubmitProposalEncodeObject;
function $e1866a24eeb8390d$var$isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
$e1866a24eeb8390d$exports.isMsgVoteEncodeObject = $e1866a24eeb8390d$var$isMsgVoteEncodeObject;
function $e1866a24eeb8390d$var$isMsgVoteWeightedEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
$e1866a24eeb8390d$exports.isMsgVoteWeightedEncodeObject = $e1866a24eeb8390d$var$isMsgVoteWeightedEncodeObject;


Object.defineProperty($0aaecf7be71ff9a4$exports, "govTypes", {
    enumerable: true,
    get: function get() {
        return $e1866a24eeb8390d$exports.govTypes;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function get() {
        return $e1866a24eeb8390d$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function get() {
        return $e1866a24eeb8390d$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function get() {
        return $e1866a24eeb8390d$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function get() {
        return $e1866a24eeb8390d$exports.isMsgVoteWeightedEncodeObject;
    }
});
var $a48edfb112676895$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($a48edfb112676895$exports, "__esModule", {
    value: true
});
$a48edfb112676895$exports.setupGovExtension = void 0;
var $abce8df04bc83204$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $abce8df04bc83204$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $abce8df04bc83204$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $abce8df04bc83204$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $abce8df04bc83204$var$__createBinding(result, mod, k);
    }
    $abce8df04bc83204$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($abce8df04bc83204$exports, "__esModule", {
    value: true
});
$abce8df04bc83204$exports.QueryClientImpl = $abce8df04bc83204$exports.QueryTallyResultResponse = $abce8df04bc83204$exports.QueryTallyResultRequest = $abce8df04bc83204$exports.QueryDepositsResponse = $abce8df04bc83204$exports.QueryDepositsRequest = $abce8df04bc83204$exports.QueryDepositResponse = $abce8df04bc83204$exports.QueryDepositRequest = $abce8df04bc83204$exports.QueryParamsResponse = $abce8df04bc83204$exports.QueryParamsRequest = $abce8df04bc83204$exports.QueryVotesResponse = $abce8df04bc83204$exports.QueryVotesRequest = $abce8df04bc83204$exports.QueryVoteResponse = $abce8df04bc83204$exports.QueryVoteRequest = $abce8df04bc83204$exports.QueryProposalsResponse = $abce8df04bc83204$exports.QueryProposalsRequest = $abce8df04bc83204$exports.QueryProposalResponse = $abce8df04bc83204$exports.QueryProposalRequest = $abce8df04bc83204$exports.protobufPackage = void 0;



var $7iZIe = parcelRequire("7iZIe");

var $abce8df04bc83204$var$_m0 = $abce8df04bc83204$var$__importStar((parcelRequire("hjb8Q")));
$abce8df04bc83204$exports.protobufPackage = "cosmos.gov.v1beta1";
function $abce8df04bc83204$var$createBaseQueryProposalRequest() {
    return {
        proposalId: $7iZIe.Long.UZERO
    };
}
$abce8df04bc83204$exports.QueryProposalRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryProposalRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryProposalRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryProposalResponse() {
    return {
        proposal: undefined
    };
}
$abce8df04bc83204$exports.QueryProposalResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.proposal !== undefined) $7ad2593f4c87d86c$exports.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposal = $7ad2593f4c87d86c$exports.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal: (0, $7iZIe.isSet)(object.proposal) ? $7ad2593f4c87d86c$exports.Proposal.fromJSON(object.proposal) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposal !== undefined && (obj.proposal = message.proposal ? $7ad2593f4c87d86c$exports.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryProposalResponse();
        message.proposal = object.proposal !== undefined && object.proposal !== null ? $7ad2593f4c87d86c$exports.Proposal.fromPartial(object.proposal) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryProposalsRequest() {
    return {
        proposalStatus: 0,
        voter: "",
        depositor: "",
        pagination: undefined
    };
}
$abce8df04bc83204$exports.QueryProposalsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.proposalStatus !== 0) writer.uint32(8).int32(message.proposalStatus);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.depositor !== "") writer.uint32(26).string(message.depositor);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryProposalsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalStatus: (0, $7iZIe.isSet)(object.proposalStatus) ? (0, $7ad2593f4c87d86c$exports.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : "",
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalStatus !== undefined && (obj.proposalStatus = (0, $7ad2593f4c87d86c$exports.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryProposalsRequest();
        var _object_proposalStatus;
        message.proposalStatus = (_object_proposalStatus = object.proposalStatus) !== null && _object_proposalStatus !== void 0 ? _object_proposalStatus : 0;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryProposalsResponse() {
    return {
        proposals: [],
        pagination: undefined
    };
}
$abce8df04bc83204$exports.QueryProposalsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.proposals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $7ad2593f4c87d86c$exports.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryProposalsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposals.push($7ad2593f4c87d86c$exports.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposals: Array.isArray(object === null || object === void 0 ? void 0 : object.proposals) ? object.proposals.map(function(e) {
                return $7ad2593f4c87d86c$exports.Proposal.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.proposals) obj.proposals = message.proposals.map(function(e) {
            return e ? $7ad2593f4c87d86c$exports.Proposal.toJSON(e) : undefined;
        });
        else obj.proposals = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_proposals;
        var message = $abce8df04bc83204$var$createBaseQueryProposalsResponse();
        message.proposals = ((_object_proposals = object.proposals) === null || _object_proposals === void 0 ? void 0 : _object_proposals.map(function(e) {
            return $7ad2593f4c87d86c$exports.Proposal.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryVoteRequest() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        voter: ""
    };
}
$abce8df04bc83204$exports.QueryVoteRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryVoteRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            voter: (0, $7iZIe.isSet)(object.voter) ? String(object.voter) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryVoteRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_voter;
        message.voter = (_object_voter = object.voter) !== null && _object_voter !== void 0 ? _object_voter : "";
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryVoteResponse() {
    return {
        vote: undefined
    };
}
$abce8df04bc83204$exports.QueryVoteResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.vote !== undefined) $7ad2593f4c87d86c$exports.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryVoteResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.vote = $7ad2593f4c87d86c$exports.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            vote: (0, $7iZIe.isSet)(object.vote) ? $7ad2593f4c87d86c$exports.Vote.fromJSON(object.vote) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? $7ad2593f4c87d86c$exports.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryVoteResponse();
        message.vote = object.vote !== undefined && object.vote !== null ? $7ad2593f4c87d86c$exports.Vote.fromPartial(object.vote) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryVotesRequest() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        pagination: undefined
    };
}
$abce8df04bc83204$exports.QueryVotesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryVotesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryVotesRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryVotesResponse() {
    return {
        votes: [],
        pagination: undefined
    };
}
$abce8df04bc83204$exports.QueryVotesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.votes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $7ad2593f4c87d86c$exports.Vote.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryVotesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votes.push($7ad2593f4c87d86c$exports.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(function(e) {
                return $7ad2593f4c87d86c$exports.Vote.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.votes) obj.votes = message.votes.map(function(e) {
            return e ? $7ad2593f4c87d86c$exports.Vote.toJSON(e) : undefined;
        });
        else obj.votes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_votes;
        var message = $abce8df04bc83204$var$createBaseQueryVotesResponse();
        message.votes = ((_object_votes = object.votes) === null || _object_votes === void 0 ? void 0 : _object_votes.map(function(e) {
            return $7ad2593f4c87d86c$exports.Vote.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryParamsRequest() {
    return {
        paramsType: ""
    };
}
$abce8df04bc83204$exports.QueryParamsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.paramsType !== "") writer.uint32(10).string(message.paramsType);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            paramsType: (0, $7iZIe.isSet)(object.paramsType) ? String(object.paramsType) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryParamsRequest();
        var _object_paramsType;
        message.paramsType = (_object_paramsType = object.paramsType) !== null && _object_paramsType !== void 0 ? _object_paramsType : "";
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryParamsResponse() {
    return {
        votingParams: undefined,
        depositParams: undefined,
        tallyParams: undefined
    };
}
$abce8df04bc83204$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.votingParams !== undefined) $7ad2593f4c87d86c$exports.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        if (message.depositParams !== undefined) $7ad2593f4c87d86c$exports.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        if (message.tallyParams !== undefined) $7ad2593f4c87d86c$exports.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingParams = $7ad2593f4c87d86c$exports.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = $7ad2593f4c87d86c$exports.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = $7ad2593f4c87d86c$exports.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            votingParams: (0, $7iZIe.isSet)(object.votingParams) ? $7ad2593f4c87d86c$exports.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: (0, $7iZIe.isSet)(object.depositParams) ? $7ad2593f4c87d86c$exports.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: (0, $7iZIe.isSet)(object.tallyParams) ? $7ad2593f4c87d86c$exports.TallyParams.fromJSON(object.tallyParams) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.votingParams !== undefined && (obj.votingParams = message.votingParams ? $7ad2593f4c87d86c$exports.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined && (obj.depositParams = message.depositParams ? $7ad2593f4c87d86c$exports.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined && (obj.tallyParams = message.tallyParams ? $7ad2593f4c87d86c$exports.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryParamsResponse();
        message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? $7ad2593f4c87d86c$exports.VotingParams.fromPartial(object.votingParams) : undefined;
        message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? $7ad2593f4c87d86c$exports.DepositParams.fromPartial(object.depositParams) : undefined;
        message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? $7ad2593f4c87d86c$exports.TallyParams.fromPartial(object.tallyParams) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryDepositRequest() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        depositor: ""
    };
}
$abce8df04bc83204$exports.QueryDepositRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryDepositRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            depositor: (0, $7iZIe.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryDepositRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        var _object_depositor;
        message.depositor = (_object_depositor = object.depositor) !== null && _object_depositor !== void 0 ? _object_depositor : "";
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryDepositResponse() {
    return {
        deposit: undefined
    };
}
$abce8df04bc83204$exports.QueryDepositResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.deposit !== undefined) $7ad2593f4c87d86c$exports.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryDepositResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposit = $7ad2593f4c87d86c$exports.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            deposit: (0, $7iZIe.isSet)(object.deposit) ? $7ad2593f4c87d86c$exports.Deposit.fromJSON(object.deposit) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.deposit !== undefined && (obj.deposit = message.deposit ? $7ad2593f4c87d86c$exports.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryDepositResponse();
        message.deposit = object.deposit !== undefined && object.deposit !== null ? $7ad2593f4c87d86c$exports.Deposit.fromPartial(object.deposit) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryDepositsRequest() {
    return {
        proposalId: $7iZIe.Long.UZERO,
        pagination: undefined
    };
}
$abce8df04bc83204$exports.QueryDepositsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryDepositsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO,
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryDepositsRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryDepositsResponse() {
    return {
        deposits: [],
        pagination: undefined
    };
}
$abce8df04bc83204$exports.QueryDepositsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.deposits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $7ad2593f4c87d86c$exports.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryDepositsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposits.push($7ad2593f4c87d86c$exports.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            deposits: Array.isArray(object === null || object === void 0 ? void 0 : object.deposits) ? object.deposits.map(function(e) {
                return $7ad2593f4c87d86c$exports.Deposit.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.deposits) obj.deposits = message.deposits.map(function(e) {
            return e ? $7ad2593f4c87d86c$exports.Deposit.toJSON(e) : undefined;
        });
        else obj.deposits = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_deposits;
        var message = $abce8df04bc83204$var$createBaseQueryDepositsResponse();
        message.deposits = ((_object_deposits = object.deposits) === null || _object_deposits === void 0 ? void 0 : _object_deposits.map(function(e) {
            return $7ad2593f4c87d86c$exports.Deposit.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryTallyResultRequest() {
    return {
        proposalId: $7iZIe.Long.UZERO
    };
}
$abce8df04bc83204$exports.QueryTallyResultRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryTallyResultRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposalId: (0, $7iZIe.isSet)(object.proposalId) ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryTallyResultRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7iZIe.Long.fromValue(object.proposalId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $abce8df04bc83204$var$createBaseQueryTallyResultResponse() {
    return {
        tally: undefined
    };
}
$abce8df04bc83204$exports.QueryTallyResultResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $abce8df04bc83204$var$_m0.Writer.create();
        if (message.tally !== undefined) $7ad2593f4c87d86c$exports.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $abce8df04bc83204$var$_m0.Reader ? input : new $abce8df04bc83204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $abce8df04bc83204$var$createBaseQueryTallyResultResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tally = $7ad2593f4c87d86c$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tally: (0, $7iZIe.isSet)(object.tally) ? $7ad2593f4c87d86c$exports.TallyResult.fromJSON(object.tally) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tally !== undefined && (obj.tally = message.tally ? $7ad2593f4c87d86c$exports.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $abce8df04bc83204$var$createBaseQueryTallyResultResponse();
        message.tally = object.tally !== undefined && object.tally !== null ? $7ad2593f4c87d86c$exports.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    }
};
var $abce8df04bc83204$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Proposal",
            value: function Proposal(request) {
                var data = $abce8df04bc83204$exports.QueryProposalRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryProposalResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Proposals",
            value: function Proposals(request) {
                var data = $abce8df04bc83204$exports.QueryProposalsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryProposalsResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Vote",
            value: function Vote(request) {
                var data = $abce8df04bc83204$exports.QueryVoteRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryVoteResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Votes",
            value: function Votes(request) {
                var data = $abce8df04bc83204$exports.QueryVotesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryVotesResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Params",
            value: function Params(request) {
                var data = $abce8df04bc83204$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryParamsResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Deposit",
            value: function Deposit(request) {
                var data = $abce8df04bc83204$exports.QueryDepositRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryDepositResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Deposits",
            value: function Deposits(request) {
                var data = $abce8df04bc83204$exports.QueryDepositsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryDepositsResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TallyResult",
            value: function TallyResult(request) {
                var data = $abce8df04bc83204$exports.QueryTallyResultRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
                return promise.then(function(data) {
                    return $abce8df04bc83204$exports.QueryTallyResultResponse.decode(new $abce8df04bc83204$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$abce8df04bc83204$exports.QueryClientImpl = $abce8df04bc83204$var$QueryClientImpl;



function $a48edfb112676895$var$setupGovExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var queryService = new $abce8df04bc83204$exports.QueryClientImpl(rpc);
    return {
        gov: {
            params: function() {
                var _ref = (0, $6rBFC._)(function(parametersType) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Params({
                                        paramsType: parametersType
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(parametersType) {
                    return _ref.apply(this, arguments);
                };
            }(),
            proposals: function() {
                var _ref = (0, $6rBFC._)(function(proposalStatus, depositorAddress, voterAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Proposals({
                                        proposalStatus: proposalStatus,
                                        depositor: depositorAddress,
                                        voter: voterAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalStatus, depositorAddress, voterAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            proposal: function() {
                var _ref = (0, $6rBFC._)(function(proposalId) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Proposal({
                                        proposalId: (0, $0f41f7d88b60184b$exports.longify)(proposalId)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            deposits: function() {
                var _ref = (0, $6rBFC._)(function(proposalId, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Deposits({
                                        proposalId: (0, $0f41f7d88b60184b$exports.longify)(proposalId),
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalId, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            deposit: function() {
                var _ref = (0, $6rBFC._)(function(proposalId, depositorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Deposit({
                                        proposalId: (0, $0f41f7d88b60184b$exports.longify)(proposalId),
                                        depositor: depositorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalId, depositorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            tally: function() {
                var _ref = (0, $6rBFC._)(function(proposalId) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.TallyResult({
                                        proposalId: (0, $0f41f7d88b60184b$exports.longify)(proposalId)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            votes: function() {
                var _ref = (0, $6rBFC._)(function(proposalId, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Votes({
                                        proposalId: (0, $0f41f7d88b60184b$exports.longify)(proposalId),
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalId, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            vote: function() {
                var _ref = (0, $6rBFC._)(function(proposalId, voterAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Vote({
                                        proposalId: (0, $0f41f7d88b60184b$exports.longify)(proposalId),
                                        voter: voterAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(proposalId, voterAddress) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$a48edfb112676895$exports.setupGovExtension = $a48edfb112676895$var$setupGovExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupGovExtension", {
    enumerable: true,
    get: function get() {
        return $a48edfb112676895$exports.setupGovExtension;
    }
});
var $bdcc6edaa8601cc1$exports = {};
"use strict";
Object.defineProperty($bdcc6edaa8601cc1$exports, "__esModule", {
    value: true
});
$bdcc6edaa8601cc1$exports.createGroupAminoConverters = void 0;
function $bdcc6edaa8601cc1$var$createGroupAminoConverters() {
    // Missing, see https://github.com/cosmos/cosmjs/issues/1441
    return {};
}
$bdcc6edaa8601cc1$exports.createGroupAminoConverters = $bdcc6edaa8601cc1$var$createGroupAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function get() {
        return $bdcc6edaa8601cc1$exports.createGroupAminoConverters;
    }
});
var $447ffd79ff4af260$exports = {};
"use strict";
Object.defineProperty($447ffd79ff4af260$exports, "__esModule", {
    value: true
});
$447ffd79ff4af260$exports.groupTypes = void 0;

var $fmEYq = parcelRequire("fmEYq");
$447ffd79ff4af260$exports.groupTypes = [
    [
        "/cosmos.group.v1.MsgCreateGroup",
        $fmEYq.MsgCreateGroup
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupPolicy",
        $fmEYq.MsgCreateGroupPolicy
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupWithPolicy",
        $fmEYq.MsgCreateGroupWithPolicy
    ],
    [
        "/cosmos.group.v1.MsgExec",
        $fmEYq.MsgExec
    ],
    [
        "/cosmos.group.v1.MsgLeaveGroup",
        $fmEYq.MsgLeaveGroup
    ],
    [
        "/cosmos.group.v1.MsgSubmitProposal",
        $fmEYq.MsgSubmitProposal
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupAdmin",
        $fmEYq.MsgUpdateGroupAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMembers",
        $fmEYq.MsgUpdateGroupMembers
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMetadata",
        $fmEYq.MsgUpdateGroupMetadata
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyAdmin",
        $fmEYq.MsgUpdateGroupPolicyAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy",
        $fmEYq.MsgUpdateGroupPolicyDecisionPolicy
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyMetadata",
        $fmEYq.MsgUpdateGroupPolicyMetadata
    ],
    [
        "/cosmos.group.v1.MsgVote",
        $fmEYq.MsgVote
    ],
    [
        "/cosmos.group.v1.MsgWithdrawProposal",
        $fmEYq.MsgWithdrawProposal
    ]
]; // There are no EncodeObject implementations for the new v1 message types because
 // those things don't scale (https://github.com/cosmos/cosmjs/issues/1440). We need to
 // address this more fundamentally. Users can use
 // const msg = {
 //   typeUrl: "/cosmos.group.v1.MsgCreateGroup",
 //   value: MsgCreateGroup.fromPartial({ ... })
 // }
 // in their app.


Object.defineProperty($0aaecf7be71ff9a4$exports, "groupTypes", {
    enumerable: true,
    get: function get() {
        return $447ffd79ff4af260$exports.groupTypes;
    }
});
var $40ea2bea7f8abc85$exports = {};

var $aVMuR = parcelRequire("aVMuR");
"use strict";
var $40ea2bea7f8abc85$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($40ea2bea7f8abc85$exports, "__esModule", {
    value: true
});
$40ea2bea7f8abc85$exports.createIbcAminoConverters = $40ea2bea7f8abc85$exports.isAminoMsgTransfer = void 0;
var $8822fe0a75ad6109$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $8822fe0a75ad6109$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8822fe0a75ad6109$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8822fe0a75ad6109$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8822fe0a75ad6109$var$__createBinding(result, mod, k);
    }
    $8822fe0a75ad6109$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8822fe0a75ad6109$exports, "__esModule", {
    value: true
});
$8822fe0a75ad6109$exports.MsgClientImpl = $8822fe0a75ad6109$exports.MsgTransferResponse = $8822fe0a75ad6109$exports.MsgTransfer = $8822fe0a75ad6109$exports.protobufPackage = void 0;

var $a483577fa3a761ce$exports = {};
"use strict";
var $a483577fa3a761ce$var$__createBinding = $a483577fa3a761ce$exports && $a483577fa3a761ce$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a483577fa3a761ce$var$__setModuleDefault = $a483577fa3a761ce$exports && $a483577fa3a761ce$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a483577fa3a761ce$var$__importStar = $a483577fa3a761ce$exports && $a483577fa3a761ce$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a483577fa3a761ce$var$__createBinding(result, mod, k);
    }
    $a483577fa3a761ce$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a483577fa3a761ce$exports, "__esModule", {
    value: true
});
$a483577fa3a761ce$exports.Params = $a483577fa3a761ce$exports.Height = $a483577fa3a761ce$exports.UpgradeProposal = $a483577fa3a761ce$exports.ClientUpdateProposal = $a483577fa3a761ce$exports.ClientConsensusStates = $a483577fa3a761ce$exports.ConsensusStateWithHeight = $a483577fa3a761ce$exports.IdentifiedClientState = $a483577fa3a761ce$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");
var $65841957fdd47c18$exports = {};
"use strict";
var $65841957fdd47c18$var$__createBinding = $65841957fdd47c18$exports && $65841957fdd47c18$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $65841957fdd47c18$var$__setModuleDefault = $65841957fdd47c18$exports && $65841957fdd47c18$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $65841957fdd47c18$var$__importStar = $65841957fdd47c18$exports && $65841957fdd47c18$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $65841957fdd47c18$var$__createBinding(result, mod, k);
    }
    $65841957fdd47c18$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($65841957fdd47c18$exports, "__esModule", {
    value: true
});
$65841957fdd47c18$exports.ModuleVersion = $65841957fdd47c18$exports.CancelSoftwareUpgradeProposal = $65841957fdd47c18$exports.SoftwareUpgradeProposal = $65841957fdd47c18$exports.Plan = $65841957fdd47c18$exports.protobufPackage = void 0;

var $ib0XJ = parcelRequire("ib0XJ");

var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $65841957fdd47c18$var$_m0 = $65841957fdd47c18$var$__importStar((parcelRequire("hjb8Q")));
$65841957fdd47c18$exports.protobufPackage = "cosmos.upgrade.v1beta1";
function $65841957fdd47c18$var$createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: $7iZIe.Long.ZERO,
        info: "",
        upgradedClientState: undefined
    };
}
$65841957fdd47c18$exports.Plan = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $65841957fdd47c18$var$_m0.Writer.create();
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $ib0XJ.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $DM7bi.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $65841957fdd47c18$var$_m0.Reader ? input : new $65841957fdd47c18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $65841957fdd47c18$var$createBasePlan();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            name: (0, $7iZIe.isSet)(object.name) ? String(object.name) : "",
            time: (0, $7iZIe.isSet)(object.time) ? (0, $7iZIe.fromJsonTimestamp)(object.time) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            info: (0, $7iZIe.isSet)(object.info) ? String(object.info) : "",
            upgradedClientState: (0, $7iZIe.isSet)(object.upgradedClientState) ? $DM7bi.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = (0, $7iZIe.fromTimestamp)(message.time).toISOString());
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $DM7bi.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $65841957fdd47c18$var$createBasePlan();
        var _object_name;
        message.name = (_object_name = object.name) !== null && _object_name !== void 0 ? _object_name : "";
        message.time = object.time !== undefined && object.time !== null ? $ib0XJ.Timestamp.fromPartial(object.time) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_info;
        message.info = (_object_info = object.info) !== null && _object_info !== void 0 ? _object_info : "";
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $DM7bi.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $65841957fdd47c18$var$createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined
    };
}
$65841957fdd47c18$exports.SoftwareUpgradeProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $65841957fdd47c18$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $65841957fdd47c18$exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $65841957fdd47c18$var$_m0.Reader ? input : new $65841957fdd47c18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $65841957fdd47c18$var$createBaseSoftwareUpgradeProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $65841957fdd47c18$exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $7iZIe.isSet)(object.plan) ? $65841957fdd47c18$exports.Plan.fromJSON(object.plan) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $65841957fdd47c18$exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $65841957fdd47c18$var$createBaseSoftwareUpgradeProposal();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        message.plan = object.plan !== undefined && object.plan !== null ? $65841957fdd47c18$exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    }
};
function $65841957fdd47c18$var$createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: ""
    };
}
$65841957fdd47c18$exports.CancelSoftwareUpgradeProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $65841957fdd47c18$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $65841957fdd47c18$var$_m0.Reader ? input : new $65841957fdd47c18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $65841957fdd47c18$var$createBaseCancelSoftwareUpgradeProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial: function(object) {
        var message = $65841957fdd47c18$var$createBaseCancelSoftwareUpgradeProposal();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        return message;
    }
};
function $65841957fdd47c18$var$createBaseModuleVersion() {
    return {
        name: "",
        version: $7iZIe.Long.UZERO
    };
}
$65841957fdd47c18$exports.ModuleVersion = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $65841957fdd47c18$var$_m0.Writer.create();
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (!message.version.isZero()) writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $65841957fdd47c18$var$_m0.Reader ? input : new $65841957fdd47c18$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $65841957fdd47c18$var$createBaseModuleVersion();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            name: (0, $7iZIe.isSet)(object.name) ? String(object.name) : "",
            version: (0, $7iZIe.isSet)(object.version) ? $7iZIe.Long.fromValue(object.version) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $65841957fdd47c18$var$createBaseModuleVersion();
        var _object_name;
        message.name = (_object_name = object.name) !== null && _object_name !== void 0 ? _object_name : "";
        message.version = object.version !== undefined && object.version !== null ? $7iZIe.Long.fromValue(object.version) : $7iZIe.Long.UZERO;
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $a483577fa3a761ce$var$_m0 = $a483577fa3a761ce$var$__importStar((parcelRequire("hjb8Q")));
$a483577fa3a761ce$exports.protobufPackage = "ibc.core.client.v1";
function $a483577fa3a761ce$var$createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined
    };
}
$a483577fa3a761ce$exports.IdentifiedClientState = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $DM7bi.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseIdentifiedClientState();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $7iZIe.isSet)(object.clientState) ? $DM7bi.Any.fromJSON(object.clientState) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $DM7bi.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a483577fa3a761ce$var$createBaseIdentifiedClientState();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $DM7bi.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
function $a483577fa3a761ce$var$createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined
    };
}
$a483577fa3a761ce$exports.ConsensusStateWithHeight = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $DM7bi.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseConsensusStateWithHeight();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined,
            consensusState: (0, $7iZIe.isSet)(object.consensusState) ? $DM7bi.Any.fromJSON(object.consensusState) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $DM7bi.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a483577fa3a761ce$var$createBaseConsensusStateWithHeight();
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $DM7bi.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
function $a483577fa3a761ce$var$createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: []
    };
}
$a483577fa3a761ce$exports.ClientConsensusStates = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.consensusStates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a483577fa3a761ce$exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseClientConsensusStates();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push($a483577fa3a761ce$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStates) ? object.consensusStates.map(function(e) {
                return $a483577fa3a761ce$exports.ConsensusStateWithHeight.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map(function(e) {
            return e ? $a483577fa3a761ce$exports.ConsensusStateWithHeight.toJSON(e) : undefined;
        });
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_consensusStates;
        var message = $a483577fa3a761ce$var$createBaseClientConsensusStates();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.consensusStates = ((_object_consensusStates = object.consensusStates) === null || _object_consensusStates === void 0 ? void 0 : _object_consensusStates.map(function(e) {
            return $a483577fa3a761ce$exports.ConsensusStateWithHeight.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a483577fa3a761ce$var$createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: ""
    };
}
$a483577fa3a761ce$exports.ClientUpdateProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseClientUpdateProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : "",
            subjectClientId: (0, $7iZIe.isSet)(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: (0, $7iZIe.isSet)(object.substituteClientId) ? String(object.substituteClientId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a483577fa3a761ce$var$createBaseClientUpdateProposal();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        var _object_subjectClientId;
        message.subjectClientId = (_object_subjectClientId = object.subjectClientId) !== null && _object_subjectClientId !== void 0 ? _object_subjectClientId : "";
        var _object_substituteClientId;
        message.substituteClientId = (_object_substituteClientId = object.substituteClientId) !== null && _object_substituteClientId !== void 0 ? _object_substituteClientId : "";
        return message;
    }
};
function $a483577fa3a761ce$var$createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined
    };
}
$a483577fa3a761ce$exports.UpgradeProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $65841957fdd47c18$exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $DM7bi.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseUpgradeProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $65841957fdd47c18$exports.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            title: (0, $7iZIe.isSet)(object.title) ? String(object.title) : "",
            description: (0, $7iZIe.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $7iZIe.isSet)(object.plan) ? $65841957fdd47c18$exports.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: (0, $7iZIe.isSet)(object.upgradedClientState) ? $DM7bi.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $65841957fdd47c18$exports.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $DM7bi.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a483577fa3a761ce$var$createBaseUpgradeProposal();
        var _object_title;
        message.title = (_object_title = object.title) !== null && _object_title !== void 0 ? _object_title : "";
        var _object_description;
        message.description = (_object_description = object.description) !== null && _object_description !== void 0 ? _object_description : "";
        message.plan = object.plan !== undefined && object.plan !== null ? $65841957fdd47c18$exports.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $DM7bi.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $a483577fa3a761ce$var$createBaseHeight() {
    return {
        revisionNumber: $7iZIe.Long.UZERO,
        revisionHeight: $7iZIe.Long.UZERO
    };
}
$a483577fa3a761ce$exports.Height = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        if (!message.revisionNumber.isZero()) writer.uint32(8).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseHeight();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            revisionNumber: (0, $7iZIe.isSet)(object.revisionNumber) ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO,
            revisionHeight: (0, $7iZIe.isSet)(object.revisionHeight) ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $7iZIe.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $a483577fa3a761ce$var$createBaseHeight();
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $a483577fa3a761ce$var$createBaseParams() {
    return {
        allowedClients: []
    };
}
$a483577fa3a761ce$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a483577fa3a761ce$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.allowedClients[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a483577fa3a761ce$var$_m0.Reader ? input : new $a483577fa3a761ce$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a483577fa3a761ce$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            allowedClients: Array.isArray(object === null || object === void 0 ? void 0 : object.allowedClients) ? object.allowedClients.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map(function(e) {
            return e;
        });
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_allowedClients;
        var message = $a483577fa3a761ce$var$createBaseParams();
        message.allowedClients = ((_object_allowedClients = object.allowedClients) === null || _object_allowedClients === void 0 ? void 0 : _object_allowedClients.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $8822fe0a75ad6109$var$_m0 = $8822fe0a75ad6109$var$__importStar((parcelRequire("hjb8Q")));
$8822fe0a75ad6109$exports.protobufPackage = "ibc.applications.transfer.v1";
function $8822fe0a75ad6109$var$createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: $7iZIe.Long.UZERO,
        memo: ""
    };
}
$8822fe0a75ad6109$exports.MsgTransfer = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8822fe0a75ad6109$var$_m0.Writer.create();
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(56).uint64(message.timeoutTimestamp);
        if (message.memo !== "") writer.uint32(66).string(message.memo);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8822fe0a75ad6109$var$_m0.Reader ? input : new $8822fe0a75ad6109$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8822fe0a75ad6109$var$createBaseMsgTransfer();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sourcePort: (0, $7iZIe.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $7iZIe.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: (0, $7iZIe.isSet)(object.token) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.token) : undefined,
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            receiver: (0, $7iZIe.isSet)(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: (0, $7iZIe.isSet)(object.timeoutHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $7iZIe.isSet)(object.timeoutTimestamp) ? $7iZIe.Long.fromValue(object.timeoutTimestamp) : $7iZIe.Long.UZERO,
            memo: (0, $7iZIe.isSet)(object.memo) ? String(object.memo) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $5bc8eb379b028930$exports.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $7iZIe.Long.UZERO).toString());
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8822fe0a75ad6109$var$createBaseMsgTransfer();
        var _object_sourcePort;
        message.sourcePort = (_object_sourcePort = object.sourcePort) !== null && _object_sourcePort !== void 0 ? _object_sourcePort : "";
        var _object_sourceChannel;
        message.sourceChannel = (_object_sourceChannel = object.sourceChannel) !== null && _object_sourceChannel !== void 0 ? _object_sourceChannel : "";
        message.token = object.token !== undefined && object.token !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.token) : undefined;
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_receiver;
        message.receiver = (_object_receiver = object.receiver) !== null && _object_receiver !== void 0 ? _object_receiver : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $7iZIe.Long.fromValue(object.timeoutTimestamp) : $7iZIe.Long.UZERO;
        var _object_memo;
        message.memo = (_object_memo = object.memo) !== null && _object_memo !== void 0 ? _object_memo : "";
        return message;
    }
};
function $8822fe0a75ad6109$var$createBaseMsgTransferResponse() {
    return {
        sequence: $7iZIe.Long.UZERO
    };
}
$8822fe0a75ad6109$exports.MsgTransferResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8822fe0a75ad6109$var$_m0.Writer.create();
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8822fe0a75ad6109$var$_m0.Reader ? input : new $8822fe0a75ad6109$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8822fe0a75ad6109$var$createBaseMsgTransferResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8822fe0a75ad6109$var$createBaseMsgTransferResponse();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
var $8822fe0a75ad6109$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "Transfer",
            value: function Transfer(request) {
                var data = $8822fe0a75ad6109$exports.MsgTransfer.encode(request).finish();
                var promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
                return promise.then(function(data) {
                    return $8822fe0a75ad6109$exports.MsgTransferResponse.decode(new $8822fe0a75ad6109$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$8822fe0a75ad6109$exports.MsgClientImpl = $8822fe0a75ad6109$var$MsgClientImpl;



var $40ea2bea7f8abc85$var$long_1 = $40ea2bea7f8abc85$var$__importDefault((parcelRequire("l6G6L")));
function $40ea2bea7f8abc85$var$isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
$40ea2bea7f8abc85$exports.isAminoMsgTransfer = $40ea2bea7f8abc85$var$isAminoMsgTransfer;
function $40ea2bea7f8abc85$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($40ea2bea7f8abc85$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error("Got unsupported type '".concat(typeof input === "undefined" ? "undefined" : (0, $aVMuR._)(input), "'"));
}
function $40ea2bea7f8abc85$var$createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: function(param) {
                var sourcePort = param.sourcePort, sourceChannel = param.sourceChannel, token = param.token, sender = param.sender, receiver = param.receiver, timeoutHeight = param.timeoutHeight, timeoutTimestamp = param.timeoutTimestamp, memo = param.memo;
                var _omitDefault, _omitDefault1, _omitDefault2, _omitDefault3;
                return {
                    source_port: sourcePort,
                    source_channel: sourceChannel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeout_height: timeoutHeight ? {
                        revision_height: (_omitDefault = $40ea2bea7f8abc85$var$omitDefault(timeoutHeight.revisionHeight)) === null || _omitDefault === void 0 ? void 0 : _omitDefault.toString(),
                        revision_number: (_omitDefault1 = $40ea2bea7f8abc85$var$omitDefault(timeoutHeight.revisionNumber)) === null || _omitDefault1 === void 0 ? void 0 : _omitDefault1.toString()
                    } : {},
                    timeout_timestamp: (_omitDefault2 = $40ea2bea7f8abc85$var$omitDefault(timeoutTimestamp)) === null || _omitDefault2 === void 0 ? void 0 : _omitDefault2.toString(),
                    memo: (_omitDefault3 = $40ea2bea7f8abc85$var$omitDefault(memo)) === null || _omitDefault3 === void 0 ? void 0 : _omitDefault3.toString()
                };
            },
            fromAmino: function(param) {
                var source_port = param.source_port, source_channel = param.source_channel, token = param.token, sender = param.sender, receiver = param.receiver, timeout_height = param.timeout_height, timeout_timestamp = param.timeout_timestamp, memo = param.memo;
                return $8822fe0a75ad6109$exports.MsgTransfer.fromPartial({
                    sourcePort: source_port,
                    sourceChannel: source_channel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeoutHeight: timeout_height ? {
                        revisionHeight: $40ea2bea7f8abc85$var$long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: $40ea2bea7f8abc85$var$long_1.default.fromString(timeout_height.revision_number || "0", true)
                    } : undefined,
                    timeoutTimestamp: $40ea2bea7f8abc85$var$long_1.default.fromString(timeout_timestamp || "0", true),
                    memo: memo !== null && memo !== void 0 ? memo : ""
                });
            }
        }
    };
}
$40ea2bea7f8abc85$exports.createIbcAminoConverters = $40ea2bea7f8abc85$var$createIbcAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function get() {
        return $40ea2bea7f8abc85$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function get() {
        return $40ea2bea7f8abc85$exports.isAminoMsgTransfer;
    }
});
var $d49dfd7aa13fe848$exports = {};
"use strict";
Object.defineProperty($d49dfd7aa13fe848$exports, "__esModule", {
    value: true
});
$d49dfd7aa13fe848$exports.isMsgTransferEncodeObject = $d49dfd7aa13fe848$exports.ibcTypes = void 0;

var $60aebf6a622c8056$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $60aebf6a622c8056$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60aebf6a622c8056$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $60aebf6a622c8056$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $60aebf6a622c8056$var$__createBinding(result, mod, k);
    }
    $60aebf6a622c8056$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($60aebf6a622c8056$exports, "__esModule", {
    value: true
});
$60aebf6a622c8056$exports.MsgClientImpl = $60aebf6a622c8056$exports.MsgAcknowledgementResponse = $60aebf6a622c8056$exports.MsgAcknowledgement = $60aebf6a622c8056$exports.MsgTimeoutOnCloseResponse = $60aebf6a622c8056$exports.MsgTimeoutOnClose = $60aebf6a622c8056$exports.MsgTimeoutResponse = $60aebf6a622c8056$exports.MsgTimeout = $60aebf6a622c8056$exports.MsgRecvPacketResponse = $60aebf6a622c8056$exports.MsgRecvPacket = $60aebf6a622c8056$exports.MsgChannelCloseConfirmResponse = $60aebf6a622c8056$exports.MsgChannelCloseConfirm = $60aebf6a622c8056$exports.MsgChannelCloseInitResponse = $60aebf6a622c8056$exports.MsgChannelCloseInit = $60aebf6a622c8056$exports.MsgChannelOpenConfirmResponse = $60aebf6a622c8056$exports.MsgChannelOpenConfirm = $60aebf6a622c8056$exports.MsgChannelOpenAckResponse = $60aebf6a622c8056$exports.MsgChannelOpenAck = $60aebf6a622c8056$exports.MsgChannelOpenTryResponse = $60aebf6a622c8056$exports.MsgChannelOpenTry = $60aebf6a622c8056$exports.MsgChannelOpenInitResponse = $60aebf6a622c8056$exports.MsgChannelOpenInit = $60aebf6a622c8056$exports.responseResultTypeToJSON = $60aebf6a622c8056$exports.responseResultTypeFromJSON = $60aebf6a622c8056$exports.ResponseResultType = $60aebf6a622c8056$exports.protobufPackage = void 0;
var $988a66f9b5875dc5$exports = {};
"use strict";
var $988a66f9b5875dc5$var$__createBinding = $988a66f9b5875dc5$exports && $988a66f9b5875dc5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $988a66f9b5875dc5$var$__setModuleDefault = $988a66f9b5875dc5$exports && $988a66f9b5875dc5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $988a66f9b5875dc5$var$__importStar = $988a66f9b5875dc5$exports && $988a66f9b5875dc5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $988a66f9b5875dc5$var$__createBinding(result, mod, k);
    }
    $988a66f9b5875dc5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($988a66f9b5875dc5$exports, "__esModule", {
    value: true
});
$988a66f9b5875dc5$exports.Acknowledgement = $988a66f9b5875dc5$exports.PacketId = $988a66f9b5875dc5$exports.PacketState = $988a66f9b5875dc5$exports.Packet = $988a66f9b5875dc5$exports.Counterparty = $988a66f9b5875dc5$exports.IdentifiedChannel = $988a66f9b5875dc5$exports.Channel = $988a66f9b5875dc5$exports.orderToJSON = $988a66f9b5875dc5$exports.orderFromJSON = $988a66f9b5875dc5$exports.Order = $988a66f9b5875dc5$exports.stateToJSON = $988a66f9b5875dc5$exports.stateFromJSON = $988a66f9b5875dc5$exports.State = $988a66f9b5875dc5$exports.protobufPackage = void 0;


var $7iZIe = parcelRequire("7iZIe");

var $988a66f9b5875dc5$var$_m0 = $988a66f9b5875dc5$var$__importStar((parcelRequire("hjb8Q")));
$988a66f9b5875dc5$exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $988a66f9b5875dc5$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($988a66f9b5875dc5$var$State = $988a66f9b5875dc5$exports.State || ($988a66f9b5875dc5$exports.State = {}));
function $988a66f9b5875dc5$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $988a66f9b5875dc5$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $988a66f9b5875dc5$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $988a66f9b5875dc5$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $988a66f9b5875dc5$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $988a66f9b5875dc5$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $988a66f9b5875dc5$var$State.UNRECOGNIZED;
    }
}
$988a66f9b5875dc5$exports.stateFromJSON = $988a66f9b5875dc5$var$stateFromJSON;
function $988a66f9b5875dc5$var$stateToJSON(object) {
    switch(object){
        case $988a66f9b5875dc5$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $988a66f9b5875dc5$var$State.STATE_INIT:
            return "STATE_INIT";
        case $988a66f9b5875dc5$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $988a66f9b5875dc5$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $988a66f9b5875dc5$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        case $988a66f9b5875dc5$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$988a66f9b5875dc5$exports.stateToJSON = $988a66f9b5875dc5$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $988a66f9b5875dc5$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($988a66f9b5875dc5$var$Order = $988a66f9b5875dc5$exports.Order || ($988a66f9b5875dc5$exports.Order = {}));
function $988a66f9b5875dc5$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $988a66f9b5875dc5$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $988a66f9b5875dc5$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $988a66f9b5875dc5$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $988a66f9b5875dc5$var$Order.UNRECOGNIZED;
    }
}
$988a66f9b5875dc5$exports.orderFromJSON = $988a66f9b5875dc5$var$orderFromJSON;
function $988a66f9b5875dc5$var$orderToJSON(object) {
    switch(object){
        case $988a66f9b5875dc5$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $988a66f9b5875dc5$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $988a66f9b5875dc5$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        case $988a66f9b5875dc5$var$Order.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$988a66f9b5875dc5$exports.orderToJSON = $988a66f9b5875dc5$var$orderToJSON;
function $988a66f9b5875dc5$var$createBaseChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: ""
    };
}
$988a66f9b5875dc5$exports.Channel = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $988a66f9b5875dc5$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.connectionHops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(34).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBaseChannel();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $988a66f9b5875dc5$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            state: (0, $7iZIe.isSet)(object.state) ? $988a66f9b5875dc5$var$stateFromJSON(object.state) : 0,
            ordering: (0, $7iZIe.isSet)(object.ordering) ? $988a66f9b5875dc5$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $7iZIe.isSet)(object.counterparty) ? $988a66f9b5875dc5$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionHops) ? object.connectionHops.map(function(e) {
                return String(e);
            }) : [],
            version: (0, $7iZIe.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.state !== undefined && (obj.state = $988a66f9b5875dc5$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $988a66f9b5875dc5$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $988a66f9b5875dc5$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map(function(e) {
            return e;
        });
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial: function(object) {
        var _object_connectionHops;
        var message = $988a66f9b5875dc5$var$createBaseChannel();
        var _object_state;
        message.state = (_object_state = object.state) !== null && _object_state !== void 0 ? _object_state : 0;
        var _object_ordering;
        message.ordering = (_object_ordering = object.ordering) !== null && _object_ordering !== void 0 ? _object_ordering : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $988a66f9b5875dc5$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = ((_object_connectionHops = object.connectionHops) === null || _object_connectionHops === void 0 ? void 0 : _object_connectionHops.map(function(e) {
            return e;
        })) || [];
        var _object_version;
        message.version = (_object_version = object.version) !== null && _object_version !== void 0 ? _object_version : "";
        return message;
    }
};
function $988a66f9b5875dc5$var$createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: ""
    };
}
$988a66f9b5875dc5$exports.IdentifiedChannel = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $988a66f9b5875dc5$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.connectionHops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(34).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBaseIdentifiedChannel();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $988a66f9b5875dc5$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            state: (0, $7iZIe.isSet)(object.state) ? $988a66f9b5875dc5$var$stateFromJSON(object.state) : 0,
            ordering: (0, $7iZIe.isSet)(object.ordering) ? $988a66f9b5875dc5$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $7iZIe.isSet)(object.counterparty) ? $988a66f9b5875dc5$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionHops) ? object.connectionHops.map(function(e) {
                return String(e);
            }) : [],
            version: (0, $7iZIe.isSet)(object.version) ? String(object.version) : "",
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.state !== undefined && (obj.state = $988a66f9b5875dc5$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $988a66f9b5875dc5$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $988a66f9b5875dc5$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map(function(e) {
            return e;
        });
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial: function(object) {
        var _object_connectionHops;
        var message = $988a66f9b5875dc5$var$createBaseIdentifiedChannel();
        var _object_state;
        message.state = (_object_state = object.state) !== null && _object_state !== void 0 ? _object_state : 0;
        var _object_ordering;
        message.ordering = (_object_ordering = object.ordering) !== null && _object_ordering !== void 0 ? _object_ordering : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $988a66f9b5875dc5$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = ((_object_connectionHops = object.connectionHops) === null || _object_connectionHops === void 0 ? void 0 : _object_connectionHops.map(function(e) {
            return e;
        })) || [];
        var _object_version;
        message.version = (_object_version = object.version) !== null && _object_version !== void 0 ? _object_version : "";
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        return message;
    }
};
function $988a66f9b5875dc5$var$createBaseCounterparty() {
    return {
        portId: "",
        channelId: ""
    };
}
$988a66f9b5875dc5$exports.Counterparty = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBaseCounterparty();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $988a66f9b5875dc5$var$createBaseCounterparty();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        return message;
    }
};
function $988a66f9b5875dc5$var$createBasePacket() {
    return {
        sequence: $7iZIe.Long.UZERO,
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: $7iZIe.Long.UZERO
    };
}
$988a66f9b5875dc5$exports.Packet = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBasePacket();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO,
            sourcePort: (0, $7iZIe.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $7iZIe.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: (0, $7iZIe.isSet)(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: (0, $7iZIe.isSet)(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            timeoutHeight: (0, $7iZIe.isSet)(object.timeoutHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $7iZIe.isSet)(object.timeoutTimestamp) ? $7iZIe.Long.fromValue(object.timeoutTimestamp) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $988a66f9b5875dc5$var$createBasePacket();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        var _object_sourcePort;
        message.sourcePort = (_object_sourcePort = object.sourcePort) !== null && _object_sourcePort !== void 0 ? _object_sourcePort : "";
        var _object_sourceChannel;
        message.sourceChannel = (_object_sourceChannel = object.sourceChannel) !== null && _object_sourceChannel !== void 0 ? _object_sourceChannel : "";
        var _object_destinationPort;
        message.destinationPort = (_object_destinationPort = object.destinationPort) !== null && _object_destinationPort !== void 0 ? _object_destinationPort : "";
        var _object_destinationChannel;
        message.destinationChannel = (_object_destinationChannel = object.destinationChannel) !== null && _object_destinationChannel !== void 0 ? _object_destinationChannel : "";
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $7iZIe.Long.fromValue(object.timeoutTimestamp) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $988a66f9b5875dc5$var$createBasePacketState() {
    return {
        portId: "",
        channelId: "",
        sequence: $7iZIe.Long.UZERO,
        data: new Uint8Array()
    };
}
$988a66f9b5875dc5$exports.PacketState = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBasePacketState();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO,
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $988a66f9b5875dc5$var$createBasePacketState();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $988a66f9b5875dc5$var$createBasePacketId() {
    return {
        portId: "",
        channelId: "",
        sequence: $7iZIe.Long.UZERO
    };
}
$988a66f9b5875dc5$exports.PacketId = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBasePacketId();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $988a66f9b5875dc5$var$createBasePacketId();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $988a66f9b5875dc5$var$createBaseAcknowledgement() {
    return {
        result: undefined,
        error: undefined
    };
}
$988a66f9b5875dc5$exports.Acknowledgement = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $988a66f9b5875dc5$var$_m0.Writer.create();
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $988a66f9b5875dc5$var$_m0.Reader ? input : new $988a66f9b5875dc5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $988a66f9b5875dc5$var$createBaseAcknowledgement();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? (0, $7iZIe.bytesFromBase64)(object.result) : undefined,
            error: (0, $7iZIe.isSet)(object.error) ? String(object.error) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? (0, $7iZIe.base64FromBytes)(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial: function(object) {
        var message = $988a66f9b5875dc5$var$createBaseAcknowledgement();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : undefined;
        var _object_error;
        message.error = (_object_error = object.error) !== null && _object_error !== void 0 ? _object_error : undefined;
        return message;
    }
};




var $7iZIe = parcelRequire("7iZIe");

var $60aebf6a622c8056$var$_m0 = $60aebf6a622c8056$var$__importStar((parcelRequire("hjb8Q")));
$60aebf6a622c8056$exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */ var $60aebf6a622c8056$var$ResponseResultType;
(function(ResponseResultType) {
    /** RESPONSE_RESULT_TYPE_UNSPECIFIED - Default zero value enumeration */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    /** RESPONSE_RESULT_TYPE_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
    /** RESPONSE_RESULT_TYPE_SUCCESS - The message was executed successfully */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($60aebf6a622c8056$var$ResponseResultType = $60aebf6a622c8056$exports.ResponseResultType || ($60aebf6a622c8056$exports.ResponseResultType = {}));
function $60aebf6a622c8056$var$responseResultTypeFromJSON(object) {
    switch(object){
        case 0:
        case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
            return $60aebf6a622c8056$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_TYPE_NOOP":
            return $60aebf6a622c8056$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
        case 2:
        case "RESPONSE_RESULT_TYPE_SUCCESS":
            return $60aebf6a622c8056$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $60aebf6a622c8056$var$ResponseResultType.UNRECOGNIZED;
    }
}
$60aebf6a622c8056$exports.responseResultTypeFromJSON = $60aebf6a622c8056$var$responseResultTypeFromJSON;
function $60aebf6a622c8056$var$responseResultTypeToJSON(object) {
    switch(object){
        case $60aebf6a622c8056$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
            return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
        case $60aebf6a622c8056$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
            return "RESPONSE_RESULT_TYPE_NOOP";
        case $60aebf6a622c8056$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
            return "RESPONSE_RESULT_TYPE_SUCCESS";
        case $60aebf6a622c8056$var$ResponseResultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$60aebf6a622c8056$exports.responseResultTypeToJSON = $60aebf6a622c8056$var$responseResultTypeToJSON;
function $60aebf6a622c8056$var$createBaseMsgChannelOpenInit() {
    return {
        portId: "",
        channel: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelOpenInit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channel !== undefined) $988a66f9b5875dc5$exports.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenInit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = $988a66f9b5875dc5$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channel: (0, $7iZIe.isSet)(object.channel) ? $988a66f9b5875dc5$exports.Channel.fromJSON(object.channel) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined && (obj.channel = message.channel ? $988a66f9b5875dc5$exports.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenInit();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        message.channel = object.channel !== undefined && object.channel !== null ? $988a66f9b5875dc5$exports.Channel.fromPartial(object.channel) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenInitResponse() {
    return {
        channelId: "",
        version: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelOpenInitResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.channelId !== "") writer.uint32(10).string(message.channelId);
        if (message.version !== "") writer.uint32(18).string(message.version);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenInitResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channelId = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            version: (0, $7iZIe.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenInitResponse();
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        var _object_version;
        message.version = (_object_version = object.version) !== null && _object_version !== void 0 ? _object_version : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenTry() {
    return {
        portId: "",
        previousChannelId: "",
        channel: undefined,
        counterpartyVersion: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelOpenTry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.previousChannelId !== "") writer.uint32(18).string(message.previousChannelId);
        if (message.channel !== undefined) $988a66f9b5875dc5$exports.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofInit.length !== 0) writer.uint32(42).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenTry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = $988a66f9b5875dc5$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            previousChannelId: (0, $7iZIe.isSet)(object.previousChannelId) ? String(object.previousChannelId) : "",
            channel: (0, $7iZIe.isSet)(object.channel) ? $988a66f9b5875dc5$exports.Channel.fromJSON(object.channel) : undefined,
            counterpartyVersion: (0, $7iZIe.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofInit: (0, $7iZIe.isSet)(object.proofInit) ? (0, $7iZIe.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined && (obj.channel = message.channel ? $988a66f9b5875dc5$exports.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined && (obj.proofInit = (0, $7iZIe.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenTry();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_previousChannelId;
        message.previousChannelId = (_object_previousChannelId = object.previousChannelId) !== null && _object_previousChannelId !== void 0 ? _object_previousChannelId : "";
        message.channel = object.channel !== undefined && object.channel !== null ? $988a66f9b5875dc5$exports.Channel.fromPartial(object.channel) : undefined;
        var _object_counterpartyVersion;
        message.counterpartyVersion = (_object_counterpartyVersion = object.counterpartyVersion) !== null && _object_counterpartyVersion !== void 0 ? _object_counterpartyVersion : "";
        var _object_proofInit;
        message.proofInit = (_object_proofInit = object.proofInit) !== null && _object_proofInit !== void 0 ? _object_proofInit : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenTryResponse() {
    return {
        version: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelOpenTryResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.version !== "") writer.uint32(10).string(message.version);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenTryResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            version: (0, $7iZIe.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenTryResponse();
        var _object_version;
        message.version = (_object_version = object.version) !== null && _object_version !== void 0 ? _object_version : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenAck() {
    return {
        portId: "",
        channelId: "",
        counterpartyChannelId: "",
        counterpartyVersion: "",
        proofTry: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelOpenAck = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.counterpartyChannelId !== "") writer.uint32(26).string(message.counterpartyChannelId);
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofTry.length !== 0) writer.uint32(42).bytes(message.proofTry);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenAck();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            counterpartyChannelId: (0, $7iZIe.isSet)(object.counterpartyChannelId) ? String(object.counterpartyChannelId) : "",
            counterpartyVersion: (0, $7iZIe.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofTry: (0, $7iZIe.isSet)(object.proofTry) ? (0, $7iZIe.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined && (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined && (obj.proofTry = (0, $7iZIe.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenAck();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        var _object_counterpartyChannelId;
        message.counterpartyChannelId = (_object_counterpartyChannelId = object.counterpartyChannelId) !== null && _object_counterpartyChannelId !== void 0 ? _object_counterpartyChannelId : "";
        var _object_counterpartyVersion;
        message.counterpartyVersion = (_object_counterpartyVersion = object.counterpartyVersion) !== null && _object_counterpartyVersion !== void 0 ? _object_counterpartyVersion : "";
        var _object_proofTry;
        message.proofTry = (_object_proofTry = object.proofTry) !== null && _object_proofTry !== void 0 ? _object_proofTry : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenAckResponse() {
    return {};
}
$60aebf6a622c8056$exports.MsgChannelOpenAckResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenAckResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenAckResponse();
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenConfirm() {
    return {
        portId: "",
        channelId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelOpenConfirm = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofAck.length !== 0) writer.uint32(26).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenConfirm();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            proofAck: (0, $7iZIe.isSet)(object.proofAck) ? (0, $7iZIe.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined && (obj.proofAck = (0, $7iZIe.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenConfirm();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        var _object_proofAck;
        message.proofAck = (_object_proofAck = object.proofAck) !== null && _object_proofAck !== void 0 ? _object_proofAck : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelOpenConfirmResponse() {
    return {};
}
$60aebf6a622c8056$exports.MsgChannelOpenConfirmResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenConfirmResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelOpenConfirmResponse();
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelCloseInit() {
    return {
        portId: "",
        channelId: "",
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelCloseInit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseInit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseInit();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelCloseInitResponse() {
    return {};
}
$60aebf6a622c8056$exports.MsgChannelCloseInitResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseInitResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseInitResponse();
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelCloseConfirm() {
    return {
        portId: "",
        channelId: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgChannelCloseConfirm = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofInit.length !== 0) writer.uint32(26).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseConfirm();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            proofInit: (0, $7iZIe.isSet)(object.proofInit) ? (0, $7iZIe.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined && (obj.proofInit = (0, $7iZIe.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseConfirm();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        var _object_proofInit;
        message.proofInit = (_object_proofInit = object.proofInit) !== null && _object_proofInit !== void 0 ? _object_proofInit : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgChannelCloseConfirmResponse() {
    return {};
}
$60aebf6a622c8056$exports.MsgChannelCloseConfirmResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseConfirmResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $60aebf6a622c8056$var$createBaseMsgChannelCloseConfirmResponse();
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgRecvPacket() {
    return {
        packet: undefined,
        proofCommitment: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgRecvPacket = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.packet !== undefined) $988a66f9b5875dc5$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofCommitment.length !== 0) writer.uint32(18).bytes(message.proofCommitment);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgRecvPacket();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $988a66f9b5875dc5$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            packet: (0, $7iZIe.isSet)(object.packet) ? $988a66f9b5875dc5$exports.Packet.fromJSON(object.packet) : undefined,
            proofCommitment: (0, $7iZIe.isSet)(object.proofCommitment) ? (0, $7iZIe.bytesFromBase64)(object.proofCommitment) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $988a66f9b5875dc5$exports.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined && (obj.proofCommitment = (0, $7iZIe.base64FromBytes)(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgRecvPacket();
        message.packet = object.packet !== undefined && object.packet !== null ? $988a66f9b5875dc5$exports.Packet.fromPartial(object.packet) : undefined;
        var _object_proofCommitment;
        message.proofCommitment = (_object_proofCommitment = object.proofCommitment) !== null && _object_proofCommitment !== void 0 ? _object_proofCommitment : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgRecvPacketResponse() {
    return {
        result: 0
    };
}
$60aebf6a622c8056$exports.MsgRecvPacketResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgRecvPacketResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? $60aebf6a622c8056$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = $60aebf6a622c8056$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgRecvPacketResponse();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgTimeout() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $7iZIe.Long.UZERO,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgTimeout = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.packet !== undefined) $988a66f9b5875dc5$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(32).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgTimeout();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $988a66f9b5875dc5$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            packet: (0, $7iZIe.isSet)(object.packet) ? $988a66f9b5875dc5$exports.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $7iZIe.isSet)(object.proofUnreceived) ? (0, $7iZIe.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $7iZIe.isSet)(object.nextSequenceRecv) ? $7iZIe.Long.fromValue(object.nextSequenceRecv) : $7iZIe.Long.UZERO,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $988a66f9b5875dc5$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $7iZIe.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $7iZIe.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgTimeout();
        message.packet = object.packet !== undefined && object.packet !== null ? $988a66f9b5875dc5$exports.Packet.fromPartial(object.packet) : undefined;
        var _object_proofUnreceived;
        message.proofUnreceived = (_object_proofUnreceived = object.proofUnreceived) !== null && _object_proofUnreceived !== void 0 ? _object_proofUnreceived : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $7iZIe.Long.fromValue(object.nextSequenceRecv) : $7iZIe.Long.UZERO;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgTimeoutResponse() {
    return {
        result: 0
    };
}
$60aebf6a622c8056$exports.MsgTimeoutResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgTimeoutResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? $60aebf6a622c8056$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = $60aebf6a622c8056$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgTimeoutResponse();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgTimeoutOnClose() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofClose: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $7iZIe.Long.UZERO,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgTimeoutOnClose = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.packet !== undefined) $988a66f9b5875dc5$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofClose.length !== 0) writer.uint32(26).bytes(message.proofClose);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(40).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgTimeoutOnClose();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $988a66f9b5875dc5$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            packet: (0, $7iZIe.isSet)(object.packet) ? $988a66f9b5875dc5$exports.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $7iZIe.isSet)(object.proofUnreceived) ? (0, $7iZIe.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofClose: (0, $7iZIe.isSet)(object.proofClose) ? (0, $7iZIe.bytesFromBase64)(object.proofClose) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $7iZIe.isSet)(object.nextSequenceRecv) ? $7iZIe.Long.fromValue(object.nextSequenceRecv) : $7iZIe.Long.UZERO,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $988a66f9b5875dc5$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $7iZIe.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined && (obj.proofClose = (0, $7iZIe.base64FromBytes)(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $7iZIe.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgTimeoutOnClose();
        message.packet = object.packet !== undefined && object.packet !== null ? $988a66f9b5875dc5$exports.Packet.fromPartial(object.packet) : undefined;
        var _object_proofUnreceived;
        message.proofUnreceived = (_object_proofUnreceived = object.proofUnreceived) !== null && _object_proofUnreceived !== void 0 ? _object_proofUnreceived : new Uint8Array();
        var _object_proofClose;
        message.proofClose = (_object_proofClose = object.proofClose) !== null && _object_proofClose !== void 0 ? _object_proofClose : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $7iZIe.Long.fromValue(object.nextSequenceRecv) : $7iZIe.Long.UZERO;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgTimeoutOnCloseResponse() {
    return {
        result: 0
    };
}
$60aebf6a622c8056$exports.MsgTimeoutOnCloseResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgTimeoutOnCloseResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? $60aebf6a622c8056$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = $60aebf6a622c8056$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgTimeoutOnCloseResponse();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgAcknowledgement() {
    return {
        packet: undefined,
        acknowledgement: new Uint8Array(),
        proofAcked: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$60aebf6a622c8056$exports.MsgAcknowledgement = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.packet !== undefined) $988a66f9b5875dc5$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.acknowledgement.length !== 0) writer.uint32(18).bytes(message.acknowledgement);
        if (message.proofAcked.length !== 0) writer.uint32(26).bytes(message.proofAcked);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgAcknowledgement();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $988a66f9b5875dc5$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            packet: (0, $7iZIe.isSet)(object.packet) ? $988a66f9b5875dc5$exports.Packet.fromJSON(object.packet) : undefined,
            acknowledgement: (0, $7iZIe.isSet)(object.acknowledgement) ? (0, $7iZIe.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proofAcked: (0, $7iZIe.isSet)(object.proofAcked) ? (0, $7iZIe.bytesFromBase64)(object.proofAcked) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $988a66f9b5875dc5$exports.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $7iZIe.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined && (obj.proofAcked = (0, $7iZIe.base64FromBytes)(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgAcknowledgement();
        message.packet = object.packet !== undefined && object.packet !== null ? $988a66f9b5875dc5$exports.Packet.fromPartial(object.packet) : undefined;
        var _object_acknowledgement;
        message.acknowledgement = (_object_acknowledgement = object.acknowledgement) !== null && _object_acknowledgement !== void 0 ? _object_acknowledgement : new Uint8Array();
        var _object_proofAcked;
        message.proofAcked = (_object_proofAcked = object.proofAcked) !== null && _object_proofAcked !== void 0 ? _object_proofAcked : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $60aebf6a622c8056$var$createBaseMsgAcknowledgementResponse() {
    return {
        result: 0
    };
}
$60aebf6a622c8056$exports.MsgAcknowledgementResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $60aebf6a622c8056$var$_m0.Writer.create();
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $60aebf6a622c8056$var$_m0.Reader ? input : new $60aebf6a622c8056$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $60aebf6a622c8056$var$createBaseMsgAcknowledgementResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? $60aebf6a622c8056$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = $60aebf6a622c8056$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial: function(object) {
        var message = $60aebf6a622c8056$var$createBaseMsgAcknowledgementResponse();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        return message;
    }
};
var $60aebf6a622c8056$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "ChannelOpenInit",
            value: function ChannelOpenInit(request) {
                var data = $60aebf6a622c8056$exports.MsgChannelOpenInit.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgChannelOpenInitResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelOpenTry",
            value: function ChannelOpenTry(request) {
                var data = $60aebf6a622c8056$exports.MsgChannelOpenTry.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgChannelOpenTryResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelOpenAck",
            value: function ChannelOpenAck(request) {
                var data = $60aebf6a622c8056$exports.MsgChannelOpenAck.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgChannelOpenAckResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelOpenConfirm",
            value: function ChannelOpenConfirm(request) {
                var data = $60aebf6a622c8056$exports.MsgChannelOpenConfirm.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgChannelOpenConfirmResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelCloseInit",
            value: function ChannelCloseInit(request) {
                var data = $60aebf6a622c8056$exports.MsgChannelCloseInit.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgChannelCloseInitResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelCloseConfirm",
            value: function ChannelCloseConfirm(request) {
                var data = $60aebf6a622c8056$exports.MsgChannelCloseConfirm.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgChannelCloseConfirmResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "RecvPacket",
            value: function RecvPacket(request) {
                var data = $60aebf6a622c8056$exports.MsgRecvPacket.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgRecvPacketResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Timeout",
            value: function Timeout(request) {
                var data = $60aebf6a622c8056$exports.MsgTimeout.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgTimeoutResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TimeoutOnClose",
            value: function TimeoutOnClose(request) {
                var data = $60aebf6a622c8056$exports.MsgTimeoutOnClose.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgTimeoutOnCloseResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Acknowledgement",
            value: function Acknowledgement(request) {
                var data = $60aebf6a622c8056$exports.MsgAcknowledgement.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
                return promise.then(function(data) {
                    return $60aebf6a622c8056$exports.MsgAcknowledgementResponse.decode(new $60aebf6a622c8056$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$60aebf6a622c8056$exports.MsgClientImpl = $60aebf6a622c8056$var$MsgClientImpl;


var $3d734f3f7df8611c$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $3d734f3f7df8611c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3d734f3f7df8611c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3d734f3f7df8611c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3d734f3f7df8611c$var$__createBinding(result, mod, k);
    }
    $3d734f3f7df8611c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3d734f3f7df8611c$exports, "__esModule", {
    value: true
});
$3d734f3f7df8611c$exports.MsgClientImpl = $3d734f3f7df8611c$exports.MsgSubmitMisbehaviourResponse = $3d734f3f7df8611c$exports.MsgSubmitMisbehaviour = $3d734f3f7df8611c$exports.MsgUpgradeClientResponse = $3d734f3f7df8611c$exports.MsgUpgradeClient = $3d734f3f7df8611c$exports.MsgUpdateClientResponse = $3d734f3f7df8611c$exports.MsgUpdateClient = $3d734f3f7df8611c$exports.MsgCreateClientResponse = $3d734f3f7df8611c$exports.MsgCreateClient = $3d734f3f7df8611c$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $3d734f3f7df8611c$var$_m0 = $3d734f3f7df8611c$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$3d734f3f7df8611c$exports.protobufPackage = "ibc.core.client.v1";
function $3d734f3f7df8611c$var$createBaseMsgCreateClient() {
    return {
        clientState: undefined,
        consensusState: undefined,
        signer: ""
    };
}
$3d734f3f7df8611c$exports.MsgCreateClient = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        if (message.clientState !== undefined) $DM7bi.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $DM7bi.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgCreateClient();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientState: (0, $7iZIe.isSet)(object.clientState) ? $DM7bi.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $7iZIe.isSet)(object.consensusState) ? $DM7bi.Any.fromJSON(object.consensusState) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $DM7bi.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $DM7bi.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3d734f3f7df8611c$var$createBaseMsgCreateClient();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $DM7bi.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $DM7bi.Any.fromPartial(object.consensusState) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgCreateClientResponse() {
    return {};
}
$3d734f3f7df8611c$exports.MsgCreateClientResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgCreateClientResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $3d734f3f7df8611c$var$createBaseMsgCreateClientResponse();
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgUpdateClient() {
    return {
        clientId: "",
        clientMessage: undefined,
        signer: ""
    };
}
$3d734f3f7df8611c$exports.MsgUpdateClient = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientMessage !== undefined) $DM7bi.Any.encode(message.clientMessage, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgUpdateClient();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientMessage = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            clientMessage: (0, $7iZIe.isSet)(object.clientMessage) ? $DM7bi.Any.fromJSON(object.clientMessage) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientMessage !== undefined && (obj.clientMessage = message.clientMessage ? $DM7bi.Any.toJSON(message.clientMessage) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3d734f3f7df8611c$var$createBaseMsgUpdateClient();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.clientMessage = object.clientMessage !== undefined && object.clientMessage !== null ? $DM7bi.Any.fromPartial(object.clientMessage) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgUpdateClientResponse() {
    return {};
}
$3d734f3f7df8611c$exports.MsgUpdateClientResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgUpdateClientResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $3d734f3f7df8611c$var$createBaseMsgUpdateClientResponse();
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgUpgradeClient() {
    return {
        clientId: "",
        clientState: undefined,
        consensusState: undefined,
        proofUpgradeClient: new Uint8Array(),
        proofUpgradeConsensusState: new Uint8Array(),
        signer: ""
    };
}
$3d734f3f7df8611c$exports.MsgUpgradeClient = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $DM7bi.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        if (message.consensusState !== undefined) $DM7bi.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        if (message.proofUpgradeClient.length !== 0) writer.uint32(34).bytes(message.proofUpgradeClient);
        if (message.proofUpgradeConsensusState.length !== 0) writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgUpgradeClient();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $7iZIe.isSet)(object.clientState) ? $DM7bi.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $7iZIe.isSet)(object.consensusState) ? $DM7bi.Any.fromJSON(object.consensusState) : undefined,
            proofUpgradeClient: (0, $7iZIe.isSet)(object.proofUpgradeClient) ? (0, $7iZIe.bytesFromBase64)(object.proofUpgradeClient) : new Uint8Array(),
            proofUpgradeConsensusState: (0, $7iZIe.isSet)(object.proofUpgradeConsensusState) ? (0, $7iZIe.bytesFromBase64)(object.proofUpgradeConsensusState) : new Uint8Array(),
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $DM7bi.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $DM7bi.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined && (obj.proofUpgradeClient = (0, $7iZIe.base64FromBytes)(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined && (obj.proofUpgradeConsensusState = (0, $7iZIe.base64FromBytes)(message.proofUpgradeConsensusState !== undefined ? message.proofUpgradeConsensusState : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3d734f3f7df8611c$var$createBaseMsgUpgradeClient();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $DM7bi.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $DM7bi.Any.fromPartial(object.consensusState) : undefined;
        var _object_proofUpgradeClient;
        message.proofUpgradeClient = (_object_proofUpgradeClient = object.proofUpgradeClient) !== null && _object_proofUpgradeClient !== void 0 ? _object_proofUpgradeClient : new Uint8Array();
        var _object_proofUpgradeConsensusState;
        message.proofUpgradeConsensusState = (_object_proofUpgradeConsensusState = object.proofUpgradeConsensusState) !== null && _object_proofUpgradeConsensusState !== void 0 ? _object_proofUpgradeConsensusState : new Uint8Array();
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgUpgradeClientResponse() {
    return {};
}
$3d734f3f7df8611c$exports.MsgUpgradeClientResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgUpgradeClientResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $3d734f3f7df8611c$var$createBaseMsgUpgradeClientResponse();
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgSubmitMisbehaviour() {
    return {
        clientId: "",
        misbehaviour: undefined,
        signer: ""
    };
}
$3d734f3f7df8611c$exports.MsgSubmitMisbehaviour = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.misbehaviour !== undefined) $DM7bi.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgSubmitMisbehaviour();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            misbehaviour: (0, $7iZIe.isSet)(object.misbehaviour) ? $DM7bi.Any.fromJSON(object.misbehaviour) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined && (obj.misbehaviour = message.misbehaviour ? $DM7bi.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3d734f3f7df8611c$var$createBaseMsgSubmitMisbehaviour();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? $DM7bi.Any.fromPartial(object.misbehaviour) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $3d734f3f7df8611c$var$createBaseMsgSubmitMisbehaviourResponse() {
    return {};
}
$3d734f3f7df8611c$exports.MsgSubmitMisbehaviourResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3d734f3f7df8611c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3d734f3f7df8611c$var$_m0.Reader ? input : new $3d734f3f7df8611c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3d734f3f7df8611c$var$createBaseMsgSubmitMisbehaviourResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $3d734f3f7df8611c$var$createBaseMsgSubmitMisbehaviourResponse();
        return message;
    }
};
var $3d734f3f7df8611c$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "CreateClient",
            value: function CreateClient(request) {
                var data = $3d734f3f7df8611c$exports.MsgCreateClient.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
                return promise.then(function(data) {
                    return $3d734f3f7df8611c$exports.MsgCreateClientResponse.decode(new $3d734f3f7df8611c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateClient",
            value: function UpdateClient(request) {
                var data = $3d734f3f7df8611c$exports.MsgUpdateClient.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
                return promise.then(function(data) {
                    return $3d734f3f7df8611c$exports.MsgUpdateClientResponse.decode(new $3d734f3f7df8611c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpgradeClient",
            value: function UpgradeClient(request) {
                var data = $3d734f3f7df8611c$exports.MsgUpgradeClient.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
                return promise.then(function(data) {
                    return $3d734f3f7df8611c$exports.MsgUpgradeClientResponse.decode(new $3d734f3f7df8611c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SubmitMisbehaviour",
            value: function SubmitMisbehaviour(request) {
                var data = $3d734f3f7df8611c$exports.MsgSubmitMisbehaviour.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
                return promise.then(function(data) {
                    return $3d734f3f7df8611c$exports.MsgSubmitMisbehaviourResponse.decode(new $3d734f3f7df8611c$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$3d734f3f7df8611c$exports.MsgClientImpl = $3d734f3f7df8611c$var$MsgClientImpl;


var $23722554c2adc0db$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $23722554c2adc0db$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $23722554c2adc0db$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $23722554c2adc0db$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $23722554c2adc0db$var$__createBinding(result, mod, k);
    }
    $23722554c2adc0db$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($23722554c2adc0db$exports, "__esModule", {
    value: true
});
$23722554c2adc0db$exports.MsgClientImpl = $23722554c2adc0db$exports.MsgConnectionOpenConfirmResponse = $23722554c2adc0db$exports.MsgConnectionOpenConfirm = $23722554c2adc0db$exports.MsgConnectionOpenAckResponse = $23722554c2adc0db$exports.MsgConnectionOpenAck = $23722554c2adc0db$exports.MsgConnectionOpenTryResponse = $23722554c2adc0db$exports.MsgConnectionOpenTry = $23722554c2adc0db$exports.MsgConnectionOpenInitResponse = $23722554c2adc0db$exports.MsgConnectionOpenInit = $23722554c2adc0db$exports.protobufPackage = void 0;
var $f87da13d55c18e89$exports = {};
"use strict";
var $f87da13d55c18e89$var$__createBinding = $f87da13d55c18e89$exports && $f87da13d55c18e89$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f87da13d55c18e89$var$__setModuleDefault = $f87da13d55c18e89$exports && $f87da13d55c18e89$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f87da13d55c18e89$var$__importStar = $f87da13d55c18e89$exports && $f87da13d55c18e89$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f87da13d55c18e89$var$__createBinding(result, mod, k);
    }
    $f87da13d55c18e89$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f87da13d55c18e89$exports, "__esModule", {
    value: true
});
$f87da13d55c18e89$exports.Params = $f87da13d55c18e89$exports.Version = $f87da13d55c18e89$exports.ConnectionPaths = $f87da13d55c18e89$exports.ClientPaths = $f87da13d55c18e89$exports.Counterparty = $f87da13d55c18e89$exports.IdentifiedConnection = $f87da13d55c18e89$exports.ConnectionEnd = $f87da13d55c18e89$exports.stateToJSON = $f87da13d55c18e89$exports.stateFromJSON = $f87da13d55c18e89$exports.State = $f87da13d55c18e89$exports.protobufPackage = void 0;
var $cb476feab4497b1e$exports = {};
"use strict";
var $cb476feab4497b1e$var$__createBinding = $cb476feab4497b1e$exports && $cb476feab4497b1e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb476feab4497b1e$var$__setModuleDefault = $cb476feab4497b1e$exports && $cb476feab4497b1e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cb476feab4497b1e$var$__importStar = $cb476feab4497b1e$exports && $cb476feab4497b1e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cb476feab4497b1e$var$__createBinding(result, mod, k);
    }
    $cb476feab4497b1e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cb476feab4497b1e$exports, "__esModule", {
    value: true
});
$cb476feab4497b1e$exports.MerkleProof = $cb476feab4497b1e$exports.MerklePath = $cb476feab4497b1e$exports.MerklePrefix = $cb476feab4497b1e$exports.MerkleRoot = $cb476feab4497b1e$exports.protobufPackage = void 0;
var $3008c3192cf1fae6$exports = {};
"use strict";
var $3008c3192cf1fae6$var$__createBinding = $3008c3192cf1fae6$exports && $3008c3192cf1fae6$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3008c3192cf1fae6$var$__setModuleDefault = $3008c3192cf1fae6$exports && $3008c3192cf1fae6$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3008c3192cf1fae6$var$__importStar = $3008c3192cf1fae6$exports && $3008c3192cf1fae6$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3008c3192cf1fae6$var$__createBinding(result, mod, k);
    }
    $3008c3192cf1fae6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3008c3192cf1fae6$exports, "__esModule", {
    value: true
});
$3008c3192cf1fae6$exports.CompressedNonExistenceProof = $3008c3192cf1fae6$exports.CompressedExistenceProof = $3008c3192cf1fae6$exports.CompressedBatchEntry = $3008c3192cf1fae6$exports.CompressedBatchProof = $3008c3192cf1fae6$exports.BatchEntry = $3008c3192cf1fae6$exports.BatchProof = $3008c3192cf1fae6$exports.InnerSpec = $3008c3192cf1fae6$exports.ProofSpec = $3008c3192cf1fae6$exports.InnerOp = $3008c3192cf1fae6$exports.LeafOp = $3008c3192cf1fae6$exports.CommitmentProof = $3008c3192cf1fae6$exports.NonExistenceProof = $3008c3192cf1fae6$exports.ExistenceProof = $3008c3192cf1fae6$exports.lengthOpToJSON = $3008c3192cf1fae6$exports.lengthOpFromJSON = $3008c3192cf1fae6$exports.LengthOp = $3008c3192cf1fae6$exports.hashOpToJSON = $3008c3192cf1fae6$exports.hashOpFromJSON = $3008c3192cf1fae6$exports.HashOp = $3008c3192cf1fae6$exports.protobufPackage = void 0;

/* eslint-disable */ var $3008c3192cf1fae6$var$_m0 = $3008c3192cf1fae6$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$3008c3192cf1fae6$exports.protobufPackage = "cosmos.ics23.v1";
var $3008c3192cf1fae6$var$HashOp;
(function(HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */ HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */ HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["SHA512_256"] = 6] = "SHA512_256";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($3008c3192cf1fae6$var$HashOp = $3008c3192cf1fae6$exports.HashOp || ($3008c3192cf1fae6$exports.HashOp = {}));
function $3008c3192cf1fae6$var$hashOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_HASH":
            return $3008c3192cf1fae6$var$HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return $3008c3192cf1fae6$var$HashOp.SHA256;
        case 2:
        case "SHA512":
            return $3008c3192cf1fae6$var$HashOp.SHA512;
        case 3:
        case "KECCAK":
            return $3008c3192cf1fae6$var$HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return $3008c3192cf1fae6$var$HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return $3008c3192cf1fae6$var$HashOp.BITCOIN;
        case 6:
        case "SHA512_256":
            return $3008c3192cf1fae6$var$HashOp.SHA512_256;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $3008c3192cf1fae6$var$HashOp.UNRECOGNIZED;
    }
}
$3008c3192cf1fae6$exports.hashOpFromJSON = $3008c3192cf1fae6$var$hashOpFromJSON;
function $3008c3192cf1fae6$var$hashOpToJSON(object) {
    switch(object){
        case $3008c3192cf1fae6$var$HashOp.NO_HASH:
            return "NO_HASH";
        case $3008c3192cf1fae6$var$HashOp.SHA256:
            return "SHA256";
        case $3008c3192cf1fae6$var$HashOp.SHA512:
            return "SHA512";
        case $3008c3192cf1fae6$var$HashOp.KECCAK:
            return "KECCAK";
        case $3008c3192cf1fae6$var$HashOp.RIPEMD160:
            return "RIPEMD160";
        case $3008c3192cf1fae6$var$HashOp.BITCOIN:
            return "BITCOIN";
        case $3008c3192cf1fae6$var$HashOp.SHA512_256:
            return "SHA512_256";
        case $3008c3192cf1fae6$var$HashOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$3008c3192cf1fae6$exports.hashOpToJSON = $3008c3192cf1fae6$var$hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */ var $3008c3192cf1fae6$var$LengthOp;
(function(LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */ LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */ LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */ LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */ LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */ LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($3008c3192cf1fae6$var$LengthOp = $3008c3192cf1fae6$exports.LengthOp || ($3008c3192cf1fae6$exports.LengthOp = {}));
function $3008c3192cf1fae6$var$lengthOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_PREFIX":
            return $3008c3192cf1fae6$var$LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return $3008c3192cf1fae6$var$LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return $3008c3192cf1fae6$var$LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return $3008c3192cf1fae6$var$LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return $3008c3192cf1fae6$var$LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return $3008c3192cf1fae6$var$LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return $3008c3192cf1fae6$var$LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return $3008c3192cf1fae6$var$LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return $3008c3192cf1fae6$var$LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $3008c3192cf1fae6$var$LengthOp.UNRECOGNIZED;
    }
}
$3008c3192cf1fae6$exports.lengthOpFromJSON = $3008c3192cf1fae6$var$lengthOpFromJSON;
function $3008c3192cf1fae6$var$lengthOpToJSON(object) {
    switch(object){
        case $3008c3192cf1fae6$var$LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case $3008c3192cf1fae6$var$LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case $3008c3192cf1fae6$var$LengthOp.VAR_RLP:
            return "VAR_RLP";
        case $3008c3192cf1fae6$var$LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case $3008c3192cf1fae6$var$LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case $3008c3192cf1fae6$var$LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case $3008c3192cf1fae6$var$LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case $3008c3192cf1fae6$var$LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case $3008c3192cf1fae6$var$LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        case $3008c3192cf1fae6$var$LengthOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$3008c3192cf1fae6$exports.lengthOpToJSON = $3008c3192cf1fae6$var$lengthOpToJSON;
function $3008c3192cf1fae6$var$createBaseExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
$3008c3192cf1fae6$exports.ExistenceProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $3008c3192cf1fae6$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $3008c3192cf1fae6$exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseExistenceProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $3008c3192cf1fae6$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push($3008c3192cf1fae6$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $7iZIe.isSet)(object.value) ? (0, $7iZIe.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $7iZIe.isSet)(object.leaf) ? $3008c3192cf1fae6$exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(function(e) {
                return $3008c3192cf1fae6$exports.InnerOp.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $7iZIe.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $3008c3192cf1fae6$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map(function(e) {
            return e ? $3008c3192cf1fae6$exports.InnerOp.toJSON(e) : undefined;
        });
        else obj.path = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_path;
        var message = $3008c3192cf1fae6$var$createBaseExistenceProof();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $3008c3192cf1fae6$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = ((_object_path = object.path) === null || _object_path === void 0 ? void 0 : _object_path.map(function(e) {
            return $3008c3192cf1fae6$exports.InnerOp.fromPartial(e);
        })) || [];
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
$3008c3192cf1fae6$exports.NonExistenceProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $3008c3192cf1fae6$exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $3008c3192cf1fae6$exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseNonExistenceProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $3008c3192cf1fae6$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $3008c3192cf1fae6$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $7iZIe.isSet)(object.left) ? $3008c3192cf1fae6$exports.ExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $7iZIe.isSet)(object.right) ? $3008c3192cf1fae6$exports.ExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $3008c3192cf1fae6$exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $3008c3192cf1fae6$exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseNonExistenceProof();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $3008c3192cf1fae6$exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $3008c3192cf1fae6$exports.ExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseCommitmentProof() {
    return {
        exist: undefined,
        nonexist: undefined,
        batch: undefined,
        compressed: undefined
    };
}
$3008c3192cf1fae6$exports.CommitmentProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.exist !== undefined) $3008c3192cf1fae6$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $3008c3192cf1fae6$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        if (message.batch !== undefined) $3008c3192cf1fae6$exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        if (message.compressed !== undefined) $3008c3192cf1fae6$exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseCommitmentProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $3008c3192cf1fae6$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $3008c3192cf1fae6$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = $3008c3192cf1fae6$exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = $3008c3192cf1fae6$exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            exist: (0, $7iZIe.isSet)(object.exist) ? $3008c3192cf1fae6$exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $7iZIe.isSet)(object.nonexist) ? $3008c3192cf1fae6$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
            batch: (0, $7iZIe.isSet)(object.batch) ? $3008c3192cf1fae6$exports.BatchProof.fromJSON(object.batch) : undefined,
            compressed: (0, $7iZIe.isSet)(object.compressed) ? $3008c3192cf1fae6$exports.CompressedBatchProof.fromJSON(object.compressed) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $3008c3192cf1fae6$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $3008c3192cf1fae6$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? $3008c3192cf1fae6$exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined && (obj.compressed = message.compressed ? $3008c3192cf1fae6$exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseCommitmentProof();
        message.exist = object.exist !== undefined && object.exist !== null ? $3008c3192cf1fae6$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $3008c3192cf1fae6$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        message.batch = object.batch !== undefined && object.batch !== null ? $3008c3192cf1fae6$exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed = object.compressed !== undefined && object.compressed !== null ? $3008c3192cf1fae6$exports.CompressedBatchProof.fromPartial(object.compressed) : undefined;
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseLeafOp() {
    return {
        hash: 0,
        prehashKey: 0,
        prehashValue: 0,
        length: 0,
        prefix: new Uint8Array()
    };
}
$3008c3192cf1fae6$exports.LeafOp = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prehashKey !== 0) writer.uint32(16).int32(message.prehashKey);
        if (message.prehashValue !== 0) writer.uint32(24).int32(message.prehashValue);
        if (message.length !== 0) writer.uint32(32).int32(message.length);
        if (message.prefix.length !== 0) writer.uint32(42).bytes(message.prefix);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseLeafOp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? $3008c3192cf1fae6$var$hashOpFromJSON(object.hash) : 0,
            prehashKey: (0, $7iZIe.isSet)(object.prehashKey) ? $3008c3192cf1fae6$var$hashOpFromJSON(object.prehashKey) : 0,
            prehashValue: (0, $7iZIe.isSet)(object.prehashValue) ? $3008c3192cf1fae6$var$hashOpFromJSON(object.prehashValue) : 0,
            length: (0, $7iZIe.isSet)(object.length) ? $3008c3192cf1fae6$var$lengthOpFromJSON(object.length) : 0,
            prefix: (0, $7iZIe.isSet)(object.prefix) ? (0, $7iZIe.bytesFromBase64)(object.prefix) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = $3008c3192cf1fae6$var$hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = $3008c3192cf1fae6$var$hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = $3008c3192cf1fae6$var$hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = $3008c3192cf1fae6$var$lengthOpToJSON(message.length));
        message.prefix !== undefined && (obj.prefix = (0, $7iZIe.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseLeafOp();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : 0;
        var _object_prehashKey;
        message.prehashKey = (_object_prehashKey = object.prehashKey) !== null && _object_prehashKey !== void 0 ? _object_prehashKey : 0;
        var _object_prehashValue;
        message.prehashValue = (_object_prehashValue = object.prehashValue) !== null && _object_prehashValue !== void 0 ? _object_prehashValue : 0;
        var _object_length;
        message.length = (_object_length = object.length) !== null && _object_length !== void 0 ? _object_length : 0;
        var _object_prefix;
        message.prefix = (_object_prefix = object.prefix) !== null && _object_prefix !== void 0 ? _object_prefix : new Uint8Array();
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseInnerOp() {
    return {
        hash: 0,
        prefix: new Uint8Array(),
        suffix: new Uint8Array()
    };
}
$3008c3192cf1fae6$exports.InnerOp = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prefix.length !== 0) writer.uint32(18).bytes(message.prefix);
        if (message.suffix.length !== 0) writer.uint32(26).bytes(message.suffix);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseInnerOp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? $3008c3192cf1fae6$var$hashOpFromJSON(object.hash) : 0,
            prefix: (0, $7iZIe.isSet)(object.prefix) ? (0, $7iZIe.bytesFromBase64)(object.prefix) : new Uint8Array(),
            suffix: (0, $7iZIe.isSet)(object.suffix) ? (0, $7iZIe.bytesFromBase64)(object.suffix) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = $3008c3192cf1fae6$var$hashOpToJSON(message.hash));
        message.prefix !== undefined && (obj.prefix = (0, $7iZIe.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined && (obj.suffix = (0, $7iZIe.base64FromBytes)(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseInnerOp();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : 0;
        var _object_prefix;
        message.prefix = (_object_prefix = object.prefix) !== null && _object_prefix !== void 0 ? _object_prefix : new Uint8Array();
        var _object_suffix;
        message.suffix = (_object_suffix = object.suffix) !== null && _object_suffix !== void 0 ? _object_suffix : new Uint8Array();
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseProofSpec() {
    return {
        leafSpec: undefined,
        innerSpec: undefined,
        maxDepth: 0,
        minDepth: 0
    };
}
$3008c3192cf1fae6$exports.ProofSpec = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.leafSpec !== undefined) $3008c3192cf1fae6$exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        if (message.innerSpec !== undefined) $3008c3192cf1fae6$exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        if (message.maxDepth !== 0) writer.uint32(24).int32(message.maxDepth);
        if (message.minDepth !== 0) writer.uint32(32).int32(message.minDepth);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseProofSpec();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.leafSpec = $3008c3192cf1fae6$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = $3008c3192cf1fae6$exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            leafSpec: (0, $7iZIe.isSet)(object.leafSpec) ? $3008c3192cf1fae6$exports.LeafOp.fromJSON(object.leafSpec) : undefined,
            innerSpec: (0, $7iZIe.isSet)(object.innerSpec) ? $3008c3192cf1fae6$exports.InnerSpec.fromJSON(object.innerSpec) : undefined,
            maxDepth: (0, $7iZIe.isSet)(object.maxDepth) ? Number(object.maxDepth) : 0,
            minDepth: (0, $7iZIe.isSet)(object.minDepth) ? Number(object.minDepth) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.leafSpec !== undefined && (obj.leafSpec = message.leafSpec ? $3008c3192cf1fae6$exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined && (obj.innerSpec = message.innerSpec ? $3008c3192cf1fae6$exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = Math.round(message.maxDepth));
        message.minDepth !== undefined && (obj.minDepth = Math.round(message.minDepth));
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseProofSpec();
        message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? $3008c3192cf1fae6$exports.LeafOp.fromPartial(object.leafSpec) : undefined;
        message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? $3008c3192cf1fae6$exports.InnerSpec.fromPartial(object.innerSpec) : undefined;
        var _object_maxDepth;
        message.maxDepth = (_object_maxDepth = object.maxDepth) !== null && _object_maxDepth !== void 0 ? _object_maxDepth : 0;
        var _object_minDepth;
        message.minDepth = (_object_minDepth = object.minDepth) !== null && _object_minDepth !== void 0 ? _object_minDepth : 0;
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseInnerSpec() {
    return {
        childOrder: [],
        childSize: 0,
        minPrefixLength: 0,
        maxPrefixLength: 0,
        emptyChild: new Uint8Array(),
        hash: 0
    };
}
$3008c3192cf1fae6$exports.InnerSpec = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        writer.uint32(10).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.childOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.int32(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        if (message.childSize !== 0) writer.uint32(16).int32(message.childSize);
        if (message.minPrefixLength !== 0) writer.uint32(24).int32(message.minPrefixLength);
        if (message.maxPrefixLength !== 0) writer.uint32(32).int32(message.maxPrefixLength);
        if (message.emptyChild.length !== 0) writer.uint32(42).bytes(message.emptyChild);
        if (message.hash !== 0) writer.uint32(48).int32(message.hash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseInnerSpec();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.childOrder.push(reader.int32());
                    } else message.childOrder.push(reader.int32());
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            childOrder: Array.isArray(object === null || object === void 0 ? void 0 : object.childOrder) ? object.childOrder.map(function(e) {
                return Number(e);
            }) : [],
            childSize: (0, $7iZIe.isSet)(object.childSize) ? Number(object.childSize) : 0,
            minPrefixLength: (0, $7iZIe.isSet)(object.minPrefixLength) ? Number(object.minPrefixLength) : 0,
            maxPrefixLength: (0, $7iZIe.isSet)(object.maxPrefixLength) ? Number(object.maxPrefixLength) : 0,
            emptyChild: (0, $7iZIe.isSet)(object.emptyChild) ? (0, $7iZIe.bytesFromBase64)(object.emptyChild) : new Uint8Array(),
            hash: (0, $7iZIe.isSet)(object.hash) ? $3008c3192cf1fae6$var$hashOpFromJSON(object.hash) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.childOrder) obj.childOrder = message.childOrder.map(function(e) {
            return Math.round(e);
        });
        else obj.childOrder = [];
        message.childSize !== undefined && (obj.childSize = Math.round(message.childSize));
        message.minPrefixLength !== undefined && (obj.minPrefixLength = Math.round(message.minPrefixLength));
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = Math.round(message.maxPrefixLength));
        message.emptyChild !== undefined && (obj.emptyChild = (0, $7iZIe.base64FromBytes)(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = $3008c3192cf1fae6$var$hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial: function(object) {
        var _object_childOrder;
        var message = $3008c3192cf1fae6$var$createBaseInnerSpec();
        message.childOrder = ((_object_childOrder = object.childOrder) === null || _object_childOrder === void 0 ? void 0 : _object_childOrder.map(function(e) {
            return e;
        })) || [];
        var _object_childSize;
        message.childSize = (_object_childSize = object.childSize) !== null && _object_childSize !== void 0 ? _object_childSize : 0;
        var _object_minPrefixLength;
        message.minPrefixLength = (_object_minPrefixLength = object.minPrefixLength) !== null && _object_minPrefixLength !== void 0 ? _object_minPrefixLength : 0;
        var _object_maxPrefixLength;
        message.maxPrefixLength = (_object_maxPrefixLength = object.maxPrefixLength) !== null && _object_maxPrefixLength !== void 0 ? _object_maxPrefixLength : 0;
        var _object_emptyChild;
        message.emptyChild = (_object_emptyChild = object.emptyChild) !== null && _object_emptyChild !== void 0 ? _object_emptyChild : new Uint8Array();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : 0;
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseBatchProof() {
    return {
        entries: []
    };
}
$3008c3192cf1fae6$exports.BatchProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $3008c3192cf1fae6$exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseBatchProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($3008c3192cf1fae6$exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(function(e) {
                return $3008c3192cf1fae6$exports.BatchEntry.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.entries) obj.entries = message.entries.map(function(e) {
            return e ? $3008c3192cf1fae6$exports.BatchEntry.toJSON(e) : undefined;
        });
        else obj.entries = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_entries;
        var message = $3008c3192cf1fae6$var$createBaseBatchProof();
        message.entries = ((_object_entries = object.entries) === null || _object_entries === void 0 ? void 0 : _object_entries.map(function(e) {
            return $3008c3192cf1fae6$exports.BatchEntry.fromPartial(e);
        })) || [];
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
$3008c3192cf1fae6$exports.BatchEntry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.exist !== undefined) $3008c3192cf1fae6$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $3008c3192cf1fae6$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseBatchEntry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $3008c3192cf1fae6$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $3008c3192cf1fae6$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            exist: (0, $7iZIe.isSet)(object.exist) ? $3008c3192cf1fae6$exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $7iZIe.isSet)(object.nonexist) ? $3008c3192cf1fae6$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $3008c3192cf1fae6$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $3008c3192cf1fae6$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? $3008c3192cf1fae6$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $3008c3192cf1fae6$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseCompressedBatchProof() {
    return {
        entries: [],
        lookupInners: []
    };
}
$3008c3192cf1fae6$exports.CompressedBatchProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $3008c3192cf1fae6$exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.lookupInners[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $3008c3192cf1fae6$exports.InnerOp.encode(v1, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseCompressedBatchProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($3008c3192cf1fae6$exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push($3008c3192cf1fae6$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(function(e) {
                return $3008c3192cf1fae6$exports.CompressedBatchEntry.fromJSON(e);
            }) : [],
            lookupInners: Array.isArray(object === null || object === void 0 ? void 0 : object.lookupInners) ? object.lookupInners.map(function(e) {
                return $3008c3192cf1fae6$exports.InnerOp.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.entries) obj.entries = message.entries.map(function(e) {
            return e ? $3008c3192cf1fae6$exports.CompressedBatchEntry.toJSON(e) : undefined;
        });
        else obj.entries = [];
        if (message.lookupInners) obj.lookupInners = message.lookupInners.map(function(e) {
            return e ? $3008c3192cf1fae6$exports.InnerOp.toJSON(e) : undefined;
        });
        else obj.lookupInners = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_entries, _object_lookupInners;
        var message = $3008c3192cf1fae6$var$createBaseCompressedBatchProof();
        message.entries = ((_object_entries = object.entries) === null || _object_entries === void 0 ? void 0 : _object_entries.map(function(e) {
            return $3008c3192cf1fae6$exports.CompressedBatchEntry.fromPartial(e);
        })) || [];
        message.lookupInners = ((_object_lookupInners = object.lookupInners) === null || _object_lookupInners === void 0 ? void 0 : _object_lookupInners.map(function(e) {
            return $3008c3192cf1fae6$exports.InnerOp.fromPartial(e);
        })) || [];
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseCompressedBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
$3008c3192cf1fae6$exports.CompressedBatchEntry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.exist !== undefined) $3008c3192cf1fae6$exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $3008c3192cf1fae6$exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseCompressedBatchEntry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $3008c3192cf1fae6$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $3008c3192cf1fae6$exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            exist: (0, $7iZIe.isSet)(object.exist) ? $3008c3192cf1fae6$exports.CompressedExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $7iZIe.isSet)(object.nonexist) ? $3008c3192cf1fae6$exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $3008c3192cf1fae6$exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $3008c3192cf1fae6$exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseCompressedBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? $3008c3192cf1fae6$exports.CompressedExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $3008c3192cf1fae6$exports.CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseCompressedExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
$3008c3192cf1fae6$exports.CompressedExistenceProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $3008c3192cf1fae6$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.int32(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseCompressedExistenceProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $3008c3192cf1fae6$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.path.push(reader.int32());
                    } else message.path.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $7iZIe.isSet)(object.value) ? (0, $7iZIe.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $7iZIe.isSet)(object.leaf) ? $3008c3192cf1fae6$exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object === null || object === void 0 ? void 0 : object.path) ? object.path.map(function(e) {
                return Number(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $7iZIe.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $3008c3192cf1fae6$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map(function(e) {
            return Math.round(e);
        });
        else obj.path = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_path;
        var message = $3008c3192cf1fae6$var$createBaseCompressedExistenceProof();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $3008c3192cf1fae6$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = ((_object_path = object.path) === null || _object_path === void 0 ? void 0 : _object_path.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $3008c3192cf1fae6$var$createBaseCompressedNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
$3008c3192cf1fae6$exports.CompressedNonExistenceProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3008c3192cf1fae6$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $3008c3192cf1fae6$exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $3008c3192cf1fae6$exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3008c3192cf1fae6$var$_m0.Reader ? input : new $3008c3192cf1fae6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3008c3192cf1fae6$var$createBaseCompressedNonExistenceProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $3008c3192cf1fae6$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $3008c3192cf1fae6$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $7iZIe.isSet)(object.left) ? $3008c3192cf1fae6$exports.CompressedExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $7iZIe.isSet)(object.right) ? $3008c3192cf1fae6$exports.CompressedExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $3008c3192cf1fae6$exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $3008c3192cf1fae6$exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3008c3192cf1fae6$var$createBaseCompressedNonExistenceProof();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $3008c3192cf1fae6$exports.CompressedExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $3008c3192cf1fae6$exports.CompressedExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};



var $cb476feab4497b1e$var$_m0 = $cb476feab4497b1e$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$cb476feab4497b1e$exports.protobufPackage = "ibc.core.commitment.v1";
function $cb476feab4497b1e$var$createBaseMerkleRoot() {
    return {
        hash: new Uint8Array()
    };
}
$cb476feab4497b1e$exports.MerkleRoot = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cb476feab4497b1e$var$_m0.Writer.create();
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $cb476feab4497b1e$var$_m0.Reader ? input : new $cb476feab4497b1e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $cb476feab4497b1e$var$createBaseMerkleRoot();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? (0, $7iZIe.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = (0, $7iZIe.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $cb476feab4497b1e$var$createBaseMerkleRoot();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : new Uint8Array();
        return message;
    }
};
function $cb476feab4497b1e$var$createBaseMerklePrefix() {
    return {
        keyPrefix: new Uint8Array()
    };
}
$cb476feab4497b1e$exports.MerklePrefix = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cb476feab4497b1e$var$_m0.Writer.create();
        if (message.keyPrefix.length !== 0) writer.uint32(10).bytes(message.keyPrefix);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $cb476feab4497b1e$var$_m0.Reader ? input : new $cb476feab4497b1e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $cb476feab4497b1e$var$createBaseMerklePrefix();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            keyPrefix: (0, $7iZIe.isSet)(object.keyPrefix) ? (0, $7iZIe.bytesFromBase64)(object.keyPrefix) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.keyPrefix !== undefined && (obj.keyPrefix = (0, $7iZIe.base64FromBytes)(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $cb476feab4497b1e$var$createBaseMerklePrefix();
        var _object_keyPrefix;
        message.keyPrefix = (_object_keyPrefix = object.keyPrefix) !== null && _object_keyPrefix !== void 0 ? _object_keyPrefix : new Uint8Array();
        return message;
    }
};
function $cb476feab4497b1e$var$createBaseMerklePath() {
    return {
        keyPath: []
    };
}
$cb476feab4497b1e$exports.MerklePath = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cb476feab4497b1e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.keyPath[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $cb476feab4497b1e$var$_m0.Reader ? input : new $cb476feab4497b1e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $cb476feab4497b1e$var$createBaseMerklePath();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            keyPath: Array.isArray(object === null || object === void 0 ? void 0 : object.keyPath) ? object.keyPath.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.keyPath) obj.keyPath = message.keyPath.map(function(e) {
            return e;
        });
        else obj.keyPath = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_keyPath;
        var message = $cb476feab4497b1e$var$createBaseMerklePath();
        message.keyPath = ((_object_keyPath = object.keyPath) === null || _object_keyPath === void 0 ? void 0 : _object_keyPath.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $cb476feab4497b1e$var$createBaseMerkleProof() {
    return {
        proofs: []
    };
}
$cb476feab4497b1e$exports.MerkleProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cb476feab4497b1e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.proofs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $3008c3192cf1fae6$exports.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $cb476feab4497b1e$var$_m0.Reader ? input : new $cb476feab4497b1e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $cb476feab4497b1e$var$createBaseMerkleProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proofs.push($3008c3192cf1fae6$exports.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proofs: Array.isArray(object === null || object === void 0 ? void 0 : object.proofs) ? object.proofs.map(function(e) {
                return $3008c3192cf1fae6$exports.CommitmentProof.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.proofs) obj.proofs = message.proofs.map(function(e) {
            return e ? $3008c3192cf1fae6$exports.CommitmentProof.toJSON(e) : undefined;
        });
        else obj.proofs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_proofs;
        var message = $cb476feab4497b1e$var$createBaseMerkleProof();
        message.proofs = ((_object_proofs = object.proofs) === null || _object_proofs === void 0 ? void 0 : _object_proofs.map(function(e) {
            return $3008c3192cf1fae6$exports.CommitmentProof.fromPartial(e);
        })) || [];
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $f87da13d55c18e89$var$_m0 = $f87da13d55c18e89$var$__importStar((parcelRequire("hjb8Q")));
$f87da13d55c18e89$exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $f87da13d55c18e89$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($f87da13d55c18e89$var$State = $f87da13d55c18e89$exports.State || ($f87da13d55c18e89$exports.State = {}));
function $f87da13d55c18e89$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $f87da13d55c18e89$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $f87da13d55c18e89$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $f87da13d55c18e89$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $f87da13d55c18e89$var$State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $f87da13d55c18e89$var$State.UNRECOGNIZED;
    }
}
$f87da13d55c18e89$exports.stateFromJSON = $f87da13d55c18e89$var$stateFromJSON;
function $f87da13d55c18e89$var$stateToJSON(object) {
    switch(object){
        case $f87da13d55c18e89$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $f87da13d55c18e89$var$State.STATE_INIT:
            return "STATE_INIT";
        case $f87da13d55c18e89$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $f87da13d55c18e89$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $f87da13d55c18e89$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$f87da13d55c18e89$exports.stateToJSON = $f87da13d55c18e89$var$stateToJSON;
function $f87da13d55c18e89$var$createBaseConnectionEnd() {
    return {
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $7iZIe.Long.UZERO
    };
}
$f87da13d55c18e89$exports.ConnectionEnd = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.versions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $f87da13d55c18e89$exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.state !== 0) writer.uint32(24).int32(message.state);
        if (message.counterparty !== undefined) $f87da13d55c18e89$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseConnectionEnd();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push($f87da13d55c18e89$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = $f87da13d55c18e89$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object === null || object === void 0 ? void 0 : object.versions) ? object.versions.map(function(e) {
                return $f87da13d55c18e89$exports.Version.fromJSON(e);
            }) : [],
            state: (0, $7iZIe.isSet)(object.state) ? $f87da13d55c18e89$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $7iZIe.isSet)(object.counterparty) ? $f87da13d55c18e89$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $7iZIe.isSet)(object.delayPeriod) ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map(function(e) {
            return e ? $f87da13d55c18e89$exports.Version.toJSON(e) : undefined;
        });
        else obj.versions = [];
        message.state !== undefined && (obj.state = $f87da13d55c18e89$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $f87da13d55c18e89$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_versions;
        var message = $f87da13d55c18e89$var$createBaseConnectionEnd();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.versions = ((_object_versions = object.versions) === null || _object_versions === void 0 ? void 0 : _object_versions.map(function(e) {
            return $f87da13d55c18e89$exports.Version.fromPartial(e);
        })) || [];
        var _object_state;
        message.state = (_object_state = object.state) !== null && _object_state !== void 0 ? _object_state : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $f87da13d55c18e89$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $f87da13d55c18e89$var$createBaseIdentifiedConnection() {
    return {
        id: "",
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $7iZIe.Long.UZERO
    };
}
$f87da13d55c18e89$exports.IdentifiedConnection = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        if (message.id !== "") writer.uint32(10).string(message.id);
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.versions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $f87da13d55c18e89$exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.state !== 0) writer.uint32(32).int32(message.state);
        if (message.counterparty !== undefined) $f87da13d55c18e89$exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(48).uint64(message.delayPeriod);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseIdentifiedConnection();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push($f87da13d55c18e89$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = $f87da13d55c18e89$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            id: (0, $7iZIe.isSet)(object.id) ? String(object.id) : "",
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object === null || object === void 0 ? void 0 : object.versions) ? object.versions.map(function(e) {
                return $f87da13d55c18e89$exports.Version.fromJSON(e);
            }) : [],
            state: (0, $7iZIe.isSet)(object.state) ? $f87da13d55c18e89$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $7iZIe.isSet)(object.counterparty) ? $f87da13d55c18e89$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $7iZIe.isSet)(object.delayPeriod) ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map(function(e) {
            return e ? $f87da13d55c18e89$exports.Version.toJSON(e) : undefined;
        });
        else obj.versions = [];
        message.state !== undefined && (obj.state = $f87da13d55c18e89$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $f87da13d55c18e89$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_versions;
        var message = $f87da13d55c18e89$var$createBaseIdentifiedConnection();
        var _object_id;
        message.id = (_object_id = object.id) !== null && _object_id !== void 0 ? _object_id : "";
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.versions = ((_object_versions = object.versions) === null || _object_versions === void 0 ? void 0 : _object_versions.map(function(e) {
            return $f87da13d55c18e89$exports.Version.fromPartial(e);
        })) || [];
        var _object_state;
        message.state = (_object_state = object.state) !== null && _object_state !== void 0 ? _object_state : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $f87da13d55c18e89$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $f87da13d55c18e89$var$createBaseCounterparty() {
    return {
        clientId: "",
        connectionId: "",
        prefix: undefined
    };
}
$f87da13d55c18e89$exports.Counterparty = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.prefix !== undefined) $cb476feab4497b1e$exports.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseCounterparty();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = $cb476feab4497b1e$exports.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            connectionId: (0, $7iZIe.isSet)(object.connectionId) ? String(object.connectionId) : "",
            prefix: (0, $7iZIe.isSet)(object.prefix) ? $cb476feab4497b1e$exports.MerklePrefix.fromJSON(object.prefix) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined && (obj.prefix = message.prefix ? $cb476feab4497b1e$exports.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $f87da13d55c18e89$var$createBaseCounterparty();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        var _object_connectionId;
        message.connectionId = (_object_connectionId = object.connectionId) !== null && _object_connectionId !== void 0 ? _object_connectionId : "";
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $cb476feab4497b1e$exports.MerklePrefix.fromPartial(object.prefix) : undefined;
        return message;
    }
};
function $f87da13d55c18e89$var$createBaseClientPaths() {
    return {
        paths: []
    };
}
$f87da13d55c18e89$exports.ClientPaths = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseClientPaths();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            paths: Array.isArray(object === null || object === void 0 ? void 0 : object.paths) ? object.paths.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.paths) obj.paths = message.paths.map(function(e) {
            return e;
        });
        else obj.paths = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_paths;
        var message = $f87da13d55c18e89$var$createBaseClientPaths();
        message.paths = ((_object_paths = object.paths) === null || _object_paths === void 0 ? void 0 : _object_paths.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $f87da13d55c18e89$var$createBaseConnectionPaths() {
    return {
        clientId: "",
        paths: []
    };
}
$f87da13d55c18e89$exports.ConnectionPaths = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(18).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseConnectionPaths();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            paths: Array.isArray(object === null || object === void 0 ? void 0 : object.paths) ? object.paths.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) obj.paths = message.paths.map(function(e) {
            return e;
        });
        else obj.paths = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_paths;
        var message = $f87da13d55c18e89$var$createBaseConnectionPaths();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.paths = ((_object_paths = object.paths) === null || _object_paths === void 0 ? void 0 : _object_paths.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $f87da13d55c18e89$var$createBaseVersion() {
    return {
        identifier: "",
        features: []
    };
}
$f87da13d55c18e89$exports.Version = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        if (message.identifier !== "") writer.uint32(10).string(message.identifier);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(18).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseVersion();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            identifier: (0, $7iZIe.isSet)(object.identifier) ? String(object.identifier) : "",
            features: Array.isArray(object === null || object === void 0 ? void 0 : object.features) ? object.features.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) obj.features = message.features.map(function(e) {
            return e;
        });
        else obj.features = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_features;
        var message = $f87da13d55c18e89$var$createBaseVersion();
        var _object_identifier;
        message.identifier = (_object_identifier = object.identifier) !== null && _object_identifier !== void 0 ? _object_identifier : "";
        message.features = ((_object_features = object.features) === null || _object_features === void 0 ? void 0 : _object_features.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $f87da13d55c18e89$var$createBaseParams() {
    return {
        maxExpectedTimePerBlock: $7iZIe.Long.UZERO
    };
}
$f87da13d55c18e89$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f87da13d55c18e89$var$_m0.Writer.create();
        if (!message.maxExpectedTimePerBlock.isZero()) writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $f87da13d55c18e89$var$_m0.Reader ? input : new $f87da13d55c18e89$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $f87da13d55c18e89$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            maxExpectedTimePerBlock: (0, $7iZIe.isSet)(object.maxExpectedTimePerBlock) ? $7iZIe.Long.fromValue(object.maxExpectedTimePerBlock) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.maxExpectedTimePerBlock !== undefined && (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $f87da13d55c18e89$var$createBaseParams();
        message.maxExpectedTimePerBlock = object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null ? $7iZIe.Long.fromValue(object.maxExpectedTimePerBlock) : $7iZIe.Long.UZERO;
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");


var $7iZIe = parcelRequire("7iZIe");

var $23722554c2adc0db$var$_m0 = $23722554c2adc0db$var$__importStar((parcelRequire("hjb8Q")));
$23722554c2adc0db$exports.protobufPackage = "ibc.core.connection.v1";
function $23722554c2adc0db$var$createBaseMsgConnectionOpenInit() {
    return {
        clientId: "",
        counterparty: undefined,
        version: undefined,
        delayPeriod: $7iZIe.Long.UZERO,
        signer: ""
    };
}
$23722554c2adc0db$exports.MsgConnectionOpenInit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.counterparty !== undefined) $f87da13d55c18e89$exports.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        if (message.version !== undefined) $f87da13d55c18e89$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(32).uint64(message.delayPeriod);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenInit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = $f87da13d55c18e89$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = $f87da13d55c18e89$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            counterparty: (0, $7iZIe.isSet)(object.counterparty) ? $f87da13d55c18e89$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            version: (0, $7iZIe.isSet)(object.version) ? $f87da13d55c18e89$exports.Version.fromJSON(object.version) : undefined,
            delayPeriod: (0, $7iZIe.isSet)(object.delayPeriod) ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $f87da13d55c18e89$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined && (obj.version = message.version ? $f87da13d55c18e89$exports.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $7iZIe.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenInit();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $f87da13d55c18e89$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $f87da13d55c18e89$exports.Version.fromPartial(object.version) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenInitResponse() {
    return {};
}
$23722554c2adc0db$exports.MsgConnectionOpenInitResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenInitResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenInitResponse();
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenTry() {
    return {
        clientId: "",
        previousConnectionId: "",
        clientState: undefined,
        counterparty: undefined,
        delayPeriod: $7iZIe.Long.UZERO,
        counterpartyVersions: [],
        proofHeight: undefined,
        proofInit: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
$23722554c2adc0db$exports.MsgConnectionOpenTry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.previousConnectionId !== "") writer.uint32(18).string(message.previousConnectionId);
        if (message.clientState !== undefined) $DM7bi.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        if (message.counterparty !== undefined) $f87da13d55c18e89$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.counterpartyVersions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $f87da13d55c18e89$exports.Version.encode(v, writer.uint32(50).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        if (message.proofInit.length !== 0) writer.uint32(66).bytes(message.proofInit);
        if (message.proofClient.length !== 0) writer.uint32(74).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(82).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        if (message.signer !== "") writer.uint32(98).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(106).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenTry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = $f87da13d55c18e89$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push($f87da13d55c18e89$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                case 13:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            previousConnectionId: (0, $7iZIe.isSet)(object.previousConnectionId) ? String(object.previousConnectionId) : "",
            clientState: (0, $7iZIe.isSet)(object.clientState) ? $DM7bi.Any.fromJSON(object.clientState) : undefined,
            counterparty: (0, $7iZIe.isSet)(object.counterparty) ? $f87da13d55c18e89$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $7iZIe.isSet)(object.delayPeriod) ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO,
            counterpartyVersions: Array.isArray(object === null || object === void 0 ? void 0 : object.counterpartyVersions) ? object.counterpartyVersions.map(function(e) {
                return $f87da13d55c18e89$exports.Version.fromJSON(e);
            }) : [],
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            proofInit: (0, $7iZIe.isSet)(object.proofInit) ? (0, $7iZIe.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofClient: (0, $7iZIe.isSet)(object.proofClient) ? (0, $7iZIe.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $7iZIe.isSet)(object.proofConsensus) ? (0, $7iZIe.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $7iZIe.isSet)(object.consensusHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $7iZIe.isSet)(object.hostConsensusStateProof) ? (0, $7iZIe.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $DM7bi.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $f87da13d55c18e89$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $7iZIe.Long.UZERO).toString());
        if (message.counterpartyVersions) obj.counterpartyVersions = message.counterpartyVersions.map(function(e) {
            return e ? $f87da13d55c18e89$exports.Version.toJSON(e) : undefined;
        });
        else obj.counterpartyVersions = [];
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined && (obj.proofInit = (0, $7iZIe.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $7iZIe.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $7iZIe.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $7iZIe.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var _object_counterpartyVersions;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenTry();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        var _object_previousConnectionId;
        message.previousConnectionId = (_object_previousConnectionId = object.previousConnectionId) !== null && _object_previousConnectionId !== void 0 ? _object_previousConnectionId : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $DM7bi.Any.fromPartial(object.clientState) : undefined;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $f87da13d55c18e89$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $7iZIe.Long.fromValue(object.delayPeriod) : $7iZIe.Long.UZERO;
        message.counterpartyVersions = ((_object_counterpartyVersions = object.counterpartyVersions) === null || _object_counterpartyVersions === void 0 ? void 0 : _object_counterpartyVersions.map(function(e) {
            return $f87da13d55c18e89$exports.Version.fromPartial(e);
        })) || [];
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_proofInit;
        message.proofInit = (_object_proofInit = object.proofInit) !== null && _object_proofInit !== void 0 ? _object_proofInit : new Uint8Array();
        var _object_proofClient;
        message.proofClient = (_object_proofClient = object.proofClient) !== null && _object_proofClient !== void 0 ? _object_proofClient : new Uint8Array();
        var _object_proofConsensus;
        message.proofConsensus = (_object_proofConsensus = object.proofConsensus) !== null && _object_proofConsensus !== void 0 ? _object_proofConsensus : new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.consensusHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        var _object_hostConsensusStateProof;
        message.hostConsensusStateProof = (_object_hostConsensusStateProof = object.hostConsensusStateProof) !== null && _object_hostConsensusStateProof !== void 0 ? _object_hostConsensusStateProof : new Uint8Array();
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenTryResponse() {
    return {};
}
$23722554c2adc0db$exports.MsgConnectionOpenTryResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenTryResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenTryResponse();
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenAck() {
    return {
        connectionId: "",
        counterpartyConnectionId: "",
        version: undefined,
        clientState: undefined,
        proofHeight: undefined,
        proofTry: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
$23722554c2adc0db$exports.MsgConnectionOpenAck = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.counterpartyConnectionId !== "") writer.uint32(18).string(message.counterpartyConnectionId);
        if (message.version !== undefined) $f87da13d55c18e89$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (message.clientState !== undefined) $DM7bi.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        if (message.proofTry.length !== 0) writer.uint32(50).bytes(message.proofTry);
        if (message.proofClient.length !== 0) writer.uint32(58).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(66).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        if (message.signer !== "") writer.uint32(82).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(90).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenAck();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = $f87da13d55c18e89$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                case 11:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connectionId: (0, $7iZIe.isSet)(object.connectionId) ? String(object.connectionId) : "",
            counterpartyConnectionId: (0, $7iZIe.isSet)(object.counterpartyConnectionId) ? String(object.counterpartyConnectionId) : "",
            version: (0, $7iZIe.isSet)(object.version) ? $f87da13d55c18e89$exports.Version.fromJSON(object.version) : undefined,
            clientState: (0, $7iZIe.isSet)(object.clientState) ? $DM7bi.Any.fromJSON(object.clientState) : undefined,
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            proofTry: (0, $7iZIe.isSet)(object.proofTry) ? (0, $7iZIe.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofClient: (0, $7iZIe.isSet)(object.proofClient) ? (0, $7iZIe.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $7iZIe.isSet)(object.proofConsensus) ? (0, $7iZIe.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $7iZIe.isSet)(object.consensusHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $7iZIe.isSet)(object.hostConsensusStateProof) ? (0, $7iZIe.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined && (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined && (obj.version = message.version ? $f87da13d55c18e89$exports.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $DM7bi.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined && (obj.proofTry = (0, $7iZIe.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $7iZIe.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $7iZIe.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $7iZIe.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenAck();
        var _object_connectionId;
        message.connectionId = (_object_connectionId = object.connectionId) !== null && _object_connectionId !== void 0 ? _object_connectionId : "";
        var _object_counterpartyConnectionId;
        message.counterpartyConnectionId = (_object_counterpartyConnectionId = object.counterpartyConnectionId) !== null && _object_counterpartyConnectionId !== void 0 ? _object_counterpartyConnectionId : "";
        message.version = object.version !== undefined && object.version !== null ? $f87da13d55c18e89$exports.Version.fromPartial(object.version) : undefined;
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $DM7bi.Any.fromPartial(object.clientState) : undefined;
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_proofTry;
        message.proofTry = (_object_proofTry = object.proofTry) !== null && _object_proofTry !== void 0 ? _object_proofTry : new Uint8Array();
        var _object_proofClient;
        message.proofClient = (_object_proofClient = object.proofClient) !== null && _object_proofClient !== void 0 ? _object_proofClient : new Uint8Array();
        var _object_proofConsensus;
        message.proofConsensus = (_object_proofConsensus = object.proofConsensus) !== null && _object_proofConsensus !== void 0 ? _object_proofConsensus : new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.consensusHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        var _object_hostConsensusStateProof;
        message.hostConsensusStateProof = (_object_hostConsensusStateProof = object.hostConsensusStateProof) !== null && _object_hostConsensusStateProof !== void 0 ? _object_hostConsensusStateProof : new Uint8Array();
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenAckResponse() {
    return {};
}
$23722554c2adc0db$exports.MsgConnectionOpenAckResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenAckResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenAckResponse();
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenConfirm() {
    return {
        connectionId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$23722554c2adc0db$exports.MsgConnectionOpenConfirm = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.proofAck.length !== 0) writer.uint32(18).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenConfirm();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connectionId: (0, $7iZIe.isSet)(object.connectionId) ? String(object.connectionId) : "",
            proofAck: (0, $7iZIe.isSet)(object.proofAck) ? (0, $7iZIe.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $7iZIe.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined && (obj.proofAck = (0, $7iZIe.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial: function(object) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenConfirm();
        var _object_connectionId;
        message.connectionId = (_object_connectionId = object.connectionId) !== null && _object_connectionId !== void 0 ? _object_connectionId : "";
        var _object_proofAck;
        message.proofAck = (_object_proofAck = object.proofAck) !== null && _object_proofAck !== void 0 ? _object_proofAck : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        var _object_signer;
        message.signer = (_object_signer = object.signer) !== null && _object_signer !== void 0 ? _object_signer : "";
        return message;
    }
};
function $23722554c2adc0db$var$createBaseMsgConnectionOpenConfirmResponse() {
    return {};
}
$23722554c2adc0db$exports.MsgConnectionOpenConfirmResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $23722554c2adc0db$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $23722554c2adc0db$var$_m0.Reader ? input : new $23722554c2adc0db$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenConfirmResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $23722554c2adc0db$var$createBaseMsgConnectionOpenConfirmResponse();
        return message;
    }
};
var $23722554c2adc0db$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "ConnectionOpenInit",
            value: function ConnectionOpenInit(request) {
                var data = $23722554c2adc0db$exports.MsgConnectionOpenInit.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
                return promise.then(function(data) {
                    return $23722554c2adc0db$exports.MsgConnectionOpenInitResponse.decode(new $23722554c2adc0db$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionOpenTry",
            value: function ConnectionOpenTry(request) {
                var data = $23722554c2adc0db$exports.MsgConnectionOpenTry.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
                return promise.then(function(data) {
                    return $23722554c2adc0db$exports.MsgConnectionOpenTryResponse.decode(new $23722554c2adc0db$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionOpenAck",
            value: function ConnectionOpenAck(request) {
                var data = $23722554c2adc0db$exports.MsgConnectionOpenAck.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
                return promise.then(function(data) {
                    return $23722554c2adc0db$exports.MsgConnectionOpenAckResponse.decode(new $23722554c2adc0db$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionOpenConfirm",
            value: function ConnectionOpenConfirm(request) {
                var data = $23722554c2adc0db$exports.MsgConnectionOpenConfirm.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
                return promise.then(function(data) {
                    return $23722554c2adc0db$exports.MsgConnectionOpenConfirmResponse.decode(new $23722554c2adc0db$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$23722554c2adc0db$exports.MsgClientImpl = $23722554c2adc0db$var$MsgClientImpl;


$d49dfd7aa13fe848$exports.ibcTypes = [
    [
        "/ibc.applications.transfer.v1.MsgTransfer",
        $8822fe0a75ad6109$exports.MsgTransfer
    ],
    [
        "/ibc.core.channel.v1.MsgAcknowledgement",
        $60aebf6a622c8056$exports.MsgAcknowledgement
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        $60aebf6a622c8056$exports.MsgChannelCloseConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseInit",
        $60aebf6a622c8056$exports.MsgChannelCloseInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenAck",
        $60aebf6a622c8056$exports.MsgChannelOpenAck
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        $60aebf6a622c8056$exports.MsgChannelOpenConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenInit",
        $60aebf6a622c8056$exports.MsgChannelOpenInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenTry",
        $60aebf6a622c8056$exports.MsgChannelOpenTry
    ],
    [
        "/ibc.core.channel.v1.MsgRecvPacket",
        $60aebf6a622c8056$exports.MsgRecvPacket
    ],
    [
        "/ibc.core.channel.v1.MsgTimeout",
        $60aebf6a622c8056$exports.MsgTimeout
    ],
    [
        "/ibc.core.channel.v1.MsgTimeoutOnClose",
        $60aebf6a622c8056$exports.MsgTimeoutOnClose
    ],
    [
        "/ibc.core.client.v1.MsgCreateClient",
        $3d734f3f7df8611c$exports.MsgCreateClient
    ],
    [
        "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        $3d734f3f7df8611c$exports.MsgSubmitMisbehaviour
    ],
    [
        "/ibc.core.client.v1.MsgUpdateClient",
        $3d734f3f7df8611c$exports.MsgUpdateClient
    ],
    [
        "/ibc.core.client.v1.MsgUpgradeClient",
        $3d734f3f7df8611c$exports.MsgUpgradeClient
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenAck",
        $23722554c2adc0db$exports.MsgConnectionOpenAck
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        $23722554c2adc0db$exports.MsgConnectionOpenConfirm
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenInit",
        $23722554c2adc0db$exports.MsgConnectionOpenInit
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenTry",
        $23722554c2adc0db$exports.MsgConnectionOpenTry
    ]
];
function $d49dfd7aa13fe848$var$isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
$d49dfd7aa13fe848$exports.isMsgTransferEncodeObject = $d49dfd7aa13fe848$var$isMsgTransferEncodeObject;


Object.defineProperty($0aaecf7be71ff9a4$exports, "ibcTypes", {
    enumerable: true,
    get: function get() {
        return $d49dfd7aa13fe848$exports.ibcTypes;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function get() {
        return $d49dfd7aa13fe848$exports.isMsgTransferEncodeObject;
    }
});
var $5a8dcc95af53b014$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $5a8dcc95af53b014$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5a8dcc95af53b014$exports, "__esModule", {
    value: true
});
$5a8dcc95af53b014$exports.setupIbcExtension = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");
var $b3a5fd852d526a0b$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $b3a5fd852d526a0b$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3a5fd852d526a0b$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b3a5fd852d526a0b$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b3a5fd852d526a0b$var$__createBinding(result, mod, k);
    }
    $b3a5fd852d526a0b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b3a5fd852d526a0b$exports, "__esModule", {
    value: true
});
$b3a5fd852d526a0b$exports.QueryClientImpl = $b3a5fd852d526a0b$exports.QueryEscrowAddressResponse = $b3a5fd852d526a0b$exports.QueryEscrowAddressRequest = $b3a5fd852d526a0b$exports.QueryDenomHashResponse = $b3a5fd852d526a0b$exports.QueryDenomHashRequest = $b3a5fd852d526a0b$exports.QueryParamsResponse = $b3a5fd852d526a0b$exports.QueryParamsRequest = $b3a5fd852d526a0b$exports.QueryDenomTracesResponse = $b3a5fd852d526a0b$exports.QueryDenomTracesRequest = $b3a5fd852d526a0b$exports.QueryDenomTraceResponse = $b3a5fd852d526a0b$exports.QueryDenomTraceRequest = $b3a5fd852d526a0b$exports.protobufPackage = void 0;

var $bf44f209ff0e1c75$exports = {};
"use strict";
var $bf44f209ff0e1c75$var$__createBinding = $bf44f209ff0e1c75$exports && $bf44f209ff0e1c75$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf44f209ff0e1c75$var$__setModuleDefault = $bf44f209ff0e1c75$exports && $bf44f209ff0e1c75$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bf44f209ff0e1c75$var$__importStar = $bf44f209ff0e1c75$exports && $bf44f209ff0e1c75$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bf44f209ff0e1c75$var$__createBinding(result, mod, k);
    }
    $bf44f209ff0e1c75$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($bf44f209ff0e1c75$exports, "__esModule", {
    value: true
});
$bf44f209ff0e1c75$exports.Params = $bf44f209ff0e1c75$exports.DenomTrace = $bf44f209ff0e1c75$exports.protobufPackage = void 0;

/* eslint-disable */ var $bf44f209ff0e1c75$var$_m0 = $bf44f209ff0e1c75$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$bf44f209ff0e1c75$exports.protobufPackage = "ibc.applications.transfer.v1";
function $bf44f209ff0e1c75$var$createBaseDenomTrace() {
    return {
        path: "",
        baseDenom: ""
    };
}
$bf44f209ff0e1c75$exports.DenomTrace = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $bf44f209ff0e1c75$var$_m0.Writer.create();
        if (message.path !== "") writer.uint32(10).string(message.path);
        if (message.baseDenom !== "") writer.uint32(18).string(message.baseDenom);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bf44f209ff0e1c75$var$_m0.Reader ? input : new $bf44f209ff0e1c75$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bf44f209ff0e1c75$var$createBaseDenomTrace();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            path: (0, $7iZIe.isSet)(object.path) ? String(object.path) : "",
            baseDenom: (0, $7iZIe.isSet)(object.baseDenom) ? String(object.baseDenom) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial: function(object) {
        var message = $bf44f209ff0e1c75$var$createBaseDenomTrace();
        var _object_path;
        message.path = (_object_path = object.path) !== null && _object_path !== void 0 ? _object_path : "";
        var _object_baseDenom;
        message.baseDenom = (_object_baseDenom = object.baseDenom) !== null && _object_baseDenom !== void 0 ? _object_baseDenom : "";
        return message;
    }
};
function $bf44f209ff0e1c75$var$createBaseParams() {
    return {
        sendEnabled: false,
        receiveEnabled: false
    };
}
$bf44f209ff0e1c75$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $bf44f209ff0e1c75$var$_m0.Writer.create();
        if (message.sendEnabled === true) writer.uint32(8).bool(message.sendEnabled);
        if (message.receiveEnabled === true) writer.uint32(16).bool(message.receiveEnabled);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bf44f209ff0e1c75$var$_m0.Reader ? input : new $bf44f209ff0e1c75$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bf44f209ff0e1c75$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sendEnabled: (0, $7iZIe.isSet)(object.sendEnabled) ? Boolean(object.sendEnabled) : false,
            receiveEnabled: (0, $7iZIe.isSet)(object.receiveEnabled) ? Boolean(object.receiveEnabled) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial: function(object) {
        var message = $bf44f209ff0e1c75$var$createBaseParams();
        var _object_sendEnabled;
        message.sendEnabled = (_object_sendEnabled = object.sendEnabled) !== null && _object_sendEnabled !== void 0 ? _object_sendEnabled : false;
        var _object_receiveEnabled;
        message.receiveEnabled = (_object_receiveEnabled = object.receiveEnabled) !== null && _object_receiveEnabled !== void 0 ? _object_receiveEnabled : false;
        return message;
    }
};



var $b3a5fd852d526a0b$var$_m0 = $b3a5fd852d526a0b$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$b3a5fd852d526a0b$exports.protobufPackage = "ibc.applications.transfer.v1";
function $b3a5fd852d526a0b$var$createBaseQueryDenomTraceRequest() {
    return {
        hash: ""
    };
}
$b3a5fd852d526a0b$exports.QueryDenomTraceRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTraceRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTraceRequest();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : "";
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryDenomTraceResponse() {
    return {
        denomTrace: undefined
    };
}
$b3a5fd852d526a0b$exports.QueryDenomTraceResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.denomTrace !== undefined) $bf44f209ff0e1c75$exports.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTraceResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTrace = $bf44f209ff0e1c75$exports.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denomTrace: (0, $7iZIe.isSet)(object.denomTrace) ? $bf44f209ff0e1c75$exports.DenomTrace.fromJSON(object.denomTrace) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.denomTrace !== undefined && (obj.denomTrace = message.denomTrace ? $bf44f209ff0e1c75$exports.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTraceResponse();
        message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? $bf44f209ff0e1c75$exports.DenomTrace.fromPartial(object.denomTrace) : undefined;
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryDenomTracesRequest() {
    return {
        pagination: undefined
    };
}
$b3a5fd852d526a0b$exports.QueryDenomTracesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTracesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTracesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryDenomTracesResponse() {
    return {
        denomTraces: [],
        pagination: undefined
    };
}
$b3a5fd852d526a0b$exports.QueryDenomTracesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.denomTraces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $bf44f209ff0e1c75$exports.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTracesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTraces.push($bf44f209ff0e1c75$exports.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denomTraces: Array.isArray(object === null || object === void 0 ? void 0 : object.denomTraces) ? object.denomTraces.map(function(e) {
                return $bf44f209ff0e1c75$exports.DenomTrace.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.denomTraces) obj.denomTraces = message.denomTraces.map(function(e) {
            return e ? $bf44f209ff0e1c75$exports.DenomTrace.toJSON(e) : undefined;
        });
        else obj.denomTraces = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_denomTraces;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomTracesResponse();
        message.denomTraces = ((_object_denomTraces = object.denomTraces) === null || _object_denomTraces === void 0 ? void 0 : _object_denomTraces.map(function(e) {
            return $bf44f209ff0e1c75$exports.DenomTrace.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryParamsRequest() {
    return {};
}
$b3a5fd852d526a0b$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$b3a5fd852d526a0b$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.params !== undefined) $bf44f209ff0e1c75$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $bf44f209ff0e1c75$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $bf44f209ff0e1c75$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $bf44f209ff0e1c75$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $bf44f209ff0e1c75$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryDenomHashRequest() {
    return {
        trace: ""
    };
}
$b3a5fd852d526a0b$exports.QueryDenomHashRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.trace !== "") writer.uint32(10).string(message.trace);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomHashRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.trace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            trace: (0, $7iZIe.isSet)(object.trace) ? String(object.trace) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.trace !== undefined && (obj.trace = message.trace);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomHashRequest();
        var _object_trace;
        message.trace = (_object_trace = object.trace) !== null && _object_trace !== void 0 ? _object_trace : "";
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryDenomHashResponse() {
    return {
        hash: ""
    };
}
$b3a5fd852d526a0b$exports.QueryDenomHashResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomHashResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryDenomHashResponse();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : "";
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryEscrowAddressRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$b3a5fd852d526a0b$exports.QueryEscrowAddressRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryEscrowAddressRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryEscrowAddressRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        return message;
    }
};
function $b3a5fd852d526a0b$var$createBaseQueryEscrowAddressResponse() {
    return {
        escrowAddress: ""
    };
}
$b3a5fd852d526a0b$exports.QueryEscrowAddressResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b3a5fd852d526a0b$var$_m0.Writer.create();
        if (message.escrowAddress !== "") writer.uint32(10).string(message.escrowAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b3a5fd852d526a0b$var$_m0.Reader ? input : new $b3a5fd852d526a0b$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b3a5fd852d526a0b$var$createBaseQueryEscrowAddressResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.escrowAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            escrowAddress: (0, $7iZIe.isSet)(object.escrowAddress) ? String(object.escrowAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.escrowAddress !== undefined && (obj.escrowAddress = message.escrowAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b3a5fd852d526a0b$var$createBaseQueryEscrowAddressResponse();
        var _object_escrowAddress;
        message.escrowAddress = (_object_escrowAddress = object.escrowAddress) !== null && _object_escrowAddress !== void 0 ? _object_escrowAddress : "";
        return message;
    }
};
var $b3a5fd852d526a0b$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomHash = this.DenomHash.bind(this);
        this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "DenomTrace",
            value: function DenomTrace(request) {
                var data = $b3a5fd852d526a0b$exports.QueryDenomTraceRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
                return promise.then(function(data) {
                    return $b3a5fd852d526a0b$exports.QueryDenomTraceResponse.decode(new $b3a5fd852d526a0b$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DenomTraces",
            value: function DenomTraces() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $b3a5fd852d526a0b$exports.QueryDenomTracesRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
                return promise.then(function(data) {
                    return $b3a5fd852d526a0b$exports.QueryDenomTracesResponse.decode(new $b3a5fd852d526a0b$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $b3a5fd852d526a0b$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
                return promise.then(function(data) {
                    return $b3a5fd852d526a0b$exports.QueryParamsResponse.decode(new $b3a5fd852d526a0b$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DenomHash",
            value: function DenomHash(request) {
                var data = $b3a5fd852d526a0b$exports.QueryDenomHashRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
                return promise.then(function(data) {
                    return $b3a5fd852d526a0b$exports.QueryDenomHashResponse.decode(new $b3a5fd852d526a0b$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "EscrowAddress",
            value: function EscrowAddress(request) {
                var data = $b3a5fd852d526a0b$exports.QueryEscrowAddressRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", data);
                return promise.then(function(data) {
                    return $b3a5fd852d526a0b$exports.QueryEscrowAddressResponse.decode(new $b3a5fd852d526a0b$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$b3a5fd852d526a0b$exports.QueryClientImpl = $b3a5fd852d526a0b$var$QueryClientImpl;



var $661af8b6a74dcaa1$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $661af8b6a74dcaa1$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $661af8b6a74dcaa1$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $661af8b6a74dcaa1$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $661af8b6a74dcaa1$var$__createBinding(result, mod, k);
    }
    $661af8b6a74dcaa1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($661af8b6a74dcaa1$exports, "__esModule", {
    value: true
});
$661af8b6a74dcaa1$exports.QueryClientImpl = $661af8b6a74dcaa1$exports.QueryNextSequenceReceiveResponse = $661af8b6a74dcaa1$exports.QueryNextSequenceReceiveRequest = $661af8b6a74dcaa1$exports.QueryUnreceivedAcksResponse = $661af8b6a74dcaa1$exports.QueryUnreceivedAcksRequest = $661af8b6a74dcaa1$exports.QueryUnreceivedPacketsResponse = $661af8b6a74dcaa1$exports.QueryUnreceivedPacketsRequest = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsResponse = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsRequest = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementResponse = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementRequest = $661af8b6a74dcaa1$exports.QueryPacketReceiptResponse = $661af8b6a74dcaa1$exports.QueryPacketReceiptRequest = $661af8b6a74dcaa1$exports.QueryPacketCommitmentsResponse = $661af8b6a74dcaa1$exports.QueryPacketCommitmentsRequest = $661af8b6a74dcaa1$exports.QueryPacketCommitmentResponse = $661af8b6a74dcaa1$exports.QueryPacketCommitmentRequest = $661af8b6a74dcaa1$exports.QueryChannelConsensusStateResponse = $661af8b6a74dcaa1$exports.QueryChannelConsensusStateRequest = $661af8b6a74dcaa1$exports.QueryChannelClientStateResponse = $661af8b6a74dcaa1$exports.QueryChannelClientStateRequest = $661af8b6a74dcaa1$exports.QueryConnectionChannelsResponse = $661af8b6a74dcaa1$exports.QueryConnectionChannelsRequest = $661af8b6a74dcaa1$exports.QueryChannelsResponse = $661af8b6a74dcaa1$exports.QueryChannelsRequest = $661af8b6a74dcaa1$exports.QueryChannelResponse = $661af8b6a74dcaa1$exports.QueryChannelRequest = $661af8b6a74dcaa1$exports.protobufPackage = void 0;




var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $661af8b6a74dcaa1$var$_m0 = $661af8b6a74dcaa1$var$__importStar((parcelRequire("hjb8Q")));
$661af8b6a74dcaa1$exports.protobufPackage = "ibc.core.channel.v1";
function $661af8b6a74dcaa1$var$createBaseQueryChannelRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$661af8b6a74dcaa1$exports.QueryChannelRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelResponse() {
    return {
        channel: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryChannelResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.channel !== undefined) $988a66f9b5875dc5$exports.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channel = $988a66f9b5875dc5$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            channel: (0, $7iZIe.isSet)(object.channel) ? $988a66f9b5875dc5$exports.Channel.fromJSON(object.channel) : undefined,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.channel !== undefined && (obj.channel = message.channel ? $988a66f9b5875dc5$exports.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelResponse();
        message.channel = object.channel !== undefined && object.channel !== null ? $988a66f9b5875dc5$exports.Channel.fromPartial(object.channel) : undefined;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelsRequest() {
    return {
        pagination: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryChannelsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryChannelsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.channels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $988a66f9b5875dc5$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($988a66f9b5875dc5$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels) ? object.channels.map(function(e) {
                return $988a66f9b5875dc5$exports.IdentifiedChannel.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.channels) obj.channels = message.channels.map(function(e) {
            return e ? $988a66f9b5875dc5$exports.IdentifiedChannel.toJSON(e) : undefined;
        });
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_channels;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelsResponse();
        message.channels = ((_object_channels = object.channels) === null || _object_channels === void 0 ? void 0 : _object_channels.map(function(e) {
            return $988a66f9b5875dc5$exports.IdentifiedChannel.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryConnectionChannelsRequest() {
    return {
        connection: "",
        pagination: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryConnectionChannelsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.connection !== "") writer.uint32(10).string(message.connection);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryConnectionChannelsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connection: (0, $7iZIe.isSet)(object.connection) ? String(object.connection) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryConnectionChannelsRequest();
        var _object_connection;
        message.connection = (_object_connection = object.connection) !== null && _object_connection !== void 0 ? _object_connection : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryConnectionChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryConnectionChannelsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.channels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $988a66f9b5875dc5$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryConnectionChannelsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($988a66f9b5875dc5$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            channels: Array.isArray(object === null || object === void 0 ? void 0 : object.channels) ? object.channels.map(function(e) {
                return $988a66f9b5875dc5$exports.IdentifiedChannel.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.channels) obj.channels = message.channels.map(function(e) {
            return e ? $988a66f9b5875dc5$exports.IdentifiedChannel.toJSON(e) : undefined;
        });
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_channels;
        var message = $661af8b6a74dcaa1$var$createBaseQueryConnectionChannelsResponse();
        message.channels = ((_object_channels = object.channels) === null || _object_channels === void 0 ? void 0 : _object_channels.map(function(e) {
            return $988a66f9b5875dc5$exports.IdentifiedChannel.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelClientStateRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$661af8b6a74dcaa1$exports.QueryChannelClientStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelClientStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelClientStateRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryChannelClientStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.identifiedClientState !== undefined) $a483577fa3a761ce$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelClientStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $a483577fa3a761ce$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            identifiedClientState: (0, $7iZIe.isSet)(object.identifiedClientState) ? $a483577fa3a761ce$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $a483577fa3a761ce$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $a483577fa3a761ce$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelConsensusStateRequest() {
    return {
        portId: "",
        channelId: "",
        revisionNumber: $7iZIe.Long.UZERO,
        revisionHeight: $7iZIe.Long.UZERO
    };
}
$661af8b6a74dcaa1$exports.QueryChannelConsensusStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.revisionNumber.isZero()) writer.uint32(24).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(32).uint64(message.revisionHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelConsensusStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            revisionNumber: (0, $7iZIe.isSet)(object.revisionNumber) ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO,
            revisionHeight: (0, $7iZIe.isSet)(object.revisionHeight) ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $7iZIe.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelConsensusStateRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryChannelConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryChannelConsensusStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.consensusState !== undefined) $DM7bi.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelConsensusStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consensusState: (0, $7iZIe.isSet)(object.consensusState) ? $DM7bi.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $DM7bi.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryChannelConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $DM7bi.Any.fromPartial(object.consensusState) : undefined;
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $7iZIe.Long.UZERO
    };
}
$661af8b6a74dcaa1$exports.QueryPacketCommitmentRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentResponse() {
    return {
        commitment: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryPacketCommitmentResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.commitment.length !== 0) writer.uint32(10).bytes(message.commitment);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            commitment: (0, $7iZIe.isSet)(object.commitment) ? (0, $7iZIe.bytesFromBase64)(object.commitment) : new Uint8Array(),
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.commitment !== undefined && (obj.commitment = (0, $7iZIe.base64FromBytes)(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentResponse();
        var _object_commitment;
        message.commitment = (_object_commitment = object.commitment) !== null && _object_commitment !== void 0 ? _object_commitment : new Uint8Array();
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryPacketCommitmentsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentsRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentsResponse() {
    return {
        commitments: [],
        pagination: undefined,
        height: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryPacketCommitmentsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.commitments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $988a66f9b5875dc5$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitments.push($988a66f9b5875dc5$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            commitments: Array.isArray(object === null || object === void 0 ? void 0 : object.commitments) ? object.commitments.map(function(e) {
                return $988a66f9b5875dc5$exports.PacketState.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.commitments) obj.commitments = message.commitments.map(function(e) {
            return e ? $988a66f9b5875dc5$exports.PacketState.toJSON(e) : undefined;
        });
        else obj.commitments = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_commitments;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketCommitmentsResponse();
        message.commitments = ((_object_commitments = object.commitments) === null || _object_commitments === void 0 ? void 0 : _object_commitments.map(function(e) {
            return $988a66f9b5875dc5$exports.PacketState.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketReceiptRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $7iZIe.Long.UZERO
    };
}
$661af8b6a74dcaa1$exports.QueryPacketReceiptRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketReceiptRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketReceiptRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketReceiptResponse() {
    return {
        received: false,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryPacketReceiptResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.received === true) writer.uint32(16).bool(message.received);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketReceiptResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            received: (0, $7iZIe.isSet)(object.received) ? Boolean(object.received) : false,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketReceiptResponse();
        var _object_received;
        message.received = (_object_received = object.received) !== null && _object_received !== void 0 ? _object_received : false;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $7iZIe.Long.UZERO
    };
}
$661af8b6a74dcaa1$exports.QueryPacketAcknowledgementRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $7iZIe.isSet)(object.sequence) ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $7iZIe.Long.fromValue(object.sequence) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementResponse() {
    return {
        acknowledgement: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryPacketAcknowledgementResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.acknowledgement.length !== 0) writer.uint32(10).bytes(message.acknowledgement);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            acknowledgement: (0, $7iZIe.isSet)(object.acknowledgement) ? (0, $7iZIe.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $7iZIe.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementResponse();
        var _object_acknowledgement;
        message.acknowledgement = (_object_acknowledgement = object.acknowledgement) !== null && _object_acknowledgement !== void 0 ? _object_acknowledgement : new Uint8Array();
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined,
        packetCommitmentSequences: []
    };
}
$661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.packetCommitmentSequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined,
            packetCommitmentSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packetCommitmentSequences) ? object.packetCommitmentSequences.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_packetCommitmentSequences;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementsRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        message.packetCommitmentSequences = ((_object_packetCommitmentSequences = object.packetCommitmentSequences) === null || _object_packetCommitmentSequences === void 0 ? void 0 : _object_packetCommitmentSequences.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementsResponse() {
    return {
        acknowledgements: [],
        pagination: undefined,
        height: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.acknowledgements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $988a66f9b5875dc5$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgements.push($988a66f9b5875dc5$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            acknowledgements: Array.isArray(object === null || object === void 0 ? void 0 : object.acknowledgements) ? object.acknowledgements.map(function(e) {
                return $988a66f9b5875dc5$exports.PacketState.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.acknowledgements) obj.acknowledgements = message.acknowledgements.map(function(e) {
            return e ? $988a66f9b5875dc5$exports.PacketState.toJSON(e) : undefined;
        });
        else obj.acknowledgements = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_acknowledgements;
        var message = $661af8b6a74dcaa1$var$createBaseQueryPacketAcknowledgementsResponse();
        message.acknowledgements = ((_object_acknowledgements = object.acknowledgements) === null || _object_acknowledgements === void 0 ? void 0 : _object_acknowledgements.map(function(e) {
            return $988a66f9b5875dc5$exports.PacketState.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryUnreceivedPacketsRequest() {
    return {
        portId: "",
        channelId: "",
        packetCommitmentSequences: []
    };
}
$661af8b6a74dcaa1$exports.QueryUnreceivedPacketsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.packetCommitmentSequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedPacketsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            packetCommitmentSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packetCommitmentSequences) ? object.packetCommitmentSequences.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_packetCommitmentSequences;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedPacketsRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.packetCommitmentSequences = ((_object_packetCommitmentSequences = object.packetCommitmentSequences) === null || _object_packetCommitmentSequences === void 0 ? void 0 : _object_packetCommitmentSequences.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryUnreceivedPacketsResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryUnreceivedPacketsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        writer.uint32(10).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.sequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedPacketsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : [],
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.sequences) obj.sequences = message.sequences.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_sequences;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedPacketsResponse();
        message.sequences = ((_object_sequences = object.sequences) === null || _object_sequences === void 0 ? void 0 : _object_sequences.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryUnreceivedAcksRequest() {
    return {
        portId: "",
        channelId: "",
        packetAckSequences: []
    };
}
$661af8b6a74dcaa1$exports.QueryUnreceivedAcksRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.packetAckSequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedAcksRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetAckSequences.push(reader.uint64());
                    } else message.packetAckSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : "",
            packetAckSequences: Array.isArray(object === null || object === void 0 ? void 0 : object.packetAckSequences) ? object.packetAckSequences.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) obj.packetAckSequences = message.packetAckSequences.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.packetAckSequences = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_packetAckSequences;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedAcksRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        message.packetAckSequences = ((_object_packetAckSequences = object.packetAckSequences) === null || _object_packetAckSequences === void 0 ? void 0 : _object_packetAckSequences.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryUnreceivedAcksResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryUnreceivedAcksResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        writer.uint32(10).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.sequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedAcksResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sequences: Array.isArray(object === null || object === void 0 ? void 0 : object.sequences) ? object.sequences.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : [],
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.sequences) obj.sequences = message.sequences.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_sequences;
        var message = $661af8b6a74dcaa1$var$createBaseQueryUnreceivedAcksResponse();
        message.sequences = ((_object_sequences = object.sequences) === null || _object_sequences === void 0 ? void 0 : _object_sequences.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryNextSequenceReceiveRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$661af8b6a74dcaa1$exports.QueryNextSequenceReceiveRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryNextSequenceReceiveRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            portId: (0, $7iZIe.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $7iZIe.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryNextSequenceReceiveRequest();
        var _object_portId;
        message.portId = (_object_portId = object.portId) !== null && _object_portId !== void 0 ? _object_portId : "";
        var _object_channelId;
        message.channelId = (_object_channelId = object.channelId) !== null && _object_channelId !== void 0 ? _object_channelId : "";
        return message;
    }
};
function $661af8b6a74dcaa1$var$createBaseQueryNextSequenceReceiveResponse() {
    return {
        nextSequenceReceive: $7iZIe.Long.UZERO,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$661af8b6a74dcaa1$exports.QueryNextSequenceReceiveResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $661af8b6a74dcaa1$var$_m0.Writer.create();
        if (!message.nextSequenceReceive.isZero()) writer.uint32(8).uint64(message.nextSequenceReceive);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $661af8b6a74dcaa1$var$_m0.Reader ? input : new $661af8b6a74dcaa1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $661af8b6a74dcaa1$var$createBaseQueryNextSequenceReceiveResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            nextSequenceReceive: (0, $7iZIe.isSet)(object.nextSequenceReceive) ? $7iZIe.Long.fromValue(object.nextSequenceReceive) : $7iZIe.Long.UZERO,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.nextSequenceReceive !== undefined && (obj.nextSequenceReceive = (message.nextSequenceReceive || $7iZIe.Long.UZERO).toString());
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $661af8b6a74dcaa1$var$createBaseQueryNextSequenceReceiveResponse();
        message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? $7iZIe.Long.fromValue(object.nextSequenceReceive) : $7iZIe.Long.UZERO;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
var $661af8b6a74dcaa1$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Channel",
            value: function Channel(request) {
                var data = $661af8b6a74dcaa1$exports.QueryChannelRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryChannelResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Channels",
            value: function Channels() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $661af8b6a74dcaa1$exports.QueryChannelsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryChannelsResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionChannels",
            value: function ConnectionChannels(request) {
                var data = $661af8b6a74dcaa1$exports.QueryConnectionChannelsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryConnectionChannelsResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelClientState",
            value: function ChannelClientState(request) {
                var data = $661af8b6a74dcaa1$exports.QueryChannelClientStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryChannelClientStateResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ChannelConsensusState",
            value: function ChannelConsensusState(request) {
                var data = $661af8b6a74dcaa1$exports.QueryChannelConsensusStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryChannelConsensusStateResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PacketCommitment",
            value: function PacketCommitment(request) {
                var data = $661af8b6a74dcaa1$exports.QueryPacketCommitmentRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryPacketCommitmentResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PacketCommitments",
            value: function PacketCommitments(request) {
                var data = $661af8b6a74dcaa1$exports.QueryPacketCommitmentsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryPacketCommitmentsResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PacketReceipt",
            value: function PacketReceipt(request) {
                var data = $661af8b6a74dcaa1$exports.QueryPacketReceiptRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryPacketReceiptResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PacketAcknowledgement",
            value: function PacketAcknowledgement(request) {
                var data = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PacketAcknowledgements",
            value: function PacketAcknowledgements(request) {
                var data = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UnreceivedPackets",
            value: function UnreceivedPackets(request) {
                var data = $661af8b6a74dcaa1$exports.QueryUnreceivedPacketsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryUnreceivedPacketsResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UnreceivedAcks",
            value: function UnreceivedAcks(request) {
                var data = $661af8b6a74dcaa1$exports.QueryUnreceivedAcksRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryUnreceivedAcksResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "NextSequenceReceive",
            value: function NextSequenceReceive(request) {
                var data = $661af8b6a74dcaa1$exports.QueryNextSequenceReceiveRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
                return promise.then(function(data) {
                    return $661af8b6a74dcaa1$exports.QueryNextSequenceReceiveResponse.decode(new $661af8b6a74dcaa1$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$661af8b6a74dcaa1$exports.QueryClientImpl = $661af8b6a74dcaa1$var$QueryClientImpl;


var $67f921b5dc14f281$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $67f921b5dc14f281$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $67f921b5dc14f281$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $67f921b5dc14f281$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $67f921b5dc14f281$var$__createBinding(result, mod, k);
    }
    $67f921b5dc14f281$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($67f921b5dc14f281$exports, "__esModule", {
    value: true
});
$67f921b5dc14f281$exports.QueryClientImpl = $67f921b5dc14f281$exports.QueryUpgradedConsensusStateResponse = $67f921b5dc14f281$exports.QueryUpgradedConsensusStateRequest = $67f921b5dc14f281$exports.QueryUpgradedClientStateResponse = $67f921b5dc14f281$exports.QueryUpgradedClientStateRequest = $67f921b5dc14f281$exports.QueryClientParamsResponse = $67f921b5dc14f281$exports.QueryClientParamsRequest = $67f921b5dc14f281$exports.QueryClientStatusResponse = $67f921b5dc14f281$exports.QueryClientStatusRequest = $67f921b5dc14f281$exports.QueryConsensusStateHeightsResponse = $67f921b5dc14f281$exports.QueryConsensusStateHeightsRequest = $67f921b5dc14f281$exports.QueryConsensusStatesResponse = $67f921b5dc14f281$exports.QueryConsensusStatesRequest = $67f921b5dc14f281$exports.QueryConsensusStateResponse = $67f921b5dc14f281$exports.QueryConsensusStateRequest = $67f921b5dc14f281$exports.QueryClientStatesResponse = $67f921b5dc14f281$exports.QueryClientStatesRequest = $67f921b5dc14f281$exports.QueryClientStateResponse = $67f921b5dc14f281$exports.QueryClientStateRequest = $67f921b5dc14f281$exports.protobufPackage = void 0;


var $DM7bi = parcelRequire("DM7bi");


var $7iZIe = parcelRequire("7iZIe");

var $67f921b5dc14f281$var$_m0 = $67f921b5dc14f281$var$__importStar((parcelRequire("hjb8Q")));
$67f921b5dc14f281$exports.protobufPackage = "ibc.core.client.v1";
function $67f921b5dc14f281$var$createBaseQueryClientStateRequest() {
    return {
        clientId: ""
    };
}
$67f921b5dc14f281$exports.QueryClientStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientStateRequest();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientStateResponse() {
    return {
        clientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$67f921b5dc14f281$exports.QueryClientStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.clientState !== undefined) $DM7bi.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientState: (0, $7iZIe.isSet)(object.clientState) ? $DM7bi.Any.fromJSON(object.clientState) : undefined,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $DM7bi.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientStateResponse();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $DM7bi.Any.fromPartial(object.clientState) : undefined;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientStatesRequest() {
    return {
        pagination: undefined
    };
}
$67f921b5dc14f281$exports.QueryClientStatesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientStatesResponse() {
    return {
        clientStates: [],
        pagination: undefined
    };
}
$67f921b5dc14f281$exports.QueryClientStatesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.clientStates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a483577fa3a761ce$exports.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientStates.push($a483577fa3a761ce$exports.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientStates: Array.isArray(object === null || object === void 0 ? void 0 : object.clientStates) ? object.clientStates.map(function(e) {
                return $a483577fa3a761ce$exports.IdentifiedClientState.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.clientStates) obj.clientStates = message.clientStates.map(function(e) {
            return e ? $a483577fa3a761ce$exports.IdentifiedClientState.toJSON(e) : undefined;
        });
        else obj.clientStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_clientStates;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatesResponse();
        message.clientStates = ((_object_clientStates = object.clientStates) === null || _object_clientStates === void 0 ? void 0 : _object_clientStates.map(function(e) {
            return $a483577fa3a761ce$exports.IdentifiedClientState.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryConsensusStateRequest() {
    return {
        clientId: "",
        revisionNumber: $7iZIe.Long.UZERO,
        revisionHeight: $7iZIe.Long.UZERO,
        latestHeight: false
    };
}
$67f921b5dc14f281$exports.QueryConsensusStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        if (message.latestHeight === true) writer.uint32(32).bool(message.latestHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            revisionNumber: (0, $7iZIe.isSet)(object.revisionNumber) ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO,
            revisionHeight: (0, $7iZIe.isSet)(object.revisionHeight) ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO,
            latestHeight: (0, $7iZIe.isSet)(object.latestHeight) ? Boolean(object.latestHeight) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $7iZIe.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $7iZIe.Long.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateRequest();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO;
        var _object_latestHeight;
        message.latestHeight = (_object_latestHeight = object.latestHeight) !== null && _object_latestHeight !== void 0 ? _object_latestHeight : false;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryConsensusStateResponse() {
    return {
        consensusState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$67f921b5dc14f281$exports.QueryConsensusStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.consensusState !== undefined) $DM7bi.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consensusState: (0, $7iZIe.isSet)(object.consensusState) ? $DM7bi.Any.fromJSON(object.consensusState) : undefined,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $DM7bi.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $DM7bi.Any.fromPartial(object.consensusState) : undefined;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryConsensusStatesRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
$67f921b5dc14f281$exports.QueryConsensusStatesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStatesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStatesRequest();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryConsensusStatesResponse() {
    return {
        consensusStates: [],
        pagination: undefined
    };
}
$67f921b5dc14f281$exports.QueryConsensusStatesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.consensusStates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a483577fa3a761ce$exports.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStatesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStates.push($a483577fa3a761ce$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStates) ? object.consensusStates.map(function(e) {
                return $a483577fa3a761ce$exports.ConsensusStateWithHeight.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map(function(e) {
            return e ? $a483577fa3a761ce$exports.ConsensusStateWithHeight.toJSON(e) : undefined;
        });
        else obj.consensusStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_consensusStates;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStatesResponse();
        message.consensusStates = ((_object_consensusStates = object.consensusStates) === null || _object_consensusStates === void 0 ? void 0 : _object_consensusStates.map(function(e) {
            return $a483577fa3a761ce$exports.ConsensusStateWithHeight.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryConsensusStateHeightsRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
$67f921b5dc14f281$exports.QueryConsensusStateHeightsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateHeightsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateHeightsRequest();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryConsensusStateHeightsResponse() {
    return {
        consensusStateHeights: [],
        pagination: undefined
    };
}
$67f921b5dc14f281$exports.QueryConsensusStateHeightsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.consensusStateHeights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $a483577fa3a761ce$exports.Height.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateHeightsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStateHeights.push($a483577fa3a761ce$exports.Height.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consensusStateHeights: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStateHeights) ? object.consensusStateHeights.map(function(e) {
                return $a483577fa3a761ce$exports.Height.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.consensusStateHeights) obj.consensusStateHeights = message.consensusStateHeights.map(function(e) {
            return e ? $a483577fa3a761ce$exports.Height.toJSON(e) : undefined;
        });
        else obj.consensusStateHeights = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_consensusStateHeights;
        var message = $67f921b5dc14f281$var$createBaseQueryConsensusStateHeightsResponse();
        message.consensusStateHeights = ((_object_consensusStateHeights = object.consensusStateHeights) === null || _object_consensusStateHeights === void 0 ? void 0 : _object_consensusStateHeights.map(function(e) {
            return $a483577fa3a761ce$exports.Height.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientStatusRequest() {
    return {
        clientId: ""
    };
}
$67f921b5dc14f281$exports.QueryClientStatusRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatusRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatusRequest();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientStatusResponse() {
    return {
        status: ""
    };
}
$67f921b5dc14f281$exports.QueryClientStatusResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.status !== "") writer.uint32(10).string(message.status);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatusResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            status: (0, $7iZIe.isSet)(object.status) ? String(object.status) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.status !== undefined && (obj.status = message.status);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientStatusResponse();
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : "";
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientParamsRequest() {
    return {};
}
$67f921b5dc14f281$exports.QueryClientParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientParamsRequest();
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryClientParamsResponse() {
    return {
        params: undefined
    };
}
$67f921b5dc14f281$exports.QueryClientParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.params !== undefined) $a483577fa3a761ce$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryClientParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $a483577fa3a761ce$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $a483577fa3a761ce$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $a483577fa3a761ce$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryClientParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $a483577fa3a761ce$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryUpgradedClientStateRequest() {
    return {};
}
$67f921b5dc14f281$exports.QueryUpgradedClientStateRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedClientStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedClientStateRequest();
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryUpgradedClientStateResponse() {
    return {
        upgradedClientState: undefined
    };
}
$67f921b5dc14f281$exports.QueryUpgradedClientStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.upgradedClientState !== undefined) $DM7bi.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedClientStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedClientState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            upgradedClientState: (0, $7iZIe.isSet)(object.upgradedClientState) ? $DM7bi.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $DM7bi.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedClientStateResponse();
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $DM7bi.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryUpgradedConsensusStateRequest() {
    return {};
}
$67f921b5dc14f281$exports.QueryUpgradedConsensusStateRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedConsensusStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedConsensusStateRequest();
        return message;
    }
};
function $67f921b5dc14f281$var$createBaseQueryUpgradedConsensusStateResponse() {
    return {
        upgradedConsensusState: undefined
    };
}
$67f921b5dc14f281$exports.QueryUpgradedConsensusStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $67f921b5dc14f281$var$_m0.Writer.create();
        if (message.upgradedConsensusState !== undefined) $DM7bi.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $67f921b5dc14f281$var$_m0.Reader ? input : new $67f921b5dc14f281$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedConsensusStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedConsensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            upgradedConsensusState: (0, $7iZIe.isSet)(object.upgradedConsensusState) ? $DM7bi.Any.fromJSON(object.upgradedConsensusState) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.upgradedConsensusState !== undefined && (obj.upgradedConsensusState = message.upgradedConsensusState ? $DM7bi.Any.toJSON(message.upgradedConsensusState) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $67f921b5dc14f281$var$createBaseQueryUpgradedConsensusStateResponse();
        message.upgradedConsensusState = object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null ? $DM7bi.Any.fromPartial(object.upgradedConsensusState) : undefined;
        return message;
    }
};
var $67f921b5dc14f281$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this);
        this.ClientStatus = this.ClientStatus.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
        this.UpgradedClientState = this.UpgradedClientState.bind(this);
        this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "ClientState",
            value: function ClientState(request) {
                var data = $67f921b5dc14f281$exports.QueryClientStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryClientStateResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ClientStates",
            value: function ClientStates() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $67f921b5dc14f281$exports.QueryClientStatesRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryClientStatesResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConsensusState",
            value: function ConsensusState(request) {
                var data = $67f921b5dc14f281$exports.QueryConsensusStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryConsensusStateResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConsensusStates",
            value: function ConsensusStates(request) {
                var data = $67f921b5dc14f281$exports.QueryConsensusStatesRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryConsensusStatesResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConsensusStateHeights",
            value: function ConsensusStateHeights(request) {
                var data = $67f921b5dc14f281$exports.QueryConsensusStateHeightsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryConsensusStateHeightsResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ClientStatus",
            value: function ClientStatus(request) {
                var data = $67f921b5dc14f281$exports.QueryClientStatusRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryClientStatusResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ClientParams",
            value: function ClientParams() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $67f921b5dc14f281$exports.QueryClientParamsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryClientParamsResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpgradedClientState",
            value: function UpgradedClientState() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $67f921b5dc14f281$exports.QueryUpgradedClientStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryUpgradedClientStateResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpgradedConsensusState",
            value: function UpgradedConsensusState() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $67f921b5dc14f281$exports.QueryUpgradedConsensusStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
                return promise.then(function(data) {
                    return $67f921b5dc14f281$exports.QueryUpgradedConsensusStateResponse.decode(new $67f921b5dc14f281$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$67f921b5dc14f281$exports.QueryClientImpl = $67f921b5dc14f281$var$QueryClientImpl;


var $98853ff72821227c$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $98853ff72821227c$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $98853ff72821227c$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $98853ff72821227c$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $98853ff72821227c$var$__createBinding(result, mod, k);
    }
    $98853ff72821227c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($98853ff72821227c$exports, "__esModule", {
    value: true
});
$98853ff72821227c$exports.QueryClientImpl = $98853ff72821227c$exports.QueryConnectionParamsResponse = $98853ff72821227c$exports.QueryConnectionParamsRequest = $98853ff72821227c$exports.QueryConnectionConsensusStateResponse = $98853ff72821227c$exports.QueryConnectionConsensusStateRequest = $98853ff72821227c$exports.QueryConnectionClientStateResponse = $98853ff72821227c$exports.QueryConnectionClientStateRequest = $98853ff72821227c$exports.QueryClientConnectionsResponse = $98853ff72821227c$exports.QueryClientConnectionsRequest = $98853ff72821227c$exports.QueryConnectionsResponse = $98853ff72821227c$exports.QueryConnectionsRequest = $98853ff72821227c$exports.QueryConnectionResponse = $98853ff72821227c$exports.QueryConnectionRequest = $98853ff72821227c$exports.protobufPackage = void 0;




var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $98853ff72821227c$var$_m0 = $98853ff72821227c$var$__importStar((parcelRequire("hjb8Q")));
$98853ff72821227c$exports.protobufPackage = "ibc.core.connection.v1";
function $98853ff72821227c$var$createBaseQueryConnectionRequest() {
    return {
        connectionId: ""
    };
}
$98853ff72821227c$exports.QueryConnectionRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connectionId: (0, $7iZIe.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionRequest();
        var _object_connectionId;
        message.connectionId = (_object_connectionId = object.connectionId) !== null && _object_connectionId !== void 0 ? _object_connectionId : "";
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionResponse() {
    return {
        connection: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$98853ff72821227c$exports.QueryConnectionResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.connection !== undefined) $f87da13d55c18e89$exports.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = $f87da13d55c18e89$exports.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connection: (0, $7iZIe.isSet)(object.connection) ? $f87da13d55c18e89$exports.ConnectionEnd.fromJSON(object.connection) : undefined,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connection !== undefined && (obj.connection = message.connection ? $f87da13d55c18e89$exports.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionResponse();
        message.connection = object.connection !== undefined && object.connection !== null ? $f87da13d55c18e89$exports.ConnectionEnd.fromPartial(object.connection) : undefined;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionsRequest() {
    return {
        pagination: undefined
    };
}
$98853ff72821227c$exports.QueryConnectionsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionsResponse() {
    return {
        connections: [],
        pagination: undefined,
        height: undefined
    };
}
$98853ff72821227c$exports.QueryConnectionsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.connections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $f87da13d55c18e89$exports.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $a483577fa3a761ce$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connections.push($f87da13d55c18e89$exports.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connections: Array.isArray(object === null || object === void 0 ? void 0 : object.connections) ? object.connections.map(function(e) {
                return $f87da13d55c18e89$exports.IdentifiedConnection.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $a483577fa3a761ce$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.connections) obj.connections = message.connections.map(function(e) {
            return e ? $f87da13d55c18e89$exports.IdentifiedConnection.toJSON(e) : undefined;
        });
        else obj.connections = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $a483577fa3a761ce$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_connections;
        var message = $98853ff72821227c$var$createBaseQueryConnectionsResponse();
        message.connections = ((_object_connections = object.connections) === null || _object_connections === void 0 ? void 0 : _object_connections.map(function(e) {
            return $f87da13d55c18e89$exports.IdentifiedConnection.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryClientConnectionsRequest() {
    return {
        clientId: ""
    };
}
$98853ff72821227c$exports.QueryClientConnectionsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryClientConnectionsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryClientConnectionsRequest();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryClientConnectionsResponse() {
    return {
        connectionPaths: [],
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$98853ff72821227c$exports.QueryClientConnectionsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.connectionPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryClientConnectionsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connectionPaths: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionPaths) ? object.connectionPaths.map(function(e) {
                return String(e);
            }) : [],
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.connectionPaths) obj.connectionPaths = message.connectionPaths.map(function(e) {
            return e;
        });
        else obj.connectionPaths = [];
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_connectionPaths;
        var message = $98853ff72821227c$var$createBaseQueryClientConnectionsResponse();
        message.connectionPaths = ((_object_connectionPaths = object.connectionPaths) === null || _object_connectionPaths === void 0 ? void 0 : _object_connectionPaths.map(function(e) {
            return e;
        })) || [];
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionClientStateRequest() {
    return {
        connectionId: ""
    };
}
$98853ff72821227c$exports.QueryConnectionClientStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionClientStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connectionId: (0, $7iZIe.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionClientStateRequest();
        var _object_connectionId;
        message.connectionId = (_object_connectionId = object.connectionId) !== null && _object_connectionId !== void 0 ? _object_connectionId : "";
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$98853ff72821227c$exports.QueryConnectionClientStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.identifiedClientState !== undefined) $a483577fa3a761ce$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionClientStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $a483577fa3a761ce$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            identifiedClientState: (0, $7iZIe.isSet)(object.identifiedClientState) ? $a483577fa3a761ce$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $a483577fa3a761ce$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $a483577fa3a761ce$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionConsensusStateRequest() {
    return {
        connectionId: "",
        revisionNumber: $7iZIe.Long.UZERO,
        revisionHeight: $7iZIe.Long.UZERO
    };
}
$98853ff72821227c$exports.QueryConnectionConsensusStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionConsensusStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            connectionId: (0, $7iZIe.isSet)(object.connectionId) ? String(object.connectionId) : "",
            revisionNumber: (0, $7iZIe.isSet)(object.revisionNumber) ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO,
            revisionHeight: (0, $7iZIe.isSet)(object.revisionHeight) ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $7iZIe.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionConsensusStateRequest();
        var _object_connectionId;
        message.connectionId = (_object_connectionId = object.connectionId) !== null && _object_connectionId !== void 0 ? _object_connectionId : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $7iZIe.Long.fromValue(object.revisionNumber) : $7iZIe.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $7iZIe.Long.fromValue(object.revisionHeight) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$98853ff72821227c$exports.QueryConnectionConsensusStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.consensusState !== undefined) $DM7bi.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionConsensusStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consensusState: (0, $7iZIe.isSet)(object.consensusState) ? $DM7bi.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $7iZIe.isSet)(object.proof) ? (0, $7iZIe.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $7iZIe.isSet)(object.proofHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $DM7bi.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $7iZIe.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $DM7bi.Any.fromPartial(object.consensusState) : undefined;
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        var _object_proof;
        message.proof = (_object_proof = object.proof) !== null && _object_proof !== void 0 ? _object_proof : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionParamsRequest() {
    return {};
}
$98853ff72821227c$exports.QueryConnectionParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionParamsRequest();
        return message;
    }
};
function $98853ff72821227c$var$createBaseQueryConnectionParamsResponse() {
    return {
        params: undefined
    };
}
$98853ff72821227c$exports.QueryConnectionParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $98853ff72821227c$var$_m0.Writer.create();
        if (message.params !== undefined) $a483577fa3a761ce$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $98853ff72821227c$var$_m0.Reader ? input : new $98853ff72821227c$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $98853ff72821227c$var$createBaseQueryConnectionParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $a483577fa3a761ce$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $a483577fa3a761ce$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $a483577fa3a761ce$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $98853ff72821227c$var$createBaseQueryConnectionParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $a483577fa3a761ce$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
var $98853ff72821227c$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
        this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Connection",
            value: function Connection(request) {
                var data = $98853ff72821227c$exports.QueryConnectionRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
                return promise.then(function(data) {
                    return $98853ff72821227c$exports.QueryConnectionResponse.decode(new $98853ff72821227c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Connections",
            value: function Connections() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $98853ff72821227c$exports.QueryConnectionsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
                return promise.then(function(data) {
                    return $98853ff72821227c$exports.QueryConnectionsResponse.decode(new $98853ff72821227c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ClientConnections",
            value: function ClientConnections(request) {
                var data = $98853ff72821227c$exports.QueryClientConnectionsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
                return promise.then(function(data) {
                    return $98853ff72821227c$exports.QueryClientConnectionsResponse.decode(new $98853ff72821227c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionClientState",
            value: function ConnectionClientState(request) {
                var data = $98853ff72821227c$exports.QueryConnectionClientStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
                return promise.then(function(data) {
                    return $98853ff72821227c$exports.QueryConnectionClientStateResponse.decode(new $98853ff72821227c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionConsensusState",
            value: function ConnectionConsensusState(request) {
                var data = $98853ff72821227c$exports.QueryConnectionConsensusStateRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
                return promise.then(function(data) {
                    return $98853ff72821227c$exports.QueryConnectionConsensusStateResponse.decode(new $98853ff72821227c$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ConnectionParams",
            value: function ConnectionParams() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $98853ff72821227c$exports.QueryConnectionParamsRequest.encode(request).finish();
                var promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", data);
                return promise.then(function(data) {
                    return $98853ff72821227c$exports.QueryConnectionParamsResponse.decode(new $98853ff72821227c$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$98853ff72821227c$exports.QueryClientImpl = $98853ff72821227c$var$QueryClientImpl;


var $b51681016f457115$exports = {};
"use strict";
var $b51681016f457115$var$__createBinding = $b51681016f457115$exports && $b51681016f457115$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b51681016f457115$var$__setModuleDefault = $b51681016f457115$exports && $b51681016f457115$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b51681016f457115$var$__importStar = $b51681016f457115$exports && $b51681016f457115$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b51681016f457115$var$__createBinding(result, mod, k);
    }
    $b51681016f457115$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b51681016f457115$exports, "__esModule", {
    value: true
});
$b51681016f457115$exports.Fraction = $b51681016f457115$exports.Header = $b51681016f457115$exports.Misbehaviour = $b51681016f457115$exports.ConsensusState = $b51681016f457115$exports.ClientState = $b51681016f457115$exports.protobufPackage = void 0;

var $i8V5u = parcelRequire("i8V5u");



var $ib0XJ = parcelRequire("ib0XJ");

var $5e6f0a13c00383a2$exports = {};
"use strict";
var $5e6f0a13c00383a2$var$__createBinding = $5e6f0a13c00383a2$exports && $5e6f0a13c00383a2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e6f0a13c00383a2$var$__setModuleDefault = $5e6f0a13c00383a2$exports && $5e6f0a13c00383a2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5e6f0a13c00383a2$var$__importStar = $5e6f0a13c00383a2$exports && $5e6f0a13c00383a2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5e6f0a13c00383a2$var$__createBinding(result, mod, k);
    }
    $5e6f0a13c00383a2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5e6f0a13c00383a2$exports, "__esModule", {
    value: true
});
$5e6f0a13c00383a2$exports.TxProof = $5e6f0a13c00383a2$exports.BlockMeta = $5e6f0a13c00383a2$exports.LightBlock = $5e6f0a13c00383a2$exports.SignedHeader = $5e6f0a13c00383a2$exports.Proposal = $5e6f0a13c00383a2$exports.CommitSig = $5e6f0a13c00383a2$exports.Commit = $5e6f0a13c00383a2$exports.Vote = $5e6f0a13c00383a2$exports.Data = $5e6f0a13c00383a2$exports.Header = $5e6f0a13c00383a2$exports.BlockID = $5e6f0a13c00383a2$exports.Part = $5e6f0a13c00383a2$exports.PartSetHeader = $5e6f0a13c00383a2$exports.signedMsgTypeToJSON = $5e6f0a13c00383a2$exports.signedMsgTypeFromJSON = $5e6f0a13c00383a2$exports.SignedMsgType = $5e6f0a13c00383a2$exports.blockIDFlagToJSON = $5e6f0a13c00383a2$exports.blockIDFlagFromJSON = $5e6f0a13c00383a2$exports.BlockIDFlag = $5e6f0a13c00383a2$exports.protobufPackage = void 0;
var $37dddc6d86f3a99e$exports = {};
"use strict";
var $37dddc6d86f3a99e$var$__createBinding = $37dddc6d86f3a99e$exports && $37dddc6d86f3a99e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $37dddc6d86f3a99e$var$__setModuleDefault = $37dddc6d86f3a99e$exports && $37dddc6d86f3a99e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $37dddc6d86f3a99e$var$__importStar = $37dddc6d86f3a99e$exports && $37dddc6d86f3a99e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $37dddc6d86f3a99e$var$__createBinding(result, mod, k);
    }
    $37dddc6d86f3a99e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($37dddc6d86f3a99e$exports, "__esModule", {
    value: true
});
$37dddc6d86f3a99e$exports.ProofOps = $37dddc6d86f3a99e$exports.ProofOp = $37dddc6d86f3a99e$exports.DominoOp = $37dddc6d86f3a99e$exports.ValueOp = $37dddc6d86f3a99e$exports.Proof = $37dddc6d86f3a99e$exports.protobufPackage = void 0;

var $7iZIe = parcelRequire("7iZIe");

var $37dddc6d86f3a99e$var$_m0 = $37dddc6d86f3a99e$var$__importStar((parcelRequire("hjb8Q")));
$37dddc6d86f3a99e$exports.protobufPackage = "tendermint.crypto";
function $37dddc6d86f3a99e$var$createBaseProof() {
    return {
        total: $7iZIe.Long.ZERO,
        index: $7iZIe.Long.ZERO,
        leafHash: new Uint8Array(),
        aunts: []
    };
}
$37dddc6d86f3a99e$exports.Proof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $37dddc6d86f3a99e$var$_m0.Writer.create();
        if (!message.total.isZero()) writer.uint32(8).int64(message.total);
        if (!message.index.isZero()) writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.aunts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(34).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $37dddc6d86f3a99e$var$_m0.Reader ? input : new $37dddc6d86f3a99e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $37dddc6d86f3a99e$var$createBaseProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            total: (0, $7iZIe.isSet)(object.total) ? $7iZIe.Long.fromValue(object.total) : $7iZIe.Long.ZERO,
            index: (0, $7iZIe.isSet)(object.index) ? $7iZIe.Long.fromValue(object.index) : $7iZIe.Long.ZERO,
            leafHash: (0, $7iZIe.isSet)(object.leafHash) ? (0, $7iZIe.bytesFromBase64)(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object === null || object === void 0 ? void 0 : object.aunts) ? object.aunts.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.total !== undefined && (obj.total = (message.total || $7iZIe.Long.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || $7iZIe.Long.ZERO).toString());
        message.leafHash !== undefined && (obj.leafHash = (0, $7iZIe.base64FromBytes)(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.aunts = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_aunts;
        var message = $37dddc6d86f3a99e$var$createBaseProof();
        message.total = object.total !== undefined && object.total !== null ? $7iZIe.Long.fromValue(object.total) : $7iZIe.Long.ZERO;
        message.index = object.index !== undefined && object.index !== null ? $7iZIe.Long.fromValue(object.index) : $7iZIe.Long.ZERO;
        var _object_leafHash;
        message.leafHash = (_object_leafHash = object.leafHash) !== null && _object_leafHash !== void 0 ? _object_leafHash : new Uint8Array();
        message.aunts = ((_object_aunts = object.aunts) === null || _object_aunts === void 0 ? void 0 : _object_aunts.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $37dddc6d86f3a99e$var$createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined
    };
}
$37dddc6d86f3a99e$exports.ValueOp = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $37dddc6d86f3a99e$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) $37dddc6d86f3a99e$exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $37dddc6d86f3a99e$var$_m0.Reader ? input : new $37dddc6d86f3a99e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $37dddc6d86f3a99e$var$createBaseValueOp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = $37dddc6d86f3a99e$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            proof: (0, $7iZIe.isSet)(object.proof) ? $37dddc6d86f3a99e$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $37dddc6d86f3a99e$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $37dddc6d86f3a99e$var$createBaseValueOp();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $37dddc6d86f3a99e$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $37dddc6d86f3a99e$var$createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: ""
    };
}
$37dddc6d86f3a99e$exports.DominoOp = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $37dddc6d86f3a99e$var$_m0.Writer.create();
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $37dddc6d86f3a99e$var$_m0.Reader ? input : new $37dddc6d86f3a99e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $37dddc6d86f3a99e$var$createBaseDominoOp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? String(object.key) : "",
            input: (0, $7iZIe.isSet)(object.input) ? String(object.input) : "",
            output: (0, $7iZIe.isSet)(object.output) ? String(object.output) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial: function(object) {
        var message = $37dddc6d86f3a99e$var$createBaseDominoOp();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : "";
        var _object_input;
        message.input = (_object_input = object.input) !== null && _object_input !== void 0 ? _object_input : "";
        var _object_output;
        message.output = (_object_output = object.output) !== null && _object_output !== void 0 ? _object_output : "";
        return message;
    }
};
function $37dddc6d86f3a99e$var$createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array()
    };
}
$37dddc6d86f3a99e$exports.ProofOp = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $37dddc6d86f3a99e$var$_m0.Writer.create();
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $37dddc6d86f3a99e$var$_m0.Reader ? input : new $37dddc6d86f3a99e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $37dddc6d86f3a99e$var$createBaseProofOp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type: (0, $7iZIe.isSet)(object.type) ? String(object.type) : "",
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $37dddc6d86f3a99e$var$createBaseProofOp();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : "";
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $37dddc6d86f3a99e$var$createBaseProofOps() {
    return {
        ops: []
    };
}
$37dddc6d86f3a99e$exports.ProofOps = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $37dddc6d86f3a99e$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.ops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $37dddc6d86f3a99e$exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $37dddc6d86f3a99e$var$_m0.Reader ? input : new $37dddc6d86f3a99e$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $37dddc6d86f3a99e$var$createBaseProofOps();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push($37dddc6d86f3a99e$exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            ops: Array.isArray(object === null || object === void 0 ? void 0 : object.ops) ? object.ops.map(function(e) {
                return $37dddc6d86f3a99e$exports.ProofOp.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.ops) obj.ops = message.ops.map(function(e) {
            return e ? $37dddc6d86f3a99e$exports.ProofOp.toJSON(e) : undefined;
        });
        else obj.ops = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_ops;
        var message = $37dddc6d86f3a99e$var$createBaseProofOps();
        message.ops = ((_object_ops = object.ops) === null || _object_ops === void 0 ? void 0 : _object_ops.map(function(e) {
            return $37dddc6d86f3a99e$exports.ProofOp.fromPartial(e);
        })) || [];
        return message;
    }
};


var $7248d640458d3da0$exports = {};
"use strict";
var $7248d640458d3da0$var$__createBinding = $7248d640458d3da0$exports && $7248d640458d3da0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7248d640458d3da0$var$__setModuleDefault = $7248d640458d3da0$exports && $7248d640458d3da0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7248d640458d3da0$var$__importStar = $7248d640458d3da0$exports && $7248d640458d3da0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7248d640458d3da0$var$__createBinding(result, mod, k);
    }
    $7248d640458d3da0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($7248d640458d3da0$exports, "__esModule", {
    value: true
});
$7248d640458d3da0$exports.Consensus = $7248d640458d3da0$exports.App = $7248d640458d3da0$exports.protobufPackage = void 0;

var $7iZIe = parcelRequire("7iZIe");

var $7248d640458d3da0$var$_m0 = $7248d640458d3da0$var$__importStar((parcelRequire("hjb8Q")));
$7248d640458d3da0$exports.protobufPackage = "tendermint.version";
function $7248d640458d3da0$var$createBaseApp() {
    return {
        protocol: $7iZIe.Long.UZERO,
        software: ""
    };
}
$7248d640458d3da0$exports.App = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7248d640458d3da0$var$_m0.Writer.create();
        if (!message.protocol.isZero()) writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7248d640458d3da0$var$_m0.Reader ? input : new $7248d640458d3da0$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7248d640458d3da0$var$createBaseApp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            protocol: (0, $7iZIe.isSet)(object.protocol) ? $7iZIe.Long.fromValue(object.protocol) : $7iZIe.Long.UZERO,
            software: (0, $7iZIe.isSet)(object.software) ? String(object.software) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || $7iZIe.Long.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial: function(object) {
        var message = $7248d640458d3da0$var$createBaseApp();
        message.protocol = object.protocol !== undefined && object.protocol !== null ? $7iZIe.Long.fromValue(object.protocol) : $7iZIe.Long.UZERO;
        var _object_software;
        message.software = (_object_software = object.software) !== null && _object_software !== void 0 ? _object_software : "";
        return message;
    }
};
function $7248d640458d3da0$var$createBaseConsensus() {
    return {
        block: $7iZIe.Long.UZERO,
        app: $7iZIe.Long.UZERO
    };
}
$7248d640458d3da0$exports.Consensus = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7248d640458d3da0$var$_m0.Writer.create();
        if (!message.block.isZero()) writer.uint32(8).uint64(message.block);
        if (!message.app.isZero()) writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $7248d640458d3da0$var$_m0.Reader ? input : new $7248d640458d3da0$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $7248d640458d3da0$var$createBaseConsensus();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            block: (0, $7iZIe.isSet)(object.block) ? $7iZIe.Long.fromValue(object.block) : $7iZIe.Long.UZERO,
            app: (0, $7iZIe.isSet)(object.app) ? $7iZIe.Long.fromValue(object.app) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.block !== undefined && (obj.block = (message.block || $7iZIe.Long.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $7248d640458d3da0$var$createBaseConsensus();
        message.block = object.block !== undefined && object.block !== null ? $7iZIe.Long.fromValue(object.block) : $7iZIe.Long.UZERO;
        message.app = object.app !== undefined && object.app !== null ? $7iZIe.Long.fromValue(object.app) : $7iZIe.Long.UZERO;
        return message;
    }
};



var $ib0XJ = parcelRequire("ib0XJ");
var $88f332d8924dbab6$exports = {};
"use strict";
var $88f332d8924dbab6$var$__createBinding = $88f332d8924dbab6$exports && $88f332d8924dbab6$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88f332d8924dbab6$var$__setModuleDefault = $88f332d8924dbab6$exports && $88f332d8924dbab6$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $88f332d8924dbab6$var$__importStar = $88f332d8924dbab6$exports && $88f332d8924dbab6$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $88f332d8924dbab6$var$__createBinding(result, mod, k);
    }
    $88f332d8924dbab6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($88f332d8924dbab6$exports, "__esModule", {
    value: true
});
$88f332d8924dbab6$exports.SimpleValidator = $88f332d8924dbab6$exports.Validator = $88f332d8924dbab6$exports.ValidatorSet = $88f332d8924dbab6$exports.protobufPackage = void 0;
var $d51814e7af8a1759$exports = {};
"use strict";
var $d51814e7af8a1759$var$__createBinding = $d51814e7af8a1759$exports && $d51814e7af8a1759$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d51814e7af8a1759$var$__setModuleDefault = $d51814e7af8a1759$exports && $d51814e7af8a1759$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d51814e7af8a1759$var$__importStar = $d51814e7af8a1759$exports && $d51814e7af8a1759$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d51814e7af8a1759$var$__createBinding(result, mod, k);
    }
    $d51814e7af8a1759$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($d51814e7af8a1759$exports, "__esModule", {
    value: true
});
$d51814e7af8a1759$exports.PublicKey = $d51814e7af8a1759$exports.protobufPackage = void 0;

/* eslint-disable */ var $d51814e7af8a1759$var$_m0 = $d51814e7af8a1759$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$d51814e7af8a1759$exports.protobufPackage = "tendermint.crypto";
function $d51814e7af8a1759$var$createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined
    };
}
$d51814e7af8a1759$exports.PublicKey = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d51814e7af8a1759$var$_m0.Writer.create();
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d51814e7af8a1759$var$_m0.Reader ? input : new $d51814e7af8a1759$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d51814e7af8a1759$var$createBasePublicKey();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            ed25519: (0, $7iZIe.isSet)(object.ed25519) ? (0, $7iZIe.bytesFromBase64)(object.ed25519) : undefined,
            secp256k1: (0, $7iZIe.isSet)(object.secp256k1) ? (0, $7iZIe.bytesFromBase64)(object.secp256k1) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? (0, $7iZIe.base64FromBytes)(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? (0, $7iZIe.base64FromBytes)(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $d51814e7af8a1759$var$createBasePublicKey();
        var _object_ed25519;
        message.ed25519 = (_object_ed25519 = object.ed25519) !== null && _object_ed25519 !== void 0 ? _object_ed25519 : undefined;
        var _object_secp256k1;
        message.secp256k1 = (_object_secp256k1 = object.secp256k1) !== null && _object_secp256k1 !== void 0 ? _object_secp256k1 : undefined;
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $88f332d8924dbab6$var$_m0 = $88f332d8924dbab6$var$__importStar((parcelRequire("hjb8Q")));
$88f332d8924dbab6$exports.protobufPackage = "tendermint.types";
function $88f332d8924dbab6$var$createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: $7iZIe.Long.ZERO
    };
}
$88f332d8924dbab6$exports.ValidatorSet = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $88f332d8924dbab6$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $88f332d8924dbab6$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.proposer !== undefined) $88f332d8924dbab6$exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $88f332d8924dbab6$var$_m0.Reader ? input : new $88f332d8924dbab6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $88f332d8924dbab6$var$createBaseValidatorSet();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($88f332d8924dbab6$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = $88f332d8924dbab6$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(function(e) {
                return $88f332d8924dbab6$exports.Validator.fromJSON(e);
            }) : [],
            proposer: (0, $7iZIe.isSet)(object.proposer) ? $88f332d8924dbab6$exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: (0, $7iZIe.isSet)(object.totalVotingPower) ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.validators) obj.validators = message.validators.map(function(e) {
            return e ? $88f332d8924dbab6$exports.Validator.toJSON(e) : undefined;
        });
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? $88f332d8924dbab6$exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_validators;
        var message = $88f332d8924dbab6$var$createBaseValidatorSet();
        message.validators = ((_object_validators = object.validators) === null || _object_validators === void 0 ? void 0 : _object_validators.map(function(e) {
            return $88f332d8924dbab6$exports.Validator.fromPartial(e);
        })) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? $88f332d8924dbab6$exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $88f332d8924dbab6$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: $7iZIe.Long.ZERO,
        proposerPriority: $7iZIe.Long.ZERO
    };
}
$88f332d8924dbab6$exports.Validator = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $88f332d8924dbab6$var$_m0.Writer.create();
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $d51814e7af8a1759$exports.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(24).int64(message.votingPower);
        if (!message.proposerPriority.isZero()) writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $88f332d8924dbab6$var$_m0.Reader ? input : new $88f332d8924dbab6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $88f332d8924dbab6$var$createBaseValidator();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $d51814e7af8a1759$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? (0, $7iZIe.bytesFromBase64)(object.address) : new Uint8Array(),
            pubKey: (0, $7iZIe.isSet)(object.pubKey) ? $d51814e7af8a1759$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $7iZIe.isSet)(object.votingPower) ? $7iZIe.Long.fromValue(object.votingPower) : $7iZIe.Long.ZERO,
            proposerPriority: (0, $7iZIe.isSet)(object.proposerPriority) ? $7iZIe.Long.fromValue(object.proposerPriority) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = (0, $7iZIe.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $d51814e7af8a1759$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $7iZIe.Long.ZERO).toString());
        message.proposerPriority !== undefined && (obj.proposerPriority = (message.proposerPriority || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $88f332d8924dbab6$var$createBaseValidator();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $d51814e7af8a1759$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $7iZIe.Long.fromValue(object.votingPower) : $7iZIe.Long.ZERO;
        message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? $7iZIe.Long.fromValue(object.proposerPriority) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $88f332d8924dbab6$var$createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: $7iZIe.Long.ZERO
    };
}
$88f332d8924dbab6$exports.SimpleValidator = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $88f332d8924dbab6$var$_m0.Writer.create();
        if (message.pubKey !== undefined) $d51814e7af8a1759$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $88f332d8924dbab6$var$_m0.Reader ? input : new $88f332d8924dbab6$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $88f332d8924dbab6$var$createBaseSimpleValidator();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $d51814e7af8a1759$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pubKey: (0, $7iZIe.isSet)(object.pubKey) ? $d51814e7af8a1759$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $7iZIe.isSet)(object.votingPower) ? $7iZIe.Long.fromValue(object.votingPower) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $d51814e7af8a1759$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $88f332d8924dbab6$var$createBaseSimpleValidator();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $d51814e7af8a1759$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $7iZIe.Long.fromValue(object.votingPower) : $7iZIe.Long.ZERO;
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $5e6f0a13c00383a2$var$_m0 = $5e6f0a13c00383a2$var$__importStar((parcelRequire("hjb8Q")));
$5e6f0a13c00383a2$exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $5e6f0a13c00383a2$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($5e6f0a13c00383a2$var$BlockIDFlag = $5e6f0a13c00383a2$exports.BlockIDFlag || ($5e6f0a13c00383a2$exports.BlockIDFlag = {}));
function $5e6f0a13c00383a2$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $5e6f0a13c00383a2$var$BlockIDFlag.UNRECOGNIZED;
    }
}
$5e6f0a13c00383a2$exports.blockIDFlagFromJSON = $5e6f0a13c00383a2$var$blockIDFlagFromJSON;
function $5e6f0a13c00383a2$var$blockIDFlagToJSON(object) {
    switch(object){
        case $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $5e6f0a13c00383a2$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        case $5e6f0a13c00383a2$var$BlockIDFlag.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$5e6f0a13c00383a2$exports.blockIDFlagToJSON = $5e6f0a13c00383a2$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $5e6f0a13c00383a2$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($5e6f0a13c00383a2$var$SignedMsgType = $5e6f0a13c00383a2$exports.SignedMsgType || ($5e6f0a13c00383a2$exports.SignedMsgType = {}));
function $5e6f0a13c00383a2$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $5e6f0a13c00383a2$var$SignedMsgType.UNRECOGNIZED;
    }
}
$5e6f0a13c00383a2$exports.signedMsgTypeFromJSON = $5e6f0a13c00383a2$var$signedMsgTypeFromJSON;
function $5e6f0a13c00383a2$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $5e6f0a13c00383a2$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        case $5e6f0a13c00383a2$var$SignedMsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$5e6f0a13c00383a2$exports.signedMsgTypeToJSON = $5e6f0a13c00383a2$var$signedMsgTypeToJSON;
function $5e6f0a13c00383a2$var$createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array()
    };
}
$5e6f0a13c00383a2$exports.PartSetHeader = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBasePartSetHeader();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            total: (0, $7iZIe.isSet)(object.total) ? Number(object.total) : 0,
            hash: (0, $7iZIe.isSet)(object.hash) ? (0, $7iZIe.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined && (obj.hash = (0, $7iZIe.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBasePartSetHeader();
        var _object_total;
        message.total = (_object_total = object.total) !== null && _object_total !== void 0 ? _object_total : 0;
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : new Uint8Array();
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined
    };
}
$5e6f0a13c00383a2$exports.Part = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $37dddc6d86f3a99e$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBasePart();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $37dddc6d86f3a99e$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            index: (0, $7iZIe.isSet)(object.index) ? Number(object.index) : 0,
            bytes: (0, $7iZIe.isSet)(object.bytes) ? (0, $7iZIe.bytesFromBase64)(object.bytes) : new Uint8Array(),
            proof: (0, $7iZIe.isSet)(object.proof) ? $37dddc6d86f3a99e$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined && (obj.bytes = (0, $7iZIe.base64FromBytes)(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $37dddc6d86f3a99e$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBasePart();
        var _object_index;
        message.index = (_object_index = object.index) !== null && _object_index !== void 0 ? _object_index : 0;
        var _object_bytes;
        message.bytes = (_object_bytes = object.bytes) !== null && _object_bytes !== void 0 ? _object_bytes : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $37dddc6d86f3a99e$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined
    };
}
$5e6f0a13c00383a2$exports.BlockID = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) $5e6f0a13c00383a2$exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseBlockID();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = $5e6f0a13c00383a2$exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? (0, $7iZIe.bytesFromBase64)(object.hash) : new Uint8Array(),
            partSetHeader: (0, $7iZIe.isSet)(object.partSetHeader) ? $5e6f0a13c00383a2$exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = (0, $7iZIe.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? $5e6f0a13c00383a2$exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseBlockID();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? $5e6f0a13c00383a2$exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: $7iZIe.Long.ZERO,
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$5e6f0a13c00383a2$exports.Header = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.version !== undefined) $7248d640458d3da0$exports.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $ib0XJ.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) $5e6f0a13c00383a2$exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseHeader();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $7248d640458d3da0$exports.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = $5e6f0a13c00383a2$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            version: (0, $7iZIe.isSet)(object.version) ? $7248d640458d3da0$exports.Consensus.fromJSON(object.version) : undefined,
            chainId: (0, $7iZIe.isSet)(object.chainId) ? String(object.chainId) : "",
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            time: (0, $7iZIe.isSet)(object.time) ? (0, $7iZIe.fromJsonTimestamp)(object.time) : undefined,
            lastBlockId: (0, $7iZIe.isSet)(object.lastBlockId) ? $5e6f0a13c00383a2$exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: (0, $7iZIe.isSet)(object.lastCommitHash) ? (0, $7iZIe.bytesFromBase64)(object.lastCommitHash) : new Uint8Array(),
            dataHash: (0, $7iZIe.isSet)(object.dataHash) ? (0, $7iZIe.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            validatorsHash: (0, $7iZIe.isSet)(object.validatorsHash) ? (0, $7iZIe.bytesFromBase64)(object.validatorsHash) : new Uint8Array(),
            nextValidatorsHash: (0, $7iZIe.isSet)(object.nextValidatorsHash) ? (0, $7iZIe.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            consensusHash: (0, $7iZIe.isSet)(object.consensusHash) ? (0, $7iZIe.bytesFromBase64)(object.consensusHash) : new Uint8Array(),
            appHash: (0, $7iZIe.isSet)(object.appHash) ? (0, $7iZIe.bytesFromBase64)(object.appHash) : new Uint8Array(),
            lastResultsHash: (0, $7iZIe.isSet)(object.lastResultsHash) ? (0, $7iZIe.bytesFromBase64)(object.lastResultsHash) : new Uint8Array(),
            evidenceHash: (0, $7iZIe.isSet)(object.evidenceHash) ? (0, $7iZIe.bytesFromBase64)(object.evidenceHash) : new Uint8Array(),
            proposerAddress: (0, $7iZIe.isSet)(object.proposerAddress) ? (0, $7iZIe.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.version !== undefined && (obj.version = message.version ? $7248d640458d3da0$exports.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $7iZIe.fromTimestamp)(message.time).toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? $5e6f0a13c00383a2$exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = (0, $7iZIe.base64FromBytes)(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = (0, $7iZIe.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = (0, $7iZIe.base64FromBytes)(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $7iZIe.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = (0, $7iZIe.base64FromBytes)(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = (0, $7iZIe.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = (0, $7iZIe.base64FromBytes)(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = (0, $7iZIe.base64FromBytes)(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $7iZIe.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseHeader();
        message.version = object.version !== undefined && object.version !== null ? $7248d640458d3da0$exports.Consensus.fromPartial(object.version) : undefined;
        var _object_chainId;
        message.chainId = (_object_chainId = object.chainId) !== null && _object_chainId !== void 0 ? _object_chainId : "";
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $ib0XJ.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? $5e6f0a13c00383a2$exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        var _object_lastCommitHash;
        message.lastCommitHash = (_object_lastCommitHash = object.lastCommitHash) !== null && _object_lastCommitHash !== void 0 ? _object_lastCommitHash : new Uint8Array();
        var _object_dataHash;
        message.dataHash = (_object_dataHash = object.dataHash) !== null && _object_dataHash !== void 0 ? _object_dataHash : new Uint8Array();
        var _object_validatorsHash;
        message.validatorsHash = (_object_validatorsHash = object.validatorsHash) !== null && _object_validatorsHash !== void 0 ? _object_validatorsHash : new Uint8Array();
        var _object_nextValidatorsHash;
        message.nextValidatorsHash = (_object_nextValidatorsHash = object.nextValidatorsHash) !== null && _object_nextValidatorsHash !== void 0 ? _object_nextValidatorsHash : new Uint8Array();
        var _object_consensusHash;
        message.consensusHash = (_object_consensusHash = object.consensusHash) !== null && _object_consensusHash !== void 0 ? _object_consensusHash : new Uint8Array();
        var _object_appHash;
        message.appHash = (_object_appHash = object.appHash) !== null && _object_appHash !== void 0 ? _object_appHash : new Uint8Array();
        var _object_lastResultsHash;
        message.lastResultsHash = (_object_lastResultsHash = object.lastResultsHash) !== null && _object_lastResultsHash !== void 0 ? _object_lastResultsHash : new Uint8Array();
        var _object_evidenceHash;
        message.evidenceHash = (_object_evidenceHash = object.evidenceHash) !== null && _object_evidenceHash !== void 0 ? _object_evidenceHash : new Uint8Array();
        var _object_proposerAddress;
        message.proposerAddress = (_object_proposerAddress = object.proposerAddress) !== null && _object_proposerAddress !== void 0 ? _object_proposerAddress : new Uint8Array();
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseData() {
    return {
        txs: []
    };
}
$5e6f0a13c00383a2$exports.Data = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseData();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.txs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs;
        var message = $5e6f0a13c00383a2$var$createBaseData();
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseVote() {
    return {
        type: 0,
        height: $7iZIe.Long.ZERO,
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array()
    };
}
$5e6f0a13c00383a2$exports.Vote = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) $5e6f0a13c00383a2$exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $ib0XJ.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = $5e6f0a13c00383a2$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type: (0, $7iZIe.isSet)(object.type) ? $5e6f0a13c00383a2$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            round: (0, $7iZIe.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $7iZIe.isSet)(object.blockId) ? $5e6f0a13c00383a2$exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? (0, $7iZIe.fromJsonTimestamp)(object.timestamp) : undefined,
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? (0, $7iZIe.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            validatorIndex: (0, $7iZIe.isSet)(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: (0, $7iZIe.isSet)(object.signature) ? (0, $7iZIe.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.type !== undefined && (obj.type = $5e6f0a13c00383a2$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $5e6f0a13c00383a2$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $7iZIe.fromTimestamp)(message.timestamp).toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $7iZIe.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined && (obj.signature = (0, $7iZIe.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseVote();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : 0;
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_round;
        message.round = (_object_round = object.round) !== null && _object_round !== void 0 ? _object_round : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $5e6f0a13c00383a2$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $ib0XJ.Timestamp.fromPartial(object.timestamp) : undefined;
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : new Uint8Array();
        var _object_validatorIndex;
        message.validatorIndex = (_object_validatorIndex = object.validatorIndex) !== null && _object_validatorIndex !== void 0 ? _object_validatorIndex : 0;
        var _object_signature;
        message.signature = (_object_signature = object.signature) !== null && _object_signature !== void 0 ? _object_signature : new Uint8Array();
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseCommit() {
    return {
        height: $7iZIe.Long.ZERO,
        round: 0,
        blockId: undefined,
        signatures: []
    };
}
$5e6f0a13c00383a2$exports.Commit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) $5e6f0a13c00383a2$exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5e6f0a13c00383a2$exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseCommit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = $5e6f0a13c00383a2$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push($5e6f0a13c00383a2$exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            round: (0, $7iZIe.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $7iZIe.isSet)(object.blockId) ? $5e6f0a13c00383a2$exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map(function(e) {
                return $5e6f0a13c00383a2$exports.CommitSig.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $5e6f0a13c00383a2$exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map(function(e) {
            return e ? $5e6f0a13c00383a2$exports.CommitSig.toJSON(e) : undefined;
        });
        else obj.signatures = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_signatures;
        var message = $5e6f0a13c00383a2$var$createBaseCommit();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_round;
        message.round = (_object_round = object.round) !== null && _object_round !== void 0 ? _object_round : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $5e6f0a13c00383a2$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = ((_object_signatures = object.signatures) === null || _object_signatures === void 0 ? void 0 : _object_signatures.map(function(e) {
            return $5e6f0a13c00383a2$exports.CommitSig.fromPartial(e);
        })) || [];
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
$5e6f0a13c00383a2$exports.CommitSig = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $ib0XJ.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseCommitSig();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            blockIdFlag: (0, $7iZIe.isSet)(object.blockIdFlag) ? $5e6f0a13c00383a2$var$blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? (0, $7iZIe.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? (0, $7iZIe.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $7iZIe.isSet)(object.signature) ? (0, $7iZIe.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $5e6f0a13c00383a2$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $7iZIe.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = (0, $7iZIe.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $7iZIe.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseCommitSig();
        var _object_blockIdFlag;
        message.blockIdFlag = (_object_blockIdFlag = object.blockIdFlag) !== null && _object_blockIdFlag !== void 0 ? _object_blockIdFlag : 0;
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : new Uint8Array();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $ib0XJ.Timestamp.fromPartial(object.timestamp) : undefined;
        var _object_signature;
        message.signature = (_object_signature = object.signature) !== null && _object_signature !== void 0 ? _object_signature : new Uint8Array();
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseProposal() {
    return {
        type: 0,
        height: $7iZIe.Long.ZERO,
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
$5e6f0a13c00383a2$exports.Proposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) $5e6f0a13c00383a2$exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $ib0XJ.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = $5e6f0a13c00383a2$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type: (0, $7iZIe.isSet)(object.type) ? $5e6f0a13c00383a2$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            round: (0, $7iZIe.isSet)(object.round) ? Number(object.round) : 0,
            polRound: (0, $7iZIe.isSet)(object.polRound) ? Number(object.polRound) : 0,
            blockId: (0, $7iZIe.isSet)(object.blockId) ? $5e6f0a13c00383a2$exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? (0, $7iZIe.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $7iZIe.isSet)(object.signature) ? (0, $7iZIe.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.type !== undefined && (obj.type = $5e6f0a13c00383a2$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $5e6f0a13c00383a2$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $7iZIe.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $7iZIe.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseProposal();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : 0;
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_round;
        message.round = (_object_round = object.round) !== null && _object_round !== void 0 ? _object_round : 0;
        var _object_polRound;
        message.polRound = (_object_polRound = object.polRound) !== null && _object_polRound !== void 0 ? _object_polRound : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $5e6f0a13c00383a2$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $ib0XJ.Timestamp.fromPartial(object.timestamp) : undefined;
        var _object_signature;
        message.signature = (_object_signature = object.signature) !== null && _object_signature !== void 0 ? _object_signature : new Uint8Array();
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined
    };
}
$5e6f0a13c00383a2$exports.SignedHeader = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.header !== undefined) $5e6f0a13c00383a2$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) $5e6f0a13c00383a2$exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseSignedHeader();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $5e6f0a13c00383a2$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = $5e6f0a13c00383a2$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            header: (0, $7iZIe.isSet)(object.header) ? $5e6f0a13c00383a2$exports.Header.fromJSON(object.header) : undefined,
            commit: (0, $7iZIe.isSet)(object.commit) ? $5e6f0a13c00383a2$exports.Commit.fromJSON(object.commit) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.header !== undefined && (obj.header = message.header ? $5e6f0a13c00383a2$exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $5e6f0a13c00383a2$exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseSignedHeader();
        message.header = object.header !== undefined && object.header !== null ? $5e6f0a13c00383a2$exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $5e6f0a13c00383a2$exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined
    };
}
$5e6f0a13c00383a2$exports.LightBlock = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.signedHeader !== undefined) $5e6f0a13c00383a2$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $88f332d8924dbab6$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseLightBlock();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $5e6f0a13c00383a2$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $88f332d8924dbab6$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            signedHeader: (0, $7iZIe.isSet)(object.signedHeader) ? $5e6f0a13c00383a2$exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $7iZIe.isSet)(object.validatorSet) ? $88f332d8924dbab6$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $5e6f0a13c00383a2$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $88f332d8924dbab6$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseLightBlock();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $5e6f0a13c00383a2$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $88f332d8924dbab6$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: $7iZIe.Long.ZERO,
        header: undefined,
        numTxs: $7iZIe.Long.ZERO
    };
}
$5e6f0a13c00383a2$exports.BlockMeta = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.blockId !== undefined) $5e6f0a13c00383a2$exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (!message.blockSize.isZero()) writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) $5e6f0a13c00383a2$exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (!message.numTxs.isZero()) writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseBlockMeta();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = $5e6f0a13c00383a2$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = $5e6f0a13c00383a2$exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            blockId: (0, $7iZIe.isSet)(object.blockId) ? $5e6f0a13c00383a2$exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: (0, $7iZIe.isSet)(object.blockSize) ? $7iZIe.Long.fromValue(object.blockSize) : $7iZIe.Long.ZERO,
            header: (0, $7iZIe.isSet)(object.header) ? $5e6f0a13c00383a2$exports.Header.fromJSON(object.header) : undefined,
            numTxs: (0, $7iZIe.isSet)(object.numTxs) ? $7iZIe.Long.fromValue(object.numTxs) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? $5e6f0a13c00383a2$exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || $7iZIe.Long.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? $5e6f0a13c00383a2$exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseBlockMeta();
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $5e6f0a13c00383a2$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? $7iZIe.Long.fromValue(object.blockSize) : $7iZIe.Long.ZERO;
        message.header = object.header !== undefined && object.header !== null ? $5e6f0a13c00383a2$exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? $7iZIe.Long.fromValue(object.numTxs) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $5e6f0a13c00383a2$var$createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined
    };
}
$5e6f0a13c00383a2$exports.TxProof = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5e6f0a13c00383a2$var$_m0.Writer.create();
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $37dddc6d86f3a99e$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $5e6f0a13c00383a2$var$_m0.Reader ? input : new $5e6f0a13c00383a2$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $5e6f0a13c00383a2$var$createBaseTxProof();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $37dddc6d86f3a99e$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rootHash: (0, $7iZIe.isSet)(object.rootHash) ? (0, $7iZIe.bytesFromBase64)(object.rootHash) : new Uint8Array(),
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            proof: (0, $7iZIe.isSet)(object.proof) ? $37dddc6d86f3a99e$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.rootHash !== undefined && (obj.rootHash = (0, $7iZIe.base64FromBytes)(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $37dddc6d86f3a99e$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $5e6f0a13c00383a2$var$createBaseTxProof();
        var _object_rootHash;
        message.rootHash = (_object_rootHash = object.rootHash) !== null && _object_rootHash !== void 0 ? _object_rootHash : new Uint8Array();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $37dddc6d86f3a99e$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};




var $7iZIe = parcelRequire("7iZIe");

var $b51681016f457115$var$_m0 = $b51681016f457115$var$__importStar((parcelRequire("hjb8Q")));
$b51681016f457115$exports.protobufPackage = "ibc.lightclients.tendermint.v1";
function $b51681016f457115$var$createBaseClientState() {
    return {
        chainId: "",
        trustLevel: undefined,
        trustingPeriod: undefined,
        unbondingPeriod: undefined,
        maxClockDrift: undefined,
        frozenHeight: undefined,
        latestHeight: undefined,
        proofSpecs: [],
        upgradePath: [],
        allowUpdateAfterExpiry: false,
        allowUpdateAfterMisbehaviour: false
    };
}
$b51681016f457115$exports.ClientState = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b51681016f457115$var$_m0.Writer.create();
        if (message.chainId !== "") writer.uint32(10).string(message.chainId);
        if (message.trustLevel !== undefined) $b51681016f457115$exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        if (message.trustingPeriod !== undefined) $i8V5u.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.unbondingPeriod !== undefined) $i8V5u.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        if (message.maxClockDrift !== undefined) $i8V5u.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        if (message.frozenHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        if (message.latestHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.proofSpecs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $3008c3192cf1fae6$exports.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.upgradePath[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                writer.uint32(74).string(v1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.allowUpdateAfterExpiry === true) writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        if (message.allowUpdateAfterMisbehaviour === true) writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b51681016f457115$var$_m0.Reader ? input : new $b51681016f457115$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b51681016f457115$var$createBaseClientState();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = $b51681016f457115$exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push($3008c3192cf1fae6$exports.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            chainId: (0, $7iZIe.isSet)(object.chainId) ? String(object.chainId) : "",
            trustLevel: (0, $7iZIe.isSet)(object.trustLevel) ? $b51681016f457115$exports.Fraction.fromJSON(object.trustLevel) : undefined,
            trustingPeriod: (0, $7iZIe.isSet)(object.trustingPeriod) ? $i8V5u.Duration.fromJSON(object.trustingPeriod) : undefined,
            unbondingPeriod: (0, $7iZIe.isSet)(object.unbondingPeriod) ? $i8V5u.Duration.fromJSON(object.unbondingPeriod) : undefined,
            maxClockDrift: (0, $7iZIe.isSet)(object.maxClockDrift) ? $i8V5u.Duration.fromJSON(object.maxClockDrift) : undefined,
            frozenHeight: (0, $7iZIe.isSet)(object.frozenHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.frozenHeight) : undefined,
            latestHeight: (0, $7iZIe.isSet)(object.latestHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.latestHeight) : undefined,
            proofSpecs: Array.isArray(object === null || object === void 0 ? void 0 : object.proofSpecs) ? object.proofSpecs.map(function(e) {
                return $3008c3192cf1fae6$exports.ProofSpec.fromJSON(e);
            }) : [],
            upgradePath: Array.isArray(object === null || object === void 0 ? void 0 : object.upgradePath) ? object.upgradePath.map(function(e) {
                return String(e);
            }) : [],
            allowUpdateAfterExpiry: (0, $7iZIe.isSet)(object.allowUpdateAfterExpiry) ? Boolean(object.allowUpdateAfterExpiry) : false,
            allowUpdateAfterMisbehaviour: (0, $7iZIe.isSet)(object.allowUpdateAfterMisbehaviour) ? Boolean(object.allowUpdateAfterMisbehaviour) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined && (obj.trustLevel = message.trustLevel ? $b51681016f457115$exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined && (obj.trustingPeriod = message.trustingPeriod ? $i8V5u.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod ? $i8V5u.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined && (obj.maxClockDrift = message.maxClockDrift ? $i8V5u.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined && (obj.frozenHeight = message.frozenHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) obj.proofSpecs = message.proofSpecs.map(function(e) {
            return e ? $3008c3192cf1fae6$exports.ProofSpec.toJSON(e) : undefined;
        });
        else obj.proofSpecs = [];
        if (message.upgradePath) obj.upgradePath = message.upgradePath.map(function(e) {
            return e;
        });
        else obj.upgradePath = [];
        message.allowUpdateAfterExpiry !== undefined && (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined && (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial: function(object) {
        var _object_proofSpecs, _object_upgradePath;
        var message = $b51681016f457115$var$createBaseClientState();
        var _object_chainId;
        message.chainId = (_object_chainId = object.chainId) !== null && _object_chainId !== void 0 ? _object_chainId : "";
        message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? $b51681016f457115$exports.Fraction.fromPartial(object.trustLevel) : undefined;
        message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? $i8V5u.Duration.fromPartial(object.trustingPeriod) : undefined;
        message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? $i8V5u.Duration.fromPartial(object.unbondingPeriod) : undefined;
        message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? $i8V5u.Duration.fromPartial(object.maxClockDrift) : undefined;
        message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.frozenHeight) : undefined;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.latestHeight) : undefined;
        message.proofSpecs = ((_object_proofSpecs = object.proofSpecs) === null || _object_proofSpecs === void 0 ? void 0 : _object_proofSpecs.map(function(e) {
            return $3008c3192cf1fae6$exports.ProofSpec.fromPartial(e);
        })) || [];
        message.upgradePath = ((_object_upgradePath = object.upgradePath) === null || _object_upgradePath === void 0 ? void 0 : _object_upgradePath.map(function(e) {
            return e;
        })) || [];
        var _object_allowUpdateAfterExpiry;
        message.allowUpdateAfterExpiry = (_object_allowUpdateAfterExpiry = object.allowUpdateAfterExpiry) !== null && _object_allowUpdateAfterExpiry !== void 0 ? _object_allowUpdateAfterExpiry : false;
        var _object_allowUpdateAfterMisbehaviour;
        message.allowUpdateAfterMisbehaviour = (_object_allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour) !== null && _object_allowUpdateAfterMisbehaviour !== void 0 ? _object_allowUpdateAfterMisbehaviour : false;
        return message;
    }
};
function $b51681016f457115$var$createBaseConsensusState() {
    return {
        timestamp: undefined,
        root: undefined,
        nextValidatorsHash: new Uint8Array()
    };
}
$b51681016f457115$exports.ConsensusState = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b51681016f457115$var$_m0.Writer.create();
        if (message.timestamp !== undefined) $ib0XJ.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        if (message.root !== undefined) $cb476feab4497b1e$exports.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(26).bytes(message.nextValidatorsHash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b51681016f457115$var$_m0.Reader ? input : new $b51681016f457115$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b51681016f457115$var$createBaseConsensusState();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestamp = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = $cb476feab4497b1e$exports.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? (0, $7iZIe.fromJsonTimestamp)(object.timestamp) : undefined,
            root: (0, $7iZIe.isSet)(object.root) ? $cb476feab4497b1e$exports.MerkleRoot.fromJSON(object.root) : undefined,
            nextValidatorsHash: (0, $7iZIe.isSet)(object.nextValidatorsHash) ? (0, $7iZIe.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.timestamp !== undefined && (obj.timestamp = (0, $7iZIe.fromTimestamp)(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? $cb476feab4497b1e$exports.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $7iZIe.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $b51681016f457115$var$createBaseConsensusState();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $ib0XJ.Timestamp.fromPartial(object.timestamp) : undefined;
        message.root = object.root !== undefined && object.root !== null ? $cb476feab4497b1e$exports.MerkleRoot.fromPartial(object.root) : undefined;
        var _object_nextValidatorsHash;
        message.nextValidatorsHash = (_object_nextValidatorsHash = object.nextValidatorsHash) !== null && _object_nextValidatorsHash !== void 0 ? _object_nextValidatorsHash : new Uint8Array();
        return message;
    }
};
function $b51681016f457115$var$createBaseMisbehaviour() {
    return {
        clientId: "",
        header1: undefined,
        header2: undefined
    };
}
$b51681016f457115$exports.Misbehaviour = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b51681016f457115$var$_m0.Writer.create();
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header1 !== undefined) $b51681016f457115$exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        if (message.header2 !== undefined) $b51681016f457115$exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b51681016f457115$var$_m0.Reader ? input : new $b51681016f457115$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b51681016f457115$var$createBaseMisbehaviour();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = $b51681016f457115$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = $b51681016f457115$exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            clientId: (0, $7iZIe.isSet)(object.clientId) ? String(object.clientId) : "",
            header1: (0, $7iZIe.isSet)(object.header1) ? $b51681016f457115$exports.Header.fromJSON(object.header1) : undefined,
            header2: (0, $7iZIe.isSet)(object.header2) ? $b51681016f457115$exports.Header.fromJSON(object.header2) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined && (obj.header1 = message.header1 ? $b51681016f457115$exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined && (obj.header2 = message.header2 ? $b51681016f457115$exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b51681016f457115$var$createBaseMisbehaviour();
        var _object_clientId;
        message.clientId = (_object_clientId = object.clientId) !== null && _object_clientId !== void 0 ? _object_clientId : "";
        message.header1 = object.header1 !== undefined && object.header1 !== null ? $b51681016f457115$exports.Header.fromPartial(object.header1) : undefined;
        message.header2 = object.header2 !== undefined && object.header2 !== null ? $b51681016f457115$exports.Header.fromPartial(object.header2) : undefined;
        return message;
    }
};
function $b51681016f457115$var$createBaseHeader() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
        trustedHeight: undefined,
        trustedValidators: undefined
    };
}
$b51681016f457115$exports.Header = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b51681016f457115$var$_m0.Writer.create();
        if (message.signedHeader !== undefined) $5e6f0a13c00383a2$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $88f332d8924dbab6$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        if (message.trustedHeight !== undefined) $a483577fa3a761ce$exports.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        if (message.trustedValidators !== undefined) $88f332d8924dbab6$exports.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b51681016f457115$var$_m0.Reader ? input : new $b51681016f457115$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b51681016f457115$var$createBaseHeader();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $5e6f0a13c00383a2$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $88f332d8924dbab6$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = $a483577fa3a761ce$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = $88f332d8924dbab6$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            signedHeader: (0, $7iZIe.isSet)(object.signedHeader) ? $5e6f0a13c00383a2$exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $7iZIe.isSet)(object.validatorSet) ? $88f332d8924dbab6$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined,
            trustedHeight: (0, $7iZIe.isSet)(object.trustedHeight) ? $a483577fa3a761ce$exports.Height.fromJSON(object.trustedHeight) : undefined,
            trustedValidators: (0, $7iZIe.isSet)(object.trustedValidators) ? $88f332d8924dbab6$exports.ValidatorSet.fromJSON(object.trustedValidators) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $5e6f0a13c00383a2$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $88f332d8924dbab6$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined && (obj.trustedHeight = message.trustedHeight ? $a483577fa3a761ce$exports.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined && (obj.trustedValidators = message.trustedValidators ? $88f332d8924dbab6$exports.ValidatorSet.toJSON(message.trustedValidators) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b51681016f457115$var$createBaseHeader();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $5e6f0a13c00383a2$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $88f332d8924dbab6$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? $a483577fa3a761ce$exports.Height.fromPartial(object.trustedHeight) : undefined;
        message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? $88f332d8924dbab6$exports.ValidatorSet.fromPartial(object.trustedValidators) : undefined;
        return message;
    }
};
function $b51681016f457115$var$createBaseFraction() {
    return {
        numerator: $7iZIe.Long.UZERO,
        denominator: $7iZIe.Long.UZERO
    };
}
$b51681016f457115$exports.Fraction = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b51681016f457115$var$_m0.Writer.create();
        if (!message.numerator.isZero()) writer.uint32(8).uint64(message.numerator);
        if (!message.denominator.isZero()) writer.uint32(16).uint64(message.denominator);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b51681016f457115$var$_m0.Reader ? input : new $b51681016f457115$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b51681016f457115$var$createBaseFraction();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            numerator: (0, $7iZIe.isSet)(object.numerator) ? $7iZIe.Long.fromValue(object.numerator) : $7iZIe.Long.UZERO,
            denominator: (0, $7iZIe.isSet)(object.denominator) ? $7iZIe.Long.fromValue(object.denominator) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || $7iZIe.Long.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $b51681016f457115$var$createBaseFraction();
        message.numerator = object.numerator !== undefined && object.numerator !== null ? $7iZIe.Long.fromValue(object.numerator) : $7iZIe.Long.UZERO;
        message.denominator = object.denominator !== undefined && object.denominator !== null ? $7iZIe.Long.fromValue(object.denominator) : $7iZIe.Long.UZERO;
        return message;
    }
};



var $5a8dcc95af53b014$var$long_1 = $5a8dcc95af53b014$var$__importDefault((parcelRequire("l6G6L")));

function $5a8dcc95af53b014$var$decodeTendermintClientStateAny(clientState) {
    if ((clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl) !== "/ibc.lightclients.tendermint.v1.ClientState") throw new Error("Unexpected client state type: ".concat(clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl));
    return $b51681016f457115$exports.ClientState.decode(clientState.value);
}
function $5a8dcc95af53b014$var$decodeTendermintConsensusStateAny(clientState) {
    if ((clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl) !== "/ibc.lightclients.tendermint.v1.ConsensusState") throw new Error("Unexpected client state type: ".concat(clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl));
    return $b51681016f457115$exports.ConsensusState.decode(clientState.value);
}
function $5a8dcc95af53b014$var$setupIbcExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    var channelQueryService = new $661af8b6a74dcaa1$exports.QueryClientImpl(rpc);
    var clientQueryService = new $67f921b5dc14f281$exports.QueryClientImpl(rpc);
    var connectionQueryService = new $98853ff72821227c$exports.QueryClientImpl(rpc);
    var transferQueryService = new $b3a5fd852d526a0b$exports.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.Channel({
                                    portId: portId,
                                    channelId: channelId
                                })
                            ];
                        });
                    });
                    return function(portId, channelId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                channels: function() {
                    var _ref = (0, $6rBFC._)(function(paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.Channels({
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allChannels: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    var channels, response, key, _channels, _response_pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                channels = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    channelQueryService.Channels({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_channels = channels).push.apply(_channels, (0, $gF0bR._)(response.channels));
                                key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if (key && key.length) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        channels: channels,
                                        height: response.height
                                    }
                                ];
                        }
                    });
                }),
                connectionChannels: function() {
                    var _ref = (0, $6rBFC._)(function(connection, paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.ConnectionChannels({
                                    connection: connection,
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(connection, paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allConnectionChannels: function() {
                    var _ref = (0, $6rBFC._)(function(connection) {
                        var channels, response, key, _channels, _response_pagination;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    channels = [];
                                    _state.label = 1;
                                case 1:
                                    return [
                                        4,
                                        channelQueryService.ConnectionChannels({
                                            connection: connection,
                                            pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    (_channels = channels).push.apply(_channels, (0, $gF0bR._)(response.channels));
                                    key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                    _state.label = 3;
                                case 3:
                                    if (key && key.length) return [
                                        3,
                                        1
                                    ];
                                    _state.label = 4;
                                case 4:
                                    return [
                                        2,
                                        {
                                            channels: channels,
                                            height: response.height
                                        }
                                    ];
                            }
                        });
                    });
                    return function(connection) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                clientState: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.ChannelClientState({
                                    portId: portId,
                                    channelId: channelId
                                })
                            ];
                        });
                    });
                    return function(portId, channelId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                consensusState: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, revisionNumber, revisionHeight) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.ChannelConsensusState({
                                    portId: portId,
                                    channelId: channelId,
                                    revisionNumber: $5a8dcc95af53b014$var$long_1.default.fromNumber(revisionNumber, true),
                                    revisionHeight: $5a8dcc95af53b014$var$long_1.default.fromNumber(revisionHeight, true)
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, revisionNumber, revisionHeight) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                packetCommitment: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, sequence) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.PacketCommitment({
                                    portId: portId,
                                    channelId: channelId,
                                    sequence: $5a8dcc95af53b014$var$long_1.default.fromNumber(sequence, true)
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, sequence) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                packetCommitments: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.PacketCommitments({
                                    channelId: channelId,
                                    portId: portId,
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allPacketCommitments: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId) {
                        var commitments, response, key, _commitments, _response_pagination;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    commitments = [];
                                    _state.label = 1;
                                case 1:
                                    return [
                                        4,
                                        channelQueryService.PacketCommitments({
                                            channelId: channelId,
                                            portId: portId,
                                            pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    (_commitments = commitments).push.apply(_commitments, (0, $gF0bR._)(response.commitments));
                                    key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                    _state.label = 3;
                                case 3:
                                    if (key && key.length) return [
                                        3,
                                        1
                                    ];
                                    _state.label = 4;
                                case 4:
                                    return [
                                        2,
                                        {
                                            commitments: commitments,
                                            height: response.height
                                        }
                                    ];
                            }
                        });
                    });
                    return function(portId, channelId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                packetReceipt: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, sequence) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.PacketReceipt({
                                    portId: portId,
                                    channelId: channelId,
                                    sequence: $5a8dcc95af53b014$var$long_1.default.fromNumber(sequence, true)
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, sequence) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                packetAcknowledgement: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, sequence) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.PacketAcknowledgement({
                                    portId: portId,
                                    channelId: channelId,
                                    sequence: $5a8dcc95af53b014$var$long_1.default.fromNumber(sequence, true)
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, sequence) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                packetAcknowledgements: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, paginationKey) {
                        var request;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            request = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsRequest.fromPartial({
                                portId: portId,
                                channelId: channelId,
                                pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                            });
                            return [
                                2,
                                channelQueryService.PacketAcknowledgements(request)
                            ];
                        });
                    });
                    return function(portId, channelId, paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allPacketAcknowledgements: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId) {
                        var acknowledgements, response, key, _acknowledgements, _response_pagination, request;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    acknowledgements = [];
                                    _state.label = 1;
                                case 1:
                                    request = $661af8b6a74dcaa1$exports.QueryPacketAcknowledgementsRequest.fromPartial({
                                        channelId: channelId,
                                        portId: portId,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                    });
                                    return [
                                        4,
                                        channelQueryService.PacketAcknowledgements(request)
                                    ];
                                case 2:
                                    response = _state.sent();
                                    (_acknowledgements = acknowledgements).push.apply(_acknowledgements, (0, $gF0bR._)(response.acknowledgements));
                                    key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                    _state.label = 3;
                                case 3:
                                    if (key && key.length) return [
                                        3,
                                        1
                                    ];
                                    _state.label = 4;
                                case 4:
                                    return [
                                        2,
                                        {
                                            acknowledgements: acknowledgements,
                                            height: response.height
                                        }
                                    ];
                            }
                        });
                    });
                    return function(portId, channelId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                unreceivedPackets: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, packetCommitmentSequences) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.UnreceivedPackets({
                                    portId: portId,
                                    channelId: channelId,
                                    packetCommitmentSequences: packetCommitmentSequences.map(function(s) {
                                        return $5a8dcc95af53b014$var$long_1.default.fromNumber(s, true);
                                    })
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, packetCommitmentSequences) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                unreceivedAcks: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId, packetAckSequences) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.UnreceivedAcks({
                                    portId: portId,
                                    channelId: channelId,
                                    packetAckSequences: packetAckSequences.map(function(s) {
                                        return $5a8dcc95af53b014$var$long_1.default.fromNumber(s, true);
                                    })
                                })
                            ];
                        });
                    });
                    return function(portId, channelId, packetAckSequences) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                nextSequenceReceive: function() {
                    var _ref = (0, $6rBFC._)(function(portId, channelId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                channelQueryService.NextSequenceReceive({
                                    portId: portId,
                                    channelId: channelId
                                })
                            ];
                        });
                    });
                    return function(portId, channelId) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            client: {
                state: function() {
                    var _ref = (0, $6rBFC._)(function(clientId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                clientQueryService.ClientState({
                                    clientId: clientId
                                })
                            ];
                        });
                    });
                    return function(clientId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                states: function() {
                    var _ref = (0, $6rBFC._)(function(paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                clientQueryService.ClientStates({
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allStates: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    var clientStates, response, key, _clientStates, _response_pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                clientStates = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    clientQueryService.ClientStates({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_clientStates = clientStates).push.apply(_clientStates, (0, $gF0bR._)(response.clientStates));
                                key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if (key && key.length) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        clientStates: clientStates
                                    }
                                ];
                        }
                    });
                }),
                consensusState: function() {
                    var _ref = (0, $6rBFC._)(function(clientId, consensusHeight) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                clientQueryService.ConsensusState($67f921b5dc14f281$exports.QueryConsensusStateRequest.fromPartial({
                                    clientId: clientId,
                                    revisionHeight: consensusHeight !== undefined ? $5a8dcc95af53b014$var$long_1.default.fromNumber(consensusHeight, true) : undefined,
                                    latestHeight: consensusHeight === undefined
                                }))
                            ];
                        });
                    });
                    return function(clientId, consensusHeight) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                consensusStates: function() {
                    var _ref = (0, $6rBFC._)(function(clientId, paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                clientQueryService.ConsensusStates({
                                    clientId: clientId,
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(clientId, paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allConsensusStates: function() {
                    var _ref = (0, $6rBFC._)(function(clientId) {
                        var consensusStates, response, key, _consensusStates, _response_pagination;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    consensusStates = [];
                                    _state.label = 1;
                                case 1:
                                    return [
                                        4,
                                        clientQueryService.ConsensusStates({
                                            clientId: clientId,
                                            pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    (_consensusStates = consensusStates).push.apply(_consensusStates, (0, $gF0bR._)(response.consensusStates));
                                    key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                    _state.label = 3;
                                case 3:
                                    if (key && key.length) return [
                                        3,
                                        1
                                    ];
                                    _state.label = 4;
                                case 4:
                                    return [
                                        2,
                                        {
                                            consensusStates: consensusStates
                                        }
                                    ];
                            }
                        });
                    });
                    return function(clientId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                params: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            clientQueryService.ClientParams({})
                        ];
                    });
                }),
                stateTm: function() {
                    var _ref = (0, $6rBFC._)(function(clientId) {
                        var response;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        clientQueryService.ClientState({
                                            clientId: clientId
                                        })
                                    ];
                                case 1:
                                    response = _state.sent();
                                    return [
                                        2,
                                        $5a8dcc95af53b014$var$decodeTendermintClientStateAny(response.clientState)
                                    ];
                            }
                        });
                    });
                    return function(clientId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                statesTm: function() {
                    var _ref = (0, $6rBFC._)(function(paginationKey) {
                        var clientStates;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        clientQueryService.ClientStates({
                                            pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                        })
                                    ];
                                case 1:
                                    clientStates = _state.sent().clientStates;
                                    return [
                                        2,
                                        clientStates.map(function(param) {
                                            var clientState = param.clientState;
                                            return $5a8dcc95af53b014$var$decodeTendermintClientStateAny(clientState);
                                        })
                                    ];
                            }
                        });
                    });
                    return function(paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allStatesTm: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    var clientStates, response, key, _clientStates, _response_pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                clientStates = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    clientQueryService.ClientStates({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_clientStates = clientStates).push.apply(_clientStates, (0, $gF0bR._)(response.clientStates));
                                key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if (key && key.length) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    clientStates.map(function(param) {
                                        var clientState = param.clientState;
                                        return $5a8dcc95af53b014$var$decodeTendermintClientStateAny(clientState);
                                    })
                                ];
                        }
                    });
                }),
                consensusStateTm: function() {
                    var _ref = (0, $6rBFC._)(function(clientId, consensusHeight) {
                        var response;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        clientQueryService.ConsensusState($67f921b5dc14f281$exports.QueryConsensusStateRequest.fromPartial({
                                            clientId: clientId,
                                            revisionHeight: consensusHeight === null || consensusHeight === void 0 ? void 0 : consensusHeight.revisionHeight,
                                            revisionNumber: consensusHeight === null || consensusHeight === void 0 ? void 0 : consensusHeight.revisionNumber,
                                            latestHeight: consensusHeight === undefined
                                        }))
                                    ];
                                case 1:
                                    response = _state.sent();
                                    return [
                                        2,
                                        $5a8dcc95af53b014$var$decodeTendermintConsensusStateAny(response.consensusState)
                                    ];
                            }
                        });
                    });
                    return function(clientId, consensusHeight) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            connection: {
                connection: function() {
                    var _ref = (0, $6rBFC._)(function(connectionId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                connectionQueryService.Connection({
                                    connectionId: connectionId
                                })
                            ];
                        });
                    });
                    return function(connectionId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                connections: function() {
                    var _ref = (0, $6rBFC._)(function(paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                connectionQueryService.Connections({
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allConnections: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    var connections, response, key, _connections, _response_pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                connections = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    connectionQueryService.Connections({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_connections = connections).push.apply(_connections, (0, $gF0bR._)(response.connections));
                                key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if (key && key.length) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        connections: connections,
                                        height: response.height
                                    }
                                ];
                        }
                    });
                }),
                clientConnections: function() {
                    var _ref = (0, $6rBFC._)(function(clientId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                connectionQueryService.ClientConnections({
                                    clientId: clientId
                                })
                            ];
                        });
                    });
                    return function(clientId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                clientState: function() {
                    var _ref = (0, $6rBFC._)(function(connectionId) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                connectionQueryService.ConnectionClientState({
                                    connectionId: connectionId
                                })
                            ];
                        });
                    });
                    return function(connectionId) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                consensusState: function() {
                    var _ref = (0, $6rBFC._)(function(connectionId, revisionHeight) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                connectionQueryService.ConnectionConsensusState($98853ff72821227c$exports.QueryConnectionConsensusStateRequest.fromPartial({
                                    connectionId: connectionId,
                                    revisionHeight: $5a8dcc95af53b014$var$long_1.default.fromNumber(revisionHeight, true)
                                }))
                            ];
                        });
                    });
                    return function(connectionId, revisionHeight) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            transfer: {
                denomTrace: function() {
                    var _ref = (0, $6rBFC._)(function(hash) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                transferQueryService.DenomTrace({
                                    hash: hash
                                })
                            ];
                        });
                    });
                    return function(hash) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                denomTraces: function() {
                    var _ref = (0, $6rBFC._)(function(paginationKey) {
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            return [
                                2,
                                transferQueryService.DenomTraces({
                                    pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                })
                            ];
                        });
                    });
                    return function(paginationKey) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                allDenomTraces: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    var denomTraces, response, key, _denomTraces, _response_pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                denomTraces = [];
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    transferQueryService.DenomTraces({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(key)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (_denomTraces = denomTraces).push.apply(_denomTraces, (0, $gF0bR._)(response.denomTraces));
                                key = (_response_pagination = response.pagination) === null || _response_pagination === void 0 ? void 0 : _response_pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if (key && key.length) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        denomTraces: denomTraces
                                    }
                                ];
                        }
                    });
                }),
                params: /*#__PURE__*/ (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            transferQueryService.Params({})
                        ];
                    });
                })
            },
            verified: {
                channel: {
                    channel: function() {
                        var _ref = (0, $6rBFC._)(function(portId, channelId) {
                            var key, value;
                            return (0, $6qu4b.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                                        key = (0, $lSA9E.toAscii)("channelEnds/ports/".concat(portId, "/channels/").concat(channelId));
                                        return [
                                            4,
                                            base.queryStoreVerified("ibc", key)
                                        ];
                                    case 1:
                                        value = _state.sent().value;
                                        return [
                                            2,
                                            value.length ? $988a66f9b5875dc5$exports.Channel.decode(value) : null
                                        ];
                                }
                            });
                        });
                        return function(portId, channelId) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    packetCommitment: function() {
                        var _ref = (0, $6rBFC._)(function(portId, channelId, sequence) {
                            var key, value;
                            return (0, $6qu4b.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                                        key = (0, $lSA9E.toAscii)("commitments/ports/".concat(portId, "/channels/").concat(channelId, "/packets/").concat(sequence));
                                        return [
                                            4,
                                            base.queryStoreVerified("ibc", key)
                                        ];
                                    case 1:
                                        value = _state.sent().value;
                                        // keeper code doesn't parse, but returns raw
                                        return [
                                            2,
                                            value
                                        ];
                                }
                            });
                        });
                        return function(portId, channelId, sequence) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    packetAcknowledgement: function() {
                        var _ref = (0, $6rBFC._)(function(portId, channelId, sequence) {
                            var key, value;
                            return (0, $6qu4b.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                                        key = (0, $lSA9E.toAscii)("acks/ports/".concat(portId, "/channels/").concat(channelId, "/acknowledgements/").concat(sequence));
                                        return [
                                            4,
                                            base.queryStoreVerified("ibc", key)
                                        ];
                                    case 1:
                                        value = _state.sent().value;
                                        // keeper code doesn't parse, but returns raw
                                        return [
                                            2,
                                            value
                                        ];
                                }
                            });
                        });
                        return function(portId, channelId, sequence) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    nextSequenceReceive: function() {
                        var _ref = (0, $6rBFC._)(function(portId, channelId) {
                            var key, value;
                            return (0, $6qu4b.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                                        key = (0, $lSA9E.toAscii)("seqAcks/ports/".concat(portId, "/channels/").concat(channelId, "/nextSequenceAck"));
                                        return [
                                            4,
                                            base.queryStoreVerified("ibc", key)
                                        ];
                                    case 1:
                                        value = _state.sent().value;
                                        return [
                                            2,
                                            value.length ? $kTbgy.Uint64.fromBytes(value).toNumber() : null
                                        ];
                                }
                            });
                        });
                        return function(portId, channelId) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                }
            }
        }
    };
}
$5a8dcc95af53b014$exports.setupIbcExtension = $5a8dcc95af53b014$var$setupIbcExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupIbcExtension", {
    enumerable: true,
    get: function get() {
        return $5a8dcc95af53b014$exports.setupIbcExtension;
    }
});
var $af080a401fbaeadb$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($af080a401fbaeadb$exports, "__esModule", {
    value: true
});
$af080a401fbaeadb$exports.setupMintExtension = void 0;

var $gMk5u = parcelRequire("gMk5u");
var $b9099bdd297b7dec$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $b9099bdd297b7dec$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b9099bdd297b7dec$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b9099bdd297b7dec$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b9099bdd297b7dec$var$__createBinding(result, mod, k);
    }
    $b9099bdd297b7dec$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b9099bdd297b7dec$exports, "__esModule", {
    value: true
});
$b9099bdd297b7dec$exports.QueryClientImpl = $b9099bdd297b7dec$exports.QueryAnnualProvisionsResponse = $b9099bdd297b7dec$exports.QueryAnnualProvisionsRequest = $b9099bdd297b7dec$exports.QueryInflationResponse = $b9099bdd297b7dec$exports.QueryInflationRequest = $b9099bdd297b7dec$exports.QueryParamsResponse = $b9099bdd297b7dec$exports.QueryParamsRequest = $b9099bdd297b7dec$exports.protobufPackage = void 0;
var $cca94bf0bfed7580$exports = {};
"use strict";
var $cca94bf0bfed7580$var$__createBinding = $cca94bf0bfed7580$exports && $cca94bf0bfed7580$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cca94bf0bfed7580$var$__setModuleDefault = $cca94bf0bfed7580$exports && $cca94bf0bfed7580$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cca94bf0bfed7580$var$__importStar = $cca94bf0bfed7580$exports && $cca94bf0bfed7580$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cca94bf0bfed7580$var$__createBinding(result, mod, k);
    }
    $cca94bf0bfed7580$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cca94bf0bfed7580$exports, "__esModule", {
    value: true
});
$cca94bf0bfed7580$exports.Params = $cca94bf0bfed7580$exports.Minter = $cca94bf0bfed7580$exports.protobufPackage = void 0;

var $7iZIe = parcelRequire("7iZIe");

var $cca94bf0bfed7580$var$_m0 = $cca94bf0bfed7580$var$__importStar((parcelRequire("hjb8Q")));
$cca94bf0bfed7580$exports.protobufPackage = "cosmos.mint.v1beta1";
function $cca94bf0bfed7580$var$createBaseMinter() {
    return {
        inflation: "",
        annualProvisions: ""
    };
}
$cca94bf0bfed7580$exports.Minter = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cca94bf0bfed7580$var$_m0.Writer.create();
        if (message.inflation !== "") writer.uint32(10).string(message.inflation);
        if (message.annualProvisions !== "") writer.uint32(18).string(message.annualProvisions);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $cca94bf0bfed7580$var$_m0.Reader ? input : new $cca94bf0bfed7580$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $cca94bf0bfed7580$var$createBaseMinter();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            inflation: (0, $7iZIe.isSet)(object.inflation) ? String(object.inflation) : "",
            annualProvisions: (0, $7iZIe.isSet)(object.annualProvisions) ? String(object.annualProvisions) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial: function(object) {
        var message = $cca94bf0bfed7580$var$createBaseMinter();
        var _object_inflation;
        message.inflation = (_object_inflation = object.inflation) !== null && _object_inflation !== void 0 ? _object_inflation : "";
        var _object_annualProvisions;
        message.annualProvisions = (_object_annualProvisions = object.annualProvisions) !== null && _object_annualProvisions !== void 0 ? _object_annualProvisions : "";
        return message;
    }
};
function $cca94bf0bfed7580$var$createBaseParams() {
    return {
        mintDenom: "",
        inflationRateChange: "",
        inflationMax: "",
        inflationMin: "",
        goalBonded: "",
        blocksPerYear: $7iZIe.Long.UZERO
    };
}
$cca94bf0bfed7580$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cca94bf0bfed7580$var$_m0.Writer.create();
        if (message.mintDenom !== "") writer.uint32(10).string(message.mintDenom);
        if (message.inflationRateChange !== "") writer.uint32(18).string(message.inflationRateChange);
        if (message.inflationMax !== "") writer.uint32(26).string(message.inflationMax);
        if (message.inflationMin !== "") writer.uint32(34).string(message.inflationMin);
        if (message.goalBonded !== "") writer.uint32(42).string(message.goalBonded);
        if (!message.blocksPerYear.isZero()) writer.uint32(48).uint64(message.blocksPerYear);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $cca94bf0bfed7580$var$_m0.Reader ? input : new $cca94bf0bfed7580$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $cca94bf0bfed7580$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            mintDenom: (0, $7iZIe.isSet)(object.mintDenom) ? String(object.mintDenom) : "",
            inflationRateChange: (0, $7iZIe.isSet)(object.inflationRateChange) ? String(object.inflationRateChange) : "",
            inflationMax: (0, $7iZIe.isSet)(object.inflationMax) ? String(object.inflationMax) : "",
            inflationMin: (0, $7iZIe.isSet)(object.inflationMin) ? String(object.inflationMin) : "",
            goalBonded: (0, $7iZIe.isSet)(object.goalBonded) ? String(object.goalBonded) : "",
            blocksPerYear: (0, $7iZIe.isSet)(object.blocksPerYear) ? $7iZIe.Long.fromValue(object.blocksPerYear) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined && (obj.blocksPerYear = (message.blocksPerYear || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $cca94bf0bfed7580$var$createBaseParams();
        var _object_mintDenom;
        message.mintDenom = (_object_mintDenom = object.mintDenom) !== null && _object_mintDenom !== void 0 ? _object_mintDenom : "";
        var _object_inflationRateChange;
        message.inflationRateChange = (_object_inflationRateChange = object.inflationRateChange) !== null && _object_inflationRateChange !== void 0 ? _object_inflationRateChange : "";
        var _object_inflationMax;
        message.inflationMax = (_object_inflationMax = object.inflationMax) !== null && _object_inflationMax !== void 0 ? _object_inflationMax : "";
        var _object_inflationMin;
        message.inflationMin = (_object_inflationMin = object.inflationMin) !== null && _object_inflationMin !== void 0 ? _object_inflationMin : "";
        var _object_goalBonded;
        message.goalBonded = (_object_goalBonded = object.goalBonded) !== null && _object_goalBonded !== void 0 ? _object_goalBonded : "";
        message.blocksPerYear = object.blocksPerYear !== undefined && object.blocksPerYear !== null ? $7iZIe.Long.fromValue(object.blocksPerYear) : $7iZIe.Long.UZERO;
        return message;
    }
};



var $b9099bdd297b7dec$var$_m0 = $b9099bdd297b7dec$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$b9099bdd297b7dec$exports.protobufPackage = "cosmos.mint.v1beta1";
function $b9099bdd297b7dec$var$createBaseQueryParamsRequest() {
    return {};
}
$b9099bdd297b7dec$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b9099bdd297b7dec$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9099bdd297b7dec$var$_m0.Reader ? input : new $b9099bdd297b7dec$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9099bdd297b7dec$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $b9099bdd297b7dec$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $b9099bdd297b7dec$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$b9099bdd297b7dec$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b9099bdd297b7dec$var$_m0.Writer.create();
        if (message.params !== undefined) $cca94bf0bfed7580$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9099bdd297b7dec$var$_m0.Reader ? input : new $b9099bdd297b7dec$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9099bdd297b7dec$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $cca94bf0bfed7580$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $cca94bf0bfed7580$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $cca94bf0bfed7580$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $b9099bdd297b7dec$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $cca94bf0bfed7580$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $b9099bdd297b7dec$var$createBaseQueryInflationRequest() {
    return {};
}
$b9099bdd297b7dec$exports.QueryInflationRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b9099bdd297b7dec$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9099bdd297b7dec$var$_m0.Reader ? input : new $b9099bdd297b7dec$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9099bdd297b7dec$var$createBaseQueryInflationRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $b9099bdd297b7dec$var$createBaseQueryInflationRequest();
        return message;
    }
};
function $b9099bdd297b7dec$var$createBaseQueryInflationResponse() {
    return {
        inflation: new Uint8Array()
    };
}
$b9099bdd297b7dec$exports.QueryInflationResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b9099bdd297b7dec$var$_m0.Writer.create();
        if (message.inflation.length !== 0) writer.uint32(10).bytes(message.inflation);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9099bdd297b7dec$var$_m0.Reader ? input : new $b9099bdd297b7dec$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9099bdd297b7dec$var$createBaseQueryInflationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            inflation: (0, $7iZIe.isSet)(object.inflation) ? (0, $7iZIe.bytesFromBase64)(object.inflation) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.inflation !== undefined && (obj.inflation = (0, $7iZIe.base64FromBytes)(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $b9099bdd297b7dec$var$createBaseQueryInflationResponse();
        var _object_inflation;
        message.inflation = (_object_inflation = object.inflation) !== null && _object_inflation !== void 0 ? _object_inflation : new Uint8Array();
        return message;
    }
};
function $b9099bdd297b7dec$var$createBaseQueryAnnualProvisionsRequest() {
    return {};
}
$b9099bdd297b7dec$exports.QueryAnnualProvisionsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b9099bdd297b7dec$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9099bdd297b7dec$var$_m0.Reader ? input : new $b9099bdd297b7dec$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9099bdd297b7dec$var$createBaseQueryAnnualProvisionsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $b9099bdd297b7dec$var$createBaseQueryAnnualProvisionsRequest();
        return message;
    }
};
function $b9099bdd297b7dec$var$createBaseQueryAnnualProvisionsResponse() {
    return {
        annualProvisions: new Uint8Array()
    };
}
$b9099bdd297b7dec$exports.QueryAnnualProvisionsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b9099bdd297b7dec$var$_m0.Writer.create();
        if (message.annualProvisions.length !== 0) writer.uint32(10).bytes(message.annualProvisions);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9099bdd297b7dec$var$_m0.Reader ? input : new $b9099bdd297b7dec$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9099bdd297b7dec$var$createBaseQueryAnnualProvisionsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            annualProvisions: (0, $7iZIe.isSet)(object.annualProvisions) ? (0, $7iZIe.bytesFromBase64)(object.annualProvisions) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.annualProvisions !== undefined && (obj.annualProvisions = (0, $7iZIe.base64FromBytes)(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $b9099bdd297b7dec$var$createBaseQueryAnnualProvisionsResponse();
        var _object_annualProvisions;
        message.annualProvisions = (_object_annualProvisions = object.annualProvisions) !== null && _object_annualProvisions !== void 0 ? _object_annualProvisions : new Uint8Array();
        return message;
    }
};
var $b9099bdd297b7dec$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $b9099bdd297b7dec$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $b9099bdd297b7dec$exports.QueryParamsResponse.decode(new $b9099bdd297b7dec$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Inflation",
            value: function Inflation() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $b9099bdd297b7dec$exports.QueryInflationRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
                return promise.then(function(data) {
                    return $b9099bdd297b7dec$exports.QueryInflationResponse.decode(new $b9099bdd297b7dec$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AnnualProvisions",
            value: function AnnualProvisions() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $b9099bdd297b7dec$exports.QueryAnnualProvisionsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
                return promise.then(function(data) {
                    return $b9099bdd297b7dec$exports.QueryAnnualProvisionsResponse.decode(new $b9099bdd297b7dec$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$b9099bdd297b7dec$exports.QueryClientImpl = $b9099bdd297b7dec$var$QueryClientImpl;



function $af080a401fbaeadb$var$setupMintExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var queryService = new $b9099bdd297b7dec$exports.QueryClientImpl(rpc);
    return {
        mint: {
            params: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var params;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.Params({})
                            ];
                        case 1:
                            params = _state.sent().params;
                            (0, $gMk5u.assert)(params);
                            return [
                                2,
                                {
                                    blocksPerYear: params.blocksPerYear,
                                    goalBonded: (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(params.goalBonded),
                                    inflationMin: (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(params.inflationMin),
                                    inflationMax: (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(params.inflationMax),
                                    inflationRateChange: (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                                    mintDenom: params.mintDenom
                                }
                            ];
                    }
                });
            }),
            inflation: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var inflation;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.Inflation({})
                            ];
                        case 1:
                            inflation = _state.sent().inflation;
                            return [
                                2,
                                (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(inflation)
                            ];
                    }
                });
            }),
            annualProvisions: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var annualProvisions;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.AnnualProvisions({})
                            ];
                        case 1:
                            annualProvisions = _state.sent().annualProvisions;
                            return [
                                2,
                                (0, $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto)(annualProvisions)
                            ];
                    }
                });
            })
        }
    };
}
$af080a401fbaeadb$exports.setupMintExtension = $af080a401fbaeadb$var$setupMintExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupMintExtension", {
    enumerable: true,
    get: function get() {
        return $af080a401fbaeadb$exports.setupMintExtension;
    }
});
var $b65c056752e8c66c$exports = {};
"use strict";
Object.defineProperty($b65c056752e8c66c$exports, "__esModule", {
    value: true
});
$b65c056752e8c66c$exports.createSlashingAminoConverters = $b65c056752e8c66c$exports.isAminoMsgUnjail = void 0;
function $b65c056752e8c66c$var$isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$b65c056752e8c66c$exports.isAminoMsgUnjail = $b65c056752e8c66c$var$isAminoMsgUnjail;
function $b65c056752e8c66c$var$createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
$b65c056752e8c66c$exports.createSlashingAminoConverters = $b65c056752e8c66c$var$createSlashingAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function get() {
        return $b65c056752e8c66c$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function get() {
        return $b65c056752e8c66c$exports.isAminoMsgUnjail;
    }
});
var $6aae056f4b905f6e$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($6aae056f4b905f6e$exports, "__esModule", {
    value: true
});
$6aae056f4b905f6e$exports.setupSlashingExtension = void 0;
var $236a063670ec5349$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $236a063670ec5349$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $236a063670ec5349$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $236a063670ec5349$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $236a063670ec5349$var$__createBinding(result, mod, k);
    }
    $236a063670ec5349$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($236a063670ec5349$exports, "__esModule", {
    value: true
});
$236a063670ec5349$exports.QueryClientImpl = $236a063670ec5349$exports.QuerySigningInfosResponse = $236a063670ec5349$exports.QuerySigningInfosRequest = $236a063670ec5349$exports.QuerySigningInfoResponse = $236a063670ec5349$exports.QuerySigningInfoRequest = $236a063670ec5349$exports.QueryParamsResponse = $236a063670ec5349$exports.QueryParamsRequest = $236a063670ec5349$exports.protobufPackage = void 0;

var $9bad28f98ba38562$exports = {};
"use strict";
var $9bad28f98ba38562$var$__createBinding = $9bad28f98ba38562$exports && $9bad28f98ba38562$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9bad28f98ba38562$var$__setModuleDefault = $9bad28f98ba38562$exports && $9bad28f98ba38562$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9bad28f98ba38562$var$__importStar = $9bad28f98ba38562$exports && $9bad28f98ba38562$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9bad28f98ba38562$var$__createBinding(result, mod, k);
    }
    $9bad28f98ba38562$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($9bad28f98ba38562$exports, "__esModule", {
    value: true
});
$9bad28f98ba38562$exports.Params = $9bad28f98ba38562$exports.ValidatorSigningInfo = $9bad28f98ba38562$exports.protobufPackage = void 0;

var $ib0XJ = parcelRequire("ib0XJ");

var $i8V5u = parcelRequire("i8V5u");

var $7iZIe = parcelRequire("7iZIe");

var $9bad28f98ba38562$var$_m0 = $9bad28f98ba38562$var$__importStar((parcelRequire("hjb8Q")));
$9bad28f98ba38562$exports.protobufPackage = "cosmos.slashing.v1beta1";
function $9bad28f98ba38562$var$createBaseValidatorSigningInfo() {
    return {
        address: "",
        startHeight: $7iZIe.Long.ZERO,
        indexOffset: $7iZIe.Long.ZERO,
        jailedUntil: undefined,
        tombstoned: false,
        missedBlocksCounter: $7iZIe.Long.ZERO
    };
}
$9bad28f98ba38562$exports.ValidatorSigningInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9bad28f98ba38562$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.startHeight.isZero()) writer.uint32(16).int64(message.startHeight);
        if (!message.indexOffset.isZero()) writer.uint32(24).int64(message.indexOffset);
        if (message.jailedUntil !== undefined) $ib0XJ.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        if (message.tombstoned === true) writer.uint32(40).bool(message.tombstoned);
        if (!message.missedBlocksCounter.isZero()) writer.uint32(48).int64(message.missedBlocksCounter);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $9bad28f98ba38562$var$_m0.Reader ? input : new $9bad28f98ba38562$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $9bad28f98ba38562$var$createBaseValidatorSigningInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            startHeight: (0, $7iZIe.isSet)(object.startHeight) ? $7iZIe.Long.fromValue(object.startHeight) : $7iZIe.Long.ZERO,
            indexOffset: (0, $7iZIe.isSet)(object.indexOffset) ? $7iZIe.Long.fromValue(object.indexOffset) : $7iZIe.Long.ZERO,
            jailedUntil: (0, $7iZIe.isSet)(object.jailedUntil) ? (0, $7iZIe.fromJsonTimestamp)(object.jailedUntil) : undefined,
            tombstoned: (0, $7iZIe.isSet)(object.tombstoned) ? Boolean(object.tombstoned) : false,
            missedBlocksCounter: (0, $7iZIe.isSet)(object.missedBlocksCounter) ? $7iZIe.Long.fromValue(object.missedBlocksCounter) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || $7iZIe.Long.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || $7iZIe.Long.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = (0, $7iZIe.fromTimestamp)(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined && (obj.missedBlocksCounter = (message.missedBlocksCounter || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $9bad28f98ba38562$var$createBaseValidatorSigningInfo();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.startHeight = object.startHeight !== undefined && object.startHeight !== null ? $7iZIe.Long.fromValue(object.startHeight) : $7iZIe.Long.ZERO;
        message.indexOffset = object.indexOffset !== undefined && object.indexOffset !== null ? $7iZIe.Long.fromValue(object.indexOffset) : $7iZIe.Long.ZERO;
        message.jailedUntil = object.jailedUntil !== undefined && object.jailedUntil !== null ? $ib0XJ.Timestamp.fromPartial(object.jailedUntil) : undefined;
        var _object_tombstoned;
        message.tombstoned = (_object_tombstoned = object.tombstoned) !== null && _object_tombstoned !== void 0 ? _object_tombstoned : false;
        message.missedBlocksCounter = object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null ? $7iZIe.Long.fromValue(object.missedBlocksCounter) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $9bad28f98ba38562$var$createBaseParams() {
    return {
        signedBlocksWindow: $7iZIe.Long.ZERO,
        minSignedPerWindow: new Uint8Array(),
        downtimeJailDuration: undefined,
        slashFractionDoubleSign: new Uint8Array(),
        slashFractionDowntime: new Uint8Array()
    };
}
$9bad28f98ba38562$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9bad28f98ba38562$var$_m0.Writer.create();
        if (!message.signedBlocksWindow.isZero()) writer.uint32(8).int64(message.signedBlocksWindow);
        if (message.minSignedPerWindow.length !== 0) writer.uint32(18).bytes(message.minSignedPerWindow);
        if (message.downtimeJailDuration !== undefined) $i8V5u.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        if (message.slashFractionDoubleSign.length !== 0) writer.uint32(34).bytes(message.slashFractionDoubleSign);
        if (message.slashFractionDowntime.length !== 0) writer.uint32(42).bytes(message.slashFractionDowntime);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $9bad28f98ba38562$var$_m0.Reader ? input : new $9bad28f98ba38562$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $9bad28f98ba38562$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            signedBlocksWindow: (0, $7iZIe.isSet)(object.signedBlocksWindow) ? $7iZIe.Long.fromValue(object.signedBlocksWindow) : $7iZIe.Long.ZERO,
            minSignedPerWindow: (0, $7iZIe.isSet)(object.minSignedPerWindow) ? (0, $7iZIe.bytesFromBase64)(object.minSignedPerWindow) : new Uint8Array(),
            downtimeJailDuration: (0, $7iZIe.isSet)(object.downtimeJailDuration) ? $i8V5u.Duration.fromJSON(object.downtimeJailDuration) : undefined,
            slashFractionDoubleSign: (0, $7iZIe.isSet)(object.slashFractionDoubleSign) ? (0, $7iZIe.bytesFromBase64)(object.slashFractionDoubleSign) : new Uint8Array(),
            slashFractionDowntime: (0, $7iZIe.isSet)(object.slashFractionDowntime) ? (0, $7iZIe.bytesFromBase64)(object.slashFractionDowntime) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.signedBlocksWindow !== undefined && (obj.signedBlocksWindow = (message.signedBlocksWindow || $7iZIe.Long.ZERO).toString());
        message.minSignedPerWindow !== undefined && (obj.minSignedPerWindow = (0, $7iZIe.base64FromBytes)(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined && (obj.downtimeJailDuration = message.downtimeJailDuration ? $i8V5u.Duration.toJSON(message.downtimeJailDuration) : undefined);
        message.slashFractionDoubleSign !== undefined && (obj.slashFractionDoubleSign = (0, $7iZIe.base64FromBytes)(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined && (obj.slashFractionDowntime = (0, $7iZIe.base64FromBytes)(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $9bad28f98ba38562$var$createBaseParams();
        message.signedBlocksWindow = object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null ? $7iZIe.Long.fromValue(object.signedBlocksWindow) : $7iZIe.Long.ZERO;
        var _object_minSignedPerWindow;
        message.minSignedPerWindow = (_object_minSignedPerWindow = object.minSignedPerWindow) !== null && _object_minSignedPerWindow !== void 0 ? _object_minSignedPerWindow : new Uint8Array();
        message.downtimeJailDuration = object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null ? $i8V5u.Duration.fromPartial(object.downtimeJailDuration) : undefined;
        var _object_slashFractionDoubleSign;
        message.slashFractionDoubleSign = (_object_slashFractionDoubleSign = object.slashFractionDoubleSign) !== null && _object_slashFractionDoubleSign !== void 0 ? _object_slashFractionDoubleSign : new Uint8Array();
        var _object_slashFractionDowntime;
        message.slashFractionDowntime = (_object_slashFractionDowntime = object.slashFractionDowntime) !== null && _object_slashFractionDowntime !== void 0 ? _object_slashFractionDowntime : new Uint8Array();
        return message;
    }
};



var $236a063670ec5349$var$_m0 = $236a063670ec5349$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$236a063670ec5349$exports.protobufPackage = "cosmos.slashing.v1beta1";
function $236a063670ec5349$var$createBaseQueryParamsRequest() {
    return {};
}
$236a063670ec5349$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $236a063670ec5349$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $236a063670ec5349$var$_m0.Reader ? input : new $236a063670ec5349$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $236a063670ec5349$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $236a063670ec5349$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $236a063670ec5349$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$236a063670ec5349$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $236a063670ec5349$var$_m0.Writer.create();
        if (message.params !== undefined) $9bad28f98ba38562$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $236a063670ec5349$var$_m0.Reader ? input : new $236a063670ec5349$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $236a063670ec5349$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $9bad28f98ba38562$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $9bad28f98ba38562$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $9bad28f98ba38562$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $236a063670ec5349$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $9bad28f98ba38562$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $236a063670ec5349$var$createBaseQuerySigningInfoRequest() {
    return {
        consAddress: ""
    };
}
$236a063670ec5349$exports.QuerySigningInfoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $236a063670ec5349$var$_m0.Writer.create();
        if (message.consAddress !== "") writer.uint32(10).string(message.consAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $236a063670ec5349$var$_m0.Reader ? input : new $236a063670ec5349$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $236a063670ec5349$var$createBaseQuerySigningInfoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consAddress: (0, $7iZIe.isSet)(object.consAddress) ? String(object.consAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $236a063670ec5349$var$createBaseQuerySigningInfoRequest();
        var _object_consAddress;
        message.consAddress = (_object_consAddress = object.consAddress) !== null && _object_consAddress !== void 0 ? _object_consAddress : "";
        return message;
    }
};
function $236a063670ec5349$var$createBaseQuerySigningInfoResponse() {
    return {
        valSigningInfo: undefined
    };
}
$236a063670ec5349$exports.QuerySigningInfoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $236a063670ec5349$var$_m0.Writer.create();
        if (message.valSigningInfo !== undefined) $9bad28f98ba38562$exports.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $236a063670ec5349$var$_m0.Reader ? input : new $236a063670ec5349$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $236a063670ec5349$var$createBaseQuerySigningInfoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.valSigningInfo = $9bad28f98ba38562$exports.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            valSigningInfo: (0, $7iZIe.isSet)(object.valSigningInfo) ? $9bad28f98ba38562$exports.ValidatorSigningInfo.fromJSON(object.valSigningInfo) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.valSigningInfo !== undefined && (obj.valSigningInfo = message.valSigningInfo ? $9bad28f98ba38562$exports.ValidatorSigningInfo.toJSON(message.valSigningInfo) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $236a063670ec5349$var$createBaseQuerySigningInfoResponse();
        message.valSigningInfo = object.valSigningInfo !== undefined && object.valSigningInfo !== null ? $9bad28f98ba38562$exports.ValidatorSigningInfo.fromPartial(object.valSigningInfo) : undefined;
        return message;
    }
};
function $236a063670ec5349$var$createBaseQuerySigningInfosRequest() {
    return {
        pagination: undefined
    };
}
$236a063670ec5349$exports.QuerySigningInfosRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $236a063670ec5349$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $236a063670ec5349$var$_m0.Reader ? input : new $236a063670ec5349$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $236a063670ec5349$var$createBaseQuerySigningInfosRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $236a063670ec5349$var$createBaseQuerySigningInfosRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $236a063670ec5349$var$createBaseQuerySigningInfosResponse() {
    return {
        info: [],
        pagination: undefined
    };
}
$236a063670ec5349$exports.QuerySigningInfosResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $236a063670ec5349$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.info[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $9bad28f98ba38562$exports.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $236a063670ec5349$var$_m0.Reader ? input : new $236a063670ec5349$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $236a063670ec5349$var$createBaseQuerySigningInfosResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info.push($9bad28f98ba38562$exports.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            info: Array.isArray(object === null || object === void 0 ? void 0 : object.info) ? object.info.map(function(e) {
                return $9bad28f98ba38562$exports.ValidatorSigningInfo.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.info) obj.info = message.info.map(function(e) {
            return e ? $9bad28f98ba38562$exports.ValidatorSigningInfo.toJSON(e) : undefined;
        });
        else obj.info = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_info;
        var message = $236a063670ec5349$var$createBaseQuerySigningInfosResponse();
        message.info = ((_object_info = object.info) === null || _object_info === void 0 ? void 0 : _object_info.map(function(e) {
            return $9bad28f98ba38562$exports.ValidatorSigningInfo.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
var $236a063670ec5349$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $236a063670ec5349$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $236a063670ec5349$exports.QueryParamsResponse.decode(new $236a063670ec5349$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SigningInfo",
            value: function SigningInfo(request) {
                var data = $236a063670ec5349$exports.QuerySigningInfoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
                return promise.then(function(data) {
                    return $236a063670ec5349$exports.QuerySigningInfoResponse.decode(new $236a063670ec5349$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SigningInfos",
            value: function SigningInfos() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $236a063670ec5349$exports.QuerySigningInfosRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
                return promise.then(function(data) {
                    return $236a063670ec5349$exports.QuerySigningInfosResponse.decode(new $236a063670ec5349$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$236a063670ec5349$exports.QueryClientImpl = $236a063670ec5349$var$QueryClientImpl;



function $6aae056f4b905f6e$var$setupSlashingExtension(base) {
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    var queryService = new $236a063670ec5349$exports.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: function() {
                var _ref = (0, $6rBFC._)(function(consAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.SigningInfo({
                                        consAddress: consAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(consAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            signingInfos: function() {
                var _ref = (0, $6rBFC._)(function(paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.SigningInfos({
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            params: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var response;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.Params({})
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response
                            ];
                    }
                });
            })
        }
    };
}
$6aae056f4b905f6e$exports.setupSlashingExtension = $6aae056f4b905f6e$var$setupSlashingExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function get() {
        return $6aae056f4b905f6e$exports.setupSlashingExtension;
    }
});
var $f14f8ae5bbb8f3a8$exports = {};

var $5OlIx = parcelRequire("5OlIx");
"use strict";
Object.defineProperty($f14f8ae5bbb8f3a8$exports, "__esModule", {
    value: true
});
$f14f8ae5bbb8f3a8$exports.createStakingAminoConverters = $f14f8ae5bbb8f3a8$exports.isAminoMsgUndelegate = $f14f8ae5bbb8f3a8$exports.isAminoMsgBeginRedelegate = $f14f8ae5bbb8f3a8$exports.isAminoMsgDelegate = $f14f8ae5bbb8f3a8$exports.isAminoMsgEditValidator = $f14f8ae5bbb8f3a8$exports.isAminoMsgCreateValidator = $f14f8ae5bbb8f3a8$exports.protoDecimalToJson = void 0;

var $kTbgy = parcelRequire("kTbgy");


var $gMk5u = parcelRequire("gMk5u");
function $f14f8ae5bbb8f3a8$var$protoDecimalToJson(decimal) {
    var parsed = $kTbgy.Decimal.fromAtomics(decimal, 18);
    var _parsed_toString_split = (0, $5OlIx._)(parsed.toString().split("."), 2), whole = _parsed_toString_split[0], fractional = _parsed_toString_split[1];
    return "".concat(whole, ".").concat((fractional !== null && fractional !== void 0 ? fractional : "").padEnd(18, "0"));
}
$f14f8ae5bbb8f3a8$exports.protoDecimalToJson = $f14f8ae5bbb8f3a8$var$protoDecimalToJson;
function $f14f8ae5bbb8f3a8$var$jsonDecimalToProto(decimal) {
    var parsed = $kTbgy.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
function $f14f8ae5bbb8f3a8$var$isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$f14f8ae5bbb8f3a8$exports.isAminoMsgCreateValidator = $f14f8ae5bbb8f3a8$var$isAminoMsgCreateValidator;
function $f14f8ae5bbb8f3a8$var$isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$f14f8ae5bbb8f3a8$exports.isAminoMsgEditValidator = $f14f8ae5bbb8f3a8$var$isAminoMsgEditValidator;
function $f14f8ae5bbb8f3a8$var$isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$f14f8ae5bbb8f3a8$exports.isAminoMsgDelegate = $f14f8ae5bbb8f3a8$var$isAminoMsgDelegate;
function $f14f8ae5bbb8f3a8$var$isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$f14f8ae5bbb8f3a8$exports.isAminoMsgBeginRedelegate = $f14f8ae5bbb8f3a8$var$isAminoMsgBeginRedelegate;
function $f14f8ae5bbb8f3a8$var$isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$f14f8ae5bbb8f3a8$exports.isAminoMsgUndelegate = $f14f8ae5bbb8f3a8$var$isAminoMsgUndelegate;
function $f14f8ae5bbb8f3a8$var$createStakingAminoConverters() {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: function(param) {
                var delegatorAddress = param.delegatorAddress, validatorSrcAddress = param.validatorSrcAddress, validatorDstAddress = param.validatorDstAddress, amount = param.amount;
                (0, $gMk5u.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount
                };
            },
            fromAmino: function(param) {
                var delegator_address = param.delegator_address, validator_src_address = param.validator_src_address, validator_dst_address = param.validator_dst_address, amount = param.amount;
                return {
                    delegatorAddress: delegator_address,
                    validatorSrcAddress: validator_src_address,
                    validatorDstAddress: validator_dst_address,
                    amount: amount
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: function(param) {
                var description = param.description, commission = param.commission, minSelfDelegation = param.minSelfDelegation, delegatorAddress = param.delegatorAddress, validatorAddress = param.validatorAddress, pubkey = param.pubkey, value = param.value;
                (0, $gMk5u.assertDefinedAndNotNull)(description, "missing description");
                (0, $gMk5u.assertDefinedAndNotNull)(commission, "missing commission");
                (0, $gMk5u.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, $gMk5u.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    commission: {
                        rate: $f14f8ae5bbb8f3a8$var$protoDecimalToJson(commission.rate),
                        max_rate: $f14f8ae5bbb8f3a8$var$protoDecimalToJson(commission.maxRate),
                        max_change_rate: $f14f8ae5bbb8f3a8$var$protoDecimalToJson(commission.maxChangeRate)
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, $ff811d56e12ad916$exports.decodePubkey)(pubkey),
                    value: value
                };
            },
            fromAmino: function(param) {
                var description = param.description, commission = param.commission, min_self_delegation = param.min_self_delegation, delegator_address = param.delegator_address, validator_address = param.validator_address, pubkey = param.pubkey, value = param.value;
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    commission: {
                        rate: $f14f8ae5bbb8f3a8$var$jsonDecimalToProto(commission.rate),
                        maxRate: $f14f8ae5bbb8f3a8$var$jsonDecimalToProto(commission.max_rate),
                        maxChangeRate: $f14f8ae5bbb8f3a8$var$jsonDecimalToProto(commission.max_change_rate)
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: (0, $ff811d56e12ad916$exports.encodePubkey)(pubkey),
                    value: value
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: function(param) {
                var delegatorAddress = param.delegatorAddress, validatorAddress = param.validatorAddress, amount = param.amount;
                (0, $gMk5u.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: function(param) {
                var delegator_address = param.delegator_address, validator_address = param.validator_address, amount = param.amount;
                return {
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: function(param) {
                var description = param.description, commissionRate = param.commissionRate, minSelfDelegation = param.minSelfDelegation, validatorAddress = param.validatorAddress;
                (0, $gMk5u.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commission_rate: commissionRate ? $f14f8ae5bbb8f3a8$var$protoDecimalToJson(commissionRate) : undefined,
                    // empty string in the protobuf document means "do not change"
                    min_self_delegation: minSelfDelegation ? minSelfDelegation : undefined,
                    validator_address: validatorAddress
                };
            },
            fromAmino: function(param) {
                var description = param.description, commission_rate = param.commission_rate, min_self_delegation = param.min_self_delegation, validator_address = param.validator_address;
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commissionRate: commission_rate ? $f14f8ae5bbb8f3a8$var$jsonDecimalToProto(commission_rate) : "",
                    // empty string in the protobuf document means "do not change"
                    minSelfDelegation: min_self_delegation !== null && min_self_delegation !== void 0 ? min_self_delegation : "",
                    validatorAddress: validator_address
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: function(param) {
                var delegatorAddress = param.delegatorAddress, validatorAddress = param.validatorAddress, amount = param.amount;
                (0, $gMk5u.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: function(param) {
                var delegator_address = param.delegator_address, validator_address = param.validator_address, amount = param.amount;
                return {
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                };
            }
        }
    };
}
$f14f8ae5bbb8f3a8$exports.createStakingAminoConverters = $f14f8ae5bbb8f3a8$var$createStakingAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function get() {
        return $f14f8ae5bbb8f3a8$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function get() {
        return $f14f8ae5bbb8f3a8$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function get() {
        return $f14f8ae5bbb8f3a8$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function get() {
        return $f14f8ae5bbb8f3a8$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function get() {
        return $f14f8ae5bbb8f3a8$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function get() {
        return $f14f8ae5bbb8f3a8$exports.isAminoMsgUndelegate;
    }
});
var $6d835ac12c5db160$exports = {};
"use strict";
Object.defineProperty($6d835ac12c5db160$exports, "__esModule", {
    value: true
});
$6d835ac12c5db160$exports.isMsgUndelegateEncodeObject = $6d835ac12c5db160$exports.isMsgEditValidatorEncodeObject = $6d835ac12c5db160$exports.isMsgDelegateEncodeObject = $6d835ac12c5db160$exports.isMsgCreateValidatorEncodeObject = $6d835ac12c5db160$exports.isMsgBeginRedelegateEncodeObject = $6d835ac12c5db160$exports.stakingTypes = void 0;
var $83b4166ddf6d1939$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $83b4166ddf6d1939$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83b4166ddf6d1939$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $83b4166ddf6d1939$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $83b4166ddf6d1939$var$__createBinding(result, mod, k);
    }
    $83b4166ddf6d1939$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($83b4166ddf6d1939$exports, "__esModule", {
    value: true
});
$83b4166ddf6d1939$exports.MsgClientImpl = $83b4166ddf6d1939$exports.MsgUpdateParamsResponse = $83b4166ddf6d1939$exports.MsgUpdateParams = $83b4166ddf6d1939$exports.MsgCancelUnbondingDelegationResponse = $83b4166ddf6d1939$exports.MsgCancelUnbondingDelegation = $83b4166ddf6d1939$exports.MsgUndelegateResponse = $83b4166ddf6d1939$exports.MsgUndelegate = $83b4166ddf6d1939$exports.MsgBeginRedelegateResponse = $83b4166ddf6d1939$exports.MsgBeginRedelegate = $83b4166ddf6d1939$exports.MsgDelegateResponse = $83b4166ddf6d1939$exports.MsgDelegate = $83b4166ddf6d1939$exports.MsgEditValidatorResponse = $83b4166ddf6d1939$exports.MsgEditValidator = $83b4166ddf6d1939$exports.MsgCreateValidatorResponse = $83b4166ddf6d1939$exports.MsgCreateValidator = $83b4166ddf6d1939$exports.protobufPackage = void 0;
var $41613f7385a625f3$exports = {};
"use strict";
var $41613f7385a625f3$var$__createBinding = $41613f7385a625f3$exports && $41613f7385a625f3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $41613f7385a625f3$var$__setModuleDefault = $41613f7385a625f3$exports && $41613f7385a625f3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $41613f7385a625f3$var$__importStar = $41613f7385a625f3$exports && $41613f7385a625f3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $41613f7385a625f3$var$__createBinding(result, mod, k);
    }
    $41613f7385a625f3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($41613f7385a625f3$exports, "__esModule", {
    value: true
});
$41613f7385a625f3$exports.ValidatorUpdates = $41613f7385a625f3$exports.Pool = $41613f7385a625f3$exports.RedelegationResponse = $41613f7385a625f3$exports.RedelegationEntryResponse = $41613f7385a625f3$exports.DelegationResponse = $41613f7385a625f3$exports.Params = $41613f7385a625f3$exports.Redelegation = $41613f7385a625f3$exports.RedelegationEntry = $41613f7385a625f3$exports.UnbondingDelegationEntry = $41613f7385a625f3$exports.UnbondingDelegation = $41613f7385a625f3$exports.Delegation = $41613f7385a625f3$exports.DVVTriplets = $41613f7385a625f3$exports.DVVTriplet = $41613f7385a625f3$exports.DVPairs = $41613f7385a625f3$exports.DVPair = $41613f7385a625f3$exports.ValAddresses = $41613f7385a625f3$exports.Validator = $41613f7385a625f3$exports.Description = $41613f7385a625f3$exports.Commission = $41613f7385a625f3$exports.CommissionRates = $41613f7385a625f3$exports.HistoricalInfo = $41613f7385a625f3$exports.infractionToJSON = $41613f7385a625f3$exports.infractionFromJSON = $41613f7385a625f3$exports.Infraction = $41613f7385a625f3$exports.bondStatusToJSON = $41613f7385a625f3$exports.bondStatusFromJSON = $41613f7385a625f3$exports.BondStatus = $41613f7385a625f3$exports.protobufPackage = void 0;


var $ib0XJ = parcelRequire("ib0XJ");

var $DM7bi = parcelRequire("DM7bi");

var $i8V5u = parcelRequire("i8V5u");

var $1e86d63877b86916$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $1e86d63877b86916$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e86d63877b86916$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1e86d63877b86916$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1e86d63877b86916$var$__createBinding(result, mod, k);
    }
    $1e86d63877b86916$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1e86d63877b86916$exports, "__esModule", {
    value: true
});
$1e86d63877b86916$exports.ResponsePrepareProposal = $1e86d63877b86916$exports.ResponseApplySnapshotChunk = $1e86d63877b86916$exports.ResponseLoadSnapshotChunk = $1e86d63877b86916$exports.ResponseOfferSnapshot = $1e86d63877b86916$exports.ResponseListSnapshots = $1e86d63877b86916$exports.ResponseCommit = $1e86d63877b86916$exports.ResponseEndBlock = $1e86d63877b86916$exports.ResponseDeliverTx = $1e86d63877b86916$exports.ResponseCheckTx = $1e86d63877b86916$exports.ResponseBeginBlock = $1e86d63877b86916$exports.ResponseQuery = $1e86d63877b86916$exports.ResponseInitChain = $1e86d63877b86916$exports.ResponseInfo = $1e86d63877b86916$exports.ResponseFlush = $1e86d63877b86916$exports.ResponseEcho = $1e86d63877b86916$exports.ResponseException = $1e86d63877b86916$exports.Response = $1e86d63877b86916$exports.RequestProcessProposal = $1e86d63877b86916$exports.RequestPrepareProposal = $1e86d63877b86916$exports.RequestApplySnapshotChunk = $1e86d63877b86916$exports.RequestLoadSnapshotChunk = $1e86d63877b86916$exports.RequestOfferSnapshot = $1e86d63877b86916$exports.RequestListSnapshots = $1e86d63877b86916$exports.RequestCommit = $1e86d63877b86916$exports.RequestEndBlock = $1e86d63877b86916$exports.RequestDeliverTx = $1e86d63877b86916$exports.RequestCheckTx = $1e86d63877b86916$exports.RequestBeginBlock = $1e86d63877b86916$exports.RequestQuery = $1e86d63877b86916$exports.RequestInitChain = $1e86d63877b86916$exports.RequestInfo = $1e86d63877b86916$exports.RequestFlush = $1e86d63877b86916$exports.RequestEcho = $1e86d63877b86916$exports.Request = $1e86d63877b86916$exports.misbehaviorTypeToJSON = $1e86d63877b86916$exports.misbehaviorTypeFromJSON = $1e86d63877b86916$exports.MisbehaviorType = $1e86d63877b86916$exports.responseProcessProposal_ProposalStatusToJSON = $1e86d63877b86916$exports.responseProcessProposal_ProposalStatusFromJSON = $1e86d63877b86916$exports.ResponseProcessProposal_ProposalStatus = $1e86d63877b86916$exports.responseApplySnapshotChunk_ResultToJSON = $1e86d63877b86916$exports.responseApplySnapshotChunk_ResultFromJSON = $1e86d63877b86916$exports.ResponseApplySnapshotChunk_Result = $1e86d63877b86916$exports.responseOfferSnapshot_ResultToJSON = $1e86d63877b86916$exports.responseOfferSnapshot_ResultFromJSON = $1e86d63877b86916$exports.ResponseOfferSnapshot_Result = $1e86d63877b86916$exports.checkTxTypeToJSON = $1e86d63877b86916$exports.checkTxTypeFromJSON = $1e86d63877b86916$exports.CheckTxType = $1e86d63877b86916$exports.protobufPackage = void 0;
$1e86d63877b86916$exports.ABCIApplicationClientImpl = $1e86d63877b86916$exports.Snapshot = $1e86d63877b86916$exports.Misbehavior = $1e86d63877b86916$exports.ExtendedVoteInfo = $1e86d63877b86916$exports.VoteInfo = $1e86d63877b86916$exports.ValidatorUpdate = $1e86d63877b86916$exports.Validator = $1e86d63877b86916$exports.TxResult = $1e86d63877b86916$exports.EventAttribute = $1e86d63877b86916$exports.Event = $1e86d63877b86916$exports.ExtendedCommitInfo = $1e86d63877b86916$exports.CommitInfo = $1e86d63877b86916$exports.ResponseProcessProposal = void 0;

var $ib0XJ = parcelRequire("ib0XJ");
var $fc6f9b3c868f2cb1$exports = {};
"use strict";
var $fc6f9b3c868f2cb1$var$__createBinding = $fc6f9b3c868f2cb1$exports && $fc6f9b3c868f2cb1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fc6f9b3c868f2cb1$var$__setModuleDefault = $fc6f9b3c868f2cb1$exports && $fc6f9b3c868f2cb1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fc6f9b3c868f2cb1$var$__importStar = $fc6f9b3c868f2cb1$exports && $fc6f9b3c868f2cb1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fc6f9b3c868f2cb1$var$__createBinding(result, mod, k);
    }
    $fc6f9b3c868f2cb1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fc6f9b3c868f2cb1$exports, "__esModule", {
    value: true
});
$fc6f9b3c868f2cb1$exports.HashedParams = $fc6f9b3c868f2cb1$exports.VersionParams = $fc6f9b3c868f2cb1$exports.ValidatorParams = $fc6f9b3c868f2cb1$exports.EvidenceParams = $fc6f9b3c868f2cb1$exports.BlockParams = $fc6f9b3c868f2cb1$exports.ConsensusParams = $fc6f9b3c868f2cb1$exports.protobufPackage = void 0;

var $i8V5u = parcelRequire("i8V5u");

var $7iZIe = parcelRequire("7iZIe");

var $fc6f9b3c868f2cb1$var$_m0 = $fc6f9b3c868f2cb1$var$__importStar((parcelRequire("hjb8Q")));
$fc6f9b3c868f2cb1$exports.protobufPackage = "tendermint.types";
function $fc6f9b3c868f2cb1$var$createBaseConsensusParams() {
    return {
        block: undefined,
        evidence: undefined,
        validator: undefined,
        version: undefined
    };
}
$fc6f9b3c868f2cb1$exports.ConsensusParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fc6f9b3c868f2cb1$var$_m0.Writer.create();
        if (message.block !== undefined) $fc6f9b3c868f2cb1$exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) $fc6f9b3c868f2cb1$exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) $fc6f9b3c868f2cb1$exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) $fc6f9b3c868f2cb1$exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fc6f9b3c868f2cb1$var$_m0.Reader ? input : new $fc6f9b3c868f2cb1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fc6f9b3c868f2cb1$var$createBaseConsensusParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $fc6f9b3c868f2cb1$exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = $fc6f9b3c868f2cb1$exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = $fc6f9b3c868f2cb1$exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = $fc6f9b3c868f2cb1$exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            block: (0, $7iZIe.isSet)(object.block) ? $fc6f9b3c868f2cb1$exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: (0, $7iZIe.isSet)(object.evidence) ? $fc6f9b3c868f2cb1$exports.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: (0, $7iZIe.isSet)(object.validator) ? $fc6f9b3c868f2cb1$exports.ValidatorParams.fromJSON(object.validator) : undefined,
            version: (0, $7iZIe.isSet)(object.version) ? $fc6f9b3c868f2cb1$exports.VersionParams.fromJSON(object.version) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.block !== undefined && (obj.block = message.block ? $fc6f9b3c868f2cb1$exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $fc6f9b3c868f2cb1$exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? $fc6f9b3c868f2cb1$exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? $fc6f9b3c868f2cb1$exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $fc6f9b3c868f2cb1$var$createBaseConsensusParams();
        message.block = object.block !== undefined && object.block !== null ? $fc6f9b3c868f2cb1$exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $fc6f9b3c868f2cb1$exports.EvidenceParams.fromPartial(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $fc6f9b3c868f2cb1$exports.ValidatorParams.fromPartial(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $fc6f9b3c868f2cb1$exports.VersionParams.fromPartial(object.version) : undefined;
        return message;
    }
};
function $fc6f9b3c868f2cb1$var$createBaseBlockParams() {
    return {
        maxBytes: $7iZIe.Long.ZERO,
        maxGas: $7iZIe.Long.ZERO
    };
}
$fc6f9b3c868f2cb1$exports.BlockParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fc6f9b3c868f2cb1$var$_m0.Writer.create();
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fc6f9b3c868f2cb1$var$_m0.Reader ? input : new $fc6f9b3c868f2cb1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fc6f9b3c868f2cb1$var$createBaseBlockParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            maxBytes: (0, $7iZIe.isSet)(object.maxBytes) ? $7iZIe.Long.fromValue(object.maxBytes) : $7iZIe.Long.ZERO,
            maxGas: (0, $7iZIe.isSet)(object.maxGas) ? $7iZIe.Long.fromValue(object.maxGas) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $7iZIe.Long.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $fc6f9b3c868f2cb1$var$createBaseBlockParams();
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $7iZIe.Long.fromValue(object.maxBytes) : $7iZIe.Long.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $7iZIe.Long.fromValue(object.maxGas) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $fc6f9b3c868f2cb1$var$createBaseEvidenceParams() {
    return {
        maxAgeNumBlocks: $7iZIe.Long.ZERO,
        maxAgeDuration: undefined,
        maxBytes: $7iZIe.Long.ZERO
    };
}
$fc6f9b3c868f2cb1$exports.EvidenceParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fc6f9b3c868f2cb1$var$_m0.Writer.create();
        if (!message.maxAgeNumBlocks.isZero()) writer.uint32(8).int64(message.maxAgeNumBlocks);
        if (message.maxAgeDuration !== undefined) $i8V5u.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        if (!message.maxBytes.isZero()) writer.uint32(24).int64(message.maxBytes);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fc6f9b3c868f2cb1$var$_m0.Reader ? input : new $fc6f9b3c868f2cb1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fc6f9b3c868f2cb1$var$createBaseEvidenceParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            maxAgeNumBlocks: (0, $7iZIe.isSet)(object.maxAgeNumBlocks) ? $7iZIe.Long.fromValue(object.maxAgeNumBlocks) : $7iZIe.Long.ZERO,
            maxAgeDuration: (0, $7iZIe.isSet)(object.maxAgeDuration) ? $i8V5u.Duration.fromJSON(object.maxAgeDuration) : undefined,
            maxBytes: (0, $7iZIe.isSet)(object.maxBytes) ? $7iZIe.Long.fromValue(object.maxBytes) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.maxAgeNumBlocks !== undefined && (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || $7iZIe.Long.ZERO).toString());
        message.maxAgeDuration !== undefined && (obj.maxAgeDuration = message.maxAgeDuration ? $i8V5u.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $fc6f9b3c868f2cb1$var$createBaseEvidenceParams();
        message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? $7iZIe.Long.fromValue(object.maxAgeNumBlocks) : $7iZIe.Long.ZERO;
        message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? $i8V5u.Duration.fromPartial(object.maxAgeDuration) : undefined;
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $7iZIe.Long.fromValue(object.maxBytes) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $fc6f9b3c868f2cb1$var$createBaseValidatorParams() {
    return {
        pubKeyTypes: []
    };
}
$fc6f9b3c868f2cb1$exports.ValidatorParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fc6f9b3c868f2cb1$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.pubKeyTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fc6f9b3c868f2cb1$var$_m0.Reader ? input : new $fc6f9b3c868f2cb1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fc6f9b3c868f2cb1$var$createBaseValidatorParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pubKeyTypes: Array.isArray(object === null || object === void 0 ? void 0 : object.pubKeyTypes) ? object.pubKeyTypes.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.pubKeyTypes) obj.pubKeyTypes = message.pubKeyTypes.map(function(e) {
            return e;
        });
        else obj.pubKeyTypes = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_pubKeyTypes;
        var message = $fc6f9b3c868f2cb1$var$createBaseValidatorParams();
        message.pubKeyTypes = ((_object_pubKeyTypes = object.pubKeyTypes) === null || _object_pubKeyTypes === void 0 ? void 0 : _object_pubKeyTypes.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $fc6f9b3c868f2cb1$var$createBaseVersionParams() {
    return {
        app: $7iZIe.Long.UZERO
    };
}
$fc6f9b3c868f2cb1$exports.VersionParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fc6f9b3c868f2cb1$var$_m0.Writer.create();
        if (!message.app.isZero()) writer.uint32(8).uint64(message.app);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fc6f9b3c868f2cb1$var$_m0.Reader ? input : new $fc6f9b3c868f2cb1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fc6f9b3c868f2cb1$var$createBaseVersionParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            app: (0, $7iZIe.isSet)(object.app) ? $7iZIe.Long.fromValue(object.app) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.app !== undefined && (obj.app = (message.app || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $fc6f9b3c868f2cb1$var$createBaseVersionParams();
        message.app = object.app !== undefined && object.app !== null ? $7iZIe.Long.fromValue(object.app) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $fc6f9b3c868f2cb1$var$createBaseHashedParams() {
    return {
        blockMaxBytes: $7iZIe.Long.ZERO,
        blockMaxGas: $7iZIe.Long.ZERO
    };
}
$fc6f9b3c868f2cb1$exports.HashedParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fc6f9b3c868f2cb1$var$_m0.Writer.create();
        if (!message.blockMaxBytes.isZero()) writer.uint32(8).int64(message.blockMaxBytes);
        if (!message.blockMaxGas.isZero()) writer.uint32(16).int64(message.blockMaxGas);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $fc6f9b3c868f2cb1$var$_m0.Reader ? input : new $fc6f9b3c868f2cb1$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $fc6f9b3c868f2cb1$var$createBaseHashedParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            blockMaxBytes: (0, $7iZIe.isSet)(object.blockMaxBytes) ? $7iZIe.Long.fromValue(object.blockMaxBytes) : $7iZIe.Long.ZERO,
            blockMaxGas: (0, $7iZIe.isSet)(object.blockMaxGas) ? $7iZIe.Long.fromValue(object.blockMaxGas) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.blockMaxBytes !== undefined && (obj.blockMaxBytes = (message.blockMaxBytes || $7iZIe.Long.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $fc6f9b3c868f2cb1$var$createBaseHashedParams();
        message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? $7iZIe.Long.fromValue(object.blockMaxBytes) : $7iZIe.Long.ZERO;
        message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? $7iZIe.Long.fromValue(object.blockMaxGas) : $7iZIe.Long.ZERO;
        return message;
    }
};






var $7iZIe = parcelRequire("7iZIe");

var $1e86d63877b86916$var$_m0 = $1e86d63877b86916$var$__importStar((parcelRequire("hjb8Q")));
$1e86d63877b86916$exports.protobufPackage = "tendermint.abci";
var $1e86d63877b86916$var$CheckTxType;
(function(CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1e86d63877b86916$var$CheckTxType = $1e86d63877b86916$exports.CheckTxType || ($1e86d63877b86916$exports.CheckTxType = {}));
function $1e86d63877b86916$var$checkTxTypeFromJSON(object) {
    switch(object){
        case 0:
        case "NEW":
            return $1e86d63877b86916$var$CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return $1e86d63877b86916$var$CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1e86d63877b86916$var$CheckTxType.UNRECOGNIZED;
    }
}
$1e86d63877b86916$exports.checkTxTypeFromJSON = $1e86d63877b86916$var$checkTxTypeFromJSON;
function $1e86d63877b86916$var$checkTxTypeToJSON(object) {
    switch(object){
        case $1e86d63877b86916$var$CheckTxType.NEW:
            return "NEW";
        case $1e86d63877b86916$var$CheckTxType.RECHECK:
            return "RECHECK";
        case $1e86d63877b86916$var$CheckTxType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1e86d63877b86916$exports.checkTxTypeToJSON = $1e86d63877b86916$var$checkTxTypeToJSON;
var $1e86d63877b86916$var$ResponseOfferSnapshot_Result;
(function(ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1e86d63877b86916$var$ResponseOfferSnapshot_Result = $1e86d63877b86916$exports.ResponseOfferSnapshot_Result || ($1e86d63877b86916$exports.ResponseOfferSnapshot_Result = {}));
function $1e86d63877b86916$var$responseOfferSnapshot_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1e86d63877b86916$var$ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
$1e86d63877b86916$exports.responseOfferSnapshot_ResultFromJSON = $1e86d63877b86916$var$responseOfferSnapshot_ResultFromJSON;
function $1e86d63877b86916$var$responseOfferSnapshot_ResultToJSON(object) {
    switch(object){
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        case $1e86d63877b86916$var$ResponseOfferSnapshot_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1e86d63877b86916$exports.responseOfferSnapshot_ResultToJSON = $1e86d63877b86916$var$responseOfferSnapshot_ResultToJSON;
var $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result;
(function(ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1e86d63877b86916$var$ResponseApplySnapshotChunk_Result = $1e86d63877b86916$exports.ResponseApplySnapshotChunk_Result || ($1e86d63877b86916$exports.ResponseApplySnapshotChunk_Result = {}));
function $1e86d63877b86916$var$responseApplySnapshotChunk_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
$1e86d63877b86916$exports.responseApplySnapshotChunk_ResultFromJSON = $1e86d63877b86916$var$responseApplySnapshotChunk_ResultFromJSON;
function $1e86d63877b86916$var$responseApplySnapshotChunk_ResultToJSON(object) {
    switch(object){
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        case $1e86d63877b86916$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1e86d63877b86916$exports.responseApplySnapshotChunk_ResultToJSON = $1e86d63877b86916$var$responseApplySnapshotChunk_ResultToJSON;
var $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus;
(function(ResponseProcessProposal_ProposalStatus) {
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNKNOWN"] = 0] = "UNKNOWN";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["ACCEPT"] = 1] = "ACCEPT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["REJECT"] = 2] = "REJECT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus = $1e86d63877b86916$exports.ResponseProcessProposal_ProposalStatus || ($1e86d63877b86916$exports.ResponseProcessProposal_ProposalStatus = {}));
function $1e86d63877b86916$var$responseProcessProposal_ProposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.ACCEPT;
        case 2:
        case "REJECT":
            return $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.REJECT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED;
    }
}
$1e86d63877b86916$exports.responseProcessProposal_ProposalStatusFromJSON = $1e86d63877b86916$var$responseProcessProposal_ProposalStatusFromJSON;
function $1e86d63877b86916$var$responseProcessProposal_ProposalStatusToJSON(object) {
    switch(object){
        case $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.UNKNOWN:
            return "UNKNOWN";
        case $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.ACCEPT:
            return "ACCEPT";
        case $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.REJECT:
            return "REJECT";
        case $1e86d63877b86916$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1e86d63877b86916$exports.responseProcessProposal_ProposalStatusToJSON = $1e86d63877b86916$var$responseProcessProposal_ProposalStatusToJSON;
var $1e86d63877b86916$var$MisbehaviorType;
(function(MisbehaviorType) {
    MisbehaviorType[MisbehaviorType["UNKNOWN"] = 0] = "UNKNOWN";
    MisbehaviorType[MisbehaviorType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    MisbehaviorType[MisbehaviorType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    MisbehaviorType[MisbehaviorType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1e86d63877b86916$var$MisbehaviorType = $1e86d63877b86916$exports.MisbehaviorType || ($1e86d63877b86916$exports.MisbehaviorType = {}));
function $1e86d63877b86916$var$misbehaviorTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $1e86d63877b86916$var$MisbehaviorType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return $1e86d63877b86916$var$MisbehaviorType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return $1e86d63877b86916$var$MisbehaviorType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1e86d63877b86916$var$MisbehaviorType.UNRECOGNIZED;
    }
}
$1e86d63877b86916$exports.misbehaviorTypeFromJSON = $1e86d63877b86916$var$misbehaviorTypeFromJSON;
function $1e86d63877b86916$var$misbehaviorTypeToJSON(object) {
    switch(object){
        case $1e86d63877b86916$var$MisbehaviorType.UNKNOWN:
            return "UNKNOWN";
        case $1e86d63877b86916$var$MisbehaviorType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case $1e86d63877b86916$var$MisbehaviorType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        case $1e86d63877b86916$var$MisbehaviorType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1e86d63877b86916$exports.misbehaviorTypeToJSON = $1e86d63877b86916$var$misbehaviorTypeToJSON;
function $1e86d63877b86916$var$createBaseRequest() {
    return {
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
$1e86d63877b86916$exports.Request = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.echo !== undefined) $1e86d63877b86916$exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        if (message.flush !== undefined) $1e86d63877b86916$exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        if (message.info !== undefined) $1e86d63877b86916$exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        if (message.initChain !== undefined) $1e86d63877b86916$exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        if (message.query !== undefined) $1e86d63877b86916$exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        if (message.beginBlock !== undefined) $1e86d63877b86916$exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        if (message.checkTx !== undefined) $1e86d63877b86916$exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        if (message.deliverTx !== undefined) $1e86d63877b86916$exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        if (message.endBlock !== undefined) $1e86d63877b86916$exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        if (message.commit !== undefined) $1e86d63877b86916$exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        if (message.listSnapshots !== undefined) $1e86d63877b86916$exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $1e86d63877b86916$exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $1e86d63877b86916$exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $1e86d63877b86916$exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.prepareProposal !== undefined) $1e86d63877b86916$exports.RequestPrepareProposal.encode(message.prepareProposal, writer.uint32(130).fork()).ldelim();
        if (message.processProposal !== undefined) $1e86d63877b86916$exports.RequestProcessProposal.encode(message.processProposal, writer.uint32(138).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.echo = $1e86d63877b86916$exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = $1e86d63877b86916$exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = $1e86d63877b86916$exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = $1e86d63877b86916$exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = $1e86d63877b86916$exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = $1e86d63877b86916$exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = $1e86d63877b86916$exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = $1e86d63877b86916$exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = $1e86d63877b86916$exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = $1e86d63877b86916$exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = $1e86d63877b86916$exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = $1e86d63877b86916$exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = $1e86d63877b86916$exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = $1e86d63877b86916$exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.prepareProposal = $1e86d63877b86916$exports.RequestPrepareProposal.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.processProposal = $1e86d63877b86916$exports.RequestProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            echo: (0, $7iZIe.isSet)(object.echo) ? $1e86d63877b86916$exports.RequestEcho.fromJSON(object.echo) : undefined,
            flush: (0, $7iZIe.isSet)(object.flush) ? $1e86d63877b86916$exports.RequestFlush.fromJSON(object.flush) : undefined,
            info: (0, $7iZIe.isSet)(object.info) ? $1e86d63877b86916$exports.RequestInfo.fromJSON(object.info) : undefined,
            initChain: (0, $7iZIe.isSet)(object.initChain) ? $1e86d63877b86916$exports.RequestInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $7iZIe.isSet)(object.query) ? $1e86d63877b86916$exports.RequestQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $7iZIe.isSet)(object.beginBlock) ? $1e86d63877b86916$exports.RequestBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $7iZIe.isSet)(object.checkTx) ? $1e86d63877b86916$exports.RequestCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $7iZIe.isSet)(object.deliverTx) ? $1e86d63877b86916$exports.RequestDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $7iZIe.isSet)(object.endBlock) ? $1e86d63877b86916$exports.RequestEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $7iZIe.isSet)(object.commit) ? $1e86d63877b86916$exports.RequestCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $7iZIe.isSet)(object.listSnapshots) ? $1e86d63877b86916$exports.RequestListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $7iZIe.isSet)(object.offerSnapshot) ? $1e86d63877b86916$exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $7iZIe.isSet)(object.loadSnapshotChunk) ? $1e86d63877b86916$exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $7iZIe.isSet)(object.applySnapshotChunk) ? $1e86d63877b86916$exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $7iZIe.isSet)(object.prepareProposal) ? $1e86d63877b86916$exports.RequestPrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $7iZIe.isSet)(object.processProposal) ? $1e86d63877b86916$exports.RequestProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? $1e86d63877b86916$exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $1e86d63877b86916$exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $1e86d63877b86916$exports.RequestInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $1e86d63877b86916$exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $1e86d63877b86916$exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $1e86d63877b86916$exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $1e86d63877b86916$exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $1e86d63877b86916$exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $1e86d63877b86916$exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $1e86d63877b86916$exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $1e86d63877b86916$exports.RequestListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $1e86d63877b86916$exports.RequestOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $1e86d63877b86916$exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $1e86d63877b86916$exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? $1e86d63877b86916$exports.RequestPrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? $1e86d63877b86916$exports.RequestProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequest();
        message.echo = object.echo !== undefined && object.echo !== null ? $1e86d63877b86916$exports.RequestEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $1e86d63877b86916$exports.RequestFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $1e86d63877b86916$exports.RequestInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $1e86d63877b86916$exports.RequestInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $1e86d63877b86916$exports.RequestQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $1e86d63877b86916$exports.RequestBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $1e86d63877b86916$exports.RequestCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $1e86d63877b86916$exports.RequestDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $1e86d63877b86916$exports.RequestEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $1e86d63877b86916$exports.RequestCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $1e86d63877b86916$exports.RequestListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $1e86d63877b86916$exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $1e86d63877b86916$exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $1e86d63877b86916$exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? $1e86d63877b86916$exports.RequestPrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? $1e86d63877b86916$exports.RequestProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestEcho() {
    return {
        message: ""
    };
}
$1e86d63877b86916$exports.RequestEcho = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestEcho();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            message: (0, $7iZIe.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestEcho();
        var _object_message;
        message.message = (_object_message = object.message) !== null && _object_message !== void 0 ? _object_message : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestFlush() {
    return {};
}
$1e86d63877b86916$exports.RequestFlush = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestFlush();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $1e86d63877b86916$var$createBaseRequestFlush();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestInfo() {
    return {
        version: "",
        blockVersion: $7iZIe.Long.UZERO,
        p2pVersion: $7iZIe.Long.UZERO,
        abciVersion: ""
    };
}
$1e86d63877b86916$exports.RequestInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.version !== "") writer.uint32(10).string(message.version);
        if (!message.blockVersion.isZero()) writer.uint32(16).uint64(message.blockVersion);
        if (!message.p2pVersion.isZero()) writer.uint32(24).uint64(message.p2pVersion);
        if (message.abciVersion !== "") writer.uint32(34).string(message.abciVersion);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                case 4:
                    message.abciVersion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            version: (0, $7iZIe.isSet)(object.version) ? String(object.version) : "",
            blockVersion: (0, $7iZIe.isSet)(object.blockVersion) ? $7iZIe.Long.fromValue(object.blockVersion) : $7iZIe.Long.UZERO,
            p2pVersion: (0, $7iZIe.isSet)(object.p2pVersion) ? $7iZIe.Long.fromValue(object.p2pVersion) : $7iZIe.Long.UZERO,
            abciVersion: (0, $7iZIe.isSet)(object.abciVersion) ? String(object.abciVersion) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined && (obj.blockVersion = (message.blockVersion || $7iZIe.Long.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || $7iZIe.Long.UZERO).toString());
        message.abciVersion !== undefined && (obj.abciVersion = message.abciVersion);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestInfo();
        var _object_version;
        message.version = (_object_version = object.version) !== null && _object_version !== void 0 ? _object_version : "";
        message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? $7iZIe.Long.fromValue(object.blockVersion) : $7iZIe.Long.UZERO;
        message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? $7iZIe.Long.fromValue(object.p2pVersion) : $7iZIe.Long.UZERO;
        var _object_abciVersion;
        message.abciVersion = (_object_abciVersion = object.abciVersion) !== null && _object_abciVersion !== void 0 ? _object_abciVersion : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestInitChain() {
    return {
        time: undefined,
        chainId: "",
        consensusParams: undefined,
        validators: [],
        appStateBytes: new Uint8Array(),
        initialHeight: $7iZIe.Long.ZERO
    };
}
$1e86d63877b86916$exports.RequestInitChain = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.time !== undefined) $ib0XJ.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.consensusParams !== undefined) $fc6f9b3c868f2cb1$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.appStateBytes.length !== 0) writer.uint32(42).bytes(message.appStateBytes);
        if (!message.initialHeight.isZero()) writer.uint32(48).int64(message.initialHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestInitChain();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.time = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = $fc6f9b3c868f2cb1$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push($1e86d63877b86916$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            time: (0, $7iZIe.isSet)(object.time) ? (0, $7iZIe.fromJsonTimestamp)(object.time) : undefined,
            chainId: (0, $7iZIe.isSet)(object.chainId) ? String(object.chainId) : "",
            consensusParams: (0, $7iZIe.isSet)(object.consensusParams) ? $fc6f9b3c868f2cb1$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(function(e) {
                return $1e86d63877b86916$exports.ValidatorUpdate.fromJSON(e);
            }) : [],
            appStateBytes: (0, $7iZIe.isSet)(object.appStateBytes) ? (0, $7iZIe.bytesFromBase64)(object.appStateBytes) : new Uint8Array(),
            initialHeight: (0, $7iZIe.isSet)(object.initialHeight) ? $7iZIe.Long.fromValue(object.initialHeight) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.time !== undefined && (obj.time = (0, $7iZIe.fromTimestamp)(message.time).toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $fc6f9b3c868f2cb1$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map(function(e) {
            return e ? $1e86d63877b86916$exports.ValidatorUpdate.toJSON(e) : undefined;
        });
        else obj.validators = [];
        message.appStateBytes !== undefined && (obj.appStateBytes = (0, $7iZIe.base64FromBytes)(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined && (obj.initialHeight = (message.initialHeight || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_validators;
        var message = $1e86d63877b86916$var$createBaseRequestInitChain();
        message.time = object.time !== undefined && object.time !== null ? $ib0XJ.Timestamp.fromPartial(object.time) : undefined;
        var _object_chainId;
        message.chainId = (_object_chainId = object.chainId) !== null && _object_chainId !== void 0 ? _object_chainId : "";
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $fc6f9b3c868f2cb1$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = ((_object_validators = object.validators) === null || _object_validators === void 0 ? void 0 : _object_validators.map(function(e) {
            return $1e86d63877b86916$exports.ValidatorUpdate.fromPartial(e);
        })) || [];
        var _object_appStateBytes;
        message.appStateBytes = (_object_appStateBytes = object.appStateBytes) !== null && _object_appStateBytes !== void 0 ? _object_appStateBytes : new Uint8Array();
        message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? $7iZIe.Long.fromValue(object.initialHeight) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestQuery() {
    return {
        data: new Uint8Array(),
        path: "",
        height: $7iZIe.Long.ZERO,
        prove: false
    };
}
$1e86d63877b86916$exports.RequestQuery = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.path !== "") writer.uint32(18).string(message.path);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.prove === true) writer.uint32(32).bool(message.prove);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestQuery();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            path: (0, $7iZIe.isSet)(object.path) ? String(object.path) : "",
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            prove: (0, $7iZIe.isSet)(object.prove) ? Boolean(object.prove) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestQuery();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        var _object_path;
        message.path = (_object_path = object.path) !== null && _object_path !== void 0 ? _object_path : "";
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_prove;
        message.prove = (_object_prove = object.prove) !== null && _object_prove !== void 0 ? _object_prove : false;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestBeginBlock() {
    return {
        hash: new Uint8Array(),
        header: undefined,
        lastCommitInfo: undefined,
        byzantineValidators: []
    };
}
$1e86d63877b86916$exports.RequestBeginBlock = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.header !== undefined) $5e6f0a13c00383a2$exports.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.lastCommitInfo !== undefined) $1e86d63877b86916$exports.CommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.byzantineValidators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestBeginBlock();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = $5e6f0a13c00383a2$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = $1e86d63877b86916$exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push($1e86d63877b86916$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? (0, $7iZIe.bytesFromBase64)(object.hash) : new Uint8Array(),
            header: (0, $7iZIe.isSet)(object.header) ? $5e6f0a13c00383a2$exports.Header.fromJSON(object.header) : undefined,
            lastCommitInfo: (0, $7iZIe.isSet)(object.lastCommitInfo) ? $1e86d63877b86916$exports.CommitInfo.fromJSON(object.lastCommitInfo) : undefined,
            byzantineValidators: Array.isArray(object === null || object === void 0 ? void 0 : object.byzantineValidators) ? object.byzantineValidators.map(function(e) {
                return $1e86d63877b86916$exports.Misbehavior.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = (0, $7iZIe.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? $5e6f0a13c00383a2$exports.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined && (obj.lastCommitInfo = message.lastCommitInfo ? $1e86d63877b86916$exports.CommitInfo.toJSON(message.lastCommitInfo) : undefined);
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map(function(e) {
            return e ? $1e86d63877b86916$exports.Misbehavior.toJSON(e) : undefined;
        });
        else obj.byzantineValidators = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_byzantineValidators;
        var message = $1e86d63877b86916$var$createBaseRequestBeginBlock();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : new Uint8Array();
        message.header = object.header !== undefined && object.header !== null ? $5e6f0a13c00383a2$exports.Header.fromPartial(object.header) : undefined;
        message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? $1e86d63877b86916$exports.CommitInfo.fromPartial(object.lastCommitInfo) : undefined;
        message.byzantineValidators = ((_object_byzantineValidators = object.byzantineValidators) === null || _object_byzantineValidators === void 0 ? void 0 : _object_byzantineValidators.map(function(e) {
            return $1e86d63877b86916$exports.Misbehavior.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestCheckTx() {
    return {
        tx: new Uint8Array(),
        type: 0
    };
}
$1e86d63877b86916$exports.RequestCheckTx = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        if (message.type !== 0) writer.uint32(16).int32(message.type);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestCheckTx();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tx: (0, $7iZIe.isSet)(object.tx) ? (0, $7iZIe.bytesFromBase64)(object.tx) : new Uint8Array(),
            type: (0, $7iZIe.isSet)(object.type) ? $1e86d63877b86916$var$checkTxTypeFromJSON(object.type) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tx !== undefined && (obj.tx = (0, $7iZIe.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = $1e86d63877b86916$var$checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestCheckTx();
        var _object_tx;
        message.tx = (_object_tx = object.tx) !== null && _object_tx !== void 0 ? _object_tx : new Uint8Array();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : 0;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestDeliverTx() {
    return {
        tx: new Uint8Array()
    };
}
$1e86d63877b86916$exports.RequestDeliverTx = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestDeliverTx();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tx: (0, $7iZIe.isSet)(object.tx) ? (0, $7iZIe.bytesFromBase64)(object.tx) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tx !== undefined && (obj.tx = (0, $7iZIe.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestDeliverTx();
        var _object_tx;
        message.tx = (_object_tx = object.tx) !== null && _object_tx !== void 0 ? _object_tx : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestEndBlock() {
    return {
        height: $7iZIe.Long.ZERO
    };
}
$1e86d63877b86916$exports.RequestEndBlock = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestEndBlock();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestEndBlock();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestCommit() {
    return {};
}
$1e86d63877b86916$exports.RequestCommit = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestCommit();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $1e86d63877b86916$var$createBaseRequestCommit();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestListSnapshots() {
    return {};
}
$1e86d63877b86916$exports.RequestListSnapshots = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestListSnapshots();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $1e86d63877b86916$var$createBaseRequestListSnapshots();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestOfferSnapshot() {
    return {
        snapshot: undefined,
        appHash: new Uint8Array()
    };
}
$1e86d63877b86916$exports.RequestOfferSnapshot = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.snapshot !== undefined) $1e86d63877b86916$exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(18).bytes(message.appHash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestOfferSnapshot();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshot = $1e86d63877b86916$exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            snapshot: (0, $7iZIe.isSet)(object.snapshot) ? $1e86d63877b86916$exports.Snapshot.fromJSON(object.snapshot) : undefined,
            appHash: (0, $7iZIe.isSet)(object.appHash) ? (0, $7iZIe.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.snapshot !== undefined && (obj.snapshot = message.snapshot ? $1e86d63877b86916$exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined && (obj.appHash = (0, $7iZIe.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestOfferSnapshot();
        message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? $1e86d63877b86916$exports.Snapshot.fromPartial(object.snapshot) : undefined;
        var _object_appHash;
        message.appHash = (_object_appHash = object.appHash) !== null && _object_appHash !== void 0 ? _object_appHash : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestLoadSnapshotChunk() {
    return {
        height: $7iZIe.Long.UZERO,
        format: 0,
        chunk: 0
    };
}
$1e86d63877b86916$exports.RequestLoadSnapshotChunk = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunk !== 0) writer.uint32(24).uint32(message.chunk);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestLoadSnapshotChunk();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.UZERO,
            format: (0, $7iZIe.isSet)(object.format) ? Number(object.format) : 0,
            chunk: (0, $7iZIe.isSet)(object.chunk) ? Number(object.chunk) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunk !== undefined && (obj.chunk = Math.round(message.chunk));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestLoadSnapshotChunk();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.UZERO;
        var _object_format;
        message.format = (_object_format = object.format) !== null && _object_format !== void 0 ? _object_format : 0;
        var _object_chunk;
        message.chunk = (_object_chunk = object.chunk) !== null && _object_chunk !== void 0 ? _object_chunk : 0;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestApplySnapshotChunk() {
    return {
        index: 0,
        chunk: new Uint8Array(),
        sender: ""
    };
}
$1e86d63877b86916$exports.RequestApplySnapshotChunk = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.chunk.length !== 0) writer.uint32(18).bytes(message.chunk);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestApplySnapshotChunk();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            index: (0, $7iZIe.isSet)(object.index) ? Number(object.index) : 0,
            chunk: (0, $7iZIe.isSet)(object.chunk) ? (0, $7iZIe.bytesFromBase64)(object.chunk) : new Uint8Array(),
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.chunk !== undefined && (obj.chunk = (0, $7iZIe.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseRequestApplySnapshotChunk();
        var _object_index;
        message.index = (_object_index = object.index) !== null && _object_index !== void 0 ? _object_index : 0;
        var _object_chunk;
        message.chunk = (_object_chunk = object.chunk) !== null && _object_chunk !== void 0 ? _object_chunk : new Uint8Array();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestPrepareProposal() {
    return {
        maxTxBytes: $7iZIe.Long.ZERO,
        txs: [],
        localLastCommit: undefined,
        misbehavior: [],
        height: $7iZIe.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$1e86d63877b86916$exports.RequestPrepareProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (!message.maxTxBytes.isZero()) writer.uint32(8).int64(message.maxTxBytes);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(18).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.localLastCommit !== undefined) $1e86d63877b86916$exports.ExtendedCommitInfo.encode(message.localLastCommit, writer.uint32(26).fork()).ldelim();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.misbehavior[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $1e86d63877b86916$exports.Misbehavior.encode(v1, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $ib0XJ.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestPrepareProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTxBytes = reader.int64();
                    break;
                case 2:
                    message.txs.push(reader.bytes());
                    break;
                case 3:
                    message.localLastCommit = $1e86d63877b86916$exports.ExtendedCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.misbehavior.push($1e86d63877b86916$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            maxTxBytes: (0, $7iZIe.isSet)(object.maxTxBytes) ? $7iZIe.Long.fromValue(object.maxTxBytes) : $7iZIe.Long.ZERO,
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : [],
            localLastCommit: (0, $7iZIe.isSet)(object.localLastCommit) ? $1e86d63877b86916$exports.ExtendedCommitInfo.fromJSON(object.localLastCommit) : undefined,
            misbehavior: Array.isArray(object === null || object === void 0 ? void 0 : object.misbehavior) ? object.misbehavior.map(function(e) {
                return $1e86d63877b86916$exports.Misbehavior.fromJSON(e);
            }) : [],
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            time: (0, $7iZIe.isSet)(object.time) ? (0, $7iZIe.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $7iZIe.isSet)(object.nextValidatorsHash) ? (0, $7iZIe.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $7iZIe.isSet)(object.proposerAddress) ? (0, $7iZIe.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.maxTxBytes !== undefined && (obj.maxTxBytes = (message.maxTxBytes || $7iZIe.Long.ZERO).toString());
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.txs = [];
        message.localLastCommit !== undefined && (obj.localLastCommit = message.localLastCommit ? $1e86d63877b86916$exports.ExtendedCommitInfo.toJSON(message.localLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map(function(e) {
            return e ? $1e86d63877b86916$exports.Misbehavior.toJSON(e) : undefined;
        });
        else obj.misbehavior = [];
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $7iZIe.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $7iZIe.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $7iZIe.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs, _object_misbehavior;
        var message = $1e86d63877b86916$var$createBaseRequestPrepareProposal();
        message.maxTxBytes = object.maxTxBytes !== undefined && object.maxTxBytes !== null ? $7iZIe.Long.fromValue(object.maxTxBytes) : $7iZIe.Long.ZERO;
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return e;
        })) || [];
        message.localLastCommit = object.localLastCommit !== undefined && object.localLastCommit !== null ? $1e86d63877b86916$exports.ExtendedCommitInfo.fromPartial(object.localLastCommit) : undefined;
        message.misbehavior = ((_object_misbehavior = object.misbehavior) === null || _object_misbehavior === void 0 ? void 0 : _object_misbehavior.map(function(e) {
            return $1e86d63877b86916$exports.Misbehavior.fromPartial(e);
        })) || [];
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $ib0XJ.Timestamp.fromPartial(object.time) : undefined;
        var _object_nextValidatorsHash;
        message.nextValidatorsHash = (_object_nextValidatorsHash = object.nextValidatorsHash) !== null && _object_nextValidatorsHash !== void 0 ? _object_nextValidatorsHash : new Uint8Array();
        var _object_proposerAddress;
        message.proposerAddress = (_object_proposerAddress = object.proposerAddress) !== null && _object_proposerAddress !== void 0 ? _object_proposerAddress : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseRequestProcessProposal() {
    return {
        txs: [],
        proposedLastCommit: undefined,
        misbehavior: [],
        hash: new Uint8Array(),
        height: $7iZIe.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$1e86d63877b86916$exports.RequestProcessProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.proposedLastCommit !== undefined) $1e86d63877b86916$exports.CommitInfo.encode(message.proposedLastCommit, writer.uint32(18).fork()).ldelim();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.misbehavior[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $1e86d63877b86916$exports.Misbehavior.encode(v1, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $ib0XJ.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseRequestProcessProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                case 2:
                    message.proposedLastCommit = $1e86d63877b86916$exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.misbehavior.push($1e86d63877b86916$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : [],
            proposedLastCommit: (0, $7iZIe.isSet)(object.proposedLastCommit) ? $1e86d63877b86916$exports.CommitInfo.fromJSON(object.proposedLastCommit) : undefined,
            misbehavior: Array.isArray(object === null || object === void 0 ? void 0 : object.misbehavior) ? object.misbehavior.map(function(e) {
                return $1e86d63877b86916$exports.Misbehavior.fromJSON(e);
            }) : [],
            hash: (0, $7iZIe.isSet)(object.hash) ? (0, $7iZIe.bytesFromBase64)(object.hash) : new Uint8Array(),
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            time: (0, $7iZIe.isSet)(object.time) ? (0, $7iZIe.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $7iZIe.isSet)(object.nextValidatorsHash) ? (0, $7iZIe.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $7iZIe.isSet)(object.proposerAddress) ? (0, $7iZIe.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.txs = [];
        message.proposedLastCommit !== undefined && (obj.proposedLastCommit = message.proposedLastCommit ? $1e86d63877b86916$exports.CommitInfo.toJSON(message.proposedLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map(function(e) {
            return e ? $1e86d63877b86916$exports.Misbehavior.toJSON(e) : undefined;
        });
        else obj.misbehavior = [];
        message.hash !== undefined && (obj.hash = (0, $7iZIe.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $7iZIe.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $7iZIe.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $7iZIe.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs, _object_misbehavior;
        var message = $1e86d63877b86916$var$createBaseRequestProcessProposal();
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return e;
        })) || [];
        message.proposedLastCommit = object.proposedLastCommit !== undefined && object.proposedLastCommit !== null ? $1e86d63877b86916$exports.CommitInfo.fromPartial(object.proposedLastCommit) : undefined;
        message.misbehavior = ((_object_misbehavior = object.misbehavior) === null || _object_misbehavior === void 0 ? void 0 : _object_misbehavior.map(function(e) {
            return $1e86d63877b86916$exports.Misbehavior.fromPartial(e);
        })) || [];
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : new Uint8Array();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $ib0XJ.Timestamp.fromPartial(object.time) : undefined;
        var _object_nextValidatorsHash;
        message.nextValidatorsHash = (_object_nextValidatorsHash = object.nextValidatorsHash) !== null && _object_nextValidatorsHash !== void 0 ? _object_nextValidatorsHash : new Uint8Array();
        var _object_proposerAddress;
        message.proposerAddress = (_object_proposerAddress = object.proposerAddress) !== null && _object_proposerAddress !== void 0 ? _object_proposerAddress : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponse() {
    return {
        exception: undefined,
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
$1e86d63877b86916$exports.Response = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.exception !== undefined) $1e86d63877b86916$exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        if (message.echo !== undefined) $1e86d63877b86916$exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        if (message.flush !== undefined) $1e86d63877b86916$exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        if (message.info !== undefined) $1e86d63877b86916$exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        if (message.initChain !== undefined) $1e86d63877b86916$exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        if (message.query !== undefined) $1e86d63877b86916$exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        if (message.beginBlock !== undefined) $1e86d63877b86916$exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        if (message.checkTx !== undefined) $1e86d63877b86916$exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        if (message.deliverTx !== undefined) $1e86d63877b86916$exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        if (message.endBlock !== undefined) $1e86d63877b86916$exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        if (message.commit !== undefined) $1e86d63877b86916$exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        if (message.listSnapshots !== undefined) $1e86d63877b86916$exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $1e86d63877b86916$exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $1e86d63877b86916$exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $1e86d63877b86916$exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        if (message.prepareProposal !== undefined) $1e86d63877b86916$exports.ResponsePrepareProposal.encode(message.prepareProposal, writer.uint32(138).fork()).ldelim();
        if (message.processProposal !== undefined) $1e86d63877b86916$exports.ResponseProcessProposal.encode(message.processProposal, writer.uint32(146).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exception = $1e86d63877b86916$exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = $1e86d63877b86916$exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = $1e86d63877b86916$exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = $1e86d63877b86916$exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = $1e86d63877b86916$exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = $1e86d63877b86916$exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = $1e86d63877b86916$exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = $1e86d63877b86916$exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = $1e86d63877b86916$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = $1e86d63877b86916$exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = $1e86d63877b86916$exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = $1e86d63877b86916$exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = $1e86d63877b86916$exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = $1e86d63877b86916$exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = $1e86d63877b86916$exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.prepareProposal = $1e86d63877b86916$exports.ResponsePrepareProposal.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.processProposal = $1e86d63877b86916$exports.ResponseProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            exception: (0, $7iZIe.isSet)(object.exception) ? $1e86d63877b86916$exports.ResponseException.fromJSON(object.exception) : undefined,
            echo: (0, $7iZIe.isSet)(object.echo) ? $1e86d63877b86916$exports.ResponseEcho.fromJSON(object.echo) : undefined,
            flush: (0, $7iZIe.isSet)(object.flush) ? $1e86d63877b86916$exports.ResponseFlush.fromJSON(object.flush) : undefined,
            info: (0, $7iZIe.isSet)(object.info) ? $1e86d63877b86916$exports.ResponseInfo.fromJSON(object.info) : undefined,
            initChain: (0, $7iZIe.isSet)(object.initChain) ? $1e86d63877b86916$exports.ResponseInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $7iZIe.isSet)(object.query) ? $1e86d63877b86916$exports.ResponseQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $7iZIe.isSet)(object.beginBlock) ? $1e86d63877b86916$exports.ResponseBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $7iZIe.isSet)(object.checkTx) ? $1e86d63877b86916$exports.ResponseCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $7iZIe.isSet)(object.deliverTx) ? $1e86d63877b86916$exports.ResponseDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $7iZIe.isSet)(object.endBlock) ? $1e86d63877b86916$exports.ResponseEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $7iZIe.isSet)(object.commit) ? $1e86d63877b86916$exports.ResponseCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $7iZIe.isSet)(object.listSnapshots) ? $1e86d63877b86916$exports.ResponseListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $7iZIe.isSet)(object.offerSnapshot) ? $1e86d63877b86916$exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $7iZIe.isSet)(object.loadSnapshotChunk) ? $1e86d63877b86916$exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $7iZIe.isSet)(object.applySnapshotChunk) ? $1e86d63877b86916$exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $7iZIe.isSet)(object.prepareProposal) ? $1e86d63877b86916$exports.ResponsePrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $7iZIe.isSet)(object.processProposal) ? $1e86d63877b86916$exports.ResponseProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.exception !== undefined && (obj.exception = message.exception ? $1e86d63877b86916$exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? $1e86d63877b86916$exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $1e86d63877b86916$exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $1e86d63877b86916$exports.ResponseInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $1e86d63877b86916$exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $1e86d63877b86916$exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $1e86d63877b86916$exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $1e86d63877b86916$exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $1e86d63877b86916$exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $1e86d63877b86916$exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $1e86d63877b86916$exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $1e86d63877b86916$exports.ResponseListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $1e86d63877b86916$exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $1e86d63877b86916$exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $1e86d63877b86916$exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? $1e86d63877b86916$exports.ResponsePrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? $1e86d63877b86916$exports.ResponseProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponse();
        message.exception = object.exception !== undefined && object.exception !== null ? $1e86d63877b86916$exports.ResponseException.fromPartial(object.exception) : undefined;
        message.echo = object.echo !== undefined && object.echo !== null ? $1e86d63877b86916$exports.ResponseEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $1e86d63877b86916$exports.ResponseFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $1e86d63877b86916$exports.ResponseInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $1e86d63877b86916$exports.ResponseInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $1e86d63877b86916$exports.ResponseQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $1e86d63877b86916$exports.ResponseBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $1e86d63877b86916$exports.ResponseCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $1e86d63877b86916$exports.ResponseDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $1e86d63877b86916$exports.ResponseEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $1e86d63877b86916$exports.ResponseCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $1e86d63877b86916$exports.ResponseListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $1e86d63877b86916$exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $1e86d63877b86916$exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $1e86d63877b86916$exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? $1e86d63877b86916$exports.ResponsePrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? $1e86d63877b86916$exports.ResponseProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseException() {
    return {
        error: ""
    };
}
$1e86d63877b86916$exports.ResponseException = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.error !== "") writer.uint32(10).string(message.error);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseException();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            error: (0, $7iZIe.isSet)(object.error) ? String(object.error) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseException();
        var _object_error;
        message.error = (_object_error = object.error) !== null && _object_error !== void 0 ? _object_error : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseEcho() {
    return {
        message: ""
    };
}
$1e86d63877b86916$exports.ResponseEcho = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseEcho();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            message: (0, $7iZIe.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseEcho();
        var _object_message;
        message.message = (_object_message = object.message) !== null && _object_message !== void 0 ? _object_message : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseFlush() {
    return {};
}
$1e86d63877b86916$exports.ResponseFlush = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseFlush();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $1e86d63877b86916$var$createBaseResponseFlush();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseInfo() {
    return {
        data: "",
        version: "",
        appVersion: $7iZIe.Long.UZERO,
        lastBlockHeight: $7iZIe.Long.ZERO,
        lastBlockAppHash: new Uint8Array()
    };
}
$1e86d63877b86916$exports.ResponseInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.data !== "") writer.uint32(10).string(message.data);
        if (message.version !== "") writer.uint32(18).string(message.version);
        if (!message.appVersion.isZero()) writer.uint32(24).uint64(message.appVersion);
        if (!message.lastBlockHeight.isZero()) writer.uint32(32).int64(message.lastBlockHeight);
        if (message.lastBlockAppHash.length !== 0) writer.uint32(42).bytes(message.lastBlockAppHash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? String(object.data) : "",
            version: (0, $7iZIe.isSet)(object.version) ? String(object.version) : "",
            appVersion: (0, $7iZIe.isSet)(object.appVersion) ? $7iZIe.Long.fromValue(object.appVersion) : $7iZIe.Long.UZERO,
            lastBlockHeight: (0, $7iZIe.isSet)(object.lastBlockHeight) ? $7iZIe.Long.fromValue(object.lastBlockHeight) : $7iZIe.Long.ZERO,
            lastBlockAppHash: (0, $7iZIe.isSet)(object.lastBlockAppHash) ? (0, $7iZIe.bytesFromBase64)(object.lastBlockAppHash) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $7iZIe.Long.UZERO).toString());
        message.lastBlockHeight !== undefined && (obj.lastBlockHeight = (message.lastBlockHeight || $7iZIe.Long.ZERO).toString());
        message.lastBlockAppHash !== undefined && (obj.lastBlockAppHash = (0, $7iZIe.base64FromBytes)(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseInfo();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : "";
        var _object_version;
        message.version = (_object_version = object.version) !== null && _object_version !== void 0 ? _object_version : "";
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $7iZIe.Long.fromValue(object.appVersion) : $7iZIe.Long.UZERO;
        message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? $7iZIe.Long.fromValue(object.lastBlockHeight) : $7iZIe.Long.ZERO;
        var _object_lastBlockAppHash;
        message.lastBlockAppHash = (_object_lastBlockAppHash = object.lastBlockAppHash) !== null && _object_lastBlockAppHash !== void 0 ? _object_lastBlockAppHash : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseInitChain() {
    return {
        consensusParams: undefined,
        validators: [],
        appHash: new Uint8Array()
    };
}
$1e86d63877b86916$exports.ResponseInitChain = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.consensusParams !== undefined) $fc6f9b3c868f2cb1$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.appHash.length !== 0) writer.uint32(26).bytes(message.appHash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseInitChain();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusParams = $fc6f9b3c868f2cb1$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push($1e86d63877b86916$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            consensusParams: (0, $7iZIe.isSet)(object.consensusParams) ? $fc6f9b3c868f2cb1$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(function(e) {
                return $1e86d63877b86916$exports.ValidatorUpdate.fromJSON(e);
            }) : [],
            appHash: (0, $7iZIe.isSet)(object.appHash) ? (0, $7iZIe.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $fc6f9b3c868f2cb1$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map(function(e) {
            return e ? $1e86d63877b86916$exports.ValidatorUpdate.toJSON(e) : undefined;
        });
        else obj.validators = [];
        message.appHash !== undefined && (obj.appHash = (0, $7iZIe.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var _object_validators;
        var message = $1e86d63877b86916$var$createBaseResponseInitChain();
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $fc6f9b3c868f2cb1$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = ((_object_validators = object.validators) === null || _object_validators === void 0 ? void 0 : _object_validators.map(function(e) {
            return $1e86d63877b86916$exports.ValidatorUpdate.fromPartial(e);
        })) || [];
        var _object_appHash;
        message.appHash = (_object_appHash = object.appHash) !== null && _object_appHash !== void 0 ? _object_appHash : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseQuery() {
    return {
        code: 0,
        log: "",
        info: "",
        index: $7iZIe.Long.ZERO,
        key: new Uint8Array(),
        value: new Uint8Array(),
        proofOps: undefined,
        height: $7iZIe.Long.ZERO,
        codespace: ""
    };
}
$1e86d63877b86916$exports.ResponseQuery = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.index.isZero()) writer.uint32(40).int64(message.index);
        if (message.key.length !== 0) writer.uint32(50).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(58).bytes(message.value);
        if (message.proofOps !== undefined) $37dddc6d86f3a99e$exports.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(72).int64(message.height);
        if (message.codespace !== "") writer.uint32(82).string(message.codespace);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseQuery();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = $37dddc6d86f3a99e$exports.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            code: (0, $7iZIe.isSet)(object.code) ? Number(object.code) : 0,
            log: (0, $7iZIe.isSet)(object.log) ? String(object.log) : "",
            info: (0, $7iZIe.isSet)(object.info) ? String(object.info) : "",
            index: (0, $7iZIe.isSet)(object.index) ? $7iZIe.Long.fromValue(object.index) : $7iZIe.Long.ZERO,
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $7iZIe.isSet)(object.value) ? (0, $7iZIe.bytesFromBase64)(object.value) : new Uint8Array(),
            proofOps: (0, $7iZIe.isSet)(object.proofOps) ? $37dddc6d86f3a99e$exports.ProofOps.fromJSON(object.proofOps) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            codespace: (0, $7iZIe.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || $7iZIe.Long.ZERO).toString());
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $7iZIe.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined && (obj.proofOps = message.proofOps ? $37dddc6d86f3a99e$exports.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseQuery();
        var _object_code;
        message.code = (_object_code = object.code) !== null && _object_code !== void 0 ? _object_code : 0;
        var _object_log;
        message.log = (_object_log = object.log) !== null && _object_log !== void 0 ? _object_log : "";
        var _object_info;
        message.info = (_object_info = object.info) !== null && _object_info !== void 0 ? _object_info : "";
        message.index = object.index !== undefined && object.index !== null ? $7iZIe.Long.fromValue(object.index) : $7iZIe.Long.ZERO;
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : new Uint8Array();
        message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? $37dddc6d86f3a99e$exports.ProofOps.fromPartial(object.proofOps) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_codespace;
        message.codespace = (_object_codespace = object.codespace) !== null && _object_codespace !== void 0 ? _object_codespace : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseBeginBlock() {
    return {
        events: []
    };
}
$1e86d63877b86916$exports.ResponseBeginBlock = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseBeginBlock();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push($1e86d63877b86916$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $1e86d63877b86916$exports.Event.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $1e86d63877b86916$exports.Event.toJSON(e) : undefined;
        });
        else obj.events = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_events;
        var message = $1e86d63877b86916$var$createBaseResponseBeginBlock();
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $1e86d63877b86916$exports.Event.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseCheckTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $7iZIe.Long.ZERO,
        gasUsed: $7iZIe.Long.ZERO,
        events: [],
        codespace: "",
        sender: "",
        priority: $7iZIe.Long.ZERO,
        mempoolError: ""
    };
}
$1e86d63877b86916$exports.ResponseCheckTx = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        if (message.sender !== "") writer.uint32(74).string(message.sender);
        if (!message.priority.isZero()) writer.uint32(80).int64(message.priority);
        if (message.mempoolError !== "") writer.uint32(90).string(message.mempoolError);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseCheckTx();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($1e86d63877b86916$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                case 9:
                    message.sender = reader.string();
                    break;
                case 10:
                    message.priority = reader.int64();
                    break;
                case 11:
                    message.mempoolError = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            code: (0, $7iZIe.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $7iZIe.isSet)(object.log) ? String(object.log) : "",
            info: (0, $7iZIe.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $7iZIe.isSet)(object.gas_wanted) ? $7iZIe.Long.fromValue(object.gas_wanted) : $7iZIe.Long.ZERO,
            gasUsed: (0, $7iZIe.isSet)(object.gas_used) ? $7iZIe.Long.fromValue(object.gas_used) : $7iZIe.Long.ZERO,
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $1e86d63877b86916$exports.Event.fromJSON(e);
            }) : [],
            codespace: (0, $7iZIe.isSet)(object.codespace) ? String(object.codespace) : "",
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            priority: (0, $7iZIe.isSet)(object.priority) ? $7iZIe.Long.fromValue(object.priority) : $7iZIe.Long.ZERO,
            mempoolError: (0, $7iZIe.isSet)(object.mempoolError) ? String(object.mempoolError) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $7iZIe.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $7iZIe.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $1e86d63877b86916$exports.Event.toJSON(e) : undefined;
        });
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.sender !== undefined && (obj.sender = message.sender);
        message.priority !== undefined && (obj.priority = (message.priority || $7iZIe.Long.ZERO).toString());
        message.mempoolError !== undefined && (obj.mempoolError = message.mempoolError);
        return obj;
    },
    fromPartial: function(object) {
        var _object_events;
        var message = $1e86d63877b86916$var$createBaseResponseCheckTx();
        var _object_code;
        message.code = (_object_code = object.code) !== null && _object_code !== void 0 ? _object_code : 0;
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        var _object_log;
        message.log = (_object_log = object.log) !== null && _object_log !== void 0 ? _object_log : "";
        var _object_info;
        message.info = (_object_info = object.info) !== null && _object_info !== void 0 ? _object_info : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $7iZIe.Long.fromValue(object.gasWanted) : $7iZIe.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $7iZIe.Long.fromValue(object.gasUsed) : $7iZIe.Long.ZERO;
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $1e86d63877b86916$exports.Event.fromPartial(e);
        })) || [];
        var _object_codespace;
        message.codespace = (_object_codespace = object.codespace) !== null && _object_codespace !== void 0 ? _object_codespace : "";
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        message.priority = object.priority !== undefined && object.priority !== null ? $7iZIe.Long.fromValue(object.priority) : $7iZIe.Long.ZERO;
        var _object_mempoolError;
        message.mempoolError = (_object_mempoolError = object.mempoolError) !== null && _object_mempoolError !== void 0 ? _object_mempoolError : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseDeliverTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $7iZIe.Long.ZERO,
        gasUsed: $7iZIe.Long.ZERO,
        events: [],
        codespace: ""
    };
}
$1e86d63877b86916$exports.ResponseDeliverTx = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseDeliverTx();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($1e86d63877b86916$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            code: (0, $7iZIe.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $7iZIe.isSet)(object.log) ? String(object.log) : "",
            info: (0, $7iZIe.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $7iZIe.isSet)(object.gas_wanted) ? $7iZIe.Long.fromValue(object.gas_wanted) : $7iZIe.Long.ZERO,
            gasUsed: (0, $7iZIe.isSet)(object.gas_used) ? $7iZIe.Long.fromValue(object.gas_used) : $7iZIe.Long.ZERO,
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $1e86d63877b86916$exports.Event.fromJSON(e);
            }) : [],
            codespace: (0, $7iZIe.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $7iZIe.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $7iZIe.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $1e86d63877b86916$exports.Event.toJSON(e) : undefined;
        });
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial: function(object) {
        var _object_events;
        var message = $1e86d63877b86916$var$createBaseResponseDeliverTx();
        var _object_code;
        message.code = (_object_code = object.code) !== null && _object_code !== void 0 ? _object_code : 0;
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        var _object_log;
        message.log = (_object_log = object.log) !== null && _object_log !== void 0 ? _object_log : "";
        var _object_info;
        message.info = (_object_info = object.info) !== null && _object_info !== void 0 ? _object_info : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $7iZIe.Long.fromValue(object.gasWanted) : $7iZIe.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $7iZIe.Long.fromValue(object.gasUsed) : $7iZIe.Long.ZERO;
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $1e86d63877b86916$exports.Event.fromPartial(e);
        })) || [];
        var _object_codespace;
        message.codespace = (_object_codespace = object.codespace) !== null && _object_codespace !== void 0 ? _object_codespace : "";
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseEndBlock() {
    return {
        validatorUpdates: [],
        consensusParamUpdates: undefined,
        events: []
    };
}
$1e86d63877b86916$exports.ResponseEndBlock = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validatorUpdates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.consensusParamUpdates !== undefined) $fc6f9b3c868f2cb1$exports.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.events[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $1e86d63877b86916$exports.Event.encode(v1, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseEndBlock();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorUpdates.push($1e86d63877b86916$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = $fc6f9b3c868f2cb1$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push($1e86d63877b86916$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorUpdates: Array.isArray(object === null || object === void 0 ? void 0 : object.validatorUpdates) ? object.validatorUpdates.map(function(e) {
                return $1e86d63877b86916$exports.ValidatorUpdate.fromJSON(e);
            }) : [],
            consensusParamUpdates: (0, $7iZIe.isSet)(object.consensusParamUpdates) ? $fc6f9b3c868f2cb1$exports.ConsensusParams.fromJSON(object.consensusParamUpdates) : undefined,
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $1e86d63877b86916$exports.Event.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.validatorUpdates) obj.validatorUpdates = message.validatorUpdates.map(function(e) {
            return e ? $1e86d63877b86916$exports.ValidatorUpdate.toJSON(e) : undefined;
        });
        else obj.validatorUpdates = [];
        message.consensusParamUpdates !== undefined && (obj.consensusParamUpdates = message.consensusParamUpdates ? $fc6f9b3c868f2cb1$exports.ConsensusParams.toJSON(message.consensusParamUpdates) : undefined);
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $1e86d63877b86916$exports.Event.toJSON(e) : undefined;
        });
        else obj.events = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_validatorUpdates, _object_events;
        var message = $1e86d63877b86916$var$createBaseResponseEndBlock();
        message.validatorUpdates = ((_object_validatorUpdates = object.validatorUpdates) === null || _object_validatorUpdates === void 0 ? void 0 : _object_validatorUpdates.map(function(e) {
            return $1e86d63877b86916$exports.ValidatorUpdate.fromPartial(e);
        })) || [];
        message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? $fc6f9b3c868f2cb1$exports.ConsensusParams.fromPartial(object.consensusParamUpdates) : undefined;
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $1e86d63877b86916$exports.Event.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseCommit() {
    return {
        data: new Uint8Array(),
        retainHeight: $7iZIe.Long.ZERO
    };
}
$1e86d63877b86916$exports.ResponseCommit = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (!message.retainHeight.isZero()) writer.uint32(24).int64(message.retainHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseCommit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            retainHeight: (0, $7iZIe.isSet)(object.retainHeight) ? $7iZIe.Long.fromValue(object.retainHeight) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseCommit();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? $7iZIe.Long.fromValue(object.retainHeight) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseListSnapshots() {
    return {
        snapshots: []
    };
}
$1e86d63877b86916$exports.ResponseListSnapshots = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.snapshots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseListSnapshots();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshots.push($1e86d63877b86916$exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            snapshots: Array.isArray(object === null || object === void 0 ? void 0 : object.snapshots) ? object.snapshots.map(function(e) {
                return $1e86d63877b86916$exports.Snapshot.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.snapshots) obj.snapshots = message.snapshots.map(function(e) {
            return e ? $1e86d63877b86916$exports.Snapshot.toJSON(e) : undefined;
        });
        else obj.snapshots = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_snapshots;
        var message = $1e86d63877b86916$var$createBaseResponseListSnapshots();
        message.snapshots = ((_object_snapshots = object.snapshots) === null || _object_snapshots === void 0 ? void 0 : _object_snapshots.map(function(e) {
            return $1e86d63877b86916$exports.Snapshot.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseOfferSnapshot() {
    return {
        result: 0
    };
}
$1e86d63877b86916$exports.ResponseOfferSnapshot = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseOfferSnapshot();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? $1e86d63877b86916$var$responseOfferSnapshot_ResultFromJSON(object.result) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = $1e86d63877b86916$var$responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseOfferSnapshot();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseLoadSnapshotChunk() {
    return {
        chunk: new Uint8Array()
    };
}
$1e86d63877b86916$exports.ResponseLoadSnapshotChunk = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.chunk.length !== 0) writer.uint32(10).bytes(message.chunk);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseLoadSnapshotChunk();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            chunk: (0, $7iZIe.isSet)(object.chunk) ? (0, $7iZIe.bytesFromBase64)(object.chunk) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.chunk !== undefined && (obj.chunk = (0, $7iZIe.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseLoadSnapshotChunk();
        var _object_chunk;
        message.chunk = (_object_chunk = object.chunk) !== null && _object_chunk !== void 0 ? _object_chunk : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseApplySnapshotChunk() {
    return {
        result: 0,
        refetchChunks: [],
        rejectSenders: []
    };
}
$1e86d63877b86916$exports.ResponseApplySnapshotChunk = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        writer.uint32(18).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.refetchChunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.rejectSenders[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                writer.uint32(26).string(v1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseApplySnapshotChunk();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.refetchChunks.push(reader.uint32());
                    } else message.refetchChunks.push(reader.uint32());
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            result: (0, $7iZIe.isSet)(object.result) ? $1e86d63877b86916$var$responseApplySnapshotChunk_ResultFromJSON(object.result) : 0,
            refetchChunks: Array.isArray(object === null || object === void 0 ? void 0 : object.refetchChunks) ? object.refetchChunks.map(function(e) {
                return Number(e);
            }) : [],
            rejectSenders: Array.isArray(object === null || object === void 0 ? void 0 : object.rejectSenders) ? object.rejectSenders.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.result !== undefined && (obj.result = $1e86d63877b86916$var$responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) obj.refetchChunks = message.refetchChunks.map(function(e) {
            return Math.round(e);
        });
        else obj.refetchChunks = [];
        if (message.rejectSenders) obj.rejectSenders = message.rejectSenders.map(function(e) {
            return e;
        });
        else obj.rejectSenders = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_refetchChunks, _object_rejectSenders;
        var message = $1e86d63877b86916$var$createBaseResponseApplySnapshotChunk();
        var _object_result;
        message.result = (_object_result = object.result) !== null && _object_result !== void 0 ? _object_result : 0;
        message.refetchChunks = ((_object_refetchChunks = object.refetchChunks) === null || _object_refetchChunks === void 0 ? void 0 : _object_refetchChunks.map(function(e) {
            return e;
        })) || [];
        message.rejectSenders = ((_object_rejectSenders = object.rejectSenders) === null || _object_rejectSenders === void 0 ? void 0 : _object_rejectSenders.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponsePrepareProposal() {
    return {
        txs: []
    };
}
$1e86d63877b86916$exports.ResponsePrepareProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).bytes(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponsePrepareProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return (0, $7iZIe.bytesFromBase64)(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return (0, $7iZIe.base64FromBytes)(e !== undefined ? e : new Uint8Array());
        });
        else obj.txs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs;
        var message = $1e86d63877b86916$var$createBaseResponsePrepareProposal();
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseResponseProcessProposal() {
    return {
        status: 0
    };
}
$1e86d63877b86916$exports.ResponseProcessProposal = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.status !== 0) writer.uint32(8).int32(message.status);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseResponseProcessProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            status: (0, $7iZIe.isSet)(object.status) ? $1e86d63877b86916$var$responseProcessProposal_ProposalStatusFromJSON(object.status) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.status !== undefined && (obj.status = $1e86d63877b86916$var$responseProcessProposal_ProposalStatusToJSON(message.status));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseResponseProcessProposal();
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : 0;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
$1e86d63877b86916$exports.CommitInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.votes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseCommitInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($1e86d63877b86916$exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            round: (0, $7iZIe.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(function(e) {
                return $1e86d63877b86916$exports.VoteInfo.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map(function(e) {
            return e ? $1e86d63877b86916$exports.VoteInfo.toJSON(e) : undefined;
        });
        else obj.votes = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_votes;
        var message = $1e86d63877b86916$var$createBaseCommitInfo();
        var _object_round;
        message.round = (_object_round = object.round) !== null && _object_round !== void 0 ? _object_round : 0;
        message.votes = ((_object_votes = object.votes) === null || _object_votes === void 0 ? void 0 : _object_votes.map(function(e) {
            return $1e86d63877b86916$exports.VoteInfo.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseExtendedCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
$1e86d63877b86916$exports.ExtendedCommitInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.votes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.ExtendedVoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseExtendedCommitInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($1e86d63877b86916$exports.ExtendedVoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            round: (0, $7iZIe.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object === null || object === void 0 ? void 0 : object.votes) ? object.votes.map(function(e) {
                return $1e86d63877b86916$exports.ExtendedVoteInfo.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map(function(e) {
            return e ? $1e86d63877b86916$exports.ExtendedVoteInfo.toJSON(e) : undefined;
        });
        else obj.votes = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_votes;
        var message = $1e86d63877b86916$var$createBaseExtendedCommitInfo();
        var _object_round;
        message.round = (_object_round = object.round) !== null && _object_round !== void 0 ? _object_round : 0;
        message.votes = ((_object_votes = object.votes) === null || _object_votes === void 0 ? void 0 : _object_votes.map(function(e) {
            return $1e86d63877b86916$exports.ExtendedVoteInfo.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseEvent() {
    return {
        type: "",
        attributes: []
    };
}
$1e86d63877b86916$exports.Event = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.type !== "") writer.uint32(10).string(message.type);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseEvent();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($1e86d63877b86916$exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type: (0, $7iZIe.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object === null || object === void 0 ? void 0 : object.attributes) ? object.attributes.map(function(e) {
                return $1e86d63877b86916$exports.EventAttribute.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map(function(e) {
            return e ? $1e86d63877b86916$exports.EventAttribute.toJSON(e) : undefined;
        });
        else obj.attributes = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_attributes;
        var message = $1e86d63877b86916$var$createBaseEvent();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : "";
        message.attributes = ((_object_attributes = object.attributes) === null || _object_attributes === void 0 ? void 0 : _object_attributes.map(function(e) {
            return $1e86d63877b86916$exports.EventAttribute.fromPartial(e);
        })) || [];
        return message;
    }
};
function $1e86d63877b86916$var$createBaseEventAttribute() {
    return {
        key: "",
        value: "",
        index: false
    };
}
$1e86d63877b86916$exports.EventAttribute = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        if (message.index === true) writer.uint32(24).bool(message.index);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseEventAttribute();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? String(object.key) : "",
            value: (0, $7iZIe.isSet)(object.value) ? String(object.value) : "",
            index: (0, $7iZIe.isSet)(object.index) ? Boolean(object.index) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseEventAttribute();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : "";
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : "";
        var _object_index;
        message.index = (_object_index = object.index) !== null && _object_index !== void 0 ? _object_index : false;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseTxResult() {
    return {
        height: $7iZIe.Long.ZERO,
        index: 0,
        tx: new Uint8Array(),
        result: undefined
    };
}
$1e86d63877b86916$exports.TxResult = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.index !== 0) writer.uint32(16).uint32(message.index);
        if (message.tx.length !== 0) writer.uint32(26).bytes(message.tx);
        if (message.result !== undefined) $1e86d63877b86916$exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseTxResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = $1e86d63877b86916$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            index: (0, $7iZIe.isSet)(object.index) ? Number(object.index) : 0,
            tx: (0, $7iZIe.isSet)(object.tx) ? (0, $7iZIe.bytesFromBase64)(object.tx) : new Uint8Array(),
            result: (0, $7iZIe.isSet)(object.result) ? $1e86d63877b86916$exports.ResponseDeliverTx.fromJSON(object.result) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.tx !== undefined && (obj.tx = (0, $7iZIe.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined && (obj.result = message.result ? $1e86d63877b86916$exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseTxResult();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_index;
        message.index = (_object_index = object.index) !== null && _object_index !== void 0 ? _object_index : 0;
        var _object_tx;
        message.tx = (_object_tx = object.tx) !== null && _object_tx !== void 0 ? _object_tx : new Uint8Array();
        message.result = object.result !== undefined && object.result !== null ? $1e86d63877b86916$exports.ResponseDeliverTx.fromPartial(object.result) : undefined;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        power: $7iZIe.Long.ZERO
    };
}
$1e86d63877b86916$exports.Validator = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (!message.power.isZero()) writer.uint32(24).int64(message.power);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseValidator();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? (0, $7iZIe.bytesFromBase64)(object.address) : new Uint8Array(),
            power: (0, $7iZIe.isSet)(object.power) ? $7iZIe.Long.fromValue(object.power) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = (0, $7iZIe.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseValidator();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : new Uint8Array();
        message.power = object.power !== undefined && object.power !== null ? $7iZIe.Long.fromValue(object.power) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseValidatorUpdate() {
    return {
        pubKey: undefined,
        power: $7iZIe.Long.ZERO
    };
}
$1e86d63877b86916$exports.ValidatorUpdate = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.pubKey !== undefined) $d51814e7af8a1759$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.power.isZero()) writer.uint32(16).int64(message.power);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseValidatorUpdate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $d51814e7af8a1759$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pubKey: (0, $7iZIe.isSet)(object.pubKey) ? $d51814e7af8a1759$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            power: (0, $7iZIe.isSet)(object.power) ? $7iZIe.Long.fromValue(object.power) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $d51814e7af8a1759$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseValidatorUpdate();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $d51814e7af8a1759$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.power = object.power !== undefined && object.power !== null ? $7iZIe.Long.fromValue(object.power) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false
    };
}
$1e86d63877b86916$exports.VoteInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.validator !== undefined) $1e86d63877b86916$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseVoteInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $1e86d63877b86916$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validator: (0, $7iZIe.isSet)(object.validator) ? $1e86d63877b86916$exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $7iZIe.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $1e86d63877b86916$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? $1e86d63877b86916$exports.Validator.fromPartial(object.validator) : undefined;
        var _object_signedLastBlock;
        message.signedLastBlock = (_object_signedLastBlock = object.signedLastBlock) !== null && _object_signedLastBlock !== void 0 ? _object_signedLastBlock : false;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseExtendedVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false,
        voteExtension: new Uint8Array()
    };
}
$1e86d63877b86916$exports.ExtendedVoteInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.validator !== undefined) $1e86d63877b86916$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        if (message.voteExtension.length !== 0) writer.uint32(26).bytes(message.voteExtension);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseExtendedVoteInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $1e86d63877b86916$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                case 3:
                    message.voteExtension = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validator: (0, $7iZIe.isSet)(object.validator) ? $1e86d63877b86916$exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $7iZIe.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false,
            voteExtension: (0, $7iZIe.isSet)(object.voteExtension) ? (0, $7iZIe.bytesFromBase64)(object.voteExtension) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $1e86d63877b86916$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        message.voteExtension !== undefined && (obj.voteExtension = (0, $7iZIe.base64FromBytes)(message.voteExtension !== undefined ? message.voteExtension : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseExtendedVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? $1e86d63877b86916$exports.Validator.fromPartial(object.validator) : undefined;
        var _object_signedLastBlock;
        message.signedLastBlock = (_object_signedLastBlock = object.signedLastBlock) !== null && _object_signedLastBlock !== void 0 ? _object_signedLastBlock : false;
        var _object_voteExtension;
        message.voteExtension = (_object_voteExtension = object.voteExtension) !== null && _object_voteExtension !== void 0 ? _object_voteExtension : new Uint8Array();
        return message;
    }
};
function $1e86d63877b86916$var$createBaseMisbehavior() {
    return {
        type: 0,
        validator: undefined,
        height: $7iZIe.Long.ZERO,
        time: undefined,
        totalVotingPower: $7iZIe.Long.ZERO
    };
}
$1e86d63877b86916$exports.Misbehavior = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.validator !== undefined) $1e86d63877b86916$exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $ib0XJ.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(40).int64(message.totalVotingPower);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseMisbehavior();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = $1e86d63877b86916$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type: (0, $7iZIe.isSet)(object.type) ? $1e86d63877b86916$var$misbehaviorTypeFromJSON(object.type) : 0,
            validator: (0, $7iZIe.isSet)(object.validator) ? $1e86d63877b86916$exports.Validator.fromJSON(object.validator) : undefined,
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            time: (0, $7iZIe.isSet)(object.time) ? (0, $7iZIe.fromJsonTimestamp)(object.time) : undefined,
            totalVotingPower: (0, $7iZIe.isSet)(object.totalVotingPower) ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.type !== undefined && (obj.type = $1e86d63877b86916$var$misbehaviorTypeToJSON(message.type));
        message.validator !== undefined && (obj.validator = message.validator ? $1e86d63877b86916$exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $7iZIe.fromTimestamp)(message.time).toISOString());
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseMisbehavior();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : 0;
        message.validator = object.validator !== undefined && object.validator !== null ? $1e86d63877b86916$exports.Validator.fromPartial(object.validator) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $ib0XJ.Timestamp.fromPartial(object.time) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $1e86d63877b86916$var$createBaseSnapshot() {
    return {
        height: $7iZIe.Long.UZERO,
        format: 0,
        chunks: 0,
        hash: new Uint8Array(),
        metadata: new Uint8Array()
    };
}
$1e86d63877b86916$exports.Snapshot = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1e86d63877b86916$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunks !== 0) writer.uint32(24).uint32(message.chunks);
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (message.metadata.length !== 0) writer.uint32(42).bytes(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1e86d63877b86916$var$_m0.Reader ? input : new $1e86d63877b86916$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1e86d63877b86916$var$createBaseSnapshot();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.UZERO,
            format: (0, $7iZIe.isSet)(object.format) ? Number(object.format) : 0,
            chunks: (0, $7iZIe.isSet)(object.chunks) ? Number(object.chunks) : 0,
            hash: (0, $7iZIe.isSet)(object.hash) ? (0, $7iZIe.bytesFromBase64)(object.hash) : new Uint8Array(),
            metadata: (0, $7iZIe.isSet)(object.metadata) ? (0, $7iZIe.bytesFromBase64)(object.metadata) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunks !== undefined && (obj.chunks = Math.round(message.chunks));
        message.hash !== undefined && (obj.hash = (0, $7iZIe.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined && (obj.metadata = (0, $7iZIe.base64FromBytes)(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1e86d63877b86916$var$createBaseSnapshot();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.UZERO;
        var _object_format;
        message.format = (_object_format = object.format) !== null && _object_format !== void 0 ? _object_format : 0;
        var _object_chunks;
        message.chunks = (_object_chunks = object.chunks) !== null && _object_chunks !== void 0 ? _object_chunks : 0;
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : new Uint8Array();
        var _object_metadata;
        message.metadata = (_object_metadata = object.metadata) !== null && _object_metadata !== void 0 ? _object_metadata : new Uint8Array();
        return message;
    }
};
var $1e86d63877b86916$var$ABCIApplicationClientImpl = /*#__PURE__*/ function() {
    function ABCIApplicationClientImpl(rpc) {
        (0, $7dKN1._)(this, ABCIApplicationClientImpl);
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
        this.PrepareProposal = this.PrepareProposal.bind(this);
        this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    (0, $eW5pA._)(ABCIApplicationClientImpl, [
        {
            key: "Echo",
            value: function Echo(request) {
                var data = $1e86d63877b86916$exports.RequestEcho.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "Echo", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseEcho.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Flush",
            value: function Flush() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $1e86d63877b86916$exports.RequestFlush.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "Flush", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseFlush.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Info",
            value: function Info(request) {
                var data = $1e86d63877b86916$exports.RequestInfo.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "Info", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseInfo.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DeliverTx",
            value: function DeliverTx(request) {
                var data = $1e86d63877b86916$exports.RequestDeliverTx.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseDeliverTx.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "CheckTx",
            value: function CheckTx(request) {
                var data = $1e86d63877b86916$exports.RequestCheckTx.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseCheckTx.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Query",
            value: function Query(request) {
                var data = $1e86d63877b86916$exports.RequestQuery.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "Query", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseQuery.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Commit",
            value: function Commit() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $1e86d63877b86916$exports.RequestCommit.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "Commit", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseCommit.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "InitChain",
            value: function InitChain(request) {
                var data = $1e86d63877b86916$exports.RequestInitChain.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseInitChain.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "BeginBlock",
            value: function BeginBlock(request) {
                var data = $1e86d63877b86916$exports.RequestBeginBlock.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseBeginBlock.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "EndBlock",
            value: function EndBlock(request) {
                var data = $1e86d63877b86916$exports.RequestEndBlock.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseEndBlock.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ListSnapshots",
            value: function ListSnapshots() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $1e86d63877b86916$exports.RequestListSnapshots.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseListSnapshots.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "OfferSnapshot",
            value: function OfferSnapshot(request) {
                var data = $1e86d63877b86916$exports.RequestOfferSnapshot.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseOfferSnapshot.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "LoadSnapshotChunk",
            value: function LoadSnapshotChunk(request) {
                var data = $1e86d63877b86916$exports.RequestLoadSnapshotChunk.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseLoadSnapshotChunk.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ApplySnapshotChunk",
            value: function ApplySnapshotChunk(request) {
                var data = $1e86d63877b86916$exports.RequestApplySnapshotChunk.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseApplySnapshotChunk.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PrepareProposal",
            value: function PrepareProposal(request) {
                var data = $1e86d63877b86916$exports.RequestPrepareProposal.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponsePrepareProposal.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ProcessProposal",
            value: function ProcessProposal(request) {
                var data = $1e86d63877b86916$exports.RequestProcessProposal.encode(request).finish();
                var promise = this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", data);
                return promise.then(function(data) {
                    return $1e86d63877b86916$exports.ResponseProcessProposal.decode(new $1e86d63877b86916$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return ABCIApplicationClientImpl;
}();
$1e86d63877b86916$exports.ABCIApplicationClientImpl = $1e86d63877b86916$var$ABCIApplicationClientImpl;



var $7iZIe = parcelRequire("7iZIe");

var $41613f7385a625f3$var$_m0 = $41613f7385a625f3$var$__importStar((parcelRequire("hjb8Q")));
$41613f7385a625f3$exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $41613f7385a625f3$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($41613f7385a625f3$var$BondStatus = $41613f7385a625f3$exports.BondStatus || ($41613f7385a625f3$exports.BondStatus = {}));
function $41613f7385a625f3$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $41613f7385a625f3$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $41613f7385a625f3$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $41613f7385a625f3$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $41613f7385a625f3$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $41613f7385a625f3$var$BondStatus.UNRECOGNIZED;
    }
}
$41613f7385a625f3$exports.bondStatusFromJSON = $41613f7385a625f3$var$bondStatusFromJSON;
function $41613f7385a625f3$var$bondStatusToJSON(object) {
    switch(object){
        case $41613f7385a625f3$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $41613f7385a625f3$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $41613f7385a625f3$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $41613f7385a625f3$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        case $41613f7385a625f3$var$BondStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$41613f7385a625f3$exports.bondStatusToJSON = $41613f7385a625f3$var$bondStatusToJSON;
/** Infraction indicates the infraction a validator commited. */ var $41613f7385a625f3$var$Infraction;
(function(Infraction) {
    /** INFRACTION_UNSPECIFIED - UNSPECIFIED defines an empty infraction. */ Infraction[Infraction["INFRACTION_UNSPECIFIED"] = 0] = "INFRACTION_UNSPECIFIED";
    /** INFRACTION_DOUBLE_SIGN - DOUBLE_SIGN defines a validator that double-signs a block. */ Infraction[Infraction["INFRACTION_DOUBLE_SIGN"] = 1] = "INFRACTION_DOUBLE_SIGN";
    /** INFRACTION_DOWNTIME - DOWNTIME defines a validator that missed signing too many blocks. */ Infraction[Infraction["INFRACTION_DOWNTIME"] = 2] = "INFRACTION_DOWNTIME";
    Infraction[Infraction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($41613f7385a625f3$var$Infraction = $41613f7385a625f3$exports.Infraction || ($41613f7385a625f3$exports.Infraction = {}));
function $41613f7385a625f3$var$infractionFromJSON(object) {
    switch(object){
        case 0:
        case "INFRACTION_UNSPECIFIED":
            return $41613f7385a625f3$var$Infraction.INFRACTION_UNSPECIFIED;
        case 1:
        case "INFRACTION_DOUBLE_SIGN":
            return $41613f7385a625f3$var$Infraction.INFRACTION_DOUBLE_SIGN;
        case 2:
        case "INFRACTION_DOWNTIME":
            return $41613f7385a625f3$var$Infraction.INFRACTION_DOWNTIME;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $41613f7385a625f3$var$Infraction.UNRECOGNIZED;
    }
}
$41613f7385a625f3$exports.infractionFromJSON = $41613f7385a625f3$var$infractionFromJSON;
function $41613f7385a625f3$var$infractionToJSON(object) {
    switch(object){
        case $41613f7385a625f3$var$Infraction.INFRACTION_UNSPECIFIED:
            return "INFRACTION_UNSPECIFIED";
        case $41613f7385a625f3$var$Infraction.INFRACTION_DOUBLE_SIGN:
            return "INFRACTION_DOUBLE_SIGN";
        case $41613f7385a625f3$var$Infraction.INFRACTION_DOWNTIME:
            return "INFRACTION_DOWNTIME";
        case $41613f7385a625f3$var$Infraction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$41613f7385a625f3$exports.infractionToJSON = $41613f7385a625f3$var$infractionToJSON;
function $41613f7385a625f3$var$createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: []
    };
}
$41613f7385a625f3$exports.HistoricalInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.header !== undefined) $5e6f0a13c00383a2$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.valset[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseHistoricalInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $5e6f0a13c00383a2$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push($41613f7385a625f3$exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            header: (0, $7iZIe.isSet)(object.header) ? $5e6f0a13c00383a2$exports.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object === null || object === void 0 ? void 0 : object.valset) ? object.valset.map(function(e) {
                return $41613f7385a625f3$exports.Validator.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.header !== undefined && (obj.header = message.header ? $5e6f0a13c00383a2$exports.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map(function(e) {
            return e ? $41613f7385a625f3$exports.Validator.toJSON(e) : undefined;
        });
        else obj.valset = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_valset;
        var message = $41613f7385a625f3$var$createBaseHistoricalInfo();
        message.header = object.header !== undefined && object.header !== null ? $5e6f0a13c00383a2$exports.Header.fromPartial(object.header) : undefined;
        message.valset = ((_object_valset = object.valset) === null || _object_valset === void 0 ? void 0 : _object_valset.map(function(e) {
            return $41613f7385a625f3$exports.Validator.fromPartial(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: ""
    };
}
$41613f7385a625f3$exports.CommissionRates = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseCommissionRates();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            rate: (0, $7iZIe.isSet)(object.rate) ? String(object.rate) : "",
            maxRate: (0, $7iZIe.isSet)(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: (0, $7iZIe.isSet)(object.maxChangeRate) ? String(object.maxChangeRate) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseCommissionRates();
        var _object_rate;
        message.rate = (_object_rate = object.rate) !== null && _object_rate !== void 0 ? _object_rate : "";
        var _object_maxRate;
        message.maxRate = (_object_maxRate = object.maxRate) !== null && _object_maxRate !== void 0 ? _object_maxRate : "";
        var _object_maxChangeRate;
        message.maxChangeRate = (_object_maxChangeRate = object.maxChangeRate) !== null && _object_maxChangeRate !== void 0 ? _object_maxChangeRate : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined
    };
}
$41613f7385a625f3$exports.Commission = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.commissionRates !== undefined) $41613f7385a625f3$exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $ib0XJ.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseCommission();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = $41613f7385a625f3$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            commissionRates: (0, $7iZIe.isSet)(object.commissionRates) ? $41613f7385a625f3$exports.CommissionRates.fromJSON(object.commissionRates) : undefined,
            updateTime: (0, $7iZIe.isSet)(object.updateTime) ? (0, $7iZIe.fromJsonTimestamp)(object.updateTime) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? $41613f7385a625f3$exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = (0, $7iZIe.fromTimestamp)(message.updateTime).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseCommission();
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? $41613f7385a625f3$exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = object.updateTime !== undefined && object.updateTime !== null ? $ib0XJ.Timestamp.fromPartial(object.updateTime) : undefined;
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: ""
    };
}
$41613f7385a625f3$exports.Description = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDescription();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            moniker: (0, $7iZIe.isSet)(object.moniker) ? String(object.moniker) : "",
            identity: (0, $7iZIe.isSet)(object.identity) ? String(object.identity) : "",
            website: (0, $7iZIe.isSet)(object.website) ? String(object.website) : "",
            securityContact: (0, $7iZIe.isSet)(object.securityContact) ? String(object.securityContact) : "",
            details: (0, $7iZIe.isSet)(object.details) ? String(object.details) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseDescription();
        var _object_moniker;
        message.moniker = (_object_moniker = object.moniker) !== null && _object_moniker !== void 0 ? _object_moniker : "";
        var _object_identity;
        message.identity = (_object_identity = object.identity) !== null && _object_identity !== void 0 ? _object_identity : "";
        var _object_website;
        message.website = (_object_website = object.website) !== null && _object_website !== void 0 ? _object_website : "";
        var _object_securityContact;
        message.securityContact = (_object_securityContact = object.securityContact) !== null && _object_securityContact !== void 0 ? _object_securityContact : "";
        var _object_details;
        message.details = (_object_details = object.details) !== null && _object_details !== void 0 ? _object_details : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: $7iZIe.Long.ZERO,
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: "",
        unbondingOnHoldRefCount: $7iZIe.Long.ZERO,
        unbondingIds: []
    };
}
$41613f7385a625f3$exports.Validator = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $DM7bi.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) $41613f7385a625f3$exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (!message.unbondingHeight.isZero()) writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $ib0XJ.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) $41613f7385a625f3$exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(96).int64(message.unbondingOnHoldRefCount);
        writer.uint32(106).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.unbondingIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseValidator();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = $41613f7385a625f3$exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = $41613f7385a625f3$exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                case 12:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                case 13:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.unbondingIds.push(reader.uint64());
                    } else message.unbondingIds.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            operatorAddress: (0, $7iZIe.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: (0, $7iZIe.isSet)(object.consensusPubkey) ? $DM7bi.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: (0, $7iZIe.isSet)(object.jailed) ? Boolean(object.jailed) : false,
            status: (0, $7iZIe.isSet)(object.status) ? $41613f7385a625f3$var$bondStatusFromJSON(object.status) : 0,
            tokens: (0, $7iZIe.isSet)(object.tokens) ? String(object.tokens) : "",
            delegatorShares: (0, $7iZIe.isSet)(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: (0, $7iZIe.isSet)(object.description) ? $41613f7385a625f3$exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: (0, $7iZIe.isSet)(object.unbondingHeight) ? $7iZIe.Long.fromValue(object.unbondingHeight) : $7iZIe.Long.ZERO,
            unbondingTime: (0, $7iZIe.isSet)(object.unbondingTime) ? (0, $7iZIe.fromJsonTimestamp)(object.unbondingTime) : undefined,
            commission: (0, $7iZIe.isSet)(object.commission) ? $41613f7385a625f3$exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $7iZIe.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            unbondingOnHoldRefCount: (0, $7iZIe.isSet)(object.unbondingOnHoldRefCount) ? $7iZIe.Long.fromValue(object.unbondingOnHoldRefCount) : $7iZIe.Long.ZERO,
            unbondingIds: Array.isArray(object === null || object === void 0 ? void 0 : object.unbondingIds) ? object.unbondingIds.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $DM7bi.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $41613f7385a625f3$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? $41613f7385a625f3$exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = (message.unbondingHeight || $7iZIe.Long.ZERO).toString());
        message.unbondingTime !== undefined && (obj.unbondingTime = (0, $7iZIe.fromTimestamp)(message.unbondingTime).toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? $41613f7385a625f3$exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $7iZIe.Long.ZERO).toString());
        if (message.unbondingIds) obj.unbondingIds = message.unbondingIds.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.unbondingIds = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_unbondingIds;
        var message = $41613f7385a625f3$var$createBaseValidator();
        var _object_operatorAddress;
        message.operatorAddress = (_object_operatorAddress = object.operatorAddress) !== null && _object_operatorAddress !== void 0 ? _object_operatorAddress : "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $DM7bi.Any.fromPartial(object.consensusPubkey) : undefined;
        var _object_jailed;
        message.jailed = (_object_jailed = object.jailed) !== null && _object_jailed !== void 0 ? _object_jailed : false;
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : 0;
        var _object_tokens;
        message.tokens = (_object_tokens = object.tokens) !== null && _object_tokens !== void 0 ? _object_tokens : "";
        var _object_delegatorShares;
        message.delegatorShares = (_object_delegatorShares = object.delegatorShares) !== null && _object_delegatorShares !== void 0 ? _object_delegatorShares : "";
        message.description = object.description !== undefined && object.description !== null ? $41613f7385a625f3$exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? $7iZIe.Long.fromValue(object.unbondingHeight) : $7iZIe.Long.ZERO;
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $ib0XJ.Timestamp.fromPartial(object.unbondingTime) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $41613f7385a625f3$exports.Commission.fromPartial(object.commission) : undefined;
        var _object_minSelfDelegation;
        message.minSelfDelegation = (_object_minSelfDelegation = object.minSelfDelegation) !== null && _object_minSelfDelegation !== void 0 ? _object_minSelfDelegation : "";
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $7iZIe.Long.fromValue(object.unbondingOnHoldRefCount) : $7iZIe.Long.ZERO;
        message.unbondingIds = ((_object_unbondingIds = object.unbondingIds) === null || _object_unbondingIds === void 0 ? void 0 : _object_unbondingIds.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseValAddresses() {
    return {
        addresses: []
    };
}
$41613f7385a625f3$exports.ValAddresses = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.addresses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseValAddresses();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.addresses) obj.addresses = message.addresses.map(function(e) {
            return e;
        });
        else obj.addresses = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_addresses;
        var message = $41613f7385a625f3$var$createBaseValAddresses();
        message.addresses = ((_object_addresses = object.addresses) === null || _object_addresses === void 0 ? void 0 : _object_addresses.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$41613f7385a625f3$exports.DVPair = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDVPair();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseDVPair();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDVPairs() {
    return {
        pairs: []
    };
}
$41613f7385a625f3$exports.DVPairs = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDVPairs();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push($41613f7385a625f3$exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pairs: Array.isArray(object === null || object === void 0 ? void 0 : object.pairs) ? object.pairs.map(function(e) {
                return $41613f7385a625f3$exports.DVPair.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.pairs) obj.pairs = message.pairs.map(function(e) {
            return e ? $41613f7385a625f3$exports.DVPair.toJSON(e) : undefined;
        });
        else obj.pairs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_pairs;
        var message = $41613f7385a625f3$var$createBaseDVPairs();
        message.pairs = ((_object_pairs = object.pairs) === null || _object_pairs === void 0 ? void 0 : _object_pairs.map(function(e) {
            return $41613f7385a625f3$exports.DVPair.fromPartial(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: ""
    };
}
$41613f7385a625f3$exports.DVVTriplet = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDVVTriplet();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $7iZIe.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $7iZIe.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseDVVTriplet();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorSrcAddress;
        message.validatorSrcAddress = (_object_validatorSrcAddress = object.validatorSrcAddress) !== null && _object_validatorSrcAddress !== void 0 ? _object_validatorSrcAddress : "";
        var _object_validatorDstAddress;
        message.validatorDstAddress = (_object_validatorDstAddress = object.validatorDstAddress) !== null && _object_validatorDstAddress !== void 0 ? _object_validatorDstAddress : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDVVTriplets() {
    return {
        triplets: []
    };
}
$41613f7385a625f3$exports.DVVTriplets = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.triplets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDVVTriplets();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push($41613f7385a625f3$exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            triplets: Array.isArray(object === null || object === void 0 ? void 0 : object.triplets) ? object.triplets.map(function(e) {
                return $41613f7385a625f3$exports.DVVTriplet.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.triplets) obj.triplets = message.triplets.map(function(e) {
            return e ? $41613f7385a625f3$exports.DVVTriplet.toJSON(e) : undefined;
        });
        else obj.triplets = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_triplets;
        var message = $41613f7385a625f3$var$createBaseDVVTriplets();
        message.triplets = ((_object_triplets = object.triplets) === null || _object_triplets === void 0 ? void 0 : _object_triplets.map(function(e) {
            return $41613f7385a625f3$exports.DVVTriplet.fromPartial(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: ""
    };
}
$41613f7385a625f3$exports.Delegation = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDelegation();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: (0, $7iZIe.isSet)(object.shares) ? String(object.shares) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseDelegation();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        var _object_shares;
        message.shares = (_object_shares = object.shares) !== null && _object_shares !== void 0 ? _object_shares : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: []
    };
}
$41613f7385a625f3$exports.UnbondingDelegation = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseUnbondingDelegation();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push($41613f7385a625f3$exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(function(e) {
                return $41613f7385a625f3$exports.UnbondingDelegationEntry.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map(function(e) {
            return e ? $41613f7385a625f3$exports.UnbondingDelegationEntry.toJSON(e) : undefined;
        });
        else obj.entries = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_entries;
        var message = $41613f7385a625f3$var$createBaseUnbondingDelegation();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.entries = ((_object_entries = object.entries) === null || _object_entries === void 0 ? void 0 : _object_entries.map(function(e) {
            return $41613f7385a625f3$exports.UnbondingDelegationEntry.fromPartial(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: $7iZIe.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        balance: "",
        unbondingId: $7iZIe.Long.UZERO,
        unbondingOnHoldRefCount: $7iZIe.Long.ZERO
    };
}
$41613f7385a625f3$exports.UnbondingDelegationEntry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $ib0XJ.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseUnbondingDelegationEntry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creationHeight: (0, $7iZIe.isSet)(object.creationHeight) ? $7iZIe.Long.fromValue(object.creationHeight) : $7iZIe.Long.ZERO,
            completionTime: (0, $7iZIe.isSet)(object.completionTime) ? (0, $7iZIe.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $7iZIe.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            balance: (0, $7iZIe.isSet)(object.balance) ? String(object.balance) : "",
            unbondingId: (0, $7iZIe.isSet)(object.unbondingId) ? $7iZIe.Long.fromValue(object.unbondingId) : $7iZIe.Long.UZERO,
            unbondingOnHoldRefCount: (0, $7iZIe.isSet)(object.unbondingOnHoldRefCount) ? $7iZIe.Long.fromValue(object.unbondingOnHoldRefCount) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $7iZIe.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $7iZIe.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $7iZIe.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseUnbondingDelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $7iZIe.Long.fromValue(object.creationHeight) : $7iZIe.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $ib0XJ.Timestamp.fromPartial(object.completionTime) : undefined;
        var _object_initialBalance;
        message.initialBalance = (_object_initialBalance = object.initialBalance) !== null && _object_initialBalance !== void 0 ? _object_initialBalance : "";
        var _object_balance;
        message.balance = (_object_balance = object.balance) !== null && _object_balance !== void 0 ? _object_balance : "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $7iZIe.Long.fromValue(object.unbondingId) : $7iZIe.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $7iZIe.Long.fromValue(object.unbondingOnHoldRefCount) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $41613f7385a625f3$var$createBaseRedelegationEntry() {
    return {
        creationHeight: $7iZIe.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        sharesDst: "",
        unbondingId: $7iZIe.Long.UZERO,
        unbondingOnHoldRefCount: $7iZIe.Long.ZERO
    };
}
$41613f7385a625f3$exports.RedelegationEntry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $ib0XJ.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseRedelegationEntry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creationHeight: (0, $7iZIe.isSet)(object.creationHeight) ? $7iZIe.Long.fromValue(object.creationHeight) : $7iZIe.Long.ZERO,
            completionTime: (0, $7iZIe.isSet)(object.completionTime) ? (0, $7iZIe.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $7iZIe.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: (0, $7iZIe.isSet)(object.sharesDst) ? String(object.sharesDst) : "",
            unbondingId: (0, $7iZIe.isSet)(object.unbondingId) ? $7iZIe.Long.fromValue(object.unbondingId) : $7iZIe.Long.UZERO,
            unbondingOnHoldRefCount: (0, $7iZIe.isSet)(object.unbondingOnHoldRefCount) ? $7iZIe.Long.fromValue(object.unbondingOnHoldRefCount) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $7iZIe.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $7iZIe.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $7iZIe.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseRedelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $7iZIe.Long.fromValue(object.creationHeight) : $7iZIe.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $ib0XJ.Timestamp.fromPartial(object.completionTime) : undefined;
        var _object_initialBalance;
        message.initialBalance = (_object_initialBalance = object.initialBalance) !== null && _object_initialBalance !== void 0 ? _object_initialBalance : "";
        var _object_sharesDst;
        message.sharesDst = (_object_sharesDst = object.sharesDst) !== null && _object_sharesDst !== void 0 ? _object_sharesDst : "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $7iZIe.Long.fromValue(object.unbondingId) : $7iZIe.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $7iZIe.Long.fromValue(object.unbondingOnHoldRefCount) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $41613f7385a625f3$var$createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: []
    };
}
$41613f7385a625f3$exports.Redelegation = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseRedelegation();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push($41613f7385a625f3$exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $7iZIe.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $7iZIe.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(function(e) {
                return $41613f7385a625f3$exports.RedelegationEntry.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map(function(e) {
            return e ? $41613f7385a625f3$exports.RedelegationEntry.toJSON(e) : undefined;
        });
        else obj.entries = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_entries;
        var message = $41613f7385a625f3$var$createBaseRedelegation();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorSrcAddress;
        message.validatorSrcAddress = (_object_validatorSrcAddress = object.validatorSrcAddress) !== null && _object_validatorSrcAddress !== void 0 ? _object_validatorSrcAddress : "";
        var _object_validatorDstAddress;
        message.validatorDstAddress = (_object_validatorDstAddress = object.validatorDstAddress) !== null && _object_validatorDstAddress !== void 0 ? _object_validatorDstAddress : "";
        message.entries = ((_object_entries = object.entries) === null || _object_entries === void 0 ? void 0 : _object_entries.map(function(e) {
            return $41613f7385a625f3$exports.RedelegationEntry.fromPartial(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: "",
        minCommissionRate: ""
    };
}
$41613f7385a625f3$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.unbondingTime !== undefined) $i8V5u.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        if (message.minCommissionRate !== "") writer.uint32(50).string(message.minCommissionRate);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $i8V5u.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                case 6:
                    message.minCommissionRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            unbondingTime: (0, $7iZIe.isSet)(object.unbondingTime) ? $i8V5u.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: (0, $7iZIe.isSet)(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: (0, $7iZIe.isSet)(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: (0, $7iZIe.isSet)(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: (0, $7iZIe.isSet)(object.bondDenom) ? String(object.bondDenom) : "",
            minCommissionRate: (0, $7iZIe.isSet)(object.minCommissionRate) ? String(object.minCommissionRate) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $i8V5u.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined && (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        message.minCommissionRate !== undefined && (obj.minCommissionRate = message.minCommissionRate);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseParams();
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $i8V5u.Duration.fromPartial(object.unbondingTime) : undefined;
        var _object_maxValidators;
        message.maxValidators = (_object_maxValidators = object.maxValidators) !== null && _object_maxValidators !== void 0 ? _object_maxValidators : 0;
        var _object_maxEntries;
        message.maxEntries = (_object_maxEntries = object.maxEntries) !== null && _object_maxEntries !== void 0 ? _object_maxEntries : 0;
        var _object_historicalEntries;
        message.historicalEntries = (_object_historicalEntries = object.historicalEntries) !== null && _object_historicalEntries !== void 0 ? _object_historicalEntries : 0;
        var _object_bondDenom;
        message.bondDenom = (_object_bondDenom = object.bondDenom) !== null && _object_bondDenom !== void 0 ? _object_bondDenom : "";
        var _object_minCommissionRate;
        message.minCommissionRate = (_object_minCommissionRate = object.minCommissionRate) !== null && _object_minCommissionRate !== void 0 ? _object_minCommissionRate : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined
    };
}
$41613f7385a625f3$exports.DelegationResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.delegation !== undefined) $41613f7385a625f3$exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseDelegationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = $41613f7385a625f3$exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegation: (0, $7iZIe.isSet)(object.delegation) ? $41613f7385a625f3$exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: (0, $7iZIe.isSet)(object.balance) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? $41613f7385a625f3$exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $5bc8eb379b028930$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseDelegationResponse();
        message.delegation = object.delegation !== undefined && object.delegation !== null ? $41613f7385a625f3$exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $41613f7385a625f3$var$createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: ""
    };
}
$41613f7385a625f3$exports.RedelegationEntryResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.redelegationEntry !== undefined) $41613f7385a625f3$exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseRedelegationEntryResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = $41613f7385a625f3$exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            redelegationEntry: (0, $7iZIe.isSet)(object.redelegationEntry) ? $41613f7385a625f3$exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined,
            balance: (0, $7iZIe.isSet)(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? $41613f7385a625f3$exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBaseRedelegationEntryResponse();
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? $41613f7385a625f3$exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        var _object_balance;
        message.balance = (_object_balance = object.balance) !== null && _object_balance !== void 0 ? _object_balance : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: []
    };
}
$41613f7385a625f3$exports.RedelegationResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.redelegation !== undefined) $41613f7385a625f3$exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseRedelegationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = $41613f7385a625f3$exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push($41613f7385a625f3$exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            redelegation: (0, $7iZIe.isSet)(object.redelegation) ? $41613f7385a625f3$exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(function(e) {
                return $41613f7385a625f3$exports.RedelegationEntryResponse.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? $41613f7385a625f3$exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map(function(e) {
            return e ? $41613f7385a625f3$exports.RedelegationEntryResponse.toJSON(e) : undefined;
        });
        else obj.entries = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_entries;
        var message = $41613f7385a625f3$var$createBaseRedelegationResponse();
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? $41613f7385a625f3$exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = ((_object_entries = object.entries) === null || _object_entries === void 0 ? void 0 : _object_entries.map(function(e) {
            return $41613f7385a625f3$exports.RedelegationEntryResponse.fromPartial(e);
        })) || [];
        return message;
    }
};
function $41613f7385a625f3$var$createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: ""
    };
}
$41613f7385a625f3$exports.Pool = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBasePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            notBondedTokens: (0, $7iZIe.isSet)(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: (0, $7iZIe.isSet)(object.bondedTokens) ? String(object.bondedTokens) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial: function(object) {
        var message = $41613f7385a625f3$var$createBasePool();
        var _object_notBondedTokens;
        message.notBondedTokens = (_object_notBondedTokens = object.notBondedTokens) !== null && _object_notBondedTokens !== void 0 ? _object_notBondedTokens : "";
        var _object_bondedTokens;
        message.bondedTokens = (_object_bondedTokens = object.bondedTokens) !== null && _object_bondedTokens !== void 0 ? _object_bondedTokens : "";
        return message;
    }
};
function $41613f7385a625f3$var$createBaseValidatorUpdates() {
    return {
        updates: []
    };
}
$41613f7385a625f3$exports.ValidatorUpdates = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $41613f7385a625f3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $41613f7385a625f3$var$_m0.Reader ? input : new $41613f7385a625f3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $41613f7385a625f3$var$createBaseValidatorUpdates();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.updates.push($1e86d63877b86916$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            updates: Array.isArray(object === null || object === void 0 ? void 0 : object.updates) ? object.updates.map(function(e) {
                return $1e86d63877b86916$exports.ValidatorUpdate.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.updates) obj.updates = message.updates.map(function(e) {
            return e ? $1e86d63877b86916$exports.ValidatorUpdate.toJSON(e) : undefined;
        });
        else obj.updates = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_updates;
        var message = $41613f7385a625f3$var$createBaseValidatorUpdates();
        message.updates = ((_object_updates = object.updates) === null || _object_updates === void 0 ? void 0 : _object_updates.map(function(e) {
            return $1e86d63877b86916$exports.ValidatorUpdate.fromPartial(e);
        })) || [];
        return message;
    }
};



var $DM7bi = parcelRequire("DM7bi");


var $ib0XJ = parcelRequire("ib0XJ");

var $7iZIe = parcelRequire("7iZIe");

var $83b4166ddf6d1939$var$_m0 = $83b4166ddf6d1939$var$__importStar((parcelRequire("hjb8Q")));
$83b4166ddf6d1939$exports.protobufPackage = "cosmos.staking.v1beta1";
function $83b4166ddf6d1939$var$createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined
    };
}
$83b4166ddf6d1939$exports.MsgCreateValidator = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.description !== undefined) $41613f7385a625f3$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $41613f7385a625f3$exports.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $DM7bi.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgCreateValidator();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $41613f7385a625f3$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $41613f7385a625f3$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            description: (0, $7iZIe.isSet)(object.description) ? $41613f7385a625f3$exports.Description.fromJSON(object.description) : undefined,
            commission: (0, $7iZIe.isSet)(object.commission) ? $41613f7385a625f3$exports.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $7iZIe.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: (0, $7iZIe.isSet)(object.pubkey) ? $DM7bi.Any.fromJSON(object.pubkey) : undefined,
            value: (0, $7iZIe.isSet)(object.value) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.value) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.description !== undefined && (obj.description = message.description ? $41613f7385a625f3$exports.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $41613f7385a625f3$exports.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $DM7bi.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $5bc8eb379b028930$exports.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgCreateValidator();
        message.description = object.description !== undefined && object.description !== null ? $41613f7385a625f3$exports.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $41613f7385a625f3$exports.CommissionRates.fromPartial(object.commission) : undefined;
        var _object_minSelfDelegation;
        message.minSelfDelegation = (_object_minSelfDelegation = object.minSelfDelegation) !== null && _object_minSelfDelegation !== void 0 ? _object_minSelfDelegation : "";
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $DM7bi.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgCreateValidatorResponse() {
    return {};
}
$83b4166ddf6d1939$exports.MsgCreateValidatorResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgCreateValidatorResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $83b4166ddf6d1939$var$createBaseMsgCreateValidatorResponse();
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: ""
    };
}
$83b4166ddf6d1939$exports.MsgEditValidator = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.description !== undefined) $41613f7385a625f3$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgEditValidator();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $41613f7385a625f3$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            description: (0, $7iZIe.isSet)(object.description) ? $41613f7385a625f3$exports.Description.fromJSON(object.description) : undefined,
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: (0, $7iZIe.isSet)(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: (0, $7iZIe.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.description !== undefined && (obj.description = message.description ? $41613f7385a625f3$exports.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgEditValidator();
        message.description = object.description !== undefined && object.description !== null ? $41613f7385a625f3$exports.Description.fromPartial(object.description) : undefined;
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        var _object_commissionRate;
        message.commissionRate = (_object_commissionRate = object.commissionRate) !== null && _object_commissionRate !== void 0 ? _object_commissionRate : "";
        var _object_minSelfDelegation;
        message.minSelfDelegation = (_object_minSelfDelegation = object.minSelfDelegation) !== null && _object_minSelfDelegation !== void 0 ? _object_minSelfDelegation : "";
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgEditValidatorResponse() {
    return {};
}
$83b4166ddf6d1939$exports.MsgEditValidatorResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgEditValidatorResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $83b4166ddf6d1939$var$createBaseMsgEditValidatorResponse();
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
$83b4166ddf6d1939$exports.MsgDelegate = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgDelegate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $5bc8eb379b028930$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgDelegate();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgDelegateResponse() {
    return {};
}
$83b4166ddf6d1939$exports.MsgDelegateResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $83b4166ddf6d1939$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined
    };
}
$83b4166ddf6d1939$exports.MsgBeginRedelegate = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgBeginRedelegate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $7iZIe.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $7iZIe.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $5bc8eb379b028930$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgBeginRedelegate();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorSrcAddress;
        message.validatorSrcAddress = (_object_validatorSrcAddress = object.validatorSrcAddress) !== null && _object_validatorSrcAddress !== void 0 ? _object_validatorSrcAddress : "";
        var _object_validatorDstAddress;
        message.validatorDstAddress = (_object_validatorDstAddress = object.validatorDstAddress) !== null && _object_validatorDstAddress !== void 0 ? _object_validatorDstAddress : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined
    };
}
$83b4166ddf6d1939$exports.MsgBeginRedelegateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.completionTime !== undefined) $ib0XJ.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgBeginRedelegateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            completionTime: (0, $7iZIe.isSet)(object.completionTime) ? (0, $7iZIe.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $7iZIe.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgBeginRedelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $ib0XJ.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
$83b4166ddf6d1939$exports.MsgUndelegate = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $5bc8eb379b028930$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgUndelegate();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined
    };
}
$83b4166ddf6d1939$exports.MsgUndelegateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.completionTime !== undefined) $ib0XJ.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            completionTime: (0, $7iZIe.isSet)(object.completionTime) ? (0, $7iZIe.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $7iZIe.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgUndelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $ib0XJ.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgCancelUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        creationHeight: $7iZIe.Long.ZERO
    };
}
$83b4166ddf6d1939$exports.MsgCancelUnbondingDelegation = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $5bc8eb379b028930$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        if (!message.creationHeight.isZero()) writer.uint32(32).int64(message.creationHeight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgCancelUnbondingDelegation();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.creationHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddress: (0, $7iZIe.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $7iZIe.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $7iZIe.isSet)(object.amount) ? $5bc8eb379b028930$exports.Coin.fromJSON(object.amount) : undefined,
            creationHeight: (0, $7iZIe.isSet)(object.creationHeight) ? $7iZIe.Long.fromValue(object.creationHeight) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $5bc8eb379b028930$exports.Coin.toJSON(message.amount) : undefined);
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgCancelUnbondingDelegation();
        var _object_delegatorAddress;
        message.delegatorAddress = (_object_delegatorAddress = object.delegatorAddress) !== null && _object_delegatorAddress !== void 0 ? _object_delegatorAddress : "";
        var _object_validatorAddress;
        message.validatorAddress = (_object_validatorAddress = object.validatorAddress) !== null && _object_validatorAddress !== void 0 ? _object_validatorAddress : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $5bc8eb379b028930$exports.Coin.fromPartial(object.amount) : undefined;
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $7iZIe.Long.fromValue(object.creationHeight) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgCancelUnbondingDelegationResponse() {
    return {};
}
$83b4166ddf6d1939$exports.MsgCancelUnbondingDelegationResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgCancelUnbondingDelegationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $83b4166ddf6d1939$var$createBaseMsgCancelUnbondingDelegationResponse();
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$83b4166ddf6d1939$exports.MsgUpdateParams = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $41613f7385a625f3$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $41613f7385a625f3$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: (0, $7iZIe.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $7iZIe.isSet)(object.params) ? $41613f7385a625f3$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $41613f7385a625f3$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $83b4166ddf6d1939$var$createBaseMsgUpdateParams();
        var _object_authority;
        message.authority = (_object_authority = object.authority) !== null && _object_authority !== void 0 ? _object_authority : "";
        message.params = object.params !== undefined && object.params !== null ? $41613f7385a625f3$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $83b4166ddf6d1939$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$83b4166ddf6d1939$exports.MsgUpdateParamsResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $83b4166ddf6d1939$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $83b4166ddf6d1939$var$_m0.Reader ? input : new $83b4166ddf6d1939$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $83b4166ddf6d1939$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $83b4166ddf6d1939$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
var $83b4166ddf6d1939$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
        this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "CreateValidator",
            value: function CreateValidator(request) {
                var data = $83b4166ddf6d1939$exports.MsgCreateValidator.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgCreateValidatorResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "EditValidator",
            value: function EditValidator(request) {
                var data = $83b4166ddf6d1939$exports.MsgEditValidator.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgEditValidatorResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Delegate",
            value: function Delegate(request) {
                var data = $83b4166ddf6d1939$exports.MsgDelegate.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgDelegateResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "BeginRedelegate",
            value: function BeginRedelegate(request) {
                var data = $83b4166ddf6d1939$exports.MsgBeginRedelegate.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgBeginRedelegateResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Undelegate",
            value: function Undelegate(request) {
                var data = $83b4166ddf6d1939$exports.MsgUndelegate.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgUndelegateResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "CancelUnbondingDelegation",
            value: function CancelUnbondingDelegation(request) {
                var data = $83b4166ddf6d1939$exports.MsgCancelUnbondingDelegation.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgCancelUnbondingDelegationResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateParams",
            value: function UpdateParams(request) {
                var data = $83b4166ddf6d1939$exports.MsgUpdateParams.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", data);
                return promise.then(function(data) {
                    return $83b4166ddf6d1939$exports.MsgUpdateParamsResponse.decode(new $83b4166ddf6d1939$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$83b4166ddf6d1939$exports.MsgClientImpl = $83b4166ddf6d1939$var$MsgClientImpl;


$6d835ac12c5db160$exports.stakingTypes = [
    [
        "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        $83b4166ddf6d1939$exports.MsgBeginRedelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgCreateValidator",
        $83b4166ddf6d1939$exports.MsgCreateValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgDelegate",
        $83b4166ddf6d1939$exports.MsgDelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgEditValidator",
        $83b4166ddf6d1939$exports.MsgEditValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgUndelegate",
        $83b4166ddf6d1939$exports.MsgUndelegate
    ]
];
function $6d835ac12c5db160$var$isMsgBeginRedelegateEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
$6d835ac12c5db160$exports.isMsgBeginRedelegateEncodeObject = $6d835ac12c5db160$var$isMsgBeginRedelegateEncodeObject;
function $6d835ac12c5db160$var$isMsgCreateValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
$6d835ac12c5db160$exports.isMsgCreateValidatorEncodeObject = $6d835ac12c5db160$var$isMsgCreateValidatorEncodeObject;
function $6d835ac12c5db160$var$isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
$6d835ac12c5db160$exports.isMsgDelegateEncodeObject = $6d835ac12c5db160$var$isMsgDelegateEncodeObject;
function $6d835ac12c5db160$var$isMsgEditValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
$6d835ac12c5db160$exports.isMsgEditValidatorEncodeObject = $6d835ac12c5db160$var$isMsgEditValidatorEncodeObject;
function $6d835ac12c5db160$var$isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
$6d835ac12c5db160$exports.isMsgUndelegateEncodeObject = $6d835ac12c5db160$var$isMsgUndelegateEncodeObject;


Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $6d835ac12c5db160$exports.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function get() {
        return $6d835ac12c5db160$exports.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $6d835ac12c5db160$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function get() {
        return $6d835ac12c5db160$exports.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $6d835ac12c5db160$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "stakingTypes", {
    enumerable: true,
    get: function get() {
        return $6d835ac12c5db160$exports.stakingTypes;
    }
});
var $c7ac9cfad541b4f8$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $c7ac9cfad541b4f8$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c7ac9cfad541b4f8$exports, "__esModule", {
    value: true
});
$c7ac9cfad541b4f8$exports.setupStakingExtension = void 0;
var $3452e709ea36c204$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $3452e709ea36c204$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3452e709ea36c204$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3452e709ea36c204$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3452e709ea36c204$var$__createBinding(result, mod, k);
    }
    $3452e709ea36c204$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3452e709ea36c204$exports, "__esModule", {
    value: true
});
$3452e709ea36c204$exports.QueryClientImpl = $3452e709ea36c204$exports.QueryParamsResponse = $3452e709ea36c204$exports.QueryParamsRequest = $3452e709ea36c204$exports.QueryPoolResponse = $3452e709ea36c204$exports.QueryPoolRequest = $3452e709ea36c204$exports.QueryHistoricalInfoResponse = $3452e709ea36c204$exports.QueryHistoricalInfoRequest = $3452e709ea36c204$exports.QueryDelegatorValidatorResponse = $3452e709ea36c204$exports.QueryDelegatorValidatorRequest = $3452e709ea36c204$exports.QueryDelegatorValidatorsResponse = $3452e709ea36c204$exports.QueryDelegatorValidatorsRequest = $3452e709ea36c204$exports.QueryRedelegationsResponse = $3452e709ea36c204$exports.QueryRedelegationsRequest = $3452e709ea36c204$exports.QueryDelegatorUnbondingDelegationsResponse = $3452e709ea36c204$exports.QueryDelegatorUnbondingDelegationsRequest = $3452e709ea36c204$exports.QueryDelegatorDelegationsResponse = $3452e709ea36c204$exports.QueryDelegatorDelegationsRequest = $3452e709ea36c204$exports.QueryUnbondingDelegationResponse = $3452e709ea36c204$exports.QueryUnbondingDelegationRequest = $3452e709ea36c204$exports.QueryDelegationResponse = $3452e709ea36c204$exports.QueryDelegationRequest = $3452e709ea36c204$exports.QueryValidatorUnbondingDelegationsResponse = $3452e709ea36c204$exports.QueryValidatorUnbondingDelegationsRequest = $3452e709ea36c204$exports.QueryValidatorDelegationsResponse = $3452e709ea36c204$exports.QueryValidatorDelegationsRequest = $3452e709ea36c204$exports.QueryValidatorResponse = $3452e709ea36c204$exports.QueryValidatorRequest = $3452e709ea36c204$exports.QueryValidatorsResponse = $3452e709ea36c204$exports.QueryValidatorsRequest = $3452e709ea36c204$exports.protobufPackage = void 0;



var $7iZIe = parcelRequire("7iZIe");

var $3452e709ea36c204$var$_m0 = $3452e709ea36c204$var$__importStar((parcelRequire("hjb8Q")));
$3452e709ea36c204$exports.protobufPackage = "cosmos.staking.v1beta1";
function $3452e709ea36c204$var$createBaseQueryValidatorsRequest() {
    return {
        status: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.status !== "") writer.uint32(10).string(message.status);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            status: (0, $7iZIe.isSet)(object.status) ? String(object.status) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryValidatorsRequest();
        var _object_status;
        message.status = (_object_status = object.status) !== null && _object_status !== void 0 ? _object_status : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($41613f7385a625f3$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(function(e) {
                return $41613f7385a625f3$exports.Validator.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.validators) obj.validators = message.validators.map(function(e) {
            return e ? $41613f7385a625f3$exports.Validator.toJSON(e) : undefined;
        });
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_validators;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorsResponse();
        message.validators = ((_object_validators = object.validators) === null || _object_validators === void 0 ? void 0 : _object_validators.map(function(e) {
            return $41613f7385a625f3$exports.Validator.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorRequest() {
    return {
        validatorAddr: ""
    };
}
$3452e709ea36c204$exports.QueryValidatorRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddr: (0, $7iZIe.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryValidatorRequest();
        var _object_validatorAddr;
        message.validatorAddr = (_object_validatorAddr = object.validatorAddr) !== null && _object_validatorAddr !== void 0 ? _object_validatorAddr : "";
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorResponse() {
    return {
        validator: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.validator !== undefined) $41613f7385a625f3$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $41613f7385a625f3$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validator: (0, $7iZIe.isSet)(object.validator) ? $41613f7385a625f3$exports.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $41613f7385a625f3$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $41613f7385a625f3$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorDelegationsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorDelegationsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddr: (0, $7iZIe.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryValidatorDelegationsRequest();
        var _object_validatorAddr;
        message.validatorAddr = (_object_validatorAddr = object.validatorAddr) !== null && _object_validatorAddr !== void 0 ? _object_validatorAddr : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorDelegationsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.delegationResponses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorDelegationsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($41613f7385a625f3$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.delegationResponses) ? object.delegationResponses.map(function(e) {
                return $41613f7385a625f3$exports.DelegationResponse.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map(function(e) {
            return e ? $41613f7385a625f3$exports.DelegationResponse.toJSON(e) : undefined;
        });
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_delegationResponses;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorDelegationsResponse();
        message.delegationResponses = ((_object_delegationResponses = object.delegationResponses) === null || _object_delegationResponses === void 0 ? void 0 : _object_delegationResponses.map(function(e) {
            return $41613f7385a625f3$exports.DelegationResponse.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorUnbondingDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorUnbondingDelegationsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validatorAddr: (0, $7iZIe.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        var _object_validatorAddr;
        message.validatorAddr = (_object_validatorAddr = object.validatorAddr) !== null && _object_validatorAddr !== void 0 ? _object_validatorAddr : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryValidatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryValidatorUnbondingDelegationsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.unbondingResponses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($41613f7385a625f3$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            unbondingResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.unbondingResponses) ? object.unbondingResponses.map(function(e) {
                return $41613f7385a625f3$exports.UnbondingDelegation.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map(function(e) {
            return e ? $41613f7385a625f3$exports.UnbondingDelegation.toJSON(e) : undefined;
        });
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_unbondingResponses;
        var message = $3452e709ea36c204$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        message.unbondingResponses = ((_object_unbondingResponses = object.unbondingResponses) === null || _object_unbondingResponses === void 0 ? void 0 : _object_unbondingResponses.map(function(e) {
            return $41613f7385a625f3$exports.UnbondingDelegation.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$3452e709ea36c204$exports.QueryDelegationRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegationRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $7iZIe.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegationRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        var _object_validatorAddr;
        message.validatorAddr = (_object_validatorAddr = object.validatorAddr) !== null && _object_validatorAddr !== void 0 ? _object_validatorAddr : "";
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegationResponse() {
    return {
        delegationResponse: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegationResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegationResponse !== undefined) $41613f7385a625f3$exports.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponse = $41613f7385a625f3$exports.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegationResponse: (0, $7iZIe.isSet)(object.delegationResponse) ? $41613f7385a625f3$exports.DelegationResponse.fromJSON(object.delegationResponse) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegationResponse !== undefined && (obj.delegationResponse = message.delegationResponse ? $41613f7385a625f3$exports.DelegationResponse.toJSON(message.delegationResponse) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegationResponse();
        message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? $41613f7385a625f3$exports.DelegationResponse.fromPartial(object.delegationResponse) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryUnbondingDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$3452e709ea36c204$exports.QueryUnbondingDelegationRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryUnbondingDelegationRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $7iZIe.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryUnbondingDelegationRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        var _object_validatorAddr;
        message.validatorAddr = (_object_validatorAddr = object.validatorAddr) !== null && _object_validatorAddr !== void 0 ? _object_validatorAddr : "";
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryUnbondingDelegationResponse() {
    return {
        unbond: undefined
    };
}
$3452e709ea36c204$exports.QueryUnbondingDelegationResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.unbond !== undefined) $41613f7385a625f3$exports.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryUnbondingDelegationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbond = $41613f7385a625f3$exports.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            unbond: (0, $7iZIe.isSet)(object.unbond) ? $41613f7385a625f3$exports.UnbondingDelegation.fromJSON(object.unbond) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.unbond !== undefined && (obj.unbond = message.unbond ? $41613f7385a625f3$exports.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryUnbondingDelegationResponse();
        message.unbond = object.unbond !== undefined && object.unbond !== null ? $41613f7385a625f3$exports.UnbondingDelegation.fromPartial(object.unbond) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorDelegationsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorDelegationsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorDelegationsRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorDelegationsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.delegationResponses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorDelegationsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($41613f7385a625f3$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.delegationResponses) ? object.delegationResponses.map(function(e) {
                return $41613f7385a625f3$exports.DelegationResponse.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map(function(e) {
            return e ? $41613f7385a625f3$exports.DelegationResponse.toJSON(e) : undefined;
        });
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_delegationResponses;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorDelegationsResponse();
        message.delegationResponses = ((_object_delegationResponses = object.delegationResponses) === null || _object_delegationResponses === void 0 ? void 0 : _object_delegationResponses.map(function(e) {
            return $41613f7385a625f3$exports.DelegationResponse.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorUnbondingDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.unbondingResponses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($41613f7385a625f3$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            unbondingResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.unbondingResponses) ? object.unbondingResponses.map(function(e) {
                return $41613f7385a625f3$exports.UnbondingDelegation.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map(function(e) {
            return e ? $41613f7385a625f3$exports.UnbondingDelegation.toJSON(e) : undefined;
        });
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_unbondingResponses;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        message.unbondingResponses = ((_object_unbondingResponses = object.unbondingResponses) === null || _object_unbondingResponses === void 0 ? void 0 : _object_unbondingResponses.map(function(e) {
            return $41613f7385a625f3$exports.UnbondingDelegation.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryRedelegationsRequest() {
    return {
        delegatorAddr: "",
        srcValidatorAddr: "",
        dstValidatorAddr: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryRedelegationsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.srcValidatorAddr !== "") writer.uint32(18).string(message.srcValidatorAddr);
        if (message.dstValidatorAddr !== "") writer.uint32(26).string(message.dstValidatorAddr);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryRedelegationsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            srcValidatorAddr: (0, $7iZIe.isSet)(object.srcValidatorAddr) ? String(object.srcValidatorAddr) : "",
            dstValidatorAddr: (0, $7iZIe.isSet)(object.dstValidatorAddr) ? String(object.dstValidatorAddr) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryRedelegationsRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        var _object_srcValidatorAddr;
        message.srcValidatorAddr = (_object_srcValidatorAddr = object.srcValidatorAddr) !== null && _object_srcValidatorAddr !== void 0 ? _object_srcValidatorAddr : "";
        var _object_dstValidatorAddr;
        message.dstValidatorAddr = (_object_dstValidatorAddr = object.dstValidatorAddr) !== null && _object_dstValidatorAddr !== void 0 ? _object_dstValidatorAddr : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryRedelegationsResponse() {
    return {
        redelegationResponses: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryRedelegationsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.redelegationResponses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryRedelegationsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationResponses.push($41613f7385a625f3$exports.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            redelegationResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.redelegationResponses) ? object.redelegationResponses.map(function(e) {
                return $41613f7385a625f3$exports.RedelegationResponse.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.redelegationResponses) obj.redelegationResponses = message.redelegationResponses.map(function(e) {
            return e ? $41613f7385a625f3$exports.RedelegationResponse.toJSON(e) : undefined;
        });
        else obj.redelegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_redelegationResponses;
        var message = $3452e709ea36c204$var$createBaseQueryRedelegationsResponse();
        message.redelegationResponses = ((_object_redelegationResponses = object.redelegationResponses) === null || _object_redelegationResponses === void 0 ? void 0 : _object_redelegationResponses.map(function(e) {
            return $41613f7385a625f3$exports.RedelegationResponse.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorValidatorsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorsRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorValidatorsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $41613f7385a625f3$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($41613f7385a625f3$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map(function(e) {
                return $41613f7385a625f3$exports.Validator.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.validators) obj.validators = message.validators.map(function(e) {
            return e ? $41613f7385a625f3$exports.Validator.toJSON(e) : undefined;
        });
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_validators;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = ((_object_validators = object.validators) === null || _object_validators === void 0 ? void 0 : _object_validators.map(function(e) {
            return $41613f7385a625f3$exports.Validator.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorValidatorRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$3452e709ea36c204$exports.QueryDelegatorValidatorRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            delegatorAddr: (0, $7iZIe.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $7iZIe.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorRequest();
        var _object_delegatorAddr;
        message.delegatorAddr = (_object_delegatorAddr = object.delegatorAddr) !== null && _object_delegatorAddr !== void 0 ? _object_delegatorAddr : "";
        var _object_validatorAddr;
        message.validatorAddr = (_object_validatorAddr = object.validatorAddr) !== null && _object_validatorAddr !== void 0 ? _object_validatorAddr : "";
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryDelegatorValidatorResponse() {
    return {
        validator: undefined
    };
}
$3452e709ea36c204$exports.QueryDelegatorValidatorResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.validator !== undefined) $41613f7385a625f3$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $41613f7385a625f3$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            validator: (0, $7iZIe.isSet)(object.validator) ? $41613f7385a625f3$exports.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $41613f7385a625f3$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryDelegatorValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $41613f7385a625f3$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryHistoricalInfoRequest() {
    return {
        height: $7iZIe.Long.ZERO
    };
}
$3452e709ea36c204$exports.QueryHistoricalInfoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryHistoricalInfoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryHistoricalInfoRequest();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryHistoricalInfoResponse() {
    return {
        hist: undefined
    };
}
$3452e709ea36c204$exports.QueryHistoricalInfoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.hist !== undefined) $41613f7385a625f3$exports.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryHistoricalInfoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hist = $41613f7385a625f3$exports.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hist: (0, $7iZIe.isSet)(object.hist) ? $41613f7385a625f3$exports.HistoricalInfo.fromJSON(object.hist) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? $41613f7385a625f3$exports.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryHistoricalInfoResponse();
        message.hist = object.hist !== undefined && object.hist !== null ? $41613f7385a625f3$exports.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryPoolRequest() {
    return {};
}
$3452e709ea36c204$exports.QueryPoolRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryPoolRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $3452e709ea36c204$var$createBaseQueryPoolRequest();
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryPoolResponse() {
    return {
        pool: undefined
    };
}
$3452e709ea36c204$exports.QueryPoolResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.pool !== undefined) $41613f7385a625f3$exports.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool = $41613f7385a625f3$exports.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pool: (0, $7iZIe.isSet)(object.pool) ? $41613f7385a625f3$exports.Pool.fromJSON(object.pool) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? $41613f7385a625f3$exports.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryPoolResponse();
        message.pool = object.pool !== undefined && object.pool !== null ? $41613f7385a625f3$exports.Pool.fromPartial(object.pool) : undefined;
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryParamsRequest() {
    return {};
}
$3452e709ea36c204$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $3452e709ea36c204$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $3452e709ea36c204$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$3452e709ea36c204$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $3452e709ea36c204$var$_m0.Writer.create();
        if (message.params !== undefined) $41613f7385a625f3$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3452e709ea36c204$var$_m0.Reader ? input : new $3452e709ea36c204$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3452e709ea36c204$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $41613f7385a625f3$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $41613f7385a625f3$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $41613f7385a625f3$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $3452e709ea36c204$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $41613f7385a625f3$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
var $3452e709ea36c204$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "Validators",
            value: function Validators(request) {
                var data = $3452e709ea36c204$exports.QueryValidatorsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryValidatorsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Validator",
            value: function Validator(request) {
                var data = $3452e709ea36c204$exports.QueryValidatorRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryValidatorResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ValidatorDelegations",
            value: function ValidatorDelegations(request) {
                var data = $3452e709ea36c204$exports.QueryValidatorDelegationsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryValidatorDelegationsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ValidatorUnbondingDelegations",
            value: function ValidatorUnbondingDelegations(request) {
                var data = $3452e709ea36c204$exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryValidatorUnbondingDelegationsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Delegation",
            value: function Delegation(request) {
                var data = $3452e709ea36c204$exports.QueryDelegationRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryDelegationResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UnbondingDelegation",
            value: function UnbondingDelegation(request) {
                var data = $3452e709ea36c204$exports.QueryUnbondingDelegationRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryUnbondingDelegationResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegatorDelegations",
            value: function DelegatorDelegations(request) {
                var data = $3452e709ea36c204$exports.QueryDelegatorDelegationsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryDelegatorDelegationsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegatorUnbondingDelegations",
            value: function DelegatorUnbondingDelegations(request) {
                var data = $3452e709ea36c204$exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryDelegatorUnbondingDelegationsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Redelegations",
            value: function Redelegations(request) {
                var data = $3452e709ea36c204$exports.QueryRedelegationsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryRedelegationsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegatorValidators",
            value: function DelegatorValidators(request) {
                var data = $3452e709ea36c204$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryDelegatorValidatorsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "DelegatorValidator",
            value: function DelegatorValidator(request) {
                var data = $3452e709ea36c204$exports.QueryDelegatorValidatorRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryDelegatorValidatorResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "HistoricalInfo",
            value: function HistoricalInfo(request) {
                var data = $3452e709ea36c204$exports.QueryHistoricalInfoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryHistoricalInfoResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Pool",
            value: function Pool() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $3452e709ea36c204$exports.QueryPoolRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryPoolResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $3452e709ea36c204$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
                return promise.then(function(data) {
                    return $3452e709ea36c204$exports.QueryParamsResponse.decode(new $3452e709ea36c204$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$3452e709ea36c204$exports.QueryClientImpl = $3452e709ea36c204$var$QueryClientImpl;



var $c7ac9cfad541b4f8$var$long_1 = $c7ac9cfad541b4f8$var$__importDefault((parcelRequire("l6G6L")));

function $c7ac9cfad541b4f8$var$setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    var queryService = new $3452e709ea36c204$exports.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Delegation({
                                        delegatorAddr: delegatorAddress,
                                        validatorAddr: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegatorDelegations: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegatorDelegations({
                                        delegatorAddr: delegatorAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegatorUnbondingDelegations: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegatorUnbondingDelegations({
                                        delegatorAddr: delegatorAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegatorValidator: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegatorValidator({
                                        delegatorAddr: delegatorAddress,
                                        validatorAddr: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delegatorValidators: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.DelegatorValidators({
                                        delegatorAddr: delegatorAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            historicalInfo: function() {
                var _ref = (0, $6rBFC._)(function(height) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.HistoricalInfo({
                                        height: $c7ac9cfad541b4f8$var$long_1.default.fromNumber(height, true)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(height) {
                    return _ref.apply(this, arguments);
                };
            }(),
            params: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var response;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.Params({})
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response
                            ];
                    }
                });
            }),
            pool: /*#__PURE__*/ (0, $6rBFC._)(function() {
                var response;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                queryService.Pool({})
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response
                            ];
                    }
                });
            }),
            redelegations: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Redelegations({
                                        delegatorAddr: delegatorAddress,
                                        srcValidatorAddr: sourceValidatorAddress,
                                        dstValidatorAddr: destinationValidatorAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            unbondingDelegation: function() {
                var _ref = (0, $6rBFC._)(function(delegatorAddress, validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.UnbondingDelegation({
                                        delegatorAddr: delegatorAddress,
                                        validatorAddr: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(delegatorAddress, validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            validator: function() {
                var _ref = (0, $6rBFC._)(function(validatorAddress) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Validator({
                                        validatorAddr: validatorAddress
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(validatorAddress) {
                    return _ref.apply(this, arguments);
                };
            }(),
            validatorDelegations: function() {
                var _ref = (0, $6rBFC._)(function(validatorAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.ValidatorDelegations({
                                        validatorAddr: validatorAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(validatorAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            validators: function() {
                var _ref = (0, $6rBFC._)(function(status, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.Validators({
                                        status: status,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(status, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            validatorUnbondingDelegations: function() {
                var _ref = (0, $6rBFC._)(function(validatorAddress, paginationKey) {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    queryService.ValidatorUnbondingDelegations({
                                        validatorAddr: validatorAddress,
                                        pagination: (0, $0f41f7d88b60184b$exports.createPagination)(paginationKey)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(validatorAddress, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$c7ac9cfad541b4f8$exports.setupStakingExtension = $c7ac9cfad541b4f8$var$setupStakingExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupStakingExtension", {
    enumerable: true,
    get: function get() {
        return $c7ac9cfad541b4f8$exports.setupStakingExtension;
    }
});
var $67fb6423506f0ef4$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $67fb6423506f0ef4$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($67fb6423506f0ef4$exports, "__esModule", {
    value: true
});
$67fb6423506f0ef4$exports.setupTxExtension = void 0;


var $13bf950853937dd3$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $13bf950853937dd3$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $13bf950853937dd3$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $13bf950853937dd3$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $13bf950853937dd3$var$__createBinding(result, mod, k);
    }
    $13bf950853937dd3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($13bf950853937dd3$exports, "__esModule", {
    value: true
});
$13bf950853937dd3$exports.ServiceClientImpl = $13bf950853937dd3$exports.TxDecodeAminoResponse = $13bf950853937dd3$exports.TxDecodeAminoRequest = $13bf950853937dd3$exports.TxEncodeAminoResponse = $13bf950853937dd3$exports.TxEncodeAminoRequest = $13bf950853937dd3$exports.TxEncodeResponse = $13bf950853937dd3$exports.TxEncodeRequest = $13bf950853937dd3$exports.TxDecodeResponse = $13bf950853937dd3$exports.TxDecodeRequest = $13bf950853937dd3$exports.GetBlockWithTxsResponse = $13bf950853937dd3$exports.GetBlockWithTxsRequest = $13bf950853937dd3$exports.GetTxResponse = $13bf950853937dd3$exports.GetTxRequest = $13bf950853937dd3$exports.SimulateResponse = $13bf950853937dd3$exports.SimulateRequest = $13bf950853937dd3$exports.BroadcastTxResponse = $13bf950853937dd3$exports.BroadcastTxRequest = $13bf950853937dd3$exports.GetTxsEventResponse = $13bf950853937dd3$exports.GetTxsEventRequest = $13bf950853937dd3$exports.broadcastModeToJSON = $13bf950853937dd3$exports.broadcastModeFromJSON = $13bf950853937dd3$exports.BroadcastMode = $13bf950853937dd3$exports.orderByToJSON = $13bf950853937dd3$exports.orderByFromJSON = $13bf950853937dd3$exports.OrderBy = $13bf950853937dd3$exports.protobufPackage = void 0;


var $81693c046571dbd5$exports = {};
"use strict";
var $81693c046571dbd5$var$__createBinding = $81693c046571dbd5$exports && $81693c046571dbd5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $81693c046571dbd5$var$__setModuleDefault = $81693c046571dbd5$exports && $81693c046571dbd5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $81693c046571dbd5$var$__importStar = $81693c046571dbd5$exports && $81693c046571dbd5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $81693c046571dbd5$var$__createBinding(result, mod, k);
    }
    $81693c046571dbd5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($81693c046571dbd5$exports, "__esModule", {
    value: true
});
$81693c046571dbd5$exports.SearchTxsResult = $81693c046571dbd5$exports.TxMsgData = $81693c046571dbd5$exports.MsgData = $81693c046571dbd5$exports.SimulationResponse = $81693c046571dbd5$exports.Result = $81693c046571dbd5$exports.GasInfo = $81693c046571dbd5$exports.Attribute = $81693c046571dbd5$exports.StringEvent = $81693c046571dbd5$exports.ABCIMessageLog = $81693c046571dbd5$exports.TxResponse = $81693c046571dbd5$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");


var $7iZIe = parcelRequire("7iZIe");

var $81693c046571dbd5$var$_m0 = $81693c046571dbd5$var$__importStar((parcelRequire("hjb8Q")));
$81693c046571dbd5$exports.protobufPackage = "cosmos.base.abci.v1beta1";
function $81693c046571dbd5$var$createBaseTxResponse() {
    return {
        height: $7iZIe.Long.ZERO,
        txhash: "",
        codespace: "",
        code: 0,
        data: "",
        rawLog: "",
        logs: [],
        info: "",
        gasWanted: $7iZIe.Long.ZERO,
        gasUsed: $7iZIe.Long.ZERO,
        tx: undefined,
        timestamp: "",
        events: []
    };
}
$81693c046571dbd5$exports.TxResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.txhash !== "") writer.uint32(18).string(message.txhash);
        if (message.codespace !== "") writer.uint32(26).string(message.codespace);
        if (message.code !== 0) writer.uint32(32).uint32(message.code);
        if (message.data !== "") writer.uint32(42).string(message.data);
        if (message.rawLog !== "") writer.uint32(50).string(message.rawLog);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.logs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $81693c046571dbd5$exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.info !== "") writer.uint32(66).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(72).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(80).int64(message.gasUsed);
        if (message.tx !== undefined) $DM7bi.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        if (message.timestamp !== "") writer.uint32(98).string(message.timestamp);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.events[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $1e86d63877b86916$exports.Event.encode(v1, writer.uint32(106).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseTxResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push($81693c046571dbd5$exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push($1e86d63877b86916$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            txhash: (0, $7iZIe.isSet)(object.txhash) ? String(object.txhash) : "",
            codespace: (0, $7iZIe.isSet)(object.codespace) ? String(object.codespace) : "",
            code: (0, $7iZIe.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $7iZIe.isSet)(object.data) ? String(object.data) : "",
            rawLog: (0, $7iZIe.isSet)(object.rawLog) ? String(object.rawLog) : "",
            logs: Array.isArray(object === null || object === void 0 ? void 0 : object.logs) ? object.logs.map(function(e) {
                return $81693c046571dbd5$exports.ABCIMessageLog.fromJSON(e);
            }) : [],
            info: (0, $7iZIe.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $7iZIe.isSet)(object.gasWanted) ? $7iZIe.Long.fromValue(object.gasWanted) : $7iZIe.Long.ZERO,
            gasUsed: (0, $7iZIe.isSet)(object.gasUsed) ? $7iZIe.Long.fromValue(object.gasUsed) : $7iZIe.Long.ZERO,
            tx: (0, $7iZIe.isSet)(object.tx) ? $DM7bi.Any.fromJSON(object.tx) : undefined,
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? String(object.timestamp) : "",
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $1e86d63877b86916$exports.Event.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) obj.logs = message.logs.map(function(e) {
            return e ? $81693c046571dbd5$exports.ABCIMessageLog.toJSON(e) : undefined;
        });
        else obj.logs = [];
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $7iZIe.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $7iZIe.Long.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? $DM7bi.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $1e86d63877b86916$exports.Event.toJSON(e) : undefined;
        });
        else obj.events = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_logs, _object_events;
        var message = $81693c046571dbd5$var$createBaseTxResponse();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        var _object_txhash;
        message.txhash = (_object_txhash = object.txhash) !== null && _object_txhash !== void 0 ? _object_txhash : "";
        var _object_codespace;
        message.codespace = (_object_codespace = object.codespace) !== null && _object_codespace !== void 0 ? _object_codespace : "";
        var _object_code;
        message.code = (_object_code = object.code) !== null && _object_code !== void 0 ? _object_code : 0;
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : "";
        var _object_rawLog;
        message.rawLog = (_object_rawLog = object.rawLog) !== null && _object_rawLog !== void 0 ? _object_rawLog : "";
        message.logs = ((_object_logs = object.logs) === null || _object_logs === void 0 ? void 0 : _object_logs.map(function(e) {
            return $81693c046571dbd5$exports.ABCIMessageLog.fromPartial(e);
        })) || [];
        var _object_info;
        message.info = (_object_info = object.info) !== null && _object_info !== void 0 ? _object_info : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $7iZIe.Long.fromValue(object.gasWanted) : $7iZIe.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $7iZIe.Long.fromValue(object.gasUsed) : $7iZIe.Long.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? $DM7bi.Any.fromPartial(object.tx) : undefined;
        var _object_timestamp;
        message.timestamp = (_object_timestamp = object.timestamp) !== null && _object_timestamp !== void 0 ? _object_timestamp : "";
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $1e86d63877b86916$exports.Event.fromPartial(e);
        })) || [];
        return message;
    }
};
function $81693c046571dbd5$var$createBaseABCIMessageLog() {
    return {
        msgIndex: 0,
        log: "",
        events: []
    };
}
$81693c046571dbd5$exports.ABCIMessageLog = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (message.msgIndex !== 0) writer.uint32(8).uint32(message.msgIndex);
        if (message.log !== "") writer.uint32(18).string(message.log);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $81693c046571dbd5$exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseABCIMessageLog();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($81693c046571dbd5$exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            msgIndex: (0, $7iZIe.isSet)(object.msgIndex) ? Number(object.msgIndex) : 0,
            log: (0, $7iZIe.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $81693c046571dbd5$exports.StringEvent.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = Math.round(message.msgIndex));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $81693c046571dbd5$exports.StringEvent.toJSON(e) : undefined;
        });
        else obj.events = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_events;
        var message = $81693c046571dbd5$var$createBaseABCIMessageLog();
        var _object_msgIndex;
        message.msgIndex = (_object_msgIndex = object.msgIndex) !== null && _object_msgIndex !== void 0 ? _object_msgIndex : 0;
        var _object_log;
        message.log = (_object_log = object.log) !== null && _object_log !== void 0 ? _object_log : "";
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $81693c046571dbd5$exports.StringEvent.fromPartial(e);
        })) || [];
        return message;
    }
};
function $81693c046571dbd5$var$createBaseStringEvent() {
    return {
        type: "",
        attributes: []
    };
}
$81693c046571dbd5$exports.StringEvent = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (message.type !== "") writer.uint32(10).string(message.type);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $81693c046571dbd5$exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseStringEvent();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($81693c046571dbd5$exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type: (0, $7iZIe.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object === null || object === void 0 ? void 0 : object.attributes) ? object.attributes.map(function(e) {
                return $81693c046571dbd5$exports.Attribute.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map(function(e) {
            return e ? $81693c046571dbd5$exports.Attribute.toJSON(e) : undefined;
        });
        else obj.attributes = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_attributes;
        var message = $81693c046571dbd5$var$createBaseStringEvent();
        var _object_type;
        message.type = (_object_type = object.type) !== null && _object_type !== void 0 ? _object_type : "";
        message.attributes = ((_object_attributes = object.attributes) === null || _object_attributes === void 0 ? void 0 : _object_attributes.map(function(e) {
            return $81693c046571dbd5$exports.Attribute.fromPartial(e);
        })) || [];
        return message;
    }
};
function $81693c046571dbd5$var$createBaseAttribute() {
    return {
        key: "",
        value: ""
    };
}
$81693c046571dbd5$exports.Attribute = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseAttribute();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? String(object.key) : "",
            value: (0, $7iZIe.isSet)(object.value) ? String(object.value) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial: function(object) {
        var message = $81693c046571dbd5$var$createBaseAttribute();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : "";
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : "";
        return message;
    }
};
function $81693c046571dbd5$var$createBaseGasInfo() {
    return {
        gasWanted: $7iZIe.Long.UZERO,
        gasUsed: $7iZIe.Long.UZERO
    };
}
$81693c046571dbd5$exports.GasInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (!message.gasWanted.isZero()) writer.uint32(8).uint64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(16).uint64(message.gasUsed);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseGasInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            gasWanted: (0, $7iZIe.isSet)(object.gasWanted) ? $7iZIe.Long.fromValue(object.gasWanted) : $7iZIe.Long.UZERO,
            gasUsed: (0, $7iZIe.isSet)(object.gasUsed) ? $7iZIe.Long.fromValue(object.gasUsed) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $7iZIe.Long.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $81693c046571dbd5$var$createBaseGasInfo();
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $7iZIe.Long.fromValue(object.gasWanted) : $7iZIe.Long.UZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $7iZIe.Long.fromValue(object.gasUsed) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $81693c046571dbd5$var$createBaseResult() {
    return {
        data: new Uint8Array(),
        log: "",
        events: [],
        msgResponses: []
    };
}
$81693c046571dbd5$exports.Result = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.log !== "") writer.uint32(18).string(message.log);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1e86d63877b86916$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.msgResponses[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $DM7bi.Any.encode(v1, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($1e86d63877b86916$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.msgResponses.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $7iZIe.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return $1e86d63877b86916$exports.Event.fromJSON(e);
            }) : [],
            msgResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.msgResponses) ? object.msgResponses.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map(function(e) {
            return e ? $1e86d63877b86916$exports.Event.toJSON(e) : undefined;
        });
        else obj.events = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_events, _object_msgResponses;
        var message = $81693c046571dbd5$var$createBaseResult();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        var _object_log;
        message.log = (_object_log = object.log) !== null && _object_log !== void 0 ? _object_log : "";
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return $1e86d63877b86916$exports.Event.fromPartial(e);
        })) || [];
        message.msgResponses = ((_object_msgResponses = object.msgResponses) === null || _object_msgResponses === void 0 ? void 0 : _object_msgResponses.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        return message;
    }
};
function $81693c046571dbd5$var$createBaseSimulationResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
$81693c046571dbd5$exports.SimulationResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (message.gasInfo !== undefined) $81693c046571dbd5$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $81693c046571dbd5$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseSimulationResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $81693c046571dbd5$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $81693c046571dbd5$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            gasInfo: (0, $7iZIe.isSet)(object.gasInfo) ? $81693c046571dbd5$exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $7iZIe.isSet)(object.result) ? $81693c046571dbd5$exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $81693c046571dbd5$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $81693c046571dbd5$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $81693c046571dbd5$var$createBaseSimulationResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $81693c046571dbd5$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $81693c046571dbd5$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $81693c046571dbd5$var$createBaseMsgData() {
    return {
        msgType: "",
        data: new Uint8Array()
    };
}
$81693c046571dbd5$exports.MsgData = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (message.msgType !== "") writer.uint32(10).string(message.msgType);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseMsgData();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            msgType: (0, $7iZIe.isSet)(object.msgType) ? String(object.msgType) : "",
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $81693c046571dbd5$var$createBaseMsgData();
        var _object_msgType;
        message.msgType = (_object_msgType = object.msgType) !== null && _object_msgType !== void 0 ? _object_msgType : "";
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $81693c046571dbd5$var$createBaseTxMsgData() {
    return {
        data: [],
        msgResponses: []
    };
}
$81693c046571dbd5$exports.TxMsgData = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $81693c046571dbd5$exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.msgResponses[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $DM7bi.Any.encode(v1, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseTxMsgData();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data.push($81693c046571dbd5$exports.MsgData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.msgResponses.push($DM7bi.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map(function(e) {
                return $81693c046571dbd5$exports.MsgData.fromJSON(e);
            }) : [],
            msgResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.msgResponses) ? object.msgResponses.map(function(e) {
                return $DM7bi.Any.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.data) obj.data = message.data.map(function(e) {
            return e ? $81693c046571dbd5$exports.MsgData.toJSON(e) : undefined;
        });
        else obj.data = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map(function(e) {
            return e ? $DM7bi.Any.toJSON(e) : undefined;
        });
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_data, _object_msgResponses;
        var message = $81693c046571dbd5$var$createBaseTxMsgData();
        message.data = ((_object_data = object.data) === null || _object_data === void 0 ? void 0 : _object_data.map(function(e) {
            return $81693c046571dbd5$exports.MsgData.fromPartial(e);
        })) || [];
        message.msgResponses = ((_object_msgResponses = object.msgResponses) === null || _object_msgResponses === void 0 ? void 0 : _object_msgResponses.map(function(e) {
            return $DM7bi.Any.fromPartial(e);
        })) || [];
        return message;
    }
};
function $81693c046571dbd5$var$createBaseSearchTxsResult() {
    return {
        totalCount: $7iZIe.Long.UZERO,
        count: $7iZIe.Long.UZERO,
        pageNumber: $7iZIe.Long.UZERO,
        pageTotal: $7iZIe.Long.UZERO,
        limit: $7iZIe.Long.UZERO,
        txs: []
    };
}
$81693c046571dbd5$exports.SearchTxsResult = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $81693c046571dbd5$var$_m0.Writer.create();
        if (!message.totalCount.isZero()) writer.uint32(8).uint64(message.totalCount);
        if (!message.count.isZero()) writer.uint32(16).uint64(message.count);
        if (!message.pageNumber.isZero()) writer.uint32(24).uint64(message.pageNumber);
        if (!message.pageTotal.isZero()) writer.uint32(32).uint64(message.pageTotal);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $81693c046571dbd5$exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $81693c046571dbd5$var$_m0.Reader ? input : new $81693c046571dbd5$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $81693c046571dbd5$var$createBaseSearchTxsResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push($81693c046571dbd5$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            totalCount: (0, $7iZIe.isSet)(object.totalCount) ? $7iZIe.Long.fromValue(object.totalCount) : $7iZIe.Long.UZERO,
            count: (0, $7iZIe.isSet)(object.count) ? $7iZIe.Long.fromValue(object.count) : $7iZIe.Long.UZERO,
            pageNumber: (0, $7iZIe.isSet)(object.pageNumber) ? $7iZIe.Long.fromValue(object.pageNumber) : $7iZIe.Long.UZERO,
            pageTotal: (0, $7iZIe.isSet)(object.pageTotal) ? $7iZIe.Long.fromValue(object.pageTotal) : $7iZIe.Long.UZERO,
            limit: (0, $7iZIe.isSet)(object.limit) ? $7iZIe.Long.fromValue(object.limit) : $7iZIe.Long.UZERO,
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return $81693c046571dbd5$exports.TxResponse.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || $7iZIe.Long.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || $7iZIe.Long.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || $7iZIe.Long.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || $7iZIe.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $7iZIe.Long.UZERO).toString());
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return e ? $81693c046571dbd5$exports.TxResponse.toJSON(e) : undefined;
        });
        else obj.txs = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs;
        var message = $81693c046571dbd5$var$createBaseSearchTxsResult();
        message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? $7iZIe.Long.fromValue(object.totalCount) : $7iZIe.Long.UZERO;
        message.count = object.count !== undefined && object.count !== null ? $7iZIe.Long.fromValue(object.count) : $7iZIe.Long.UZERO;
        message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? $7iZIe.Long.fromValue(object.pageNumber) : $7iZIe.Long.UZERO;
        message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? $7iZIe.Long.fromValue(object.pageTotal) : $7iZIe.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $7iZIe.Long.fromValue(object.limit) : $7iZIe.Long.UZERO;
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return $81693c046571dbd5$exports.TxResponse.fromPartial(e);
        })) || [];
        return message;
    }
};



var $4ce308f1ff13eaff$exports = {};
"use strict";
var $4ce308f1ff13eaff$var$__createBinding = $4ce308f1ff13eaff$exports && $4ce308f1ff13eaff$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4ce308f1ff13eaff$var$__setModuleDefault = $4ce308f1ff13eaff$exports && $4ce308f1ff13eaff$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4ce308f1ff13eaff$var$__importStar = $4ce308f1ff13eaff$exports && $4ce308f1ff13eaff$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4ce308f1ff13eaff$var$__createBinding(result, mod, k);
    }
    $4ce308f1ff13eaff$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4ce308f1ff13eaff$exports, "__esModule", {
    value: true
});
$4ce308f1ff13eaff$exports.Block = $4ce308f1ff13eaff$exports.protobufPackage = void 0;

var $8eb678272a711586$exports = {};
"use strict";
var $8eb678272a711586$var$__createBinding = $8eb678272a711586$exports && $8eb678272a711586$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8eb678272a711586$var$__setModuleDefault = $8eb678272a711586$exports && $8eb678272a711586$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8eb678272a711586$var$__importStar = $8eb678272a711586$exports && $8eb678272a711586$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8eb678272a711586$var$__createBinding(result, mod, k);
    }
    $8eb678272a711586$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8eb678272a711586$exports, "__esModule", {
    value: true
});
$8eb678272a711586$exports.EvidenceList = $8eb678272a711586$exports.LightClientAttackEvidence = $8eb678272a711586$exports.DuplicateVoteEvidence = $8eb678272a711586$exports.Evidence = $8eb678272a711586$exports.protobufPackage = void 0;


var $ib0XJ = parcelRequire("ib0XJ");


var $7iZIe = parcelRequire("7iZIe");

var $8eb678272a711586$var$_m0 = $8eb678272a711586$var$__importStar((parcelRequire("hjb8Q")));
$8eb678272a711586$exports.protobufPackage = "tendermint.types";
function $8eb678272a711586$var$createBaseEvidence() {
    return {
        duplicateVoteEvidence: undefined,
        lightClientAttackEvidence: undefined
    };
}
$8eb678272a711586$exports.Evidence = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8eb678272a711586$var$_m0.Writer.create();
        if (message.duplicateVoteEvidence !== undefined) $8eb678272a711586$exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        if (message.lightClientAttackEvidence !== undefined) $8eb678272a711586$exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8eb678272a711586$var$_m0.Reader ? input : new $8eb678272a711586$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8eb678272a711586$var$createBaseEvidence();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplicateVoteEvidence = $8eb678272a711586$exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = $8eb678272a711586$exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            duplicateVoteEvidence: (0, $7iZIe.isSet)(object.duplicateVoteEvidence) ? $8eb678272a711586$exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence) : undefined,
            lightClientAttackEvidence: (0, $7iZIe.isSet)(object.lightClientAttackEvidence) ? $8eb678272a711586$exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.duplicateVoteEvidence !== undefined && (obj.duplicateVoteEvidence = message.duplicateVoteEvidence ? $8eb678272a711586$exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence) : undefined);
        message.lightClientAttackEvidence !== undefined && (obj.lightClientAttackEvidence = message.lightClientAttackEvidence ? $8eb678272a711586$exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $8eb678272a711586$var$createBaseEvidence();
        message.duplicateVoteEvidence = object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null ? $8eb678272a711586$exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence) : undefined;
        message.lightClientAttackEvidence = object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null ? $8eb678272a711586$exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence) : undefined;
        return message;
    }
};
function $8eb678272a711586$var$createBaseDuplicateVoteEvidence() {
    return {
        voteA: undefined,
        voteB: undefined,
        totalVotingPower: $7iZIe.Long.ZERO,
        validatorPower: $7iZIe.Long.ZERO,
        timestamp: undefined
    };
}
$8eb678272a711586$exports.DuplicateVoteEvidence = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8eb678272a711586$var$_m0.Writer.create();
        if (message.voteA !== undefined) $5e6f0a13c00383a2$exports.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        if (message.voteB !== undefined) $5e6f0a13c00383a2$exports.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        if (!message.validatorPower.isZero()) writer.uint32(32).int64(message.validatorPower);
        if (message.timestamp !== undefined) $ib0XJ.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8eb678272a711586$var$_m0.Reader ? input : new $8eb678272a711586$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8eb678272a711586$var$createBaseDuplicateVoteEvidence();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.voteA = $5e6f0a13c00383a2$exports.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = $5e6f0a13c00383a2$exports.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            voteA: (0, $7iZIe.isSet)(object.voteA) ? $5e6f0a13c00383a2$exports.Vote.fromJSON(object.voteA) : undefined,
            voteB: (0, $7iZIe.isSet)(object.voteB) ? $5e6f0a13c00383a2$exports.Vote.fromJSON(object.voteB) : undefined,
            totalVotingPower: (0, $7iZIe.isSet)(object.totalVotingPower) ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO,
            validatorPower: (0, $7iZIe.isSet)(object.validatorPower) ? $7iZIe.Long.fromValue(object.validatorPower) : $7iZIe.Long.ZERO,
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? (0, $7iZIe.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? $5e6f0a13c00383a2$exports.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? $5e6f0a13c00383a2$exports.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $7iZIe.Long.ZERO).toString());
        message.validatorPower !== undefined && (obj.validatorPower = (message.validatorPower || $7iZIe.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $7iZIe.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $8eb678272a711586$var$createBaseDuplicateVoteEvidence();
        message.voteA = object.voteA !== undefined && object.voteA !== null ? $5e6f0a13c00383a2$exports.Vote.fromPartial(object.voteA) : undefined;
        message.voteB = object.voteB !== undefined && object.voteB !== null ? $5e6f0a13c00383a2$exports.Vote.fromPartial(object.voteB) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO;
        message.validatorPower = object.validatorPower !== undefined && object.validatorPower !== null ? $7iZIe.Long.fromValue(object.validatorPower) : $7iZIe.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $ib0XJ.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $8eb678272a711586$var$createBaseLightClientAttackEvidence() {
    return {
        conflictingBlock: undefined,
        commonHeight: $7iZIe.Long.ZERO,
        byzantineValidators: [],
        totalVotingPower: $7iZIe.Long.ZERO,
        timestamp: undefined
    };
}
$8eb678272a711586$exports.LightClientAttackEvidence = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8eb678272a711586$var$_m0.Writer.create();
        if (message.conflictingBlock !== undefined) $5e6f0a13c00383a2$exports.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        if (!message.commonHeight.isZero()) writer.uint32(16).int64(message.commonHeight);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.byzantineValidators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $88f332d8924dbab6$exports.Validator.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!message.totalVotingPower.isZero()) writer.uint32(32).int64(message.totalVotingPower);
        if (message.timestamp !== undefined) $ib0XJ.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8eb678272a711586$var$_m0.Reader ? input : new $8eb678272a711586$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8eb678272a711586$var$createBaseLightClientAttackEvidence();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.conflictingBlock = $5e6f0a13c00383a2$exports.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push($88f332d8924dbab6$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $ib0XJ.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            conflictingBlock: (0, $7iZIe.isSet)(object.conflictingBlock) ? $5e6f0a13c00383a2$exports.LightBlock.fromJSON(object.conflictingBlock) : undefined,
            commonHeight: (0, $7iZIe.isSet)(object.commonHeight) ? $7iZIe.Long.fromValue(object.commonHeight) : $7iZIe.Long.ZERO,
            byzantineValidators: Array.isArray(object === null || object === void 0 ? void 0 : object.byzantineValidators) ? object.byzantineValidators.map(function(e) {
                return $88f332d8924dbab6$exports.Validator.fromJSON(e);
            }) : [],
            totalVotingPower: (0, $7iZIe.isSet)(object.totalVotingPower) ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO,
            timestamp: (0, $7iZIe.isSet)(object.timestamp) ? (0, $7iZIe.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.conflictingBlock !== undefined && (obj.conflictingBlock = message.conflictingBlock ? $5e6f0a13c00383a2$exports.LightBlock.toJSON(message.conflictingBlock) : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || $7iZIe.Long.ZERO).toString());
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map(function(e) {
            return e ? $88f332d8924dbab6$exports.Validator.toJSON(e) : undefined;
        });
        else obj.byzantineValidators = [];
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $7iZIe.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $7iZIe.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_byzantineValidators;
        var message = $8eb678272a711586$var$createBaseLightClientAttackEvidence();
        message.conflictingBlock = object.conflictingBlock !== undefined && object.conflictingBlock !== null ? $5e6f0a13c00383a2$exports.LightBlock.fromPartial(object.conflictingBlock) : undefined;
        message.commonHeight = object.commonHeight !== undefined && object.commonHeight !== null ? $7iZIe.Long.fromValue(object.commonHeight) : $7iZIe.Long.ZERO;
        message.byzantineValidators = ((_object_byzantineValidators = object.byzantineValidators) === null || _object_byzantineValidators === void 0 ? void 0 : _object_byzantineValidators.map(function(e) {
            return $88f332d8924dbab6$exports.Validator.fromPartial(e);
        })) || [];
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $7iZIe.Long.fromValue(object.totalVotingPower) : $7iZIe.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $ib0XJ.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $8eb678272a711586$var$createBaseEvidenceList() {
    return {
        evidence: []
    };
}
$8eb678272a711586$exports.EvidenceList = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8eb678272a711586$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.evidence[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $8eb678272a711586$exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $8eb678272a711586$var$_m0.Reader ? input : new $8eb678272a711586$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $8eb678272a711586$var$createBaseEvidenceList();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.evidence.push($8eb678272a711586$exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            evidence: Array.isArray(object === null || object === void 0 ? void 0 : object.evidence) ? object.evidence.map(function(e) {
                return $8eb678272a711586$exports.Evidence.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.evidence) obj.evidence = message.evidence.map(function(e) {
            return e ? $8eb678272a711586$exports.Evidence.toJSON(e) : undefined;
        });
        else obj.evidence = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_evidence;
        var message = $8eb678272a711586$var$createBaseEvidenceList();
        message.evidence = ((_object_evidence = object.evidence) === null || _object_evidence === void 0 ? void 0 : _object_evidence.map(function(e) {
            return $8eb678272a711586$exports.Evidence.fromPartial(e);
        })) || [];
        return message;
    }
};



var $4ce308f1ff13eaff$var$_m0 = $4ce308f1ff13eaff$var$__importStar((parcelRequire("hjb8Q")));

var $7iZIe = parcelRequire("7iZIe");
$4ce308f1ff13eaff$exports.protobufPackage = "tendermint.types";
function $4ce308f1ff13eaff$var$createBaseBlock() {
    return {
        header: undefined,
        data: undefined,
        evidence: undefined,
        lastCommit: undefined
    };
}
$4ce308f1ff13eaff$exports.Block = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4ce308f1ff13eaff$var$_m0.Writer.create();
        if (message.header !== undefined) $5e6f0a13c00383a2$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $5e6f0a13c00383a2$exports.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.evidence !== undefined) $8eb678272a711586$exports.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        if (message.lastCommit !== undefined) $5e6f0a13c00383a2$exports.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4ce308f1ff13eaff$var$_m0.Reader ? input : new $4ce308f1ff13eaff$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4ce308f1ff13eaff$var$createBaseBlock();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $5e6f0a13c00383a2$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $5e6f0a13c00383a2$exports.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = $8eb678272a711586$exports.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = $5e6f0a13c00383a2$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            header: (0, $7iZIe.isSet)(object.header) ? $5e6f0a13c00383a2$exports.Header.fromJSON(object.header) : undefined,
            data: (0, $7iZIe.isSet)(object.data) ? $5e6f0a13c00383a2$exports.Data.fromJSON(object.data) : undefined,
            evidence: (0, $7iZIe.isSet)(object.evidence) ? $8eb678272a711586$exports.EvidenceList.fromJSON(object.evidence) : undefined,
            lastCommit: (0, $7iZIe.isSet)(object.lastCommit) ? $5e6f0a13c00383a2$exports.Commit.fromJSON(object.lastCommit) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.header !== undefined && (obj.header = message.header ? $5e6f0a13c00383a2$exports.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? $5e6f0a13c00383a2$exports.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $8eb678272a711586$exports.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined && (obj.lastCommit = message.lastCommit ? $5e6f0a13c00383a2$exports.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $4ce308f1ff13eaff$var$createBaseBlock();
        message.header = object.header !== undefined && object.header !== null ? $5e6f0a13c00383a2$exports.Header.fromPartial(object.header) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $5e6f0a13c00383a2$exports.Data.fromPartial(object.data) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $8eb678272a711586$exports.EvidenceList.fromPartial(object.evidence) : undefined;
        message.lastCommit = object.lastCommit !== undefined && object.lastCommit !== null ? $5e6f0a13c00383a2$exports.Commit.fromPartial(object.lastCommit) : undefined;
        return message;
    }
};



var $7iZIe = parcelRequire("7iZIe");

var $13bf950853937dd3$var$_m0 = $13bf950853937dd3$var$__importStar((parcelRequire("hjb8Q")));
$13bf950853937dd3$exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */ var $13bf950853937dd3$var$OrderBy;
(function(OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */ OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */ OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */ OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($13bf950853937dd3$var$OrderBy = $13bf950853937dd3$exports.OrderBy || ($13bf950853937dd3$exports.OrderBy = {}));
function $13bf950853937dd3$var$orderByFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return $13bf950853937dd3$var$OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return $13bf950853937dd3$var$OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return $13bf950853937dd3$var$OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $13bf950853937dd3$var$OrderBy.UNRECOGNIZED;
    }
}
$13bf950853937dd3$exports.orderByFromJSON = $13bf950853937dd3$var$orderByFromJSON;
function $13bf950853937dd3$var$orderByToJSON(object) {
    switch(object){
        case $13bf950853937dd3$var$OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case $13bf950853937dd3$var$OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case $13bf950853937dd3$var$OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        case $13bf950853937dd3$var$OrderBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$13bf950853937dd3$exports.orderByToJSON = $13bf950853937dd3$var$orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */ var $13bf950853937dd3$var$BroadcastMode;
(function(BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */ BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - DEPRECATED: use BROADCAST_MODE_SYNC instead,
     * BROADCAST_MODE_BLOCK is not supported by the SDK from v0.47.x onwards.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($13bf950853937dd3$var$BroadcastMode = $13bf950853937dd3$exports.BroadcastMode || ($13bf950853937dd3$exports.BroadcastMode = {}));
function $13bf950853937dd3$var$broadcastModeFromJSON(object) {
    switch(object){
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $13bf950853937dd3$var$BroadcastMode.UNRECOGNIZED;
    }
}
$13bf950853937dd3$exports.broadcastModeFromJSON = $13bf950853937dd3$var$broadcastModeFromJSON;
function $13bf950853937dd3$var$broadcastModeToJSON(object) {
    switch(object){
        case $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case $13bf950853937dd3$var$BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        case $13bf950853937dd3$var$BroadcastMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$13bf950853937dd3$exports.broadcastModeToJSON = $13bf950853937dd3$var$broadcastModeToJSON;
function $13bf950853937dd3$var$createBaseGetTxsEventRequest() {
    return {
        events: [],
        pagination: undefined,
        orderBy: 0,
        page: $7iZIe.Long.UZERO,
        limit: $7iZIe.Long.UZERO
    };
}
$13bf950853937dd3$exports.GetTxsEventRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.orderBy !== 0) writer.uint32(24).int32(message.orderBy);
        if (!message.page.isZero()) writer.uint32(32).uint64(message.page);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseGetTxsEventRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                case 4:
                    message.page = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            events: Array.isArray(object === null || object === void 0 ? void 0 : object.events) ? object.events.map(function(e) {
                return String(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined,
            orderBy: (0, $7iZIe.isSet)(object.orderBy) ? $13bf950853937dd3$var$orderByFromJSON(object.orderBy) : 0,
            page: (0, $7iZIe.isSet)(object.page) ? $7iZIe.Long.fromValue(object.page) : $7iZIe.Long.UZERO,
            limit: (0, $7iZIe.isSet)(object.limit) ? $7iZIe.Long.fromValue(object.limit) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.events) obj.events = message.events.map(function(e) {
            return e;
        });
        else obj.events = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = $13bf950853937dd3$var$orderByToJSON(message.orderBy));
        message.page !== undefined && (obj.page = (message.page || $7iZIe.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_events;
        var message = $13bf950853937dd3$var$createBaseGetTxsEventRequest();
        message.events = ((_object_events = object.events) === null || _object_events === void 0 ? void 0 : _object_events.map(function(e) {
            return e;
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        var _object_orderBy;
        message.orderBy = (_object_orderBy = object.orderBy) !== null && _object_orderBy !== void 0 ? _object_orderBy : 0;
        message.page = object.page !== undefined && object.page !== null ? $7iZIe.Long.fromValue(object.page) : $7iZIe.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $7iZIe.Long.fromValue(object.limit) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseGetTxsEventResponse() {
    return {
        txs: [],
        txResponses: [],
        pagination: undefined,
        total: $7iZIe.Long.UZERO
    };
}
$13bf950853937dd3$exports.GetTxsEventResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $540f96552e476ffb$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = message.txResponses[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var v1 = _step1.value;
                $81693c046571dbd5$exports.TxResponse.encode(v1, writer.uint32(18).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        if (!message.total.isZero()) writer.uint32(32).uint64(message.total);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseGetTxsEventResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($540f96552e476ffb$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push($81693c046571dbd5$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return $540f96552e476ffb$exports.Tx.fromJSON(e);
            }) : [],
            txResponses: Array.isArray(object === null || object === void 0 ? void 0 : object.txResponses) ? object.txResponses.map(function(e) {
                return $81693c046571dbd5$exports.TxResponse.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined,
            total: (0, $7iZIe.isSet)(object.total) ? $7iZIe.Long.fromValue(object.total) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return e ? $540f96552e476ffb$exports.Tx.toJSON(e) : undefined;
        });
        else obj.txs = [];
        if (message.txResponses) obj.txResponses = message.txResponses.map(function(e) {
            return e ? $81693c046571dbd5$exports.TxResponse.toJSON(e) : undefined;
        });
        else obj.txResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.total !== undefined && (obj.total = (message.total || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs, _object_txResponses;
        var message = $13bf950853937dd3$var$createBaseGetTxsEventResponse();
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return $540f96552e476ffb$exports.Tx.fromPartial(e);
        })) || [];
        message.txResponses = ((_object_txResponses = object.txResponses) === null || _object_txResponses === void 0 ? void 0 : _object_txResponses.map(function(e) {
            return $81693c046571dbd5$exports.TxResponse.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.total = object.total !== undefined && object.total !== null ? $7iZIe.Long.fromValue(object.total) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseBroadcastTxRequest() {
    return {
        txBytes: new Uint8Array(),
        mode: 0
    };
}
$13bf950853937dd3$exports.BroadcastTxRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        if (message.mode !== 0) writer.uint32(16).int32(message.mode);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseBroadcastTxRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txBytes: (0, $7iZIe.isSet)(object.txBytes) ? (0, $7iZIe.bytesFromBase64)(object.txBytes) : new Uint8Array(),
            mode: (0, $7iZIe.isSet)(object.mode) ? $13bf950853937dd3$var$broadcastModeFromJSON(object.mode) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $7iZIe.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = $13bf950853937dd3$var$broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseBroadcastTxRequest();
        var _object_txBytes;
        message.txBytes = (_object_txBytes = object.txBytes) !== null && _object_txBytes !== void 0 ? _object_txBytes : new Uint8Array();
        var _object_mode;
        message.mode = (_object_mode = object.mode) !== null && _object_mode !== void 0 ? _object_mode : 0;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseBroadcastTxResponse() {
    return {
        txResponse: undefined
    };
}
$13bf950853937dd3$exports.BroadcastTxResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.txResponse !== undefined) $81693c046571dbd5$exports.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseBroadcastTxResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txResponse = $81693c046571dbd5$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txResponse: (0, $7iZIe.isSet)(object.txResponse) ? $81693c046571dbd5$exports.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $81693c046571dbd5$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseBroadcastTxResponse();
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $81693c046571dbd5$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseSimulateRequest() {
    return {
        tx: undefined,
        txBytes: new Uint8Array()
    };
}
$13bf950853937dd3$exports.SimulateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.tx !== undefined) $540f96552e476ffb$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txBytes.length !== 0) writer.uint32(18).bytes(message.txBytes);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseSimulateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $540f96552e476ffb$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tx: (0, $7iZIe.isSet)(object.tx) ? $540f96552e476ffb$exports.Tx.fromJSON(object.tx) : undefined,
            txBytes: (0, $7iZIe.isSet)(object.txBytes) ? (0, $7iZIe.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $540f96552e476ffb$exports.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined && (obj.txBytes = (0, $7iZIe.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseSimulateRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $540f96552e476ffb$exports.Tx.fromPartial(object.tx) : undefined;
        var _object_txBytes;
        message.txBytes = (_object_txBytes = object.txBytes) !== null && _object_txBytes !== void 0 ? _object_txBytes : new Uint8Array();
        return message;
    }
};
function $13bf950853937dd3$var$createBaseSimulateResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
$13bf950853937dd3$exports.SimulateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.gasInfo !== undefined) $81693c046571dbd5$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $81693c046571dbd5$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseSimulateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $81693c046571dbd5$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $81693c046571dbd5$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            gasInfo: (0, $7iZIe.isSet)(object.gasInfo) ? $81693c046571dbd5$exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $7iZIe.isSet)(object.result) ? $81693c046571dbd5$exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $81693c046571dbd5$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $81693c046571dbd5$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseSimulateResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $81693c046571dbd5$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $81693c046571dbd5$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseGetTxRequest() {
    return {
        hash: ""
    };
}
$13bf950853937dd3$exports.GetTxRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseGetTxRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            hash: (0, $7iZIe.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseGetTxRequest();
        var _object_hash;
        message.hash = (_object_hash = object.hash) !== null && _object_hash !== void 0 ? _object_hash : "";
        return message;
    }
};
function $13bf950853937dd3$var$createBaseGetTxResponse() {
    return {
        tx: undefined,
        txResponse: undefined
    };
}
$13bf950853937dd3$exports.GetTxResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.tx !== undefined) $540f96552e476ffb$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txResponse !== undefined) $81693c046571dbd5$exports.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseGetTxResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $540f96552e476ffb$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = $81693c046571dbd5$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tx: (0, $7iZIe.isSet)(object.tx) ? $540f96552e476ffb$exports.Tx.fromJSON(object.tx) : undefined,
            txResponse: (0, $7iZIe.isSet)(object.txResponse) ? $81693c046571dbd5$exports.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $540f96552e476ffb$exports.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $81693c046571dbd5$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseGetTxResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $540f96552e476ffb$exports.Tx.fromPartial(object.tx) : undefined;
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $81693c046571dbd5$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseGetBlockWithTxsRequest() {
    return {
        height: $7iZIe.Long.ZERO,
        pagination: undefined
    };
}
$13bf950853937dd3$exports.GetBlockWithTxsRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseGetBlockWithTxsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            height: (0, $7iZIe.isSet)(object.height) ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO,
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.height !== undefined && (obj.height = (message.height || $7iZIe.Long.ZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseGetBlockWithTxsRequest();
        message.height = object.height !== undefined && object.height !== null ? $7iZIe.Long.fromValue(object.height) : $7iZIe.Long.ZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseGetBlockWithTxsResponse() {
    return {
        txs: [],
        blockId: undefined,
        block: undefined,
        pagination: undefined
    };
}
$13bf950853937dd3$exports.GetBlockWithTxsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.txs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $540f96552e476ffb$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.blockId !== undefined) $5e6f0a13c00383a2$exports.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        if (message.block !== undefined) $4ce308f1ff13eaff$exports.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseGetBlockWithTxsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($540f96552e476ffb$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = $5e6f0a13c00383a2$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = $4ce308f1ff13eaff$exports.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map(function(e) {
                return $540f96552e476ffb$exports.Tx.fromJSON(e);
            }) : [],
            blockId: (0, $7iZIe.isSet)(object.blockId) ? $5e6f0a13c00383a2$exports.BlockID.fromJSON(object.blockId) : undefined,
            block: (0, $7iZIe.isSet)(object.block) ? $4ce308f1ff13eaff$exports.Block.fromJSON(object.block) : undefined,
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.txs) obj.txs = message.txs.map(function(e) {
            return e ? $540f96552e476ffb$exports.Tx.toJSON(e) : undefined;
        });
        else obj.txs = [];
        message.blockId !== undefined && (obj.blockId = message.blockId ? $5e6f0a13c00383a2$exports.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? $4ce308f1ff13eaff$exports.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_txs;
        var message = $13bf950853937dd3$var$createBaseGetBlockWithTxsResponse();
        message.txs = ((_object_txs = object.txs) === null || _object_txs === void 0 ? void 0 : _object_txs.map(function(e) {
            return $540f96552e476ffb$exports.Tx.fromPartial(e);
        })) || [];
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $5e6f0a13c00383a2$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.block = object.block !== undefined && object.block !== null ? $4ce308f1ff13eaff$exports.Block.fromPartial(object.block) : undefined;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxDecodeRequest() {
    return {
        txBytes: new Uint8Array()
    };
}
$13bf950853937dd3$exports.TxDecodeRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxDecodeRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txBytes: (0, $7iZIe.isSet)(object.txBytes) ? (0, $7iZIe.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $7iZIe.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxDecodeRequest();
        var _object_txBytes;
        message.txBytes = (_object_txBytes = object.txBytes) !== null && _object_txBytes !== void 0 ? _object_txBytes : new Uint8Array();
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxDecodeResponse() {
    return {
        tx: undefined
    };
}
$13bf950853937dd3$exports.TxDecodeResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.tx !== undefined) $540f96552e476ffb$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxDecodeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $540f96552e476ffb$exports.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tx: (0, $7iZIe.isSet)(object.tx) ? $540f96552e476ffb$exports.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $540f96552e476ffb$exports.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxDecodeResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $540f96552e476ffb$exports.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxEncodeRequest() {
    return {
        tx: undefined
    };
}
$13bf950853937dd3$exports.TxEncodeRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.tx !== undefined) $540f96552e476ffb$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxEncodeRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $540f96552e476ffb$exports.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            tx: (0, $7iZIe.isSet)(object.tx) ? $540f96552e476ffb$exports.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $540f96552e476ffb$exports.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxEncodeRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $540f96552e476ffb$exports.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxEncodeResponse() {
    return {
        txBytes: new Uint8Array()
    };
}
$13bf950853937dd3$exports.TxEncodeResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxEncodeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            txBytes: (0, $7iZIe.isSet)(object.txBytes) ? (0, $7iZIe.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $7iZIe.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxEncodeResponse();
        var _object_txBytes;
        message.txBytes = (_object_txBytes = object.txBytes) !== null && _object_txBytes !== void 0 ? _object_txBytes : new Uint8Array();
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxEncodeAminoRequest() {
    return {
        aminoJson: ""
    };
}
$13bf950853937dd3$exports.TxEncodeAminoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxEncodeAminoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            aminoJson: (0, $7iZIe.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxEncodeAminoRequest();
        var _object_aminoJson;
        message.aminoJson = (_object_aminoJson = object.aminoJson) !== null && _object_aminoJson !== void 0 ? _object_aminoJson : "";
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxEncodeAminoResponse() {
    return {
        aminoBinary: new Uint8Array()
    };
}
$13bf950853937dd3$exports.TxEncodeAminoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxEncodeAminoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            aminoBinary: (0, $7iZIe.isSet)(object.aminoBinary) ? (0, $7iZIe.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $7iZIe.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxEncodeAminoResponse();
        var _object_aminoBinary;
        message.aminoBinary = (_object_aminoBinary = object.aminoBinary) !== null && _object_aminoBinary !== void 0 ? _object_aminoBinary : new Uint8Array();
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxDecodeAminoRequest() {
    return {
        aminoBinary: new Uint8Array()
    };
}
$13bf950853937dd3$exports.TxDecodeAminoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxDecodeAminoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            aminoBinary: (0, $7iZIe.isSet)(object.aminoBinary) ? (0, $7iZIe.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $7iZIe.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxDecodeAminoRequest();
        var _object_aminoBinary;
        message.aminoBinary = (_object_aminoBinary = object.aminoBinary) !== null && _object_aminoBinary !== void 0 ? _object_aminoBinary : new Uint8Array();
        return message;
    }
};
function $13bf950853937dd3$var$createBaseTxDecodeAminoResponse() {
    return {
        aminoJson: ""
    };
}
$13bf950853937dd3$exports.TxDecodeAminoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $13bf950853937dd3$var$_m0.Writer.create();
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $13bf950853937dd3$var$_m0.Reader ? input : new $13bf950853937dd3$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $13bf950853937dd3$var$createBaseTxDecodeAminoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            aminoJson: (0, $7iZIe.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial: function(object) {
        var message = $13bf950853937dd3$var$createBaseTxDecodeAminoResponse();
        var _object_aminoJson;
        message.aminoJson = (_object_aminoJson = object.aminoJson) !== null && _object_aminoJson !== void 0 ? _object_aminoJson : "";
        return message;
    }
};
var $13bf950853937dd3$var$ServiceClientImpl = /*#__PURE__*/ function() {
    function ServiceClientImpl(rpc) {
        (0, $7dKN1._)(this, ServiceClientImpl);
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
        this.TxDecode = this.TxDecode.bind(this);
        this.TxEncode = this.TxEncode.bind(this);
        this.TxEncodeAmino = this.TxEncodeAmino.bind(this);
        this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    (0, $eW5pA._)(ServiceClientImpl, [
        {
            key: "Simulate",
            value: function Simulate(request) {
                var data = $13bf950853937dd3$exports.SimulateRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.SimulateResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "GetTx",
            value: function GetTx(request) {
                var data = $13bf950853937dd3$exports.GetTxRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.GetTxResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "BroadcastTx",
            value: function BroadcastTx(request) {
                var data = $13bf950853937dd3$exports.BroadcastTxRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.BroadcastTxResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "GetTxsEvent",
            value: function GetTxsEvent(request) {
                var data = $13bf950853937dd3$exports.GetTxsEventRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.GetTxsEventResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "GetBlockWithTxs",
            value: function GetBlockWithTxs(request) {
                var data = $13bf950853937dd3$exports.GetBlockWithTxsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.GetBlockWithTxsResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TxDecode",
            value: function TxDecode(request) {
                var data = $13bf950853937dd3$exports.TxDecodeRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.TxDecodeResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TxEncode",
            value: function TxEncode(request) {
                var data = $13bf950853937dd3$exports.TxEncodeRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.TxEncodeResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TxEncodeAmino",
            value: function TxEncodeAmino(request) {
                var data = $13bf950853937dd3$exports.TxEncodeAminoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.TxEncodeAminoResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "TxDecodeAmino",
            value: function TxDecodeAmino(request) {
                var data = $13bf950853937dd3$exports.TxDecodeAminoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", data);
                return promise.then(function(data) {
                    return $13bf950853937dd3$exports.TxDecodeAminoResponse.decode(new $13bf950853937dd3$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return ServiceClientImpl;
}();
$13bf950853937dd3$exports.ServiceClientImpl = $13bf950853937dd3$var$ServiceClientImpl;




var $67fb6423506f0ef4$var$long_1 = $67fb6423506f0ef4$var$__importDefault((parcelRequire("l6G6L")));

function $67fb6423506f0ef4$var$setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var rpc = (0, $0f41f7d88b60184b$exports.createProtobufRpcClient)(base);
    var queryService = new $13bf950853937dd3$exports.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: function() {
                var _ref = (0, $6rBFC._)(function(txId) {
                    var request, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = {
                                    hash: txId
                                };
                                return [
                                    4,
                                    queryService.GetTx(request)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(txId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            simulate: function() {
                var _ref = (0, $6rBFC._)(function(messages, memo, signer, sequence) {
                    var tx, request, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tx = $540f96552e476ffb$exports.Tx.fromPartial({
                                    authInfo: $540f96552e476ffb$exports.AuthInfo.fromPartial({
                                        fee: $540f96552e476ffb$exports.Fee.fromPartial({}),
                                        signerInfos: [
                                            {
                                                publicKey: (0, $ff811d56e12ad916$exports.encodePubkey)(signer),
                                                sequence: $67fb6423506f0ef4$var$long_1.default.fromNumber(sequence, true),
                                                modeInfo: {
                                                    single: {
                                                        mode: $82c22db8b6bc5755$exports.SignMode.SIGN_MODE_UNSPECIFIED
                                                    }
                                                }
                                            }
                                        ]
                                    }),
                                    body: $540f96552e476ffb$exports.TxBody.fromPartial({
                                        messages: Array.from(messages),
                                        memo: memo
                                    }),
                                    signatures: [
                                        new Uint8Array()
                                    ]
                                });
                                request = $13bf950853937dd3$exports.SimulateRequest.fromPartial({
                                    txBytes: $540f96552e476ffb$exports.Tx.encode(tx).finish()
                                });
                                return [
                                    4,
                                    queryService.Simulate(request)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function(messages, memo, signer, sequence) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$67fb6423506f0ef4$exports.setupTxExtension = $67fb6423506f0ef4$var$setupTxExtension;


Object.defineProperty($0aaecf7be71ff9a4$exports, "setupTxExtension", {
    enumerable: true,
    get: function get() {
        return $67fb6423506f0ef4$exports.setupTxExtension;
    }
});
var $f6c0793e1e20485a$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
var $f6c0793e1e20485a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f6c0793e1e20485a$exports, "__esModule", {
    value: true
});
$f6c0793e1e20485a$exports.createVestingAminoConverters = $f6c0793e1e20485a$exports.isAminoMsgCreateVestingAccount = void 0;

var $f6c0793e1e20485a$var$long_1 = $f6c0793e1e20485a$var$__importDefault((parcelRequire("l6G6L")));
function $f6c0793e1e20485a$var$isAminoMsgCreateVestingAccount(msg) {
    return msg.type === "cosmos-sdk/MsgCreateVestingAccount";
}
$f6c0793e1e20485a$exports.isAminoMsgCreateVestingAccount = $f6c0793e1e20485a$var$isAminoMsgCreateVestingAccount;
function $f6c0793e1e20485a$var$createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
            aminoType: "cosmos-sdk/MsgCreateVestingAccount",
            toAmino: function(param) {
                var fromAddress = param.fromAddress, toAddress = param.toAddress, amount = param.amount, endTime = param.endTime, delayed = param.delayed;
                return {
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: (0, $gF0bR._)(amount),
                    end_time: endTime.toString(),
                    delayed: delayed
                };
            },
            fromAmino: function(param) {
                var from_address = param.from_address, to_address = param.to_address, amount = param.amount, end_time = param.end_time, delayed = param.delayed;
                return {
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: (0, $gF0bR._)(amount),
                    endTime: $f6c0793e1e20485a$var$long_1.default.fromString(end_time),
                    delayed: delayed
                };
            }
        }
    };
}
$f6c0793e1e20485a$exports.createVestingAminoConverters = $f6c0793e1e20485a$var$createVestingAminoConverters;


Object.defineProperty($0aaecf7be71ff9a4$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function get() {
        return $f6c0793e1e20485a$exports.createVestingAminoConverters;
    }
});
Object.defineProperty($0aaecf7be71ff9a4$exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function get() {
        return $f6c0793e1e20485a$exports.isAminoMsgCreateVestingAccount;
    }
});
var $8825fcff74eae17c$exports = {};
"use strict";
Object.defineProperty($8825fcff74eae17c$exports, "__esModule", {
    value: true
});
$8825fcff74eae17c$exports.vestingTypes = void 0;
var $c9f90bca7758276f$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $c9f90bca7758276f$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9f90bca7758276f$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c9f90bca7758276f$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c9f90bca7758276f$var$__createBinding(result, mod, k);
    }
    $c9f90bca7758276f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c9f90bca7758276f$exports, "__esModule", {
    value: true
});
$c9f90bca7758276f$exports.MsgClientImpl = $c9f90bca7758276f$exports.MsgCreatePeriodicVestingAccountResponse = $c9f90bca7758276f$exports.MsgCreatePeriodicVestingAccount = $c9f90bca7758276f$exports.MsgCreatePermanentLockedAccountResponse = $c9f90bca7758276f$exports.MsgCreatePermanentLockedAccount = $c9f90bca7758276f$exports.MsgCreateVestingAccountResponse = $c9f90bca7758276f$exports.MsgCreateVestingAccount = $c9f90bca7758276f$exports.protobufPackage = void 0;



var $7iZIe = parcelRequire("7iZIe");

var $c9f90bca7758276f$var$_m0 = $c9f90bca7758276f$var$__importStar((parcelRequire("hjb8Q")));
$c9f90bca7758276f$exports.protobufPackage = "cosmos.vesting.v1beta1";
function $c9f90bca7758276f$var$createBaseMsgCreateVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
        endTime: $7iZIe.Long.ZERO,
        delayed: false
    };
}
$c9f90bca7758276f$exports.MsgCreateVestingAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9f90bca7758276f$var$_m0.Writer.create();
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!message.endTime.isZero()) writer.uint32(32).int64(message.endTime);
        if (message.delayed === true) writer.uint32(40).bool(message.delayed);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c9f90bca7758276f$var$_m0.Reader ? input : new $c9f90bca7758276f$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c9f90bca7758276f$var$createBaseMsgCreateVestingAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            fromAddress: (0, $7iZIe.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $7iZIe.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            endTime: (0, $7iZIe.isSet)(object.endTime) ? $7iZIe.Long.fromValue(object.endTime) : $7iZIe.Long.ZERO,
            delayed: (0, $7iZIe.isSet)(object.delayed) ? Boolean(object.delayed) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $7iZIe.Long.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $c9f90bca7758276f$var$createBaseMsgCreateVestingAccount();
        var _object_fromAddress;
        message.fromAddress = (_object_fromAddress = object.fromAddress) !== null && _object_fromAddress !== void 0 ? _object_fromAddress : "";
        var _object_toAddress;
        message.toAddress = (_object_toAddress = object.toAddress) !== null && _object_toAddress !== void 0 ? _object_toAddress : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $7iZIe.Long.fromValue(object.endTime) : $7iZIe.Long.ZERO;
        var _object_delayed;
        message.delayed = (_object_delayed = object.delayed) !== null && _object_delayed !== void 0 ? _object_delayed : false;
        return message;
    }
};
function $c9f90bca7758276f$var$createBaseMsgCreateVestingAccountResponse() {
    return {};
}
$c9f90bca7758276f$exports.MsgCreateVestingAccountResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9f90bca7758276f$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c9f90bca7758276f$var$_m0.Reader ? input : new $c9f90bca7758276f$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c9f90bca7758276f$var$createBaseMsgCreateVestingAccountResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $c9f90bca7758276f$var$createBaseMsgCreateVestingAccountResponse();
        return message;
    }
};
function $c9f90bca7758276f$var$createBaseMsgCreatePermanentLockedAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
$c9f90bca7758276f$exports.MsgCreatePermanentLockedAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9f90bca7758276f$var$_m0.Writer.create();
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.amount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c9f90bca7758276f$var$_m0.Reader ? input : new $c9f90bca7758276f$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePermanentLockedAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            fromAddress: (0, $7iZIe.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $7iZIe.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.amount = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_amount;
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePermanentLockedAccount();
        var _object_fromAddress;
        message.fromAddress = (_object_fromAddress = object.fromAddress) !== null && _object_fromAddress !== void 0 ? _object_fromAddress : "";
        var _object_toAddress;
        message.toAddress = (_object_toAddress = object.toAddress) !== null && _object_toAddress !== void 0 ? _object_toAddress : "";
        message.amount = ((_object_amount = object.amount) === null || _object_amount === void 0 ? void 0 : _object_amount.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $c9f90bca7758276f$var$createBaseMsgCreatePermanentLockedAccountResponse() {
    return {};
}
$c9f90bca7758276f$exports.MsgCreatePermanentLockedAccountResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9f90bca7758276f$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c9f90bca7758276f$var$_m0.Reader ? input : new $c9f90bca7758276f$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePermanentLockedAccountResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePermanentLockedAccountResponse();
        return message;
    }
};
function $c9f90bca7758276f$var$createBaseMsgCreatePeriodicVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        startTime: $7iZIe.Long.ZERO,
        vestingPeriods: []
    };
}
$c9f90bca7758276f$exports.MsgCreatePeriodicVestingAccount = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9f90bca7758276f$var$_m0.Writer.create();
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        if (!message.startTime.isZero()) writer.uint32(24).int64(message.startTime);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.vestingPeriods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $b4b5bd98e8da940b$exports.Period.encode(v, writer.uint32(34).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c9f90bca7758276f$var$_m0.Reader ? input : new $c9f90bca7758276f$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePeriodicVestingAccount();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.startTime = reader.int64();
                    break;
                case 4:
                    message.vestingPeriods.push($b4b5bd98e8da940b$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            fromAddress: (0, $7iZIe.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $7iZIe.isSet)(object.toAddress) ? String(object.toAddress) : "",
            startTime: (0, $7iZIe.isSet)(object.startTime) ? $7iZIe.Long.fromValue(object.startTime) : $7iZIe.Long.ZERO,
            vestingPeriods: Array.isArray(object === null || object === void 0 ? void 0 : object.vestingPeriods) ? object.vestingPeriods.map(function(e) {
                return $b4b5bd98e8da940b$exports.Period.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $7iZIe.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map(function(e) {
            return e ? $b4b5bd98e8da940b$exports.Period.toJSON(e) : undefined;
        });
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_vestingPeriods;
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePeriodicVestingAccount();
        var _object_fromAddress;
        message.fromAddress = (_object_fromAddress = object.fromAddress) !== null && _object_fromAddress !== void 0 ? _object_fromAddress : "";
        var _object_toAddress;
        message.toAddress = (_object_toAddress = object.toAddress) !== null && _object_toAddress !== void 0 ? _object_toAddress : "";
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $7iZIe.Long.fromValue(object.startTime) : $7iZIe.Long.ZERO;
        message.vestingPeriods = ((_object_vestingPeriods = object.vestingPeriods) === null || _object_vestingPeriods === void 0 ? void 0 : _object_vestingPeriods.map(function(e) {
            return $b4b5bd98e8da940b$exports.Period.fromPartial(e);
        })) || [];
        return message;
    }
};
function $c9f90bca7758276f$var$createBaseMsgCreatePeriodicVestingAccountResponse() {
    return {};
}
$c9f90bca7758276f$exports.MsgCreatePeriodicVestingAccountResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c9f90bca7758276f$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c9f90bca7758276f$var$_m0.Reader ? input : new $c9f90bca7758276f$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $c9f90bca7758276f$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        return message;
    }
};
var $c9f90bca7758276f$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
        this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this);
        this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "CreateVestingAccount",
            value: function CreateVestingAccount(request) {
                var data = $c9f90bca7758276f$exports.MsgCreateVestingAccount.encode(request).finish();
                var promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
                return promise.then(function(data) {
                    return $c9f90bca7758276f$exports.MsgCreateVestingAccountResponse.decode(new $c9f90bca7758276f$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "CreatePermanentLockedAccount",
            value: function CreatePermanentLockedAccount(request) {
                var data = $c9f90bca7758276f$exports.MsgCreatePermanentLockedAccount.encode(request).finish();
                var promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", data);
                return promise.then(function(data) {
                    return $c9f90bca7758276f$exports.MsgCreatePermanentLockedAccountResponse.decode(new $c9f90bca7758276f$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "CreatePeriodicVestingAccount",
            value: function CreatePeriodicVestingAccount(request) {
                var data = $c9f90bca7758276f$exports.MsgCreatePeriodicVestingAccount.encode(request).finish();
                var promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", data);
                return promise.then(function(data) {
                    return $c9f90bca7758276f$exports.MsgCreatePeriodicVestingAccountResponse.decode(new $c9f90bca7758276f$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$c9f90bca7758276f$exports.MsgClientImpl = $c9f90bca7758276f$var$MsgClientImpl;


$8825fcff74eae17c$exports.vestingTypes = [
    [
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        $c9f90bca7758276f$exports.MsgCreateVestingAccount
    ]
];


Object.defineProperty($0aaecf7be71ff9a4$exports, "vestingTypes", {
    enumerable: true,
    get: function get() {
        return $8825fcff74eae17c$exports.vestingTypes;
    }
});


Object.defineProperty($3e8bd88d734bad5a$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createAuthzAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createBankAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createFeegrantAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createGovAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createGroupAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.createVestingAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgCreateVestingAccount;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgSend;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgSubmitEvidence;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgTransfer;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgUndelegate;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgUnjail;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgVerifyInvariant;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgVote;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgVoteWeighted;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgSendEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgTransferEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgVoteWeightedEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupAuthExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupAuthExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupAuthzExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupAuthzExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupBankExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupBankExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupDistributionExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupFeegrantExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupGovExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupGovExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupIbcExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupIbcExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupMintExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupMintExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupSlashingExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupStakingExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupStakingExtension;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "setupTxExtension", {
    enumerable: true,
    get: function get() {
        return $0aaecf7be71ff9a4$exports.setupTxExtension;
    }
});
var $4009e5eeda2475fe$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
var $4009e5eeda2475fe$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4009e5eeda2475fe$exports, "__esModule", {
    value: true
});
$4009e5eeda2475fe$exports.makeMultisignedTxBytes = $4009e5eeda2475fe$exports.makeMultisignedTx = $4009e5eeda2475fe$exports.makeCompactBitArray = void 0;


var $lSA9E = parcelRequire("lSA9E");






var $4009e5eeda2475fe$var$long_1 = $4009e5eeda2475fe$var$__importDefault((parcelRequire("l6G6L")));
function $4009e5eeda2475fe$var$makeCompactBitArray(bits) {
    var byteCount = Math.ceil(bits.length / 8);
    var extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    var bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach(function(value, index) {
        var bytePos = Math.floor(index / 8);
        var bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value) bytes[bytePos] |= 1 << 7 - bitPos;
    });
    return $8a18a2241640c168$exports.CompactBitArray.fromPartial({
        elems: bytes,
        extraBitsStored: extraBits
    });
}
$4009e5eeda2475fe$exports.makeCompactBitArray = $4009e5eeda2475fe$var$makeCompactBitArray;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted after serialization.
 *
 * Consider using `makeMultisignedTxBytes` instead if you want to broadcast the
 * transaction immediately.
 */ function $4009e5eeda2475fe$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    var addresses = Array.from(signatures.keys());
    var prefix = (0, $lSA9E.fromBech32)(addresses[0]).prefix;
    var signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    var signaturesList = new Array();
    for(var i = 0; i < multisigPubkey.value.pubkeys.length; i++){
        var signerAddress = (0, $c9b9a1a428003423$exports.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        var signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    var signerInfo = {
        publicKey: (0, $ff811d56e12ad916$exports.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: $4009e5eeda2475fe$var$makeCompactBitArray(signers),
                modeInfos: signaturesList.map(function(_) {
                    return {
                        single: {
                            mode: $82c22db8b6bc5755$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    };
                })
            }
        },
        sequence: $4009e5eeda2475fe$var$long_1.default.fromNumber(sequence)
    };
    var authInfo = $540f96552e476ffb$exports.AuthInfo.fromPartial({
        signerInfos: [
            signerInfo
        ],
        fee: {
            amount: (0, $gF0bR._)(fee.amount),
            gasLimit: $4009e5eeda2475fe$var$long_1.default.fromString(fee.gas)
        }
    });
    var authInfoBytes = $540f96552e476ffb$exports.AuthInfo.encode(authInfo).finish();
    var signedTx = $540f96552e476ffb$exports.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [
            $8a18a2241640c168$exports.MultiSignature.encode($8a18a2241640c168$exports.MultiSignature.fromPartial({
                signatures: signaturesList
            })).finish()
        ]
    });
    return signedTx;
}
$4009e5eeda2475fe$exports.makeMultisignedTx = $4009e5eeda2475fe$var$makeMultisignedTx;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted.
 *
 * This is a wrapper around `makeMultisignedTx` that encodes the transaction for broadcasting.
 */ function $4009e5eeda2475fe$var$makeMultisignedTxBytes(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    var signedTx = $4009e5eeda2475fe$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures);
    return Uint8Array.from($540f96552e476ffb$exports.TxRaw.encode(signedTx).finish());
}
$4009e5eeda2475fe$exports.makeMultisignedTxBytes = $4009e5eeda2475fe$var$makeMultisignedTxBytes;


Object.defineProperty($3e8bd88d734bad5a$exports, "makeMultisignedTx", {
    enumerable: true,
    get: function get() {
        return $4009e5eeda2475fe$exports.makeMultisignedTx;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "makeMultisignedTxBytes", {
    enumerable: true,
    get: function get() {
        return $4009e5eeda2475fe$exports.makeMultisignedTxBytes;
    }
});

Object.defineProperty($3e8bd88d734bad5a$exports, "createPagination", {
    enumerable: true,
    get: function get() {
        return $0f41f7d88b60184b$exports.createPagination;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function get() {
        return $0f41f7d88b60184b$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function get() {
        return $0f41f7d88b60184b$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "QueryClient", {
    enumerable: true,
    get: function get() {
        return $0f41f7d88b60184b$exports.QueryClient;
    }
});
var $e9477aecb74fcbc3$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $e9477aecb74fcbc3$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e9477aecb74fcbc3$exports, "__esModule", {
    value: true
});
$e9477aecb74fcbc3$exports.SigningStargateClient = $e9477aecb74fcbc3$exports.createDefaultAminoConverters = $e9477aecb74fcbc3$exports.defaultRegistryTypes = void 0;


var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");

var $7cd013e5dbc8ccb9$exports = {};
"use strict";
var $7cd013e5dbc8ccb9$var$__createBinding = $7cd013e5dbc8ccb9$exports && $7cd013e5dbc8ccb9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7cd013e5dbc8ccb9$var$__setModuleDefault = $7cd013e5dbc8ccb9$exports && $7cd013e5dbc8ccb9$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7cd013e5dbc8ccb9$var$__importStar = $7cd013e5dbc8ccb9$exports && $7cd013e5dbc8ccb9$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7cd013e5dbc8ccb9$var$__createBinding(result, mod, k);
    }
    $7cd013e5dbc8ccb9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($7cd013e5dbc8ccb9$exports, "__esModule", {
    value: true
});
$7cd013e5dbc8ccb9$exports.BlockIdFlag = $7cd013e5dbc8ccb9$exports.isTendermint37Client = $7cd013e5dbc8ccb9$exports.isTendermint34Client = $7cd013e5dbc8ccb9$exports.Tendermint37Client = $7cd013e5dbc8ccb9$exports.tendermint37 = $7cd013e5dbc8ccb9$exports.Tendermint34Client = $7cd013e5dbc8ccb9$exports.tendermint34 = $7cd013e5dbc8ccb9$exports.VoteType = $7cd013e5dbc8ccb9$exports.SubscriptionEventType = $7cd013e5dbc8ccb9$exports.Method = $7cd013e5dbc8ccb9$exports.broadcastTxSyncSuccess = $7cd013e5dbc8ccb9$exports.broadcastTxCommitSuccess = $7cd013e5dbc8ccb9$exports.WebsocketClient = $7cd013e5dbc8ccb9$exports.HttpClient = $7cd013e5dbc8ccb9$exports.HttpBatchClient = $7cd013e5dbc8ccb9$exports.toSeconds = $7cd013e5dbc8ccb9$exports.toRfc3339WithNanoseconds = $7cd013e5dbc8ccb9$exports.fromSeconds = $7cd013e5dbc8ccb9$exports.fromRfc3339WithNanoseconds = $7cd013e5dbc8ccb9$exports.DateTime = $7cd013e5dbc8ccb9$exports.rawSecp256k1PubkeyToRawAddress = $7cd013e5dbc8ccb9$exports.rawEd25519PubkeyToRawAddress = $7cd013e5dbc8ccb9$exports.pubkeyToRawAddress = $7cd013e5dbc8ccb9$exports.pubkeyToAddress = void 0;
var $3cbd1dfc5d804d6f$exports = {};
"use strict";
Object.defineProperty($3cbd1dfc5d804d6f$exports, "__esModule", {
    value: true
});
$3cbd1dfc5d804d6f$exports.pubkeyToAddress = $3cbd1dfc5d804d6f$exports.pubkeyToRawAddress = $3cbd1dfc5d804d6f$exports.rawSecp256k1PubkeyToRawAddress = $3cbd1dfc5d804d6f$exports.rawEd25519PubkeyToRawAddress = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");
function $3cbd1dfc5d804d6f$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error("Invalid Ed25519 pubkey length: ".concat(pubkeyData.length));
    return (0, $3d6bA.sha256)(pubkeyData).slice(0, 20);
}
$3cbd1dfc5d804d6f$exports.rawEd25519PubkeyToRawAddress = $3cbd1dfc5d804d6f$var$rawEd25519PubkeyToRawAddress;
function $3cbd1dfc5d804d6f$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error("Invalid Secp256k1 pubkey length (compressed): ".concat(pubkeyData.length));
    return (0, $3d6bA.ripemd160)((0, $3d6bA.sha256)(pubkeyData));
}
$3cbd1dfc5d804d6f$exports.rawSecp256k1PubkeyToRawAddress = $3cbd1dfc5d804d6f$var$rawSecp256k1PubkeyToRawAddress;
/**
 * Returns Tendermint address as bytes.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $3cbd1dfc5d804d6f$var$pubkeyToRawAddress(type, data) {
    switch(type){
        case "ed25519":
            return $3cbd1dfc5d804d6f$var$rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return $3cbd1dfc5d804d6f$var$rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error("Pubkey type ".concat(type, " not supported"));
    }
}
$3cbd1dfc5d804d6f$exports.pubkeyToRawAddress = $3cbd1dfc5d804d6f$var$pubkeyToRawAddress;
/**
 * Returns Tendermint address in uppercase hex format.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $3cbd1dfc5d804d6f$var$pubkeyToAddress(type, data) {
    return (0, $lSA9E.toHex)($3cbd1dfc5d804d6f$var$pubkeyToRawAddress(type, data)).toUpperCase();
}
$3cbd1dfc5d804d6f$exports.pubkeyToAddress = $3cbd1dfc5d804d6f$var$pubkeyToAddress;


Object.defineProperty($7cd013e5dbc8ccb9$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function get() {
        return $3cbd1dfc5d804d6f$exports.pubkeyToAddress;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function get() {
        return $3cbd1dfc5d804d6f$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function get() {
        return $3cbd1dfc5d804d6f$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function get() {
        return $3cbd1dfc5d804d6f$exports.rawSecp256k1PubkeyToRawAddress;
    }
});

var $bCIvL = parcelRequire("bCIvL");
Object.defineProperty($7cd013e5dbc8ccb9$exports, "DateTime", {
    enumerable: true,
    get: function get() {
        return $bCIvL.DateTime;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "fromRfc3339WithNanoseconds", {
    enumerable: true,
    get: function get() {
        return $bCIvL.fromRfc3339WithNanoseconds;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "fromSeconds", {
    enumerable: true,
    get: function get() {
        return $bCIvL.fromSeconds;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "toRfc3339WithNanoseconds", {
    enumerable: true,
    get: function get() {
        return $bCIvL.toRfc3339WithNanoseconds;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "toSeconds", {
    enumerable: true,
    get: function get() {
        return $bCIvL.toSeconds;
    }
});

var $1GCRg = parcelRequire("1GCRg");
Object.defineProperty($7cd013e5dbc8ccb9$exports, "HttpBatchClient", {
    enumerable: true,
    get: function get() {
        return $1GCRg.HttpBatchClient;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "HttpClient", {
    enumerable: true,
    get: function get() {
        return $1GCRg.HttpClient;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "WebsocketClient", {
    enumerable: true,
    get: function get() {
        return $1GCRg.WebsocketClient;
    }
});

Object.defineProperty($7cd013e5dbc8ccb9$exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("2Xz7H")).broadcastTxCommitSuccess;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("2Xz7H")).broadcastTxSyncSuccess;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "Method", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("2Xz7H")).Method;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "SubscriptionEventType", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("2Xz7H")).SubscriptionEventType;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "VoteType", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("2Xz7H")).VoteType;
    }
});

$7cd013e5dbc8ccb9$exports.tendermint34 = $7cd013e5dbc8ccb9$var$__importStar((parcelRequire("2Xz7H")));

Object.defineProperty($7cd013e5dbc8ccb9$exports, "Tendermint34Client", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("2Xz7H")).Tendermint34Client;
    }
});

$7cd013e5dbc8ccb9$exports.tendermint37 = $7cd013e5dbc8ccb9$var$__importStar((parcelRequire("dK1Ew")));

Object.defineProperty($7cd013e5dbc8ccb9$exports, "Tendermint37Client", {
    enumerable: true,
    get: function get() {
        return (parcelRequire("dK1Ew")).Tendermint37Client;
    }
});
var $7124075dbd758f4e$exports = {};
"use strict";
Object.defineProperty($7124075dbd758f4e$exports, "__esModule", {
    value: true
});
$7124075dbd758f4e$exports.isTendermint37Client = $7124075dbd758f4e$exports.isTendermint34Client = void 0;

var $2Xz7H = parcelRequire("2Xz7H");

var $dK1Ew = parcelRequire("dK1Ew");
function $7124075dbd758f4e$var$isTendermint34Client(client) {
    return client instanceof $2Xz7H.Tendermint34Client;
}
$7124075dbd758f4e$exports.isTendermint34Client = $7124075dbd758f4e$var$isTendermint34Client;
function $7124075dbd758f4e$var$isTendermint37Client(client) {
    return client instanceof $dK1Ew.Tendermint37Client;
}
$7124075dbd758f4e$exports.isTendermint37Client = $7124075dbd758f4e$var$isTendermint37Client;


Object.defineProperty($7cd013e5dbc8ccb9$exports, "isTendermint34Client", {
    enumerable: true,
    get: function get() {
        return $7124075dbd758f4e$exports.isTendermint34Client;
    }
});
Object.defineProperty($7cd013e5dbc8ccb9$exports, "isTendermint37Client", {
    enumerable: true,
    get: function get() {
        return $7124075dbd758f4e$exports.isTendermint37Client;
    }
});

var $3yHgT = parcelRequire("3yHgT");
Object.defineProperty($7cd013e5dbc8ccb9$exports, "BlockIdFlag", {
    enumerable: true,
    get: function get() {
        return $3yHgT.BlockIdFlag;
    }
});



var $gMk5u = parcelRequire("gMk5u");







var $e9477aecb74fcbc3$var$long_1 = $e9477aecb74fcbc3$var$__importDefault((parcelRequire("l6G6L")));




var $df3d0edb70d7e1d3$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($df3d0edb70d7e1d3$exports, "__esModule", {
    value: true
});
$df3d0edb70d7e1d3$exports.StargateClient = $df3d0edb70d7e1d3$exports.BroadcastTxError = $df3d0edb70d7e1d3$exports.assertIsDeliverTxFailure = $df3d0edb70d7e1d3$exports.assertIsDeliverTxSuccess = $df3d0edb70d7e1d3$exports.isDeliverTxSuccess = $df3d0edb70d7e1d3$exports.isDeliverTxFailure = $df3d0edb70d7e1d3$exports.TimeoutError = void 0;


var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");


var $gMk5u = parcelRequire("gMk5u");





var $df3d0edb70d7e1d3$var$TimeoutError = /*#__PURE__*/ function(Error1) {
    (0, $cgJ2Y._)(TimeoutError, Error1);
    var _super = (0, $hKD8n._)(TimeoutError);
    function TimeoutError(message, txId) {
        (0, $7dKN1._)(this, TimeoutError);
        var _this;
        _this = _super.call(this, message);
        _this.txId = txId;
        return _this;
    }
    return TimeoutError;
}((0, $jShW9._)(Error));
$df3d0edb70d7e1d3$exports.TimeoutError = $df3d0edb70d7e1d3$var$TimeoutError;
function $df3d0edb70d7e1d3$var$isDeliverTxFailure(result) {
    return !!result.code;
}
$df3d0edb70d7e1d3$exports.isDeliverTxFailure = $df3d0edb70d7e1d3$var$isDeliverTxFailure;
function $df3d0edb70d7e1d3$var$isDeliverTxSuccess(result) {
    return !$df3d0edb70d7e1d3$var$isDeliverTxFailure(result);
}
$df3d0edb70d7e1d3$exports.isDeliverTxSuccess = $df3d0edb70d7e1d3$var$isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $df3d0edb70d7e1d3$var$assertIsDeliverTxSuccess(result) {
    if ($df3d0edb70d7e1d3$var$isDeliverTxFailure(result)) throw new Error("Error when broadcasting tx ".concat(result.transactionHash, " at height ").concat(result.height, ". Code: ").concat(result.code, "; Raw log: ").concat(result.rawLog));
}
$df3d0edb70d7e1d3$exports.assertIsDeliverTxSuccess = $df3d0edb70d7e1d3$var$assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */ function $df3d0edb70d7e1d3$var$assertIsDeliverTxFailure(result) {
    if ($df3d0edb70d7e1d3$var$isDeliverTxSuccess(result)) throw new Error("Transaction ".concat(result.transactionHash, " did not fail at height ").concat(result.height, ". Code: ").concat(result.code, "; Raw log: ").concat(result.rawLog));
}
$df3d0edb70d7e1d3$exports.assertIsDeliverTxFailure = $df3d0edb70d7e1d3$var$assertIsDeliverTxFailure;
/**
 * An error when broadcasting the transaction. This contains the CheckTx errors
 * from the blockchain. Once a transaction is included in a block no BroadcastTxError
 * is thrown, even if the execution fails (DeliverTx errors).
 */ var $df3d0edb70d7e1d3$var$BroadcastTxError = /*#__PURE__*/ function(Error1) {
    (0, $cgJ2Y._)(BroadcastTxError, Error1);
    var _super = (0, $hKD8n._)(BroadcastTxError);
    function BroadcastTxError(code, codespace, log) {
        (0, $7dKN1._)(this, BroadcastTxError);
        var _this;
        _this = _super.call(this, "Broadcasting transaction failed with code ".concat(code, " (codespace: ").concat(codespace, "). Log: ").concat(log));
        _this.code = code;
        _this.codespace = codespace;
        _this.log = log;
        return _this;
    }
    return BroadcastTxError;
}((0, $jShW9._)(Error));
$df3d0edb70d7e1d3$exports.BroadcastTxError = $df3d0edb70d7e1d3$var$BroadcastTxError;
var $df3d0edb70d7e1d3$var$StargateClient = /*#__PURE__*/ function() {
    function StargateClient(tmClient, options) {
        (0, $7dKN1._)(this, StargateClient);
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = $0f41f7d88b60184b$exports.QueryClient.withExtensions(tmClient, $0aaecf7be71ff9a4$exports.setupAuthExtension, $0aaecf7be71ff9a4$exports.setupBankExtension, $0aaecf7be71ff9a4$exports.setupStakingExtension, $0aaecf7be71ff9a4$exports.setupTxExtension);
        }
        var _options_accountParser = options.accountParser, accountParser = _options_accountParser === void 0 ? $99afcd2e4c2331d7$exports.accountFromAny : _options_accountParser;
        this.accountParser = accountParser;
    }
    (0, $eW5pA._)(StargateClient, [
        {
            key: "getTmClient",
            value: function getTmClient() {
                return this.tmClient;
            }
        },
        {
            key: "forceGetTmClient",
            value: function forceGetTmClient() {
                if (!this.tmClient) throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
                return this.tmClient;
            }
        },
        {
            key: "getQueryClient",
            value: function getQueryClient() {
                return this.queryClient;
            }
        },
        {
            key: "forceGetQueryClient",
            value: function forceGetQueryClient() {
                if (!this.queryClient) throw new Error("Query client not available. You cannot use online functionality in offline mode.");
                return this.queryClient;
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response, chainId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.chainId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.forceGetTmClient().status()
                                ];
                            case 1:
                                response = _state.sent();
                                chainId = response.nodeInfo.network;
                                if (!chainId) throw new Error("Chain ID must not be empty");
                                _this.chainId = chainId;
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.chainId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var status;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().status()
                                ];
                            case 1:
                                status = _state.sent();
                                return [
                                    2,
                                    status.syncInfo.latestBlockHeight
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccount",
            value: function getAccount(searchAddress) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var account, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.forceGetQueryClient().auth.account(searchAddress)
                                ];
                            case 1:
                                account = _state.sent();
                                return [
                                    2,
                                    account ? _this.accountParser(account) : null
                                ];
                            case 2:
                                error = _state.sent();
                                if (/rpc error: code = NotFound/i.test(error.toString())) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSequence",
            value: function getSequence(address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var account;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccount(address)
                                ];
                            case 1:
                                account = _state.sent();
                                if (!account) throw new Error("Account '".concat(address, "' does not exist on chain. Send some tokens there before trying to query sequence."));
                                return [
                                    2,
                                    {
                                        accountNumber: account.accountNumber,
                                        sequence: account.sequence
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: function getBlock(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().block(height)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    {
                                        id: (0, $lSA9E.toHex)(response.blockId.hash).toUpperCase(),
                                        header: {
                                            version: {
                                                block: new $kTbgy.Uint53(response.block.header.version.block).toString(),
                                                app: new $kTbgy.Uint53(response.block.header.version.app).toString()
                                            },
                                            height: response.block.header.height,
                                            chainId: response.block.header.chainId,
                                            time: (0, $7cd013e5dbc8ccb9$exports.toRfc3339WithNanoseconds)(response.block.header.time)
                                        },
                                        txs: response.block.txs
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalance",
            value: function getBalance(address, searchDenom) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.forceGetQueryClient().bank.balance(address, searchDenom)
                        ];
                    });
                })();
            }
        },
        {
            key: "getAllBalances",
            value: /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */ function getAllBalances(address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.forceGetQueryClient().bank.allBalances(address)
                        ];
                    });
                })();
            }
        },
        {
            key: "getBalanceStaked",
            value: function getBalanceStaked(address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var allDelegations, startAtKey, _allDelegations, _ref, delegationResponses, pagination, loadedDelegations, sumValues;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                allDelegations = [];
                                startAtKey = undefined;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey)
                                ];
                            case 2:
                                _ref = _state.sent(), delegationResponses = _ref.delegationResponses, pagination = _ref.pagination;
                                loadedDelegations = delegationResponses || [];
                                (_allDelegations = allDelegations).push.apply(_allDelegations, (0, $gF0bR._)(loadedDelegations));
                                startAtKey = pagination === null || pagination === void 0 ? void 0 : pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if (startAtKey !== undefined && startAtKey.length !== 0) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                sumValues = allDelegations.reduce(function(previousValue, currentValue) {
                                    // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
                                    (0, $gMk5u.assert)(currentValue.balance);
                                    return previousValue !== null ? (0, $c9b9a1a428003423$exports.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
                                }, null);
                                return [
                                    2,
                                    sumValues
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDelegation",
            value: function getDelegation(delegatorAddress, validatorAddress) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var delegatedAmount, _delegationResponse, e;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)
                                ];
                            case 1:
                                delegatedAmount = (_delegationResponse = _state.sent().delegationResponse) === null || _delegationResponse === void 0 ? void 0 : _delegationResponse.balance;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                if (e.toString().includes("key not found")) ;
                                else throw e;
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2,
                                    delegatedAmount || null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTx",
            value: function getTx(id) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var results, _results_;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.txsQuery("tx.hash='".concat(id, "'"))
                                ];
                            case 1:
                                results = _state.sent();
                                return [
                                    2,
                                    (_results_ = results[0]) !== null && _results_ !== void 0 ? _results_ : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "searchTx",
            value: function searchTx(query) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var rawQuery;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        if (typeof query === "string") rawQuery = query;
                        else if (Array.isArray(query)) rawQuery = query.map(function(t) {
                            return "".concat(t.key, "='").concat(t.value, "'");
                        }).join(" AND ");
                        else throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
                        return [
                            2,
                            _this.txsQuery(rawQuery)
                        ];
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.tmClient) this.tmClient.disconnect();
            }
        },
        {
            key: "broadcastTx",
            value: /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */ function broadcastTx(tx) {
                var timeoutMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60000, pollIntervalMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3000;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var timedOut, txPollTimeout, pollForTx, transactionId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                timedOut = false;
                                txPollTimeout = setTimeout(function() {
                                    timedOut = true;
                                }, timeoutMs);
                                pollForTx = function() {
                                    var _ref = (0, $6rBFC._)(function(txId) {
                                        var result;
                                        return (0, $6qu4b.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (timedOut) throw new $df3d0edb70d7e1d3$var$TimeoutError("Transaction with ID ".concat(txId, " was submitted but was not yet found on the chain. You might want to check later. There was a wait of ").concat(timeoutMs / 1000, " seconds."), txId);
                                                    return [
                                                        4,
                                                        (0, $gMk5u.sleep)(pollIntervalMs)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        _this.getTx(txId)
                                                    ];
                                                case 2:
                                                    result = _state.sent();
                                                    return [
                                                        2,
                                                        result ? {
                                                            code: result.code,
                                                            height: result.height,
                                                            txIndex: result.txIndex,
                                                            events: result.events,
                                                            rawLog: result.rawLog,
                                                            transactionHash: txId,
                                                            msgResponses: result.msgResponses,
                                                            gasUsed: result.gasUsed,
                                                            gasWanted: result.gasWanted
                                                        } : pollForTx(txId)
                                                    ];
                                            }
                                        });
                                    });
                                    return function pollForTx(txId) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return [
                                    4,
                                    _this.broadcastTxSync(tx)
                                ];
                            case 1:
                                transactionId = _state.sent();
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        return pollForTx(transactionId).then(function(value) {
                                            clearTimeout(txPollTimeout);
                                            resolve(value);
                                        }, function(error) {
                                            clearTimeout(txPollTimeout);
                                            reject(error);
                                        });
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "broadcastTxSync",
            value: /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */ function broadcastTxSync(tx) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var broadcasted, _broadcasted_codespace, transactionId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().broadcastTxSync({
                                        tx: tx
                                    })
                                ];
                            case 1:
                                broadcasted = _state.sent();
                                if (broadcasted.code) return [
                                    2,
                                    Promise.reject(new $df3d0edb70d7e1d3$var$BroadcastTxError(broadcasted.code, (_broadcasted_codespace = broadcasted.codespace) !== null && _broadcasted_codespace !== void 0 ? _broadcasted_codespace : "", broadcasted.log))
                                ];
                                transactionId = (0, $lSA9E.toHex)(broadcasted.hash).toUpperCase();
                                return [
                                    2,
                                    transactionId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "txsQuery",
            value: function txsQuery(query) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var results;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().txSearchAll({
                                        query: query
                                    })
                                ];
                            case 1:
                                results = _state.sent();
                                return [
                                    2,
                                    results.txs.map(function(tx) {
                                        var _tx_result_data;
                                        var txMsgData = $81693c046571dbd5$exports.TxMsgData.decode((_tx_result_data = tx.result.data) !== null && _tx_result_data !== void 0 ? _tx_result_data : new Uint8Array());
                                        return {
                                            height: tx.height,
                                            txIndex: tx.index,
                                            hash: (0, $lSA9E.toHex)(tx.hash).toUpperCase(),
                                            code: tx.result.code,
                                            events: tx.result.events.map($27f242075526edb1$exports.fromTendermintEvent),
                                            rawLog: tx.result.log || "",
                                            tx: tx.tx,
                                            msgResponses: txMsgData.msgResponses,
                                            gasUsed: tx.result.gasUsed,
                                            gasWanted: tx.result.gasWanted
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "connect",
            value: /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */ function connect(endpoint) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    var tmClient, tm37Client, version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint37Client.connect(endpoint)
                                ];
                            case 1:
                                tm37Client = _state.sent();
                                return [
                                    4,
                                    tm37Client.status()
                                ];
                            case 2:
                                version = _state.sent().nodeInfo.version;
                                if (!version.startsWith("0.37.")) return [
                                    3,
                                    3
                                ];
                                tmClient = tm37Client;
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                tm37Client.disconnect();
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint34Client.connect(endpoint)
                                ];
                            case 4:
                                tmClient = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    StargateClient.create(tmClient, options)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ function create(tmClient) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new StargateClient(tmClient, options)
                        ];
                    });
                })();
            }
        }
    ]);
    return StargateClient;
}();
$df3d0edb70d7e1d3$exports.StargateClient = $df3d0edb70d7e1d3$var$StargateClient;


$e9477aecb74fcbc3$exports.defaultRegistryTypes = [
    [
        "/cosmos.base.v1beta1.Coin",
        $5bc8eb379b028930$exports.Coin
    ]
].concat((0, $gF0bR._)($0aaecf7be71ff9a4$exports.authzTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.bankTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.distributionTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.feegrantTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.govTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.groupTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.stakingTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.ibcTypes), (0, $gF0bR._)($0aaecf7be71ff9a4$exports.vestingTypes));
function $e9477aecb74fcbc3$var$createDefaultAminoConverters() {
    return (0, $4JCw4._)({}, (0, $0aaecf7be71ff9a4$exports.createAuthzAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createBankAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createDistributionAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createGovAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createStakingAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createIbcAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createFeegrantAminoConverters)(), (0, $0aaecf7be71ff9a4$exports.createVestingAminoConverters)());
}
$e9477aecb74fcbc3$exports.createDefaultAminoConverters = $e9477aecb74fcbc3$var$createDefaultAminoConverters;
var $e9477aecb74fcbc3$var$SigningStargateClient = /*#__PURE__*/ function(_stargateclient_1_StargateClient) {
    (0, $cgJ2Y._)(SigningStargateClient, _stargateclient_1_StargateClient);
    var _super = (0, $hKD8n._)(SigningStargateClient);
    function SigningStargateClient(tmClient, signer, options) {
        (0, $7dKN1._)(this, SigningStargateClient);
        var _this;
        _this = _super.call(this, tmClient, options);
        var _options_registry = options.registry, registry = _options_registry === void 0 ? new $ff811d56e12ad916$exports.Registry($e9477aecb74fcbc3$exports.defaultRegistryTypes) : _options_registry, _options_aminoTypes = options.aminoTypes, aminoTypes = _options_aminoTypes === void 0 ? new $0d8e1021775d5d34$exports.AminoTypes($e9477aecb74fcbc3$var$createDefaultAminoConverters()) : _options_aminoTypes;
        _this.registry = registry;
        _this.aminoTypes = aminoTypes;
        _this.signer = signer;
        _this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        _this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        _this.gasPrice = options.gasPrice;
        return _this;
    }
    (0, $eW5pA._)(SigningStargateClient, [
        {
            key: "simulate",
            value: function simulate(signerAddress, messages, memo) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var anyMsgs, accountFromSigner, pubkey, sequence, gasInfo;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                anyMsgs = messages.map(function(m) {
                                    return _this.registry.encodeAsAny(m);
                                });
                                return [
                                    4,
                                    _this.signer.getAccounts()
                                ];
                            case 1:
                                accountFromSigner = _state.sent().find(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
                                pubkey = (0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
                                return [
                                    4,
                                    _this.getSequence(signerAddress)
                                ];
                            case 2:
                                sequence = _state.sent().sequence;
                                return [
                                    4,
                                    _this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence)
                                ];
                            case 3:
                                gasInfo = _state.sent().gasInfo;
                                (0, $gMk5u.assertDefined)(gasInfo);
                                return [
                                    2,
                                    $kTbgy.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTokens",
            value: function sendTokens(senderAddress, recipientAddress, amount, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var sendMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        sendMsg = {
                            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
                            value: {
                                fromAddress: senderAddress,
                                toAddress: recipientAddress,
                                amount: (0, $gF0bR._)(amount)
                            }
                        };
                        return [
                            2,
                            _this.signAndBroadcast(senderAddress, [
                                sendMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "delegateTokens",
            value: function delegateTokens(delegatorAddress, validatorAddress, amount, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var delegateMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        delegateMsg = {
                            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
                            value: $83b4166ddf6d1939$exports.MsgDelegate.fromPartial({
                                delegatorAddress: delegatorAddress,
                                validatorAddress: validatorAddress,
                                amount: amount
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(delegatorAddress, [
                                delegateMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "undelegateTokens",
            value: function undelegateTokens(delegatorAddress, validatorAddress, amount, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var undelegateMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        undelegateMsg = {
                            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
                            value: $83b4166ddf6d1939$exports.MsgUndelegate.fromPartial({
                                delegatorAddress: delegatorAddress,
                                validatorAddress: validatorAddress,
                                amount: amount
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(delegatorAddress, [
                                undelegateMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "withdrawRewards",
            value: function withdrawRewards(delegatorAddress, validatorAddress, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var withdrawMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        withdrawMsg = {
                            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                            value: $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorReward.fromPartial({
                                delegatorAddress: delegatorAddress,
                                validatorAddress: validatorAddress
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(delegatorAddress, [
                                withdrawMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "sendIbcTokens",
            value: function sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, /** timeout in seconds */ timeoutTimestamp, fee) {
                var memo = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var timeoutTimestampNanoseconds, transferMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        timeoutTimestampNanoseconds = timeoutTimestamp ? $e9477aecb74fcbc3$var$long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000) : undefined;
                        transferMsg = {
                            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
                            value: $8822fe0a75ad6109$exports.MsgTransfer.fromPartial({
                                sourcePort: sourcePort,
                                sourceChannel: sourceChannel,
                                sender: senderAddress,
                                receiver: recipientAddress,
                                token: transferAmount,
                                timeoutHeight: timeoutHeight,
                                timeoutTimestamp: timeoutTimestampNanoseconds
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(senderAddress, [
                                transferMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "signAndBroadcast",
            value: function signAndBroadcast(signerAddress, messages, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var usedFee, gasEstimation, multiplier, txRaw, txBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(fee == "auto" || typeof fee === "number")) return [
                                    3,
                                    2
                                ];
                                (0, $gMk5u.assertDefined)(_this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
                                return [
                                    4,
                                    _this.simulate(signerAddress, messages, memo)
                                ];
                            case 1:
                                gasEstimation = _state.sent();
                                // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
                                // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
                                multiplier = typeof fee === "number" ? fee : 1.4;
                                usedFee = (0, $fdc4d1c1d72f53dc$exports.calculateFee)(Math.round(gasEstimation * multiplier), _this.gasPrice);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                usedFee = fee;
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _this.sign(signerAddress, messages, usedFee, memo)
                                ];
                            case 4:
                                txRaw = _state.sent();
                                txBytes = $540f96552e476ffb$exports.TxRaw.encode(txRaw).finish();
                                return [
                                    2,
                                    _this.broadcastTx(txBytes, _this.broadcastTimeoutMs, _this.broadcastPollIntervalMs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAndBroadcastSync",
            value: /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */ function signAndBroadcastSync(signerAddress, messages, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var usedFee, gasEstimation, multiplier, txRaw, txBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(fee == "auto" || typeof fee === "number")) return [
                                    3,
                                    2
                                ];
                                (0, $gMk5u.assertDefined)(_this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
                                return [
                                    4,
                                    _this.simulate(signerAddress, messages, memo)
                                ];
                            case 1:
                                gasEstimation = _state.sent();
                                multiplier = typeof fee === "number" ? fee : 1.3;
                                usedFee = (0, $fdc4d1c1d72f53dc$exports.calculateFee)(Math.round(gasEstimation * multiplier), _this.gasPrice);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                usedFee = fee;
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _this.sign(signerAddress, messages, usedFee, memo)
                                ];
                            case 4:
                                txRaw = _state.sent();
                                txBytes = $540f96552e476ffb$exports.TxRaw.encode(txRaw).finish();
                                return [
                                    2,
                                    _this.broadcastTxSync(txBytes)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sign",
            value: /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */ function sign(signerAddress, messages, fee, memo, explicitSignerData) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var signerData, _ref, accountNumber, sequence, chainId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!explicitSignerData) return [
                                    3,
                                    1
                                ];
                                signerData = explicitSignerData;
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.getSequence(signerAddress)
                                ];
                            case 2:
                                _ref = _state.sent(), accountNumber = _ref.accountNumber, sequence = _ref.sequence;
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 3:
                                chainId = _state.sent();
                                signerData = {
                                    accountNumber: accountNumber,
                                    sequence: sequence,
                                    chainId: chainId
                                };
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    (0, $ff811d56e12ad916$exports.isOfflineDirectSigner)(_this.signer) ? _this.signDirect(signerAddress, messages, fee, memo, signerData) : _this.signAmino(signerAddress, messages, fee, memo, signerData)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAmino",
            value: function signAmino(signerAddress, messages, fee, memo, param) {
                var accountNumber = param.accountNumber, sequence = param.sequence, chainId = param.chainId;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accountFromSigner, pubkey, signMode, msgs, signDoc, _ref, signature, signed, signedTxBody, signedTxBodyEncodeObject, signedTxBodyBytes, signedGasLimit, signedSequence, signedAuthInfoBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $gMk5u.assert)(!(0, $ff811d56e12ad916$exports.isOfflineDirectSigner)(_this.signer));
                                return [
                                    4,
                                    _this.signer.getAccounts()
                                ];
                            case 1:
                                accountFromSigner = _state.sent().find(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
                                pubkey = (0, $ff811d56e12ad916$exports.encodePubkey)((0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
                                signMode = $82c22db8b6bc5755$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
                                msgs = messages.map(function(msg) {
                                    return _this.aminoTypes.toAmino(msg);
                                });
                                signDoc = (0, $c9b9a1a428003423$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
                                return [
                                    4,
                                    _this.signer.signAmino(signerAddress, signDoc)
                                ];
                            case 2:
                                _ref = _state.sent(), signature = _ref.signature, signed = _ref.signed;
                                signedTxBody = {
                                    messages: signed.msgs.map(function(msg) {
                                        return _this.aminoTypes.fromAmino(msg);
                                    }),
                                    memo: signed.memo
                                };
                                signedTxBodyEncodeObject = {
                                    typeUrl: "/cosmos.tx.v1beta1.TxBody",
                                    value: signedTxBody
                                };
                                signedTxBodyBytes = _this.registry.encode(signedTxBodyEncodeObject);
                                signedGasLimit = $kTbgy.Int53.fromString(signed.fee.gas).toNumber();
                                signedSequence = $kTbgy.Int53.fromString(signed.sequence).toNumber();
                                signedAuthInfoBytes = (0, $ff811d56e12ad916$exports.makeAuthInfoBytes)([
                                    {
                                        pubkey: pubkey,
                                        sequence: signedSequence
                                    }
                                ], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
                                return [
                                    2,
                                    $540f96552e476ffb$exports.TxRaw.fromPartial({
                                        bodyBytes: signedTxBodyBytes,
                                        authInfoBytes: signedAuthInfoBytes,
                                        signatures: [
                                            (0, $lSA9E.fromBase64)(signature.signature)
                                        ]
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signDirect",
            value: function signDirect(signerAddress, messages, fee, memo, param) {
                var accountNumber = param.accountNumber, sequence = param.sequence, chainId = param.chainId;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accountFromSigner, pubkey, txBodyEncodeObject, txBodyBytes, gasLimit, authInfoBytes, signDoc, _ref, signature, signed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $gMk5u.assert)((0, $ff811d56e12ad916$exports.isOfflineDirectSigner)(_this.signer));
                                return [
                                    4,
                                    _this.signer.getAccounts()
                                ];
                            case 1:
                                accountFromSigner = _state.sent().find(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
                                pubkey = (0, $ff811d56e12ad916$exports.encodePubkey)((0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
                                txBodyEncodeObject = {
                                    typeUrl: "/cosmos.tx.v1beta1.TxBody",
                                    value: {
                                        messages: messages,
                                        memo: memo
                                    }
                                };
                                txBodyBytes = _this.registry.encode(txBodyEncodeObject);
                                gasLimit = $kTbgy.Int53.fromString(fee.gas).toNumber();
                                authInfoBytes = (0, $ff811d56e12ad916$exports.makeAuthInfoBytes)([
                                    {
                                        pubkey: pubkey,
                                        sequence: sequence
                                    }
                                ], fee.amount, gasLimit, fee.granter, fee.payer);
                                signDoc = (0, $ff811d56e12ad916$exports.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
                                return [
                                    4,
                                    _this.signer.signDirect(signerAddress, signDoc)
                                ];
                            case 2:
                                _ref = _state.sent(), signature = _ref.signature, signed = _ref.signed;
                                return [
                                    2,
                                    $540f96552e476ffb$exports.TxRaw.fromPartial({
                                        bodyBytes: signed.bodyBytes,
                                        authInfoBytes: signed.authInfoBytes,
                                        signatures: [
                                            (0, $lSA9E.fromBase64)(signature.signature)
                                        ]
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "connectWithSigner",
            value: /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */ function connectWithSigner(endpoint, signer) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return (0, $6rBFC._)(function() {
                    var tmClient, tm37Client, version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint37Client.connect(endpoint)
                                ];
                            case 1:
                                tm37Client = _state.sent();
                                return [
                                    4,
                                    tm37Client.status()
                                ];
                            case 2:
                                version = _state.sent().nodeInfo.version;
                                if (!version.startsWith("0.37.")) return [
                                    3,
                                    3
                                ];
                                tmClient = tm37Client;
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                tm37Client.disconnect();
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint34Client.connect(endpoint)
                                ];
                            case 4:
                                tmClient = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    SigningStargateClient.createWithSigner(tmClient, signer, options)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createWithSigner",
            value: /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ function createWithSigner(tmClient, signer) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new SigningStargateClient(tmClient, signer, options)
                        ];
                    });
                })();
            }
        },
        {
            key: "offline",
            value: /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */ function offline(signer) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new SigningStargateClient(undefined, signer, options)
                        ];
                    });
                })();
            }
        }
    ]);
    return SigningStargateClient;
}($df3d0edb70d7e1d3$exports.StargateClient);
$e9477aecb74fcbc3$exports.SigningStargateClient = $e9477aecb74fcbc3$var$SigningStargateClient;


Object.defineProperty($3e8bd88d734bad5a$exports, "createDefaultAminoConverters", {
    enumerable: true,
    get: function get() {
        return $e9477aecb74fcbc3$exports.createDefaultAminoConverters;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "defaultRegistryTypes", {
    enumerable: true,
    get: function get() {
        return $e9477aecb74fcbc3$exports.defaultRegistryTypes;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "SigningStargateClient", {
    enumerable: true,
    get: function get() {
        return $e9477aecb74fcbc3$exports.SigningStargateClient;
    }
});

Object.defineProperty($3e8bd88d734bad5a$exports, "assertIsDeliverTxFailure", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.assertIsDeliverTxFailure;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "assertIsDeliverTxSuccess", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.assertIsDeliverTxSuccess;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "BroadcastTxError", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.BroadcastTxError;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isDeliverTxFailure", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.isDeliverTxFailure;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "isDeliverTxSuccess", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.isDeliverTxSuccess;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "StargateClient", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.StargateClient;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "TimeoutError", {
    enumerable: true,
    get: function get() {
        return $df3d0edb70d7e1d3$exports.TimeoutError;
    }
});

Object.defineProperty($3e8bd88d734bad5a$exports, "coin", {
    enumerable: true,
    get: function get() {
        return $ff811d56e12ad916$exports.coin;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "coins", {
    enumerable: true,
    get: function get() {
        return $ff811d56e12ad916$exports.coins;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function get() {
        return $ff811d56e12ad916$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($3e8bd88d734bad5a$exports, "parseCoins", {
    enumerable: true,
    get: function get() {
        return $ff811d56e12ad916$exports.parseCoins;
    }
});




var $gMk5u = parcelRequire("gMk5u");

var $1bc6660756f38535$exports = {};
"use strict";
var $1bc6660756f38535$var$__createBinding = $1bc6660756f38535$exports && $1bc6660756f38535$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1bc6660756f38535$var$__setModuleDefault = $1bc6660756f38535$exports && $1bc6660756f38535$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1bc6660756f38535$var$__importStar = $1bc6660756f38535$exports && $1bc6660756f38535$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1bc6660756f38535$var$__createBinding(result, mod, k);
    }
    $1bc6660756f38535$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1bc6660756f38535$exports, "__esModule", {
    value: true
});
$1bc6660756f38535$exports.Model = $1bc6660756f38535$exports.AbsoluteTxPosition = $1bc6660756f38535$exports.ContractCodeHistoryEntry = $1bc6660756f38535$exports.ContractInfo = $1bc6660756f38535$exports.CodeInfo = $1bc6660756f38535$exports.Params = $1bc6660756f38535$exports.AccessConfig = $1bc6660756f38535$exports.AccessTypeParam = $1bc6660756f38535$exports.contractCodeHistoryOperationTypeToJSON = $1bc6660756f38535$exports.contractCodeHistoryOperationTypeFromJSON = $1bc6660756f38535$exports.ContractCodeHistoryOperationType = $1bc6660756f38535$exports.accessTypeToJSON = $1bc6660756f38535$exports.accessTypeFromJSON = $1bc6660756f38535$exports.AccessType = $1bc6660756f38535$exports.protobufPackage = void 0;

var $DM7bi = parcelRequire("DM7bi");

var $7iZIe = parcelRequire("7iZIe");

var $1bc6660756f38535$var$_m0 = $1bc6660756f38535$var$__importStar((parcelRequire("hjb8Q")));
$1bc6660756f38535$exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */ var $1bc6660756f38535$var$AccessType;
(function(AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */ AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */ AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /**
     * ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to a single address
     * Deprecated: use AccessTypeAnyOfAddresses instead
     */ AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */ AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    /** ACCESS_TYPE_ANY_OF_ADDRESSES - AccessTypeAnyOfAddresses allow any of the addresses */ AccessType[AccessType["ACCESS_TYPE_ANY_OF_ADDRESSES"] = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1bc6660756f38535$var$AccessType = $1bc6660756f38535$exports.AccessType || ($1bc6660756f38535$exports.AccessType = {}));
function $1bc6660756f38535$var$accessTypeFromJSON(object) {
    switch(object){
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return $1bc6660756f38535$var$AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return $1bc6660756f38535$var$AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return $1bc6660756f38535$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return $1bc6660756f38535$var$AccessType.ACCESS_TYPE_EVERYBODY;
        case 4:
        case "ACCESS_TYPE_ANY_OF_ADDRESSES":
            return $1bc6660756f38535$var$AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1bc6660756f38535$var$AccessType.UNRECOGNIZED;
    }
}
$1bc6660756f38535$exports.accessTypeFromJSON = $1bc6660756f38535$var$accessTypeFromJSON;
function $1bc6660756f38535$var$accessTypeToJSON(object) {
    switch(object){
        case $1bc6660756f38535$var$AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case $1bc6660756f38535$var$AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case $1bc6660756f38535$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case $1bc6660756f38535$var$AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        case $1bc6660756f38535$var$AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
            return "ACCESS_TYPE_ANY_OF_ADDRESSES";
        case $1bc6660756f38535$var$AccessType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1bc6660756f38535$exports.accessTypeToJSON = $1bc6660756f38535$var$accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */ var $1bc6660756f38535$var$ContractCodeHistoryOperationType;
(function(ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1bc6660756f38535$var$ContractCodeHistoryOperationType = $1bc6660756f38535$exports.ContractCodeHistoryOperationType || ($1bc6660756f38535$exports.ContractCodeHistoryOperationType = {}));
function $1bc6660756f38535$var$contractCodeHistoryOperationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1bc6660756f38535$var$ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
$1bc6660756f38535$exports.contractCodeHistoryOperationTypeFromJSON = $1bc6660756f38535$var$contractCodeHistoryOperationTypeFromJSON;
function $1bc6660756f38535$var$contractCodeHistoryOperationTypeToJSON(object) {
    switch(object){
        case $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case $1bc6660756f38535$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        case $1bc6660756f38535$var$ContractCodeHistoryOperationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$1bc6660756f38535$exports.contractCodeHistoryOperationTypeToJSON = $1bc6660756f38535$var$contractCodeHistoryOperationTypeToJSON;
function $1bc6660756f38535$var$createBaseAccessTypeParam() {
    return {
        value: 0
    };
}
$1bc6660756f38535$exports.AccessTypeParam = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (message.value !== 0) writer.uint32(8).int32(message.value);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseAccessTypeParam();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            value: (0, $7iZIe.isSet)(object.value) ? $1bc6660756f38535$var$accessTypeFromJSON(object.value) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.value !== undefined && (obj.value = $1bc6660756f38535$var$accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseAccessTypeParam();
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : 0;
        return message;
    }
};
function $1bc6660756f38535$var$createBaseAccessConfig() {
    return {
        permission: 0,
        address: "",
        addresses: []
    };
}
$1bc6660756f38535$exports.AccessConfig = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (message.permission !== 0) writer.uint32(8).int32(message.permission);
        if (message.address !== "") writer.uint32(18).string(message.address);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.addresses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(26).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseAccessConfig();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            permission: (0, $7iZIe.isSet)(object.permission) ? $1bc6660756f38535$var$accessTypeFromJSON(object.permission) : 0,
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map(function(e) {
                return String(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.permission !== undefined && (obj.permission = $1bc6660756f38535$var$accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        if (message.addresses) obj.addresses = message.addresses.map(function(e) {
            return e;
        });
        else obj.addresses = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_addresses;
        var message = $1bc6660756f38535$var$createBaseAccessConfig();
        var _object_permission;
        message.permission = (_object_permission = object.permission) !== null && _object_permission !== void 0 ? _object_permission : 0;
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.addresses = ((_object_addresses = object.addresses) === null || _object_addresses === void 0 ? void 0 : _object_addresses.map(function(e) {
            return e;
        })) || [];
        return message;
    }
};
function $1bc6660756f38535$var$createBaseParams() {
    return {
        codeUploadAccess: undefined,
        instantiateDefaultPermission: 0
    };
}
$1bc6660756f38535$exports.Params = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (message.codeUploadAccess !== undefined) $1bc6660756f38535$exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        if (message.instantiateDefaultPermission !== 0) writer.uint32(16).int32(message.instantiateDefaultPermission);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeUploadAccess = $1bc6660756f38535$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeUploadAccess: (0, $7iZIe.isSet)(object.codeUploadAccess) ? $1bc6660756f38535$exports.AccessConfig.fromJSON(object.codeUploadAccess) : undefined,
            instantiateDefaultPermission: (0, $7iZIe.isSet)(object.instantiateDefaultPermission) ? $1bc6660756f38535$var$accessTypeFromJSON(object.instantiateDefaultPermission) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeUploadAccess !== undefined && (obj.codeUploadAccess = message.codeUploadAccess ? $1bc6660756f38535$exports.AccessConfig.toJSON(message.codeUploadAccess) : undefined);
        message.instantiateDefaultPermission !== undefined && (obj.instantiateDefaultPermission = $1bc6660756f38535$var$accessTypeToJSON(message.instantiateDefaultPermission));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseParams();
        message.codeUploadAccess = object.codeUploadAccess !== undefined && object.codeUploadAccess !== null ? $1bc6660756f38535$exports.AccessConfig.fromPartial(object.codeUploadAccess) : undefined;
        var _object_instantiateDefaultPermission;
        message.instantiateDefaultPermission = (_object_instantiateDefaultPermission = object.instantiateDefaultPermission) !== null && _object_instantiateDefaultPermission !== void 0 ? _object_instantiateDefaultPermission : 0;
        return message;
    }
};
function $1bc6660756f38535$var$createBaseCodeInfo() {
    return {
        codeHash: new Uint8Array(),
        creator: "",
        instantiateConfig: undefined
    };
}
$1bc6660756f38535$exports.CodeInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (message.codeHash.length !== 0) writer.uint32(10).bytes(message.codeHash);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.instantiateConfig !== undefined) $1bc6660756f38535$exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseCodeInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = $1bc6660756f38535$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeHash: (0, $7iZIe.isSet)(object.codeHash) ? (0, $7iZIe.bytesFromBase64)(object.codeHash) : new Uint8Array(),
            creator: (0, $7iZIe.isSet)(object.creator) ? String(object.creator) : "",
            instantiateConfig: (0, $7iZIe.isSet)(object.instantiateConfig) ? $1bc6660756f38535$exports.AccessConfig.fromJSON(object.instantiateConfig) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeHash !== undefined && (obj.codeHash = (0, $7iZIe.base64FromBytes)(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined && (obj.instantiateConfig = message.instantiateConfig ? $1bc6660756f38535$exports.AccessConfig.toJSON(message.instantiateConfig) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseCodeInfo();
        var _object_codeHash;
        message.codeHash = (_object_codeHash = object.codeHash) !== null && _object_codeHash !== void 0 ? _object_codeHash : new Uint8Array();
        var _object_creator;
        message.creator = (_object_creator = object.creator) !== null && _object_creator !== void 0 ? _object_creator : "";
        message.instantiateConfig = object.instantiateConfig !== undefined && object.instantiateConfig !== null ? $1bc6660756f38535$exports.AccessConfig.fromPartial(object.instantiateConfig) : undefined;
        return message;
    }
};
function $1bc6660756f38535$var$createBaseContractInfo() {
    return {
        codeId: $7iZIe.Long.UZERO,
        creator: "",
        admin: "",
        label: "",
        created: undefined,
        ibcPortId: "",
        extension: undefined
    };
}
$1bc6660756f38535$exports.ContractInfo = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.created !== undefined) $1bc6660756f38535$exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        if (message.ibcPortId !== "") writer.uint32(50).string(message.ibcPortId);
        if (message.extension !== undefined) $DM7bi.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseContractInfo();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = $1bc6660756f38535$exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = $DM7bi.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            creator: (0, $7iZIe.isSet)(object.creator) ? String(object.creator) : "",
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            label: (0, $7iZIe.isSet)(object.label) ? String(object.label) : "",
            created: (0, $7iZIe.isSet)(object.created) ? $1bc6660756f38535$exports.AbsoluteTxPosition.fromJSON(object.created) : undefined,
            ibcPortId: (0, $7iZIe.isSet)(object.ibcPortId) ? String(object.ibcPortId) : "",
            extension: (0, $7iZIe.isSet)(object.extension) ? $DM7bi.Any.fromJSON(object.extension) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined && (obj.created = message.created ? $1bc6660756f38535$exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined && (obj.extension = message.extension ? $DM7bi.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseContractInfo();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        var _object_creator;
        message.creator = (_object_creator = object.creator) !== null && _object_creator !== void 0 ? _object_creator : "";
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        var _object_label;
        message.label = (_object_label = object.label) !== null && _object_label !== void 0 ? _object_label : "";
        message.created = object.created !== undefined && object.created !== null ? $1bc6660756f38535$exports.AbsoluteTxPosition.fromPartial(object.created) : undefined;
        var _object_ibcPortId;
        message.ibcPortId = (_object_ibcPortId = object.ibcPortId) !== null && _object_ibcPortId !== void 0 ? _object_ibcPortId : "";
        message.extension = object.extension !== undefined && object.extension !== null ? $DM7bi.Any.fromPartial(object.extension) : undefined;
        return message;
    }
};
function $1bc6660756f38535$var$createBaseContractCodeHistoryEntry() {
    return {
        operation: 0,
        codeId: $7iZIe.Long.UZERO,
        updated: undefined,
        msg: new Uint8Array()
    };
}
$1bc6660756f38535$exports.ContractCodeHistoryEntry = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (message.operation !== 0) writer.uint32(8).int32(message.operation);
        if (!message.codeId.isZero()) writer.uint32(16).uint64(message.codeId);
        if (message.updated !== undefined) $1bc6660756f38535$exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseContractCodeHistoryEntry();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.updated = $1bc6660756f38535$exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            operation: (0, $7iZIe.isSet)(object.operation) ? $1bc6660756f38535$var$contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            updated: (0, $7iZIe.isSet)(object.updated) ? $1bc6660756f38535$exports.AbsoluteTxPosition.fromJSON(object.updated) : undefined,
            msg: (0, $7iZIe.isSet)(object.msg) ? (0, $7iZIe.bytesFromBase64)(object.msg) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.operation !== undefined && (obj.operation = $1bc6660756f38535$var$contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.updated !== undefined && (obj.updated = message.updated ? $1bc6660756f38535$exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined && (obj.msg = (0, $7iZIe.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseContractCodeHistoryEntry();
        var _object_operation;
        message.operation = (_object_operation = object.operation) !== null && _object_operation !== void 0 ? _object_operation : 0;
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        message.updated = object.updated !== undefined && object.updated !== null ? $1bc6660756f38535$exports.AbsoluteTxPosition.fromPartial(object.updated) : undefined;
        var _object_msg;
        message.msg = (_object_msg = object.msg) !== null && _object_msg !== void 0 ? _object_msg : new Uint8Array();
        return message;
    }
};
function $1bc6660756f38535$var$createBaseAbsoluteTxPosition() {
    return {
        blockHeight: $7iZIe.Long.UZERO,
        txIndex: $7iZIe.Long.UZERO
    };
}
$1bc6660756f38535$exports.AbsoluteTxPosition = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (!message.blockHeight.isZero()) writer.uint32(8).uint64(message.blockHeight);
        if (!message.txIndex.isZero()) writer.uint32(16).uint64(message.txIndex);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseAbsoluteTxPosition();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockHeight = reader.uint64();
                    break;
                case 2:
                    message.txIndex = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            blockHeight: (0, $7iZIe.isSet)(object.blockHeight) ? $7iZIe.Long.fromValue(object.blockHeight) : $7iZIe.Long.UZERO,
            txIndex: (0, $7iZIe.isSet)(object.txIndex) ? $7iZIe.Long.fromValue(object.txIndex) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = (message.blockHeight || $7iZIe.Long.UZERO).toString());
        message.txIndex !== undefined && (obj.txIndex = (message.txIndex || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseAbsoluteTxPosition();
        message.blockHeight = object.blockHeight !== undefined && object.blockHeight !== null ? $7iZIe.Long.fromValue(object.blockHeight) : $7iZIe.Long.UZERO;
        message.txIndex = object.txIndex !== undefined && object.txIndex !== null ? $7iZIe.Long.fromValue(object.txIndex) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $1bc6660756f38535$var$createBaseModel() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array()
    };
}
$1bc6660756f38535$exports.Model = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1bc6660756f38535$var$_m0.Writer.create();
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $1bc6660756f38535$var$_m0.Reader ? input : new $1bc6660756f38535$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $1bc6660756f38535$var$createBaseModel();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            key: (0, $7iZIe.isSet)(object.key) ? (0, $7iZIe.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $7iZIe.isSet)(object.value) ? (0, $7iZIe.bytesFromBase64)(object.value) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.key !== undefined && (obj.key = (0, $7iZIe.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $7iZIe.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $1bc6660756f38535$var$createBaseModel();
        var _object_key;
        message.key = (_object_key = object.key) !== null && _object_key !== void 0 ? _object_key : new Uint8Array();
        var _object_value;
        message.value = (_object_value = object.value) !== null && _object_value !== void 0 ? _object_value : new Uint8Array();
        return message;
    }
};


var $13726c8633dadd49$exports = {};
"use strict";
Object.defineProperty($13726c8633dadd49$exports, "__esModule", {
    value: true
});
$13726c8633dadd49$exports.setupWasmExtension = $13726c8633dadd49$exports.wasmTypes = $13726c8633dadd49$exports.isMsgUpdateAdminEncodeObject = $13726c8633dadd49$exports.isMsgStoreCodeEncodeObject = $13726c8633dadd49$exports.isMsgMigrateEncodeObject = $13726c8633dadd49$exports.isMsgInstantiateContractEncodeObject = $13726c8633dadd49$exports.isMsgInstantiateContract2EncodeObject = $13726c8633dadd49$exports.isMsgExecuteEncodeObject = $13726c8633dadd49$exports.isMsgClearAdminEncodeObject = $13726c8633dadd49$exports.createWasmAminoConverters = void 0;
var $265f94055b8fad24$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
var $265f94055b8fad24$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($265f94055b8fad24$exports, "__esModule", {
    value: true
});
$265f94055b8fad24$exports.createWasmAminoConverters = $265f94055b8fad24$exports.accessTypeToString = $265f94055b8fad24$exports.accessTypeFromString = void 0;

var $lSA9E = parcelRequire("lSA9E");


var $265f94055b8fad24$var$long_1 = $265f94055b8fad24$var$__importDefault((parcelRequire("l6G6L")));
function $265f94055b8fad24$var$accessTypeFromString(str) {
    switch(str){
        case "Unspecified":
            return $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_UNSPECIFIED;
        case "Nobody":
            return $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_NOBODY;
        case "OnlyAddress":
            return $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case "Everybody":
            return $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_EVERYBODY;
        case "AnyOfAddresses":
            return $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES;
        default:
            return $1bc6660756f38535$exports.AccessType.UNRECOGNIZED;
    }
}
$265f94055b8fad24$exports.accessTypeFromString = $265f94055b8fad24$var$accessTypeFromString;
function $265f94055b8fad24$var$accessTypeToString(object) {
    switch(object){
        case $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "Unspecified";
        case $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_NOBODY:
            return "Nobody";
        case $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "OnlyAddress";
        case $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_EVERYBODY:
            return "Everybody";
        case $1bc6660756f38535$exports.AccessType.ACCESS_TYPE_ANY_OF_ADDRESSES:
            return "AnyOfAddresses";
        case $1bc6660756f38535$exports.AccessType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$265f94055b8fad24$exports.accessTypeToString = $265f94055b8fad24$var$accessTypeToString;
function $265f94055b8fad24$var$createWasmAminoConverters() {
    return {
        "/cosmwasm.wasm.v1.MsgStoreCode": {
            aminoType: "wasm/MsgStoreCode",
            toAmino: function(param) {
                var sender = param.sender, wasmByteCode = param.wasmByteCode, instantiatePermission = param.instantiatePermission;
                return {
                    sender: sender,
                    wasm_byte_code: (0, $lSA9E.toBase64)(wasmByteCode),
                    instantiate_permission: instantiatePermission ? {
                        permission: $265f94055b8fad24$var$accessTypeToString(instantiatePermission.permission),
                        address: instantiatePermission.address || undefined,
                        addresses: instantiatePermission.addresses.length !== 0 ? instantiatePermission.addresses : undefined
                    } : undefined
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, wasm_byte_code = param.wasm_byte_code, instantiate_permission = param.instantiate_permission;
                var _instantiate_permission_address, _instantiate_permission_addresses;
                return {
                    sender: sender,
                    wasmByteCode: (0, $lSA9E.fromBase64)(wasm_byte_code),
                    instantiatePermission: instantiate_permission ? {
                        permission: $265f94055b8fad24$var$accessTypeFromString(instantiate_permission.permission),
                        address: (_instantiate_permission_address = instantiate_permission.address) !== null && _instantiate_permission_address !== void 0 ? _instantiate_permission_address : "",
                        addresses: (_instantiate_permission_addresses = instantiate_permission.addresses) !== null && _instantiate_permission_addresses !== void 0 ? _instantiate_permission_addresses : []
                    } : undefined
                };
            }
        },
        "/cosmwasm.wasm.v1.MsgInstantiateContract": {
            aminoType: "wasm/MsgInstantiateContract",
            toAmino: function(param) {
                var sender = param.sender, codeId = param.codeId, label = param.label, msg = param.msg, funds = param.funds, admin = param.admin;
                return {
                    sender: sender,
                    code_id: codeId.toString(),
                    label: label,
                    msg: JSON.parse((0, $lSA9E.fromUtf8)(msg)),
                    funds: funds,
                    admin: admin || undefined
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, code_id = param.code_id, label = param.label, msg = param.msg, funds = param.funds, admin = param.admin;
                return {
                    sender: sender,
                    codeId: $265f94055b8fad24$var$long_1.default.fromString(code_id),
                    label: label,
                    msg: (0, $lSA9E.toUtf8)(JSON.stringify(msg)),
                    funds: (0, $gF0bR._)(funds),
                    admin: admin !== null && admin !== void 0 ? admin : ""
                };
            }
        },
        "/cosmwasm.wasm.v1.MsgInstantiateContract2": {
            aminoType: "wasm/MsgInstantiateContract2",
            toAmino: function(param) {
                var sender = param.sender, codeId = param.codeId, label = param.label, msg = param.msg, funds = param.funds, admin = param.admin, salt = param.salt, fixMsg = param.fixMsg;
                return {
                    sender: sender,
                    code_id: codeId.toString(),
                    label: label,
                    msg: JSON.parse((0, $lSA9E.fromUtf8)(msg)),
                    funds: funds,
                    admin: admin || undefined,
                    salt: (0, $lSA9E.toBase64)(salt),
                    fix_msg: fixMsg
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, code_id = param.code_id, label = param.label, msg = param.msg, funds = param.funds, admin = param.admin, salt = param.salt, fix_msg = param.fix_msg;
                return {
                    sender: sender,
                    codeId: $265f94055b8fad24$var$long_1.default.fromString(code_id),
                    label: label,
                    msg: (0, $lSA9E.toUtf8)(JSON.stringify(msg)),
                    funds: (0, $gF0bR._)(funds),
                    admin: admin !== null && admin !== void 0 ? admin : "",
                    salt: (0, $lSA9E.fromBase64)(salt),
                    fixMsg: fix_msg
                };
            }
        },
        "/cosmwasm.wasm.v1.MsgUpdateAdmin": {
            aminoType: "wasm/MsgUpdateAdmin",
            toAmino: function(param) {
                var sender = param.sender, newAdmin = param.newAdmin, contract = param.contract;
                return {
                    sender: sender,
                    new_admin: newAdmin,
                    contract: contract
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, new_admin = param.new_admin, contract = param.contract;
                return {
                    sender: sender,
                    newAdmin: new_admin,
                    contract: contract
                };
            }
        },
        "/cosmwasm.wasm.v1.MsgClearAdmin": {
            aminoType: "wasm/MsgClearAdmin",
            toAmino: function(param) {
                var sender = param.sender, contract = param.contract;
                return {
                    sender: sender,
                    contract: contract
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, contract = param.contract;
                return {
                    sender: sender,
                    contract: contract
                };
            }
        },
        "/cosmwasm.wasm.v1.MsgExecuteContract": {
            aminoType: "wasm/MsgExecuteContract",
            toAmino: function(param) {
                var sender = param.sender, contract = param.contract, msg = param.msg, funds = param.funds;
                return {
                    sender: sender,
                    contract: contract,
                    msg: JSON.parse((0, $lSA9E.fromUtf8)(msg)),
                    funds: funds
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, contract = param.contract, msg = param.msg, funds = param.funds;
                return {
                    sender: sender,
                    contract: contract,
                    msg: (0, $lSA9E.toUtf8)(JSON.stringify(msg)),
                    funds: (0, $gF0bR._)(funds)
                };
            }
        },
        "/cosmwasm.wasm.v1.MsgMigrateContract": {
            aminoType: "wasm/MsgMigrateContract",
            toAmino: function(param) {
                var sender = param.sender, contract = param.contract, codeId = param.codeId, msg = param.msg;
                return {
                    sender: sender,
                    contract: contract,
                    code_id: codeId.toString(),
                    msg: JSON.parse((0, $lSA9E.fromUtf8)(msg))
                };
            },
            fromAmino: function(param) {
                var sender = param.sender, contract = param.contract, code_id = param.code_id, msg = param.msg;
                return {
                    sender: sender,
                    contract: contract,
                    codeId: $265f94055b8fad24$var$long_1.default.fromString(code_id),
                    msg: (0, $lSA9E.toUtf8)(JSON.stringify(msg))
                };
            }
        }
    };
}
$265f94055b8fad24$exports.createWasmAminoConverters = $265f94055b8fad24$var$createWasmAminoConverters;


Object.defineProperty($13726c8633dadd49$exports, "createWasmAminoConverters", {
    enumerable: true,
    get: function get() {
        return $265f94055b8fad24$exports.createWasmAminoConverters;
    }
});
var $a4ec21e67fc26b92$exports = {};
"use strict";
Object.defineProperty($a4ec21e67fc26b92$exports, "__esModule", {
    value: true
});
$a4ec21e67fc26b92$exports.isMsgExecuteEncodeObject = $a4ec21e67fc26b92$exports.isMsgMigrateEncodeObject = $a4ec21e67fc26b92$exports.isMsgClearAdminEncodeObject = $a4ec21e67fc26b92$exports.isMsgUpdateAdminEncodeObject = $a4ec21e67fc26b92$exports.isMsgInstantiateContract2EncodeObject = $a4ec21e67fc26b92$exports.isMsgInstantiateContractEncodeObject = $a4ec21e67fc26b92$exports.isMsgStoreCodeEncodeObject = $a4ec21e67fc26b92$exports.wasmTypes = void 0;
var $a3e3198abc37a385$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $a3e3198abc37a385$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a3e3198abc37a385$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a3e3198abc37a385$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a3e3198abc37a385$var$__createBinding(result, mod, k);
    }
    $a3e3198abc37a385$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a3e3198abc37a385$exports, "__esModule", {
    value: true
});
$a3e3198abc37a385$exports.MsgClientImpl = $a3e3198abc37a385$exports.MsgUpdateInstantiateConfigResponse = $a3e3198abc37a385$exports.MsgUpdateInstantiateConfig = $a3e3198abc37a385$exports.MsgClearAdminResponse = $a3e3198abc37a385$exports.MsgClearAdmin = $a3e3198abc37a385$exports.MsgUpdateAdminResponse = $a3e3198abc37a385$exports.MsgUpdateAdmin = $a3e3198abc37a385$exports.MsgMigrateContractResponse = $a3e3198abc37a385$exports.MsgMigrateContract = $a3e3198abc37a385$exports.MsgExecuteContractResponse = $a3e3198abc37a385$exports.MsgExecuteContract = $a3e3198abc37a385$exports.MsgInstantiateContract2Response = $a3e3198abc37a385$exports.MsgInstantiateContractResponse = $a3e3198abc37a385$exports.MsgInstantiateContract2 = $a3e3198abc37a385$exports.MsgInstantiateContract = $a3e3198abc37a385$exports.MsgStoreCodeResponse = $a3e3198abc37a385$exports.MsgStoreCode = $a3e3198abc37a385$exports.protobufPackage = void 0;



var $7iZIe = parcelRequire("7iZIe");

var $a3e3198abc37a385$var$_m0 = $a3e3198abc37a385$var$__importStar((parcelRequire("hjb8Q")));
$a3e3198abc37a385$exports.protobufPackage = "cosmwasm.wasm.v1";
function $a3e3198abc37a385$var$createBaseMsgStoreCode() {
    return {
        sender: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined
    };
}
$a3e3198abc37a385$exports.MsgStoreCode = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.wasmByteCode.length !== 0) writer.uint32(18).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $1bc6660756f38535$exports.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgStoreCode();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = $1bc6660756f38535$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            wasmByteCode: (0, $7iZIe.isSet)(object.wasmByteCode) ? (0, $7iZIe.bytesFromBase64)(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: (0, $7iZIe.isSet)(object.instantiatePermission) ? $1bc6660756f38535$exports.AccessConfig.fromJSON(object.instantiatePermission) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = (0, $7iZIe.base64FromBytes)(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $1bc6660756f38535$exports.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgStoreCode();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_wasmByteCode;
        message.wasmByteCode = (_object_wasmByteCode = object.wasmByteCode) !== null && _object_wasmByteCode !== void 0 ? _object_wasmByteCode : new Uint8Array();
        message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? $1bc6660756f38535$exports.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgStoreCodeResponse() {
    return {
        codeId: $7iZIe.Long.UZERO,
        checksum: new Uint8Array()
    };
}
$a3e3198abc37a385$exports.MsgStoreCodeResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.checksum.length !== 0) writer.uint32(18).bytes(message.checksum);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgStoreCodeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.checksum = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            checksum: (0, $7iZIe.isSet)(object.checksum) ? (0, $7iZIe.bytesFromBase64)(object.checksum) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.checksum !== undefined && (obj.checksum = (0, $7iZIe.base64FromBytes)(message.checksum !== undefined ? message.checksum : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgStoreCodeResponse();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        var _object_checksum;
        message.checksum = (_object_checksum = object.checksum) !== null && _object_checksum !== void 0 ? _object_checksum : new Uint8Array();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgInstantiateContract() {
    return {
        sender: "",
        admin: "",
        codeId: $7iZIe.Long.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: []
    };
}
$a3e3198abc37a385$exports.MsgInstantiateContract = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.funds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(50).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContract();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            label: (0, $7iZIe.isSet)(object.label) ? String(object.label) : "",
            msg: (0, $7iZIe.isSet)(object.msg) ? (0, $7iZIe.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = (0, $7iZIe.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.funds = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_funds;
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContract();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        var _object_label;
        message.label = (_object_label = object.label) !== null && _object_label !== void 0 ? _object_label : "";
        var _object_msg;
        message.msg = (_object_msg = object.msg) !== null && _object_msg !== void 0 ? _object_msg : new Uint8Array();
        message.funds = ((_object_funds = object.funds) === null || _object_funds === void 0 ? void 0 : _object_funds.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgInstantiateContract2() {
    return {
        sender: "",
        admin: "",
        codeId: $7iZIe.Long.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: [],
        salt: new Uint8Array(),
        fixMsg: false
    };
}
$a3e3198abc37a385$exports.MsgInstantiateContract2 = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.funds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(50).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.salt.length !== 0) writer.uint32(58).bytes(message.salt);
        if (message.fixMsg === true) writer.uint32(64).bool(message.fixMsg);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContract2();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.salt = reader.bytes();
                    break;
                case 8:
                    message.fixMsg = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            admin: (0, $7iZIe.isSet)(object.admin) ? String(object.admin) : "",
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            label: (0, $7iZIe.isSet)(object.label) ? String(object.label) : "",
            msg: (0, $7iZIe.isSet)(object.msg) ? (0, $7iZIe.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : [],
            salt: (0, $7iZIe.isSet)(object.salt) ? (0, $7iZIe.bytesFromBase64)(object.salt) : new Uint8Array(),
            fixMsg: (0, $7iZIe.isSet)(object.fixMsg) ? Boolean(object.fixMsg) : false
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = (0, $7iZIe.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.funds = [];
        message.salt !== undefined && (obj.salt = (0, $7iZIe.base64FromBytes)(message.salt !== undefined ? message.salt : new Uint8Array()));
        message.fixMsg !== undefined && (obj.fixMsg = message.fixMsg);
        return obj;
    },
    fromPartial: function(object) {
        var _object_funds;
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContract2();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_admin;
        message.admin = (_object_admin = object.admin) !== null && _object_admin !== void 0 ? _object_admin : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        var _object_label;
        message.label = (_object_label = object.label) !== null && _object_label !== void 0 ? _object_label : "";
        var _object_msg;
        message.msg = (_object_msg = object.msg) !== null && _object_msg !== void 0 ? _object_msg : new Uint8Array();
        message.funds = ((_object_funds = object.funds) === null || _object_funds === void 0 ? void 0 : _object_funds.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        var _object_salt;
        message.salt = (_object_salt = object.salt) !== null && _object_salt !== void 0 ? _object_salt : new Uint8Array();
        var _object_fixMsg;
        message.fixMsg = (_object_fixMsg = object.fixMsg) !== null && _object_fixMsg !== void 0 ? _object_fixMsg : false;
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgInstantiateContractResponse() {
    return {
        address: "",
        data: new Uint8Array()
    };
}
$a3e3198abc37a385$exports.MsgInstantiateContractResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContractResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContractResponse();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgInstantiateContract2Response() {
    return {
        address: "",
        data: new Uint8Array()
    };
}
$a3e3198abc37a385$exports.MsgInstantiateContract2Response = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContract2Response();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgInstantiateContract2Response();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgExecuteContract() {
    return {
        sender: "",
        contract: "",
        msg: new Uint8Array(),
        funds: []
    };
}
$a3e3198abc37a385$exports.MsgExecuteContract = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(26).bytes(message.msg);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.funds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $5bc8eb379b028930$exports.Coin.encode(v, writer.uint32(42).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgExecuteContract();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push($5bc8eb379b028930$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            contract: (0, $7iZIe.isSet)(object.contract) ? String(object.contract) : "",
            msg: (0, $7iZIe.isSet)(object.msg) ? (0, $7iZIe.bytesFromBase64)(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map(function(e) {
                return $5bc8eb379b028930$exports.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = (0, $7iZIe.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map(function(e) {
            return e ? $5bc8eb379b028930$exports.Coin.toJSON(e) : undefined;
        });
        else obj.funds = [];
        return obj;
    },
    fromPartial: function(object) {
        var _object_funds;
        var message = $a3e3198abc37a385$var$createBaseMsgExecuteContract();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_contract;
        message.contract = (_object_contract = object.contract) !== null && _object_contract !== void 0 ? _object_contract : "";
        var _object_msg;
        message.msg = (_object_msg = object.msg) !== null && _object_msg !== void 0 ? _object_msg : new Uint8Array();
        message.funds = ((_object_funds = object.funds) === null || _object_funds === void 0 ? void 0 : _object_funds.map(function(e) {
            return $5bc8eb379b028930$exports.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgExecuteContractResponse() {
    return {
        data: new Uint8Array()
    };
}
$a3e3198abc37a385$exports.MsgExecuteContractResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgExecuteContractResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgExecuteContractResponse();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgMigrateContract() {
    return {
        sender: "",
        contract: "",
        codeId: $7iZIe.Long.UZERO,
        msg: new Uint8Array()
    };
}
$a3e3198abc37a385$exports.MsgMigrateContract = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgMigrateContract();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            contract: (0, $7iZIe.isSet)(object.contract) ? String(object.contract) : "",
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            msg: (0, $7iZIe.isSet)(object.msg) ? (0, $7iZIe.bytesFromBase64)(object.msg) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.msg !== undefined && (obj.msg = (0, $7iZIe.base64FromBytes)(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgMigrateContract();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_contract;
        message.contract = (_object_contract = object.contract) !== null && _object_contract !== void 0 ? _object_contract : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        var _object_msg;
        message.msg = (_object_msg = object.msg) !== null && _object_msg !== void 0 ? _object_msg : new Uint8Array();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgMigrateContractResponse() {
    return {
        data: new Uint8Array()
    };
}
$a3e3198abc37a385$exports.MsgMigrateContractResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgMigrateContractResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgMigrateContractResponse();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgUpdateAdmin() {
    return {
        sender: "",
        newAdmin: "",
        contract: ""
    };
}
$a3e3198abc37a385$exports.MsgUpdateAdmin = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.newAdmin !== "") writer.uint32(18).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateAdmin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            newAdmin: (0, $7iZIe.isSet)(object.newAdmin) ? String(object.newAdmin) : "",
            contract: (0, $7iZIe.isSet)(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateAdmin();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_newAdmin;
        message.newAdmin = (_object_newAdmin = object.newAdmin) !== null && _object_newAdmin !== void 0 ? _object_newAdmin : "";
        var _object_contract;
        message.contract = (_object_contract = object.contract) !== null && _object_contract !== void 0 ? _object_contract : "";
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgUpdateAdminResponse() {
    return {};
}
$a3e3198abc37a385$exports.MsgUpdateAdminResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateAdminResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateAdminResponse();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgClearAdmin() {
    return {
        sender: "",
        contract: ""
    };
}
$a3e3198abc37a385$exports.MsgClearAdmin = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgClearAdmin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            contract: (0, $7iZIe.isSet)(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgClearAdmin();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        var _object_contract;
        message.contract = (_object_contract = object.contract) !== null && _object_contract !== void 0 ? _object_contract : "";
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgClearAdminResponse() {
    return {};
}
$a3e3198abc37a385$exports.MsgClearAdminResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgClearAdminResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $a3e3198abc37a385$var$createBaseMsgClearAdminResponse();
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgUpdateInstantiateConfig() {
    return {
        sender: "",
        codeId: $7iZIe.Long.UZERO,
        newInstantiatePermission: undefined
    };
}
$a3e3198abc37a385$exports.MsgUpdateInstantiateConfig = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (!message.codeId.isZero()) writer.uint32(16).uint64(message.codeId);
        if (message.newInstantiatePermission !== undefined) $1bc6660756f38535$exports.AccessConfig.encode(message.newInstantiatePermission, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateInstantiateConfig();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.newInstantiatePermission = $1bc6660756f38535$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            sender: (0, $7iZIe.isSet)(object.sender) ? String(object.sender) : "",
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            newInstantiatePermission: (0, $7iZIe.isSet)(object.newInstantiatePermission) ? $1bc6660756f38535$exports.AccessConfig.fromJSON(object.newInstantiatePermission) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.newInstantiatePermission !== undefined && (obj.newInstantiatePermission = message.newInstantiatePermission ? $1bc6660756f38535$exports.AccessConfig.toJSON(message.newInstantiatePermission) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateInstantiateConfig();
        var _object_sender;
        message.sender = (_object_sender = object.sender) !== null && _object_sender !== void 0 ? _object_sender : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        message.newInstantiatePermission = object.newInstantiatePermission !== undefined && object.newInstantiatePermission !== null ? $1bc6660756f38535$exports.AccessConfig.fromPartial(object.newInstantiatePermission) : undefined;
        return message;
    }
};
function $a3e3198abc37a385$var$createBaseMsgUpdateInstantiateConfigResponse() {
    return {};
}
$a3e3198abc37a385$exports.MsgUpdateInstantiateConfigResponse = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $a3e3198abc37a385$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $a3e3198abc37a385$var$_m0.Reader ? input : new $a3e3198abc37a385$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateInstantiateConfigResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $a3e3198abc37a385$var$createBaseMsgUpdateInstantiateConfigResponse();
        return message;
    }
};
var $a3e3198abc37a385$var$MsgClientImpl = /*#__PURE__*/ function() {
    function MsgClientImpl(rpc) {
        (0, $7dKN1._)(this, MsgClientImpl);
        this.rpc = rpc;
        this.StoreCode = this.StoreCode.bind(this);
        this.InstantiateContract = this.InstantiateContract.bind(this);
        this.InstantiateContract2 = this.InstantiateContract2.bind(this);
        this.ExecuteContract = this.ExecuteContract.bind(this);
        this.MigrateContract = this.MigrateContract.bind(this);
        this.UpdateAdmin = this.UpdateAdmin.bind(this);
        this.ClearAdmin = this.ClearAdmin.bind(this);
        this.UpdateInstantiateConfig = this.UpdateInstantiateConfig.bind(this);
    }
    (0, $eW5pA._)(MsgClientImpl, [
        {
            key: "StoreCode",
            value: function StoreCode(request) {
                var data = $a3e3198abc37a385$exports.MsgStoreCode.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgStoreCodeResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "InstantiateContract",
            value: function InstantiateContract(request) {
                var data = $a3e3198abc37a385$exports.MsgInstantiateContract.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgInstantiateContractResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "InstantiateContract2",
            value: function InstantiateContract2(request) {
                var data = $a3e3198abc37a385$exports.MsgInstantiateContract2.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgInstantiateContract2Response.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ExecuteContract",
            value: function ExecuteContract(request) {
                var data = $a3e3198abc37a385$exports.MsgExecuteContract.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgExecuteContractResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "MigrateContract",
            value: function MigrateContract(request) {
                var data = $a3e3198abc37a385$exports.MsgMigrateContract.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgMigrateContractResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateAdmin",
            value: function UpdateAdmin(request) {
                var data = $a3e3198abc37a385$exports.MsgUpdateAdmin.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgUpdateAdminResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ClearAdmin",
            value: function ClearAdmin(request) {
                var data = $a3e3198abc37a385$exports.MsgClearAdmin.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgClearAdminResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "UpdateInstantiateConfig",
            value: function UpdateInstantiateConfig(request) {
                var data = $a3e3198abc37a385$exports.MsgUpdateInstantiateConfig.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", data);
                return promise.then(function(data) {
                    return $a3e3198abc37a385$exports.MsgUpdateInstantiateConfigResponse.decode(new $a3e3198abc37a385$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return MsgClientImpl;
}();
$a3e3198abc37a385$exports.MsgClientImpl = $a3e3198abc37a385$var$MsgClientImpl;


$a4ec21e67fc26b92$exports.wasmTypes = [
    [
        "/cosmwasm.wasm.v1.MsgClearAdmin",
        $a3e3198abc37a385$exports.MsgClearAdmin
    ],
    [
        "/cosmwasm.wasm.v1.MsgExecuteContract",
        $a3e3198abc37a385$exports.MsgExecuteContract
    ],
    [
        "/cosmwasm.wasm.v1.MsgMigrateContract",
        $a3e3198abc37a385$exports.MsgMigrateContract
    ],
    [
        "/cosmwasm.wasm.v1.MsgStoreCode",
        $a3e3198abc37a385$exports.MsgStoreCode
    ],
    [
        "/cosmwasm.wasm.v1.MsgInstantiateContract",
        $a3e3198abc37a385$exports.MsgInstantiateContract
    ],
    [
        "/cosmwasm.wasm.v1.MsgInstantiateContract2",
        $a3e3198abc37a385$exports.MsgInstantiateContract2
    ],
    [
        "/cosmwasm.wasm.v1.MsgUpdateAdmin",
        $a3e3198abc37a385$exports.MsgUpdateAdmin
    ]
];
function $a4ec21e67fc26b92$var$isMsgStoreCodeEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgStoreCode";
}
$a4ec21e67fc26b92$exports.isMsgStoreCodeEncodeObject = $a4ec21e67fc26b92$var$isMsgStoreCodeEncodeObject;
function $a4ec21e67fc26b92$var$isMsgInstantiateContractEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract";
}
$a4ec21e67fc26b92$exports.isMsgInstantiateContractEncodeObject = $a4ec21e67fc26b92$var$isMsgInstantiateContractEncodeObject;
function $a4ec21e67fc26b92$var$isMsgInstantiateContract2EncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgInstantiateContract2";
}
$a4ec21e67fc26b92$exports.isMsgInstantiateContract2EncodeObject = $a4ec21e67fc26b92$var$isMsgInstantiateContract2EncodeObject;
function $a4ec21e67fc26b92$var$isMsgUpdateAdminEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgUpdateAdmin";
}
$a4ec21e67fc26b92$exports.isMsgUpdateAdminEncodeObject = $a4ec21e67fc26b92$var$isMsgUpdateAdminEncodeObject;
function $a4ec21e67fc26b92$var$isMsgClearAdminEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgClearAdmin";
}
$a4ec21e67fc26b92$exports.isMsgClearAdminEncodeObject = $a4ec21e67fc26b92$var$isMsgClearAdminEncodeObject;
function $a4ec21e67fc26b92$var$isMsgMigrateEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgMigrateContract";
}
$a4ec21e67fc26b92$exports.isMsgMigrateEncodeObject = $a4ec21e67fc26b92$var$isMsgMigrateEncodeObject;
function $a4ec21e67fc26b92$var$isMsgExecuteEncodeObject(object) {
    return object.typeUrl === "/cosmwasm.wasm.v1.MsgExecuteContract";
}
$a4ec21e67fc26b92$exports.isMsgExecuteEncodeObject = $a4ec21e67fc26b92$var$isMsgExecuteEncodeObject;


Object.defineProperty($13726c8633dadd49$exports, "isMsgClearAdminEncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgClearAdminEncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "isMsgExecuteEncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgExecuteEncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "isMsgInstantiateContract2EncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgInstantiateContract2EncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "isMsgInstantiateContractEncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgInstantiateContractEncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "isMsgMigrateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgMigrateEncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "isMsgStoreCodeEncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgStoreCodeEncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "isMsgUpdateAdminEncodeObject", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.isMsgUpdateAdminEncodeObject;
    }
});
Object.defineProperty($13726c8633dadd49$exports, "wasmTypes", {
    enumerable: true,
    get: function get() {
        return $a4ec21e67fc26b92$exports.wasmTypes;
    }
});
var $2f2f553db42d169a$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $2f2f553db42d169a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2f2f553db42d169a$exports, "__esModule", {
    value: true
});
$2f2f553db42d169a$exports.setupWasmExtension = void 0;

var $lSA9E = parcelRequire("lSA9E");

var $2045c1b799e41d82$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $2045c1b799e41d82$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2045c1b799e41d82$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2045c1b799e41d82$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2045c1b799e41d82$var$__createBinding(result, mod, k);
    }
    $2045c1b799e41d82$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2045c1b799e41d82$exports, "__esModule", {
    value: true
});
$2045c1b799e41d82$exports.QueryClientImpl = $2045c1b799e41d82$exports.QueryContractsByCreatorResponse = $2045c1b799e41d82$exports.QueryContractsByCreatorRequest = $2045c1b799e41d82$exports.QueryParamsResponse = $2045c1b799e41d82$exports.QueryParamsRequest = $2045c1b799e41d82$exports.QueryPinnedCodesResponse = $2045c1b799e41d82$exports.QueryPinnedCodesRequest = $2045c1b799e41d82$exports.QueryCodesResponse = $2045c1b799e41d82$exports.QueryCodesRequest = $2045c1b799e41d82$exports.QueryCodeResponse = $2045c1b799e41d82$exports.CodeInfoResponse = $2045c1b799e41d82$exports.QueryCodeRequest = $2045c1b799e41d82$exports.QuerySmartContractStateResponse = $2045c1b799e41d82$exports.QuerySmartContractStateRequest = $2045c1b799e41d82$exports.QueryRawContractStateResponse = $2045c1b799e41d82$exports.QueryRawContractStateRequest = $2045c1b799e41d82$exports.QueryAllContractStateResponse = $2045c1b799e41d82$exports.QueryAllContractStateRequest = $2045c1b799e41d82$exports.QueryContractsByCodeResponse = $2045c1b799e41d82$exports.QueryContractsByCodeRequest = $2045c1b799e41d82$exports.QueryContractHistoryResponse = $2045c1b799e41d82$exports.QueryContractHistoryRequest = $2045c1b799e41d82$exports.QueryContractInfoResponse = $2045c1b799e41d82$exports.QueryContractInfoRequest = $2045c1b799e41d82$exports.protobufPackage = void 0;



var $7iZIe = parcelRequire("7iZIe");

var $2045c1b799e41d82$var$_m0 = $2045c1b799e41d82$var$__importStar((parcelRequire("hjb8Q")));
$2045c1b799e41d82$exports.protobufPackage = "cosmwasm.wasm.v1";
function $2045c1b799e41d82$var$createBaseQueryContractInfoRequest() {
    return {
        address: ""
    };
}
$2045c1b799e41d82$exports.QueryContractInfoRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractInfoRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryContractInfoRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractInfoResponse() {
    return {
        address: "",
        contractInfo: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractInfoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.contractInfo !== undefined) $1bc6660756f38535$exports.ContractInfo.encode(message.contractInfo, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractInfoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.contractInfo = $1bc6660756f38535$exports.ContractInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            contractInfo: (0, $7iZIe.isSet)(object.contractInfo) ? $1bc6660756f38535$exports.ContractInfo.fromJSON(object.contractInfo) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.contractInfo !== undefined && (obj.contractInfo = message.contractInfo ? $1bc6660756f38535$exports.ContractInfo.toJSON(message.contractInfo) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryContractInfoResponse();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.contractInfo = object.contractInfo !== undefined && object.contractInfo !== null ? $1bc6660756f38535$exports.ContractInfo.fromPartial(object.contractInfo) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractHistoryRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractHistoryRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractHistoryRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryContractHistoryRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractHistoryResponse() {
    return {
        entries: [],
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractHistoryResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1bc6660756f38535$exports.ContractCodeHistoryEntry.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractHistoryResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($1bc6660756f38535$exports.ContractCodeHistoryEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map(function(e) {
                return $1bc6660756f38535$exports.ContractCodeHistoryEntry.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.entries) obj.entries = message.entries.map(function(e) {
            return e ? $1bc6660756f38535$exports.ContractCodeHistoryEntry.toJSON(e) : undefined;
        });
        else obj.entries = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_entries;
        var message = $2045c1b799e41d82$var$createBaseQueryContractHistoryResponse();
        message.entries = ((_object_entries = object.entries) === null || _object_entries === void 0 ? void 0 : _object_entries.map(function(e) {
            return $1bc6660756f38535$exports.ContractCodeHistoryEntry.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractsByCodeRequest() {
    return {
        codeId: $7iZIe.Long.UZERO,
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractsByCodeRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCodeRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCodeRequest();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractsByCodeResponse() {
    return {
        contracts: [],
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractsByCodeResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.contracts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCodeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.contracts.push(reader.string());
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            contracts: Array.isArray(object === null || object === void 0 ? void 0 : object.contracts) ? object.contracts.map(function(e) {
                return String(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.contracts) obj.contracts = message.contracts.map(function(e) {
            return e;
        });
        else obj.contracts = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_contracts;
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCodeResponse();
        message.contracts = ((_object_contracts = object.contracts) === null || _object_contracts === void 0 ? void 0 : _object_contracts.map(function(e) {
            return e;
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryAllContractStateRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryAllContractStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryAllContractStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryAllContractStateRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryAllContractStateResponse() {
    return {
        models: [],
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryAllContractStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.models[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $1bc6660756f38535$exports.Model.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryAllContractStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.models.push($1bc6660756f38535$exports.Model.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            models: Array.isArray(object === null || object === void 0 ? void 0 : object.models) ? object.models.map(function(e) {
                return $1bc6660756f38535$exports.Model.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.models) obj.models = message.models.map(function(e) {
            return e ? $1bc6660756f38535$exports.Model.toJSON(e) : undefined;
        });
        else obj.models = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_models;
        var message = $2045c1b799e41d82$var$createBaseQueryAllContractStateResponse();
        message.models = ((_object_models = object.models) === null || _object_models === void 0 ? void 0 : _object_models.map(function(e) {
            return $1bc6660756f38535$exports.Model.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryRawContractStateRequest() {
    return {
        address: "",
        queryData: new Uint8Array()
    };
}
$2045c1b799e41d82$exports.QueryRawContractStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.queryData.length !== 0) writer.uint32(18).bytes(message.queryData);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryRawContractStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.queryData = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            queryData: (0, $7iZIe.isSet)(object.queryData) ? (0, $7iZIe.bytesFromBase64)(object.queryData) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.queryData !== undefined && (obj.queryData = (0, $7iZIe.base64FromBytes)(message.queryData !== undefined ? message.queryData : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryRawContractStateRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_queryData;
        message.queryData = (_object_queryData = object.queryData) !== null && _object_queryData !== void 0 ? _object_queryData : new Uint8Array();
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryRawContractStateResponse() {
    return {
        data: new Uint8Array()
    };
}
$2045c1b799e41d82$exports.QueryRawContractStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryRawContractStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryRawContractStateResponse();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQuerySmartContractStateRequest() {
    return {
        address: "",
        queryData: new Uint8Array()
    };
}
$2045c1b799e41d82$exports.QuerySmartContractStateRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.queryData.length !== 0) writer.uint32(18).bytes(message.queryData);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQuerySmartContractStateRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.queryData = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            address: (0, $7iZIe.isSet)(object.address) ? String(object.address) : "",
            queryData: (0, $7iZIe.isSet)(object.queryData) ? (0, $7iZIe.bytesFromBase64)(object.queryData) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.queryData !== undefined && (obj.queryData = (0, $7iZIe.base64FromBytes)(message.queryData !== undefined ? message.queryData : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQuerySmartContractStateRequest();
        var _object_address;
        message.address = (_object_address = object.address) !== null && _object_address !== void 0 ? _object_address : "";
        var _object_queryData;
        message.queryData = (_object_queryData = object.queryData) !== null && _object_queryData !== void 0 ? _object_queryData : new Uint8Array();
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQuerySmartContractStateResponse() {
    return {
        data: new Uint8Array()
    };
}
$2045c1b799e41d82$exports.QuerySmartContractStateResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQuerySmartContractStateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQuerySmartContractStateResponse();
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryCodeRequest() {
    return {
        codeId: $7iZIe.Long.UZERO
    };
}
$2045c1b799e41d82$exports.QueryCodeRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryCodeRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryCodeRequest();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseCodeInfoResponse() {
    return {
        codeId: $7iZIe.Long.UZERO,
        creator: "",
        dataHash: new Uint8Array(),
        instantiatePermission: undefined
    };
}
$2045c1b799e41d82$exports.CodeInfoResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.dataHash.length !== 0) writer.uint32(26).bytes(message.dataHash);
        if (message.instantiatePermission !== undefined) $1bc6660756f38535$exports.AccessConfig.encode(message.instantiatePermission, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseCodeInfoResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.dataHash = reader.bytes();
                    break;
                case 6:
                    message.instantiatePermission = $1bc6660756f38535$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeId: (0, $7iZIe.isSet)(object.codeId) ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO,
            creator: (0, $7iZIe.isSet)(object.creator) ? String(object.creator) : "",
            dataHash: (0, $7iZIe.isSet)(object.dataHash) ? (0, $7iZIe.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            instantiatePermission: (0, $7iZIe.isSet)(object.instantiatePermission) ? $1bc6660756f38535$exports.AccessConfig.fromJSON(object.instantiatePermission) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7iZIe.Long.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.dataHash !== undefined && (obj.dataHash = (0, $7iZIe.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $1bc6660756f38535$exports.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseCodeInfoResponse();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7iZIe.Long.fromValue(object.codeId) : $7iZIe.Long.UZERO;
        var _object_creator;
        message.creator = (_object_creator = object.creator) !== null && _object_creator !== void 0 ? _object_creator : "";
        var _object_dataHash;
        message.dataHash = (_object_dataHash = object.dataHash) !== null && _object_dataHash !== void 0 ? _object_dataHash : new Uint8Array();
        message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? $1bc6660756f38535$exports.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryCodeResponse() {
    return {
        codeInfo: undefined,
        data: new Uint8Array()
    };
}
$2045c1b799e41d82$exports.QueryCodeResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.codeInfo !== undefined) $2045c1b799e41d82$exports.CodeInfoResponse.encode(message.codeInfo, writer.uint32(10).fork()).ldelim();
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryCodeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeInfo = $2045c1b799e41d82$exports.CodeInfoResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeInfo: (0, $7iZIe.isSet)(object.codeInfo) ? $2045c1b799e41d82$exports.CodeInfoResponse.fromJSON(object.codeInfo) : undefined,
            data: (0, $7iZIe.isSet)(object.data) ? (0, $7iZIe.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.codeInfo !== undefined && (obj.codeInfo = message.codeInfo ? $2045c1b799e41d82$exports.CodeInfoResponse.toJSON(message.codeInfo) : undefined);
        message.data !== undefined && (obj.data = (0, $7iZIe.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryCodeResponse();
        message.codeInfo = object.codeInfo !== undefined && object.codeInfo !== null ? $2045c1b799e41d82$exports.CodeInfoResponse.fromPartial(object.codeInfo) : undefined;
        var _object_data;
        message.data = (_object_data = object.data) !== null && _object_data !== void 0 ? _object_data : new Uint8Array();
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryCodesRequest() {
    return {
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryCodesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryCodesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryCodesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryCodesResponse() {
    return {
        codeInfos: [],
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryCodesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.codeInfos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                $2045c1b799e41d82$exports.CodeInfoResponse.encode(v, writer.uint32(10).fork()).ldelim();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryCodesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeInfos.push($2045c1b799e41d82$exports.CodeInfoResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.codeInfos) ? object.codeInfos.map(function(e) {
                return $2045c1b799e41d82$exports.CodeInfoResponse.fromJSON(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.codeInfos) obj.codeInfos = message.codeInfos.map(function(e) {
            return e ? $2045c1b799e41d82$exports.CodeInfoResponse.toJSON(e) : undefined;
        });
        else obj.codeInfos = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_codeInfos;
        var message = $2045c1b799e41d82$var$createBaseQueryCodesResponse();
        message.codeInfos = ((_object_codeInfos = object.codeInfos) === null || _object_codeInfos === void 0 ? void 0 : _object_codeInfos.map(function(e) {
            return $2045c1b799e41d82$exports.CodeInfoResponse.fromPartial(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryPinnedCodesRequest() {
    return {
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryPinnedCodesRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryPinnedCodesRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryPinnedCodesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryPinnedCodesResponse() {
    return {
        codeIds: [],
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryPinnedCodesResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        writer.uint32(10).fork();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.codeIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint64(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        writer.ldelim();
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryPinnedCodesResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.codeIds.push(reader.uint64());
                    } else message.codeIds.push(reader.uint64());
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            codeIds: Array.isArray(object === null || object === void 0 ? void 0 : object.codeIds) ? object.codeIds.map(function(e) {
                return $7iZIe.Long.fromValue(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.codeIds) obj.codeIds = message.codeIds.map(function(e) {
            return (e || $7iZIe.Long.UZERO).toString();
        });
        else obj.codeIds = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_codeIds;
        var message = $2045c1b799e41d82$var$createBaseQueryPinnedCodesResponse();
        message.codeIds = ((_object_codeIds = object.codeIds) === null || _object_codeIds === void 0 ? void 0 : _object_codeIds.map(function(e) {
            return $7iZIe.Long.fromValue(e);
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryParamsRequest() {
    return {};
}
$2045c1b799e41d82$exports.QueryParamsRequest = {
    encode: function(_) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    fromPartial: function(_) {
        var message = $2045c1b799e41d82$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$2045c1b799e41d82$exports.QueryParamsResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.params !== undefined) $1bc6660756f38535$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $1bc6660756f38535$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            params: (0, $7iZIe.isSet)(object.params) ? $1bc6660756f38535$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.params !== undefined && (obj.params = message.params ? $1bc6660756f38535$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $1bc6660756f38535$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractsByCreatorRequest() {
    return {
        creatorAddress: "",
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractsByCreatorRequest = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        if (message.creatorAddress !== "") writer.uint32(10).string(message.creatorAddress);
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCreatorRequest();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creatorAddress = reader.string();
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creatorAddress: (0, $7iZIe.isSet)(object.creatorAddress) ? String(object.creatorAddress) : "",
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        message.creatorAddress !== undefined && (obj.creatorAddress = message.creatorAddress);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCreatorRequest();
        var _object_creatorAddress;
        message.creatorAddress = (_object_creatorAddress = object.creatorAddress) !== null && _object_creatorAddress !== void 0 ? _object_creatorAddress : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2045c1b799e41d82$var$createBaseQueryContractsByCreatorResponse() {
    return {
        contractAddresses: [],
        pagination: undefined
    };
}
$2045c1b799e41d82$exports.QueryContractsByCreatorResponse = {
    encode: function(message) {
        var writer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2045c1b799e41d82$var$_m0.Writer.create();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.contractAddresses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                writer.uint32(10).string(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (message.pagination !== undefined) $95b9a3aa411e7c5d$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $2045c1b799e41d82$var$_m0.Reader ? input : new $2045c1b799e41d82$var$_m0.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCreatorResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.contractAddresses.push(reader.string());
                    break;
                case 2:
                    message.pagination = $95b9a3aa411e7c5d$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            contractAddresses: Array.isArray(object === null || object === void 0 ? void 0 : object.contractAddresses) ? object.contractAddresses.map(function(e) {
                return String(e);
            }) : [],
            pagination: (0, $7iZIe.isSet)(object.pagination) ? $95b9a3aa411e7c5d$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.contractAddresses) obj.contractAddresses = message.contractAddresses.map(function(e) {
            return e;
        });
        else obj.contractAddresses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $95b9a3aa411e7c5d$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial: function(object) {
        var _object_contractAddresses;
        var message = $2045c1b799e41d82$var$createBaseQueryContractsByCreatorResponse();
        message.contractAddresses = ((_object_contractAddresses = object.contractAddresses) === null || _object_contractAddresses === void 0 ? void 0 : _object_contractAddresses.map(function(e) {
            return e;
        })) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $95b9a3aa411e7c5d$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
var $2045c1b799e41d82$var$QueryClientImpl = /*#__PURE__*/ function() {
    function QueryClientImpl(rpc) {
        (0, $7dKN1._)(this, QueryClientImpl);
        this.rpc = rpc;
        this.ContractInfo = this.ContractInfo.bind(this);
        this.ContractHistory = this.ContractHistory.bind(this);
        this.ContractsByCode = this.ContractsByCode.bind(this);
        this.AllContractState = this.AllContractState.bind(this);
        this.RawContractState = this.RawContractState.bind(this);
        this.SmartContractState = this.SmartContractState.bind(this);
        this.Code = this.Code.bind(this);
        this.Codes = this.Codes.bind(this);
        this.PinnedCodes = this.PinnedCodes.bind(this);
        this.Params = this.Params.bind(this);
        this.ContractsByCreator = this.ContractsByCreator.bind(this);
    }
    (0, $eW5pA._)(QueryClientImpl, [
        {
            key: "ContractInfo",
            value: function ContractInfo(request) {
                var data = $2045c1b799e41d82$exports.QueryContractInfoRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractInfo", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryContractInfoResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ContractHistory",
            value: function ContractHistory(request) {
                var data = $2045c1b799e41d82$exports.QueryContractHistoryRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractHistory", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryContractHistoryResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ContractsByCode",
            value: function ContractsByCode(request) {
                var data = $2045c1b799e41d82$exports.QueryContractsByCodeRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCode", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryContractsByCodeResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "AllContractState",
            value: function AllContractState(request) {
                var data = $2045c1b799e41d82$exports.QueryAllContractStateRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "AllContractState", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryAllContractStateResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "RawContractState",
            value: function RawContractState(request) {
                var data = $2045c1b799e41d82$exports.QueryRawContractStateRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "RawContractState", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryRawContractStateResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "SmartContractState",
            value: function SmartContractState(request) {
                var data = $2045c1b799e41d82$exports.QuerySmartContractStateRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "SmartContractState", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QuerySmartContractStateResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Code",
            value: function Code(request) {
                var data = $2045c1b799e41d82$exports.QueryCodeRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Code", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryCodeResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Codes",
            value: function Codes() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $2045c1b799e41d82$exports.QueryCodesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Codes", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryCodesResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "PinnedCodes",
            value: function PinnedCodes() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    pagination: undefined
                };
                var data = $2045c1b799e41d82$exports.QueryPinnedCodesRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "PinnedCodes", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryPinnedCodesResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "Params",
            value: function Params() {
                var request = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var data = $2045c1b799e41d82$exports.QueryParamsRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "Params", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryParamsResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        },
        {
            key: "ContractsByCreator",
            value: function ContractsByCreator(request) {
                var data = $2045c1b799e41d82$exports.QueryContractsByCreatorRequest.encode(request).finish();
                var promise = this.rpc.request("cosmwasm.wasm.v1.Query", "ContractsByCreator", data);
                return promise.then(function(data) {
                    return $2045c1b799e41d82$exports.QueryContractsByCreatorResponse.decode(new $2045c1b799e41d82$var$_m0.Reader(data));
                });
            }
        }
    ]);
    return QueryClientImpl;
}();
$2045c1b799e41d82$exports.QueryClientImpl = $2045c1b799e41d82$var$QueryClientImpl;



var $2f2f553db42d169a$var$long_1 = $2f2f553db42d169a$var$__importDefault((parcelRequire("l6G6L")));
function $2f2f553db42d169a$var$setupWasmExtension(base) {
    var rpc = (0, $3e8bd88d734bad5a$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    var queryService = new $2045c1b799e41d82$exports.QueryClientImpl(rpc);
    return {
        wasm: {
            listCodeInfo: function() {
                var _ref = (0, $6rBFC._)(function(paginationKey) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            pagination: (0, $3e8bd88d734bad5a$exports.createPagination)(paginationKey)
                        };
                        return [
                            2,
                            queryService.Codes(request)
                        ];
                    });
                });
                return function(paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getCode: function() {
                var _ref = (0, $6rBFC._)(function(id) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            codeId: $2f2f553db42d169a$var$long_1.default.fromNumber(id)
                        };
                        return [
                            2,
                            queryService.Code(request)
                        ];
                    });
                });
                return function(id) {
                    return _ref.apply(this, arguments);
                };
            }(),
            listContractsByCodeId: function() {
                var _ref = (0, $6rBFC._)(function(id, paginationKey) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            codeId: $2f2f553db42d169a$var$long_1.default.fromNumber(id),
                            pagination: (0, $3e8bd88d734bad5a$exports.createPagination)(paginationKey)
                        };
                        return [
                            2,
                            queryService.ContractsByCode(request)
                        ];
                    });
                });
                return function(id, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            listContractsByCreator: function() {
                var _ref = (0, $6rBFC._)(function(creator, paginationKey) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            creatorAddress: creator,
                            pagination: (0, $3e8bd88d734bad5a$exports.createPagination)(paginationKey)
                        };
                        return [
                            2,
                            queryService.ContractsByCreator(request)
                        ];
                    });
                });
                return function(creator, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getContractInfo: function() {
                var _ref = (0, $6rBFC._)(function(address) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            address: address
                        };
                        return [
                            2,
                            queryService.ContractInfo(request)
                        ];
                    });
                });
                return function(address) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getContractCodeHistory: function() {
                var _ref = (0, $6rBFC._)(function(address, paginationKey) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            address: address,
                            pagination: (0, $3e8bd88d734bad5a$exports.createPagination)(paginationKey)
                        };
                        return [
                            2,
                            queryService.ContractHistory(request)
                        ];
                    });
                });
                return function(address, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getAllContractState: function() {
                var _ref = (0, $6rBFC._)(function(address, paginationKey) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            address: address,
                            pagination: (0, $3e8bd88d734bad5a$exports.createPagination)(paginationKey)
                        };
                        return [
                            2,
                            queryService.AllContractState(request)
                        ];
                    });
                });
                return function(address, paginationKey) {
                    return _ref.apply(this, arguments);
                };
            }(),
            queryContractRaw: function() {
                var _ref = (0, $6rBFC._)(function(address, key) {
                    var request;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        request = {
                            address: address,
                            queryData: key
                        };
                        return [
                            2,
                            queryService.RawContractState(request)
                        ];
                    });
                });
                return function(address, key) {
                    return _ref.apply(this, arguments);
                };
            }(),
            queryContractSmart: function() {
                var _ref = (0, $6rBFC._)(function(address, query) {
                    var request, data, responseText;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                request = {
                                    address: address,
                                    queryData: (0, $lSA9E.toUtf8)(JSON.stringify(query))
                                };
                                return [
                                    4,
                                    queryService.SmartContractState(request)
                                ];
                            case 1:
                                data = _state.sent().data;
                                try {
                                    responseText = (0, $lSA9E.fromUtf8)(data);
                                } catch (error) {
                                    throw new Error("Could not UTF-8 decode smart query response from contract: ".concat(error));
                                }
                                try {
                                    return [
                                        2,
                                        JSON.parse(responseText)
                                    ];
                                } catch (error) {
                                    throw new Error("Could not JSON parse smart query response from contract: ".concat(error));
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(address, query) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
}
$2f2f553db42d169a$exports.setupWasmExtension = $2f2f553db42d169a$var$setupWasmExtension;


Object.defineProperty($13726c8633dadd49$exports, "setupWasmExtension", {
    enumerable: true,
    get: function get() {
        return $2f2f553db42d169a$exports.setupWasmExtension;
    }
});


var $874883cdc389d04f$var$CosmWasmClient = /*#__PURE__*/ function() {
    function CosmWasmClient(tmClient) {
        (0, $7dKN1._)(this, CosmWasmClient);
        this.codesCache = new Map();
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = $3e8bd88d734bad5a$exports.QueryClient.withExtensions(tmClient, $3e8bd88d734bad5a$exports.setupAuthExtension, $3e8bd88d734bad5a$exports.setupBankExtension, $13726c8633dadd49$exports.setupWasmExtension, $3e8bd88d734bad5a$exports.setupTxExtension);
        }
    }
    (0, $eW5pA._)(CosmWasmClient, [
        {
            key: "getTmClient",
            value: function getTmClient() {
                return this.tmClient;
            }
        },
        {
            key: "forceGetTmClient",
            value: function forceGetTmClient() {
                if (!this.tmClient) throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
                return this.tmClient;
            }
        },
        {
            key: "getQueryClient",
            value: function getQueryClient() {
                return this.queryClient;
            }
        },
        {
            key: "forceGetQueryClient",
            value: function forceGetQueryClient() {
                if (!this.queryClient) throw new Error("Query client not available. You cannot use online functionality in offline mode.");
                return this.queryClient;
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response, chainId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.chainId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.forceGetTmClient().status()
                                ];
                            case 1:
                                response = _state.sent();
                                chainId = response.nodeInfo.network;
                                if (!chainId) throw new Error("Chain ID must not be empty");
                                _this.chainId = chainId;
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.chainId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var status;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().status()
                                ];
                            case 1:
                                status = _state.sent();
                                return [
                                    2,
                                    status.syncInfo.latestBlockHeight
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccount",
            value: function getAccount(searchAddress) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var account, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.forceGetQueryClient().auth.account(searchAddress)
                                ];
                            case 1:
                                account = _state.sent();
                                return [
                                    2,
                                    account ? (0, $3e8bd88d734bad5a$exports.accountFromAny)(account) : null
                                ];
                            case 2:
                                error = _state.sent();
                                if (/rpc error: code = NotFound/i.test(error.toString())) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSequence",
            value: function getSequence(address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var account;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccount(address)
                                ];
                            case 1:
                                account = _state.sent();
                                if (!account) throw new Error("Account '".concat(address, "' does not exist on chain. Send some tokens there before trying to query sequence."));
                                return [
                                    2,
                                    {
                                        accountNumber: account.accountNumber,
                                        sequence: account.sequence
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: function getBlock(height) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().block(height)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    {
                                        id: (0, $lSA9E.toHex)(response.blockId.hash).toUpperCase(),
                                        header: {
                                            version: {
                                                block: new $kTbgy.Uint53(response.block.header.version.block).toString(),
                                                app: new $kTbgy.Uint53(response.block.header.version.app).toString()
                                            },
                                            height: response.block.header.height,
                                            chainId: response.block.header.chainId,
                                            time: (0, $7cd013e5dbc8ccb9$exports.toRfc3339WithNanoseconds)(response.block.header.time)
                                        },
                                        txs: response.block.txs
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalance",
            value: function getBalance(address, searchDenom) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.forceGetQueryClient().bank.balance(address, searchDenom)
                        ];
                    });
                })();
            }
        },
        {
            key: "getTx",
            value: function getTx(id) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var results, _results_;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.txsQuery("tx.hash='".concat(id, "'"))
                                ];
                            case 1:
                                results = _state.sent();
                                return [
                                    2,
                                    (_results_ = results[0]) !== null && _results_ !== void 0 ? _results_ : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "searchTx",
            value: function searchTx(query) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var rawQuery;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        if (typeof query === "string") rawQuery = query;
                        else if (Array.isArray(query)) rawQuery = query.map(function(t) {
                            return "".concat(t.key, "='").concat(t.value, "'");
                        }).join(" AND ");
                        else throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
                        return [
                            2,
                            _this.txsQuery(rawQuery)
                        ];
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.tmClient) this.tmClient.disconnect();
            }
        },
        {
            key: "broadcastTx",
            value: /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */ // NOTE: This method is tested against slow chains and timeouts in the @cosmjs/stargate package.
            // Make sure it is kept in sync!
            function broadcastTx(tx) {
                var timeoutMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60000, pollIntervalMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3000;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var timedOut, txPollTimeout, pollForTx, transactionId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                timedOut = false;
                                txPollTimeout = setTimeout(function() {
                                    timedOut = true;
                                }, timeoutMs);
                                pollForTx = function() {
                                    var _ref = (0, $6rBFC._)(function(txId) {
                                        var result;
                                        return (0, $6qu4b.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (timedOut) throw new $3e8bd88d734bad5a$exports.TimeoutError("Transaction with ID ".concat(txId, " was submitted but was not yet found on the chain. You might want to check later. There was a wait of ").concat(timeoutMs / 1000, " seconds."), txId);
                                                    return [
                                                        4,
                                                        (0, $gMk5u.sleep)(pollIntervalMs)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        _this.getTx(txId)
                                                    ];
                                                case 2:
                                                    result = _state.sent();
                                                    return [
                                                        2,
                                                        result ? {
                                                            code: result.code,
                                                            height: result.height,
                                                            txIndex: result.txIndex,
                                                            rawLog: result.rawLog,
                                                            transactionHash: txId,
                                                            events: result.events,
                                                            msgResponses: result.msgResponses,
                                                            gasUsed: result.gasUsed,
                                                            gasWanted: result.gasWanted
                                                        } : pollForTx(txId)
                                                    ];
                                            }
                                        });
                                    });
                                    return function pollForTx(txId) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return [
                                    4,
                                    _this.broadcastTxSync(tx)
                                ];
                            case 1:
                                transactionId = _state.sent();
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        return pollForTx(transactionId).then(function(value) {
                                            clearTimeout(txPollTimeout);
                                            resolve(value);
                                        }, function(error) {
                                            clearTimeout(txPollTimeout);
                                            reject(error);
                                        });
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "broadcastTxSync",
            value: /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */ function broadcastTxSync(tx) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var broadcasted, _broadcasted_codespace, transactionId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().broadcastTxSync({
                                        tx: tx
                                    })
                                ];
                            case 1:
                                broadcasted = _state.sent();
                                if (broadcasted.code) return [
                                    2,
                                    Promise.reject(new $3e8bd88d734bad5a$exports.BroadcastTxError(broadcasted.code, (_broadcasted_codespace = broadcasted.codespace) !== null && _broadcasted_codespace !== void 0 ? _broadcasted_codespace : "", broadcasted.log))
                                ];
                                transactionId = (0, $lSA9E.toHex)(broadcasted.hash).toUpperCase();
                                return [
                                    2,
                                    transactionId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCodes",
            value: /**
     * getCodes() returns all codes and is just looping through all pagination pages.
     *
     * This is potentially inefficient and advanced apps should consider creating
     * their own query client to handle pagination together with the app's screens.
     */ function getCodes() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var allCodes, startAtKey, _allCodes, _ref, codeInfos, pagination, loadedCodes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                allCodes = [];
                                startAtKey = undefined;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.listCodeInfo(startAtKey)
                                ];
                            case 2:
                                _ref = _state.sent(), codeInfos = _ref.codeInfos, pagination = _ref.pagination;
                                loadedCodes = codeInfos || [];
                                (_allCodes = allCodes).push.apply(_allCodes, (0, $gF0bR._)(loadedCodes));
                                startAtKey = pagination === null || pagination === void 0 ? void 0 : pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if ((startAtKey === null || startAtKey === void 0 ? void 0 : startAtKey.length) !== 0) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    allCodes.map(function(entry) {
                                        (0, $gMk5u.assert)(entry.creator && entry.codeId && entry.dataHash, "entry incomplete");
                                        return {
                                            id: entry.codeId.toNumber(),
                                            creator: entry.creator,
                                            checksum: (0, $lSA9E.toHex)(entry.dataHash)
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCodeDetails",
            value: function getCodeDetails(codeId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var cached, _ref, codeInfo, data, codeDetails;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cached = _this.codesCache.get(codeId);
                                if (cached) return [
                                    2,
                                    cached
                                ];
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.getCode(codeId)
                                ];
                            case 1:
                                _ref = _state.sent(), codeInfo = _ref.codeInfo, data = _ref.data;
                                (0, $gMk5u.assert)(codeInfo && codeInfo.codeId && codeInfo.creator && codeInfo.dataHash && data, "codeInfo missing or incomplete");
                                codeDetails = {
                                    id: codeInfo.codeId.toNumber(),
                                    creator: codeInfo.creator,
                                    checksum: (0, $lSA9E.toHex)(codeInfo.dataHash),
                                    data: data
                                };
                                _this.codesCache.set(codeId, codeDetails);
                                return [
                                    2,
                                    codeDetails
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContracts",
            value: /**
     * getContracts() returns all contract instances for one code and is just looping through all pagination pages.
     *
     * This is potentially inefficient and advanced apps should consider creating
     * their own query client to handle pagination together with the app's screens.
     */ function getContracts(codeId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var allContracts, startAtKey, _allContracts, _ref, contracts, pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                allContracts = [];
                                startAtKey = undefined;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.listContractsByCodeId(codeId, startAtKey)
                                ];
                            case 2:
                                _ref = _state.sent(), contracts = _ref.contracts, pagination = _ref.pagination;
                                (_allContracts = allContracts).push.apply(_allContracts, (0, $gF0bR._)(contracts));
                                startAtKey = pagination === null || pagination === void 0 ? void 0 : pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if ((startAtKey === null || startAtKey === void 0 ? void 0 : startAtKey.length) !== 0 && startAtKey !== undefined) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    allContracts
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContractsByCreator",
            value: /**
     * Returns a list of contract addresses created by the given creator.
     * This just loops through all pagination pages.
     */ function getContractsByCreator(creator) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var allContracts, startAtKey, _allContracts, _ref, contractAddresses, pagination;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                allContracts = [];
                                startAtKey = undefined;
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.listContractsByCreator(creator, startAtKey)
                                ];
                            case 2:
                                _ref = _state.sent(), contractAddresses = _ref.contractAddresses, pagination = _ref.pagination;
                                (_allContracts = allContracts).push.apply(_allContracts, (0, $gF0bR._)(contractAddresses));
                                startAtKey = pagination === null || pagination === void 0 ? void 0 : pagination.nextKey;
                                _state.label = 3;
                            case 3:
                                if ((startAtKey === null || startAtKey === void 0 ? void 0 : startAtKey.length) !== 0 && startAtKey !== undefined) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    allContracts
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContract",
            value: /**
     * Throws an error if no contract was found at the address
     */ function getContract(address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, retrievedAddress, contractInfo;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.getContractInfo(address)
                                ];
                            case 1:
                                _ref = _state.sent(), retrievedAddress = _ref.address, contractInfo = _ref.contractInfo;
                                if (!contractInfo) throw new Error('No contract found at address "'.concat(address, '"'));
                                (0, $gMk5u.assert)(retrievedAddress, "address missing");
                                (0, $gMk5u.assert)(contractInfo.codeId && contractInfo.creator && contractInfo.label, "contractInfo incomplete");
                                return [
                                    2,
                                    {
                                        address: retrievedAddress,
                                        codeId: contractInfo.codeId.toNumber(),
                                        creator: contractInfo.creator,
                                        admin: contractInfo.admin || undefined,
                                        label: contractInfo.label,
                                        ibcPortId: contractInfo.ibcPortId || undefined
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getContractCodeHistory",
            value: /**
     * Throws an error if no contract was found at the address
     */ function getContractCodeHistory(address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var result, _obj, operations;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.getContractCodeHistory(address)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) throw new Error('No contract history found for address "'.concat(address, '"'));
                                operations = (_obj = {}, (0, $a7gqy._)(_obj, $1bc6660756f38535$exports.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT, "Init"), (0, $a7gqy._)(_obj, $1bc6660756f38535$exports.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS, "Genesis"), (0, $a7gqy._)(_obj, $1bc6660756f38535$exports.ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE, "Migrate"), _obj);
                                return [
                                    2,
                                    (result.entries || []).map(function(entry) {
                                        (0, $gMk5u.assert)(entry.operation && entry.codeId && entry.msg);
                                        return {
                                            operation: operations[entry.operation],
                                            codeId: entry.codeId.toNumber(),
                                            msg: JSON.parse((0, $lSA9E.fromUtf8)(entry.msg))
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queryContractRaw",
            value: /**
     * Returns the data at the key if present (raw contract dependent storage data)
     * or null if no data at this key.
     *
     * Promise is rejected when contract does not exist.
     */ function queryContractRaw(address, key) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var data;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // just test contract existence
                                return [
                                    4,
                                    _this.getContract(address)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.queryContractRaw(address, key)
                                ];
                            case 2:
                                data = _state.sent().data;
                                return [
                                    2,
                                    data !== null && data !== void 0 ? data : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queryContractSmart",
            value: /**
     * Makes a smart query on the contract, returns the parsed JSON document.
     *
     * Promise is rejected when contract does not exist.
     * Promise is rejected for invalid query format.
     * Promise is rejected for invalid response format.
     */ function queryContractSmart(address, queryMsg) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.forceGetQueryClient().wasm.queryContractSmart(address, queryMsg)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if (error instanceof Error) {
                                    if (error.message.startsWith("not found: contract")) throw new Error('No contract found at address "'.concat(address, '"'));
                                    else throw error;
                                } else throw error;
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "txsQuery",
            value: function txsQuery(query) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var results;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.forceGetTmClient().txSearchAll({
                                        query: query
                                    })
                                ];
                            case 1:
                                results = _state.sent();
                                return [
                                    2,
                                    results.txs.map(function(tx) {
                                        var _tx_result_data;
                                        var txMsgData = $81693c046571dbd5$exports.TxMsgData.decode((_tx_result_data = tx.result.data) !== null && _tx_result_data !== void 0 ? _tx_result_data : new Uint8Array());
                                        return {
                                            height: tx.height,
                                            txIndex: tx.index,
                                            hash: (0, $lSA9E.toHex)(tx.hash).toUpperCase(),
                                            code: tx.result.code,
                                            events: tx.result.events.map($3e8bd88d734bad5a$exports.fromTendermintEvent),
                                            rawLog: tx.result.log || "",
                                            tx: tx.tx,
                                            msgResponses: txMsgData.msgResponses,
                                            gasUsed: tx.result.gasUsed,
                                            gasWanted: tx.result.gasWanted
                                        };
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "connect",
            value: /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */ function connect(endpoint) {
                return (0, $6rBFC._)(function() {
                    var tmClient, tm37Client, version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint37Client.connect(endpoint)
                                ];
                            case 1:
                                tm37Client = _state.sent();
                                return [
                                    4,
                                    tm37Client.status()
                                ];
                            case 2:
                                version = _state.sent().nodeInfo.version;
                                if (!version.startsWith("0.37.")) return [
                                    3,
                                    3
                                ];
                                tmClient = tm37Client;
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                tm37Client.disconnect();
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint34Client.connect(endpoint)
                                ];
                            case 4:
                                tmClient = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    CosmWasmClient.create(tmClient)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "create",
            value: /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ function create(tmClient) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new CosmWasmClient(tmClient)
                        ];
                    });
                })();
            }
        }
    ]);
    return CosmWasmClient;
}();
$874883cdc389d04f$exports.CosmWasmClient = $874883cdc389d04f$var$CosmWasmClient;


Object.defineProperty($5806cdd0880cf151$exports, "CosmWasmClient", {
    enumerable: true,
    get: function get() {
        return $874883cdc389d04f$exports.CosmWasmClient;
    }
});
var $c064fb5fcce44e8c$exports = {};
"use strict";
Object.defineProperty($c064fb5fcce44e8c$exports, "__esModule", {
    value: true
});
$c064fb5fcce44e8c$exports.fromBinary = $c064fb5fcce44e8c$exports.toBinary = void 0;

var $lSA9E = parcelRequire("lSA9E");
/**
 * Takes a value, serializes it to JSON and encodes it as base64.
 *
 * This can be used for creating values of fields that have the CosmWasm Binary type.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $c064fb5fcce44e8c$var$toBinary(obj) {
    return (0, $lSA9E.toBase64)((0, $lSA9E.toUtf8)(JSON.stringify(obj)));
}
$c064fb5fcce44e8c$exports.toBinary = $c064fb5fcce44e8c$var$toBinary;
/**
 * Takes a base64 string, decodes it and parses the content from JSON to an object.
 *
 * This can be used for parsing the values of a CosmWasm Binary field.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $c064fb5fcce44e8c$var$fromBinary(base64) {
    return JSON.parse((0, $lSA9E.fromUtf8)((0, $lSA9E.fromBase64)(base64)));
}
$c064fb5fcce44e8c$exports.fromBinary = $c064fb5fcce44e8c$var$fromBinary;


Object.defineProperty($5806cdd0880cf151$exports, "fromBinary", {
    enumerable: true,
    get: function get() {
        return $c064fb5fcce44e8c$exports.fromBinary;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "toBinary", {
    enumerable: true,
    get: function get() {
        return $c064fb5fcce44e8c$exports.toBinary;
    }
});
var $4517f6180089488a$exports = {};

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($4517f6180089488a$exports, "__esModule", {
    value: true
});
$4517f6180089488a$exports.instantiate2Address = $4517f6180089488a$exports._instantiate2AddressIntermediate = void 0;

var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");

var $gMk5u = parcelRequire("gMk5u");
/**
 * The "Basic Address" Hash from
 * https://github.com/cosmos/cosmos-sdk/blob/v0.45.8/docs/architecture/adr-028-public-key-addresses.md
 */ function $4517f6180089488a$var$hash(type, key) {
    return new $3d6bA.Sha256((0, $3d6bA.sha256)((0, $lSA9E.toAscii)(type))).update(key).digest();
}
/**
 * Takes an integer [0, 2**64-1] and returns a one-byte encoding of it.
 */ function $4517f6180089488a$var$toUint64(int) {
    return $kTbgy.Uint64.fromNumber(int).toBytesBigEndian();
}
/**
 * Private function to export test vector data for https://github.com/cosmos/cosmjs/pull/1253.
 * Do not use in production code.
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $4517f6180089488a$var$_instantiate2AddressIntermediate(checksum, creator, salt, msg, prefix) {
    (0, $gMk5u.assert)(checksum.length === 32);
    var creatorData = (0, $lSA9E.fromBech32)(creator).data;
    var msgData = typeof msg === "string" ? (0, $lSA9E.toUtf8)(msg) : new Uint8Array();
    // Validate inputs
    if (salt.length < 1 || salt.length > 64) throw new Error("Salt must be between 1 and 64 bytes");
    var key = new Uint8Array((0, $gF0bR._)((0, $lSA9E.toAscii)("wasm")).concat([
        0x00
    ], (0, $gF0bR._)($4517f6180089488a$var$toUint64(checksum.length)), (0, $gF0bR._)(checksum), (0, $gF0bR._)($4517f6180089488a$var$toUint64(creatorData.length)), (0, $gF0bR._)(creatorData), (0, $gF0bR._)($4517f6180089488a$var$toUint64(salt.length)), (0, $gF0bR._)(salt), (0, $gF0bR._)($4517f6180089488a$var$toUint64(msgData.length)), (0, $gF0bR._)(msgData)));
    var addressData = $4517f6180089488a$var$hash("module", key);
    var address = (0, $lSA9E.toBech32)(prefix, addressData);
    return {
        key: key,
        addressData: addressData,
        address: address
    };
}
$4517f6180089488a$exports._instantiate2AddressIntermediate = $4517f6180089488a$var$_instantiate2AddressIntermediate;
/**
 * Predictable address generation for the MsgInstantiateContract2
 * introduced with wasmd 0.29.
 */ function $4517f6180089488a$var$instantiate2Address(checksum, creator, salt, prefix) {
    // Non-empty msg values are discouraged.
    // See https://medium.com/cosmwasm/dev-note-3-limitations-of-instantiate2-and-how-to-deal-with-them-a3f946874230.
    var msg = null;
    return $4517f6180089488a$var$_instantiate2AddressIntermediate(checksum, creator, salt, msg, prefix).address;
}
$4517f6180089488a$exports.instantiate2Address = $4517f6180089488a$var$instantiate2Address;


Object.defineProperty($5806cdd0880cf151$exports, "_instantiate2AddressIntermediate", {
    enumerable: true,
    get: function get() {
        return $4517f6180089488a$exports._instantiate2AddressIntermediate;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "instantiate2Address", {
    enumerable: true,
    get: function get() {
        return $4517f6180089488a$exports.instantiate2Address;
    }
});

Object.defineProperty($5806cdd0880cf151$exports, "createWasmAminoConverters", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.createWasmAminoConverters;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgClearAdminEncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgClearAdminEncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgExecuteEncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgExecuteEncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgInstantiateContract2EncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgInstantiateContract2EncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgInstantiateContractEncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgInstantiateContractEncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgMigrateEncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgMigrateEncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgStoreCodeEncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgStoreCodeEncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "isMsgUpdateAdminEncodeObject", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.isMsgUpdateAdminEncodeObject;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "setupWasmExtension", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.setupWasmExtension;
    }
});
Object.defineProperty($5806cdd0880cf151$exports, "wasmTypes", {
    enumerable: true,
    get: function get() {
        return $13726c8633dadd49$exports.wasmTypes;
    }
});
var $e3268442d0b08e42$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $e3268442d0b08e42$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e3268442d0b08e42$exports, "__esModule", {
    value: true
});
$e3268442d0b08e42$exports.SigningCosmWasmClient = void 0;


var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");

var $kTbgy = parcelRequire("kTbgy");




var $gMk5u = parcelRequire("gMk5u");






var $e3268442d0b08e42$var$long_1 = $e3268442d0b08e42$var$__importDefault((parcelRequire("l6G6L")));

var $e3268442d0b08e42$var$pako_1 = $e3268442d0b08e42$var$__importDefault((parcelRequire("3sALI")));


function $e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result) {
    return "Error when broadcasting tx ".concat(result.transactionHash, " at height ").concat(result.height, ". Code: ").concat(result.code, "; Raw log: ").concat(result.rawLog);
}
var $e3268442d0b08e42$var$SigningCosmWasmClient = /*#__PURE__*/ function(_cosmwasmclient_1_CosmWasmClient) {
    (0, $cgJ2Y._)(SigningCosmWasmClient, _cosmwasmclient_1_CosmWasmClient);
    var _super = (0, $hKD8n._)(SigningCosmWasmClient);
    function SigningCosmWasmClient(tmClient, signer, options) {
        (0, $7dKN1._)(this, SigningCosmWasmClient);
        var _this;
        _this = _super.call(this, tmClient);
        var _options_registry = options.registry, registry = _options_registry === void 0 ? new $ff811d56e12ad916$exports.Registry((0, $gF0bR._)($3e8bd88d734bad5a$exports.defaultRegistryTypes).concat((0, $gF0bR._)($13726c8633dadd49$exports.wasmTypes))) : _options_registry, _options_aminoTypes = options.aminoTypes, aminoTypes = _options_aminoTypes === void 0 ? new $3e8bd88d734bad5a$exports.AminoTypes((0, $4JCw4._)({}, (0, $3e8bd88d734bad5a$exports.createDefaultAminoConverters)(), (0, $13726c8633dadd49$exports.createWasmAminoConverters)())) : _options_aminoTypes;
        _this.registry = registry;
        _this.aminoTypes = aminoTypes;
        _this.signer = signer;
        _this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        _this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        _this.gasPrice = options.gasPrice;
        return _this;
    }
    (0, $eW5pA._)(SigningCosmWasmClient, [
        {
            key: "simulate",
            value: function simulate(signerAddress, messages, memo) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var anyMsgs, accountFromSigner, pubkey, sequence, gasInfo;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                anyMsgs = messages.map(function(m) {
                                    return _this.registry.encodeAsAny(m);
                                });
                                return [
                                    4,
                                    _this.signer.getAccounts()
                                ];
                            case 1:
                                accountFromSigner = _state.sent().find(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
                                pubkey = (0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
                                return [
                                    4,
                                    _this.getSequence(signerAddress)
                                ];
                            case 2:
                                sequence = _state.sent().sequence;
                                return [
                                    4,
                                    _this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence)
                                ];
                            case 3:
                                gasInfo = _state.sent().gasInfo;
                                (0, $gMk5u.assertDefined)(gasInfo);
                                return [
                                    2,
                                    $kTbgy.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "upload",
            value: /** Uploads code and returns a receipt, including the code ID */ function upload(senderAddress, wasmCode, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", instantiatePermission = arguments.length > 4 ? arguments[4] : void 0;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var compressed, storeCodeMsg, usedFee, result, parsedLogs, codeIdAttr;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                compressed = $e3268442d0b08e42$var$pako_1.default.gzip(wasmCode, {
                                    level: 9
                                });
                                storeCodeMsg = {
                                    typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
                                    value: $a3e3198abc37a385$exports.MsgStoreCode.fromPartial({
                                        sender: senderAddress,
                                        wasmByteCode: compressed,
                                        instantiatePermission: instantiatePermission
                                    })
                                };
                                // When uploading a contract, the simulation is only 1-2% away from the actual gas usage.
                                // So we have a smaller default gas multiplier than signAndBroadcast.
                                usedFee = fee == "auto" ? 1.1 : fee;
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, [
                                        storeCodeMsg
                                    ], usedFee, memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                parsedLogs = $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog);
                                codeIdAttr = $3e8bd88d734bad5a$exports.logs.findAttribute(parsedLogs, "store_code", "code_id");
                                return [
                                    2,
                                    {
                                        checksum: (0, $lSA9E.toHex)((0, $3d6bA.sha256)(wasmCode)),
                                        originalSize: wasmCode.length,
                                        compressedSize: compressed.length,
                                        codeId: Number.parseInt(codeIdAttr.value, 10),
                                        logs: parsedLogs,
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "instantiate",
            value: function instantiate(senderAddress, codeId, msg, label, fee) {
                var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var instantiateContractMsg, result, parsedLogs, contractAddressAttr;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                instantiateContractMsg = {
                                    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
                                    value: $a3e3198abc37a385$exports.MsgInstantiateContract.fromPartial({
                                        sender: senderAddress,
                                        codeId: $e3268442d0b08e42$var$long_1.default.fromString(new $kTbgy.Uint53(codeId).toString()),
                                        label: label,
                                        msg: (0, $lSA9E.toUtf8)(JSON.stringify(msg)),
                                        funds: (0, $gF0bR._)(options.funds || []),
                                        admin: options.admin
                                    })
                                };
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, [
                                        instantiateContractMsg
                                    ], fee, options.memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                parsedLogs = $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog);
                                contractAddressAttr = $3e8bd88d734bad5a$exports.logs.findAttribute(parsedLogs, "instantiate", "_contract_address");
                                return [
                                    2,
                                    {
                                        contractAddress: contractAddressAttr.value,
                                        logs: parsedLogs,
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "instantiate2",
            value: function instantiate2(senderAddress, codeId, salt, msg, label, fee) {
                var options = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {};
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var instantiateContract2Msg, result, parsedLogs, contractAddressAttr;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                instantiateContract2Msg = {
                                    typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract2",
                                    value: $a3e3198abc37a385$exports.MsgInstantiateContract2.fromPartial({
                                        sender: senderAddress,
                                        codeId: $e3268442d0b08e42$var$long_1.default.fromString(new $kTbgy.Uint53(codeId).toString()),
                                        label: label,
                                        msg: (0, $lSA9E.toUtf8)(JSON.stringify(msg)),
                                        funds: (0, $gF0bR._)(options.funds || []),
                                        admin: options.admin,
                                        salt: salt,
                                        fixMsg: false
                                    })
                                };
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, [
                                        instantiateContract2Msg
                                    ], fee, options.memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                parsedLogs = $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog);
                                contractAddressAttr = $3e8bd88d734bad5a$exports.logs.findAttribute(parsedLogs, "instantiate", "_contract_address");
                                return [
                                    2,
                                    {
                                        contractAddress: contractAddressAttr.value,
                                        logs: parsedLogs,
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateAdmin",
            value: function updateAdmin(senderAddress, contractAddress, newAdmin, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var updateAdminMsg, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                updateAdminMsg = {
                                    typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
                                    value: $a3e3198abc37a385$exports.MsgUpdateAdmin.fromPartial({
                                        sender: senderAddress,
                                        contract: contractAddress,
                                        newAdmin: newAdmin
                                    })
                                };
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, [
                                        updateAdminMsg
                                    ], fee, memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                return [
                                    2,
                                    {
                                        logs: $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog),
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearAdmin",
            value: function clearAdmin(senderAddress, contractAddress, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var clearAdminMsg, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                clearAdminMsg = {
                                    typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
                                    value: $a3e3198abc37a385$exports.MsgClearAdmin.fromPartial({
                                        sender: senderAddress,
                                        contract: contractAddress
                                    })
                                };
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, [
                                        clearAdminMsg
                                    ], fee, memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                return [
                                    2,
                                    {
                                        logs: $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog),
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "migrate",
            value: function migrate(senderAddress, contractAddress, codeId, migrateMsg, fee) {
                var memo = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var migrateContractMsg, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                migrateContractMsg = {
                                    typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
                                    value: $a3e3198abc37a385$exports.MsgMigrateContract.fromPartial({
                                        sender: senderAddress,
                                        contract: contractAddress,
                                        codeId: $e3268442d0b08e42$var$long_1.default.fromString(new $kTbgy.Uint53(codeId).toString()),
                                        msg: (0, $lSA9E.toUtf8)(JSON.stringify(migrateMsg))
                                    })
                                };
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, [
                                        migrateContractMsg
                                    ], fee, memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                return [
                                    2,
                                    {
                                        logs: $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog),
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "execute",
            value: function execute(senderAddress, contractAddress, msg, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", funds = arguments.length > 5 ? arguments[5] : void 0;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var instruction;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        instruction = {
                            contractAddress: contractAddress,
                            msg: msg,
                            funds: funds
                        };
                        return [
                            2,
                            _this.executeMultiple(senderAddress, [
                                instruction
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "executeMultiple",
            value: /**
     * Like `execute` but allows executing multiple messages in one transaction.
     */ function executeMultiple(senderAddress, instructions, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var msgs, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                msgs = instructions.map(function(i) {
                                    return {
                                        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
                                        value: $a3e3198abc37a385$exports.MsgExecuteContract.fromPartial({
                                            sender: senderAddress,
                                            contract: i.contractAddress,
                                            msg: (0, $lSA9E.toUtf8)(JSON.stringify(i.msg)),
                                            funds: (0, $gF0bR._)(i.funds || [])
                                        })
                                    };
                                });
                                return [
                                    4,
                                    _this.signAndBroadcast(senderAddress, msgs, fee, memo)
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0, $3e8bd88d734bad5a$exports.isDeliverTxFailure)(result)) throw new Error($e3268442d0b08e42$var$createDeliverTxResponseErrorMessage(result));
                                return [
                                    2,
                                    {
                                        logs: $3e8bd88d734bad5a$exports.logs.parseRawLog(result.rawLog),
                                        height: result.height,
                                        transactionHash: result.transactionHash,
                                        events: result.events,
                                        gasWanted: result.gasWanted,
                                        gasUsed: result.gasUsed
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTokens",
            value: function sendTokens(senderAddress, recipientAddress, amount, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var sendMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        sendMsg = {
                            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
                            value: {
                                fromAddress: senderAddress,
                                toAddress: recipientAddress,
                                amount: (0, $gF0bR._)(amount)
                            }
                        };
                        return [
                            2,
                            _this.signAndBroadcast(senderAddress, [
                                sendMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "delegateTokens",
            value: function delegateTokens(delegatorAddress, validatorAddress, amount, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var delegateMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        delegateMsg = {
                            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
                            value: $83b4166ddf6d1939$exports.MsgDelegate.fromPartial({
                                delegatorAddress: delegatorAddress,
                                validatorAddress: validatorAddress,
                                amount: amount
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(delegatorAddress, [
                                delegateMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "undelegateTokens",
            value: function undelegateTokens(delegatorAddress, validatorAddress, amount, fee) {
                var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var undelegateMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        undelegateMsg = {
                            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
                            value: $83b4166ddf6d1939$exports.MsgUndelegate.fromPartial({
                                delegatorAddress: delegatorAddress,
                                validatorAddress: validatorAddress,
                                amount: amount
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(delegatorAddress, [
                                undelegateMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "withdrawRewards",
            value: function withdrawRewards(delegatorAddress, validatorAddress, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var withdrawDelegatorRewardMsg;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        withdrawDelegatorRewardMsg = {
                            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                            value: $87cae70f73bd5cdd$exports.MsgWithdrawDelegatorReward.fromPartial({
                                delegatorAddress: delegatorAddress,
                                validatorAddress: validatorAddress
                            })
                        };
                        return [
                            2,
                            _this.signAndBroadcast(delegatorAddress, [
                                withdrawDelegatorRewardMsg
                            ], fee, memo)
                        ];
                    });
                })();
            }
        },
        {
            key: "signAndBroadcast",
            value: /**
     * Creates a transaction with the given messages, fee and memo. Then signs and broadcasts the transaction.
     *
     * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
     * @param messages
     * @param fee
     * @param memo
     */ function signAndBroadcast(signerAddress, messages, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var usedFee, gasEstimation, multiplier, txRaw, txBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(fee == "auto" || typeof fee === "number")) return [
                                    3,
                                    2
                                ];
                                (0, $gMk5u.assertDefined)(_this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
                                return [
                                    4,
                                    _this.simulate(signerAddress, messages, memo)
                                ];
                            case 1:
                                gasEstimation = _state.sent();
                                // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
                                // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
                                multiplier = typeof fee === "number" ? fee : 1.4;
                                usedFee = (0, $3e8bd88d734bad5a$exports.calculateFee)(Math.round(gasEstimation * multiplier), _this.gasPrice);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                usedFee = fee;
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _this.sign(signerAddress, messages, usedFee, memo)
                                ];
                            case 4:
                                txRaw = _state.sent();
                                txBytes = $540f96552e476ffb$exports.TxRaw.encode(txRaw).finish();
                                return [
                                    2,
                                    _this.broadcastTx(txBytes, _this.broadcastTimeoutMs, _this.broadcastPollIntervalMs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAndBroadcastSync",
            value: /**
     * Creates a transaction with the given messages, fee and memo. Then signs and broadcasts the transaction.
     *
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     *
     * @param signerAddress The address that will sign transactions using this instance. The signer must be able to sign with this address.
     * @param messages
     * @param fee
     * @param memo
     *
     * @returns Returns the hash of the transaction
     */ function signAndBroadcastSync(signerAddress, messages, fee) {
                var memo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var usedFee, gasEstimation, multiplier, txRaw, txBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(fee == "auto" || typeof fee === "number")) return [
                                    3,
                                    2
                                ];
                                (0, $gMk5u.assertDefined)(_this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
                                return [
                                    4,
                                    _this.simulate(signerAddress, messages, memo)
                                ];
                            case 1:
                                gasEstimation = _state.sent();
                                multiplier = typeof fee === "number" ? fee : 1.3;
                                usedFee = (0, $3e8bd88d734bad5a$exports.calculateFee)(Math.round(gasEstimation * multiplier), _this.gasPrice);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                usedFee = fee;
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _this.sign(signerAddress, messages, usedFee, memo)
                                ];
                            case 4:
                                txRaw = _state.sent();
                                txBytes = $540f96552e476ffb$exports.TxRaw.encode(txRaw).finish();
                                return [
                                    2,
                                    _this.broadcastTxSync(txBytes)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sign",
            value: function sign(signerAddress, messages, fee, memo, explicitSignerData) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var signerData, _ref, accountNumber, sequence, chainId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!explicitSignerData) return [
                                    3,
                                    1
                                ];
                                signerData = explicitSignerData;
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.getSequence(signerAddress)
                                ];
                            case 2:
                                _ref = _state.sent(), accountNumber = _ref.accountNumber, sequence = _ref.sequence;
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 3:
                                chainId = _state.sent();
                                signerData = {
                                    accountNumber: accountNumber,
                                    sequence: sequence,
                                    chainId: chainId
                                };
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    (0, $ff811d56e12ad916$exports.isOfflineDirectSigner)(_this.signer) ? _this.signDirect(signerAddress, messages, fee, memo, signerData) : _this.signAmino(signerAddress, messages, fee, memo, signerData)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAmino",
            value: function signAmino(signerAddress, messages, fee, memo, param) {
                var accountNumber = param.accountNumber, sequence = param.sequence, chainId = param.chainId;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accountFromSigner, pubkey, signMode, msgs, signDoc, _ref, signature, signed, signedTxBody, signedTxBodyBytes, signedGasLimit, signedSequence, signedAuthInfoBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $gMk5u.assert)(!(0, $ff811d56e12ad916$exports.isOfflineDirectSigner)(_this.signer));
                                return [
                                    4,
                                    _this.signer.getAccounts()
                                ];
                            case 1:
                                accountFromSigner = _state.sent().find(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
                                pubkey = (0, $ff811d56e12ad916$exports.encodePubkey)((0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
                                signMode = $82c22db8b6bc5755$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
                                msgs = messages.map(function(msg) {
                                    return _this.aminoTypes.toAmino(msg);
                                });
                                signDoc = (0, $c9b9a1a428003423$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
                                return [
                                    4,
                                    _this.signer.signAmino(signerAddress, signDoc)
                                ];
                            case 2:
                                _ref = _state.sent(), signature = _ref.signature, signed = _ref.signed;
                                signedTxBody = {
                                    typeUrl: "/cosmos.tx.v1beta1.TxBody",
                                    value: {
                                        messages: signed.msgs.map(function(msg) {
                                            return _this.aminoTypes.fromAmino(msg);
                                        }),
                                        memo: signed.memo
                                    }
                                };
                                signedTxBodyBytes = _this.registry.encode(signedTxBody);
                                signedGasLimit = $kTbgy.Int53.fromString(signed.fee.gas).toNumber();
                                signedSequence = $kTbgy.Int53.fromString(signed.sequence).toNumber();
                                signedAuthInfoBytes = (0, $ff811d56e12ad916$exports.makeAuthInfoBytes)([
                                    {
                                        pubkey: pubkey,
                                        sequence: signedSequence
                                    }
                                ], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
                                return [
                                    2,
                                    $540f96552e476ffb$exports.TxRaw.fromPartial({
                                        bodyBytes: signedTxBodyBytes,
                                        authInfoBytes: signedAuthInfoBytes,
                                        signatures: [
                                            (0, $lSA9E.fromBase64)(signature.signature)
                                        ]
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signDirect",
            value: function signDirect(signerAddress, messages, fee, memo, param) {
                var accountNumber = param.accountNumber, sequence = param.sequence, chainId = param.chainId;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accountFromSigner, pubkey, txBody, txBodyBytes, gasLimit, authInfoBytes, signDoc, _ref, signature, signed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $gMk5u.assert)((0, $ff811d56e12ad916$exports.isOfflineDirectSigner)(_this.signer));
                                return [
                                    4,
                                    _this.signer.getAccounts()
                                ];
                            case 1:
                                accountFromSigner = _state.sent().find(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
                                pubkey = (0, $ff811d56e12ad916$exports.encodePubkey)((0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
                                txBody = {
                                    typeUrl: "/cosmos.tx.v1beta1.TxBody",
                                    value: {
                                        messages: messages,
                                        memo: memo
                                    }
                                };
                                txBodyBytes = _this.registry.encode(txBody);
                                gasLimit = $kTbgy.Int53.fromString(fee.gas).toNumber();
                                authInfoBytes = (0, $ff811d56e12ad916$exports.makeAuthInfoBytes)([
                                    {
                                        pubkey: pubkey,
                                        sequence: sequence
                                    }
                                ], fee.amount, gasLimit, fee.granter, fee.payer);
                                signDoc = (0, $ff811d56e12ad916$exports.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
                                return [
                                    4,
                                    _this.signer.signDirect(signerAddress, signDoc)
                                ];
                            case 2:
                                _ref = _state.sent(), signature = _ref.signature, signed = _ref.signed;
                                return [
                                    2,
                                    $540f96552e476ffb$exports.TxRaw.fromPartial({
                                        bodyBytes: signed.bodyBytes,
                                        authInfoBytes: signed.authInfoBytes,
                                        signatures: [
                                            (0, $lSA9E.fromBase64)(signature.signature)
                                        ]
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "connectWithSigner",
            value: /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */ function connectWithSigner(endpoint, signer) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return (0, $6rBFC._)(function() {
                    var tmClient, tm37Client, version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint37Client.connect(endpoint)
                                ];
                            case 1:
                                tm37Client = _state.sent();
                                return [
                                    4,
                                    tm37Client.status()
                                ];
                            case 2:
                                version = _state.sent().nodeInfo.version;
                                if (!version.startsWith("0.37.")) return [
                                    3,
                                    3
                                ];
                                tmClient = tm37Client;
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                tm37Client.disconnect();
                                return [
                                    4,
                                    $7cd013e5dbc8ccb9$exports.Tendermint34Client.connect(endpoint)
                                ];
                            case 4:
                                tmClient = _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    SigningCosmWasmClient.createWithSigner(tmClient, signer, options)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createWithSigner",
            value: /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ function createWithSigner(tmClient, signer) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new SigningCosmWasmClient(tmClient, signer, options)
                        ];
                    });
                })();
            }
        },
        {
            key: "offline",
            value: /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */ function offline(signer) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new SigningCosmWasmClient(undefined, signer, options)
                        ];
                    });
                })();
            }
        }
    ]);
    return SigningCosmWasmClient;
}($874883cdc389d04f$exports.CosmWasmClient);
$e3268442d0b08e42$exports.SigningCosmWasmClient = $e3268442d0b08e42$var$SigningCosmWasmClient;


Object.defineProperty($5806cdd0880cf151$exports, "SigningCosmWasmClient", {
    enumerable: true,
    get: function get() {
        return $e3268442d0b08e42$exports.SigningCosmWasmClient;
    }
});


var $43a17493f975232b$exports = {};
"use strict";
Object.defineProperty($43a17493f975232b$exports, "__esModule", {
    value: true
});
$43a17493f975232b$exports.LedgerSigner = $43a17493f975232b$exports.LedgerConnector = void 0;
var $d28f3046bd9806cf$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $d28f3046bd9806cf$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d28f3046bd9806cf$exports, "__esModule", {
    value: true
});
$d28f3046bd9806cf$exports.LedgerConnector = void 0;


var $3d6bA = parcelRequire("3d6bA");

var $lSA9E = parcelRequire("lSA9E");

var $gMk5u = parcelRequire("gMk5u");

var $d28f3046bd9806cf$var$ledger_cosmos_js_1 = $d28f3046bd9806cf$var$__importDefault((parcelRequire("jUfIR")));

var $d28f3046bd9806cf$var$semver_1 = $d28f3046bd9806cf$var$__importDefault((parcelRequire("kvw3m")));
/* eslint-enable */ function $d28f3046bd9806cf$var$unharden(hdPath) {
    return hdPath.map(function(n) {
        return n.isHardened() ? n.toNumber() - Math.pow(2, 31) : n.toNumber();
    });
}
var $d28f3046bd9806cf$var$cosmosHdPath = (0, $c9b9a1a428003423$exports.makeCosmoshubPath)(0);
var $d28f3046bd9806cf$var$cosmosBech32Prefix = "cosmos";
var $d28f3046bd9806cf$var$cosmosLedgerAppName = "Cosmos";
var $d28f3046bd9806cf$var$requiredCosmosAppVersion = "1.5.3";
var $d28f3046bd9806cf$var$LedgerConnector = /*#__PURE__*/ function() {
    function LedgerConnector(transport) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $7dKN1._)(this, LedgerConnector);
        var defaultOptions = {
            hdPaths: [
                $d28f3046bd9806cf$var$cosmosHdPath
            ],
            prefix: $d28f3046bd9806cf$var$cosmosBech32Prefix,
            testModeAllowed: false,
            ledgerAppName: $d28f3046bd9806cf$var$cosmosLedgerAppName,
            requiredLedgerAppVersion: $d28f3046bd9806cf$var$requiredCosmosAppVersion
        };
        var _options_testModeAllowed;
        this.testModeAllowed = (_options_testModeAllowed = options.testModeAllowed) !== null && _options_testModeAllowed !== void 0 ? _options_testModeAllowed : defaultOptions.testModeAllowed;
        var _options_hdPaths;
        this.hdPaths = (_options_hdPaths = options.hdPaths) !== null && _options_hdPaths !== void 0 ? _options_hdPaths : defaultOptions.hdPaths;
        var _options_prefix;
        this.prefix = (_options_prefix = options.prefix) !== null && _options_prefix !== void 0 ? _options_prefix : defaultOptions.prefix;
        var _options_ledgerAppName;
        this.ledgerAppName = (_options_ledgerAppName = options.ledgerAppName) !== null && _options_ledgerAppName !== void 0 ? _options_ledgerAppName : defaultOptions.ledgerAppName;
        var _options_minLedgerAppVersion;
        this.minLedgerAppVersion = (_options_minLedgerAppVersion = options.minLedgerAppVersion) !== null && _options_minLedgerAppVersion !== void 0 ? _options_minLedgerAppVersion : defaultOptions.requiredLedgerAppVersion;
        this.app = new $d28f3046bd9806cf$var$ledger_cosmos_js_1.default(transport);
    }
    (0, $eW5pA._)(LedgerConnector, [
        {
            key: "getCosmosAppVersion",
            value: function getCosmosAppVersion() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response, major, minor, patch, testMode;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.verifyCosmosAppIsOpen()
                                ];
                            case 1:
                                _state.sent();
                                (0, $gMk5u.assert)(_this.app, "".concat(_this.ledgerAppName, " Ledger App is not connected"));
                                return [
                                    4,
                                    _this.app.getVersion()
                                ];
                            case 2:
                                response = _state.sent();
                                _this.handleLedgerErrors(response);
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                major = response.major, minor = response.minor, patch = response.patch, testMode = response.test_mode;
                                _this.verifyAppMode(testMode);
                                return [
                                    2,
                                    "".concat(major, ".").concat(minor, ".").concat(patch)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPubkey",
            value: function getPubkey(hdPath) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var hdPathToUse, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.verifyDeviceIsReady()
                                ];
                            case 1:
                                _state.sent();
                                (0, $gMk5u.assert)(_this.app, "".concat(_this.ledgerAppName, " Ledger App is not connected"));
                                hdPathToUse = hdPath || _this.hdPaths[0];
                                return [
                                    4,
                                    _this.app.publicKey($d28f3046bd9806cf$var$unharden(hdPathToUse))
                                ];
                            case 2:
                                response = _state.sent();
                                _this.handleLedgerErrors(response);
                                return [
                                    2,
                                    Uint8Array.from(response.compressed_pk)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPubkeys",
            value: function getPubkeys() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.hdPaths.reduce(function(promise, hdPath) {
                                return promise.then(function() {
                                    var _ref = (0, $6rBFC._)(function(pubkeys) {
                                        var _, _1;
                                        return (0, $6qu4b.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _1 = (_ = (0, $gF0bR._)(pubkeys)).concat;
                                                    return [
                                                        4,
                                                        _this.getPubkey(hdPath)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _1.apply(_, [
                                                            [
                                                                _state.sent()
                                                            ]
                                                        ])
                                                    ];
                                            }
                                        });
                                    });
                                    return function(pubkeys) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            }, Promise.resolve([]))
                        ];
                    });
                })();
            }
        },
        {
            key: "getCosmosAddress",
            value: function getCosmosAddress(pubkey) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var pubkeyToUse, _tmp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = pubkey;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getPubkey()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                pubkeyToUse = _tmp;
                                return [
                                    2,
                                    (0, $c9b9a1a428003423$exports.pubkeyToAddress)((0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(pubkeyToUse), _this.prefix)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sign",
            value: function sign(message, hdPath) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var hdPathToUse, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.verifyDeviceIsReady()
                                ];
                            case 1:
                                _state.sent();
                                (0, $gMk5u.assert)(_this.app, "".concat(_this.ledgerAppName, " Ledger App is not connected"));
                                hdPathToUse = hdPath || _this.hdPaths[0];
                                return [
                                    4,
                                    _this.app.sign($d28f3046bd9806cf$var$unharden(hdPathToUse), (0, $lSA9E.fromUtf8)(message))
                                ];
                            case 2:
                                response = _state.sent();
                                _this.handleLedgerErrors(response, "Transaction signing request was rejected by the user");
                                return [
                                    2,
                                    $3d6bA.Secp256k1Signature.fromDer(response.signature).toFixedLength()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyAppMode",
            value: function verifyAppMode(testMode) {
                if (testMode && !this.testModeAllowed) throw new Error("DANGER: The ".concat(this.ledgerAppName, " Ledger app is in test mode and should not be used on mainnet!"));
            }
        },
        {
            key: "getOpenAppName",
            value: function getOpenAppName() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $gMk5u.assert)(_this.app, "".concat(_this.ledgerAppName, " Ledger App is not connected"));
                                return [
                                    4,
                                    _this.app.appInfo()
                                ];
                            case 1:
                                response = _state.sent();
                                _this.handleLedgerErrors(response);
                                return [
                                    2,
                                    response.appName
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyAppVersion",
            value: function verifyAppVersion() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var version;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getCosmosAppVersion()
                                ];
                            case 1:
                                version = _state.sent();
                                if (!$d28f3046bd9806cf$var$semver_1.default.gte(version, _this.minLedgerAppVersion)) throw new Error("Outdated version: Please update ".concat(_this.ledgerAppName, " Ledger App to the latest version."));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyCosmosAppIsOpen",
            value: function verifyCosmosAppIsOpen() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var appName;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOpenAppName()
                                ];
                            case 1:
                                appName = _state.sent();
                                if (appName.toLowerCase() === "dashboard") throw new Error("Please open the ".concat(_this.ledgerAppName, " Ledger app on your Ledger device."));
                                if (appName.toLowerCase() !== _this.ledgerAppName.toLowerCase()) throw new Error("Please close ".concat(appName, " and open the ").concat(_this.ledgerAppName, " Ledger app on your Ledger device."));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyDeviceIsReady",
            value: function verifyDeviceIsReady() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.verifyAppVersion()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.verifyCosmosAppIsOpen()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "showAddress",
            value: /**
     * Shows the user's address in the device and returns an address/pubkey pair.
     *
     * The address will be shown with the native prefix of the app (e.g. cosmos, persistence, desmos)
     * and does not support the usage of other address prefixes.
     *
     * @param path The HD path to show the address for. If unset, this is the first account.
     */ function showAddress(hdPath) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var hdPathToUse, response, address, compressed_pk;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.verifyDeviceIsReady()
                                ];
                            case 1:
                                _state.sent();
                                hdPathToUse = hdPath || _this.hdPaths[0];
                                return [
                                    4,
                                    _this.app.showAddressAndPubKey($d28f3046bd9806cf$var$unharden(hdPathToUse), _this.prefix)
                                ];
                            case 2:
                                response = _state.sent();
                                _this.handleLedgerErrors(response);
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                address = response.address, compressed_pk = response.compressed_pk;
                                return [
                                    2,
                                    {
                                        address: address,
                                        pubkey: (0, $c9b9a1a428003423$exports.encodeSecp256k1Pubkey)(compressed_pk)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleLedgerErrors",
            value: function handleLedgerErrors(/* eslint-disable @typescript-eslint/naming-convention */ param) {
                var tmp = param.error_message, errorMessage = tmp === void 0 ? "No errors" : tmp, tmp1 = param.device_locked, deviceLocked = tmp1 === void 0 ? false : tmp1, /* eslint-enable */ rejectionMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Request was rejected by the user";
                if (deviceLocked) throw new Error("Ledger\u2019s screensaver mode is on");
                switch(errorMessage){
                    case "U2F: Timeout":
                        throw new Error("Connection timed out. Please try again.");
                    case "Cosmos app does not seem to be open":
                        throw new Error("".concat(this.ledgerAppName, " app is not open"));
                    case "Command not allowed":
                        throw new Error("Transaction rejected");
                    case "Transaction rejected":
                        throw new Error(rejectionMessage);
                    case "Unknown Status Code: 26628":
                        throw new Error("Ledger\u2019s screensaver mode is on");
                    case "Instruction not supported":
                        throw new Error("Your ".concat(this.ledgerAppName, " Ledger App is not up to date. Please update to version ").concat(this.minLedgerAppVersion, " or newer."));
                    case "No errors":
                        break;
                    default:
                        throw new Error("Ledger Native Error: ".concat(errorMessage));
                }
            }
        }
    ]);
    return LedgerConnector;
}();
$d28f3046bd9806cf$exports.LedgerConnector = $d28f3046bd9806cf$var$LedgerConnector;


Object.defineProperty($43a17493f975232b$exports, "LedgerConnector", {
    enumerable: true,
    get: function get() {
        return $d28f3046bd9806cf$exports.LedgerConnector;
    }
});
var $7f1916d9b120fef8$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($7f1916d9b120fef8$exports, "__esModule", {
    value: true
});
$7f1916d9b120fef8$exports.LedgerSigner = void 0;


var $7f1916d9b120fef8$var$LedgerSigner = /*#__PURE__*/ function() {
    function LedgerSigner(transport) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $7dKN1._)(this, LedgerSigner);
        this.hdPaths = options.hdPaths || [
            (0, $c9b9a1a428003423$exports.makeCosmoshubPath)(0)
        ];
        this.connector = new $d28f3046bd9806cf$exports.LedgerConnector(transport, options);
    }
    (0, $eW5pA._)(LedgerSigner, [
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var pubkeys;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.accounts) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.connector.getPubkeys()
                                ];
                            case 1:
                                pubkeys = _state.sent();
                                return [
                                    4,
                                    Promise.all(pubkeys.map(function() {
                                        var _ref = (0, $6rBFC._)(function(pubkey) {
                                            var _tmp;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _tmp = {
                                                            algo: "secp256k1"
                                                        };
                                                        return [
                                                            4,
                                                            _this.connector.getCosmosAddress(pubkey)
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            (_tmp.address = _state.sent(), _tmp.pubkey = pubkey, _tmp)
                                                        ];
                                                }
                                            });
                                        });
                                        return function(pubkey) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 2:
                                _this.accounts = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.accounts
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "showAddress",
            value: /**
     * Shows the user's address in the device and returns an address/pubkey pair.
     *
     * The address will be shown with the native prefix of the app (e.g. cosmos, persistence, desmos)
     * and does not support the usage of other address prefixes.
     *
     * @param path The HD path to show the address for. If unset, this is the first account.
     */ function showAddress(path) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.connector.showAddress(path)
                        ];
                    });
                })();
            }
        },
        {
            key: "signAmino",
            value: function signAmino(signerAddress, signDoc) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var accounts, _tmp, accountIndex, message, accountForAddress, hdPath, signature;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.accounts;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getAccounts()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                accounts = _tmp;
                                accountIndex = accounts.findIndex(function(account) {
                                    return account.address === signerAddress;
                                });
                                if (accountIndex === -1) throw new Error("Address ".concat(signerAddress, " not found in wallet"));
                                message = (0, $c9b9a1a428003423$exports.serializeSignDoc)(signDoc);
                                accountForAddress = accounts[accountIndex];
                                hdPath = _this.hdPaths[accountIndex];
                                return [
                                    4,
                                    _this.connector.sign(message, hdPath)
                                ];
                            case 3:
                                signature = _state.sent();
                                return [
                                    2,
                                    {
                                        signed: signDoc,
                                        signature: (0, $c9b9a1a428003423$exports.encodeSecp256k1Signature)(accountForAddress.pubkey, signature)
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return LedgerSigner;
}();
$7f1916d9b120fef8$exports.LedgerSigner = $7f1916d9b120fef8$var$LedgerSigner;


Object.defineProperty($43a17493f975232b$exports, "LedgerSigner", {
    enumerable: true,
    get: function get() {
        return $7f1916d9b120fef8$exports.LedgerSigner;
    }
});




var $aVMuR = parcelRequire("aVMuR");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $5cc35981c6d83686$export$83d89fbfd8236492 = "logger/5.5.0";


"use strict";
var $8056241a417d1601$var$_permanentCensorErrors = false;
var $8056241a417d1601$var$_censorErrors = false;
var $8056241a417d1601$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
var $8056241a417d1601$var$_logLevel = $8056241a417d1601$var$LogLevels["default"];
var $8056241a417d1601$var$_globalLogger = null;
function $8056241a417d1601$var$_checkNormalize() {
    try {
        var missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(form) {
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
var $8056241a417d1601$var$_normalizeError = $8056241a417d1601$var$_checkNormalize();
var $8056241a417d1601$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($8056241a417d1601$export$243e62d78d3b544d || ($8056241a417d1601$export$243e62d78d3b544d = {}));
var $8056241a417d1601$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($8056241a417d1601$export$d4e71bc0b80dc0fb || ($8056241a417d1601$export$d4e71bc0b80dc0fb = {}));
var $8056241a417d1601$var$HEX = "0123456789abcdef";
var $8056241a417d1601$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger(version) {
        (0, $7dKN1._)(this, Logger);
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    (0, $eW5pA._)(Logger, [
        {
            key: "_log",
            value: function _log(logLevel, args) {
                var level = logLevel.toLowerCase();
                if ($8056241a417d1601$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
                if ($8056241a417d1601$var$_logLevel > $8056241a417d1601$var$LogLevels[level]) return;
                console.log.apply(console, args);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.DEBUG, args);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.INFO, args);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.WARNING, args);
            }
        },
        {
            key: "makeError",
            value: function makeError(message, code, params) {
                // Errors are being censored
                if ($8056241a417d1601$var$_censorErrors) return this.makeError("censored error", code, {});
                if (!code) code = Logger.errors.UNKNOWN_ERROR;
                if (!params) params = {};
                var messageDetails = [];
                Object.keys(params).forEach(function(key) {
                    var value = params[key];
                    try {
                        if (value instanceof Uint8Array) {
                            var hex = "";
                            for(var i = 0; i < value.length; i++){
                                hex += $8056241a417d1601$var$HEX[value[i] >> 4];
                                hex += $8056241a417d1601$var$HEX[value[i] & 0x0f];
                            }
                            messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                        } else messageDetails.push(key + "=" + JSON.stringify(value));
                    } catch (error) {
                        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
                    }
                });
                messageDetails.push("code=".concat(code));
                messageDetails.push("version=".concat(this.version));
                var reason = message;
                if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
                // @TODO: Any??
                var error = new Error(message);
                error.reason = reason;
                error.code = code;
                Object.keys(params).forEach(function(key) {
                    error[key] = params[key];
                });
                return error;
            }
        },
        {
            key: "throwError",
            value: function throwError(message, code, params) {
                throw this.makeError(message, code, params);
            }
        },
        {
            key: "throwArgumentError",
            value: function throwArgumentError(message, name, value) {
                return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
                    argument: name,
                    value: value
                });
            }
        },
        {
            key: "assert",
            value: function assert(condition, message, code, params) {
                if (!!condition) return;
                this.throwError(message, code, params);
            }
        },
        {
            key: "assertArgument",
            value: function assertArgument(condition, message, name, value) {
                if (!!condition) return;
                this.throwArgumentError(message, name, value);
            }
        },
        {
            key: "checkNormalize",
            value: function checkNormalize(message) {
                if (message == null) message = "platform missing String.prototype.normalize";
                if ($8056241a417d1601$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "String.prototype.normalize",
                    form: $8056241a417d1601$var$_normalizeError
                });
            }
        },
        {
            key: "checkSafeUint53",
            value: function checkSafeUint53(value, message) {
                if (typeof value !== "number") return;
                if (message == null) message = "value not safe";
                if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "out-of-safe-range",
                    value: value
                });
                if (value % 1) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "non-integer",
                    value: value
                });
            }
        },
        {
            key: "checkArgumentCount",
            value: function checkArgumentCount(count, expectedCount, message) {
                if (message) message = ": " + message;
                else message = "";
                if (count < expectedCount) this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
                if (count > expectedCount) this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
            }
        },
        {
            key: "checkNew",
            value: function checkNew(target, kind) {
                if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        },
        {
            key: "checkAbstract",
            value: function checkAbstract(target, kind) {
                if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, {
                    name: target.name,
                    operation: "new"
                });
                else if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        }
    ], [
        {
            key: "globalLogger",
            value: function globalLogger() {
                if (!$8056241a417d1601$var$_globalLogger) $8056241a417d1601$var$_globalLogger = new Logger((0, $5cc35981c6d83686$export$83d89fbfd8236492));
                return $8056241a417d1601$var$_globalLogger;
            }
        },
        {
            key: "setCensorship",
            value: function setCensorship(censorship, permanent) {
                if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                });
                if ($8056241a417d1601$var$_permanentCensorErrors) {
                    if (!censorship) return;
                    this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                }
                $8056241a417d1601$var$_censorErrors = !!censorship;
                $8056241a417d1601$var$_permanentCensorErrors = !!permanent;
            }
        },
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                var level = $8056241a417d1601$var$LogLevels[logLevel.toLowerCase()];
                if (level == null) {
                    Logger.globalLogger().warn("invalid log level - " + logLevel);
                    return;
                }
                $8056241a417d1601$var$_logLevel = level;
            }
        },
        {
            key: "from",
            value: function from(version) {
                return new Logger(version);
            }
        }
    ]);
    return Logger;
}();
$8056241a417d1601$export$efa9a398d6368992.errors = $8056241a417d1601$export$d4e71bc0b80dc0fb;
$8056241a417d1601$export$efa9a398d6368992.levels = $8056241a417d1601$export$243e62d78d3b544d;


var $adb96bf0796653fd$export$83d89fbfd8236492 = "bytes/5.5.0";


"use strict";
var $a3456dc00c6ba25e$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $adb96bf0796653fd$export$83d89fbfd8236492));
///////////////////////////////
function $a3456dc00c6ba25e$var$isHexable(value) {
    return !!value.toHexString;
}
function $a3456dc00c6ba25e$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        var args = Array.prototype.slice.call(arguments);
        return $a3456dc00c6ba25e$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $a3456dc00c6ba25e$export$9a14abb1a440cd5e(value) {
    return $a3456dc00c6ba25e$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $a3456dc00c6ba25e$export$c6fabfbfd097fc30(value);
}
function $a3456dc00c6ba25e$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $a3456dc00c6ba25e$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$a3456dc00c6ba25e$var$isInteger(value.length) || value.length < 0) return false;
    for(var i = 0; i < value.length; i++){
        var v = value[i];
        if (!$a3456dc00c6ba25e$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $a3456dc00c6ba25e$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $a3456dc00c6ba25e$var$logger.checkSafeUint53(value, "invalid arrayify value");
        var result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $a3456dc00c6ba25e$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($a3456dc00c6ba25e$var$isHexable(value)) value = value.toHexString();
    if ($a3456dc00c6ba25e$export$b02a40aff8e4ad18(value)) {
        var hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0x0" + hex.substring(2);
            else if (options.hexPad === "right") hex += "0";
            else $a3456dc00c6ba25e$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        var result1 = [];
        for(var i = 0; i < hex.length; i += 2)result1.push(parseInt(hex.substring(i, i + 2), 16));
        return $a3456dc00c6ba25e$var$addSlice(new Uint8Array(result1));
    }
    if ($a3456dc00c6ba25e$export$c6fabfbfd097fc30(value)) return $a3456dc00c6ba25e$var$addSlice(new Uint8Array(value));
    return $a3456dc00c6ba25e$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $a3456dc00c6ba25e$export$ee1b3e54f0441b22(items) {
    var objects = items.map(function(item) {
        return $a3456dc00c6ba25e$export$3131421a7d01b4fb(item);
    });
    var length = objects.reduce(function(accum, item) {
        return accum + item.length;
    }, 0);
    var result = new Uint8Array(length);
    objects.reduce(function(offset, object) {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $a3456dc00c6ba25e$var$addSlice(result);
}
function $a3456dc00c6ba25e$export$a8f4574d0e56446c(value) {
    var result = $a3456dc00c6ba25e$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    var start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $a3456dc00c6ba25e$export$3cdc770bf8b2ed3d(value, length) {
    value = $a3456dc00c6ba25e$export$3131421a7d01b4fb(value);
    if (value.length > length) $a3456dc00c6ba25e$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    var result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $a3456dc00c6ba25e$var$addSlice(result);
}
function $a3456dc00c6ba25e$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
var $a3456dc00c6ba25e$var$HexCharacters = "0123456789abcdef";
function $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $a3456dc00c6ba25e$var$logger.checkSafeUint53(value, "invalid hexlify value");
        var hex = "";
        while(value){
            hex = $a3456dc00c6ba25e$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if ((typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($a3456dc00c6ba25e$var$isHexable(value)) return value.toHexString();
    if ($a3456dc00c6ba25e$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $a3456dc00c6ba25e$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($a3456dc00c6ba25e$export$c6fabfbfd097fc30(value)) {
        var result = "0x";
        for(var i = 0; i < value.length; i++){
            var v = value[i];
            result += $a3456dc00c6ba25e$var$HexCharacters[(v & 0xf0) >> 4] + $a3456dc00c6ba25e$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $a3456dc00c6ba25e$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $a3456dc00c6ba25e$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(data);
    else if (!$a3456dc00c6ba25e$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $a3456dc00c6ba25e$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(data);
    else if (!$a3456dc00c6ba25e$export$b02a40aff8e4ad18(data) || data.length % 2) $a3456dc00c6ba25e$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $a3456dc00c6ba25e$export$6d4b99629b38754a(items) {
    var result = "0x";
    items.forEach(function(item) {
        result += $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $a3456dc00c6ba25e$export$6916af760a341dd3(value) {
    var trimmed = $a3456dc00c6ba25e$export$967bc0082a978949($a3456dc00c6ba25e$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $a3456dc00c6ba25e$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(value);
    if (!$a3456dc00c6ba25e$export$b02a40aff8e4ad18(value)) $a3456dc00c6ba25e$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    var offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $a3456dc00c6ba25e$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(value);
    else if (!$a3456dc00c6ba25e$export$b02a40aff8e4ad18(value)) $a3456dc00c6ba25e$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $a3456dc00c6ba25e$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $a3456dc00c6ba25e$export$7fb170f1e457988f(signature) {
    var result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0
    };
    if ($a3456dc00c6ba25e$export$9a14abb1a440cd5e(signature)) {
        var bytes = $a3456dc00c6ba25e$export$3131421a7d01b4fb(signature);
        if (bytes.length !== 65) $a3456dc00c6ba25e$var$logger.throwArgumentError("invalid signature string; must be 65 bytes", "signature", signature);
        // Get the r, s and v
        result.r = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
        result.s = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        result.v = bytes[64];
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $a3456dc00c6ba25e$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            var vs = $a3456dc00c6ba25e$export$3cdc770bf8b2ed3d($a3456dc00c6ba25e$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            var recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            var s = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            var recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$a3456dc00c6ba25e$export$b02a40aff8e4ad18(result.r)) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $a3456dc00c6ba25e$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$a3456dc00c6ba25e$export$b02a40aff8e4ad18(result.s)) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $a3456dc00c6ba25e$export$e9c46a54370b47e8(result.s, 32);
        var vs1 = $a3456dc00c6ba25e$export$3131421a7d01b4fb(result.s);
        if (vs1[0] >= 128) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs1[0] |= 0x80;
        var _vs = $a3456dc00c6ba25e$export$2b0d6b5fbe698c70(vs1);
        if (result._vs) {
            if (!$a3456dc00c6ba25e$export$b02a40aff8e4ad18(result._vs)) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $a3456dc00c6ba25e$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $a3456dc00c6ba25e$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    return result;
}
function $a3456dc00c6ba25e$export$71bb9d78a59bbe25(signature) {
    signature = $a3456dc00c6ba25e$export$7fb170f1e457988f(signature);
    return $a3456dc00c6ba25e$export$2b0d6b5fbe698c70($a3456dc00c6ba25e$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $515f895c141cc7f5$export$83d89fbfd8236492 = "rlp/5.5.0";


"use strict";
var $7a70ce756b0eaa1e$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $515f895c141cc7f5$export$83d89fbfd8236492));
function $7a70ce756b0eaa1e$var$arrayifyInteger(value) {
    var result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $7a70ce756b0eaa1e$var$unarrayifyInteger(data, offset, length) {
    var result = 0;
    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $7a70ce756b0eaa1e$var$_encode(object) {
    if (Array.isArray(object)) {
        var payload = [];
        object.forEach(function(child) {
            payload = payload.concat($7a70ce756b0eaa1e$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        var length = $7a70ce756b0eaa1e$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $a3456dc00c6ba25e$export$9a14abb1a440cd5e)(object)) $7a70ce756b0eaa1e$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    var data = Array.prototype.slice.call((0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    var length1 = $7a70ce756b0eaa1e$var$arrayifyInteger(data.length);
    length1.unshift(0xb7 + length1.length);
    return length1.concat(data);
}
function $7a70ce756b0eaa1e$export$c564cdbbe6da493(object) {
    return (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)($7a70ce756b0eaa1e$var$_encode(object));
}
function $7a70ce756b0eaa1e$var$_decodeChildren(data, offset, childOffset, length) {
    var result = [];
    while(childOffset < offset + 1 + length){
        var decoded = $7a70ce756b0eaa1e$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $7a70ce756b0eaa1e$var$logger.throwError("child data too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $7a70ce756b0eaa1e$var$_decode(data, offset) {
    if (data.length === 0) $7a70ce756b0eaa1e$var$logger.throwError("data too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        var lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $7a70ce756b0eaa1e$var$logger.throwError("data short segment too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var length = $7a70ce756b0eaa1e$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $7a70ce756b0eaa1e$var$logger.throwError("data long segment too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $7a70ce756b0eaa1e$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        var length1 = data[offset] - 0xc0;
        if (offset + 1 + length1 > data.length) $7a70ce756b0eaa1e$var$logger.throwError("data array too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $7a70ce756b0eaa1e$var$_decodeChildren(data, offset, offset + 1, length1);
    } else if (data[offset] >= 0xb8) {
        var lengthLength1 = data[offset] - 0xb7;
        if (offset + 1 + lengthLength1 > data.length) $7a70ce756b0eaa1e$var$logger.throwError("data array too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var length2 = $7a70ce756b0eaa1e$var$unarrayifyInteger(data, offset + 1, lengthLength1);
        if (offset + 1 + lengthLength1 + length2 > data.length) $7a70ce756b0eaa1e$var$logger.throwError("data array too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var result = (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength1, offset + 1 + lengthLength1 + length2));
        return {
            consumed: 1 + lengthLength1 + length2,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        var length3 = data[offset] - 0x80;
        if (offset + 1 + length3 > data.length) $7a70ce756b0eaa1e$var$logger.throwError("data too short", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var result1 = (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length3));
        return {
            consumed: 1 + length3,
            result: result1
        };
    }
    return {
        consumed: 1,
        result: (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $7a70ce756b0eaa1e$export$2f872c0f2117be69(data) {
    var bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data);
    var decoded = $7a70ce756b0eaa1e$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $7a70ce756b0eaa1e$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}


var $db8bc0fd2bf11ecf$exports = {};
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.0.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2021 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function random53bitInt() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var n, i = 1, m = new BigNumber(args[0]);
            for(; i < args.length; i++){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? 2 - isOdd(n) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, $db8bc0fd2bf11ecf$exports) $db8bc0fd2bf11ecf$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($db8bc0fd2bf11ecf$exports);



var $ilnag = parcelRequire("ilnag");
var $f6a3edc136b9f477$require$Buffer = $ilnag.Buffer;
function $f6a3edc136b9f477$export$824c337f43f2b64d(path) {
    var result = [];
    var components = path.split("/");
    components.forEach(function(element) {
        var number = parseInt(element, 10);
        if (isNaN(number)) return; // FIXME shouldn't it throws instead?
        if (element.length > 1 && element[element.length - 1] === "'") number += 0x80000000;
        result.push(number);
    });
    return result;
}
function $f6a3edc136b9f477$export$864b00bc9b75231a(str) {
    return $f6a3edc136b9f477$require$Buffer.from(str.startsWith("0x") ? str.slice(2) : str, "hex");
}
function $f6a3edc136b9f477$export$89e6129ce4ebfefc(str) {
    if (!str) return null;
    return $f6a3edc136b9f477$export$864b00bc9b75231a(str);
}
var $f6a3edc136b9f477$export$e952eba50b3a65d5 = function decodeTxInfo(rawTx) {
    var VALID_TYPES = [
        1,
        2
    ];
    var txType = VALID_TYPES.includes(rawTx[0]) ? rawTx[0] : null;
    var rlpData = txType === null ? rawTx : rawTx.slice(1);
    var rlpTx = (0, $7a70ce756b0eaa1e$export$2f872c0f2117be69)(rlpData).map(function(hex) {
        return $f6a3edc136b9f477$require$Buffer.from(hex.slice(2), "hex");
    });
    var chainIdTruncated = 0;
    var rlpDecoded = (0, $7a70ce756b0eaa1e$export$2f872c0f2117be69)(rlpData);
    var decodedTx;
    if (txType === 2) // EIP1559
    decodedTx = {
        data: rlpDecoded[7],
        to: rlpDecoded[5],
        chainId: rlpTx[0]
    };
    else if (txType === 1) // EIP2930
    decodedTx = {
        data: rlpDecoded[6],
        to: rlpDecoded[4],
        chainId: rlpTx[0]
    };
    else // Legacy tx
    decodedTx = {
        data: rlpDecoded[5],
        to: rlpDecoded[3],
        // Default to 1 for non EIP 155 txs
        chainId: rlpTx.length > 6 ? rlpTx[6] : $f6a3edc136b9f477$require$Buffer.from("0x01", "hex")
    };
    var chainIdSrc = decodedTx.chainId;
    var chainId = new (0, $db8bc0fd2bf11ecf$exports.BigNumber)(0);
    if (chainIdSrc) {
        // Using BigNumber because chainID could be any uint256.
        chainId = new (0, $db8bc0fd2bf11ecf$exports.BigNumber)(chainIdSrc.toString("hex"), 16);
        var chainIdTruncatedBuf = $f6a3edc136b9f477$require$Buffer.alloc(4);
        if (chainIdSrc.length > 4) chainIdSrc.copy(chainIdTruncatedBuf);
        else chainIdSrc.copy(chainIdTruncatedBuf, 4 - chainIdSrc.length);
        chainIdTruncated = chainIdTruncatedBuf.readUInt32BE(0);
    }
    var vrsOffset = 0;
    if (txType === null && rlpTx.length > 6) {
        var rlpVrs = $f6a3edc136b9f477$require$Buffer.from((0, $7a70ce756b0eaa1e$export$c564cdbbe6da493)(rlpTx.slice(-3)).slice(2), "hex");
        vrsOffset = rawTx.length - (rlpVrs.length - 1);
        // First byte > 0xf7 means the length of the list length doesn't fit in a single byte.
        if (rlpVrs[0] > 0xf7) {
            // Increment vrsOffset to account for that extra byte.
            vrsOffset++;
            // Compute size of the list length.
            var sizeOfListLen = rlpVrs[0] - 0xf7;
            // Increase rlpOffset by the size of the list length.
            vrsOffset += sizeOfListLen - 1;
        }
    }
    return {
        decodedTx: decodedTx,
        txType: txType,
        chainId: chainId,
        chainIdTruncated: chainIdTruncated,
        vrsOffset: vrsOffset
    };
};
var $f6a3edc136b9f477$export$64ed265a1cd37072 = function intAsHexBytes(int, bytes) {
    return int.toString(16).padStart(2 * bytes, "0");
};


var $f1d0124ea9de5ab6$var$id = 0;
var $f1d0124ea9de5ab6$var$subscribers = [];
var $f1d0124ea9de5ab6$export$bef1f36f5486a6a3 = function log(type, message, data) {
    var obj = {
        type: type,
        id: String(++$f1d0124ea9de5ab6$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $f1d0124ea9de5ab6$var$dispatch(obj);
};
var $f1d0124ea9de5ab6$export$63174c828edd6ff8 = function listen(cb) {
    $f1d0124ea9de5ab6$var$subscribers.push(cb);
    return function() {
        var i = $f1d0124ea9de5ab6$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $f1d0124ea9de5ab6$var$subscribers[i] = $f1d0124ea9de5ab6$var$subscribers[$f1d0124ea9de5ab6$var$subscribers.length - 1];
            $f1d0124ea9de5ab6$var$subscribers.pop();
        }
    };
};
function $f1d0124ea9de5ab6$var$dispatch(log) {
    for(var i = 0; i < $f1d0124ea9de5ab6$var$subscribers.length; i++)try {
        $f1d0124ea9de5ab6$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = $f1d0124ea9de5ab6$export$63174c828edd6ff8;



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $42mVo = parcelRequire("42mVo");


var $edc747bc06d062e6$export$83d89fbfd8236492 = "bignumber/5.5.0";


"use strict";
var $7e88e1c86db60aed$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($42mVo))).BN;
var $7e88e1c86db60aed$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $edc747bc06d062e6$export$83d89fbfd8236492));
var $7e88e1c86db60aed$var$_constructorGuard = {};
var $7e88e1c86db60aed$var$MAX_SAFE = 0x1fffffffffffff;
function $7e88e1c86db60aed$export$a3d0a7fa9b65683b(value) {
    return value != null && ($7e88e1c86db60aed$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(value) || (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) === "bigint" || (0, $a3456dc00c6ba25e$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
var $7e88e1c86db60aed$var$_warnedToStringRadix = false;
var $7e88e1c86db60aed$export$d97aa349ed20696 = /*#__PURE__*/ function _target() {
    function BigNumber(constructorGuard, hex) {
        (0, $7dKN1._)(this, BigNumber);
        $7e88e1c86db60aed$var$logger.checkNew(this instanceof BigNumber ? this.constructor : void 0, BigNumber);
        if (constructorGuard !== $7e88e1c86db60aed$var$_constructorGuard) $7e88e1c86db60aed$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(BigNumber, [
        {
            key: "fromTwos",
            value: function fromTwos(value) {
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).fromTwos(value));
            }
        },
        {
            key: "toTwos",
            value: function toTwos(value) {
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).toTwos(value));
            }
        },
        {
            key: "abs",
            value: function abs() {
                if (this._hex[0] === "-") return BigNumber.from(this._hex.substring(1));
                return this;
            }
        },
        {
            key: "add",
            value: function add(other) {
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).add($7e88e1c86db60aed$var$toBN(other)));
            }
        },
        {
            key: "sub",
            value: function sub(other) {
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).sub($7e88e1c86db60aed$var$toBN(other)));
            }
        },
        {
            key: "div",
            value: function div(other) {
                var o = BigNumber.from(other);
                if (o.isZero()) $7e88e1c86db60aed$var$throwFault("division by zero", "div");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).div($7e88e1c86db60aed$var$toBN(other)));
            }
        },
        {
            key: "mul",
            value: function mul(other) {
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).mul($7e88e1c86db60aed$var$toBN(other)));
            }
        },
        {
            key: "mod",
            value: function mod(other) {
                var value = $7e88e1c86db60aed$var$toBN(other);
                if (value.isNeg()) $7e88e1c86db60aed$var$throwFault("cannot modulo negative values", "mod");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).umod(value));
            }
        },
        {
            key: "pow",
            value: function pow(other) {
                var value = $7e88e1c86db60aed$var$toBN(other);
                if (value.isNeg()) $7e88e1c86db60aed$var$throwFault("cannot raise to negative values", "pow");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).pow(value));
            }
        },
        {
            key: "and",
            value: function and(other) {
                var value = $7e88e1c86db60aed$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $7e88e1c86db60aed$var$throwFault("cannot 'and' negative values", "and");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).and(value));
            }
        },
        {
            key: "or",
            value: function or(other) {
                var value = $7e88e1c86db60aed$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $7e88e1c86db60aed$var$throwFault("cannot 'or' negative values", "or");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).or(value));
            }
        },
        {
            key: "xor",
            value: function xor(other) {
                var value = $7e88e1c86db60aed$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $7e88e1c86db60aed$var$throwFault("cannot 'xor' negative values", "xor");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).xor(value));
            }
        },
        {
            key: "mask",
            value: function mask(value) {
                if (this.isNegative() || value < 0) $7e88e1c86db60aed$var$throwFault("cannot mask negative values", "mask");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).maskn(value));
            }
        },
        {
            key: "shl",
            value: function shl(value) {
                if (this.isNegative() || value < 0) $7e88e1c86db60aed$var$throwFault("cannot shift negative values", "shl");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).shln(value));
            }
        },
        {
            key: "shr",
            value: function shr(value) {
                if (this.isNegative() || value < 0) $7e88e1c86db60aed$var$throwFault("cannot shift negative values", "shr");
                return $7e88e1c86db60aed$var$toBigNumber($7e88e1c86db60aed$var$toBN(this).shrn(value));
            }
        },
        {
            key: "eq",
            value: function eq(other) {
                return $7e88e1c86db60aed$var$toBN(this).eq($7e88e1c86db60aed$var$toBN(other));
            }
        },
        {
            key: "lt",
            value: function lt(other) {
                return $7e88e1c86db60aed$var$toBN(this).lt($7e88e1c86db60aed$var$toBN(other));
            }
        },
        {
            key: "lte",
            value: function lte(other) {
                return $7e88e1c86db60aed$var$toBN(this).lte($7e88e1c86db60aed$var$toBN(other));
            }
        },
        {
            key: "gt",
            value: function gt(other) {
                return $7e88e1c86db60aed$var$toBN(this).gt($7e88e1c86db60aed$var$toBN(other));
            }
        },
        {
            key: "gte",
            value: function gte(other) {
                return $7e88e1c86db60aed$var$toBN(this).gte($7e88e1c86db60aed$var$toBN(other));
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._hex[0] === "-";
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return $7e88e1c86db60aed$var$toBN(this).isZero();
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                try {
                    return $7e88e1c86db60aed$var$toBN(this).toNumber();
                } catch (error) {
                    $7e88e1c86db60aed$var$throwFault("overflow", "toNumber", this.toString());
                }
                return null;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                try {
                    return BigInt(this.toString());
                } catch (e) {}
                return $7e88e1c86db60aed$var$logger.throwError("this platform does not support BigInt", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    value: this.toString()
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                // Lots of people expect this, which we do not support, so check (See: #889)
                if (arguments.length > 0) {
                    if (arguments[0] === 10) {
                        if (!$7e88e1c86db60aed$var$_warnedToStringRadix) {
                            $7e88e1c86db60aed$var$_warnedToStringRadix = true;
                            $7e88e1c86db60aed$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                        }
                    } else if (arguments[0] === 16) $7e88e1c86db60aed$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
                    else $7e88e1c86db60aed$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
                }
                return $7e88e1c86db60aed$var$toBN(this).toString(10);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this._hex;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(key) {
                return {
                    type: "BigNumber",
                    hex: this.toHexString()
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof BigNumber) return value;
                if (typeof value === "string") {
                    if (value.match(/^-?0x[0-9a-f]+$/i)) return new BigNumber($7e88e1c86db60aed$var$_constructorGuard, $7e88e1c86db60aed$var$toHex(value));
                    if (value.match(/^-?[0-9]+$/)) return new BigNumber($7e88e1c86db60aed$var$_constructorGuard, $7e88e1c86db60aed$var$toHex(new $7e88e1c86db60aed$var$BN(value)));
                    return $7e88e1c86db60aed$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
                }
                if (typeof value === "number") {
                    if (value % 1) $7e88e1c86db60aed$var$throwFault("underflow", "BigNumber.from", value);
                    if (value >= $7e88e1c86db60aed$var$MAX_SAFE || value <= -$7e88e1c86db60aed$var$MAX_SAFE) $7e88e1c86db60aed$var$throwFault("overflow", "BigNumber.from", value);
                    return BigNumber.from(String(value));
                }
                var anyValue = value;
                if ((typeof anyValue === "undefined" ? "undefined" : (0, $aVMuR._)(anyValue)) === "bigint") return BigNumber.from(anyValue.toString());
                if ((0, $a3456dc00c6ba25e$export$c6fabfbfd097fc30)(anyValue)) return BigNumber.from((0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(anyValue));
                if (anyValue) {
                    // Hexable interface (takes priority)
                    if (anyValue.toHexString) {
                        var hex = anyValue.toHexString();
                        if (typeof hex === "string") return BigNumber.from(hex);
                    } else {
                        // For now, handle legacy JSON-ified values (goes away in v6)
                        var hex1 = anyValue._hex;
                        // New-form JSON
                        if (hex1 == null && anyValue.type === "BigNumber") hex1 = anyValue.hex;
                        if (typeof hex1 === "string") {
                            if ((0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(hex1) || hex1[0] === "-" && (0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(hex1.substring(1))) return BigNumber.from(hex1);
                        }
                    }
                }
                return $7e88e1c86db60aed$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
            }
        },
        {
            key: "isBigNumber",
            value: function isBigNumber(value) {
                return !!(value && value._isBigNumber);
            }
        }
    ]);
    return BigNumber;
}();
// Normalize the hex string
function $7e88e1c86db60aed$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $7e88e1c86db60aed$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $7e88e1c86db60aed$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $7e88e1c86db60aed$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $7e88e1c86db60aed$var$toBigNumber(value) {
    return $7e88e1c86db60aed$export$d97aa349ed20696.from($7e88e1c86db60aed$var$toHex(value));
}
function $7e88e1c86db60aed$var$toBN(value) {
    var hex = $7e88e1c86db60aed$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $7e88e1c86db60aed$var$BN("-" + hex.substring(3), 16);
    return new $7e88e1c86db60aed$var$BN(hex.substring(2), 16);
}
function $7e88e1c86db60aed$var$throwFault(fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $7e88e1c86db60aed$var$logger.throwError(fault, (0, $8056241a417d1601$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $7e88e1c86db60aed$export$51e4a08295f7770f(value) {
    return new $7e88e1c86db60aed$var$BN(value, 36).toString(16);
}
function $7e88e1c86db60aed$export$1293db5d29c264ff(value) {
    return new $7e88e1c86db60aed$var$BN(value, 16).toString(36);
}


var $8c256eaa6070eeae$exports = {};

var $aVMuR = parcelRequire("aVMuR");

var $4pbh3 = parcelRequire("4pbh3");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $4pbh3 === "object" && $4pbh3.versions && $4pbh3.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && $8c256eaa6070eeae$exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function createOutputMethod(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function createShakeOutputMethod(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function createCshakeOutputMethod(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function createKmacOutputMethod(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function createOutputMethods(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function createMethod(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function createShakeMethod(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function createCshakeMethod(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function createKmacMethod(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message === "undefined" ? "undefined" : (0, $aVMuR._)(message);
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str);
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function f(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) $8c256eaa6070eeae$exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();



"use strict";
function $851ef8e3386cb4de$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($8c256eaa6070eeae$exports))).keccak_256((0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data));
}




var $ed3aca051247623a$export$83d89fbfd8236492 = "address/5.5.0";


"use strict";
var $5a4c577f8a12516c$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $ed3aca051247623a$export$83d89fbfd8236492));
function $5a4c577f8a12516c$var$getChecksumAddress(address) {
    if (!(0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(address, 20)) $5a4c577f8a12516c$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    var chars = address.substring(2).split("");
    var expanded = new Uint8Array(40);
    for(var i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    var hashed = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)((0, $851ef8e3386cb4de$export$f8151fce47ad1c35)(expanded));
    for(var i1 = 0; i1 < 40; i1 += 2){
        if (hashed[i1 >> 1] >> 4 >= 8) chars[i1] = chars[i1].toUpperCase();
        if ((hashed[i1 >> 1] & 0x0f) >= 8) chars[i1 + 1] = chars[i1 + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
var $5a4c577f8a12516c$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5a4c577f8a12516c$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
var $5a4c577f8a12516c$var$ibanLookup = {};
for(var $5a4c577f8a12516c$var$i = 0; $5a4c577f8a12516c$var$i < 10; $5a4c577f8a12516c$var$i++)$5a4c577f8a12516c$var$ibanLookup[String($5a4c577f8a12516c$var$i)] = String($5a4c577f8a12516c$var$i);
for(var $5a4c577f8a12516c$var$i1 = 0; $5a4c577f8a12516c$var$i1 < 26; $5a4c577f8a12516c$var$i1++)$5a4c577f8a12516c$var$ibanLookup[String.fromCharCode(65 + $5a4c577f8a12516c$var$i1)] = String(10 + $5a4c577f8a12516c$var$i1);
// How many decimal digits can we process? (for 64-bit float, this is 15)
var $5a4c577f8a12516c$var$safeDigits = Math.floor($5a4c577f8a12516c$var$log10($5a4c577f8a12516c$var$MAX_SAFE_INTEGER));
function $5a4c577f8a12516c$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    var expanded = address.split("").map(function(c) {
        return $5a4c577f8a12516c$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5a4c577f8a12516c$var$safeDigits){
        var block = expanded.substring(0, $5a4c577f8a12516c$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    var checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5a4c577f8a12516c$export$88411125f012957a(address) {
    var result = null;
    if (typeof address !== "string") $5a4c577f8a12516c$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5a4c577f8a12516c$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5a4c577f8a12516c$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5a4c577f8a12516c$var$ibanChecksum(address)) $5a4c577f8a12516c$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $7e88e1c86db60aed$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5a4c577f8a12516c$var$getChecksumAddress("0x" + result);
    } else $5a4c577f8a12516c$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5a4c577f8a12516c$export$977e255126d763d6(address) {
    try {
        $5a4c577f8a12516c$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5a4c577f8a12516c$export$962c4ddada9f668f(address) {
    var base36 = (0, $7e88e1c86db60aed$export$1293db5d29c264ff)($5a4c577f8a12516c$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5a4c577f8a12516c$var$ibanChecksum("XE00" + base36) + base36;
}
function $5a4c577f8a12516c$export$b7fbffef12272e40(transaction) {
    var from = null;
    try {
        from = $5a4c577f8a12516c$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5a4c577f8a12516c$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    var nonce = (0, $a3456dc00c6ba25e$export$a8f4574d0e56446c)((0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)((0, $7e88e1c86db60aed$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $5a4c577f8a12516c$export$88411125f012957a((0, $a3456dc00c6ba25e$export$15da666eba198c18)((0, $851ef8e3386cb4de$export$f8151fce47ad1c35)((0, $7a70ce756b0eaa1e$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $5a4c577f8a12516c$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $a3456dc00c6ba25e$export$13882f896d3c0683)(salt) !== 32) $5a4c577f8a12516c$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $a3456dc00c6ba25e$export$13882f896d3c0683)(initCodeHash) !== 32) $5a4c577f8a12516c$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5a4c577f8a12516c$export$88411125f012957a((0, $a3456dc00c6ba25e$export$15da666eba198c18)((0, $851ef8e3386cb4de$export$f8151fce47ad1c35)((0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)([
        "0xff",
        $5a4c577f8a12516c$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}







var $915e8e55cb84a99d$export$83d89fbfd8236492 = "strings/5.5.0";


"use strict";
var $0eea8a441ae5dfe5$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $915e8e55cb84a99d$export$83d89fbfd8236492));
var $0eea8a441ae5dfe5$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($0eea8a441ae5dfe5$export$c6986442964129f5 || ($0eea8a441ae5dfe5$export$c6986442964129f5 = {}));
var $0eea8a441ae5dfe5$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6 || ($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6 = {}));
function $0eea8a441ae5dfe5$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $0eea8a441ae5dfe5$var$logger.throwArgumentError("invalid codepoint at offset ".concat(offset, "; ").concat(reason), "bytes", bytes);
}
function $0eea8a441ae5dfe5$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        var i = 0;
        for(var o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $0eea8a441ae5dfe5$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $0eea8a441ae5dfe5$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
var $0eea8a441ae5dfe5$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $0eea8a441ae5dfe5$var$errorFunc,
    ignore: $0eea8a441ae5dfe5$var$ignoreFunc,
    replace: $0eea8a441ae5dfe5$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $0eea8a441ae5dfe5$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $0eea8a441ae5dfe5$export$c6e2180c5bb5bc05.error;
    bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(bytes);
    var result = [];
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($0eea8a441ae5dfe5$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $0eea8a441ae5dfe5$export$8feeb310b4b4752f(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $0eea8a441ae5dfe5$export$c6986442964129f5.current;
    if (form != $0eea8a441ae5dfe5$export$c6986442964129f5.current) {
        $0eea8a441ae5dfe5$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            var pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(result);
}
function $0eea8a441ae5dfe5$var$escapeChar(value) {
    var hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $0eea8a441ae5dfe5$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $0eea8a441ae5dfe5$var$getUtf8CodePoints(bytes, onError).map(function(codePoint) {
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $0eea8a441ae5dfe5$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $0eea8a441ae5dfe5$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $0eea8a441ae5dfe5$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $0eea8a441ae5dfe5$export$232e1dab03132235(codePoints) {
    return codePoints.map(function(codePoint) {
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $0eea8a441ae5dfe5$export$7643a1dc2c38d5eb(bytes, onError) {
    return $0eea8a441ae5dfe5$export$232e1dab03132235($0eea8a441ae5dfe5$var$getUtf8CodePoints(bytes, onError));
}
function $0eea8a441ae5dfe5$export$ae470a36a31b28c2(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $0eea8a441ae5dfe5$export$c6986442964129f5.current;
    return $0eea8a441ae5dfe5$var$getUtf8CodePoints($0eea8a441ae5dfe5$export$8feeb310b4b4752f(str, form));
}


function $f80f9215e8493b87$export$d560c7e4a29451c2(text) {
    return (0, $851ef8e3386cb4de$export$f8151fce47ad1c35)((0, $0eea8a441ae5dfe5$export$8feeb310b4b4752f)(text));
}




var $7dKN1 = parcelRequire("7dKN1");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");

var $f2d7d9432b7b9f7d$export$83d89fbfd8236492 = "properties/5.5.0";


"use strict";
var $c70bdfd9091def92$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c70bdfd9091def92$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $f2d7d9432b7b9f7d$export$83d89fbfd8236492));
function $c70bdfd9091def92$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $c70bdfd9091def92$export$f695fbbf3cdaaf47(ctor, key) {
    for(var i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $c70bdfd9091def92$export$d503dd157d963b60(object) {
    return $c70bdfd9091def92$var$__awaiter(this, void 0, void 0, function() {
        var promises, results;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = Object.keys(object).map(function(key) {
                        var value = object[key];
                        return Promise.resolve(value).then(function(v) {
                            return {
                                key: key,
                                value: v
                            };
                        });
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(accum, result) {
                            accum[result.key] = result.value;
                            return accum;
                        }, {})
                    ];
            }
        });
    });
}
function $c70bdfd9091def92$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $c70bdfd9091def92$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach(function(key) {
        if (!properties[key]) $c70bdfd9091def92$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $c70bdfd9091def92$export$9c13236873b118a5(object) {
    var result = {};
    for(var key in object)result[key] = object[key];
    return result;
}
var $c70bdfd9091def92$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $c70bdfd9091def92$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $c70bdfd9091def92$var$opaque[typeof object === "undefined" ? "undefined" : (0, $aVMuR._)(object)]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        var keys = Object.keys(object);
        for(var i = 0; i < keys.length; i++){
            var value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$c70bdfd9091def92$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $c70bdfd9091def92$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $aVMuR._)(object)), "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $c70bdfd9091def92$var$_deepCopy(object) {
    if ($c70bdfd9091def92$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map(function(item) {
        return $c70bdfd9091def92$export$6c40052bed430212(item);
    }));
    if (typeof object === "object") {
        var result = {};
        for(var key in object){
            var value = object[key];
            if (value === undefined) continue;
            $c70bdfd9091def92$export$104236534534f9be(result, key, $c70bdfd9091def92$export$6c40052bed430212(value));
        }
        return result;
    }
    return $c70bdfd9091def92$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $aVMuR._)(object)), "object", object);
}
function $c70bdfd9091def92$export$6c40052bed430212(object) {
    return $c70bdfd9091def92$var$_deepCopy(object);
}
var $c70bdfd9091def92$export$393edc798c47379d = function Description(info) {
    (0, $7dKN1._)(this, Description);
    for(var key in info)this[key] = $c70bdfd9091def92$export$6c40052bed430212(info[key]);
};



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");



var $48a45f5b8ab68ce9$export$83d89fbfd8236492 = "abi/5.5.0";



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");





"use strict";
var $70cb18a6832b2ae7$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $48a45f5b8ab68ce9$export$83d89fbfd8236492));
function $70cb18a6832b2ae7$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    var errors = [];
    var checkErrors = function checkErrors1(path, object) {
        if (!Array.isArray(object)) return;
        for(var key in object){
            var childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
var $70cb18a6832b2ae7$export$2c0c39526f8bad46 = /*#__PURE__*/ function() {
    function Coder(name, type, localName, dynamic) {
        (0, $7dKN1._)(this, Coder);
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    (0, $eW5pA._)(Coder, [
        {
            key: "_throwError",
            value: function _throwError(message, value) {
                $70cb18a6832b2ae7$var$logger.throwArgumentError(message, this.localName, value);
            }
        }
    ]);
    return Coder;
}();
var $70cb18a6832b2ae7$export$d7a960146e1a269e = /*#__PURE__*/ function() {
    function Writer(wordSize) {
        (0, $7dKN1._)(this, Writer);
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    (0, $eW5pA._)(Writer, [
        {
            key: "data",
            get: function get() {
                return (0, $a3456dc00c6ba25e$export$6d4b99629b38754a)(this._data);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._dataLength;
            }
        },
        {
            key: "_writeData",
            value: function _writeData(data) {
                this._data.push(data);
                this._dataLength += data.length;
                return data.length;
            }
        },
        {
            key: "appendWriter",
            value: function appendWriter(writer) {
                return this._writeData((0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)(writer._data));
            }
        },
        {
            // Arrayish items; padded on the right to wordSize
            key: "writeBytes",
            value: function writeBytes(value) {
                var bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(value);
                var paddingOffset = bytes.length % this.wordSize;
                if (paddingOffset) bytes = (0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)([
                    bytes,
                    this._padding.slice(paddingOffset)
                ]);
                return this._writeData(bytes);
            }
        },
        {
            key: "_getValue",
            value: function _getValue(value) {
                var bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)((0, $7e88e1c86db60aed$export$d97aa349ed20696).from(value));
                if (bytes.length > this.wordSize) $70cb18a6832b2ae7$var$logger.throwError("value out-of-bounds", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                    length: this.wordSize,
                    offset: bytes.length
                });
                if (bytes.length % this.wordSize) bytes = (0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)([
                    this._padding.slice(bytes.length % this.wordSize),
                    bytes
                ]);
                return bytes;
            }
        },
        {
            // BigNumberish items; padded on the left to wordSize
            key: "writeValue",
            value: function writeValue(value) {
                return this._writeData(this._getValue(value));
            }
        },
        {
            key: "writeUpdatableValue",
            value: function writeUpdatableValue() {
                var _this = this;
                var offset = this._data.length;
                this._data.push(this._padding);
                this._dataLength += this.wordSize;
                return function(value) {
                    _this._data[offset] = _this._getValue(value);
                };
            }
        }
    ]);
    return Writer;
}();
var $70cb18a6832b2ae7$export$2f7a2f0e90c07dc4 = /*#__PURE__*/ function() {
    function Reader(data, wordSize, coerceFunc, allowLoose) {
        (0, $7dKN1._)(this, Reader);
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "_data", (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data));
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "_coerceFunc", coerceFunc);
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    (0, $eW5pA._)(Reader, [
        {
            key: "data",
            get: function get() {
                return (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(this._data);
            }
        },
        {
            key: "consumed",
            get: function get() {
                return this._offset;
            }
        },
        {
            key: "coerce",
            value: function coerce(name, value) {
                if (this._coerceFunc) return this._coerceFunc(name, value);
                return Reader.coerce(name, value);
            }
        },
        {
            key: "_peekBytes",
            value: function _peekBytes(offset, length, loose) {
                var alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
                if (this._offset + alignedLength > this._data.length) {
                    if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
                    else $70cb18a6832b2ae7$var$logger.throwError("data out-of-bounds", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                        length: this._data.length,
                        offset: this._offset + alignedLength
                    });
                }
                return this._data.slice(this._offset, this._offset + alignedLength);
            }
        },
        {
            key: "subReader",
            value: function subReader(offset) {
                return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
            }
        },
        {
            key: "readBytes",
            value: function readBytes(length, loose) {
                var bytes = this._peekBytes(0, length, !!loose);
                this._offset += bytes.length;
                // @TODO: Make sure the length..end bytes are all 0?
                return bytes.slice(0, length);
            }
        },
        {
            key: "readValue",
            value: function readValue() {
                return (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
            }
        }
    ], [
        {
            key: "coerce",
            value: // The default Coerce function
            function coerce(name, value) {
                var match = name.match("^u?int([0-9]+)$");
                if (match && parseInt(match[1]) <= 48) value = value.toNumber();
                return value;
            }
        }
    ]);
    return Reader;
}();



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



"use strict";
var $6ba39b362c857d96$export$59dbbded7775bfe7 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(AddressCoder, Coder);
    var _super = (0, $hKD8n._)(AddressCoder);
    function AddressCoder(localName) {
        (0, $7dKN1._)(this, AddressCoder);
        return _super.call(this, "address", "address", localName, false);
    }
    (0, $eW5pA._)(AddressCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                try {
                    value = (0, $5a4c577f8a12516c$export$88411125f012957a)(value);
                } catch (error) {
                    this._throwError(error.message, value);
                }
                return writer.writeValue(value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $5a4c577f8a12516c$export$88411125f012957a)((0, $a3456dc00c6ba25e$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
            }
        }
    ]);
    return AddressCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

"use strict";
var $06c75ebc5de26304$export$87c41d1139a03fa2 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(AnonymousCoder, Coder);
    var _super = (0, $hKD8n._)(AnonymousCoder);
    function AnonymousCoder(coder) {
        (0, $7dKN1._)(this, AnonymousCoder);
        var _this;
        _this = _super.call(this, coder.name, coder.type, undefined, coder.dynamic);
        _this.coder = coder;
        return _this;
    }
    (0, $eW5pA._)(AnonymousCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return this.coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return this.coder.encode(writer, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return this.coder.decode(reader);
            }
        }
    ]);
    return AnonymousCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));


"use strict";
var $bbaa8cf983c520bb$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $48a45f5b8ab68ce9$export$83d89fbfd8236492));
function $bbaa8cf983c520bb$export$2a703dbb0cb35339(writer, coders, values) {
    var arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        var unique = {};
        arrayValues = coders.map(function(coder) {
            var name = coder.localName;
            if (!name) $bbaa8cf983c520bb$var$logger.throwError("cannot encode object for signature with missing names", (0, $8056241a417d1601$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $bbaa8cf983c520bb$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $8056241a417d1601$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $bbaa8cf983c520bb$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $bbaa8cf983c520bb$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    var staticWriter = new (0, $70cb18a6832b2ae7$export$d7a960146e1a269e)(writer.wordSize);
    var dynamicWriter = new (0, $70cb18a6832b2ae7$export$d7a960146e1a269e)(writer.wordSize);
    var updateFuncs = [];
    coders.forEach(function(coder, index) {
        var value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            var dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            var updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push(function(baseOffset) {
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach(function(func) {
        func(staticWriter.length);
    });
    var length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $bbaa8cf983c520bb$export$417857010dc9287f(reader, coders) {
    var _loop = function(i) {
        var value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
    };
    var values = [];
    // A reader anchored to this base
    var baseReader = reader.subReader(0);
    coders.forEach(function(coder) {
        var value = null;
        if (coder.dynamic) {
            var offset = reader.readValue();
            var offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    var uniqueNames = coders.reduce(function(accum, coder) {
        var name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach(function(coder, index) {
        var name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        var value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
        else values[name] = value;
    });
    for(var i = 0; i < values.length; i++)_loop(i);
    return Object.freeze(values);
}
var $bbaa8cf983c520bb$export$88bc419d2df11f54 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(ArrayCoder, Coder);
    var _super = (0, $hKD8n._)(ArrayCoder);
    function ArrayCoder(coder, length, localName) {
        (0, $7dKN1._)(this, ArrayCoder);
        var _this;
        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        var dynamic = length === -1 || coder.dynamic;
        _this = _super.call(this, "array", type, localName, dynamic);
        _this.coder = coder;
        _this.length = length;
        return _this;
    }
    (0, $eW5pA._)(ArrayCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                // Verifies the child coder is valid (even if the array is dynamic or 0-length)
                var defaultChild = this.coder.defaultValue();
                var result = [];
                for(var i = 0; i < this.length; i++)result.push(defaultChild);
                return result;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (!Array.isArray(value)) this._throwError("expected array value", value);
                var count = this.length;
                if (count === -1) {
                    count = value.length;
                    writer.writeValue(value.length);
                }
                $bbaa8cf983c520bb$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
                var coders = [];
                for(var i = 0; i < value.length; i++)coders.push(this.coder);
                return $bbaa8cf983c520bb$export$2a703dbb0cb35339(writer, coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var count = this.length;
                if (count === -1) {
                    count = reader.readValue().toNumber();
                    // Check that there is *roughly* enough data to ensure
                    // stray random data is not being read as a length. Each
                    // slot requires at least 32 bytes for their value (or 32
                    // bytes as a link to the data). This could use a much
                    // tighter bound, but we are erroring on the side of safety.
                    if (count * 32 > reader._data.length) $bbaa8cf983c520bb$var$logger.throwError("insufficient data length", (0, $8056241a417d1601$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                        length: reader._data.length,
                        count: count
                    });
                }
                var coders = [];
                for(var i = 0; i < count; i++)coders.push(new (0, $06c75ebc5de26304$export$87c41d1139a03fa2)(this.coder));
                return reader.coerce(this.name, $bbaa8cf983c520bb$export$417857010dc9287f(reader, coders));
            }
        }
    ]);
    return ArrayCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

"use strict";
var $11b44428e85525a0$export$fe9118d6c093150c = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(BooleanCoder, Coder);
    var _super = (0, $hKD8n._)(BooleanCoder);
    function BooleanCoder(localName) {
        (0, $7dKN1._)(this, BooleanCoder);
        return _super.call(this, "bool", "bool", localName, false);
    }
    (0, $eW5pA._)(BooleanCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return false;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return writer.writeValue(value ? 1 : 0);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.type, !reader.readValue().isZero());
            }
        }
    ]);
    return BooleanCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $7f85988b8bfb8a76$export$db9eadd8df12ad2e = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(DynamicBytesCoder, Coder);
    var _super = (0, $hKD8n._)(DynamicBytesCoder);
    function DynamicBytesCoder(type, localName) {
        (0, $7dKN1._)(this, DynamicBytesCoder);
        return _super.call(this, type, type, localName, true);
    }
    (0, $eW5pA._)(DynamicBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                value = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(value);
                var length = writer.writeValue(value.length);
                length += writer.writeBytes(value);
                return length;
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.readBytes(reader.readValue().toNumber(), true);
            }
        }
    ]);
    return DynamicBytesCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));
var $7f85988b8bfb8a76$export$e5823e9574df18d2 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $cgJ2Y._)(BytesCoder, DynamicBytesCoder);
    var _super = (0, $hKD8n._)(BytesCoder);
    function BytesCoder(localName) {
        (0, $7dKN1._)(this, BytesCoder);
        return _super.call(this, "bytes", localName);
    }
    (0, $eW5pA._)(BytesCoder, [
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)((0, $2Nfql._)((0, $fG73q._)(BytesCoder.prototype), "decode", this).call(this, reader)));
            }
        }
    ]);
    return BytesCoder;
}($7f85988b8bfb8a76$export$db9eadd8df12ad2e);



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $da38eb37e2477152$export$7dec9db68e6bcf5a = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(FixedBytesCoder, Coder);
    var _super = (0, $hKD8n._)(FixedBytesCoder);
    function FixedBytesCoder(size, localName) {
        (0, $7dKN1._)(this, FixedBytesCoder);
        var _this;
        var name = "bytes" + String(size);
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        return _this;
    }
    (0, $eW5pA._)(FixedBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var data = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(value);
                if (data.length !== this.size) this._throwError("incorrect data length", value);
                return writer.writeBytes(data);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
            }
        }
    ]);
    return FixedBytesCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

"use strict";
var $a6d7e466f7e709c7$export$70982cadf2d6b4ec = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(NullCoder, Coder);
    var _super = (0, $hKD8n._)(NullCoder);
    function NullCoder(localName) {
        (0, $7dKN1._)(this, NullCoder);
        return _super.call(this, "null", "", localName, false);
    }
    (0, $eW5pA._)(NullCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return null;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (value != null) this._throwError("not null", value);
                return writer.writeBytes([]);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                reader.readBytes(0);
                return reader.coerce(this.name, null);
            }
        }
    ]);
    return NullCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


var $fd7b66e3708bbe55$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(-1);
var $fd7b66e3708bbe55$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(0);
var $fd7b66e3708bbe55$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(1);
var $fd7b66e3708bbe55$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(2);
var $fd7b66e3708bbe55$export$c8db55bd7405209e = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from("1000000000000000000");
var $fd7b66e3708bbe55$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var $fd7b66e3708bbe55$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
var $fd7b66e3708bbe55$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $7e88e1c86db60aed$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
var $69822a35e1696b83$export$b934dc8cfe13938c = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(NumberCoder, Coder);
    var _super = (0, $hKD8n._)(NumberCoder);
    function NumberCoder(size, signed, localName) {
        (0, $7dKN1._)(this, NumberCoder);
        var _this;
        var name = (signed ? "int" : "uint") + size * 8;
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        _this.signed = signed;
        return _this;
    }
    (0, $eW5pA._)(NumberCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return 0;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var v = (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(value);
                // Check bounds are safe for encoding
                var maxUintValue = (0, $fd7b66e3708bbe55$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
                if (this.signed) {
                    var bounds = maxUintValue.mask(this.size * 8 - 1);
                    if (v.gt(bounds) || v.lt(bounds.add((0, $fd7b66e3708bbe55$export$9aa05a5866350bcf)).mul((0, $fd7b66e3708bbe55$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
                } else if (v.lt((0, $fd7b66e3708bbe55$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
                v = v.toTwos(this.size * 8).mask(this.size * 8);
                if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
                return writer.writeValue(v);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var value = reader.readValue().mask(this.size * 8);
                if (this.signed) value = value.fromTwos(this.size * 8);
                return reader.coerce(this.name, value);
            }
        }
    ]);
    return NumberCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $b7709eb9721699cf$export$2d1b854518731426 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $cgJ2Y._)(StringCoder, DynamicBytesCoder);
    var _super = (0, $hKD8n._)(StringCoder);
    function StringCoder(localName) {
        (0, $7dKN1._)(this, StringCoder);
        return _super.call(this, "string", localName);
    }
    (0, $eW5pA._)(StringCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $2Nfql._)((0, $fG73q._)(StringCoder.prototype), "encode", this).call(this, writer, (0, $0eea8a441ae5dfe5$export$8feeb310b4b4752f)(value));
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $0eea8a441ae5dfe5$export$7643a1dc2c38d5eb)((0, $2Nfql._)((0, $fG73q._)(StringCoder.prototype), "decode", this).call(this, reader));
            }
        }
    ]);
    return StringCoder;
}((0, $7f85988b8bfb8a76$export$db9eadd8df12ad2e));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $8a028e1cb4330878$export$e9fceba8f110fea6 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(TupleCoder, Coder);
    var _super = (0, $hKD8n._)(TupleCoder);
    function TupleCoder(coders, localName) {
        (0, $7dKN1._)(this, TupleCoder);
        var _this;
        var dynamic = false;
        var types = [];
        coders.forEach(function(coder) {
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        var type = "tuple(" + types.join(",") + ")";
        _this = _super.call(this, "tuple", type, localName, dynamic);
        _this.coders = coders;
        return _this;
    }
    (0, $eW5pA._)(TupleCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                var values = [];
                this.coders.forEach(function(coder) {
                    values.push(coder.defaultValue());
                });
                // We only output named properties for uniquely named coders
                var uniqueNames = this.coders.reduce(function(accum, coder) {
                    var name = coder.localName;
                    if (name) {
                        if (!accum[name]) accum[name] = 0;
                        accum[name]++;
                    }
                    return accum;
                }, {});
                // Add named values
                this.coders.forEach(function(coder, index) {
                    var name = coder.localName;
                    if (!name || uniqueNames[name] !== 1) return;
                    if (name === "length") name = "_length";
                    if (values[name] != null) return;
                    values[name] = values[index];
                });
                return Object.freeze(values);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $bbaa8cf983c520bb$export$2a703dbb0cb35339)(writer, this.coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $bbaa8cf983c520bb$export$417857010dc9287f)(reader, this.coders));
            }
        }
    ]);
    return TupleCoder;
}((0, $70cb18a6832b2ae7$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




"use strict";
var $a0ba291fd93b65f0$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $48a45f5b8ab68ce9$export$83d89fbfd8236492));
var $a0ba291fd93b65f0$var$_constructorGuard = {};
var $a0ba291fd93b65f0$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
var $a0ba291fd93b65f0$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $a0ba291fd93b65f0$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($a0ba291fd93b65f0$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($a0ba291fd93b65f0$var$ModifiersNest[name]) return true;
    }
    if ($a0ba291fd93b65f0$var$ModifiersBytes[name] || name === "payable") $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $a0ba291fd93b65f0$var$parseParamType(param, allowIndexed) {
    var originalParam = param;
    function throwError(i) {
        $a0ba291fd93b65f0$var$logger.throwArgumentError("unexpected character at position ".concat(i), "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        var node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    var parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    var node = parent;
    for(var i = 0; i < param.length; i++){
        var c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $a0ba291fd93b65f0$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($a0ba291fd93b65f0$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $a0ba291fd93b65f0$var$verifyType(node.type);
                var child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($a0ba291fd93b65f0$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $a0ba291fd93b65f0$var$verifyType(node.type);
                var sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $a0ba291fd93b65f0$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($a0ba291fd93b65f0$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $a0ba291fd93b65f0$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($a0ba291fd93b65f0$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $a0ba291fd93b65f0$var$verifyType(parent.type);
    return parent;
}
function $a0ba291fd93b65f0$var$populate(object, params) {
    for(var key in params)(0, $c70bdfd9091def92$export$104236534534f9be)(object, key, params[key]);
}
var $a0ba291fd93b65f0$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
var $a0ba291fd93b65f0$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
var $a0ba291fd93b65f0$export$426dc07f493a4c47 = /*#__PURE__*/ function() {
    function ParamType(constructorGuard, params) {
        (0, $7dKN1._)(this, ParamType);
        if (constructorGuard !== $a0ba291fd93b65f0$var$_constructorGuard) $a0ba291fd93b65f0$var$logger.throwError("use fromString", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $a0ba291fd93b65f0$var$populate(this, params);
        var match = this.type.match($a0ba291fd93b65f0$var$paramTypeArray);
        if (match) $a0ba291fd93b65f0$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: ParamType.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $a0ba291fd93b65f0$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(ParamType, [
        {
            // Format the parameter fragment
            //   - sighash: "(uint256,address)"
            //   - minimal: "tuple(uint256,address) indexed"
            //   - full:    "tuple(uint256 foo, address bar) indexed baz"
            key: "format",
            value: function format(format) {
                if (!format) format = $a0ba291fd93b65f0$export$f010f239efc4d445.sighash;
                if (!$a0ba291fd93b65f0$export$f010f239efc4d445[format]) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.json) {
                    var result = {
                        type: this.baseType === "tuple" ? "tuple" : this.type,
                        name: this.name || undefined
                    };
                    if (typeof this.indexed === "boolean") result.indexed = this.indexed;
                    if (this.components) result.components = this.components.map(function(comp) {
                        return JSON.parse(comp.format(format));
                    });
                    return JSON.stringify(result);
                }
                var result1 = "";
                // Array
                if (this.baseType === "array") {
                    result1 += this.arrayChildren.format(format);
                    result1 += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
                } else if (this.baseType === "tuple") {
                    if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) result1 += this.type;
                    result1 += "(" + this.components.map(function(comp) {
                        return comp.format(format);
                    }).join(format === $a0ba291fd93b65f0$export$f010f239efc4d445.full ? ", " : ",") + ")";
                } else result1 += this.type;
                if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) {
                    if (this.indexed === true) result1 += " indexed";
                    if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.full && this.name) result1 += " " + this.name;
                }
                return result1;
            }
        }
    ], [
        {
            key: "from",
            value: function from(value, allowIndexed) {
                if (typeof value === "string") return ParamType.fromString(value, allowIndexed);
                return ParamType.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ParamType.isParamType(value)) return value;
                return new ParamType($a0ba291fd93b65f0$var$_constructorGuard, {
                    name: value.name || null,
                    type: $a0ba291fd93b65f0$var$verifyType(value.type),
                    indexed: value.indexed == null ? null : !!value.indexed,
                    components: value.components ? value.components.map(ParamType.fromObject) : null
                });
            }
        },
        {
            key: "fromString",
            value: function fromString(value, allowIndexed) {
                function ParamTypify(node) {
                    return ParamType.fromObject({
                        name: node.name,
                        type: node.type,
                        indexed: node.indexed,
                        components: node.components
                    });
                }
                return ParamTypify($a0ba291fd93b65f0$var$parseParamType(value, !!allowIndexed));
            }
        },
        {
            key: "isParamType",
            value: function isParamType(value) {
                return !!(value != null && value._isParamType);
            }
        }
    ]);
    return ParamType;
}();
function $a0ba291fd93b65f0$var$parseParams(value, allowIndex) {
    return $a0ba291fd93b65f0$var$splitNesting(value).map(function(param) {
        return $a0ba291fd93b65f0$export$426dc07f493a4c47.fromString(param, allowIndex);
    });
}
var $a0ba291fd93b65f0$export$ffb0004e005737fa = /*#__PURE__*/ function() {
    function Fragment(constructorGuard, params) {
        (0, $7dKN1._)(this, Fragment);
        if (constructorGuard !== $a0ba291fd93b65f0$var$_constructorGuard) $a0ba291fd93b65f0$var$logger.throwError("use a static from method", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $a0ba291fd93b65f0$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(Fragment, null, [
        {
            key: "from",
            value: function from(value) {
                if (Fragment.isFragment(value)) return value;
                if (typeof value === "string") return Fragment.fromString(value);
                return Fragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (Fragment.isFragment(value)) return value;
                switch(value.type){
                    case "function":
                        return $a0ba291fd93b65f0$export$8d576c928b93668f.fromObject(value);
                    case "event":
                        return $a0ba291fd93b65f0$export$958548f08bac2833.fromObject(value);
                    case "constructor":
                        return $a0ba291fd93b65f0$export$3ac5c9504f801ea4.fromObject(value);
                    case "error":
                        return $a0ba291fd93b65f0$export$2c42c6d543aa9b59.fromObject(value);
                    case "fallback":
                    case "receive":
                        // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                        return null;
                }
                return $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid fragment object", "value", value);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
                value = value.replace(/\s/g, " ");
                value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
                value = value.trim();
                if (value.split(" ")[0] === "event") return $a0ba291fd93b65f0$export$958548f08bac2833.fromString(value.substring(5).trim());
                else if (value.split(" ")[0] === "function") return $a0ba291fd93b65f0$export$8d576c928b93668f.fromString(value.substring(8).trim());
                else if (value.split("(")[0].trim() === "constructor") return $a0ba291fd93b65f0$export$3ac5c9504f801ea4.fromString(value.trim());
                else if (value.split(" ")[0] === "error") return $a0ba291fd93b65f0$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
                return $a0ba291fd93b65f0$var$logger.throwArgumentError("unsupported fragment", "value", value);
            }
        },
        {
            key: "isFragment",
            value: function isFragment(value) {
                return !!(value && value._isFragment);
            }
        }
    ]);
    return Fragment;
}();
var $a0ba291fd93b65f0$export$958548f08bac2833 = /*#__PURE__*/ function(Fragment) {
    (0, $cgJ2Y._)(EventFragment, Fragment);
    var _super = (0, $hKD8n._)(EventFragment);
    function EventFragment() {
        (0, $7dKN1._)(this, EventFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(EventFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $a0ba291fd93b65f0$export$f010f239efc4d445.sighash;
                if (!$a0ba291fd93b65f0$export$f010f239efc4d445[format]) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "event",
                    anonymous: this.anonymous,
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) result += "event ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $a0ba291fd93b65f0$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) {
                    if (this.anonymous) result += "anonymous ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return EventFragment.fromString(value);
                return EventFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (EventFragment.isEventFragment(value)) return value;
                if (value.type !== "event") $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid event object", "value", value);
                var params = {
                    name: $a0ba291fd93b65f0$var$verifyIdentifier(value.name),
                    anonymous: value.anonymous,
                    inputs: value.inputs ? value.inputs.map($a0ba291fd93b65f0$export$426dc07f493a4c47.fromObject) : [],
                    type: "event"
                };
                return new EventFragment($a0ba291fd93b65f0$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var match = value.match($a0ba291fd93b65f0$var$regexParen);
                if (!match) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid event string", "value", value);
                var anonymous = false;
                match[3].split(" ").forEach(function(modifier) {
                    switch(modifier.trim()){
                        case "anonymous":
                            anonymous = true;
                            break;
                        case "":
                            break;
                        default:
                            $a0ba291fd93b65f0$var$logger.warn("unknown modifier: " + modifier);
                    }
                });
                return EventFragment.fromObject({
                    name: match[1].trim(),
                    anonymous: anonymous,
                    inputs: $a0ba291fd93b65f0$var$parseParams(match[2], true),
                    type: "event"
                });
            }
        },
        {
            key: "isEventFragment",
            value: function isEventFragment(value) {
                return value && value._isFragment && value.type === "event";
            }
        }
    ]);
    return EventFragment;
}($a0ba291fd93b65f0$export$ffb0004e005737fa);
function $a0ba291fd93b65f0$var$parseGas(value, params) {
    params.gas = null;
    var comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $a0ba291fd93b65f0$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach(function(modifier) {
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $a0ba291fd93b65f0$var$verifyState(value) {
    var result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $a0ba291fd93b65f0$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $a0ba291fd93b65f0$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $a0ba291fd93b65f0$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $a0ba291fd93b65f0$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $a0ba291fd93b65f0$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
var $a0ba291fd93b65f0$export$3ac5c9504f801ea4 = /*#__PURE__*/ function(Fragment) {
    (0, $cgJ2Y._)(ConstructorFragment, Fragment);
    var _super = (0, $hKD8n._)(ConstructorFragment);
    function ConstructorFragment() {
        (0, $7dKN1._)(this, ConstructorFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(ConstructorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $a0ba291fd93b65f0$export$f010f239efc4d445.sighash;
                if (!$a0ba291fd93b65f0$export$f010f239efc4d445[format]) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "constructor",
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) $a0ba291fd93b65f0$var$logger.throwError("cannot format a constructor for sighash", (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "format(sighash)"
                });
                var result = "constructor(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $a0ba291fd93b65f0$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ConstructorFragment.fromString(value);
                return ConstructorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ConstructorFragment.isConstructorFragment(value)) return value;
                if (value.type !== "constructor") $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid constructor object", "value", value);
                var state = $a0ba291fd93b65f0$var$verifyState(value);
                if (state.constant) $a0ba291fd93b65f0$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
                var params = {
                    name: null,
                    type: value.type,
                    inputs: value.inputs ? value.inputs.map($a0ba291fd93b65f0$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(value.gas) : null
                };
                return new ConstructorFragment($a0ba291fd93b65f0$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "constructor"
                };
                value = $a0ba291fd93b65f0$var$parseGas(value, params);
                var parens = value.match($a0ba291fd93b65f0$var$regexParen);
                if (!parens || parens[1].trim() !== "constructor") $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid constructor string", "value", value);
                params.inputs = $a0ba291fd93b65f0$var$parseParams(parens[2].trim(), false);
                $a0ba291fd93b65f0$var$parseModifiers(parens[3].trim(), params);
                return ConstructorFragment.fromObject(params);
            }
        },
        {
            key: "isConstructorFragment",
            value: function isConstructorFragment(value) {
                return value && value._isFragment && value.type === "constructor";
            }
        }
    ]);
    return ConstructorFragment;
}($a0ba291fd93b65f0$export$ffb0004e005737fa);
var $a0ba291fd93b65f0$export$8d576c928b93668f = /*#__PURE__*/ function(ConstructorFragment) {
    (0, $cgJ2Y._)(FunctionFragment, ConstructorFragment);
    var _super = (0, $hKD8n._)(FunctionFragment);
    function FunctionFragment() {
        (0, $7dKN1._)(this, FunctionFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(FunctionFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $a0ba291fd93b65f0$export$f010f239efc4d445.sighash;
                if (!$a0ba291fd93b65f0$export$f010f239efc4d445[format]) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "function",
                    name: this.name,
                    constant: this.constant,
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    }),
                    outputs: this.outputs.map(function(output) {
                        return JSON.parse(output.format(format));
                    })
                });
                var result = "";
                if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) result += "function ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $a0ba291fd93b65f0$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) {
                    if (this.stateMutability) {
                        if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                    } else if (this.constant) result += "view ";
                    if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map(function(output) {
                        return output.format(format);
                    }).join(", ") + ") ";
                    if (this.gas != null) result += "@" + this.gas.toString() + " ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return FunctionFragment.fromString(value);
                return FunctionFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (FunctionFragment.isFunctionFragment(value)) return value;
                if (value.type !== "function") $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid function object", "value", value);
                var state = $a0ba291fd93b65f0$var$verifyState(value);
                var params = {
                    type: value.type,
                    name: $a0ba291fd93b65f0$var$verifyIdentifier(value.name),
                    constant: state.constant,
                    inputs: value.inputs ? value.inputs.map($a0ba291fd93b65f0$export$426dc07f493a4c47.fromObject) : [],
                    outputs: value.outputs ? value.outputs.map($a0ba291fd93b65f0$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(value.gas) : null
                };
                return new FunctionFragment($a0ba291fd93b65f0$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "function"
                };
                value = $a0ba291fd93b65f0$var$parseGas(value, params);
                var comps = value.split(" returns ");
                if (comps.length > 2) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid function string", "value", value);
                var parens = comps[0].match($a0ba291fd93b65f0$var$regexParen);
                if (!parens) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid function signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $a0ba291fd93b65f0$var$verifyIdentifier(params.name);
                params.inputs = $a0ba291fd93b65f0$var$parseParams(parens[2], false);
                $a0ba291fd93b65f0$var$parseModifiers(parens[3].trim(), params);
                // We have outputs
                if (comps.length > 1) {
                    var returns = comps[1].match($a0ba291fd93b65f0$var$regexParen);
                    if (returns[1].trim() != "" || returns[3].trim() != "") $a0ba291fd93b65f0$var$logger.throwArgumentError("unexpected tokens", "value", value);
                    params.outputs = $a0ba291fd93b65f0$var$parseParams(returns[2], false);
                } else params.outputs = [];
                return FunctionFragment.fromObject(params);
            }
        },
        {
            key: "isFunctionFragment",
            value: function isFunctionFragment(value) {
                return value && value._isFragment && value.type === "function";
            }
        }
    ]);
    return FunctionFragment;
}($a0ba291fd93b65f0$export$3ac5c9504f801ea4);
//export class StructFragment extends Fragment {
//}
function $a0ba291fd93b65f0$var$checkForbidden(fragment) {
    var sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $a0ba291fd93b65f0$var$logger.throwArgumentError("cannot specify user defined ".concat(sig, " error"), "fragment", fragment);
    return fragment;
}
var $a0ba291fd93b65f0$export$2c42c6d543aa9b59 = /*#__PURE__*/ function(Fragment) {
    (0, $cgJ2Y._)(ErrorFragment, Fragment);
    var _super = (0, $hKD8n._)(ErrorFragment);
    function ErrorFragment() {
        (0, $7dKN1._)(this, ErrorFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(ErrorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $a0ba291fd93b65f0$export$f010f239efc4d445.sighash;
                if (!$a0ba291fd93b65f0$export$f010f239efc4d445[format]) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $a0ba291fd93b65f0$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "error",
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $a0ba291fd93b65f0$export$f010f239efc4d445.sighash) result += "error ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $a0ba291fd93b65f0$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ErrorFragment.fromString(value);
                return ErrorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ErrorFragment.isErrorFragment(value)) return value;
                if (value.type !== "error") $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid error object", "value", value);
                var params = {
                    type: value.type,
                    name: $a0ba291fd93b65f0$var$verifyIdentifier(value.name),
                    inputs: value.inputs ? value.inputs.map($a0ba291fd93b65f0$export$426dc07f493a4c47.fromObject) : []
                };
                return $a0ba291fd93b65f0$var$checkForbidden(new ErrorFragment($a0ba291fd93b65f0$var$_constructorGuard, params));
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "error"
                };
                var parens = value.match($a0ba291fd93b65f0$var$regexParen);
                if (!parens) $a0ba291fd93b65f0$var$logger.throwArgumentError("invalid error signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $a0ba291fd93b65f0$var$verifyIdentifier(params.name);
                params.inputs = $a0ba291fd93b65f0$var$parseParams(parens[2], false);
                return $a0ba291fd93b65f0$var$checkForbidden(ErrorFragment.fromObject(params));
            }
        },
        {
            key: "isErrorFragment",
            value: function isErrorFragment(value) {
                return value && value._isFragment && value.type === "error";
            }
        }
    ]);
    return ErrorFragment;
}($a0ba291fd93b65f0$export$ffb0004e005737fa);
function $a0ba291fd93b65f0$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
var $a0ba291fd93b65f0$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $a0ba291fd93b65f0$var$verifyIdentifier(value) {
    if (!value || !value.match($a0ba291fd93b65f0$var$regexIdentifier)) $a0ba291fd93b65f0$var$logger.throwArgumentError('invalid identifier "'.concat(value, '"'), "value", value);
    return value;
}
var $a0ba291fd93b65f0$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $a0ba291fd93b65f0$var$splitNesting(value) {
    value = value.trim();
    var result = [];
    var accum = "";
    var depth = 0;
    for(var offset = 0; offset < value.length; offset++){
        var c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $a0ba291fd93b65f0$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
var $7e86b3fe3b84ca22$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $48a45f5b8ab68ce9$export$83d89fbfd8236492));
var $7e86b3fe3b84ca22$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var $7e86b3fe3b84ca22$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var $7e86b3fe3b84ca22$export$fe041e1a83d3efc6 = /*#__PURE__*/ function _target() {
    function AbiCoder(coerceFunc) {
        (0, $7dKN1._)(this, AbiCoder);
        $7e86b3fe3b84ca22$var$logger.checkNew(this instanceof AbiCoder ? this.constructor : void 0, AbiCoder);
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "coerceFunc", coerceFunc || null);
    }
    (0, $eW5pA._)(AbiCoder, [
        {
            key: "_getCoder",
            value: function _getCoder(param) {
                var _this = this;
                switch(param.baseType){
                    case "address":
                        return new (0, $6ba39b362c857d96$export$59dbbded7775bfe7)(param.name);
                    case "bool":
                        return new (0, $11b44428e85525a0$export$fe9118d6c093150c)(param.name);
                    case "string":
                        return new (0, $b7709eb9721699cf$export$2d1b854518731426)(param.name);
                    case "bytes":
                        return new (0, $7f85988b8bfb8a76$export$e5823e9574df18d2)(param.name);
                    case "array":
                        return new (0, $bbaa8cf983c520bb$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
                    case "tuple":
                        return new (0, $8a028e1cb4330878$export$e9fceba8f110fea6)((param.components || []).map(function(component) {
                            return _this._getCoder(component);
                        }), param.name);
                    case "":
                        return new (0, $a6d7e466f7e709c7$export$70982cadf2d6b4ec)(param.name);
                }
                // u?int[0-9]*
                var match = param.type.match($7e86b3fe3b84ca22$var$paramTypeNumber);
                if (match) {
                    var size = parseInt(match[2] || "256");
                    if (size === 0 || size > 256 || size % 8 !== 0) $7e86b3fe3b84ca22$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
                    return new (0, $69822a35e1696b83$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
                }
                // bytes[0-9]+
                match = param.type.match($7e86b3fe3b84ca22$var$paramTypeBytes);
                if (match) {
                    var size1 = parseInt(match[1]);
                    if (size1 === 0 || size1 > 32) $7e86b3fe3b84ca22$var$logger.throwArgumentError("invalid bytes length", "param", param);
                    return new (0, $da38eb37e2477152$export$7dec9db68e6bcf5a)(size1, param.name);
                }
                return $7e86b3fe3b84ca22$var$logger.throwArgumentError("invalid type", "type", param.type);
            }
        },
        {
            key: "_getWordSize",
            value: function _getWordSize() {
                return 32;
            }
        },
        {
            key: "_getReader",
            value: function _getReader(data, allowLoose) {
                return new (0, $70cb18a6832b2ae7$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
            }
        },
        {
            key: "_getWriter",
            value: function _getWriter() {
                return new (0, $70cb18a6832b2ae7$export$d7a960146e1a269e)(this._getWordSize());
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue(types) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $a0ba291fd93b65f0$export$426dc07f493a4c47).from(type));
                });
                var coder = new (0, $8a028e1cb4330878$export$e9fceba8f110fea6)(coders, "_");
                return coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(types, values) {
                var _this = this;
                if (types.length !== values.length) $7e86b3fe3b84ca22$var$logger.throwError("types/values length mismatch", (0, $8056241a417d1601$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    count: {
                        types: types.length,
                        values: values.length
                    },
                    value: {
                        types: types,
                        values: values
                    }
                });
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $a0ba291fd93b65f0$export$426dc07f493a4c47).from(type));
                });
                var coder = new (0, $8a028e1cb4330878$export$e9fceba8f110fea6)(coders, "_");
                var writer = this._getWriter();
                coder.encode(writer, values);
                return writer.data;
            }
        },
        {
            key: "decode",
            value: function decode(types, data, loose) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $a0ba291fd93b65f0$export$426dc07f493a4c47).from(type));
                });
                var coder = new (0, $8a028e1cb4330878$export$e9fceba8f110fea6)(coders, "_");
                return coder.decode(this._getReader((0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data), loose));
            }
        }
    ]);
    return AbiCoder;
}();
var $7e86b3fe3b84ca22$export$51d1cfcdb913adff = new $7e86b3fe3b84ca22$export$fe041e1a83d3efc6();






"use strict";
var $c5b99c48bb80847a$var$logger = new (0, $8056241a417d1601$export$efa9a398d6368992)((0, $48a45f5b8ab68ce9$export$83d89fbfd8236492));
var $c5b99c48bb80847a$export$c2ab6499be98b3c5 = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(LogDescription, Description);
    var _super = (0, $hKD8n._)(LogDescription);
    function LogDescription() {
        (0, $7dKN1._)(this, LogDescription);
        return _super.apply(this, arguments);
    }
    return LogDescription;
}((0, $c70bdfd9091def92$export$393edc798c47379d));
var $c5b99c48bb80847a$export$7a3223b0fadb690b = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(TransactionDescription, Description);
    var _super = (0, $hKD8n._)(TransactionDescription);
    function TransactionDescription() {
        (0, $7dKN1._)(this, TransactionDescription);
        return _super.apply(this, arguments);
    }
    return TransactionDescription;
}((0, $c70bdfd9091def92$export$393edc798c47379d));
var $c5b99c48bb80847a$export$cfba08fc0e40e2ab = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(ErrorDescription, Description);
    var _super = (0, $hKD8n._)(ErrorDescription);
    function ErrorDescription() {
        (0, $7dKN1._)(this, ErrorDescription);
        return _super.apply(this, arguments);
    }
    return ErrorDescription;
}((0, $c70bdfd9091def92$export$393edc798c47379d));
var $c5b99c48bb80847a$export$8ef99100a3c56f8c = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(Indexed, Description);
    var _super = (0, $hKD8n._)(Indexed);
    function Indexed() {
        (0, $7dKN1._)(this, Indexed);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(Indexed, null, [
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return !!(value && value._isIndexed);
            }
        }
    ]);
    return Indexed;
}((0, $c70bdfd9091def92$export$393edc798c47379d));
var $c5b99c48bb80847a$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $c5b99c48bb80847a$var$wrapAccessError(property, error) {
    var wrap = new Error("deferred error during ABI decoding triggered accessing ".concat(property));
    wrap.error = error;
    return wrap;
}
var $c5b99c48bb80847a$export$48cefb51a4e315b2 = /*#__PURE__*/ function _target() {
    function Interface(fragments) {
        var _this = this;
        (0, $7dKN1._)(this, Interface);
        $c5b99c48bb80847a$var$logger.checkNew(this instanceof Interface ? this.constructor : void 0, Interface);
        var abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "fragments", abi.map(function(fragment) {
            return (0, $a0ba291fd93b65f0$export$ffb0004e005737fa).from(fragment);
        }).filter(function(fragment) {
            return fragment != null;
        }));
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "_abiCoder", (0, $c70bdfd9091def92$export$f695fbbf3cdaaf47)(this instanceof Interface ? this.constructor : void 0, "getAbiCoder")());
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "functions", {});
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "errors", {});
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "events", {});
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach(function(fragment) {
            var bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (_this.deploy) {
                        $c5b99c48bb80847a$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $c70bdfd9091def92$export$104236534534f9be)(_this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = _this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = _this.events;
                    break;
                case "error":
                    bucket = _this.errors;
                    break;
                default:
                    return;
            }
            var signature = fragment.format();
            if (bucket[signature]) {
                $c5b99c48bb80847a$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $c70bdfd9091def92$export$104236534534f9be)(this, "deploy", (0, $a0ba291fd93b65f0$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $c70bdfd9091def92$export$104236534534f9be)(this, "_isInterface", true);
    }
    (0, $eW5pA._)(Interface, [
        {
            key: "format",
            value: function format(_format) {
                if (!_format) _format = (0, $a0ba291fd93b65f0$export$f010f239efc4d445).full;
                if (_format === (0, $a0ba291fd93b65f0$export$f010f239efc4d445).sighash) $c5b99c48bb80847a$var$logger.throwArgumentError("interface does not support formatting sighash", "format", _format);
                var abi = this.fragments.map(function(fragment) {
                    return fragment.format(_format);
                });
                // We need to re-bundle the JSON fragments a bit
                if (_format === (0, $a0ba291fd93b65f0$export$f010f239efc4d445).json) return JSON.stringify(abi.map(function(j) {
                    return JSON.parse(j);
                }));
                return abi;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getFunction",
            value: function getFunction(nameOrSignatureOrSighash) {
                if ((0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
                    for(var name in this.functions){
                        if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
                    }
                    $c5b99c48bb80847a$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.functions).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $c5b99c48bb80847a$var$logger.throwArgumentError("no matching function", "name", name1);
                    else if (matching.length > 1) $c5b99c48bb80847a$var$logger.throwArgumentError("multiple matching functions", "name", name1);
                    return this.functions[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.functions[(0, $a0ba291fd93b65f0$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $c5b99c48bb80847a$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Find an event definition by any means necessary (unless it is ambiguous)
            key: "getEvent",
            value: function getEvent(nameOrSignatureOrTopic) {
                if ((0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
                    var topichash = nameOrSignatureOrTopic.toLowerCase();
                    for(var name in this.events){
                        if (topichash === this.getEventTopic(name)) return this.events[name];
                    }
                    $c5b99c48bb80847a$var$logger.throwArgumentError("no matching event", "topichash", topichash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrTopic.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrTopic.trim();
                    var matching = Object.keys(this.events).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $c5b99c48bb80847a$var$logger.throwArgumentError("no matching event", "name", name1);
                    else if (matching.length > 1) $c5b99c48bb80847a$var$logger.throwArgumentError("multiple matching events", "name", name1);
                    return this.events[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.events[(0, $a0ba291fd93b65f0$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
                if (!result) $c5b99c48bb80847a$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
                return result;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getError",
            value: function getError(nameOrSignatureOrSighash) {
                if ((0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
                    var getSighash = (0, $c70bdfd9091def92$export$f695fbbf3cdaaf47)(this.constructor, "getSighash");
                    for(var name in this.errors){
                        var error = this.errors[name];
                        if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
                    }
                    $c5b99c48bb80847a$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.errors).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $c5b99c48bb80847a$var$logger.throwArgumentError("no matching error", "name", name1);
                    else if (matching.length > 1) $c5b99c48bb80847a$var$logger.throwArgumentError("multiple matching errors", "name", name1);
                    return this.errors[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.errors[(0, $a0ba291fd93b65f0$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $c5b99c48bb80847a$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Get the sighash (the bytes4 selector) used by Solidity to identify a function
            key: "getSighash",
            value: function getSighash(fragment) {
                if (typeof fragment === "string") try {
                    fragment = this.getFunction(fragment);
                } catch (error) {
                    try {
                        fragment = this.getError(fragment);
                    } catch (_) {
                        throw error;
                    }
                }
                return (0, $c70bdfd9091def92$export$f695fbbf3cdaaf47)(this.constructor, "getSighash")(fragment);
            }
        },
        {
            // Get the topic (the bytes32 hash) used by Solidity to identify an event
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                return (0, $c70bdfd9091def92$export$f695fbbf3cdaaf47)(this.constructor, "getEventTopic")(eventFragment);
            }
        },
        {
            key: "_decodeParams",
            value: function _decodeParams(params, data) {
                return this._abiCoder.decode(params, data);
            }
        },
        {
            key: "_encodeParams",
            value: function _encodeParams(params, values) {
                return this._abiCoder.encode(params, values);
            }
        },
        {
            key: "encodeDeploy",
            value: function encodeDeploy(values) {
                return this._encodeParams(this.deploy.inputs, values || []);
            }
        },
        {
            key: "decodeErrorResult",
            value: function decodeErrorResult(fragment, data) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                var bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data);
                if ((0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $c5b99c48bb80847a$var$logger.throwArgumentError("data signature does not match error ".concat(fragment.name, "."), "data", (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(bytes));
                return this._decodeParams(fragment.inputs, bytes.slice(4));
            }
        },
        {
            key: "encodeErrorResult",
            value: function encodeErrorResult(fragment, values) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                return (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)((0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)([
                    this.getSighash(fragment),
                    this._encodeParams(fragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the data for a function call (e.g. tx.data)
            key: "decodeFunctionData",
            value: function decodeFunctionData(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data);
                if ((0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $c5b99c48bb80847a$var$logger.throwArgumentError("data signature does not match function ".concat(functionFragment.name, "."), "data", (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(bytes));
                return this._decodeParams(functionFragment.inputs, bytes.slice(4));
            }
        },
        {
            // Encode the data for a function call (e.g. tx.data)
            key: "encodeFunctionData",
            value: function encodeFunctionData(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)((0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)([
                    this.getSighash(functionFragment),
                    this._encodeParams(functionFragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the result from a function call (e.g. from eth_call)
            key: "decodeFunctionResult",
            value: function decodeFunctionResult(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $a3456dc00c6ba25e$export$3131421a7d01b4fb)(data);
                var reason = null;
                var errorArgs = null;
                var errorName = null;
                var errorSignature = null;
                switch(bytes.length % this._abiCoder._getWordSize()){
                    case 0:
                        try {
                            return this._abiCoder.decode(functionFragment.outputs, bytes);
                        } catch (error) {}
                        break;
                    case 4:
                        {
                            var selector = (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                            var builtin = $c5b99c48bb80847a$var$BuiltinErrors[selector];
                            if (builtin) {
                                errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                                errorName = builtin.name;
                                errorSignature = builtin.signature;
                                if (builtin.reason) reason = errorArgs[0];
                            } else try {
                                var _$error = this.getError(selector);
                                errorArgs = this._abiCoder.decode(_$error.inputs, bytes.slice(4));
                                errorName = _$error.name;
                                errorSignature = _$error.format();
                            } catch (error) {
                                console.log(error);
                            }
                            break;
                        }
                }
                return $c5b99c48bb80847a$var$logger.throwError("call revert exception", (0, $8056241a417d1601$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    method: functionFragment.format(),
                    errorArgs: errorArgs,
                    errorName: errorName,
                    errorSignature: errorSignature,
                    reason: reason
                });
            }
        },
        {
            // Encode the result for a function call (e.g. for eth_call)
            key: "encodeFunctionResult",
            value: function encodeFunctionResult(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
            }
        },
        {
            // Create the filter for the event with search criteria (e.g. for eth_filterLog)
            key: "encodeFilterTopics",
            value: function encodeFilterTopics(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (values.length > eventFragment.inputs.length) $c5b99c48bb80847a$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $8056241a417d1601$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
                    argument: "values",
                    value: values
                });
                var topics = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                var encodeTopic = function(param, value) {
                    if (param.type === "string") return (0, $f80f9215e8493b87$export$d560c7e4a29451c2)(value);
                    else if (param.type === "bytes") return (0, $851ef8e3386cb4de$export$f8151fce47ad1c35)((0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(value));
                    // Check addresses are valid
                    if (param.type === "address") _this._abiCoder.encode([
                        "address"
                    ], [
                        value
                    ]);
                    return (0, $a3456dc00c6ba25e$export$e9c46a54370b47e8)((0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(value), 32);
                };
                values.forEach(function(value, index) {
                    var param = eventFragment.inputs[index];
                    if (!param.indexed) {
                        if (value != null) $c5b99c48bb80847a$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                        return;
                    }
                    if (value == null) topics.push(null);
                    else if (param.baseType === "array" || param.baseType === "tuple") $c5b99c48bb80847a$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
                    else if (Array.isArray(value)) topics.push(value.map(function(value) {
                        return encodeTopic(param, value);
                    }));
                    else topics.push(encodeTopic(param, value));
                });
                // Trim off trailing nulls
                while(topics.length && topics[topics.length - 1] === null)topics.pop();
                return topics;
            }
        },
        {
            key: "encodeEventLog",
            value: function encodeEventLog(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                var topics = [];
                var dataTypes = [];
                var dataValues = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                if (values.length !== eventFragment.inputs.length) $c5b99c48bb80847a$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
                eventFragment.inputs.forEach(function(param, index) {
                    var value = values[index];
                    if (param.indexed) {
                        if (param.type === "string") topics.push((0, $f80f9215e8493b87$export$d560c7e4a29451c2)(value));
                        else if (param.type === "bytes") topics.push((0, $851ef8e3386cb4de$export$f8151fce47ad1c35)(value));
                        else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                        throw new Error("not implemented");
                        else topics.push(_this._abiCoder.encode([
                            param.type
                        ], [
                            value
                        ]));
                    } else {
                        dataTypes.push(param);
                        dataValues.push(value);
                    }
                });
                return {
                    data: this._abiCoder.encode(dataTypes, dataValues),
                    topics: topics
                };
            }
        },
        {
            // Decode a filter for the event and the search criteria
            key: "decodeEventLog",
            value: function decodeEventLog(eventFragment, data, topics) {
                var _loop = function(i) {
                    var value = result[i];
                    if (value instanceof Error) Object.defineProperty(result, i, {
                        enumerable: true,
                        get: function() {
                            throw $c5b99c48bb80847a$var$wrapAccessError("index ".concat(i), value);
                        }
                    });
                };
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (topics != null && !eventFragment.anonymous) {
                    var topicHash = this.getEventTopic(eventFragment);
                    if (!(0, $a3456dc00c6ba25e$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $c5b99c48bb80847a$var$logger.throwError("fragment/topic mismatch", (0, $8056241a417d1601$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                        argument: "topics[0]",
                        expected: topicHash,
                        value: topics[0]
                    });
                    topics = topics.slice(1);
                }
                var indexed = [];
                var nonIndexed = [];
                var dynamic = [];
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                            indexed.push((0, $a0ba291fd93b65f0$export$426dc07f493a4c47).fromObject({
                                type: "bytes32",
                                name: param.name
                            }));
                            dynamic.push(true);
                        } else {
                            indexed.push(param);
                            dynamic.push(false);
                        }
                    } else {
                        nonIndexed.push(param);
                        dynamic.push(false);
                    }
                });
                var resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $a3456dc00c6ba25e$export$ee1b3e54f0441b22)(topics)) : null;
                var resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
                var result = [];
                var nonIndexedIndex = 0, indexedIndex = 0;
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (resultIndexed == null) result[index] = new $c5b99c48bb80847a$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: null
                        });
                        else if (dynamic[index]) result[index] = new $c5b99c48bb80847a$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: resultIndexed[indexedIndex++]
                        });
                        else try {
                            result[index] = resultIndexed[indexedIndex++];
                        } catch (error) {
                            result[index] = error;
                        }
                    } else try {
                        result[index] = resultNonIndexed[nonIndexedIndex++];
                    } catch (error) {
                        result[index] = error;
                    }
                    // Add the keyword argument if named and safe
                    if (param.name && result[param.name] == null) {
                        var value = result[index];
                        // Make error named values throw on access
                        if (value instanceof Error) Object.defineProperty(result, param.name, {
                            enumerable: true,
                            get: function() {
                                throw $c5b99c48bb80847a$var$wrapAccessError("property ".concat(JSON.stringify(param.name)), value);
                            }
                        });
                        else result[param.name] = value;
                    }
                });
                // Make all error indexed values throw on access
                for(var i = 0; i < result.length; i++)_loop(i);
                return Object.freeze(result);
            }
        },
        {
            // Given a transaction, find the matching function fragment (if any) and
            // determine all its properties and call parameters
            key: "parseTransaction",
            value: function parseTransaction(tx) {
                var fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $c5b99c48bb80847a$export$7a3223b0fadb690b({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
                    functionFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment),
                    value: (0, $7e88e1c86db60aed$export$d97aa349ed20696).from(tx.value || "0")
                });
            }
        },
        {
            // @TODO
            //parseCallResult(data: BytesLike): ??
            // Given an event log, find the matching event fragment (if any) and
            // determine all its properties and values
            key: "parseLog",
            value: function parseLog(log) {
                var fragment = this.getEvent(log.topics[0]);
                if (!fragment || fragment.anonymous) return null;
                // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
                //        Probably not, because just because it is the only event in the ABI does
                //        not mean we have the full ABI; maybe just a fragment?
                return new $c5b99c48bb80847a$export$c2ab6499be98b3c5({
                    eventFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    topic: this.getEventTopic(fragment),
                    args: this.decodeEventLog(fragment, log.data, log.topics)
                });
            }
        },
        {
            key: "parseError",
            value: function parseError(data) {
                var hexData = (0, $a3456dc00c6ba25e$export$2b0d6b5fbe698c70)(data);
                var fragment = this.getError(hexData.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $c5b99c48bb80847a$export$cfba08fc0e40e2ab({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
                    errorFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment)
                });
            }
        }
    ], [
        {
            key: "getAbiCoder",
            value: // Sub-classes can override these to handle other blockchains
            function getAbiCoder() {
                return 0, $7e86b3fe3b84ca22$export$51d1cfcdb913adff;
            }
        },
        {
            key: "getAddress",
            value: function getAddress1(address) {
                return (0, $5a4c577f8a12516c$export$88411125f012957a)(address);
            }
        },
        {
            key: "getSighash",
            value: function getSighash(fragment) {
                return (0, $a3456dc00c6ba25e$export$15da666eba198c18)((0, $f80f9215e8493b87$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
            }
        },
        {
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                return (0, $f80f9215e8493b87$export$d560c7e4a29451c2)(eventFragment.format());
            }
        },
        {
            key: "isInterface",
            value: /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ function isInterface(value) {
                return !!(value && value._isInterface);
            }
        }
    ]);
    return Interface;
}();


var $b59a4fd7eaed4b2a$exports = {};

$b59a4fd7eaed4b2a$exports = (parcelRequire("kkCxI"));


var $cd2601fe49fb6c63$var$__assign = undefined && undefined.__assign || function() {
    $cd2601fe49fb6c63$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd2601fe49fb6c63$var$__assign.apply(this, arguments);
};
var $cd2601fe49fb6c63$var$defaultLoadConfig = {
    nftExplorerBaseURL: null,
    pluginBaseURL: "https://cdn.live.ledger.com",
    extraPlugins: null
};
function $cd2601fe49fb6c63$export$be7c4852cecdb879(userLoadConfig) {
    return $cd2601fe49fb6c63$var$__assign($cd2601fe49fb6c63$var$__assign({}, $cd2601fe49fb6c63$var$defaultLoadConfig), userLoadConfig);
}



var $2835e5d96c0148fa$var$__assign = undefined && undefined.__assign || function() {
    $2835e5d96c0148fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2835e5d96c0148fa$var$__assign.apply(this, arguments);
};
var $2835e5d96c0148fa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2835e5d96c0148fa$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2835e5d96c0148fa$export$a16a71980c55ad18 = function loadInfosForContractMethod(contractAddress, selector, chainId, userLoadConfig) {
    return $2835e5d96c0148fa$var$__awaiter(void 0, void 0, void 0, function() {
        var _a, pluginBaseURL, extraPlugins, data, url_1, lcSelector, lcContractAddress, contractSelectors;
        return $2835e5d96c0148fa$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, $cd2601fe49fb6c63$export$be7c4852cecdb879)(userLoadConfig), pluginBaseURL = _a.pluginBaseURL, extraPlugins = _a.extraPlugins;
                    data = {};
                    if (!pluginBaseURL) return [
                        3 /*break*/ ,
                        2
                    ];
                    url_1 = "".concat(pluginBaseURL, "/plugins/ethereum.json");
                    return [
                        4 /*yield*/ ,
                        (0, (/*@__PURE__*/$parcel$interopDefault($b59a4fd7eaed4b2a$exports))).get("".concat(pluginBaseURL, "/plugins/ethereum.json")).then(function(r) {
                            return r.data;
                        })["catch"](function(e) {
                            (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("error", "could not fetch from " + url_1 + ": " + String(e));
                            return null;
                        })
                    ];
                case 1:
                    data = _b.sent();
                    _b.label = 2;
                case 2:
                    if (extraPlugins) data = $2835e5d96c0148fa$var$__assign($2835e5d96c0148fa$var$__assign({}, data), extraPlugins);
                    if (!data) return [
                        2 /*return*/ 
                    ];
                    lcSelector = selector.toLowerCase();
                    lcContractAddress = contractAddress.toLowerCase();
                    if (lcContractAddress in data) {
                        contractSelectors = data[lcContractAddress];
                        if (lcSelector in contractSelectors) return [
                            2 /*return*/ ,
                            {
                                payload: contractSelectors[lcSelector]["serialized_data"],
                                signature: contractSelectors[lcSelector]["signature"],
                                plugin: contractSelectors[lcSelector]["plugin"],
                                erc20OfInterest: contractSelectors[lcSelector]["erc20OfInterest"],
                                abi: contractSelectors["abi"]
                            }
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};


var $81faaafa573d87db$exports = {};
$81faaafa573d87db$exports = "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";



var $ilnag = parcelRequire("ilnag");
var $ee2637306345ec5e$require$Buffer = $ilnag.Buffer;
var $ee2637306345ec5e$export$1fe8702bf9db68fe = function byContractAddressAndChainId(contract, chainId) {
    return $ee2637306345ec5e$var$get().byContractAndChainId($ee2637306345ec5e$var$asContractAddress(contract), chainId);
};
var $ee2637306345ec5e$export$8837f4fc672e936d = function list() {
    return $ee2637306345ec5e$var$get().list();
};
var $ee2637306345ec5e$var$asContractAddress = function asContractAddress(addr) {
    var a = addr.toLowerCase();
    return a.startsWith("0x") ? a : "0x" + a;
};
// this internal get() will lazy load and cache the data from the erc20 data blob
var $ee2637306345ec5e$var$get = function() {
    var cache;
    return function() {
        if (cache) return cache;
        var buf = $ee2637306345ec5e$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($81faaafa573d87db$exports))), "base64");
        var map = {};
        var entries = [];
        var i = 0;
        while(i < buf.length){
            var length_1 = buf.readUInt32BE(i);
            i += 4;
            var item = buf.slice(i, i + length_1);
            var j = 0;
            var tickerLength = item.readUInt8(j);
            j += 1;
            var ticker = item.slice(j, j + tickerLength).toString("ascii");
            j += tickerLength;
            var contractAddress = $ee2637306345ec5e$var$asContractAddress(item.slice(j, j + 20).toString("hex"));
            j += 20;
            var decimals = item.readUInt32BE(j);
            j += 4;
            var chainId = item.readUInt32BE(j);
            j += 4;
            var signature = item.slice(j);
            var entry = {
                ticker: ticker,
                contractAddress: contractAddress,
                decimals: decimals,
                chainId: chainId,
                signature: signature,
                data: item
            };
            entries.push(entry);
            map[String(chainId) + ":" + contractAddress] = entry;
            i += length_1;
        }
        var api = {
            list: function list() {
                return entries;
            },
            byContractAndChainId: function byContractAndChainId(contractAddress, chainId) {
                return map[String(chainId) + ":" + contractAddress];
            }
        };
        cache = api;
        return api;
    };
}();




var $bd284f074e26b846$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bd284f074e26b846$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $bd284f074e26b846$var$axiosErrorHandling(e) {
    if (!e || !e.status) throw e;
    if (e.status === 404) return null;
    throw e;
}
var $bd284f074e26b846$export$1affa857560d4311 = function getNFTInfo(contractAddress, chainId, userLoadConfig) {
    return $bd284f074e26b846$var$__awaiter(void 0, void 0, void 0, function() {
        var nftExplorerBaseURL, url, response, payload, collectionNameLength, collectionNameHex, collectionName;
        var _a;
        return $bd284f074e26b846$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    nftExplorerBaseURL = (0, $cd2601fe49fb6c63$export$be7c4852cecdb879)(userLoadConfig).nftExplorerBaseURL;
                    if (!nftExplorerBaseURL) return [
                        2 /*return*/ 
                    ];
                    url = "".concat(nftExplorerBaseURL, "/").concat(chainId, "/contracts/").concat(contractAddress);
                    return [
                        4 /*yield*/ ,
                        (0, (/*@__PURE__*/$parcel$interopDefault($b59a4fd7eaed4b2a$exports))).get(url).then(function(r) {
                            return r.data;
                        })["catch"]($bd284f074e26b846$var$axiosErrorHandling)
                    ];
                case 1:
                    response = _b.sent();
                    if (!response) return [
                        2 /*return*/ 
                    ];
                    payload = response["payload"];
                    collectionNameLength = parseInt(payload.slice(4, 6), 16);
                    collectionNameHex = payload.substr(6, collectionNameLength * 2);
                    collectionName = (_a = collectionNameHex.match(/.{2}/g) // split every 2 characters
                    ) === null || _a === void 0 ? void 0 : _a.reduce(function(acc, curr) {
                        return acc += String.fromCharCode(parseInt(curr, 16));
                    }, "");
                    return [
                        2 /*return*/ ,
                        {
                            contractAddress: contractAddress,
                            collectionName: collectionName || "",
                            data: payload
                        }
                    ];
            }
        });
    });
};
var $bd284f074e26b846$export$59d9a940c3335886 = function loadNftPlugin(contractAddress, selector, chainId, userLoadConfig) {
    return $bd284f074e26b846$var$__awaiter(void 0, void 0, void 0, function() {
        var nftExplorerBaseURL, url, response, payload;
        return $bd284f074e26b846$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    nftExplorerBaseURL = (0, $cd2601fe49fb6c63$export$be7c4852cecdb879)(userLoadConfig).nftExplorerBaseURL;
                    if (!nftExplorerBaseURL) return [
                        2 /*return*/ 
                    ];
                    url = "".concat(nftExplorerBaseURL, "/").concat(chainId, "/contracts/").concat(contractAddress, "/plugin-selector/").concat(selector);
                    return [
                        4 /*yield*/ ,
                        (0, (/*@__PURE__*/$parcel$interopDefault($b59a4fd7eaed4b2a$exports))).get(url).then(function(r) {
                            return r.data;
                        })["catch"]($bd284f074e26b846$var$axiosErrorHandling)
                    ];
                case 1:
                    response = _a.sent();
                    if (!response) return [
                        2 /*return*/ 
                    ];
                    payload = response["payload"];
                    return [
                        2 /*return*/ ,
                        payload
                    ];
            }
        });
    });
};




var $ilnag = parcelRequire("ilnag");
var $fd117c956f2ba52b$require$Buffer = $ilnag.Buffer;
var $fd117c956f2ba52b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fd117c956f2ba52b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fd117c956f2ba52b$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $fd117c956f2ba52b$var$ledgerService = {
    resolveTransaction: function resolveTransaction(rawTxHex, loadConfig, resolutionConfig) {
        return $fd117c956f2ba52b$var$__awaiter(void 0, void 0, void 0, function() {
            function provideERC20TokenInformation(dataHex) {
                resolution.erc20Tokens.push(dataHex);
            }
            function provideNFTInformation(dataHex) {
                resolution.nfts.push(dataHex);
            }
            function setExternalPlugin(payload, signature) {
                resolution.externalPlugin.push({
                    payload: payload,
                    signature: signature
                });
            }
            function setPlugin(dataHex) {
                resolution.plugin.push(dataHex);
            }
            var resolution, rawTx, _a, decodedTx, chainIdTruncated, provideForContract, selector, nftPluginPayload, _b, infos, _c, plugin, payload, signature, erc20OfInterest, abi, contract, args, erc20OfInterest_1, erc20OfInterest_1_1, path, address, e_1_1;
            var e_1, _d;
            return $fd117c956f2ba52b$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        resolution = {
                            erc20Tokens: [],
                            nfts: [],
                            externalPlugin: [],
                            plugin: []
                        };
                        rawTx = $fd117c956f2ba52b$require$Buffer.from(rawTxHex, "hex");
                        _a = (0, $f6a3edc136b9f477$export$e952eba50b3a65d5)(rawTx), decodedTx = _a.decodedTx, chainIdTruncated = _a.chainIdTruncated;
                        provideForContract = function provideForContract(address) {
                            return $fd117c956f2ba52b$var$__awaiter(void 0, void 0, void 0, function() {
                                var nftInfo, _a, erc20Info;
                                return $fd117c956f2ba52b$var$__generator(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            if (!resolutionConfig.nft) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, $bd284f074e26b846$export$1affa857560d4311)(address, chainIdTruncated, loadConfig)
                                            ];
                                        case 1:
                                            _a = _b.sent();
                                            return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 2:
                                            _a = null;
                                            _b.label = 3;
                                        case 3:
                                            nftInfo = _a;
                                            if (nftInfo) {
                                                (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("ethereum", "loaded nft info for " + nftInfo.contractAddress + " (" + nftInfo.collectionName + ")");
                                                provideNFTInformation(nftInfo.data);
                                            } else {
                                                erc20Info = (0, $ee2637306345ec5e$export$1fe8702bf9db68fe)(address, chainIdTruncated);
                                                if (erc20Info) {
                                                    (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("ethereum", "loaded erc20token info for " + erc20Info.contractAddress + " (" + erc20Info.ticker + ")");
                                                    provideERC20TokenInformation(erc20Info.data.toString("hex"));
                                                }
                                            }
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        if (!(decodedTx.data.length >= 10)) return [
                            3 /*break*/ ,
                            19
                        ];
                        selector = decodedTx.data.substring(0, 10);
                        if (!resolutionConfig.nft) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $bd284f074e26b846$export$59d9a940c3335886)(decodedTx.to, selector, chainIdTruncated, loadConfig)
                        ];
                    case 1:
                        _b = _e.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _b = null;
                        _e.label = 3;
                    case 3:
                        nftPluginPayload = _b;
                        if (!nftPluginPayload) return [
                            3 /*break*/ ,
                            4
                        ];
                        setPlugin(nftPluginPayload);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        if (!resolutionConfig.externalPlugins) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2835e5d96c0148fa$export$a16a71980c55ad18)(decodedTx.to, selector, chainIdTruncated, loadConfig)
                        ];
                    case 5:
                        _c = _e.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        _c = null;
                        _e.label = 7;
                    case 7:
                        infos = _c;
                        if (!infos) return [
                            3 /*break*/ ,
                            16
                        ];
                        plugin = infos.plugin, payload = infos.payload, signature = infos.signature, erc20OfInterest = infos.erc20OfInterest, abi = infos.abi;
                        if (plugin) {
                            (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("ethereum", "found plugin for " + selector);
                            setExternalPlugin(payload, signature);
                        }
                        if (!(erc20OfInterest && erc20OfInterest.length && abi)) return [
                            3 /*break*/ ,
                            15
                        ];
                        contract = new (0, $c5b99c48bb80847a$export$48cefb51a4e315b2)(abi);
                        args = contract.parseTransaction(decodedTx).args;
                        _e.label = 8;
                    case 8:
                        _e.trys.push([
                            8,
                            13,
                            14,
                            15
                        ]);
                        erc20OfInterest_1 = $fd117c956f2ba52b$var$__values(erc20OfInterest), erc20OfInterest_1_1 = erc20OfInterest_1.next();
                        _e.label = 9;
                    case 9:
                        if (!!erc20OfInterest_1_1.done) return [
                            3 /*break*/ ,
                            12
                        ];
                        path = erc20OfInterest_1_1.value;
                        address = path.split(".").reduce(function(value, seg) {
                            if (seg === "-1" && Array.isArray(value)) return value[value.length - 1];
                            return value[seg];
                        }, args);
                        return [
                            4 /*yield*/ ,
                            provideForContract(address)
                        ];
                    case 10:
                        _e.sent();
                        _e.label = 11;
                    case 11:
                        erc20OfInterest_1_1 = erc20OfInterest_1.next();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 12:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 13:
                        e_1_1 = _e.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        try {
                            if (erc20OfInterest_1_1 && !erc20OfInterest_1_1.done && (_d = erc20OfInterest_1["return"])) _d.call(erc20OfInterest_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("ethereum", "no infos for selector " + selector);
                        _e.label = 17;
                    case 17:
                        return [
                            4 /*yield*/ ,
                            provideForContract(decodedTx.to)
                        ];
                    case 18:
                        _e.sent();
                        _e.label = 19;
                    case 19:
                        return [
                            2 /*return*/ ,
                            resolution
                        ];
                }
            });
        });
    }
};
var $fd117c956f2ba52b$export$2e2bcd8739ae039 = $fd117c956f2ba52b$var$ledgerService;


/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ var $df49a17a38678b94$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $df49a17a38678b94$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $df49a17a38678b94$var$errorClasses = {};
var $df49a17a38678b94$var$deserializers = {};
var $df49a17a38678b94$export$ff6248acd0c27a3f = function addCustomErrorDeserializer(name, deserializer) {
    $df49a17a38678b94$var$deserializers[name] = deserializer;
};
var $df49a17a38678b94$export$94baff7bf5134824 = function createCustomErrorClass(name) {
    var CustomErrorClass = /** @class */ function(_super) {
        $df49a17a38678b94$var$__extends(CustomErrorClass, _super);
        function CustomErrorClass(message, fields, options) {
            var _this = // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            _super.call(this, message || name, options) || this;
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(_this, CustomErrorClass.prototype);
            _this.name = name;
            if (fields) for(var k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            _this[k] = fields[k];
            if ($df49a17a38678b94$var$isObject(options) && "cause" in options && !("cause" in _this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                var cause = options.cause;
                _this.cause = cause;
                if ("stack" in cause) _this.stack = _this.stack + "\nCAUSE: " + cause.stack;
            }
            return _this;
        }
        return CustomErrorClass;
    }(Error);
    $df49a17a38678b94$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $df49a17a38678b94$var$isObject(value) {
    return value !== null && typeof value === "object";
}
var $df49a17a38678b94$export$64cddc1e268e9046 = function deserializeError1(object) {
    if (typeof object === "object" && object) {
        try {
            // $FlowFixMe FIXME HACK
            var msg = JSON.parse(object.message);
            if (msg.message && msg.name) object = msg;
        } catch (e) {
        // nothing
        }
        var error = void 0;
        if (typeof object.name === "string") {
            var name_1 = object.name;
            var des = $df49a17a38678b94$var$deserializers[name_1];
            if (des) error = des(object);
            else {
                var constructor = name_1 === "Error" ? Error : $df49a17a38678b94$var$errorClasses[name_1];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name_1 + "'");
                    constructor = $df49a17a38678b94$export$94baff7bf5134824(name_1);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(var prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else error = new Error(object.message);
        if (!error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $df49a17a38678b94$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
var $df49a17a38678b94$export$46ff38bc6bdea8fb = function serializeError(value) {
    if (!value) return value;
    if (typeof value === "object") return $df49a17a38678b94$var$destroyCircular(value, []);
    if (typeof value === "function") return "[Function: ".concat(value.name || "anonymous", "]");
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $df49a17a38678b94$var$destroyCircular(from, seen) {
    var e_1, _a;
    var to = {};
    seen.push(from);
    try {
        for(var _b = $df49a17a38678b94$var$__values(Object.keys(from)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = from[key];
            if (typeof value === "function") continue;
            if (!value || typeof value !== "object") {
                to[key] = value;
                continue;
            }
            if (seen.indexOf(from[key]) === -1) {
                to[key] = $df49a17a38678b94$var$destroyCircular(from[key], seen.slice(0));
                continue;
            }
            to[key] = "[Circular]";
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}


var $2c29c7d2e6f002ec$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2c29c7d2e6f002ec$export$d7dd32b41fc9c3a0 = (0, $df49a17a38678b94$export$94baff7bf5134824)("AccountNameRequired");
var $2c29c7d2e6f002ec$export$fb9db505804530ec = (0, $df49a17a38678b94$export$94baff7bf5134824)("AccountNotSupported");
var $2c29c7d2e6f002ec$export$c9d6bf2b06944665 = (0, $df49a17a38678b94$export$94baff7bf5134824)("AmountRequired");
var $2c29c7d2e6f002ec$export$2628fce2396c23c2 = (0, $df49a17a38678b94$export$94baff7bf5134824)("BluetoothRequired");
var $2c29c7d2e6f002ec$export$75f8b0767ef406f1 = (0, $df49a17a38678b94$export$94baff7bf5134824)("BtcUnmatchedApp");
var $2c29c7d2e6f002ec$export$f60aa84fd00bc3ee = (0, $df49a17a38678b94$export$94baff7bf5134824)("CantOpenDevice");
var $2c29c7d2e6f002ec$export$fc0260506e4022ab = (0, $df49a17a38678b94$export$94baff7bf5134824)("CashAddrNotSupported");
var $2c29c7d2e6f002ec$export$e0b1ec53ba36e221 = (0, $df49a17a38678b94$export$94baff7bf5134824)("CurrencyNotSupported");
var $2c29c7d2e6f002ec$export$fa9aacd48d3a45c2 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceAppVerifyNotSupported");
var $2c29c7d2e6f002ec$export$f21ce806524ab8d4 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceGenuineSocketEarlyClose");
var $2c29c7d2e6f002ec$export$9c30dc6872fcd74c = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceNotGenuine");
var $2c29c7d2e6f002ec$export$1d5ae41b109edf1f = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceOnDashboardExpected");
var $2c29c7d2e6f002ec$export$8eecf64ec9a8cfd7 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceOnDashboardUnexpected");
var $2c29c7d2e6f002ec$export$a5e2071f1ac48fdd = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceInOSUExpected");
var $2c29c7d2e6f002ec$export$3be6e7231165f4ac = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceHalted");
var $2c29c7d2e6f002ec$export$fa7bfae6dce03474 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceNameInvalid");
var $2c29c7d2e6f002ec$export$bcce4e5aded80ca0 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceSocketFail");
var $2c29c7d2e6f002ec$export$944a0f9a7cc1e03a = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
var $2c29c7d2e6f002ec$export$1e42f3936938e063 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DisconnectedDevice");
var $2c29c7d2e6f002ec$export$2a60f41a2ed2742 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DisconnectedDeviceDuringOperation");
var $2c29c7d2e6f002ec$export$93e2040d8e24d646 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceExtractOnboardingStateError");
var $2c29c7d2e6f002ec$export$e6aaf90bcb4b2013 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceOnboardingStatePollingError");
var $2c29c7d2e6f002ec$export$cfbd0adf8f9fdaf9 = (0, $df49a17a38678b94$export$94baff7bf5134824)("EnpointConfig");
var $2c29c7d2e6f002ec$export$96d8d3c501f1625 = (0, $df49a17a38678b94$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
var $2c29c7d2e6f002ec$export$37b49553b7172cb1 = (0, $df49a17a38678b94$export$94baff7bf5134824)("FeeEstimationFailed");
var $2c29c7d2e6f002ec$export$d00fd6c398a70fd9 = (0, $df49a17a38678b94$export$94baff7bf5134824)("FirmwareNotRecognized");
var $2c29c7d2e6f002ec$export$3dc3bbf8c134219c = (0, $df49a17a38678b94$export$94baff7bf5134824)("HardResetFail");
var $2c29c7d2e6f002ec$export$5e8f7ae1054a2777 = (0, $df49a17a38678b94$export$94baff7bf5134824)("InvalidXRPTag");
var $2c29c7d2e6f002ec$export$953b602d2269ceba = (0, $df49a17a38678b94$export$94baff7bf5134824)("InvalidAddress");
var $2c29c7d2e6f002ec$export$bbdaf7c77a7508eb = (0, $df49a17a38678b94$export$94baff7bf5134824)("InvalidAddressBecauseDestinationIsAlsoSource");
var $2c29c7d2e6f002ec$export$882967e2980534f9 = (0, $df49a17a38678b94$export$94baff7bf5134824)("LatestMCUInstalledError");
var $2c29c7d2e6f002ec$export$59772a13ac97df0e = (0, $df49a17a38678b94$export$94baff7bf5134824)("UnknownMCU");
var $2c29c7d2e6f002ec$export$26bf4f7c63d50901 = (0, $df49a17a38678b94$export$94baff7bf5134824)("LedgerAPIError");
var $2c29c7d2e6f002ec$export$fdab6afd1b1820af = (0, $df49a17a38678b94$export$94baff7bf5134824)("LedgerAPIErrorWithMessage");
var $2c29c7d2e6f002ec$export$c2996b38942cf758 = (0, $df49a17a38678b94$export$94baff7bf5134824)("LedgerAPINotAvailable");
var $2c29c7d2e6f002ec$export$3d81abcc61613a27 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerAppAlreadyInstalled");
var $2c29c7d2e6f002ec$export$87a9bff9fff141e2 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerAppRelyOnBTC");
var $2c29c7d2e6f002ec$export$86581a722c4238c0 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerAppDepInstallRequired");
var $2c29c7d2e6f002ec$export$267a8476044885dd = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerAppDepUninstallRequired");
var $2c29c7d2e6f002ec$export$bb771ca417eca344 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerDeviceLocked");
var $2c29c7d2e6f002ec$export$b634ce25e3ff5229 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerFirmwareNotEnoughSpace");
var $2c29c7d2e6f002ec$export$2d26f4eadfe37285 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerNotEnoughSpace");
var $2c29c7d2e6f002ec$export$ceb7f9bef5a1e481 = (0, $df49a17a38678b94$export$94baff7bf5134824)("ManagerUninstallBTCDep");
var $2c29c7d2e6f002ec$export$baadb6886fde1621 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NetworkDown");
var $2c29c7d2e6f002ec$export$5cbfa0659f97216a = (0, $df49a17a38678b94$export$94baff7bf5134824)("NoAddressesFound");
var $2c29c7d2e6f002ec$export$9e00aead3515e5c9 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotEnoughBalance");
var $2c29c7d2e6f002ec$export$5ed90e0e011f4857 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotEnoughBalanceToDelegate");
var $2c29c7d2e6f002ec$export$75178c95e66d9630 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotEnoughBalanceInParentAccount");
var $2c29c7d2e6f002ec$export$e3e2865b29f7e0b0 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotEnoughSpendableBalance");
var $2c29c7d2e6f002ec$export$a84b3634866707ea = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotEnoughBalanceBecauseDestinationNotCreated");
var $2c29c7d2e6f002ec$export$a282f858b69a7326 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NoAccessToCamera");
var $2c29c7d2e6f002ec$export$5111c405c5cacc97 = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotEnoughGas");
var $2c29c7d2e6f002ec$export$626e1fd20d22139c = (0, $df49a17a38678b94$export$94baff7bf5134824)("NotSupportedLegacyAddress");
var $2c29c7d2e6f002ec$export$f919e2c9c746346b = (0, $df49a17a38678b94$export$94baff7bf5134824)("GasLessThanEstimate");
var $2c29c7d2e6f002ec$export$22c5aa8937c5b423 = (0, $df49a17a38678b94$export$94baff7bf5134824)("PasswordsDontMatch");
var $2c29c7d2e6f002ec$export$f57670cd1aaf386 = (0, $df49a17a38678b94$export$94baff7bf5134824)("PasswordIncorrect");
var $2c29c7d2e6f002ec$export$3ba22bf10deb1448 = (0, $df49a17a38678b94$export$94baff7bf5134824)("RecommendSubAccountsToEmpty");
var $2c29c7d2e6f002ec$export$33f73085e1b7871b = (0, $df49a17a38678b94$export$94baff7bf5134824)("RecommendUndelegation");
var $2c29c7d2e6f002ec$export$cd4d967a66d81060 = (0, $df49a17a38678b94$export$94baff7bf5134824)("TimeoutTagged");
var $2c29c7d2e6f002ec$export$9375635756d6156e = (0, $df49a17a38678b94$export$94baff7bf5134824)("UnexpectedBootloader");
var $2c29c7d2e6f002ec$export$90478a5d08d6c2d7 = (0, $df49a17a38678b94$export$94baff7bf5134824)("MCUNotGenuineToDashboard");
var $2c29c7d2e6f002ec$export$132f0197eaa65535 = (0, $df49a17a38678b94$export$94baff7bf5134824)("RecipientRequired");
var $2c29c7d2e6f002ec$export$7aee729193ab77ba = (0, $df49a17a38678b94$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountReceive");
var $2c29c7d2e6f002ec$export$4ec11dc947a3c9d6 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountSend");
var $2c29c7d2e6f002ec$export$5e3ed85b946872a1 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UpdateFetchFileFail");
var $2c29c7d2e6f002ec$export$5db6383ad081f01e = (0, $df49a17a38678b94$export$94baff7bf5134824)("UpdateIncorrectHash");
var $2c29c7d2e6f002ec$export$92c199eb837d8df8 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UpdateIncorrectSig");
var $2c29c7d2e6f002ec$export$85e0c017833c894c = (0, $df49a17a38678b94$export$94baff7bf5134824)("UpdateYourApp");
var $2c29c7d2e6f002ec$export$84115f1b54c874b3 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UserRefusedDeviceNameChange");
var $2c29c7d2e6f002ec$export$3f4864efb1638333 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UserRefusedAddress");
var $2c29c7d2e6f002ec$export$d777e0ef77faca34 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UserRefusedFirmwareUpdate");
var $2c29c7d2e6f002ec$export$3d8a4f08cd3eb133 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UserRefusedAllowManager");
var $2c29c7d2e6f002ec$export$db9b724c3524b5d6 = (0, $df49a17a38678b94$export$94baff7bf5134824)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
var $2c29c7d2e6f002ec$export$9642f061c2494239 = (0, $df49a17a38678b94$export$94baff7bf5134824)("TransportOpenUserCancelled");
var $2c29c7d2e6f002ec$export$fd71e3a51c4bf0ae = (0, $df49a17a38678b94$export$94baff7bf5134824)("TransportInterfaceNotAvailable");
var $2c29c7d2e6f002ec$export$d6cb63cda2c2b2a4 = (0, $df49a17a38678b94$export$94baff7bf5134824)("TransportRaceCondition");
var $2c29c7d2e6f002ec$export$c0ffbdd94649bd06 = (0, $df49a17a38678b94$export$94baff7bf5134824)("TransportWebUSBGestureRequired");
var $2c29c7d2e6f002ec$export$4800af3cc6204928 = (0, $df49a17a38678b94$export$94baff7bf5134824)("DeviceShouldStayInApp");
var $2c29c7d2e6f002ec$export$101490ec073327e1 = (0, $df49a17a38678b94$export$94baff7bf5134824)("WebsocketConnectionError");
var $2c29c7d2e6f002ec$export$219228963d86b069 = (0, $df49a17a38678b94$export$94baff7bf5134824)("WebsocketConnectionFailed");
var $2c29c7d2e6f002ec$export$25b49ca0efdfe5d1 = (0, $df49a17a38678b94$export$94baff7bf5134824)("WrongDeviceForAccount");
var $2c29c7d2e6f002ec$export$63498b46122d8a23 = (0, $df49a17a38678b94$export$94baff7bf5134824)("WrongAppForCurrency");
var $2c29c7d2e6f002ec$export$707f317a4761c46d = (0, $df49a17a38678b94$export$94baff7bf5134824)("ETHAddressNonEIP");
var $2c29c7d2e6f002ec$export$a5d8da2f27618c16 = (0, $df49a17a38678b94$export$94baff7bf5134824)("CantScanQRCode");
var $2c29c7d2e6f002ec$export$3f2d8a7775aab6cc = (0, $df49a17a38678b94$export$94baff7bf5134824)("FeeNotLoaded");
var $2c29c7d2e6f002ec$export$ffbf6641e9ab88d3 = (0, $df49a17a38678b94$export$94baff7bf5134824)("FeeRequired");
var $2c29c7d2e6f002ec$export$53e797c2fa09aff3 = (0, $df49a17a38678b94$export$94baff7bf5134824)("FeeTooHigh");
var $2c29c7d2e6f002ec$export$cb0b645e3d7170ab = (0, $df49a17a38678b94$export$94baff7bf5134824)("PendingOperation");
var $2c29c7d2e6f002ec$export$2aca4567d80fd933 = (0, $df49a17a38678b94$export$94baff7bf5134824)("SyncError");
var $2c29c7d2e6f002ec$export$a2d6658d365c43df = (0, $df49a17a38678b94$export$94baff7bf5134824)("PairingFailed");
var $2c29c7d2e6f002ec$export$3f7ba18f3c84cced = (0, $df49a17a38678b94$export$94baff7bf5134824)("GenuineCheckFailed");
var $2c29c7d2e6f002ec$export$437e6aac14cab3d9 = (0, $df49a17a38678b94$export$94baff7bf5134824)("LedgerAPI4xx");
var $2c29c7d2e6f002ec$export$309835543e52bf92 = (0, $df49a17a38678b94$export$94baff7bf5134824)("LedgerAPI5xx");
var $2c29c7d2e6f002ec$export$c282cdb2f7fdc27a = (0, $df49a17a38678b94$export$94baff7bf5134824)("FirmwareOrAppUpdateRequired");
var $2c29c7d2e6f002ec$export$28f62a162580c9c2 = (0, $df49a17a38678b94$export$94baff7bf5134824)("LanguageNotFound");
var $2c29c7d2e6f002ec$export$d3cadb9f4e1fa40d = (0, $df49a17a38678b94$export$94baff7bf5134824)("NoDBPathGiven");
var $2c29c7d2e6f002ec$export$de46c919e379f03f = (0, $df49a17a38678b94$export$94baff7bf5134824)("DBWrongPassword");
var $2c29c7d2e6f002ec$export$e1c94c135b0a553e = (0, $df49a17a38678b94$export$94baff7bf5134824)("DBNotReset");
/**
 * TransportError is used for any generic transport errors.
 * e.g. Error thrown when data received by exchanges are incorrect or if exchanged failed to communicate with the device for various reason.
 */ var $2c29c7d2e6f002ec$export$8e68de6fb26f2236 = /** @class */ function(_super) {
    $2c29c7d2e6f002ec$var$__extends(TransportError, _super);
    function TransportError(message, id) {
        var _this = this;
        var name = "TransportError";
        _this = _super.call(this, message || name) || this;
        _this.name = name;
        _this.message = message;
        _this.stack = new Error().stack;
        _this.id = id;
        return _this;
    }
    return TransportError;
}(Error);
(0, $df49a17a38678b94$export$ff6248acd0c27a3f)("TransportError", function(e) {
    return new $2c29c7d2e6f002ec$export$8e68de6fb26f2236(e.message, e.id);
});
var $2c29c7d2e6f002ec$export$efd5569f873811b1 = {
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    INCORRECT_LENGTH: 0x6700,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    INCORRECT_DATA: 0x6a80,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    FILE_ALREADY_EXISTS: 0x6a89,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    CLA_NOT_SUPPORTED: 0x6e00,
    TECHNICAL_PROBLEM: 0x6f00,
    OK: 0x9000,
    MEMORY_PROBLEM: 0x9240,
    NO_EF_SELECTED: 0x9400,
    INVALID_OFFSET: 0x9402,
    FILE_NOT_FOUND: 0x9404,
    INCONSISTENT_FILE: 0x9408,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    INVALID_KCV: 0x9485,
    CODE_NOT_INITIALIZED: 0x9802,
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CONTRADICTION_INVALIDATION: 0x9810,
    CODE_BLOCKED: 0x9840,
    MAX_VALUE_REACHED: 0x9850,
    GP_AUTH_FAILED: 0x6300,
    LICENSING: 0x6f42,
    HALTED: 0x6faa
};
function $2c29c7d2e6f002ec$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
function $2c29c7d2e6f002ec$export$78917f4716d96cfe(statusCode) {
    this.name = "TransportStatusError";
    var statusText = Object.keys($2c29c7d2e6f002ec$export$efd5569f873811b1).find(function(k) {
        return $2c29c7d2e6f002ec$export$efd5569f873811b1[k] === statusCode;
    }) || "UNKNOWN_ERROR";
    var smsg = $2c29c7d2e6f002ec$export$799566c03457ebd5(statusCode) || statusText;
    var statusCodeStr = statusCode.toString(16);
    this.message = "Ledger device: ".concat(smsg, " (0x").concat(statusCodeStr, ")");
    this.stack = new Error().stack;
    this.statusCode = statusCode;
    this.statusText = statusText;
}
$2c29c7d2e6f002ec$export$78917f4716d96cfe.prototype = new Error();
(0, $df49a17a38678b94$export$ff6248acd0c27a3f)("TransportStatusError", function(e) {
    return new $2c29c7d2e6f002ec$export$78917f4716d96cfe(e.statusCode);
});


var $6e45af695d24937b$export$96d8d3c501f1625 = (0, $df49a17a38678b94$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
var $6e45af695d24937b$export$4876e60a0029a81c = (0, $df49a17a38678b94$export$94baff7bf5134824)("EthAppNftNotSupported");





var $ilnag = parcelRequire("ilnag");
var $305b6c00bc71328c$require$Buffer = $ilnag.Buffer;
var $305b6c00bc71328c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $305b6c00bc71328c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @ignore for the README
 *
 * A Map of helpers to get the wanted binary value for
 * each type of array possible in a type definition
 */ var $305b6c00bc71328c$var$EIP712_ARRAY_TYPE_VALUE;
(function(EIP712_ARRAY_TYPE_VALUE) {
    EIP712_ARRAY_TYPE_VALUE[EIP712_ARRAY_TYPE_VALUE["DYNAMIC"] = 0] = "DYNAMIC";
    EIP712_ARRAY_TYPE_VALUE[EIP712_ARRAY_TYPE_VALUE["FIXED"] = 1] = "FIXED";
})($305b6c00bc71328c$var$EIP712_ARRAY_TYPE_VALUE || ($305b6c00bc71328c$var$EIP712_ARRAY_TYPE_VALUE = {}));
var $305b6c00bc71328c$export$aa47ac0ee53419e2 = {
    CUSTOM: {
        key: function key() {
            return 0;
        },
        sizeInBits: function sizeInBits() {
            return null;
        }
    },
    INT: {
        key: function key() {
            return 1;
        },
        sizeInBits: function sizeInBits(size) {
            return Number(size) / 8;
        }
    },
    UINT: {
        key: function key() {
            return 2;
        },
        sizeInBits: function sizeInBits(size) {
            return Number(size) / 8;
        }
    },
    ADDRESS: {
        key: function key() {
            return 3;
        },
        sizeInBits: function sizeInBits() {
            return null;
        }
    },
    BOOL: {
        key: function key() {
            return 4;
        },
        sizeInBits: function sizeInBits() {
            return null;
        }
    },
    STRING: {
        key: function key() {
            return 5;
        },
        sizeInBits: function sizeInBits() {
            return null;
        }
    },
    BYTES: {
        key: function key(size) {
            return typeof size !== "undefined" ? 6 : 7;
        },
        sizeInBits: function sizeInBits(size) {
            return typeof size !== "undefined" ? Number(size) : null;
        }
    }
};
var $305b6c00bc71328c$export$e370b40e9c7fb0f = {
    INT: function INT(value) {
        var failSafeValue = value !== null && value !== void 0 ? value : 0;
        if (typeof failSafeValue === "string" && (failSafeValue === null || failSafeValue === void 0 ? void 0 : failSafeValue.startsWith("0x"))) return (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(failSafeValue);
        var valueAsInt = typeof failSafeValue === "string" ? parseInt(failSafeValue, 10) : failSafeValue;
        var valueAsHexString = valueAsInt.toString(16);
        var paddedHexString = valueAsHexString.length % 2 ? "0" + valueAsHexString : valueAsHexString;
        return $305b6c00bc71328c$require$Buffer.from(paddedHexString, "hex");
    },
    UINT: function UINT(value) {
        return this.INT(value);
    },
    BOOL: function BOOL(value) {
        return this.INT(typeof value === "boolean" ? Number(value) : value);
    },
    ADDRESS: function ADDRESS(value) {
        // Only sending the first 10 bytes (why ?)
        return (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(value !== null && value !== void 0 ? value : "").slice(0, 20);
    },
    STRING: function STRING(value) {
        return $305b6c00bc71328c$require$Buffer.from(value !== null && value !== void 0 ? value : "", "utf-8");
    },
    BYTES: function BYTES(value, sizeInBits) {
        var failSafeValue = value !== null && value !== void 0 ? value : "";
        // Why slice again ?
        return (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(failSafeValue).slice(0, sizeInBits !== null && sizeInBits !== void 0 ? sizeInBits : ((failSafeValue === null || failSafeValue === void 0 ? void 0 : failSafeValue.length) - 2) / 2);
    }
};
var $305b6c00bc71328c$export$598f26315e73345b = function destructTypeFromString(typeName) {
    // Will split "any[][1][10]" in "any", "[][1][10]"
    var splitNameAndArraysRegex = new RegExp(/^([^[\]]*)(\[.*\])*/g);
    // Will match all numbers (or null) inside each array. [0][10][] => [0,10,null]
    var splitArraysRegex = new RegExp(/\[(\d*)\]/g);
    // Will separate the the name from the potential bits allocation. uint8 => [uint,8]
    var splitNameAndNumberRegex = new RegExp(/(\D*)(\d*)/);
    var _a = $305b6c00bc71328c$var$__read(splitNameAndArraysRegex.exec(typeName || "") || [], 3), type = _a[1], maybeArrays = _a[2];
    var _b = $305b6c00bc71328c$var$__read(splitNameAndNumberRegex.exec(type || "") || [], 3), name = _b[1], bits = _b[2];
    var typeDescription = name ? {
        name: name,
        bits: bits ? Number(bits) : undefined
    } : null;
    var arrays = maybeArrays ? $305b6c00bc71328c$var$__spreadArray([], $305b6c00bc71328c$var$__read(maybeArrays.matchAll(splitArraysRegex)), false) : [];
    // Parse each size to either a Number or null
    var arraySizes = arrays.map(function(_a) {
        var _b = $305b6c00bc71328c$var$__read(_a, 2), size = _b[1];
        return size ? Number(size) : null;
    });
    return [
        typeDescription,
        arraySizes
    ];
};
var $305b6c00bc71328c$export$dcd6ab1d1c2c7706 = function constructTypeDescByteString(isArray, typeSize, typeValue) {
    if (typeValue >= 16) throw new Error("Eth utils - constructTypeDescByteString - Cannot accept a typeValue >= 16 because the typeValue can only be 4 bits in binary[object Object]");
    // 1 is array, 0 is not array
    var isArrayBit = isArray ? "1" : "0";
    // 1 has type size, 0 has no type size
    var hasTypeSize = typeof typeSize === "number" ? "1" : "0";
    // 2 unused bits
    var unusedBits = "00";
    // type key as 4 bits
    var typeValueBits = typeValue.toString(2).padStart(4, "0");
    return (0, $f6a3edc136b9f477$export$64ed265a1cd37072)(parseInt(isArrayBit + hasTypeSize + unusedBits + typeValueBits, 2), 1);
};
var $305b6c00bc71328c$export$7c191342f3ed2438 = function makeTypeEntryStructBuffer(_a) {
    var _b, _c, _d, _e;
    var name = _a.name, type = _a.type;
    var _f = $305b6c00bc71328c$var$__read($305b6c00bc71328c$export$598f26315e73345b(type), 2), typeDescription = _f[0], arrSizes = _f[1];
    var isTypeAnArray = Boolean(arrSizes.length);
    var typeProperties = $305b6c00bc71328c$export$aa47ac0ee53419e2[((_b = typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ""] || $305b6c00bc71328c$export$aa47ac0ee53419e2.CUSTOM;
    var typeKey = typeProperties.key(typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.bits);
    var typeSizeInBits = typeProperties.sizeInBits(typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.bits);
    var typeDescData = $305b6c00bc71328c$export$dcd6ab1d1c2c7706(isTypeAnArray, typeSizeInBits, typeKey);
    var bufferArray = [
        $305b6c00bc71328c$require$Buffer.from(typeDescData, "hex")
    ];
    if (typeProperties === $305b6c00bc71328c$export$aa47ac0ee53419e2.CUSTOM) {
        bufferArray.push($305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)((_d = (_c = typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0, 1), "hex"));
        bufferArray.push($305b6c00bc71328c$require$Buffer.from((_e = typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) !== null && _e !== void 0 ? _e : "", "utf-8"));
    }
    if (typeof typeSizeInBits === "number") bufferArray.push($305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(typeSizeInBits, 1), "hex"));
    if (isTypeAnArray) {
        bufferArray.push($305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(arrSizes.length, 1), "hex"));
        arrSizes.forEach(function(size) {
            if (typeof size === "number") bufferArray.push($305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)($305b6c00bc71328c$var$EIP712_ARRAY_TYPE_VALUE.FIXED, 1), "hex"), $305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(size, 1), "hex"));
            else bufferArray.push($305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)($305b6c00bc71328c$var$EIP712_ARRAY_TYPE_VALUE.DYNAMIC, 1), "hex"));
        });
    }
    bufferArray.push($305b6c00bc71328c$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(name.length, 1), "hex"), $305b6c00bc71328c$require$Buffer.from(name, "utf-8"));
    return $305b6c00bc71328c$require$Buffer.concat(bufferArray);
};
function $305b6c00bc71328c$export$50f8d4986fc98b76(message) {
    return "types" in message && "primaryType" in message && "domain" in message && "message" in message;
}



var $ilnag = parcelRequire("ilnag");
var $9cfdda3ebf838156$require$Buffer = $ilnag.Buffer;
var $9cfdda3ebf838156$var$__assign = undefined && undefined.__assign || function() {
    $9cfdda3ebf838156$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9cfdda3ebf838156$var$__assign.apply(this, arguments);
};
var $9cfdda3ebf838156$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9cfdda3ebf838156$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9cfdda3ebf838156$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9cfdda3ebf838156$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @ignore for the README
 *
 * Factory to create the recursive function that will pass on each
 * field level and APDUs to describe its structure implementation
 *
 * @param {Eth["EIP712SendStructImplem"]} EIP712SendStructImplem
 * @param {EIP712MessageTypes} types
 * @returns {void}
 */ var $9cfdda3ebf838156$var$makeRecursiveFieldStructImplem = function makeRecursiveFieldStructImplem(transport, types) {
    var _a;
    var typesMap = {};
    for(var type in types)typesMap[type] = (_a = types[type]) === null || _a === void 0 ? void 0 : _a.reduce(function(acc, curr) {
        var _a;
        return $9cfdda3ebf838156$var$__assign($9cfdda3ebf838156$var$__assign({}, acc), (_a = {}, _a[curr.name] = curr.type, _a));
    }, {});
    // This recursion will call itself to handle each level of each field
    // in order to send APDUs for each of them
    var recursiveFieldStructImplem = function recursiveFieldStructImplem1(destructedType, data) {
        return $9cfdda3ebf838156$var$__awaiter(void 0, void 0, void 0, function() {
            var _a, typeDescription, arrSizes, _b, currSize, restSizes, isCustomType, data_1, data_1_1, entry, e_1_1, _c, _d, _e, fieldName, fieldValue, fieldType, e_2_1;
            var e_1, _f, e_2, _g;
            var _h;
            return $9cfdda3ebf838156$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        _a = $9cfdda3ebf838156$var$__read(destructedType, 2), typeDescription = _a[0], arrSizes = _a[1];
                        _b = $9cfdda3ebf838156$var$__read(arrSizes), currSize = _b[0], restSizes = _b.slice(1);
                        isCustomType = !(0, $305b6c00bc71328c$export$aa47ac0ee53419e2)[((_h = typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) === null || _h === void 0 ? void 0 : _h.toUpperCase()) || ""];
                        if (!(Array.isArray(data) && typeof currSize !== "undefined")) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            $9cfdda3ebf838156$var$EIP712SendStructImplem(transport, {
                                structType: "array",
                                value: data.length
                            })
                        ];
                    case 1:
                        _j.sent();
                        _j.label = 2;
                    case 2:
                        _j.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        data_1 = $9cfdda3ebf838156$var$__values(data), data_1_1 = data_1.next();
                        _j.label = 3;
                    case 3:
                        if (!!data_1_1.done) return [
                            3 /*break*/ ,
                            6
                        ];
                        entry = data_1_1.value;
                        return [
                            4 /*yield*/ ,
                            recursiveFieldStructImplem([
                                typeDescription,
                                restSizes
                            ], entry)
                        ];
                    case 4:
                        _j.sent();
                        _j.label = 5;
                    case 5:
                        data_1_1 = data_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        e_1_1 = _j.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        try {
                            if (data_1_1 && !data_1_1.done && (_f = data_1["return"])) _f.call(data_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 10:
                        if (!isCustomType) return [
                            3 /*break*/ ,
                            19
                        ];
                        _j.label = 11;
                    case 11:
                        _j.trys.push([
                            11,
                            16,
                            17,
                            18
                        ]);
                        _c = $9cfdda3ebf838156$var$__values(Object.entries(data)), _d = _c.next();
                        _j.label = 12;
                    case 12:
                        if (!!_d.done) return [
                            3 /*break*/ ,
                            15
                        ];
                        _e = $9cfdda3ebf838156$var$__read(_d.value, 2), fieldName = _e[0], fieldValue = _e[1];
                        fieldType = typesMap === null || typesMap === void 0 ? void 0 : typesMap[(typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) || ""][fieldName];
                        if (!fieldType) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            recursiveFieldStructImplem((0, $305b6c00bc71328c$export$598f26315e73345b)(fieldType), fieldValue)
                        ];
                    case 13:
                        _j.sent();
                        _j.label = 14;
                    case 14:
                        _d = _c.next();
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 16:
                        e_2_1 = _j.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 17:
                        try {
                            if (_d && !_d.done && (_g = _c["return"])) _g.call(_c);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 19:
                        return [
                            4 /*yield*/ ,
                            $9cfdda3ebf838156$var$EIP712SendStructImplem(transport, {
                                structType: "field",
                                value: {
                                    data: data,
                                    type: (typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) || "",
                                    sizeInBits: typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.bits
                                }
                            })
                        ];
                    case 20:
                        _j.sent();
                        _j.label = 21;
                    case 21:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return recursiveFieldStructImplem;
};
/**
 * @ignore for the README
 *
 * This method is used to send the message definition with all its types.
 * This method should be used before the EIP712SendStructImplem one
 *
 * @param {String} structType
 * @param {String|Buffer} value
 * @returns {Promise<void>}
 */ var $9cfdda3ebf838156$var$EIP712SendStructDef = function EIP712SendStructDef(transport, structDef) {
    var APDU_FIELDS;
    (function(APDU_FIELDS) {
        APDU_FIELDS[APDU_FIELDS["CLA"] = 224] = "CLA";
        APDU_FIELDS[APDU_FIELDS["INS"] = 26] = "INS";
        APDU_FIELDS[APDU_FIELDS["P1_complete"] = 0] = "P1_complete";
        APDU_FIELDS[APDU_FIELDS["P1_partial"] = 1] = "P1_partial";
        APDU_FIELDS[APDU_FIELDS["P2_name"] = 0] = "P2_name";
        APDU_FIELDS[APDU_FIELDS["P2_field"] = 255] = "P2_field";
    })(APDU_FIELDS || (APDU_FIELDS = {}));
    var structType = structDef.structType, value = structDef.value;
    var data = structType === "name" && typeof value === "string" ? $9cfdda3ebf838156$require$Buffer.from(value, "utf-8") : value;
    return transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1_complete, structType === "name" ? APDU_FIELDS.P2_name : APDU_FIELDS.P2_field, data);
};
/**
 * @ignore for the README
 *
 * This method provides a trusted new display name to use for the upcoming field.
 * This method should be used after the EIP712SendStructDef one.
 *
 * If the method describes an empty name (length of 0), the upcoming field will be taken
 * into account but won’t be shown on the device.
 *
 * The signature is computed on :
 * json key length || json key || display name length || display name
 *
 * signed by the following secp256k1 public key:
 * 0482bbf2f34f367b2e5bc21847b6566f21f0976b22d3388a9a5e446ac62d25cf725b62a2555b2dd464a4da0ab2f4d506820543af1d242470b1b1a969a27578f353
 *
 * @param {String} structType "root" | "array" | "field"
 * @param {string | number | StructFieldData} value
 * @returns {Promise<Buffer | void>}
 */ var $9cfdda3ebf838156$var$EIP712SendStructImplem = function EIP712SendStructImplem(transport, structImplem) {
    return $9cfdda3ebf838156$var$__awaiter(void 0, void 0, void 0, function() {
        var APDU_FIELDS, structType, value, rawData, type, sizeInBits, encodedData, dataLengthPer16Bits, dataLengthModulo16Bits, data_2, bufferSlices, bufferSlices_1, bufferSlices_1_1, bufferSlice, e_3_1;
        var e_3, _a;
        var _b;
        return $9cfdda3ebf838156$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    (function(APDU_FIELDS) {
                        APDU_FIELDS[APDU_FIELDS["CLA"] = 224] = "CLA";
                        APDU_FIELDS[APDU_FIELDS["INS"] = 28] = "INS";
                        APDU_FIELDS[APDU_FIELDS["P1_complete"] = 0] = "P1_complete";
                        APDU_FIELDS[APDU_FIELDS["P1_partial"] = 1] = "P1_partial";
                        APDU_FIELDS[APDU_FIELDS["P2_root"] = 0] = "P2_root";
                        APDU_FIELDS[APDU_FIELDS["P2_array"] = 15] = "P2_array";
                        APDU_FIELDS[APDU_FIELDS["P2_field"] = 255] = "P2_field";
                    })(APDU_FIELDS || (APDU_FIELDS = {}));
                    structType = structImplem.structType, value = structImplem.value;
                    if (structType === "root") return [
                        2 /*return*/ ,
                        transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1_complete, APDU_FIELDS.P2_root, $9cfdda3ebf838156$require$Buffer.from(value, "utf-8"))
                    ];
                    if (structType === "array") return [
                        2 /*return*/ ,
                        transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1_complete, APDU_FIELDS.P2_array, $9cfdda3ebf838156$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(value, 1), "hex"))
                    ];
                    if (!(structType === "field")) return [
                        3 /*break*/ ,
                        8
                    ];
                    rawData = value.data, type = value.type, sizeInBits = value.sizeInBits;
                    encodedData = (_b = (0, $305b6c00bc71328c$export$e370b40e9c7fb0f)[type.toUpperCase()]) === null || _b === void 0 ? void 0 : _b.call((0, $305b6c00bc71328c$export$e370b40e9c7fb0f), rawData, sizeInBits);
                    if (!encodedData) return [
                        3 /*break*/ ,
                        8
                    ];
                    dataLengthPer16Bits = Math.floor(encodedData.length / 256);
                    dataLengthModulo16Bits = encodedData.length % 256;
                    data_2 = $9cfdda3ebf838156$require$Buffer.concat([
                        $9cfdda3ebf838156$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(dataLengthPer16Bits, 1), "hex"),
                        $9cfdda3ebf838156$require$Buffer.from((0, $f6a3edc136b9f477$export$64ed265a1cd37072)(dataLengthModulo16Bits, 1), "hex"),
                        encodedData
                    ]);
                    bufferSlices = new Array(Math.ceil(data_2.length / 256)).fill(null).map(function(_, i) {
                        return data_2.slice(i * 255, (i + 1) * 255);
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    bufferSlices_1 = $9cfdda3ebf838156$var$__values(bufferSlices), bufferSlices_1_1 = bufferSlices_1.next();
                    _c.label = 2;
                case 2:
                    if (!!bufferSlices_1_1.done) return [
                        3 /*break*/ ,
                        5
                    ];
                    bufferSlice = bufferSlices_1_1.value;
                    return [
                        4 /*yield*/ ,
                        transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, bufferSlice !== bufferSlices[bufferSlices.length - 1] ? APDU_FIELDS.P1_partial : APDU_FIELDS.P1_complete, APDU_FIELDS.P2_field, bufferSlice)
                    ];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    bufferSlices_1_1 = bufferSlices_1.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 6:
                    e_3_1 = _c.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    try {
                        if (bufferSlices_1_1 && !bufferSlices_1_1.done && (_a = bufferSlices_1["return"])) _a.call(bufferSlices_1);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 8:
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
            }
        });
    });
};
var $9cfdda3ebf838156$export$5d48fc60e05ec3c9 = function signEIP712Message(transport, path, jsonMessage, fullImplem) {
    if (fullImplem === void 0) fullImplem = false;
    return $9cfdda3ebf838156$var$__awaiter(void 0, void 0, void 0, function() {
        var APDU_FIELDS, primaryType, types, domain, message, typeEntries, typeEntries_1, typeEntries_1_1, _a, typeName, entries, entries_1, entries_1_1, _b, name_1, type, typeEntryBuffer, e_4_1, e_5_1, recursiveFieldStructImplem, domainName, domainTypeFields, domainTypeFields_1, domainTypeFields_1_1, _c, name_2, type, domainFieldValue, e_6_1, primaryTypeFields, primaryTypeFields_1, primaryTypeFields_1_1, _d, name_3, type, primaryTypeValue, e_7_1, paths, signatureBuffer;
        var e_5, _e, e_4, _f, e_6, _g, e_7, _h;
        return $9cfdda3ebf838156$var$__generator(this, function(_j) {
            switch(_j.label){
                case 0:
                    (function(APDU_FIELDS) {
                        APDU_FIELDS[APDU_FIELDS["CLA"] = 224] = "CLA";
                        APDU_FIELDS[APDU_FIELDS["INS"] = 12] = "INS";
                        APDU_FIELDS[APDU_FIELDS["P1"] = 0] = "P1";
                        APDU_FIELDS[APDU_FIELDS["P2_v0"] = 0] = "P2_v0";
                        APDU_FIELDS[APDU_FIELDS["P2_full"] = 1] = "P2_full";
                    })(APDU_FIELDS || (APDU_FIELDS = {}));
                    primaryType = jsonMessage.primaryType, types = jsonMessage.types, domain = jsonMessage.domain, message = jsonMessage.message;
                    typeEntries = Object.entries(types);
                    _j.label = 1;
                case 1:
                    _j.trys.push([
                        1,
                        13,
                        14,
                        15
                    ]);
                    typeEntries_1 = $9cfdda3ebf838156$var$__values(typeEntries), typeEntries_1_1 = typeEntries_1.next();
                    _j.label = 2;
                case 2:
                    if (!!typeEntries_1_1.done) return [
                        3 /*break*/ ,
                        12
                    ];
                    _a = $9cfdda3ebf838156$var$__read(typeEntries_1_1.value, 2), typeName = _a[0], entries = _a[1];
                    return [
                        4 /*yield*/ ,
                        $9cfdda3ebf838156$var$EIP712SendStructDef(transport, {
                            structType: "name",
                            value: typeName
                        })
                    ];
                case 3:
                    _j.sent();
                    _j.label = 4;
                case 4:
                    _j.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    entries_1 = (e_4 = void 0, $9cfdda3ebf838156$var$__values(entries)), entries_1_1 = entries_1.next();
                    _j.label = 5;
                case 5:
                    if (!!entries_1_1.done) return [
                        3 /*break*/ ,
                        8
                    ];
                    _b = entries_1_1.value, name_1 = _b.name, type = _b.type;
                    typeEntryBuffer = (0, $305b6c00bc71328c$export$7c191342f3ed2438)({
                        name: name_1,
                        type: type
                    });
                    return [
                        4 /*yield*/ ,
                        $9cfdda3ebf838156$var$EIP712SendStructDef(transport, {
                            structType: "field",
                            value: typeEntryBuffer
                        })
                    ];
                case 6:
                    _j.sent();
                    _j.label = 7;
                case 7:
                    entries_1_1 = entries_1.next();
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 9:
                    e_4_1 = _j.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    try {
                        if (entries_1_1 && !entries_1_1.done && (_f = entries_1["return"])) _f.call(entries_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 11:
                    typeEntries_1_1 = typeEntries_1.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 12:
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 13:
                    e_5_1 = _j.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    try {
                        if (typeEntries_1_1 && !typeEntries_1_1.done && (_e = typeEntries_1["return"])) _e.call(typeEntries_1);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 15:
                    recursiveFieldStructImplem = $9cfdda3ebf838156$var$makeRecursiveFieldStructImplem(transport, types);
                    domainName = "EIP712Domain";
                    return [
                        4 /*yield*/ ,
                        $9cfdda3ebf838156$var$EIP712SendStructImplem(transport, {
                            structType: "root",
                            value: domainName
                        })
                    ];
                case 16:
                    _j.sent();
                    domainTypeFields = types[domainName];
                    _j.label = 17;
                case 17:
                    _j.trys.push([
                        17,
                        22,
                        23,
                        24
                    ]);
                    domainTypeFields_1 = $9cfdda3ebf838156$var$__values(domainTypeFields), domainTypeFields_1_1 = domainTypeFields_1.next();
                    _j.label = 18;
                case 18:
                    if (!!domainTypeFields_1_1.done) return [
                        3 /*break*/ ,
                        21
                    ];
                    _c = domainTypeFields_1_1.value, name_2 = _c.name, type = _c.type;
                    domainFieldValue = domain[name_2];
                    return [
                        4 /*yield*/ ,
                        recursiveFieldStructImplem((0, $305b6c00bc71328c$export$598f26315e73345b)(type), domainFieldValue)
                    ];
                case 19:
                    _j.sent();
                    _j.label = 20;
                case 20:
                    domainTypeFields_1_1 = domainTypeFields_1.next();
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 21:
                    return [
                        3 /*break*/ ,
                        24
                    ];
                case 22:
                    e_6_1 = _j.sent();
                    e_6 = {
                        error: e_6_1
                    };
                    return [
                        3 /*break*/ ,
                        24
                    ];
                case 23:
                    try {
                        if (domainTypeFields_1_1 && !domainTypeFields_1_1.done && (_g = domainTypeFields_1["return"])) _g.call(domainTypeFields_1);
                    } finally{
                        if (e_6) throw e_6.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 24:
                    // Looping on all primaryType type entries and fields to send
                    // structures' implementations
                    return [
                        4 /*yield*/ ,
                        $9cfdda3ebf838156$var$EIP712SendStructImplem(transport, {
                            structType: "root",
                            value: primaryType
                        })
                    ];
                case 25:
                    // Looping on all primaryType type entries and fields to send
                    // structures' implementations
                    _j.sent();
                    primaryTypeFields = types[primaryType];
                    _j.label = 26;
                case 26:
                    _j.trys.push([
                        26,
                        31,
                        32,
                        33
                    ]);
                    primaryTypeFields_1 = $9cfdda3ebf838156$var$__values(primaryTypeFields), primaryTypeFields_1_1 = primaryTypeFields_1.next();
                    _j.label = 27;
                case 27:
                    if (!!primaryTypeFields_1_1.done) return [
                        3 /*break*/ ,
                        30
                    ];
                    _d = primaryTypeFields_1_1.value, name_3 = _d.name, type = _d.type;
                    primaryTypeValue = message[name_3];
                    return [
                        4 /*yield*/ ,
                        recursiveFieldStructImplem((0, $305b6c00bc71328c$export$598f26315e73345b)(type), primaryTypeValue)
                    ];
                case 28:
                    _j.sent();
                    _j.label = 29;
                case 29:
                    primaryTypeFields_1_1 = primaryTypeFields_1.next();
                    return [
                        3 /*break*/ ,
                        27
                    ];
                case 30:
                    return [
                        3 /*break*/ ,
                        33
                    ];
                case 31:
                    e_7_1 = _j.sent();
                    e_7 = {
                        error: e_7_1
                    };
                    return [
                        3 /*break*/ ,
                        33
                    ];
                case 32:
                    try {
                        if (primaryTypeFields_1_1 && !primaryTypeFields_1_1.done && (_h = primaryTypeFields_1["return"])) _h.call(primaryTypeFields_1);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 33:
                    paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
                    signatureBuffer = $9cfdda3ebf838156$require$Buffer.alloc(1 + paths.length * 4);
                    signatureBuffer[0] = paths.length;
                    paths.forEach(function(element, index) {
                        signatureBuffer.writeUInt32BE(element, 1 + 4 * index);
                    });
                    return [
                        2 /*return*/ ,
                        transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1, fullImplem ? APDU_FIELDS.P2_v0 : APDU_FIELDS.P2_full, signatureBuffer).then(function(response) {
                            var v = response[0];
                            var r = response.slice(1, 33).toString("hex");
                            var s = response.slice(33, 65).toString("hex");
                            return {
                                v: v,
                                r: r,
                                s: s
                            };
                        })
                    ];
            }
        });
    });
};
var $9cfdda3ebf838156$export$4bf70f710371ea6f = function signEIP712HashedMessage(transport, path, domainSeparatorHex, hashStructMessageHex) {
    var domainSeparator = (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(domainSeparatorHex);
    var hashStruct = (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(hashStructMessageHex);
    var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
    var buffer = $9cfdda3ebf838156$require$Buffer.alloc(1 + paths.length * 4 + 32 + 32, 0);
    var offset = 0;
    buffer[0] = paths.length;
    paths.forEach(function(element, index) {
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    offset = 1 + 4 * paths.length;
    domainSeparator.copy(buffer, offset);
    offset += 32;
    hashStruct.copy(buffer, offset);
    return transport.send(0xe0, 0x0c, 0x00, 0x00, buffer).then(function(response) {
        var v = response[0];
        var r = response.slice(1, 33).toString("hex");
        var s = response.slice(33, 65).toString("hex");
        return {
            v: v,
            r: r,
            s: s
        };
    });
};



var $ilnag = parcelRequire("ilnag");
var $342c61efd3810a3d$require$Buffer = $ilnag.Buffer;
var $342c61efd3810a3d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $342c61efd3810a3d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $342c61efd3810a3d$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $342c61efd3810a3d$var$starkQuantizationTypeMap = {
    eth: 1,
    erc20: 2,
    erc721: 3,
    erc20mintable: 4,
    erc721mintable: 5
};
var $342c61efd3810a3d$var$remapTransactionRelatedErrors = function remapTransactionRelatedErrors(e) {
    if (e && e.statusCode === 0x6a80) return new (0, $6e45af695d24937b$export$96d8d3c501f1625)("Please enable Blind signing or Contract data in the Ethereum app Settings");
    return e;
};
/**
 * Ethereum API
 *
 * @example
 * import Eth from "@ledgerhq/hw-app-eth";
 * const eth = new Eth(transport)
 */ var $342c61efd3810a3d$var$Eth = /** @class */ function() {
    function Eth(transport, scrambleKey, loadConfig) {
        if (scrambleKey === void 0) scrambleKey = "w0w";
        if (loadConfig === void 0) loadConfig = {};
        this.transport = transport;
        this.loadConfig = loadConfig;
        transport.decorateAppAPIMethods(this, [
            "getAddress",
            "provideERC20TokenInformation",
            "signTransaction",
            "signPersonalMessage",
            "getAppConfiguration",
            "signEIP712Message",
            "signEIP712HashedMessage",
            "starkGetPublicKey",
            "starkSignOrder",
            "starkSignOrder_v2",
            "starkSignTransfer",
            "starkSignTransfer_v2",
            "starkProvideQuantum",
            "starkProvideQuantum_v2",
            "starkUnsafeSign",
            "eth2GetPublicKey",
            "eth2SetWithdrawalIndex",
            "setExternalPlugin",
            "setPlugin",
            "getEIP1024PublicEncryptionKey",
            "getEIP1024SharedSecret"
        ], scrambleKey);
    }
    Eth.prototype.setLoadConfig = function(loadConfig) {
        this.loadConfig = loadConfig;
    };
    /**
     * get Ethereum address for a given BIP 32 path.
     * @param path a path in BIP 32 format
     * @option boolDisplay optionally enable or not the display
     * @option boolChaincode optionally enable or not the chaincode request
     * @return an object with a publicKey, address and (optionally) chainCode
     * @example
     * eth.getAddress("44'/60'/0'/0/0").then(o => o.address)
     */ Eth.prototype.getAddress = function(path, boolDisplay, boolChaincode) {
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4);
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        return this.transport.send(0xe0, 0x02, boolDisplay ? 0x01 : 0x00, boolChaincode ? 0x01 : 0x00, buffer).then(function(response) {
            var publicKeyLength = response[0];
            var addressLength = response[1 + publicKeyLength];
            return {
                publicKey: response.slice(1, 1 + publicKeyLength).toString("hex"),
                address: "0x" + response.slice(1 + publicKeyLength + 1, 1 + publicKeyLength + 1 + addressLength).toString("ascii"),
                chainCode: boolChaincode ? response.slice(1 + publicKeyLength + 1 + addressLength, 1 + publicKeyLength + 1 + addressLength + 32).toString("hex") : undefined
            };
        });
    };
    /**
     * You can sign a transaction and retrieve v, r, s given the raw transaction and the BIP 32 path of the account to sign.
     *
     * @param path: the BIP32 path to sign the transaction on
     * @param rawTxHex: the raw ethereum transaction in hexadecimal to sign
     * @param resolution: resolution is an object with all "resolved" metadata necessary to allow the device to clear sign information. This includes: ERC20 token information, plugins, contracts, NFT signatures,... You must explicitly provide something to avoid having a warning. By default, you can use Ledger's service or your own resolution service. See services/types.js for the contract. Setting the value to "null" will fallback everything to blind signing but will still allow the device to sign the transaction.
     * @example
     import { ledgerService } from "@ledgerhq/hw-app-eth"
     const tx = "e8018504e3b292008252089428ee52a8f3d6e5d15f8b131996950d7f296c7952872bd72a2487400080"; // raw tx to sign
     const resolution = await ledgerService.resolveTransaction(tx);
     const result = eth.signTransaction("44'/60'/0'/0/0", tx, resolution);
     console.log(result);
     */ Eth.prototype.signTransaction = function(path, rawTxHex, resolution) {
        return $342c61efd3810a3d$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, plugin, e_1_1, _c, _d, _e, payload, signature, e_2_1, _f, _g, nft, e_3_1, _h, _j, data, e_4_1, rawTx, _k, vrsOffset, txType, chainId, chainIdTruncated, paths, response, offset, _loop_1, this_1, response_byte, v, oneByteChainId, ecc_parity, r, s;
            var e_1, _l, e_2, _m, e_3, _o, e_4, _p;
            return $342c61efd3810a3d$var$__generator(this, function(_q) {
                switch(_q.label){
                    case 0:
                        if (!(resolution === undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        console.warn("hw-app-eth: signTransaction(path, rawTxHex, resolution): please provide the 'resolution' parameter. See https://github.com/LedgerHQ/ledgerjs/blob/master/packages/hw-app-eth/README.md \u2013 the previous signature is deprecated and providing the 3rd 'resolution' parameter explicitly will become mandatory so you have the control on the resolution and the fallback mecanism (e.g. fallback to blind signing or not).// Possible solution:\n + import { ledgerService } from '@ledgerhq/hw-app-eth';\n + const resolution = await ledgerService.resolveTransaction(rawTxHex);");
                        return [
                            4 /*yield*/ ,
                            (0, $fd117c956f2ba52b$export$2e2bcd8739ae039).resolveTransaction(rawTxHex, this.loadConfig, {
                                externalPlugins: true,
                                erc20: true
                            })["catch"](function(e) {
                                console.warn("an error occurred in resolveTransaction => fallback to blind signing: " + String(e));
                                return null;
                            })
                        ];
                    case 1:
                        resolution = _q.sent();
                        _q.label = 2;
                    case 2:
                        if (!resolution) return [
                            3 /*break*/ ,
                            31
                        ];
                        _q.label = 3;
                    case 3:
                        _q.trys.push([
                            3,
                            8,
                            9,
                            10
                        ]);
                        _a = $342c61efd3810a3d$var$__values(resolution.plugin), _b = _a.next();
                        _q.label = 4;
                    case 4:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        plugin = _b.value;
                        return [
                            4 /*yield*/ ,
                            $342c61efd3810a3d$var$setPlugin(this.transport, plugin)
                        ];
                    case 5:
                        _q.sent();
                        _q.label = 6;
                    case 6:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_1_1 = _q.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (_b && !_b.done && (_l = _a["return"])) _l.call(_a);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        _q.trys.push([
                            10,
                            15,
                            16,
                            17
                        ]);
                        _c = $342c61efd3810a3d$var$__values(resolution.externalPlugin), _d = _c.next();
                        _q.label = 11;
                    case 11:
                        if (!!_d.done) return [
                            3 /*break*/ ,
                            14
                        ];
                        _e = _d.value, payload = _e.payload, signature = _e.signature;
                        return [
                            4 /*yield*/ ,
                            $342c61efd3810a3d$var$setExternalPlugin(this.transport, payload, signature)
                        ];
                    case 12:
                        _q.sent();
                        _q.label = 13;
                    case 13:
                        _d = _c.next();
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        e_2_1 = _q.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        try {
                            if (_d && !_d.done && (_m = _c["return"])) _m.call(_c);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        _q.trys.push([
                            17,
                            22,
                            23,
                            24
                        ]);
                        _f = $342c61efd3810a3d$var$__values(resolution.nfts), _g = _f.next();
                        _q.label = 18;
                    case 18:
                        if (!!_g.done) return [
                            3 /*break*/ ,
                            21
                        ];
                        nft = _g.value;
                        return [
                            4 /*yield*/ ,
                            $342c61efd3810a3d$var$provideNFTInformation(this.transport, $342c61efd3810a3d$require$Buffer.from(nft, "hex"))
                        ];
                    case 19:
                        _q.sent();
                        _q.label = 20;
                    case 20:
                        _g = _f.next();
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 21:
                        return [
                            3 /*break*/ ,
                            24
                        ];
                    case 22:
                        e_3_1 = _q.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            24
                        ];
                    case 23:
                        try {
                            if (_g && !_g.done && (_o = _f["return"])) _o.call(_f);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 24:
                        _q.trys.push([
                            24,
                            29,
                            30,
                            31
                        ]);
                        _h = $342c61efd3810a3d$var$__values(resolution.erc20Tokens), _j = _h.next();
                        _q.label = 25;
                    case 25:
                        if (!!_j.done) return [
                            3 /*break*/ ,
                            28
                        ];
                        data = _j.value;
                        return [
                            4 /*yield*/ ,
                            $342c61efd3810a3d$var$provideERC20TokenInformation(this.transport, $342c61efd3810a3d$require$Buffer.from(data, "hex"))
                        ];
                    case 26:
                        _q.sent();
                        _q.label = 27;
                    case 27:
                        _j = _h.next();
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 28:
                        return [
                            3 /*break*/ ,
                            31
                        ];
                    case 29:
                        e_4_1 = _q.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            31
                        ];
                    case 30:
                        try {
                            if (_j && !_j.done && (_p = _h["return"])) _p.call(_h);
                        } finally{
                            if (e_4) throw e_4.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 31:
                        rawTx = $342c61efd3810a3d$require$Buffer.from(rawTxHex, "hex");
                        _k = (0, $f6a3edc136b9f477$export$e952eba50b3a65d5)(rawTx), vrsOffset = _k.vrsOffset, txType = _k.txType, chainId = _k.chainId, chainIdTruncated = _k.chainIdTruncated;
                        paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
                        offset = 0;
                        _loop_1 = function _loop_1() {
                            var first, maxChunkSize, chunkSize, buffer;
                            return $342c61efd3810a3d$var$__generator(this, function(_r) {
                                switch(_r.label){
                                    case 0:
                                        first = offset === 0;
                                        maxChunkSize = first ? 149 - paths.length * 4 : 150;
                                        chunkSize = offset + maxChunkSize > rawTx.length ? rawTx.length - offset : maxChunkSize;
                                        if (vrsOffset != 0 && offset + chunkSize >= vrsOffset) // Make sure that the chunk doesn't end right on the EIP 155 marker if set
                                        chunkSize = rawTx.length - offset;
                                        buffer = $342c61efd3810a3d$require$Buffer.alloc(first ? 1 + paths.length * 4 + chunkSize : chunkSize);
                                        if (first) {
                                            buffer[0] = paths.length;
                                            paths.forEach(function(element, index) {
                                                buffer.writeUInt32BE(element, 1 + 4 * index);
                                            });
                                            rawTx.copy(buffer, 1 + 4 * paths.length, offset, offset + chunkSize);
                                        } else rawTx.copy(buffer, 0, offset, offset + chunkSize);
                                        return [
                                            4 /*yield*/ ,
                                            this_1.transport.send(0xe0, 0x04, first ? 0x00 : 0x80, 0x00, buffer)["catch"](function(e) {
                                                throw $342c61efd3810a3d$var$remapTransactionRelatedErrors(e);
                                            })
                                        ];
                                    case 1:
                                        response = _r.sent();
                                        offset += chunkSize;
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _q.label = 32;
                    case 32:
                        if (!(offset !== rawTx.length)) return [
                            3 /*break*/ ,
                            34
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 33:
                        _q.sent();
                        return [
                            3 /*break*/ ,
                            32
                        ];
                    case 34:
                        response_byte = response[0];
                        v = "";
                        if (chainId.times(2).plus(35).plus(1).isGreaterThan(255)) {
                            oneByteChainId = (chainIdTruncated * 2 + 35) % 256;
                            ecc_parity = Math.abs(response_byte - oneByteChainId);
                            if (txType != null) // For EIP2930 and EIP1559 tx, v is simply the parity.
                            v = ecc_parity % 2 == 1 ? "00" : "01";
                            else // Legacy type transaction with a big chain ID
                            v = chainId.times(2).plus(35).plus(ecc_parity).toString(16);
                        } else v = response_byte.toString(16);
                        // Make sure v has is prefixed with a 0 if its length is odd ("1" -> "01").
                        if (v.length % 2 == 1) v = "0" + v;
                        r = response.slice(1, 33).toString("hex");
                        s = response.slice(33, 65).toString("hex");
                        return [
                            2 /*return*/ ,
                            {
                                v: v,
                                r: r,
                                s: s
                            }
                        ];
                }
            });
        });
    };
    /**
     */ Eth.prototype.getAppConfiguration = function() {
        return this.transport.send(0xe0, 0x06, 0x00, 0x00).then(function(response) {
            return {
                arbitraryDataEnabled: response[0] & 0x01,
                erc20ProvisioningNecessary: response[0] & 0x02,
                starkEnabled: response[0] & 0x04,
                starkv2Supported: response[0] & 0x08,
                version: "" + response[1] + "." + response[2] + "." + response[3]
            };
        });
    };
    /**
    * You can sign a message according to eth_sign RPC call and retrieve v, r, s given the message and the BIP 32 path of the account to sign.
    * @example
    eth.signPersonalMessage("44'/60'/0'/0/0", Buffer.from("test").toString("hex")).then(result => {
    var v = result['v'] - 27;
    v = v.toString(16);
    if (v.length < 2) {
      v = "0" + v;
    }
    console.log("Signature 0x" + result['r'] + result['s'] + v);
    })
     */ Eth.prototype.signPersonalMessage = function(path, messageHex) {
        return $342c61efd3810a3d$var$__awaiter(this, void 0, void 0, function() {
            var paths, offset, message, response, _loop_2, this_2, v, r, s;
            return $342c61efd3810a3d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
                        offset = 0;
                        message = $342c61efd3810a3d$require$Buffer.from(messageHex, "hex");
                        _loop_2 = function _loop_2() {
                            var maxChunkSize, chunkSize, buffer;
                            return $342c61efd3810a3d$var$__generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        maxChunkSize = offset === 0 ? 149 - paths.length * 4 - 4 : 150;
                                        chunkSize = offset + maxChunkSize > message.length ? message.length - offset : maxChunkSize;
                                        buffer = $342c61efd3810a3d$require$Buffer.alloc(offset === 0 ? 1 + paths.length * 4 + 4 + chunkSize : chunkSize);
                                        if (offset === 0) {
                                            buffer[0] = paths.length;
                                            paths.forEach(function(element, index) {
                                                buffer.writeUInt32BE(element, 1 + 4 * index);
                                            });
                                            buffer.writeUInt32BE(message.length, 1 + 4 * paths.length);
                                            message.copy(buffer, 1 + 4 * paths.length + 4, offset, offset + chunkSize);
                                        } else message.copy(buffer, 0, offset, offset + chunkSize);
                                        return [
                                            4 /*yield*/ ,
                                            this_2.transport.send(0xe0, 0x08, offset === 0 ? 0x00 : 0x80, 0x00, buffer)
                                        ];
                                    case 1:
                                        response = _b.sent();
                                        offset += chunkSize;
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_2 = this;
                        _a.label = 1;
                    case 1:
                        if (!(offset !== message.length)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_2()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        v = response[0];
                        r = response.slice(1, 33).toString("hex");
                        s = response.slice(33, 65).toString("hex");
                        return [
                            2 /*return*/ ,
                            {
                                v: v,
                                r: r,
                                s: s
                            }
                        ];
                }
            });
        });
    };
    /**
    * Sign a prepared message following web3.eth.signTypedData specification. The host computes the domain separator and hashStruct(message)
    * @example
    eth.signEIP712HashedMessage("44'/60'/0'/0/0", Buffer.from("0101010101010101010101010101010101010101010101010101010101010101").toString("hex"), Buffer.from("0202020202020202020202020202020202020202020202020202020202020202").toString("hex")).then(result => {
    var v = result['v'] - 27;
    v = v.toString(16);
    if (v.length < 2) {
      v = "0" + v;
    }
    console.log("Signature 0x" + result['r'] + result['s'] + v);
    })
     */ Eth.prototype.signEIP712HashedMessage = function(path, domainSeparatorHex, hashStructMessageHex) {
        return (0, $9cfdda3ebf838156$export$4bf70f710371ea6f)(this.transport, path, domainSeparatorHex, hashStructMessageHex);
    };
    /**
     * Sign an EIP-721 formatted message following the specification here:
     * https://github.com/LedgerHQ/app-ethereum/blob/develop/doc/ethapp.asc#sign-eth-eip-712
     @example
     eth.signEIP721Message("44'/60'/0'/0/0", {
        domain: {
          chainId: 69,
          name: "Da Domain",
          verifyingContract: "0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC",
          version: "1"
        },
        types: {
          "EIP712Domain": [
                { name: "name", type: "string" },
                { name: "version", type: "string" },
                { name: "chainId", type: "uint256" },
                { name: "verifyingContract", type: "address" }
            ],
          "Test": [
            { name: "contents", type: "string" }
          ]
        },
        primaryType: "Test",
        message: {contents: "Hello, Bob!"},
      })
     *
     * @param {String} path derivationPath
     * @param {Object} jsonMessage message to sign
     * @param {Boolean} fullImplem use the legacy implementation
     * @returns {Promise}
     */ Eth.prototype.signEIP712Message = function(path, jsonMessage, fullImplem) {
        if (fullImplem === void 0) fullImplem = false;
        return $342c61efd3810a3d$var$__awaiter(this, void 0, void 0, function() {
            return $342c61efd3810a3d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $9cfdda3ebf838156$export$5d48fc60e05ec3c9)(this.transport, path, jsonMessage, fullImplem)
                ];
            });
        });
    };
    /**
     * get Stark public key for a given BIP 32 path.
     * @param path a path in BIP 32 format
     * @option boolDisplay optionally enable or not the display
     * @return the Stark public key
     */ Eth.prototype.starkGetPublicKey = function(path, boolDisplay) {
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4);
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        return this.transport.send(0xf0, 0x02, boolDisplay ? 0x01 : 0x00, 0x00, buffer).then(function(response) {
            return response.slice(0, response.length - 2);
        });
    };
    /**
     * sign a Stark order
     * @param path a path in BIP 32 format
     * @option sourceTokenAddress contract address of the source token (not present for ETH)
     * @param sourceQuantization quantization used for the source token
     * @option destinationTokenAddress contract address of the destination token (not present for ETH)
     * @param destinationQuantization quantization used for the destination token
     * @param sourceVault ID of the source vault
     * @param destinationVault ID of the destination vault
     * @param amountSell amount to sell
     * @param amountBuy amount to buy
     * @param nonce transaction nonce
     * @param timestamp transaction validity timestamp
     * @return the signature
     */ Eth.prototype.starkSignOrder = function(path, sourceTokenAddress, sourceQuantization, destinationTokenAddress, destinationQuantization, sourceVault, destinationVault, amountSell, amountBuy, nonce, timestamp) {
        var sourceTokenAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(sourceTokenAddress);
        var destinationTokenAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(destinationTokenAddress);
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4 + 20 + 32 + 20 + 32 + 4 + 4 + 8 + 8 + 4 + 4, 0);
        var offset = 0;
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        offset = 1 + 4 * paths.length;
        if (sourceTokenAddressHex) sourceTokenAddressHex.copy(buffer, offset);
        offset += 20;
        $342c61efd3810a3d$require$Buffer.from(sourceQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        if (destinationTokenAddressHex) destinationTokenAddressHex.copy(buffer, offset);
        offset += 20;
        $342c61efd3810a3d$require$Buffer.from(destinationQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        buffer.writeUInt32BE(sourceVault, offset);
        offset += 4;
        buffer.writeUInt32BE(destinationVault, offset);
        offset += 4;
        $342c61efd3810a3d$require$Buffer.from(amountSell.toString(16).padStart(16, "0"), "hex").copy(buffer, offset);
        offset += 8;
        $342c61efd3810a3d$require$Buffer.from(amountBuy.toString(16).padStart(16, "0"), "hex").copy(buffer, offset);
        offset += 8;
        buffer.writeUInt32BE(nonce, offset);
        offset += 4;
        buffer.writeUInt32BE(timestamp, offset);
        return this.transport.send(0xf0, 0x04, 0x01, 0x00, buffer).then(function(response) {
            var r = response.slice(1, 33).toString("hex");
            var s = response.slice(33, 65).toString("hex");
            return {
                r: r,
                s: s
            };
        });
    };
    /**
     * sign a Stark order using the Starkex V2 protocol
     * @param path a path in BIP 32 format
     * @option sourceTokenAddress contract address of the source token (not present for ETH)
     * @param sourceQuantizationType quantization type used for the source token
     * @option sourceQuantization quantization used for the source token (not present for erc 721 or mintable erc 721)
     * @option sourceMintableBlobOrTokenId mintable blob (mintable erc 20 / mintable erc 721) or token id (erc 721) associated to the source token
     * @option destinationTokenAddress contract address of the destination token (not present for ETH)
     * @param destinationQuantizationType quantization type used for the destination token
     * @option destinationQuantization quantization used for the destination token (not present for erc 721 or mintable erc 721)
     * @option destinationMintableBlobOrTokenId mintable blob (mintable erc 20 / mintable erc 721) or token id (erc 721) associated to the destination token
     * @param sourceVault ID of the source vault
     * @param destinationVault ID of the destination vault
     * @param amountSell amount to sell
     * @param amountBuy amount to buy
     * @param nonce transaction nonce
     * @param timestamp transaction validity timestamp
     * @return the signature
     */ Eth.prototype.starkSignOrder_v2 = function(path, sourceTokenAddress, sourceQuantizationType, sourceQuantization, sourceMintableBlobOrTokenId, destinationTokenAddress, destinationQuantizationType, destinationQuantization, destinationMintableBlobOrTokenId, sourceVault, destinationVault, amountSell, amountBuy, nonce, timestamp) {
        var sourceTokenAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(sourceTokenAddress);
        var destinationTokenAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(destinationTokenAddress);
        if (!(sourceQuantizationType in $342c61efd3810a3d$var$starkQuantizationTypeMap)) throw new Error("eth.starkSignOrderv2 invalid source quantization type=" + sourceQuantizationType);
        if (!(destinationQuantizationType in $342c61efd3810a3d$var$starkQuantizationTypeMap)) throw new Error("eth.starkSignOrderv2 invalid destination quantization type=" + destinationQuantizationType);
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4 + 1 + 20 + 32 + 32 + 1 + 20 + 32 + 32 + 4 + 4 + 8 + 8 + 4 + 4, 0);
        var offset = 0;
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        offset = 1 + 4 * paths.length;
        buffer[offset] = $342c61efd3810a3d$var$starkQuantizationTypeMap[sourceQuantizationType];
        offset++;
        if (sourceTokenAddressHex) sourceTokenAddressHex.copy(buffer, offset);
        offset += 20;
        if (sourceQuantization) $342c61efd3810a3d$require$Buffer.from(sourceQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        if (sourceMintableBlobOrTokenId) $342c61efd3810a3d$require$Buffer.from(sourceMintableBlobOrTokenId.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        buffer[offset] = $342c61efd3810a3d$var$starkQuantizationTypeMap[destinationQuantizationType];
        offset++;
        if (destinationTokenAddressHex) destinationTokenAddressHex.copy(buffer, offset);
        offset += 20;
        if (destinationQuantization) $342c61efd3810a3d$require$Buffer.from(destinationQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        if (destinationMintableBlobOrTokenId) $342c61efd3810a3d$require$Buffer.from(destinationMintableBlobOrTokenId.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        buffer.writeUInt32BE(sourceVault, offset);
        offset += 4;
        buffer.writeUInt32BE(destinationVault, offset);
        offset += 4;
        $342c61efd3810a3d$require$Buffer.from(amountSell.toString(16).padStart(16, "0"), "hex").copy(buffer, offset);
        offset += 8;
        $342c61efd3810a3d$require$Buffer.from(amountBuy.toString(16).padStart(16, "0"), "hex").copy(buffer, offset);
        offset += 8;
        buffer.writeUInt32BE(nonce, offset);
        offset += 4;
        buffer.writeUInt32BE(timestamp, offset);
        return this.transport.send(0xf0, 0x04, 0x03, 0x00, buffer).then(function(response) {
            var r = response.slice(1, 33).toString("hex");
            var s = response.slice(33, 65).toString("hex");
            return {
                r: r,
                s: s
            };
        });
    };
    /**
     * sign a Stark transfer
     * @param path a path in BIP 32 format
     * @option transferTokenAddress contract address of the token to be transferred (not present for ETH)
     * @param transferQuantization quantization used for the token to be transferred
     * @param targetPublicKey target Stark public key
     * @param sourceVault ID of the source vault
     * @param destinationVault ID of the destination vault
     * @param amountTransfer amount to transfer
     * @param nonce transaction nonce
     * @param timestamp transaction validity timestamp
     * @return the signature
     */ Eth.prototype.starkSignTransfer = function(path, transferTokenAddress, transferQuantization, targetPublicKey, sourceVault, destinationVault, amountTransfer, nonce, timestamp) {
        var transferTokenAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(transferTokenAddress);
        var targetPublicKeyHex = (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(targetPublicKey);
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4 + 20 + 32 + 32 + 4 + 4 + 8 + 4 + 4, 0);
        var offset = 0;
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        offset = 1 + 4 * paths.length;
        if (transferTokenAddressHex) transferTokenAddressHex.copy(buffer, offset);
        offset += 20;
        $342c61efd3810a3d$require$Buffer.from(transferQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        targetPublicKeyHex.copy(buffer, offset);
        offset += 32;
        buffer.writeUInt32BE(sourceVault, offset);
        offset += 4;
        buffer.writeUInt32BE(destinationVault, offset);
        offset += 4;
        $342c61efd3810a3d$require$Buffer.from(amountTransfer.toString(16).padStart(16, "0"), "hex").copy(buffer, offset);
        offset += 8;
        buffer.writeUInt32BE(nonce, offset);
        offset += 4;
        buffer.writeUInt32BE(timestamp, offset);
        return this.transport.send(0xf0, 0x04, 0x02, 0x00, buffer).then(function(response) {
            var r = response.slice(1, 33).toString("hex");
            var s = response.slice(33, 65).toString("hex");
            return {
                r: r,
                s: s
            };
        });
    };
    /**
     * sign a Stark transfer or conditional transfer using the Starkex V2 protocol
     * @param path a path in BIP 32 format
     * @option transferTokenAddress contract address of the token to be transferred (not present for ETH)
     * @param transferQuantizationType quantization type used for the token to be transferred
     * @option transferQuantization quantization used for the token to be transferred (not present for erc 721 or mintable erc 721)
     * @option transferMintableBlobOrTokenId mintable blob (mintable erc 20 / mintable erc 721) or token id (erc 721) associated to the token to be transferred
     * @param targetPublicKey target Stark public key
     * @param sourceVault ID of the source vault
     * @param destinationVault ID of the destination vault
     * @param amountTransfer amount to transfer
     * @param nonce transaction nonce
     * @param timestamp transaction validity timestamp
     * @option conditionalTransferAddress onchain address of the condition for a conditional transfer
     * @option conditionalTransferFact fact associated to the condition for a conditional transfer
     * @return the signature
     */ Eth.prototype.starkSignTransfer_v2 = function(path, transferTokenAddress, transferQuantizationType, transferQuantization, transferMintableBlobOrTokenId, targetPublicKey, sourceVault, destinationVault, amountTransfer, nonce, timestamp, conditionalTransferAddress, conditionalTransferFact) {
        var transferTokenAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(transferTokenAddress);
        var targetPublicKeyHex = (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(targetPublicKey);
        var conditionalTransferAddressHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(conditionalTransferAddress);
        if (!(transferQuantizationType in $342c61efd3810a3d$var$starkQuantizationTypeMap)) throw new Error("eth.starkSignTransferv2 invalid quantization type=" + transferQuantizationType);
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4 + 1 + 20 + 32 + 32 + 32 + 4 + 4 + 8 + 4 + 4 + (conditionalTransferAddressHex ? 52 : 0), 0);
        var offset = 0;
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        offset = 1 + 4 * paths.length;
        buffer[offset] = $342c61efd3810a3d$var$starkQuantizationTypeMap[transferQuantizationType];
        offset++;
        if (transferTokenAddressHex) transferTokenAddressHex.copy(buffer, offset);
        offset += 20;
        if (transferQuantization) $342c61efd3810a3d$require$Buffer.from(transferQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        if (transferMintableBlobOrTokenId) $342c61efd3810a3d$require$Buffer.from(transferMintableBlobOrTokenId.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        targetPublicKeyHex.copy(buffer, offset);
        offset += 32;
        buffer.writeUInt32BE(sourceVault, offset);
        offset += 4;
        buffer.writeUInt32BE(destinationVault, offset);
        offset += 4;
        $342c61efd3810a3d$require$Buffer.from(amountTransfer.toString(16).padStart(16, "0"), "hex").copy(buffer, offset);
        offset += 8;
        buffer.writeUInt32BE(nonce, offset);
        offset += 4;
        buffer.writeUInt32BE(timestamp, offset);
        if (conditionalTransferAddressHex && conditionalTransferFact) {
            offset += 4;
            $342c61efd3810a3d$require$Buffer.from(conditionalTransferFact.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
            offset += 32;
            conditionalTransferAddressHex.copy(buffer, offset);
        }
        return this.transport.send(0xf0, 0x04, conditionalTransferAddressHex ? 0x05 : 0x04, 0x00, buffer).then(function(response) {
            var r = response.slice(1, 33).toString("hex");
            var s = response.slice(33, 65).toString("hex");
            return {
                r: r,
                s: s
            };
        });
    };
    /**
     * provide quantization information before singing a deposit or withdrawal Stark powered contract call
     *
     * It shall be run following a provideERC20TokenInformation call for the given contract
     *
     * @param operationContract contract address of the token to be transferred (not present for ETH)
     * @param operationQuantization quantization used for the token to be transferred
     */ Eth.prototype.starkProvideQuantum = function(operationContract, operationQuantization) {
        var operationContractHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(operationContract);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(52, 0);
        if (operationContractHex) operationContractHex.copy(buffer, 0);
        $342c61efd3810a3d$require$Buffer.from(operationQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, 20);
        return this.transport.send(0xf0, 0x08, 0x00, 0x00, buffer).then(function() {
            return true;
        }, function(e) {
            if (e && e.statusCode === 0x6d00) // this case happen for ETH application versions not supporting Stark extensions
            return false;
            throw e;
        });
    };
    /**
     * provide quantization information before singing a deposit or withdrawal Stark powered contract call using the Starkex V2 protocol
     *
     * It shall be run following a provideERC20TokenInformation call for the given contract
     *
     * @param operationContract contract address of the token to be transferred (not present for ETH)
     * @param operationQuantizationType quantization type of the token to be transferred
     * @option operationQuantization quantization used for the token to be transferred (not present for erc 721 or mintable erc 721)
     * @option operationMintableBlobOrTokenId mintable blob (mintable erc 20 / mintable erc 721) or token id (erc 721) of the token to be transferred
     */ Eth.prototype.starkProvideQuantum_v2 = function(operationContract, operationQuantizationType, operationQuantization, operationMintableBlobOrTokenId) {
        var operationContractHex = (0, $f6a3edc136b9f477$export$89e6129ce4ebfefc)(operationContract);
        if (!(operationQuantizationType in $342c61efd3810a3d$var$starkQuantizationTypeMap)) throw new Error("eth.starkProvideQuantumV2 invalid quantization type=" + operationQuantizationType);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(84, 0);
        var offset = 0;
        if (operationContractHex) operationContractHex.copy(buffer, offset);
        offset += 20;
        if (operationQuantization) $342c61efd3810a3d$require$Buffer.from(operationQuantization.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        offset += 32;
        if (operationMintableBlobOrTokenId) $342c61efd3810a3d$require$Buffer.from(operationMintableBlobOrTokenId.toString(16).padStart(64, "0"), "hex").copy(buffer, offset);
        return this.transport.send(0xf0, 0x08, $342c61efd3810a3d$var$starkQuantizationTypeMap[operationQuantizationType], 0x00, buffer).then(function() {
            return true;
        }, function(e) {
            if (e && e.statusCode === 0x6d00) // this case happen for ETH application versions not supporting Stark extensions
            return false;
            throw e;
        });
    };
    /**
     * sign the given hash over the Stark curve
     * It is intended for speed of execution in case an unknown Stark model is pushed and should be avoided as much as possible.
     * @param path a path in BIP 32 format
     * @param hash hexadecimal hash to sign
     * @return the signature
     */ Eth.prototype.starkUnsafeSign = function(path, hash) {
        var hashHex = (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(hash);
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4 + 32);
        var offset = 0;
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        offset = 1 + 4 * paths.length;
        hashHex.copy(buffer, offset);
        return this.transport.send(0xf0, 0x0a, 0x00, 0x00, buffer).then(function(response) {
            var r = response.slice(1, 33).toString("hex");
            var s = response.slice(33, 65).toString("hex");
            return {
                r: r,
                s: s
            };
        });
    };
    /**
     * get an Ethereum 2 BLS-12 381 public key for a given BIP 32 path.
     * @param path a path in BIP 32 format
     * @option boolDisplay optionally enable or not the display
     * @return an object with a publicKey
     * @example
     * eth.eth2GetPublicKey("12381/3600/0/0").then(o => o.publicKey)
     */ Eth.prototype.eth2GetPublicKey = function(path, boolDisplay) {
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4);
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        return this.transport.send(0xe0, 0x0e, boolDisplay ? 0x01 : 0x00, 0x00, buffer).then(function(response) {
            return {
                publicKey: response.slice(0, -2).toString("hex")
            };
        });
    };
    /**
     * Set the index of a Withdrawal key used as withdrawal credentials in an ETH 2 deposit contract call signature
     *
     * It shall be run before the ETH 2 deposit transaction is signed. If not called, the index is set to 0
     *
     * @param withdrawalIndex index path in the EIP 2334 path m/12381/3600/withdrawalIndex/0
     * @return True if the method was executed successfully
     */ Eth.prototype.eth2SetWithdrawalIndex = function(withdrawalIndex) {
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(4, 0);
        buffer.writeUInt32BE(withdrawalIndex, 0);
        return this.transport.send(0xe0, 0x10, 0x00, 0x00, buffer).then(function() {
            return true;
        }, function(e) {
            if (e && e.statusCode === 0x6d00) // this case happen for ETH application versions not supporting ETH 2
            return false;
            throw e;
        });
    };
    /**
     * get a public encryption key on Curve25519 according to EIP 1024
     * @param path a path in BIP 32 format
     * @option boolDisplay optionally enable or not the display
     * @return an object with a publicKey
     * @example
     * eth.getEIP1024PublicEncryptionKey("44'/60'/0'/0/0").then(o => o.publicKey)
     */ Eth.prototype.getEIP1024PublicEncryptionKey = function(path, boolDisplay) {
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4);
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        return this.transport.send(0xe0, 0x18, boolDisplay ? 0x01 : 0x00, 0x00, buffer).then(function(response) {
            return {
                publicKey: response.slice(0, -2).toString("hex")
            };
        });
    };
    /**
     * get a shared secret on Curve25519 according to EIP 1024
     * @param path a path in BIP 32 format
     * @param remotePublicKeyHex remote Curve25519 public key
     * @option boolDisplay optionally enable or not the display
     * @return an object with a shared secret
     * @example
     * eth.getEIP1024SharedSecret("44'/60'/0'/0/0", "87020e80af6e07a6e4697f091eacadb9e7e6629cb7e5a8a371689a3ed53b3d64").then(o => o.sharedSecret)
     */ Eth.prototype.getEIP1024SharedSecret = function(path, remotePublicKeyHex, boolDisplay) {
        var paths = (0, $f6a3edc136b9f477$export$824c337f43f2b64d)(path);
        var remotePublicKey = (0, $f6a3edc136b9f477$export$864b00bc9b75231a)(remotePublicKeyHex);
        var buffer = $342c61efd3810a3d$require$Buffer.alloc(1 + paths.length * 4 + 32);
        var offset = 0;
        buffer[0] = paths.length;
        paths.forEach(function(element, index) {
            buffer.writeUInt32BE(element, 1 + 4 * index);
        });
        offset = 1 + 4 * paths.length;
        remotePublicKey.copy(buffer, offset);
        return this.transport.send(0xe0, 0x18, boolDisplay ? 0x01 : 0x00, 0x01, buffer).then(function(response) {
            return {
                sharedSecret: response.slice(0, -2).toString("hex")
            };
        });
    };
    Eth.prototype.provideERC20TokenInformation = function(_a) {
        var data = _a.data;
        return $342c61efd3810a3d$var$provideERC20TokenInformation(this.transport, data);
    };
    Eth.prototype.setExternalPlugin = function(pluginName, contractAddress, selector) {
        console.warn("hw-app-eth: eth.setExternalPlugin is deprecated. signTransaction solves this for you when providing it in `resolution`.");
        return $342c61efd3810a3d$var$setExternalPlugin(this.transport, pluginName, selector);
    };
    Eth.prototype.setPlugin = function(data) {
        console.warn("hw-app-eth: eth.setPlugin is deprecated. signTransaction solves this for you when providing it in `resolution`.");
        return $342c61efd3810a3d$var$setPlugin(this.transport, data);
    };
    return Eth;
}();
var $342c61efd3810a3d$export$2e2bcd8739ae039 = $342c61efd3810a3d$var$Eth;
// internal helpers
function $342c61efd3810a3d$var$provideERC20TokenInformation(transport, data) {
    return transport.send(0xe0, 0x0a, 0x00, 0x00, data).then(function() {
        return true;
    }, function(e) {
        if (e && e.statusCode === 0x6d00) // this case happen for older version of ETH app, since older app version had the ERC20 data hardcoded, it's fine to assume it worked.
        // we return a flag to know if the call was effective or not
        return false;
        throw e;
    });
}
function $342c61efd3810a3d$var$provideNFTInformation(transport, data) {
    return transport.send(0xe0, 0x14, 0x00, 0x00, data).then(function() {
        return true;
    }, function(e) {
        if (e && e.statusCode === 0x6d00) // older version of ETH app => error because we don't allow blind sign when NFT is explicitly requested to be resolved.
        throw new (0, $6e45af695d24937b$export$4876e60a0029a81c)();
        throw e;
    });
}
function $342c61efd3810a3d$var$setExternalPlugin(transport, payload, signature) {
    var payloadBuffer = $342c61efd3810a3d$require$Buffer.from(payload, "hex");
    var signatureBuffer = $342c61efd3810a3d$require$Buffer.from(signature, "hex");
    var buffer = $342c61efd3810a3d$require$Buffer.concat([
        payloadBuffer,
        signatureBuffer
    ]);
    return transport.send(0xe0, 0x12, 0x00, 0x00, buffer).then(function() {
        return true;
    }, function(e) {
        if (e && e.statusCode === 0x6a80) // this case happen when the plugin name is too short or too long
        return false;
        else if (e && e.statusCode === 0x6984) // this case happen when the plugin requested is not installed on the device
        return false;
        else if (e && e.statusCode === 0x6d00) // this case happen for older version of ETH app
        return false;
        throw e;
    });
}
function $342c61efd3810a3d$var$setPlugin(transport, data) {
    var buffer = $342c61efd3810a3d$require$Buffer.from(data, "hex");
    return transport.send(0xe0, 0x16, 0x00, 0x00, buffer).then(function() {
        return true;
    }, function(e) {
        if (e && e.statusCode === 0x6a80) // this case happen when the plugin name is too short or too long
        return false;
        else if (e && e.statusCode === 0x6984) // this case happen when the plugin requested is not installed on the device
        return false;
        else if (e && e.statusCode === 0x6d00) // this case happen for older version of ETH app
        return false;
        throw e;
    });
}


/********************************************************************************
 *   Ledger JS API for ICON
 *   (c) 2018 ICON Foundation
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ********************************************************************************/ //
// FIXME drop:

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $a7gqy = parcelRequire("a7gqy");
/********************************************************************************
 *   Ledger Node JS API for ICON
 *   (c) 2016-2017 Ledger
 *
 *  Modifications (c) 2018 ICON Foundation
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ********************************************************************************/ //
function $c2d3bd12dcbaeee6$export$260e5c0943f31606() {
    var resolve, reject;
    var promise = new Promise(function(success, failure) {
        resolve = success;
        reject = failure;
    });
    if (!resolve || !reject) throw "defer() error"; // this never happens and is just to make flow happy
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
function $c2d3bd12dcbaeee6$export$824c337f43f2b64d(path) {
    var result = [];
    var components = path.split("/");
    components.forEach(function(element) {
        var number = parseInt(element, 10);
        if (isNaN(number)) return; // FIXME shouldn't it throws instead?
        if (element.length > 1 && element[element.length - 1] === "'") number += 0x80000000;
        result.push(number);
    });
    return result;
}
function $c2d3bd12dcbaeee6$export$9bd663f1fadd104c(arr, fun) {
    return arr.reduce(function(p, e) {
        return p.then(function() {
            return fun(e);
        });
    }, Promise.resolve());
}
function $c2d3bd12dcbaeee6$export$8802485f9deae94f(arr, callback) {
    function iterate(index, array, result) {
        if (index >= array.length) return result;
        else return callback(array[index], index).then(function(res) {
            result.push(res);
            return iterate(index + 1, array, result);
        });
    }
    return Promise.resolve().then(function() {
        return iterate(0, arr, []);
    });
}
function $c2d3bd12dcbaeee6$export$69ccb85ac9ba86da(condition, callback) {
    return Promise.resolve().then(function() {
        if (condition) return callback();
    });
}
function $c2d3bd12dcbaeee6$export$4b2ecbe45ba1525d(predicate, callback) {
    function iterate(result) {
        if (!predicate()) return result;
        else return callback().then(function(res) {
            result.push(res);
            return iterate(result);
        });
    }
    return Promise.resolve([]).then(iterate);
}
function $c2d3bd12dcbaeee6$export$544112ebebdc5fa4(hexString) {
    return btoa(hexString.match(/\w{2}/g).map(function(a) {
        return String.fromCharCode(parseInt(a, 16));
    }).join(""));
}



var $ilnag = parcelRequire("ilnag");
var $11ba9be4553419b5$require$Buffer = $ilnag.Buffer;
var $11ba9be4553419b5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Icx(transport) {
        (0, $7dKN1._)(this, Icx);
        (0, $a7gqy._)(this, "transport", void 0);
        this.transport = transport;
        transport.decorateAppAPIMethods(this, [
            "getAddress",
            "signTransaction",
            "getAppConfiguration",
            "setTestPrivateKey"
        ], "ICON");
    }
    (0, $eW5pA._)(Icx, [
        {
            /**
   * Returns public key and ICON address for a given BIP 32 path.
   * @param path a path in BIP 32 format
   * @option boolDisplay optionally enable or not the display
   * @option boolChaincode optionally enable or not the chaincode request
   * @return an object with a publickey(hexa string), address(string) and
   *  (optionally) chaincode(hexa string)
   * @example
   * icx.getAddress("44'/4801368'/0'", true, true).then(o => o.address)
   */ key: "getAddress",
            value: function getAddress(path) {
                var boolDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, boolChaincode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var paths = (0, $c2d3bd12dcbaeee6$export$824c337f43f2b64d)(path);
                var buffer = new $11ba9be4553419b5$require$Buffer(1 + paths.length * 4);
                buffer[0] = paths.length;
                paths.forEach(function(element, index) {
                    buffer.writeUInt32BE(element, 1 + 4 * index);
                });
                return this.transport.send(0xe0, 0x02, boolDisplay ? 0x01 : 0x00, boolChaincode ? 0x01 : 0x00, buffer).then(function(response) {
                    var result = {};
                    var publicKeyLength = response[0];
                    result.publicKey = response.slice(1, 1 + publicKeyLength).toString("hex");
                    var addressLength = response[1 + publicKeyLength];
                    result.address = response.slice(1 + publicKeyLength + 1, 1 + publicKeyLength + 1 + addressLength);
                    if (boolChaincode) result.chainCode = response.slice(-32).toString("hex");
                    return result;
                });
            }
        },
        {
            /**
   * Signs a transaction and returns signed message given the raw transaction
   * and the BIP 32 path of the account to sign
   * @param path a path in BIP 32 format
   * @param rawTxAscii raw transaction data to sign in ASCII string format
   * @return an object with a base64 encoded signature and hash in hexa string
   * @example
   * icx.signTransaction("44'/4801368'/0'",
   *     "icx_sendTransaction.fee.0x2386f26fc10000." +
   *     "from.hxc9ecad30b05a0650a337452fce031e0c60eacc3a.nonce.0x3." +
   *     "to.hx4c5101add2caa6a920420cf951f7dd7c7df6ca24.value.0xde0b6b3a7640000")
   *   .then(result => ...)
   */ key: "signTransaction",
            value: function signTransaction(path, rawTxAscii) {
                var _loop = function() {
                    var maxChunkSize = offset === 0 ? 149 - paths.length * 4 - 4 : 150;
                    var chunkSize = offset + maxChunkSize > rawTx.length ? rawTx.length - offset : maxChunkSize;
                    var buffer = new $11ba9be4553419b5$require$Buffer(offset === 0 ? 1 + paths.length * 4 + 4 + chunkSize : chunkSize);
                    if (offset === 0) {
                        buffer[0] = paths.length;
                        paths.forEach(function(element, index) {
                            buffer.writeUInt32BE(element, 1 + 4 * index);
                        });
                        buffer.writeUInt32BE(rawTx.length, 1 + 4 * paths.length);
                        rawTx.copy(buffer, 1 + 4 * paths.length + 4, offset, offset + chunkSize);
                    } else rawTx.copy(buffer, 0, offset, offset + chunkSize);
                    toSend.push(buffer);
                    offset += chunkSize;
                };
                var _this = this;
                var paths = (0, $c2d3bd12dcbaeee6$export$824c337f43f2b64d)(path);
                var offset = 0;
                var rawTx = new $11ba9be4553419b5$require$Buffer(rawTxAscii);
                var toSend = [];
                var response;
                while(offset !== rawTx.length)_loop();
                return (0, $c2d3bd12dcbaeee6$export$8802485f9deae94f)(toSend, function(data, i) {
                    return _this.transport.send(0xe0, 0x04, i === 0 ? 0x00 : 0x80, 0x00, data).then(function(apduResponse) {
                        response = apduResponse;
                    });
                }).then(function() {
                    var result = {};
                    // r, s, v are aligned sequencially
                    result.signedRawTxBase64 = (0, $c2d3bd12dcbaeee6$export$544112ebebdc5fa4)(response.slice(0, 65).toString("hex"));
                    result.hashHex = response.slice(65, 97).toString("hex");
                    return result;
                });
            }
        },
        {
            /**
   * Returns the application configurations such as versions.
   * @return  major/minor/patch versions of Icon application
   */ key: "getAppConfiguration",
            value: function getAppConfiguration() {
                return this.transport.send(0xe0, 0x06, 0x00, 0x00).then(function(response) {
                    var result = {};
                    result.majorVersion = response[0];
                    result.minorVersion = response[1];
                    result.patchVersion = response[2];
                    return result;
                });
            }
        },
        {
            /**
   * Sets the given key as the test purpose private key corresponding to
   * "\0'" of BIP 32 path just for test purpose. After calling this function,
   * all functions with "\0'" path works based on this private key.
   * REMARK: Test purpose only such as verifying signTransaction function.
   * @param privateKeyHex private key in hexadecimal string format
   * @example
   * icx.setTestPrivateKey("23498dc21b9ee52e63e8d6566e0911ac255a38d3fcbc68a51e6b298520b72d6e")
   *   .then(result => ...)
   * icx.getAddress("0'", false, false).then(o => o.address)
   */ key: "setTestPrivateKey",
            value: function setTestPrivateKey(privateKeyHex) {
                var data = new $11ba9be4553419b5$require$Buffer(32);
                for(var i = 0; i < privateKeyHex.length; i += 2)data[i / 2] = parseInt(privateKeyHex.substr(i, 2), 16);
                return this.transport.send(0xe0, 0xff, 0x00, 0x00, data).then();
            }
        }
    ]);
    return Icx;
}();



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
/********************************************************************************
 *   Ledger Node JS API
 *   (c) 2017-2018 Ledger
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ********************************************************************************/ 
var $zGv1L = parcelRequire("zGv1L");

var $b8irb = parcelRequire("b8irb");

var $fXOt1 = parcelRequire("fXOt1");

var $ilnag = parcelRequire("ilnag");
var $93aaa0883ccdbf78$require$Buffer = $ilnag.Buffer;
function $93aaa0883ccdbf78$export$824c337f43f2b64d(path) {
    var result = [];
    var components = path.split("/");
    components.forEach(function(element) {
        var number = parseInt(element, 10);
        if (isNaN(number)) return; // FIXME shouldn't it throws instead?
        if (element.length > 1 && element[element.length - 1] === "'") number += 0x80000000;
        result.push(number);
    });
    return result;
}
function $93aaa0883ccdbf78$export$8802485f9deae94f(arr, callback) {
    function iterate(index, array, result) {
        if (index >= array.length) return result;
        else return callback(array[index], index).then(function(res) {
            result.push(res);
            return iterate(index + 1, array, result);
        });
    }
    return Promise.resolve().then(function() {
        return iterate(0, arr, []);
    });
}
function $93aaa0883ccdbf78$export$8635ccd907512d61(buf, previous) {
    var crc = typeof previous !== "undefined" ? ~~previous : 0x0;
    for(var index = 0; index < buf.length; index++){
        var byte = buf[index];
        var code = crc >>> 8 & 0xff;
        code ^= byte & 0xff;
        code ^= code >>> 4;
        crc = crc << 8 & 0xffff;
        crc ^= code;
        code = code << 5 & 0xffff;
        crc ^= code;
        code = code << 7 & 0xffff;
        crc ^= code;
    }
    return crc;
}
function $93aaa0883ccdbf78$export$db76eb67fafa33f3(rawPublicKey) {
    var versionByte = 48; // 'G'
    var data = $93aaa0883ccdbf78$require$Buffer.from(rawPublicKey);
    var versionBuffer = $93aaa0883ccdbf78$require$Buffer.from([
        versionByte
    ]);
    var payload = $93aaa0883ccdbf78$require$Buffer.concat([
        versionBuffer,
        data
    ]);
    var checksum = $93aaa0883ccdbf78$require$Buffer.alloc(2);
    checksum.writeUInt16LE($93aaa0883ccdbf78$export$8635ccd907512d61(payload), 0);
    var unencoded = $93aaa0883ccdbf78$require$Buffer.concat([
        payload,
        checksum
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($zGv1L))).encode(unencoded);
}
function $93aaa0883ccdbf78$export$f626d450622ec1db(data, signature, publicKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b8irb))).sign.detached.verify(new Uint8Array(data.toJSON().data), new Uint8Array(signature.toJSON().data), new Uint8Array(publicKey.toJSON().data));
}
function $93aaa0883ccdbf78$export$d6af199866bfb566(data) {
    var hasher = new (0, $fXOt1.sha256)();
    hasher.update(data, "utf8");
    return hasher.digest();
}
function $93aaa0883ccdbf78$export$59b837b91054ee36(path) {
    path.split("/").forEach(function(element) {
        if (!element.toString().endsWith("'")) throw new Error("Detected a non-hardened path element in requested BIP32 path. Non-hardended paths are not supported at this time. Please use an all-hardened path. Example: 44'/148'/0'");
    });
}



var $ilnag = parcelRequire("ilnag");
var $d44be13057c2c607$require$Buffer = $ilnag.Buffer;
var $d44be13057c2c607$var$CLA = 0xe0;
var $d44be13057c2c607$var$INS_GET_PK = 0x02;
var $d44be13057c2c607$var$INS_SIGN_TX = 0x04;
var $d44be13057c2c607$var$INS_GET_CONF = 0x06;
var $d44be13057c2c607$var$INS_SIGN_TX_HASH = 0x08;
var $d44be13057c2c607$var$INS_KEEP_ALIVE = 0x10;
var $d44be13057c2c607$var$APDU_MAX_SIZE = 150;
var $d44be13057c2c607$var$P1_FIRST_APDU = 0x00;
var $d44be13057c2c607$var$P1_MORE_APDU = 0x80;
var $d44be13057c2c607$var$P2_LAST_APDU = 0x00;
var $d44be13057c2c607$var$P2_MORE_APDU = 0x80;
var $d44be13057c2c607$var$SW_OK = 0x9000;
var $d44be13057c2c607$var$SW_CANCEL = 0x6985;
var $d44be13057c2c607$var$SW_UNKNOWN_OP = 0x6c24;
var $d44be13057c2c607$var$SW_MULTI_OP = 0x6c25;
var $d44be13057c2c607$var$SW_NOT_ALLOWED = 0x6c66;
var $d44be13057c2c607$var$SW_UNSUPPORTED = 0x6d00;
var $d44be13057c2c607$var$SW_KEEP_ALIVE = 0x6e02;
var $d44be13057c2c607$var$TX_MAX_SIZE = 1540;
var $d44be13057c2c607$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Str(transport) {
        var scrambleKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "l0v";
        (0, $7dKN1._)(this, Str);
        this.transport = transport;
        transport.decorateAppAPIMethods(this, [
            "getAppConfiguration",
            "getPublicKey",
            "signTransaction",
            "signHash"
        ], scrambleKey);
    }
    (0, $eW5pA._)(Str, [
        {
            key: "getAppConfiguration",
            value: function getAppConfiguration() {
                return this.transport.send($d44be13057c2c607$var$CLA, $d44be13057c2c607$var$INS_GET_CONF, 0x00, 0x00).then(function(response) {
                    var multiOpsEnabled = response[0] === 0x01 || response[1] < 0x02;
                    var version = "" + response[1] + "." + response[2] + "." + response[3];
                    return {
                        version: version,
                        multiOpsEnabled: multiOpsEnabled
                    };
                });
            }
        },
        {
            /**
     * get Stellar public key for a given BIP 32 path.
     * @param path a path in BIP 32 format
     * @option boolValidate optionally enable key pair validation
     * @option boolDisplay optionally enable or not the display
     * @return an object with the publicKey (using XLM public key format) and
     * the raw ed25519 public key.
     * @example
     * str.getPublicKey("44'/148'/0'").then(o => o.publicKey)
     */ key: "getPublicKey",
            value: function getPublicKey(path, boolValidate, boolDisplay) {
                var _this = this;
                (0, $93aaa0883ccdbf78$export$59b837b91054ee36)(path);
                var apdus = [];
                var response;
                var pathElts = (0, $93aaa0883ccdbf78$export$824c337f43f2b64d)(path);
                var buffer = $d44be13057c2c607$require$Buffer.alloc(1 + pathElts.length * 4);
                buffer[0] = pathElts.length;
                pathElts.forEach(function(element, index) {
                    buffer.writeUInt32BE(element, 1 + 4 * index);
                });
                var verifyMsg = $d44be13057c2c607$require$Buffer.from("via lumina", "ascii");
                apdus.push($d44be13057c2c607$require$Buffer.concat([
                    buffer,
                    verifyMsg
                ]));
                var keepAlive = false;
                return (0, $93aaa0883ccdbf78$export$8802485f9deae94f)(apdus, function(data) {
                    return _this.transport.send($d44be13057c2c607$var$CLA, keepAlive ? $d44be13057c2c607$var$INS_KEEP_ALIVE : $d44be13057c2c607$var$INS_GET_PK, boolValidate ? 0x01 : 0x00, boolDisplay ? 0x01 : 0x00, data, [
                        $d44be13057c2c607$var$SW_OK,
                        $d44be13057c2c607$var$SW_KEEP_ALIVE
                    ]).then(function(apduResponse) {
                        var status = $d44be13057c2c607$require$Buffer.from(apduResponse.slice(apduResponse.length - 2)).readUInt16BE(0);
                        if (status === $d44be13057c2c607$var$SW_KEEP_ALIVE) {
                            keepAlive = true;
                            apdus.push($d44be13057c2c607$require$Buffer.alloc(0));
                        }
                        response = apduResponse;
                    });
                }).then(function() {
                    // response = Buffer.from(response, 'hex');
                    var offset = 0;
                    var rawPublicKey = response.slice(offset, offset + 32);
                    offset += 32;
                    var publicKey = (0, $93aaa0883ccdbf78$export$db76eb67fafa33f3)(rawPublicKey);
                    if (boolValidate) {
                        var signature = response.slice(offset, offset + 64);
                        if (!(0, $93aaa0883ccdbf78$export$f626d450622ec1db)(verifyMsg, signature, rawPublicKey)) throw new Error("Bad signature. Keypair is invalid. Please report this.");
                    }
                    return {
                        publicKey: publicKey,
                        raw: rawPublicKey
                    };
                });
            }
        },
        {
            /**
     * sign a Stellar transaction.
     * @param path a path in BIP 32 format
     * @param transaction signature base of the transaction to sign
     * @return an object with the signature and the status
     * @example
     * str.signTransaction("44'/148'/0'", signatureBase).then(o => o.signature)
     */ key: "signTransaction",
            value: function signTransaction(path, transaction) {
                var _this = this;
                (0, $93aaa0883ccdbf78$export$59b837b91054ee36)(path);
                if (transaction.length > $d44be13057c2c607$var$TX_MAX_SIZE) throw new Error("Transaction too large: max = " + $d44be13057c2c607$var$TX_MAX_SIZE + "; actual = " + transaction.length);
                var apdus = [];
                var response;
                var pathElts = (0, $93aaa0883ccdbf78$export$824c337f43f2b64d)(path);
                var bufferSize = 1 + pathElts.length * 4;
                var buffer = $d44be13057c2c607$require$Buffer.alloc(bufferSize);
                buffer[0] = pathElts.length;
                pathElts.forEach(function(element, index) {
                    buffer.writeUInt32BE(element, 1 + 4 * index);
                });
                var chunkSize = $d44be13057c2c607$var$APDU_MAX_SIZE - bufferSize;
                if (transaction.length <= chunkSize) // it fits in a single apdu
                apdus.push($d44be13057c2c607$require$Buffer.concat([
                    buffer,
                    transaction
                ]));
                else {
                    // we need to send multiple apdus to transmit the entire transaction
                    var chunk = $d44be13057c2c607$require$Buffer.alloc(chunkSize);
                    var offset = 0;
                    transaction.copy(chunk, 0, offset, chunkSize);
                    apdus.push($d44be13057c2c607$require$Buffer.concat([
                        buffer,
                        chunk
                    ]));
                    offset += chunkSize;
                    while(offset < transaction.length){
                        var remaining = transaction.length - offset;
                        chunkSize = remaining < $d44be13057c2c607$var$APDU_MAX_SIZE ? remaining : $d44be13057c2c607$var$APDU_MAX_SIZE;
                        chunk = $d44be13057c2c607$require$Buffer.alloc(chunkSize);
                        transaction.copy(chunk, 0, offset, offset + chunkSize);
                        offset += chunkSize;
                        apdus.push(chunk);
                    }
                }
                var keepAlive = false;
                return (0, $93aaa0883ccdbf78$export$8802485f9deae94f)(apdus, function(data, i) {
                    return _this.transport.send($d44be13057c2c607$var$CLA, keepAlive ? $d44be13057c2c607$var$INS_KEEP_ALIVE : $d44be13057c2c607$var$INS_SIGN_TX, i === 0 ? $d44be13057c2c607$var$P1_FIRST_APDU : $d44be13057c2c607$var$P1_MORE_APDU, i === apdus.length - 1 ? $d44be13057c2c607$var$P2_LAST_APDU : $d44be13057c2c607$var$P2_MORE_APDU, data, [
                        $d44be13057c2c607$var$SW_OK,
                        $d44be13057c2c607$var$SW_CANCEL,
                        $d44be13057c2c607$var$SW_UNKNOWN_OP,
                        $d44be13057c2c607$var$SW_MULTI_OP,
                        $d44be13057c2c607$var$SW_KEEP_ALIVE
                    ]).then(function(apduResponse) {
                        var status = $d44be13057c2c607$require$Buffer.from(apduResponse.slice(apduResponse.length - 2)).readUInt16BE(0);
                        if (status === $d44be13057c2c607$var$SW_KEEP_ALIVE) {
                            keepAlive = true;
                            apdus.push($d44be13057c2c607$require$Buffer.alloc(0));
                        }
                        response = apduResponse;
                    });
                }).then(function() {
                    var status = $d44be13057c2c607$require$Buffer.from(response.slice(response.length - 2)).readUInt16BE(0);
                    if (status === $d44be13057c2c607$var$SW_OK) {
                        var signature = $d44be13057c2c607$require$Buffer.from(response.slice(0, response.length - 2));
                        return {
                            signature: signature
                        };
                    } else if (status === $d44be13057c2c607$var$SW_UNKNOWN_OP) // pre-v2 app version: fall back on hash signing
                    return _this.signHash_private(path, (0, $93aaa0883ccdbf78$export$d6af199866bfb566)(transaction));
                    else if (status === $d44be13057c2c607$var$SW_MULTI_OP) // multi-operation transaction: attempt hash signing
                    return _this.signHash_private(path, (0, $93aaa0883ccdbf78$export$d6af199866bfb566)(transaction));
                    else throw new Error("Transaction approval request was rejected");
                });
            }
        },
        {
            /**
     * sign a Stellar transaction hash.
     * @param path a path in BIP 32 format
     * @param hash hash of the transaction to sign
     * @return an object with the signature
     * @example
     * str.signHash("44'/148'/0'", hash).then(o => o.signature)
     */ key: "signHash",
            value: function signHash(path, hash) {
                (0, $93aaa0883ccdbf78$export$59b837b91054ee36)(path);
                return this.signHash_private(path, hash);
            }
        },
        {
            key: "signHash_private",
            value: function signHash_private(path, hash) {
                var _this = this;
                var apdus = [];
                var response;
                var pathElts = (0, $93aaa0883ccdbf78$export$824c337f43f2b64d)(path);
                var buffer = $d44be13057c2c607$require$Buffer.alloc(1 + pathElts.length * 4);
                buffer[0] = pathElts.length;
                pathElts.forEach(function(element, index) {
                    buffer.writeUInt32BE(element, 1 + 4 * index);
                });
                apdus.push($d44be13057c2c607$require$Buffer.concat([
                    buffer,
                    hash
                ]));
                var keepAlive = false;
                return (0, $93aaa0883ccdbf78$export$8802485f9deae94f)(apdus, function(data) {
                    return _this.transport.send($d44be13057c2c607$var$CLA, keepAlive ? $d44be13057c2c607$var$INS_KEEP_ALIVE : $d44be13057c2c607$var$INS_SIGN_TX_HASH, 0x00, 0x00, data, [
                        $d44be13057c2c607$var$SW_OK,
                        $d44be13057c2c607$var$SW_CANCEL,
                        $d44be13057c2c607$var$SW_NOT_ALLOWED,
                        $d44be13057c2c607$var$SW_UNSUPPORTED,
                        $d44be13057c2c607$var$SW_KEEP_ALIVE
                    ]).then(function(apduResponse) {
                        var status = $d44be13057c2c607$require$Buffer.from(apduResponse.slice(apduResponse.length - 2)).readUInt16BE(0);
                        if (status === $d44be13057c2c607$var$SW_KEEP_ALIVE) {
                            keepAlive = true;
                            apdus.push($d44be13057c2c607$require$Buffer.alloc(0));
                        }
                        response = apduResponse;
                    });
                }).then(function() {
                    var status = $d44be13057c2c607$require$Buffer.from(response.slice(response.length - 2)).readUInt16BE(0);
                    if (status === $d44be13057c2c607$var$SW_OK) {
                        var signature = $d44be13057c2c607$require$Buffer.from(response.slice(0, response.length - 2));
                        return {
                            signature: signature
                        };
                    } else if (status === $d44be13057c2c607$var$SW_CANCEL) throw new Error("Transaction approval request was rejected");
                    else if (status === $d44be13057c2c607$var$SW_UNSUPPORTED) throw new Error("Hash signing is not supported");
                    else throw new Error("Hash signing not allowed. Have you enabled it in the app settings?");
                });
            }
        }
    ]);
    return Str;
}();



var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");

var $6qu4b = parcelRequire("6qu4b");
var $5ff08816ee11028f$exports = {};
(function(root, factory) {
    // Hack to make all exports of this module sha256 function object properties.
    var exports = {};
    factory(exports);
    var sha256 = exports["default"];
    for(var k in exports)sha256[k] = exports[k];
    if (typeof $5ff08816ee11028f$exports === "object") $5ff08816ee11028f$exports = sha256;
    else if (typeof define === "function" && define.amd) define(function() {
        return sha256;
    });
    else root.sha256 = sha256;
})($5ff08816ee11028f$exports, function(exports) {
    "use strict";
    exports.__esModule = true;
    // SHA-256 (+ HMAC and PBKDF2) for JavaScript.
    //
    // Written in 2014-2016 by Dmitry Chestnykh.
    // Public domain, no warranty.
    //
    // Functions (accept and return Uint8Arrays):
    //
    //   sha256(message) -> hash
    //   sha256.hmac(key, message) -> mac
    //   sha256.pbkdf2(password, salt, rounds, dkLen) -> dk
    //
    //  Classes:
    //
    //   new sha256.Hash()
    //   new sha256.HMAC(key)
    //
    exports.digestLength = 32;
    exports.blockSize = 64;
    // SHA-256 constants
    var K = new Uint32Array([
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ]);
    function hashBlocks(w, v, p, pos, len) {
        var a, b, c, d, e, f, g, h, u, i, j, t1, t2;
        while(len >= 64){
            a = v[0];
            b = v[1];
            c = v[2];
            d = v[3];
            e = v[4];
            f = v[5];
            g = v[6];
            h = v[7];
            for(i = 0; i < 16; i++){
                j = pos + i * 4;
                w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
            }
            for(i = 16; i < 64; i++){
                u = w[i - 2];
                t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = w[i - 15];
                t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
            }
            for(i = 0; i < 64; i++){
                t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                h = g;
                g = f;
                f = e;
                e = d + t1 | 0;
                d = c;
                c = b;
                b = a;
                a = t1 + t2 | 0;
            }
            v[0] += a;
            v[1] += b;
            v[2] += c;
            v[3] += d;
            v[4] += e;
            v[5] += f;
            v[6] += g;
            v[7] += h;
            pos += 64;
            len -= 64;
        }
        return pos;
    }
    // Hash implements SHA256 hash algorithm.
    var Hash = /** @class */ function() {
        function Hash() {
            this.digestLength = exports.digestLength;
            this.blockSize = exports.blockSize;
            // Note: Int32Array is used instead of Uint32Array for performance reasons.
            this.state = new Int32Array(8); // hash state
            this.temp = new Int32Array(64); // temporary state
            this.buffer = new Uint8Array(128); // buffer for data to hash
            this.bufferLength = 0; // number of bytes in buffer
            this.bytesHashed = 0; // number of total bytes hashed
            this.finished = false; // indicates whether the hash was finalized
            this.reset();
        }
        // Resets hash state making it possible
        // to re-use this instance to hash other data.
        Hash.prototype.reset = function() {
            this.state[0] = 0x6a09e667;
            this.state[1] = 0xbb67ae85;
            this.state[2] = 0x3c6ef372;
            this.state[3] = 0xa54ff53a;
            this.state[4] = 0x510e527f;
            this.state[5] = 0x9b05688c;
            this.state[6] = 0x1f83d9ab;
            this.state[7] = 0x5be0cd19;
            this.bufferLength = 0;
            this.bytesHashed = 0;
            this.finished = false;
            return this;
        };
        // Cleans internal buffers and re-initializes hash state.
        Hash.prototype.clean = function() {
            for(var i = 0; i < this.buffer.length; i++)this.buffer[i] = 0;
            for(var i = 0; i < this.temp.length; i++)this.temp[i] = 0;
            this.reset();
        };
        // Updates hash state with the given data.
        //
        // Optionally, length of the data can be specified to hash
        // fewer bytes than data.length.
        //
        // Throws error when trying to update already finalized hash:
        // instance must be reset to use it again.
        Hash.prototype.update = function(data, dataLength) {
            if (dataLength === void 0) dataLength = data.length;
            if (this.finished) throw new Error("SHA256: can't update because hash was finished.");
            var dataPos = 0;
            this.bytesHashed += dataLength;
            if (this.bufferLength > 0) {
                while(this.bufferLength < 64 && dataLength > 0){
                    this.buffer[this.bufferLength++] = data[dataPos++];
                    dataLength--;
                }
                if (this.bufferLength === 64) {
                    hashBlocks(this.temp, this.state, this.buffer, 0, 64);
                    this.bufferLength = 0;
                }
            }
            if (dataLength >= 64) {
                dataPos = hashBlocks(this.temp, this.state, data, dataPos, dataLength);
                dataLength %= 64;
            }
            while(dataLength > 0){
                this.buffer[this.bufferLength++] = data[dataPos++];
                dataLength--;
            }
            return this;
        };
        // Finalizes hash state and puts hash into out.
        //
        // If hash was already finalized, puts the same value.
        Hash.prototype.finish = function(out) {
            if (!this.finished) {
                var bytesHashed = this.bytesHashed;
                var left = this.bufferLength;
                var bitLenHi = bytesHashed / 0x20000000 | 0;
                var bitLenLo = bytesHashed << 3;
                var padLength = bytesHashed % 64 < 56 ? 64 : 128;
                this.buffer[left] = 0x80;
                for(var i = left + 1; i < padLength - 8; i++)this.buffer[i] = 0;
                this.buffer[padLength - 8] = bitLenHi >>> 24 & 0xff;
                this.buffer[padLength - 7] = bitLenHi >>> 16 & 0xff;
                this.buffer[padLength - 6] = bitLenHi >>> 8 & 0xff;
                this.buffer[padLength - 5] = bitLenHi >>> 0 & 0xff;
                this.buffer[padLength - 4] = bitLenLo >>> 24 & 0xff;
                this.buffer[padLength - 3] = bitLenLo >>> 16 & 0xff;
                this.buffer[padLength - 2] = bitLenLo >>> 8 & 0xff;
                this.buffer[padLength - 1] = bitLenLo >>> 0 & 0xff;
                hashBlocks(this.temp, this.state, this.buffer, 0, padLength);
                this.finished = true;
            }
            for(var i = 0; i < 8; i++){
                out[i * 4 + 0] = this.state[i] >>> 24 & 0xff;
                out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
                out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
                out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
            }
            return this;
        };
        // Returns the final hash digest.
        Hash.prototype.digest = function() {
            var out = new Uint8Array(this.digestLength);
            this.finish(out);
            return out;
        };
        // Internal function for use in HMAC for optimization.
        Hash.prototype._saveState = function(out) {
            for(var i = 0; i < this.state.length; i++)out[i] = this.state[i];
        };
        // Internal function for use in HMAC for optimization.
        Hash.prototype._restoreState = function(from, bytesHashed) {
            for(var i = 0; i < this.state.length; i++)this.state[i] = from[i];
            this.bytesHashed = bytesHashed;
            this.finished = false;
            this.bufferLength = 0;
        };
        return Hash;
    }();
    exports.Hash = Hash;
    // HMAC implements HMAC-SHA256 message authentication algorithm.
    var HMAC = /** @class */ function() {
        function HMAC(key) {
            this.inner = new Hash();
            this.outer = new Hash();
            this.blockSize = this.inner.blockSize;
            this.digestLength = this.inner.digestLength;
            var pad = new Uint8Array(this.blockSize);
            if (key.length > this.blockSize) new Hash().update(key).finish(pad).clean();
            else for(var i = 0; i < key.length; i++)pad[i] = key[i];
            for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
            this.inner.update(pad);
            for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
            this.outer.update(pad);
            this.istate = new Uint32Array(8);
            this.ostate = new Uint32Array(8);
            this.inner._saveState(this.istate);
            this.outer._saveState(this.ostate);
            for(var i = 0; i < pad.length; i++)pad[i] = 0;
        }
        // Returns HMAC state to the state initialized with key
        // to make it possible to run HMAC over the other data with the same
        // key without creating a new instance.
        HMAC.prototype.reset = function() {
            this.inner._restoreState(this.istate, this.inner.blockSize);
            this.outer._restoreState(this.ostate, this.outer.blockSize);
            return this;
        };
        // Cleans HMAC state.
        HMAC.prototype.clean = function() {
            for(var i = 0; i < this.istate.length; i++)this.ostate[i] = this.istate[i] = 0;
            this.inner.clean();
            this.outer.clean();
        };
        // Updates state with provided data.
        HMAC.prototype.update = function(data) {
            this.inner.update(data);
            return this;
        };
        // Finalizes HMAC and puts the result in out.
        HMAC.prototype.finish = function(out) {
            if (this.outer.finished) this.outer.finish(out);
            else {
                this.inner.finish(out);
                this.outer.update(out, this.digestLength).finish(out);
            }
            return this;
        };
        // Returns message authentication code.
        HMAC.prototype.digest = function() {
            var out = new Uint8Array(this.digestLength);
            this.finish(out);
            return out;
        };
        return HMAC;
    }();
    exports.HMAC = HMAC;
    // Returns SHA256 hash of data.
    function hash(data) {
        var h = new Hash().update(data);
        var digest = h.digest();
        h.clean();
        return digest;
    }
    exports.hash = hash;
    // Function hash is both available as module.hash and as default export.
    exports["default"] = hash;
    // Returns HMAC-SHA256 of data under the key.
    function hmac(key, data) {
        var h = new HMAC(key).update(data);
        var digest = h.digest();
        h.clean();
        return digest;
    }
    exports.hmac = hmac;
    // Fills hkdf buffer like this:
    // T(1) = HMAC-Hash(PRK, T(0) | info | 0x01)
    function fillBuffer(buffer, hmac, info, counter) {
        // Counter is a byte value: check if it overflowed.
        var num = counter[0];
        if (num === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (num > 1) hmac.update(buffer);
        // Hash in info if it exists.
        if (info) hmac.update(info);
        // Hash in the counter.
        hmac.update(counter);
        // Output result to buffer and clean HMAC instance.
        hmac.finish(buffer);
        // Increment counter inside typed array, this works properly.
        counter[0]++;
    }
    var hkdfSalt = new Uint8Array(exports.digestLength); // Filled with zeroes.
    function hkdf(key, salt, info, length) {
        if (salt === void 0) salt = hkdfSalt;
        if (length === void 0) length = 32;
        var counter = new Uint8Array([
            1
        ]);
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = hmac(salt, key);
        // Initialize HMAC for expanding with extracted key.
        // Ensure no collisions with `hmac` function.
        var hmac_ = new HMAC(okm);
        // Allocate buffer.
        var buffer = new Uint8Array(hmac_.digestLength);
        var bufpos = buffer.length;
        var out = new Uint8Array(length);
        for(var i = 0; i < length; i++){
            if (bufpos === buffer.length) {
                fillBuffer(buffer, hmac_, info, counter);
                bufpos = 0;
            }
            out[i] = buffer[bufpos++];
        }
        hmac_.clean();
        buffer.fill(0);
        counter.fill(0);
        return out;
    }
    exports.hkdf = hkdf;
    // Derives a key from password and salt using PBKDF2-HMAC-SHA256
    // with the given number of iterations.
    //
    // The number of bytes returned is equal to dkLen.
    //
    // (For better security, avoid dkLen greater than hash length - 32 bytes).
    function pbkdf2(password, salt, iterations, dkLen) {
        var prf = new HMAC(password);
        var len = prf.digestLength;
        var ctr = new Uint8Array(4);
        var t = new Uint8Array(len);
        var u = new Uint8Array(len);
        var dk = new Uint8Array(dkLen);
        for(var i = 0; i * len < dkLen; i++){
            var c = i + 1;
            ctr[0] = c >>> 24 & 0xff;
            ctr[1] = c >>> 16 & 0xff;
            ctr[2] = c >>> 8 & 0xff;
            ctr[3] = c >>> 0 & 0xff;
            prf.reset();
            prf.update(salt);
            prf.update(ctr);
            prf.finish(u);
            for(var j = 0; j < len; j++)t[j] = u[j];
            for(var j = 2; j <= iterations; j++){
                prf.reset();
                prf.update(u).finish(u);
                for(var k = 0; k < len; k++)t[k] ^= u[k];
            }
            for(var j = 0; j < len && i * len + j < dkLen; j++)dk[i * len + j] = t[j];
        }
        for(var i = 0; i < len; i++)t[i] = u[i] = 0;
        for(var i = 0; i < 4; i++)ctr[i] = 0;
        prf.clean();
        return dk;
    }
    exports.pbkdf2 = pbkdf2;
});



var $ilnag = parcelRequire("ilnag");
var $9b6e4442a77ba03d$require$Buffer = $ilnag.Buffer;
var $9b6e4442a77ba03d$var$__accessCheck = function(obj, member, msg) {
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $9b6e4442a77ba03d$var$__privateGet = function(obj, member, getter) {
    $9b6e4442a77ba03d$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $9b6e4442a77ba03d$var$__privateAdd = function(obj, member, value) {
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $9b6e4442a77ba03d$var$__privateSet = function(obj, member, value, setter) {
    $9b6e4442a77ba03d$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $9b6e4442a77ba03d$var$__privateMethod = function(obj, member, method) {
    $9b6e4442a77ba03d$var$__accessCheck(obj, member, "access private method");
    return method;
};
var $9b6e4442a77ba03d$var$_verbose, $9b6e4442a77ba03d$var$_sendChunks, $9b6e4442a77ba03d$var$sendChunks_fn, $9b6e4442a77ba03d$var$_handleBlocksProtocol, $9b6e4442a77ba03d$var$handleBlocksProtocol_fn, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn;
var $9b6e4442a77ba03d$var$LedgerToHost = /* @__PURE__ */ function(LedgerToHost2) {
    LedgerToHost2[LedgerToHost2["RESULT_ACCUMULATING"] = 0] = "RESULT_ACCUMULATING";
    LedgerToHost2[LedgerToHost2["RESULT_FINAL"] = 1] = "RESULT_FINAL";
    LedgerToHost2[LedgerToHost2["GET_CHUNK"] = 2] = "GET_CHUNK";
    LedgerToHost2[LedgerToHost2["PUT_CHUNK"] = 3] = "PUT_CHUNK";
    return LedgerToHost2;
}($9b6e4442a77ba03d$var$LedgerToHost || {});
var $9b6e4442a77ba03d$var$HostToLedger = /* @__PURE__ */ function(HostToLedger2) {
    HostToLedger2[HostToLedger2["START"] = 0] = "START";
    HostToLedger2[HostToLedger2["GET_CHUNK_RESPONSE_SUCCESS"] = 1] = "GET_CHUNK_RESPONSE_SUCCESS";
    HostToLedger2[HostToLedger2["GET_CHUNK_RESPONSE_FAILURE"] = 2] = "GET_CHUNK_RESPONSE_FAILURE";
    HostToLedger2[HostToLedger2["PUT_CHUNK_RESPONSE"] = 3] = "PUT_CHUNK_RESPONSE";
    HostToLedger2[HostToLedger2["RESULT_ACCUMULATING_RESPONSE"] = 4] = "RESULT_ACCUMULATING_RESPONSE";
    return HostToLedger2;
}($9b6e4442a77ba03d$var$HostToLedger || {});
var $9b6e4442a77ba03d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Sui(transport) {
        var scrambleKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default_sui_scramble_key", verbose = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $7dKN1._)(this, Sui);
        /**
     * Convert a raw payload into what is essentially a singly-linked list of chunks, which
     * allows the ledger to re-seek the data in a secure fashion.
     */ $9b6e4442a77ba03d$var$__privateAdd(this, $9b6e4442a77ba03d$var$_sendChunks);
        $9b6e4442a77ba03d$var$__privateAdd(this, $9b6e4442a77ba03d$var$_handleBlocksProtocol);
        $9b6e4442a77ba03d$var$__privateAdd(this, $9b6e4442a77ba03d$var$_log);
        $9b6e4442a77ba03d$var$__privateAdd(this, $9b6e4442a77ba03d$var$_verbose, void 0);
        $9b6e4442a77ba03d$var$__privateSet(this, $9b6e4442a77ba03d$var$_verbose, verbose);
        this.transport = transport;
        this.transport.decorateAppAPIMethods(this, [
            "getPublicKey",
            "signTransaction",
            "getVersion"
        ], scrambleKey);
    }
    (0, $eW5pA._)(Sui, [
        {
            key: "getPublicKey",
            value: /**
   * Retrieves the public key associated with a particular BIP32 path from the Ledger app.
   *
   * @param path - the path to retrieve.
   * @param displayOnDevice - whether or not the address should be displayed on the device.
   *
   */ function getPublicKey(path) {
                var displayOnDevice = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var cla, ins, p1, p2, payload, response, keySize, publicKey, address, addressSize, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cla = 0;
                                ins = displayOnDevice ? 1 : 2;
                                p1 = 0;
                                p2 = 0;
                                payload = $9b6e4442a77ba03d$var$buildBip32KeyPayload(path);
                                return [
                                    4,
                                    $9b6e4442a77ba03d$var$__privateMethod(_this, $9b6e4442a77ba03d$var$_sendChunks, $9b6e4442a77ba03d$var$sendChunks_fn).call(_this, cla, ins, p1, p2, payload)
                                ];
                            case 1:
                                response = _state.sent();
                                keySize = response[0];
                                publicKey = response.slice(1, keySize + 1);
                                address = null;
                                if (response.length > keySize + 2) {
                                    addressSize = response[keySize + 1];
                                    address = response.slice(keySize + 2, keySize + 2 + addressSize);
                                }
                                res = {
                                    publicKey: publicKey,
                                    address: address
                                };
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signTransaction",
            value: /**
   * Sign a transaction with the key at a BIP32 path.
   *
   * @param txn - The transaction; this can be any of a node Buffer, Uint8Array, or a hexadecimal string, encoding the form of the transaction appropriate for hashing and signing.
   * @param path - the path to use when signing the transaction.
   */ function signTransaction(path, txn) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var cla, ins, p1, p2, rawTxn, hashSize, bip32KeyPayload, payload_txn, signature;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cla = 0;
                                ins = 3;
                                p1 = 0;
                                p2 = 0;
                                if ($9b6e4442a77ba03d$var$__privateGet(_this, $9b6e4442a77ba03d$var$_verbose)) $9b6e4442a77ba03d$var$__privateMethod(_this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(_this, txn);
                                rawTxn = typeof txn == "string" ? $9b6e4442a77ba03d$require$Buffer.from(txn, "hex") : $9b6e4442a77ba03d$require$Buffer.from(txn);
                                hashSize = $9b6e4442a77ba03d$require$Buffer.alloc(4);
                                hashSize.writeUInt32LE(rawTxn.length, 0);
                                bip32KeyPayload = $9b6e4442a77ba03d$var$buildBip32KeyPayload(path);
                                payload_txn = $9b6e4442a77ba03d$require$Buffer.concat([
                                    hashSize,
                                    rawTxn
                                ]);
                                $9b6e4442a77ba03d$var$__privateMethod(_this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(_this, "Payload Txn", payload_txn);
                                return [
                                    4,
                                    $9b6e4442a77ba03d$var$__privateMethod(_this, $9b6e4442a77ba03d$var$_sendChunks, $9b6e4442a77ba03d$var$sendChunks_fn).call(_this, cla, ins, p1, p2, [
                                        payload_txn,
                                        bip32KeyPayload
                                    ])
                                ];
                            case 1:
                                signature = _state.sent();
                                return [
                                    2,
                                    {
                                        signature: signature
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVersion",
            value: /**
   * Retrieve the app version on the attached Ledger device.
   */ function getVersion() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, major, minor, patch;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9b6e4442a77ba03d$var$__privateMethod(_this, $9b6e4442a77ba03d$var$_sendChunks, $9b6e4442a77ba03d$var$sendChunks_fn).call(_this, 0, 0, 0, 0, $9b6e4442a77ba03d$require$Buffer.alloc(1))
                                ];
                            case 1:
                                _ref = (0, $5OlIx._).apply(void 0, [
                                    _state.sent(),
                                    3
                                ]), major = _ref[0], minor = _ref[1], patch = _ref[2];
                                return [
                                    2,
                                    {
                                        major: major,
                                        minor: minor,
                                        patch: patch
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Sui;
}();
$9b6e4442a77ba03d$var$_verbose = new WeakMap();
$9b6e4442a77ba03d$var$_sendChunks = new WeakSet();
$9b6e4442a77ba03d$var$sendChunks_fn = function() {
    var _ref = (0, $6rBFC._)(function(cla, ins, p1, p2, payload) {
        var _this, _loop, extraData, _this1, chunkSize, parameterList, data, j;
        var _arguments = arguments;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this, _loop = function(j) {
                        var chunkList = [];
                        for(var i = 0; i < payload[j].length; i += chunkSize){
                            var cur = payload[j].slice(i, i + chunkSize);
                            chunkList.push(cur);
                        }
                        var lastHash = $9b6e4442a77ba03d$require$Buffer.alloc(32);
                        $9b6e4442a77ba03d$var$__privateMethod(_this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(_this, lastHash);
                        data = chunkList.reduceRight(function(blocks, chunk) {
                            var linkedChunk = $9b6e4442a77ba03d$require$Buffer.concat([
                                lastHash,
                                chunk
                            ]);
                            $9b6e4442a77ba03d$var$__privateMethod(_this1, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(_this1, "Chunk: ", chunk);
                            $9b6e4442a77ba03d$var$__privateMethod(_this1, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(_this1, "linkedChunk: ", linkedChunk);
                            lastHash = $9b6e4442a77ba03d$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($5ff08816ee11028f$exports)))(linkedChunk));
                            blocks.set(lastHash.toString("hex"), linkedChunk);
                            return blocks;
                        }, data);
                        parameterList.push(lastHash);
                        lastHash = $9b6e4442a77ba03d$require$Buffer.alloc(32);
                    };
                    extraData = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : /* @__PURE__ */ new Map();
                    _this1 = this;
                    chunkSize = 180;
                    if (!(payload instanceof Array)) payload = [
                        payload
                    ];
                    parameterList = [];
                    data = new Map(extraData);
                    for(j = 0; j < payload.length; j++)_loop(j);
                    $9b6e4442a77ba03d$var$__privateMethod(this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(this, data);
                    return [
                        4,
                        $9b6e4442a77ba03d$var$__privateMethod(this, $9b6e4442a77ba03d$var$_handleBlocksProtocol, $9b6e4442a77ba03d$var$handleBlocksProtocol_fn).call(this, cla, ins, p1, p2, $9b6e4442a77ba03d$require$Buffer.concat([
                            $9b6e4442a77ba03d$require$Buffer.from([
                                0 /* START */ 
                            ])
                        ].concat(parameterList)), data)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function(cla, ins, p1, p2, payload) {
        return _ref.apply(this, arguments);
    };
}();
$9b6e4442a77ba03d$var$_handleBlocksProtocol = new WeakSet();
$9b6e4442a77ba03d$var$handleBlocksProtocol_fn = function() {
    var _ref = (0, $6rBFC._)(function(cla, ins, p1, p2, initialPayload, data) {
        var payload, result, rv, rv_instruction, rv_payload, chunk;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = initialPayload;
                    result = $9b6e4442a77ba03d$require$Buffer.alloc(0);
                    _state.label = 1;
                case 1:
                    $9b6e4442a77ba03d$var$__privateMethod(this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(this, "Sending payload to ledger: ", payload.toString("hex"));
                    return [
                        4,
                        this.transport.send(cla, ins, p1, p2, payload)
                    ];
                case 2:
                    rv = _state.sent();
                    $9b6e4442a77ba03d$var$__privateMethod(this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(this, "Received response: ", rv);
                    rv_instruction = rv[0];
                    rv_payload = rv.slice(1, rv.length - 2);
                    if (!(rv_instruction in $9b6e4442a77ba03d$var$LedgerToHost)) throw new TypeError("Unknown instruction returned from ledger");
                    switch(rv_instruction){
                        case 0 /* RESULT_ACCUMULATING */ :
                        case 1 /* RESULT_FINAL */ :
                            result = $9b6e4442a77ba03d$require$Buffer.concat([
                                result,
                                rv_payload
                            ]);
                            payload = $9b6e4442a77ba03d$require$Buffer.from([
                                4 /* RESULT_ACCUMULATING_RESPONSE */ 
                            ]);
                            break;
                        case 2 /* GET_CHUNK */ :
                            chunk = data.get(rv_payload.toString("hex"));
                            $9b6e4442a77ba03d$var$__privateMethod(this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(this, "Getting block ", rv_payload);
                            $9b6e4442a77ba03d$var$__privateMethod(this, $9b6e4442a77ba03d$var$_log, $9b6e4442a77ba03d$var$log_fn).call(this, "Found block ", chunk);
                            if (chunk) payload = $9b6e4442a77ba03d$require$Buffer.concat([
                                $9b6e4442a77ba03d$require$Buffer.from([
                                    1 /* GET_CHUNK_RESPONSE_SUCCESS */ 
                                ]),
                                chunk
                            ]);
                            else payload = $9b6e4442a77ba03d$require$Buffer.from([
                                2 /* GET_CHUNK_RESPONSE_FAILURE */ 
                            ]);
                            break;
                        case 3 /* PUT_CHUNK */ :
                            data.set($9b6e4442a77ba03d$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($5ff08816ee11028f$exports)))(rv_payload)).toString("hex"), rv_payload);
                            payload = $9b6e4442a77ba03d$require$Buffer.from([
                                3 /* PUT_CHUNK_RESPONSE */ 
                            ]);
                            break;
                    }
                    _state.label = 3;
                case 3:
                    if (rv_instruction !== 1 /* RESULT_FINAL */ ) return [
                        3,
                        1
                    ];
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function(cla, ins, p1, p2, initialPayload, data) {
        return _ref.apply(this, arguments);
    };
}();
$9b6e4442a77ba03d$var$_log = new WeakSet();
$9b6e4442a77ba03d$var$log_fn = function log_fn() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if ($9b6e4442a77ba03d$var$__privateGet(this, $9b6e4442a77ba03d$var$_verbose)) console.log(args);
};
function $9b6e4442a77ba03d$var$buildBip32KeyPayload(path) {
    var paths = $9b6e4442a77ba03d$var$splitPath(path);
    var payload = $9b6e4442a77ba03d$require$Buffer.alloc(1 + paths.length * 4);
    payload[0] = paths.length;
    paths.forEach(function(element, index) {
        payload.writeUInt32LE(element, 1 + 4 * index);
    });
    return payload;
}
function $9b6e4442a77ba03d$var$splitPath(path) {
    var result = [];
    var components = path.split("/");
    components.forEach(function(element) {
        var number = parseInt(element, 10);
        if (isNaN(number)) return;
        if (element.length > 1 && element[element.length - 1] === "'") number += 2147483648;
        result.push(number);
    });
    return result;
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
var $3ddfffd3116f371d$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $iKDDq = parcelRequire("iKDDq");









































$3ddfffd3116f371d$exports = {
    re: $iKDDq.re,
    src: $iKDDq.src,
    tokens: $iKDDq.t,
    SEMVER_SPEC_VERSION: (parcelRequire("cu7qF")).SEMVER_SPEC_VERSION,
    SemVer: (parcelRequire("fhQ3r")),
    compareIdentifiers: (parcelRequire("2adro")).compareIdentifiers,
    rcompareIdentifiers: (parcelRequire("2adro")).rcompareIdentifiers,
    parse: (parcelRequire("89yo3")),
    valid: (parcelRequire("cU1KI")),
    clean: (parcelRequire("tGB4i")),
    inc: (parcelRequire("e89SQ")),
    diff: (parcelRequire("8vn9F")),
    major: (parcelRequire("dsuoG")),
    minor: (parcelRequire("eLH0Y")),
    patch: (parcelRequire("dV01e")),
    prerelease: (parcelRequire("bRYnC")),
    compare: (parcelRequire("gn47S")),
    rcompare: (parcelRequire("dslSA")),
    compareLoose: (parcelRequire("aiY67")),
    compareBuild: (parcelRequire("hUEHc")),
    sort: (parcelRequire("2RmpA")),
    rsort: (parcelRequire("4VEN0")),
    gt: (parcelRequire("9na5M")),
    lt: (parcelRequire("5wPAk")),
    eq: (parcelRequire("1yJ7B")),
    neq: (parcelRequire("52O0B")),
    gte: (parcelRequire("8QHW3")),
    lte: (parcelRequire("iVLRd")),
    cmp: (parcelRequire("bYOEb")),
    coerce: (parcelRequire("d3reA")),
    Comparator: (parcelRequire("1sSb8")),
    Range: (parcelRequire("i08Aw")),
    satisfies: (parcelRequire("B9qRr")),
    toComparators: (parcelRequire("60tE2")),
    maxSatisfying: (parcelRequire("3hIaE")),
    minSatisfying: (parcelRequire("fftIS")),
    minVersion: (parcelRequire("dZtqZ")),
    validRange: (parcelRequire("6IbnX")),
    outside: (parcelRequire("4pFRl")),
    gtr: (parcelRequire("hTmzP")),
    ltr: (parcelRequire("f1Vlz")),
    intersects: (parcelRequire("fqkAs")),
    simplifyRange: (parcelRequire("fgwwn")),
    subset: (parcelRequire("4GVuP"))
};



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");
var $9ce982a108f9bffc$exports = {};
"use strict";
Object.defineProperty($9ce982a108f9bffc$exports, "__esModule", {
    value: true
});
var $11dde517550f9000$exports = {};
"use strict";
Object.defineProperty($11dde517550f9000$exports, "__esModule", {
    value: true
});
var $fc19772f4e9ed7f5$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $fc19772f4e9ed7f5$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($fc19772f4e9ed7f5$exports, "__esModule", {
    value: true
});
var $a0616478670a7883$exports = {};
"use strict";
Object.defineProperty($a0616478670a7883$exports, "__esModule", {
    value: true
});

var $jMOyI = parcelRequire("jMOyI");

var $c9AEc = parcelRequire("c9AEc");
function $a0616478670a7883$var$hash160(buffer) {
    var sha256Hash = $jMOyI("sha256").update(buffer).digest();
    try {
        return $jMOyI("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $jMOyI("ripemd160").update(sha256Hash).digest();
    }
}
$a0616478670a7883$exports.hash160 = $a0616478670a7883$var$hash160;
function $a0616478670a7883$var$hmacSHA512(key, data) {
    return $c9AEc("sha512", key).update(data).digest();
}
$a0616478670a7883$exports.hmacSHA512 = $a0616478670a7883$var$hmacSHA512;


var $3edaade963281bc2$exports = {};
"use strict";

var $jMOyI = parcelRequire("jMOyI");
var $4aba75115b5c38ab$exports = {};
"use strict";

var $gYRJ8 = parcelRequire("gYRJ8");

var $b1nU2 = parcelRequire("b1nU2");
var $4aba75115b5c38ab$require$Buffer = $b1nU2.Buffer;
$4aba75115b5c38ab$exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $gYRJ8.encode($4aba75115b5c38ab$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $gYRJ8.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $gYRJ8.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};


// SHA256(SHA256(buffer))
function $3edaade963281bc2$var$sha256x2(buffer) {
    var tmp = $jMOyI("sha256").update(buffer).digest();
    return $jMOyI("sha256").update(tmp).digest();
}
$3edaade963281bc2$exports = $4aba75115b5c38ab$exports($3edaade963281bc2$var$sha256x2);


var $a051056425522516$exports = {};

var $ilnag = parcelRequire("ilnag");
var $a051056425522516$require$Buffer = $ilnag.Buffer;

var $42mVo = parcelRequire("42mVo");

var $aW3Sp = parcelRequire("aW3Sp");
var $a051056425522516$require$EC = $aW3Sp.ec;
var $a051056425522516$var$secp256k1 = new $a051056425522516$require$EC("secp256k1");
var $405d9f8b3a66eabf$exports = {};

var $ilnag = parcelRequire("ilnag");
var $405d9f8b3a66eabf$require$Buffer = $ilnag.Buffer;

var $c9AEc = parcelRequire("c9AEc");
var $405d9f8b3a66eabf$var$ONE1 = $405d9f8b3a66eabf$require$Buffer.alloc(1, 1);
var $405d9f8b3a66eabf$var$ZERO1 = $405d9f8b3a66eabf$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $405d9f8b3a66eabf$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    var k = $405d9f8b3a66eabf$require$Buffer.alloc(32, 0);
    var v = $405d9f8b3a66eabf$require$Buffer.alloc(32, 1);
    // Step D
    k = $c9AEc("sha256", k).update(v).update($405d9f8b3a66eabf$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $c9AEc("sha256", k).update(v).digest();
    // Step F
    k = $c9AEc("sha256", k).update(v).update($405d9f8b3a66eabf$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $c9AEc("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $c9AEc("sha256", k).update(v).digest();
    var T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $c9AEc("sha256", k).update(v).update($405d9f8b3a66eabf$var$ZERO1).digest();
        v = $c9AEc("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $c9AEc("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
$405d9f8b3a66eabf$exports = $405d9f8b3a66eabf$var$deterministicGenerateK;


var $a051056425522516$var$ZERO32 = $a051056425522516$require$Buffer.alloc(32, 0);
var $a051056425522516$var$EC_GROUP_ORDER = $a051056425522516$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
var $a051056425522516$var$EC_P = $a051056425522516$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
var $a051056425522516$var$n = $a051056425522516$var$secp256k1.curve.n;
var $a051056425522516$var$nDiv2 = $a051056425522516$var$n.shrn(1);
var $a051056425522516$var$G = $a051056425522516$var$secp256k1.curve.g;
var $a051056425522516$var$THROW_BAD_PRIVATE = "Expected Private";
var $a051056425522516$var$THROW_BAD_POINT = "Expected Point";
var $a051056425522516$var$THROW_BAD_TWEAK = "Expected Tweak";
var $a051056425522516$var$THROW_BAD_HASH = "Expected Hash";
var $a051056425522516$var$THROW_BAD_SIGNATURE = "Expected Signature";
var $a051056425522516$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $a051056425522516$var$isScalar(x) {
    return $a051056425522516$require$Buffer.isBuffer(x) && x.length === 32;
}
function $a051056425522516$var$isOrderScalar(x) {
    if (!$a051056425522516$var$isScalar(x)) return false;
    return x.compare($a051056425522516$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $a051056425522516$var$isPoint(p) {
    if (!$a051056425522516$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    var t = p[0];
    var x = p.slice(1, 33);
    if (x.compare($a051056425522516$var$ZERO32) === 0) return false;
    if (x.compare($a051056425522516$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $a051056425522516$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    var y = p.slice(33);
    if (y.compare($a051056425522516$var$ZERO32) === 0) return false;
    if (y.compare($a051056425522516$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $a051056425522516$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $a051056425522516$var$isPointCompressed(p) {
    if (!$a051056425522516$var$isPoint(p)) return false;
    return $a051056425522516$var$__isPointCompressed(p);
}
function $a051056425522516$var$isPrivate(x) {
    if (!$a051056425522516$var$isScalar(x)) return false;
    return x.compare($a051056425522516$var$ZERO32) > 0 && // > 0
    x.compare($a051056425522516$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $a051056425522516$var$isSignature(value) {
    var r = value.slice(0, 32);
    var s = value.slice(32, 64);
    return $a051056425522516$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($a051056425522516$var$EC_GROUP_ORDER) < 0 && s.compare($a051056425522516$var$EC_GROUP_ORDER) < 0;
}
function $a051056425522516$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $a051056425522516$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $a051056425522516$var$fromBuffer(d) {
    return new $42mVo(d);
}
function $a051056425522516$var$toBuffer(d) {
    return d.toArrayLike($a051056425522516$require$Buffer, "be", 32);
}
function $a051056425522516$var$decodeFrom(P) {
    return $a051056425522516$var$secp256k1.curve.decodePoint(P);
}
function $a051056425522516$var$getEncoded(P, compressed) {
    return $a051056425522516$require$Buffer.from(P._encode(compressed));
}
function $a051056425522516$var$pointAdd(pA, pB, __compressed) {
    if (!$a051056425522516$var$isPoint(pA)) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    if (!$a051056425522516$var$isPoint(pB)) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    var a = $a051056425522516$var$decodeFrom(pA);
    var b = $a051056425522516$var$decodeFrom(pB);
    var pp = a.add(b);
    if (pp.isInfinity()) return null;
    var compressed = $a051056425522516$var$assumeCompression(__compressed, pA);
    return $a051056425522516$var$getEncoded(pp, compressed);
}
function $a051056425522516$var$pointAddScalar(p, tweak, __compressed) {
    if (!$a051056425522516$var$isPoint(p)) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    if (!$a051056425522516$var$isOrderScalar(tweak)) throw new TypeError($a051056425522516$var$THROW_BAD_TWEAK);
    var compressed = $a051056425522516$var$assumeCompression(__compressed, p);
    var pp = $a051056425522516$var$decodeFrom(p);
    if (tweak.compare($a051056425522516$var$ZERO32) === 0) return $a051056425522516$var$getEncoded(pp, compressed);
    var tt = $a051056425522516$var$fromBuffer(tweak);
    var qq = $a051056425522516$var$G.mul(tt);
    var uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $a051056425522516$var$getEncoded(uu, compressed);
}
function $a051056425522516$var$pointCompress(p, __compressed) {
    if (!$a051056425522516$var$isPoint(p)) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    var pp = $a051056425522516$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    var compressed = $a051056425522516$var$assumeCompression(__compressed, p);
    return $a051056425522516$var$getEncoded(pp, compressed);
}
function $a051056425522516$var$pointFromScalar(d, __compressed) {
    if (!$a051056425522516$var$isPrivate(d)) throw new TypeError($a051056425522516$var$THROW_BAD_PRIVATE);
    var dd = $a051056425522516$var$fromBuffer(d);
    var pp = $a051056425522516$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    var compressed = $a051056425522516$var$assumeCompression(__compressed);
    return $a051056425522516$var$getEncoded(pp, compressed);
}
function $a051056425522516$var$pointMultiply(p, tweak, __compressed) {
    if (!$a051056425522516$var$isPoint(p)) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    if (!$a051056425522516$var$isOrderScalar(tweak)) throw new TypeError($a051056425522516$var$THROW_BAD_TWEAK);
    var compressed = $a051056425522516$var$assumeCompression(__compressed, p);
    var pp = $a051056425522516$var$decodeFrom(p);
    var tt = $a051056425522516$var$fromBuffer(tweak);
    var qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $a051056425522516$var$getEncoded(qq, compressed);
}
function $a051056425522516$var$privateAdd(d, tweak) {
    if (!$a051056425522516$var$isPrivate(d)) throw new TypeError($a051056425522516$var$THROW_BAD_PRIVATE);
    if (!$a051056425522516$var$isOrderScalar(tweak)) throw new TypeError($a051056425522516$var$THROW_BAD_TWEAK);
    var dd = $a051056425522516$var$fromBuffer(d);
    var tt = $a051056425522516$var$fromBuffer(tweak);
    var dt = $a051056425522516$var$toBuffer(dd.add(tt).umod($a051056425522516$var$n));
    if (!$a051056425522516$var$isPrivate(dt)) return null;
    return dt;
}
function $a051056425522516$var$privateSub(d, tweak) {
    if (!$a051056425522516$var$isPrivate(d)) throw new TypeError($a051056425522516$var$THROW_BAD_PRIVATE);
    if (!$a051056425522516$var$isOrderScalar(tweak)) throw new TypeError($a051056425522516$var$THROW_BAD_TWEAK);
    var dd = $a051056425522516$var$fromBuffer(d);
    var tt = $a051056425522516$var$fromBuffer(tweak);
    var dt = $a051056425522516$var$toBuffer(dd.sub(tt).umod($a051056425522516$var$n));
    if (!$a051056425522516$var$isPrivate(dt)) return null;
    return dt;
}
function $a051056425522516$var$sign(hash, x) {
    return $a051056425522516$var$__sign(hash, x);
}
function $a051056425522516$var$signWithEntropy(hash, x, addData) {
    return $a051056425522516$var$__sign(hash, x, addData);
}
function $a051056425522516$var$__sign(hash, x, addData) {
    if (!$a051056425522516$var$isScalar(hash)) throw new TypeError($a051056425522516$var$THROW_BAD_HASH);
    if (!$a051056425522516$var$isPrivate(x)) throw new TypeError($a051056425522516$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$a051056425522516$var$isScalar(addData)) throw new TypeError($a051056425522516$var$THROW_BAD_EXTRA_DATA);
    var d = $a051056425522516$var$fromBuffer(x);
    var e = $a051056425522516$var$fromBuffer(hash);
    var r, s;
    var checkSig = function checkSig(k) {
        var kI = $a051056425522516$var$fromBuffer(k);
        var Q = $a051056425522516$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($a051056425522516$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($a051056425522516$var$n).mul(e.add(d.mul(r))).umod($a051056425522516$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $405d9f8b3a66eabf$exports(hash, x, checkSig, $a051056425522516$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($a051056425522516$var$nDiv2) > 0) s = $a051056425522516$var$n.sub(s);
    var buffer = $a051056425522516$require$Buffer.allocUnsafe(64);
    $a051056425522516$var$toBuffer(r).copy(buffer, 0);
    $a051056425522516$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $a051056425522516$var$verify(hash, q, signature, strict) {
    if (!$a051056425522516$var$isScalar(hash)) throw new TypeError($a051056425522516$var$THROW_BAD_HASH);
    if (!$a051056425522516$var$isPoint(q)) throw new TypeError($a051056425522516$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$a051056425522516$var$isSignature(signature)) throw new TypeError($a051056425522516$var$THROW_BAD_SIGNATURE);
    var Q = $a051056425522516$var$decodeFrom(q);
    var r = $a051056425522516$var$fromBuffer(signature.slice(0, 32));
    var s = $a051056425522516$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($a051056425522516$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    var e = $a051056425522516$var$fromBuffer(hash);
    // Compute s^-1
    var sInv = s.invm($a051056425522516$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    var u1 = e.mul(sInv).umod($a051056425522516$var$n);
    var u2 = r.mul(sInv).umod($a051056425522516$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    var R = $a051056425522516$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    var xR = R.x;
    // 1.4.7 Set v = xR mod n
    var v = xR.umod($a051056425522516$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
$a051056425522516$exports = {
    isPoint: $a051056425522516$var$isPoint,
    isPointCompressed: $a051056425522516$var$isPointCompressed,
    isPrivate: $a051056425522516$var$isPrivate,
    pointAdd: $a051056425522516$var$pointAdd,
    pointAddScalar: $a051056425522516$var$pointAddScalar,
    pointCompress: $a051056425522516$var$pointCompress,
    pointFromScalar: $a051056425522516$var$pointFromScalar,
    pointMultiply: $a051056425522516$var$pointMultiply,
    privateAdd: $a051056425522516$var$privateAdd,
    privateSub: $a051056425522516$var$privateSub,
    sign: $a051056425522516$var$sign,
    signWithEntropy: $a051056425522516$var$signWithEntropy,
    verify: $a051056425522516$var$verify
};



var $e9ZU4 = parcelRequire("e9ZU4");
var $a666cb608162a432$exports = {};

var $ilnag = parcelRequire("ilnag");
var $a666cb608162a432$require$Buffer = $ilnag.Buffer;

function $a666cb608162a432$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $a666cb608162a432$var$encodeRaw(version, privateKey, compressed) {
    var result = new $a666cb608162a432$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $a666cb608162a432$var$decode(string, version) {
    return $a666cb608162a432$var$decodeRaw($3edaade963281bc2$exports.decode(string), version);
}
function $a666cb608162a432$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $3edaade963281bc2$exports.encode($a666cb608162a432$var$encodeRaw(version, privateKey, compressed));
    return $3edaade963281bc2$exports.encode($a666cb608162a432$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
$a666cb608162a432$exports = {
    decode: $a666cb608162a432$var$decode,
    decodeRaw: $a666cb608162a432$var$decodeRaw,
    encode: $a666cb608162a432$var$encode,
    encodeRaw: $a666cb608162a432$var$encodeRaw
};


var $fc19772f4e9ed7f5$var$UINT256_TYPE = $e9ZU4.BufferN(32);
var $fc19772f4e9ed7f5$var$NETWORK_TYPE = $e9ZU4.compile({
    wif: $e9ZU4.UInt8,
    bip32: {
        public: $e9ZU4.UInt32,
        private: $e9ZU4.UInt32
    }
});
var $fc19772f4e9ed7f5$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
var $fc19772f4e9ed7f5$var$HIGHEST_BIT = 0x80000000;
var $fc19772f4e9ed7f5$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $fc19772f4e9ed7f5$var$BIP32Path(value) {
    return $e9ZU4.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $fc19772f4e9ed7f5$var$UInt31(value) {
    return $e9ZU4.UInt32(value) && value <= $fc19772f4e9ed7f5$var$UINT31_MAX;
}
var $fc19772f4e9ed7f5$var$BIP32 = /*#__PURE__*/ function() {
    "use strict";
    function BIP32(__D, __Q, chainCode, network) {
        var __DEPTH = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, __INDEX = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, __PARENT_FINGERPRINT = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0x00000000;
        (0, $7dKN1._)(this, BIP32);
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $e9ZU4($fc19772f4e9ed7f5$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    (0, $eW5pA._)(BIP32, [
        {
            key: "depth",
            get: function get() {
                return this.__DEPTH;
            }
        },
        {
            key: "index",
            get: function get() {
                return this.__INDEX;
            }
        },
        {
            key: "parentFingerprint",
            get: function get() {
                return this.__PARENT_FINGERPRINT;
            }
        },
        {
            key: "publicKey",
            get: function get() {
                if (this.__Q === undefined) this.__Q = $a051056425522516$exports.pointFromScalar(this.__D, true);
                return this.__Q;
            }
        },
        {
            key: "privateKey",
            get: function get() {
                return this.__D;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return $a0616478670a7883$exports.hash160(this.publicKey);
            }
        },
        {
            key: "fingerprint",
            get: function get() {
                return this.identifier.slice(0, 4);
            }
        },
        {
            key: "compressed",
            get: function get() {
                return true;
            }
        },
        {
            // Private === not neutered
            // Public === neutered
            key: "isNeutered",
            value: function isNeutered() {
                return this.__D === undefined;
            }
        },
        {
            key: "neutered",
            value: function neutered() {
                return $fc19772f4e9ed7f5$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
            }
        },
        {
            key: "toBase58",
            value: function toBase58() {
                var network = this.network;
                var version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
                var buffer = $fc19772f4e9ed7f5$require$Buffer.allocUnsafe(78);
                // 4 bytes: version bytes
                buffer.writeUInt32BE(version, 0);
                // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
                buffer.writeUInt8(this.depth, 4);
                // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
                buffer.writeUInt32BE(this.parentFingerprint, 5);
                // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
                // This is encoded in big endian. (0x00000000 if master key)
                buffer.writeUInt32BE(this.index, 9);
                // 32 bytes: the chain code
                this.chainCode.copy(buffer, 13);
                // 33 bytes: the public key or private key data
                if (!this.isNeutered()) {
                    // 0x00 + k for private keys
                    buffer.writeUInt8(0, 45);
                    this.privateKey.copy(buffer, 46);
                // 33 bytes: the public key
                } else // X9.62 encoding for public keys
                this.publicKey.copy(buffer, 45);
                return $3edaade963281bc2$exports.encode(buffer);
            }
        },
        {
            key: "toWIF",
            value: function toWIF() {
                if (!this.privateKey) throw new TypeError("Missing private key");
                return $a666cb608162a432$exports.encode(this.network.wif, this.privateKey, true);
            }
        },
        {
            // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
            key: "derive",
            value: function derive(index) {
                $e9ZU4($e9ZU4.UInt32, index);
                var isHardened = index >= $fc19772f4e9ed7f5$var$HIGHEST_BIT;
                var data = $fc19772f4e9ed7f5$require$Buffer.allocUnsafe(37);
                // Hardened child
                if (isHardened) {
                    if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
                    // data = 0x00 || ser256(kpar) || ser32(index)
                    data[0] = 0x00;
                    this.privateKey.copy(data, 1);
                    data.writeUInt32BE(index, 33);
                // Normal child
                } else {
                    // data = serP(point(kpar)) || ser32(index)
                    //      = serP(Kpar) || ser32(index)
                    this.publicKey.copy(data, 0);
                    data.writeUInt32BE(index, 33);
                }
                var I = $a0616478670a7883$exports.hmacSHA512(this.chainCode, data);
                var IL = I.slice(0, 32);
                var IR = I.slice(32);
                // if parse256(IL) >= n, proceed with the next value for i
                if (!$a051056425522516$exports.isPrivate(IL)) return this.derive(index + 1);
                // Private parent key -> private child key
                var hd;
                if (!this.isNeutered()) {
                    // ki = parse256(IL) + kpar (mod n)
                    var ki = $a051056425522516$exports.privateAdd(this.privateKey, IL);
                    // In case ki == 0, proceed with the next value for i
                    if (ki == null) return this.derive(index + 1);
                    hd = $fc19772f4e9ed7f5$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
                // Public parent key -> public child key
                } else {
                    // Ki = point(parse256(IL)) + Kpar
                    //    = G*IL + Kpar
                    var Ki = $a051056425522516$exports.pointAddScalar(this.publicKey, IL, true);
                    // In case Ki is the point at infinity, proceed with the next value for i
                    if (Ki === null) return this.derive(index + 1);
                    hd = $fc19772f4e9ed7f5$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
                }
                return hd;
            }
        },
        {
            key: "deriveHardened",
            value: function deriveHardened(index) {
                $e9ZU4($fc19772f4e9ed7f5$var$UInt31, index);
                // Only derives hardened private keys by default
                return this.derive(index + $fc19772f4e9ed7f5$var$HIGHEST_BIT);
            }
        },
        {
            key: "derivePath",
            value: function derivePath(path) {
                $e9ZU4($fc19772f4e9ed7f5$var$BIP32Path, path);
                var splitPath = path.split("/");
                if (splitPath[0] === "m") {
                    if (this.parentFingerprint) throw new TypeError("Expected master, got child");
                    splitPath = splitPath.slice(1);
                }
                return splitPath.reduce(function(prevHd, indexStr) {
                    var index;
                    if (indexStr.slice(-1) === "'") {
                        index = parseInt(indexStr.slice(0, -1), 10);
                        return prevHd.deriveHardened(index);
                    } else {
                        index = parseInt(indexStr, 10);
                        return prevHd.derive(index);
                    }
                }, this);
            }
        },
        {
            key: "sign",
            value: function sign(hash, lowR) {
                if (!this.privateKey) throw new Error("Missing private key");
                if (lowR === undefined) lowR = this.lowR;
                if (lowR === false) return $a051056425522516$exports.sign(hash, this.privateKey);
                else {
                    var sig = $a051056425522516$exports.sign(hash, this.privateKey);
                    var extraData = $fc19772f4e9ed7f5$require$Buffer.alloc(32, 0);
                    var counter = 0;
                    // if first try is lowR, skip the loop
                    // for second try and on, add extra entropy counting up
                    while(sig[0] > 0x7f){
                        counter++;
                        extraData.writeUIntLE(counter, 0, 6);
                        sig = $a051056425522516$exports.signWithEntropy(hash, this.privateKey, extraData);
                    }
                    return sig;
                }
            }
        },
        {
            key: "verify",
            value: function verify(hash, signature) {
                return $a051056425522516$exports.verify(hash, this.publicKey, signature);
            }
        }
    ]);
    return BIP32;
}();
function $fc19772f4e9ed7f5$var$fromBase58(inString, network) {
    var buffer = $3edaade963281bc2$exports.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $fc19772f4e9ed7f5$var$BITCOIN;
    // 4 bytes: version bytes
    var version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    var depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    var parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    var index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    var chainCode = buffer.slice(13, 45);
    var hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        var k = buffer.slice(46, 78);
        hd = $fc19772f4e9ed7f5$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        var X = buffer.slice(45, 78);
        hd = $fc19772f4e9ed7f5$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
$fc19772f4e9ed7f5$exports.fromBase58 = $fc19772f4e9ed7f5$var$fromBase58;
function $fc19772f4e9ed7f5$var$fromPrivateKey(privateKey, chainCode, network) {
    return $fc19772f4e9ed7f5$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
$fc19772f4e9ed7f5$exports.fromPrivateKey = $fc19772f4e9ed7f5$var$fromPrivateKey;
function $fc19772f4e9ed7f5$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $e9ZU4({
        privateKey: $fc19772f4e9ed7f5$var$UINT256_TYPE,
        chainCode: $fc19772f4e9ed7f5$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $fc19772f4e9ed7f5$var$BITCOIN;
    if (!$a051056425522516$exports.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $fc19772f4e9ed7f5$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $fc19772f4e9ed7f5$var$fromPublicKey(publicKey, chainCode, network) {
    return $fc19772f4e9ed7f5$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
$fc19772f4e9ed7f5$exports.fromPublicKey = $fc19772f4e9ed7f5$var$fromPublicKey;
function $fc19772f4e9ed7f5$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $e9ZU4({
        publicKey: $e9ZU4.BufferN(33),
        chainCode: $fc19772f4e9ed7f5$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $fc19772f4e9ed7f5$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$a051056425522516$exports.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $fc19772f4e9ed7f5$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $fc19772f4e9ed7f5$var$fromSeed(seed, network) {
    $e9ZU4($e9ZU4.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $fc19772f4e9ed7f5$var$BITCOIN;
    var I = $a0616478670a7883$exports.hmacSHA512($fc19772f4e9ed7f5$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    var IL = I.slice(0, 32);
    var IR = I.slice(32);
    return $fc19772f4e9ed7f5$var$fromPrivateKey(IL, IR, network);
}
$fc19772f4e9ed7f5$exports.fromSeed = $fc19772f4e9ed7f5$var$fromSeed;


$11dde517550f9000$exports.fromSeed = $fc19772f4e9ed7f5$exports.fromSeed;
$11dde517550f9000$exports.fromBase58 = $fc19772f4e9ed7f5$exports.fromBase58;
$11dde517550f9000$exports.fromPublicKey = $fc19772f4e9ed7f5$exports.fromPublicKey;
$11dde517550f9000$exports.fromPrivateKey = $fc19772f4e9ed7f5$exports.fromPrivateKey;


$9ce982a108f9bffc$exports.bip32 = $11dde517550f9000$exports;
var $52c2d07c5f3c77af$exports = {};

var $ilnag = parcelRequire("ilnag");
var $52c2d07c5f3c77af$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($52c2d07c5f3c77af$exports, "__esModule", {
    value: true
});
var $255d167d6a85e1f2$exports = {};
"use strict";
Object.defineProperty($255d167d6a85e1f2$exports, "__esModule", {
    value: true
});
$255d167d6a85e1f2$exports.bitcoin = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
$255d167d6a85e1f2$exports.regtest = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bcrt",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
$255d167d6a85e1f2$exports.testnet = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};


var $8a09fb4c2f496869$exports = {};
"use strict";
Object.defineProperty($8a09fb4c2f496869$exports, "__esModule", {
    value: true
});
var $e842db5c70772a1a$exports = {};
"use strict";
Object.defineProperty($e842db5c70772a1a$exports, "__esModule", {
    value: true
});

var $120fce5ded7fb153$exports = {};

var $ilnag = parcelRequire("ilnag");
var $120fce5ded7fb153$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($120fce5ded7fb153$exports, "__esModule", {
    value: true
});
var $956b2b7afdd68c00$exports = {};

var $ilnag = parcelRequire("ilnag");
var $956b2b7afdd68c00$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($956b2b7afdd68c00$exports, "__esModule", {
    value: true
});
function $956b2b7afdd68c00$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    var length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError("Script number overflow");
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error("Non-minimally encoded script number");
        }
    }
    // 40-bit
    if (length === 5) {
        var a = buffer.readUInt32LE(0);
        var b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    var result = 0;
    for(var i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
$956b2b7afdd68c00$exports.decode = $956b2b7afdd68c00$var$decode;
function $956b2b7afdd68c00$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
function $956b2b7afdd68c00$var$encode(_number) {
    var value = Math.abs(_number);
    var size = $956b2b7afdd68c00$var$scriptNumSize(value);
    var buffer = $956b2b7afdd68c00$require$Buffer.allocUnsafe(size);
    var negative = _number < 0;
    for(var i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
$956b2b7afdd68c00$exports.encode = $956b2b7afdd68c00$var$encode;


var $7032949507c9530b$exports = {};

var $ilnag = parcelRequire("ilnag");
var $7032949507c9530b$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($7032949507c9530b$exports, "__esModule", {
    value: true
});
var $8f74010e7554fd26$exports = {};
"use strict";
Object.defineProperty($8f74010e7554fd26$exports, "__esModule", {
    value: true
});

var $e9ZU4 = parcelRequire("e9ZU4");
var $8f74010e7554fd26$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $8f74010e7554fd26$var$UInt31(value) {
    return $e9ZU4.UInt32(value) && value <= $8f74010e7554fd26$var$UINT31_MAX;
}
$8f74010e7554fd26$exports.UInt31 = $8f74010e7554fd26$var$UInt31;
function $8f74010e7554fd26$var$BIP32Path(value) {
    return $e9ZU4.String(value) && !!value.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
}
$8f74010e7554fd26$exports.BIP32Path = $8f74010e7554fd26$var$BIP32Path;
$8f74010e7554fd26$var$BIP32Path.toJSON = function() {
    return "BIP32 derivation path";
};
function $8f74010e7554fd26$var$Signer(obj) {
    return ($e9ZU4.Buffer(obj.publicKey) || typeof obj.getPublicKey === "function") && typeof obj.sign === "function";
}
$8f74010e7554fd26$exports.Signer = $8f74010e7554fd26$var$Signer;
var $8f74010e7554fd26$var$SATOSHI_MAX = 21 * 1e14;
function $8f74010e7554fd26$var$Satoshi(value) {
    return $e9ZU4.UInt53(value) && value <= $8f74010e7554fd26$var$SATOSHI_MAX;
}
$8f74010e7554fd26$exports.Satoshi = $8f74010e7554fd26$var$Satoshi;
// external dependent types
$8f74010e7554fd26$exports.ECPoint = $e9ZU4.quacksLike("Point");
// exposed, external API
$8f74010e7554fd26$exports.Network = $e9ZU4.compile({
    messagePrefix: $e9ZU4.oneOf($e9ZU4.Buffer, $e9ZU4.String),
    bip32: {
        public: $e9ZU4.UInt32,
        private: $e9ZU4.UInt32
    },
    pubKeyHash: $e9ZU4.UInt8,
    scriptHash: $e9ZU4.UInt8,
    wif: $e9ZU4.UInt8
});
$8f74010e7554fd26$exports.Buffer256bit = $e9ZU4.BufferN(32);
$8f74010e7554fd26$exports.Hash160bit = $e9ZU4.BufferN(20);
$8f74010e7554fd26$exports.Hash256bit = $e9ZU4.BufferN(32);
$8f74010e7554fd26$exports.Number = $e9ZU4.Number; // tslint:disable-line variable-name
$8f74010e7554fd26$exports.Array = $e9ZU4.Array;
$8f74010e7554fd26$exports.Boolean = $e9ZU4.Boolean; // tslint:disable-line variable-name
$8f74010e7554fd26$exports.String = $e9ZU4.String; // tslint:disable-line variable-name
$8f74010e7554fd26$exports.Buffer = $e9ZU4.Buffer;
$8f74010e7554fd26$exports.Hex = $e9ZU4.Hex;
$8f74010e7554fd26$exports.maybe = $e9ZU4.maybe;
$8f74010e7554fd26$exports.tuple = $e9ZU4.tuple;
$8f74010e7554fd26$exports.UInt8 = $e9ZU4.UInt8;
$8f74010e7554fd26$exports.UInt32 = $e9ZU4.UInt32;
$8f74010e7554fd26$exports.Function = $e9ZU4.Function;
$8f74010e7554fd26$exports.BufferN = $e9ZU4.BufferN;
$8f74010e7554fd26$exports.Null = $e9ZU4.Null;
$8f74010e7554fd26$exports.oneOf = $e9ZU4.oneOf;


var $ab8cc85f65b23756$exports = {};
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use

var $b1nU2 = parcelRequire("b1nU2");
var $ab8cc85f65b23756$require$Buffer = $b1nU2.Buffer;
function $ab8cc85f65b23756$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    var lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    var lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
function $ab8cc85f65b23756$var$decode(buffer) {
    if (buffer.length < 8) throw new Error("DER sequence length is too short");
    if (buffer.length > 72) throw new Error("DER sequence length is too long");
    if (buffer[0] !== 0x30) throw new Error("Expected DER sequence");
    if (buffer[1] !== buffer.length - 2) throw new Error("DER sequence length is invalid");
    if (buffer[2] !== 0x02) throw new Error("Expected DER integer");
    var lenR = buffer[3];
    if (lenR === 0) throw new Error("R length is zero");
    if (5 + lenR >= buffer.length) throw new Error("R length is too long");
    if (buffer[4 + lenR] !== 0x02) throw new Error("Expected DER integer (2)");
    var lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error("S length is zero");
    if (6 + lenR + lenS !== buffer.length) throw new Error("S length is invalid");
    if (buffer[4] & 0x80) throw new Error("R value is negative");
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error("R value excessively padded");
    if (buffer[lenR + 6] & 0x80) throw new Error("S value is negative");
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error("S value excessively padded");
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
*/ function $ab8cc85f65b23756$var$encode(r, s) {
    var lenR = r.length;
    var lenS = s.length;
    if (lenR === 0) throw new Error("R length is zero");
    if (lenS === 0) throw new Error("S length is zero");
    if (lenR > 33) throw new Error("R length is too long");
    if (lenS > 33) throw new Error("S length is too long");
    if (r[0] & 0x80) throw new Error("R value is negative");
    if (s[0] & 0x80) throw new Error("S value is negative");
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error("R value excessively padded");
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error("S value excessively padded");
    var signature = $ab8cc85f65b23756$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
$ab8cc85f65b23756$exports = {
    check: $ab8cc85f65b23756$var$check,
    decode: $ab8cc85f65b23756$var$decode,
    encode: $ab8cc85f65b23756$var$encode
};



var $e9ZU4 = parcelRequire("e9ZU4");
var $7032949507c9530b$var$ZERO = $7032949507c9530b$require$Buffer.alloc(1, 0);
function $7032949507c9530b$var$toDER(x) {
    var i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $7032949507c9530b$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $7032949507c9530b$require$Buffer.concat([
        $7032949507c9530b$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
function $7032949507c9530b$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    var buffer = $7032949507c9530b$require$Buffer.alloc(32, 0);
    var bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
function $7032949507c9530b$var$decode(buffer) {
    var hashType = buffer.readUInt8(buffer.length - 1);
    var hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    var decoded = $ab8cc85f65b23756$exports.decode(buffer.slice(0, -1));
    var r = $7032949507c9530b$var$fromDER(decoded.r);
    var s = $7032949507c9530b$var$fromDER(decoded.s);
    var signature = $7032949507c9530b$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
$7032949507c9530b$exports.decode = $7032949507c9530b$var$decode;
function $7032949507c9530b$var$encode(signature, hashType) {
    $e9ZU4({
        signature: $8f74010e7554fd26$exports.BufferN(64),
        hashType: $8f74010e7554fd26$exports.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    var hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    var hashTypeBuffer = $7032949507c9530b$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    var r = $7032949507c9530b$var$toDER(signature.slice(0, 32));
    var s = $7032949507c9530b$var$toDER(signature.slice(32, 64));
    return $7032949507c9530b$require$Buffer.concat([
        $ab8cc85f65b23756$exports.encode(r, s),
        hashTypeBuffer
    ]);
}
$7032949507c9530b$exports.encode = $7032949507c9530b$var$encode;




var $337af2715cffd62a$exports = {};

var $ilnag = parcelRequire("ilnag");
var $337af2715cffd62a$require$Buffer = $ilnag.Buffer;

var $42mVo = parcelRequire("42mVo");

var $aW3Sp = parcelRequire("aW3Sp");
var $337af2715cffd62a$require$EC = $aW3Sp.ec;
var $337af2715cffd62a$var$secp256k1 = new $337af2715cffd62a$require$EC("secp256k1");
var $4f905929b32feace$exports = {};

var $ilnag = parcelRequire("ilnag");
var $4f905929b32feace$require$Buffer = $ilnag.Buffer;

var $c9AEc = parcelRequire("c9AEc");
var $4f905929b32feace$var$ONE1 = $4f905929b32feace$require$Buffer.alloc(1, 1);
var $4f905929b32feace$var$ZERO1 = $4f905929b32feace$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $4f905929b32feace$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    var k = $4f905929b32feace$require$Buffer.alloc(32, 0);
    var v = $4f905929b32feace$require$Buffer.alloc(32, 1);
    // Step D
    k = $c9AEc("sha256", k).update(v).update($4f905929b32feace$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $c9AEc("sha256", k).update(v).digest();
    // Step F
    k = $c9AEc("sha256", k).update(v).update($4f905929b32feace$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $c9AEc("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $c9AEc("sha256", k).update(v).digest();
    var T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $c9AEc("sha256", k).update(v).update($4f905929b32feace$var$ZERO1).digest();
        v = $c9AEc("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $c9AEc("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
$4f905929b32feace$exports = $4f905929b32feace$var$deterministicGenerateK;


var $337af2715cffd62a$var$ZERO32 = $337af2715cffd62a$require$Buffer.alloc(32, 0);
var $337af2715cffd62a$var$EC_GROUP_ORDER = $337af2715cffd62a$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
var $337af2715cffd62a$var$EC_P = $337af2715cffd62a$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
var $337af2715cffd62a$var$n = $337af2715cffd62a$var$secp256k1.curve.n;
var $337af2715cffd62a$var$nDiv2 = $337af2715cffd62a$var$n.shrn(1);
var $337af2715cffd62a$var$G = $337af2715cffd62a$var$secp256k1.curve.g;
var $337af2715cffd62a$var$THROW_BAD_PRIVATE = "Expected Private";
var $337af2715cffd62a$var$THROW_BAD_POINT = "Expected Point";
var $337af2715cffd62a$var$THROW_BAD_TWEAK = "Expected Tweak";
var $337af2715cffd62a$var$THROW_BAD_HASH = "Expected Hash";
var $337af2715cffd62a$var$THROW_BAD_SIGNATURE = "Expected Signature";
var $337af2715cffd62a$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $337af2715cffd62a$var$isScalar(x) {
    return x instanceof Uint8Array && x.length === 32;
}
function $337af2715cffd62a$var$isOrderScalar(x) {
    if (!$337af2715cffd62a$var$isScalar(x)) return false;
    return $337af2715cffd62a$var$EC_GROUP_ORDER.compare(x) > 0 // < G
    ;
}
function $337af2715cffd62a$var$isPoint(p) {
    if (!(p instanceof Uint8Array)) return false;
    if (p.length < 33) return false;
    var t = p[0];
    var x = p.subarray(1, 33);
    if ($337af2715cffd62a$var$ZERO32.compare(x) === 0) return false;
    if ($337af2715cffd62a$var$EC_P.compare(x) <= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $337af2715cffd62a$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    var y = p.subarray(33);
    if ($337af2715cffd62a$var$ZERO32.compare(y) === 0) return false;
    if ($337af2715cffd62a$var$EC_P.compare(y) <= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $337af2715cffd62a$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $337af2715cffd62a$var$isPointCompressed(p) {
    if (!$337af2715cffd62a$var$isPoint(p)) return false;
    return $337af2715cffd62a$var$__isPointCompressed(p);
}
function $337af2715cffd62a$var$isPrivate(x) {
    if (!$337af2715cffd62a$var$isScalar(x)) return false;
    return $337af2715cffd62a$var$ZERO32.compare(x) < 0 && // > 0
    $337af2715cffd62a$var$EC_GROUP_ORDER.compare(x) > 0 // < G
    ;
}
function $337af2715cffd62a$var$isSignature(value) {
    var r = value.subarray(0, 32);
    var s = value.subarray(32, 64);
    return value instanceof Uint8Array && value.length === 64 && $337af2715cffd62a$var$EC_GROUP_ORDER.compare(r) > 0 && $337af2715cffd62a$var$EC_GROUP_ORDER.compare(s) > 0;
}
function $337af2715cffd62a$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $337af2715cffd62a$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $337af2715cffd62a$var$fromBuffer(d) {
    return new $42mVo(d);
}
function $337af2715cffd62a$var$toBuffer(d) {
    return d.toArrayLike($337af2715cffd62a$require$Buffer, "be", 32);
}
function $337af2715cffd62a$var$decodeFrom(P) {
    return $337af2715cffd62a$var$secp256k1.curve.decodePoint(P);
}
function $337af2715cffd62a$var$getEncoded(P, compressed) {
    return $337af2715cffd62a$require$Buffer.from(P._encode(compressed));
}
function $337af2715cffd62a$var$pointAdd(pA, pB, __compressed) {
    if (!$337af2715cffd62a$var$isPoint(pA)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    if (!$337af2715cffd62a$var$isPoint(pB)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    var a = $337af2715cffd62a$var$decodeFrom(pA);
    var b = $337af2715cffd62a$var$decodeFrom(pB);
    var pp = a.add(b);
    if (pp.isInfinity()) return null;
    var compressed = $337af2715cffd62a$var$assumeCompression(__compressed, pA);
    return $337af2715cffd62a$var$getEncoded(pp, compressed);
}
function $337af2715cffd62a$var$pointAddScalar(p, tweak, __compressed) {
    if (!$337af2715cffd62a$var$isPoint(p)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    if (!$337af2715cffd62a$var$isOrderScalar(tweak)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_TWEAK);
    var compressed = $337af2715cffd62a$var$assumeCompression(__compressed, p);
    var pp = $337af2715cffd62a$var$decodeFrom(p);
    if ($337af2715cffd62a$var$ZERO32.compare(tweak) === 0) return $337af2715cffd62a$var$getEncoded(pp, compressed);
    var tt = $337af2715cffd62a$var$fromBuffer(tweak);
    var qq = $337af2715cffd62a$var$G.mul(tt);
    var uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $337af2715cffd62a$var$getEncoded(uu, compressed);
}
function $337af2715cffd62a$var$pointCompress(p, __compressed) {
    if (!$337af2715cffd62a$var$isPoint(p)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    var pp = $337af2715cffd62a$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    var compressed = $337af2715cffd62a$var$assumeCompression(__compressed, p);
    return $337af2715cffd62a$var$getEncoded(pp, compressed);
}
function $337af2715cffd62a$var$pointFromScalar(d, __compressed) {
    if (!$337af2715cffd62a$var$isPrivate(d)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_PRIVATE);
    var dd = $337af2715cffd62a$var$fromBuffer(d);
    var pp = $337af2715cffd62a$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    var compressed = $337af2715cffd62a$var$assumeCompression(__compressed);
    return $337af2715cffd62a$var$getEncoded(pp, compressed);
}
function $337af2715cffd62a$var$pointMultiply(p, tweak, __compressed) {
    if (!$337af2715cffd62a$var$isPoint(p)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    if (!$337af2715cffd62a$var$isOrderScalar(tweak)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_TWEAK);
    var compressed = $337af2715cffd62a$var$assumeCompression(__compressed, p);
    var pp = $337af2715cffd62a$var$decodeFrom(p);
    var tt = $337af2715cffd62a$var$fromBuffer(tweak);
    var qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $337af2715cffd62a$var$getEncoded(qq, compressed);
}
function $337af2715cffd62a$var$privateAdd(d, tweak) {
    if (!$337af2715cffd62a$var$isPrivate(d)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_PRIVATE);
    if (!$337af2715cffd62a$var$isOrderScalar(tweak)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_TWEAK);
    var dd = $337af2715cffd62a$var$fromBuffer(d);
    var tt = $337af2715cffd62a$var$fromBuffer(tweak);
    var dt = $337af2715cffd62a$var$toBuffer(dd.add(tt).umod($337af2715cffd62a$var$n));
    if (!$337af2715cffd62a$var$isPrivate(dt)) return null;
    return dt;
}
function $337af2715cffd62a$var$privateSub(d, tweak) {
    if (!$337af2715cffd62a$var$isPrivate(d)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_PRIVATE);
    if (!$337af2715cffd62a$var$isOrderScalar(tweak)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_TWEAK);
    var dd = $337af2715cffd62a$var$fromBuffer(d);
    var tt = $337af2715cffd62a$var$fromBuffer(tweak);
    var dt = $337af2715cffd62a$var$toBuffer(dd.sub(tt).umod($337af2715cffd62a$var$n));
    if (!$337af2715cffd62a$var$isPrivate(dt)) return null;
    return dt;
}
function $337af2715cffd62a$var$sign(hash, x) {
    return $337af2715cffd62a$var$__sign(hash, x);
}
function $337af2715cffd62a$var$signWithEntropy(hash, x, addData) {
    return $337af2715cffd62a$var$__sign(hash, x, addData);
}
function $337af2715cffd62a$var$__sign(hash, x, addData) {
    if (!$337af2715cffd62a$var$isScalar(hash)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_HASH);
    if (!$337af2715cffd62a$var$isPrivate(x)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$337af2715cffd62a$var$isScalar(addData)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_EXTRA_DATA);
    var d = $337af2715cffd62a$var$fromBuffer(x);
    var e = $337af2715cffd62a$var$fromBuffer(hash);
    var r, s;
    var checkSig = function checkSig(k) {
        var kI = $337af2715cffd62a$var$fromBuffer(k);
        var Q = $337af2715cffd62a$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($337af2715cffd62a$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($337af2715cffd62a$var$n).mul(e.add(d.mul(r))).umod($337af2715cffd62a$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $4f905929b32feace$exports(hash, x, checkSig, $337af2715cffd62a$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($337af2715cffd62a$var$nDiv2) > 0) s = $337af2715cffd62a$var$n.sub(s);
    var buffer = $337af2715cffd62a$require$Buffer.allocUnsafe(64);
    $337af2715cffd62a$var$toBuffer(r).copy(buffer, 0);
    $337af2715cffd62a$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $337af2715cffd62a$var$verify(hash, q, signature, strict) {
    if (!$337af2715cffd62a$var$isScalar(hash)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_HASH);
    if (!$337af2715cffd62a$var$isPoint(q)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$337af2715cffd62a$var$isSignature(signature)) throw new TypeError($337af2715cffd62a$var$THROW_BAD_SIGNATURE);
    var Q = $337af2715cffd62a$var$decodeFrom(q);
    var r = $337af2715cffd62a$var$fromBuffer(signature.subarray(0, 32));
    var s = $337af2715cffd62a$var$fromBuffer(signature.subarray(32, 64));
    if (strict && s.cmp($337af2715cffd62a$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    var e = $337af2715cffd62a$var$fromBuffer(hash);
    // Compute s^-1
    var sInv = s.invm($337af2715cffd62a$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    var u1 = e.mul(sInv).umod($337af2715cffd62a$var$n);
    var u2 = r.mul(sInv).umod($337af2715cffd62a$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    var R = $337af2715cffd62a$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    var xR = R.x;
    // 1.4.7 Set v = xR mod n
    var v = xR.umod($337af2715cffd62a$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
$337af2715cffd62a$exports = {
    isPoint: $337af2715cffd62a$var$isPoint,
    isPointCompressed: $337af2715cffd62a$var$isPointCompressed,
    isPrivate: $337af2715cffd62a$var$isPrivate,
    pointAdd: $337af2715cffd62a$var$pointAdd,
    pointAddScalar: $337af2715cffd62a$var$pointAddScalar,
    pointCompress: $337af2715cffd62a$var$pointCompress,
    pointFromScalar: $337af2715cffd62a$var$pointFromScalar,
    pointMultiply: $337af2715cffd62a$var$pointMultiply,
    privateAdd: $337af2715cffd62a$var$privateAdd,
    privateSub: $337af2715cffd62a$var$privateSub,
    sign: $337af2715cffd62a$var$sign,
    signWithEntropy: $337af2715cffd62a$var$signWithEntropy,
    verify: $337af2715cffd62a$var$verify
};


var $c529093e4cbce5d2$exports = {};

var $26CEw = parcelRequire("26CEw");
function $c529093e4cbce5d2$var$encodingLength(i) {
    return i < $26CEw.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
function $c529093e4cbce5d2$var$encode(buffer, number, offset) {
    var size = $c529093e4cbce5d2$var$encodingLength(number);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(number, offset);
    else if (size === 2) {
        buffer.writeUInt8($26CEw.OP_PUSHDATA1, offset);
        buffer.writeUInt8(number, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($26CEw.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(number, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($26CEw.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(number, offset + 1);
    }
    return size;
}
function $c529093e4cbce5d2$var$decode(buffer, offset) {
    var opcode = buffer.readUInt8(offset);
    var number, size;
    // ~6 bit
    if (opcode < $26CEw.OP_PUSHDATA1) {
        number = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $26CEw.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        number = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $26CEw.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        number = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $26CEw.OP_PUSHDATA4) throw new Error("Unexpected opcode");
        number = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: number,
        size: size
    };
}
$c529093e4cbce5d2$exports = {
    encodingLength: $c529093e4cbce5d2$var$encodingLength,
    encode: $c529093e4cbce5d2$var$encode,
    decode: $c529093e4cbce5d2$var$decode
};



var $e9ZU4 = parcelRequire("e9ZU4");

$120fce5ded7fb153$exports.OPS = (parcelRequire("26CEw"));
var $5d5c0ac7ccb4008f$exports = {};

var $26CEw = parcelRequire("26CEw");
var $5d5c0ac7ccb4008f$var$map = {};
for(var $5d5c0ac7ccb4008f$var$op in $26CEw){
    var $5d5c0ac7ccb4008f$var$code = $26CEw[$5d5c0ac7ccb4008f$var$op];
    $5d5c0ac7ccb4008f$var$map[$5d5c0ac7ccb4008f$var$code] = $5d5c0ac7ccb4008f$var$op;
}
$5d5c0ac7ccb4008f$exports = $5d5c0ac7ccb4008f$var$map;


var $120fce5ded7fb153$var$OP_INT_BASE = $120fce5ded7fb153$exports.OPS.OP_RESERVED; // OP_1 - 1
function $120fce5ded7fb153$var$isOPInt(value) {
    return $8f74010e7554fd26$exports.Number(value) && (value === $120fce5ded7fb153$exports.OPS.OP_0 || value >= $120fce5ded7fb153$exports.OPS.OP_1 && value <= $120fce5ded7fb153$exports.OPS.OP_16 || value === $120fce5ded7fb153$exports.OPS.OP_1NEGATE);
}
function $120fce5ded7fb153$var$isPushOnlyChunk(value) {
    return $8f74010e7554fd26$exports.Buffer(value) || $120fce5ded7fb153$var$isOPInt(value);
}
function $120fce5ded7fb153$var$isPushOnly(value) {
    return $8f74010e7554fd26$exports.Array(value) && value.every($120fce5ded7fb153$var$isPushOnlyChunk);
}
$120fce5ded7fb153$exports.isPushOnly = $120fce5ded7fb153$var$isPushOnly;
function $120fce5ded7fb153$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $120fce5ded7fb153$exports.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $120fce5ded7fb153$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $120fce5ded7fb153$exports.OPS.OP_1NEGATE;
}
function $120fce5ded7fb153$var$chunksIsBuffer(buf) {
    return $120fce5ded7fb153$require$Buffer.isBuffer(buf);
}
function $120fce5ded7fb153$var$chunksIsArray(buf) {
    return $8f74010e7554fd26$exports.Array(buf);
}
function $120fce5ded7fb153$var$singleChunkIsBuffer(buf) {
    return $120fce5ded7fb153$require$Buffer.isBuffer(buf);
}
function $120fce5ded7fb153$var$compile(chunks) {
    // TODO: remove me
    if ($120fce5ded7fb153$var$chunksIsBuffer(chunks)) return chunks;
    $e9ZU4($8f74010e7554fd26$exports.Array, chunks);
    var bufferSize = chunks.reduce(function(accum, chunk) {
        // data chunk
        if ($120fce5ded7fb153$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $120fce5ded7fb153$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $c529093e4cbce5d2$exports.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    var buffer = $120fce5ded7fb153$require$Buffer.allocUnsafe(bufferSize);
    var offset = 0;
    chunks.forEach(function(chunk) {
        // data chunk
        if ($120fce5ded7fb153$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            var opcode = $120fce5ded7fb153$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $c529093e4cbce5d2$exports.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error("Could not decode chunks");
    return buffer;
}
$120fce5ded7fb153$exports.compile = $120fce5ded7fb153$var$compile;
function $120fce5ded7fb153$var$decompile(buffer) {
    // TODO: remove me
    if ($120fce5ded7fb153$var$chunksIsArray(buffer)) return buffer;
    $e9ZU4($8f74010e7554fd26$exports.Buffer, buffer);
    var chunks = [];
    var i = 0;
    while(i < buffer.length){
        var opcode = buffer[i];
        // data chunk
        if (opcode > $120fce5ded7fb153$exports.OPS.OP_0 && opcode <= $120fce5ded7fb153$exports.OPS.OP_PUSHDATA4) {
            var d = $c529093e4cbce5d2$exports.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            var data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            var op = $120fce5ded7fb153$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
$120fce5ded7fb153$exports.decompile = $120fce5ded7fb153$var$decompile;
function $120fce5ded7fb153$var$toASM(chunks) {
    if ($120fce5ded7fb153$var$chunksIsBuffer(chunks)) chunks = $120fce5ded7fb153$var$decompile(chunks);
    return chunks.map(function(chunk) {
        // data?
        if ($120fce5ded7fb153$var$singleChunkIsBuffer(chunk)) {
            var op = $120fce5ded7fb153$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString("hex");
            chunk = op;
        }
        // opcode!
        return $5d5c0ac7ccb4008f$exports[chunk];
    }).join(" ");
}
$120fce5ded7fb153$exports.toASM = $120fce5ded7fb153$var$toASM;
function $120fce5ded7fb153$var$fromASM(asm) {
    $e9ZU4($8f74010e7554fd26$exports.String, asm);
    return $120fce5ded7fb153$var$compile(asm.split(" ").map(function(chunkStr) {
        // opcode?
        if ($120fce5ded7fb153$exports.OPS[chunkStr] !== undefined) return $120fce5ded7fb153$exports.OPS[chunkStr];
        $e9ZU4($8f74010e7554fd26$exports.Hex, chunkStr);
        // data!
        return $120fce5ded7fb153$require$Buffer.from(chunkStr, "hex");
    }));
}
$120fce5ded7fb153$exports.fromASM = $120fce5ded7fb153$var$fromASM;
function $120fce5ded7fb153$var$toStack(chunks) {
    chunks = $120fce5ded7fb153$var$decompile(chunks);
    $e9ZU4($120fce5ded7fb153$var$isPushOnly, chunks);
    return chunks.map(function(op) {
        if ($120fce5ded7fb153$var$singleChunkIsBuffer(op)) return op;
        if (op === $120fce5ded7fb153$exports.OPS.OP_0) return $120fce5ded7fb153$require$Buffer.allocUnsafe(0);
        return $956b2b7afdd68c00$exports.encode(op - $120fce5ded7fb153$var$OP_INT_BASE);
    });
}
$120fce5ded7fb153$exports.toStack = $120fce5ded7fb153$var$toStack;
function $120fce5ded7fb153$var$isCanonicalPubKey(buffer) {
    return $337af2715cffd62a$exports.isPoint(buffer);
}
$120fce5ded7fb153$exports.isCanonicalPubKey = $120fce5ded7fb153$var$isCanonicalPubKey;
function $120fce5ded7fb153$var$isDefinedHashType(hashType) {
    var hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
$120fce5ded7fb153$exports.isDefinedHashType = $120fce5ded7fb153$var$isDefinedHashType;
function $120fce5ded7fb153$var$isCanonicalScriptSignature(buffer) {
    if (!$120fce5ded7fb153$require$Buffer.isBuffer(buffer)) return false;
    if (!$120fce5ded7fb153$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $ab8cc85f65b23756$exports.check(buffer.slice(0, -1));
}
$120fce5ded7fb153$exports.isCanonicalScriptSignature = $120fce5ded7fb153$var$isCanonicalScriptSignature;
// tslint:disable-next-line variable-name
$120fce5ded7fb153$exports.number = $956b2b7afdd68c00$exports;
$120fce5ded7fb153$exports.signature = $7032949507c9530b$exports;


var $38f113fb4e70fc72$exports = {};
"use strict";
Object.defineProperty($38f113fb4e70fc72$exports, "__esModule", {
    value: true
});
function $38f113fb4e70fc72$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set: function(_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
$38f113fb4e70fc72$exports.prop = $38f113fb4e70fc72$var$prop;
function $38f113fb4e70fc72$var$value(f) {
    var _value;
    return function() {
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
$38f113fb4e70fc72$exports.value = $38f113fb4e70fc72$var$value;



var $e9ZU4 = parcelRequire("e9ZU4");
var $e842db5c70772a1a$var$OPS = $120fce5ded7fb153$exports.OPS;
function $e842db5c70772a1a$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function(x, i) {
        return x.equals(b[i]);
    });
}
// output: OP_RETURN ...
function $e842db5c70772a1a$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $e9ZU4({
        network: $e9ZU4.maybe($e9ZU4.Object),
        output: $e9ZU4.maybe($e9ZU4.Buffer),
        data: $e9ZU4.maybe($e9ZU4.arrayOf($e9ZU4.Buffer))
    }, a);
    var network = a.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        name: "embed",
        network: network
    };
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!a.data) return;
        return $120fce5ded7fb153$exports.compile([
            $e842db5c70772a1a$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $38f113fb4e70fc72$exports.prop(o, "data", function() {
        if (!a.output) return;
        return $120fce5ded7fb153$exports.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            var chunks = $120fce5ded7fb153$exports.decompile(a.output);
            if (chunks[0] !== $e842db5c70772a1a$var$OPS.OP_RETURN) throw new TypeError("Output is invalid");
            if (!chunks.slice(1).every($e9ZU4.Buffer)) throw new TypeError("Output is invalid");
            if (a.data && !$e842db5c70772a1a$var$stacksEqual(a.data, o.data)) throw new TypeError("Data mismatch");
        }
    }
    return Object.assign(o, a);
}
$e842db5c70772a1a$exports.p2data = $e842db5c70772a1a$var$p2data;


$8a09fb4c2f496869$exports.embed = $e842db5c70772a1a$exports.p2data;
var $33908105b828b270$exports = {};
"use strict";
Object.defineProperty($33908105b828b270$exports, "__esModule", {
    value: true
});



var $33908105b828b270$var$OPS = $120fce5ded7fb153$exports.OPS;

var $e9ZU4 = parcelRequire("e9ZU4");

var $33908105b828b270$var$OP_INT_BASE = $33908105b828b270$var$OPS.OP_RESERVED; // OP_1 - 1
function $33908105b828b270$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function(x, i) {
        return x.equals(b[i]);
    });
}
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
function $33908105b828b270$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $120fce5ded7fb153$exports.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $33908105b828b270$var$OPS.OP_0) !== undefined;
    }
    $e9ZU4({
        network: $e9ZU4.maybe($e9ZU4.Object),
        m: $e9ZU4.maybe($e9ZU4.Number),
        n: $e9ZU4.maybe($e9ZU4.Number),
        output: $e9ZU4.maybe($e9ZU4.Buffer),
        pubkeys: $e9ZU4.maybe($e9ZU4.arrayOf($337af2715cffd62a$exports.isPoint)),
        signatures: $e9ZU4.maybe($e9ZU4.arrayOf(isAcceptableSignature)),
        input: $e9ZU4.maybe($e9ZU4.Buffer)
    }, a);
    var network = a.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        network: network
    };
    var chunks = [];
    var decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $120fce5ded7fb153$exports.decompile(output);
        o.m = chunks[0] - $33908105b828b270$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $33908105b828b270$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $120fce5ded7fb153$exports.compile([].concat($33908105b828b270$var$OP_INT_BASE + a.m, a.pubkeys, $33908105b828b270$var$OP_INT_BASE + o.n, $33908105b828b270$var$OPS.OP_CHECKMULTISIG));
    });
    $38f113fb4e70fc72$exports.prop(o, "m", function() {
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $38f113fb4e70fc72$exports.prop(o, "n", function() {
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $38f113fb4e70fc72$exports.prop(o, "pubkeys", function() {
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $38f113fb4e70fc72$exports.prop(o, "signatures", function() {
        if (!a.input) return;
        return $120fce5ded7fb153$exports.decompile(a.input).slice(1);
    });
    $38f113fb4e70fc72$exports.prop(o, "input", function() {
        if (!a.signatures) return;
        return $120fce5ded7fb153$exports.compile([
            $33908105b828b270$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $38f113fb4e70fc72$exports.prop(o, "witness", function() {
        if (!o.input) return;
        return [];
    });
    $38f113fb4e70fc72$exports.prop(o, "name", function() {
        if (!o.m || !o.n) return;
        return "p2ms(".concat(o.m, " of ").concat(o.n, ")");
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$e9ZU4.Number(chunks[0])) throw new TypeError("Output is invalid");
            if (!$e9ZU4.Number(chunks[chunks.length - 2])) throw new TypeError("Output is invalid");
            if (chunks[chunks.length - 1] !== $33908105b828b270$var$OPS.OP_CHECKMULTISIG) throw new TypeError("Output is invalid");
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError("Output is invalid");
            if (!o.pubkeys.every(function(x) {
                return $337af2715cffd62a$exports.isPoint(x);
            })) throw new TypeError("Output is invalid");
            if (a.m !== undefined && a.m !== o.m) throw new TypeError("m mismatch");
            if (a.n !== undefined && a.n !== o.n) throw new TypeError("n mismatch");
            if (a.pubkeys && !$33908105b828b270$var$stacksEqual(a.pubkeys, o.pubkeys)) throw new TypeError("Pubkeys mismatch");
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError("Pubkey count mismatch");
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError("Pubkey count cannot be less than m");
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError("Not enough signatures provided");
            if (a.signatures.length > o.m) throw new TypeError("Too many signatures provided");
        }
        if (a.input) {
            if (a.input[0] !== $33908105b828b270$var$OPS.OP_0) throw new TypeError("Input is invalid");
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError("Input has invalid signature(s)");
            if (a.signatures && !$33908105b828b270$var$stacksEqual(a.signatures, o.signatures)) throw new TypeError("Signature mismatch");
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError("Signature count mismatch");
        }
    }
    return Object.assign(o, a);
}
$33908105b828b270$exports.p2ms = $33908105b828b270$var$p2ms;


$8a09fb4c2f496869$exports.p2ms = $33908105b828b270$exports.p2ms;
var $a842136bd98b6ad9$exports = {};
"use strict";
Object.defineProperty($a842136bd98b6ad9$exports, "__esModule", {
    value: true
});




var $e9ZU4 = parcelRequire("e9ZU4");
var $a842136bd98b6ad9$var$OPS = $120fce5ded7fb153$exports.OPS;

// input: {signature}
// output: {pubKey} OP_CHECKSIG
function $a842136bd98b6ad9$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $e9ZU4({
        network: $e9ZU4.maybe($e9ZU4.Object),
        output: $e9ZU4.maybe($e9ZU4.Buffer),
        pubkey: $e9ZU4.maybe($337af2715cffd62a$exports.isPoint),
        signature: $e9ZU4.maybe($120fce5ded7fb153$exports.isCanonicalScriptSignature),
        input: $e9ZU4.maybe($e9ZU4.Buffer)
    }, a);
    var _chunks = $38f113fb4e70fc72$exports.value(function() {
        return $120fce5ded7fb153$exports.decompile(a.input);
    });
    var network = a.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        name: "p2pk",
        network: network
    };
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!a.pubkey) return;
        return $120fce5ded7fb153$exports.compile([
            a.pubkey,
            $a842136bd98b6ad9$var$OPS.OP_CHECKSIG
        ]);
    });
    $38f113fb4e70fc72$exports.prop(o, "pubkey", function() {
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $38f113fb4e70fc72$exports.prop(o, "signature", function() {
        if (!a.input) return;
        return _chunks()[0];
    });
    $38f113fb4e70fc72$exports.prop(o, "input", function() {
        if (!a.signature) return;
        return $120fce5ded7fb153$exports.compile([
            a.signature
        ]);
    });
    $38f113fb4e70fc72$exports.prop(o, "witness", function() {
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $a842136bd98b6ad9$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            if (!$337af2715cffd62a$exports.isPoint(o.pubkey)) throw new TypeError("Output pubkey is invalid");
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError("Pubkey mismatch");
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError("Signature mismatch");
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError("Input is invalid");
            if (!$120fce5ded7fb153$exports.isCanonicalScriptSignature(o.signature)) throw new TypeError("Input has invalid signature");
        }
    }
    return Object.assign(o, a);
}
$a842136bd98b6ad9$exports.p2pk = $a842136bd98b6ad9$var$p2pk;


$8a09fb4c2f496869$exports.p2pk = $a842136bd98b6ad9$exports.p2pk;
var $23b0fd356abe22e1$exports = {};

var $ilnag = parcelRequire("ilnag");
var $23b0fd356abe22e1$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($23b0fd356abe22e1$exports, "__esModule", {
    value: true
});
var $0f478b5636513f95$exports = {};
"use strict";
Object.defineProperty($0f478b5636513f95$exports, "__esModule", {
    value: true
});

var $jMOyI = parcelRequire("jMOyI");
function $0f478b5636513f95$var$ripemd160(buffer) {
    try {
        return $jMOyI("rmd160").update(buffer).digest();
    } catch (err) {
        return $jMOyI("ripemd160").update(buffer).digest();
    }
}
$0f478b5636513f95$exports.ripemd160 = $0f478b5636513f95$var$ripemd160;
function $0f478b5636513f95$var$sha1(buffer) {
    return $jMOyI("sha1").update(buffer).digest();
}
$0f478b5636513f95$exports.sha1 = $0f478b5636513f95$var$sha1;
function $0f478b5636513f95$var$sha256(buffer) {
    return $jMOyI("sha256").update(buffer).digest();
}
$0f478b5636513f95$exports.sha256 = $0f478b5636513f95$var$sha256;
function $0f478b5636513f95$var$hash160(buffer) {
    return $0f478b5636513f95$var$ripemd160($0f478b5636513f95$var$sha256(buffer));
}
$0f478b5636513f95$exports.hash160 = $0f478b5636513f95$var$hash160;
function $0f478b5636513f95$var$hash256(buffer) {
    return $0f478b5636513f95$var$sha256($0f478b5636513f95$var$sha256(buffer));
}
$0f478b5636513f95$exports.hash256 = $0f478b5636513f95$var$hash256;






var $e9ZU4 = parcelRequire("e9ZU4");
var $23b0fd356abe22e1$var$OPS = $120fce5ded7fb153$exports.OPS;


// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
function $23b0fd356abe22e1$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $e9ZU4({
        network: $e9ZU4.maybe($e9ZU4.Object),
        address: $e9ZU4.maybe($e9ZU4.String),
        hash: $e9ZU4.maybe($e9ZU4.BufferN(20)),
        output: $e9ZU4.maybe($e9ZU4.BufferN(25)),
        pubkey: $e9ZU4.maybe($337af2715cffd62a$exports.isPoint),
        signature: $e9ZU4.maybe($120fce5ded7fb153$exports.isCanonicalScriptSignature),
        input: $e9ZU4.maybe($e9ZU4.Buffer)
    }, a);
    var _address = $38f113fb4e70fc72$exports.value(function() {
        var payload = $3edaade963281bc2$exports.decode(a.address);
        var version = payload.readUInt8(0);
        var hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    var _chunks = $38f113fb4e70fc72$exports.value(function() {
        return $120fce5ded7fb153$exports.decompile(a.input);
    });
    var network = a.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        name: "p2pkh",
        network: network
    };
    $38f113fb4e70fc72$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var payload = $23b0fd356abe22e1$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $3edaade963281bc2$exports.encode(payload);
    });
    $38f113fb4e70fc72$exports.prop(o, "hash", function() {
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $0f478b5636513f95$exports.hash160(a.pubkey || o.pubkey);
    });
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $120fce5ded7fb153$exports.compile([
            $23b0fd356abe22e1$var$OPS.OP_DUP,
            $23b0fd356abe22e1$var$OPS.OP_HASH160,
            o.hash,
            $23b0fd356abe22e1$var$OPS.OP_EQUALVERIFY,
            $23b0fd356abe22e1$var$OPS.OP_CHECKSIG
        ]);
    });
    $38f113fb4e70fc72$exports.prop(o, "pubkey", function() {
        if (!a.input) return;
        return _chunks()[1];
    });
    $38f113fb4e70fc72$exports.prop(o, "signature", function() {
        if (!a.input) return;
        return _chunks()[0];
    });
    $38f113fb4e70fc72$exports.prop(o, "input", function() {
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $120fce5ded7fb153$exports.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $38f113fb4e70fc72$exports.prop(o, "witness", function() {
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        var hash = $23b0fd356abe22e1$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $23b0fd356abe22e1$var$OPS.OP_DUP || a.output[1] !== $23b0fd356abe22e1$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $23b0fd356abe22e1$var$OPS.OP_EQUALVERIFY || a.output[24] !== $23b0fd356abe22e1$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            var hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.pubkey) {
            var pkh = $0f478b5636513f95$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
        }
        if (a.input) {
            var chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError("Input is invalid");
            if (!$120fce5ded7fb153$exports.isCanonicalScriptSignature(chunks[0])) throw new TypeError("Input has invalid signature");
            if (!$337af2715cffd62a$exports.isPoint(chunks[1])) throw new TypeError("Input has invalid pubkey");
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError("Pubkey mismatch");
            var pkh1 = $0f478b5636513f95$exports.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh1)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
$23b0fd356abe22e1$exports.p2pkh = $23b0fd356abe22e1$var$p2pkh;


$8a09fb4c2f496869$exports.p2pkh = $23b0fd356abe22e1$exports.p2pkh;
var $0b2ae761963b4e1d$exports = {};

var $ilnag = parcelRequire("ilnag");
var $0b2ae761963b4e1d$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($0b2ae761963b4e1d$exports, "__esModule", {
    value: true
});





var $e9ZU4 = parcelRequire("e9ZU4");
var $0b2ae761963b4e1d$var$OPS = $120fce5ded7fb153$exports.OPS;

function $0b2ae761963b4e1d$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function(x, i) {
        return x.equals(b[i]);
    });
}
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
function $0b2ae761963b4e1d$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $e9ZU4({
        network: $e9ZU4.maybe($e9ZU4.Object),
        address: $e9ZU4.maybe($e9ZU4.String),
        hash: $e9ZU4.maybe($e9ZU4.BufferN(20)),
        output: $e9ZU4.maybe($e9ZU4.BufferN(23)),
        redeem: $e9ZU4.maybe({
            network: $e9ZU4.maybe($e9ZU4.Object),
            output: $e9ZU4.maybe($e9ZU4.Buffer),
            input: $e9ZU4.maybe($e9ZU4.Buffer),
            witness: $e9ZU4.maybe($e9ZU4.arrayOf($e9ZU4.Buffer))
        }),
        input: $e9ZU4.maybe($e9ZU4.Buffer),
        witness: $e9ZU4.maybe($e9ZU4.arrayOf($e9ZU4.Buffer))
    }, a);
    var network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        network: network
    };
    var _address = $38f113fb4e70fc72$exports.value(function() {
        var payload = $3edaade963281bc2$exports.decode(a.address);
        var version = payload.readUInt8(0);
        var hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    var _chunks = $38f113fb4e70fc72$exports.value(function() {
        return $120fce5ded7fb153$exports.decompile(a.input);
    });
    var _redeem = $38f113fb4e70fc72$exports.value(function() {
        var chunks = _chunks();
        return {
            network: network,
            output: chunks[chunks.length - 1],
            input: $120fce5ded7fb153$exports.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $38f113fb4e70fc72$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var payload = $0b2ae761963b4e1d$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $3edaade963281bc2$exports.encode(payload);
    });
    $38f113fb4e70fc72$exports.prop(o, "hash", function() {
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $0f478b5636513f95$exports.hash160(o.redeem.output);
    });
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $120fce5ded7fb153$exports.compile([
            $0b2ae761963b4e1d$var$OPS.OP_HASH160,
            o.hash,
            $0b2ae761963b4e1d$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $38f113fb4e70fc72$exports.prop(o, "redeem", function() {
        if (!a.input) return;
        return _redeem();
    });
    $38f113fb4e70fc72$exports.prop(o, "input", function() {
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $120fce5ded7fb153$exports.compile([].concat($120fce5ded7fb153$exports.decompile(a.redeem.input), a.redeem.output));
    });
    $38f113fb4e70fc72$exports.prop(o, "witness", function() {
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $38f113fb4e70fc72$exports.prop(o, "name", function() {
        var nameParts = [
            "p2sh"
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    if (opts.validate) {
        var hash = $0b2ae761963b4e1d$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $0b2ae761963b4e1d$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $0b2ae761963b4e1d$var$OPS.OP_EQUAL) throw new TypeError("Output is invalid");
            var hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        var checkRedeem = function(redeem) {
            // is the redeem output empty/invalid?
            if (redeem.output) {
                var decompile = $120fce5ded7fb153$exports.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output too short");
                // match hash against other sources
                var hash2 = $0f478b5636513f95$exports.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (redeem.input) {
                var hasInput = redeem.input.length > 0;
                var hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError("Empty input");
                if (hasInput && hasWitness) throw new TypeError("Input and witness provided");
                if (hasInput) {
                    var richunks = $120fce5ded7fb153$exports.decompile(redeem.input);
                    if (!$120fce5ded7fb153$exports.isPushOnly(richunks)) throw new TypeError("Non push-only scriptSig");
                }
            }
        };
        if (a.input) {
            var chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError("Input too short");
            if (!$0b2ae761963b4e1d$require$Buffer.isBuffer(_redeem().output)) throw new TypeError("Input is invalid");
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            if (a.input) {
                var redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError("Redeem.output mismatch");
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError("Redeem.input mismatch");
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !$0b2ae761963b4e1d$var$stacksEqual(a.redeem.witness, a.witness)) throw new TypeError("Witness and redeem.witness mismatch");
        }
    }
    return Object.assign(o, a);
}
$0b2ae761963b4e1d$exports.p2sh = $0b2ae761963b4e1d$var$p2sh;


$8a09fb4c2f496869$exports.p2sh = $0b2ae761963b4e1d$exports.p2sh;
var $5a914ab6f698f214$exports = {};

var $ilnag = parcelRequire("ilnag");
var $5a914ab6f698f214$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($5a914ab6f698f214$exports, "__esModule", {
    value: true
});





var $e9ZU4 = parcelRequire("e9ZU4");
var $5a914ab6f698f214$var$OPS = $120fce5ded7fb153$exports.OPS;


var $gHFi0 = parcelRequire("gHFi0");
var $5a914ab6f698f214$var$EMPTY_BUFFER = $5a914ab6f698f214$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
function $5a914ab6f698f214$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $e9ZU4({
        address: $e9ZU4.maybe($e9ZU4.String),
        hash: $e9ZU4.maybe($e9ZU4.BufferN(20)),
        input: $e9ZU4.maybe($e9ZU4.BufferN(0)),
        network: $e9ZU4.maybe($e9ZU4.Object),
        output: $e9ZU4.maybe($e9ZU4.BufferN(22)),
        pubkey: $e9ZU4.maybe($337af2715cffd62a$exports.isPoint),
        signature: $e9ZU4.maybe($120fce5ded7fb153$exports.isCanonicalScriptSignature),
        witness: $e9ZU4.maybe($e9ZU4.arrayOf($e9ZU4.Buffer))
    }, a);
    var _address = $38f113fb4e70fc72$exports.value(function() {
        var result = $gHFi0.decode(a.address);
        var version = result.words.shift();
        var data = $gHFi0.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $5a914ab6f698f214$require$Buffer.from(data)
        };
    });
    var network = a.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        name: "p2wpkh",
        network: network
    };
    $38f113fb4e70fc72$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var words = $gHFi0.toWords(o.hash);
        words.unshift(0x00);
        return $gHFi0.encode(network.bech32, words);
    });
    $38f113fb4e70fc72$exports.prop(o, "hash", function() {
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $0f478b5636513f95$exports.hash160(a.pubkey || o.pubkey);
    });
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $120fce5ded7fb153$exports.compile([
            $5a914ab6f698f214$var$OPS.OP_0,
            o.hash
        ]);
    });
    $38f113fb4e70fc72$exports.prop(o, "pubkey", function() {
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $38f113fb4e70fc72$exports.prop(o, "signature", function() {
        if (!a.witness) return;
        return a.witness[0];
    });
    $38f113fb4e70fc72$exports.prop(o, "input", function() {
        if (!o.witness) return;
        return $5a914ab6f698f214$var$EMPTY_BUFFER;
    });
    $38f113fb4e70fc72$exports.prop(o, "witness", function() {
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        var hash = $5a914ab6f698f214$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 20) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $5a914ab6f698f214$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError("Output is invalid");
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError("Hash mismatch");
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            var pkh = $0f478b5636513f95$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
            if (!$337af2715cffd62a$exports.isPoint(a.pubkey) || a.pubkey.length !== 33) throw new TypeError("Invalid pubkey for p2wpkh");
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError("Witness is invalid");
            if (!$120fce5ded7fb153$exports.isCanonicalScriptSignature(a.witness[0])) throw new TypeError("Witness has invalid signature");
            if (!$337af2715cffd62a$exports.isPoint(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError("Witness has invalid pubkey");
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError("Pubkey mismatch");
            var pkh1 = $0f478b5636513f95$exports.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh1)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
$5a914ab6f698f214$exports.p2wpkh = $5a914ab6f698f214$var$p2wpkh;


$8a09fb4c2f496869$exports.p2wpkh = $5a914ab6f698f214$exports.p2wpkh;
var $47f06ce6f84add33$exports = {};

var $ilnag = parcelRequire("ilnag");
var $47f06ce6f84add33$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($47f06ce6f84add33$exports, "__esModule", {
    value: true
});





var $e9ZU4 = parcelRequire("e9ZU4");
var $47f06ce6f84add33$var$OPS = $120fce5ded7fb153$exports.OPS;


var $gHFi0 = parcelRequire("gHFi0");
var $47f06ce6f84add33$var$EMPTY_BUFFER = $47f06ce6f84add33$require$Buffer.alloc(0);
function $47f06ce6f84add33$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function(x, i) {
        return x.equals(b[i]);
    });
}
function $47f06ce6f84add33$var$chunkHasUncompressedPubkey(chunk) {
    if ($47f06ce6f84add33$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && $337af2715cffd62a$exports.isPoint(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
function $47f06ce6f84add33$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $e9ZU4({
        network: $e9ZU4.maybe($e9ZU4.Object),
        address: $e9ZU4.maybe($e9ZU4.String),
        hash: $e9ZU4.maybe($e9ZU4.BufferN(32)),
        output: $e9ZU4.maybe($e9ZU4.BufferN(34)),
        redeem: $e9ZU4.maybe({
            input: $e9ZU4.maybe($e9ZU4.Buffer),
            network: $e9ZU4.maybe($e9ZU4.Object),
            output: $e9ZU4.maybe($e9ZU4.Buffer),
            witness: $e9ZU4.maybe($e9ZU4.arrayOf($e9ZU4.Buffer))
        }),
        input: $e9ZU4.maybe($e9ZU4.BufferN(0)),
        witness: $e9ZU4.maybe($e9ZU4.arrayOf($e9ZU4.Buffer))
    }, a);
    var _address = $38f113fb4e70fc72$exports.value(function() {
        var result = $gHFi0.decode(a.address);
        var version = result.words.shift();
        var data = $gHFi0.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $47f06ce6f84add33$require$Buffer.from(data)
        };
    });
    var _rchunks = $38f113fb4e70fc72$exports.value(function() {
        return $120fce5ded7fb153$exports.decompile(a.redeem.input);
    });
    var network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $255d167d6a85e1f2$exports.bitcoin;
    var o = {
        network: network
    };
    $38f113fb4e70fc72$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var words = $gHFi0.toWords(o.hash);
        words.unshift(0x00);
        return $gHFi0.encode(network.bech32, words);
    });
    $38f113fb4e70fc72$exports.prop(o, "hash", function() {
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $0f478b5636513f95$exports.sha256(o.redeem.output);
    });
    $38f113fb4e70fc72$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $120fce5ded7fb153$exports.compile([
            $47f06ce6f84add33$var$OPS.OP_0,
            o.hash
        ]);
    });
    $38f113fb4e70fc72$exports.prop(o, "redeem", function() {
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $47f06ce6f84add33$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $38f113fb4e70fc72$exports.prop(o, "input", function() {
        if (!o.witness) return;
        return $47f06ce6f84add33$var$EMPTY_BUFFER;
    });
    $38f113fb4e70fc72$exports.prop(o, "witness", function() {
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            var stack = $120fce5ded7fb153$exports.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $47f06ce6f84add33$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $38f113fb4e70fc72$exports.prop(o, "name", function() {
        var nameParts = [
            "p2wsh"
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    // extended validation
    if (opts.validate) {
        var hash = $47f06ce6f84add33$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $47f06ce6f84add33$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            var hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError("Ambiguous witness source");
            // is the redeem output non-empty?
            if (a.redeem.output) {
                if ($120fce5ded7fb153$exports.decompile(a.redeem.output).length === 0) throw new TypeError("Redeem.output is invalid");
                // match hash against other sources
                var hash21 = $0f478b5636513f95$exports.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash21)) throw new TypeError("Hash mismatch");
                else hash = hash21;
            }
            if (a.redeem.input && !$120fce5ded7fb153$exports.isPushOnly(_rchunks())) throw new TypeError("Non push-only scriptSig");
            if (a.witness && a.redeem.witness && !$47f06ce6f84add33$var$stacksEqual(a.witness, a.redeem.witness)) throw new TypeError("Witness and redeem.witness mismatch");
            if (a.redeem.input && _rchunks().some($47f06ce6f84add33$var$chunkHasUncompressedPubkey) || a.redeem.output && ($120fce5ded7fb153$exports.decompile(a.redeem.output) || []).some($47f06ce6f84add33$var$chunkHasUncompressedPubkey)) throw new TypeError("redeem.input or redeem.output contains uncompressed pubkey");
        }
        if (a.witness && a.witness.length > 0) {
            var wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError("Witness and redeem.output mismatch");
            if (a.witness.some($47f06ce6f84add33$var$chunkHasUncompressedPubkey) || ($120fce5ded7fb153$exports.decompile(wScript) || []).some($47f06ce6f84add33$var$chunkHasUncompressedPubkey)) throw new TypeError("Witness contains uncompressed pubkey");
        }
    }
    return Object.assign(o, a);
}
$47f06ce6f84add33$exports.p2wsh = $47f06ce6f84add33$var$p2wsh;


$8a09fb4c2f496869$exports.p2wsh = $47f06ce6f84add33$exports.p2wsh; // TODO
 // witness commitment





var $gHFi0 = parcelRequire("gHFi0");


var $e9ZU4 = parcelRequire("e9ZU4");
function $52c2d07c5f3c77af$var$fromBase58Check(address) {
    var payload = $3edaade963281bc2$exports.decode(address);
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + " is too short");
    if (payload.length > 21) throw new TypeError(address + " is too long");
    var version = payload.readUInt8(0);
    var hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
$52c2d07c5f3c77af$exports.fromBase58Check = $52c2d07c5f3c77af$var$fromBase58Check;
function $52c2d07c5f3c77af$var$fromBech32(address) {
    var result = $gHFi0.decode(address);
    var data = $gHFi0.fromWords(result.words.slice(1));
    return {
        version: result.words[0],
        prefix: result.prefix,
        data: $52c2d07c5f3c77af$require$Buffer.from(data)
    };
}
$52c2d07c5f3c77af$exports.fromBech32 = $52c2d07c5f3c77af$var$fromBech32;
function $52c2d07c5f3c77af$var$toBase58Check(hash, version) {
    $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Hash160bit, $8f74010e7554fd26$exports.UInt8), arguments);
    var payload = $52c2d07c5f3c77af$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $3edaade963281bc2$exports.encode(payload);
}
$52c2d07c5f3c77af$exports.toBase58Check = $52c2d07c5f3c77af$var$toBase58Check;
function $52c2d07c5f3c77af$var$toBech32(data, version, prefix) {
    var words = $gHFi0.toWords(data);
    words.unshift(version);
    return $gHFi0.encode(prefix, words);
}
$52c2d07c5f3c77af$exports.toBech32 = $52c2d07c5f3c77af$var$toBech32;
function $52c2d07c5f3c77af$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $255d167d6a85e1f2$exports.bitcoin;
    try {
        return $8a09fb4c2f496869$exports.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $8a09fb4c2f496869$exports.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $8a09fb4c2f496869$exports.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $8a09fb4c2f496869$exports.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    throw new Error($120fce5ded7fb153$exports.toASM(output) + " has no matching Address");
}
$52c2d07c5f3c77af$exports.fromOutputScript = $52c2d07c5f3c77af$var$fromOutputScript;
function $52c2d07c5f3c77af$var$toOutputScript(address, network) {
    network = network || $255d167d6a85e1f2$exports.bitcoin;
    var decodeBase58;
    var decodeBech32;
    try {
        decodeBase58 = $52c2d07c5f3c77af$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $8a09fb4c2f496869$exports.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $8a09fb4c2f496869$exports.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $52c2d07c5f3c77af$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + " has an invalid prefix");
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $8a09fb4c2f496869$exports.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $8a09fb4c2f496869$exports.p2wsh({
                    hash: decodeBech32.data
                }).output;
            }
        }
    }
    throw new Error(address + " has no matching Script");
}
$52c2d07c5f3c77af$exports.toOutputScript = $52c2d07c5f3c77af$var$toOutputScript;


$9ce982a108f9bffc$exports.address = $52c2d07c5f3c77af$exports;

$9ce982a108f9bffc$exports.crypto = $0f478b5636513f95$exports;
var $d25f5aec1142ce7b$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $d25f5aec1142ce7b$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($d25f5aec1142ce7b$exports, "__esModule", {
    value: true
});




var $2gcE5 = parcelRequire("2gcE5");

var $e9ZU4 = parcelRequire("e9ZU4");

var $d25f5aec1142ce7b$var$isOptions = $e9ZU4.maybe($e9ZU4.compile({
    compressed: $8f74010e7554fd26$exports.maybe($8f74010e7554fd26$exports.Boolean),
    network: $8f74010e7554fd26$exports.maybe($8f74010e7554fd26$exports.Network)
}));
var $d25f5aec1142ce7b$var$ECPair = /*#__PURE__*/ function() {
    "use strict";
    function ECPair(__D, __Q, options) {
        (0, $7dKN1._)(this, ECPair);
        this.__D = __D;
        this.__Q = __Q;
        this.lowR = false;
        if (options === undefined) options = {};
        this.compressed = options.compressed === undefined ? true : options.compressed;
        this.network = options.network || $255d167d6a85e1f2$exports.bitcoin;
        if (__Q !== undefined) this.__Q = $337af2715cffd62a$exports.pointCompress(__Q, this.compressed);
    }
    (0, $eW5pA._)(ECPair, [
        {
            key: "privateKey",
            get: function get() {
                return this.__D;
            }
        },
        {
            key: "publicKey",
            get: function get() {
                if (!this.__Q) this.__Q = $337af2715cffd62a$exports.pointFromScalar(this.__D, this.compressed);
                return this.__Q;
            }
        },
        {
            key: "toWIF",
            value: function toWIF() {
                if (!this.__D) throw new Error("Missing private key");
                return $a666cb608162a432$exports.encode(this.network.wif, this.__D, this.compressed);
            }
        },
        {
            key: "sign",
            value: function sign(hash, lowR) {
                if (!this.__D) throw new Error("Missing private key");
                if (lowR === undefined) lowR = this.lowR;
                if (lowR === false) return $337af2715cffd62a$exports.sign(hash, this.__D);
                else {
                    var sig = $337af2715cffd62a$exports.sign(hash, this.__D);
                    var extraData = $d25f5aec1142ce7b$require$Buffer.alloc(32, 0);
                    var counter = 0;
                    // if first try is lowR, skip the loop
                    // for second try and on, add extra entropy counting up
                    while(sig[0] > 0x7f){
                        counter++;
                        extraData.writeUIntLE(counter, 0, 6);
                        sig = $337af2715cffd62a$exports.signWithEntropy(hash, this.__D, extraData);
                    }
                    return sig;
                }
            }
        },
        {
            key: "verify",
            value: function verify(hash, signature) {
                return $337af2715cffd62a$exports.verify(hash, this.publicKey, signature);
            }
        }
    ]);
    return ECPair;
}();
function $d25f5aec1142ce7b$var$fromPrivateKey(buffer, options) {
    $e9ZU4($8f74010e7554fd26$exports.Buffer256bit, buffer);
    if (!$337af2715cffd62a$exports.isPrivate(buffer)) throw new TypeError("Private key not in range [1, n)");
    $e9ZU4($d25f5aec1142ce7b$var$isOptions, options);
    return new $d25f5aec1142ce7b$var$ECPair(buffer, undefined, options);
}
$d25f5aec1142ce7b$exports.fromPrivateKey = $d25f5aec1142ce7b$var$fromPrivateKey;
function $d25f5aec1142ce7b$var$fromPublicKey(buffer, options) {
    $e9ZU4($337af2715cffd62a$exports.isPoint, buffer);
    $e9ZU4($d25f5aec1142ce7b$var$isOptions, options);
    return new $d25f5aec1142ce7b$var$ECPair(undefined, buffer, options);
}
$d25f5aec1142ce7b$exports.fromPublicKey = $d25f5aec1142ce7b$var$fromPublicKey;
function $d25f5aec1142ce7b$var$fromWIF(wifString, network) {
    var decoded = $a666cb608162a432$exports.decode(wifString);
    var version = decoded.version;
    // list of networks?
    if ($8f74010e7554fd26$exports.Array(network)) {
        network = network.filter(function(x) {
            return version === x.wif;
        }).pop();
        if (!network) throw new Error("Unknown network version");
    // otherwise, assume a network object (or default to bitcoin)
    } else {
        network = network || $255d167d6a85e1f2$exports.bitcoin;
        if (version !== network.wif) throw new Error("Invalid network version");
    }
    return $d25f5aec1142ce7b$var$fromPrivateKey(decoded.privateKey, {
        compressed: decoded.compressed,
        network: network
    });
}
$d25f5aec1142ce7b$exports.fromWIF = $d25f5aec1142ce7b$var$fromWIF;
function $d25f5aec1142ce7b$var$makeRandom(options) {
    $e9ZU4($d25f5aec1142ce7b$var$isOptions, options);
    if (options === undefined) options = {};
    var rng = options.rng || $2gcE5;
    var d;
    do {
        d = rng(32);
        $e9ZU4($8f74010e7554fd26$exports.Buffer256bit, d);
    }while (!$337af2715cffd62a$exports.isPrivate(d));
    return $d25f5aec1142ce7b$var$fromPrivateKey(d, options);
}
$d25f5aec1142ce7b$exports.makeRandom = $d25f5aec1142ce7b$var$makeRandom;


$9ce982a108f9bffc$exports.ECPair = $d25f5aec1142ce7b$exports;

$9ce982a108f9bffc$exports.networks = $255d167d6a85e1f2$exports;

$9ce982a108f9bffc$exports.payments = $8a09fb4c2f496869$exports;

$9ce982a108f9bffc$exports.script = $120fce5ded7fb153$exports;
var $db2b43867ef95ee1$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $db2b43867ef95ee1$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($db2b43867ef95ee1$exports, "__esModule", {
    value: true
});
var $4f1d1f810d91b53b$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $4f1d1f810d91b53b$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($4f1d1f810d91b53b$exports, "__esModule", {
    value: true
});


var $e9ZU4 = parcelRequire("e9ZU4");
var $3aab16f2bcaeeed2$exports = {};
"use strict";

var $b1nU2 = parcelRequire("b1nU2");
var $3aab16f2bcaeeed2$require$Buffer = $b1nU2.Buffer;
// Number.MAX_SAFE_INTEGER
var $3aab16f2bcaeeed2$var$MAX_SAFE_INTEGER = 9007199254740991;
function $3aab16f2bcaeeed2$var$checkUInt53(n) {
    if (n < 0 || n > $3aab16f2bcaeeed2$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $3aab16f2bcaeeed2$var$encode(number, buffer, offset) {
    $3aab16f2bcaeeed2$var$checkUInt53(number);
    if (!buffer) buffer = $3aab16f2bcaeeed2$require$Buffer.allocUnsafe($3aab16f2bcaeeed2$var$encodingLength(number));
    if (!$3aab16f2bcaeeed2$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (number < 0xfd) {
        buffer.writeUInt8(number, offset);
        $3aab16f2bcaeeed2$var$encode.bytes = 1;
    // 16 bit
    } else if (number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(number, offset + 1);
        $3aab16f2bcaeeed2$var$encode.bytes = 3;
    // 32 bit
    } else if (number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(number, offset + 1);
        $3aab16f2bcaeeed2$var$encode.bytes = 5;
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(number >>> 0, offset + 1);
        buffer.writeUInt32LE(number / 0x100000000 | 0, offset + 5);
        $3aab16f2bcaeeed2$var$encode.bytes = 9;
    }
    return buffer;
}
function $3aab16f2bcaeeed2$var$decode(buffer, offset) {
    if (!$3aab16f2bcaeeed2$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    var first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        $3aab16f2bcaeeed2$var$decode.bytes = 1;
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        $3aab16f2bcaeeed2$var$decode.bytes = 3;
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        $3aab16f2bcaeeed2$var$decode.bytes = 5;
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        $3aab16f2bcaeeed2$var$decode.bytes = 9;
        var lo = buffer.readUInt32LE(offset + 1);
        var hi = buffer.readUInt32LE(offset + 5);
        var number = hi * 0x0100000000 + lo;
        $3aab16f2bcaeeed2$var$checkUInt53(number);
        return number;
    }
}
function $3aab16f2bcaeeed2$var$encodingLength(number) {
    $3aab16f2bcaeeed2$var$checkUInt53(number);
    return number < 0xfd ? 1 : number <= 0xffff ? 3 : number <= 0xffffffff ? 5 : 9;
}
$3aab16f2bcaeeed2$exports = {
    encode: $3aab16f2bcaeeed2$var$encode,
    decode: $3aab16f2bcaeeed2$var$decode,
    encodingLength: $3aab16f2bcaeeed2$var$encodingLength
};


// https://github.com/feross/buffer/blob/master/index.js#L1127
function $4f1d1f810d91b53b$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $4f1d1f810d91b53b$var$readUInt64LE(buffer, offset) {
    var a = buffer.readUInt32LE(offset);
    var b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $4f1d1f810d91b53b$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
$4f1d1f810d91b53b$exports.readUInt64LE = $4f1d1f810d91b53b$var$readUInt64LE;
function $4f1d1f810d91b53b$var$writeUInt64LE(buffer, value, offset) {
    $4f1d1f810d91b53b$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
$4f1d1f810d91b53b$exports.writeUInt64LE = $4f1d1f810d91b53b$var$writeUInt64LE;
function $4f1d1f810d91b53b$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    var j = buffer.length - 1;
    var tmp = 0;
    for(var i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
$4f1d1f810d91b53b$exports.reverseBuffer = $4f1d1f810d91b53b$var$reverseBuffer;
function $4f1d1f810d91b53b$var$cloneBuffer(buffer) {
    var clone = $4f1d1f810d91b53b$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
$4f1d1f810d91b53b$exports.cloneBuffer = $4f1d1f810d91b53b$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ var $4f1d1f810d91b53b$var$BufferWriter = /*#__PURE__*/ function() {
    "use strict";
    function BufferWriter(buffer) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $7dKN1._)(this, BufferWriter);
        this.buffer = buffer;
        this.offset = offset;
        $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Buffer, $8f74010e7554fd26$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    (0, $eW5pA._)(BufferWriter, [
        {
            key: "writeUInt8",
            value: function writeUInt8(i) {
                this.offset = this.buffer.writeUInt8(i, this.offset);
            }
        },
        {
            key: "writeInt32",
            value: function writeInt32(i) {
                this.offset = this.buffer.writeInt32LE(i, this.offset);
            }
        },
        {
            key: "writeUInt32",
            value: function writeUInt32(i) {
                this.offset = this.buffer.writeUInt32LE(i, this.offset);
            }
        },
        {
            key: "writeUInt64",
            value: function writeUInt64(i) {
                this.offset = $4f1d1f810d91b53b$var$writeUInt64LE(this.buffer, i, this.offset);
            }
        },
        {
            key: "writeVarInt",
            value: function writeVarInt(i) {
                $3aab16f2bcaeeed2$exports.encode(i, this.buffer, this.offset);
                this.offset += $3aab16f2bcaeeed2$exports.encode.bytes;
            }
        },
        {
            key: "writeSlice",
            value: function writeSlice(slice) {
                if (this.buffer.length < this.offset + slice.length) throw new Error("Cannot write slice out of bounds");
                this.offset += slice.copy(this.buffer, this.offset);
            }
        },
        {
            key: "writeVarSlice",
            value: function writeVarSlice(slice) {
                this.writeVarInt(slice.length);
                this.writeSlice(slice);
            }
        },
        {
            key: "writeVector",
            value: function writeVector(vector) {
                var _this = this;
                this.writeVarInt(vector.length);
                vector.forEach(function(buf) {
                    return _this.writeVarSlice(buf);
                });
            }
        }
    ]);
    return BufferWriter;
}();
$4f1d1f810d91b53b$exports.BufferWriter = $4f1d1f810d91b53b$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ var $4f1d1f810d91b53b$var$BufferReader = /*#__PURE__*/ function() {
    "use strict";
    function BufferReader(buffer) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $7dKN1._)(this, BufferReader);
        this.buffer = buffer;
        this.offset = offset;
        $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Buffer, $8f74010e7554fd26$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    (0, $eW5pA._)(BufferReader, [
        {
            key: "readUInt8",
            value: function readUInt8() {
                var result = this.buffer.readUInt8(this.offset);
                this.offset++;
                return result;
            }
        },
        {
            key: "readInt32",
            value: function readInt32() {
                var result = this.buffer.readInt32LE(this.offset);
                this.offset += 4;
                return result;
            }
        },
        {
            key: "readUInt32",
            value: function readUInt32() {
                var result = this.buffer.readUInt32LE(this.offset);
                this.offset += 4;
                return result;
            }
        },
        {
            key: "readUInt64",
            value: function readUInt64() {
                var result = $4f1d1f810d91b53b$var$readUInt64LE(this.buffer, this.offset);
                this.offset += 8;
                return result;
            }
        },
        {
            key: "readVarInt",
            value: function readVarInt() {
                var vi = $3aab16f2bcaeeed2$exports.decode(this.buffer, this.offset);
                this.offset += $3aab16f2bcaeeed2$exports.decode.bytes;
                return vi;
            }
        },
        {
            key: "readSlice",
            value: function readSlice(n) {
                if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
                var result = this.buffer.slice(this.offset, this.offset + n);
                this.offset += n;
                return result;
            }
        },
        {
            key: "readVarSlice",
            value: function readVarSlice() {
                return this.readSlice(this.readVarInt());
            }
        },
        {
            key: "readVector",
            value: function readVector() {
                var count = this.readVarInt();
                var vector = [];
                for(var i = 0; i < count; i++)vector.push(this.readVarSlice());
                return vector;
            }
        }
    ]);
    return BufferReader;
}();
$4f1d1f810d91b53b$exports.BufferReader = $4f1d1f810d91b53b$var$BufferReader;



var $55e09fe174fff4e9$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $55e09fe174fff4e9$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($55e09fe174fff4e9$exports, "__esModule", {
    value: true
});






var $e9ZU4 = parcelRequire("e9ZU4");

function $55e09fe174fff4e9$var$varSliceSize(someScript) {
    var length = someScript.length;
    return $3aab16f2bcaeeed2$exports.encodingLength(length) + length;
}
function $55e09fe174fff4e9$var$vectorSize(someVector) {
    var length = someVector.length;
    return $3aab16f2bcaeeed2$exports.encodingLength(length) + someVector.reduce(function(sum, witness) {
        return sum + $55e09fe174fff4e9$var$varSliceSize(witness);
    }, 0);
}
var $55e09fe174fff4e9$var$EMPTY_SCRIPT = $55e09fe174fff4e9$require$Buffer.allocUnsafe(0);
var $55e09fe174fff4e9$var$EMPTY_WITNESS = [];
var $55e09fe174fff4e9$var$ZERO = $55e09fe174fff4e9$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
var $55e09fe174fff4e9$var$ONE = $55e09fe174fff4e9$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000001", "hex");
var $55e09fe174fff4e9$var$VALUE_UINT64_MAX = $55e09fe174fff4e9$require$Buffer.from("ffffffffffffffff", "hex");
var $55e09fe174fff4e9$var$BLANK_OUTPUT = {
    script: $55e09fe174fff4e9$var$EMPTY_SCRIPT,
    valueBuffer: $55e09fe174fff4e9$var$VALUE_UINT64_MAX
};
function $55e09fe174fff4e9$var$isOutput(out) {
    return out.value !== undefined;
}
var $55e09fe174fff4e9$var$Transaction = /*#__PURE__*/ function() {
    "use strict";
    function Transaction() {
        (0, $7dKN1._)(this, Transaction);
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    (0, $eW5pA._)(Transaction, [
        {
            key: "isCoinbase",
            value: function isCoinbase() {
                return this.ins.length === 1 && Transaction.isCoinbaseHash(this.ins[0].hash);
            }
        },
        {
            key: "addInput",
            value: function addInput(hash, index, sequence, scriptSig) {
                $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Hash256bit, $8f74010e7554fd26$exports.UInt32, $8f74010e7554fd26$exports.maybe($8f74010e7554fd26$exports.UInt32), $8f74010e7554fd26$exports.maybe($8f74010e7554fd26$exports.Buffer)), arguments);
                if ($8f74010e7554fd26$exports.Null(sequence)) sequence = Transaction.DEFAULT_SEQUENCE;
                // Add the input and return the input's index
                return this.ins.push({
                    hash: hash,
                    index: index,
                    script: scriptSig || $55e09fe174fff4e9$var$EMPTY_SCRIPT,
                    sequence: sequence,
                    witness: $55e09fe174fff4e9$var$EMPTY_WITNESS
                }) - 1;
            }
        },
        {
            key: "addOutput",
            value: function addOutput(scriptPubKey, value) {
                $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Buffer, $8f74010e7554fd26$exports.Satoshi), arguments);
                // Add the output and return the output's index
                return this.outs.push({
                    script: scriptPubKey,
                    value: value
                }) - 1;
            }
        },
        {
            key: "hasWitnesses",
            value: function hasWitnesses() {
                return this.ins.some(function(x) {
                    return x.witness.length !== 0;
                });
            }
        },
        {
            key: "weight",
            value: function weight() {
                var base = this.byteLength(false);
                var total = this.byteLength(true);
                return base * 3 + total;
            }
        },
        {
            key: "virtualSize",
            value: function virtualSize() {
                return Math.ceil(this.weight() / 4);
            }
        },
        {
            key: "byteLength",
            value: function byteLength() {
                var _ALLOW_WITNESS = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
                return (hasWitnesses ? 10 : 8) + $3aab16f2bcaeeed2$exports.encodingLength(this.ins.length) + $3aab16f2bcaeeed2$exports.encodingLength(this.outs.length) + this.ins.reduce(function(sum, input) {
                    return sum + 40 + $55e09fe174fff4e9$var$varSliceSize(input.script);
                }, 0) + this.outs.reduce(function(sum, output) {
                    return sum + 8 + $55e09fe174fff4e9$var$varSliceSize(output.script);
                }, 0) + (hasWitnesses ? this.ins.reduce(function(sum, input) {
                    return sum + $55e09fe174fff4e9$var$vectorSize(input.witness);
                }, 0) : 0);
            }
        },
        {
            key: "clone",
            value: function clone() {
                var newTx = new Transaction();
                newTx.version = this.version;
                newTx.locktime = this.locktime;
                newTx.ins = this.ins.map(function(txIn) {
                    return {
                        hash: txIn.hash,
                        index: txIn.index,
                        script: txIn.script,
                        sequence: txIn.sequence,
                        witness: txIn.witness
                    };
                });
                newTx.outs = this.outs.map(function(txOut) {
                    return {
                        script: txOut.script,
                        value: txOut.value
                    };
                });
                return newTx;
            }
        },
        {
            /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ key: "hashForSignature",
            value: function hashForSignature(inIndex, prevOutScript, hashType) {
                $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.UInt32, $8f74010e7554fd26$exports.Buffer, /* types.UInt8 */ $8f74010e7554fd26$exports.Number), arguments);
                // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
                if (inIndex >= this.ins.length) return $55e09fe174fff4e9$var$ONE;
                // ignore OP_CODESEPARATOR
                var ourScript = $120fce5ded7fb153$exports.compile($120fce5ded7fb153$exports.decompile(prevOutScript).filter(function(x) {
                    return x !== $120fce5ded7fb153$exports.OPS.OP_CODESEPARATOR;
                }));
                var txTmp = this.clone();
                // SIGHASH_NONE: ignore all outputs? (wildcard payee)
                if ((hashType & 0x1f) === Transaction.SIGHASH_NONE) {
                    txTmp.outs = [];
                    // ignore sequence numbers (except at inIndex)
                    txTmp.ins.forEach(function(input, i) {
                        if (i === inIndex) return;
                        input.sequence = 0;
                    });
                // SIGHASH_SINGLE: ignore all outputs, except at the same index?
                } else if ((hashType & 0x1f) === Transaction.SIGHASH_SINGLE) {
                    // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
                    if (inIndex >= this.outs.length) return $55e09fe174fff4e9$var$ONE;
                    // truncate outputs after
                    txTmp.outs.length = inIndex + 1;
                    // "blank" outputs before
                    for(var i = 0; i < inIndex; i++)txTmp.outs[i] = $55e09fe174fff4e9$var$BLANK_OUTPUT;
                    // ignore sequence numbers (except at inIndex)
                    txTmp.ins.forEach(function(input, y) {
                        if (y === inIndex) return;
                        input.sequence = 0;
                    });
                }
                // SIGHASH_ANYONECANPAY: ignore inputs entirely?
                if (hashType & Transaction.SIGHASH_ANYONECANPAY) {
                    txTmp.ins = [
                        txTmp.ins[inIndex]
                    ];
                    txTmp.ins[0].script = ourScript;
                // SIGHASH_ALL: only ignore input scripts
                } else {
                    // "blank" others input scripts
                    txTmp.ins.forEach(function(input) {
                        input.script = $55e09fe174fff4e9$var$EMPTY_SCRIPT;
                    });
                    txTmp.ins[inIndex].script = ourScript;
                }
                // serialize and hash
                var buffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
                buffer.writeInt32LE(hashType, buffer.length - 4);
                txTmp.__toBuffer(buffer, 0, false);
                return $0f478b5636513f95$exports.hash256(buffer);
            }
        },
        {
            key: "hashForWitnessV0",
            value: function hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
                $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.UInt32, $8f74010e7554fd26$exports.Buffer, $8f74010e7554fd26$exports.Satoshi, $8f74010e7554fd26$exports.UInt32), arguments);
                var tbuffer = $55e09fe174fff4e9$require$Buffer.from([]);
                var bufferWriter;
                var hashOutputs = $55e09fe174fff4e9$var$ZERO;
                var hashPrevouts = $55e09fe174fff4e9$var$ZERO;
                var hashSequence = $55e09fe174fff4e9$var$ZERO;
                if (!(hashType & Transaction.SIGHASH_ANYONECANPAY)) {
                    tbuffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(36 * this.ins.length);
                    bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(tbuffer, 0);
                    this.ins.forEach(function(txIn) {
                        bufferWriter.writeSlice(txIn.hash);
                        bufferWriter.writeUInt32(txIn.index);
                    });
                    hashPrevouts = $0f478b5636513f95$exports.hash256(tbuffer);
                }
                if (!(hashType & Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== Transaction.SIGHASH_NONE) {
                    tbuffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(4 * this.ins.length);
                    bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(tbuffer, 0);
                    this.ins.forEach(function(txIn) {
                        bufferWriter.writeUInt32(txIn.sequence);
                    });
                    hashSequence = $0f478b5636513f95$exports.hash256(tbuffer);
                }
                if ((hashType & 0x1f) !== Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== Transaction.SIGHASH_NONE) {
                    var txOutsSize = this.outs.reduce(function(sum, output) {
                        return sum + 8 + $55e09fe174fff4e9$var$varSliceSize(output.script);
                    }, 0);
                    tbuffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(txOutsSize);
                    bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(tbuffer, 0);
                    this.outs.forEach(function(out) {
                        bufferWriter.writeUInt64(out.value);
                        bufferWriter.writeVarSlice(out.script);
                    });
                    hashOutputs = $0f478b5636513f95$exports.hash256(tbuffer);
                } else if ((hashType & 0x1f) === Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
                    var output = this.outs[inIndex];
                    tbuffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(8 + $55e09fe174fff4e9$var$varSliceSize(output.script));
                    bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(tbuffer, 0);
                    bufferWriter.writeUInt64(output.value);
                    bufferWriter.writeVarSlice(output.script);
                    hashOutputs = $0f478b5636513f95$exports.hash256(tbuffer);
                }
                tbuffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(156 + $55e09fe174fff4e9$var$varSliceSize(prevOutScript));
                bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(tbuffer, 0);
                var input = this.ins[inIndex];
                bufferWriter.writeUInt32(this.version);
                bufferWriter.writeSlice(hashPrevouts);
                bufferWriter.writeSlice(hashSequence);
                bufferWriter.writeSlice(input.hash);
                bufferWriter.writeUInt32(input.index);
                bufferWriter.writeVarSlice(prevOutScript);
                bufferWriter.writeUInt64(value);
                bufferWriter.writeUInt32(input.sequence);
                bufferWriter.writeSlice(hashOutputs);
                bufferWriter.writeUInt32(this.locktime);
                bufferWriter.writeUInt32(hashType);
                return $0f478b5636513f95$exports.hash256(tbuffer);
            }
        },
        {
            key: "getHash",
            value: function getHash(forWitness) {
                // wtxid for coinbase is always 32 bytes of 0x00
                if (forWitness && this.isCoinbase()) return $55e09fe174fff4e9$require$Buffer.alloc(32, 0);
                return $0f478b5636513f95$exports.hash256(this.__toBuffer(undefined, undefined, forWitness));
            }
        },
        {
            key: "getId",
            value: function getId() {
                // transaction hash's are displayed in reverse order
                return $4f1d1f810d91b53b$exports.reverseBuffer(this.getHash(false)).toString("hex");
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer(buffer, initialOffset) {
                return this.__toBuffer(buffer, initialOffset, true);
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return this.toBuffer(undefined, undefined).toString("hex");
            }
        },
        {
            key: "setInputScript",
            value: function setInputScript(index, scriptSig) {
                $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Number, $8f74010e7554fd26$exports.Buffer), arguments);
                this.ins[index].script = scriptSig;
            }
        },
        {
            key: "setWitness",
            value: function setWitness(index, witness) {
                $e9ZU4($8f74010e7554fd26$exports.tuple($8f74010e7554fd26$exports.Number, [
                    $8f74010e7554fd26$exports.Buffer
                ]), arguments);
                this.ins[index].witness = witness;
            }
        },
        {
            key: "__toBuffer",
            value: function __toBuffer(buffer, initialOffset) {
                var _ALLOW_WITNESS = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (!buffer) buffer = $55e09fe174fff4e9$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
                var bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(buffer, initialOffset || 0);
                bufferWriter.writeInt32(this.version);
                var hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
                if (hasWitnesses) {
                    bufferWriter.writeUInt8(Transaction.ADVANCED_TRANSACTION_MARKER);
                    bufferWriter.writeUInt8(Transaction.ADVANCED_TRANSACTION_FLAG);
                }
                bufferWriter.writeVarInt(this.ins.length);
                this.ins.forEach(function(txIn) {
                    bufferWriter.writeSlice(txIn.hash);
                    bufferWriter.writeUInt32(txIn.index);
                    bufferWriter.writeVarSlice(txIn.script);
                    bufferWriter.writeUInt32(txIn.sequence);
                });
                bufferWriter.writeVarInt(this.outs.length);
                this.outs.forEach(function(txOut) {
                    if ($55e09fe174fff4e9$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
                    else bufferWriter.writeSlice(txOut.valueBuffer);
                    bufferWriter.writeVarSlice(txOut.script);
                });
                if (hasWitnesses) this.ins.forEach(function(input) {
                    bufferWriter.writeVector(input.witness);
                });
                bufferWriter.writeUInt32(this.locktime);
                // avoid slicing unless necessary
                if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
                return buffer;
            }
        }
    ], [
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer, _NO_STRICT) {
                var bufferReader = new $4f1d1f810d91b53b$exports.BufferReader(buffer);
                var tx = new Transaction();
                tx.version = bufferReader.readInt32();
                var marker = bufferReader.readUInt8();
                var flag = bufferReader.readUInt8();
                var hasWitnesses = false;
                if (marker === Transaction.ADVANCED_TRANSACTION_MARKER && flag === Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
                else bufferReader.offset -= 2;
                var vinLen = bufferReader.readVarInt();
                for(var i = 0; i < vinLen; ++i)tx.ins.push({
                    hash: bufferReader.readSlice(32),
                    index: bufferReader.readUInt32(),
                    script: bufferReader.readVarSlice(),
                    sequence: bufferReader.readUInt32(),
                    witness: $55e09fe174fff4e9$var$EMPTY_WITNESS
                });
                var voutLen = bufferReader.readVarInt();
                for(var i1 = 0; i1 < voutLen; ++i1)tx.outs.push({
                    value: bufferReader.readUInt64(),
                    script: bufferReader.readVarSlice()
                });
                if (hasWitnesses) {
                    for(var i2 = 0; i2 < vinLen; ++i2)tx.ins[i2].witness = bufferReader.readVector();
                    // was this pointless?
                    if (!tx.hasWitnesses()) throw new Error("Transaction has superfluous witness data");
                }
                tx.locktime = bufferReader.readUInt32();
                if (_NO_STRICT) return tx;
                if (bufferReader.offset !== buffer.length) throw new Error("Transaction has unexpected data");
                return tx;
            }
        },
        {
            key: "fromHex",
            value: function fromHex(hex) {
                return Transaction.fromBuffer($55e09fe174fff4e9$require$Buffer.from(hex, "hex"), false);
            }
        },
        {
            key: "isCoinbaseHash",
            value: function isCoinbaseHash(buffer) {
                $e9ZU4($8f74010e7554fd26$exports.Hash256bit, buffer);
                for(var i = 0; i < 32; ++i){
                    if (buffer[i] !== 0) return false;
                }
                return true;
            }
        }
    ]);
    return Transaction;
}();
$55e09fe174fff4e9$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$55e09fe174fff4e9$var$Transaction.SIGHASH_ALL = 0x01;
$55e09fe174fff4e9$var$Transaction.SIGHASH_NONE = 0x02;
$55e09fe174fff4e9$var$Transaction.SIGHASH_SINGLE = 0x03;
$55e09fe174fff4e9$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$55e09fe174fff4e9$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$55e09fe174fff4e9$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;
$55e09fe174fff4e9$exports.Transaction = $55e09fe174fff4e9$var$Transaction;



var $55394cd22df245ae$exports = {};
// constant-space merkle root calculation algorithm

var $ilnag = parcelRequire("ilnag");
var $55394cd22df245ae$require$Buffer = $ilnag.Buffer;
$55394cd22df245ae$exports = function fastRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError("Expected values Array");
    if (typeof digestFn !== "function") throw TypeError("Expected digest Function");
    var length = values.length;
    var results = values.concat();
    while(length > 1){
        var j = 0;
        for(var i = 0; i < length; i += 2, ++j){
            var left = results[i];
            var right = i + 1 === length ? left : results[i + 1];
            var data = $55394cd22df245ae$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
};



var $e9ZU4 = parcelRequire("e9ZU4");

var $db2b43867ef95ee1$var$errorMerkleNoTxes = new TypeError("Cannot compute merkle root for zero transactions");
var $db2b43867ef95ee1$var$errorWitnessNotSegwit = new TypeError("Cannot compute witness commit for non-segwit block");
var $db2b43867ef95ee1$var$Block = /*#__PURE__*/ function() {
    "use strict";
    function Block() {
        (0, $7dKN1._)(this, Block);
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    (0, $eW5pA._)(Block, [
        {
            key: "getWitnessCommit",
            value: function getWitnessCommit() {
                if (!$db2b43867ef95ee1$var$txesHaveWitnessCommit(this.transactions)) return null;
                // The merkle root for the witness data is in an OP_RETURN output.
                // There is no rule for the index of the output, so use filter to find it.
                // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
                // If multiple commits are found, the output with highest index is assumed.
                var witnessCommits = this.transactions[0].outs.filter(function(out) {
                    return out.script.slice(0, 6).equals($db2b43867ef95ee1$require$Buffer.from("6a24aa21a9ed", "hex"));
                }).map(function(out) {
                    return out.script.slice(6, 38);
                });
                if (witnessCommits.length === 0) return null;
                // Use the commit with the highest output (should only be one though)
                var result = witnessCommits[witnessCommits.length - 1];
                if (!(result instanceof $db2b43867ef95ee1$require$Buffer && result.length === 32)) return null;
                return result;
            }
        },
        {
            key: "hasWitnessCommit",
            value: function hasWitnessCommit() {
                if (this.witnessCommit instanceof $db2b43867ef95ee1$require$Buffer && this.witnessCommit.length === 32) return true;
                if (this.getWitnessCommit() !== null) return true;
                return false;
            }
        },
        {
            key: "hasWitness",
            value: function hasWitness() {
                return $db2b43867ef95ee1$var$anyTxHasWitness(this.transactions);
            }
        },
        {
            key: "weight",
            value: function weight() {
                var base = this.byteLength(false, false);
                var total = this.byteLength(false, true);
                return base * 3 + total;
            }
        },
        {
            key: "byteLength",
            value: function byteLength(headersOnly) {
                var allowWitness = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (headersOnly || !this.transactions) return 80;
                return 80 + $3aab16f2bcaeeed2$exports.encodingLength(this.transactions.length) + this.transactions.reduce(function(a, x) {
                    return a + x.byteLength(allowWitness);
                }, 0);
            }
        },
        {
            key: "getHash",
            value: function getHash() {
                return $0f478b5636513f95$exports.hash256(this.toBuffer(true));
            }
        },
        {
            key: "getId",
            value: function getId() {
                return $4f1d1f810d91b53b$exports.reverseBuffer(this.getHash()).toString("hex");
            }
        },
        {
            key: "getUTCDate",
            value: function getUTCDate() {
                var date = new Date(0); // epoch
                date.setUTCSeconds(this.timestamp);
                return date;
            }
        },
        {
            // TODO: buffer, offset compatibility
            key: "toBuffer",
            value: function toBuffer(headersOnly) {
                var buffer = $db2b43867ef95ee1$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
                var bufferWriter = new $4f1d1f810d91b53b$exports.BufferWriter(buffer);
                bufferWriter.writeInt32(this.version);
                bufferWriter.writeSlice(this.prevHash);
                bufferWriter.writeSlice(this.merkleRoot);
                bufferWriter.writeUInt32(this.timestamp);
                bufferWriter.writeUInt32(this.bits);
                bufferWriter.writeUInt32(this.nonce);
                if (headersOnly || !this.transactions) return buffer;
                $3aab16f2bcaeeed2$exports.encode(this.transactions.length, buffer, bufferWriter.offset);
                bufferWriter.offset += $3aab16f2bcaeeed2$exports.encode.bytes;
                this.transactions.forEach(function(tx) {
                    var txSize = tx.byteLength(); // TODO: extract from toBuffer?
                    tx.toBuffer(buffer, bufferWriter.offset);
                    bufferWriter.offset += txSize;
                });
                return buffer;
            }
        },
        {
            key: "toHex",
            value: function toHex(headersOnly) {
                return this.toBuffer(headersOnly).toString("hex");
            }
        },
        {
            key: "checkTxRoots",
            value: function checkTxRoots() {
                // If the Block has segwit transactions but no witness commit,
                // there's no way it can be valid, so fail the check.
                var hasWitnessCommit = this.hasWitnessCommit();
                if (!hasWitnessCommit && this.hasWitness()) return false;
                return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
            }
        },
        {
            key: "checkProofOfWork",
            value: function checkProofOfWork() {
                var hash = $4f1d1f810d91b53b$exports.reverseBuffer(this.getHash());
                var target = Block.calculateTarget(this.bits);
                return hash.compare(target) <= 0;
            }
        },
        {
            key: "__checkMerkleRoot",
            value: function __checkMerkleRoot() {
                if (!this.transactions) throw $db2b43867ef95ee1$var$errorMerkleNoTxes;
                var actualMerkleRoot = Block.calculateMerkleRoot(this.transactions);
                return this.merkleRoot.compare(actualMerkleRoot) === 0;
            }
        },
        {
            key: "__checkWitnessCommit",
            value: function __checkWitnessCommit() {
                if (!this.transactions) throw $db2b43867ef95ee1$var$errorMerkleNoTxes;
                if (!this.hasWitnessCommit()) throw $db2b43867ef95ee1$var$errorWitnessNotSegwit;
                var actualWitnessCommit = Block.calculateMerkleRoot(this.transactions, true);
                return this.witnessCommit.compare(actualWitnessCommit) === 0;
            }
        }
    ], [
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer) {
                if (buffer.length < 80) throw new Error("Buffer too small (< 80 bytes)");
                var bufferReader = new $4f1d1f810d91b53b$exports.BufferReader(buffer);
                var block = new Block();
                block.version = bufferReader.readInt32();
                block.prevHash = bufferReader.readSlice(32);
                block.merkleRoot = bufferReader.readSlice(32);
                block.timestamp = bufferReader.readUInt32();
                block.bits = bufferReader.readUInt32();
                block.nonce = bufferReader.readUInt32();
                if (buffer.length === 80) return block;
                var readTransaction = function() {
                    var tx = $55e09fe174fff4e9$exports.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
                    bufferReader.offset += tx.byteLength();
                    return tx;
                };
                var nTransactions = bufferReader.readVarInt();
                block.transactions = [];
                for(var i = 0; i < nTransactions; ++i){
                    var tx = readTransaction();
                    block.transactions.push(tx);
                }
                var witnessCommit = block.getWitnessCommit();
                // This Block contains a witness commit
                if (witnessCommit) block.witnessCommit = witnessCommit;
                return block;
            }
        },
        {
            key: "fromHex",
            value: function fromHex(hex) {
                return Block.fromBuffer($db2b43867ef95ee1$require$Buffer.from(hex, "hex"));
            }
        },
        {
            key: "calculateTarget",
            value: function calculateTarget(bits) {
                var exponent = ((bits & 0xff000000) >> 24) - 3;
                var mantissa = bits & 0x007fffff;
                var target = $db2b43867ef95ee1$require$Buffer.alloc(32, 0);
                target.writeUIntBE(mantissa, 29 - exponent, 3);
                return target;
            }
        },
        {
            key: "calculateMerkleRoot",
            value: function calculateMerkleRoot(transactions, forWitness) {
                $e9ZU4([
                    {
                        getHash: $8f74010e7554fd26$exports.Function
                    }
                ], transactions);
                if (transactions.length === 0) throw $db2b43867ef95ee1$var$errorMerkleNoTxes;
                if (forWitness && !$db2b43867ef95ee1$var$txesHaveWitnessCommit(transactions)) throw $db2b43867ef95ee1$var$errorWitnessNotSegwit;
                var hashes = transactions.map(function(transaction) {
                    return transaction.getHash(forWitness);
                });
                var rootHash = $55394cd22df245ae$exports(hashes, $0f478b5636513f95$exports.hash256);
                return forWitness ? $0f478b5636513f95$exports.hash256($db2b43867ef95ee1$require$Buffer.concat([
                    rootHash,
                    transactions[0].ins[0].witness[0]
                ])) : rootHash;
            }
        }
    ]);
    return Block;
}();
$db2b43867ef95ee1$exports.Block = $db2b43867ef95ee1$var$Block;
function $db2b43867ef95ee1$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $db2b43867ef95ee1$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some(function(tx) {
        return typeof tx === "object" && tx.ins instanceof Array && tx.ins.some(function(input) {
            return typeof input === "object" && input.witness instanceof Array && input.witness.length > 0;
        });
    });
}


$9ce982a108f9bffc$exports.Block = $db2b43867ef95ee1$exports.Block;
var $7ef4ee67e9f293e1$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $7ef4ee67e9f293e1$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($7ef4ee67e9f293e1$exports, "__esModule", {
    value: true
});
var $27f0a5038233d038$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $27f0a5038233d038$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($27f0a5038233d038$exports, "__esModule", {
    value: true
});
var $854cdc960609cac3$exports = {};
"use strict";
Object.defineProperty($854cdc960609cac3$exports, "__esModule", {
    value: true
});
var $0d595798c6372086$exports = {};
"use strict";
function $0d595798c6372086$var$__export(m) {
    for(var p in m)if (!$0d595798c6372086$exports.hasOwnProperty(p)) $0d595798c6372086$exports[p] = m[p];
}
Object.defineProperty($0d595798c6372086$exports, "__esModule", {
    value: true
});

$0d595798c6372086$var$__export((parcelRequire("7xZy0")));

$0d595798c6372086$var$__export((parcelRequire("2D2Ay")));


function $854cdc960609cac3$var$combine(psbts) {
    var self = psbts[0];
    var selfKeyVals = $0d595798c6372086$exports.psbtToKeyVals(self);
    var others = psbts.slice(1);
    if (others.length === 0) throw new Error("Combine: Nothing to combine");
    var selfTx = $854cdc960609cac3$var$getTx(self);
    if (selfTx === undefined) throw new Error("Combine: Self missing transaction");
    var selfGlobalSet = $854cdc960609cac3$var$getKeySet(selfKeyVals.globalKeyVals);
    var selfInputSets = selfKeyVals.inputKeyVals.map($854cdc960609cac3$var$getKeySet);
    var selfOutputSets = selfKeyVals.outputKeyVals.map($854cdc960609cac3$var$getKeySet);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var other = _step.value;
            var otherTx = $854cdc960609cac3$var$getTx(other);
            if (otherTx === undefined || !otherTx.toBuffer().equals(selfTx.toBuffer())) throw new Error("Combine: One of the Psbts does not have the same transaction.");
            var otherKeyVals = $0d595798c6372086$exports.psbtToKeyVals(other);
            var otherGlobalSet = $854cdc960609cac3$var$getKeySet(otherKeyVals.globalKeyVals);
            otherGlobalSet.forEach($854cdc960609cac3$var$keyPusher(selfGlobalSet, selfKeyVals.globalKeyVals, otherKeyVals.globalKeyVals));
            var otherInputSets = otherKeyVals.inputKeyVals.map($854cdc960609cac3$var$getKeySet);
            otherInputSets.forEach(function(inputSet, idx) {
                return inputSet.forEach($854cdc960609cac3$var$keyPusher(selfInputSets[idx], selfKeyVals.inputKeyVals[idx], otherKeyVals.inputKeyVals[idx]));
            });
            var otherOutputSets = otherKeyVals.outputKeyVals.map($854cdc960609cac3$var$getKeySet);
            otherOutputSets.forEach(function(outputSet, idx) {
                return outputSet.forEach($854cdc960609cac3$var$keyPusher(selfOutputSets[idx], selfKeyVals.outputKeyVals[idx], otherKeyVals.outputKeyVals[idx]));
            });
        };
        for(var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $0d595798c6372086$exports.psbtFromKeyVals(selfTx, {
        globalMapKeyVals: selfKeyVals.globalKeyVals,
        inputKeyVals: selfKeyVals.inputKeyVals,
        outputKeyVals: selfKeyVals.outputKeyVals
    });
}
$854cdc960609cac3$exports.combine = $854cdc960609cac3$var$combine;
function $854cdc960609cac3$var$keyPusher(selfSet, selfKeyVals, otherKeyVals) {
    return function(key) {
        if (selfSet.has(key)) return;
        var newKv = otherKeyVals.filter(function(kv) {
            return kv.key.toString("hex") === key;
        })[0];
        selfKeyVals.push(newKv);
        selfSet.add(key);
    };
}
function $854cdc960609cac3$var$getTx(psbt) {
    return psbt.globalMap.unsignedTx;
}
function $854cdc960609cac3$var$getKeySet(keyVals) {
    var set = new Set();
    keyVals.forEach(function(keyVal) {
        var hex = keyVal.key.toString("hex");
        if (set.has(hex)) throw new Error("Combine: KeyValue Map keys should be unique");
        set.add(hex);
    });
    return set;
}




var $iUuQV = parcelRequire("iUuQV");
var $2afa9fa2748275c6$exports = {};

var $ilnag = parcelRequire("ilnag");
var $2afa9fa2748275c6$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($2afa9fa2748275c6$exports, "__esModule", {
    value: true
});

var $lXO7v = parcelRequire("lXO7v");
function $2afa9fa2748275c6$var$checkForInput(inputs, inputIndex) {
    var input = inputs[inputIndex];
    if (input === undefined) throw new Error("No input #".concat(inputIndex));
    return input;
}
$2afa9fa2748275c6$exports.checkForInput = $2afa9fa2748275c6$var$checkForInput;
function $2afa9fa2748275c6$var$checkForOutput(outputs, outputIndex) {
    var output = outputs[outputIndex];
    if (output === undefined) throw new Error("No output #".concat(outputIndex));
    return output;
}
$2afa9fa2748275c6$exports.checkForOutput = $2afa9fa2748275c6$var$checkForOutput;
function $2afa9fa2748275c6$var$checkHasKey(checkKeyVal, keyVals, enumLength) {
    if (checkKeyVal.key[0] < enumLength) throw new Error("Use the method for your specific key instead of addUnknownKeyVal*");
    if (keyVals && keyVals.filter(function(kv) {
        return kv.key.equals(checkKeyVal.key);
    }).length !== 0) throw new Error("Duplicate Key: ".concat(checkKeyVal.key.toString("hex")));
}
$2afa9fa2748275c6$exports.checkHasKey = $2afa9fa2748275c6$var$checkHasKey;
function $2afa9fa2748275c6$var$getEnumLength(myenum) {
    var count = 0;
    Object.keys(myenum).forEach(function(val) {
        if (Number(isNaN(Number(val)))) count++;
    });
    return count;
}
$2afa9fa2748275c6$exports.getEnumLength = $2afa9fa2748275c6$var$getEnumLength;
function $2afa9fa2748275c6$var$inputCheckUncleanFinalized(inputIndex, input) {
    var result = false;
    if (input.nonWitnessUtxo || input.witnessUtxo) {
        var needScriptSig = !!input.redeemScript;
        var needWitnessScript = !!input.witnessScript;
        var scriptSigOK = !needScriptSig || !!input.finalScriptSig;
        var witnessScriptOK = !needWitnessScript || !!input.finalScriptWitness;
        var hasOneFinal = !!input.finalScriptSig || !!input.finalScriptWitness;
        result = scriptSigOK && witnessScriptOK && hasOneFinal;
    }
    if (result === false) throw new Error("Input #".concat(inputIndex, " has too much or too little data to clean"));
}
$2afa9fa2748275c6$exports.inputCheckUncleanFinalized = $2afa9fa2748275c6$var$inputCheckUncleanFinalized;
function $2afa9fa2748275c6$var$throwForUpdateMaker(typeName, name, expected, data) {
    throw new Error("Data for ".concat(typeName, " key ").concat(name, " is incorrect: Expected ") + "".concat(expected, " and got ").concat(JSON.stringify(data)));
}
function $2afa9fa2748275c6$var$updateMaker(typeName) {
    return function(updateData, mainData) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var name = _step.value;
                // @ts-ignore
                var data = updateData[name];
                // @ts-ignore
                var // @ts-ignore
                _ref = $lXO7v[typeName + "s"][name] || {}, canAdd = _ref.canAdd, canAddToArray = _ref.canAddToArray, check = _ref.check, expected = _ref.expected;
                var isArray = !!canAddToArray;
                // If unknown data. ignore and do not add
                if (check) {
                    if (isArray) {
                        if (!Array.isArray(data) || // @ts-ignore
                        mainData[name] && !Array.isArray(mainData[name])) throw new Error("Key type ".concat(name, " must be an array"));
                        if (!data.every(check)) $2afa9fa2748275c6$var$throwForUpdateMaker(typeName, name, expected, data);
                        // @ts-ignore
                        var arr = mainData[name] || [];
                        var dupeCheckSet = new Set();
                        if (!data.every(function(v) {
                            return canAddToArray(arr, v, dupeCheckSet);
                        })) throw new Error("Can not add duplicate data to array");
                        // @ts-ignore
                        mainData[name] = arr.concat(data);
                    } else {
                        if (!check(data)) $2afa9fa2748275c6$var$throwForUpdateMaker(typeName, name, expected, data);
                        if (!canAdd(mainData, data)) throw new Error("Can not add duplicate data to ".concat(typeName));
                        // @ts-ignore
                        mainData[name] = data;
                    }
                }
            };
            for(var _iterator = Object.keys(updateData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
$2afa9fa2748275c6$exports.updateGlobal = $2afa9fa2748275c6$var$updateMaker("global");
$2afa9fa2748275c6$exports.updateInput = $2afa9fa2748275c6$var$updateMaker("input");
$2afa9fa2748275c6$exports.updateOutput = $2afa9fa2748275c6$var$updateMaker("output");
function $2afa9fa2748275c6$var$addInputAttributes(inputs, data) {
    var index = inputs.length - 1;
    var input = $2afa9fa2748275c6$var$checkForInput(inputs, index);
    $2afa9fa2748275c6$exports.updateInput(data, input);
}
$2afa9fa2748275c6$exports.addInputAttributes = $2afa9fa2748275c6$var$addInputAttributes;
function $2afa9fa2748275c6$var$addOutputAttributes(outputs, data) {
    var index = outputs.length - 1;
    var output = $2afa9fa2748275c6$var$checkForOutput(outputs, index);
    $2afa9fa2748275c6$exports.updateOutput(data, output);
}
$2afa9fa2748275c6$exports.addOutputAttributes = $2afa9fa2748275c6$var$addOutputAttributes;
function $2afa9fa2748275c6$var$defaultVersionSetter(version, txBuf) {
    if (!$2afa9fa2748275c6$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Version: Invalid Transaction");
    txBuf.writeUInt32LE(version, 0);
    return txBuf;
}
$2afa9fa2748275c6$exports.defaultVersionSetter = $2afa9fa2748275c6$var$defaultVersionSetter;
function $2afa9fa2748275c6$var$defaultLocktimeSetter(locktime, txBuf) {
    if (!$2afa9fa2748275c6$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Locktime: Invalid Transaction");
    txBuf.writeUInt32LE(locktime, txBuf.length - 4);
    return txBuf;
}
$2afa9fa2748275c6$exports.defaultLocktimeSetter = $2afa9fa2748275c6$var$defaultLocktimeSetter;


var $27f0a5038233d038$var$Psbt = /*#__PURE__*/ function() {
    "use strict";
    function Psbt(tx) {
        (0, $7dKN1._)(this, Psbt);
        this.inputs = [];
        this.outputs = [];
        this.globalMap = {
            unsignedTx: tx
        };
    }
    (0, $eW5pA._)(Psbt, [
        {
            key: "toBase64",
            value: function toBase64() {
                var buffer = this.toBuffer();
                return buffer.toString("base64");
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                var buffer = this.toBuffer();
                return buffer.toString("hex");
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer() {
                return $0d595798c6372086$exports.psbtToBuffer(this);
            }
        },
        {
            key: "updateGlobal",
            value: function updateGlobal(updateData) {
                $2afa9fa2748275c6$exports.updateGlobal(updateData, this.globalMap);
                return this;
            }
        },
        {
            key: "updateInput",
            value: function updateInput(inputIndex, updateData) {
                var input = $2afa9fa2748275c6$exports.checkForInput(this.inputs, inputIndex);
                $2afa9fa2748275c6$exports.updateInput(updateData, input);
                return this;
            }
        },
        {
            key: "updateOutput",
            value: function updateOutput(outputIndex, updateData) {
                var output = $2afa9fa2748275c6$exports.checkForOutput(this.outputs, outputIndex);
                $2afa9fa2748275c6$exports.updateOutput(updateData, output);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToGlobal",
            value: function addUnknownKeyValToGlobal(keyVal) {
                $2afa9fa2748275c6$exports.checkHasKey(keyVal, this.globalMap.unknownKeyVals, $2afa9fa2748275c6$exports.getEnumLength($iUuQV.GlobalTypes));
                if (!this.globalMap.unknownKeyVals) this.globalMap.unknownKeyVals = [];
                this.globalMap.unknownKeyVals.push(keyVal);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToInput",
            value: function addUnknownKeyValToInput(inputIndex, keyVal) {
                var input = $2afa9fa2748275c6$exports.checkForInput(this.inputs, inputIndex);
                $2afa9fa2748275c6$exports.checkHasKey(keyVal, input.unknownKeyVals, $2afa9fa2748275c6$exports.getEnumLength($iUuQV.InputTypes));
                if (!input.unknownKeyVals) input.unknownKeyVals = [];
                input.unknownKeyVals.push(keyVal);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToOutput",
            value: function addUnknownKeyValToOutput(outputIndex, keyVal) {
                var output = $2afa9fa2748275c6$exports.checkForOutput(this.outputs, outputIndex);
                $2afa9fa2748275c6$exports.checkHasKey(keyVal, output.unknownKeyVals, $2afa9fa2748275c6$exports.getEnumLength($iUuQV.OutputTypes));
                if (!output.unknownKeyVals) output.unknownKeyVals = [];
                output.unknownKeyVals.push(keyVal);
                return this;
            }
        },
        {
            key: "addInput",
            value: function addInput(inputData) {
                var _this = this;
                this.globalMap.unsignedTx.addInput(inputData);
                this.inputs.push({
                    unknownKeyVals: []
                });
                var addKeyVals = inputData.unknownKeyVals || [];
                var inputIndex = this.inputs.length - 1;
                if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
                addKeyVals.forEach(function(keyVal) {
                    return _this.addUnknownKeyValToInput(inputIndex, keyVal);
                });
                $2afa9fa2748275c6$exports.addInputAttributes(this.inputs, inputData);
                return this;
            }
        },
        {
            key: "addOutput",
            value: function addOutput(outputData) {
                var _this = this;
                this.globalMap.unsignedTx.addOutput(outputData);
                this.outputs.push({
                    unknownKeyVals: []
                });
                var addKeyVals = outputData.unknownKeyVals || [];
                var outputIndex = this.outputs.length - 1;
                if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
                addKeyVals.forEach(function(keyVal) {
                    return _this.addUnknownKeyValToOutput(outputIndex, keyVal);
                });
                $2afa9fa2748275c6$exports.addOutputAttributes(this.outputs, outputData);
                return this;
            }
        },
        {
            key: "clearFinalizedInput",
            value: function clearFinalizedInput(inputIndex) {
                var input = $2afa9fa2748275c6$exports.checkForInput(this.inputs, inputIndex);
                $2afa9fa2748275c6$exports.inputCheckUncleanFinalized(inputIndex, input);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(input)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (![
                            "witnessUtxo",
                            "nonWitnessUtxo",
                            "finalScriptSig",
                            "finalScriptWitness",
                            "unknownKeyVals"
                        ].includes(key)) // @ts-ignore
                        delete input[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            key: "combine",
            value: function combine() {
                for(var _len = arguments.length, those = new Array(_len), _key = 0; _key < _len; _key++){
                    those[_key] = arguments[_key];
                }
                // Combine this with those.
                // Return self for chaining.
                var result = $854cdc960609cac3$exports.combine([
                    this
                ].concat(those));
                Object.assign(this, result);
                return this;
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction() {
                return this.globalMap.unsignedTx.toBuffer();
            }
        }
    ], [
        {
            key: "fromBase64",
            value: function fromBase64(data, txFromBuffer) {
                var buffer = $27f0a5038233d038$require$Buffer.from(data, "base64");
                return this.fromBuffer(buffer, txFromBuffer);
            }
        },
        {
            key: "fromHex",
            value: function fromHex(data, txFromBuffer) {
                var buffer = $27f0a5038233d038$require$Buffer.from(data, "hex");
                return this.fromBuffer(buffer, txFromBuffer);
            }
        },
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer, txFromBuffer) {
                var results = $0d595798c6372086$exports.psbtFromBuffer(buffer, txFromBuffer);
                var psbt = new this(results.globalMap.unsignedTx);
                Object.assign(psbt, results);
                return psbt;
            }
        }
    ]);
    return Psbt;
}();
$27f0a5038233d038$exports.Psbt = $27f0a5038233d038$var$Psbt;



var $d1BPf = parcelRequire("d1BPf");









/**
 * These are the default arguments for a Psbt instance.
 */ var $7ef4ee67e9f293e1$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $255d167d6a85e1f2$exports.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ var $7ef4ee67e9f293e1$var$Psbt = /*#__PURE__*/ function() {
    "use strict";
    function Psbt() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $27f0a5038233d038$exports.Psbt(new $7ef4ee67e9f293e1$var$PsbtTransaction());
        (0, $7dKN1._)(this, Psbt);
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $7ef4ee67e9f293e1$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Old TransactionBuilder behavior was to not confirm input values
            // before signing. Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        var dpew = function(obj, attr, enumerable, writable) {
            return Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        };
        dpew(this, "__CACHE", false, true);
        dpew(this, "opts", false, true);
    }
    (0, $eW5pA._)(Psbt, [
        {
            key: "inputCount",
            get: function get() {
                return this.data.inputs.length;
            }
        },
        {
            key: "version",
            get: function get() {
                return this.__CACHE.__TX.version;
            },
            set: function set(version) {
                this.setVersion(version);
            }
        },
        {
            key: "locktime",
            get: function get() {
                return this.__CACHE.__TX.locktime;
            },
            set: function set(locktime) {
                this.setLocktime(locktime);
            }
        },
        {
            key: "txInputs",
            get: function get() {
                return this.__CACHE.__TX.ins.map(function(input) {
                    return {
                        hash: $4f1d1f810d91b53b$exports.cloneBuffer(input.hash),
                        index: input.index,
                        sequence: input.sequence
                    };
                });
            }
        },
        {
            key: "txOutputs",
            get: function get() {
                var _this = this;
                return this.__CACHE.__TX.outs.map(function(output) {
                    var address;
                    try {
                        address = $52c2d07c5f3c77af$exports.fromOutputScript(output.script, _this.opts.network);
                    } catch (_) {}
                    return {
                        script: $4f1d1f810d91b53b$exports.cloneBuffer(output.script),
                        value: output.value,
                        address: address
                    };
                });
            }
        },
        {
            key: "combine",
            value: function combine() {
                for(var _len = arguments.length, those = new Array(_len), _key = 0; _key < _len; _key++){
                    those[_key] = arguments[_key];
                }
                var _this_data;
                (_this_data = this.data).combine.apply(_this_data, (0, $gF0bR._)(those.map(function(o) {
                    return o.data;
                })));
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                // TODO: more efficient cloning
                var res = Psbt.fromBuffer(this.data.toBuffer());
                res.opts = JSON.parse(JSON.stringify(this.opts));
                return res;
            }
        },
        {
            key: "setMaximumFeeRate",
            value: function setMaximumFeeRate(satoshiPerByte) {
                $7ef4ee67e9f293e1$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
                this.opts.maximumFeeRate = satoshiPerByte;
            }
        },
        {
            key: "setVersion",
            value: function setVersion(version) {
                $7ef4ee67e9f293e1$var$check32Bit(version);
                $7ef4ee67e9f293e1$var$checkInputsForPartialSig(this.data.inputs, "setVersion");
                var c = this.__CACHE;
                c.__TX.version = version;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "setLocktime",
            value: function setLocktime(locktime) {
                $7ef4ee67e9f293e1$var$check32Bit(locktime);
                $7ef4ee67e9f293e1$var$checkInputsForPartialSig(this.data.inputs, "setLocktime");
                var c = this.__CACHE;
                c.__TX.locktime = locktime;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "setInputSequence",
            value: function setInputSequence(inputIndex, sequence) {
                $7ef4ee67e9f293e1$var$check32Bit(sequence);
                $7ef4ee67e9f293e1$var$checkInputsForPartialSig(this.data.inputs, "setInputSequence");
                var c = this.__CACHE;
                if (c.__TX.ins.length <= inputIndex) throw new Error("Input index too high");
                c.__TX.ins[inputIndex].sequence = sequence;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "addInputs",
            value: function addInputs(inputDatas) {
                var _this = this;
                inputDatas.forEach(function(inputData) {
                    return _this.addInput(inputData);
                });
                return this;
            }
        },
        {
            key: "addInput",
            value: function addInput(inputData) {
                if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error("Invalid arguments for Psbt.addInput. " + "Requires single object with at least [hash] and [index]");
                $7ef4ee67e9f293e1$var$checkInputsForPartialSig(this.data.inputs, "addInput");
                if (inputData.witnessScript) $7ef4ee67e9f293e1$var$checkInvalidP2WSH(inputData.witnessScript);
                var c = this.__CACHE;
                this.data.addInput(inputData);
                var txIn = c.__TX.ins[c.__TX.ins.length - 1];
                $7ef4ee67e9f293e1$var$checkTxInputCache(c, txIn);
                var inputIndex = this.data.inputs.length - 1;
                var input = this.data.inputs[inputIndex];
                if (input.nonWitnessUtxo) $7ef4ee67e9f293e1$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
                c.__FEE = undefined;
                c.__FEE_RATE = undefined;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "addOutputs",
            value: function addOutputs(outputDatas) {
                var _this = this;
                outputDatas.forEach(function(outputData) {
                    return _this.addOutput(outputData);
                });
                return this;
            }
        },
        {
            key: "addOutput",
            value: function addOutput(outputData) {
                if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error("Invalid arguments for Psbt.addOutput. " + "Requires single object with at least [script or address] and [value]");
                $7ef4ee67e9f293e1$var$checkInputsForPartialSig(this.data.inputs, "addOutput");
                var address = outputData.address;
                if (typeof address === "string") {
                    var network = this.opts.network;
                    var script = $52c2d07c5f3c77af$exports.toOutputScript(address, network);
                    outputData = Object.assign(outputData, {
                        script: script
                    });
                }
                var c = this.__CACHE;
                this.data.addOutput(outputData);
                c.__FEE = undefined;
                c.__FEE_RATE = undefined;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "extractTransaction",
            value: function extractTransaction(disableFeeCheck) {
                if (!this.data.inputs.every($7ef4ee67e9f293e1$var$isFinalized)) throw new Error("Not finalized");
                var c = this.__CACHE;
                if (!disableFeeCheck) $7ef4ee67e9f293e1$var$checkFees(this, c, this.opts);
                if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
                var tx = c.__TX.clone();
                $7ef4ee67e9f293e1$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
                return tx;
            }
        },
        {
            key: "getFeeRate",
            value: function getFeeRate() {
                return $7ef4ee67e9f293e1$var$getTxCacheValue("__FEE_RATE", "fee rate", this.data.inputs, this.__CACHE);
            }
        },
        {
            key: "getFee",
            value: function getFee() {
                return $7ef4ee67e9f293e1$var$getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
            }
        },
        {
            key: "finalizeAllInputs",
            value: function finalizeAllInputs() {
                var _this = this;
                $2afa9fa2748275c6$exports.checkForInput(this.data.inputs, 0); // making sure we have at least one
                $7ef4ee67e9f293e1$var$range(this.data.inputs.length).forEach(function(idx) {
                    return _this.finalizeInput(idx);
                });
                return this;
            }
        },
        {
            key: "finalizeInput",
            value: function finalizeInput(inputIndex) {
                var finalScriptsFunc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7ef4ee67e9f293e1$var$getFinalScripts;
                var input = $2afa9fa2748275c6$exports.checkForInput(this.data.inputs, inputIndex);
                var _getScriptFromInput = $7ef4ee67e9f293e1$var$getScriptFromInput(inputIndex, input, this.__CACHE), script = _getScriptFromInput.script, isP2SH = _getScriptFromInput.isP2SH, isP2WSH = _getScriptFromInput.isP2WSH, isSegwit = _getScriptFromInput.isSegwit;
                if (!script) throw new Error("No script found for input #".concat(inputIndex));
                $7ef4ee67e9f293e1$var$checkPartialSigSighashes(input);
                var _finalScriptsFunc = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH), finalScriptSig = _finalScriptsFunc.finalScriptSig, finalScriptWitness = _finalScriptsFunc.finalScriptWitness;
                if (finalScriptSig) this.data.updateInput(inputIndex, {
                    finalScriptSig: finalScriptSig
                });
                if (finalScriptWitness) this.data.updateInput(inputIndex, {
                    finalScriptWitness: finalScriptWitness
                });
                if (!finalScriptSig && !finalScriptWitness) throw new Error("Unknown error finalizing input #".concat(inputIndex));
                this.data.clearFinalizedInput(inputIndex);
                return this;
            }
        },
        {
            key: "getInputType",
            value: function getInputType(inputIndex) {
                var input = $2afa9fa2748275c6$exports.checkForInput(this.data.inputs, inputIndex);
                var script = $7ef4ee67e9f293e1$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
                var result = $7ef4ee67e9f293e1$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript || $7ef4ee67e9f293e1$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $7ef4ee67e9f293e1$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
                var type = result.type === "raw" ? "" : result.type + "-";
                var mainType = $7ef4ee67e9f293e1$var$classifyScript(result.meaningfulScript);
                return type + mainType;
            }
        },
        {
            key: "inputHasPubkey",
            value: function inputHasPubkey(inputIndex, pubkey) {
                var input = $2afa9fa2748275c6$exports.checkForInput(this.data.inputs, inputIndex);
                return $7ef4ee67e9f293e1$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
            }
        },
        {
            key: "inputHasHDKey",
            value: function inputHasHDKey(inputIndex, root) {
                var input = $2afa9fa2748275c6$exports.checkForInput(this.data.inputs, inputIndex);
                var derivationIsMine = $7ef4ee67e9f293e1$var$bip32DerivationIsMine(root);
                return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
            }
        },
        {
            key: "outputHasPubkey",
            value: function outputHasPubkey(outputIndex, pubkey) {
                var output = $2afa9fa2748275c6$exports.checkForOutput(this.data.outputs, outputIndex);
                return $7ef4ee67e9f293e1$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
            }
        },
        {
            key: "outputHasHDKey",
            value: function outputHasHDKey(outputIndex, root) {
                var output = $2afa9fa2748275c6$exports.checkForOutput(this.data.outputs, outputIndex);
                var derivationIsMine = $7ef4ee67e9f293e1$var$bip32DerivationIsMine(root);
                return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
            }
        },
        {
            key: "validateSignaturesOfAllInputs",
            value: function validateSignaturesOfAllInputs() {
                var _this = this;
                $2afa9fa2748275c6$exports.checkForInput(this.data.inputs, 0); // making sure we have at least one
                var results = $7ef4ee67e9f293e1$var$range(this.data.inputs.length).map(function(idx) {
                    return _this.validateSignaturesOfInput(idx);
                });
                return results.reduce(function(final, res) {
                    return res === true && final;
                }, true);
            }
        },
        {
            key: "validateSignaturesOfInput",
            value: function validateSignaturesOfInput(inputIndex, pubkey) {
                var input = this.data.inputs[inputIndex];
                var partialSig = (input || {}).partialSig;
                if (!input || !partialSig || partialSig.length < 1) throw new Error("No signatures to validate");
                var mySigs = pubkey ? partialSig.filter(function(sig) {
                    return sig.pubkey.equals(pubkey);
                }) : partialSig;
                if (mySigs.length < 1) throw new Error("No signatures for this pubkey");
                var results = [];
                var hashCache;
                var scriptCache;
                var sighashCache;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mySigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pSig = _step.value;
                        var sig = $120fce5ded7fb153$exports.signature.decode(pSig.signature);
                        var _ref = sighashCache !== sig.hashType ? $7ef4ee67e9f293e1$var$getHashForSig(inputIndex, Object.assign({}, input, {
                            sighashType: sig.hashType
                        }), this.__CACHE, true) : {
                            hash: hashCache,
                            script: scriptCache
                        }, hash = _ref.hash, script = _ref.script;
                        sighashCache = sig.hashType;
                        hashCache = hash;
                        scriptCache = script;
                        $7ef4ee67e9f293e1$var$checkScriptForPubkey(pSig.pubkey, script, "verify");
                        var keypair = $d25f5aec1142ce7b$exports.fromPublicKey(pSig.pubkey);
                        results.push(keypair.verify(hash, sig.signature));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return results.every(function(res) {
                    return res === true;
                });
            }
        },
        {
            key: "signAllInputsHD",
            value: function signAllInputsHD(hdKeyPair) {
                var sighashTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
                var results = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $7ef4ee67e9f293e1$var$range(this.data.inputs.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        try {
                            this.signInputHD(i, hdKeyPair, sighashTypes);
                            results.push(true);
                        } catch (err) {
                            results.push(false);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (results.every(function(v) {
                    return v === false;
                })) throw new Error("No inputs were signed");
                return this;
            }
        },
        {
            key: "signAllInputsHDAsync",
            value: function signAllInputsHDAsync(hdKeyPair) {
                var sighashTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
                    var results = [];
                    var promises = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = $7ef4ee67e9f293e1$var$range(_this.data.inputs.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            promises.push(_this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(function() {
                                results.push(true);
                            }, function() {
                                results.push(false);
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return Promise.all(promises).then(function() {
                        if (results.every(function(v) {
                            return v === false;
                        })) return reject(new Error("No inputs were signed"));
                        resolve();
                    });
                });
            }
        },
        {
            key: "signInputHD",
            value: function signInputHD(inputIndex, hdKeyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
                var signers = $7ef4ee67e9f293e1$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
                signers.forEach(function(signer) {
                    return _this.signInput(inputIndex, signer, sighashTypes);
                });
                return this;
            }
        },
        {
            key: "signInputHDAsync",
            value: function signInputHDAsync(inputIndex, hdKeyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
                    var signers = $7ef4ee67e9f293e1$var$getSignersFromHD(inputIndex, _this.data.inputs, hdKeyPair);
                    var promises = signers.map(function(signer) {
                        return _this.signInputAsync(inputIndex, signer, sighashTypes);
                    });
                    return Promise.all(promises).then(function() {
                        resolve();
                    }).catch(reject);
                });
            }
        },
        {
            key: "signAllInputs",
            value: function signAllInputs(keyPair) {
                var sighashTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                // TODO: Add a pubkey/pubkeyhash cache to each input
                // as input information is added, then eventually
                // optimize this method.
                var results = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $7ef4ee67e9f293e1$var$range(this.data.inputs.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        try {
                            this.signInput(i, keyPair, sighashTypes);
                            results.push(true);
                        } catch (err) {
                            results.push(false);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (results.every(function(v) {
                    return v === false;
                })) throw new Error("No inputs were signed");
                return this;
            }
        },
        {
            key: "signAllInputsAsync",
            value: function signAllInputsAsync(keyPair) {
                var sighashTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!keyPair || !keyPair.publicKey) return reject(new Error("Need Signer to sign input"));
                    // TODO: Add a pubkey/pubkeyhash cache to each input
                    // as input information is added, then eventually
                    // optimize this method.
                    var results = [];
                    var promises = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.data.inputs.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $5OlIx._)(_step.value, 1), i = _step_value[0];
                            promises.push(_this.signInputAsync(i, keyPair, sighashTypes).then(function() {
                                results.push(true);
                            }, function() {
                                results.push(false);
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return Promise.all(promises).then(function() {
                        if (results.every(function(v) {
                            return v === false;
                        })) return reject(new Error("No inputs were signed"));
                        resolve();
                    });
                });
            }
        },
        {
            key: "signInput",
            value: function signInput(inputIndex, keyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                var _getHashAndSighashType = $7ef4ee67e9f293e1$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes), hash = _getHashAndSighashType.hash, sighashType = _getHashAndSighashType.sighashType;
                var partialSig = [
                    {
                        pubkey: keyPair.publicKey,
                        signature: $120fce5ded7fb153$exports.signature.encode(keyPair.sign(hash), sighashType)
                    }
                ];
                this.data.updateInput(inputIndex, {
                    partialSig: partialSig
                });
                return this;
            }
        },
        {
            key: "signInputAsync",
            value: function signInputAsync(inputIndex, keyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                return Promise.resolve().then(function() {
                    if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                    var _getHashAndSighashType = $7ef4ee67e9f293e1$var$getHashAndSighashType(_this.data.inputs, inputIndex, keyPair.publicKey, _this.__CACHE, sighashTypes), hash = _getHashAndSighashType.hash, sighashType = _getHashAndSighashType.sighashType;
                    return Promise.resolve(keyPair.sign(hash)).then(function(signature) {
                        var partialSig = [
                            {
                                pubkey: keyPair.publicKey,
                                signature: $120fce5ded7fb153$exports.signature.encode(signature, sighashType)
                            }
                        ];
                        _this.data.updateInput(inputIndex, {
                            partialSig: partialSig
                        });
                    });
                });
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer() {
                $7ef4ee67e9f293e1$var$checkCache(this.__CACHE);
                return this.data.toBuffer();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                $7ef4ee67e9f293e1$var$checkCache(this.__CACHE);
                return this.data.toHex();
            }
        },
        {
            key: "toBase64",
            value: function toBase64() {
                $7ef4ee67e9f293e1$var$checkCache(this.__CACHE);
                return this.data.toBase64();
            }
        },
        {
            key: "updateGlobal",
            value: function updateGlobal(updateData) {
                this.data.updateGlobal(updateData);
                return this;
            }
        },
        {
            key: "updateInput",
            value: function updateInput(inputIndex, updateData) {
                if (updateData.witnessScript) $7ef4ee67e9f293e1$var$checkInvalidP2WSH(updateData.witnessScript);
                this.data.updateInput(inputIndex, updateData);
                if (updateData.nonWitnessUtxo) $7ef4ee67e9f293e1$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
                return this;
            }
        },
        {
            key: "updateOutput",
            value: function updateOutput(outputIndex, updateData) {
                this.data.updateOutput(outputIndex, updateData);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToGlobal",
            value: function addUnknownKeyValToGlobal(keyVal) {
                this.data.addUnknownKeyValToGlobal(keyVal);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToInput",
            value: function addUnknownKeyValToInput(inputIndex, keyVal) {
                this.data.addUnknownKeyValToInput(inputIndex, keyVal);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToOutput",
            value: function addUnknownKeyValToOutput(outputIndex, keyVal) {
                this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
                return this;
            }
        },
        {
            key: "clearFinalizedInput",
            value: function clearFinalizedInput(inputIndex) {
                this.data.clearFinalizedInput(inputIndex);
                return this;
            }
        }
    ], [
        {
            key: "fromBase64",
            value: function fromBase64(data) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var buffer = $7ef4ee67e9f293e1$require$Buffer.from(data, "base64");
                return this.fromBuffer(buffer, opts);
            }
        },
        {
            key: "fromHex",
            value: function fromHex(data) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var buffer = $7ef4ee67e9f293e1$require$Buffer.from(data, "hex");
                return this.fromBuffer(buffer, opts);
            }
        },
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var psbtBase = $27f0a5038233d038$exports.Psbt.fromBuffer(buffer, $7ef4ee67e9f293e1$var$transactionFromBuffer);
                var psbt = new Psbt(opts, psbtBase);
                $7ef4ee67e9f293e1$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
                return psbt;
            }
        }
    ]);
    return Psbt;
}();
$7ef4ee67e9f293e1$exports.Psbt = $7ef4ee67e9f293e1$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ var $7ef4ee67e9f293e1$var$transactionFromBuffer = function(buffer) {
    return new $7ef4ee67e9f293e1$var$PsbtTransaction(buffer);
};
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ var $7ef4ee67e9f293e1$var$PsbtTransaction = /*#__PURE__*/ function() {
    "use strict";
    function PsbtTransaction() {
        var buffer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $7ef4ee67e9f293e1$require$Buffer.from([
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        (0, $7dKN1._)(this, PsbtTransaction);
        this.tx = $55e09fe174fff4e9$exports.Transaction.fromBuffer(buffer);
        $7ef4ee67e9f293e1$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, "tx", {
            enumerable: false,
            writable: true
        });
    }
    (0, $eW5pA._)(PsbtTransaction, [
        {
            key: "getInputOutputCounts",
            value: function getInputOutputCounts() {
                return {
                    inputCount: this.tx.ins.length,
                    outputCount: this.tx.outs.length
                };
            }
        },
        {
            key: "addInput",
            value: function addInput(input) {
                if (input.hash === undefined || input.index === undefined || !$7ef4ee67e9f293e1$require$Buffer.isBuffer(input.hash) && typeof input.hash !== "string" || typeof input.index !== "number") throw new Error("Error adding input.");
                var hash = typeof input.hash === "string" ? $4f1d1f810d91b53b$exports.reverseBuffer($7ef4ee67e9f293e1$require$Buffer.from(input.hash, "hex")) : input.hash;
                this.tx.addInput(hash, input.index, input.sequence);
            }
        },
        {
            key: "addOutput",
            value: function addOutput(output) {
                if (output.script === undefined || output.value === undefined || !$7ef4ee67e9f293e1$require$Buffer.isBuffer(output.script) || typeof output.value !== "number") throw new Error("Error adding output.");
                this.tx.addOutput(output.script, output.value);
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer() {
                return this.tx.toBuffer();
            }
        }
    ]);
    return PsbtTransaction;
}();
function $7ef4ee67e9f293e1$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case "pubkey":
        case "pubkeyhash":
        case "witnesspubkeyhash":
            return $7ef4ee67e9f293e1$var$hasSigs(1, input.partialSig);
        case "multisig":
            var p2ms = $8a09fb4c2f496869$exports.p2ms({
                output: script
            });
            return $7ef4ee67e9f293e1$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $7ef4ee67e9f293e1$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error("Not BIP174 compliant, can not export");
}
function $7ef4ee67e9f293e1$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    var sigs;
    if (pubkeys) sigs = pubkeys.map(function(pkey) {
        var pubkey = $d25f5aec1142ce7b$exports.fromPublicKey(pkey, {
            compressed: true
        }).publicKey;
        return partialSig.find(function(pSig) {
            return pSig.pubkey.equals(pubkey);
        });
    }).filter(function(v) {
        return !!v;
    });
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error("Too many signatures");
    return sigs.length === neededSigs;
}
function $7ef4ee67e9f293e1$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $7ef4ee67e9f293e1$var$isPaymentFactory(payment) {
    return function(script) {
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
var $7ef4ee67e9f293e1$var$isP2MS = $7ef4ee67e9f293e1$var$isPaymentFactory($8a09fb4c2f496869$exports.p2ms);
var $7ef4ee67e9f293e1$var$isP2PK = $7ef4ee67e9f293e1$var$isPaymentFactory($8a09fb4c2f496869$exports.p2pk);
var $7ef4ee67e9f293e1$var$isP2PKH = $7ef4ee67e9f293e1$var$isPaymentFactory($8a09fb4c2f496869$exports.p2pkh);
var $7ef4ee67e9f293e1$var$isP2WPKH = $7ef4ee67e9f293e1$var$isPaymentFactory($8a09fb4c2f496869$exports.p2wpkh);
var $7ef4ee67e9f293e1$var$isP2WSHScript = $7ef4ee67e9f293e1$var$isPaymentFactory($8a09fb4c2f496869$exports.p2wsh);
var $7ef4ee67e9f293e1$var$isP2SHScript = $7ef4ee67e9f293e1$var$isPaymentFactory($8a09fb4c2f496869$exports.p2sh);
function $7ef4ee67e9f293e1$var$bip32DerivationIsMine(root) {
    return function(d) {
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $7ef4ee67e9f293e1$var$check32Bit(num) {
    if (typeof num !== "number" || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error("Invalid 32 bit integer");
}
function $7ef4ee67e9f293e1$var$checkFees(psbt, cache, opts) {
    var feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    var vsize = cache.__EXTRACTED_TX.virtualSize();
    var satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error("Warning: You are paying around ".concat((satoshis / 1e8).toFixed(8), " in ") + "fees, which is ".concat(feeRate, " satoshi per byte for a transaction ") + "with a VSize of ".concat(vsize, " bytes (segwit counted as 0.25 byte per ") + "byte). Use setMaximumFeeRate method to raise your threshold, or " + "pass true to the first arg of extractTransaction.");
}
function $7ef4ee67e9f293e1$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach(function(input) {
        var throws = false;
        var pSigs = [];
        if ((input.partialSig || []).length === 0) {
            if (!input.finalScriptSig && !input.finalScriptWitness) return;
            pSigs = $7ef4ee67e9f293e1$var$getPsigsFromInputFinalScripts(input);
        } else pSigs = input.partialSig;
        pSigs.forEach(function(pSig) {
            var hashType = $120fce5ded7fb153$exports.signature.decode(pSig.signature).hashType;
            var whitelist = [];
            var isAnyoneCanPay = hashType & $55e09fe174fff4e9$exports.Transaction.SIGHASH_ANYONECANPAY;
            if (isAnyoneCanPay) whitelist.push("addInput");
            var hashMod = hashType & 0x1f;
            switch(hashMod){
                case $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL:
                    break;
                case $55e09fe174fff4e9$exports.Transaction.SIGHASH_SINGLE:
                case $55e09fe174fff4e9$exports.Transaction.SIGHASH_NONE:
                    whitelist.push("addOutput");
                    whitelist.push("setInputSequence");
                    break;
            }
            if (whitelist.indexOf(action) === -1) throws = true;
        });
        if (throws) throw new Error("Can not modify transaction, signatures exist.");
    });
}
function $7ef4ee67e9f293e1$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    var partialSig = input.partialSig, sighashType = input.sighashType;
    partialSig.forEach(function(pSig) {
        var hashType = $120fce5ded7fb153$exports.signature.decode(pSig.signature).hashType;
        if (sighashType !== hashType) throw new Error("Signature sighash does not match input sighash type");
    });
}
function $7ef4ee67e9f293e1$var$checkScriptForPubkey(pubkey, script, action) {
    if (!$7ef4ee67e9f293e1$var$pubkeyInScript(pubkey, script)) throw new Error("Can not ".concat(action, " for this input with the key ").concat(pubkey.toString("hex")));
}
function $7ef4ee67e9f293e1$var$checkTxEmpty(tx) {
    var isEmpty = tx.ins.every(function(input) {
        return input.script && input.script.length === 0 && input.witness && input.witness.length === 0;
    });
    if (!isEmpty) throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function $7ef4ee67e9f293e1$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach(function(input) {
        $7ef4ee67e9f293e1$var$checkTxInputCache(cache, input);
    });
}
function $7ef4ee67e9f293e1$var$checkTxInputCache(cache, input) {
    var key = $4f1d1f810d91b53b$exports.reverseBuffer($7ef4ee67e9f293e1$require$Buffer.from(input.hash)).toString("hex") + ":" + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error("Duplicate input detected.");
    cache.__TX_IN_CACHE[key] = 1;
}
function $7ef4ee67e9f293e1$var$scriptCheckerFactory(payment, paymentScriptName) {
    return function(inputIndex, scriptPubKey, redeemScript, ioType) {
        var redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error("".concat(paymentScriptName, " for ").concat(ioType, " #").concat(inputIndex, " doesn't match the scriptPubKey in the prevout"));
    };
}
var $7ef4ee67e9f293e1$var$checkRedeemScript = $7ef4ee67e9f293e1$var$scriptCheckerFactory($8a09fb4c2f496869$exports.p2sh, "Redeem script");
var $7ef4ee67e9f293e1$var$checkWitnessScript = $7ef4ee67e9f293e1$var$scriptCheckerFactory($8a09fb4c2f496869$exports.p2wsh, "Witness script");
function $7ef4ee67e9f293e1$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($7ef4ee67e9f293e1$var$isFinalized)) throw new Error("PSBT must be finalized to calculate ".concat(name));
    if (key === "__FEE_RATE" && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === "__FEE" && c.__FEE) return c.__FEE;
    var tx;
    var mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $7ef4ee67e9f293e1$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === "__FEE_RATE") return c.__FEE_RATE;
    else if (key === "__FEE") return c.__FEE;
}
function $7ef4ee67e9f293e1$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    var scriptType = $7ef4ee67e9f293e1$var$classifyScript(script);
    if (!$7ef4ee67e9f293e1$var$canFinalize(input, script, scriptType)) throw new Error("Can not finalize input #".concat(inputIndex));
    return $7ef4ee67e9f293e1$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $7ef4ee67e9f293e1$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    var finalScriptSig;
    var finalScriptWitness;
    // Wow, the payments API is very handy
    var payment = $7ef4ee67e9f293e1$var$getPayment(script, scriptType, partialSig);
    var p2wsh = !isP2WSH ? null : $8a09fb4c2f496869$exports.p2wsh({
        redeem: payment
    });
    var p2sh = !isP2SH ? null : $8a09fb4c2f496869$exports.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = $7ef4ee67e9f293e1$var$witnessStackToScriptWitness(p2wsh.witness);
        else finalScriptWitness = $7ef4ee67e9f293e1$var$witnessStackToScriptWitness(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $7ef4ee67e9f293e1$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    var input = $2afa9fa2748275c6$exports.checkForInput(inputs, inputIndex);
    var _getHashForSig = $7ef4ee67e9f293e1$var$getHashForSig(inputIndex, input, cache, false, sighashTypes), hash = _getHashForSig.hash, sighashType = _getHashForSig.sighashType, script = _getHashForSig.script;
    $7ef4ee67e9f293e1$var$checkScriptForPubkey(pubkey, script, "sign");
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $7ef4ee67e9f293e1$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    var unsignedTx = cache.__TX;
    var sighashType = input.sighashType || $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL;
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        var str = $7ef4ee67e9f293e1$var$sighashTypeToString(sighashType);
        throw new Error("Sighash type is not allowed. Retry the sign method passing the " + "sighashTypes array of whitelisted types. Sighash type: ".concat(str));
    }
    var hash;
    var prevout;
    if (input.nonWitnessUtxo) {
        var nonWitnessUtxoTx = $7ef4ee67e9f293e1$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        var prevoutHash = unsignedTx.ins[inputIndex].hash;
        var utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error("Non-witness UTXO hash for input #".concat(inputIndex, " doesn't match the hash specified in the prevout"));
        var prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error("Need a Utxo input item for signing");
    var _getMeaningfulScript = $7ef4ee67e9f293e1$var$getMeaningfulScript(prevout.script, inputIndex, "input", input.redeemScript, input.witnessScript), meaningfulScript = _getMeaningfulScript.meaningfulScript, type = _getMeaningfulScript.type;
    if ([
        "p2sh-p2wsh",
        "p2wsh"
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ($7ef4ee67e9f293e1$var$isP2WPKH(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        var signingScript = $8a09fb4c2f496869$exports.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error("Input #".concat(inputIndex, " has witnessUtxo but non-segwit script: ") + "".concat(meaningfulScript.toString("hex")));
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as the old TransactionBuilder class when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $7ef4ee67e9f293e1$var$getPayment(script, scriptType, partialSig) {
    var payment;
    switch(scriptType){
        case "multisig":
            var sigs = $7ef4ee67e9f293e1$var$getSortedSigs(script, partialSig);
            payment = $8a09fb4c2f496869$exports.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case "pubkey":
            payment = $8a09fb4c2f496869$exports.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case "pubkeyhash":
            payment = $8a09fb4c2f496869$exports.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case "witnesspubkeyhash":
            payment = $8a09fb4c2f496869$exports.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $7ef4ee67e9f293e1$var$getPsigsFromInputFinalScripts(input) {
    var scriptItems = !input.finalScriptSig ? [] : $120fce5ded7fb153$exports.decompile(input.finalScriptSig) || [];
    var witnessItems = !input.finalScriptWitness ? [] : $120fce5ded7fb153$exports.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter(function(item) {
        return $7ef4ee67e9f293e1$require$Buffer.isBuffer(item) && $120fce5ded7fb153$exports.isCanonicalScriptSignature(item);
    }).map(function(sig) {
        return {
            signature: sig
        };
    });
}
function $7ef4ee67e9f293e1$var$getScriptFromInput(inputIndex, input, cache) {
    var unsignedTx = cache.__TX;
    var res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            var nonWitnessUtxoTx = $7ef4ee67e9f293e1$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            var prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || $7ef4ee67e9f293e1$var$isP2WPKH(res.script)) res.isSegwit = true;
    return res;
}
function $7ef4ee67e9f293e1$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    var input = $2afa9fa2748275c6$exports.checkForInput(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error("Need bip32Derivation to sign with HD");
    var myDerivations = input.bip32Derivation.map(function(bipDv) {
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter(function(v) {
        return !!v;
    });
    if (myDerivations.length === 0) throw new Error("Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint");
    var signers = myDerivations.map(function(bipDv) {
        var node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error("pubkey did not match bip32Derivation");
        return node;
    });
    return signers;
}
function $7ef4ee67e9f293e1$var$getSortedSigs(script, partialSig) {
    var p2ms = $8a09fb4c2f496869$exports.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map(function(pk) {
        // filter partialSig array by pubkey being equal
        return (partialSig.filter(function(ps) {
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter(function(v) {
        return !!v;
    });
}
function $7ef4ee67e9f293e1$var$scriptWitnessToWitnessStack(buffer) {
    var offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        var vi = $d1BPf.decode(buffer, offset);
        offset += $d1BPf.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        var count = readVarInt();
        var vector = [];
        for(var i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $7ef4ee67e9f293e1$var$sighashTypeToString(sighashType) {
    var text = sighashType & $55e09fe174fff4e9$exports.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    var sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL:
            text += "SIGHASH_ALL";
            break;
        case $55e09fe174fff4e9$exports.Transaction.SIGHASH_SINGLE:
            text += "SIGHASH_SINGLE";
            break;
        case $55e09fe174fff4e9$exports.Transaction.SIGHASH_NONE:
            text += "SIGHASH_NONE";
            break;
    }
    return text;
}
function $7ef4ee67e9f293e1$var$witnessStackToScriptWitness(witness) {
    var buffer = $7ef4ee67e9f293e1$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $7ef4ee67e9f293e1$require$Buffer.concat([
            buffer,
            $7ef4ee67e9f293e1$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        var currentLen = buffer.length;
        var varintLen = $d1BPf.encodingLength(i);
        buffer = $7ef4ee67e9f293e1$require$Buffer.concat([
            buffer,
            $7ef4ee67e9f293e1$require$Buffer.allocUnsafe(varintLen)
        ]);
        $d1BPf.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
function $7ef4ee67e9f293e1$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    var tx = $55e09fe174fff4e9$exports.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    var self = cache;
    var selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, "nonWitnessUtxo", {
        enumerable: true,
        get: function() {
            var buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            var txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                var newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set: function(data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $7ef4ee67e9f293e1$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    var inputAmount = 0;
    inputs.forEach(function(input, idx) {
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $7ef4ee67e9f293e1$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            var nwTx = $7ef4ee67e9f293e1$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            var vout = tx.ins[idx].index;
            var out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    var outputAmount = tx.outs.reduce(function(total, o) {
        return total + o.value;
    }, 0);
    var fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error("Outputs are spending more than Inputs");
    var bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $7ef4ee67e9f293e1$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    var c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $7ef4ee67e9f293e1$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $7ef4ee67e9f293e1$var$getScriptFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return input.witnessUtxo.script;
    else if (input.nonWitnessUtxo !== undefined) {
        var nonWitnessUtxoTx = $7ef4ee67e9f293e1$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        return nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index].script;
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $7ef4ee67e9f293e1$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    var script = $7ef4ee67e9f293e1$var$getScriptFromUtxo(inputIndex, input, cache);
    var meaningfulScript = $7ef4ee67e9f293e1$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript, input.witnessScript).meaningfulScript;
    return $7ef4ee67e9f293e1$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $7ef4ee67e9f293e1$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    var script = cache.__TX.outs[outputIndex].script;
    var meaningfulScript = $7ef4ee67e9f293e1$var$getMeaningfulScript(script, outputIndex, "output", output.redeemScript, output.witnessScript).meaningfulScript;
    return $7ef4ee67e9f293e1$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $7ef4ee67e9f293e1$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    var decomp = $120fce5ded7fb153$exports.decompile(finalScript);
    if (!decomp) return;
    var lastItem = decomp[decomp.length - 1];
    if (!$7ef4ee67e9f293e1$require$Buffer.isBuffer(lastItem) || $7ef4ee67e9f293e1$var$isPubkeyLike(lastItem) || $7ef4ee67e9f293e1$var$isSigLike(lastItem)) return;
    var sDecomp = $120fce5ded7fb153$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $7ef4ee67e9f293e1$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    var decomp = $7ef4ee67e9f293e1$var$scriptWitnessToWitnessStack(finalScript);
    var lastItem = decomp[decomp.length - 1];
    if ($7ef4ee67e9f293e1$var$isPubkeyLike(lastItem)) return;
    var sDecomp = $120fce5ded7fb153$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $7ef4ee67e9f293e1$var$isPubkeyLike(buf) {
    return buf.length === 33 && $120fce5ded7fb153$exports.isCanonicalPubKey(buf);
}
function $7ef4ee67e9f293e1$var$isSigLike(buf) {
    return $120fce5ded7fb153$exports.isCanonicalScriptSignature(buf);
}
function $7ef4ee67e9f293e1$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    var isP2SH = $7ef4ee67e9f293e1$var$isP2SHScript(script);
    var isP2SHP2WSH = isP2SH && redeemScript && $7ef4ee67e9f293e1$var$isP2WSHScript(redeemScript);
    var isP2WSH = $7ef4ee67e9f293e1$var$isP2WSHScript(script);
    if (isP2SH && redeemScript === undefined) throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error("scriptPubkey or redeemScript is P2WSH but witnessScript missing");
    var meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $7ef4ee67e9f293e1$var$checkRedeemScript(index, script, redeemScript, ioType);
        $7ef4ee67e9f293e1$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $7ef4ee67e9f293e1$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $7ef4ee67e9f293e1$var$checkWitnessScript(index, script, witnessScript, ioType);
        $7ef4ee67e9f293e1$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $7ef4ee67e9f293e1$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? "p2sh-p2wsh" : isP2SH ? "p2sh" : isP2WSH ? "p2wsh" : "raw"
    };
}
function $7ef4ee67e9f293e1$var$checkInvalidP2WSH(script) {
    if ($7ef4ee67e9f293e1$var$isP2WPKH(script) || $7ef4ee67e9f293e1$var$isP2SHScript(script)) throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function $7ef4ee67e9f293e1$var$pubkeyInScript(pubkey, script) {
    var pubkeyHash = $0f478b5636513f95$exports.hash160(pubkey);
    var decompiled = $120fce5ded7fb153$exports.decompile(script);
    if (decompiled === null) throw new Error("Unknown script error");
    return decompiled.some(function(element) {
        if (typeof element === "number") return false;
        return element.equals(pubkey) || element.equals(pubkeyHash);
    });
}
function $7ef4ee67e9f293e1$var$classifyScript(script) {
    if ($7ef4ee67e9f293e1$var$isP2WPKH(script)) return "witnesspubkeyhash";
    if ($7ef4ee67e9f293e1$var$isP2PKH(script)) return "pubkeyhash";
    if ($7ef4ee67e9f293e1$var$isP2MS(script)) return "multisig";
    if ($7ef4ee67e9f293e1$var$isP2PK(script)) return "pubkey";
    return "nonstandard";
}
function $7ef4ee67e9f293e1$var$range(n) {
    return (0, $gF0bR._)(Array(n).keys());
}


$9ce982a108f9bffc$exports.Psbt = $7ef4ee67e9f293e1$exports.Psbt;

$9ce982a108f9bffc$exports.opcodes = $120fce5ded7fb153$exports.OPS;

$9ce982a108f9bffc$exports.Transaction = $55e09fe174fff4e9$exports.Transaction;
var $5c3050bf90afe92a$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");

var $ilnag = parcelRequire("ilnag");
var $5c3050bf90afe92a$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($5c3050bf90afe92a$exports, "__esModule", {
    value: true
});


var $a9d0110726ea614b$exports = {};
"use strict";
Object.defineProperty($a9d0110726ea614b$exports, "__esModule", {
    value: true
});

var $0a8a6d9c9eec534d$exports = {};
"use strict";
Object.defineProperty($0a8a6d9c9eec534d$exports, "__esModule", {
    value: true
});
var $9dbffc2eabc68142$exports = {};
"use strict";
// OP_0 [signatures ...]
Object.defineProperty($9dbffc2eabc68142$exports, "__esModule", {
    value: true
});


function $9dbffc2eabc68142$var$partialSignature(value) {
    return value === $120fce5ded7fb153$exports.OPS.OP_0 || $120fce5ded7fb153$exports.isCanonicalScriptSignature(value);
}
function $9dbffc2eabc68142$var$check(script, allowIncomplete) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    if (chunks.length < 2) return false;
    if (chunks[0] !== $120fce5ded7fb153$exports.OPS.OP_0) return false;
    if (allowIncomplete) return chunks.slice(1).every($9dbffc2eabc68142$var$partialSignature);
    return chunks.slice(1).every($120fce5ded7fb153$exports.isCanonicalScriptSignature);
}
$9dbffc2eabc68142$exports.check = $9dbffc2eabc68142$var$check;
$9dbffc2eabc68142$var$check.toJSON = function() {
    return "multisig input";
};


$0a8a6d9c9eec534d$exports.input = $9dbffc2eabc68142$exports;
var $2766dfb0ab6c4634$exports = {};
"use strict";
// m [pubKeys ...] n OP_CHECKMULTISIG
Object.defineProperty($2766dfb0ab6c4634$exports, "__esModule", {
    value: true
});



var $2766dfb0ab6c4634$var$OP_INT_BASE = $120fce5ded7fb153$exports.OPS.OP_RESERVED; // OP_1 - 1
function $2766dfb0ab6c4634$var$check(script, allowIncomplete) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    if (chunks.length < 4) return false;
    if (chunks[chunks.length - 1] !== $120fce5ded7fb153$exports.OPS.OP_CHECKMULTISIG) return false;
    if (!$8f74010e7554fd26$exports.Number(chunks[0])) return false;
    if (!$8f74010e7554fd26$exports.Number(chunks[chunks.length - 2])) return false;
    var m = chunks[0] - $2766dfb0ab6c4634$var$OP_INT_BASE;
    var n = chunks[chunks.length - 2] - $2766dfb0ab6c4634$var$OP_INT_BASE;
    if (m <= 0) return false;
    if (n > 16) return false;
    if (m > n) return false;
    if (n !== chunks.length - 3) return false;
    if (allowIncomplete) return true;
    var keys = chunks.slice(1, -2);
    return keys.every($120fce5ded7fb153$exports.isCanonicalPubKey);
}
$2766dfb0ab6c4634$exports.check = $2766dfb0ab6c4634$var$check;
$2766dfb0ab6c4634$var$check.toJSON = function() {
    return "multi-sig output";
};


$0a8a6d9c9eec534d$exports.output = $2766dfb0ab6c4634$exports;


var $30752427629d5db5$exports = {};
"use strict";
Object.defineProperty($30752427629d5db5$exports, "__esModule", {
    value: true
});

var $30752427629d5db5$var$OPS = $120fce5ded7fb153$exports.OPS;
function $30752427629d5db5$var$check(script) {
    var buffer = $120fce5ded7fb153$exports.compile(script);
    return buffer.length > 1 && buffer[0] === $30752427629d5db5$var$OPS.OP_RETURN;
}
$30752427629d5db5$exports.check = $30752427629d5db5$var$check;
$30752427629d5db5$var$check.toJSON = function() {
    return "null data output";
};
var $30752427629d5db5$var$output = {
    check: $30752427629d5db5$var$check
};
$30752427629d5db5$exports.output = $30752427629d5db5$var$output;


var $023ee51618c3589b$exports = {};
"use strict";
Object.defineProperty($023ee51618c3589b$exports, "__esModule", {
    value: true
});
var $bec55fb98f2572b9$exports = {};
"use strict";
// {signature}
Object.defineProperty($bec55fb98f2572b9$exports, "__esModule", {
    value: true
});

function $bec55fb98f2572b9$var$check(script) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    return chunks.length === 1 && $120fce5ded7fb153$exports.isCanonicalScriptSignature(chunks[0]);
}
$bec55fb98f2572b9$exports.check = $bec55fb98f2572b9$var$check;
$bec55fb98f2572b9$var$check.toJSON = function() {
    return "pubKey input";
};


$023ee51618c3589b$exports.input = $bec55fb98f2572b9$exports;
var $1cabef79e119cc98$exports = {};
"use strict";
// {pubKey} OP_CHECKSIG
Object.defineProperty($1cabef79e119cc98$exports, "__esModule", {
    value: true
});


function $1cabef79e119cc98$var$check(script) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    return chunks.length === 2 && $120fce5ded7fb153$exports.isCanonicalPubKey(chunks[0]) && chunks[1] === $120fce5ded7fb153$exports.OPS.OP_CHECKSIG;
}
$1cabef79e119cc98$exports.check = $1cabef79e119cc98$var$check;
$1cabef79e119cc98$var$check.toJSON = function() {
    return "pubKey output";
};


$023ee51618c3589b$exports.output = $1cabef79e119cc98$exports;


var $74076c87d216dc3b$exports = {};
"use strict";
Object.defineProperty($74076c87d216dc3b$exports, "__esModule", {
    value: true
});
var $d137b15373ecdc24$exports = {};
"use strict";
// {signature} {pubKey}
Object.defineProperty($d137b15373ecdc24$exports, "__esModule", {
    value: true
});

function $d137b15373ecdc24$var$check(script) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    return chunks.length === 2 && $120fce5ded7fb153$exports.isCanonicalScriptSignature(chunks[0]) && $120fce5ded7fb153$exports.isCanonicalPubKey(chunks[1]);
}
$d137b15373ecdc24$exports.check = $d137b15373ecdc24$var$check;
$d137b15373ecdc24$var$check.toJSON = function() {
    return "pubKeyHash input";
};


$74076c87d216dc3b$exports.input = $d137b15373ecdc24$exports;
var $ce3d9e3d85f43091$exports = {};
"use strict";
// OP_DUP OP_HASH160 {pubKeyHash} OP_EQUALVERIFY OP_CHECKSIG
Object.defineProperty($ce3d9e3d85f43091$exports, "__esModule", {
    value: true
});


function $ce3d9e3d85f43091$var$check(script) {
    var buffer = $120fce5ded7fb153$exports.compile(script);
    return buffer.length === 25 && buffer[0] === $120fce5ded7fb153$exports.OPS.OP_DUP && buffer[1] === $120fce5ded7fb153$exports.OPS.OP_HASH160 && buffer[2] === 0x14 && buffer[23] === $120fce5ded7fb153$exports.OPS.OP_EQUALVERIFY && buffer[24] === $120fce5ded7fb153$exports.OPS.OP_CHECKSIG;
}
$ce3d9e3d85f43091$exports.check = $ce3d9e3d85f43091$var$check;
$ce3d9e3d85f43091$var$check.toJSON = function() {
    return "pubKeyHash output";
};


$74076c87d216dc3b$exports.output = $ce3d9e3d85f43091$exports;


var $e1950f7aa6cd0d27$exports = {};
"use strict";
Object.defineProperty($e1950f7aa6cd0d27$exports, "__esModule", {
    value: true
});
var $e93f45fb68c1c55d$exports = {};

var $ilnag = parcelRequire("ilnag");
var $e93f45fb68c1c55d$require$Buffer = $ilnag.Buffer;
"use strict";
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($e93f45fb68c1c55d$exports, "__esModule", {
    value: true
});




var $f2c92e6c47d2b023$exports = {};
"use strict";
// OP_0 {pubKeyHash}
Object.defineProperty($f2c92e6c47d2b023$exports, "__esModule", {
    value: true
});


function $f2c92e6c47d2b023$var$check(script) {
    var buffer = $120fce5ded7fb153$exports.compile(script);
    return buffer.length === 22 && buffer[0] === $120fce5ded7fb153$exports.OPS.OP_0 && buffer[1] === 0x14;
}
$f2c92e6c47d2b023$exports.check = $f2c92e6c47d2b023$var$check;
$f2c92e6c47d2b023$var$check.toJSON = function() {
    return "Witness pubKeyHash output";
};


var $21ce999d058e82ff$exports = {};
"use strict";
// OP_0 {scriptHash}
Object.defineProperty($21ce999d058e82ff$exports, "__esModule", {
    value: true
});


function $21ce999d058e82ff$var$check(script) {
    var buffer = $120fce5ded7fb153$exports.compile(script);
    return buffer.length === 34 && buffer[0] === $120fce5ded7fb153$exports.OPS.OP_0 && buffer[1] === 0x20;
}
$21ce999d058e82ff$exports.check = $21ce999d058e82ff$var$check;
$21ce999d058e82ff$var$check.toJSON = function() {
    return "Witness scriptHash output";
};


function $e93f45fb68c1c55d$var$check(script, allowIncomplete) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    if (chunks.length < 1) return false;
    var lastChunk = chunks[chunks.length - 1];
    if (!$e93f45fb68c1c55d$require$Buffer.isBuffer(lastChunk)) return false;
    var scriptSigChunks = $120fce5ded7fb153$exports.decompile($120fce5ded7fb153$exports.compile(chunks.slice(0, -1)));
    var redeemScriptChunks = $120fce5ded7fb153$exports.decompile(lastChunk);
    // is redeemScript a valid script?
    if (!redeemScriptChunks) return false;
    // is redeemScriptSig push only?
    if (!$120fce5ded7fb153$exports.isPushOnly(scriptSigChunks)) return false;
    // is witness?
    if (chunks.length === 1) return $21ce999d058e82ff$exports.check(redeemScriptChunks) || $f2c92e6c47d2b023$exports.check(redeemScriptChunks);
    // match types
    if ($74076c87d216dc3b$exports.input.check(scriptSigChunks) && $74076c87d216dc3b$exports.output.check(redeemScriptChunks)) return true;
    if ($0a8a6d9c9eec534d$exports.input.check(scriptSigChunks, allowIncomplete) && $0a8a6d9c9eec534d$exports.output.check(redeemScriptChunks)) return true;
    if ($023ee51618c3589b$exports.input.check(scriptSigChunks) && $023ee51618c3589b$exports.output.check(redeemScriptChunks)) return true;
    return false;
}
$e93f45fb68c1c55d$exports.check = $e93f45fb68c1c55d$var$check;
$e93f45fb68c1c55d$var$check.toJSON = function() {
    return "scriptHash input";
};


$e1950f7aa6cd0d27$exports.input = $e93f45fb68c1c55d$exports;
var $08faa7a63b6919bf$exports = {};
"use strict";
// OP_HASH160 {scriptHash} OP_EQUAL
Object.defineProperty($08faa7a63b6919bf$exports, "__esModule", {
    value: true
});


function $08faa7a63b6919bf$var$check(script) {
    var buffer = $120fce5ded7fb153$exports.compile(script);
    return buffer.length === 23 && buffer[0] === $120fce5ded7fb153$exports.OPS.OP_HASH160 && buffer[1] === 0x14 && buffer[22] === $120fce5ded7fb153$exports.OPS.OP_EQUAL;
}
$08faa7a63b6919bf$exports.check = $08faa7a63b6919bf$var$check;
$08faa7a63b6919bf$var$check.toJSON = function() {
    return "scriptHash output";
};


$e1950f7aa6cd0d27$exports.output = $08faa7a63b6919bf$exports;


var $e49df5ae440c090d$exports = {};
"use strict";
Object.defineProperty($e49df5ae440c090d$exports, "__esModule", {
    value: true
});
var $05c531457ee6c6f9$exports = {};

var $ilnag = parcelRequire("ilnag");
var $05c531457ee6c6f9$require$Buffer = $ilnag.Buffer;
"use strict";
// OP_RETURN {aa21a9ed} {commitment}
Object.defineProperty($05c531457ee6c6f9$exports, "__esModule", {
    value: true
});




var $e9ZU4 = parcelRequire("e9ZU4");
var $05c531457ee6c6f9$var$HEADER = $05c531457ee6c6f9$require$Buffer.from("aa21a9ed", "hex");
function $05c531457ee6c6f9$var$check(script) {
    var buffer = $120fce5ded7fb153$exports.compile(script);
    return buffer.length > 37 && buffer[0] === $120fce5ded7fb153$exports.OPS.OP_RETURN && buffer[1] === 0x24 && buffer.slice(2, 6).equals($05c531457ee6c6f9$var$HEADER);
}
$05c531457ee6c6f9$exports.check = $05c531457ee6c6f9$var$check;
$05c531457ee6c6f9$var$check.toJSON = function() {
    return "Witness commitment output";
};
function $05c531457ee6c6f9$var$encode(commitment) {
    $e9ZU4($8f74010e7554fd26$exports.Hash256bit, commitment);
    var buffer = $05c531457ee6c6f9$require$Buffer.allocUnsafe(36);
    $05c531457ee6c6f9$var$HEADER.copy(buffer, 0);
    commitment.copy(buffer, 4);
    return $120fce5ded7fb153$exports.compile([
        $120fce5ded7fb153$exports.OPS.OP_RETURN,
        buffer
    ]);
}
$05c531457ee6c6f9$exports.encode = $05c531457ee6c6f9$var$encode;
function $05c531457ee6c6f9$var$decode(buffer) {
    $e9ZU4($05c531457ee6c6f9$var$check, buffer);
    return $120fce5ded7fb153$exports.decompile(buffer)[1].slice(4, 36);
}
$05c531457ee6c6f9$exports.decode = $05c531457ee6c6f9$var$decode;


$e49df5ae440c090d$exports.output = $05c531457ee6c6f9$exports;


var $9269782424e07163$exports = {};
"use strict";
Object.defineProperty($9269782424e07163$exports, "__esModule", {
    value: true
});
var $82cd878a9c54c690$exports = {};
"use strict";
// {signature} {pubKey}
Object.defineProperty($82cd878a9c54c690$exports, "__esModule", {
    value: true
});

function $82cd878a9c54c690$var$isCompressedCanonicalPubKey(pubKey) {
    return $120fce5ded7fb153$exports.isCanonicalPubKey(pubKey) && pubKey.length === 33;
}
function $82cd878a9c54c690$var$check(script) {
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    return chunks.length === 2 && $120fce5ded7fb153$exports.isCanonicalScriptSignature(chunks[0]) && $82cd878a9c54c690$var$isCompressedCanonicalPubKey(chunks[1]);
}
$82cd878a9c54c690$exports.check = $82cd878a9c54c690$var$check;
$82cd878a9c54c690$var$check.toJSON = function() {
    return "witnessPubKeyHash input";
};


$9269782424e07163$exports.input = $82cd878a9c54c690$exports;

$9269782424e07163$exports.output = $f2c92e6c47d2b023$exports;


var $3a378b8dc0cea08d$exports = {};
"use strict";
Object.defineProperty($3a378b8dc0cea08d$exports, "__esModule", {
    value: true
});
var $be02fde40cd1f0e7$exports = {};

var $ilnag = parcelRequire("ilnag");
var $be02fde40cd1f0e7$require$Buffer = $ilnag.Buffer;
"use strict";
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($be02fde40cd1f0e7$exports, "__esModule", {
    value: true
});


var $e9ZU4 = parcelRequire("e9ZU4");



function $be02fde40cd1f0e7$var$check(chunks, allowIncomplete) {
    $e9ZU4($e9ZU4.Array, chunks);
    if (chunks.length < 1) return false;
    var witnessScript = chunks[chunks.length - 1];
    if (!$be02fde40cd1f0e7$require$Buffer.isBuffer(witnessScript)) return false;
    var witnessScriptChunks = $120fce5ded7fb153$exports.decompile(witnessScript);
    // is witnessScript a valid script?
    if (!witnessScriptChunks || witnessScriptChunks.length === 0) return false;
    var witnessRawScriptSig = $120fce5ded7fb153$exports.compile(chunks.slice(0, -1));
    // match types
    if ($74076c87d216dc3b$exports.input.check(witnessRawScriptSig) && $74076c87d216dc3b$exports.output.check(witnessScriptChunks)) return true;
    if ($0a8a6d9c9eec534d$exports.input.check(witnessRawScriptSig, allowIncomplete) && $0a8a6d9c9eec534d$exports.output.check(witnessScriptChunks)) return true;
    if ($023ee51618c3589b$exports.input.check(witnessRawScriptSig) && $023ee51618c3589b$exports.output.check(witnessScriptChunks)) return true;
    return false;
}
$be02fde40cd1f0e7$exports.check = $be02fde40cd1f0e7$var$check;
$be02fde40cd1f0e7$var$check.toJSON = function() {
    return "witnessScriptHash input";
};


$3a378b8dc0cea08d$exports.input = $be02fde40cd1f0e7$exports;

$3a378b8dc0cea08d$exports.output = $21ce999d058e82ff$exports;


var $a9d0110726ea614b$var$types = {
    P2MS: "multisig",
    NONSTANDARD: "nonstandard",
    NULLDATA: "nulldata",
    P2PK: "pubkey",
    P2PKH: "pubkeyhash",
    P2SH: "scripthash",
    P2WPKH: "witnesspubkeyhash",
    P2WSH: "witnessscripthash",
    WITNESS_COMMITMENT: "witnesscommitment"
};
$a9d0110726ea614b$exports.types = $a9d0110726ea614b$var$types;
function $a9d0110726ea614b$var$classifyOutput(script) {
    if ($9269782424e07163$exports.output.check(script)) return $a9d0110726ea614b$var$types.P2WPKH;
    if ($3a378b8dc0cea08d$exports.output.check(script)) return $a9d0110726ea614b$var$types.P2WSH;
    if ($74076c87d216dc3b$exports.output.check(script)) return $a9d0110726ea614b$var$types.P2PKH;
    if ($e1950f7aa6cd0d27$exports.output.check(script)) return $a9d0110726ea614b$var$types.P2SH;
    // XXX: optimization, below functions .decompile before use
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($0a8a6d9c9eec534d$exports.output.check(chunks)) return $a9d0110726ea614b$var$types.P2MS;
    if ($023ee51618c3589b$exports.output.check(chunks)) return $a9d0110726ea614b$var$types.P2PK;
    if ($e49df5ae440c090d$exports.output.check(chunks)) return $a9d0110726ea614b$var$types.WITNESS_COMMITMENT;
    if ($30752427629d5db5$exports.output.check(chunks)) return $a9d0110726ea614b$var$types.NULLDATA;
    return $a9d0110726ea614b$var$types.NONSTANDARD;
}
$a9d0110726ea614b$exports.output = $a9d0110726ea614b$var$classifyOutput;
function $a9d0110726ea614b$var$classifyInput(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($74076c87d216dc3b$exports.input.check(chunks)) return $a9d0110726ea614b$var$types.P2PKH;
    if ($e1950f7aa6cd0d27$exports.input.check(chunks, allowIncomplete)) return $a9d0110726ea614b$var$types.P2SH;
    if ($0a8a6d9c9eec534d$exports.input.check(chunks, allowIncomplete)) return $a9d0110726ea614b$var$types.P2MS;
    if ($023ee51618c3589b$exports.input.check(chunks)) return $a9d0110726ea614b$var$types.P2PK;
    return $a9d0110726ea614b$var$types.NONSTANDARD;
}
$a9d0110726ea614b$exports.input = $a9d0110726ea614b$var$classifyInput;
function $a9d0110726ea614b$var$classifyWitness(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    var chunks = $120fce5ded7fb153$exports.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($9269782424e07163$exports.input.check(chunks)) return $a9d0110726ea614b$var$types.P2WPKH;
    if ($3a378b8dc0cea08d$exports.input.check(chunks, allowIncomplete)) return $a9d0110726ea614b$var$types.P2WSH;
    return $a9d0110726ea614b$var$types.NONSTANDARD;
}
$a9d0110726ea614b$exports.witness = $a9d0110726ea614b$var$classifyWitness;











var $e9ZU4 = parcelRequire("e9ZU4");
var $5c3050bf90afe92a$var$SCRIPT_TYPES = $a9d0110726ea614b$exports.types;
var $5c3050bf90afe92a$var$PREVOUT_TYPES = new Set([
    // Raw
    "p2pkh",
    "p2pk",
    "p2wpkh",
    "p2ms",
    // P2SH wrapped
    "p2sh-p2pkh",
    "p2sh-p2pk",
    "p2sh-p2wpkh",
    "p2sh-p2ms",
    // P2WSH wrapped
    "p2wsh-p2pkh",
    "p2wsh-p2pk",
    "p2wsh-p2ms",
    // P2SH-P2WSH wrapper
    "p2sh-p2wsh-p2pkh",
    "p2sh-p2wsh-p2pk",
    "p2sh-p2wsh-p2ms"
]);
function $5c3050bf90afe92a$var$tfMessage(type, value, message) {
    try {
        $e9ZU4(type, value);
    } catch (err) {
        throw new Error(message);
    }
}
function $5c3050bf90afe92a$var$txIsString(tx) {
    return typeof tx === "string" || tx instanceof String;
}
function $5c3050bf90afe92a$var$txIsTransaction(tx) {
    return tx instanceof $55e09fe174fff4e9$exports.Transaction;
}
var $5c3050bf90afe92a$var$TransactionBuilder = /*#__PURE__*/ function() {
    "use strict";
    function TransactionBuilder() {
        var network = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $255d167d6a85e1f2$exports.bitcoin, maximumFeeRate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2500;
        (0, $7dKN1._)(this, TransactionBuilder);
        this.network = network;
        this.maximumFeeRate = maximumFeeRate;
        this.__PREV_TX_SET = {};
        this.__INPUTS = [];
        this.__TX = new $55e09fe174fff4e9$exports.Transaction();
        this.__TX.version = 2;
        this.__USE_LOW_R = false;
        console.warn("Deprecation Warning: TransactionBuilder will be removed in the future. (v6.x.x or later) Please use the Psbt class instead. Examples of usage are available in the transactions-psbt.js integration test file on our Github. A high level explanation is available in the psbt.ts and psbt.js files as well.");
    }
    (0, $eW5pA._)(TransactionBuilder, [
        {
            key: "setLowR",
            value: function setLowR(setting) {
                $e9ZU4($e9ZU4.maybe($e9ZU4.Boolean), setting);
                if (setting === undefined) setting = true;
                this.__USE_LOW_R = setting;
                return setting;
            }
        },
        {
            key: "setLockTime",
            value: function setLockTime(locktime) {
                $e9ZU4($8f74010e7554fd26$exports.UInt32, locktime);
                // if any signatures exist, throw
                if (this.__INPUTS.some(function(input) {
                    if (!input.signatures) return false;
                    return input.signatures.some(function(s) {
                        return s !== undefined;
                    });
                })) throw new Error("No, this would invalidate signatures");
                this.__TX.locktime = locktime;
            }
        },
        {
            key: "setVersion",
            value: function setVersion(version) {
                $e9ZU4($8f74010e7554fd26$exports.UInt32, version);
                // XXX: this might eventually become more complex depending on what the versions represent
                this.__TX.version = version;
            }
        },
        {
            key: "addInput",
            value: function addInput(txHash, vout, sequence, prevOutScript) {
                if (!this.__canModifyInputs()) throw new Error("No, this would invalidate signatures");
                var value;
                // is it a hex string?
                if ($5c3050bf90afe92a$var$txIsString(txHash)) // transaction hashs's are displayed in reverse order, un-reverse it
                txHash = $4f1d1f810d91b53b$exports.reverseBuffer($5c3050bf90afe92a$require$Buffer.from(txHash, "hex"));
                else if ($5c3050bf90afe92a$var$txIsTransaction(txHash)) {
                    var txOut = txHash.outs[vout];
                    prevOutScript = txOut.script;
                    value = txOut.value;
                    txHash = txHash.getHash(false);
                }
                return this.__addInputUnsafe(txHash, vout, {
                    sequence: sequence,
                    prevOutScript: prevOutScript,
                    value: value
                });
            }
        },
        {
            key: "addOutput",
            value: function addOutput(scriptPubKey, value) {
                if (!this.__canModifyOutputs()) throw new Error("No, this would invalidate signatures");
                // Attempt to get a script if it's a base58 or bech32 address string
                if (typeof scriptPubKey === "string") scriptPubKey = $52c2d07c5f3c77af$exports.toOutputScript(scriptPubKey, this.network);
                return this.__TX.addOutput(scriptPubKey, value);
            }
        },
        {
            key: "build",
            value: function build() {
                return this.__build(false);
            }
        },
        {
            key: "buildIncomplete",
            value: function buildIncomplete() {
                return this.__build(true);
            }
        },
        {
            key: "sign",
            value: function sign(signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript) {
                $5c3050bf90afe92a$var$trySign($5c3050bf90afe92a$var$getSigningData(this.network, this.__INPUTS, this.__needsOutputs.bind(this), this.__TX, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, this.__USE_LOW_R));
            }
        },
        {
            key: "__addInputUnsafe",
            value: function __addInputUnsafe(txHash, vout, options) {
                if ($55e09fe174fff4e9$exports.Transaction.isCoinbaseHash(txHash)) throw new Error("coinbase inputs not supported");
                var prevTxOut = txHash.toString("hex") + ":" + vout;
                if (this.__PREV_TX_SET[prevTxOut] !== undefined) throw new Error("Duplicate TxOut: " + prevTxOut);
                var input = {};
                // derive what we can from the scriptSig
                if (options.script !== undefined) input = $5c3050bf90afe92a$var$expandInput(options.script, options.witness || []);
                // if an input value was given, retain it
                if (options.value !== undefined) input.value = options.value;
                // derive what we can from the previous transactions output script
                if (!input.prevOutScript && options.prevOutScript) {
                    var prevOutType;
                    if (!input.pubkeys && !input.signatures) {
                        var expanded = $5c3050bf90afe92a$var$expandOutput(options.prevOutScript);
                        if (expanded.pubkeys) {
                            input.pubkeys = expanded.pubkeys;
                            input.signatures = expanded.signatures;
                        }
                        prevOutType = expanded.type;
                    }
                    input.prevOutScript = options.prevOutScript;
                    input.prevOutType = prevOutType || $a9d0110726ea614b$exports.output(options.prevOutScript);
                }
                var vin = this.__TX.addInput(txHash, vout, options.sequence, options.scriptSig);
                this.__INPUTS[vin] = input;
                this.__PREV_TX_SET[prevTxOut] = true;
                return vin;
            }
        },
        {
            key: "__build",
            value: function __build(allowIncomplete) {
                if (!allowIncomplete) {
                    if (!this.__TX.ins.length) throw new Error("Transaction has no inputs");
                    if (!this.__TX.outs.length) throw new Error("Transaction has no outputs");
                }
                var tx = this.__TX.clone();
                // create script signatures from inputs
                this.__INPUTS.forEach(function(input, i) {
                    if (!input.prevOutType && !allowIncomplete) throw new Error("Transaction is not complete");
                    var result = $5c3050bf90afe92a$var$build(input.prevOutType, input, allowIncomplete);
                    if (!result) {
                        if (!allowIncomplete && input.prevOutType === $5c3050bf90afe92a$var$SCRIPT_TYPES.NONSTANDARD) throw new Error("Unknown input type");
                        if (!allowIncomplete) throw new Error("Not enough information");
                        return;
                    }
                    tx.setInputScript(i, result.input);
                    tx.setWitness(i, result.witness);
                });
                if (!allowIncomplete) {
                    // do not rely on this, its merely a last resort
                    if (this.__overMaximumFees(tx.virtualSize())) throw new Error("Transaction has absurd fees");
                }
                return tx;
            }
        },
        {
            key: "__canModifyInputs",
            value: function __canModifyInputs() {
                return this.__INPUTS.every(function(input) {
                    if (!input.signatures) return true;
                    return input.signatures.every(function(signature) {
                        if (!signature) return true;
                        var hashType = $5c3050bf90afe92a$var$signatureHashType(signature);
                        // if SIGHASH_ANYONECANPAY is set, signatures would not
                        // be invalidated by more inputs
                        return (hashType & $55e09fe174fff4e9$exports.Transaction.SIGHASH_ANYONECANPAY) !== 0;
                    });
                });
            }
        },
        {
            key: "__needsOutputs",
            value: function __needsOutputs(signingHashType) {
                if (signingHashType === $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL) return this.__TX.outs.length === 0;
                // if inputs are being signed with SIGHASH_NONE, we don't strictly need outputs
                // .build() will fail, but .buildIncomplete() is OK
                return this.__TX.outs.length === 0 && this.__INPUTS.some(function(input) {
                    if (!input.signatures) return false;
                    return input.signatures.some(function(signature) {
                        if (!signature) return false; // no signature, no issue
                        var hashType = $5c3050bf90afe92a$var$signatureHashType(signature);
                        if (hashType & $55e09fe174fff4e9$exports.Transaction.SIGHASH_NONE) return false; // SIGHASH_NONE doesn't care about outputs
                        return true; // SIGHASH_* does care
                    });
                });
            }
        },
        {
            key: "__canModifyOutputs",
            value: function __canModifyOutputs() {
                var nInputs = this.__TX.ins.length;
                var nOutputs = this.__TX.outs.length;
                return this.__INPUTS.every(function(input) {
                    if (input.signatures === undefined) return true;
                    return input.signatures.every(function(signature) {
                        if (!signature) return true;
                        var hashType = $5c3050bf90afe92a$var$signatureHashType(signature);
                        var hashTypeMod = hashType & 0x1f;
                        if (hashTypeMod === $55e09fe174fff4e9$exports.Transaction.SIGHASH_NONE) return true;
                        if (hashTypeMod === $55e09fe174fff4e9$exports.Transaction.SIGHASH_SINGLE) // if SIGHASH_SINGLE is set, and nInputs > nOutputs
                        // some signatures would be invalidated by the addition
                        // of more outputs
                        return nInputs <= nOutputs;
                        return false;
                    });
                });
            }
        },
        {
            key: "__overMaximumFees",
            value: function __overMaximumFees(bytes) {
                // not all inputs will have .value defined
                var incoming = this.__INPUTS.reduce(function(a, x) {
                    return a + (x.value >>> 0);
                }, 0);
                // but all outputs do, and if we have any input value
                // we can immediately determine if the outputs are too small
                var outgoing = this.__TX.outs.reduce(function(a, x) {
                    return a + x.value;
                }, 0);
                var fee = incoming - outgoing;
                var feeRate = fee / bytes;
                return feeRate > this.maximumFeeRate;
            }
        }
    ], [
        {
            key: "fromTransaction",
            value: function fromTransaction(transaction, network) {
                var txb = new TransactionBuilder(network);
                // Copy transaction fields
                txb.setVersion(transaction.version);
                txb.setLockTime(transaction.locktime);
                // Copy outputs (done first to avoid signature invalidation)
                transaction.outs.forEach(function(txOut) {
                    txb.addOutput(txOut.script, txOut.value);
                });
                // Copy inputs
                transaction.ins.forEach(function(txIn) {
                    txb.__addInputUnsafe(txIn.hash, txIn.index, {
                        sequence: txIn.sequence,
                        script: txIn.script,
                        witness: txIn.witness
                    });
                });
                // fix some things not possible through the public API
                txb.__INPUTS.forEach(function(input, i) {
                    $5c3050bf90afe92a$var$fixMultisigOrder(input, transaction, i);
                });
                return txb;
            }
        }
    ]);
    return TransactionBuilder;
}();
$5c3050bf90afe92a$exports.TransactionBuilder = $5c3050bf90afe92a$var$TransactionBuilder;
function $5c3050bf90afe92a$var$expandInput(scriptSig, witnessStack, type, scriptPubKey) {
    if (scriptSig.length === 0 && witnessStack.length === 0) return {};
    if (!type) {
        var ssType = $a9d0110726ea614b$exports.input(scriptSig, true);
        var wsType = $a9d0110726ea614b$exports.witness(witnessStack, true);
        if (ssType === $5c3050bf90afe92a$var$SCRIPT_TYPES.NONSTANDARD) ssType = undefined;
        if (wsType === $5c3050bf90afe92a$var$SCRIPT_TYPES.NONSTANDARD) wsType = undefined;
        type = ssType || wsType;
    }
    switch(type){
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH:
            {
                var _payments_p2wpkh = $8a09fb4c2f496869$exports.p2wpkh({
                    witness: witnessStack
                }), output = _payments_p2wpkh.output, pubkey = _payments_p2wpkh.pubkey, signature = _payments_p2wpkh.signature;
                return {
                    prevOutScript: output,
                    prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PKH:
            {
                var _payments_p2pkh = $8a09fb4c2f496869$exports.p2pkh({
                    input: scriptSig
                }), output1 = _payments_p2pkh.output, pubkey1 = _payments_p2pkh.pubkey, signature1 = _payments_p2pkh.signature;
                return {
                    prevOutScript: output1,
                    prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PKH,
                    pubkeys: [
                        pubkey1
                    ],
                    signatures: [
                        signature1
                    ]
                };
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PK:
            {
                var signature2 = $8a09fb4c2f496869$exports.p2pk({
                    input: scriptSig
                }).signature;
                return {
                    prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PK,
                    pubkeys: [
                        undefined
                    ],
                    signatures: [
                        signature2
                    ]
                };
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2MS:
            {
                var _payments_p2ms = $8a09fb4c2f496869$exports.p2ms({
                    input: scriptSig,
                    output: scriptPubKey
                }, {
                    allowIncomplete: true
                }), m = _payments_p2ms.m, pubkeys = _payments_p2ms.pubkeys, signatures = _payments_p2ms.signatures;
                return {
                    prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2MS,
                    pubkeys: pubkeys,
                    signatures: signatures,
                    maxSignatures: m
                };
            }
    }
    if (type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2SH) {
        var _payments_p2sh = $8a09fb4c2f496869$exports.p2sh({
            input: scriptSig,
            witness: witnessStack
        }), output2 = _payments_p2sh.output, redeem = _payments_p2sh.redeem;
        var outputType = $a9d0110726ea614b$exports.output(redeem.output);
        var expanded = $5c3050bf90afe92a$var$expandInput(redeem.input, redeem.witness, outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output2,
            prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2SH,
            redeemScript: redeem.output,
            redeemScriptType: expanded.prevOutType,
            witnessScript: expanded.witnessScript,
            witnessScriptType: expanded.witnessScriptType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    if (type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WSH) {
        var _payments_p2wsh = $8a09fb4c2f496869$exports.p2wsh({
            input: scriptSig,
            witness: witnessStack
        }), output3 = _payments_p2wsh.output, redeem1 = _payments_p2wsh.redeem;
        var outputType1 = $a9d0110726ea614b$exports.output(redeem1.output);
        var expanded1;
        if (outputType1 === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH) expanded1 = $5c3050bf90afe92a$var$expandInput(redeem1.input, redeem1.witness, outputType1);
        else expanded1 = $5c3050bf90afe92a$var$expandInput($120fce5ded7fb153$exports.compile(redeem1.witness), [], outputType1, redeem1.output);
        if (!expanded1.prevOutType) return {};
        return {
            prevOutScript: output3,
            prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WSH,
            witnessScript: redeem1.output,
            witnessScriptType: expanded1.prevOutType,
            pubkeys: expanded1.pubkeys,
            signatures: expanded1.signatures
        };
    }
    return {
        prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.NONSTANDARD,
        prevOutScript: scriptSig
    };
}
// could be done in expandInput, but requires the original Transaction for hashForSignature
function $5c3050bf90afe92a$var$fixMultisigOrder(input, transaction, vin) {
    if (input.redeemScriptType !== $5c3050bf90afe92a$var$SCRIPT_TYPES.P2MS || !input.redeemScript) return;
    if (input.pubkeys.length === input.signatures.length) return;
    var unmatched = input.signatures.concat();
    input.signatures = input.pubkeys.map(function(pubKey) {
        var keyPair = $d25f5aec1142ce7b$exports.fromPublicKey(pubKey);
        var match;
        // check for a signature
        unmatched.some(function(signature, i) {
            // skip if undefined || OP_0
            if (!signature) return false;
            // TODO: avoid O(n) hashForSignature
            var parsed = $120fce5ded7fb153$exports.signature.decode(signature);
            var hash = transaction.hashForSignature(vin, input.redeemScript, parsed.hashType);
            // skip if signature does not match pubKey
            if (!keyPair.verify(hash, parsed.signature)) return false;
            // remove matched signature from unmatched
            unmatched[i] = undefined;
            match = signature;
            return true;
        });
        return match;
    });
}
function $5c3050bf90afe92a$var$expandOutput(script, ourPubKey) {
    $e9ZU4($8f74010e7554fd26$exports.Buffer, script);
    var type = $a9d0110726ea614b$exports.output(script);
    switch(type){
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                var pkh1 = $8a09fb4c2f496869$exports.p2pkh({
                    output: script
                }).hash;
                var pkh2 = $0f478b5636513f95$exports.hash160(ourPubKey);
                if (!pkh1.equals(pkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                var wpkh1 = $8a09fb4c2f496869$exports.p2wpkh({
                    output: script
                }).hash;
                var wpkh2 = $0f478b5636513f95$exports.hash160(ourPubKey);
                if (!wpkh1.equals(wpkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PK:
            {
                var p2pk = $8a09fb4c2f496869$exports.p2pk({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: [
                        p2pk.pubkey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2MS:
            {
                var p2ms = $8a09fb4c2f496869$exports.p2ms({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: p2ms.pubkeys,
                    signatures: p2ms.pubkeys.map(function() {
                        return undefined;
                    }),
                    maxSignatures: p2ms.m
                };
            }
    }
    return {
        type: type
    };
}
function $5c3050bf90afe92a$var$prepareInput(input, ourPubKey, redeemScript, witnessScript) {
    if (redeemScript && witnessScript) {
        var p2wsh = $8a09fb4c2f496869$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        var p2wshAlt = $8a09fb4c2f496869$exports.p2wsh({
            output: redeemScript
        });
        var p2sh = $8a09fb4c2f496869$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        var p2shAlt = $8a09fb4c2f496869$exports.p2sh({
            redeem: p2wsh
        });
        // enforces P2SH(P2WSH(...))
        if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error("Witness script inconsistent with prevOutScript");
        if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error("Redeem script inconsistent with prevOutScript");
        var expanded = $5c3050bf90afe92a$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as witnessScript (" + $120fce5ded7fb153$exports.toASM(witnessScript) + ")");
        if (input.signatures && input.signatures.some(function(x) {
            return x !== undefined;
        })) expanded.signatures = input.signatures;
        var signScript = witnessScript;
        if (expanded.type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH) throw new Error("P2SH(P2WSH(P2WPKH)) is a consensus failure");
        return {
            redeemScript: redeemScript,
            redeemScriptType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WSH,
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (redeemScript) {
        var p2sh1 = $8a09fb4c2f496869$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        if (input.prevOutScript) {
            var p2shAlt1;
            try {
                p2shAlt1 = $8a09fb4c2f496869$exports.p2sh({
                    output: input.prevOutScript
                });
            } catch (e) {
                throw new Error("PrevOutScript must be P2SH");
            }
            if (!p2sh1.hash.equals(p2shAlt1.hash)) throw new Error("Redeem script inconsistent with prevOutScript");
        }
        var expanded1 = $5c3050bf90afe92a$var$expandOutput(p2sh1.redeem.output, ourPubKey);
        if (!expanded1.pubkeys) throw new Error(expanded1.type + " not supported as redeemScript (" + $120fce5ded7fb153$exports.toASM(redeemScript) + ")");
        if (input.signatures && input.signatures.some(function(x) {
            return x !== undefined;
        })) expanded1.signatures = input.signatures;
        var signScript1 = redeemScript;
        if (expanded1.type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH) signScript1 = $8a09fb4c2f496869$exports.p2pkh({
            pubkey: expanded1.pubkeys[0]
        }).output;
        return {
            redeemScript: redeemScript,
            redeemScriptType: expanded1.type,
            prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh1.output,
            hasWitness: expanded1.type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript1,
            signType: expanded1.type,
            pubkeys: expanded1.pubkeys,
            signatures: expanded1.signatures,
            maxSignatures: expanded1.maxSignatures
        };
    }
    if (witnessScript) {
        var p2wsh1 = $8a09fb4c2f496869$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        if (input.prevOutScript) {
            var p2wshAlt1 = $8a09fb4c2f496869$exports.p2wsh({
                output: input.prevOutScript
            });
            if (!p2wsh1.hash.equals(p2wshAlt1.hash)) throw new Error("Witness script inconsistent with prevOutScript");
        }
        var expanded2 = $5c3050bf90afe92a$var$expandOutput(p2wsh1.redeem.output, ourPubKey);
        if (!expanded2.pubkeys) throw new Error(expanded2.type + " not supported as witnessScript (" + $120fce5ded7fb153$exports.toASM(witnessScript) + ")");
        if (input.signatures && input.signatures.some(function(x) {
            return x !== undefined;
        })) expanded2.signatures = input.signatures;
        var signScript2 = witnessScript;
        if (expanded2.type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH) throw new Error("P2WSH(P2WPKH) is a consensus failure");
        return {
            witnessScript: witnessScript,
            witnessScriptType: expanded2.type,
            prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WSH,
            prevOutScript: p2wsh1.output,
            hasWitness: true,
            signScript: signScript2,
            signType: expanded2.type,
            pubkeys: expanded2.pubkeys,
            signatures: expanded2.signatures,
            maxSignatures: expanded2.maxSignatures
        };
    }
    if (input.prevOutType && input.prevOutScript) {
        // embedded scripts are not possible without extra information
        if (input.prevOutType === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2SH) throw new Error("PrevOutScript is " + input.prevOutType + ", requires redeemScript");
        if (input.prevOutType === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WSH) throw new Error("PrevOutScript is " + input.prevOutType + ", requires witnessScript");
        if (!input.prevOutScript) throw new Error("PrevOutScript is missing");
        var expanded3 = $5c3050bf90afe92a$var$expandOutput(input.prevOutScript, ourPubKey);
        if (!expanded3.pubkeys) throw new Error(expanded3.type + " not supported (" + $120fce5ded7fb153$exports.toASM(input.prevOutScript) + ")");
        if (input.signatures && input.signatures.some(function(x) {
            return x !== undefined;
        })) expanded3.signatures = input.signatures;
        var signScript3 = input.prevOutScript;
        if (expanded3.type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH) signScript3 = $8a09fb4c2f496869$exports.p2pkh({
            pubkey: expanded3.pubkeys[0]
        }).output;
        return {
            prevOutType: expanded3.type,
            prevOutScript: input.prevOutScript,
            hasWitness: expanded3.type === $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript3,
            signType: expanded3.type,
            pubkeys: expanded3.pubkeys,
            signatures: expanded3.signatures,
            maxSignatures: expanded3.maxSignatures
        };
    }
    var prevOutScript = $8a09fb4c2f496869$exports.p2pkh({
        pubkey: ourPubKey
    }).output;
    return {
        prevOutType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PKH,
        prevOutScript: prevOutScript,
        hasWitness: false,
        signScript: prevOutScript,
        signType: $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PKH,
        pubkeys: [
            ourPubKey
        ],
        signatures: [
            undefined
        ]
    };
}
function $5c3050bf90afe92a$var$build(type, input, allowIncomplete) {
    var pubkeys = input.pubkeys || [];
    var signatures = input.signatures || [];
    switch(type){
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $8a09fb4c2f496869$exports.p2pkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WPKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $8a09fb4c2f496869$exports.p2wpkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2PK:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $8a09fb4c2f496869$exports.p2pk({
                signature: signatures[0]
            });
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2MS:
            {
                var m = input.maxSignatures;
                if (allowIncomplete) signatures = signatures.map(function(x) {
                    return x || $120fce5ded7fb153$exports.OPS.OP_0;
                });
                else signatures = signatures.filter(function(x) {
                    return x;
                });
                // if the transaction is not not complete (complete), or if signatures.length === m, validate
                // otherwise, the number of OP_0's may be >= m, so don't validate (boo)
                var validate = !allowIncomplete || m === signatures.length;
                return $8a09fb4c2f496869$exports.p2ms({
                    m: m,
                    pubkeys: pubkeys,
                    signatures: signatures
                }, {
                    allowIncomplete: allowIncomplete,
                    validate: validate
                });
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2SH:
            {
                var redeem = $5c3050bf90afe92a$var$build(input.redeemScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $8a09fb4c2f496869$exports.p2sh({
                    redeem: {
                        output: redeem.output || input.redeemScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
        case $5c3050bf90afe92a$var$SCRIPT_TYPES.P2WSH:
            {
                var redeem1 = $5c3050bf90afe92a$var$build(input.witnessScriptType, input, allowIncomplete);
                if (!redeem1) return;
                return $8a09fb4c2f496869$exports.p2wsh({
                    redeem: {
                        output: input.witnessScript,
                        input: redeem1.input,
                        witness: redeem1.witness
                    }
                });
            }
    }
}
function $5c3050bf90afe92a$var$canSign(input) {
    return input.signScript !== undefined && input.signType !== undefined && input.pubkeys !== undefined && input.signatures !== undefined && input.signatures.length === input.pubkeys.length && input.pubkeys.length > 0 && (input.hasWitness === false || input.value !== undefined);
}
function $5c3050bf90afe92a$var$signatureHashType(buffer) {
    return buffer.readUInt8(buffer.length - 1);
}
function $5c3050bf90afe92a$var$checkSignArgs(inputs, signParams) {
    if (!$5c3050bf90afe92a$var$PREVOUT_TYPES.has(signParams.prevOutScriptType)) throw new TypeError('Unknown prevOutScriptType "'.concat(signParams.prevOutScriptType, '"'));
    $5c3050bf90afe92a$var$tfMessage($e9ZU4.Number, signParams.vin, "sign must include vin parameter as Number (input index)");
    $5c3050bf90afe92a$var$tfMessage($8f74010e7554fd26$exports.Signer, signParams.keyPair, "sign must include keyPair parameter as Signer interface");
    $5c3050bf90afe92a$var$tfMessage($e9ZU4.maybe($e9ZU4.Number), signParams.hashType, "sign hashType parameter must be a number");
    var prevOutType = (inputs[signParams.vin] || []).prevOutType;
    var posType = signParams.prevOutScriptType;
    switch(posType){
        case "p2pkh":
            if (prevOutType && prevOutType !== "pubkeyhash") throw new TypeError("input #".concat(signParams.vin, " is not of type p2pkh: ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessScript, "".concat(posType, " requires NO witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.redeemScript, "".concat(posType, " requires NO redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessValue, "".concat(posType, " requires NO witnessValue"));
            break;
        case "p2pk":
            if (prevOutType && prevOutType !== "pubkey") throw new TypeError("input #".concat(signParams.vin, " is not of type p2pk: ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessScript, "".concat(posType, " requires NO witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.redeemScript, "".concat(posType, " requires NO redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessValue, "".concat(posType, " requires NO witnessValue"));
            break;
        case "p2wpkh":
            if (prevOutType && prevOutType !== "witnesspubkeyhash") throw new TypeError("input #".concat(signParams.vin, " is not of type p2wpkh: ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessScript, "".concat(posType, " requires NO witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.redeemScript, "".concat(posType, " requires NO redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($8f74010e7554fd26$exports.Satoshi, signParams.witnessValue, "".concat(posType, " requires witnessValue"));
            break;
        case "p2ms":
            if (prevOutType && prevOutType !== "multisig") throw new TypeError("input #".concat(signParams.vin, " is not of type p2ms: ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessScript, "".concat(posType, " requires NO witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.redeemScript, "".concat(posType, " requires NO redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessValue, "".concat(posType, " requires NO witnessValue"));
            break;
        case "p2sh-p2wpkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError("input #".concat(signParams.vin, " is not of type p2sh-p2wpkh: ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessScript, "".concat(posType, " requires NO witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.Buffer, signParams.redeemScript, "".concat(posType, " requires redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($8f74010e7554fd26$exports.Satoshi, signParams.witnessValue, "".concat(posType, " requires witnessValue"));
            break;
        case "p2sh-p2ms":
        case "p2sh-p2pk":
        case "p2sh-p2pkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError("input #".concat(signParams.vin, " is not of type ").concat(posType, ": ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessScript, "".concat(posType, " requires NO witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.Buffer, signParams.redeemScript, "".concat(posType, " requires redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.witnessValue, "".concat(posType, " requires NO witnessValue"));
            break;
        case "p2wsh-p2ms":
        case "p2wsh-p2pk":
        case "p2wsh-p2pkh":
            if (prevOutType && prevOutType !== "witnessscripthash") throw new TypeError("input #".concat(signParams.vin, " is not of type ").concat(posType, ": ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.Buffer, signParams.witnessScript, "".concat(posType, " requires witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.value(undefined), signParams.redeemScript, "".concat(posType, " requires NO redeemScript"));
            $5c3050bf90afe92a$var$tfMessage($8f74010e7554fd26$exports.Satoshi, signParams.witnessValue, "".concat(posType, " requires witnessValue"));
            break;
        case "p2sh-p2wsh-p2ms":
        case "p2sh-p2wsh-p2pk":
        case "p2sh-p2wsh-p2pkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError("input #".concat(signParams.vin, " is not of type ").concat(posType, ": ").concat(prevOutType));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.Buffer, signParams.witnessScript, "".concat(posType, " requires witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($e9ZU4.Buffer, signParams.redeemScript, "".concat(posType, " requires witnessScript"));
            $5c3050bf90afe92a$var$tfMessage($8f74010e7554fd26$exports.Satoshi, signParams.witnessValue, "".concat(posType, " requires witnessScript"));
            break;
    }
}
function $5c3050bf90afe92a$var$trySign(param) {
    var input = param.input, ourPubKey = param.ourPubKey, keyPair = param.keyPair, signatureHash = param.signatureHash, hashType = param.hashType, useLowR = param.useLowR;
    // enforce in order signing of public keys
    var signed = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = input.pubkeys.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $5OlIx._)(_step.value, 2), i = _step_value[0], pubKey = _step_value[1];
            if (!ourPubKey.equals(pubKey)) continue;
            if (input.signatures[i]) throw new Error("Signature already exists");
            // TODO: add tests
            if (ourPubKey.length !== 33 && input.hasWitness) throw new Error("BIP143 rejects uncompressed public keys in P2WPKH or P2WSH");
            var signature = keyPair.sign(signatureHash, useLowR);
            input.signatures[i] = $120fce5ded7fb153$exports.signature.encode(signature, hashType);
            signed = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!signed) throw new Error("Key pair cannot sign for this input");
}
function $5c3050bf90afe92a$var$getSigningData(network, inputs, needsOutputs, tx, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, useLowR) {
    var vin;
    if (typeof signParams === "number") {
        console.warn("DEPRECATED: TransactionBuilder sign method arguments will change in v6, please use the TxbSignArg interface");
        vin = signParams;
    } else if (typeof signParams === "object") {
        $5c3050bf90afe92a$var$checkSignArgs(inputs, signParams);
        var ref;
        ref = signParams, vin = ref.vin, keyPair = ref.keyPair, redeemScript = ref.redeemScript, hashType = ref.hashType, witnessValue = ref.witnessValue, witnessScript = ref.witnessScript, ref;
    } else throw new TypeError("TransactionBuilder sign first arg must be TxbSignArg or number");
    if (keyPair === undefined) throw new Error("sign requires keypair");
    // TODO: remove keyPair.network matching in 4.0.0
    if (keyPair.network && keyPair.network !== network) throw new TypeError("Inconsistent network");
    if (!inputs[vin]) throw new Error("No input at index: " + vin);
    hashType = hashType || $55e09fe174fff4e9$exports.Transaction.SIGHASH_ALL;
    if (needsOutputs(hashType)) throw new Error("Transaction needs outputs");
    var input = inputs[vin];
    // if redeemScript was previously provided, enforce consistency
    if (input.redeemScript !== undefined && redeemScript && !input.redeemScript.equals(redeemScript)) throw new Error("Inconsistent redeemScript");
    var ourPubKey = keyPair.publicKey || keyPair.getPublicKey && keyPair.getPublicKey();
    if (!$5c3050bf90afe92a$var$canSign(input)) {
        if (witnessValue !== undefined) {
            if (input.value !== undefined && input.value !== witnessValue) throw new Error("Input did not match witnessValue");
            $e9ZU4($8f74010e7554fd26$exports.Satoshi, witnessValue);
            input.value = witnessValue;
        }
        if (!$5c3050bf90afe92a$var$canSign(input)) {
            var prepared = $5c3050bf90afe92a$var$prepareInput(input, ourPubKey, redeemScript, witnessScript);
            // updates inline
            Object.assign(input, prepared);
        }
        if (!$5c3050bf90afe92a$var$canSign(input)) throw Error(input.prevOutType + " not supported");
    }
    // ready to sign
    var signatureHash;
    if (input.hasWitness) signatureHash = tx.hashForWitnessV0(vin, input.signScript, input.value, hashType);
    else signatureHash = tx.hashForSignature(vin, input.signScript, hashType);
    return {
        input: input,
        ourPubKey: ourPubKey,
        keyPair: keyPair,
        signatureHash: signatureHash,
        hashType: hashType,
        useLowR: !!useLowR
    };
}


$9ce982a108f9bffc$exports.TransactionBuilder = $5c3050bf90afe92a$exports.TransactionBuilder;



/**
 * @file bip32.ts
 * @description BIP32 Path Handling for Bitcoin Wallets
 *
 * This file provides utility functions to handle BIP32 paths,
 * which are commonly used in hierarchical deterministic (HD) wallets.
 * It includes functions to convert BIP32 paths to and from different formats,
 * extract components from extended public keys (xpubs), and manipulate path elements.
 */ var $4f3a21d3ef79f6d4$exports = {};
/*
 * Bitcoin BIP32 path helpers
 * (C) 2016 Alex Beregszaszi
 */ var $4f3a21d3ef79f6d4$var$HARDENED = 0x80000000;
var $4f3a21d3ef79f6d4$var$BIPPath = function BIPPath(path) {
    if (!Array.isArray(path)) throw new Error("Input must be an Array");
    if (path.length === 0) throw new Error("Path must contain at least one level");
    for(var i = 0; i < path.length; i++){
        if (typeof path[i] !== "number") throw new Error("Path element is not a number");
    }
    this.path = path;
};
$4f3a21d3ef79f6d4$var$BIPPath.validatePathArray = function(path) {
    try {
        $4f3a21d3ef79f6d4$var$BIPPath.fromPathArray(path);
        return true;
    } catch (e) {
        return false;
    }
};
$4f3a21d3ef79f6d4$var$BIPPath.validateString = function(text, reqRoot) {
    try {
        $4f3a21d3ef79f6d4$var$BIPPath.fromString(text, reqRoot);
        return true;
    } catch (e) {
        return false;
    }
};
$4f3a21d3ef79f6d4$var$BIPPath.fromPathArray = function(path) {
    return new $4f3a21d3ef79f6d4$var$BIPPath(path);
};
$4f3a21d3ef79f6d4$var$BIPPath.fromString = function(text, reqRoot) {
    // skip the root
    if (/^m\//i.test(text)) text = text.slice(2);
    else if (reqRoot) throw new Error("Root element is required");
    var path = text.split("/");
    var ret = new Array(path.length);
    for(var i = 0; i < path.length; i++){
        var tmp = /(\d+)([hH\']?)/.exec(path[i]);
        if (tmp === null) throw new Error("Invalid input");
        ret[i] = parseInt(tmp[1], 10);
        if (ret[i] >= $4f3a21d3ef79f6d4$var$HARDENED) throw new Error("Invalid child index");
        if (tmp[2] === "h" || tmp[2] === "H" || tmp[2] === "'") ret[i] += $4f3a21d3ef79f6d4$var$HARDENED;
        else if (tmp[2].length != 0) throw new Error("Invalid modifier");
    }
    return new $4f3a21d3ef79f6d4$var$BIPPath(ret);
};
$4f3a21d3ef79f6d4$var$BIPPath.prototype.toPathArray = function() {
    return this.path;
};
$4f3a21d3ef79f6d4$var$BIPPath.prototype.toString = function(noRoot, oldStyle) {
    var ret = new Array(this.path.length);
    for(var i = 0; i < this.path.length; i++){
        var tmp = this.path[i];
        if (tmp & $4f3a21d3ef79f6d4$var$HARDENED) ret[i] = (tmp & ~$4f3a21d3ef79f6d4$var$HARDENED) + (oldStyle ? "h" : "'");
        else ret[i] = tmp;
    }
    return (noRoot ? "" : "m/") + ret.join("/");
};
$4f3a21d3ef79f6d4$var$BIPPath.prototype.inspect = function() {
    return "BIPPath <" + this.toString() + ">";
};
$4f3a21d3ef79f6d4$exports = $4f3a21d3ef79f6d4$var$BIPPath;




var $ilnag = parcelRequire("ilnag");
var $2c8b12cb6eb67c46$require$Buffer = $ilnag.Buffer;
function $2c8b12cb6eb67c46$export$91b509509e9f8b52(paths) {
    var buffer = $2c8b12cb6eb67c46$require$Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach(function(element, index) {
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
function $2c8b12cb6eb67c46$export$dae4da1c913eeebb(path) {
    var pathElements = !path ? [] : $2c8b12cb6eb67c46$export$35caeff6b64c2b35(path);
    return $2c8b12cb6eb67c46$export$91b509509e9f8b52(pathElements);
}
function $2c8b12cb6eb67c46$export$6e27cd76987a4ce2(pathElements) {
    // Limitation: bippath can't handle and empty path. It shouldn't affect us
    // right now, but might in the future.
    // TODO: Fix support for empty path.
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f3a21d3ef79f6d4$exports))).fromPathArray(pathElements).toString();
}
function $2c8b12cb6eb67c46$export$35caeff6b64c2b35(path) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f3a21d3ef79f6d4$exports))).fromString(path).toPathArray();
}
function $2c8b12cb6eb67c46$export$133bb17506582e39(xpub) {
    var xpubBuf = (0, (/*@__PURE__*/$parcel$interopDefault($3edaade963281bc2$exports))).decode(xpub);
    return xpubBuf.slice(xpubBuf.length - 33);
}
function $2c8b12cb6eb67c46$export$8bb2dc8ba35445c6(xpub) {
    var xpubBuf = (0, (/*@__PURE__*/$parcel$interopDefault($3edaade963281bc2$exports))).decode(xpub);
    return {
        chaincode: xpubBuf.slice(13, 45),
        pubkey: xpubBuf.slice(xpubBuf.length - 33),
        version: xpubBuf.readUInt32BE(0)
    };
}
function $2c8b12cb6eb67c46$export$cc16963b25268381(pathElements) {
    for(var i = pathElements.length - 1; i >= 0; i--){
        if (pathElements[i] >= 0x80000000) return pathElements.slice(0, i + 1);
    }
    return [];
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");


var $ilnag = parcelRequire("ilnag");
var $9c8c78117b026d4b$require$Buffer = $ilnag.Buffer;
function $9c8c78117b026d4b$export$8ccb8fa75d191fb7(n) {
    // we want to represent the input as a 8-bytes array
    if (n > Number.MAX_SAFE_INTEGER) throw new Error("Can't convert numbers > MAX_SAFE_INT");
    var byteArray = $9c8c78117b026d4b$require$Buffer.alloc(8, 0);
    for(var index = 0; index < byteArray.length; index++){
        var byte = n & 0xff;
        byteArray[index] = byte;
        n = (n - byte) / 256;
    }
    return byteArray;
}
function $9c8c78117b026d4b$export$cbe6b25937ae0aed(byteArray) {
    var value = 0;
    if (byteArray.length != 8) throw new Error("Expected Bufffer of lenght 8");
    if (byteArray[7] != 0) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (byteArray[6] > 0x1f) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for(var i = byteArray.length - 1; i >= 0; i--)value = value * 256 + byteArray[i];
    return value;
}
var $9c8c78117b026d4b$export$67649df22d9ca0ab = /*#__PURE__*/ function() {
    "use strict";
    function BufferWriter() {
        (0, $7dKN1._)(this, BufferWriter);
        this.bufs = [];
    }
    (0, $eW5pA._)(BufferWriter, [
        {
            key: "write",
            value: function write(alloc, fn) {
                var b = $9c8c78117b026d4b$require$Buffer.alloc(alloc);
                fn(b);
                this.bufs.push(b);
            }
        },
        {
            key: "writeUInt8",
            value: function writeUInt8(i) {
                this.write(1, function(b) {
                    return b.writeUInt8(i, 0);
                });
            }
        },
        {
            key: "writeInt32",
            value: function writeInt32(i) {
                this.write(4, function(b) {
                    return b.writeInt32LE(i, 0);
                });
            }
        },
        {
            key: "writeUInt32",
            value: function writeUInt32(i) {
                this.write(4, function(b) {
                    return b.writeUInt32LE(i, 0);
                });
            }
        },
        {
            key: "writeUInt64",
            value: function writeUInt64(i) {
                var bytes = $9c8c78117b026d4b$export$8ccb8fa75d191fb7(i);
                this.writeSlice(bytes);
            }
        },
        {
            key: "writeVarInt",
            value: function writeVarInt(i) {
                this.bufs.push((0, (/*@__PURE__*/$parcel$interopDefault($3aab16f2bcaeeed2$exports))).encode(i));
            }
        },
        {
            key: "writeSlice",
            value: function writeSlice(slice) {
                this.bufs.push($9c8c78117b026d4b$require$Buffer.from(slice));
            }
        },
        {
            key: "writeVarSlice",
            value: function writeVarSlice(slice) {
                this.writeVarInt(slice.length);
                this.writeSlice(slice);
            }
        },
        {
            key: "buffer",
            value: function buffer() {
                return $9c8c78117b026d4b$require$Buffer.concat(this.bufs);
            }
        }
    ]);
    return BufferWriter;
}();
var $9c8c78117b026d4b$export$bd4917b7431e3e00 = /*#__PURE__*/ function() {
    "use strict";
    function BufferReader(buffer) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $7dKN1._)(this, BufferReader);
        this.buffer = buffer;
        this.offset = offset;
    }
    (0, $eW5pA._)(BufferReader, [
        {
            key: "available",
            value: function available() {
                return this.buffer.length - this.offset;
            }
        },
        {
            key: "readUInt8",
            value: function readUInt8() {
                var result = this.buffer.readUInt8(this.offset);
                this.offset++;
                return result;
            }
        },
        {
            key: "readInt32",
            value: function readInt32() {
                var result = this.buffer.readInt32LE(this.offset);
                this.offset += 4;
                return result;
            }
        },
        {
            key: "readUInt32",
            value: function readUInt32() {
                var result = this.buffer.readUInt32LE(this.offset);
                this.offset += 4;
                return result;
            }
        },
        {
            key: "readUInt64",
            value: function readUInt64() {
                var buf = this.readSlice(8);
                var n = $9c8c78117b026d4b$export$cbe6b25937ae0aed(buf);
                return n;
            }
        },
        {
            key: "readVarInt",
            value: function readVarInt() {
                var vi = (0, (/*@__PURE__*/$parcel$interopDefault($3aab16f2bcaeeed2$exports))).decode(this.buffer, this.offset);
                this.offset += (0, (/*@__PURE__*/$parcel$interopDefault($3aab16f2bcaeeed2$exports))).decode.bytes;
                return vi;
            }
        },
        {
            key: "readSlice",
            value: function readSlice(n) {
                if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
                var result = this.buffer.slice(this.offset, this.offset + n);
                this.offset += n;
                return result;
            }
        },
        {
            key: "readVarSlice",
            value: function readVarSlice() {
                return this.readSlice(this.readVarInt());
            }
        },
        {
            key: "readVector",
            value: function readVector() {
                var count = this.readVarInt();
                var vector = [];
                for(var i = 0; i < count; i++)vector.push(this.readVarSlice());
                return vector;
            }
        }
    ]);
    return BufferReader;
}();



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



// the maximum number of bytes allowed in a single chunk when processing bitcoin script data.
// if the Bitcoin script is too large, we will process it in several chunks.
var $163b3efa8595af0e$export$53184d0ac57d9130 = 50;
var $163b3efa8595af0e$export$363ebe89e6e7aeef = 1;
var $163b3efa8595af0e$export$7e0b52e7059ffec7 = 0;
var $163b3efa8595af0e$export$57fe8370989728bf = 0xffffffff;
var $163b3efa8595af0e$export$f53d15270899011f = 1;
var $163b3efa8595af0e$export$df6efc3aa949001c = 0x76;
var $163b3efa8595af0e$export$25244e17dfd6169b = 0xa9;
var $163b3efa8595af0e$export$259fba643ee77695 = 0x14;
var $163b3efa8595af0e$export$5459033a849d318 = 0x87;
var $163b3efa8595af0e$export$f8b5c605020bd49c = 0x88;
var $163b3efa8595af0e$export$dc70dbf3545af7b7 = 0xac;
var $163b3efa8595af0e$export$713f182313880dec = 0x6a;



var $aEC5U = parcelRequire("aEC5U");

var $fXOt1 = parcelRequire("fXOt1");
function $e9d59204e9a7b588$export$4f1687fa25e5df17(buffer) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($aEC5U)))().update((0, (/*@__PURE__*/$parcel$interopDefault($fXOt1)))("sha256").update(buffer).digest()).digest();
}



var $ilnag = parcelRequire("ilnag");
var $5cb0e8ce7eee2a4b$require$Buffer = $ilnag.Buffer;
var $5cb0e8ce7eee2a4b$var$BaseAccount = function BaseAccount(psbt, masterFp) {
    "use strict";
    (0, $7dKN1._)(this, BaseAccount);
    this.psbt = psbt;
    this.masterFp = masterFp;
};
/**
 * Superclass for single signature accounts. This will make sure that the pubkey
 * arrays and path arrays in the method arguments contains exactly one element
 * and calls an abstract method to do the actual work.
 */ var $5cb0e8ce7eee2a4b$var$SingleKeyAccount = /*#__PURE__*/ function(BaseAccount) {
    "use strict";
    (0, $cgJ2Y._)(SingleKeyAccount, BaseAccount);
    var _super = (0, $hKD8n._)(SingleKeyAccount);
    function SingleKeyAccount() {
        (0, $7dKN1._)(this, SingleKeyAccount);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(SingleKeyAccount, [
        {
            key: "spendingCondition",
            value: function spendingCondition(pubkeys) {
                if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
                return this.singleKeyCondition(pubkeys[0]);
            }
        },
        {
            key: "setInput",
            value: function setInput(i, inputTx, spentOutput, pubkeys, pathElems) {
                if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
                if (pathElems.length != 1) throw new Error("Expected single path, got " + pathElems.length);
                this.setSingleKeyInput(i, inputTx, spentOutput, pubkeys[0], pathElems[0]);
            }
        },
        {
            key: "setOwnOutput",
            value: function setOwnOutput(i, cond, pubkeys, paths) {
                if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
                if (paths.length != 1) throw new Error("Expected single path, got " + paths.length);
                this.setSingleKeyOutput(i, cond, pubkeys[0], paths[0]);
            }
        }
    ]);
    return SingleKeyAccount;
}($5cb0e8ce7eee2a4b$var$BaseAccount);
var $5cb0e8ce7eee2a4b$export$864e513602cf2381 = /*#__PURE__*/ function(SingleKeyAccount) {
    "use strict";
    (0, $cgJ2Y._)(p2pkh, SingleKeyAccount);
    var _super = (0, $hKD8n._)(p2pkh);
    function p2pkh() {
        (0, $7dKN1._)(this, p2pkh);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(p2pkh, [
        {
            key: "singleKeyCondition",
            value: function singleKeyCondition(pubkey) {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                var pubkeyHash = (0, $e9d59204e9a7b588$export$4f1687fa25e5df17)(pubkey);
                buf.writeSlice($5cb0e8ce7eee2a4b$require$Buffer.from([
                    (0, $163b3efa8595af0e$export$df6efc3aa949001c),
                    (0, $163b3efa8595af0e$export$25244e17dfd6169b),
                    (0, $163b3efa8595af0e$export$259fba643ee77695)
                ]));
                buf.writeSlice(pubkeyHash);
                buf.writeSlice($5cb0e8ce7eee2a4b$require$Buffer.from([
                    (0, $163b3efa8595af0e$export$f8b5c605020bd49c),
                    (0, $163b3efa8595af0e$export$dc70dbf3545af7b7)
                ]));
                return {
                    scriptPubKey: buf.buffer()
                };
            }
        },
        {
            key: "setSingleKeyInput",
            value: function setSingleKeyInput(i, inputTx, _spentOutput, pubkey, path) {
                if (!inputTx) throw new Error("Full input base transaction required");
                this.psbt.setInputNonWitnessUtxo(i, inputTx);
                this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
            }
        },
        {
            key: "setSingleKeyOutput",
            value: function setSingleKeyOutput(i, cond, pubkey, path) {
                this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
            }
        },
        {
            key: "getDescriptorTemplate",
            value: function getDescriptorTemplate() {
                return "pkh(@0)";
            }
        }
    ]);
    return p2pkh;
}($5cb0e8ce7eee2a4b$var$SingleKeyAccount);
var $5cb0e8ce7eee2a4b$export$12d04d0fe56ae53 = /*#__PURE__*/ function(SingleKeyAccount) {
    "use strict";
    (0, $cgJ2Y._)(p2tr, SingleKeyAccount);
    var _super = (0, $hKD8n._)(p2tr);
    function p2tr() {
        (0, $7dKN1._)(this, p2tr);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(p2tr, [
        {
            key: "singleKeyCondition",
            value: function singleKeyCondition(pubkey) {
                var xonlyPubkey = pubkey.slice(1); // x-only pubkey
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                var outputKey = this.getTaprootOutputKey(xonlyPubkey);
                buf.writeSlice($5cb0e8ce7eee2a4b$require$Buffer.from([
                    0x51,
                    32
                ])); // push1, pubkeylen
                buf.writeSlice(outputKey);
                return {
                    scriptPubKey: buf.buffer()
                };
            }
        },
        {
            key: "setSingleKeyInput",
            value: function setSingleKeyInput(i, _inputTx, spentOutput, pubkey, path) {
                var xonly = pubkey.slice(1);
                this.psbt.setInputTapBip32Derivation(i, xonly, [], this.masterFp, path);
                this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
            }
        },
        {
            key: "setSingleKeyOutput",
            value: function setSingleKeyOutput(i, cond, pubkey, path) {
                var xonly = pubkey.slice(1);
                this.psbt.setOutputTapBip32Derivation(i, xonly, [], this.masterFp, path);
            }
        },
        {
            key: "getDescriptorTemplate",
            value: function getDescriptorTemplate() {
                return "tr(@0)";
            }
        },
        {
            /*
    The following two functions are copied from wallet-btc and adapted.
    They should be moved to a library to avoid code reuse.
    */ key: "hashTapTweak",
            value: function hashTapTweak(x) {
                // hash_tag(x) = SHA256(SHA256(tag) || SHA256(tag) || x), see BIP340
                // See https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki#specification
                var h = (0, $9ce982a108f9bffc$exports.crypto).sha256($5cb0e8ce7eee2a4b$require$Buffer.from("TapTweak", "utf-8"));
                return (0, $9ce982a108f9bffc$exports.crypto).sha256($5cb0e8ce7eee2a4b$require$Buffer.concat([
                    h,
                    h,
                    x
                ]));
            }
        },
        {
            /**
     * Calculates a taproot output key from an internal key. This output key will be
     * used as witness program in a taproot output. The internal key is tweaked
     * according to recommendation in BIP341:
     * https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_ref-22-0
     *
     * @param internalPubkey A 32 byte x-only taproot internal key
     * @returns The output key
     */ key: "getTaprootOutputKey",
            value: function getTaprootOutputKey(internalPubkey) {
                if (internalPubkey.length != 32) throw new Error("Expected 32 byte pubkey. Got " + internalPubkey.length);
                // A BIP32 derived key can be converted to a schnorr pubkey by dropping
                // the first byte, which represent the oddness/evenness. In schnorr all
                // pubkeys are even.
                // https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki#public-key-conversion
                var evenEcdsaPubkey = $5cb0e8ce7eee2a4b$require$Buffer.concat([
                    $5cb0e8ce7eee2a4b$require$Buffer.from([
                        0x02
                    ]),
                    internalPubkey
                ]);
                var tweak = this.hashTapTweak(internalPubkey);
                // Q = P + int(hash_TapTweak(bytes(P)))G
                var outputEcdsaKey = $5cb0e8ce7eee2a4b$require$Buffer.from((0, $a051056425522516$exports.pointAddScalar)(evenEcdsaPubkey, tweak));
                // Convert to schnorr.
                var outputSchnorrKey = outputEcdsaKey.slice(1);
                // Create address
                return outputSchnorrKey;
            }
        }
    ]);
    return p2tr;
}($5cb0e8ce7eee2a4b$var$SingleKeyAccount);
var $5cb0e8ce7eee2a4b$export$efcc171358cfcc7d = /*#__PURE__*/ function(SingleKeyAccount) {
    "use strict";
    (0, $cgJ2Y._)(p2wpkhWrapped, SingleKeyAccount);
    var _super = (0, $hKD8n._)(p2wpkhWrapped);
    function p2wpkhWrapped() {
        (0, $7dKN1._)(this, p2wpkhWrapped);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(p2wpkhWrapped, [
        {
            key: "singleKeyCondition",
            value: function singleKeyCondition(pubkey) {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                var redeemScript = this.createRedeemScript(pubkey);
                var scriptHash = (0, $e9d59204e9a7b588$export$4f1687fa25e5df17)(redeemScript);
                buf.writeSlice($5cb0e8ce7eee2a4b$require$Buffer.from([
                    (0, $163b3efa8595af0e$export$25244e17dfd6169b),
                    (0, $163b3efa8595af0e$export$259fba643ee77695)
                ]));
                buf.writeSlice(scriptHash);
                buf.writeUInt8((0, $163b3efa8595af0e$export$5459033a849d318));
                return {
                    scriptPubKey: buf.buffer(),
                    redeemScript: redeemScript
                };
            }
        },
        {
            key: "setSingleKeyInput",
            value: function setSingleKeyInput(i, inputTx, spentOutput, pubkey, path) {
                if (!inputTx) throw new Error("Full input base transaction required");
                this.psbt.setInputNonWitnessUtxo(i, inputTx);
                this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
                var userSuppliedRedeemScript = spentOutput.cond.redeemScript;
                var expectedRedeemScript = this.createRedeemScript(pubkey);
                if (userSuppliedRedeemScript && !expectedRedeemScript.equals(userSuppliedRedeemScript)) // At what point might a user set the redeemScript on its own?
                throw new Error("User-supplied redeemScript ".concat(userSuppliedRedeemScript.toString("hex"), " doesn't\n       match expected ").concat(expectedRedeemScript.toString("hex"), " for input ").concat(i));
                this.psbt.setInputRedeemScript(i, expectedRedeemScript);
                this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
            }
        },
        {
            key: "setSingleKeyOutput",
            value: function setSingleKeyOutput(i, cond, pubkey, path) {
                this.psbt.setOutputRedeemScript(i, cond.redeemScript);
                this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
            }
        },
        {
            key: "getDescriptorTemplate",
            value: function getDescriptorTemplate() {
                return "sh(wpkh(@0))";
            }
        },
        {
            key: "createRedeemScript",
            value: function createRedeemScript(pubkey) {
                var pubkeyHash = (0, $e9d59204e9a7b588$export$4f1687fa25e5df17)(pubkey);
                return $5cb0e8ce7eee2a4b$require$Buffer.concat([
                    $5cb0e8ce7eee2a4b$require$Buffer.from("0014", "hex"),
                    pubkeyHash
                ]);
            }
        }
    ]);
    return p2wpkhWrapped;
}($5cb0e8ce7eee2a4b$var$SingleKeyAccount);
var $5cb0e8ce7eee2a4b$export$5126746498e32b4b = /*#__PURE__*/ function(SingleKeyAccount) {
    "use strict";
    (0, $cgJ2Y._)(p2wpkh, SingleKeyAccount);
    var _super = (0, $hKD8n._)(p2wpkh);
    function p2wpkh() {
        (0, $7dKN1._)(this, p2wpkh);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(p2wpkh, [
        {
            key: "singleKeyCondition",
            value: function singleKeyCondition(pubkey) {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                var pubkeyHash = (0, $e9d59204e9a7b588$export$4f1687fa25e5df17)(pubkey);
                buf.writeSlice($5cb0e8ce7eee2a4b$require$Buffer.from([
                    0,
                    (0, $163b3efa8595af0e$export$259fba643ee77695)
                ]));
                buf.writeSlice(pubkeyHash);
                return {
                    scriptPubKey: buf.buffer()
                };
            }
        },
        {
            key: "setSingleKeyInput",
            value: function setSingleKeyInput(i, inputTx, spentOutput, pubkey, path) {
                if (!inputTx) throw new Error("Full input base transaction required");
                this.psbt.setInputNonWitnessUtxo(i, inputTx);
                this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
                this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
            }
        },
        {
            key: "setSingleKeyOutput",
            value: function setSingleKeyOutput(i, cond, pubkey, path) {
                this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
            }
        },
        {
            key: "getDescriptorTemplate",
            value: function getDescriptorTemplate() {
                return "wpkh(@0)";
            }
        }
    ]);
    return p2wpkh;
}($5cb0e8ce7eee2a4b$var$SingleKeyAccount);



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");




var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $gF0bR = parcelRequire("gF0bR");


var $ilnag = parcelRequire("ilnag");
var $45fa351ddc777738$require$Buffer = $ilnag.Buffer;
var $45fa351ddc777738$export$987d21b768c89d26 = /*#__PURE__*/ function() {
    "use strict";
    function Merkle(leaves) {
        var hasher = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $9ce982a108f9bffc$exports.crypto).sha256;
        (0, $7dKN1._)(this, Merkle);
        this.leaves = leaves;
        this.h = hasher;
        var nodes = this.calculateRoot(leaves);
        this.rootNode = nodes.root;
        this.leafNodes = nodes.leaves;
    }
    (0, $eW5pA._)(Merkle, [
        {
            key: "getRoot",
            value: function getRoot() {
                return this.rootNode.hash;
            }
        },
        {
            key: "size",
            value: function size() {
                return this.leaves.length;
            }
        },
        {
            key: "getLeaves",
            value: function getLeaves() {
                return this.leaves;
            }
        },
        {
            key: "getLeafHash",
            value: function getLeafHash(index) {
                return this.leafNodes[index].hash;
            }
        },
        {
            key: "getProof",
            value: function getProof(index) {
                if (index >= this.leaves.length) throw Error("Index out of bounds");
                return $45fa351ddc777738$var$proveNode(this.leafNodes[index]);
            }
        },
        {
            key: "calculateRoot",
            value: function calculateRoot(leaves) {
                var n = leaves.length;
                if (n == 0) return {
                    root: new $45fa351ddc777738$var$Node(undefined, undefined, $45fa351ddc777738$require$Buffer.alloc(32, 0)),
                    leaves: []
                };
                if (n == 1) {
                    var newNode = new $45fa351ddc777738$var$Node(undefined, undefined, leaves[0]);
                    return {
                        root: newNode,
                        leaves: [
                            newNode
                        ]
                    };
                }
                var leftCount = $45fa351ddc777738$var$highestPowerOf2LessThan(n);
                var leftBranch = this.calculateRoot(leaves.slice(0, leftCount));
                var rightBranch = this.calculateRoot(leaves.slice(leftCount));
                var leftChild = leftBranch.root;
                var rightChild = rightBranch.root;
                var hash = this.hashNode(leftChild.hash, rightChild.hash);
                var node = new $45fa351ddc777738$var$Node(leftChild, rightChild, hash);
                leftChild.parent = node;
                rightChild.parent = node;
                return {
                    root: node,
                    leaves: leftBranch.leaves.concat(rightBranch.leaves)
                };
            }
        },
        {
            key: "hashNode",
            value: function hashNode(left, right) {
                return this.h($45fa351ddc777738$require$Buffer.concat([
                    $45fa351ddc777738$require$Buffer.from([
                        1
                    ]),
                    left,
                    right
                ]));
            }
        }
    ]);
    return Merkle;
}();
function $45fa351ddc777738$export$bc68c1df7778232a(buf) {
    var hashFunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $9ce982a108f9bffc$exports.crypto).sha256;
    return $45fa351ddc777738$var$hashConcat($45fa351ddc777738$require$Buffer.from([
        0
    ]), buf, hashFunction);
}
function $45fa351ddc777738$var$hashConcat(bufA, bufB, hashFunction) {
    return hashFunction($45fa351ddc777738$require$Buffer.concat([
        bufA,
        bufB
    ]));
}
var $45fa351ddc777738$var$Node = /*#__PURE__*/ function() {
    "use strict";
    function Node(left, right, hash) {
        (0, $7dKN1._)(this, Node);
        this.leftChild = left;
        this.rightChild = right;
        this.hash = hash;
    }
    (0, $eW5pA._)(Node, [
        {
            key: "isLeaf",
            value: function isLeaf() {
                return this.leftChild == undefined;
            }
        }
    ]);
    return Node;
}();
function $45fa351ddc777738$var$proveNode(node) {
    if (!node.parent) return [];
    if (node.parent.leftChild == node) {
        if (!node.parent.rightChild) throw new Error("Expected right child to exist");
        return [
            node.parent.rightChild.hash
        ].concat((0, $gF0bR._)($45fa351ddc777738$var$proveNode(node.parent)));
    } else {
        if (!node.parent.leftChild) throw new Error("Expected left child to exist");
        return [
            node.parent.leftChild.hash
        ].concat((0, $gF0bR._)($45fa351ddc777738$var$proveNode(node.parent)));
    }
}
function $45fa351ddc777738$var$highestPowerOf2LessThan(n) {
    if (n < 2) throw Error("Expected n >= 2");
    if ($45fa351ddc777738$var$isPowerOf2(n)) return n / 2;
    return 1 << Math.floor(Math.log2(n));
}
function $45fa351ddc777738$var$isPowerOf2(n) {
    return (n & n - 1) == 0;
}



var $ilnag = parcelRequire("ilnag");
var $8d3c12c8c0797031$require$Buffer = $ilnag.Buffer;
var $8d3c12c8c0797031$export$7dabddf99c50dec7 = /*#__PURE__*/ function() {
    "use strict";
    function WalletPolicy(descriptorTemplate, key) {
        (0, $7dKN1._)(this, WalletPolicy);
        this.descriptorTemplate = descriptorTemplate;
        this.keys = [
            key
        ];
    }
    (0, $eW5pA._)(WalletPolicy, [
        {
            key: "getWalletId",
            value: function getWalletId() {
                // wallet_id (sha256 of the wallet serialization),
                return (0, $9ce982a108f9bffc$exports.crypto).sha256(this.serialize());
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var keyBuffers = this.keys.map(function(k) {
                    return $8d3c12c8c0797031$require$Buffer.from(k, "ascii");
                });
                var m = new (0, $45fa351ddc777738$export$987d21b768c89d26)(keyBuffers.map(function(k) {
                    return (0, $45fa351ddc777738$export$bc68c1df7778232a)(k);
                }));
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                buf.writeUInt8(0x01); // wallet type (policy map)
                buf.writeUInt8(0); // length of wallet name (empty string for default wallets)
                buf.writeVarSlice($8d3c12c8c0797031$require$Buffer.from(this.descriptorTemplate, "ascii"));
                buf.writeVarInt(this.keys.length), buf.writeSlice(m.getRoot());
                return buf.buffer();
            }
        }
    ]);
    return WalletPolicy;
}();
function $8d3c12c8c0797031$export$e2280c1995141b13(masterFingerprint, path, xpub) {
    var accountPath = (0, $2c8b12cb6eb67c46$export$6e27cd76987a4ce2)(path);
    return "[".concat(masterFingerprint.toString("hex")).concat(accountPath.substring(1), "]").concat(xpub, "/**");
}




var $ilnag = parcelRequire("ilnag");
var $06b08d9151e6bdb8$require$Buffer = $ilnag.Buffer;
function $06b08d9151e6bdb8$export$f9380c9a627682d3(psbt) {
    var _a, _b;
    var tx = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
    tx.writeUInt32(psbt.getGlobalTxVersion());
    var isSegwit = !!psbt.getInputWitnessUtxo(0);
    if (isSegwit) tx.writeSlice($06b08d9151e6bdb8$require$Buffer.from([
        0,
        1
    ]));
    var inputCount = psbt.getGlobalInputCount();
    tx.writeVarInt(inputCount);
    var witnessWriter = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
    for(var i = 0; i < inputCount; i++){
        tx.writeSlice(psbt.getInputPreviousTxid(i));
        tx.writeUInt32(psbt.getInputOutputIndex(i));
        tx.writeVarSlice((_a = psbt.getInputFinalScriptsig(i)) !== null && _a !== void 0 ? _a : $06b08d9151e6bdb8$require$Buffer.from([]));
        tx.writeUInt32(psbt.getInputSequence(i));
        if (isSegwit) witnessWriter.writeSlice(psbt.getInputFinalScriptwitness(i));
    }
    var outputCount = psbt.getGlobalOutputCount();
    tx.writeVarInt(outputCount);
    for(var i1 = 0; i1 < outputCount; i1++){
        tx.writeUInt64(psbt.getOutputAmount(i1));
        tx.writeVarSlice(psbt.getOutputScript(i1));
    }
    tx.writeSlice(witnessWriter.buffer());
    tx.writeUInt32((_b = psbt.getGlobalFallbackLocktime()) !== null && _b !== void 0 ? _b : 0);
    return tx.buffer();
}



/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 
var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");


var $ilnag = parcelRequire("ilnag");
var $8ac540c119cbea8e$require$Buffer = $ilnag.Buffer;
var $8ac540c119cbea8e$export$51f4a0bcfde23fa;
(function(psbtGlobal) {
    psbtGlobal[psbtGlobal["TX_VERSION"] = 2] = "TX_VERSION";
    psbtGlobal[psbtGlobal["FALLBACK_LOCKTIME"] = 3] = "FALLBACK_LOCKTIME";
    psbtGlobal[psbtGlobal["INPUT_COUNT"] = 4] = "INPUT_COUNT";
    psbtGlobal[psbtGlobal["OUTPUT_COUNT"] = 5] = "OUTPUT_COUNT";
    psbtGlobal[psbtGlobal["TX_MODIFIABLE"] = 6] = "TX_MODIFIABLE";
    psbtGlobal[psbtGlobal["VERSION"] = 251] = "VERSION";
})($8ac540c119cbea8e$export$51f4a0bcfde23fa || ($8ac540c119cbea8e$export$51f4a0bcfde23fa = {}));
var $8ac540c119cbea8e$export$835161b70055ac87;
(function(psbtIn) {
    psbtIn[psbtIn["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    psbtIn[psbtIn["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    psbtIn[psbtIn["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    psbtIn[psbtIn["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    psbtIn[psbtIn["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    psbtIn[psbtIn["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    psbtIn[psbtIn["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    psbtIn[psbtIn["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    psbtIn[psbtIn["PREVIOUS_TXID"] = 14] = "PREVIOUS_TXID";
    psbtIn[psbtIn["OUTPUT_INDEX"] = 15] = "OUTPUT_INDEX";
    psbtIn[psbtIn["SEQUENCE"] = 16] = "SEQUENCE";
    psbtIn[psbtIn["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    psbtIn[psbtIn["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
})($8ac540c119cbea8e$export$835161b70055ac87 || ($8ac540c119cbea8e$export$835161b70055ac87 = {}));
var $8ac540c119cbea8e$export$a0c38500664f371;
(function(psbtOut) {
    psbtOut[psbtOut["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    psbtOut[psbtOut["BIP_32_DERIVATION"] = 2] = "BIP_32_DERIVATION";
    psbtOut[psbtOut["AMOUNT"] = 3] = "AMOUNT";
    psbtOut[psbtOut["SCRIPT"] = 4] = "SCRIPT";
    psbtOut[psbtOut["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($8ac540c119cbea8e$export$a0c38500664f371 || ($8ac540c119cbea8e$export$a0c38500664f371 = {}));
var $8ac540c119cbea8e$var$PSBT_MAGIC_BYTES = $8ac540c119cbea8e$require$Buffer.from([
    0x70,
    0x73,
    0x62,
    0x74,
    0xff
]);
var $8ac540c119cbea8e$export$9192c04a9e9ddc4d = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(NoSuchEntry, Error1);
    var _super = (0, $hKD8n._)(NoSuchEntry);
    function NoSuchEntry() {
        (0, $7dKN1._)(this, NoSuchEntry);
        return _super.apply(this, arguments);
    }
    return NoSuchEntry;
}((0, $jShW9._)(Error));
var $8ac540c119cbea8e$export$df421e92e1e77f5 = /*#__PURE__*/ function() {
    "use strict";
    function PsbtV2() {
        (0, $7dKN1._)(this, PsbtV2);
        this.globalMap = new Map();
        this.inputMaps = [];
        this.outputMaps = [];
    }
    (0, $eW5pA._)(PsbtV2, [
        {
            key: "setGlobalTxVersion",
            value: function setGlobalTxVersion(version) {
                this.setGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.TX_VERSION, $8ac540c119cbea8e$var$uint32LE(version));
            }
        },
        {
            key: "getGlobalTxVersion",
            value: function getGlobalTxVersion() {
                return this.getGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.TX_VERSION).readUInt32LE(0);
            }
        },
        {
            key: "setGlobalFallbackLocktime",
            value: function setGlobalFallbackLocktime(locktime) {
                this.setGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.FALLBACK_LOCKTIME, $8ac540c119cbea8e$var$uint32LE(locktime));
            }
        },
        {
            key: "getGlobalFallbackLocktime",
            value: function getGlobalFallbackLocktime() {
                var _a;
                return (_a = this.getGlobalOptional($8ac540c119cbea8e$export$51f4a0bcfde23fa.FALLBACK_LOCKTIME)) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0);
            }
        },
        {
            key: "setGlobalInputCount",
            value: function setGlobalInputCount(inputCount) {
                this.setGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.INPUT_COUNT, $8ac540c119cbea8e$var$varint(inputCount));
            }
        },
        {
            key: "getGlobalInputCount",
            value: function getGlobalInputCount() {
                return $8ac540c119cbea8e$var$fromVarint(this.getGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.INPUT_COUNT));
            }
        },
        {
            key: "setGlobalOutputCount",
            value: function setGlobalOutputCount(outputCount) {
                this.setGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.OUTPUT_COUNT, $8ac540c119cbea8e$var$varint(outputCount));
            }
        },
        {
            key: "getGlobalOutputCount",
            value: function getGlobalOutputCount() {
                return $8ac540c119cbea8e$var$fromVarint(this.getGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.OUTPUT_COUNT));
            }
        },
        {
            key: "setGlobalTxModifiable",
            value: function setGlobalTxModifiable(byte) {
                this.setGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.TX_MODIFIABLE, byte);
            }
        },
        {
            key: "getGlobalTxModifiable",
            value: function getGlobalTxModifiable() {
                return this.getGlobalOptional($8ac540c119cbea8e$export$51f4a0bcfde23fa.TX_MODIFIABLE);
            }
        },
        {
            key: "setGlobalPsbtVersion",
            value: function setGlobalPsbtVersion(psbtVersion) {
                this.setGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.VERSION, $8ac540c119cbea8e$var$uint32LE(psbtVersion));
            }
        },
        {
            key: "getGlobalPsbtVersion",
            value: function getGlobalPsbtVersion() {
                return this.getGlobal($8ac540c119cbea8e$export$51f4a0bcfde23fa.VERSION).readUInt32LE(0);
            }
        },
        {
            key: "setInputNonWitnessUtxo",
            value: function setInputNonWitnessUtxo(inputIndex, transaction) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.NON_WITNESS_UTXO, $8ac540c119cbea8e$var$b(), transaction);
            }
        },
        {
            key: "getInputNonWitnessUtxo",
            value: function getInputNonWitnessUtxo(inputIndex) {
                return this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.NON_WITNESS_UTXO, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setInputWitnessUtxo",
            value: function setInputWitnessUtxo(inputIndex, amount, scriptPubKey) {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                buf.writeSlice(amount);
                buf.writeVarSlice(scriptPubKey);
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.WITNESS_UTXO, $8ac540c119cbea8e$var$b(), buf.buffer());
            }
        },
        {
            key: "getInputWitnessUtxo",
            value: function getInputWitnessUtxo(inputIndex) {
                var utxo = this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.WITNESS_UTXO, $8ac540c119cbea8e$var$b());
                if (!utxo) return undefined;
                var buf = new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(utxo);
                return {
                    amount: buf.readSlice(8),
                    scriptPubKey: buf.readVarSlice()
                };
            }
        },
        {
            key: "setInputPartialSig",
            value: function setInputPartialSig(inputIndex, pubkey, signature) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.PARTIAL_SIG, pubkey, signature);
            }
        },
        {
            key: "getInputPartialSig",
            value: function getInputPartialSig(inputIndex, pubkey) {
                return this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.PARTIAL_SIG, pubkey);
            }
        },
        {
            key: "setInputSighashType",
            value: function setInputSighashType(inputIndex, sigHashtype) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.SIGHASH_TYPE, $8ac540c119cbea8e$var$b(), $8ac540c119cbea8e$var$uint32LE(sigHashtype));
            }
        },
        {
            key: "getInputSighashType",
            value: function getInputSighashType(inputIndex) {
                var result = this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.SIGHASH_TYPE, $8ac540c119cbea8e$var$b());
                if (!result) return undefined;
                return result.readUInt32LE(0);
            }
        },
        {
            key: "setInputRedeemScript",
            value: function setInputRedeemScript(inputIndex, redeemScript) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.REDEEM_SCRIPT, $8ac540c119cbea8e$var$b(), redeemScript);
            }
        },
        {
            key: "getInputRedeemScript",
            value: function getInputRedeemScript(inputIndex) {
                return this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.REDEEM_SCRIPT, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setInputBip32Derivation",
            value: function setInputBip32Derivation(inputIndex, pubkey, masterFingerprint, path) {
                if (pubkey.length != 33) throw new Error("Invalid pubkey length: " + pubkey.length);
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.BIP32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
            }
        },
        {
            key: "getInputBip32Derivation",
            value: function getInputBip32Derivation(inputIndex, pubkey) {
                var buf = this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.BIP32_DERIVATION, pubkey);
                if (!buf) return undefined;
                return this.decodeBip32Derivation(buf);
            }
        },
        {
            key: "setInputFinalScriptsig",
            value: function setInputFinalScriptsig(inputIndex, scriptSig) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.FINAL_SCRIPTSIG, $8ac540c119cbea8e$var$b(), scriptSig);
            }
        },
        {
            key: "getInputFinalScriptsig",
            value: function getInputFinalScriptsig(inputIndex) {
                return this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.FINAL_SCRIPTSIG, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setInputFinalScriptwitness",
            value: function setInputFinalScriptwitness(inputIndex, scriptWitness) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.FINAL_SCRIPTWITNESS, $8ac540c119cbea8e$var$b(), scriptWitness);
            }
        },
        {
            key: "getInputFinalScriptwitness",
            value: function getInputFinalScriptwitness(inputIndex) {
                return this.getInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.FINAL_SCRIPTWITNESS, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setInputPreviousTxId",
            value: function setInputPreviousTxId(inputIndex, txid) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.PREVIOUS_TXID, $8ac540c119cbea8e$var$b(), txid);
            }
        },
        {
            key: "getInputPreviousTxid",
            value: function getInputPreviousTxid(inputIndex) {
                return this.getInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.PREVIOUS_TXID, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setInputOutputIndex",
            value: function setInputOutputIndex(inputIndex, outputIndex) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.OUTPUT_INDEX, $8ac540c119cbea8e$var$b(), $8ac540c119cbea8e$var$uint32LE(outputIndex));
            }
        },
        {
            key: "getInputOutputIndex",
            value: function getInputOutputIndex(inputIndex) {
                return this.getInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.OUTPUT_INDEX, $8ac540c119cbea8e$var$b()).readUInt32LE(0);
            }
        },
        {
            key: "setInputSequence",
            value: function setInputSequence(inputIndex, sequence) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.SEQUENCE, $8ac540c119cbea8e$var$b(), $8ac540c119cbea8e$var$uint32LE(sequence));
            }
        },
        {
            key: "getInputSequence",
            value: function getInputSequence(inputIndex) {
                var _a, _b;
                return (_b = (_a = this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.SEQUENCE, $8ac540c119cbea8e$var$b())) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0)) !== null && _b !== void 0 ? _b : 0xffffffff;
            }
        },
        {
            key: "setInputTapKeySig",
            value: function setInputTapKeySig(inputIndex, sig) {
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.TAP_KEY_SIG, $8ac540c119cbea8e$var$b(), sig);
            }
        },
        {
            key: "getInputTapKeySig",
            value: function getInputTapKeySig(inputIndex) {
                return this.getInputOptional(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.TAP_KEY_SIG, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setInputTapBip32Derivation",
            value: function setInputTapBip32Derivation(inputIndex, pubkey, hashes, masterFingerprint, path) {
                if (pubkey.length != 32) throw new Error("Invalid pubkey length: " + pubkey.length);
                var buf = this.encodeTapBip32Derivation(hashes, masterFingerprint, path);
                this.setInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.TAP_BIP32_DERIVATION, pubkey, buf);
            }
        },
        {
            key: "getInputTapBip32Derivation",
            value: function getInputTapBip32Derivation(inputIndex, pubkey) {
                var buf = this.getInput(inputIndex, $8ac540c119cbea8e$export$835161b70055ac87.TAP_BIP32_DERIVATION, pubkey);
                return this.decodeTapBip32Derivation(buf);
            }
        },
        {
            key: "getInputKeyDatas",
            value: function getInputKeyDatas(inputIndex, keyType) {
                return this.getKeyDatas(this.inputMaps[inputIndex], keyType);
            }
        },
        {
            key: "setOutputRedeemScript",
            value: function setOutputRedeemScript(outputIndex, redeemScript) {
                this.setOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.REDEEM_SCRIPT, $8ac540c119cbea8e$var$b(), redeemScript);
            }
        },
        {
            key: "getOutputRedeemScript",
            value: function getOutputRedeemScript(outputIndex) {
                return this.getOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.REDEEM_SCRIPT, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setOutputBip32Derivation",
            value: function setOutputBip32Derivation(outputIndex, pubkey, masterFingerprint, path) {
                this.setOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.BIP_32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
            }
        },
        {
            key: "getOutputBip32Derivation",
            value: function getOutputBip32Derivation(outputIndex, pubkey) {
                var buf = this.getOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.BIP_32_DERIVATION, pubkey);
                return this.decodeBip32Derivation(buf);
            }
        },
        {
            key: "setOutputAmount",
            value: function setOutputAmount(outputIndex, amount) {
                this.setOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.AMOUNT, $8ac540c119cbea8e$var$b(), $8ac540c119cbea8e$var$uint64LE(amount));
            }
        },
        {
            key: "getOutputAmount",
            value: function getOutputAmount(outputIndex) {
                var buf = this.getOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.AMOUNT, $8ac540c119cbea8e$var$b());
                return (0, $9c8c78117b026d4b$export$cbe6b25937ae0aed)(buf);
            }
        },
        {
            key: "setOutputScript",
            value: function setOutputScript(outputIndex, scriptPubKey) {
                this.setOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.SCRIPT, $8ac540c119cbea8e$var$b(), scriptPubKey);
            }
        },
        {
            key: "getOutputScript",
            value: function getOutputScript(outputIndex) {
                return this.getOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.SCRIPT, $8ac540c119cbea8e$var$b());
            }
        },
        {
            key: "setOutputTapBip32Derivation",
            value: function setOutputTapBip32Derivation(outputIndex, pubkey, hashes, fingerprint, path) {
                var buf = this.encodeTapBip32Derivation(hashes, fingerprint, path);
                this.setOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.TAP_BIP32_DERIVATION, pubkey, buf);
            }
        },
        {
            key: "getOutputTapBip32Derivation",
            value: function getOutputTapBip32Derivation(outputIndex, pubkey) {
                var buf = this.getOutput(outputIndex, $8ac540c119cbea8e$export$a0c38500664f371.TAP_BIP32_DERIVATION, pubkey);
                return this.decodeTapBip32Derivation(buf);
            }
        },
        {
            key: "deleteInputEntries",
            value: function deleteInputEntries(inputIndex, keyTypes) {
                var _this = this;
                var map = this.inputMaps[inputIndex];
                map.forEach(function(_v, k, m) {
                    if (_this.isKeyType(k, keyTypes)) m.delete(k);
                });
            }
        },
        {
            key: "copy",
            value: function copy(to) {
                this.copyMap(this.globalMap, to.globalMap);
                this.copyMaps(this.inputMaps, to.inputMaps);
                this.copyMaps(this.outputMaps, to.outputMaps);
            }
        },
        {
            key: "copyMaps",
            value: function copyMaps(from, to) {
                var _this = this;
                from.forEach(function(m, index) {
                    var to_index = new Map();
                    _this.copyMap(m, to_index);
                    to[index] = to_index;
                });
            }
        },
        {
            key: "copyMap",
            value: function copyMap(from, to) {
                from.forEach(function(v, k) {
                    return to.set(k, $8ac540c119cbea8e$require$Buffer.from(v));
                });
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                buf.writeSlice($8ac540c119cbea8e$require$Buffer.from([
                    0x70,
                    0x73,
                    0x62,
                    0x74,
                    0xff
                ]));
                $8ac540c119cbea8e$var$serializeMap(buf, this.globalMap);
                this.inputMaps.forEach(function(map) {
                    $8ac540c119cbea8e$var$serializeMap(buf, map);
                });
                this.outputMaps.forEach(function(map) {
                    $8ac540c119cbea8e$var$serializeMap(buf, map);
                });
                return buf.buffer();
            }
        },
        {
            key: "deserialize",
            value: function deserialize(psbt) {
                var buf = new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(psbt);
                if (!buf.readSlice(5).equals($8ac540c119cbea8e$var$PSBT_MAGIC_BYTES)) throw new Error("Invalid magic bytes");
                while(this.readKeyPair(this.globalMap, buf));
                for(var i = 0; i < this.getGlobalInputCount(); i++){
                    this.inputMaps[i] = new Map();
                    while(this.readKeyPair(this.inputMaps[i], buf));
                }
                for(var i1 = 0; i1 < this.getGlobalOutputCount(); i1++){
                    this.outputMaps[i1] = new Map();
                    while(this.readKeyPair(this.outputMaps[i1], buf));
                }
            }
        },
        {
            key: "readKeyPair",
            value: function readKeyPair(map, buf) {
                var keyLen = buf.readVarInt();
                if (keyLen == 0) return false;
                var keyType = buf.readUInt8();
                var keyData = buf.readSlice(keyLen - 1);
                var value = buf.readVarSlice();
                $8ac540c119cbea8e$var$set(map, keyType, keyData, value);
                return true;
            }
        },
        {
            key: "getKeyDatas",
            value: function getKeyDatas(map, keyType) {
                var _this = this;
                var result = [];
                map.forEach(function(_v, k) {
                    if (_this.isKeyType(k, [
                        keyType
                    ])) result.push($8ac540c119cbea8e$require$Buffer.from(k.substring(2), "hex"));
                });
                return result;
            }
        },
        {
            key: "isKeyType",
            value: function isKeyType(hexKey, keyTypes) {
                var keyType = $8ac540c119cbea8e$require$Buffer.from(hexKey.substring(0, 2), "hex").readUInt8(0);
                return keyTypes.some(function(k) {
                    return k == keyType;
                });
            }
        },
        {
            key: "setGlobal",
            value: function setGlobal(keyType, value) {
                var key = new $8ac540c119cbea8e$var$Key(keyType, $8ac540c119cbea8e$require$Buffer.from([]));
                this.globalMap.set(key.toString(), value);
            }
        },
        {
            key: "getGlobal",
            value: function getGlobal(keyType) {
                return $8ac540c119cbea8e$var$get(this.globalMap, keyType, $8ac540c119cbea8e$var$b(), false);
            }
        },
        {
            key: "getGlobalOptional",
            value: function getGlobalOptional(keyType) {
                return $8ac540c119cbea8e$var$get(this.globalMap, keyType, $8ac540c119cbea8e$var$b(), true);
            }
        },
        {
            key: "setInput",
            value: function setInput(index, keyType, keyData, value) {
                $8ac540c119cbea8e$var$set(this.getMap(index, this.inputMaps), keyType, keyData, value);
            }
        },
        {
            key: "getInput",
            value: function getInput(index, keyType, keyData) {
                return $8ac540c119cbea8e$var$get(this.inputMaps[index], keyType, keyData, false);
            }
        },
        {
            key: "getInputOptional",
            value: function getInputOptional(index, keyType, keyData) {
                return $8ac540c119cbea8e$var$get(this.inputMaps[index], keyType, keyData, true);
            }
        },
        {
            key: "setOutput",
            value: function setOutput(index, keyType, keyData, value) {
                $8ac540c119cbea8e$var$set(this.getMap(index, this.outputMaps), keyType, keyData, value);
            }
        },
        {
            key: "getOutput",
            value: function getOutput(index, keyType, keyData) {
                return $8ac540c119cbea8e$var$get(this.outputMaps[index], keyType, keyData, false);
            }
        },
        {
            key: "getMap",
            value: function getMap(index, maps) {
                if (maps[index]) return maps[index];
                return maps[index] = new Map();
            }
        },
        {
            key: "encodeBip32Derivation",
            value: function encodeBip32Derivation(masterFingerprint, path) {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                this.writeBip32Derivation(buf, masterFingerprint, path);
                return buf.buffer();
            }
        },
        {
            key: "decodeBip32Derivation",
            value: function decodeBip32Derivation(buffer) {
                var buf = new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(buffer);
                return this.readBip32Derivation(buf);
            }
        },
        {
            key: "writeBip32Derivation",
            value: function writeBip32Derivation(buf, masterFingerprint, path) {
                buf.writeSlice(masterFingerprint);
                path.forEach(function(element) {
                    buf.writeUInt32(element);
                });
            }
        },
        {
            key: "readBip32Derivation",
            value: function readBip32Derivation(buf) {
                var masterFingerprint = buf.readSlice(4);
                var path = [];
                while(buf.offset < buf.buffer.length)path.push(buf.readUInt32());
                return {
                    masterFingerprint: masterFingerprint,
                    path: path
                };
            }
        },
        {
            key: "encodeTapBip32Derivation",
            value: function encodeTapBip32Derivation(hashes, masterFingerprint, path) {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                buf.writeVarInt(hashes.length);
                hashes.forEach(function(h) {
                    buf.writeSlice(h);
                });
                this.writeBip32Derivation(buf, masterFingerprint, path);
                return buf.buffer();
            }
        },
        {
            key: "decodeTapBip32Derivation",
            value: function decodeTapBip32Derivation(buffer) {
                var buf = new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(buffer);
                var hashCount = buf.readVarInt();
                var hashes = [];
                for(var i = 0; i < hashCount; i++)hashes.push(buf.readSlice(32));
                var deriv = this.readBip32Derivation(buf);
                return Object.assign({
                    hashes: hashes
                }, deriv);
            }
        }
    ]);
    return PsbtV2;
}();
function $8ac540c119cbea8e$var$get(map, keyType, keyData, acceptUndefined) {
    if (!map) throw Error("No such map");
    var key = new $8ac540c119cbea8e$var$Key(keyType, keyData);
    var value = map.get(key.toString());
    if (!value) {
        if (acceptUndefined) return undefined;
        throw new $8ac540c119cbea8e$export$9192c04a9e9ddc4d(key.toString());
    }
    // Make sure to return a copy, to protect the underlying data.
    return $8ac540c119cbea8e$require$Buffer.from(value);
}
var $8ac540c119cbea8e$var$Key = /*#__PURE__*/ function() {
    "use strict";
    function Key(keyType, keyData) {
        (0, $7dKN1._)(this, Key);
        this.keyType = keyType;
        this.keyData = keyData;
    }
    (0, $eW5pA._)(Key, [
        {
            key: "toString",
            value: function toString() {
                var buf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                this.toBuffer(buf);
                return buf.buffer().toString("hex");
            }
        },
        {
            key: "serialize",
            value: function serialize(buf) {
                buf.writeVarInt(1 + this.keyData.length);
                this.toBuffer(buf);
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer(buf) {
                buf.writeUInt8(this.keyType);
                buf.writeSlice(this.keyData);
            }
        }
    ]);
    return Key;
}();
var $8ac540c119cbea8e$var$KeyPair = /*#__PURE__*/ function() {
    "use strict";
    function KeyPair(key, value) {
        (0, $7dKN1._)(this, KeyPair);
        this.key = key;
        this.value = value;
    }
    (0, $eW5pA._)(KeyPair, [
        {
            key: "serialize",
            value: function serialize(buf) {
                this.key.serialize(buf);
                buf.writeVarSlice(this.value);
            }
        }
    ]);
    return KeyPair;
}();
function $8ac540c119cbea8e$var$createKey(buf) {
    return new $8ac540c119cbea8e$var$Key(buf.readUInt8(0), buf.slice(1));
}
function $8ac540c119cbea8e$var$serializeMap(buf, map) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = map.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            var value = map.get(k);
            var keyPair = new $8ac540c119cbea8e$var$KeyPair($8ac540c119cbea8e$var$createKey($8ac540c119cbea8e$require$Buffer.from(k, "hex")), value);
            keyPair.serialize(buf);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    buf.writeUInt8(0);
}
function $8ac540c119cbea8e$var$b() {
    return $8ac540c119cbea8e$require$Buffer.from([]);
}
function $8ac540c119cbea8e$var$set(map, keyType, keyData, value) {
    var key = new $8ac540c119cbea8e$var$Key(keyType, keyData);
    map.set(key.toString(), value);
}
function $8ac540c119cbea8e$var$uint32LE(n) {
    var b = $8ac540c119cbea8e$require$Buffer.alloc(4);
    b.writeUInt32LE(n, 0);
    return b;
}
function $8ac540c119cbea8e$var$uint64LE(n) {
    return (0, $9c8c78117b026d4b$export$8ccb8fa75d191fb7)(n);
}
function $8ac540c119cbea8e$var$varint(n) {
    var b = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
    b.writeVarInt(n);
    return b.buffer();
}
function $8ac540c119cbea8e$var$fromVarint(buf) {
    return new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(buf).readVarInt();
}



var $ilnag = parcelRequire("ilnag");
var $975bf7ce1013542a$require$Buffer = $ilnag.Buffer;
function $975bf7ce1013542a$export$578723aef62d92f5(psbt) {
    // First check that each input has a signature
    var inputCount = psbt.getGlobalInputCount();
    for(var i = 0; i < inputCount; i++){
        var legacyPubkeys = psbt.getInputKeyDatas(i, (0, $8ac540c119cbea8e$export$835161b70055ac87).PARTIAL_SIG);
        var taprootSig = psbt.getInputTapKeySig(i);
        if (legacyPubkeys.length == 0 && !taprootSig) throw Error("No signature for input ".concat(i, " present"));
        if (legacyPubkeys.length > 0) {
            if (legacyPubkeys.length > 1) throw Error("Expected exactly one signature, got ".concat(legacyPubkeys.length));
            if (taprootSig) throw Error("Both taproot and non-taproot signatures present.");
            var isSegwitV0 = !!psbt.getInputWitnessUtxo(i);
            var redeemScript = psbt.getInputRedeemScript(i);
            var isWrappedSegwit = !!redeemScript;
            var signature = psbt.getInputPartialSig(i, legacyPubkeys[0]);
            if (!signature) throw new Error("Expected partial signature for input " + i);
            if (isSegwitV0) {
                var witnessBuf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                witnessBuf.writeVarInt(2);
                witnessBuf.writeVarInt(signature.length);
                witnessBuf.writeSlice(signature);
                witnessBuf.writeVarInt(legacyPubkeys[0].length);
                witnessBuf.writeSlice(legacyPubkeys[0]);
                psbt.setInputFinalScriptwitness(i, witnessBuf.buffer());
                if (isWrappedSegwit) {
                    if (!redeemScript || redeemScript.length == 0) throw new Error("Expected non-empty redeemscript. Can't finalize intput " + i);
                    var scriptSigBuf = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                    // Push redeemScript length
                    scriptSigBuf.writeUInt8(redeemScript.length);
                    scriptSigBuf.writeSlice(redeemScript);
                    psbt.setInputFinalScriptsig(i, scriptSigBuf.buffer());
                }
            } else {
                // Legacy input
                var scriptSig = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
                $975bf7ce1013542a$var$writePush(scriptSig, signature);
                $975bf7ce1013542a$var$writePush(scriptSig, legacyPubkeys[0]);
                psbt.setInputFinalScriptsig(i, scriptSig.buffer());
            }
        } else {
            // Taproot input
            var signature1 = psbt.getInputTapKeySig(i);
            if (!signature1) throw Error("No taproot signature found");
            if (signature1.length != 64 && signature1.length != 65) throw Error("Unexpected length of schnorr signature.");
            var witnessBuf1 = new (0, $9c8c78117b026d4b$export$67649df22d9ca0ab)();
            witnessBuf1.writeVarInt(1);
            witnessBuf1.writeVarSlice(signature1);
            psbt.setInputFinalScriptwitness(i, witnessBuf1.buffer());
        }
        $975bf7ce1013542a$var$clearFinalizedInput(psbt, i);
    }
}
/**
 * Deletes fields that are no longer neccesary from the psbt.
 *
 * Note, the spec doesn't say anything about removing ouput fields
 * like PSBT_OUT_BIP32_DERIVATION_PATH and others, so we keep them
 * without actually knowing why. I think we should remove them too.
 */ function $975bf7ce1013542a$var$clearFinalizedInput(psbt, inputIndex) {
    var keyTypes = [
        (0, $8ac540c119cbea8e$export$835161b70055ac87).BIP32_DERIVATION,
        (0, $8ac540c119cbea8e$export$835161b70055ac87).PARTIAL_SIG,
        (0, $8ac540c119cbea8e$export$835161b70055ac87).TAP_BIP32_DERIVATION,
        (0, $8ac540c119cbea8e$export$835161b70055ac87).TAP_KEY_SIG
    ];
    var witnessUtxoAvailable = !!psbt.getInputWitnessUtxo(inputIndex);
    var nonWitnessUtxoAvailable = !!psbt.getInputNonWitnessUtxo(inputIndex);
    if (witnessUtxoAvailable && nonWitnessUtxoAvailable) // Remove NON_WITNESS_UTXO for segwit v0 as it's only needed while signing.
    // Segwit v1 doesn't have NON_WITNESS_UTXO set.
    // See https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki#cite_note-7
    keyTypes.push((0, $8ac540c119cbea8e$export$835161b70055ac87).NON_WITNESS_UTXO);
    psbt.deleteInputEntries(inputIndex, keyTypes);
}
/**
 * Writes a script push operation to buf, which looks different
 * depending on the size of the data. See
 * https://en.bitcoin.it/wiki/Script#Constants
 *
 * @param buf the BufferWriter to write to
 * @param data the Buffer to be pushed.
 */ function $975bf7ce1013542a$var$writePush(buf, data) {
    if (data.length <= 75) buf.writeUInt8(data.length);
    else if (data.length <= 256) {
        buf.writeUInt8(76);
        buf.writeUInt8(data.length);
    } else if (data.length <= 65536) {
        buf.writeUInt8(77);
        var b = $975bf7ce1013542a$require$Buffer.alloc(2);
        b.writeUInt16LE(data.length, 0);
        buf.writeSlice(b);
    }
    buf.writeSlice(data);
}




var $ilnag = parcelRequire("ilnag");
var $df80e223f69a4e4d$require$Buffer = $ilnag.Buffer;
function $df80e223f69a4e4d$export$aa1483be3b95dbf(data, offset) {
    if (data[offset] < 0xfd) return [
        data[offset],
        1
    ];
    if (data[offset] === 0xfd) return [
        (data[offset + 2] << 8) + data[offset + 1],
        3
    ];
    if (data[offset] === 0xfe) return [
        (data[offset + 4] << 24) + (data[offset + 3] << 16) + (data[offset + 2] << 8) + data[offset + 1],
        5
    ];
    throw new Error("getVarint called with unexpected parameters");
}
function $df80e223f69a4e4d$export$6124fc6ccfda9c(value) {
    if (value < 0xfd) {
        var buffer = $df80e223f69a4e4d$require$Buffer.alloc(1);
        buffer[0] = value;
        return buffer;
    }
    if (value <= 0xffff) {
        var buffer1 = $df80e223f69a4e4d$require$Buffer.alloc(3);
        buffer1[0] = 0xfd;
        buffer1[1] = value & 0xff;
        buffer1[2] = value >> 8 & 0xff;
        return buffer1;
    }
    var buffer2 = $df80e223f69a4e4d$require$Buffer.alloc(5);
    buffer2[0] = 0xfe;
    buffer2[1] = value & 0xff;
    buffer2[2] = value >> 8 & 0xff;
    buffer2[3] = value >> 16 & 0xff;
    buffer2[4] = value >> 24 & 0xff;
    return buffer2;
}



var $ilnag = parcelRequire("ilnag");
var $ee4d0822350d8bd1$require$Buffer = $ilnag.Buffer;
function $ee4d0822350d8bd1$export$e6e9ad4770a214a8(param) {
    var outputs = param.outputs;
    var outputBuffer = $ee4d0822350d8bd1$require$Buffer.alloc(0);
    if (typeof outputs !== "undefined") {
        outputBuffer = $ee4d0822350d8bd1$require$Buffer.concat([
            outputBuffer,
            (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(outputs.length)
        ]);
        outputs.forEach(function(output) {
            outputBuffer = $ee4d0822350d8bd1$require$Buffer.concat([
                outputBuffer,
                output.amount,
                (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(output.script.length),
                output.script
            ]);
        });
    }
    return outputBuffer;
}
function $ee4d0822350d8bd1$export$7cb44e9a321cd996(transaction, skipWitness, timestamp) {
    var additionals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var isDecred = additionals.includes("decred");
    var isZcash = additionals.includes("zcash");
    var isBech32 = additionals.includes("bech32");
    var inputBuffer = $ee4d0822350d8bd1$require$Buffer.alloc(0);
    var useWitness = typeof transaction["witness"] != "undefined" && !skipWitness;
    transaction.inputs.forEach(function(input) {
        inputBuffer = isDecred || isBech32 ? $ee4d0822350d8bd1$require$Buffer.concat([
            inputBuffer,
            input.prevout,
            $ee4d0822350d8bd1$require$Buffer.from([
                0x00
            ]),
            input.sequence
        ]) : $ee4d0822350d8bd1$require$Buffer.concat([
            inputBuffer,
            input.prevout,
            (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(input.script.length),
            input.script,
            input.sequence
        ]);
    });
    var outputBuffer = $ee4d0822350d8bd1$export$e6e9ad4770a214a8(transaction);
    if (typeof transaction.outputs !== "undefined" && typeof transaction.locktime !== "undefined") outputBuffer = $ee4d0822350d8bd1$require$Buffer.concat([
        outputBuffer,
        useWitness && transaction.witness || $ee4d0822350d8bd1$require$Buffer.alloc(0),
        transaction.locktime,
        transaction.nExpiryHeight || $ee4d0822350d8bd1$require$Buffer.alloc(0),
        transaction.extraData || $ee4d0822350d8bd1$require$Buffer.alloc(0)
    ]);
    // from to https://zips.z.cash/zip-0225, zcash is different with other coins, the lock_time and nExpiryHeight fields are before the inputs and outputs
    if (isZcash) return $ee4d0822350d8bd1$require$Buffer.concat([
        transaction.version,
        transaction.nVersionGroupId || $ee4d0822350d8bd1$require$Buffer.alloc(0),
        $ee4d0822350d8bd1$require$Buffer.from([
            0x55,
            0x10,
            0xe7,
            0xc8
        ]),
        transaction.locktime || $ee4d0822350d8bd1$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        transaction.nExpiryHeight || $ee4d0822350d8bd1$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        useWitness ? $ee4d0822350d8bd1$require$Buffer.from("0001", "hex") : $ee4d0822350d8bd1$require$Buffer.alloc(0),
        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(transaction.inputs.length),
        inputBuffer,
        outputBuffer
    ]);
    return $ee4d0822350d8bd1$require$Buffer.concat([
        transaction.version,
        timestamp ? timestamp : $ee4d0822350d8bd1$require$Buffer.alloc(0),
        transaction.nVersionGroupId || $ee4d0822350d8bd1$require$Buffer.alloc(0),
        useWitness ? $ee4d0822350d8bd1$require$Buffer.from("0001", "hex") : $ee4d0822350d8bd1$require$Buffer.alloc(0),
        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(transaction.inputs.length),
        inputBuffer,
        outputBuffer
    ]);
}



var $ilnag = parcelRequire("ilnag");
var $3bfd867659cb4a1b$require$Buffer = $ilnag.Buffer;
var $3bfd867659cb4a1b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3bfd867659cb4a1b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function BtcNew(client) {
        (0, $7dKN1._)(this, BtcNew);
        this.client = client;
    }
    (0, $eW5pA._)(BtcNew, [
        {
            /**
     * This is a new method that allow users to get an xpub at a standard path.
     * Standard paths are described at
     * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md#description
     *
     * This boils down to paths (N=0 for Bitcoin, N=1 for Testnet):
     * M/44'/N'/x'/**
     * M/48'/N'/x'/y'/**
     * M/49'/N'/x'/**
     * M/84'/N'/x'/**
     * M/86'/N'/x'/**
     *
     * The method was added because of added security in the hardware app v2+. The
     * new hardware app will allow export of any xpub up to and including the
     * deepest hardened key of standard derivation paths, whereas the old app
     * would allow export of any key.
     *
     * This caused an issue for callers of this class, who only had
     * getWalletPublicKey() to call which means they have to constuct xpub
     * themselves:
     *
     * Suppose a user of this class wants to create an account xpub on a standard
     * path, M/44'/0'/Z'. The user must get the parent key fingerprint (see BIP32)
     * by requesting the parent key M/44'/0'. The new app won't allow that, because
     * it only allows exporting deepest level hardened path. So the options are to
     * allow requesting M/44'/0' from the app, or to add a new function
     * "getWalletXpub".
     *
     * We opted for adding a new function, which can greatly simplify client code.
     */ key: "getWalletXpub",
            value: function getWalletXpub(_a) {
                return $3bfd867659cb4a1b$var$__awaiter(this, arguments, void 0, function(param) {
                    var path, xpubVersion, pathElements, xpub, xpubComponents;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                path = param.path, xpubVersion = param.xpubVersion;
                                pathElements = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(path);
                                return [
                                    4,
                                    this.client.getExtendedPubkey(false, pathElements)
                                ];
                            case 1:
                                xpub = _state.sent();
                                xpubComponents = (0, $2c8b12cb6eb67c46$export$8bb2dc8ba35445c6)(xpub);
                                if (xpubComponents.version != xpubVersion) throw new Error("Expected xpub version ".concat(xpubVersion, " doesn't match the xpub version from the device ").concat(xpubComponents.version));
                                return [
                                    2,
                                    xpub
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * This method returns a public key, a bitcoin address, and and a chaincode
     * for a specific derivation path.
     *
     * Limitation: If the path is not a leaf node of a standard path, the address
     * will be the empty string "", see this.getWalletAddress() for details.
     */ key: "getWalletPublicKey",
            value: function getWalletPublicKey(path, opts) {
                return $3bfd867659cb4a1b$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _b, pathElements, xpub, display, address, components, uncompressedPubkey;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!$3bfd867659cb4a1b$export$d0edaed3aa4f6f65(path)) throw Error("non-standard path: ".concat(path));
                                pathElements = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(path);
                                return [
                                    4,
                                    this.client.getExtendedPubkey(false, pathElements)
                                ];
                            case 1:
                                xpub = _state.sent();
                                display = (_a = opts === null || opts === void 0 ? void 0 : opts.verify) !== null && _a !== void 0 ? _a : false;
                                return [
                                    4,
                                    this.getWalletAddress(pathElements, $3bfd867659cb4a1b$var$descrTemplFrom((_b = opts === null || opts === void 0 ? void 0 : opts.format) !== null && _b !== void 0 ? _b : "legacy"), display)
                                ];
                            case 2:
                                address = _state.sent();
                                components = (0, $2c8b12cb6eb67c46$export$8bb2dc8ba35445c6)(xpub);
                                uncompressedPubkey = $3bfd867659cb4a1b$require$Buffer.from((0, $a051056425522516$exports.pointCompress)(components.pubkey, false));
                                return [
                                    2,
                                    {
                                        publicKey: uncompressedPubkey.toString("hex"),
                                        bitcoinAddress: address,
                                        chainCode: components.chaincode.toString("hex")
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Get an address for the specified path.
     *
     * If display is true, we must get the address from the device, which would require
     * us to determine WalletPolicy. This requires two *extra* queries to the device, one
     * for the account xpub and one for master key fingerprint.
     *
     * If display is false we *could* generate the address ourselves, but chose to
     * get it from the device to save development time. However, it shouldn't take
     * too much time to implement local address generation.
     *
     * Moreover, if the path is not for a leaf, ie accountPath+/X/Y, there is no
     * way to get the address from the device. In this case we have to create it
     * ourselves, but we don't at this time, and instead return an empty ("") address.
     */ key: "getWalletAddress",
            value: function getWalletAddress(pathElements, descrTempl, display) {
                return $3bfd867659cb4a1b$var$__awaiter(this, void 0, void 0, function() {
                    var accountPath, accountXpub, masterFingerprint, policy, changeAndIndex;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accountPath = (0, $2c8b12cb6eb67c46$export$cc16963b25268381)(pathElements);
                                if (accountPath.length + 2 != pathElements.length) return [
                                    2,
                                    ""
                                ];
                                return [
                                    4,
                                    this.client.getExtendedPubkey(false, accountPath)
                                ];
                            case 1:
                                accountXpub = _state.sent();
                                return [
                                    4,
                                    this.client.getMasterFingerprint()
                                ];
                            case 2:
                                masterFingerprint = _state.sent();
                                policy = new (0, $8d3c12c8c0797031$export$7dabddf99c50dec7)(descrTempl, (0, $8d3c12c8c0797031$export$e2280c1995141b13)(masterFingerprint, accountPath, accountXpub));
                                changeAndIndex = pathElements.slice(-2, pathElements.length);
                                return [
                                    2,
                                    this.client.getWalletAddress(policy, $3bfd867659cb4a1b$require$Buffer.alloc(32, 0), changeAndIndex[0], changeAndIndex[1], display)
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Build and sign a transaction. See Btc.createPaymentTransaction for
     * details on how to use this method.
     *
     * This method will convert the legacy arguments, CreateTransactionArg, into
     * a psbt which is finally signed and finalized, and the extracted fully signed
     * transaction is returned.
     */ key: "createPaymentTransaction",
            value: function createPaymentTransaction(arg) {
                return $3bfd867659cb4a1b$var$__awaiter(this, void 0, void 0, function() {
                    var inputCount, psbt, masterFp, accountType, notifyCount, progress, accountXpub, accountPath, i, pathElems, outputsConcat, outputsBufferReader, outputCount, changeData, changeFound, i1, amount, outputScript, isChange, changePath, pubkey, key, p, firstSigned, progressCallback, serializedTx;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                inputCount = arg.inputs.length;
                                if (inputCount == 0) throw Error("No inputs");
                                psbt = new (0, $8ac540c119cbea8e$export$df421e92e1e77f5)();
                                return [
                                    4,
                                    this.client.getMasterFingerprint()
                                ];
                            case 1:
                                masterFp = _state.sent();
                                accountType = $3bfd867659cb4a1b$var$accountTypeFromArg(arg, psbt, masterFp);
                                if (arg.lockTime != undefined) // The signer will assume locktime 0 if unset
                                psbt.setGlobalFallbackLocktime(arg.lockTime);
                                psbt.setGlobalInputCount(inputCount);
                                psbt.setGlobalPsbtVersion(2);
                                psbt.setGlobalTxVersion(2);
                                notifyCount = 0;
                                progress = function() {
                                    if (!arg.onDeviceStreaming) return;
                                    arg.onDeviceStreaming({
                                        total: 2 * inputCount,
                                        index: notifyCount,
                                        progress: ++notifyCount / (2 * inputCount)
                                    });
                                };
                                accountXpub = "";
                                accountPath = [];
                                i = 0;
                                _state.label = 2;
                            case 2:
                                if (!(i < inputCount)) return [
                                    3,
                                    7
                                ];
                                progress();
                                pathElems = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(arg.associatedKeysets[i]);
                                if (!(accountXpub == "")) return [
                                    3,
                                    4
                                ];
                                // We assume all inputs belong to the same account so we set
                                // the account xpub and path based on the first input.
                                accountPath = pathElems.slice(0, -2);
                                return [
                                    4,
                                    this.client.getExtendedPubkey(false, accountPath)
                                ];
                            case 3:
                                accountXpub = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    this.setInput(psbt, i, arg.inputs[i], pathElems, accountType, masterFp, arg.sigHashType)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                i++;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                outputsConcat = $3bfd867659cb4a1b$require$Buffer.from(arg.outputScriptHex, "hex");
                                outputsBufferReader = new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(outputsConcat);
                                outputCount = outputsBufferReader.readVarInt();
                                psbt.setGlobalOutputCount(outputCount);
                                return [
                                    4,
                                    this.outputScriptAt(accountPath, accountType, arg.changePath)
                                ];
                            case 8:
                                changeData = _state.sent();
                                // If the caller supplied a changePath, we must make sure there actually is
                                // a change output. If no change output found, we'll throw an error.
                                changeFound = !changeData;
                                for(i1 = 0; i1 < outputCount; i1++){
                                    amount = Number(outputsBufferReader.readUInt64());
                                    outputScript = outputsBufferReader.readVarSlice();
                                    psbt.setOutputAmount(i1, amount);
                                    psbt.setOutputScript(i1, outputScript);
                                    // We won't know if we're paying to ourselves, because there's no
                                    // information in arg to support multiple "change paths". One exception is
                                    // if there are multiple outputs to the change address.
                                    isChange = changeData && outputScript.equals(changeData === null || changeData === void 0 ? void 0 : changeData.cond.scriptPubKey);
                                    if (isChange) {
                                        changeFound = true;
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        changePath = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(arg.changePath);
                                        pubkey = changeData.pubkey;
                                        accountType.setOwnOutput(i1, changeData.cond, [
                                            pubkey
                                        ], [
                                            changePath
                                        ]);
                                    }
                                }
                                if (!changeFound) throw new Error("Change script not found among outputs! " + (changeData === null || changeData === void 0 ? void 0 : changeData.cond.scriptPubKey.toString("hex")));
                                key = (0, $8d3c12c8c0797031$export$e2280c1995141b13)(masterFp, accountPath, accountXpub);
                                p = new (0, $8d3c12c8c0797031$export$7dabddf99c50dec7)(accountType.getDescriptorTemplate(), key);
                                // This is cheating, because it's not actually requested on the
                                // device yet, but it will be, soonish.
                                if (arg.onDeviceSignatureRequested) arg.onDeviceSignatureRequested();
                                firstSigned = false;
                                // This callback will be called once for each signature yielded.
                                progressCallback = function() {
                                    if (!firstSigned) {
                                        firstSigned = true;
                                        arg.onDeviceSignatureGranted && arg.onDeviceSignatureGranted();
                                    }
                                    progress();
                                };
                                return [
                                    4,
                                    this.signPsbt(psbt, p, progressCallback)
                                ];
                            case 9:
                                _state.sent();
                                (0, $975bf7ce1013542a$export$578723aef62d92f5)(psbt);
                                serializedTx = (0, $06b08d9151e6bdb8$export$f9380c9a627682d3)(psbt);
                                return [
                                    2,
                                    serializedTx.toString("hex")
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Signs an arbitrary hex-formatted message with the private key at
     * the provided derivation path according to the Bitcoin Signature format
     * and returns v, r, s.
     */ key: "signMessage",
            value: function signMessage(_a) {
                return $3bfd867659cb4a1b$var$__awaiter(this, arguments, void 0, function(param) {
                    var path, messageHex, pathElements, message, sig, buf, v, r, s;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                path = param.path, messageHex = param.messageHex;
                                pathElements = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(path);
                                message = $3bfd867659cb4a1b$require$Buffer.from(messageHex, "hex");
                                return [
                                    4,
                                    this.client.signMessage(message, pathElements)
                                ];
                            case 1:
                                sig = _state.sent();
                                buf = $3bfd867659cb4a1b$require$Buffer.from(sig, "base64");
                                v = buf.readUInt8() - 27 - 4;
                                r = buf.slice(1, 33).toString("hex");
                                s = buf.slice(33, 65).toString("hex");
                                return [
                                    2,
                                    {
                                        v: v,
                                        r: r,
                                        s: s
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Calculates an output script along with public key and possible redeemScript
     * from a path and accountType. The accountPath must be a prefix of path.
     *
     * @returns an object with output script (property "script"), redeemScript (if
     * wrapped p2wpkh), and pubkey at provided path. The values of these three
     * properties depend on the accountType used.
     */ key: "outputScriptAt",
            value: function outputScriptAt(accountPath, accountType, path) {
                return $3bfd867659cb4a1b$var$__awaiter(this, void 0, void 0, function() {
                    var pathElems, i, xpub, pubkey, cond;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!path) return [
                                    2,
                                    undefined
                                ];
                                pathElems = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(path);
                                // Make sure path is in our account, otherwise something fishy is probably
                                // going on.
                                for(i = 0; i < accountPath.length; i++){
                                    if (accountPath[i] != pathElems[i]) throw new Error("Path ".concat(path, " not in account ").concat((0, $2c8b12cb6eb67c46$export$6e27cd76987a4ce2)(accountPath)));
                                }
                                return [
                                    4,
                                    this.client.getExtendedPubkey(false, pathElems)
                                ];
                            case 1:
                                xpub = _state.sent();
                                pubkey = (0, $2c8b12cb6eb67c46$export$133bb17506582e39)(xpub);
                                cond = accountType.spendingCondition([
                                    pubkey
                                ]);
                                return [
                                    2,
                                    {
                                        cond: cond,
                                        pubkey: pubkey
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Adds relevant data about an input to the psbt. This includes sequence,
     * previous txid, output index, spent UTXO, redeem script for wrapped p2wpkh,
     * public key and its derivation path.
     */ key: "setInput",
            value: function setInput(psbt, i, input, pathElements, accountType, masterFP, sigHashType) {
                return $3bfd867659cb4a1b$var$__awaiter(this, void 0, void 0, function() {
                    var inputTx, spentOutputIndex, redeemScript, sequence, inputTxBuffer, inputTxid, xpubBase58, pubkey, spentTxOutput, spendCondition, spentOutput;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                inputTx = input[0];
                                spentOutputIndex = input[1];
                                // redeemScript will be null for wrapped p2wpkh, we need to create it
                                // ourselves. But if set, it should be used.
                                redeemScript = input[2] ? $3bfd867659cb4a1b$require$Buffer.from(input[2], "hex") : undefined;
                                sequence = input[3];
                                if (sequence != undefined) psbt.setInputSequence(i, sequence);
                                if (sigHashType != undefined) psbt.setInputSighashType(i, sigHashType);
                                inputTxBuffer = (0, $ee4d0822350d8bd1$export$7cb44e9a321cd996)(inputTx, true);
                                inputTxid = (0, $9ce982a108f9bffc$exports.crypto).hash256(inputTxBuffer);
                                return [
                                    4,
                                    this.client.getExtendedPubkey(false, pathElements)
                                ];
                            case 1:
                                xpubBase58 = _state.sent();
                                pubkey = (0, $2c8b12cb6eb67c46$export$133bb17506582e39)(xpubBase58);
                                if (!inputTx.outputs) throw Error("Missing outputs array in transaction to sign");
                                spentTxOutput = inputTx.outputs[spentOutputIndex];
                                spendCondition = {
                                    scriptPubKey: spentTxOutput.script,
                                    redeemScript: redeemScript
                                };
                                spentOutput = {
                                    cond: spendCondition,
                                    amount: spentTxOutput.amount
                                };
                                accountType.setInput(i, inputTxBuffer, spentOutput, [
                                    pubkey
                                ], [
                                    pathElements
                                ]);
                                psbt.setInputPreviousTxId(i, inputTxid);
                                psbt.setInputOutputIndex(i, spentOutputIndex);
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * This implements the "Signer" role of the BIP370 transaction signing
     * process.
     *
     * It ssks the hardware device to sign the a psbt using the specified wallet
     * policy. This method assumes BIP32 derived keys are used for all inputs, see
     * comment in-line. The signatures returned from the hardware device is added
     * to the appropriate input fields of the PSBT.
     */ key: "signPsbt",
            value: function signPsbt(psbt, walletPolicy, progressCallback) {
                return $3bfd867659cb4a1b$var$__awaiter(this, void 0, void 0, function() {
                    var sigs;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.client.signPsbt(psbt, walletPolicy, $3bfd867659cb4a1b$require$Buffer.alloc(32, 0), progressCallback)
                                ];
                            case 1:
                                sigs = _state.sent();
                                sigs.forEach(function(v, k) {
                                    // Note: Looking at BIP32 derivation does not work in the generic case,
                                    // since some inputs might not have a BIP32-derived pubkey.
                                    var pubkeys = psbt.getInputKeyDatas(k, (0, $8ac540c119cbea8e$export$835161b70055ac87).BIP32_DERIVATION);
                                    var pubkey;
                                    if (pubkeys.length != 1) {
                                        // No legacy BIP32_DERIVATION, assume we're using taproot.
                                        pubkey = psbt.getInputKeyDatas(k, (0, $8ac540c119cbea8e$export$835161b70055ac87).TAP_BIP32_DERIVATION);
                                        if (pubkey.length == 0) throw Error("Missing pubkey derivation for input ".concat(k));
                                        psbt.setInputTapKeySig(k, v);
                                    } else {
                                        pubkey = pubkeys[0];
                                        psbt.setInputPartialSig(k, pubkey, v);
                                    }
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return BtcNew;
}();
/**
 * This function returns a descriptor template based on the address format.
 * See https://github.com/LedgerHQ/app-bitcoin-new/blob/develop/doc/wallet.md for details of
 * the bitcoin descriptor template.
 */ function $3bfd867659cb4a1b$var$descrTemplFrom(addressFormat) {
    if (addressFormat == "legacy") return "pkh(@0)";
    if (addressFormat == "p2sh") return "sh(wpkh(@0))";
    if (addressFormat == "bech32") return "wpkh(@0)";
    if (addressFormat == "bech32m") return "tr(@0)";
    throw new Error("Unsupported address format " + addressFormat);
}
function $3bfd867659cb4a1b$var$accountTypeFromArg(arg, psbt, masterFp) {
    if (arg.additionals.includes("bech32m")) return new (0, $5cb0e8ce7eee2a4b$export$12d04d0fe56ae53)(psbt, masterFp);
    if (arg.additionals.includes("bech32")) return new (0, $5cb0e8ce7eee2a4b$export$5126746498e32b4b)(psbt, masterFp);
    if (arg.segwit) return new (0, $5cb0e8ce7eee2a4b$export$efcc171358cfcc7d)(psbt, masterFp);
    return new (0, $5cb0e8ce7eee2a4b$export$864e513602cf2381)(psbt, masterFp);
}
/*
  The new protocol only allows standard path.
  Standard paths are (currently):
  M/44'/(1|0|88)'/X'
  M/49'/(1|0|88)'/X'
  M/84'/(1|0|88)'/X'
  M/86'/(1|0|88)'/X'
  M/48'/(1|0|88)'/X'/Y'
  followed by "", "(0|1)", or "(0|1)/b", where a and b are
  non-hardened. For example, the following paths are standard
  M/48'/1'/99'/7'
  M/86'/1'/99'/0
  M/48'/0'/99'/7'/1/17
  The following paths are non-standard
  M/48'/0'/99'           // Not deepest hardened path
  M/48'/0'/99'/7'/1/17/2 // Too many non-hardened derivation steps
  M/199'/0'/1'/0/88      // Not a known purpose 199
  M/86'/1'/99'/2         // Change path item must be 0 or 1

  Useful resource on derivation paths: https://learnmeabitcoin.com/technical/derivation-paths
*/ //path is not deepest hardened node of a standard path or deeper, use BtcOld
var $3bfd867659cb4a1b$var$H = 0x80000000; //HARDENED from bip32
var $3bfd867659cb4a1b$var$VALID_COIN_TYPES = [
    0,
    1,
    88
];
var $3bfd867659cb4a1b$var$VALID_SINGLE_SIG_PURPOSES = [
    44,
    49,
    84,
    86
];
var $3bfd867659cb4a1b$var$VALID_MULTISIG_PURPOSES = [
    48
];
var $3bfd867659cb4a1b$var$hard = function(n) {
    return n >= $3bfd867659cb4a1b$var$H;
};
var $3bfd867659cb4a1b$var$soft = function(n) {
    return n === undefined || n < $3bfd867659cb4a1b$var$H;
};
var $3bfd867659cb4a1b$var$change = function(n) {
    return n === undefined || n === 0 || n === 1;
};
var $3bfd867659cb4a1b$var$validCoinPathPartsSet = new Set($3bfd867659cb4a1b$var$VALID_COIN_TYPES.map(function(t) {
    return t + $3bfd867659cb4a1b$var$H;
}));
var $3bfd867659cb4a1b$var$validSingleSigPurposePathPartsSet = new Set($3bfd867659cb4a1b$var$VALID_SINGLE_SIG_PURPOSES.map(function(t) {
    return t + $3bfd867659cb4a1b$var$H;
}));
var $3bfd867659cb4a1b$var$validMultiSigPurposePathPartsSet = new Set($3bfd867659cb4a1b$var$VALID_MULTISIG_PURPOSES.map(function(t) {
    return t + $3bfd867659cb4a1b$var$H;
}));
function $3bfd867659cb4a1b$export$d0edaed3aa4f6f65(path) {
    var pathElems = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(path);
    // Single sig
    if (pathElems.length >= 3 && pathElems.length <= 5 && $3bfd867659cb4a1b$var$validSingleSigPurposePathPartsSet.has(pathElems[0]) && $3bfd867659cb4a1b$var$validCoinPathPartsSet.has(pathElems[1]) && $3bfd867659cb4a1b$var$hard(pathElems[2]) && $3bfd867659cb4a1b$var$change(pathElems[3]) && $3bfd867659cb4a1b$var$soft(pathElems[4])) return true;
    // Multi sig
    if (pathElems.length >= 4 && pathElems.length <= 6 && $3bfd867659cb4a1b$var$validMultiSigPurposePathPartsSet.has(pathElems[0]) && $3bfd867659cb4a1b$var$validCoinPathPartsSet.has(pathElems[1]) && $3bfd867659cb4a1b$var$hard(pathElems[2]) && $3bfd867659cb4a1b$var$hard(pathElems[3]) && $3bfd867659cb4a1b$var$change(pathElems[4]) && $3bfd867659cb4a1b$var$soft(pathElems[5])) return true;
    return false;
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");

var $gYRJ8 = parcelRequire("gYRJ8");

var $aEC5U = parcelRequire("aEC5U");

var $fXOt1 = parcelRequire("fXOt1");

var $6qu4b = parcelRequire("6qu4b");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $1da806d2fc522c7e$var$id = 0;
var $1da806d2fc522c7e$var$subscribers = [];
var $1da806d2fc522c7e$export$bef1f36f5486a6a3 = function(type, message, data) {
    var obj = {
        type: type,
        id: String(++$1da806d2fc522c7e$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $1da806d2fc522c7e$var$dispatch(obj);
};
var $1da806d2fc522c7e$export$357889f174732d38 = function(param) {
    var type = param.type, message = param.message, data = param.data, context = param.context;
    var obj = {
        type: type,
        id: String(++$1da806d2fc522c7e$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    if (context) obj.context = context;
    $1da806d2fc522c7e$var$dispatch(obj);
};
var $1da806d2fc522c7e$export$c9a255a7b61db733 = /*#__PURE__*/ function() {
    "use strict";
    function LocalTracer(type, context) {
        (0, $7dKN1._)(this, LocalTracer);
        this.type = type;
        this.context = context;
    }
    (0, $eW5pA._)(LocalTracer, [
        {
            key: "trace",
            value: function trace1(message, data) {
                $1da806d2fc522c7e$export$357889f174732d38({
                    type: this.type,
                    message: message,
                    data: data,
                    context: this.context
                });
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context;
            }
        },
        {
            key: "setContext",
            value: function setContext(context) {
                this.context = context;
            }
        },
        {
            key: "updateContext",
            value: function updateContext(contextToAdd) {
                this.context = Object.assign(Object.assign({}, this.context), contextToAdd);
            }
        },
        {
            key: "getType",
            value: function getType() {
                return this.type;
            }
        },
        {
            key: "setType",
            value: function setType(type) {
                this.type = type;
            }
        },
        {
            /**
     * Create a new instance of the LocalTracer with an updated `type`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ key: "withType",
            value: function withType(type) {
                return new LocalTracer(type, this.context);
            }
        },
        {
            /**
     * Create a new instance of the LocalTracer with a new `context`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ key: "withContext",
            value: function withContext(context) {
                return new LocalTracer(this.type, context);
            }
        },
        {
            /**
     * Create a new instance of the LocalTracer with an updated `context`,
     * on which an additional context is merged with the existing one.
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ key: "withUpdatedContext",
            value: function withUpdatedContext(contextToAdd) {
                return new LocalTracer(this.type, Object.assign(Object.assign({}, this.context), contextToAdd));
            }
        }
    ]);
    return LocalTracer;
}();
var $1da806d2fc522c7e$export$63174c828edd6ff8 = function(cb) {
    $1da806d2fc522c7e$var$subscribers.push(cb);
    return function() {
        var i = $1da806d2fc522c7e$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $1da806d2fc522c7e$var$subscribers[i] = $1da806d2fc522c7e$var$subscribers[$1da806d2fc522c7e$var$subscribers.length - 1];
            $1da806d2fc522c7e$var$subscribers.pop();
        }
    };
};
function $1da806d2fc522c7e$var$dispatch(log) {
    for(var i = 0; i < $1da806d2fc522c7e$var$subscribers.length; i++)try {
        $1da806d2fc522c7e$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = $1da806d2fc522c7e$export$63174c828edd6ff8;




var $6qu4b = parcelRequire("6qu4b");

var $62581c13e2c02a89$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62581c13e2c02a89$var$addressFormatMap = {
    legacy: 0,
    p2sh: 1,
    bech32: 2,
    cashaddr: 3
};
function $62581c13e2c02a89$export$133040f4c0744766(transport, options) {
    return $62581c13e2c02a89$var$__awaiter(this, void 0, void 0, function() {
        var _Object_assign, path, verify, format, buffer, p1, p2, response, publicKeyLength, addressLength, publicKey, bitcoinAddress, chainCode;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Object_assign = Object.assign({
                        verify: false,
                        format: "legacy"
                    }, options), path = _Object_assign.path, verify = _Object_assign.verify, format = _Object_assign.format;
                    if (!(format in $62581c13e2c02a89$var$addressFormatMap)) throw new Error("btc.getWalletPublicKey invalid format=" + format);
                    buffer = (0, $2c8b12cb6eb67c46$export$dae4da1c913eeebb)(path);
                    p1 = verify ? 1 : 0;
                    p2 = $62581c13e2c02a89$var$addressFormatMap[format];
                    return [
                        4,
                        transport.send(0xe0, 0x40, p1, p2, buffer)
                    ];
                case 1:
                    response = _state.sent();
                    publicKeyLength = response[0];
                    addressLength = response[1 + publicKeyLength];
                    publicKey = response.slice(1, 1 + publicKeyLength).toString("hex");
                    bitcoinAddress = response.slice(1 + publicKeyLength + 1, 1 + publicKeyLength + 1 + addressLength).toString("ascii");
                    chainCode = response.slice(1 + publicKeyLength + 1 + addressLength, 1 + publicKeyLength + 1 + addressLength + 32).toString("hex");
                    return [
                        2,
                        {
                            publicKey: publicKey,
                            bitcoinAddress: bitcoinAddress,
                            chainCode: chainCode
                        }
                    ];
            }
        });
    });
}



var $6qu4b = parcelRequire("6qu4b");
var $208cab84cd3d0259$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $208cab84cd3d0259$var$invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$208cab84cd3d0259$exports = $208cab84cd3d0259$var$invariant;





var $ilnag = parcelRequire("ilnag");
var $72f03fa13b63a09b$require$Buffer = $ilnag.Buffer;
var $72f03fa13b63a09b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, transactionData, indexLookup) {
    return $72f03fa13b63a09b$var$__awaiter(this, void 0, void 0, function() {
        var data, firstRound, prefix, trustedInput, res;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    firstRound = false;
                    if (typeof indexLookup === "number") {
                        firstRound = true;
                        prefix = $72f03fa13b63a09b$require$Buffer.alloc(4);
                        prefix.writeUInt32BE(indexLookup, 0);
                        data = $72f03fa13b63a09b$require$Buffer.concat([
                            prefix,
                            transactionData
                        ], transactionData.length + 4);
                    } else data = transactionData;
                    return [
                        4,
                        transport.send(0xe0, 0x42, firstRound ? 0x00 : 0x80, 0x00, data)
                    ];
                case 1:
                    trustedInput = _state.sent();
                    res = trustedInput.slice(0, trustedInput.length - 2).toString("hex");
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function $72f03fa13b63a09b$export$31ab969c8a87fc21(transport_1, indexLookup_1, transaction_1) {
    return $72f03fa13b63a09b$var$__awaiter(this, arguments, void 0, function(transport, indexLookup, transaction) {
        var additionals, _this, inputs, outputs, locktime, nExpiryHeight, extraData, isDecred, processScriptBlocks, processWholeScriptBlock, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, treeField, data, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, output, data1, err, endData, extraPart, data2, res;
        var _arguments = arguments;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    additionals = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : [];
                    _this = this;
                    inputs = transaction.inputs, outputs = transaction.outputs, locktime = transaction.locktime, nExpiryHeight = transaction.nExpiryHeight, extraData = transaction.extraData;
                    if (!outputs || !locktime) throw new Error("getTrustedInput: locktime & outputs is expected");
                    isDecred = additionals.includes("decred");
                    processScriptBlocks = function(script, sequence) {
                        return $72f03fa13b63a09b$var$__awaiter(_this, void 0, void 0, function() {
                            var seq, scriptBlocks, offset, blockSize, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, scriptBlock, err;
                            return (0, $6qu4b.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        seq = sequence || $72f03fa13b63a09b$require$Buffer.alloc(0);
                                        scriptBlocks = [];
                                        offset = 0;
                                        while(offset !== script.length){
                                            blockSize = script.length - offset > (0, $163b3efa8595af0e$export$53184d0ac57d9130) ? (0, $163b3efa8595af0e$export$53184d0ac57d9130) : script.length - offset;
                                            if (offset + blockSize !== script.length) scriptBlocks.push(script.slice(offset, offset + blockSize));
                                            else scriptBlocks.push($72f03fa13b63a09b$require$Buffer.concat([
                                                script.slice(offset, offset + blockSize),
                                                seq
                                            ]));
                                            offset += blockSize;
                                        }
                                        // Handle case when no script length: we still want to pass the sequence
                                        // relatable: https://github.com/LedgerHQ/ledger-live-desktop/issues/1386
                                        if (script.length === 0) scriptBlocks.push(seq);
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]);
                                        _iterator = scriptBlocks[Symbol.iterator]();
                                        _state.label = 2;
                                    case 2:
                                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                            3,
                                            5
                                        ];
                                        scriptBlock = _step.value;
                                        return [
                                            4,
                                            $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, scriptBlock)
                                        ];
                                    case 3:
                                        res = _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        _iteratorNormalCompletion = true;
                                        return [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2,
                                            res
                                        ];
                                }
                            });
                        });
                    };
                    processWholeScriptBlock = function(block) {
                        return $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, block);
                    };
                    return [
                        4,
                        $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, $72f03fa13b63a09b$require$Buffer.concat([
                            transaction.version,
                            transaction.timestamp || $72f03fa13b63a09b$require$Buffer.alloc(0),
                            transaction.nVersionGroupId || $72f03fa13b63a09b$require$Buffer.alloc(0),
                            (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(inputs.length)
                        ]), indexLookup)
                    ];
                case 1:
                    _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        9,
                        10
                    ]);
                    _iterator = inputs[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    input = _step.value;
                    treeField = isDecred ? input.tree || $72f03fa13b63a09b$require$Buffer.from([
                        0x00
                    ]) : $72f03fa13b63a09b$require$Buffer.alloc(0);
                    data = $72f03fa13b63a09b$require$Buffer.concat([
                        input.prevout,
                        treeField,
                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(input.script.length)
                    ]);
                    return [
                        4,
                        $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, data)
                    ];
                case 4:
                    _state.sent();
                    // iteration (eachSeries) ended
                    // TODO notify progress
                    // deferred.notify("input");
                    return [
                        4,
                        isDecred ? processWholeScriptBlock($72f03fa13b63a09b$require$Buffer.concat([
                            input.script,
                            input.sequence
                        ])) : processScriptBlocks(input.script, input.sequence)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    return [
                        4,
                        $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(outputs.length))
                    ];
                case 11:
                    _state.sent();
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 12;
                case 12:
                    _state.trys.push([
                        12,
                        17,
                        18,
                        19
                    ]);
                    _iterator1 = outputs[Symbol.iterator]();
                    _state.label = 13;
                case 13:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        16
                    ];
                    output = _step1.value;
                    data1 = $72f03fa13b63a09b$require$Buffer.concat([
                        output.amount,
                        isDecred ? $72f03fa13b63a09b$require$Buffer.from([
                            0x00,
                            0x00
                        ]) : $72f03fa13b63a09b$require$Buffer.alloc(0),
                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(output.script.length),
                        output.script
                    ]);
                    return [
                        4,
                        $72f03fa13b63a09b$export$c346d6c04a5f7a55(transport, data1)
                    ];
                case 14:
                    _state.sent();
                    _state.label = 15;
                case 15:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        13
                    ];
                case 16:
                    return [
                        3,
                        19
                    ];
                case 17:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        19
                    ];
                case 18:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 19:
                    endData = [];
                    if (nExpiryHeight && nExpiryHeight.length > 0) endData.push(nExpiryHeight);
                    if (extraData && extraData.length > 0) endData.push(extraData);
                    if (endData.length) {
                        data2 = $72f03fa13b63a09b$require$Buffer.concat(endData);
                        extraPart = isDecred ? data2 : $72f03fa13b63a09b$require$Buffer.concat([
                            (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(data2.length),
                            data2
                        ]);
                    }
                    return [
                        4,
                        processScriptBlocks($72f03fa13b63a09b$require$Buffer.concat([
                            locktime,
                            extraPart || $72f03fa13b63a09b$require$Buffer.alloc(0)
                        ]))
                    ];
                case 20:
                    res = _state.sent();
                    (0, (/*@__PURE__*/$parcel$interopDefault($208cab84cd3d0259$exports)))(res, "missing result in processScriptBlocks");
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}



var $6qu4b = parcelRequire("6qu4b");



var $ilnag = parcelRequire("ilnag");
var $f089a464d071c8ad$require$Buffer = $ilnag.Buffer;
var $f089a464d071c8ad$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $f089a464d071c8ad$export$a3d2597c2fd4c463(transport, newTransaction, firstRound, transactionData) {
    var bip143 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, overwinter = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, additionals = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : [];
    var p2 = additionals.includes("cashaddr") ? 0x03 : bip143 ? additionals.includes("sapling") ? 0x05 : overwinter ? 0x04 : 0x02 : 0x00;
    return transport.send(0xe0, 0x44, firstRound ? 0x00 : 0x80, newTransaction ? p2 : 0x80, transactionData);
}
function $f089a464d071c8ad$export$fe75eaa1344c36c1(transport_1, newTransaction_1, transaction_1, inputs_1) {
    return $f089a464d071c8ad$var$__awaiter(this, arguments, void 0, function(transport, newTransaction, transaction, inputs) {
        var bip143, overwinter, additionals, useTrustedInputForSegwit, data, i, isDecred, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, prefix, inputValue, scriptBlocks, offset, blockSize, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, scriptBlock, err, err;
        var _arguments = arguments;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bip143 = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false, overwinter = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : false, additionals = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : [], useTrustedInputForSegwit = _arguments.length > 7 && _arguments[7] !== void 0 ? _arguments[7] : false;
                    data = $f089a464d071c8ad$require$Buffer.concat([
                        transaction.version,
                        transaction.timestamp || $f089a464d071c8ad$require$Buffer.alloc(0),
                        transaction.nVersionGroupId || $f089a464d071c8ad$require$Buffer.alloc(0),
                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(transaction.inputs.length)
                    ]);
                    return [
                        4,
                        $f089a464d071c8ad$export$a3d2597c2fd4c463(transport, newTransaction, true, data, bip143, overwinter, additionals)
                    ];
                case 1:
                    _state.sent();
                    i = 0;
                    isDecred = additionals.includes("decred");
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        15,
                        16,
                        17
                    ]);
                    _iterator = transaction.inputs[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        14
                    ];
                    input = _step.value;
                    prefix = void 0;
                    inputValue = inputs[i].value;
                    if (bip143) {
                        if (useTrustedInputForSegwit && inputs[i].trustedInput) prefix = $f089a464d071c8ad$require$Buffer.from([
                            0x01,
                            inputValue.length
                        ]);
                        else prefix = $f089a464d071c8ad$require$Buffer.from([
                            0x02
                        ]);
                    } else if (inputs[i].trustedInput) prefix = $f089a464d071c8ad$require$Buffer.from([
                        0x01,
                        inputs[i].value.length
                    ]);
                    else prefix = $f089a464d071c8ad$require$Buffer.from([
                        0x00
                    ]);
                    data = $f089a464d071c8ad$require$Buffer.concat([
                        prefix,
                        inputValue,
                        isDecred ? $f089a464d071c8ad$require$Buffer.from([
                            0x00
                        ]) : $f089a464d071c8ad$require$Buffer.alloc(0),
                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(input.script.length)
                    ]);
                    return [
                        4,
                        $f089a464d071c8ad$export$a3d2597c2fd4c463(transport, newTransaction, false, data, bip143, overwinter, additionals)
                    ];
                case 4:
                    _state.sent();
                    scriptBlocks = [];
                    offset = 0;
                    if (input.script.length === 0) scriptBlocks.push(input.sequence);
                    else while(offset !== input.script.length){
                        blockSize = input.script.length - offset > (0, $163b3efa8595af0e$export$53184d0ac57d9130) ? (0, $163b3efa8595af0e$export$53184d0ac57d9130) : input.script.length - offset;
                        if (offset + blockSize !== input.script.length) scriptBlocks.push(input.script.slice(offset, offset + blockSize));
                        else scriptBlocks.push($f089a464d071c8ad$require$Buffer.concat([
                            input.script.slice(offset, offset + blockSize),
                            input.sequence
                        ]));
                        offset += blockSize;
                    }
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        10,
                        11,
                        12
                    ]);
                    _iterator1 = scriptBlocks[Symbol.iterator]();
                    _state.label = 6;
                case 6:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        9
                    ];
                    scriptBlock = _step1.value;
                    return [
                        4,
                        $f089a464d071c8ad$export$a3d2597c2fd4c463(transport, newTransaction, false, scriptBlock, bip143, overwinter, additionals)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        6
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        12
                    ];
                case 11:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 12:
                    i++;
                    _state.label = 13;
                case 13:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 14:
                    return [
                        3,
                        17
                    ];
                case 15:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        17
                    ];
                case 16:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 17:
                    return [
                        2
                    ];
            }
        });
    });
}




var $fXOt1 = parcelRequire("fXOt1");


var $ilnag = parcelRequire("ilnag");
var $900480f4a2b90723$require$Buffer = $ilnag.Buffer;
function $900480f4a2b90723$export$33b7242117f697d5(transport, indexLookup, transaction) {
    var additionals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!transaction) throw new Error("getTrustedInputBIP143: missing tx");
    var isDecred = additionals.includes("decred");
    if (isDecred) throw new Error("Decred does not implement BIP143");
    var hash = (0, (/*@__PURE__*/$parcel$interopDefault($fXOt1)))("sha256").update((0, (/*@__PURE__*/$parcel$interopDefault($fXOt1)))("sha256").update((0, $ee4d0822350d8bd1$export$7cb44e9a321cd996)(transaction, true)).digest()).digest();
    var data = $900480f4a2b90723$require$Buffer.alloc(4);
    data.writeUInt32LE(indexLookup, 0);
    var outputs = transaction.outputs, locktime = transaction.locktime;
    if (!outputs || !locktime) throw new Error("getTrustedInputBIP143: locktime & outputs is expected");
    if (!outputs[indexLookup]) throw new Error("getTrustedInputBIP143: wrong index");
    hash = $900480f4a2b90723$require$Buffer.concat([
        hash,
        data,
        outputs[indexLookup].amount
    ]);
    return hash.toString("hex");
}



var $ilnag = parcelRequire("ilnag");
var $caf3c89cddfd11ae$require$Buffer = $ilnag.Buffer;
function $caf3c89cddfd11ae$export$a490116043767aa7(publicKey) {
    var prefix = (publicKey[64] & 1) !== 0 ? 0x03 : 0x02;
    var prefixBuffer = $caf3c89cddfd11ae$require$Buffer.alloc(1);
    prefixBuffer[0] = prefix;
    return $caf3c89cddfd11ae$require$Buffer.concat([
        prefixBuffer,
        publicKey.slice(1, 33)
    ]);
}




var $ilnag = parcelRequire("ilnag");
var $b4148d7fbddc3a38$require$Buffer = $ilnag.Buffer;
function $b4148d7fbddc3a38$export$6ad02cc4966b42ab(transport, path, lockTime, sigHashType, expiryHeight) {
    var additionals = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [];
    var isDecred = additionals.includes("decred");
    var pathsBuffer = (0, $2c8b12cb6eb67c46$export$dae4da1c913eeebb)(path);
    var lockTimeBuffer = $b4148d7fbddc3a38$require$Buffer.alloc(4);
    lockTimeBuffer.writeUInt32BE(lockTime, 0);
    var buffer = isDecred ? $b4148d7fbddc3a38$require$Buffer.concat([
        pathsBuffer,
        lockTimeBuffer,
        expiryHeight || $b4148d7fbddc3a38$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        $b4148d7fbddc3a38$require$Buffer.from([
            sigHashType
        ])
    ]) : $b4148d7fbddc3a38$require$Buffer.concat([
        pathsBuffer,
        $b4148d7fbddc3a38$require$Buffer.from([
            0x00
        ]),
        lockTimeBuffer,
        $b4148d7fbddc3a38$require$Buffer.from([
            sigHashType
        ])
    ]);
    if (expiryHeight && !isDecred) buffer = $b4148d7fbddc3a38$require$Buffer.concat([
        buffer,
        expiryHeight
    ]);
    return transport.send(0xe0, 0x48, 0x00, 0x00, buffer).then(function(result) {
        if (result.length > 0) {
            result[0] = 0x30;
            return result.slice(0, result.length - 2);
        }
        return result;
    });
}



var $6qu4b = parcelRequire("6qu4b");


var $d81f67c97ca26db7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $d81f67c97ca26db7$export$8f0374b05305ecf2(transport, path) {
    var buffer = (0, $2c8b12cb6eb67c46$export$dae4da1c913eeebb)(path);
    return transport.send(0xe0, 0x4a, 0xff, 0x00, buffer);
}
function $d81f67c97ca26db7$export$34dd66230370b398(transport_1, outputScript_1) {
    return $d81f67c97ca26db7$var$__awaiter(this, arguments, void 0, function(transport, outputScript) {
        var additionals, offset, p1, isDecred, blockSize, p11, data;
        var _arguments = arguments;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    additionals = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [];
                    offset = 0;
                    p1 = Number(0x80);
                    isDecred = additionals.includes("decred");
                    ///WARNING: Decred works only with one call (without chunking)
                    //TODO: test without this for Decred
                    if (isDecred) return [
                        2,
                        transport.send(0xe0, 0x4a, p1, 0x00, outputScript)
                    ];
                    _state.label = 1;
                case 1:
                    if (!(offset < outputScript.length)) return [
                        3,
                        3
                    ];
                    blockSize = offset + (0, $163b3efa8595af0e$export$53184d0ac57d9130) >= outputScript.length ? outputScript.length - offset : (0, $163b3efa8595af0e$export$53184d0ac57d9130);
                    p11 = offset + blockSize === outputScript.length ? 0x80 : 0x00;
                    data = outputScript.slice(offset, offset + blockSize);
                    return [
                        4,
                        transport.send(0xe0, 0x4a, p11, 0x00, data)
                    ];
                case 2:
                    _state.sent();
                    offset += blockSize;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
}



var $6qu4b = parcelRequire("6qu4b");

var $c59dbc3737457f3b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c59dbc3737457f3b$export$bd21f07fb59bc20d = function(transport) {
    return $c59dbc3737457f3b$var$__awaiter(void 0, void 0, void 0, function() {
        var r, i, format, nameLength, name, versionLength, version, flagLength, flags;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        transport.send(0xb0, 0x01, 0x00, 0x00)
                    ];
                case 1:
                    r = _state.sent();
                    i = 0;
                    format = r[i++];
                    (0, (/*@__PURE__*/$parcel$interopDefault($208cab84cd3d0259$exports)))(format === 1, "getAppAndVersion: format not supported");
                    nameLength = r[i++];
                    name = r.slice(i, i += nameLength).toString("ascii");
                    versionLength = r[i++];
                    version = r.slice(i, i += versionLength).toString("ascii");
                    flagLength = r[i++];
                    flags = r.slice(i, i += flagLength);
                    return [
                        2,
                        {
                            name: name,
                            version: version,
                            flags: flags
                        }
                    ];
            }
        });
    });
};
var $c59dbc3737457f3b$export$33e1ebd1430bed57 = function(transport) {
    return $c59dbc3737457f3b$var$__awaiter(void 0, void 0, void 0, function() {
        var e;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    // Call old btc API, it will throw an exception with new btc app. It is a workaround to differentiate new/old btc nano app
                    return [
                        4,
                        transport.send(0xe0, 0xc4, 0, 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2,
                        true
                    ];
            }
        });
    });
};




function $503fb2cde38a9528$export$f21853333aa2ecd1(param) {
    var version = param.version, name = param.name;
    if (name === "Decred") return false;
    if (name === "Exchange") return true;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ddfffd3116f371d$exports))).gte(version, "1.4.0");
}



var $ilnag = parcelRequire("ilnag");
var $3f148a818e62fbc4$require$Buffer = $ilnag.Buffer;
var $3f148a818e62fbc4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3f148a818e62fbc4$var$defaultsSignTransaction = {
    lockTime: (0, $163b3efa8595af0e$export$7e0b52e7059ffec7),
    sigHashType: (0, $163b3efa8595af0e$export$f53d15270899011f),
    segwit: false,
    additionals: [],
    onDeviceStreaming: function(_e) {},
    onDeviceSignatureGranted: function() {},
    onDeviceSignatureRequested: function() {}
};
function $3f148a818e62fbc4$export$714aebfec8ead7f0(transport, arg) {
    return $3f148a818e62fbc4$var$__awaiter(this, void 0, void 0, function() {
        var signTx, inputs, associatedKeysets, changePath, outputScriptHex, lockTime, sigHashType, segwit, additionals, expiryHeight, onDeviceStreaming, onDeviceSignatureGranted, onDeviceSignatureRequested, useTrustedInputForSegwit, a, e, notify, isDecred, isZcash, sapling, bech32, useBip143, lockTimeBuffer, nullScript, nullPrevout, defaultVersion, trustedInputs, regularOutputs, signatures, publicKeys, firstRun, resuming, targetTransaction, getTrustedInputCall, outputScript, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, trustedInput, sequence, outputs, index, err, result, i, r, i1, i2, input1, script, pseudoTX, pseudoTrustedInputs, signature, i3, signatureSize, keySize, offset, result1, witness, i4, tmpScriptData, decredWitness;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    signTx = Object.assign(Object.assign({}, $3f148a818e62fbc4$var$defaultsSignTransaction), arg);
                    inputs = signTx.inputs, associatedKeysets = signTx.associatedKeysets, changePath = signTx.changePath, outputScriptHex = signTx.outputScriptHex, lockTime = signTx.lockTime, sigHashType = signTx.sigHashType, segwit = signTx.segwit, additionals = signTx.additionals, expiryHeight = signTx.expiryHeight, onDeviceStreaming = signTx.onDeviceStreaming, onDeviceSignatureGranted = signTx.onDeviceSignatureGranted, onDeviceSignatureRequested = signTx.onDeviceSignatureRequested;
                    useTrustedInputForSegwit = signTx.useTrustedInputForSegwit;
                    if (!(useTrustedInputForSegwit === undefined)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $c59dbc3737457f3b$export$bd21f07fb59bc20d)(transport)
                    ];
                case 2:
                    a = _state.sent();
                    useTrustedInputForSegwit = (0, $503fb2cde38a9528$export$f21853333aa2ecd1)(a);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    if (e.statusCode === 0x6d00) useTrustedInputForSegwit = false;
                    else throw e;
                    return [
                        3,
                        4
                    ];
                case 4:
                    // loop: 0 or 1 (before and after)
                    // i: index of the input being streamed
                    // i goes on 0...n, inluding n. in order for the progress value to go to 1
                    // we normalize the 2 loops to make a global percentage
                    notify = function(loop, i) {
                        var length = inputs.length;
                        if (length < 3) return; // there is not enough significant event to worth notifying (aka just use a spinner)
                        var index = length * loop + i;
                        var total = 2 * length;
                        var progress = index / total;
                        onDeviceStreaming({
                            progress: progress,
                            total: total,
                            index: index
                        });
                    };
                    isDecred = additionals.includes("decred");
                    isZcash = additionals.includes("zcash");
                    sapling = additionals.includes("sapling");
                    bech32 = segwit && additionals.includes("bech32");
                    useBip143 = segwit || !!additionals && (additionals.includes("abc") || additionals.includes("gold") || additionals.includes("bip143")) || !!expiryHeight && !isDecred;
                    // Inputs are provided as arrays of [transaction, output_index, optional redeem script, optional sequence]
                    // associatedKeysets are provided as arrays of [path]
                    lockTimeBuffer = $3f148a818e62fbc4$require$Buffer.alloc(4);
                    lockTimeBuffer.writeUInt32LE(lockTime, 0);
                    nullScript = $3f148a818e62fbc4$require$Buffer.alloc(0);
                    nullPrevout = $3f148a818e62fbc4$require$Buffer.alloc(0);
                    defaultVersion = $3f148a818e62fbc4$require$Buffer.alloc(4);
                    !!expiryHeight && !isDecred ? defaultVersion.writeUInt32LE(isZcash ? 0x80000005 : sapling ? 0x80000004 : 0x80000003, 0) // v5 format for zcash refer to https://zips.z.cash/zip-0225
                     : defaultVersion.writeUInt32LE(1, 0);
                    // Default version to 2 for XST not to have timestamp
                    trustedInputs = [];
                    regularOutputs = [];
                    signatures = [];
                    publicKeys = [];
                    firstRun = true;
                    resuming = false;
                    targetTransaction = {
                        inputs: [],
                        version: defaultVersion,
                        timestamp: $3f148a818e62fbc4$require$Buffer.alloc(0)
                    };
                    getTrustedInputCall = useBip143 && !useTrustedInputForSegwit ? (0, $900480f4a2b90723$export$33b7242117f697d5) : (0, $72f03fa13b63a09b$export$31ab969c8a87fc21);
                    outputScript = $3f148a818e62fbc4$require$Buffer.from(outputScriptHex, "hex");
                    notify(0, 0);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        11,
                        12,
                        13
                    ]);
                    _iterator = inputs[Symbol.iterator]();
                    _state.label = 6;
                case 6:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        10
                    ];
                    input = _step.value;
                    if (!!resuming) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        getTrustedInputCall(transport, input[1], input[0], additionals)
                    ];
                case 7:
                    trustedInput = _state.sent();
                    (0, $1da806d2fc522c7e$export$bef1f36f5486a6a3)("hw", "got trustedInput=" + trustedInput);
                    sequence = $3f148a818e62fbc4$require$Buffer.alloc(4);
                    sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $163b3efa8595af0e$export$57fe8370989728bf), 0);
                    trustedInputs.push({
                        trustedInput: true,
                        value: $3f148a818e62fbc4$require$Buffer.from(trustedInput, "hex"),
                        sequence: sequence
                    });
                    _state.label = 8;
                case 8:
                    outputs = input[0].outputs;
                    index = input[1];
                    if (outputs && index <= outputs.length - 1) regularOutputs.push(outputs[index]);
                    if (expiryHeight && !isDecred) {
                        targetTransaction.nVersionGroupId = $3f148a818e62fbc4$require$Buffer.from(// nVersionGroupId is 0x26A7270A for zcash NU5 upgrade
                        // refer to https://github.com/zcash/zcash/blob/master/src/primitives/transaction.h
                        isZcash ? [
                            0x0a,
                            0x27,
                            0xa7,
                            0x26
                        ] : sapling ? [
                            0x85,
                            0x20,
                            0x2f,
                            0x89
                        ] : [
                            0x70,
                            0x82,
                            0xc4,
                            0x03
                        ]);
                        targetTransaction.nExpiryHeight = expiryHeight;
                        // For sapling : valueBalance (8), nShieldedSpend (1), nShieldedOutput (1), nJoinSplit (1)
                        // Overwinter : use nJoinSplit (1)
                        targetTransaction.extraData = $3f148a818e62fbc4$require$Buffer.from(sapling ? [
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00,
                            0x00
                        ] : [
                            0x00
                        ]);
                    } else if (isDecred) targetTransaction.nExpiryHeight = expiryHeight;
                    _state.label = 9;
                case 9:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        6
                    ];
                case 10:
                    return [
                        3,
                        13
                    ];
                case 11:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 12:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 13:
                    targetTransaction.inputs = inputs.map(function(input, idx) {
                        var sequence = $3f148a818e62fbc4$require$Buffer.alloc(4);
                        sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $163b3efa8595af0e$export$57fe8370989728bf), 0);
                        return {
                            script: isZcash ? regularOutputs[idx].script : nullScript,
                            prevout: nullPrevout,
                            sequence: sequence
                        };
                    });
                    if (!!resuming) return [
                        3,
                        18
                    ];
                    // Collect public keys
                    result = [];
                    i = 0;
                    _state.label = 14;
                case 14:
                    if (!(i < inputs.length)) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        (0, $62581c13e2c02a89$export$133040f4c0744766)(transport, {
                            path: associatedKeysets[i]
                        })
                    ];
                case 15:
                    r = _state.sent();
                    notify(0, i + 1);
                    result.push(r);
                    _state.label = 16;
                case 16:
                    i++;
                    return [
                        3,
                        14
                    ];
                case 17:
                    for(i1 = 0; i1 < result.length; i1++)publicKeys.push((0, $caf3c89cddfd11ae$export$a490116043767aa7)($3f148a818e62fbc4$require$Buffer.from(result[i1].publicKey, "hex")));
                    _state.label = 18;
                case 18:
                    onDeviceSignatureRequested();
                    if (!useBip143) return [
                        3,
                        23
                    ];
                    // Do the first run with all inputs
                    return [
                        4,
                        (0, $f089a464d071c8ad$export$fe75eaa1344c36c1)(transport, true, targetTransaction, trustedInputs, true, !!expiryHeight, additionals, useTrustedInputForSegwit)
                    ];
                case 19:
                    _state.sent();
                    if (!(!resuming && changePath)) return [
                        3,
                        21
                    ];
                    return [
                        4,
                        (0, $d81f67c97ca26db7$export$8f0374b05305ecf2)(transport, changePath)
                    ];
                case 20:
                    _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        4,
                        (0, $d81f67c97ca26db7$export$34dd66230370b398)(transport, outputScript)
                    ];
                case 22:
                    _state.sent();
                    _state.label = 23;
                case 23:
                    if (!(!!expiryHeight && !isDecred)) return [
                        3,
                        25
                    ];
                    return [
                        4,
                        (0, $b4148d7fbddc3a38$export$6ad02cc4966b42ab)(transport, "", lockTime, (0, $163b3efa8595af0e$export$f53d15270899011f), expiryHeight)
                    ];
                case 24:
                    _state.sent();
                    _state.label = 25;
                case 25:
                    i2 = 0;
                    _state.label = 26;
                case 26:
                    if (!(i2 < inputs.length)) return [
                        3,
                        34
                    ];
                    input1 = inputs[i2];
                    script = inputs[i2].length >= 3 && typeof input1[2] === "string" ? $3f148a818e62fbc4$require$Buffer.from(input1[2], "hex") : !segwit ? regularOutputs[i2].script : $3f148a818e62fbc4$require$Buffer.concat([
                        $3f148a818e62fbc4$require$Buffer.from([
                            (0, $163b3efa8595af0e$export$df6efc3aa949001c),
                            (0, $163b3efa8595af0e$export$25244e17dfd6169b),
                            (0, $163b3efa8595af0e$export$259fba643ee77695)
                        ]),
                        (0, $e9d59204e9a7b588$export$4f1687fa25e5df17)(publicKeys[i2]),
                        $3f148a818e62fbc4$require$Buffer.from([
                            (0, $163b3efa8595af0e$export$f8b5c605020bd49c),
                            (0, $163b3efa8595af0e$export$dc70dbf3545af7b7)
                        ])
                    ]);
                    pseudoTX = Object.assign({}, targetTransaction);
                    pseudoTrustedInputs = useBip143 ? [
                        trustedInputs[i2]
                    ] : trustedInputs;
                    if (useBip143) pseudoTX.inputs = [
                        Object.assign(Object.assign({}, pseudoTX.inputs[i2]), {
                            script: script
                        })
                    ];
                    else pseudoTX.inputs[i2].script = script;
                    return [
                        4,
                        (0, $f089a464d071c8ad$export$fe75eaa1344c36c1)(transport, !useBip143 && firstRun, pseudoTX, pseudoTrustedInputs, useBip143, !!expiryHeight && !isDecred, additionals, useTrustedInputForSegwit)
                    ];
                case 27:
                    _state.sent();
                    if (!!useBip143) return [
                        3,
                        31
                    ];
                    if (!(!resuming && changePath)) return [
                        3,
                        29
                    ];
                    return [
                        4,
                        (0, $d81f67c97ca26db7$export$8f0374b05305ecf2)(transport, changePath)
                    ];
                case 28:
                    _state.sent();
                    _state.label = 29;
                case 29:
                    return [
                        4,
                        (0, $d81f67c97ca26db7$export$34dd66230370b398)(transport, outputScript, additionals)
                    ];
                case 30:
                    _state.sent();
                    _state.label = 31;
                case 31:
                    if (firstRun) {
                        onDeviceSignatureGranted();
                        notify(1, 0);
                    }
                    return [
                        4,
                        (0, $b4148d7fbddc3a38$export$6ad02cc4966b42ab)(transport, associatedKeysets[i2], lockTime, sigHashType, expiryHeight, additionals)
                    ];
                case 32:
                    signature = _state.sent();
                    notify(1, i2 + 1);
                    signatures.push(signature);
                    targetTransaction.inputs[i2].script = nullScript;
                    if (firstRun) firstRun = false;
                    _state.label = 33;
                case 33:
                    i2++;
                    return [
                        3,
                        26
                    ];
                case 34:
                    // Populate the final input scripts
                    for(i3 = 0; i3 < inputs.length; i3++){
                        if (segwit) {
                            targetTransaction.witness = $3f148a818e62fbc4$require$Buffer.alloc(0);
                            if (!bech32) targetTransaction.inputs[i3].script = $3f148a818e62fbc4$require$Buffer.concat([
                                $3f148a818e62fbc4$require$Buffer.from("160014", "hex"),
                                (0, $e9d59204e9a7b588$export$4f1687fa25e5df17)(publicKeys[i3])
                            ]);
                        } else {
                            signatureSize = $3f148a818e62fbc4$require$Buffer.alloc(1);
                            keySize = $3f148a818e62fbc4$require$Buffer.alloc(1);
                            signatureSize[0] = signatures[i3].length;
                            keySize[0] = publicKeys[i3].length;
                            targetTransaction.inputs[i3].script = $3f148a818e62fbc4$require$Buffer.concat([
                                signatureSize,
                                signatures[i3],
                                keySize,
                                publicKeys[i3]
                            ]);
                        }
                        offset = useBip143 && !useTrustedInputForSegwit ? 0 : 4;
                        targetTransaction.inputs[i3].prevout = trustedInputs[i3].value.slice(offset, offset + 0x24);
                    }
                    targetTransaction.locktime = lockTimeBuffer;
                    result1 = $3f148a818e62fbc4$require$Buffer.concat([
                        (0, $ee4d0822350d8bd1$export$7cb44e9a321cd996)(targetTransaction, false, targetTransaction.timestamp, additionals),
                        outputScript
                    ]);
                    if (segwit && !isDecred) {
                        witness = $3f148a818e62fbc4$require$Buffer.alloc(0);
                        for(i4 = 0; i4 < inputs.length; i4++){
                            tmpScriptData = $3f148a818e62fbc4$require$Buffer.concat([
                                $3f148a818e62fbc4$require$Buffer.from("02", "hex"),
                                $3f148a818e62fbc4$require$Buffer.from([
                                    signatures[i4].length
                                ]),
                                signatures[i4],
                                $3f148a818e62fbc4$require$Buffer.from([
                                    publicKeys[i4].length
                                ]),
                                publicKeys[i4]
                            ]);
                            witness = $3f148a818e62fbc4$require$Buffer.concat([
                                witness,
                                tmpScriptData
                            ]);
                        }
                        result1 = $3f148a818e62fbc4$require$Buffer.concat([
                            result1,
                            witness
                        ]);
                    }
                    // from to https://zips.z.cash/zip-0225, zcash is different with other coins, the lock_time and nExpiryHeight fields are before the inputs and outputs
                    if (!isZcash) {
                        result1 = $3f148a818e62fbc4$require$Buffer.concat([
                            result1,
                            lockTimeBuffer
                        ]);
                        if (expiryHeight) result1 = $3f148a818e62fbc4$require$Buffer.concat([
                            result1,
                            targetTransaction.nExpiryHeight || $3f148a818e62fbc4$require$Buffer.alloc(0),
                            targetTransaction.extraData || $3f148a818e62fbc4$require$Buffer.alloc(0)
                        ]);
                    }
                    if (isDecred) {
                        decredWitness = $3f148a818e62fbc4$require$Buffer.from([
                            targetTransaction.inputs.length
                        ]);
                        inputs.forEach(function(input, inputIndex) {
                            decredWitness = $3f148a818e62fbc4$require$Buffer.concat([
                                decredWitness,
                                $3f148a818e62fbc4$require$Buffer.from([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00
                                ]),
                                $3f148a818e62fbc4$require$Buffer.from([
                                    0x00,
                                    0x00,
                                    0x00,
                                    0x00
                                ]),
                                $3f148a818e62fbc4$require$Buffer.from([
                                    0xff,
                                    0xff,
                                    0xff,
                                    0xff
                                ]),
                                $3f148a818e62fbc4$require$Buffer.from([
                                    targetTransaction.inputs[inputIndex].script.length
                                ]),
                                targetTransaction.inputs[inputIndex].script
                            ]);
                        });
                        result1 = $3f148a818e62fbc4$require$Buffer.concat([
                            result1,
                            decredWitness
                        ]);
                    }
                    if (isZcash) result1 = $3f148a818e62fbc4$require$Buffer.concat([
                        result1,
                        $3f148a818e62fbc4$require$Buffer.from([
                            0x00,
                            0x00,
                            0x00
                        ])
                    ]);
                    return [
                        2,
                        result1.toString("hex")
                    ];
            }
        });
    });
}





var $6qu4b = parcelRequire("6qu4b");

var $6qu4b = parcelRequire("6qu4b");



var $ilnag = parcelRequire("ilnag");
var $120b049daeba506e$require$Buffer = $ilnag.Buffer;
var $120b049daeba506e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $120b049daeba506e$export$1d9a7a8a40780de(transport_1, _a) {
    return $120b049daeba506e$var$__awaiter(this, arguments, void 0, function(transport, param) {
        var _loop, path, messageHex, paths, message, offset, res, v, r, s;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var maxChunkSize, chunkSize, buffer;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    maxChunkSize = offset === 0 ? (0, $163b3efa8595af0e$export$53184d0ac57d9130) - 1 - paths.length * 4 - 4 : (0, $163b3efa8595af0e$export$53184d0ac57d9130);
                                    chunkSize = offset + maxChunkSize > message.length ? message.length - offset : maxChunkSize;
                                    buffer = $120b049daeba506e$require$Buffer.alloc(offset === 0 ? 1 + paths.length * 4 + 2 + chunkSize : chunkSize);
                                    if (offset === 0) {
                                        buffer[0] = paths.length;
                                        paths.forEach(function(element, index) {
                                            buffer.writeUInt32BE(element, 1 + 4 * index);
                                        });
                                        buffer.writeUInt16BE(message.length, 1 + 4 * paths.length);
                                        message.copy(buffer, 1 + 4 * paths.length + 2, offset, offset + chunkSize);
                                    } else message.copy(buffer, 0, offset, offset + chunkSize);
                                    return [
                                        4,
                                        transport.send(0xe0, 0x4e, 0x00, offset === 0 ? 0x01 : 0x80, buffer)
                                    ];
                                case 1:
                                    _state.sent();
                                    offset += chunkSize;
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    path = param.path, messageHex = param.messageHex;
                    paths = (0, (/*@__PURE__*/$parcel$interopDefault($4f3a21d3ef79f6d4$exports))).fromString(path).toPathArray();
                    message = $120b049daeba506e$require$Buffer.from(messageHex, "hex");
                    offset = 0;
                    _state.label = 1;
                case 1:
                    if (!(offset !== message.length)) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $6qu4b.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        4,
                        transport.send(0xe0, 0x4e, 0x80, 0x00, $120b049daeba506e$require$Buffer.from([
                            0x00
                        ]))
                    ];
                case 4:
                    res = _state.sent();
                    v = res[0] - 0x30;
                    r = res.slice(4, 4 + res[3]);
                    if (r[0] === 0) r = r.slice(1);
                    r = r.toString("hex");
                    offset = 4 + res[3] + 2;
                    s = res.slice(offset, offset + res[offset - 1]);
                    if (s[0] === 0) s = s.slice(1);
                    s = s.toString("hex");
                    return [
                        2,
                        {
                            v: v,
                            r: r,
                            s: s
                        }
                    ];
            }
        });
    });
}



var $ilnag = parcelRequire("ilnag");
var $27bb53c6025dce1a$require$Buffer = $ilnag.Buffer;
var $27bb53c6025dce1a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $27bb53c6025dce1a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function BtcOld(transport) {
        (0, $7dKN1._)(this, BtcOld);
        this.transport = transport;
        this.derivationsCache = {};
    }
    (0, $eW5pA._)(BtcOld, [
        {
            key: "derivatePath",
            value: function derivatePath(path) {
                return $27bb53c6025dce1a$var$__awaiter(this, void 0, void 0, function() {
                    var res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.derivationsCache[path]) return [
                                    2,
                                    this.derivationsCache[path]
                                ];
                                return [
                                    4,
                                    (0, $62581c13e2c02a89$export$133040f4c0744766)(this.transport, {
                                        path: path
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                this.derivationsCache[path] = res;
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getWalletXpub",
            value: function getWalletXpub(_a) {
                return $27bb53c6025dce1a$var$__awaiter(this, arguments, void 0, function(param) {
                    var path, xpubVersion, pathElements, parentPath, parentDerivation, accountDerivation, fingerprint, xpub;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                path = param.path, xpubVersion = param.xpubVersion;
                                pathElements = (0, $2c8b12cb6eb67c46$export$35caeff6b64c2b35)(path);
                                parentPath = pathElements.slice(0, -1);
                                return [
                                    4,
                                    this.derivatePath((0, $2c8b12cb6eb67c46$export$6e27cd76987a4ce2)(parentPath))
                                ];
                            case 1:
                                parentDerivation = _state.sent();
                                return [
                                    4,
                                    this.derivatePath(path)
                                ];
                            case 2:
                                accountDerivation = _state.sent();
                                fingerprint = $27bb53c6025dce1a$var$makeFingerprint($27bb53c6025dce1a$var$compressPublicKeySECP256($27bb53c6025dce1a$require$Buffer.from(parentDerivation.publicKey, "hex")));
                                xpub = $27bb53c6025dce1a$var$makeXpub(xpubVersion, pathElements.length, fingerprint, pathElements[pathElements.length - 1], $27bb53c6025dce1a$require$Buffer.from(accountDerivation.chainCode, "hex"), $27bb53c6025dce1a$var$compressPublicKeySECP256($27bb53c6025dce1a$require$Buffer.from(accountDerivation.publicKey, "hex")));
                                return [
                                    2,
                                    xpub
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * @param path a BIP 32 path
     * @param options an object with optional these fields:
     *
     * - verify (boolean) will ask user to confirm the address on the device
     *
     * - format ("legacy" | "p2sh" | "bech32" | "bech32m" | "cashaddr") to use different bitcoin address formatter.
     *
     * NB The normal usage is to use:
     *
     * - legacy format with 44' paths
     *
     * - p2sh format with 49' paths
     *
     * - bech32 format with 84' paths
     *
     * - bech32m format with 86' paths
     *
     * - cashaddr in case of Bitcoin Cash
     *
     * @example
     * btc.getWalletPublicKey("44'/0'/0'/0/0").then(o => o.bitcoinAddress)
     * btc.getWalletPublicKey("49'/0'/0'/0/0", { format: "p2sh" }).then(o => o.bitcoinAddress)
     */ key: "getWalletPublicKey",
            value: function getWalletPublicKey1(path, opts) {
                if ((opts === null || opts === void 0 ? void 0 : opts.format) === "bech32m") throw new Error("Unsupported address format bech32m");
                return (0, $62581c13e2c02a89$export$133040f4c0744766)(this.transport, Object.assign(Object.assign({}, opts), {
                    path: path
                }));
            }
        },
        {
            /**
     * To sign a transaction involving standard (P2PKH) inputs, call createTransaction with the following parameters
     * @param inputs is an array of [ transaction, output_index, optional redeem script, optional sequence ] where
     *
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the optional redeem script to use when consuming a Segregated Witness input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param changePath is an optional BIP 32 path pointing to the path to the public key used to compute the change address
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @param segwit is an optional boolean indicating wether to use segwit or not
     * @param additionals list of additionnal options
     *
     * - "bech32" for spending native segwit outputs
     * - "abc" for bch
     * - "gold" for btg
     * - "decred" for decred
     * - "zcash" for zcash
     * - "bipxxx" for using BIPxxx
     * - "sapling" to indicate a zec transaction is supporting sapling (to be set over block 419200)
     * @param expiryHeight is an optional Buffer for zec overwinter / sapling Txs
     * @param useTrustedInputForSegwit trust inputs for segwit transactions
     * @return the signed transaction ready to be broadcast
     * @example
    btc.createTransaction({
     inputs: [ [tx1, 1] ],
     associatedKeysets: ["0'/0/0"],
     outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(res => ...);
     */ key: "createPaymentTransaction",
            value: function createPaymentTransaction(arg) {
                if (arguments.length > 1) throw new Error("@ledgerhq/hw-app-btc: createPaymentTransaction multi argument signature is deprecated. please switch to named parameters.");
                return (0, $3f148a818e62fbc4$export$714aebfec8ead7f0)(this.transport, arg);
            }
        },
        {
            key: "signMessage",
            value: function signMessage1(_a) {
                return $27bb53c6025dce1a$var$__awaiter(this, arguments, void 0, function(param) {
                    var path, messageHex;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        path = param.path, messageHex = param.messageHex;
                        return [
                            2,
                            (0, $120b049daeba506e$export$1d9a7a8a40780de)(this.transport, {
                                path: path,
                                messageHex: messageHex
                            })
                        ];
                    });
                });
            }
        }
    ]);
    return BtcOld;
}();
function $27bb53c6025dce1a$var$makeFingerprint(compressedPubKey) {
    return $27bb53c6025dce1a$var$hash160(compressedPubKey).slice(0, 4);
}
function $27bb53c6025dce1a$var$asBufferUInt32BE(n) {
    var buf = $27bb53c6025dce1a$require$Buffer.allocUnsafe(4);
    buf.writeUInt32BE(n, 0);
    return buf;
}
var $27bb53c6025dce1a$var$compressPublicKeySECP256 = function(publicKey) {
    return $27bb53c6025dce1a$require$Buffer.concat([
        $27bb53c6025dce1a$require$Buffer.from([
            0x02 + (publicKey[64] & 0x01)
        ]),
        publicKey.slice(1, 33)
    ]);
};
function $27bb53c6025dce1a$var$makeXpub(version, depth, parentFingerprint, index, chainCode, pubKey) {
    var indexBuffer = $27bb53c6025dce1a$var$asBufferUInt32BE(index);
    indexBuffer[0] |= 0x80;
    var extendedKeyBytes = $27bb53c6025dce1a$require$Buffer.concat([
        $27bb53c6025dce1a$var$asBufferUInt32BE(version),
        $27bb53c6025dce1a$require$Buffer.from([
            depth
        ]),
        parentFingerprint,
        indexBuffer,
        chainCode,
        pubKey
    ]);
    var checksum = $27bb53c6025dce1a$var$hash256(extendedKeyBytes).slice(0, 4);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode($27bb53c6025dce1a$require$Buffer.concat([
        extendedKeyBytes,
        checksum
    ]));
}
function $27bb53c6025dce1a$var$sha256(buffer) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fXOt1)))("sha256").update(buffer).digest();
}
function $27bb53c6025dce1a$var$hash256(buffer) {
    return $27bb53c6025dce1a$var$sha256($27bb53c6025dce1a$var$sha256(buffer));
}
function $27bb53c6025dce1a$var$ripemd160(buffer) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($aEC5U)))().update(buffer).digest();
}
function $27bb53c6025dce1a$var$hash160(buffer) {
    return $27bb53c6025dce1a$var$ripemd160($27bb53c6025dce1a$var$sha256(buffer));
}





var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");


var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");



var $ilnag = parcelRequire("ilnag");
var $6b8dd70f76984d0d$require$Buffer = $ilnag.Buffer;
var $6b8dd70f76984d0d$export$6333c118d63c57fc = /*#__PURE__*/ function() {
    "use strict";
    function MerkleMap(keys, values) {
        (0, $7dKN1._)(this, MerkleMap);
        if (keys.length != values.length) throw new Error("keys and values should have the same length");
        // Sanity check: verify that keys are actually sorted and with no duplicates
        for(var i = 0; i < keys.length - 1; i++){
            if (keys[i].toString("hex") >= keys[i + 1].toString("hex")) throw new Error("keys must be in strictly increasing order");
        }
        this.keys = keys;
        this.keysTree = new (0, $45fa351ddc777738$export$987d21b768c89d26)(keys.map(function(k) {
            return (0, $45fa351ddc777738$export$bc68c1df7778232a)(k);
        }));
        this.values = values;
        this.valuesTree = new (0, $45fa351ddc777738$export$987d21b768c89d26)(values.map(function(v) {
            return (0, $45fa351ddc777738$export$bc68c1df7778232a)(v);
        }));
    }
    (0, $eW5pA._)(MerkleMap, [
        {
            key: "commitment",
            value: function commitment() {
                // returns a buffer between 65 and 73 (included) bytes long
                return $6b8dd70f76984d0d$require$Buffer.concat([
                    (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(this.keys.length),
                    this.keysTree.getRoot(),
                    this.valuesTree.getRoot()
                ]);
            }
        }
    ]);
    return MerkleMap;
}();




var $ilnag = parcelRequire("ilnag");
var $7be83c50be697832$require$Buffer = $ilnag.Buffer;
var $7be83c50be697832$export$6138aa48176e3ed2 = /*#__PURE__*/ function(PsbtV2) {
    "use strict";
    (0, $cgJ2Y._)(MerkelizedPsbt, PsbtV2);
    var _super = (0, $hKD8n._)(MerkelizedPsbt);
    function MerkelizedPsbt(psbt) {
        (0, $7dKN1._)(this, MerkelizedPsbt);
        var _this;
        _this = _super.call(this);
        _this.inputMerkleMaps = [];
        _this.outputMerkleMaps = [];
        psbt.copy((0, $b9zO9._)(_this));
        _this.globalMerkleMap = MerkelizedPsbt.createMerkleMap(_this.globalMap);
        for(var i = 0; i < _this.getGlobalInputCount(); i++)_this.inputMerkleMaps.push(MerkelizedPsbt.createMerkleMap(_this.inputMaps[i]));
        _this.inputMapCommitments = (0, $gF0bR._)(_this.inputMerkleMaps.values()).map(function(v) {
            return v.commitment();
        });
        for(var i1 = 0; i1 < _this.getGlobalOutputCount(); i1++)_this.outputMerkleMaps.push(MerkelizedPsbt.createMerkleMap(_this.outputMaps[i1]));
        _this.outputMapCommitments = (0, $gF0bR._)(_this.outputMerkleMaps.values()).map(function(v) {
            return v.commitment();
        });
        return _this;
    }
    (0, $eW5pA._)(MerkelizedPsbt, [
        {
            // These public functions are for MerkelizedPsbt.
            key: "getGlobalSize",
            value: function getGlobalSize() {
                return this.globalMap.size;
            }
        },
        {
            key: "getGlobalKeysValuesRoot",
            value: function getGlobalKeysValuesRoot() {
                return this.globalMerkleMap.commitment();
            }
        }
    ], [
        {
            key: "createMerkleMap",
            value: function createMerkleMap(map) {
                var sortedKeysStrings = (0, $gF0bR._)(map.keys()).sort();
                var values = sortedKeysStrings.map(function(k) {
                    var v = map.get(k);
                    if (!v) throw new Error("No value for key " + k);
                    return v;
                });
                var sortedKeys = sortedKeysStrings.map(function(k) {
                    return $7be83c50be697832$require$Buffer.from(k, "hex");
                });
                var merkleMap = new (0, $6b8dd70f76984d0d$export$6333c118d63c57fc)(sortedKeys, values);
                return merkleMap;
            }
        }
    ]);
    return MerkelizedPsbt;
}((0, $8ac540c119cbea8e$export$df421e92e1e77f5));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");





var $ilnag = parcelRequire("ilnag");
var $01274688f5a8e448$require$Buffer = $ilnag.Buffer;
var $01274688f5a8e448$var$ClientCommandCode;
(function(ClientCommandCode) {
    ClientCommandCode[ClientCommandCode["YIELD"] = 16] = "YIELD";
    ClientCommandCode[ClientCommandCode["GET_PREIMAGE"] = 64] = "GET_PREIMAGE";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_PROOF"] = 65] = "GET_MERKLE_LEAF_PROOF";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_INDEX"] = 66] = "GET_MERKLE_LEAF_INDEX";
    ClientCommandCode[ClientCommandCode["GET_MORE_ELEMENTS"] = 160] = "GET_MORE_ELEMENTS";
})($01274688f5a8e448$var$ClientCommandCode || ($01274688f5a8e448$var$ClientCommandCode = {}));
var $01274688f5a8e448$var$ClientCommand = function ClientCommand() {
    "use strict";
    (0, $7dKN1._)(this, ClientCommand);
};
var $01274688f5a8e448$export$6cdc18cd411866ae = /*#__PURE__*/ function(ClientCommand) {
    "use strict";
    (0, $cgJ2Y._)(YieldCommand, ClientCommand);
    var _super = (0, $hKD8n._)(YieldCommand);
    function YieldCommand(results, progressCallback) {
        (0, $7dKN1._)(this, YieldCommand);
        var _this;
        _this = _super.call(this);
        _this.progressCallback = progressCallback;
        _this.code = $01274688f5a8e448$var$ClientCommandCode.YIELD;
        _this.results = results;
        return _this;
    }
    (0, $eW5pA._)(YieldCommand, [
        {
            key: "execute",
            value: function execute(request) {
                this.results.push($01274688f5a8e448$require$Buffer.from(request.subarray(1)));
                this.progressCallback();
                return $01274688f5a8e448$require$Buffer.from("");
            }
        }
    ]);
    return YieldCommand;
}($01274688f5a8e448$var$ClientCommand);
var $01274688f5a8e448$export$be0d4b5d2e5a3c27 = /*#__PURE__*/ function(ClientCommand) {
    "use strict";
    (0, $cgJ2Y._)(GetPreimageCommand, ClientCommand);
    var _super = (0, $hKD8n._)(GetPreimageCommand);
    function GetPreimageCommand(known_preimages, queue) {
        (0, $7dKN1._)(this, GetPreimageCommand);
        var _this;
        _this = _super.call(this);
        _this.code = $01274688f5a8e448$var$ClientCommandCode.GET_PREIMAGE;
        _this.known_preimages = known_preimages;
        _this.queue = queue;
        return _this;
    }
    (0, $eW5pA._)(GetPreimageCommand, [
        {
            key: "execute",
            value: function execute(request) {
                var req = $01274688f5a8e448$require$Buffer.from(request.subarray(1));
                // we expect no more data to read
                if (req.length != 33) throw new Error("Invalid request, unexpected trailing data");
                if (req[0] != 0) throw new Error("Unsupported request, the first byte should be 0");
                // read the hash
                var hash = $01274688f5a8e448$require$Buffer.alloc(32);
                for(var i = 0; i < 32; i++)hash[i] = req[1 + i];
                var req_hash_hex = hash.toString("hex");
                var known_preimage = this.known_preimages.get(req_hash_hex);
                if (known_preimage != undefined) {
                    var preimage_len_varint = (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(known_preimage.length);
                    // We can send at most 255 - len(preimage_len_out) - 1 bytes in a single message;
                    // the rest will be stored in the queue for GET_MORE_ELEMENTS
                    var max_payload_size = 255 - preimage_len_varint.length - 1;
                    var payload_size = Math.min(max_payload_size, known_preimage.length);
                    if (payload_size < known_preimage.length) for(var i1 = payload_size; i1 < known_preimage.length; i1++)this.queue.push($01274688f5a8e448$require$Buffer.from([
                        known_preimage[i1]
                    ]));
                    return $01274688f5a8e448$require$Buffer.concat([
                        preimage_len_varint,
                        $01274688f5a8e448$require$Buffer.from([
                            payload_size
                        ]),
                        $01274688f5a8e448$require$Buffer.from(known_preimage.subarray(0, payload_size))
                    ]);
                }
                throw Error("Requested unknown preimage for: ".concat(req_hash_hex));
            }
        }
    ]);
    return GetPreimageCommand;
}($01274688f5a8e448$var$ClientCommand);
var $01274688f5a8e448$export$a5a8e1b007cbff9d = /*#__PURE__*/ function(ClientCommand) {
    "use strict";
    (0, $cgJ2Y._)(GetMerkleLeafProofCommand, ClientCommand);
    var _super = (0, $hKD8n._)(GetMerkleLeafProofCommand);
    function GetMerkleLeafProofCommand(known_trees, queue) {
        (0, $7dKN1._)(this, GetMerkleLeafProofCommand);
        var _this;
        _this = _super.call(this);
        _this.code = $01274688f5a8e448$var$ClientCommandCode.GET_MERKLE_LEAF_PROOF;
        _this.known_trees = known_trees;
        _this.queue = queue;
        return _this;
    }
    (0, $eW5pA._)(GetMerkleLeafProofCommand, [
        {
            key: "execute",
            value: function execute(request) {
                var _this_queue;
                var req = $01274688f5a8e448$require$Buffer.from(request.subarray(1));
                if (req.length < 34) throw new Error("Invalid request, expected at least 34 bytes");
                var reqBuf = new (0, $9c8c78117b026d4b$export$bd4917b7431e3e00)(req);
                var hash = reqBuf.readSlice(32);
                var hash_hex = hash.toString("hex");
                var tree_size;
                var leaf_index;
                try {
                    tree_size = reqBuf.readVarInt();
                    leaf_index = reqBuf.readVarInt();
                } catch (e) {
                    throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
                }
                var mt = this.known_trees.get(hash_hex);
                if (!mt) throw Error("Requested Merkle leaf proof for unknown tree: ".concat(hash_hex));
                if (leaf_index >= tree_size || mt.size() != tree_size) throw Error("Invalid index or tree size.");
                if (this.queue.length != 0) throw Error("This command should not execute when the queue is not empty.");
                var proof = mt.getProof(leaf_index);
                var n_response_elements = Math.min(Math.floor(6.90625), proof.length);
                var n_leftover_elements = proof.length - n_response_elements;
                // Add to the queue any proof elements that do not fit the response
                if (n_leftover_elements > 0) (_this_queue = this.queue).push.apply(_this_queue, (0, $gF0bR._)(proof.slice(-n_leftover_elements)));
                return $01274688f5a8e448$require$Buffer.concat([
                    mt.getLeafHash(leaf_index),
                    $01274688f5a8e448$require$Buffer.from([
                        proof.length
                    ]),
                    $01274688f5a8e448$require$Buffer.from([
                        n_response_elements
                    ])
                ].concat((0, $gF0bR._)(proof.slice(0, n_response_elements))));
            }
        }
    ]);
    return GetMerkleLeafProofCommand;
}($01274688f5a8e448$var$ClientCommand);
var $01274688f5a8e448$export$9e6812ae409a7928 = /*#__PURE__*/ function(ClientCommand) {
    "use strict";
    (0, $cgJ2Y._)(GetMerkleLeafIndexCommand, ClientCommand);
    var _super = (0, $hKD8n._)(GetMerkleLeafIndexCommand);
    function GetMerkleLeafIndexCommand(known_trees) {
        (0, $7dKN1._)(this, GetMerkleLeafIndexCommand);
        var _this;
        _this = _super.call(this);
        _this.code = $01274688f5a8e448$var$ClientCommandCode.GET_MERKLE_LEAF_INDEX;
        _this.known_trees = known_trees;
        return _this;
    }
    (0, $eW5pA._)(GetMerkleLeafIndexCommand, [
        {
            key: "execute",
            value: function execute(request) {
                var req = $01274688f5a8e448$require$Buffer.from(request.subarray(1));
                if (req.length != 64) throw new Error("Invalid request, unexpected trailing data");
                // read the root hash
                var root_hash = $01274688f5a8e448$require$Buffer.alloc(32);
                for(var i = 0; i < 32; i++)root_hash[i] = req.readUInt8(i);
                var root_hash_hex = root_hash.toString("hex");
                // read the leaf hash
                var leef_hash = $01274688f5a8e448$require$Buffer.alloc(32);
                for(var i1 = 0; i1 < 32; i1++)leef_hash[i1] = req.readUInt8(32 + i1);
                var leef_hash_hex = leef_hash.toString("hex");
                var mt = this.known_trees.get(root_hash_hex);
                if (!mt) throw Error("Requested Merkle leaf index for unknown root: ".concat(root_hash_hex));
                var leaf_index = 0;
                var found = 0;
                for(var i2 = 0; i2 < mt.size(); i2++)if (mt.getLeafHash(i2).toString("hex") == leef_hash_hex) {
                    found = 1;
                    leaf_index = i2;
                    break;
                }
                return $01274688f5a8e448$require$Buffer.concat([
                    $01274688f5a8e448$require$Buffer.from([
                        found
                    ]),
                    (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(leaf_index)
                ]);
            }
        }
    ]);
    return GetMerkleLeafIndexCommand;
}($01274688f5a8e448$var$ClientCommand);
var $01274688f5a8e448$export$947bca8282126547 = /*#__PURE__*/ function(ClientCommand) {
    "use strict";
    (0, $cgJ2Y._)(GetMoreElementsCommand, ClientCommand);
    var _super = (0, $hKD8n._)(GetMoreElementsCommand);
    function GetMoreElementsCommand(queue) {
        (0, $7dKN1._)(this, GetMoreElementsCommand);
        var _this;
        _this = _super.call(this);
        _this.code = $01274688f5a8e448$var$ClientCommandCode.GET_MORE_ELEMENTS;
        _this.queue = queue;
        return _this;
    }
    (0, $eW5pA._)(GetMoreElementsCommand, [
        {
            key: "execute",
            value: function execute(request) {
                if (request.length != 1) throw new Error("Invalid request, unexpected trailing data");
                if (this.queue.length === 0) throw new Error("No elements to get");
                // all elements should have the same length
                var element_len = this.queue[0].length;
                if (this.queue.some(function(el) {
                    return el.length != element_len;
                })) throw new Error("The queue contains elements with different byte length, which is not expected");
                var max_elements = Math.floor(253 / element_len);
                var n_returned_elements = Math.min(max_elements, this.queue.length);
                var returned_elements = this.queue.splice(0, n_returned_elements);
                return $01274688f5a8e448$require$Buffer.concat([
                    $01274688f5a8e448$require$Buffer.from([
                        n_returned_elements
                    ]),
                    $01274688f5a8e448$require$Buffer.from([
                        element_len
                    ])
                ].concat((0, $gF0bR._)(returned_elements)));
            }
        }
    ]);
    return GetMoreElementsCommand;
}($01274688f5a8e448$var$ClientCommand);
var $01274688f5a8e448$export$be0ded693afdcf85 = /*#__PURE__*/ function() {
    "use strict";
    function ClientCommandInterpreter(progressCallback) {
        (0, $7dKN1._)(this, ClientCommandInterpreter);
        this.roots = new Map();
        this.preimages = new Map();
        this.yielded = [];
        this.queue = [];
        this.commands = new Map();
        var commands = [
            new $01274688f5a8e448$export$6cdc18cd411866ae(this.yielded, progressCallback),
            new $01274688f5a8e448$export$be0d4b5d2e5a3c27(this.preimages, this.queue),
            new $01274688f5a8e448$export$9e6812ae409a7928(this.roots),
            new $01274688f5a8e448$export$a5a8e1b007cbff9d(this.roots, this.queue),
            new $01274688f5a8e448$export$947bca8282126547(this.queue)
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = commands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var cmd = _step.value;
                if (this.commands.has(cmd.code)) throw new Error("Multiple commands with code ".concat(cmd.code));
                this.commands.set(cmd.code, cmd);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $eW5pA._)(ClientCommandInterpreter, [
        {
            key: "getYielded",
            value: function getYielded() {
                return this.yielded;
            }
        },
        {
            key: "addKnownPreimage",
            value: function addKnownPreimage(preimage) {
                this.preimages.set((0, $9ce982a108f9bffc$exports.crypto).sha256(preimage).toString("hex"), preimage);
            }
        },
        {
            key: "addKnownList",
            value: function addKnownList(elements) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var el = _step.value;
                        var preimage = $01274688f5a8e448$require$Buffer.concat([
                            $01274688f5a8e448$require$Buffer.from([
                                0
                            ]),
                            el
                        ]);
                        this.addKnownPreimage(preimage);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var mt = new (0, $45fa351ddc777738$export$987d21b768c89d26)(elements.map(function(el) {
                    return (0, $45fa351ddc777738$export$bc68c1df7778232a)(el);
                }));
                this.roots.set(mt.getRoot().toString("hex"), mt);
            }
        },
        {
            key: "addKnownMapping",
            value: function addKnownMapping(mm) {
                this.addKnownList(mm.keys);
                this.addKnownList(mm.values);
            }
        },
        {
            key: "execute",
            value: function execute(request) {
                if (request.length == 0) throw new Error("Unexpected empty command");
                var cmdCode = request[0];
                var cmd = this.commands.get(cmdCode);
                if (!cmd) throw new Error("Unexpected command code ".concat(cmdCode));
                return cmd.execute(request);
            }
        }
    ]);
    return ClientCommandInterpreter;
}();





var $ilnag = parcelRequire("ilnag");
var $9824097b8a3b32ce$require$Buffer = $ilnag.Buffer;
var $9824097b8a3b32ce$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9824097b8a3b32ce$var$CLA_BTC = 0xe1;
var $9824097b8a3b32ce$var$CLA_FRAMEWORK = 0xf8;
var $9824097b8a3b32ce$var$BitcoinIns;
(function(BitcoinIns) {
    BitcoinIns[BitcoinIns["GET_PUBKEY"] = 0] = "GET_PUBKEY";
    // GET_ADDRESS = 0x01, // Removed from app
    BitcoinIns[BitcoinIns["REGISTER_WALLET"] = 2] = "REGISTER_WALLET";
    BitcoinIns[BitcoinIns["GET_WALLET_ADDRESS"] = 3] = "GET_WALLET_ADDRESS";
    BitcoinIns[BitcoinIns["SIGN_PSBT"] = 4] = "SIGN_PSBT";
    BitcoinIns[BitcoinIns["GET_MASTER_FINGERPRINT"] = 5] = "GET_MASTER_FINGERPRINT";
    BitcoinIns[BitcoinIns["SIGN_MESSAGE"] = 16] = "SIGN_MESSAGE";
})($9824097b8a3b32ce$var$BitcoinIns || ($9824097b8a3b32ce$var$BitcoinIns = {}));
var $9824097b8a3b32ce$var$FrameworkIns;
(function(FrameworkIns) {
    FrameworkIns[FrameworkIns["CONTINUE_INTERRUPTED"] = 1] = "CONTINUE_INTERRUPTED";
})($9824097b8a3b32ce$var$FrameworkIns || ($9824097b8a3b32ce$var$FrameworkIns = {}));
var $9824097b8a3b32ce$export$9bbedc1992a787b4 = /*#__PURE__*/ function() {
    "use strict";
    function AppClient(transport) {
        (0, $7dKN1._)(this, AppClient);
        this.transport = transport;
    }
    (0, $eW5pA._)(AppClient, [
        {
            key: "makeRequest",
            value: function makeRequest(ins, data, cci) {
                return $9824097b8a3b32ce$var$__awaiter(this, void 0, void 0, function() {
                    var response, hwRequest, commandResponse;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.transport.send($9824097b8a3b32ce$var$CLA_BTC, ins, 0, 0, data, [
                                        0x9000,
                                        0xe000
                                    ])
                                ];
                            case 1:
                                response = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!(response.readUInt16BE(response.length - 2) === 0xe000)) return [
                                    3,
                                    4
                                ];
                                if (!cci) throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
                                hwRequest = response.slice(0, -2);
                                commandResponse = cci.execute(hwRequest);
                                return [
                                    4,
                                    this.transport.send($9824097b8a3b32ce$var$CLA_FRAMEWORK, $9824097b8a3b32ce$var$FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, commandResponse, [
                                        0x9000,
                                        0xe000
                                    ])
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    3,
                                    2
                                ];
                            case 4:
                                return [
                                    2,
                                    response.slice(0, -2)
                                ]; // drop the status word (can only be 0x9000 at this point)
                        }
                    });
                });
            }
        },
        {
            key: "getExtendedPubkey",
            value: function getExtendedPubkey(display, pathElements) {
                return $9824097b8a3b32ce$var$__awaiter(this, void 0, void 0, function() {
                    var response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
                                return [
                                    4,
                                    this.makeRequest($9824097b8a3b32ce$var$BitcoinIns.GET_PUBKEY, $9824097b8a3b32ce$require$Buffer.concat([
                                        $9824097b8a3b32ce$require$Buffer.from(display ? [
                                            1
                                        ] : [
                                            0
                                        ]),
                                        (0, $2c8b12cb6eb67c46$export$91b509509e9f8b52)(pathElements)
                                    ]))
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.toString("ascii")
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getWalletAddress",
            value: function getWalletAddress(walletPolicy, walletHMAC, change, addressIndex, display) {
                return $9824097b8a3b32ce$var$__awaiter(this, void 0, void 0, function() {
                    var clientInterpreter, addressIndexBuffer, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (change !== 0 && change !== 1) throw new Error("Change can only be 0 or 1");
                                if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error("Invalid address index");
                                if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
                                clientInterpreter = new (0, $01274688f5a8e448$export$be0ded693afdcf85)(function() {});
                                clientInterpreter.addKnownList(walletPolicy.keys.map(function(k) {
                                    return $9824097b8a3b32ce$require$Buffer.from(k, "ascii");
                                }));
                                clientInterpreter.addKnownPreimage(walletPolicy.serialize());
                                addressIndexBuffer = $9824097b8a3b32ce$require$Buffer.alloc(4);
                                addressIndexBuffer.writeUInt32BE(addressIndex, 0);
                                return [
                                    4,
                                    this.makeRequest($9824097b8a3b32ce$var$BitcoinIns.GET_WALLET_ADDRESS, $9824097b8a3b32ce$require$Buffer.concat([
                                        $9824097b8a3b32ce$require$Buffer.from(display ? [
                                            1
                                        ] : [
                                            0
                                        ]),
                                        walletPolicy.getWalletId(),
                                        walletHMAC || $9824097b8a3b32ce$require$Buffer.alloc(32, 0),
                                        $9824097b8a3b32ce$require$Buffer.from([
                                            change
                                        ]),
                                        addressIndexBuffer
                                    ]), clientInterpreter)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.toString("ascii")
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signPsbt",
            value: function signPsbt(psbt, walletPolicy, walletHMAC, progressCallback) {
                return $9824097b8a3b32ce$var$__awaiter(this, void 0, void 0, function() {
                    var merkelizedPsbt, clientInterpreter, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, map, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, map1, inputMapsRoot, outputMapsRoot, yielded, ret, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, inputAndSig;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                merkelizedPsbt = new (0, $7be83c50be697832$export$6138aa48176e3ed2)(psbt);
                                if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
                                clientInterpreter = new (0, $01274688f5a8e448$export$be0ded693afdcf85)(progressCallback);
                                // prepare ClientCommandInterpreter
                                clientInterpreter.addKnownList(walletPolicy.keys.map(function(k) {
                                    return $9824097b8a3b32ce$require$Buffer.from(k, "ascii");
                                }));
                                clientInterpreter.addKnownPreimage(walletPolicy.serialize());
                                clientInterpreter.addKnownMapping(merkelizedPsbt.globalMerkleMap);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = merkelizedPsbt.inputMerkleMaps[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        map = _step.value;
                                        clientInterpreter.addKnownMapping(map);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = merkelizedPsbt.outputMerkleMaps[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        map1 = _step1.value;
                                        clientInterpreter.addKnownMapping(map1);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                clientInterpreter.addKnownList(merkelizedPsbt.inputMapCommitments);
                                inputMapsRoot = new (0, $45fa351ddc777738$export$987d21b768c89d26)(merkelizedPsbt.inputMapCommitments.map(function(m) {
                                    return (0, $45fa351ddc777738$export$bc68c1df7778232a)(m);
                                })).getRoot();
                                clientInterpreter.addKnownList(merkelizedPsbt.outputMapCommitments);
                                outputMapsRoot = new (0, $45fa351ddc777738$export$987d21b768c89d26)(merkelizedPsbt.outputMapCommitments.map(function(m) {
                                    return (0, $45fa351ddc777738$export$bc68c1df7778232a)(m);
                                })).getRoot();
                                return [
                                    4,
                                    this.makeRequest($9824097b8a3b32ce$var$BitcoinIns.SIGN_PSBT, $9824097b8a3b32ce$require$Buffer.concat([
                                        merkelizedPsbt.getGlobalKeysValuesRoot(),
                                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(merkelizedPsbt.getGlobalInputCount()),
                                        inputMapsRoot,
                                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(merkelizedPsbt.getGlobalOutputCount()),
                                        outputMapsRoot,
                                        walletPolicy.getWalletId(),
                                        walletHMAC || $9824097b8a3b32ce$require$Buffer.alloc(32, 0)
                                    ]), clientInterpreter)
                                ];
                            case 1:
                                _state.sent();
                                yielded = clientInterpreter.getYielded();
                                ret = new Map();
                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(_iterator2 = yielded[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        inputAndSig = _step2.value;
                                        ret.set(inputAndSig[0], inputAndSig.slice(1));
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    ret
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getMasterFingerprint",
            value: function getMasterFingerprint() {
                return $9824097b8a3b32ce$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            this.makeRequest($9824097b8a3b32ce$var$BitcoinIns.GET_MASTER_FINGERPRINT, $9824097b8a3b32ce$require$Buffer.from([]))
                        ];
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message, pathElements) {
                return $9824097b8a3b32ce$var$__awaiter(this, void 0, void 0, function() {
                    var clientInterpreter, nChunks, chunks, i, chunksRoot, response;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
                                clientInterpreter = new (0, $01274688f5a8e448$export$be0ded693afdcf85)(function() {});
                                // prepare ClientCommandInterpreter
                                nChunks = Math.ceil(message.length / 64);
                                chunks = [];
                                for(i = 0; i < nChunks; i++)chunks.push(message.subarray(64 * i, 64 * i + 64));
                                clientInterpreter.addKnownList(chunks);
                                chunksRoot = new (0, $45fa351ddc777738$export$987d21b768c89d26)(chunks.map(function(m) {
                                    return (0, $45fa351ddc777738$export$bc68c1df7778232a)(m);
                                })).getRoot();
                                return [
                                    4,
                                    this.makeRequest($9824097b8a3b32ce$var$BitcoinIns.SIGN_MESSAGE, $9824097b8a3b32ce$require$Buffer.concat([
                                        (0, $2c8b12cb6eb67c46$export$91b509509e9f8b52)(pathElements),
                                        (0, $df80e223f69a4e4d$export$6124fc6ccfda9c)(message.length),
                                        chunksRoot
                                    ]), clientInterpreter)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.toString("base64")
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return AppClient;
}();





function $b7dc3bc7e4df2ee6$export$83ccbb54a35801e8(transaction) {
    var str = "TX";
    str += " version " + transaction.version.toString("hex");
    if (transaction.locktime) str += " locktime " + transaction.locktime.toString("hex");
    if (transaction.witness) str += " witness " + transaction.witness.toString("hex");
    if (transaction.timestamp) str += " timestamp " + transaction.timestamp.toString("hex");
    if (transaction.nVersionGroupId) str += " nVersionGroupId " + transaction.nVersionGroupId.toString("hex");
    if (transaction.nExpiryHeight) str += " nExpiryHeight " + transaction.nExpiryHeight.toString("hex");
    if (transaction.extraData) str += " extraData " + transaction.extraData.toString("hex");
    transaction.inputs.forEach(function(param, i) {
        var prevout = param.prevout, script = param.script, sequence = param.sequence;
        str += "\ninput ".concat(i, ":");
        str += " prevout ".concat(prevout.toString("hex"));
        str += " script ".concat(script.toString("hex"));
        str += " sequence ".concat(sequence.toString("hex"));
    });
    (transaction.outputs || []).forEach(function(param, i) {
        var amount = param.amount, script = param.script;
        str += "\noutput ".concat(i, ":");
        str += " amount ".concat(amount.toString("hex"));
        str += " script ".concat(script.toString("hex"));
    });
    return str;
}
function $b7dc3bc7e4df2ee6$export$ecf0056473e2fd14(transaction) {
    console.log($b7dc3bc7e4df2ee6$export$83ccbb54a35801e8(transaction));
}



var $ilnag = parcelRequire("ilnag");
var $a484a747c0b9641c$require$Buffer = $ilnag.Buffer;
function $a484a747c0b9641c$export$58013ee1a5c7c230(transactionHex) {
    var isSegwitSupported = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, hasExtraData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, additionals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var inputs = [];
    var outputs = [];
    var witness = false;
    var offset = 0;
    var timestamp = $a484a747c0b9641c$require$Buffer.alloc(0);
    var nExpiryHeight = $a484a747c0b9641c$require$Buffer.alloc(0);
    var nVersionGroupId = $a484a747c0b9641c$require$Buffer.alloc(0);
    var extraData = $a484a747c0b9641c$require$Buffer.alloc(0);
    var witnessScript, locktime;
    var isDecred = additionals.includes("decred");
    var isZencash = additionals.includes("zencash");
    var isZcash = additionals.includes("zcash");
    var transaction = $a484a747c0b9641c$require$Buffer.from(transactionHex, "hex");
    var version = transaction.slice(offset, offset + 4);
    var overwinter = version.equals($a484a747c0b9641c$require$Buffer.from([
        0x03,
        0x00,
        0x00,
        0x80
    ])) || version.equals($a484a747c0b9641c$require$Buffer.from([
        0x04,
        0x00,
        0x00,
        0x80
    ])) || version.equals($a484a747c0b9641c$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    var isZcashv5 = isZcash && version.equals($a484a747c0b9641c$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    offset += 4;
    if (isSegwitSupported && transaction[offset] === 0 && transaction[offset + 1] !== 0 && !isZencash) {
        offset += 2;
        witness = true;
    }
    if (overwinter) {
        nVersionGroupId = transaction.slice(offset, 4 + offset);
        offset += 4;
    }
    if (isZcashv5) {
        locktime = transaction.slice(offset + 4, offset + 8);
        nExpiryHeight = transaction.slice(offset + 8, offset + 12);
        offset += 12;
    }
    var varint = (0, $df80e223f69a4e4d$export$aa1483be3b95dbf)(transaction, offset);
    var numberInputs = varint[0];
    offset += varint[1];
    for(var i = 0; i < numberInputs; i++){
        var prevout = transaction.slice(offset, offset + 36);
        offset += 36;
        var script = $a484a747c0b9641c$require$Buffer.alloc(0);
        var tree = $a484a747c0b9641c$require$Buffer.alloc(0);
        //No script for decred, it has a witness
        if (!isDecred) {
            varint = (0, $df80e223f69a4e4d$export$aa1483be3b95dbf)(transaction, offset);
            offset += varint[1];
            script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
        } else {
            //Tree field
            tree = transaction.slice(offset, offset + 1);
            offset += 1;
        }
        var sequence = transaction.slice(offset, offset + 4);
        offset += 4;
        inputs.push({
            prevout: prevout,
            script: script,
            sequence: sequence,
            tree: tree
        });
    }
    varint = (0, $df80e223f69a4e4d$export$aa1483be3b95dbf)(transaction, offset);
    var numberOutputs = varint[0];
    offset += varint[1];
    for(var i1 = 0; i1 < numberOutputs; i1++){
        var amount = transaction.slice(offset, offset + 8);
        offset += 8;
        if (isDecred) //Script version
        offset += 2;
        varint = (0, $df80e223f69a4e4d$export$aa1483be3b95dbf)(transaction, offset);
        offset += varint[1];
        var script1 = transaction.slice(offset, offset + varint[0]);
        offset += varint[0];
        outputs.push({
            amount: amount,
            script: script1
        });
    }
    if (witness) {
        witnessScript = transaction.slice(offset, -4);
        locktime = transaction.slice(transaction.length - 4);
    } else if (!isZcashv5) locktime = transaction.slice(offset, offset + 4);
    offset += 4;
    if ((overwinter || isDecred) && !isZcashv5) {
        nExpiryHeight = transaction.slice(offset, offset + 4);
        offset += 4;
    }
    if (hasExtraData) extraData = transaction.slice(offset);
    //Get witnesses for Decred
    if (isDecred) {
        varint = (0, $df80e223f69a4e4d$export$aa1483be3b95dbf)(transaction, offset);
        offset += varint[1];
        if (varint[0] !== numberInputs) throw new Error("splitTransaction: incoherent number of witnesses");
        for(var i2 = 0; i2 < numberInputs; i2++){
            //amount
            offset += 8;
            //block height
            offset += 4;
            //block index
            offset += 4;
            //Script size
            varint = (0, $df80e223f69a4e4d$export$aa1483be3b95dbf)(transaction, offset);
            offset += varint[1];
            var script2 = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
            inputs[i2].script = script2;
        }
    }
    var t = {
        version: version,
        inputs: inputs,
        outputs: outputs,
        locktime: locktime,
        witness: witnessScript,
        timestamp: timestamp,
        nVersionGroupId: nVersionGroupId,
        nExpiryHeight: nExpiryHeight,
        extraData: extraData
    };
    (0, $1da806d2fc522c7e$export$bef1f36f5486a6a3)("btc", "splitTransaction ".concat(transactionHex, ":\n").concat((0, $b7dc3bc7e4df2ee6$export$83ccbb54a35801e8)(t)));
    return t;
}



var $6qu4b = parcelRequire("6qu4b");







var $ilnag = parcelRequire("ilnag");
var $bc5c2ae986e190fa$require$Buffer = $ilnag.Buffer;
var $bc5c2ae986e190fa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bc5c2ae986e190fa$var$defaultArg = {
    lockTime: (0, $163b3efa8595af0e$export$7e0b52e7059ffec7),
    sigHashType: (0, $163b3efa8595af0e$export$f53d15270899011f),
    segwit: false,
    transactionVersion: (0, $163b3efa8595af0e$export$363ebe89e6e7aeef)
};
function $bc5c2ae986e190fa$export$3cec8aff7aab66b(transport, arg) {
    return $bc5c2ae986e190fa$var$__awaiter(this, void 0, void 0, function() {
        var _Object_assign, inputs, associatedKeysets, outputScriptHex, lockTime, sigHashType, segwit, transactionVersion, nullScript, nullPrevout, defaultVersion, trustedInputs, regularOutputs, signatures, firstRun, resuming, targetTransaction, getTrustedInputCall, outputScript, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, trustedInput, sequence, outputs, index, err, i, sequence1, i1, input1, script, pseudoTX, pseudoTrustedInputs, signature;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Object_assign = Object.assign(Object.assign({}, $bc5c2ae986e190fa$var$defaultArg), arg), inputs = _Object_assign.inputs, associatedKeysets = _Object_assign.associatedKeysets, outputScriptHex = _Object_assign.outputScriptHex, lockTime = _Object_assign.lockTime, sigHashType = _Object_assign.sigHashType, segwit = _Object_assign.segwit, transactionVersion = _Object_assign.transactionVersion;
                    // Inputs are provided as arrays of [transaction, output_index, redeem script, optional sequence]
                    // associatedKeysets are provided as arrays of [path]
                    nullScript = $bc5c2ae986e190fa$require$Buffer.alloc(0);
                    nullPrevout = $bc5c2ae986e190fa$require$Buffer.alloc(0);
                    defaultVersion = $bc5c2ae986e190fa$require$Buffer.alloc(4);
                    defaultVersion.writeUInt32LE(transactionVersion, 0);
                    trustedInputs = [];
                    regularOutputs = [];
                    signatures = [];
                    firstRun = true;
                    resuming = false;
                    targetTransaction = {
                        inputs: [],
                        version: defaultVersion
                    };
                    getTrustedInputCall = segwit ? (0, $900480f4a2b90723$export$33b7242117f697d5) : (0, $72f03fa13b63a09b$export$31ab969c8a87fc21);
                    outputScript = $bc5c2ae986e190fa$require$Buffer.from(outputScriptHex, "hex");
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _iterator = inputs[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    input = _step.value;
                    if (!!resuming) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        getTrustedInputCall(transport, input[1], input[0])
                    ];
                case 3:
                    trustedInput = _state.sent();
                    sequence = $bc5c2ae986e190fa$require$Buffer.alloc(4);
                    sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $163b3efa8595af0e$export$57fe8370989728bf), 0);
                    trustedInputs.push({
                        trustedInput: false,
                        value: segwit ? $bc5c2ae986e190fa$require$Buffer.from(trustedInput, "hex") : $bc5c2ae986e190fa$require$Buffer.from(trustedInput, "hex").slice(4, 40),
                        sequence: sequence
                    });
                    _state.label = 4;
                case 4:
                    outputs = input[0].outputs;
                    index = input[1];
                    if (outputs && index <= outputs.length - 1) regularOutputs.push(outputs[index]);
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    // Pre-build the target transaction
                    for(i = 0; i < inputs.length; i++){
                        sequence1 = $bc5c2ae986e190fa$require$Buffer.alloc(4);
                        sequence1.writeUInt32LE(inputs[i].length >= 4 && typeof inputs[i][3] === "number" ? inputs[i][3] : (0, $163b3efa8595af0e$export$57fe8370989728bf), 0);
                        targetTransaction.inputs.push({
                            script: nullScript,
                            prevout: nullPrevout,
                            sequence: sequence1
                        });
                    }
                    if (!segwit) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        (0, $f089a464d071c8ad$export$fe75eaa1344c36c1)(transport, true, targetTransaction, trustedInputs, true)
                    ];
                case 10:
                    _state.sent();
                    return [
                        4,
                        (0, $d81f67c97ca26db7$export$34dd66230370b398)(transport, outputScript)
                    ];
                case 11:
                    _state.sent();
                    _state.label = 12;
                case 12:
                    i1 = 0;
                    _state.label = 13;
                case 13:
                    if (!(i1 < inputs.length)) return [
                        3,
                        19
                    ];
                    input1 = inputs[i1];
                    script = inputs[i1].length >= 3 && typeof input1[2] === "string" ? $bc5c2ae986e190fa$require$Buffer.from(input1[2], "hex") : regularOutputs[i1].script;
                    pseudoTX = Object.assign({}, targetTransaction);
                    pseudoTrustedInputs = segwit ? [
                        trustedInputs[i1]
                    ] : trustedInputs;
                    if (segwit) pseudoTX.inputs = [
                        Object.assign(Object.assign({}, pseudoTX.inputs[i1]), {
                            script: script
                        })
                    ];
                    else pseudoTX.inputs[i1].script = script;
                    return [
                        4,
                        (0, $f089a464d071c8ad$export$fe75eaa1344c36c1)(transport, !segwit && firstRun, pseudoTX, pseudoTrustedInputs, segwit)
                    ];
                case 14:
                    _state.sent();
                    if (!!segwit) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        (0, $d81f67c97ca26db7$export$34dd66230370b398)(transport, outputScript)
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    return [
                        4,
                        (0, $b4148d7fbddc3a38$export$6ad02cc4966b42ab)(transport, associatedKeysets[i1], lockTime, sigHashType)
                    ];
                case 17:
                    signature = _state.sent();
                    signatures.push(segwit ? signature.toString("hex") : signature.slice(0, signature.length - 1).toString("hex"));
                    targetTransaction.inputs[i1].script = nullScript;
                    if (firstRun) firstRun = false;
                    _state.label = 18;
                case 18:
                    i1++;
                    return [
                        3,
                        13
                    ];
                case 19:
                    return [
                        2,
                        signatures
                    ];
            }
        });
    });
}



var $6c687ba53a124d05$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6c687ba53a124d05$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Btc(param) {
        var transport = param.transport, _param_scrambleKey = param.scrambleKey, scrambleKey = _param_scrambleKey === void 0 ? "BTC" : _param_scrambleKey, _param_currency = param.currency, currency = _param_currency === void 0 ? "bitcoin" : _param_currency;
        var _this = this;
        (0, $7dKN1._)(this, Btc);
        this._transport = transport;
        this._transport.decorateAppAPIMethods(this, [
            "getWalletXpub",
            "getWalletPublicKey",
            "signP2SHTransaction",
            "signMessage",
            "createPaymentTransaction",
            "getTrustedInput",
            "getTrustedInputBIP143"
        ], scrambleKey);
        this._impl = function() {
            switch(currency){
                case "bitcoin":
                case "bitcoin_testnet":
                case "qtum":
                    // new APDU (nano app API) for currencies using app-bitcoin-new implementation
                    return new (0, $3bfd867659cb4a1b$export$2e2bcd8739ae039)(new (0, $9824097b8a3b32ce$export$9bbedc1992a787b4)(_this._transport));
                default:
                    // old APDU (legacy API) for currencies using legacy bitcoin app implementation
                    return new (0, $27bb53c6025dce1a$export$2e2bcd8739ae039)(_this._transport);
            }
        }();
    }
    (0, $eW5pA._)(Btc, [
        {
            /**
     * Get an XPUB with a ledger device
     * @param arg derivation parameter
     * - path: a BIP 32 path of the account level. (e.g. The derivation path `84'/0'/0'`
     * follows the `purpose' / coin_type' / account'` standard, with purpose=84, coin_type=0, account=0)
     * - xpubVersion: the XPUBVersion of the coin used. (refer to ledgerjs/packages/cryptoassets/src/currencies.ts
     * for the XPUBVersion value if needed)
     * @returns XPUB of the account
     */ key: "getWalletXpub",
            value: function getWalletXpub(arg) {
                return this.changeImplIfNecessary().then(function(impl) {
                    return impl.getWalletXpub(arg);
                });
            }
        },
        {
            /**
     * @param path a BIP 32 path (i.e. the `purpose’ / coin_type’ / account’ / change / address_index` standard)
     * @param options an object with optional these fields:
     *
     * - verify (boolean) whether ask user to confirm the address on the device
     *
     * - format ("legacy" | "p2sh" | "bech32" | "bech32m" | "cashaddr") to use different bitcoin address formatter.
     *
     * NB The normal usage is to use:
     *
     * - legacy format with 44' paths
     *
     * - p2sh format with 49' paths
     *
     * - bech32 format with 84' paths
     *
     * - bech32m format with 86' paths
     *
     * - cashaddr in case of Bitcoin Cash
     *
     * @example
     * btc.getWalletPublicKey("44'/0'/0'/0/0").then(o => o.bitcoinAddress)
     * btc.getWalletPublicKey("49'/0'/0'/0/0", { format: "p2sh" }).then(o => o.bitcoinAddress)
     */ key: "getWalletPublicKey",
            value: function getWalletPublicKey(path, opts) {
                var options;
                if (arguments.length > 2 || typeof opts === "boolean") {
                    console.warn("btc.getWalletPublicKey deprecated signature used. Please switch to getWalletPublicKey(path, { format, verify })");
                    options = {
                        verify: !!opts,
                        // eslint-disable-next-line prefer-rest-params
                        format: arguments[2] ? "p2sh" : "legacy"
                    };
                } else options = opts || {};
                return this.changeImplIfNecessary().then(function(impl) {
                    return impl.getWalletPublicKey(path, options);
                });
            }
        },
        {
            /**
     * You can sign a message according to the Bitcoin Signature format and retrieve v, r, s given the message and the BIP 32 path of the account to sign.
     * @example
     btc.signMessage("44'/60'/0'/0'/0", Buffer.from("test").toString("hex")).then(function(result) {
       var v = result['v'] + 27 + 4;
       var signature = Buffer.from(v.toString(16) + result['r'] + result['s'], 'hex').toString('base64');
       console.log("Signature : " + signature);
     }).catch(function(ex) {console.log(ex);});
     */ key: "signMessage",
            value: function signMessage(path, messageHex) {
                return this.changeImplIfNecessary().then(function(impl) {
                    return impl.signMessage({
                        path: path,
                        messageHex: messageHex
                    });
                });
            }
        },
        {
            /**
     * To sign a transaction involving standard (P2PKH) inputs, call createTransaction with the following parameters
     * @param inputs is an array of [ transaction, output_index, optional redeem script, optional sequence ] where
     *
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the optional redeem script to use when consuming a Segregated Witness input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param changePath is an optional BIP 32 path pointing to the path to the public key used to compute the change address
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign, including leading vararg voutCount
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @param segwit is an optional boolean indicating wether to use segwit or not. This includes wrapped segwit.
     * @param additionals list of additionnal options
     *
     * - "bech32" for spending native segwit outputs
     * - "bech32m" for spending segwit v1+ outputs
     * - "abc" for bch
     * - "gold" for btg
     * - "decred" for decred
     * - "zcash" for zcash
     * - "bipxxx" for using BIPxxx
     * - "sapling" to indicate a zec transaction is supporting sapling (to be set over block 419200)
     * @param expiryHeight is an optional Buffer for zec overwinter / sapling Txs
     * @param useTrustedInputForSegwit trust inputs for segwit transactions. If app version >= 1.4.0 this should be true.
     * @return the signed transaction ready to be broadcast
     * @example
    btc.createTransaction({
     inputs: [ [tx1, 1] ],
     associatedKeysets: ["0'/0/0"],
     outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(res => ...);
     */ key: "createPaymentTransaction",
            value: function createPaymentTransaction(arg) {
                if (arguments.length > 1) throw new Error("@ledgerhq/hw-app-btc: createPaymentTransaction multi argument signature is deprecated. please switch to named parameters.");
                return this.changeImplIfNecessary().then(function(impl) {
                    return impl.createPaymentTransaction(arg);
                });
            }
        },
        {
            /**
     * To obtain the signature of multisignature (P2SH) inputs, call signP2SHTransaction_async with the folowing parameters
     * @param inputs is an array of [ transaction, output_index, redeem script, optional sequence ] where
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the mandatory redeem script associated to the current P2SH input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @return the signed transaction ready to be broadcast
     * @example
    btc.signP2SHTransaction({
    inputs: [ [tx, 1, "52210289b4a3ad52a919abd2bdd6920d8a6879b1e788c38aa76f0440a6f32a9f1996d02103a3393b1439d1693b063482c04bd40142db97bdf139eedd1b51ffb7070a37eac321030b9a409a1e476b0d5d17b804fcdb81cf30f9b99c6f3ae1178206e08bc500639853ae"] ],
    associatedKeysets: ["0'/0/0"],
    outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(result => ...);
     */ key: "signP2SHTransaction",
            value: function signP2SHTransaction1(arg) {
                return (0, $bc5c2ae986e190fa$export$3cec8aff7aab66b)(this._transport, arg);
            }
        },
        {
            /**
     * For each UTXO included in your transaction, create a transaction object from the raw serialized version of the transaction used in this UTXO.
     * @param transactionHex a raw hexadecimal serialized transaction
     * @param isSegwitSupported is a boolean indicating if the segwit is supported
     * @param hasExtraData is a boolean (komodo, zencash and zcash include extraData in their transactions, others don't)
     * @param additionals list of additionnal options
     * @return the transaction object deserialized from the raw hexadecimal transaction
     * @example
    const tx1 = btc.splitTransaction("01000000014ea60aeac5252c14291d428915bd7ccd1bfc4af009f4d4dc57ae597ed0420b71010000008a47304402201f36a12c240dbf9e566bc04321050b1984cd6eaf6caee8f02bb0bfec08e3354b022012ee2aeadcbbfd1e92959f57c15c1c6debb757b798451b104665aa3010569b49014104090b15bde569386734abf2a2b99f9ca6a50656627e77de663ca7325702769986cf26cc9dd7fdea0af432c8e2becc867c932e1b9dd742f2a108997c2252e2bdebffffffff0281b72e00000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88aca0860100000000001976a9144533f5fb9b4817f713c48f0bfe96b9f50c476c9b88ac00000000");
     */ key: "splitTransaction",
            value: function splitTransaction1(transactionHex) {
                var isSegwitSupported = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, hasExtraData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, additionals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
                return (0, $a484a747c0b9641c$export$58013ee1a5c7c230)(transactionHex, isSegwitSupported, hasExtraData, additionals);
            }
        },
        {
            /**
     * Serialize a transaction's outputs to hexadecimal
     * @example
    const tx1 = btc.splitTransaction("01000000014ea60aeac5252c14291d428915bd7ccd1bfc4af009f4d4dc57ae597ed0420b71010000008a47304402201f36a12c240dbf9e566bc04321050b1984cd6eaf6caee8f02bb0bfec08e3354b022012ee2aeadcbbfd1e92959f57c15c1c6debb757b798451b104665aa3010569b49014104090b15bde569386734abf2a2b99f9ca6a50656627e77de663ca7325702769986cf26cc9dd7fdea0af432c8e2becc867c932e1b9dd742f2a108997c2252e2bdebffffffff0281b72e00000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88aca0860100000000001976a9144533f5fb9b4817f713c48f0bfe96b9f50c476c9b88ac00000000");
    const outputScript = btc.serializeTransactionOutputs(tx1).toString('hex');
    */ key: "serializeTransactionOutputs",
            value: function serializeTransactionOutputs1(t) {
                return (0, $ee4d0822350d8bd1$export$e6e9ad4770a214a8)(t);
            }
        },
        {
            /**
     * Trusted input is the hash of a UTXO that needs to be signed
     * For Legacy transactions, the app has some APDUs flows that do the amount check for an UTXO,
     * by parsing the transaction that created this UTXO
     */ key: "getTrustedInput",
            value: function getTrustedInput1(indexLookup, transaction) {
                var additionals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                return (0, $72f03fa13b63a09b$export$31ab969c8a87fc21)(this._transport, indexLookup, transaction, additionals);
            }
        },
        {
            /**
     * Trusted input is the hash of a UTXO that needs to be signed. BIP143 is used for Segwit inputs.
     */ key: "getTrustedInputBIP143",
            value: function getTrustedInputBIP1431(indexLookup, transaction) {
                var additionals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                return (0, $900480f4a2b90723$export$33b7242117f697d5)(this._transport, indexLookup, transaction, additionals);
            }
        },
        {
            key: "changeImplIfNecessary",
            value: function changeImplIfNecessary() {
                return $6c687ba53a124d05$var$__awaiter(this, void 0, void 0, function() {
                    var _this, _ref, name, version, isBtcLegacy;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                // if BtcOld was instantiated, stick with it
                                if (this._impl instanceof (0, $27bb53c6025dce1a$export$2e2bcd8739ae039)) return [
                                    2,
                                    this._impl
                                ];
                                return [
                                    4,
                                    (0, $c59dbc3737457f3b$export$bd21f07fb59bc20d)(this._transport)
                                ];
                            case 1:
                                _ref = _state.sent(), name = _ref.name, version = _ref.version;
                                return [
                                    4,
                                    function() {
                                        return $6c687ba53a124d05$var$__awaiter(_this, void 0, void 0, function() {
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        switch(name){
                                                            case "Bitcoin":
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case "Bitcoin Test":
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case "Bitcoin Legacy":
                                                                return [
                                                                    3,
                                                                    2
                                                                ];
                                                            case "Bitcoin Test Legacy":
                                                                return [
                                                                    3,
                                                                    2
                                                                ];
                                                            case "Exchange":
                                                                return [
                                                                    3,
                                                                    3
                                                                ];
                                                            case "Qtum":
                                                                return [
                                                                    3,
                                                                    5
                                                                ];
                                                        }
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 1:
                                                        // we use the legacy protocol for versions below 2.1.0 of the Bitcoin app.
                                                        return [
                                                            2,
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($3ddfffd3116f371d$exports))).lt(version, "2.1.0")
                                                        ];
                                                    case 2:
                                                        // the "Bitcoin Legacy" and "Bitcoin Testnet Legacy" app use the legacy protocol, regardless of the version
                                                        return [
                                                            2,
                                                            true
                                                        ];
                                                    case 3:
                                                        return [
                                                            4,
                                                            (0, $c59dbc3737457f3b$export$33e1ebd1430bed57)(this._transport)
                                                        ];
                                                    case 4:
                                                        // We can't query the version of the Bitcoin app if we're coming from Exchange;
                                                        // therefore, we use a workaround to distinguish legacy and new versions.
                                                        // This can be removed once Ledger Live enforces minimum bitcoin version >= 2.1.0.
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                    case 5:
                                                        // we use the legacy protocol for versions below 3.0.0 of the Qtum app.
                                                        return [
                                                            2,
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($3ddfffd3116f371d$exports))).lt(version, "3.0.0")
                                                        ];
                                                    case 6:
                                                        return [
                                                            2,
                                                            true
                                                        ];
                                                    case 7:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    }()
                                ];
                            case 2:
                                isBtcLegacy = _state.sent();
                                if (isBtcLegacy) this._impl = new (0, $27bb53c6025dce1a$export$2e2bcd8739ae039)(this._transport);
                                return [
                                    2,
                                    this._impl
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return Btc;
}();


var $881b6534ce6ec462$exports = {};
"use strict";
Object.defineProperty($881b6534ce6ec462$exports, "__esModule", {
    value: true
});
$881b6534ce6ec462$exports.initEccLib = $881b6534ce6ec462$exports.Transaction = $881b6534ce6ec462$exports.opcodes = $881b6534ce6ec462$exports.Psbt = $881b6534ce6ec462$exports.Block = $881b6534ce6ec462$exports.script = $881b6534ce6ec462$exports.payments = $881b6534ce6ec462$exports.networks = $881b6534ce6ec462$exports.crypto = $881b6534ce6ec462$exports.address = void 0;
var $7c5b8444ede2c46b$exports = {};

var $ilnag = parcelRequire("ilnag");
var $7c5b8444ede2c46b$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($7c5b8444ede2c46b$exports, "__esModule", {
    value: true
});
$7c5b8444ede2c46b$exports.toOutputScript = $7c5b8444ede2c46b$exports.fromOutputScript = $7c5b8444ede2c46b$exports.toBech32 = $7c5b8444ede2c46b$exports.toBase58Check = $7c5b8444ede2c46b$exports.fromBech32 = $7c5b8444ede2c46b$exports.fromBase58Check = void 0;
var $6945d51b6afc3226$exports = {};
"use strict";
// https://en.bitcoin.it/wiki/List_of_address_prefixes
// Dogecoin BIP32 is a proposed standard: https://bitcointalk.org/index.php?topic=409731
Object.defineProperty($6945d51b6afc3226$exports, "__esModule", {
    value: true
});
$6945d51b6afc3226$exports.testnet = $6945d51b6afc3226$exports.regtest = $6945d51b6afc3226$exports.bitcoin = void 0;
/**
 * Represents the Bitcoin network configuration.
 */ $6945d51b6afc3226$exports.bitcoin = {
    /**
   * The message prefix used for signing Bitcoin messages.
   */ messagePrefix: "\x18Bitcoin Signed Message:\n",
    /**
   * The Bech32 prefix used for Bitcoin addresses.
   */ bech32: "bc",
    /**
   * The BIP32 key prefixes for Bitcoin.
   */ bip32: {
        /**
     * The public key prefix for BIP32 extended public keys.
     */ public: 0x0488b21e,
        /**
     * The private key prefix for BIP32 extended private keys.
     */ private: 0x0488ade4
    },
    /**
   * The prefix for Bitcoin public key hashes.
   */ pubKeyHash: 0x00,
    /**
   * The prefix for Bitcoin script hashes.
   */ scriptHash: 0x05,
    /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */ wif: 0x80
};
/**
 * Represents the regtest network configuration.
 */ $6945d51b6afc3226$exports.regtest = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bcrt",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
/**
 * Represents the testnet network configuration.
 */ $6945d51b6afc3226$exports.testnet = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};


var $9771a9b72cb50314$exports = {};
"use strict";
Object.defineProperty($9771a9b72cb50314$exports, "__esModule", {
    value: true
});
$9771a9b72cb50314$exports.p2tr = $9771a9b72cb50314$exports.p2wsh = $9771a9b72cb50314$exports.p2wpkh = $9771a9b72cb50314$exports.p2sh = $9771a9b72cb50314$exports.p2pkh = $9771a9b72cb50314$exports.p2pk = $9771a9b72cb50314$exports.p2ms = $9771a9b72cb50314$exports.embed = void 0;
var $0cba35f254d2cb34$exports = {};
"use strict";
Object.defineProperty($0cba35f254d2cb34$exports, "__esModule", {
    value: true
});
$0cba35f254d2cb34$exports.p2data = void 0;

var $cbd225966f86718e$exports = {};

var $ilnag = parcelRequire("ilnag");
var $cbd225966f86718e$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($cbd225966f86718e$exports, "__esModule", {
    value: true
});
$cbd225966f86718e$exports.signature = $cbd225966f86718e$exports.number = $cbd225966f86718e$exports.isCanonicalScriptSignature = $cbd225966f86718e$exports.isDefinedHashType = $cbd225966f86718e$exports.isCanonicalPubKey = $cbd225966f86718e$exports.toStack = $cbd225966f86718e$exports.fromASM = $cbd225966f86718e$exports.toASM = $cbd225966f86718e$exports.decompile = $cbd225966f86718e$exports.compile = $cbd225966f86718e$exports.countNonPushOnlyOPs = $cbd225966f86718e$exports.isPushOnly = $cbd225966f86718e$exports.OPS = void 0;
var $419bde69d1b9d8f9$exports = {};

var $ilnag = parcelRequire("ilnag");
var $419bde69d1b9d8f9$require$Buffer = $ilnag.Buffer;
"use strict";
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use
Object.defineProperty($419bde69d1b9d8f9$exports, "__esModule", {
    value: true
});
$419bde69d1b9d8f9$exports.encode = $419bde69d1b9d8f9$exports.decode = $419bde69d1b9d8f9$exports.check = void 0;
function $419bde69d1b9d8f9$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    var lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    var lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
$419bde69d1b9d8f9$exports.check = $419bde69d1b9d8f9$var$check;
function $419bde69d1b9d8f9$var$decode(buffer) {
    if (buffer.length < 8) throw new Error("DER sequence length is too short");
    if (buffer.length > 72) throw new Error("DER sequence length is too long");
    if (buffer[0] !== 0x30) throw new Error("Expected DER sequence");
    if (buffer[1] !== buffer.length - 2) throw new Error("DER sequence length is invalid");
    if (buffer[2] !== 0x02) throw new Error("Expected DER integer");
    var lenR = buffer[3];
    if (lenR === 0) throw new Error("R length is zero");
    if (5 + lenR >= buffer.length) throw new Error("R length is too long");
    if (buffer[4 + lenR] !== 0x02) throw new Error("Expected DER integer (2)");
    var lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error("S length is zero");
    if (6 + lenR + lenS !== buffer.length) throw new Error("S length is invalid");
    if (buffer[4] & 0x80) throw new Error("R value is negative");
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error("R value excessively padded");
    if (buffer[lenR + 6] & 0x80) throw new Error("S value is negative");
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error("S value excessively padded");
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
$419bde69d1b9d8f9$exports.decode = $419bde69d1b9d8f9$var$decode;
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
 */ function $419bde69d1b9d8f9$var$encode(r, s) {
    var lenR = r.length;
    var lenS = s.length;
    if (lenR === 0) throw new Error("R length is zero");
    if (lenS === 0) throw new Error("S length is zero");
    if (lenR > 33) throw new Error("R length is too long");
    if (lenS > 33) throw new Error("S length is too long");
    if (r[0] & 0x80) throw new Error("R value is negative");
    if (s[0] & 0x80) throw new Error("S value is negative");
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error("R value excessively padded");
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error("S value excessively padded");
    var signature = $419bde69d1b9d8f9$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
$419bde69d1b9d8f9$exports.encode = $419bde69d1b9d8f9$var$encode;


var $822920c23b5c1ebc$exports = {};
"use strict";
Object.defineProperty($822920c23b5c1ebc$exports, "__esModule", {
    value: true
});
$822920c23b5c1ebc$exports.REVERSE_OPS = $822920c23b5c1ebc$exports.OPS = void 0;
var $822920c23b5c1ebc$var$OPS = {
    OP_FALSE: 0,
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_RESERVED: 80,
    OP_TRUE: 81,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_VER: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_VERIF: 101,
    OP_VERNOTIF: 102,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_CAT: 126,
    OP_SUBSTR: 127,
    OP_LEFT: 128,
    OP_RIGHT: 129,
    OP_SIZE: 130,
    OP_INVERT: 131,
    OP_AND: 132,
    OP_OR: 133,
    OP_XOR: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_RESERVED1: 137,
    OP_RESERVED2: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_2MUL: 141,
    OP_2DIV: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_MUL: 149,
    OP_DIV: 150,
    OP_MOD: 151,
    OP_LSHIFT: 152,
    OP_RSHIFT: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_NOP2: 177,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_NOP3: 178,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_PUBKEYHASH: 253,
    OP_PUBKEY: 254,
    OP_INVALIDOPCODE: 255
};
$822920c23b5c1ebc$exports.OPS = $822920c23b5c1ebc$var$OPS;
var $822920c23b5c1ebc$var$REVERSE_OPS = {};
$822920c23b5c1ebc$exports.REVERSE_OPS = $822920c23b5c1ebc$var$REVERSE_OPS;
var $822920c23b5c1ebc$var$_iteratorNormalCompletion = true, $822920c23b5c1ebc$var$_didIteratorError = false, $822920c23b5c1ebc$var$_iteratorError = undefined;
try {
    for(var $822920c23b5c1ebc$var$_iterator = Object.keys($822920c23b5c1ebc$var$OPS)[Symbol.iterator](), $822920c23b5c1ebc$var$_step; !($822920c23b5c1ebc$var$_iteratorNormalCompletion = ($822920c23b5c1ebc$var$_step = $822920c23b5c1ebc$var$_iterator.next()).done); $822920c23b5c1ebc$var$_iteratorNormalCompletion = true){
        var $822920c23b5c1ebc$var$op = $822920c23b5c1ebc$var$_step.value;
        var $822920c23b5c1ebc$var$code = $822920c23b5c1ebc$var$OPS[$822920c23b5c1ebc$var$op];
        $822920c23b5c1ebc$var$REVERSE_OPS[$822920c23b5c1ebc$var$code] = $822920c23b5c1ebc$var$op;
    }
} catch (err) {
    $822920c23b5c1ebc$var$_didIteratorError = true;
    $822920c23b5c1ebc$var$_iteratorError = err;
} finally{
    try {
        if (!$822920c23b5c1ebc$var$_iteratorNormalCompletion && $822920c23b5c1ebc$var$_iterator.return != null) {
            $822920c23b5c1ebc$var$_iterator.return();
        }
    } finally{
        if ($822920c23b5c1ebc$var$_didIteratorError) {
            throw $822920c23b5c1ebc$var$_iteratorError;
        }
    }
}


Object.defineProperty($cbd225966f86718e$exports, "OPS", {
    enumerable: true,
    get: function get() {
        return $822920c23b5c1ebc$exports.OPS;
    }
});
var $98c74a6d9c498f91$exports = {};
"use strict";
Object.defineProperty($98c74a6d9c498f91$exports, "__esModule", {
    value: true
});
$98c74a6d9c498f91$exports.decode = $98c74a6d9c498f91$exports.encode = $98c74a6d9c498f91$exports.encodingLength = void 0;

/**
 * Calculates the encoding length of a number used for push data in Bitcoin transactions.
 * @param i The number to calculate the encoding length for.
 * @returns The encoding length of the number.
 */ function $98c74a6d9c498f91$var$encodingLength(i) {
    return i < $822920c23b5c1ebc$exports.OPS.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
$98c74a6d9c498f91$exports.encodingLength = $98c74a6d9c498f91$var$encodingLength;
/**
 * Encodes a number into a buffer using a variable-length encoding scheme.
 * The encoded buffer is written starting at the specified offset.
 * Returns the size of the encoded buffer.
 *
 * @param buffer - The buffer to write the encoded data into.
 * @param num - The number to encode.
 * @param offset - The offset at which to start writing the encoded buffer.
 * @returns The size of the encoded buffer.
 */ function $98c74a6d9c498f91$var$encode(buffer, num, offset) {
    var size = $98c74a6d9c498f91$var$encodingLength(num);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(num, offset);
    else if (size === 2) {
        buffer.writeUInt8($822920c23b5c1ebc$exports.OPS.OP_PUSHDATA1, offset);
        buffer.writeUInt8(num, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($822920c23b5c1ebc$exports.OPS.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(num, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($822920c23b5c1ebc$exports.OPS.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(num, offset + 1);
    }
    return size;
}
$98c74a6d9c498f91$exports.encode = $98c74a6d9c498f91$var$encode;
/**
 * Decodes a buffer and returns information about the opcode, number, and size.
 * @param buffer - The buffer to decode.
 * @param offset - The offset within the buffer to start decoding.
 * @returns An object containing the opcode, number, and size, or null if decoding fails.
 */ function $98c74a6d9c498f91$var$decode(buffer, offset) {
    var opcode = buffer.readUInt8(offset);
    var num;
    var size;
    // ~6 bit
    if (opcode < $822920c23b5c1ebc$exports.OPS.OP_PUSHDATA1) {
        num = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $822920c23b5c1ebc$exports.OPS.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        num = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $822920c23b5c1ebc$exports.OPS.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        num = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $822920c23b5c1ebc$exports.OPS.OP_PUSHDATA4) throw new Error("Unexpected opcode");
        num = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: num,
        size: size
    };
}
$98c74a6d9c498f91$exports.decode = $98c74a6d9c498f91$var$decode;


var $6eb68c9245d42655$exports = {};

var $ilnag = parcelRequire("ilnag");
var $6eb68c9245d42655$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($6eb68c9245d42655$exports, "__esModule", {
    value: true
});
$6eb68c9245d42655$exports.encode = $6eb68c9245d42655$exports.decode = void 0;
/**
 * Decodes a script number from a buffer.
 *
 * @param buffer - The buffer containing the script number.
 * @param maxLength - The maximum length of the script number. Defaults to 4.
 * @param minimal - Whether the script number should be minimal. Defaults to true.
 * @returns The decoded script number.
 * @throws {TypeError} If the script number overflows the maximum length.
 * @throws {Error} If the script number is not minimally encoded when minimal is true.
 */ function $6eb68c9245d42655$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    var length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError("Script number overflow");
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error("Non-minimally encoded script number");
        }
    }
    // 40-bit
    if (length === 5) {
        var a = buffer.readUInt32LE(0);
        var b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    var result = 0;
    for(var i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
$6eb68c9245d42655$exports.decode = $6eb68c9245d42655$var$decode;
function $6eb68c9245d42655$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
/**
 * Encodes a number into a Buffer using a specific format.
 *
 * @param _number - The number to encode.
 * @returns The encoded number as a Buffer.
 */ function $6eb68c9245d42655$var$encode(_number) {
    var value = Math.abs(_number);
    var size = $6eb68c9245d42655$var$scriptNumSize(value);
    var buffer = $6eb68c9245d42655$require$Buffer.allocUnsafe(size);
    var negative = _number < 0;
    for(var i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
$6eb68c9245d42655$exports.encode = $6eb68c9245d42655$var$encode;


var $4adc76966f102bfe$exports = {};

var $ilnag = parcelRequire("ilnag");
var $4adc76966f102bfe$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($4adc76966f102bfe$exports, "__esModule", {
    value: true
});
$4adc76966f102bfe$exports.encode = $4adc76966f102bfe$exports.decode = void 0;


var $76e9130b49af92ba$exports = {};
"use strict";
Object.defineProperty($76e9130b49af92ba$exports, "__esModule", {
    value: true
});
$76e9130b49af92ba$exports.oneOf = $76e9130b49af92ba$exports.Null = $76e9130b49af92ba$exports.BufferN = $76e9130b49af92ba$exports.Function = $76e9130b49af92ba$exports.UInt32 = $76e9130b49af92ba$exports.UInt8 = $76e9130b49af92ba$exports.tuple = $76e9130b49af92ba$exports.maybe = $76e9130b49af92ba$exports.Hex = $76e9130b49af92ba$exports.Buffer = $76e9130b49af92ba$exports.String = $76e9130b49af92ba$exports.Boolean = $76e9130b49af92ba$exports.Array = $76e9130b49af92ba$exports.Number = $76e9130b49af92ba$exports.Hash256bit = $76e9130b49af92ba$exports.Hash160bit = $76e9130b49af92ba$exports.Buffer256bit = $76e9130b49af92ba$exports.isTaptree = $76e9130b49af92ba$exports.isTapleaf = $76e9130b49af92ba$exports.TAPLEAF_VERSION_MASK = $76e9130b49af92ba$exports.Satoshi = $76e9130b49af92ba$exports.isPoint = $76e9130b49af92ba$exports.stacksEqual = $76e9130b49af92ba$exports.typeforce = void 0;

var $ilnag = parcelRequire("ilnag");

$76e9130b49af92ba$exports.typeforce = (parcelRequire("e9ZU4"));
var $76e9130b49af92ba$var$ZERO32 = $ilnag.Buffer.alloc(32, 0);
var $76e9130b49af92ba$var$EC_P = $ilnag.Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
/**
 * Checks if two arrays of Buffers are equal.
 * @param a - The first array of Buffers.
 * @param b - The second array of Buffers.
 * @returns True if the arrays are equal, false otherwise.
 */ function $76e9130b49af92ba$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function(x, i) {
        return x.equals(b[i]);
    });
}
$76e9130b49af92ba$exports.stacksEqual = $76e9130b49af92ba$var$stacksEqual;
/**
 * Checks if the given value is a valid elliptic curve point.
 * @param p - The value to check.
 * @returns True if the value is a valid elliptic curve point, false otherwise.
 */ function $76e9130b49af92ba$var$isPoint(p) {
    if (!$ilnag.Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    var t = p[0];
    var x = p.slice(1, 33);
    if (x.compare($76e9130b49af92ba$var$ZERO32) === 0) return false;
    if (x.compare($76e9130b49af92ba$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) return true;
    var y = p.slice(33);
    if (y.compare($76e9130b49af92ba$var$ZERO32) === 0) return false;
    if (y.compare($76e9130b49af92ba$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
$76e9130b49af92ba$exports.isPoint = $76e9130b49af92ba$var$isPoint;
var $76e9130b49af92ba$var$SATOSHI_MAX = 21 * 1e14;
function $76e9130b49af92ba$var$Satoshi(value) {
    return $76e9130b49af92ba$exports.typeforce.UInt53(value) && value <= $76e9130b49af92ba$var$SATOSHI_MAX;
}
$76e9130b49af92ba$exports.Satoshi = $76e9130b49af92ba$var$Satoshi;
$76e9130b49af92ba$exports.TAPLEAF_VERSION_MASK = 0xfe;
function $76e9130b49af92ba$var$isTapleaf(o) {
    if (!o || !("output" in o)) return false;
    if (!$ilnag.Buffer.isBuffer(o.output)) return false;
    if (o.version !== undefined) return (o.version & $76e9130b49af92ba$exports.TAPLEAF_VERSION_MASK) === o.version;
    return true;
}
$76e9130b49af92ba$exports.isTapleaf = $76e9130b49af92ba$var$isTapleaf;
function $76e9130b49af92ba$var$isTaptree(scriptTree) {
    if (!(0, $76e9130b49af92ba$exports.Array)(scriptTree)) return $76e9130b49af92ba$var$isTapleaf(scriptTree);
    if (scriptTree.length !== 2) return false;
    return scriptTree.every(function(t) {
        return $76e9130b49af92ba$var$isTaptree(t);
    });
}
$76e9130b49af92ba$exports.isTaptree = $76e9130b49af92ba$var$isTaptree;
$76e9130b49af92ba$exports.Buffer256bit = $76e9130b49af92ba$exports.typeforce.BufferN(32);
$76e9130b49af92ba$exports.Hash160bit = $76e9130b49af92ba$exports.typeforce.BufferN(20);
$76e9130b49af92ba$exports.Hash256bit = $76e9130b49af92ba$exports.typeforce.BufferN(32);
$76e9130b49af92ba$exports.Number = $76e9130b49af92ba$exports.typeforce.Number;
$76e9130b49af92ba$exports.Array = $76e9130b49af92ba$exports.typeforce.Array;
$76e9130b49af92ba$exports.Boolean = $76e9130b49af92ba$exports.typeforce.Boolean;
$76e9130b49af92ba$exports.String = $76e9130b49af92ba$exports.typeforce.String;
$76e9130b49af92ba$exports.Buffer = $76e9130b49af92ba$exports.typeforce.Buffer;
$76e9130b49af92ba$exports.Hex = $76e9130b49af92ba$exports.typeforce.Hex;
$76e9130b49af92ba$exports.maybe = $76e9130b49af92ba$exports.typeforce.maybe;
$76e9130b49af92ba$exports.tuple = $76e9130b49af92ba$exports.typeforce.tuple;
$76e9130b49af92ba$exports.UInt8 = $76e9130b49af92ba$exports.typeforce.UInt8;
$76e9130b49af92ba$exports.UInt32 = $76e9130b49af92ba$exports.typeforce.UInt32;
$76e9130b49af92ba$exports.Function = $76e9130b49af92ba$exports.typeforce.Function;
$76e9130b49af92ba$exports.BufferN = $76e9130b49af92ba$exports.typeforce.BufferN;
$76e9130b49af92ba$exports.Null = $76e9130b49af92ba$exports.typeforce.Null;
$76e9130b49af92ba$exports.oneOf = $76e9130b49af92ba$exports.typeforce.oneOf;


var $4adc76966f102bfe$var$typeforce = $76e9130b49af92ba$exports.typeforce;
var $4adc76966f102bfe$var$ZERO = $4adc76966f102bfe$require$Buffer.alloc(1, 0);
/**
 * Converts a buffer to a DER-encoded buffer.
 * @param x - The buffer to be converted.
 * @returns The DER-encoded buffer.
 */ function $4adc76966f102bfe$var$toDER(x) {
    var i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $4adc76966f102bfe$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $4adc76966f102bfe$require$Buffer.concat([
        $4adc76966f102bfe$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
/**
 * Converts a DER-encoded signature to a buffer.
 * If the first byte of the input buffer is 0x00, it is skipped.
 * The resulting buffer is 32 bytes long, filled with zeros if necessary.
 * @param x - The DER-encoded signature.
 * @returns The converted buffer.
 */ function $4adc76966f102bfe$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    var buffer = $4adc76966f102bfe$require$Buffer.alloc(32, 0);
    var bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
/**
 * Decodes a buffer into a ScriptSignature object.
 * @param buffer - The buffer to decode.
 * @returns The decoded ScriptSignature object.
 * @throws Error if the hashType is invalid.
 */ function $4adc76966f102bfe$var$decode(buffer) {
    var hashType = buffer.readUInt8(buffer.length - 1);
    if (!(0, $cbd225966f86718e$exports.isDefinedHashType)(hashType)) throw new Error("Invalid hashType " + hashType);
    var decoded = $419bde69d1b9d8f9$exports.decode(buffer.slice(0, -1));
    var r = $4adc76966f102bfe$var$fromDER(decoded.r);
    var s = $4adc76966f102bfe$var$fromDER(decoded.s);
    var signature = $4adc76966f102bfe$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
$4adc76966f102bfe$exports.decode = $4adc76966f102bfe$var$decode;
/**
 * Encodes a signature and hash type into a buffer.
 * @param signature - The signature to encode.
 * @param hashType - The hash type to encode.
 * @returns The encoded buffer.
 * @throws Error if the hashType is invalid.
 */ function $4adc76966f102bfe$var$encode(signature, hashType) {
    $4adc76966f102bfe$var$typeforce({
        signature: $76e9130b49af92ba$exports.BufferN(64),
        hashType: $76e9130b49af92ba$exports.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    if (!(0, $cbd225966f86718e$exports.isDefinedHashType)(hashType)) throw new Error("Invalid hashType " + hashType);
    var hashTypeBuffer = $4adc76966f102bfe$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    var r = $4adc76966f102bfe$var$toDER(signature.slice(0, 32));
    var s = $4adc76966f102bfe$var$toDER(signature.slice(32, 64));
    return $4adc76966f102bfe$require$Buffer.concat([
        $419bde69d1b9d8f9$exports.encode(r, s),
        hashTypeBuffer
    ]);
}
$4adc76966f102bfe$exports.encode = $4adc76966f102bfe$var$encode;



var $cbd225966f86718e$var$typeforce = $76e9130b49af92ba$exports.typeforce;
var $cbd225966f86718e$var$OP_INT_BASE = $822920c23b5c1ebc$exports.OPS.OP_RESERVED; // OP_1 - 1
function $cbd225966f86718e$var$isOPInt(value) {
    return $76e9130b49af92ba$exports.Number(value) && (value === $822920c23b5c1ebc$exports.OPS.OP_0 || value >= $822920c23b5c1ebc$exports.OPS.OP_1 && value <= $822920c23b5c1ebc$exports.OPS.OP_16 || value === $822920c23b5c1ebc$exports.OPS.OP_1NEGATE);
}
function $cbd225966f86718e$var$isPushOnlyChunk(value) {
    return $76e9130b49af92ba$exports.Buffer(value) || $cbd225966f86718e$var$isOPInt(value);
}
function $cbd225966f86718e$var$isPushOnly(value) {
    return $76e9130b49af92ba$exports.Array(value) && value.every($cbd225966f86718e$var$isPushOnlyChunk);
}
$cbd225966f86718e$exports.isPushOnly = $cbd225966f86718e$var$isPushOnly;
function $cbd225966f86718e$var$countNonPushOnlyOPs(value) {
    return value.length - value.filter($cbd225966f86718e$var$isPushOnlyChunk).length;
}
$cbd225966f86718e$exports.countNonPushOnlyOPs = $cbd225966f86718e$var$countNonPushOnlyOPs;
function $cbd225966f86718e$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $822920c23b5c1ebc$exports.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $cbd225966f86718e$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $822920c23b5c1ebc$exports.OPS.OP_1NEGATE;
}
function $cbd225966f86718e$var$chunksIsBuffer(buf) {
    return $cbd225966f86718e$require$Buffer.isBuffer(buf);
}
function $cbd225966f86718e$var$chunksIsArray(buf) {
    return $76e9130b49af92ba$exports.Array(buf);
}
function $cbd225966f86718e$var$singleChunkIsBuffer(buf) {
    return $cbd225966f86718e$require$Buffer.isBuffer(buf);
}
/**
 * Compiles an array of chunks into a Buffer.
 *
 * @param chunks - The array of chunks to compile.
 * @returns The compiled Buffer.
 * @throws Error if the compilation fails.
 */ function $cbd225966f86718e$var$compile(chunks) {
    // TODO: remove me
    if ($cbd225966f86718e$var$chunksIsBuffer(chunks)) return chunks;
    $cbd225966f86718e$var$typeforce($76e9130b49af92ba$exports.Array, chunks);
    var bufferSize = chunks.reduce(function(accum, chunk) {
        // data chunk
        if ($cbd225966f86718e$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $cbd225966f86718e$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $98c74a6d9c498f91$exports.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    var buffer = $cbd225966f86718e$require$Buffer.allocUnsafe(bufferSize);
    var offset = 0;
    chunks.forEach(function(chunk) {
        // data chunk
        if ($cbd225966f86718e$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            var opcode = $cbd225966f86718e$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $98c74a6d9c498f91$exports.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error("Could not decode chunks");
    return buffer;
}
$cbd225966f86718e$exports.compile = $cbd225966f86718e$var$compile;
function $cbd225966f86718e$var$decompile(buffer) {
    // TODO: remove me
    if ($cbd225966f86718e$var$chunksIsArray(buffer)) return buffer;
    $cbd225966f86718e$var$typeforce($76e9130b49af92ba$exports.Buffer, buffer);
    var chunks = [];
    var i = 0;
    while(i < buffer.length){
        var opcode = buffer[i];
        // data chunk
        if (opcode > $822920c23b5c1ebc$exports.OPS.OP_0 && opcode <= $822920c23b5c1ebc$exports.OPS.OP_PUSHDATA4) {
            var d = $98c74a6d9c498f91$exports.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            var data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            var op = $cbd225966f86718e$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
$cbd225966f86718e$exports.decompile = $cbd225966f86718e$var$decompile;
/**
 * Converts the given chunks into an ASM (Assembly) string representation.
 * If the chunks parameter is a Buffer, it will be decompiled into a Stack before conversion.
 * @param chunks - The chunks to convert into ASM.
 * @returns The ASM string representation of the chunks.
 */ function $cbd225966f86718e$var$toASM(chunks) {
    if ($cbd225966f86718e$var$chunksIsBuffer(chunks)) chunks = $cbd225966f86718e$var$decompile(chunks);
    if (!chunks) throw new Error("Could not convert invalid chunks to ASM");
    return chunks.map(function(chunk) {
        // data?
        if ($cbd225966f86718e$var$singleChunkIsBuffer(chunk)) {
            var op = $cbd225966f86718e$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString("hex");
            chunk = op;
        }
        // opcode!
        return $822920c23b5c1ebc$exports.REVERSE_OPS[chunk];
    }).join(" ");
}
$cbd225966f86718e$exports.toASM = $cbd225966f86718e$var$toASM;
/**
 * Converts an ASM string to a Buffer.
 * @param asm The ASM string to convert.
 * @returns The converted Buffer.
 */ function $cbd225966f86718e$var$fromASM(asm) {
    $cbd225966f86718e$var$typeforce($76e9130b49af92ba$exports.String, asm);
    return $cbd225966f86718e$var$compile(asm.split(" ").map(function(chunkStr) {
        // opcode?
        if ($822920c23b5c1ebc$exports.OPS[chunkStr] !== undefined) return $822920c23b5c1ebc$exports.OPS[chunkStr];
        $cbd225966f86718e$var$typeforce($76e9130b49af92ba$exports.Hex, chunkStr);
        // data!
        return $cbd225966f86718e$require$Buffer.from(chunkStr, "hex");
    }));
}
$cbd225966f86718e$exports.fromASM = $cbd225966f86718e$var$fromASM;
/**
 * Converts the given chunks into a stack of buffers.
 *
 * @param chunks - The chunks to convert.
 * @returns The stack of buffers.
 */ function $cbd225966f86718e$var$toStack(chunks) {
    chunks = $cbd225966f86718e$var$decompile(chunks);
    $cbd225966f86718e$var$typeforce($cbd225966f86718e$var$isPushOnly, chunks);
    return chunks.map(function(op) {
        if ($cbd225966f86718e$var$singleChunkIsBuffer(op)) return op;
        if (op === $822920c23b5c1ebc$exports.OPS.OP_0) return $cbd225966f86718e$require$Buffer.allocUnsafe(0);
        return $6eb68c9245d42655$exports.encode(op - $cbd225966f86718e$var$OP_INT_BASE);
    });
}
$cbd225966f86718e$exports.toStack = $cbd225966f86718e$var$toStack;
function $cbd225966f86718e$var$isCanonicalPubKey(buffer) {
    return $76e9130b49af92ba$exports.isPoint(buffer);
}
$cbd225966f86718e$exports.isCanonicalPubKey = $cbd225966f86718e$var$isCanonicalPubKey;
function $cbd225966f86718e$var$isDefinedHashType(hashType) {
    var hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
$cbd225966f86718e$exports.isDefinedHashType = $cbd225966f86718e$var$isDefinedHashType;
function $cbd225966f86718e$var$isCanonicalScriptSignature(buffer) {
    if (!$cbd225966f86718e$require$Buffer.isBuffer(buffer)) return false;
    if (!$cbd225966f86718e$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $419bde69d1b9d8f9$exports.check(buffer.slice(0, -1));
}
$cbd225966f86718e$exports.isCanonicalScriptSignature = $cbd225966f86718e$var$isCanonicalScriptSignature;
$cbd225966f86718e$exports.number = $6eb68c9245d42655$exports;
$cbd225966f86718e$exports.signature = $4adc76966f102bfe$exports;



var $42ecdd0882a6eef0$exports = {};
"use strict";
Object.defineProperty($42ecdd0882a6eef0$exports, "__esModule", {
    value: true
});
$42ecdd0882a6eef0$exports.value = $42ecdd0882a6eef0$exports.prop = void 0;
function $42ecdd0882a6eef0$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set: function(_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
$42ecdd0882a6eef0$exports.prop = $42ecdd0882a6eef0$var$prop;
function $42ecdd0882a6eef0$var$value(f) {
    var _value;
    return function() {
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
$42ecdd0882a6eef0$exports.value = $42ecdd0882a6eef0$var$value;


var $0cba35f254d2cb34$var$OPS = $cbd225966f86718e$exports.OPS;
// output: OP_RETURN ...
/**
 * Embeds data in a Bitcoin payment.
 * @param a - The payment object.
 * @param opts - Optional payment options.
 * @returns The modified payment object.
 * @throws {TypeError} If there is not enough data or if the output is invalid.
 */ function $0cba35f254d2cb34$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
        data: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
    }, a);
    var network = a.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        name: "embed",
        network: network
    };
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!a.data) return;
        return $cbd225966f86718e$exports.compile([
            $0cba35f254d2cb34$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $42ecdd0882a6eef0$exports.prop(o, "data", function() {
        if (!a.output) return;
        return $cbd225966f86718e$exports.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            var chunks = $cbd225966f86718e$exports.decompile(a.output);
            if (chunks[0] !== $0cba35f254d2cb34$var$OPS.OP_RETURN) throw new TypeError("Output is invalid");
            if (!chunks.slice(1).every($76e9130b49af92ba$exports.typeforce.Buffer)) throw new TypeError("Output is invalid");
            if (a.data && !(0, $76e9130b49af92ba$exports.stacksEqual)(a.data, o.data)) throw new TypeError("Data mismatch");
        }
    }
    return Object.assign(o, a);
}
$0cba35f254d2cb34$exports.p2data = $0cba35f254d2cb34$var$p2data;


Object.defineProperty($9771a9b72cb50314$exports, "embed", {
    enumerable: true,
    get: function get() {
        return $0cba35f254d2cb34$exports.p2data;
    }
});
var $ee6cd2f98a3475a0$exports = {};
"use strict";
Object.defineProperty($ee6cd2f98a3475a0$exports, "__esModule", {
    value: true
});
$ee6cd2f98a3475a0$exports.p2ms = void 0;




var $ee6cd2f98a3475a0$var$OPS = $cbd225966f86718e$exports.OPS;
var $ee6cd2f98a3475a0$var$OP_INT_BASE = $ee6cd2f98a3475a0$var$OPS.OP_RESERVED; // OP_1 - 1
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
/**
 * Represents a function that creates a Pay-to-Multisig (P2MS) payment object.
 * @param a - The payment object.
 * @param opts - Optional payment options.
 * @returns The created payment object.
 * @throws {TypeError} If the provided data is not valid.
 */ function $ee6cd2f98a3475a0$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $cbd225966f86718e$exports.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $ee6cd2f98a3475a0$var$OPS.OP_0) !== undefined;
    }
    (0, $76e9130b49af92ba$exports.typeforce)({
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        m: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Number),
        n: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Number),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
        pubkeys: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.isPoint)),
        signatures: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf(isAcceptableSignature)),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer)
    }, a);
    var network = a.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        network: network
    };
    var chunks = [];
    var decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $cbd225966f86718e$exports.decompile(output);
        o.m = chunks[0] - $ee6cd2f98a3475a0$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $ee6cd2f98a3475a0$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $cbd225966f86718e$exports.compile([].concat($ee6cd2f98a3475a0$var$OP_INT_BASE + a.m, a.pubkeys, $ee6cd2f98a3475a0$var$OP_INT_BASE + o.n, $ee6cd2f98a3475a0$var$OPS.OP_CHECKMULTISIG));
    });
    $42ecdd0882a6eef0$exports.prop(o, "m", function() {
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $42ecdd0882a6eef0$exports.prop(o, "n", function() {
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $42ecdd0882a6eef0$exports.prop(o, "pubkeys", function() {
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $42ecdd0882a6eef0$exports.prop(o, "signatures", function() {
        if (!a.input) return;
        return $cbd225966f86718e$exports.decompile(a.input).slice(1);
    });
    $42ecdd0882a6eef0$exports.prop(o, "input", function() {
        if (!a.signatures) return;
        return $cbd225966f86718e$exports.compile([
            $ee6cd2f98a3475a0$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        if (!o.input) return;
        return [];
    });
    $42ecdd0882a6eef0$exports.prop(o, "name", function() {
        if (!o.m || !o.n) return;
        return "p2ms(".concat(o.m, " of ").concat(o.n, ")");
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$76e9130b49af92ba$exports.typeforce.Number(chunks[0])) throw new TypeError("Output is invalid");
            if (!$76e9130b49af92ba$exports.typeforce.Number(chunks[chunks.length - 2])) throw new TypeError("Output is invalid");
            if (chunks[chunks.length - 1] !== $ee6cd2f98a3475a0$var$OPS.OP_CHECKMULTISIG) throw new TypeError("Output is invalid");
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError("Output is invalid");
            if (!o.pubkeys.every(function(x) {
                return (0, $76e9130b49af92ba$exports.isPoint)(x);
            })) throw new TypeError("Output is invalid");
            if (a.m !== undefined && a.m !== o.m) throw new TypeError("m mismatch");
            if (a.n !== undefined && a.n !== o.n) throw new TypeError("n mismatch");
            if (a.pubkeys && !(0, $76e9130b49af92ba$exports.stacksEqual)(a.pubkeys, o.pubkeys)) throw new TypeError("Pubkeys mismatch");
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError("Pubkey count mismatch");
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError("Pubkey count cannot be less than m");
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError("Not enough signatures provided");
            if (a.signatures.length > o.m) throw new TypeError("Too many signatures provided");
        }
        if (a.input) {
            if (a.input[0] !== $ee6cd2f98a3475a0$var$OPS.OP_0) throw new TypeError("Input is invalid");
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError("Input has invalid signature(s)");
            if (a.signatures && !(0, $76e9130b49af92ba$exports.stacksEqual)(a.signatures, o.signatures)) throw new TypeError("Signature mismatch");
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError("Signature count mismatch");
        }
    }
    return Object.assign(o, a);
}
$ee6cd2f98a3475a0$exports.p2ms = $ee6cd2f98a3475a0$var$p2ms;


Object.defineProperty($9771a9b72cb50314$exports, "p2ms", {
    enumerable: true,
    get: function get() {
        return $ee6cd2f98a3475a0$exports.p2ms;
    }
});
var $333383963a614846$exports = {};
"use strict";
Object.defineProperty($333383963a614846$exports, "__esModule", {
    value: true
});
$333383963a614846$exports.p2pk = void 0;




var $333383963a614846$var$OPS = $cbd225966f86718e$exports.OPS;
// input: {signature}
// output: {pubKey} OP_CHECKSIG
/**
 * Creates a pay-to-public-key (P2PK) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2PK payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $333383963a614846$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
        pubkey: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.isPoint),
        signature: $76e9130b49af92ba$exports.typeforce.maybe($cbd225966f86718e$exports.isCanonicalScriptSignature),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer)
    }, a);
    var _chunks = $42ecdd0882a6eef0$exports.value(function() {
        return $cbd225966f86718e$exports.decompile(a.input);
    });
    var network = a.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        name: "p2pk",
        network: network
    };
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!a.pubkey) return;
        return $cbd225966f86718e$exports.compile([
            a.pubkey,
            $333383963a614846$var$OPS.OP_CHECKSIG
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "pubkey", function() {
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $42ecdd0882a6eef0$exports.prop(o, "signature", function() {
        if (!a.input) return;
        return _chunks()[0];
    });
    $42ecdd0882a6eef0$exports.prop(o, "input", function() {
        if (!a.signature) return;
        return $cbd225966f86718e$exports.compile([
            a.signature
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $333383963a614846$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            if (!(0, $76e9130b49af92ba$exports.isPoint)(o.pubkey)) throw new TypeError("Output pubkey is invalid");
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError("Pubkey mismatch");
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError("Signature mismatch");
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError("Input is invalid");
            if (!$cbd225966f86718e$exports.isCanonicalScriptSignature(o.signature)) throw new TypeError("Input has invalid signature");
        }
    }
    return Object.assign(o, a);
}
$333383963a614846$exports.p2pk = $333383963a614846$var$p2pk;


Object.defineProperty($9771a9b72cb50314$exports, "p2pk", {
    enumerable: true,
    get: function get() {
        return $333383963a614846$exports.p2pk;
    }
});
var $067a857cf7b0caa4$exports = {};

var $ilnag = parcelRequire("ilnag");
var $067a857cf7b0caa4$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($067a857cf7b0caa4$exports, "__esModule", {
    value: true
});
$067a857cf7b0caa4$exports.p2pkh = void 0;
var $f55d6b3f34e2f599$exports = {};

var $ilnag = parcelRequire("ilnag");
var $f55d6b3f34e2f599$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($f55d6b3f34e2f599$exports, "__esModule", {
    value: true
});
$f55d6b3f34e2f599$exports.taggedHash = $f55d6b3f34e2f599$exports.TAGGED_HASH_PREFIXES = $f55d6b3f34e2f599$exports.TAGS = $f55d6b3f34e2f599$exports.hash256 = $f55d6b3f34e2f599$exports.hash160 = $f55d6b3f34e2f599$exports.sha256 = $f55d6b3f34e2f599$exports.sha1 = $f55d6b3f34e2f599$exports.ripemd160 = void 0;
var $a881f54c93dc82e5$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($a881f54c93dc82e5$exports, "__esModule", {
    value: true
});
$a881f54c93dc82e5$exports.ripemd160 = $a881f54c93dc82e5$exports.RIPEMD160 = void 0;
var $0ed15ad4e2426f58$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($0ed15ad4e2426f58$exports, "__esModule", {
    value: true
});
$0ed15ad4e2426f58$exports.HashMD = $0ed15ad4e2426f58$exports.Maj = $0ed15ad4e2426f58$exports.Chi = void 0;
var $0963f94c0ee9164c$exports = {};
"use strict";
Object.defineProperty($0963f94c0ee9164c$exports, "__esModule", {
    value: true
});
$0963f94c0ee9164c$exports.anumber = $0963f94c0ee9164c$var$anumber;
$0963f94c0ee9164c$exports.number = $0963f94c0ee9164c$var$anumber;
$0963f94c0ee9164c$exports.abytes = $0963f94c0ee9164c$var$abytes;
$0963f94c0ee9164c$exports.bytes = $0963f94c0ee9164c$var$abytes;
$0963f94c0ee9164c$exports.ahash = $0963f94c0ee9164c$var$ahash;
$0963f94c0ee9164c$exports.aexists = $0963f94c0ee9164c$var$aexists;
$0963f94c0ee9164c$exports.aoutput = $0963f94c0ee9164c$var$aoutput;
function $0963f94c0ee9164c$var$anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
// copied from utils
function $0963f94c0ee9164c$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $0963f94c0ee9164c$var$abytes(b) {
    for(var _len = arguments.length, lengths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        lengths[_key - 1] = arguments[_key];
    }
    if (!$0963f94c0ee9164c$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
function $0963f94c0ee9164c$var$ahash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $0963f94c0ee9164c$var$anumber(h.outputLen);
    $0963f94c0ee9164c$var$anumber(h.blockLen);
}
function $0963f94c0ee9164c$var$aexists(instance) {
    var checkFinished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $0963f94c0ee9164c$var$aoutput(out, instance) {
    $0963f94c0ee9164c$var$abytes(out);
    var min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}
var $0963f94c0ee9164c$var$assert = {
    number: $0963f94c0ee9164c$var$anumber,
    bytes: $0963f94c0ee9164c$var$abytes,
    hash: $0963f94c0ee9164c$var$ahash,
    exists: $0963f94c0ee9164c$var$aexists,
    output: $0963f94c0ee9164c$var$aoutput
};
$0963f94c0ee9164c$exports.default = $0963f94c0ee9164c$var$assert;


var $7e830747d4dae5c1$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($7e830747d4dae5c1$exports, "__esModule", {
    value: true
});
$7e830747d4dae5c1$exports.Hash = $7e830747d4dae5c1$exports.nextTick = $7e830747d4dae5c1$exports.byteSwapIfBE = $7e830747d4dae5c1$exports.byteSwap = $7e830747d4dae5c1$exports.isLE = $7e830747d4dae5c1$exports.rotl = $7e830747d4dae5c1$exports.rotr = $7e830747d4dae5c1$exports.createView = $7e830747d4dae5c1$exports.u32 = $7e830747d4dae5c1$exports.u8 = void 0;
$7e830747d4dae5c1$exports.isBytes = $7e830747d4dae5c1$var$isBytes;
$7e830747d4dae5c1$exports.byteSwap32 = $7e830747d4dae5c1$var$byteSwap32;
$7e830747d4dae5c1$exports.bytesToHex = $7e830747d4dae5c1$var$bytesToHex;
$7e830747d4dae5c1$exports.hexToBytes = $7e830747d4dae5c1$var$hexToBytes;
$7e830747d4dae5c1$exports.asyncLoop = $7e830747d4dae5c1$var$asyncLoop;
$7e830747d4dae5c1$exports.utf8ToBytes = $7e830747d4dae5c1$var$utf8ToBytes;
$7e830747d4dae5c1$exports.toBytes = $7e830747d4dae5c1$var$toBytes;
$7e830747d4dae5c1$exports.concatBytes = $7e830747d4dae5c1$var$concatBytes;
$7e830747d4dae5c1$exports.checkOpts = $7e830747d4dae5c1$var$checkOpts;
$7e830747d4dae5c1$exports.wrapConstructor = $7e830747d4dae5c1$var$wrapConstructor;
$7e830747d4dae5c1$exports.wrapConstructorWithOpts = $7e830747d4dae5c1$var$wrapConstructorWithOpts;
$7e830747d4dae5c1$exports.wrapXOFConstructorWithOpts = $7e830747d4dae5c1$var$wrapXOFConstructorWithOpts;
$7e830747d4dae5c1$exports.randomBytes = $7e830747d4dae5c1$var$randomBytes;
var $4dd38eb7f531f19b$exports = {};
"use strict";
Object.defineProperty($4dd38eb7f531f19b$exports, "__esModule", {
    value: true
});
$4dd38eb7f531f19b$exports.crypto = void 0;
$4dd38eb7f531f19b$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;



// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $7e830747d4dae5c1$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
// Cast array to different type
var $7e830747d4dae5c1$var$u8 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
$7e830747d4dae5c1$exports.u8 = $7e830747d4dae5c1$var$u8;
var $7e830747d4dae5c1$var$u32 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
$7e830747d4dae5c1$exports.u32 = $7e830747d4dae5c1$var$u32;
// Cast array to view
var $7e830747d4dae5c1$var$createView = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
$7e830747d4dae5c1$exports.createView = $7e830747d4dae5c1$var$createView;
// The rotate right (circular right shift) operation for uint32
var $7e830747d4dae5c1$var$rotr = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
$7e830747d4dae5c1$exports.rotr = $7e830747d4dae5c1$var$rotr;
// The rotate left (circular left shift) operation for uint32
var $7e830747d4dae5c1$var$rotl = function(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
};
$7e830747d4dae5c1$exports.rotl = $7e830747d4dae5c1$var$rotl;
$7e830747d4dae5c1$exports.isLE = function() {
    return new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44;
}();
// The byte swap operation for uint32
var $7e830747d4dae5c1$var$byteSwap = function(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
};
$7e830747d4dae5c1$exports.byteSwap = $7e830747d4dae5c1$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
$7e830747d4dae5c1$exports.byteSwapIfBE = $7e830747d4dae5c1$exports.isLE ? function(n) {
    return n;
} : function(n) {
    return (0, $7e830747d4dae5c1$exports.byteSwap)(n);
};
// In place byte swap for Uint32Array
function $7e830747d4dae5c1$var$byteSwap32(arr) {
    for(var i = 0; i < arr.length; i++)arr[i] = (0, $7e830747d4dae5c1$exports.byteSwap)(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
var $7e830747d4dae5c1$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, function(_, i) {
    return i.toString(16).padStart(2, "0");
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $7e830747d4dae5c1$var$bytesToHex(bytes) {
    (0, $0963f94c0ee9164c$exports.abytes)(bytes);
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $7e830747d4dae5c1$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
var $7e830747d4dae5c1$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $7e830747d4dae5c1$var$asciiToBase16(ch) {
    if (ch >= $7e830747d4dae5c1$var$asciis._0 && ch <= $7e830747d4dae5c1$var$asciis._9) return ch - $7e830747d4dae5c1$var$asciis._0; // '2' => 50-48
    if (ch >= $7e830747d4dae5c1$var$asciis.A && ch <= $7e830747d4dae5c1$var$asciis.F) return ch - ($7e830747d4dae5c1$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $7e830747d4dae5c1$var$asciis.a && ch <= $7e830747d4dae5c1$var$asciis.f) return ch - ($7e830747d4dae5c1$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $7e830747d4dae5c1$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $aVMuR._)(hex)));
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    var array = new Uint8Array(al);
    for(var ai = 0, hi = 0; ai < al; ai++, hi += 2){
        var n1 = $7e830747d4dae5c1$var$asciiToBase16(hex.charCodeAt(hi));
        var n2 = $7e830747d4dae5c1$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
var $7e830747d4dae5c1$var$nextTick = function() {
    var _ref = (0, $6rBFC._)(function() {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function nextTick() {
        return _ref.apply(this, arguments);
    };
}();
$7e830747d4dae5c1$exports.nextTick = $7e830747d4dae5c1$var$nextTick;
function $7e830747d4dae5c1$var$asyncLoop(iters, tick, cb) {
    return $7e830747d4dae5c1$var$_asyncLoop.apply(this, arguments);
}
function $7e830747d4dae5c1$var$_asyncLoop() {
    $7e830747d4dae5c1$var$_asyncLoop = // Returns control to thread each 'tick' ms to avoid blocking
    (0, $6rBFC._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, $7e830747d4dae5c1$exports.nextTick)()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $7e830747d4dae5c1$var$_asyncLoop.apply(this, arguments);
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $7e830747d4dae5c1$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got " + (typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $7e830747d4dae5c1$var$toBytes(data) {
    if (typeof data === "string") data = $7e830747d4dae5c1$var$utf8ToBytes(data);
    (0, $0963f94c0ee9164c$exports.abytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $7e830747d4dae5c1$var$concatBytes() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var sum = 0;
    for(var i = 0; i < arrays.length; i++){
        var a = arrays[i];
        (0, $0963f94c0ee9164c$exports.abytes)(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for(var i1 = 0, pad = 0; i1 < arrays.length; i1++){
        var a1 = arrays[i1];
        res.set(a1, pad);
        pad += a1.length;
    }
    return res;
}
// For runtime check if class implements interface
var $7e830747d4dae5c1$var$Hash = /*#__PURE__*/ function() {
    function Hash() {
        (0, $7dKN1._)(this, Hash);
    }
    (0, $eW5pA._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
$7e830747d4dae5c1$exports.Hash = $7e830747d4dae5c1$var$Hash;
function $7e830747d4dae5c1$var$checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    var merged = Object.assign(defaults, opts);
    return merged;
}
function $7e830747d4dae5c1$var$wrapConstructor(hashCons) {
    var hashC = function(msg) {
        return hashCons().update($7e830747d4dae5c1$var$toBytes(msg)).digest();
    };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashCons();
    };
    return hashC;
}
function $7e830747d4dae5c1$var$wrapConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($7e830747d4dae5c1$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
function $7e830747d4dae5c1$var$wrapXOFConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($7e830747d4dae5c1$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $7e830747d4dae5c1$var$randomBytes() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ($4dd38eb7f531f19b$exports.crypto && typeof $4dd38eb7f531f19b$exports.crypto.getRandomValues === "function") return $4dd38eb7f531f19b$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($4dd38eb7f531f19b$exports.crypto && typeof $4dd38eb7f531f19b$exports.crypto.randomBytes === "function") return $4dd38eb7f531f19b$exports.crypto.randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}


/**
 * Polyfill for Safari 14
 */ function $0ed15ad4e2426f58$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number(value >> _32n & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/**
 * Choice: a ? b : c
 */ var $0ed15ad4e2426f58$var$Chi = function(a, b, c) {
    return a & b ^ ~a & c;
};
$0ed15ad4e2426f58$exports.Chi = $0ed15ad4e2426f58$var$Chi;
/**
 * Majority function, true if any two inputs is true
 */ var $0ed15ad4e2426f58$var$Maj = function(a, b, c) {
    return a & b ^ a & c ^ b & c;
};
$0ed15ad4e2426f58$exports.Maj = $0ed15ad4e2426f58$var$Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ var $0ed15ad4e2426f58$var$HashMD = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(HashMD, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(HashMD);
    function HashMD(blockLen, outputLen, padOffset, isLE) {
        (0, $7dKN1._)(this, HashMD);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, $7e830747d4dae5c1$exports.createView)(_this.buffer);
        return _this;
    }
    (0, $eW5pA._)(HashMD, [
        {
            key: "update",
            value: function update(data) {
                (0, $0963f94c0ee9164c$exports.aexists)(this);
                var _this = this, view = _this.view, buffer = _this.buffer, blockLen = _this.blockLen;
                data = (0, $7e830747d4dae5c1$exports.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    // Fast path: we have at least one block in input, cast it to view and process
                    if (take === blockLen) {
                        var dataView = (0, $7e830747d4dae5c1$exports.createView)(data);
                        for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    pos += take;
                    if (this.pos === blockLen) {
                        this.process(view, 0);
                        this.pos = 0;
                    }
                }
                this.length += data.length;
                this.roundClean();
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $0963f94c0ee9164c$exports.aexists)(this);
                (0, $0963f94c0ee9164c$exports.aoutput)(out, this);
                this.finished = true;
                // Padding
                // We can avoid allocation of buffer for padding completely if it
                // was previously not allocated here. But it won't change performance.
                var _this = this, buffer = _this.buffer, view = _this.view, blockLen = _this.blockLen, isLE = _this.isLE;
                var pos = this.pos;
                // append the bit '1' to the message
                buffer[pos++] = 128;
                this.buffer.subarray(pos).fill(0);
                // we have less than padOffset left in buffer, so we cannot put length in
                // current block, need process it and pad again
                if (this.padOffset > blockLen - pos) {
                    this.process(view, 0);
                    pos = 0;
                }
                // Pad until full block byte with zeros
                for(var i = pos; i < blockLen; i++)buffer[i] = 0;
                // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
                // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
                // So we just write lowest 64 bits of that value.
                $0ed15ad4e2426f58$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
                this.process(view, 0);
                var oview = (0, $7e830747d4dae5c1$exports.createView)(out);
                var len = this.outputLen;
                // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
                if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                var outLen = len / 4;
                var state = this.get();
                if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
                for(var i1 = 0; i1 < outLen; i1++)oview.setUint32(4 * i1, state[i1], isLE);
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                to || (to = new this.constructor());
                (_to = to).set.apply(_to, (0, $gF0bR._)(this.get()));
                var _this = this, blockLen = _this.blockLen, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, pos = _this.pos;
                to.length = length;
                to.pos = pos;
                to.finished = finished;
                to.destroyed = destroyed;
                if (length % blockLen) to.buffer.set(buffer);
                return to;
            }
        }
    ]);
    return HashMD;
}($7e830747d4dae5c1$exports.Hash);
$0ed15ad4e2426f58$exports.HashMD = $0ed15ad4e2426f58$var$HashMD;



// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
var $a881f54c93dc82e5$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
var $a881f54c93dc82e5$var$Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map(function(_, i) {
    return i;
}));
var $a881f54c93dc82e5$var$Pi = /* @__PURE__ */ $a881f54c93dc82e5$var$Id.map(function(i) {
    return (9 * i + 5) % 16;
});
var $a881f54c93dc82e5$var$idxL = [
    $a881f54c93dc82e5$var$Id
];
var $a881f54c93dc82e5$var$idxR = [
    $a881f54c93dc82e5$var$Pi
];
for(var $a881f54c93dc82e5$var$i = 0; $a881f54c93dc82e5$var$i < 4; $a881f54c93dc82e5$var$i++)for(var $a881f54c93dc82e5$var$_i = 0, $a881f54c93dc82e5$var$_iter = [
    $a881f54c93dc82e5$var$idxL,
    $a881f54c93dc82e5$var$idxR
]; $a881f54c93dc82e5$var$_i < $a881f54c93dc82e5$var$_iter.length; $a881f54c93dc82e5$var$_i++){
    var $a881f54c93dc82e5$var$j = $a881f54c93dc82e5$var$_iter[$a881f54c93dc82e5$var$_i];
    $a881f54c93dc82e5$var$j.push($a881f54c93dc82e5$var$j[$a881f54c93dc82e5$var$i].map(function(k) {
        return $a881f54c93dc82e5$var$Rho[k];
    }));
}
var $a881f54c93dc82e5$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map(function(i) {
    return new Uint8Array(i);
});
var $a881f54c93dc82e5$var$shiftsL = /* @__PURE__ */ $a881f54c93dc82e5$var$idxL.map(function(idx, i) {
    return idx.map(function(j) {
        return $a881f54c93dc82e5$var$shifts[i][j];
    });
});
var $a881f54c93dc82e5$var$shiftsR = /* @__PURE__ */ $a881f54c93dc82e5$var$idxR.map(function(idx, i) {
    return idx.map(function(j) {
        return $a881f54c93dc82e5$var$shifts[i][j];
    });
});
var $a881f54c93dc82e5$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
var $a881f54c93dc82e5$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $a881f54c93dc82e5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
var $a881f54c93dc82e5$var$R_BUF = /* @__PURE__ */ new Uint32Array(16);
var $a881f54c93dc82e5$var$RIPEMD160 = /*#__PURE__*/ function(_md_js_1_HashMD) {
    (0, $cgJ2Y._)(RIPEMD160, _md_js_1_HashMD);
    var _super = (0, $hKD8n._)(RIPEMD160);
    function RIPEMD160() {
        (0, $7dKN1._)(this, RIPEMD160);
        var _this;
        _this = _super.call(this, 64, 20, 8, true);
        _this.h0 = 1732584193;
        _this.h1 = -271733879;
        _this.h2 = -1732584194;
        _this.h3 = 271733878;
        _this.h4 = -1009589776;
        return _this;
    }
    (0, $eW5pA._)(RIPEMD160, [
        {
            key: "get",
            value: function get() {
                var _this = this, h0 = _this.h0, h1 = _this.h1, h2 = _this.h2, h3 = _this.h3, h4 = _this.h4;
                return [
                    h0,
                    h1,
                    h2,
                    h3,
                    h4
                ];
            }
        },
        {
            key: "set",
            value: function set(h0, h1, h2, h3, h4) {
                this.h0 = h0 | 0;
                this.h1 = h1 | 0;
                this.h2 = h2 | 0;
                this.h3 = h3 | 0;
                this.h4 = h4 | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                for(var i = 0; i < 16; i++, offset += 4)$a881f54c93dc82e5$var$R_BUF[i] = view.getUint32(offset, true);
                // prettier-ignore
                var al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
                // Instead of iterating 0 to 80, we split it into 5 groups
                // And use the groups in constants, functions, etc. Much simpler
                for(var group = 0; group < 5; group++){
                    var rGroup = 4 - group;
                    var hbl = $a881f54c93dc82e5$var$Kl[group], hbr = $a881f54c93dc82e5$var$Kr[group]; // prettier-ignore
                    var rl = $a881f54c93dc82e5$var$idxL[group], rr = $a881f54c93dc82e5$var$idxR[group]; // prettier-ignore
                    var sl = $a881f54c93dc82e5$var$shiftsL[group], sr = $a881f54c93dc82e5$var$shiftsR[group]; // prettier-ignore
                    for(var i1 = 0; i1 < 16; i1++){
                        var tl = (0, $7e830747d4dae5c1$exports.rotl)(al + $a881f54c93dc82e5$var$f(group, bl, cl, dl) + $a881f54c93dc82e5$var$R_BUF[rl[i1]] + hbl, sl[i1]) + el | 0;
                        al = el, el = dl, dl = (0, $7e830747d4dae5c1$exports.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
                    }
                    // 2 loops are 10% faster
                    for(var i2 = 0; i2 < 16; i2++){
                        var tr = (0, $7e830747d4dae5c1$exports.rotl)(ar + $a881f54c93dc82e5$var$f(rGroup, br, cr, dr) + $a881f54c93dc82e5$var$R_BUF[rr[i2]] + hbr, sr[i2]) + er | 0;
                        ar = er, er = dr, dr = (0, $7e830747d4dae5c1$exports.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
                    }
                }
                // Add the compressed chunk to the current hash value
                this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $a881f54c93dc82e5$var$R_BUF.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0);
            }
        }
    ]);
    return RIPEMD160;
}($0ed15ad4e2426f58$exports.HashMD);
$a881f54c93dc82e5$exports.RIPEMD160 = $a881f54c93dc82e5$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $a881f54c93dc82e5$exports.ripemd160 = (0, $7e830747d4dae5c1$exports.wrapConstructor)(function() {
    return new $a881f54c93dc82e5$var$RIPEMD160();
});


var $6c55247aaf4bc0f1$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($6c55247aaf4bc0f1$exports, "__esModule", {
    value: true
});
$6c55247aaf4bc0f1$exports.sha1 = $6c55247aaf4bc0f1$exports.SHA1 = void 0;


// SHA1 (RFC 3174). It was cryptographically broken: prefer newer algorithms.
// Initial state
var $6c55247aaf4bc0f1$var$SHA1_IV = /* @__PURE__ */ new Uint32Array([
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
    0xc3d2e1f0
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var $6c55247aaf4bc0f1$var$SHA1_W = /* @__PURE__ */ new Uint32Array(80);
var $6c55247aaf4bc0f1$var$SHA1 = /*#__PURE__*/ function(_md_js_1_HashMD) {
    (0, $cgJ2Y._)(SHA1, _md_js_1_HashMD);
    var _super = (0, $hKD8n._)(SHA1);
    function SHA1() {
        (0, $7dKN1._)(this, SHA1);
        var _this;
        _this = _super.call(this, 64, 20, 8, false);
        _this.A = $6c55247aaf4bc0f1$var$SHA1_IV[0] | 0;
        _this.B = $6c55247aaf4bc0f1$var$SHA1_IV[1] | 0;
        _this.C = $6c55247aaf4bc0f1$var$SHA1_IV[2] | 0;
        _this.D = $6c55247aaf4bc0f1$var$SHA1_IV[3] | 0;
        _this.E = $6c55247aaf4bc0f1$var$SHA1_IV[4] | 0;
        return _this;
    }
    (0, $eW5pA._)(SHA1, [
        {
            key: "get",
            value: function get() {
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E;
                return [
                    A,
                    B,
                    C,
                    D,
                    E
                ];
            }
        },
        {
            key: "set",
            value: function set(A, B, C, D, E) {
                this.A = A | 0;
                this.B = B | 0;
                this.C = C | 0;
                this.D = D | 0;
                this.E = E | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                for(var i = 0; i < 16; i++, offset += 4)$6c55247aaf4bc0f1$var$SHA1_W[i] = view.getUint32(offset, false);
                for(var i1 = 16; i1 < 80; i1++)$6c55247aaf4bc0f1$var$SHA1_W[i1] = (0, $7e830747d4dae5c1$exports.rotl)($6c55247aaf4bc0f1$var$SHA1_W[i1 - 3] ^ $6c55247aaf4bc0f1$var$SHA1_W[i1 - 8] ^ $6c55247aaf4bc0f1$var$SHA1_W[i1 - 14] ^ $6c55247aaf4bc0f1$var$SHA1_W[i1 - 16], 1);
                // Compression function main loop, 80 rounds
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E;
                for(var i2 = 0; i2 < 80; i2++){
                    var F = void 0, K = void 0;
                    if (i2 < 20) {
                        F = (0, $0ed15ad4e2426f58$exports.Chi)(B, C, D);
                        K = 0x5a827999;
                    } else if (i2 < 40) {
                        F = B ^ C ^ D;
                        K = 0x6ed9eba1;
                    } else if (i2 < 60) {
                        F = (0, $0ed15ad4e2426f58$exports.Maj)(B, C, D);
                        K = 0x8f1bbcdc;
                    } else {
                        F = B ^ C ^ D;
                        K = 0xca62c1d6;
                    }
                    var T = (0, $7e830747d4dae5c1$exports.rotl)(A, 5) + F + E + K + $6c55247aaf4bc0f1$var$SHA1_W[i2] | 0;
                    E = D;
                    D = C;
                    C = (0, $7e830747d4dae5c1$exports.rotl)(B, 30);
                    B = A;
                    A = T;
                }
                // Add the compressed chunk to the current hash value
                A = A + this.A | 0;
                B = B + this.B | 0;
                C = C + this.C | 0;
                D = D + this.D | 0;
                E = E + this.E | 0;
                this.set(A, B, C, D, E);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $6c55247aaf4bc0f1$var$SHA1_W.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.set(0, 0, 0, 0, 0);
                this.buffer.fill(0);
            }
        }
    ]);
    return SHA1;
}($0ed15ad4e2426f58$exports.HashMD);
$6c55247aaf4bc0f1$exports.SHA1 = $6c55247aaf4bc0f1$var$SHA1;
/**
 * SHA1 (RFC 3174) hash function.
 * It was cryptographically broken: prefer newer algorithms.
 * @param message - data that would be hashed
 */ $6c55247aaf4bc0f1$exports.sha1 = (0, $7e830747d4dae5c1$exports.wrapConstructor)(function() {
    return new $6c55247aaf4bc0f1$var$SHA1();
});


var $8752aea5014ee75f$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($8752aea5014ee75f$exports, "__esModule", {
    value: true
});
$8752aea5014ee75f$exports.sha224 = $8752aea5014ee75f$exports.sha256 = $8752aea5014ee75f$exports.SHA256 = void 0;


// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per late 2024.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var $8752aea5014ee75f$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
var $8752aea5014ee75f$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var $8752aea5014ee75f$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var $8752aea5014ee75f$var$SHA256 = /*#__PURE__*/ function(_md_js_1_HashMD) {
    (0, $cgJ2Y._)(SHA256, _md_js_1_HashMD);
    var _super = (0, $hKD8n._)(SHA256);
    function SHA256() {
        (0, $7dKN1._)(this, SHA256);
        var _this;
        _this = _super.call(this, 64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = $8752aea5014ee75f$var$SHA256_IV[0] | 0;
        _this.B = $8752aea5014ee75f$var$SHA256_IV[1] | 0;
        _this.C = $8752aea5014ee75f$var$SHA256_IV[2] | 0;
        _this.D = $8752aea5014ee75f$var$SHA256_IV[3] | 0;
        _this.E = $8752aea5014ee75f$var$SHA256_IV[4] | 0;
        _this.F = $8752aea5014ee75f$var$SHA256_IV[5] | 0;
        _this.G = $8752aea5014ee75f$var$SHA256_IV[6] | 0;
        _this.H = $8752aea5014ee75f$var$SHA256_IV[7] | 0;
        return _this;
    }
    (0, $eW5pA._)(SHA256, [
        {
            key: "get",
            value: function get() {
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                return [
                    A,
                    B,
                    C,
                    D,
                    E,
                    F,
                    G,
                    H
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(A, B, C, D, E, F, G, H) {
                this.A = A | 0;
                this.B = B | 0;
                this.C = C | 0;
                this.D = D | 0;
                this.E = E | 0;
                this.F = F | 0;
                this.G = G | 0;
                this.H = H | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4)$8752aea5014ee75f$var$SHA256_W[i] = view.getUint32(offset, false);
                for(var i1 = 16; i1 < 64; i1++){
                    var W15 = $8752aea5014ee75f$var$SHA256_W[i1 - 15];
                    var W2 = $8752aea5014ee75f$var$SHA256_W[i1 - 2];
                    var s0 = (0, $7e830747d4dae5c1$exports.rotr)(W15, 7) ^ (0, $7e830747d4dae5c1$exports.rotr)(W15, 18) ^ W15 >>> 3;
                    var s1 = (0, $7e830747d4dae5c1$exports.rotr)(W2, 17) ^ (0, $7e830747d4dae5c1$exports.rotr)(W2, 19) ^ W2 >>> 10;
                    $8752aea5014ee75f$var$SHA256_W[i1] = s1 + $8752aea5014ee75f$var$SHA256_W[i1 - 7] + s0 + $8752aea5014ee75f$var$SHA256_W[i1 - 16] | 0;
                }
                // Compression function main loop, 64 rounds
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                for(var i2 = 0; i2 < 64; i2++){
                    var sigma1 = (0, $7e830747d4dae5c1$exports.rotr)(E, 6) ^ (0, $7e830747d4dae5c1$exports.rotr)(E, 11) ^ (0, $7e830747d4dae5c1$exports.rotr)(E, 25);
                    var T1 = H + sigma1 + (0, $0ed15ad4e2426f58$exports.Chi)(E, F, G) + $8752aea5014ee75f$var$SHA256_K[i2] + $8752aea5014ee75f$var$SHA256_W[i2] | 0;
                    var sigma0 = (0, $7e830747d4dae5c1$exports.rotr)(A, 2) ^ (0, $7e830747d4dae5c1$exports.rotr)(A, 13) ^ (0, $7e830747d4dae5c1$exports.rotr)(A, 22);
                    var T2 = sigma0 + (0, $0ed15ad4e2426f58$exports.Maj)(A, B, C) | 0;
                    H = G;
                    G = F;
                    F = E;
                    E = D + T1 | 0;
                    D = C;
                    C = B;
                    B = A;
                    A = T1 + T2 | 0;
                }
                // Add the compressed chunk to the current hash value
                A = A + this.A | 0;
                B = B + this.B | 0;
                C = C + this.C | 0;
                D = D + this.D | 0;
                E = E + this.E | 0;
                F = F + this.F | 0;
                G = G + this.G | 0;
                H = H + this.H | 0;
                this.set(A, B, C, D, E, F, G, H);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $8752aea5014ee75f$var$SHA256_W.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.set(0, 0, 0, 0, 0, 0, 0, 0);
                this.buffer.fill(0);
            }
        }
    ]);
    return SHA256;
}($0ed15ad4e2426f58$exports.HashMD);
$8752aea5014ee75f$exports.SHA256 = $8752aea5014ee75f$var$SHA256;
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var $8752aea5014ee75f$var$SHA224 = /*#__PURE__*/ function(SHA256) {
    (0, $cgJ2Y._)(SHA224, SHA256);
    var _super = (0, $hKD8n._)(SHA224);
    function SHA224() {
        (0, $7dKN1._)(this, SHA224);
        var _this;
        _this = _super.call(this);
        _this.A = -1056596264;
        _this.B = 914150663;
        _this.C = 812702999;
        _this.D = -150054599;
        _this.E = -4191439;
        _this.F = 1750603025;
        _this.G = 1694076839;
        _this.H = -1090891868;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}($8752aea5014ee75f$var$SHA256);
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $8752aea5014ee75f$exports.sha256 = (0, $7e830747d4dae5c1$exports.wrapConstructor)(function() {
    return new $8752aea5014ee75f$var$SHA256();
});
/**
 * SHA2-224 hash function
 */ $8752aea5014ee75f$exports.sha224 = (0, $7e830747d4dae5c1$exports.wrapConstructor)(function() {
    return new $8752aea5014ee75f$var$SHA224();
});


function $f55d6b3f34e2f599$var$ripemd160(buffer) {
    return $f55d6b3f34e2f599$require$Buffer.from((0, $a881f54c93dc82e5$exports.ripemd160)(Uint8Array.from(buffer)));
}
$f55d6b3f34e2f599$exports.ripemd160 = $f55d6b3f34e2f599$var$ripemd160;
function $f55d6b3f34e2f599$var$sha1(buffer) {
    return $f55d6b3f34e2f599$require$Buffer.from((0, $6c55247aaf4bc0f1$exports.sha1)(Uint8Array.from(buffer)));
}
$f55d6b3f34e2f599$exports.sha1 = $f55d6b3f34e2f599$var$sha1;
function $f55d6b3f34e2f599$var$sha256(buffer) {
    return $f55d6b3f34e2f599$require$Buffer.from((0, $8752aea5014ee75f$exports.sha256)(Uint8Array.from(buffer)));
}
$f55d6b3f34e2f599$exports.sha256 = $f55d6b3f34e2f599$var$sha256;
function $f55d6b3f34e2f599$var$hash160(buffer) {
    return $f55d6b3f34e2f599$require$Buffer.from((0, $a881f54c93dc82e5$exports.ripemd160)((0, $8752aea5014ee75f$exports.sha256)(Uint8Array.from(buffer))));
}
$f55d6b3f34e2f599$exports.hash160 = $f55d6b3f34e2f599$var$hash160;
function $f55d6b3f34e2f599$var$hash256(buffer) {
    return $f55d6b3f34e2f599$require$Buffer.from((0, $8752aea5014ee75f$exports.sha256)((0, $8752aea5014ee75f$exports.sha256)(Uint8Array.from(buffer))));
}
$f55d6b3f34e2f599$exports.hash256 = $f55d6b3f34e2f599$var$hash256;
$f55d6b3f34e2f599$exports.TAGS = [
    "BIP0340/challenge",
    "BIP0340/aux",
    "BIP0340/nonce",
    "TapLeaf",
    "TapBranch",
    "TapSighash",
    "TapTweak",
    "KeyAgg list",
    "KeyAgg coefficient"
];
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ /**
 * Defines the tagged hash prefixes used in the crypto module.
 */ $f55d6b3f34e2f599$exports.TAGGED_HASH_PREFIXES = {
    "BIP0340/challenge": $f55d6b3f34e2f599$require$Buffer.from([
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124,
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124
    ]),
    "BIP0340/aux": $f55d6b3f34e2f599$require$Buffer.from([
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144,
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144
    ]),
    "BIP0340/nonce": $f55d6b3f34e2f599$require$Buffer.from([
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47,
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47
    ]),
    TapLeaf: $f55d6b3f34e2f599$require$Buffer.from([
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238,
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238
    ]),
    TapBranch: $f55d6b3f34e2f599$require$Buffer.from([
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21,
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21
    ]),
    TapSighash: $f55d6b3f34e2f599$require$Buffer.from([
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49,
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49
    ]),
    TapTweak: $f55d6b3f34e2f599$require$Buffer.from([
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233,
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233
    ]),
    "KeyAgg list": $f55d6b3f34e2f599$require$Buffer.from([
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240,
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240
    ]),
    "KeyAgg coefficient": $f55d6b3f34e2f599$require$Buffer.from([
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129,
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129
    ])
};
function $f55d6b3f34e2f599$var$taggedHash(prefix, data) {
    return $f55d6b3f34e2f599$var$sha256($f55d6b3f34e2f599$require$Buffer.concat([
        $f55d6b3f34e2f599$exports.TAGGED_HASH_PREFIXES[prefix],
        data
    ]));
}
$f55d6b3f34e2f599$exports.taggedHash = $f55d6b3f34e2f599$var$taggedHash;






var $27358ce981e45e98$exports = {};
"use strict";

var $27358ce981e45e98$require$sha256 = $8752aea5014ee75f$exports.sha256;
var $729bfc08e5465a5c$exports = {};
"use strict";
var $ed435663553bf924$exports = {};
var $4e00a1b7bfc94d5b$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $4e00a1b7bfc94d5b$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$4e00a1b7bfc94d5b$exports = $4e00a1b7bfc94d5b$var$base;


var $ed435663553bf924$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$ed435663553bf924$exports = $4e00a1b7bfc94d5b$exports($ed435663553bf924$var$ALPHABET);


$729bfc08e5465a5c$exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $ed435663553bf924$exports.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $ed435663553bf924$exports.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $ed435663553bf924$exports.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};


// SHA256(SHA256(buffer))
function $27358ce981e45e98$var$sha256x2(buffer) {
    return $27358ce981e45e98$require$sha256($27358ce981e45e98$require$sha256(buffer));
}
$27358ce981e45e98$exports = $729bfc08e5465a5c$exports($27358ce981e45e98$var$sha256x2);


var $067a857cf7b0caa4$var$OPS = $cbd225966f86718e$exports.OPS;
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
/**
 * Creates a Pay-to-Public-Key-Hash (P2PKH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2PKH payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $067a857cf7b0caa4$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        address: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.String),
        hash: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(20)),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(25)),
        pubkey: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.isPoint),
        signature: $76e9130b49af92ba$exports.typeforce.maybe($cbd225966f86718e$exports.isCanonicalScriptSignature),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer)
    }, a);
    var _address = $42ecdd0882a6eef0$exports.value(function() {
        var payload = $067a857cf7b0caa4$require$Buffer.from($27358ce981e45e98$exports.decode(a.address));
        var version = payload.readUInt8(0);
        var hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    var _chunks = $42ecdd0882a6eef0$exports.value(function() {
        return $cbd225966f86718e$exports.decompile(a.input);
    });
    var network = a.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        name: "p2pkh",
        network: network
    };
    $42ecdd0882a6eef0$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var payload = $067a857cf7b0caa4$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $27358ce981e45e98$exports.encode(payload);
    });
    $42ecdd0882a6eef0$exports.prop(o, "hash", function() {
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $f55d6b3f34e2f599$exports.hash160(a.pubkey || o.pubkey);
    });
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $cbd225966f86718e$exports.compile([
            $067a857cf7b0caa4$var$OPS.OP_DUP,
            $067a857cf7b0caa4$var$OPS.OP_HASH160,
            o.hash,
            $067a857cf7b0caa4$var$OPS.OP_EQUALVERIFY,
            $067a857cf7b0caa4$var$OPS.OP_CHECKSIG
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "pubkey", function() {
        if (!a.input) return;
        return _chunks()[1];
    });
    $42ecdd0882a6eef0$exports.prop(o, "signature", function() {
        if (!a.input) return;
        return _chunks()[0];
    });
    $42ecdd0882a6eef0$exports.prop(o, "input", function() {
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $cbd225966f86718e$exports.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        var hash = $067a857cf7b0caa4$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $067a857cf7b0caa4$var$OPS.OP_DUP || a.output[1] !== $067a857cf7b0caa4$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $067a857cf7b0caa4$var$OPS.OP_EQUALVERIFY || a.output[24] !== $067a857cf7b0caa4$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            var hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.pubkey) {
            var pkh = $f55d6b3f34e2f599$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
        }
        if (a.input) {
            var chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError("Input is invalid");
            if (!$cbd225966f86718e$exports.isCanonicalScriptSignature(chunks[0])) throw new TypeError("Input has invalid signature");
            if (!(0, $76e9130b49af92ba$exports.isPoint)(chunks[1])) throw new TypeError("Input has invalid pubkey");
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError("Pubkey mismatch");
            var pkh1 = $f55d6b3f34e2f599$exports.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh1)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
$067a857cf7b0caa4$exports.p2pkh = $067a857cf7b0caa4$var$p2pkh;


Object.defineProperty($9771a9b72cb50314$exports, "p2pkh", {
    enumerable: true,
    get: function get() {
        return $067a857cf7b0caa4$exports.p2pkh;
    }
});
var $e81b40830b2d4ceb$exports = {};

var $ilnag = parcelRequire("ilnag");
var $e81b40830b2d4ceb$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($e81b40830b2d4ceb$exports, "__esModule", {
    value: true
});
$e81b40830b2d4ceb$exports.p2sh = void 0;






var $e81b40830b2d4ceb$var$OPS = $cbd225966f86718e$exports.OPS;
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
/**
 * Creates a Pay-to-Script-Hash (P2SH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2SH payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $e81b40830b2d4ceb$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        address: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.String),
        hash: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(20)),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(23)),
        redeem: $76e9130b49af92ba$exports.typeforce.maybe({
            network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
            output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
            input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
            witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
        }),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
        witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
    }, a);
    var network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        network: network
    };
    var _address = $42ecdd0882a6eef0$exports.value(function() {
        var payload = $e81b40830b2d4ceb$require$Buffer.from($27358ce981e45e98$exports.decode(a.address));
        var version = payload.readUInt8(0);
        var hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    var _chunks = $42ecdd0882a6eef0$exports.value(function() {
        return $cbd225966f86718e$exports.decompile(a.input);
    });
    var _redeem = $42ecdd0882a6eef0$exports.value(function() {
        var chunks = _chunks();
        var lastChunk = chunks[chunks.length - 1];
        return {
            network: network,
            output: lastChunk === $e81b40830b2d4ceb$var$OPS.OP_FALSE ? $e81b40830b2d4ceb$require$Buffer.from([]) : lastChunk,
            input: $cbd225966f86718e$exports.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $42ecdd0882a6eef0$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var payload = $e81b40830b2d4ceb$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $27358ce981e45e98$exports.encode(payload);
    });
    $42ecdd0882a6eef0$exports.prop(o, "hash", function() {
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $f55d6b3f34e2f599$exports.hash160(o.redeem.output);
    });
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $cbd225966f86718e$exports.compile([
            $e81b40830b2d4ceb$var$OPS.OP_HASH160,
            o.hash,
            $e81b40830b2d4ceb$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $42ecdd0882a6eef0$exports.prop(o, "redeem", function() {
        if (!a.input) return;
        return _redeem();
    });
    $42ecdd0882a6eef0$exports.prop(o, "input", function() {
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $cbd225966f86718e$exports.compile([].concat($cbd225966f86718e$exports.decompile(a.redeem.input), a.redeem.output));
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $42ecdd0882a6eef0$exports.prop(o, "name", function() {
        var nameParts = [
            "p2sh"
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    if (opts.validate) {
        var hash = $e81b40830b2d4ceb$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $e81b40830b2d4ceb$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $e81b40830b2d4ceb$var$OPS.OP_EQUAL) throw new TypeError("Output is invalid");
            var hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        var checkRedeem = function(redeem) {
            // is the redeem output empty/invalid?
            if (redeem.output) {
                var decompile = $cbd225966f86718e$exports.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output too short");
                if (redeem.output.byteLength > 520) throw new TypeError("Redeem.output unspendable if larger than 520 bytes");
                if ($cbd225966f86718e$exports.countNonPushOnlyOPs(decompile) > 201) throw new TypeError("Redeem.output unspendable with more than 201 non-push ops");
                // match hash against other sources
                var hash2 = $f55d6b3f34e2f599$exports.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (redeem.input) {
                var hasInput = redeem.input.length > 0;
                var hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError("Empty input");
                if (hasInput && hasWitness) throw new TypeError("Input and witness provided");
                if (hasInput) {
                    var richunks = $cbd225966f86718e$exports.decompile(redeem.input);
                    if (!$cbd225966f86718e$exports.isPushOnly(richunks)) throw new TypeError("Non push-only scriptSig");
                }
            }
        };
        if (a.input) {
            var chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError("Input too short");
            if (!$e81b40830b2d4ceb$require$Buffer.isBuffer(_redeem().output)) throw new TypeError("Input is invalid");
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            if (a.input) {
                var redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError("Redeem.output mismatch");
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError("Redeem.input mismatch");
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !(0, $76e9130b49af92ba$exports.stacksEqual)(a.redeem.witness, a.witness)) throw new TypeError("Witness and redeem.witness mismatch");
        }
    }
    return Object.assign(o, a);
}
$e81b40830b2d4ceb$exports.p2sh = $e81b40830b2d4ceb$var$p2sh;


Object.defineProperty($9771a9b72cb50314$exports, "p2sh", {
    enumerable: true,
    get: function get() {
        return $e81b40830b2d4ceb$exports.p2sh;
    }
});
var $4bf88c834f38546e$exports = {};

var $ilnag = parcelRequire("ilnag");
var $4bf88c834f38546e$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($4bf88c834f38546e$exports, "__esModule", {
    value: true
});
$4bf88c834f38546e$exports.p2wpkh = void 0;





var $eed9357e4124c415$exports = {};
"use strict";
Object.defineProperty($eed9357e4124c415$exports, "__esModule", {
    value: true
});
$eed9357e4124c415$exports.bech32m = $eed9357e4124c415$exports.bech32 = void 0;
var $eed9357e4124c415$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
var $eed9357e4124c415$var$ALPHABET_MAP = {};
for(var $eed9357e4124c415$var$z = 0; $eed9357e4124c415$var$z < $eed9357e4124c415$var$ALPHABET.length; $eed9357e4124c415$var$z++){
    var $eed9357e4124c415$var$x = $eed9357e4124c415$var$ALPHABET.charAt($eed9357e4124c415$var$z);
    $eed9357e4124c415$var$ALPHABET_MAP[$eed9357e4124c415$var$x] = $eed9357e4124c415$var$z;
}
function $eed9357e4124c415$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $eed9357e4124c415$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $eed9357e4124c415$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $eed9357e4124c415$var$polymodStep(chk);
    for(var i1 = 0; i1 < prefix.length; ++i1){
        var v = prefix.charCodeAt(i1);
        chk = $eed9357e4124c415$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $eed9357e4124c415$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $eed9357e4124c415$var$toWords(bytes) {
    return $eed9357e4124c415$var$convert(bytes, 8, 5, true);
}
function $eed9357e4124c415$var$fromWordsUnsafe(words) {
    var res = $eed9357e4124c415$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $eed9357e4124c415$var$fromWords(words) {
    var res = $eed9357e4124c415$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $eed9357e4124c415$var$getLibraryFromEncoding(encoding) {
    var ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        var chk = $eed9357e4124c415$var$prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        var result = prefix + "1";
        for(var i = 0; i < words.length; ++i){
            var x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = $eed9357e4124c415$var$polymodStep(chk) ^ x;
            result += $eed9357e4124c415$var$ALPHABET.charAt(x);
        }
        for(var i1 = 0; i1 < 6; ++i1)chk = $eed9357e4124c415$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(var i2 = 0; i2 < 6; ++i2){
            var v = chk >> (5 - i2) * 5 & 0x1f;
            result += $eed9357e4124c415$var$ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        var lowered = str.toLowerCase();
        var uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        var split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        var prefix = str.slice(0, split);
        var wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        var chk = $eed9357e4124c415$var$prefixChk(prefix);
        if (typeof chk === "string") return chk;
        var words = [];
        for(var i = 0; i < wordChars.length; ++i){
            var c = wordChars.charAt(i);
            var v = $eed9357e4124c415$var$ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = $eed9357e4124c415$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix: prefix,
            words: words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        var res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    }
    function decode(str, LIMIT) {
        var res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $eed9357e4124c415$var$toWords,
        fromWordsUnsafe: $eed9357e4124c415$var$fromWordsUnsafe,
        fromWords: $eed9357e4124c415$var$fromWords
    };
}
$eed9357e4124c415$exports.bech32 = $eed9357e4124c415$var$getLibraryFromEncoding("bech32");
$eed9357e4124c415$exports.bech32m = $eed9357e4124c415$var$getLibraryFromEncoding("bech32m");


var $4bf88c834f38546e$var$OPS = $cbd225966f86718e$exports.OPS;
var $4bf88c834f38546e$var$EMPTY_BUFFER = $4bf88c834f38546e$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
/**
 * Creates a pay-to-witness-public-key-hash (p2wpkh) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The p2wpkh payment object.
 * @throws {TypeError} If the required data is missing or invalid.
 */ function $4bf88c834f38546e$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        address: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.String),
        hash: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(20)),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(0)),
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(22)),
        pubkey: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.isPoint),
        signature: $76e9130b49af92ba$exports.typeforce.maybe($cbd225966f86718e$exports.isCanonicalScriptSignature),
        witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
    }, a);
    var _address = $42ecdd0882a6eef0$exports.value(function() {
        var result = $eed9357e4124c415$exports.bech32.decode(a.address);
        var version = result.words.shift();
        var data = $eed9357e4124c415$exports.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $4bf88c834f38546e$require$Buffer.from(data)
        };
    });
    var network = a.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        name: "p2wpkh",
        network: network
    };
    $42ecdd0882a6eef0$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var words = $eed9357e4124c415$exports.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $eed9357e4124c415$exports.bech32.encode(network.bech32, words);
    });
    $42ecdd0882a6eef0$exports.prop(o, "hash", function() {
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $f55d6b3f34e2f599$exports.hash160(a.pubkey || o.pubkey);
    });
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $cbd225966f86718e$exports.compile([
            $4bf88c834f38546e$var$OPS.OP_0,
            o.hash
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "pubkey", function() {
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $42ecdd0882a6eef0$exports.prop(o, "signature", function() {
        if (!a.witness) return;
        return a.witness[0];
    });
    $42ecdd0882a6eef0$exports.prop(o, "input", function() {
        if (!o.witness) return;
        return $4bf88c834f38546e$var$EMPTY_BUFFER;
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        var hash = $4bf88c834f38546e$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 20) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $4bf88c834f38546e$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError("Output is invalid");
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError("Hash mismatch");
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            var pkh = $f55d6b3f34e2f599$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
            if (!(0, $76e9130b49af92ba$exports.isPoint)(a.pubkey) || a.pubkey.length !== 33) throw new TypeError("Invalid pubkey for p2wpkh");
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError("Witness is invalid");
            if (!$cbd225966f86718e$exports.isCanonicalScriptSignature(a.witness[0])) throw new TypeError("Witness has invalid signature");
            if (!(0, $76e9130b49af92ba$exports.isPoint)(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError("Witness has invalid pubkey");
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError("Pubkey mismatch");
            var pkh1 = $f55d6b3f34e2f599$exports.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh1)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
$4bf88c834f38546e$exports.p2wpkh = $4bf88c834f38546e$var$p2wpkh;


Object.defineProperty($9771a9b72cb50314$exports, "p2wpkh", {
    enumerable: true,
    get: function get() {
        return $4bf88c834f38546e$exports.p2wpkh;
    }
});
var $2c4d0cd4a00260a1$exports = {};

var $ilnag = parcelRequire("ilnag");
var $2c4d0cd4a00260a1$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($2c4d0cd4a00260a1$exports, "__esModule", {
    value: true
});
$2c4d0cd4a00260a1$exports.p2wsh = void 0;






var $2c4d0cd4a00260a1$var$OPS = $cbd225966f86718e$exports.OPS;
var $2c4d0cd4a00260a1$var$EMPTY_BUFFER = $2c4d0cd4a00260a1$require$Buffer.alloc(0);
function $2c4d0cd4a00260a1$var$chunkHasUncompressedPubkey(chunk) {
    if ($2c4d0cd4a00260a1$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && (0, $76e9130b49af92ba$exports.isPoint)(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
/**
 * Creates a Pay-to-Witness-Script-Hash (P2WSH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2WSH payment object.
 * @throws {TypeError} If the required data is missing or invalid.
 */ function $2c4d0cd4a00260a1$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        address: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.String),
        hash: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(32)),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(34)),
        redeem: $76e9130b49af92ba$exports.typeforce.maybe({
            input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
            network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
            output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
            witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
        }),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(0)),
        witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
    }, a);
    var _address = $42ecdd0882a6eef0$exports.value(function() {
        var result = $eed9357e4124c415$exports.bech32.decode(a.address);
        var version = result.words.shift();
        var data = $eed9357e4124c415$exports.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $2c4d0cd4a00260a1$require$Buffer.from(data)
        };
    });
    var _rchunks = $42ecdd0882a6eef0$exports.value(function() {
        return $cbd225966f86718e$exports.decompile(a.redeem.input);
    });
    var network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        network: network
    };
    $42ecdd0882a6eef0$exports.prop(o, "address", function() {
        if (!o.hash) return;
        var words = $eed9357e4124c415$exports.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $eed9357e4124c415$exports.bech32.encode(network.bech32, words);
    });
    $42ecdd0882a6eef0$exports.prop(o, "hash", function() {
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $f55d6b3f34e2f599$exports.sha256(o.redeem.output);
    });
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!o.hash) return;
        return $cbd225966f86718e$exports.compile([
            $2c4d0cd4a00260a1$var$OPS.OP_0,
            o.hash
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "redeem", function() {
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $2c4d0cd4a00260a1$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $42ecdd0882a6eef0$exports.prop(o, "input", function() {
        if (!o.witness) return;
        return $2c4d0cd4a00260a1$var$EMPTY_BUFFER;
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            var stack = $cbd225966f86718e$exports.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $2c4d0cd4a00260a1$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $42ecdd0882a6eef0$exports.prop(o, "name", function() {
        var nameParts = [
            "p2wsh"
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    // extended validation
    if (opts.validate) {
        var hash = $2c4d0cd4a00260a1$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $2c4d0cd4a00260a1$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            var hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError("Ambiguous witness source");
            // is the redeem output non-empty/valid?
            if (a.redeem.output) {
                var decompile = $cbd225966f86718e$exports.decompile(a.redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output is invalid");
                if (a.redeem.output.byteLength > 3600) throw new TypeError("Redeem.output unspendable if larger than 3600 bytes");
                if ($cbd225966f86718e$exports.countNonPushOnlyOPs(decompile) > 201) throw new TypeError("Redeem.output unspendable with more than 201 non-push ops");
                // match hash against other sources
                var hash21 = $f55d6b3f34e2f599$exports.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash21)) throw new TypeError("Hash mismatch");
                else hash = hash21;
            }
            if (a.redeem.input && !$cbd225966f86718e$exports.isPushOnly(_rchunks())) throw new TypeError("Non push-only scriptSig");
            if (a.witness && a.redeem.witness && !(0, $76e9130b49af92ba$exports.stacksEqual)(a.witness, a.redeem.witness)) throw new TypeError("Witness and redeem.witness mismatch");
            if (a.redeem.input && _rchunks().some($2c4d0cd4a00260a1$var$chunkHasUncompressedPubkey) || a.redeem.output && ($cbd225966f86718e$exports.decompile(a.redeem.output) || []).some($2c4d0cd4a00260a1$var$chunkHasUncompressedPubkey)) throw new TypeError("redeem.input or redeem.output contains uncompressed pubkey");
        }
        if (a.witness && a.witness.length > 0) {
            var wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError("Witness and redeem.output mismatch");
            if (a.witness.some($2c4d0cd4a00260a1$var$chunkHasUncompressedPubkey) || ($cbd225966f86718e$exports.decompile(wScript) || []).some($2c4d0cd4a00260a1$var$chunkHasUncompressedPubkey)) throw new TypeError("Witness contains uncompressed pubkey");
        }
    }
    return Object.assign(o, a);
}
$2c4d0cd4a00260a1$exports.p2wsh = $2c4d0cd4a00260a1$var$p2wsh;


Object.defineProperty($9771a9b72cb50314$exports, "p2wsh", {
    enumerable: true,
    get: function get() {
        return $2c4d0cd4a00260a1$exports.p2wsh;
    }
});
var $bf8a44cb3ab078f4$exports = {};
"use strict";
Object.defineProperty($bf8a44cb3ab078f4$exports, "__esModule", {
    value: true
});
$bf8a44cb3ab078f4$exports.p2tr = void 0;

var $ilnag = parcelRequire("ilnag");



var $d1c3d48d4239db47$exports = {};

var $ilnag = parcelRequire("ilnag");
var $d1c3d48d4239db47$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($d1c3d48d4239db47$exports, "__esModule", {
    value: true
});
$d1c3d48d4239db47$exports.getEccLib = $d1c3d48d4239db47$exports.initEccLib = void 0;
var $d1c3d48d4239db47$var$_ECCLIB_CACHE = {};
/**
 * Initializes the ECC library with the provided instance.
 * If `eccLib` is `undefined`, the library will be cleared.
 * If `eccLib` is a new instance, it will be verified before setting it as the active library.
 *
 * @param eccLib The instance of the ECC library to initialize.
 * @param opts Extra initialization options. Use {DANGER_DO_NOT_VERIFY_ECCLIB:true} if ecc verification should not be executed. Not recommended!
 */ function $d1c3d48d4239db47$var$initEccLib(eccLib, opts) {
    if (!eccLib) // allow clearing the library
    $d1c3d48d4239db47$var$_ECCLIB_CACHE.eccLib = eccLib;
    else if (eccLib !== $d1c3d48d4239db47$var$_ECCLIB_CACHE.eccLib) {
        if (!(opts === null || opts === void 0 ? void 0 : opts.DANGER_DO_NOT_VERIFY_ECCLIB)) // new instance, verify it
        $d1c3d48d4239db47$var$verifyEcc(eccLib);
        $d1c3d48d4239db47$var$_ECCLIB_CACHE.eccLib = eccLib;
    }
}
$d1c3d48d4239db47$exports.initEccLib = $d1c3d48d4239db47$var$initEccLib;
/**
 * Retrieves the ECC Library instance.
 * Throws an error if the ECC Library is not provided.
 * You must call initEccLib() with a valid TinySecp256k1Interface instance before calling this function.
 * @returns The ECC Library instance.
 * @throws Error if the ECC Library is not provided.
 */ function $d1c3d48d4239db47$var$getEccLib() {
    if (!$d1c3d48d4239db47$var$_ECCLIB_CACHE.eccLib) throw new Error("No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance");
    return $d1c3d48d4239db47$var$_ECCLIB_CACHE.eccLib;
}
$d1c3d48d4239db47$exports.getEccLib = $d1c3d48d4239db47$var$getEccLib;
var $d1c3d48d4239db47$var$h = function(hex) {
    return $d1c3d48d4239db47$require$Buffer.from(hex, "hex");
};
/**
 * Verifies the ECC functionality.
 *
 * @param ecc - The TinySecp256k1Interface object.
 */ function $d1c3d48d4239db47$var$verifyEcc(ecc) {
    $d1c3d48d4239db47$var$assert(typeof ecc.isXOnlyPoint === "function");
    $d1c3d48d4239db47$var$assert(ecc.isXOnlyPoint($d1c3d48d4239db47$var$h("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")));
    $d1c3d48d4239db47$var$assert(ecc.isXOnlyPoint($d1c3d48d4239db47$var$h("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")));
    $d1c3d48d4239db47$var$assert(ecc.isXOnlyPoint($d1c3d48d4239db47$var$h("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")));
    $d1c3d48d4239db47$var$assert(ecc.isXOnlyPoint($d1c3d48d4239db47$var$h("0000000000000000000000000000000000000000000000000000000000000001")));
    $d1c3d48d4239db47$var$assert(!ecc.isXOnlyPoint($d1c3d48d4239db47$var$h("0000000000000000000000000000000000000000000000000000000000000000")));
    $d1c3d48d4239db47$var$assert(!ecc.isXOnlyPoint($d1c3d48d4239db47$var$h("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")));
    $d1c3d48d4239db47$var$assert(typeof ecc.xOnlyPointAddTweak === "function");
    $d1c3d48d4239db47$var$tweakAddVectors.forEach(function(t) {
        var r = ecc.xOnlyPointAddTweak($d1c3d48d4239db47$var$h(t.pubkey), $d1c3d48d4239db47$var$h(t.tweak));
        if (t.result === null) $d1c3d48d4239db47$var$assert(r === null);
        else {
            $d1c3d48d4239db47$var$assert(r !== null);
            $d1c3d48d4239db47$var$assert(r.parity === t.parity);
            $d1c3d48d4239db47$var$assert($d1c3d48d4239db47$require$Buffer.from(r.xOnlyPubkey).equals($d1c3d48d4239db47$var$h(t.result)));
        }
    });
}
function $d1c3d48d4239db47$var$assert(bool) {
    if (!bool) throw new Error("ecc library invalid");
}
var $d1c3d48d4239db47$var$tweakAddVectors = [
    {
        pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
        parity: -1,
        result: null
    },
    {
        pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
        tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
        parity: 1,
        result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
    },
    {
        pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
        tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
        parity: 0,
        result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
    }
];


var $c86b0fc6a57c595c$exports = {};

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($c86b0fc6a57c595c$exports, "__esModule", {
    value: true
});
$c86b0fc6a57c595c$exports.tweakKey = $c86b0fc6a57c595c$exports.tapTweakHash = $c86b0fc6a57c595c$exports.tapleafHash = $c86b0fc6a57c595c$exports.findScriptPath = $c86b0fc6a57c595c$exports.toHashTree = $c86b0fc6a57c595c$exports.rootHashFromPath = $c86b0fc6a57c595c$exports.MAX_TAPTREE_DEPTH = $c86b0fc6a57c595c$exports.LEAF_VERSION_TAPSCRIPT = void 0;

var $ilnag = parcelRequire("ilnag");


var $d6dfd2397ab1936f$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $d6dfd2397ab1936f$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($d6dfd2397ab1936f$exports, "__esModule", {
    value: true
});
$d6dfd2397ab1936f$exports.BufferReader = $d6dfd2397ab1936f$exports.BufferWriter = $d6dfd2397ab1936f$exports.cloneBuffer = $d6dfd2397ab1936f$exports.reverseBuffer = $d6dfd2397ab1936f$exports.writeUInt64LE = $d6dfd2397ab1936f$exports.readUInt64LE = $d6dfd2397ab1936f$exports.varuint = void 0;

var $d6dfd2397ab1936f$var$typeforce = $76e9130b49af92ba$exports.typeforce;

$d6dfd2397ab1936f$exports.varuint = $3aab16f2bcaeeed2$exports;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $d6dfd2397ab1936f$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $d6dfd2397ab1936f$var$readUInt64LE(buffer, offset) {
    var a = buffer.readUInt32LE(offset);
    var b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $d6dfd2397ab1936f$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
$d6dfd2397ab1936f$exports.readUInt64LE = $d6dfd2397ab1936f$var$readUInt64LE;
/**
 * Writes a 64-bit unsigned integer in little-endian format to the specified buffer at the given offset.
 *
 * @param buffer - The buffer to write the value to.
 * @param value - The 64-bit unsigned integer value to write.
 * @param offset - The offset in the buffer where the value should be written.
 * @returns The new offset after writing the value.
 */ function $d6dfd2397ab1936f$var$writeUInt64LE(buffer, value, offset) {
    $d6dfd2397ab1936f$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
$d6dfd2397ab1936f$exports.writeUInt64LE = $d6dfd2397ab1936f$var$writeUInt64LE;
/**
 * Reverses the order of bytes in a buffer.
 * @param buffer - The buffer to reverse.
 * @returns A new buffer with the bytes reversed.
 */ function $d6dfd2397ab1936f$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    var j = buffer.length - 1;
    var tmp = 0;
    for(var i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
$d6dfd2397ab1936f$exports.reverseBuffer = $d6dfd2397ab1936f$var$reverseBuffer;
function $d6dfd2397ab1936f$var$cloneBuffer(buffer) {
    var clone = $d6dfd2397ab1936f$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
$d6dfd2397ab1936f$exports.cloneBuffer = $d6dfd2397ab1936f$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ var $d6dfd2397ab1936f$var$BufferWriter = /*#__PURE__*/ function() {
    "use strict";
    function BufferWriter(buffer) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $7dKN1._)(this, BufferWriter);
        this.buffer = buffer;
        this.offset = offset;
        $d6dfd2397ab1936f$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.Buffer, $76e9130b49af92ba$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    (0, $eW5pA._)(BufferWriter, [
        {
            key: "writeUInt8",
            value: function writeUInt8(i) {
                this.offset = this.buffer.writeUInt8(i, this.offset);
            }
        },
        {
            key: "writeInt32",
            value: function writeInt32(i) {
                this.offset = this.buffer.writeInt32LE(i, this.offset);
            }
        },
        {
            key: "writeUInt32",
            value: function writeUInt32(i) {
                this.offset = this.buffer.writeUInt32LE(i, this.offset);
            }
        },
        {
            key: "writeUInt64",
            value: function writeUInt64(i) {
                this.offset = $d6dfd2397ab1936f$var$writeUInt64LE(this.buffer, i, this.offset);
            }
        },
        {
            key: "writeVarInt",
            value: function writeVarInt(i) {
                $3aab16f2bcaeeed2$exports.encode(i, this.buffer, this.offset);
                this.offset += $3aab16f2bcaeeed2$exports.encode.bytes;
            }
        },
        {
            key: "writeSlice",
            value: function writeSlice(slice) {
                if (this.buffer.length < this.offset + slice.length) throw new Error("Cannot write slice out of bounds");
                this.offset += slice.copy(this.buffer, this.offset);
            }
        },
        {
            key: "writeVarSlice",
            value: function writeVarSlice(slice) {
                this.writeVarInt(slice.length);
                this.writeSlice(slice);
            }
        },
        {
            key: "writeVector",
            value: function writeVector(vector) {
                var _this = this;
                this.writeVarInt(vector.length);
                vector.forEach(function(buf) {
                    return _this.writeVarSlice(buf);
                });
            }
        },
        {
            key: "end",
            value: function end() {
                if (this.buffer.length === this.offset) return this.buffer;
                throw new Error("buffer size ".concat(this.buffer.length, ", offset ").concat(this.offset));
            }
        }
    ], [
        {
            key: "withCapacity",
            value: function withCapacity(size) {
                return new BufferWriter($d6dfd2397ab1936f$require$Buffer.alloc(size));
            }
        }
    ]);
    return BufferWriter;
}();
$d6dfd2397ab1936f$exports.BufferWriter = $d6dfd2397ab1936f$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ var $d6dfd2397ab1936f$var$BufferReader = /*#__PURE__*/ function() {
    "use strict";
    function BufferReader(buffer) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $7dKN1._)(this, BufferReader);
        this.buffer = buffer;
        this.offset = offset;
        $d6dfd2397ab1936f$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.Buffer, $76e9130b49af92ba$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    (0, $eW5pA._)(BufferReader, [
        {
            key: "readUInt8",
            value: function readUInt8() {
                var result = this.buffer.readUInt8(this.offset);
                this.offset++;
                return result;
            }
        },
        {
            key: "readInt32",
            value: function readInt32() {
                var result = this.buffer.readInt32LE(this.offset);
                this.offset += 4;
                return result;
            }
        },
        {
            key: "readUInt32",
            value: function readUInt32() {
                var result = this.buffer.readUInt32LE(this.offset);
                this.offset += 4;
                return result;
            }
        },
        {
            key: "readUInt64",
            value: function readUInt64() {
                var result = $d6dfd2397ab1936f$var$readUInt64LE(this.buffer, this.offset);
                this.offset += 8;
                return result;
            }
        },
        {
            key: "readVarInt",
            value: function readVarInt() {
                var vi = $3aab16f2bcaeeed2$exports.decode(this.buffer, this.offset);
                this.offset += $3aab16f2bcaeeed2$exports.decode.bytes;
                return vi;
            }
        },
        {
            key: "readSlice",
            value: function readSlice(n) {
                if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
                var result = this.buffer.slice(this.offset, this.offset + n);
                this.offset += n;
                return result;
            }
        },
        {
            key: "readVarSlice",
            value: function readVarSlice() {
                return this.readSlice(this.readVarInt());
            }
        },
        {
            key: "readVector",
            value: function readVector() {
                var count = this.readVarInt();
                var vector = [];
                for(var i = 0; i < count; i++)vector.push(this.readVarSlice());
                return vector;
            }
        }
    ]);
    return BufferReader;
}();
$d6dfd2397ab1936f$exports.BufferReader = $d6dfd2397ab1936f$var$BufferReader;



$c86b0fc6a57c595c$exports.LEAF_VERSION_TAPSCRIPT = 0xc0;
$c86b0fc6a57c595c$exports.MAX_TAPTREE_DEPTH = 128;
var $c86b0fc6a57c595c$var$isHashBranch = function(ht) {
    return "left" in ht && "right" in ht;
};
/**
 * Calculates the root hash from a given control block and leaf hash.
 * @param controlBlock - The control block buffer.
 * @param leafHash - The leaf hash buffer.
 * @returns The root hash buffer.
 * @throws {TypeError} If the control block length is less than 33.
 */ function $c86b0fc6a57c595c$var$rootHashFromPath(controlBlock, leafHash) {
    if (controlBlock.length < 33) throw new TypeError("The control-block length is too small. Got ".concat(controlBlock.length, ", expected min 33."));
    var m = (controlBlock.length - 33) / 32;
    var kj = leafHash;
    for(var j = 0; j < m; j++){
        var ej = controlBlock.slice(33 + 32 * j, 65 + 32 * j);
        if (kj.compare(ej) < 0) kj = $c86b0fc6a57c595c$var$tapBranchHash(kj, ej);
        else kj = $c86b0fc6a57c595c$var$tapBranchHash(ej, kj);
    }
    return kj;
}
$c86b0fc6a57c595c$exports.rootHashFromPath = $c86b0fc6a57c595c$var$rootHashFromPath;
/**
 * Build a hash tree of merkle nodes from the scripts binary tree.
 * @param scriptTree - the tree of scripts to pairwise hash.
 */ function $c86b0fc6a57c595c$var$toHashTree(scriptTree) {
    if ((0, $76e9130b49af92ba$exports.isTapleaf)(scriptTree)) return {
        hash: $c86b0fc6a57c595c$var$tapleafHash(scriptTree)
    };
    var hashes = [
        $c86b0fc6a57c595c$var$toHashTree(scriptTree[0]),
        $c86b0fc6a57c595c$var$toHashTree(scriptTree[1])
    ];
    hashes.sort(function(a, b) {
        return a.hash.compare(b.hash);
    });
    var _hashes = (0, $5OlIx._)(hashes, 2), left = _hashes[0], right = _hashes[1];
    return {
        hash: $c86b0fc6a57c595c$var$tapBranchHash(left.hash, right.hash),
        left: left,
        right: right
    };
}
$c86b0fc6a57c595c$exports.toHashTree = $c86b0fc6a57c595c$var$toHashTree;
/**
 * Given a HashTree, finds the path from a particular hash to the root.
 * @param node - the root of the tree
 * @param hash - the hash to search for
 * @returns - array of sibling hashes, from leaf (inclusive) to root
 * (exclusive) needed to prove inclusion of the specified hash. undefined if no
 * path is found
 */ function $c86b0fc6a57c595c$var$findScriptPath(node, hash) {
    if ($c86b0fc6a57c595c$var$isHashBranch(node)) {
        var leftPath = $c86b0fc6a57c595c$var$findScriptPath(node.left, hash);
        if (leftPath !== undefined) return (0, $gF0bR._)(leftPath).concat([
            node.right.hash
        ]);
        var rightPath = $c86b0fc6a57c595c$var$findScriptPath(node.right, hash);
        if (rightPath !== undefined) return (0, $gF0bR._)(rightPath).concat([
            node.left.hash
        ]);
    } else if (node.hash.equals(hash)) return [];
    return undefined;
}
$c86b0fc6a57c595c$exports.findScriptPath = $c86b0fc6a57c595c$var$findScriptPath;
function $c86b0fc6a57c595c$var$tapleafHash(leaf) {
    var version = leaf.version || $c86b0fc6a57c595c$exports.LEAF_VERSION_TAPSCRIPT;
    return $f55d6b3f34e2f599$exports.taggedHash("TapLeaf", $ilnag.Buffer.concat([
        $ilnag.Buffer.from([
            version
        ]),
        $c86b0fc6a57c595c$var$serializeScript(leaf.output)
    ]));
}
$c86b0fc6a57c595c$exports.tapleafHash = $c86b0fc6a57c595c$var$tapleafHash;
function $c86b0fc6a57c595c$var$tapTweakHash(pubKey, h) {
    return $f55d6b3f34e2f599$exports.taggedHash("TapTweak", $ilnag.Buffer.concat(h ? [
        pubKey,
        h
    ] : [
        pubKey
    ]));
}
$c86b0fc6a57c595c$exports.tapTweakHash = $c86b0fc6a57c595c$var$tapTweakHash;
function $c86b0fc6a57c595c$var$tweakKey(pubKey, h) {
    if (!$ilnag.Buffer.isBuffer(pubKey)) return null;
    if (pubKey.length !== 32) return null;
    if (h && h.length !== 32) return null;
    var tweakHash = $c86b0fc6a57c595c$var$tapTweakHash(pubKey, h);
    var res = (0, $d1c3d48d4239db47$exports.getEccLib)().xOnlyPointAddTweak(pubKey, tweakHash);
    if (!res || res.xOnlyPubkey === null) return null;
    return {
        parity: res.parity,
        x: $ilnag.Buffer.from(res.xOnlyPubkey)
    };
}
$c86b0fc6a57c595c$exports.tweakKey = $c86b0fc6a57c595c$var$tweakKey;
function $c86b0fc6a57c595c$var$tapBranchHash(a, b) {
    return $f55d6b3f34e2f599$exports.taggedHash("TapBranch", $ilnag.Buffer.concat([
        a,
        b
    ]));
}
function $c86b0fc6a57c595c$var$serializeScript(s) {
    var varintLen = $d6dfd2397ab1936f$exports.varuint.encodingLength(s.length);
    var buffer = $ilnag.Buffer.allocUnsafe(varintLen); // better
    $d6dfd2397ab1936f$exports.varuint.encode(s.length, buffer);
    return $ilnag.Buffer.concat([
        buffer,
        s
    ]);
}





var $bf8a44cb3ab078f4$var$OPS = $cbd225966f86718e$exports.OPS;
var $bf8a44cb3ab078f4$var$TAPROOT_WITNESS_VERSION = 0x01;
var $bf8a44cb3ab078f4$var$ANNEX_PREFIX = 0x50;
/**
 * Creates a Pay-to-Taproot (P2TR) payment object.
 *
 * @param a - The payment object containing the necessary data for P2TR.
 * @param opts - Optional payment options.
 * @returns The P2TR payment object.
 * @throws {TypeError} If the provided data is invalid or insufficient.
 */ function $bf8a44cb3ab078f4$var$p2tr(a, opts) {
    if (!a.address && !a.output && !a.pubkey && !a.internalPubkey && !(a.witness && a.witness.length > 1)) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $76e9130b49af92ba$exports.typeforce)({
        address: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.String),
        input: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(0)),
        network: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Object),
        output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(34)),
        internalPubkey: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(32)),
        hash: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(32)),
        pubkey: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.BufferN(32)),
        signature: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.anyOf($76e9130b49af92ba$exports.typeforce.BufferN(64), $76e9130b49af92ba$exports.typeforce.BufferN(65))),
        witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer)),
        scriptTree: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.isTaptree),
        redeem: $76e9130b49af92ba$exports.typeforce.maybe({
            output: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Buffer),
            redeemVersion: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Number),
            witness: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.arrayOf($76e9130b49af92ba$exports.typeforce.Buffer))
        }),
        redeemVersion: $76e9130b49af92ba$exports.typeforce.maybe($76e9130b49af92ba$exports.typeforce.Number)
    }, a);
    var _address = $42ecdd0882a6eef0$exports.value(function() {
        return (0, $7c5b8444ede2c46b$exports.fromBech32)(a.address);
    });
    // remove annex if present, ignored by taproot
    var _witness = $42ecdd0882a6eef0$exports.value(function() {
        if (!a.witness || !a.witness.length) return;
        if (a.witness.length >= 2 && a.witness[a.witness.length - 1][0] === $bf8a44cb3ab078f4$var$ANNEX_PREFIX) return a.witness.slice(0, -1);
        return a.witness.slice();
    });
    var _hashTree = $42ecdd0882a6eef0$exports.value(function() {
        if (a.scriptTree) return (0, $c86b0fc6a57c595c$exports.toHashTree)(a.scriptTree);
        if (a.hash) return {
            hash: a.hash
        };
        return;
    });
    var network = a.network || $6945d51b6afc3226$exports.bitcoin;
    var o = {
        name: "p2tr",
        network: network
    };
    $42ecdd0882a6eef0$exports.prop(o, "address", function() {
        if (!o.pubkey) return;
        var words = $eed9357e4124c415$exports.bech32m.toWords(o.pubkey);
        words.unshift($bf8a44cb3ab078f4$var$TAPROOT_WITNESS_VERSION);
        return $eed9357e4124c415$exports.bech32m.encode(network.bech32, words);
    });
    $42ecdd0882a6eef0$exports.prop(o, "hash", function() {
        var hashTree = _hashTree();
        if (hashTree) return hashTree.hash;
        var w = _witness();
        if (w && w.length > 1) {
            var controlBlock = w[w.length - 1];
            var leafVersion = controlBlock[0] & $76e9130b49af92ba$exports.TAPLEAF_VERSION_MASK;
            var script = w[w.length - 2];
            var leafHash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
                output: script,
                version: leafVersion
            });
            return (0, $c86b0fc6a57c595c$exports.rootHashFromPath)(controlBlock, leafHash);
        }
        return null;
    });
    $42ecdd0882a6eef0$exports.prop(o, "output", function() {
        if (!o.pubkey) return;
        return $cbd225966f86718e$exports.compile([
            $bf8a44cb3ab078f4$var$OPS.OP_1,
            o.pubkey
        ]);
    });
    $42ecdd0882a6eef0$exports.prop(o, "redeemVersion", function() {
        if (a.redeemVersion) return a.redeemVersion;
        if (a.redeem && a.redeem.redeemVersion !== undefined && a.redeem.redeemVersion !== null) return a.redeem.redeemVersion;
        return $c86b0fc6a57c595c$exports.LEAF_VERSION_TAPSCRIPT;
    });
    $42ecdd0882a6eef0$exports.prop(o, "redeem", function() {
        var witness = _witness(); // witness without annex
        if (!witness || witness.length < 2) return;
        return {
            output: witness[witness.length - 2],
            witness: witness.slice(0, -2),
            redeemVersion: witness[witness.length - 1][0] & $76e9130b49af92ba$exports.TAPLEAF_VERSION_MASK
        };
    });
    $42ecdd0882a6eef0$exports.prop(o, "pubkey", function() {
        if (a.pubkey) return a.pubkey;
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.internalPubkey) {
            var tweakedKey = (0, $c86b0fc6a57c595c$exports.tweakKey)(o.internalPubkey, o.hash);
            if (tweakedKey) return tweakedKey.x;
        }
    });
    $42ecdd0882a6eef0$exports.prop(o, "internalPubkey", function() {
        if (a.internalPubkey) return a.internalPubkey;
        var witness = _witness();
        if (witness && witness.length > 1) return witness[witness.length - 1].slice(1, 33);
    });
    $42ecdd0882a6eef0$exports.prop(o, "signature", function() {
        if (a.signature) return a.signature;
        var witness = _witness(); // witness without annex
        if (!witness || witness.length !== 1) return;
        return witness[0];
    });
    $42ecdd0882a6eef0$exports.prop(o, "witness", function() {
        if (a.witness) return a.witness;
        var hashTree = _hashTree();
        if (hashTree && a.redeem && a.redeem.output && a.internalPubkey) {
            var leafHash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            var path = (0, $c86b0fc6a57c595c$exports.findScriptPath)(hashTree, leafHash);
            if (!path) return;
            var outputKey = (0, $c86b0fc6a57c595c$exports.tweakKey)(a.internalPubkey, hashTree.hash);
            if (!outputKey) return;
            var controlBock = $ilnag.Buffer.concat([
                $ilnag.Buffer.from([
                    o.redeemVersion | outputKey.parity
                ]),
                a.internalPubkey
            ].concat(path));
            return [
                a.redeem.output,
                controlBock
            ];
        }
        if (a.signature) return [
            a.signature
        ];
    });
    // extended validation
    if (opts.validate) {
        var pubkey = $ilnag.Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== $bf8a44cb3ab078f4$var$TAPROOT_WITNESS_VERSION) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            pubkey = _address().data;
        }
        if (a.pubkey) {
            if (pubkey.length > 0 && !pubkey.equals(a.pubkey)) throw new TypeError("Pubkey mismatch");
            else pubkey = a.pubkey;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $bf8a44cb3ab078f4$var$OPS.OP_1 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            if (pubkey.length > 0 && !pubkey.equals(a.output.slice(2))) throw new TypeError("Pubkey mismatch");
            else pubkey = a.output.slice(2);
        }
        if (a.internalPubkey) {
            var tweakedKey = (0, $c86b0fc6a57c595c$exports.tweakKey)(a.internalPubkey, o.hash);
            if (pubkey.length > 0 && !pubkey.equals(tweakedKey.x)) throw new TypeError("Pubkey mismatch");
            else pubkey = tweakedKey.x;
        }
        if (pubkey && pubkey.length) {
            if (!(0, $d1c3d48d4239db47$exports.getEccLib)().isXOnlyPoint(pubkey)) throw new TypeError("Invalid pubkey for p2tr");
        }
        var hashTree = _hashTree();
        if (a.hash && hashTree) {
            if (!a.hash.equals(hashTree.hash)) throw new TypeError("Hash mismatch");
        }
        if (a.redeem && a.redeem.output && hashTree) {
            var leafHash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            if (!(0, $c86b0fc6a57c595c$exports.findScriptPath)(hashTree, leafHash)) throw new TypeError("Redeem script not in tree");
        }
        var witness = _witness();
        // compare the provided redeem data with the one computed from witness
        if (a.redeem && o.redeem) {
            if (a.redeem.redeemVersion) {
                if (a.redeem.redeemVersion !== o.redeem.redeemVersion) throw new TypeError("Redeem.redeemVersion and witness mismatch");
            }
            if (a.redeem.output) {
                if ($cbd225966f86718e$exports.decompile(a.redeem.output).length === 0) throw new TypeError("Redeem.output is invalid");
                // output redeem is constructed from the witness
                if (o.redeem.output && !a.redeem.output.equals(o.redeem.output)) throw new TypeError("Redeem.output and witness mismatch");
            }
            if (a.redeem.witness) {
                if (o.redeem.witness && !(0, $76e9130b49af92ba$exports.stacksEqual)(a.redeem.witness, o.redeem.witness)) throw new TypeError("Redeem.witness and witness mismatch");
            }
        }
        if (witness && witness.length) {
            if (witness.length === 1) {
                // key spending
                if (a.signature && !a.signature.equals(witness[0])) throw new TypeError("Signature mismatch");
            } else {
                // script path spending
                var controlBlock = witness[witness.length - 1];
                if (controlBlock.length < 33) throw new TypeError("The control-block length is too small. Got ".concat(controlBlock.length, ", expected min 33."));
                if ((controlBlock.length - 33) % 32 !== 0) throw new TypeError("The control-block length of ".concat(controlBlock.length, " is incorrect!"));
                var m = (controlBlock.length - 33) / 32;
                if (m > 128) throw new TypeError("The script path is too long. Got ".concat(m, ", expected max 128."));
                var internalPubkey = controlBlock.slice(1, 33);
                if (a.internalPubkey && !a.internalPubkey.equals(internalPubkey)) throw new TypeError("Internal pubkey mismatch");
                if (!(0, $d1c3d48d4239db47$exports.getEccLib)().isXOnlyPoint(internalPubkey)) throw new TypeError("Invalid internalPubkey for p2tr witness");
                var leafVersion = controlBlock[0] & $76e9130b49af92ba$exports.TAPLEAF_VERSION_MASK;
                var script = witness[witness.length - 2];
                var leafHash1 = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
                    output: script,
                    version: leafVersion
                });
                var hash = (0, $c86b0fc6a57c595c$exports.rootHashFromPath)(controlBlock, leafHash1);
                var outputKey = (0, $c86b0fc6a57c595c$exports.tweakKey)(internalPubkey, hash);
                if (!outputKey) // todo: needs test data
                throw new TypeError("Invalid outputKey for p2tr witness");
                if (pubkey.length && !pubkey.equals(outputKey.x)) throw new TypeError("Pubkey mismatch for p2tr witness");
                if (outputKey.parity !== (controlBlock[0] & 1)) throw new Error("Incorrect parity");
            }
        }
    }
    return Object.assign(o, a);
}
$bf8a44cb3ab078f4$exports.p2tr = $bf8a44cb3ab078f4$var$p2tr;


Object.defineProperty($9771a9b72cb50314$exports, "p2tr", {
    enumerable: true,
    get: function get() {
        return $bf8a44cb3ab078f4$exports.p2tr;
    }
}); // TODO
 // witness commitment






var $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MAX_SIZE = 40;
var $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MIN_SIZE = 2;
var $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MAX_VERSION = 16;
var $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MIN_VERSION = 2;
var $7c5b8444ede2c46b$var$FUTURE_SEGWIT_VERSION_DIFF = 0x50;
var $7c5b8444ede2c46b$var$FUTURE_SEGWIT_VERSION_WARNING = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function $7c5b8444ede2c46b$var$_toFutureSegwitAddress(output, network) {
    var data = output.slice(2);
    if (data.length < $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MIN_SIZE || data.length > $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MAX_SIZE) throw new TypeError("Invalid program length for segwit address");
    var version = output[0] - $7c5b8444ede2c46b$var$FUTURE_SEGWIT_VERSION_DIFF;
    if (version < $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MIN_VERSION || version > $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MAX_VERSION) throw new TypeError("Invalid version for segwit address");
    if (output[1] !== data.length) throw new TypeError("Invalid script for segwit address");
    console.warn($7c5b8444ede2c46b$var$FUTURE_SEGWIT_VERSION_WARNING);
    return $7c5b8444ede2c46b$var$toBech32(data, version, network.bech32);
}
/**
 * decode address with base58 specification,  return address version and address hash if valid
 */ function $7c5b8444ede2c46b$var$fromBase58Check(address) {
    var payload = $7c5b8444ede2c46b$require$Buffer.from($27358ce981e45e98$exports.decode(address));
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + " is too short");
    if (payload.length > 21) throw new TypeError(address + " is too long");
    var version = payload.readUInt8(0);
    var hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
$7c5b8444ede2c46b$exports.fromBase58Check = $7c5b8444ede2c46b$var$fromBase58Check;
/**
 * decode address with bech32 specification,  return address version、address prefix and address data if valid
 */ function $7c5b8444ede2c46b$var$fromBech32(address) {
    var result;
    var version;
    try {
        result = $eed9357e4124c415$exports.bech32.decode(address);
    } catch (e) {}
    if (result) {
        version = result.words[0];
        if (version !== 0) throw new TypeError(address + " uses wrong encoding");
    } else {
        result = $eed9357e4124c415$exports.bech32m.decode(address);
        version = result.words[0];
        if (version === 0) throw new TypeError(address + " uses wrong encoding");
    }
    var data = $eed9357e4124c415$exports.bech32.fromWords(result.words.slice(1));
    return {
        version: version,
        prefix: result.prefix,
        data: $7c5b8444ede2c46b$require$Buffer.from(data)
    };
}
$7c5b8444ede2c46b$exports.fromBech32 = $7c5b8444ede2c46b$var$fromBech32;
/**
 * encode address hash to base58 address with version
 */ function $7c5b8444ede2c46b$var$toBase58Check(hash, version) {
    (0, $76e9130b49af92ba$exports.typeforce)((0, $76e9130b49af92ba$exports.tuple)($76e9130b49af92ba$exports.Hash160bit, $76e9130b49af92ba$exports.UInt8), arguments);
    var payload = $7c5b8444ede2c46b$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $27358ce981e45e98$exports.encode(payload);
}
$7c5b8444ede2c46b$exports.toBase58Check = $7c5b8444ede2c46b$var$toBase58Check;
/**
 * encode address hash to bech32 address with version and prefix
 */ function $7c5b8444ede2c46b$var$toBech32(data, version, prefix) {
    var words = $eed9357e4124c415$exports.bech32.toWords(data);
    words.unshift(version);
    return version === 0 ? $eed9357e4124c415$exports.bech32.encode(prefix, words) : $eed9357e4124c415$exports.bech32m.encode(prefix, words);
}
$7c5b8444ede2c46b$exports.toBech32 = $7c5b8444ede2c46b$var$toBech32;
/**
 * decode address from output script with network, return address if matched
 */ function $7c5b8444ede2c46b$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $6945d51b6afc3226$exports.bitcoin;
    try {
        return $9771a9b72cb50314$exports.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9771a9b72cb50314$exports.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9771a9b72cb50314$exports.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9771a9b72cb50314$exports.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $9771a9b72cb50314$exports.p2tr({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $7c5b8444ede2c46b$var$_toFutureSegwitAddress(output, network);
    } catch (e) {}
    throw new Error($cbd225966f86718e$exports.toASM(output) + " has no matching Address");
}
$7c5b8444ede2c46b$exports.fromOutputScript = $7c5b8444ede2c46b$var$fromOutputScript;
/**
 * encodes address to output script with network, return output script if address matched
 */ function $7c5b8444ede2c46b$var$toOutputScript(address, network) {
    network = network || $6945d51b6afc3226$exports.bitcoin;
    var decodeBase58;
    var decodeBech32;
    try {
        decodeBase58 = $7c5b8444ede2c46b$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $9771a9b72cb50314$exports.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $9771a9b72cb50314$exports.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $7c5b8444ede2c46b$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + " has an invalid prefix");
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $9771a9b72cb50314$exports.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $9771a9b72cb50314$exports.p2wsh({
                    hash: decodeBech32.data
                }).output;
            } else if (decodeBech32.version === 1) {
                if (decodeBech32.data.length === 32) return $9771a9b72cb50314$exports.p2tr({
                    pubkey: decodeBech32.data
                }).output;
            } else if (decodeBech32.version >= $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MIN_VERSION && decodeBech32.version <= $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MAX_VERSION && decodeBech32.data.length >= $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MIN_SIZE && decodeBech32.data.length <= $7c5b8444ede2c46b$var$FUTURE_SEGWIT_MAX_SIZE) {
                console.warn($7c5b8444ede2c46b$var$FUTURE_SEGWIT_VERSION_WARNING);
                return $cbd225966f86718e$exports.compile([
                    decodeBech32.version + $7c5b8444ede2c46b$var$FUTURE_SEGWIT_VERSION_DIFF,
                    decodeBech32.data
                ]);
            }
        }
    }
    throw new Error(address + " has no matching Script");
}
$7c5b8444ede2c46b$exports.toOutputScript = $7c5b8444ede2c46b$var$toOutputScript;


$881b6534ce6ec462$exports.address = $7c5b8444ede2c46b$exports;

$881b6534ce6ec462$exports.crypto = $f55d6b3f34e2f599$exports;

$881b6534ce6ec462$exports.networks = $6945d51b6afc3226$exports;

$881b6534ce6ec462$exports.payments = $9771a9b72cb50314$exports;

$881b6534ce6ec462$exports.script = $cbd225966f86718e$exports;
var $4e71176287ff5c51$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $4e71176287ff5c51$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($4e71176287ff5c51$exports, "__esModule", {
    value: true
});
$4e71176287ff5c51$exports.Block = void 0;


var $c8cd5b2fcf1b7476$exports = {};

var $ilnag = parcelRequire("ilnag");
var $c8cd5b2fcf1b7476$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($c8cd5b2fcf1b7476$exports, "__esModule", {
    value: true
});
$c8cd5b2fcf1b7476$exports.fastMerkleRoot = void 0;
/**
 * Calculates the Merkle root of an array of buffers using a specified digest function.
 *
 * @param values - The array of buffers.
 * @param digestFn - The digest function used to calculate the hash of the concatenated buffers.
 * @returns The Merkle root as a buffer.
 * @throws {TypeError} If the values parameter is not an array or the digestFn parameter is not a function.
 */ function $c8cd5b2fcf1b7476$var$fastMerkleRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError("Expected values Array");
    if (typeof digestFn !== "function") throw TypeError("Expected digest Function");
    var length = values.length;
    var results = values.concat();
    while(length > 1){
        var j = 0;
        for(var i = 0; i < length; i += 2, ++j){
            var left = results[i];
            var right = i + 1 === length ? left : results[i + 1];
            var data = $c8cd5b2fcf1b7476$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
}
$c8cd5b2fcf1b7476$exports.fastMerkleRoot = $c8cd5b2fcf1b7476$var$fastMerkleRoot;


var $0ae6e9085c711f8c$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $ilnag = parcelRequire("ilnag");
var $0ae6e9085c711f8c$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($0ae6e9085c711f8c$exports, "__esModule", {
    value: true
});
$0ae6e9085c711f8c$exports.Transaction = void 0;





var $0ae6e9085c711f8c$var$typeforce = $76e9130b49af92ba$exports.typeforce;
function $0ae6e9085c711f8c$var$varSliceSize(someScript) {
    var length = someScript.length;
    return $d6dfd2397ab1936f$exports.varuint.encodingLength(length) + length;
}
function $0ae6e9085c711f8c$var$vectorSize(someVector) {
    var length = someVector.length;
    return $d6dfd2397ab1936f$exports.varuint.encodingLength(length) + someVector.reduce(function(sum, witness) {
        return sum + $0ae6e9085c711f8c$var$varSliceSize(witness);
    }, 0);
}
var $0ae6e9085c711f8c$var$EMPTY_BUFFER = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(0);
var $0ae6e9085c711f8c$var$EMPTY_WITNESS = [];
var $0ae6e9085c711f8c$var$ZERO = $0ae6e9085c711f8c$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
var $0ae6e9085c711f8c$var$ONE = $0ae6e9085c711f8c$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000001", "hex");
var $0ae6e9085c711f8c$var$VALUE_UINT64_MAX = $0ae6e9085c711f8c$require$Buffer.from("ffffffffffffffff", "hex");
var $0ae6e9085c711f8c$var$BLANK_OUTPUT = {
    script: $0ae6e9085c711f8c$var$EMPTY_BUFFER,
    valueBuffer: $0ae6e9085c711f8c$var$VALUE_UINT64_MAX
};
function $0ae6e9085c711f8c$var$isOutput(out) {
    return out.value !== undefined;
}
/**
 * Represents a Bitcoin transaction.
 */ var $0ae6e9085c711f8c$var$Transaction = /*#__PURE__*/ function() {
    "use strict";
    function Transaction() {
        (0, $7dKN1._)(this, Transaction);
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    (0, $eW5pA._)(Transaction, [
        {
            key: "isCoinbase",
            value: function isCoinbase() {
                return this.ins.length === 1 && Transaction.isCoinbaseHash(this.ins[0].hash);
            }
        },
        {
            key: "addInput",
            value: function addInput(hash, index, sequence, scriptSig) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.Hash256bit, $76e9130b49af92ba$exports.UInt32, $76e9130b49af92ba$exports.maybe($76e9130b49af92ba$exports.UInt32), $76e9130b49af92ba$exports.maybe($76e9130b49af92ba$exports.Buffer)), arguments);
                if ($76e9130b49af92ba$exports.Null(sequence)) sequence = Transaction.DEFAULT_SEQUENCE;
                // Add the input and return the input's index
                return this.ins.push({
                    hash: hash,
                    index: index,
                    script: scriptSig || $0ae6e9085c711f8c$var$EMPTY_BUFFER,
                    sequence: sequence,
                    witness: $0ae6e9085c711f8c$var$EMPTY_WITNESS
                }) - 1;
            }
        },
        {
            key: "addOutput",
            value: function addOutput(scriptPubKey, value) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.Buffer, $76e9130b49af92ba$exports.Satoshi), arguments);
                // Add the output and return the output's index
                return this.outs.push({
                    script: scriptPubKey,
                    value: value
                }) - 1;
            }
        },
        {
            key: "hasWitnesses",
            value: function hasWitnesses() {
                return this.ins.some(function(x) {
                    return x.witness.length !== 0;
                });
            }
        },
        {
            key: "stripWitnesses",
            value: function stripWitnesses() {
                this.ins.forEach(function(input) {
                    input.witness = $0ae6e9085c711f8c$var$EMPTY_WITNESS; // Set witness data to an empty array
                });
            }
        },
        {
            key: "weight",
            value: function weight() {
                var base = this.byteLength(false);
                var total = this.byteLength(true);
                return base * 3 + total;
            }
        },
        {
            key: "virtualSize",
            value: function virtualSize() {
                return Math.ceil(this.weight() / 4);
            }
        },
        {
            key: "byteLength",
            value: function byteLength() {
                var _ALLOW_WITNESS = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
                return (hasWitnesses ? 10 : 8) + $d6dfd2397ab1936f$exports.varuint.encodingLength(this.ins.length) + $d6dfd2397ab1936f$exports.varuint.encodingLength(this.outs.length) + this.ins.reduce(function(sum, input) {
                    return sum + 40 + $0ae6e9085c711f8c$var$varSliceSize(input.script);
                }, 0) + this.outs.reduce(function(sum, output) {
                    return sum + 8 + $0ae6e9085c711f8c$var$varSliceSize(output.script);
                }, 0) + (hasWitnesses ? this.ins.reduce(function(sum, input) {
                    return sum + $0ae6e9085c711f8c$var$vectorSize(input.witness);
                }, 0) : 0);
            }
        },
        {
            key: "clone",
            value: function clone() {
                var newTx = new Transaction();
                newTx.version = this.version;
                newTx.locktime = this.locktime;
                newTx.ins = this.ins.map(function(txIn) {
                    return {
                        hash: txIn.hash,
                        index: txIn.index,
                        script: txIn.script,
                        sequence: txIn.sequence,
                        witness: txIn.witness
                    };
                });
                newTx.outs = this.outs.map(function(txOut) {
                    return {
                        script: txOut.script,
                        value: txOut.value
                    };
                });
                return newTx;
            }
        },
        {
            /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ key: "hashForSignature",
            value: function hashForSignature(inIndex, prevOutScript, hashType) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.UInt32, $76e9130b49af92ba$exports.Buffer, /* types.UInt8 */ $76e9130b49af92ba$exports.Number), arguments);
                // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
                if (inIndex >= this.ins.length) return $0ae6e9085c711f8c$var$ONE;
                // ignore OP_CODESEPARATOR
                var ourScript = $cbd225966f86718e$exports.compile($cbd225966f86718e$exports.decompile(prevOutScript).filter(function(x) {
                    return x !== $cbd225966f86718e$exports.OPS.OP_CODESEPARATOR;
                }));
                var txTmp = this.clone();
                // SIGHASH_NONE: ignore all outputs? (wildcard payee)
                if ((hashType & 0x1f) === Transaction.SIGHASH_NONE) {
                    txTmp.outs = [];
                    // ignore sequence numbers (except at inIndex)
                    txTmp.ins.forEach(function(input, i) {
                        if (i === inIndex) return;
                        input.sequence = 0;
                    });
                // SIGHASH_SINGLE: ignore all outputs, except at the same index?
                } else if ((hashType & 0x1f) === Transaction.SIGHASH_SINGLE) {
                    // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
                    if (inIndex >= this.outs.length) return $0ae6e9085c711f8c$var$ONE;
                    // truncate outputs after
                    txTmp.outs.length = inIndex + 1;
                    // "blank" outputs before
                    for(var i = 0; i < inIndex; i++)txTmp.outs[i] = $0ae6e9085c711f8c$var$BLANK_OUTPUT;
                    // ignore sequence numbers (except at inIndex)
                    txTmp.ins.forEach(function(input, y) {
                        if (y === inIndex) return;
                        input.sequence = 0;
                    });
                }
                // SIGHASH_ANYONECANPAY: ignore inputs entirely?
                if (hashType & Transaction.SIGHASH_ANYONECANPAY) {
                    txTmp.ins = [
                        txTmp.ins[inIndex]
                    ];
                    txTmp.ins[0].script = ourScript;
                // SIGHASH_ALL: only ignore input scripts
                } else {
                    // "blank" others input scripts
                    txTmp.ins.forEach(function(input) {
                        input.script = $0ae6e9085c711f8c$var$EMPTY_BUFFER;
                    });
                    txTmp.ins[inIndex].script = ourScript;
                }
                // serialize and hash
                var buffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
                buffer.writeInt32LE(hashType, buffer.length - 4);
                txTmp.__toBuffer(buffer, 0, false);
                return $f55d6b3f34e2f599$exports.hash256(buffer);
            }
        },
        {
            key: "hashForWitnessV1",
            value: function hashForWitnessV1(inIndex, prevOutScripts, values, hashType, leafHash, annex) {
                // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#common-signature-message
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.UInt32, $0ae6e9085c711f8c$var$typeforce.arrayOf($76e9130b49af92ba$exports.Buffer), $0ae6e9085c711f8c$var$typeforce.arrayOf($76e9130b49af92ba$exports.Satoshi), $76e9130b49af92ba$exports.UInt32), arguments);
                if (values.length !== this.ins.length || prevOutScripts.length !== this.ins.length) throw new Error("Must supply prevout script and value for all inputs");
                var outputType = hashType === Transaction.SIGHASH_DEFAULT ? Transaction.SIGHASH_ALL : hashType & Transaction.SIGHASH_OUTPUT_MASK;
                var inputType = hashType & Transaction.SIGHASH_INPUT_MASK;
                var isAnyoneCanPay = inputType === Transaction.SIGHASH_ANYONECANPAY;
                var isNone = outputType === Transaction.SIGHASH_NONE;
                var isSingle = outputType === Transaction.SIGHASH_SINGLE;
                var hashPrevouts = $0ae6e9085c711f8c$var$EMPTY_BUFFER;
                var hashAmounts = $0ae6e9085c711f8c$var$EMPTY_BUFFER;
                var hashScriptPubKeys = $0ae6e9085c711f8c$var$EMPTY_BUFFER;
                var hashSequences = $0ae6e9085c711f8c$var$EMPTY_BUFFER;
                var hashOutputs = $0ae6e9085c711f8c$var$EMPTY_BUFFER;
                if (!isAnyoneCanPay) {
                    var bufferWriter = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(36 * this.ins.length);
                    this.ins.forEach(function(txIn) {
                        bufferWriter.writeSlice(txIn.hash);
                        bufferWriter.writeUInt32(txIn.index);
                    });
                    hashPrevouts = $f55d6b3f34e2f599$exports.sha256(bufferWriter.end());
                    bufferWriter = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(8 * this.ins.length);
                    values.forEach(function(value) {
                        return bufferWriter.writeUInt64(value);
                    });
                    hashAmounts = $f55d6b3f34e2f599$exports.sha256(bufferWriter.end());
                    bufferWriter = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(prevOutScripts.map($0ae6e9085c711f8c$var$varSliceSize).reduce(function(a, b) {
                        return a + b;
                    }));
                    prevOutScripts.forEach(function(prevOutScript) {
                        return bufferWriter.writeVarSlice(prevOutScript);
                    });
                    hashScriptPubKeys = $f55d6b3f34e2f599$exports.sha256(bufferWriter.end());
                    bufferWriter = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(4 * this.ins.length);
                    this.ins.forEach(function(txIn) {
                        return bufferWriter.writeUInt32(txIn.sequence);
                    });
                    hashSequences = $f55d6b3f34e2f599$exports.sha256(bufferWriter.end());
                }
                if (!(isNone || isSingle)) {
                    var txOutsSize = this.outs.map(function(output) {
                        return 8 + $0ae6e9085c711f8c$var$varSliceSize(output.script);
                    }).reduce(function(a, b) {
                        return a + b;
                    });
                    var bufferWriter1 = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(txOutsSize);
                    this.outs.forEach(function(out) {
                        bufferWriter1.writeUInt64(out.value);
                        bufferWriter1.writeVarSlice(out.script);
                    });
                    hashOutputs = $f55d6b3f34e2f599$exports.sha256(bufferWriter1.end());
                } else if (isSingle && inIndex < this.outs.length) {
                    var output = this.outs[inIndex];
                    var bufferWriter2 = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(8 + $0ae6e9085c711f8c$var$varSliceSize(output.script));
                    bufferWriter2.writeUInt64(output.value);
                    bufferWriter2.writeVarSlice(output.script);
                    hashOutputs = $f55d6b3f34e2f599$exports.sha256(bufferWriter2.end());
                }
                var spendType = (leafHash ? 2 : 0) + (annex ? 1 : 0);
                // Length calculation from:
                // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-14
                // With extension from:
                // https://github.com/bitcoin/bips/blob/master/bip-0342.mediawiki#signature-validation
                var sigMsgSize = 174 - (isAnyoneCanPay ? 49 : 0) - (isNone ? 32 : 0) + (annex ? 32 : 0) + (leafHash ? 37 : 0);
                var sigMsgWriter = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity(sigMsgSize);
                sigMsgWriter.writeUInt8(hashType);
                // Transaction
                sigMsgWriter.writeInt32(this.version);
                sigMsgWriter.writeUInt32(this.locktime);
                sigMsgWriter.writeSlice(hashPrevouts);
                sigMsgWriter.writeSlice(hashAmounts);
                sigMsgWriter.writeSlice(hashScriptPubKeys);
                sigMsgWriter.writeSlice(hashSequences);
                if (!(isNone || isSingle)) sigMsgWriter.writeSlice(hashOutputs);
                // Input
                sigMsgWriter.writeUInt8(spendType);
                if (isAnyoneCanPay) {
                    var input = this.ins[inIndex];
                    sigMsgWriter.writeSlice(input.hash);
                    sigMsgWriter.writeUInt32(input.index);
                    sigMsgWriter.writeUInt64(values[inIndex]);
                    sigMsgWriter.writeVarSlice(prevOutScripts[inIndex]);
                    sigMsgWriter.writeUInt32(input.sequence);
                } else sigMsgWriter.writeUInt32(inIndex);
                if (annex) {
                    var bufferWriter3 = $d6dfd2397ab1936f$exports.BufferWriter.withCapacity($0ae6e9085c711f8c$var$varSliceSize(annex));
                    bufferWriter3.writeVarSlice(annex);
                    sigMsgWriter.writeSlice($f55d6b3f34e2f599$exports.sha256(bufferWriter3.end()));
                }
                // Output
                if (isSingle) sigMsgWriter.writeSlice(hashOutputs);
                // BIP342 extension
                if (leafHash) {
                    sigMsgWriter.writeSlice(leafHash);
                    sigMsgWriter.writeUInt8(0);
                    sigMsgWriter.writeUInt32(0xffffffff);
                }
                // Extra zero byte because:
                // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-19
                return $f55d6b3f34e2f599$exports.taggedHash("TapSighash", $0ae6e9085c711f8c$require$Buffer.concat([
                    $0ae6e9085c711f8c$require$Buffer.from([
                        0x00
                    ]),
                    sigMsgWriter.end()
                ]));
            }
        },
        {
            key: "hashForWitnessV0",
            value: function hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.UInt32, $76e9130b49af92ba$exports.Buffer, $76e9130b49af92ba$exports.Satoshi, $76e9130b49af92ba$exports.UInt32), arguments);
                var tbuffer = $0ae6e9085c711f8c$require$Buffer.from([]);
                var bufferWriter;
                var hashOutputs = $0ae6e9085c711f8c$var$ZERO;
                var hashPrevouts = $0ae6e9085c711f8c$var$ZERO;
                var hashSequence = $0ae6e9085c711f8c$var$ZERO;
                if (!(hashType & Transaction.SIGHASH_ANYONECANPAY)) {
                    tbuffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(36 * this.ins.length);
                    bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(tbuffer, 0);
                    this.ins.forEach(function(txIn) {
                        bufferWriter.writeSlice(txIn.hash);
                        bufferWriter.writeUInt32(txIn.index);
                    });
                    hashPrevouts = $f55d6b3f34e2f599$exports.hash256(tbuffer);
                }
                if (!(hashType & Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== Transaction.SIGHASH_NONE) {
                    tbuffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(4 * this.ins.length);
                    bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(tbuffer, 0);
                    this.ins.forEach(function(txIn) {
                        bufferWriter.writeUInt32(txIn.sequence);
                    });
                    hashSequence = $f55d6b3f34e2f599$exports.hash256(tbuffer);
                }
                if ((hashType & 0x1f) !== Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== Transaction.SIGHASH_NONE) {
                    var txOutsSize = this.outs.reduce(function(sum, output) {
                        return sum + 8 + $0ae6e9085c711f8c$var$varSliceSize(output.script);
                    }, 0);
                    tbuffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(txOutsSize);
                    bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(tbuffer, 0);
                    this.outs.forEach(function(out) {
                        bufferWriter.writeUInt64(out.value);
                        bufferWriter.writeVarSlice(out.script);
                    });
                    hashOutputs = $f55d6b3f34e2f599$exports.hash256(tbuffer);
                } else if ((hashType & 0x1f) === Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
                    var output = this.outs[inIndex];
                    tbuffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(8 + $0ae6e9085c711f8c$var$varSliceSize(output.script));
                    bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(tbuffer, 0);
                    bufferWriter.writeUInt64(output.value);
                    bufferWriter.writeVarSlice(output.script);
                    hashOutputs = $f55d6b3f34e2f599$exports.hash256(tbuffer);
                }
                tbuffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(156 + $0ae6e9085c711f8c$var$varSliceSize(prevOutScript));
                bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(tbuffer, 0);
                var input = this.ins[inIndex];
                bufferWriter.writeInt32(this.version);
                bufferWriter.writeSlice(hashPrevouts);
                bufferWriter.writeSlice(hashSequence);
                bufferWriter.writeSlice(input.hash);
                bufferWriter.writeUInt32(input.index);
                bufferWriter.writeVarSlice(prevOutScript);
                bufferWriter.writeUInt64(value);
                bufferWriter.writeUInt32(input.sequence);
                bufferWriter.writeSlice(hashOutputs);
                bufferWriter.writeUInt32(this.locktime);
                bufferWriter.writeUInt32(hashType);
                return $f55d6b3f34e2f599$exports.hash256(tbuffer);
            }
        },
        {
            key: "getHash",
            value: function getHash(forWitness) {
                // wtxid for coinbase is always 32 bytes of 0x00
                if (forWitness && this.isCoinbase()) return $0ae6e9085c711f8c$require$Buffer.alloc(32, 0);
                return $f55d6b3f34e2f599$exports.hash256(this.__toBuffer(undefined, undefined, forWitness));
            }
        },
        {
            key: "getId",
            value: function getId() {
                // transaction hash's are displayed in reverse order
                return (0, $d6dfd2397ab1936f$exports.reverseBuffer)(this.getHash(false)).toString("hex");
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer(buffer, initialOffset) {
                return this.__toBuffer(buffer, initialOffset, true);
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return this.toBuffer(undefined, undefined).toString("hex");
            }
        },
        {
            key: "setInputScript",
            value: function setInputScript(index, scriptSig) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.Number, $76e9130b49af92ba$exports.Buffer), arguments);
                this.ins[index].script = scriptSig;
            }
        },
        {
            key: "setWitness",
            value: function setWitness(index, witness) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.tuple($76e9130b49af92ba$exports.Number, [
                    $76e9130b49af92ba$exports.Buffer
                ]), arguments);
                this.ins[index].witness = witness;
            }
        },
        {
            key: "__toBuffer",
            value: function __toBuffer(buffer, initialOffset) {
                var _ALLOW_WITNESS = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (!buffer) buffer = $0ae6e9085c711f8c$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
                var bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(buffer, initialOffset || 0);
                bufferWriter.writeInt32(this.version);
                var hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
                if (hasWitnesses) {
                    bufferWriter.writeUInt8(Transaction.ADVANCED_TRANSACTION_MARKER);
                    bufferWriter.writeUInt8(Transaction.ADVANCED_TRANSACTION_FLAG);
                }
                bufferWriter.writeVarInt(this.ins.length);
                this.ins.forEach(function(txIn) {
                    bufferWriter.writeSlice(txIn.hash);
                    bufferWriter.writeUInt32(txIn.index);
                    bufferWriter.writeVarSlice(txIn.script);
                    bufferWriter.writeUInt32(txIn.sequence);
                });
                bufferWriter.writeVarInt(this.outs.length);
                this.outs.forEach(function(txOut) {
                    if ($0ae6e9085c711f8c$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
                    else bufferWriter.writeSlice(txOut.valueBuffer);
                    bufferWriter.writeVarSlice(txOut.script);
                });
                if (hasWitnesses) this.ins.forEach(function(input) {
                    bufferWriter.writeVector(input.witness);
                });
                bufferWriter.writeUInt32(this.locktime);
                // avoid slicing unless necessary
                if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
                return buffer;
            }
        }
    ], [
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer, _NO_STRICT) {
                var bufferReader = new $d6dfd2397ab1936f$exports.BufferReader(buffer);
                var tx = new Transaction();
                tx.version = bufferReader.readInt32();
                var marker = bufferReader.readUInt8();
                var flag = bufferReader.readUInt8();
                var hasWitnesses = false;
                if (marker === Transaction.ADVANCED_TRANSACTION_MARKER && flag === Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
                else bufferReader.offset -= 2;
                var vinLen = bufferReader.readVarInt();
                for(var i = 0; i < vinLen; ++i)tx.ins.push({
                    hash: bufferReader.readSlice(32),
                    index: bufferReader.readUInt32(),
                    script: bufferReader.readVarSlice(),
                    sequence: bufferReader.readUInt32(),
                    witness: $0ae6e9085c711f8c$var$EMPTY_WITNESS
                });
                var voutLen = bufferReader.readVarInt();
                for(var i1 = 0; i1 < voutLen; ++i1)tx.outs.push({
                    value: bufferReader.readUInt64(),
                    script: bufferReader.readVarSlice()
                });
                if (hasWitnesses) {
                    for(var i2 = 0; i2 < vinLen; ++i2)tx.ins[i2].witness = bufferReader.readVector();
                    // was this pointless?
                    if (!tx.hasWitnesses()) throw new Error("Transaction has superfluous witness data");
                }
                tx.locktime = bufferReader.readUInt32();
                if (_NO_STRICT) return tx;
                if (bufferReader.offset !== buffer.length) throw new Error("Transaction has unexpected data");
                return tx;
            }
        },
        {
            key: "fromHex",
            value: function fromHex(hex) {
                return Transaction.fromBuffer($0ae6e9085c711f8c$require$Buffer.from(hex, "hex"), false);
            }
        },
        {
            key: "isCoinbaseHash",
            value: function isCoinbaseHash(buffer) {
                $0ae6e9085c711f8c$var$typeforce($76e9130b49af92ba$exports.Hash256bit, buffer);
                for(var i = 0; i < 32; ++i){
                    if (buffer[i] !== 0) return false;
                }
                return true;
            }
        }
    ]);
    return Transaction;
}();
$0ae6e9085c711f8c$exports.Transaction = $0ae6e9085c711f8c$var$Transaction;
$0ae6e9085c711f8c$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_DEFAULT = 0x00;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_ALL = 0x01;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_NONE = 0x02;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_SINGLE = 0x03;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_OUTPUT_MASK = 0x03;
$0ae6e9085c711f8c$var$Transaction.SIGHASH_INPUT_MASK = 0x80;
$0ae6e9085c711f8c$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$0ae6e9085c711f8c$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;



var $4e71176287ff5c51$var$typeforce = $76e9130b49af92ba$exports.typeforce;
var $4e71176287ff5c51$var$errorMerkleNoTxes = new TypeError("Cannot compute merkle root for zero transactions");
var $4e71176287ff5c51$var$errorWitnessNotSegwit = new TypeError("Cannot compute witness commit for non-segwit block");
var $4e71176287ff5c51$var$Block = /*#__PURE__*/ function() {
    "use strict";
    function Block() {
        (0, $7dKN1._)(this, Block);
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    (0, $eW5pA._)(Block, [
        {
            key: "getWitnessCommit",
            value: function getWitnessCommit() {
                if (!$4e71176287ff5c51$var$txesHaveWitnessCommit(this.transactions)) return null;
                // The merkle root for the witness data is in an OP_RETURN output.
                // There is no rule for the index of the output, so use filter to find it.
                // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
                // If multiple commits are found, the output with highest index is assumed.
                var witnessCommits = this.transactions[0].outs.filter(function(out) {
                    return out.script.slice(0, 6).equals($4e71176287ff5c51$require$Buffer.from("6a24aa21a9ed", "hex"));
                }).map(function(out) {
                    return out.script.slice(6, 38);
                });
                if (witnessCommits.length === 0) return null;
                // Use the commit with the highest output (should only be one though)
                var result = witnessCommits[witnessCommits.length - 1];
                if (!(result instanceof $4e71176287ff5c51$require$Buffer && result.length === 32)) return null;
                return result;
            }
        },
        {
            key: "hasWitnessCommit",
            value: function hasWitnessCommit() {
                if (this.witnessCommit instanceof $4e71176287ff5c51$require$Buffer && this.witnessCommit.length === 32) return true;
                if (this.getWitnessCommit() !== null) return true;
                return false;
            }
        },
        {
            key: "hasWitness",
            value: function hasWitness() {
                return $4e71176287ff5c51$var$anyTxHasWitness(this.transactions);
            }
        },
        {
            key: "weight",
            value: function weight() {
                var base = this.byteLength(false, false);
                var total = this.byteLength(false, true);
                return base * 3 + total;
            }
        },
        {
            key: "byteLength",
            value: function byteLength(headersOnly) {
                var allowWitness = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (headersOnly || !this.transactions) return 80;
                return 80 + $d6dfd2397ab1936f$exports.varuint.encodingLength(this.transactions.length) + this.transactions.reduce(function(a, x) {
                    return a + x.byteLength(allowWitness);
                }, 0);
            }
        },
        {
            key: "getHash",
            value: function getHash() {
                return $f55d6b3f34e2f599$exports.hash256(this.toBuffer(true));
            }
        },
        {
            key: "getId",
            value: function getId() {
                return (0, $d6dfd2397ab1936f$exports.reverseBuffer)(this.getHash()).toString("hex");
            }
        },
        {
            key: "getUTCDate",
            value: function getUTCDate() {
                var date = new Date(0); // epoch
                date.setUTCSeconds(this.timestamp);
                return date;
            }
        },
        {
            // TODO: buffer, offset compatibility
            key: "toBuffer",
            value: function toBuffer(headersOnly) {
                var buffer = $4e71176287ff5c51$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
                var bufferWriter = new $d6dfd2397ab1936f$exports.BufferWriter(buffer);
                bufferWriter.writeInt32(this.version);
                bufferWriter.writeSlice(this.prevHash);
                bufferWriter.writeSlice(this.merkleRoot);
                bufferWriter.writeUInt32(this.timestamp);
                bufferWriter.writeUInt32(this.bits);
                bufferWriter.writeUInt32(this.nonce);
                if (headersOnly || !this.transactions) return buffer;
                $d6dfd2397ab1936f$exports.varuint.encode(this.transactions.length, buffer, bufferWriter.offset);
                bufferWriter.offset += $d6dfd2397ab1936f$exports.varuint.encode.bytes;
                this.transactions.forEach(function(tx) {
                    var txSize = tx.byteLength(); // TODO: extract from toBuffer?
                    tx.toBuffer(buffer, bufferWriter.offset);
                    bufferWriter.offset += txSize;
                });
                return buffer;
            }
        },
        {
            key: "toHex",
            value: function toHex(headersOnly) {
                return this.toBuffer(headersOnly).toString("hex");
            }
        },
        {
            key: "checkTxRoots",
            value: function checkTxRoots() {
                // If the Block has segwit transactions but no witness commit,
                // there's no way it can be valid, so fail the check.
                var hasWitnessCommit = this.hasWitnessCommit();
                if (!hasWitnessCommit && this.hasWitness()) return false;
                return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
            }
        },
        {
            key: "checkProofOfWork",
            value: function checkProofOfWork() {
                var hash = (0, $d6dfd2397ab1936f$exports.reverseBuffer)(this.getHash());
                var target = Block.calculateTarget(this.bits);
                return hash.compare(target) <= 0;
            }
        },
        {
            key: "__checkMerkleRoot",
            value: function __checkMerkleRoot() {
                if (!this.transactions) throw $4e71176287ff5c51$var$errorMerkleNoTxes;
                var actualMerkleRoot = Block.calculateMerkleRoot(this.transactions);
                return this.merkleRoot.compare(actualMerkleRoot) === 0;
            }
        },
        {
            key: "__checkWitnessCommit",
            value: function __checkWitnessCommit() {
                if (!this.transactions) throw $4e71176287ff5c51$var$errorMerkleNoTxes;
                if (!this.hasWitnessCommit()) throw $4e71176287ff5c51$var$errorWitnessNotSegwit;
                var actualWitnessCommit = Block.calculateMerkleRoot(this.transactions, true);
                return this.witnessCommit.compare(actualWitnessCommit) === 0;
            }
        }
    ], [
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer) {
                if (buffer.length < 80) throw new Error("Buffer too small (< 80 bytes)");
                var bufferReader = new $d6dfd2397ab1936f$exports.BufferReader(buffer);
                var block = new Block();
                block.version = bufferReader.readInt32();
                block.prevHash = bufferReader.readSlice(32);
                block.merkleRoot = bufferReader.readSlice(32);
                block.timestamp = bufferReader.readUInt32();
                block.bits = bufferReader.readUInt32();
                block.nonce = bufferReader.readUInt32();
                if (buffer.length === 80) return block;
                var readTransaction = function() {
                    var tx = $0ae6e9085c711f8c$exports.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
                    bufferReader.offset += tx.byteLength();
                    return tx;
                };
                var nTransactions = bufferReader.readVarInt();
                block.transactions = [];
                for(var i = 0; i < nTransactions; ++i){
                    var tx = readTransaction();
                    block.transactions.push(tx);
                }
                var witnessCommit = block.getWitnessCommit();
                // This Block contains a witness commit
                if (witnessCommit) block.witnessCommit = witnessCommit;
                return block;
            }
        },
        {
            key: "fromHex",
            value: function fromHex(hex) {
                return Block.fromBuffer($4e71176287ff5c51$require$Buffer.from(hex, "hex"));
            }
        },
        {
            key: "calculateTarget",
            value: function calculateTarget(bits) {
                var exponent = ((bits & 0xff000000) >> 24) - 3;
                var mantissa = bits & 0x007fffff;
                var target = $4e71176287ff5c51$require$Buffer.alloc(32, 0);
                target.writeUIntBE(mantissa, 29 - exponent, 3);
                return target;
            }
        },
        {
            key: "calculateMerkleRoot",
            value: function calculateMerkleRoot(transactions, forWitness) {
                $4e71176287ff5c51$var$typeforce([
                    {
                        getHash: $76e9130b49af92ba$exports.Function
                    }
                ], transactions);
                if (transactions.length === 0) throw $4e71176287ff5c51$var$errorMerkleNoTxes;
                if (forWitness && !$4e71176287ff5c51$var$txesHaveWitnessCommit(transactions)) throw $4e71176287ff5c51$var$errorWitnessNotSegwit;
                var hashes = transactions.map(function(transaction) {
                    return transaction.getHash(forWitness);
                });
                var rootHash = (0, $c8cd5b2fcf1b7476$exports.fastMerkleRoot)(hashes, $f55d6b3f34e2f599$exports.hash256);
                return forWitness ? $f55d6b3f34e2f599$exports.hash256($4e71176287ff5c51$require$Buffer.concat([
                    rootHash,
                    transactions[0].ins[0].witness[0]
                ])) : rootHash;
            }
        }
    ]);
    return Block;
}();
$4e71176287ff5c51$exports.Block = $4e71176287ff5c51$var$Block;
function $4e71176287ff5c51$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $4e71176287ff5c51$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some(function(tx) {
        return typeof tx === "object" && tx.ins instanceof Array && tx.ins.some(function(input) {
            return typeof input === "object" && input.witness instanceof Array && input.witness.length > 0;
        });
    });
}


Object.defineProperty($881b6534ce6ec462$exports, "Block", {
    enumerable: true,
    get: function get() {
        return $4e71176287ff5c51$exports.Block;
    }
});
var $94769f80e8eb4304$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");

var $ilnag = parcelRequire("ilnag");
var $94769f80e8eb4304$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($94769f80e8eb4304$exports, "__esModule", {
    value: true
});
$94769f80e8eb4304$exports.Psbt = void 0;


var $d1BPf = parcelRequire("d1BPf");








var $b5a175672e85eac3$exports = {};

var $gF0bR = parcelRequire("gF0bR");

var $ilnag = parcelRequire("ilnag");
var $b5a175672e85eac3$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($b5a175672e85eac3$exports, "__esModule", {
    value: true
});
$b5a175672e85eac3$exports.checkTaprootInputForSigs = $b5a175672e85eac3$exports.tapTreeFromList = $b5a175672e85eac3$exports.tapTreeToList = $b5a175672e85eac3$exports.tweakInternalPubKey = $b5a175672e85eac3$exports.checkTaprootOutputFields = $b5a175672e85eac3$exports.checkTaprootInputFields = $b5a175672e85eac3$exports.isTaprootOutput = $b5a175672e85eac3$exports.isTaprootInput = $b5a175672e85eac3$exports.serializeTaprootSignature = $b5a175672e85eac3$exports.tapScriptFinalizer = $b5a175672e85eac3$exports.toXOnly = void 0;


var $895ab8ec90f143e6$exports = {};

var $ilnag = parcelRequire("ilnag");
var $895ab8ec90f143e6$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($895ab8ec90f143e6$exports, "__esModule", {
    value: true
});
$895ab8ec90f143e6$exports.signatureBlocksAction = $895ab8ec90f143e6$exports.checkInputForSig = $895ab8ec90f143e6$exports.pubkeyInScript = $895ab8ec90f143e6$exports.pubkeyPositionInScript = $895ab8ec90f143e6$exports.witnessStackToScriptWitness = $895ab8ec90f143e6$exports.isP2TR = $895ab8ec90f143e6$exports.isP2SHScript = $895ab8ec90f143e6$exports.isP2WSHScript = $895ab8ec90f143e6$exports.isP2WPKH = $895ab8ec90f143e6$exports.isP2PKH = $895ab8ec90f143e6$exports.isP2PK = $895ab8ec90f143e6$exports.isP2MS = void 0;

var $d1BPf = parcelRequire("d1BPf");




function $895ab8ec90f143e6$var$isPaymentFactory(payment) {
    return function(script) {
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
$895ab8ec90f143e6$exports.isP2MS = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2ms);
$895ab8ec90f143e6$exports.isP2PK = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2pk);
$895ab8ec90f143e6$exports.isP2PKH = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2pkh);
$895ab8ec90f143e6$exports.isP2WPKH = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2wpkh);
$895ab8ec90f143e6$exports.isP2WSHScript = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2wsh);
$895ab8ec90f143e6$exports.isP2SHScript = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2sh);
$895ab8ec90f143e6$exports.isP2TR = $895ab8ec90f143e6$var$isPaymentFactory($9771a9b72cb50314$exports.p2tr);
/**
 * Converts a witness stack to a script witness.
 * @param witness The witness stack to convert.
 * @returns The script witness as a Buffer.
 */ /**
 * Converts a witness stack to a script witness.
 * @param witness The witness stack to convert.
 * @returns The converted script witness.
 */ function $895ab8ec90f143e6$var$witnessStackToScriptWitness(witness) {
    var buffer = $895ab8ec90f143e6$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $895ab8ec90f143e6$require$Buffer.concat([
            buffer,
            $895ab8ec90f143e6$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        var currentLen = buffer.length;
        var varintLen = $d1BPf.encodingLength(i);
        buffer = $895ab8ec90f143e6$require$Buffer.concat([
            buffer,
            $895ab8ec90f143e6$require$Buffer.allocUnsafe(varintLen)
        ]);
        $d1BPf.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
$895ab8ec90f143e6$exports.witnessStackToScriptWitness = $895ab8ec90f143e6$var$witnessStackToScriptWitness;
/**
 * Finds the position of a public key in a script.
 * @param pubkey The public key to search for.
 * @param script The script to search in.
 * @returns The index of the public key in the script, or -1 if not found.
 * @throws {Error} If there is an unknown script error.
 */ function $895ab8ec90f143e6$var$pubkeyPositionInScript(pubkey, script) {
    var pubkeyHash = (0, $f55d6b3f34e2f599$exports.hash160)(pubkey);
    var pubkeyXOnly = pubkey.slice(1, 33); // slice before calling?
    var decompiled = $cbd225966f86718e$exports.decompile(script);
    if (decompiled === null) throw new Error("Unknown script error");
    return decompiled.findIndex(function(element) {
        if (typeof element === "number") return false;
        return element.equals(pubkey) || element.equals(pubkeyHash) || element.equals(pubkeyXOnly);
    });
}
$895ab8ec90f143e6$exports.pubkeyPositionInScript = $895ab8ec90f143e6$var$pubkeyPositionInScript;
/**
 * Checks if a public key is present in a script.
 * @param pubkey The public key to check.
 * @param script The script to search in.
 * @returns A boolean indicating whether the public key is present in the script.
 */ function $895ab8ec90f143e6$var$pubkeyInScript(pubkey, script) {
    return $895ab8ec90f143e6$var$pubkeyPositionInScript(pubkey, script) !== -1;
}
$895ab8ec90f143e6$exports.pubkeyInScript = $895ab8ec90f143e6$var$pubkeyInScript;
/**
 * Checks if an input contains a signature for a specific action.
 * @param input - The input to check.
 * @param action - The action to check for.
 * @returns A boolean indicating whether the input contains a signature for the specified action.
 */ function $895ab8ec90f143e6$var$checkInputForSig(input, action) {
    var pSigs = $895ab8ec90f143e6$var$extractPartialSigs(input);
    return pSigs.some(function(pSig) {
        return $895ab8ec90f143e6$var$signatureBlocksAction(pSig, $cbd225966f86718e$exports.signature.decode, action);
    });
}
$895ab8ec90f143e6$exports.checkInputForSig = $895ab8ec90f143e6$var$checkInputForSig;
/**
 * Determines if a given action is allowed for a signature block.
 * @param signature - The signature block.
 * @param signatureDecodeFn - The function used to decode the signature.
 * @param action - The action to be checked.
 * @returns True if the action is allowed, false otherwise.
 */ function $895ab8ec90f143e6$var$signatureBlocksAction(signature, signatureDecodeFn, action) {
    var hashType = signatureDecodeFn(signature).hashType;
    var whitelist = [];
    var isAnyoneCanPay = hashType & $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ANYONECANPAY;
    if (isAnyoneCanPay) whitelist.push("addInput");
    var hashMod = hashType & 0x1f;
    switch(hashMod){
        case $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL:
            break;
        case $0ae6e9085c711f8c$exports.Transaction.SIGHASH_SINGLE:
        case $0ae6e9085c711f8c$exports.Transaction.SIGHASH_NONE:
            whitelist.push("addOutput");
            whitelist.push("setInputSequence");
            break;
    }
    if (whitelist.indexOf(action) === -1) return true;
    return false;
}
$895ab8ec90f143e6$exports.signatureBlocksAction = $895ab8ec90f143e6$var$signatureBlocksAction;
/**
 * Extracts the signatures from a PsbtInput object.
 * If the input has partial signatures, it returns an array of the signatures.
 * If the input does not have partial signatures, it checks if it has a finalScriptSig or finalScriptWitness.
 * If it does, it extracts the signatures from the final scripts and returns them.
 * If none of the above conditions are met, it returns an empty array.
 *
 * @param input - The PsbtInput object from which to extract the signatures.
 * @returns An array of signatures extracted from the PsbtInput object.
 */ function $895ab8ec90f143e6$var$extractPartialSigs(input) {
    var pSigs = [];
    if ((input.partialSig || []).length === 0) {
        if (!input.finalScriptSig && !input.finalScriptWitness) return [];
        pSigs = $895ab8ec90f143e6$var$getPsigsFromInputFinalScripts(input);
    } else pSigs = input.partialSig;
    return pSigs.map(function(p) {
        return p.signature;
    });
}
/**
 * Retrieves the partial signatures (Psigs) from the input's final scripts.
 * Psigs are extracted from both the final scriptSig and final scriptWitness of the input.
 * Only canonical script signatures are considered.
 *
 * @param input - The PsbtInput object representing the input.
 * @returns An array of PartialSig objects containing the extracted Psigs.
 */ function $895ab8ec90f143e6$var$getPsigsFromInputFinalScripts(input) {
    var scriptItems = !input.finalScriptSig ? [] : $cbd225966f86718e$exports.decompile(input.finalScriptSig) || [];
    var witnessItems = !input.finalScriptWitness ? [] : $cbd225966f86718e$exports.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter(function(item) {
        return $895ab8ec90f143e6$require$Buffer.isBuffer(item) && $cbd225966f86718e$exports.isCanonicalScriptSignature(item);
    }).map(function(sig) {
        return {
            signature: sig
        };
    });
}





var $b5a175672e85eac3$var$toXOnly = function(pubKey) {
    return pubKey.length === 32 ? pubKey : pubKey.slice(1, 33);
};
$b5a175672e85eac3$exports.toXOnly = $b5a175672e85eac3$var$toXOnly;
/**
 * Default tapscript finalizer. It searches for the `tapLeafHashToFinalize` if provided.
 * Otherwise it will search for the tapleaf that has at least one signature and has the shortest path.
 * @param inputIndex the position of the PSBT input.
 * @param input the PSBT input.
 * @param tapLeafHashToFinalize optional, if provided the finalizer will search for a tapleaf that has this hash
 *                              and will try to build the finalScriptWitness.
 * @returns the finalScriptWitness or throws an exception if no tapleaf found.
 */ function $b5a175672e85eac3$var$tapScriptFinalizer(inputIndex, input, tapLeafHashToFinalize) {
    var tapLeaf = $b5a175672e85eac3$var$findTapLeafToFinalize(input, inputIndex, tapLeafHashToFinalize);
    try {
        var sigs = $b5a175672e85eac3$var$sortSignatures(input, tapLeaf);
        var witness = sigs.concat(tapLeaf.script).concat(tapLeaf.controlBlock);
        return {
            finalScriptWitness: (0, $895ab8ec90f143e6$exports.witnessStackToScriptWitness)(witness)
        };
    } catch (err) {
        throw new Error("Can not finalize taproot input #".concat(inputIndex, ": ").concat(err));
    }
}
$b5a175672e85eac3$exports.tapScriptFinalizer = $b5a175672e85eac3$var$tapScriptFinalizer;
function $b5a175672e85eac3$var$serializeTaprootSignature(sig, sighashType) {
    var sighashTypeByte = sighashType ? $b5a175672e85eac3$require$Buffer.from([
        sighashType
    ]) : $b5a175672e85eac3$require$Buffer.from([]);
    return $b5a175672e85eac3$require$Buffer.concat([
        sig,
        sighashTypeByte
    ]);
}
$b5a175672e85eac3$exports.serializeTaprootSignature = $b5a175672e85eac3$var$serializeTaprootSignature;
function $b5a175672e85eac3$var$isTaprootInput(input) {
    return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || input.witnessUtxo && (0, $895ab8ec90f143e6$exports.isP2TR)(input.witnessUtxo.script));
}
$b5a175672e85eac3$exports.isTaprootInput = $b5a175672e85eac3$var$isTaprootInput;
function $b5a175672e85eac3$var$isTaprootOutput(output, script) {
    return output && !!(output.tapInternalKey || output.tapTree || output.tapBip32Derivation && output.tapBip32Derivation.length || script && (0, $895ab8ec90f143e6$exports.isP2TR)(script));
}
$b5a175672e85eac3$exports.isTaprootOutput = $b5a175672e85eac3$var$isTaprootOutput;
function $b5a175672e85eac3$var$checkTaprootInputFields(inputData, newInputData, action) {
    $b5a175672e85eac3$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action);
    $b5a175672e85eac3$var$checkIfTapLeafInTree(inputData, newInputData, action);
}
$b5a175672e85eac3$exports.checkTaprootInputFields = $b5a175672e85eac3$var$checkTaprootInputFields;
function $b5a175672e85eac3$var$checkTaprootOutputFields(outputData, newOutputData, action) {
    $b5a175672e85eac3$var$checkMixedTaprootAndNonTaprootOutputFields(outputData, newOutputData, action);
    $b5a175672e85eac3$var$checkTaprootScriptPubkey(outputData, newOutputData);
}
$b5a175672e85eac3$exports.checkTaprootOutputFields = $b5a175672e85eac3$var$checkTaprootOutputFields;
function $b5a175672e85eac3$var$checkTaprootScriptPubkey(outputData, newOutputData) {
    if (!newOutputData.tapTree && !newOutputData.tapInternalKey) return;
    var tapInternalKey = newOutputData.tapInternalKey || outputData.tapInternalKey;
    var tapTree = newOutputData.tapTree || outputData.tapTree;
    if (tapInternalKey) {
        var scriptPubkey = outputData.script;
        var script = $b5a175672e85eac3$var$getTaprootScripPubkey(tapInternalKey, tapTree);
        if (scriptPubkey && !scriptPubkey.equals(script)) throw new Error("Error adding output. Script or address missmatch.");
    }
}
function $b5a175672e85eac3$var$getTaprootScripPubkey(tapInternalKey, tapTree) {
    var scriptTree = tapTree && $b5a175672e85eac3$var$tapTreeFromList(tapTree.leaves);
    var output = (0, $9771a9b72cb50314$exports.p2tr)({
        internalPubkey: tapInternalKey,
        scriptTree: scriptTree
    }).output;
    return output;
}
function $b5a175672e85eac3$var$tweakInternalPubKey(inputIndex, input) {
    var tapInternalKey = input.tapInternalKey;
    var outputKey = tapInternalKey && (0, $c86b0fc6a57c595c$exports.tweakKey)(tapInternalKey, input.tapMerkleRoot);
    if (!outputKey) throw new Error("Cannot tweak tap internal key for input #".concat(inputIndex, ". Public key: ").concat(tapInternalKey && tapInternalKey.toString("hex")));
    return outputKey.x;
}
$b5a175672e85eac3$exports.tweakInternalPubKey = $b5a175672e85eac3$var$tweakInternalPubKey;
/**
 * Convert a binary tree to a BIP371 type list. Each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @param tree the binary tap tree
 * @returns a list of BIP 371 tapleaves
 */ function $b5a175672e85eac3$var$tapTreeToList(tree) {
    if (!(0, $76e9130b49af92ba$exports.isTaptree)(tree)) throw new Error("Cannot convert taptree to tapleaf list. Expecting a tapree structure.");
    return $b5a175672e85eac3$var$_tapTreeToList(tree);
}
$b5a175672e85eac3$exports.tapTreeToList = $b5a175672e85eac3$var$tapTreeToList;
/**
 * Convert a BIP371 TapLeaf list to a TapTree (binary).
 * @param leaves a list of tapleaves where each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @returns the corresponding taptree, or throws an exception if the tree cannot be reconstructed
 */ function $b5a175672e85eac3$var$tapTreeFromList() {
    var leaves = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (leaves.length === 1 && leaves[0].depth === 0) return {
        output: leaves[0].script,
        version: leaves[0].leafVersion
    };
    return $b5a175672e85eac3$var$instertLeavesInTree(leaves);
}
$b5a175672e85eac3$exports.tapTreeFromList = $b5a175672e85eac3$var$tapTreeFromList;
function $b5a175672e85eac3$var$checkTaprootInputForSigs(input, action) {
    var sigs = $b5a175672e85eac3$var$extractTaprootSigs(input);
    return sigs.some(function(sig) {
        return (0, $895ab8ec90f143e6$exports.signatureBlocksAction)(sig, $b5a175672e85eac3$var$decodeSchnorrSignature, action);
    });
}
$b5a175672e85eac3$exports.checkTaprootInputForSigs = $b5a175672e85eac3$var$checkTaprootInputForSigs;
function $b5a175672e85eac3$var$decodeSchnorrSignature(signature) {
    return {
        signature: signature.slice(0, 64),
        hashType: signature.slice(64)[0] || $0ae6e9085c711f8c$exports.Transaction.SIGHASH_DEFAULT
    };
}
function $b5a175672e85eac3$var$extractTaprootSigs(input) {
    var _sigs;
    var sigs = [];
    if (input.tapKeySig) sigs.push(input.tapKeySig);
    if (input.tapScriptSig) (_sigs = sigs).push.apply(_sigs, (0, $gF0bR._)(input.tapScriptSig.map(function(s) {
        return s.signature;
    })));
    if (!sigs.length) {
        var finalTapKeySig = $b5a175672e85eac3$var$getTapKeySigFromWithness(input.finalScriptWitness);
        if (finalTapKeySig) sigs.push(finalTapKeySig);
    }
    return sigs;
}
function $b5a175672e85eac3$var$getTapKeySigFromWithness(finalScriptWitness) {
    if (!finalScriptWitness) return;
    var witness = finalScriptWitness.slice(2);
    // todo: add schnorr signature validation
    if (witness.length === 64 || witness.length === 65) return witness;
}
function $b5a175672e85eac3$var$_tapTreeToList(tree) {
    var leaves = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (depth > $c86b0fc6a57c595c$exports.MAX_TAPTREE_DEPTH) throw new Error("Max taptree depth exceeded.");
    if (!tree) return [];
    if ((0, $76e9130b49af92ba$exports.isTapleaf)(tree)) {
        leaves.push({
            depth: depth,
            leafVersion: tree.version || $c86b0fc6a57c595c$exports.LEAF_VERSION_TAPSCRIPT,
            script: tree.output
        });
        return leaves;
    }
    if (tree[0]) $b5a175672e85eac3$var$_tapTreeToList(tree[0], leaves, depth + 1);
    if (tree[1]) $b5a175672e85eac3$var$_tapTreeToList(tree[1], leaves, depth + 1);
    return leaves;
}
function $b5a175672e85eac3$var$instertLeavesInTree(leaves) {
    var tree;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = leaves[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var leaf = _step.value;
            tree = $b5a175672e85eac3$var$instertLeafInTree(leaf, tree);
            if (!tree) throw new Error("No room left to insert tapleaf in tree");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return tree;
}
function $b5a175672e85eac3$var$instertLeafInTree(leaf, tree) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (depth > $c86b0fc6a57c595c$exports.MAX_TAPTREE_DEPTH) throw new Error("Max taptree depth exceeded.");
    if (leaf.depth === depth) {
        if (!tree) return {
            output: leaf.script,
            version: leaf.leafVersion
        };
        return;
    }
    if ((0, $76e9130b49af92ba$exports.isTapleaf)(tree)) return;
    var leftSide = $b5a175672e85eac3$var$instertLeafInTree(leaf, tree && tree[0], depth + 1);
    if (leftSide) return [
        leftSide,
        tree && tree[1]
    ];
    var rightSide = $b5a175672e85eac3$var$instertLeafInTree(leaf, tree && tree[1], depth + 1);
    if (rightSide) return [
        tree && tree[0],
        rightSide
    ];
}
function $b5a175672e85eac3$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action) {
    var isBadTaprootUpdate = $b5a175672e85eac3$var$isTaprootInput(inputData) && $b5a175672e85eac3$var$hasNonTaprootFields(newInputData);
    var isBadNonTaprootUpdate = $b5a175672e85eac3$var$hasNonTaprootFields(inputData) && $b5a175672e85eac3$var$isTaprootInput(newInputData);
    var hasMixedFields = inputData === newInputData && $b5a175672e85eac3$var$isTaprootInput(newInputData) && $b5a175672e85eac3$var$hasNonTaprootFields(newInputData); // todo: bad? use !===
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error("Invalid arguments for Psbt.".concat(action, ". ") + "Cannot use both taproot and non-taproot fields.");
}
function $b5a175672e85eac3$var$checkMixedTaprootAndNonTaprootOutputFields(inputData, newInputData, action) {
    var isBadTaprootUpdate = $b5a175672e85eac3$var$isTaprootOutput(inputData) && $b5a175672e85eac3$var$hasNonTaprootFields(newInputData);
    var isBadNonTaprootUpdate = $b5a175672e85eac3$var$hasNonTaprootFields(inputData) && $b5a175672e85eac3$var$isTaprootOutput(newInputData);
    var hasMixedFields = inputData === newInputData && $b5a175672e85eac3$var$isTaprootOutput(newInputData) && $b5a175672e85eac3$var$hasNonTaprootFields(newInputData);
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error("Invalid arguments for Psbt.".concat(action, ". ") + "Cannot use both taproot and non-taproot fields.");
}
/**
 * Checks if the tap leaf is part of the tap tree for the given input data.
 * Throws an error if the tap leaf is not part of the tap tree.
 * @param inputData - The original PsbtInput data.
 * @param newInputData - The new PsbtInput data.
 * @param action - The action being performed.
 * @throws {Error} - If the tap leaf is not part of the tap tree.
 */ function $b5a175672e85eac3$var$checkIfTapLeafInTree(inputData, newInputData, action) {
    if (newInputData.tapMerkleRoot) {
        var newLeafsInTree = (newInputData.tapLeafScript || []).every(function(l) {
            return $b5a175672e85eac3$var$isTapLeafInTree(l, newInputData.tapMerkleRoot);
        });
        var oldLeafsInTree = (inputData.tapLeafScript || []).every(function(l) {
            return $b5a175672e85eac3$var$isTapLeafInTree(l, newInputData.tapMerkleRoot);
        });
        if (!newLeafsInTree || !oldLeafsInTree) throw new Error("Invalid arguments for Psbt.".concat(action, ". Tapleaf not part of taptree."));
    } else if (inputData.tapMerkleRoot) {
        var newLeafsInTree1 = (newInputData.tapLeafScript || []).every(function(l) {
            return $b5a175672e85eac3$var$isTapLeafInTree(l, inputData.tapMerkleRoot);
        });
        if (!newLeafsInTree1) throw new Error("Invalid arguments for Psbt.".concat(action, ". Tapleaf not part of taptree."));
    }
}
/**
 * Checks if a TapLeafScript is present in a Merkle tree.
 * @param tapLeaf The TapLeafScript to check.
 * @param merkleRoot The Merkle root of the tree. If not provided, the function assumes the TapLeafScript is present.
 * @returns A boolean indicating whether the TapLeafScript is present in the tree.
 */ function $b5a175672e85eac3$var$isTapLeafInTree(tapLeaf, merkleRoot) {
    if (!merkleRoot) return true;
    var leafHash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    var rootHash = (0, $c86b0fc6a57c595c$exports.rootHashFromPath)(tapLeaf.controlBlock, leafHash);
    return rootHash.equals(merkleRoot);
}
/**
 * Sorts the signatures in the input's tapScriptSig array based on their position in the tapLeaf script.
 *
 * @param input - The PsbtInput object.
 * @param tapLeaf - The TapLeafScript object.
 * @returns An array of sorted signatures as Buffers.
 */ function $b5a175672e85eac3$var$sortSignatures(input, tapLeaf) {
    var leafHash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    return (input.tapScriptSig || []).filter(function(tss) {
        return tss.leafHash.equals(leafHash);
    }).map(function(tss) {
        return $b5a175672e85eac3$var$addPubkeyPositionInScript(tapLeaf.script, tss);
    }).sort(function(t1, t2) {
        return t2.positionInScript - t1.positionInScript;
    }).map(function(t) {
        return t.signature;
    });
}
/**
 * Adds the position of a public key in a script to a TapScriptSig object.
 * @param script The script in which to find the position of the public key.
 * @param tss The TapScriptSig object to add the position to.
 * @returns A TapScriptSigWitPosition object with the added position.
 */ function $b5a175672e85eac3$var$addPubkeyPositionInScript(script, tss) {
    return Object.assign({
        positionInScript: (0, $895ab8ec90f143e6$exports.pubkeyPositionInScript)(tss.pubkey, script)
    }, tss);
}
/**
 * Find tapleaf by hash, or get the signed tapleaf with the shortest path.
 */ function $b5a175672e85eac3$var$findTapLeafToFinalize(input, inputIndex, leafHashToFinalize) {
    if (!input.tapScriptSig || !input.tapScriptSig.length) throw new Error("Can not finalize taproot input #".concat(inputIndex, ". No tapleaf script signature provided."));
    var tapLeaf = (input.tapLeafScript || []).sort(function(a, b) {
        return a.controlBlock.length - b.controlBlock.length;
    }).find(function(leaf) {
        return $b5a175672e85eac3$var$canFinalizeLeaf(leaf, input.tapScriptSig, leafHashToFinalize);
    });
    if (!tapLeaf) throw new Error("Can not finalize taproot input #".concat(inputIndex, ". Signature for tapleaf script not found."));
    return tapLeaf;
}
/**
 * Determines whether a TapLeafScript can be finalized.
 *
 * @param leaf - The TapLeafScript to check.
 * @param tapScriptSig - The array of TapScriptSig objects.
 * @param hash - The optional hash to compare with the leaf hash.
 * @returns A boolean indicating whether the TapLeafScript can be finalized.
 */ function $b5a175672e85eac3$var$canFinalizeLeaf(leaf, tapScriptSig, hash) {
    var leafHash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
        output: leaf.script,
        version: leaf.leafVersion
    });
    var whiteListedHash = !hash || hash.equals(leafHash);
    return whiteListedHash && tapScriptSig.find(function(tss) {
        return tss.leafHash.equals(leafHash);
    }) !== undefined;
}
/**
 * Checks if the given PsbtInput or PsbtOutput has non-taproot fields.
 * Non-taproot fields include redeemScript, witnessScript, and bip32Derivation.
 * @param io The PsbtInput or PsbtOutput to check.
 * @returns A boolean indicating whether the given input or output has non-taproot fields.
 */ function $b5a175672e85eac3$var$hasNonTaprootFields(io) {
    return io && !!(io.redeemScript || io.witnessScript || io.bip32Derivation && io.bip32Derivation.length);
}



/**
 * These are the default arguments for a Psbt instance.
 */ var $94769f80e8eb4304$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $6945d51b6afc3226$exports.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 *
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 *
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 *
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 *
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 *
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ var $94769f80e8eb4304$var$Psbt = /*#__PURE__*/ function() {
    "use strict";
    function Psbt() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $27f0a5038233d038$exports.Psbt(new $94769f80e8eb4304$var$PsbtTransaction());
        (0, $7dKN1._)(this, Psbt);
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $94769f80e8eb4304$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Psbt's predecessor (TransactionBuilder - now removed) behavior
            // was to not confirm input values  before signing.
            // Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        var dpew = function(obj, attr, enumerable, writable) {
            return Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        };
        dpew(this, "__CACHE", false, true);
        dpew(this, "opts", false, true);
    }
    (0, $eW5pA._)(Psbt, [
        {
            key: "inputCount",
            get: function get() {
                return this.data.inputs.length;
            }
        },
        {
            key: "version",
            get: function get() {
                return this.__CACHE.__TX.version;
            },
            set: function set(version) {
                this.setVersion(version);
            }
        },
        {
            key: "locktime",
            get: function get() {
                return this.__CACHE.__TX.locktime;
            },
            set: function set(locktime) {
                this.setLocktime(locktime);
            }
        },
        {
            key: "txInputs",
            get: function get() {
                return this.__CACHE.__TX.ins.map(function(input) {
                    return {
                        hash: (0, $d6dfd2397ab1936f$exports.cloneBuffer)(input.hash),
                        index: input.index,
                        sequence: input.sequence
                    };
                });
            }
        },
        {
            key: "txOutputs",
            get: function get() {
                var _this = this;
                return this.__CACHE.__TX.outs.map(function(output) {
                    var address;
                    try {
                        address = (0, $7c5b8444ede2c46b$exports.fromOutputScript)(output.script, _this.opts.network);
                    } catch (_) {}
                    return {
                        script: (0, $d6dfd2397ab1936f$exports.cloneBuffer)(output.script),
                        value: output.value,
                        address: address
                    };
                });
            }
        },
        {
            key: "combine",
            value: function combine() {
                for(var _len = arguments.length, those = new Array(_len), _key = 0; _key < _len; _key++){
                    those[_key] = arguments[_key];
                }
                var _this_data;
                (_this_data = this.data).combine.apply(_this_data, (0, $gF0bR._)(those.map(function(o) {
                    return o.data;
                })));
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                // TODO: more efficient cloning
                var res = Psbt.fromBuffer(this.data.toBuffer());
                res.opts = JSON.parse(JSON.stringify(this.opts));
                return res;
            }
        },
        {
            key: "setMaximumFeeRate",
            value: function setMaximumFeeRate(satoshiPerByte) {
                $94769f80e8eb4304$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
                this.opts.maximumFeeRate = satoshiPerByte;
            }
        },
        {
            key: "setVersion",
            value: function setVersion(version) {
                $94769f80e8eb4304$var$check32Bit(version);
                $94769f80e8eb4304$var$checkInputsForPartialSig(this.data.inputs, "setVersion");
                var c = this.__CACHE;
                c.__TX.version = version;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "setLocktime",
            value: function setLocktime(locktime) {
                $94769f80e8eb4304$var$check32Bit(locktime);
                $94769f80e8eb4304$var$checkInputsForPartialSig(this.data.inputs, "setLocktime");
                var c = this.__CACHE;
                c.__TX.locktime = locktime;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "setInputSequence",
            value: function setInputSequence(inputIndex, sequence) {
                $94769f80e8eb4304$var$check32Bit(sequence);
                $94769f80e8eb4304$var$checkInputsForPartialSig(this.data.inputs, "setInputSequence");
                var c = this.__CACHE;
                if (c.__TX.ins.length <= inputIndex) throw new Error("Input index too high");
                c.__TX.ins[inputIndex].sequence = sequence;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "addInputs",
            value: function addInputs(inputDatas) {
                var _this = this;
                inputDatas.forEach(function(inputData) {
                    return _this.addInput(inputData);
                });
                return this;
            }
        },
        {
            key: "addInput",
            value: function addInput(inputData) {
                if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error("Invalid arguments for Psbt.addInput. " + "Requires single object with at least [hash] and [index]");
                (0, $b5a175672e85eac3$exports.checkTaprootInputFields)(inputData, inputData, "addInput");
                $94769f80e8eb4304$var$checkInputsForPartialSig(this.data.inputs, "addInput");
                if (inputData.witnessScript) $94769f80e8eb4304$var$checkInvalidP2WSH(inputData.witnessScript);
                var c = this.__CACHE;
                this.data.addInput(inputData);
                var txIn = c.__TX.ins[c.__TX.ins.length - 1];
                $94769f80e8eb4304$var$checkTxInputCache(c, txIn);
                var inputIndex = this.data.inputs.length - 1;
                var input = this.data.inputs[inputIndex];
                if (input.nonWitnessUtxo) $94769f80e8eb4304$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
                c.__FEE = undefined;
                c.__FEE_RATE = undefined;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "addOutputs",
            value: function addOutputs(outputDatas) {
                var _this = this;
                outputDatas.forEach(function(outputData) {
                    return _this.addOutput(outputData);
                });
                return this;
            }
        },
        {
            key: "addOutput",
            value: function addOutput(outputData) {
                if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error("Invalid arguments for Psbt.addOutput. " + "Requires single object with at least [script or address] and [value]");
                $94769f80e8eb4304$var$checkInputsForPartialSig(this.data.inputs, "addOutput");
                var address = outputData.address;
                if (typeof address === "string") {
                    var network = this.opts.network;
                    var script = (0, $7c5b8444ede2c46b$exports.toOutputScript)(address, network);
                    outputData = Object.assign({}, outputData, {
                        script: script
                    });
                }
                (0, $b5a175672e85eac3$exports.checkTaprootOutputFields)(outputData, outputData, "addOutput");
                var c = this.__CACHE;
                this.data.addOutput(outputData);
                c.__FEE = undefined;
                c.__FEE_RATE = undefined;
                c.__EXTRACTED_TX = undefined;
                return this;
            }
        },
        {
            key: "extractTransaction",
            value: function extractTransaction(disableFeeCheck) {
                if (!this.data.inputs.every($94769f80e8eb4304$var$isFinalized)) throw new Error("Not finalized");
                var c = this.__CACHE;
                if (!disableFeeCheck) $94769f80e8eb4304$var$checkFees(this, c, this.opts);
                if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
                var tx = c.__TX.clone();
                $94769f80e8eb4304$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
                return tx;
            }
        },
        {
            key: "getFeeRate",
            value: function getFeeRate() {
                return $94769f80e8eb4304$var$getTxCacheValue("__FEE_RATE", "fee rate", this.data.inputs, this.__CACHE);
            }
        },
        {
            key: "getFee",
            value: function getFee() {
                return $94769f80e8eb4304$var$getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
            }
        },
        {
            key: "finalizeAllInputs",
            value: function finalizeAllInputs() {
                var _this = this;
                (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, 0); // making sure we have at least one
                $94769f80e8eb4304$var$range(this.data.inputs.length).forEach(function(idx) {
                    return _this.finalizeInput(idx);
                });
                return this;
            }
        },
        {
            key: "finalizeInput",
            value: function finalizeInput(inputIndex, finalScriptsFunc) {
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, undefined, finalScriptsFunc);
                return this._finalizeInput(inputIndex, input, finalScriptsFunc);
            }
        },
        {
            key: "finalizeTaprootInput",
            value: function finalizeTaprootInput(inputIndex, tapLeafHashToFinalize) {
                var finalScriptsFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $b5a175672e85eac3$exports.tapScriptFinalizer;
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc);
                throw new Error("Cannot finalize input #".concat(inputIndex, ". Not Taproot."));
            }
        },
        {
            key: "_finalizeInput",
            value: function _finalizeInput(inputIndex, input) {
                var finalScriptsFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $94769f80e8eb4304$var$getFinalScripts;
                var _getScriptFromInput = $94769f80e8eb4304$var$getScriptFromInput(inputIndex, input, this.__CACHE), script = _getScriptFromInput.script, isP2SH = _getScriptFromInput.isP2SH, isP2WSH = _getScriptFromInput.isP2WSH, isSegwit = _getScriptFromInput.isSegwit;
                if (!script) throw new Error("No script found for input #".concat(inputIndex));
                $94769f80e8eb4304$var$checkPartialSigSighashes(input);
                var _finalScriptsFunc = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH), finalScriptSig = _finalScriptsFunc.finalScriptSig, finalScriptWitness = _finalScriptsFunc.finalScriptWitness;
                if (finalScriptSig) this.data.updateInput(inputIndex, {
                    finalScriptSig: finalScriptSig
                });
                if (finalScriptWitness) this.data.updateInput(inputIndex, {
                    finalScriptWitness: finalScriptWitness
                });
                if (!finalScriptSig && !finalScriptWitness) throw new Error("Unknown error finalizing input #".concat(inputIndex));
                this.data.clearFinalizedInput(inputIndex);
                return this;
            }
        },
        {
            key: "_finalizeTaprootInput",
            value: function _finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize) {
                var finalScriptsFunc = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $b5a175672e85eac3$exports.tapScriptFinalizer;
                if (!input.witnessUtxo) throw new Error("Cannot finalize input #".concat(inputIndex, ". Missing withness utxo."));
                // Check key spend first. Increased privacy and reduced block space.
                if (input.tapKeySig) {
                    var payment = $9771a9b72cb50314$exports.p2tr({
                        output: input.witnessUtxo.script,
                        signature: input.tapKeySig
                    });
                    var finalScriptWitness = (0, $895ab8ec90f143e6$exports.witnessStackToScriptWitness)(payment.witness);
                    this.data.updateInput(inputIndex, {
                        finalScriptWitness: finalScriptWitness
                    });
                } else {
                    var finalScriptWitness1 = finalScriptsFunc(inputIndex, input, tapLeafHashToFinalize).finalScriptWitness;
                    this.data.updateInput(inputIndex, {
                        finalScriptWitness: finalScriptWitness1
                    });
                }
                this.data.clearFinalizedInput(inputIndex);
                return this;
            }
        },
        {
            key: "getInputType",
            value: function getInputType(inputIndex) {
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                var script = $94769f80e8eb4304$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
                var result = $94769f80e8eb4304$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript || $94769f80e8eb4304$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $94769f80e8eb4304$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
                var type = result.type === "raw" ? "" : result.type + "-";
                var mainType = $94769f80e8eb4304$var$classifyScript(result.meaningfulScript);
                return type + mainType;
            }
        },
        {
            key: "inputHasPubkey",
            value: function inputHasPubkey(inputIndex, pubkey) {
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                return $94769f80e8eb4304$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
            }
        },
        {
            key: "inputHasHDKey",
            value: function inputHasHDKey(inputIndex, root) {
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                var derivationIsMine = $94769f80e8eb4304$var$bip32DerivationIsMine(root);
                return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
            }
        },
        {
            key: "outputHasPubkey",
            value: function outputHasPubkey(outputIndex, pubkey) {
                var output = (0, $2afa9fa2748275c6$exports.checkForOutput)(this.data.outputs, outputIndex);
                return $94769f80e8eb4304$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
            }
        },
        {
            key: "outputHasHDKey",
            value: function outputHasHDKey(outputIndex, root) {
                var output = (0, $2afa9fa2748275c6$exports.checkForOutput)(this.data.outputs, outputIndex);
                var derivationIsMine = $94769f80e8eb4304$var$bip32DerivationIsMine(root);
                return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
            }
        },
        {
            key: "validateSignaturesOfAllInputs",
            value: function validateSignaturesOfAllInputs(validator) {
                var _this = this;
                (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, 0); // making sure we have at least one
                var results = $94769f80e8eb4304$var$range(this.data.inputs.length).map(function(idx) {
                    return _this.validateSignaturesOfInput(idx, validator);
                });
                return results.reduce(function(final, res) {
                    return res === true && final;
                }, true);
            }
        },
        {
            key: "validateSignaturesOfInput",
            value: function validateSignaturesOfInput(inputIndex, validator, pubkey) {
                var input = this.data.inputs[inputIndex];
                if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return this.validateSignaturesOfTaprootInput(inputIndex, validator, pubkey);
                return this._validateSignaturesOfInput(inputIndex, validator, pubkey);
            }
        },
        {
            key: "_validateSignaturesOfInput",
            value: function _validateSignaturesOfInput(inputIndex, validator, pubkey) {
                var input = this.data.inputs[inputIndex];
                var partialSig = (input || {}).partialSig;
                if (!input || !partialSig || partialSig.length < 1) throw new Error("No signatures to validate");
                if (typeof validator !== "function") throw new Error("Need validator function to validate signatures");
                var mySigs = pubkey ? partialSig.filter(function(sig) {
                    return sig.pubkey.equals(pubkey);
                }) : partialSig;
                if (mySigs.length < 1) throw new Error("No signatures for this pubkey");
                var results = [];
                var hashCache;
                var scriptCache;
                var sighashCache;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mySigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pSig = _step.value;
                        var sig = $cbd225966f86718e$exports.signature.decode(pSig.signature);
                        var _ref = sighashCache !== sig.hashType ? $94769f80e8eb4304$var$getHashForSig(inputIndex, Object.assign({}, input, {
                            sighashType: sig.hashType
                        }), this.__CACHE, true) : {
                            hash: hashCache,
                            script: scriptCache
                        }, hash = _ref.hash, script = _ref.script;
                        sighashCache = sig.hashType;
                        hashCache = hash;
                        scriptCache = script;
                        $94769f80e8eb4304$var$checkScriptForPubkey(pSig.pubkey, script, "verify");
                        results.push(validator(pSig.pubkey, hash, sig.signature));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return results.every(function(res) {
                    return res === true;
                });
            }
        },
        {
            key: "validateSignaturesOfTaprootInput",
            value: function validateSignaturesOfTaprootInput(inputIndex, validator, pubkey) {
                var input = this.data.inputs[inputIndex];
                var tapKeySig = (input || {}).tapKeySig;
                var tapScriptSig = (input || {}).tapScriptSig;
                if (!input && !tapKeySig && !(tapScriptSig && !tapScriptSig.length)) throw new Error("No signatures to validate");
                if (typeof validator !== "function") throw new Error("Need validator function to validate signatures");
                pubkey = pubkey && (0, $b5a175672e85eac3$exports.toXOnly)(pubkey);
                var allHashses = pubkey ? $94769f80e8eb4304$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, pubkey, this.__CACHE) : $94769f80e8eb4304$var$getAllTaprootHashesForSig(inputIndex, input, this.data.inputs, this.__CACHE);
                if (!allHashses.length) throw new Error("No signatures for this pubkey");
                var tapKeyHash = allHashses.find(function(h) {
                    return !h.leafHash;
                });
                var validationResultCount = 0;
                if (tapKeySig && tapKeyHash) {
                    var isValidTapkeySig = validator(tapKeyHash.pubkey, tapKeyHash.hash, $94769f80e8eb4304$var$trimTaprootSig(tapKeySig));
                    if (!isValidTapkeySig) return false;
                    validationResultCount++;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (tapScriptSig) try {
                    var _loop = function() {
                        var tapSig = _step.value;
                        var tapSigHash = allHashses.find(function(h) {
                            return tapSig.pubkey.equals(h.pubkey);
                        });
                        if (tapSigHash) {
                            var isValidTapScriptSig = validator(tapSig.pubkey, tapSigHash.hash, $94769f80e8eb4304$var$trimTaprootSig(tapSig.signature));
                            if (!isValidTapScriptSig) return {
                                v: false
                            };
                            validationResultCount++;
                        }
                    };
                    for(var _iterator = tapScriptSig[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = _loop();
                        if ((0, $aVMuR._)(_ret) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return validationResultCount > 0;
            }
        },
        {
            key: "signAllInputsHD",
            value: function signAllInputsHD(hdKeyPair) {
                var sighashTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL
                ];
                if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
                var results = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $94769f80e8eb4304$var$range(this.data.inputs.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        try {
                            this.signInputHD(i, hdKeyPair, sighashTypes);
                            results.push(true);
                        } catch (err) {
                            results.push(false);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (results.every(function(v) {
                    return v === false;
                })) throw new Error("No inputs were signed");
                return this;
            }
        },
        {
            key: "signAllInputsHDAsync",
            value: function signAllInputsHDAsync(hdKeyPair) {
                var sighashTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
                    var results = [];
                    var promises = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = $94769f80e8eb4304$var$range(_this.data.inputs.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            promises.push(_this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(function() {
                                results.push(true);
                            }, function() {
                                results.push(false);
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return Promise.all(promises).then(function() {
                        if (results.every(function(v) {
                            return v === false;
                        })) return reject(new Error("No inputs were signed"));
                        resolve();
                    });
                });
            }
        },
        {
            key: "signInputHD",
            value: function signInputHD(inputIndex, hdKeyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
                var signers = $94769f80e8eb4304$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
                signers.forEach(function(signer) {
                    return _this.signInput(inputIndex, signer, sighashTypes);
                });
                return this;
            }
        },
        {
            key: "signInputHDAsync",
            value: function signInputHDAsync(inputIndex, hdKeyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
                    var signers = $94769f80e8eb4304$var$getSignersFromHD(inputIndex, _this.data.inputs, hdKeyPair);
                    var promises = signers.map(function(signer) {
                        return _this.signInputAsync(inputIndex, signer, sighashTypes);
                    });
                    return Promise.all(promises).then(function() {
                        resolve();
                    }).catch(reject);
                });
            }
        },
        {
            key: "signAllInputs",
            value: function signAllInputs(keyPair, sighashTypes) {
                if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                // TODO: Add a pubkey/pubkeyhash cache to each input
                // as input information is added, then eventually
                // optimize this method.
                var results = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $94769f80e8eb4304$var$range(this.data.inputs.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        try {
                            this.signInput(i, keyPair, sighashTypes);
                            results.push(true);
                        } catch (err) {
                            results.push(false);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (results.every(function(v) {
                    return v === false;
                })) throw new Error("No inputs were signed");
                return this;
            }
        },
        {
            key: "signAllInputsAsync",
            value: function signAllInputsAsync(keyPair, sighashTypes) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!keyPair || !keyPair.publicKey) return reject(new Error("Need Signer to sign input"));
                    // TODO: Add a pubkey/pubkeyhash cache to each input
                    // as input information is added, then eventually
                    // optimize this method.
                    var results = [];
                    var promises = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.data.inputs.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $5OlIx._)(_step.value, 1), i = _step_value[0];
                            promises.push(_this.signInputAsync(i, keyPair, sighashTypes).then(function() {
                                results.push(true);
                            }, function() {
                                results.push(false);
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return Promise.all(promises).then(function() {
                        if (results.every(function(v) {
                            return v === false;
                        })) return reject(new Error("No inputs were signed"));
                        resolve();
                    });
                });
            }
        },
        {
            key: "signInput",
            value: function signInput(inputIndex, keyPair, sighashTypes) {
                if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, undefined, sighashTypes);
                return this._signInput(inputIndex, keyPair, sighashTypes);
            }
        },
        {
            key: "signTaprootInput",
            value: function signTaprootInput(inputIndex, keyPair, tapLeafHashToSign, sighashTypes) {
                if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                var input = (0, $2afa9fa2748275c6$exports.checkForInput)(this.data.inputs, inputIndex);
                if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, sighashTypes);
                throw new Error("Input #".concat(inputIndex, " is not of type Taproot."));
            }
        },
        {
            key: "_signInput",
            value: function _signInput(inputIndex, keyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL
                ];
                var _getHashAndSighashType = $94769f80e8eb4304$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes), hash = _getHashAndSighashType.hash, sighashType = _getHashAndSighashType.sighashType;
                var partialSig = [
                    {
                        pubkey: keyPair.publicKey,
                        signature: $cbd225966f86718e$exports.signature.encode(keyPair.sign(hash), sighashType)
                    }
                ];
                this.data.updateInput(inputIndex, {
                    partialSig: partialSig
                });
                return this;
            }
        },
        {
            key: "_signTaprootInput",
            value: function _signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign) {
                var allowedSighashTypes = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_DEFAULT
                ];
                var hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes);
                var tapKeySig = hashesForSig.filter(function(h) {
                    return !h.leafHash;
                }).map(function(h) {
                    return (0, $b5a175672e85eac3$exports.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType);
                })[0];
                var tapScriptSig = hashesForSig.filter(function(h) {
                    return !!h.leafHash;
                }).map(function(h) {
                    return {
                        pubkey: (0, $b5a175672e85eac3$exports.toXOnly)(keyPair.publicKey),
                        signature: (0, $b5a175672e85eac3$exports.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType),
                        leafHash: h.leafHash
                    };
                });
                if (tapKeySig) this.data.updateInput(inputIndex, {
                    tapKeySig: tapKeySig
                });
                if (tapScriptSig.length) this.data.updateInput(inputIndex, {
                    tapScriptSig: tapScriptSig
                });
                return this;
            }
        },
        {
            key: "signInputAsync",
            value: function signInputAsync(inputIndex, keyPair, sighashTypes) {
                var _this = this;
                return Promise.resolve().then(function() {
                    if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                    var input = (0, $2afa9fa2748275c6$exports.checkForInput)(_this.data.inputs, inputIndex);
                    if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return _this._signTaprootInputAsync(inputIndex, input, keyPair, undefined, sighashTypes);
                    return _this._signInputAsync(inputIndex, keyPair, sighashTypes);
                });
            }
        },
        {
            key: "signTaprootInputAsync",
            value: function signTaprootInputAsync(inputIndex, keyPair, tapLeafHash, sighashTypes) {
                var _this = this;
                return Promise.resolve().then(function() {
                    if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
                    var input = (0, $2afa9fa2748275c6$exports.checkForInput)(_this.data.inputs, inputIndex);
                    if ((0, $b5a175672e85eac3$exports.isTaprootInput)(input)) return _this._signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
                    throw new Error("Input #".concat(inputIndex, " is not of type Taproot."));
                });
            }
        },
        {
            key: "_signInputAsync",
            value: function _signInputAsync(inputIndex, keyPair) {
                var sighashTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL
                ];
                var _this = this;
                var _getHashAndSighashType = $94769f80e8eb4304$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes), hash = _getHashAndSighashType.hash, sighashType = _getHashAndSighashType.sighashType;
                return Promise.resolve(keyPair.sign(hash)).then(function(signature) {
                    var partialSig = [
                        {
                            pubkey: keyPair.publicKey,
                            signature: $cbd225966f86718e$exports.signature.encode(signature, sighashType)
                        }
                    ];
                    _this.data.updateInput(inputIndex, {
                        partialSig: partialSig
                    });
                });
            }
        },
        {
            key: "_signTaprootInputAsync",
            value: function _signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash) {
                var sighashTypes = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [
                    $0ae6e9085c711f8c$exports.Transaction.SIGHASH_DEFAULT
                ];
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var hashesForSig, signaturePromises, tapKeyHash, tapKeySigPromise, tapScriptHashes, _signaturePromises, tapScriptSigPromises;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        hashesForSig = _this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
                        signaturePromises = [];
                        tapKeyHash = hashesForSig.filter(function(h) {
                            return !h.leafHash;
                        })[0];
                        if (tapKeyHash) {
                            tapKeySigPromise = Promise.resolve(keyPair.signSchnorr(tapKeyHash.hash)).then(function(sig) {
                                return {
                                    tapKeySig: (0, $b5a175672e85eac3$exports.serializeTaprootSignature)(sig, input.sighashType)
                                };
                            });
                            signaturePromises.push(tapKeySigPromise);
                        }
                        tapScriptHashes = hashesForSig.filter(function(h) {
                            return !!h.leafHash;
                        });
                        if (tapScriptHashes.length) {
                            ;
                            tapScriptSigPromises = tapScriptHashes.map(function(tsh) {
                                return Promise.resolve(keyPair.signSchnorr(tsh.hash)).then(function(signature) {
                                    var tapScriptSig = [
                                        {
                                            pubkey: (0, $b5a175672e85eac3$exports.toXOnly)(keyPair.publicKey),
                                            signature: (0, $b5a175672e85eac3$exports.serializeTaprootSignature)(signature, input.sighashType),
                                            leafHash: tsh.leafHash
                                        }
                                    ];
                                    return {
                                        tapScriptSig: tapScriptSig
                                    };
                                });
                            });
                            (_signaturePromises = signaturePromises).push.apply(_signaturePromises, (0, $gF0bR._)(tapScriptSigPromises));
                        }
                        return [
                            2,
                            Promise.all(signaturePromises).then(function(results) {
                                results.forEach(function(v) {
                                    return _this.data.updateInput(inputIndex, v);
                                });
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "checkTaprootHashesForSig",
            value: function checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes) {
                if (typeof keyPair.signSchnorr !== "function") throw new Error("Need Schnorr Signer to sign taproot input #".concat(inputIndex, "."));
                var hashesForSig = $94769f80e8eb4304$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, keyPair.publicKey, this.__CACHE, tapLeafHashToSign, allowedSighashTypes);
                if (!hashesForSig || !hashesForSig.length) throw new Error("Can not sign for input #".concat(inputIndex, " with the key ").concat(keyPair.publicKey.toString("hex")));
                return hashesForSig;
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer() {
                $94769f80e8eb4304$var$checkCache(this.__CACHE);
                return this.data.toBuffer();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                $94769f80e8eb4304$var$checkCache(this.__CACHE);
                return this.data.toHex();
            }
        },
        {
            key: "toBase64",
            value: function toBase64() {
                $94769f80e8eb4304$var$checkCache(this.__CACHE);
                return this.data.toBase64();
            }
        },
        {
            key: "updateGlobal",
            value: function updateGlobal(updateData) {
                this.data.updateGlobal(updateData);
                return this;
            }
        },
        {
            key: "updateInput",
            value: function updateInput(inputIndex, updateData) {
                if (updateData.witnessScript) $94769f80e8eb4304$var$checkInvalidP2WSH(updateData.witnessScript);
                (0, $b5a175672e85eac3$exports.checkTaprootInputFields)(this.data.inputs[inputIndex], updateData, "updateInput");
                this.data.updateInput(inputIndex, updateData);
                if (updateData.nonWitnessUtxo) $94769f80e8eb4304$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
                return this;
            }
        },
        {
            key: "updateOutput",
            value: function updateOutput(outputIndex, updateData) {
                var outputData = this.data.outputs[outputIndex];
                (0, $b5a175672e85eac3$exports.checkTaprootOutputFields)(outputData, updateData, "updateOutput");
                this.data.updateOutput(outputIndex, updateData);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToGlobal",
            value: function addUnknownKeyValToGlobal(keyVal) {
                this.data.addUnknownKeyValToGlobal(keyVal);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToInput",
            value: function addUnknownKeyValToInput(inputIndex, keyVal) {
                this.data.addUnknownKeyValToInput(inputIndex, keyVal);
                return this;
            }
        },
        {
            key: "addUnknownKeyValToOutput",
            value: function addUnknownKeyValToOutput(outputIndex, keyVal) {
                this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
                return this;
            }
        },
        {
            key: "clearFinalizedInput",
            value: function clearFinalizedInput(inputIndex) {
                this.data.clearFinalizedInput(inputIndex);
                return this;
            }
        }
    ], [
        {
            key: "fromBase64",
            value: function fromBase64(data) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var buffer = $94769f80e8eb4304$require$Buffer.from(data, "base64");
                return this.fromBuffer(buffer, opts);
            }
        },
        {
            key: "fromHex",
            value: function fromHex(data) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var buffer = $94769f80e8eb4304$require$Buffer.from(data, "hex");
                return this.fromBuffer(buffer, opts);
            }
        },
        {
            key: "fromBuffer",
            value: function fromBuffer(buffer) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var psbtBase = $27f0a5038233d038$exports.Psbt.fromBuffer(buffer, $94769f80e8eb4304$var$transactionFromBuffer);
                var psbt = new Psbt(opts, psbtBase);
                $94769f80e8eb4304$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
                return psbt;
            }
        }
    ]);
    return Psbt;
}();
$94769f80e8eb4304$exports.Psbt = $94769f80e8eb4304$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ var $94769f80e8eb4304$var$transactionFromBuffer = function(buffer) {
    return new $94769f80e8eb4304$var$PsbtTransaction(buffer);
};
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ var $94769f80e8eb4304$var$PsbtTransaction = /*#__PURE__*/ function() {
    "use strict";
    function PsbtTransaction() {
        var buffer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $94769f80e8eb4304$require$Buffer.from([
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        (0, $7dKN1._)(this, PsbtTransaction);
        this.tx = $0ae6e9085c711f8c$exports.Transaction.fromBuffer(buffer);
        $94769f80e8eb4304$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, "tx", {
            enumerable: false,
            writable: true
        });
    }
    (0, $eW5pA._)(PsbtTransaction, [
        {
            key: "getInputOutputCounts",
            value: function getInputOutputCounts() {
                return {
                    inputCount: this.tx.ins.length,
                    outputCount: this.tx.outs.length
                };
            }
        },
        {
            key: "addInput",
            value: function addInput(input) {
                if (input.hash === undefined || input.index === undefined || !$94769f80e8eb4304$require$Buffer.isBuffer(input.hash) && typeof input.hash !== "string" || typeof input.index !== "number") throw new Error("Error adding input.");
                var hash = typeof input.hash === "string" ? (0, $d6dfd2397ab1936f$exports.reverseBuffer)($94769f80e8eb4304$require$Buffer.from(input.hash, "hex")) : input.hash;
                this.tx.addInput(hash, input.index, input.sequence);
            }
        },
        {
            key: "addOutput",
            value: function addOutput(output) {
                if (output.script === undefined || output.value === undefined || !$94769f80e8eb4304$require$Buffer.isBuffer(output.script) || typeof output.value !== "number") throw new Error("Error adding output.");
                this.tx.addOutput(output.script, output.value);
            }
        },
        {
            key: "toBuffer",
            value: function toBuffer() {
                return this.tx.toBuffer();
            }
        }
    ]);
    return PsbtTransaction;
}();
function $94769f80e8eb4304$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case "pubkey":
        case "pubkeyhash":
        case "witnesspubkeyhash":
            return $94769f80e8eb4304$var$hasSigs(1, input.partialSig);
        case "multisig":
            var p2ms = $9771a9b72cb50314$exports.p2ms({
                output: script
            });
            return $94769f80e8eb4304$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $94769f80e8eb4304$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error("Not BIP174 compliant, can not export");
}
function $94769f80e8eb4304$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    var sigs;
    if (pubkeys) sigs = pubkeys.map(function(pkey) {
        var pubkey = $94769f80e8eb4304$var$compressPubkey(pkey);
        return partialSig.find(function(pSig) {
            return pSig.pubkey.equals(pubkey);
        });
    }).filter(function(v) {
        return !!v;
    });
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error("Too many signatures");
    return sigs.length === neededSigs;
}
function $94769f80e8eb4304$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $94769f80e8eb4304$var$bip32DerivationIsMine(root) {
    return function(d) {
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $94769f80e8eb4304$var$check32Bit(num) {
    if (typeof num !== "number" || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error("Invalid 32 bit integer");
}
function $94769f80e8eb4304$var$checkFees(psbt, cache, opts) {
    var feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    var vsize = cache.__EXTRACTED_TX.virtualSize();
    var satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error("Warning: You are paying around ".concat((satoshis / 1e8).toFixed(8), " in ") + "fees, which is ".concat(feeRate, " satoshi per byte for a transaction ") + "with a VSize of ".concat(vsize, " bytes (segwit counted as 0.25 byte per ") + "byte). Use setMaximumFeeRate method to raise your threshold, or " + "pass true to the first arg of extractTransaction.");
}
function $94769f80e8eb4304$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach(function(input) {
        var throws = (0, $b5a175672e85eac3$exports.isTaprootInput)(input) ? (0, $b5a175672e85eac3$exports.checkTaprootInputForSigs)(input, action) : (0, $895ab8ec90f143e6$exports.checkInputForSig)(input, action);
        if (throws) throw new Error("Can not modify transaction, signatures exist.");
    });
}
function $94769f80e8eb4304$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    var partialSig = input.partialSig, sighashType = input.sighashType;
    partialSig.forEach(function(pSig) {
        var hashType = $cbd225966f86718e$exports.signature.decode(pSig.signature).hashType;
        if (sighashType !== hashType) throw new Error("Signature sighash does not match input sighash type");
    });
}
function $94769f80e8eb4304$var$checkScriptForPubkey(pubkey, script, action) {
    if (!(0, $895ab8ec90f143e6$exports.pubkeyInScript)(pubkey, script)) throw new Error("Can not ".concat(action, " for this input with the key ").concat(pubkey.toString("hex")));
}
function $94769f80e8eb4304$var$checkTxEmpty(tx) {
    var isEmpty = tx.ins.every(function(input) {
        return input.script && input.script.length === 0 && input.witness && input.witness.length === 0;
    });
    if (!isEmpty) throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function $94769f80e8eb4304$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach(function(input) {
        $94769f80e8eb4304$var$checkTxInputCache(cache, input);
    });
}
function $94769f80e8eb4304$var$checkTxInputCache(cache, input) {
    var key = (0, $d6dfd2397ab1936f$exports.reverseBuffer)($94769f80e8eb4304$require$Buffer.from(input.hash)).toString("hex") + ":" + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error("Duplicate input detected.");
    cache.__TX_IN_CACHE[key] = 1;
}
function $94769f80e8eb4304$var$scriptCheckerFactory(payment, paymentScriptName) {
    return function(inputIndex, scriptPubKey, redeemScript, ioType) {
        var redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error("".concat(paymentScriptName, " for ").concat(ioType, " #").concat(inputIndex, " doesn't match the scriptPubKey in the prevout"));
    };
}
var $94769f80e8eb4304$var$checkRedeemScript = $94769f80e8eb4304$var$scriptCheckerFactory($9771a9b72cb50314$exports.p2sh, "Redeem script");
var $94769f80e8eb4304$var$checkWitnessScript = $94769f80e8eb4304$var$scriptCheckerFactory($9771a9b72cb50314$exports.p2wsh, "Witness script");
function $94769f80e8eb4304$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($94769f80e8eb4304$var$isFinalized)) throw new Error("PSBT must be finalized to calculate ".concat(name));
    if (key === "__FEE_RATE" && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === "__FEE" && c.__FEE) return c.__FEE;
    var tx;
    var mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $94769f80e8eb4304$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === "__FEE_RATE") return c.__FEE_RATE;
    else if (key === "__FEE") return c.__FEE;
}
function $94769f80e8eb4304$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    var scriptType = $94769f80e8eb4304$var$classifyScript(script);
    if (!$94769f80e8eb4304$var$canFinalize(input, script, scriptType)) throw new Error("Can not finalize input #".concat(inputIndex));
    return $94769f80e8eb4304$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $94769f80e8eb4304$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    var finalScriptSig;
    var finalScriptWitness;
    // Wow, the payments API is very handy
    var payment = $94769f80e8eb4304$var$getPayment(script, scriptType, partialSig);
    var p2wsh = !isP2WSH ? null : $9771a9b72cb50314$exports.p2wsh({
        redeem: payment
    });
    var p2sh = !isP2SH ? null : $9771a9b72cb50314$exports.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = (0, $895ab8ec90f143e6$exports.witnessStackToScriptWitness)(p2wsh.witness);
        else finalScriptWitness = (0, $895ab8ec90f143e6$exports.witnessStackToScriptWitness)(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $94769f80e8eb4304$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    var input = (0, $2afa9fa2748275c6$exports.checkForInput)(inputs, inputIndex);
    var _getHashForSig = $94769f80e8eb4304$var$getHashForSig(inputIndex, input, cache, false, sighashTypes), hash = _getHashForSig.hash, sighashType = _getHashForSig.sighashType, script = _getHashForSig.script;
    $94769f80e8eb4304$var$checkScriptForPubkey(pubkey, script, "sign");
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $94769f80e8eb4304$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    var unsignedTx = cache.__TX;
    var sighashType = input.sighashType || $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL;
    $94769f80e8eb4304$var$checkSighashTypeAllowed(sighashType, sighashTypes);
    var hash;
    var prevout;
    if (input.nonWitnessUtxo) {
        var nonWitnessUtxoTx = $94769f80e8eb4304$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        var prevoutHash = unsignedTx.ins[inputIndex].hash;
        var utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error("Non-witness UTXO hash for input #".concat(inputIndex, " doesn't match the hash specified in the prevout"));
        var prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error("Need a Utxo input item for signing");
    var _getMeaningfulScript = $94769f80e8eb4304$var$getMeaningfulScript(prevout.script, inputIndex, "input", input.redeemScript, input.witnessScript), meaningfulScript = _getMeaningfulScript.meaningfulScript, type = _getMeaningfulScript.type;
    if ([
        "p2sh-p2wsh",
        "p2wsh"
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ((0, $895ab8ec90f143e6$exports.isP2WPKH)(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        var signingScript = $9771a9b72cb50314$exports.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error("Input #".concat(inputIndex, " has witnessUtxo but non-segwit script: ") + "".concat(meaningfulScript.toString("hex")));
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecessor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $94769f80e8eb4304$var$getAllTaprootHashesForSig(inputIndex, input, inputs, cache) {
    var allPublicKeys = [];
    if (input.tapInternalKey) {
        var key = $94769f80e8eb4304$var$getPrevoutTaprootKey(inputIndex, input, cache);
        if (key) allPublicKeys.push(key);
    }
    if (input.tapScriptSig) {
        var _allPublicKeys;
        var tapScriptPubkeys = input.tapScriptSig.map(function(tss) {
            return tss.pubkey;
        });
        (_allPublicKeys = allPublicKeys).push.apply(_allPublicKeys, (0, $gF0bR._)(tapScriptPubkeys));
    }
    var allHashes = allPublicKeys.map(function(pubicKey) {
        return $94769f80e8eb4304$var$getTaprootHashesForSig(inputIndex, input, inputs, pubicKey, cache);
    });
    return allHashes.flat();
}
function $94769f80e8eb4304$var$getPrevoutTaprootKey(inputIndex, input, cache) {
    var script = $94769f80e8eb4304$var$getScriptAndAmountFromUtxo(inputIndex, input, cache).script;
    return (0, $895ab8ec90f143e6$exports.isP2TR)(script) ? script.subarray(2, 34) : null;
}
function $94769f80e8eb4304$var$trimTaprootSig(signature) {
    return signature.length === 64 ? signature : signature.subarray(0, 64);
}
function $94769f80e8eb4304$var$getTaprootHashesForSig(inputIndex, input, inputs, pubkey, cache, tapLeafHashToSign, allowedSighashTypes) {
    var unsignedTx = cache.__TX;
    var sighashType = input.sighashType || $0ae6e9085c711f8c$exports.Transaction.SIGHASH_DEFAULT;
    $94769f80e8eb4304$var$checkSighashTypeAllowed(sighashType, allowedSighashTypes);
    var prevOuts = inputs.map(function(i, index) {
        return $94769f80e8eb4304$var$getScriptAndAmountFromUtxo(index, i, cache);
    });
    var signingScripts = prevOuts.map(function(o) {
        return o.script;
    });
    var values = prevOuts.map(function(o) {
        return o.value;
    });
    var hashes = [];
    if (input.tapInternalKey && !tapLeafHashToSign) {
        var outputKey = $94769f80e8eb4304$var$getPrevoutTaprootKey(inputIndex, input, cache) || $94769f80e8eb4304$require$Buffer.from([]);
        if ((0, $b5a175672e85eac3$exports.toXOnly)(pubkey).equals(outputKey)) {
            var tapKeyHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType);
            hashes.push({
                pubkey: pubkey,
                hash: tapKeyHash
            });
        }
    }
    var tapLeafHashes = (input.tapLeafScript || []).filter(function(tapLeaf) {
        return (0, $895ab8ec90f143e6$exports.pubkeyInScript)(pubkey, tapLeaf.script);
    }).map(function(tapLeaf) {
        var hash = (0, $c86b0fc6a57c595c$exports.tapleafHash)({
            output: tapLeaf.script,
            version: tapLeaf.leafVersion
        });
        return Object.assign({
            hash: hash
        }, tapLeaf);
    }).filter(function(tapLeaf) {
        return !tapLeafHashToSign || tapLeafHashToSign.equals(tapLeaf.hash);
    }).map(function(tapLeaf) {
        var tapScriptHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType, tapLeaf.hash);
        return {
            pubkey: pubkey,
            hash: tapScriptHash,
            leafHash: tapLeaf.hash
        };
    });
    return hashes.concat(tapLeafHashes);
}
function $94769f80e8eb4304$var$checkSighashTypeAllowed(sighashType, sighashTypes) {
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        var str = $94769f80e8eb4304$var$sighashTypeToString(sighashType);
        throw new Error("Sighash type is not allowed. Retry the sign method passing the " + "sighashTypes array of whitelisted types. Sighash type: ".concat(str));
    }
}
function $94769f80e8eb4304$var$getPayment(script, scriptType, partialSig) {
    var payment;
    switch(scriptType){
        case "multisig":
            var sigs = $94769f80e8eb4304$var$getSortedSigs(script, partialSig);
            payment = $9771a9b72cb50314$exports.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case "pubkey":
            payment = $9771a9b72cb50314$exports.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case "pubkeyhash":
            payment = $9771a9b72cb50314$exports.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case "witnesspubkeyhash":
            payment = $9771a9b72cb50314$exports.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $94769f80e8eb4304$var$getScriptFromInput(inputIndex, input, cache) {
    var unsignedTx = cache.__TX;
    var res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            var nonWitnessUtxoTx = $94769f80e8eb4304$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            var prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || (0, $895ab8ec90f143e6$exports.isP2WPKH)(res.script)) res.isSegwit = true;
    return res;
}
function $94769f80e8eb4304$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    var input = (0, $2afa9fa2748275c6$exports.checkForInput)(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error("Need bip32Derivation to sign with HD");
    var myDerivations = input.bip32Derivation.map(function(bipDv) {
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter(function(v) {
        return !!v;
    });
    if (myDerivations.length === 0) throw new Error("Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint");
    var signers = myDerivations.map(function(bipDv) {
        var node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error("pubkey did not match bip32Derivation");
        return node;
    });
    return signers;
}
function $94769f80e8eb4304$var$getSortedSigs(script, partialSig) {
    var p2ms = $9771a9b72cb50314$exports.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map(function(pk) {
        // filter partialSig array by pubkey being equal
        return (partialSig.filter(function(ps) {
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter(function(v) {
        return !!v;
    });
}
function $94769f80e8eb4304$var$scriptWitnessToWitnessStack(buffer) {
    var offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        var vi = $d1BPf.decode(buffer, offset);
        offset += $d1BPf.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        var count = readVarInt();
        var vector = [];
        for(var i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $94769f80e8eb4304$var$sighashTypeToString(sighashType) {
    var text = sighashType & $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    var sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $0ae6e9085c711f8c$exports.Transaction.SIGHASH_ALL:
            text += "SIGHASH_ALL";
            break;
        case $0ae6e9085c711f8c$exports.Transaction.SIGHASH_SINGLE:
            text += "SIGHASH_SINGLE";
            break;
        case $0ae6e9085c711f8c$exports.Transaction.SIGHASH_NONE:
            text += "SIGHASH_NONE";
            break;
    }
    return text;
}
function $94769f80e8eb4304$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    var tx = $0ae6e9085c711f8c$exports.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    var self = cache;
    var selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, "nonWitnessUtxo", {
        enumerable: true,
        get: function() {
            var buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            var txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                var newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set: function(data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $94769f80e8eb4304$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    var inputAmount = 0;
    inputs.forEach(function(input, idx) {
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $94769f80e8eb4304$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            var nwTx = $94769f80e8eb4304$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            var vout = tx.ins[idx].index;
            var out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    var outputAmount = tx.outs.reduce(function(total, o) {
        return total + o.value;
    }, 0);
    var fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error("Outputs are spending more than Inputs");
    var bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $94769f80e8eb4304$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    var c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $94769f80e8eb4304$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $94769f80e8eb4304$var$getScriptFromUtxo(inputIndex, input, cache) {
    var script = $94769f80e8eb4304$var$getScriptAndAmountFromUtxo(inputIndex, input, cache).script;
    return script;
}
function $94769f80e8eb4304$var$getScriptAndAmountFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return {
        script: input.witnessUtxo.script,
        value: input.witnessUtxo.value
    };
    else if (input.nonWitnessUtxo !== undefined) {
        var nonWitnessUtxoTx = $94769f80e8eb4304$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        var o = nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index];
        return {
            script: o.script,
            value: o.value
        };
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $94769f80e8eb4304$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    var script = $94769f80e8eb4304$var$getScriptFromUtxo(inputIndex, input, cache);
    var meaningfulScript = $94769f80e8eb4304$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript, input.witnessScript).meaningfulScript;
    return (0, $895ab8ec90f143e6$exports.pubkeyInScript)(pubkey, meaningfulScript);
}
function $94769f80e8eb4304$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    var script = cache.__TX.outs[outputIndex].script;
    var meaningfulScript = $94769f80e8eb4304$var$getMeaningfulScript(script, outputIndex, "output", output.redeemScript, output.witnessScript).meaningfulScript;
    return (0, $895ab8ec90f143e6$exports.pubkeyInScript)(pubkey, meaningfulScript);
}
function $94769f80e8eb4304$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    var decomp = $cbd225966f86718e$exports.decompile(finalScript);
    if (!decomp) return;
    var lastItem = decomp[decomp.length - 1];
    if (!$94769f80e8eb4304$require$Buffer.isBuffer(lastItem) || $94769f80e8eb4304$var$isPubkeyLike(lastItem) || $94769f80e8eb4304$var$isSigLike(lastItem)) return;
    var sDecomp = $cbd225966f86718e$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $94769f80e8eb4304$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    var decomp = $94769f80e8eb4304$var$scriptWitnessToWitnessStack(finalScript);
    var lastItem = decomp[decomp.length - 1];
    if ($94769f80e8eb4304$var$isPubkeyLike(lastItem)) return;
    var sDecomp = $cbd225966f86718e$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $94769f80e8eb4304$var$compressPubkey(pubkey) {
    if (pubkey.length === 65) {
        var parity = pubkey[64] & 1;
        var newKey = pubkey.slice(0, 33);
        newKey[0] = 2 | parity;
        return newKey;
    }
    return pubkey.slice();
}
function $94769f80e8eb4304$var$isPubkeyLike(buf) {
    return buf.length === 33 && $cbd225966f86718e$exports.isCanonicalPubKey(buf);
}
function $94769f80e8eb4304$var$isSigLike(buf) {
    return $cbd225966f86718e$exports.isCanonicalScriptSignature(buf);
}
function $94769f80e8eb4304$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    var isP2SH = (0, $895ab8ec90f143e6$exports.isP2SHScript)(script);
    var isP2SHP2WSH = isP2SH && redeemScript && (0, $895ab8ec90f143e6$exports.isP2WSHScript)(redeemScript);
    var isP2WSH = (0, $895ab8ec90f143e6$exports.isP2WSHScript)(script);
    if (isP2SH && redeemScript === undefined) throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error("scriptPubkey or redeemScript is P2WSH but witnessScript missing");
    var meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $94769f80e8eb4304$var$checkRedeemScript(index, script, redeemScript, ioType);
        $94769f80e8eb4304$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $94769f80e8eb4304$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $94769f80e8eb4304$var$checkWitnessScript(index, script, witnessScript, ioType);
        $94769f80e8eb4304$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $94769f80e8eb4304$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? "p2sh-p2wsh" : isP2SH ? "p2sh" : isP2WSH ? "p2wsh" : "raw"
    };
}
function $94769f80e8eb4304$var$checkInvalidP2WSH(script) {
    if ((0, $895ab8ec90f143e6$exports.isP2WPKH)(script) || (0, $895ab8ec90f143e6$exports.isP2SHScript)(script)) throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function $94769f80e8eb4304$var$classifyScript(script) {
    if ((0, $895ab8ec90f143e6$exports.isP2WPKH)(script)) return "witnesspubkeyhash";
    if ((0, $895ab8ec90f143e6$exports.isP2PKH)(script)) return "pubkeyhash";
    if ((0, $895ab8ec90f143e6$exports.isP2MS)(script)) return "multisig";
    if ((0, $895ab8ec90f143e6$exports.isP2PK)(script)) return "pubkey";
    return "nonstandard";
}
function $94769f80e8eb4304$var$range(n) {
    return (0, $gF0bR._)(Array(n).keys());
}


Object.defineProperty($881b6534ce6ec462$exports, "Psbt", {
    enumerable: true,
    get: function get() {
        return $94769f80e8eb4304$exports.Psbt;
    }
});

Object.defineProperty($881b6534ce6ec462$exports, "opcodes", {
    enumerable: true,
    get: function get() {
        return $822920c23b5c1ebc$exports.OPS;
    }
});

Object.defineProperty($881b6534ce6ec462$exports, "Transaction", {
    enumerable: true,
    get: function get() {
        return $0ae6e9085c711f8c$exports.Transaction;
    }
});

Object.defineProperty($881b6534ce6ec462$exports, "initEccLib", {
    enumerable: true,
    get: function get() {
        return $d1c3d48d4239db47$exports.initEccLib;
    }
});


var $23fa097f73defb11$exports = {};
"use strict";
var $23fa097f73defb11$var$__defProp = Object.defineProperty;
var $23fa097f73defb11$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $23fa097f73defb11$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $23fa097f73defb11$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $23fa097f73defb11$var$__export = function(target, all) {
    for(var name in all)$23fa097f73defb11$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $23fa097f73defb11$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$23fa097f73defb11$var$__hasOwnProp.call(to, key) && key !== except) $23fa097f73defb11$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $23fa097f73defb11$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $23fa097f73defb11$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $23fa097f73defb11$var$__toCommonJS = function(mod) {
    return $23fa097f73defb11$var$__copyProps($23fa097f73defb11$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $23fa097f73defb11$var$cryptography_exports = {};
$23fa097f73defb11$var$__export($23fa097f73defb11$var$cryptography_exports, {
    Keypair: function() {
        return $d51b88c4f7df6939$exports.Keypair;
    },
    LEGACY_PRIVATE_KEY_SIZE: function() {
        return $d51b88c4f7df6939$exports.LEGACY_PRIVATE_KEY_SIZE;
    },
    PRIVATE_KEY_SIZE: function() {
        return $d51b88c4f7df6939$exports.PRIVATE_KEY_SIZE;
    },
    PublicKey: function() {
        return $f18ddaf76dcce603$exports.PublicKey;
    },
    SIGNATURE_FLAG_TO_SCHEME: function() {
        return $eee0db41adbb8a07$exports.SIGNATURE_FLAG_TO_SCHEME;
    },
    SIGNATURE_SCHEME_TO_FLAG: function() {
        return $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG;
    },
    SIGNATURE_SCHEME_TO_SIZE: function() {
        return $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_SIZE;
    },
    SUI_PRIVATE_KEY_PREFIX: function() {
        return $d51b88c4f7df6939$exports.SUI_PRIVATE_KEY_PREFIX;
    },
    Signer: function() {
        return $d51b88c4f7df6939$exports.Signer;
    },
    decodeSuiPrivateKey: function() {
        return $d51b88c4f7df6939$exports.decodeSuiPrivateKey;
    },
    encodeSuiPrivateKey: function() {
        return $d51b88c4f7df6939$exports.encodeSuiPrivateKey;
    },
    isValidBIP32Path: function() {
        return $021e843c62eff7b5$exports.isValidBIP32Path;
    },
    isValidHardenedPath: function() {
        return $021e843c62eff7b5$exports.isValidHardenedPath;
    },
    messageWithIntent: function() {
        return $33b0080294277266$exports.messageWithIntent;
    },
    mnemonicToSeed: function() {
        return $021e843c62eff7b5$exports.mnemonicToSeed;
    },
    mnemonicToSeedHex: function() {
        return $021e843c62eff7b5$exports.mnemonicToSeedHex;
    },
    parseSerializedSignature: function() {
        return $bcd52e1566c5a424$exports.parseSerializedSignature;
    },
    toSerializedSignature: function() {
        return $bcd52e1566c5a424$exports.toSerializedSignature;
    }
});
$23fa097f73defb11$exports = $23fa097f73defb11$var$__toCommonJS($23fa097f73defb11$var$cryptography_exports);
var $bcd52e1566c5a424$exports = {};
"use strict";
var $bcd52e1566c5a424$var$__defProp = Object.defineProperty;
var $bcd52e1566c5a424$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $bcd52e1566c5a424$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $bcd52e1566c5a424$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bcd52e1566c5a424$var$__export = function(target, all) {
    for(var name in all)$bcd52e1566c5a424$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $bcd52e1566c5a424$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$bcd52e1566c5a424$var$__hasOwnProp.call(to, key) && key !== except) $bcd52e1566c5a424$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $bcd52e1566c5a424$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $bcd52e1566c5a424$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $bcd52e1566c5a424$var$__toCommonJS = function(mod) {
    return $bcd52e1566c5a424$var$__copyProps($bcd52e1566c5a424$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $bcd52e1566c5a424$var$signature_exports = {};
$bcd52e1566c5a424$var$__export($bcd52e1566c5a424$var$signature_exports, {
    parseSerializedSignature: function() {
        return $bcd52e1566c5a424$var$parseSerializedSignature;
    },
    toSerializedSignature: function() {
        return $bcd52e1566c5a424$var$toSerializedSignature;
    }
});
$bcd52e1566c5a424$exports = $bcd52e1566c5a424$var$__toCommonJS($bcd52e1566c5a424$var$signature_exports);

var $gF0bR = parcelRequire("gF0bR");
function $00e2ec7379a5c39a$export$4f2a95e90ef32c3c(base64String) {
    return Uint8Array.from(atob(base64String), function(char) {
        return char.charCodeAt(0);
    });
}
var $00e2ec7379a5c39a$var$CHUNK_SIZE = 8192;
function $00e2ec7379a5c39a$export$747bdef45a77895b(bytes) {
    var _String;
    if (bytes.length < $00e2ec7379a5c39a$var$CHUNK_SIZE) return btoa((_String = String).fromCharCode.apply(_String, (0, $gF0bR._)(bytes)));
    var output = "";
    for(var i = 0; i < bytes.length; i += $00e2ec7379a5c39a$var$CHUNK_SIZE){
        var _String1;
        var chunk = bytes.slice(i, i + $00e2ec7379a5c39a$var$CHUNK_SIZE);
        output += (_String1 = String).fromCharCode.apply(_String1, (0, $gF0bR._)(chunk));
    }
    return btoa(output);
}


var $f8d1f806bddc4e70$exports = {};

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");
"use strict";
var $f8d1f806bddc4e70$var$__defProp = Object.defineProperty;
var $f8d1f806bddc4e70$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $f8d1f806bddc4e70$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $f8d1f806bddc4e70$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f8d1f806bddc4e70$var$__export = function(target, all) {
    for(var name in all)$f8d1f806bddc4e70$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $f8d1f806bddc4e70$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$f8d1f806bddc4e70$var$__hasOwnProp.call(to, key) && key !== except) $f8d1f806bddc4e70$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $f8d1f806bddc4e70$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $f8d1f806bddc4e70$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $f8d1f806bddc4e70$var$__toCommonJS = function(mod) {
    return $f8d1f806bddc4e70$var$__copyProps($f8d1f806bddc4e70$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $f8d1f806bddc4e70$var$bcs_exports = {};
$f8d1f806bddc4e70$var$__export($f8d1f806bddc4e70$var$bcs_exports, {
    BcsType: function() {
        return $61409c8a303ddfe6$export$ae8046b497d99c33;
    },
    TypeTagSerializer: function() {
        return $ac4a7dfbea23f1ea$exports.TypeTagSerializer;
    },
    bcs: function() {
        return $f8d1f806bddc4e70$var$suiBcs;
    }
});
$f8d1f806bddc4e70$exports = $f8d1f806bddc4e70$var$__toCommonJS($f8d1f806bddc4e70$var$bcs_exports);

var $a7gqy = parcelRequire("a7gqy");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $bL8uU = parcelRequire("bL8uU");
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $e1909e5796964812$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $e1909e5796964812$export$2e2bcd8739ae039 = $e1909e5796964812$var$base;


var $dddacd2193ccebbe$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $dddacd2193ccebbe$export$2e2bcd8739ae039 = (0, $e1909e5796964812$export$2e2bcd8739ae039)($dddacd2193ccebbe$var$ALPHABET);


var $0b14fdeb97356916$export$4b59780ad59f5559 = function(buffer) {
    return (0, $dddacd2193ccebbe$export$2e2bcd8739ae039).encode(buffer);
};
var $0b14fdeb97356916$export$c58c1bf044f5dd4e = function(str) {
    return (0, $dddacd2193ccebbe$export$2e2bcd8739ae039).decode(str);
};



function $96a5e6519bfce0e5$export$74f3b7b01e99604c(hexStr) {
    var _padded_match;
    var normalized = hexStr.startsWith("0x") ? hexStr.slice(2) : hexStr;
    var padded = normalized.length % 2 === 0 ? normalized : "0".concat(normalized, "}");
    var _padded_match_map;
    var intArr = (_padded_match_map = (_padded_match = padded.match(/.{2}/g)) === null || _padded_match === void 0 ? void 0 : _padded_match.map(function(byte) {
        return parseInt(byte, 16);
    })) !== null && _padded_match_map !== void 0 ? _padded_match_map : [];
    return Uint8Array.from(intArr);
}
function $96a5e6519bfce0e5$export$276eb56e46302cb0(bytes) {
    return bytes.reduce(function(str, byte) {
        return str + byte.toString(16).padStart(2, "0");
    }, "");
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
function $2e8f542bb708e7fb$export$fd9e5206f9ba4320(num) {
    var arr = [];
    var len = 0;
    if (num === 0) return [
        0
    ];
    while(num > 0){
        arr[len] = num & 127;
        if (num >>= 7) arr[len] |= 128;
        len += 1;
    }
    return arr;
}
function $2e8f542bb708e7fb$export$31314c3893823285(arr) {
    var total = 0;
    var shift = 0;
    var len = 0;
    while(true){
        var byte = arr[len];
        len += 1;
        total |= (byte & 127) << shift;
        if ((byte & 128) === 0) break;
        shift += 7;
    }
    return {
        value: total,
        length: len
    };
}


var $fca13d2b4228d477$export$d86c88b5b59af4e1 = /*#__PURE__*/ function() {
    "use strict";
    function BcsReader(data) {
        (0, $7dKN1._)(this, BcsReader);
        this.bytePosition = 0;
        this.dataView = new DataView(data.buffer);
    }
    (0, $eW5pA._)(BcsReader, [
        {
            /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */ key: "shift",
            value: function shift(bytes) {
                this.bytePosition += bytes;
                return this;
            }
        },
        {
            /**
   * Read U8 value from the buffer and shift cursor by 1.
   * @returns
   */ key: "read8",
            value: function read8() {
                var value = this.dataView.getUint8(this.bytePosition);
                this.shift(1);
                return value;
            }
        },
        {
            /**
   * Read U16 value from the buffer and shift cursor by 2.
   * @returns
   */ key: "read16",
            value: function read16() {
                var value = this.dataView.getUint16(this.bytePosition, true);
                this.shift(2);
                return value;
            }
        },
        {
            /**
   * Read U32 value from the buffer and shift cursor by 4.
   * @returns
   */ key: "read32",
            value: function read32() {
                var value = this.dataView.getUint32(this.bytePosition, true);
                this.shift(4);
                return value;
            }
        },
        {
            /**
   * Read U64 value from the buffer and shift cursor by 8.
   * @returns
   */ key: "read64",
            value: function read64() {
                var value1 = this.read32();
                var value2 = this.read32();
                var result = value2.toString(16) + value1.toString(16).padStart(8, "0");
                return BigInt("0x" + result).toString(10);
            }
        },
        {
            /**
   * Read U128 value from the buffer and shift cursor by 16.
   */ key: "read128",
            value: function read128() {
                var value1 = BigInt(this.read64());
                var value2 = BigInt(this.read64());
                var result = value2.toString(16) + value1.toString(16).padStart(16, "0");
                return BigInt("0x" + result).toString(10);
            }
        },
        {
            /**
   * Read U128 value from the buffer and shift cursor by 32.
   * @returns
   */ key: "read256",
            value: function read256() {
                var value1 = BigInt(this.read128());
                var value2 = BigInt(this.read128());
                var result = value2.toString(16) + value1.toString(16).padStart(32, "0");
                return BigInt("0x" + result).toString(10);
            }
        },
        {
            /**
   * Read `num` number of bytes from the buffer and shift cursor by `num`.
   * @param num Number of bytes to read.
   */ key: "readBytes",
            value: function readBytes(num) {
                var start = this.bytePosition + this.dataView.byteOffset;
                var value = new Uint8Array(this.dataView.buffer, start, num);
                this.shift(num);
                return value;
            }
        },
        {
            /**
   * Read ULEB value - an integer of varying size. Used for enum indexes and
   * vector lengths.
   * @returns {Number} The ULEB value.
   */ key: "readULEB",
            value: function readULEB() {
                var start = this.bytePosition + this.dataView.byteOffset;
                var buffer = new Uint8Array(this.dataView.buffer, start);
                var _ulebDecode = (0, $2e8f542bb708e7fb$export$31314c3893823285)(buffer), value = _ulebDecode.value, length = _ulebDecode.length;
                this.shift(length);
                return value;
            }
        },
        {
            /**
   * Read a BCS vector: read a length and then apply function `cb` X times
   * where X is the length of the vector, defined as ULEB in BCS bytes.
   * @param cb Callback to process elements of vector.
   * @returns {Array<Any>} Array of the resulting values, returned by callback.
   */ key: "readVec",
            value: function readVec(cb) {
                var length = this.readULEB();
                var result = [];
                for(var i = 0; i < length; i++)result.push(cb(this, i, length));
                return result;
            }
        }
    ]);
    return BcsReader;
}();




var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");


var $5OlIx = parcelRequire("5OlIx");



function $b71982c61b21f02f$export$b2dc80a12af7a507(data, encoding) {
    switch(encoding){
        case "base58":
            return (0, $0b14fdeb97356916$export$4b59780ad59f5559)(data);
        case "base64":
            return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(data);
        case "hex":
            return (0, $96a5e6519bfce0e5$export$276eb56e46302cb0)(data);
        default:
            throw new Error("Unsupported encoding, supported values are: base64, hex");
    }
}
function $b71982c61b21f02f$export$e8c3ccd706ecaf1f(data, encoding) {
    switch(encoding){
        case "base58":
            return (0, $0b14fdeb97356916$export$c58c1bf044f5dd4e)(data);
        case "base64":
            return (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(data);
        case "hex":
            return (0, $96a5e6519bfce0e5$export$74f3b7b01e99604c)(data);
        default:
            throw new Error("Unsupported encoding, supported values are: base64, hex");
    }
}
function $b71982c61b21f02f$export$b8dbde61e4252147(str) {
    var genericSeparators = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        "<",
        ">"
    ];
    var _genericSeparators = (0, $5OlIx._)(genericSeparators, 2), left = _genericSeparators[0], right = _genericSeparators[1];
    var tok = [];
    var word = "";
    var nestedAngleBrackets = 0;
    for(var i = 0; i < str.length; i++){
        var char = str[i];
        if (char === left) nestedAngleBrackets++;
        if (char === right) nestedAngleBrackets--;
        if (nestedAngleBrackets === 0 && char === ",") {
            tok.push(word.trim());
            word = "";
            continue;
        }
        word += char;
    }
    tok.push(word.trim());
    return tok;
}


var $4948bb3e64805a94$export$2c0eef36f60e69e = /*#__PURE__*/ function() {
    "use strict";
    function BcsWriter() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_initialSize = _ref.initialSize, initialSize = _ref_initialSize === void 0 ? 1024 : _ref_initialSize, _ref_maxSize = _ref.maxSize, maxSize = _ref_maxSize === void 0 ? Infinity : _ref_maxSize, _ref_allocateSize = _ref.allocateSize, allocateSize = _ref_allocateSize === void 0 ? 1024 : _ref_allocateSize;
        (0, $7dKN1._)(this, BcsWriter);
        this.bytePosition = 0;
        this.size = initialSize;
        this.maxSize = maxSize;
        this.allocateSize = allocateSize;
        this.dataView = new DataView(new ArrayBuffer(initialSize));
    }
    (0, $eW5pA._)(BcsWriter, [
        {
            key: "ensureSizeOrGrow",
            value: function ensureSizeOrGrow(bytes) {
                var requiredSize = this.bytePosition + bytes;
                if (requiredSize > this.size) {
                    var nextSize = Math.min(this.maxSize, this.size + this.allocateSize);
                    if (requiredSize > nextSize) throw new Error("Attempting to serialize to BCS, but buffer does not have enough size. Allocated size: ".concat(this.size, ", Max size: ").concat(this.maxSize, ", Required size: ").concat(requiredSize));
                    this.size = nextSize;
                    var nextBuffer = new ArrayBuffer(this.size);
                    new Uint8Array(nextBuffer).set(new Uint8Array(this.dataView.buffer));
                    this.dataView = new DataView(nextBuffer);
                }
            }
        },
        {
            /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */ key: "shift",
            value: function shift(bytes) {
                this.bytePosition += bytes;
                return this;
            }
        },
        {
            /**
   * Write a U8 value into a buffer and shift cursor position by 1.
   * @param {Number} value Value to write.
   * @returns {this}
   */ key: "write8",
            value: function write8(value) {
                this.ensureSizeOrGrow(1);
                this.dataView.setUint8(this.bytePosition, Number(value));
                return this.shift(1);
            }
        },
        {
            /**
   * Write a U16 value into a buffer and shift cursor position by 2.
   * @param {Number} value Value to write.
   * @returns {this}
   */ key: "write16",
            value: function write16(value) {
                this.ensureSizeOrGrow(2);
                this.dataView.setUint16(this.bytePosition, Number(value), true);
                return this.shift(2);
            }
        },
        {
            /**
   * Write a U32 value into a buffer and shift cursor position by 4.
   * @param {Number} value Value to write.
   * @returns {this}
   */ key: "write32",
            value: function write32(value) {
                this.ensureSizeOrGrow(4);
                this.dataView.setUint32(this.bytePosition, Number(value), true);
                return this.shift(4);
            }
        },
        {
            /**
   * Write a U64 value into a buffer and shift cursor position by 8.
   * @param {bigint} value Value to write.
   * @returns {this}
   */ key: "write64",
            value: function write64(value) {
                var _this = this;
                $4948bb3e64805a94$var$toLittleEndian(BigInt(value), 8).forEach(function(el) {
                    return _this.write8(el);
                });
                return this;
            }
        },
        {
            /**
   * Write a U128 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */ key: "write128",
            value: function write128(value) {
                var _this = this;
                $4948bb3e64805a94$var$toLittleEndian(BigInt(value), 16).forEach(function(el) {
                    return _this.write8(el);
                });
                return this;
            }
        },
        {
            /**
   * Write a U256 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */ key: "write256",
            value: function write256(value) {
                var _this = this;
                $4948bb3e64805a94$var$toLittleEndian(BigInt(value), 32).forEach(function(el) {
                    return _this.write8(el);
                });
                return this;
            }
        },
        {
            /**
   * Write a ULEB value into a buffer and shift cursor position by number of bytes
   * written.
   * @param {Number} value Value to write.
   * @returns {this}
   */ key: "writeULEB",
            value: function writeULEB(value) {
                var _this = this;
                (0, $2e8f542bb708e7fb$export$fd9e5206f9ba4320)(value).forEach(function(el) {
                    return _this.write8(el);
                });
                return this;
            }
        },
        {
            /**
   * Write a vector into a buffer by first writing the vector length and then calling
   * a callback on each passed value.
   *
   * @param {Array<Any>} vector Array of elements to write.
   * @param {WriteVecCb} cb Callback to call on each element of the vector.
   * @returns {this}
   */ key: "writeVec",
            value: function writeVec(vector, cb) {
                var _this = this;
                this.writeULEB(vector.length);
                Array.from(vector).forEach(function(el, i) {
                    return cb(_this, el, i, vector.length);
                });
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: /**
   * Adds support for iterations over the object.
   * @returns {Uint8Array}
   */ function value() {
                var i;
                return (0, $6qu4b.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(i < this.bytePosition)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.dataView.getUint8(i)
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            i++;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2,
                                this.toBytes()
                            ];
                    }
                });
            }
        },
        {
            /**
   * Get underlying buffer taking only value bytes (in case initial buffer size was bigger).
   * @returns {Uint8Array} Resulting bcs.
   */ key: "toBytes",
            value: function toBytes() {
                return new Uint8Array(this.dataView.buffer.slice(0, this.bytePosition));
            }
        },
        {
            /**
   * Represent data as 'hex' or 'base64'
   * @param encoding Encoding to use: 'base64' or 'hex'
   */ key: "toString",
            value: function toString(encoding) {
                return (0, $b71982c61b21f02f$export$b2dc80a12af7a507)(this.toBytes(), encoding);
            }
        }
    ]);
    return BcsWriter;
}();
function $4948bb3e64805a94$var$toLittleEndian(bigint, size) {
    var result = new Uint8Array(size);
    var i = 0;
    while(bigint > 0){
        result[i] = Number(bigint % BigInt(256));
        bigint = bigint / BigInt(256);
        i += 1;
    }
    return result;
}


var $61409c8a303ddfe6$var$__typeError = function(msg) {
    throw TypeError(msg);
};
var $61409c8a303ddfe6$var$__accessCheck = function(obj, member, msg) {
    return member.has(obj) || $61409c8a303ddfe6$var$__typeError("Cannot " + msg);
};
var $61409c8a303ddfe6$var$__privateGet = function(obj, member, getter) {
    return $61409c8a303ddfe6$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var $61409c8a303ddfe6$var$__privateAdd = function(obj, member, value) {
    return member.has(obj) ? $61409c8a303ddfe6$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $61409c8a303ddfe6$var$__privateSet = function(obj, member, value, setter) {
    return $61409c8a303ddfe6$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value;
};
var $61409c8a303ddfe6$var$_write, $61409c8a303ddfe6$var$_serialize, $61409c8a303ddfe6$var$_schema, $61409c8a303ddfe6$var$_bytes;
var $61409c8a303ddfe6$var$_BcsType = /*#__PURE__*/ function() {
    "use strict";
    function _BcsType(options) {
        var _this = this;
        (0, $7dKN1._)(this, _BcsType);
        $61409c8a303ddfe6$var$__privateAdd(this, $61409c8a303ddfe6$var$_write);
        $61409c8a303ddfe6$var$__privateAdd(this, $61409c8a303ddfe6$var$_serialize);
        this.name = options.name;
        this.read = options.read;
        var _options_serializedSize;
        this.serializedSize = (_options_serializedSize = options.serializedSize) !== null && _options_serializedSize !== void 0 ? _options_serializedSize : function() {
            return null;
        };
        $61409c8a303ddfe6$var$__privateSet(this, $61409c8a303ddfe6$var$_write, options.write);
        var _options_serialize;
        $61409c8a303ddfe6$var$__privateSet(this, $61409c8a303ddfe6$var$_serialize, (_options_serialize = options.serialize) !== null && _options_serialize !== void 0 ? _options_serialize : function(value, options2) {
            var _this_serializedSize;
            var writer = new (0, $4948bb3e64805a94$export$2c0eef36f60e69e)((0, $4JCw4._)({
                initialSize: (_this_serializedSize = _this.serializedSize(value)) !== null && _this_serializedSize !== void 0 ? _this_serializedSize : void 0
            }, options2));
            $61409c8a303ddfe6$var$__privateGet(_this, $61409c8a303ddfe6$var$_write).call(_this, value, writer);
            return writer.toBytes();
        });
        var _options_validate;
        this.validate = (_options_validate = options.validate) !== null && _options_validate !== void 0 ? _options_validate : function() {};
    }
    (0, $eW5pA._)(_BcsType, [
        {
            key: "write",
            value: function write(value, writer) {
                this.validate(value);
                $61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_write).call(this, value, writer);
            }
        },
        {
            key: "serialize",
            value: function serialize(value, options) {
                this.validate(value);
                return new $61409c8a303ddfe6$export$10e065514cfb642d(this, $61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_serialize).call(this, value, options));
            }
        },
        {
            key: "parse",
            value: function parse(bytes) {
                var reader = new (0, $fca13d2b4228d477$export$d86c88b5b59af4e1)(bytes);
                return this.read(reader);
            }
        },
        {
            key: "fromHex",
            value: function fromHex(hex) {
                return this.parse((0, $96a5e6519bfce0e5$export$74f3b7b01e99604c)(hex));
            }
        },
        {
            key: "fromBase58",
            value: function fromBase58(b64) {
                return this.parse((0, $0b14fdeb97356916$export$c58c1bf044f5dd4e)(b64));
            }
        },
        {
            key: "fromBase64",
            value: function fromBase64(b64) {
                return this.parse((0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(b64));
            }
        },
        {
            key: "transform",
            value: function transform(param) {
                var name = param.name, input = param.input, output = param.output, validate = param.validate;
                var _this = this;
                return new _BcsType({
                    name: name !== null && name !== void 0 ? name : this.name,
                    read: function(reader) {
                        return output(_this.read(reader));
                    },
                    write: function(value, writer) {
                        return $61409c8a303ddfe6$var$__privateGet(_this, $61409c8a303ddfe6$var$_write).call(_this, input(value), writer);
                    },
                    serializedSize: function(value) {
                        return _this.serializedSize(input(value));
                    },
                    serialize: function(value, options) {
                        return $61409c8a303ddfe6$var$__privateGet(_this, $61409c8a303ddfe6$var$_serialize).call(_this, input(value), options);
                    },
                    validate: function(value) {
                        validate === null || validate === void 0 ? void 0 : validate(value);
                        _this.validate(input(value));
                    }
                });
            }
        }
    ]);
    return _BcsType;
}();
$61409c8a303ddfe6$var$_write = new WeakMap();
$61409c8a303ddfe6$var$_serialize = new WeakMap();
var $61409c8a303ddfe6$export$ae8046b497d99c33 = $61409c8a303ddfe6$var$_BcsType;
var $61409c8a303ddfe6$var$SERIALIZED_BCS_BRAND = Symbol.for("@mysten/serialized-bcs");
function $61409c8a303ddfe6$export$2557e7ec29b79bb5(obj) {
    return !!obj && typeof obj === "object" && obj[$61409c8a303ddfe6$var$SERIALIZED_BCS_BRAND] === true;
}
var $61409c8a303ddfe6$export$10e065514cfb642d = /*#__PURE__*/ function() {
    "use strict";
    function SerializedBcs(type, schema) {
        (0, $7dKN1._)(this, SerializedBcs);
        $61409c8a303ddfe6$var$__privateAdd(this, $61409c8a303ddfe6$var$_schema);
        $61409c8a303ddfe6$var$__privateAdd(this, $61409c8a303ddfe6$var$_bytes);
        $61409c8a303ddfe6$var$__privateSet(this, $61409c8a303ddfe6$var$_schema, type);
        $61409c8a303ddfe6$var$__privateSet(this, $61409c8a303ddfe6$var$_bytes, schema);
    }
    (0, $eW5pA._)(SerializedBcs, [
        {
            key: $61409c8a303ddfe6$var$SERIALIZED_BCS_BRAND,
            get: // Used to brand SerializedBcs so that they can be identified, even between multiple copies
            // of the @mysten/bcs package are installed
            function get() {
                return true;
            }
        },
        {
            key: "toBytes",
            value: function toBytes() {
                return $61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_bytes);
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return (0, $96a5e6519bfce0e5$export$276eb56e46302cb0)($61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_bytes));
            }
        },
        {
            key: "toBase64",
            value: function toBase64() {
                return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)($61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_bytes));
            }
        },
        {
            key: "toBase58",
            value: function toBase58() {
                return (0, $0b14fdeb97356916$export$4b59780ad59f5559)($61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_bytes));
            }
        },
        {
            key: "parse",
            value: function parse() {
                return $61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_schema).parse($61409c8a303ddfe6$var$__privateGet(this, $61409c8a303ddfe6$var$_bytes));
            }
        }
    ]);
    return SerializedBcs;
}();
$61409c8a303ddfe6$var$_schema = new WeakMap();
$61409c8a303ddfe6$var$_bytes = new WeakMap();
function $61409c8a303ddfe6$export$5c7358d69472e6e8(_param) {
    var size = _param.size, options = (0, $bL8uU._)(_param, [
        "size"
    ]);
    return new $61409c8a303ddfe6$export$ae8046b497d99c33((0, $gddcW._)((0, $4JCw4._)({}, options), {
        serializedSize: function() {
            return size;
        }
    }));
}
function $61409c8a303ddfe6$export$db55278270baacf0(_param) {
    var readMethod = _param.readMethod, writeMethod = _param.writeMethod, options = (0, $bL8uU._)(_param, [
        "readMethod",
        "writeMethod"
    ]);
    return $61409c8a303ddfe6$export$5c7358d69472e6e8((0, $gddcW._)((0, $4JCw4._)({}, options), {
        read: function(reader) {
            return reader[readMethod]();
        },
        write: function(value, writer) {
            return writer[writeMethod](value);
        },
        validate: function(value) {
            var _options_validate;
            if (value < 0 || value > options.maxValue) throw new TypeError("Invalid ".concat(options.name, " value: ").concat(value, ". Expected value in range 0-").concat(options.maxValue));
            (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
        }
    }));
}
function $61409c8a303ddfe6$export$d3e2d431e9eec0b6(_param) {
    var readMethod = _param.readMethod, writeMethod = _param.writeMethod, options = (0, $bL8uU._)(_param, [
        "readMethod",
        "writeMethod"
    ]);
    return $61409c8a303ddfe6$export$5c7358d69472e6e8((0, $gddcW._)((0, $4JCw4._)({}, options), {
        read: function(reader) {
            return reader[readMethod]();
        },
        write: function(value, writer) {
            return writer[writeMethod](BigInt(value));
        },
        validate: function(val) {
            var _options_validate;
            var value = BigInt(val);
            if (value < 0 || value > options.maxValue) throw new TypeError("Invalid ".concat(options.name, " value: ").concat(value, ". Expected value in range 0-").concat(options.maxValue));
            (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
        }
    }));
}
function $61409c8a303ddfe6$export$d3bc1d104fb36039(_param) {
    var serialize = _param.serialize, options = (0, $bL8uU._)(_param, [
        "serialize"
    ]);
    var type = new $61409c8a303ddfe6$export$ae8046b497d99c33((0, $gddcW._)((0, $4JCw4._)({}, options), {
        serialize: serialize,
        write: function(value, writer) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = type.serialize(value).toBytes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var byte = _step.value;
                    writer.write8(byte);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }));
    return type;
}
function $61409c8a303ddfe6$export$566befbac1c17756(_param) {
    var toBytes = _param.toBytes, fromBytes = _param.fromBytes, options = (0, $bL8uU._)(_param, [
        "toBytes",
        "fromBytes"
    ]);
    return new $61409c8a303ddfe6$export$ae8046b497d99c33((0, $gddcW._)((0, $4JCw4._)({}, options), {
        read: function(reader) {
            var length = reader.readULEB();
            var bytes = reader.readBytes(length);
            return fromBytes(bytes);
        },
        write: function(hex, writer) {
            var bytes = toBytes(hex);
            writer.writeULEB(bytes.length);
            for(var i = 0; i < bytes.length; i++)writer.write8(bytes[i]);
        },
        serialize: function(value) {
            var bytes = toBytes(value);
            var size = (0, $2e8f542bb708e7fb$export$fd9e5206f9ba4320)(bytes.length);
            var result = new Uint8Array(size.length + bytes.length);
            result.set(size, 0);
            result.set(bytes, size.length);
            return result;
        },
        validate: function(value) {
            var _options_validate;
            if (typeof value !== "string") throw new TypeError("Invalid ".concat(options.name, " value: ").concat(value, ". Expected string"));
            (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
        }
    }));
}
function $61409c8a303ddfe6$export$e1265262e9076fae(cb) {
    var lazyType = null;
    function getType() {
        if (!lazyType) lazyType = cb();
        return lazyType;
    }
    return new $61409c8a303ddfe6$export$ae8046b497d99c33({
        name: "lazy",
        read: function(data) {
            return getType().read(data);
        },
        serializedSize: function(value) {
            return getType().serializedSize(value);
        },
        write: function(value, writer) {
            return getType().write(value, writer);
        },
        serialize: function(value, options) {
            return getType().serialize(value, options).toBytes();
        }
    });
}



var $634b23529fb8a913$export$9faca4e3b5a9912b = {
    /**
   * Creates a BcsType that can be used to read and write an 8-bit unsigned integer.
   * @example
   * bcs.u8().serialize(255).toBytes() // Uint8Array [ 255 ]
   */ u8: function(options) {
        return (0, $61409c8a303ddfe6$export$db55278270baacf0)((0, $4JCw4._)({
            name: "u8",
            readMethod: "read8",
            writeMethod: "write8",
            size: 1,
            maxValue: 255
        }, options));
    },
    /**
   * Creates a BcsType that can be used to read and write a 16-bit unsigned integer.
   * @example
   * bcs.u16().serialize(65535).toBytes() // Uint8Array [ 255, 255 ]
   */ u16: function(options) {
        return (0, $61409c8a303ddfe6$export$db55278270baacf0)((0, $4JCw4._)({
            name: "u16",
            readMethod: "read16",
            writeMethod: "write16",
            size: 2,
            maxValue: Math.pow(2, 16) - 1
        }, options));
    },
    /**
   * Creates a BcsType that can be used to read and write a 32-bit unsigned integer.
   * @example
   * bcs.u32().serialize(4294967295).toBytes() // Uint8Array [ 255, 255, 255, 255 ]
   */ u32: function(options) {
        return (0, $61409c8a303ddfe6$export$db55278270baacf0)((0, $4JCw4._)({
            name: "u32",
            readMethod: "read32",
            writeMethod: "write32",
            size: 4,
            maxValue: Math.pow(2, 32) - 1
        }, options));
    },
    /**
   * Creates a BcsType that can be used to read and write a 64-bit unsigned integer.
   * @example
   * bcs.u64().serialize(1).toBytes() // Uint8Array [ 1, 0, 0, 0, 0, 0, 0, 0 ]
   */ u64: function(options) {
        return (0, $61409c8a303ddfe6$export$d3e2d431e9eec0b6)((0, $4JCw4._)({
            name: "u64",
            readMethod: "read64",
            writeMethod: "write64",
            size: 8,
            maxValue: Math.pow(2n, 64n) - 1n
        }, options));
    },
    /**
   * Creates a BcsType that can be used to read and write a 128-bit unsigned integer.
   * @example
   * bcs.u128().serialize(1).toBytes() // Uint8Array [ 1, ..., 0 ]
   */ u128: function(options) {
        return (0, $61409c8a303ddfe6$export$d3e2d431e9eec0b6)((0, $4JCw4._)({
            name: "u128",
            readMethod: "read128",
            writeMethod: "write128",
            size: 16,
            maxValue: Math.pow(2n, 128n) - 1n
        }, options));
    },
    /**
   * Creates a BcsType that can be used to read and write a 256-bit unsigned integer.
   * @example
   * bcs.u256().serialize(1).toBytes() // Uint8Array [ 1, ..., 0 ]
   */ u256: function(options) {
        return (0, $61409c8a303ddfe6$export$d3e2d431e9eec0b6)((0, $4JCw4._)({
            name: "u256",
            readMethod: "read256",
            writeMethod: "write256",
            size: 32,
            maxValue: Math.pow(2n, 256n) - 1n
        }, options));
    },
    /**
   * Creates a BcsType that can be used to read and write boolean values.
   * @example
   * bcs.bool().serialize(true).toBytes() // Uint8Array [ 1 ]
   */ bool: function(options) {
        return (0, $61409c8a303ddfe6$export$5c7358d69472e6e8)((0, $gddcW._)((0, $4JCw4._)({
            name: "bool",
            size: 1,
            read: function(reader) {
                return reader.read8() === 1;
            },
            write: function(value, writer) {
                return writer.write8(value ? 1 : 0);
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (typeof value !== "boolean") throw new TypeError("Expected boolean, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
            }
        }));
    },
    /**
   * Creates a BcsType that can be used to read and write unsigned LEB encoded integers
   * @example
   *
   */ uleb128: function(options) {
        return (0, $61409c8a303ddfe6$export$d3bc1d104fb36039)((0, $4JCw4._)({
            name: "uleb128",
            read: function(reader) {
                return reader.readULEB();
            },
            serialize: function(value) {
                return Uint8Array.from((0, $2e8f542bb708e7fb$export$fd9e5206f9ba4320)(value));
            }
        }, options));
    },
    /**
   * Creates a BcsType representing a fixed length byte array
   * @param size The number of bytes this types represents
   * @example
   * bcs.bytes(3).serialize(new Uint8Array([1, 2, 3])).toBytes() // Uint8Array [1, 2, 3]
   */ bytes: function(size, options) {
        return (0, $61409c8a303ddfe6$export$5c7358d69472e6e8)((0, $gddcW._)((0, $4JCw4._)({
            name: "bytes[".concat(size, "]"),
            size: size,
            read: function(reader) {
                return reader.readBytes(size);
            },
            write: function(value, writer) {
                var _value_i;
                for(var i = 0; i < size; i++)writer.write8((_value_i = value[i]) !== null && _value_i !== void 0 ? _value_i : 0);
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (!value || typeof value !== "object" || !("length" in value)) throw new TypeError("Expected array, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
                if (value.length !== size) throw new TypeError("Expected array of length ".concat(size, ", found ").concat(value.length));
            }
        }));
    },
    /**
   * Creates a BcsType that can ser/de string values.  Strings will be UTF-8 encoded
   * @example
   * bcs.string().serialize('a').toBytes() // Uint8Array [ 1, 97 ]
   */ string: function(options) {
        return (0, $61409c8a303ddfe6$export$566befbac1c17756)((0, $4JCw4._)({
            name: "string",
            toBytes: function(value) {
                return new TextEncoder().encode(value);
            },
            fromBytes: function(bytes) {
                return new TextDecoder().decode(bytes);
            }
        }, options));
    },
    /**
   * Creates a BcsType that represents a fixed length array of a given type
   * @param size The number of elements in the array
   * @param type The BcsType of each element in the array
   * @example
   * bcs.fixedArray(3, bcs.u8()).serialize([1, 2, 3]).toBytes() // Uint8Array [ 1, 2, 3 ]
   */ fixedArray: function(size, type, options) {
        return new (0, $61409c8a303ddfe6$export$ae8046b497d99c33)((0, $gddcW._)((0, $4JCw4._)({
            name: "".concat(type.name, "[").concat(size, "]"),
            read: function(reader) {
                var result = new Array(size);
                for(var i = 0; i < size; i++)result[i] = type.read(reader);
                return result;
            },
            write: function(value, writer) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        type.write(item, writer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (!value || typeof value !== "object" || !("length" in value)) throw new TypeError("Expected array, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
                if (value.length !== size) throw new TypeError("Expected array of length ".concat(size, ", found ").concat(value.length));
            }
        }));
    },
    /**
   * Creates a BcsType representing an optional value
   * @param type The BcsType of the optional value
   * @example
   * bcs.option(bcs.u8()).serialize(null).toBytes() // Uint8Array [ 0 ]
   * bcs.option(bcs.u8()).serialize(1).toBytes() // Uint8Array [ 1, 1 ]
   */ option: function(type) {
        return $634b23529fb8a913$export$9faca4e3b5a9912b.enum("Option<".concat(type.name, ">"), {
            None: null,
            Some: type
        }).transform({
            input: function(value) {
                if (value == null) return {
                    None: true
                };
                return {
                    Some: value
                };
            },
            output: function(value) {
                if (value.$kind === "Some") return value.Some;
                return null;
            }
        });
    },
    /**
   * Creates a BcsType representing a variable length vector of a given type
   * @param type The BcsType of each element in the vector
   *
   * @example
   * bcs.vector(bcs.u8()).toBytes([1, 2, 3]) // Uint8Array [ 3, 1, 2, 3 ]
   */ vector: function(type, options) {
        return new (0, $61409c8a303ddfe6$export$ae8046b497d99c33)((0, $gddcW._)((0, $4JCw4._)({
            name: "vector<".concat(type.name, ">"),
            read: function(reader) {
                var length = reader.readULEB();
                var result = new Array(length);
                for(var i = 0; i < length; i++)result[i] = type.read(reader);
                return result;
            },
            write: function(value, writer) {
                writer.writeULEB(value.length);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        type.write(item, writer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (!value || typeof value !== "object" || !("length" in value)) throw new TypeError("Expected array, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
            }
        }));
    },
    /**
   * Creates a BcsType representing a tuple of a given set of types
   * @param types The BcsTypes for each element in the tuple
   *
   * @example
   * const tuple = bcs.tuple([bcs.u8(), bcs.string(), bcs.bool()])
   * tuple.serialize([1, 'a', true]).toBytes() // Uint8Array [ 1, 1, 97, 1 ]
   */ tuple: function(types, options) {
        return new (0, $61409c8a303ddfe6$export$ae8046b497d99c33)((0, $gddcW._)((0, $4JCw4._)({
            name: "(".concat(types.map(function(t) {
                return t.name;
            }).join(", "), ")"),
            serializedSize: function(values) {
                var total = 0;
                for(var i = 0; i < types.length; i++){
                    var size = types[i].serializedSize(values[i]);
                    if (size == null) return null;
                    total += size;
                }
                return total;
            },
            read: function(reader) {
                var result = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        result.push(type.read(reader));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            },
            write: function(value, writer) {
                for(var i = 0; i < types.length; i++)types[i].write(value[i], writer);
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (!Array.isArray(value)) throw new TypeError("Expected array, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
                if (value.length !== types.length) throw new TypeError("Expected array of length ".concat(types.length, ", found ").concat(value.length));
            }
        }));
    },
    /**
   * Creates a BcsType representing a struct of a given set of fields
   * @param name The name of the struct
   * @param fields The fields of the struct. The order of the fields affects how data is serialized and deserialized
   *
   * @example
   * const struct = bcs.struct('MyStruct', {
   *  a: bcs.u8(),
   *  b: bcs.string(),
   * })
   * struct.serialize({ a: 1, b: 'a' }).toBytes() // Uint8Array [ 1, 1, 97 ]
   */ struct: function(name, fields, options) {
        var canonicalOrder = Object.entries(fields);
        return new (0, $61409c8a303ddfe6$export$ae8046b497d99c33)((0, $gddcW._)((0, $4JCw4._)({
            name: name,
            serializedSize: function(values) {
                var total = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = canonicalOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), field = _step_value[0], type = _step_value[1];
                        var size = type.serializedSize(values[field]);
                        if (size == null) return null;
                        total += size;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return total;
            },
            read: function(reader) {
                var result = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = canonicalOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), field = _step_value[0], type = _step_value[1];
                        result[field] = type.read(reader);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            },
            write: function(value, writer) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = canonicalOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), field = _step_value[0], type = _step_value[1];
                        type.write(value[field], writer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (typeof value !== "object" || value == null) throw new TypeError("Expected object, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
            }
        }));
    },
    /**
   * Creates a BcsType representing an enum of a given set of options
   * @param name The name of the enum
   * @param values The values of the enum. The order of the values affects how data is serialized and deserialized.
   * null can be used to represent a variant with no data.
   *
   * @example
   * const enum = bcs.enum('MyEnum', {
   *   A: bcs.u8(),
   *   B: bcs.string(),
   *   C: null,
   * })
   * enum.serialize({ A: 1 }).toBytes() // Uint8Array [ 0, 1 ]
   * enum.serialize({ B: 'a' }).toBytes() // Uint8Array [ 1, 1, 97 ]
   * enum.serialize({ C: true }).toBytes() // Uint8Array [ 2 ]
   */ enum: function(name, values, options) {
        var canonicalOrder = Object.entries(values);
        return new (0, $61409c8a303ddfe6$export$ae8046b497d99c33)((0, $gddcW._)((0, $4JCw4._)({
            name: name,
            read: function(reader) {
                var index = reader.readULEB();
                var _canonicalOrder_index = (0, $5OlIx._)(canonicalOrder[index], 2), name2 = _canonicalOrder_index[0], type = _canonicalOrder_index[1];
                var _type_read;
                var _obj;
                return _obj = {}, (0, $a7gqy._)(_obj, name2, (_type_read = type === null || type === void 0 ? void 0 : type.read(reader)) !== null && _type_read !== void 0 ? _type_read : true), (0, $a7gqy._)(_obj, "$kind", name2), _obj;
            },
            write: function(value, writer) {
                var _Object_entries_filter_ = (0, $5OlIx._)(Object.entries(value).filter(function(param) {
                    var _param = (0, $5OlIx._)(param, 1), name3 = _param[0];
                    return Object.hasOwn(values, name3);
                })[0], 2), name2 = _Object_entries_filter_[0], val = _Object_entries_filter_[1];
                for(var i = 0; i < canonicalOrder.length; i++){
                    var _canonicalOrder_i = (0, $5OlIx._)(canonicalOrder[i], 2), optionName = _canonicalOrder_i[0], optionType = _canonicalOrder_i[1];
                    if (optionName === name2) {
                        writer.writeULEB(i);
                        optionType === null || optionType === void 0 ? void 0 : optionType.write(val, writer);
                        return;
                    }
                }
            }
        }, options), {
            validate: function(value) {
                var _options_validate;
                options === null || options === void 0 ? void 0 : (_options_validate = options.validate) === null || _options_validate === void 0 ? void 0 : _options_validate.call(options, value);
                if (typeof value !== "object" || value == null) throw new TypeError("Expected object, found ".concat(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
                var keys = Object.keys(value).filter(function(k) {
                    return value[k] !== void 0 && Object.hasOwn(values, k);
                });
                if (keys.length !== 1) throw new TypeError("Expected object with one key, but found ".concat(keys.length, " for type ").concat(name, "}"));
                var _keys = (0, $5OlIx._)(keys, 1), variant = _keys[0];
                if (!Object.hasOwn(values, variant)) throw new TypeError("Invalid enum variant ".concat(variant));
            }
        }));
    },
    /**
   * Creates a BcsType representing a map of a given key and value type
   * @param keyType The BcsType of the key
   * @param valueType The BcsType of the value
   * @example
   * const map = bcs.map(bcs.u8(), bcs.string())
   * map.serialize(new Map([[2, 'a']])).toBytes() // Uint8Array [ 1, 2, 1, 97 ]
   */ map: function(keyType, valueType) {
        return $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
            keyType,
            valueType
        ])).transform({
            name: "Map<".concat(keyType.name, ", ").concat(valueType.name, ">"),
            input: function(value) {
                return (0, $gF0bR._)(value.entries());
            },
            output: function(value) {
                var result = /* @__PURE__ */ new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
                        result.set(key, val);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        });
    },
    /**
   * Creates a BcsType that wraps another BcsType which is lazily evaluated. This is useful for creating recursive types.
   * @param cb A callback that returns the BcsType
   */ lazy: function(cb) {
        return (0, $61409c8a303ddfe6$export$e1265262e9076fae)(cb);
    }
};


var $5963f3e88b017f5a$exports = {};

var $4JCw4 = parcelRequire("4JCw4");
"use strict";
var $5963f3e88b017f5a$var$__defProp = Object.defineProperty;
var $5963f3e88b017f5a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5963f3e88b017f5a$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5963f3e88b017f5a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5963f3e88b017f5a$var$__export = function(target, all) {
    for(var name in all)$5963f3e88b017f5a$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $5963f3e88b017f5a$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$5963f3e88b017f5a$var$__hasOwnProp.call(to, key) && key !== except) $5963f3e88b017f5a$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $5963f3e88b017f5a$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $5963f3e88b017f5a$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $5963f3e88b017f5a$var$__toCommonJS = function(mod) {
    return $5963f3e88b017f5a$var$__copyProps($5963f3e88b017f5a$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $5963f3e88b017f5a$var$bcs_exports = {};
$5963f3e88b017f5a$var$__export($5963f3e88b017f5a$var$bcs_exports, {
    Address: function() {
        return $5963f3e88b017f5a$var$Address;
    },
    AppId: function() {
        return $5963f3e88b017f5a$var$AppId;
    },
    Argument: function() {
        return $5963f3e88b017f5a$var$Argument;
    },
    CallArg: function() {
        return $5963f3e88b017f5a$var$CallArg;
    },
    Command: function() {
        return $5963f3e88b017f5a$var$Command;
    },
    CompressedSignature: function() {
        return $5963f3e88b017f5a$var$CompressedSignature;
    },
    GasData: function() {
        return $5963f3e88b017f5a$var$GasData;
    },
    Intent: function() {
        return $5963f3e88b017f5a$var$Intent;
    },
    IntentMessage: function() {
        return $5963f3e88b017f5a$var$IntentMessage;
    },
    IntentScope: function() {
        return $5963f3e88b017f5a$var$IntentScope;
    },
    IntentVersion: function() {
        return $5963f3e88b017f5a$var$IntentVersion;
    },
    MultiSig: function() {
        return $5963f3e88b017f5a$var$MultiSig;
    },
    MultiSigPkMap: function() {
        return $5963f3e88b017f5a$var$MultiSigPkMap;
    },
    MultiSigPublicKey: function() {
        return $5963f3e88b017f5a$var$MultiSigPublicKey;
    },
    ObjectArg: function() {
        return $5963f3e88b017f5a$var$ObjectArg;
    },
    ObjectDigest: function() {
        return $5963f3e88b017f5a$var$ObjectDigest;
    },
    ProgrammableMoveCall: function() {
        return $5963f3e88b017f5a$var$ProgrammableMoveCall;
    },
    ProgrammableTransaction: function() {
        return $5963f3e88b017f5a$var$ProgrammableTransaction;
    },
    PublicKey: function() {
        return $5963f3e88b017f5a$var$PublicKey;
    },
    SenderSignedData: function() {
        return $5963f3e88b017f5a$var$SenderSignedData;
    },
    SenderSignedTransaction: function() {
        return $5963f3e88b017f5a$var$SenderSignedTransaction;
    },
    SharedObjectRef: function() {
        return $5963f3e88b017f5a$var$SharedObjectRef;
    },
    StructTag: function() {
        return $5963f3e88b017f5a$var$StructTag;
    },
    SuiObjectRef: function() {
        return $5963f3e88b017f5a$var$SuiObjectRef;
    },
    TransactionData: function() {
        return $5963f3e88b017f5a$var$TransactionData;
    },
    TransactionDataV1: function() {
        return $5963f3e88b017f5a$var$TransactionDataV1;
    },
    TransactionExpiration: function() {
        return $5963f3e88b017f5a$var$TransactionExpiration;
    },
    TransactionKind: function() {
        return $5963f3e88b017f5a$var$TransactionKind;
    },
    TypeTag: function() {
        return $5963f3e88b017f5a$var$TypeTag;
    },
    base64String: function() {
        return $5963f3e88b017f5a$var$base64String;
    }
});
$5963f3e88b017f5a$exports = $5963f3e88b017f5a$var$__toCommonJS($5963f3e88b017f5a$var$bcs_exports);

var $2c4ee7908f345874$exports = {};

var $5OlIx = parcelRequire("5OlIx");
"use strict";
var $2c4ee7908f345874$var$__defProp = Object.defineProperty;
var $2c4ee7908f345874$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $2c4ee7908f345874$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $2c4ee7908f345874$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2c4ee7908f345874$var$__export = function(target, all) {
    for(var name in all)$2c4ee7908f345874$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $2c4ee7908f345874$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$2c4ee7908f345874$var$__hasOwnProp.call(to, key) && key !== except) $2c4ee7908f345874$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $2c4ee7908f345874$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $2c4ee7908f345874$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $2c4ee7908f345874$var$__toCommonJS = function(mod) {
    return $2c4ee7908f345874$var$__copyProps($2c4ee7908f345874$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $2c4ee7908f345874$var$sui_types_exports = {};
$2c4ee7908f345874$var$__export($2c4ee7908f345874$var$sui_types_exports, {
    SUI_ADDRESS_LENGTH: function() {
        return $2c4ee7908f345874$var$SUI_ADDRESS_LENGTH;
    },
    isValidSuiAddress: function() {
        return $2c4ee7908f345874$var$isValidSuiAddress;
    },
    isValidSuiObjectId: function() {
        return $2c4ee7908f345874$var$isValidSuiObjectId;
    },
    isValidTransactionDigest: function() {
        return $2c4ee7908f345874$var$isValidTransactionDigest;
    },
    normalizeStructTag: function() {
        return $2c4ee7908f345874$var$normalizeStructTag;
    },
    normalizeSuiAddress: function() {
        return $2c4ee7908f345874$var$normalizeSuiAddress;
    },
    normalizeSuiObjectId: function() {
        return $2c4ee7908f345874$var$normalizeSuiObjectId;
    },
    parseStructTag: function() {
        return $2c4ee7908f345874$var$parseStructTag;
    }
});
$2c4ee7908f345874$exports = $2c4ee7908f345874$var$__toCommonJS($2c4ee7908f345874$var$sui_types_exports);

var $2c4ee7908f345874$var$TX_DIGEST_LENGTH = 32;
function $2c4ee7908f345874$var$isValidTransactionDigest(value) {
    try {
        var buffer = (0, $0b14fdeb97356916$export$c58c1bf044f5dd4e)(value);
        return buffer.length === $2c4ee7908f345874$var$TX_DIGEST_LENGTH;
    } catch (e) {
        return false;
    }
}
var $2c4ee7908f345874$var$SUI_ADDRESS_LENGTH = 32;
function $2c4ee7908f345874$var$isValidSuiAddress(value) {
    return $2c4ee7908f345874$var$isHex(value) && $2c4ee7908f345874$var$getHexByteLength(value) === $2c4ee7908f345874$var$SUI_ADDRESS_LENGTH;
}
function $2c4ee7908f345874$var$isValidSuiObjectId(value) {
    return $2c4ee7908f345874$var$isValidSuiAddress(value);
}
function $2c4ee7908f345874$var$parseTypeTag(type) {
    if (!type.includes("::")) return type;
    return $2c4ee7908f345874$var$parseStructTag(type);
}
function $2c4ee7908f345874$var$parseStructTag(type) {
    var _type_split = (0, $5OlIx._)(type.split("::"), 2), address = _type_split[0], module2 = _type_split[1];
    var rest = type.slice(address.length + module2.length + 4);
    var name = rest.includes("<") ? rest.slice(0, rest.indexOf("<")) : rest;
    var typeParams = rest.includes("<") ? (0, $b71982c61b21f02f$export$b8dbde61e4252147)(rest.slice(rest.indexOf("<") + 1, rest.lastIndexOf(">"))).map(function(typeParam) {
        return $2c4ee7908f345874$var$parseTypeTag(typeParam.trim());
    }) : [];
    return {
        address: $2c4ee7908f345874$var$normalizeSuiAddress(address),
        module: module2,
        name: name,
        typeParams: typeParams
    };
}
function $2c4ee7908f345874$var$normalizeStructTag(type) {
    var _ref = typeof type === "string" ? $2c4ee7908f345874$var$parseStructTag(type) : type, address = _ref.address, module2 = _ref.module, name = _ref.name, typeParams = _ref.typeParams;
    var formattedTypeParams = (typeParams === null || typeParams === void 0 ? void 0 : typeParams.length) > 0 ? "<".concat(typeParams.map(function(typeParam) {
        return typeof typeParam === "string" ? typeParam : $2c4ee7908f345874$var$normalizeStructTag(typeParam);
    }).join(","), ">") : "";
    return "".concat(address, "::").concat(module2, "::").concat(name).concat(formattedTypeParams);
}
function $2c4ee7908f345874$var$normalizeSuiAddress(value) {
    var forceAdd0x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var address = value.toLowerCase();
    if (!forceAdd0x && address.startsWith("0x")) address = address.slice(2);
    return "0x".concat(address.padStart($2c4ee7908f345874$var$SUI_ADDRESS_LENGTH * 2, "0"));
}
function $2c4ee7908f345874$var$normalizeSuiObjectId(value) {
    var forceAdd0x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $2c4ee7908f345874$var$normalizeSuiAddress(value, forceAdd0x);
}
function $2c4ee7908f345874$var$isHex(value) {
    return /^(0x|0X)?[a-fA-F0-9]+$/.test(value) && value.length % 2 === 0;
}
function $2c4ee7908f345874$var$getHexByteLength(value) {
    return /^(0x|0X)/.test(value) ? (value.length - 2) / 2 : value.length / 2;
}


var $ac4a7dfbea23f1ea$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $ac4a7dfbea23f1ea$var$__defProp = Object.defineProperty;
var $ac4a7dfbea23f1ea$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ac4a7dfbea23f1ea$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $ac4a7dfbea23f1ea$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ac4a7dfbea23f1ea$var$__export = function(target, all) {
    for(var name in all)$ac4a7dfbea23f1ea$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $ac4a7dfbea23f1ea$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$ac4a7dfbea23f1ea$var$__hasOwnProp.call(to, key) && key !== except) $ac4a7dfbea23f1ea$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $ac4a7dfbea23f1ea$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $ac4a7dfbea23f1ea$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $ac4a7dfbea23f1ea$var$__toCommonJS = function(mod) {
    return $ac4a7dfbea23f1ea$var$__copyProps($ac4a7dfbea23f1ea$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $ac4a7dfbea23f1ea$var$type_tag_serializer_exports = {};
$ac4a7dfbea23f1ea$var$__export($ac4a7dfbea23f1ea$var$type_tag_serializer_exports, {
    TypeTagSerializer: function() {
        return $ac4a7dfbea23f1ea$var$TypeTagSerializer;
    }
});
$ac4a7dfbea23f1ea$exports = $ac4a7dfbea23f1ea$var$__toCommonJS($ac4a7dfbea23f1ea$var$type_tag_serializer_exports);


var $ac4a7dfbea23f1ea$var$VECTOR_REGEX = /^vector<(.+)>$/;
var $ac4a7dfbea23f1ea$var$STRUCT_REGEX = /^([^:]+)::([^:]+)::([^<]+)(<(.+)>)?/;
var $ac4a7dfbea23f1ea$var$TypeTagSerializer = /*#__PURE__*/ function() {
    function TypeTagSerializer() {
        (0, $7dKN1._)(this, TypeTagSerializer);
    }
    (0, $eW5pA._)(TypeTagSerializer, null, [
        {
            key: "parseFromStr",
            value: function parseFromStr(str) {
                var normalizeAddress = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (str === "address") return {
                    address: null
                };
                else if (str === "bool") return {
                    bool: null
                };
                else if (str === "u8") return {
                    u8: null
                };
                else if (str === "u16") return {
                    u16: null
                };
                else if (str === "u32") return {
                    u32: null
                };
                else if (str === "u64") return {
                    u64: null
                };
                else if (str === "u128") return {
                    u128: null
                };
                else if (str === "u256") return {
                    u256: null
                };
                else if (str === "signer") return {
                    signer: null
                };
                var vectorMatch = str.match($ac4a7dfbea23f1ea$var$VECTOR_REGEX);
                if (vectorMatch) return {
                    vector: TypeTagSerializer.parseFromStr(vectorMatch[1], normalizeAddress)
                };
                var structMatch = str.match($ac4a7dfbea23f1ea$var$STRUCT_REGEX);
                if (structMatch) {
                    var address = normalizeAddress ? (0, $2c4ee7908f345874$exports.normalizeSuiAddress)(structMatch[1]) : structMatch[1];
                    return {
                        struct: {
                            address: address,
                            module: structMatch[2],
                            name: structMatch[3],
                            typeParams: structMatch[5] === void 0 ? [] : TypeTagSerializer.parseStructTypeArgs(structMatch[5], normalizeAddress)
                        }
                    };
                }
                throw new Error("Encountered unexpected token when parsing type args for ".concat(str));
            }
        },
        {
            key: "parseStructTypeArgs",
            value: function parseStructTypeArgs(str) {
                var normalizeAddress = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return (0, $b71982c61b21f02f$export$b8dbde61e4252147)(str).map(function(tok) {
                    return TypeTagSerializer.parseFromStr(tok, normalizeAddress);
                });
            }
        },
        {
            key: "tagToString",
            value: function tagToString(tag) {
                if ("bool" in tag) return "bool";
                if ("u8" in tag) return "u8";
                if ("u16" in tag) return "u16";
                if ("u32" in tag) return "u32";
                if ("u64" in tag) return "u64";
                if ("u128" in tag) return "u128";
                if ("u256" in tag) return "u256";
                if ("address" in tag) return "address";
                if ("signer" in tag) return "signer";
                if ("vector" in tag) return "vector<".concat(TypeTagSerializer.tagToString(tag.vector), ">");
                if ("struct" in tag) {
                    var struct = tag.struct;
                    var typeParams = struct.typeParams.map(TypeTagSerializer.tagToString).join(", ");
                    return "".concat(struct.address, "::").concat(struct.module, "::").concat(struct.name).concat(typeParams ? "<".concat(typeParams, ">") : "");
                }
                throw new Error("Invalid TypeTag");
            }
        }
    ]);
    return TypeTagSerializer;
}();


function $5963f3e88b017f5a$var$unsafe_u64(options) {
    return $634b23529fb8a913$export$9faca4e3b5a9912b.u64((0, $4JCw4._)({
        name: "unsafe_u64"
    }, options)).transform({
        input: function(val) {
            return val;
        },
        output: function(val) {
            return Number(val);
        }
    });
}
function $5963f3e88b017f5a$var$optionEnum(type) {
    return $634b23529fb8a913$export$9faca4e3b5a9912b.enum("Option", {
        None: null,
        Some: type
    });
}
var $5963f3e88b017f5a$var$Address = $634b23529fb8a913$export$9faca4e3b5a9912b.bytes($2c4ee7908f345874$exports.SUI_ADDRESS_LENGTH).transform({
    validate: function(val) {
        var address = typeof val === "string" ? val : (0, $96a5e6519bfce0e5$export$276eb56e46302cb0)(val);
        if (!address || !(0, $2c4ee7908f345874$exports.isValidSuiAddress)((0, $2c4ee7908f345874$exports.normalizeSuiAddress)(address))) throw new Error("Invalid Sui address ".concat(address));
    },
    input: function(val) {
        return typeof val === "string" ? (0, $96a5e6519bfce0e5$export$74f3b7b01e99604c)((0, $2c4ee7908f345874$exports.normalizeSuiAddress)(val)) : val;
    },
    output: function(val) {
        return (0, $2c4ee7908f345874$exports.normalizeSuiAddress)((0, $96a5e6519bfce0e5$export$276eb56e46302cb0)(val));
    }
});
var $5963f3e88b017f5a$var$ObjectDigest = $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8()).transform({
    name: "ObjectDigest",
    input: function(value) {
        return (0, $0b14fdeb97356916$export$c58c1bf044f5dd4e)(value);
    },
    output: function(value) {
        return (0, $0b14fdeb97356916$export$4b59780ad59f5559)(new Uint8Array(value));
    },
    validate: function(value) {
        if ((0, $0b14fdeb97356916$export$c58c1bf044f5dd4e)(value).length !== 32) throw new Error("ObjectDigest must be 32 bytes");
    }
});
var $5963f3e88b017f5a$var$SuiObjectRef = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("SuiObjectRef", {
    objectId: $5963f3e88b017f5a$var$Address,
    version: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    digest: $5963f3e88b017f5a$var$ObjectDigest
});
var $5963f3e88b017f5a$var$SharedObjectRef = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("SharedObjectRef", {
    objectId: $5963f3e88b017f5a$var$Address,
    initialSharedVersion: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    mutable: $634b23529fb8a913$export$9faca4e3b5a9912b.bool()
});
var $5963f3e88b017f5a$var$ObjectArg = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("ObjectArg", {
    ImmOrOwnedObject: $5963f3e88b017f5a$var$SuiObjectRef,
    SharedObject: $5963f3e88b017f5a$var$SharedObjectRef,
    Receiving: $5963f3e88b017f5a$var$SuiObjectRef
});
var $5963f3e88b017f5a$var$CallArg = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("CallArg", {
    Pure: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("Pure", {
        bytes: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8()).transform({
            input: function(val) {
                return typeof val === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(val) : val;
            },
            output: function(val) {
                return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(new Uint8Array(val));
            }
        })
    }),
    Object: $5963f3e88b017f5a$var$ObjectArg
});
var $5963f3e88b017f5a$var$InnerTypeTag = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("TypeTag", {
    bool: null,
    u8: null,
    u64: null,
    u128: null,
    address: null,
    signer: null,
    vector: $634b23529fb8a913$export$9faca4e3b5a9912b.lazy(function() {
        return $5963f3e88b017f5a$var$InnerTypeTag;
    }),
    struct: $634b23529fb8a913$export$9faca4e3b5a9912b.lazy(function() {
        return $5963f3e88b017f5a$var$StructTag;
    }),
    u16: null,
    u32: null,
    u256: null
});
var $5963f3e88b017f5a$var$TypeTag = $5963f3e88b017f5a$var$InnerTypeTag.transform({
    input: function(typeTag) {
        return typeof typeTag === "string" ? $ac4a7dfbea23f1ea$exports.TypeTagSerializer.parseFromStr(typeTag, true) : typeTag;
    },
    output: function(typeTag) {
        return $ac4a7dfbea23f1ea$exports.TypeTagSerializer.tagToString(typeTag);
    }
});
var $5963f3e88b017f5a$var$Argument = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("Argument", {
    GasCoin: null,
    Input: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
    Result: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
    NestedResult: $634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
        $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
    ])
});
var $5963f3e88b017f5a$var$ProgrammableMoveCall = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ProgrammableMoveCall", {
    package: $5963f3e88b017f5a$var$Address,
    module: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
    function: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
    typeArguments: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$TypeTag),
    arguments: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Argument)
});
var $5963f3e88b017f5a$var$Command = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("Command", {
    /**
   * A Move Call - any public Move function can be called via
   * this transaction. The results can be used that instant to pass
   * into the next transaction.
   */ MoveCall: $5963f3e88b017f5a$var$ProgrammableMoveCall,
    /**
   * Transfer vector of objects to a receiver.
   */ TransferObjects: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("TransferObjects", {
        objects: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Argument),
        address: $5963f3e88b017f5a$var$Argument
    }),
    // /**
    //  * Split `amount` from a `coin`.
    //  */
    SplitCoins: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("SplitCoins", {
        coin: $5963f3e88b017f5a$var$Argument,
        amounts: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Argument)
    }),
    // /**
    //  * Merge Vector of Coins (`sources`) into a `destination`.
    //  */
    MergeCoins: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MergeCoins", {
        destination: $5963f3e88b017f5a$var$Argument,
        sources: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Argument)
    }),
    // /**
    //  * Publish a Move module.
    //  */
    Publish: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("Publish", {
        modules: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8()).transform({
            input: function(val) {
                return typeof val === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(val) : val;
            },
            output: function(val) {
                return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(new Uint8Array(val));
            }
        })),
        dependencies: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Address)
    }),
    // /**
    //  * Build a vector of objects using the input arguments.
    //  * It is impossible to export construct a `vector<T: key>` otherwise,
    //  * so this call serves a utility function.
    //  */
    MakeMoveVec: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MakeMoveVec", {
        type: $5963f3e88b017f5a$var$optionEnum($5963f3e88b017f5a$var$TypeTag).transform({
            input: function(val) {
                return val === null ? {
                    None: true
                } : {
                    Some: val
                };
            },
            output: function(val) {
                var _val_Some;
                return (_val_Some = val.Some) !== null && _val_Some !== void 0 ? _val_Some : null;
            }
        }),
        elements: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Argument)
    }),
    Upgrade: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("Upgrade", {
        modules: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8()).transform({
            input: function(val) {
                return typeof val === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(val) : val;
            },
            output: function(val) {
                return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(new Uint8Array(val));
            }
        })),
        dependencies: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Address),
        package: $5963f3e88b017f5a$var$Address,
        ticket: $5963f3e88b017f5a$var$Argument
    })
});
var $5963f3e88b017f5a$var$ProgrammableTransaction = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ProgrammableTransaction", {
    inputs: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$CallArg),
    commands: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$Command)
});
var $5963f3e88b017f5a$var$TransactionKind = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("TransactionKind", {
    ProgrammableTransaction: $5963f3e88b017f5a$var$ProgrammableTransaction,
    ChangeEpoch: null,
    Genesis: null,
    ConsensusCommitPrologue: null
});
var $5963f3e88b017f5a$var$TransactionExpiration = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("TransactionExpiration", {
    None: null,
    Epoch: $5963f3e88b017f5a$var$unsafe_u64()
});
var $5963f3e88b017f5a$var$StructTag = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("StructTag", {
    address: $5963f3e88b017f5a$var$Address,
    module: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
    name: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
    typeParams: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$InnerTypeTag)
});
var $5963f3e88b017f5a$var$GasData = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("GasData", {
    payment: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$SuiObjectRef),
    owner: $5963f3e88b017f5a$var$Address,
    price: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    budget: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
});
var $5963f3e88b017f5a$var$TransactionDataV1 = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("TransactionDataV1", {
    kind: $5963f3e88b017f5a$var$TransactionKind,
    sender: $5963f3e88b017f5a$var$Address,
    gasData: $5963f3e88b017f5a$var$GasData,
    expiration: $5963f3e88b017f5a$var$TransactionExpiration
});
var $5963f3e88b017f5a$var$TransactionData = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("TransactionData", {
    V1: $5963f3e88b017f5a$var$TransactionDataV1
});
var $5963f3e88b017f5a$var$IntentScope = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("IntentScope", {
    TransactionData: null,
    TransactionEffects: null,
    CheckpointSummary: null,
    PersonalMessage: null
});
var $5963f3e88b017f5a$var$IntentVersion = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("IntentVersion", {
    V0: null
});
var $5963f3e88b017f5a$var$AppId = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("AppId", {
    Sui: null
});
var $5963f3e88b017f5a$var$Intent = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("Intent", {
    scope: $5963f3e88b017f5a$var$IntentScope,
    version: $5963f3e88b017f5a$var$IntentVersion,
    appId: $5963f3e88b017f5a$var$AppId
});
function $5963f3e88b017f5a$var$IntentMessage(T) {
    return $634b23529fb8a913$export$9faca4e3b5a9912b.struct("IntentMessage<".concat(T.name, ">"), {
        intent: $5963f3e88b017f5a$var$Intent,
        value: T
    });
}
var $5963f3e88b017f5a$var$CompressedSignature = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("CompressedSignature", {
    ED25519: $634b23529fb8a913$export$9faca4e3b5a9912b.fixedArray(64, $634b23529fb8a913$export$9faca4e3b5a9912b.u8()),
    Secp256k1: $634b23529fb8a913$export$9faca4e3b5a9912b.fixedArray(64, $634b23529fb8a913$export$9faca4e3b5a9912b.u8()),
    Secp256r1: $634b23529fb8a913$export$9faca4e3b5a9912b.fixedArray(64, $634b23529fb8a913$export$9faca4e3b5a9912b.u8()),
    ZkLogin: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8())
});
var $5963f3e88b017f5a$var$PublicKey = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("PublicKey", {
    ED25519: $634b23529fb8a913$export$9faca4e3b5a9912b.fixedArray(32, $634b23529fb8a913$export$9faca4e3b5a9912b.u8()),
    Secp256k1: $634b23529fb8a913$export$9faca4e3b5a9912b.fixedArray(33, $634b23529fb8a913$export$9faca4e3b5a9912b.u8()),
    Secp256r1: $634b23529fb8a913$export$9faca4e3b5a9912b.fixedArray(33, $634b23529fb8a913$export$9faca4e3b5a9912b.u8()),
    ZkLogin: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8())
});
var $5963f3e88b017f5a$var$MultiSigPkMap = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MultiSigPkMap", {
    pubKey: $5963f3e88b017f5a$var$PublicKey,
    weight: $634b23529fb8a913$export$9faca4e3b5a9912b.u8()
});
var $5963f3e88b017f5a$var$MultiSigPublicKey = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MultiSigPublicKey", {
    pk_map: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$MultiSigPkMap),
    threshold: $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
});
var $5963f3e88b017f5a$var$MultiSig = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MultiSig", {
    sigs: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$CompressedSignature),
    bitmap: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
    multisig_pk: $5963f3e88b017f5a$var$MultiSigPublicKey
});
var $5963f3e88b017f5a$var$base64String = $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8()).transform({
    input: function(val) {
        return typeof val === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(val) : val;
    },
    output: function(val) {
        return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(new Uint8Array(val));
    }
});
var $5963f3e88b017f5a$var$SenderSignedTransaction = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("SenderSignedTransaction", {
    intentMessage: $5963f3e88b017f5a$var$IntentMessage($5963f3e88b017f5a$var$TransactionData),
    txSignatures: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$base64String)
});
var $5963f3e88b017f5a$var$SenderSignedData = $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$var$SenderSignedTransaction, {
    name: "SenderSignedData"
});


var $9a5eef3b14e1a33b$exports = {};
"use strict";
var $9a5eef3b14e1a33b$var$__defProp = Object.defineProperty;
var $9a5eef3b14e1a33b$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $9a5eef3b14e1a33b$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $9a5eef3b14e1a33b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9a5eef3b14e1a33b$var$__export = function(target, all) {
    for(var name in all)$9a5eef3b14e1a33b$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $9a5eef3b14e1a33b$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$9a5eef3b14e1a33b$var$__hasOwnProp.call(to, key) && key !== except) $9a5eef3b14e1a33b$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $9a5eef3b14e1a33b$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $9a5eef3b14e1a33b$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $9a5eef3b14e1a33b$var$__toCommonJS = function(mod) {
    return $9a5eef3b14e1a33b$var$__copyProps($9a5eef3b14e1a33b$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $9a5eef3b14e1a33b$var$effects_exports = {};
$9a5eef3b14e1a33b$var$__export($9a5eef3b14e1a33b$var$effects_exports, {
    TransactionEffects: function() {
        return $9a5eef3b14e1a33b$var$TransactionEffects;
    }
});
$9a5eef3b14e1a33b$exports = $9a5eef3b14e1a33b$var$__toCommonJS($9a5eef3b14e1a33b$var$effects_exports);


var $9a5eef3b14e1a33b$var$PackageUpgradeError = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("PackageUpgradeError", {
    UnableToFetchPackage: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("UnableToFetchPackage", {
        packageId: $5963f3e88b017f5a$exports.Address
    }),
    NotAPackage: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("NotAPackage", {
        objectId: $5963f3e88b017f5a$exports.Address
    }),
    IncompatibleUpgrade: null,
    DigestDoesNotMatch: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("DigestDoesNotMatch", {
        digest: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8())
    }),
    UnknownUpgradePolicy: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("UnknownUpgradePolicy", {
        policy: $634b23529fb8a913$export$9faca4e3b5a9912b.u8()
    }),
    PackageIDDoesNotMatch: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("PackageIDDoesNotMatch", {
        packageId: $5963f3e88b017f5a$exports.Address,
        ticketId: $5963f3e88b017f5a$exports.Address
    })
});
var $9a5eef3b14e1a33b$var$ModuleId = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ModuleId", {
    address: $5963f3e88b017f5a$exports.Address,
    name: $634b23529fb8a913$export$9faca4e3b5a9912b.string()
});
var $9a5eef3b14e1a33b$var$MoveLocation = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MoveLocation", {
    module: $9a5eef3b14e1a33b$var$ModuleId,
    function: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
    instruction: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
    functionName: $634b23529fb8a913$export$9faca4e3b5a9912b.option($634b23529fb8a913$export$9faca4e3b5a9912b.string())
});
var $9a5eef3b14e1a33b$var$CommandArgumentError = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("CommandArgumentError", {
    TypeMismatch: null,
    InvalidBCSBytes: null,
    InvalidUsageOfPureArg: null,
    InvalidArgumentToPrivateEntryFunction: null,
    IndexOutOfBounds: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("IndexOutOfBounds", {
        idx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
    }),
    SecondaryIndexOutOfBounds: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("SecondaryIndexOutOfBounds", {
        resultIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
        secondaryIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
    }),
    InvalidResultArity: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("InvalidResultArity", {
        resultIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
    }),
    InvalidGasCoinUsage: null,
    InvalidValueUsage: null,
    InvalidObjectByValue: null,
    InvalidObjectByMutRef: null,
    SharedObjectOperationNotAllowed: null
});
var $9a5eef3b14e1a33b$var$TypeArgumentError = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("TypeArgumentError", {
    TypeNotFound: null,
    ConstraintNotSatisfied: null
});
var $9a5eef3b14e1a33b$var$ExecutionFailureStatus = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("ExecutionFailureStatus", {
    InsufficientGas: null,
    InvalidGasObject: null,
    InvariantViolation: null,
    FeatureNotYetSupported: null,
    MoveObjectTooBig: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MoveObjectTooBig", {
        objectSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
        maxObjectSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    }),
    MovePackageTooBig: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("MovePackageTooBig", {
        objectSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
        maxObjectSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    }),
    CircularObjectOwnership: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("CircularObjectOwnership", {
        object: $5963f3e88b017f5a$exports.Address
    }),
    InsufficientCoinBalance: null,
    CoinBalanceOverflow: null,
    PublishErrorNonZeroAddress: null,
    SuiMoveVerificationError: null,
    MovePrimitiveRuntimeError: $634b23529fb8a913$export$9faca4e3b5a9912b.option($9a5eef3b14e1a33b$var$MoveLocation),
    MoveAbort: $634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $9a5eef3b14e1a33b$var$MoveLocation,
        $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    ]),
    VMVerificationOrDeserializationError: null,
    VMInvariantViolation: null,
    FunctionNotFound: null,
    ArityMismatch: null,
    TypeArityMismatch: null,
    NonEntryFunctionInvoked: null,
    CommandArgumentError: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("CommandArgumentError", {
        argIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
        kind: $9a5eef3b14e1a33b$var$CommandArgumentError
    }),
    TypeArgumentError: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("TypeArgumentError", {
        argumentIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
        kind: $9a5eef3b14e1a33b$var$TypeArgumentError
    }),
    UnusedValueWithoutDrop: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("UnusedValueWithoutDrop", {
        resultIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
        secondaryIdx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
    }),
    InvalidPublicFunctionReturnType: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("InvalidPublicFunctionReturnType", {
        idx: $634b23529fb8a913$export$9faca4e3b5a9912b.u16()
    }),
    InvalidTransferObject: null,
    EffectsTooLarge: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("EffectsTooLarge", {
        currentSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
        maxSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    }),
    PublishUpgradeMissingDependency: null,
    PublishUpgradeDependencyDowngrade: null,
    PackageUpgradeError: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("PackageUpgradeError", {
        upgradeError: $9a5eef3b14e1a33b$var$PackageUpgradeError
    }),
    WrittenObjectsTooLarge: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("WrittenObjectsTooLarge", {
        currentSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
        maxSize: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    }),
    CertificateDenied: null,
    SuiMoveVerificationTimedout: null,
    SharedObjectOperationNotAllowed: null,
    InputObjectDeleted: null
});
var $9a5eef3b14e1a33b$var$ExecutionStatus = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("ExecutionStatus", {
    Success: null,
    Failed: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ExecutionFailed", {
        error: $9a5eef3b14e1a33b$var$ExecutionFailureStatus,
        command: $634b23529fb8a913$export$9faca4e3b5a9912b.option($634b23529fb8a913$export$9faca4e3b5a9912b.u64())
    })
});
var $9a5eef3b14e1a33b$var$GasCostSummary = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("GasCostSummary", {
    computationCost: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    storageCost: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    storageRebate: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    nonRefundableStorageFee: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
});
var $9a5eef3b14e1a33b$var$Owner = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("Owner", {
    AddressOwner: $5963f3e88b017f5a$exports.Address,
    ObjectOwner: $5963f3e88b017f5a$exports.Address,
    Shared: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("Shared", {
        initialSharedVersion: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    }),
    Immutable: null
});
var $9a5eef3b14e1a33b$var$TransactionEffectsV1 = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("TransactionEffectsV1", {
    status: $9a5eef3b14e1a33b$var$ExecutionStatus,
    executedEpoch: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    gasUsed: $9a5eef3b14e1a33b$var$GasCostSummary,
    modifiedAtVersions: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.Address,
        $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
    ])),
    sharedObjects: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$exports.SuiObjectRef),
    transactionDigest: $5963f3e88b017f5a$exports.ObjectDigest,
    created: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.SuiObjectRef,
        $9a5eef3b14e1a33b$var$Owner
    ])),
    mutated: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.SuiObjectRef,
        $9a5eef3b14e1a33b$var$Owner
    ])),
    unwrapped: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.SuiObjectRef,
        $9a5eef3b14e1a33b$var$Owner
    ])),
    deleted: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$exports.SuiObjectRef),
    unwrappedThenDeleted: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$exports.SuiObjectRef),
    wrapped: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$exports.SuiObjectRef),
    gasObject: $634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.SuiObjectRef,
        $9a5eef3b14e1a33b$var$Owner
    ]),
    eventsDigest: $634b23529fb8a913$export$9faca4e3b5a9912b.option($5963f3e88b017f5a$exports.ObjectDigest),
    dependencies: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$exports.ObjectDigest)
});
var $9a5eef3b14e1a33b$var$VersionDigest = $634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
    $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    $5963f3e88b017f5a$exports.ObjectDigest
]);
var $9a5eef3b14e1a33b$var$ObjectIn = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("ObjectIn", {
    NotExist: null,
    Exist: $634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $9a5eef3b14e1a33b$var$VersionDigest,
        $9a5eef3b14e1a33b$var$Owner
    ])
});
var $9a5eef3b14e1a33b$var$ObjectOut = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("ObjectOut", {
    NotExist: null,
    ObjectWrite: $634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.ObjectDigest,
        $9a5eef3b14e1a33b$var$Owner
    ]),
    PackageWrite: $9a5eef3b14e1a33b$var$VersionDigest
});
var $9a5eef3b14e1a33b$var$IDOperation = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("IDOperation", {
    None: null,
    Created: null,
    Deleted: null
});
var $9a5eef3b14e1a33b$var$EffectsObjectChange = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("EffectsObjectChange", {
    inputState: $9a5eef3b14e1a33b$var$ObjectIn,
    outputState: $9a5eef3b14e1a33b$var$ObjectOut,
    idOperation: $9a5eef3b14e1a33b$var$IDOperation
});
var $9a5eef3b14e1a33b$var$UnchangedSharedKind = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("UnchangedSharedKind", {
    ReadOnlyRoot: $9a5eef3b14e1a33b$var$VersionDigest,
    MutateDeleted: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    ReadDeleted: $634b23529fb8a913$export$9faca4e3b5a9912b.u64()
});
var $9a5eef3b14e1a33b$var$TransactionEffectsV2 = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("TransactionEffectsV2", {
    status: $9a5eef3b14e1a33b$var$ExecutionStatus,
    executedEpoch: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    gasUsed: $9a5eef3b14e1a33b$var$GasCostSummary,
    transactionDigest: $5963f3e88b017f5a$exports.ObjectDigest,
    gasObjectIndex: $634b23529fb8a913$export$9faca4e3b5a9912b.option($634b23529fb8a913$export$9faca4e3b5a9912b.u32()),
    eventsDigest: $634b23529fb8a913$export$9faca4e3b5a9912b.option($5963f3e88b017f5a$exports.ObjectDigest),
    dependencies: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($5963f3e88b017f5a$exports.ObjectDigest),
    lamportVersion: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    changedObjects: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.Address,
        $9a5eef3b14e1a33b$var$EffectsObjectChange
    ])),
    unchangedSharedObjects: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.tuple([
        $5963f3e88b017f5a$exports.Address,
        $9a5eef3b14e1a33b$var$UnchangedSharedKind
    ])),
    auxDataDigest: $634b23529fb8a913$export$9faca4e3b5a9912b.option($5963f3e88b017f5a$exports.ObjectDigest)
});
var $9a5eef3b14e1a33b$var$TransactionEffects = $634b23529fb8a913$export$9faca4e3b5a9912b.enum("TransactionEffects", {
    V1: $9a5eef3b14e1a33b$var$TransactionEffectsV1,
    V2: $9a5eef3b14e1a33b$var$TransactionEffectsV2
});




var $f8d1f806bddc4e70$var$suiBcs = (0, $gddcW._)((0, $4JCw4._)({}, $634b23529fb8a913$export$9faca4e3b5a9912b), {
    U8: $634b23529fb8a913$export$9faca4e3b5a9912b.u8(),
    U16: $634b23529fb8a913$export$9faca4e3b5a9912b.u16(),
    U32: $634b23529fb8a913$export$9faca4e3b5a9912b.u32(),
    U64: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    U128: $634b23529fb8a913$export$9faca4e3b5a9912b.u128(),
    U256: $634b23529fb8a913$export$9faca4e3b5a9912b.u256(),
    ULEB128: $634b23529fb8a913$export$9faca4e3b5a9912b.uleb128(),
    Bool: $634b23529fb8a913$export$9faca4e3b5a9912b.bool(),
    String: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
    Address: $5963f3e88b017f5a$exports.Address,
    AppId: $5963f3e88b017f5a$exports.AppId,
    Argument: $5963f3e88b017f5a$exports.Argument,
    CallArg: $5963f3e88b017f5a$exports.CallArg,
    CompressedSignature: $5963f3e88b017f5a$exports.CompressedSignature,
    GasData: $5963f3e88b017f5a$exports.GasData,
    Intent: $5963f3e88b017f5a$exports.Intent,
    IntentMessage: $5963f3e88b017f5a$exports.IntentMessage,
    IntentScope: $5963f3e88b017f5a$exports.IntentScope,
    IntentVersion: $5963f3e88b017f5a$exports.IntentVersion,
    MultiSig: $5963f3e88b017f5a$exports.MultiSig,
    MultiSigPkMap: $5963f3e88b017f5a$exports.MultiSigPkMap,
    MultiSigPublicKey: $5963f3e88b017f5a$exports.MultiSigPublicKey,
    ObjectArg: $5963f3e88b017f5a$exports.ObjectArg,
    ObjectDigest: $5963f3e88b017f5a$exports.ObjectDigest,
    ProgrammableMoveCall: $5963f3e88b017f5a$exports.ProgrammableMoveCall,
    ProgrammableTransaction: $5963f3e88b017f5a$exports.ProgrammableTransaction,
    PublicKey: $5963f3e88b017f5a$exports.PublicKey,
    SenderSignedData: $5963f3e88b017f5a$exports.SenderSignedData,
    SenderSignedTransaction: $5963f3e88b017f5a$exports.SenderSignedTransaction,
    SharedObjectRef: $5963f3e88b017f5a$exports.SharedObjectRef,
    StructTag: $5963f3e88b017f5a$exports.StructTag,
    SuiObjectRef: $5963f3e88b017f5a$exports.SuiObjectRef,
    Command: $5963f3e88b017f5a$exports.Command,
    TransactionData: $5963f3e88b017f5a$exports.TransactionData,
    TransactionDataV1: $5963f3e88b017f5a$exports.TransactionDataV1,
    TransactionExpiration: $5963f3e88b017f5a$exports.TransactionExpiration,
    TransactionKind: $5963f3e88b017f5a$exports.TransactionKind,
    TypeTag: $5963f3e88b017f5a$exports.TypeTag,
    TransactionEffects: $9a5eef3b14e1a33b$exports.TransactionEffects
});


var $33d626209c61d8cf$exports = {};

var $b9zO9 = parcelRequire("b9zO9");

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $33d626209c61d8cf$var$__defProp = Object.defineProperty;
var $33d626209c61d8cf$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $33d626209c61d8cf$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $33d626209c61d8cf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $33d626209c61d8cf$var$__typeError = function(msg) {
    throw TypeError(msg);
};
var $33d626209c61d8cf$var$__export = function(target, all) {
    for(var name in all)$33d626209c61d8cf$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $33d626209c61d8cf$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$33d626209c61d8cf$var$__hasOwnProp.call(to, key) && key !== except) $33d626209c61d8cf$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $33d626209c61d8cf$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $33d626209c61d8cf$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $33d626209c61d8cf$var$__toCommonJS = function(mod) {
    return $33d626209c61d8cf$var$__copyProps($33d626209c61d8cf$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $33d626209c61d8cf$var$__accessCheck = function(obj, member, msg) {
    return member.has(obj) || $33d626209c61d8cf$var$__typeError("Cannot " + msg);
};
var $33d626209c61d8cf$var$__privateGet = function(obj, member, getter) {
    return $33d626209c61d8cf$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var $33d626209c61d8cf$var$__privateAdd = function(obj, member, value) {
    return member.has(obj) ? $33d626209c61d8cf$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $33d626209c61d8cf$var$__privateSet = function(obj, member, value, setter) {
    return $33d626209c61d8cf$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value;
};
var $33d626209c61d8cf$var$publickey_exports = {};
$33d626209c61d8cf$var$__export($33d626209c61d8cf$var$publickey_exports, {
    ZkLoginPublicIdentifier: function() {
        return $33d626209c61d8cf$var$ZkLoginPublicIdentifier;
    },
    parseSerializedZkLoginSignature: function() {
        return $33d626209c61d8cf$var$parseSerializedZkLoginSignature;
    },
    toZkLoginPublicIdentifier: function() {
        return $33d626209c61d8cf$var$toZkLoginPublicIdentifier;
    }
});
$33d626209c61d8cf$exports = $33d626209c61d8cf$var$__toCommonJS($33d626209c61d8cf$var$publickey_exports);

var $f18ddaf76dcce603$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
"use strict";
var $f18ddaf76dcce603$var$__defProp = Object.defineProperty;
var $f18ddaf76dcce603$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $f18ddaf76dcce603$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $f18ddaf76dcce603$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f18ddaf76dcce603$var$__export = function(target, all) {
    for(var name in all)$f18ddaf76dcce603$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $f18ddaf76dcce603$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$f18ddaf76dcce603$var$__hasOwnProp.call(to, key) && key !== except) $f18ddaf76dcce603$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $f18ddaf76dcce603$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $f18ddaf76dcce603$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $f18ddaf76dcce603$var$__toCommonJS = function(mod) {
    return $f18ddaf76dcce603$var$__copyProps($f18ddaf76dcce603$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $f18ddaf76dcce603$var$publickey_exports = {};
$f18ddaf76dcce603$var$__export($f18ddaf76dcce603$var$publickey_exports, {
    PublicKey: function() {
        return $f18ddaf76dcce603$var$PublicKey;
    },
    bytesEqual: function() {
        return $f18ddaf76dcce603$var$bytesEqual;
    }
});
$f18ddaf76dcce603$exports = $f18ddaf76dcce603$var$__toCommonJS($f18ddaf76dcce603$var$publickey_exports);

var $3274270117ba9b37$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($3274270117ba9b37$exports, "__esModule", {
    value: true
});
$3274270117ba9b37$exports.blake2b = void 0;
var $6375d96e3f4396cb$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($6375d96e3f4396cb$exports, "__esModule", {
    value: true
});
$6375d96e3f4396cb$exports.BLAKE = $6375d96e3f4396cb$exports.SIGMA = void 0;
var $87bc1d41ebb7f232$exports = {};
"use strict";
Object.defineProperty($87bc1d41ebb7f232$exports, "__esModule", {
    value: true
});
$87bc1d41ebb7f232$exports.output = $87bc1d41ebb7f232$exports.exists = $87bc1d41ebb7f232$exports.hash = $87bc1d41ebb7f232$exports.bytes = $87bc1d41ebb7f232$exports.bool = $87bc1d41ebb7f232$exports.number = $87bc1d41ebb7f232$exports.isBytes = void 0;
function $87bc1d41ebb7f232$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, not ".concat(n));
}
$87bc1d41ebb7f232$exports.number = $87bc1d41ebb7f232$var$number;
function $87bc1d41ebb7f232$var$bool(b) {
    if (typeof b !== "boolean") throw new Error("boolean expected, not ".concat(b));
}
$87bc1d41ebb7f232$exports.bool = $87bc1d41ebb7f232$var$bool;
// copied from utils
function $87bc1d41ebb7f232$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
$87bc1d41ebb7f232$exports.isBytes = $87bc1d41ebb7f232$var$isBytes;
function $87bc1d41ebb7f232$var$bytes(b) {
    for(var _len = arguments.length, lengths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        lengths[_key - 1] = arguments[_key];
    }
    if (!$87bc1d41ebb7f232$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length ".concat(lengths, ", not of length=").concat(b.length));
}
$87bc1d41ebb7f232$exports.bytes = $87bc1d41ebb7f232$var$bytes;
function $87bc1d41ebb7f232$var$hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $87bc1d41ebb7f232$var$number(h.outputLen);
    $87bc1d41ebb7f232$var$number(h.blockLen);
}
$87bc1d41ebb7f232$exports.hash = $87bc1d41ebb7f232$var$hash;
function $87bc1d41ebb7f232$var$exists(instance) {
    var checkFinished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$87bc1d41ebb7f232$exports.exists = $87bc1d41ebb7f232$var$exists;
function $87bc1d41ebb7f232$var$output(out, instance) {
    $87bc1d41ebb7f232$var$bytes(out);
    var min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least ".concat(min));
}
$87bc1d41ebb7f232$exports.output = $87bc1d41ebb7f232$var$output;
var $87bc1d41ebb7f232$var$assert = {
    number: $87bc1d41ebb7f232$var$number,
    bool: $87bc1d41ebb7f232$var$bool,
    bytes: $87bc1d41ebb7f232$var$bytes,
    hash: $87bc1d41ebb7f232$var$hash,
    exists: $87bc1d41ebb7f232$var$exists,
    output: $87bc1d41ebb7f232$var$output
};
$87bc1d41ebb7f232$exports.default = $87bc1d41ebb7f232$var$assert;


var $84f9351876d022a0$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($84f9351876d022a0$exports, "__esModule", {
    value: true
});
$84f9351876d022a0$exports.randomBytes = $84f9351876d022a0$exports.wrapXOFConstructorWithOpts = $84f9351876d022a0$exports.wrapConstructorWithOpts = $84f9351876d022a0$exports.wrapConstructor = $84f9351876d022a0$exports.checkOpts = $84f9351876d022a0$exports.Hash = $84f9351876d022a0$exports.concatBytes = $84f9351876d022a0$exports.toBytes = $84f9351876d022a0$exports.utf8ToBytes = $84f9351876d022a0$exports.asyncLoop = $84f9351876d022a0$exports.nextTick = $84f9351876d022a0$exports.hexToBytes = $84f9351876d022a0$exports.bytesToHex = $84f9351876d022a0$exports.byteSwap32 = $84f9351876d022a0$exports.byteSwapIfBE = $84f9351876d022a0$exports.byteSwap = $84f9351876d022a0$exports.isLE = $84f9351876d022a0$exports.rotl = $84f9351876d022a0$exports.rotr = $84f9351876d022a0$exports.createView = $84f9351876d022a0$exports.u32 = $84f9351876d022a0$exports.u8 = $84f9351876d022a0$exports.isBytes = void 0;
var $215722c3fec46fb2$exports = {};
"use strict";
Object.defineProperty($215722c3fec46fb2$exports, "__esModule", {
    value: true
});
$215722c3fec46fb2$exports.crypto = void 0;
$215722c3fec46fb2$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;



// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $84f9351876d022a0$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
$84f9351876d022a0$exports.isBytes = $84f9351876d022a0$var$isBytes;
// Cast array to different type
var $84f9351876d022a0$var$u8 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
$84f9351876d022a0$exports.u8 = $84f9351876d022a0$var$u8;
var $84f9351876d022a0$var$u32 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
$84f9351876d022a0$exports.u32 = $84f9351876d022a0$var$u32;
// Cast array to view
var $84f9351876d022a0$var$createView = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
$84f9351876d022a0$exports.createView = $84f9351876d022a0$var$createView;
// The rotate right (circular right shift) operation for uint32
var $84f9351876d022a0$var$rotr = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
$84f9351876d022a0$exports.rotr = $84f9351876d022a0$var$rotr;
// The rotate left (circular left shift) operation for uint32
var $84f9351876d022a0$var$rotl = function(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
};
$84f9351876d022a0$exports.rotl = $84f9351876d022a0$var$rotl;
$84f9351876d022a0$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
var $84f9351876d022a0$var$byteSwap = function(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
};
$84f9351876d022a0$exports.byteSwap = $84f9351876d022a0$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
$84f9351876d022a0$exports.byteSwapIfBE = $84f9351876d022a0$exports.isLE ? function(n) {
    return n;
} : function(n) {
    return (0, $84f9351876d022a0$exports.byteSwap)(n);
};
// In place byte swap for Uint32Array
function $84f9351876d022a0$var$byteSwap32(arr) {
    for(var i = 0; i < arr.length; i++)arr[i] = (0, $84f9351876d022a0$exports.byteSwap)(arr[i]);
}
$84f9351876d022a0$exports.byteSwap32 = $84f9351876d022a0$var$byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
var $84f9351876d022a0$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, function(_, i) {
    return i.toString(16).padStart(2, "0");
});
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $84f9351876d022a0$var$bytesToHex(bytes) {
    (0, $87bc1d41ebb7f232$exports.bytes)(bytes);
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $84f9351876d022a0$var$hexes[bytes[i]];
    return hex;
}
$84f9351876d022a0$exports.bytesToHex = $84f9351876d022a0$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
var $84f9351876d022a0$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $84f9351876d022a0$var$asciiToBase16(char) {
    if (char >= $84f9351876d022a0$var$asciis._0 && char <= $84f9351876d022a0$var$asciis._9) return char - $84f9351876d022a0$var$asciis._0;
    if (char >= $84f9351876d022a0$var$asciis._A && char <= $84f9351876d022a0$var$asciis._F) return char - ($84f9351876d022a0$var$asciis._A - 10);
    if (char >= $84f9351876d022a0$var$asciis._a && char <= $84f9351876d022a0$var$asciis._f) return char - ($84f9351876d022a0$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $84f9351876d022a0$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $aVMuR._)(hex)));
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    var array = new Uint8Array(al);
    for(var ai = 0, hi = 0; ai < al; ai++, hi += 2){
        var n1 = $84f9351876d022a0$var$asciiToBase16(hex.charCodeAt(hi));
        var n2 = $84f9351876d022a0$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
$84f9351876d022a0$exports.hexToBytes = $84f9351876d022a0$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
var $84f9351876d022a0$var$nextTick = function() {
    var _ref = (0, $6rBFC._)(function() {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function nextTick() {
        return _ref.apply(this, arguments);
    };
}();
$84f9351876d022a0$exports.nextTick = $84f9351876d022a0$var$nextTick;
function $84f9351876d022a0$var$asyncLoop(iters, tick, cb) {
    return $84f9351876d022a0$var$_asyncLoop.apply(this, arguments);
}
function $84f9351876d022a0$var$_asyncLoop() {
    $84f9351876d022a0$var$_asyncLoop = // Returns control to thread each 'tick' ms to avoid blocking
    (0, $6rBFC._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, $84f9351876d022a0$exports.nextTick)()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $84f9351876d022a0$var$_asyncLoop.apply(this, arguments);
}
$84f9351876d022a0$exports.asyncLoop = $84f9351876d022a0$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $84f9351876d022a0$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$84f9351876d022a0$exports.utf8ToBytes = $84f9351876d022a0$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $84f9351876d022a0$var$toBytes(data) {
    if (typeof data === "string") data = $84f9351876d022a0$var$utf8ToBytes(data);
    (0, $87bc1d41ebb7f232$exports.bytes)(data);
    return data;
}
$84f9351876d022a0$exports.toBytes = $84f9351876d022a0$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $84f9351876d022a0$var$concatBytes() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var sum = 0;
    for(var i = 0; i < arrays.length; i++){
        var a = arrays[i];
        (0, $87bc1d41ebb7f232$exports.bytes)(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for(var i1 = 0, pad = 0; i1 < arrays.length; i1++){
        var a1 = arrays[i1];
        res.set(a1, pad);
        pad += a1.length;
    }
    return res;
}
$84f9351876d022a0$exports.concatBytes = $84f9351876d022a0$var$concatBytes;
// For runtime check if class implements interface
var $84f9351876d022a0$var$Hash = /*#__PURE__*/ function() {
    function Hash() {
        (0, $7dKN1._)(this, Hash);
    }
    (0, $eW5pA._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
$84f9351876d022a0$exports.Hash = $84f9351876d022a0$var$Hash;
var $84f9351876d022a0$var$toStr = {}.toString;
function $84f9351876d022a0$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $84f9351876d022a0$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    var merged = Object.assign(defaults, opts);
    return merged;
}
$84f9351876d022a0$exports.checkOpts = $84f9351876d022a0$var$checkOpts;
function $84f9351876d022a0$var$wrapConstructor(hashCons) {
    var hashC = function(msg) {
        return hashCons().update($84f9351876d022a0$var$toBytes(msg)).digest();
    };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashCons();
    };
    return hashC;
}
$84f9351876d022a0$exports.wrapConstructor = $84f9351876d022a0$var$wrapConstructor;
function $84f9351876d022a0$var$wrapConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($84f9351876d022a0$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
$84f9351876d022a0$exports.wrapConstructorWithOpts = $84f9351876d022a0$var$wrapConstructorWithOpts;
function $84f9351876d022a0$var$wrapXOFConstructorWithOpts(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($84f9351876d022a0$var$toBytes(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
$84f9351876d022a0$exports.wrapXOFConstructorWithOpts = $84f9351876d022a0$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $84f9351876d022a0$var$randomBytes() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ($215722c3fec46fb2$exports.crypto && typeof $215722c3fec46fb2$exports.crypto.getRandomValues === "function") return $215722c3fec46fb2$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$84f9351876d022a0$exports.randomBytes = $84f9351876d022a0$var$randomBytes;


// Blake is based on ChaCha permutation.
// For BLAKE2b, the two extra permutations for rounds 10 and 11 are SIGMA[10..11] = SIGMA[0..1].
// prettier-ignore
$6375d96e3f4396cb$exports.SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
]);
var $6375d96e3f4396cb$var$BLAKE = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(BLAKE, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(BLAKE);
    function BLAKE(blockLen, outputLen) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, keyLen = arguments.length > 3 ? arguments[3] : void 0, saltLen = arguments.length > 4 ? arguments[4] : void 0, persLen = arguments.length > 5 ? arguments[5] : void 0;
        (0, $7dKN1._)(this, BLAKE);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.length = 0;
        _this.pos = 0;
        _this.finished = false;
        _this.destroyed = false;
        (0, $87bc1d41ebb7f232$exports.number)(blockLen);
        (0, $87bc1d41ebb7f232$exports.number)(outputLen);
        (0, $87bc1d41ebb7f232$exports.number)(keyLen);
        if (outputLen < 0 || outputLen > keyLen) throw new Error("outputLen bigger than keyLen");
        if (opts.key !== undefined && (opts.key.length < 1 || opts.key.length > keyLen)) throw new Error("key must be up 1..".concat(keyLen, " byte long or undefined"));
        if (opts.salt !== undefined && opts.salt.length !== saltLen) throw new Error("salt must be ".concat(saltLen, " byte long or undefined"));
        if (opts.personalization !== undefined && opts.personalization.length !== persLen) throw new Error("personalization must be ".concat(persLen, " byte long or undefined"));
        _this.buffer32 = (0, $84f9351876d022a0$exports.u32)(_this.buffer = new Uint8Array(blockLen));
        return _this;
    }
    (0, $eW5pA._)(BLAKE, [
        {
            key: "update",
            value: function update(data) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                // Main difference with other hashes: there is flag for last block,
                // so we cannot process current block before we know that there
                // is the next one. This significantly complicates logic and reduces ability
                // to do zero-copy processing
                var _this = this, blockLen = _this.blockLen, buffer = _this.buffer, buffer32 = _this.buffer32;
                data = (0, $84f9351876d022a0$exports.toBytes)(data);
                var len = data.length;
                var offset = data.byteOffset;
                var buf = data.buffer;
                for(var pos = 0; pos < len;){
                    // If buffer is full and we still have input (don't process last block, same as blake2s)
                    if (this.pos === blockLen) {
                        if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(buffer32);
                        this.compress(buffer32, 0, false);
                        if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(buffer32);
                        this.pos = 0;
                    }
                    var take = Math.min(blockLen - this.pos, len - pos);
                    var dataOffset = offset + pos;
                    // full block && aligned to 4 bytes && not last in input
                    if (take === blockLen && !(dataOffset % 4) && pos + take < len) {
                        var data32 = new Uint32Array(buf, dataOffset, Math.floor((len - pos) / 4));
                        if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(data32);
                        for(var pos32 = 0; pos + blockLen < len; pos32 += buffer32.length, pos += blockLen){
                            this.length += blockLen;
                            this.compress(data32, pos32, false);
                        }
                        if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(data32);
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    this.length += take;
                    pos += take;
                }
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                (0, $87bc1d41ebb7f232$exports.output)(out, this);
                var _this = this, pos = _this.pos, buffer32 = _this.buffer32;
                this.finished = true;
                // Padding
                this.buffer.subarray(pos).fill(0);
                if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(buffer32);
                this.compress(buffer32, 0, true);
                if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(buffer32);
                var out32 = (0, $84f9351876d022a0$exports.u32)(out);
                this.get().forEach(function(v, i) {
                    return out32[i] = (0, $84f9351876d022a0$exports.byteSwapIfBE)(v);
                });
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                var _this = this, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, outputLen = _this.outputLen, pos = _this.pos;
                to || (to = new this.constructor({
                    dkLen: outputLen
                }));
                (_to = to).set.apply(_to, (0, $gF0bR._)(this.get()));
                to.length = length;
                to.finished = finished;
                to.destroyed = destroyed;
                to.outputLen = outputLen;
                to.buffer.set(buffer);
                to.pos = pos;
                return to;
            }
        }
    ]);
    return BLAKE;
}($84f9351876d022a0$exports.Hash);
$6375d96e3f4396cb$exports.BLAKE = $6375d96e3f4396cb$var$BLAKE;


var $56477cbf0e8d09c2$exports = {};
"use strict";
Object.defineProperty($56477cbf0e8d09c2$exports, "__esModule", {
    value: true
});
$56477cbf0e8d09c2$exports.add5L = $56477cbf0e8d09c2$exports.add5H = $56477cbf0e8d09c2$exports.add4H = $56477cbf0e8d09c2$exports.add4L = $56477cbf0e8d09c2$exports.add3H = $56477cbf0e8d09c2$exports.add3L = $56477cbf0e8d09c2$exports.add = $56477cbf0e8d09c2$exports.rotlBL = $56477cbf0e8d09c2$exports.rotlBH = $56477cbf0e8d09c2$exports.rotlSL = $56477cbf0e8d09c2$exports.rotlSH = $56477cbf0e8d09c2$exports.rotr32L = $56477cbf0e8d09c2$exports.rotr32H = $56477cbf0e8d09c2$exports.rotrBL = $56477cbf0e8d09c2$exports.rotrBH = $56477cbf0e8d09c2$exports.rotrSL = $56477cbf0e8d09c2$exports.rotrSH = $56477cbf0e8d09c2$exports.shrSL = $56477cbf0e8d09c2$exports.shrSH = $56477cbf0e8d09c2$exports.toBig = $56477cbf0e8d09c2$exports.split = $56477cbf0e8d09c2$exports.fromBig = void 0;
var $56477cbf0e8d09c2$var$U32_MASK64 = /* @__PURE__ */ BigInt(Math.pow(2, 32) - 1);
var $56477cbf0e8d09c2$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $56477cbf0e8d09c2$var$fromBig(n) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (le) return {
        h: Number(n & $56477cbf0e8d09c2$var$U32_MASK64),
        l: Number(n >> $56477cbf0e8d09c2$var$_32n & $56477cbf0e8d09c2$var$U32_MASK64)
    };
    return {
        h: Number(n >> $56477cbf0e8d09c2$var$_32n & $56477cbf0e8d09c2$var$U32_MASK64) | 0,
        l: Number(n & $56477cbf0e8d09c2$var$U32_MASK64) | 0
    };
}
$56477cbf0e8d09c2$exports.fromBig = $56477cbf0e8d09c2$var$fromBig;
function $56477cbf0e8d09c2$var$split(lst) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for(var i = 0; i < lst.length; i++){
        var _fromBig = $56477cbf0e8d09c2$var$fromBig(lst[i], le), h = _fromBig.h, l = _fromBig.l;
        var ref;
        ref = [
            h,
            l
        ], Ah[i] = ref[0], Al[i] = ref[1], ref;
    }
    return [
        Ah,
        Al
    ];
}
$56477cbf0e8d09c2$exports.split = $56477cbf0e8d09c2$var$split;
var $56477cbf0e8d09c2$var$toBig = function(h, l) {
    return BigInt(h >>> 0) << $56477cbf0e8d09c2$var$_32n | BigInt(l >>> 0);
};
$56477cbf0e8d09c2$exports.toBig = $56477cbf0e8d09c2$var$toBig;
// for Shift in [0, 32)
var $56477cbf0e8d09c2$var$shrSH = function(h, _l, s) {
    return h >>> s;
};
$56477cbf0e8d09c2$exports.shrSH = $56477cbf0e8d09c2$var$shrSH;
var $56477cbf0e8d09c2$var$shrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
$56477cbf0e8d09c2$exports.shrSL = $56477cbf0e8d09c2$var$shrSL;
// Right rotate for Shift in [1, 32)
var $56477cbf0e8d09c2$var$rotrSH = function(h, l, s) {
    return h >>> s | l << 32 - s;
};
$56477cbf0e8d09c2$exports.rotrSH = $56477cbf0e8d09c2$var$rotrSH;
var $56477cbf0e8d09c2$var$rotrSL = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
$56477cbf0e8d09c2$exports.rotrSL = $56477cbf0e8d09c2$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var $56477cbf0e8d09c2$var$rotrBH = function(h, l, s) {
    return h << 64 - s | l >>> s - 32;
};
$56477cbf0e8d09c2$exports.rotrBH = $56477cbf0e8d09c2$var$rotrBH;
var $56477cbf0e8d09c2$var$rotrBL = function(h, l, s) {
    return h >>> s - 32 | l << 64 - s;
};
$56477cbf0e8d09c2$exports.rotrBL = $56477cbf0e8d09c2$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
var $56477cbf0e8d09c2$var$rotr32H = function(_h, l) {
    return l;
};
$56477cbf0e8d09c2$exports.rotr32H = $56477cbf0e8d09c2$var$rotr32H;
var $56477cbf0e8d09c2$var$rotr32L = function(h, _l) {
    return h;
};
$56477cbf0e8d09c2$exports.rotr32L = $56477cbf0e8d09c2$var$rotr32L;
// Left rotate for Shift in [1, 32)
var $56477cbf0e8d09c2$var$rotlSH = function(h, l, s) {
    return h << s | l >>> 32 - s;
};
$56477cbf0e8d09c2$exports.rotlSH = $56477cbf0e8d09c2$var$rotlSH;
var $56477cbf0e8d09c2$var$rotlSL = function(h, l, s) {
    return l << s | h >>> 32 - s;
};
$56477cbf0e8d09c2$exports.rotlSL = $56477cbf0e8d09c2$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var $56477cbf0e8d09c2$var$rotlBH = function(h, l, s) {
    return l << s - 32 | h >>> 64 - s;
};
$56477cbf0e8d09c2$exports.rotlBH = $56477cbf0e8d09c2$var$rotlBH;
var $56477cbf0e8d09c2$var$rotlBL = function(h, l, s) {
    return h << s - 32 | l >>> 64 - s;
};
$56477cbf0e8d09c2$exports.rotlBL = $56477cbf0e8d09c2$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $56477cbf0e8d09c2$var$add(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
        l: l | 0
    };
}
$56477cbf0e8d09c2$exports.add = $56477cbf0e8d09c2$var$add;
// Addition with more than 2 elements
var $56477cbf0e8d09c2$var$add3L = function(Al, Bl, Cl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};
$56477cbf0e8d09c2$exports.add3L = $56477cbf0e8d09c2$var$add3L;
var $56477cbf0e8d09c2$var$add3H = function(low, Ah, Bh, Ch) {
    return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};
$56477cbf0e8d09c2$exports.add3H = $56477cbf0e8d09c2$var$add3H;
var $56477cbf0e8d09c2$var$add4L = function(Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
$56477cbf0e8d09c2$exports.add4L = $56477cbf0e8d09c2$var$add4L;
var $56477cbf0e8d09c2$var$add4H = function(low, Ah, Bh, Ch, Dh) {
    return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};
$56477cbf0e8d09c2$exports.add4H = $56477cbf0e8d09c2$var$add4H;
var $56477cbf0e8d09c2$var$add5L = function(Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
$56477cbf0e8d09c2$exports.add5L = $56477cbf0e8d09c2$var$add5L;
var $56477cbf0e8d09c2$var$add5H = function(low, Ah, Bh, Ch, Dh, Eh) {
    return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};
$56477cbf0e8d09c2$exports.add5H = $56477cbf0e8d09c2$var$add5H;
// prettier-ignore
var $56477cbf0e8d09c2$var$u64 = {
    fromBig: $56477cbf0e8d09c2$var$fromBig,
    split: $56477cbf0e8d09c2$var$split,
    toBig: $56477cbf0e8d09c2$var$toBig,
    shrSH: $56477cbf0e8d09c2$var$shrSH,
    shrSL: $56477cbf0e8d09c2$var$shrSL,
    rotrSH: $56477cbf0e8d09c2$var$rotrSH,
    rotrSL: $56477cbf0e8d09c2$var$rotrSL,
    rotrBH: $56477cbf0e8d09c2$var$rotrBH,
    rotrBL: $56477cbf0e8d09c2$var$rotrBL,
    rotr32H: $56477cbf0e8d09c2$var$rotr32H,
    rotr32L: $56477cbf0e8d09c2$var$rotr32L,
    rotlSH: $56477cbf0e8d09c2$var$rotlSH,
    rotlSL: $56477cbf0e8d09c2$var$rotlSL,
    rotlBH: $56477cbf0e8d09c2$var$rotlBH,
    rotlBL: $56477cbf0e8d09c2$var$rotlBL,
    add: $56477cbf0e8d09c2$var$add,
    add3L: $56477cbf0e8d09c2$var$add3L,
    add3H: $56477cbf0e8d09c2$var$add3H,
    add4L: $56477cbf0e8d09c2$var$add4L,
    add4H: $56477cbf0e8d09c2$var$add4H,
    add5H: $56477cbf0e8d09c2$var$add5H,
    add5L: $56477cbf0e8d09c2$var$add5L
};
$56477cbf0e8d09c2$exports.default = $56477cbf0e8d09c2$var$u64;



// Same as SHA-512 but LE
// prettier-ignore
var $3274270117ba9b37$var$B2B_IV = /* @__PURE__ */ new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Temporary buffer
var $3274270117ba9b37$var$BBUF = /* @__PURE__ */ new Uint32Array(32);
// Mixing function G splitted in two halfs
function $3274270117ba9b37$var$G1b(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    var Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    var Al = $3274270117ba9b37$var$BBUF[2 * a], Ah = $3274270117ba9b37$var$BBUF[2 * a + 1]; // prettier-ignore
    var Bl = $3274270117ba9b37$var$BBUF[2 * b], Bh = $3274270117ba9b37$var$BBUF[2 * b + 1]; // prettier-ignore
    var Cl = $3274270117ba9b37$var$BBUF[2 * c], Ch = $3274270117ba9b37$var$BBUF[2 * c + 1]; // prettier-ignore
    var Dl = $3274270117ba9b37$var$BBUF[2 * d], Dh = $3274270117ba9b37$var$BBUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    var ll = $56477cbf0e8d09c2$exports.default.add3L(Al, Bl, Xl);
    Ah = $56477cbf0e8d09c2$exports.default.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    var ref;
    // v[d] = rotr(v[d] ^ v[a], 32)
    ref = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    }, Dh = ref.Dh, Dl = ref.Dl, ref;
    var ref1;
    ref1 = {
        Dh: $56477cbf0e8d09c2$exports.default.rotr32H(Dh, Dl),
        Dl: $56477cbf0e8d09c2$exports.default.rotr32L(Dh, Dl)
    }, Dh = ref1.Dh, Dl = ref1.Dl, ref1;
    var ref2;
    // v[c] = (v[c] + v[d]) | 0;
    ref2 = $56477cbf0e8d09c2$exports.default.add(Ch, Cl, Dh, Dl), Ch = ref2.h, Cl = ref2.l, ref2;
    var ref3;
    // v[b] = rotr(v[b] ^ v[c], 24)
    ref3 = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    }, Bh = ref3.Bh, Bl = ref3.Bl, ref3;
    var ref4;
    ref4 = {
        Bh: $56477cbf0e8d09c2$exports.default.rotrSH(Bh, Bl, 24),
        Bl: $56477cbf0e8d09c2$exports.default.rotrSL(Bh, Bl, 24)
    }, Bh = ref4.Bh, Bl = ref4.Bl, ref4;
    $3274270117ba9b37$var$BBUF[2 * a] = Al, $3274270117ba9b37$var$BBUF[2 * a + 1] = Ah;
    $3274270117ba9b37$var$BBUF[2 * b] = Bl, $3274270117ba9b37$var$BBUF[2 * b + 1] = Bh;
    $3274270117ba9b37$var$BBUF[2 * c] = Cl, $3274270117ba9b37$var$BBUF[2 * c + 1] = Ch;
    $3274270117ba9b37$var$BBUF[2 * d] = Dl, $3274270117ba9b37$var$BBUF[2 * d + 1] = Dh;
}
function $3274270117ba9b37$var$G2b(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    var Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    var Al = $3274270117ba9b37$var$BBUF[2 * a], Ah = $3274270117ba9b37$var$BBUF[2 * a + 1]; // prettier-ignore
    var Bl = $3274270117ba9b37$var$BBUF[2 * b], Bh = $3274270117ba9b37$var$BBUF[2 * b + 1]; // prettier-ignore
    var Cl = $3274270117ba9b37$var$BBUF[2 * c], Ch = $3274270117ba9b37$var$BBUF[2 * c + 1]; // prettier-ignore
    var Dl = $3274270117ba9b37$var$BBUF[2 * d], Dh = $3274270117ba9b37$var$BBUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    var ll = $56477cbf0e8d09c2$exports.default.add3L(Al, Bl, Xl);
    Ah = $56477cbf0e8d09c2$exports.default.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    var ref;
    // v[d] = rotr(v[d] ^ v[a], 16)
    ref = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    }, Dh = ref.Dh, Dl = ref.Dl, ref;
    var ref1;
    ref1 = {
        Dh: $56477cbf0e8d09c2$exports.default.rotrSH(Dh, Dl, 16),
        Dl: $56477cbf0e8d09c2$exports.default.rotrSL(Dh, Dl, 16)
    }, Dh = ref1.Dh, Dl = ref1.Dl, ref1;
    var ref2;
    // v[c] = (v[c] + v[d]) | 0;
    ref2 = $56477cbf0e8d09c2$exports.default.add(Ch, Cl, Dh, Dl), Ch = ref2.h, Cl = ref2.l, ref2;
    var ref3;
    // v[b] = rotr(v[b] ^ v[c], 63)
    ref3 = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    }, Bh = ref3.Bh, Bl = ref3.Bl, ref3;
    var ref4;
    ref4 = {
        Bh: $56477cbf0e8d09c2$exports.default.rotrBH(Bh, Bl, 63),
        Bl: $56477cbf0e8d09c2$exports.default.rotrBL(Bh, Bl, 63)
    }, Bh = ref4.Bh, Bl = ref4.Bl, ref4;
    $3274270117ba9b37$var$BBUF[2 * a] = Al, $3274270117ba9b37$var$BBUF[2 * a + 1] = Ah;
    $3274270117ba9b37$var$BBUF[2 * b] = Bl, $3274270117ba9b37$var$BBUF[2 * b + 1] = Bh;
    $3274270117ba9b37$var$BBUF[2 * c] = Cl, $3274270117ba9b37$var$BBUF[2 * c + 1] = Ch;
    $3274270117ba9b37$var$BBUF[2 * d] = Dl, $3274270117ba9b37$var$BBUF[2 * d + 1] = Dh;
}
var $3274270117ba9b37$var$BLAKE2b = /*#__PURE__*/ function(_blake_js_1_BLAKE) {
    (0, $cgJ2Y._)(BLAKE2b, _blake_js_1_BLAKE);
    var _super = (0, $hKD8n._)(BLAKE2b);
    function BLAKE2b() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $7dKN1._)(this, BLAKE2b);
        var _this;
        _this = _super.call(this, 128, opts.dkLen === undefined ? 64 : opts.dkLen, opts, 64, 16, 16);
        // Same as SHA-512, but LE
        _this.v0l = $3274270117ba9b37$var$B2B_IV[0] | 0;
        _this.v0h = $3274270117ba9b37$var$B2B_IV[1] | 0;
        _this.v1l = $3274270117ba9b37$var$B2B_IV[2] | 0;
        _this.v1h = $3274270117ba9b37$var$B2B_IV[3] | 0;
        _this.v2l = $3274270117ba9b37$var$B2B_IV[4] | 0;
        _this.v2h = $3274270117ba9b37$var$B2B_IV[5] | 0;
        _this.v3l = $3274270117ba9b37$var$B2B_IV[6] | 0;
        _this.v3h = $3274270117ba9b37$var$B2B_IV[7] | 0;
        _this.v4l = $3274270117ba9b37$var$B2B_IV[8] | 0;
        _this.v4h = $3274270117ba9b37$var$B2B_IV[9] | 0;
        _this.v5l = $3274270117ba9b37$var$B2B_IV[10] | 0;
        _this.v5h = $3274270117ba9b37$var$B2B_IV[11] | 0;
        _this.v6l = $3274270117ba9b37$var$B2B_IV[12] | 0;
        _this.v6h = $3274270117ba9b37$var$B2B_IV[13] | 0;
        _this.v7l = $3274270117ba9b37$var$B2B_IV[14] | 0;
        _this.v7h = $3274270117ba9b37$var$B2B_IV[15] | 0;
        var keyLength = opts.key ? opts.key.length : 0;
        _this.v0l ^= _this.outputLen | keyLength << 8 | 16842752;
        if (opts.salt) {
            var salt = (0, $84f9351876d022a0$exports.u32)((0, $84f9351876d022a0$exports.toBytes)(opts.salt));
            _this.v4l ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(salt[0]);
            _this.v4h ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(salt[1]);
            _this.v5l ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(salt[2]);
            _this.v5h ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(salt[3]);
        }
        if (opts.personalization) {
            var pers = (0, $84f9351876d022a0$exports.u32)((0, $84f9351876d022a0$exports.toBytes)(opts.personalization));
            _this.v6l ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(pers[0]);
            _this.v6h ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(pers[1]);
            _this.v7l ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(pers[2]);
            _this.v7h ^= (0, $84f9351876d022a0$exports.byteSwapIfBE)(pers[3]);
        }
        if (opts.key) {
            // Pad to blockLen and update
            var tmp = new Uint8Array(_this.blockLen);
            tmp.set((0, $84f9351876d022a0$exports.toBytes)(opts.key));
            _this.update(tmp);
        }
        return _this;
    }
    (0, $eW5pA._)(BLAKE2b, [
        {
            // prettier-ignore
            key: "get",
            value: function get() {
                var _this = this, v0l = _this.v0l, v0h = _this.v0h, v1l = _this.v1l, v1h = _this.v1h, v2l = _this.v2l, v2h = _this.v2h, v3l = _this.v3l, v3h = _this.v3h, v4l = _this.v4l, v4h = _this.v4h, v5l = _this.v5l, v5h = _this.v5h, v6l = _this.v6l, v6h = _this.v6h, v7l = _this.v7l, v7h = _this.v7h;
                return [
                    v0l,
                    v0h,
                    v1l,
                    v1h,
                    v2l,
                    v2h,
                    v3l,
                    v3h,
                    v4l,
                    v4h,
                    v5l,
                    v5h,
                    v6l,
                    v6h,
                    v7l,
                    v7h
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h) {
                this.v0l = v0l | 0;
                this.v0h = v0h | 0;
                this.v1l = v1l | 0;
                this.v1h = v1h | 0;
                this.v2l = v2l | 0;
                this.v2h = v2h | 0;
                this.v3l = v3l | 0;
                this.v3h = v3h | 0;
                this.v4l = v4l | 0;
                this.v4h = v4h | 0;
                this.v5l = v5l | 0;
                this.v5h = v5h | 0;
                this.v6l = v6l | 0;
                this.v6h = v6h | 0;
                this.v7l = v7l | 0;
                this.v7h = v7h | 0;
            }
        },
        {
            key: "compress",
            value: function compress(msg, offset, isLast) {
                this.get().forEach(function(v, i) {
                    return $3274270117ba9b37$var$BBUF[i] = v;
                }); // First half from state.
                $3274270117ba9b37$var$BBUF.set($3274270117ba9b37$var$B2B_IV, 16); // Second half from IV.
                var _u64_js_1_default_fromBig = $56477cbf0e8d09c2$exports.default.fromBig(BigInt(this.length)), h = _u64_js_1_default_fromBig.h, l = _u64_js_1_default_fromBig.l;
                $3274270117ba9b37$var$BBUF[24] = $3274270117ba9b37$var$B2B_IV[8] ^ l; // Low word of the offset.
                $3274270117ba9b37$var$BBUF[25] = $3274270117ba9b37$var$B2B_IV[9] ^ h; // High word.
                // Invert all bits for last block
                if (isLast) {
                    $3274270117ba9b37$var$BBUF[28] = ~$3274270117ba9b37$var$BBUF[28];
                    $3274270117ba9b37$var$BBUF[29] = ~$3274270117ba9b37$var$BBUF[29];
                }
                var j = 0;
                var s = $6375d96e3f4396cb$exports.SIGMA;
                for(var i = 0; i < 12; i++){
                    $3274270117ba9b37$var$G1b(0, 4, 8, 12, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(0, 4, 8, 12, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(1, 5, 9, 13, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(1, 5, 9, 13, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(2, 6, 10, 14, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(2, 6, 10, 14, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(3, 7, 11, 15, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(3, 7, 11, 15, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(0, 5, 10, 15, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(0, 5, 10, 15, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(1, 6, 11, 12, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(1, 6, 11, 12, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(2, 7, 8, 13, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(2, 7, 8, 13, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G1b(3, 4, 9, 14, msg, offset + 2 * s[j++]);
                    $3274270117ba9b37$var$G2b(3, 4, 9, 14, msg, offset + 2 * s[j++]);
                }
                this.v0l ^= $3274270117ba9b37$var$BBUF[0] ^ $3274270117ba9b37$var$BBUF[16];
                this.v0h ^= $3274270117ba9b37$var$BBUF[1] ^ $3274270117ba9b37$var$BBUF[17];
                this.v1l ^= $3274270117ba9b37$var$BBUF[2] ^ $3274270117ba9b37$var$BBUF[18];
                this.v1h ^= $3274270117ba9b37$var$BBUF[3] ^ $3274270117ba9b37$var$BBUF[19];
                this.v2l ^= $3274270117ba9b37$var$BBUF[4] ^ $3274270117ba9b37$var$BBUF[20];
                this.v2h ^= $3274270117ba9b37$var$BBUF[5] ^ $3274270117ba9b37$var$BBUF[21];
                this.v3l ^= $3274270117ba9b37$var$BBUF[6] ^ $3274270117ba9b37$var$BBUF[22];
                this.v3h ^= $3274270117ba9b37$var$BBUF[7] ^ $3274270117ba9b37$var$BBUF[23];
                this.v4l ^= $3274270117ba9b37$var$BBUF[8] ^ $3274270117ba9b37$var$BBUF[24];
                this.v4h ^= $3274270117ba9b37$var$BBUF[9] ^ $3274270117ba9b37$var$BBUF[25];
                this.v5l ^= $3274270117ba9b37$var$BBUF[10] ^ $3274270117ba9b37$var$BBUF[26];
                this.v5h ^= $3274270117ba9b37$var$BBUF[11] ^ $3274270117ba9b37$var$BBUF[27];
                this.v6l ^= $3274270117ba9b37$var$BBUF[12] ^ $3274270117ba9b37$var$BBUF[28];
                this.v6h ^= $3274270117ba9b37$var$BBUF[13] ^ $3274270117ba9b37$var$BBUF[29];
                this.v7l ^= $3274270117ba9b37$var$BBUF[14] ^ $3274270117ba9b37$var$BBUF[30];
                this.v7h ^= $3274270117ba9b37$var$BBUF[15] ^ $3274270117ba9b37$var$BBUF[31];
                $3274270117ba9b37$var$BBUF.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.buffer32.fill(0);
                this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
        }
    ]);
    return BLAKE2b;
}($6375d96e3f4396cb$exports.BLAKE);
/**
 * BLAKE2b - optimized for 64-bit platforms. JS doesn't have uint64, so it's slower than BLAKE2s.
 * @param msg - message that would be hashed
 * @param opts - dkLen, key, salt, personalization
 */ $3274270117ba9b37$exports.blake2b = (0, $84f9351876d022a0$exports.wrapConstructorWithOpts)(function(opts) {
    return new $3274270117ba9b37$var$BLAKE2b(opts);
});





var $33b0080294277266$exports = {};

var $a7gqy = parcelRequire("a7gqy");
"use strict";
var $33b0080294277266$var$__defProp = Object.defineProperty;
var $33b0080294277266$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $33b0080294277266$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $33b0080294277266$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $33b0080294277266$var$__export = function(target, all) {
    for(var name in all)$33b0080294277266$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $33b0080294277266$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$33b0080294277266$var$__hasOwnProp.call(to, key) && key !== except) $33b0080294277266$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $33b0080294277266$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $33b0080294277266$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $33b0080294277266$var$__toCommonJS = function(mod) {
    return $33b0080294277266$var$__copyProps($33b0080294277266$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $33b0080294277266$var$intent_exports = {};
$33b0080294277266$var$__export($33b0080294277266$var$intent_exports, {
    messageWithIntent: function() {
        return $33b0080294277266$var$messageWithIntent;
    }
});
$33b0080294277266$exports = $33b0080294277266$var$__toCommonJS($33b0080294277266$var$intent_exports);

function $33b0080294277266$var$messageWithIntent(scope, message) {
    return $f8d1f806bddc4e70$exports.bcs.IntentMessage($f8d1f806bddc4e70$exports.bcs.fixedArray(message.length, $f8d1f806bddc4e70$exports.bcs.u8())).serialize({
        intent: {
            scope: (0, $a7gqy._)({}, scope, true),
            version: {
                V0: true
            },
            appId: {
                Sui: true
            }
        },
        value: message
    }).toBytes();
}


function $f18ddaf76dcce603$var$bytesEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
var $f18ddaf76dcce603$var$PublicKey = /*#__PURE__*/ function() {
    function PublicKey() {
        (0, $7dKN1._)(this, PublicKey);
    }
    (0, $eW5pA._)(PublicKey, [
        {
            /**
   * Checks if two public keys are equal
   */ key: "equals",
            value: function equals(publicKey) {
                return $f18ddaf76dcce603$var$bytesEqual(this.toRawBytes(), publicKey.toRawBytes());
            }
        },
        {
            /**
   * Return the base-64 representation of the public key
   */ key: "toBase64",
            value: function toBase64() {
                return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(this.toRawBytes());
            }
        },
        {
            key: "toString",
            value: function toString() {
                throw new Error("`toString` is not implemented on public keys. Use `toBase64()` or `toRawBytes()` instead.");
            }
        },
        {
            /**
   * Return the Sui representation of the public key encoded in
   * base-64. A Sui public key is formed by the concatenation
   * of the scheme flag with the raw bytes of the public key
   */ key: "toSuiPublicKey",
            value: function toSuiPublicKey() {
                var bytes = this.toSuiBytes();
                return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(bytes);
            }
        },
        {
            key: "verifyWithIntent",
            value: function verifyWithIntent(bytes, signature, intent) {
                var intentMessage = (0, $33b0080294277266$exports.messageWithIntent)(intent, bytes);
                var digest = (0, $3274270117ba9b37$exports.blake2b)(intentMessage, {
                    dkLen: 32
                });
                return this.verify(digest, signature);
            }
        },
        {
            /**
   * Verifies that the signature is valid for for the provided PersonalMessage
   */ key: "verifyPersonalMessage",
            value: function verifyPersonalMessage(message, signature) {
                return this.verifyWithIntent($f8d1f806bddc4e70$exports.bcs.vector($f8d1f806bddc4e70$exports.bcs.u8()).serialize(message).toBytes(), signature, "PersonalMessage");
            }
        },
        {
            /**
   * Verifies that the signature is valid for for the provided Transaction
   */ key: "verifyTransaction",
            value: function verifyTransaction(transaction, signature) {
                return this.verifyWithIntent(transaction, signature, "TransactionData");
            }
        },
        {
            /**
   * Returns the bytes representation of the public key
   * prefixed with the signature scheme flag
   */ key: "toSuiBytes",
            value: function toSuiBytes() {
                var rawBytes = this.toRawBytes();
                var suiBytes = new Uint8Array(rawBytes.length + 1);
                suiBytes.set([
                    this.flag()
                ]);
                suiBytes.set(rawBytes, 1);
                return suiBytes;
            }
        },
        {
            /**
   * Return the Sui address associated with this Ed25519 public key
   */ key: "toSuiAddress",
            value: function toSuiAddress() {
                return (0, $2c4ee7908f345874$exports.normalizeSuiAddress)((0, $84f9351876d022a0$exports.bytesToHex)((0, $3274270117ba9b37$exports.blake2b)(this.toSuiBytes(), {
                    dkLen: 32
                })).slice(0, $2c4ee7908f345874$exports.SUI_ADDRESS_LENGTH * 2));
            }
        }
    ]);
    return PublicKey;
}();


var $eee0db41adbb8a07$exports = {};
"use strict";
var $eee0db41adbb8a07$var$__defProp = Object.defineProperty;
var $eee0db41adbb8a07$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $eee0db41adbb8a07$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $eee0db41adbb8a07$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $eee0db41adbb8a07$var$__export = function(target, all) {
    for(var name in all)$eee0db41adbb8a07$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $eee0db41adbb8a07$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$eee0db41adbb8a07$var$__hasOwnProp.call(to, key) && key !== except) $eee0db41adbb8a07$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $eee0db41adbb8a07$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $eee0db41adbb8a07$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $eee0db41adbb8a07$var$__toCommonJS = function(mod) {
    return $eee0db41adbb8a07$var$__copyProps($eee0db41adbb8a07$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $eee0db41adbb8a07$var$signature_scheme_exports = {};
$eee0db41adbb8a07$var$__export($eee0db41adbb8a07$var$signature_scheme_exports, {
    SIGNATURE_FLAG_TO_SCHEME: function() {
        return $eee0db41adbb8a07$var$SIGNATURE_FLAG_TO_SCHEME;
    },
    SIGNATURE_SCHEME_TO_FLAG: function() {
        return $eee0db41adbb8a07$var$SIGNATURE_SCHEME_TO_FLAG;
    },
    SIGNATURE_SCHEME_TO_SIZE: function() {
        return $eee0db41adbb8a07$var$SIGNATURE_SCHEME_TO_SIZE;
    }
});
$eee0db41adbb8a07$exports = $eee0db41adbb8a07$var$__toCommonJS($eee0db41adbb8a07$var$signature_scheme_exports);
var $eee0db41adbb8a07$var$SIGNATURE_SCHEME_TO_FLAG = {
    ED25519: 0,
    Secp256k1: 1,
    Secp256r1: 2,
    MultiSig: 3,
    ZkLogin: 5
};
var $eee0db41adbb8a07$var$SIGNATURE_SCHEME_TO_SIZE = {
    ED25519: 32,
    Secp256k1: 33,
    Secp256r1: 33
};
var $eee0db41adbb8a07$var$SIGNATURE_FLAG_TO_SCHEME = {
    0: "ED25519",
    1: "Secp256k1",
    2: "Secp256r1",
    3: "MultiSig",
    5: "ZkLogin"
};


var $d3a5a0e392964fca$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $d3a5a0e392964fca$var$__defProp = Object.defineProperty;
var $d3a5a0e392964fca$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d3a5a0e392964fca$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d3a5a0e392964fca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d3a5a0e392964fca$var$__typeError = function(msg) {
    throw TypeError(msg);
};
var $d3a5a0e392964fca$var$__export = function(target, all) {
    for(var name in all)$d3a5a0e392964fca$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d3a5a0e392964fca$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$d3a5a0e392964fca$var$__hasOwnProp.call(to, key) && key !== except) $d3a5a0e392964fca$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $d3a5a0e392964fca$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $d3a5a0e392964fca$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $d3a5a0e392964fca$var$__toCommonJS = function(mod) {
    return $d3a5a0e392964fca$var$__copyProps($d3a5a0e392964fca$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $d3a5a0e392964fca$var$__accessCheck = function(obj, member, msg) {
    return member.has(obj) || $d3a5a0e392964fca$var$__typeError("Cannot " + msg);
};
var $d3a5a0e392964fca$var$__privateGet = function(obj, member, getter) {
    return $d3a5a0e392964fca$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var $d3a5a0e392964fca$var$__privateAdd = function(obj, member, value) {
    return member.has(obj) ? $d3a5a0e392964fca$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $d3a5a0e392964fca$var$__privateSet = function(obj, member, value, setter) {
    return $d3a5a0e392964fca$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value;
};
var $d3a5a0e392964fca$var$client_exports = {};
$d3a5a0e392964fca$var$__export($d3a5a0e392964fca$var$client_exports, {
    SuiGraphQLClient: function() {
        return $d3a5a0e392964fca$var$SuiGraphQLClient;
    },
    SuiGraphQLRequestError: function() {
        return $d3a5a0e392964fca$var$SuiGraphQLRequestError;
    }
});
$d3a5a0e392964fca$exports = $d3a5a0e392964fca$var$__toCommonJS($d3a5a0e392964fca$var$client_exports);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $7de5d137739e49f5$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $7de5d137739e49f5$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $7de5d137739e49f5$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $7de5d137739e49f5$export$45a677ea7cb6d5c8(code) {
    return $7de5d137739e49f5$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $7de5d137739e49f5$export$d3f406ff46035894(code) {
    return $7de5d137739e49f5$export$79c5d5217943d6a7(code) || $7de5d137739e49f5$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $761878c1e8047d59$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    var commonIndent = Number.MAX_SAFE_INTEGER;
    var firstNonEmptyLine = null;
    var lastNonEmptyLine = -1;
    for(var i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        var line = lines[i];
        var indent = $761878c1e8047d59$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map(function(line, i) {
        return i === 0 ? line : line.slice(commonIndent);
    }) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $761878c1e8047d59$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (0, $7de5d137739e49f5$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $761878c1e8047d59$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    var isEmptyLine = true;
    var hasIndent = false;
    var hasCommonIndent = true;
    var seenNonEmptyLine = false;
    for(var i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $761878c1e8047d59$export$adb6ca997eeb1f45(value, options) {
    var escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    var lines = escapedValue.split(/\r\n|[\n\r]/g);
    var isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    var forceLeadingNewLine = lines.length > 1 && lines.slice(1).every(function(line) {
        return line.length === 0 || (0, $7de5d137739e49f5$export$3c52dd84024ae72c)(line.charCodeAt(0));
    }); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    var hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    var hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    var hasTrailingSlash = value.endsWith("\\");
    var forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    var printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    var result = ""; // Format a multi-line block quote to account for leading space.
    var skipLeadingNewLine = isSingleLine && (0, $7de5d137739e49f5$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $c5558f463966bcee$export$3cdec7cf614a0ecc(str) {
    return '"'.concat(str.replace($c5558f463966bcee$var$escapedRegExp, $c5558f463966bcee$var$escapedReplacer), '"');
} // eslint-disable-next-line no-control-regex
var $c5558f463966bcee$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $c5558f463966bcee$var$escapedReplacer(str) {
    return $c5558f463966bcee$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
var $c5558f463966bcee$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];



var $5OlIx = parcelRequire("5OlIx");
function $d449a7b491621505$export$b6cb5906f04696c8(condition, message) {
    var booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}



var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");
var $3446e2e940698c2d$var$MAX_ARRAY_LENGTH = 10;
var $3446e2e940698c2d$var$MAX_RECURSIVE_DEPTH = 2;
function $3446e2e940698c2d$export$9dec5d1b3b6a130d(value) {
    return $3446e2e940698c2d$var$formatValue(value, []);
}
function $3446e2e940698c2d$var$formatValue(value, seenValues) {
    switch(typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            return $3446e2e940698c2d$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $3446e2e940698c2d$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    var seenValues = (0, $gF0bR._)(previouslySeenValues).concat([
        value
    ]);
    if ($3446e2e940698c2d$var$isJSONable(value)) {
        var jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $3446e2e940698c2d$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $3446e2e940698c2d$var$formatArray(value, seenValues);
    return $3446e2e940698c2d$var$formatObject(value, seenValues);
}
function $3446e2e940698c2d$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $3446e2e940698c2d$var$formatObject(object, seenValues) {
    var entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $3446e2e940698c2d$var$MAX_RECURSIVE_DEPTH) return "[" + $3446e2e940698c2d$var$getObjectTag(object) + "]";
    var properties = entries.map(function(param) {
        var _param = (0, $5OlIx._)(param, 2), key = _param[0], value = _param[1];
        return key + ": " + $3446e2e940698c2d$var$formatValue(value, seenValues);
    });
    return "{ " + properties.join(", ") + " }";
}
function $3446e2e940698c2d$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $3446e2e940698c2d$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($3446e2e940698c2d$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($3446e2e940698c2d$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $3446e2e940698c2d$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ 
var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $92a11c6abdd5778c$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    "use strict";
    function Location(startToken, endToken, source) {
        (0, $7dKN1._)(this, Location);
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    (0, $eW5pA._)(Location, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Location";
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    start: this.start,
                    end: this.end
                };
            }
        }
    ]);
    return Location;
}();
var $92a11c6abdd5778c$export$50792b0e93539fde = /*#__PURE__*/ function() {
    "use strict";
    function Token(kind, start, end, line, column, value) {
        (0, $7dKN1._)(this, Token);
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    (0, $eW5pA._)(Token, [
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Token";
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind,
                    value: this.value,
                    line: this.line,
                    column: this.column
                };
            }
        }
    ]);
    return Token;
}();
var $92a11c6abdd5778c$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $92a11c6abdd5778c$var$kindValues = new Set(Object.keys($92a11c6abdd5778c$export$4fcd777a40ccf407));
function $92a11c6abdd5778c$export$8ee0fc9ee280b4ee(maybeNode) {
    var maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $92a11c6abdd5778c$var$kindValues.has(maybeKind);
}
/** Name */ var $92a11c6abdd5778c$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($92a11c6abdd5778c$export$f58c50edb4aef9d4 || ($92a11c6abdd5778c$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $5260612160fdb00c$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($5260612160fdb00c$export$a84bdc57c5122798 || ($5260612160fdb00c$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

var $14b4111c99d90e46$export$a89c95c098ac2a58 = Object.freeze({});
function $14b4111c99d90e46$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $92a11c6abdd5778c$export$4fcd777a40ccf407);
    var enterLeaveMap = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values((0, $5260612160fdb00c$export$a84bdc57c5122798))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var kind = _step.value;
            enterLeaveMap.set(kind, $14b4111c99d90e46$export$736de8489257458(visitor, kind));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = root;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    var editOffset = 0;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = edits[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value = (0, $5OlIx._)(_step1.value, 2), editKey = _step_value[0], editValue = _step_value[1];
                            var arrayKey = editKey - editOffset;
                            if (editValue === null) {
                                node.splice(arrayKey, 1);
                                editOffset++;
                            } else node[arrayKey] = editValue;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = edits[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _step_value1 = (0, $5OlIx._)(_step2.value, 2), editKey1 = _step_value1[0], editValue1 = _step_value1[1];
                            node[editKey1] = editValue1;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $92a11c6abdd5778c$export$8ee0fc9ee280b4ee)(node) || (0, $d449a7b491621505$export$b6cb5906f04696c8)(false, "Invalid AST Node: ".concat((0, $3446e2e940698c2d$export$9dec5d1b3b6a130d)(node), "."));
            var visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $14b4111c99d90e46$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $92a11c6abdd5778c$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $14b4111c99d90e46$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length).fill(null);
    var mergedVisitor = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var kind = _step.value;
            var hasVisitor = false;
            var enterList = new Array(visitors.length).fill(undefined);
            var leaveList = new Array(visitors.length).fill(undefined);
            for(var i = 0; i < visitors.length; ++i){
                var _getEnterLeaveForKind = $14b4111c99d90e46$export$736de8489257458(visitors[i], kind), enter = _getEnterLeaveForKind.enter, leave = _getEnterLeaveForKind.leave;
                hasVisitor || (hasVisitor = enter != null || leave != null);
                enterList[i] = enter;
                leaveList[i] = leave;
            }
            if (!hasVisitor) return "continue";
            var mergedEnterLeave = {
                enter: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var node = args[0];
                    for(var i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                        var _enterList$i;
                        var result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                        if (result === false) skipping[i] = node;
                        else if (result === $14b4111c99d90e46$export$a89c95c098ac2a58) skipping[i] = $14b4111c99d90e46$export$a89c95c098ac2a58;
                        else if (result !== undefined) return result;
                    }
                },
                leave: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var node = args[0];
                    for(var i = 0; i < visitors.length; i++){
                        if (skipping[i] === null) {
                            var _leaveList$i;
                            var result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                            if (result === $14b4111c99d90e46$export$a89c95c098ac2a58) skipping[i] = $14b4111c99d90e46$export$a89c95c098ac2a58;
                            else if (result !== undefined && result !== false) return result;
                        } else if (skipping[i] === node) skipping[i] = null;
                    }
                }
            };
            mergedVisitor[kind] = mergedEnterLeave;
        };
        for(var _iterator = Object.values((0, $5260612160fdb00c$export$a84bdc57c5122798))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedVisitor;
}
function $14b4111c99d90e46$export$736de8489257458(visitor, kind) {
    var kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $14b4111c99d90e46$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var _getEnterLeaveForKind = $14b4111c99d90e46$export$736de8489257458(visitor, kind), enter = _getEnterLeaveForKind.enter, leave = _getEnterLeaveForKind.leave;
    return isLeaving ? leave : enter;
}


function $d273ff594f239e2f$export$c2d084dc44961371(ast) {
    return (0, $14b4111c99d90e46$export$bf638b60ea8b89b7)(ast, $d273ff594f239e2f$var$printDocASTReducer);
}
var $d273ff594f239e2f$var$MAX_LINE_LENGTH = 80;
var $d273ff594f239e2f$var$printDocASTReducer = {
    Name: {
        leave: function(node) {
            return node.value;
        }
    },
    Variable: {
        leave: function(node) {
            return "$" + node.name;
        }
    },
    // Document
    Document: {
        leave: function(node) {
            return $d273ff594f239e2f$var$join(node.definitions, "\n\n");
        }
    },
    OperationDefinition: {
        leave: function(node) {
            var varDefs = $d273ff594f239e2f$var$wrap("(", $d273ff594f239e2f$var$join(node.variableDefinitions, ", "), ")");
            var prefix = $d273ff594f239e2f$var$join([
                node.operation,
                $d273ff594f239e2f$var$join([
                    node.name,
                    varDefs
                ]),
                $d273ff594f239e2f$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: function(param) {
            var variable = param.variable, type = param.type, defaultValue = param.defaultValue, directives = param.directives;
            return variable + ": " + type + $d273ff594f239e2f$var$wrap(" = ", defaultValue) + $d273ff594f239e2f$var$wrap(" ", $d273ff594f239e2f$var$join(directives, " "));
        }
    },
    SelectionSet: {
        leave: function(param) {
            var selections = param.selections;
            return $d273ff594f239e2f$var$block(selections);
        }
    },
    Field: {
        leave: function(param) {
            var alias = param.alias, name = param.name, args = param.arguments, directives = param.directives, selectionSet = param.selectionSet;
            var prefix = $d273ff594f239e2f$var$wrap("", alias, ": ") + name;
            var argsLine = prefix + $d273ff594f239e2f$var$wrap("(", $d273ff594f239e2f$var$join(args, ", "), ")");
            if (argsLine.length > $d273ff594f239e2f$var$MAX_LINE_LENGTH) argsLine = prefix + $d273ff594f239e2f$var$wrap("(\n", $d273ff594f239e2f$var$indent($d273ff594f239e2f$var$join(args, "\n")), "\n)");
            return $d273ff594f239e2f$var$join([
                argsLine,
                $d273ff594f239e2f$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: function(param) {
            var name = param.name, value = param.value;
            return name + ": " + value;
        }
    },
    // Fragments
    FragmentSpread: {
        leave: function(param) {
            var name = param.name, directives = param.directives;
            return "..." + name + $d273ff594f239e2f$var$wrap(" ", $d273ff594f239e2f$var$join(directives, " "));
        }
    },
    InlineFragment: {
        leave: function(param) {
            var typeCondition = param.typeCondition, directives = param.directives, selectionSet = param.selectionSet;
            return $d273ff594f239e2f$var$join([
                "...",
                $d273ff594f239e2f$var$wrap("on ", typeCondition),
                $d273ff594f239e2f$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    FragmentDefinition: {
        leave: function(param) {
            var name = param.name, typeCondition = param.typeCondition, variableDefinitions = param.variableDefinitions, directives = param.directives, selectionSet = param.selectionSet;
            return(// or removed in the future.
            "fragment ".concat(name).concat($d273ff594f239e2f$var$wrap("(", $d273ff594f239e2f$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($d273ff594f239e2f$var$wrap("", $d273ff594f239e2f$var$join(directives, " "), " ")) + selectionSet);
        }
    },
    // Value
    IntValue: {
        leave: function(param) {
            var value = param.value;
            return value;
        }
    },
    FloatValue: {
        leave: function(param) {
            var value = param.value;
            return value;
        }
    },
    StringValue: {
        leave: function(param) {
            var value = param.value, isBlockString = param.block;
            return isBlockString ? (0, $761878c1e8047d59$export$adb6ca997eeb1f45)(value) : (0, $c5558f463966bcee$export$3cdec7cf614a0ecc)(value);
        }
    },
    BooleanValue: {
        leave: function(param) {
            var value = param.value;
            return value ? "true" : "false";
        }
    },
    NullValue: {
        leave: function() {
            return "null";
        }
    },
    EnumValue: {
        leave: function(param) {
            var value = param.value;
            return value;
        }
    },
    ListValue: {
        leave: function(param) {
            var values = param.values;
            return "[" + $d273ff594f239e2f$var$join(values, ", ") + "]";
        }
    },
    ObjectValue: {
        leave: function(param) {
            var fields = param.fields;
            return "{" + $d273ff594f239e2f$var$join(fields, ", ") + "}";
        }
    },
    ObjectField: {
        leave: function(param) {
            var name = param.name, value = param.value;
            return name + ": " + value;
        }
    },
    // Directive
    Directive: {
        leave: function(param) {
            var name = param.name, args = param.arguments;
            return "@" + name + $d273ff594f239e2f$var$wrap("(", $d273ff594f239e2f$var$join(args, ", "), ")");
        }
    },
    // Type
    NamedType: {
        leave: function(param) {
            var name = param.name;
            return name;
        }
    },
    ListType: {
        leave: function(param) {
            var type = param.type;
            return "[" + type + "]";
        }
    },
    NonNullType: {
        leave: function(param) {
            var type = param.type;
            return type + "!";
        }
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: function(param) {
            var description = param.description, directives = param.directives, operationTypes = param.operationTypes;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "schema",
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(operationTypes)
            ], " ");
        }
    },
    OperationTypeDefinition: {
        leave: function(param) {
            var operation = param.operation, type = param.type;
            return operation + ": " + type;
        }
    },
    ScalarTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "scalar",
                name,
                $d273ff594f239e2f$var$join(directives, " ")
            ], " ");
        }
    },
    ObjectTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "type",
                name,
                $d273ff594f239e2f$var$wrap("implements ", $d273ff594f239e2f$var$join(interfaces, " & ")),
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(fields)
            ], " ");
        }
    },
    FieldDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, args = param.arguments, type = param.type, directives = param.directives;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + name + ($d273ff594f239e2f$var$hasMultilineItems(args) ? $d273ff594f239e2f$var$wrap("(\n", $d273ff594f239e2f$var$indent($d273ff594f239e2f$var$join(args, "\n")), "\n)") : $d273ff594f239e2f$var$wrap("(", $d273ff594f239e2f$var$join(args, ", "), ")")) + ": " + type + $d273ff594f239e2f$var$wrap(" ", $d273ff594f239e2f$var$join(directives, " "));
        }
    },
    InputValueDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, type = param.type, defaultValue = param.defaultValue, directives = param.directives;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                name + ": " + type,
                $d273ff594f239e2f$var$wrap("= ", defaultValue),
                $d273ff594f239e2f$var$join(directives, " ")
            ], " ");
        }
    },
    InterfaceTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "interface",
                name,
                $d273ff594f239e2f$var$wrap("implements ", $d273ff594f239e2f$var$join(interfaces, " & ")),
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(fields)
            ], " ");
        }
    },
    UnionTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives, types = param.types;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "union",
                name,
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$wrap("= ", $d273ff594f239e2f$var$join(types, " | "))
            ], " ");
        }
    },
    EnumTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives, values = param.values;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "enum",
                name,
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(values)
            ], " ");
        }
    },
    EnumValueDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                name,
                $d273ff594f239e2f$var$join(directives, " ")
            ], " ");
        }
    },
    InputObjectTypeDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, directives = param.directives, fields = param.fields;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + $d273ff594f239e2f$var$join([
                "input",
                name,
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(fields)
            ], " ");
        }
    },
    DirectiveDefinition: {
        leave: function(param) {
            var description = param.description, name = param.name, args = param.arguments, repeatable = param.repeatable, locations = param.locations;
            return $d273ff594f239e2f$var$wrap("", description, "\n") + "directive @" + name + ($d273ff594f239e2f$var$hasMultilineItems(args) ? $d273ff594f239e2f$var$wrap("(\n", $d273ff594f239e2f$var$indent($d273ff594f239e2f$var$join(args, "\n")), "\n)") : $d273ff594f239e2f$var$wrap("(", $d273ff594f239e2f$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $d273ff594f239e2f$var$join(locations, " | ");
        }
    },
    SchemaExtension: {
        leave: function(param) {
            var directives = param.directives, operationTypes = param.operationTypes;
            return $d273ff594f239e2f$var$join([
                "extend schema",
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(operationTypes)
            ], " ");
        }
    },
    ScalarTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives;
            return $d273ff594f239e2f$var$join([
                "extend scalar",
                name,
                $d273ff594f239e2f$var$join(directives, " ")
            ], " ");
        }
    },
    ObjectTypeExtension: {
        leave: function(param) {
            var name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $d273ff594f239e2f$var$join([
                "extend type",
                name,
                $d273ff594f239e2f$var$wrap("implements ", $d273ff594f239e2f$var$join(interfaces, " & ")),
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(fields)
            ], " ");
        }
    },
    InterfaceTypeExtension: {
        leave: function(param) {
            var name = param.name, interfaces = param.interfaces, directives = param.directives, fields = param.fields;
            return $d273ff594f239e2f$var$join([
                "extend interface",
                name,
                $d273ff594f239e2f$var$wrap("implements ", $d273ff594f239e2f$var$join(interfaces, " & ")),
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(fields)
            ], " ");
        }
    },
    UnionTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives, types = param.types;
            return $d273ff594f239e2f$var$join([
                "extend union",
                name,
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$wrap("= ", $d273ff594f239e2f$var$join(types, " | "))
            ], " ");
        }
    },
    EnumTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives, values = param.values;
            return $d273ff594f239e2f$var$join([
                "extend enum",
                name,
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(values)
            ], " ");
        }
    },
    InputObjectTypeExtension: {
        leave: function(param) {
            var name = param.name, directives = param.directives, fields = param.fields;
            return $d273ff594f239e2f$var$join([
                "extend input",
                name,
                $d273ff594f239e2f$var$join(directives, " "),
                $d273ff594f239e2f$var$block(fields)
            ], " ");
        }
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $d273ff594f239e2f$var$join(maybeArray) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $d273ff594f239e2f$var$block(array) {
    return $d273ff594f239e2f$var$wrap("{\n", $d273ff594f239e2f$var$indent($d273ff594f239e2f$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $d273ff594f239e2f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $d273ff594f239e2f$var$indent(str) {
    return $d273ff594f239e2f$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $d273ff594f239e2f$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some(function(str) {
        return str.includes("\n");
    })) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


var $d3a5a0e392964fca$var$_url, $d3a5a0e392964fca$var$_queries, $d3a5a0e392964fca$var$_headers, $d3a5a0e392964fca$var$_fetch;
var $d3a5a0e392964fca$var$SuiGraphQLRequestError = /*#__PURE__*/ function(Error1) {
    (0, $cgJ2Y._)(SuiGraphQLRequestError, Error1);
    var _super = (0, $hKD8n._)(SuiGraphQLRequestError);
    function SuiGraphQLRequestError() {
        (0, $7dKN1._)(this, SuiGraphQLRequestError);
        return _super.apply(this, arguments);
    }
    return SuiGraphQLRequestError;
}((0, $jShW9._)(Error));
var $d3a5a0e392964fca$var$SuiGraphQLClient = /*#__PURE__*/ function() {
    function SuiGraphQLClient(param) {
        var url = param.url, tmp = param.fetch, fetchFn = tmp === void 0 ? fetch : tmp, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_queries = param.queries, queries = _param_queries === void 0 ? {} : _param_queries;
        (0, $7dKN1._)(this, SuiGraphQLClient);
        $d3a5a0e392964fca$var$__privateAdd(this, $d3a5a0e392964fca$var$_url);
        $d3a5a0e392964fca$var$__privateAdd(this, $d3a5a0e392964fca$var$_queries);
        $d3a5a0e392964fca$var$__privateAdd(this, $d3a5a0e392964fca$var$_headers);
        $d3a5a0e392964fca$var$__privateAdd(this, $d3a5a0e392964fca$var$_fetch);
        $d3a5a0e392964fca$var$__privateSet(this, $d3a5a0e392964fca$var$_url, url);
        $d3a5a0e392964fca$var$__privateSet(this, $d3a5a0e392964fca$var$_queries, queries);
        $d3a5a0e392964fca$var$__privateSet(this, $d3a5a0e392964fca$var$_headers, headers);
        $d3a5a0e392964fca$var$__privateSet(this, $d3a5a0e392964fca$var$_fetch, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return fetchFn.apply(void 0, (0, $gF0bR._)(args));
        });
    }
    (0, $eW5pA._)(SuiGraphQLClient, [
        {
            key: "query",
            value: function query(options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $d3a5a0e392964fca$var$__privateGet(_this, $d3a5a0e392964fca$var$_fetch).call(_this, $d3a5a0e392964fca$var$__privateGet(_this, $d3a5a0e392964fca$var$_url), {
                                        method: "POST",
                                        headers: (0, $4JCw4._)({
                                            "Content-Type": "application/json"
                                        }, $d3a5a0e392964fca$var$__privateGet(_this, $d3a5a0e392964fca$var$_headers)),
                                        body: JSON.stringify({
                                            query: typeof options.query === "string" ? String(options.query) : (0, $d273ff594f239e2f$export$c2d084dc44961371)(options.query),
                                            variables: options.variables,
                                            extensions: options.extensions,
                                            operationName: options.operationName
                                        })
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                if (!res.ok) throw new $d3a5a0e392964fca$var$SuiGraphQLRequestError("GraphQL request failed: ".concat(res.statusText, " (").concat(res.status, ")"));
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "execute",
            value: function execute(query, options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.query((0, $gddcW._)((0, $4JCw4._)({}, options), {
                                query: $d3a5a0e392964fca$var$__privateGet(_this, $d3a5a0e392964fca$var$_queries)[query]
                            }))
                        ];
                    });
                })();
            }
        }
    ]);
    return SuiGraphQLClient;
}();
$d3a5a0e392964fca$var$_url = new WeakMap();
$d3a5a0e392964fca$var$_queries = new WeakMap();
$d3a5a0e392964fca$var$_headers = new WeakMap();
$d3a5a0e392964fca$var$_fetch = new WeakMap();


var $530620c5ce6a6423$exports = {};
"use strict";
var $530620c5ce6a6423$var$__defProp = Object.defineProperty;
var $530620c5ce6a6423$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $530620c5ce6a6423$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $530620c5ce6a6423$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $530620c5ce6a6423$var$__export = function(target, all) {
    for(var name in all)$530620c5ce6a6423$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $530620c5ce6a6423$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$530620c5ce6a6423$var$__hasOwnProp.call(to, key) && key !== except) $530620c5ce6a6423$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $530620c5ce6a6423$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $530620c5ce6a6423$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $530620c5ce6a6423$var$__reExport = function(target, mod, secondTarget) {
    return $530620c5ce6a6423$var$__copyProps(target, mod, "default"), secondTarget && $530620c5ce6a6423$var$__copyProps(secondTarget, mod, "default");
};
var $530620c5ce6a6423$var$__toCommonJS = function(mod) {
    return $530620c5ce6a6423$var$__copyProps($530620c5ce6a6423$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $530620c5ce6a6423$var$__exports = {};
$530620c5ce6a6423$var$__export($530620c5ce6a6423$var$__exports, {
    graphql: function() {
        return $530620c5ce6a6423$var$graphql;
    },
    maskFragments: function() {
        return $c682576553e0b020$export$d4a2d0b9594de4ca;
    },
    readFragment: function() {
        return $c682576553e0b020$export$f105281f156b6cc0;
    }
});
$530620c5ce6a6423$exports = $530620c5ce6a6423$var$__toCommonJS($530620c5ce6a6423$var$__exports);

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");
var $2650b814f611b4e8$export$a84bdc57c5122798 = {
    NAME: "Name",
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    DIRECTIVE: "Directive",
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType"
};
var $2650b814f611b4e8$export$f58c50edb4aef9d4 = {
    QUERY: "query",
    MUTATION: "mutation",
    SUBSCRIPTION: "subscription"
};
var $2650b814f611b4e8$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(GraphQLError, Error1);
    var _super = (0, $hKD8n._)(GraphQLError);
    function GraphQLError(e, r, i, n, a, t, l) {
        (0, $7dKN1._)(this, GraphQLError);
        var _this;
        _this = _super.call(this, e);
        _this.name = "GraphQLError";
        _this.message = e;
        if (a) _this.path = a;
        if (r) _this.nodes = Array.isArray(r) ? r : [
            r
        ];
        if (i) _this.source = i;
        if (n) _this.positions = n;
        if (t) _this.originalError = t;
        var o = l;
        if (!o && t) {
            var u = t.extensions;
            if (u && "object" == typeof u) o = u;
        }
        _this.extensions = o || {};
        return _this;
    }
    (0, $eW5pA._)(GraphQLError, [
        {
            key: "toJSON",
            value: function toJSON() {
                return (0, $gddcW._)((0, $4JCw4._)({}, this), {
                    message: this.message
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "GraphQLError";
            }
        }
    ]);
    return GraphQLError;
}((0, $jShW9._)(Error));
var $2650b814f611b4e8$var$i;
var $2650b814f611b4e8$var$n;
function $2650b814f611b4e8$var$error(e) {
    return new $2650b814f611b4e8$export$92d6ed0888e7cb7f("Syntax Error: Unexpected token at ".concat($2650b814f611b4e8$var$n, " in ").concat(e));
}
function $2650b814f611b4e8$var$advance(e) {
    e.lastIndex = $2650b814f611b4e8$var$n;
    if (e.test($2650b814f611b4e8$var$i)) return $2650b814f611b4e8$var$i.slice($2650b814f611b4e8$var$n, $2650b814f611b4e8$var$n = e.lastIndex);
}
var $2650b814f611b4e8$var$a = RegExp(" +(?=[^\\s])", "y");
function $2650b814f611b4e8$var$blockString(e) {
    var r = e.split("\n");
    var i = "";
    var n = 0;
    var t = 0;
    var l = r.length - 1;
    for(var o = 0; o < r.length; o++){
        $2650b814f611b4e8$var$a.lastIndex = 0;
        if ($2650b814f611b4e8$var$a.test(r[o])) {
            if (o && (!n || $2650b814f611b4e8$var$a.lastIndex < n)) n = $2650b814f611b4e8$var$a.lastIndex;
            t = t || o;
            l = o;
        }
    }
    for(var u = t; u <= l; u++){
        if (u !== t) i += "\n";
        i += r[u].slice(n).replace(/\\"""/g, '"""');
    }
    return i;
}
function $2650b814f611b4e8$var$ignored() {
    for(var e = 0 | $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++); 9 === e || 10 === e || 13 === e || 32 === e || 35 === e || 44 === e || 65279 === e; e = 0 | $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++))if (35 === e) {
        while(10 !== (e = $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) && 13 !== e);
    }
    $2650b814f611b4e8$var$n--;
}
var $2650b814f611b4e8$var$t = RegExp("[_A-Za-z]\\w*", "y");
var $2650b814f611b4e8$var$l = new RegExp("(?:(null|true|false)|\\$(" + $2650b814f611b4e8$var$t.source + ')|(-?\\d+)((?:\\.\\d+)?[eE][+-]?\\d+|\\.\\d+)?|("""(?:"""|(?:[\\s\\S]*?[^\\\\])"""))|("(?:"|[^\\r\\n]*?[^\\\\]"))|(' + $2650b814f611b4e8$var$t.source + "))", "y");
var $2650b814f611b4e8$var$o = function(e) {
    e[e.Const = 1] = "Const";
    e[e.Var = 2] = "Var";
    e[e.Int = 3] = "Int";
    e[e.Float = 4] = "Float";
    e[e.BlockString = 5] = "BlockString";
    e[e.String = 6] = "String";
    e[e.Enum = 7] = "Enum";
    return e;
}($2650b814f611b4e8$var$o || {});
var $2650b814f611b4e8$var$u = /\\/g;
function $2650b814f611b4e8$var$value(e) {
    var r;
    var a;
    $2650b814f611b4e8$var$l.lastIndex = $2650b814f611b4e8$var$n;
    if (91 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        var d = [];
        while(93 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n))d.push($2650b814f611b4e8$var$value(e));
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        return {
            kind: "ListValue",
            values: d
        };
    } else if (123 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        var v = [];
        while(125 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)){
            if (null == (r = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("ObjectField");
            $2650b814f611b4e8$var$ignored();
            if (58 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("ObjectField");
            $2650b814f611b4e8$var$ignored();
            v.push({
                kind: "ObjectField",
                name: {
                    kind: "Name",
                    value: r
                },
                value: $2650b814f611b4e8$var$value(e)
            });
        }
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        return {
            kind: "ObjectValue",
            fields: v
        };
    } else if (null != (a = $2650b814f611b4e8$var$l.exec($2650b814f611b4e8$var$i))) {
        $2650b814f611b4e8$var$n = $2650b814f611b4e8$var$l.lastIndex;
        $2650b814f611b4e8$var$ignored();
        if (null != (r = a[$2650b814f611b4e8$var$o.Const])) return "null" === r ? {
            kind: "NullValue"
        } : {
            kind: "BooleanValue",
            value: "true" === r
        };
        else if (null != (r = a[$2650b814f611b4e8$var$o.Var])) {
            if (e) throw $2650b814f611b4e8$var$error("Variable");
            else return {
                kind: "Variable",
                name: {
                    kind: "Name",
                    value: r
                }
            };
        } else if (null != (r = a[$2650b814f611b4e8$var$o.Int])) {
            var s;
            if (null != (s = a[$2650b814f611b4e8$var$o.Float])) return {
                kind: "FloatValue",
                value: r + s
            };
            else return {
                kind: "IntValue",
                value: r
            };
        } else if (null != (r = a[$2650b814f611b4e8$var$o.BlockString])) return {
            kind: "StringValue",
            value: $2650b814f611b4e8$var$blockString(r.slice(3, -3)),
            block: !0
        };
        else if (null != (r = a[$2650b814f611b4e8$var$o.String])) return {
            kind: "StringValue",
            value: $2650b814f611b4e8$var$u.test(r) ? JSON.parse(r) : r.slice(1, -1),
            block: !1
        };
        else if (null != (r = a[$2650b814f611b4e8$var$o.Enum])) return {
            kind: "EnumValue",
            value: r
        };
    }
    throw $2650b814f611b4e8$var$error("Value");
}
function $2650b814f611b4e8$var$arguments_(e) {
    if (40 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
        var r = [];
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        var a;
        do {
            if (null == (a = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("Argument");
            $2650b814f611b4e8$var$ignored();
            if (58 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("Argument");
            $2650b814f611b4e8$var$ignored();
            r.push({
                kind: "Argument",
                name: {
                    kind: "Name",
                    value: a
                },
                value: $2650b814f611b4e8$var$value(e)
            });
        }while (41 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n));
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        return r;
    }
}
function $2650b814f611b4e8$var$directives(e) {
    if (64 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
        var r = [];
        var a;
        do {
            $2650b814f611b4e8$var$n++;
            if (null == (a = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("Directive");
            $2650b814f611b4e8$var$ignored();
            r.push({
                kind: "Directive",
                name: {
                    kind: "Name",
                    value: a
                },
                arguments: $2650b814f611b4e8$var$arguments_(e)
            });
        }while (64 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n));
        return r;
    }
}
function $2650b814f611b4e8$var$type() {
    var e;
    var r = 0;
    while(91 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)){
        r++;
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
    }
    if (null == (e = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("NamedType");
    $2650b814f611b4e8$var$ignored();
    var a = {
        kind: "NamedType",
        name: {
            kind: "Name",
            value: e
        }
    };
    do {
        if (33 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
            $2650b814f611b4e8$var$n++;
            $2650b814f611b4e8$var$ignored();
            a = {
                kind: "NonNullType",
                type: a
            };
        }
        if (r) {
            if (93 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("NamedType");
            $2650b814f611b4e8$var$ignored();
            a = {
                kind: "ListType",
                type: a
            };
        }
    }while (r--);
    return a;
}
var $2650b814f611b4e8$var$d = new RegExp("(?:(\\.{3})|(" + $2650b814f611b4e8$var$t.source + "))", "y");
var $2650b814f611b4e8$var$v = function(e) {
    e[e.Spread = 1] = "Spread";
    e[e.Name = 2] = "Name";
    return e;
}($2650b814f611b4e8$var$v || {});
function $2650b814f611b4e8$var$selectionSet() {
    var e = [];
    var r;
    var a;
    do {
        $2650b814f611b4e8$var$d.lastIndex = $2650b814f611b4e8$var$n;
        if (null != (a = $2650b814f611b4e8$var$d.exec($2650b814f611b4e8$var$i))) {
            $2650b814f611b4e8$var$n = $2650b814f611b4e8$var$d.lastIndex;
            if (null != a[$2650b814f611b4e8$var$v.Spread]) {
                $2650b814f611b4e8$var$ignored();
                var l = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t);
                if (null != l && "on" !== l) {
                    $2650b814f611b4e8$var$ignored();
                    e.push({
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: l
                        },
                        directives: $2650b814f611b4e8$var$directives(!1)
                    });
                } else {
                    $2650b814f611b4e8$var$ignored();
                    if ("on" === l) {
                        if (null == (l = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("NamedType");
                        $2650b814f611b4e8$var$ignored();
                    }
                    var o = $2650b814f611b4e8$var$directives(!1);
                    if (123 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("InlineFragment");
                    $2650b814f611b4e8$var$ignored();
                    e.push({
                        kind: "InlineFragment",
                        typeCondition: l ? {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: l
                            }
                        } : void 0,
                        directives: o,
                        selectionSet: $2650b814f611b4e8$var$selectionSet()
                    });
                }
            } else if (null != (r = a[$2650b814f611b4e8$var$v.Name])) {
                var u = void 0;
                $2650b814f611b4e8$var$ignored();
                if (58 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
                    $2650b814f611b4e8$var$n++;
                    $2650b814f611b4e8$var$ignored();
                    u = r;
                    if (null == (r = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("Field");
                    $2650b814f611b4e8$var$ignored();
                }
                var s = $2650b814f611b4e8$var$arguments_(!1);
                $2650b814f611b4e8$var$ignored();
                var c = $2650b814f611b4e8$var$directives(!1);
                var f = void 0;
                if (123 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
                    $2650b814f611b4e8$var$n++;
                    $2650b814f611b4e8$var$ignored();
                    f = $2650b814f611b4e8$var$selectionSet();
                }
                e.push({
                    kind: "Field",
                    alias: u ? {
                        kind: "Name",
                        value: u
                    } : void 0,
                    name: {
                        kind: "Name",
                        value: r
                    },
                    arguments: s,
                    directives: c,
                    selectionSet: f
                });
            }
        } else throw $2650b814f611b4e8$var$error("SelectionSet");
    }while (125 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n));
    $2650b814f611b4e8$var$n++;
    $2650b814f611b4e8$var$ignored();
    return {
        kind: "SelectionSet",
        selections: e
    };
}
function $2650b814f611b4e8$var$fragmentDefinition() {
    var e;
    var r;
    if (null == (e = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("FragmentDefinition");
    $2650b814f611b4e8$var$ignored();
    if ("on" !== $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t)) throw $2650b814f611b4e8$var$error("FragmentDefinition");
    $2650b814f611b4e8$var$ignored();
    if (null == (r = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("FragmentDefinition");
    $2650b814f611b4e8$var$ignored();
    var a = $2650b814f611b4e8$var$directives(!1);
    if (123 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("FragmentDefinition");
    $2650b814f611b4e8$var$ignored();
    return {
        kind: "FragmentDefinition",
        name: {
            kind: "Name",
            value: e
        },
        typeCondition: {
            kind: "NamedType",
            name: {
                kind: "Name",
                value: r
            }
        },
        directives: a,
        selectionSet: $2650b814f611b4e8$var$selectionSet()
    };
}
var $2650b814f611b4e8$var$s = RegExp("(?:query|mutation|subscription|fragment)", "y");
function $2650b814f611b4e8$var$operationDefinition(e) {
    var r;
    var a;
    var l;
    if (e) {
        $2650b814f611b4e8$var$ignored();
        r = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t);
        a = function variableDefinitions() {
            $2650b814f611b4e8$var$ignored();
            if (40 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
                var _$e = [];
                $2650b814f611b4e8$var$n++;
                $2650b814f611b4e8$var$ignored();
                var r;
                do {
                    if (36 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("Variable");
                    if (null == (r = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$t))) throw $2650b814f611b4e8$var$error("Variable");
                    $2650b814f611b4e8$var$ignored();
                    if (58 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n++)) throw $2650b814f611b4e8$var$error("VariableDefinition");
                    $2650b814f611b4e8$var$ignored();
                    var a = $2650b814f611b4e8$var$type();
                    var l = void 0;
                    if (61 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
                        $2650b814f611b4e8$var$n++;
                        $2650b814f611b4e8$var$ignored();
                        l = $2650b814f611b4e8$var$value(!0);
                    }
                    $2650b814f611b4e8$var$ignored();
                    _$e.push({
                        kind: "VariableDefinition",
                        variable: {
                            kind: "Variable",
                            name: {
                                kind: "Name",
                                value: r
                            }
                        },
                        type: a,
                        defaultValue: l,
                        directives: $2650b814f611b4e8$var$directives(!0)
                    });
                }while (41 !== $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n));
                $2650b814f611b4e8$var$n++;
                $2650b814f611b4e8$var$ignored();
                return _$e;
            }
        }();
        l = $2650b814f611b4e8$var$directives(!1);
    }
    if (123 === $2650b814f611b4e8$var$i.charCodeAt($2650b814f611b4e8$var$n)) {
        $2650b814f611b4e8$var$n++;
        $2650b814f611b4e8$var$ignored();
        return {
            kind: "OperationDefinition",
            operation: e || "query",
            name: r ? {
                kind: "Name",
                value: r
            } : void 0,
            variableDefinitions: a,
            directives: l,
            selectionSet: $2650b814f611b4e8$var$selectionSet()
        };
    }
}
function $2650b814f611b4e8$export$98e6a39c04603d36(e, r) {
    $2650b814f611b4e8$var$i = "string" == typeof e.body ? e.body : e;
    $2650b814f611b4e8$var$n = 0;
    return function document() {
        var _$e;
        var r;
        $2650b814f611b4e8$var$ignored();
        var a = [];
        do {
            if ("fragment" === (_$e = $2650b814f611b4e8$var$advance($2650b814f611b4e8$var$s))) {
                $2650b814f611b4e8$var$ignored();
                a.push($2650b814f611b4e8$var$fragmentDefinition());
            } else if (null != (r = $2650b814f611b4e8$var$operationDefinition(_$e))) a.push(r);
            else throw $2650b814f611b4e8$var$error("Document");
        }while ($2650b814f611b4e8$var$n < $2650b814f611b4e8$var$i.length);
        return {
            kind: "Document",
            definitions: a
        };
    }();
}
function $2650b814f611b4e8$export$5303528d1070ff6f(e, r) {
    $2650b814f611b4e8$var$i = "string" == typeof e.body ? e.body : e;
    $2650b814f611b4e8$var$n = 0;
    $2650b814f611b4e8$var$ignored();
    return $2650b814f611b4e8$var$value(!1);
}
function $2650b814f611b4e8$export$28b8f402ccc88182(e, r) {
    $2650b814f611b4e8$var$i = "string" == typeof e.body ? e.body : e;
    $2650b814f611b4e8$var$n = 0;
    return $2650b814f611b4e8$var$type();
}
var $2650b814f611b4e8$export$a89c95c098ac2a58 = {};
function $2650b814f611b4e8$export$bf638b60ea8b89b7(e, r) {
    var i = [];
    var n = [];
    try {
        var a = function traverse(e, a, t) {
            var l = !1;
            var o = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
            var u = o && o.call(r, e, a, t, n, i);
            if (!1 === u) return e;
            else if (null === u) return null;
            else if (u === $2650b814f611b4e8$export$a89c95c098ac2a58) throw $2650b814f611b4e8$export$a89c95c098ac2a58;
            else if (u && "string" == typeof u.kind) {
                l = u !== e;
                e = u;
            }
            if (t) i.push(t);
            var d;
            var v = (0, $4JCw4._)({}, e);
            for(var s in e){
                n.push(s);
                var f = e[s];
                if (Array.isArray(f)) {
                    var m = [];
                    for(var g = 0; g < f.length; g++)if (null != f[g] && "string" == typeof f[g].kind) {
                        i.push(e);
                        n.push(g);
                        d = traverse(f[g], g, f);
                        n.pop();
                        i.pop();
                        if (null == d) l = !0;
                        else {
                            l = l || d !== f[g];
                            m.push(d);
                        }
                    }
                    f = m;
                } else if (null != f && "string" == typeof f.kind) {
                    if (void 0 !== (d = traverse(f, s, e))) {
                        l = l || f !== d;
                        f = d;
                    }
                }
                n.pop();
                if (l) v[s] = f;
            }
            if (t) i.pop();
            var p = r[e.kind] && r[e.kind].leave || r.leave;
            var h = p && p.call(r, e, a, t, n, i);
            if (h === $2650b814f611b4e8$export$a89c95c098ac2a58) throw $2650b814f611b4e8$export$a89c95c098ac2a58;
            else if (void 0 !== h) return h;
            else if (void 0 !== u) return l ? v : u;
            else return l ? v : e;
        }(e);
        return void 0 !== a && !1 !== a ? a : e;
    } catch (r) {
        if (r !== $2650b814f611b4e8$export$a89c95c098ac2a58) throw r;
        return e;
    }
}
function $2650b814f611b4e8$var$mapJoin(e, r, i) {
    var n = "";
    for(var a = 0; a < e.length; a++){
        if (a) n += r;
        n += i(e[a]);
    }
    return n;
}
function $2650b814f611b4e8$export$3cdec7cf614a0ecc(e) {
    return JSON.stringify(e);
}
function $2650b814f611b4e8$export$adb6ca997eeb1f45(e) {
    return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}
var $2650b814f611b4e8$var$f = "\n";
var $2650b814f611b4e8$var$m = {
    OperationDefinition: function(e) {
        var r = e.operation;
        if (e.name) r += " " + e.name.value;
        if (e.variableDefinitions && e.variableDefinitions.length) {
            if (!e.name) r += " ";
            r += "(" + $2650b814f611b4e8$var$mapJoin(e.variableDefinitions, ", ", $2650b814f611b4e8$var$m.VariableDefinition) + ")";
        }
        if (e.directives && e.directives.length) r += " " + $2650b814f611b4e8$var$mapJoin(e.directives, " ", $2650b814f611b4e8$var$m.Directive);
        return "query" !== r ? r + " " + $2650b814f611b4e8$var$m.SelectionSet(e.selectionSet) : $2650b814f611b4e8$var$m.SelectionSet(e.selectionSet);
    },
    VariableDefinition: function(e) {
        var r = $2650b814f611b4e8$var$m.Variable(e.variable) + ": " + $2650b814f611b4e8$var$_print(e.type);
        if (e.defaultValue) r += " = " + $2650b814f611b4e8$var$_print(e.defaultValue);
        if (e.directives && e.directives.length) r += " " + $2650b814f611b4e8$var$mapJoin(e.directives, " ", $2650b814f611b4e8$var$m.Directive);
        return r;
    },
    Field: function(e) {
        var r = e.alias ? e.alias.value + ": " + e.name.value : e.name.value;
        if (e.arguments && e.arguments.length) {
            var i = $2650b814f611b4e8$var$mapJoin(e.arguments, ", ", $2650b814f611b4e8$var$m.Argument);
            if (r.length + i.length + 2 > 80) r += "(" + ($2650b814f611b4e8$var$f += "  ") + $2650b814f611b4e8$var$mapJoin(e.arguments, $2650b814f611b4e8$var$f, $2650b814f611b4e8$var$m.Argument) + ($2650b814f611b4e8$var$f = $2650b814f611b4e8$var$f.slice(0, -2)) + ")";
            else r += "(" + i + ")";
        }
        if (e.directives && e.directives.length) r += " " + $2650b814f611b4e8$var$mapJoin(e.directives, " ", $2650b814f611b4e8$var$m.Directive);
        if (e.selectionSet) r += " " + $2650b814f611b4e8$var$m.SelectionSet(e.selectionSet);
        return r;
    },
    StringValue: function(e) {
        if (e.block) return $2650b814f611b4e8$export$adb6ca997eeb1f45(e.value).replace(/\n/g, $2650b814f611b4e8$var$f);
        else return $2650b814f611b4e8$export$3cdec7cf614a0ecc(e.value);
    },
    BooleanValue: function(e) {
        return "" + e.value;
    },
    NullValue: function(e) {
        return "null";
    },
    IntValue: function(e) {
        return e.value;
    },
    FloatValue: function(e) {
        return e.value;
    },
    EnumValue: function(e) {
        return e.value;
    },
    Name: function(e) {
        return e.value;
    },
    Variable: function(e) {
        return "$" + e.name.value;
    },
    ListValue: function(e) {
        return "[" + $2650b814f611b4e8$var$mapJoin(e.values, ", ", $2650b814f611b4e8$var$_print) + "]";
    },
    ObjectValue: function(e) {
        return "{" + $2650b814f611b4e8$var$mapJoin(e.fields, ", ", $2650b814f611b4e8$var$m.ObjectField) + "}";
    },
    ObjectField: function(e) {
        return e.name.value + ": " + $2650b814f611b4e8$var$_print(e.value);
    },
    Document: function(e) {
        if (!e.definitions || !e.definitions.length) return "";
        return $2650b814f611b4e8$var$mapJoin(e.definitions, "\n\n", $2650b814f611b4e8$var$_print);
    },
    SelectionSet: function(e) {
        return "{" + ($2650b814f611b4e8$var$f += "  ") + $2650b814f611b4e8$var$mapJoin(e.selections, $2650b814f611b4e8$var$f, $2650b814f611b4e8$var$_print) + ($2650b814f611b4e8$var$f = $2650b814f611b4e8$var$f.slice(0, -2)) + "}";
    },
    Argument: function(e) {
        return e.name.value + ": " + $2650b814f611b4e8$var$_print(e.value);
    },
    FragmentSpread: function(e) {
        var r = "..." + e.name.value;
        if (e.directives && e.directives.length) r += " " + $2650b814f611b4e8$var$mapJoin(e.directives, " ", $2650b814f611b4e8$var$m.Directive);
        return r;
    },
    InlineFragment: function(e) {
        var r = "...";
        if (e.typeCondition) r += " on " + e.typeCondition.name.value;
        if (e.directives && e.directives.length) r += " " + $2650b814f611b4e8$var$mapJoin(e.directives, " ", $2650b814f611b4e8$var$m.Directive);
        return r += " " + $2650b814f611b4e8$var$m.SelectionSet(e.selectionSet);
    },
    FragmentDefinition: function(e) {
        var r = "fragment " + e.name.value;
        r += " on " + e.typeCondition.name.value;
        if (e.directives && e.directives.length) r += " " + $2650b814f611b4e8$var$mapJoin(e.directives, " ", $2650b814f611b4e8$var$m.Directive);
        return r + " " + $2650b814f611b4e8$var$m.SelectionSet(e.selectionSet);
    },
    Directive: function(e) {
        var r = "@" + e.name.value;
        if (e.arguments && e.arguments.length) r += "(" + $2650b814f611b4e8$var$mapJoin(e.arguments, ", ", $2650b814f611b4e8$var$m.Argument) + ")";
        return r;
    },
    NamedType: function(e) {
        return e.name.value;
    },
    ListType: function(e) {
        return "[" + $2650b814f611b4e8$var$_print(e.type) + "]";
    },
    NonNullType: function(e) {
        return $2650b814f611b4e8$var$_print(e.type) + "!";
    }
};
var $2650b814f611b4e8$var$_print = function(e) {
    return $2650b814f611b4e8$var$m[e.kind](e);
};
function $2650b814f611b4e8$export$c2d084dc44961371(e) {
    $2650b814f611b4e8$var$f = "\n";
    return $2650b814f611b4e8$var$m[e.kind] ? $2650b814f611b4e8$var$m[e.kind](e) : "";
}
function $2650b814f611b4e8$export$448e0963aec9442f(e, r) {
    switch(e.kind){
        case "NullValue":
            return null;
        case "IntValue":
            return parseInt(e.value, 10);
        case "FloatValue":
            return parseFloat(e.value);
        case "StringValue":
        case "EnumValue":
        case "BooleanValue":
            return e.value;
        case "ListValue":
            var i = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    i.push($2650b814f611b4e8$export$448e0963aec9442f(n, r));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return i;
        case "ObjectValue":
            var a = Object.create(null);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = e.fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var t = _step1.value;
                    a[t.name.value] = $2650b814f611b4e8$export$448e0963aec9442f(t.value, r);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return a;
        case "Variable":
            return r && r[e.name.value];
    }
}
function $2650b814f611b4e8$export$d7c3f1876e7bc864(e, r, i) {
    if ("Variable" === e.kind) return i ? $2650b814f611b4e8$export$d7c3f1876e7bc864(i[e.name.value], r, i) : void 0;
    else if ("NonNullType" === r.kind) return "NullValue" !== e.kind ? $2650b814f611b4e8$export$d7c3f1876e7bc864(e, r, i) : void 0;
    else if ("NullValue" === e.kind) return null;
    else if ("ListType" === r.kind) {
        if ("ListValue" === e.kind) {
            var n = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var a = _step.value;
                    var t = $2650b814f611b4e8$export$d7c3f1876e7bc864(a, r.type, i);
                    if (void 0 === t) return;
                    else n.push(t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return n;
        }
    } else if ("NamedType" === r.kind) switch(r.name.value){
        case "Int":
        case "Float":
        case "String":
        case "Bool":
            return r.name.value + "Value" === e.kind ? $2650b814f611b4e8$export$448e0963aec9442f(e, i) : void 0;
        default:
            return $2650b814f611b4e8$export$448e0963aec9442f(e, i);
    }
}


function $c682576553e0b020$export$421a65ee623ceca2() {
    function graphql(e, i) {
        var a = (0, $2650b814f611b4e8$export$98e6a39c04603d36)(e).definitions;
        var t = new Set;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (i || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = s.definitions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var d = _step1.value;
                        if (d.kind === (0, $2650b814f611b4e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION && !t.has(d)) {
                            a.push(d);
                            t.add(d);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (a[0].kind === (0, $2650b814f611b4e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION && a[0].directives) a[0].directives = a[0].directives.filter(function(n) {
            return "_unmask" !== n.name.value;
        });
        return {
            kind: (0, $2650b814f611b4e8$export$a84bdc57c5122798).DOCUMENT,
            definitions: a
        };
    }
    graphql.scalar = function scalar(n, r) {
        return r;
    };
    graphql.persisted = function persisted(r, e) {
        return {
            kind: (0, $2650b814f611b4e8$export$a84bdc57c5122798).DOCUMENT,
            definitions: e ? e.definitions : [],
            documentId: r
        };
    };
    return graphql;
}
function $c682576553e0b020$export$98e6a39c04603d36(n) {
    return (0, $2650b814f611b4e8$export$98e6a39c04603d36)(n);
}
function $c682576553e0b020$export$f105281f156b6cc0() {
    for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
        n[_key] = arguments[_key];
    }
    return 2 === n.length ? n[1] : n[0];
}
function $c682576553e0b020$export$d4a2d0b9594de4ca(n, r) {
    return r;
}
function $c682576553e0b020$export$2c5c6911a07498d4(n, r) {
    return r;
}
var $c682576553e0b020$export$1eb4e7c0ed67b035 = $c682576553e0b020$export$421a65ee623ceca2();



$530620c5ce6a6423$var$__reExport($530620c5ce6a6423$var$__exports, (parcelRequire("hSLu6")), $530620c5ce6a6423$exports);

var $530620c5ce6a6423$var$graphql = (0, $c682576553e0b020$export$421a65ee623ceca2)();


var $a5fee237d75e042f$exports = {};

var $5OlIx = parcelRequire("5OlIx");
"use strict";
var $a5fee237d75e042f$var$__defProp = Object.defineProperty;
var $a5fee237d75e042f$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a5fee237d75e042f$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a5fee237d75e042f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a5fee237d75e042f$var$__export = function(target, all) {
    for(var name in all)$a5fee237d75e042f$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $a5fee237d75e042f$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$a5fee237d75e042f$var$__hasOwnProp.call(to, key) && key !== except) $a5fee237d75e042f$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $a5fee237d75e042f$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $a5fee237d75e042f$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $a5fee237d75e042f$var$__toCommonJS = function(mod) {
    return $a5fee237d75e042f$var$__copyProps($a5fee237d75e042f$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $a5fee237d75e042f$var$jwt_utils_exports = {};
$a5fee237d75e042f$var$__export($a5fee237d75e042f$var$jwt_utils_exports, {
    extractClaimValue: function() {
        return $a5fee237d75e042f$var$extractClaimValue;
    }
});
$a5fee237d75e042f$exports = $a5fee237d75e042f$var$__toCommonJS($a5fee237d75e042f$var$jwt_utils_exports);
function $a5fee237d75e042f$var$base64UrlCharTo6Bits(base64UrlChar) {
    if (base64UrlChar.length !== 1) throw new Error("Invalid base64Url character: " + base64UrlChar);
    var base64UrlCharacterSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
    var index = base64UrlCharacterSet.indexOf(base64UrlChar);
    if (index === -1) throw new Error("Invalid base64Url character: " + base64UrlChar);
    var binaryString = index.toString(2).padStart(6, "0");
    var bits = Array.from(binaryString).map(Number);
    return bits;
}
function $a5fee237d75e042f$var$base64UrlStringToBitVector(base64UrlString) {
    var bitVector = [];
    for(var i = 0; i < base64UrlString.length; i++){
        var base64UrlChar = base64UrlString.charAt(i);
        var bits = $a5fee237d75e042f$var$base64UrlCharTo6Bits(base64UrlChar);
        bitVector = bitVector.concat(bits);
    }
    return bitVector;
}
function $a5fee237d75e042f$var$decodeBase64URL(s, i) {
    if (s.length < 2) throw new Error("Input (s = ".concat(s, ") is not tightly packed because s.length < 2"));
    var bits = $a5fee237d75e042f$var$base64UrlStringToBitVector(s);
    var firstCharOffset = i % 4;
    if (firstCharOffset === 0) ;
    else if (firstCharOffset === 1) bits = bits.slice(2);
    else if (firstCharOffset === 2) bits = bits.slice(4);
    else throw new Error("Input (s = ".concat(s, ") is not tightly packed because i%4 = 3 (i = ").concat(i, "))"));
    var lastCharOffset = (i + s.length - 1) % 4;
    if (lastCharOffset === 3) ;
    else if (lastCharOffset === 2) bits = bits.slice(0, bits.length - 2);
    else if (lastCharOffset === 1) bits = bits.slice(0, bits.length - 4);
    else throw new Error("Input (s = ".concat(s, ") is not tightly packed because (i + s.length - 1)%4 = 0 (i = ").concat(i, "))"));
    if (bits.length % 8 !== 0) throw new Error("We should never reach here...");
    var bytes = new Uint8Array(Math.floor(bits.length / 8));
    var currentByteIndex = 0;
    for(var i2 = 0; i2 < bits.length; i2 += 8){
        var bitChunk = bits.slice(i2, i2 + 8);
        var byte = parseInt(bitChunk.join(""), 2);
        bytes[currentByteIndex++] = byte;
    }
    return new TextDecoder().decode(bytes);
}
function $a5fee237d75e042f$var$verifyExtendedClaim(claim) {
    if (!(claim.slice(-1) === "}" || claim.slice(-1) === ",")) throw new Error("Invalid claim");
    var json = JSON.parse("{" + claim.slice(0, -1) + "}");
    if (Object.keys(json).length !== 1) throw new Error("Invalid claim");
    var key = Object.keys(json)[0];
    return [
        key,
        json[key]
    ];
}
function $a5fee237d75e042f$var$extractClaimValue(claim, claimName) {
    var extendedClaim = $a5fee237d75e042f$var$decodeBase64URL(claim.value, claim.indexMod4);
    var _verifyExtendedClaim = (0, $5OlIx._)($a5fee237d75e042f$var$verifyExtendedClaim(extendedClaim), 2), name = _verifyExtendedClaim[0], value = _verifyExtendedClaim[1];
    if (name !== claimName) throw new Error("Invalid field name: found ".concat(name, " expected ").concat(claimName));
    return value;
}


var $de838e9f9a1aa56f$exports = {};
"use strict";
var $de838e9f9a1aa56f$var$__defProp = Object.defineProperty;
var $de838e9f9a1aa56f$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $de838e9f9a1aa56f$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $de838e9f9a1aa56f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $de838e9f9a1aa56f$var$__export = function(target, all) {
    for(var name in all)$de838e9f9a1aa56f$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $de838e9f9a1aa56f$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$de838e9f9a1aa56f$var$__hasOwnProp.call(to, key) && key !== except) $de838e9f9a1aa56f$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $de838e9f9a1aa56f$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $de838e9f9a1aa56f$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $de838e9f9a1aa56f$var$__toCommonJS = function(mod) {
    return $de838e9f9a1aa56f$var$__copyProps($de838e9f9a1aa56f$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $de838e9f9a1aa56f$var$signature_exports = {};
$de838e9f9a1aa56f$var$__export($de838e9f9a1aa56f$var$signature_exports, {
    getZkLoginSignature: function() {
        return $de838e9f9a1aa56f$var$getZkLoginSignature;
    },
    parseZkLoginSignature: function() {
        return $de838e9f9a1aa56f$var$parseZkLoginSignature;
    }
});
$de838e9f9a1aa56f$exports = $de838e9f9a1aa56f$var$__toCommonJS($de838e9f9a1aa56f$var$signature_exports);


var $b2df6bf1ccb93890$exports = {};
"use strict";
var $b2df6bf1ccb93890$var$__defProp = Object.defineProperty;
var $b2df6bf1ccb93890$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $b2df6bf1ccb93890$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $b2df6bf1ccb93890$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b2df6bf1ccb93890$var$__export = function(target, all) {
    for(var name in all)$b2df6bf1ccb93890$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $b2df6bf1ccb93890$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$b2df6bf1ccb93890$var$__hasOwnProp.call(to, key) && key !== except) $b2df6bf1ccb93890$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $b2df6bf1ccb93890$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $b2df6bf1ccb93890$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $b2df6bf1ccb93890$var$__toCommonJS = function(mod) {
    return $b2df6bf1ccb93890$var$__copyProps($b2df6bf1ccb93890$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $b2df6bf1ccb93890$var$bcs_exports = {};
$b2df6bf1ccb93890$var$__export($b2df6bf1ccb93890$var$bcs_exports, {
    zkLoginSignature: function() {
        return $b2df6bf1ccb93890$var$zkLoginSignature;
    }
});
$b2df6bf1ccb93890$exports = $b2df6bf1ccb93890$var$__toCommonJS($b2df6bf1ccb93890$var$bcs_exports);

var $b2df6bf1ccb93890$var$zkLoginSignature = $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ZkLoginSignature", {
    inputs: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ZkLoginSignatureInputs", {
        proofPoints: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ZkLoginSignatureInputsProofPoints", {
            a: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.string()),
            b: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.string())),
            c: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.string())
        }),
        issBase64Details: $634b23529fb8a913$export$9faca4e3b5a9912b.struct("ZkLoginSignatureInputsClaim", {
            value: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
            indexMod4: $634b23529fb8a913$export$9faca4e3b5a9912b.u8()
        }),
        headerBase64: $634b23529fb8a913$export$9faca4e3b5a9912b.string(),
        addressSeed: $634b23529fb8a913$export$9faca4e3b5a9912b.string()
    }),
    maxEpoch: $634b23529fb8a913$export$9faca4e3b5a9912b.u64(),
    userSignature: $634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8())
});


function $de838e9f9a1aa56f$var$getZkLoginSignatureBytes(param) {
    var inputs = param.inputs, maxEpoch = param.maxEpoch, userSignature = param.userSignature;
    return $b2df6bf1ccb93890$exports.zkLoginSignature.serialize({
        inputs: inputs,
        maxEpoch: maxEpoch,
        userSignature: typeof userSignature === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(userSignature) : userSignature
    }, {
        maxSize: 2048
    }).toBytes();
}
function $de838e9f9a1aa56f$var$getZkLoginSignature(param) {
    var inputs = param.inputs, maxEpoch = param.maxEpoch, userSignature = param.userSignature;
    var bytes = $de838e9f9a1aa56f$var$getZkLoginSignatureBytes({
        inputs: inputs,
        maxEpoch: maxEpoch,
        userSignature: userSignature
    });
    var signatureBytes = new Uint8Array(bytes.length + 1);
    signatureBytes.set([
        $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG.ZkLogin
    ]);
    signatureBytes.set(bytes, 1);
    return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(signatureBytes);
}
function $de838e9f9a1aa56f$var$parseZkLoginSignature(signature) {
    return $b2df6bf1ccb93890$exports.zkLoginSignature.parse(typeof signature === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(signature) : signature);
}


var $d1b3ef3803576e71$exports = {};
"use strict";
var $d1b3ef3803576e71$var$__defProp = Object.defineProperty;
var $d1b3ef3803576e71$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d1b3ef3803576e71$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d1b3ef3803576e71$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d1b3ef3803576e71$var$__export = function(target, all) {
    for(var name in all)$d1b3ef3803576e71$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d1b3ef3803576e71$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$d1b3ef3803576e71$var$__hasOwnProp.call(to, key) && key !== except) $d1b3ef3803576e71$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $d1b3ef3803576e71$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $d1b3ef3803576e71$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $d1b3ef3803576e71$var$__toCommonJS = function(mod) {
    return $d1b3ef3803576e71$var$__copyProps($d1b3ef3803576e71$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $d1b3ef3803576e71$var$utils_exports = {};
$d1b3ef3803576e71$var$__export($d1b3ef3803576e71$var$utils_exports, {
    toBigEndianBytes: function() {
        return $d1b3ef3803576e71$var$toBigEndianBytes;
    },
    toPaddedBigEndianBytes: function() {
        return $d1b3ef3803576e71$var$toPaddedBigEndianBytes;
    }
});
$d1b3ef3803576e71$exports = $d1b3ef3803576e71$var$__toCommonJS($d1b3ef3803576e71$var$utils_exports);

function $d1b3ef3803576e71$var$findFirstNonZeroIndex(bytes) {
    for(var i = 0; i < bytes.length; i++){
        if (bytes[i] !== 0) return i;
    }
    return -1;
}
function $d1b3ef3803576e71$var$toPaddedBigEndianBytes(num, width) {
    var hex = num.toString(16);
    return (0, $84f9351876d022a0$exports.hexToBytes)(hex.padStart(width * 2, "0").slice(-width * 2));
}
function $d1b3ef3803576e71$var$toBigEndianBytes(num, width) {
    var bytes = $d1b3ef3803576e71$var$toPaddedBigEndianBytes(num, width);
    var firstNonZeroIndex = $d1b3ef3803576e71$var$findFirstNonZeroIndex(bytes);
    if (firstNonZeroIndex === -1) return new Uint8Array([
        0
    ]);
    return bytes.slice(firstNonZeroIndex);
}


var $33d626209c61d8cf$var$_data, $33d626209c61d8cf$var$_client;
var $33d626209c61d8cf$var$_ZkLoginPublicIdentifier = /*#__PURE__*/ function(_import_publickey_PublicKey) {
    (0, $cgJ2Y._)(_ZkLoginPublicIdentifier, _import_publickey_PublicKey);
    var _super = (0, $hKD8n._)(_ZkLoginPublicIdentifier);
    function _ZkLoginPublicIdentifier(value) {
        var client = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).client;
        (0, $7dKN1._)(this, _ZkLoginPublicIdentifier);
        var _this;
        _this = _super.call(this);
        $33d626209c61d8cf$var$__privateAdd((0, $b9zO9._)(_this), $33d626209c61d8cf$var$_data);
        $33d626209c61d8cf$var$__privateAdd((0, $b9zO9._)(_this), $33d626209c61d8cf$var$_client);
        $33d626209c61d8cf$var$__privateSet((0, $b9zO9._)(_this), $33d626209c61d8cf$var$_client, client);
        if (typeof value === "string") $33d626209c61d8cf$var$__privateSet((0, $b9zO9._)(_this), $33d626209c61d8cf$var$_data, (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(value));
        else if (value instanceof Uint8Array) $33d626209c61d8cf$var$__privateSet((0, $b9zO9._)(_this), $33d626209c61d8cf$var$_data, value);
        else $33d626209c61d8cf$var$__privateSet((0, $b9zO9._)(_this), $33d626209c61d8cf$var$_data, Uint8Array.from(value));
        return _this;
    }
    (0, $eW5pA._)(_ZkLoginPublicIdentifier, [
        {
            /**
   * Checks if two zkLogin public identifiers are equal
   */ key: "equals",
            value: function equals(publicKey) {
                return (0, $2Nfql._)((0, $fG73q._)(_ZkLoginPublicIdentifier.prototype), "equals", this).call(this, publicKey);
            }
        },
        {
            /**
   * Return the byte array representation of the zkLogin public identifier
   */ key: "toRawBytes",
            value: function toRawBytes() {
                return $33d626209c61d8cf$var$__privateGet(this, $33d626209c61d8cf$var$_data);
            }
        },
        {
            /**
   * Return the Sui address associated with this ZkLogin public identifier
   */ key: "flag",
            value: function flag() {
                return $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG["ZkLogin"];
            }
        },
        {
            key: "verify",
            value: /**
   * Verifies that the signature is valid for for the provided message
   */ function verify(_message, _signature) {
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        throw Error("does not support");
                    });
                })();
            }
        },
        {
            /**
   * Verifies that the signature is valid for for the provided PersonalMessage
   */ key: "verifyPersonalMessage",
            value: function verifyPersonalMessage(message, signature) {
                var parsedSignature = $33d626209c61d8cf$var$parseSerializedZkLoginSignature(signature);
                var address = new _ZkLoginPublicIdentifier(parsedSignature.publicKey).toSuiAddress();
                return $33d626209c61d8cf$var$graphqlVerifyZkLoginSignature({
                    address: address,
                    bytes: (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(message),
                    signature: parsedSignature.serializedSignature,
                    intentScope: "PERSONAL_MESSAGE",
                    client: $33d626209c61d8cf$var$__privateGet(this, $33d626209c61d8cf$var$_client)
                });
            }
        },
        {
            /**
   * Verifies that the signature is valid for for the provided Transaction
   */ key: "verifyTransaction",
            value: function verifyTransaction(transaction, signature) {
                var parsedSignature = $33d626209c61d8cf$var$parseSerializedZkLoginSignature(signature);
                var address = new _ZkLoginPublicIdentifier(parsedSignature.publicKey).toSuiAddress();
                return $33d626209c61d8cf$var$graphqlVerifyZkLoginSignature({
                    address: address,
                    bytes: (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(transaction),
                    signature: parsedSignature.serializedSignature,
                    intentScope: "TRANSACTION_DATA",
                    client: $33d626209c61d8cf$var$__privateGet(this, $33d626209c61d8cf$var$_client)
                });
            }
        }
    ]);
    return _ZkLoginPublicIdentifier;
}($f18ddaf76dcce603$exports.PublicKey);
$33d626209c61d8cf$var$_data = new WeakMap();
$33d626209c61d8cf$var$_client = new WeakMap();
var $33d626209c61d8cf$var$ZkLoginPublicIdentifier = $33d626209c61d8cf$var$_ZkLoginPublicIdentifier;
function $33d626209c61d8cf$var$toZkLoginPublicIdentifier(addressSeed, iss, options) {
    var addressSeedBytesBigEndian = (0, $d1b3ef3803576e71$exports.toPaddedBigEndianBytes)(addressSeed, 32);
    var issBytes = new TextEncoder().encode(iss);
    var tmp = new Uint8Array(1 + issBytes.length + addressSeedBytesBigEndian.length);
    tmp.set([
        issBytes.length
    ], 0);
    tmp.set(issBytes, 1);
    tmp.set(addressSeedBytesBigEndian, 1 + issBytes.length);
    return new $33d626209c61d8cf$var$ZkLoginPublicIdentifier(tmp, options);
}
var $33d626209c61d8cf$var$VerifyZkLoginSignatureQuery = (0, $530620c5ce6a6423$exports.graphql)("\n	query Zklogin(\n		$bytes: Base64!\n		$signature: Base64!\n		$intentScope: ZkLoginIntentScope!\n		$author: SuiAddress!\n	) {\n		verifyZkloginSignature(\n			bytes: $bytes\n			signature: $signature\n			intentScope: $intentScope\n			author: $author\n		) {\n			success\n			errors\n		}\n	}\n");
function $33d626209c61d8cf$var$graphqlVerifyZkLoginSignature(_) {
    return $33d626209c61d8cf$var$_graphqlVerifyZkLoginSignature.apply(this, arguments);
}
function $33d626209c61d8cf$var$_graphqlVerifyZkLoginSignature() {
    $33d626209c61d8cf$var$_graphqlVerifyZkLoginSignature = (0, $6rBFC._)(function(param) {
        var address, bytes, signature, intentScope, _param_client, client, _resp_data, _resp_data1, resp;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, bytes = param.bytes, signature = param.signature, intentScope = param.intentScope, _param_client = param.client, client = _param_client === void 0 ? new $d3a5a0e392964fca$exports.SuiGraphQLClient({
                        url: "https://sui-mainnet.mystenlabs.com/graphql"
                    }) : _param_client;
                    return [
                        4,
                        client.query({
                            query: $33d626209c61d8cf$var$VerifyZkLoginSignatureQuery,
                            variables: {
                                bytes: bytes,
                                signature: signature,
                                intentScope: intentScope,
                                author: address
                            }
                        })
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        ((_resp_data = resp.data) === null || _resp_data === void 0 ? void 0 : _resp_data.verifyZkloginSignature.success) === true && ((_resp_data1 = resp.data) === null || _resp_data1 === void 0 ? void 0 : _resp_data1.verifyZkloginSignature.errors.length) === 0
                    ];
            }
        });
    });
    return $33d626209c61d8cf$var$_graphqlVerifyZkLoginSignature.apply(this, arguments);
}
function $33d626209c61d8cf$var$parseSerializedZkLoginSignature(signature) {
    var bytes = typeof signature === "string" ? (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(signature) : signature;
    if (bytes[0] !== $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG.ZkLogin) throw new Error("Invalid signature scheme");
    var signatureBytes = bytes.slice(1);
    var _ref = (0, $de838e9f9a1aa56f$exports.parseZkLoginSignature)(signatureBytes), inputs = _ref.inputs, maxEpoch = _ref.maxEpoch, userSignature = _ref.userSignature;
    var issBase64Details = inputs.issBase64Details, addressSeed = inputs.addressSeed;
    var iss = (0, $a5fee237d75e042f$exports.extractClaimValue)(issBase64Details, "iss");
    var publicIdentifer = $33d626209c61d8cf$var$toZkLoginPublicIdentifier(BigInt(addressSeed), iss);
    return {
        serializedSignature: (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(bytes),
        signatureScheme: "ZkLogin",
        zkLogin: {
            inputs: inputs,
            maxEpoch: maxEpoch,
            userSignature: userSignature,
            iss: iss,
            addressSeed: BigInt(addressSeed)
        },
        signature: bytes,
        publicKey: publicIdentifer.toRawBytes()
    };
}



function $bcd52e1566c5a424$var$toSerializedSignature(param) {
    var signature = param.signature, signatureScheme = param.signatureScheme, publicKey = param.publicKey;
    if (!publicKey) throw new Error("`publicKey` is required");
    var pubKeyBytes = publicKey.toRawBytes();
    var serializedSignature = new Uint8Array(1 + signature.length + pubKeyBytes.length);
    serializedSignature.set([
        $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG[signatureScheme]
    ]);
    serializedSignature.set(signature, 1);
    serializedSignature.set(pubKeyBytes, 1 + signature.length);
    return (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(serializedSignature);
}
function $bcd52e1566c5a424$var$parseSerializedSignature(serializedSignature) {
    var bytes = (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(serializedSignature);
    var signatureScheme = $eee0db41adbb8a07$exports.SIGNATURE_FLAG_TO_SCHEME[bytes[0]];
    switch(signatureScheme){
        case "MultiSig":
            var multisig = $f8d1f806bddc4e70$exports.bcs.MultiSig.parse(bytes.slice(1));
            return {
                serializedSignature: serializedSignature,
                signatureScheme: signatureScheme,
                multisig: multisig,
                bytes: bytes
            };
        case "ZkLogin":
            return (0, $33d626209c61d8cf$exports.parseSerializedZkLoginSignature)(serializedSignature);
        case "ED25519":
        case "Secp256k1":
        case "Secp256r1":
            var size = $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_SIZE[signatureScheme];
            var signature = bytes.slice(1, bytes.length - size);
            var publicKey = bytes.slice(1 + signature.length);
            return {
                serializedSignature: serializedSignature,
                signatureScheme: signatureScheme,
                signature: signature,
                publicKey: publicKey,
                bytes: bytes
            };
        default:
            throw new Error("Unsupported signature scheme");
    }
}



var $021e843c62eff7b5$exports = {};
"use strict";
var $021e843c62eff7b5$var$__defProp = Object.defineProperty;
var $021e843c62eff7b5$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $021e843c62eff7b5$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $021e843c62eff7b5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $021e843c62eff7b5$var$__export = function(target, all) {
    for(var name in all)$021e843c62eff7b5$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $021e843c62eff7b5$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$021e843c62eff7b5$var$__hasOwnProp.call(to, key) && key !== except) $021e843c62eff7b5$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $021e843c62eff7b5$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $021e843c62eff7b5$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $021e843c62eff7b5$var$__toCommonJS = function(mod) {
    return $021e843c62eff7b5$var$__copyProps($021e843c62eff7b5$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $021e843c62eff7b5$var$mnemonics_exports = {};
$021e843c62eff7b5$var$__export($021e843c62eff7b5$var$mnemonics_exports, {
    isValidBIP32Path: function() {
        return $021e843c62eff7b5$var$isValidBIP32Path;
    },
    isValidHardenedPath: function() {
        return $021e843c62eff7b5$var$isValidHardenedPath;
    },
    mnemonicToSeed: function() {
        return $021e843c62eff7b5$var$mnemonicToSeed;
    },
    mnemonicToSeedHex: function() {
        return $021e843c62eff7b5$var$mnemonicToSeedHex;
    }
});
$021e843c62eff7b5$exports = $021e843c62eff7b5$var$__toCommonJS($021e843c62eff7b5$var$mnemonics_exports);

var $d5f0ff38d3589712$exports = {};

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty($d5f0ff38d3589712$exports, "__esModule", {
    value: true
});
$d5f0ff38d3589712$exports.mnemonicToSeedSync = $d5f0ff38d3589712$exports.mnemonicToSeed = $d5f0ff38d3589712$exports.validateMnemonic = $d5f0ff38d3589712$exports.entropyToMnemonic = $d5f0ff38d3589712$exports.mnemonicToEntropy = $d5f0ff38d3589712$exports.generateMnemonic = void 0;

var $3c04152910f10e2d$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $6qu4b = parcelRequire("6qu4b");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
Object.defineProperty($3c04152910f10e2d$exports, "__esModule", {
    value: true
});
$3c04152910f10e2d$exports.pbkdf2Async = $3c04152910f10e2d$exports.pbkdf2 = void 0;

var $6c6d2bbf9aa5b6fa$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($6c6d2bbf9aa5b6fa$exports, "__esModule", {
    value: true
});
$6c6d2bbf9aa5b6fa$exports.hmac = $6c6d2bbf9aa5b6fa$exports.HMAC = void 0;


// HMAC (RFC 2104)
var $6c6d2bbf9aa5b6fa$var$HMAC = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(HMAC, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(HMAC);
    function HMAC(hash, _key) {
        (0, $7dKN1._)(this, HMAC);
        var _this;
        _this = _super.call(this);
        _this.finished = false;
        _this.destroyed = false;
        (0, $87bc1d41ebb7f232$exports.hash)(hash);
        var key = (0, $84f9351876d022a0$exports.toBytes)(_key);
        _this.iHash = hash.create();
        if (typeof _this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        _this.blockLen = _this.iHash.blockLen;
        _this.outputLen = _this.iHash.outputLen;
        var blockLen = _this.blockLen;
        var pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        _this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        _this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(var i1 = 0; i1 < pad.length; i1++)pad[i1] ^= 106;
        _this.oHash.update(pad);
        pad.fill(0);
        return _this;
    }
    (0, $eW5pA._)(HMAC, [
        {
            key: "update",
            value: function update(buf) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                this.iHash.update(buf);
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                (0, $87bc1d41ebb7f232$exports.bytes)(out, this.outputLen);
                this.finished = true;
                this.iHash.digestInto(out);
                this.oHash.update(out);
                this.oHash.digestInto(out);
                this.destroy();
            }
        },
        {
            key: "digest",
            value: function digest() {
                var out = new Uint8Array(this.oHash.outputLen);
                this.digestInto(out);
                return out;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                // Create new instance without calling constructor since key already in state and we don't know it.
                to || (to = Object.create(Object.getPrototypeOf(this), {}));
                var _this = this, oHash = _this.oHash, iHash = _this.iHash, finished = _this.finished, destroyed = _this.destroyed, blockLen = _this.blockLen, outputLen = _this.outputLen;
                to;
                to.finished = finished;
                to.destroyed = destroyed;
                to.blockLen = blockLen;
                to.outputLen = outputLen;
                to.oHash = oHash._cloneInto(to.oHash);
                to.iHash = iHash._cloneInto(to.iHash);
                return to;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.oHash.destroy();
                this.iHash.destroy();
            }
        }
    ]);
    return HMAC;
}($84f9351876d022a0$exports.Hash);
$6c6d2bbf9aa5b6fa$exports.HMAC = $6c6d2bbf9aa5b6fa$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ var $6c6d2bbf9aa5b6fa$var$hmac = function(hash, key, message) {
    return new $6c6d2bbf9aa5b6fa$var$HMAC(hash, key).update(message).digest();
};
$6c6d2bbf9aa5b6fa$exports.hmac = $6c6d2bbf9aa5b6fa$var$hmac;
$6c6d2bbf9aa5b6fa$exports.hmac.create = function(hash, key) {
    return new $6c6d2bbf9aa5b6fa$var$HMAC(hash, key);
};



// Common prologue and epilogue for sync/async functions
function $3c04152910f10e2d$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $87bc1d41ebb7f232$exports.hash)(hash);
    var opts = (0, $84f9351876d022a0$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    var c = opts.c, dkLen = opts.dkLen, asyncTick = opts.asyncTick;
    (0, $87bc1d41ebb7f232$exports.number)(c);
    (0, $87bc1d41ebb7f232$exports.number)(dkLen);
    (0, $87bc1d41ebb7f232$exports.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    var password = (0, $84f9351876d022a0$exports.toBytes)(_password);
    var salt = (0, $84f9351876d022a0$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    var DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    var PRF = $6c6d2bbf9aa5b6fa$exports.hmac.create(hash, password);
    var PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $3c04152910f10e2d$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $3c04152910f10e2d$var$pbkdf2(hash, password, salt, opts) {
    var _pbkdf2Init = $3c04152910f10e2d$var$pbkdf2Init(hash, password, salt, opts), c = _pbkdf2Init.c, dkLen = _pbkdf2Init.dkLen, DK = _pbkdf2Init.DK, PRF = _pbkdf2Init.PRF, PRFSalt = _pbkdf2Init.PRFSalt;
    var prfW; // Working copy
    var arr = new Uint8Array(4);
    var view = (0, $84f9351876d022a0$exports.createView)(arr);
    var u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(var ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        var Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(var ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(var i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $3c04152910f10e2d$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$3c04152910f10e2d$exports.pbkdf2 = $3c04152910f10e2d$var$pbkdf2;
function $3c04152910f10e2d$var$pbkdf2Async(hash, password, salt, opts) {
    return $3c04152910f10e2d$var$_pbkdf2Async.apply(this, arguments);
}
function $3c04152910f10e2d$var$_pbkdf2Async() {
    $3c04152910f10e2d$var$_pbkdf2Async = (0, $6rBFC._)(function(hash, password, salt, opts) {
        var _loop, _pbkdf2Init, c, dkLen, asyncTick, DK, PRF, PRFSalt, prfW, arr, view, u, ti, pos;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(ti, pos) {
                        var Ti;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // Ti = F(Password, Salt, c, i)
                                    Ti = DK.subarray(pos, pos + PRF.outputLen);
                                    view.setInt32(0, ti, false);
                                    // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
                                    // U1 = PRF(Password, Salt + INT_32_BE(i))
                                    (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
                                    Ti.set(u.subarray(0, Ti.length));
                                    return [
                                        4,
                                        (0, $84f9351876d022a0$exports.asyncLoop)(c - 1, asyncTick, function() {
                                            // Uc = PRF(Password, Uc−1)
                                            PRF._cloneInto(prfW).update(u).digestInto(u);
                                            for(var i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _pbkdf2Init = $3c04152910f10e2d$var$pbkdf2Init(hash, password, salt, opts), c = _pbkdf2Init.c, dkLen = _pbkdf2Init.dkLen, asyncTick = _pbkdf2Init.asyncTick, DK = _pbkdf2Init.DK, PRF = _pbkdf2Init.PRF, PRFSalt = _pbkdf2Init.PRFSalt;
                    arr = new Uint8Array(4);
                    view = (0, $84f9351876d022a0$exports.createView)(arr);
                    u = new Uint8Array(PRF.outputLen);
                    ti = 1, pos = 0;
                    _state.label = 1;
                case 1:
                    if (!(pos < dkLen)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $6qu4b.__values)(_loop(ti, pos))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    ti++, pos += PRF.outputLen;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2,
                        $3c04152910f10e2d$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u)
                    ];
            }
        });
    });
    return $3c04152910f10e2d$var$_pbkdf2Async.apply(this, arguments);
}
$3c04152910f10e2d$exports.pbkdf2Async = $3c04152910f10e2d$var$pbkdf2Async;


var $33bf81adc16df8a0$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($33bf81adc16df8a0$exports, "__esModule", {
    value: true
});
$33bf81adc16df8a0$exports.sha224 = $33bf81adc16df8a0$exports.sha256 = void 0;
var $ad5c3fa287917a3a$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($ad5c3fa287917a3a$exports, "__esModule", {
    value: true
});
$ad5c3fa287917a3a$exports.HashMD = $ad5c3fa287917a3a$exports.Maj = $ad5c3fa287917a3a$exports.Chi = void 0;


// Polyfill for Safari 14
function $ad5c3fa287917a3a$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number(value >> _32n & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Choice: a ? b : c
var $ad5c3fa287917a3a$var$Chi = function(a, b, c) {
    return a & b ^ ~a & c;
};
$ad5c3fa287917a3a$exports.Chi = $ad5c3fa287917a3a$var$Chi;
// Majority function, true if any two inpust is true
var $ad5c3fa287917a3a$var$Maj = function(a, b, c) {
    return a & b ^ a & c ^ b & c;
};
$ad5c3fa287917a3a$exports.Maj = $ad5c3fa287917a3a$var$Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ var $ad5c3fa287917a3a$var$HashMD = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(HashMD, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(HashMD);
    function HashMD(blockLen, outputLen, padOffset, isLE) {
        (0, $7dKN1._)(this, HashMD);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, $84f9351876d022a0$exports.createView)(_this.buffer);
        return _this;
    }
    (0, $eW5pA._)(HashMD, [
        {
            key: "update",
            value: function update(data) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                var _this = this, view = _this.view, buffer = _this.buffer, blockLen = _this.blockLen;
                data = (0, $84f9351876d022a0$exports.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    // Fast path: we have at least one block in input, cast it to view and process
                    if (take === blockLen) {
                        var dataView = (0, $84f9351876d022a0$exports.createView)(data);
                        for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    pos += take;
                    if (this.pos === blockLen) {
                        this.process(view, 0);
                        this.pos = 0;
                    }
                }
                this.length += data.length;
                this.roundClean();
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                (0, $87bc1d41ebb7f232$exports.output)(out, this);
                this.finished = true;
                // Padding
                // We can avoid allocation of buffer for padding completely if it
                // was previously not allocated here. But it won't change performance.
                var _this = this, buffer = _this.buffer, view = _this.view, blockLen = _this.blockLen, isLE = _this.isLE;
                var pos = this.pos;
                // append the bit '1' to the message
                buffer[pos++] = 128;
                this.buffer.subarray(pos).fill(0);
                // we have less than padOffset left in buffer, so we cannot put length in
                // current block, need process it and pad again
                if (this.padOffset > blockLen - pos) {
                    this.process(view, 0);
                    pos = 0;
                }
                // Pad until full block byte with zeros
                for(var i = pos; i < blockLen; i++)buffer[i] = 0;
                // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
                // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
                // So we just write lowest 64 bits of that value.
                $ad5c3fa287917a3a$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
                this.process(view, 0);
                var oview = (0, $84f9351876d022a0$exports.createView)(out);
                var len = this.outputLen;
                // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
                if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                var outLen = len / 4;
                var state = this.get();
                if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
                for(var i1 = 0; i1 < outLen; i1++)oview.setUint32(4 * i1, state[i1], isLE);
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                to || (to = new this.constructor());
                (_to = to).set.apply(_to, (0, $gF0bR._)(this.get()));
                var _this = this, blockLen = _this.blockLen, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, pos = _this.pos;
                to.length = length;
                to.pos = pos;
                to.finished = finished;
                to.destroyed = destroyed;
                if (length % blockLen) to.buffer.set(buffer);
                return to;
            }
        }
    ]);
    return HashMD;
}($84f9351876d022a0$exports.Hash);
$ad5c3fa287917a3a$exports.HashMD = $ad5c3fa287917a3a$var$HashMD;



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var $33bf81adc16df8a0$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
var $33bf81adc16df8a0$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var $33bf81adc16df8a0$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var $33bf81adc16df8a0$var$SHA256 = /*#__PURE__*/ function(_md_js_1_HashMD) {
    (0, $cgJ2Y._)(SHA256, _md_js_1_HashMD);
    var _super = (0, $hKD8n._)(SHA256);
    function SHA256() {
        (0, $7dKN1._)(this, SHA256);
        var _this;
        _this = _super.call(this, 64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = $33bf81adc16df8a0$var$SHA256_IV[0] | 0;
        _this.B = $33bf81adc16df8a0$var$SHA256_IV[1] | 0;
        _this.C = $33bf81adc16df8a0$var$SHA256_IV[2] | 0;
        _this.D = $33bf81adc16df8a0$var$SHA256_IV[3] | 0;
        _this.E = $33bf81adc16df8a0$var$SHA256_IV[4] | 0;
        _this.F = $33bf81adc16df8a0$var$SHA256_IV[5] | 0;
        _this.G = $33bf81adc16df8a0$var$SHA256_IV[6] | 0;
        _this.H = $33bf81adc16df8a0$var$SHA256_IV[7] | 0;
        return _this;
    }
    (0, $eW5pA._)(SHA256, [
        {
            key: "get",
            value: function get() {
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                return [
                    A,
                    B,
                    C,
                    D,
                    E,
                    F,
                    G,
                    H
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(A, B, C, D, E, F, G, H) {
                this.A = A | 0;
                this.B = B | 0;
                this.C = C | 0;
                this.D = D | 0;
                this.E = E | 0;
                this.F = F | 0;
                this.G = G | 0;
                this.H = H | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4)$33bf81adc16df8a0$var$SHA256_W[i] = view.getUint32(offset, false);
                for(var i1 = 16; i1 < 64; i1++){
                    var W15 = $33bf81adc16df8a0$var$SHA256_W[i1 - 15];
                    var W2 = $33bf81adc16df8a0$var$SHA256_W[i1 - 2];
                    var s0 = (0, $84f9351876d022a0$exports.rotr)(W15, 7) ^ (0, $84f9351876d022a0$exports.rotr)(W15, 18) ^ W15 >>> 3;
                    var s1 = (0, $84f9351876d022a0$exports.rotr)(W2, 17) ^ (0, $84f9351876d022a0$exports.rotr)(W2, 19) ^ W2 >>> 10;
                    $33bf81adc16df8a0$var$SHA256_W[i1] = s1 + $33bf81adc16df8a0$var$SHA256_W[i1 - 7] + s0 + $33bf81adc16df8a0$var$SHA256_W[i1 - 16] | 0;
                }
                // Compression function main loop, 64 rounds
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                for(var i2 = 0; i2 < 64; i2++){
                    var sigma1 = (0, $84f9351876d022a0$exports.rotr)(E, 6) ^ (0, $84f9351876d022a0$exports.rotr)(E, 11) ^ (0, $84f9351876d022a0$exports.rotr)(E, 25);
                    var T1 = H + sigma1 + (0, $ad5c3fa287917a3a$exports.Chi)(E, F, G) + $33bf81adc16df8a0$var$SHA256_K[i2] + $33bf81adc16df8a0$var$SHA256_W[i2] | 0;
                    var sigma0 = (0, $84f9351876d022a0$exports.rotr)(A, 2) ^ (0, $84f9351876d022a0$exports.rotr)(A, 13) ^ (0, $84f9351876d022a0$exports.rotr)(A, 22);
                    var T2 = sigma0 + (0, $ad5c3fa287917a3a$exports.Maj)(A, B, C) | 0;
                    H = G;
                    G = F;
                    F = E;
                    E = D + T1 | 0;
                    D = C;
                    C = B;
                    B = A;
                    A = T1 + T2 | 0;
                }
                // Add the compressed chunk to the current hash value
                A = A + this.A | 0;
                B = B + this.B | 0;
                C = C + this.C | 0;
                D = D + this.D | 0;
                E = E + this.E | 0;
                F = F + this.F | 0;
                G = G + this.G | 0;
                H = H + this.H | 0;
                this.set(A, B, C, D, E, F, G, H);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $33bf81adc16df8a0$var$SHA256_W.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.set(0, 0, 0, 0, 0, 0, 0, 0);
                this.buffer.fill(0);
            }
        }
    ]);
    return SHA256;
}($ad5c3fa287917a3a$exports.HashMD);
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var $33bf81adc16df8a0$var$SHA224 = /*#__PURE__*/ function(SHA256) {
    (0, $cgJ2Y._)(SHA224, SHA256);
    var _super = (0, $hKD8n._)(SHA224);
    function SHA224() {
        (0, $7dKN1._)(this, SHA224);
        var _this;
        _this = _super.call(this);
        _this.A = -1056596264;
        _this.B = 914150663;
        _this.C = 812702999;
        _this.D = -150054599;
        _this.E = -4191439;
        _this.F = 1750603025;
        _this.G = 1694076839;
        _this.H = -1090891868;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}($33bf81adc16df8a0$var$SHA256);
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $33bf81adc16df8a0$exports.sha256 = (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
    return new $33bf81adc16df8a0$var$SHA256();
});
$33bf81adc16df8a0$exports.sha224 = (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
    return new $33bf81adc16df8a0$var$SHA224();
});


var $b647a6fb65a37e6c$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($b647a6fb65a37e6c$exports, "__esModule", {
    value: true
});
$b647a6fb65a37e6c$exports.sha384 = $b647a6fb65a37e6c$exports.sha512_256 = $b647a6fb65a37e6c$exports.sha512_224 = $b647a6fb65a37e6c$exports.sha512 = $b647a6fb65a37e6c$exports.SHA512 = void 0;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
var $b647a6fb65a37e6c$var$_ref = (0, $5OlIx._)(/* @__PURE__ */ function() {
    return $56477cbf0e8d09c2$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map(function(n) {
        return BigInt(n);
    }));
}(), 2), $b647a6fb65a37e6c$var$SHA512_Kh = $b647a6fb65a37e6c$var$_ref[0], $b647a6fb65a37e6c$var$SHA512_Kl = $b647a6fb65a37e6c$var$_ref[1];
// Temporary buffer, not used to store anything between runs
var $b647a6fb65a37e6c$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
var $b647a6fb65a37e6c$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
var $b647a6fb65a37e6c$var$SHA512 = /*#__PURE__*/ function(_md_js_1_HashMD) {
    (0, $cgJ2Y._)(SHA512, _md_js_1_HashMD);
    var _super = (0, $hKD8n._)(SHA512);
    function SHA512() {
        (0, $7dKN1._)(this, SHA512);
        var _this;
        _this = _super.call(this, 128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 1779033703;
        _this.Al = -205731576;
        _this.Bh = -1150833019;
        _this.Bl = -2067093701;
        _this.Ch = 1013904242;
        _this.Cl = -23791573;
        _this.Dh = -1521486534;
        _this.Dl = 1595750129;
        _this.Eh = 1359893119;
        _this.El = -1377402159;
        _this.Fh = -1694144372;
        _this.Fl = 725511199;
        _this.Gh = 528734635;
        _this.Gl = -79577749;
        _this.Hh = 1541459225;
        _this.Hl = 327033209;
        return _this;
    }
    (0, $eW5pA._)(SHA512, [
        {
            // prettier-ignore
            key: "get",
            value: function get() {
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                return [
                    Ah,
                    Al,
                    Bh,
                    Bl,
                    Ch,
                    Cl,
                    Dh,
                    Dl,
                    Eh,
                    El,
                    Fh,
                    Fl,
                    Gh,
                    Gl,
                    Hh,
                    Hl
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
                this.Ah = Ah | 0;
                this.Al = Al | 0;
                this.Bh = Bh | 0;
                this.Bl = Bl | 0;
                this.Ch = Ch | 0;
                this.Cl = Cl | 0;
                this.Dh = Dh | 0;
                this.Dl = Dl | 0;
                this.Eh = Eh | 0;
                this.El = El | 0;
                this.Fh = Fh | 0;
                this.Fl = Fl | 0;
                this.Gh = Gh | 0;
                this.Gl = Gl | 0;
                this.Hh = Hh | 0;
                this.Hl = Hl | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4){
                    $b647a6fb65a37e6c$var$SHA512_W_H[i] = view.getUint32(offset);
                    $b647a6fb65a37e6c$var$SHA512_W_L[i] = view.getUint32(offset += 4);
                }
                for(var i1 = 16; i1 < 80; i1++){
                    // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
                    var W15h = $b647a6fb65a37e6c$var$SHA512_W_H[i1 - 15] | 0;
                    var W15l = $b647a6fb65a37e6c$var$SHA512_W_L[i1 - 15] | 0;
                    var s0h = $56477cbf0e8d09c2$exports.default.rotrSH(W15h, W15l, 1) ^ $56477cbf0e8d09c2$exports.default.rotrSH(W15h, W15l, 8) ^ $56477cbf0e8d09c2$exports.default.shrSH(W15h, W15l, 7);
                    var s0l = $56477cbf0e8d09c2$exports.default.rotrSL(W15h, W15l, 1) ^ $56477cbf0e8d09c2$exports.default.rotrSL(W15h, W15l, 8) ^ $56477cbf0e8d09c2$exports.default.shrSL(W15h, W15l, 7);
                    // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
                    var W2h = $b647a6fb65a37e6c$var$SHA512_W_H[i1 - 2] | 0;
                    var W2l = $b647a6fb65a37e6c$var$SHA512_W_L[i1 - 2] | 0;
                    var s1h = $56477cbf0e8d09c2$exports.default.rotrSH(W2h, W2l, 19) ^ $56477cbf0e8d09c2$exports.default.rotrBH(W2h, W2l, 61) ^ $56477cbf0e8d09c2$exports.default.shrSH(W2h, W2l, 6);
                    var s1l = $56477cbf0e8d09c2$exports.default.rotrSL(W2h, W2l, 19) ^ $56477cbf0e8d09c2$exports.default.rotrBL(W2h, W2l, 61) ^ $56477cbf0e8d09c2$exports.default.shrSL(W2h, W2l, 6);
                    // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
                    var SUMl = $56477cbf0e8d09c2$exports.default.add4L(s0l, s1l, $b647a6fb65a37e6c$var$SHA512_W_L[i1 - 7], $b647a6fb65a37e6c$var$SHA512_W_L[i1 - 16]);
                    var SUMh = $56477cbf0e8d09c2$exports.default.add4H(SUMl, s0h, s1h, $b647a6fb65a37e6c$var$SHA512_W_H[i1 - 7], $b647a6fb65a37e6c$var$SHA512_W_H[i1 - 16]);
                    $b647a6fb65a37e6c$var$SHA512_W_H[i1] = SUMh | 0;
                    $b647a6fb65a37e6c$var$SHA512_W_L[i1] = SUMl | 0;
                }
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                // Compression function main loop, 80 rounds
                for(var i2 = 0; i2 < 80; i2++){
                    // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
                    var sigma1h = $56477cbf0e8d09c2$exports.default.rotrSH(Eh, El, 14) ^ $56477cbf0e8d09c2$exports.default.rotrSH(Eh, El, 18) ^ $56477cbf0e8d09c2$exports.default.rotrBH(Eh, El, 41);
                    var sigma1l = $56477cbf0e8d09c2$exports.default.rotrSL(Eh, El, 14) ^ $56477cbf0e8d09c2$exports.default.rotrSL(Eh, El, 18) ^ $56477cbf0e8d09c2$exports.default.rotrBL(Eh, El, 41);
                    //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
                    var CHIh = Eh & Fh ^ ~Eh & Gh;
                    var CHIl = El & Fl ^ ~El & Gl;
                    // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
                    // prettier-ignore
                    var T1ll = $56477cbf0e8d09c2$exports.default.add5L(Hl, sigma1l, CHIl, $b647a6fb65a37e6c$var$SHA512_Kl[i2], $b647a6fb65a37e6c$var$SHA512_W_L[i2]);
                    var T1h = $56477cbf0e8d09c2$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $b647a6fb65a37e6c$var$SHA512_Kh[i2], $b647a6fb65a37e6c$var$SHA512_W_H[i2]);
                    var T1l = T1ll | 0;
                    // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
                    var sigma0h = $56477cbf0e8d09c2$exports.default.rotrSH(Ah, Al, 28) ^ $56477cbf0e8d09c2$exports.default.rotrBH(Ah, Al, 34) ^ $56477cbf0e8d09c2$exports.default.rotrBH(Ah, Al, 39);
                    var sigma0l = $56477cbf0e8d09c2$exports.default.rotrSL(Ah, Al, 28) ^ $56477cbf0e8d09c2$exports.default.rotrBL(Ah, Al, 34) ^ $56477cbf0e8d09c2$exports.default.rotrBL(Ah, Al, 39);
                    var MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
                    var MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
                    Hh = Gh | 0;
                    Hl = Gl | 0;
                    Gh = Fh | 0;
                    Gl = Fl | 0;
                    Fh = Eh | 0;
                    Fl = El | 0;
                    var ref;
                    ref = $56477cbf0e8d09c2$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0), Eh = ref.h, El = ref.l, ref;
                    Dh = Ch | 0;
                    Dl = Cl | 0;
                    Ch = Bh | 0;
                    Cl = Bl | 0;
                    Bh = Ah | 0;
                    Bl = Al | 0;
                    var All = $56477cbf0e8d09c2$exports.default.add3L(T1l, sigma0l, MAJl);
                    Ah = $56477cbf0e8d09c2$exports.default.add3H(All, T1h, sigma0h, MAJh);
                    Al = All | 0;
                }
                var ref1;
                // Add the compressed chunk to the current hash value
                ref1 = $56477cbf0e8d09c2$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0), Ah = ref1.h, Al = ref1.l, ref1;
                var ref2;
                ref2 = $56477cbf0e8d09c2$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0), Bh = ref2.h, Bl = ref2.l, ref2;
                var ref3;
                ref3 = $56477cbf0e8d09c2$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0), Ch = ref3.h, Cl = ref3.l, ref3;
                var ref4;
                ref4 = $56477cbf0e8d09c2$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0), Dh = ref4.h, Dl = ref4.l, ref4;
                var ref5;
                ref5 = $56477cbf0e8d09c2$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0), Eh = ref5.h, El = ref5.l, ref5;
                var ref6;
                ref6 = $56477cbf0e8d09c2$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0), Fh = ref6.h, Fl = ref6.l, ref6;
                var ref7;
                ref7 = $56477cbf0e8d09c2$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0), Gh = ref7.h, Gl = ref7.l, ref7;
                var ref8;
                ref8 = $56477cbf0e8d09c2$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0), Hh = ref8.h, Hl = ref8.l, ref8;
                this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $b647a6fb65a37e6c$var$SHA512_W_H.fill(0);
                $b647a6fb65a37e6c$var$SHA512_W_L.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
        }
    ]);
    return SHA512;
}($ad5c3fa287917a3a$exports.HashMD);
$b647a6fb65a37e6c$exports.SHA512 = $b647a6fb65a37e6c$var$SHA512;
var $b647a6fb65a37e6c$var$SHA512_224 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA512_224, SHA512);
    var _super = (0, $hKD8n._)(SHA512_224);
    function SHA512_224() {
        (0, $7dKN1._)(this, SHA512_224);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -1942145080;
        _this.Al = 424955298;
        _this.Bh = 1944164710;
        _this.Bl = -1982016298;
        _this.Ch = 502970286;
        _this.Cl = 855612546;
        _this.Dh = 1738396948;
        _this.Dl = 1479516111;
        _this.Eh = 258812777;
        _this.El = 2077511080;
        _this.Fh = 2011393907;
        _this.Fl = 79989058;
        _this.Gh = 1067287976;
        _this.Gl = 1780299464;
        _this.Hh = 286451373;
        _this.Hl = -1848208735;
        _this.outputLen = 28;
        return _this;
    }
    return SHA512_224;
}($b647a6fb65a37e6c$var$SHA512);
var $b647a6fb65a37e6c$var$SHA512_256 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA512_256, SHA512);
    var _super = (0, $hKD8n._)(SHA512_256);
    function SHA512_256() {
        (0, $7dKN1._)(this, SHA512_256);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 573645204;
        _this.Al = -64227540;
        _this.Bh = -1621794909;
        _this.Bl = -934517566;
        _this.Ch = 596883563;
        _this.Cl = 1867755857;
        _this.Dh = -1774684391;
        _this.Dl = 1497426621;
        _this.Eh = -1775747358;
        _this.El = -1467023389;
        _this.Fh = -1101128155;
        _this.Fl = 1401305490;
        _this.Gh = 721525244;
        _this.Gl = 746961066;
        _this.Hh = 246885852;
        _this.Hl = -2117784414;
        _this.outputLen = 32;
        return _this;
    }
    return SHA512_256;
}($b647a6fb65a37e6c$var$SHA512);
var $b647a6fb65a37e6c$var$SHA384 = /*#__PURE__*/ function(SHA512) {
    (0, $cgJ2Y._)(SHA384, SHA512);
    var _super = (0, $hKD8n._)(SHA384);
    function SHA384() {
        (0, $7dKN1._)(this, SHA384);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -876896931;
        _this.Al = -1056596264;
        _this.Bh = 1654270250;
        _this.Bl = 914150663;
        _this.Ch = -1856437926;
        _this.Cl = 812702999;
        _this.Dh = 355462360;
        _this.Dl = -150054599;
        _this.Eh = 1731405415;
        _this.El = -4191439;
        _this.Fh = -1900787065;
        _this.Fl = 1750603025;
        _this.Gh = -619958771;
        _this.Gl = 1694076839;
        _this.Hh = 1203062813;
        _this.Hl = -1090891868;
        _this.outputLen = 48;
        return _this;
    }
    return SHA384;
}($b647a6fb65a37e6c$var$SHA512);
$b647a6fb65a37e6c$exports.sha512 = (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
    return new $b647a6fb65a37e6c$var$SHA512();
});
$b647a6fb65a37e6c$exports.sha512_224 = (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
    return new $b647a6fb65a37e6c$var$SHA512_224();
});
$b647a6fb65a37e6c$exports.sha512_256 = (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
    return new $b647a6fb65a37e6c$var$SHA512_256();
});
$b647a6fb65a37e6c$exports.sha384 = (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
    return new $b647a6fb65a37e6c$var$SHA384();
});



/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities
/**
 * @__NO_SIDE_EFFECTS__
 */ 
var $aVMuR = parcelRequire("aVMuR");
function $7349915407ad253d$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error("Wrong integer: ".concat(n));
}
function $7349915407ad253d$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$chain() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var id = function(a) {
        return a;
    };
    // Wrap call in closure so JIT can inline calls
    var wrap = function(a, b) {
        return function(c) {
            return a(b(c));
        };
    };
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    var encode = args.map(function(x) {
        return x.encode;
    }).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    var decode = args.map(function(x) {
        return x.decode;
    }).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$alphabet(alphabet) {
    return {
        encode: function(digits) {
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map(function(i) {
                $7349915407ad253d$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error("Digit index outside alphabet: ".concat(i, " (alphabet: ").concat(alphabet.length, ")"));
                return alphabet[i];
            });
        },
        decode: function(input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map(function(letter) {
                if (typeof letter !== "string") throw new Error("alphabet.decode: not string element=".concat(letter));
                var index = alphabet.indexOf(letter);
                if (index === -1) throw new Error('Unknown letter: "'.concat(letter, '". Allowed: ').concat(alphabet));
                return index;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$join() {
    var separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: function(from) {
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = from[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (typeof i !== "string") throw new Error("join.encode: non-string input=".concat(i));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return from.join(separator);
        },
        decode: function(to) {
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$padding(bits) {
    var chr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "=";
    $7349915407ad253d$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode: function(data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (typeof i !== "string") throw new Error("padding.encode: non-string input=".concat(i));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode: function(input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (typeof i !== "string") throw new Error("padding.decode: non-string input=".concat(i));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: function(from) {
            return from;
        },
        decode: function(to) {
            return fn(to);
        }
    };
}
/**
 * Slow: O(n^2) time complexity
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error("convertRadix: wrong from=".concat(from, ", base cannot be less than 2"));
    if (to < 2) throw new Error("convertRadix: wrong to=".concat(to, ", base cannot be less than 2"));
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    var pos = 0;
    var res = [];
    var digits = Array.from(data);
    digits.forEach(function(d) {
        $7349915407ad253d$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error("Wrong integer: ".concat(d));
    });
    while(true){
        var carry = 0;
        var done = true;
        for(var i = pos; i < digits.length; i++){
            var digit = digits[i];
            var digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            var rounded = Math.floor(digitBase / to);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(var i1 = 0; i1 < data.length - 1 && data[i1] === 0; i1++)res.push(0);
    return res.reverse();
}
var $7349915407ad253d$var$gcd = /* @__NO_SIDE_EFFECTS__ */ function(a, b) {
    return !b ? a : $7349915407ad253d$var$gcd(b, a % b);
};
var $7349915407ad253d$var$radix2carry = /*@__NO_SIDE_EFFECTS__ */ function(from, to) {
    return from + (to - $7349915407ad253d$var$gcd(from, to));
};
/**
 * Implemented with numbers, because BigInt is 5x slower
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error("convertRadix2: wrong from=".concat(from));
    if (to <= 0 || to > 32) throw new Error("convertRadix2: wrong to=".concat(to));
    if ($7349915407ad253d$var$radix2carry(from, to) > 32) throw new Error("convertRadix2: carry overflow from=".concat(from, " to=").concat(to, " carryBits=").concat($7349915407ad253d$var$radix2carry(from, to)));
    var carry = 0;
    var pos = 0; // bitwise position in current element
    var mask = Math.pow(2, to) - 1;
    var res = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            $7349915407ad253d$export$dfbcecb440255e4a(n);
            if (n >= Math.pow(2, from)) throw new Error("convertRadix2: invalid data word=".concat(n, " from=").concat(from));
            carry = carry << from | n;
            if (pos + from > 32) throw new Error("convertRadix2: carry overflow pos=".concat(pos, " from=").concat(from));
            pos += from;
            for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
            carry &= Math.pow(2, pos) - 1; // clean carry, otherwise it will cause overflow
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error("Non-zero padding: ".concat(carry));
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$radix(num) {
    $7349915407ad253d$export$dfbcecb440255e4a(num);
    return {
        encode: function(bytes) {
            if (!$7349915407ad253d$var$isBytes(bytes)) throw new Error("radix.encode input should be Uint8Array");
            return $7349915407ad253d$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: function(digits) {
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of numbers");
            return Uint8Array.from($7349915407ad253d$var$convertRadix(digits, num, 256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$radix2(bits) {
    var revPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $7349915407ad253d$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($7349915407ad253d$var$radix2carry(8, bits) > 32 || $7349915407ad253d$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: function(bytes) {
            if (!$7349915407ad253d$var$isBytes(bytes)) throw new Error("radix2.encode input should be Uint8Array");
            return $7349915407ad253d$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: function(digits) {
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of numbers");
            return Uint8Array.from($7349915407ad253d$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$checksum(len, fn) {
    $7349915407ad253d$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode: function(data) {
            if (!$7349915407ad253d$var$isBytes(data)) throw new Error("checksum.encode: input should be Uint8Array");
            var _$checksum = fn(data).slice(0, len);
            var res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(_$checksum, data.length);
            return res;
        },
        decode: function(data) {
            if (!$7349915407ad253d$var$isBytes(data)) throw new Error("checksum.decode: input should be Uint8Array");
            var payload = data.slice(0, -len);
            var newChecksum = fn(payload).slice(0, len);
            var oldChecksum = data.slice(-len);
            for(var i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
var $7349915407ad253d$export$eab97d15b1788b8d = {
    alphabet: $7349915407ad253d$var$alphabet,
    chain: $7349915407ad253d$var$chain,
    checksum: $7349915407ad253d$var$checksum,
    convertRadix: $7349915407ad253d$var$convertRadix,
    convertRadix2: $7349915407ad253d$var$convertRadix2,
    radix: $7349915407ad253d$var$radix,
    radix2: $7349915407ad253d$var$radix2,
    join: $7349915407ad253d$var$join,
    padding: $7349915407ad253d$var$padding
};
var $7349915407ad253d$export$586f61c71cb02fe4 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(4), $7349915407ad253d$var$alphabet("0123456789ABCDEF"), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$4a4d5965e2738b2a = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(5), $7349915407ad253d$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $7349915407ad253d$var$padding(5), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$e077e39445e9b6db = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(5), $7349915407ad253d$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$c57d6760d519c8ac = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(5), $7349915407ad253d$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $7349915407ad253d$var$padding(5), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$e37c85831a779eb9 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(5), $7349915407ad253d$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$5fbcb08925249358 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(5), $7349915407ad253d$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $7349915407ad253d$var$join(""), $7349915407ad253d$var$normalize(function(s) {
    return s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1");
}));
var $7349915407ad253d$export$b3b2de96497acc47 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(6), $7349915407ad253d$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $7349915407ad253d$var$padding(6), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$c907e660b9401ec7 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(6), $7349915407ad253d$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$7d21597c7bc64465 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(6), $7349915407ad253d$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $7349915407ad253d$var$padding(6), $7349915407ad253d$var$join(""));
var $7349915407ad253d$export$963cd24a38dd2f90 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(6), $7349915407ad253d$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $7349915407ad253d$var$join(""));
// base58 code
// -----------
var $7349915407ad253d$var$genBase58 = function(abc) {
    return $7349915407ad253d$var$chain($7349915407ad253d$var$radix(58), $7349915407ad253d$var$alphabet(abc), $7349915407ad253d$var$join(""));
};
var $7349915407ad253d$export$61f53211c069eefb = /* @__PURE__ */ $7349915407ad253d$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
var $7349915407ad253d$export$c6a7baed2941aad2 = /* @__PURE__ */ $7349915407ad253d$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
var $7349915407ad253d$export$cbd4c72942a9201d = /* @__PURE__ */ $7349915407ad253d$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
// xmr ver is done in 8-byte blocks (which equals 11 chars in decoding). Last (non-full) block padded with '1' to size in XMR_BLOCK_LEN.
// Block encoding significantly reduces quadratic complexity of base58.
// Data len (index) -> encoded block len
var $7349915407ad253d$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
var $7349915407ad253d$export$e86cd8e7f8cff4a6 = {
    encode: function(data) {
        var res = "";
        for(var i = 0; i < data.length; i += 8){
            var block = data.subarray(i, i + 8);
            res += $7349915407ad253d$export$61f53211c069eefb.encode(block).padStart($7349915407ad253d$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode: function(str) {
        var res = [];
        for(var i = 0; i < str.length; i += 11){
            var slice = str.slice(i, i + 11);
            var blockLen = $7349915407ad253d$var$XMR_BLOCK_LEN.indexOf(slice.length);
            var block = $7349915407ad253d$export$61f53211c069eefb.decode(slice);
            for(var j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
var $7349915407ad253d$export$2217e0412f7b06b6 = function(sha256) {
    return $7349915407ad253d$var$chain($7349915407ad253d$var$checksum(4, function(data) {
        return sha256(sha256(data));
    }), $7349915407ad253d$export$61f53211c069eefb);
};
var $7349915407ad253d$export$fff625c574161df6 = $7349915407ad253d$export$2217e0412f7b06b6;
var $7349915407ad253d$var$BECH_ALPHABET = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $7349915407ad253d$var$join(""));
var $7349915407ad253d$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$bech32Polymod(pre) {
    var b = pre >> 25;
    var chk = (pre & 0x1ffffff) << 5;
    for(var i = 0; i < $7349915407ad253d$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $7349915407ad253d$var$POLYMOD_GENERATORS[i];
    return chk;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$bechChecksum(prefix, words) {
    var encodingConst = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var len = prefix.length;
    var chk = 1;
    for(var i = 0; i < len; i++){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error("Invalid prefix (".concat(prefix, ")"));
        chk = $7349915407ad253d$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $7349915407ad253d$var$bech32Polymod(chk);
    for(var i1 = 0; i1 < len; i1++)chk = $7349915407ad253d$var$bech32Polymod(chk) ^ prefix.charCodeAt(i1) & 0x1f;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = words[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            chk = $7349915407ad253d$var$bech32Polymod(chk) ^ v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var i2 = 0; i2 < 6; i2++)chk = $7349915407ad253d$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $7349915407ad253d$var$BECH_ALPHABET.encode($7349915407ad253d$var$convertRadix2([
        chk % Math.pow(2, 30)
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $7349915407ad253d$var$genBech32(encoding) {
    var ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    var _words = $7349915407ad253d$var$radix2(5);
    var fromWords = _words.decode;
    var toWords = _words.encode;
    var fromWordsUnsafe = $7349915407ad253d$var$unsafeWrapper(fromWords);
    function encode(prefix, words) {
        var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 90;
        if (typeof prefix !== "string") throw new Error("bech32.encode prefix should be string, not ".concat(typeof prefix === "undefined" ? "undefined" : (0, $aVMuR._)(prefix)));
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error("bech32.encode words should be array of numbers, not ".concat(typeof words === "undefined" ? "undefined" : (0, $aVMuR._)(words)));
        if (prefix.length === 0) throw new TypeError("Invalid prefix length ".concat(prefix.length));
        var actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError("Length ".concat(actualLength, " exceeds limit ").concat(limit));
        var lowered = prefix.toLowerCase();
        var sum = $7349915407ad253d$var$bechChecksum(lowered, words, ENCODING_CONST);
        return "".concat(lowered, "1").concat($7349915407ad253d$var$BECH_ALPHABET.encode(words)).concat(sum);
    }
    function decode(str) {
        var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
        if (typeof str !== "string") throw new Error("bech32.decode input should be string, not ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError("Wrong string length: ".concat(str.length, " (").concat(str, "). Expected (8..").concat(limit, ")"));
        // don't allow mixed case
        var lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error("String must be lowercase or uppercase");
        var sepIndex = lowered.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error('Letter "1" must be present between prefix and data only');
        var prefix = lowered.slice(0, sepIndex);
        var data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error("Data must be at least 6 characters long");
        var words = $7349915407ad253d$var$BECH_ALPHABET.decode(data).slice(0, -6);
        var sum = $7349915407ad253d$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error("Invalid checksum in ".concat(str, ': expected "').concat(sum, '"'));
        return {
            prefix: prefix,
            words: words
        };
    }
    var decodeUnsafe = $7349915407ad253d$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        var _decode = decode(str, false), prefix = _decode.prefix, words = _decode.words;
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
var $7349915407ad253d$export$27c42482533637da = /* @__PURE__ */ $7349915407ad253d$var$genBech32("bech32");
var $7349915407ad253d$export$4963f7e473ccf819 = /* @__PURE__ */ $7349915407ad253d$var$genBech32("bech32m");
var $7349915407ad253d$export$74329b762b589566 = {
    encode: function(data) {
        return new TextDecoder().decode(data);
    },
    decode: function(str) {
        return new TextEncoder().encode(str);
    }
};
var $7349915407ad253d$export$834dfc94dde4b3d8 = /* @__PURE__ */ $7349915407ad253d$var$chain($7349915407ad253d$var$radix2(4), $7349915407ad253d$var$alphabet("0123456789abcdef"), $7349915407ad253d$var$join(""), $7349915407ad253d$var$normalize(function(s) {
    if (typeof s !== "string" || s.length % 2) throw new TypeError("hex.decode: expected string, got ".concat(typeof s === "undefined" ? "undefined" : (0, $aVMuR._)(s), " with length ").concat(s.length));
    return s.toLowerCase();
}));
// prettier-ignore
var $7349915407ad253d$var$CODERS = {
    utf8: $7349915407ad253d$export$74329b762b589566,
    hex: $7349915407ad253d$export$834dfc94dde4b3d8,
    base16: $7349915407ad253d$export$586f61c71cb02fe4,
    base32: $7349915407ad253d$export$4a4d5965e2738b2a,
    base64: $7349915407ad253d$export$b3b2de96497acc47,
    base64url: $7349915407ad253d$export$7d21597c7bc64465,
    base58: $7349915407ad253d$export$61f53211c069eefb,
    base58xmr: $7349915407ad253d$export$e86cd8e7f8cff4a6
};
var $7349915407ad253d$var$coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr";
var $7349915407ad253d$export$7c746b75f47c9c7d = function(type, bytes) {
    if (typeof type !== "string" || !$7349915407ad253d$var$CODERS.hasOwnProperty(type)) throw new TypeError($7349915407ad253d$var$coderTypeError);
    if (!$7349915407ad253d$var$isBytes(bytes)) throw new TypeError("bytesToString() expects Uint8Array");
    return $7349915407ad253d$var$CODERS[type].encode(bytes);
};
var $7349915407ad253d$export$42d51816ce590c93 = $7349915407ad253d$export$7c746b75f47c9c7d; // as in python, but for bytes only
var $7349915407ad253d$export$c8dd6bc66a63753c = function(type, str) {
    if (!$7349915407ad253d$var$CODERS.hasOwnProperty(type)) throw new TypeError($7349915407ad253d$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $7349915407ad253d$var$CODERS[type].decode(str);
};
var $7349915407ad253d$export$b3317979f9250576 = $7349915407ad253d$export$c8dd6bc66a63753c;


// Japanese wordlist
var $d5f0ff38d3589712$var$isJapanese = function(wordlist) {
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093";
};
// Normalization replaces equivalent sequences of characters
// so that any two texts that are equivalent will be reduced
// to the same sequence of code points, called the normal form of the original text.
// https://tonsky.me/blog/unicode/#why-is-a----
function $d5f0ff38d3589712$var$nfkd(str) {
    if (typeof str !== "string") throw new TypeError("Invalid mnemonic type: ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
    return str.normalize("NFKD");
}
function $d5f0ff38d3589712$var$normalize(str) {
    var norm = $d5f0ff38d3589712$var$nfkd(str);
    var words = norm.split(" ");
    if (![
        12,
        15,
        18,
        21,
        24
    ].includes(words.length)) throw new Error("Invalid mnemonic");
    return {
        nfkd: norm,
        words: words
    };
}
function $d5f0ff38d3589712$var$assertEntropy(entropy) {
    (0, $87bc1d41ebb7f232$exports.bytes)(entropy, 16, 20, 24, 28, 32);
}
/**
 * Generate x random words. Uses Cryptographically-Secure Random Number Generator.
 * @param wordlist imported wordlist for specific language
 * @param strength mnemonic strength 128-256 bits
 * @example
 * generateMnemonic(wordlist, 128)
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $d5f0ff38d3589712$var$generateMnemonic(wordlist) {
    var strength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 128;
    (0, $87bc1d41ebb7f232$exports.number)(strength);
    if (strength % 32 !== 0 || strength > 256) throw new TypeError("Invalid entropy");
    return $d5f0ff38d3589712$var$entropyToMnemonic((0, $84f9351876d022a0$exports.randomBytes)(strength / 8), wordlist);
}
$d5f0ff38d3589712$exports.generateMnemonic = $d5f0ff38d3589712$var$generateMnemonic;
var $d5f0ff38d3589712$var$calcChecksum = function(entropy) {
    // Checksum is ent.length/4 bits long
    var bitsLeft = 8 - entropy.length / 4;
    // Zero rightmost "bitsLeft" bits in byte
    // For example: bitsLeft=4 val=10111101 -> 10110000
    return new Uint8Array([
        (0, $33bf81adc16df8a0$exports.sha256)(entropy)[0] >> bitsLeft << bitsLeft
    ]);
};
function $d5f0ff38d3589712$var$getCoder(wordlist) {
    if (!Array.isArray(wordlist) || wordlist.length !== 2048 || typeof wordlist[0] !== "string") throw new Error("Wordlist: expected array of 2048 strings");
    wordlist.forEach(function(i) {
        if (typeof i !== "string") throw new Error("Wordlist: non-string element: ".concat(i));
    });
    return $7349915407ad253d$export$eab97d15b1788b8d.chain($7349915407ad253d$export$eab97d15b1788b8d.checksum(1, $d5f0ff38d3589712$var$calcChecksum), $7349915407ad253d$export$eab97d15b1788b8d.radix2(11, true), $7349915407ad253d$export$eab97d15b1788b8d.alphabet(wordlist));
}
/**
 * Reversible: Converts mnemonic string to raw entropy in form of byte array.
 * @param mnemonic 12-24 words
 * @param wordlist imported wordlist for specific language
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToEntropy(mnem, wordlist)
 * // Produces
 * new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ])
 */ function $d5f0ff38d3589712$var$mnemonicToEntropy(mnemonic, wordlist) {
    var words = $d5f0ff38d3589712$var$normalize(mnemonic).words;
    var entropy = $d5f0ff38d3589712$var$getCoder(wordlist).decode(words);
    $d5f0ff38d3589712$var$assertEntropy(entropy);
    return entropy;
}
$d5f0ff38d3589712$exports.mnemonicToEntropy = $d5f0ff38d3589712$var$mnemonicToEntropy;
/**
 * Reversible: Converts raw entropy in form of byte array to mnemonic string.
 * @param entropy byte array
 * @param wordlist imported wordlist for specific language
 * @returns 12-24 words
 * @example
 * const ent = new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ]);
 * entropyToMnemonic(ent, wordlist);
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $d5f0ff38d3589712$var$entropyToMnemonic(entropy, wordlist) {
    $d5f0ff38d3589712$var$assertEntropy(entropy);
    var words = $d5f0ff38d3589712$var$getCoder(wordlist).encode(entropy);
    return words.join($d5f0ff38d3589712$var$isJapanese(wordlist) ? "\u3000" : " ");
}
$d5f0ff38d3589712$exports.entropyToMnemonic = $d5f0ff38d3589712$var$entropyToMnemonic;
/**
 * Validates mnemonic for being 12-24 words contained in `wordlist`.
 */ function $d5f0ff38d3589712$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $d5f0ff38d3589712$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
$d5f0ff38d3589712$exports.validateMnemonic = $d5f0ff38d3589712$var$validateMnemonic;
var $d5f0ff38d3589712$var$salt = function(passphrase) {
    return $d5f0ff38d3589712$var$nfkd("mnemonic".concat(passphrase));
};
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * await mnemonicToSeed(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $d5f0ff38d3589712$var$mnemonicToSeed(mnemonic) {
    var passphrase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, $3c04152910f10e2d$exports.pbkdf2Async)($b647a6fb65a37e6c$exports.sha512, $d5f0ff38d3589712$var$normalize(mnemonic).nfkd, $d5f0ff38d3589712$var$salt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}
$d5f0ff38d3589712$exports.mnemonicToSeed = $d5f0ff38d3589712$var$mnemonicToSeed;
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToSeedSync(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $d5f0ff38d3589712$var$mnemonicToSeedSync(mnemonic) {
    var passphrase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, $3c04152910f10e2d$exports.pbkdf2)($b647a6fb65a37e6c$exports.sha512, $d5f0ff38d3589712$var$normalize(mnemonic).nfkd, $d5f0ff38d3589712$var$salt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}
$d5f0ff38d3589712$exports.mnemonicToSeedSync = $d5f0ff38d3589712$var$mnemonicToSeedSync;


function $021e843c62eff7b5$var$isValidHardenedPath(path) {
    if (!new RegExp("^m\\/44'\\/784'\\/[0-9]+'\\/[0-9]+'\\/[0-9]+'+$").test(path)) return false;
    return true;
}
function $021e843c62eff7b5$var$isValidBIP32Path(path) {
    if (!new RegExp("^m\\/(54|74)'\\/784'\\/[0-9]+'\\/[0-9]+\\/[0-9]+$").test(path)) return false;
    return true;
}
function $021e843c62eff7b5$var$mnemonicToSeed(mnemonics) {
    return (0, $d5f0ff38d3589712$exports.mnemonicToSeedSync)(mnemonics, "");
}
function $021e843c62eff7b5$var$mnemonicToSeedHex(mnemonics) {
    return (0, $96a5e6519bfce0e5$export$276eb56e46302cb0)($021e843c62eff7b5$var$mnemonicToSeed(mnemonics));
}



var $d51b88c4f7df6939$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $d51b88c4f7df6939$var$__defProp = Object.defineProperty;
var $d51b88c4f7df6939$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d51b88c4f7df6939$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d51b88c4f7df6939$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d51b88c4f7df6939$var$__export = function(target, all) {
    for(var name in all)$d51b88c4f7df6939$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d51b88c4f7df6939$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$d51b88c4f7df6939$var$__hasOwnProp.call(to, key) && key !== except) $d51b88c4f7df6939$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $d51b88c4f7df6939$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $d51b88c4f7df6939$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $d51b88c4f7df6939$var$__toCommonJS = function(mod) {
    return $d51b88c4f7df6939$var$__copyProps($d51b88c4f7df6939$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $d51b88c4f7df6939$var$keypair_exports = {};
$d51b88c4f7df6939$var$__export($d51b88c4f7df6939$var$keypair_exports, {
    Keypair: function() {
        return $d51b88c4f7df6939$var$Keypair;
    },
    LEGACY_PRIVATE_KEY_SIZE: function() {
        return $d51b88c4f7df6939$var$LEGACY_PRIVATE_KEY_SIZE;
    },
    PRIVATE_KEY_SIZE: function() {
        return $d51b88c4f7df6939$var$PRIVATE_KEY_SIZE;
    },
    SUI_PRIVATE_KEY_PREFIX: function() {
        return $d51b88c4f7df6939$var$SUI_PRIVATE_KEY_PREFIX;
    },
    Signer: function() {
        return $d51b88c4f7df6939$var$Signer;
    },
    decodeSuiPrivateKey: function() {
        return $d51b88c4f7df6939$var$decodeSuiPrivateKey;
    },
    encodeSuiPrivateKey: function() {
        return $d51b88c4f7df6939$var$encodeSuiPrivateKey;
    }
});
$d51b88c4f7df6939$exports = $d51b88c4f7df6939$var$__toCommonJS($d51b88c4f7df6939$var$keypair_exports);


var $ece922c0622f9073$exports = {};
"use strict";
Object.defineProperty($ece922c0622f9073$exports, "__esModule", {
    value: true
});
$ece922c0622f9073$exports.bech32m = $ece922c0622f9073$exports.bech32 = void 0;
var $ece922c0622f9073$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
var $ece922c0622f9073$var$ALPHABET_MAP = {};
for(var $ece922c0622f9073$var$z = 0; $ece922c0622f9073$var$z < $ece922c0622f9073$var$ALPHABET.length; $ece922c0622f9073$var$z++){
    var $ece922c0622f9073$var$x = $ece922c0622f9073$var$ALPHABET.charAt($ece922c0622f9073$var$z);
    $ece922c0622f9073$var$ALPHABET_MAP[$ece922c0622f9073$var$x] = $ece922c0622f9073$var$z;
}
function $ece922c0622f9073$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $ece922c0622f9073$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $ece922c0622f9073$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $ece922c0622f9073$var$polymodStep(chk);
    for(var i1 = 0; i1 < prefix.length; ++i1){
        var v = prefix.charCodeAt(i1);
        chk = $ece922c0622f9073$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $ece922c0622f9073$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $ece922c0622f9073$var$toWords(bytes) {
    return $ece922c0622f9073$var$convert(bytes, 8, 5, true);
}
function $ece922c0622f9073$var$fromWordsUnsafe(words) {
    var res = $ece922c0622f9073$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $ece922c0622f9073$var$fromWords(words) {
    var res = $ece922c0622f9073$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $ece922c0622f9073$var$getLibraryFromEncoding(encoding) {
    var ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        var chk = $ece922c0622f9073$var$prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        var result = prefix + "1";
        for(var i = 0; i < words.length; ++i){
            var x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = $ece922c0622f9073$var$polymodStep(chk) ^ x;
            result += $ece922c0622f9073$var$ALPHABET.charAt(x);
        }
        for(var i1 = 0; i1 < 6; ++i1)chk = $ece922c0622f9073$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(var i2 = 0; i2 < 6; ++i2){
            var v = chk >> (5 - i2) * 5 & 0x1f;
            result += $ece922c0622f9073$var$ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        var lowered = str.toLowerCase();
        var uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        var split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        var prefix = str.slice(0, split);
        var wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        var chk = $ece922c0622f9073$var$prefixChk(prefix);
        if (typeof chk === "string") return chk;
        var words = [];
        for(var i = 0; i < wordChars.length; ++i){
            var c = wordChars.charAt(i);
            var v = $ece922c0622f9073$var$ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = $ece922c0622f9073$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix: prefix,
            words: words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        var res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    }
    function decode(str, LIMIT) {
        var res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $ece922c0622f9073$var$toWords,
        fromWordsUnsafe: $ece922c0622f9073$var$fromWordsUnsafe,
        fromWords: $ece922c0622f9073$var$fromWords
    };
}
$ece922c0622f9073$exports.bech32 = $ece922c0622f9073$var$getLibraryFromEncoding("bech32");
$ece922c0622f9073$exports.bech32m = $ece922c0622f9073$var$getLibraryFromEncoding("bech32m");





var $d51b88c4f7df6939$var$PRIVATE_KEY_SIZE = 32;
var $d51b88c4f7df6939$var$LEGACY_PRIVATE_KEY_SIZE = 64;
var $d51b88c4f7df6939$var$SUI_PRIVATE_KEY_PREFIX = "suiprivkey";
var $d51b88c4f7df6939$var$Signer = /*#__PURE__*/ function() {
    function Signer() {
        (0, $7dKN1._)(this, Signer);
    }
    (0, $eW5pA._)(Signer, [
        {
            key: "signWithIntent",
            value: /**
   * Sign messages with a specific intent. By combining the message bytes with the intent before hashing and signing,
   * it ensures that a signed message is tied to a specific purpose and domain separator is provided
   */ function signWithIntent(bytes, intent) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var intentMessage, digest, signature, _, _tmp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                intentMessage = (0, $33b0080294277266$exports.messageWithIntent)(intent, bytes);
                                digest = (0, $3274270117ba9b37$exports.blake2b)(intentMessage, {
                                    dkLen: 32
                                });
                                _ = (0, $bcd52e1566c5a424$exports.toSerializedSignature);
                                _tmp = {};
                                return [
                                    4,
                                    _this.sign(digest)
                                ];
                            case 1:
                                signature = _.apply(void 0, [
                                    (_tmp.signature = _state.sent(), _tmp.signatureScheme = _this.getKeyScheme(), _tmp.publicKey = _this.getPublicKey(), _tmp)
                                ]);
                                return [
                                    2,
                                    {
                                        signature: signature,
                                        bytes: (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(bytes)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signTransaction",
            value: /**
   * Signs provided transaction by calling `signWithIntent()` with a `TransactionData` provided as intent scope
   */ function signTransaction(bytes) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.signWithIntent(bytes, "TransactionData")
                        ];
                    });
                })();
            }
        },
        {
            key: "signPersonalMessage",
            value: /**
   * Signs provided personal message by calling `signWithIntent()` with a `PersonalMessage` provided as intent scope
   */ function signPersonalMessage(bytes) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var signature;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.signWithIntent($634b23529fb8a913$export$9faca4e3b5a9912b.vector($634b23529fb8a913$export$9faca4e3b5a9912b.u8()).serialize(bytes).toBytes(), "PersonalMessage")
                                ];
                            case 1:
                                signature = _state.sent().signature;
                                return [
                                    2,
                                    {
                                        bytes: (0, $00e2ec7379a5c39a$export$747bdef45a77895b)(bytes),
                                        signature: signature
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toSuiAddress",
            value: function toSuiAddress() {
                return this.getPublicKey().toSuiAddress();
            }
        }
    ]);
    return Signer;
}();
var $d51b88c4f7df6939$var$Keypair = /*#__PURE__*/ function(Signer) {
    (0, $cgJ2Y._)(Keypair, Signer);
    var _super = (0, $hKD8n._)(Keypair);
    function Keypair() {
        (0, $7dKN1._)(this, Keypair);
        return _super.apply(this, arguments);
    }
    return Keypair;
}($d51b88c4f7df6939$var$Signer);
function $d51b88c4f7df6939$var$decodeSuiPrivateKey(value) {
    var _import_bech32_bech32_decode = $ece922c0622f9073$exports.bech32.decode(value), prefix = _import_bech32_bech32_decode.prefix, words = _import_bech32_bech32_decode.words;
    if (prefix !== $d51b88c4f7df6939$var$SUI_PRIVATE_KEY_PREFIX) throw new Error("invalid private key prefix");
    var extendedSecretKey = new Uint8Array($ece922c0622f9073$exports.bech32.fromWords(words));
    var secretKey = extendedSecretKey.slice(1);
    var signatureScheme = $eee0db41adbb8a07$exports.SIGNATURE_FLAG_TO_SCHEME[extendedSecretKey[0]];
    return {
        schema: signatureScheme,
        secretKey: secretKey
    };
}
function $d51b88c4f7df6939$var$encodeSuiPrivateKey(bytes, scheme) {
    if (bytes.length !== $d51b88c4f7df6939$var$PRIVATE_KEY_SIZE) throw new Error("Invalid bytes length");
    var flag = $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG[scheme];
    var privKeyBytes = new Uint8Array(bytes.length + 1);
    privKeyBytes.set([
        flag
    ]);
    privKeyBytes.set(bytes, 1);
    return $ece922c0622f9073$exports.bech32.encode($d51b88c4f7df6939$var$SUI_PRIVATE_KEY_PREFIX, $ece922c0622f9073$exports.bech32.toWords(privKeyBytes));
}





var $bef2e912dc82ffc5$exports = {};
"use strict";
var $bef2e912dc82ffc5$var$__defProp = Object.defineProperty;
var $bef2e912dc82ffc5$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $bef2e912dc82ffc5$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $bef2e912dc82ffc5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bef2e912dc82ffc5$var$__export = function(target, all) {
    for(var name in all)$bef2e912dc82ffc5$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $bef2e912dc82ffc5$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$bef2e912dc82ffc5$var$__hasOwnProp.call(to, key) && key !== except) $bef2e912dc82ffc5$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $bef2e912dc82ffc5$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $bef2e912dc82ffc5$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $bef2e912dc82ffc5$var$__toCommonJS = function(mod) {
    return $bef2e912dc82ffc5$var$__copyProps($bef2e912dc82ffc5$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $bef2e912dc82ffc5$var$ed25519_exports = {};
$bef2e912dc82ffc5$var$__export($bef2e912dc82ffc5$var$ed25519_exports, {
    DEFAULT_ED25519_DERIVATION_PATH: function() {
        return $c93a88be081350c1$exports.DEFAULT_ED25519_DERIVATION_PATH;
    },
    Ed25519Keypair: function() {
        return $c93a88be081350c1$exports.Ed25519Keypair;
    },
    Ed25519PublicKey: function() {
        return $3495806906ff99bc$exports.Ed25519PublicKey;
    }
});
$bef2e912dc82ffc5$exports = $bef2e912dc82ffc5$var$__toCommonJS($bef2e912dc82ffc5$var$ed25519_exports);
var $c93a88be081350c1$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $c93a88be081350c1$var$__create = Object.create;
var $c93a88be081350c1$var$__defProp = Object.defineProperty;
var $c93a88be081350c1$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $c93a88be081350c1$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $c93a88be081350c1$var$__getProtoOf = Object.getPrototypeOf;
var $c93a88be081350c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c93a88be081350c1$var$__export = function(target, all) {
    for(var name in all)$c93a88be081350c1$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $c93a88be081350c1$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$c93a88be081350c1$var$__hasOwnProp.call(to, key) && key !== except) $c93a88be081350c1$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $c93a88be081350c1$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $c93a88be081350c1$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $c93a88be081350c1$var$__toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? $c93a88be081350c1$var$__create($c93a88be081350c1$var$__getProtoOf(mod)) : {}, $c93a88be081350c1$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $c93a88be081350c1$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var $c93a88be081350c1$var$__toCommonJS = function(mod) {
    return $c93a88be081350c1$var$__copyProps($c93a88be081350c1$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $c93a88be081350c1$var$keypair_exports = {};
$c93a88be081350c1$var$__export($c93a88be081350c1$var$keypair_exports, {
    DEFAULT_ED25519_DERIVATION_PATH: function() {
        return $c93a88be081350c1$var$DEFAULT_ED25519_DERIVATION_PATH;
    },
    Ed25519Keypair: function() {
        return $c93a88be081350c1$var$Ed25519Keypair;
    }
});
$c93a88be081350c1$exports = $c93a88be081350c1$var$__toCommonJS($c93a88be081350c1$var$keypair_exports);

var $c93a88be081350c1$var$import_tweetnacl = $c93a88be081350c1$var$__toESM((parcelRequire("b8irb")));


var $2342eddbec494676$exports = {};
"use strict";
var $2342eddbec494676$var$__create = Object.create;
var $2342eddbec494676$var$__defProp = Object.defineProperty;
var $2342eddbec494676$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $2342eddbec494676$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $2342eddbec494676$var$__getProtoOf = Object.getPrototypeOf;
var $2342eddbec494676$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2342eddbec494676$var$__export = function(target, all) {
    for(var name in all)$2342eddbec494676$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $2342eddbec494676$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$2342eddbec494676$var$__hasOwnProp.call(to, key) && key !== except) $2342eddbec494676$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $2342eddbec494676$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $2342eddbec494676$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $2342eddbec494676$var$__toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? $2342eddbec494676$var$__create($2342eddbec494676$var$__getProtoOf(mod)) : {}, $2342eddbec494676$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $2342eddbec494676$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var $2342eddbec494676$var$__toCommonJS = function(mod) {
    return $2342eddbec494676$var$__copyProps($2342eddbec494676$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $2342eddbec494676$var$ed25519_hd_key_exports = {};
$2342eddbec494676$var$__export($2342eddbec494676$var$ed25519_hd_key_exports, {
    derivePath: function() {
        return $2342eddbec494676$var$derivePath;
    },
    getMasterKeyFromSeed: function() {
        return $2342eddbec494676$var$getMasterKeyFromSeed;
    },
    getPublicKey: function() {
        return $2342eddbec494676$var$getPublicKey;
    },
    isValidPath: function() {
        return $2342eddbec494676$var$isValidPath;
    },
    pathRegex: function() {
        return $2342eddbec494676$var$pathRegex;
    },
    replaceDerive: function() {
        return $2342eddbec494676$var$replaceDerive;
    }
});
$2342eddbec494676$exports = $2342eddbec494676$var$__toCommonJS($2342eddbec494676$var$ed25519_hd_key_exports);




var $2342eddbec494676$var$import_tweetnacl = $2342eddbec494676$var$__toESM((parcelRequire("b8irb")));
var $2342eddbec494676$var$ED25519_CURVE = "ed25519 seed";
var $2342eddbec494676$var$HARDENED_OFFSET = 2147483648;
var $2342eddbec494676$var$pathRegex = new RegExp("^m(\\/[0-9]+')+$");
var $2342eddbec494676$var$replaceDerive = function(val) {
    return val.replace("'", "");
};
var $2342eddbec494676$var$getMasterKeyFromSeed = function(seed) {
    var h = $6c6d2bbf9aa5b6fa$exports.hmac.create($b647a6fb65a37e6c$exports.sha512, $2342eddbec494676$var$ED25519_CURVE);
    var I = h.update((0, $96a5e6519bfce0e5$export$74f3b7b01e99604c)(seed)).digest();
    var IL = I.slice(0, 32);
    var IR = I.slice(32);
    return {
        key: IL,
        chainCode: IR
    };
};
var $2342eddbec494676$var$CKDPriv = function(param, index) {
    var key = param.key, chainCode = param.chainCode;
    var indexBuffer = new ArrayBuffer(4);
    var cv = new DataView(indexBuffer);
    cv.setUint32(0, index);
    var data = new Uint8Array(1 + key.length + indexBuffer.byteLength);
    data.set(new Uint8Array(1).fill(0));
    data.set(key, 1);
    data.set(new Uint8Array(indexBuffer, 0, indexBuffer.byteLength), key.length + 1);
    var I = $6c6d2bbf9aa5b6fa$exports.hmac.create($b647a6fb65a37e6c$exports.sha512, chainCode).update(data).digest();
    var IL = I.slice(0, 32);
    var IR = I.slice(32);
    return {
        key: IL,
        chainCode: IR
    };
};
var $2342eddbec494676$var$getPublicKey = function(privateKey) {
    var withZeroByte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var keyPair = $2342eddbec494676$var$import_tweetnacl.default.sign.keyPair.fromSeed(privateKey);
    var signPk = keyPair.secretKey.subarray(32);
    var newArr = new Uint8Array(signPk.length + 1);
    newArr.set([
        0
    ]);
    newArr.set(signPk, 1);
    return withZeroByte ? newArr : signPk;
};
var $2342eddbec494676$var$isValidPath = function(path) {
    if (!$2342eddbec494676$var$pathRegex.test(path)) return false;
    return !path.split("/").slice(1).map($2342eddbec494676$var$replaceDerive).some(isNaN);
};
var $2342eddbec494676$var$derivePath = function(path, seed) {
    var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2342eddbec494676$var$HARDENED_OFFSET;
    if (!$2342eddbec494676$var$isValidPath(path)) throw new Error("Invalid derivation path");
    var _getMasterKeyFromSeed = $2342eddbec494676$var$getMasterKeyFromSeed(seed), key = _getMasterKeyFromSeed.key, chainCode = _getMasterKeyFromSeed.chainCode;
    var segments = path.split("/").slice(1).map($2342eddbec494676$var$replaceDerive).map(function(el) {
        return parseInt(el, 10);
    });
    return segments.reduce(function(parentKeys, segment) {
        return $2342eddbec494676$var$CKDPriv(parentKeys, segment + offset);
    }, {
        key: key,
        chainCode: chainCode
    });
};


var $3495806906ff99bc$exports = {};

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
"use strict";
var $3495806906ff99bc$var$__create = Object.create;
var $3495806906ff99bc$var$__defProp = Object.defineProperty;
var $3495806906ff99bc$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $3495806906ff99bc$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $3495806906ff99bc$var$__getProtoOf = Object.getPrototypeOf;
var $3495806906ff99bc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3495806906ff99bc$var$__export = function(target, all) {
    for(var name in all)$3495806906ff99bc$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $3495806906ff99bc$var$__copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!$3495806906ff99bc$var$__hasOwnProp.call(to, key) && key !== except) $3495806906ff99bc$var$__defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = $3495806906ff99bc$var$__getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = $3495806906ff99bc$var$__getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var $3495806906ff99bc$var$__toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? $3495806906ff99bc$var$__create($3495806906ff99bc$var$__getProtoOf(mod)) : {}, $3495806906ff99bc$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $3495806906ff99bc$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var $3495806906ff99bc$var$__toCommonJS = function(mod) {
    return $3495806906ff99bc$var$__copyProps($3495806906ff99bc$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
};
var $3495806906ff99bc$var$publickey_exports = {};
$3495806906ff99bc$var$__export($3495806906ff99bc$var$publickey_exports, {
    Ed25519PublicKey: function() {
        return $3495806906ff99bc$var$Ed25519PublicKey;
    }
});
$3495806906ff99bc$exports = $3495806906ff99bc$var$__toCommonJS($3495806906ff99bc$var$publickey_exports);


var $3495806906ff99bc$var$import_tweetnacl = $3495806906ff99bc$var$__toESM((parcelRequire("b8irb")));



var $3495806906ff99bc$var$PUBLIC_KEY_SIZE = 32;
var $3495806906ff99bc$var$Ed25519PublicKey = /*#__PURE__*/ function(_import_publickey_PublicKey) {
    (0, $cgJ2Y._)(Ed25519PublicKey, _import_publickey_PublicKey);
    var _super = (0, $hKD8n._)(Ed25519PublicKey);
    function Ed25519PublicKey(value) {
        (0, $7dKN1._)(this, Ed25519PublicKey);
        var _this;
        _this = _super.call(this);
        if (typeof value === "string") _this.data = (0, $00e2ec7379a5c39a$export$4f2a95e90ef32c3c)(value);
        else if (value instanceof Uint8Array) _this.data = value;
        else _this.data = Uint8Array.from(value);
        if (_this.data.length !== $3495806906ff99bc$var$PUBLIC_KEY_SIZE) throw new Error("Invalid public key input. Expected ".concat($3495806906ff99bc$var$PUBLIC_KEY_SIZE, " bytes, got ").concat(_this.data.length));
        return _this;
    }
    (0, $eW5pA._)(Ed25519PublicKey, [
        {
            /**
   * Checks if two Ed25519 public keys are equal
   */ key: "equals",
            value: function equals(publicKey) {
                return (0, $2Nfql._)((0, $fG73q._)(Ed25519PublicKey.prototype), "equals", this).call(this, publicKey);
            }
        },
        {
            /**
   * Return the byte array representation of the Ed25519 public key
   */ key: "toRawBytes",
            value: function toRawBytes() {
                return this.data;
            }
        },
        {
            /**
   * Return the Sui address associated with this Ed25519 public key
   */ key: "flag",
            value: function flag() {
                return $eee0db41adbb8a07$exports.SIGNATURE_SCHEME_TO_FLAG["ED25519"];
            }
        },
        {
            key: "verify",
            value: /**
   * Verifies that the signature is valid for for the provided message
   */ function verify(message, signature) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var bytes, parsed;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        if (typeof signature === "string") {
                            parsed = (0, $bcd52e1566c5a424$exports.parseSerializedSignature)(signature);
                            if (parsed.signatureScheme !== "ED25519") throw new Error("Invalid signature scheme");
                            if (!(0, $f18ddaf76dcce603$exports.bytesEqual)(_this.toRawBytes(), parsed.publicKey)) throw new Error("Signature does not match public key");
                            bytes = parsed.signature;
                        } else bytes = signature;
                        return [
                            2,
                            $3495806906ff99bc$var$import_tweetnacl.default.sign.detached.verify(message, bytes, _this.toRawBytes())
                        ];
                    });
                })();
            }
        }
    ]);
    return Ed25519PublicKey;
}($f18ddaf76dcce603$exports.PublicKey);
$3495806906ff99bc$var$Ed25519PublicKey.SIZE = $3495806906ff99bc$var$PUBLIC_KEY_SIZE;


var $c93a88be081350c1$var$DEFAULT_ED25519_DERIVATION_PATH = "m/44'/784'/0'/0'/0'";
var $c93a88be081350c1$var$Ed25519Keypair = /*#__PURE__*/ function(_import_keypair_Keypair) {
    (0, $cgJ2Y._)(Ed25519Keypair, _import_keypair_Keypair);
    var _super = (0, $hKD8n._)(Ed25519Keypair);
    function Ed25519Keypair(keypair) {
        (0, $7dKN1._)(this, Ed25519Keypair);
        var _this;
        _this = _super.call(this);
        if (keypair) _this.keypair = keypair;
        else _this.keypair = $c93a88be081350c1$var$import_tweetnacl.default.sign.keyPair();
        return _this;
    }
    (0, $eW5pA._)(Ed25519Keypair, [
        {
            /**
   * Get the key scheme of the keypair ED25519
   */ key: "getKeyScheme",
            value: function getKeyScheme() {
                return "ED25519";
            }
        },
        {
            /**
   * The public key for this Ed25519 keypair
   */ key: "getPublicKey",
            value: function getPublicKey() {
                return new $3495806906ff99bc$exports.Ed25519PublicKey(this.keypair.publicKey);
            }
        },
        {
            /**
   * The Bech32 secret key string for this Ed25519 keypair
   */ key: "getSecretKey",
            value: function getSecretKey() {
                return (0, $d51b88c4f7df6939$exports.encodeSuiPrivateKey)(this.keypair.secretKey.slice(0, $d51b88c4f7df6939$exports.PRIVATE_KEY_SIZE), this.getKeyScheme());
            }
        },
        {
            key: "sign",
            value: /**
   * Return the signature for the provided data using Ed25519.
   */ function sign(data) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            $c93a88be081350c1$var$import_tweetnacl.default.sign.detached(data, _this.keypair.secretKey)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "generate",
            value: /**
   * Generate a new random Ed25519 keypair
   */ function generate() {
                return new Ed25519Keypair($c93a88be081350c1$var$import_tweetnacl.default.sign.keyPair());
            }
        },
        {
            key: "fromSecretKey",
            value: /**
   * Create a Ed25519 keypair from a raw secret key byte array, also known as seed.
   * This is NOT the private scalar which is result of hashing and bit clamping of
   * the raw secret key.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options: skip secret key validation
   */ function fromSecretKey(secretKey, options) {
                var secretKeyLength = secretKey.length;
                if (secretKeyLength !== $d51b88c4f7df6939$exports.PRIVATE_KEY_SIZE) throw new Error("Wrong secretKey size. Expected ".concat($d51b88c4f7df6939$exports.PRIVATE_KEY_SIZE, " bytes, got ").concat(secretKeyLength, "."));
                var keypair = $c93a88be081350c1$var$import_tweetnacl.default.sign.keyPair.fromSeed(secretKey);
                if (!options || !options.skipValidation) {
                    var encoder = new TextEncoder();
                    var signData = encoder.encode("sui validation");
                    var signature = $c93a88be081350c1$var$import_tweetnacl.default.sign.detached(signData, keypair.secretKey);
                    if (!$c93a88be081350c1$var$import_tweetnacl.default.sign.detached.verify(signData, signature, keypair.publicKey)) throw new Error("provided secretKey is invalid");
                }
                return new Ed25519Keypair(keypair);
            }
        },
        {
            key: "deriveKeypair",
            value: /**
   * Derive Ed25519 keypair from mnemonics and path. The mnemonics must be normalized
   * and validated against the english wordlist.
   *
   * If path is none, it will default to m/44'/784'/0'/0'/0', otherwise the path must
   * be compliant to SLIP-0010 in form m/44'/784'/{account_index}'/{change_index}'/{address_index}'.
   */ function deriveKeypair(mnemonics, path) {
                if (path == null) path = $c93a88be081350c1$var$DEFAULT_ED25519_DERIVATION_PATH;
                if (!(0, $021e843c62eff7b5$exports.isValidHardenedPath)(path)) throw new Error("Invalid derivation path");
                var key = (0, $2342eddbec494676$exports.derivePath)(path, (0, $021e843c62eff7b5$exports.mnemonicToSeedHex)(mnemonics)).key;
                return Ed25519Keypair.fromSecretKey(key);
            }
        },
        {
            key: "deriveKeypairFromSeed",
            value: /**
   * Derive Ed25519 keypair from mnemonicSeed and path.
   *
   * If path is none, it will default to m/44'/784'/0'/0'/0', otherwise the path must
   * be compliant to SLIP-0010 in form m/44'/784'/{account_index}'/{change_index}'/{address_index}'.
   */ function deriveKeypairFromSeed(seedHex, path) {
                if (path == null) path = $c93a88be081350c1$var$DEFAULT_ED25519_DERIVATION_PATH;
                if (!(0, $021e843c62eff7b5$exports.isValidHardenedPath)(path)) throw new Error("Invalid derivation path");
                var key = (0, $2342eddbec494676$exports.derivePath)(path, seedHex).key;
                return Ed25519Keypair.fromSecretKey(key);
            }
        }
    ]);
    return Ed25519Keypair;
}($d51b88c4f7df6939$exports.Keypair);






var $b9zO9 = parcelRequire("b9zO9");

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");
var $779eb0753567c7c5$exports = {};
"use strict";

$779eb0753567c7c5$exports = (parcelRequire("hr76e"));



var $3eX0e = parcelRequire("3eX0e");


var $ilnag = parcelRequire("ilnag");
var $b29ea9007901f005$require$Buffer = $ilnag.Buffer;
var $b29ea9007901f005$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b29ea9007901f005$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b29ea9007901f005$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b29ea9007901f005$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $b29ea9007901f005$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Transport defines the generic interface to share between node/u2f impl
 * A **Descriptor** is a parametric type that is up to be determined for the implementation.
 * it can be for instance an ID, an file path, a URL,...
 */ var $b29ea9007901f005$var$Transport = /** @class */ function() {
    function Transport() {
        var _this = this;
        this.exchangeTimeout = 30000;
        this.unresponsiveTimeout = 15000;
        this.deviceModel = null;
        this._events = new (0, (/*@__PURE__*/$parcel$interopDefault($3eX0e)))();
        /**
         * wrapper on top of exchange to simplify work of the implementation.
         * @param cla
         * @param ins
         * @param p1
         * @param p2
         * @param data
         * @param statusList is a list of accepted status code (shorts). [0x9000] by default
         * @return a Promise of response buffer
         */ this.send = function(cla, ins, p1, p2, data, statusList) {
            if (data === void 0) data = $b29ea9007901f005$require$Buffer.alloc(0);
            if (statusList === void 0) statusList = [
                (0, $2c29c7d2e6f002ec$export$efd5569f873811b1).OK
            ];
            return $b29ea9007901f005$var$__awaiter(_this, void 0, void 0, function() {
                var response, sw;
                return $b29ea9007901f005$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (data.length >= 256) throw new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
                            return [
                                4 /*yield*/ ,
                                this.exchange($b29ea9007901f005$require$Buffer.concat([
                                    $b29ea9007901f005$require$Buffer.from([
                                        cla,
                                        ins,
                                        p1,
                                        p2
                                    ]),
                                    $b29ea9007901f005$require$Buffer.from([
                                        data.length
                                    ]),
                                    data
                                ]))
                            ];
                        case 1:
                            response = _a.sent();
                            sw = response.readUInt16BE(response.length - 2);
                            if (!statusList.some(function(s) {
                                return s === sw;
                            })) throw new (0, $2c29c7d2e6f002ec$export$78917f4716d96cfe)(sw);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
        this.exchangeAtomicImpl = function(f) {
            return $b29ea9007901f005$var$__awaiter(_this, void 0, void 0, function() {
                var resolveBusy, busyPromise, unresponsiveReached, timeout, res;
                var _this = this;
                return $b29ea9007901f005$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.exchangeBusyPromise) throw new (0, $2c29c7d2e6f002ec$export$d6cb63cda2c2b2a4)("An action was already pending on the Ledger device. Please deny or reconnect.");
                            busyPromise = new Promise(function(r) {
                                resolveBusy = r;
                            });
                            this.exchangeBusyPromise = busyPromise;
                            unresponsiveReached = false;
                            timeout = setTimeout(function() {
                                unresponsiveReached = true;
                                _this.emit("unresponsive");
                            }, this.unresponsiveTimeout);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                f()
                            ];
                        case 2:
                            res = _a.sent();
                            if (unresponsiveReached) this.emit("responsive");
                            return [
                                2 /*return*/ ,
                                res
                            ];
                        case 3:
                            clearTimeout(timeout);
                            if (resolveBusy) resolveBusy();
                            this.exchangeBusyPromise = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this._appAPIlock = null;
    }
    /**
     * low level api to communicate with the device
     * This method is for implementations to implement but should not be directly called.
     * Instead, the recommanded way is to use send() method
     * @param apdu the data to send
     * @return a Promise of response data
     */ Transport.prototype.exchange = function(_apdu) {
        throw new Error("exchange not implemented");
    };
    /**
     * set the "scramble key" for the next exchanges with the device.
     * Each App can have a different scramble key and they internally will set it at instanciation.
     * @param key the scramble key
     */ Transport.prototype.setScrambleKey = function(_key) {};
    /**
     * close the exchange with the device.
     * @return a Promise that ends when the transport is closed.
     */ Transport.prototype.close = function() {
        return Promise.resolve();
    };
    /**
     * Listen to an event on an instance of transport.
     * Transport implementation can have specific events. Here is the common events:
     * * `"disconnect"` : triggered if Transport is disconnected
     */ Transport.prototype.on = function(eventName, cb) {
        this._events.on(eventName, cb);
    };
    /**
     * Stop listening to an event on an instance of transport.
     */ Transport.prototype.off = function(eventName, cb) {
        this._events.removeListener(eventName, cb);
    };
    Transport.prototype.emit = function(event) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this._events).emit.apply(_a, $b29ea9007901f005$var$__spreadArray([
            event
        ], $b29ea9007901f005$var$__read(args), false));
    };
    /**
     * Enable or not logs of the binary exchange
     */ Transport.prototype.setDebugMode = function() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    };
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ Transport.prototype.setExchangeTimeout = function(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    };
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ Transport.prototype.setExchangeUnresponsiveTimeout = function(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    };
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ Transport.create = function(openTimeout, listenTimeout) {
        var _this = this;
        if (openTimeout === void 0) openTimeout = 3000;
        return new Promise(function(resolve, reject) {
            var found = false;
            var sub = _this.listen({
                next: function next(e) {
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    _this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: function error(e) {
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: function complete() {
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)(_this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            var listenTimeoutId = listenTimeout ? setTimeout(function() {
                sub.unsubscribe();
                reject(new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)(_this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    };
    Transport.prototype.decorateAppAPIMethods = function(self, methods, scrambleKey) {
        var e_1, _a;
        try {
            for(var methods_1 = $b29ea9007901f005$var$__values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()){
                var methodName = methods_1_1.value;
                self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (methods_1_1 && !methods_1_1.done && (_a = methods_1["return"])) _a.call(methods_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Transport.prototype.decorateAppAPIMethod = function(methodName, f, ctx, scrambleKey) {
        var _this = this;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $b29ea9007901f005$var$__awaiter(_this, void 0, void 0, function() {
                var _appAPIlock;
                return $b29ea9007901f005$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _appAPIlock = this._appAPIlock;
                            if (_appAPIlock) return [
                                2 /*return*/ ,
                                Promise.reject(new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"))
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            this._appAPIlock = methodName;
                            this.setScrambleKey(scrambleKey);
                            return [
                                4 /*yield*/ ,
                                f.apply(ctx, args)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            this._appAPIlock = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
    Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
    return Transport;
}();
var $b29ea9007901f005$export$2e2bcd8739ae039 = $b29ea9007901f005$var$Transport;


/**
 * A Log object
 */ var $8a000dc8abadb981$var$id = 0;
var $8a000dc8abadb981$var$subscribers = [];
var $8a000dc8abadb981$export$bef1f36f5486a6a3 = function(type, message, data) {
    var obj = {
        type: type,
        id: String(++$8a000dc8abadb981$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $8a000dc8abadb981$var$dispatch(obj);
};
var $8a000dc8abadb981$export$63174c828edd6ff8 = function(cb) {
    $8a000dc8abadb981$var$subscribers.push(cb);
    return function() {
        var i = $8a000dc8abadb981$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $8a000dc8abadb981$var$subscribers[i] = $8a000dc8abadb981$var$subscribers[$8a000dc8abadb981$var$subscribers.length - 1];
            $8a000dc8abadb981$var$subscribers.pop();
        }
    };
};
function $8a000dc8abadb981$var$dispatch(log) {
    for(var i = 0; i < $8a000dc8abadb981$var$subscribers.length; i++)try {
        $8a000dc8abadb981$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
} // for debug purpose
if (typeof window !== "undefined") window.__ledgerLogsListen = $8a000dc8abadb981$export$63174c828edd6ff8;


/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ var $fb5846adc48167d5$var$errorClasses = {};
var $fb5846adc48167d5$var$deserializers = {};
var $fb5846adc48167d5$export$ff6248acd0c27a3f = function addCustomErrorDeserializer(name, deserializer) {
    $fb5846adc48167d5$var$deserializers[name] = deserializer;
};
var $fb5846adc48167d5$export$94baff7bf5134824 = function createCustomErrorClass(name) {
    var C = function CustomError(message, fields) {
        Object.assign(this, fields);
        this.name = name;
        this.message = message || name;
        this.stack = new Error().stack;
    };
    C.prototype = new Error();
    $fb5846adc48167d5$var$errorClasses[name] = C;
    return C;
};
// inspired from https://github.com/programble/errio/blob/master/index.js
var $fb5846adc48167d5$export$64cddc1e268e9046 = function deserializeError1(object) {
    if (typeof object === "object" && object) {
        try {
            // $FlowFixMe FIXME HACK
            var msg = JSON.parse(object.message);
            if (msg.message && msg.name) object = msg;
        } catch (e) {
        // nothing
        }
        var error = void 0;
        if (typeof object.name === "string") {
            var name_1 = object.name;
            var des = $fb5846adc48167d5$var$deserializers[name_1];
            if (des) error = des(object);
            else {
                var constructor = name_1 === "Error" ? Error : $fb5846adc48167d5$var$errorClasses[name_1];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name_1 + "'");
                    constructor = $fb5846adc48167d5$export$94baff7bf5134824(name_1);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(var prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else error = new Error(object.message);
        if (!error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $fb5846adc48167d5$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
// inspired from https://github.com/sindresorhus/serialize-error/blob/master/index.js
var $fb5846adc48167d5$export$46ff38bc6bdea8fb = function serializeError(value) {
    if (!value) return value;
    if (typeof value === "object") return $fb5846adc48167d5$var$destroyCircular(value, []);
    if (typeof value === "function") return "[Function: " + (value.name || "anonymous") + "]";
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $fb5846adc48167d5$var$destroyCircular(from, seen) {
    var to = {};
    seen.push(from);
    for(var _i = 0, _a = Object.keys(from); _i < _a.length; _i++){
        var key = _a[_i];
        var value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $fb5846adc48167d5$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}
var $fb5846adc48167d5$export$d7dd32b41fc9c3a0 = $fb5846adc48167d5$export$94baff7bf5134824("AccountNameRequired");
var $fb5846adc48167d5$export$fb9db505804530ec = $fb5846adc48167d5$export$94baff7bf5134824("AccountNotSupported");
var $fb5846adc48167d5$export$c9d6bf2b06944665 = $fb5846adc48167d5$export$94baff7bf5134824("AmountRequired");
var $fb5846adc48167d5$export$2628fce2396c23c2 = $fb5846adc48167d5$export$94baff7bf5134824("BluetoothRequired");
var $fb5846adc48167d5$export$75f8b0767ef406f1 = $fb5846adc48167d5$export$94baff7bf5134824("BtcUnmatchedApp");
var $fb5846adc48167d5$export$f60aa84fd00bc3ee = $fb5846adc48167d5$export$94baff7bf5134824("CantOpenDevice");
var $fb5846adc48167d5$export$fc0260506e4022ab = $fb5846adc48167d5$export$94baff7bf5134824("CashAddrNotSupported");
var $fb5846adc48167d5$export$e0b1ec53ba36e221 = $fb5846adc48167d5$export$94baff7bf5134824("CurrencyNotSupported");
var $fb5846adc48167d5$export$fa9aacd48d3a45c2 = $fb5846adc48167d5$export$94baff7bf5134824("DeviceAppVerifyNotSupported");
var $fb5846adc48167d5$export$f21ce806524ab8d4 = $fb5846adc48167d5$export$94baff7bf5134824("DeviceGenuineSocketEarlyClose");
var $fb5846adc48167d5$export$9c30dc6872fcd74c = $fb5846adc48167d5$export$94baff7bf5134824("DeviceNotGenuine");
var $fb5846adc48167d5$export$1d5ae41b109edf1f = $fb5846adc48167d5$export$94baff7bf5134824("DeviceOnDashboardExpected");
var $fb5846adc48167d5$export$8eecf64ec9a8cfd7 = $fb5846adc48167d5$export$94baff7bf5134824("DeviceOnDashboardUnexpected");
var $fb5846adc48167d5$export$a5e2071f1ac48fdd = $fb5846adc48167d5$export$94baff7bf5134824("DeviceInOSUExpected");
var $fb5846adc48167d5$export$3be6e7231165f4ac = $fb5846adc48167d5$export$94baff7bf5134824("DeviceHalted");
var $fb5846adc48167d5$export$fa7bfae6dce03474 = $fb5846adc48167d5$export$94baff7bf5134824("DeviceNameInvalid");
var $fb5846adc48167d5$export$bcce4e5aded80ca0 = $fb5846adc48167d5$export$94baff7bf5134824("DeviceSocketFail");
var $fb5846adc48167d5$export$944a0f9a7cc1e03a = $fb5846adc48167d5$export$94baff7bf5134824("DeviceSocketNoBulkStatus");
var $fb5846adc48167d5$export$1e42f3936938e063 = $fb5846adc48167d5$export$94baff7bf5134824("DisconnectedDevice");
var $fb5846adc48167d5$export$2a60f41a2ed2742 = $fb5846adc48167d5$export$94baff7bf5134824("DisconnectedDeviceDuringOperation");
var $fb5846adc48167d5$export$cfbd0adf8f9fdaf9 = $fb5846adc48167d5$export$94baff7bf5134824("EnpointConfig");
var $fb5846adc48167d5$export$96d8d3c501f1625 = $fb5846adc48167d5$export$94baff7bf5134824("EthAppPleaseEnableContractData");
var $fb5846adc48167d5$export$37b49553b7172cb1 = $fb5846adc48167d5$export$94baff7bf5134824("FeeEstimationFailed");
var $fb5846adc48167d5$export$d00fd6c398a70fd9 = $fb5846adc48167d5$export$94baff7bf5134824("FirmwareNotRecognized");
var $fb5846adc48167d5$export$3dc3bbf8c134219c = $fb5846adc48167d5$export$94baff7bf5134824("HardResetFail");
var $fb5846adc48167d5$export$5e8f7ae1054a2777 = $fb5846adc48167d5$export$94baff7bf5134824("InvalidXRPTag");
var $fb5846adc48167d5$export$953b602d2269ceba = $fb5846adc48167d5$export$94baff7bf5134824("InvalidAddress");
var $fb5846adc48167d5$export$bbdaf7c77a7508eb = $fb5846adc48167d5$export$94baff7bf5134824("InvalidAddressBecauseDestinationIsAlsoSource");
var $fb5846adc48167d5$export$882967e2980534f9 = $fb5846adc48167d5$export$94baff7bf5134824("LatestMCUInstalledError");
var $fb5846adc48167d5$export$59772a13ac97df0e = $fb5846adc48167d5$export$94baff7bf5134824("UnknownMCU");
var $fb5846adc48167d5$export$26bf4f7c63d50901 = $fb5846adc48167d5$export$94baff7bf5134824("LedgerAPIError");
var $fb5846adc48167d5$export$fdab6afd1b1820af = $fb5846adc48167d5$export$94baff7bf5134824("LedgerAPIErrorWithMessage");
var $fb5846adc48167d5$export$c2996b38942cf758 = $fb5846adc48167d5$export$94baff7bf5134824("LedgerAPINotAvailable");
var $fb5846adc48167d5$export$3d81abcc61613a27 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerAppAlreadyInstalled");
var $fb5846adc48167d5$export$87a9bff9fff141e2 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerAppRelyOnBTC");
var $fb5846adc48167d5$export$86581a722c4238c0 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerAppDepInstallRequired");
var $fb5846adc48167d5$export$267a8476044885dd = $fb5846adc48167d5$export$94baff7bf5134824("ManagerAppDepUninstallRequired");
var $fb5846adc48167d5$export$bb771ca417eca344 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerDeviceLocked");
var $fb5846adc48167d5$export$b634ce25e3ff5229 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerFirmwareNotEnoughSpace");
var $fb5846adc48167d5$export$2d26f4eadfe37285 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerNotEnoughSpace");
var $fb5846adc48167d5$export$ceb7f9bef5a1e481 = $fb5846adc48167d5$export$94baff7bf5134824("ManagerUninstallBTCDep");
var $fb5846adc48167d5$export$baadb6886fde1621 = $fb5846adc48167d5$export$94baff7bf5134824("NetworkDown");
var $fb5846adc48167d5$export$5cbfa0659f97216a = $fb5846adc48167d5$export$94baff7bf5134824("NoAddressesFound");
var $fb5846adc48167d5$export$9e00aead3515e5c9 = $fb5846adc48167d5$export$94baff7bf5134824("NotEnoughBalance");
var $fb5846adc48167d5$export$5ed90e0e011f4857 = $fb5846adc48167d5$export$94baff7bf5134824("NotEnoughBalanceToDelegate");
var $fb5846adc48167d5$export$75178c95e66d9630 = $fb5846adc48167d5$export$94baff7bf5134824("NotEnoughBalanceInParentAccount");
var $fb5846adc48167d5$export$e3e2865b29f7e0b0 = $fb5846adc48167d5$export$94baff7bf5134824("NotEnoughSpendableBalance");
var $fb5846adc48167d5$export$a84b3634866707ea = $fb5846adc48167d5$export$94baff7bf5134824("NotEnoughBalanceBecauseDestinationNotCreated");
var $fb5846adc48167d5$export$a282f858b69a7326 = $fb5846adc48167d5$export$94baff7bf5134824("NoAccessToCamera");
var $fb5846adc48167d5$export$5111c405c5cacc97 = $fb5846adc48167d5$export$94baff7bf5134824("NotEnoughGas");
var $fb5846adc48167d5$export$626e1fd20d22139c = $fb5846adc48167d5$export$94baff7bf5134824("NotSupportedLegacyAddress");
var $fb5846adc48167d5$export$f919e2c9c746346b = $fb5846adc48167d5$export$94baff7bf5134824("GasLessThanEstimate");
var $fb5846adc48167d5$export$22c5aa8937c5b423 = $fb5846adc48167d5$export$94baff7bf5134824("PasswordsDontMatch");
var $fb5846adc48167d5$export$f57670cd1aaf386 = $fb5846adc48167d5$export$94baff7bf5134824("PasswordIncorrect");
var $fb5846adc48167d5$export$3ba22bf10deb1448 = $fb5846adc48167d5$export$94baff7bf5134824("RecommendSubAccountsToEmpty");
var $fb5846adc48167d5$export$33f73085e1b7871b = $fb5846adc48167d5$export$94baff7bf5134824("RecommendUndelegation");
var $fb5846adc48167d5$export$cd4d967a66d81060 = $fb5846adc48167d5$export$94baff7bf5134824("TimeoutTagged");
var $fb5846adc48167d5$export$9375635756d6156e = $fb5846adc48167d5$export$94baff7bf5134824("UnexpectedBootloader");
var $fb5846adc48167d5$export$90478a5d08d6c2d7 = $fb5846adc48167d5$export$94baff7bf5134824("MCUNotGenuineToDashboard");
var $fb5846adc48167d5$export$132f0197eaa65535 = $fb5846adc48167d5$export$94baff7bf5134824("RecipientRequired");
var $fb5846adc48167d5$export$7aee729193ab77ba = $fb5846adc48167d5$export$94baff7bf5134824("UnavailableTezosOriginatedAccountReceive");
var $fb5846adc48167d5$export$4ec11dc947a3c9d6 = $fb5846adc48167d5$export$94baff7bf5134824("UnavailableTezosOriginatedAccountSend");
var $fb5846adc48167d5$export$5e3ed85b946872a1 = $fb5846adc48167d5$export$94baff7bf5134824("UpdateFetchFileFail");
var $fb5846adc48167d5$export$5db6383ad081f01e = $fb5846adc48167d5$export$94baff7bf5134824("UpdateIncorrectHash");
var $fb5846adc48167d5$export$92c199eb837d8df8 = $fb5846adc48167d5$export$94baff7bf5134824("UpdateIncorrectSig");
var $fb5846adc48167d5$export$85e0c017833c894c = $fb5846adc48167d5$export$94baff7bf5134824("UpdateYourApp");
var $fb5846adc48167d5$export$84115f1b54c874b3 = $fb5846adc48167d5$export$94baff7bf5134824("UserRefusedDeviceNameChange");
var $fb5846adc48167d5$export$3f4864efb1638333 = $fb5846adc48167d5$export$94baff7bf5134824("UserRefusedAddress");
var $fb5846adc48167d5$export$d777e0ef77faca34 = $fb5846adc48167d5$export$94baff7bf5134824("UserRefusedFirmwareUpdate");
var $fb5846adc48167d5$export$3d8a4f08cd3eb133 = $fb5846adc48167d5$export$94baff7bf5134824("UserRefusedAllowManager");
var $fb5846adc48167d5$export$db9b724c3524b5d6 = $fb5846adc48167d5$export$94baff7bf5134824("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
var $fb5846adc48167d5$export$9642f061c2494239 = $fb5846adc48167d5$export$94baff7bf5134824("TransportOpenUserCancelled");
var $fb5846adc48167d5$export$fd71e3a51c4bf0ae = $fb5846adc48167d5$export$94baff7bf5134824("TransportInterfaceNotAvailable");
var $fb5846adc48167d5$export$d6cb63cda2c2b2a4 = $fb5846adc48167d5$export$94baff7bf5134824("TransportRaceCondition");
var $fb5846adc48167d5$export$c0ffbdd94649bd06 = $fb5846adc48167d5$export$94baff7bf5134824("TransportWebUSBGestureRequired");
var $fb5846adc48167d5$export$4800af3cc6204928 = $fb5846adc48167d5$export$94baff7bf5134824("DeviceShouldStayInApp");
var $fb5846adc48167d5$export$101490ec073327e1 = $fb5846adc48167d5$export$94baff7bf5134824("WebsocketConnectionError");
var $fb5846adc48167d5$export$219228963d86b069 = $fb5846adc48167d5$export$94baff7bf5134824("WebsocketConnectionFailed");
var $fb5846adc48167d5$export$25b49ca0efdfe5d1 = $fb5846adc48167d5$export$94baff7bf5134824("WrongDeviceForAccount");
var $fb5846adc48167d5$export$63498b46122d8a23 = $fb5846adc48167d5$export$94baff7bf5134824("WrongAppForCurrency");
var $fb5846adc48167d5$export$707f317a4761c46d = $fb5846adc48167d5$export$94baff7bf5134824("ETHAddressNonEIP");
var $fb5846adc48167d5$export$a5d8da2f27618c16 = $fb5846adc48167d5$export$94baff7bf5134824("CantScanQRCode");
var $fb5846adc48167d5$export$3f2d8a7775aab6cc = $fb5846adc48167d5$export$94baff7bf5134824("FeeNotLoaded");
var $fb5846adc48167d5$export$ffbf6641e9ab88d3 = $fb5846adc48167d5$export$94baff7bf5134824("FeeRequired");
var $fb5846adc48167d5$export$53e797c2fa09aff3 = $fb5846adc48167d5$export$94baff7bf5134824("FeeTooHigh");
var $fb5846adc48167d5$export$2aca4567d80fd933 = $fb5846adc48167d5$export$94baff7bf5134824("SyncError");
var $fb5846adc48167d5$export$a2d6658d365c43df = $fb5846adc48167d5$export$94baff7bf5134824("PairingFailed");
var $fb5846adc48167d5$export$3f7ba18f3c84cced = $fb5846adc48167d5$export$94baff7bf5134824("GenuineCheckFailed");
var $fb5846adc48167d5$export$437e6aac14cab3d9 = $fb5846adc48167d5$export$94baff7bf5134824("LedgerAPI4xx");
var $fb5846adc48167d5$export$309835543e52bf92 = $fb5846adc48167d5$export$94baff7bf5134824("LedgerAPI5xx");
var $fb5846adc48167d5$export$c282cdb2f7fdc27a = $fb5846adc48167d5$export$94baff7bf5134824("FirmwareOrAppUpdateRequired");
// db stuff, no need to translate
var $fb5846adc48167d5$export$d3cadb9f4e1fa40d = $fb5846adc48167d5$export$94baff7bf5134824("NoDBPathGiven");
var $fb5846adc48167d5$export$de46c919e379f03f = $fb5846adc48167d5$export$94baff7bf5134824("DBWrongPassword");
var $fb5846adc48167d5$export$e1c94c135b0a553e = $fb5846adc48167d5$export$94baff7bf5134824("DBNotReset");
/**
 * TransportError is used for any generic transport errors.
 * e.g. Error thrown when data received by exchanges are incorrect or if exchanged failed to communicate with the device for various reason.
 */ function $fb5846adc48167d5$export$8e68de6fb26f2236(message, id) {
    this.name = "TransportError";
    this.message = message;
    this.stack = new Error().stack;
    this.id = id;
}
$fb5846adc48167d5$export$8e68de6fb26f2236.prototype = new Error();
$fb5846adc48167d5$export$ff6248acd0c27a3f("TransportError", function(e) {
    return new $fb5846adc48167d5$export$8e68de6fb26f2236(e.message, e.id);
});
var $fb5846adc48167d5$export$efd5569f873811b1 = {
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    INCORRECT_LENGTH: 0x6700,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    INCORRECT_DATA: 0x6a80,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    FILE_ALREADY_EXISTS: 0x6a89,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    CLA_NOT_SUPPORTED: 0x6e00,
    TECHNICAL_PROBLEM: 0x6f00,
    OK: 0x9000,
    MEMORY_PROBLEM: 0x9240,
    NO_EF_SELECTED: 0x9400,
    INVALID_OFFSET: 0x9402,
    FILE_NOT_FOUND: 0x9404,
    INCONSISTENT_FILE: 0x9408,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    INVALID_KCV: 0x9485,
    CODE_NOT_INITIALIZED: 0x9802,
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CONTRADICTION_INVALIDATION: 0x9810,
    CODE_BLOCKED: 0x9840,
    MAX_VALUE_REACHED: 0x9850,
    GP_AUTH_FAILED: 0x6300,
    LICENSING: 0x6f42,
    HALTED: 0x6faa
};
function $fb5846adc48167d5$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
/**
 * Error thrown when a device returned a non success status.
 * the error.statusCode is one of the `StatusCodes` exported by this library.
 */ function $fb5846adc48167d5$export$78917f4716d96cfe(statusCode) {
    this.name = "TransportStatusError";
    var statusText = Object.keys($fb5846adc48167d5$export$efd5569f873811b1).find(function(k) {
        return $fb5846adc48167d5$export$efd5569f873811b1[k] === statusCode;
    }) || "UNKNOWN_ERROR";
    var smsg = $fb5846adc48167d5$export$799566c03457ebd5(statusCode) || statusText;
    var statusCodeStr = statusCode.toString(16);
    this.message = "Ledger device: " + smsg + " (0x" + statusCodeStr + ")";
    this.stack = new Error().stack;
    this.statusCode = statusCode;
    this.statusText = statusText;
}
$fb5846adc48167d5$export$78917f4716d96cfe.prototype = new Error();
$fb5846adc48167d5$export$ff6248acd0c27a3f("TransportStatusError", function(e) {
    return new $fb5846adc48167d5$export$78917f4716d96cfe(e.statusCode);
});



var $ilnag = parcelRequire("ilnag");
var $6878a85554e577b6$require$Buffer = $ilnag.Buffer;
function $6878a85554e577b6$var$wrapU2FTransportError(originalError, message, id) {
    var err = new (0, $fb5846adc48167d5$export$8e68de6fb26f2236)(message, id); // $FlowFixMe
    err.originalError = originalError;
    return err;
}
function $6878a85554e577b6$var$wrapApdu(apdu, key) {
    var result = $6878a85554e577b6$require$Buffer.alloc(apdu.length);
    for(var i = 0; i < apdu.length; i++)result[i] = apdu[i] ^ key[i % key.length];
    return result;
} // Convert from normal to web-safe, strip trailing "="s
var $6878a85554e577b6$var$webSafe64 = function(base64) {
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}; // Convert from web-safe to normal, add trailing "="s
var $6878a85554e577b6$var$normal64 = function(base64) {
    return base64.replace(/-/g, "+").replace(/_/g, "/") + "==".substring(0, 3 * base64.length % 4);
};
function $6878a85554e577b6$var$attemptExchange(apdu, timeoutMillis, scrambleKey, unwrap) {
    var keyHandle = $6878a85554e577b6$var$wrapApdu(apdu, scrambleKey);
    var challenge = $6878a85554e577b6$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
    var signRequest = {
        version: "U2F_V2",
        keyHandle: $6878a85554e577b6$var$webSafe64(keyHandle.toString("base64")),
        challenge: $6878a85554e577b6$var$webSafe64(challenge.toString("base64")),
        appId: location.origin
    };
    (0, $8a000dc8abadb981$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
    return (0, $779eb0753567c7c5$exports.sign)(signRequest, timeoutMillis / 1000).then(function(response) {
        var signatureData = response.signatureData;
        if (typeof signatureData === "string") {
            var data = $6878a85554e577b6$require$Buffer.from($6878a85554e577b6$var$normal64(signatureData), "base64");
            var result;
            if (!unwrap) result = data;
            else result = data.slice(5);
            (0, $8a000dc8abadb981$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
            return result;
        } else throw response;
    });
}
var $6878a85554e577b6$var$transportInstances = [];
function $6878a85554e577b6$var$emitDisconnect() {
    $6878a85554e577b6$var$transportInstances.forEach(function(t) {
        return t.emit("disconnect");
    });
    $6878a85554e577b6$var$transportInstances = [];
}
function $6878a85554e577b6$var$isTimeoutU2FError(u2fError) {
    return u2fError.metaData.code === 5;
}
var $6878a85554e577b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Transport) {
    "use strict";
    (0, $cgJ2Y._)(TransportU2F, Transport);
    var _super = (0, $hKD8n._)(TransportU2F);
    function TransportU2F() {
        (0, $7dKN1._)(this, TransportU2F);
        var _this;
        _this = _super.call(this);
        _this.scrambleKey = void 0;
        _this.unwrap = true;
        $6878a85554e577b6$var$transportInstances.push((0, $b9zO9._)(_this));
        return _this;
    }
    (0, $eW5pA._)(TransportU2F, [
        {
            key: "exchange",
            value: /**
   * Exchange with the device using APDU protocol.
   * @param apdu
   * @returns a promise of apdu response
   */ function exchange(apdu) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var e, isU2FError;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $6878a85554e577b6$var$attemptExchange(apdu, _this.exchangeTimeout, _this.scrambleKey, _this.unwrap)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                e = _state.sent();
                                isU2FError = typeof e.metaData === "object";
                                if (isU2FError) {
                                    if ($6878a85554e577b6$var$isTimeoutU2FError(e)) $6878a85554e577b6$var$emitDisconnect();
                                     // the wrapping make error more usable and "printable" to the end user.
                                    throw $6878a85554e577b6$var$wrapU2FTransportError(e, "Failed to sign with Ledger device: U2F " + e.metaData.type, "U2F_" + e.metaData.code);
                                } else throw e;
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   */ key: "setScrambleKey",
            value: function setScrambleKey(scrambleKey) {
                this.scrambleKey = $6878a85554e577b6$require$Buffer.from(scrambleKey, "ascii");
            }
        },
        {
            /**
   */ key: "setUnwrap",
            value: function setUnwrap(unwrap) {
                this.unwrap = unwrap;
            }
        },
        {
            key: "close",
            value: function close() {
                // u2f have no way to clean things up
                return Promise.resolve();
            }
        }
    ], [
        {
            key: "open",
            value: /*
   */ /*
   */ /**
   * static function to create a new Transport from a connected Ledger device discoverable via U2F (browser support)
   */ function open(_) {
                var _openTimeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5000;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            new TransportU2F()
                        ];
                    });
                })();
            }
        }
    ]);
    return TransportU2F;
}((0, $b29ea9007901f005$export$2e2bcd8739ae039));
$6878a85554e577b6$export$2e2bcd8739ae039.isSupported = (0, $779eb0753567c7c5$exports.isSupported);
$6878a85554e577b6$export$2e2bcd8739ae039.list = function() {
    return (0, $779eb0753567c7c5$exports.isSupported)().then(function(supported) {
        return supported ? [
            null
        ] : [];
    });
};
$6878a85554e577b6$export$2e2bcd8739ae039.listen = function(observer) {
    var unsubscribed = false;
    (0, $779eb0753567c7c5$exports.isSupported)().then(function(supported) {
        if (unsubscribed) return;
        if (supported) {
            observer.next({
                type: "add",
                descriptor: null
            });
            observer.complete();
        } else observer.error(new (0, $fb5846adc48167d5$export$8e68de6fb26f2236)("U2F browser support is needed for Ledger. Please use Chrome, Opera or Firefox with a U2F extension. Also make sure you're on an HTTPS connection", "U2FNotSupported"));
    });
    return {
        unsubscribe: function() {
            unsubscribed = true;
        }
    };
};





var $ilnag = parcelRequire("ilnag");
var $33bbf9120198c227$require$Buffer = $ilnag.Buffer;
var $33bbf9120198c227$var$Tag = 0x05;
function $33bbf9120198c227$var$asUInt16BE(value) {
    var b = $33bbf9120198c227$require$Buffer.alloc(2);
    b.writeUInt16BE(value, 0);
    return b;
}
var $33bbf9120198c227$var$initialAcc = {
    data: $33bbf9120198c227$require$Buffer.alloc(0),
    dataLength: 0,
    sequence: 0
};
/**
 *
 */ var $33bbf9120198c227$var$createHIDframing = function createHIDframing(channel, packetSize) {
    return {
        makeBlocks: function makeBlocks(apdu) {
            var data = $33bbf9120198c227$require$Buffer.concat([
                $33bbf9120198c227$var$asUInt16BE(apdu.length),
                apdu
            ]);
            var blockSize = packetSize - 5;
            var nbBlocks = Math.ceil(data.length / blockSize);
            data = $33bbf9120198c227$require$Buffer.concat([
                data,
                $33bbf9120198c227$require$Buffer.alloc(nbBlocks * blockSize - data.length + 1).fill(0)
            ]);
            var blocks = [];
            for(var i = 0; i < nbBlocks; i++){
                var head = $33bbf9120198c227$require$Buffer.alloc(5);
                head.writeUInt16BE(channel, 0);
                head.writeUInt8($33bbf9120198c227$var$Tag, 2);
                head.writeUInt16BE(i, 3);
                var chunk = data.slice(i * blockSize, (i + 1) * blockSize);
                blocks.push($33bbf9120198c227$require$Buffer.concat([
                    head,
                    chunk
                ]));
            }
            return blocks;
        },
        reduceResponse: function reduceResponse(acc, chunk) {
            var _a = acc || $33bbf9120198c227$var$initialAcc, data = _a.data, dataLength = _a.dataLength, sequence = _a.sequence;
            if (chunk.readUInt16BE(0) !== channel) throw new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)("Invalid channel", "InvalidChannel");
            if (chunk.readUInt8(2) !== $33bbf9120198c227$var$Tag) throw new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)("Invalid tag", "InvalidTag");
            if (chunk.readUInt16BE(3) !== sequence) throw new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)("Invalid sequence", "InvalidSequence");
            if (!acc) dataLength = chunk.readUInt16BE(5);
            sequence++;
            var chunkData = chunk.slice(acc ? 5 : 7);
            data = $33bbf9120198c227$require$Buffer.concat([
                data,
                chunkData
            ]);
            if (data.length > dataLength) data = data.slice(0, dataLength);
            return {
                data: data,
                dataLength: dataLength,
                sequence: sequence
            };
        },
        getReducedResult: function getReducedResult(acc) {
            if (acc && acc.dataLength === acc.data.length) return acc.data;
        }
    };
};
var $33bbf9120198c227$export$2e2bcd8739ae039 = $33bbf9120198c227$var$createHIDframing;


var $6235a841c02293b3$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $ib1AC = parcelRequire("ib1AC");









































$6235a841c02293b3$exports = {
    re: $ib1AC.re,
    src: $ib1AC.src,
    tokens: $ib1AC.t,
    SEMVER_SPEC_VERSION: (parcelRequire("58Fx4")).SEMVER_SPEC_VERSION,
    SemVer: (parcelRequire("gwDzE")),
    compareIdentifiers: (parcelRequire("c1LTT")).compareIdentifiers,
    rcompareIdentifiers: (parcelRequire("c1LTT")).rcompareIdentifiers,
    parse: (parcelRequire("hkVtd")),
    valid: (parcelRequire("5r19k")),
    clean: (parcelRequire("3X1yG")),
    inc: (parcelRequire("ciEIn")),
    diff: (parcelRequire("aRzGx")),
    major: (parcelRequire("lS2mz")),
    minor: (parcelRequire("izrOF")),
    patch: (parcelRequire("c2m8w")),
    prerelease: (parcelRequire("8wcJT")),
    compare: (parcelRequire("1gCWi")),
    rcompare: (parcelRequire("jhv0l")),
    compareLoose: (parcelRequire("i1Epj")),
    compareBuild: (parcelRequire("6JgXS")),
    sort: (parcelRequire("4TpM6")),
    rsort: (parcelRequire("h7HZJ")),
    gt: (parcelRequire("6vAgh")),
    lt: (parcelRequire("6dKLA")),
    eq: (parcelRequire("dnnWP")),
    neq: (parcelRequire("9tBKZ")),
    gte: (parcelRequire("66BFD")),
    lte: (parcelRequire("ioCQv")),
    cmp: (parcelRequire("9iuUs")),
    coerce: (parcelRequire("lRNOe")),
    Comparator: (parcelRequire("ijfhR")),
    Range: (parcelRequire("8J7OE")),
    satisfies: (parcelRequire("7DhOR")),
    toComparators: (parcelRequire("5jM8E")),
    maxSatisfying: (parcelRequire("8RqiC")),
    minSatisfying: (parcelRequire("9Y9Js")),
    minVersion: (parcelRequire("4zclB")),
    validRange: (parcelRequire("ekRHf")),
    outside: (parcelRequire("1U3F9")),
    gtr: (parcelRequire("1IwIP")),
    ltr: (parcelRequire("Nnt5Q")),
    intersects: (parcelRequire("kQfnz")),
    simplifyRange: (parcelRequire("6RKuc")),
    subset: (parcelRequire("gtK9J"))
};


var $4e9ee4c7b8101fc3$var$__assign = undefined && undefined.__assign || function() {
    $4e9ee4c7b8101fc3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4e9ee4c7b8101fc3$var$__assign.apply(this, arguments);
};
var $4e9ee4c7b8101fc3$var$_a;
var $4e9ee4c7b8101fc3$export$36f742de2ed7d90b = 0x01;
var $4e9ee4c7b8101fc3$export$54bc2e040474338c = 0x02;
var $4e9ee4c7b8101fc3$export$9368aec5a4b02506 = 0x04;
var $4e9ee4c7b8101fc3$export$95f5e559ebc551b3 = 0x08;
var $4e9ee4c7b8101fc3$export$18b064749618be01 = 0x10;
var $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549;
(function(DeviceModelId) {
    DeviceModelId["blue"] = "blue";
    DeviceModelId["nanoS"] = "nanoS";
    DeviceModelId["nanoSP"] = "nanoSP";
    DeviceModelId["nanoX"] = "nanoX";
    DeviceModelId["nanoFTS"] = "nanoFTS";
})($4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549 || ($4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549 = {}));
var $4e9ee4c7b8101fc3$var$devices = ($4e9ee4c7b8101fc3$var$_a = {}, $4e9ee4c7b8101fc3$var$_a[$4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.blue] = {
    id: $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.blue,
    productName: "Ledger\xa0Blue",
    productIdMM: 0x00,
    legacyUsbProductId: 0x0000,
    usbOnly: true,
    memorySize: 491520,
    masks: [
        0x31000000,
        0x31010000
    ],
    getBlockSize: function getBlockSize(_firwareVersion) {
        return 4096;
    }
}, $4e9ee4c7b8101fc3$var$_a[$4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoS] = {
    id: $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoS,
    productName: "Ledger\xa0Nano\xa0S",
    productIdMM: 0x10,
    legacyUsbProductId: 0x0001,
    usbOnly: true,
    memorySize: 327680,
    masks: [
        0x31100000
    ],
    getBlockSize: function getBlockSize(firmwareVersion) {
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6235a841c02293b3$exports))).lt((_a = (0, (/*@__PURE__*/$parcel$interopDefault($6235a841c02293b3$exports))).coerce(firmwareVersion)) !== null && _a !== void 0 ? _a : "", "2.0.0") ? 4096 : 2048;
    }
}, $4e9ee4c7b8101fc3$var$_a[$4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoSP] = {
    id: $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 0x50,
    legacyUsbProductId: 0x0005,
    usbOnly: true,
    memorySize: 1572864,
    masks: [
        0x33100000
    ],
    getBlockSize: function getBlockSize(_firmwareVersion) {
        return 32;
    }
}, $4e9ee4c7b8101fc3$var$_a[$4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoX] = {
    id: $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoX,
    productName: "Ledger\xa0Nano\xa0X",
    productIdMM: 0x40,
    legacyUsbProductId: 0x0004,
    usbOnly: false,
    memorySize: 2097152,
    masks: [
        0x33000000
    ],
    getBlockSize: function getBlockSize(_firwareVersion) {
        return 4096;
    },
    bluetoothSpec: [
        {
            serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
            notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
            writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
            writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
        }
    ]
}, $4e9ee4c7b8101fc3$var$_a[$4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoFTS] = {
    id: $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoFTS,
    productName: "Ledger\xa0Nano\xa0FTS",
    productIdMM: 0x60,
    legacyUsbProductId: 0x0006,
    usbOnly: false,
    memorySize: 1572864,
    masks: [
        0x33200000
    ],
    getBlockSize: function getBlockSize(_firmwareVersion) {
        return 32;
    },
    bluetoothSpec: [
        {
            serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
            notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
            writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
            writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
        }
    ]
}, $4e9ee4c7b8101fc3$var$_a);
var $4e9ee4c7b8101fc3$var$productMap = {
    Blue: $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.blue,
    "Nano S": $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoS,
    "Nano S Plus": $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoSP,
    "Nano X": $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoX,
    "Nano FTS": $4e9ee4c7b8101fc3$export$b8d24b2c0d9c5549.nanoFTS
};
var $4e9ee4c7b8101fc3$var$devicesList = Object.values($4e9ee4c7b8101fc3$var$devices);
var $4e9ee4c7b8101fc3$export$268c42a4ddec87f3 = 0x2c97;
var $4e9ee4c7b8101fc3$export$289d48518583cbd7 = function getDeviceModel(id) {
    var info = $4e9ee4c7b8101fc3$var$devices[id];
    if (!info) throw new Error("device '" + id + "' does not exist");
    return info;
};
var $4e9ee4c7b8101fc3$export$f656be11ec4fd95b = function identifyTargetId(targetId) {
    var deviceModel = $4e9ee4c7b8101fc3$var$devicesList.find(function(_a) {
        var masks = _a.masks;
        return masks.find(function(mask) {
            return (targetId & 0xffff0000) === mask;
        });
    });
    return deviceModel;
};
var $4e9ee4c7b8101fc3$export$df8f4444a7c73154 = function identifyUSBProductId(usbProductId) {
    var legacy = $4e9ee4c7b8101fc3$var$devicesList.find(function(d) {
        return d.legacyUsbProductId === usbProductId;
    });
    if (legacy) return legacy;
    var mm = usbProductId >> 8;
    var deviceModel = $4e9ee4c7b8101fc3$var$devicesList.find(function(d) {
        return d.productIdMM === mm;
    });
    return deviceModel;
};
var $4e9ee4c7b8101fc3$export$dce0906e1912b553 = function identifyProductName(productName) {
    var deviceModel = $4e9ee4c7b8101fc3$var$devicesList.find(function(d) {
        return d.id === $4e9ee4c7b8101fc3$var$productMap[productName];
    });
    return deviceModel;
};
var $4e9ee4c7b8101fc3$var$bluetoothServices = [];
var $4e9ee4c7b8101fc3$var$serviceUuidToInfos = {};
for(var $4e9ee4c7b8101fc3$var$id in $4e9ee4c7b8101fc3$var$devices){
    var $4e9ee4c7b8101fc3$var$deviceModel = $4e9ee4c7b8101fc3$var$devices[$4e9ee4c7b8101fc3$var$id];
    var $4e9ee4c7b8101fc3$var$bluetoothSpec = $4e9ee4c7b8101fc3$var$deviceModel.bluetoothSpec;
    if ($4e9ee4c7b8101fc3$var$bluetoothSpec) for(var $4e9ee4c7b8101fc3$var$i = 0; $4e9ee4c7b8101fc3$var$i < $4e9ee4c7b8101fc3$var$bluetoothSpec.length; $4e9ee4c7b8101fc3$var$i++){
        var $4e9ee4c7b8101fc3$var$spec = $4e9ee4c7b8101fc3$var$bluetoothSpec[$4e9ee4c7b8101fc3$var$i];
        $4e9ee4c7b8101fc3$var$bluetoothServices.push($4e9ee4c7b8101fc3$var$spec.serviceUuid);
        $4e9ee4c7b8101fc3$var$serviceUuidToInfos[$4e9ee4c7b8101fc3$var$spec.serviceUuid] = $4e9ee4c7b8101fc3$var$serviceUuidToInfos[$4e9ee4c7b8101fc3$var$spec.serviceUuid.replace(/-/g, "")] = $4e9ee4c7b8101fc3$var$__assign({
            deviceModel: $4e9ee4c7b8101fc3$var$deviceModel
        }, $4e9ee4c7b8101fc3$var$spec);
    }
}
var $4e9ee4c7b8101fc3$export$1f1251c1c71d84cf = function getBluetoothServiceUuids() {
    return $4e9ee4c7b8101fc3$var$bluetoothServices;
};
var $4e9ee4c7b8101fc3$export$8c98567a3882f79e = function getInfosForServiceUuid(uuid) {
    return $4e9ee4c7b8101fc3$var$serviceUuidToInfos[uuid.toLowerCase()];
};





var $ilnag = parcelRequire("ilnag");
var $fa5311e106947240$require$Buffer = $ilnag.Buffer;
var $fa5311e106947240$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fa5311e106947240$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fa5311e106947240$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fa5311e106947240$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fa5311e106947240$var$ledgerDevices = [
    {
        vendorId: (0, $4e9ee4c7b8101fc3$export$268c42a4ddec87f3)
    }
];
var $fa5311e106947240$var$isSupported = function isSupported() {
    return Promise.resolve(!!(window.navigator && window.navigator.hid));
};
var $fa5311e106947240$var$getHID = function getHID() {
    // $FlowFixMe
    var hid = navigator.hid;
    if (!hid) throw new (0, $2c29c7d2e6f002ec$export$8e68de6fb26f2236)("navigator.hid is not supported", "HIDNotSupported");
    return hid;
};
function $fa5311e106947240$var$requestLedgerDevices() {
    return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
        var device;
        return $fa5311e106947240$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $fa5311e106947240$var$getHID().requestDevice({
                            filters: $fa5311e106947240$var$ledgerDevices
                        })
                    ];
                case 1:
                    device = _a.sent();
                    if (Array.isArray(device)) return [
                        2 /*return*/ ,
                        device
                    ];
                    return [
                        2 /*return*/ ,
                        [
                            device
                        ]
                    ];
            }
        });
    });
}
function $fa5311e106947240$var$getLedgerDevices() {
    return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
        var devices;
        return $fa5311e106947240$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $fa5311e106947240$var$getHID().getDevices()
                    ];
                case 1:
                    devices = _a.sent();
                    return [
                        2 /*return*/ ,
                        devices.filter(function(d) {
                            return d.vendorId === (0, $4e9ee4c7b8101fc3$export$268c42a4ddec87f3);
                        })
                    ];
            }
        });
    });
}
function $fa5311e106947240$var$getFirstLedgerDevice() {
    return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
        var existingDevices, devices;
        return $fa5311e106947240$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $fa5311e106947240$var$getLedgerDevices()
                    ];
                case 1:
                    existingDevices = _a.sent();
                    if (existingDevices.length > 0) return [
                        2 /*return*/ ,
                        existingDevices[0]
                    ];
                    return [
                        4 /*yield*/ ,
                        $fa5311e106947240$var$requestLedgerDevices()
                    ];
                case 2:
                    devices = _a.sent();
                    return [
                        2 /*return*/ ,
                        devices[0]
                    ];
            }
        });
    });
}
/**
 * WebHID Transport implementation
 * @example
 * import TransportWebHID from "@ledgerhq/hw-transport-webhid";
 * ...
 * TransportWebHID.create().then(transport => ...)
 */ var $fa5311e106947240$var$TransportWebHID = /** @class */ function(_super) {
    $fa5311e106947240$var$__extends(TransportWebHID, _super);
    function TransportWebHID(device) {
        var _this = _super.call(this) || this;
        _this.channel = Math.floor(Math.random() * 0xffff);
        _this.packetSize = 64;
        _this.inputs = [];
        _this.read = function() {
            if (_this.inputs.length) return Promise.resolve(_this.inputs.shift());
            return new Promise(function(success) {
                _this.inputCallback = success;
            });
        };
        _this.onInputReport = function(e) {
            var buffer = $fa5311e106947240$require$Buffer.from(e.data.buffer);
            if (_this.inputCallback) {
                _this.inputCallback(buffer);
                _this.inputCallback = null;
            } else _this.inputs.push(buffer);
        };
        _this._disconnectEmitted = false;
        _this._emitDisconnect = function(e) {
            if (_this._disconnectEmitted) return;
            _this._disconnectEmitted = true;
            _this.emit("disconnect", e);
        };
        /**
         * Exchange with the device using APDU protocol.
         * @param apdu
         * @returns a promise of apdu response
         */ _this.exchange = function(apdu) {
            return $fa5311e106947240$var$__awaiter(_this, void 0, void 0, function() {
                var b;
                var _this = this;
                return $fa5311e106947240$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.exchangeAtomicImpl(function() {
                                    return $fa5311e106947240$var$__awaiter(_this, void 0, void 0, function() {
                                        var _$_a, channel, packetSize, framing, blocks, i, result, acc, buffer;
                                        return $fa5311e106947240$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    _$_a = this, channel = _$_a.channel, packetSize = _$_a.packetSize;
                                                    (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
                                                    framing = (0, $33bbf9120198c227$export$2e2bcd8739ae039)(channel, packetSize);
                                                    blocks = framing.makeBlocks(apdu);
                                                    i = 0;
                                                    _b.label = 1;
                                                case 1:
                                                    if (!(i < blocks.length)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.device.sendReport(0, blocks[i])
                                                    ];
                                                case 2:
                                                    _b.sent();
                                                    _b.label = 3;
                                                case 3:
                                                    i++;
                                                    return [
                                                        3 /*break*/ ,
                                                        1
                                                    ];
                                                case 4:
                                                    if (!!(result = framing.getReducedResult(acc))) return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.read()
                                                    ];
                                                case 5:
                                                    buffer = _b.sent();
                                                    acc = framing.reduceResponse(acc, buffer);
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 6:
                                                    (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
                                                    return [
                                                        2 /*return*/ ,
                                                        result
                                                    ];
                                            }
                                        });
                                    });
                                })["catch"](function(e) {
                                    if (e && e.message && e.message.includes("write")) {
                                        _this._emitDisconnect(e);
                                        throw new (0, $2c29c7d2e6f002ec$export$2a60f41a2ed2742)(e.message);
                                    }
                                    throw e;
                                })
                            ];
                        case 1:
                            b = _a.sent();
                            return [
                                2 /*return*/ ,
                                b
                            ];
                    }
                });
            });
        };
        _this.device = device;
        _this.deviceModel = typeof device.productId === "number" ? (0, $4e9ee4c7b8101fc3$export$df8f4444a7c73154)(device.productId) : undefined;
        device.addEventListener("inputreport", _this.onInputReport);
        return _this;
    }
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ TransportWebHID.request = function() {
        return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
            var _a, device;
            return $fa5311e106947240$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $fa5311e106947240$var$requestLedgerDevices()
                        ];
                    case 1:
                        _a = $fa5311e106947240$var$__read.apply(void 0, [
                            _b.sent(),
                            1
                        ]), device = _a[0];
                        return [
                            2 /*return*/ ,
                            TransportWebHID.open(device)
                        ];
                }
            });
        });
    };
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ TransportWebHID.openConnected = function() {
        return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $fa5311e106947240$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $fa5311e106947240$var$getLedgerDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        if (devices.length === 0) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ ,
                            TransportWebHID.open(devices[0])
                        ];
                }
            });
        });
    };
    /**
     * Create a Ledger transport with a HIDDevice
     */ TransportWebHID.open = function(device) {
        return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
            var transport, onDisconnect;
            return $fa5311e106947240$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            device.open()
                        ];
                    case 1:
                        _a.sent();
                        transport = new TransportWebHID(device);
                        onDisconnect = function(e) {
                            if (device === e.device) {
                                $fa5311e106947240$var$getHID().removeEventListener("disconnect", onDisconnect);
                                transport._emitDisconnect(new (0, $2c29c7d2e6f002ec$export$1e42f3936938e063)());
                            }
                        };
                        $fa5311e106947240$var$getHID().addEventListener("disconnect", onDisconnect);
                        return [
                            2 /*return*/ ,
                            transport
                        ];
                }
            });
        });
    };
    /**
     * Release the transport device
     */ TransportWebHID.prototype.close = function() {
        return $fa5311e106947240$var$__awaiter(this, void 0, void 0, function() {
            return $fa5311e106947240$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.exchangeBusyPromise
                        ];
                    case 1:
                        _a.sent();
                        this.device.removeEventListener("inputreport", this.onInputReport);
                        return [
                            4 /*yield*/ ,
                            this.device.close()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TransportWebHID.prototype.setScrambleKey = function() {};
    /**
     * Check if WebUSB transport is supported.
     */ TransportWebHID.isSupported = $fa5311e106947240$var$isSupported;
    /**
     * List the WebUSB devices that was previously authorized by the user.
     */ TransportWebHID.list = $fa5311e106947240$var$getLedgerDevices;
    /**
     * Actively listen to WebUSB devices and emit ONE device
     * that was either accepted before, if not it will trigger the native permission UI.
     *
     * Important: it must be called in the context of a UI click!
     */ TransportWebHID.listen = function(observer) {
        var unsubscribed = false;
        $fa5311e106947240$var$getFirstLedgerDevice().then(function(device) {
            if (!device) observer.error(new (0, $2c29c7d2e6f002ec$export$9642f061c2494239)("Access denied to use Ledger device"));
            else if (!unsubscribed) {
                var deviceModel = typeof device.productId === "number" ? (0, $4e9ee4c7b8101fc3$export$df8f4444a7c73154)(device.productId) : undefined;
                observer.next({
                    type: "add",
                    descriptor: device,
                    deviceModel: deviceModel
                });
                observer.complete();
            }
        }, function(error) {
            observer.error(new (0, $2c29c7d2e6f002ec$export$9642f061c2494239)(error.message));
        });
        function unsubscribe() {
            unsubscribed = true;
        }
        return {
            unsubscribe: unsubscribe
        };
    };
    return TransportWebHID;
}((0, $b29ea9007901f005$export$2e2bcd8739ae039));
var $fa5311e106947240$export$2e2bcd8739ae039 = $fa5311e106947240$var$TransportWebHID;








var $b61a10ef55a00d99$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b61a10ef55a00d99$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b61a10ef55a00d99$var$ledgerDevices = [
    {
        vendorId: (0, $4e9ee4c7b8101fc3$export$268c42a4ddec87f3)
    }
];
function $b61a10ef55a00d99$export$5e45f905eefbea79() {
    return $b61a10ef55a00d99$var$__awaiter(this, void 0, void 0, function() {
        var device;
        return $b61a10ef55a00d99$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        navigator.usb.requestDevice({
                            filters: $b61a10ef55a00d99$var$ledgerDevices
                        })
                    ];
                case 1:
                    device = _a.sent();
                    return [
                        2 /*return*/ ,
                        device
                    ];
            }
        });
    });
}
function $b61a10ef55a00d99$export$36755904a34d5197() {
    return $b61a10ef55a00d99$var$__awaiter(this, void 0, void 0, function() {
        var devices;
        return $b61a10ef55a00d99$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        navigator.usb.getDevices()
                    ];
                case 1:
                    devices = _a.sent();
                    return [
                        2 /*return*/ ,
                        devices.filter(function(d) {
                            return d.vendorId === (0, $4e9ee4c7b8101fc3$export$268c42a4ddec87f3);
                        })
                    ];
            }
        });
    });
}
function $b61a10ef55a00d99$export$527d8164321a6e6c() {
    return $b61a10ef55a00d99$var$__awaiter(this, void 0, void 0, function() {
        var existingDevices;
        return $b61a10ef55a00d99$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b61a10ef55a00d99$export$36755904a34d5197()
                    ];
                case 1:
                    existingDevices = _a.sent();
                    if (existingDevices.length > 0) return [
                        2 /*return*/ ,
                        existingDevices[0]
                    ];
                    return [
                        2 /*return*/ ,
                        $b61a10ef55a00d99$export$5e45f905eefbea79()
                    ];
            }
        });
    });
}
var $b61a10ef55a00d99$export$48c17662a6902497 = function isSupported() {
    return Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices === "function");
};



var $ilnag = parcelRequire("ilnag");
var $8586421fc21d55d0$require$Buffer = $ilnag.Buffer;
var $8586421fc21d55d0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8586421fc21d55d0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8586421fc21d55d0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8586421fc21d55d0$var$configurationValue = 1;
var $8586421fc21d55d0$var$endpointNumber = 3;
/**
 * WebUSB Transport implementation
 * @example
 * import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
 * ...
 * TransportWebUSB.create().then(transport => ...)
 */ var $8586421fc21d55d0$var$TransportWebUSB = /** @class */ function(_super) {
    $8586421fc21d55d0$var$__extends(TransportWebUSB, _super);
    function TransportWebUSB(device, interfaceNumber) {
        var _this = _super.call(this) || this;
        _this.channel = Math.floor(Math.random() * 0xffff);
        _this.packetSize = 64;
        _this._disconnectEmitted = false;
        _this._emitDisconnect = function(e) {
            if (_this._disconnectEmitted) return;
            _this._disconnectEmitted = true;
            _this.emit("disconnect", e);
        };
        _this.device = device;
        _this.interfaceNumber = interfaceNumber;
        _this.deviceModel = (0, $4e9ee4c7b8101fc3$export$df8f4444a7c73154)(device.productId);
        return _this;
    }
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ TransportWebUSB.request = function() {
        return $8586421fc21d55d0$var$__awaiter(this, void 0, void 0, function() {
            var device;
            return $8586421fc21d55d0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $b61a10ef55a00d99$export$5e45f905eefbea79)()
                        ];
                    case 1:
                        device = _a.sent();
                        return [
                            2 /*return*/ ,
                            TransportWebUSB.open(device)
                        ];
                }
            });
        });
    };
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ TransportWebUSB.openConnected = function() {
        return $8586421fc21d55d0$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $8586421fc21d55d0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $b61a10ef55a00d99$export$36755904a34d5197)()
                        ];
                    case 1:
                        devices = _a.sent();
                        if (devices.length === 0) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ ,
                            TransportWebUSB.open(devices[0])
                        ];
                }
            });
        });
    };
    /**
     * Create a Ledger transport with a USBDevice
     */ TransportWebUSB.open = function(device) {
        return $8586421fc21d55d0$var$__awaiter(this, void 0, void 0, function() {
            var iface, interfaceNumber, e_1, transport, onDisconnect;
            return $8586421fc21d55d0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            device.open()
                        ];
                    case 1:
                        _a.sent();
                        if (!(device.configuration === null)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            device.selectConfiguration($8586421fc21d55d0$var$configurationValue)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            $8586421fc21d55d0$var$gracefullyResetDevice(device)
                        ];
                    case 4:
                        _a.sent();
                        iface = device.configurations[0].interfaces.find(function(_a) {
                            var alternates = _a.alternates;
                            return alternates.some(function(a) {
                                return a.interfaceClass === 255;
                            });
                        });
                        if (!iface) throw new (0, $2c29c7d2e6f002ec$export$fd71e3a51c4bf0ae)("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
                        interfaceNumber = iface.interfaceNumber;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            device.claimInterface(interfaceNumber)
                        ];
                    case 6:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        e_1 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            device.close()
                        ];
                    case 8:
                        _a.sent();
                        throw new (0, $2c29c7d2e6f002ec$export$fd71e3a51c4bf0ae)(e_1.message);
                    case 9:
                        transport = new TransportWebUSB(device, interfaceNumber);
                        onDisconnect = function(e) {
                            if (device === e.device) {
                                // $FlowFixMe
                                navigator.usb.removeEventListener("disconnect", onDisconnect);
                                transport._emitDisconnect(new (0, $2c29c7d2e6f002ec$export$1e42f3936938e063)());
                            }
                        };
                        // $FlowFixMe
                        navigator.usb.addEventListener("disconnect", onDisconnect);
                        return [
                            2 /*return*/ ,
                            transport
                        ];
                }
            });
        });
    };
    /**
     * Release the transport device
     */ TransportWebUSB.prototype.close = function() {
        return $8586421fc21d55d0$var$__awaiter(this, void 0, void 0, function() {
            return $8586421fc21d55d0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.exchangeBusyPromise
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.device.releaseInterface(this.interfaceNumber)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            $8586421fc21d55d0$var$gracefullyResetDevice(this.device)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.device.close()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */ TransportWebUSB.prototype.exchange = function(apdu) {
        return $8586421fc21d55d0$var$__awaiter(this, void 0, void 0, function() {
            var b;
            var _this = this;
            return $8586421fc21d55d0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.exchangeAtomicImpl(function() {
                                return $8586421fc21d55d0$var$__awaiter(_this, void 0, void 0, function() {
                                    var _$_a, channel, packetSize, framing, blocks, i, result, acc, r, buffer;
                                    return $8586421fc21d55d0$var$__generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                _$_a = this, channel = _$_a.channel, packetSize = _$_a.packetSize;
                                                (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
                                                framing = (0, $33bbf9120198c227$export$2e2bcd8739ae039)(channel, packetSize);
                                                blocks = framing.makeBlocks(apdu);
                                                i = 0;
                                                _b.label = 1;
                                            case 1:
                                                if (!(i < blocks.length)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.device.transferOut($8586421fc21d55d0$var$endpointNumber, blocks[i])
                                                ];
                                            case 2:
                                                _b.sent();
                                                _b.label = 3;
                                            case 3:
                                                i++;
                                                return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                            case 4:
                                                if (!!(result = framing.getReducedResult(acc))) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.device.transferIn($8586421fc21d55d0$var$endpointNumber, packetSize)
                                                ];
                                            case 5:
                                                r = _b.sent();
                                                buffer = $8586421fc21d55d0$require$Buffer.from(r.data.buffer);
                                                acc = framing.reduceResponse(acc, buffer);
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 6:
                                                (0, $f1d0124ea9de5ab6$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
                                                return [
                                                    2 /*return*/ ,
                                                    result
                                                ];
                                        }
                                    });
                                });
                            })["catch"](function(e) {
                                if (e && e.message && e.message.includes("disconnected")) {
                                    _this._emitDisconnect(e);
                                    throw new (0, $2c29c7d2e6f002ec$export$2a60f41a2ed2742)(e.message);
                                }
                                throw e;
                            })
                        ];
                    case 1:
                        b = _a.sent();
                        return [
                            2 /*return*/ ,
                            b
                        ];
                }
            });
        });
    };
    TransportWebUSB.prototype.setScrambleKey = function() {};
    /**
     * Check if WebUSB transport is supported.
     */ TransportWebUSB.isSupported = (0, $b61a10ef55a00d99$export$48c17662a6902497);
    /**
     * List the WebUSB devices that was previously authorized by the user.
     */ TransportWebUSB.list = (0, $b61a10ef55a00d99$export$36755904a34d5197);
    /**
     * Actively listen to WebUSB devices and emit ONE device
     * that was either accepted before, if not it will trigger the native permission UI.
     *
     * Important: it must be called in the context of a UI click!
     */ TransportWebUSB.listen = function(observer) {
        var unsubscribed = false;
        (0, $b61a10ef55a00d99$export$527d8164321a6e6c)().then(function(device) {
            if (!unsubscribed) {
                var deviceModel = (0, $4e9ee4c7b8101fc3$export$df8f4444a7c73154)(device.productId);
                observer.next({
                    type: "add",
                    descriptor: device,
                    deviceModel: deviceModel
                });
                observer.complete();
            }
        }, function(error) {
            if (window.DOMException && error instanceof window.DOMException && error.code === 18) observer.error(new (0, $2c29c7d2e6f002ec$export$c0ffbdd94649bd06)(error.message));
            else observer.error(new (0, $2c29c7d2e6f002ec$export$9642f061c2494239)(error.message));
        });
        function unsubscribe() {
            unsubscribed = true;
        }
        return {
            unsubscribe: unsubscribe
        };
    };
    return TransportWebUSB;
}((0, $b29ea9007901f005$export$2e2bcd8739ae039));
var $8586421fc21d55d0$export$2e2bcd8739ae039 = $8586421fc21d55d0$var$TransportWebUSB;
function $8586421fc21d55d0$var$gracefullyResetDevice(device) {
    return $8586421fc21d55d0$var$__awaiter(this, void 0, void 0, function() {
        var err_1;
        return $8586421fc21d55d0$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        device.reset()
                    ];
                case 1:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    err_1 = _a.sent();
                    console.warn(err_1);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Original implementation: https://github.com/paritytech/polka-ui/blob/4858c094684769080f5811f32b081dd7780b0880/src/polkadot.js#L34
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * @name isFunction
 * @summary Tests for a `function`.
 * @description
 * Checks to see if the input value is a JavaScript function.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isFunction } from '@polkadot/util';
 *
 * isFunction(() => false); // => true
 * ```
 */ function $d0bff99ad22469e3$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}


// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
/**
 * @name isNull
 * @summary Tests for a `null` values.
 * @description
 * Checks to see if the input value is `null`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isNull } from '@polkadot/util';
 *
 * console.log('isNull', isNull(null)); // => true
 * ```
 */ function $27f752cfcfc32d05$export$630801d484da15df(value) {
    return value === null;
}


// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
/**
 * @name isUndefined
 * @summary Tests for a `undefined` values.
 * @description
 * Checks to see if the input value is `undefined`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isUndefined } from '@polkadot/util';
 *
 * console.log('isUndefined', isUndefined(void(0))); // => true
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $89dacedfe0f29f3b$export$fce6876652108ab(value) {
    return typeof value === "undefined";
}


function $825198f93516e193$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error((0, $d0bff99ad22469e3$export$f6e2535fb5126e54)(message) ? message() : message);
}
function $825198f93516e193$export$5529f1223fff4d4a(value, message) {
    $825198f93516e193$export$a7a9523472993e97(!(0, $89dacedfe0f29f3b$export$fce6876652108ab)(value) && !(0, $27f752cfcfc32d05$export$630801d484da15df)(value), message);
    return value;
}
function $825198f93516e193$export$f2525c1d596f8d46(x) {
    throw new Error("This codepath should be unreachable. Unhandled input: ".concat(x));
}

// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $e7578918ebce54c7$export$ceddb95bf4b87e91 = new Array(256);
var $e7578918ebce54c7$export$56cfdbeb228b5229 = new Array(65536);
var $e7578918ebce54c7$export$6af446c72b600edb = {};
var $e7578918ebce54c7$export$d503445a537bbb41 = {};
for(var $e7578918ebce54c7$var$n = 0; $e7578918ebce54c7$var$n < 256; $e7578918ebce54c7$var$n++){
    var $e7578918ebce54c7$var$hex = $e7578918ebce54c7$var$n.toString(16).padStart(2, "0");
    $e7578918ebce54c7$export$ceddb95bf4b87e91[$e7578918ebce54c7$var$n] = $e7578918ebce54c7$var$hex;
    $e7578918ebce54c7$export$6af446c72b600edb[$e7578918ebce54c7$var$hex] = $e7578918ebce54c7$var$n;
}
for(var $e7578918ebce54c7$var$i = 0; $e7578918ebce54c7$var$i < 256; $e7578918ebce54c7$var$i++)for(var $e7578918ebce54c7$var$j = 0; $e7578918ebce54c7$var$j < 256; $e7578918ebce54c7$var$j++){
    var $e7578918ebce54c7$var$hex1 = $e7578918ebce54c7$export$ceddb95bf4b87e91[$e7578918ebce54c7$var$i] + $e7578918ebce54c7$export$ceddb95bf4b87e91[$e7578918ebce54c7$var$j];
    var $e7578918ebce54c7$var$n1 = $e7578918ebce54c7$var$i << 8 | $e7578918ebce54c7$var$j;
    $e7578918ebce54c7$export$56cfdbeb228b5229[$e7578918ebce54c7$var$n1] = $e7578918ebce54c7$var$hex1;
    $e7578918ebce54c7$export$d503445a537bbb41[$e7578918ebce54c7$var$hex1] = $e7578918ebce54c7$var$n1;
}


// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $bd546d5b5907df14$export$aeee3e57f1b0a4e5 = /^0x[\da-fA-F]+$/;
var $bd546d5b5907df14$export$cfe92fa222ae2d9 = /^[\da-fA-F]+$/;
function $bd546d5b5907df14$export$8a9b6341a7c96bc(value) {
    var bitLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, ignoreLength = arguments.length > 2 ? arguments[2] : void 0;
    return typeof value === "string" && (value === "0x" || $bd546d5b5907df14$export$aeee3e57f1b0a4e5.test(value)) && (bitLength === -1 ? ignoreLength || value.length % 2 === 0 : value.length === 2 + Math.ceil(bitLength / 4));
}


function $4da9b63cd3fdf555$export$3e415f1787628d9c(value) {
    if (!value || value === "0x") return "";
    else if ((0, $bd546d5b5907df14$export$aeee3e57f1b0a4e5).test(value)) return value.substr(2);
    else if ((0, $bd546d5b5907df14$export$cfe92fa222ae2d9).test(value)) return value;
    throw new Error("Expected hex value to convert, found '".concat(value, "'"));
}


function $ead3e503fb51c635$export$fbca403d18cdd700(_value) {
    var bitLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    if (!_value) return new Uint8Array();
    var value = (0, $4da9b63cd3fdf555$export$3e415f1787628d9c)(_value).toLowerCase();
    var valLength = value.length / 2;
    var endLength = Math.ceil(bitLength === -1 ? valLength : bitLength / 8);
    var result = new Uint8Array(endLength);
    var offset = endLength > valLength ? endLength - valLength : 0;
    var dv = new DataView(result.buffer, offset);
    var mod = (endLength - offset) % 2;
    var length = endLength - offset - mod;
    for(var i = 0; i < length; i += 2)dv.setUint16(i, (0, $e7578918ebce54c7$export$d503445a537bbb41)[value.substr(i * 2, 4)]);
    if (mod) dv.setUint8(length, (0, $e7578918ebce54c7$export$6af446c72b600edb)[value.substr(value.length - 2, 2)]);
    return result;
}


// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/x-bigint authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/x-global authors & contributors
// SPDX-License-Identifier: Apache-2.0

function $70a11d92524ceb3e$var$evaluateThis(fn) {
    return fn("return this");
}
var $70a11d92524ceb3e$export$51e5d554977815ce = typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $70a11d92524ceb3e$var$evaluateThis(Function);
function $70a11d92524ceb3e$export$157d08edb917d81(name, fallback) {
    return typeof $70a11d92524ceb3e$export$51e5d554977815ce[name] === "undefined" ? fallback : $70a11d92524ceb3e$export$51e5d554977815ce[name];
}
function $70a11d92524ceb3e$export$89c2709f9d51d171(name, fallback) {
    if (typeof $70a11d92524ceb3e$export$51e5d554977815ce[name] === "undefined") $70a11d92524ceb3e$export$51e5d554977815ce[name] = fallback;
}



var $9e1a7adf20210f1c$export$2eb24fc24c69cb4d = typeof (0, $70a11d92524ceb3e$export$51e5d554977815ce).BigInt === "function" && typeof (0, $70a11d92524ceb3e$export$51e5d554977815ce).BigInt.asIntN === "function" ? (0, $70a11d92524ceb3e$export$51e5d554977815ce).BigInt : function() {
    return Number.NaN;
};



var $ilnag = parcelRequire("ilnag");
var $8a2cc693f2458a2f$require$Buffer = $ilnag.Buffer;
var $8a2cc693f2458a2f$var$__dirname = "node_modules/@polkadot/util";

var $4pbh3 = parcelRequire("4pbh3");
var $8a2cc693f2458a2f$export$c50f41259082745b = typeof (0, $9e1a7adf20210f1c$export$2eb24fc24c69cb4d) === "function" && typeof (0, $9e1a7adf20210f1c$export$2eb24fc24c69cb4d).asIntN === "function";
var $8a2cc693f2458a2f$export$a09f058e8ecd2d7b = typeof $8a2cc693f2458a2f$require$Buffer !== "undefined";
var $8a2cc693f2458a2f$export$b30b9665a6ed8596 = typeof $8a2cc693f2458a2f$var$__dirname !== "undefined";
var $8a2cc693f2458a2f$export$7af020c88c16a8f7 = typeof $4pbh3 === "object";
var $8a2cc693f2458a2f$export$f5c02881c55e08bb = typeof WebAssembly !== "undefined";



var $ilnag = parcelRequire("ilnag");
var $7773f0b33d60e01e$require$Buffer = $ilnag.Buffer;
function $7773f0b33d60e01e$export$a7884ebc965f8f54(value) {
    return (0, $8a2cc693f2458a2f$export$a09f058e8ecd2d7b) && $7773f0b33d60e01e$require$Buffer.isBuffer(value);
}



// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
/**
 * @name isU8a
 * @summary Tests for a `Uint8Array` object instance.
 * @description
 * Checks to see if the input object is an instance of `Uint8Array`.
 * @example
 * <BR>
 *
 * ```javascript
 * import { isUint8Array } from '@polkadot/util';
 *
 * console.log('isU8a', isU8a([])); // => false
 * ```
 */ function $21ab7f4bfe532bde$export$f5328759db5e050d(value) {
    return value instanceof Uint8Array;
}


// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $68c82a3965310b78$export$88fb0cfd153261a7 = /*#__PURE__*/ function() {
    "use strict";
    function TextEncoder() {
        (0, $7dKN1._)(this, TextEncoder);
    }
    (0, $eW5pA._)(TextEncoder, [
        {
            key: "encode",
            value: function encode(value) {
                var u8a = new Uint8Array(value.length);
                for(var i = 0; i < value.length; i++)u8a[i] = value.charCodeAt(i);
                return u8a;
            }
        }
    ]);
    return TextEncoder;
}();


// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Auto-generated by @polkadot/dev, do not edit
var $b610b1afbe671168$export$ce0097da4c08ff3f = {
    name: "@polkadot/x-textencoder",
    version: "8.2.2"
};


var $f3be9cc7ce70a56e$export$88fb0cfd153261a7 = (0, $70a11d92524ceb3e$export$157d08edb917d81)("TextEncoder", (0, $68c82a3965310b78$export$88fb0cfd153261a7));


var $9aa70a4c1365a75e$var$encoder = new (0, $f3be9cc7ce70a56e$export$88fb0cfd153261a7)();
function $9aa70a4c1365a75e$export$e66335b9b1239eaf(value) {
    return value ? $9aa70a4c1365a75e$var$encoder.encode(value.toString()) : new Uint8Array();
}


function $06f406c421475967$export$3d1a44fbed727ee2(value) {
    return !value ? new Uint8Array() : Array.isArray(value) || (0, $7773f0b33d60e01e$export$a7884ebc965f8f54)(value) ? new Uint8Array(value) : (0, $21ab7f4bfe532bde$export$f5328759db5e050d)(value) ? value : (0, $bd546d5b5907df14$export$8a9b6341a7c96bc)(value) ? (0, $ead3e503fb51c635$export$fbca403d18cdd700)(value) : (0, $9aa70a4c1365a75e$export$e66335b9b1239eaf)(value);
}


function $c4685798df67064d$export$7b640c40d4922c2e() {
    for(var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++){
        list[_key] = arguments[_key];
    }
    var length = 0;
    var offset = 0;
    var u8as = new Array(list.length);
    for(var i = 0; i < list.length; i++){
        u8as[i] = (0, $06f406c421475967$export$3d1a44fbed727ee2)(list[i]);
        length += u8as[i].length;
    }
    var result = new Uint8Array(length);
    for(var i1 = 0; i1 < u8as.length; i1++){
        result.set(u8as[i1], offset);
        offset += u8as[i1].length;
    }
    return result;
}


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $27599cd1922aaff6$exports = {};

var $aVMuR = parcelRequire("aVMuR");
"use strict";
/*! micro-base - MIT License (c) 2021 Paul Miller (paulmillr.com) */ Object.defineProperty($27599cd1922aaff6$exports, "__esModule", {
    value: true
});
$27599cd1922aaff6$exports.bytes = $27599cd1922aaff6$exports.stringToBytes = $27599cd1922aaff6$exports.str = $27599cd1922aaff6$exports.bytesToString = $27599cd1922aaff6$exports.hex = $27599cd1922aaff6$exports.utf8 = $27599cd1922aaff6$exports.bech32m = $27599cd1922aaff6$exports.bech32 = $27599cd1922aaff6$exports.base58check = $27599cd1922aaff6$exports.base58xmr = $27599cd1922aaff6$exports.base58xrp = $27599cd1922aaff6$exports.base58flickr = $27599cd1922aaff6$exports.base58 = $27599cd1922aaff6$exports.base64url = $27599cd1922aaff6$exports.base64 = $27599cd1922aaff6$exports.base32crockford = $27599cd1922aaff6$exports.base32hex = $27599cd1922aaff6$exports.base32 = $27599cd1922aaff6$exports.base16 = $27599cd1922aaff6$exports.utils = $27599cd1922aaff6$exports.assertNumber = void 0;
function $27599cd1922aaff6$var$assertNumber(n) {
    if (!Number.isSafeInteger(n)) throw new Error("Wrong integer: ".concat(n));
}
$27599cd1922aaff6$exports.assertNumber = $27599cd1922aaff6$var$assertNumber;
function $27599cd1922aaff6$var$chain() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var wrap = function(a, b) {
        return function(c) {
            return a(b(c));
        };
    };
    var encode = Array.from(args).reverse().reduce(function(acc, i) {
        return acc ? wrap(acc, i.encode) : i.encode;
    }, undefined);
    var decode = args.reduce(function(acc, i) {
        return acc ? wrap(acc, i.decode) : i.decode;
    }, undefined);
    return {
        encode: encode,
        decode: decode
    };
}
function $27599cd1922aaff6$var$alphabet(alphabet) {
    return {
        encode: function(digits) {
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map(function(i) {
                $27599cd1922aaff6$var$assertNumber(i);
                if (i < 0 || i >= alphabet.length) throw new Error("Digit index outside alphabet: ".concat(i, " (alphabet: ").concat(alphabet.length, ")"));
                return alphabet[i];
            });
        },
        decode: function(input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map(function(letter) {
                if (typeof letter !== "string") throw new Error("alphabet.decode: not string element=".concat(letter));
                var index = alphabet.indexOf(letter);
                if (index === -1) throw new Error('Unknown letter: "'.concat(letter, '". Allowed: ').concat(alphabet));
                return index;
            });
        }
    };
}
function $27599cd1922aaff6$var$join() {
    var separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: function(from) {
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = from[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (typeof i !== "string") throw new Error("join.encode: non-string input=".concat(i));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return from.join(separator);
        },
        decode: function(to) {
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
function $27599cd1922aaff6$var$padding(bits) {
    var chr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "=";
    $27599cd1922aaff6$var$assertNumber(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode: function(data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (typeof i !== "string") throw new Error("padding.encode: non-string input=".concat(i));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode: function(input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if (typeof i !== "string") throw new Error("padding.decode: non-string input=".concat(i));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
function $27599cd1922aaff6$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: function(from) {
            return from;
        },
        decode: function(to) {
            return fn(to);
        }
    };
}
function $27599cd1922aaff6$var$convertRadix(data, from, to) {
    if (from < 2) throw new Error("convertRadix: wrong from=".concat(from, ", base cannot be less than 2"));
    if (to < 2) throw new Error("convertRadix: wrong to=".concat(to, ", base cannot be less than 2"));
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    var pos = 0;
    var res = [];
    var digits = Array.from(data);
    digits.forEach(function(d) {
        $27599cd1922aaff6$var$assertNumber(d);
        if (d < 0 || d >= from) throw new Error("Wrong integer: ".concat(d));
    });
    while(true){
        var carry = 0;
        var done = true;
        for(var i = pos; i < digits.length; i++){
            var digit = digits[i];
            var digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            digits[i] = Math.floor(digitBase / to);
            if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!digits[i]) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(var i1 = 0; i1 < data.length - 1 && data[i1] === 0; i1++)res.push(0);
    return res.reverse();
}
var $27599cd1922aaff6$var$gcd = function(a, b) {
    return !b ? a : $27599cd1922aaff6$var$gcd(b, a % b);
};
var $27599cd1922aaff6$var$radix2carry = function(from, to) {
    return from + (to - $27599cd1922aaff6$var$gcd(from, to));
};
function $27599cd1922aaff6$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error("convertRadix2: wrong from=".concat(from));
    if (to <= 0 || to > 32) throw new Error("convertRadix2: wrong to=".concat(to));
    if ($27599cd1922aaff6$var$radix2carry(from, to) > 32) throw new Error("convertRadix2: carry overflow from=".concat(from, " to=").concat(to, " carryBits=").concat($27599cd1922aaff6$var$radix2carry(from, to)));
    var carry = 0;
    var pos = 0;
    var mask = Math.pow(2, to) - 1;
    var res = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            $27599cd1922aaff6$var$assertNumber(n);
            if (n >= Math.pow(2, from)) throw new Error("convertRadix2: invalid data word=".concat(n, " from=").concat(from));
            carry = carry << from | n;
            if (pos + from > 32) throw new Error("convertRadix2: carry overflow pos=".concat(pos, " from=").concat(from));
            pos += from;
            for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
            carry &= Math.pow(2, pos) - 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error("Non-zero padding: ".concat(carry));
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
function $27599cd1922aaff6$var$radix(num) {
    $27599cd1922aaff6$var$assertNumber(num);
    return {
        encode: function(bytes) {
            if (!(bytes instanceof Uint8Array)) throw new Error("radix.encode input should be Uint8Array");
            return $27599cd1922aaff6$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: function(digits) {
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of strings");
            return Uint8Array.from($27599cd1922aaff6$var$convertRadix(digits, num, 256));
        }
    };
}
function $27599cd1922aaff6$var$radix2(bits) {
    var revPadding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $27599cd1922aaff6$var$assertNumber(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($27599cd1922aaff6$var$radix2carry(8, bits) > 32 || $27599cd1922aaff6$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: function(bytes) {
            if (!(bytes instanceof Uint8Array)) throw new Error("radix2.encode input should be Uint8Array");
            return $27599cd1922aaff6$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: function(digits) {
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of strings");
            return Uint8Array.from($27599cd1922aaff6$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $27599cd1922aaff6$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $27599cd1922aaff6$var$checksum(len, fn) {
    $27599cd1922aaff6$var$assertNumber(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode: function(data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.encode: input should be Uint8Array");
            var _$checksum = fn(data).slice(0, len);
            var res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(_$checksum, data.length);
            return res;
        },
        decode: function(data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.decode: input should be Uint8Array");
            var payload = data.slice(0, -len);
            var newChecksum = fn(payload).slice(0, len);
            var oldChecksum = data.slice(-len);
            for(var i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
$27599cd1922aaff6$exports.utils = {
    alphabet: $27599cd1922aaff6$var$alphabet,
    chain: $27599cd1922aaff6$var$chain,
    checksum: $27599cd1922aaff6$var$checksum,
    radix: $27599cd1922aaff6$var$radix,
    radix2: $27599cd1922aaff6$var$radix2,
    join: $27599cd1922aaff6$var$join,
    padding: $27599cd1922aaff6$var$padding
};
$27599cd1922aaff6$exports.base16 = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(4), $27599cd1922aaff6$var$alphabet("0123456789ABCDEF"), $27599cd1922aaff6$var$join(""));
$27599cd1922aaff6$exports.base32 = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(5), $27599cd1922aaff6$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $27599cd1922aaff6$var$padding(5), $27599cd1922aaff6$var$join(""));
$27599cd1922aaff6$exports.base32hex = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(5), $27599cd1922aaff6$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $27599cd1922aaff6$var$padding(5), $27599cd1922aaff6$var$join(""));
$27599cd1922aaff6$exports.base32crockford = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(5), $27599cd1922aaff6$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $27599cd1922aaff6$var$join(""), $27599cd1922aaff6$var$normalize(function(s) {
    return s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1");
}));
$27599cd1922aaff6$exports.base64 = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(6), $27599cd1922aaff6$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $27599cd1922aaff6$var$padding(6), $27599cd1922aaff6$var$join(""));
$27599cd1922aaff6$exports.base64url = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(6), $27599cd1922aaff6$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $27599cd1922aaff6$var$padding(6), $27599cd1922aaff6$var$join(""));
var $27599cd1922aaff6$var$genBase58 = function(abc) {
    return $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix(58), $27599cd1922aaff6$var$alphabet(abc), $27599cd1922aaff6$var$join(""));
};
$27599cd1922aaff6$exports.base58 = $27599cd1922aaff6$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
$27599cd1922aaff6$exports.base58flickr = $27599cd1922aaff6$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
$27599cd1922aaff6$exports.base58xrp = $27599cd1922aaff6$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
var $27599cd1922aaff6$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
$27599cd1922aaff6$exports.base58xmr = {
    encode: function(data) {
        var res = "";
        for(var i = 0; i < data.length; i += 8){
            var block = data.subarray(i, i + 8);
            res += $27599cd1922aaff6$exports.base58.encode(block).padStart($27599cd1922aaff6$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode: function(str) {
        var res = [];
        for(var i = 0; i < str.length; i += 11){
            var slice = str.slice(i, i + 11);
            var blockLen = $27599cd1922aaff6$var$XMR_BLOCK_LEN.indexOf(slice.length);
            var block = $27599cd1922aaff6$exports.base58.decode(slice);
            for(var j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
var $27599cd1922aaff6$var$base58check = function(sha256) {
    return $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$checksum(4, function(data) {
        return sha256(sha256(data));
    }), $27599cd1922aaff6$exports.base58);
};
$27599cd1922aaff6$exports.base58check = $27599cd1922aaff6$var$base58check;
var $27599cd1922aaff6$var$BECH_ALPHABET = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $27599cd1922aaff6$var$join(""));
var $27599cd1922aaff6$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $27599cd1922aaff6$var$bech32Polymod(pre) {
    var b = pre >> 25;
    var chk = (pre & 0x1ffffff) << 5;
    for(var i = 0; i < $27599cd1922aaff6$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $27599cd1922aaff6$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $27599cd1922aaff6$var$bechChecksum(prefix, words) {
    var encodingConst = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var len = prefix.length;
    var chk = 1;
    for(var i = 0; i < len; i++){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error("Invalid prefix (".concat(prefix, ")"));
        chk = $27599cd1922aaff6$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $27599cd1922aaff6$var$bech32Polymod(chk);
    for(var i1 = 0; i1 < len; i1++)chk = $27599cd1922aaff6$var$bech32Polymod(chk) ^ prefix.charCodeAt(i1) & 0x1f;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = words[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            chk = $27599cd1922aaff6$var$bech32Polymod(chk) ^ v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var i2 = 0; i2 < 6; i2++)chk = $27599cd1922aaff6$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $27599cd1922aaff6$var$BECH_ALPHABET.encode($27599cd1922aaff6$var$convertRadix2([
        chk % Math.pow(2, 30)
    ], 30, 5, false));
}
function $27599cd1922aaff6$var$genBech32(encoding) {
    var ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    var _words = $27599cd1922aaff6$var$radix2(5);
    var fromWords = _words.decode;
    var toWords = _words.encode;
    var fromWordsUnsafe = $27599cd1922aaff6$var$unsafeWrapper(fromWords);
    function encode(prefix, words) {
        var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 90;
        if (typeof prefix !== "string") throw new Error("bech32.encode prefix should be string, not ".concat(typeof prefix === "undefined" ? "undefined" : (0, $aVMuR._)(prefix)));
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error("bech32.encode words should be array of numbers, not ".concat(typeof words === "undefined" ? "undefined" : (0, $aVMuR._)(words)));
        var actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError("Length ".concat(actualLength, " exceeds limit ").concat(limit));
        prefix = prefix.toLowerCase();
        return "".concat(prefix, "1").concat($27599cd1922aaff6$var$BECH_ALPHABET.encode(words)).concat($27599cd1922aaff6$var$bechChecksum(prefix, words, ENCODING_CONST));
    }
    function decode(str) {
        var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
        if (typeof str !== "string") throw new Error("bech32.decode input should be string, not ".concat(typeof str === "undefined" ? "undefined" : (0, $aVMuR._)(str)));
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError("Wrong string length: ".concat(str.length, " (").concat(str, "). Expected (8..").concat(limit, ")"));
        var lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error("String must be lowercase or uppercase");
        str = lowered;
        var sepIndex = str.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error('Letter "1" must be present between prefix and data only');
        var _ref = [
            str.slice(0, sepIndex),
            str.slice(sepIndex + 1)
        ], prefix = _ref[0], _words = _ref[1];
        if (_words.length < 6) throw new Error("Data must be at least 6 characters long");
        var words = $27599cd1922aaff6$var$BECH_ALPHABET.decode(_words).slice(0, -6);
        var sum = $27599cd1922aaff6$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!_words.endsWith(sum)) throw new Error("Invalid checksum in ".concat(str, ': expected "').concat(sum, '"'));
        return {
            prefix: prefix,
            words: words
        };
    }
    var decodeUnsafe = $27599cd1922aaff6$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        var _decode = decode(str, false), prefix = _decode.prefix, words = _decode.words;
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
$27599cd1922aaff6$exports.bech32 = $27599cd1922aaff6$var$genBech32("bech32");
$27599cd1922aaff6$exports.bech32m = $27599cd1922aaff6$var$genBech32("bech32m");
$27599cd1922aaff6$exports.utf8 = {
    encode: function(data) {
        return new TextDecoder().decode(data);
    },
    decode: function(str) {
        return new TextEncoder().encode(str);
    }
};
$27599cd1922aaff6$exports.hex = $27599cd1922aaff6$var$chain($27599cd1922aaff6$var$radix2(4), $27599cd1922aaff6$var$alphabet("0123456789abcdef"), $27599cd1922aaff6$var$join(""), $27599cd1922aaff6$var$normalize(function(s) {
    if (typeof s !== "string" || s.length % 2) throw new TypeError("hex.decode: expected string, got ".concat(typeof s === "undefined" ? "undefined" : (0, $aVMuR._)(s), " with length ").concat(s.length));
    return s.toLowerCase();
}));
var $27599cd1922aaff6$var$CODERS = {
    utf8: $27599cd1922aaff6$exports.utf8,
    hex: $27599cd1922aaff6$exports.hex,
    base16: $27599cd1922aaff6$exports.base16,
    base32: $27599cd1922aaff6$exports.base32,
    base64: $27599cd1922aaff6$exports.base64,
    base64url: $27599cd1922aaff6$exports.base64url,
    base58: $27599cd1922aaff6$exports.base58,
    base58xmr: $27599cd1922aaff6$exports.base58xmr
};
var $27599cd1922aaff6$var$coderTypeError = "Invalid encoding type. Available types: ".concat(Object.keys($27599cd1922aaff6$var$CODERS).join(", "));
var $27599cd1922aaff6$var$bytesToString = function(type, bytes) {
    if (typeof type !== "string" || !$27599cd1922aaff6$var$CODERS.hasOwnProperty(type)) throw new TypeError($27599cd1922aaff6$var$coderTypeError);
    if (!(bytes instanceof Uint8Array)) throw new TypeError("bytesToString() expects Uint8Array");
    return $27599cd1922aaff6$var$CODERS[type].encode(bytes);
};
$27599cd1922aaff6$exports.bytesToString = $27599cd1922aaff6$var$bytesToString;
$27599cd1922aaff6$exports.str = $27599cd1922aaff6$exports.bytesToString;
var $27599cd1922aaff6$var$stringToBytes = function(type, str) {
    if (!$27599cd1922aaff6$var$CODERS.hasOwnProperty(type)) throw new TypeError($27599cd1922aaff6$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $27599cd1922aaff6$var$CODERS[type].decode(str);
};
$27599cd1922aaff6$exports.stringToBytes = $27599cd1922aaff6$var$stringToBytes;
$27599cd1922aaff6$exports.bytes = $27599cd1922aaff6$exports.stringToBytes;


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

function $24218981aa9f4a38$export$731f08e8f7451db(param, validate) {
    var coder = param.coder, ipfs = param.ipfs;
    return function(value, ipfsCompat) {
        validate(value, ipfsCompat);
        return coder.decode(ipfs && ipfsCompat ? value.substr(1) : value);
    };
}
function $24218981aa9f4a38$export$9e30af3a800385aa(param) {
    var coder = param.coder, ipfs = param.ipfs;
    return function(value, ipfsCompat) {
        var out = coder.encode((0, $06f406c421475967$export$3d1a44fbed727ee2)(value));
        return ipfs && ipfsCompat ? "".concat(ipfs).concat(out) : out;
    };
}
function $24218981aa9f4a38$export$9836a0dc385be8f1(validate) {
    return function(value, ipfsCompat) {
        try {
            return validate(value, ipfsCompat);
        } catch (error) {
            return false;
        }
    };
}
function $24218981aa9f4a38$export$2859a83e4d6da57d(param) {
    var chars = param.chars, ipfs = param.ipfs, type = param.type;
    return function(value, ipfsCompat) {
        var _loop = function(i) {
            (0, $825198f93516e193$export$a7a9523472993e97)(chars.includes(value[i]) || value[i] === "=" && (i === value.length - 1 || !chars.includes(value[i + 1])), function() {
                return "Invalid ".concat(type, ' character "').concat(value[i], '" (0x').concat(value.charCodeAt(i).toString(16), ") at index ").concat(i);
            });
        };
        (0, $825198f93516e193$export$a7a9523472993e97)(value && typeof value === "string", function() {
            return "Expected non-null, non-empty ".concat(type, " string input");
        });
        if (ipfs && ipfsCompat) (0, $825198f93516e193$export$a7a9523472993e97)(value[0] === ipfs, function() {
            return "Expected ipfs-compatible ".concat(type, " to start with '").concat(ipfs, "'");
        });
        for(var i = ipfsCompat ? 1 : 0; i < value.length; i++)_loop(i);
        return true;
    };
}


var $649963e59efa3266$var$config = {
    chars: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz",
    coder: (0, $27599cd1922aaff6$exports.base58),
    ipfs: "z",
    type: "base58"
};
var $649963e59efa3266$export$1bb67fe68adb5db2 = (0, $24218981aa9f4a38$export$2859a83e4d6da57d)($649963e59efa3266$var$config);
var $649963e59efa3266$export$e42db48932fc32fe = (0, $24218981aa9f4a38$export$731f08e8f7451db)($649963e59efa3266$var$config, $649963e59efa3266$export$1bb67fe68adb5db2);
var $649963e59efa3266$export$a025eb30fde2c140 = (0, $24218981aa9f4a38$export$9e30af3a800385aa)($649963e59efa3266$var$config);
var $649963e59efa3266$export$fe9a3fa02c7cb60d = (0, $24218981aa9f4a38$export$9836a0dc385be8f1)($649963e59efa3266$export$1bb67fe68adb5db2);


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Original implementation: https://github.com/paritytech/polka-ui/blob/4858c094684769080f5811f32b081dd7780b0880/src/polkadot.js#L6

var $5OlIx = parcelRequire("5OlIx");


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $cd12d97bf05dfd81$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
var $cd12d97bf05dfd81$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd12d97bf05dfd81$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cd12d97bf05dfd81$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cd12d97bf05dfd81$var$__createBinding(result, mod, k);
    }
    $cd12d97bf05dfd81$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cd12d97bf05dfd81$exports, "__esModule", {
    value: true
});
$cd12d97bf05dfd81$exports.blake2b = void 0;

var $cd12d97bf05dfd81$var$blake2 = $cd12d97bf05dfd81$var$__importStar((parcelRequire("1OlAV")));

var $cd12d97bf05dfd81$var$u64 = $cd12d97bf05dfd81$var$__importStar((parcelRequire("5zObe")));

var $1bB2U = parcelRequire("1bB2U");
// Same as SHA-512 but LE
// prettier-ignore
var $cd12d97bf05dfd81$var$IV = new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
// Temporary buffer
var $cd12d97bf05dfd81$var$BUF = new Uint32Array(32);
// Mixing function G splitted in two halfs
function $cd12d97bf05dfd81$var$G1(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    var Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    var Al = $cd12d97bf05dfd81$var$BUF[2 * a], Ah = $cd12d97bf05dfd81$var$BUF[2 * a + 1]; // prettier-ignore
    var Bl = $cd12d97bf05dfd81$var$BUF[2 * b], Bh = $cd12d97bf05dfd81$var$BUF[2 * b + 1]; // prettier-ignore
    var Cl = $cd12d97bf05dfd81$var$BUF[2 * c], Ch = $cd12d97bf05dfd81$var$BUF[2 * c + 1]; // prettier-ignore
    var Dl = $cd12d97bf05dfd81$var$BUF[2 * d], Dh = $cd12d97bf05dfd81$var$BUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    var ll = $cd12d97bf05dfd81$var$u64.add3L(Al, Bl, Xl);
    Ah = $cd12d97bf05dfd81$var$u64.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    var ref;
    // v[d] = rotr(v[d] ^ v[a], 32)
    ref = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    }, Dh = ref.Dh, Dl = ref.Dl, ref;
    var ref1;
    ref1 = {
        Dh: $cd12d97bf05dfd81$var$u64.rotr32H(Dh, Dl),
        Dl: $cd12d97bf05dfd81$var$u64.rotr32L(Dh, Dl)
    }, Dh = ref1.Dh, Dl = ref1.Dl, ref1;
    var ref2;
    // v[c] = (v[c] + v[d]) | 0;
    ref2 = $cd12d97bf05dfd81$var$u64.add(Ch, Cl, Dh, Dl), Ch = ref2.h, Cl = ref2.l, ref2;
    var ref3;
    // v[b] = rotr(v[b] ^ v[c], 24)
    ref3 = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    }, Bh = ref3.Bh, Bl = ref3.Bl, ref3;
    var ref4;
    ref4 = {
        Bh: $cd12d97bf05dfd81$var$u64.rotrSH(Bh, Bl, 24),
        Bl: $cd12d97bf05dfd81$var$u64.rotrSL(Bh, Bl, 24)
    }, Bh = ref4.Bh, Bl = ref4.Bl, ref4;
    $cd12d97bf05dfd81$var$BUF[2 * a] = Al, $cd12d97bf05dfd81$var$BUF[2 * a + 1] = Ah;
    $cd12d97bf05dfd81$var$BUF[2 * b] = Bl, $cd12d97bf05dfd81$var$BUF[2 * b + 1] = Bh;
    $cd12d97bf05dfd81$var$BUF[2 * c] = Cl, $cd12d97bf05dfd81$var$BUF[2 * c + 1] = Ch;
    $cd12d97bf05dfd81$var$BUF[2 * d] = Dl, $cd12d97bf05dfd81$var$BUF[2 * d + 1] = Dh;
}
function $cd12d97bf05dfd81$var$G2(a, b, c, d, msg, x) {
    // NOTE: V is LE here
    var Xl = msg[x], Xh = msg[x + 1]; // prettier-ignore
    var Al = $cd12d97bf05dfd81$var$BUF[2 * a], Ah = $cd12d97bf05dfd81$var$BUF[2 * a + 1]; // prettier-ignore
    var Bl = $cd12d97bf05dfd81$var$BUF[2 * b], Bh = $cd12d97bf05dfd81$var$BUF[2 * b + 1]; // prettier-ignore
    var Cl = $cd12d97bf05dfd81$var$BUF[2 * c], Ch = $cd12d97bf05dfd81$var$BUF[2 * c + 1]; // prettier-ignore
    var Dl = $cd12d97bf05dfd81$var$BUF[2 * d], Dh = $cd12d97bf05dfd81$var$BUF[2 * d + 1]; // prettier-ignore
    // v[a] = (v[a] + v[b] + x) | 0;
    var ll = $cd12d97bf05dfd81$var$u64.add3L(Al, Bl, Xl);
    Ah = $cd12d97bf05dfd81$var$u64.add3H(ll, Ah, Bh, Xh);
    Al = ll | 0;
    var ref;
    // v[d] = rotr(v[d] ^ v[a], 16)
    ref = {
        Dh: Dh ^ Ah,
        Dl: Dl ^ Al
    }, Dh = ref.Dh, Dl = ref.Dl, ref;
    var ref1;
    ref1 = {
        Dh: $cd12d97bf05dfd81$var$u64.rotrSH(Dh, Dl, 16),
        Dl: $cd12d97bf05dfd81$var$u64.rotrSL(Dh, Dl, 16)
    }, Dh = ref1.Dh, Dl = ref1.Dl, ref1;
    var ref2;
    // v[c] = (v[c] + v[d]) | 0;
    ref2 = $cd12d97bf05dfd81$var$u64.add(Ch, Cl, Dh, Dl), Ch = ref2.h, Cl = ref2.l, ref2;
    var ref3;
    // v[b] = rotr(v[b] ^ v[c], 63)
    ref3 = {
        Bh: Bh ^ Ch,
        Bl: Bl ^ Cl
    }, Bh = ref3.Bh, Bl = ref3.Bl, ref3;
    var ref4;
    ref4 = {
        Bh: $cd12d97bf05dfd81$var$u64.rotrBH(Bh, Bl, 63),
        Bl: $cd12d97bf05dfd81$var$u64.rotrBL(Bh, Bl, 63)
    }, Bh = ref4.Bh, Bl = ref4.Bl, ref4;
    $cd12d97bf05dfd81$var$BUF[2 * a] = Al, $cd12d97bf05dfd81$var$BUF[2 * a + 1] = Ah;
    $cd12d97bf05dfd81$var$BUF[2 * b] = Bl, $cd12d97bf05dfd81$var$BUF[2 * b + 1] = Bh;
    $cd12d97bf05dfd81$var$BUF[2 * c] = Cl, $cd12d97bf05dfd81$var$BUF[2 * c + 1] = Ch;
    $cd12d97bf05dfd81$var$BUF[2 * d] = Dl, $cd12d97bf05dfd81$var$BUF[2 * d + 1] = Dh;
}
var $cd12d97bf05dfd81$var$BLAKE2b = /*#__PURE__*/ function(_blake2_BLAKE2) {
    (0, $cgJ2Y._)(BLAKE2b, _blake2_BLAKE2);
    var _super = (0, $hKD8n._)(BLAKE2b);
    function BLAKE2b() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $7dKN1._)(this, BLAKE2b);
        var _this;
        _this = _super.call(this, 128, opts.dkLen === undefined ? 64 : opts.dkLen, opts, 64, 16, 16);
        // Same as SHA-512, but LE
        _this.v0l = $cd12d97bf05dfd81$var$IV[0] | 0;
        _this.v0h = $cd12d97bf05dfd81$var$IV[1] | 0;
        _this.v1l = $cd12d97bf05dfd81$var$IV[2] | 0;
        _this.v1h = $cd12d97bf05dfd81$var$IV[3] | 0;
        _this.v2l = $cd12d97bf05dfd81$var$IV[4] | 0;
        _this.v2h = $cd12d97bf05dfd81$var$IV[5] | 0;
        _this.v3l = $cd12d97bf05dfd81$var$IV[6] | 0;
        _this.v3h = $cd12d97bf05dfd81$var$IV[7] | 0;
        _this.v4l = $cd12d97bf05dfd81$var$IV[8] | 0;
        _this.v4h = $cd12d97bf05dfd81$var$IV[9] | 0;
        _this.v5l = $cd12d97bf05dfd81$var$IV[10] | 0;
        _this.v5h = $cd12d97bf05dfd81$var$IV[11] | 0;
        _this.v6l = $cd12d97bf05dfd81$var$IV[12] | 0;
        _this.v6h = $cd12d97bf05dfd81$var$IV[13] | 0;
        _this.v7l = $cd12d97bf05dfd81$var$IV[14] | 0;
        _this.v7h = $cd12d97bf05dfd81$var$IV[15] | 0;
        var keyLength = opts.key ? opts.key.length : 0;
        _this.v0l ^= _this.outputLen | keyLength << 8 | 16842752;
        if (opts.salt) {
            var salt = (0, $1bB2U.u32)((0, $1bB2U.toBytes)(opts.salt));
            _this.v4l ^= salt[0];
            _this.v4h ^= salt[1];
            _this.v5l ^= salt[2];
            _this.v5h ^= salt[3];
        }
        if (opts.personalization) {
            var pers = (0, $1bB2U.u32)((0, $1bB2U.toBytes)(opts.personalization));
            _this.v6l ^= pers[0];
            _this.v6h ^= pers[1];
            _this.v7l ^= pers[2];
            _this.v7h ^= pers[3];
        }
        if (opts.key) {
            // Pad to blockLen and update
            var tmp = new Uint8Array(_this.blockLen);
            tmp.set((0, $1bB2U.toBytes)(opts.key));
            _this.update(tmp);
        }
        return _this;
    }
    (0, $eW5pA._)(BLAKE2b, [
        {
            // prettier-ignore
            key: "get",
            value: function get() {
                var _this = this, v0l = _this.v0l, v0h = _this.v0h, v1l = _this.v1l, v1h = _this.v1h, v2l = _this.v2l, v2h = _this.v2h, v3l = _this.v3l, v3h = _this.v3h, v4l = _this.v4l, v4h = _this.v4h, v5l = _this.v5l, v5h = _this.v5h, v6l = _this.v6l, v6h = _this.v6h, v7l = _this.v7l, v7h = _this.v7h;
                return [
                    v0l,
                    v0h,
                    v1l,
                    v1h,
                    v2l,
                    v2h,
                    v3l,
                    v3h,
                    v4l,
                    v4h,
                    v5l,
                    v5h,
                    v6l,
                    v6h,
                    v7l,
                    v7h
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h) {
                this.v0l = v0l | 0;
                this.v0h = v0h | 0;
                this.v1l = v1l | 0;
                this.v1h = v1h | 0;
                this.v2l = v2l | 0;
                this.v2h = v2h | 0;
                this.v3l = v3l | 0;
                this.v3h = v3h | 0;
                this.v4l = v4l | 0;
                this.v4h = v4h | 0;
                this.v5l = v5l | 0;
                this.v5h = v5h | 0;
                this.v6l = v6l | 0;
                this.v6h = v6h | 0;
                this.v7l = v7l | 0;
                this.v7h = v7h | 0;
            }
        },
        {
            key: "compress",
            value: function compress(msg, offset, isLast) {
                this.get().forEach(function(v, i) {
                    return $cd12d97bf05dfd81$var$BUF[i] = v;
                }); // First half from state.
                $cd12d97bf05dfd81$var$BUF.set($cd12d97bf05dfd81$var$IV, 16); // Second half from IV.
                var _u64_fromBig = $cd12d97bf05dfd81$var$u64.fromBig(BigInt(this.length)), h = _u64_fromBig.h, l = _u64_fromBig.l;
                $cd12d97bf05dfd81$var$BUF[24] = $cd12d97bf05dfd81$var$IV[8] ^ l; // Low word of the offset.
                $cd12d97bf05dfd81$var$BUF[25] = $cd12d97bf05dfd81$var$IV[9] ^ h; // High word.
                // Invert all bits for last block
                if (isLast) {
                    $cd12d97bf05dfd81$var$BUF[28] = ~$cd12d97bf05dfd81$var$BUF[28];
                    $cd12d97bf05dfd81$var$BUF[29] = ~$cd12d97bf05dfd81$var$BUF[29];
                }
                var j = 0;
                var s = $cd12d97bf05dfd81$var$blake2.SIGMA;
                for(var i = 0; i < 12; i++){
                    $cd12d97bf05dfd81$var$G1(0, 4, 8, 12, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(0, 4, 8, 12, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(1, 5, 9, 13, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(1, 5, 9, 13, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(2, 6, 10, 14, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(2, 6, 10, 14, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(3, 7, 11, 15, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(3, 7, 11, 15, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(0, 5, 10, 15, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(0, 5, 10, 15, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(1, 6, 11, 12, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(1, 6, 11, 12, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(2, 7, 8, 13, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(2, 7, 8, 13, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G1(3, 4, 9, 14, msg, offset + 2 * s[j++]);
                    $cd12d97bf05dfd81$var$G2(3, 4, 9, 14, msg, offset + 2 * s[j++]);
                }
                this.v0l ^= $cd12d97bf05dfd81$var$BUF[0] ^ $cd12d97bf05dfd81$var$BUF[16];
                this.v0h ^= $cd12d97bf05dfd81$var$BUF[1] ^ $cd12d97bf05dfd81$var$BUF[17];
                this.v1l ^= $cd12d97bf05dfd81$var$BUF[2] ^ $cd12d97bf05dfd81$var$BUF[18];
                this.v1h ^= $cd12d97bf05dfd81$var$BUF[3] ^ $cd12d97bf05dfd81$var$BUF[19];
                this.v2l ^= $cd12d97bf05dfd81$var$BUF[4] ^ $cd12d97bf05dfd81$var$BUF[20];
                this.v2h ^= $cd12d97bf05dfd81$var$BUF[5] ^ $cd12d97bf05dfd81$var$BUF[21];
                this.v3l ^= $cd12d97bf05dfd81$var$BUF[6] ^ $cd12d97bf05dfd81$var$BUF[22];
                this.v3h ^= $cd12d97bf05dfd81$var$BUF[7] ^ $cd12d97bf05dfd81$var$BUF[23];
                this.v4l ^= $cd12d97bf05dfd81$var$BUF[8] ^ $cd12d97bf05dfd81$var$BUF[24];
                this.v4h ^= $cd12d97bf05dfd81$var$BUF[9] ^ $cd12d97bf05dfd81$var$BUF[25];
                this.v5l ^= $cd12d97bf05dfd81$var$BUF[10] ^ $cd12d97bf05dfd81$var$BUF[26];
                this.v5h ^= $cd12d97bf05dfd81$var$BUF[11] ^ $cd12d97bf05dfd81$var$BUF[27];
                this.v6l ^= $cd12d97bf05dfd81$var$BUF[12] ^ $cd12d97bf05dfd81$var$BUF[28];
                this.v6h ^= $cd12d97bf05dfd81$var$BUF[13] ^ $cd12d97bf05dfd81$var$BUF[29];
                this.v7l ^= $cd12d97bf05dfd81$var$BUF[14] ^ $cd12d97bf05dfd81$var$BUF[30];
                this.v7h ^= $cd12d97bf05dfd81$var$BUF[15] ^ $cd12d97bf05dfd81$var$BUF[31];
                $cd12d97bf05dfd81$var$BUF.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.buffer32.fill(0);
                this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
        }
    ]);
    return BLAKE2b;
}($cd12d97bf05dfd81$var$blake2.BLAKE2);
$cd12d97bf05dfd81$exports.blake2b = (0, $1bB2U.wrapConstructorWithOpts)(function(opts) {
    return new $cd12d97bf05dfd81$var$BLAKE2b(opts);
});



// Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

var $gF0bR = parcelRequire("gF0bR");
// Copyright 2019-2021 @polkadot/wasm-crypto-asmjs authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $efae7c76d77a5325$export$55a8d7752269af9b = null;


// Copyright 2019-2021 @polkadot/wasm-crypto-wasm authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $34e0061bb3b4a2f8$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function $34e0061bb3b4a2f8$export$c62426fdd000a97e(data) {
    var bytes = [];
    var byte = 0;
    var bits = 0;
    for(var i = 0; i < data.length && data[i] !== "="; i++){
        // each character represents 6 bits
        byte = byte << 6 | $34e0061bb3b4a2f8$var$chars.indexOf(data[i]); // each byte needs to contain 8 bits
        if ((bits += 6) >= 8) bytes.push(byte >>> (bits -= 8) & 0xff);
    }
    return Uint8Array.from(bytes);
}


// Copyright 2019-2021 @polkadot/wasm-crypto-wasm authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $a4c4e786623b90aa$exports = {};
// Copyright 2019-2021 @polkadot/wasm-crypto-wasm authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Generated as part of the build, do not edit
var $a4c4e786623b90aa$var$sizeCompressed = 171007;
var $a4c4e786623b90aa$var$sizeUncompressed = 349686;
var $a4c4e786623b90aa$var$bytes = "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";
$a4c4e786623b90aa$exports = {
    bytes: $a4c4e786623b90aa$var$bytes,
    sizeCompressed: $a4c4e786623b90aa$var$sizeCompressed,
    sizeUncompressed: $a4c4e786623b90aa$var$sizeUncompressed
};


var $a0f44b6e30f95aac$export$b3317979f9250576 = (0, $a4c4e786623b90aa$exports.bytes);
var $a0f44b6e30f95aac$export$f9b3651a4e63731f = (0, $a4c4e786623b90aa$exports.sizeCompressed);
var $a0f44b6e30f95aac$export$e9c43f21ee54beb6 = (0, $a4c4e786623b90aa$exports.sizeUncompressed);


// Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// MIT License
//
// Copyright (c) 2020 Arjun Barrett
//
// Copied from https://github.com/101arrowz/fflate/blob/73c737941ec89d85cdf0ad39ee6f26c5fdc95fd7/src/index.ts
// This only contains the unzlibSync function, no compression, no async, no workers
//
// These 2 issues are addressed as a short-term, stop-gap solution
//   - https://github.com/polkadot-js/api/issues/2963
//   - https://github.com/101arrowz/fflate/issues/17
//
// Only tweaks make here are some TS adjustments (we use strict null checks), the code is otherwise as-is with
// only the single required function provided (compression is still being done in the build with fflate)
/* eslint-disable */ // inflate state
// aliases for shorter compressed code (most minifers don't do this)

var $5OlIx = parcelRequire("5OlIx");
var $4c39ec9613bfd9dc$var$u8 = Uint8Array, $4c39ec9613bfd9dc$var$u16 = Uint16Array, $4c39ec9613bfd9dc$var$u32 = Uint32Array; // code length index map
var $4c39ec9613bfd9dc$var$clim = new $4c39ec9613bfd9dc$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]); // fixed length extra bits
var $4c39ec9613bfd9dc$var$fleb = new $4c39ec9613bfd9dc$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]); // fixed distance extra bits
// see fleb note
var $4c39ec9613bfd9dc$var$fdeb = new $4c39ec9613bfd9dc$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]); // get base, reverse index map from extra bits
var $4c39ec9613bfd9dc$var$freb = function(eb, start) {
    var b = new $4c39ec9613bfd9dc$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
     // numbers here are at max 18 bits
    var r = new $4c39ec9613bfd9dc$var$u32(b[30]);
    for(var i1 = 1; i1 < 30; ++i1)for(var j = b[i1]; j < b[i1 + 1]; ++j)r[j] = j - b[i1] << 5 | i1;
    return [
        b,
        r
    ];
};
var $4c39ec9613bfd9dc$var$_freb = (0, $5OlIx._)($4c39ec9613bfd9dc$var$freb($4c39ec9613bfd9dc$var$fleb, 2), 2), $4c39ec9613bfd9dc$var$fl = $4c39ec9613bfd9dc$var$_freb[0], $4c39ec9613bfd9dc$var$revfl = $4c39ec9613bfd9dc$var$_freb[1]; // we can ignore the fact that the other numbers are wrong; they never happen anyway
$4c39ec9613bfd9dc$var$fl[28] = 258, $4c39ec9613bfd9dc$var$revfl[258] = 28;
var $4c39ec9613bfd9dc$var$_freb1 = (0, $5OlIx._)($4c39ec9613bfd9dc$var$freb($4c39ec9613bfd9dc$var$fdeb, 0), 1), $4c39ec9613bfd9dc$var$fd = $4c39ec9613bfd9dc$var$_freb1[0]; // map of value to reverse (assuming 16 bits)
var $4c39ec9613bfd9dc$var$rev = new $4c39ec9613bfd9dc$var$u16(32768);
for(var $4c39ec9613bfd9dc$var$i = 0; $4c39ec9613bfd9dc$var$i < 32768; ++$4c39ec9613bfd9dc$var$i){
    // reverse table algorithm from SO
    var $4c39ec9613bfd9dc$var$x = ($4c39ec9613bfd9dc$var$i & 0xAAAA) >>> 1 | ($4c39ec9613bfd9dc$var$i & 0x5555) << 1;
    $4c39ec9613bfd9dc$var$x = ($4c39ec9613bfd9dc$var$x & 0xCCCC) >>> 2 | ($4c39ec9613bfd9dc$var$x & 0x3333) << 2;
    $4c39ec9613bfd9dc$var$x = ($4c39ec9613bfd9dc$var$x & 0xF0F0) >>> 4 | ($4c39ec9613bfd9dc$var$x & 0x0F0F) << 4;
    $4c39ec9613bfd9dc$var$rev[$4c39ec9613bfd9dc$var$i] = (($4c39ec9613bfd9dc$var$x & 0xFF00) >>> 8 | ($4c39ec9613bfd9dc$var$x & 0x00FF) << 8) >>> 1;
} // create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $4c39ec9613bfd9dc$var$hMap = function(cd, mb, r) {
    var s = cd.length; // index
    var i = 0; // u16 "map": index -> # of codes with bit length = index
    var l = new $4c39ec9613bfd9dc$var$u16(mb); // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1]; // u16 "map": index -> minimum code for bit length = index
    var le = new $4c39ec9613bfd9dc$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $4c39ec9613bfd9dc$var$u16(1 << mb); // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i]; // free bits
            var _$r = mb - cd[i]; // start value
            var v = le[cd[i] - 1]++ << _$r; // m is end value
            for(var m = v | (1 << _$r) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$4c39ec9613bfd9dc$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $4c39ec9613bfd9dc$var$u16(s);
        for(i = 0; i < s; ++i)co[i] = $4c39ec9613bfd9dc$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
}; // fixed length tree
var $4c39ec9613bfd9dc$var$flt = new $4c39ec9613bfd9dc$var$u8(288);
for(var $4c39ec9613bfd9dc$var$i1 = 0; $4c39ec9613bfd9dc$var$i1 < 144; ++$4c39ec9613bfd9dc$var$i1)$4c39ec9613bfd9dc$var$flt[$4c39ec9613bfd9dc$var$i1] = 8;
for(var $4c39ec9613bfd9dc$var$i2 = 144; $4c39ec9613bfd9dc$var$i2 < 256; ++$4c39ec9613bfd9dc$var$i2)$4c39ec9613bfd9dc$var$flt[$4c39ec9613bfd9dc$var$i2] = 9;
for(var $4c39ec9613bfd9dc$var$i3 = 256; $4c39ec9613bfd9dc$var$i3 < 280; ++$4c39ec9613bfd9dc$var$i3)$4c39ec9613bfd9dc$var$flt[$4c39ec9613bfd9dc$var$i3] = 7;
for(var $4c39ec9613bfd9dc$var$i4 = 280; $4c39ec9613bfd9dc$var$i4 < 288; ++$4c39ec9613bfd9dc$var$i4)$4c39ec9613bfd9dc$var$flt[$4c39ec9613bfd9dc$var$i4] = 8; // fixed distance tree
var $4c39ec9613bfd9dc$var$fdt = new $4c39ec9613bfd9dc$var$u8(32);
for(var $4c39ec9613bfd9dc$var$i5 = 0; $4c39ec9613bfd9dc$var$i5 < 32; ++$4c39ec9613bfd9dc$var$i5)$4c39ec9613bfd9dc$var$fdt[$4c39ec9613bfd9dc$var$i5] = 5; // fixed length map
var $4c39ec9613bfd9dc$var$flrm = $4c39ec9613bfd9dc$var$hMap($4c39ec9613bfd9dc$var$flt, 9, 1); // fixed distance map
var $4c39ec9613bfd9dc$var$fdrm = $4c39ec9613bfd9dc$var$hMap($4c39ec9613bfd9dc$var$fdt, 5, 1); // read d, starting at bit p and mask with m
var $4c39ec9613bfd9dc$var$bits = function(d, p, m) {
    var o = p >>> 3;
    return (d[o] | d[o + 1] << 8) >>> (p & 7) & m;
}; // read d, starting at bit p continuing for at least 16 bits
var $4c39ec9613bfd9dc$var$bits16 = function(d, p) {
    var o = p >>> 3;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >>> (p & 7);
}; // get end of byte
var $4c39ec9613bfd9dc$var$shft = function(p) {
    return (p >>> 3) + (p & 7 && 1);
}; // typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $4c39ec9613bfd9dc$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length; // can't use .constructor in case user-supplied
    var n = new (v instanceof $4c39ec9613bfd9dc$var$u16 ? $4c39ec9613bfd9dc$var$u16 : v instanceof $4c39ec9613bfd9dc$var$u32 ? $4c39ec9613bfd9dc$var$u32 : $4c39ec9613bfd9dc$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
}; // find max of array
var $4c39ec9613bfd9dc$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
}; // expands raw DEFLATE data
var $4c39ec9613bfd9dc$var$inflt = function(dat, buf, st) {
    var noSt = !st || st.i;
    if (!st) st = {}; // source length
    var sl = dat.length; // have to estimate size
    var noBuf = !buf || !noSt; // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $4c39ec9613bfd9dc$var$u8(sl * 3); // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length; // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $4c39ec9613bfd9dc$var$u8(Math.max(bl << 1, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    }; //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    if (final && !lm) return buf; // total bits
    var tbts = sl << 3;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $4c39ec9613bfd9dc$var$bits(dat, pos, 1); // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $4c39ec9613bfd9dc$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $4c39ec9613bfd9dc$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw "unexpected EOF";
                    break;
                } // ensure size
                if (noBuf) cbuf(bt + l); // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt); // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t << 3;
                continue;
            } else if (type == 1) lm = $4c39ec9613bfd9dc$var$flrm, dm = $4c39ec9613bfd9dc$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $4c39ec9613bfd9dc$var$bits(dat, pos, 31) + 257, hcLen = $4c39ec9613bfd9dc$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $4c39ec9613bfd9dc$var$bits(dat, pos + 5, 31) + 1;
                pos += 14; // length+distance tree
                var ldt = new $4c39ec9613bfd9dc$var$u8(tl); // code length tree
                var clt = new $4c39ec9613bfd9dc$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$4c39ec9613bfd9dc$var$clim[i]] = $4c39ec9613bfd9dc$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3; // code lengths bits
                var clb = $4c39ec9613bfd9dc$var$max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break; // code lengths map
                var clm = $4c39ec9613bfd9dc$var$hMap(clt, clb, 1);
                for(var i1 = 0; i1 < tl;){
                    var r = clm[$4c39ec9613bfd9dc$var$bits(dat, pos, clbmsk)]; // bits read
                    pos += r & 15; // symbol
                    var s1 = r >>> 4; // code length to copy
                    if (s1 < 16) ldt[i1++] = s1;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s1 == 16) n = 3 + $4c39ec9613bfd9dc$var$bits(dat, pos, 3), pos += 2, c = ldt[i1 - 1];
                        else if (s1 == 17) n = 3 + $4c39ec9613bfd9dc$var$bits(dat, pos, 7), pos += 3;
                        else if (s1 == 18) n = 11 + $4c39ec9613bfd9dc$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i1++] = c;
                    }
                } //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit); // max length bits
                lbt = $4c39ec9613bfd9dc$var$max(lt); // max dist bits
                dbt = $4c39ec9613bfd9dc$var$max(dt);
                lm = $4c39ec9613bfd9dc$var$hMap(lt, lbt, 1);
                dm = $4c39ec9613bfd9dc$var$hMap(dt, dbt, 1);
            } else throw "invalid block type";
            if (pos > tbts) throw "unexpected EOF";
        } // Make sure the buffer can hold this + the largest possible addition
        // maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while(noSt || pos + mxa < tbts){
            // bits read, code
            var c1 = lm[$4c39ec9613bfd9dc$var$bits16(dat, pos) & lms], sym = c1 >>> 4;
            pos += c1 & 15;
            if (pos > tbts) throw "unexpected EOF";
            if (!c1) throw "invalid length/literal";
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = undefined;
                break;
            } else {
                var add = sym - 254; // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i2 = sym - 257, b = $4c39ec9613bfd9dc$var$fleb[i2];
                    add = $4c39ec9613bfd9dc$var$bits(dat, pos, (1 << b) - 1) + $4c39ec9613bfd9dc$var$fl[i2];
                    pos += b;
                } // dist
                var d = dm[$4c39ec9613bfd9dc$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw "invalid distance";
                pos += d & 15;
                var dt1 = $4c39ec9613bfd9dc$var$fd[dsym];
                if (dsym > 3) {
                    var b1 = $4c39ec9613bfd9dc$var$fdeb[dsym];
                    dt1 += $4c39ec9613bfd9dc$var$bits16(dat, pos) & (1 << b1) - 1, pos += b1;
                }
                if (pos > tbts) throw "unexpected EOF";
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt1];
                    buf[bt + 1] = buf[bt + 1 - dt1];
                    buf[bt + 2] = buf[bt + 2 - dt1];
                    buf[bt + 3] = buf[bt + 3 - dt1];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $4c39ec9613bfd9dc$var$slc(buf, 0, bt);
}; // zlib valid
var $4c39ec9613bfd9dc$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw "invalid zlib data";
    if (d[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
function $4c39ec9613bfd9dc$export$9ec8134f0f1b9fc6(data, out) {
    return $4c39ec9613bfd9dc$var$inflt(($4c39ec9613bfd9dc$var$zlv(data), data.subarray(2, -4)), out);
}


var $89efd43e57103f35$export$871a6229fd6ab771 = (0, $4c39ec9613bfd9dc$export$9ec8134f0f1b9fc6)((0, $34e0061bb3b4a2f8$export$c62426fdd000a97e)((0, $a0f44b6e30f95aac$export$b3317979f9250576)), new Uint8Array((0, $a0f44b6e30f95aac$export$e9c43f21ee54beb6)));


// Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $6rBFC = parcelRequire("6rBFC");

var $gF0bR = parcelRequire("gF0bR");

var $6qu4b = parcelRequire("6qu4b");
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $1572ed2560779676$export$9c6b53e35bc51b5c = /*#__PURE__*/ function() {
    "use strict";
    function TextDecoder(_) {
        (0, $7dKN1._)(this, TextDecoder);
    }
    (0, $eW5pA._)(TextDecoder, [
        {
            key: "decode",
            value: function decode(value) {
                var result = "";
                for(var i = 0; i < value.length; i++)result += String.fromCharCode(value[i]);
                return result;
            }
        }
    ]);
    return TextDecoder;
}();


// Copyright 2017-2021 @polkadot/x-textdecoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Auto-generated by @polkadot/dev, do not edit
var $9baee2a6315d2f45$export$ce0097da4c08ff3f = {
    name: "@polkadot/x-textdecoder",
    version: "8.2.2"
};


var $aabc6b105f61bd3e$export$9c6b53e35bc51b5c = (0, $70a11d92524ceb3e$export$157d08edb917d81)("TextDecoder", (0, $1572ed2560779676$export$9c6b53e35bc51b5c));


var $7927f0e05314a7b7$var$decoder = new (0, $aabc6b105f61bd3e$export$9c6b53e35bc51b5c)("utf-8");
function $7927f0e05314a7b7$export$792464756f58046b(value) {
    return !(value !== null && value !== void 0 && value.length) ? "" : $7927f0e05314a7b7$var$decoder.decode(value);
}


var $ea004b88ecb57cf2$var$wasm = null;
var $ea004b88ecb57cf2$var$cachegetInt32 = null;
var $ea004b88ecb57cf2$var$cachegetUint8 = null;
function $ea004b88ecb57cf2$export$3b24329f2e9107b6(wasmBytes, asmFn, wbg) {
    return $ea004b88ecb57cf2$var$_initWasm.apply(this, arguments);
}
function $ea004b88ecb57cf2$var$_initWasm() {
    $ea004b88ecb57cf2$var$_initWasm = (0, $6rBFC._)(function(wasmBytes, asmFn, wbg) {
        var source, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, $825198f93516e193$export$a7a9523472993e97)(typeof WebAssembly !== "undefined" && wasmBytes && wasmBytes.length, "WebAssembly is not available in your environment");
                    return [
                        4,
                        WebAssembly.instantiate(wasmBytes, {
                            wbg: wbg
                        })
                    ];
                case 1:
                    source = _state.sent();
                    $ea004b88ecb57cf2$var$wasm = source.instance.exports;
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    // if we have a valid supplied asm.js, return that
                    if (asmFn) $ea004b88ecb57cf2$var$wasm = asmFn(wbg);
                    else {
                        console.error("FATAL: Unable to initialize @polkadot/wasm-crypto");
                        console.error(error);
                        $ea004b88ecb57cf2$var$wasm = null;
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $ea004b88ecb57cf2$var$_initWasm.apply(this, arguments);
}
function $ea004b88ecb57cf2$export$8b9a791ab82cfa73(fn) {
    return function() {
        for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
            params[_key] = arguments[_key];
        }
        (0, $825198f93516e193$export$a7a9523472993e97)($ea004b88ecb57cf2$var$wasm, "The WASM interface has not been initialized. Ensure that you wait for the initialization Promise with waitReady() from @polkadot/wasm-crypto (or cryptoWaitReady() from @polkadot/util-crypto) before attempting to use WASM-only interfaces.");
        return fn.apply(void 0, [
            $ea004b88ecb57cf2$var$wasm
        ].concat((0, $gF0bR._)(params)));
    };
}
function $ea004b88ecb57cf2$export$10e9f578f0248026() {
    return $ea004b88ecb57cf2$var$wasm;
}
function $ea004b88ecb57cf2$export$20d487fff2ae6963() {
    if ($ea004b88ecb57cf2$var$cachegetInt32 === null || $ea004b88ecb57cf2$var$cachegetInt32.buffer !== $ea004b88ecb57cf2$var$wasm.memory.buffer) $ea004b88ecb57cf2$var$cachegetInt32 = new Int32Array($ea004b88ecb57cf2$var$wasm.memory.buffer);
    return $ea004b88ecb57cf2$var$cachegetInt32;
}
function $ea004b88ecb57cf2$export$3834d1ed55a74793() {
    if ($ea004b88ecb57cf2$var$cachegetUint8 === null || $ea004b88ecb57cf2$var$cachegetUint8.buffer !== $ea004b88ecb57cf2$var$wasm.memory.buffer) $ea004b88ecb57cf2$var$cachegetUint8 = new Uint8Array($ea004b88ecb57cf2$var$wasm.memory.buffer);
    return $ea004b88ecb57cf2$var$cachegetUint8;
}
function $ea004b88ecb57cf2$export$73d4f12a05c8488c(ptr, len) {
    return $ea004b88ecb57cf2$export$3834d1ed55a74793().subarray(ptr / 1, ptr / 1 + len);
}
function $ea004b88ecb57cf2$export$f8963f3214707ee4(ptr, len) {
    return (0, $7927f0e05314a7b7$export$792464756f58046b)($ea004b88ecb57cf2$export$73d4f12a05c8488c(ptr, len));
}
function $ea004b88ecb57cf2$export$5b9999928488c403(arg) {
    var ptr = $ea004b88ecb57cf2$var$wasm.__wbindgen_malloc(arg.length * 1);
    $ea004b88ecb57cf2$export$3834d1ed55a74793().set(arg, ptr / 1);
    return [
        ptr,
        arg.length
    ];
}
function $ea004b88ecb57cf2$export$1db87afeaddaceb2(arg) {
    return $ea004b88ecb57cf2$export$5b9999928488c403((0, $9aa70a4c1365a75e$export$e66335b9b1239eaf)(arg));
}
function $ea004b88ecb57cf2$export$7c8e0ebf1230e6af() {
    var r0 = $ea004b88ecb57cf2$export$20d487fff2ae6963()[2];
    var r1 = $ea004b88ecb57cf2$export$20d487fff2ae6963()[3];
    var ret = $ea004b88ecb57cf2$export$73d4f12a05c8488c(r0, r1).slice();
    $ea004b88ecb57cf2$var$wasm.__wbindgen_free(r0, r1 * 1);
    return ret;
}
function $ea004b88ecb57cf2$export$531e863820a43472() {
    return (0, $7927f0e05314a7b7$export$792464756f58046b)($ea004b88ecb57cf2$export$7c8e0ebf1230e6af());
}


var $586ae9e42eb454e1$exports = {};

$parcel$export($586ae9e42eb454e1$exports, "__wbindgen_is_undefined", function () { return $586ae9e42eb454e1$export$3b2b2ed759e5e15; });
$parcel$export($586ae9e42eb454e1$exports, "__wbindgen_throw", function () { return $586ae9e42eb454e1$export$39a6850c64af1eb3; });
$parcel$export($586ae9e42eb454e1$exports, "__wbg_self_1b7a39e3a92c949c", function () { return $586ae9e42eb454e1$export$ec504183618e0698; });
$parcel$export($586ae9e42eb454e1$exports, "__wbg_require_604837428532a733", function () { return $586ae9e42eb454e1$export$6ebb1b478ee36e39; });
$parcel$export($586ae9e42eb454e1$exports, "__wbg_crypto_968f1772287e2df0", function () { return $586ae9e42eb454e1$export$877644ecd88234f3; });
$parcel$export($586ae9e42eb454e1$exports, "__wbg_getRandomValues_a3d34b4fee3c2869", function () { return $586ae9e42eb454e1$export$4e3cbd6a218734ff; });
$parcel$export($586ae9e42eb454e1$exports, "__wbg_getRandomValues_f5e14ab7ac8e995d", function () { return $586ae9e42eb454e1$export$4b22af11f34a13db; });
$parcel$export($586ae9e42eb454e1$exports, "__wbg_randomFillSync_d5bd2d655fdf256a", function () { return $586ae9e42eb454e1$export$a8edc2539148e706; });
$parcel$export($586ae9e42eb454e1$exports, "__wbindgen_object_drop_ref", function () { return $586ae9e42eb454e1$export$b385d28488f5908e; });
$parcel$export($586ae9e42eb454e1$exports, "abort", function () { return $586ae9e42eb454e1$export$5def58af4fd46132; });
// Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
/* eslint-disable camelcase */ // Copyright 2017-2021 @polkadot/x-randomvalues authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/x-randomvalues authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Auto-generated by @polkadot/dev, do not edit
var $76adc0f270c942a5$export$ce0097da4c08ff3f = {
    name: "@polkadot/x-randomvalues",
    version: "8.2.2"
};


function $5ccdd39bb428d06d$export$960b9ff25e7d4257(arr) {
    return crypto.getRandomValues(arr);
}



var $586ae9e42eb454e1$var$DEFAULT_CRYPTO = {
    getRandomValues: (0, $5ccdd39bb428d06d$export$960b9ff25e7d4257)
};
var $586ae9e42eb454e1$var$DEFAULT_SELF = {
    crypto: $586ae9e42eb454e1$var$DEFAULT_CRYPTO
};
var $586ae9e42eb454e1$var$heap = new Array(32).fill(undefined).concat(undefined, null, true, false);
var $586ae9e42eb454e1$var$heapNext = $586ae9e42eb454e1$var$heap.length;
function $586ae9e42eb454e1$var$getObject(idx) {
    return $586ae9e42eb454e1$var$heap[idx];
}
function $586ae9e42eb454e1$var$dropObject(idx) {
    if (idx < 36) return;
    $586ae9e42eb454e1$var$heap[idx] = $586ae9e42eb454e1$var$heapNext;
    $586ae9e42eb454e1$var$heapNext = idx;
}
function $586ae9e42eb454e1$var$takeObject(idx) {
    var ret = $586ae9e42eb454e1$var$getObject(idx);
    $586ae9e42eb454e1$var$dropObject(idx);
    return ret;
}
function $586ae9e42eb454e1$var$addObject(obj) {
    if ($586ae9e42eb454e1$var$heapNext === $586ae9e42eb454e1$var$heap.length) $586ae9e42eb454e1$var$heap.push($586ae9e42eb454e1$var$heap.length + 1);
    var idx = $586ae9e42eb454e1$var$heapNext;
    $586ae9e42eb454e1$var$heapNext = $586ae9e42eb454e1$var$heap[idx];
    $586ae9e42eb454e1$var$heap[idx] = obj;
    return idx;
}
function $586ae9e42eb454e1$export$3b2b2ed759e5e15(idx) {
    return $586ae9e42eb454e1$var$getObject(idx) === undefined;
}
function $586ae9e42eb454e1$export$39a6850c64af1eb3(ptr, len) {
    throw new Error((0, $ea004b88ecb57cf2$export$f8963f3214707ee4)(ptr, len));
}
function $586ae9e42eb454e1$export$ec504183618e0698() {
    return $586ae9e42eb454e1$var$addObject($586ae9e42eb454e1$var$DEFAULT_SELF);
}
function $586ae9e42eb454e1$export$6ebb1b478ee36e39(ptr, len) {
    throw new Error("Unable to require ".concat((0, $ea004b88ecb57cf2$export$f8963f3214707ee4)(ptr, len)));
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $586ae9e42eb454e1$export$877644ecd88234f3(_idx) {
    return $586ae9e42eb454e1$var$addObject($586ae9e42eb454e1$var$DEFAULT_CRYPTO);
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $586ae9e42eb454e1$export$4e3cbd6a218734ff(_idx) {
    return $586ae9e42eb454e1$var$addObject($586ae9e42eb454e1$var$DEFAULT_CRYPTO.getRandomValues);
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $586ae9e42eb454e1$export$4b22af11f34a13db(_arg0, ptr, len) {
    $586ae9e42eb454e1$var$DEFAULT_CRYPTO.getRandomValues((0, $ea004b88ecb57cf2$export$73d4f12a05c8488c)(ptr, len));
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $586ae9e42eb454e1$export$a8edc2539148e706(_idx, _ptr, _len) {
    throw new Error("randomFillsync is not available"); // getObject(idx).randomFillSync(getU8a(ptr, len));
}
function $586ae9e42eb454e1$export$b385d28488f5908e(idx) {
    $586ae9e42eb454e1$var$takeObject(idx);
}
function $586ae9e42eb454e1$export$5def58af4fd46132() {
    throw new Error("abort");
}



var $1e17eee1fd4b0708$var$wasmPromise = (0, $ea004b88ecb57cf2$export$3b24329f2e9107b6)((0, $89efd43e57103f35$export$871a6229fd6ab771), (0, $efae7c76d77a5325$export$55a8d7752269af9b), $586ae9e42eb454e1$exports).catch(function() {
    return null;
});
var $1e17eee1fd4b0708$export$35df27fe5ef13c6a = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, words) {
    wasm.ext_bip39_generate(8, words);
    return (0, $ea004b88ecb57cf2$export$531e863820a43472)();
});
var $1e17eee1fd4b0708$export$783f901bc6c03ef8 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, phrase) {
    var _wasm;
    (_wasm = wasm).ext_bip39_to_entropy.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$1db87afeaddaceb2)(phrase))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$26b92a276f4ce11a = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, phrase, password) {
    var _wasm;
    (_wasm = wasm).ext_bip39_to_mini_secret.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$1db87afeaddaceb2)(phrase)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$1db87afeaddaceb2)(password))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$cba58e913ea1e4dd = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, phrase, password) {
    var _wasm;
    (_wasm = wasm).ext_bip39_to_seed.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$1db87afeaddaceb2)(phrase)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$1db87afeaddaceb2)(password))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$bc906819c94874c7 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, phrase) {
    var _wasm;
    var ret = (_wasm = wasm).ext_bip39_validate.apply(_wasm, (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$1db87afeaddaceb2)(phrase)));
    return ret !== 0;
});
var $1e17eee1fd4b0708$export$e2c6920639612ea9 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, seed) {
    var _wasm;
    (_wasm = wasm).ext_ed_from_seed.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(seed))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$efeeb32bd0b99991 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey, seckey, message) {
    var _wasm;
    (_wasm = wasm).ext_ed_sign.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(seckey)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(message))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$6318e82db5ba9c5b = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, signature, message, pubkey) {
    var _wasm;
    var ret = (_wasm = wasm).ext_ed_verify.apply(_wasm, (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(signature)).concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(message)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey))));
    return ret !== 0;
});
var $1e17eee1fd4b0708$export$761623c44fdf790 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, seckey) {
    var _wasm;
    (_wasm = wasm).ext_secp_from_seed.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(seckey))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$77e7b9749fd538d7 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey) {
    var _wasm;
    (_wasm = wasm).ext_secp_pub_compress.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$aeb350b8636aeb32 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey) {
    var _wasm;
    (_wasm = wasm).ext_secp_pub_expand.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$b3a14b2e44f710df = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, msgHash, sig, recovery) {
    var _wasm;
    (_wasm = wasm).ext_secp_recover.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(msgHash)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(sig)), [
        recovery
    ]));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$ccc409d84129e38e = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, msgHash, seckey) {
    var _wasm;
    (_wasm = wasm).ext_secp_sign.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(msgHash)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(seckey))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$9de1259e4f2cc265 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pair, cc) {
    var _wasm;
    (_wasm = wasm).ext_sr_derive_keypair_hard.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pair)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(cc))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$f7969b889341848e = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pair, cc) {
    var _wasm;
    (_wasm = wasm).ext_sr_derive_keypair_soft.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pair)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(cc))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$c258d6ece124c84d = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey, cc) {
    var _wasm;
    (_wasm = wasm).ext_sr_derive_public_soft.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(cc))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$9cb94d9e1f85177c = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, seed) {
    var _wasm;
    (_wasm = wasm).ext_sr_from_seed.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(seed))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$a0daa256430739d5 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey, secret, message) {
    var _wasm;
    (_wasm = wasm).ext_sr_sign.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(secret)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(message))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$66054820ad7c0da7 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, signature, message, pubkey) {
    var _wasm;
    var ret = (_wasm = wasm).ext_sr_verify.apply(_wasm, (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(signature)).concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(message)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey))));
    return ret !== 0;
});
var $1e17eee1fd4b0708$export$ff5b3d47a1e4fb35 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey, secret) {
    var _wasm;
    (_wasm = wasm).ext_sr_agree.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(secret))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$abd7916afb7ee599 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, secret, context, message, extra) {
    var _wasm;
    (_wasm = wasm).ext_vrf_sign.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(secret)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(context)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(message)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(extra))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$994b32edcaf9ff72 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, pubkey, context, message, extra, outAndProof) {
    var _wasm;
    var ret = (_wasm = wasm).ext_vrf_verify.apply(_wasm, (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(pubkey)).concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(context)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(message)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(extra)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(outAndProof))));
    return ret !== 0;
});
var $1e17eee1fd4b0708$export$31406b37573ddf7 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data, key, size) {
    var _wasm;
    (_wasm = wasm).ext_blake2b.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(key)), [
        size
    ]));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$8cb906c207500861 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, key, data) {
    var _wasm;
    (_wasm = wasm).ext_hmac_sha256.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(key)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$2fa9719a63596dff = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, key, data) {
    var _wasm;
    (_wasm = wasm).ext_hmac_sha512.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(key)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$f8151fce47ad1c35 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data) {
    var _wasm;
    (_wasm = wasm).ext_keccak256.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$e432dfb0f2f2942f = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data) {
    var _wasm;
    (_wasm = wasm).ext_keccak512.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$448fa22aedc9dbca = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data, salt, rounds) {
    var _wasm;
    (_wasm = wasm).ext_pbkdf2.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(salt)), [
        rounds
    ]));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$7cf7c2f1ec457bf3 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, password, salt, log2n, r, p) {
    var _wasm;
    (_wasm = wasm).ext_scrypt.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(password)), (0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(salt)), [
        log2n,
        r,
        p
    ]));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$bced8d2aada2d1c9 = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data) {
    var _wasm;
    (_wasm = wasm).ext_sha256.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$a888d2532e6dc7bb = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data) {
    var _wasm;
    (_wasm = wasm).ext_sha512.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data))));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
var $1e17eee1fd4b0708$export$efade200b728510d = (0, $ea004b88ecb57cf2$export$8b9a791ab82cfa73)(function(wasm, data, rounds) {
    var _wasm;
    (_wasm = wasm).ext_twox.apply(_wasm, [
        8
    ].concat((0, $gF0bR._)((0, $ea004b88ecb57cf2$export$5b9999928488c403)(data)), [
        rounds
    ]));
    return (0, $ea004b88ecb57cf2$export$7c8e0ebf1230e6af)();
});
function $1e17eee1fd4b0708$export$af3c031fde264cc6() {
    return !!(0, $ea004b88ecb57cf2$export$10e9f578f0248026)();
}
function $1e17eee1fd4b0708$export$6975dd8173b81e43() {
    return $1e17eee1fd4b0708$var$wasmPromise.then(function() {
        return $1e17eee1fd4b0708$export$af3c031fde264cc6();
    });
}


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

var $gF0bR = parcelRequire("gF0bR");
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0

/** @internal */ function $cec04ad4c4c8858a$var$hex(value) {
    var mod = value.length % 2;
    var length = value.length - mod;
    var dv = new DataView(value.buffer, value.byteOffset);
    var result = "";
    for(var i = 0; i < length; i += 2)result += (0, $e7578918ebce54c7$export$56cfdbeb228b5229)[dv.getUint16(i)];
    if (mod) result += (0, $e7578918ebce54c7$export$ceddb95bf4b87e91)[dv.getUint8(length)];
    return result;
}
function $cec04ad4c4c8858a$export$4429d284633899e1(value) {
    var bitLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, isPrefixed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var length = Math.ceil(bitLength / 8);
    return "".concat(isPrefixed ? "0x" : "").concat(!value || !value.length ? "" : length > 0 && value.length > length ? "".concat($cec04ad4c4c8858a$var$hex(value.subarray(0, length / 2)), "\u2026").concat($cec04ad4c4c8858a$var$hex(value.subarray(value.length - length / 2))) : $cec04ad4c4c8858a$var$hex(value));
}



function $e78b617a73c50627$export$6e489b4cfdd62721(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $cec04ad4c4c8858a$export$4429d284633899e1)(fn.apply(void 0, (0, $gF0bR._)(args)));
    };
}
function $e78b617a73c50627$export$6d7551883ed6dc0f(bitLength, fn) {
    return function(data, onlyJs) {
        return fn(data, bitLength, onlyJs);
    };
}
function $e78b617a73c50627$export$1b8e7c173b6f2602(wa, js) {
    return function(value) {
        var bitLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 256, onlyJs = arguments.length > 2 ? arguments[2] : void 0;
        var u8a = (0, $06f406c421475967$export$3d1a44fbed727ee2)(value);
        return !(0, $8a2cc693f2458a2f$export$c50f41259082745b) || !onlyJs && (0, $1e17eee1fd4b0708$export$af3c031fde264cc6)() ? wa[bitLength](u8a) : js[bitLength](u8a);
    };
}


function $31c4d254e093ce02$export$5faebd53a9e0f952(data) {
    var bitLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 256, key = arguments.length > 2 ? arguments[2] : void 0, onlyJs = arguments.length > 3 ? arguments[3] : void 0;
    var byteLength = Math.ceil(bitLength / 8);
    var u8a = (0, $06f406c421475967$export$3d1a44fbed727ee2)(data);
    return !(0, $8a2cc693f2458a2f$export$c50f41259082745b) || !onlyJs && (0, $1e17eee1fd4b0708$export$af3c031fde264cc6)() ? (0, $1e17eee1fd4b0708$export$31406b37573ddf7)(u8a, (0, $06f406c421475967$export$3d1a44fbed727ee2)(key), byteLength) : (0, $cd12d97bf05dfd81$exports.blake2b)(u8a, {
        dkLen: byteLength,
        key: key || undefined
    });
}
var $31c4d254e093ce02$export$808fb830d95da849 = (0, $e78b617a73c50627$export$6e489b4cfdd62721)($31c4d254e093ce02$export$5faebd53a9e0f952);


var $a714e42ec419add2$var$SS58_PREFIX = (0, $9aa70a4c1365a75e$export$e66335b9b1239eaf)("SS58PRE");
function $a714e42ec419add2$export$532a1e05ac7e36e6(key) {
    return (0, $31c4d254e093ce02$export$5faebd53a9e0f952)((0, $c4685798df67064d$export$7b640c40d4922c2e)($a714e42ec419add2$var$SS58_PREFIX, key), 512);
}


function $07a335b1202d9e5c$export$3a8dea5969197010(decoded) {
    var ss58Length = decoded[0] & 64 ? 2 : 1;
    var ss58Decoded = ss58Length === 1 ? decoded[0] : (decoded[0] & 63) << 2 | decoded[1] >> 6 | (decoded[1] & 63) << 8; // 32/33 bytes public + 2 bytes checksum + prefix
    var isPublicKey = [
        34 + ss58Length,
        35 + ss58Length
    ].includes(decoded.length);
    var length = decoded.length - (isPublicKey ? 2 : 1); // calculate the hash and do the checksum byte checks
    var hash = (0, $a714e42ec419add2$export$532a1e05ac7e36e6)(decoded.subarray(0, length));
    var isValid = (decoded[0] & 128) === 0 && ![
        46,
        47
    ].includes(decoded[0]) && (isPublicKey ? decoded[decoded.length - 2] === hash[0] && decoded[decoded.length - 1] === hash[1] : decoded[decoded.length - 1] === hash[0]);
    return [
        isValid,
        length,
        ss58Length,
        ss58Decoded
    ];
}


// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/networks authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Copyright 2017-2021 @polkadot/networks authors & contributors
// SPDX-License-Identifier: Apache-2.0
var $d678781db17b8a25$export$9cace3d557b030c6 = "https://raw.githubusercontent.com/paritytech/ss58-registry/main/ss58-registry.json"; // NOTE: In the case where the network was hard-spooned and multiple genesisHashes
var $d678781db17b8a25$export$5a4d9c086e2d7883 = {
    acala: [
        "0xfc41b9bd8ef8fe53d58c7ea67c794c7ec9a73daf05e6d54b14ff6342c99ba64c"
    ],
    bifrost: [
        "0x9f28c6a68e0fc9646eff64935684f6eeeece527e37bbe1f213d22caa1d9d6bed"
    ],
    centrifuge: [
        "0x67dddf2673b69e5f875f6f25277495834398eafd67f492e09f3f3345e003d1b5"
    ],
    "dock-mainnet": [
        "0xf73467c6544aa68df2ee546b135f955c46b90fa627e9b5d7935f41061bb8a5a9"
    ],
    edgeware: [
        "0x742a2ca70c2fda6cee4f8df98d64c4c670a052d9568058982dad9d5a7a135c5b"
    ],
    equilibrium: [
        "0x6f1a800de3daff7f5e037ddf66ab22ce03ab91874debeddb1086f5f7dbd48925"
    ],
    genshiro: [
        "0x9b8cefc0eb5c568b527998bdd76c184e2b76ae561be76e4667072230217ea243"
    ],
    hydradx: [
        "0xd2a620c27ec5cbc5621ff9a522689895074f7cca0d08e7134a7804e1a3ba86fc",
        "0x10af6e84234477d84dc572bac0789813b254aa490767ed06fb9591191d1073f9",
        "0x3d75507dd46301767e601265791da1d9cb47b6ebc94e87347b635e5bf58bd047",
        "0x0ed32bfcab4a83517fac88f2aa7cbc2f88d3ab93be9a12b6188a036bf8a943c2" // Snakenet Gen1
    ],
    karura: [
        "0xbaf5aabe40646d11f0ee8abbdc64f4a4b7674925cba08e4a05ff9ebed6e2126b"
    ],
    kulupu: [
        "0xf7a99d3cb92853d00d5275c971c132c074636256583fee53b3bbe60d7b8769ba"
    ],
    kusama: [
        "0xb0a8d493285c2df73290dfb7e61f870f17b41801197a149ca93654499ea3dafe",
        "0xe3777fa922cafbff200cadeaea1a76bd7898ad5b89f7848999058b50e715f636",
        "0x3fd7b9eb6a00376e5be61f01abb429ffb0b104be05eaff4d458da48fcd425baf" // Kusama CC1
    ],
    "nodle-chain": [
        "0xa3d114c2b8d0627c1aa9b134eafcf7d05ca561fdc19fb388bb9457f81809fb23"
    ],
    picasso: [
        "0xe8e7f0f4c4f5a00720b4821dbfddefea7490bcf0b19009961cc46957984e2c1c"
    ],
    plasm: [
        "0x3e86364d4b4894021cb2a0390bcf2feb5517d5292f2de2bb9404227e908b0b8b"
    ],
    polkadot: [
        "0x91b171bb158e2d3848fa23a9f1c25182fb8e20313b2c1eb49219da7a70ce90c3"
    ],
    polymesh: [
        "0x6fbd74e5e1d0a61d52ccfe9d4adaed16dd3a7caa37c6bc4d0c2fa12e8b2f4063"
    ],
    sora: [
        "0x7e4e32d0feafd4f9c9414b0be86373f9a1efa904809b683453a9af6856d38ad5"
    ],
    stafi: [
        "0x290a4149f09ea0e402c74c1c7e96ae4239588577fe78932f94f5404c68243d80"
    ],
    statemine: [
        "0x48239ef607d7928874027a43a67689209727dfb3d3dc5e5b03a39bdc2eda771a"
    ],
    subsocial: [
        "0x0bd72c1c305172e1275278aaeb3f161e02eccb7a819e63f62d47bd53a28189f8"
    ]
}; // these are icon overrides
var $d678781db17b8a25$export$1b2dd6e34fcff367 = {
    centrifuge: "polkadot",
    kusama: "polkadot",
    polkadot: "polkadot",
    sora: "polkadot",
    statemine: "polkadot",
    statemint: "polkadot",
    westmint: "polkadot"
}; // These match up with the keys of the ledgerApps object in the @polkadot/hw-ledger/defaults.ts
var $d678781db17b8a25$export$4454dde8b324e76f = {
    bifrost: 0x00000314,
    centrifuge: 0x000002eb,
    "dock-mainnet": 0x00000252,
    edgeware: 0x0000020b,
    equilibrium: 0x05f5e0fd,
    genshiro: 0x05f5e0fc,
    kusama: 0x000001b2,
    "nodle-chain": 0x000003eb,
    polkadot: 0x00000162,
    polymesh: 0x00000253,
    sora: 0x00000269,
    statemine: 0x000001b2 // common-good on Kusama, shares derivation
}; // testnets should not allow selection
var $d678781db17b8a25$export$6cc4c2f1b56ab49e = {
    "": true,
    // this is the default non-network entry
    "cess-testnet": true,
    "dock-testnet": true,
    jupiter: true,
    "mathchain-testnet": true,
    subspace_testnet: true,
    "zero-alphaville": true
};


// Copyright 2017-2021 @polkadot/networks authors & contributors
// SPDX-License-Identifier: Apache-2.0
//
// Auto-generated by yarn networks:sync (via scripts/fromSubstrate.mjs)
//
// This file should never be edited manually. Rather the process is as follow -
//
//   - make a PR to the upstream registry found at https://github.com/paritytech/ss58-registry/
//   - ensure the PR gets merged
//   - yarn networks:sync in this repo to sync
//
// Any manual changes to this file will make CI cron checks fail and will be
// lost when the registry is updated alongside the above sync.
//
var $ca0ab2c1b47bd0ad$export$d503e845a12236aa = [
    {
        decimals: [
            10
        ],
        displayName: "Polkadot Relay Chain",
        network: "polkadot",
        prefix: 0,
        standardAccount: "*25519",
        symbols: [
            "DOT"
        ],
        website: "https://polkadot.network"
    },
    {
        decimals: null,
        displayName: "Bare 32-bit Schnorr/Ristretto (S/R 25519) public key.",
        network: "BareSr25519",
        prefix: 1,
        standardAccount: "Sr25519",
        symbols: null,
        website: null
    },
    {
        decimals: [
            12
        ],
        displayName: "Kusama Relay Chain",
        network: "kusama",
        prefix: 2,
        standardAccount: "*25519",
        symbols: [
            "KSM"
        ],
        website: "https://kusama.network"
    },
    {
        decimals: null,
        displayName: "Bare 32-bit Ed25519 public key.",
        network: "BareEd25519",
        prefix: 3,
        standardAccount: "Ed25519",
        symbols: null,
        website: null
    },
    {
        decimals: null,
        displayName: "Katal Chain",
        network: "katalchain",
        prefix: 4,
        standardAccount: "*25519",
        symbols: null,
        website: null
    },
    {
        decimals: [
            15
        ],
        displayName: "Plasm Network",
        network: "plasm",
        prefix: 5,
        standardAccount: "*25519",
        symbols: [
            "PLM"
        ],
        website: "https://plasmnet.io"
    },
    {
        decimals: [
            12
        ],
        displayName: "Bifrost",
        network: "bifrost",
        prefix: 6,
        standardAccount: "*25519",
        symbols: [
            "BNC"
        ],
        website: "https://bifrost.finance/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Edgeware",
        network: "edgeware",
        prefix: 7,
        standardAccount: "*25519",
        symbols: [
            "EDG"
        ],
        website: "https://edgewa.re"
    },
    {
        decimals: [
            12
        ],
        displayName: "Karura",
        network: "karura",
        prefix: 8,
        standardAccount: "*25519",
        symbols: [
            "KAR"
        ],
        website: "https://karura.network/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Laminar Reynolds Canary",
        network: "reynolds",
        prefix: 9,
        standardAccount: "*25519",
        symbols: [
            "REY"
        ],
        website: "http://laminar.network/"
    },
    {
        decimals: [
            12
        ],
        displayName: "Acala",
        network: "acala",
        prefix: 10,
        standardAccount: "*25519",
        symbols: [
            "ACA"
        ],
        website: "https://acala.network/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Laminar",
        network: "laminar",
        prefix: 11,
        standardAccount: "*25519",
        symbols: [
            "LAMI"
        ],
        website: "http://laminar.network/"
    },
    {
        decimals: [
            6
        ],
        displayName: "Polymesh",
        network: "polymesh",
        prefix: 12,
        standardAccount: "*25519",
        symbols: [
            "POLYX"
        ],
        website: "https://polymath.network/"
    },
    {
        decimals: [
            12
        ],
        displayName: "Integritee",
        network: "integritee",
        prefix: 13,
        standardAccount: "*25519",
        symbols: [
            "TEER"
        ],
        website: "https://integritee.network"
    },
    {
        decimals: [
            0
        ],
        displayName: "Totem",
        network: "totem",
        prefix: 14,
        standardAccount: "*25519",
        symbols: [
            "TOTEM"
        ],
        website: "https://totemaccounting.com"
    },
    {
        decimals: [
            12
        ],
        displayName: "Synesthesia",
        network: "synesthesia",
        prefix: 15,
        standardAccount: "*25519",
        symbols: [
            "SYN"
        ],
        website: "https://synesthesia.network/"
    },
    {
        decimals: [
            12
        ],
        displayName: "Kulupu",
        network: "kulupu",
        prefix: 16,
        standardAccount: "*25519",
        symbols: [
            "KLP"
        ],
        website: "https://kulupu.network/"
    },
    {
        decimals: null,
        displayName: "Dark Mainnet",
        network: "dark",
        prefix: 17,
        standardAccount: "*25519",
        symbols: null,
        website: null
    },
    {
        decimals: [
            9,
            9
        ],
        displayName: "Darwinia Network",
        network: "darwinia",
        prefix: 18,
        standardAccount: "*25519",
        symbols: [
            "RING",
            "KTON"
        ],
        website: "https://darwinia.network/"
    },
    {
        decimals: [
            12
        ],
        displayName: "GeekCash",
        network: "geek",
        prefix: 19,
        standardAccount: "*25519",
        symbols: [
            "GEEK"
        ],
        website: "https://geekcash.org"
    },
    {
        decimals: [
            12
        ],
        displayName: "Stafi",
        network: "stafi",
        prefix: 20,
        standardAccount: "*25519",
        symbols: [
            "FIS"
        ],
        website: "https://stafi.io"
    },
    {
        decimals: [
            6
        ],
        displayName: "Dock Testnet",
        network: "dock-testnet",
        prefix: 21,
        standardAccount: "*25519",
        symbols: [
            "DCK"
        ],
        website: "https://dock.io"
    },
    {
        decimals: [
            6
        ],
        displayName: "Dock Mainnet",
        network: "dock-mainnet",
        prefix: 22,
        standardAccount: "*25519",
        symbols: [
            "DCK"
        ],
        website: "https://dock.io"
    },
    {
        decimals: null,
        displayName: "ShiftNrg",
        network: "shift",
        prefix: 23,
        standardAccount: "*25519",
        symbols: null,
        website: null
    },
    {
        decimals: [
            18
        ],
        displayName: "ZERO",
        network: "zero",
        prefix: 24,
        standardAccount: "*25519",
        symbols: [
            "PLAY"
        ],
        website: "https://zero.io"
    },
    {
        decimals: [
            18
        ],
        displayName: "ZERO Alphaville",
        network: "zero-alphaville",
        prefix: 25,
        standardAccount: "*25519",
        symbols: [
            "PLAY"
        ],
        website: "https://zero.io"
    },
    {
        decimals: [
            10
        ],
        displayName: "Jupiter",
        network: "jupiter",
        prefix: 26,
        standardAccount: "*25519",
        symbols: [
            "jDOT"
        ],
        website: "https://jupiter.patract.io"
    },
    {
        decimals: null,
        displayName: "Subsocial",
        network: "subsocial",
        prefix: 28,
        standardAccount: "*25519",
        symbols: null,
        website: null
    },
    {
        decimals: [
            12,
            12
        ],
        displayName: "CORD Network",
        network: "cord",
        prefix: 29,
        standardAccount: "*25519",
        symbols: [
            "DHI",
            "WAY"
        ],
        website: "https://cord.network/"
    },
    {
        decimals: [
            12
        ],
        displayName: "Phala Network",
        network: "phala",
        prefix: 30,
        standardAccount: "*25519",
        symbols: [
            "PHA"
        ],
        website: "https://phala.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "Litentry Network",
        network: "litentry",
        prefix: 31,
        standardAccount: "*25519",
        symbols: [
            "LIT"
        ],
        website: "https://litentry.com/"
    },
    {
        decimals: [
            9
        ],
        displayName: "Robonomics",
        network: "robonomics",
        prefix: 32,
        standardAccount: "*25519",
        symbols: [
            "XRT"
        ],
        website: "https://robonomics.network"
    },
    {
        decimals: null,
        displayName: "DataHighway",
        network: "datahighway",
        prefix: 33,
        standardAccount: "*25519",
        symbols: null,
        website: null
    },
    {
        decimals: [
            12
        ],
        displayName: "Ares Protocol",
        network: "ares",
        prefix: 34,
        standardAccount: "*25519",
        symbols: [
            "ARES"
        ],
        website: "https://www.aresprotocol.com/"
    },
    {
        decimals: [
            15
        ],
        displayName: "Valiu Liquidity Network",
        network: "vln",
        prefix: 35,
        standardAccount: "*25519",
        symbols: [
            "USDv"
        ],
        website: "https://valiu.com/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Centrifuge Chain",
        network: "centrifuge",
        prefix: 36,
        standardAccount: "*25519",
        symbols: [
            "CFG"
        ],
        website: "https://centrifuge.io/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Nodle Chain",
        network: "nodle",
        prefix: 37,
        standardAccount: "*25519",
        symbols: [
            "NODL"
        ],
        website: "https://nodle.io/"
    },
    {
        decimals: [
            18
        ],
        displayName: "KILT Chain",
        network: "kilt",
        prefix: 38,
        standardAccount: "*25519",
        symbols: [
            "KILT"
        ],
        website: "https://kilt.io/"
    },
    {
        decimals: [
            18
        ],
        displayName: "MathChain mainnet",
        network: "mathchain",
        prefix: 39,
        standardAccount: "*25519",
        symbols: [
            "MATH"
        ],
        website: "https://mathwallet.org"
    },
    {
        decimals: [
            18
        ],
        displayName: "MathChain testnet",
        network: "mathchain-testnet",
        prefix: 40,
        standardAccount: "*25519",
        symbols: [
            "MATH"
        ],
        website: "https://mathwallet.org"
    },
    {
        decimals: null,
        displayName: "Polimec Chain",
        network: "poli",
        prefix: 41,
        standardAccount: "*25519",
        symbols: null,
        website: "https://polimec.io/"
    },
    {
        decimals: null,
        displayName: "Substrate",
        network: "substrate",
        prefix: 42,
        standardAccount: "*25519",
        symbols: null,
        website: "https://substrate.io/"
    },
    {
        decimals: null,
        displayName: "Bare 32-bit ECDSA SECP-256k1 public key.",
        network: "BareSecp256k1",
        prefix: 43,
        standardAccount: "secp256k1",
        symbols: null,
        website: null
    },
    {
        decimals: [
            8
        ],
        displayName: "ChainX",
        network: "chainx",
        prefix: 44,
        standardAccount: "*25519",
        symbols: [
            "PCX"
        ],
        website: "https://chainx.org/"
    },
    {
        decimals: [
            12,
            12
        ],
        displayName: "UniArts Network",
        network: "uniarts",
        prefix: 45,
        standardAccount: "*25519",
        symbols: [
            "UART",
            "UINK"
        ],
        website: "https://uniarts.me"
    },
    {
        decimals: null,
        displayName: "This prefix is reserved.",
        network: "reserved46",
        prefix: 46,
        standardAccount: null,
        symbols: null,
        website: null
    },
    {
        decimals: null,
        displayName: "This prefix is reserved.",
        network: "reserved47",
        prefix: 47,
        standardAccount: null,
        symbols: null,
        website: null
    },
    {
        decimals: [
            12
        ],
        displayName: "Neatcoin Mainnet",
        network: "neatcoin",
        prefix: 48,
        standardAccount: "*25519",
        symbols: [
            "NEAT"
        ],
        website: "https://neatcoin.org"
    },
    {
        decimals: [
            12
        ],
        displayName: "Picasso",
        network: "picasso",
        prefix: 49,
        standardAccount: "*25519",
        symbols: [
            "PICA"
        ],
        website: "https://picasso.composable.finance"
    },
    {
        decimals: [
            12
        ],
        displayName: "Composable",
        network: "composable",
        prefix: 50,
        standardAccount: "*25519",
        symbols: [
            "LAYR"
        ],
        website: "https://composable.finance"
    },
    {
        decimals: [
            9
        ],
        displayName: "xx network",
        network: "xxnetwork",
        prefix: 55,
        standardAccount: "*25519",
        symbols: [
            "XX"
        ],
        website: "https://xx.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "HydraDX",
        network: "hydradx",
        prefix: 63,
        standardAccount: "*25519",
        symbols: [
            "HDX"
        ],
        website: "https://hydradx.io"
    },
    {
        decimals: [
            18
        ],
        displayName: "AvN Mainnet",
        network: "aventus",
        prefix: 65,
        standardAccount: "*25519",
        symbols: [
            "AVT"
        ],
        website: "https://aventus.io"
    },
    {
        decimals: [
            12
        ],
        displayName: "Crust Network",
        network: "crust",
        prefix: 66,
        standardAccount: "*25519",
        symbols: [
            "CRU"
        ],
        website: "https://crust.network"
    },
    {
        decimals: [
            9,
            9,
            9
        ],
        displayName: "Genshiro Network",
        network: "genshiro",
        prefix: 67,
        standardAccount: "*25519",
        symbols: [
            "GENS",
            "EQD",
            "LPT0"
        ],
        website: "https://genshiro.equilibrium.io"
    },
    {
        decimals: [
            9
        ],
        displayName: "Equilibrium Network",
        network: "equilibrium",
        prefix: 68,
        standardAccount: "*25519",
        symbols: [
            "EQ"
        ],
        website: "https://equilibrium.io"
    },
    {
        decimals: [
            18
        ],
        displayName: "SORA Network",
        network: "sora",
        prefix: 69,
        standardAccount: "*25519",
        symbols: [
            "XOR"
        ],
        website: "https://sora.org"
    },
    {
        decimals: [
            10
        ],
        displayName: "Zeitgeist",
        network: "zeitgeist",
        prefix: 73,
        standardAccount: "*25519",
        symbols: [
            "ZTG"
        ],
        website: "https://zeitgeist.pm"
    },
    {
        decimals: [
            18
        ],
        displayName: "Manta network",
        network: "manta",
        prefix: 77,
        standardAccount: "*25519",
        symbols: [
            "MANTA"
        ],
        website: "https://manta.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "Calamari: Manta Canary Network",
        network: "calamari",
        prefix: 78,
        standardAccount: "*25519",
        symbols: [
            "KMA"
        ],
        website: "https://manta.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "Polkadex Mainnet",
        network: "polkadex",
        prefix: 88,
        standardAccount: "*25519",
        symbols: [
            "PDEX"
        ],
        website: "https://polkadex.trade"
    },
    {
        decimals: [
            18
        ],
        displayName: "PolkaSmith Canary Network",
        network: "polkasmith",
        prefix: 98,
        standardAccount: "*25519",
        symbols: [
            "PKS"
        ],
        website: "https://polkafoundry.com"
    },
    {
        decimals: [
            18
        ],
        displayName: "PolkaFoundry Network",
        network: "polkafoundry",
        prefix: 99,
        standardAccount: "*25519",
        symbols: [
            "PKF"
        ],
        website: "https://polkafoundry.com"
    },
    {
        decimals: [
            18
        ],
        displayName: "OriginTrail Parachain",
        network: "origintrail-parachain",
        prefix: 101,
        standardAccount: "secp256k1",
        symbols: [
            "TRAC"
        ],
        website: "https://origintrail.io"
    },
    {
        decimals: [
            10
        ],
        displayName: "Pontem Network",
        network: "pontem-network",
        prefix: 105,
        standardAccount: "*25519",
        symbols: [
            "PONT"
        ],
        website: "https://pontem.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "Heiko",
        network: "heiko",
        prefix: 110,
        standardAccount: "*25519",
        symbols: [
            "HKO"
        ],
        website: "https://parallel.fi/"
    },
    {
        decimals: null,
        displayName: "Integritee Incognito",
        network: "integritee-incognito",
        prefix: 113,
        standardAccount: "*25519",
        symbols: null,
        website: "https://integritee.network"
    },
    {
        decimals: [
            18
        ],
        displayName: "Clover Finance",
        network: "clover",
        prefix: 128,
        standardAccount: "*25519",
        symbols: [
            "CLV"
        ],
        website: "https://clover.finance"
    },
    {
        decimals: [
            18
        ],
        displayName: "Altair",
        network: "altair",
        prefix: 136,
        standardAccount: "*25519",
        symbols: [
            "AIR"
        ],
        website: "https://centrifuge.io/"
    },
    {
        decimals: [
            12
        ],
        displayName: "Parallel",
        network: "parallel",
        prefix: 172,
        standardAccount: "*25519",
        symbols: [
            "PARA"
        ],
        website: "https://parallel.fi/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Social Network",
        network: "social-network",
        prefix: 252,
        standardAccount: "*25519",
        symbols: [
            "NET"
        ],
        website: "https://social.network"
    },
    {
        decimals: [
            15
        ],
        displayName: "QUARTZ by UNIQUE",
        network: "quartz_mainnet",
        prefix: 255,
        standardAccount: "*25519",
        symbols: [
            "QTZ"
        ],
        website: "https://unique.network"
    },
    {
        decimals: [
            18
        ],
        displayName: "Pioneer Network by Bit.Country",
        network: "pioneer_network",
        prefix: 268,
        standardAccount: "*25519",
        symbols: [
            "NEER"
        ],
        website: "https://bit.country"
    },
    {
        decimals: [
            18
        ],
        displayName: "Efinity",
        network: "efinity",
        prefix: 1110,
        standardAccount: "Sr25519",
        symbols: [
            "EFI"
        ],
        website: "https://efinity.io/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Moonbeam",
        network: "moonbeam",
        prefix: 1284,
        standardAccount: "secp256k1",
        symbols: [
            "GLMR"
        ],
        website: "https://moonbeam.network"
    },
    {
        decimals: [
            18
        ],
        displayName: "Moonriver",
        network: "moonriver",
        prefix: 1285,
        standardAccount: "secp256k1",
        symbols: [
            "MOVR"
        ],
        website: "https://moonbeam.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "Kapex",
        network: "kapex",
        prefix: 2007,
        standardAccount: "*25519",
        symbols: [
            "KAPEX"
        ],
        website: "https://totemaccounting.com"
    },
    {
        decimals: [
            10
        ],
        displayName: "Interlay",
        network: "interlay",
        prefix: 2032,
        standardAccount: "*25519",
        symbols: [
            "INTR"
        ],
        website: "https://interlay.io/"
    },
    {
        decimals: [
            12
        ],
        displayName: "Kintsugi",
        network: "kintsugi",
        prefix: 2092,
        standardAccount: "*25519",
        symbols: [
            "KINT"
        ],
        website: "https://interlay.io/"
    },
    {
        decimals: [
            18
        ],
        displayName: "Subspace testnet",
        network: "subspace_testnet",
        prefix: 2254,
        standardAccount: "*25519",
        symbols: [
            "tSSC"
        ],
        website: "https://subspace.network"
    },
    {
        decimals: [
            18
        ],
        displayName: "Subspace",
        network: "subspace",
        prefix: 6094,
        standardAccount: "*25519",
        symbols: [
            "SSC"
        ],
        website: "https://subspace.network"
    },
    {
        decimals: [
            12
        ],
        displayName: "Basilisk",
        network: "basilisk",
        prefix: 10041,
        standardAccount: "*25519",
        symbols: [
            "BSX"
        ],
        website: "https://bsx.fi"
    },
    {
        decimals: [
            12
        ],
        displayName: "CESS Testnet",
        network: "cess-testnet",
        prefix: 11330,
        standardAccount: "*25519",
        symbols: [
            "TCESS"
        ],
        website: "https://cess.cloud"
    },
    {
        decimals: [
            12
        ],
        displayName: "CESS",
        network: "cess",
        prefix: 11331,
        standardAccount: "*25519",
        symbols: [
            "CESS"
        ],
        website: "https://cess.cloud"
    },
    {
        decimals: [
            18
        ],
        displayName: "Automata ContextFree",
        network: "contextfree",
        prefix: 11820,
        standardAccount: "*25519",
        symbols: [
            "CTX"
        ],
        website: "https://ata.network"
    }
];


var $6aac272e5099df82$var$UNSORTED = [
    0,
    2,
    42
];
var $6aac272e5099df82$var$TESTNETS = [
    "testnet"
];
function $6aac272e5099df82$var$toExpanded(o) {
    var network = o.network || "";
    var nameParts = network.replace(/_/g, "-").split("-");
    var n = o; // ledger additions
    n.slip44 = (0, $d678781db17b8a25$export$4454dde8b324e76f)[network];
    n.hasLedgerSupport = !!n.slip44; // general items
    n.genesisHash = (0, $d678781db17b8a25$export$5a4d9c086e2d7883)[network] || [];
    n.icon = (0, $d678781db17b8a25$export$1b2dd6e34fcff367)[network] || "substrate"; // filtering
    n.isTestnet = !!(0, $d678781db17b8a25$export$6cc4c2f1b56ab49e)[network] || $6aac272e5099df82$var$TESTNETS.includes(nameParts[nameParts.length - 1]);
    n.isIgnored = n.isTestnet || !(o.standardAccount && o.decimals && o.symbols) && o.prefix !== 42;
    return n;
}
function $6aac272e5099df82$var$filterSelectable(param) {
    var genesisHash = param.genesisHash, prefix = param.prefix;
    return !!genesisHash.length || prefix === 42;
}
function $6aac272e5099df82$var$filterAvailable(n) {
    return !n.isIgnored && !!n.network;
}
function $6aac272e5099df82$var$sortNetworks(a, b) {
    var isUnSortedA = $6aac272e5099df82$var$UNSORTED.includes(a.prefix);
    var isUnSortedB = $6aac272e5099df82$var$UNSORTED.includes(b.prefix);
    return isUnSortedA === isUnSortedB ? 0 : isUnSortedA ? -1 : isUnSortedB ? 1 : a.displayName.localeCompare(b.displayName);
} // This is all the Substrate networks with our additional information
var $6aac272e5099df82$export$603455b6116637a6 = (0, $ca0ab2c1b47bd0ad$export$d503e845a12236aa).map($6aac272e5099df82$var$toExpanded); // The list of available/claimed prefixes
var $6aac272e5099df82$export$337a7c3584aeadf8 = $6aac272e5099df82$export$603455b6116637a6.filter($6aac272e5099df82$var$filterAvailable).sort($6aac272e5099df82$var$sortNetworks); // A filtered list of those chains we have details about (genesisHashes)
var $6aac272e5099df82$export$e19aa740f1b5be6c = $6aac272e5099df82$export$337a7c3584aeadf8.filter($6aac272e5099df82$var$filterSelectable);


function $f726d3f209a8bd5f$var$networkToPrefix(param) {
    var prefix = param.prefix;
    return prefix;
}
var $f726d3f209a8bd5f$export$ebe90cb607ad99e = {
    allowedDecodedLengths: [
        1,
        2,
        4,
        8,
        32,
        33
    ],
    // publicKey has prefix + 2 checksum bytes, short only prefix + 1 checksum byte
    allowedEncodedLengths: [
        3,
        4,
        6,
        10,
        35,
        36,
        37,
        38
    ],
    allowedPrefix: (0, $6aac272e5099df82$export$337a7c3584aeadf8).map($f726d3f209a8bd5f$var$networkToPrefix),
    prefix: 42
};


function $7659ffc2a5ce1e32$export$63e61a72b498228b(encoded, ignoreChecksum) {
    var ss58Format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    (0, $825198f93516e193$export$a7a9523472993e97)(encoded, "Invalid empty address passed");
    if ((0, $21ab7f4bfe532bde$export$f5328759db5e050d)(encoded) || (0, $bd546d5b5907df14$export$8a9b6341a7c96bc)(encoded)) return (0, $06f406c421475967$export$3d1a44fbed727ee2)(encoded);
    try {
        var decoded = (0, $649963e59efa3266$export$e42db48932fc32fe)(encoded);
        (0, $825198f93516e193$export$a7a9523472993e97)((0, $f726d3f209a8bd5f$export$ebe90cb607ad99e).allowedEncodedLengths.includes(decoded.length), "Invalid decoded address length");
        var _checkAddressChecksum = (0, $5OlIx._)((0, $07a335b1202d9e5c$export$3a8dea5969197010)(decoded), 4), isValid = _checkAddressChecksum[0], endPos = _checkAddressChecksum[1], ss58Length = _checkAddressChecksum[2], ss58Decoded = _checkAddressChecksum[3];
        (0, $825198f93516e193$export$a7a9523472993e97)(ignoreChecksum || isValid, "Invalid decoded address checksum");
        (0, $825198f93516e193$export$a7a9523472993e97)([
            -1,
            ss58Decoded
        ].includes(ss58Format), function() {
            return "Expected ss58Format ".concat(ss58Format, ", received ").concat(ss58Decoded);
        });
        return decoded.slice(ss58Length, endPos);
    } catch (error) {
        throw new Error("Decoding ".concat(encoded, ": ").concat(error.message));
    }
}




function $37db50d48c8e4e6d$export$b149ba8ff44e4e70(key) {
    var ss58Format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $f726d3f209a8bd5f$export$ebe90cb607ad99e).prefix;
    // decode it, this means we can re-encode an address
    var u8a = (0, $7659ffc2a5ce1e32$export$63e61a72b498228b)(key);
    (0, $825198f93516e193$export$a7a9523472993e97)(ss58Format >= 0 && ss58Format <= 16383 && ![
        46,
        47
    ].includes(ss58Format), "Out of range ss58Format specified");
    (0, $825198f93516e193$export$a7a9523472993e97)((0, $f726d3f209a8bd5f$export$ebe90cb607ad99e).allowedDecodedLengths.includes(u8a.length), function() {
        return "Expected a valid key to convert, with length ".concat((0, $f726d3f209a8bd5f$export$ebe90cb607ad99e).allowedDecodedLengths.join(", "));
    });
    var input = (0, $c4685798df67064d$export$7b640c40d4922c2e)(ss58Format < 64 ? [
        ss58Format
    ] : [
        (ss58Format & 252) >> 2 | 64,
        ss58Format >> 8 | (ss58Format & 3) << 6
    ], u8a);
    return (0, $649963e59efa3266$export$a025eb30fde2c140)((0, $c4685798df67064d$export$7b640c40d4922c2e)(input, (0, $a714e42ec419add2$export$532a1e05ac7e36e6)(input).subarray(0, [
        32,
        33
    ].includes(u8a.length) ? 2 : 1)));
}


var $e9a503bce58fac65$exports = {};
"use strict";
/** ******************************************************************************
 *  (c) 2018 - 2022 Zondax AG
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */ var $e9a503bce58fac65$var$__createBinding = $e9a503bce58fac65$exports && $e9a503bce58fac65$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9a503bce58fac65$var$__exportStar = $e9a503bce58fac65$exports && $e9a503bce58fac65$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e9a503bce58fac65$var$__createBinding(exports1, m, p);
};
$e9a503bce58fac65$exports.__esModule = true;

$e9a503bce58fac65$var$__exportStar((parcelRequire("e1Yck")), $e9a503bce58fac65$exports);


var $b6ea585a3a423ae0$exports = {};

var $ilnag = parcelRequire("ilnag");
var $b6ea585a3a423ae0$require$Buffer = $ilnag.Buffer;
"use strict";
var $528afaf5bd76a493$exports = {};
function $528afaf5bd76a493$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$528afaf5bd76a493$exports = $528afaf5bd76a493$var$_interopRequireDefault;
$528afaf5bd76a493$exports["default"] = $528afaf5bd76a493$exports, $528afaf5bd76a493$exports.__esModule = true;



var $b6ea585a3a423ae0$var$_regenerator = $528afaf5bd76a493$exports((parcelRequire("67h2x")));

var $b6ea585a3a423ae0$var$_toConsumableArray2 = $528afaf5bd76a493$exports((parcelRequire("4hJjN")));

var $b6ea585a3a423ae0$var$_asyncToGenerator2 = $528afaf5bd76a493$exports((parcelRequire("aasQN")));

var $b6ea585a3a423ae0$var$_classCallCheck2 = $528afaf5bd76a493$exports((parcelRequire("5DYAP")));

var $b6ea585a3a423ae0$var$_createClass2 = $528afaf5bd76a493$exports((parcelRequire("jEeEI")));
var $0a9217f4fc00e97f$exports = {};
"use strict";


var $0a9217f4fc00e97f$var$_regenerator = $528afaf5bd76a493$exports((parcelRequire("67h2x")));

var $0a9217f4fc00e97f$var$_asyncToGenerator2 = $528afaf5bd76a493$exports((parcelRequire("aasQN")));

var $0a9217f4fc00e97f$var$_typeof2 = $528afaf5bd76a493$exports((parcelRequire("bOCFh")));
var $0a9217f4fc00e97f$var$INS = {
    GET_VERSION: 0x00
};
var $0a9217f4fc00e97f$var$CHUNK_SIZE = 250;
var $0a9217f4fc00e97f$var$PAYLOAD_TYPE = {
    INIT: 0x00,
    ADD: 0x01,
    LAST: 0x02
};
var $0a9217f4fc00e97f$var$P1_VALUES = {
    ONLY_RETRIEVE: 0x00,
    SHOW_ADDRESS_IN_DEVICE: 0x01
};
var $0a9217f4fc00e97f$var$SCHEME = {
    ED25519: 0x00,
    SR25519: 0x01
};
var $0a9217f4fc00e97f$var$ERROR_CODE = {
    NoError: 0x9000
};
var $0a9217f4fc00e97f$var$ERROR_DESCRIPTION = {
    1: "U2F: Unknown",
    2: "U2F: Bad request",
    3: "U2F: Configuration unsupported",
    4: "U2F: Device Ineligible",
    5: "U2F: Timeout",
    14: "Timeout",
    0x9000: "No errors",
    0x9001: "Device is busy",
    0x6802: "Error deriving keys",
    0x6400: "Execution Error",
    0x6700: "Wrong Length",
    0x6982: "Empty Buffer",
    0x6983: "Output buffer too small",
    0x6984: "Data is invalid",
    0x6985: "Conditions not satisfied",
    0x6986: "Transaction rejected",
    0x6a80: "Bad key handle",
    0x6b00: "Invalid P1/P2",
    0x6d00: "Instruction not supported",
    0x6e00: "App does not seem to be open",
    0x6f00: "Unknown error",
    0x6f01: "Sign/verify error"
};
function $0a9217f4fc00e97f$var$errorCodeToString(statusCode) {
    if (statusCode in $0a9217f4fc00e97f$var$ERROR_DESCRIPTION) return $0a9217f4fc00e97f$var$ERROR_DESCRIPTION[statusCode];
    return "Unknown Status Code: ".concat(statusCode);
}
function $0a9217f4fc00e97f$var$isDict(v) {
    return (0, $0a9217f4fc00e97f$var$_typeof2.default)(v) === "object" && v !== null && !(v instanceof Array) && !(v instanceof Date);
}
function $0a9217f4fc00e97f$var$processErrorResponse(response) {
    if (response) {
        if ($0a9217f4fc00e97f$var$isDict(response)) {
            if (Object.prototype.hasOwnProperty.call(response, "statusCode")) return {
                return_code: response.statusCode,
                error_message: $0a9217f4fc00e97f$var$errorCodeToString(response.statusCode)
            };
            if (Object.prototype.hasOwnProperty.call(response, "return_code") && Object.prototype.hasOwnProperty.call(response, "error_message")) return response;
        }
        return {
            return_code: 0xffff,
            error_message: response.toString()
        };
    }
    return {
        return_code: 0xffff,
        error_message: response.toString()
    };
}
function $0a9217f4fc00e97f$var$getVersion(_x, _x2) {
    return $0a9217f4fc00e97f$var$_getVersion.apply(this, arguments);
}
function $0a9217f4fc00e97f$var$_getVersion() {
    $0a9217f4fc00e97f$var$_getVersion = (0, $0a9217f4fc00e97f$var$_asyncToGenerator2.default)(/*#__PURE__*/ $0a9217f4fc00e97f$var$_regenerator.default.mark(function _callee(transport, cla) {
        return $0a9217f4fc00e97f$var$_regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", transport.send(cla, $0a9217f4fc00e97f$var$INS.GET_VERSION, 0, 0).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1]; // 12 bytes + 2 error code
                        // 12 bytes + 2 error code
                        if (response.length !== 14) return {
                            return_code: 0x6984,
                            error_message: $0a9217f4fc00e97f$var$errorCodeToString(0x6984)
                        };
                        var major = response[1] * 256 + response[2];
                        var minor = response[3] * 256 + response[4];
                        var patch = response[5] * 256 + response[6];
                        var deviceLocked = response[7] === 1; // eslint-disable-next-line no-bitwise
                        // eslint-disable-next-line no-bitwise
                        var targetId = (response[8] << 24) + (response[9] << 16) + (response[10] << 8) + (response[11] << 0);
                        return {
                            return_code: returnCode,
                            error_message: $0a9217f4fc00e97f$var$errorCodeToString(returnCode),
                            // ///
                            test_mode: response[0] !== 0,
                            major: major,
                            minor: minor,
                            patch: patch,
                            deviceLocked: deviceLocked,
                            target_id: targetId.toString(16)
                        };
                    }, $0a9217f4fc00e97f$var$processErrorResponse));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $0a9217f4fc00e97f$var$_getVersion.apply(this, arguments);
}
$0a9217f4fc00e97f$exports = {
    CHUNK_SIZE: $0a9217f4fc00e97f$var$CHUNK_SIZE,
    INS: $0a9217f4fc00e97f$var$INS,
    PAYLOAD_TYPE: $0a9217f4fc00e97f$var$PAYLOAD_TYPE,
    P1_VALUES: $0a9217f4fc00e97f$var$P1_VALUES,
    SCHEME: $0a9217f4fc00e97f$var$SCHEME,
    ERROR_CODE: $0a9217f4fc00e97f$var$ERROR_CODE,
    getVersion: $0a9217f4fc00e97f$var$getVersion,
    processErrorResponse: $0a9217f4fc00e97f$var$processErrorResponse,
    errorCodeToString: $0a9217f4fc00e97f$var$errorCodeToString
};


var $21c99f07492dd553$exports = {};
"use strict";
var $21c99f07492dd553$var$CLA = {
    POLKADOT: 0x90,
    POLYMESH: 0x91,
    DOCK: 0x92,
    CENTRIFUGE: 0x93,
    EDGEWARE: 0x94,
    EQUILIBRIUM: 0x95,
    STATEMINT: 0x96,
    STATEMINE: 0x97,
    NODLE: 0x98,
    KUSAMA: 0x99,
    KARURA: 0x9a,
    ACALA: 0x9b,
    GENSHIRO: 0x9e,
    SORA: 0x9f,
    POLKADEX: 0xa0,
    BIFROST: 0xa1,
    REEF: 0xa2,
    ELIXXIR: 0xa3
}; // https://github.com/satoshilabs/slips/blob/master/slip-0044.md
var $21c99f07492dd553$var$SLIP0044 = {
    POLKADOT: 0x80000162,
    POLYMESH: 0x80000253,
    DOCK: 0x80000252,
    CENTRIFUGE: 0x800002eb,
    EDGEWARE: 0x8000020b,
    EQUILIBRIUM: 0x85f5e0fd,
    GENSHIRO: 0x85f5e0fc,
    STATEMINT: 0x80000162,
    STATEMINE: 0x800001b2,
    NODLE: 0x800003eb,
    KUSAMA: 0x800001b2,
    SORA: 0x80000269,
    POLKADEX: 0x8000031f,
    BIFROST: 0x80000314,
    KARURA: 0x800002ae,
    REEF: 0x80000333,
    ACALA: 0x80000313,
    ELIXXIR: 0x800007a3
};
var $21c99f07492dd553$var$SS58_ADDR_TYPE = {
    POLKADOT: 0,
    KUSAMA: 2,
    EDGEWARE: 7,
    POLYMESH: 12,
    DOCK: 22,
    //mainnet
    CENTRIFUGE: 36,
    EQUILIBRIUM: 67,
    GENSHIRO: 67,
    STATEMINT: 0,
    STATEMINE: 2,
    NODLE: 37,
    SORA: 69,
    POLKADEX: 88,
    BIFROST: 6,
    KARURA: 8,
    REEF: 42,
    ACALA: 10,
    ELIXXIR: 55
};
$21c99f07492dd553$exports = {
    CLA: $21c99f07492dd553$var$CLA,
    SLIP0044: $21c99f07492dd553$var$SLIP0044,
    SS58_ADDR_TYPE: $21c99f07492dd553$var$SS58_ADDR_TYPE
};


var $3e887e0d61d3bf2f$exports = {};

var $ilnag = parcelRequire("ilnag");
var $3e887e0d61d3bf2f$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($3e887e0d61d3bf2f$exports, "__esModule", {
    value: true
});

var $jMOyI = parcelRequire("jMOyI");

var $aO3KN = parcelRequire("aO3KN");

var $2gcE5 = parcelRequire("2gcE5");
var $c287f51987b9200d$exports = {};
"use strict";
Object.defineProperty($c287f51987b9200d$exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
var $c287f51987b9200d$var$wordlists = {};
$c287f51987b9200d$exports.wordlists = $c287f51987b9200d$var$wordlists;
var $c287f51987b9200d$var$_default;
$c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default;

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("6uziT"));
    $c287f51987b9200d$var$wordlists.czech = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("dUcoq"));
    $c287f51987b9200d$var$wordlists.chinese_simplified = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("iEGT8"));
    $c287f51987b9200d$var$wordlists.chinese_traditional = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("6Wih2"));
    $c287f51987b9200d$var$wordlists.korean = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("4t7kS"));
    $c287f51987b9200d$var$wordlists.french = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("kd8bJ"));
    $c287f51987b9200d$var$wordlists.italian = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("95oK7"));
    $c287f51987b9200d$var$wordlists.spanish = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("603gt"));
    $c287f51987b9200d$var$wordlists.japanese = $c287f51987b9200d$var$_default;
    $c287f51987b9200d$var$wordlists.JA = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("cjHVk"));
    $c287f51987b9200d$var$wordlists.portuguese = $c287f51987b9200d$var$_default;
} catch (err) {}

try {
    $c287f51987b9200d$exports._default = $c287f51987b9200d$var$_default = (parcelRequire("1CxPl"));
    $c287f51987b9200d$var$wordlists.english = $c287f51987b9200d$var$_default;
    $c287f51987b9200d$var$wordlists.EN = $c287f51987b9200d$var$_default;
} catch (err) {}


var $3e887e0d61d3bf2f$var$DEFAULT_WORDLIST = $c287f51987b9200d$exports._default;
var $3e887e0d61d3bf2f$var$INVALID_MNEMONIC = "Invalid mnemonic";
var $3e887e0d61d3bf2f$var$INVALID_ENTROPY = "Invalid entropy";
var $3e887e0d61d3bf2f$var$INVALID_CHECKSUM = "Invalid mnemonic checksum";
var $3e887e0d61d3bf2f$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $3e887e0d61d3bf2f$var$pbkdf2Promise(password, saltMixin, iterations, keylen, digest) {
    return Promise.resolve().then(function() {
        return new Promise(function(resolve, reject) {
            var callback = function(err, derivedKey) {
                if (err) return reject(err);
                else return resolve(derivedKey);
            };
            $aO3KN.pbkdf2(password, saltMixin, iterations, keylen, digest, callback);
        });
    });
}
function $3e887e0d61d3bf2f$var$normalize(str) {
    return (str || "").normalize("NFKD");
}
function $3e887e0d61d3bf2f$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $3e887e0d61d3bf2f$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $3e887e0d61d3bf2f$var$bytesToBinary(bytes) {
    return bytes.map(function(x) {
        return $3e887e0d61d3bf2f$var$lpad(x.toString(2), "0", 8);
    }).join("");
}
function $3e887e0d61d3bf2f$var$deriveChecksumBits(entropyBuffer) {
    var ENT = entropyBuffer.length * 8;
    var CS = ENT / 32;
    var hash = $jMOyI("sha256").update(entropyBuffer).digest();
    return $3e887e0d61d3bf2f$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $3e887e0d61d3bf2f$var$salt(password) {
    return "mnemonic" + (password || "");
}
function $3e887e0d61d3bf2f$var$mnemonicToSeedSync(mnemonic, password) {
    var mnemonicBuffer = $3e887e0d61d3bf2f$require$Buffer.from($3e887e0d61d3bf2f$var$normalize(mnemonic), "utf8");
    var saltBuffer = $3e887e0d61d3bf2f$require$Buffer.from($3e887e0d61d3bf2f$var$salt($3e887e0d61d3bf2f$var$normalize(password)), "utf8");
    return $aO3KN.pbkdf2Sync(mnemonicBuffer, saltBuffer, 2048, 64, "sha512");
}
$3e887e0d61d3bf2f$exports.mnemonicToSeedSync = $3e887e0d61d3bf2f$var$mnemonicToSeedSync;
function $3e887e0d61d3bf2f$var$mnemonicToSeed(mnemonic, password) {
    return Promise.resolve().then(function() {
        var mnemonicBuffer = $3e887e0d61d3bf2f$require$Buffer.from($3e887e0d61d3bf2f$var$normalize(mnemonic), "utf8");
        var saltBuffer = $3e887e0d61d3bf2f$require$Buffer.from($3e887e0d61d3bf2f$var$salt($3e887e0d61d3bf2f$var$normalize(password)), "utf8");
        return $3e887e0d61d3bf2f$var$pbkdf2Promise(mnemonicBuffer, saltBuffer, 2048, 64, "sha512");
    });
}
$3e887e0d61d3bf2f$exports.mnemonicToSeed = $3e887e0d61d3bf2f$var$mnemonicToSeed;
function $3e887e0d61d3bf2f$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $3e887e0d61d3bf2f$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3e887e0d61d3bf2f$var$WORDLIST_REQUIRED);
    var words = $3e887e0d61d3bf2f$var$normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error($3e887e0d61d3bf2f$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    var bits = words.map(function(word) {
        var index = wordlist.indexOf(word);
        if (index === -1) throw new Error($3e887e0d61d3bf2f$var$INVALID_MNEMONIC);
        return $3e887e0d61d3bf2f$var$lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    var dividerIndex = Math.floor(bits.length / 33) * 32;
    var entropyBits = bits.slice(0, dividerIndex);
    var checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    var entropyBytes = entropyBits.match(/(.{1,8})/g).map($3e887e0d61d3bf2f$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    var entropy = $3e887e0d61d3bf2f$require$Buffer.from(entropyBytes);
    var newChecksum = $3e887e0d61d3bf2f$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($3e887e0d61d3bf2f$var$INVALID_CHECKSUM);
    return entropy.toString("hex");
}
$3e887e0d61d3bf2f$exports.mnemonicToEntropy = $3e887e0d61d3bf2f$var$mnemonicToEntropy;
function $3e887e0d61d3bf2f$var$entropyToMnemonic(entropy, wordlist) {
    if (!$3e887e0d61d3bf2f$require$Buffer.isBuffer(entropy)) entropy = $3e887e0d61d3bf2f$require$Buffer.from(entropy, "hex");
    wordlist = wordlist || $3e887e0d61d3bf2f$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3e887e0d61d3bf2f$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    var entropyBits = $3e887e0d61d3bf2f$var$bytesToBinary(Array.from(entropy));
    var checksumBits = $3e887e0d61d3bf2f$var$deriveChecksumBits(entropy);
    var bits = entropyBits + checksumBits;
    var chunks = bits.match(/(.{1,11})/g);
    var words = chunks.map(function(binary) {
        var index = $3e887e0d61d3bf2f$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" // Japanese wordlist
     ? words.join("\u3000") : words.join(" ");
}
$3e887e0d61d3bf2f$exports.entropyToMnemonic = $3e887e0d61d3bf2f$var$entropyToMnemonic;
function $3e887e0d61d3bf2f$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($3e887e0d61d3bf2f$var$INVALID_ENTROPY);
    rng = rng || $2gcE5;
    return $3e887e0d61d3bf2f$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
$3e887e0d61d3bf2f$exports.generateMnemonic = $3e887e0d61d3bf2f$var$generateMnemonic;
function $3e887e0d61d3bf2f$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $3e887e0d61d3bf2f$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
$3e887e0d61d3bf2f$exports.validateMnemonic = $3e887e0d61d3bf2f$var$validateMnemonic;
function $3e887e0d61d3bf2f$var$setDefaultWordlist(language) {
    var result = $c287f51987b9200d$exports.wordlists[language];
    if (result) $3e887e0d61d3bf2f$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
$3e887e0d61d3bf2f$exports.setDefaultWordlist = $3e887e0d61d3bf2f$var$setDefaultWordlist;
function $3e887e0d61d3bf2f$var$getDefaultWordlist() {
    if (!$3e887e0d61d3bf2f$var$DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys($c287f51987b9200d$exports.wordlists).filter(function(lang) {
        if (lang === "JA" || lang === "EN") return false;
        return $c287f51987b9200d$exports.wordlists[lang].every(function(word, index) {
            return word === $3e887e0d61d3bf2f$var$DEFAULT_WORDLIST[index];
        });
    })[0];
}
$3e887e0d61d3bf2f$exports.getDefaultWordlist = $3e887e0d61d3bf2f$var$getDefaultWordlist;

$3e887e0d61d3bf2f$exports.wordlists = $c287f51987b9200d$exports.wordlists;



var $kZo2m = parcelRequire("kZo2m");
var $c2c95997c89a1556$exports = {};

var $ilnag = parcelRequire("ilnag");
var $c2c95997c89a1556$require$Buffer = $ilnag.Buffer;

var $dItct = parcelRequire("dItct");

var $kZo2m = parcelRequire("kZo2m");

var $aW3Sp = parcelRequire("aW3Sp");
var $c2c95997c89a1556$var$utils = $aW3Sp.utils;
var $91d3c4b1edf9bc1b$exports = {};
"use strict";

var $kZo2m = parcelRequire("kZo2m");

var $aW3Sp = parcelRequire("aW3Sp");
var $91d3c4b1edf9bc1b$var$utils = $aW3Sp.utils;
var $91d3c4b1edf9bc1b$var$assert = $91d3c4b1edf9bc1b$var$utils.assert;
var $91d3c4b1edf9bc1b$var$parseBytes = $91d3c4b1edf9bc1b$var$utils.parseBytes;
var $96187e05a84273f9$exports = {};
"use strict";

var $aW3Sp = parcelRequire("aW3Sp");
var $96187e05a84273f9$var$utils = $aW3Sp.utils;
var $96187e05a84273f9$var$assert = $96187e05a84273f9$var$utils.assert;
var $96187e05a84273f9$var$parseBytes = $96187e05a84273f9$var$utils.parseBytes;
var $96187e05a84273f9$var$cachedProperty = $96187e05a84273f9$var$utils.cachedProperty;
/**
 * @param {EDDSA} eddsa - instance
 * @param {Object} params - public/private key parameters
 *
 * @param {Array<Byte>} [params.secret] - secret seed bytes
 * @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
 * @param {Array<Byte>} [params.pub] - public key point encoded as bytes
 *
 */ function $96187e05a84273f9$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $96187e05a84273f9$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $96187e05a84273f9$var$parseBytes(params.pub);
}
$96187e05a84273f9$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $96187e05a84273f9$var$KeyPair) return pub;
    return new $96187e05a84273f9$var$KeyPair(eddsa, {
        pub: pub
    });
};
$96187e05a84273f9$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $96187e05a84273f9$var$KeyPair) return secret;
    return new $96187e05a84273f9$var$KeyPair(eddsa, {
        secret: secret
    });
};
$96187e05a84273f9$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$96187e05a84273f9$var$cachedProperty($96187e05a84273f9$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$96187e05a84273f9$var$cachedProperty($96187e05a84273f9$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$96187e05a84273f9$var$cachedProperty($96187e05a84273f9$var$KeyPair, "privBytes", function privBytes() {
    return this.secret();
});
$96187e05a84273f9$var$cachedProperty($96187e05a84273f9$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$96187e05a84273f9$var$cachedProperty($96187e05a84273f9$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$96187e05a84273f9$var$cachedProperty($96187e05a84273f9$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$96187e05a84273f9$var$KeyPair.prototype.sign = function sign(message) {
    $96187e05a84273f9$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$96187e05a84273f9$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$96187e05a84273f9$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $96187e05a84273f9$var$assert(this._secret, "KeyPair is public only");
    return $96187e05a84273f9$var$utils.encode(this.secret(), enc);
};
$96187e05a84273f9$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $96187e05a84273f9$var$utils.encode(this.pubBytes(), enc);
};
$96187e05a84273f9$exports = $96187e05a84273f9$var$KeyPair;



var $7ZIwX = parcelRequire("7ZIwX");
function $91d3c4b1edf9bc1b$var$EDDSA(curve) {
    $91d3c4b1edf9bc1b$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $91d3c4b1edf9bc1b$var$EDDSA)) return new $91d3c4b1edf9bc1b$var$EDDSA(curve);
    var curve = $aW3Sp.curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kZo2m.sha512;
}
$91d3c4b1edf9bc1b$exports = $91d3c4b1edf9bc1b$var$EDDSA;
/**
 * @param {Array|String} message - message bytes
 * @param {Array|String|KeyPair} secret - secret bytes or a keypair
 * @returns {Signature} - signature
 */ $91d3c4b1edf9bc1b$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $91d3c4b1edf9bc1b$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
 * @param {Array} message - message bytes
 * @param {Array|String|Signature} sig - sig bytes
 * @param {Array|String|Point|KeyPair} pub - public key
 * @returns {Boolean} - true if public key matches sig of message
 */ $91d3c4b1edf9bc1b$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $91d3c4b1edf9bc1b$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $91d3c4b1edf9bc1b$var$utils.intFromLE(hash.digest()).umod(this.curve.n);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $96187e05a84273f9$exports.fromPublic(this, pub);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $96187e05a84273f9$exports.fromSecret(this, secret);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7ZIwX) return sig;
    return new $7ZIwX(this, sig);
};
/**
 * * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
 *
 * EDDSA defines methods for encoding and decoding points and integers. These are
 * helper convenience methods, that pass along to utility functions implied
 * parameters.
 *
 */ $91d3c4b1edf9bc1b$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $91d3c4b1edf9bc1b$var$utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $91d3c4b1edf9bc1b$var$utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $91d3c4b1edf9bc1b$var$utils.intFromLE(bytes);
};
$91d3c4b1edf9bc1b$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};


var $c2c95997c89a1556$var$eddsa = new $91d3c4b1edf9bc1b$exports("ed25519");
function $c2c95997c89a1556$var$sha512(data) {
    var digest = $kZo2m.sha512().update(data).digest();
    return $c2c95997c89a1556$require$Buffer.from(digest);
}
function $c2c95997c89a1556$var$hmac512(key, data) {
    var digest = $kZo2m.hmac($kZo2m.sha512, key).update(data).digest();
    return $c2c95997c89a1556$require$Buffer.from(digest);
}
function $c2c95997c89a1556$var$makeEd25519Extended(secret) {
    var extended = $c2c95997c89a1556$var$sha512(secret);
    extended[0] &= 248;
    extended[31] &= 63;
    extended[31] |= 64;
    return extended;
}
function $c2c95997c89a1556$var$generateFromSeed(seed) {
    var iter = 1;
    while(true){
        var s = "Root Seed Chain " + iter;
        var block = $c2c95997c89a1556$var$hmac512(seed, s);
        var extended = $c2c95997c89a1556$var$makeEd25519Extended(block.slice(0, 32));
        if ((extended[31] & 0x20) === 0) return $c2c95997c89a1556$require$Buffer.concat([
            extended,
            block.slice(32, 64)
        ]);
        iter++;
    }
}
function $c2c95997c89a1556$var$fromSeed2(seed) {
    var s = "ed25519 cardano seed";
    var block = $c2c95997c89a1556$var$hmac512(s, seed);
    var extended = $c2c95997c89a1556$var$sha512(block.slice(0, 32));
    extended[0] &= 248;
    extended[31] &= 0x1f;
    extended[31] |= 64;
    return $c2c95997c89a1556$require$Buffer.concat([
        extended,
        block.slice(32, 64)
    ]);
}
function $c2c95997c89a1556$var$derivePrivate(xprv, index) {
    var kl = xprv.slice(0, 32);
    var kr = xprv.slice(32, 64);
    var cc = xprv.slice(64, 96);
    var data;
    var z, i;
    if (index < 0x80000000) {
        data = $c2c95997c89a1556$require$Buffer.allocUnsafe(37);
        data.writeUInt32LE(index, 33);
        var pk = $c2c95997c89a1556$var$toPublic(kl);
        pk.copy(data, 1);
        data[0] = 0x02;
        z = $c2c95997c89a1556$var$hmac512(cc, data);
        data[0] = 0x03;
        i = $c2c95997c89a1556$var$hmac512(cc, data);
    } else {
        data = $c2c95997c89a1556$require$Buffer.allocUnsafe(69);
        data.writeUInt32LE(index, 65);
        kl.copy(data, 1);
        kr.copy(data, 33);
        data[0] = 0x00;
        z = $c2c95997c89a1556$var$hmac512(cc, data);
        data[0] = 0x01;
        i = $c2c95997c89a1556$var$hmac512(cc, data);
    }
    var chainCode = i.slice(32, 64);
    var zl = z.slice(0, 32);
    var zr = z.slice(32, 64);
    // left = kl + 8 * trunc28(zl)
    // right = zr + kr
    var left = new $dItct(kl, 16, "le").add(new $dItct(zl.slice(0, 28), 16, "le").mul(new $dItct(8))).toArrayLike($c2c95997c89a1556$require$Buffer, "le", 32);
    var right = new $dItct(kr, 16, "le").add(new $dItct(zr, 16, "le")).toArrayLike($c2c95997c89a1556$require$Buffer, "le").slice(0, 32);
    // just padding
    if (right.length !== 32) right = $c2c95997c89a1556$require$Buffer.from(right.toString("hex") + "00", "hex");
    return $c2c95997c89a1556$require$Buffer.concat([
        left,
        right,
        chainCode
    ]);
}
function $c2c95997c89a1556$var$derivePublic(xpub, index) {
    var pk = xpub.slice(0, 32);
    var cc = xpub.slice(32, 64);
    var data = $c2c95997c89a1556$require$Buffer.allocUnsafe(37);
    data.writeUInt32LE(index, 33);
    var z, i;
    if (index < 0x80000000) {
        pk.copy(data, 1);
        data[0] = 0x02;
        z = $c2c95997c89a1556$var$hmac512(cc, data);
        data[0] = 0x03;
        i = $c2c95997c89a1556$var$hmac512(cc, data);
    } else throw new Error("can not derive public key with harden");
    var chainCode = i.slice(32, 64);
    var zl = z.slice(0, 32);
    // left = 8 * trunc28(zl)
    var left = new $dItct(zl.slice(0, 28), 16, "le").mul(new $dItct(8));
    var p = $c2c95997c89a1556$var$eddsa.g.mul(left);
    var pp = $c2c95997c89a1556$var$eddsa.decodePoint(pk.toString("hex"));
    var point = pp.add(p);
    return $c2c95997c89a1556$require$Buffer.concat([
        $c2c95997c89a1556$require$Buffer.from($c2c95997c89a1556$var$eddsa.encodePoint(point)),
        chainCode
    ]);
}
function $c2c95997c89a1556$var$toPublic(xprv) {
    if (xprv.length !== 32 && xprv.length !== 96) throw new Error("invalid xprv");
    var key = $c2c95997c89a1556$var$eddsa.keyFromSecret(xprv.slice(0, 32).toString("hex"));
    var pk = $c2c95997c89a1556$require$Buffer.from(key.pubBytes());
    if (xprv.length > 64) return $c2c95997c89a1556$require$Buffer.concat([
        pk,
        xprv.slice(64, 96)
    ]);
    return pk;
}
function $c2c95997c89a1556$var$sign(message, xprv) {
    if (typeof xprv !== "string") xprv = xprv.toString("hex");
    var keyPair = $c2c95997c89a1556$var$eddsa.keyFromSecret($c2c95997c89a1556$var$utils.parseBytes(xprv).slice(0, 32));
    var sig = keyPair.sign(message);
    return $c2c95997c89a1556$require$Buffer.from(sig.toBytes());
}
function $c2c95997c89a1556$var$verify(message, sig, xpub) {
    if (typeof xpub !== "string") xpub = xpub.toString("hex");
    return $c2c95997c89a1556$var$eddsa.verify(message, sig.toString("hex"), $c2c95997c89a1556$var$utils.parseBytes(xpub).slice(0, 32));
}
$c2c95997c89a1556$exports = {
    fromSeed2: $c2c95997c89a1556$var$fromSeed2,
    fromSeed: $c2c95997c89a1556$var$generateFromSeed,
    generateFromSeed: $c2c95997c89a1556$var$generateFromSeed,
    derivePrivate: $c2c95997c89a1556$var$derivePrivate,
    derivePublic: $c2c95997c89a1556$var$derivePublic,
    toPublic: $c2c95997c89a1556$var$toPublic,
    eddsa: $c2c95997c89a1556$var$eddsa,
    sign: $c2c95997c89a1556$var$sign,
    verify: $c2c95997c89a1556$var$verify
};



var $gYRJ8 = parcelRequire("gYRJ8");
var $a26f0a0d5ac54941$exports = {};
var $bc898815a381c20d$exports = {};
// Blake2B in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch
var $e9119709d3488a62$exports = {};

var $ilnag = parcelRequire("ilnag");
var $e9119709d3488a62$require$Buffer = $ilnag.Buffer;
var $e9119709d3488a62$var$ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
// For convenience, let people hash a string, not just a Uint8Array
function $e9119709d3488a62$var$normalizeInput(input) {
    var ret;
    if (input instanceof Uint8Array) ret = input;
    else if (input instanceof $e9119709d3488a62$require$Buffer) ret = new Uint8Array(input);
    else if (typeof input === "string") ret = new Uint8Array($e9119709d3488a62$require$Buffer.from(input, "utf8"));
    else throw new Error($e9119709d3488a62$var$ERROR_MSG_INPUT);
    return ret;
}
// Converts a Uint8Array to a hexadecimal string
// For example, toHex([255, 0, 255]) returns "ff00ff"
function $e9119709d3488a62$var$toHex(bytes) {
    return Array.prototype.map.call(bytes, function(n) {
        return (n < 16 ? "0" : "") + n.toString(16);
    }).join("");
}
// Converts any value in [0...2^32-1] to an 8-character hex string
function $e9119709d3488a62$var$uint32ToHex(val) {
    return (0x100000000 + val).toString(16).substring(1);
}
// For debugging: prints out hash state in the same format as the RFC
// sample computation exactly, so that you can diff
function $e9119709d3488a62$var$debugPrint(label, arr, size) {
    var msg = "\n" + label + " = ";
    for(var i = 0; i < arr.length; i += 2){
        if (size === 32) {
            msg += $e9119709d3488a62$var$uint32ToHex(arr[i]).toUpperCase();
            msg += " ";
            msg += $e9119709d3488a62$var$uint32ToHex(arr[i + 1]).toUpperCase();
        } else if (size === 64) {
            msg += $e9119709d3488a62$var$uint32ToHex(arr[i + 1]).toUpperCase();
            msg += $e9119709d3488a62$var$uint32ToHex(arr[i]).toUpperCase();
        } else throw new Error("Invalid size " + size);
        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
        else if (i < arr.length - 2) msg += " ";
    }
    console.log(msg);
}
// For performance testing: generates N bytes of input, hashes M times
// Measures and prints MB/second hash performance each time
function $e9119709d3488a62$var$testSpeed(hashFn, N, M) {
    var startMs = new Date().getTime();
    var input = new Uint8Array(N);
    for(var i = 0; i < N; i++)input[i] = i % 256;
    var genMs = new Date().getTime();
    console.log("Generated random input in " + (genMs - startMs) + "ms");
    startMs = genMs;
    for(var i1 = 0; i1 < M; i1++){
        var hashHex = hashFn(input);
        var hashMs = new Date().getTime();
        var ms = hashMs - startMs;
        startMs = hashMs;
        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
    }
}
$e9119709d3488a62$exports = {
    normalizeInput: $e9119709d3488a62$var$normalizeInput,
    toHex: $e9119709d3488a62$var$toHex,
    debugPrint: $e9119709d3488a62$var$debugPrint,
    testSpeed: $e9119709d3488a62$var$testSpeed
};


// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function $bc898815a381c20d$var$ADD64AA(v, a, b) {
    var o0 = v[a] + v[b];
    var o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function $bc898815a381c20d$var$ADD64AC(v, a, b0, b1) {
    var o0 = v[a] + b0;
    if (b0 < 0) o0 += 0x100000000;
    var o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function $bc898815a381c20d$var$B2B_GET32(arr, i) {
    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}
// G Mixing function
// The ROTRs are inlined for speed
function $bc898815a381c20d$var$B2B_G(a, b, c, d, ix, iy) {
    var x0 = $bc898815a381c20d$var$m[ix];
    var x1 = $bc898815a381c20d$var$m[ix + 1];
    var y0 = $bc898815a381c20d$var$m[iy];
    var y1 = $bc898815a381c20d$var$m[iy + 1];
    $bc898815a381c20d$var$ADD64AA($bc898815a381c20d$var$v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ;
    $bc898815a381c20d$var$ADD64AC($bc898815a381c20d$var$v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    ;
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    var xor0 = $bc898815a381c20d$var$v[d] ^ $bc898815a381c20d$var$v[a];
    var xor1 = $bc898815a381c20d$var$v[d + 1] ^ $bc898815a381c20d$var$v[a + 1];
    $bc898815a381c20d$var$v[d] = xor1;
    $bc898815a381c20d$var$v[d + 1] = xor0;
    $bc898815a381c20d$var$ADD64AA($bc898815a381c20d$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = $bc898815a381c20d$var$v[b] ^ $bc898815a381c20d$var$v[c];
    xor1 = $bc898815a381c20d$var$v[b + 1] ^ $bc898815a381c20d$var$v[c + 1];
    $bc898815a381c20d$var$v[b] = xor0 >>> 24 ^ xor1 << 8;
    $bc898815a381c20d$var$v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
    $bc898815a381c20d$var$ADD64AA($bc898815a381c20d$var$v, a, b);
    $bc898815a381c20d$var$ADD64AC($bc898815a381c20d$var$v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = $bc898815a381c20d$var$v[d] ^ $bc898815a381c20d$var$v[a];
    xor1 = $bc898815a381c20d$var$v[d + 1] ^ $bc898815a381c20d$var$v[a + 1];
    $bc898815a381c20d$var$v[d] = xor0 >>> 16 ^ xor1 << 16;
    $bc898815a381c20d$var$v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
    $bc898815a381c20d$var$ADD64AA($bc898815a381c20d$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = $bc898815a381c20d$var$v[b] ^ $bc898815a381c20d$var$v[c];
    xor1 = $bc898815a381c20d$var$v[b + 1] ^ $bc898815a381c20d$var$v[c + 1];
    $bc898815a381c20d$var$v[b] = xor1 >>> 31 ^ xor0 << 1;
    $bc898815a381c20d$var$v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}
// Initialization Vector
var $bc898815a381c20d$var$BLAKE2B_IV32 = new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
var $bc898815a381c20d$var$SIGMA8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var $bc898815a381c20d$var$SIGMA82 = new Uint8Array($bc898815a381c20d$var$SIGMA8.map(function(x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var $bc898815a381c20d$var$v = new Uint32Array(32);
var $bc898815a381c20d$var$m = new Uint32Array(32);
function $bc898815a381c20d$var$blake2bCompress(ctx, last) {
    var i = 0;
    // init work variables
    for(i = 0; i < 16; i++){
        $bc898815a381c20d$var$v[i] = ctx.h[i];
        $bc898815a381c20d$var$v[i + 16] = $bc898815a381c20d$var$BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    $bc898815a381c20d$var$v[24] = $bc898815a381c20d$var$v[24] ^ ctx.t;
    $bc898815a381c20d$var$v[25] = $bc898815a381c20d$var$v[25] ^ ctx.t / 0x100000000;
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        $bc898815a381c20d$var$v[28] = ~$bc898815a381c20d$var$v[28];
        $bc898815a381c20d$var$v[29] = ~$bc898815a381c20d$var$v[29];
    }
    // get little-endian words
    for(i = 0; i < 32; i++)$bc898815a381c20d$var$m[i] = $bc898815a381c20d$var$B2B_GET32(ctx.b, 4 * i);
    // twelve rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 64)
    for(i = 0; i < 12; i++){
        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
        $bc898815a381c20d$var$B2B_G(0, 8, 16, 24, $bc898815a381c20d$var$SIGMA82[i * 16 + 0], $bc898815a381c20d$var$SIGMA82[i * 16 + 1]);
        $bc898815a381c20d$var$B2B_G(2, 10, 18, 26, $bc898815a381c20d$var$SIGMA82[i * 16 + 2], $bc898815a381c20d$var$SIGMA82[i * 16 + 3]);
        $bc898815a381c20d$var$B2B_G(4, 12, 20, 28, $bc898815a381c20d$var$SIGMA82[i * 16 + 4], $bc898815a381c20d$var$SIGMA82[i * 16 + 5]);
        $bc898815a381c20d$var$B2B_G(6, 14, 22, 30, $bc898815a381c20d$var$SIGMA82[i * 16 + 6], $bc898815a381c20d$var$SIGMA82[i * 16 + 7]);
        $bc898815a381c20d$var$B2B_G(0, 10, 20, 30, $bc898815a381c20d$var$SIGMA82[i * 16 + 8], $bc898815a381c20d$var$SIGMA82[i * 16 + 9]);
        $bc898815a381c20d$var$B2B_G(2, 12, 22, 24, $bc898815a381c20d$var$SIGMA82[i * 16 + 10], $bc898815a381c20d$var$SIGMA82[i * 16 + 11]);
        $bc898815a381c20d$var$B2B_G(4, 14, 16, 26, $bc898815a381c20d$var$SIGMA82[i * 16 + 12], $bc898815a381c20d$var$SIGMA82[i * 16 + 13]);
        $bc898815a381c20d$var$B2B_G(6, 8, 18, 28, $bc898815a381c20d$var$SIGMA82[i * 16 + 14], $bc898815a381c20d$var$SIGMA82[i * 16 + 15]);
    }
    // util.debugPrint('   (i=12) v[16]', v, 64)
    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ $bc898815a381c20d$var$v[i] ^ $bc898815a381c20d$var$v[i + 16];
// util.debugPrint('h[8]', ctx.h, 64)
}
// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
function $bc898815a381c20d$var$blake2bInit(outlen, key) {
    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
    // state, 'param block'
    var ctx = {
        b: new Uint8Array(128),
        h: new Uint32Array(16),
        t: 0,
        c: 0,
        outlen: outlen // output length in bytes
    };
    // initialize hash state
    for(var i = 0; i < 16; i++)ctx.h[i] = $bc898815a381c20d$var$BLAKE2B_IV32[i];
    var keylen = key ? key.length : 0;
    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
    // key the hash, if applicable
    if (key) {
        $bc898815a381c20d$var$blake2bUpdate(ctx, key);
        // at the end
        ctx.c = 128;
    }
    return ctx;
}
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function $bc898815a381c20d$var$blake2bUpdate(ctx, input) {
    for(var i = 0; i < input.length; i++){
        if (ctx.c === 128) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            $bc898815a381c20d$var$blake2bCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function $bc898815a381c20d$var$blake2bFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 128)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    $bc898815a381c20d$var$blake2bCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    var out = new Uint8Array(ctx.outlen);
    for(var i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
    return out;
}
// Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
function $bc898815a381c20d$var$blake2b(input, key, outlen) {
    // preprocess inputs
    outlen = outlen || 64;
    input = $e9119709d3488a62$exports.normalizeInput(input);
    // do the math
    var ctx = $bc898815a381c20d$var$blake2bInit(outlen, key);
    $bc898815a381c20d$var$blake2bUpdate(ctx, input);
    return $bc898815a381c20d$var$blake2bFinal(ctx);
}
// Computes the BLAKE2B hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
function $bc898815a381c20d$var$blake2bHex(input, key, outlen) {
    var output = $bc898815a381c20d$var$blake2b(input, key, outlen);
    return $e9119709d3488a62$exports.toHex(output);
}
$bc898815a381c20d$exports = {
    blake2b: $bc898815a381c20d$var$blake2b,
    blake2bHex: $bc898815a381c20d$var$blake2bHex,
    blake2bInit: $bc898815a381c20d$var$blake2bInit,
    blake2bUpdate: $bc898815a381c20d$var$blake2bUpdate,
    blake2bFinal: $bc898815a381c20d$var$blake2bFinal
};


var $19f1576d8eccccdc$exports = {};
// BLAKE2s hash function in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch

// Little-endian byte access.
// Expects a Uint8Array and an index
// Returns the little-endian uint32 at v[i..i+3]
function $19f1576d8eccccdc$var$B2S_GET32(v, i) {
    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
}
// Mixing function G.
function $19f1576d8eccccdc$var$B2S_G(a, b, c, d, x, y) {
    $19f1576d8eccccdc$var$v[a] = $19f1576d8eccccdc$var$v[a] + $19f1576d8eccccdc$var$v[b] + x;
    $19f1576d8eccccdc$var$v[d] = $19f1576d8eccccdc$var$ROTR32($19f1576d8eccccdc$var$v[d] ^ $19f1576d8eccccdc$var$v[a], 16);
    $19f1576d8eccccdc$var$v[c] = $19f1576d8eccccdc$var$v[c] + $19f1576d8eccccdc$var$v[d];
    $19f1576d8eccccdc$var$v[b] = $19f1576d8eccccdc$var$ROTR32($19f1576d8eccccdc$var$v[b] ^ $19f1576d8eccccdc$var$v[c], 12);
    $19f1576d8eccccdc$var$v[a] = $19f1576d8eccccdc$var$v[a] + $19f1576d8eccccdc$var$v[b] + y;
    $19f1576d8eccccdc$var$v[d] = $19f1576d8eccccdc$var$ROTR32($19f1576d8eccccdc$var$v[d] ^ $19f1576d8eccccdc$var$v[a], 8);
    $19f1576d8eccccdc$var$v[c] = $19f1576d8eccccdc$var$v[c] + $19f1576d8eccccdc$var$v[d];
    $19f1576d8eccccdc$var$v[b] = $19f1576d8eccccdc$var$ROTR32($19f1576d8eccccdc$var$v[b] ^ $19f1576d8eccccdc$var$v[c], 7);
}
// 32-bit right rotation
// x should be a uint32
// y must be between 1 and 31, inclusive
function $19f1576d8eccccdc$var$ROTR32(x, y) {
    return x >>> y ^ x << 32 - y;
}
// Initialization Vector.
var $19f1576d8eccccdc$var$BLAKE2S_IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
var $19f1576d8eccccdc$var$SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0
]);
// Compression function. "last" flag indicates last block
var $19f1576d8eccccdc$var$v = new Uint32Array(16);
var $19f1576d8eccccdc$var$m = new Uint32Array(16);
function $19f1576d8eccccdc$var$blake2sCompress(ctx, last) {
    var i = 0;
    for(i = 0; i < 8; i++){
        // init work variables
        $19f1576d8eccccdc$var$v[i] = ctx.h[i];
        $19f1576d8eccccdc$var$v[i + 8] = $19f1576d8eccccdc$var$BLAKE2S_IV[i];
    }
    $19f1576d8eccccdc$var$v[12] ^= ctx.t // low 32 bits of offset
    ;
    $19f1576d8eccccdc$var$v[13] ^= ctx.t / 0x100000000 // high 32 bits
    ;
    if (last) // last block flag set ?
    $19f1576d8eccccdc$var$v[14] = ~$19f1576d8eccccdc$var$v[14];
    for(i = 0; i < 16; i++)// get little-endian words
    $19f1576d8eccccdc$var$m[i] = $19f1576d8eccccdc$var$B2S_GET32(ctx.b, 4 * i);
    // ten rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 32)
    for(i = 0; i < 10; i++){
        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
        $19f1576d8eccccdc$var$B2S_G(0, 4, 8, 12, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 0]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 1]]);
        $19f1576d8eccccdc$var$B2S_G(1, 5, 9, 13, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 2]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 3]]);
        $19f1576d8eccccdc$var$B2S_G(2, 6, 10, 14, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 4]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 5]]);
        $19f1576d8eccccdc$var$B2S_G(3, 7, 11, 15, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 6]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 7]]);
        $19f1576d8eccccdc$var$B2S_G(0, 5, 10, 15, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 8]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 9]]);
        $19f1576d8eccccdc$var$B2S_G(1, 6, 11, 12, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 10]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 11]]);
        $19f1576d8eccccdc$var$B2S_G(2, 7, 8, 13, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 12]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 13]]);
        $19f1576d8eccccdc$var$B2S_G(3, 4, 9, 14, $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 14]], $19f1576d8eccccdc$var$m[$19f1576d8eccccdc$var$SIGMA[i * 16 + 15]]);
    }
    // util.debugPrint('   (i=10) v[16]', v, 32)
    for(i = 0; i < 8; i++)ctx.h[i] ^= $19f1576d8eccccdc$var$v[i] ^ $19f1576d8eccccdc$var$v[i + 8];
// util.debugPrint('h[8]', ctx.h, 32)
}
// Creates a BLAKE2s hashing context
// Requires an output length between 1 and 32 bytes
// Takes an optional Uint8Array key
function $19f1576d8eccccdc$var$blake2sInit(outlen, key) {
    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
    var keylen = key ? key.length : 0;
    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
    var ctx = {
        h: new Uint32Array($19f1576d8eccccdc$var$BLAKE2S_IV),
        b: new Uint8Array(64),
        c: 0,
        t: 0,
        outlen: outlen // output length in bytes
    };
    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
    if (keylen > 0) {
        $19f1576d8eccccdc$var$blake2sUpdate(ctx, key);
        ctx.c = 64 // at the end
        ;
    }
    return ctx;
}
// Updates a BLAKE2s streaming hash
// Requires hash context and Uint8Array (byte array)
function $19f1576d8eccccdc$var$blake2sUpdate(ctx, input) {
    for(var i = 0; i < input.length; i++){
        if (ctx.c === 64) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            $19f1576d8eccccdc$var$blake2sCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2s streaming hash
// Returns a Uint8Array containing the message digest
function $19f1576d8eccccdc$var$blake2sFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 64)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    $19f1576d8eccccdc$var$blake2sCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    var out = new Uint8Array(ctx.outlen);
    for(var i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
    return out;
}
// Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function $19f1576d8eccccdc$var$blake2s(input, key, outlen) {
    // preprocess inputs
    outlen = outlen || 32;
    input = $e9119709d3488a62$exports.normalizeInput(input);
    // do the math
    var ctx = $19f1576d8eccccdc$var$blake2sInit(outlen, key);
    $19f1576d8eccccdc$var$blake2sUpdate(ctx, input);
    return $19f1576d8eccccdc$var$blake2sFinal(ctx);
}
// Computes the BLAKE2S hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function $19f1576d8eccccdc$var$blake2sHex(input, key, outlen) {
    var output = $19f1576d8eccccdc$var$blake2s(input, key, outlen);
    return $e9119709d3488a62$exports.toHex(output);
}
$19f1576d8eccccdc$exports = {
    blake2s: $19f1576d8eccccdc$var$blake2s,
    blake2sHex: $19f1576d8eccccdc$var$blake2sHex,
    blake2sInit: $19f1576d8eccccdc$var$blake2sInit,
    blake2sUpdate: $19f1576d8eccccdc$var$blake2sUpdate,
    blake2sFinal: $19f1576d8eccccdc$var$blake2sFinal
};


$a26f0a0d5ac54941$exports = {
    blake2b: $bc898815a381c20d$exports.blake2b,
    blake2bHex: $bc898815a381c20d$exports.blake2bHex,
    blake2bInit: $bc898815a381c20d$exports.blake2bInit,
    blake2bUpdate: $bc898815a381c20d$exports.blake2bUpdate,
    blake2bFinal: $bc898815a381c20d$exports.blake2bFinal,
    blake2s: $19f1576d8eccccdc$exports.blake2s,
    blake2sHex: $19f1576d8eccccdc$exports.blake2sHex,
    blake2sInit: $19f1576d8eccccdc$exports.blake2sInit,
    blake2sUpdate: $19f1576d8eccccdc$exports.blake2sUpdate,
    blake2sFinal: $19f1576d8eccccdc$exports.blake2sFinal
};


var $b6ea585a3a423ae0$var$HDPATH_0_DEFAULT = 0x8000002c;
var $b6ea585a3a423ae0$var$INS = {
    GET_VERSION: 0x00,
    GET_ADDR: 0x01,
    SIGN: 0x02,
    // Allow list related commands
    ALLOWLIST_GET_PUBKEY: 0x90,
    ALLOWLIST_SET_PUBKEY: 0x91,
    ALLOWLIST_GET_HASH: 0x92,
    ALLOWLIST_UPLOAD: 0x93
};
var $b6ea585a3a423ae0$var$SubstrateApp = /*#__PURE__*/ function() {
    function SubstrateApp(transport, cla, slip0044) {
        (0, $b6ea585a3a423ae0$var$_classCallCheck2.default)(this, SubstrateApp);
        if (!transport) throw new Error("Transport has not been defined");
        this.transport = transport;
        this.cla = cla;
        this.slip0044 = slip0044;
    }
    (0, $b6ea585a3a423ae0$var$_createClass2.default)(SubstrateApp, [
        {
            key: "getVersion",
            value: function() {
                var _getVersion2 = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee() {
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (0, $0a9217f4fc00e97f$exports.getVersion)(this.transport, this.cla);
                            case 3:
                                return _context.abrupt("return", _context.sent);
                            case 6:
                                _context.prev = 6;
                                _context.t0 = _context["catch"](0);
                                return _context.abrupt("return", (0, $0a9217f4fc00e97f$exports.processErrorResponse)(_context.t0));
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            0,
                            6
                        ]
                    ]);
                }));
                function getVersion() {
                    return _getVersion2.apply(this, arguments);
                }
                return getVersion;
            }()
        },
        {
            key: "appInfo",
            value: function() {
                var _appInfo = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee2() {
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.transport.send(0xb0, 0x01, 0, 0).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    var result = {};
                                    var appName = "err";
                                    var appVersion = "err";
                                    var flagLen = 0;
                                    var flagsValue = 0;
                                    if (response[0] !== 1) {
                                        // Ledger responds with format ID 1. There is no spec for any format != 1
                                        result.error_message = "response format ID not recognized";
                                        result.return_code = 0x9001;
                                    } else {
                                        var appNameLen = response[1];
                                        appName = response.slice(2, 2 + appNameLen).toString("ascii");
                                        var idx = 2 + appNameLen;
                                        var appVersionLen = response[idx];
                                        idx += 1;
                                        appVersion = response.slice(idx, idx + appVersionLen).toString("ascii");
                                        idx += appVersionLen;
                                        var appFlagsLen = response[idx];
                                        idx += 1;
                                        flagLen = appFlagsLen;
                                        flagsValue = response[idx];
                                    }
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(returnCode),
                                        // //
                                        appName: appName,
                                        appVersion: appVersion,
                                        flagLen: flagLen,
                                        flagsValue: flagsValue,
                                        // eslint-disable-next-line no-bitwise
                                        flag_recovery: (flagsValue & 1) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_signed_mcu_code: (flagsValue & 2) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_onboarded: (flagsValue & 4) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_pin_validated: (flagsValue & 128) !== 0
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function appInfo() {
                    return _appInfo.apply(this, arguments);
                }
                return appInfo;
            }()
        },
        {
            key: "getAddress",
            value: function() {
                var _getAddress = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee3(account, change, addressIndex) {
                    var requireConfirmation, scheme, bip44Path, p1, p2, _args3 = arguments;
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                requireConfirmation = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
                                scheme = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : $0a9217f4fc00e97f$exports.SCHEME.ED25519;
                                bip44Path = SubstrateApp.serializePath(this.slip0044, account, change, addressIndex);
                                p1 = 0;
                                if (requireConfirmation) p1 = 1;
                                p2 = 0;
                                if (!isNaN(scheme)) p2 = scheme;
                                return _context3.abrupt("return", this.transport.send(this.cla, $b6ea585a3a423ae0$var$INS.GET_ADDR, p1, p2, bip44Path).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var errorCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    return {
                                        pubKey: response.slice(0, 32).toString("hex"),
                                        address: response.slice(32, response.length - 2).toString("ascii"),
                                        return_code: errorCode,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(errorCode)
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 8:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function getAddress(_x, _x2, _x3) {
                    return _getAddress.apply(this, arguments);
                }
                return getAddress;
            }()
        },
        {
            key: "signSendChunk",
            value: function() {
                var _signSendChunk = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee4(chunkIdx, chunkNum, chunk) {
                    var scheme, payloadType, p2, _args4 = arguments;
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                scheme = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : $0a9217f4fc00e97f$exports.SCHEME.ED25519;
                                payloadType = $0a9217f4fc00e97f$exports.PAYLOAD_TYPE.ADD;
                                if (chunkIdx === 1) payloadType = $0a9217f4fc00e97f$exports.PAYLOAD_TYPE.INIT;
                                if (chunkIdx === chunkNum) payloadType = $0a9217f4fc00e97f$exports.PAYLOAD_TYPE.LAST;
                                p2 = 0;
                                if (!isNaN(scheme)) p2 = scheme;
                                return _context4.abrupt("return", this.transport.send(this.cla, $b6ea585a3a423ae0$var$INS.SIGN, payloadType, p2, chunk, [
                                    $0a9217f4fc00e97f$exports.ERROR_CODE.NoError,
                                    0x6984,
                                    0x6a80
                                ]).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    var errorMessage = (0, $0a9217f4fc00e97f$exports.errorCodeToString)(returnCode);
                                    var signature = null;
                                    if (returnCode === 0x6a80 || returnCode === 0x6984) errorMessage = response.slice(0, response.length - 2).toString("ascii");
                                    else if (response.length > 2) signature = response.slice(0, response.length - 2);
                                    return {
                                        signature: signature,
                                        return_code: returnCode,
                                        error_message: errorMessage
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function signSendChunk(_x4, _x5, _x6) {
                    return _signSendChunk.apply(this, arguments);
                }
                return signSendChunk;
            }()
        },
        {
            key: "sign",
            value: function() {
                var _sign = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee6(account, change, addressIndex, message) {
                    var _this = this;
                    var scheme, chunks, _args6 = arguments;
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                scheme = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : $0a9217f4fc00e97f$exports.SCHEME.ED25519;
                                chunks = SubstrateApp.signGetChunks(this.slip0044, account, change, addressIndex, message);
                                return _context6.abrupt("return", this.signSendChunk(1, chunks.length, chunks[0], scheme).then(/*#__PURE__*/ function() {
                                    var _ref = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee5(result) {
                                        var i;
                                        return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee5$(_context5) {
                                            while(true)switch(_context5.prev = _context5.next){
                                                case 0:
                                                    i = 1;
                                                case 1:
                                                    if (!(i < chunks.length)) {
                                                        _context5.next = 10;
                                                        break;
                                                    }
                                                    _context5.next = 4;
                                                    return _this.signSendChunk(1 + i, chunks.length, chunks[i], scheme);
                                                case 4:
                                                    result = _context5.sent;
                                                    if (!(result.return_code !== $0a9217f4fc00e97f$exports.ERROR_CODE.NoError)) {
                                                        _context5.next = 7;
                                                        break;
                                                    }
                                                    return _context5.abrupt("break", 10);
                                                case 7:
                                                    i += 1;
                                                    _context5.next = 1;
                                                    break;
                                                case 10:
                                                    return _context5.abrupt("return", {
                                                        return_code: result.return_code,
                                                        error_message: result.error_message,
                                                        signature: result.signature
                                                    });
                                                case 11:
                                                case "end":
                                                    return _context5.stop();
                                            }
                                        }, _callee5);
                                    }));
                                    return function(_x11) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(), $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 3:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function sign(_x7, _x8, _x9, _x10) {
                    return _sign.apply(this, arguments);
                }
                return sign;
            }() /// Allow list related commands. They are NOT available on all apps
        },
        {
            key: "getAllowlistPubKey",
            value: function() {
                var _getAllowlistPubKey = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee7() {
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                return _context7.abrupt("return", this.transport.send(this.cla, $b6ea585a3a423ae0$var$INS.ALLOWLIST_GET_PUBKEY, 0, 0).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    console.log(response);
                                    var pubkey = response.slice(0, 32); // 32 bytes + 2 error code
                                    // 32 bytes + 2 error code
                                    if (response.length !== 34) return {
                                        return_code: 0x6984,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(0x6984)
                                    };
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(returnCode),
                                        pubkey: pubkey
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 1:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function getAllowlistPubKey() {
                    return _getAllowlistPubKey.apply(this, arguments);
                }
                return getAllowlistPubKey;
            }()
        },
        {
            key: "setAllowlistPubKey",
            value: function() {
                var _setAllowlistPubKey = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee8(pk) {
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                return _context8.abrupt("return", this.transport.send(this.cla, $b6ea585a3a423ae0$var$INS.ALLOWLIST_SET_PUBKEY, 0, 0, pk).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(returnCode)
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 1:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function setAllowlistPubKey(_x12) {
                    return _setAllowlistPubKey.apply(this, arguments);
                }
                return setAllowlistPubKey;
            }()
        },
        {
            key: "getAllowlistHash",
            value: function() {
                var _getAllowlistHash = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee9() {
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                return _context9.abrupt("return", this.transport.send(this.cla, $b6ea585a3a423ae0$var$INS.ALLOWLIST_GET_HASH, 0, 0).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    console.log(response);
                                    var hash = response.slice(0, 32); // 32 bytes + 2 error code
                                    // 32 bytes + 2 error code
                                    if (response.length !== 34) return {
                                        return_code: 0x6984,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(0x6984)
                                    };
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, $0a9217f4fc00e97f$exports.errorCodeToString)(returnCode),
                                        hash: hash
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 1:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function getAllowlistHash() {
                    return _getAllowlistHash.apply(this, arguments);
                }
                return getAllowlistHash;
            }()
        },
        {
            key: "uploadSendChunk",
            value: function() {
                var _uploadSendChunk = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee10(chunkIdx, chunkNum, chunk) {
                    var payloadType;
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                payloadType = $0a9217f4fc00e97f$exports.PAYLOAD_TYPE.ADD;
                                if (chunkIdx === 1) payloadType = $0a9217f4fc00e97f$exports.PAYLOAD_TYPE.INIT;
                                if (chunkIdx === chunkNum) payloadType = $0a9217f4fc00e97f$exports.PAYLOAD_TYPE.LAST;
                                return _context10.abrupt("return", this.transport.send(this.cla, $b6ea585a3a423ae0$var$INS.ALLOWLIST_UPLOAD, payloadType, 0, chunk, [
                                    $0a9217f4fc00e97f$exports.ERROR_CODE.NoError
                                ]).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    var errorMessage = (0, $0a9217f4fc00e97f$exports.errorCodeToString)(returnCode);
                                    return {
                                        return_code: returnCode,
                                        error_message: errorMessage
                                    };
                                }, $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function uploadSendChunk(_x13, _x14, _x15) {
                    return _uploadSendChunk.apply(this, arguments);
                }
                return uploadSendChunk;
            }()
        },
        {
            key: "uploadAllowlist",
            value: function() {
                var _uploadAllowlist = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee12(message) {
                    var _this2 = this;
                    var chunks;
                    return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                chunks = [];
                                chunks.push($b6ea585a3a423ae0$require$Buffer.from([
                                    0
                                ]));
                                chunks.push.apply(chunks, (0, $b6ea585a3a423ae0$var$_toConsumableArray2.default)(SubstrateApp.GetChunks(message)));
                                return _context12.abrupt("return", this.uploadSendChunk(1, chunks.length, chunks[0]).then(/*#__PURE__*/ function() {
                                    var _ref2 = (0, $b6ea585a3a423ae0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $b6ea585a3a423ae0$var$_regenerator.default.mark(function _callee11(result) {
                                        var i;
                                        return $b6ea585a3a423ae0$var$_regenerator.default.wrap(function _callee11$(_context11) {
                                            while(true)switch(_context11.prev = _context11.next){
                                                case 0:
                                                    if (!(result.return_code !== $0a9217f4fc00e97f$exports.ERROR_CODE.NoError)) {
                                                        _context11.next = 2;
                                                        break;
                                                    }
                                                    return _context11.abrupt("return", {
                                                        return_code: result.return_code,
                                                        error_message: result.error_message
                                                    });
                                                case 2:
                                                    i = 1;
                                                case 3:
                                                    if (!(i < chunks.length)) {
                                                        _context11.next = 12;
                                                        break;
                                                    }
                                                    _context11.next = 6;
                                                    return _this2.uploadSendChunk(1 + i, chunks.length, chunks[i]);
                                                case 6:
                                                    result = _context11.sent;
                                                    if (!(result.return_code !== $0a9217f4fc00e97f$exports.ERROR_CODE.NoError)) {
                                                        _context11.next = 9;
                                                        break;
                                                    }
                                                    return _context11.abrupt("break", 12);
                                                case 9:
                                                    i += 1;
                                                    _context11.next = 3;
                                                    break;
                                                case 12:
                                                    return _context11.abrupt("return", {
                                                        return_code: result.return_code,
                                                        error_message: result.error_message
                                                    });
                                                case 13:
                                                case "end":
                                                    return _context11.stop();
                                            }
                                        }, _callee11);
                                    }));
                                    return function(_x17) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }(), $0a9217f4fc00e97f$exports.processErrorResponse));
                            case 4:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function uploadAllowlist(_x16) {
                    return _uploadAllowlist.apply(this, arguments);
                }
                return uploadAllowlist;
            }()
        }
    ], [
        {
            key: "serializePath",
            value: function serializePath(slip0044, account, change, addressIndex) {
                if (!Number.isInteger(account)) throw new Error("Input must be an integer");
                if (!Number.isInteger(change)) throw new Error("Input must be an integer");
                if (!Number.isInteger(addressIndex)) throw new Error("Input must be an integer");
                var buf = $b6ea585a3a423ae0$require$Buffer.alloc(20);
                buf.writeUInt32LE(0x8000002c, 0);
                buf.writeUInt32LE(slip0044, 4);
                buf.writeUInt32LE(account, 8);
                buf.writeUInt32LE(change, 12);
                buf.writeUInt32LE(addressIndex, 16);
                return buf;
            }
        },
        {
            key: "GetChunks",
            value: function GetChunks(message) {
                var chunks = [];
                var buffer = $b6ea585a3a423ae0$require$Buffer.from(message);
                for(var i = 0; i < buffer.length; i += $0a9217f4fc00e97f$exports.CHUNK_SIZE){
                    var end = i + $0a9217f4fc00e97f$exports.CHUNK_SIZE;
                    if (i > buffer.length) end = buffer.length;
                    chunks.push(buffer.slice(i, end));
                }
                return chunks;
            }
        },
        {
            key: "signGetChunks",
            value: function signGetChunks(slip0044, account, change, addressIndex, message) {
                var chunks = [];
                var bip44Path = SubstrateApp.serializePath(slip0044, account, change, addressIndex);
                chunks.push(bip44Path);
                chunks.push.apply(chunks, (0, $b6ea585a3a423ae0$var$_toConsumableArray2.default)(SubstrateApp.GetChunks(message)));
                return chunks;
            }
        }
    ]);
    return SubstrateApp;
}();
function $b6ea585a3a423ae0$var$newKusamaApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.KUSAMA, $21c99f07492dd553$exports.SLIP0044.KUSAMA);
}
function $b6ea585a3a423ae0$var$newPolkadotApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.POLKADOT, $21c99f07492dd553$exports.SLIP0044.POLKADOT);
}
function $b6ea585a3a423ae0$var$newPolymeshApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.POLYMESH, $21c99f07492dd553$exports.SLIP0044.POLYMESH);
}
function $b6ea585a3a423ae0$var$newDockApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.DOCK, $21c99f07492dd553$exports.SLIP0044.DOCK);
}
function $b6ea585a3a423ae0$var$newCentrifugeApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.CENTRIFUGE, $21c99f07492dd553$exports.SLIP0044.CENTRIFUGE);
}
function $b6ea585a3a423ae0$var$newEdgewareApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.EDGEWARE, $21c99f07492dd553$exports.SLIP0044.EDGEWARE);
}
function $b6ea585a3a423ae0$var$newEquilibriumApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.EQUILIBRIUM, $21c99f07492dd553$exports.SLIP0044.EQUILIBRIUM);
}
function $b6ea585a3a423ae0$var$newGenshiroApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.GENSHIRO, $21c99f07492dd553$exports.SLIP0044.GENSHIRO);
}
function $b6ea585a3a423ae0$var$newStatemintApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.STATEMINT, $21c99f07492dd553$exports.SLIP0044.STATEMINT);
}
function $b6ea585a3a423ae0$var$newStatemineApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.STATEMINE, $21c99f07492dd553$exports.SLIP0044.STATEMINE);
}
function $b6ea585a3a423ae0$var$newNodleApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.NODLE, $21c99f07492dd553$exports.SLIP0044.NODLE);
}
function $b6ea585a3a423ae0$var$newSoraApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.SORA, $21c99f07492dd553$exports.SLIP0044.SORA);
}
function $b6ea585a3a423ae0$var$newPolkadexApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.POLKADEX, $21c99f07492dd553$exports.SLIP0044.POLKADEX);
}
function $b6ea585a3a423ae0$var$newBifrostApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.BIFROST, $21c99f07492dd553$exports.SLIP0044.BIFROST);
}
function $b6ea585a3a423ae0$var$newKaruraApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.KARURA, $21c99f07492dd553$exports.SLIP0044.KARURA);
}
function $b6ea585a3a423ae0$var$newReefApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.REEF, $21c99f07492dd553$exports.SLIP0044.REEF);
}
function $b6ea585a3a423ae0$var$newAcalaApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.ACALA, $21c99f07492dd553$exports.SLIP0044.ACALA);
}
function $b6ea585a3a423ae0$var$newElixxirApp(transport) {
    return new $b6ea585a3a423ae0$var$SubstrateApp(transport, $21c99f07492dd553$exports.CLA.ELIXXIR, $21c99f07492dd553$exports.SLIP0044.ELIXXIR);
}
function $b6ea585a3a423ae0$var$sha512(data) {
    var digest = $kZo2m.sha512().update(data).digest();
    return $b6ea585a3a423ae0$require$Buffer.from(digest);
}
function $b6ea585a3a423ae0$var$hmac256(key, data) {
    var digest = $kZo2m.hmac($kZo2m.sha256, key).update(data).digest();
    return $b6ea585a3a423ae0$require$Buffer.from(digest);
}
function $b6ea585a3a423ae0$var$hmac512(key, data) {
    var digest = $kZo2m.hmac($kZo2m.sha512, key).update(data).digest();
    return $b6ea585a3a423ae0$require$Buffer.from(digest);
}
function $b6ea585a3a423ae0$var$ss58hash(data) {
    var hash = $a26f0a0d5ac54941$exports.blake2bInit(64, null);
    $a26f0a0d5ac54941$exports.blake2bUpdate(hash, $b6ea585a3a423ae0$require$Buffer.from("SS58PRE"));
    $a26f0a0d5ac54941$exports.blake2bUpdate(hash, data);
    return $a26f0a0d5ac54941$exports.blake2bFinal(hash);
}
function $b6ea585a3a423ae0$var$ss58_encode(prefix, pubkey) {
    if (pubkey.byteLength !== 32) return null;
    var data = $b6ea585a3a423ae0$require$Buffer.alloc(35);
    data[0] = prefix;
    pubkey.copy(data, 1);
    var hash = $b6ea585a3a423ae0$var$ss58hash(data.slice(0, 33));
    data[33] = hash[0];
    data[34] = hash[1];
    return $gYRJ8.encode(data);
}
function $b6ea585a3a423ae0$var$root_node_slip10(master_seed) {
    var data = $b6ea585a3a423ae0$require$Buffer.alloc(65);
    data[0] = 0x01;
    master_seed.copy(data, 1);
    var c = $b6ea585a3a423ae0$var$hmac256("ed25519 seed", data);
    var I = $b6ea585a3a423ae0$var$hmac512("ed25519 seed", data.slice(1));
    var kL = I.slice(0, 32);
    var kR = I.slice(32);
    while((kL[31] & 32) !== 0){
        I.copy(data, 1);
        I = $b6ea585a3a423ae0$var$hmac512("ed25519 seed", data.slice(1));
        kL = I.slice(0, 32);
        kR = I.slice(32);
    }
    kL[0] &= 248;
    kL[31] &= 127;
    kL[31] |= 64;
    return $b6ea585a3a423ae0$require$Buffer.concat([
        kL,
        kR,
        c
    ]);
}
function $b6ea585a3a423ae0$var$hdKeyDerivation(mnemonic, password, slip0044, accountIndex, changeIndex, addressIndex, ss58prefix) {
    if (!$3e887e0d61d3bf2f$exports.validateMnemonic(mnemonic)) {
        console.log("Invalid mnemonic");
        return null;
    }
    var seed = $3e887e0d61d3bf2f$exports.mnemonicToSeedSync(mnemonic, password);
    var node = $b6ea585a3a423ae0$var$root_node_slip10(seed);
    node = $c2c95997c89a1556$exports.derivePrivate(node, $b6ea585a3a423ae0$var$HDPATH_0_DEFAULT);
    node = $c2c95997c89a1556$exports.derivePrivate(node, slip0044);
    node = $c2c95997c89a1556$exports.derivePrivate(node, accountIndex);
    node = $c2c95997c89a1556$exports.derivePrivate(node, changeIndex);
    node = $c2c95997c89a1556$exports.derivePrivate(node, addressIndex);
    var kL = node.slice(0, 32);
    var sk = $b6ea585a3a423ae0$var$sha512(kL).slice(0, 32);
    sk[0] &= 248;
    sk[31] &= 127;
    sk[31] |= 64;
    var pk = $c2c95997c89a1556$exports.toPublic(sk);
    var address = $b6ea585a3a423ae0$var$ss58_encode(ss58prefix, pk);
    return {
        sk: kL,
        pk: pk,
        address: address
    };
}
$b6ea585a3a423ae0$exports = {
    hdKeyDerivation: $b6ea585a3a423ae0$var$hdKeyDerivation,
    newKusamaApp: $b6ea585a3a423ae0$var$newKusamaApp,
    newPolkadotApp: $b6ea585a3a423ae0$var$newPolkadotApp,
    newPolymeshApp: $b6ea585a3a423ae0$var$newPolymeshApp,
    newDockApp: $b6ea585a3a423ae0$var$newDockApp,
    newCentrifugeApp: $b6ea585a3a423ae0$var$newCentrifugeApp,
    newEdgewareApp: $b6ea585a3a423ae0$var$newEdgewareApp,
    newEquilibriumApp: $b6ea585a3a423ae0$var$newEquilibriumApp,
    newGenshiroApp: $b6ea585a3a423ae0$var$newGenshiroApp,
    newStatemintApp: $b6ea585a3a423ae0$var$newStatemintApp,
    newStatemineApp: $b6ea585a3a423ae0$var$newStatemineApp,
    newNodleApp: $b6ea585a3a423ae0$var$newNodleApp,
    newSoraApp: $b6ea585a3a423ae0$var$newSoraApp,
    newPolkadexApp: $b6ea585a3a423ae0$var$newPolkadexApp,
    newBifrostApp: $b6ea585a3a423ae0$var$newBifrostApp,
    newKaruraApp: $b6ea585a3a423ae0$var$newKaruraApp,
    newReefApp: $b6ea585a3a423ae0$var$newReefApp,
    newAcalaApp: $b6ea585a3a423ae0$var$newAcalaApp,
    newElixxirApp: $b6ea585a3a423ae0$var$newElixxirApp
};



/** Used for built-in method references. */ var $780de54fdc8caa3f$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $780de54fdc8caa3f$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $780de54fdc8caa3f$var$objectProto;
    return value === proto;
}
var $780de54fdc8caa3f$export$2e2bcd8739ae039 = $780de54fdc8caa3f$var$isPrototype;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e45beffd02b1a67a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $e45beffd02b1a67a$export$2e2bcd8739ae039 = $e45beffd02b1a67a$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa122dd75fffd842$var$nativeKeys = (0, $e45beffd02b1a67a$export$2e2bcd8739ae039)(Object.keys, Object);
var $fa122dd75fffd842$export$2e2bcd8739ae039 = $fa122dd75fffd842$var$nativeKeys;


/** Used for built-in method references. */ var $8c3b6de58a795952$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8c3b6de58a795952$var$hasOwnProperty = $8c3b6de58a795952$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8c3b6de58a795952$var$baseKeys(object) {
    if (!(0, $780de54fdc8caa3f$export$2e2bcd8739ae039)(object)) return (0, $fa122dd75fffd842$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($8c3b6de58a795952$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $8c3b6de58a795952$export$2e2bcd8739ae039 = $8c3b6de58a795952$var$baseKeys;



var $eaQXQ = parcelRequire("eaQXQ");
/** Built-in value references. */ var $4e6c8393525faf38$var$Symbol = (0, $eaQXQ.default).Symbol;
var $4e6c8393525faf38$export$2e2bcd8739ae039 = $4e6c8393525faf38$var$Symbol;



/** Used for built-in method references. */ var $6456c2b66b7c5956$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6456c2b66b7c5956$var$hasOwnProperty = $6456c2b66b7c5956$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6456c2b66b7c5956$var$nativeObjectToString = $6456c2b66b7c5956$var$objectProto.toString;
/** Built-in value references. */ var $6456c2b66b7c5956$var$symToStringTag = (0, $4e6c8393525faf38$export$2e2bcd8739ae039) ? (0, $4e6c8393525faf38$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $6456c2b66b7c5956$var$getRawTag(value) {
    var isOwn = $6456c2b66b7c5956$var$hasOwnProperty.call(value, $6456c2b66b7c5956$var$symToStringTag), tag = value[$6456c2b66b7c5956$var$symToStringTag];
    try {
        value[$6456c2b66b7c5956$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $6456c2b66b7c5956$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$6456c2b66b7c5956$var$symToStringTag] = tag;
        else delete value[$6456c2b66b7c5956$var$symToStringTag];
    }
    return result;
}
var $6456c2b66b7c5956$export$2e2bcd8739ae039 = $6456c2b66b7c5956$var$getRawTag;


/** Used for built-in method references. */ var $a5fcba6958ba1507$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a5fcba6958ba1507$var$nativeObjectToString = $a5fcba6958ba1507$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a5fcba6958ba1507$var$objectToString(value) {
    return $a5fcba6958ba1507$var$nativeObjectToString.call(value);
}
var $a5fcba6958ba1507$export$2e2bcd8739ae039 = $a5fcba6958ba1507$var$objectToString;


/** `Object#toString` result references. */ var $2388b19ca55899d6$var$nullTag = "[object Null]", $2388b19ca55899d6$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $2388b19ca55899d6$var$symToStringTag = (0, $4e6c8393525faf38$export$2e2bcd8739ae039) ? (0, $4e6c8393525faf38$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $2388b19ca55899d6$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $2388b19ca55899d6$var$undefinedTag : $2388b19ca55899d6$var$nullTag;
    return $2388b19ca55899d6$var$symToStringTag && $2388b19ca55899d6$var$symToStringTag in Object(value) ? (0, $6456c2b66b7c5956$export$2e2bcd8739ae039)(value) : (0, $a5fcba6958ba1507$export$2e2bcd8739ae039)(value);
}
var $2388b19ca55899d6$export$2e2bcd8739ae039 = $2388b19ca55899d6$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $aVMuR = parcelRequire("aVMuR");
function $fdda8d81170ec173$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value);
    return value != null && (type == "object" || type == "function");
}
var $fdda8d81170ec173$export$2e2bcd8739ae039 = $fdda8d81170ec173$var$isObject;


/** `Object#toString` result references. */ var $7ca99eb5fbbb66ff$var$asyncTag = "[object AsyncFunction]", $7ca99eb5fbbb66ff$var$funcTag = "[object Function]", $7ca99eb5fbbb66ff$var$genTag = "[object GeneratorFunction]", $7ca99eb5fbbb66ff$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $7ca99eb5fbbb66ff$var$isFunction(value) {
    if (!(0, $fdda8d81170ec173$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $2388b19ca55899d6$export$2e2bcd8739ae039)(value);
    return tag == $7ca99eb5fbbb66ff$var$funcTag || tag == $7ca99eb5fbbb66ff$var$genTag || tag == $7ca99eb5fbbb66ff$var$asyncTag || tag == $7ca99eb5fbbb66ff$var$proxyTag;
}
var $7ca99eb5fbbb66ff$export$2e2bcd8739ae039 = $7ca99eb5fbbb66ff$var$isFunction;



var $eaQXQ = parcelRequire("eaQXQ");
/** Used to detect overreaching core-js shims. */ var $82173d95f5f3c979$var$coreJsData = (0, $eaQXQ.default)["__core-js_shared__"];
var $82173d95f5f3c979$export$2e2bcd8739ae039 = $82173d95f5f3c979$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $fa986fbc5a9aed25$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $82173d95f5f3c979$export$2e2bcd8739ae039) && (0, $82173d95f5f3c979$export$2e2bcd8739ae039).keys && (0, $82173d95f5f3c979$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $fa986fbc5a9aed25$var$isMasked(func) {
    return !!$fa986fbc5a9aed25$var$maskSrcKey && $fa986fbc5a9aed25$var$maskSrcKey in func;
}
var $fa986fbc5a9aed25$export$2e2bcd8739ae039 = $fa986fbc5a9aed25$var$isMasked;



/** Used for built-in method references. */ var $d60d6270507ddf77$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $d60d6270507ddf77$var$funcToString = $d60d6270507ddf77$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $d60d6270507ddf77$var$toSource(func) {
    if (func != null) {
        try {
            return $d60d6270507ddf77$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $d60d6270507ddf77$export$2e2bcd8739ae039 = $d60d6270507ddf77$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7721ec4d8c9fdf23$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $7721ec4d8c9fdf23$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $7721ec4d8c9fdf23$var$funcProto = Function.prototype, $7721ec4d8c9fdf23$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7721ec4d8c9fdf23$var$funcToString = $7721ec4d8c9fdf23$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7721ec4d8c9fdf23$var$hasOwnProperty = $7721ec4d8c9fdf23$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $7721ec4d8c9fdf23$var$reIsNative = RegExp("^" + $7721ec4d8c9fdf23$var$funcToString.call($7721ec4d8c9fdf23$var$hasOwnProperty).replace($7721ec4d8c9fdf23$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7721ec4d8c9fdf23$var$baseIsNative(value) {
    if (!(0, $fdda8d81170ec173$export$2e2bcd8739ae039)(value) || (0, $fa986fbc5a9aed25$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $7ca99eb5fbbb66ff$export$2e2bcd8739ae039)(value) ? $7721ec4d8c9fdf23$var$reIsNative : $7721ec4d8c9fdf23$var$reIsHostCtor;
    return pattern.test((0, $d60d6270507ddf77$export$2e2bcd8739ae039)(value));
}
var $7721ec4d8c9fdf23$export$2e2bcd8739ae039 = $7721ec4d8c9fdf23$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $84e494f56e0c05ab$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $84e494f56e0c05ab$export$2e2bcd8739ae039 = $84e494f56e0c05ab$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $19388d40beae88b9$var$getNative(object, key) {
    var value = (0, $84e494f56e0c05ab$export$2e2bcd8739ae039)(object, key);
    return (0, $7721ec4d8c9fdf23$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $19388d40beae88b9$export$2e2bcd8739ae039 = $19388d40beae88b9$var$getNative;



var $eaQXQ = parcelRequire("eaQXQ");
/* Built-in method references that are verified to be native. */ var $fa6766d40f3e5820$var$DataView = (0, $19388d40beae88b9$export$2e2bcd8739ae039)((0, $eaQXQ.default), "DataView");
var $fa6766d40f3e5820$export$2e2bcd8739ae039 = $fa6766d40f3e5820$var$DataView;




var $eaQXQ = parcelRequire("eaQXQ");
/* Built-in method references that are verified to be native. */ var $4256cc9d4cdece94$var$Map = (0, $19388d40beae88b9$export$2e2bcd8739ae039)((0, $eaQXQ.default), "Map");
var $4256cc9d4cdece94$export$2e2bcd8739ae039 = $4256cc9d4cdece94$var$Map;




var $eaQXQ = parcelRequire("eaQXQ");
/* Built-in method references that are verified to be native. */ var $c855fb676d124683$var$Promise = (0, $19388d40beae88b9$export$2e2bcd8739ae039)((0, $eaQXQ.default), "Promise");
var $c855fb676d124683$export$2e2bcd8739ae039 = $c855fb676d124683$var$Promise;




var $eaQXQ = parcelRequire("eaQXQ");
/* Built-in method references that are verified to be native. */ var $440c2bb174a5a0c7$var$Set = (0, $19388d40beae88b9$export$2e2bcd8739ae039)((0, $eaQXQ.default), "Set");
var $440c2bb174a5a0c7$export$2e2bcd8739ae039 = $440c2bb174a5a0c7$var$Set;




var $eaQXQ = parcelRequire("eaQXQ");
/* Built-in method references that are verified to be native. */ var $8de2340630047a41$var$WeakMap = (0, $19388d40beae88b9$export$2e2bcd8739ae039)((0, $eaQXQ.default), "WeakMap");
var $8de2340630047a41$export$2e2bcd8739ae039 = $8de2340630047a41$var$WeakMap;




/** `Object#toString` result references. */ var $580e0150ca147fe7$var$mapTag = "[object Map]", $580e0150ca147fe7$var$objectTag = "[object Object]", $580e0150ca147fe7$var$promiseTag = "[object Promise]", $580e0150ca147fe7$var$setTag = "[object Set]", $580e0150ca147fe7$var$weakMapTag = "[object WeakMap]";
var $580e0150ca147fe7$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $580e0150ca147fe7$var$dataViewCtorString = (0, $d60d6270507ddf77$export$2e2bcd8739ae039)((0, $fa6766d40f3e5820$export$2e2bcd8739ae039)), $580e0150ca147fe7$var$mapCtorString = (0, $d60d6270507ddf77$export$2e2bcd8739ae039)((0, $4256cc9d4cdece94$export$2e2bcd8739ae039)), $580e0150ca147fe7$var$promiseCtorString = (0, $d60d6270507ddf77$export$2e2bcd8739ae039)((0, $c855fb676d124683$export$2e2bcd8739ae039)), $580e0150ca147fe7$var$setCtorString = (0, $d60d6270507ddf77$export$2e2bcd8739ae039)((0, $440c2bb174a5a0c7$export$2e2bcd8739ae039)), $580e0150ca147fe7$var$weakMapCtorString = (0, $d60d6270507ddf77$export$2e2bcd8739ae039)((0, $8de2340630047a41$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $580e0150ca147fe7$var$getTag = (0, $2388b19ca55899d6$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $fa6766d40f3e5820$export$2e2bcd8739ae039) && $580e0150ca147fe7$var$getTag(new (0, $fa6766d40f3e5820$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $580e0150ca147fe7$var$dataViewTag || (0, $4256cc9d4cdece94$export$2e2bcd8739ae039) && $580e0150ca147fe7$var$getTag(new (0, $4256cc9d4cdece94$export$2e2bcd8739ae039)) != $580e0150ca147fe7$var$mapTag || (0, $c855fb676d124683$export$2e2bcd8739ae039) && $580e0150ca147fe7$var$getTag((0, $c855fb676d124683$export$2e2bcd8739ae039).resolve()) != $580e0150ca147fe7$var$promiseTag || (0, $440c2bb174a5a0c7$export$2e2bcd8739ae039) && $580e0150ca147fe7$var$getTag(new (0, $440c2bb174a5a0c7$export$2e2bcd8739ae039)) != $580e0150ca147fe7$var$setTag || (0, $8de2340630047a41$export$2e2bcd8739ae039) && $580e0150ca147fe7$var$getTag(new (0, $8de2340630047a41$export$2e2bcd8739ae039)) != $580e0150ca147fe7$var$weakMapTag) $580e0150ca147fe7$var$getTag = function getTag(value) {
    var result = (0, $2388b19ca55899d6$export$2e2bcd8739ae039)(value), Ctor = result == $580e0150ca147fe7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $d60d6270507ddf77$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $580e0150ca147fe7$var$dataViewCtorString:
            return $580e0150ca147fe7$var$dataViewTag;
        case $580e0150ca147fe7$var$mapCtorString:
            return $580e0150ca147fe7$var$mapTag;
        case $580e0150ca147fe7$var$promiseCtorString:
            return $580e0150ca147fe7$var$promiseTag;
        case $580e0150ca147fe7$var$setCtorString:
            return $580e0150ca147fe7$var$setTag;
        case $580e0150ca147fe7$var$weakMapCtorString:
            return $580e0150ca147fe7$var$weakMapTag;
    }
    return result;
};
var $580e0150ca147fe7$export$2e2bcd8739ae039 = $580e0150ca147fe7$var$getTag;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3c1f5d97959b9e85$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $3c1f5d97959b9e85$export$2e2bcd8739ae039 = $3c1f5d97959b9e85$var$isObjectLike;


/** `Object#toString` result references. */ var $9dcd96d33a0f5476$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $9dcd96d33a0f5476$var$baseIsArguments(value) {
    return (0, $3c1f5d97959b9e85$export$2e2bcd8739ae039)(value) && (0, $2388b19ca55899d6$export$2e2bcd8739ae039)(value) == $9dcd96d33a0f5476$var$argsTag;
}
var $9dcd96d33a0f5476$export$2e2bcd8739ae039 = $9dcd96d33a0f5476$var$baseIsArguments;



/** Used for built-in method references. */ var $be0f7992900e5663$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $be0f7992900e5663$var$hasOwnProperty = $be0f7992900e5663$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $be0f7992900e5663$var$propertyIsEnumerable = $be0f7992900e5663$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $be0f7992900e5663$var$isArguments = (0, $9dcd96d33a0f5476$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $9dcd96d33a0f5476$export$2e2bcd8739ae039) : function isArguments(value) {
    return (0, $3c1f5d97959b9e85$export$2e2bcd8739ae039)(value) && $be0f7992900e5663$var$hasOwnProperty.call(value, "callee") && !$be0f7992900e5663$var$propertyIsEnumerable.call(value, "callee");
};
var $be0f7992900e5663$export$2e2bcd8739ae039 = $be0f7992900e5663$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $a9aed815ffcf4575$var$isArray = Array.isArray;
var $a9aed815ffcf4575$export$2e2bcd8739ae039 = $a9aed815ffcf4575$var$isArray;



/** Used as references for various `Number` constants. */ var $2a82487ce4d00eda$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $2a82487ce4d00eda$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $2a82487ce4d00eda$var$MAX_SAFE_INTEGER;
}
var $2a82487ce4d00eda$export$2e2bcd8739ae039 = $2a82487ce4d00eda$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $419ec352b93f2829$var$isArrayLike(value) {
    return value != null && (0, $2a82487ce4d00eda$export$2e2bcd8739ae039)(value.length) && !(0, $7ca99eb5fbbb66ff$export$2e2bcd8739ae039)(value);
}
var $419ec352b93f2829$export$2e2bcd8739ae039 = $419ec352b93f2829$var$isArrayLike;



var $kbOln = parcelRequire("kbOln");




/** `Object#toString` result references. */ var $fe75b957dfb6306c$var$argsTag = "[object Arguments]", $fe75b957dfb6306c$var$arrayTag = "[object Array]", $fe75b957dfb6306c$var$boolTag = "[object Boolean]", $fe75b957dfb6306c$var$dateTag = "[object Date]", $fe75b957dfb6306c$var$errorTag = "[object Error]", $fe75b957dfb6306c$var$funcTag = "[object Function]", $fe75b957dfb6306c$var$mapTag = "[object Map]", $fe75b957dfb6306c$var$numberTag = "[object Number]", $fe75b957dfb6306c$var$objectTag = "[object Object]", $fe75b957dfb6306c$var$regexpTag = "[object RegExp]", $fe75b957dfb6306c$var$setTag = "[object Set]", $fe75b957dfb6306c$var$stringTag = "[object String]", $fe75b957dfb6306c$var$weakMapTag = "[object WeakMap]";
var $fe75b957dfb6306c$var$arrayBufferTag = "[object ArrayBuffer]", $fe75b957dfb6306c$var$dataViewTag = "[object DataView]", $fe75b957dfb6306c$var$float32Tag = "[object Float32Array]", $fe75b957dfb6306c$var$float64Tag = "[object Float64Array]", $fe75b957dfb6306c$var$int8Tag = "[object Int8Array]", $fe75b957dfb6306c$var$int16Tag = "[object Int16Array]", $fe75b957dfb6306c$var$int32Tag = "[object Int32Array]", $fe75b957dfb6306c$var$uint8Tag = "[object Uint8Array]", $fe75b957dfb6306c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $fe75b957dfb6306c$var$uint16Tag = "[object Uint16Array]", $fe75b957dfb6306c$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $fe75b957dfb6306c$var$typedArrayTags = {};
$fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$float32Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$float64Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$int8Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$int16Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$int32Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$uint8Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$uint8ClampedTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$uint16Tag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$uint32Tag] = true;
$fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$argsTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$arrayTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$arrayBufferTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$boolTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$dataViewTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$dateTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$errorTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$funcTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$mapTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$numberTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$objectTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$regexpTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$setTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$stringTag] = $fe75b957dfb6306c$var$typedArrayTags[$fe75b957dfb6306c$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $fe75b957dfb6306c$var$baseIsTypedArray(value) {
    return (0, $3c1f5d97959b9e85$export$2e2bcd8739ae039)(value) && (0, $2a82487ce4d00eda$export$2e2bcd8739ae039)(value.length) && !!$fe75b957dfb6306c$var$typedArrayTags[(0, $2388b19ca55899d6$export$2e2bcd8739ae039)(value)];
}
var $fe75b957dfb6306c$export$2e2bcd8739ae039 = $fe75b957dfb6306c$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d9c06cf9a178e262$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $d9c06cf9a178e262$export$2e2bcd8739ae039 = $d9c06cf9a178e262$var$baseUnary;



var $7gJxq = parcelRequire("7gJxq");
/* Node.js helper references. */ var $2eddea39790a0e16$var$nodeIsTypedArray = (0, $7gJxq.default) && (0, $7gJxq.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $2eddea39790a0e16$var$isTypedArray = $2eddea39790a0e16$var$nodeIsTypedArray ? (0, $d9c06cf9a178e262$export$2e2bcd8739ae039)($2eddea39790a0e16$var$nodeIsTypedArray) : (0, $fe75b957dfb6306c$export$2e2bcd8739ae039);
var $2eddea39790a0e16$export$2e2bcd8739ae039 = $2eddea39790a0e16$var$isTypedArray;


/** `Object#toString` result references. */ var $8c2bc561ca8daee1$var$mapTag = "[object Map]", $8c2bc561ca8daee1$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $8c2bc561ca8daee1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8c2bc561ca8daee1$var$hasOwnProperty = $8c2bc561ca8daee1$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $8c2bc561ca8daee1$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $419ec352b93f2829$export$2e2bcd8739ae039)(value) && ((0, $a9aed815ffcf4575$export$2e2bcd8739ae039)(value) || typeof value == "string" || typeof value.splice == "function" || (0, $kbOln.default)(value) || (0, $2eddea39790a0e16$export$2e2bcd8739ae039)(value) || (0, $be0f7992900e5663$export$2e2bcd8739ae039)(value))) return !value.length;
    var tag = (0, $580e0150ca147fe7$export$2e2bcd8739ae039)(value);
    if (tag == $8c2bc561ca8daee1$var$mapTag || tag == $8c2bc561ca8daee1$var$setTag) return !value.size;
    if ((0, $780de54fdc8caa3f$export$2e2bcd8739ae039)(value)) return !(0, $8c3b6de58a795952$export$2e2bcd8739ae039)(value).length;
    for(var key in value){
        if ($8c2bc561ca8daee1$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $8c2bc561ca8daee1$export$2e2bcd8739ae039 = $8c2bc561ca8daee1$var$isEmpty;

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $f59e127e73eaefde$var$isNil(value) {
    return value == null;
}
var $f59e127e73eaefde$export$2e2bcd8739ae039 = $f59e127e73eaefde$var$isNil;


var $7c9fa484a0263d49$exports = {};

$parcel$export($7c9fa484a0263d49$exports, "logger", function () { return $7c9fa484a0263d49$export$af88d00dbe7f521; });
$parcel$export($7c9fa484a0263d49$exports, "Signer", function () { return $3e3669d74ee1fde3$export$fdf54fdde81cc9f0; });
$parcel$export($7c9fa484a0263d49$exports, "Wallet", function () { return $56cd539b6bfcd29d$export$bcca3ea514774656; });
$parcel$export($7c9fa484a0263d49$exports, "VoidSigner", function () { return $3e3669d74ee1fde3$export$7dbc56d9b9612bad; });
$parcel$export($7c9fa484a0263d49$exports, "getDefaultProvider", function () { return $62f207a30c1ed53d$export$4f77a1d3c1ac6642; });
$parcel$export($7c9fa484a0263d49$exports, "providers", function () { return $62f207a30c1ed53d$exports; });
$parcel$export($7c9fa484a0263d49$exports, "BaseContract", function () { return $872b1ea3a0575206$export$304faa4fc17528db; });
$parcel$export($7c9fa484a0263d49$exports, "Contract", function () { return $872b1ea3a0575206$export$8517d80acf00e19a; });
$parcel$export($7c9fa484a0263d49$exports, "ContractFactory", function () { return $872b1ea3a0575206$export$505569a6bf584fd9; });
$parcel$export($7c9fa484a0263d49$exports, "BigNumber", function () { return $3b33bab384c8baec$export$d97aa349ed20696; });
$parcel$export($7c9fa484a0263d49$exports, "FixedNumber", function () { return $44cb5ef3e3762151$export$d4693c66c2213e45; });
$parcel$export($7c9fa484a0263d49$exports, "constants", function () { return $bdc883725b97a4d2$exports; });
$parcel$export($7c9fa484a0263d49$exports, "errors", function () { return $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb; });
$parcel$export($7c9fa484a0263d49$exports, "utils", function () { return $3caeaa80902316a2$exports; });
$parcel$export($7c9fa484a0263d49$exports, "wordlists", function () { return $0a5359b01aeda1c5$export$e8e1b4711c2d1939; });
$parcel$export($7c9fa484a0263d49$exports, "version", function () { return $501153bf8c9d2de4$export$83d89fbfd8236492; });
$parcel$export($7c9fa484a0263d49$exports, "Wordlist", function () { return $98bdf1880fe142f1$export$4d9531a8ddb0ebca; });

var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $gF0bR = parcelRequire("gF0bR");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
var $de7543790ad8525c$export$83d89fbfd8236492 = "logger/5.7.0";


"use strict";
var $4942c2e156bb1fcc$var$_permanentCensorErrors = false;
var $4942c2e156bb1fcc$var$_censorErrors = false;
var $4942c2e156bb1fcc$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
var $4942c2e156bb1fcc$var$_logLevel = $4942c2e156bb1fcc$var$LogLevels["default"];
var $4942c2e156bb1fcc$var$_globalLogger = null;
function $4942c2e156bb1fcc$var$_checkNormalize() {
    try {
        var missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(form) {
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
var $4942c2e156bb1fcc$var$_normalizeError = $4942c2e156bb1fcc$var$_checkNormalize();
var $4942c2e156bb1fcc$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($4942c2e156bb1fcc$export$243e62d78d3b544d || ($4942c2e156bb1fcc$export$243e62d78d3b544d = {}));
var $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($4942c2e156bb1fcc$export$d4e71bc0b80dc0fb || ($4942c2e156bb1fcc$export$d4e71bc0b80dc0fb = {}));
var $4942c2e156bb1fcc$var$HEX = "0123456789abcdef";
var $4942c2e156bb1fcc$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger(version) {
        (0, $7dKN1._)(this, Logger);
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    (0, $eW5pA._)(Logger, [
        {
            key: "_log",
            value: function _log(logLevel, args) {
                var level = logLevel.toLowerCase();
                if ($4942c2e156bb1fcc$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
                if ($4942c2e156bb1fcc$var$_logLevel > $4942c2e156bb1fcc$var$LogLevels[level]) return;
                console.log.apply(console, args);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.DEBUG, args);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.INFO, args);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._log(Logger.levels.WARNING, args);
            }
        },
        {
            key: "makeError",
            value: function makeError(message, code, params) {
                // Errors are being censored
                if ($4942c2e156bb1fcc$var$_censorErrors) return this.makeError("censored error", code, {});
                if (!code) code = Logger.errors.UNKNOWN_ERROR;
                if (!params) params = {};
                var messageDetails = [];
                Object.keys(params).forEach(function(key) {
                    var value = params[key];
                    try {
                        if (value instanceof Uint8Array) {
                            var hex = "";
                            for(var i = 0; i < value.length; i++){
                                hex += $4942c2e156bb1fcc$var$HEX[value[i] >> 4];
                                hex += $4942c2e156bb1fcc$var$HEX[value[i] & 0x0f];
                            }
                            messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                        } else messageDetails.push(key + "=" + JSON.stringify(value));
                    } catch (error) {
                        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
                    }
                });
                messageDetails.push("code=".concat(code));
                messageDetails.push("version=".concat(this.version));
                var reason = message;
                var url = "";
                switch(code){
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                        {
                            url = "NUMERIC_FAULT";
                            var fault = message;
                            switch(fault){
                                case "overflow":
                                case "underflow":
                                case "division-by-zero":
                                    url += "-" + fault;
                                    break;
                                case "negative-power":
                                case "negative-width":
                                    url += "-unsupported";
                                    break;
                                case "unbound-bitwise-result":
                                    url += "-unbound-result";
                                    break;
                            }
                            break;
                        }
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.MISSING_NEW:
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
                    case $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                        url = code;
                        break;
                }
                if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
                if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
                // @TODO: Any??
                var error = new Error(message);
                error.reason = reason;
                error.code = code;
                Object.keys(params).forEach(function(key) {
                    error[key] = params[key];
                });
                return error;
            }
        },
        {
            key: "throwError",
            value: function throwError(message, code, params) {
                throw this.makeError(message, code, params);
            }
        },
        {
            key: "throwArgumentError",
            value: function throwArgumentError(message, name, value) {
                return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
                    argument: name,
                    value: value
                });
            }
        },
        {
            key: "assert",
            value: function assert(condition, message, code, params) {
                if (!!condition) return;
                this.throwError(message, code, params);
            }
        },
        {
            key: "assertArgument",
            value: function assertArgument(condition, message, name, value) {
                if (!!condition) return;
                this.throwArgumentError(message, name, value);
            }
        },
        {
            key: "checkNormalize",
            value: function checkNormalize(message) {
                if (message == null) message = "platform missing String.prototype.normalize";
                if ($4942c2e156bb1fcc$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "String.prototype.normalize",
                    form: $4942c2e156bb1fcc$var$_normalizeError
                });
            }
        },
        {
            key: "checkSafeUint53",
            value: function checkSafeUint53(value, message) {
                if (typeof value !== "number") return;
                if (message == null) message = "value not safe";
                if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "out-of-safe-range",
                    value: value
                });
                if (value % 1) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "non-integer",
                    value: value
                });
            }
        },
        {
            key: "checkArgumentCount",
            value: function checkArgumentCount(count, expectedCount, message) {
                if (message) message = ": " + message;
                else message = "";
                if (count < expectedCount) this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
                if (count > expectedCount) this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
                    count: count,
                    expectedCount: expectedCount
                });
            }
        },
        {
            key: "checkNew",
            value: function checkNew(target, kind) {
                if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        },
        {
            key: "checkAbstract",
            value: function checkAbstract(target, kind) {
                if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, {
                    name: target.name,
                    operation: "new"
                });
                else if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
                    name: kind.name
                });
            }
        }
    ], [
        {
            key: "globalLogger",
            value: function globalLogger() {
                if (!$4942c2e156bb1fcc$var$_globalLogger) $4942c2e156bb1fcc$var$_globalLogger = new Logger((0, $de7543790ad8525c$export$83d89fbfd8236492));
                return $4942c2e156bb1fcc$var$_globalLogger;
            }
        },
        {
            key: "setCensorship",
            value: function setCensorship(censorship, permanent) {
                if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                });
                if ($4942c2e156bb1fcc$var$_permanentCensorErrors) {
                    if (!censorship) return;
                    this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                }
                $4942c2e156bb1fcc$var$_censorErrors = !!censorship;
                $4942c2e156bb1fcc$var$_permanentCensorErrors = !!permanent;
            }
        },
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                var level = $4942c2e156bb1fcc$var$LogLevels[logLevel.toLowerCase()];
                if (level == null) {
                    Logger.globalLogger().warn("invalid log level - " + logLevel);
                    return;
                }
                $4942c2e156bb1fcc$var$_logLevel = level;
            }
        },
        {
            key: "from",
            value: function from(version) {
                return new Logger(version);
            }
        }
    ]);
    return Logger;
}();
$4942c2e156bb1fcc$export$efa9a398d6368992.errors = $4942c2e156bb1fcc$export$d4e71bc0b80dc0fb;
$4942c2e156bb1fcc$export$efa9a398d6368992.levels = $4942c2e156bb1fcc$export$243e62d78d3b544d;


var $2756d33d1302a555$export$83d89fbfd8236492 = "bytes/5.7.0";


"use strict";
var $b8b53b1cc922c9da$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $2756d33d1302a555$export$83d89fbfd8236492));
///////////////////////////////
function $b8b53b1cc922c9da$var$isHexable(value) {
    return !!value.toHexString;
}
function $b8b53b1cc922c9da$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        var args = Array.prototype.slice.call(arguments);
        return $b8b53b1cc922c9da$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $b8b53b1cc922c9da$export$9a14abb1a440cd5e(value) {
    return $b8b53b1cc922c9da$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $b8b53b1cc922c9da$export$c6fabfbfd097fc30(value);
}
function $b8b53b1cc922c9da$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $b8b53b1cc922c9da$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$b8b53b1cc922c9da$var$isInteger(value.length) || value.length < 0) return false;
    for(var i = 0; i < value.length; i++){
        var v = value[i];
        if (!$b8b53b1cc922c9da$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $b8b53b1cc922c9da$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $b8b53b1cc922c9da$var$logger.checkSafeUint53(value, "invalid arrayify value");
        var result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $b8b53b1cc922c9da$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($b8b53b1cc922c9da$var$isHexable(value)) value = value.toHexString();
    if ($b8b53b1cc922c9da$export$b02a40aff8e4ad18(value)) {
        var hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $b8b53b1cc922c9da$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        var result1 = [];
        for(var i = 0; i < hex.length; i += 2)result1.push(parseInt(hex.substring(i, i + 2), 16));
        return $b8b53b1cc922c9da$var$addSlice(new Uint8Array(result1));
    }
    if ($b8b53b1cc922c9da$export$c6fabfbfd097fc30(value)) return $b8b53b1cc922c9da$var$addSlice(new Uint8Array(value));
    return $b8b53b1cc922c9da$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $b8b53b1cc922c9da$export$ee1b3e54f0441b22(items) {
    var objects = items.map(function(item) {
        return $b8b53b1cc922c9da$export$3131421a7d01b4fb(item);
    });
    var length = objects.reduce(function(accum, item) {
        return accum + item.length;
    }, 0);
    var result = new Uint8Array(length);
    objects.reduce(function(offset, object) {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $b8b53b1cc922c9da$var$addSlice(result);
}
function $b8b53b1cc922c9da$export$a8f4574d0e56446c(value) {
    var result = $b8b53b1cc922c9da$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    var start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $b8b53b1cc922c9da$export$3cdc770bf8b2ed3d(value, length) {
    value = $b8b53b1cc922c9da$export$3131421a7d01b4fb(value);
    if (value.length > length) $b8b53b1cc922c9da$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    var result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $b8b53b1cc922c9da$var$addSlice(result);
}
function $b8b53b1cc922c9da$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
var $b8b53b1cc922c9da$var$HexCharacters = "0123456789abcdef";
function $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $b8b53b1cc922c9da$var$logger.checkSafeUint53(value, "invalid hexlify value");
        var hex = "";
        while(value){
            hex = $b8b53b1cc922c9da$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if ((typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($b8b53b1cc922c9da$var$isHexable(value)) return value.toHexString();
    if ($b8b53b1cc922c9da$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $b8b53b1cc922c9da$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($b8b53b1cc922c9da$export$c6fabfbfd097fc30(value)) {
        var result = "0x";
        for(var i = 0; i < value.length; i++){
            var v = value[i];
            result += $b8b53b1cc922c9da$var$HexCharacters[(v & 0xf0) >> 4] + $b8b53b1cc922c9da$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $b8b53b1cc922c9da$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $b8b53b1cc922c9da$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(data);
    else if (!$b8b53b1cc922c9da$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $b8b53b1cc922c9da$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(data);
    else if (!$b8b53b1cc922c9da$export$b02a40aff8e4ad18(data) || data.length % 2) $b8b53b1cc922c9da$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $b8b53b1cc922c9da$export$6d4b99629b38754a(items) {
    var result = "0x";
    items.forEach(function(item) {
        result += $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $b8b53b1cc922c9da$export$6916af760a341dd3(value) {
    var trimmed = $b8b53b1cc922c9da$export$967bc0082a978949($b8b53b1cc922c9da$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $b8b53b1cc922c9da$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(value);
    if (!$b8b53b1cc922c9da$export$b02a40aff8e4ad18(value)) $b8b53b1cc922c9da$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    var offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $b8b53b1cc922c9da$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(value);
    else if (!$b8b53b1cc922c9da$export$b02a40aff8e4ad18(value)) $b8b53b1cc922c9da$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $b8b53b1cc922c9da$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $b8b53b1cc922c9da$export$7fb170f1e457988f(signature) {
    var result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($b8b53b1cc922c9da$export$9a14abb1a440cd5e(signature)) {
        var bytes = $b8b53b1cc922c9da$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $b8b53b1cc922c9da$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $b8b53b1cc922c9da$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            var vs = $b8b53b1cc922c9da$export$3cdc770bf8b2ed3d($b8b53b1cc922c9da$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            var recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            var s = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            var recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$b8b53b1cc922c9da$export$b02a40aff8e4ad18(result.r)) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $b8b53b1cc922c9da$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$b8b53b1cc922c9da$export$b02a40aff8e4ad18(result.s)) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $b8b53b1cc922c9da$export$e9c46a54370b47e8(result.s, 32);
        var vs1 = $b8b53b1cc922c9da$export$3131421a7d01b4fb(result.s);
        if (vs1[0] >= 128) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs1[0] |= 0x80;
        var _vs = $b8b53b1cc922c9da$export$2b0d6b5fbe698c70(vs1);
        if (result._vs) {
            if (!$b8b53b1cc922c9da$export$b02a40aff8e4ad18(result._vs)) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $b8b53b1cc922c9da$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $b8b53b1cc922c9da$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $b8b53b1cc922c9da$export$71bb9d78a59bbe25(signature) {
    signature = $b8b53b1cc922c9da$export$7fb170f1e457988f(signature);
    return $b8b53b1cc922c9da$export$2b0d6b5fbe698c70($b8b53b1cc922c9da$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");

var $4bXmX = parcelRequire("4bXmX");


var $4780727a72442bf5$export$83d89fbfd8236492 = "bignumber/5.7.0";


"use strict";
var $3b33bab384c8baec$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($4bXmX))).BN;
var $3b33bab384c8baec$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $4780727a72442bf5$export$83d89fbfd8236492));
var $3b33bab384c8baec$var$_constructorGuard = {};
var $3b33bab384c8baec$var$MAX_SAFE = 0x1fffffffffffff;
function $3b33bab384c8baec$export$a3d0a7fa9b65683b(value) {
    return value != null && ($3b33bab384c8baec$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value) || (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) === "bigint" || (0, $b8b53b1cc922c9da$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
var $3b33bab384c8baec$var$_warnedToStringRadix = false;
var $3b33bab384c8baec$export$d97aa349ed20696 = /*#__PURE__*/ function() {
    function BigNumber(constructorGuard, hex) {
        (0, $7dKN1._)(this, BigNumber);
        if (constructorGuard !== $3b33bab384c8baec$var$_constructorGuard) $3b33bab384c8baec$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(BigNumber, [
        {
            key: "fromTwos",
            value: function fromTwos(value) {
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).fromTwos(value));
            }
        },
        {
            key: "toTwos",
            value: function toTwos(value) {
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).toTwos(value));
            }
        },
        {
            key: "abs",
            value: function abs() {
                if (this._hex[0] === "-") return BigNumber.from(this._hex.substring(1));
                return this;
            }
        },
        {
            key: "add",
            value: function add(other) {
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).add($3b33bab384c8baec$var$toBN(other)));
            }
        },
        {
            key: "sub",
            value: function sub(other) {
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).sub($3b33bab384c8baec$var$toBN(other)));
            }
        },
        {
            key: "div",
            value: function div(other) {
                var o = BigNumber.from(other);
                if (o.isZero()) $3b33bab384c8baec$var$throwFault("division-by-zero", "div");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).div($3b33bab384c8baec$var$toBN(other)));
            }
        },
        {
            key: "mul",
            value: function mul(other) {
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).mul($3b33bab384c8baec$var$toBN(other)));
            }
        },
        {
            key: "mod",
            value: function mod(other) {
                var value = $3b33bab384c8baec$var$toBN(other);
                if (value.isNeg()) $3b33bab384c8baec$var$throwFault("division-by-zero", "mod");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).umod(value));
            }
        },
        {
            key: "pow",
            value: function pow(other) {
                var value = $3b33bab384c8baec$var$toBN(other);
                if (value.isNeg()) $3b33bab384c8baec$var$throwFault("negative-power", "pow");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).pow(value));
            }
        },
        {
            key: "and",
            value: function and(other) {
                var value = $3b33bab384c8baec$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $3b33bab384c8baec$var$throwFault("unbound-bitwise-result", "and");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).and(value));
            }
        },
        {
            key: "or",
            value: function or(other) {
                var value = $3b33bab384c8baec$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $3b33bab384c8baec$var$throwFault("unbound-bitwise-result", "or");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).or(value));
            }
        },
        {
            key: "xor",
            value: function xor(other) {
                var value = $3b33bab384c8baec$var$toBN(other);
                if (this.isNegative() || value.isNeg()) $3b33bab384c8baec$var$throwFault("unbound-bitwise-result", "xor");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).xor(value));
            }
        },
        {
            key: "mask",
            value: function mask(value) {
                if (this.isNegative() || value < 0) $3b33bab384c8baec$var$throwFault("negative-width", "mask");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).maskn(value));
            }
        },
        {
            key: "shl",
            value: function shl(value) {
                if (this.isNegative() || value < 0) $3b33bab384c8baec$var$throwFault("negative-width", "shl");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).shln(value));
            }
        },
        {
            key: "shr",
            value: function shr(value) {
                if (this.isNegative() || value < 0) $3b33bab384c8baec$var$throwFault("negative-width", "shr");
                return $3b33bab384c8baec$var$toBigNumber($3b33bab384c8baec$var$toBN(this).shrn(value));
            }
        },
        {
            key: "eq",
            value: function eq(other) {
                return $3b33bab384c8baec$var$toBN(this).eq($3b33bab384c8baec$var$toBN(other));
            }
        },
        {
            key: "lt",
            value: function lt(other) {
                return $3b33bab384c8baec$var$toBN(this).lt($3b33bab384c8baec$var$toBN(other));
            }
        },
        {
            key: "lte",
            value: function lte(other) {
                return $3b33bab384c8baec$var$toBN(this).lte($3b33bab384c8baec$var$toBN(other));
            }
        },
        {
            key: "gt",
            value: function gt(other) {
                return $3b33bab384c8baec$var$toBN(this).gt($3b33bab384c8baec$var$toBN(other));
            }
        },
        {
            key: "gte",
            value: function gte(other) {
                return $3b33bab384c8baec$var$toBN(this).gte($3b33bab384c8baec$var$toBN(other));
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._hex[0] === "-";
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return $3b33bab384c8baec$var$toBN(this).isZero();
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                try {
                    return $3b33bab384c8baec$var$toBN(this).toNumber();
                } catch (error) {
                    $3b33bab384c8baec$var$throwFault("overflow", "toNumber", this.toString());
                }
                return null;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                try {
                    return BigInt(this.toString());
                } catch (e) {}
                return $3b33bab384c8baec$var$logger.throwError("this platform does not support BigInt", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    value: this.toString()
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                // Lots of people expect this, which we do not support, so check (See: #889)
                if (arguments.length > 0) {
                    if (arguments[0] === 10) {
                        if (!$3b33bab384c8baec$var$_warnedToStringRadix) {
                            $3b33bab384c8baec$var$_warnedToStringRadix = true;
                            $3b33bab384c8baec$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                        }
                    } else if (arguments[0] === 16) $3b33bab384c8baec$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
                    else $3b33bab384c8baec$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
                }
                return $3b33bab384c8baec$var$toBN(this).toString(10);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this._hex;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(key) {
                return {
                    type: "BigNumber",
                    hex: this.toHexString()
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof BigNumber) return value;
                if (typeof value === "string") {
                    if (value.match(/^-?0x[0-9a-f]+$/i)) return new BigNumber($3b33bab384c8baec$var$_constructorGuard, $3b33bab384c8baec$var$toHex(value));
                    if (value.match(/^-?[0-9]+$/)) return new BigNumber($3b33bab384c8baec$var$_constructorGuard, $3b33bab384c8baec$var$toHex(new $3b33bab384c8baec$var$BN(value)));
                    return $3b33bab384c8baec$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
                }
                if (typeof value === "number") {
                    if (value % 1) $3b33bab384c8baec$var$throwFault("underflow", "BigNumber.from", value);
                    if (value >= $3b33bab384c8baec$var$MAX_SAFE || value <= -$3b33bab384c8baec$var$MAX_SAFE) $3b33bab384c8baec$var$throwFault("overflow", "BigNumber.from", value);
                    return BigNumber.from(String(value));
                }
                var anyValue = value;
                if ((typeof anyValue === "undefined" ? "undefined" : (0, $aVMuR._)(anyValue)) === "bigint") return BigNumber.from(anyValue.toString());
                if ((0, $b8b53b1cc922c9da$export$c6fabfbfd097fc30)(anyValue)) return BigNumber.from((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(anyValue));
                if (anyValue) {
                    // Hexable interface (takes priority)
                    if (anyValue.toHexString) {
                        var hex = anyValue.toHexString();
                        if (typeof hex === "string") return BigNumber.from(hex);
                    } else {
                        // For now, handle legacy JSON-ified values (goes away in v6)
                        var hex1 = anyValue._hex;
                        // New-form JSON
                        if (hex1 == null && anyValue.type === "BigNumber") hex1 = anyValue.hex;
                        if (typeof hex1 === "string") {
                            if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(hex1) || hex1[0] === "-" && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(hex1.substring(1))) return BigNumber.from(hex1);
                        }
                    }
                }
                return $3b33bab384c8baec$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
            }
        },
        {
            key: "isBigNumber",
            value: function isBigNumber(value) {
                return !!(value && value._isBigNumber);
            }
        }
    ]);
    return BigNumber;
}();
// Normalize the hex string
function $3b33bab384c8baec$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $3b33bab384c8baec$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $3b33bab384c8baec$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $3b33bab384c8baec$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $3b33bab384c8baec$var$toBigNumber(value) {
    return $3b33bab384c8baec$export$d97aa349ed20696.from($3b33bab384c8baec$var$toHex(value));
}
function $3b33bab384c8baec$var$toBN(value) {
    var hex = $3b33bab384c8baec$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $3b33bab384c8baec$var$BN("-" + hex.substring(3), 16);
    return new $3b33bab384c8baec$var$BN(hex.substring(2), 16);
}
function $3b33bab384c8baec$var$throwFault(fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $3b33bab384c8baec$var$logger.throwError(fault, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $3b33bab384c8baec$export$51e4a08295f7770f(value) {
    return new $3b33bab384c8baec$var$BN(value, 36).toString(16);
}
function $3b33bab384c8baec$export$1293db5d29c264ff(value) {
    return new $3b33bab384c8baec$var$BN(value, 16).toString(36);
}



var $7dKN1 = parcelRequire("7dKN1");

var $aVMuR = parcelRequire("aVMuR");

var $6qu4b = parcelRequire("6qu4b");

var $d8ab39ff118d8812$export$83d89fbfd8236492 = "properties/5.7.0";


"use strict";
var $8832fb576a60463b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8832fb576a60463b$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $d8ab39ff118d8812$export$83d89fbfd8236492));
function $8832fb576a60463b$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $8832fb576a60463b$export$f695fbbf3cdaaf47(ctor, key) {
    for(var i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $8832fb576a60463b$export$d503dd157d963b60(object) {
    return $8832fb576a60463b$var$__awaiter(this, void 0, void 0, function() {
        var promises, results;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = Object.keys(object).map(function(key) {
                        var value = object[key];
                        return Promise.resolve(value).then(function(v) {
                            return {
                                key: key,
                                value: v
                            };
                        });
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(accum, result) {
                            accum[result.key] = result.value;
                            return accum;
                        }, {})
                    ];
            }
        });
    });
}
function $8832fb576a60463b$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $8832fb576a60463b$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach(function(key) {
        if (!properties[key]) $8832fb576a60463b$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $8832fb576a60463b$export$9c13236873b118a5(object) {
    var result = {};
    for(var key in object)result[key] = object[key];
    return result;
}
var $8832fb576a60463b$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $8832fb576a60463b$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $8832fb576a60463b$var$opaque[typeof object === "undefined" ? "undefined" : (0, $aVMuR._)(object)]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        var keys = Object.keys(object);
        for(var i = 0; i < keys.length; i++){
            var value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$8832fb576a60463b$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $8832fb576a60463b$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $aVMuR._)(object)), "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $8832fb576a60463b$var$_deepCopy(object) {
    if ($8832fb576a60463b$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map(function(item) {
        return $8832fb576a60463b$export$6c40052bed430212(item);
    }));
    if (typeof object === "object") {
        var result = {};
        for(var key in object){
            var value = object[key];
            if (value === undefined) continue;
            $8832fb576a60463b$export$104236534534f9be(result, key, $8832fb576a60463b$export$6c40052bed430212(value));
        }
        return result;
    }
    return $8832fb576a60463b$var$logger.throwArgumentError("Cannot deepCopy ".concat(typeof object === "undefined" ? "undefined" : (0, $aVMuR._)(object)), "object", object);
}
function $8832fb576a60463b$export$6c40052bed430212(object) {
    return $8832fb576a60463b$var$_deepCopy(object);
}
var $8832fb576a60463b$export$393edc798c47379d = function Description(info) {
    (0, $7dKN1._)(this, Description);
    for(var key in info)this[key] = $8832fb576a60463b$export$6c40052bed430212(info[key]);
};



var $3adaaf8a1b7ee32d$export$83d89fbfd8236492 = "abi/5.7.0";


"use strict";
var $cf95945b1659ac47$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $3adaaf8a1b7ee32d$export$83d89fbfd8236492));
function $cf95945b1659ac47$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    var errors = [];
    var checkErrors = function checkErrors1(path, object) {
        if (!Array.isArray(object)) return;
        for(var key in object){
            var childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
var $cf95945b1659ac47$export$2c0c39526f8bad46 = /*#__PURE__*/ function() {
    function Coder(name, type, localName, dynamic) {
        (0, $7dKN1._)(this, Coder);
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    (0, $eW5pA._)(Coder, [
        {
            key: "_throwError",
            value: function _throwError(message, value) {
                $cf95945b1659ac47$var$logger.throwArgumentError(message, this.localName, value);
            }
        }
    ]);
    return Coder;
}();
var $cf95945b1659ac47$export$d7a960146e1a269e = /*#__PURE__*/ function() {
    function Writer(wordSize) {
        (0, $7dKN1._)(this, Writer);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    (0, $eW5pA._)(Writer, [
        {
            key: "data",
            get: function get() {
                return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)(this._data);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._dataLength;
            }
        },
        {
            key: "_writeData",
            value: function _writeData(data) {
                this._data.push(data);
                this._dataLength += data.length;
                return data.length;
            }
        },
        {
            key: "appendWriter",
            value: function appendWriter(writer) {
                return this._writeData((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)(writer._data));
            }
        },
        {
            // Arrayish items; padded on the right to wordSize
            key: "writeBytes",
            value: function writeBytes(value) {
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
                var paddingOffset = bytes.length % this.wordSize;
                if (paddingOffset) bytes = (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    bytes,
                    this._padding.slice(paddingOffset)
                ]);
                return this._writeData(bytes);
            }
        },
        {
            key: "_getValue",
            value: function _getValue(value) {
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $3b33bab384c8baec$export$d97aa349ed20696).from(value));
                if (bytes.length > this.wordSize) $cf95945b1659ac47$var$logger.throwError("value out-of-bounds", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                    length: this.wordSize,
                    offset: bytes.length
                });
                if (bytes.length % this.wordSize) bytes = (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    this._padding.slice(bytes.length % this.wordSize),
                    bytes
                ]);
                return bytes;
            }
        },
        {
            // BigNumberish items; padded on the left to wordSize
            key: "writeValue",
            value: function writeValue(value) {
                return this._writeData(this._getValue(value));
            }
        },
        {
            key: "writeUpdatableValue",
            value: function writeUpdatableValue() {
                var _this = this;
                var offset = this._data.length;
                this._data.push(this._padding);
                this._dataLength += this.wordSize;
                return function(value) {
                    _this._data[offset] = _this._getValue(value);
                };
            }
        }
    ]);
    return Writer;
}();
var $cf95945b1659ac47$export$2f7a2f0e90c07dc4 = /*#__PURE__*/ function() {
    function Reader(data, wordSize, coerceFunc, allowLoose) {
        (0, $7dKN1._)(this, Reader);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_data", (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_coerceFunc", coerceFunc);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    (0, $eW5pA._)(Reader, [
        {
            key: "data",
            get: function get() {
                return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(this._data);
            }
        },
        {
            key: "consumed",
            get: function get() {
                return this._offset;
            }
        },
        {
            key: "coerce",
            value: function coerce(name, value) {
                if (this._coerceFunc) return this._coerceFunc(name, value);
                return Reader.coerce(name, value);
            }
        },
        {
            key: "_peekBytes",
            value: function _peekBytes(offset, length, loose) {
                var alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
                if (this._offset + alignedLength > this._data.length) {
                    if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
                    else $cf95945b1659ac47$var$logger.throwError("data out-of-bounds", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                        length: this._data.length,
                        offset: this._offset + alignedLength
                    });
                }
                return this._data.slice(this._offset, this._offset + alignedLength);
            }
        },
        {
            key: "subReader",
            value: function subReader(offset) {
                return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
            }
        },
        {
            key: "readBytes",
            value: function readBytes(length, loose) {
                var bytes = this._peekBytes(0, length, !!loose);
                this._offset += bytes.length;
                // @TODO: Make sure the length..end bytes are all 0?
                return bytes.slice(0, length);
            }
        },
        {
            key: "readValue",
            value: function readValue() {
                return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
            }
        }
    ], [
        {
            key: "coerce",
            value: // The default Coerce function
            function coerce(name, value) {
                var match = name.match("^u?int([0-9]+)$");
                if (match && parseInt(match[1]) <= 48) value = value.toNumber();
                return value;
            }
        }
    ]);
    return Reader;
}();


var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




"use strict";
function $aca68b720d4a692f$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($8c256eaa6070eeae$exports))).keccak_256((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data));
}


var $00af536cb1026bd9$exports = {};

$parcel$export($00af536cb1026bd9$exports, "encode", function () { return $00af536cb1026bd9$export$c564cdbbe6da493; });
$parcel$export($00af536cb1026bd9$exports, "decode", function () { return $00af536cb1026bd9$export$2f872c0f2117be69; });


var $9051d24fe43b6f45$export$83d89fbfd8236492 = "rlp/5.7.0";


"use strict";
var $00af536cb1026bd9$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $9051d24fe43b6f45$export$83d89fbfd8236492));
function $00af536cb1026bd9$var$arrayifyInteger(value) {
    var result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $00af536cb1026bd9$var$unarrayifyInteger(data, offset, length) {
    var result = 0;
    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $00af536cb1026bd9$var$_encode(object) {
    if (Array.isArray(object)) {
        var payload = [];
        object.forEach(function(child) {
            payload = payload.concat($00af536cb1026bd9$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        var length = $00af536cb1026bd9$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $b8b53b1cc922c9da$export$9a14abb1a440cd5e)(object)) $00af536cb1026bd9$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    var data = Array.prototype.slice.call((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    var length1 = $00af536cb1026bd9$var$arrayifyInteger(data.length);
    length1.unshift(0xb7 + length1.length);
    return length1.concat(data);
}
function $00af536cb1026bd9$export$c564cdbbe6da493(object) {
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)($00af536cb1026bd9$var$_encode(object));
}
function $00af536cb1026bd9$var$_decodeChildren(data, offset, childOffset, length) {
    var result = [];
    while(childOffset < offset + 1 + length){
        var decoded = $00af536cb1026bd9$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $00af536cb1026bd9$var$logger.throwError("child data too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $00af536cb1026bd9$var$_decode(data, offset) {
    if (data.length === 0) $00af536cb1026bd9$var$logger.throwError("data too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        var lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $00af536cb1026bd9$var$logger.throwError("data short segment too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var length = $00af536cb1026bd9$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $00af536cb1026bd9$var$logger.throwError("data long segment too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $00af536cb1026bd9$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        var length1 = data[offset] - 0xc0;
        if (offset + 1 + length1 > data.length) $00af536cb1026bd9$var$logger.throwError("data array too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $00af536cb1026bd9$var$_decodeChildren(data, offset, offset + 1, length1);
    } else if (data[offset] >= 0xb8) {
        var lengthLength1 = data[offset] - 0xb7;
        if (offset + 1 + lengthLength1 > data.length) $00af536cb1026bd9$var$logger.throwError("data array too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var length2 = $00af536cb1026bd9$var$unarrayifyInteger(data, offset + 1, lengthLength1);
        if (offset + 1 + lengthLength1 + length2 > data.length) $00af536cb1026bd9$var$logger.throwError("data array too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var result = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength1, offset + 1 + lengthLength1 + length2));
        return {
            consumed: 1 + lengthLength1 + length2,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        var length3 = data[offset] - 0x80;
        if (offset + 1 + length3 > data.length) $00af536cb1026bd9$var$logger.throwError("data too short", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        var result1 = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length3));
        return {
            consumed: 1 + length3,
            result: result1
        };
    }
    return {
        consumed: 1,
        result: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $00af536cb1026bd9$export$2f872c0f2117be69(data) {
    var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
    var decoded = $00af536cb1026bd9$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $00af536cb1026bd9$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



var $f2f03df9174af2d3$export$83d89fbfd8236492 = "address/5.7.0";


"use strict";
var $77ffbd0470aad2fd$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $f2f03df9174af2d3$export$83d89fbfd8236492));
function $77ffbd0470aad2fd$var$getChecksumAddress(address) {
    if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(address, 20)) $77ffbd0470aad2fd$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    var chars = address.substring(2).split("");
    var expanded = new Uint8Array(40);
    for(var i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    var hashed = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $aca68b720d4a692f$export$f8151fce47ad1c35)(expanded));
    for(var i1 = 0; i1 < 40; i1 += 2){
        if (hashed[i1 >> 1] >> 4 >= 8) chars[i1] = chars[i1].toUpperCase();
        if ((hashed[i1 >> 1] & 0x0f) >= 8) chars[i1 + 1] = chars[i1 + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
var $77ffbd0470aad2fd$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $77ffbd0470aad2fd$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
var $77ffbd0470aad2fd$var$ibanLookup = {};
for(var $77ffbd0470aad2fd$var$i = 0; $77ffbd0470aad2fd$var$i < 10; $77ffbd0470aad2fd$var$i++)$77ffbd0470aad2fd$var$ibanLookup[String($77ffbd0470aad2fd$var$i)] = String($77ffbd0470aad2fd$var$i);
for(var $77ffbd0470aad2fd$var$i1 = 0; $77ffbd0470aad2fd$var$i1 < 26; $77ffbd0470aad2fd$var$i1++)$77ffbd0470aad2fd$var$ibanLookup[String.fromCharCode(65 + $77ffbd0470aad2fd$var$i1)] = String(10 + $77ffbd0470aad2fd$var$i1);
// How many decimal digits can we process? (for 64-bit float, this is 15)
var $77ffbd0470aad2fd$var$safeDigits = Math.floor($77ffbd0470aad2fd$var$log10($77ffbd0470aad2fd$var$MAX_SAFE_INTEGER));
function $77ffbd0470aad2fd$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    var expanded = address.split("").map(function(c) {
        return $77ffbd0470aad2fd$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $77ffbd0470aad2fd$var$safeDigits){
        var block = expanded.substring(0, $77ffbd0470aad2fd$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    var checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $77ffbd0470aad2fd$export$88411125f012957a(address) {
    var result = null;
    if (typeof address !== "string") $77ffbd0470aad2fd$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $77ffbd0470aad2fd$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $77ffbd0470aad2fd$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $77ffbd0470aad2fd$var$ibanChecksum(address)) $77ffbd0470aad2fd$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $3b33bab384c8baec$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $77ffbd0470aad2fd$var$getChecksumAddress("0x" + result);
    } else $77ffbd0470aad2fd$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $77ffbd0470aad2fd$export$977e255126d763d6(address) {
    try {
        $77ffbd0470aad2fd$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $77ffbd0470aad2fd$export$962c4ddada9f668f(address) {
    var base36 = (0, $3b33bab384c8baec$export$1293db5d29c264ff)($77ffbd0470aad2fd$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $77ffbd0470aad2fd$var$ibanChecksum("XE00" + base36) + base36;
}
function $77ffbd0470aad2fd$export$b7fbffef12272e40(transaction) {
    var from = null;
    try {
        from = $77ffbd0470aad2fd$export$88411125f012957a(transaction.from);
    } catch (error) {
        $77ffbd0470aad2fd$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    var nonce = (0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $3b33bab384c8baec$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $77ffbd0470aad2fd$export$88411125f012957a((0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $00af536cb1026bd9$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $77ffbd0470aad2fd$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(salt) !== 32) $77ffbd0470aad2fd$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(initCodeHash) !== 32) $77ffbd0470aad2fd$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $77ffbd0470aad2fd$export$88411125f012957a((0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        "0xff",
        $77ffbd0470aad2fd$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}







var $8d353730745bec22$export$83d89fbfd8236492 = "strings/5.7.0";


"use strict";
var $4d583f407d5b3d1a$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $8d353730745bec22$export$83d89fbfd8236492));
var $4d583f407d5b3d1a$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($4d583f407d5b3d1a$export$c6986442964129f5 || ($4d583f407d5b3d1a$export$c6986442964129f5 = {}));
var $4d583f407d5b3d1a$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($4d583f407d5b3d1a$export$c285fa6ac15ff6a6 || ($4d583f407d5b3d1a$export$c285fa6ac15ff6a6 = {}));
function $4d583f407d5b3d1a$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $4d583f407d5b3d1a$var$logger.throwArgumentError("invalid codepoint at offset ".concat(offset, "; ").concat(reason), "bytes", bytes);
}
function $4d583f407d5b3d1a$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $4d583f407d5b3d1a$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $4d583f407d5b3d1a$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        var i = 0;
        for(var o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $4d583f407d5b3d1a$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $4d583f407d5b3d1a$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $4d583f407d5b3d1a$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $4d583f407d5b3d1a$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
var $4d583f407d5b3d1a$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $4d583f407d5b3d1a$var$errorFunc,
    ignore: $4d583f407d5b3d1a$var$ignoreFunc,
    replace: $4d583f407d5b3d1a$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $4d583f407d5b3d1a$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $4d583f407d5b3d1a$export$c6e2180c5bb5bc05.error;
    bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(bytes);
    var result = [];
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($4d583f407d5b3d1a$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $4d583f407d5b3d1a$export$8feeb310b4b4752f(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4d583f407d5b3d1a$export$c6986442964129f5.current;
    if (form != $4d583f407d5b3d1a$export$c6986442964129f5.current) {
        $4d583f407d5b3d1a$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            var pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(result);
}
function $4d583f407d5b3d1a$var$escapeChar(value) {
    var hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $4d583f407d5b3d1a$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $4d583f407d5b3d1a$var$getUtf8CodePoints(bytes, onError).map(function(codePoint) {
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $4d583f407d5b3d1a$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $4d583f407d5b3d1a$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $4d583f407d5b3d1a$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $4d583f407d5b3d1a$export$232e1dab03132235(codePoints) {
    return codePoints.map(function(codePoint) {
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $4d583f407d5b3d1a$export$7643a1dc2c38d5eb(bytes, onError) {
    return $4d583f407d5b3d1a$export$232e1dab03132235($4d583f407d5b3d1a$var$getUtf8CodePoints(bytes, onError));
}
function $4d583f407d5b3d1a$export$ae470a36a31b28c2(str) {
    var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4d583f407d5b3d1a$export$c6986442964129f5.current;
    return $4d583f407d5b3d1a$var$getUtf8CodePoints($4d583f407d5b3d1a$export$8feeb310b4b4752f(str, form));
}


function $c31b68ebaa2e080f$export$d560c7e4a29451c2(text) {
    return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(text));
}





var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");






var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



"use strict";
var $b376794181708ebf$export$59dbbded7775bfe7 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(AddressCoder, Coder);
    var _super = (0, $hKD8n._)(AddressCoder);
    function AddressCoder(localName) {
        (0, $7dKN1._)(this, AddressCoder);
        return _super.call(this, "address", "address", localName, false);
    }
    (0, $eW5pA._)(AddressCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                try {
                    value = (0, $77ffbd0470aad2fd$export$88411125f012957a)(value);
                } catch (error) {
                    this._throwError(error.message, value);
                }
                return writer.writeValue(value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $77ffbd0470aad2fd$export$88411125f012957a)((0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
            }
        }
    ]);
    return AddressCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

"use strict";
var $21679343b94b547e$export$87c41d1139a03fa2 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(AnonymousCoder, Coder);
    var _super = (0, $hKD8n._)(AnonymousCoder);
    function AnonymousCoder(coder) {
        (0, $7dKN1._)(this, AnonymousCoder);
        var _this;
        _this = _super.call(this, coder.name, coder.type, undefined, coder.dynamic);
        _this.coder = coder;
        return _this;
    }
    (0, $eW5pA._)(AnonymousCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return this.coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return this.coder.encode(writer, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return this.coder.decode(reader);
            }
        }
    ]);
    return AnonymousCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));


"use strict";
var $7b72d058ca04ba74$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $3adaaf8a1b7ee32d$export$83d89fbfd8236492));
function $7b72d058ca04ba74$export$2a703dbb0cb35339(writer, coders, values) {
    var arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        var unique = {};
        arrayValues = coders.map(function(coder) {
            var name = coder.localName;
            if (!name) $7b72d058ca04ba74$var$logger.throwError("cannot encode object for signature with missing names", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $7b72d058ca04ba74$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $7b72d058ca04ba74$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $7b72d058ca04ba74$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    var staticWriter = new (0, $cf95945b1659ac47$export$d7a960146e1a269e)(writer.wordSize);
    var dynamicWriter = new (0, $cf95945b1659ac47$export$d7a960146e1a269e)(writer.wordSize);
    var updateFuncs = [];
    coders.forEach(function(coder, index) {
        var value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            var dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            var updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push(function(baseOffset) {
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach(function(func) {
        func(staticWriter.length);
    });
    var length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $7b72d058ca04ba74$export$417857010dc9287f(reader, coders) {
    var _loop = function(i) {
        var value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
    };
    var values = [];
    // A reader anchored to this base
    var baseReader = reader.subReader(0);
    coders.forEach(function(coder) {
        var value = null;
        if (coder.dynamic) {
            var offset = reader.readValue();
            var offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    var uniqueNames = coders.reduce(function(accum, coder) {
        var name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach(function(coder, index) {
        var name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        var value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: function() {
                throw value;
            }
        });
        else values[name] = value;
    });
    for(var i = 0; i < values.length; i++)_loop(i);
    return Object.freeze(values);
}
var $7b72d058ca04ba74$export$88bc419d2df11f54 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(ArrayCoder, Coder);
    var _super = (0, $hKD8n._)(ArrayCoder);
    function ArrayCoder(coder, length, localName) {
        (0, $7dKN1._)(this, ArrayCoder);
        var _this;
        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        var dynamic = length === -1 || coder.dynamic;
        _this = _super.call(this, "array", type, localName, dynamic);
        _this.coder = coder;
        _this.length = length;
        return _this;
    }
    (0, $eW5pA._)(ArrayCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                // Verifies the child coder is valid (even if the array is dynamic or 0-length)
                var defaultChild = this.coder.defaultValue();
                var result = [];
                for(var i = 0; i < this.length; i++)result.push(defaultChild);
                return result;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (!Array.isArray(value)) this._throwError("expected array value", value);
                var count = this.length;
                if (count === -1) {
                    count = value.length;
                    writer.writeValue(value.length);
                }
                $7b72d058ca04ba74$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
                var coders = [];
                for(var i = 0; i < value.length; i++)coders.push(this.coder);
                return $7b72d058ca04ba74$export$2a703dbb0cb35339(writer, coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var count = this.length;
                if (count === -1) {
                    count = reader.readValue().toNumber();
                    // Check that there is *roughly* enough data to ensure
                    // stray random data is not being read as a length. Each
                    // slot requires at least 32 bytes for their value (or 32
                    // bytes as a link to the data). This could use a much
                    // tighter bound, but we are erroring on the side of safety.
                    if (count * 32 > reader._data.length) $7b72d058ca04ba74$var$logger.throwError("insufficient data length", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                        length: reader._data.length,
                        count: count
                    });
                }
                var coders = [];
                for(var i = 0; i < count; i++)coders.push(new (0, $21679343b94b547e$export$87c41d1139a03fa2)(this.coder));
                return reader.coerce(this.name, $7b72d058ca04ba74$export$417857010dc9287f(reader, coders));
            }
        }
    ]);
    return ArrayCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

"use strict";
var $77ea31ea68c05bab$export$fe9118d6c093150c = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(BooleanCoder, Coder);
    var _super = (0, $hKD8n._)(BooleanCoder);
    function BooleanCoder(localName) {
        (0, $7dKN1._)(this, BooleanCoder);
        return _super.call(this, "bool", "bool", localName, false);
    }
    (0, $eW5pA._)(BooleanCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return false;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return writer.writeValue(value ? 1 : 0);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.type, !reader.readValue().isZero());
            }
        }
    ]);
    return BooleanCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $ed84c647d4e296a1$export$db9eadd8df12ad2e = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(DynamicBytesCoder, Coder);
    var _super = (0, $hKD8n._)(DynamicBytesCoder);
    function DynamicBytesCoder(type, localName) {
        (0, $7dKN1._)(this, DynamicBytesCoder);
        return _super.call(this, type, type, localName, true);
    }
    (0, $eW5pA._)(DynamicBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                value = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
                var length = writer.writeValue(value.length);
                length += writer.writeBytes(value);
                return length;
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.readBytes(reader.readValue().toNumber(), true);
            }
        }
    ]);
    return DynamicBytesCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));
var $ed84c647d4e296a1$export$e5823e9574df18d2 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $cgJ2Y._)(BytesCoder, DynamicBytesCoder);
    var _super = (0, $hKD8n._)(BytesCoder);
    function BytesCoder(localName) {
        (0, $7dKN1._)(this, BytesCoder);
        return _super.call(this, "bytes", localName);
    }
    (0, $eW5pA._)(BytesCoder, [
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $2Nfql._)((0, $fG73q._)(BytesCoder.prototype), "decode", this).call(this, reader)));
            }
        }
    ]);
    return BytesCoder;
}($ed84c647d4e296a1$export$db9eadd8df12ad2e);



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $d1ba9ee8495b4e5a$export$7dec9db68e6bcf5a = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(FixedBytesCoder, Coder);
    var _super = (0, $hKD8n._)(FixedBytesCoder);
    function FixedBytesCoder(size, localName) {
        (0, $7dKN1._)(this, FixedBytesCoder);
        var _this;
        var name = "bytes" + String(size);
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        return _this;
    }
    (0, $eW5pA._)(FixedBytesCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var data = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
                if (data.length !== this.size) this._throwError("incorrect data length", value);
                return writer.writeBytes(data);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
            }
        }
    ]);
    return FixedBytesCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

"use strict";
var $68545ba475a93f08$export$70982cadf2d6b4ec = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(NullCoder, Coder);
    var _super = (0, $hKD8n._)(NullCoder);
    function NullCoder(localName) {
        (0, $7dKN1._)(this, NullCoder);
        return _super.call(this, "null", "", localName, false);
    }
    (0, $eW5pA._)(NullCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return null;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                if (value != null) this._throwError("not null", value);
                return writer.writeBytes([]);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                reader.readBytes(0);
                return reader.coerce(this.name, null);
            }
        }
    ]);
    return NullCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


var $90f483a28c97692a$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from(-1);
var $90f483a28c97692a$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from(0);
var $90f483a28c97692a$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from(1);
var $90f483a28c97692a$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from(2);
var $90f483a28c97692a$export$c8db55bd7405209e = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from("1000000000000000000");
var $90f483a28c97692a$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var $90f483a28c97692a$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
var $90f483a28c97692a$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $3b33bab384c8baec$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
var $c1ecc9ee28098200$export$b934dc8cfe13938c = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(NumberCoder, Coder);
    var _super = (0, $hKD8n._)(NumberCoder);
    function NumberCoder(size, signed, localName) {
        (0, $7dKN1._)(this, NumberCoder);
        var _this;
        var name = (signed ? "int" : "uint") + size * 8;
        _this = _super.call(this, name, name, localName, false);
        _this.size = size;
        _this.signed = signed;
        return _this;
    }
    (0, $eW5pA._)(NumberCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return 0;
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                var v = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
                // Check bounds are safe for encoding
                var maxUintValue = (0, $90f483a28c97692a$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
                if (this.signed) {
                    var bounds = maxUintValue.mask(this.size * 8 - 1);
                    if (v.gt(bounds) || v.lt(bounds.add((0, $90f483a28c97692a$export$9aa05a5866350bcf)).mul((0, $90f483a28c97692a$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
                } else if (v.lt((0, $90f483a28c97692a$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
                v = v.toTwos(this.size * 8).mask(this.size * 8);
                if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
                return writer.writeValue(v);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                var value = reader.readValue().mask(this.size * 8);
                if (this.signed) value = value.fromTwos(this.size * 8);
                return reader.coerce(this.name, value);
            }
        }
    ]);
    return NumberCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $7c35d76786a73a12$export$2d1b854518731426 = /*#__PURE__*/ function(DynamicBytesCoder) {
    (0, $cgJ2Y._)(StringCoder, DynamicBytesCoder);
    var _super = (0, $hKD8n._)(StringCoder);
    function StringCoder(localName) {
        (0, $7dKN1._)(this, StringCoder);
        return _super.call(this, "string", localName);
    }
    (0, $eW5pA._)(StringCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                return "";
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $2Nfql._)((0, $fG73q._)(StringCoder.prototype), "encode", this).call(this, writer, (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(value));
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return (0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)((0, $2Nfql._)((0, $fG73q._)(StringCoder.prototype), "decode", this).call(this, reader));
            }
        }
    ]);
    return StringCoder;
}((0, $ed84c647d4e296a1$export$db9eadd8df12ad2e));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");


"use strict";
var $dc829b354b83351f$export$e9fceba8f110fea6 = /*#__PURE__*/ function(Coder) {
    (0, $cgJ2Y._)(TupleCoder, Coder);
    var _super = (0, $hKD8n._)(TupleCoder);
    function TupleCoder(coders, localName) {
        (0, $7dKN1._)(this, TupleCoder);
        var _this;
        var dynamic = false;
        var types = [];
        coders.forEach(function(coder) {
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        var type = "tuple(" + types.join(",") + ")";
        _this = _super.call(this, "tuple", type, localName, dynamic);
        _this.coders = coders;
        return _this;
    }
    (0, $eW5pA._)(TupleCoder, [
        {
            key: "defaultValue",
            value: function defaultValue() {
                var values = [];
                this.coders.forEach(function(coder) {
                    values.push(coder.defaultValue());
                });
                // We only output named properties for uniquely named coders
                var uniqueNames = this.coders.reduce(function(accum, coder) {
                    var name = coder.localName;
                    if (name) {
                        if (!accum[name]) accum[name] = 0;
                        accum[name]++;
                    }
                    return accum;
                }, {});
                // Add named values
                this.coders.forEach(function(coder, index) {
                    var name = coder.localName;
                    if (!name || uniqueNames[name] !== 1) return;
                    if (name === "length") name = "_length";
                    if (values[name] != null) return;
                    values[name] = values[index];
                });
                return Object.freeze(values);
            }
        },
        {
            key: "encode",
            value: function encode(writer, value) {
                return (0, $7b72d058ca04ba74$export$2a703dbb0cb35339)(writer, this.coders, value);
            }
        },
        {
            key: "decode",
            value: function decode(reader) {
                return reader.coerce(this.name, (0, $7b72d058ca04ba74$export$417857010dc9287f)(reader, this.coders));
            }
        }
    ]);
    return TupleCoder;
}((0, $cf95945b1659ac47$export$2c0c39526f8bad46));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




"use strict";
var $7978476fda259c54$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $3adaaf8a1b7ee32d$export$83d89fbfd8236492));
var $7978476fda259c54$var$_constructorGuard = {};
var $7978476fda259c54$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
var $7978476fda259c54$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $7978476fda259c54$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($7978476fda259c54$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($7978476fda259c54$var$ModifiersNest[name]) return true;
    }
    if ($7978476fda259c54$var$ModifiersBytes[name] || name === "payable") $7978476fda259c54$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $7978476fda259c54$var$parseParamType(param, allowIndexed) {
    var originalParam = param;
    function throwError(i) {
        $7978476fda259c54$var$logger.throwArgumentError("unexpected character at position ".concat(i), "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        var node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    var parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    var node = parent;
    for(var i = 0; i < param.length; i++){
        var c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $7978476fda259c54$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($7978476fda259c54$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $7978476fda259c54$var$verifyType(node.type);
                var child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($7978476fda259c54$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $7978476fda259c54$var$verifyType(node.type);
                var sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $7978476fda259c54$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($7978476fda259c54$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $7978476fda259c54$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($7978476fda259c54$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $7978476fda259c54$var$verifyType(parent.type);
    return parent;
}
function $7978476fda259c54$var$populate(object, params) {
    for(var key in params)(0, $8832fb576a60463b$export$104236534534f9be)(object, key, params[key]);
}
var $7978476fda259c54$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
var $7978476fda259c54$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
var $7978476fda259c54$export$426dc07f493a4c47 = /*#__PURE__*/ function() {
    function ParamType(constructorGuard, params) {
        (0, $7dKN1._)(this, ParamType);
        if (constructorGuard !== $7978476fda259c54$var$_constructorGuard) $7978476fda259c54$var$logger.throwError("use fromString", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $7978476fda259c54$var$populate(this, params);
        var match = this.type.match($7978476fda259c54$var$paramTypeArray);
        if (match) $7978476fda259c54$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: ParamType.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $7978476fda259c54$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(ParamType, [
        {
            // Format the parameter fragment
            //   - sighash: "(uint256,address)"
            //   - minimal: "tuple(uint256,address) indexed"
            //   - full:    "tuple(uint256 foo, address bar) indexed baz"
            key: "format",
            value: function format(format) {
                if (!format) format = $7978476fda259c54$export$f010f239efc4d445.sighash;
                if (!$7978476fda259c54$export$f010f239efc4d445[format]) $7978476fda259c54$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $7978476fda259c54$export$f010f239efc4d445.json) {
                    var result = {
                        type: this.baseType === "tuple" ? "tuple" : this.type,
                        name: this.name || undefined
                    };
                    if (typeof this.indexed === "boolean") result.indexed = this.indexed;
                    if (this.components) result.components = this.components.map(function(comp) {
                        return JSON.parse(comp.format(format));
                    });
                    return JSON.stringify(result);
                }
                var result1 = "";
                // Array
                if (this.baseType === "array") {
                    result1 += this.arrayChildren.format(format);
                    result1 += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
                } else if (this.baseType === "tuple") {
                    if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) result1 += this.type;
                    result1 += "(" + this.components.map(function(comp) {
                        return comp.format(format);
                    }).join(format === $7978476fda259c54$export$f010f239efc4d445.full ? ", " : ",") + ")";
                } else result1 += this.type;
                if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) {
                    if (this.indexed === true) result1 += " indexed";
                    if (format === $7978476fda259c54$export$f010f239efc4d445.full && this.name) result1 += " " + this.name;
                }
                return result1;
            }
        }
    ], [
        {
            key: "from",
            value: function from(value, allowIndexed) {
                if (typeof value === "string") return ParamType.fromString(value, allowIndexed);
                return ParamType.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ParamType.isParamType(value)) return value;
                return new ParamType($7978476fda259c54$var$_constructorGuard, {
                    name: value.name || null,
                    type: $7978476fda259c54$var$verifyType(value.type),
                    indexed: value.indexed == null ? null : !!value.indexed,
                    components: value.components ? value.components.map(ParamType.fromObject) : null
                });
            }
        },
        {
            key: "fromString",
            value: function fromString(value, allowIndexed) {
                function ParamTypify(node) {
                    return ParamType.fromObject({
                        name: node.name,
                        type: node.type,
                        indexed: node.indexed,
                        components: node.components
                    });
                }
                return ParamTypify($7978476fda259c54$var$parseParamType(value, !!allowIndexed));
            }
        },
        {
            key: "isParamType",
            value: function isParamType(value) {
                return !!(value != null && value._isParamType);
            }
        }
    ]);
    return ParamType;
}();
function $7978476fda259c54$var$parseParams(value, allowIndex) {
    return $7978476fda259c54$var$splitNesting(value).map(function(param) {
        return $7978476fda259c54$export$426dc07f493a4c47.fromString(param, allowIndex);
    });
}
var $7978476fda259c54$export$ffb0004e005737fa = /*#__PURE__*/ function() {
    function Fragment(constructorGuard, params) {
        (0, $7dKN1._)(this, Fragment);
        if (constructorGuard !== $7978476fda259c54$var$_constructorGuard) $7978476fda259c54$var$logger.throwError("use a static from method", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $7978476fda259c54$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(Fragment, null, [
        {
            key: "from",
            value: function from(value) {
                if (Fragment.isFragment(value)) return value;
                if (typeof value === "string") return Fragment.fromString(value);
                return Fragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (Fragment.isFragment(value)) return value;
                switch(value.type){
                    case "function":
                        return $7978476fda259c54$export$8d576c928b93668f.fromObject(value);
                    case "event":
                        return $7978476fda259c54$export$958548f08bac2833.fromObject(value);
                    case "constructor":
                        return $7978476fda259c54$export$3ac5c9504f801ea4.fromObject(value);
                    case "error":
                        return $7978476fda259c54$export$2c42c6d543aa9b59.fromObject(value);
                    case "fallback":
                    case "receive":
                        // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                        return null;
                }
                return $7978476fda259c54$var$logger.throwArgumentError("invalid fragment object", "value", value);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
                value = value.replace(/\s/g, " ");
                value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
                value = value.trim();
                if (value.split(" ")[0] === "event") return $7978476fda259c54$export$958548f08bac2833.fromString(value.substring(5).trim());
                else if (value.split(" ")[0] === "function") return $7978476fda259c54$export$8d576c928b93668f.fromString(value.substring(8).trim());
                else if (value.split("(")[0].trim() === "constructor") return $7978476fda259c54$export$3ac5c9504f801ea4.fromString(value.trim());
                else if (value.split(" ")[0] === "error") return $7978476fda259c54$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
                return $7978476fda259c54$var$logger.throwArgumentError("unsupported fragment", "value", value);
            }
        },
        {
            key: "isFragment",
            value: function isFragment(value) {
                return !!(value && value._isFragment);
            }
        }
    ]);
    return Fragment;
}();
var $7978476fda259c54$export$958548f08bac2833 = /*#__PURE__*/ function(Fragment) {
    (0, $cgJ2Y._)(EventFragment, Fragment);
    var _super = (0, $hKD8n._)(EventFragment);
    function EventFragment() {
        (0, $7dKN1._)(this, EventFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(EventFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $7978476fda259c54$export$f010f239efc4d445.sighash;
                if (!$7978476fda259c54$export$f010f239efc4d445[format]) $7978476fda259c54$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $7978476fda259c54$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "event",
                    anonymous: this.anonymous,
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) result += "event ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $7978476fda259c54$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) {
                    if (this.anonymous) result += "anonymous ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return EventFragment.fromString(value);
                return EventFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (EventFragment.isEventFragment(value)) return value;
                if (value.type !== "event") $7978476fda259c54$var$logger.throwArgumentError("invalid event object", "value", value);
                var params = {
                    name: $7978476fda259c54$var$verifyIdentifier(value.name),
                    anonymous: value.anonymous,
                    inputs: value.inputs ? value.inputs.map($7978476fda259c54$export$426dc07f493a4c47.fromObject) : [],
                    type: "event"
                };
                return new EventFragment($7978476fda259c54$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var match = value.match($7978476fda259c54$var$regexParen);
                if (!match) $7978476fda259c54$var$logger.throwArgumentError("invalid event string", "value", value);
                var anonymous = false;
                match[3].split(" ").forEach(function(modifier) {
                    switch(modifier.trim()){
                        case "anonymous":
                            anonymous = true;
                            break;
                        case "":
                            break;
                        default:
                            $7978476fda259c54$var$logger.warn("unknown modifier: " + modifier);
                    }
                });
                return EventFragment.fromObject({
                    name: match[1].trim(),
                    anonymous: anonymous,
                    inputs: $7978476fda259c54$var$parseParams(match[2], true),
                    type: "event"
                });
            }
        },
        {
            key: "isEventFragment",
            value: function isEventFragment(value) {
                return value && value._isFragment && value.type === "event";
            }
        }
    ]);
    return EventFragment;
}($7978476fda259c54$export$ffb0004e005737fa);
function $7978476fda259c54$var$parseGas(value, params) {
    params.gas = null;
    var comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $7978476fda259c54$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $7978476fda259c54$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $7978476fda259c54$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach(function(modifier) {
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $7978476fda259c54$var$verifyState(value) {
    var result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $7978476fda259c54$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $7978476fda259c54$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $7978476fda259c54$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $7978476fda259c54$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $7978476fda259c54$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
var $7978476fda259c54$export$3ac5c9504f801ea4 = /*#__PURE__*/ function(Fragment) {
    (0, $cgJ2Y._)(ConstructorFragment, Fragment);
    var _super = (0, $hKD8n._)(ConstructorFragment);
    function ConstructorFragment() {
        (0, $7dKN1._)(this, ConstructorFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(ConstructorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $7978476fda259c54$export$f010f239efc4d445.sighash;
                if (!$7978476fda259c54$export$f010f239efc4d445[format]) $7978476fda259c54$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $7978476fda259c54$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "constructor",
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                if (format === $7978476fda259c54$export$f010f239efc4d445.sighash) $7978476fda259c54$var$logger.throwError("cannot format a constructor for sighash", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "format(sighash)"
                });
                var result = "constructor(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $7978476fda259c54$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ConstructorFragment.fromString(value);
                return ConstructorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ConstructorFragment.isConstructorFragment(value)) return value;
                if (value.type !== "constructor") $7978476fda259c54$var$logger.throwArgumentError("invalid constructor object", "value", value);
                var state = $7978476fda259c54$var$verifyState(value);
                if (state.constant) $7978476fda259c54$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
                var params = {
                    name: null,
                    type: value.type,
                    inputs: value.inputs ? value.inputs.map($7978476fda259c54$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value.gas) : null
                };
                return new ConstructorFragment($7978476fda259c54$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "constructor"
                };
                value = $7978476fda259c54$var$parseGas(value, params);
                var parens = value.match($7978476fda259c54$var$regexParen);
                if (!parens || parens[1].trim() !== "constructor") $7978476fda259c54$var$logger.throwArgumentError("invalid constructor string", "value", value);
                params.inputs = $7978476fda259c54$var$parseParams(parens[2].trim(), false);
                $7978476fda259c54$var$parseModifiers(parens[3].trim(), params);
                return ConstructorFragment.fromObject(params);
            }
        },
        {
            key: "isConstructorFragment",
            value: function isConstructorFragment(value) {
                return value && value._isFragment && value.type === "constructor";
            }
        }
    ]);
    return ConstructorFragment;
}($7978476fda259c54$export$ffb0004e005737fa);
var $7978476fda259c54$export$8d576c928b93668f = /*#__PURE__*/ function(ConstructorFragment) {
    (0, $cgJ2Y._)(FunctionFragment, ConstructorFragment);
    var _super = (0, $hKD8n._)(FunctionFragment);
    function FunctionFragment() {
        (0, $7dKN1._)(this, FunctionFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(FunctionFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $7978476fda259c54$export$f010f239efc4d445.sighash;
                if (!$7978476fda259c54$export$f010f239efc4d445[format]) $7978476fda259c54$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $7978476fda259c54$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "function",
                    name: this.name,
                    constant: this.constant,
                    stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
                    payable: this.payable,
                    gas: this.gas ? this.gas.toNumber() : undefined,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    }),
                    outputs: this.outputs.map(function(output) {
                        return JSON.parse(output.format(format));
                    })
                });
                var result = "";
                if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) result += "function ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $7978476fda259c54$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) {
                    if (this.stateMutability) {
                        if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
                    } else if (this.constant) result += "view ";
                    if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map(function(output) {
                        return output.format(format);
                    }).join(", ") + ") ";
                    if (this.gas != null) result += "@" + this.gas.toString() + " ";
                }
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return FunctionFragment.fromString(value);
                return FunctionFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (FunctionFragment.isFunctionFragment(value)) return value;
                if (value.type !== "function") $7978476fda259c54$var$logger.throwArgumentError("invalid function object", "value", value);
                var state = $7978476fda259c54$var$verifyState(value);
                var params = {
                    type: value.type,
                    name: $7978476fda259c54$var$verifyIdentifier(value.name),
                    constant: state.constant,
                    inputs: value.inputs ? value.inputs.map($7978476fda259c54$export$426dc07f493a4c47.fromObject) : [],
                    outputs: value.outputs ? value.outputs.map($7978476fda259c54$export$426dc07f493a4c47.fromObject) : [],
                    payable: state.payable,
                    stateMutability: state.stateMutability,
                    gas: value.gas ? (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value.gas) : null
                };
                return new FunctionFragment($7978476fda259c54$var$_constructorGuard, params);
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "function"
                };
                value = $7978476fda259c54$var$parseGas(value, params);
                var comps = value.split(" returns ");
                if (comps.length > 2) $7978476fda259c54$var$logger.throwArgumentError("invalid function string", "value", value);
                var parens = comps[0].match($7978476fda259c54$var$regexParen);
                if (!parens) $7978476fda259c54$var$logger.throwArgumentError("invalid function signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $7978476fda259c54$var$verifyIdentifier(params.name);
                params.inputs = $7978476fda259c54$var$parseParams(parens[2], false);
                $7978476fda259c54$var$parseModifiers(parens[3].trim(), params);
                // We have outputs
                if (comps.length > 1) {
                    var returns = comps[1].match($7978476fda259c54$var$regexParen);
                    if (returns[1].trim() != "" || returns[3].trim() != "") $7978476fda259c54$var$logger.throwArgumentError("unexpected tokens", "value", value);
                    params.outputs = $7978476fda259c54$var$parseParams(returns[2], false);
                } else params.outputs = [];
                return FunctionFragment.fromObject(params);
            }
        },
        {
            key: "isFunctionFragment",
            value: function isFunctionFragment(value) {
                return value && value._isFragment && value.type === "function";
            }
        }
    ]);
    return FunctionFragment;
}($7978476fda259c54$export$3ac5c9504f801ea4);
//export class StructFragment extends Fragment {
//}
function $7978476fda259c54$var$checkForbidden(fragment) {
    var sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $7978476fda259c54$var$logger.throwArgumentError("cannot specify user defined ".concat(sig, " error"), "fragment", fragment);
    return fragment;
}
var $7978476fda259c54$export$2c42c6d543aa9b59 = /*#__PURE__*/ function(Fragment) {
    (0, $cgJ2Y._)(ErrorFragment, Fragment);
    var _super = (0, $hKD8n._)(ErrorFragment);
    function ErrorFragment() {
        (0, $7dKN1._)(this, ErrorFragment);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(ErrorFragment, [
        {
            key: "format",
            value: function format(format) {
                if (!format) format = $7978476fda259c54$export$f010f239efc4d445.sighash;
                if (!$7978476fda259c54$export$f010f239efc4d445[format]) $7978476fda259c54$var$logger.throwArgumentError("invalid format type", "format", format);
                if (format === $7978476fda259c54$export$f010f239efc4d445.json) return JSON.stringify({
                    type: "error",
                    name: this.name,
                    inputs: this.inputs.map(function(input) {
                        return JSON.parse(input.format(format));
                    })
                });
                var result = "";
                if (format !== $7978476fda259c54$export$f010f239efc4d445.sighash) result += "error ";
                result += this.name + "(" + this.inputs.map(function(input) {
                    return input.format(format);
                }).join(format === $7978476fda259c54$export$f010f239efc4d445.full ? ", " : ",") + ") ";
                return result.trim();
            }
        }
    ], [
        {
            key: "from",
            value: function from(value) {
                if (typeof value === "string") return ErrorFragment.fromString(value);
                return ErrorFragment.fromObject(value);
            }
        },
        {
            key: "fromObject",
            value: function fromObject(value) {
                if (ErrorFragment.isErrorFragment(value)) return value;
                if (value.type !== "error") $7978476fda259c54$var$logger.throwArgumentError("invalid error object", "value", value);
                var params = {
                    type: value.type,
                    name: $7978476fda259c54$var$verifyIdentifier(value.name),
                    inputs: value.inputs ? value.inputs.map($7978476fda259c54$export$426dc07f493a4c47.fromObject) : []
                };
                return $7978476fda259c54$var$checkForbidden(new ErrorFragment($7978476fda259c54$var$_constructorGuard, params));
            }
        },
        {
            key: "fromString",
            value: function fromString(value) {
                var params = {
                    type: "error"
                };
                var parens = value.match($7978476fda259c54$var$regexParen);
                if (!parens) $7978476fda259c54$var$logger.throwArgumentError("invalid error signature", "value", value);
                params.name = parens[1].trim();
                if (params.name) $7978476fda259c54$var$verifyIdentifier(params.name);
                params.inputs = $7978476fda259c54$var$parseParams(parens[2], false);
                return $7978476fda259c54$var$checkForbidden(ErrorFragment.fromObject(params));
            }
        },
        {
            key: "isErrorFragment",
            value: function isErrorFragment(value) {
                return value && value._isFragment && value.type === "error";
            }
        }
    ]);
    return ErrorFragment;
}($7978476fda259c54$export$ffb0004e005737fa);
function $7978476fda259c54$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
var $7978476fda259c54$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $7978476fda259c54$var$verifyIdentifier(value) {
    if (!value || !value.match($7978476fda259c54$var$regexIdentifier)) $7978476fda259c54$var$logger.throwArgumentError('invalid identifier "'.concat(value, '"'), "value", value);
    return value;
}
var $7978476fda259c54$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $7978476fda259c54$var$splitNesting(value) {
    value = value.trim();
    var result = [];
    var accum = "";
    var depth = 0;
    for(var offset = 0; offset < value.length; offset++){
        var c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $7978476fda259c54$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
var $5b4960d4c3b0981f$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $3adaaf8a1b7ee32d$export$83d89fbfd8236492));
var $5b4960d4c3b0981f$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var $5b4960d4c3b0981f$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var $5b4960d4c3b0981f$export$fe041e1a83d3efc6 = /*#__PURE__*/ function() {
    function AbiCoder(coerceFunc) {
        (0, $7dKN1._)(this, AbiCoder);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "coerceFunc", coerceFunc || null);
    }
    (0, $eW5pA._)(AbiCoder, [
        {
            key: "_getCoder",
            value: function _getCoder(param) {
                var _this = this;
                switch(param.baseType){
                    case "address":
                        return new (0, $b376794181708ebf$export$59dbbded7775bfe7)(param.name);
                    case "bool":
                        return new (0, $77ea31ea68c05bab$export$fe9118d6c093150c)(param.name);
                    case "string":
                        return new (0, $7c35d76786a73a12$export$2d1b854518731426)(param.name);
                    case "bytes":
                        return new (0, $ed84c647d4e296a1$export$e5823e9574df18d2)(param.name);
                    case "array":
                        return new (0, $7b72d058ca04ba74$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
                    case "tuple":
                        return new (0, $dc829b354b83351f$export$e9fceba8f110fea6)((param.components || []).map(function(component) {
                            return _this._getCoder(component);
                        }), param.name);
                    case "":
                        return new (0, $68545ba475a93f08$export$70982cadf2d6b4ec)(param.name);
                }
                // u?int[0-9]*
                var match = param.type.match($5b4960d4c3b0981f$var$paramTypeNumber);
                if (match) {
                    var size = parseInt(match[2] || "256");
                    if (size === 0 || size > 256 || size % 8 !== 0) $5b4960d4c3b0981f$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
                    return new (0, $c1ecc9ee28098200$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
                }
                // bytes[0-9]+
                match = param.type.match($5b4960d4c3b0981f$var$paramTypeBytes);
                if (match) {
                    var size1 = parseInt(match[1]);
                    if (size1 === 0 || size1 > 32) $5b4960d4c3b0981f$var$logger.throwArgumentError("invalid bytes length", "param", param);
                    return new (0, $d1ba9ee8495b4e5a$export$7dec9db68e6bcf5a)(size1, param.name);
                }
                return $5b4960d4c3b0981f$var$logger.throwArgumentError("invalid type", "type", param.type);
            }
        },
        {
            key: "_getWordSize",
            value: function _getWordSize() {
                return 32;
            }
        },
        {
            key: "_getReader",
            value: function _getReader(data, allowLoose) {
                return new (0, $cf95945b1659ac47$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
            }
        },
        {
            key: "_getWriter",
            value: function _getWriter() {
                return new (0, $cf95945b1659ac47$export$d7a960146e1a269e)(this._getWordSize());
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue(types) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $7978476fda259c54$export$426dc07f493a4c47).from(type));
                });
                var coder = new (0, $dc829b354b83351f$export$e9fceba8f110fea6)(coders, "_");
                return coder.defaultValue();
            }
        },
        {
            key: "encode",
            value: function encode(types, values) {
                var _this = this;
                if (types.length !== values.length) $5b4960d4c3b0981f$var$logger.throwError("types/values length mismatch", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    count: {
                        types: types.length,
                        values: values.length
                    },
                    value: {
                        types: types,
                        values: values
                    }
                });
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $7978476fda259c54$export$426dc07f493a4c47).from(type));
                });
                var coder = new (0, $dc829b354b83351f$export$e9fceba8f110fea6)(coders, "_");
                var writer = this._getWriter();
                coder.encode(writer, values);
                return writer.data;
            }
        },
        {
            key: "decode",
            value: function decode(types, data, loose) {
                var _this = this;
                var coders = types.map(function(type) {
                    return _this._getCoder((0, $7978476fda259c54$export$426dc07f493a4c47).from(type));
                });
                var coder = new (0, $dc829b354b83351f$export$e9fceba8f110fea6)(coders, "_");
                return coder.decode(this._getReader((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data), loose));
            }
        }
    ]);
    return AbiCoder;
}();
var $5b4960d4c3b0981f$export$51d1cfcdb913adff = new $5b4960d4c3b0981f$export$fe041e1a83d3efc6();






"use strict";
var $52cdf212653b6230$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $3adaaf8a1b7ee32d$export$83d89fbfd8236492));
var $52cdf212653b6230$export$c2ab6499be98b3c5 = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(LogDescription, Description);
    var _super = (0, $hKD8n._)(LogDescription);
    function LogDescription() {
        (0, $7dKN1._)(this, LogDescription);
        return _super.apply(this, arguments);
    }
    return LogDescription;
}((0, $8832fb576a60463b$export$393edc798c47379d));
var $52cdf212653b6230$export$7a3223b0fadb690b = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(TransactionDescription, Description);
    var _super = (0, $hKD8n._)(TransactionDescription);
    function TransactionDescription() {
        (0, $7dKN1._)(this, TransactionDescription);
        return _super.apply(this, arguments);
    }
    return TransactionDescription;
}((0, $8832fb576a60463b$export$393edc798c47379d));
var $52cdf212653b6230$export$cfba08fc0e40e2ab = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(ErrorDescription, Description);
    var _super = (0, $hKD8n._)(ErrorDescription);
    function ErrorDescription() {
        (0, $7dKN1._)(this, ErrorDescription);
        return _super.apply(this, arguments);
    }
    return ErrorDescription;
}((0, $8832fb576a60463b$export$393edc798c47379d));
var $52cdf212653b6230$export$8ef99100a3c56f8c = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(Indexed, Description);
    var _super = (0, $hKD8n._)(Indexed);
    function Indexed() {
        (0, $7dKN1._)(this, Indexed);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(Indexed, null, [
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return !!(value && value._isIndexed);
            }
        }
    ]);
    return Indexed;
}((0, $8832fb576a60463b$export$393edc798c47379d));
var $52cdf212653b6230$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $52cdf212653b6230$var$wrapAccessError(property, error) {
    var wrap = new Error("deferred error during ABI decoding triggered accessing ".concat(property));
    wrap.error = error;
    return wrap;
}
var $52cdf212653b6230$export$48cefb51a4e315b2 = /*#__PURE__*/ function _target() {
    function Interface(fragments) {
        var _this = this;
        (0, $7dKN1._)(this, Interface);
        var abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "fragments", abi.map(function(fragment) {
            return (0, $7978476fda259c54$export$ffb0004e005737fa).from(fragment);
        }).filter(function(fragment) {
            return fragment != null;
        }));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_abiCoder", (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof Interface ? this.constructor : void 0, "getAbiCoder")());
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "functions", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "errors", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "events", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach(function(fragment) {
            var bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (_this.deploy) {
                        $52cdf212653b6230$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $8832fb576a60463b$export$104236534534f9be)(_this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = _this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = _this.events;
                    break;
                case "error":
                    bucket = _this.errors;
                    break;
                default:
                    return;
            }
            var signature = fragment.format();
            if (bucket[signature]) {
                $52cdf212653b6230$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $8832fb576a60463b$export$104236534534f9be)(this, "deploy", (0, $7978476fda259c54$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_isInterface", true);
    }
    (0, $eW5pA._)(Interface, [
        {
            key: "format",
            value: function format(_format) {
                if (!_format) _format = (0, $7978476fda259c54$export$f010f239efc4d445).full;
                if (_format === (0, $7978476fda259c54$export$f010f239efc4d445).sighash) $52cdf212653b6230$var$logger.throwArgumentError("interface does not support formatting sighash", "format", _format);
                var abi = this.fragments.map(function(fragment) {
                    return fragment.format(_format);
                });
                // We need to re-bundle the JSON fragments a bit
                if (_format === (0, $7978476fda259c54$export$f010f239efc4d445).json) return JSON.stringify(abi.map(function(j) {
                    return JSON.parse(j);
                }));
                return abi;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getFunction",
            value: function getFunction(nameOrSignatureOrSighash) {
                if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
                    for(var name in this.functions){
                        if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
                    }
                    $52cdf212653b6230$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.functions).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $52cdf212653b6230$var$logger.throwArgumentError("no matching function", "name", name1);
                    else if (matching.length > 1) $52cdf212653b6230$var$logger.throwArgumentError("multiple matching functions", "name", name1);
                    return this.functions[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.functions[(0, $7978476fda259c54$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $52cdf212653b6230$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Find an event definition by any means necessary (unless it is ambiguous)
            key: "getEvent",
            value: function getEvent(nameOrSignatureOrTopic) {
                if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
                    var topichash = nameOrSignatureOrTopic.toLowerCase();
                    for(var name in this.events){
                        if (topichash === this.getEventTopic(name)) return this.events[name];
                    }
                    $52cdf212653b6230$var$logger.throwArgumentError("no matching event", "topichash", topichash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrTopic.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrTopic.trim();
                    var matching = Object.keys(this.events).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $52cdf212653b6230$var$logger.throwArgumentError("no matching event", "name", name1);
                    else if (matching.length > 1) $52cdf212653b6230$var$logger.throwArgumentError("multiple matching events", "name", name1);
                    return this.events[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.events[(0, $7978476fda259c54$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
                if (!result) $52cdf212653b6230$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
                return result;
            }
        },
        {
            // Find a function definition by any means necessary (unless it is ambiguous)
            key: "getError",
            value: function getError(nameOrSignatureOrSighash) {
                if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
                    var getSighash = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "getSighash");
                    for(var name in this.errors){
                        var error = this.errors[name];
                        if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
                    }
                    $52cdf212653b6230$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
                }
                // It is a bare name, look up the function (will return null if ambiguous)
                if (nameOrSignatureOrSighash.indexOf("(") === -1) {
                    var name1 = nameOrSignatureOrSighash.trim();
                    var matching = Object.keys(this.errors).filter(function(f) {
                        return f.split("(" /* fix:) */ )[0] === name1;
                    });
                    if (matching.length === 0) $52cdf212653b6230$var$logger.throwArgumentError("no matching error", "name", name1);
                    else if (matching.length > 1) $52cdf212653b6230$var$logger.throwArgumentError("multiple matching errors", "name", name1);
                    return this.errors[matching[0]];
                }
                // Normalize the signature and lookup the function
                var result = this.errors[(0, $7978476fda259c54$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
                if (!result) $52cdf212653b6230$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
                return result;
            }
        },
        {
            // Get the sighash (the bytes4 selector) used by Solidity to identify a function
            key: "getSighash",
            value: function getSighash(fragment) {
                if (typeof fragment === "string") try {
                    fragment = this.getFunction(fragment);
                } catch (error) {
                    try {
                        fragment = this.getError(fragment);
                    } catch (_) {
                        throw error;
                    }
                }
                return (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "getSighash")(fragment);
            }
        },
        {
            // Get the topic (the bytes32 hash) used by Solidity to identify an event
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                return (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "getEventTopic")(eventFragment);
            }
        },
        {
            key: "_decodeParams",
            value: function _decodeParams(params, data) {
                return this._abiCoder.decode(params, data);
            }
        },
        {
            key: "_encodeParams",
            value: function _encodeParams(params, values) {
                return this._abiCoder.encode(params, values);
            }
        },
        {
            key: "encodeDeploy",
            value: function encodeDeploy(values) {
                return this._encodeParams(this.deploy.inputs, values || []);
            }
        },
        {
            key: "decodeErrorResult",
            value: function decodeErrorResult(fragment, data) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
                if ((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $52cdf212653b6230$var$logger.throwArgumentError("data signature does not match error ".concat(fragment.name, "."), "data", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes));
                return this._decodeParams(fragment.inputs, bytes.slice(4));
            }
        },
        {
            key: "encodeErrorResult",
            value: function encodeErrorResult(fragment, values) {
                if (typeof fragment === "string") fragment = this.getError(fragment);
                return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    this.getSighash(fragment),
                    this._encodeParams(fragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the data for a function call (e.g. tx.data)
            key: "decodeFunctionData",
            value: function decodeFunctionData(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
                if ((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $52cdf212653b6230$var$logger.throwArgumentError("data signature does not match function ".concat(functionFragment.name, "."), "data", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes));
                return this._decodeParams(functionFragment.inputs, bytes.slice(4));
            }
        },
        {
            // Encode the data for a function call (e.g. tx.data)
            key: "encodeFunctionData",
            value: function encodeFunctionData(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    this.getSighash(functionFragment),
                    this._encodeParams(functionFragment.inputs, values || [])
                ]));
            }
        },
        {
            // Decode the result from a function call (e.g. from eth_call)
            key: "decodeFunctionResult",
            value: function decodeFunctionResult(functionFragment, data) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
                var reason = null;
                var message = "";
                var errorArgs = null;
                var errorName = null;
                var errorSignature = null;
                switch(bytes.length % this._abiCoder._getWordSize()){
                    case 0:
                        try {
                            return this._abiCoder.decode(functionFragment.outputs, bytes);
                        } catch (error) {}
                        break;
                    case 4:
                        {
                            var selector = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                            var builtin = $52cdf212653b6230$var$BuiltinErrors[selector];
                            if (builtin) {
                                errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                                errorName = builtin.name;
                                errorSignature = builtin.signature;
                                if (builtin.reason) reason = errorArgs[0];
                                if (errorName === "Error") message = "; VM Exception while processing transaction: reverted with reason string ".concat(JSON.stringify(errorArgs[0]));
                                else if (errorName === "Panic") message = "; VM Exception while processing transaction: reverted with panic code ".concat(errorArgs[0]);
                            } else try {
                                var error = this.getError(selector);
                                errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                                errorName = error.name;
                                errorSignature = error.format();
                            } catch (error) {}
                            break;
                        }
                }
                return $52cdf212653b6230$var$logger.throwError("call revert exception" + message, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    method: functionFragment.format(),
                    data: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data),
                    errorArgs: errorArgs,
                    errorName: errorName,
                    errorSignature: errorSignature,
                    reason: reason
                });
            }
        },
        {
            // Encode the result for a function call (e.g. for eth_call)
            key: "encodeFunctionResult",
            value: function encodeFunctionResult(functionFragment, values) {
                if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
                return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
            }
        },
        {
            // Create the filter for the event with search criteria (e.g. for eth_filterLog)
            key: "encodeFilterTopics",
            value: function encodeFilterTopics(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (values.length > eventFragment.inputs.length) $52cdf212653b6230$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
                    argument: "values",
                    value: values
                });
                var topics = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                var encodeTopic = function(param, value) {
                    if (param.type === "string") return (0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(value);
                    else if (param.type === "bytes") return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value));
                    if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
                    if (param.type.match(/^u?int/)) value = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value).toHexString();
                    // Check addresses are valid
                    if (param.type === "address") _this._abiCoder.encode([
                        "address"
                    ], [
                        value
                    ]);
                    return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value), 32);
                };
                values.forEach(function(value, index) {
                    var param = eventFragment.inputs[index];
                    if (!param.indexed) {
                        if (value != null) $52cdf212653b6230$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                        return;
                    }
                    if (value == null) topics.push(null);
                    else if (param.baseType === "array" || param.baseType === "tuple") $52cdf212653b6230$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
                    else if (Array.isArray(value)) topics.push(value.map(function(value) {
                        return encodeTopic(param, value);
                    }));
                    else topics.push(encodeTopic(param, value));
                });
                // Trim off trailing nulls
                while(topics.length && topics[topics.length - 1] === null)topics.pop();
                return topics;
            }
        },
        {
            key: "encodeEventLog",
            value: function encodeEventLog(eventFragment, values) {
                var _this = this;
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                var topics = [];
                var dataTypes = [];
                var dataValues = [];
                if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
                if (values.length !== eventFragment.inputs.length) $52cdf212653b6230$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
                eventFragment.inputs.forEach(function(param, index) {
                    var value = values[index];
                    if (param.indexed) {
                        if (param.type === "string") topics.push((0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(value));
                        else if (param.type === "bytes") topics.push((0, $aca68b720d4a692f$export$f8151fce47ad1c35)(value));
                        else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                        throw new Error("not implemented");
                        else topics.push(_this._abiCoder.encode([
                            param.type
                        ], [
                            value
                        ]));
                    } else {
                        dataTypes.push(param);
                        dataValues.push(value);
                    }
                });
                return {
                    data: this._abiCoder.encode(dataTypes, dataValues),
                    topics: topics
                };
            }
        },
        {
            // Decode a filter for the event and the search criteria
            key: "decodeEventLog",
            value: function decodeEventLog(eventFragment, data, topics) {
                var _loop = function(i) {
                    var value = result[i];
                    if (value instanceof Error) Object.defineProperty(result, i, {
                        enumerable: true,
                        get: function() {
                            throw $52cdf212653b6230$var$wrapAccessError("index ".concat(i), value);
                        }
                    });
                };
                if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
                if (topics != null && !eventFragment.anonymous) {
                    var topicHash = this.getEventTopic(eventFragment);
                    if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $52cdf212653b6230$var$logger.throwError("fragment/topic mismatch", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                        argument: "topics[0]",
                        expected: topicHash,
                        value: topics[0]
                    });
                    topics = topics.slice(1);
                }
                var indexed = [];
                var nonIndexed = [];
                var dynamic = [];
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                            indexed.push((0, $7978476fda259c54$export$426dc07f493a4c47).fromObject({
                                type: "bytes32",
                                name: param.name
                            }));
                            dynamic.push(true);
                        } else {
                            indexed.push(param);
                            dynamic.push(false);
                        }
                    } else {
                        nonIndexed.push(param);
                        dynamic.push(false);
                    }
                });
                var resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)(topics)) : null;
                var resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
                var result = [];
                var nonIndexedIndex = 0, indexedIndex = 0;
                eventFragment.inputs.forEach(function(param, index) {
                    if (param.indexed) {
                        if (resultIndexed == null) result[index] = new $52cdf212653b6230$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: null
                        });
                        else if (dynamic[index]) result[index] = new $52cdf212653b6230$export$8ef99100a3c56f8c({
                            _isIndexed: true,
                            hash: resultIndexed[indexedIndex++]
                        });
                        else try {
                            result[index] = resultIndexed[indexedIndex++];
                        } catch (error) {
                            result[index] = error;
                        }
                    } else try {
                        result[index] = resultNonIndexed[nonIndexedIndex++];
                    } catch (error) {
                        result[index] = error;
                    }
                    // Add the keyword argument if named and safe
                    if (param.name && result[param.name] == null) {
                        var value = result[index];
                        // Make error named values throw on access
                        if (value instanceof Error) Object.defineProperty(result, param.name, {
                            enumerable: true,
                            get: function() {
                                throw $52cdf212653b6230$var$wrapAccessError("property ".concat(JSON.stringify(param.name)), value);
                            }
                        });
                        else result[param.name] = value;
                    }
                });
                // Make all error indexed values throw on access
                for(var i = 0; i < result.length; i++)_loop(i);
                return Object.freeze(result);
            }
        },
        {
            // Given a transaction, find the matching function fragment (if any) and
            // determine all its properties and call parameters
            key: "parseTransaction",
            value: function parseTransaction(tx) {
                var fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $52cdf212653b6230$export$7a3223b0fadb690b({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
                    functionFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment),
                    value: (0, $3b33bab384c8baec$export$d97aa349ed20696).from(tx.value || "0")
                });
            }
        },
        {
            // @TODO
            //parseCallResult(data: BytesLike): ??
            // Given an event log, find the matching event fragment (if any) and
            // determine all its properties and values
            key: "parseLog",
            value: function parseLog(log) {
                var fragment = this.getEvent(log.topics[0]);
                if (!fragment || fragment.anonymous) return null;
                // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
                //        Probably not, because just because it is the only event in the ABI does
                //        not mean we have the full ABI; maybe just a fragment?
                return new $52cdf212653b6230$export$c2ab6499be98b3c5({
                    eventFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    topic: this.getEventTopic(fragment),
                    args: this.decodeEventLog(fragment, log.data, log.topics)
                });
            }
        },
        {
            key: "parseError",
            value: function parseError(data) {
                var hexData = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data);
                var fragment = this.getError(hexData.substring(0, 10).toLowerCase());
                if (!fragment) return null;
                return new $52cdf212653b6230$export$cfba08fc0e40e2ab({
                    args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
                    errorFragment: fragment,
                    name: fragment.name,
                    signature: fragment.format(),
                    sighash: this.getSighash(fragment)
                });
            }
        }
    ], [
        {
            key: "getAbiCoder",
            value: // Sub-classes can override these to handle other blockchains
            function getAbiCoder() {
                return 0, $5b4960d4c3b0981f$export$51d1cfcdb913adff;
            }
        },
        {
            key: "getAddress",
            value: function getAddress1(address) {
                return (0, $77ffbd0470aad2fd$export$88411125f012957a)(address);
            }
        },
        {
            key: "getSighash",
            value: function getSighash(fragment) {
                return (0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
            }
        },
        {
            key: "getEventTopic",
            value: function getEventTopic(eventFragment) {
                return (0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(eventFragment.format());
            }
        },
        {
            key: "isInterface",
            value: /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ function isInterface(value) {
                return !!(value && value._isInterface);
            }
        }
    ]);
    return Interface;
}();



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");




var $8b6439c2d20a5d1d$export$83d89fbfd8236492 = "abstract-provider/5.7.0";


"use strict";
var $fc170b81a17b0865$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fc170b81a17b0865$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $8b6439c2d20a5d1d$export$83d89fbfd8236492));
var $fc170b81a17b0865$export$406ece1549ccd00e = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(ForkEvent, Description);
    var _super = (0, $hKD8n._)(ForkEvent);
    function ForkEvent() {
        (0, $7dKN1._)(this, ForkEvent);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(ForkEvent, null, [
        {
            key: "isForkEvent",
            value: function isForkEvent(value) {
                return !!(value && value._isForkEvent);
            }
        }
    ]);
    return ForkEvent;
}((0, $8832fb576a60463b$export$393edc798c47379d));
var $fc170b81a17b0865$export$5b2cada8494f9d99 = /*#__PURE__*/ function(ForkEvent) {
    (0, $cgJ2Y._)(BlockForkEvent, ForkEvent);
    var _super = (0, $hKD8n._)(BlockForkEvent);
    function BlockForkEvent(blockHash, expiry) {
        (0, $7dKN1._)(this, BlockForkEvent);
        if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(blockHash, 32)) $fc170b81a17b0865$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        return _super.call(this, {
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
    return BlockForkEvent;
}($fc170b81a17b0865$export$406ece1549ccd00e);
var $fc170b81a17b0865$export$26bcd61a55716c98 = /*#__PURE__*/ function(ForkEvent) {
    (0, $cgJ2Y._)(TransactionForkEvent, ForkEvent);
    var _super = (0, $hKD8n._)(TransactionForkEvent);
    function TransactionForkEvent(hash, expiry) {
        (0, $7dKN1._)(this, TransactionForkEvent);
        if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(hash, 32)) $fc170b81a17b0865$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        return _super.call(this, {
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
    return TransactionForkEvent;
}($fc170b81a17b0865$export$406ece1549ccd00e);
var $fc170b81a17b0865$export$8f8609bfee47c93 = /*#__PURE__*/ function(ForkEvent) {
    (0, $cgJ2Y._)(TransactionOrderForkEvent, ForkEvent);
    var _super = (0, $hKD8n._)(TransactionOrderForkEvent);
    function TransactionOrderForkEvent(beforeHash, afterHash, expiry) {
        (0, $7dKN1._)(this, TransactionOrderForkEvent);
        if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(beforeHash, 32)) $fc170b81a17b0865$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(afterHash, 32)) $fc170b81a17b0865$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        return _super.call(this, {
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
    return TransactionOrderForkEvent;
}($fc170b81a17b0865$export$406ece1549ccd00e);
var $fc170b81a17b0865$export$2881499e37b75b9a = /*#__PURE__*/ function _target() {
    function Provider() {
        (0, $7dKN1._)(this, Provider);
        $fc170b81a17b0865$var$logger.checkAbstract(this instanceof Provider ? this.constructor : void 0, Provider);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_isProvider", true);
    }
    (0, $eW5pA._)(Provider, [
        {
            key: "getFeeData",
            value: function getFeeData() {
                return $fc170b81a17b0865$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, block, gasPrice, lastBaseFeePerGas, maxFeePerGas, maxPriorityFeePerGas;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        block: this.getBlock("latest"),
                                        gasPrice: this.getGasPrice().catch(function(error) {
                                            // @TODO: Why is this now failing on Calaveras?
                                            //console.log(error);
                                            return null;
                                        })
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), block = _ref.block, gasPrice = _ref.gasPrice;
                                lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
                                if (block && block.baseFeePerGas) {
                                    // We may want to compute this more accurately in the future,
                                    // using the formula "check if the base fee is correct".
                                    // See: https://eips.ethereum.org/EIPS/eip-1559
                                    lastBaseFeePerGas = block.baseFeePerGas;
                                    maxPriorityFeePerGas = (0, $3b33bab384c8baec$export$d97aa349ed20696).from("1500000000");
                                    maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
                                }
                                return [
                                    2,
                                    {
                                        lastBaseFeePerGas: lastBaseFeePerGas,
                                        maxFeePerGas: maxFeePerGas,
                                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                                        gasPrice: gasPrice
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            // Alias for "on"
            key: "addListener",
            value: function addListener(eventName, listener) {
                return this.on(eventName, listener);
            }
        },
        {
            // Alias for "off"
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                return this.off(eventName, listener);
            }
        }
    ], [
        {
            key: "isProvider",
            value: function isProvider(value) {
                return !!(value && value._isProvider);
            }
        }
    ]);
    return Provider;
}();



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");


var $a5655e084e54a9d2$export$83d89fbfd8236492 = "abstract-signer/5.7.0";


"use strict";
var $3e3669d74ee1fde3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3e3669d74ee1fde3$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5655e084e54a9d2$export$83d89fbfd8236492));
var $3e3669d74ee1fde3$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
var $3e3669d74ee1fde3$var$forwardErrors = [
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED
];
var $3e3669d74ee1fde3$export$fdf54fdde81cc9f0 = /*#__PURE__*/ function _target() {
    function Signer() {
        (0, $7dKN1._)(this, Signer);
        $3e3669d74ee1fde3$var$logger.checkAbstract(this instanceof Signer ? this.constructor : void 0, Signer);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_isSigner", true);
    }
    (0, $eW5pA._)(Signer, [
        {
            ///////////////////
            // Sub-classes MAY override these
            key: "getBalance",
            value: function getBalance(blockTag) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getBalance");
                                return [
                                    4,
                                    this.provider.getBalance(this.getAddress(), blockTag)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount(blockTag) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getTransactionCount");
                                return [
                                    4,
                                    this.provider.getTransactionCount(this.getAddress(), blockTag)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates "from" if unspecified, and estimates the gas for the transaction
            key: "estimateGas",
            value: function estimateGas(transaction) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    var tx;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("estimateGas");
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.provider.estimateGas(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates "from" if unspecified, and calls with the transaction
            key: "call",
            value: function call(transaction, blockTag) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    var tx;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("call");
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.provider.call(tx, blockTag)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Populates all fields in a transaction, signs it and sends it to the network
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    var tx, signedTx;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("sendTransaction");
                                return [
                                    4,
                                    this.populateTransaction(transaction)
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    4,
                                    this.signTransaction(tx)
                                ];
                            case 2:
                                signedTx = _state.sent();
                                return [
                                    4,
                                    this.provider.sendTransaction(signedTx)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    var network;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getChainId");
                                return [
                                    4,
                                    this.provider.getNetwork()
                                ];
                            case 1:
                                network = _state.sent();
                                return [
                                    2,
                                    network.chainId
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getGasPrice",
            value: function getGasPrice() {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getGasPrice");
                                return [
                                    4,
                                    this.provider.getGasPrice()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getFeeData",
            value: function getFeeData() {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("getFeeData");
                                return [
                                    4,
                                    this.provider.getFeeData()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveName",
            value: function resolveName(name) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._checkProvider("resolveName");
                                return [
                                    4,
                                    this.provider.resolveName(name)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            // Checks a transaction does not contain invalid keys and if
            // no "from" is provided, populates it.
            // - does NOT require a provider
            // - adds "from" is not present
            // - returns a COPY (safe to mutate the result)
            // By default called from: (overriding these prevents it)
            //   - call
            //   - estimateGas
            //   - populateTransaction (and therefor sendTransaction)
            key: "checkTransaction",
            value: function checkTransaction(transaction) {
                for(var key in transaction)if ($3e3669d74ee1fde3$var$allowedTransactionKeys.indexOf(key) === -1) $3e3669d74ee1fde3$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
                var tx = (0, $8832fb576a60463b$export$9c13236873b118a5)(transaction);
                if (tx.from == null) tx.from = this.getAddress();
                else // Make sure any provided address matches this signer
                tx.from = Promise.all([
                    Promise.resolve(tx.from),
                    this.getAddress()
                ]).then(function(result) {
                    if (result[0].toLowerCase() !== result[1].toLowerCase()) $3e3669d74ee1fde3$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
                    return result[0];
                });
                return tx;
            }
        },
        {
            // Populates ALL keys for a transaction and checks that "from" matches
            // this Signer. Should be used by sendTransaction but NOT by signTransaction.
            // By default called from: (overriding these prevents it)
            //   - sendTransaction
            //
            // Notes:
            //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
            key: "populateTransaction",
            value: function populateTransaction(transaction) {
                return $3e3669d74ee1fde3$var$__awaiter(this, void 0, void 0, function() {
                    var _this, tx, hasEip1559, feeData, gasPrice;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)(this.checkTransaction(transaction))
                                ];
                            case 1:
                                tx = _state.sent();
                                if (tx.to != null) {
                                    tx.to = Promise.resolve(tx.to).then(function(to) {
                                        return $3e3669d74ee1fde3$var$__awaiter(_this, void 0, void 0, function() {
                                            var address;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (to == null) return [
                                                            2,
                                                            null
                                                        ];
                                                        return [
                                                            4,
                                                            this.resolveName(to)
                                                        ];
                                                    case 1:
                                                        address = _state.sent();
                                                        if (address == null) $3e3669d74ee1fde3$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                                                        return [
                                                            2,
                                                            address
                                                        ];
                                                }
                                            });
                                        });
                                    });
                                    // Prevent this error from causing an UnhandledPromiseException
                                    tx.to.catch(function(error) {});
                                }
                                // Do not allow mixing pre-eip-1559 and eip-1559 properties
                                hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
                                if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $3e3669d74ee1fde3$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
                                else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $3e3669d74ee1fde3$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
                                if (!((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null)) return [
                                    3,
                                    2
                                ];
                                // Fully-formed EIP-1559 transaction (skip getFeeData)
                                tx.type = 2;
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!(tx.type === 0 || tx.type === 1)) return [
                                    3,
                                    3
                                ];
                                // Explicit Legacy or EIP-2930 transaction
                                // Populate missing gasPrice
                                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    this.getFeeData()
                                ];
                            case 4:
                                feeData = _state.sent();
                                if (tx.type == null) {
                                    // We need to auto-detect the intended type of this transaction...
                                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                                        // The network supports EIP-1559!
                                        // Upgrade transaction from null to eip-1559
                                        tx.type = 2;
                                        if (tx.gasPrice != null) {
                                            // Using legacy gasPrice property on an eip-1559 network,
                                            // so use gasPrice as both fee properties
                                            gasPrice = tx.gasPrice;
                                            delete tx.gasPrice;
                                            tx.maxFeePerGas = gasPrice;
                                            tx.maxPriorityFeePerGas = gasPrice;
                                        } else {
                                            // Populate missing fee data
                                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                                        }
                                    } else if (feeData.gasPrice != null) {
                                        // Network doesn't support EIP-1559...
                                        // ...but they are trying to use EIP-1559 properties
                                        if (hasEip1559) $3e3669d74ee1fde3$var$logger.throwError("network does not support EIP-1559", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                            operation: "populateTransaction"
                                        });
                                        // Populate missing fee data
                                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                                        // Explicitly set untyped transaction to legacy
                                        tx.type = 0;
                                    } else // getFeeData has failed us.
                                    $3e3669d74ee1fde3$var$logger.throwError("failed to get consistent fee data", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                        operation: "signer.getFeeData"
                                    });
                                } else if (tx.type === 2) {
                                    // Explicitly using EIP-1559
                                    // Populate missing fee data
                                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                                }
                                _state.label = 5;
                            case 5:
                                if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
                                if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch(function(error) {
                                    if ($3e3669d74ee1fde3$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                                    return $3e3669d74ee1fde3$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
                                        error: error,
                                        tx: tx
                                    });
                                });
                                if (tx.chainId == null) tx.chainId = this.getChainId();
                                else tx.chainId = Promise.all([
                                    Promise.resolve(tx.chainId),
                                    this.getChainId()
                                ]).then(function(results) {
                                    if (results[1] !== 0 && results[0] !== results[1]) $3e3669d74ee1fde3$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                                    return results[0];
                                });
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)(tx)
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            ///////////////////
            // Sub-classes SHOULD leave these alone
            key: "_checkProvider",
            value: function _checkProvider(operation) {
                if (!this.provider) $3e3669d74ee1fde3$var$logger.throwError("missing provider", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: operation || "_checkProvider"
                });
            }
        }
    ], [
        {
            key: "isSigner",
            value: function isSigner(value) {
                return !!(value && value._isSigner);
            }
        }
    ]);
    return Signer;
}();
var $3e3669d74ee1fde3$export$7dbc56d9b9612bad = /*#__PURE__*/ function(Signer) {
    (0, $cgJ2Y._)(VoidSigner, Signer);
    var _super = (0, $hKD8n._)(VoidSigner);
    function VoidSigner(address, provider) {
        (0, $7dKN1._)(this, VoidSigner);
        var _this;
        _this = _super.call(this);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "address", address);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "provider", provider || null);
        return _this;
    }
    (0, $eW5pA._)(VoidSigner, [
        {
            key: "getAddress",
            value: function getAddress() {
                return Promise.resolve(this.address);
            }
        },
        {
            key: "_fail",
            value: function _fail(message, operation) {
                return Promise.resolve().then(function() {
                    $3e3669d74ee1fde3$var$logger.throwError(message, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: operation
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return this._fail("VoidSigner cannot sign messages", "signMessage");
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return this._fail("VoidSigner cannot sign transactions", "signTransaction");
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return this._fail("VoidSigner cannot sign typed data", "signTypedData");
            }
        },
        {
            key: "connect",
            value: function connect(provider) {
                return new VoidSigner(this.address, provider);
            }
        }
    ]);
    return VoidSigner;
}($3e3669d74ee1fde3$export$fdf54fdde81cc9f0);














var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $3YqWF = parcelRequire("3YqWF");

var $kZo2m = parcelRequire("kZo2m");
var $01aadad038cea167$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $01aadad038cea167$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $01aadad038cea167$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function require(path, base) {
            return $01aadad038cea167$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $01aadad038cea167$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $01aadad038cea167$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $01aadad038cea167$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n[k];
            }
        });
    });
    return a;
}
function $01aadad038cea167$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $01aadad038cea167$var$minimalisticAssert = $01aadad038cea167$var$assert;
function $01aadad038cea167$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$01aadad038cea167$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $01aadad038cea167$var$utils_1 = $01aadad038cea167$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $01aadad038cea167$var$utils_1$1 = $01aadad038cea167$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $01aadad038cea167$var$minimalisticAssert;
    utils.toArray = $01aadad038cea167$var$utils_1.toArray;
    utils.zero2 = $01aadad038cea167$var$utils_1.zero2;
    utils.toHex = $01aadad038cea167$var$utils_1.toHex;
    utils.encode = $01aadad038cea167$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $01aadad038cea167$var$getNAF = $01aadad038cea167$var$utils_1$1.getNAF;
var $01aadad038cea167$var$getJSF = $01aadad038cea167$var$utils_1$1.getJSF;
var $01aadad038cea167$var$assert$1 = $01aadad038cea167$var$utils_1$1.assert;
function $01aadad038cea167$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $01aadad038cea167$var$base = $01aadad038cea167$var$BaseCurve;
$01aadad038cea167$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$01aadad038cea167$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$01aadad038cea167$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $01aadad038cea167$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $01aadad038cea167$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$01aadad038cea167$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $01aadad038cea167$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $01aadad038cea167$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$01aadad038cea167$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $01aadad038cea167$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $01aadad038cea167$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $01aadad038cea167$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $01aadad038cea167$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$01aadad038cea167$var$BaseCurve.BasePoint = $01aadad038cea167$var$BasePoint;
$01aadad038cea167$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$01aadad038cea167$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$01aadad038cea167$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $01aadad038cea167$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $01aadad038cea167$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $01aadad038cea167$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$01aadad038cea167$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$01aadad038cea167$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$01aadad038cea167$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $01aadad038cea167$var$utils_1$1.encode(this._encode(compact), enc);
};
$01aadad038cea167$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$01aadad038cea167$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$01aadad038cea167$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$01aadad038cea167$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$01aadad038cea167$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$01aadad038cea167$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $01aadad038cea167$var$inherits_browser = $01aadad038cea167$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function TempCtor() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $01aadad038cea167$var$assert$2 = $01aadad038cea167$var$utils_1$1.assert;
function $01aadad038cea167$var$ShortCurve(conf) {
    $01aadad038cea167$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$01aadad038cea167$var$inherits_browser($01aadad038cea167$var$ShortCurve, $01aadad038cea167$var$base);
var $01aadad038cea167$var$short_1 = $01aadad038cea167$var$ShortCurve;
$01aadad038cea167$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $01aadad038cea167$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$01aadad038cea167$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$01aadad038cea167$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$01aadad038cea167$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$01aadad038cea167$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$01aadad038cea167$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$01aadad038cea167$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $01aadad038cea167$var$Point(curve, x, y, isRed) {
    $01aadad038cea167$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$01aadad038cea167$var$inherits_browser($01aadad038cea167$var$Point, $01aadad038cea167$var$base.BasePoint);
$01aadad038cea167$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $01aadad038cea167$var$Point(this, x, y, isRed);
};
$01aadad038cea167$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $01aadad038cea167$var$Point.fromJSON(this, obj, red);
};
$01aadad038cea167$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$01aadad038cea167$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$01aadad038cea167$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$01aadad038cea167$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$01aadad038cea167$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$01aadad038cea167$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$01aadad038cea167$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$01aadad038cea167$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$01aadad038cea167$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$01aadad038cea167$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$01aadad038cea167$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$01aadad038cea167$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$01aadad038cea167$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$01aadad038cea167$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$01aadad038cea167$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $01aadad038cea167$var$JPoint(curve, x, y, z) {
    $01aadad038cea167$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$01aadad038cea167$var$inherits_browser($01aadad038cea167$var$JPoint, $01aadad038cea167$var$base.BasePoint);
$01aadad038cea167$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $01aadad038cea167$var$JPoint(this, x, y, z);
};
$01aadad038cea167$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$01aadad038cea167$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$01aadad038cea167$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$01aadad038cea167$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$01aadad038cea167$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$01aadad038cea167$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$01aadad038cea167$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$01aadad038cea167$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$01aadad038cea167$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$01aadad038cea167$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$01aadad038cea167$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$01aadad038cea167$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$01aadad038cea167$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$01aadad038cea167$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$01aadad038cea167$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $01aadad038cea167$var$curve_1 = $01aadad038cea167$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $01aadad038cea167$var$base;
    curve.short = $01aadad038cea167$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $01aadad038cea167$var$curves_1 = $01aadad038cea167$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var _$assert = $01aadad038cea167$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $01aadad038cea167$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $01aadad038cea167$var$curve_1.edwards(options);
        else this.curve = new $01aadad038cea167$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        _$assert(this.g.validate(), "Invalid curve");
        _$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function get() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $01aadad038cea167$var$HmacDRBG(options) {
    if (!(this instanceof $01aadad038cea167$var$HmacDRBG)) return new $01aadad038cea167$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $01aadad038cea167$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $01aadad038cea167$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $01aadad038cea167$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $01aadad038cea167$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $01aadad038cea167$var$hmacDrbg = $01aadad038cea167$var$HmacDRBG;
$01aadad038cea167$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$01aadad038cea167$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).hmac(this.hash, this.K);
};
$01aadad038cea167$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$01aadad038cea167$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $01aadad038cea167$var$utils_1.toArray(entropy, entropyEnc);
    add = $01aadad038cea167$var$utils_1.toArray(add, addEnc);
    $01aadad038cea167$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$01aadad038cea167$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $01aadad038cea167$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $01aadad038cea167$var$utils_1.encode(res, enc);
};
"use strict";
var $01aadad038cea167$var$assert$3 = $01aadad038cea167$var$utils_1$1.assert;
function $01aadad038cea167$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $01aadad038cea167$var$key = $01aadad038cea167$var$KeyPair;
$01aadad038cea167$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $01aadad038cea167$var$KeyPair) return pub;
    return new $01aadad038cea167$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$01aadad038cea167$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $01aadad038cea167$var$KeyPair) return priv;
    return new $01aadad038cea167$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$01aadad038cea167$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$01aadad038cea167$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$01aadad038cea167$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$01aadad038cea167$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$01aadad038cea167$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $01aadad038cea167$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $01aadad038cea167$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$01aadad038cea167$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $01aadad038cea167$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$01aadad038cea167$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$01aadad038cea167$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$01aadad038cea167$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $01aadad038cea167$var$assert$4 = $01aadad038cea167$var$utils_1$1.assert;
function $01aadad038cea167$var$Signature(options, enc) {
    if (options instanceof $01aadad038cea167$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $01aadad038cea167$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $01aadad038cea167$var$signature = $01aadad038cea167$var$Signature;
function $01aadad038cea167$var$Position() {
    this.place = 0;
}
function $01aadad038cea167$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $01aadad038cea167$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$01aadad038cea167$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $01aadad038cea167$var$utils_1$1.toArray(data, enc);
    var p = new $01aadad038cea167$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $01aadad038cea167$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $01aadad038cea167$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $01aadad038cea167$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(s);
    this.recoveryParam = null;
    return true;
};
function $01aadad038cea167$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$01aadad038cea167$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $01aadad038cea167$var$rmPadding(r);
    s = $01aadad038cea167$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $01aadad038cea167$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $01aadad038cea167$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $01aadad038cea167$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $01aadad038cea167$var$utils_1$1.encode(res, enc);
};
"use strict";
var $01aadad038cea167$var$rand = /*RicMoo:ethers:require(brorand)*/ function rand() {
    throw new Error("unsupported");
};
var $01aadad038cea167$var$assert$5 = $01aadad038cea167$var$utils_1$1.assert;
function $01aadad038cea167$var$EC(options) {
    if (!(this instanceof $01aadad038cea167$var$EC)) return new $01aadad038cea167$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $01aadad038cea167$var$assert$5(Object.prototype.hasOwnProperty.call($01aadad038cea167$var$curves_1, options), "Unknown curve " + options);
        options = $01aadad038cea167$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $01aadad038cea167$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $01aadad038cea167$var$ec = $01aadad038cea167$var$EC;
$01aadad038cea167$var$EC.prototype.keyPair = function keyPair(options) {
    return new $01aadad038cea167$var$key(this, options);
};
$01aadad038cea167$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $01aadad038cea167$var$key.fromPrivate(this, priv, enc);
};
$01aadad038cea167$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $01aadad038cea167$var$key.fromPublic(this, pub, enc);
};
$01aadad038cea167$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $01aadad038cea167$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $01aadad038cea167$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$01aadad038cea167$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$01aadad038cea167$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $01aadad038cea167$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $01aadad038cea167$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$01aadad038cea167$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $01aadad038cea167$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$01aadad038cea167$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $01aadad038cea167$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $01aadad038cea167$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($3YqWF)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$01aadad038cea167$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $01aadad038cea167$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $01aadad038cea167$var$elliptic_1 = $01aadad038cea167$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $01aadad038cea167$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $01aadad038cea167$var$curve_1;
    elliptic.curves = $01aadad038cea167$var$curves_1;
    // Protocols
    elliptic.ec = $01aadad038cea167$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $01aadad038cea167$export$129fe12d32abc311 = $01aadad038cea167$var$elliptic_1.ec;





var $a964ce90ebe0e776$export$83d89fbfd8236492 = "signing-key/5.7.0";


"use strict";
var $14bbf95e2a82e6fd$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a964ce90ebe0e776$export$83d89fbfd8236492));
var $14bbf95e2a82e6fd$var$_curve = null;
function $14bbf95e2a82e6fd$var$getCurve() {
    if (!$14bbf95e2a82e6fd$var$_curve) $14bbf95e2a82e6fd$var$_curve = new (0, $01aadad038cea167$export$129fe12d32abc311)("secp256k1");
    return $14bbf95e2a82e6fd$var$_curve;
}
var $14bbf95e2a82e6fd$export$21643ca94aed3e83 = /*#__PURE__*/ function() {
    function SigningKey(privateKey) {
        (0, $7dKN1._)(this, SigningKey);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "curve", "secp256k1");
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "privateKey", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(this.privateKey) !== 32) $14bbf95e2a82e6fd$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        var keyPair = $14bbf95e2a82e6fd$var$getCurve().keyFromPrivate((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(this.privateKey));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_isSigningKey", true);
    }
    (0, $eW5pA._)(SigningKey, [
        {
            key: "_addPoint",
            value: function _addPoint(other) {
                var p0 = $14bbf95e2a82e6fd$var$getCurve().keyFromPublic((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(this.publicKey));
                var p1 = $14bbf95e2a82e6fd$var$getCurve().keyFromPublic((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(other));
                return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
            }
        },
        {
            key: "signDigest",
            value: function signDigest(digest) {
                var keyPair = $14bbf95e2a82e6fd$var$getCurve().keyFromPrivate((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(this.privateKey));
                var digestBytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(digest);
                if (digestBytes.length !== 32) $14bbf95e2a82e6fd$var$logger.throwArgumentError("bad digest length", "digest", digest);
                var signature = keyPair.sign(digestBytes, {
                    canonical: true
                });
                return (0, $b8b53b1cc922c9da$export$7fb170f1e457988f)({
                    recoveryParam: signature.recoveryParam,
                    r: (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
                    s: (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
                });
            }
        },
        {
            key: "computeSharedSecret",
            value: function computeSharedSecret(otherKey) {
                var keyPair = $14bbf95e2a82e6fd$var$getCurve().keyFromPrivate((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(this.privateKey));
                var otherKeyPair = $14bbf95e2a82e6fd$var$getCurve().keyFromPublic((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)($14bbf95e2a82e6fd$export$4a89473d39301224(otherKey)));
                return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
            }
        }
    ], [
        {
            key: "isSigningKey",
            value: function isSigningKey(value) {
                return !!(value && value._isSigningKey);
            }
        }
    ]);
    return SigningKey;
}();
function $14bbf95e2a82e6fd$export$952dd09fbe0232b7(digest, signature) {
    var sig = (0, $b8b53b1cc922c9da$export$7fb170f1e457988f)(signature);
    var rs = {
        r: (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(sig.r),
        s: (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $14bbf95e2a82e6fd$var$getCurve().recoverPubKey((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $14bbf95e2a82e6fd$export$4a89473d39301224(key, compressed) {
    var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        var signingKey = new $14bbf95e2a82e6fd$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $14bbf95e2a82e6fd$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $14bbf95e2a82e6fd$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $14bbf95e2a82e6fd$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $14bbf95e2a82e6fd$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



var $b71e67652edd98c9$export$83d89fbfd8236492 = "transactions/5.7.0";


"use strict";
var $fd7cc3a32c93c53c$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $b71e67652edd98c9$export$83d89fbfd8236492));
var $fd7cc3a32c93c53c$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($fd7cc3a32c93c53c$export$80349e05e0724e11 || ($fd7cc3a32c93c53c$export$80349e05e0724e11 = {}));
///////////////////////////////
function $fd7cc3a32c93c53c$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $77ffbd0470aad2fd$export$88411125f012957a)(value);
}
function $fd7cc3a32c93c53c$var$handleNumber(value) {
    if (value === "0x") return 0, $90f483a28c97692a$export$aaef8a3eae948f03;
    return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
var $fd7cc3a32c93c53c$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
var $fd7cc3a32c93c53c$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $fd7cc3a32c93c53c$export$e67e2732ba9803f9(key) {
    var publicKey = (0, $14bbf95e2a82e6fd$export$4a89473d39301224)(key);
    return (0, $77ffbd0470aad2fd$export$88411125f012957a)((0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $fd7cc3a32c93c53c$export$23cc18f96d8510e2(digest, signature) {
    return $fd7cc3a32c93c53c$export$e67e2732ba9803f9((0, $14bbf95e2a82e6fd$export$952dd09fbe0232b7)((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(digest), signature));
}
function $fd7cc3a32c93c53c$var$formatNumber(value, name) {
    var result = (0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)((0, $3b33bab384c8baec$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $fd7cc3a32c93c53c$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $77ffbd0470aad2fd$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map(function(storageKey, index) {
            if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(storageKey) !== 32) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid access list storageKey", "accessList[".concat(addr, ":").concat(index, "]"), storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $fd7cc3a32c93c53c$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map(function(set, index) {
        if (Array.isArray(set)) {
            if (set.length > 2) $fd7cc3a32c93c53c$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", "value[".concat(index, "]"), set);
            return $fd7cc3a32c93c53c$var$accessSetify(set[0], set[1]);
        }
        return $fd7cc3a32c93c53c$var$accessSetify(set.address, set.storageKeys);
    });
    var result = Object.keys(value).map(function(addr) {
        var storageKeys = value[addr].reduce(function(accum, storageKey) {
            accum[storageKey] = true;
            return accum;
        }, {});
        return $fd7cc3a32c93c53c$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort(function(a, b) {
        return a.address.localeCompare(b.address);
    });
    return result;
}
function $fd7cc3a32c93c53c$var$formatAccessList(value) {
    return $fd7cc3a32c93c53c$export$6c8662b1600dce2(value).map(function(set) {
        return [
            set.address,
            set.storageKeys
        ];
    });
}
function $fd7cc3a32c93c53c$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        var gasPrice = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(transaction.gasPrice);
        var maxFeePerGas = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $fd7cc3a32c93c53c$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    var fields = [
        $fd7cc3a32c93c53c$var$formatNumber(transaction.chainId || 0, "chainId"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.nonce || 0, "nonce"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $77ffbd0470aad2fd$export$88411125f012957a)(transaction.to) : "0x",
        $fd7cc3a32c93c53c$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $fd7cc3a32c93c53c$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        var sig = (0, $b8b53b1cc922c9da$export$7fb170f1e457988f)(signature);
        fields.push($fd7cc3a32c93c53c$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
        "0x02",
        $00af536cb1026bd9$export$c564cdbbe6da493(fields)
    ]);
}
function $fd7cc3a32c93c53c$var$_serializeEip2930(transaction, signature) {
    var fields = [
        $fd7cc3a32c93c53c$var$formatNumber(transaction.chainId || 0, "chainId"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.nonce || 0, "nonce"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $fd7cc3a32c93c53c$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $77ffbd0470aad2fd$export$88411125f012957a)(transaction.to) : "0x",
        $fd7cc3a32c93c53c$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $fd7cc3a32c93c53c$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        var sig = (0, $b8b53b1cc922c9da$export$7fb170f1e457988f)(signature);
        fields.push($fd7cc3a32c93c53c$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
        "0x01",
        $00af536cb1026bd9$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $fd7cc3a32c93c53c$var$_serialize(transaction, signature) {
    (0, $8832fb576a60463b$export$ae5a316ba623b73a)(transaction, $fd7cc3a32c93c53c$var$allowedTransactionKeys);
    var raw = [];
    $fd7cc3a32c93c53c$var$transactionFields.forEach(function(fieldInfo) {
        var value = transaction[fieldInfo.name] || [];
        var options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value));
    });
    var chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $b8b53b1cc922c9da$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $00af536cb1026bd9$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    var sig = (0, $b8b53b1cc922c9da$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    var v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $fd7cc3a32c93c53c$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $fd7cc3a32c93c53c$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $b8b53b1cc922c9da$export$a8f4574d0e56446c)((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(sig.s)));
    return $00af536cb1026bd9$export$c564cdbbe6da493(raw);
}
function $fd7cc3a32c93c53c$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $fd7cc3a32c93c53c$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $fd7cc3a32c93c53c$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $fd7cc3a32c93c53c$var$_serializeEip2930(transaction, signature);
        case 2:
            return $fd7cc3a32c93c53c$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $fd7cc3a32c93c53c$var$logger.throwError("unsupported transaction type: ".concat(transaction.type), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $fd7cc3a32c93c53c$var$_parseEipSignature(tx, fields, serialize) {
    try {
        var recid = $fd7cc3a32c93c53c$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        var digest = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $fd7cc3a32c93c53c$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $fd7cc3a32c93c53c$var$_parseEip1559(payload) {
    var transaction = $00af536cb1026bd9$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(payload));
    var maxPriorityFeePerGas = $fd7cc3a32c93c53c$var$handleNumber(transaction[2]);
    var maxFeePerGas = $fd7cc3a32c93c53c$var$handleNumber(transaction[3]);
    var tx = {
        type: 2,
        chainId: $fd7cc3a32c93c53c$var$handleNumber(transaction[0]).toNumber(),
        nonce: $fd7cc3a32c93c53c$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $fd7cc3a32c93c53c$var$handleNumber(transaction[4]),
        to: $fd7cc3a32c93c53c$var$handleAddress(transaction[5]),
        value: $fd7cc3a32c93c53c$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $fd7cc3a32c93c53c$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(payload);
    $fd7cc3a32c93c53c$var$_parseEipSignature(tx, transaction.slice(9), $fd7cc3a32c93c53c$var$_serializeEip1559);
    return tx;
}
function $fd7cc3a32c93c53c$var$_parseEip2930(payload) {
    var transaction = $00af536cb1026bd9$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(payload));
    var tx = {
        type: 1,
        chainId: $fd7cc3a32c93c53c$var$handleNumber(transaction[0]).toNumber(),
        nonce: $fd7cc3a32c93c53c$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $fd7cc3a32c93c53c$var$handleNumber(transaction[2]),
        gasLimit: $fd7cc3a32c93c53c$var$handleNumber(transaction[3]),
        to: $fd7cc3a32c93c53c$var$handleAddress(transaction[4]),
        value: $fd7cc3a32c93c53c$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $fd7cc3a32c93c53c$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(payload);
    $fd7cc3a32c93c53c$var$_parseEipSignature(tx, transaction.slice(8), $fd7cc3a32c93c53c$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $fd7cc3a32c93c53c$var$_parse(rawTransaction) {
    var transaction = $00af536cb1026bd9$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $fd7cc3a32c93c53c$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    var tx = {
        nonce: $fd7cc3a32c93c53c$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $fd7cc3a32c93c53c$var$handleNumber(transaction[1]),
        gasLimit: $fd7cc3a32c93c53c$var$handleNumber(transaction[2]),
        to: $fd7cc3a32c93c53c$var$handleAddress(transaction[3]),
        value: $fd7cc3a32c93c53c$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $3b33bab384c8baec$export$d97aa349ed20696).from(tx.r).isZero() && (0, $3b33bab384c8baec$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        var recoveryParam = tx.v - 27;
        var raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        var digest = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)($00af536cb1026bd9$export$c564cdbbe6da493(raw));
        try {
            tx.from = $fd7cc3a32c93c53c$export$23cc18f96d8510e2(digest, {
                r: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $fd7cc3a32c93c53c$export$98e6a39c04603d36(rawTransaction) {
    var payload = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $fd7cc3a32c93c53c$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $fd7cc3a32c93c53c$var$_parseEip2930(payload);
        case 2:
            return $fd7cc3a32c93c53c$var$_parseEip1559(payload);
        default:
            break;
    }
    return $fd7cc3a32c93c53c$var$logger.throwError("unsupported transaction type: ".concat(payload[0]), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



var $ead83ae53a8bca95$export$83d89fbfd8236492 = "contracts/5.7.0";


"use strict";
var $872b1ea3a0575206$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $872b1ea3a0575206$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $ead83ae53a8bca95$export$83d89fbfd8236492));
///////////////////////////////
var $872b1ea3a0575206$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $872b1ea3a0575206$var$resolveName(resolver, nameOrPromise) {
    return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
        var name, address;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        nameOrPromise
                    ];
                case 1:
                    name = _state.sent();
                    if (typeof name !== "string") $872b1ea3a0575206$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
                    // If it is already an address, just use it (after adding checksum)
                    try {
                        return [
                            2,
                            (0, $77ffbd0470aad2fd$export$88411125f012957a)(name)
                        ];
                    } catch (error) {}
                    if (!resolver) $872b1ea3a0575206$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "resolveName"
                    });
                    return [
                        4,
                        resolver.resolveName(name)
                    ];
                case 2:
                    address = _state.sent();
                    if (address == null) $872b1ea3a0575206$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
                    return [
                        2,
                        address
                    ];
            }
        });
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $872b1ea3a0575206$var$resolveAddresses(resolver, value, paramType) {
    return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!Array.isArray(paramType)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(paramType.map(function(paramType, index) {
                            return $872b1ea3a0575206$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    if (!(paramType.type === "address")) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $872b1ea3a0575206$var$resolveName(resolver, value)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    if (!(paramType.type === "tuple")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        $872b1ea3a0575206$var$resolveAddresses(resolver, value, paramType.components)
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    if (!(paramType.baseType === "array")) return [
                        3,
                        8
                    ];
                    if (!Array.isArray(value)) return [
                        2,
                        Promise.reject($872b1ea3a0575206$var$logger.makeError("invalid value for array", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                            argument: "value",
                            value: value
                        }))
                    ];
                    return [
                        4,
                        Promise.all(value.map(function(v) {
                            return $872b1ea3a0575206$var$resolveAddresses(resolver, v, paramType.arrayChildren);
                        }))
                    ];
                case 7:
                    return [
                        2,
                        _state.sent()
                    ];
                case 8:
                    return [
                        2,
                        value
                    ];
            }
        });
    });
}
function $872b1ea3a0575206$var$populateTransaction(contract, fragment, args) {
    return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
        var _this, overrides, resolved, data, tx, ro, intrinsic, bytes, i, roValue, leftovers;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    // If an extra argument is given, it is overrides
                    overrides = {};
                    if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $8832fb576a60463b$export$9c13236873b118a5)(args.pop());
                    // Make sure the parameter count matches
                    $872b1ea3a0575206$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
                    // Populate "from" override (allow promises)
                    if (contract.signer) {
                        if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
                        // but we allow overriding "from" if it matches the signer
                        overrides.from = (0, $8832fb576a60463b$export$d503dd157d963b60)({
                            override: $872b1ea3a0575206$var$resolveName(contract.signer, overrides.from),
                            signer: contract.signer.getAddress()
                        }).then(function(check) {
                            return $872b1ea3a0575206$var$__awaiter(_this, void 0, void 0, function() {
                                return (0, $6qu4b.__generator)(this, function(_state) {
                                    if ((0, $77ffbd0470aad2fd$export$88411125f012957a)(check.signer) !== check.override) $872b1ea3a0575206$var$logger.throwError("Contract with a Signer cannot override from", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                        operation: "overrides.from"
                                    });
                                    return [
                                        2,
                                        check.override
                                    ];
                                });
                            });
                        });
                        else overrides.from = contract.signer.getAddress();
                    } else if (overrides.from) overrides.from = $872b1ea3a0575206$var$resolveName(contract.provider, overrides.from);
                    return [
                        4,
                        (0, $8832fb576a60463b$export$d503dd157d963b60)({
                            args: $872b1ea3a0575206$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
                            address: contract.resolvedAddress,
                            overrides: (0, $8832fb576a60463b$export$d503dd157d963b60)(overrides) || {}
                        })
                    ];
                case 1:
                    resolved = _state.sent();
                    // The ABI coded transaction
                    data = contract.interface.encodeFunctionData(fragment, resolved.args);
                    tx = {
                        data: data,
                        to: resolved.address
                    };
                    // Resolved Overrides
                    ro = resolved.overrides;
                    // Populate simple overrides
                    if (ro.nonce != null) tx.nonce = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(ro.nonce).toNumber();
                    if (ro.gasLimit != null) tx.gasLimit = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(ro.gasLimit);
                    if (ro.gasPrice != null) tx.gasPrice = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(ro.gasPrice);
                    if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(ro.maxFeePerGas);
                    if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(ro.maxPriorityFeePerGas);
                    if (ro.from != null) tx.from = ro.from;
                    if (ro.type != null) tx.type = ro.type;
                    if (ro.accessList != null) tx.accessList = (0, $fd7cc3a32c93c53c$export$6c8662b1600dce2)(ro.accessList);
                    // If there was no "gasLimit" override, but the ABI specifies a default, use it
                    if (tx.gasLimit == null && fragment.gas != null) {
                        // Compute the intrinsic gas cost for this transaction
                        // @TODO: This is based on the yellow paper as of Petersburg; this is something
                        // we may wish to parameterize in v6 as part of the Network object. Since this
                        // is always a non-nil to address, we can ignore G_create, but may wish to add
                        // similar logic to the ContractFactory.
                        intrinsic = 21000;
                        bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
                        for(i = 0; i < bytes.length; i++){
                            intrinsic += 4;
                            if (bytes[i]) intrinsic += 64;
                        }
                        tx.gasLimit = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(fragment.gas).add(intrinsic);
                    }
                    // Populate "value" override
                    if (ro.value) {
                        roValue = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(ro.value);
                        if (!roValue.isZero() && !fragment.payable) $872b1ea3a0575206$var$logger.throwError("non-payable method cannot override value", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.value",
                            value: overrides.value
                        });
                        tx.value = roValue;
                    }
                    if (ro.customData) tx.customData = (0, $8832fb576a60463b$export$9c13236873b118a5)(ro.customData);
                    if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
                    // Remove the overrides
                    delete overrides.nonce;
                    delete overrides.gasLimit;
                    delete overrides.gasPrice;
                    delete overrides.from;
                    delete overrides.value;
                    delete overrides.type;
                    delete overrides.accessList;
                    delete overrides.maxFeePerGas;
                    delete overrides.maxPriorityFeePerGas;
                    delete overrides.customData;
                    delete overrides.ccipReadEnabled;
                    // Make sure there are no stray overrides, which may indicate a
                    // typo or using an unsupported key.
                    leftovers = Object.keys(overrides).filter(function(key) {
                        return overrides[key] != null;
                    });
                    if (leftovers.length) $872b1ea3a0575206$var$logger.throwError("cannot override ".concat(leftovers.map(function(l) {
                        return JSON.stringify(l);
                    }).join(",")), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides",
                        overrides: leftovers
                    });
                    return [
                        2,
                        tx
                    ];
            }
        });
    });
}
function $872b1ea3a0575206$var$buildPopulate(contract, fragment) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $872b1ea3a0575206$var$populateTransaction(contract, fragment, args);
    };
}
function $872b1ea3a0575206$var$buildEstimate(contract, fragment) {
    var signerOrProvider = contract.signer || contract.provider;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
            var tx;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!signerOrProvider) $872b1ea3a0575206$var$logger.throwError("estimate require a provider or signer", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "estimateGas"
                        });
                        return [
                            4,
                            $872b1ea3a0575206$var$populateTransaction(contract, fragment, args)
                        ];
                    case 1:
                        tx = _state.sent();
                        return [
                            4,
                            signerOrProvider.estimateGas(tx)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
    };
}
function $872b1ea3a0575206$var$addContractWait(contract, tx) {
    var wait = tx.wait.bind(tx);
    tx.wait = function(confirmations) {
        return wait(confirmations).then(function(receipt) {
            receipt.events = receipt.logs.map(function(log) {
                var event = (0, $8832fb576a60463b$export$6c40052bed430212)(log);
                var parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = function(data, topics) {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = function() {
                    return contract.provider;
                };
                event.getBlock = function() {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = function() {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $872b1ea3a0575206$var$buildCall(contract, fragment, collapseSimple) {
    var signerOrProvider = contract.signer || contract.provider;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
            var blockTag, overrides, tx, result, value;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Extract the "blockTag" override if present
                        blockTag = undefined;
                        if (!(args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object")) return [
                            3,
                            3
                        ];
                        overrides = (0, $8832fb576a60463b$export$9c13236873b118a5)(args.pop());
                        if (!(overrides.blockTag != null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            overrides.blockTag
                        ];
                    case 1:
                        blockTag = _state.sent();
                        _state.label = 2;
                    case 2:
                        delete overrides.blockTag;
                        args.push(overrides);
                        _state.label = 3;
                    case 3:
                        if (!(contract.deployTransaction != null)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            contract._deployed(blockTag)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            4,
                            $872b1ea3a0575206$var$populateTransaction(contract, fragment, args)
                        ];
                    case 6:
                        tx = _state.sent();
                        return [
                            4,
                            signerOrProvider.call(tx, blockTag)
                        ];
                    case 7:
                        result = _state.sent();
                        try {
                            value = contract.interface.decodeFunctionResult(fragment, result);
                            if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                            return [
                                2,
                                value
                            ];
                        } catch (error) {
                            if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION) {
                                error.address = contract.address;
                                error.args = args;
                                error.transaction = tx;
                            }
                            throw error;
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
}
function $872b1ea3a0575206$var$buildSend(contract, fragment) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
            var txRequest, tx;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!contract.signer) $872b1ea3a0575206$var$logger.throwError("sending a transaction requires a signer", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "sendTransaction"
                        });
                        if (!(contract.deployTransaction != null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            contract._deployed()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            $872b1ea3a0575206$var$populateTransaction(contract, fragment, args)
                        ];
                    case 3:
                        txRequest = _state.sent();
                        return [
                            4,
                            contract.signer.sendTransaction(txRequest)
                        ];
                    case 4:
                        tx = _state.sent();
                        // Tweak the tx.wait so the receipt has extra properties
                        $872b1ea3a0575206$var$addContractWait(contract, tx);
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
    };
}
function $872b1ea3a0575206$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $872b1ea3a0575206$var$buildCall(contract, fragment, collapseSimple);
    return $872b1ea3a0575206$var$buildSend(contract, fragment);
}
function $872b1ea3a0575206$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map(function(topic) {
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
var $872b1ea3a0575206$var$RunningEvent = /*#__PURE__*/ function() {
    function RunningEvent(tag, filter) {
        (0, $7dKN1._)(this, RunningEvent);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "tag", tag);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "filter", filter);
        this._listeners = [];
    }
    (0, $eW5pA._)(RunningEvent, [
        {
            key: "addListener",
            value: function addListener(listener, once) {
                this._listeners.push({
                    listener: listener,
                    once: once
                });
            }
        },
        {
            key: "removeListener",
            value: function removeListener(listener) {
                var done = false;
                this._listeners = this._listeners.filter(function(item) {
                    if (done || item.listener !== listener) return true;
                    done = true;
                    return false;
                });
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners() {
                this._listeners = [];
            }
        },
        {
            key: "listeners",
            value: function listeners() {
                return this._listeners.map(function(i) {
                    return i.listener;
                });
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount() {
                return this._listeners.length;
            }
        },
        {
            key: "run",
            value: function run(args) {
                var _this = this;
                var listenerCount = this.listenerCount();
                this._listeners = this._listeners.filter(function(item) {
                    var argsCopy = args.slice();
                    // Call the callback in the next event loop
                    setTimeout(function() {
                        item.listener.apply(_this, argsCopy);
                    }, 0);
                    // Reschedule it if it not "once"
                    return !item.once;
                });
                return listenerCount;
            }
        },
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {}
        },
        {
            // Returns the array that will be applied to an emit
            key: "getEmit",
            value: function getEmit(event) {
                return [
                    event
                ];
            }
        }
    ]);
    return RunningEvent;
}();
var $872b1ea3a0575206$var$ErrorRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $cgJ2Y._)(ErrorRunningEvent, RunningEvent);
    var _super = (0, $hKD8n._)(ErrorRunningEvent);
    function ErrorRunningEvent() {
        (0, $7dKN1._)(this, ErrorRunningEvent);
        return _super.call(this, "error", null);
    }
    return ErrorRunningEvent;
}($872b1ea3a0575206$var$RunningEvent);
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
var $872b1ea3a0575206$var$FragmentRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $cgJ2Y._)(FragmentRunningEvent, RunningEvent);
    var _super = (0, $hKD8n._)(FragmentRunningEvent);
    function FragmentRunningEvent(address, contractInterface, fragment, topics) {
        (0, $7dKN1._)(this, FragmentRunningEvent);
        var _this;
        var filter = {
            address: address
        };
        var topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $872b1ea3a0575206$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        _this = _super.call(this, $872b1ea3a0575206$var$getEventTag(filter), filter);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "address", address);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "interface", contractInterface);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "fragment", fragment);
        return _this;
    }
    (0, $eW5pA._)(FragmentRunningEvent, [
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {
                var _this = this;
                (0, $2Nfql._)((0, $fG73q._)(FragmentRunningEvent.prototype), "prepareEvent", this).call(this, event);
                event.event = this.fragment.name;
                event.eventSignature = this.fragment.format();
                event.decode = function(data, topics) {
                    return _this.interface.decodeEventLog(_this.fragment, data, topics);
                };
                try {
                    event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
                } catch (error) {
                    event.args = null;
                    event.decodeError = error;
                }
            }
        },
        {
            key: "getEmit",
            value: function getEmit(event) {
                var errors = (0, $cf95945b1659ac47$export$5546b9ec21157cc2)(event.args);
                if (errors.length) throw errors[0].error;
                var args = (event.args || []).slice();
                args.push(event);
                return args;
            }
        }
    ]);
    return FragmentRunningEvent;
}($872b1ea3a0575206$var$RunningEvent);
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
var $872b1ea3a0575206$var$WildcardRunningEvent = /*#__PURE__*/ function(RunningEvent) {
    (0, $cgJ2Y._)(WildcardRunningEvent, RunningEvent);
    var _super = (0, $hKD8n._)(WildcardRunningEvent);
    function WildcardRunningEvent(address, contractInterface) {
        (0, $7dKN1._)(this, WildcardRunningEvent);
        var _this;
        _this = _super.call(this, "*", {
            address: address
        });
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "address", address);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "interface", contractInterface);
        return _this;
    }
    (0, $eW5pA._)(WildcardRunningEvent, [
        {
            key: "prepareEvent",
            value: function prepareEvent(event) {
                var _this = this;
                (0, $2Nfql._)((0, $fG73q._)(WildcardRunningEvent.prototype), "prepareEvent", this).call(this, event);
                try {
                    var parsed = this.interface.parseLog(event);
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                    event.decode = function(data, topics) {
                        return _this.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.args = parsed.args;
                } catch (error) {
                // No matching event
                }
            }
        }
    ]);
    return WildcardRunningEvent;
}($872b1ea3a0575206$var$RunningEvent);
var $872b1ea3a0575206$export$304faa4fc17528db = /*#__PURE__*/ function _target() {
    function BaseContract(addressOrName, contractInterface, signerOrProvider) {
        var _this = this;
        (0, $7dKN1._)(this, BaseContract);
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "interface", (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof BaseContract ? this.constructor : void 0, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "provider", null);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "signer", null);
        } else if ((0, $3e3669d74ee1fde3$export$fdf54fdde81cc9f0).isSigner(signerOrProvider)) {
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "provider", signerOrProvider.provider || null);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "signer", signerOrProvider);
        } else if ((0, $fc170b81a17b0865$export$2881499e37b75b9a).isProvider(signerOrProvider)) {
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "provider", signerOrProvider);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "signer", null);
        } else $872b1ea3a0575206$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "callStatic", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "estimateGas", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "functions", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "populateTransaction", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "filters", {});
        {
            var uniqueFilters = {};
            Object.keys(this.interface.events).forEach(function(eventSignature) {
                var event = _this.interface.events[eventSignature];
                (0, $8832fb576a60463b$export$104236534534f9be)(_this.filters, eventSignature, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return {
                        address: _this.address,
                        topics: _this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach(function(name) {
                var filters = uniqueFilters[name];
                if (filters.length === 1) (0, $8832fb576a60463b$export$104236534534f9be)(_this.filters, name, _this.filters[filters[0]]);
                else $872b1ea3a0575206$var$logger.warn("Duplicate definition of ".concat(name, " (").concat(filters.join(", "), ")"));
            });
        }
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_runningEvents", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_wrappedEmits", {});
        if (addressOrName == null) $872b1ea3a0575206$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "address", addressOrName);
        if (this.provider) (0, $8832fb576a60463b$export$104236534534f9be)(this, "resolvedAddress", $872b1ea3a0575206$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "resolvedAddress", Promise.resolve((0, $77ffbd0470aad2fd$export$88411125f012957a)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $872b1ea3a0575206$var$logger.throwError("provider is required to use ENS name as contract address", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch(function(e) {});
        var uniqueNames = {};
        var uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach(function(signature) {
            var fragment = _this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $872b1ea3a0575206$var$logger.warn("Duplicate ABI entry for ".concat(JSON.stringify(signature)));
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                var name = fragment.name;
                if (!uniqueNames["%".concat(name)]) uniqueNames["%".concat(name)] = [];
                uniqueNames["%".concat(name)].push(signature);
            }
            if (_this[signature] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this, signature, $872b1ea3a0575206$var$buildDefault(_this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (_this.functions[signature] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.functions, signature, $872b1ea3a0575206$var$buildDefault(_this, fragment, false));
            if (_this.callStatic[signature] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.callStatic, signature, $872b1ea3a0575206$var$buildCall(_this, fragment, true));
            if (_this.populateTransaction[signature] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.populateTransaction, signature, $872b1ea3a0575206$var$buildPopulate(_this, fragment));
            if (_this.estimateGas[signature] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.estimateGas, signature, $872b1ea3a0575206$var$buildEstimate(_this, fragment));
        });
        Object.keys(uniqueNames).forEach(function(name) {
            // Ambiguous names to not get attached as bare names
            var signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            var signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (_this[name] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this, name, _this[signature]);
            } catch (e) {}
            if (_this.functions[name] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.functions, name, _this.functions[signature]);
            if (_this.callStatic[name] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.callStatic, name, _this.callStatic[signature]);
            if (_this.populateTransaction[name] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.populateTransaction, name, _this.populateTransaction[signature]);
            if (_this.estimateGas[name] == null) (0, $8832fb576a60463b$export$104236534534f9be)(_this.estimateGas, name, _this.estimateGas[signature]);
        });
    }
    (0, $eW5pA._)(BaseContract, [
        {
            // @TODO: Allow timeout?
            key: "deployed",
            value: function deployed() {
                return this._deployed();
            }
        },
        {
            key: "_deployed",
            value: function _deployed(blockTag) {
                var _this = this;
                if (!this._deployedPromise) {
                    // If we were just deployed, we know the transaction we should occur in
                    if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(function() {
                        return _this;
                    });
                    else // @TODO: Once we allow a timeout to be passed in, we will wait
                    // up to that many blocks for getCode
                    // Otherwise, poll for our code to be deployed
                    this._deployedPromise = this.provider.getCode(this.address, blockTag).then(function(code) {
                        if (code === "0x") $872b1ea3a0575206$var$logger.throwError("contract not deployed", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            contractAddress: _this.address,
                            operation: "getDeployed"
                        });
                        return _this;
                    });
                }
                return this._deployedPromise;
            }
        },
        {
            // @TODO:
            // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
            // @TODO:
            // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
            key: "fallback",
            value: function fallback(overrides) {
                var _this = this;
                if (!this.signer) $872b1ea3a0575206$var$logger.throwError("sending a transactions require a signer", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "sendTransaction(fallback)"
                });
                var tx = (0, $8832fb576a60463b$export$9c13236873b118a5)(overrides || {});
                [
                    "from",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == null) return;
                    $872b1ea3a0575206$var$logger.throwError("cannot override " + key, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: key
                    });
                });
                tx.to = this.resolvedAddress;
                return this.deployed().then(function() {
                    return _this.signer.sendTransaction(tx);
                });
            }
        },
        {
            // Reconnect to a different signer or provider
            key: "connect",
            value: function connect(signerOrProvider) {
                if (typeof signerOrProvider === "string") signerOrProvider = new (0, $3e3669d74ee1fde3$export$7dbc56d9b9612bad)(signerOrProvider, this.provider);
                var contract = new this.constructor(this.address, this.interface, signerOrProvider);
                if (this.deployTransaction) (0, $8832fb576a60463b$export$104236534534f9be)(contract, "deployTransaction", this.deployTransaction);
                return contract;
            }
        },
        {
            // Re-attach to a different on-chain instance of this contract
            key: "attach",
            value: function attach(addressOrName) {
                return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
            }
        },
        {
            key: "_normalizeRunningEvent",
            value: function _normalizeRunningEvent(runningEvent) {
                // Already have an instance of this event running; we can re-use it
                if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
                return runningEvent;
            }
        },
        {
            key: "_getRunningEvent",
            value: function _getRunningEvent(eventName) {
                if (typeof eventName === "string") {
                    // Listen for "error" events (if your contract has an error event, include
                    // the full signature to bypass this special event keyword)
                    if (eventName === "error") return this._normalizeRunningEvent(new $872b1ea3a0575206$var$ErrorRunningEvent());
                    // Listen for any event that is registered
                    if (eventName === "event") return this._normalizeRunningEvent(new $872b1ea3a0575206$var$RunningEvent("event", null));
                    // Listen for any event
                    if (eventName === "*") return this._normalizeRunningEvent(new $872b1ea3a0575206$var$WildcardRunningEvent(this.address, this.interface));
                    // Get the event Fragment (throws if ambiguous/unknown event)
                    var fragment = this.interface.getEvent(eventName);
                    return this._normalizeRunningEvent(new $872b1ea3a0575206$var$FragmentRunningEvent(this.address, this.interface, fragment));
                }
                // We have topics to filter by...
                if (eventName.topics && eventName.topics.length > 0) {
                    // Is it a known topichash? (throws if no matching topichash)
                    try {
                        var topic = eventName.topics[0];
                        if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                        var fragment1 = this.interface.getEvent(topic);
                        return this._normalizeRunningEvent(new $872b1ea3a0575206$var$FragmentRunningEvent(this.address, this.interface, fragment1, eventName.topics));
                    } catch (error) {}
                    // Filter by the unknown topichash
                    var filter = {
                        address: this.address,
                        topics: eventName.topics
                    };
                    return this._normalizeRunningEvent(new $872b1ea3a0575206$var$RunningEvent($872b1ea3a0575206$var$getEventTag(filter), filter));
                }
                return this._normalizeRunningEvent(new $872b1ea3a0575206$var$WildcardRunningEvent(this.address, this.interface));
            }
        },
        {
            key: "_checkRunningEvents",
            value: function _checkRunningEvents(runningEvent) {
                if (runningEvent.listenerCount() === 0) {
                    delete this._runningEvents[runningEvent.tag];
                    // If we have a poller for this, remove it
                    var emit = this._wrappedEmits[runningEvent.tag];
                    if (emit && runningEvent.filter) {
                        this.provider.off(runningEvent.filter, emit);
                        delete this._wrappedEmits[runningEvent.tag];
                    }
                }
            }
        },
        {
            // Subclasses can override this to gracefully recover
            // from parse errors if they wish
            key: "_wrapEvent",
            value: function _wrapEvent(runningEvent, log, listener) {
                var _this = this;
                var event = (0, $8832fb576a60463b$export$6c40052bed430212)(log);
                event.removeListener = function() {
                    if (!listener) return;
                    runningEvent.removeListener(listener);
                    _this._checkRunningEvents(runningEvent);
                };
                event.getBlock = function() {
                    return _this.provider.getBlock(log.blockHash);
                };
                event.getTransaction = function() {
                    return _this.provider.getTransaction(log.transactionHash);
                };
                event.getTransactionReceipt = function() {
                    return _this.provider.getTransactionReceipt(log.transactionHash);
                };
                // This may throw if the topics and data mismatch the signature
                runningEvent.prepareEvent(event);
                return event;
            }
        },
        {
            key: "_addEventListener",
            value: function _addEventListener(runningEvent, listener, once) {
                var _this = this;
                if (!this.provider) $872b1ea3a0575206$var$logger.throwError("events require a provider or a signer with a provider", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "once"
                });
                runningEvent.addListener(listener, once);
                // Track this running event and its listeners (may already be there; but no hard in updating)
                this._runningEvents[runningEvent.tag] = runningEvent;
                // If we are not polling the provider, start polling
                if (!this._wrappedEmits[runningEvent.tag]) {
                    var wrappedEmit = function(log) {
                        var event = _this._wrapEvent(runningEvent, log, listener);
                        // Try to emit the result for the parameterized event...
                        if (event.decodeError == null) try {
                            var args = runningEvent.getEmit(event);
                            _this.emit.apply(_this, [
                                runningEvent.filter
                            ].concat((0, $gF0bR._)(args)));
                        } catch (error) {
                            event.decodeError = error.error;
                        }
                        // Always emit "event" for fragment-base events
                        if (runningEvent.filter != null) _this.emit("event", event);
                        // Emit "error" if there was an error
                        if (event.decodeError != null) _this.emit("error", event.decodeError, event);
                    };
                    this._wrappedEmits[runningEvent.tag] = wrappedEmit;
                    // Special events, like "error" do not have a filter
                    if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
                }
            }
        },
        {
            key: "queryFilter",
            value: function queryFilter(event, fromBlockOrBlockhash, toBlock) {
                var _this = this;
                var runningEvent = this._getRunningEvent(event);
                var filter = (0, $8832fb576a60463b$export$9c13236873b118a5)(runningEvent.filter);
                if (typeof fromBlockOrBlockhash === "string" && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(fromBlockOrBlockhash, 32)) {
                    if (toBlock != null) $872b1ea3a0575206$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
                    filter.blockHash = fromBlockOrBlockhash;
                } else {
                    filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
                    filter.toBlock = toBlock != null ? toBlock : "latest";
                }
                return this.provider.getLogs(filter).then(function(logs) {
                    return logs.map(function(log) {
                        return _this._wrapEvent(runningEvent, log, null);
                    });
                });
            }
        },
        {
            key: "on",
            value: function on(event, listener) {
                this._addEventListener(this._getRunningEvent(event), listener, false);
                return this;
            }
        },
        {
            key: "once",
            value: function once(event, listener) {
                this._addEventListener(this._getRunningEvent(event), listener, true);
                return this;
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!this.provider) return false;
                var runningEvent = this._getRunningEvent(eventName);
                var result = runningEvent.run(args) > 0;
                // May have drained all the "once" events; check for living events
                this._checkRunningEvents(runningEvent);
                return result;
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                var _this = this;
                if (!this.provider) return 0;
                if (eventName == null) return Object.keys(this._runningEvents).reduce(function(accum, key) {
                    return accum + _this._runningEvents[key].listenerCount();
                }, 0);
                return this._getRunningEvent(eventName).listenerCount();
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                if (!this.provider) return [];
                if (eventName == null) {
                    var result = [];
                    for(var tag in this._runningEvents)this._runningEvents[tag].listeners().forEach(function(listener) {
                        result.push(listener);
                    });
                    return result;
                }
                return this._getRunningEvent(eventName).listeners();
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                if (!this.provider) return this;
                if (eventName == null) {
                    for(var tag in this._runningEvents){
                        var runningEvent = this._runningEvents[tag];
                        runningEvent.removeAllListeners();
                        this._checkRunningEvents(runningEvent);
                    }
                    return this;
                }
                // Delete any listeners
                var runningEvent1 = this._getRunningEvent(eventName);
                runningEvent1.removeAllListeners();
                this._checkRunningEvents(runningEvent1);
                return this;
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                if (!this.provider) return this;
                var runningEvent = this._getRunningEvent(eventName);
                runningEvent.removeListener(listener);
                this._checkRunningEvents(runningEvent);
                return this;
            }
        },
        {
            key: "removeListener",
            value: function removeListener(eventName, listener) {
                return this.off(eventName, listener);
            }
        }
    ], [
        {
            key: "getContractAddress",
            value: function getContractAddress1(transaction) {
                return (0, $77ffbd0470aad2fd$export$b7fbffef12272e40)(transaction);
            }
        },
        {
            key: "getInterface",
            value: function getInterface(contractInterface) {
                if ((0, $52cdf212653b6230$export$48cefb51a4e315b2).isInterface(contractInterface)) return contractInterface;
                return new (0, $52cdf212653b6230$export$48cefb51a4e315b2)(contractInterface);
            }
        },
        {
            key: "isIndexed",
            value: function isIndexed(value) {
                return (0, $52cdf212653b6230$export$8ef99100a3c56f8c).isIndexed(value);
            }
        }
    ]);
    return BaseContract;
}();
var $872b1ea3a0575206$export$8517d80acf00e19a = /*#__PURE__*/ function(BaseContract) {
    (0, $cgJ2Y._)(Contract, BaseContract);
    var _super = (0, $hKD8n._)(Contract);
    function Contract() {
        (0, $7dKN1._)(this, Contract);
        return _super.apply(this, arguments);
    }
    return Contract;
}($872b1ea3a0575206$export$304faa4fc17528db);
var $872b1ea3a0575206$export$505569a6bf584fd9 = /*#__PURE__*/ function _target() {
    function ContractFactory(contractInterface, bytecode, signer) {
        (0, $7dKN1._)(this, ContractFactory);
        var bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $b8b53b1cc922c9da$export$c6fabfbfd097fc30)(bytecode)) bytecodeHex = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(bytecodeHex) || bytecodeHex.length % 2) $872b1ea3a0575206$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $3e3669d74ee1fde3$export$fdf54fdde81cc9f0).isSigner(signer)) $872b1ea3a0575206$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "bytecode", bytecodeHex);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "interface", (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof ContractFactory ? this.constructor : void 0, "getInterface")(contractInterface));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "signer", signer || null);
    }
    (0, $eW5pA._)(ContractFactory, [
        {
            // @TODO: Future; rename to populateTransaction?
            key: "getDeployTransaction",
            value: function getDeployTransaction() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var tx = {};
                // If we have 1 additional argument, we allow transaction overrides
                if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                    tx = (0, $8832fb576a60463b$export$9c13236873b118a5)(args.pop());
                    for(var key in tx){
                        if (!$872b1ea3a0575206$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
                    }
                }
                // Do not allow these to be overridden in a deployment transaction
                [
                    "data",
                    "from",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == null) return;
                    $872b1ea3a0575206$var$logger.throwError("cannot override " + key, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: key
                    });
                });
                if (tx.value) {
                    var value = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(tx.value);
                    if (!value.isZero() && !this.interface.deploy.payable) $872b1ea3a0575206$var$logger.throwError("non-payable constructor cannot override value", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.value",
                        value: tx.value
                    });
                }
                // Make sure the call matches the constructor signature
                $872b1ea3a0575206$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
                // Set the data to the bytecode + the encoded constructor arguments
                tx.data = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    this.bytecode,
                    this.interface.encodeDeploy(args)
                ]));
                return tx;
            }
        },
        {
            key: "deploy",
            value: function deploy() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return $872b1ea3a0575206$var$__awaiter(this, void 0, void 0, function() {
                    var overrides, params, unsignedTx, tx, address, contract;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                overrides = {};
                                // If 1 extra parameter was passed in, it contains overrides
                                if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
                                // Make sure the call matches the constructor signature
                                $872b1ea3a0575206$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
                                return [
                                    4,
                                    $872b1ea3a0575206$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs)
                                ];
                            case 1:
                                params = _state.sent();
                                params.push(overrides);
                                // Get the deployment transaction (with optional overrides)
                                unsignedTx = this.getDeployTransaction.apply(this, (0, $gF0bR._)(params));
                                return [
                                    4,
                                    this.signer.sendTransaction(unsignedTx)
                                ];
                            case 2:
                                tx = _state.sent();
                                address = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "getContractAddress")(tx);
                                contract = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "getContract")(address, this.interface, this.signer);
                                // Add the modified wait that wraps events
                                $872b1ea3a0575206$var$addContractWait(contract, tx);
                                (0, $8832fb576a60463b$export$104236534534f9be)(contract, "deployTransaction", tx);
                                return [
                                    2,
                                    contract
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "attach",
            value: function attach(address) {
                return this.constructor.getContract(address, this.interface, this.signer);
            }
        },
        {
            key: "connect",
            value: function connect(signer) {
                return new this.constructor(this.interface, this.bytecode, signer);
            }
        }
    ], [
        {
            key: "fromSolidity",
            value: function fromSolidity(compilerOutput, signer) {
                if (compilerOutput == null) $872b1ea3a0575206$var$logger.throwError("missing compiler output", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.MISSING_ARGUMENT, {
                    argument: "compilerOutput"
                });
                if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
                var abi = compilerOutput.abi;
                var bytecode = null;
                if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
                else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
                return new this(abi, bytecode, signer);
            }
        },
        {
            key: "getInterface",
            value: function getInterface(contractInterface) {
                return $872b1ea3a0575206$export$8517d80acf00e19a.getInterface(contractInterface);
            }
        },
        {
            key: "getContractAddress",
            value: function getContractAddress1(tx) {
                return (0, $77ffbd0470aad2fd$export$b7fbffef12272e40)(tx);
            }
        },
        {
            key: "getContract",
            value: function getContract(address, contractInterface, signer) {
                return new $872b1ea3a0575206$export$8517d80acf00e19a(address, contractInterface, signer);
            }
        }
    ]);
    return ContractFactory;
}();



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $aVMuR = parcelRequire("aVMuR");




"use strict";
var $44cb5ef3e3762151$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $4780727a72442bf5$export$83d89fbfd8236492));
var $44cb5ef3e3762151$var$_constructorGuard = {};
var $44cb5ef3e3762151$var$Zero = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(0);
var $44cb5ef3e3762151$var$NegativeOne = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(-1);
function $44cb5ef3e3762151$var$throwFault(message, fault, operation, value) {
    var params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $44cb5ef3e3762151$var$logger.throwError(message, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
var $44cb5ef3e3762151$var$zeros = "0";
while($44cb5ef3e3762151$var$zeros.length < 256)$44cb5ef3e3762151$var$zeros += $44cb5ef3e3762151$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $44cb5ef3e3762151$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $44cb5ef3e3762151$var$zeros.substring(0, decimals);
    return $44cb5ef3e3762151$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $44cb5ef3e3762151$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    var multiplier = $44cb5ef3e3762151$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
    var negative = value.lt($44cb5ef3e3762151$var$Zero);
    if (negative) value = value.mul($44cb5ef3e3762151$var$NegativeOne);
    var fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $44cb5ef3e3762151$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    var multiplier = $44cb5ef3e3762151$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    var negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $44cb5ef3e3762151$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    var comps = value.split(".");
    if (comps.length > 2) $44cb5ef3e3762151$var$logger.throwArgumentError("too many decimal points", "value", value);
    var whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $44cb5ef3e3762151$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    var wholeValue = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(whole);
    var fractionValue = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(fraction);
    var wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($44cb5ef3e3762151$var$NegativeOne);
    return wei;
}
var $44cb5ef3e3762151$export$1f3ec5b8f47ebd4d = /*#__PURE__*/ function() {
    function FixedFormat(constructorGuard, signed, width, decimals) {
        (0, $7dKN1._)(this, FixedFormat);
        if (constructorGuard !== $44cb5ef3e3762151$var$_constructorGuard) $44cb5ef3e3762151$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $44cb5ef3e3762151$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    (0, $eW5pA._)(FixedFormat, null, [
        {
            key: "from",
            value: function from(value) {
                if (value instanceof FixedFormat) return value;
                if (typeof value === "number") value = "fixed128x".concat(value);
                var signed = true;
                var width = 128;
                var decimals = 18;
                if (typeof value === "string") {
                    if (value === "fixed") ;
                    else if (value === "ufixed") signed = false;
                    else {
                        var match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                        if (!match) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid fixed format", "format", value);
                        signed = match[1] !== "u";
                        width = parseInt(match[2]);
                        decimals = parseInt(match[3]);
                    }
                } else if (value) {
                    var check = function(key, type, defaultValue) {
                        if (value[key] == null) return defaultValue;
                        if ((0, $aVMuR._)(value[key]) !== type) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                        return value[key];
                    };
                    signed = check("signed", "boolean", signed);
                    width = check("width", "number", width);
                    decimals = check("decimals", "number", decimals);
                }
                if (width % 8) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
                if (decimals > 80) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
                return new FixedFormat($44cb5ef3e3762151$var$_constructorGuard, signed, width, decimals);
            }
        }
    ]);
    return FixedFormat;
}();
var $44cb5ef3e3762151$export$d4693c66c2213e45 = /*#__PURE__*/ function() {
    function FixedNumber(constructorGuard, hex, value, format) {
        (0, $7dKN1._)(this, FixedNumber);
        if (constructorGuard !== $44cb5ef3e3762151$var$_constructorGuard) $44cb5ef3e3762151$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    (0, $eW5pA._)(FixedNumber, [
        {
            key: "_checkFormat",
            value: function _checkFormat(other) {
                if (this.format.name !== other.format.name) $44cb5ef3e3762151$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
            }
        },
        {
            key: "addUnsafe",
            value: function addUnsafe(other) {
                this._checkFormat(other);
                var a = $44cb5ef3e3762151$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44cb5ef3e3762151$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
            }
        },
        {
            key: "subUnsafe",
            value: function subUnsafe(other) {
                this._checkFormat(other);
                var a = $44cb5ef3e3762151$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44cb5ef3e3762151$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
            }
        },
        {
            key: "mulUnsafe",
            value: function mulUnsafe(other) {
                this._checkFormat(other);
                var a = $44cb5ef3e3762151$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44cb5ef3e3762151$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
            }
        },
        {
            key: "divUnsafe",
            value: function divUnsafe(other) {
                this._checkFormat(other);
                var a = $44cb5ef3e3762151$export$1b039987e86d7269(this._value, this.format.decimals);
                var b = $44cb5ef3e3762151$export$1b039987e86d7269(other._value, other.format.decimals);
                return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
            }
        },
        {
            key: "floor",
            value: function floor() {
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                var result = FixedNumber.from(comps[0], this.format);
                var hasFraction = !comps[1].match(/^(0*)$/);
                if (this.isNegative() && hasFraction) result = result.subUnsafe($44cb5ef3e3762151$var$ONE.toFormat(result.format));
                return result;
            }
        },
        {
            key: "ceiling",
            value: function ceiling() {
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                var result = FixedNumber.from(comps[0], this.format);
                var hasFraction = !comps[1].match(/^(0*)$/);
                if (!this.isNegative() && hasFraction) result = result.addUnsafe($44cb5ef3e3762151$var$ONE.toFormat(result.format));
                return result;
            }
        },
        {
            // @TODO: Support other rounding algorithms
            key: "round",
            value: function round(decimals) {
                if (decimals == null) decimals = 0;
                // If we are already in range, we're done
                var comps = this.toString().split(".");
                if (comps.length === 1) comps.push("0");
                if (decimals < 0 || decimals > 80 || decimals % 1) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
                if (comps[1].length <= decimals) return this;
                var factor = FixedNumber.from("1" + $44cb5ef3e3762151$var$zeros.substring(0, decimals), this.format);
                var bump = $44cb5ef3e3762151$var$BUMP.toFormat(this.format);
                return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return this._value === "0.0" || this._value === "0";
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._value[0] === "-";
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._value;
            }
        },
        {
            key: "toHexString",
            value: function toHexString(width) {
                if (width == null) return this._hex;
                if (width % 8) $44cb5ef3e3762151$var$logger.throwArgumentError("invalid byte width", "width", width);
                var hex = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
                return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(hex, width / 8);
            }
        },
        {
            key: "toUnsafeFloat",
            value: function toUnsafeFloat() {
                return parseFloat(this.toString());
            }
        },
        {
            key: "toFormat",
            value: function toFormat(format) {
                return FixedNumber.fromString(this._value, format);
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(value, decimals, format) {
                // If decimals looks more like a format, and there is no format, shift the parameters
                if (format == null && decimals != null && !(0, $3b33bab384c8baec$export$a3d0a7fa9b65683b)(decimals)) {
                    format = decimals;
                    decimals = null;
                }
                if (decimals == null) decimals = 0;
                if (format == null) format = "fixed";
                return FixedNumber.fromString($44cb5ef3e3762151$export$cc011b843b5d69f2(value, decimals), $44cb5ef3e3762151$export$1f3ec5b8f47ebd4d.from(format));
            }
        },
        {
            key: "fromString",
            value: function fromString(value, format) {
                if (format == null) format = "fixed";
                var fixedFormat = $44cb5ef3e3762151$export$1f3ec5b8f47ebd4d.from(format);
                var numeric = $44cb5ef3e3762151$export$1b039987e86d7269(value, fixedFormat.decimals);
                if (!fixedFormat.signed && numeric.lt($44cb5ef3e3762151$var$Zero)) $44cb5ef3e3762151$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
                var hex = null;
                if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
                else {
                    hex = numeric.toHexString();
                    hex = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(hex, fixedFormat.width / 8);
                }
                var decimal = $44cb5ef3e3762151$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
                return new FixedNumber($44cb5ef3e3762151$var$_constructorGuard, hex, decimal, fixedFormat);
            }
        },
        {
            key: "fromBytes",
            value: function fromBytes(value, format) {
                if (format == null) format = "fixed";
                var fixedFormat = $44cb5ef3e3762151$export$1f3ec5b8f47ebd4d.from(format);
                if ((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value).length > fixedFormat.width / 8) throw new Error("overflow");
                var numeric = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
                if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
                var hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
                var decimal = $44cb5ef3e3762151$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
                return new FixedNumber($44cb5ef3e3762151$var$_constructorGuard, hex, decimal, fixedFormat);
            }
        },
        {
            key: "from",
            value: function from(value, format) {
                if (typeof value === "string") return FixedNumber.fromString(value, format);
                if ((0, $b8b53b1cc922c9da$export$c6fabfbfd097fc30)(value)) return FixedNumber.fromBytes(value, format);
                try {
                    return FixedNumber.fromValue(value, 0, format);
                } catch (error) {
                    // Allow NUMERIC_FAULT to bubble up
                    if (error.code !== (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT) throw error;
                }
                return $44cb5ef3e3762151$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
            }
        },
        {
            key: "isFixedNumber",
            value: function isFixedNumber(value) {
                return !!(value && value._isFixedNumber);
            }
        }
    ]);
    return FixedNumber;
}();
var $44cb5ef3e3762151$var$ONE = $44cb5ef3e3762151$export$d4693c66c2213e45.from(1);
var $44cb5ef3e3762151$var$BUMP = $44cb5ef3e3762151$export$d4693c66c2213e45.from("0.5");




var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");





var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $6qu4b = parcelRequire("6qu4b");






var $5903d51e6964a77f$export$83d89fbfd8236492 = "hash/5.7.0";



var $48669d0386352f19$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $48669d0386352f19$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $5903d51e6964a77f$export$83d89fbfd8236492));
var $48669d0386352f19$var$padding = new Uint8Array(32);
$48669d0386352f19$var$padding.fill(0);
var $48669d0386352f19$var$NegativeOne = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(-1);
var $48669d0386352f19$var$Zero = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(0);
var $48669d0386352f19$var$One = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(1);
var $48669d0386352f19$var$MaxUint256 = (0, $3b33bab384c8baec$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $48669d0386352f19$var$hexPadRight(value) {
    var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
    var padOffset = bytes.length % 32;
    if (padOffset) return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
        bytes,
        $48669d0386352f19$var$padding.slice(padOffset)
    ]);
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes);
}
var $48669d0386352f19$var$hexTrue = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)($48669d0386352f19$var$One.toHexString(), 32);
var $48669d0386352f19$var$hexFalse = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)($48669d0386352f19$var$Zero.toHexString(), 32);
var $48669d0386352f19$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
var $48669d0386352f19$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $48669d0386352f19$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $48669d0386352f19$var$logger.throwArgumentError("invalid domain value for ".concat(JSON.stringify(key)), "domain.".concat(key), value);
        return value;
    };
}
var $48669d0386352f19$var$domainChecks = {
    name: $48669d0386352f19$var$checkString("name"),
    version: $48669d0386352f19$var$checkString("version"),
    chainId: function chainId(value) {
        try {
            return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value).toString();
        } catch (error) {}
        return $48669d0386352f19$var$logger.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", value);
    },
    verifyingContract: function verifyingContract(value) {
        try {
            return (0, $77ffbd0470aad2fd$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        return $48669d0386352f19$var$logger.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", value);
    },
    salt: function salt(value) {
        try {
            var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes);
        } catch (error) {}
        return $48669d0386352f19$var$logger.throwArgumentError('invalid domain value "salt"', "domain.salt", value);
    }
};
function $48669d0386352f19$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        var match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            var signed = match[1] === "";
            var width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $48669d0386352f19$var$logger.throwArgumentError("invalid numeric width", "type", type);
            var boundsUpper = $48669d0386352f19$var$MaxUint256.mask(signed ? width - 1 : width);
            var boundsLower = signed ? boundsUpper.add($48669d0386352f19$var$One).mul($48669d0386352f19$var$NegativeOne) : $48669d0386352f19$var$Zero;
            return function(value) {
                var v = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $48669d0386352f19$var$logger.throwArgumentError("value out-of-bounds for ".concat(type), "value", value);
                return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        var match1 = type.match(/^bytes(\d+)$/);
        if (match1) {
            var width1 = parseInt(match1[1]);
            if (width1 === 0 || width1 > 32 || match1[1] !== String(width1)) $48669d0386352f19$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
                if (bytes.length !== width1) $48669d0386352f19$var$logger.throwArgumentError("invalid length for ".concat(type), "value", value);
                return $48669d0386352f19$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)((0, $77ffbd0470aad2fd$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $48669d0386352f19$var$hexFalse : $48669d0386352f19$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $48669d0386352f19$var$encodeType(name, fields) {
    return "".concat(name, "(").concat(fields.map(function(param) {
        var _$name = param.name, type = param.type;
        return type + " " + _$name;
    }).join(","), ")");
}
var $48669d0386352f19$export$458ab927ae635c3 = /*#__PURE__*/ function() {
    "use strict";
    function TypedDataEncoder(types) {
        var _loop = function(name) {
            var uniqueNames = {};
            types[name].forEach(function(field) {
                // Check each field has a unique name
                if (uniqueNames[field.name]) $48669d0386352f19$var$logger.throwArgumentError("duplicate variable name ".concat(JSON.stringify(field.name), " in ").concat(JSON.stringify(name)), "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                var baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $48669d0386352f19$var$logger.throwArgumentError("circular type reference to ".concat(JSON.stringify(baseType)), "types", types);
                // Is this a base encoding type?
                var encoder = $48669d0386352f19$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $48669d0386352f19$var$logger.throwArgumentError("unknown type ".concat(JSON.stringify(baseType)), "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        };
        (0, $7dKN1._)(this, TypedDataEncoder);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "types", Object.freeze((0, $8832fb576a60463b$export$6c40052bed430212)(types)));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_encoderCache", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_types", {});
        // Link struct types to their direct child structs
        var links = {};
        // Link structs to structs which contain them as a child
        var parents = {};
        // Link all subtypes within a given struct
        var subtypes = {};
        Object.keys(types).forEach(function(type) {
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(var name in types)_loop(name);
        // Deduce the primary type
        var primaryTypes = Object.keys(parents).filter(function(n) {
            return parents[n].length === 0;
        });
        if (primaryTypes.length === 0) $48669d0386352f19$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $48669d0386352f19$var$logger.throwArgumentError("ambiguous primary types or unused types: ".concat(primaryTypes.map(function(t) {
            return JSON.stringify(t);
        }).join(", ")), "types", types);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $48669d0386352f19$var$logger.throwArgumentError("circular type reference to ".concat(JSON.stringify(type)), "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach(function(child) {
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach(function(subtype) {
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(var name1 in subtypes){
            var st = Object.keys(subtypes[name1]);
            st.sort();
            this._types[name1] = $48669d0386352f19$var$encodeType(name1, types[name1]) + st.map(function(t) {
                return $48669d0386352f19$var$encodeType(t, types[t]);
            }).join("");
        }
    }
    (0, $eW5pA._)(TypedDataEncoder, [
        {
            key: "getEncoder",
            value: function getEncoder(type) {
                var encoder = this._encoderCache[type];
                if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
                return encoder;
            }
        },
        {
            key: "_getEncoder",
            value: function _getEncoder(type) {
                var _this = this;
                // Basic encoder type (address, bool, uint256, etc)
                {
                    var encoder = $48669d0386352f19$var$getBaseEncoder(type);
                    if (encoder) return encoder;
                }
                // Array
                var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
                if (match) {
                    var subtype = match[1];
                    var subEncoder = this.getEncoder(subtype);
                    var length = parseInt(match[3]);
                    return function(value) {
                        if (length >= 0 && value.length !== length) $48669d0386352f19$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                        var result = value.map(subEncoder);
                        if (_this._types[subtype]) result = result.map((0, $aca68b720d4a692f$export$f8151fce47ad1c35));
                        return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$6d4b99629b38754a)(result));
                    };
                }
                // Struct
                var fields = this.types[type];
                if (fields) {
                    var encodedType = (0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(this._types[type]);
                    return function(value) {
                        var values = fields.map(function(param) {
                            var name = param.name, _$type = param.type;
                            var result = _this.getEncoder(_$type)(value[name]);
                            if (_this._types[_$type]) return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(result);
                            return result;
                        });
                        values.unshift(encodedType);
                        return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)(values);
                    };
                }
                return $48669d0386352f19$var$logger.throwArgumentError("unknown type: ".concat(type), "type", type);
            }
        },
        {
            key: "encodeType",
            value: function encodeType(name) {
                var result = this._types[name];
                if (!result) $48669d0386352f19$var$logger.throwArgumentError("unknown type: ".concat(JSON.stringify(name)), "name", name);
                return result;
            }
        },
        {
            key: "encodeData",
            value: function encodeData(type, value) {
                return this.getEncoder(type)(value);
            }
        },
        {
            key: "hashStruct",
            value: function hashStruct(name, value) {
                return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(this.encodeData(name, value));
            }
        },
        {
            key: "encode",
            value: function encode(value) {
                return this.encodeData(this.primaryType, value);
            }
        },
        {
            key: "hash",
            value: function hash(value) {
                return this.hashStruct(this.primaryType, value);
            }
        },
        {
            key: "_visit",
            value: function _visit(type, value, callback) {
                var _this = this;
                // Basic encoder type (address, bool, uint256, etc)
                {
                    var encoder = $48669d0386352f19$var$getBaseEncoder(type);
                    if (encoder) return callback(type, value);
                }
                // Array
                var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
                if (match) {
                    var subtype = match[1];
                    var length = parseInt(match[3]);
                    if (length >= 0 && value.length !== length) $48669d0386352f19$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                    return value.map(function(v) {
                        return _this._visit(subtype, v, callback);
                    });
                }
                // Struct
                var fields = this.types[type];
                if (fields) return fields.reduce(function(accum, param) {
                    var name = param.name, _$type = param.type;
                    accum[name] = _this._visit(_$type, value[name], callback);
                    return accum;
                }, {});
                return $48669d0386352f19$var$logger.throwArgumentError("unknown type: ".concat(type), "type", type);
            }
        },
        {
            key: "visit",
            value: function visit(value, callback) {
                return this._visit(this.primaryType, value, callback);
            }
        }
    ], [
        {
            key: "from",
            value: function from(types) {
                return new TypedDataEncoder(types);
            }
        },
        {
            key: "getPrimaryType",
            value: function getPrimaryType(types) {
                return TypedDataEncoder.from(types).primaryType;
            }
        },
        {
            key: "hashStruct",
            value: function hashStruct(name, types, value) {
                return TypedDataEncoder.from(types).hashStruct(name, value);
            }
        },
        {
            key: "hashDomain",
            value: function hashDomain(domain) {
                var domainFields = [];
                for(var name in domain){
                    var type = $48669d0386352f19$var$domainFieldTypes[name];
                    if (!type) $48669d0386352f19$var$logger.throwArgumentError("invalid typed-data domain key: ".concat(JSON.stringify(name)), "domain", domain);
                    domainFields.push({
                        name: name,
                        type: type
                    });
                }
                domainFields.sort(function(a, b) {
                    return $48669d0386352f19$var$domainFieldNames.indexOf(a.name) - $48669d0386352f19$var$domainFieldNames.indexOf(b.name);
                });
                return TypedDataEncoder.hashStruct("EIP712Domain", {
                    EIP712Domain: domainFields
                }, domain);
            }
        },
        {
            key: "encode",
            value: function encode(domain, types, value) {
                return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                    "0x1901",
                    TypedDataEncoder.hashDomain(domain),
                    TypedDataEncoder.from(types).hash(value)
                ]);
            }
        },
        {
            key: "hash",
            value: function hash(domain, types, value) {
                return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(TypedDataEncoder.encode(domain, types, value));
            }
        },
        {
            key: "resolveNames",
            value: // Replaces all address types with ENS names with their looked up address
            function resolveNames(domain, types, value, resolveName) {
                return $48669d0386352f19$var$__awaiter(this, void 0, void 0, function() {
                    var ensCache, encoder, _tmp, _tmp1, _i, name;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Make a copy to isolate it from the object passed in
                                domain = (0, $8832fb576a60463b$export$9c13236873b118a5)(domain);
                                // Look up all ENS names
                                ensCache = {};
                                // Do we need to look up the domain's verifyingContract?
                                if (domain.verifyingContract && !(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
                                // We are going to use the encoder to visit all the base values
                                encoder = TypedDataEncoder.from(types);
                                // Get a list of all the addresses
                                encoder.visit(value, function(type, value) {
                                    if (type === "address" && !(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
                                    return value;
                                });
                                _tmp = [];
                                for(_tmp1 in ensCache)_tmp.push(_tmp1);
                                _i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(_i < _tmp.length)) return [
                                    3,
                                    4
                                ];
                                name = _tmp[_i];
                                return [
                                    4,
                                    resolveName(name)
                                ];
                            case 2:
                                ensCache[name] = _state.sent();
                                _state.label = 3;
                            case 3:
                                _i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                // Replace the domain verifyingContract if needed
                                if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
                                // Replace all ENS names with their address
                                value = encoder.visit(value, function(type, value) {
                                    if (type === "address" && ensCache[value]) return ensCache[value];
                                    return value;
                                });
                                return [
                                    2,
                                    {
                                        domain: domain,
                                        value: value
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getPayload",
            value: function getPayload(domain, types, value) {
                // Validate the domain fields
                TypedDataEncoder.hashDomain(domain);
                // Derive the EIP712Domain Struct reference type
                var domainValues = {};
                var domainTypes = [];
                $48669d0386352f19$var$domainFieldNames.forEach(function(name) {
                    var _$value = domain[name];
                    if (_$value == null) return;
                    domainValues[name] = $48669d0386352f19$var$domainChecks[name](_$value);
                    domainTypes.push({
                        name: name,
                        type: $48669d0386352f19$var$domainFieldTypes[name]
                    });
                });
                var encoder = TypedDataEncoder.from(types);
                var typesWithDomain = (0, $8832fb576a60463b$export$9c13236873b118a5)(types);
                if (typesWithDomain.EIP712Domain) $48669d0386352f19$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
                else typesWithDomain.EIP712Domain = domainTypes;
                // Validate the data structures and types
                encoder.encode(value);
                return {
                    types: typesWithDomain,
                    domain: domainValues,
                    primaryType: encoder.primaryType,
                    message: encoder.visit(value, function(type, value) {
                        // bytes
                        if (type.match(/^bytes(\d*)/)) return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value));
                        // uint or int
                        if (type.match(/^u?int/)) return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value).toString();
                        switch(type){
                            case "address":
                                return value.toLowerCase();
                            case "bool":
                                return !!value;
                            case "string":
                                if (typeof value !== "string") $48669d0386352f19$var$logger.throwArgumentError("invalid string", "value", value);
                                return value;
                        }
                        return $48669d0386352f19$var$logger.throwArgumentError("unsupported type", "type", type);
                    })
                };
            }
        }
    ]);
    return TypedDataEncoder;
}();




var $c9b75c627427b5da$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $c9b75c627427b5da$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(message);
    return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)($c9b75c627427b5da$export$1ff3fdc4802a2ba6),
        (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");


var $59ddd2fedfa0199a$export$240043ab8e806ec7 = /*#__PURE__*/ function() {
    "use strict";
    function BaseX(alphabet) {
        (0, $7dKN1._)(this, BaseX);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "alphabet", alphabet);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "base", alphabet.length);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_alphabetMap", {});
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(var i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    (0, $eW5pA._)(BaseX, [
        {
            key: "encode",
            value: function encode(value) {
                var source = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
                if (source.length === 0) return "";
                var digits = [
                    0
                ];
                for(var i = 0; i < source.length; ++i){
                    var carry = source[i];
                    for(var j = 0; j < digits.length; ++j){
                        carry += digits[j] << 8;
                        digits[j] = carry % this.base;
                        carry = carry / this.base | 0;
                    }
                    while(carry > 0){
                        digits.push(carry % this.base);
                        carry = carry / this.base | 0;
                    }
                }
                var string = "";
                // deal with leading zeros
                for(var k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
                // convert digits to a string
                for(var q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
                return string;
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                if (typeof value !== "string") throw new TypeError("Expected String");
                var bytes = [];
                if (value.length === 0) return new Uint8Array(bytes);
                bytes.push(0);
                for(var i = 0; i < value.length; i++){
                    var byte = this._alphabetMap[value[i]];
                    if (byte === undefined) throw new Error("Non-base" + this.base + " character");
                    var carry = byte;
                    for(var j = 0; j < bytes.length; ++j){
                        carry += bytes[j] * this.base;
                        bytes[j] = carry & 0xff;
                        carry >>= 8;
                    }
                    while(carry > 0){
                        bytes.push(carry & 0xff);
                        carry >>= 8;
                    }
                }
                // deal with leading zeros
                for(var k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
                return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(new Uint8Array(bytes.reverse()));
            }
        }
    ]);
    return BaseX;
}();
var $59ddd2fedfa0199a$export$cfabb2852920f5ec = new $59ddd2fedfa0199a$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
var $59ddd2fedfa0199a$export$45a587635c9954b2 = new $59ddd2fedfa0199a$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))







var $kZo2m = parcelRequire("kZo2m");

var $0aa4fe98041e6886$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($0aa4fe98041e6886$export$d2a8849cfb277c || ($0aa4fe98041e6886$export$d2a8849cfb277c = {}));



var $a739c9a5a30c5246$export$83d89fbfd8236492 = "sha2/5.7.0";


"use strict";
var $fd8149ac93df5472$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a739c9a5a30c5246$export$83d89fbfd8236492));
function $fd8149ac93df5472$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).ripemd160().update((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $fd8149ac93df5472$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha256().update((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $fd8149ac93df5472$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).sha512().update((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $fd8149ac93df5472$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $0aa4fe98041e6886$export$d2a8849cfb277c)[algorithm]) $fd8149ac93df5472$var$logger.throwError("unsupported algorithm " + algorithm, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kZo2m))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kZo2m)))[algorithm], (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(key)).update((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data)).digest("hex");
}


"use strict";
function $d77b31d152b92f84$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(password);
    salt = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(salt);
    var hLen;
    var l = 1;
    var DK = new Uint8Array(keylen);
    var block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    var r;
    var T;
    for(var i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        var U = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $fd8149ac93df5472$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(var j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $fd8149ac93df5472$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        var destPos = (i - 1) * hLen;
        var len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(T).slice(0, len), destPos);
    }
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(DK);
}







var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");



var $60a5c984c5fc6b0f$export$83d89fbfd8236492 = "wordlists/5.7.0";


"use strict";
// This gets overridden by rollup
var $98bdf1880fe142f1$var$exportWordlist = false;
var $98bdf1880fe142f1$export$af88d00dbe7f521 = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $60a5c984c5fc6b0f$export$83d89fbfd8236492));
var $98bdf1880fe142f1$export$4d9531a8ddb0ebca = /*#__PURE__*/ function _target() {
    function Wordlist(locale) {
        (0, $7dKN1._)(this, Wordlist);
        $98bdf1880fe142f1$export$af88d00dbe7f521.checkAbstract(this instanceof Wordlist ? this.constructor : void 0, Wordlist);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "locale", locale);
    }
    (0, $eW5pA._)(Wordlist, [
        {
            // Subclasses may override this
            key: "split",
            value: function split(mnemonic) {
                return mnemonic.toLowerCase().split(/ +/g);
            }
        },
        {
            // Subclasses may override this
            key: "join",
            value: function join(words) {
                return words.join(" ");
            }
        }
    ], [
        {
            key: "check",
            value: function check(wordlist) {
                var words = [];
                for(var i = 0; i < 2048; i++){
                    var word = wordlist.getWord(i);
                    /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
                    words.push(word);
                }
                return (0, $c31b68ebaa2e080f$export$d560c7e4a29451c2)(words.join("\n") + "\n");
            }
        },
        {
            key: "register",
            value: function register(lang, name) {
                if (!name) name = lang.locale;
                /* istanbul ignore if */ if ($98bdf1880fe142f1$var$exportWordlist) try {
                    var anyGlobal = window;
                    if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                        if (!anyGlobal._ethers.wordlists[name]) (0, $8832fb576a60463b$export$104236534534f9be)(anyGlobal._ethers.wordlists, name, lang);
                    }
                } catch (error) {}
            }
        }
    ]);
    return Wordlist;
}();


"use strict";
var $baeb355dd7dad70c$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
var $baeb355dd7dad70c$var$wordlist = null;
function $baeb355dd7dad70c$var$loadWords(lang) {
    if ($baeb355dd7dad70c$var$wordlist != null) return;
    $baeb355dd7dad70c$var$wordlist = $baeb355dd7dad70c$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $98bdf1880fe142f1$export$4d9531a8ddb0ebca).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $baeb355dd7dad70c$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
var $baeb355dd7dad70c$var$LangEn = /*#__PURE__*/ function(Wordlist) {
    (0, $cgJ2Y._)(LangEn, Wordlist);
    var _super = (0, $hKD8n._)(LangEn);
    function LangEn() {
        (0, $7dKN1._)(this, LangEn);
        return _super.call(this, "en");
    }
    (0, $eW5pA._)(LangEn, [
        {
            key: "getWord",
            value: function getWord(index) {
                $baeb355dd7dad70c$var$loadWords(this);
                return $baeb355dd7dad70c$var$wordlist[index];
            }
        },
        {
            key: "getWordIndex",
            value: function getWordIndex(word) {
                $baeb355dd7dad70c$var$loadWords(this);
                return $baeb355dd7dad70c$var$wordlist.indexOf(word);
            }
        }
    ]);
    return LangEn;
}((0, $98bdf1880fe142f1$export$4d9531a8ddb0ebca));
var $baeb355dd7dad70c$export$a2c9518710cf1f49 = new $baeb355dd7dad70c$var$LangEn();
(0, $98bdf1880fe142f1$export$4d9531a8ddb0ebca).register($baeb355dd7dad70c$export$a2c9518710cf1f49);


"use strict";
var $0a5359b01aeda1c5$export$e8e1b4711c2d1939 = {
    en: (0, $baeb355dd7dad70c$export$a2c9518710cf1f49)
};



var $e4b56ba9d0ae402f$export$83d89fbfd8236492 = "hdnode/5.7.0";


"use strict";
var $1017e67baeca0b33$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $e4b56ba9d0ae402f$export$83d89fbfd8236492));
var $1017e67baeca0b33$var$N = (0, $3b33bab384c8baec$export$d97aa349ed20696).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
var $1017e67baeca0b33$var$MasterSecret = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)("Bitcoin seed");
var $1017e67baeca0b33$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $1017e67baeca0b33$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $1017e67baeca0b33$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $1017e67baeca0b33$var$bytes32(value) {
    return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value), 32);
}
function $1017e67baeca0b33$var$base58check(data) {
    return (0, $59ddd2fedfa0199a$export$45a587635c9954b2).encode((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        data,
        (0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
function $1017e67baeca0b33$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $0a5359b01aeda1c5$export$e8e1b4711c2d1939)["en"];
    if (typeof wordlist === "string") {
        var words = (0, $0a5359b01aeda1c5$export$e8e1b4711c2d1939)[wordlist];
        if (words == null) $1017e67baeca0b33$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
var $1017e67baeca0b33$var$_constructorGuard = {};
var $1017e67baeca0b33$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
var $1017e67baeca0b33$export$b68640c53e22b952 = /*#__PURE__*/ function() {
    function HDNode(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath) {
        (0, $7dKN1._)(this, HDNode);
        /* istanbul ignore if */ if (constructorGuard !== $1017e67baeca0b33$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            var signingKey = new (0, $14bbf95e2a82e6fd$export$21643ca94aed3e83)(privateKey);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "privateKey", signingKey.privateKey);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "privateKey", null);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "publicKey", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(publicKey));
        }
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "parentFingerprint", parentFingerprint);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "fingerprint", (0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $fd8149ac93df5472$export$d1cea0ee4e3f0d3e)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "address", (0, $fd7cc3a32c93c53c$export$e67e2732ba9803f9)(this.publicKey));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "chainCode", chainCode);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "index", index);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "mnemonic", null);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "mnemonic", null);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "mnemonic", mnemonicOrPath);
            (0, $8832fb576a60463b$export$104236534534f9be)(this, "path", mnemonicOrPath.path);
        }
    }
    (0, $eW5pA._)(HDNode, [
        {
            key: "extendedKey",
            get: function get() {
                // We only support the mainnet values for now, but if anyone needs
                // testnet values, let me know. I believe current sentiment is that
                // we should always use mainnet, and use BIP-44 to derive the network
                //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
                //   - Testnet: public=0x043587CF, private=0x04358394
                if (this.depth >= 256) throw new Error("Depth too large!");
                return $1017e67baeca0b33$var$base58check((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
                    (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(this.depth),
                    this.parentFingerprint,
                    (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(this.index), 4),
                    this.chainCode,
                    this.privateKey != null ? (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                        "0x00",
                        this.privateKey
                    ]) : this.publicKey
                ]));
            }
        },
        {
            key: "neuter",
            value: function neuter() {
                return new HDNode($1017e67baeca0b33$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
            }
        },
        {
            key: "_derive",
            value: function _derive(index) {
                if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
                // Base path
                var path = this.path;
                if (path) path += "/" + (index & ~$1017e67baeca0b33$var$HardenedBit);
                var data = new Uint8Array(37);
                if (index & $1017e67baeca0b33$var$HardenedBit) {
                    if (!this.privateKey) throw new Error("cannot derive child of neutered node");
                    // Data = 0x00 || ser_256(k_par)
                    data.set((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(this.privateKey), 1);
                    // Hardened path
                    if (path) path += "'";
                } else // Data = ser_p(point(k_par))
                data.set((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(this.publicKey));
                // Data += ser_32(i)
                for(var i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
                var I = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $fd8149ac93df5472$export$967075d2f3b8e7ff)((0, $0aa4fe98041e6886$export$d2a8849cfb277c).sha512, this.chainCode, data));
                var IL = I.slice(0, 32);
                var IR = I.slice(32);
                // The private key
                var ki = null;
                // The public key
                var Ki = null;
                if (this.privateKey) ki = $1017e67baeca0b33$var$bytes32((0, $3b33bab384c8baec$export$d97aa349ed20696).from(IL).add(this.privateKey).mod($1017e67baeca0b33$var$N));
                else {
                    var ek = new (0, $14bbf95e2a82e6fd$export$21643ca94aed3e83)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(IL));
                    Ki = ek._addPoint(this.publicKey);
                }
                var mnemonicOrPath = path;
                var srcMnemonic = this.mnemonic;
                if (srcMnemonic) mnemonicOrPath = Object.freeze({
                    phrase: srcMnemonic.phrase,
                    path: path,
                    locale: srcMnemonic.locale || "en"
                });
                return new HDNode($1017e67baeca0b33$var$_constructorGuard, ki, Ki, this.fingerprint, $1017e67baeca0b33$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
            }
        },
        {
            key: "derivePath",
            value: function derivePath(path) {
                var components = path.split("/");
                if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
                if (components[0] === "m") components.shift();
                var result = this;
                for(var i = 0; i < components.length; i++){
                    var component = components[i];
                    if (component.match(/^[0-9]+'$/)) {
                        var index = parseInt(component.substring(0, component.length - 1));
                        if (index >= $1017e67baeca0b33$var$HardenedBit) throw new Error("invalid path index - " + component);
                        result = result._derive($1017e67baeca0b33$var$HardenedBit + index);
                    } else if (component.match(/^[0-9]+$/)) {
                        var index1 = parseInt(component);
                        if (index1 >= $1017e67baeca0b33$var$HardenedBit) throw new Error("invalid path index - " + component);
                        result = result._derive(index1);
                    } else throw new Error("invalid path component - " + component);
                }
                return result;
            }
        }
    ], [
        {
            key: "_fromSeed",
            value: function _fromSeed(seed, mnemonic) {
                var seedArray = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(seed);
                if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
                var I = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $fd8149ac93df5472$export$967075d2f3b8e7ff)((0, $0aa4fe98041e6886$export$d2a8849cfb277c).sha512, $1017e67baeca0b33$var$MasterSecret, seedArray));
                return new HDNode($1017e67baeca0b33$var$_constructorGuard, $1017e67baeca0b33$var$bytes32(I.slice(0, 32)), null, "0x00000000", $1017e67baeca0b33$var$bytes32(I.slice(32)), 0, 0, mnemonic);
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(mnemonic, password, wordlist) {
                // If a locale name was passed in, find the associated wordlist
                wordlist = $1017e67baeca0b33$var$getWordlist(wordlist);
                // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
                mnemonic = $1017e67baeca0b33$export$4becd65eb23312e6($1017e67baeca0b33$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
                return HDNode._fromSeed($1017e67baeca0b33$export$3dee74f1204ab09f(mnemonic, password), {
                    phrase: mnemonic,
                    path: "m",
                    locale: wordlist.locale
                });
            }
        },
        {
            key: "fromSeed",
            value: function fromSeed(seed) {
                return HDNode._fromSeed(seed, null);
            }
        },
        {
            key: "fromExtendedKey",
            value: function fromExtendedKey(extendedKey) {
                var bytes = (0, $59ddd2fedfa0199a$export$45a587635c9954b2).decode(extendedKey);
                if (bytes.length !== 82 || $1017e67baeca0b33$var$base58check(bytes.slice(0, 78)) !== extendedKey) $1017e67baeca0b33$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
                var depth = bytes[4];
                var parentFingerprint = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
                var index = parseInt((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
                var chainCode = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
                var key = bytes.slice(45, 78);
                switch((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
                    // Public Key
                    case "0x0488b21e":
                    case "0x043587cf":
                        return new HDNode($1017e67baeca0b33$var$_constructorGuard, null, (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(key), parentFingerprint, chainCode, index, depth, null);
                    // Private Key
                    case "0x0488ade4":
                    case "0x04358394 ":
                        if (key[0] !== 0) break;
                        return new HDNode($1017e67baeca0b33$var$_constructorGuard, (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
                }
                return $1017e67baeca0b33$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
            }
        }
    ]);
    return HDNode;
}();
function $1017e67baeca0b33$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    var salt = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)("mnemonic" + password, (0, $4d583f407d5b3d1a$export$c6986442964129f5).NFKD);
    return (0, $d77b31d152b92f84$export$448fa22aedc9dbca)((0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(mnemonic, (0, $4d583f407d5b3d1a$export$c6986442964129f5).NFKD), salt, 2048, 64, "sha512");
}
function $1017e67baeca0b33$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $1017e67baeca0b33$var$getWordlist(wordlist);
    $1017e67baeca0b33$var$logger.checkNormalize();
    var words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    var entropy = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    var offset = 0;
    for(var i = 0; i < words.length; i++){
        var index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(var bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    var entropyBits = 32 * words.length / 3;
    var checksumBits = words.length / 3;
    var checksumMask = $1017e67baeca0b33$var$getUpperMask(checksumBits);
    var checksum = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $1017e67baeca0b33$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $1017e67baeca0b33$var$getWordlist(wordlist);
    entropy = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    var indices = [
        0
    ];
    var remainingBits = 11;
    for(var i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $1017e67baeca0b33$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    var checksumBits = entropy.length / 4;
    var checksum = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)(entropy))[0] & $1017e67baeca0b33$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map(function(index) {
        return wordlist.getWord(index);
    }));
}
function $1017e67baeca0b33$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $1017e67baeca0b33$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $1017e67baeca0b33$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $1017e67baeca0b33$var$HardenedBit || index % 1) $1017e67baeca0b33$var$logger.throwArgumentError("invalid account index", "index", index);
    return "m/44'/60'/".concat(index, "'/0/0");
}






var $bea3dc4f4beb7fc2$export$83d89fbfd8236492 = "random/5.7.0";


"use strict";
var $134eca54eaa0c337$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $bea3dc4f4beb7fc2$export$83d89fbfd8236492));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $134eca54eaa0c337$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
var $134eca54eaa0c337$var$anyGlobal = $134eca54eaa0c337$var$getGlobal();
var $134eca54eaa0c337$var$crypto = $134eca54eaa0c337$var$anyGlobal.crypto || $134eca54eaa0c337$var$anyGlobal.msCrypto;
if (!$134eca54eaa0c337$var$crypto || !$134eca54eaa0c337$var$crypto.getRandomValues) {
    $134eca54eaa0c337$var$logger.warn("WARNING: Missing strong random number source");
    $134eca54eaa0c337$var$crypto = {
        getRandomValues: function getRandomValues(buffer) {
            return $134eca54eaa0c337$var$logger.throwError("no secure random source avaialble", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $134eca54eaa0c337$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $134eca54eaa0c337$var$logger.throwArgumentError("invalid length", "length", length);
    var result = new Uint8Array(length);
    $134eca54eaa0c337$var$crypto.getRandomValues(result);
    return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(result);
}




var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");
var $c7e4922972984c13$exports = {};
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function AES1(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function ModeOfOperationECB1(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function ModeOfOperationCBC1(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function ModeOfOperationCFB1(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function ModeOfOperationOFB1(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function Counter1(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function ModeOfOperationCTR1(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    $c7e4922972984c13$exports = aesjs;
})($c7e4922972984c13$exports);









var $f5560a89ceda75a7$export$83d89fbfd8236492 = "json-wallets/5.7.0";




"use strict";
function $3252a809e0ae7c3e$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(hexString);
}
function $3252a809e0ae7c3e$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $3252a809e0ae7c3e$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(password, (0, $4d583f407d5b3d1a$export$c6986442964129f5).NFKC);
    return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(password);
}
function $3252a809e0ae7c3e$export$5a5c1dbd910e2c32(object, path) {
    var currentChild = object;
    var comps = path.toLowerCase().split("/");
    for(var i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        var matchingChild = null;
        for(var key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $3252a809e0ae7c3e$export$ec7b18ebad55a3a9(randomBytes) {
    var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    var value = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}


"use strict";
var $51d7eb67f25fa918$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $f5560a89ceda75a7$export$83d89fbfd8236492));
var $51d7eb67f25fa918$export$93a76d16f88f2b3 = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(CrowdsaleAccount, Description);
    var _super = (0, $hKD8n._)(CrowdsaleAccount);
    function CrowdsaleAccount() {
        (0, $7dKN1._)(this, CrowdsaleAccount);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(CrowdsaleAccount, [
        {
            key: "isCrowdsaleAccount",
            value: function isCrowdsaleAccount(value) {
                return !!(value && value._isCrowdsaleAccount);
            }
        }
    ]);
    return CrowdsaleAccount;
}((0, $8832fb576a60463b$export$393edc798c47379d));
function $51d7eb67f25fa918$export$e85a0c9a1067c5d3(json, password) {
    var data = JSON.parse(json);
    password = (0, $3252a809e0ae7c3e$export$350bd33120f7413e)(password);
    // Ethereum Address
    var ethaddr = (0, $77ffbd0470aad2fd$export$88411125f012957a)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "ethaddr"));
    // Encrypted Seed
    var encseed = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $51d7eb67f25fa918$var$logger.throwArgumentError("invalid encseed", "json", json);
    var key = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $d77b31d152b92f84$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    var iv = encseed.slice(0, 16);
    var encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    var aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).ModeOfOperation.cbc(key, iv);
    var seed = (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).padding.pkcs7.strip((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    var seedHex = "";
    for(var i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    var seedHexBytes = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(seedHex);
    var privateKey = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(seedHexBytes);
    return new $51d7eb67f25fa918$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}



"use strict";
function $96fdb01d9ee7515b$export$724d6cf6b9fd8578(json) {
    var data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $96fdb01d9ee7515b$export$67dc926b8e68b2d8(json) {
    var data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $96fdb01d9ee7515b$export$9a68ee9f8f3afd38(json) {
    if ($96fdb01d9ee7515b$export$724d6cf6b9fd8578(json)) try {
        return (0, $77ffbd0470aad2fd$export$88411125f012957a)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($96fdb01d9ee7515b$export$67dc926b8e68b2d8(json)) try {
        return (0, $77ffbd0470aad2fd$export$88411125f012957a)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");

var $4d04f13e0e8e6e30$exports = {};
"use strict";
(function(root) {
    var MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        var K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        var h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        var h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        var w = new Uint32Array(64);
        function blocks(p) {
            var off = 0, len = p.length;
            while(len >= 64){
                var a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u = void 0, i = void 0, j = void 0, t1 = void 0, t2 = void 0;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        var i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        var innerLen = 64 + salt.length + 4;
        var inner = new Array(innerLen);
        var outerKey = new Array(64);
        var i;
        var dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(var i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        var i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(var i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(var i1 = 0; i1 < 16; ++i1)B[i1] += x[i1];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(var i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(var i = 0; i < o.length; i++){
            var v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        var b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        var B = new Uint32Array(p * 32 * r);
        for(var i = 0; i < B.length; i++){
            var j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        var XY = new Uint32Array(64 * r);
        var V = new Uint32Array(32 * r * N);
        var Yi = 32 * r;
        // scratch space
        var x = new Uint32Array(16); // salsa20_8
        var _X = new Uint32Array(16); // blockmix_salsa8
        var totalOps = p * N * 2;
        var currentOp = 0;
        var lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        var stop = false;
        // State information
        var state = 0;
        var i0 = 0, i1;
        var Bi;
        // How many blockmix_salsa8 can we do per step?
        var limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        var nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        var incrementalSMix = function incrementalSMix1() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            var steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        var percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i2 = 0; i2 < steps; i2++){
                        var offset = (2 * r - 1) * 16; // ROMix - 7
                        var j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        var percent101 = parseInt(1000 * currentOp / totalOps);
                        if (percent101 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent101;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(var i3 = 0; i3 < B.length; i3++){
                        b.push(B[i3] >> 0 & 0xff);
                        b.push(B[i3] >> 8 & 0xff);
                        b.push(B[i3] >> 16 & 0xff);
                        b.push(B[i3] >> 24 & 0xff);
                    }
                    var derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            var derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    var lib = {
        scrypt: function scrypt(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                var lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function syncScrypt(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof $4d04f13e0e8e6e30$exports !== "undefined") $4d04f13e0e8e6e30$exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})($4d04f13e0e8e6e30$exports);













"use strict";
var $38d550924743f700$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $38d550924743f700$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $f5560a89ceda75a7$export$83d89fbfd8236492));
// Exported Types
function $38d550924743f700$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
var $38d550924743f700$export$cf9dc4fd6dde0315 = /*#__PURE__*/ function(Description) {
    (0, $cgJ2Y._)(KeystoreAccount, Description);
    var _super = (0, $hKD8n._)(KeystoreAccount);
    function KeystoreAccount() {
        (0, $7dKN1._)(this, KeystoreAccount);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(KeystoreAccount, [
        {
            key: "isKeystoreAccount",
            value: function isKeystoreAccount(value) {
                return !!(value && value._isKeystoreAccount);
            }
        }
    ]);
    return KeystoreAccount;
}((0, $8832fb576a60463b$export$393edc798c47379d));
function $38d550924743f700$var$_decrypt(data, key, ciphertext) {
    var cipher = (0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        var iv = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/cipherparams/iv"));
        var counter = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).Counter(iv);
        var aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).ModeOfOperation.ctr(key, counter);
        return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $38d550924743f700$var$_getAccount(data, key) {
    var ciphertext = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/ciphertext"));
    var computedMAC = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    var privateKey = $38d550924743f700$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $38d550924743f700$var$logger.throwError("unsupported cipher", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    var mnemonicKey = key.slice(32, 64);
    var address = (0, $fd7cc3a32c93c53c$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        var check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $77ffbd0470aad2fd$export$88411125f012957a)(check) !== address) throw new Error("address mismatch");
    }
    var account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "x-ethers/version") === "0.1") {
        var mnemonicCiphertext = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCiphertext"));
        var mnemonicIv = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCounter"));
        var mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).Counter(mnemonicIv);
        var mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        var path = (0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "x-ethers/path") || (0, $1017e67baeca0b33$export$d48ad89f7e11a603);
        var locale = (0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "x-ethers/locale") || "en";
        var entropy = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            var mnemonic = (0, $1017e67baeca0b33$export$4becd65eb23312e6)(entropy, locale);
            var node = (0, $1017e67baeca0b33$export$b68640c53e22b952).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $38d550924743f700$export$cf9dc4fd6dde0315(account);
}
function $38d550924743f700$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $d77b31d152b92f84$export$448fa22aedc9dbca)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $38d550924743f700$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($38d550924743f700$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $38d550924743f700$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    var passwordBytes = (0, $3252a809e0ae7c3e$export$350bd33120f7413e)(password);
    var kdf = (0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        var throwError = function throwError(name, value) {
            return $38d550924743f700$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            var salt = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            var N = parseInt((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/n"));
            var r = parseInt((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/r"));
            var p = parseInt((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            var dkLen = parseInt((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            var salt1 = (0, $3252a809e0ae7c3e$export$2cde08bde0cfd932)((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            var prfFunc = null;
            var prf = (0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            var count = parseInt((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/c"));
            var dkLen1 = parseInt((0, $3252a809e0ae7c3e$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen1 !== 32) throwError("dklen", dkLen1);
            return pbkdf2Func(passwordBytes, salt1, count, dkLen1, prfFunc);
        }
    }
    return $38d550924743f700$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $38d550924743f700$export$9bd2c37889ee5e36(json, password) {
    var data = JSON.parse(json);
    var key = $38d550924743f700$var$_computeKdfKey(data, password, $38d550924743f700$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($4d04f13e0e8e6e30$exports))).syncScrypt);
    return $38d550924743f700$var$_getAccount(data, key);
}
function $38d550924743f700$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $38d550924743f700$var$__awaiter(this, void 0, void 0, function() {
        var data, key;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = JSON.parse(json);
                    return [
                        4,
                        $38d550924743f700$var$_computeKdfKey(data, password, $38d550924743f700$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($4d04f13e0e8e6e30$exports))).scrypt, progressCallback)
                    ];
                case 1:
                    key = _state.sent();
                    return [
                        2,
                        $38d550924743f700$var$_getAccount(data, key)
                    ];
            }
        });
    });
}
function $38d550924743f700$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $77ffbd0470aad2fd$export$88411125f012957a)(account.address) !== (0, $fd7cc3a32c93c53c$export$e67e2732ba9803f9)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($38d550924743f700$var$hasMnemonic(account)) {
            var mnemonic = account.mnemonic;
            var node = (0, $1017e67baeca0b33$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $1017e67baeca0b33$export$d48ad89f7e11a603));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    var privateKey = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(account.privateKey);
    var passwordBytes = (0, $3252a809e0ae7c3e$export$350bd33120f7413e)(password);
    var entropy = null;
    var path = null;
    var locale = null;
    if ($38d550924743f700$var$hasMnemonic(account)) {
        var srcMnemonic = account.mnemonic;
        entropy = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $1017e67baeca0b33$export$135e090d58b310ca)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $1017e67baeca0b33$export$d48ad89f7e11a603);
        locale = srcMnemonic.locale || "en";
    }
    var client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    var salt = null;
    if (options.salt) salt = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(options.salt);
    else salt = (0, $134eca54eaa0c337$export$5f828d93ff035aa8)(32);
    // Override initialization vector
    var iv = null;
    if (options.iv) {
        iv = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $134eca54eaa0c337$export$5f828d93ff035aa8)(16);
    // Override the uuid
    var uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $134eca54eaa0c337$export$5f828d93ff035aa8)(16);
    // Override the scrypt password-based key derivation function parameters
    var N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($4d04f13e0e8e6e30$exports))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then(function(key) {
        key = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        var derivedKey = key.slice(0, 16);
        var macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        var mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        var counter = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).Counter(iv);
        var aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).ModeOfOperation.ctr(derivedKey, counter);
        var ciphertext = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        var mac = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        var data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $3252a809e0ae7c3e$export$ec7b18ebad55a3a9)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(iv).substring(2)
                },
                ciphertext: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            var mnemonicIv = (0, $134eca54eaa0c337$export$5f828d93ff035aa8)(16);
            var mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).Counter(mnemonicIv);
            var mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($c7e4922972984c13$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            var mnemonicCiphertext = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(mnemonicAesCtr.encrypt(entropy));
            var now = new Date();
            var timestamp = now.getUTCFullYear() + "-" + (0, $3252a809e0ae7c3e$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $3252a809e0ae7c3e$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $3252a809e0ae7c3e$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $3252a809e0ae7c3e$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $3252a809e0ae7c3e$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}


"use strict";
function $48552dcef36851b5$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $96fdb01d9ee7515b$export$724d6cf6b9fd8578)(json)) {
        if (progressCallback) progressCallback(0);
        var account = (0, $51d7eb67f25fa918$export$e85a0c9a1067c5d3)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $96fdb01d9ee7515b$export$67dc926b8e68b2d8)(json)) return (0, $38d550924743f700$export$e85a0c9a1067c5d3)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $48552dcef36851b5$export$7a81c437a678891a(json, password) {
    if ((0, $96fdb01d9ee7515b$export$724d6cf6b9fd8578)(json)) return (0, $51d7eb67f25fa918$export$e85a0c9a1067c5d3)(json, password);
    if ((0, $96fdb01d9ee7515b$export$67dc926b8e68b2d8)(json)) return (0, $38d550924743f700$export$9bd2c37889ee5e36)(json, password);
    throw new Error("invalid JSON wallet");
}




var $98359763e8852833$export$83d89fbfd8236492 = "wallet/5.7.0";


"use strict";
var $56cd539b6bfcd29d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $56cd539b6bfcd29d$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $98359763e8852833$export$83d89fbfd8236492));
function $56cd539b6bfcd29d$var$isAccount(value) {
    return value != null && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value.privateKey, 32) && value.address != null;
}
function $56cd539b6bfcd29d$var$hasMnemonic(value) {
    var mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
var $56cd539b6bfcd29d$export$bcca3ea514774656 = /*#__PURE__*/ function(Signer) {
    (0, $cgJ2Y._)(Wallet, Signer);
    var _super = (0, $hKD8n._)(Wallet);
    function Wallet(privateKey, provider) {
        (0, $7dKN1._)(this, Wallet);
        var _this;
        _this = _super.call(this);
        if ($56cd539b6bfcd29d$var$isAccount(privateKey)) {
            var signingKey = new (0, $14bbf95e2a82e6fd$export$21643ca94aed3e83)(privateKey.privateKey);
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_signingKey", function() {
                return signingKey;
            });
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "address", (0, $fd7cc3a32c93c53c$export$e67e2732ba9803f9)(_this.publicKey));
            if (_this.address !== (0, $77ffbd0470aad2fd$export$88411125f012957a)(privateKey.address)) $56cd539b6bfcd29d$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($56cd539b6bfcd29d$var$hasMnemonic(privateKey)) {
                var srcMnemonic = privateKey.mnemonic;
                (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_mnemonic", function() {
                    return {
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $1017e67baeca0b33$export$d48ad89f7e11a603),
                        locale: srcMnemonic.locale || "en"
                    };
                });
                var mnemonic = _this.mnemonic;
                var node = (0, $1017e67baeca0b33$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $fd7cc3a32c93c53c$export$e67e2732ba9803f9)(node.privateKey) !== _this.address) $56cd539b6bfcd29d$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_mnemonic", function() {
                return null;
            });
        } else {
            if ((0, $14bbf95e2a82e6fd$export$21643ca94aed3e83).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $56cd539b6bfcd29d$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_signingKey", function() {
                    return privateKey;
                });
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                var signingKey1 = new (0, $14bbf95e2a82e6fd$export$21643ca94aed3e83)(privateKey);
                (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_signingKey", function() {
                    return signingKey1;
                });
            }
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_mnemonic", function() {
                return null;
            });
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "address", (0, $fd7cc3a32c93c53c$export$e67e2732ba9803f9)(_this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $fc170b81a17b0865$export$2881499e37b75b9a).isProvider(provider)) $56cd539b6bfcd29d$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "provider", provider || null);
        return _this;
    }
    (0, $eW5pA._)(Wallet, [
        {
            key: "mnemonic",
            get: function get() {
                return this._mnemonic();
            }
        },
        {
            key: "privateKey",
            get: function get() {
                return this._signingKey().privateKey;
            }
        },
        {
            key: "publicKey",
            get: function get() {
                return this._signingKey().publicKey;
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                return Promise.resolve(this.address);
            }
        },
        {
            key: "connect",
            value: function connect(provider) {
                return new Wallet(this, provider);
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                var _this = this;
                return (0, $8832fb576a60463b$export$d503dd157d963b60)(transaction).then(function(tx) {
                    if (tx.from != null) {
                        if ((0, $77ffbd0470aad2fd$export$88411125f012957a)(tx.from) !== _this.address) $56cd539b6bfcd29d$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                        delete tx.from;
                    }
                    var signature = _this._signingKey().signDigest((0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $fd7cc3a32c93c53c$export$dfdc1655ccc5b9cb)(tx)));
                    return (0, $fd7cc3a32c93c53c$export$dfdc1655ccc5b9cb)(tx, signature);
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $56cd539b6bfcd29d$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            (0, $b8b53b1cc922c9da$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $c9b75c627427b5da$export$d4c241cec96564c1)(message)))
                        ];
                    });
                });
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return $56cd539b6bfcd29d$var$__awaiter(this, void 0, void 0, function() {
                    var _this, populated;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $48669d0386352f19$export$458ab927ae635c3).resolveNames(domain, types, value, function(name) {
                                        if (_this.provider == null) $56cd539b6bfcd29d$var$logger.throwError("cannot resolve ENS names without a provider", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                            operation: "resolveName",
                                            value: name
                                        });
                                        return _this.provider.resolveName(name);
                                    })
                                ];
                            case 1:
                                populated = _state.sent();
                                return [
                                    2,
                                    (0, $b8b53b1cc922c9da$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $48669d0386352f19$export$458ab927ae635c3).hash(populated.domain, types, populated.value)))
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "encrypt",
            value: function encrypt(password, options, progressCallback) {
                if (typeof options === "function" && !progressCallback) {
                    progressCallback = options;
                    options = {};
                }
                if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
                if (!options) options = {};
                return (0, $38d550924743f700$export$5b0f6292f11d1d18)(this, password, options, progressCallback);
            }
        }
    ], [
        {
            key: "createRandom",
            value: /**
     *  Static methods to create Wallet instances.
     */ function createRandom(options) {
                var entropy = (0, $134eca54eaa0c337$export$5f828d93ff035aa8)(16);
                if (!options) options = {};
                if (options.extraEntropy) entropy = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                    entropy,
                    options.extraEntropy
                ])), 0, 16));
                var mnemonic = (0, $1017e67baeca0b33$export$4becd65eb23312e6)(entropy, options.locale);
                return Wallet.fromMnemonic(mnemonic, options.path, options.locale);
            }
        },
        {
            key: "fromEncryptedJson",
            value: function fromEncryptedJson(json, password, progressCallback) {
                return (0, $48552dcef36851b5$export$e74fcde37488267a)(json, password, progressCallback).then(function(account) {
                    return new Wallet(account);
                });
            }
        },
        {
            key: "fromEncryptedJsonSync",
            value: function fromEncryptedJsonSync(json, password) {
                return new Wallet((0, $48552dcef36851b5$export$7a81c437a678891a)(json, password));
            }
        },
        {
            key: "fromMnemonic",
            value: function fromMnemonic(mnemonic, path, wordlist) {
                if (!path) path = (0, $1017e67baeca0b33$export$d48ad89f7e11a603);
                return new Wallet((0, $1017e67baeca0b33$export$b68640c53e22b952).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
            }
        }
    ]);
    return Wallet;
}((0, $3e3669d74ee1fde3$export$fdf54fdde81cc9f0));
function $56cd539b6bfcd29d$export$228d0e772cc158cb(message, signature) {
    return (0, $fd7cc3a32c93c53c$export$23cc18f96d8510e2)((0, $c9b75c627427b5da$export$d4c241cec96564c1)(message), signature);
}
function $56cd539b6bfcd29d$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $fd7cc3a32c93c53c$export$23cc18f96d8510e2)((0, $48669d0386352f19$export$458ab927ae635c3).hash(domain, types, value), signature);
}


var $bdc883725b97a4d2$exports = {};

$parcel$export($bdc883725b97a4d2$exports, "AddressZero", function () { return $6088cb855366de49$export$badd13187c087617; });
$parcel$export($bdc883725b97a4d2$exports, "NegativeOne", function () { return $90f483a28c97692a$export$c83ef0909a6ddeec; });
$parcel$export($bdc883725b97a4d2$exports, "Zero", function () { return $90f483a28c97692a$export$aaef8a3eae948f03; });
$parcel$export($bdc883725b97a4d2$exports, "One", function () { return $90f483a28c97692a$export$9aa05a5866350bcf; });
$parcel$export($bdc883725b97a4d2$exports, "Two", function () { return $90f483a28c97692a$export$9276dd97bf62cc8d; });
$parcel$export($bdc883725b97a4d2$exports, "WeiPerEther", function () { return $90f483a28c97692a$export$c8db55bd7405209e; });
$parcel$export($bdc883725b97a4d2$exports, "MaxUint256", function () { return $90f483a28c97692a$export$1b53890de5aabdd0; });
$parcel$export($bdc883725b97a4d2$exports, "MinInt256", function () { return $90f483a28c97692a$export$963c9b9317b80aaf; });
$parcel$export($bdc883725b97a4d2$exports, "MaxInt256", function () { return $90f483a28c97692a$export$6f8dbb07ebe6d738; });
$parcel$export($bdc883725b97a4d2$exports, "HashZero", function () { return $4865d0dc710dfa88$export$71c2e4e213dcb7f2; });
$parcel$export($bdc883725b97a4d2$exports, "EtherSymbol", function () { return $6916b6ed914b8212$export$c7e79fcb6f8ac048; });
var $6088cb855366de49$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";



var $4865d0dc710dfa88$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";


// NFKC (composed)             // (decomposed)
var $6916b6ed914b8212$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";


"use strict";


var $62f207a30c1ed53d$exports = {};

$parcel$export($62f207a30c1ed53d$exports, "getDefaultProvider", function () { return $62f207a30c1ed53d$export$4f77a1d3c1ac6642; });
$parcel$export($62f207a30c1ed53d$exports, "Provider", function () { return $fc170b81a17b0865$export$2881499e37b75b9a; });
$parcel$export($62f207a30c1ed53d$exports, "BaseProvider", function () { return $526e8ebee4b63c77$export$ff3f6dd83125ac45; });
$parcel$export($62f207a30c1ed53d$exports, "Resolver", function () { return $526e8ebee4b63c77$export$8b4c839865b08288; });
$parcel$export($62f207a30c1ed53d$exports, "UrlJsonRpcProvider", function () { return $1026e27d6463850a$export$664128d6239ccf96; });
$parcel$export($62f207a30c1ed53d$exports, "FallbackProvider", function () { return $3e9d92c6058b8741$export$cb1d0beacb55feb7; });
$parcel$export($62f207a30c1ed53d$exports, "AlchemyProvider", function () { return $406085ed0719de30$export$999cc40da3fbc6f; });
$parcel$export($62f207a30c1ed53d$exports, "AlchemyWebSocketProvider", function () { return $406085ed0719de30$export$f6c13301c7b76371; });
$parcel$export($62f207a30c1ed53d$exports, "AnkrProvider", function () { return $5d99454c30f7154e$export$72783b2aefa72a45; });
$parcel$export($62f207a30c1ed53d$exports, "CloudflareProvider", function () { return $e53beb044b99e708$export$7113381f8f264fc0; });
$parcel$export($62f207a30c1ed53d$exports, "EtherscanProvider", function () { return $3c0b36f99ba2c448$export$dd1d942a536c7912; });
$parcel$export($62f207a30c1ed53d$exports, "InfuraProvider", function () { return $68d21aeec040073b$export$60ff1a559b5c6ebd; });
$parcel$export($62f207a30c1ed53d$exports, "InfuraWebSocketProvider", function () { return $68d21aeec040073b$export$dd168a807d60da4f; });
$parcel$export($62f207a30c1ed53d$exports, "JsonRpcProvider", function () { return $12c7496014ff7c2a$export$da28308012bf6748; });
$parcel$export($62f207a30c1ed53d$exports, "JsonRpcBatchProvider", function () { return $a041024484c0181d$export$5a16092bf20edf97; });
$parcel$export($62f207a30c1ed53d$exports, "NodesmithProvider", function () { return $ac40b9bcc218771b$export$8235cbce3ce273bd; });
$parcel$export($62f207a30c1ed53d$exports, "PocketProvider", function () { return $da37faaa508e19bc$export$58bb47e42f6b092e; });
$parcel$export($62f207a30c1ed53d$exports, "StaticJsonRpcProvider", function () { return $1026e27d6463850a$export$b3d647c1c29df44d; });
$parcel$export($62f207a30c1ed53d$exports, "Web3Provider", function () { return $10a88493ad9176c2$export$d05096c9fd9d936d; });
$parcel$export($62f207a30c1ed53d$exports, "WebSocketProvider", function () { return $f2e2193043971f40$export$bfafe629242f30bd; });
$parcel$export($62f207a30c1ed53d$exports, "IpcProvider", function () { return $02193b699917d742$export$fbe151f90a1ece01; });
$parcel$export($62f207a30c1ed53d$exports, "JsonRpcSigner", function () { return $12c7496014ff7c2a$export$5f7b5fca3508545a; });
$parcel$export($62f207a30c1ed53d$exports, "getNetwork", function () { return $83843fdbb5c0c0a1$export$7de4970ebfd8206d; });
$parcel$export($62f207a30c1ed53d$exports, "isCommunityResource", function () { return $2fc925c8cd1d3841$export$d93d5f61c2498b6; });
$parcel$export($62f207a30c1ed53d$exports, "isCommunityResourcable", function () { return $2fc925c8cd1d3841$export$3091239f5b20b896; });
$parcel$export($62f207a30c1ed53d$exports, "showThrottleMessage", function () { return $2fc925c8cd1d3841$export$4c41bd49e82e82ab; });
$parcel$export($62f207a30c1ed53d$exports, "Formatter", function () { return $2fc925c8cd1d3841$export$a06636add2a09fd8; });


var $270a5bc7436035c7$export$83d89fbfd8236492 = "networks/5.7.1";


"use strict";
var $83843fdbb5c0c0a1$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $270a5bc7436035c7$export$83d89fbfd8236492));
function $83843fdbb5c0c0a1$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $83843fdbb5c0c0a1$var$ethDefaultProvider(network) {
    var func = function func(providers, options) {
        if (options == null) options = {};
        var providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            var skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                var provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            var skip1 = [
                "ropsten"
            ];
            var provider1 = new providers.AnkrProvider(network, options.ankr);
            if (provider1.network && skip1.indexOf(provider1.network.name) === -1) providerList.push(provider1);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            var quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $83843fdbb5c0c0a1$var$ethDefaultProvider(network);
    };
    return func;
}
function $83843fdbb5c0c0a1$var$etcDefaultProvider(url, network) {
    var func = function func(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $83843fdbb5c0c0a1$var$etcDefaultProvider(url, network);
    };
    return func;
}
var $83843fdbb5c0c0a1$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("homestead")
};
var $83843fdbb5c0c0a1$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("ropsten")
};
var $83843fdbb5c0c0a1$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $83843fdbb5c0c0a1$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
var $83843fdbb5c0c0a1$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $83843fdbb5c0c0a1$var$homestead,
    mainnet: $83843fdbb5c0c0a1$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $83843fdbb5c0c0a1$var$ropsten,
    testnet: $83843fdbb5c0c0a1$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $83843fdbb5c0c0a1$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $83843fdbb5c0c0a1$var$classicMordor,
    classicTestnet: $83843fdbb5c0c0a1$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $83843fdbb5c0c0a1$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $83843fdbb5c0c0a1$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $83843fdbb5c0c0a1$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(var name in $83843fdbb5c0c0a1$var$networks){
            var standard = $83843fdbb5c0c0a1$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        var standard1 = $83843fdbb5c0c0a1$var$networks[network];
        if (standard1 == null) return null;
        return {
            name: standard1.name,
            chainId: standard1.chainId,
            ensAddress: standard1.ensAddress,
            _defaultProvider: standard1._defaultProvider || null
        };
    }
    var standard2 = $83843fdbb5c0c0a1$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard2) {
        if (typeof network.chainId !== "number") $83843fdbb5c0c0a1$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard2.chainId) $83843fdbb5c0c0a1$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    var defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard2._defaultProvider) {
        if ($83843fdbb5c0c0a1$var$isRenetworkable(standard2._defaultProvider)) defaultProvider = standard2._defaultProvider.renetwork(network);
        else defaultProvider = standard2._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard2.chainId,
        ensAddress: network.ensAddress || standard2.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");


"use strict";
function $20128c45dd8db8c0$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    var data = [];
    for(var i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
}
function $20128c45dd8db8c0$export$c564cdbbe6da493(data) {
    data = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(data);
    var textData = "";
    for(var i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}











/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $gF0bR = parcelRequire("gF0bR");

/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $41ffebaf4fa9c28d$var$flat(array, depth) {
    if (depth == null) depth = 1;
    var result = [];
    var forEach = result.forEach;
    var flatDeep = function flatDeep1(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $41ffebaf4fa9c28d$var$fromEntries(array) {
    var result = {};
    for(var i = 0; i < array.length; i++){
        var value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $41ffebaf4fa9c28d$export$956eeed0f8f2ceff(bytes) {
    var pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    var symbol_count = u16();
    var total = 1;
    var acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(var i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    var skip = u16();
    var pos_payload = pos;
    pos += skip;
    var read_width = 0;
    var read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    var N = 31;
    var FULL = Math.pow(2, N);
    var HALF = FULL >>> 1;
    var QRTR = HALF >> 1;
    var MASK = FULL - 1;
    // fill register
    var register = 0;
    for(var i1 = 0; i1 < N; i1++)register = register << 1 | read_bit();
    var symbols = [];
    var low = 0;
    var range = FULL; // treat like a float
    while(true){
        var value = Math.floor(((register - low + 1) * total - 1) / range);
        var start = 0;
        var end = symbol_count;
        while(end - start > 1){
            var mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        var a = low + Math.floor(range * acc[start] / total);
        var b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    var offset = symbol_count - 4;
    return symbols.map(function(x) {
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $41ffebaf4fa9c28d$export$2cda812f22276871(v) {
    var pos = 0;
    return function() {
        return v[pos++];
    };
}
function $41ffebaf4fa9c28d$export$671d8b4ebc0c42ad(bytes) {
    return $41ffebaf4fa9c28d$export$2cda812f22276871($41ffebaf4fa9c28d$export$956eeed0f8f2ceff(bytes));
}
function $41ffebaf4fa9c28d$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $41ffebaf4fa9c28d$var$read_counts(n, next) {
    var v = Array(n);
    for(var i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $41ffebaf4fa9c28d$var$read_ascending(n, next) {
    var v = Array(n);
    for(var i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $41ffebaf4fa9c28d$var$read_deltas(n, next) {
    var v = Array(n);
    for(var i = 0, x = 0; i < n; i++)v[i] = x += $41ffebaf4fa9c28d$export$a785de3a2a8dd1aa(next());
    return v;
}
function $41ffebaf4fa9c28d$export$9303bf4e1ede4914(next, lookup) {
    var v = $41ffebaf4fa9c28d$var$read_ascending(next(), next);
    var n = next();
    var vX = $41ffebaf4fa9c28d$var$read_ascending(n, next);
    var vN = $41ffebaf4fa9c28d$var$read_counts(n, next);
    for(var i = 0; i < n; i++)for(var j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map(function(x) {
        return lookup[x];
    }) : v;
}
function $41ffebaf4fa9c28d$export$824d00fb01c38bd9(next) {
    var ret = [];
    while(true){
        var w = next();
        if (w == 0) break;
        ret.push($41ffebaf4fa9c28d$var$read_linear_table(w, next));
    }
    while(true){
        var w1 = next() - 1;
        if (w1 < 0) break;
        ret.push($41ffebaf4fa9c28d$var$read_replacement_table(w1, next));
    }
    return $41ffebaf4fa9c28d$var$fromEntries($41ffebaf4fa9c28d$var$flat(ret));
}
function $41ffebaf4fa9c28d$export$e9011071590ab431(next) {
    var v = [];
    while(true){
        var i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $41ffebaf4fa9c28d$var$read_transposed(n, w, next) {
    var m = Array(n).fill(undefined).map(function() {
        return [];
    });
    for(var i = 0; i < w; i++)$41ffebaf4fa9c28d$var$read_deltas(n, next).forEach(function(x, j) {
        return m[j].push(x);
    });
    return m;
}
function $41ffebaf4fa9c28d$var$read_linear_table(w, next) {
    var dx = 1 + next();
    var dy = next();
    var vN = $41ffebaf4fa9c28d$export$e9011071590ab431(next);
    var m = $41ffebaf4fa9c28d$var$read_transposed(vN.length, 1 + w, next);
    return $41ffebaf4fa9c28d$var$flat(m.map(function(v, i) {
        var x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map(function(_, j) {
            var j_dy = j * dy;
            return [
                x + j * dx,
                ys.map(function(y) {
                    return y + j_dy;
                })
            ];
        });
    }));
}
function $41ffebaf4fa9c28d$var$read_replacement_table(w, next) {
    var n = 1 + next();
    var m = $41ffebaf4fa9c28d$var$read_transposed(n, 1 + w, next);
    return m.map(function(v) {
        return [
            v[0],
            v.slice(1)
        ];
    });
}
function $41ffebaf4fa9c28d$export$d7b24c6ce369e1b7(next) {
    var sorted = $41ffebaf4fa9c28d$export$9303bf4e1ede4914(next).sort(function(a, b) {
        return a - b;
    });
    return read();
    function read() {
        var branches = [];
        while(true){
            var keys = $41ffebaf4fa9c28d$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort(function(a, b) {
            return b.set.size - a.set.size;
        }); // sort by likelihood
        var temp = next();
        var valid = temp % 3;
        temp = temp / 3 | 0;
        var fe0f = !!(temp & 1);
        temp >>= 1;
        var save = temp == 1;
        var check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}


function $4576181bc00984f7$export$7a171f172be0782e() {
    return (0, $41ffebaf4fa9c28d$export$671d8b4ebc0c42ad)((0, $20128c45dd8db8c0$export$2f872c0f2117be69)("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"));
}



var $c62262186ff32e4f$var$r = (0, $4576181bc00984f7$export$7a171f172be0782e)();
// @TODO: This should be lazily loaded
var $c62262186ff32e4f$var$VALID = new Set((0, $41ffebaf4fa9c28d$export$9303bf4e1ede4914)($c62262186ff32e4f$var$r));
var $c62262186ff32e4f$var$IGNORED = new Set((0, $41ffebaf4fa9c28d$export$9303bf4e1ede4914)($c62262186ff32e4f$var$r));
var $c62262186ff32e4f$var$MAPPED = (0, $41ffebaf4fa9c28d$export$824d00fb01c38bd9)($c62262186ff32e4f$var$r);
var $c62262186ff32e4f$var$EMOJI_ROOT = (0, $41ffebaf4fa9c28d$export$d7b24c6ce369e1b7)($c62262186ff32e4f$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
var $c62262186ff32e4f$var$HYPHEN = 0x2D;
var $c62262186ff32e4f$var$UNDERSCORE = 0x5F;
function $c62262186ff32e4f$var$explode_cp(name) {
    return (0, $4d583f407d5b3d1a$export$ae470a36a31b28c2)(name);
}
function $c62262186ff32e4f$var$filter_fe0f(cps) {
    return cps.filter(function(cp) {
        return cp != 0xFE0F;
    });
}
function $c62262186ff32e4f$export$5252e54b57fcf4fd(name) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var label = _step.value;
            var cps = $c62262186ff32e4f$var$explode_cp(label);
            try {
                for(var i = cps.lastIndexOf($c62262186ff32e4f$var$UNDERSCORE) - 1; i >= 0; i--){
                    if (cps[i] !== $c62262186ff32e4f$var$UNDERSCORE) throw new Error("underscore only allowed at start");
                }
                if (cps.length >= 4 && cps.every(function(cp) {
                    return cp < 0x80;
                }) && cps[2] === $c62262186ff32e4f$var$HYPHEN && cps[3] === $c62262186ff32e4f$var$HYPHEN) throw new Error("invalid label extension");
            } catch (err) {
                throw new Error('Invalid label "'.concat(label, '": ').concat(err.message));
            }
        };
        for(var _iterator = name.split(".")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return name;
}
function $c62262186ff32e4f$export$499f715881831a51(name) {
    return $c62262186ff32e4f$export$5252e54b57fcf4fd($c62262186ff32e4f$var$normalize(name, $c62262186ff32e4f$var$filter_fe0f));
}
function $c62262186ff32e4f$var$normalize(name, emoji_filter) {
    var _String;
    var input = $c62262186ff32e4f$var$explode_cp(name).reverse(); // flip for pop
    var output = [];
    while(input.length){
        var emoji = $c62262186ff32e4f$var$consume_emoji_reversed(input);
        if (emoji) {
            var _output;
            (_output = output).push.apply(_output, (0, $gF0bR._)(emoji_filter(emoji)));
            continue;
        }
        var cp = input.pop();
        if ($c62262186ff32e4f$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($c62262186ff32e4f$var$IGNORED.has(cp)) continue;
        var cps = $c62262186ff32e4f$var$MAPPED[cp];
        if (cps) {
            var _output1;
            (_output1 = output).push.apply(_output1, (0, $gF0bR._)(cps));
            continue;
        }
        throw new Error("Disallowed codepoint: 0x".concat(cp.toString(16).toUpperCase()));
    }
    return $c62262186ff32e4f$export$5252e54b57fcf4fd($c62262186ff32e4f$var$nfc((_String = String).fromCodePoint.apply(_String, (0, $gF0bR._)(output))));
}
function $c62262186ff32e4f$var$nfc(s) {
    return s.normalize("NFC");
}
function $c62262186ff32e4f$var$consume_emoji_reversed(cps, eaten) {
    var _loop = function() {
        var cp = cps[--pos];
        node = (_a = node.branches.find(function(x) {
            return x.set.has(cp);
        })) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) return "break";
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) return "break";
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            var _eaten;
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) (_eaten = eaten).push.apply(_eaten, (0, $gF0bR._)(cps.slice(pos).reverse())); // copy input (if needed)
            cps.length = pos; // truncate
        }
    };
    var _a;
    var node = $c62262186ff32e4f$var$EMOJI_ROOT;
    var emoji;
    var saved;
    var stack = [];
    var pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        var _ret = _loop();
        if (_ret === "break") break;
    }
    return emoji;
}


var $502d474d526285f9$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $5903d51e6964a77f$export$83d89fbfd8236492));
var $502d474d526285f9$var$Zeros = new Uint8Array(32);
$502d474d526285f9$var$Zeros.fill(0);
function $502d474d526285f9$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $502d474d526285f9$var$ensNameSplit(name) {
    var bytes = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)((0, $c62262186ff32e4f$export$499f715881831a51)(name));
    var comps = [];
    if (name.length === 0) return comps;
    var last = 0;
    for(var i = 0; i < bytes.length; i++){
        var d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($502d474d526285f9$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($502d474d526285f9$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $502d474d526285f9$export$5f232fd2f1a1e8ac(name) {
    return $502d474d526285f9$var$ensNameSplit(name).map(function(comp) {
        return (0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)(comp);
    }).join(".");
}
function $502d474d526285f9$export$cce2300886e7ace6(name) {
    try {
        return $502d474d526285f9$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $502d474d526285f9$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $502d474d526285f9$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    var result = $502d474d526285f9$var$Zeros;
    var comps = $502d474d526285f9$var$ensNameSplit(name);
    while(comps.length)result = (0, $aca68b720d4a692f$export$f8151fce47ad1c35)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        result,
        (0, $aca68b720d4a692f$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(result);
}
function $502d474d526285f9$export$6c0a8cdae51cb512(name) {
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)($502d474d526285f9$var$ensNameSplit(name).map(function(comp) {
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        var bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}







var $6qu4b = parcelRequire("6qu4b");





var $9a027a20e466de5a$export$83d89fbfd8236492 = "web/5.7.1";



var $6qu4b = parcelRequire("6qu4b");

"use strict";
var $37c48f758db9eac6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $37c48f758db9eac6$export$94df0e59ebebf4a7(href, options) {
    return $37c48f758db9eac6$var$__awaiter(this, void 0, void 0, function() {
        var request, opts, response, body, headers;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options == null) options = {};
                    request = {
                        method: options.method || "GET",
                        headers: options.headers || {},
                        body: options.body || undefined
                    };
                    if (options.skipFetchSetup !== true) {
                        request.mode = "cors"; // no-cors, cors, *same-origin
                        request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
                        request.credentials = "same-origin"; // include, *same-origin, omit
                        request.redirect = "follow"; // manual, *follow, error
                        request.referrer = "client"; // no-referrer, *client
                    }
                    if (options.fetchOptions != null) {
                        opts = options.fetchOptions;
                        if (opts.mode) request.mode = opts.mode;
                        if (opts.cache) request.cache = opts.cache;
                        if (opts.credentials) request.credentials = opts.credentials;
                        if (opts.redirect) request.redirect = opts.redirect;
                        if (opts.referrer) request.referrer = opts.referrer;
                    }
                    return [
                        4,
                        fetch(href, request)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.arrayBuffer()
                    ];
                case 2:
                    body = _state.sent();
                    headers = {};
                    if (response.headers.forEach) response.headers.forEach(function(value, key) {
                        headers[key.toLowerCase()] = value;
                    });
                    else response.headers.keys().forEach(function(key) {
                        headers[key.toLowerCase()] = response.headers.get(key);
                    });
                    return [
                        2,
                        {
                            headers: headers,
                            statusCode: response.status,
                            statusMessage: response.statusText,
                            body: (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(new Uint8Array(body))
                        }
                    ];
            }
        });
    });
}


"use strict";
var $43ca5dbe92db6f17$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $43ca5dbe92db6f17$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $9a027a20e466de5a$export$83d89fbfd8236492));
function $43ca5dbe92db6f17$var$staller(duration) {
    return new Promise(function(resolve) {
        setTimeout(resolve, duration);
    });
}
function $43ca5dbe92db6f17$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $b8b53b1cc922c9da$export$9a14abb1a440cd5e)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)(value);
        } catch (error) {}
        return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value);
    }
    return value;
}
function $43ca5dbe92db6f17$var$unpercent(value) {
    return (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, function(all, code) {
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $43ca5dbe92db6f17$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    var attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $43ca5dbe92db6f17$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    var throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    var throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $43ca5dbe92db6f17$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    var errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    var headers = {};
    var url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    var options = {
        method: "GET"
    };
    var allow304 = false;
    var timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $43ca5dbe92db6f17$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(var key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $43ca5dbe92db6f17$var$logger.throwError("basic authentication requires a secure https url", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            var authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $20128c45dd8db8c0$export$c564cdbbe6da493)((0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $8832fb576a60463b$export$9c13236873b118a5)(connection.fetchOptions);
    }
    var reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    var dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        var response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $20128c45dd8db8c0$export$2f872c0f2117be69)(dataMatch[3]) : $43ca5dbe92db6f17$var$unpercent(dataMatch[3])
        };
        var result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $43ca5dbe92db6f17$var$logger.throwError("processing response error", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
            body: $43ca5dbe92db6f17$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    var flatHeaders = {};
    Object.keys(headers).forEach(function(key) {
        var header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    var runningTimeout = function() {
        var timer = null;
        var promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(function() {
                if (timer == null) return;
                timer = null;
                reject($43ca5dbe92db6f17$var$logger.makeError("timeout", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.TIMEOUT, {
                    requestBody: $43ca5dbe92db6f17$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        var cancel = function cancel() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    var runningFetch = function() {
        return $43ca5dbe92db6f17$var$__awaiter(this, void 0, void 0, function() {
            var attempt, response, location, tryAgain, stall, retryAfter, error, _$body, result, error1, tryAgain1, timeout;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        attempt = 0;
                        _state.label = 1;
                    case 1:
                        if (!(attempt < attemptLimit)) return [
                            3,
                            20
                        ];
                        response = null;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            (0, $37c48f758db9eac6$export$94df0e59ebebf4a7)(url, options)
                        ];
                    case 3:
                        response = _state.sent();
                        if (!(attempt < attemptLimit)) return [
                            3,
                            8
                        ];
                        if (!(response.statusCode === 301 || response.statusCode === 302)) return [
                            3,
                            4
                        ];
                        // Redirection; for now we only support absolute locataions
                        location = response.headers.location || "";
                        if (options.method === "GET" && location.match(/^https:/)) {
                            url = response.headers.location;
                            return [
                                3,
                                19
                            ];
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(response.statusCode === 429)) return [
                            3,
                            8
                        ];
                        // Exponential back-off throttling
                        tryAgain = true;
                        if (!throttleCallback) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            throttleCallback(attempt, url)
                        ];
                    case 5:
                        tryAgain = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!tryAgain) return [
                            3,
                            8
                        ];
                        stall = 0;
                        retryAfter = response.headers["retry-after"];
                        if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                        else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                        //console.log("Stalling 429");
                        return [
                            4,
                            $43ca5dbe92db6f17$var$staller(stall)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            3,
                            19
                        ];
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        error = _state.sent();
                        response = error.response;
                        if (response == null) {
                            runningTimeout.cancel();
                            $43ca5dbe92db6f17$var$logger.throwError("missing response", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                requestBody: $43ca5dbe92db6f17$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                serverError: error,
                                url: url
                            });
                        }
                        return [
                            3,
                            10
                        ];
                    case 10:
                        _$body = response.body;
                        if (allow304 && response.statusCode === 304) _$body = null;
                        else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                            runningTimeout.cancel();
                            $43ca5dbe92db6f17$var$logger.throwError("bad response", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                status: response.statusCode,
                                headers: response.headers,
                                body: $43ca5dbe92db6f17$var$bodyify(_$body, response.headers ? response.headers["content-type"] : null),
                                requestBody: $43ca5dbe92db6f17$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                url: url
                            });
                        }
                        if (!processFunc) return [
                            3,
                            18
                        ];
                        _state.label = 11;
                    case 11:
                        _state.trys.push([
                            11,
                            13,
                            ,
                            18
                        ]);
                        return [
                            4,
                            processFunc(_$body, response)
                        ];
                    case 12:
                        result = _state.sent();
                        runningTimeout.cancel();
                        return [
                            2,
                            result
                        ];
                    case 13:
                        error1 = _state.sent();
                        if (!(error1.throttleRetry && attempt < attemptLimit)) return [
                            3,
                            17
                        ];
                        tryAgain1 = true;
                        if (!throttleCallback) return [
                            3,
                            15
                        ];
                        return [
                            4,
                            throttleCallback(attempt, url)
                        ];
                    case 14:
                        tryAgain1 = _state.sent();
                        _state.label = 15;
                    case 15:
                        if (!tryAgain1) return [
                            3,
                            17
                        ];
                        timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                        //console.log("Stalling callback");
                        return [
                            4,
                            $43ca5dbe92db6f17$var$staller(timeout)
                        ];
                    case 16:
                        _state.sent();
                        return [
                            3,
                            19
                        ];
                    case 17:
                        runningTimeout.cancel();
                        $43ca5dbe92db6f17$var$logger.throwError("processing response error", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                            body: $43ca5dbe92db6f17$var$bodyify(_$body, response.headers ? response.headers["content-type"] : null),
                            error: error1,
                            requestBody: $43ca5dbe92db6f17$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            url: url
                        });
                        return [
                            3,
                            18
                        ];
                    case 18:
                        runningTimeout.cancel();
                        // If we had a processFunc, it either returned a T or threw above.
                        // The "body" is now a Uint8Array.
                        return [
                            2,
                            _$body
                        ];
                    case 19:
                        attempt++;
                        return [
                            3,
                            1
                        ];
                    case 20:
                        return [
                            2,
                            $43ca5dbe92db6f17$var$logger.throwError("failed response", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                requestBody: $43ca5dbe92db6f17$var$bodyify(options.body, flatHeaders["content-type"]),
                                requestMethod: options.method,
                                url: url
                            })
                        ];
                }
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $43ca5dbe92db6f17$export$6d71b655afe1638d(connection, json, processFunc) {
    var processJsonFunc = function(value, response) {
        var result = null;
        if (value != null) try {
            result = JSON.parse((0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)(value));
        } catch (error) {
            $43ca5dbe92db6f17$var$logger.throwError("invalid JSON", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    var body = null;
    if (json != null) {
        body = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(json);
        // Create a connection with the content-type set for JSON
        var updated = typeof connection === "string" ? {
            url: connection
        } : (0, $8832fb576a60463b$export$9c13236873b118a5)(connection);
        if (updated.headers) {
            var hasContentType = Object.keys(updated.headers).filter(function(k) {
                return k.toLowerCase() === "content-type";
            }).length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $8832fb576a60463b$export$9c13236873b118a5)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $43ca5dbe92db6f17$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $43ca5dbe92db6f17$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $8832fb576a60463b$export$9c13236873b118a5)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        var timer = null;
        var done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        var cancel = function() {
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(function() {
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        var retryLimit = options.retryLimit;
        var attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    var timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}



var $gHFi0 = parcelRequire("gHFi0");

var $a5b1dc8d7da2a5bb$export$83d89fbfd8236492 = "providers/5.7.2";



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");








"use strict";
var $2fc925c8cd1d3841$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $2fc925c8cd1d3841$export$a06636add2a09fd8 = /*#__PURE__*/ function() {
    function Formatter() {
        (0, $7dKN1._)(this, Formatter);
        this.formats = this.getDefaultFormats();
    }
    (0, $eW5pA._)(Formatter, [
        {
            key: "getDefaultFormats",
            value: function getDefaultFormats() {
                var _this = this;
                var formats = {};
                var address = this.address.bind(this);
                var bigNumber = this.bigNumber.bind(this);
                var blockTag = this.blockTag.bind(this);
                var data = this.data.bind(this);
                var hash = this.hash.bind(this);
                var hex = this.hex.bind(this);
                var number = this.number.bind(this);
                var type = this.type.bind(this);
                var strictData = function(v) {
                    return _this.data(v, true);
                };
                formats.transaction = {
                    hash: hash,
                    type: type,
                    accessList: Formatter.allowNull(this.accessList.bind(this), null),
                    blockHash: Formatter.allowNull(hash, null),
                    blockNumber: Formatter.allowNull(number, null),
                    transactionIndex: Formatter.allowNull(number, null),
                    confirmations: Formatter.allowNull(number, null),
                    from: address,
                    // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
                    // must be set
                    gasPrice: Formatter.allowNull(bigNumber),
                    maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
                    maxFeePerGas: Formatter.allowNull(bigNumber),
                    gasLimit: bigNumber,
                    to: Formatter.allowNull(address, null),
                    value: bigNumber,
                    nonce: number,
                    data: data,
                    r: Formatter.allowNull(this.uint256),
                    s: Formatter.allowNull(this.uint256),
                    v: Formatter.allowNull(number),
                    creates: Formatter.allowNull(address, null),
                    raw: Formatter.allowNull(data)
                };
                formats.transactionRequest = {
                    from: Formatter.allowNull(address),
                    nonce: Formatter.allowNull(number),
                    gasLimit: Formatter.allowNull(bigNumber),
                    gasPrice: Formatter.allowNull(bigNumber),
                    maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
                    maxFeePerGas: Formatter.allowNull(bigNumber),
                    to: Formatter.allowNull(address),
                    value: Formatter.allowNull(bigNumber),
                    data: Formatter.allowNull(strictData),
                    type: Formatter.allowNull(number),
                    accessList: Formatter.allowNull(this.accessList.bind(this), null)
                };
                formats.receiptLog = {
                    transactionIndex: number,
                    blockNumber: number,
                    transactionHash: hash,
                    address: address,
                    topics: Formatter.arrayOf(hash),
                    data: data,
                    logIndex: number,
                    blockHash: hash
                };
                formats.receipt = {
                    to: Formatter.allowNull(this.address, null),
                    from: Formatter.allowNull(this.address, null),
                    contractAddress: Formatter.allowNull(address, null),
                    transactionIndex: number,
                    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
                    root: Formatter.allowNull(hex),
                    gasUsed: bigNumber,
                    logsBloom: Formatter.allowNull(data),
                    blockHash: hash,
                    transactionHash: hash,
                    logs: Formatter.arrayOf(this.receiptLog.bind(this)),
                    blockNumber: number,
                    confirmations: Formatter.allowNull(number, null),
                    cumulativeGasUsed: bigNumber,
                    effectiveGasPrice: Formatter.allowNull(bigNumber),
                    status: Formatter.allowNull(number),
                    type: type
                };
                formats.block = {
                    hash: Formatter.allowNull(hash),
                    parentHash: hash,
                    number: number,
                    timestamp: number,
                    nonce: Formatter.allowNull(hex),
                    difficulty: this.difficulty.bind(this),
                    gasLimit: bigNumber,
                    gasUsed: bigNumber,
                    miner: Formatter.allowNull(address),
                    extraData: data,
                    transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
                    baseFeePerGas: Formatter.allowNull(bigNumber)
                };
                formats.blockWithTransactions = (0, $8832fb576a60463b$export$9c13236873b118a5)(formats.block);
                formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
                formats.filter = {
                    fromBlock: Formatter.allowNull(blockTag, undefined),
                    toBlock: Formatter.allowNull(blockTag, undefined),
                    blockHash: Formatter.allowNull(hash, undefined),
                    address: Formatter.allowNull(address, undefined),
                    topics: Formatter.allowNull(this.topics.bind(this), undefined)
                };
                formats.filterLog = {
                    blockNumber: Formatter.allowNull(number),
                    blockHash: Formatter.allowNull(hash),
                    transactionIndex: number,
                    removed: Formatter.allowNull(this.boolean.bind(this)),
                    address: address,
                    data: Formatter.allowFalsish(data, "0x"),
                    topics: Formatter.arrayOf(hash),
                    transactionHash: hash,
                    logIndex: number
                };
                return formats;
            }
        },
        {
            key: "accessList",
            value: function accessList(accessList) {
                return (0, $fd7cc3a32c93c53c$export$6c8662b1600dce2)(accessList || []);
            }
        },
        {
            // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
            // Strict! Used on input.
            key: "number",
            value: function number(number) {
                if (number === "0x") return 0;
                return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(number).toNumber();
            }
        },
        {
            key: "type",
            value: function type(number) {
                if (number === "0x" || number == null) return 0;
                return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(number).toNumber();
            }
        },
        {
            // Strict! Used on input.
            key: "bigNumber",
            value: function bigNumber(value) {
                return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
            }
        },
        {
            // Requires a boolean, "true" or  "false"; returns a boolean
            key: "boolean",
            value: function boolean(value) {
                if (typeof value === "boolean") return value;
                if (typeof value === "string") {
                    value = value.toLowerCase();
                    if (value === "true") return true;
                    if (value === "false") return false;
                }
                throw new Error("invalid boolean - " + value);
            }
        },
        {
            key: "hex",
            value: function hex(value, strict) {
                if (typeof value === "string") {
                    if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
                    if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value)) return value.toLowerCase();
                }
                return $2fc925c8cd1d3841$var$logger.throwArgumentError("invalid hash", "value", value);
            }
        },
        {
            key: "data",
            value: function data(value, strict) {
                var result = this.hex(value, strict);
                if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
                return result;
            }
        },
        {
            // Requires an address
            // Strict! Used on input.
            key: "address",
            value: function address(value) {
                return (0, $77ffbd0470aad2fd$export$88411125f012957a)(value);
            }
        },
        {
            key: "callAddress",
            value: function callAddress(value) {
                if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value, 32)) return null;
                var address = (0, $77ffbd0470aad2fd$export$88411125f012957a)((0, $b8b53b1cc922c9da$export$15da666eba198c18)(value, 12));
                return address === (0, $6088cb855366de49$export$badd13187c087617) ? null : address;
            }
        },
        {
            key: "contractAddress",
            value: function contractAddress(value) {
                return (0, $77ffbd0470aad2fd$export$b7fbffef12272e40)(value);
            }
        },
        {
            // Strict! Used on input.
            key: "blockTag",
            value: function blockTag(blockTag) {
                if (blockTag == null) return "latest";
                if (blockTag === "earliest") return "0x0";
                switch(blockTag){
                    case "earliest":
                        return "0x0";
                    case "latest":
                    case "pending":
                    case "safe":
                    case "finalized":
                        return blockTag;
                }
                if (typeof blockTag === "number" || (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(blockTag)) return (0, $b8b53b1cc922c9da$export$6916af760a341dd3)(blockTag);
                throw new Error("invalid blockTag");
            }
        },
        {
            // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
            key: "hash",
            value: function hash(value, strict) {
                var result = this.hex(value, strict);
                if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(result) !== 32) return $2fc925c8cd1d3841$var$logger.throwArgumentError("invalid hash", "value", value);
                return result;
            }
        },
        {
            // Returns the difficulty as a number, or if too large (i.e. PoA network) null
            key: "difficulty",
            value: function difficulty(value) {
                if (value == null) return null;
                var v = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value);
                try {
                    return v.toNumber();
                } catch (error) {}
                return null;
            }
        },
        {
            key: "uint256",
            value: function uint256(value) {
                if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
                return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(value, 32);
            }
        },
        {
            key: "_block",
            value: function _block(value, format) {
                if (value.author != null && value.miner == null) value.miner = value.author;
                // The difficulty may need to come from _difficulty in recursed blocks
                var difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
                var result = Formatter.check(format, value);
                result._difficulty = difficulty == null ? null : (0, $3b33bab384c8baec$export$d97aa349ed20696).from(difficulty);
                return result;
            }
        },
        {
            key: "block",
            value: function block(value) {
                return this._block(value, this.formats.block);
            }
        },
        {
            key: "blockWithTransactions",
            value: function blockWithTransactions(value) {
                return this._block(value, this.formats.blockWithTransactions);
            }
        },
        {
            // Strict! Used on input.
            key: "transactionRequest",
            value: function transactionRequest(value) {
                return Formatter.check(this.formats.transactionRequest, value);
            }
        },
        {
            key: "transactionResponse",
            value: function transactionResponse(transaction) {
                // Rename gas to gasLimit
                if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
                // Some clients (TestRPC) do strange things like return 0x0 for the
                // 0 address; correct this to be a real address
                if (transaction.to && (0, $3b33bab384c8baec$export$d97aa349ed20696).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
                // Rename input to data
                if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
                // If to and creates are empty, populate the creates from the transaction
                if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
                if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
                var result = Formatter.check(this.formats.transaction, transaction);
                if (transaction.chainId != null) {
                    var chainId = transaction.chainId;
                    if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(chainId).toNumber();
                    result.chainId = chainId;
                } else {
                    var chainId1 = transaction.networkId;
                    // geth-etc returns chainId
                    if (chainId1 == null && result.v == null) chainId1 = transaction.chainId;
                    if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(chainId1)) chainId1 = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(chainId1).toNumber();
                    if (typeof chainId1 !== "number" && result.v != null) {
                        chainId1 = (result.v - 35) / 2;
                        if (chainId1 < 0) chainId1 = 0;
                        chainId1 = parseInt(chainId1);
                    }
                    if (typeof chainId1 !== "number") chainId1 = 0;
                    result.chainId = chainId1;
                }
                // 0x0000... should actually be null
                if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
                return result;
            }
        },
        {
            key: "transaction",
            value: function transaction(value) {
                return (0, $fd7cc3a32c93c53c$export$98e6a39c04603d36)(value);
            }
        },
        {
            key: "receiptLog",
            value: function receiptLog(value) {
                return Formatter.check(this.formats.receiptLog, value);
            }
        },
        {
            key: "receipt",
            value: function receipt(value) {
                var result = Formatter.check(this.formats.receipt, value);
                // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
                if (result.root != null) {
                    if (result.root.length <= 4) {
                        // Could be 0x00, 0x0, 0x01 or 0x1
                        var _$value = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result.root).toNumber();
                        if (_$value === 0 || _$value === 1) {
                            // Make sure if both are specified, they match
                            if (result.status != null && result.status !== _$value) $2fc925c8cd1d3841$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                                root: result.root,
                                status: result.status
                            });
                            result.status = _$value;
                            delete result.root;
                        } else $2fc925c8cd1d3841$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
                    } else if (result.root.length !== 66) // Must be a valid bytes32
                    $2fc925c8cd1d3841$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
                }
                if (result.status != null) result.byzantium = true;
                return result;
            }
        },
        {
            key: "topics",
            value: function topics(value) {
                var _this = this;
                if (Array.isArray(value)) return value.map(function(v) {
                    return _this.topics(v);
                });
                else if (value != null) return this.hash(value, true);
                return null;
            }
        },
        {
            key: "filter",
            value: function filter(value) {
                return Formatter.check(this.formats.filter, value);
            }
        },
        {
            key: "filterLog",
            value: function filterLog(value) {
                return Formatter.check(this.formats.filterLog, value);
            }
        }
    ], [
        {
            key: "check",
            value: function check(format, object) {
                var result = {};
                for(var key in format)try {
                    var value = format[key](object[key]);
                    if (value !== undefined) result[key] = value;
                } catch (error) {
                    error.checkKey = key;
                    error.checkValue = object[key];
                    throw error;
                }
                return result;
            }
        },
        {
            key: "allowNull",
            value: // if value is null-ish, nullValue is returned
            function allowNull(format, nullValue) {
                return function(value) {
                    if (value == null) return nullValue;
                    return format(value);
                };
            }
        },
        {
            key: "allowFalsish",
            value: // If value is false-ish, replaceValue is returned
            function allowFalsish(format, replaceValue) {
                return function(value) {
                    if (!value) return replaceValue;
                    return format(value);
                };
            }
        },
        {
            key: "arrayOf",
            value: // Requires an Array satisfying check
            function arrayOf(format) {
                return function(array) {
                    if (!Array.isArray(array)) throw new Error("not an array");
                    var result = [];
                    array.forEach(function(value) {
                        result.push(format(value));
                    });
                    return result;
                };
            }
        }
    ]);
    return Formatter;
}();
function $2fc925c8cd1d3841$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $2fc925c8cd1d3841$export$d93d5f61c2498b6(value) {
    return $2fc925c8cd1d3841$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
var $2fc925c8cd1d3841$var$throttleMessage = false;
function $2fc925c8cd1d3841$export$4c41bd49e82e82ab() {
    if ($2fc925c8cd1d3841$var$throttleMessage) return;
    $2fc925c8cd1d3841$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}


"use strict";
var $526e8ebee4b63c77$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $526e8ebee4b63c77$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $526e8ebee4b63c77$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $526e8ebee4b63c77$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(topic) !== 32) $526e8ebee4b63c77$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $526e8ebee4b63c77$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map(function(topic) {
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            var unique = {};
            topic.forEach(function(topic) {
                unique[$526e8ebee4b63c77$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            var sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $526e8ebee4b63c77$var$checkTopic(topic);
    }).join("&");
}
function $526e8ebee4b63c77$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map(function(topic) {
        if (topic === "") return [];
        var comps = topic.split("|").map(function(topic) {
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $526e8ebee4b63c77$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $b8b53b1cc922c9da$export$13882f896d3c0683)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $526e8ebee4b63c77$var$serializeTopics(eventName);
    else if ((0, $fc170b81a17b0865$export$406ece1549ccd00e).isForkEvent(eventName)) {
        $526e8ebee4b63c77$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $526e8ebee4b63c77$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $526e8ebee4b63c77$var$getTime() {
    return new Date().getTime();
}
function $526e8ebee4b63c77$var$stall(duration) {
    return new Promise(function(resolve) {
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ var $526e8ebee4b63c77$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
var $526e8ebee4b63c77$export$d61e24a684f9e51 = /*#__PURE__*/ function() {
    function Event(tag, listener, once) {
        (0, $7dKN1._)(this, Event);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "tag", tag);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "listener", listener);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    (0, $eW5pA._)(Event, [
        {
            key: "event",
            get: function get() {
                switch(this.type){
                    case "tx":
                        return this.hash;
                    case "filter":
                        return this.filter;
                }
                return this.tag;
            }
        },
        {
            key: "type",
            get: function get() {
                return this.tag.split(":")[0];
            }
        },
        {
            key: "hash",
            get: function get() {
                var comps = this.tag.split(":");
                if (comps[0] !== "tx") return null;
                return comps[1];
            }
        },
        {
            key: "filter",
            get: function get() {
                var comps = this.tag.split(":");
                if (comps[0] !== "filter") return null;
                var address = comps[1];
                var topics = $526e8ebee4b63c77$var$deserializeTopics(comps[2]);
                var filter = {};
                if (topics.length > 0) filter.topics = topics;
                if (address && address !== "*") filter.address = address;
                return filter;
            }
        },
        {
            key: "pollable",
            value: function pollable() {
                return this.tag.indexOf(":") >= 0 || $526e8ebee4b63c77$var$PollableEvents.indexOf(this.tag) >= 0;
            }
        }
    ]);
    return Event;
}();
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
var $526e8ebee4b63c77$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $526e8ebee4b63c77$var$bytes32ify(value) {
    return (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)((0, $3b33bab384c8baec$export$d97aa349ed20696).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $526e8ebee4b63c77$var$base58Encode(data) {
    return (0, $59ddd2fedfa0199a$export$45a587635c9954b2).encode((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        data,
        (0, $b8b53b1cc922c9da$export$15da666eba198c18)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)((0, $fd8149ac93df5472$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
var $526e8ebee4b63c77$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
var $526e8ebee4b63c77$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $526e8ebee4b63c77$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $526e8ebee4b63c77$var$_parseString(result, start) {
    try {
        return (0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)($526e8ebee4b63c77$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $526e8ebee4b63c77$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    var offset = (0, $3b33bab384c8baec$export$d97aa349ed20696).from((0, $b8b53b1cc922c9da$export$15da666eba198c18)(result, start, start + 32)).toNumber();
    var length = (0, $3b33bab384c8baec$export$d97aa349ed20696).from((0, $b8b53b1cc922c9da$export$15da666eba198c18)(result, offset, offset + 32)).toNumber();
    return (0, $b8b53b1cc922c9da$export$15da666eba198c18)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $526e8ebee4b63c77$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $526e8ebee4b63c77$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return "https://gateway.ipfs.io/ipfs/".concat(link);
}
function $526e8ebee4b63c77$var$numPad(value) {
    var result = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    var padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $526e8ebee4b63c77$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    var result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $526e8ebee4b63c77$var$encodeBytes(datas) {
    var result = [];
    var byteCount = 0;
    // Add place-holders for pointers as we add items
    for(var i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(var i1 = 0; i1 < datas.length; i1++){
        var data = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(datas[i1]);
        // Update the bytes offset
        result[i1] = $526e8ebee4b63c77$var$numPad(byteCount);
        // The length and padded value of data
        result.push($526e8ebee4b63c77$var$numPad(data.length));
        result.push($526e8ebee4b63c77$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)(result);
}
var $526e8ebee4b63c77$export$8b4c839865b08288 = /*#__PURE__*/ function() {
    function Resolver(provider, address, name, resolvedAddress) {
        (0, $7dKN1._)(this, Resolver);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "provider", provider);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "name", name);
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "address", provider.formatter.address(address));
        (0, $8832fb576a60463b$export$104236534534f9be)(this, "_resolvedAddress", resolvedAddress);
    }
    (0, $eW5pA._)(Resolver, [
        {
            key: "supportsWildcard",
            value: function supportsWildcard() {
                var _this = this;
                if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
                this._supportsEip2544 = this.provider.call({
                    to: this.address,
                    data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
                }).then(function(result) {
                    return (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result).eq(1);
                }).catch(function(error) {
                    if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION) return false;
                    // Rethrow the error: link is down, etc. Let future attempts retry.
                    _this._supportsEip2544 = null;
                    throw error;
                });
                return this._supportsEip2544;
            }
        },
        {
            key: "_fetch",
            value: function _fetch(selector, parameters) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var tx, parseBytes, result, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // e.g. keccak256("addr(bytes32,uint256)")
                                tx = {
                                    to: this.address,
                                    ccipReadEnabled: true,
                                    data: (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                                        selector,
                                        (0, $502d474d526285f9$export$91d651ee363e1209)(this.name),
                                        parameters || "0x"
                                    ])
                                };
                                // Wildcard support; use EIP-2544 to resolve the request
                                parseBytes = false;
                                return [
                                    4,
                                    this.supportsWildcard()
                                ];
                            case 1:
                                if (_state.sent()) {
                                    parseBytes = true;
                                    // selector("resolve(bytes,bytes)")
                                    tx.data = (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                                        "0x9061b923",
                                        $526e8ebee4b63c77$var$encodeBytes([
                                            (0, $502d474d526285f9$export$6c0a8cdae51cb512)(this.name),
                                            tx.data
                                        ])
                                    ]);
                                }
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.provider.call(tx)
                                ];
                            case 3:
                                result = _state.sent();
                                if ((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(result).length % 32 === 4) $526e8ebee4b63c77$var$logger.throwError("resolver threw error", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                                    transaction: tx,
                                    data: result
                                });
                                if (parseBytes) result = $526e8ebee4b63c77$var$_parseBytes(result, 0);
                                return [
                                    2,
                                    result
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_fetchBytes",
            value: function _fetchBytes(selector, parameters) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._fetch(selector, parameters)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result != null) return [
                                    2,
                                    $526e8ebee4b63c77$var$_parseBytes(result, 0)
                                ];
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getAddress",
            value: function _getAddress(coinType, hexBytes) {
                var coinInfo = $526e8ebee4b63c77$var$coinInfos[String(coinType)];
                if (coinInfo == null) $526e8ebee4b63c77$var$logger.throwError("unsupported coin type: ".concat(coinType), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "getAddress(".concat(coinType, ")")
                });
                if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
                var bytes = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(hexBytes);
                // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
                if (coinInfo.p2pkh != null) {
                    var p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
                    if (p2pkh) {
                        var length = parseInt(p2pkh[1], 16);
                        if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $526e8ebee4b63c77$var$base58Encode((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                            [
                                coinInfo.p2pkh
                            ],
                            "0x" + p2pkh[2]
                        ]));
                    }
                }
                // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
                if (coinInfo.p2sh != null) {
                    var p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
                    if (p2sh) {
                        var length1 = parseInt(p2sh[1], 16);
                        if (p2sh[2].length === length1 * 2 && length1 >= 1 && length1 <= 75) return $526e8ebee4b63c77$var$base58Encode((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                            [
                                coinInfo.p2sh
                            ],
                            "0x" + p2sh[2]
                        ]));
                    }
                }
                // Bech32
                if (coinInfo.prefix != null) {
                    var length2 = bytes[1];
                    // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
                    var _$version = bytes[0];
                    if (_$version === 0x00) {
                        if (length2 !== 20 && length2 !== 32) _$version = -1;
                    } else _$version = -1;
                    if (_$version >= 0 && bytes.length === 2 + length2 && length2 >= 1 && length2 <= 75) {
                        var words = (0, (/*@__PURE__*/$parcel$interopDefault($gHFi0))).toWords(bytes.slice(2));
                        words.unshift(_$version);
                        return (0, (/*@__PURE__*/$parcel$interopDefault($gHFi0))).encode(coinInfo.prefix, words);
                    }
                }
                return null;
            }
        },
        {
            key: "getAddress",
            value: function getAddress(coinType) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var result, error, hexBytes, address;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (coinType == null) coinType = 60;
                                if (!(coinType === 60)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._fetch("0x3b3b57de")
                                ];
                            case 2:
                                result = _state.sent();
                                // No address
                                if (result === "0x" || result === (0, $4865d0dc710dfa88$export$71c2e4e213dcb7f2)) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    this.provider.formatter.callAddress(result)
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION) return [
                                    2,
                                    null
                                ];
                                throw error;
                            case 4:
                                return [
                                    4,
                                    this._fetchBytes("0xf1cb7e06", $526e8ebee4b63c77$var$bytes32ify(coinType))
                                ];
                            case 5:
                                hexBytes = _state.sent();
                                // No address
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                // Compute the address
                                address = this._getAddress(coinType, hexBytes);
                                if (address == null) $526e8ebee4b63c77$var$logger.throwError("invalid or unsupported coin data", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    operation: "getAddress(".concat(coinType, ")"),
                                    coinType: coinType,
                                    data: hexBytes
                                });
                                return [
                                    2,
                                    address
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getAvatar",
            value: function getAvatar() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var linkage, avatar, i, match, scheme, selector, owner, _tmp, comps, addr, tokenId, tokenOwner, _, _1, balance, _2, tx, metadataUrl, metadata, imageUrl, ipfs, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                linkage = [
                                    {
                                        type: "name",
                                        content: this.name
                                    }
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    19,
                                    ,
                                    20
                                ]);
                                return [
                                    4,
                                    this.getText("avatar")
                                ];
                            case 2:
                                avatar = _state.sent();
                                if (avatar == null) return [
                                    2,
                                    null
                                ];
                                i = 0;
                                _state.label = 3;
                            case 3:
                                if (!(i < $526e8ebee4b63c77$var$matchers.length)) return [
                                    3,
                                    18
                                ];
                                match = avatar.match($526e8ebee4b63c77$var$matchers[i]);
                                if (match == null) return [
                                    3,
                                    17
                                ];
                                scheme = match[1].toLowerCase();
                                switch(scheme){
                                    case "https":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "data":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "ipfs":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "erc721":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "erc1155":
                                        return [
                                            3,
                                            7
                                        ];
                                }
                                return [
                                    3,
                                    17
                                ];
                            case 4:
                                linkage.push({
                                    type: "url",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: avatar
                                    }
                                ];
                            case 5:
                                linkage.push({
                                    type: "data",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: avatar
                                    }
                                ];
                            case 6:
                                linkage.push({
                                    type: "ipfs",
                                    content: avatar
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: $526e8ebee4b63c77$var$getIpfsLink(avatar)
                                    }
                                ];
                            case 7:
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                _tmp = this._resolvedAddress;
                                if (_tmp) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 8:
                                _tmp = _state.sent();
                                _state.label = 9;
                            case 9:
                                owner = _tmp;
                                comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this.provider.formatter.address(comps[0])
                                ];
                            case 10:
                                addr = _state.sent();
                                tokenId = (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)((0, $3b33bab384c8baec$export$d97aa349ed20696).from(comps[1]).toHexString(), 32);
                                if (!(scheme === "erc721")) return [
                                    3,
                                    12
                                ];
                                _1 = (_ = this.provider.formatter).callAddress;
                                return [
                                    4,
                                    this.provider.call({
                                        to: addr,
                                        data: (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })
                                ];
                            case 11:
                                tokenOwner = _1.apply(_, [
                                    _state.sent()
                                ]);
                                if (owner !== tokenOwner) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "owner",
                                    content: tokenOwner
                                });
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                if (!(scheme === "erc1155")) return [
                                    3,
                                    14
                                ];
                                _2 = (0, $3b33bab384c8baec$export$d97aa349ed20696).from;
                                return [
                                    4,
                                    this.provider.call({
                                        to: addr,
                                        data: (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                                            "0x00fdd58e",
                                            (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(owner, 32),
                                            tokenId
                                        ])
                                    })
                                ];
                            case 13:
                                balance = _2.apply((0, $3b33bab384c8baec$export$d97aa349ed20696), [
                                    _state.sent()
                                ]);
                                if (balance.isZero()) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "balance",
                                    content: balance.toString()
                                });
                                _state.label = 14;
                            case 14:
                                // Call the token contract for the metadata URL
                                tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                return [
                                    4,
                                    this.provider.call(tx)
                                ];
                            case 15:
                                metadataUrl = $526e8ebee4b63c77$var$_parseString.apply(void 0, [
                                    _state.sent(),
                                    0
                                ]);
                                if (metadataUrl == null) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $526e8ebee4b63c77$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                return [
                                    4,
                                    (0, $43ca5dbe92db6f17$export$6d71b655afe1638d)(metadataUrl)
                                ];
                            case 16:
                                metadata = _state.sent();
                                if (!metadata) return [
                                    2,
                                    null
                                ];
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return [
                                    2,
                                    null
                                ];
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    ipfs = imageUrl.match($526e8ebee4b63c77$var$matcherIpfs);
                                    if (ipfs == null) return [
                                        2,
                                        null
                                    ];
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $526e8ebee4b63c77$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return [
                                    2,
                                    {
                                        linkage: linkage,
                                        url: imageUrl
                                    }
                                ];
                            case 17:
                                i++;
                                return [
                                    3,
                                    3
                                ];
                            case 18:
                                return [
                                    3,
                                    20
                                ];
                            case 19:
                                error = _state.sent();
                                return [
                                    3,
                                    20
                                ];
                            case 20:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getContentHash",
            value: function getContentHash() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var hexBytes, ipfs, length, ipns, length1, swarm, skynet, urlSafe, hash;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._fetchBytes("0xbc1c58d1")
                                ];
                            case 1:
                                hexBytes = _state.sent();
                                // No contenthash
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                // IPFS (CID: 1, Type: DAG-PB)
                                ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
                                if (ipfs) {
                                    length = parseInt(ipfs[3], 16);
                                    if (ipfs[4].length === length * 2) return [
                                        2,
                                        "ipfs://" + (0, $59ddd2fedfa0199a$export$45a587635c9954b2).encode("0x" + ipfs[1])
                                    ];
                                }
                                // IPNS (CID: 1, Type: libp2p-key)
                                ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
                                if (ipns) {
                                    length1 = parseInt(ipns[3], 16);
                                    if (ipns[4].length === length1 * 2) return [
                                        2,
                                        "ipns://" + (0, $59ddd2fedfa0199a$export$45a587635c9954b2).encode("0x" + ipns[1])
                                    ];
                                }
                                // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
                                swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
                                if (swarm) {
                                    if (swarm[1].length === 64) return [
                                        2,
                                        "bzz://" + swarm[1]
                                    ];
                                }
                                skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
                                if (skynet) {
                                    if (skynet[1].length === 68) {
                                        // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                                        urlSafe = {
                                            "=": "",
                                            "+": "-",
                                            "/": "_"
                                        };
                                        hash = (0, $20128c45dd8db8c0$export$c564cdbbe6da493)("0x" + skynet[1]).replace(/[=+\/]/g, function(a) {
                                            return urlSafe[a];
                                        });
                                        return [
                                            2,
                                            "sia://" + hash
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    $526e8ebee4b63c77$var$logger.throwError("invalid or unsupported content hash data", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                        operation: "getContentHash()",
                                        data: hexBytes
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getText",
            value: function getText(key) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var keyBytes, hexBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // The key encoded as parameter to fetchBytes
                                keyBytes = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(key);
                                // The nodehash consumes the first slot, so the string pointer targets
                                // offset 64, with the length at offset 64 and data starting at offset 96
                                keyBytes = (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                                    $526e8ebee4b63c77$var$bytes32ify(64),
                                    $526e8ebee4b63c77$var$bytes32ify(keyBytes.length),
                                    keyBytes
                                ]);
                                // Pad to word-size (32 bytes)
                                if (keyBytes.length % 32 !== 0) keyBytes = (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
                                    keyBytes,
                                    (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)("0x", 32 - key.length % 32)
                                ]);
                                return [
                                    4,
                                    this._fetchBytes("0x59d1d43c", (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(keyBytes))
                                ];
                            case 1:
                                hexBytes = _state.sent();
                                if (hexBytes == null || hexBytes === "0x") return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    (0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)(hexBytes)
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return Resolver;
}();
var $526e8ebee4b63c77$var$defaultFormatter = null;
var $526e8ebee4b63c77$var$nextPollId = 1;
var $526e8ebee4b63c77$export$ff3f6dd83125ac45 = /*#__PURE__*/ function _target(Provider) {
    (0, $cgJ2Y._)(BaseProvider, Provider);
    var _super = (0, $hKD8n._)(BaseProvider);
    function BaseProvider(network) {
        (0, $7dKN1._)(this, BaseProvider);
        var _this;
        _this = _super.call(this);
        // Events being listened to
        _this._events = [];
        _this._emitted = {
            block: -2
        };
        _this.disableCcipRead = false;
        _this.formatter = (this instanceof BaseProvider ? this.constructor : void 0).getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "anyNetwork", network === "any");
        if (_this.anyNetwork) network = _this.detectNetwork();
        if (network instanceof Promise) {
            _this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch(function(error) {});
            // Trigger initial network setting (async)
            _this._ready().catch(function(error) {});
        } else {
            var knownNetwork = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof BaseProvider ? this.constructor : void 0, "getNetwork")(network);
            if (knownNetwork) {
                (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_network", knownNetwork);
                _this.emit("network", knownNetwork, null);
            } else $526e8ebee4b63c77$var$logger.throwArgumentError("invalid network", "network", network);
        }
        _this._maxInternalBlockNumber = -1024;
        _this._lastBlockNumber = -2;
        _this._maxFilterBlockRange = 10;
        _this._pollingInterval = 4000;
        _this._fastQueryDate = 0;
        return _this;
    }
    (0, $eW5pA._)(BaseProvider, [
        {
            key: "_ready",
            value: function _ready() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var network, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this._network == null)) return [
                                    3,
                                    7
                                ];
                                network = null;
                                if (!this._networkPromise) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._networkPromise
                                ];
                            case 2:
                                network = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!(network == null)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.detectNetwork()
                                ];
                            case 5:
                                network = _state.sent();
                                _state.label = 6;
                            case 6:
                                // This should never happen; every Provider sub-class should have
                                // suggested a network by here (or have thrown).
                                if (!network) $526e8ebee4b63c77$var$logger.throwError("no network detected", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                                // Possible this call stacked so do not call defineReadOnly again
                                if (this._network == null) {
                                    if (this.anyNetwork) this._network = network;
                                    else (0, $8832fb576a60463b$export$104236534534f9be)(this, "_network", network);
                                    this.emit("network", network, null);
                                }
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    this._network
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "ready",
            get: // This will always return the most recently established network.
            // For "any", this can change (a "network" event is emitted before
            // any change is reflected); otherwise this cannot change
            function get() {
                var _this = this;
                return (0, $43ca5dbe92db6f17$export$e0c10349b2c5e1d4)(function() {
                    return _this._ready().then(function(network) {
                        return network;
                    }, function(error) {
                        // If the network isn't running yet, we will wait
                        if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                        throw error;
                    });
                });
            }
        },
        {
            key: "ccipReadFetch",
            value: function ccipReadFetch(tx, calldata, urls) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var sender, data, errorMessages, i, url, href, json, result, errorMessage;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.disableCcipRead || urls.length === 0) return [
                                    2,
                                    null
                                ];
                                sender = tx.to.toLowerCase();
                                data = calldata.toLowerCase();
                                errorMessages = [];
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < urls.length)) return [
                                    3,
                                    4
                                ];
                                url = urls[i];
                                // URL expansion
                                href = url.replace("{sender}", sender).replace("{data}", data);
                                // If no {data} is present, use POST; otherwise GET
                                json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                                    data: data,
                                    sender: sender
                                });
                                return [
                                    4,
                                    (0, $43ca5dbe92db6f17$export$6d71b655afe1638d)({
                                        url: href,
                                        errorPassThrough: true
                                    }, json, function(value, response) {
                                        value.status = response.statusCode;
                                        return value;
                                    })
                                ];
                            case 2:
                                result = _state.sent();
                                if (result.data) return [
                                    2,
                                    result.data
                                ];
                                errorMessage = result.message || "unknown error";
                                // 4xx indicates the result is not present; stop
                                if (result.status >= 400 && result.status < 500) return [
                                    2,
                                    $526e8ebee4b63c77$var$logger.throwError("response not found during CCIP fetch: ".concat(errorMessage), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                        url: url,
                                        errorMessage: errorMessage
                                    })
                                ];
                                // 5xx indicates server issue; try the next url
                                errorMessages.push(errorMessage);
                                _state.label = 3;
                            case 3:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2,
                                    $526e8ebee4b63c77$var$logger.throwError("error encountered during CCIP fetch: ".concat(errorMessages.map(function(m) {
                                        return JSON.stringify(m);
                                    }).join(", ")), (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                        urls: urls,
                                        errorMessages: errorMessages
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            // Fetches the blockNumber, but will reuse any result that is less
            // than maxAge old or has been requested since the last request
            key: "_getInternalBlockNumber",
            value: function _getInternalBlockNumber(maxAge) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, internalBlockNumber, result, error, reqTime, checkInternalBlockNumber;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this._ready()
                                ];
                            case 1:
                                _state.sent();
                                if (!(maxAge > 0)) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                if (!this._internalBlockNumber) return [
                                    3,
                                    7
                                ];
                                // ..."remember" which fetch we started with
                                internalBlockNumber = this._internalBlockNumber;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    internalBlockNumber
                                ];
                            case 4:
                                result = _state.sent();
                                if ($526e8ebee4b63c77$var$getTime() - result.respTime <= maxAge) return [
                                    2,
                                    result.blockNumber
                                ];
                                // Too old; fetch a new value
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                error = _state.sent();
                                // The fetch rejected; if we are the first to get the
                                // rejection, drop through so we replace it with a new
                                // fetch; all others blocked will then get that fetch
                                // which won't match the one they "remembered" and loop
                                if (this._internalBlockNumber === internalBlockNumber) return [
                                    3,
                                    7
                                ];
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                reqTime = $526e8ebee4b63c77$var$getTime();
                                checkInternalBlockNumber = (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                    blockNumber: this.perform("getBlockNumber", {}),
                                    networkError: this.getNetwork().then(function(network) {
                                        return null;
                                    }, function(error) {
                                        return error;
                                    })
                                }).then(function(param) {
                                    var blockNumber = param.blockNumber, networkError = param.networkError;
                                    if (networkError) {
                                        // Unremember this bad internal block number
                                        if (_this._internalBlockNumber === checkInternalBlockNumber) _this._internalBlockNumber = null;
                                        throw networkError;
                                    }
                                    var respTime = $526e8ebee4b63c77$var$getTime();
                                    blockNumber = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(blockNumber).toNumber();
                                    if (blockNumber < _this._maxInternalBlockNumber) blockNumber = _this._maxInternalBlockNumber;
                                    _this._maxInternalBlockNumber = blockNumber;
                                    _this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                                    return {
                                        blockNumber: blockNumber,
                                        reqTime: reqTime,
                                        respTime: respTime
                                    };
                                });
                                this._internalBlockNumber = checkInternalBlockNumber;
                                // Swallow unhandled exceptions; if needed they are handled else where
                                checkInternalBlockNumber.catch(function(error) {
                                    // Don't null the dead (rejected) fetch, if it has already been updated
                                    if (_this._internalBlockNumber === checkInternalBlockNumber) _this._internalBlockNumber = null;
                                });
                                return [
                                    4,
                                    checkInternalBlockNumber
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent().blockNumber
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "poll",
            value: function poll() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, pollId, runners, blockNumber, error, i;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                pollId = $526e8ebee4b63c77$var$nextPollId++;
                                // Track all running promises, so we can trigger a post-poll once they are complete
                                runners = [];
                                blockNumber = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + this.pollingInterval / 2)
                                ];
                            case 2:
                                blockNumber = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                this.emit("error", error);
                                return [
                                    2
                                ];
                            case 4:
                                this._setFastBlockNumber(blockNumber);
                                // Emit a poll event after we have the latest (fast) block number
                                this.emit("poll", pollId, blockNumber);
                                // If the block has not changed, meh.
                                if (blockNumber === this._lastBlockNumber) {
                                    this.emit("didPoll", pollId);
                                    return [
                                        2
                                    ];
                                }
                                // First polling cycle, trigger a "block" events
                                if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
                                if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                                    $526e8ebee4b63c77$var$logger.warn("network block skew detected; skipping block events (emitted=".concat(this._emitted.block, " blockNumber").concat(blockNumber, ")"));
                                    this.emit("error", $526e8ebee4b63c77$var$logger.makeError("network block skew detected", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                                        blockNumber: blockNumber,
                                        event: "blockSkew",
                                        previousBlockNumber: this._emitted.block
                                    }));
                                    this.emit("block", blockNumber);
                                } else // Notify all listener for each block that has passed
                                for(i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
                                // The emitted block was updated, check for obsolete events
                                if (this._emitted.block !== blockNumber) {
                                    this._emitted.block = blockNumber;
                                    Object.keys(this._emitted).forEach(function(key) {
                                        // The block event does not expire
                                        if (key === "block") return;
                                        // The block we were at when we emitted this event
                                        var eventBlockNumber = _this._emitted[key];
                                        // We cannot garbage collect pending transactions or blocks here
                                        // They should be garbage collected by the Provider when setting
                                        // "pending" events
                                        if (eventBlockNumber === "pending") return;
                                        // Evict any transaction hashes or block hashes over 12 blocks
                                        // old, since they should not return null anyways
                                        if (blockNumber - eventBlockNumber > 12) delete _this._emitted[key];
                                    });
                                }
                                // First polling cycle
                                if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
                                // Find all transaction hashes we are waiting on
                                this._events.forEach(function(event) {
                                    switch(event.type){
                                        case "tx":
                                            {
                                                var hash = event.hash;
                                                var runner = _this.getTransactionReceipt(hash).then(function(receipt) {
                                                    if (!receipt || receipt.blockNumber == null) return null;
                                                    _this._emitted["t:" + hash] = receipt.blockNumber;
                                                    _this.emit(hash, receipt);
                                                    return null;
                                                }).catch(function(error) {
                                                    _this.emit("error", error);
                                                });
                                                runners.push(runner);
                                                break;
                                            }
                                        case "filter":
                                            // We only allow a single getLogs to be in-flight at a time
                                            if (!event._inflight) {
                                                event._inflight = true;
                                                // This is the first filter for this event, so we want to
                                                // restrict events to events that happened no earlier than now
                                                if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                                                // Filter from the last *known* event; due to load-balancing
                                                // and some nodes returning updated block numbers before
                                                // indexing events, a logs result with 0 entries cannot be
                                                // trusted and we must retry a range which includes it again
                                                var filter = event.filter;
                                                filter.fromBlock = event._lastBlockNumber + 1;
                                                filter.toBlock = blockNumber;
                                                // Prevent fitler ranges from growing too wild, since it is quite
                                                // likely there just haven't been any events to move the lastBlockNumber.
                                                var minFromBlock = filter.toBlock - _this._maxFilterBlockRange;
                                                if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                                                if (filter.fromBlock < 0) filter.fromBlock = 0;
                                                var runner1 = _this.getLogs(filter).then(function(logs) {
                                                    // Allow the next getLogs
                                                    event._inflight = false;
                                                    if (logs.length === 0) return;
                                                    logs.forEach(function(log) {
                                                        // Only when we get an event for a given block number
                                                        // can we trust the events are indexed
                                                        if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                                        // Make sure we stall requests to fetch blocks and txs
                                                        _this._emitted["b:" + log.blockHash] = log.blockNumber;
                                                        _this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                                        _this.emit(filter, log);
                                                    });
                                                }).catch(function(error) {
                                                    _this.emit("error", error);
                                                    // Allow another getLogs (the range was not updated)
                                                    event._inflight = false;
                                                });
                                                runners.push(runner1);
                                            }
                                            break;
                                    }
                                });
                                this._lastBlockNumber = blockNumber;
                                // Once all events for this loop have been processed, emit "didPoll"
                                Promise.all(runners).then(function() {
                                    _this.emit("didPoll", pollId);
                                }).catch(function(error) {
                                    _this.emit("error", error);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            // Deprecated; do not use this
            key: "resetEventsBlock",
            value: function resetEventsBlock(blockNumber) {
                this._lastBlockNumber = blockNumber - 1;
                if (this.polling) this.poll();
            }
        },
        {
            key: "network",
            get: function get() {
                return this._network;
            }
        },
        {
            // This method should query the network if the underlying network
            // can change, such as when connected to a JSON-RPC backend
            key: "detectNetwork",
            value: function detectNetwork() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            $526e8ebee4b63c77$var$logger.throwError("provider does not support network detection", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                operation: "provider.detectNetwork"
                            })
                        ];
                    });
                });
            }
        },
        {
            key: "getNetwork",
            value: function getNetwork() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var network, currentNetwork, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._ready()
                                ];
                            case 1:
                                network = _state.sent();
                                return [
                                    4,
                                    this.detectNetwork()
                                ];
                            case 2:
                                currentNetwork = _state.sent();
                                if (!(network.chainId !== currentNetwork.chainId)) return [
                                    3,
                                    5
                                ];
                                if (!this.anyNetwork) return [
                                    3,
                                    4
                                ];
                                this._network = currentNetwork;
                                // Reset all internal block number guards and caches
                                this._lastBlockNumber = -2;
                                this._fastBlockNumber = null;
                                this._fastBlockNumberPromise = null;
                                this._fastQueryDate = 0;
                                this._emitted.block = -2;
                                this._maxInternalBlockNumber = -1024;
                                this._internalBlockNumber = null;
                                // The "network" event MUST happen before this method resolves
                                // so any events have a chance to unregister, so we stall an
                                // additional event loop before returning from /this/ call
                                this.emit("network", currentNetwork, network);
                                return [
                                    4,
                                    $526e8ebee4b63c77$var$stall(0)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    this._network
                                ];
                            case 4:
                                error = $526e8ebee4b63c77$var$logger.makeError("underlying network changed", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                                    event: "changed",
                                    network: network,
                                    detectedNetwork: currentNetwork
                                });
                                this.emit("error", error);
                                throw error;
                            case 5:
                                return [
                                    2,
                                    network
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "blockNumber",
            get: function get() {
                var _this = this;
                this._getInternalBlockNumber(100 + this.pollingInterval / 2).then(function(blockNumber) {
                    _this._setFastBlockNumber(blockNumber);
                }, function(error) {});
                return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
            }
        },
        {
            key: "polling",
            get: function get() {
                return this._poller != null;
            },
            set: function set(value) {
                var _this = this;
                if (value && !this._poller) {
                    this._poller = setInterval(function() {
                        _this.poll();
                    }, this.pollingInterval);
                    if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(function() {
                        _this.poll();
                        // We block additional polls until the polling interval
                        // is done, to prevent overwhelming the poll function
                        _this._bootstrapPoll = setTimeout(function() {
                            // If polling was disabled, something may require a poke
                            // since starting the bootstrap poll and it was disabled
                            if (!_this._poller) _this.poll();
                            // Clear out the bootstrap so we can do another
                            _this._bootstrapPoll = null;
                        }, _this.pollingInterval);
                    }, 0);
                } else if (!value && this._poller) {
                    clearInterval(this._poller);
                    this._poller = null;
                }
            }
        },
        {
            key: "pollingInterval",
            get: function get() {
                return this._pollingInterval;
            },
            set: function set(value) {
                var _this = this;
                if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
                this._pollingInterval = value;
                if (this._poller) {
                    clearInterval(this._poller);
                    this._poller = setInterval(function() {
                        _this.poll();
                    }, this._pollingInterval);
                }
            }
        },
        {
            key: "_getFastBlockNumber",
            value: function _getFastBlockNumber() {
                var _this = this;
                var now = $526e8ebee4b63c77$var$getTime();
                // Stale block number, request a newer value
                if (now - this._fastQueryDate > 2 * this._pollingInterval) {
                    this._fastQueryDate = now;
                    this._fastBlockNumberPromise = this.getBlockNumber().then(function(blockNumber) {
                        if (_this._fastBlockNumber == null || blockNumber > _this._fastBlockNumber) _this._fastBlockNumber = blockNumber;
                        return _this._fastBlockNumber;
                    });
                }
                return this._fastBlockNumberPromise;
            }
        },
        {
            key: "_setFastBlockNumber",
            value: function _setFastBlockNumber(blockNumber) {
                // Older block, maybe a stale request
                if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
                // Update the time we updated the blocknumber
                this._fastQueryDate = $526e8ebee4b63c77$var$getTime();
                // Newer block number, use  it
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
                    this._fastBlockNumber = blockNumber;
                    this._fastBlockNumberPromise = Promise.resolve(blockNumber);
                }
            }
        },
        {
            key: "waitForTransaction",
            value: function waitForTransaction(transactionHash, confirmations, timeout) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null)
                        ];
                    });
                });
            }
        },
        {
            key: "_waitForTransaction",
            value: function _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, receipt;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getTransactionReceipt(transactionHash)
                                ];
                            case 1:
                                receipt = _state.sent();
                                // Receipt is already good
                                if ((receipt ? receipt.confirmations : 0) >= confirmations) return [
                                    2,
                                    receipt
                                ];
                                // Poll until the receipt is good...
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        var cancelFuncs = [];
                                        var done = false;
                                        var alreadyDone = function alreadyDone() {
                                            if (done) return true;
                                            done = true;
                                            cancelFuncs.forEach(function(func) {
                                                func();
                                            });
                                            return false;
                                        };
                                        var minedHandler = function(receipt) {
                                            if (receipt.confirmations < confirmations) return;
                                            if (alreadyDone()) return;
                                            resolve(receipt);
                                        };
                                        _this.on(transactionHash, minedHandler);
                                        cancelFuncs.push(function() {
                                            _this.removeListener(transactionHash, minedHandler);
                                        });
                                        if (replaceable) {
                                            var lastBlockNumber = replaceable.startBlock;
                                            var scannedBlock = null;
                                            var replaceHandler = function(blockNumber) {
                                                return $526e8ebee4b63c77$var$__awaiter(_this, void 0, void 0, function() {
                                                    var _this;
                                                    return (0, $6qu4b.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _this = this;
                                                                if (done) return [
                                                                    2
                                                                ];
                                                                // Wait 1 second; this is only used in the case of a fault, so
                                                                // we will trade off a little bit of latency for more consistent
                                                                // results and fewer JSON-RPC calls
                                                                return [
                                                                    4,
                                                                    $526e8ebee4b63c77$var$stall(1000)
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                this.getTransactionCount(replaceable.from).then(function(nonce) {
                                                                    return $526e8ebee4b63c77$var$__awaiter(_this, void 0, void 0, function() {
                                                                        var mined, block, ti, tx, receipt, reason;
                                                                        return (0, $6qu4b.__generator)(this, function(_state) {
                                                                            switch(_state.label){
                                                                                case 0:
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    if (!(nonce <= replaceable.nonce)) return [
                                                                                        3,
                                                                                        1
                                                                                    ];
                                                                                    lastBlockNumber = blockNumber;
                                                                                    return [
                                                                                        3,
                                                                                        9
                                                                                    ];
                                                                                case 1:
                                                                                    return [
                                                                                        4,
                                                                                        this.getTransaction(transactionHash)
                                                                                    ];
                                                                                case 2:
                                                                                    mined = _state.sent();
                                                                                    if (mined && mined.blockNumber != null) return [
                                                                                        2
                                                                                    ];
                                                                                    // First time scanning. We start a little earlier for some
                                                                                    // wiggle room here to handle the eventually consistent nature
                                                                                    // of blockchain (e.g. the getTransactionCount was for a
                                                                                    // different block)
                                                                                    if (scannedBlock == null) {
                                                                                        scannedBlock = lastBlockNumber - 3;
                                                                                        if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                                                                    }
                                                                                    _state.label = 3;
                                                                                case 3:
                                                                                    if (!(scannedBlock <= blockNumber)) return [
                                                                                        3,
                                                                                        9
                                                                                    ];
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    return [
                                                                                        4,
                                                                                        this.getBlockWithTransactions(scannedBlock)
                                                                                    ];
                                                                                case 4:
                                                                                    block = _state.sent();
                                                                                    ti = 0;
                                                                                    _state.label = 5;
                                                                                case 5:
                                                                                    if (!(ti < block.transactions.length)) return [
                                                                                        3,
                                                                                        8
                                                                                    ];
                                                                                    tx = block.transactions[ti];
                                                                                    // Successfully mined!
                                                                                    if (tx.hash === transactionHash) return [
                                                                                        2
                                                                                    ];
                                                                                    if (!(tx.from === replaceable.from && tx.nonce === replaceable.nonce)) return [
                                                                                        3,
                                                                                        7
                                                                                    ];
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    return [
                                                                                        4,
                                                                                        this.waitForTransaction(tx.hash, confirmations)
                                                                                    ];
                                                                                case 6:
                                                                                    receipt = _state.sent();
                                                                                    // Already resolved or rejected (prolly a timeout)
                                                                                    if (alreadyDone()) return [
                                                                                        2
                                                                                    ];
                                                                                    // The reason we were replaced
                                                                                    reason = "replaced";
                                                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                                                    // Explain why we were replaced
                                                                                    reject($526e8ebee4b63c77$var$logger.makeError("transaction was replaced", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.TRANSACTION_REPLACED, {
                                                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                                                        reason: reason,
                                                                                        replacement: this._wrapTransaction(tx),
                                                                                        hash: transactionHash,
                                                                                        receipt: receipt
                                                                                    }));
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                                case 7:
                                                                                    ti++;
                                                                                    return [
                                                                                        3,
                                                                                        5
                                                                                    ];
                                                                                case 8:
                                                                                    scannedBlock++;
                                                                                    return [
                                                                                        3,
                                                                                        3
                                                                                    ];
                                                                                case 9:
                                                                                    if (done) return [
                                                                                        2
                                                                                    ];
                                                                                    this.once("block", replaceHandler);
                                                                                    return [
                                                                                        2
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                }, function(error) {
                                                                    if (done) return;
                                                                    _this.once("block", replaceHandler);
                                                                });
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                            };
                                            if (done) return;
                                            _this.once("block", replaceHandler);
                                            cancelFuncs.push(function() {
                                                _this.removeListener("block", replaceHandler);
                                            });
                                        }
                                        if (typeof timeout === "number" && timeout > 0) {
                                            var timer = setTimeout(function() {
                                                if (alreadyDone()) return;
                                                reject($526e8ebee4b63c77$var$logger.makeError("timeout exceeded", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.TIMEOUT, {
                                                    timeout: timeout
                                                }));
                                            }, timeout);
                                            if (timer.unref) timer.unref();
                                            cancelFuncs.push(function() {
                                                clearTimeout(timer);
                                            });
                                        }
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBlockNumber",
            value: function getBlockNumber() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            this._getInternalBlockNumber(0)
                        ];
                    });
                });
            }
        },
        {
            key: "getGasPrice",
            value: function getGasPrice() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.perform("getGasPrice", {})
                                ];
                            case 2:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "getGasPrice",
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBalance",
            value: function getBalance(addressOrName, blockTag) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getBalance", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "getBalance",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionCount",
            value: function getTransactionCount(addressOrName, blockTag) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getTransactionCount", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result).toNumber()
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "getTransactionCount",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getCode",
            value: function getCode(addressOrName, blockTag) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getCode", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "getCode",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getStorageAt",
            value: function getStorageAt(addressOrName, position, blockTag) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        address: this._getAddress(addressOrName),
                                        blockTag: this._getBlockTag(blockTag),
                                        position: Promise.resolve(position).then(function(p) {
                                            return (0, $b8b53b1cc922c9da$export$6916af760a341dd3)(p);
                                        })
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getStorageAt", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "getStorageAt",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            // This should be called by any subclass wrapping a TransactionResponse
            key: "_wrapTransaction",
            value: function _wrapTransaction(tx, hash, startBlock) {
                var _this = this;
                if (hash != null && (0, $b8b53b1cc922c9da$export$13882f896d3c0683)(hash) !== 32) throw new Error("invalid response - sendTransaction");
                var result = tx;
                // Check the hash we expect is the same as the hash the server reported
                if (hash != null && tx.hash !== hash) $526e8ebee4b63c77$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
                    expectedHash: tx.hash,
                    returnedHash: hash
                });
                result.wait = function(confirms, timeout) {
                    return $526e8ebee4b63c77$var$__awaiter(_this, void 0, void 0, function() {
                        var replacement, receipt;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (confirms == null) confirms = 1;
                                    if (timeout == null) timeout = 0;
                                    // Get the details to detect replacement
                                    replacement = undefined;
                                    if (confirms !== 0 && startBlock != null) replacement = {
                                        data: tx.data,
                                        from: tx.from,
                                        nonce: tx.nonce,
                                        to: tx.to,
                                        value: tx.value,
                                        startBlock: startBlock
                                    };
                                    return [
                                        4,
                                        this._waitForTransaction(tx.hash, confirms, timeout, replacement)
                                    ];
                                case 1:
                                    receipt = _state.sent();
                                    if (receipt == null && confirms === 0) return [
                                        2,
                                        null
                                    ];
                                    // No longer pending, allow the polling loop to garbage collect this
                                    this._emitted["t:" + tx.hash] = receipt.blockNumber;
                                    if (receipt.status === 0) $526e8ebee4b63c77$var$logger.throwError("transaction failed", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                                        transactionHash: tx.hash,
                                        transaction: tx,
                                        receipt: receipt
                                    });
                                    return [
                                        2,
                                        receipt
                                    ];
                            }
                        });
                    });
                };
                return result;
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(signedTransaction) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var hexTx, tx, blockNumber, hash, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    Promise.resolve(signedTransaction).then(function(t) {
                                        return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(t);
                                    })
                                ];
                            case 2:
                                hexTx = _state.sent();
                                tx = this.formatter.transaction(signedTransaction);
                                if (tx.confirmations == null) tx.confirmations = 0;
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                ];
                            case 3:
                                blockNumber = _state.sent();
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    this.perform("sendTransaction", {
                                        signedTransaction: hexTx
                                    })
                                ];
                            case 5:
                                hash = _state.sent();
                                return [
                                    2,
                                    this._wrapTransaction(tx, hash, blockNumber)
                                ];
                            case 6:
                                error = _state.sent();
                                error.transaction = tx;
                                error.transactionHash = tx.hash;
                                throw error;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getTransactionRequest",
            value: function _getTransactionRequest(transaction) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, values, tx, _, _1;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    transaction
                                ];
                            case 1:
                                values = _state.sent();
                                tx = {};
                                [
                                    "from",
                                    "to"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? _this._getAddress(v) : null;
                                    });
                                });
                                [
                                    "gasLimit",
                                    "gasPrice",
                                    "maxFeePerGas",
                                    "maxPriorityFeePerGas",
                                    "value"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? (0, $3b33bab384c8baec$export$d97aa349ed20696).from(v) : null;
                                    });
                                });
                                [
                                    "type"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v != null ? v : null;
                                    });
                                });
                                if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
                                [
                                    "data"
                                ].forEach(function(key) {
                                    if (values[key] == null) return;
                                    tx[key] = Promise.resolve(values[key]).then(function(v) {
                                        return v ? (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(v) : null;
                                    });
                                });
                                _1 = (_ = this.formatter).transactionRequest;
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)(tx)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getFilter",
            value: function _getFilter(filter) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, result, _, _1;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    filter
                                ];
                            case 1:
                                filter = _state.sent();
                                result = {};
                                if (filter.address != null) result.address = this._getAddress(filter.address);
                                [
                                    "blockHash",
                                    "topics"
                                ].forEach(function(key) {
                                    if (filter[key] == null) return;
                                    result[key] = filter[key];
                                });
                                [
                                    "fromBlock",
                                    "toBlock"
                                ].forEach(function(key) {
                                    if (filter[key] == null) return;
                                    result[key] = _this._getBlockTag(filter[key]);
                                });
                                _1 = (_ = this.formatter).filter;
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)(result)
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_call",
            value: function _call(transaction, blockTag, attempt) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var txSender, result, data, sender, urls, urlsOffset, urlsLength, urlsData, u, url, calldata, callbackSelector, extraData, ccipResult, tx, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (attempt >= $526e8ebee4b63c77$var$MAX_CCIP_REDIRECTS) $526e8ebee4b63c77$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                    redirects: attempt,
                                    transaction: transaction
                                });
                                txSender = transaction.to;
                                return [
                                    4,
                                    this.perform("call", {
                                        transaction: transaction,
                                        blockTag: blockTag
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!(attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $b8b53b1cc922c9da$export$13882f896d3c0683)(result) % 32 === 4)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                data = (0, $b8b53b1cc922c9da$export$15da666eba198c18)(result, 4);
                                // Check the sender of the OffchainLookup matches the transaction
                                sender = (0, $b8b53b1cc922c9da$export$15da666eba198c18)(data, 0, 32);
                                if (!(0, $3b33bab384c8baec$export$d97aa349ed20696).from(sender).eq(txSender)) $526e8ebee4b63c77$var$logger.throwError("CCIP Read sender did not match", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                                    name: "OffchainLookup",
                                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                    transaction: transaction,
                                    data: result
                                });
                                // Read the URLs from the response
                                urls = [];
                                urlsOffset = (0, $3b33bab384c8baec$export$d97aa349ed20696).from((0, $b8b53b1cc922c9da$export$15da666eba198c18)(data, 32, 64)).toNumber();
                                urlsLength = (0, $3b33bab384c8baec$export$d97aa349ed20696).from((0, $b8b53b1cc922c9da$export$15da666eba198c18)(data, urlsOffset, urlsOffset + 32)).toNumber();
                                urlsData = (0, $b8b53b1cc922c9da$export$15da666eba198c18)(data, urlsOffset + 32);
                                for(u = 0; u < urlsLength; u++){
                                    url = $526e8ebee4b63c77$var$_parseString(urlsData, u * 32);
                                    if (url == null) $526e8ebee4b63c77$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                                        name: "OffchainLookup",
                                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                        transaction: transaction,
                                        data: result
                                    });
                                    urls.push(url);
                                }
                                // Get the CCIP calldata to forward
                                calldata = $526e8ebee4b63c77$var$_parseBytes(data, 64);
                                // Get the callbackSelector (bytes4)
                                if (!(0, $3b33bab384c8baec$export$d97aa349ed20696).from((0, $b8b53b1cc922c9da$export$15da666eba198c18)(data, 100, 128)).isZero()) $526e8ebee4b63c77$var$logger.throwError("CCIP Read callback selector included junk", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                                    name: "OffchainLookup",
                                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                    transaction: transaction,
                                    data: result
                                });
                                callbackSelector = (0, $b8b53b1cc922c9da$export$15da666eba198c18)(data, 96, 100);
                                // Get the extra data to send back to the contract as context
                                extraData = $526e8ebee4b63c77$var$_parseBytes(data, 128);
                                return [
                                    4,
                                    this.ccipReadFetch(transaction, calldata, urls)
                                ];
                            case 3:
                                ccipResult = _state.sent();
                                if (ccipResult == null) $526e8ebee4b63c77$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                                    name: "OffchainLookup",
                                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                    transaction: transaction,
                                    data: result
                                });
                                tx = {
                                    to: txSender,
                                    data: (0, $b8b53b1cc922c9da$export$6d4b99629b38754a)([
                                        callbackSelector,
                                        $526e8ebee4b63c77$var$encodeBytes([
                                            ccipResult,
                                            extraData
                                        ])
                                    ])
                                };
                                return [
                                    2,
                                    this._call(tx, blockTag, attempt + 1)
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR) throw error;
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                try {
                                    return [
                                        2,
                                        (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "call",
                                            params: {
                                                transaction: transaction,
                                                blockTag: blockTag
                                            },
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "call",
            value: function call(transaction, blockTag) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var resolved;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        transaction: this._getTransactionRequest(transaction),
                                        blockTag: this._getBlockTag(blockTag),
                                        ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
                                    })
                                ];
                            case 2:
                                resolved = _state.sent();
                                return [
                                    2,
                                    this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "estimateGas",
            value: function estimateGas(transaction) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var params, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        transaction: this._getTransactionRequest(transaction)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("estimateGas", params)
                                ];
                            case 3:
                                result = _state.sent();
                                try {
                                    return [
                                        2,
                                        (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result)
                                    ];
                                } catch (error) {
                                    return [
                                        2,
                                        $526e8ebee4b63c77$var$logger.throwError("bad result from backend", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                            method: "estimateGas",
                                            params: params,
                                            result: result,
                                            error: error
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getAddress",
            value: function _getAddress(addressOrName) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var address;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    addressOrName
                                ];
                            case 1:
                                addressOrName = _state.sent();
                                if (typeof addressOrName !== "string") $526e8ebee4b63c77$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
                                return [
                                    4,
                                    this.resolveName(addressOrName)
                                ];
                            case 2:
                                address = _state.sent();
                                if (address == null) $526e8ebee4b63c77$var$logger.throwError("ENS name not configured", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    operation: "resolveName(".concat(JSON.stringify(addressOrName), ")")
                                });
                                return [
                                    2,
                                    address
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getBlock",
            value: function _getBlock(blockHashOrBlockTag, includeTransactions) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blockNumber, params, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    blockHashOrBlockTag
                                ];
                            case 2:
                                blockHashOrBlockTag = _state.sent();
                                // If blockTag is a number (not "latest", etc), this is the block number
                                blockNumber = -128;
                                params = {
                                    includeTransactions: !!includeTransactions
                                };
                                if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(blockHashOrBlockTag, 32)) return [
                                    3,
                                    3
                                ];
                                params.blockHash = blockHashOrBlockTag;
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this._getBlockTag(blockHashOrBlockTag)
                                ];
                            case 4:
                                params.blockTag = _state.sent();
                                if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                $526e8ebee4b63c77$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2,
                                    (0, $43ca5dbe92db6f17$export$e0c10349b2c5e1d4)(function() {
                                        return $526e8ebee4b63c77$var$__awaiter(_this, void 0, void 0, function() {
                                            var _this, block, blockNumber1, i, tx, confirmations, blockWithTxs;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this = this;
                                                        return [
                                                            4,
                                                            this.perform("getBlock", params)
                                                        ];
                                                    case 1:
                                                        block = _state.sent();
                                                        // Block was not found
                                                        if (block == null) {
                                                            // For blockhashes, if we didn't say it existed, that blockhash may
                                                            // not exist. If we did see it though, perhaps from a log, we know
                                                            // it exists, and this node is just not caught up yet.
                                                            if (params.blockHash != null) {
                                                                if (this._emitted["b:" + params.blockHash] == null) return [
                                                                    2,
                                                                    null
                                                                ];
                                                            }
                                                            // For block tags, if we are asking for a future block, we return null
                                                            if (params.blockTag != null) {
                                                                if (blockNumber > this._emitted.block) return [
                                                                    2,
                                                                    null
                                                                ];
                                                            }
                                                            // Retry on the next block
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        if (!includeTransactions) return [
                                                            3,
                                                            8
                                                        ];
                                                        blockNumber1 = null;
                                                        i = 0;
                                                        _state.label = 2;
                                                    case 2:
                                                        if (!(i < block.transactions.length)) return [
                                                            3,
                                                            7
                                                        ];
                                                        tx = block.transactions[i];
                                                        if (!(tx.blockNumber == null)) return [
                                                            3,
                                                            3
                                                        ];
                                                        tx.confirmations = 0;
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 3:
                                                        if (!(tx.confirmations == null)) return [
                                                            3,
                                                            6
                                                        ];
                                                        if (!(blockNumber1 == null)) return [
                                                            3,
                                                            5
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 4:
                                                        blockNumber1 = _state.sent();
                                                        _state.label = 5;
                                                    case 5:
                                                        // Add the confirmations using the fast block number (pessimistic)
                                                        confirmations = blockNumber1 - tx.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        tx.confirmations = confirmations;
                                                        _state.label = 6;
                                                    case 6:
                                                        i++;
                                                        return [
                                                            3,
                                                            2
                                                        ];
                                                    case 7:
                                                        blockWithTxs = this.formatter.blockWithTransactions(block);
                                                        blockWithTxs.transactions = blockWithTxs.transactions.map(function(tx) {
                                                            return _this._wrapTransaction(tx);
                                                        });
                                                        return [
                                                            2,
                                                            blockWithTxs
                                                        ];
                                                    case 8:
                                                        return [
                                                            2,
                                                            this.formatter.block(block)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getBlock",
            value: function getBlock(blockHashOrBlockTag) {
                return this._getBlock(blockHashOrBlockTag, false);
            }
        },
        {
            key: "getBlockWithTransactions",
            value: function getBlockWithTransactions(blockHashOrBlockTag) {
                return this._getBlock(blockHashOrBlockTag, true);
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(transactionHash) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    transactionHash
                                ];
                            case 2:
                                transactionHash = _state.sent();
                                params = {
                                    transactionHash: this.formatter.hash(transactionHash, true)
                                };
                                return [
                                    2,
                                    (0, $43ca5dbe92db6f17$export$e0c10349b2c5e1d4)(function() {
                                        return $526e8ebee4b63c77$var$__awaiter(_this, void 0, void 0, function() {
                                            var result, tx, blockNumber, confirmations;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.perform("getTransaction", params)
                                                        ];
                                                    case 1:
                                                        result = _state.sent();
                                                        if (result == null) {
                                                            if (this._emitted["t:" + transactionHash] == null) return [
                                                                2,
                                                                null
                                                            ];
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        tx = this.formatter.transactionResponse(result);
                                                        if (!(tx.blockNumber == null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        tx.confirmations = 0;
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        if (!(tx.confirmations == null)) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 3:
                                                        blockNumber = _state.sent();
                                                        // Add the confirmations using the fast block number (pessimistic)
                                                        confirmations = blockNumber - tx.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        tx.confirmations = confirmations;
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2,
                                                            this._wrapTransaction(tx)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getTransactionReceipt",
            value: function getTransactionReceipt(transactionHash) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    transactionHash
                                ];
                            case 2:
                                transactionHash = _state.sent();
                                params = {
                                    transactionHash: this.formatter.hash(transactionHash, true)
                                };
                                return [
                                    2,
                                    (0, $43ca5dbe92db6f17$export$e0c10349b2c5e1d4)(function() {
                                        return $526e8ebee4b63c77$var$__awaiter(_this, void 0, void 0, function() {
                                            var result, receipt, blockNumber, confirmations;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.perform("getTransactionReceipt", params)
                                                        ];
                                                    case 1:
                                                        result = _state.sent();
                                                        if (result == null) {
                                                            if (this._emitted["t:" + transactionHash] == null) return [
                                                                2,
                                                                null
                                                            ];
                                                            return [
                                                                2,
                                                                undefined
                                                            ];
                                                        }
                                                        // "geth-etc" returns receipts before they are ready
                                                        if (result.blockHash == null) return [
                                                            2,
                                                            undefined
                                                        ];
                                                        receipt = this.formatter.receipt(result);
                                                        if (!(receipt.blockNumber == null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        receipt.confirmations = 0;
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        if (!(receipt.confirmations == null)) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                                        ];
                                                    case 3:
                                                        blockNumber = _state.sent();
                                                        // Add the confirmations using the fast block number (pessimistic)
                                                        confirmations = blockNumber - receipt.blockNumber + 1;
                                                        if (confirmations <= 0) confirmations = 1;
                                                        receipt.confirmations = confirmations;
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            2,
                                                            receipt
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getLogs",
            value: function getLogs(filter) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var params, logs;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8832fb576a60463b$export$d503dd157d963b60)({
                                        filter: this._getFilter(filter)
                                    })
                                ];
                            case 2:
                                params = _state.sent();
                                return [
                                    4,
                                    this.perform("getLogs", params)
                                ];
                            case 3:
                                logs = _state.sent();
                                logs.forEach(function(log) {
                                    if (log.removed == null) log.removed = false;
                                });
                                return [
                                    2,
                                    (0, $2fc925c8cd1d3841$export$a06636add2a09fd8).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getEtherPrice",
            value: function getEtherPrice() {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this.perform("getEtherPrice", {})
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getBlockTag",
            value: function _getBlockTag(blockTag) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var blockNumber;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockTag
                                ];
                            case 1:
                                blockTag = _state.sent();
                                if (!(typeof blockTag === "number" && blockTag < 0)) return [
                                    3,
                                    3
                                ];
                                if (blockTag % 1) $526e8ebee4b63c77$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                                return [
                                    4,
                                    this._getInternalBlockNumber(100 + 2 * this.pollingInterval)
                                ];
                            case 2:
                                blockNumber = _state.sent();
                                blockNumber += blockTag;
                                if (blockNumber < 0) blockNumber = 0;
                                return [
                                    2,
                                    this.formatter.blockTag(blockNumber)
                                ];
                            case 3:
                                return [
                                    2,
                                    this.formatter.blockTag(blockTag)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getResolver",
            value: function getResolver(name) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var currentName, addr, resolver, _tmp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                currentName = name;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    6
                                ];
                                if (currentName === "" || currentName === ".") return [
                                    2,
                                    null
                                ];
                                // Optimization since the eth node cannot change and does
                                // not have a wildcard resolver
                                if (name !== "eth" && currentName === "eth") return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this._getResolver(currentName, "getResolver")
                                ];
                            case 2:
                                addr = _state.sent();
                                if (!(addr != null)) return [
                                    3,
                                    5
                                ];
                                resolver = new $526e8ebee4b63c77$export$8b4c839865b08288(this, addr, name);
                                _tmp = currentName !== name;
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    resolver.supportsWildcard()
                                ];
                            case 3:
                                _tmp = !_state.sent();
                                _state.label = 4;
                            case 4:
                                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                                if (_tmp) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    resolver
                                ];
                            case 5:
                                // Get the parent node
                                currentName = currentName.split(".").slice(1).join(".");
                                return [
                                    3,
                                    1
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_getResolver",
            value: function _getResolver(name, operation) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var network, addrData, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (operation == null) operation = "ENS";
                                return [
                                    4,
                                    this.getNetwork()
                                ];
                            case 1:
                                network = _state.sent();
                                // No ENS...
                                if (!network.ensAddress) $526e8ebee4b63c77$var$logger.throwError("network does not support ENS", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    operation: operation,
                                    network: network.name
                                });
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.call({
                                        to: network.ensAddress,
                                        data: "0x0178b8bf" + (0, $502d474d526285f9$export$91d651ee363e1209)(name).substring(2)
                                    })
                                ];
                            case 3:
                                addrData = _state.sent();
                                return [
                                    2,
                                    this.formatter.callAddress(addrData)
                                ];
                            case 4:
                                error = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resolveName",
            value: function resolveName(name) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var resolver;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    name
                                ];
                            case 1:
                                name = _state.sent();
                                // If it is already an address, nothing to resolve
                                try {
                                    return [
                                        2,
                                        Promise.resolve(this.formatter.address(name))
                                    ];
                                } catch (error) {
                                    // If is is a hexstring, the address is bad (See #694)
                                    if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(name)) throw error;
                                }
                                if (typeof name !== "string") $526e8ebee4b63c77$var$logger.throwArgumentError("invalid ENS name", "name", name);
                                return [
                                    4,
                                    this.getResolver(name)
                                ];
                            case 2:
                                resolver = _state.sent();
                                if (!resolver) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    resolver.getAddress()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "lookupAddress",
            value: function lookupAddress(address) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var node, resolverAddr, name, addr;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    address
                                ];
                            case 1:
                                address = _state.sent();
                                address = this.formatter.address(address);
                                node = address.substring(2).toLowerCase() + ".addr.reverse";
                                return [
                                    4,
                                    this._getResolver(node, "lookupAddress")
                                ];
                            case 2:
                                resolverAddr = _state.sent();
                                if (resolverAddr == null) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    this.call({
                                        to: resolverAddr,
                                        data: "0x691f3431" + (0, $502d474d526285f9$export$91d651ee363e1209)(node).substring(2)
                                    })
                                ];
                            case 3:
                                name = $526e8ebee4b63c77$var$_parseString.apply(void 0, [
                                    _state.sent(),
                                    0
                                ]);
                                return [
                                    4,
                                    this.resolveName(name)
                                ];
                            case 4:
                                addr = _state.sent();
                                if (addr != address) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    name
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getAvatar",
            value: function getAvatar(nameOrAddress) {
                return $526e8ebee4b63c77$var$__awaiter(this, void 0, void 0, function() {
                    var resolver, address, node, resolverAddress, avatar, error, name, error1, avatar1;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                resolver = null;
                                if (!(0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(nameOrAddress)) return [
                                    3,
                                    10
                                ];
                                // Address; reverse lookup
                                address = this.formatter.address(nameOrAddress);
                                node = address.substring(2).toLowerCase() + ".addr.reverse";
                                return [
                                    4,
                                    this._getResolver(node, "getAvatar")
                                ];
                            case 1:
                                resolverAddress = _state.sent();
                                if (!resolverAddress) return [
                                    2,
                                    null
                                ];
                                // Try resolving the avatar against the addr.reverse resolver
                                resolver = new $526e8ebee4b63c77$export$8b4c839865b08288(this, resolverAddress, node);
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    resolver.getAvatar()
                                ];
                            case 3:
                                avatar = _state.sent();
                                if (avatar) return [
                                    2,
                                    avatar.url
                                ];
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code !== (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                _state.trys.push([
                                    5,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.call({
                                        to: resolverAddress,
                                        data: "0x691f3431" + (0, $502d474d526285f9$export$91d651ee363e1209)(node).substring(2)
                                    })
                                ];
                            case 6:
                                name = $526e8ebee4b63c77$var$_parseString.apply(void 0, [
                                    _state.sent(),
                                    0
                                ]);
                                return [
                                    4,
                                    this.getResolver(name)
                                ];
                            case 7:
                                resolver = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error1 = _state.sent();
                                if (error1.code !== (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error1;
                                return [
                                    2,
                                    null
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                return [
                                    4,
                                    this.getResolver(nameOrAddress)
                                ];
                            case 11:
                                // ENS name; forward lookup with wildcard
                                resolver = _state.sent();
                                if (!resolver) return [
                                    2,
                                    null
                                ];
                                _state.label = 12;
                            case 12:
                                return [
                                    4,
                                    resolver.getAvatar()
                                ];
                            case 13:
                                avatar1 = _state.sent();
                                if (avatar1 == null) return [
                                    2,
                                    null
                                ];
                                return [
                                    2,
                                    avatar1.url
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $526e8ebee4b63c77$var$logger.throwError(method + " not implemented", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                    operation: method
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                this.polling = this._events.filter(function(e) {
                    return e.pollable();
                }).length > 0;
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                this.polling = this._events.filter(function(e) {
                    return e.pollable();
                }).length > 0;
            }
        },
        {
            key: "_addEventListener",
            value: function _addEventListener(eventName, listener, once) {
                var event = new $526e8ebee4b63c77$export$d61e24a684f9e51($526e8ebee4b63c77$var$getEventTag(eventName), listener, once);
                this._events.push(event);
                this._startEvent(event);
                return this;
            }
        },
        {
            key: "on",
            value: function on(eventName, listener) {
                return this._addEventListener(eventName, listener, false);
            }
        },
        {
            key: "once",
            value: function once(eventName, listener) {
                return this._addEventListener(eventName, listener, true);
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this = this;
                var result = false;
                var stopped = [];
                var eventTag = $526e8ebee4b63c77$var$getEventTag(eventName);
                this._events = this._events.filter(function(event) {
                    if (event.tag !== eventTag) return true;
                    setTimeout(function() {
                        event.listener.apply(_this, args);
                    }, 0);
                    result = true;
                    if (event.once) {
                        stopped.push(event);
                        return false;
                    }
                    return true;
                });
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return result;
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                if (!eventName) return this._events.length;
                var eventTag = $526e8ebee4b63c77$var$getEventTag(eventName);
                return this._events.filter(function(event) {
                    return event.tag === eventTag;
                }).length;
            }
        },
        {
            key: "listeners",
            value: function listeners(eventName) {
                if (eventName == null) return this._events.map(function(event) {
                    return event.listener;
                });
                var eventTag = $526e8ebee4b63c77$var$getEventTag(eventName);
                return this._events.filter(function(event) {
                    return event.tag === eventTag;
                }).map(function(event) {
                    return event.listener;
                });
            }
        },
        {
            key: "off",
            value: function off(eventName, listener) {
                var _this = this;
                if (listener == null) return this.removeAllListeners(eventName);
                var stopped = [];
                var found = false;
                var eventTag = $526e8ebee4b63c77$var$getEventTag(eventName);
                this._events = this._events.filter(function(event) {
                    if (event.tag !== eventTag || event.listener != listener) return true;
                    if (found) return true;
                    found = true;
                    stopped.push(event);
                    return false;
                });
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return this;
            }
        },
        {
            key: "removeAllListeners",
            value: function removeAllListeners(eventName) {
                var _this = this;
                var stopped = [];
                if (eventName == null) {
                    stopped = this._events;
                    this._events = [];
                } else {
                    var eventTag = $526e8ebee4b63c77$var$getEventTag(eventName);
                    this._events = this._events.filter(function(event) {
                        if (event.tag !== eventTag) return true;
                        stopped.push(event);
                        return false;
                    });
                }
                stopped.forEach(function(event) {
                    _this._stopEvent(event);
                });
                return this;
            }
        }
    ], [
        {
            key: "getFormatter",
            value: // @TODO: Remove this and just create a singleton formatter
            function getFormatter() {
                if ($526e8ebee4b63c77$var$defaultFormatter == null) $526e8ebee4b63c77$var$defaultFormatter = new (0, $2fc925c8cd1d3841$export$a06636add2a09fd8)();
                return $526e8ebee4b63c77$var$defaultFormatter;
            }
        },
        {
            key: "getNetwork",
            value: // @TODO: Remove this and just use getNetwork
            function getNetwork1(network) {
                return (0, $83843fdbb5c0c0a1$export$7de4970ebfd8206d)(network == null ? "homestead" : network);
            }
        }
    ]);
    return BaseProvider;
}((0, $fc170b81a17b0865$export$2881499e37b75b9a));



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $7ZqEM = parcelRequire("7ZqEM");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");











"use strict";
var $12c7496014ff7c2a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $12c7496014ff7c2a$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $12c7496014ff7c2a$var$errorGas = [
    "call",
    "estimateGas"
];
function $12c7496014ff7c2a$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        var data = (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(var key in value){
            var result = $12c7496014ff7c2a$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $12c7496014ff7c2a$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $12c7496014ff7c2a$var$checkError(method, error, params) {
    var transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        var result = $12c7496014ff7c2a$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $12c7496014ff7c2a$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        var result1 = $12c7496014ff7c2a$var$spelunk(error.body, false);
        if (result1 == null) result1 = $12c7496014ff7c2a$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result1) $12c7496014ff7c2a$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result1.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    var message = error.message;
    if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $12c7496014ff7c2a$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $12c7496014ff7c2a$var$logger.throwError("nonce has already been used", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $12c7496014ff7c2a$var$logger.throwError("replacement fee too low", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $12c7496014ff7c2a$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($12c7496014ff7c2a$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $12c7496014ff7c2a$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $12c7496014ff7c2a$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $12c7496014ff7c2a$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        var error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $12c7496014ff7c2a$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
var $12c7496014ff7c2a$var$_constructorGuard = {};
var $12c7496014ff7c2a$export$5f7b5fca3508545a = /*#__PURE__*/ function(Signer) {
    (0, $cgJ2Y._)(JsonRpcSigner, Signer);
    var _super = (0, $hKD8n._)(JsonRpcSigner);
    function JsonRpcSigner(constructorGuard, provider, addressOrIndex) {
        (0, $7dKN1._)(this, JsonRpcSigner);
        var _this;
        _this = _super.call(this);
        if (constructorGuard !== $12c7496014ff7c2a$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_address", _this.provider.formatter.address(addressOrIndex));
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_index", addressOrIndex);
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_address", null);
        } else $12c7496014ff7c2a$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
        return _this;
    }
    (0, $eW5pA._)(JsonRpcSigner, [
        {
            key: "connect",
            value: function connect(provider) {
                return $12c7496014ff7c2a$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "connect"
                });
            }
        },
        {
            key: "connectUnchecked",
            value: function connectUnchecked() {
                return new $12c7496014ff7c2a$var$UncheckedJsonRpcSigner($12c7496014ff7c2a$var$_constructorGuard, this.provider, this._address || this._index);
            }
        },
        {
            key: "getAddress",
            value: function getAddress() {
                var _this = this;
                if (this._address) return Promise.resolve(this._address);
                return this.provider.send("eth_accounts", []).then(function(accounts) {
                    if (accounts.length <= _this._index) $12c7496014ff7c2a$var$logger.throwError("unknown account #" + _this._index, (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "getAddress"
                    });
                    return _this.provider.formatter.address(accounts[_this._index]);
                });
            }
        },
        {
            key: "sendUncheckedTransaction",
            value: function sendUncheckedTransaction(transaction) {
                var _this = this;
                transaction = (0, $8832fb576a60463b$export$9c13236873b118a5)(transaction);
                var fromAddress = this.getAddress().then(function(address) {
                    if (address) address = address.toLowerCase();
                    return address;
                });
                // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
                // wishes to use this, it is easy to specify explicitly, otherwise
                // we look it up for them.
                if (transaction.gasLimit == null) {
                    var estimate = (0, $8832fb576a60463b$export$9c13236873b118a5)(transaction);
                    estimate.from = fromAddress;
                    transaction.gasLimit = this.provider.estimateGas(estimate);
                }
                if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then(function(to) {
                    return $12c7496014ff7c2a$var$__awaiter(_this, void 0, void 0, function() {
                        var address;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (to == null) return [
                                        2,
                                        null
                                    ];
                                    return [
                                        4,
                                        this.provider.resolveName(to)
                                    ];
                                case 1:
                                    address = _state.sent();
                                    if (address == null) $12c7496014ff7c2a$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                                    return [
                                        2,
                                        address
                                    ];
                            }
                        });
                    });
                });
                return (0, $8832fb576a60463b$export$d503dd157d963b60)({
                    tx: (0, $8832fb576a60463b$export$d503dd157d963b60)(transaction),
                    sender: fromAddress
                }).then(function(param) {
                    var tx = param.tx, sender = param.sender;
                    if (tx.from != null) {
                        if (tx.from.toLowerCase() !== sender) $12c7496014ff7c2a$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
                    } else tx.from = sender;
                    var hexTx = _this.provider.constructor.hexlifyTransaction(tx, {
                        from: true
                    });
                    return _this.provider.send("eth_sendTransaction", [
                        hexTx
                    ]).then(function(hash) {
                        return hash;
                    }, function(error) {
                        if (typeof error.message === "string" && error.message.match(/user denied/i)) $12c7496014ff7c2a$var$logger.throwError("user rejected transaction", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                            action: "sendTransaction",
                            transaction: tx
                        });
                        return $12c7496014ff7c2a$var$checkError("sendTransaction", error, hexTx);
                    });
                });
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return $12c7496014ff7c2a$var$logger.throwError("signing transactions is unsupported", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "signTransaction"
                });
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var _this, blockNumber, hash, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval)
                                ];
                            case 1:
                                blockNumber = _state.sent();
                                return [
                                    4,
                                    this.sendUncheckedTransaction(transaction)
                                ];
                            case 2:
                                hash = _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $43ca5dbe92db6f17$export$e0c10349b2c5e1d4)(function() {
                                        return $12c7496014ff7c2a$var$__awaiter(_this, void 0, void 0, function() {
                                            var tx;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.provider.getTransaction(hash)
                                                        ];
                                                    case 1:
                                                        tx = _state.sent();
                                                        if (tx === null) return [
                                                            2,
                                                            undefined
                                                        ];
                                                        return [
                                                            2,
                                                            this.provider._wrapTransaction(tx, hash, blockNumber)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        oncePoll: this.provider
                                    })
                                ];
                            case 4:
                                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                                // for a response, and we need the actual transaction, so we poll
                                // for it; it should show up very quickly
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                error.transactionHash = hash;
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var data, address, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = typeof message === "string" ? (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(message) : message;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.provider.send("personal_sign", [
                                        (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data),
                                        address.toLowerCase()
                                    ])
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if (typeof error.message === "string" && error.message.match(/user denied/i)) $12c7496014ff7c2a$var$logger.throwError("user rejected signing", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                                    action: "signMessage",
                                    from: address,
                                    messageData: message
                                });
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_legacySignMessage",
            value: function _legacySignMessage(message) {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var data, address, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = typeof message === "string" ? (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(message) : message;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this.provider.send("eth_sign", [
                                        address.toLowerCase(),
                                        (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(data)
                                    ])
                                ];
                            case 3:
                                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if (typeof error.message === "string" && error.message.match(/user denied/i)) $12c7496014ff7c2a$var$logger.throwError("user rejected signing", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                                    action: "_legacySignMessage",
                                    from: address,
                                    messageData: message
                                });
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_signTypedData",
            value: function _signTypedData(domain, types, value) {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var _this, populated, address, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    (0, $48669d0386352f19$export$458ab927ae635c3).resolveNames(domain, types, value, function(name) {
                                        return _this.provider.resolveName(name);
                                    })
                                ];
                            case 1:
                                populated = _state.sent();
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 2:
                                address = _state.sent();
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this.provider.send("eth_signTypedData_v4", [
                                        address.toLowerCase(),
                                        JSON.stringify((0, $48669d0386352f19$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
                                    ])
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                if (typeof error.message === "string" && error.message.match(/user denied/i)) $12c7496014ff7c2a$var$logger.throwError("user rejected signing", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                                    action: "_signTypedData",
                                    from: address,
                                    messageData: {
                                        domain: populated.domain,
                                        types: types,
                                        value: populated.value
                                    }
                                });
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "unlock",
            value: function unlock(password) {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var provider, address;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                provider = this.provider;
                                return [
                                    4,
                                    this.getAddress()
                                ];
                            case 1:
                                address = _state.sent();
                                return [
                                    2,
                                    provider.send("personal_unlockAccount", [
                                        address.toLowerCase(),
                                        password,
                                        null
                                    ])
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return JsonRpcSigner;
}((0, $3e3669d74ee1fde3$export$fdf54fdde81cc9f0));
var $12c7496014ff7c2a$var$UncheckedJsonRpcSigner = /*#__PURE__*/ function(JsonRpcSigner) {
    (0, $cgJ2Y._)(UncheckedJsonRpcSigner, JsonRpcSigner);
    var _super = (0, $hKD8n._)(UncheckedJsonRpcSigner);
    function UncheckedJsonRpcSigner() {
        (0, $7dKN1._)(this, UncheckedJsonRpcSigner);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(UncheckedJsonRpcSigner, [
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction) {
                var _this = this;
                return this.sendUncheckedTransaction(transaction).then(function(hash) {
                    return {
                        hash: hash,
                        nonce: null,
                        gasLimit: null,
                        gasPrice: null,
                        data: null,
                        value: null,
                        chainId: null,
                        confirmations: 0,
                        from: null,
                        wait: function(confirmations) {
                            return _this.provider.waitForTransaction(hash, confirmations);
                        }
                    };
                });
            }
        }
    ]);
    return UncheckedJsonRpcSigner;
}($12c7496014ff7c2a$export$5f7b5fca3508545a);
var $12c7496014ff7c2a$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
var $12c7496014ff7c2a$export$da28308012bf6748 = /*#__PURE__*/ function(BaseProvider) {
    (0, $cgJ2Y._)(JsonRpcProvider, BaseProvider);
    var _super = (0, $hKD8n._)(JsonRpcProvider);
    function JsonRpcProvider(url, network) {
        (0, $7dKN1._)(this, JsonRpcProvider);
        var _this;
        var networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this.detectNetwork().then(function(network) {
                    resolve(network);
                }, function(error) {
                    reject(error);
                });
            }, 0);
        });
        _this = _super.call(this, networkOrReady);
        // Default URL
        if (!url) url = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(_this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "connection", Object.freeze({
            url: url
        }));
        else (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "connection", Object.freeze((0, $8832fb576a60463b$export$9c13236873b118a5)(url)));
        _this._nextId = 42;
        return _this;
    }
    (0, $eW5pA._)(JsonRpcProvider, [
        {
            key: "_cache",
            get: function get() {
                if (this._eventLoopCache == null) this._eventLoopCache = {};
                return this._eventLoopCache;
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                var _this = this;
                if (!this._cache["detectNetwork"]) {
                    this._cache["detectNetwork"] = this._uncachedDetectNetwork();
                    // Clear this cache at the beginning of the next event loop
                    setTimeout(function() {
                        _this._cache["detectNetwork"] = null;
                    }, 0);
                }
                return this._cache["detectNetwork"];
            }
        },
        {
            key: "_uncachedDetectNetwork",
            value: function _uncachedDetectNetwork() {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var chainId, error, error1, getNetwork;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $12c7496014ff7c2a$var$timer(0)
                                ];
                            case 1:
                                _state.sent();
                                chainId = null;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.send("eth_chainId", [])
                                ];
                            case 3:
                                chainId = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 4:
                                error = _state.sent();
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    this.send("net_version", [])
                                ];
                            case 6:
                                chainId = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                if (chainId != null) {
                                    getNetwork = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "getNetwork");
                                    try {
                                        return [
                                            2,
                                            getNetwork((0, $3b33bab384c8baec$export$d97aa349ed20696).from(chainId).toNumber())
                                        ];
                                    } catch (error) {
                                        return [
                                            2,
                                            $12c7496014ff7c2a$var$logger.throwError("could not detect network", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                                                chainId: chainId,
                                                event: "invalidNetwork",
                                                serverError: error
                                            })
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    $12c7496014ff7c2a$var$logger.throwError("could not detect network", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                                        event: "noNetwork"
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "getSigner",
            value: function getSigner(addressOrIndex) {
                return new $12c7496014ff7c2a$export$5f7b5fca3508545a($12c7496014ff7c2a$var$_constructorGuard, this, addressOrIndex);
            }
        },
        {
            key: "getUncheckedSigner",
            value: function getUncheckedSigner(addressOrIndex) {
                return this.getSigner(addressOrIndex).connectUnchecked();
            }
        },
        {
            key: "listAccounts",
            value: function listAccounts() {
                var _this = this;
                return this.send("eth_accounts", []).then(function(accounts) {
                    return accounts.map(function(a) {
                        return _this.formatter.address(a);
                    });
                });
            }
        },
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var request = {
                    method: method,
                    params: params,
                    id: this._nextId++,
                    jsonrpc: "2.0"
                };
                this.emit("debug", {
                    action: "request",
                    request: (0, $8832fb576a60463b$export$6c40052bed430212)(request),
                    provider: this
                });
                // We can expand this in the future to any call, but for now these
                // are the biggest wins and do not require any serializing parameters.
                var cache = [
                    "eth_chainId",
                    "eth_blockNumber"
                ].indexOf(method) >= 0;
                if (cache && this._cache[method]) return this._cache[method];
                var result = (0, $43ca5dbe92db6f17$export$6d71b655afe1638d)(this.connection, JSON.stringify(request), $12c7496014ff7c2a$var$getResult).then(function(result) {
                    _this.emit("debug", {
                        action: "response",
                        request: request,
                        response: result,
                        provider: _this
                    });
                    return result;
                }, function(error) {
                    _this.emit("debug", {
                        action: "response",
                        error: error,
                        request: request,
                        provider: _this
                    });
                    throw error;
                });
                // Cache the fetch, but clear it on the next event loop
                if (cache) {
                    this._cache[method] = result;
                    setTimeout(function() {
                        _this._cache[method] = null;
                    }, 0);
                }
                return result;
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(method, params) {
                switch(method){
                    case "getBlockNumber":
                        return [
                            "eth_blockNumber",
                            []
                        ];
                    case "getGasPrice":
                        return [
                            "eth_gasPrice",
                            []
                        ];
                    case "getBalance":
                        return [
                            "eth_getBalance",
                            [
                                $12c7496014ff7c2a$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getTransactionCount":
                        return [
                            "eth_getTransactionCount",
                            [
                                $12c7496014ff7c2a$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getCode":
                        return [
                            "eth_getCode",
                            [
                                $12c7496014ff7c2a$var$getLowerCase(params.address),
                                params.blockTag
                            ]
                        ];
                    case "getStorageAt":
                        return [
                            "eth_getStorageAt",
                            [
                                $12c7496014ff7c2a$var$getLowerCase(params.address),
                                (0, $b8b53b1cc922c9da$export$e9c46a54370b47e8)(params.position, 32),
                                params.blockTag
                            ]
                        ];
                    case "sendTransaction":
                        return [
                            "eth_sendRawTransaction",
                            [
                                params.signedTransaction
                            ]
                        ];
                    case "getBlock":
                        if (params.blockTag) return [
                            "eth_getBlockByNumber",
                            [
                                params.blockTag,
                                !!params.includeTransactions
                            ]
                        ];
                        else if (params.blockHash) return [
                            "eth_getBlockByHash",
                            [
                                params.blockHash,
                                !!params.includeTransactions
                            ]
                        ];
                        return null;
                    case "getTransaction":
                        return [
                            "eth_getTransactionByHash",
                            [
                                params.transactionHash
                            ]
                        ];
                    case "getTransactionReceipt":
                        return [
                            "eth_getTransactionReceipt",
                            [
                                params.transactionHash
                            ]
                        ];
                    case "call":
                        {
                            var hexlifyTransaction = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "hexlifyTransaction");
                            return [
                                "eth_call",
                                [
                                    hexlifyTransaction(params.transaction, {
                                        from: true
                                    }),
                                    params.blockTag
                                ]
                            ];
                        }
                    case "estimateGas":
                        {
                            var hexlifyTransaction1 = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this.constructor, "hexlifyTransaction");
                            return [
                                "eth_estimateGas",
                                [
                                    hexlifyTransaction1(params.transaction, {
                                        from: true
                                    })
                                ]
                            ];
                        }
                    case "getLogs":
                        if (params.filter && params.filter.address != null) params.filter.address = $12c7496014ff7c2a$var$getLowerCase(params.filter.address);
                        return [
                            "eth_getLogs",
                            [
                                params.filter
                            ]
                        ];
                    default:
                        break;
                }
                return null;
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $12c7496014ff7c2a$var$__awaiter(this, void 0, void 0, function() {
                    var tx, feeData, args, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(method === "call" || method === "estimateGas")) return [
                                    3,
                                    2
                                ];
                                tx = params.transaction;
                                if (!(tx && tx.type != null && (0, $3b33bab384c8baec$export$d97aa349ed20696).from(tx.type).isZero())) return [
                                    3,
                                    2
                                ];
                                if (!(tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.getFeeData()
                                ];
                            case 1:
                                feeData = _state.sent();
                                if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                                    // Network doesn't know about EIP-1559 (and hence type)
                                    params = (0, $8832fb576a60463b$export$9c13236873b118a5)(params);
                                    params.transaction = (0, $8832fb576a60463b$export$9c13236873b118a5)(tx);
                                    delete params.transaction.type;
                                }
                                _state.label = 2;
                            case 2:
                                args = this.prepareRequest(method, params);
                                if (args == null) $12c7496014ff7c2a$var$logger.throwError(method + " not implemented", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                                    operation: method
                                });
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    this.send(args[0], args[1])
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                return [
                                    2,
                                    $12c7496014ff7c2a$var$checkError(method, error, params)
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                if (event.tag === "pending") this._startPending();
                (0, $2Nfql._)((0, $fG73q._)(JsonRpcProvider.prototype), "_startEvent", this).call(this, event);
            }
        },
        {
            key: "_startPending",
            value: function _startPending() {
                if (this._pendingFilter != null) return;
                var self = this;
                var pendingFilter = this.send("eth_newPendingTransactionFilter", []);
                this._pendingFilter = pendingFilter;
                pendingFilter.then(function(filterId) {
                    function poll() {
                        self.send("eth_getFilterChanges", [
                            filterId
                        ]).then(function(hashes) {
                            if (self._pendingFilter != pendingFilter) return null;
                            var seq = Promise.resolve();
                            hashes.forEach(function(hash) {
                                // @TODO: This should be garbage collected at some point... How? When?
                                self._emitted["t:" + hash.toLowerCase()] = "pending";
                                seq = seq.then(function() {
                                    return self.getTransaction(hash).then(function(tx) {
                                        self.emit("pending", tx);
                                        return null;
                                    });
                                });
                            });
                            return seq.then(function() {
                                return $12c7496014ff7c2a$var$timer(1000);
                            });
                        }).then(function() {
                            if (self._pendingFilter != pendingFilter) {
                                self.send("eth_uninstallFilter", [
                                    filterId
                                ]);
                                return;
                            }
                            setTimeout(function() {
                                poll();
                            }, 0);
                            return null;
                        }).catch(function(error) {});
                    }
                    poll();
                    return filterId;
                }).catch(function(error) {});
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
                (0, $2Nfql._)((0, $fG73q._)(JsonRpcProvider.prototype), "_stopEvent", this).call(this, event);
            }
        }
    ], [
        {
            key: "defaultUrl",
            value: function defaultUrl() {
                return "http://localhost:8545";
            }
        },
        {
            key: "hexlifyTransaction",
            value: // Convert an ethers.js transaction into a JSON-RPC transaction
            //  - gasLimit => gas
            //  - All values hexlified
            //  - All numeric values zero-striped
            //  - All addresses are lowercased
            // NOTE: This allows a TransactionRequest, but all values should be resolved
            //       before this is called
            // @TODO: This will likely be removed in future versions and prepareRequest
            //        will be the preferred method for this.
            function hexlifyTransaction(transaction, allowExtra) {
                // Check only allowed properties are given
                var allowed = (0, $8832fb576a60463b$export$9c13236873b118a5)($12c7496014ff7c2a$var$allowedTransactionKeys);
                if (allowExtra) {
                    for(var key in allowExtra)if (allowExtra[key]) allowed[key] = true;
                }
                (0, $8832fb576a60463b$export$ae5a316ba623b73a)(transaction, allowed);
                var result = {};
                // JSON-RPC now requires numeric values to be "quantity" values
                [
                    "chainId",
                    "gasLimit",
                    "gasPrice",
                    "type",
                    "maxFeePerGas",
                    "maxPriorityFeePerGas",
                    "nonce",
                    "value"
                ].forEach(function(key) {
                    if (transaction[key] == null) return;
                    var value = (0, $b8b53b1cc922c9da$export$6916af760a341dd3)((0, $3b33bab384c8baec$export$d97aa349ed20696).from(transaction[key]));
                    if (key === "gasLimit") key = "gas";
                    result[key] = value;
                });
                [
                    "from",
                    "to",
                    "data"
                ].forEach(function(key) {
                    if (transaction[key] == null) return;
                    result[key] = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(transaction[key]);
                });
                if (transaction.accessList) result["accessList"] = (0, $fd7cc3a32c93c53c$export$6c8662b1600dce2)(transaction.accessList);
                return result;
            }
        }
    ]);
    return JsonRpcProvider;
}((0, $526e8ebee4b63c77$export$ff3f6dd83125ac45));




"use strict";
var $6be5bc8e06a9a0ba$export$3909fb301d3dc8c9 = null;
try {
    $6be5bc8e06a9a0ba$export$3909fb301d3dc8c9 = WebSocket;
    if ($6be5bc8e06a9a0ba$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    var $6be5bc8e06a9a0ba$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
    $6be5bc8e06a9a0ba$export$3909fb301d3dc8c9 = function WS() {
        $6be5bc8e06a9a0ba$var$logger.throwError("WebSockets not supported in this environment", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}




"use strict";
var $f2e2193043971f40$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f2e2193043971f40$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ var $f2e2193043971f40$var$NextId = 1;
var $f2e2193043971f40$export$bfafe629242f30bd = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $cgJ2Y._)(WebSocketProvider, JsonRpcProvider);
    var _super = (0, $hKD8n._)(WebSocketProvider);
    function WebSocketProvider(url, network) {
        (0, $7dKN1._)(this, WebSocketProvider);
        var _this;
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $f2e2193043971f40$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") _this = _super.call(this, url, network);
        else _this = _super.call(this, "_websocket", network);
        _this._pollingInterval = -1;
        _this._wsReady = false;
        if (typeof url === "string") (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_websocket", new (0, $6be5bc8e06a9a0ba$export$3909fb301d3dc8c9)(_this.connection.url));
        else (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_websocket", url);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_requests", {});
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_subs", {});
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_subIds", {});
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "_detectNetwork", (0, $2Nfql._)(((0, $b9zO9._)(_this), (0, $fG73q._)(WebSocketProvider.prototype)), "detectNetwork", _this).call(_this));
        // Stall sending requests until the socket is open...
        _this.websocket.onopen = function() {
            _this._wsReady = true;
            Object.keys(_this._requests).forEach(function(id) {
                _this.websocket.send(_this._requests[id].payload);
            });
        };
        _this.websocket.onmessage = function(messageEvent) {
            var data = messageEvent.data;
            var result = JSON.parse(data);
            if (result.id != null) {
                var id = String(result.id);
                var request = _this._requests[id];
                delete _this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    _this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: (0, $b9zO9._)(_this)
                    });
                } else {
                    var error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $8832fb576a60463b$export$104236534534f9be)(error, "code", result.error.code || null);
                        (0, $8832fb576a60463b$export$104236534534f9be)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    _this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: (0, $b9zO9._)(_this)
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                var sub = _this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        var fauxPoll = setInterval(function() {
            _this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
        return (0, $7ZqEM._)(_this);
    }
    (0, $eW5pA._)(WebSocketProvider, [
        {
            key: "websocket",
            get: // Cannot narrow the type of _websocket, as that is not backwards compatible
            // so we add a getter and let the WebSocket be a public API.
            function get() {
                return this._websocket;
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return this._detectNetwork;
            }
        },
        {
            key: "pollingInterval",
            get: function get() {
                return 0;
            },
            set: function set(value) {
                $f2e2193043971f40$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "setPollingInterval"
                });
            }
        },
        {
            key: "resetEventsBlock",
            value: function resetEventsBlock(blockNumber) {
                $f2e2193043971f40$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "resetEventBlock"
                });
            }
        },
        {
            key: "poll",
            value: function poll() {
                return $f2e2193043971f40$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            null
                        ];
                    });
                });
            }
        },
        {
            key: "polling",
            set: function set(value) {
                if (!value) return;
                $f2e2193043971f40$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "setPolling"
                });
            }
        },
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var rid = $f2e2193043971f40$var$NextId++;
                return new Promise(function(resolve, reject) {
                    function callback(error, result) {
                        if (error) return reject(error);
                        return resolve(result);
                    }
                    var payload = JSON.stringify({
                        method: method,
                        params: params,
                        id: rid,
                        jsonrpc: "2.0"
                    });
                    _this.emit("debug", {
                        action: "request",
                        request: JSON.parse(payload),
                        provider: _this
                    });
                    _this._requests[String(rid)] = {
                        callback: callback,
                        payload: payload
                    };
                    if (_this._wsReady) _this.websocket.send(payload);
                });
            }
        },
        {
            key: "_subscribe",
            value: function _subscribe(tag, param, processFunc) {
                return $f2e2193043971f40$var$__awaiter(this, void 0, void 0, function() {
                    var _this, subIdPromise, subId;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                subIdPromise = this._subIds[tag];
                                if (subIdPromise == null) {
                                    subIdPromise = Promise.all(param).then(function(param) {
                                        return _this.send("eth_subscribe", param);
                                    });
                                    this._subIds[tag] = subIdPromise;
                                }
                                return [
                                    4,
                                    subIdPromise
                                ];
                            case 1:
                                subId = _state.sent();
                                this._subs[subId] = {
                                    tag: tag,
                                    processFunc: processFunc
                                };
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_startEvent",
            value: function _startEvent(event) {
                var _this = this;
                switch(event.type){
                    case "block":
                        this._subscribe("block", [
                            "newHeads"
                        ], function(result) {
                            var blockNumber = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(result.number).toNumber();
                            _this._emitted.block = blockNumber;
                            _this.emit("block", blockNumber);
                        });
                        break;
                    case "pending":
                        this._subscribe("pending", [
                            "newPendingTransactions"
                        ], function(result) {
                            _this.emit("pending", result);
                        });
                        break;
                    case "filter":
                        this._subscribe(event.tag, [
                            "logs",
                            this._getFilter(event.filter)
                        ], function(result) {
                            if (result.removed == null) result.removed = false;
                            _this.emit(event.filter, _this.formatter.filterLog(result));
                        });
                        break;
                    case "tx":
                        {
                            var emitReceipt = function(event) {
                                var hash = event.hash;
                                _this.getTransactionReceipt(hash).then(function(receipt) {
                                    if (!receipt) return;
                                    _this.emit(hash, receipt);
                                });
                            };
                            // In case it is already mined
                            emitReceipt(event);
                            // To keep things simple, we start up a single newHeads subscription
                            // to keep an eye out for transactions we are watching for.
                            // Starting a subscription for an event (i.e. "tx") that is already
                            // running is (basically) a nop.
                            this._subscribe("tx", [
                                "newHeads"
                            ], function(result) {
                                _this._events.filter(function(e) {
                                    return e.type === "tx";
                                }).forEach(emitReceipt);
                            });
                            break;
                        }
                    // Nothing is needed
                    case "debug":
                    case "poll":
                    case "willPoll":
                    case "didPoll":
                    case "error":
                        break;
                    default:
                        console.log("unhandled:", event);
                        break;
                }
            }
        },
        {
            key: "_stopEvent",
            value: function _stopEvent(event) {
                var _this = this;
                var tag = event.tag;
                if (event.type === "tx") {
                    // There are remaining transaction event listeners
                    if (this._events.filter(function(e) {
                        return e.type === "tx";
                    }).length) return;
                    tag = "tx";
                } else if (this.listenerCount(event.event)) // There are remaining event listeners
                return;
                var subId = this._subIds[tag];
                if (!subId) return;
                delete this._subIds[tag];
                subId.then(function(subId) {
                    if (!_this._subs[subId]) return;
                    delete _this._subs[subId];
                    _this.send("eth_unsubscribe", [
                        subId
                    ]);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $f2e2193043971f40$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!(this.websocket.readyState === (0, $6be5bc8e06a9a0ba$export$3909fb301d3dc8c9).CONNECTING)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.websocket.onopen = function() {
                                            resolve(true);
                                        };
                                        _this.websocket.onerror = function() {
                                            resolve(false);
                                        };
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // Hangup
                                // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
                                this.websocket.close(1000);
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "defaultUrl",
            value: function defaultUrl() {
                return "ws://localhost:8546";
            }
        }
    ]);
    return WebSocketProvider;
}((0, $12c7496014ff7c2a$export$da28308012bf6748));





var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");




"use strict";
var $1026e27d6463850a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1026e27d6463850a$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $1026e27d6463850a$export$b3d647c1c29df44d = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $cgJ2Y._)(StaticJsonRpcProvider, JsonRpcProvider);
    var _super = (0, $hKD8n._)(StaticJsonRpcProvider);
    function StaticJsonRpcProvider() {
        (0, $7dKN1._)(this, StaticJsonRpcProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(StaticJsonRpcProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                var _this = this;
                var _super = Object.create(null, {
                    detectNetwork: {
                        get: function() {
                            return (0, $2Nfql._)((0, $fG73q._)(StaticJsonRpcProvider.prototype), "detectNetwork", _this);
                        }
                    }
                });
                return $1026e27d6463850a$var$__awaiter(this, void 0, void 0, function() {
                    var network;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                network = this.network;
                                if (!(network == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _super.detectNetwork.call(this)
                                ];
                            case 1:
                                network = _state.sent();
                                if (!network) $1026e27d6463850a$var$logger.throwError("no network detected", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                                // If still not set, set it
                                if (this._network == null) {
                                    // A static network does not support "any"
                                    (0, $8832fb576a60463b$export$104236534534f9be)(this, "_network", network);
                                    this.emit("network", network, null);
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    network
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return StaticJsonRpcProvider;
}((0, $12c7496014ff7c2a$export$da28308012bf6748));
var $1026e27d6463850a$export$664128d6239ccf96 = /*#__PURE__*/ function _target(StaticJsonRpcProvider) {
    (0, $cgJ2Y._)(UrlJsonRpcProvider, StaticJsonRpcProvider);
    var _super = (0, $hKD8n._)(UrlJsonRpcProvider);
    function UrlJsonRpcProvider(network, apiKey) {
        (0, $7dKN1._)(this, UrlJsonRpcProvider);
        var _this;
        $1026e27d6463850a$var$logger.checkAbstract(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, UrlJsonRpcProvider);
        // Normalize the Network and API Key
        network = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getNetwork")(network);
        apiKey = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getApiKey")(apiKey);
        var connection = (0, $8832fb576a60463b$export$f695fbbf3cdaaf47)(this instanceof UrlJsonRpcProvider ? this.constructor : void 0, "getUrl")(network, apiKey);
        _this = _super.call(this, connection, network);
        if (typeof apiKey === "string") (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach(function(key) {
            (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), key, apiKey[key]);
        });
        return _this;
    }
    (0, $eW5pA._)(UrlJsonRpcProvider, [
        {
            key: "_startPending",
            value: function _startPending() {
                $1026e27d6463850a$var$logger.warn("WARNING: API provider does not support pending filters");
            }
        },
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return false;
            }
        },
        {
            key: "getSigner",
            value: function getSigner(address) {
                return $1026e27d6463850a$var$logger.throwError("API provider does not support signing", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "getSigner"
                });
            }
        },
        {
            key: "listAccounts",
            value: function listAccounts() {
                return Promise.resolve([]);
            }
        }
    ], [
        {
            key: "getApiKey",
            value: // Return a defaultApiKey if null, otherwise validate the API key
            function getApiKey(apiKey) {
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: // Returns the url or connection for the given network and API key. The
            // API key will have been sanitized by the getApiKey first, so any validation
            // or transformations can be done there.
            function getUrl(network, apiKey) {
                return $1026e27d6463850a$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                    operation: "getUrl"
                });
            }
        }
    ]);
    return UrlJsonRpcProvider;
}($1026e27d6463850a$export$b3d647c1c29df44d);


"use strict";
var $406085ed0719de30$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
var $406085ed0719de30$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
var $406085ed0719de30$export$f6c13301c7b76371 = /*#__PURE__*/ function(WebSocketProvider) {
    (0, $cgJ2Y._)(AlchemyWebSocketProvider, WebSocketProvider);
    var _super = (0, $hKD8n._)(AlchemyWebSocketProvider);
    function AlchemyWebSocketProvider(network, apiKey) {
        (0, $7dKN1._)(this, AlchemyWebSocketProvider);
        var _this;
        var provider = new $406085ed0719de30$export$999cc40da3fbc6f(network, apiKey);
        var url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        _this = _super.call(this, url, provider.network);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "apiKey", provider.apiKey);
        return _this;
    }
    (0, $eW5pA._)(AlchemyWebSocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $406085ed0719de30$var$defaultApiKey;
            }
        }
    ]);
    return AlchemyWebSocketProvider;
}((0, $f2e2193043971f40$export$bfafe629242f30bd));
var $406085ed0719de30$export$999cc40da3fbc6f = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $cgJ2Y._)(AlchemyProvider, UrlJsonRpcProvider);
    var _super = (0, $hKD8n._)(AlchemyProvider);
    function AlchemyProvider() {
        (0, $7dKN1._)(this, AlchemyProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(AlchemyProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $406085ed0719de30$var$defaultApiKey;
            }
        }
    ], [
        {
            key: "getWebSocketProvider",
            value: function getWebSocketProvider(network, apiKey) {
                return new $406085ed0719de30$export$f6c13301c7b76371(network, apiKey);
            }
        },
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey == null) return $406085ed0719de30$var$defaultApiKey;
                if (apiKey && typeof apiKey !== "string") $406085ed0719de30$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "eth-mainnet.alchemyapi.io/v2/";
                        break;
                    case "goerli":
                        host = "eth-goerli.g.alchemy.com/v2/";
                        break;
                    case "matic":
                        host = "polygon-mainnet.g.alchemy.com/v2/";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai.g.alchemy.com/v2/";
                        break;
                    case "arbitrum":
                        host = "arb-mainnet.g.alchemy.com/v2/";
                        break;
                    case "arbitrum-goerli":
                        host = "arb-goerli.g.alchemy.com/v2/";
                        break;
                    case "optimism":
                        host = "opt-mainnet.g.alchemy.com/v2/";
                        break;
                    case "optimism-goerli":
                        host = "opt-goerli.g.alchemy.com/v2/";
                        break;
                    default:
                        $406085ed0719de30$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return {
                    allowGzip: true,
                    url: "https://" + host + apiKey,
                    throttleCallback: function(attempt, url) {
                        if (apiKey === $406085ed0719de30$var$defaultApiKey) (0, $2fc925c8cd1d3841$export$4c41bd49e82e82ab)();
                        return Promise.resolve(true);
                    }
                };
            }
        }
    ]);
    return AlchemyProvider;
}((0, $1026e27d6463850a$export$664128d6239ccf96));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




var $5d99454c30f7154e$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $5d99454c30f7154e$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $5d99454c30f7154e$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $5d99454c30f7154e$var$logger.throwArgumentError("unsupported network", "name", name);
}
var $5d99454c30f7154e$export$72783b2aefa72a45 = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    "use strict";
    (0, $cgJ2Y._)(AnkrProvider, UrlJsonRpcProvider);
    var _super = (0, $hKD8n._)(AnkrProvider);
    function AnkrProvider() {
        (0, $7dKN1._)(this, AnkrProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(AnkrProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey === $5d99454c30f7154e$var$defaultApiKey;
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey == null) return $5d99454c30f7154e$var$defaultApiKey;
                return apiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                if (apiKey == null) apiKey = $5d99454c30f7154e$var$defaultApiKey;
                var connection = {
                    allowGzip: true,
                    url: "https://" + $5d99454c30f7154e$var$getHost(network.name) + apiKey,
                    throttleCallback: function(attempt, url) {
                        if (apiKey.apiKey === $5d99454c30f7154e$var$defaultApiKey) (0, $2fc925c8cd1d3841$export$4c41bd49e82e82ab)();
                        return Promise.resolve(true);
                    }
                };
                if (apiKey.projectSecret != null) {
                    connection.user = "";
                    connection.password = apiKey.projectSecret;
                }
                return connection;
            }
        }
    ]);
    return AnkrProvider;
}((0, $1026e27d6463850a$export$664128d6239ccf96));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");



"use strict";
var $e53beb044b99e708$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e53beb044b99e708$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $e53beb044b99e708$export$7113381f8f264fc0 = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $cgJ2Y._)(CloudflareProvider, UrlJsonRpcProvider);
    var _super = (0, $hKD8n._)(CloudflareProvider);
    function CloudflareProvider() {
        (0, $7dKN1._)(this, CloudflareProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(CloudflareProvider, [
        {
            key: "perform",
            value: function perform(method, params) {
                var _this = this;
                var _super = Object.create(null, {
                    perform: {
                        get: function() {
                            return (0, $2Nfql._)((0, $fG73q._)(CloudflareProvider.prototype), "perform", _this);
                        }
                    }
                });
                return $e53beb044b99e708$var$__awaiter(this, void 0, void 0, function() {
                    var block;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(method === "getBlockNumber")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _super.perform.call(this, "getBlock", {
                                        blockTag: "latest"
                                    })
                                ];
                            case 1:
                                block = _state.sent();
                                return [
                                    2,
                                    block.number
                                ];
                            case 2:
                                return [
                                    2,
                                    _super.perform.call(this, method, params)
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey != null) $e53beb044b99e708$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
                return null;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "https://cloudflare-eth.com/";
                        break;
                    default:
                        $e53beb044b99e708$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return host;
            }
        }
    ]);
    return CloudflareProvider;
}((0, $1026e27d6463850a$export$664128d6239ccf96));



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");








"use strict";
var $3c0b36f99ba2c448$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3c0b36f99ba2c448$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
// The transaction has already been sanitized by the calls in Provider
function $3c0b36f99ba2c448$var$getTransactionPostData(transaction) {
    var result = {};
    for(var key in transaction){
        if (transaction[key] == null) continue;
        var value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $b8b53b1cc922c9da$export$6916af760a341dd3)((0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value));
        else if (key === "accessList") value = "[" + (0, $fd7cc3a32c93c53c$export$6c8662b1600dce2)(value).map(function(set) {
            return '{address:"'.concat(set.address, '",storageKeys:["').concat(set.storageKeys.join('","'), '"]}');
        }).join(",") + "]";
        else value = (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)(value);
        result[key] = value;
    }
    return result;
}
function $3c0b36f99ba2c448$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        var error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $3c0b36f99ba2c448$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        var error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        var error1 = new Error("invalid response");
        error1.result = JSON.stringify(result);
        throw error1;
    }
    if (result.error) {
        // @TODO: not any
        var error2 = new Error(result.error.message || "unknown error");
        if (result.error.code) error2.code = result.error.code;
        if (result.error.data) error2.data = result.error.data;
        throw error2;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $3c0b36f99ba2c448$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $3c0b36f99ba2c448$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR) {
        var e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            var data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(data)) return data;
            $3c0b36f99ba2c448$var$logger.throwError("missing revert data in call exception", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    var message = error.message;
    if (error.code === (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $3c0b36f99ba2c448$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $3c0b36f99ba2c448$var$logger.throwError("nonce has already been used", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $3c0b36f99ba2c448$var$logger.throwError("replacement fee too low", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $3c0b36f99ba2c448$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
var $3c0b36f99ba2c448$export$dd1d942a536c7912 = /*#__PURE__*/ function(BaseProvider) {
    (0, $cgJ2Y._)(EtherscanProvider, BaseProvider);
    var _super = (0, $hKD8n._)(EtherscanProvider);
    function EtherscanProvider(network, apiKey) {
        (0, $7dKN1._)(this, EtherscanProvider);
        var _this;
        _this = _super.call(this, network);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "baseUrl", _this.getBaseUrl());
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "apiKey", apiKey || null);
        return _this;
    }
    (0, $eW5pA._)(EtherscanProvider, [
        {
            key: "getBaseUrl",
            value: function getBaseUrl() {
                switch(this.network ? this.network.name : "invalid"){
                    case "homestead":
                        return "https://api.etherscan.io";
                    case "goerli":
                        return "https://api-goerli.etherscan.io";
                    case "sepolia":
                        return "https://api-sepolia.etherscan.io";
                    case "matic":
                        return "https://api.polygonscan.com";
                    case "maticmum":
                        return "https://api-testnet.polygonscan.com";
                    case "arbitrum":
                        return "https://api.arbiscan.io";
                    case "arbitrum-goerli":
                        return "https://api-goerli.arbiscan.io";
                    case "optimism":
                        return "https://api-optimistic.etherscan.io";
                    case "optimism-goerli":
                        return "https://api-goerli-optimistic.etherscan.io";
                    default:
                }
                return $3c0b36f99ba2c448$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
            }
        },
        {
            key: "getUrl",
            value: function getUrl(module, params) {
                var query = Object.keys(params).reduce(function(accum, key) {
                    var value = params[key];
                    if (value != null) accum += "&".concat(key, "=").concat(value);
                    return accum;
                }, "");
                var apiKey = this.apiKey ? "&apikey=".concat(this.apiKey) : "";
                return "".concat(this.baseUrl, "/api?module=").concat(module).concat(query).concat(apiKey);
            }
        },
        {
            key: "getPostUrl",
            value: function getPostUrl() {
                return "".concat(this.baseUrl, "/api");
            }
        },
        {
            key: "getPostData",
            value: function getPostData(module, params) {
                params.module = module;
                params.apikey = this.apiKey;
                return params;
            }
        },
        {
            key: "fetch",
            value: function fetch(module, params, post) {
                return $3c0b36f99ba2c448$var$__awaiter(this, void 0, void 0, function() {
                    var _this, url, payload, procFunc, connection, payloadStr, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                url = post ? this.getPostUrl() : this.getUrl(module, params);
                                payload = post ? this.getPostData(module, params) : null;
                                procFunc = module === "proxy" ? $3c0b36f99ba2c448$var$getJsonResult : $3c0b36f99ba2c448$var$getResult;
                                this.emit("debug", {
                                    action: "request",
                                    request: url,
                                    provider: this
                                });
                                connection = {
                                    url: url,
                                    throttleSlotInterval: 1000,
                                    throttleCallback: function(attempt, url) {
                                        if (_this.isCommunityResource()) (0, $2fc925c8cd1d3841$export$4c41bd49e82e82ab)();
                                        return Promise.resolve(true);
                                    }
                                };
                                payloadStr = null;
                                if (payload) {
                                    connection.headers = {
                                        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                                    };
                                    payloadStr = Object.keys(payload).map(function(key) {
                                        return "".concat(key, "=").concat(payload[key]);
                                    }).join("&");
                                }
                                return [
                                    4,
                                    (0, $43ca5dbe92db6f17$export$6d71b655afe1638d)(connection, payloadStr, procFunc || $3c0b36f99ba2c448$var$getJsonResult)
                                ];
                            case 1:
                                result = _state.sent();
                                this.emit("debug", {
                                    action: "response",
                                    request: url,
                                    response: (0, $8832fb576a60463b$export$6c40052bed430212)(result),
                                    provider: this
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return $3c0b36f99ba2c448$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            this.network
                        ];
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                var _this = this;
                var _super = Object.create(null, {
                    perform: {
                        get: function() {
                            return (0, $2Nfql._)((0, $fG73q._)(EtherscanProvider.prototype), "perform", _this);
                        }
                    }
                });
                return $3c0b36f99ba2c448$var$__awaiter(this, void 0, void 0, function() {
                    var postData, error, postData1, error1, args, topic0, logs, blocks, i, log, block;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                switch(method){
                                    case "getBlockNumber":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "getGasPrice":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "getBalance":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "getTransactionCount":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "getCode":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "getStorageAt":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "sendTransaction":
                                        return [
                                            3,
                                            7
                                        ];
                                    case "getBlock":
                                        return [
                                            3,
                                            8
                                        ];
                                    case "getTransaction":
                                        return [
                                            3,
                                            9
                                        ];
                                    case "getTransactionReceipt":
                                        return [
                                            3,
                                            10
                                        ];
                                    case "call":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "estimateGas":
                                        return [
                                            3,
                                            15
                                        ];
                                    case "getLogs":
                                        return [
                                            3,
                                            19
                                        ];
                                    case "getEtherPrice":
                                        return [
                                            3,
                                            26
                                        ];
                                }
                                return [
                                    3,
                                    28
                                ];
                            case 1:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_blockNumber"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_gasPrice"
                                    })
                                ];
                            case 3:
                                // Returns base-10 result
                                return [
                                    2,
                                    this.fetch("account", {
                                        action: "balance",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 4:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionCount",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 5:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getCode",
                                        address: params.address,
                                        tag: params.blockTag
                                    })
                                ];
                            case 6:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getStorageAt",
                                        address: params.address,
                                        position: params.position,
                                        tag: params.blockTag
                                    })
                                ];
                            case 7:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_sendRawTransaction",
                                        hex: params.signedTransaction
                                    }, true).catch(function(error) {
                                        return $3c0b36f99ba2c448$var$checkError("sendTransaction", error, params.signedTransaction);
                                    })
                                ];
                            case 8:
                                if (params.blockTag) return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getBlockByNumber",
                                        tag: params.blockTag,
                                        boolean: params.includeTransactions ? "true" : "false"
                                    })
                                ];
                                throw new Error("getBlock by blockHash not implemented");
                            case 9:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionByHash",
                                        txhash: params.transactionHash
                                    })
                                ];
                            case 10:
                                return [
                                    2,
                                    this.fetch("proxy", {
                                        action: "eth_getTransactionReceipt",
                                        txhash: params.transactionHash
                                    })
                                ];
                            case 11:
                                if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                                postData = $3c0b36f99ba2c448$var$getTransactionPostData(params.transaction);
                                postData.module = "proxy";
                                postData.action = "eth_call";
                                _state.label = 12;
                            case 12:
                                _state.trys.push([
                                    12,
                                    14,
                                    ,
                                    15
                                ]);
                                return [
                                    4,
                                    this.fetch("proxy", postData, true)
                                ];
                            case 13:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 14:
                                error = _state.sent();
                                return [
                                    2,
                                    $3c0b36f99ba2c448$var$checkError("call", error, params.transaction)
                                ];
                            case 15:
                                postData1 = $3c0b36f99ba2c448$var$getTransactionPostData(params.transaction);
                                postData1.module = "proxy";
                                postData1.action = "eth_estimateGas";
                                _state.label = 16;
                            case 16:
                                _state.trys.push([
                                    16,
                                    18,
                                    ,
                                    19
                                ]);
                                return [
                                    4,
                                    this.fetch("proxy", postData1, true)
                                ];
                            case 17:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 18:
                                error1 = _state.sent();
                                return [
                                    2,
                                    $3c0b36f99ba2c448$var$checkError("estimateGas", error1, params.transaction)
                                ];
                            case 19:
                                args = {
                                    action: "getLogs"
                                };
                                if (params.filter.fromBlock) args.fromBlock = $3c0b36f99ba2c448$var$checkLogTag(params.filter.fromBlock);
                                if (params.filter.toBlock) args.toBlock = $3c0b36f99ba2c448$var$checkLogTag(params.filter.toBlock);
                                if (params.filter.address) args.address = params.filter.address;
                                // @TODO: We can handle slightly more complicated logs using the logs API
                                if (params.filter.topics && params.filter.topics.length > 0) {
                                    if (params.filter.topics.length > 1) $3c0b36f99ba2c448$var$logger.throwError("unsupported topic count", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                        topics: params.filter.topics
                                    });
                                    if (params.filter.topics.length === 1) {
                                        topic0 = params.filter.topics[0];
                                        if (typeof topic0 !== "string" || topic0.length !== 66) $3c0b36f99ba2c448$var$logger.throwError("unsupported topic format", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                            topic0: topic0
                                        });
                                        args.topic0 = topic0;
                                    }
                                }
                                return [
                                    4,
                                    this.fetch("logs", args)
                                ];
                            case 20:
                                logs = _state.sent();
                                // Cache txHash => blockHash
                                blocks = {};
                                i = 0;
                                _state.label = 21;
                            case 21:
                                if (!(i < logs.length)) return [
                                    3,
                                    25
                                ];
                                log = logs[i];
                                if (log.blockHash != null) return [
                                    3,
                                    24
                                ];
                                if (!(blocks[log.blockNumber] == null)) return [
                                    3,
                                    23
                                ];
                                return [
                                    4,
                                    this.getBlock(log.blockNumber)
                                ];
                            case 22:
                                block = _state.sent();
                                if (block) blocks[log.blockNumber] = block.hash;
                                _state.label = 23;
                            case 23:
                                log.blockHash = blocks[log.blockNumber];
                                _state.label = 24;
                            case 24:
                                i++;
                                return [
                                    3,
                                    21
                                ];
                            case 25:
                                return [
                                    2,
                                    logs
                                ];
                            case 26:
                                if (this.network.name !== "homestead") return [
                                    2,
                                    0.0
                                ];
                                return [
                                    4,
                                    this.fetch("stats", {
                                        action: "ethprice"
                                    })
                                ];
                            case 27:
                                return [
                                    2,
                                    parseFloat.apply(void 0, [
                                        _state.sent().ethusd
                                    ])
                                ];
                            case 28:
                                return [
                                    3,
                                    29
                                ];
                            case 29:
                                return [
                                    2,
                                    _super.perform.call(this, method, params)
                                ];
                        }
                    });
                });
            }
        },
        {
            // Note: The `page` page parameter only allows pagination within the
            //       10,000 window available without a page and offset parameter
            //       Error: Result window is too large, PageNo x Offset size must
            //              be less than or equal to 10000
            key: "getHistory",
            value: function getHistory(addressOrName, startBlock, endBlock) {
                return $3c0b36f99ba2c448$var$__awaiter(this, void 0, void 0, function() {
                    var _this, params, _tmp, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _tmp = {
                                    action: "txlist"
                                };
                                return [
                                    4,
                                    this.resolveName(addressOrName)
                                ];
                            case 1:
                                params = (_tmp.address = _state.sent(), _tmp.startblock = startBlock == null ? 0 : startBlock, _tmp.endblock = endBlock == null ? 99999999 : endBlock, _tmp.sort = "asc", _tmp);
                                return [
                                    4,
                                    this.fetch("account", params)
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result.map(function(tx) {
                                        [
                                            "contractAddress",
                                            "to"
                                        ].forEach(function(key) {
                                            if (tx[key] == "") delete tx[key];
                                        });
                                        if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                                        var item = _this.formatter.transactionResponse(tx);
                                        if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                                        return item;
                                    })
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.apiKey == null;
            }
        }
    ]);
    return EtherscanProvider;
}((0, $526e8ebee4b63c77$export$ff3f6dd83125ac45));



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $aVMuR = parcelRequire("aVMuR");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");

var $6qu4b = parcelRequire("6qu4b");




"use strict";
function $acdf15154f192af3$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(var i = array.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}







"use strict";
var $3e9d92c6058b8741$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3e9d92c6058b8741$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
function $3e9d92c6058b8741$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $3e9d92c6058b8741$var$checkNetworks(networks) {
    var result = null;
    for(var i = 0; i < networks.length; i++){
        var network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $3e9d92c6058b8741$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $3e9d92c6058b8741$var$median(values, maxDelta) {
    values = values.slice().sort();
    var middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    var a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $3e9d92c6058b8741$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $3b33bab384c8baec$export$d97aa349ed20696).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map(function(i) {
        return $3e9d92c6058b8741$var$serialize(i);
    }));
    else if (typeof value === "object") {
        var keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map(function(key) {
            var v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $3e9d92c6058b8741$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)));
}
// Next request ID to use for emitting debug info
var $3e9d92c6058b8741$var$nextRid = 1;
function $3e9d92c6058b8741$var$stall(duration) {
    var cancel = null;
    var timer = null;
    var promise = new Promise(function(resolve) {
        cancel = function cancel() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    var wait = function(func) {
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
var $3e9d92c6058b8741$var$ForwardErrors = [
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.CALL_EXCEPTION,
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED,
    (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT
];
var $3e9d92c6058b8741$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $3e9d92c6058b8741$var$exposeDebugConfig(config, now) {
    var result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: function() {
            return config.provider;
        }
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $3e9d92c6058b8741$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        var tally = {};
        configs.forEach(function(c) {
            var value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        var keys = Object.keys(tally);
        for(var i = 0; i < keys.length; i++){
            var check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $3e9d92c6058b8741$var$getProcessFunc(provider, method, params) {
    var normalize = $3e9d92c6058b8741$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                var values = configs.map(function(c) {
                    return c.result;
                });
                // Get the median block number
                var blockNumber = $3e9d92c6058b8741$var$median(configs.map(function(c) {
                    return c.result;
                }), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                var values = configs.map(function(c) {
                    return c.result;
                });
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $3e9d92c6058b8741$var$median(configs.map(function(c) {
                    return c.result;
                }));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function normalize(tx) {
                if (tx == null) return null;
                tx = (0, $8832fb576a60463b$export$9c13236873b118a5)(tx);
                tx.confirmations = -1;
                return $3e9d92c6058b8741$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function normalize(block) {
                if (block == null) return null;
                block = (0, $8832fb576a60463b$export$9c13236873b118a5)(block);
                block.transactions = block.transactions.map(function(tx) {
                    tx = (0, $8832fb576a60463b$export$9c13236873b118a5)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $3e9d92c6058b8741$var$serialize(block);
            };
            else normalize = function normalize(block) {
                if (block == null) return null;
                return $3e9d92c6058b8741$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $3e9d92c6058b8741$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $3e9d92c6058b8741$var$waitForSync(config, blockNumber) {
    return $3e9d92c6058b8741$var$__awaiter(this, void 0, void 0, function() {
        var provider;
        return (0, $6qu4b.__generator)(this, function(_state) {
            provider = config.provider;
            if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return [
                2,
                provider
            ];
            return [
                2,
                (0, $43ca5dbe92db6f17$export$e0c10349b2c5e1d4)(function() {
                    return new Promise(function(resolve, reject) {
                        setTimeout(function() {
                            // We are synced
                            if (provider.blockNumber >= blockNumber) return resolve(provider);
                            // We're done; just quit
                            if (config.cancelled) return resolve(null);
                            // Try again, next block
                            return resolve(undefined);
                        }, 0);
                    });
                }, {
                    oncePoll: provider
                })
            ];
        });
    });
}
function $3e9d92c6058b8741$var$getRunner(config, currentBlockNumber, method, params) {
    return $3e9d92c6058b8741$var$__awaiter(this, void 0, void 0, function() {
        var provider, filter;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = config.provider;
                    switch(method){
                        case "getBlockNumber":
                            return [
                                3,
                                1
                            ];
                        case "getGasPrice":
                            return [
                                3,
                                1
                            ];
                        case "getEtherPrice":
                            return [
                                3,
                                2
                            ];
                        case "getBalance":
                            return [
                                3,
                                3
                            ];
                        case "getTransactionCount":
                            return [
                                3,
                                3
                            ];
                        case "getCode":
                            return [
                                3,
                                3
                            ];
                        case "getStorageAt":
                            return [
                                3,
                                6
                            ];
                        case "getBlock":
                            return [
                                3,
                                9
                            ];
                        case "call":
                            return [
                                3,
                                12
                            ];
                        case "estimateGas":
                            return [
                                3,
                                12
                            ];
                        case "getTransaction":
                            return [
                                3,
                                15
                            ];
                        case "getTransactionReceipt":
                            return [
                                3,
                                15
                            ];
                        case "getLogs":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        19
                    ];
                case 1:
                    return [
                        2,
                        provider[method]()
                    ];
                case 2:
                    if (provider.getEtherPrice) return [
                        2,
                        provider.getEtherPrice()
                    ];
                    return [
                        3,
                        19
                    ];
                case 3:
                    if (!(params.blockTag && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(params.blockTag))) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $3e9d92c6058b8741$var$waitForSync(config, currentBlockNumber)
                    ];
                case 4:
                    provider = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        provider[method](params.address, params.blockTag || "latest")
                    ];
                case 6:
                    if (!(params.blockTag && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(params.blockTag))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        $3e9d92c6058b8741$var$waitForSync(config, currentBlockNumber)
                    ];
                case 7:
                    provider = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        provider.getStorageAt(params.address, params.position, params.blockTag || "latest")
                    ];
                case 9:
                    if (!(params.blockTag && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(params.blockTag))) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        $3e9d92c6058b8741$var$waitForSync(config, currentBlockNumber)
                    ];
                case 10:
                    provider = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        2,
                        provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash)
                    ];
                case 12:
                    if (!(params.blockTag && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(params.blockTag))) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        $3e9d92c6058b8741$var$waitForSync(config, currentBlockNumber)
                    ];
                case 13:
                    provider = _state.sent();
                    _state.label = 14;
                case 14:
                    if (method === "call" && params.blockTag) return [
                        2,
                        provider[method](params.transaction, params.blockTag)
                    ];
                    return [
                        2,
                        provider[method](params.transaction)
                    ];
                case 15:
                    return [
                        2,
                        provider[method](params.transactionHash)
                    ];
                case 16:
                    filter = params.filter;
                    if (!(filter.fromBlock && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(filter.fromBlock) || filter.toBlock && (0, $b8b53b1cc922c9da$export$b02a40aff8e4ad18)(filter.toBlock))) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        $3e9d92c6058b8741$var$waitForSync(config, currentBlockNumber)
                    ];
                case 17:
                    provider = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2,
                        provider.getLogs(filter)
                    ];
                case 19:
                    return [
                        2,
                        $3e9d92c6058b8741$var$logger.throwError("unknown method error", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
                            method: method,
                            params: params
                        })
                    ];
            }
        });
    });
}
var $3e9d92c6058b8741$export$cb1d0beacb55feb7 = /*#__PURE__*/ function(BaseProvider) {
    (0, $cgJ2Y._)(FallbackProvider, BaseProvider);
    var _super = (0, $hKD8n._)(FallbackProvider);
    function FallbackProvider(providers, quorum) {
        (0, $7dKN1._)(this, FallbackProvider);
        var _this;
        if (providers.length === 0) $3e9d92c6058b8741$var$logger.throwArgumentError("missing providers", "providers", providers);
        var providerConfigs = providers.map(function(configOrProvider, index) {
            if ((0, $fc170b81a17b0865$export$2881499e37b75b9a).isProvider(configOrProvider)) {
                var stallTimeout = (0, $2fc925c8cd1d3841$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
                var priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            var config = (0, $8832fb576a60463b$export$9c13236873b118a5)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $2fc925c8cd1d3841$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            var weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $3e9d92c6058b8741$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", "providers[".concat(index, "].weight"), weight);
            return Object.freeze(config);
        });
        var total = providerConfigs.reduce(function(accum, c) {
            return accum + c.weight;
        }, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $3e9d92c6058b8741$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        var networkOrReady = $3e9d92c6058b8741$var$checkNetworks(providerConfigs.map(function(c) {
            return c.provider.network;
        }));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        _this = _super.call(this, networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "providerConfigs", Object.freeze(providerConfigs));
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "quorum", quorum);
        _this._highestBlockNumber = -1;
        return _this;
    }
    (0, $eW5pA._)(FallbackProvider, [
        {
            key: "detectNetwork",
            value: function detectNetwork() {
                return $3e9d92c6058b8741$var$__awaiter(this, void 0, void 0, function() {
                    var networks;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(this.providerConfigs.map(function(c) {
                                        return c.provider.getNetwork();
                                    }))
                                ];
                            case 1:
                                networks = _state.sent();
                                return [
                                    2,
                                    $3e9d92c6058b8741$var$checkNetworks(networks)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "perform",
            value: function perform(method, params) {
                return $3e9d92c6058b8741$var$__awaiter(this, void 0, void 0, function() {
                    var _this, _loop, _this1, results, i, result, processFunc, configs, currentBlockNumber, i1, first, _ret;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this, _loop = function() {
                                    var _this2, _loop, t0, inflightWeight, waiting, results, result, errors;
                                    return (0, $6qu4b.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this2 = _this, _loop = function() {
                                                    var config = configs[i1++];
                                                    var rid = $3e9d92c6058b8741$var$nextRid++;
                                                    config.start = $3e9d92c6058b8741$var$now();
                                                    config.staller = $3e9d92c6058b8741$var$stall(config.stallTimeout);
                                                    config.staller.wait(function() {
                                                        config.staller = null;
                                                    });
                                                    config.runner = $3e9d92c6058b8741$var$getRunner(config, currentBlockNumber, method, params).then(function(result) {
                                                        config.done = true;
                                                        config.result = result;
                                                        if (_this1.listenerCount("debug")) _this1.emit("debug", {
                                                            action: "request",
                                                            rid: rid,
                                                            backend: $3e9d92c6058b8741$var$exposeDebugConfig(config, $3e9d92c6058b8741$var$now()),
                                                            request: {
                                                                method: method,
                                                                params: (0, $8832fb576a60463b$export$6c40052bed430212)(params)
                                                            },
                                                            provider: _this1
                                                        });
                                                    }, function(error) {
                                                        config.done = true;
                                                        config.error = error;
                                                        if (_this1.listenerCount("debug")) _this1.emit("debug", {
                                                            action: "request",
                                                            rid: rid,
                                                            backend: $3e9d92c6058b8741$var$exposeDebugConfig(config, $3e9d92c6058b8741$var$now()),
                                                            request: {
                                                                method: method,
                                                                params: (0, $8832fb576a60463b$export$6c40052bed430212)(params)
                                                            },
                                                            provider: _this1
                                                        });
                                                    });
                                                    if (_this2.listenerCount("debug")) _this2.emit("debug", {
                                                        action: "request",
                                                        rid: rid,
                                                        backend: $3e9d92c6058b8741$var$exposeDebugConfig(config, null),
                                                        request: {
                                                            method: method,
                                                            params: (0, $8832fb576a60463b$export$6c40052bed430212)(params)
                                                        },
                                                        provider: _this2
                                                    });
                                                    inflightWeight += config.weight;
                                                };
                                                t0 = $3e9d92c6058b8741$var$now();
                                                // Compute the inflight weight (exclude anything past)
                                                inflightWeight = configs.filter(function(c) {
                                                    return c.runner && t0 - c.start < c.stallTimeout;
                                                }).reduce(function(accum, c) {
                                                    return accum + c.weight;
                                                }, 0);
                                                // Start running enough to meet quorum
                                                while(inflightWeight < _this.quorum && i1 < configs.length)_loop();
                                                // Wait for anything meaningful to finish or stall out
                                                waiting = [];
                                                configs.forEach(function(c) {
                                                    if (c.done || !c.runner) return;
                                                    waiting.push(c.runner);
                                                    if (c.staller) waiting.push(c.staller.getPromise());
                                                });
                                                if (!waiting.length) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    Promise.race(waiting)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                // Check the quorum and process the results; the process function
                                                // may additionally decide the quorum is not met
                                                results = configs.filter(function(c) {
                                                    return c.done && c.error == null;
                                                });
                                                if (!(results.length >= _this.quorum)) return [
                                                    3,
                                                    5
                                                ];
                                                result = processFunc(results);
                                                if (result !== undefined) {
                                                    // Shut down any stallers
                                                    configs.forEach(function(c) {
                                                        if (c.staller) c.staller.cancel();
                                                        c.cancelled = true;
                                                    });
                                                    return [
                                                        2,
                                                        {
                                                            v: result
                                                        }
                                                    ];
                                                }
                                                if (!!first) return [
                                                    3,
                                                    4
                                                ];
                                                return [
                                                    4,
                                                    $3e9d92c6058b8741$var$stall(100).getPromise()
                                                ];
                                            case 3:
                                                _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                first = false;
                                                _state.label = 5;
                                            case 5:
                                                // No result, check for errors that should be forwarded
                                                errors = configs.reduce(function(accum, c) {
                                                    if (!c.done || c.error == null) return accum;
                                                    var code = c.error.code;
                                                    if ($3e9d92c6058b8741$var$ForwardErrors.indexOf(code) >= 0) {
                                                        if (!accum[code]) accum[code] = {
                                                            error: c.error,
                                                            weight: 0
                                                        };
                                                        accum[code].weight += c.weight;
                                                    }
                                                    return accum;
                                                }, {});
                                                Object.keys(errors).forEach(function(errorCode) {
                                                    var tally = errors[errorCode];
                                                    if (tally.weight < _this1.quorum) return;
                                                    // Shut down any stallers
                                                    configs.forEach(function(c) {
                                                        if (c.staller) c.staller.cancel();
                                                        c.cancelled = true;
                                                    });
                                                    var e = tally.error;
                                                    var props = {};
                                                    $3e9d92c6058b8741$var$ForwardProperties.forEach(function(name) {
                                                        if (e[name] == null) return;
                                                        props[name] = e[name];
                                                    });
                                                    $3e9d92c6058b8741$var$logger.throwError(e.reason || e.message, errorCode, props);
                                                });
                                                // All configs have run to completion; we will never get more data
                                                if (configs.filter(function(c) {
                                                    return !c.done;
                                                }).length === 0) return [
                                                    2,
                                                    "break"
                                                ];
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _this1 = this;
                                if (!(method === "sendTransaction")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Promise.all(this.providerConfigs.map(function(c) {
                                        return c.provider.sendTransaction(params.signedTransaction).then(function(result) {
                                            return result.hash;
                                        }, function(error) {
                                            return error;
                                        });
                                    }))
                                ];
                            case 1:
                                results = _state.sent();
                                // Any success is good enough (other errors are likely "already seen" errors
                                for(i = 0; i < results.length; i++){
                                    result = results[i];
                                    if (typeof result === "string") return [
                                        2,
                                        result
                                    ];
                                }
                                // They were all an error; pick the first error
                                throw results[0];
                            case 2:
                                if (!(this._highestBlockNumber === -1 && method !== "getBlockNumber")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.getBlockNumber()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                processFunc = $3e9d92c6058b8741$var$getProcessFunc(this, method, params);
                                // Shuffle the providers and then sort them by their priority; we
                                // shallowCopy them since we will store the result in them too
                                configs = (0, $acdf15154f192af3$export$e6c7296801b9b341)(this.providerConfigs.map((0, $8832fb576a60463b$export$9c13236873b118a5)));
                                configs.sort(function(a, b) {
                                    return a.priority - b.priority;
                                });
                                currentBlockNumber = this._highestBlockNumber;
                                i1 = 0;
                                first = true;
                                _state.label = 5;
                            case 5:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                return [
                                    5,
                                    (0, $6qu4b.__values)(_loop())
                                ];
                            case 6:
                                _ret = _state.sent();
                                if ((0, $aVMuR._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                if (_ret === "break") return [
                                    3,
                                    7
                                ];
                                return [
                                    3,
                                    5
                                ];
                            case 7:
                                // Shut down any stallers; shouldn't be any
                                configs.forEach(function(c) {
                                    if (c.staller) c.staller.cancel();
                                    c.cancelled = true;
                                });
                                return [
                                    2,
                                    $3e9d92c6058b8741$var$logger.throwError("failed to meet quorum", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.SERVER_ERROR, {
                                        method: method,
                                        params: params,
                                        //results: configs.map((c) => c.result),
                                        //errors: configs.map((c) => c.error),
                                        results: configs.map(function(c) {
                                            return $3e9d92c6058b8741$var$exposeDebugConfig(c);
                                        }),
                                        provider: this
                                    })
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return FallbackProvider;
}((0, $526e8ebee4b63c77$export$ff3f6dd83125ac45));


"use strict";
var $02193b699917d742$export$fbe151f90a1ece01 = null;



var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");






"use strict";
var $68d21aeec040073b$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $68d21aeec040073b$var$defaultProjectId = "84842078b09946638c03157f83405213";
var $68d21aeec040073b$export$dd168a807d60da4f = /*#__PURE__*/ function(WebSocketProvider) {
    (0, $cgJ2Y._)(InfuraWebSocketProvider, WebSocketProvider);
    var _super = (0, $hKD8n._)(InfuraWebSocketProvider);
    function InfuraWebSocketProvider(network, apiKey) {
        (0, $7dKN1._)(this, InfuraWebSocketProvider);
        var _this;
        var provider = new $68d21aeec040073b$export$60ff1a559b5c6ebd(network, apiKey);
        var connection = provider.connection;
        if (connection.password) $68d21aeec040073b$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        var url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        _this = _super.call(this, url, network);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "apiKey", provider.projectId);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "projectId", provider.projectId);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "projectSecret", provider.projectSecret);
        return _this;
    }
    (0, $eW5pA._)(InfuraWebSocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.projectId === $68d21aeec040073b$var$defaultProjectId;
            }
        }
    ]);
    return InfuraWebSocketProvider;
}((0, $f2e2193043971f40$export$bfafe629242f30bd));
var $68d21aeec040073b$export$60ff1a559b5c6ebd = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $cgJ2Y._)(InfuraProvider, UrlJsonRpcProvider);
    var _super = (0, $hKD8n._)(InfuraProvider);
    function InfuraProvider() {
        (0, $7dKN1._)(this, InfuraProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(InfuraProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.projectId === $68d21aeec040073b$var$defaultProjectId;
            }
        }
    ], [
        {
            key: "getWebSocketProvider",
            value: function getWebSocketProvider(network, apiKey) {
                return new $68d21aeec040073b$export$dd168a807d60da4f(network, apiKey);
            }
        },
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                var apiKeyObj = {
                    apiKey: $68d21aeec040073b$var$defaultProjectId,
                    projectId: $68d21aeec040073b$var$defaultProjectId,
                    projectSecret: null
                };
                if (apiKey == null) return apiKeyObj;
                if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
                else if (apiKey.projectSecret != null) {
                    $68d21aeec040073b$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
                    $68d21aeec040073b$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
                    apiKeyObj.projectId = apiKey.projectId;
                    apiKeyObj.projectSecret = apiKey.projectSecret;
                } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
                apiKeyObj.apiKey = apiKeyObj.projectId;
                return apiKeyObj;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network ? network.name : "unknown"){
                    case "homestead":
                        host = "mainnet.infura.io";
                        break;
                    case "goerli":
                        host = "goerli.infura.io";
                        break;
                    case "sepolia":
                        host = "sepolia.infura.io";
                        break;
                    case "matic":
                        host = "polygon-mainnet.infura.io";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai.infura.io";
                        break;
                    case "optimism":
                        host = "optimism-mainnet.infura.io";
                        break;
                    case "optimism-goerli":
                        host = "optimism-goerli.infura.io";
                        break;
                    case "arbitrum":
                        host = "arbitrum-mainnet.infura.io";
                        break;
                    case "arbitrum-goerli":
                        host = "arbitrum-goerli.infura.io";
                        break;
                    default:
                        $68d21aeec040073b$var$logger.throwError("unsupported network", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                            argument: "network",
                            value: network
                        });
                }
                var connection = {
                    allowGzip: true,
                    url: "https://" + host + "/v3/" + apiKey.projectId,
                    throttleCallback: function(attempt, url) {
                        if (apiKey.projectId === $68d21aeec040073b$var$defaultProjectId) (0, $2fc925c8cd1d3841$export$4c41bd49e82e82ab)();
                        return Promise.resolve(true);
                    }
                };
                if (apiKey.projectSecret != null) {
                    connection.user = "";
                    connection.password = apiKey.projectSecret;
                }
                return connection;
            }
        }
    ]);
    return InfuraProvider;
}((0, $1026e27d6463850a$export$664128d6239ccf96));




var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



var $a041024484c0181d$export$5a16092bf20edf97 = /*#__PURE__*/ function(JsonRpcProvider) {
    "use strict";
    (0, $cgJ2Y._)(JsonRpcBatchProvider, JsonRpcProvider);
    var _super = (0, $hKD8n._)(JsonRpcBatchProvider);
    function JsonRpcBatchProvider() {
        (0, $7dKN1._)(this, JsonRpcBatchProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(JsonRpcBatchProvider, [
        {
            key: "send",
            value: function send(method, params) {
                var _this = this;
                var request = {
                    method: method,
                    params: params,
                    id: this._nextId++,
                    jsonrpc: "2.0"
                };
                if (this._pendingBatch == null) this._pendingBatch = [];
                var inflightRequest = {
                    request: request,
                    resolve: null,
                    reject: null
                };
                var promise = new Promise(function(resolve, reject) {
                    inflightRequest.resolve = resolve;
                    inflightRequest.reject = reject;
                });
                this._pendingBatch.push(inflightRequest);
                if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
                this._pendingBatchAggregator = setTimeout(function() {
                    // Get teh current batch and clear it, so new requests
                    // go into the next batch
                    var batch = _this._pendingBatch;
                    _this._pendingBatch = null;
                    _this._pendingBatchAggregator = null;
                    // Get the request as an array of requests
                    var request = batch.map(function(inflight) {
                        return inflight.request;
                    });
                    _this.emit("debug", {
                        action: "requestBatch",
                        request: (0, $8832fb576a60463b$export$6c40052bed430212)(request),
                        provider: _this
                    });
                    return (0, $43ca5dbe92db6f17$export$6d71b655afe1638d)(_this.connection, JSON.stringify(request)).then(function(result) {
                        _this.emit("debug", {
                            action: "response",
                            request: request,
                            response: result,
                            provider: _this
                        });
                        // For each result, feed it to the correct Promise, depending
                        // on whether it was a success or error
                        batch.forEach(function(inflightRequest, index) {
                            var payload = result[index];
                            if (payload.error) {
                                var error = new Error(payload.error.message);
                                error.code = payload.error.code;
                                error.data = payload.error.data;
                                inflightRequest.reject(error);
                            } else inflightRequest.resolve(payload.result);
                        });
                    }, function(error) {
                        _this.emit("debug", {
                            action: "response",
                            error: error,
                            request: request,
                            provider: _this
                        });
                        batch.forEach(function(inflightRequest) {
                            inflightRequest.reject(error);
                        });
                    });
                }, 10);
                return promise;
            }
        }
    ]);
    return JsonRpcBatchProvider;
}((0, $12c7496014ff7c2a$export$da28308012bf6748));


/* istanbul ignore file */ 
var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



"use strict";
var $ac40b9bcc218771b$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
// Special API key provided by Nodesmith for ethers.js
var $ac40b9bcc218771b$var$defaultApiKey = "ETHERS_JS_SHARED";
var $ac40b9bcc218771b$export$8235cbce3ce273bd = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $cgJ2Y._)(NodesmithProvider, UrlJsonRpcProvider);
    var _super = (0, $hKD8n._)(NodesmithProvider);
    function NodesmithProvider() {
        (0, $7dKN1._)(this, NodesmithProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(NodesmithProvider, null, [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                if (apiKey && typeof apiKey !== "string") $ac40b9bcc218771b$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
                return apiKey || $ac40b9bcc218771b$var$defaultApiKey;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                $ac40b9bcc218771b$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
                var host = null;
                switch(network.name){
                    case "homestead":
                        host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                        break;
                    case "ropsten":
                        host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                        break;
                    case "rinkeby":
                        host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                        break;
                    case "goerli":
                        host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                        break;
                    case "kovan":
                        host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                        break;
                    default:
                        $ac40b9bcc218771b$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
                }
                return host + "?apiKey=" + apiKey;
            }
        }
    ]);
    return NodesmithProvider;
}((0, $1026e27d6463850a$export$664128d6239ccf96));



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");



"use strict";
var $da37faaa508e19bc$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $da37faaa508e19bc$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
var $da37faaa508e19bc$export$58bb47e42f6b092e = /*#__PURE__*/ function(UrlJsonRpcProvider) {
    (0, $cgJ2Y._)(PocketProvider, UrlJsonRpcProvider);
    var _super = (0, $hKD8n._)(PocketProvider);
    function PocketProvider() {
        (0, $7dKN1._)(this, PocketProvider);
        return _super.apply(this, arguments);
    }
    (0, $eW5pA._)(PocketProvider, [
        {
            key: "isCommunityResource",
            value: function isCommunityResource() {
                return this.applicationId === $da37faaa508e19bc$var$defaultApplicationId;
            }
        }
    ], [
        {
            key: "getApiKey",
            value: function getApiKey(apiKey) {
                var apiKeyObj = {
                    applicationId: null,
                    loadBalancer: true,
                    applicationSecretKey: null
                };
                // Parse applicationId and applicationSecretKey
                if (apiKey == null) apiKeyObj.applicationId = $da37faaa508e19bc$var$defaultApplicationId;
                else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
                else if (apiKey.applicationSecretKey != null) {
                    apiKeyObj.applicationId = apiKey.applicationId;
                    apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
                } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
                else $da37faaa508e19bc$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
                return apiKeyObj;
            }
        },
        {
            key: "getUrl",
            value: function getUrl(network, apiKey) {
                var host = null;
                switch(network ? network.name : "unknown"){
                    case "goerli":
                        host = "eth-goerli.gateway.pokt.network";
                        break;
                    case "homestead":
                        host = "eth-mainnet.gateway.pokt.network";
                        break;
                    case "kovan":
                        host = "poa-kovan.gateway.pokt.network";
                        break;
                    case "matic":
                        host = "poly-mainnet.gateway.pokt.network";
                        break;
                    case "maticmum":
                        host = "polygon-mumbai-rpc.gateway.pokt.network";
                        break;
                    case "rinkeby":
                        host = "eth-rinkeby.gateway.pokt.network";
                        break;
                    case "ropsten":
                        host = "eth-ropsten.gateway.pokt.network";
                        break;
                    default:
                        $da37faaa508e19bc$var$logger.throwError("unsupported network", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                            argument: "network",
                            value: network
                        });
                }
                var url = "https://".concat(host, "/v1/lb/").concat(apiKey.applicationId);
                var connection = {
                    headers: {},
                    url: url
                };
                if (apiKey.applicationSecretKey != null) {
                    connection.user = "";
                    connection.password = apiKey.applicationSecretKey;
                }
                return connection;
            }
        }
    ]);
    return PocketProvider;
}((0, $1026e27d6463850a$export$664128d6239ccf96));




var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $hKD8n = parcelRequire("hKD8n");




"use strict";
var $10a88493ad9176c2$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
var $10a88493ad9176c2$var$_nextId = 1;
function $10a88493ad9176c2$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    var fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        var _this = this;
        var request = {
            method: method,
            params: params,
            id: $10a88493ad9176c2$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise(function(resolve, reject) {
            _this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $8832fb576a60463b$export$6c40052bed430212)(request),
                provider: _this
            });
            sendFunc(request, function(error, response) {
                if (error) {
                    _this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: _this
                    });
                    return reject(error);
                }
                _this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: _this
                });
                if (response.error) {
                    var _$error = new Error(response.error.message);
                    _$error.code = response.error.code;
                    _$error.data = response.error.data;
                    return reject(_$error);
                }
                resolve(response.result);
            });
        });
    };
}
function $10a88493ad9176c2$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        var _this = this;
        if (params == null) params = [];
        var request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $8832fb576a60463b$export$6c40052bed430212)(request),
            provider: this
        });
        return provider.request(request).then(function(response) {
            _this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: _this
            });
            return response;
        }, function(error) {
            _this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: _this
            });
            throw error;
        });
    };
}
var $10a88493ad9176c2$export$d05096c9fd9d936d = /*#__PURE__*/ function(JsonRpcProvider) {
    (0, $cgJ2Y._)(Web3Provider, JsonRpcProvider);
    var _super = (0, $hKD8n._)(Web3Provider);
    function Web3Provider(provider, network) {
        (0, $7dKN1._)(this, Web3Provider);
        var _this;
        if (provider == null) $10a88493ad9176c2$var$logger.throwArgumentError("missing provider", "provider", provider);
        var path = null;
        var jsonRpcFetchFunc = null;
        var subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $10a88493ad9176c2$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $10a88493ad9176c2$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $10a88493ad9176c2$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $10a88493ad9176c2$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        _this = _super.call(this, path, network);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $8832fb576a60463b$export$104236534534f9be)((0, $b9zO9._)(_this), "provider", subprovider);
        return _this;
    }
    (0, $eW5pA._)(Web3Provider, [
        {
            key: "send",
            value: function send(method, params) {
                return this.jsonRpcFetchFunc(method, params);
            }
        }
    ]);
    return Web3Provider;
}((0, $12c7496014ff7c2a$export$da28308012bf6748));






"use strict";
var $62f207a30c1ed53d$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $a5b1dc8d7da2a5bb$export$83d89fbfd8236492));
////////////////////////
// Helper Functions
function $62f207a30c1ed53d$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        var match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $12c7496014ff7c2a$export$da28308012bf6748)(network);
            case "ws":
            case "wss":
                return new (0, $f2e2193043971f40$export$bfafe629242f30bd)(network);
            default:
                $62f207a30c1ed53d$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    var n = (0, $83843fdbb5c0c0a1$export$7de4970ebfd8206d)(network);
    if (!n || !n._defaultProvider) $62f207a30c1ed53d$var$logger.throwError("unsupported getDefaultProvider network", (0, $4942c2e156bb1fcc$export$efa9a398d6368992).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: (0, $3e9d92c6058b8741$export$cb1d0beacb55feb7),
        AlchemyProvider: (0, $406085ed0719de30$export$999cc40da3fbc6f),
        AnkrProvider: (0, $5d99454c30f7154e$export$72783b2aefa72a45),
        CloudflareProvider: (0, $e53beb044b99e708$export$7113381f8f264fc0),
        EtherscanProvider: (0, $3c0b36f99ba2c448$export$dd1d942a536c7912),
        InfuraProvider: (0, $68d21aeec040073b$export$60ff1a559b5c6ebd),
        JsonRpcProvider: (0, $12c7496014ff7c2a$export$da28308012bf6748),
        NodesmithProvider: (0, $ac40b9bcc218771b$export$8235cbce3ce273bd),
        PocketProvider: (0, $da37faaa508e19bc$export$58bb47e42f6b092e),
        Web3Provider: (0, $10a88493ad9176c2$export$d05096c9fd9d936d),
        IpcProvider: (0, $02193b699917d742$export$fbe151f90a1ece01)
    }, options);
}



var $3caeaa80902316a2$exports = {};

$parcel$export($3caeaa80902316a2$exports, "AbiCoder", function () { return $5b4960d4c3b0981f$export$fe041e1a83d3efc6; });
$parcel$export($3caeaa80902316a2$exports, "defaultAbiCoder", function () { return $5b4960d4c3b0981f$export$51d1cfcdb913adff; });
$parcel$export($3caeaa80902316a2$exports, "Fragment", function () { return $7978476fda259c54$export$ffb0004e005737fa; });
$parcel$export($3caeaa80902316a2$exports, "ConstructorFragment", function () { return $7978476fda259c54$export$3ac5c9504f801ea4; });
$parcel$export($3caeaa80902316a2$exports, "ErrorFragment", function () { return $7978476fda259c54$export$2c42c6d543aa9b59; });
$parcel$export($3caeaa80902316a2$exports, "EventFragment", function () { return $7978476fda259c54$export$958548f08bac2833; });
$parcel$export($3caeaa80902316a2$exports, "FunctionFragment", function () { return $7978476fda259c54$export$8d576c928b93668f; });
$parcel$export($3caeaa80902316a2$exports, "ParamType", function () { return $7978476fda259c54$export$426dc07f493a4c47; });
$parcel$export($3caeaa80902316a2$exports, "FormatTypes", function () { return $7978476fda259c54$export$f010f239efc4d445; });
$parcel$export($3caeaa80902316a2$exports, "checkResultErrors", function () { return $cf95945b1659ac47$export$5546b9ec21157cc2; });
$parcel$export($3caeaa80902316a2$exports, "Logger", function () { return $4942c2e156bb1fcc$export$efa9a398d6368992; });
$parcel$export($3caeaa80902316a2$exports, "RLP", function () { return $00af536cb1026bd9$exports; });
$parcel$export($3caeaa80902316a2$exports, "_fetchData", function () { return $43ca5dbe92db6f17$export$e37fa27017c6c012; });
$parcel$export($3caeaa80902316a2$exports, "fetchJson", function () { return $43ca5dbe92db6f17$export$6d71b655afe1638d; });
$parcel$export($3caeaa80902316a2$exports, "poll", function () { return $43ca5dbe92db6f17$export$e0c10349b2c5e1d4; });
$parcel$export($3caeaa80902316a2$exports, "checkProperties", function () { return $8832fb576a60463b$export$ae5a316ba623b73a; });
$parcel$export($3caeaa80902316a2$exports, "deepCopy", function () { return $8832fb576a60463b$export$6c40052bed430212; });
$parcel$export($3caeaa80902316a2$exports, "defineReadOnly", function () { return $8832fb576a60463b$export$104236534534f9be; });
$parcel$export($3caeaa80902316a2$exports, "getStatic", function () { return $8832fb576a60463b$export$f695fbbf3cdaaf47; });
$parcel$export($3caeaa80902316a2$exports, "resolveProperties", function () { return $8832fb576a60463b$export$d503dd157d963b60; });
$parcel$export($3caeaa80902316a2$exports, "shallowCopy", function () { return $8832fb576a60463b$export$9c13236873b118a5; });
$parcel$export($3caeaa80902316a2$exports, "arrayify", function () { return $b8b53b1cc922c9da$export$3131421a7d01b4fb; });
$parcel$export($3caeaa80902316a2$exports, "concat", function () { return $b8b53b1cc922c9da$export$ee1b3e54f0441b22; });
$parcel$export($3caeaa80902316a2$exports, "stripZeros", function () { return $b8b53b1cc922c9da$export$a8f4574d0e56446c; });
$parcel$export($3caeaa80902316a2$exports, "zeroPad", function () { return $b8b53b1cc922c9da$export$3cdc770bf8b2ed3d; });
$parcel$export($3caeaa80902316a2$exports, "isBytes", function () { return $b8b53b1cc922c9da$export$c6fabfbfd097fc30; });
$parcel$export($3caeaa80902316a2$exports, "isBytesLike", function () { return $b8b53b1cc922c9da$export$9a14abb1a440cd5e; });
$parcel$export($3caeaa80902316a2$exports, "defaultPath", function () { return $1017e67baeca0b33$export$d48ad89f7e11a603; });
$parcel$export($3caeaa80902316a2$exports, "HDNode", function () { return $1017e67baeca0b33$export$b68640c53e22b952; });
$parcel$export($3caeaa80902316a2$exports, "SigningKey", function () { return $14bbf95e2a82e6fd$export$21643ca94aed3e83; });
$parcel$export($3caeaa80902316a2$exports, "Interface", function () { return $52cdf212653b6230$export$48cefb51a4e315b2; });
$parcel$export($3caeaa80902316a2$exports, "LogDescription", function () { return $52cdf212653b6230$export$c2ab6499be98b3c5; });
$parcel$export($3caeaa80902316a2$exports, "TransactionDescription", function () { return $52cdf212653b6230$export$7a3223b0fadb690b; });
$parcel$export($3caeaa80902316a2$exports, "base58", function () { return $59ddd2fedfa0199a$export$45a587635c9954b2; });
$parcel$export($3caeaa80902316a2$exports, "base64", function () { return $6611feb5defc5929$exports; });
$parcel$export($3caeaa80902316a2$exports, "hexlify", function () { return $b8b53b1cc922c9da$export$2b0d6b5fbe698c70; });
$parcel$export($3caeaa80902316a2$exports, "isHexString", function () { return $b8b53b1cc922c9da$export$b02a40aff8e4ad18; });
$parcel$export($3caeaa80902316a2$exports, "hexConcat", function () { return $b8b53b1cc922c9da$export$6d4b99629b38754a; });
$parcel$export($3caeaa80902316a2$exports, "hexStripZeros", function () { return $b8b53b1cc922c9da$export$967bc0082a978949; });
$parcel$export($3caeaa80902316a2$exports, "hexValue", function () { return $b8b53b1cc922c9da$export$6916af760a341dd3; });
$parcel$export($3caeaa80902316a2$exports, "hexZeroPad", function () { return $b8b53b1cc922c9da$export$e9c46a54370b47e8; });
$parcel$export($3caeaa80902316a2$exports, "hexDataLength", function () { return $b8b53b1cc922c9da$export$13882f896d3c0683; });
$parcel$export($3caeaa80902316a2$exports, "hexDataSlice", function () { return $b8b53b1cc922c9da$export$15da666eba198c18; });
$parcel$export($3caeaa80902316a2$exports, "nameprep", function () { return $70ce3eda513017ba$export$94f0b6f93c619bc; });
$parcel$export($3caeaa80902316a2$exports, "_toEscapedUtf8String", function () { return $4d583f407d5b3d1a$export$a7a0ec15960b9055; });
$parcel$export($3caeaa80902316a2$exports, "toUtf8Bytes", function () { return $4d583f407d5b3d1a$export$8feeb310b4b4752f; });
$parcel$export($3caeaa80902316a2$exports, "toUtf8CodePoints", function () { return $4d583f407d5b3d1a$export$ae470a36a31b28c2; });
$parcel$export($3caeaa80902316a2$exports, "toUtf8String", function () { return $4d583f407d5b3d1a$export$7643a1dc2c38d5eb; });
$parcel$export($3caeaa80902316a2$exports, "Utf8ErrorFuncs", function () { return $4d583f407d5b3d1a$export$c6e2180c5bb5bc05; });
$parcel$export($3caeaa80902316a2$exports, "formatBytes32String", function () { return $8638d05fb8c8e813$export$b97e949c0076e971; });
$parcel$export($3caeaa80902316a2$exports, "parseBytes32String", function () { return $8638d05fb8c8e813$export$49340cb8f3954db8; });
$parcel$export($3caeaa80902316a2$exports, "dnsEncode", function () { return $502d474d526285f9$export$6c0a8cdae51cb512; });
$parcel$export($3caeaa80902316a2$exports, "hashMessage", function () { return $c9b75c627427b5da$export$d4c241cec96564c1; });
$parcel$export($3caeaa80902316a2$exports, "namehash", function () { return $502d474d526285f9$export$91d651ee363e1209; });
$parcel$export($3caeaa80902316a2$exports, "isValidName", function () { return $502d474d526285f9$export$cce2300886e7ace6; });
$parcel$export($3caeaa80902316a2$exports, "id", function () { return $c31b68ebaa2e080f$export$d560c7e4a29451c2; });
$parcel$export($3caeaa80902316a2$exports, "_TypedDataEncoder", function () { return $48669d0386352f19$export$458ab927ae635c3; });
$parcel$export($3caeaa80902316a2$exports, "getAddress", function () { return $77ffbd0470aad2fd$export$88411125f012957a; });
$parcel$export($3caeaa80902316a2$exports, "getIcapAddress", function () { return $77ffbd0470aad2fd$export$962c4ddada9f668f; });
$parcel$export($3caeaa80902316a2$exports, "getContractAddress", function () { return $77ffbd0470aad2fd$export$b7fbffef12272e40; });
$parcel$export($3caeaa80902316a2$exports, "getCreate2Address", function () { return $77ffbd0470aad2fd$export$e0b22d96621f73a2; });
$parcel$export($3caeaa80902316a2$exports, "isAddress", function () { return $77ffbd0470aad2fd$export$977e255126d763d6; });
$parcel$export($3caeaa80902316a2$exports, "formatEther", function () { return $59c578df31e5a309$export$11bc63b4c03ea518; });
$parcel$export($3caeaa80902316a2$exports, "parseEther", function () { return $59c578df31e5a309$export$642c4e67bbdc0bc7; });
$parcel$export($3caeaa80902316a2$exports, "formatUnits", function () { return $59c578df31e5a309$export$bd39b96f71da1885; });
$parcel$export($3caeaa80902316a2$exports, "parseUnits", function () { return $59c578df31e5a309$export$203ae30b4f6490b3; });
$parcel$export($3caeaa80902316a2$exports, "commify", function () { return $59c578df31e5a309$export$de1294767e6ef661; });
$parcel$export($3caeaa80902316a2$exports, "computeHmac", function () { return $fd8149ac93df5472$export$967075d2f3b8e7ff; });
$parcel$export($3caeaa80902316a2$exports, "keccak256", function () { return $aca68b720d4a692f$export$f8151fce47ad1c35; });
$parcel$export($3caeaa80902316a2$exports, "ripemd160", function () { return $fd8149ac93df5472$export$d1cea0ee4e3f0d3e; });
$parcel$export($3caeaa80902316a2$exports, "sha256", function () { return $fd8149ac93df5472$export$bced8d2aada2d1c9; });
$parcel$export($3caeaa80902316a2$exports, "sha512", function () { return $fd8149ac93df5472$export$a888d2532e6dc7bb; });
$parcel$export($3caeaa80902316a2$exports, "randomBytes", function () { return $134eca54eaa0c337$export$5f828d93ff035aa8; });
$parcel$export($3caeaa80902316a2$exports, "shuffled", function () { return $acdf15154f192af3$export$e6c7296801b9b341; });
$parcel$export($3caeaa80902316a2$exports, "solidityPack", function () { return $a17c105ca4f0fd1a$export$2a703dbb0cb35339; });
$parcel$export($3caeaa80902316a2$exports, "solidityKeccak256", function () { return $a17c105ca4f0fd1a$export$f8151fce47ad1c35; });
$parcel$export($3caeaa80902316a2$exports, "soliditySha256", function () { return $a17c105ca4f0fd1a$export$bced8d2aada2d1c9; });
$parcel$export($3caeaa80902316a2$exports, "splitSignature", function () { return $b8b53b1cc922c9da$export$7fb170f1e457988f; });
$parcel$export($3caeaa80902316a2$exports, "joinSignature", function () { return $b8b53b1cc922c9da$export$71bb9d78a59bbe25; });
$parcel$export($3caeaa80902316a2$exports, "accessListify", function () { return $fd7cc3a32c93c53c$export$6c8662b1600dce2; });
$parcel$export($3caeaa80902316a2$exports, "parseTransaction", function () { return $fd7cc3a32c93c53c$export$98e6a39c04603d36; });
$parcel$export($3caeaa80902316a2$exports, "serializeTransaction", function () { return $fd7cc3a32c93c53c$export$dfdc1655ccc5b9cb; });
$parcel$export($3caeaa80902316a2$exports, "TransactionTypes", function () { return $fd7cc3a32c93c53c$export$80349e05e0724e11; });
$parcel$export($3caeaa80902316a2$exports, "getJsonWalletAddress", function () { return $96fdb01d9ee7515b$export$9a68ee9f8f3afd38; });
$parcel$export($3caeaa80902316a2$exports, "computeAddress", function () { return $fd7cc3a32c93c53c$export$e67e2732ba9803f9; });
$parcel$export($3caeaa80902316a2$exports, "recoverAddress", function () { return $fd7cc3a32c93c53c$export$23cc18f96d8510e2; });
$parcel$export($3caeaa80902316a2$exports, "computePublicKey", function () { return $14bbf95e2a82e6fd$export$4a89473d39301224; });
$parcel$export($3caeaa80902316a2$exports, "recoverPublicKey", function () { return $14bbf95e2a82e6fd$export$952dd09fbe0232b7; });
$parcel$export($3caeaa80902316a2$exports, "verifyMessage", function () { return $56cd539b6bfcd29d$export$228d0e772cc158cb; });
$parcel$export($3caeaa80902316a2$exports, "verifyTypedData", function () { return $56cd539b6bfcd29d$export$3603b1c1bcd76798; });
$parcel$export($3caeaa80902316a2$exports, "getAccountPath", function () { return $1017e67baeca0b33$export$22b80e4f9eff636d; });
$parcel$export($3caeaa80902316a2$exports, "mnemonicToEntropy", function () { return $1017e67baeca0b33$export$135e090d58b310ca; });
$parcel$export($3caeaa80902316a2$exports, "entropyToMnemonic", function () { return $1017e67baeca0b33$export$4becd65eb23312e6; });
$parcel$export($3caeaa80902316a2$exports, "isValidMnemonic", function () { return $1017e67baeca0b33$export$5eea3393c6119c80; });
$parcel$export($3caeaa80902316a2$exports, "mnemonicToSeed", function () { return $1017e67baeca0b33$export$3dee74f1204ab09f; });
$parcel$export($3caeaa80902316a2$exports, "SupportedAlgorithm", function () { return $0aa4fe98041e6886$export$d2a8849cfb277c; });
$parcel$export($3caeaa80902316a2$exports, "UnicodeNormalizationForm", function () { return $4d583f407d5b3d1a$export$c6986442964129f5; });
$parcel$export($3caeaa80902316a2$exports, "Utf8ErrorReason", function () { return $4d583f407d5b3d1a$export$c285fa6ac15ff6a6; });
$parcel$export($3caeaa80902316a2$exports, "Indexed", function () { return $52cdf212653b6230$export$8ef99100a3c56f8c; });


var $6611feb5defc5929$exports = {};

$parcel$export($6611feb5defc5929$exports, "decode", function () { return $20128c45dd8db8c0$export$2f872c0f2117be69; });
$parcel$export($6611feb5defc5929$exports, "encode", function () { return $20128c45dd8db8c0$export$c564cdbbe6da493; });

"use strict";
















var $2da5309618cec8a2$export$83d89fbfd8236492 = "solidity/5.7.0";


"use strict";
var $a17c105ca4f0fd1a$var$regexBytes = new RegExp("^bytes([0-9]+)$");
var $a17c105ca4f0fd1a$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
var $a17c105ca4f0fd1a$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
var $a17c105ca4f0fd1a$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
var $a17c105ca4f0fd1a$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $2da5309618cec8a2$export$83d89fbfd8236492));
function $a17c105ca4f0fd1a$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $b8b53b1cc922c9da$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
        case "string":
            return (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(value);
        case "bytes":
            return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $b8b53b1cc922c9da$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value);
    }
    var match = type.match($a17c105ca4f0fd1a$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        var size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $a17c105ca4f0fd1a$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $3b33bab384c8baec$export$d97aa349ed20696).from(value).toTwos(size);
        return (0, $b8b53b1cc922c9da$export$3cdc770bf8b2ed3d)(value, size / 8);
    }
    match = type.match($a17c105ca4f0fd1a$var$regexBytes);
    if (match) {
        var size1 = parseInt(match[1]);
        if (String(size1) !== match[1] || size1 === 0 || size1 > 32) $a17c105ca4f0fd1a$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(value).byteLength !== size1) $a17c105ca4f0fd1a$var$logger.throwArgumentError("invalid value for ".concat(type), "value", value);
        if (isArray) return (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)((value + $a17c105ca4f0fd1a$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($a17c105ca4f0fd1a$var$regexArray);
    if (match && Array.isArray(value)) {
        var baseType = match[1];
        var count = parseInt(match[2] || String(value.length));
        if (count != value.length) $a17c105ca4f0fd1a$var$logger.throwArgumentError("invalid array length for ".concat(type), "value", value);
        var result = [];
        value.forEach(function(value) {
            result.push($a17c105ca4f0fd1a$var$_pack(baseType, value, true));
        });
        return (0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)(result);
    }
    return $a17c105ca4f0fd1a$var$logger.throwArgumentError("invalid type", "type", type);
}
function $a17c105ca4f0fd1a$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $a17c105ca4f0fd1a$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    var tight = [];
    types.forEach(function(type, index) {
        tight.push($a17c105ca4f0fd1a$var$_pack(type, values[index]));
    });
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)(tight));
}
function $a17c105ca4f0fd1a$export$f8151fce47ad1c35(types, values) {
    return (0, $aca68b720d4a692f$export$f8151fce47ad1c35)($a17c105ca4f0fd1a$export$2a703dbb0cb35339(types, values));
}
function $a17c105ca4f0fd1a$export$bced8d2aada2d1c9(types, values) {
    return (0, $fd8149ac93df5472$export$bced8d2aada2d1c9)($a17c105ca4f0fd1a$export$2a703dbb0cb35339(types, values));
}









"use strict";
function $8638d05fb8c8e813$export$b97e949c0076e971(text) {
    // Get the bytes
    var bytes = (0, $4d583f407d5b3d1a$export$8feeb310b4b4752f)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $b8b53b1cc922c9da$export$2b0d6b5fbe698c70)((0, $b8b53b1cc922c9da$export$ee1b3e54f0441b22)([
        bytes,
        (0, $4865d0dc710dfa88$export$71c2e4e213dcb7f2)
    ]).slice(0, 32));
}
function $8638d05fb8c8e813$export$49340cb8f3954db8(bytes) {
    var data = (0, $b8b53b1cc922c9da$export$3131421a7d01b4fb)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    var length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $4d583f407d5b3d1a$export$7643a1dc2c38d5eb)(data.slice(0, length));
}


"use strict";
function $70ce3eda513017ba$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    var result = [];
    for(var i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $70ce3eda513017ba$var$createTable(data, func) {
    if (!func) func = function func(value) {
        return [
            parseInt(value, 16)
        ];
    };
    var lo = 0;
    var result = {};
    data.split(",").forEach(function(pair) {
        var comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $70ce3eda513017ba$var$createRangeTable(data) {
    var hi = 0;
    return data.split(",").map(function(v) {
        var comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        var lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $70ce3eda513017ba$var$matchMap(value, ranges) {
    var lo = 0;
    for(var i = 0; i < ranges.length; i++){
        var range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
var $70ce3eda513017ba$var$Table_A_1_ranges = $70ce3eda513017ba$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
var $70ce3eda513017ba$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function(v) {
    return parseInt(v, 16);
});
var $70ce3eda513017ba$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
var $70ce3eda513017ba$var$Table_B_2_lut_abs = $70ce3eda513017ba$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
var $70ce3eda513017ba$var$Table_B_2_lut_rel = $70ce3eda513017ba$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
var $70ce3eda513017ba$var$Table_B_2_complex = $70ce3eda513017ba$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $70ce3eda513017ba$var$bytes2);
var $70ce3eda513017ba$var$Table_C_ranges = $70ce3eda513017ba$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $70ce3eda513017ba$var$flatten(values) {
    return values.reduce(function(accum, value) {
        value.forEach(function(value) {
            accum.push(value);
        });
        return accum;
    }, []);
}
function $70ce3eda513017ba$export$d1ae0d802533bef0(codepoint) {
    return !!$70ce3eda513017ba$var$matchMap(codepoint, $70ce3eda513017ba$var$Table_A_1_ranges);
}
function $70ce3eda513017ba$export$9630a1f26a43b76c(codepoint) {
    var range = $70ce3eda513017ba$var$matchMap(codepoint, $70ce3eda513017ba$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    var codes = $70ce3eda513017ba$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    var shift = $70ce3eda513017ba$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    var complex = $70ce3eda513017ba$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $70ce3eda513017ba$export$e07a548cae6d1553(codepoint) {
    return !!$70ce3eda513017ba$var$matchMap(codepoint, $70ce3eda513017ba$var$Table_C_ranges);
}
function $70ce3eda513017ba$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    var codes = (0, $4d583f407d5b3d1a$export$ae470a36a31b28c2)(value);
    codes = $70ce3eda513017ba$var$flatten(codes.map(function(code) {
        // Substitute Table B.1 (Maps to Nothing)
        if ($70ce3eda513017ba$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        var codesTableB2 = $70ce3eda513017ba$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $4d583f407d5b3d1a$export$ae470a36a31b28c2)((0, $4d583f407d5b3d1a$export$232e1dab03132235)(codes), (0, $4d583f407d5b3d1a$export$c6986442964129f5).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach(function(code) {
        if ($70ce3eda513017ba$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach(function(code) {
        if ($70ce3eda513017ba$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    var name = (0, $4d583f407d5b3d1a$export$232e1dab03132235)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}





var $b4dcd5ea891793e0$export$83d89fbfd8236492 = "units/5.7.0";


"use strict";
var $59c578df31e5a309$var$logger = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $b4dcd5ea891793e0$export$83d89fbfd8236492));
var $59c578df31e5a309$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $59c578df31e5a309$export$de1294767e6ef661(value) {
    var comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $59c578df31e5a309$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    var whole = comps[0];
    var negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    var suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    var formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        var index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $59c578df31e5a309$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        var index = $59c578df31e5a309$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $44cb5ef3e3762151$export$cc011b843b5d69f2)(value, unitName != null ? unitName : 18);
}
function $59c578df31e5a309$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $59c578df31e5a309$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        var index = $59c578df31e5a309$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $44cb5ef3e3762151$export$1b039987e86d7269)(value, unitName != null ? unitName : 18);
}
function $59c578df31e5a309$export$11bc63b4c03ea518(wei) {
    return $59c578df31e5a309$export$bd39b96f71da1885(wei, 18);
}
function $59c578df31e5a309$export$642c4e67bbdc0bc7(ether) {
    return $59c578df31e5a309$export$203ae30b4f6490b3(ether, 18);
}




"use strict";



var $501153bf8c9d2de4$export$83d89fbfd8236492 = "ethers/5.7.2";


"use strict";
var $7c9fa484a0263d49$export$af88d00dbe7f521 = new (0, $4942c2e156bb1fcc$export$efa9a398d6368992)((0, $501153bf8c9d2de4$export$83d89fbfd8236492));


"use strict";
try {
    var $22ae02235192e57c$var$anyGlobal = window;
    if ($22ae02235192e57c$var$anyGlobal._ethers == null) $22ae02235192e57c$var$anyGlobal._ethers = $7c9fa484a0263d49$exports;
} catch (error) {}



var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $2Nfql = parcelRequire("2Nfql");

var $fG73q = parcelRequire("fG73q");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $bL8uU = parcelRequire("bL8uU");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");

var $ilnag = parcelRequire("ilnag");
var $c0ad2f99ab67211e$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");
"use strict";
Object.defineProperty($c0ad2f99ab67211e$exports, "__esModule", {
    value: true
});
$c0ad2f99ab67211e$exports.hash_to_ristretto255 = $c0ad2f99ab67211e$exports.hashToRistretto255 = $c0ad2f99ab67211e$exports.RistrettoPoint = $c0ad2f99ab67211e$exports.encodeToCurve = $c0ad2f99ab67211e$exports.hashToCurve = $c0ad2f99ab67211e$exports.edwardsToMontgomery = $c0ad2f99ab67211e$exports.x25519 = $c0ad2f99ab67211e$exports.ed25519ph = $c0ad2f99ab67211e$exports.ed25519ctx = $c0ad2f99ab67211e$exports.ed25519 = $c0ad2f99ab67211e$exports.ED25519_TORSION_SUBGROUP = void 0;
$c0ad2f99ab67211e$exports.edwardsToMontgomeryPub = $c0ad2f99ab67211e$var$edwardsToMontgomeryPub;
$c0ad2f99ab67211e$exports.edwardsToMontgomeryPriv = $c0ad2f99ab67211e$var$edwardsToMontgomeryPriv;


var $2bcb0cd052759051$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $4JCw4 = parcelRequire("4JCw4");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty($2bcb0cd052759051$exports, "__esModule", {
    value: true
});
$2bcb0cd052759051$exports.twistedEdwards = $2bcb0cd052759051$var$twistedEdwards;

var $bUKt0 = parcelRequire("bUKt0");

var $ev04Q = parcelRequire("ev04Q");

var $1YtXk = parcelRequire("1YtXk");

var $1YtXk = parcelRequire("1YtXk");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var $2bcb0cd052759051$var$_0n = BigInt(0), $2bcb0cd052759051$var$_1n = BigInt(1), $2bcb0cd052759051$var$_2n = BigInt(2), $2bcb0cd052759051$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
var $2bcb0cd052759051$var$VERIFY_DEFAULT = {
    zip215: true
};
function $2bcb0cd052759051$var$validateOpts(curve) {
    var opts = (0, $bUKt0.validateBasic)(curve);
    $1YtXk.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze((0, $4JCw4._)({}, opts));
}
// It is not generic twisted curve for now, but ed25519/ed448 generic implementation
function $2bcb0cd052759051$var$twistedEdwards(curveDef) {
    var CURVE = $2bcb0cd052759051$var$validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n, prehash = CURVE.prehash, cHash = CURVE.hash, randomBytes = CURVE.randomBytes, nByteLength = CURVE.nByteLength, cofactor = CURVE.h;
    var MASK = $2bcb0cd052759051$var$_2n << BigInt(nByteLength * 8) - $2bcb0cd052759051$var$_1n;
    var modP = Fp.create; // Function overrides
    // sqrt(u/v)
    var uvRatio = CURVE.uvRatio || function(u, v) {
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $2bcb0cd052759051$var$_0n
            };
        }
    };
    var adjustScalarBytes = CURVE.adjustScalarBytes || function(bytes) {
        return bytes;
    }; // NOOP
    var domain = CURVE.domain || function(data, ctx, phflag) {
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }; // NOOP
    var inBig = function(n) {
        return (typeof n === "undefined" ? "undefined" : (0, $aVMuR._)(n)) === "bigint" && $2bcb0cd052759051$var$_0n < n;
    }; // n in [1..]
    var inRange = function(n, max) {
        return inBig(n) && inBig(max) && n < max;
    }; // n in [1..max-1]
    var in0MaskRange = function(n) {
        return n === $2bcb0cd052759051$var$_0n || inRange(n, MASK);
    }; // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error("Expected valid scalar < ".concat(max, ", got ").concat(typeof n === "undefined" ? "undefined" : (0, $aVMuR._)(n), " ").concat(n));
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $2bcb0cd052759051$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    var pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    var Point = /*#__PURE__*/ function() {
        function Point(ex, ey, ez, et) {
            (0, $7dKN1._)(this, Point);
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        (0, $eW5pA._)(Point, [
            {
                key: "x",
                get: function get() {
                    return this.toAffine().x;
                }
            },
            {
                key: "y",
                get: function get() {
                    return this.toAffine().y;
                }
            },
            {
                // "Private method", don't use it directly
                key: "_setWindowSize",
                value: function _setWindowSize(windowSize) {
                    this._WINDOW_SIZE = windowSize;
                    pointPrecomputes.delete(this);
                }
            },
            {
                // Not required for fromHex(), which always creates valid points.
                // Could be useful for fromAffine().
                key: "assertValidity",
                value: function assertValidity() {
                    var a = CURVE.a, d = CURVE.d;
                    if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
                    // Equation in affine coordinates: ax² + y² = 1 + dx²y²
                    // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
                    var _this = this, X = _this.ex, Y = _this.ey, Z = _this.ez, T = _this.et;
                    var X2 = modP(X * X); // X²
                    var Y2 = modP(Y * Y); // Y²
                    var Z2 = modP(Z * Z); // Z²
                    var Z4 = modP(Z2 * Z2); // Z⁴
                    var aX2 = modP(X2 * a); // aX²
                    var left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
                    var right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
                    if (left !== right) throw new Error("bad point: equation left != right (1)");
                    // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
                    var XY = modP(X * Y);
                    var ZT = modP(Z * T);
                    if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
                }
            },
            {
                // Compare one point to another.
                key: "equals",
                value: function equals(other) {
                    isPoint(other);
                    var _this = this, X1 = _this.ex, Y1 = _this.ey, Z1 = _this.ez;
                    var X2 = other.ex, Y2 = other.ey, Z2 = other.ez;
                    var X1Z2 = modP(X1 * Z2);
                    var X2Z1 = modP(X2 * Z1);
                    var Y1Z2 = modP(Y1 * Z2);
                    var Y2Z1 = modP(Y2 * Z1);
                    return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
                }
            },
            {
                key: "is0",
                value: function is0() {
                    return this.equals(Point.ZERO);
                }
            },
            {
                key: "negate",
                value: function negate() {
                    // Flips point sign to a negative one (-x, y in affine coords)
                    return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
                }
            },
            {
                // Fast algo for doubling Extended Point.
                // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
                // Cost: 4M + 4S + 1*a + 6add + 1*2.
                key: "double",
                value: function double() {
                    var a = CURVE.a;
                    var _this = this, X1 = _this.ex, Y1 = _this.ey, Z1 = _this.ez;
                    var A = modP(X1 * X1); // A = X12
                    var B = modP(Y1 * Y1); // B = Y12
                    var C = modP($2bcb0cd052759051$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
                    var D = modP(a * A); // D = a*A
                    var x1y1 = X1 + Y1;
                    var E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
                    var G = D + B; // G = D+B
                    var F = G - C; // F = G-C
                    var H = D - B; // H = D-B
                    var X3 = modP(E * F); // X3 = E*F
                    var Y3 = modP(G * H); // Y3 = G*H
                    var T3 = modP(E * H); // T3 = E*H
                    var Z3 = modP(F * G); // Z3 = F*G
                    return new Point(X3, Y3, Z3, T3);
                }
            },
            {
                // Fast algo for adding 2 Extended Points.
                // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
                // Cost: 9M + 1*a + 1*d + 7add.
                key: "add",
                value: function add(other) {
                    isPoint(other);
                    var a = CURVE.a, d = CURVE.d;
                    var _this = this, X1 = _this.ex, Y1 = _this.ey, Z1 = _this.ez, T1 = _this.et;
                    var X2 = other.ex, Y2 = other.ey, Z2 = other.ez, T2 = other.et;
                    // Faster algo for adding 2 Extended Points when curve's a=-1.
                    // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
                    // Cost: 8M + 8add + 2*2.
                    // Note: It does not check whether the `other` point is valid.
                    if (a === BigInt(-1)) {
                        var A = modP((Y1 - X1) * (Y2 + X2));
                        var B = modP((Y1 + X1) * (Y2 - X2));
                        var F = modP(B - A);
                        if (F === $2bcb0cd052759051$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                        var C = modP(Z1 * $2bcb0cd052759051$var$_2n * T2);
                        var D = modP(T1 * $2bcb0cd052759051$var$_2n * Z2);
                        var E = D + C;
                        var G = B + A;
                        var H = D - C;
                        var X3 = modP(E * F);
                        var Y3 = modP(G * H);
                        var T3 = modP(E * H);
                        var Z3 = modP(F * G);
                        return new Point(X3, Y3, Z3, T3);
                    }
                    var A1 = modP(X1 * X2); // A = X1*X2
                    var B1 = modP(Y1 * Y2); // B = Y1*Y2
                    var C1 = modP(T1 * d * T2); // C = T1*d*T2
                    var D1 = modP(Z1 * Z2); // D = Z1*Z2
                    var E1 = modP((X1 + Y1) * (X2 + Y2) - A1 - B1); // E = (X1+Y1)*(X2+Y2)-A-B
                    var F1 = D1 - C1; // F = D-C
                    var G1 = D1 + C1; // G = D+C
                    var H1 = modP(B1 - a * A1); // H = B-a*A
                    var X31 = modP(E1 * F1); // X3 = E*F
                    var Y31 = modP(G1 * H1); // Y3 = G*H
                    var T31 = modP(E1 * H1); // T3 = E*H
                    var Z31 = modP(F1 * G1); // Z3 = F*G
                    return new Point(X31, Y31, Z31, T31);
                }
            },
            {
                key: "subtract",
                value: function subtract(other) {
                    return this.add(other.negate());
                }
            },
            {
                key: "wNAF",
                value: function wNAF(n) {
                    return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
                }
            },
            {
                // Constant-time multiplication.
                key: "multiply",
                value: function multiply(scalar) {
                    var _this_wNAF = this.wNAF(assertInRange(scalar, CURVE_ORDER)), p = _this_wNAF.p, f = _this_wNAF.f;
                    return Point.normalizeZ([
                        p,
                        f
                    ])[0];
                }
            },
            {
                // Non-constant-time multiplication. Uses double-and-add algorithm.
                // It's faster, but should only be used when you don't care about
                // an exposed private key e.g. sig verification.
                // Does NOT allow scalars higher than CURVE.n.
                key: "multiplyUnsafe",
                value: function multiplyUnsafe(scalar) {
                    var n = assertGE0(scalar); // 0 <= scalar < CURVE.n
                    if (n === $2bcb0cd052759051$var$_0n) return I;
                    if (this.equals(I) || n === $2bcb0cd052759051$var$_1n) return this;
                    if (this.equals(G)) return this.wNAF(n).p;
                    return wnaf.unsafeLadder(this, n);
                }
            },
            {
                // Checks if point is of small order.
                // If you add something to small order point, you will have "dirty"
                // point with torsion component.
                // Multiplies point by cofactor and checks if the result is 0.
                key: "isSmallOrder",
                value: function isSmallOrder() {
                    return this.multiplyUnsafe(cofactor).is0();
                }
            },
            {
                // Multiplies point by curve order and checks if the result is 0.
                // Returns `false` is the point is dirty.
                key: "isTorsionFree",
                value: function isTorsionFree() {
                    return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
                }
            },
            {
                // Converts Extended point to default (x, y) coordinates.
                // Can accept precomputed Z^-1 - for example, from invertBatch.
                key: "toAffine",
                value: function toAffine(iz) {
                    var _this = this, x = _this.ex, y = _this.ey, z = _this.ez;
                    var is0 = this.is0();
                    if (iz == null) iz = is0 ? $2bcb0cd052759051$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
                    var ax = modP(x * iz);
                    var ay = modP(y * iz);
                    var zz = modP(z * iz);
                    if (is0) return {
                        x: $2bcb0cd052759051$var$_0n,
                        y: $2bcb0cd052759051$var$_1n
                    };
                    if (zz !== $2bcb0cd052759051$var$_1n) throw new Error("invZ was invalid");
                    return {
                        x: ax,
                        y: ay
                    };
                }
            },
            {
                key: "clearCofactor",
                value: function clearCofactor() {
                    var cofactor = CURVE.h;
                    if (cofactor === $2bcb0cd052759051$var$_1n) return this;
                    return this.multiplyUnsafe(cofactor);
                }
            },
            {
                key: "toRawBytes",
                value: function toRawBytes() {
                    var _this_toAffine = this.toAffine(), x = _this_toAffine.x, y = _this_toAffine.y;
                    var bytes = $1YtXk.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
                    bytes[bytes.length - 1] |= x & $2bcb0cd052759051$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
                    return bytes; // and use the last byte to encode sign of x
                }
            },
            {
                key: "toHex",
                value: function toHex() {
                    return $1YtXk.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
                }
            }
        ], [
            {
                key: "fromAffine",
                value: function fromAffine(p) {
                    if (p instanceof Point) throw new Error("extended point not allowed");
                    var _ref = p || {}, x = _ref.x, y = _ref.y;
                    if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
                    return new Point(x, y, $2bcb0cd052759051$var$_1n, modP(x * y));
                }
            },
            {
                key: "normalizeZ",
                value: function normalizeZ(points) {
                    var toInv = Fp.invertBatch(points.map(function(p) {
                        return p.ez;
                    }));
                    return points.map(function(p, i) {
                        return p.toAffine(toInv[i]);
                    }).map(Point.fromAffine);
                }
            },
            {
                key: "fromHex",
                value: // Converts hash string or Uint8Array to Point.
                // Uses algo from RFC8032 5.1.3.
                function fromHex(hex) {
                    var zip215 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var d = CURVE.d, a = CURVE.a;
                    var len = Fp.BYTES;
                    hex = (0, $1YtXk.ensureBytes)("pointHex", hex, len); // copy hex to a new array
                    var normed = hex.slice(); // copy again, we'll manipulate it
                    var lastByte = hex[len - 1]; // select last byte
                    normed[len - 1] = lastByte & -129; // clear last bit
                    var y = $1YtXk.bytesToNumberLE(normed);
                    if (y === $2bcb0cd052759051$var$_0n) ;
                    else // RFC8032 prohibits >= p, but ZIP215 doesn't
                    if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
                    else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
                    // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
                    // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
                    var y2 = modP(y * y); // denominator is always non-0 mod p.
                    var u = modP(y2 - $2bcb0cd052759051$var$_1n); // u = y² - 1
                    var v = modP(d * y2 - a); // v = d y² + 1.
                    var _uvRatio = uvRatio(u, v), isValid = _uvRatio.isValid, x = _uvRatio.value; // √(u/v)
                    if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
                    var isXOdd = (x & $2bcb0cd052759051$var$_1n) === $2bcb0cd052759051$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
                    var isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
                    if (!zip215 && x === $2bcb0cd052759051$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
                    throw new Error("Point.fromHex: x=0 and x_0=1");
                    if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
                    return Point.fromAffine({
                        x: x,
                        y: y
                    });
                }
            },
            {
                key: "fromPrivateKey",
                value: function fromPrivateKey(privKey) {
                    return getExtendedPublicKey(privKey).point;
                }
            }
        ]);
        return Point;
    }();
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $2bcb0cd052759051$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($2bcb0cd052759051$var$_0n, $2bcb0cd052759051$var$_1n, $2bcb0cd052759051$var$_1n, $2bcb0cd052759051$var$_0n); // 0, 1, 1, 0
    var G = Point.BASE, I = Point.ZERO;
    var wnaf = (0, $bUKt0.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $ev04Q.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($1YtXk.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        var len = nByteLength;
        key = (0, $1YtXk.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        var hashed = (0, $1YtXk.ensureBytes)("hashed private key", cHash(key), 2 * len);
        var head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        var prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        var scalar = modN_LE(head); // The actual private scalar
        var point = G.multiply(scalar); // Point on Edwards curve aka public key
        var pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar() {
        var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Uint8Array();
        for(var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            msgs[_key - 1] = arguments[_key];
        }
        var _ut;
        var msg = (_ut = $1YtXk).concatBytes.apply(_ut, (0, $gF0bR._)(msgs));
        return modN_LE(cHash(domain(msg, (0, $1YtXk.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        msg = (0, $1YtXk.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        var _getExtendedPublicKey = getExtendedPublicKey(privKey), prefix = _getExtendedPublicKey.prefix, scalar = _getExtendedPublicKey.scalar, pointBytes = _getExtendedPublicKey.pointBytes;
        var r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        var R = G.multiply(r).toRawBytes(); // R = rG
        var k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        var s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        var res = $1YtXk.concatBytes(R, $1YtXk.numberToBytesLE(s, Fp.BYTES));
        return (0, $1YtXk.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    var verifyOpts = $2bcb0cd052759051$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey) {
        var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : verifyOpts;
        var context = options.context, zip215 = options.zip215;
        var len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $1YtXk.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $1YtXk.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        var s = $1YtXk.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        var A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        var k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        var RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    var utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: function() {
            return randomBytes(Fp.BYTES);
        },
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute: function() {
            var windowSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8, point = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Point.BASE;
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}


var $7ecabfc5fa04abcb$exports = {};

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $5OlIx = parcelRequire("5OlIx");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty($7ecabfc5fa04abcb$exports, "__esModule", {
    value: true
});
$7ecabfc5fa04abcb$exports.expand_message_xmd = $7ecabfc5fa04abcb$var$expand_message_xmd;
$7ecabfc5fa04abcb$exports.expand_message_xof = $7ecabfc5fa04abcb$var$expand_message_xof;
$7ecabfc5fa04abcb$exports.hash_to_field = $7ecabfc5fa04abcb$var$hash_to_field;
$7ecabfc5fa04abcb$exports.isogenyMap = $7ecabfc5fa04abcb$var$isogenyMap;
$7ecabfc5fa04abcb$exports.createHasher = $7ecabfc5fa04abcb$var$createHasher;

var $ev04Q = parcelRequire("ev04Q");

var $1YtXk = parcelRequire("1YtXk");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
var $7ecabfc5fa04abcb$var$os2ip = $1YtXk.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $7ecabfc5fa04abcb$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error("bad I2OSP call: value=".concat(value, " length=").concat(length));
    var res = Array.from({
        length: length
    }).fill(0);
    for(var i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $7ecabfc5fa04abcb$var$strxor(a, b) {
    var arr = new Uint8Array(a.length);
    for(var i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $7ecabfc5fa04abcb$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $7ecabfc5fa04abcb$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, $1YtXk.abytes)(msg);
    (0, $1YtXk.abytes)(DST);
    $7ecabfc5fa04abcb$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $1YtXk.concatBytes)((0, $1YtXk.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    var b_in_bytes = H.outputLen, r_in_bytes = H.blockLen;
    var ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    var DST_prime = (0, $1YtXk.concatBytes)(DST, $7ecabfc5fa04abcb$var$i2osp(DST.length, 1));
    var Z_pad = $7ecabfc5fa04abcb$var$i2osp(0, r_in_bytes);
    var l_i_b_str = $7ecabfc5fa04abcb$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    var b = new Array(ell);
    var b_0 = H((0, $1YtXk.concatBytes)(Z_pad, msg, l_i_b_str, $7ecabfc5fa04abcb$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $1YtXk.concatBytes)(b_0, $7ecabfc5fa04abcb$var$i2osp(1, 1), DST_prime));
    for(var i = 1; i <= ell; i++){
        var args = [
            $7ecabfc5fa04abcb$var$strxor(b_0, b[i - 1]),
            $7ecabfc5fa04abcb$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $1YtXk.concatBytes).apply(this, (0, $gF0bR._)(args)));
    }
    var pseudo_random_bytes = (0, $1YtXk.concatBytes).apply(this, (0, $gF0bR._)(b));
    return pseudo_random_bytes.slice(0, lenInBytes);
}
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $7ecabfc5fa04abcb$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, $1YtXk.abytes)(msg);
    (0, $1YtXk.abytes)(DST);
    $7ecabfc5fa04abcb$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        var dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $1YtXk.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($7ecabfc5fa04abcb$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($7ecabfc5fa04abcb$var$i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $7ecabfc5fa04abcb$var$hash_to_field(msg, count, options) {
    (0, $1YtXk.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    var p = options.p, k = options.k, m = options.m, hash = options.hash, expand = options.expand, _DST = options.DST;
    (0, $1YtXk.abytes)(msg);
    $7ecabfc5fa04abcb$var$anum(count);
    var DST = typeof _DST === "string" ? (0, $1YtXk.utf8ToBytes)(_DST) : _DST;
    var log2p = p.toString(2).length;
    var L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    var len_in_bytes = count * m * L;
    var prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $7ecabfc5fa04abcb$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $7ecabfc5fa04abcb$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    var u = new Array(count);
    for(var i = 0; i < count; i++){
        var e = new Array(m);
        for(var j = 0; j < m; j++){
            var elm_offset = L * (j + i * m);
            var tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $ev04Q.mod)($7ecabfc5fa04abcb$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $7ecabfc5fa04abcb$var$isogenyMap(field, map) {
    // Make same order as in spec
    var COEFF = map.map(function(i) {
        return Array.from(i).reverse();
    });
    return function(x, y) {
        var _COEFF_map = (0, $5OlIx._)(COEFF.map(function(val) {
            return val.reduce(function(acc, i) {
                return field.add(field.mul(acc, x), i);
            });
        }), 4), xNum = _COEFF_map[0], xDen = _COEFF_map[1], yNum = _COEFF_map[2], yDen = _COEFF_map[3];
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $7ecabfc5fa04abcb$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve: function(msg, options) {
            var u = $7ecabfc5fa04abcb$var$hash_to_field(msg, 2, (0, $4JCw4._)((0, $gddcW._)((0, $4JCw4._)({}, def), {
                DST: def.DST
            }), options));
            var u0 = Point.fromAffine(mapToCurve(u[0]));
            var u1 = Point.fromAffine(mapToCurve(u[1]));
            var P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve: function(msg, options) {
            var u = $7ecabfc5fa04abcb$var$hash_to_field(msg, 1, (0, $4JCw4._)((0, $gddcW._)((0, $4JCw4._)({}, def), {
                DST: def.encodeDST
            }), options));
            var P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve: function(scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = scalars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if ((typeof i === "undefined" ? "undefined" : (0, $aVMuR._)(i)) !== "bigint") throw new Error("mapToCurve: expected array of bigints, got ".concat(i, " in array"));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}



var $ev04Q = parcelRequire("ev04Q");
var $050b8fb64a85cc50$exports = {};

var $4JCw4 = parcelRequire("4JCw4");

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty($050b8fb64a85cc50$exports, "__esModule", {
    value: true
});
$050b8fb64a85cc50$exports.montgomery = $050b8fb64a85cc50$var$montgomery;

var $ev04Q = parcelRequire("ev04Q");

var $1YtXk = parcelRequire("1YtXk");
var $050b8fb64a85cc50$var$_0n = BigInt(0);
var $050b8fb64a85cc50$var$_1n = BigInt(1);
function $050b8fb64a85cc50$var$validateOpts(curve) {
    (0, $1YtXk.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze((0, $4JCw4._)({}, curve));
}
// NOTE: not really montgomery curve, just bunch of very specific methods for X25519/X448 (RFC 7748, https://www.rfc-editor.org/rfc/rfc7748)
// Uses only one coordinate instead of two
function $050b8fb64a85cc50$var$montgomery(curveDef) {
    var CURVE = $050b8fb64a85cc50$var$validateOpts(curveDef);
    var P = CURVE.P;
    var modP = function(n) {
        return (0, $ev04Q.mod)(n, P);
    };
    var montgomeryBits = CURVE.montgomeryBits;
    var montgomeryBytes = Math.ceil(montgomeryBits / 8);
    var fieldLen = CURVE.nByteLength;
    var adjustScalarBytes = CURVE.adjustScalarBytes || function(bytes) {
        return bytes;
    };
    var powPminus2 = CURVE.powPminus2 || function(x) {
        return (0, $ev04Q.pow)(x, P - BigInt(2), P);
    };
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        var dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if ((typeof n === "undefined" ? "undefined" : (0, $aVMuR._)(n)) === "bigint" && $050b8fb64a85cc50$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    var a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        var u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        var k = assertFieldElement(scalar);
        var x_1 = u;
        var x_2 = $050b8fb64a85cc50$var$_1n;
        var z_2 = $050b8fb64a85cc50$var$_0n;
        var x_3 = u;
        var z_3 = $050b8fb64a85cc50$var$_1n;
        var swap = $050b8fb64a85cc50$var$_0n;
        var sw;
        for(var t = BigInt(montgomeryBits - 1); t >= $050b8fb64a85cc50$var$_0n; t--){
            var k_t = k >> t & $050b8fb64a85cc50$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            var A = x_2 + z_2;
            var AA = modP(A * A);
            var B = x_2 - z_2;
            var BB = modP(B * B);
            var E = AA - BB;
            var C = x_3 + z_3;
            var D = x_3 - z_3;
            var DA = modP(D * A);
            var CB = modP(C * B);
            var dacb = DA + CB;
            var da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        var z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $1YtXk.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        var u = (0, $1YtXk.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $1YtXk.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        var bytes = (0, $1YtXk.ensureBytes)("scalar", n);
        var len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error("Expected ".concat(montgomeryBytes, " or ").concat(fieldLen, " bytes, got ").concat(len));
        return (0, $1YtXk.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        var pointU = decodeUCoordinate(u);
        var _scalar = decodeScalar(scalar);
        var pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $050b8fb64a85cc50$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    var GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: function(privateKey, publicKey) {
            return scalarMult(privateKey, publicKey);
        },
        getPublicKey: function(privateKey) {
            return scalarMultBase(privateKey);
        },
        utils: {
            randomPrivateKey: function() {
                return CURVE.randomBytes(CURVE.nByteLength);
            }
        },
        GuBytes: GuBytes
    };
}



var $1YtXk = parcelRequire("1YtXk");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ var $c0ad2f99ab67211e$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
var $c0ad2f99ab67211e$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
var $c0ad2f99ab67211e$var$_0n = BigInt(0), $c0ad2f99ab67211e$var$_1n = BigInt(1), $c0ad2f99ab67211e$var$_2n = BigInt(2), $c0ad2f99ab67211e$var$_3n = BigInt(3);
// prettier-ignore
var $c0ad2f99ab67211e$var$_5n = BigInt(5), $c0ad2f99ab67211e$var$_8n = BigInt(8);
function $c0ad2f99ab67211e$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    var _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    var P = $c0ad2f99ab67211e$var$ED25519_P;
    var x2 = x * x % P;
    var b2 = x2 * x % P; // x^3, 11
    var b4 = (0, $ev04Q.pow2)(b2, $c0ad2f99ab67211e$var$_2n, P) * b2 % P; // x^15, 1111
    var b5 = (0, $ev04Q.pow2)(b4, $c0ad2f99ab67211e$var$_1n, P) * x % P; // x^31
    var b10 = (0, $ev04Q.pow2)(b5, $c0ad2f99ab67211e$var$_5n, P) * b5 % P;
    var b20 = (0, $ev04Q.pow2)(b10, _10n, P) * b10 % P;
    var b40 = (0, $ev04Q.pow2)(b20, _20n, P) * b20 % P;
    var b80 = (0, $ev04Q.pow2)(b40, _40n, P) * b40 % P;
    var b160 = (0, $ev04Q.pow2)(b80, _80n, P) * b80 % P;
    var b240 = (0, $ev04Q.pow2)(b160, _80n, P) * b80 % P;
    var b250 = (0, $ev04Q.pow2)(b240, _10n, P) * b10 % P;
    var pow_p_5_8 = (0, $ev04Q.pow2)(b250, $c0ad2f99ab67211e$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $c0ad2f99ab67211e$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $c0ad2f99ab67211e$var$uvRatio(u, v) {
    var P = $c0ad2f99ab67211e$var$ED25519_P;
    var v3 = (0, $ev04Q.mod)(v * v * v, P); // v³
    var v7 = (0, $ev04Q.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    var pow = $c0ad2f99ab67211e$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    var x = (0, $ev04Q.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    var vx2 = (0, $ev04Q.mod)(v * x * x, P); // vx²
    var root1 = x; // First root candidate
    var root2 = (0, $ev04Q.mod)(x * $c0ad2f99ab67211e$var$ED25519_SQRT_M1, P); // Second root candidate
    var useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    var useRoot2 = vx2 === (0, $ev04Q.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    var noRoot = vx2 === (0, $ev04Q.mod)(-u * $c0ad2f99ab67211e$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $ev04Q.isNegativeLE)(x, P)) x = (0, $ev04Q.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
// Just in case
$c0ad2f99ab67211e$exports.ED25519_TORSION_SUBGROUP = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
var $c0ad2f99ab67211e$var$Fp = /* @__PURE__ */ function() {
    return (0, $ev04Q.Field)($c0ad2f99ab67211e$var$ED25519_P, undefined, true);
}();
var $c0ad2f99ab67211e$var$ed25519Defaults = /* @__PURE__ */ function() {
    return {
        // Param: a
        a: BigInt(-1),
        // d is equal to -121665/121666 over finite field.
        // Negative number is P - number, and division is invert(number, P)
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
        Fp: $c0ad2f99ab67211e$var$Fp,
        // Subgroup order: how many points curve has
        // 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        // Cofactor
        h: $c0ad2f99ab67211e$var$_8n,
        // Base point (x, y) aka generator point
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: $b647a6fb65a37e6c$exports.sha512,
        randomBytes: $84f9351876d022a0$exports.randomBytes,
        adjustScalarBytes: $c0ad2f99ab67211e$var$adjustScalarBytes,
        // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        uvRatio: $c0ad2f99ab67211e$var$uvRatio
    };
}();
$c0ad2f99ab67211e$exports.ed25519 = function() {
    return (0, $2bcb0cd052759051$exports.twistedEdwards)($c0ad2f99ab67211e$var$ed25519Defaults);
}();
function $c0ad2f99ab67211e$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $84f9351876d022a0$exports.concatBytes)((0, $84f9351876d022a0$exports.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
$c0ad2f99ab67211e$exports.ed25519ctx = function() {
    return (0, $2bcb0cd052759051$exports.twistedEdwards)((0, $gddcW._)((0, $4JCw4._)({}, $c0ad2f99ab67211e$var$ed25519Defaults), {
        domain: $c0ad2f99ab67211e$var$ed25519_domain
    }));
}();
$c0ad2f99ab67211e$exports.ed25519ph = function() {
    return (0, $2bcb0cd052759051$exports.twistedEdwards)(Object.assign({}, $c0ad2f99ab67211e$var$ed25519Defaults, {
        domain: $c0ad2f99ab67211e$var$ed25519_domain,
        prehash: $b647a6fb65a37e6c$exports.sha512
    }));
}();
$c0ad2f99ab67211e$exports.x25519 = function() {
    return (0, $050b8fb64a85cc50$exports.montgomery)({
        P: $c0ad2f99ab67211e$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: function(x) {
            var P = $c0ad2f99ab67211e$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            var _ed25519_pow_2_252_3 = $c0ad2f99ab67211e$var$ed25519_pow_2_252_3(x), pow_p_5_8 = _ed25519_pow_2_252_3.pow_p_5_8, b2 = _ed25519_pow_2_252_3.b2;
            return (0, $ev04Q.mod)((0, $ev04Q.pow2)(pow_p_5_8, $c0ad2f99ab67211e$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $c0ad2f99ab67211e$var$adjustScalarBytes,
        randomBytes: $84f9351876d022a0$exports.randomBytes
    });
}();
/**
 * Converts ed25519 public key to x25519 public key. Uses formula:
 * * `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
 * * `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
 * @example
 *   const someonesPub = ed25519.getPublicKey(ed25519.utils.randomPrivateKey());
 *   const aPriv = x25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(aPriv, edwardsToMontgomeryPub(someonesPub))
 */ function $c0ad2f99ab67211e$var$edwardsToMontgomeryPub(edwardsPub) {
    var y = $c0ad2f99ab67211e$exports.ed25519.ExtendedPoint.fromHex(edwardsPub).y;
    var _1n = BigInt(1);
    return $c0ad2f99ab67211e$var$Fp.toBytes($c0ad2f99ab67211e$var$Fp.create((_1n + y) * $c0ad2f99ab67211e$var$Fp.inv(_1n - y)));
}
$c0ad2f99ab67211e$exports.edwardsToMontgomery = $c0ad2f99ab67211e$var$edwardsToMontgomeryPub; // deprecated
/**
 * Converts ed25519 secret key to x25519 secret key.
 * @example
 *   const someonesPub = x25519.getPublicKey(x25519.utils.randomPrivateKey());
 *   const aPriv = ed25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(edwardsToMontgomeryPriv(aPriv), someonesPub)
 */ function $c0ad2f99ab67211e$var$edwardsToMontgomeryPriv(edwardsPriv) {
    var hashed = $c0ad2f99ab67211e$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $c0ad2f99ab67211e$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
var $c0ad2f99ab67211e$var$ELL2_C1 = /* @__PURE__ */ function() {
    return ($c0ad2f99ab67211e$var$Fp.ORDER + $c0ad2f99ab67211e$var$_3n) / $c0ad2f99ab67211e$var$_8n;
}(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
var $c0ad2f99ab67211e$var$ELL2_C2 = /* @__PURE__ */ function() {
    return $c0ad2f99ab67211e$var$Fp.pow($c0ad2f99ab67211e$var$_2n, $c0ad2f99ab67211e$var$ELL2_C1);
}(); // 2. c2 = 2^c1
var $c0ad2f99ab67211e$var$ELL2_C3 = /* @__PURE__ */ function() {
    return $c0ad2f99ab67211e$var$Fp.sqrt($c0ad2f99ab67211e$var$Fp.neg($c0ad2f99ab67211e$var$Fp.ONE));
}(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $c0ad2f99ab67211e$var$map_to_curve_elligator2_curve25519(u) {
    var ELL2_C4 = ($c0ad2f99ab67211e$var$Fp.ORDER - $c0ad2f99ab67211e$var$_5n) / $c0ad2f99ab67211e$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    var ELL2_J = BigInt(486662);
    var tv1 = $c0ad2f99ab67211e$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $c0ad2f99ab67211e$var$Fp.mul(tv1, $c0ad2f99ab67211e$var$_2n); //  2.  tv1 = 2 * tv1
    var xd = $c0ad2f99ab67211e$var$Fp.add(tv1, $c0ad2f99ab67211e$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    var x1n = $c0ad2f99ab67211e$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    var tv2 = $c0ad2f99ab67211e$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    var gxd = $c0ad2f99ab67211e$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    var gx1 = $c0ad2f99ab67211e$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $c0ad2f99ab67211e$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $c0ad2f99ab67211e$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $c0ad2f99ab67211e$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    var tv3 = $c0ad2f99ab67211e$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $c0ad2f99ab67211e$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $c0ad2f99ab67211e$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $c0ad2f99ab67211e$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $c0ad2f99ab67211e$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    var y11 = $c0ad2f99ab67211e$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $c0ad2f99ab67211e$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    var y12 = $c0ad2f99ab67211e$var$Fp.mul(y11, $c0ad2f99ab67211e$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $c0ad2f99ab67211e$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $c0ad2f99ab67211e$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    var e1 = $c0ad2f99ab67211e$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    var y1 = $c0ad2f99ab67211e$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    var x2n = $c0ad2f99ab67211e$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    var y21 = $c0ad2f99ab67211e$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $c0ad2f99ab67211e$var$Fp.mul(y21, $c0ad2f99ab67211e$var$ELL2_C2); //  25. y21 = y21 * c2
    var y22 = $c0ad2f99ab67211e$var$Fp.mul(y21, $c0ad2f99ab67211e$var$ELL2_C3); //  26. y22 = y21 * c3
    var gx2 = $c0ad2f99ab67211e$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $c0ad2f99ab67211e$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $c0ad2f99ab67211e$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    var e2 = $c0ad2f99ab67211e$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    var y2 = $c0ad2f99ab67211e$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $c0ad2f99ab67211e$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $c0ad2f99ab67211e$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    var e3 = $c0ad2f99ab67211e$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    var xn = $c0ad2f99ab67211e$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    var y = $c0ad2f99ab67211e$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    var e4 = $c0ad2f99ab67211e$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $c0ad2f99ab67211e$var$Fp.cmov(y, $c0ad2f99ab67211e$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $c0ad2f99ab67211e$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
var $c0ad2f99ab67211e$var$ELL2_C1_EDWARDS = /* @__PURE__ */ function() {
    return (0, $ev04Q.FpSqrtEven)($c0ad2f99ab67211e$var$Fp, $c0ad2f99ab67211e$var$Fp.neg(BigInt(486664)));
}(); // sgn0(c1) MUST equal 0
function $c0ad2f99ab67211e$var$map_to_curve_elligator2_edwards25519(u) {
    var _map_to_curve_elligator2_curve25519 = $c0ad2f99ab67211e$var$map_to_curve_elligator2_curve25519(u), xMn = _map_to_curve_elligator2_curve25519.xMn, xMd = _map_to_curve_elligator2_curve25519.xMd, yMn = _map_to_curve_elligator2_curve25519.yMn, yMd = _map_to_curve_elligator2_curve25519.yMd; //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    var xn = $c0ad2f99ab67211e$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $c0ad2f99ab67211e$var$Fp.mul(xn, $c0ad2f99ab67211e$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    var xd = $c0ad2f99ab67211e$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    var yn = $c0ad2f99ab67211e$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    var yd = $c0ad2f99ab67211e$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    var tv1 = $c0ad2f99ab67211e$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    var e = $c0ad2f99ab67211e$var$Fp.eql(tv1, $c0ad2f99ab67211e$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $c0ad2f99ab67211e$var$Fp.cmov(xn, $c0ad2f99ab67211e$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $c0ad2f99ab67211e$var$Fp.cmov(xd, $c0ad2f99ab67211e$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $c0ad2f99ab67211e$var$Fp.cmov(yn, $c0ad2f99ab67211e$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $c0ad2f99ab67211e$var$Fp.cmov(yd, $c0ad2f99ab67211e$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    var inv = $c0ad2f99ab67211e$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $c0ad2f99ab67211e$var$Fp.mul(xn, inv[0]),
        y: $c0ad2f99ab67211e$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
var $c0ad2f99ab67211e$var$htf = /* @__PURE__ */ function() {
    return (0, $7ecabfc5fa04abcb$exports.createHasher)($c0ad2f99ab67211e$exports.ed25519.ExtendedPoint, function(scalars) {
        return $c0ad2f99ab67211e$var$map_to_curve_elligator2_edwards25519(scalars[0]);
    }, {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $c0ad2f99ab67211e$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $b647a6fb65a37e6c$exports.sha512
    });
}();
$c0ad2f99ab67211e$exports.hashToCurve = function() {
    return $c0ad2f99ab67211e$var$htf.hashToCurve;
}();
$c0ad2f99ab67211e$exports.encodeToCurve = function() {
    return $c0ad2f99ab67211e$var$htf.encodeToCurve;
}();
function $c0ad2f99ab67211e$var$assertRstPoint(other) {
    if (!(other instanceof $c0ad2f99ab67211e$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
var $c0ad2f99ab67211e$var$SQRT_M1 = $c0ad2f99ab67211e$var$ED25519_SQRT_M1;
// √(ad - 1)
var $c0ad2f99ab67211e$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
var $c0ad2f99ab67211e$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
var $c0ad2f99ab67211e$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
var $c0ad2f99ab67211e$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
var $c0ad2f99ab67211e$var$invertSqrt = function(number) {
    return $c0ad2f99ab67211e$var$uvRatio($c0ad2f99ab67211e$var$_1n, number);
};
var $c0ad2f99ab67211e$var$MAX_255B = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var $c0ad2f99ab67211e$var$bytes255ToNumberLE = function(bytes) {
    return $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.create((0, $1YtXk.bytesToNumberLE)(bytes) & $c0ad2f99ab67211e$var$MAX_255B);
};
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $c0ad2f99ab67211e$var$calcElligatorRistrettoMap(r0) {
    var d = $c0ad2f99ab67211e$exports.ed25519.CURVE.d;
    var P = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.ORDER;
    var mod = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.create;
    var r = mod($c0ad2f99ab67211e$var$SQRT_M1 * r0 * r0); // 1
    var Ns = mod((r + $c0ad2f99ab67211e$var$_1n) * $c0ad2f99ab67211e$var$ONE_MINUS_D_SQ); // 2
    var c = BigInt(-1); // 3
    var D = mod((c - d * r) * mod(r + d)); // 4
    var _uvRatio = $c0ad2f99ab67211e$var$uvRatio(Ns, D), Ns_D_is_sq = _uvRatio.isValid, s = _uvRatio.value; // 5
    var s_ = mod(s * r0); // 6
    if (!(0, $ev04Q.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    var Nt = mod(c * (r - $c0ad2f99ab67211e$var$_1n) * $c0ad2f99ab67211e$var$D_MINUS_ONE_SQ - D); // 9
    var s2 = s * s;
    var W0 = mod((s + s) * D); // 10
    var W1 = mod(Nt * $c0ad2f99ab67211e$var$SQRT_AD_MINUS_ONE); // 11
    var W2 = mod($c0ad2f99ab67211e$var$_1n - s2); // 12
    var W3 = mod($c0ad2f99ab67211e$var$_1n + s2); // 13
    return new $c0ad2f99ab67211e$exports.ed25519.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ var $c0ad2f99ab67211e$var$RistPoint = /*#__PURE__*/ function() {
    function RistPoint(ep) {
        (0, $7dKN1._)(this, RistPoint);
        this.ep = ep;
    }
    (0, $eW5pA._)(RistPoint, [
        {
            /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ key: "toRawBytes",
            value: function toRawBytes() {
                var _this_ep = this.ep, x = _this_ep.ex, y = _this_ep.ey, z = _this_ep.ez, t = _this_ep.et;
                var P = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.ORDER;
                var mod = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.create;
                var u1 = mod(mod(z + y) * mod(z - y)); // 1
                var u2 = mod(x * y); // 2
                // Square root always exists
                var u2sq = mod(u2 * u2);
                var _invertSqrt = $c0ad2f99ab67211e$var$invertSqrt(mod(u1 * u2sq)), invsqrt = _invertSqrt.value; // 3
                var D1 = mod(invsqrt * u1); // 4
                var D2 = mod(invsqrt * u2); // 5
                var zInv = mod(D1 * D2 * t); // 6
                var D; // 7
                if ((0, $ev04Q.isNegativeLE)(t * zInv, P)) {
                    var _x = mod(y * $c0ad2f99ab67211e$var$SQRT_M1);
                    var _y = mod(x * $c0ad2f99ab67211e$var$SQRT_M1);
                    x = _x;
                    y = _y;
                    D = mod(D1 * $c0ad2f99ab67211e$var$INVSQRT_A_MINUS_D);
                } else D = D2; // 8
                if ((0, $ev04Q.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
                var s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
                if ((0, $ev04Q.isNegativeLE)(s, P)) s = mod(-s);
                return (0, $1YtXk.numberToBytesLE)(s, 32); // 11
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return (0, $1YtXk.bytesToHex)(this.toRawBytes());
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.toHex();
            }
        },
        {
            // Compare one point to another.
            key: "equals",
            value: function equals(other) {
                $c0ad2f99ab67211e$var$assertRstPoint(other);
                var _this_ep = this.ep, X1 = _this_ep.ex, Y1 = _this_ep.ey;
                var _other_ep = other.ep, X2 = _other_ep.ex, Y2 = _other_ep.ey;
                var mod = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.create;
                // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
                var one = mod(X1 * Y2) === mod(Y1 * X2);
                var two = mod(Y1 * Y2) === mod(X1 * X2);
                return one || two;
            }
        },
        {
            key: "add",
            value: function add(other) {
                $c0ad2f99ab67211e$var$assertRstPoint(other);
                return new RistPoint(this.ep.add(other.ep));
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                $c0ad2f99ab67211e$var$assertRstPoint(other);
                return new RistPoint(this.ep.subtract(other.ep));
            }
        },
        {
            key: "multiply",
            value: function multiply(scalar) {
                return new RistPoint(this.ep.multiply(scalar));
            }
        },
        {
            key: "multiplyUnsafe",
            value: function multiplyUnsafe(scalar) {
                return new RistPoint(this.ep.multiplyUnsafe(scalar));
            }
        },
        {
            key: "double",
            value: function double() {
                return new RistPoint(this.ep.double());
            }
        },
        {
            key: "negate",
            value: function negate() {
                return new RistPoint(this.ep.negate());
            }
        }
    ], [
        {
            key: "fromAffine",
            value: function fromAffine(ap) {
                return new RistPoint($c0ad2f99ab67211e$exports.ed25519.ExtendedPoint.fromAffine(ap));
            }
        },
        {
            key: "hashToCurve",
            value: /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ function hashToCurve(hex) {
                hex = (0, $1YtXk.ensureBytes)("ristrettoHash", hex, 64);
                var r1 = $c0ad2f99ab67211e$var$bytes255ToNumberLE(hex.slice(0, 32));
                var R1 = $c0ad2f99ab67211e$var$calcElligatorRistrettoMap(r1);
                var r2 = $c0ad2f99ab67211e$var$bytes255ToNumberLE(hex.slice(32, 64));
                var R2 = $c0ad2f99ab67211e$var$calcElligatorRistrettoMap(r2);
                return new RistPoint(R1.add(R2));
            }
        },
        {
            key: "fromHex",
            value: /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ function fromHex(hex) {
                hex = (0, $1YtXk.ensureBytes)("ristrettoHex", hex, 32);
                var _exports_ed25519_CURVE = $c0ad2f99ab67211e$exports.ed25519.CURVE, a = _exports_ed25519_CURVE.a, d = _exports_ed25519_CURVE.d;
                var P = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.ORDER;
                var mod = $c0ad2f99ab67211e$exports.ed25519.CURVE.Fp.create;
                var emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
                var s = $c0ad2f99ab67211e$var$bytes255ToNumberLE(hex);
                // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
                // 3. Check that s is non-negative, or else abort
                if (!(0, $1YtXk.equalBytes)((0, $1YtXk.numberToBytesLE)(s, 32), hex) || (0, $ev04Q.isNegativeLE)(s, P)) throw new Error(emsg);
                var s2 = mod(s * s);
                var u1 = mod($c0ad2f99ab67211e$var$_1n + a * s2); // 4 (a is -1)
                var u2 = mod($c0ad2f99ab67211e$var$_1n - a * s2); // 5
                var u1_2 = mod(u1 * u1);
                var u2_2 = mod(u2 * u2);
                var v = mod(a * d * u1_2 - u2_2); // 6
                var _invertSqrt = $c0ad2f99ab67211e$var$invertSqrt(mod(v * u2_2)), isValid = _invertSqrt.isValid, I = _invertSqrt.value; // 7
                var Dx = mod(I * u2); // 8
                var Dy = mod(I * Dx * v); // 9
                var x = mod((s + s) * Dx); // 10
                if ((0, $ev04Q.isNegativeLE)(x, P)) x = mod(-x); // 10
                var y = mod(u1 * Dy); // 11
                var t = mod(x * y); // 12
                if (!isValid || (0, $ev04Q.isNegativeLE)(t, P) || y === $c0ad2f99ab67211e$var$_0n) throw new Error(emsg);
                return new RistPoint(new $c0ad2f99ab67211e$exports.ed25519.ExtendedPoint(x, y, $c0ad2f99ab67211e$var$_1n, t));
            }
        }
    ]);
    return RistPoint;
}();
$c0ad2f99ab67211e$exports.RistrettoPoint = function() {
    if (!$c0ad2f99ab67211e$var$RistPoint.BASE) $c0ad2f99ab67211e$var$RistPoint.BASE = new $c0ad2f99ab67211e$var$RistPoint($c0ad2f99ab67211e$exports.ed25519.ExtendedPoint.BASE);
    if (!$c0ad2f99ab67211e$var$RistPoint.ZERO) $c0ad2f99ab67211e$var$RistPoint.ZERO = new $c0ad2f99ab67211e$var$RistPoint($c0ad2f99ab67211e$exports.ed25519.ExtendedPoint.ZERO);
    return $c0ad2f99ab67211e$var$RistPoint;
}();
// Hashing to ristretto255. https://www.rfc-editor.org/rfc/rfc9380#appendix-B
var $c0ad2f99ab67211e$var$hashToRistretto255 = function(msg, options) {
    var d = options.DST;
    var DST = typeof d === "string" ? (0, $84f9351876d022a0$exports.utf8ToBytes)(d) : d;
    var uniform_bytes = (0, $7ecabfc5fa04abcb$exports.expand_message_xmd)(msg, DST, 64, $b647a6fb65a37e6c$exports.sha512);
    var P = $c0ad2f99ab67211e$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
$c0ad2f99ab67211e$exports.hashToRistretto255 = $c0ad2f99ab67211e$var$hashToRistretto255;
$c0ad2f99ab67211e$exports.hash_to_ristretto255 = $c0ad2f99ab67211e$exports.hashToRistretto255; // legacy



var $fzie2 = parcelRequire("fzie2");

var $gYRJ8 = parcelRequire("gYRJ8");

var $116141357f49ed92$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $a7gqy = parcelRequire("a7gqy");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");

var $ilnag = parcelRequire("ilnag");
var $116141357f49ed92$require$Buffer = $ilnag.Buffer;
"use strict";
var $116141357f49ed92$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $116141357f49ed92$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $116141357f49ed92$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $116141357f49ed92$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $116141357f49ed92$var$__createBinding(result, mod, k);
    }
    $116141357f49ed92$var$__setModuleDefault(result, mod);
    return result;
};
var $116141357f49ed92$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($116141357f49ed92$exports, "__esModule", {
    value: true
});
$116141357f49ed92$exports.deserializeUnchecked = $116141357f49ed92$exports.deserialize = $116141357f49ed92$exports.serialize = $116141357f49ed92$exports.BinaryReader = $116141357f49ed92$exports.BinaryWriter = $116141357f49ed92$exports.BorshError = $116141357f49ed92$exports.baseDecode = $116141357f49ed92$exports.baseEncode = void 0;

var $116141357f49ed92$var$bn_js_1 = $116141357f49ed92$var$__importDefault((parcelRequire("ar2eu")));

var $116141357f49ed92$var$bs58_1 = $116141357f49ed92$var$__importDefault((parcelRequire("gYRJ8")));

// TODO: Make sure this polyfill not included when not required
var $116141357f49ed92$var$encoding = $116141357f49ed92$var$__importStar((parcelRequire("lV5eT")));
var $116141357f49ed92$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $116141357f49ed92$var$encoding.TextDecoder : TextDecoder;
var $116141357f49ed92$var$textDecoder = new $116141357f49ed92$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $116141357f49ed92$var$baseEncode(value) {
    if (typeof value === "string") value = $116141357f49ed92$require$Buffer.from(value, "utf8");
    return $116141357f49ed92$var$bs58_1.default.encode($116141357f49ed92$require$Buffer.from(value));
}
$116141357f49ed92$exports.baseEncode = $116141357f49ed92$var$baseEncode;
function $116141357f49ed92$var$baseDecode(value) {
    return $116141357f49ed92$require$Buffer.from($116141357f49ed92$var$bs58_1.default.decode(value));
}
$116141357f49ed92$exports.baseDecode = $116141357f49ed92$var$baseDecode;
var $116141357f49ed92$var$INITIAL_LENGTH = 1024;
var $116141357f49ed92$var$BorshError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(BorshError, Error1);
    var _super = (0, $hKD8n._)(BorshError);
    function BorshError(message) {
        (0, $7dKN1._)(this, BorshError);
        var _this;
        _this = _super.call(this, message);
        _this.fieldPath = [];
        _this.originalMessage = message;
        return _this;
    }
    (0, $eW5pA._)(BorshError, [
        {
            key: "addToFieldPath",
            value: function addToFieldPath(fieldName) {
                this.fieldPath.splice(0, 0, fieldName);
                // NOTE: Modifying message directly as jest doesn't use .toString()
                this.message = this.originalMessage + ": " + this.fieldPath.join(".");
            }
        }
    ]);
    return BorshError;
}((0, $jShW9._)(Error));
$116141357f49ed92$exports.BorshError = $116141357f49ed92$var$BorshError;
/// Binary encoder.
var $116141357f49ed92$var$BinaryWriter = /*#__PURE__*/ function() {
    "use strict";
    function BinaryWriter() {
        (0, $7dKN1._)(this, BinaryWriter);
        this.buf = $116141357f49ed92$require$Buffer.alloc($116141357f49ed92$var$INITIAL_LENGTH);
        this.length = 0;
    }
    (0, $eW5pA._)(BinaryWriter, [
        {
            key: "maybeResize",
            value: function maybeResize() {
                if (this.buf.length < 16 + this.length) this.buf = $116141357f49ed92$require$Buffer.concat([
                    this.buf,
                    $116141357f49ed92$require$Buffer.alloc($116141357f49ed92$var$INITIAL_LENGTH)
                ]);
            }
        },
        {
            key: "writeU8",
            value: function writeU8(value) {
                this.maybeResize();
                this.buf.writeUInt8(value, this.length);
                this.length += 1;
            }
        },
        {
            key: "writeU16",
            value: function writeU16(value) {
                this.maybeResize();
                this.buf.writeUInt16LE(value, this.length);
                this.length += 2;
            }
        },
        {
            key: "writeU32",
            value: function writeU32(value) {
                this.maybeResize();
                this.buf.writeUInt32LE(value, this.length);
                this.length += 4;
            }
        },
        {
            key: "writeU64",
            value: function writeU64(value) {
                this.maybeResize();
                this.writeBuffer($116141357f49ed92$require$Buffer.from(new $116141357f49ed92$var$bn_js_1.default(value).toArray("le", 8)));
            }
        },
        {
            key: "writeU128",
            value: function writeU128(value) {
                this.maybeResize();
                this.writeBuffer($116141357f49ed92$require$Buffer.from(new $116141357f49ed92$var$bn_js_1.default(value).toArray("le", 16)));
            }
        },
        {
            key: "writeU256",
            value: function writeU256(value) {
                this.maybeResize();
                this.writeBuffer($116141357f49ed92$require$Buffer.from(new $116141357f49ed92$var$bn_js_1.default(value).toArray("le", 32)));
            }
        },
        {
            key: "writeU512",
            value: function writeU512(value) {
                this.maybeResize();
                this.writeBuffer($116141357f49ed92$require$Buffer.from(new $116141357f49ed92$var$bn_js_1.default(value).toArray("le", 64)));
            }
        },
        {
            key: "writeBuffer",
            value: function writeBuffer(buffer) {
                // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
                this.buf = $116141357f49ed92$require$Buffer.concat([
                    $116141357f49ed92$require$Buffer.from(this.buf.subarray(0, this.length)),
                    buffer,
                    $116141357f49ed92$require$Buffer.alloc($116141357f49ed92$var$INITIAL_LENGTH)
                ]);
                this.length += buffer.length;
            }
        },
        {
            key: "writeString",
            value: function writeString(str) {
                this.maybeResize();
                var b = $116141357f49ed92$require$Buffer.from(str, "utf8");
                this.writeU32(b.length);
                this.writeBuffer(b);
            }
        },
        {
            key: "writeFixedArray",
            value: function writeFixedArray(array) {
                this.writeBuffer($116141357f49ed92$require$Buffer.from(array));
            }
        },
        {
            key: "writeArray",
            value: function writeArray(array, fn) {
                this.maybeResize();
                this.writeU32(array.length);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var elem = _step.value;
                        this.maybeResize();
                        fn(elem);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.buf.subarray(0, this.length);
            }
        }
    ]);
    return BinaryWriter;
}();
$116141357f49ed92$exports.BinaryWriter = $116141357f49ed92$var$BinaryWriter;
function $116141357f49ed92$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    var originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                var code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $116141357f49ed92$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
var $116141357f49ed92$var$BinaryReader = /*#__PURE__*/ function() {
    "use strict";
    function BinaryReader(buf) {
        (0, $7dKN1._)(this, BinaryReader);
        this.buf = buf;
        this.offset = 0;
    }
    (0, $eW5pA._)(BinaryReader, [
        {
            key: "readU8",
            value: function readU8() {
                var value = this.buf.readUInt8(this.offset);
                this.offset += 1;
                return value;
            }
        },
        {
            key: "readU16",
            value: function readU16() {
                var value = this.buf.readUInt16LE(this.offset);
                this.offset += 2;
                return value;
            }
        },
        {
            key: "readU32",
            value: function readU32() {
                var value = this.buf.readUInt32LE(this.offset);
                this.offset += 4;
                return value;
            }
        },
        {
            key: "readU64",
            value: function readU64() {
                var buf = this.readBuffer(8);
                return new $116141357f49ed92$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU128",
            value: function readU128() {
                var buf = this.readBuffer(16);
                return new $116141357f49ed92$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU256",
            value: function readU256() {
                var buf = this.readBuffer(32);
                return new $116141357f49ed92$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU512",
            value: function readU512() {
                var buf = this.readBuffer(64);
                return new $116141357f49ed92$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readBuffer",
            value: function readBuffer(len) {
                if (this.offset + len > this.buf.length) throw new $116141357f49ed92$var$BorshError("Expected buffer length ".concat(len, " isn't within bounds"));
                var result = this.buf.slice(this.offset, this.offset + len);
                this.offset += len;
                return result;
            }
        },
        {
            key: "readString",
            value: function readString() {
                var len = this.readU32();
                var buf = this.readBuffer(len);
                try {
                    // NOTE: Using TextDecoder to fail on invalid UTF-8
                    return $116141357f49ed92$var$textDecoder.decode(buf);
                } catch (e) {
                    throw new $116141357f49ed92$var$BorshError("Error decoding UTF-8 string: ".concat(e));
                }
            }
        },
        {
            key: "readFixedArray",
            value: function readFixedArray(len) {
                return new Uint8Array(this.readBuffer(len));
            }
        },
        {
            key: "readArray",
            value: function readArray(fn) {
                var len = this.readU32();
                var result = Array();
                for(var i = 0; i < len; ++i)result.push(fn());
                return result;
            }
        }
    ]);
    return BinaryReader;
}();
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU8", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU16", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU32", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU64", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU128", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU256", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readU512", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readString", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readFixedArray", null);
$116141357f49ed92$var$__decorate([
    $116141357f49ed92$var$handlingRangeError
], $116141357f49ed92$var$BinaryReader.prototype, "readArray", null);
$116141357f49ed92$exports.BinaryReader = $116141357f49ed92$var$BinaryReader;
function $116141357f49ed92$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $116141357f49ed92$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer["write".concat($116141357f49ed92$var$capitalizeFirstLetter(fieldType))](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $116141357f49ed92$var$BorshError("Expecting byte array of length ".concat(fieldType[0], ", but got ").concat(value.length, " bytes"));
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $116141357f49ed92$var$BorshError("Expecting byte array of length ".concat(fieldType[1], ", but got ").concat(value.length, " bytes"));
                for(var i = 0; i < fieldType[1]; i++)$116141357f49ed92$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, function(item) {
                $116141357f49ed92$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $116141357f49ed92$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach(function(val, key) {
                    $116141357f49ed92$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $116141357f49ed92$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $116141357f49ed92$var$BorshError("FieldType ".concat(fieldType, " unrecognized"));
        }
        else $116141357f49ed92$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $116141357f49ed92$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $116141357f49ed92$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    var structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $116141357f49ed92$var$BorshError("Class ".concat(obj.constructor.name, " is missing in schema"));
    if (structSchema.kind === "struct") structSchema.fields.map(function(param) {
        var _param = (0, $5OlIx._)(param, 2), fieldName = _param[0], fieldType = _param[1];
        $116141357f49ed92$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        var name = obj[structSchema.field];
        for(var idx = 0; idx < structSchema.values.length; ++idx){
            var _structSchema_values_idx = (0, $5OlIx._)(structSchema.values[idx], 2), fieldName = _structSchema_values_idx[0], fieldType = _structSchema_values_idx[1];
            if (fieldName === name) {
                writer.writeU8(idx);
                $116141357f49ed92$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $116141357f49ed92$var$BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(obj.constructor.name));
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $116141357f49ed92$var$serialize(schema, obj) {
    var Writer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $116141357f49ed92$var$BinaryWriter;
    var writer = new Writer();
    $116141357f49ed92$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
$116141357f49ed92$exports.serialize = $116141357f49ed92$var$serialize;
function $116141357f49ed92$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader["read".concat($116141357f49ed92$var$capitalizeFirstLetter(fieldType))]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                var arr = [];
                for(var i = 0; i < fieldType[1]; i++)arr.push($116141357f49ed92$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(function() {
                return $116141357f49ed92$var$deserializeField(schema, fieldName, fieldType[0], reader);
            });
        }
        if (fieldType.kind === "option") {
            var option = reader.readU8();
            if (option) return $116141357f49ed92$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            var map = new Map();
            var length = reader.readU32();
            for(var i1 = 0; i1 < length; i1++){
                var key = $116141357f49ed92$var$deserializeField(schema, fieldName, fieldType.key, reader);
                var val = $116141357f49ed92$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $116141357f49ed92$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $116141357f49ed92$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $116141357f49ed92$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    var structSchema = schema.get(classType);
    if (!structSchema) throw new $116141357f49ed92$var$BorshError("Class ".concat(classType.name, " is missing in schema"));
    if (structSchema.kind === "struct") {
        var result = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = schema.get(classType).fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $5OlIx._)(_step.value, 2), fieldName = _step_value[0], fieldType = _step_value[1];
                result[fieldName] = $116141357f49ed92$var$deserializeField(schema, fieldName, fieldType, reader);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        var idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $116141357f49ed92$var$BorshError("Enum index: ".concat(idx, " is out of range"));
        var _structSchema_values_idx = (0, $5OlIx._)(structSchema.values[idx], 2), fieldName1 = _structSchema_values_idx[0], fieldType1 = _structSchema_values_idx[1];
        var fieldValue = $116141357f49ed92$var$deserializeField(schema, fieldName1, fieldType1, reader);
        return new classType((0, $a7gqy._)({}, fieldName1, fieldValue));
    }
    throw new $116141357f49ed92$var$BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(classType.constructor.name));
}
/// Deserializes object from bytes using schema.
function $116141357f49ed92$var$deserialize(schema, classType, buffer) {
    var Reader = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $116141357f49ed92$var$BinaryReader;
    var reader = new Reader(buffer);
    var result = $116141357f49ed92$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $116141357f49ed92$var$BorshError("Unexpected ".concat(buffer.length - reader.offset, " bytes after deserialized data"));
    return result;
}
$116141357f49ed92$exports.deserialize = $116141357f49ed92$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $116141357f49ed92$var$deserializeUnchecked(schema, classType, buffer) {
    var Reader = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $116141357f49ed92$var$BinaryReader;
    var reader = new Reader(buffer);
    return $116141357f49ed92$var$deserializeStruct(schema, classType, reader);
}
$116141357f49ed92$exports.deserializeUnchecked = $116141357f49ed92$var$deserializeUnchecked;



var $i4x6j = parcelRequire("i4x6j");
var $cf4fc149d7ee5705$exports = {};

var $ilnag = parcelRequire("ilnag");
var $cf4fc149d7ee5705$require$Buffer = $ilnag.Buffer;
"use strict";
Object.defineProperty($cf4fc149d7ee5705$exports, "__esModule", {
    value: true
});
var $cf4fc149d7ee5705$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $cf4fc149d7ee5705$var$toBigIntLE(buf) {
    {
        var reversed = $cf4fc149d7ee5705$require$Buffer.from(buf);
        reversed.reverse();
        var hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt("0x".concat(hex));
    }
    return $cf4fc149d7ee5705$var$converter.toBigInt(buf, false);
}
$cf4fc149d7ee5705$exports.toBigIntLE = $cf4fc149d7ee5705$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $cf4fc149d7ee5705$var$toBigIntBE(buf) {
    {
        var hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt("0x".concat(hex));
    }
    return $cf4fc149d7ee5705$var$converter.toBigInt(buf, true);
}
$cf4fc149d7ee5705$exports.toBigIntBE = $cf4fc149d7ee5705$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $cf4fc149d7ee5705$var$toBufferLE(num, width) {
    {
        var hex = num.toString(16);
        var buffer = $cf4fc149d7ee5705$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $cf4fc149d7ee5705$var$converter.fromBigInt(num, $cf4fc149d7ee5705$require$Buffer.allocUnsafe(width), false);
}
$cf4fc149d7ee5705$exports.toBufferLE = $cf4fc149d7ee5705$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $cf4fc149d7ee5705$var$toBufferBE(num, width) {
    {
        var hex = num.toString(16);
        return $cf4fc149d7ee5705$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $cf4fc149d7ee5705$var$converter.fromBigInt(num, $cf4fc149d7ee5705$require$Buffer.allocUnsafe(width), true);
}
$cf4fc149d7ee5705$exports.toBufferBE = $cf4fc149d7ee5705$var$toBufferBE;



var $91bj2 = parcelRequire("91bj2");
var $978213d9094d7b3e$exports = {};
"use strict";
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ea34f57c85148d43$var$getRandomValues;
var $ea34f57c85148d43$var$rnds8 = new Uint8Array(16);
function $ea34f57c85148d43$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ea34f57c85148d43$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ea34f57c85148d43$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ea34f57c85148d43$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ea34f57c85148d43$var$getRandomValues($ea34f57c85148d43$var$rnds8);
}


var $5bd18ca22f8da591$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $ae87bd2232572044$var$validate(uuid) {
    return typeof uuid === "string" && (0, $5bd18ca22f8da591$export$2e2bcd8739ae039).test(uuid);
}
var $ae87bd2232572044$export$2e2bcd8739ae039 = $ae87bd2232572044$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $32446ba9caa1da44$var$byteToHex = [];
for(var $32446ba9caa1da44$var$i = 0; $32446ba9caa1da44$var$i < 256; ++$32446ba9caa1da44$var$i)$32446ba9caa1da44$var$byteToHex.push(($32446ba9caa1da44$var$i + 0x100).toString(16).substr(1));
function $32446ba9caa1da44$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($32446ba9caa1da44$var$byteToHex[arr[offset + 0]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 1]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 2]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 3]] + "-" + $32446ba9caa1da44$var$byteToHex[arr[offset + 4]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 5]] + "-" + $32446ba9caa1da44$var$byteToHex[arr[offset + 6]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 7]] + "-" + $32446ba9caa1da44$var$byteToHex[arr[offset + 8]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 9]] + "-" + $32446ba9caa1da44$var$byteToHex[arr[offset + 10]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 11]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 12]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 13]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 14]] + $32446ba9caa1da44$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $ae87bd2232572044$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $32446ba9caa1da44$export$2e2bcd8739ae039 = $32446ba9caa1da44$var$stringify;


function $67b79514c8138e3c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $ea34f57c85148d43$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $32446ba9caa1da44$export$2e2bcd8739ae039)(rnds);
}
var $67b79514c8138e3c$export$2e2bcd8739ae039 = $67b79514c8138e3c$var$v4;


var $978213d9094d7b3e$require$uuid = $67b79514c8138e3c$export$2e2bcd8739ae039;
var $79efc39ad438d0fe$exports = {};
"use strict";

var $79efc39ad438d0fe$require$uuid = $67b79514c8138e3c$export$2e2bcd8739ae039;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ var $79efc39ad438d0fe$var$generateRequest = function generateRequest(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    var version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    var request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        var generator = typeof options.generator === "function" ? options.generator : function generator() {
            return $79efc39ad438d0fe$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
$79efc39ad438d0fe$exports = $79efc39ad438d0fe$var$generateRequest;


/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ var $978213d9094d7b3e$var$ClientBrowser = function ClientBrowser1(callServer, options) {
    if (!(this instanceof $978213d9094d7b3e$var$ClientBrowser)) return new $978213d9094d7b3e$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $978213d9094d7b3e$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
$978213d9094d7b3e$exports = $978213d9094d7b3e$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $978213d9094d7b3e$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    var self = this;
    var request = null;
    // is this a batch request?
    var isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    var isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        var hasCallback = typeof callback === "function";
        try {
            request = $79efc39ad438d0fe$exports(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    var message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $978213d9094d7b3e$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    var response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            var isError = function isError(res) {
                return typeof res.error !== "undefined";
            };
            var isNotError = function isNotError(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};



var $b9zO9 = parcelRequire("b9zO9");

var $6rBFC = parcelRequire("6rBFC");

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $a7gqy = parcelRequire("a7gqy");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $bL8uU = parcelRequire("bL8uU");

var $hKD8n = parcelRequire("hKD8n");

var $6qu4b = parcelRequire("6qu4b");

var $ilnag = parcelRequire("ilnag");
var $d1cfbeee367a53a3$exports = {};
"use strict";
var $d1cfbeee367a53a3$var$has = Object.prototype.hasOwnProperty, $d1cfbeee367a53a3$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $d1cfbeee367a53a3$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $d1cfbeee367a53a3$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $d1cfbeee367a53a3$var$Events().__proto__) $d1cfbeee367a53a3$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $d1cfbeee367a53a3$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $d1cfbeee367a53a3$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $d1cfbeee367a53a3$var$EE(fn, context || emitter, once), evt = $d1cfbeee367a53a3$var$prefix ? $d1cfbeee367a53a3$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $d1cfbeee367a53a3$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $d1cfbeee367a53a3$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $d1cfbeee367a53a3$var$EventEmitter() {
    this._events = new $d1cfbeee367a53a3$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($d1cfbeee367a53a3$var$has.call(events, name)) names.push($d1cfbeee367a53a3$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $d1cfbeee367a53a3$var$prefix ? $d1cfbeee367a53a3$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $d1cfbeee367a53a3$var$prefix ? $d1cfbeee367a53a3$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $d1cfbeee367a53a3$var$prefix ? $d1cfbeee367a53a3$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $d1cfbeee367a53a3$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $d1cfbeee367a53a3$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $d1cfbeee367a53a3$var$prefix ? $d1cfbeee367a53a3$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $d1cfbeee367a53a3$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $d1cfbeee367a53a3$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $d1cfbeee367a53a3$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d1cfbeee367a53a3$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $d1cfbeee367a53a3$var$prefix ? $d1cfbeee367a53a3$var$prefix + event : event;
        if (this._events[evt]) $d1cfbeee367a53a3$var$clearEvent(this, evt);
    } else {
        this._events = new $d1cfbeee367a53a3$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$d1cfbeee367a53a3$var$EventEmitter.prototype.off = $d1cfbeee367a53a3$var$EventEmitter.prototype.removeListener;
$d1cfbeee367a53a3$var$EventEmitter.prototype.addListener = $d1cfbeee367a53a3$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$d1cfbeee367a53a3$var$EventEmitter.prefixed = $d1cfbeee367a53a3$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$d1cfbeee367a53a3$var$EventEmitter.EventEmitter = $d1cfbeee367a53a3$var$EventEmitter;
$d1cfbeee367a53a3$exports = $d1cfbeee367a53a3$var$EventEmitter;


// node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
var $1e85a2f8427b8fbd$var$WebSocketBrowserImpl = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $cgJ2Y._)(WebSocketBrowserImpl, EventEmitter);
    var _super = (0, $hKD8n._)(WebSocketBrowserImpl);
    function WebSocketBrowserImpl(address, options, protocols) {
        (0, $7dKN1._)(this, WebSocketBrowserImpl);
        var _this;
        _this = _super.call(this);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "socket", void 0);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    (0, $eW5pA._)(WebSocketBrowserImpl, [
        {
            /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */ key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */ key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}((0, $d1cfbeee367a53a3$exports.EventEmitter));
function $1e85a2f8427b8fbd$export$3909fb301d3dc8c9(address, options) {
    return new $1e85a2f8427b8fbd$var$WebSocketBrowserImpl(address, options);
}
// src/lib/utils.ts
var $1e85a2f8427b8fbd$export$9fd32f4b4353d82d = /*#__PURE__*/ function() {
    "use strict";
    function DefaultDataPack() {
        (0, $7dKN1._)(this, DefaultDataPack);
    }
    (0, $eW5pA._)(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
// src/lib/client.ts
var $1e85a2f8427b8fbd$export$b43a6d9568fa5272 = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $cgJ2Y._)(CommonClient, EventEmitter);
    var _super = (0, $hKD8n._)(CommonClient);
    function CommonClient(webSocketFactory) {
        var address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ws://localhost:8080", _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, generate_request_id = arguments.length > 3 ? arguments[3] : void 0, dataPack = arguments.length > 4 ? arguments[4] : void 0;
        (0, $7dKN1._)(this, CommonClient);
        var _this;
        var _param_autoconnect = _param.autoconnect, autoconnect = _param_autoconnect === void 0 ? true : _param_autoconnect, _param_reconnect = _param.reconnect, reconnect = _param_reconnect === void 0 ? true : _param_reconnect, _param_reconnect_interval = _param.reconnect_interval, reconnect_interval = _param_reconnect_interval === void 0 ? 1e3 : _param_reconnect_interval, _param_max_reconnects = _param.max_reconnects, max_reconnects = _param_max_reconnects === void 0 ? 5 : _param_max_reconnects, rest_options = (0, $bL8uU._)(_param, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "address", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "rpc_id", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "queue", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "options", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "autoconnect", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "ready", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "reconnect", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "reconnect_timer_id", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "reconnect_interval", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "max_reconnects", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "rest_options", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "current_reconnects", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "generate_request_id", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "socket", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "webSocketFactory", void 0);
        (0, $a7gqy._)((0, $b9zO9._)(_this), "dataPack", void 0);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = void 0;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $1e85a2f8427b8fbd$export$9fd32f4b4353d82d();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, (0, $4JCw4._)({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    (0, $eW5pA._)(CommonClient, [
        {
            /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */ key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, (0, $4JCw4._)({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */ key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this = this;
                if (!ws_opts && "object" === typeof timeout) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || void 0,
                        id: rpc_id
                    };
                    _this.socket.send(_this.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */ function login(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var resp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.call("rpc.login", params)
                                ];
                            case 1:
                                resp = _state.sent();
                                if (!resp) throw new Error("authentication failed");
                                return [
                                    2,
                                    resp
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listMethods",
            value: /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */ function listMethods() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.call("__listMethods")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */ key: "notify",
            value: function notify(method, params) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!_this.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this.socket.send(_this.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ function subscribe(event) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                return [
                                    4,
                                    _this.call("rpc.on", event)
                                ];
                            case 1:
                                result = _state.sent();
                                if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unsubscribe",
            value: /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ function unsubscribe(event) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                return [
                                    4,
                                    _this.call("rpc.off", event)
                                ];
                            case 1:
                                result = _state.sent();
                                if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed unsubscribing from an event with: " + result);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */ key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1e3, data);
            }
        },
        {
            /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */ key: "setAutoReconnect",
            value: function setAutoReconnect(reconnect) {
                this.reconnect = reconnect;
            }
        },
        {
            /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */ key: "setReconnectInterval",
            value: function setReconnectInterval(interval) {
                this.reconnect_interval = interval;
            }
        },
        {
            /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */ key: "setMaxReconnects",
            value: function setMaxReconnects(max_reconnects) {
                this.max_reconnects = max_reconnects;
            }
        },
        {
            /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */ key: "_connect",
            value: function _connect(address, options) {
                var _this = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this.ready = true;
                    _this.emit("open");
                    _this.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(param) {
                    var message = param.data;
                    if (message instanceof ArrayBuffer) message = (0, $ilnag.Buffer).from(message).toString();
                    try {
                        message = _this.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    if (message.notification && _this.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        return Promise.resolve().then(function() {
                            _this.emit.apply(_this, args);
                        });
                    }
                    if (!_this.queue[message.id]) {
                        if (message.method) return Promise.resolve().then(function() {
                            _this.emit(message.method, message === null || message === void 0 ? void 0 : message.params);
                        });
                        return;
                    }
                    if ("error" in message === "result" in message) _this.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this.queue[message.id].timeout) clearTimeout(_this.queue[message.id].timeout);
                    if (message.error) _this.queue[message.id].promise[1](message.error);
                    else _this.queue[message.id].promise[0](message.result);
                    delete _this.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this.emit("error", error);
                });
                this.socket.addEventListener("close", function(param) {
                    var code = param.code, reason = param.reason;
                    if (_this.ready) setTimeout(function() {
                        return _this.emit("close", code, reason);
                    }, 0);
                    _this.ready = false;
                    _this.socket = void 0;
                    if (code === 1e3) return;
                    _this.current_reconnects++;
                    if (_this.reconnect && (_this.max_reconnects > _this.current_reconnects || _this.max_reconnects === 0)) _this.reconnect_timer_id = setTimeout(function() {
                        return _this._connect(address, options);
                    }, _this.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}((0, $d1cfbeee367a53a3$exports.EventEmitter));
// src/index.browser.ts
var $1e85a2f8427b8fbd$export$1f2bb630327ac4b6 = /*#__PURE__*/ function(CommonClient) {
    "use strict";
    (0, $cgJ2Y._)(Client, CommonClient);
    var _super = (0, $hKD8n._)(Client);
    function Client() {
        var address = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ws://localhost:8080", _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_autoconnect = _ref.autoconnect, autoconnect = _ref_autoconnect === void 0 ? true : _ref_autoconnect, _ref_reconnect = _ref.reconnect, reconnect = _ref_reconnect === void 0 ? true : _ref_reconnect, _ref_reconnect_interval = _ref.reconnect_interval, reconnect_interval = _ref_reconnect_interval === void 0 ? 1e3 : _ref_reconnect_interval, _ref_max_reconnects = _ref.max_reconnects, max_reconnects = _ref_max_reconnects === void 0 ? 5 : _ref_max_reconnects, generate_request_id = arguments.length > 2 ? arguments[2] : void 0;
        (0, $7dKN1._)(this, Client);
        return _super.call(this, $1e85a2f8427b8fbd$export$3909fb301d3dc8c9, address, {
            autoconnect: autoconnect,
            reconnect: reconnect,
            reconnect_interval: reconnect_interval,
            max_reconnects: max_reconnects
        }, generate_request_id);
    }
    return Client;
}($1e85a2f8427b8fbd$export$b43a6d9568fa5272);
 //# sourceMappingURL=out.js.map


var $7db8000d9da7abf9$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $5OlIx = parcelRequire("5OlIx");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($7db8000d9da7abf9$exports, "__esModule", {
    value: true
});
$7db8000d9da7abf9$exports.shake256 = $7db8000d9da7abf9$exports.shake128 = $7db8000d9da7abf9$exports.keccak_512 = $7db8000d9da7abf9$exports.keccak_384 = $7db8000d9da7abf9$exports.keccak_256 = $7db8000d9da7abf9$exports.keccak_224 = $7db8000d9da7abf9$exports.sha3_512 = $7db8000d9da7abf9$exports.sha3_384 = $7db8000d9da7abf9$exports.sha3_256 = $7db8000d9da7abf9$exports.sha3_224 = $7db8000d9da7abf9$exports.Keccak = $7db8000d9da7abf9$exports.keccakP = void 0;



// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
var $7db8000d9da7abf9$var$SHA3_PI = [];
var $7db8000d9da7abf9$var$SHA3_ROTL = [];
var $7db8000d9da7abf9$var$_SHA3_IOTA = [];
var $7db8000d9da7abf9$var$_0n = /* @__PURE__ */ BigInt(0);
var $7db8000d9da7abf9$var$_1n = /* @__PURE__ */ BigInt(1);
var $7db8000d9da7abf9$var$_2n = /* @__PURE__ */ BigInt(2);
var $7db8000d9da7abf9$var$_7n = /* @__PURE__ */ BigInt(7);
var $7db8000d9da7abf9$var$_256n = /* @__PURE__ */ BigInt(256);
var $7db8000d9da7abf9$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(var $7db8000d9da7abf9$var$round = 0, $7db8000d9da7abf9$var$R = $7db8000d9da7abf9$var$_1n, $7db8000d9da7abf9$var$x = 1, $7db8000d9da7abf9$var$y = 0; $7db8000d9da7abf9$var$round < 24; $7db8000d9da7abf9$var$round++){
    var $7db8000d9da7abf9$var$ref;
    // Pi
    $7db8000d9da7abf9$var$ref = [
        $7db8000d9da7abf9$var$y,
        (2 * $7db8000d9da7abf9$var$x + 3 * $7db8000d9da7abf9$var$y) % 5
    ], $7db8000d9da7abf9$var$x = $7db8000d9da7abf9$var$ref[0], $7db8000d9da7abf9$var$y = $7db8000d9da7abf9$var$ref[1], $7db8000d9da7abf9$var$ref;
    $7db8000d9da7abf9$var$SHA3_PI.push(2 * (5 * $7db8000d9da7abf9$var$y + $7db8000d9da7abf9$var$x));
    // Rotational
    $7db8000d9da7abf9$var$SHA3_ROTL.push(($7db8000d9da7abf9$var$round + 1) * ($7db8000d9da7abf9$var$round + 2) / 2 % 64);
    // Iota
    var $7db8000d9da7abf9$var$t = $7db8000d9da7abf9$var$_0n;
    for(var $7db8000d9da7abf9$var$j = 0; $7db8000d9da7abf9$var$j < 7; $7db8000d9da7abf9$var$j++){
        $7db8000d9da7abf9$var$R = ($7db8000d9da7abf9$var$R << $7db8000d9da7abf9$var$_1n ^ ($7db8000d9da7abf9$var$R >> $7db8000d9da7abf9$var$_7n) * $7db8000d9da7abf9$var$_0x71n) % $7db8000d9da7abf9$var$_256n;
        if ($7db8000d9da7abf9$var$R & $7db8000d9da7abf9$var$_2n) $7db8000d9da7abf9$var$t ^= $7db8000d9da7abf9$var$_1n << ($7db8000d9da7abf9$var$_1n << /* @__PURE__ */ BigInt($7db8000d9da7abf9$var$j)) - $7db8000d9da7abf9$var$_1n;
    }
    $7db8000d9da7abf9$var$_SHA3_IOTA.push($7db8000d9da7abf9$var$t);
}
var $7db8000d9da7abf9$var$_ref = (0, $5OlIx._)(/* @__PURE__ */ (0, $56477cbf0e8d09c2$exports.split)($7db8000d9da7abf9$var$_SHA3_IOTA, true), 2), $7db8000d9da7abf9$var$SHA3_IOTA_H = $7db8000d9da7abf9$var$_ref[0], $7db8000d9da7abf9$var$SHA3_IOTA_L = $7db8000d9da7abf9$var$_ref[1];
// Left rotation (without 0, 32, 64)
var $7db8000d9da7abf9$var$rotlH = function(h, l, s) {
    return s > 32 ? (0, $56477cbf0e8d09c2$exports.rotlBH)(h, l, s) : (0, $56477cbf0e8d09c2$exports.rotlSH)(h, l, s);
};
var $7db8000d9da7abf9$var$rotlL = function(h, l, s) {
    return s > 32 ? (0, $56477cbf0e8d09c2$exports.rotlBL)(h, l, s) : (0, $56477cbf0e8d09c2$exports.rotlSL)(h, l, s);
};
// Same as keccakf1600, but allows to skip some rounds
function $7db8000d9da7abf9$var$keccakP(s) {
    var rounds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(var round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(var x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(var x1 = 0; x1 < 10; x1 += 2){
            var idx1 = (x1 + 8) % 10;
            var idx0 = (x1 + 2) % 10;
            var B0 = B[idx0];
            var B1 = B[idx0 + 1];
            var Th = $7db8000d9da7abf9$var$rotlH(B0, B1, 1) ^ B[idx1];
            var Tl = $7db8000d9da7abf9$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(var y = 0; y < 50; y += 10){
                s[x1 + y] ^= Th;
                s[x1 + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        var curH = s[2];
        var curL = s[3];
        for(var t = 0; t < 24; t++){
            var shift = $7db8000d9da7abf9$var$SHA3_ROTL[t];
            var Th1 = $7db8000d9da7abf9$var$rotlH(curH, curL, shift);
            var Tl1 = $7db8000d9da7abf9$var$rotlL(curH, curL, shift);
            var PI = $7db8000d9da7abf9$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th1;
            s[PI + 1] = Tl1;
        }
        // Chi (χ)
        for(var y1 = 0; y1 < 50; y1 += 10){
            for(var x2 = 0; x2 < 10; x2++)B[x2] = s[y1 + x2];
            for(var x3 = 0; x3 < 10; x3++)s[y1 + x3] ^= ~B[(x3 + 2) % 10] & B[(x3 + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $7db8000d9da7abf9$var$SHA3_IOTA_H[round];
        s[1] ^= $7db8000d9da7abf9$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$7db8000d9da7abf9$exports.keccakP = $7db8000d9da7abf9$var$keccakP;
var $7db8000d9da7abf9$var$Keccak = /*#__PURE__*/ function(_utils_js_1_Hash) {
    (0, $cgJ2Y._)(Keccak, _utils_js_1_Hash);
    var _super = (0, $hKD8n._)(Keccak);
    function Keccak(blockLen, suffix, outputLen) {
        var enableXOF = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, rounds = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 24;
        (0, $7dKN1._)(this, Keccak);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.suffix = suffix;
        _this.outputLen = outputLen;
        _this.enableXOF = enableXOF;
        _this.rounds = rounds;
        _this.pos = 0;
        _this.posOut = 0;
        _this.finished = false;
        _this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $87bc1d41ebb7f232$exports.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= _this.blockLen || _this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        _this.state = new Uint8Array(200);
        _this.state32 = (0, $84f9351876d022a0$exports.u32)(_this.state);
        return _this;
    }
    (0, $eW5pA._)(Keccak, [
        {
            key: "keccak",
            value: function keccak() {
                if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(this.state32);
                $7db8000d9da7abf9$var$keccakP(this.state32, this.rounds);
                if (!$84f9351876d022a0$exports.isLE) (0, $84f9351876d022a0$exports.byteSwap32)(this.state32);
                this.posOut = 0;
                this.pos = 0;
            }
        },
        {
            key: "update",
            value: function update(data) {
                (0, $87bc1d41ebb7f232$exports.exists)(this);
                var _this = this, blockLen = _this.blockLen, state = _this.state;
                data = (0, $84f9351876d022a0$exports.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    for(var i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
                    if (this.pos === blockLen) this.keccak();
                }
                return this;
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.finished) return;
                this.finished = true;
                var _this = this, state = _this.state, suffix = _this.suffix, pos = _this.pos, blockLen = _this.blockLen;
                // Do the padding
                state[pos] ^= suffix;
                if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
                state[blockLen - 1] ^= 0x80;
                this.keccak();
            }
        },
        {
            key: "writeInto",
            value: function writeInto(out) {
                (0, $87bc1d41ebb7f232$exports.exists)(this, false);
                (0, $87bc1d41ebb7f232$exports.bytes)(out);
                this.finish();
                var bufferOut = this.state;
                var blockLen = this.blockLen;
                for(var pos = 0, len = out.length; pos < len;){
                    if (this.posOut >= blockLen) this.keccak();
                    var take = Math.min(blockLen - this.posOut, len - pos);
                    out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
                    this.posOut += take;
                    pos += take;
                }
                return out;
            }
        },
        {
            key: "xofInto",
            value: function xofInto(out) {
                // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
                if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                return this.writeInto(out);
            }
        },
        {
            key: "xof",
            value: function xof(bytes) {
                (0, $87bc1d41ebb7f232$exports.number)(bytes);
                return this.xofInto(new Uint8Array(bytes));
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $87bc1d41ebb7f232$exports.output)(out, this);
                if (this.finished) throw new Error("digest() was already called");
                this.writeInto(out);
                this.destroy();
                return out;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.digestInto(new Uint8Array(this.outputLen));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.state.fill(0);
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _this = this, blockLen = _this.blockLen, suffix = _this.suffix, outputLen = _this.outputLen, rounds = _this.rounds, enableXOF = _this.enableXOF;
                to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
                to.state32.set(this.state32);
                to.pos = this.pos;
                to.posOut = this.posOut;
                to.finished = this.finished;
                to.rounds = rounds;
                // Suffix can change in cSHAKE
                to.suffix = suffix;
                to.outputLen = outputLen;
                to.enableXOF = enableXOF;
                to.destroyed = this.destroyed;
                return to;
            }
        }
    ]);
    return Keccak;
}($84f9351876d022a0$exports.Hash);
$7db8000d9da7abf9$exports.Keccak = $7db8000d9da7abf9$var$Keccak;
var $7db8000d9da7abf9$var$gen = function(suffix, blockLen, outputLen) {
    return (0, $84f9351876d022a0$exports.wrapConstructor)(function() {
        return new $7db8000d9da7abf9$var$Keccak(blockLen, suffix, outputLen);
    });
};
$7db8000d9da7abf9$exports.sha3_224 = $7db8000d9da7abf9$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $7db8000d9da7abf9$exports.sha3_256 = $7db8000d9da7abf9$var$gen(0x06, 136, 32);
$7db8000d9da7abf9$exports.sha3_384 = $7db8000d9da7abf9$var$gen(0x06, 104, 48);
$7db8000d9da7abf9$exports.sha3_512 = $7db8000d9da7abf9$var$gen(0x06, 72, 64);
$7db8000d9da7abf9$exports.keccak_224 = $7db8000d9da7abf9$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $7db8000d9da7abf9$exports.keccak_256 = $7db8000d9da7abf9$var$gen(0x01, 136, 32);
$7db8000d9da7abf9$exports.keccak_384 = $7db8000d9da7abf9$var$gen(0x01, 104, 48);
$7db8000d9da7abf9$exports.keccak_512 = $7db8000d9da7abf9$var$gen(0x01, 72, 64);
var $7db8000d9da7abf9$var$genShake = function(suffix, blockLen, outputLen) {
    return (0, $84f9351876d022a0$exports.wrapXOFConstructorWithOpts)(function() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new $7db8000d9da7abf9$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true);
    });
};
$7db8000d9da7abf9$exports.shake128 = $7db8000d9da7abf9$var$genShake(0x1f, 168, 16);
$7db8000d9da7abf9$exports.shake256 = $7db8000d9da7abf9$var$genShake(0x1f, 136, 32);


var $a492fc3495682ad4$exports = {};

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");
"use strict";
Object.defineProperty($a492fc3495682ad4$exports, "__esModule", {
    value: true
});
$a492fc3495682ad4$exports.encodeToCurve = $a492fc3495682ad4$exports.hashToCurve = $a492fc3495682ad4$exports.schnorr = $a492fc3495682ad4$exports.secp256k1 = void 0;


var $8a2d54ab42853915$exports = {};

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");
"use strict";
Object.defineProperty($8a2d54ab42853915$exports, "__esModule", {
    value: true
});
$8a2d54ab42853915$exports.getHash = $8a2d54ab42853915$var$getHash;
$8a2d54ab42853915$exports.createCurve = $8a2d54ab42853915$var$createCurve;


var $2323702f68a70653$exports = {};

var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $a7gqy = parcelRequire("a7gqy");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $4JCw4 = parcelRequire("4JCw4");

var $gddcW = parcelRequire("gddcW");

var $gF0bR = parcelRequire("gF0bR");

var $aVMuR = parcelRequire("aVMuR");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");
"use strict";
Object.defineProperty($2323702f68a70653$exports, "__esModule", {
    value: true
});
$2323702f68a70653$exports.DER = void 0;
$2323702f68a70653$exports.weierstrassPoints = $2323702f68a70653$var$weierstrassPoints;
$2323702f68a70653$exports.weierstrass = $2323702f68a70653$var$weierstrass;
$2323702f68a70653$exports.SWUFpSqrtRatio = $2323702f68a70653$var$SWUFpSqrtRatio;
$2323702f68a70653$exports.mapToCurveSimpleSWU = $2323702f68a70653$var$mapToCurveSimpleSWU;

var $bUKt0 = parcelRequire("bUKt0");

var $ev04Q = parcelRequire("ev04Q");

var $1YtXk = parcelRequire("1YtXk");

var $1YtXk = parcelRequire("1YtXk");
function $2323702f68a70653$var$validatePointOpts(curve) {
    var opts = (0, $bUKt0.validateBasic)(curve);
    $1YtXk.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    var endo = opts.endo, Fp = opts.Fp, a = opts.a;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || (0, $aVMuR._)(endo.beta) !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze((0, $4JCw4._)({}, opts));
}
// ASN.1 DER encoding utilities
var $2323702f68a70653$var$b2n = $1YtXk.bytesToNumberBE, $2323702f68a70653$var$h2b = $1YtXk.hexToBytes;
var $2323702f68a70653$var$_obj;
$2323702f68a70653$exports.DER = ($2323702f68a70653$var$_obj = {
    // asn.1 DER encoding utils
    Err: /*#__PURE__*/ function(Error1) {
        (0, $cgJ2Y._)(DERErr, Error1);
        var _super = (0, $hKD8n._)(DERErr);
        function DERErr() {
            var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            (0, $7dKN1._)(this, DERErr);
            return _super.call(this, m);
        }
        return DERErr;
    }((0, $jShW9._)(Error))
}, (0, $a7gqy._)($2323702f68a70653$var$_obj, "_parseInt", function(data) {
    var _exports_DER = $2323702f68a70653$exports.DER, E = _exports_DER["Err"];
    if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
    var len = data[1];
    var res = data.subarray(2, len + 2);
    if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    if (res[0] & 128) throw new E("Invalid signature integer: negative");
    if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
    return {
        d: $2323702f68a70653$var$b2n(res),
        l: data.subarray(len + 2)
    }; // d is data, l is left
}), (0, $a7gqy._)($2323702f68a70653$var$_obj, "toSig", function(hex) {
    // parse DER signature
    var _exports_DER = $2323702f68a70653$exports.DER, E = _exports_DER["Err"];
    var data = typeof hex === "string" ? $2323702f68a70653$var$h2b(hex) : hex;
    $1YtXk.abytes(data);
    var l = data.length;
    if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
    if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
    var _exports_DER__parseInt = $2323702f68a70653$exports.DER._parseInt(data.subarray(2)), r = _exports_DER__parseInt.d, sBytes = _exports_DER__parseInt.l;
    var _exports_DER__parseInt1 = $2323702f68a70653$exports.DER._parseInt(sBytes), s = _exports_DER__parseInt1["d"], rBytesLeft = _exports_DER__parseInt1["l"];
    if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
    return {
        r: r,
        s: s
    };
}), (0, $a7gqy._)($2323702f68a70653$var$_obj, "hexFromSig", function(sig) {
    // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
    var slice = function(s) {
        return Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
    };
    var h = function(num) {
        var hex = num.toString(16);
        return hex.length & 1 ? "0".concat(hex) : hex;
    };
    var s = slice(h(sig.s));
    var r = slice(h(sig.r));
    var shl = s.length / 2;
    var rhl = r.length / 2;
    var sl = h(shl);
    var rl = h(rhl);
    return "30".concat(h(rhl + shl + 4), "02").concat(rl).concat(r, "02").concat(sl).concat(s);
}), $2323702f68a70653$var$_obj);
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var $2323702f68a70653$var$_0n = BigInt(0), $2323702f68a70653$var$_1n = BigInt(1), $2323702f68a70653$var$_2n = BigInt(2), $2323702f68a70653$var$_3n = BigInt(3), $2323702f68a70653$var$_4n = BigInt(4);
function $2323702f68a70653$var$weierstrassPoints(opts) {
    var CURVE = $2323702f68a70653$var$validatePointOpts(opts);
    var Fp = CURVE.Fp; // All curves has same field / group length as for now, but they can differ
    var toBytes = CURVE.toBytes || function(_c, point, _isCompressed) {
        var a = point.toAffine();
        return $1YtXk.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    };
    var fromBytes = CURVE.fromBytes || function(bytes) {
        // const head = bytes[0];
        var tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    };
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        var a = CURVE.a, b = CURVE.b;
        var x2 = Fp.sqr(x); // x * x
        var x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return (typeof num === "undefined" ? "undefined" : (0, $aVMuR._)(num)) === "bigint" && $2323702f68a70653$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        var lengths = CURVE.allowedPrivateKeyLengths, nByteLength = CURVE.nByteLength, wrapPrivateKey = CURVE.wrapPrivateKey, n = CURVE.n;
        if (lengths && (typeof key === "undefined" ? "undefined" : (0, $aVMuR._)(key)) !== "bigint") {
            if ($1YtXk.isBytes(key)) key = $1YtXk.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        var num;
        try {
            num = (typeof key === "undefined" ? "undefined" : (0, $aVMuR._)(key)) === "bigint" ? key : $1YtXk.bytesToNumberBE((0, $1YtXk.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error("private key must be ".concat(nByteLength, " bytes, hex or bigint, not ").concat(typeof key === "undefined" ? "undefined" : (0, $aVMuR._)(key)));
        }
        if (wrapPrivateKey) num = $ev04Q.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    var pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ var Point = /*#__PURE__*/ function() {
        function Point(px, py, pz) {
            (0, $7dKN1._)(this, Point);
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        (0, $eW5pA._)(Point, [
            {
                key: "x",
                get: function get() {
                    return this.toAffine().x;
                }
            },
            {
                key: "y",
                get: function get() {
                    return this.toAffine().y;
                }
            },
            {
                // "Private method", don't use it directly
                key: "_setWindowSize",
                value: function _setWindowSize(windowSize) {
                    this._WINDOW_SIZE = windowSize;
                    pointPrecomputes.delete(this);
                }
            },
            {
                // A point on curve is valid if it conforms to equation.
                key: "assertValidity",
                value: function assertValidity() {
                    if (this.is0()) {
                        // (0, 1, 0) aka ZERO is invalid in most contexts.
                        // In BLS, ZERO can be serialized, so we allow it.
                        // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                        if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                        throw new Error("bad point: ZERO");
                    }
                    // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
                    var _this_toAffine = this.toAffine(), x = _this_toAffine.x, y = _this_toAffine.y;
                    // Check if x, y are valid field elements
                    if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
                    var left = Fp.sqr(y); // y²
                    var right = weierstrassEquation(x); // x³ + ax + b
                    if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
                    if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
                }
            },
            {
                key: "hasEvenY",
                value: function hasEvenY() {
                    var y = this.toAffine().y;
                    if (Fp.isOdd) return !Fp.isOdd(y);
                    throw new Error("Field doesn't support isOdd");
                }
            },
            {
                /**
         * Compare one point to another.
         */ key: "equals",
                value: function equals(other) {
                    assertPrjPoint(other);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X2 = other.px, Y2 = other.py, Z2 = other.pz;
                    var U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
                    var U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
                    return U1 && U2;
                }
            },
            {
                /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ key: "negate",
                value: function negate() {
                    return new Point(this.px, Fp.neg(this.py), this.pz);
                }
            },
            {
                // Renes-Costello-Batina exception-free doubling formula.
                // There is 30% faster Jacobian formula, but it is not complete.
                // https://eprint.iacr.org/2015/1060, algorithm 3
                // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
                key: "double",
                value: function double() {
                    var a = CURVE.a, b = CURVE.b;
                    var b3 = Fp.mul(b, $2323702f68a70653$var$_3n);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
                    var t0 = Fp.mul(X1, X1); // step 1
                    var t1 = Fp.mul(Y1, Y1);
                    var t2 = Fp.mul(Z1, Z1);
                    var t3 = Fp.mul(X1, Y1);
                    t3 = Fp.add(t3, t3); // step 5
                    Z3 = Fp.mul(X1, Z1);
                    Z3 = Fp.add(Z3, Z3);
                    X3 = Fp.mul(a, Z3);
                    Y3 = Fp.mul(b3, t2);
                    Y3 = Fp.add(X3, Y3); // step 10
                    X3 = Fp.sub(t1, Y3);
                    Y3 = Fp.add(t1, Y3);
                    Y3 = Fp.mul(X3, Y3);
                    X3 = Fp.mul(t3, X3);
                    Z3 = Fp.mul(b3, Z3); // step 15
                    t2 = Fp.mul(a, t2);
                    t3 = Fp.sub(t0, t2);
                    t3 = Fp.mul(a, t3);
                    t3 = Fp.add(t3, Z3);
                    Z3 = Fp.add(t0, t0); // step 20
                    t0 = Fp.add(Z3, t0);
                    t0 = Fp.add(t0, t2);
                    t0 = Fp.mul(t0, t3);
                    Y3 = Fp.add(Y3, t0);
                    t2 = Fp.mul(Y1, Z1); // step 25
                    t2 = Fp.add(t2, t2);
                    t0 = Fp.mul(t2, t3);
                    X3 = Fp.sub(X3, t0);
                    Z3 = Fp.mul(t2, t1);
                    Z3 = Fp.add(Z3, Z3); // step 30
                    Z3 = Fp.add(Z3, Z3);
                    return new Point(X3, Y3, Z3);
                }
            },
            {
                // Renes-Costello-Batina exception-free addition formula.
                // There is 30% faster Jacobian formula, but it is not complete.
                // https://eprint.iacr.org/2015/1060, algorithm 1
                // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
                key: "add",
                value: function add(other) {
                    assertPrjPoint(other);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X2 = other.px, Y2 = other.py, Z2 = other.pz;
                    var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
                    var a = CURVE.a;
                    var b3 = Fp.mul(CURVE.b, $2323702f68a70653$var$_3n);
                    var t0 = Fp.mul(X1, X2); // step 1
                    var t1 = Fp.mul(Y1, Y2);
                    var t2 = Fp.mul(Z1, Z2);
                    var t3 = Fp.add(X1, Y1);
                    var t4 = Fp.add(X2, Y2); // step 5
                    t3 = Fp.mul(t3, t4);
                    t4 = Fp.add(t0, t1);
                    t3 = Fp.sub(t3, t4);
                    t4 = Fp.add(X1, Z1);
                    var t5 = Fp.add(X2, Z2); // step 10
                    t4 = Fp.mul(t4, t5);
                    t5 = Fp.add(t0, t2);
                    t4 = Fp.sub(t4, t5);
                    t5 = Fp.add(Y1, Z1);
                    X3 = Fp.add(Y2, Z2); // step 15
                    t5 = Fp.mul(t5, X3);
                    X3 = Fp.add(t1, t2);
                    t5 = Fp.sub(t5, X3);
                    Z3 = Fp.mul(a, t4);
                    X3 = Fp.mul(b3, t2); // step 20
                    Z3 = Fp.add(X3, Z3);
                    X3 = Fp.sub(t1, Z3);
                    Z3 = Fp.add(t1, Z3);
                    Y3 = Fp.mul(X3, Z3);
                    t1 = Fp.add(t0, t0); // step 25
                    t1 = Fp.add(t1, t0);
                    t2 = Fp.mul(a, t2);
                    t4 = Fp.mul(b3, t4);
                    t1 = Fp.add(t1, t2);
                    t2 = Fp.sub(t0, t2); // step 30
                    t2 = Fp.mul(a, t2);
                    t4 = Fp.add(t4, t2);
                    t0 = Fp.mul(t1, t4);
                    Y3 = Fp.add(Y3, t0);
                    t0 = Fp.mul(t5, t4); // step 35
                    X3 = Fp.mul(t3, X3);
                    X3 = Fp.sub(X3, t0);
                    t0 = Fp.mul(t3, t1);
                    Z3 = Fp.mul(t5, Z3);
                    Z3 = Fp.add(Z3, t0); // step 40
                    return new Point(X3, Y3, Z3);
                }
            },
            {
                key: "subtract",
                value: function subtract(other) {
                    return this.add(other.negate());
                }
            },
            {
                key: "is0",
                value: function is0() {
                    return this.equals(Point.ZERO);
                }
            },
            {
                key: "wNAF",
                value: function wNAF(n) {
                    return wnaf.wNAFCached(this, pointPrecomputes, n, function(comp) {
                        var toInv = Fp.invertBatch(comp.map(function(p) {
                            return p.pz;
                        }));
                        return comp.map(function(p, i) {
                            return p.toAffine(toInv[i]);
                        }).map(Point.fromAffine);
                    });
                }
            },
            {
                /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ key: "multiplyUnsafe",
                value: function multiplyUnsafe(n) {
                    var I = Point.ZERO;
                    if (n === $2323702f68a70653$var$_0n) return I;
                    assertGE(n); // Will throw on 0
                    if (n === $2323702f68a70653$var$_1n) return this;
                    var endo = CURVE.endo;
                    if (!endo) return wnaf.unsafeLadder(this, n);
                    // Apply endomorphism
                    var _endo_splitScalar = endo.splitScalar(n), k1neg = _endo_splitScalar.k1neg, k1 = _endo_splitScalar.k1, k2neg = _endo_splitScalar.k2neg, k2 = _endo_splitScalar.k2;
                    var k1p = I;
                    var k2p = I;
                    var d = this;
                    while(k1 > $2323702f68a70653$var$_0n || k2 > $2323702f68a70653$var$_0n){
                        if (k1 & $2323702f68a70653$var$_1n) k1p = k1p.add(d);
                        if (k2 & $2323702f68a70653$var$_1n) k2p = k2p.add(d);
                        d = d.double();
                        k1 >>= $2323702f68a70653$var$_1n;
                        k2 >>= $2323702f68a70653$var$_1n;
                    }
                    if (k1neg) k1p = k1p.negate();
                    if (k2neg) k2p = k2p.negate();
                    k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                    return k1p.add(k2p);
                }
            },
            {
                /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ key: "multiply",
                value: function multiply(scalar) {
                    assertGE(scalar);
                    var n = scalar;
                    var point, fake; // Fake point is used to const-time mult
                    var endo = CURVE.endo;
                    if (endo) {
                        var _endo_splitScalar = endo.splitScalar(n), k1neg = _endo_splitScalar.k1neg, k1 = _endo_splitScalar.k1, k2neg = _endo_splitScalar.k2neg, k2 = _endo_splitScalar.k2;
                        var _this_wNAF = this.wNAF(k1), k1p = _this_wNAF.p, f1p = _this_wNAF.f;
                        var _this_wNAF1 = this.wNAF(k2), k2p = _this_wNAF1.p, f2p = _this_wNAF1.f;
                        k1p = wnaf.constTimeNegate(k1neg, k1p);
                        k2p = wnaf.constTimeNegate(k2neg, k2p);
                        k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                        point = k1p.add(k2p);
                        fake = f1p.add(f2p);
                    } else {
                        var _this_wNAF2 = this.wNAF(n), p = _this_wNAF2.p, f = _this_wNAF2.f;
                        point = p;
                        fake = f;
                    }
                    // Normalize `z` for both points, but return only real one
                    return Point.normalizeZ([
                        point,
                        fake
                    ])[0];
                }
            },
            {
                /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ key: "multiplyAndAddUnsafe",
                value: function multiplyAndAddUnsafe(Q, a, b) {
                    var G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
                    var mul = function(P, a // Select faster multiply() method
                    ) {
                        return a === $2323702f68a70653$var$_0n || a === $2323702f68a70653$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
                    };
                    var sum = mul(this, a).add(mul(Q, b));
                    return sum.is0() ? undefined : sum;
                }
            },
            {
                // Converts Projective point to affine (x, y) coordinates.
                // Can accept precomputed Z^-1 - for example, from invertBatch.
                // (x, y, z) ∋ (x=x/z, y=y/z)
                key: "toAffine",
                value: function toAffine(iz) {
                    var _this = this, x = _this.px, y = _this.py, z = _this.pz;
                    var is0 = this.is0();
                    // If invZ was 0, we return zero point. However we still want to execute
                    // all operations, so we replace invZ with a random number, 1.
                    if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
                    var ax = Fp.mul(x, iz);
                    var ay = Fp.mul(y, iz);
                    var zz = Fp.mul(z, iz);
                    if (is0) return {
                        x: Fp.ZERO,
                        y: Fp.ZERO
                    };
                    if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
                    return {
                        x: ax,
                        y: ay
                    };
                }
            },
            {
                key: "isTorsionFree",
                value: function isTorsionFree() {
                    var cofactor = CURVE.h, isTorsionFree = CURVE.isTorsionFree;
                    if (cofactor === $2323702f68a70653$var$_1n) return true; // No subgroups, always torsion-free
                    if (isTorsionFree) return isTorsionFree(Point, this);
                    throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                }
            },
            {
                key: "clearCofactor",
                value: function clearCofactor() {
                    var cofactor = CURVE.h, clearCofactor = CURVE.clearCofactor;
                    if (cofactor === $2323702f68a70653$var$_1n) return this; // Fast-path
                    if (clearCofactor) return clearCofactor(Point, this);
                    return this.multiplyUnsafe(CURVE.h);
                }
            },
            {
                key: "toRawBytes",
                value: function toRawBytes() {
                    var isCompressed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.assertValidity();
                    return toBytes(Point, this, isCompressed);
                }
            },
            {
                key: "toHex",
                value: function toHex() {
                    var isCompressed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    return $1YtXk.bytesToHex(this.toRawBytes(isCompressed));
                }
            }
        ], [
            {
                key: "fromAffine",
                value: // Does not validate if the point is on-curve.
                // Use fromHex instead, or call assertValidity() later.
                function fromAffine(p) {
                    var _ref = p || {}, x = _ref.x, y = _ref.y;
                    if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
                    if (p instanceof Point) throw new Error("projective point not allowed");
                    var is0 = function(i) {
                        return Fp.eql(i, Fp.ZERO);
                    };
                    // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
                    if (is0(x) && is0(y)) return Point.ZERO;
                    return new Point(x, y, Fp.ONE);
                }
            },
            {
                key: "normalizeZ",
                value: /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ function normalizeZ(points) {
                    var toInv = Fp.invertBatch(points.map(function(p) {
                        return p.pz;
                    }));
                    return points.map(function(p, i) {
                        return p.toAffine(toInv[i]);
                    }).map(Point.fromAffine);
                }
            },
            {
                key: "fromHex",
                value: /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ function fromHex(hex) {
                    var P = Point.fromAffine(fromBytes((0, $1YtXk.ensureBytes)("pointHex", hex)));
                    P.assertValidity();
                    return P;
                }
            },
            {
                key: "fromPrivateKey",
                value: // Multiplies generator point by privateKey.
                function fromPrivateKey(privateKey) {
                    return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
                }
            }
        ]);
        return Point;
    }();
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    var _bits = CURVE.nBitLength;
    var wnaf = (0, $bUKt0.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $2323702f68a70653$var$validateOpts(curve) {
    var opts = (0, $bUKt0.validateBasic)(curve);
    $1YtXk.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze((0, $4JCw4._)({
        lowS: true
    }, opts));
}
function $2323702f68a70653$var$weierstrass(curveDef) {
    var CURVE = $2323702f68a70653$var$validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n;
    var compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    var uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $2323702f68a70653$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $ev04Q.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $ev04Q.invert(a, CURVE_ORDER);
    }
    var _weierstrassPoints = $2323702f68a70653$var$weierstrassPoints((0, $gddcW._)((0, $4JCw4._)({}, CURVE), {
        toBytes: function(_c, point, isCompressed) {
            var a = point.toAffine();
            var x = Fp.toBytes(a.x);
            var cat = $1YtXk.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes: function(bytes) {
            var len = bytes.length;
            var head = bytes[0];
            var tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                var x = $1YtXk.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                var y2 = weierstrassEquation(x); // y² = x³ + ax + b
                var y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    var suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                var isYOdd = (y & $2323702f68a70653$var$_1n) === $2323702f68a70653$var$_1n;
                // ECDSA
                var isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                var x1 = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                var y1 = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x1,
                    y: y1
                };
            } else throw new Error("Point of length ".concat(len, " was invalid. Expected ").concat(compressedLen, " compressed bytes or ").concat(uncompressedLen, " uncompressed bytes"));
        }
    })), Point = _weierstrassPoints.ProjectivePoint, normPrivateKeyToScalar = _weierstrassPoints.normPrivateKeyToScalar, weierstrassEquation = _weierstrassPoints.weierstrassEquation, isWithinCurveOrder = _weierstrassPoints.isWithinCurveOrder;
    var numToNByteStr = function(num) {
        return $1YtXk.bytesToHex($1YtXk.numberToBytesBE(num, CURVE.nByteLength));
    };
    function isBiggerThanHalfOrder(number) {
        var HALF = CURVE_ORDER >> $2323702f68a70653$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    var slcNum = function(b, from, to) {
        return $1YtXk.bytesToNumberBE(b.slice(from, to));
    };
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ var Signature = /*#__PURE__*/ function() {
        function Signature(r, s, recovery) {
            (0, $7dKN1._)(this, Signature);
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        (0, $eW5pA._)(Signature, [
            {
                key: "assertValidity",
                value: function assertValidity() {
                    // can use assertGE here
                    if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
                    if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
                }
            },
            {
                key: "addRecoveryBit",
                value: function addRecoveryBit(recovery) {
                    return new Signature(this.r, this.s, recovery);
                }
            },
            {
                key: "recoverPublicKey",
                value: function recoverPublicKey(msgHash) {
                    var _this = this, r = _this.r, s = _this.s, rec = _this.recovery;
                    var h = bits2int_modN((0, $1YtXk.ensureBytes)("msgHash", msgHash)); // Truncate hash
                    if (rec == null || ![
                        0,
                        1,
                        2,
                        3
                    ].includes(rec)) throw new Error("recovery id invalid");
                    var radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
                    if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
                    var prefix = (rec & 1) === 0 ? "02" : "03";
                    var R = Point.fromHex(prefix + numToNByteStr(radj));
                    var ir = invN(radj); // r^-1
                    var u1 = modN(-h * ir); // -hr^-1
                    var u2 = modN(s * ir); // sr^-1
                    var Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
                    if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
                    Q.assertValidity();
                    return Q;
                }
            },
            {
                // Signatures should be low-s, to prevent malleability.
                key: "hasHighS",
                value: function hasHighS() {
                    return isBiggerThanHalfOrder(this.s);
                }
            },
            {
                key: "normalizeS",
                value: function normalizeS() {
                    return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
                }
            },
            {
                // DER-encoded
                key: "toDERRawBytes",
                value: function toDERRawBytes() {
                    return $1YtXk.hexToBytes(this.toDERHex());
                }
            },
            {
                key: "toDERHex",
                value: function toDERHex() {
                    return $2323702f68a70653$exports.DER.hexFromSig({
                        r: this.r,
                        s: this.s
                    });
                }
            },
            {
                // padded bytes of r, then padded bytes of s
                key: "toCompactRawBytes",
                value: function toCompactRawBytes() {
                    return $1YtXk.hexToBytes(this.toCompactHex());
                }
            },
            {
                key: "toCompactHex",
                value: function toCompactHex() {
                    return numToNByteStr(this.r) + numToNByteStr(this.s);
                }
            }
        ], [
            {
                key: "fromCompact",
                value: // pair (bytes of r, bytes of s)
                function fromCompact(hex) {
                    var l = CURVE.nByteLength;
                    hex = (0, $1YtXk.ensureBytes)("compactSignature", hex, l * 2);
                    return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
                }
            },
            {
                key: "fromDER",
                value: // DER encoded ECDSA signature
                // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
                function fromDER(hex) {
                    var _exports_DER_toSig = $2323702f68a70653$exports.DER.toSig((0, $1YtXk.ensureBytes)("DER", hex)), r = _exports_DER_toSig.r, s = _exports_DER_toSig.s;
                    return new Signature(r, s);
                }
            }
        ]);
        return Signature;
    }();
    var utils = {
        isValidPrivateKey: function(privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: function() {
            var length = $ev04Q.getMinHashLength(CURVE.n);
            return $ev04Q.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute: function() {
            var windowSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8, point = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Point.BASE;
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey) {
        var isCompressed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        var arr = $1YtXk.isBytes(item);
        var str = typeof item === "string";
        var len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB) {
        var isCompressed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        var b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    var bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        var num = $1YtXk.bytesToNumberBE(bytes); // check for == u8 done here
        var delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    var bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    var ORDER_MASK = $1YtXk.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if ((typeof num === "undefined" ? "undefined" : (0, $aVMuR._)(num)) !== "bigint") throw new Error("bigint expected");
        if (!($2323702f68a70653$var$_0n <= num && num < ORDER_MASK)) throw new Error("bigint expected < 2^".concat(CURVE.nBitLength));
        // works with order, can have different size than numToField!
        return $1YtXk.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultSigOpts;
        var _ut;
        if ([
            "recovered",
            "canonical"
        ].some(function(k) {
            return k in opts;
        })) throw new Error("sign() legacy options not supported");
        var hash = CURVE.hash, randomBytes = CURVE.randomBytes;
        var lowS = opts.lowS, prehash = opts.prehash, ent = opts.extraEntropy; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $1YtXk.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $1YtXk.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        var h1int = bits2int_modN(msgHash);
        var d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        var seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            var e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $1YtXk.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        var seed = (_ut = $1YtXk).concatBytes.apply(_ut, (0, $gF0bR._)(seedArgs)); // Step D of RFC6979 3.2
        var m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            var k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            var ik = invN(k); // k^-1 mod n
            var q = Point.BASE.multiply(k).toAffine(); // q = Gk
            var r = modN(q.x); // r = q.x mod n
            if (r === $2323702f68a70653$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            var s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $2323702f68a70653$var$_0n) return;
            var recovery = (q.x === r ? 0 : 2) | Number(q.y & $2323702f68a70653$var$_1n); // recovery bit (2 or 3, when q.x > n)
            var normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    var defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    var defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultSigOpts;
        var _prepSig = prepSig(msgHash, privKey, opts), seed = _prepSig.seed, k2sig = _prepSig.k2sig; // Steps A, D of RFC6979 3.2.
        var C = CURVE;
        var drbg = $1YtXk.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultVerOpts;
        var _Point_BASE_multiplyAndAddUnsafe;
        var sg = signature;
        msgHash = (0, $1YtXk.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $1YtXk.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        var lowS = opts.lowS, prehash = opts.prehash;
        var _sig = undefined;
        var P;
        try {
            if (typeof sg === "string" || $1YtXk.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $2323702f68a70653$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && (0, $aVMuR._)(sg.r) === "bigint" && (0, $aVMuR._)(sg.s) === "bigint") {
                var r = sg.r, s = sg.s;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error("signature must be Signature instance, Uint8Array or hex string");
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        var r1 = _sig.r, s1 = _sig.s;
        var h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        var is = invN(s1); // s^-1
        var u1 = modN(h * is); // u1 = hs^-1 mod n
        var u2 = modN(r1 * is); // u2 = rs^-1 mod n
        var R = (_Point_BASE_multiplyAndAddUnsafe = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)) === null || _Point_BASE_multiplyAndAddUnsafe === void 0 ? void 0 : _Point_BASE_multiplyAndAddUnsafe.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        var v = modN(R.x);
        return v === r1;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $2323702f68a70653$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    var q = Fp.ORDER;
    var l = $2323702f68a70653$var$_0n;
    for(var o = q - $2323702f68a70653$var$_1n; o % $2323702f68a70653$var$_2n === $2323702f68a70653$var$_0n; o /= $2323702f68a70653$var$_2n)l += $2323702f68a70653$var$_1n;
    var c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    var _2n_pow_c1_1 = $2323702f68a70653$var$_2n << c1 - $2323702f68a70653$var$_1n - $2323702f68a70653$var$_1n;
    var _2n_pow_c1 = _2n_pow_c1_1 * $2323702f68a70653$var$_2n;
    var c2 = (q - $2323702f68a70653$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    var c3 = (c2 - $2323702f68a70653$var$_1n) / $2323702f68a70653$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    var c4 = _2n_pow_c1 - $2323702f68a70653$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    var c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    var c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    var c7 = Fp.pow(Z, (c2 + $2323702f68a70653$var$_1n) / $2323702f68a70653$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    var sqrtRatio = function(u, v) {
        var tv1 = c6; // 1. tv1 = c6
        var tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        var tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        var tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        var tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        var isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(var i = c1; i > $2323702f68a70653$var$_1n; i--){
            var tv51 = i - $2323702f68a70653$var$_2n; // 18.    tv5 = i - 2
            tv51 = $2323702f68a70653$var$_2n << tv51 - $2323702f68a70653$var$_1n; // 19.    tv5 = 2^tv5
            var tvv5 = Fp.pow(tv4, tv51); // 20.    tv5 = tv4^tv5
            var e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $2323702f68a70653$var$_4n === $2323702f68a70653$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        var c11 = (Fp.ORDER - $2323702f68a70653$var$_3n) / $2323702f68a70653$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        var c21 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = function(u, v) {
            var tv1 = Fp.sqr(v); // 1. tv1 = v^2
            var tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            var y1 = Fp.pow(tv1, c11); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            var y2 = Fp.mul(y1, c21); // 6. y2 = y1 * c2
            var tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            var isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            var y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $2323702f68a70653$var$mapToCurveSimpleSWU(Fp, opts) {
    $ev04Q.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    var sqrtRatio = $2323702f68a70653$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return function(u) {
        // prettier-ignore
        var tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        var _sqrtRatio = sqrtRatio(tv2, tv6), isValid = _sqrtRatio.isValid, value = _sqrtRatio.value; // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        var e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}


// connects noble-curves to noble-hashes
function $8a2d54ab42853915$var$getHash(hash) {
    var _this = this;
    return {
        hash: hash,
        hmac: function(key) {
            for(var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                msgs[_key - 1] = arguments[_key];
            }
            return (0, $6c6d2bbf9aa5b6fa$exports.hmac)(hash, key, (0, $84f9351876d022a0$exports.concatBytes).apply(_this, (0, $gF0bR._)(msgs)));
        },
        randomBytes: $84f9351876d022a0$exports.randomBytes
    };
}
function $8a2d54ab42853915$var$createCurve(curveDef, defHash) {
    var create = function(hash) {
        return (0, $2323702f68a70653$exports.weierstrass)((0, $4JCw4._)({}, curveDef, $8a2d54ab42853915$var$getHash(hash)));
    };
    return Object.freeze((0, $gddcW._)((0, $4JCw4._)({}, create(defHash)), {
        create: create
    }));
}




var $ev04Q = parcelRequire("ev04Q");

var $1YtXk = parcelRequire("1YtXk");

var $a492fc3495682ad4$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
var $a492fc3495682ad4$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
var $a492fc3495682ad4$var$_1n = BigInt(1);
var $a492fc3495682ad4$var$_2n = BigInt(2);
var $a492fc3495682ad4$var$divNearest = function(a, b) {
    return (a + b / $a492fc3495682ad4$var$_2n) / b;
};
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $a492fc3495682ad4$var$sqrtMod(y) {
    var P = $a492fc3495682ad4$var$secp256k1P;
    // prettier-ignore
    var _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    var _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    var b2 = y * y * y % P; // x^3, 11
    var b3 = b2 * b2 * y % P; // x^7
    var b6 = (0, $ev04Q.pow2)(b3, _3n, P) * b3 % P;
    var b9 = (0, $ev04Q.pow2)(b6, _3n, P) * b3 % P;
    var b11 = (0, $ev04Q.pow2)(b9, $a492fc3495682ad4$var$_2n, P) * b2 % P;
    var b22 = (0, $ev04Q.pow2)(b11, _11n, P) * b11 % P;
    var b44 = (0, $ev04Q.pow2)(b22, _22n, P) * b22 % P;
    var b88 = (0, $ev04Q.pow2)(b44, _44n, P) * b44 % P;
    var b176 = (0, $ev04Q.pow2)(b88, _88n, P) * b88 % P;
    var b220 = (0, $ev04Q.pow2)(b176, _44n, P) * b44 % P;
    var b223 = (0, $ev04Q.pow2)(b220, _3n, P) * b3 % P;
    var t1 = (0, $ev04Q.pow2)(b223, _23n, P) * b22 % P;
    var t2 = (0, $ev04Q.pow2)(t1, _6n, P) * b2 % P;
    var root = (0, $ev04Q.pow2)(t2, $a492fc3495682ad4$var$_2n, P);
    if (!$a492fc3495682ad4$var$Fp.eql($a492fc3495682ad4$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
var $a492fc3495682ad4$var$Fp = (0, $ev04Q.Field)($a492fc3495682ad4$var$secp256k1P, undefined, undefined, {
    sqrt: $a492fc3495682ad4$var$sqrtMod
});
$a492fc3495682ad4$exports.secp256k1 = (0, $8a2d54ab42853915$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $a492fc3495682ad4$var$Fp,
    n: $a492fc3495682ad4$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: function(k) {
            var n = $a492fc3495682ad4$var$secp256k1N;
            var a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            var b1 = -$a492fc3495682ad4$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            var a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            var b2 = a1;
            var POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            var c1 = $a492fc3495682ad4$var$divNearest(b2 * k, n);
            var c2 = $a492fc3495682ad4$var$divNearest(-b1 * k, n);
            var k1 = (0, $ev04Q.mod)(k - c1 * a1 - c2 * a2, n);
            var k2 = (0, $ev04Q.mod)(-c1 * b1 - c2 * b2, n);
            var k1neg = k1 > POW_2_128;
            var k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $33bf81adc16df8a0$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
var $a492fc3495682ad4$var$_0n = BigInt(0);
var $a492fc3495682ad4$var$fe = function(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $aVMuR._)(x)) === "bigint" && $a492fc3495682ad4$var$_0n < x && x < $a492fc3495682ad4$var$secp256k1P;
};
var $a492fc3495682ad4$var$ge = function(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $aVMuR._)(x)) === "bigint" && $a492fc3495682ad4$var$_0n < x && x < $a492fc3495682ad4$var$secp256k1N;
};
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ var $a492fc3495682ad4$var$TAGGED_HASH_PREFIXES = {};
function $a492fc3495682ad4$var$taggedHash(tag) {
    for(var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        messages[_key - 1] = arguments[_key];
    }
    var tagP = $a492fc3495682ad4$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        var tagH = (0, $33bf81adc16df8a0$exports.sha256)(Uint8Array.from(tag, function(c) {
            return c.charCodeAt(0);
        }));
        tagP = (0, $1YtXk.concatBytes)(tagH, tagH);
        $a492fc3495682ad4$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $33bf81adc16df8a0$exports.sha256)((0, $1YtXk.concatBytes).apply(this, [
        tagP
    ].concat((0, $gF0bR._)(messages))));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
var $a492fc3495682ad4$var$pointToBytes = function(point) {
    return point.toRawBytes(true).slice(1);
};
var $a492fc3495682ad4$var$numTo32b = function(n) {
    return (0, $1YtXk.numberToBytesBE)(n, 32);
};
var $a492fc3495682ad4$var$modP = function(x) {
    return (0, $ev04Q.mod)(x, $a492fc3495682ad4$var$secp256k1P);
};
var $a492fc3495682ad4$var$modN = function(x) {
    return (0, $ev04Q.mod)(x, $a492fc3495682ad4$var$secp256k1N);
};
var $a492fc3495682ad4$var$Point = $a492fc3495682ad4$exports.secp256k1.ProjectivePoint;
var $a492fc3495682ad4$var$GmulAdd = function(Q, a, b) {
    return $a492fc3495682ad4$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
};
// Calculate point, scalar and bytes
function $a492fc3495682ad4$var$schnorrGetExtPubKey(priv) {
    var d_ = $a492fc3495682ad4$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    var p = $a492fc3495682ad4$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    var scalar = p.hasEvenY() ? d_ : $a492fc3495682ad4$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $a492fc3495682ad4$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $a492fc3495682ad4$var$lift_x(x) {
    if (!$a492fc3495682ad4$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    var xx = $a492fc3495682ad4$var$modP(x * x);
    var c = $a492fc3495682ad4$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    var y = $a492fc3495682ad4$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $a492fc3495682ad4$var$_2n !== $a492fc3495682ad4$var$_0n) y = $a492fc3495682ad4$var$modP(-y); // Return the unique point P such that x(P) = x and
    var p = new $a492fc3495682ad4$var$Point(x, y, $a492fc3495682ad4$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $a492fc3495682ad4$var$challenge() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $a492fc3495682ad4$var$modN((0, $1YtXk.bytesToNumberBE)($a492fc3495682ad4$var$taggedHash.apply(void 0, [
        "BIP0340/challenge"
    ].concat((0, $gF0bR._)(args)))));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $a492fc3495682ad4$var$schnorrGetPublicKey(privateKey) {
    return $a492fc3495682ad4$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $a492fc3495682ad4$var$schnorrSign(message, privateKey) {
    var auxRand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $84f9351876d022a0$exports.randomBytes)(32);
    var m = (0, $1YtXk.ensureBytes)("message", message);
    var _schnorrGetExtPubKey = $a492fc3495682ad4$var$schnorrGetExtPubKey(privateKey), px = _schnorrGetExtPubKey.bytes, d = _schnorrGetExtPubKey.scalar; // checks for isWithinCurveOrder
    var a = (0, $1YtXk.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    var t = $a492fc3495682ad4$var$numTo32b(d ^ (0, $1YtXk.bytesToNumberBE)($a492fc3495682ad4$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    var rand = $a492fc3495682ad4$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    var k_ = $a492fc3495682ad4$var$modN((0, $1YtXk.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $a492fc3495682ad4$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    var _schnorrGetExtPubKey1 = $a492fc3495682ad4$var$schnorrGetExtPubKey(k_), rx = _schnorrGetExtPubKey1.bytes, k = _schnorrGetExtPubKey1.scalar; // Let R = k'⋅G.
    var e = $a492fc3495682ad4$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    var sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($a492fc3495682ad4$var$numTo32b($a492fc3495682ad4$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$a492fc3495682ad4$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $a492fc3495682ad4$var$schnorrVerify(signature, message, publicKey) {
    var sig = (0, $1YtXk.ensureBytes)("signature", signature, 64);
    var m = (0, $1YtXk.ensureBytes)("message", message);
    var pub = (0, $1YtXk.ensureBytes)("publicKey", publicKey, 32);
    try {
        var P = $a492fc3495682ad4$var$lift_x((0, $1YtXk.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        var r = (0, $1YtXk.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$a492fc3495682ad4$var$fe(r)) return false;
        var s = (0, $1YtXk.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$a492fc3495682ad4$var$ge(s)) return false;
        var e = $a492fc3495682ad4$var$challenge($a492fc3495682ad4$var$numTo32b(r), $a492fc3495682ad4$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        var R = $a492fc3495682ad4$var$GmulAdd(P, s, $a492fc3495682ad4$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$a492fc3495682ad4$exports.schnorr = function() {
    return {
        getPublicKey: $a492fc3495682ad4$var$schnorrGetPublicKey,
        sign: $a492fc3495682ad4$var$schnorrSign,
        verify: $a492fc3495682ad4$var$schnorrVerify,
        utils: {
            randomPrivateKey: $a492fc3495682ad4$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $a492fc3495682ad4$var$lift_x,
            pointToBytes: $a492fc3495682ad4$var$pointToBytes,
            numberToBytesBE: $1YtXk.numberToBytesBE,
            bytesToNumberBE: $1YtXk.bytesToNumberBE,
            taggedHash: $a492fc3495682ad4$var$taggedHash,
            mod: $ev04Q.mod
        }
    };
}();
var $a492fc3495682ad4$var$isoMap = /* @__PURE__ */ function() {
    return (0, $7ecabfc5fa04abcb$exports.isogenyMap)($a492fc3495682ad4$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map(function(i) {
        return i.map(function(j) {
            return BigInt(j);
        });
    }));
}();
var $a492fc3495682ad4$var$mapSWU = /* @__PURE__ */ function() {
    return (0, $2323702f68a70653$exports.mapToCurveSimpleSWU)($a492fc3495682ad4$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $a492fc3495682ad4$var$Fp.create(BigInt("-11"))
    });
}();
var $a492fc3495682ad4$var$htf = /* @__PURE__ */ function() {
    return (0, $7ecabfc5fa04abcb$exports.createHasher)($a492fc3495682ad4$exports.secp256k1.ProjectivePoint, function(scalars) {
        var _mapSWU = $a492fc3495682ad4$var$mapSWU($a492fc3495682ad4$var$Fp.create(scalars[0])), x = _mapSWU.x, y = _mapSWU.y;
        return $a492fc3495682ad4$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $a492fc3495682ad4$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $33bf81adc16df8a0$exports.sha256
    });
}();
$a492fc3495682ad4$exports.hashToCurve = function() {
    return $a492fc3495682ad4$var$htf.hashToCurve;
}();
$a492fc3495682ad4$exports.encodeToCurve = function() {
    return $a492fc3495682ad4$var$htf.encodeToCurve;
}();


/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ var $275f7bb2bb263073$var$generatePrivateKey = (0, $c0ad2f99ab67211e$exports.ed25519).utils.randomPrivateKey;
var $275f7bb2bb263073$var$generateKeypair = function() {
    var privateScalar = (0, $c0ad2f99ab67211e$exports.ed25519).utils.randomPrivateKey();
    var publicKey = $275f7bb2bb263073$var$getPublicKey(privateScalar);
    var secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
var $275f7bb2bb263073$var$getPublicKey = (0, $c0ad2f99ab67211e$exports.ed25519).getPublicKey;
function $275f7bb2bb263073$var$isOnCurve(publicKey) {
    try {
        (0, $c0ad2f99ab67211e$exports.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch (e) {
        return false;
    }
}
var $275f7bb2bb263073$var$sign = function(message, secretKey) {
    return (0, $c0ad2f99ab67211e$exports.ed25519).sign(message, secretKey.slice(0, 32));
};
var $275f7bb2bb263073$var$verify = (0, $c0ad2f99ab67211e$exports.ed25519).verify;
var $275f7bb2bb263073$var$toBuffer = function(arr) {
    if ((0, $ilnag.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $ilnag.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $ilnag.Buffer).from(arr);
};
// Class wrapping a plain object
var $275f7bb2bb263073$export$eabc71f011df675a = /*#__PURE__*/ function() {
    "use strict";
    function Struct(properties) {
        (0, $7dKN1._)(this, Struct);
        Object.assign(this, properties);
    }
    (0, $eW5pA._)(Struct, [
        {
            key: "encode",
            value: function encode() {
                return (0, $ilnag.Buffer).from((0, $116141357f49ed92$exports.serialize)($275f7bb2bb263073$export$68d13ce9b4cc48f3, this));
            }
        }
    ], [
        {
            key: "decode",
            value: function decode(data) {
                return (0, $116141357f49ed92$exports.deserialize)($275f7bb2bb263073$export$68d13ce9b4cc48f3, this, data);
            }
        },
        {
            key: "decodeUnchecked",
            value: function decodeUnchecked(data) {
                return (0, $116141357f49ed92$exports.deserializeUnchecked)($275f7bb2bb263073$export$68d13ce9b4cc48f3, this, data);
            }
        }
    ]);
    return Struct;
}();
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
var $275f7bb2bb263073$export$deb82508dd66d288 = /*#__PURE__*/ function(Struct) {
    "use strict";
    (0, $cgJ2Y._)(Enum, Struct);
    var _super = (0, $hKD8n._)(Enum);
    function Enum(properties) {
        (0, $7dKN1._)(this, Enum);
        var _this;
        _this = _super.call(this, properties);
        _this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map(function(key) {
            _this.enum = key;
        });
        return _this;
    }
    return Enum;
}($275f7bb2bb263073$export$eabc71f011df675a);
var $275f7bb2bb263073$export$68d13ce9b4cc48f3 = new Map();
var $275f7bb2bb263073$var$_PublicKey;
/**
 * Maximum length of derived pubkey seed
 */ var $275f7bb2bb263073$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ var $275f7bb2bb263073$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $275f7bb2bb263073$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
var $275f7bb2bb263073$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ var $275f7bb2bb263073$export$ca8b6604d6ce14de = /*#__PURE__*/ function(Struct) {
    "use strict";
    (0, $cgJ2Y._)(PublicKey, Struct);
    var _super = (0, $hKD8n._)(PublicKey);
    function PublicKey(value) {
        (0, $7dKN1._)(this, PublicKey);
        var _this;
        _this = _super.call(this, {});
        /** @internal */ _this._bn = void 0;
        if ($275f7bb2bb263073$var$isPublicKeyData(value)) _this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                var decoded = (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(value);
                if (decoded.length != $275f7bb2bb263073$export$84fc0a248cc54343) throw new Error("Invalid public key input");
                _this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($fzie2)))(decoded);
            } else _this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($fzie2)))(value);
            if (_this._bn.byteLength() > $275f7bb2bb263073$export$84fc0a248cc54343) throw new Error("Invalid public key input");
        }
        return _this;
    }
    (0, $eW5pA._)(PublicKey, [
        {
            /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ key: "equals",
            value: function equals(publicKey) {
                return this._bn.eq(publicKey._bn);
            }
        },
        {
            /**
   * Return the base-58 representation of the public key
   */ key: "toBase58",
            value: function toBase58() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode(this.toBytes());
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toBase58();
            }
        },
        {
            /**
   * Return the byte array representation of the public key in big endian
   */ key: "toBytes",
            value: function toBytes() {
                var buf = this.toBuffer();
                return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
            }
        },
        {
            /**
   * Return the Buffer representation of the public key in big endian
   */ key: "toBuffer",
            value: function toBuffer() {
                var b = this._bn.toArrayLike((0, $ilnag.Buffer));
                if (b.length === $275f7bb2bb263073$export$84fc0a248cc54343) return b;
                var zeroPad = (0, $ilnag.Buffer).alloc(32);
                b.copy(zeroPad, 32 - b.length);
                return zeroPad;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "PublicKey(".concat(this.toString(), ")");
            }
        },
        {
            /**
   * Return the base-58 representation of the public key
   */ key: "toString",
            value: function toString() {
                return this.toBase58();
            }
        }
    ], [
        {
            key: "unique",
            value: /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ function unique() {
                var key = new PublicKey($275f7bb2bb263073$var$uniquePublicKeyCounter);
                $275f7bb2bb263073$var$uniquePublicKeyCounter += 1;
                return new PublicKey(key.toBuffer());
            }
        },
        {
            key: "createWithSeed",
            value: /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ function createWithSeed(fromPublicKey, seed, programId) {
                return (0, $6rBFC._)(function() {
                    var buffer, publicKeyBytes;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        buffer = (0, $ilnag.Buffer).concat([
                            fromPublicKey.toBuffer(),
                            (0, $ilnag.Buffer).from(seed),
                            programId.toBuffer()
                        ]);
                        publicKeyBytes = (0, $33bf81adc16df8a0$exports.sha256)(buffer);
                        return [
                            2,
                            new PublicKey(publicKeyBytes)
                        ];
                    });
                })();
            }
        },
        {
            key: "createProgramAddressSync",
            value: /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ function createProgramAddressSync(seeds, programId) {
                var buffer = (0, $ilnag.Buffer).alloc(0);
                seeds.forEach(function(seed) {
                    if (seed.length > $275f7bb2bb263073$export$8240f9da84ad7873) throw new TypeError("Max seed length exceeded");
                    buffer = (0, $ilnag.Buffer).concat([
                        buffer,
                        $275f7bb2bb263073$var$toBuffer(seed)
                    ]);
                });
                buffer = (0, $ilnag.Buffer).concat([
                    buffer,
                    programId.toBuffer(),
                    (0, $ilnag.Buffer).from("ProgramDerivedAddress")
                ]);
                var publicKeyBytes = (0, $33bf81adc16df8a0$exports.sha256)(buffer);
                if ($275f7bb2bb263073$var$isOnCurve(publicKeyBytes)) throw new Error("Invalid seeds, address must fall off the curve");
                return new PublicKey(publicKeyBytes);
            }
        },
        {
            key: "createProgramAddress",
            value: /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ function createProgramAddress(seeds, programId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.createProgramAddressSync(seeds, programId)
                        ];
                    });
                })();
            }
        },
        {
            key: "findProgramAddressSync",
            value: /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ function findProgramAddressSync(seeds, programId) {
                var nonce = 255;
                var address;
                while(nonce != 0){
                    try {
                        var seedsWithNonce = seeds.concat((0, $ilnag.Buffer).from([
                            nonce
                        ]));
                        address = this.createProgramAddressSync(seedsWithNonce, programId);
                    } catch (err) {
                        if (err instanceof TypeError) throw err;
                        nonce--;
                        continue;
                    }
                    return [
                        address,
                        nonce
                    ];
                }
                throw new Error("Unable to find a viable program address nonce");
            }
        },
        {
            key: "findProgramAddress",
            value: /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ function findProgramAddress(seeds, programId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.findProgramAddressSync(seeds, programId)
                        ];
                    });
                })();
            }
        },
        {
            key: "isOnCurve",
            value: /**
   * Check that a pubkey is on the ed25519 curve.
   */ function isOnCurve1(pubkeyData) {
                var pubkey = new PublicKey(pubkeyData);
                return $275f7bb2bb263073$var$isOnCurve(pubkey.toBytes());
            }
        }
    ]);
    return PublicKey;
}($275f7bb2bb263073$export$eabc71f011df675a);
$275f7bb2bb263073$var$_PublicKey = $275f7bb2bb263073$export$ca8b6604d6ce14de;
$275f7bb2bb263073$export$ca8b6604d6ce14de.default = new $275f7bb2bb263073$var$_PublicKey("11111111111111111111111111111111");
$275f7bb2bb263073$export$68d13ce9b4cc48f3.set($275f7bb2bb263073$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ var $275f7bb2bb263073$export$1ed4b10e4aba04a7 = /*#__PURE__*/ function() {
    "use strict";
    function Account(secretKey) {
        (0, $7dKN1._)(this, Account);
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            var secretKeyBuffer = $275f7bb2bb263073$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $275f7bb2bb263073$var$toBuffer($275f7bb2bb263073$var$generatePrivateKey());
            this._publicKey = $275f7bb2bb263073$var$toBuffer($275f7bb2bb263073$var$getPublicKey(this._secretKey));
        }
    }
    (0, $eW5pA._)(Account, [
        {
            key: "publicKey",
            get: /**
   * The public key for this account
   */ function get() {
                return new $275f7bb2bb263073$export$ca8b6604d6ce14de(this._publicKey);
            }
        },
        {
            key: "secretKey",
            get: /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ function get() {
                return (0, $ilnag.Buffer).concat([
                    this._secretKey,
                    this._publicKey
                ], 64);
            }
        }
    ]);
    return Account;
}();
var $275f7bb2bb263073$export$42bd37c1c64962b6 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ var $275f7bb2bb263073$export$4c6d5b89e1596f26 = 1232;
var $275f7bb2bb263073$export$3c3793d809f8b858 = 0x7f;
var $275f7bb2bb263073$export$14aee086fde78fa6 = 64;
var $275f7bb2bb263073$export$718fcd78527f88ed = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(TransactionExpiredBlockheightExceededError, Error1);
    var _super = (0, $hKD8n._)(TransactionExpiredBlockheightExceededError);
    function TransactionExpiredBlockheightExceededError(signature) {
        (0, $7dKN1._)(this, TransactionExpiredBlockheightExceededError);
        var _this;
        _this = _super.call(this, "Signature ".concat(signature, " has expired: block height exceeded."));
        _this.signature = void 0;
        _this.signature = signature;
        return _this;
    }
    return TransactionExpiredBlockheightExceededError;
}((0, $jShW9._)(Error));
Object.defineProperty($275f7bb2bb263073$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
var $275f7bb2bb263073$export$b822204c22e46bdf = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(TransactionExpiredTimeoutError, Error1);
    var _super = (0, $hKD8n._)(TransactionExpiredTimeoutError);
    function TransactionExpiredTimeoutError(signature, timeoutSeconds) {
        (0, $7dKN1._)(this, TransactionExpiredTimeoutError);
        var _this;
        _this = _super.call(this, "Transaction was not confirmed in ".concat(timeoutSeconds.toFixed(2), " seconds. It is ") + "unknown if it succeeded or failed. Check signature " + "".concat(signature, " using the Solana Explorer or CLI tools."));
        _this.signature = void 0;
        _this.signature = signature;
        return _this;
    }
    return TransactionExpiredTimeoutError;
}((0, $jShW9._)(Error));
Object.defineProperty($275f7bb2bb263073$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
var $275f7bb2bb263073$export$a3e7565a95f5a1e5 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(TransactionExpiredNonceInvalidError, Error1);
    var _super = (0, $hKD8n._)(TransactionExpiredNonceInvalidError);
    function TransactionExpiredNonceInvalidError(signature) {
        (0, $7dKN1._)(this, TransactionExpiredNonceInvalidError);
        var _this;
        _this = _super.call(this, "Signature ".concat(signature, " has expired: the nonce is no longer valid."));
        _this.signature = void 0;
        _this.signature = signature;
        return _this;
    }
    return TransactionExpiredNonceInvalidError;
}((0, $jShW9._)(Error));
Object.defineProperty($275f7bb2bb263073$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
var $275f7bb2bb263073$export$109914c107623102 = /*#__PURE__*/ function() {
    "use strict";
    function MessageAccountKeys(staticAccountKeys, accountKeysFromLookups) {
        (0, $7dKN1._)(this, MessageAccountKeys);
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    (0, $eW5pA._)(MessageAccountKeys, [
        {
            key: "keySegments",
            value: function keySegments() {
                var keySegments = [
                    this.staticAccountKeys
                ];
                if (this.accountKeysFromLookups) {
                    keySegments.push(this.accountKeysFromLookups.writable);
                    keySegments.push(this.accountKeysFromLookups.readonly);
                }
                return keySegments;
            }
        },
        {
            key: "get",
            value: function get(index) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.keySegments()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var keySegment = _step.value;
                        if (index < keySegment.length) return keySegment[index];
                        else index -= keySegment.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.keySegments().flat().length;
            }
        },
        {
            key: "compileInstructions",
            value: function compileInstructions(instructions) {
                // Bail early if any account indexes would overflow a u8
                var U8_MAX = 255;
                if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
                var keyIndexMap = new Map();
                this.keySegments().flat().forEach(function(key, index) {
                    keyIndexMap.set(key.toBase58(), index);
                });
                var findKeyIndex = function(key) {
                    var keyIndex = keyIndexMap.get(key.toBase58());
                    if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
                    return keyIndex;
                };
                return instructions.map(function(instruction) {
                    return {
                        programIdIndex: findKeyIndex(instruction.programId),
                        accountKeyIndexes: instruction.keys.map(function(meta) {
                            return findKeyIndex(meta.pubkey);
                        }),
                        data: instruction.data
                    };
                });
            }
        }
    ]);
    return MessageAccountKeys;
}();
/**
 * Layout for a public key
 */ var $275f7bb2bb263073$var$publicKey = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "publicKey";
    return $i4x6j.blob(32, property);
};
/**
 * Layout for a signature
 */ var $275f7bb2bb263073$var$signature = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "signature";
    return $i4x6j.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ var $275f7bb2bb263073$var$rustString = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "string";
    var rsl = $i4x6j.struct([
        $i4x6j.u32("length"),
        $i4x6j.u32("lengthPadding"),
        $i4x6j.blob($i4x6j.offset($i4x6j.u32(), -8), "chars")
    ], property);
    var _decode = rsl.decode.bind(rsl);
    var _encode = rsl.encode.bind(rsl);
    var rslShim = rsl;
    rslShim.decode = function(b, offset) {
        var data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = function(str, b, offset) {
        var data = {
            chars: (0, $ilnag.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = function(str) {
        return $i4x6j.u32().span + $i4x6j.u32().span + (0, $ilnag.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ var $275f7bb2bb263073$var$authorized = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "authorized";
    return $i4x6j.struct([
        $275f7bb2bb263073$var$publicKey("staker"),
        $275f7bb2bb263073$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ var $275f7bb2bb263073$var$lockup = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "lockup";
    return $i4x6j.struct([
        $i4x6j.ns64("unixTimestamp"),
        $i4x6j.ns64("epoch"),
        $275f7bb2bb263073$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ var $275f7bb2bb263073$var$voteInit = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "voteInit";
    return $i4x6j.struct([
        $275f7bb2bb263073$var$publicKey("nodePubkey"),
        $275f7bb2bb263073$var$publicKey("authorizedVoter"),
        $275f7bb2bb263073$var$publicKey("authorizedWithdrawer"),
        $i4x6j.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ var $275f7bb2bb263073$var$voteAuthorizeWithSeedArgs = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "voteAuthorizeWithSeedArgs";
    return $i4x6j.struct([
        $i4x6j.u32("voteAuthorizationType"),
        $275f7bb2bb263073$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $275f7bb2bb263073$var$rustString("currentAuthorityDerivedKeySeed"),
        $275f7bb2bb263073$var$publicKey("newAuthorized")
    ], property);
};
function $275f7bb2bb263073$var$getAlloc(type, fields) {
    var getItemAlloc = function(item) {
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            var field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $275f7bb2bb263073$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    var alloc = 0;
    type.layout.fields.forEach(function(item) {
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $275f7bb2bb263073$var$decodeLength(bytes) {
    var len = 0;
    var size = 0;
    for(;;){
        var elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $275f7bb2bb263073$var$encodeLength(bytes, len) {
    var rem_len = len;
    for(;;){
        var elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $275f7bb2bb263073$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
var $275f7bb2bb263073$var$CompiledKeys = /*#__PURE__*/ function() {
    "use strict";
    function CompiledKeys(payer, keyMetaMap) {
        (0, $7dKN1._)(this, CompiledKeys);
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    (0, $eW5pA._)(CompiledKeys, [
        {
            key: "getMessageComponents",
            value: function getMessageComponents() {
                var mapEntries = (0, $gF0bR._)(this.keyMetaMap.entries());
                $275f7bb2bb263073$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
                var writableSigners = mapEntries.filter(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), meta = _param[1];
                    return meta.isSigner && meta.isWritable;
                });
                var readonlySigners = mapEntries.filter(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), meta = _param[1];
                    return meta.isSigner && !meta.isWritable;
                });
                var writableNonSigners = mapEntries.filter(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), meta = _param[1];
                    return !meta.isSigner && meta.isWritable;
                });
                var readonlyNonSigners = mapEntries.filter(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), meta = _param[1];
                    return !meta.isSigner && !meta.isWritable;
                });
                var header = {
                    numRequiredSignatures: writableSigners.length + readonlySigners.length,
                    numReadonlySignedAccounts: readonlySigners.length,
                    numReadonlyUnsignedAccounts: readonlyNonSigners.length
                };
                // sanity checks
                {
                    $275f7bb2bb263073$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
                    var _writableSigners_ = (0, $5OlIx._)(writableSigners[0], 1), payerAddress = _writableSigners_[0];
                    $275f7bb2bb263073$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
                }
                var staticAccountKeys = (0, $gF0bR._)(writableSigners.map(function(param) {
                    var _param = (0, $5OlIx._)(param, 1), address = _param[0];
                    return new $275f7bb2bb263073$export$ca8b6604d6ce14de(address);
                })).concat((0, $gF0bR._)(readonlySigners.map(function(param) {
                    var _param = (0, $5OlIx._)(param, 1), address = _param[0];
                    return new $275f7bb2bb263073$export$ca8b6604d6ce14de(address);
                })), (0, $gF0bR._)(writableNonSigners.map(function(param) {
                    var _param = (0, $5OlIx._)(param, 1), address = _param[0];
                    return new $275f7bb2bb263073$export$ca8b6604d6ce14de(address);
                })), (0, $gF0bR._)(readonlyNonSigners.map(function(param) {
                    var _param = (0, $5OlIx._)(param, 1), address = _param[0];
                    return new $275f7bb2bb263073$export$ca8b6604d6ce14de(address);
                })));
                return [
                    header,
                    staticAccountKeys
                ];
            }
        },
        {
            key: "extractTableLookup",
            value: function extractTableLookup(lookupTable) {
                var _this_drainKeysFoundInLookupTable = (0, $5OlIx._)(this.drainKeysFoundInLookupTable(lookupTable.state.addresses, function(keyMeta) {
                    return !keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable;
                }), 2), writableIndexes = _this_drainKeysFoundInLookupTable[0], drainedWritableKeys = _this_drainKeysFoundInLookupTable[1];
                var _this_drainKeysFoundInLookupTable1 = (0, $5OlIx._)(this.drainKeysFoundInLookupTable(lookupTable.state.addresses, function(keyMeta) {
                    return !keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable;
                }), 2), readonlyIndexes = _this_drainKeysFoundInLookupTable1[0], drainedReadonlyKeys = _this_drainKeysFoundInLookupTable1[1];
                // Don't extract lookup if no keys were found
                if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
                return [
                    {
                        accountKey: lookupTable.key,
                        writableIndexes: writableIndexes,
                        readonlyIndexes: readonlyIndexes
                    },
                    {
                        writable: drainedWritableKeys,
                        readonly: drainedReadonlyKeys
                    }
                ];
            }
        },
        {
            /** @internal */ key: "drainKeysFoundInLookupTable",
            value: function drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
                var lookupTableIndexes = new Array();
                var drainedKeys = new Array();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this = this, _loop = function() {
                        var _step_value = (0, $5OlIx._)(_step.value, 2), address = _step_value[0], keyMeta = _step_value[1];
                        if (keyMetaFilter(keyMeta)) {
                            var key = new $275f7bb2bb263073$export$ca8b6604d6ce14de(address);
                            var lookupTableIndex = lookupTableEntries.findIndex(function(entry) {
                                return entry.equals(key);
                            });
                            if (lookupTableIndex >= 0) {
                                $275f7bb2bb263073$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                                lookupTableIndexes.push(lookupTableIndex);
                                drainedKeys.push(key);
                                _this.keyMetaMap.delete(address);
                            }
                        }
                    };
                    for(var _iterator = this.keyMetaMap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    lookupTableIndexes,
                    drainedKeys
                ];
            }
        }
    ], [
        {
            key: "compile",
            value: function compile(instructions, payer) {
                var keyMetaMap = new Map();
                var getOrInsertDefault = function(pubkey) {
                    var address = pubkey.toBase58();
                    var keyMeta = keyMetaMap.get(address);
                    if (keyMeta === undefined) {
                        keyMeta = {
                            isSigner: false,
                            isWritable: false,
                            isInvoked: false
                        };
                        keyMetaMap.set(address, keyMeta);
                    }
                    return keyMeta;
                };
                var payerKeyMeta = getOrInsertDefault(payer);
                payerKeyMeta.isSigner = true;
                payerKeyMeta.isWritable = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = instructions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ix = _step.value;
                        getOrInsertDefault(ix.programId).isInvoked = true;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = ix.keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var accountMeta = _step1.value;
                                var _keyMeta, _keyMeta1;
                                var keyMeta = getOrInsertDefault(accountMeta.pubkey);
                                (_keyMeta = keyMeta).isSigner || (_keyMeta.isSigner = accountMeta.isSigner);
                                (_keyMeta1 = keyMeta).isWritable || (_keyMeta1.isWritable = accountMeta.isWritable);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new CompiledKeys(payer, keyMetaMap);
            }
        }
    ]);
    return CompiledKeys;
}();
var $275f7bb2bb263073$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $275f7bb2bb263073$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($275f7bb2bb263073$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $275f7bb2bb263073$var$guardedSplice(byteArray) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _byteArray;
    var _args = (0, $5OlIx._)(args, 1), start = _args[0];
    var _args_;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + ((_args_ = args[1]) !== null && _args_ !== void 0 ? _args_ : 0) > byteArray.length : start >= byteArray.length) throw new Error($275f7bb2bb263073$var$END_OF_BUFFER_ERROR_MESSAGE);
    return (_byteArray = byteArray).splice.apply(_byteArray, (0, $gF0bR._)(args));
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ var $275f7bb2bb263073$export$f69c19e57285b83a = /*#__PURE__*/ function() {
    "use strict";
    function Message(args) {
        var _this = this;
        (0, $7dKN1._)(this, Message);
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map(function(account) {
            return new $275f7bb2bb263073$export$ca8b6604d6ce14de(account);
        });
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach(function(ix) {
            return _this.indexToProgramIds.set(ix.programIdIndex, _this.accountKeys[ix.programIdIndex]);
        });
    }
    (0, $eW5pA._)(Message, [
        {
            key: "version",
            get: function get() {
                return "legacy";
            }
        },
        {
            key: "staticAccountKeys",
            get: function get() {
                return this.accountKeys;
            }
        },
        {
            key: "compiledInstructions",
            get: function get() {
                return this.instructions.map(function(ix) {
                    return {
                        programIdIndex: ix.programIdIndex,
                        accountKeyIndexes: ix.accounts,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(ix.data)
                    };
                });
            }
        },
        {
            key: "addressTableLookups",
            get: function get() {
                return [];
            }
        },
        {
            key: "getAccountKeys",
            value: function getAccountKeys() {
                return new $275f7bb2bb263073$export$109914c107623102(this.staticAccountKeys);
            }
        },
        {
            key: "isAccountSigner",
            value: function isAccountSigner(index) {
                return index < this.header.numRequiredSignatures;
            }
        },
        {
            key: "isAccountWritable",
            value: function isAccountWritable(index) {
                var numSignedAccounts = this.header.numRequiredSignatures;
                if (index >= this.header.numRequiredSignatures) {
                    var unsignedAccountIndex = index - numSignedAccounts;
                    var numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
                    var numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
                    return unsignedAccountIndex < numWritableUnsignedAccounts;
                } else {
                    var numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
                    return index < numWritableSignedAccounts;
                }
            }
        },
        {
            key: "isProgramId",
            value: function isProgramId(index) {
                return this.indexToProgramIds.has(index);
            }
        },
        {
            key: "programIds",
            value: function programIds() {
                return (0, $gF0bR._)(this.indexToProgramIds.values());
            }
        },
        {
            key: "nonProgramIds",
            value: function nonProgramIds() {
                var _this = this;
                return this.accountKeys.filter(function(_, index) {
                    return !_this.isProgramId(index);
                });
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var numKeys = this.accountKeys.length;
                var keyCount = [];
                $275f7bb2bb263073$var$encodeLength(keyCount, numKeys);
                var instructions = this.instructions.map(function(instruction) {
                    var accounts = instruction.accounts, programIdIndex = instruction.programIdIndex;
                    var data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(instruction.data));
                    var keyIndicesCount = [];
                    $275f7bb2bb263073$var$encodeLength(keyIndicesCount, accounts.length);
                    var dataCount = [];
                    $275f7bb2bb263073$var$encodeLength(dataCount, data.length);
                    return {
                        programIdIndex: programIdIndex,
                        keyIndicesCount: (0, $ilnag.Buffer).from(keyIndicesCount),
                        keyIndices: accounts,
                        dataLength: (0, $ilnag.Buffer).from(dataCount),
                        data: data
                    };
                });
                var instructionCount = [];
                $275f7bb2bb263073$var$encodeLength(instructionCount, instructions.length);
                var instructionBuffer = (0, $ilnag.Buffer).alloc($275f7bb2bb263073$export$4c6d5b89e1596f26);
                (0, $ilnag.Buffer).from(instructionCount).copy(instructionBuffer);
                var instructionBufferLength = instructionCount.length;
                instructions.forEach(function(instruction) {
                    var instructionLayout = $i4x6j.struct([
                        $i4x6j.u8("programIdIndex"),
                        $i4x6j.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                        $i4x6j.seq($i4x6j.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                        $i4x6j.blob(instruction.dataLength.length, "dataLength"),
                        $i4x6j.seq($i4x6j.u8("userdatum"), instruction.data.length, "data")
                    ]);
                    var length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
                    instructionBufferLength += length;
                });
                instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
                var signDataLayout = $i4x6j.struct([
                    $i4x6j.blob(1, "numRequiredSignatures"),
                    $i4x6j.blob(1, "numReadonlySignedAccounts"),
                    $i4x6j.blob(1, "numReadonlyUnsignedAccounts"),
                    $i4x6j.blob(keyCount.length, "keyCount"),
                    $i4x6j.seq($275f7bb2bb263073$var$publicKey("key"), numKeys, "keys"),
                    $275f7bb2bb263073$var$publicKey("recentBlockhash")
                ]);
                var transaction = {
                    numRequiredSignatures: (0, $ilnag.Buffer).from([
                        this.header.numRequiredSignatures
                    ]),
                    numReadonlySignedAccounts: (0, $ilnag.Buffer).from([
                        this.header.numReadonlySignedAccounts
                    ]),
                    numReadonlyUnsignedAccounts: (0, $ilnag.Buffer).from([
                        this.header.numReadonlyUnsignedAccounts
                    ]),
                    keyCount: (0, $ilnag.Buffer).from(keyCount),
                    keys: this.accountKeys.map(function(key) {
                        return $275f7bb2bb263073$var$toBuffer(key.toBytes());
                    }),
                    recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(this.recentBlockhash)
                };
                var signData = (0, $ilnag.Buffer).alloc(2048);
                var length = signDataLayout.encode(transaction, signData);
                instructionBuffer.copy(signData, length);
                return signData.slice(0, length + instructionBuffer.length);
            }
        }
    ], [
        {
            key: "compile",
            value: function compile(args) {
                var compiledKeys = $275f7bb2bb263073$var$CompiledKeys.compile(args.instructions, args.payerKey);
                var _compiledKeys_getMessageComponents = (0, $5OlIx._)(compiledKeys.getMessageComponents(), 2), header = _compiledKeys_getMessageComponents[0], staticAccountKeys = _compiledKeys_getMessageComponents[1];
                var accountKeys = new $275f7bb2bb263073$export$109914c107623102(staticAccountKeys);
                var instructions = accountKeys.compileInstructions(args.instructions).map(function(ix) {
                    return {
                        programIdIndex: ix.programIdIndex,
                        accounts: ix.accountKeyIndexes,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode(ix.data)
                    };
                });
                return new Message({
                    header: header,
                    accountKeys: staticAccountKeys,
                    recentBlockhash: args.recentBlockhash,
                    instructions: instructions
                });
            }
        },
        {
            key: "from",
            value: /**
   * Decode a compiled message into a Message object.
   */ function from(buffer) {
                // Slice up wire data
                var byteArray = (0, $gF0bR._)(buffer);
                var numRequiredSignatures = $275f7bb2bb263073$var$guardedShift(byteArray);
                if (numRequiredSignatures !== (numRequiredSignatures & $275f7bb2bb263073$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
                var numReadonlySignedAccounts = $275f7bb2bb263073$var$guardedShift(byteArray);
                var numReadonlyUnsignedAccounts = $275f7bb2bb263073$var$guardedShift(byteArray);
                var accountCount = $275f7bb2bb263073$var$decodeLength(byteArray);
                var accountKeys = [];
                for(var i = 0; i < accountCount; i++){
                    var account = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$84fc0a248cc54343);
                    accountKeys.push(new $275f7bb2bb263073$export$ca8b6604d6ce14de((0, $ilnag.Buffer).from(account)));
                }
                var recentBlockhash = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$84fc0a248cc54343);
                var instructionCount = $275f7bb2bb263073$var$decodeLength(byteArray);
                var instructions = [];
                for(var i1 = 0; i1 < instructionCount; i1++){
                    var programIdIndex = $275f7bb2bb263073$var$guardedShift(byteArray);
                    var accountCount1 = $275f7bb2bb263073$var$decodeLength(byteArray);
                    var accounts = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, accountCount1);
                    var dataLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                    var dataSlice = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, dataLength);
                    var data = (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode((0, $ilnag.Buffer).from(dataSlice));
                    instructions.push({
                        programIdIndex: programIdIndex,
                        accounts: accounts,
                        data: data
                    });
                }
                var messageArgs = {
                    header: {
                        numRequiredSignatures: numRequiredSignatures,
                        numReadonlySignedAccounts: numReadonlySignedAccounts,
                        numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
                    },
                    recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode((0, $ilnag.Buffer).from(recentBlockhash)),
                    accountKeys: accountKeys,
                    instructions: instructions
                };
                return new Message(messageArgs);
            }
        }
    ]);
    return Message;
}();
/**
 * Message constructor arguments
 */ var $275f7bb2bb263073$export$ee274c70e0fae590 = /*#__PURE__*/ function() {
    "use strict";
    function MessageV0(args) {
        (0, $7dKN1._)(this, MessageV0);
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    (0, $eW5pA._)(MessageV0, [
        {
            key: "version",
            get: function get() {
                return 0;
            }
        },
        {
            key: "numAccountKeysFromLookups",
            get: function get() {
                var count = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.addressTableLookups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lookup = _step.value;
                        count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return count;
            }
        },
        {
            key: "getAccountKeys",
            value: function getAccountKeys(args) {
                var accountKeysFromLookups;
                if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
                    if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
                    accountKeysFromLookups = args.accountKeysFromLookups;
                } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
                else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
                return new $275f7bb2bb263073$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
            }
        },
        {
            key: "isAccountSigner",
            value: function isAccountSigner(index) {
                return index < this.header.numRequiredSignatures;
            }
        },
        {
            key: "isAccountWritable",
            value: function isAccountWritable(index) {
                var numSignedAccounts = this.header.numRequiredSignatures;
                var numStaticAccountKeys = this.staticAccountKeys.length;
                if (index >= numStaticAccountKeys) {
                    var lookupAccountKeysIndex = index - numStaticAccountKeys;
                    var numWritableLookupAccountKeys = this.addressTableLookups.reduce(function(count, lookup) {
                        return count + lookup.writableIndexes.length;
                    }, 0);
                    return lookupAccountKeysIndex < numWritableLookupAccountKeys;
                } else if (index >= this.header.numRequiredSignatures) {
                    var unsignedAccountIndex = index - numSignedAccounts;
                    var numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
                    var numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
                    return unsignedAccountIndex < numWritableUnsignedAccounts;
                } else {
                    var numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
                    return index < numWritableSignedAccounts;
                }
            }
        },
        {
            key: "resolveAddressTableLookups",
            value: function resolveAddressTableLookups(addressLookupTableAccounts) {
                var accountKeysFromLookups = {
                    writable: [],
                    readonly: []
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var tableLookup = _step.value;
                        var tableAccount = addressLookupTableAccounts.find(function(account) {
                            return account.key.equals(tableLookup.accountKey);
                        });
                        if (!tableAccount) throw new Error("Failed to find address lookup table account for table key ".concat(tableLookup.accountKey.toBase58()));
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = tableLookup.writableIndexes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var index = _step1.value;
                                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                                else throw new Error("Failed to find address for index ".concat(index, " in address lookup table ").concat(tableLookup.accountKey.toBase58()));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = tableLookup.readonlyIndexes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var index1 = _step2.value;
                                if (index1 < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index1]);
                                else throw new Error("Failed to find address for index ".concat(index1, " in address lookup table ").concat(tableLookup.accountKey.toBase58()));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    };
                    for(var _iterator = this.addressTableLookups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return accountKeysFromLookups;
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var encodedStaticAccountKeysLength = Array();
                $275f7bb2bb263073$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
                var serializedInstructions = this.serializeInstructions();
                var encodedInstructionsLength = Array();
                $275f7bb2bb263073$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
                var serializedAddressTableLookups = this.serializeAddressTableLookups();
                var encodedAddressTableLookupsLength = Array();
                $275f7bb2bb263073$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
                var messageLayout = $i4x6j.struct([
                    $i4x6j.u8("prefix"),
                    $i4x6j.struct([
                        $i4x6j.u8("numRequiredSignatures"),
                        $i4x6j.u8("numReadonlySignedAccounts"),
                        $i4x6j.u8("numReadonlyUnsignedAccounts")
                    ], "header"),
                    $i4x6j.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
                    $i4x6j.seq($275f7bb2bb263073$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
                    $275f7bb2bb263073$var$publicKey("recentBlockhash"),
                    $i4x6j.blob(encodedInstructionsLength.length, "instructionsLength"),
                    $i4x6j.blob(serializedInstructions.length, "serializedInstructions"),
                    $i4x6j.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
                    $i4x6j.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
                ]);
                var serializedMessage = new Uint8Array($275f7bb2bb263073$export$4c6d5b89e1596f26);
                var MESSAGE_VERSION_0_PREFIX = 128;
                var serializedMessageLength = messageLayout.encode({
                    prefix: MESSAGE_VERSION_0_PREFIX,
                    header: this.header,
                    staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
                    staticAccountKeys: this.staticAccountKeys.map(function(key) {
                        return key.toBytes();
                    }),
                    recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(this.recentBlockhash),
                    instructionsLength: new Uint8Array(encodedInstructionsLength),
                    serializedInstructions: serializedInstructions,
                    addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
                    serializedAddressTableLookups: serializedAddressTableLookups
                }, serializedMessage);
                return serializedMessage.slice(0, serializedMessageLength);
            }
        },
        {
            key: "serializeInstructions",
            value: function serializeInstructions() {
                var serializedLength = 0;
                var serializedInstructions = new Uint8Array($275f7bb2bb263073$export$4c6d5b89e1596f26);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.compiledInstructions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var instruction = _step.value;
                        var encodedAccountKeyIndexesLength = Array();
                        $275f7bb2bb263073$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
                        var encodedDataLength = Array();
                        $275f7bb2bb263073$var$encodeLength(encodedDataLength, instruction.data.length);
                        var instructionLayout = $i4x6j.struct([
                            $i4x6j.u8("programIdIndex"),
                            $i4x6j.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                            $i4x6j.seq($i4x6j.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                            $i4x6j.blob(encodedDataLength.length, "encodedDataLength"),
                            $i4x6j.blob(instruction.data.length, "data")
                        ]);
                        serializedLength += instructionLayout.encode({
                            programIdIndex: instruction.programIdIndex,
                            encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                            accountKeyIndexes: instruction.accountKeyIndexes,
                            encodedDataLength: new Uint8Array(encodedDataLength),
                            data: instruction.data
                        }, serializedInstructions, serializedLength);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return serializedInstructions.slice(0, serializedLength);
            }
        },
        {
            key: "serializeAddressTableLookups",
            value: function serializeAddressTableLookups() {
                var serializedLength = 0;
                var serializedAddressTableLookups = new Uint8Array($275f7bb2bb263073$export$4c6d5b89e1596f26);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.addressTableLookups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lookup = _step.value;
                        var encodedWritableIndexesLength = Array();
                        $275f7bb2bb263073$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
                        var encodedReadonlyIndexesLength = Array();
                        $275f7bb2bb263073$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
                        var addressTableLookupLayout = $i4x6j.struct([
                            $275f7bb2bb263073$var$publicKey("accountKey"),
                            $i4x6j.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                            $i4x6j.seq($i4x6j.u8(), lookup.writableIndexes.length, "writableIndexes"),
                            $i4x6j.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                            $i4x6j.seq($i4x6j.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
                        ]);
                        serializedLength += addressTableLookupLayout.encode({
                            accountKey: lookup.accountKey.toBytes(),
                            encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                            writableIndexes: lookup.writableIndexes,
                            encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                            readonlyIndexes: lookup.readonlyIndexes
                        }, serializedAddressTableLookups, serializedLength);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return serializedAddressTableLookups.slice(0, serializedLength);
            }
        }
    ], [
        {
            key: "compile",
            value: function compile(args) {
                var compiledKeys = $275f7bb2bb263073$var$CompiledKeys.compile(args.instructions, args.payerKey);
                var addressTableLookups = new Array();
                var accountKeysFromLookups = {
                    writable: new Array(),
                    readonly: new Array()
                };
                var lookupTableAccounts = args.addressLookupTableAccounts || [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = lookupTableAccounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lookupTable = _step.value;
                        var extractResult = compiledKeys.extractTableLookup(lookupTable);
                        if (extractResult !== undefined) {
                            var _accountKeysFromLookups_writable, _accountKeysFromLookups_readonly;
                            var _extractResult = (0, $5OlIx._)(extractResult, 2), addressTableLookup = _extractResult[0], _extractResult_ = _extractResult[1], writable = _extractResult_.writable, readonly = _extractResult_.readonly;
                            addressTableLookups.push(addressTableLookup);
                            (_accountKeysFromLookups_writable = accountKeysFromLookups.writable).push.apply(_accountKeysFromLookups_writable, (0, $gF0bR._)(writable));
                            (_accountKeysFromLookups_readonly = accountKeysFromLookups.readonly).push.apply(_accountKeysFromLookups_readonly, (0, $gF0bR._)(readonly));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _compiledKeys_getMessageComponents = (0, $5OlIx._)(compiledKeys.getMessageComponents(), 2), header = _compiledKeys_getMessageComponents[0], staticAccountKeys = _compiledKeys_getMessageComponents[1];
                var accountKeys = new $275f7bb2bb263073$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
                var compiledInstructions = accountKeys.compileInstructions(args.instructions);
                return new MessageV0({
                    header: header,
                    staticAccountKeys: staticAccountKeys,
                    recentBlockhash: args.recentBlockhash,
                    compiledInstructions: compiledInstructions,
                    addressTableLookups: addressTableLookups
                });
            }
        },
        {
            key: "deserialize",
            value: function deserialize(serializedMessage) {
                var byteArray = (0, $gF0bR._)(serializedMessage);
                var prefix = $275f7bb2bb263073$var$guardedShift(byteArray);
                var maskedPrefix = prefix & $275f7bb2bb263073$export$3c3793d809f8b858;
                $275f7bb2bb263073$var$assert(prefix !== maskedPrefix, "Expected versioned message but received legacy message");
                var version = maskedPrefix;
                $275f7bb2bb263073$var$assert(version === 0, "Expected versioned message with version 0 but found version ".concat(version));
                var header = {
                    numRequiredSignatures: $275f7bb2bb263073$var$guardedShift(byteArray),
                    numReadonlySignedAccounts: $275f7bb2bb263073$var$guardedShift(byteArray),
                    numReadonlyUnsignedAccounts: $275f7bb2bb263073$var$guardedShift(byteArray)
                };
                var staticAccountKeys = [];
                var staticAccountKeysLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                for(var i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $275f7bb2bb263073$export$ca8b6604d6ce14de($275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$84fc0a248cc54343)));
                var recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode($275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$84fc0a248cc54343));
                var instructionCount = $275f7bb2bb263073$var$decodeLength(byteArray);
                var compiledInstructions = [];
                for(var i1 = 0; i1 < instructionCount; i1++){
                    var programIdIndex = $275f7bb2bb263073$var$guardedShift(byteArray);
                    var accountKeyIndexesLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                    var accountKeyIndexes = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
                    var dataLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                    var data = new Uint8Array($275f7bb2bb263073$var$guardedSplice(byteArray, 0, dataLength));
                    compiledInstructions.push({
                        programIdIndex: programIdIndex,
                        accountKeyIndexes: accountKeyIndexes,
                        data: data
                    });
                }
                var addressTableLookupsCount = $275f7bb2bb263073$var$decodeLength(byteArray);
                var addressTableLookups = [];
                for(var i2 = 0; i2 < addressTableLookupsCount; i2++){
                    var accountKey = new $275f7bb2bb263073$export$ca8b6604d6ce14de($275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$84fc0a248cc54343));
                    var writableIndexesLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                    var writableIndexes = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, writableIndexesLength);
                    var readonlyIndexesLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                    var readonlyIndexes = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
                    addressTableLookups.push({
                        accountKey: accountKey,
                        writableIndexes: writableIndexes,
                        readonlyIndexes: readonlyIndexes
                    });
                }
                return new MessageV0({
                    header: header,
                    staticAccountKeys: staticAccountKeys,
                    recentBlockhash: recentBlockhash,
                    compiledInstructions: compiledInstructions,
                    addressTableLookups: addressTableLookups
                });
            }
        }
    ]);
    return MessageV0;
}();
// eslint-disable-next-line no-redeclare
var $275f7bb2bb263073$export$b0a61927d00ede7f = {
    deserializeMessageVersion: function(serializedMessage) {
        var prefix = serializedMessage[0];
        var maskedPrefix = prefix & $275f7bb2bb263073$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: function(serializedMessage) {
        var version = $275f7bb2bb263073$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $275f7bb2bb263073$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $275f7bb2bb263073$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error("Transaction message version ".concat(version, " deserialization is not supported"));
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ var $275f7bb2bb263073$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ var $275f7bb2bb263073$var$DEFAULT_SIGNATURE = (0, $ilnag.Buffer).alloc($275f7bb2bb263073$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ var $275f7bb2bb263073$export$a7a3aa8360ac9f59 = /*#__PURE__*/ function() {
    "use strict";
    function TransactionInstruction(opts) {
        (0, $7dKN1._)(this, TransactionInstruction);
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $ilnag.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    (0, $eW5pA._)(TransactionInstruction, [
        {
            /**
   * @internal
   */ key: "toJSON",
            value: function toJSON() {
                return {
                    keys: this.keys.map(function(param) {
                        var pubkey = param.pubkey, isSigner = param.isSigner, isWritable = param.isWritable;
                        return {
                            pubkey: pubkey.toJSON(),
                            isSigner: isSigner,
                            isWritable: isWritable
                        };
                    }),
                    programId: this.programId.toJSON(),
                    data: (0, $gF0bR._)(this.data)
                };
            }
        }
    ]);
    return TransactionInstruction;
}();
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ var $275f7bb2bb263073$export$febc5573c75cefb0 = /*#__PURE__*/ function() {
    "use strict";
    function Transaction(opts) {
        (0, $7dKN1._)(this, Transaction);
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            var minContextSlot = opts.minContextSlot, nonceInfo = opts.nonceInfo;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            var blockhash = opts.blockhash, lastValidBlockHeight = opts.lastValidBlockHeight;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            var recentBlockhash = opts.recentBlockhash, nonceInfo1 = opts.nonceInfo;
            if (nonceInfo1) this.nonceInfo = nonceInfo1;
            this.recentBlockhash = recentBlockhash;
        }
    }
    (0, $eW5pA._)(Transaction, [
        {
            key: "signature",
            get: /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ function get() {
                if (this.signatures.length > 0) return this.signatures[0].signature;
                return null;
            }
        },
        {
            /**
   * @internal
   */ key: "toJSON",
            value: function toJSON() {
                return {
                    recentBlockhash: this.recentBlockhash || null,
                    feePayer: this.feePayer ? this.feePayer.toJSON() : null,
                    nonceInfo: this.nonceInfo ? {
                        nonce: this.nonceInfo.nonce,
                        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
                    } : null,
                    instructions: this.instructions.map(function(instruction) {
                        return instruction.toJSON();
                    }),
                    signers: this.signatures.map(function(param) {
                        var publicKey = param.publicKey;
                        return publicKey.toJSON();
                    })
                };
            }
        },
        {
            /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ key: "add",
            value: function add() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                var _this = this;
                if (items.length === 0) throw new Error("No instructions");
                items.forEach(function(item) {
                    if ("instructions" in item) _this.instructions = _this.instructions.concat(item.instructions);
                    else if ("data" in item && "programId" in item && "keys" in item) _this.instructions.push(item);
                    else _this.instructions.push(new $275f7bb2bb263073$export$a7a3aa8360ac9f59(item));
                });
                return this;
            }
        },
        {
            /**
   * Compile transaction data
   */ key: "compileMessage",
            value: function compileMessage() {
                if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
                var recentBlockhash;
                var instructions;
                if (this.nonceInfo) {
                    recentBlockhash = this.nonceInfo.nonce;
                    if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                        this.nonceInfo.nonceInstruction
                    ].concat((0, $gF0bR._)(this.instructions));
                    else instructions = this.instructions;
                } else {
                    recentBlockhash = this.recentBlockhash;
                    instructions = this.instructions;
                }
                if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
                if (instructions.length < 1) console.warn("No instructions provided");
                var feePayer;
                if (this.feePayer) feePayer = this.feePayer;
                else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
                feePayer = this.signatures[0].publicKey;
                else throw new Error("Transaction fee payer required");
                for(var i = 0; i < instructions.length; i++){
                    if (instructions[i].programId === undefined) throw new Error("Transaction instruction index ".concat(i, " has undefined program id"));
                }
                var programIds = [];
                var accountMetas = [];
                instructions.forEach(function(instruction) {
                    instruction.keys.forEach(function(accountMeta) {
                        accountMetas.push((0, $4JCw4._)({}, accountMeta));
                    });
                    var programId = instruction.programId.toString();
                    if (!programIds.includes(programId)) programIds.push(programId);
                });
                // Append programID account metas
                programIds.forEach(function(programId) {
                    accountMetas.push({
                        pubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId),
                        isSigner: false,
                        isWritable: false
                    });
                });
                // Cull duplicate account metas
                var uniqueMetas = [];
                accountMetas.forEach(function(accountMeta) {
                    var pubkeyString = accountMeta.pubkey.toString();
                    var uniqueIndex = uniqueMetas.findIndex(function(x) {
                        return x.pubkey.toString() === pubkeyString;
                    });
                    if (uniqueIndex > -1) {
                        uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                        uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
                    } else uniqueMetas.push(accountMeta);
                });
                // Sort. Prioritizing first by signer, then by writable
                uniqueMetas.sort(function(x, y) {
                    if (x.isSigner !== y.isSigner) // Signers always come before non-signers
                    return x.isSigner ? -1 : 1;
                    if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
                    return x.isWritable ? -1 : 1;
                    // Otherwise, sort by pubkey, stringwise.
                    var options = {
                        localeMatcher: "best fit",
                        usage: "sort",
                        sensitivity: "variant",
                        ignorePunctuation: false,
                        numeric: false,
                        caseFirst: "lower"
                    };
                    return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
                });
                // Move fee payer to the front
                var feePayerIndex = uniqueMetas.findIndex(function(x) {
                    return x.pubkey.equals(feePayer);
                });
                if (feePayerIndex > -1) {
                    var _uniqueMetas_splice = (0, $5OlIx._)(uniqueMetas.splice(feePayerIndex, 1), 1), payerMeta = _uniqueMetas_splice[0];
                    payerMeta.isSigner = true;
                    payerMeta.isWritable = true;
                    uniqueMetas.unshift(payerMeta);
                } else uniqueMetas.unshift({
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: true
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var signature = _step.value;
                        var uniqueIndex = uniqueMetas.findIndex(function(x) {
                            return x.pubkey.equals(signature.publicKey);
                        });
                        if (uniqueIndex > -1) {
                            if (!uniqueMetas[uniqueIndex].isSigner) {
                                uniqueMetas[uniqueIndex].isSigner = true;
                                console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                            }
                        } else throw new Error("unknown signer: ".concat(signature.publicKey.toString()));
                    };
                    // Disallow unknown signers
                    for(var _iterator = this.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var numRequiredSignatures = 0;
                var numReadonlySignedAccounts = 0;
                var numReadonlyUnsignedAccounts = 0;
                // Split out signing from non-signing keys and count header values
                var signedKeys = [];
                var unsignedKeys = [];
                uniqueMetas.forEach(function(param) {
                    var pubkey = param.pubkey, isSigner = param.isSigner, isWritable = param.isWritable;
                    if (isSigner) {
                        signedKeys.push(pubkey.toString());
                        numRequiredSignatures += 1;
                        if (!isWritable) numReadonlySignedAccounts += 1;
                    } else {
                        unsignedKeys.push(pubkey.toString());
                        if (!isWritable) numReadonlyUnsignedAccounts += 1;
                    }
                });
                var accountKeys = signedKeys.concat(unsignedKeys);
                var compiledInstructions = instructions.map(function(instruction) {
                    var data = instruction.data, programId = instruction.programId;
                    return {
                        programIdIndex: accountKeys.indexOf(programId.toString()),
                        accounts: instruction.keys.map(function(meta) {
                            return accountKeys.indexOf(meta.pubkey.toString());
                        }),
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode(data)
                    };
                });
                compiledInstructions.forEach(function(instruction) {
                    $275f7bb2bb263073$var$assert(instruction.programIdIndex >= 0);
                    instruction.accounts.forEach(function(keyIndex) {
                        return $275f7bb2bb263073$var$assert(keyIndex >= 0);
                    });
                });
                return new $275f7bb2bb263073$export$f69c19e57285b83a({
                    header: {
                        numRequiredSignatures: numRequiredSignatures,
                        numReadonlySignedAccounts: numReadonlySignedAccounts,
                        numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
                    },
                    accountKeys: accountKeys,
                    recentBlockhash: recentBlockhash,
                    instructions: compiledInstructions
                });
            }
        },
        {
            /**
   * @internal
   */ key: "_compile",
            value: function _compile() {
                var message = this.compileMessage();
                var signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
                if (this.signatures.length === signedKeys.length) {
                    var valid = this.signatures.every(function(pair, index) {
                        return signedKeys[index].equals(pair.publicKey);
                    });
                    if (valid) return message;
                }
                this.signatures = signedKeys.map(function(publicKey) {
                    return {
                        signature: null,
                        publicKey: publicKey
                    };
                });
                return message;
            }
        },
        {
            /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ key: "serializeMessage",
            value: function serializeMessage() {
                return this._compile().serialize();
            }
        },
        {
            key: "getEstimatedFee",
            value: /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ function getEstimatedFee(connection) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    connection.getFeeForMessage(_this.compileMessage())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().value
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ key: "setSigners",
            value: function setSigners() {
                for(var _len = arguments.length, signers = new Array(_len), _key = 0; _key < _len; _key++){
                    signers[_key] = arguments[_key];
                }
                if (signers.length === 0) throw new Error("No signers");
                var seen = new Set();
                this.signatures = signers.filter(function(publicKey) {
                    var key = publicKey.toString();
                    if (seen.has(key)) return false;
                    else {
                        seen.add(key);
                        return true;
                    }
                }).map(function(publicKey) {
                    return {
                        signature: null,
                        publicKey: publicKey
                    };
                });
            }
        },
        {
            /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ key: "sign",
            value: function sign() {
                for(var _len = arguments.length, signers = new Array(_len), _key = 0; _key < _len; _key++){
                    signers[_key] = arguments[_key];
                }
                if (signers.length === 0) throw new Error("No signers");
                // Dedupe signers
                var seen = new Set();
                var uniqueSigners = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = signers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var signer = _step.value;
                        var key = signer.publicKey.toString();
                        if (seen.has(key)) continue;
                        else {
                            seen.add(key);
                            uniqueSigners.push(signer);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.signatures = uniqueSigners.map(function(signer) {
                    return {
                        signature: null,
                        publicKey: signer.publicKey
                    };
                });
                var message = this._compile();
                this._partialSign.apply(this, [
                    message
                ].concat((0, $gF0bR._)(uniqueSigners)));
            }
        },
        {
            /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ key: "partialSign",
            value: function partialSign() {
                for(var _len = arguments.length, signers = new Array(_len), _key = 0; _key < _len; _key++){
                    signers[_key] = arguments[_key];
                }
                if (signers.length === 0) throw new Error("No signers");
                // Dedupe signers
                var seen = new Set();
                var uniqueSigners = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = signers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var signer = _step.value;
                        var key = signer.publicKey.toString();
                        if (seen.has(key)) continue;
                        else {
                            seen.add(key);
                            uniqueSigners.push(signer);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var message = this._compile();
                this._partialSign.apply(this, [
                    message
                ].concat((0, $gF0bR._)(uniqueSigners)));
            }
        },
        {
            /**
   * @internal
   */ key: "_partialSign",
            value: function _partialSign(message) {
                for(var _len = arguments.length, signers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    signers[_key - 1] = arguments[_key];
                }
                var _this = this;
                var signData = message.serialize();
                signers.forEach(function(signer) {
                    var signature = $275f7bb2bb263073$var$sign(signData, signer.secretKey);
                    _this._addSignature(signer.publicKey, $275f7bb2bb263073$var$toBuffer(signature));
                });
            }
        },
        {
            /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ key: "addSignature",
            value: function addSignature(pubkey, signature) {
                this._compile(); // Ensure signatures array is populated
                this._addSignature(pubkey, signature);
            }
        },
        {
            /**
   * @internal
   */ key: "_addSignature",
            value: function _addSignature(pubkey, signature) {
                $275f7bb2bb263073$var$assert(signature.length === 64);
                var index = this.signatures.findIndex(function(sigpair) {
                    return pubkey.equals(sigpair.publicKey);
                });
                if (index < 0) throw new Error("unknown signer: ".concat(pubkey.toString()));
                this.signatures[index].signature = (0, $ilnag.Buffer).from(signature);
            }
        },
        {
            /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ key: "verifySignatures",
            value: function verifySignatures() {
                var requireAllSignatures = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
                return !signatureErrors;
            }
        },
        {
            /**
   * @internal
   */ key: "_getMessageSignednessErrors",
            value: function _getMessageSignednessErrors(message, requireAllSignatures) {
                var errors = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, signature = _step_value.signature, publicKey = _step_value.publicKey;
                        var _errors, _errors1;
                        if (signature === null) {
                            if (requireAllSignatures) ((_errors = errors).missing || (_errors.missing = [])).push(publicKey);
                        } else if (!$275f7bb2bb263073$var$verify(signature, message, publicKey.toBytes())) ((_errors1 = errors).invalid || (_errors1.invalid = [])).push(publicKey);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return errors.invalid || errors.missing ? errors : undefined;
            }
        },
        {
            /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ key: "serialize",
            value: function serialize(config) {
                var _Object_assign = Object.assign({
                    requireAllSignatures: true,
                    verifySignatures: true
                }, config), requireAllSignatures = _Object_assign.requireAllSignatures, verifySignatures = _Object_assign.verifySignatures;
                var signData = this.serializeMessage();
                if (verifySignatures) {
                    var sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
                    if (sigErrors) {
                        var errorMessage = "Signature verification failed.";
                        if (sigErrors.invalid) errorMessage += "\nInvalid signature for public key".concat(sigErrors.invalid.length === 1 ? "" : "(s)", " [`").concat(sigErrors.invalid.map(function(p) {
                            return p.toBase58();
                        }).join("`, `"), "`].");
                        if (sigErrors.missing) errorMessage += "\nMissing signature for public key".concat(sigErrors.missing.length === 1 ? "" : "(s)", " [`").concat(sigErrors.missing.map(function(p) {
                            return p.toBase58();
                        }).join("`, `"), "`].");
                        throw new Error(errorMessage);
                    }
                }
                return this._serialize(signData);
            }
        },
        {
            /**
   * @internal
   */ key: "_serialize",
            value: function _serialize(signData) {
                var signatures = this.signatures;
                var signatureCount = [];
                $275f7bb2bb263073$var$encodeLength(signatureCount, signatures.length);
                var transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
                var wireTransaction = (0, $ilnag.Buffer).alloc(transactionLength);
                $275f7bb2bb263073$var$assert(signatures.length < 256);
                (0, $ilnag.Buffer).from(signatureCount).copy(wireTransaction, 0);
                signatures.forEach(function(param, index) {
                    var signature = param.signature;
                    if (signature !== null) {
                        $275f7bb2bb263073$var$assert(signature.length === 64, "signature has invalid length");
                        (0, $ilnag.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
                    }
                });
                signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
                $275f7bb2bb263073$var$assert(wireTransaction.length <= $275f7bb2bb263073$export$4c6d5b89e1596f26, "Transaction too large: ".concat(wireTransaction.length, " > ").concat($275f7bb2bb263073$export$4c6d5b89e1596f26));
                return wireTransaction;
            }
        },
        {
            key: "keys",
            get: /**
   * Deprecated method
   * @internal
   */ function get() {
                $275f7bb2bb263073$var$assert(this.instructions.length === 1);
                return this.instructions[0].keys.map(function(keyObj) {
                    return keyObj.pubkey;
                });
            }
        },
        {
            key: "programId",
            get: /**
   * Deprecated method
   * @internal
   */ function get() {
                $275f7bb2bb263073$var$assert(this.instructions.length === 1);
                return this.instructions[0].programId;
            }
        },
        {
            key: "data",
            get: /**
   * Deprecated method
   * @internal
   */ function get() {
                $275f7bb2bb263073$var$assert(this.instructions.length === 1);
                return this.instructions[0].data;
            }
        }
    ], [
        {
            key: "from",
            value: /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ function from(buffer) {
                // Slice up wire data
                var byteArray = (0, $gF0bR._)(buffer);
                var signatureCount = $275f7bb2bb263073$var$decodeLength(byteArray);
                var signatures = [];
                for(var i = 0; i < signatureCount; i++){
                    var signature = $275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$14aee086fde78fa6);
                    signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode((0, $ilnag.Buffer).from(signature)));
                }
                return Transaction.populate($275f7bb2bb263073$export$f69c19e57285b83a.from(byteArray), signatures);
            }
        },
        {
            key: "populate",
            value: /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ function populate(message) {
                var signatures = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var transaction = new Transaction();
                transaction.recentBlockhash = message.recentBlockhash;
                if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
                signatures.forEach(function(signature, index) {
                    var sigPubkeyPair = {
                        signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).encode($275f7bb2bb263073$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(signature),
                        publicKey: message.accountKeys[index]
                    };
                    transaction.signatures.push(sigPubkeyPair);
                });
                message.instructions.forEach(function(instruction) {
                    var keys = instruction.accounts.map(function(account) {
                        var pubkey = message.accountKeys[account];
                        return {
                            pubkey: pubkey,
                            isSigner: transaction.signatures.some(function(keyObj) {
                                return keyObj.publicKey.toString() === pubkey.toString();
                            }) || message.isAccountSigner(account),
                            isWritable: message.isAccountWritable(account)
                        };
                    });
                    transaction.instructions.push(new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                        keys: keys,
                        programId: message.accountKeys[instruction.programIdIndex],
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(instruction.data)
                    }));
                });
                transaction._message = message;
                transaction._json = transaction.toJSON();
                return transaction;
            }
        }
    ]);
    return Transaction;
}();
var $275f7bb2bb263073$export$eb15f3e001dd262d = /*#__PURE__*/ function() {
    "use strict";
    function TransactionMessage(args) {
        (0, $7dKN1._)(this, TransactionMessage);
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    (0, $eW5pA._)(TransactionMessage, [
        {
            key: "compileToLegacyMessage",
            value: function compileToLegacyMessage() {
                return $275f7bb2bb263073$export$f69c19e57285b83a.compile({
                    payerKey: this.payerKey,
                    recentBlockhash: this.recentBlockhash,
                    instructions: this.instructions
                });
            }
        },
        {
            key: "compileToV0Message",
            value: function compileToV0Message(addressLookupTableAccounts) {
                return $275f7bb2bb263073$export$ee274c70e0fae590.compile({
                    payerKey: this.payerKey,
                    recentBlockhash: this.recentBlockhash,
                    instructions: this.instructions,
                    addressLookupTableAccounts: addressLookupTableAccounts
                });
            }
        }
    ], [
        {
            key: "decompile",
            value: function decompile(message, args) {
                var header = message.header, compiledInstructions = message.compiledInstructions, recentBlockhash = message.recentBlockhash;
                var numRequiredSignatures = header.numRequiredSignatures, numReadonlySignedAccounts = header.numReadonlySignedAccounts, numReadonlyUnsignedAccounts = header.numReadonlyUnsignedAccounts;
                var numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
                $275f7bb2bb263073$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
                var numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
                $275f7bb2bb263073$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
                var accountKeys = message.getAccountKeys(args);
                var payerKey = accountKeys.get(0);
                if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
                var instructions = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = compiledInstructions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var compiledIx = _step.value;
                        var keys = [];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = compiledIx.accountKeyIndexes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var keyIndex = _step1.value;
                                var pubkey = accountKeys.get(keyIndex);
                                if (pubkey === undefined) throw new Error("Failed to find key for account key index ".concat(keyIndex));
                                var isSigner = keyIndex < numRequiredSignatures;
                                var isWritable = void 0;
                                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                                accountKeys.accountKeysFromLookups.writable.length;
                                keys.push({
                                    pubkey: pubkey,
                                    isSigner: keyIndex < header.numRequiredSignatures,
                                    isWritable: isWritable
                                });
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var programId = accountKeys.get(compiledIx.programIdIndex);
                        if (programId === undefined) throw new Error("Failed to find program id for program id index ".concat(compiledIx.programIdIndex));
                        instructions.push(new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                            programId: programId,
                            data: $275f7bb2bb263073$var$toBuffer(compiledIx.data),
                            keys: keys
                        }));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new TransactionMessage({
                    payerKey: payerKey,
                    instructions: instructions,
                    recentBlockhash: recentBlockhash
                });
            }
        }
    ]);
    return TransactionMessage;
}();
/**
 * Versioned transaction class
 */ var $275f7bb2bb263073$export$232cc3f078dcc284 = /*#__PURE__*/ function() {
    "use strict";
    function VersionedTransaction(message, signatures) {
        (0, $7dKN1._)(this, VersionedTransaction);
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $275f7bb2bb263073$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            var defaultSignatures = [];
            for(var i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($275f7bb2bb263073$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    (0, $eW5pA._)(VersionedTransaction, [
        {
            key: "version",
            get: function get() {
                return this.message.version;
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var serializedMessage = this.message.serialize();
                var encodedSignaturesLength = Array();
                $275f7bb2bb263073$var$encodeLength(encodedSignaturesLength, this.signatures.length);
                var transactionLayout = $i4x6j.struct([
                    $i4x6j.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
                    $i4x6j.seq($275f7bb2bb263073$var$signature(), this.signatures.length, "signatures"),
                    $i4x6j.blob(serializedMessage.length, "serializedMessage")
                ]);
                var serializedTransaction = new Uint8Array(2048);
                var serializedTransactionLength = transactionLayout.encode({
                    encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
                    signatures: this.signatures,
                    serializedMessage: serializedMessage
                }, serializedTransaction);
                return serializedTransaction.slice(0, serializedTransactionLength);
            }
        },
        {
            key: "sign",
            value: function sign1(signers) {
                var messageData = this.message.serialize();
                var signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this = this, _loop = function() {
                        var signer = _step.value;
                        var signerIndex = signerPubkeys.findIndex(function(pubkey) {
                            return pubkey.equals(signer.publicKey);
                        });
                        $275f7bb2bb263073$var$assert(signerIndex >= 0, "Cannot sign with non signer key ".concat(signer.publicKey.toBase58()));
                        _this.signatures[signerIndex] = $275f7bb2bb263073$var$sign(messageData, signer.secretKey);
                    };
                    for(var _iterator = signers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "addSignature",
            value: function addSignature(publicKey, signature) {
                $275f7bb2bb263073$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
                var signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
                var signerIndex = signerPubkeys.findIndex(function(pubkey) {
                    return pubkey.equals(publicKey);
                });
                $275f7bb2bb263073$var$assert(signerIndex >= 0, "Can not add signature; `".concat(publicKey.toBase58(), "` is not required to sign this transaction"));
                this.signatures[signerIndex] = signature;
            }
        }
    ], [
        {
            key: "deserialize",
            value: function deserialize(serializedTransaction) {
                var byteArray = (0, $gF0bR._)(serializedTransaction);
                var signatures = [];
                var signaturesLength = $275f7bb2bb263073$var$decodeLength(byteArray);
                for(var i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$14aee086fde78fa6)));
                var message = $275f7bb2bb263073$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
                return new VersionedTransaction(message, signatures);
            }
        }
    ]);
    return VersionedTransaction;
}();
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ var $275f7bb2bb263073$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ var $275f7bb2bb263073$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ var $275f7bb2bb263073$var$NUM_SLOTS_PER_SECOND = $275f7bb2bb263073$var$NUM_TICKS_PER_SECOND / $275f7bb2bb263073$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ var $275f7bb2bb263073$var$MS_PER_SLOT = 1000 / $275f7bb2bb263073$var$NUM_SLOTS_PER_SECOND;
var $275f7bb2bb263073$export$393aa1412d47050e = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
var $275f7bb2bb263073$export$2b71d479444d2f4 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
var $275f7bb2bb263073$export$54419cc1a3ece8d6 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
var $275f7bb2bb263073$export$e74201139e9833db = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
var $275f7bb2bb263073$export$970d0190cdb3a8e9 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
var $275f7bb2bb263073$export$da3b38d796bc1af1 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
var $275f7bb2bb263073$export$7b3a057916a4a7ae = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
var $275f7bb2bb263073$export$3272815bf0633907 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
var $275f7bb2bb263073$export$ca994171317280ea = new $275f7bb2bb263073$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
var $275f7bb2bb263073$export$121e803f723b3045 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(SendTransactionError, Error1);
    var _super = (0, $hKD8n._)(SendTransactionError);
    function SendTransactionError(param) {
        var action = param.action, signature = param.signature, transactionMessage = param.transactionMessage, logs = param.logs;
        (0, $7dKN1._)(this, SendTransactionError);
        var _this;
        var maybeLogsOutput = logs ? "Logs: \n".concat(JSON.stringify(logs.slice(-10), null, 2), ". ") : "";
        var guideText = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
        var message;
        switch(action){
            case "send":
                message = "Transaction ".concat(signature, " resulted in an error. \n") + "".concat(transactionMessage, ". ") + maybeLogsOutput + guideText;
                break;
            case "simulate":
                message = "Simulation failed. \nMessage: ".concat(transactionMessage, ". \n") + maybeLogsOutput + guideText;
                break;
            default:
                message = "Unknown action '".concat(function(a) {
                    return a;
                }(action), "'");
        }
        _this = _super.call(this, message);
        _this.signature = void 0;
        _this.transactionMessage = void 0;
        _this.transactionLogs = void 0;
        _this.signature = signature;
        _this.transactionMessage = transactionMessage;
        _this.transactionLogs = logs ? logs : undefined;
        return _this;
    }
    (0, $eW5pA._)(SendTransactionError, [
        {
            key: "transactionError",
            get: function get() {
                return {
                    message: this.transactionMessage,
                    logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : undefined
                };
            }
        },
        {
            key: "logs",
            get: /* @deprecated Use `await getLogs()` instead */ function get() {
                var cachedLogs = this.transactionLogs;
                if (cachedLogs != null && typeof cachedLogs === "object" && "then" in cachedLogs) return undefined;
                return cachedLogs;
            }
        },
        {
            key: "getLogs",
            value: function getLogs(connection) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!Array.isArray(_this.transactionLogs)) _this.transactionLogs = new Promise(function(resolve, reject) {
                                    connection.getTransaction(_this.signature).then(function(tx) {
                                        if (tx && tx.meta && tx.meta.logMessages) {
                                            var logs = tx.meta.logMessages;
                                            _this.transactionLogs = logs;
                                            resolve(logs);
                                        } else reject(new Error("Log messages not found"));
                                    }).catch(reject);
                                });
                                return [
                                    4,
                                    _this.transactionLogs
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SendTransactionError;
}((0, $jShW9._)(Error));
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
var $275f7bb2bb263073$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
var $275f7bb2bb263073$export$ea1b1a1bba5c14ad = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(SolanaJSONRPCError, Error1);
    var _super = (0, $hKD8n._)(SolanaJSONRPCError);
    function SolanaJSONRPCError(param, customMessage) {
        var code = param.code, message = param.message, data = param.data;
        (0, $7dKN1._)(this, SolanaJSONRPCError);
        var _this;
        _this = _super.call(this, customMessage != null ? "".concat(customMessage, ": ").concat(message) : message);
        _this.code = void 0;
        _this.data = void 0;
        _this.code = code;
        _this.data = data;
        _this.name = "SolanaJSONRPCError";
        return _this;
    }
    return SolanaJSONRPCError;
}((0, $jShW9._)(Error));
function $275f7bb2bb263073$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    return $275f7bb2bb263073$var$_sendAndConfirmTransaction.apply(this, arguments);
}
function $275f7bb2bb263073$var$_sendAndConfirmTransaction() {
    $275f7bb2bb263073$var$_sendAndConfirmTransaction = /**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ (0, $6rBFC._)(function(connection, transaction, signers, options) {
        var sendOptions, signature, status, nonceInstruction, nonceAccountPubkey;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sendOptions = options && {
                        skipPreflight: options.skipPreflight,
                        preflightCommitment: options.preflightCommitment || options.commitment,
                        maxRetries: options.maxRetries,
                        minContextSlot: options.minContextSlot
                    };
                    return [
                        4,
                        connection.sendTransaction(transaction, signers, sendOptions)
                    ];
                case 1:
                    signature = _state.sent();
                    if (!(transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        connection.confirmTransaction({
                            abortSignal: options === null || options === void 0 ? void 0 : options.abortSignal,
                            signature: signature,
                            blockhash: transaction.recentBlockhash,
                            lastValidBlockHeight: transaction.lastValidBlockHeight
                        }, options && options.commitment)
                    ];
                case 2:
                    status = _state.sent().value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    if (!(transaction.minNonceContextSlot != null && transaction.nonceInfo != null)) return [
                        3,
                        5
                    ];
                    nonceInstruction = transaction.nonceInfo.nonceInstruction;
                    nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
                    return [
                        4,
                        connection.confirmTransaction({
                            abortSignal: options === null || options === void 0 ? void 0 : options.abortSignal,
                            minContextSlot: transaction.minNonceContextSlot,
                            nonceAccountPubkey: nonceAccountPubkey,
                            nonceValue: transaction.nonceInfo.nonce,
                            signature: signature
                        }, options && options.commitment)
                    ];
                case 4:
                    status = _state.sent().value;
                    return [
                        3,
                        7
                    ];
                case 5:
                    if ((options === null || options === void 0 ? void 0 : options.abortSignal) != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
                    return [
                        4,
                        connection.confirmTransaction(signature, options && options.commitment)
                    ];
                case 6:
                    status = _state.sent().value;
                    _state.label = 7;
                case 7:
                    if (status.err) {
                        if (signature != null) throw new $275f7bb2bb263073$export$121e803f723b3045({
                            action: "send",
                            signature: signature,
                            transactionMessage: "Status: (".concat(JSON.stringify(status), ")")
                        });
                        throw new Error("Transaction ".concat(signature, " failed (").concat(JSON.stringify(status), ")"));
                    }
                    return [
                        2,
                        signature
                    ];
            }
        });
    });
    return $275f7bb2bb263073$var$_sendAndConfirmTransaction.apply(this, arguments);
}
// zzz
function $275f7bb2bb263073$var$sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $275f7bb2bb263073$var$encodeData(type, fields) {
    var allocLength = type.layout.span >= 0 ? type.layout.span : $275f7bb2bb263073$var$getAlloc(type, fields);
    var data = (0, $ilnag.Buffer).alloc(allocLength);
    var layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $275f7bb2bb263073$var$decodeData$1(type, buffer) {
    var data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error("invalid instruction; instruction index mismatch ".concat(data.instruction, " != ").concat(type.index));
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ var $275f7bb2bb263073$export$d1cc579b1c48f515 = $i4x6j.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ var $275f7bb2bb263073$var$NonceAccountLayout = $i4x6j.struct([
    $i4x6j.u32("version"),
    $i4x6j.u32("state"),
    $275f7bb2bb263073$var$publicKey("authorizedPubkey"),
    $275f7bb2bb263073$var$publicKey("nonce"),
    $i4x6j.struct([
        $275f7bb2bb263073$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
var $275f7bb2bb263073$export$7126250b6d8bd94a = $275f7bb2bb263073$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ var $275f7bb2bb263073$export$ed1c2356ce604759 = /*#__PURE__*/ function() {
    "use strict";
    function NonceAccount(args) {
        (0, $7dKN1._)(this, NonceAccount);
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    (0, $eW5pA._)(NonceAccount, null, [
        {
            key: "fromAccountData",
            value: /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ function fromAccountData(buffer) {
                var nonceAccount = $275f7bb2bb263073$var$NonceAccountLayout.decode($275f7bb2bb263073$var$toBuffer(buffer), 0);
                return new NonceAccount({
                    authorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
                    nonce: new $275f7bb2bb263073$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
                    feeCalculator: nonceAccount.feeCalculator
                });
            }
        }
    ]);
    return NonceAccount;
}();
var $275f7bb2bb263073$var$encodeDecode = function(layout) {
    var decode = layout.decode.bind(layout);
    var encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
var $275f7bb2bb263073$var$bigInt = function(length) {
    return function(property) {
        var layout = (0, $i4x6j.blob)(length, property);
        var _encodeDecode = $275f7bb2bb263073$var$encodeDecode(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
        var bigIntLayout = layout;
        bigIntLayout.decode = function(buffer, offset) {
            var src = decode(buffer, offset);
            return (0, $cf4fc149d7ee5705$exports.toBigIntLE)((0, $ilnag.Buffer).from(src));
        };
        bigIntLayout.encode = function(bigInt, buffer, offset) {
            var src = (0, $cf4fc149d7ee5705$exports.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
};
var $275f7bb2bb263073$var$u64 = $275f7bb2bb263073$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ var $275f7bb2bb263073$export$f009802131fa3d06 = /*#__PURE__*/ function() {
    "use strict";
    function SystemInstruction() {
        (0, $7dKN1._)(this, SystemInstruction);
    }
    (0, $eW5pA._)(SystemInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a system instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $i4x6j.u32("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($275f7bb2bb263073$export$74bdf41d8d1e7108)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a SystemInstruction");
                return _$type;
            }
        },
        {
            key: "decodeCreateAccount",
            value: /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ function decodeCreateAccount(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.Create, instruction.data), lamports = _decodeData$1.lamports, space = _decodeData$1.space, programId = _decodeData$1.programId;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    newAccountPubkey: instruction.keys[1].pubkey,
                    lamports: lamports,
                    space: space,
                    programId: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeTransfer",
            value: /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ function decodeTransfer(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var lamports = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.Transfer, instruction.data).lamports;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    toPubkey: instruction.keys[1].pubkey,
                    lamports: lamports
                };
            }
        },
        {
            key: "decodeTransferWithSeed",
            value: /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ function decodeTransferWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data), lamports = _decodeData$1.lamports, seed = _decodeData$1.seed, programId = _decodeData$1.programId;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    basePubkey: instruction.keys[1].pubkey,
                    toPubkey: instruction.keys[2].pubkey,
                    lamports: lamports,
                    seed: seed,
                    programId: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeAllocate",
            value: /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ function decodeAllocate(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var space = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.Allocate, instruction.data).space;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    space: space
                };
            }
        },
        {
            key: "decodeAllocateWithSeed",
            value: /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ function decodeAllocateWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data), base = _decodeData$1.base, seed = _decodeData$1.seed, space = _decodeData$1.space, programId = _decodeData$1.programId;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    basePubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(base),
                    seed: seed,
                    space: space,
                    programId: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeAssign",
            value: /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ function decodeAssign(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var programId = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.Assign, instruction.data).programId;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    programId: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeAssignWithSeed",
            value: /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ function decodeAssignWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data), base = _decodeData$1.base, seed = _decodeData$1.seed, programId = _decodeData$1.programId;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    basePubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(base),
                    seed: seed,
                    programId: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeCreateWithSeed",
            value: /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ function decodeCreateWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data), base = _decodeData$1.base, seed = _decodeData$1.seed, lamports = _decodeData$1.lamports, space = _decodeData$1.space, programId = _decodeData$1.programId;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    newAccountPubkey: instruction.keys[1].pubkey,
                    basePubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(base),
                    seed: seed,
                    lamports: lamports,
                    space: space,
                    programId: new $275f7bb2bb263073$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeNonceInitialize",
            value: /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ function decodeNonceInitialize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var authorized = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data).authorized;
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorized)
                };
            }
        },
        {
            key: "decodeNonceAdvance",
            value: /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ function decodeNonceAdvance(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey
                };
            }
        },
        {
            key: "decodeNonceWithdraw",
            value: /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ function decodeNonceWithdraw(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 5);
                var lamports = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data).lamports;
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    toPubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[4].pubkey,
                    lamports: lamports
                };
            }
        },
        {
            key: "decodeNonceAuthorize",
            value: /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ function decodeNonceAuthorize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var authorized = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data).authorized;
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[1].pubkey,
                    newAuthorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorized)
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($275f7bb2bb263073$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
            }
        },
        {
            key: "checkKeyLength",
            value: /**
   * @internal
   */ function checkKeyLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return SystemInstruction;
}();
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ var $275f7bb2bb263073$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $i4x6j.ns64("lamports"),
            $i4x6j.ns64("space"),
            $275f7bb2bb263073$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("base"),
            $275f7bb2bb263073$var$rustString("seed"),
            $i4x6j.ns64("lamports"),
            $i4x6j.ns64("space"),
            $275f7bb2bb263073$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $i4x6j.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $i4x6j.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("base"),
            $275f7bb2bb263073$var$rustString("seed"),
            $i4x6j.ns64("space"),
            $275f7bb2bb263073$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("base"),
            $275f7bb2bb263073$var$rustString("seed"),
            $275f7bb2bb263073$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$u64("lamports"),
            $275f7bb2bb263073$var$rustString("seed"),
            $275f7bb2bb263073$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ var $275f7bb2bb263073$export$d8c4e17726848113 = /*#__PURE__*/ function() {
    "use strict";
    function SystemProgram() {
        (0, $7dKN1._)(this, SystemProgram);
    }
    (0, $eW5pA._)(SystemProgram, null, [
        {
            key: "createAccount",
            value: /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ function createAccount(params) {
                var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.Create;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    lamports: params.lamports,
                    space: params.space,
                    programId: $275f7bb2bb263073$var$toBuffer(params.programId.toBuffer())
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: params.fromPubkey,
                            isSigner: true,
                            isWritable: true
                        },
                        {
                            pubkey: params.newAccountPubkey,
                            isSigner: true,
                            isWritable: true
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "transfer",
            value: /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ function transfer(params) {
                var data;
                var keys;
                if ("basePubkey" in params) {
                    var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.TransferWithSeed;
                    data = $275f7bb2bb263073$var$encodeData(_$type, {
                        lamports: BigInt(params.lamports),
                        seed: params.seed,
                        programId: $275f7bb2bb263073$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.fromPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.basePubkey,
                            isSigner: true,
                            isWritable: false
                        },
                        {
                            pubkey: params.toPubkey,
                            isSigner: false,
                            isWritable: true
                        }
                    ];
                } else {
                    var _$type1 = $275f7bb2bb263073$export$74bdf41d8d1e7108.Transfer;
                    data = $275f7bb2bb263073$var$encodeData(_$type1, {
                        lamports: BigInt(params.lamports)
                    });
                    keys = [
                        {
                            pubkey: params.fromPubkey,
                            isSigner: true,
                            isWritable: true
                        },
                        {
                            pubkey: params.toPubkey,
                            isSigner: false,
                            isWritable: true
                        }
                    ];
                }
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "assign",
            value: /**
   * Generate a transaction instruction that assigns an account to a program
   */ function assign(params) {
                var data;
                var keys;
                if ("basePubkey" in params) {
                    var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.AssignWithSeed;
                    data = $275f7bb2bb263073$var$encodeData(_$type, {
                        base: $275f7bb2bb263073$var$toBuffer(params.basePubkey.toBuffer()),
                        seed: params.seed,
                        programId: $275f7bb2bb263073$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.basePubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ];
                } else {
                    var _$type1 = $275f7bb2bb263073$export$74bdf41d8d1e7108.Assign;
                    data = $275f7bb2bb263073$var$encodeData(_$type1, {
                        programId: $275f7bb2bb263073$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: true,
                            isWritable: true
                        }
                    ];
                }
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "createAccountWithSeed",
            value: /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ function createAccountWithSeed(params) {
                var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.CreateWithSeed;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    base: $275f7bb2bb263073$var$toBuffer(params.basePubkey.toBuffer()),
                    seed: params.seed,
                    lamports: params.lamports,
                    space: params.space,
                    programId: $275f7bb2bb263073$var$toBuffer(params.programId.toBuffer())
                });
                var keys = [
                    {
                        pubkey: params.fromPubkey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: params.newAccountPubkey,
                        isSigner: false,
                        isWritable: true
                    }
                ];
                if (!params.basePubkey.equals(params.fromPubkey)) keys.push({
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "createNonceAccount",
            value: /**
   * Generate a transaction that creates a new Nonce account
   */ function createNonceAccount(params) {
                var transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                if ("basePubkey" in params && "seed" in params) transaction.add(SystemProgram.createAccountWithSeed({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.noncePubkey,
                    basePubkey: params.basePubkey,
                    seed: params.seed,
                    lamports: params.lamports,
                    space: $275f7bb2bb263073$export$7126250b6d8bd94a,
                    programId: this.programId
                }));
                else transaction.add(SystemProgram.createAccount({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.noncePubkey,
                    lamports: params.lamports,
                    space: $275f7bb2bb263073$export$7126250b6d8bd94a,
                    programId: this.programId
                }));
                var initParams = {
                    noncePubkey: params.noncePubkey,
                    authorizedPubkey: params.authorizedPubkey
                };
                transaction.add(this.nonceInitialize(initParams));
                return transaction;
            }
        },
        {
            key: "nonceInitialize",
            value: /**
   * Generate an instruction to initialize a Nonce account
   */ function nonceInitialize(params) {
                var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.InitializeNonceAccount;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    authorized: $275f7bb2bb263073$var$toBuffer(params.authorizedPubkey.toBuffer())
                });
                var instructionData = {
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$e74201139e9833db,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "nonceAdvance",
            value: /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ function nonceAdvance(params) {
                var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.AdvanceNonceAccount;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                var instructionData = {
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$e74201139e9833db,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: params.authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "nonceWithdraw",
            value: /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ function nonceWithdraw(params) {
                var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.WithdrawNonceAccount;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    lamports: params.lamports
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.toPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$e74201139e9833db,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: params.authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "nonceAuthorize",
            value: /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ function nonceAuthorize(params) {
                var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    authorized: $275f7bb2bb263073$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "allocate",
            value: /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ function allocate(params) {
                var data;
                var keys;
                if ("basePubkey" in params) {
                    var _$type = $275f7bb2bb263073$export$74bdf41d8d1e7108.AllocateWithSeed;
                    data = $275f7bb2bb263073$var$encodeData(_$type, {
                        base: $275f7bb2bb263073$var$toBuffer(params.basePubkey.toBuffer()),
                        seed: params.seed,
                        space: params.space,
                        programId: $275f7bb2bb263073$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.basePubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ];
                } else {
                    var _$type1 = $275f7bb2bb263073$export$74bdf41d8d1e7108.Allocate;
                    data = $275f7bb2bb263073$var$encodeData(_$type1, {
                        space: params.space
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: true,
                            isWritable: true
                        }
                    ];
                }
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return SystemProgram;
}();
$275f7bb2bb263073$export$d8c4e17726848113.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
var $275f7bb2bb263073$var$CHUNK_SIZE = $275f7bb2bb263073$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ var $275f7bb2bb263073$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader() {
        (0, $7dKN1._)(this, Loader);
    }
    (0, $eW5pA._)(Loader, null, [
        {
            key: "getMinNumSignatures",
            value: /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ function getMinNumSignatures(dataLength) {
                return 2 * // Every transaction requires two signatures (payer + program)
                (Math.ceil(dataLength / Loader.chunkSize) + 1 + // Add one for Create transaction
                1 // Add one for Finalize transaction
                );
            }
        },
        {
            key: "load",
            value: /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ function load(connection, payer, program, programId, data) {
                return (0, $6rBFC._)(function() {
                    var balanceNeeded, programInfo, transaction, dataLayout, chunkSize, offset, _$array, transactions, bytes, _$data, transaction1, REQUESTS_PER_SECOND, dataLayout1, _$data1, transaction2, deployCommitment, finalizeSignature, _ref, context, value, currentSlot, e;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    connection.getMinimumBalanceForRentExemption(data.length)
                                ];
                            case 1:
                                balanceNeeded = _state.sent();
                                return [
                                    4,
                                    connection.getAccountInfo(program.publicKey, "confirmed")
                                ];
                            case 2:
                                programInfo = _state.sent();
                                transaction = null;
                                if (programInfo !== null) {
                                    if (programInfo.executable) {
                                        console.error("Program load failed, account is already executable");
                                        return [
                                            2,
                                            false
                                        ];
                                    }
                                    if (programInfo.data.length !== data.length) {
                                        transaction = transaction || new $275f7bb2bb263073$export$febc5573c75cefb0();
                                        transaction.add($275f7bb2bb263073$export$d8c4e17726848113.allocate({
                                            accountPubkey: program.publicKey,
                                            space: data.length
                                        }));
                                    }
                                    if (!programInfo.owner.equals(programId)) {
                                        transaction = transaction || new $275f7bb2bb263073$export$febc5573c75cefb0();
                                        transaction.add($275f7bb2bb263073$export$d8c4e17726848113.assign({
                                            accountPubkey: program.publicKey,
                                            programId: programId
                                        }));
                                    }
                                    if (programInfo.lamports < balanceNeeded) {
                                        transaction = transaction || new $275f7bb2bb263073$export$febc5573c75cefb0();
                                        transaction.add($275f7bb2bb263073$export$d8c4e17726848113.transfer({
                                            fromPubkey: payer.publicKey,
                                            toPubkey: program.publicKey,
                                            lamports: balanceNeeded - programInfo.lamports
                                        }));
                                    }
                                } else transaction = new $275f7bb2bb263073$export$febc5573c75cefb0().add($275f7bb2bb263073$export$d8c4e17726848113.createAccount({
                                    fromPubkey: payer.publicKey,
                                    newAccountPubkey: program.publicKey,
                                    lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                                    space: data.length,
                                    programId: programId
                                }));
                                if (!(transaction !== null)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    $275f7bb2bb263073$export$4ad6fe6dae0b6bc3(connection, transaction, [
                                        payer,
                                        program
                                    ], {
                                        commitment: "confirmed"
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                dataLayout = $i4x6j.struct([
                                    $i4x6j.u32("instruction"),
                                    $i4x6j.u32("offset"),
                                    $i4x6j.u32("bytesLength"),
                                    $i4x6j.u32("bytesLengthPadding"),
                                    $i4x6j.seq($i4x6j.u8("byte"), $i4x6j.offset($i4x6j.u32(), -8), "bytes")
                                ]);
                                chunkSize = Loader.chunkSize;
                                offset = 0;
                                _$array = data;
                                transactions = [];
                                _state.label = 5;
                            case 5:
                                if (!(_$array.length > 0)) return [
                                    3,
                                    8
                                ];
                                bytes = _$array.slice(0, chunkSize);
                                _$data = (0, $ilnag.Buffer).alloc(chunkSize + 16);
                                dataLayout.encode({
                                    instruction: 0,
                                    // Load instruction
                                    offset: offset,
                                    bytes: bytes,
                                    bytesLength: 0,
                                    bytesLengthPadding: 0
                                }, _$data);
                                transaction1 = new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                                    keys: [
                                        {
                                            pubkey: program.publicKey,
                                            isSigner: true,
                                            isWritable: true
                                        }
                                    ],
                                    programId: programId,
                                    data: _$data
                                });
                                transactions.push($275f7bb2bb263073$export$4ad6fe6dae0b6bc3(connection, transaction1, [
                                    payer,
                                    program
                                ], {
                                    commitment: "confirmed"
                                }));
                                if (!connection._rpcEndpoint.includes("solana.com")) return [
                                    3,
                                    7
                                ];
                                REQUESTS_PER_SECOND = 4;
                                return [
                                    4,
                                    $275f7bb2bb263073$var$sleep(1000 / REQUESTS_PER_SECOND)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                offset += chunkSize;
                                _$array = _$array.slice(chunkSize);
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    4,
                                    Promise.all(transactions)
                                ];
                            case 9:
                                _state.sent();
                                dataLayout1 = $i4x6j.struct([
                                    $i4x6j.u32("instruction")
                                ]);
                                _$data1 = (0, $ilnag.Buffer).alloc(dataLayout1.span);
                                dataLayout1.encode({
                                    instruction: 1 // Finalize instruction
                                }, _$data1);
                                transaction2 = new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                                    keys: [
                                        {
                                            pubkey: program.publicKey,
                                            isSigner: true,
                                            isWritable: true
                                        },
                                        {
                                            pubkey: $275f7bb2bb263073$export$970d0190cdb3a8e9,
                                            isSigner: false,
                                            isWritable: false
                                        }
                                    ],
                                    programId: programId,
                                    data: _$data1
                                });
                                deployCommitment = "processed";
                                return [
                                    4,
                                    connection.sendTransaction(transaction2, [
                                        payer,
                                        program
                                    ], {
                                        preflightCommitment: deployCommitment
                                    })
                                ];
                            case 10:
                                finalizeSignature = _state.sent();
                                return [
                                    4,
                                    connection.confirmTransaction({
                                        signature: finalizeSignature,
                                        lastValidBlockHeight: transaction2.lastValidBlockHeight,
                                        blockhash: transaction2.recentBlockhash
                                    }, deployCommitment)
                                ];
                            case 11:
                                _ref = _state.sent(), context = _ref.context, value = _ref.value;
                                if (value.err) throw new Error("Transaction ".concat(finalizeSignature, " failed (").concat(JSON.stringify(value), ")"));
                                _state.label = 12;
                            case 12:
                                if (!true // eslint-disable-line no-constant-condition
                                ) return [
                                    3,
                                    18
                                ];
                                _state.label = 13;
                            case 13:
                                _state.trys.push([
                                    13,
                                    15,
                                    ,
                                    16
                                ]);
                                return [
                                    4,
                                    connection.getSlot({
                                        commitment: deployCommitment
                                    })
                                ];
                            case 14:
                                currentSlot = _state.sent();
                                if (currentSlot > context.slot) return [
                                    3,
                                    18
                                ];
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                e = _state.sent();
                                return [
                                    3,
                                    16
                                ];
                            case 16:
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, Math.round($275f7bb2bb263073$var$MS_PER_SLOT / 2));
                                    })
                                ];
                            case 17:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 18:
                                // success
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Loader;
}();
$275f7bb2bb263073$export$3b0d6d7590275603.chunkSize = $275f7bb2bb263073$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ var $275f7bb2bb263073$export$59833422f998b937 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ var $275f7bb2bb263073$export$493be68e6a240d3b = /*#__PURE__*/ function() {
    "use strict";
    function BpfLoader() {
        (0, $7dKN1._)(this, BpfLoader);
    }
    (0, $eW5pA._)(BpfLoader, null, [
        {
            key: "getMinNumSignatures",
            value: /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ function getMinNumSignatures(dataLength) {
                return $275f7bb2bb263073$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
            }
        },
        {
            key: "load",
            value: /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ function load(connection, payer, program, elf, loaderProgramId) {
                return $275f7bb2bb263073$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
            }
        }
    ]);
    return BpfLoader;
}();
function $275f7bb2bb263073$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $275f7bb2bb263073$var$fastStableStringify$1;
var $275f7bb2bb263073$var$hasRequiredFastStableStringify;
function $275f7bb2bb263073$var$requireFastStableStringify() {
    if ($275f7bb2bb263073$var$hasRequiredFastStableStringify) return $275f7bb2bb263073$var$fastStableStringify$1;
    $275f7bb2bb263073$var$hasRequiredFastStableStringify = 1;
    var objToString = Object.prototype.toString;
    var objKeys = Object.keys || function(obj) {
        var keys = [];
        for(var name in obj)keys.push(name);
        return keys;
    };
    function stringify(val, isArrayProp) {
        var i, max, str, keys, key, propVal, toStr;
        if (val === true) return "true";
        if (val === false) return "false";
        switch(typeof val === "undefined" ? "undefined" : (0, $aVMuR._)(val)){
            case "object":
                if (val === null) return null;
                else if (val.toJSON && typeof val.toJSON === "function") return stringify(val.toJSON(), isArrayProp);
                else {
                    toStr = objToString.call(val);
                    if (toStr === "[object Array]") {
                        str = "[";
                        max = val.length - 1;
                        for(i = 0; i < max; i++)str += stringify(val[i], true) + ",";
                        if (max > -1) str += stringify(val[i], true);
                        return str + "]";
                    } else if (toStr === "[object Object]") {
                        // only object is left
                        keys = objKeys(val).sort();
                        max = keys.length;
                        str = "";
                        i = 0;
                        while(i < max){
                            key = keys[i];
                            propVal = stringify(val[key], false);
                            if (propVal !== undefined) {
                                if (str) str += ",";
                                str += JSON.stringify(key) + ":" + propVal;
                            }
                            i++;
                        }
                        return "{" + str + "}";
                    } else return JSON.stringify(val);
                }
            case "function":
            case "undefined":
                return isArrayProp ? null : undefined;
            case "string":
                return JSON.stringify(val);
            default:
                return isFinite(val) ? val : null;
        }
    }
    $275f7bb2bb263073$var$fastStableStringify$1 = function fastStableStringify$1(val) {
        var returnVal = stringify(val, false);
        if (returnVal !== undefined) return "" + returnVal;
    };
    return $275f7bb2bb263073$var$fastStableStringify$1;
}
var $275f7bb2bb263073$var$fastStableStringifyExports = /*@__PURE__*/ $275f7bb2bb263073$var$requireFastStableStringify();
var $275f7bb2bb263073$var$fastStableStringify = /*@__PURE__*/ $275f7bb2bb263073$var$getDefaultExportFromCjs($275f7bb2bb263073$var$fastStableStringifyExports);
var $275f7bb2bb263073$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $275f7bb2bb263073$var$trailingZeros(n) {
    var trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $275f7bb2bb263073$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ var $275f7bb2bb263073$export$df8ed3e830b1d591 = /*#__PURE__*/ function() {
    "use strict";
    function EpochSchedule(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot) {
        (0, $7dKN1._)(this, EpochSchedule);
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    (0, $eW5pA._)(EpochSchedule, [
        {
            key: "getEpoch",
            value: function getEpoch(slot) {
                return this.getEpochAndSlotIndex(slot)[0];
            }
        },
        {
            key: "getEpochAndSlotIndex",
            value: function getEpochAndSlotIndex(slot) {
                if (slot < this.firstNormalSlot) {
                    var epoch = $275f7bb2bb263073$var$trailingZeros($275f7bb2bb263073$var$nextPowerOfTwo(slot + $275f7bb2bb263073$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $275f7bb2bb263073$var$trailingZeros($275f7bb2bb263073$var$MINIMUM_SLOT_PER_EPOCH) - 1;
                    var epochLen = this.getSlotsInEpoch(epoch);
                    var slotIndex = slot - (epochLen - $275f7bb2bb263073$var$MINIMUM_SLOT_PER_EPOCH);
                    return [
                        epoch,
                        slotIndex
                    ];
                } else {
                    var normalSlotIndex = slot - this.firstNormalSlot;
                    var normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
                    var epoch1 = this.firstNormalEpoch + normalEpochIndex;
                    var slotIndex1 = normalSlotIndex % this.slotsPerEpoch;
                    return [
                        epoch1,
                        slotIndex1
                    ];
                }
            }
        },
        {
            key: "getFirstSlotInEpoch",
            value: function getFirstSlotInEpoch(epoch) {
                if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $275f7bb2bb263073$var$MINIMUM_SLOT_PER_EPOCH;
                else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
            }
        },
        {
            key: "getLastSlotInEpoch",
            value: function getLastSlotInEpoch(epoch) {
                return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
            }
        },
        {
            key: "getSlotsInEpoch",
            value: function getSlotsInEpoch(epoch) {
                if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $275f7bb2bb263073$var$trailingZeros($275f7bb2bb263073$var$MINIMUM_SLOT_PER_EPOCH));
                else return this.slotsPerEpoch;
            }
        }
    ]);
    return EpochSchedule;
}();
var $275f7bb2bb263073$var$fetchImpl = globalThis.fetch;
var $275f7bb2bb263073$var$RpcWebSocketClient = /*#__PURE__*/ function(CommonClient) {
    "use strict";
    (0, $cgJ2Y._)(RpcWebSocketClient, CommonClient);
    var _super = (0, $hKD8n._)(RpcWebSocketClient);
    function RpcWebSocketClient(address, options, generate_request_id) {
        (0, $7dKN1._)(this, RpcWebSocketClient);
        var _this;
        var webSocketFactory = function(url) {
            var rpc = (0, $1e85a2f8427b8fbd$export$3909fb301d3dc8c9)(url, (0, $4JCw4._)({
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000
            }, options));
            if ("socket" in rpc) _this.underlyingSocket = rpc.socket;
            else _this.underlyingSocket = rpc;
            return rpc;
        };
        _this = _super.call(this, webSocketFactory, address, options, generate_request_id);
        _this.underlyingSocket = void 0;
        return _this;
    }
    (0, $eW5pA._)(RpcWebSocketClient, [
        {
            key: "call",
            value: function call() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _$_get;
                var _this_underlyingSocket;
                var readyState = (_this_underlyingSocket = this.underlyingSocket) === null || _this_underlyingSocket === void 0 ? void 0 : _this_underlyingSocket.readyState;
                if (readyState === 1 /* WebSocket.OPEN */ ) return (_$_get = (0, $2Nfql._)((0, $fG73q._)(RpcWebSocketClient.prototype), "call", this)).call.apply(_$_get, [
                    this
                ].concat((0, $gF0bR._)(args)));
                return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
            }
        },
        {
            key: "notify",
            value: function notify() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _$_get;
                var _this_underlyingSocket;
                var readyState = (_this_underlyingSocket = this.underlyingSocket) === null || _this_underlyingSocket === void 0 ? void 0 : _this_underlyingSocket.readyState;
                if (readyState === 1 /* WebSocket.OPEN */ ) return (_$_get = (0, $2Nfql._)((0, $fG73q._)(RpcWebSocketClient.prototype), "notify", this)).call.apply(_$_get, [
                    this
                ].concat((0, $gF0bR._)(args)));
                return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
            }
        }
    ]);
    return RpcWebSocketClient;
}((0, $1e85a2f8427b8fbd$export$b43a6d9568fa5272));
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $275f7bb2bb263073$var$decodeData(type, data) {
    var decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error("invalid account data; account type mismatch ".concat(decoded.typeIndex, " != ").concat(type.index));
    return decoded;
}
/// The serialized size of lookup table metadata
var $275f7bb2bb263073$var$LOOKUP_TABLE_META_SIZE = 56;
var $275f7bb2bb263073$export$5b2310da10e607da = /*#__PURE__*/ function() {
    "use strict";
    function AddressLookupTableAccount(args) {
        (0, $7dKN1._)(this, AddressLookupTableAccount);
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    (0, $eW5pA._)(AddressLookupTableAccount, [
        {
            key: "isActive",
            value: function isActive() {
                var U64_MAX = BigInt("0xffffffffffffffff");
                return this.state.deactivationSlot === U64_MAX;
            }
        }
    ], [
        {
            key: "deserialize",
            value: function deserialize(accountData) {
                var meta = $275f7bb2bb263073$var$decodeData($275f7bb2bb263073$var$LookupTableMetaLayout, accountData);
                var serializedAddressesLen = accountData.length - $275f7bb2bb263073$var$LOOKUP_TABLE_META_SIZE;
                $275f7bb2bb263073$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
                $275f7bb2bb263073$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
                var numSerializedAddresses = serializedAddressesLen / 32;
                var addresses = $i4x6j.struct([
                    $i4x6j.seq($275f7bb2bb263073$var$publicKey(), numSerializedAddresses, "addresses")
                ]).decode(accountData.slice($275f7bb2bb263073$var$LOOKUP_TABLE_META_SIZE)).addresses;
                return {
                    deactivationSlot: meta.deactivationSlot,
                    lastExtendedSlot: meta.lastExtendedSlot,
                    lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
                    authority: meta.authority.length !== 0 ? new $275f7bb2bb263073$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
                    addresses: addresses.map(function(address) {
                        return new $275f7bb2bb263073$export$ca8b6604d6ce14de(address);
                    })
                };
            }
        }
    ]);
    return AddressLookupTableAccount;
}();
var $275f7bb2bb263073$var$LookupTableMetaLayout = {
    index: 1,
    layout: $i4x6j.struct([
        $i4x6j.u32("typeIndex"),
        $275f7bb2bb263073$var$u64("deactivationSlot"),
        $i4x6j.nu64("lastExtendedSlot"),
        $i4x6j.u8("lastExtendedStartIndex"),
        $i4x6j.u8(),
        // option
        $i4x6j.seq($275f7bb2bb263073$var$publicKey(), $i4x6j.offset($i4x6j.u8(), -1), "authority")
    ])
};
var $275f7bb2bb263073$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $275f7bb2bb263073$var$makeWebsocketUrl(endpoint) {
    var matches = endpoint.match($275f7bb2bb263073$var$URL_RE);
    if (matches == null) throw TypeError("Failed to validate endpoint URL `".concat(endpoint, "`"));
    var _matches = (0, $5OlIx._)(matches, 4), _ = _matches[0], // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish = _matches[1], portWithColon = _matches[2], rest = _matches[3];
    var protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    var startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    var websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : ":".concat(startPort + 1);
    return "".concat(protocol, "//").concat(hostish).concat(websocketPort).concat(rest);
}
var $275f7bb2bb263073$var$PublicKeyFromString = (0, $91bj2.coerce)((0, $91bj2.instance)($275f7bb2bb263073$export$ca8b6604d6ce14de), (0, $91bj2.string)(), function(value) {
    return new $275f7bb2bb263073$export$ca8b6604d6ce14de(value);
});
var $275f7bb2bb263073$var$RawAccountDataResult = (0, $91bj2.tuple)([
    (0, $91bj2.string)(),
    (0, $91bj2.literal)("base64")
]);
var $275f7bb2bb263073$var$BufferFromRawAccountData = (0, $91bj2.coerce)((0, $91bj2.instance)((0, $ilnag.Buffer)), $275f7bb2bb263073$var$RawAccountDataResult, function(value) {
    return (0, $ilnag.Buffer).from(value[0], "base64");
});
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ var $275f7bb2bb263073$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $275f7bb2bb263073$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig) {
    var commitment;
    var config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        var specifiedCommitment = commitmentOrConfig.commitment, specifiedConfig = (0, $bL8uU._)(commitmentOrConfig, [
            "commitment"
        ]);
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $275f7bb2bb263073$var$applyDefaultMemcmpEncodingToFilters(filters) {
    return filters.map(function(filter) {
        var _filter_memcmp_encoding;
        return "memcmp" in filter ? (0, $gddcW._)((0, $4JCw4._)({}, filter), {
            memcmp: (0, $gddcW._)((0, $4JCw4._)({}, filter.memcmp), {
                encoding: (_filter_memcmp_encoding = filter.memcmp.encoding) !== null && _filter_memcmp_encoding !== void 0 ? _filter_memcmp_encoding : "base58"
            })
        }) : filter;
    });
}
/**
 * @internal
 */ function $275f7bb2bb263073$var$createRpcResult(result) {
    return (0, $91bj2.union)([
        (0, $91bj2.type)({
            jsonrpc: (0, $91bj2.literal)("2.0"),
            id: (0, $91bj2.string)(),
            result: result
        }),
        (0, $91bj2.type)({
            jsonrpc: (0, $91bj2.literal)("2.0"),
            id: (0, $91bj2.string)(),
            error: (0, $91bj2.type)({
                code: (0, $91bj2.unknown)(),
                message: (0, $91bj2.string)(),
                data: (0, $91bj2.optional)((0, $91bj2.any)())
            })
        })
    ]);
}
var $275f7bb2bb263073$var$UnknownRpcResult = $275f7bb2bb263073$var$createRpcResult((0, $91bj2.unknown)());
/**
 * @internal
 */ function $275f7bb2bb263073$var$jsonRpcResult(schema) {
    return (0, $91bj2.coerce)($275f7bb2bb263073$var$createRpcResult(schema), $275f7bb2bb263073$var$UnknownRpcResult, function(value) {
        if ("error" in value) return value;
        else return (0, $gddcW._)((0, $4JCw4._)({}, value), {
            result: (0, $91bj2.create)(value.result, schema)
        });
    });
}
/**
 * @internal
 */ function $275f7bb2bb263073$var$jsonRpcResultAndContext(value) {
    return $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.type)({
        context: (0, $91bj2.type)({
            slot: (0, $91bj2.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $275f7bb2bb263073$var$notificationResultAndContext(value) {
    return (0, $91bj2.type)({
        context: (0, $91bj2.type)({
            slot: (0, $91bj2.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $275f7bb2bb263073$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $275f7bb2bb263073$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map(function(accountKey) {
            return new $275f7bb2bb263073$export$ca8b6604d6ce14de(accountKey);
        }),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map(function(ix) {
            return {
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(ix.data)
            };
        }),
        addressTableLookups: response.addressTableLookups
    });
    else return new $275f7bb2bb263073$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ var $275f7bb2bb263073$var$GetInflationGovernorResult = (0, $91bj2.type)({
    foundation: (0, $91bj2.number)(),
    foundationTerm: (0, $91bj2.number)(),
    initial: (0, $91bj2.number)(),
    taper: (0, $91bj2.number)(),
    terminal: (0, $91bj2.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ var $275f7bb2bb263073$var$GetInflationRewardResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)((0, $91bj2.nullable)((0, $91bj2.type)({
    epoch: (0, $91bj2.number)(),
    effectiveSlot: (0, $91bj2.number)(),
    amount: (0, $91bj2.number)(),
    postBalance: (0, $91bj2.number)(),
    commission: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ var $275f7bb2bb263073$var$GetRecentPrioritizationFeesResult = (0, $91bj2.array)((0, $91bj2.type)({
    slot: (0, $91bj2.number)(),
    prioritizationFee: (0, $91bj2.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ var $275f7bb2bb263073$var$GetInflationRateResult = (0, $91bj2.type)({
    total: (0, $91bj2.number)(),
    validator: (0, $91bj2.number)(),
    foundation: (0, $91bj2.number)(),
    epoch: (0, $91bj2.number)()
});
/**
 * Information about the current epoch
 */ var $275f7bb2bb263073$var$GetEpochInfoResult = (0, $91bj2.type)({
    epoch: (0, $91bj2.number)(),
    slotIndex: (0, $91bj2.number)(),
    slotsInEpoch: (0, $91bj2.number)(),
    absoluteSlot: (0, $91bj2.number)(),
    blockHeight: (0, $91bj2.optional)((0, $91bj2.number)()),
    transactionCount: (0, $91bj2.optional)((0, $91bj2.number)())
});
var $275f7bb2bb263073$var$GetEpochScheduleResult = (0, $91bj2.type)({
    slotsPerEpoch: (0, $91bj2.number)(),
    leaderScheduleSlotOffset: (0, $91bj2.number)(),
    warmup: (0, $91bj2.boolean)(),
    firstNormalEpoch: (0, $91bj2.number)(),
    firstNormalSlot: (0, $91bj2.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ var $275f7bb2bb263073$var$GetLeaderScheduleResult = (0, $91bj2.record)((0, $91bj2.string)(), (0, $91bj2.array)((0, $91bj2.number)()));
/**
 * Transaction error or null
 */ var $275f7bb2bb263073$var$TransactionErrorResult = (0, $91bj2.nullable)((0, $91bj2.union)([
    (0, $91bj2.type)({}),
    (0, $91bj2.string)()
]));
/**
 * Signature status for a transaction
 */ var $275f7bb2bb263073$var$SignatureStatusResult = (0, $91bj2.type)({
    err: $275f7bb2bb263073$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ var $275f7bb2bb263073$var$SignatureReceivedResult = (0, $91bj2.literal)("receivedSignature");
/**
 * Version info for a node
 */ var $275f7bb2bb263073$var$VersionResult = (0, $91bj2.type)({
    "solana-core": (0, $91bj2.string)(),
    "feature-set": (0, $91bj2.optional)((0, $91bj2.number)())
});
var $275f7bb2bb263073$var$ParsedInstructionStruct = (0, $91bj2.type)({
    program: (0, $91bj2.string)(),
    programId: $275f7bb2bb263073$var$PublicKeyFromString,
    parsed: (0, $91bj2.unknown)()
});
var $275f7bb2bb263073$var$PartiallyDecodedInstructionStruct = (0, $91bj2.type)({
    programId: $275f7bb2bb263073$var$PublicKeyFromString,
    accounts: (0, $91bj2.array)($275f7bb2bb263073$var$PublicKeyFromString),
    data: (0, $91bj2.string)()
});
var $275f7bb2bb263073$var$SimulatedTransactionResponseStruct = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.type)({
    err: (0, $91bj2.nullable)((0, $91bj2.union)([
        (0, $91bj2.type)({}),
        (0, $91bj2.string)()
    ])),
    logs: (0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.string)())),
    accounts: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.nullable)((0, $91bj2.type)({
        executable: (0, $91bj2.boolean)(),
        owner: (0, $91bj2.string)(),
        lamports: (0, $91bj2.number)(),
        data: (0, $91bj2.array)((0, $91bj2.string)()),
        rentEpoch: (0, $91bj2.optional)((0, $91bj2.number)())
    }))))),
    unitsConsumed: (0, $91bj2.optional)((0, $91bj2.number)()),
    returnData: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.type)({
        programId: (0, $91bj2.string)(),
        data: (0, $91bj2.tuple)([
            (0, $91bj2.string)(),
            (0, $91bj2.literal)("base64")
        ])
    }))),
    innerInstructions: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.type)({
        index: (0, $91bj2.number)(),
        instructions: (0, $91bj2.array)((0, $91bj2.union)([
            $275f7bb2bb263073$var$ParsedInstructionStruct,
            $275f7bb2bb263073$var$PartiallyDecodedInstructionStruct
        ]))
    }))))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ var $275f7bb2bb263073$var$BlockProductionResponseStruct = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.type)({
    byIdentity: (0, $91bj2.record)((0, $91bj2.string)(), (0, $91bj2.array)((0, $91bj2.number)())),
    range: (0, $91bj2.type)({
        firstSlot: (0, $91bj2.number)(),
        lastSlot: (0, $91bj2.number)()
    })
}));
/**
 * A performance sample
 */ function $275f7bb2bb263073$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    var fetch = customFetch ? customFetch : $275f7bb2bb263073$var$fetchImpl;
    var agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    var fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = function() {
        var _ref = (0, $6rBFC._)(function(info, init) {
            var modifiedFetchArgs;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                try {
                                    fetchMiddleware(info, init, function(modifiedInfo, modifiedInit) {
                                        return resolve([
                                            modifiedInfo,
                                            modifiedInit
                                        ]);
                                    });
                                } catch (error) {
                                    reject(error);
                                }
                            })
                        ];
                    case 1:
                        modifiedFetchArgs = _state.sent();
                        return [
                            4,
                            fetch.apply(void 0, (0, $gF0bR._)(modifiedFetchArgs))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(info, init) {
            return _ref.apply(this, arguments);
        };
    }();
    var clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($978213d9094d7b3e$exports)))(function() {
        var _ref = (0, $6rBFC._)(function(request, callback) {
            var options, too_many_requests_retries, res, waitTime, text, err;
            return (0, $6qu4b.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = {
                            method: "POST",
                            body: request,
                            agent: agent,
                            headers: Object.assign({
                                "Content-Type": "application/json"
                            }, httpHeaders || {}, $275f7bb2bb263073$var$COMMON_HTTP_HEADERS)
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            11,
                            ,
                            12
                        ]);
                        too_many_requests_retries = 5;
                        waitTime = 500;
                        _state.label = 2;
                    case 2:
                        if (!fetchWithMiddleware) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetchWithMiddleware(url, options)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 5:
                        res = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (res.status !== 429 /* Too many requests */ ) return [
                            3,
                            9
                        ];
                        if (disableRetryOnRateLimit === true) return [
                            3,
                            9
                        ];
                        too_many_requests_retries -= 1;
                        if (too_many_requests_retries === 0) return [
                            3,
                            9
                        ];
                        console.error("Server responded with ".concat(res.status, " ").concat(res.statusText, ".  Retrying after ").concat(waitTime, "ms delay..."));
                        return [
                            4,
                            $275f7bb2bb263073$var$sleep(waitTime)
                        ];
                    case 7:
                        _state.sent();
                        waitTime *= 2;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            4,
                            res.text()
                        ];
                    case 10:
                        text = _state.sent();
                        if (res.ok) callback(null, text);
                        else callback(new Error("".concat(res.status, " ").concat(res.statusText, ": ").concat(text)));
                        return [
                            3,
                            12
                        ];
                    case 11:
                        err = _state.sent();
                        if (err instanceof Error) callback(err);
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(request, callback) {
            return _ref.apply(this, arguments);
        };
    }(), {});
    return clientBrowser;
}
function $275f7bb2bb263073$var$createRpcRequest(client) {
    return function(method, args) {
        return new Promise(function(resolve, reject) {
            client.request(method, args, function(err, response) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $275f7bb2bb263073$var$createRpcBatchRequest(client) {
    return function(requests) {
        return new Promise(function(resolve, reject) {
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            var batch = requests.map(function(params) {
                return client.request(params.methodName, params.args);
            });
            client.request(batch, function(err, response) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ var $275f7bb2bb263073$var$GetInflationGovernorRpcResult = $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ var $275f7bb2bb263073$var$GetInflationRateRpcResult = $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ var $275f7bb2bb263073$var$GetRecentPrioritizationFeesRpcResult = $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ var $275f7bb2bb263073$var$GetEpochInfoRpcResult = $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ var $275f7bb2bb263073$var$GetEpochScheduleRpcResult = $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ var $275f7bb2bb263073$var$GetLeaderScheduleRpcResult = $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ var $275f7bb2bb263073$var$SlotRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ var $275f7bb2bb263073$var$GetSupplyRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.type)({
    total: (0, $91bj2.number)(),
    circulating: (0, $91bj2.number)(),
    nonCirculating: (0, $91bj2.number)(),
    nonCirculatingAccounts: (0, $91bj2.array)($275f7bb2bb263073$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ var $275f7bb2bb263073$var$TokenAmountResult = (0, $91bj2.type)({
    amount: (0, $91bj2.string)(),
    uiAmount: (0, $91bj2.nullable)((0, $91bj2.number)()),
    decimals: (0, $91bj2.number)(),
    uiAmountString: (0, $91bj2.optional)((0, $91bj2.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ var $275f7bb2bb263073$var$GetTokenLargestAccountsResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.type)({
    address: $275f7bb2bb263073$var$PublicKeyFromString,
    amount: (0, $91bj2.string)(),
    uiAmount: (0, $91bj2.nullable)((0, $91bj2.number)()),
    decimals: (0, $91bj2.number)(),
    uiAmountString: (0, $91bj2.optional)((0, $91bj2.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ var $275f7bb2bb263073$var$GetTokenAccountsByOwner = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.type)({
    pubkey: $275f7bb2bb263073$var$PublicKeyFromString,
    account: (0, $91bj2.type)({
        executable: (0, $91bj2.boolean)(),
        owner: $275f7bb2bb263073$var$PublicKeyFromString,
        lamports: (0, $91bj2.number)(),
        data: $275f7bb2bb263073$var$BufferFromRawAccountData,
        rentEpoch: (0, $91bj2.number)()
    })
})));
var $275f7bb2bb263073$var$ParsedAccountDataResult = (0, $91bj2.type)({
    program: (0, $91bj2.string)(),
    parsed: (0, $91bj2.unknown)(),
    space: (0, $91bj2.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ var $275f7bb2bb263073$var$GetParsedTokenAccountsByOwner = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.type)({
    pubkey: $275f7bb2bb263073$var$PublicKeyFromString,
    account: (0, $91bj2.type)({
        executable: (0, $91bj2.boolean)(),
        owner: $275f7bb2bb263073$var$PublicKeyFromString,
        lamports: (0, $91bj2.number)(),
        data: $275f7bb2bb263073$var$ParsedAccountDataResult,
        rentEpoch: (0, $91bj2.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ var $275f7bb2bb263073$var$GetLargestAccountsRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.type)({
    lamports: (0, $91bj2.number)(),
    address: $275f7bb2bb263073$var$PublicKeyFromString
})));
/**
 * @internal
 */ var $275f7bb2bb263073$var$AccountInfoResult = (0, $91bj2.type)({
    executable: (0, $91bj2.boolean)(),
    owner: $275f7bb2bb263073$var$PublicKeyFromString,
    lamports: (0, $91bj2.number)(),
    data: $275f7bb2bb263073$var$BufferFromRawAccountData,
    rentEpoch: (0, $91bj2.number)()
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$KeyedAccountInfoResult = (0, $91bj2.type)({
    pubkey: $275f7bb2bb263073$var$PublicKeyFromString,
    account: $275f7bb2bb263073$var$AccountInfoResult
});
var $275f7bb2bb263073$var$ParsedOrRawAccountData = (0, $91bj2.coerce)((0, $91bj2.union)([
    (0, $91bj2.instance)((0, $ilnag.Buffer)),
    $275f7bb2bb263073$var$ParsedAccountDataResult
]), (0, $91bj2.union)([
    $275f7bb2bb263073$var$RawAccountDataResult,
    $275f7bb2bb263073$var$ParsedAccountDataResult
]), function(value) {
    if (Array.isArray(value)) return (0, $91bj2.create)(value, $275f7bb2bb263073$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$ParsedAccountInfoResult = (0, $91bj2.type)({
    executable: (0, $91bj2.boolean)(),
    owner: $275f7bb2bb263073$var$PublicKeyFromString,
    lamports: (0, $91bj2.number)(),
    data: $275f7bb2bb263073$var$ParsedOrRawAccountData,
    rentEpoch: (0, $91bj2.number)()
});
var $275f7bb2bb263073$var$KeyedParsedAccountInfoResult = (0, $91bj2.type)({
    pubkey: $275f7bb2bb263073$var$PublicKeyFromString,
    account: $275f7bb2bb263073$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$StakeActivationResult = (0, $91bj2.type)({
    state: (0, $91bj2.union)([
        (0, $91bj2.literal)("active"),
        (0, $91bj2.literal)("inactive"),
        (0, $91bj2.literal)("activating"),
        (0, $91bj2.literal)("deactivating")
    ]),
    active: (0, $91bj2.number)(),
    inactive: (0, $91bj2.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ var $275f7bb2bb263073$var$GetConfirmedSignaturesForAddress2RpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)((0, $91bj2.type)({
    signature: (0, $91bj2.string)(),
    slot: (0, $91bj2.number)(),
    err: $275f7bb2bb263073$var$TransactionErrorResult,
    memo: (0, $91bj2.nullable)((0, $91bj2.string)()),
    blockTime: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ var $275f7bb2bb263073$var$GetSignaturesForAddressRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)((0, $91bj2.type)({
    signature: (0, $91bj2.string)(),
    slot: (0, $91bj2.number)(),
    err: $275f7bb2bb263073$var$TransactionErrorResult,
    memo: (0, $91bj2.nullable)((0, $91bj2.string)()),
    blockTime: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ var $275f7bb2bb263073$var$AccountNotificationResult = (0, $91bj2.type)({
    subscription: (0, $91bj2.number)(),
    result: $275f7bb2bb263073$var$notificationResultAndContext($275f7bb2bb263073$var$AccountInfoResult)
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$ProgramAccountInfoResult = (0, $91bj2.type)({
    pubkey: $275f7bb2bb263073$var$PublicKeyFromString,
    account: $275f7bb2bb263073$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ var $275f7bb2bb263073$var$ProgramAccountNotificationResult = (0, $91bj2.type)({
    subscription: (0, $91bj2.number)(),
    result: $275f7bb2bb263073$var$notificationResultAndContext($275f7bb2bb263073$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$SlotInfoResult = (0, $91bj2.type)({
    parent: (0, $91bj2.number)(),
    slot: (0, $91bj2.number)(),
    root: (0, $91bj2.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ var $275f7bb2bb263073$var$SlotNotificationResult = (0, $91bj2.type)({
    subscription: (0, $91bj2.number)(),
    result: $275f7bb2bb263073$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ var $275f7bb2bb263073$var$SlotUpdateResult = (0, $91bj2.union)([
    (0, $91bj2.type)({
        type: (0, $91bj2.union)([
            (0, $91bj2.literal)("firstShredReceived"),
            (0, $91bj2.literal)("completed"),
            (0, $91bj2.literal)("optimisticConfirmation"),
            (0, $91bj2.literal)("root")
        ]),
        slot: (0, $91bj2.number)(),
        timestamp: (0, $91bj2.number)()
    }),
    (0, $91bj2.type)({
        type: (0, $91bj2.literal)("createdBank"),
        parent: (0, $91bj2.number)(),
        slot: (0, $91bj2.number)(),
        timestamp: (0, $91bj2.number)()
    }),
    (0, $91bj2.type)({
        type: (0, $91bj2.literal)("frozen"),
        slot: (0, $91bj2.number)(),
        timestamp: (0, $91bj2.number)(),
        stats: (0, $91bj2.type)({
            numTransactionEntries: (0, $91bj2.number)(),
            numSuccessfulTransactions: (0, $91bj2.number)(),
            numFailedTransactions: (0, $91bj2.number)(),
            maxTransactionsPerEntry: (0, $91bj2.number)()
        })
    }),
    (0, $91bj2.type)({
        type: (0, $91bj2.literal)("dead"),
        slot: (0, $91bj2.number)(),
        timestamp: (0, $91bj2.number)(),
        err: (0, $91bj2.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ var $275f7bb2bb263073$var$SlotUpdateNotificationResult = (0, $91bj2.type)({
    subscription: (0, $91bj2.number)(),
    result: $275f7bb2bb263073$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ var $275f7bb2bb263073$var$SignatureNotificationResult = (0, $91bj2.type)({
    subscription: (0, $91bj2.number)(),
    result: $275f7bb2bb263073$var$notificationResultAndContext((0, $91bj2.union)([
        $275f7bb2bb263073$var$SignatureStatusResult,
        $275f7bb2bb263073$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ var $275f7bb2bb263073$var$RootNotificationResult = (0, $91bj2.type)({
    subscription: (0, $91bj2.number)(),
    result: (0, $91bj2.number)()
});
var $275f7bb2bb263073$var$ContactInfoResult = (0, $91bj2.type)({
    pubkey: (0, $91bj2.string)(),
    gossip: (0, $91bj2.nullable)((0, $91bj2.string)()),
    tpu: (0, $91bj2.nullable)((0, $91bj2.string)()),
    rpc: (0, $91bj2.nullable)((0, $91bj2.string)()),
    version: (0, $91bj2.nullable)((0, $91bj2.string)())
});
var $275f7bb2bb263073$var$VoteAccountInfoResult = (0, $91bj2.type)({
    votePubkey: (0, $91bj2.string)(),
    nodePubkey: (0, $91bj2.string)(),
    activatedStake: (0, $91bj2.number)(),
    epochVoteAccount: (0, $91bj2.boolean)(),
    epochCredits: (0, $91bj2.array)((0, $91bj2.tuple)([
        (0, $91bj2.number)(),
        (0, $91bj2.number)(),
        (0, $91bj2.number)()
    ])),
    commission: (0, $91bj2.number)(),
    lastVote: (0, $91bj2.number)(),
    rootSlot: (0, $91bj2.nullable)((0, $91bj2.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ var $275f7bb2bb263073$var$GetVoteAccounts = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.type)({
    current: (0, $91bj2.array)($275f7bb2bb263073$var$VoteAccountInfoResult),
    delinquent: (0, $91bj2.array)($275f7bb2bb263073$var$VoteAccountInfoResult)
}));
var $275f7bb2bb263073$var$ConfirmationStatus = (0, $91bj2.union)([
    (0, $91bj2.literal)("processed"),
    (0, $91bj2.literal)("confirmed"),
    (0, $91bj2.literal)("finalized")
]);
var $275f7bb2bb263073$var$SignatureStatusResponse = (0, $91bj2.type)({
    slot: (0, $91bj2.number)(),
    confirmations: (0, $91bj2.nullable)((0, $91bj2.number)()),
    err: $275f7bb2bb263073$var$TransactionErrorResult,
    confirmationStatus: (0, $91bj2.optional)($275f7bb2bb263073$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ var $275f7bb2bb263073$var$GetSignatureStatusesRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.nullable)($275f7bb2bb263073$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ var $275f7bb2bb263073$var$GetMinimumBalanceForRentExemptionRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.number)());
var $275f7bb2bb263073$var$AddressTableLookupStruct = (0, $91bj2.type)({
    accountKey: $275f7bb2bb263073$var$PublicKeyFromString,
    writableIndexes: (0, $91bj2.array)((0, $91bj2.number)()),
    readonlyIndexes: (0, $91bj2.array)((0, $91bj2.number)())
});
var $275f7bb2bb263073$var$ConfirmedTransactionResult = (0, $91bj2.type)({
    signatures: (0, $91bj2.array)((0, $91bj2.string)()),
    message: (0, $91bj2.type)({
        accountKeys: (0, $91bj2.array)((0, $91bj2.string)()),
        header: (0, $91bj2.type)({
            numRequiredSignatures: (0, $91bj2.number)(),
            numReadonlySignedAccounts: (0, $91bj2.number)(),
            numReadonlyUnsignedAccounts: (0, $91bj2.number)()
        }),
        instructions: (0, $91bj2.array)((0, $91bj2.type)({
            accounts: (0, $91bj2.array)((0, $91bj2.number)()),
            data: (0, $91bj2.string)(),
            programIdIndex: (0, $91bj2.number)()
        })),
        recentBlockhash: (0, $91bj2.string)(),
        addressTableLookups: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$AddressTableLookupStruct))
    })
});
var $275f7bb2bb263073$var$AnnotatedAccountKey = (0, $91bj2.type)({
    pubkey: $275f7bb2bb263073$var$PublicKeyFromString,
    signer: (0, $91bj2.boolean)(),
    writable: (0, $91bj2.boolean)(),
    source: (0, $91bj2.optional)((0, $91bj2.union)([
        (0, $91bj2.literal)("transaction"),
        (0, $91bj2.literal)("lookupTable")
    ]))
});
var $275f7bb2bb263073$var$ConfirmedTransactionAccountsModeResult = (0, $91bj2.type)({
    accountKeys: (0, $91bj2.array)($275f7bb2bb263073$var$AnnotatedAccountKey),
    signatures: (0, $91bj2.array)((0, $91bj2.string)())
});
var $275f7bb2bb263073$var$ParsedInstructionResult = (0, $91bj2.type)({
    parsed: (0, $91bj2.unknown)(),
    program: (0, $91bj2.string)(),
    programId: $275f7bb2bb263073$var$PublicKeyFromString
});
var $275f7bb2bb263073$var$RawInstructionResult = (0, $91bj2.type)({
    accounts: (0, $91bj2.array)($275f7bb2bb263073$var$PublicKeyFromString),
    data: (0, $91bj2.string)(),
    programId: $275f7bb2bb263073$var$PublicKeyFromString
});
var $275f7bb2bb263073$var$InstructionResult = (0, $91bj2.union)([
    $275f7bb2bb263073$var$RawInstructionResult,
    $275f7bb2bb263073$var$ParsedInstructionResult
]);
var $275f7bb2bb263073$var$UnknownInstructionResult = (0, $91bj2.union)([
    (0, $91bj2.type)({
        parsed: (0, $91bj2.unknown)(),
        program: (0, $91bj2.string)(),
        programId: (0, $91bj2.string)()
    }),
    (0, $91bj2.type)({
        accounts: (0, $91bj2.array)((0, $91bj2.string)()),
        data: (0, $91bj2.string)(),
        programId: (0, $91bj2.string)()
    })
]);
var $275f7bb2bb263073$var$ParsedOrRawInstruction = (0, $91bj2.coerce)($275f7bb2bb263073$var$InstructionResult, $275f7bb2bb263073$var$UnknownInstructionResult, function(value) {
    if ("accounts" in value) return (0, $91bj2.create)(value, $275f7bb2bb263073$var$RawInstructionResult);
    else return (0, $91bj2.create)(value, $275f7bb2bb263073$var$ParsedInstructionResult);
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$ParsedConfirmedTransactionResult = (0, $91bj2.type)({
    signatures: (0, $91bj2.array)((0, $91bj2.string)()),
    message: (0, $91bj2.type)({
        accountKeys: (0, $91bj2.array)($275f7bb2bb263073$var$AnnotatedAccountKey),
        instructions: (0, $91bj2.array)($275f7bb2bb263073$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $91bj2.string)(),
        addressTableLookups: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)($275f7bb2bb263073$var$AddressTableLookupStruct)))
    })
});
var $275f7bb2bb263073$var$TokenBalanceResult = (0, $91bj2.type)({
    accountIndex: (0, $91bj2.number)(),
    mint: (0, $91bj2.string)(),
    owner: (0, $91bj2.optional)((0, $91bj2.string)()),
    uiTokenAmount: $275f7bb2bb263073$var$TokenAmountResult
});
var $275f7bb2bb263073$var$LoadedAddressesResult = (0, $91bj2.type)({
    writable: (0, $91bj2.array)($275f7bb2bb263073$var$PublicKeyFromString),
    readonly: (0, $91bj2.array)($275f7bb2bb263073$var$PublicKeyFromString)
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$ConfirmedTransactionMetaResult = (0, $91bj2.type)({
    err: $275f7bb2bb263073$var$TransactionErrorResult,
    fee: (0, $91bj2.number)(),
    innerInstructions: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.type)({
        index: (0, $91bj2.number)(),
        instructions: (0, $91bj2.array)((0, $91bj2.type)({
            accounts: (0, $91bj2.array)((0, $91bj2.number)()),
            data: (0, $91bj2.string)(),
            programIdIndex: (0, $91bj2.number)()
        }))
    })))),
    preBalances: (0, $91bj2.array)((0, $91bj2.number)()),
    postBalances: (0, $91bj2.array)((0, $91bj2.number)()),
    logMessages: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.string)()))),
    preTokenBalances: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)($275f7bb2bb263073$var$TokenBalanceResult))),
    postTokenBalances: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)($275f7bb2bb263073$var$TokenBalanceResult))),
    loadedAddresses: (0, $91bj2.optional)($275f7bb2bb263073$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $91bj2.optional)((0, $91bj2.number)())
});
/**
 * @internal
 */ var $275f7bb2bb263073$var$ParsedConfirmedTransactionMetaResult = (0, $91bj2.type)({
    err: $275f7bb2bb263073$var$TransactionErrorResult,
    fee: (0, $91bj2.number)(),
    innerInstructions: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.type)({
        index: (0, $91bj2.number)(),
        instructions: (0, $91bj2.array)($275f7bb2bb263073$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $91bj2.array)((0, $91bj2.number)()),
    postBalances: (0, $91bj2.array)((0, $91bj2.number)()),
    logMessages: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)((0, $91bj2.string)()))),
    preTokenBalances: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)($275f7bb2bb263073$var$TokenBalanceResult))),
    postTokenBalances: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.array)($275f7bb2bb263073$var$TokenBalanceResult))),
    loadedAddresses: (0, $91bj2.optional)($275f7bb2bb263073$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $91bj2.optional)((0, $91bj2.number)())
});
var $275f7bb2bb263073$var$TransactionVersionStruct = (0, $91bj2.union)([
    (0, $91bj2.literal)(0),
    (0, $91bj2.literal)("legacy")
]);
/** @internal */ var $275f7bb2bb263073$var$RewardsResult = (0, $91bj2.type)({
    pubkey: (0, $91bj2.string)(),
    lamports: (0, $91bj2.number)(),
    postBalance: (0, $91bj2.nullable)((0, $91bj2.number)()),
    rewardType: (0, $91bj2.nullable)((0, $91bj2.string)()),
    commission: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ var $275f7bb2bb263073$var$GetBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    transactions: (0, $91bj2.array)((0, $91bj2.type)({
        transaction: $275f7bb2bb263073$var$ConfirmedTransactionResult,
        meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ConfirmedTransactionMetaResult),
        version: (0, $91bj2.optional)($275f7bb2bb263073$var$TransactionVersionStruct)
    })),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)()),
    blockHeight: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ var $275f7bb2bb263073$var$GetNoneModeBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)()),
    blockHeight: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ var $275f7bb2bb263073$var$GetAccountsModeBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    transactions: (0, $91bj2.array)((0, $91bj2.type)({
        transaction: $275f7bb2bb263073$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ConfirmedTransactionMetaResult),
        version: (0, $91bj2.optional)($275f7bb2bb263073$var$TransactionVersionStruct)
    })),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)()),
    blockHeight: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ var $275f7bb2bb263073$var$GetParsedBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    transactions: (0, $91bj2.array)((0, $91bj2.type)({
        transaction: $275f7bb2bb263073$var$ParsedConfirmedTransactionResult,
        meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $91bj2.optional)($275f7bb2bb263073$var$TransactionVersionStruct)
    })),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)()),
    blockHeight: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ var $275f7bb2bb263073$var$GetParsedAccountsModeBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    transactions: (0, $91bj2.array)((0, $91bj2.type)({
        transaction: $275f7bb2bb263073$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $91bj2.optional)($275f7bb2bb263073$var$TransactionVersionStruct)
    })),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)()),
    blockHeight: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ var $275f7bb2bb263073$var$GetParsedNoneModeBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)()),
    blockHeight: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ var $275f7bb2bb263073$var$GetConfirmedBlockRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    transactions: (0, $91bj2.array)((0, $91bj2.type)({
        transaction: $275f7bb2bb263073$var$ConfirmedTransactionResult,
        meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $91bj2.optional)((0, $91bj2.array)($275f7bb2bb263073$var$RewardsResult)),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ var $275f7bb2bb263073$var$GetBlockSignaturesRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    previousBlockhash: (0, $91bj2.string)(),
    parentSlot: (0, $91bj2.number)(),
    signatures: (0, $91bj2.array)((0, $91bj2.string)()),
    blockTime: (0, $91bj2.nullable)((0, $91bj2.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ var $275f7bb2bb263073$var$GetTransactionRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    slot: (0, $91bj2.number)(),
    meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.number)())),
    transaction: $275f7bb2bb263073$var$ConfirmedTransactionResult,
    version: (0, $91bj2.optional)($275f7bb2bb263073$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ var $275f7bb2bb263073$var$GetParsedTransactionRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.type)({
    slot: (0, $91bj2.number)(),
    transaction: $275f7bb2bb263073$var$ParsedConfirmedTransactionResult,
    meta: (0, $91bj2.nullable)($275f7bb2bb263073$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $91bj2.optional)((0, $91bj2.nullable)((0, $91bj2.number)())),
    version: (0, $91bj2.optional)($275f7bb2bb263073$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ var $275f7bb2bb263073$var$GetRecentBlockhashAndContextRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    feeCalculator: (0, $91bj2.type)({
        lamportsPerSignature: (0, $91bj2.number)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ var $275f7bb2bb263073$var$GetLatestBlockhashRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.type)({
    blockhash: (0, $91bj2.string)(),
    lastValidBlockHeight: (0, $91bj2.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ var $275f7bb2bb263073$var$IsBlockhashValidRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.boolean)());
var $275f7bb2bb263073$var$PerfSampleResult = (0, $91bj2.type)({
    slot: (0, $91bj2.number)(),
    numTransactions: (0, $91bj2.number)(),
    numSlots: (0, $91bj2.number)(),
    samplePeriodSecs: (0, $91bj2.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ var $275f7bb2bb263073$var$GetRecentPerformanceSamplesRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)($275f7bb2bb263073$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ var $275f7bb2bb263073$var$GetFeeCalculatorRpcResult = $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.nullable)((0, $91bj2.type)({
    feeCalculator: (0, $91bj2.type)({
        lamportsPerSignature: (0, $91bj2.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ var $275f7bb2bb263073$var$RequestAirdropRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ var $275f7bb2bb263073$var$SendTransactionRpcResult = $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ var $275f7bb2bb263073$var$LogsResult = (0, $91bj2.type)({
    err: $275f7bb2bb263073$var$TransactionErrorResult,
    logs: (0, $91bj2.array)((0, $91bj2.string)()),
    signature: (0, $91bj2.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ var $275f7bb2bb263073$var$LogsNotificationResult = (0, $91bj2.type)({
    result: $275f7bb2bb263073$var$notificationResultAndContext($275f7bb2bb263073$var$LogsResult),
    subscription: (0, $91bj2.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ var $275f7bb2bb263073$var$COMMON_HTTP_HEADERS = {
    "solana-client": "js/1.0.0-maintenance"
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ var $275f7bb2bb263073$export$98b66c25bb38499d = /*#__PURE__*/ function() {
    "use strict";
    function Connection(endpoint, _commitmentOrConfig) {
        var _this = this;
        (0, $7dKN1._)(this, Connection);
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = function() {
            var requestPromises = {};
            var _this1 = _this;
            return function() {
                var _ref = (0, $6rBFC._)(function(commitmentOrConfig) {
                    var _extractCommitmentFromConfig, commitment, config, args, requestHash, _requestPromises_requestHash;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this1._buildArgs([], commitment, undefined /* encoding */ , config);
                                requestHash = $275f7bb2bb263073$var$fastStableStringify(args);
                                requestPromises[requestHash] = (_requestPromises_requestHash = requestPromises[requestHash]) !== null && _requestPromises_requestHash !== void 0 ? _requestPromises_requestHash : (0, $6rBFC._)(function() {
                                    var unsafeRes, res;
                                    return (0, $6qu4b.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    ,
                                                    2,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    _this1._rpcRequest("getBlockHeight", args)
                                                ];
                                            case 1:
                                                unsafeRes = _state.sent();
                                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.number)()));
                                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                                                return [
                                                    2,
                                                    res.result
                                                ];
                                            case 2:
                                                delete requestPromises[requestHash];
                                                return [
                                                    7
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                                return [
                                    4,
                                    requestPromises[requestHash]
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function(commitmentOrConfig) {
                    return _ref.apply(this, arguments);
                };
            }();
        }();
        var wsEndpoint;
        var httpHeaders;
        var fetch;
        var fetchMiddleware;
        var disableRetryOnRateLimit;
        var httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $275f7bb2bb263073$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $275f7bb2bb263073$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $275f7bb2bb263073$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $275f7bb2bb263073$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $275f7bb2bb263073$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $275f7bb2bb263073$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    (0, $eW5pA._)(Connection, [
        {
            key: "commitment",
            get: /**
   * The default commitment used for requests
   */ function get() {
                return this._commitment;
            }
        },
        {
            key: "rpcEndpoint",
            get: /**
   * The RPC endpoint
   */ function get() {
                return this._rpcEndpoint;
            }
        },
        {
            key: "getBalanceAndContext",
            value: /**
   * Fetch the balance for the specified public key, return with context
   */ function getBalanceAndContext(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                /** @internal */ _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getBalance", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.number)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get balance for ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalance",
            value: /**
   * Fetch the balance for the specified public key
   */ function getBalance(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getBalanceAndContext(publicKey, commitmentOrConfig).then(function(x) {
                                        return x.value;
                                    }).catch(function(e) {
                                        throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockTime",
            value: /**
   * Fetch the estimated production time of a block
   */ function getBlockTime(slot) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getBlockTime", [
                                        slot
                                    ])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.nullable)((0, $91bj2.number)())));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get block time for slot ".concat(slot));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMinimumLedgerSlot",
            value: /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ function getMinimumLedgerSlot() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("minimumLedgerSlot", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.number)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFirstAvailableBlock",
            value: /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ function getFirstAvailableBlock() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getFirstAvailableBlock", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$SlotRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSupply",
            value: /**
   * Fetch information about the current supply
   */ function getSupply(config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var configArg, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                configArg = {};
                                if (typeof config === "string") configArg = {
                                    commitment: config
                                };
                                else if (config) configArg = (0, $gddcW._)((0, $4JCw4._)({}, config), {
                                    commitment: config && config.commitment || _this.commitment
                                });
                                else configArg = {
                                    commitment: _this.commitment
                                };
                                return [
                                    4,
                                    _this._rpcRequest("getSupply", [
                                        configArg
                                    ])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetSupplyRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenSupply",
            value: /**
   * Fetch the current supply of a token mint
   */ function getTokenSupply(tokenMintAddress, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    tokenMintAddress.toBase58()
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenSupply", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext($275f7bb2bb263073$var$TokenAmountResult));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenAccountBalance",
            value: /**
   * Fetch the current balance of a token account
   */ function getTokenAccountBalance(tokenAddress, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    tokenAddress.toBase58()
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenAccountBalance", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext($275f7bb2bb263073$var$TokenAmountResult));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenAccountsByOwner",
            value: /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ function getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, _args, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                _args = [
                                    ownerAddress.toBase58()
                                ];
                                if ("mint" in filter) _args.push({
                                    mint: filter.mint.toBase58()
                                });
                                else _args.push({
                                    programId: filter.programId.toBase58()
                                });
                                args = _this._buildArgs(_args, commitment, "base64", config);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenAccountsByOwner", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetTokenAccountsByOwner);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get token accounts owned by account ".concat(ownerAddress.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedTokenAccountsByOwner",
            value: /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ function getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _args, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _args = [
                                    ownerAddress.toBase58()
                                ];
                                if ("mint" in filter) _args.push({
                                    mint: filter.mint.toBase58()
                                });
                                else _args.push({
                                    programId: filter.programId.toBase58()
                                });
                                args = _this._buildArgs(_args, commitment, "jsonParsed");
                                return [
                                    4,
                                    _this._rpcRequest("getTokenAccountsByOwner", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedTokenAccountsByOwner);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get token accounts owned by account ".concat(ownerAddress.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLargestAccounts",
            value: /**
   * Fetch the 20 largest accounts with their current balances
   */ function getLargestAccounts(config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var arg, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                arg = (0, $gddcW._)((0, $4JCw4._)({}, config), {
                                    commitment: config && config.commitment || _this.commitment
                                });
                                args = arg.filter || arg.commitment ? [
                                    arg
                                ] : [];
                                return [
                                    4,
                                    _this._rpcRequest("getLargestAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetLargestAccountsRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenLargestAccounts",
            value: /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ function getTokenLargestAccounts(mintAddress, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    mintAddress.toBase58()
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenLargestAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetTokenLargestAccountsResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountInfoAndContext",
            value: /**
   * Fetch all the account info for the specified public key, return with context
   */ function getAccountInfoAndContext(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, "base64", config);
                                return [
                                    4,
                                    _this._rpcRequest("getAccountInfo", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.nullable)($275f7bb2bb263073$var$AccountInfoResult)));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get info about account ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedAccountInfo",
            value: /**
   * Fetch parsed account info for the specified public key
   */ function getParsedAccountInfo(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getAccountInfo", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.nullable)($275f7bb2bb263073$var$ParsedAccountInfoResult)));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get info about account ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountInfo",
            value: /**
   * Fetch all the account info for the specified public key
   */ function getAccountInfo(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var res, e;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getAccountInfoAndContext(publicKey, commitmentOrConfig)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMultipleParsedAccounts",
            value: /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ function getMultipleParsedAccounts(publicKeys, rawConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, keys, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                keys = publicKeys.map(function(key) {
                                    return key.toBase58();
                                });
                                args = _this._buildArgs([
                                    keys
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getMultipleAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.nullable)($275f7bb2bb263073$var$ParsedAccountInfoResult))));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get info for accounts ".concat(keys));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMultipleAccountsInfoAndContext",
            value: /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ function getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, keys, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                keys = publicKeys.map(function(key) {
                                    return key.toBase58();
                                });
                                args = _this._buildArgs([
                                    keys
                                ], commitment, "base64", config);
                                return [
                                    4,
                                    _this._rpcRequest("getMultipleAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.array)((0, $91bj2.nullable)($275f7bb2bb263073$var$AccountInfoResult))));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get info for accounts ".concat(keys));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMultipleAccountsInfo",
            value: /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ function getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStakeActivation",
            value: /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */ function getStakeActivation(publicKey, commitmentOrConfig, epoch) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, undefined /* encoding */ , (0, $gddcW._)((0, $4JCw4._)({}, config), {
                                    epoch: epoch != null ? epoch : config === null || config === void 0 ? void 0 : config.epoch
                                }));
                                return [
                                    4,
                                    _this._rpcRequest("getStakeActivation", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$StakeActivationResult));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get Stake Activation ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProgramAccounts",
            value: /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            function getProgramAccounts(programId, configOrCommitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, _ref, encoding, configWithoutEncoding, args, unsafeRes, baseSchema, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(configOrCommitment), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                _ref = config || {}, encoding = _ref.encoding, configWithoutEncoding = (0, $bL8uU._)(_ref, [
                                    "encoding"
                                ]);
                                args = _this._buildArgs([
                                    programId.toBase58()
                                ], commitment, encoding || "base64", (0, $4JCw4._)({}, configWithoutEncoding, configWithoutEncoding.filters ? {
                                    filters: $275f7bb2bb263073$var$applyDefaultMemcmpEncodingToFilters(configWithoutEncoding.filters)
                                } : null));
                                return [
                                    4,
                                    _this._rpcRequest("getProgramAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                baseSchema = (0, $91bj2.array)($275f7bb2bb263073$var$KeyedAccountInfoResult);
                                res = configWithoutEncoding.withContext === true ? (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext(baseSchema)) : (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult(baseSchema));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get accounts owned by program ".concat(programId.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedProgramAccounts",
            value: /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ function getParsedProgramAccounts(programId, configOrCommitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(configOrCommitment), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    programId.toBase58()
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getProgramAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)($275f7bb2bb263073$var$KeyedParsedAccountInfoResult)));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get accounts owned by program ".concat(programId.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmTransaction",
            value: /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            function confirmTransaction(strategy, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var rawSignature, _config_abortSignal, config, decodedSignature;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof strategy == "string") rawSignature = strategy;
                                else {
                                    ;
                                    config = strategy;
                                    if ((_config_abortSignal = config.abortSignal) === null || _config_abortSignal === void 0 ? void 0 : _config_abortSignal.aborted) return [
                                        2,
                                        Promise.reject(config.abortSignal.reason)
                                    ];
                                    rawSignature = config.signature;
                                }
                                try {
                                    decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($gYRJ8))).decode(rawSignature);
                                } catch (err) {
                                    throw new Error("signature must be base58 encoded: " + rawSignature);
                                }
                                $275f7bb2bb263073$var$assert(decodedSignature.length === 64, "signature has invalid length");
                                if (!(typeof strategy === "string")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.confirmTransactionUsingLegacyTimeoutStrategy({
                                        commitment: commitment || _this.commitment,
                                        signature: rawSignature
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                if (!("lastValidBlockHeight" in strategy)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.confirmTransactionUsingBlockHeightExceedanceStrategy({
                                        commitment: commitment || _this.commitment,
                                        strategy: strategy
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.confirmTransactionUsingDurableNonceStrategy({
                                        commitment: commitment || _this.commitment,
                                        strategy: strategy
                                    })
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCancellationPromise",
            value: function getCancellationPromise(signal) {
                return new Promise(function(_, reject) {
                    if (signal == null) return;
                    if (signal.aborted) reject(signal.reason);
                    else signal.addEventListener("abort", function() {
                        reject(signal.reason);
                    });
                });
            }
        },
        {
            key: "getTransactionConfirmationPromise",
            value: function getTransactionConfirmationPromise(param) {
                var commitment = param.commitment, signature = param.signature;
                var _this = this;
                var signatureSubscriptionId;
                var disposeSignatureSubscriptionStateChangeObserver;
                var done = false;
                var confirmationPromise = new Promise(function(resolve, reject) {
                    try {
                        signatureSubscriptionId = _this.onSignature(signature, function(result, context) {
                            signatureSubscriptionId = undefined;
                            var response = {
                                context: context,
                                value: result
                            };
                            resolve({
                                __type: $275f7bb2bb263073$export$7c391bd3b61d2374.PROCESSED,
                                response: response
                            });
                        }, commitment);
                        var subscriptionSetupPromise = new Promise(function(resolveSubscriptionSetup) {
                            if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                            else disposeSignatureSubscriptionStateChangeObserver = _this._onSubscriptionStateChange(signatureSubscriptionId, function(nextState) {
                                if (nextState === "subscribed") resolveSubscriptionSetup();
                            });
                        });
                        var _this1 = _this;
                        (0, $6rBFC._)(function() {
                            var response, context, value;
                            return (0, $6qu4b.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            subscriptionSetupPromise
                                        ];
                                    case 1:
                                        _state.sent();
                                        if (done) return [
                                            2
                                        ];
                                        return [
                                            4,
                                            _this1.getSignatureStatus(signature)
                                        ];
                                    case 2:
                                        response = _state.sent();
                                        if (done) return [
                                            2
                                        ];
                                        if (response == null) return [
                                            2
                                        ];
                                        context = response.context, value = response.value;
                                        if (value == null) return [
                                            2
                                        ];
                                        if (value === null || value === void 0 ? void 0 : value.err) reject(value.err);
                                        else {
                                            switch(commitment){
                                                case "confirmed":
                                                case "single":
                                                case "singleGossip":
                                                    if (value.confirmationStatus === "processed") return [
                                                        2
                                                    ];
                                                    break;
                                                case "finalized":
                                                case "max":
                                                case "root":
                                                    if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return [
                                                        2
                                                    ];
                                                    break;
                                                // exhaust enums to ensure full coverage
                                                case "processed":
                                                case "recent":
                                            }
                                            done = true;
                                            resolve({
                                                __type: $275f7bb2bb263073$export$7c391bd3b61d2374.PROCESSED,
                                                response: {
                                                    context: context,
                                                    value: value
                                                }
                                            });
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    } catch (err) {
                        reject(err);
                    }
                });
                var abortConfirmation = function() {
                    if (disposeSignatureSubscriptionStateChangeObserver) {
                        disposeSignatureSubscriptionStateChangeObserver();
                        disposeSignatureSubscriptionStateChangeObserver = undefined;
                    }
                    if (signatureSubscriptionId != null) {
                        _this.removeSignatureListener(signatureSubscriptionId);
                        signatureSubscriptionId = undefined;
                    }
                };
                return {
                    abortConfirmation: abortConfirmation,
                    confirmationPromise: confirmationPromise
                };
            }
        },
        {
            key: "confirmTransactionUsingBlockHeightExceedanceStrategy",
            value: function confirmTransactionUsingBlockHeightExceedanceStrategy(param) {
                var commitment = param.commitment, _param_strategy = param.strategy, abortSignal = _param_strategy.abortSignal, lastValidBlockHeight = _param_strategy.lastValidBlockHeight, signature = _param_strategy.signature;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var done, expiryPromise, _this_getTransactionConfirmationPromise, abortConfirmation, confirmationPromise, cancellationPromise, result, outcome;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                done = false;
                                expiryPromise = new Promise(function(resolve) {
                                    var checkBlockHeight = function() {
                                        var _ref = (0, $6rBFC._)(function() {
                                            var blockHeight, _e;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]);
                                                        return [
                                                            4,
                                                            _this.getBlockHeight(commitment)
                                                        ];
                                                    case 1:
                                                        blockHeight = _state.sent();
                                                        return [
                                                            2,
                                                            blockHeight
                                                        ];
                                                    case 2:
                                                        _e = _state.sent();
                                                        return [
                                                            2,
                                                            -1
                                                        ];
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function checkBlockHeight() {
                                            return _ref.apply(this, arguments);
                                        };
                                    }();
                                    (0, $6rBFC._)(function() {
                                        var currentBlockHeight;
                                        return (0, $6qu4b.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        checkBlockHeight()
                                                    ];
                                                case 1:
                                                    currentBlockHeight = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    _state.label = 2;
                                                case 2:
                                                    if (!(currentBlockHeight <= lastValidBlockHeight)) return [
                                                        3,
                                                        5
                                                    ];
                                                    return [
                                                        4,
                                                        $275f7bb2bb263073$var$sleep(1000)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        checkBlockHeight()
                                                    ];
                                                case 4:
                                                    currentBlockHeight = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        3,
                                                        2
                                                    ];
                                                case 5:
                                                    resolve({
                                                        __type: $275f7bb2bb263073$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                                                    });
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                                _this_getTransactionConfirmationPromise = _this.getTransactionConfirmationPromise({
                                    commitment: commitment,
                                    signature: signature
                                }), abortConfirmation = _this_getTransactionConfirmationPromise.abortConfirmation, confirmationPromise = _this_getTransactionConfirmationPromise.confirmationPromise;
                                cancellationPromise = _this.getCancellationPromise(abortSignal);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.race([
                                        cancellationPromise,
                                        confirmationPromise,
                                        expiryPromise
                                    ])
                                ];
                            case 2:
                                outcome = _state.sent();
                                if (outcome.__type === $275f7bb2bb263073$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
                                else throw new $275f7bb2bb263073$export$718fcd78527f88ed(signature);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                done = true;
                                abortConfirmation();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmTransactionUsingDurableNonceStrategy",
            value: function confirmTransactionUsingDurableNonceStrategy(param) {
                var commitment = param.commitment, _param_strategy = param.strategy, abortSignal = _param_strategy.abortSignal, minContextSlot = _param_strategy.minContextSlot, nonceAccountPubkey = _param_strategy.nonceAccountPubkey, nonceValue = _param_strategy.nonceValue, signature = _param_strategy.signature;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var done, expiryPromise, _this_getTransactionConfirmationPromise, abortConfirmation, confirmationPromise, cancellationPromise, result, outcome, signatureStatus, status, _outcome_slotInWhichNonceDidAdvance, commitmentForStatus, confirmationStatus;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                done = false;
                                expiryPromise = new Promise(function(resolve) {
                                    var currentNonceValue = nonceValue;
                                    var lastCheckedSlot = null;
                                    var getCurrentNonceValue = function() {
                                        var _ref = (0, $6rBFC._)(function() {
                                            var _ref, context, nonceAccount, e;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]);
                                                        return [
                                                            4,
                                                            _this.getNonceAndContext(nonceAccountPubkey, {
                                                                commitment: commitment,
                                                                minContextSlot: minContextSlot
                                                            })
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), context = _ref.context, nonceAccount = _ref.value;
                                                        lastCheckedSlot = context.slot;
                                                        return [
                                                            2,
                                                            nonceAccount === null || nonceAccount === void 0 ? void 0 : nonceAccount.nonce
                                                        ];
                                                    case 2:
                                                        e = _state.sent();
                                                        // If for whatever reason we can't reach/read the nonce
                                                        // account, just keep using the last-known value.
                                                        return [
                                                            2,
                                                            currentNonceValue
                                                        ];
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function getCurrentNonceValue() {
                                            return _ref.apply(this, arguments);
                                        };
                                    }();
                                    (0, $6rBFC._)(function() {
                                        return (0, $6qu4b.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        getCurrentNonceValue()
                                                    ];
                                                case 1:
                                                    currentNonceValue = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    _state.label = 2;
                                                case 2:
                                                    if (!true // eslint-disable-line no-constant-condition
                                                    ) return [
                                                        3,
                                                        5
                                                    ];
                                                    if (nonceValue !== currentNonceValue) {
                                                        resolve({
                                                            __type: $275f7bb2bb263073$export$7c391bd3b61d2374.NONCE_INVALID,
                                                            slotInWhichNonceDidAdvance: lastCheckedSlot
                                                        });
                                                        return [
                                                            2
                                                        ];
                                                    }
                                                    return [
                                                        4,
                                                        $275f7bb2bb263073$var$sleep(2000)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        getCurrentNonceValue()
                                                    ];
                                                case 4:
                                                    currentNonceValue = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        3,
                                                        2
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                                _this_getTransactionConfirmationPromise = _this.getTransactionConfirmationPromise({
                                    commitment: commitment,
                                    signature: signature
                                }), abortConfirmation = _this_getTransactionConfirmationPromise.abortConfirmation, confirmationPromise = _this_getTransactionConfirmationPromise.confirmationPromise;
                                cancellationPromise = _this.getCancellationPromise(abortSignal);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    9,
                                    10
                                ]);
                                return [
                                    4,
                                    Promise.race([
                                        cancellationPromise,
                                        confirmationPromise,
                                        expiryPromise
                                    ])
                                ];
                            case 2:
                                outcome = _state.sent();
                                if (!(outcome.__type === $275f7bb2bb263073$export$7c391bd3b61d2374.PROCESSED)) return [
                                    3,
                                    3
                                ];
                                result = outcome.response;
                                return [
                                    3,
                                    8
                                ];
                            case 3:
                                if (!true // eslint-disable-line no-constant-condition
                                ) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.getSignatureStatus(signature)
                                ];
                            case 4:
                                status = _state.sent();
                                if (status == null) return [
                                    3,
                                    7
                                ];
                                if (!(status.context.slot < ((_outcome_slotInWhichNonceDidAdvance = outcome.slotInWhichNonceDidAdvance) !== null && _outcome_slotInWhichNonceDidAdvance !== void 0 ? _outcome_slotInWhichNonceDidAdvance : minContextSlot))) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    $275f7bb2bb263073$var$sleep(400)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                signatureStatus = status;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                if (signatureStatus === null || signatureStatus === void 0 ? void 0 : signatureStatus.value) {
                                    commitmentForStatus = commitment || "finalized";
                                    confirmationStatus = signatureStatus.value.confirmationStatus;
                                    switch(commitmentForStatus){
                                        case "processed":
                                        case "recent":
                                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $275f7bb2bb263073$export$a3e7565a95f5a1e5(signature);
                                            break;
                                        case "confirmed":
                                        case "single":
                                        case "singleGossip":
                                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $275f7bb2bb263073$export$a3e7565a95f5a1e5(signature);
                                            break;
                                        case "finalized":
                                        case "max":
                                        case "root":
                                            if (confirmationStatus !== "finalized") throw new $275f7bb2bb263073$export$a3e7565a95f5a1e5(signature);
                                            break;
                                        default:
                                            // Exhaustive switch.
                                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                            (function(_) {})(commitmentForStatus);
                                    }
                                    result = {
                                        context: signatureStatus.context,
                                        value: {
                                            err: signatureStatus.value.err
                                        }
                                    };
                                } else throw new $275f7bb2bb263073$export$a3e7565a95f5a1e5(signature);
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                done = true;
                                abortConfirmation();
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmTransactionUsingLegacyTimeoutStrategy",
            value: function confirmTransactionUsingLegacyTimeoutStrategy(param) {
                var commitment = param.commitment, signature = param.signature;
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var timeoutId, expiryPromise, _this_getTransactionConfirmationPromise, abortConfirmation, confirmationPromise, result, outcome;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                expiryPromise = new Promise(function(resolve) {
                                    var timeoutMs = _this._confirmTransactionInitialTimeout || 60000;
                                    switch(commitment){
                                        case "processed":
                                        case "recent":
                                        case "single":
                                        case "confirmed":
                                        case "singleGossip":
                                            timeoutMs = _this._confirmTransactionInitialTimeout || 30000;
                                            break;
                                    }
                                    timeoutId = setTimeout(function() {
                                        return resolve({
                                            __type: $275f7bb2bb263073$export$7c391bd3b61d2374.TIMED_OUT,
                                            timeoutMs: timeoutMs
                                        });
                                    }, timeoutMs);
                                });
                                _this_getTransactionConfirmationPromise = _this.getTransactionConfirmationPromise({
                                    commitment: commitment,
                                    signature: signature
                                }), abortConfirmation = _this_getTransactionConfirmationPromise.abortConfirmation, confirmationPromise = _this_getTransactionConfirmationPromise.confirmationPromise;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.race([
                                        confirmationPromise,
                                        expiryPromise
                                    ])
                                ];
                            case 2:
                                outcome = _state.sent();
                                if (outcome.__type === $275f7bb2bb263073$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
                                else throw new $275f7bb2bb263073$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                clearTimeout(timeoutId);
                                abortConfirmation();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getClusterNodes",
            value: /**
   * Return the list of nodes that are currently participating in the cluster
   */ function getClusterNodes() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getClusterNodes", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)($275f7bb2bb263073$var$ContactInfoResult)));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVoteAccounts",
            value: /**
   * Return the list of nodes that are currently participating in the cluster
   */ function getVoteAccounts(commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getVoteAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetVoteAccounts);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlot",
            value: /**
   * Fetch the current slot that the node is processing
   */ function getSlot(commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getSlot", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.number)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlotLeader",
            value: /**
   * Fetch the current slot leader of the cluster
   */ function getSlotLeader(commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getSlotLeader", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.string)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlotLeaders",
            value: /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ function getSlotLeaders(startSlot, limit) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = [
                                    startSlot,
                                    limit
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("getSlotLeaders", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)($275f7bb2bb263073$var$PublicKeyFromString)));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignatureStatus",
            value: /**
   * Fetch the current status of a signature
   */ function getSignatureStatus(signature, config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, context, values, value;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignatureStatuses([
                                        signature
                                    ], config)
                                ];
                            case 1:
                                _ref = _state.sent(), context = _ref.context, values = _ref.value;
                                $275f7bb2bb263073$var$assert(values.length === 1);
                                value = values[0];
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignatureStatuses",
            value: /**
   * Fetch the current statuses of a batch of signatures
   */ function getSignatureStatuses(signatures, config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var params, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = [
                                    signatures
                                ];
                                if (config) params.push(config);
                                return [
                                    4,
                                    _this._rpcRequest("getSignatureStatuses", params)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetSignatureStatusesRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactionCount",
            value: /**
   * Fetch the current transaction count of the cluster
   */ function getTransactionCount(commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getTransactionCount", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.number)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTotalSupply",
            value: /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */ function getTotalSupply(commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSupply({
                                        commitment: commitment,
                                        excludeNonCirculatingAccountsList: true
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.value.total
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInflationGovernor",
            value: /**
   * Fetch the cluster InflationGovernor parameters
   */ function getInflationGovernor(commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getInflationGovernor", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetInflationGovernorRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInflationReward",
            value: /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ function getInflationReward(addresses, epoch, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    addresses.map(function(pubkey) {
                                        return pubkey.toBase58();
                                    })
                                ], commitment, undefined /* encoding */ , (0, $gddcW._)((0, $4JCw4._)({}, config), {
                                    epoch: epoch != null ? epoch : config === null || config === void 0 ? void 0 : config.epoch
                                }));
                                return [
                                    4,
                                    _this._rpcRequest("getInflationReward", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetInflationRewardResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInflationRate",
            value: /**
   * Fetch the specific inflation values for the current epoch
   */ function getInflationRate() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getInflationRate", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetInflationRateRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEpochInfo",
            value: /**
   * Fetch the Epoch Info parameters
   */ function getEpochInfo(commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getEpochInfo", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetEpochInfoRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEpochSchedule",
            value: /**
   * Fetch the Epoch Schedule parameters
   */ function getEpochSchedule() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res, epochSchedule;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getEpochSchedule", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetEpochScheduleRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
                                epochSchedule = res.result;
                                return [
                                    2,
                                    new $275f7bb2bb263073$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLeaderSchedule",
            value: /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ function getLeaderSchedule() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getLeaderSchedule", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetLeaderScheduleRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMinimumBalanceForRentExemption",
            value: /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ function getMinimumBalanceForRentExemption(dataLength, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    dataLength
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getMinimumBalanceForRentExemption", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetMinimumBalanceForRentExemptionRpcResult);
                                if ("error" in res) {
                                    console.warn("Unable to fetch minimum balance for rent exemption");
                                    return [
                                        2,
                                        0
                                    ];
                                }
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentBlockhashAndContext",
            value: /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */ function getRecentBlockhashAndContext(commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getRecentBlockhash", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetRecentBlockhashAndContextRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentPerformanceSamples",
            value: /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ function getRecentPerformanceSamples(limit) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getRecentPerformanceSamples", limit ? [
                                        limit
                                    ] : [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetRecentPerformanceSamplesRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFeeCalculatorForBlockhash",
            value: /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */ function getFeeCalculatorForBlockhash(blockhash, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res, _res_result, context, value;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    blockhash
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getFeeCalculatorForBlockhash", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetFeeCalculatorRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
                                _res_result = res.result, context = _res_result.context, value = _res_result.value;
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value !== null ? value.feeCalculator : null
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFeeForMessage",
            value: /**
   * Fetch the fee for a message from the cluster, return with context
   */ function getFeeForMessage(message, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var wireMessage, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wireMessage = $275f7bb2bb263073$var$toBuffer(message.serialize()).toString("base64");
                                args = _this._buildArgs([
                                    wireMessage
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getFeeForMessage", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.nullable)((0, $91bj2.number)())));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
                                if (res.result === null) throw new Error("invalid blockhash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentPrioritizationFees",
            value: /**
   * Fetch a list of prioritization fees from recent blocks.
   */ function getRecentPrioritizationFees(config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _config_lockedWritableAccounts, accounts, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accounts = config === null || config === void 0 ? void 0 : (_config_lockedWritableAccounts = config.lockedWritableAccounts) === null || _config_lockedWritableAccounts === void 0 ? void 0 : _config_lockedWritableAccounts.map(function(key) {
                                    return key.toBase58();
                                });
                                args = (accounts === null || accounts === void 0 ? void 0 : accounts.length) ? [
                                    accounts
                                ] : [];
                                return [
                                    4,
                                    _this._rpcRequest("getRecentPrioritizationFees", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetRecentPrioritizationFeesRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentBlockhash",
            value: /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ function getRecentBlockhash(commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var res, e;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getRecentBlockhashAndContext(commitment)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error("failed to get recent blockhash: " + e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLatestBlockhash",
            value: /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ function getLatestBlockhash(commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var res, e;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getLatestBlockhashAndContext(commitmentOrConfig)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error("failed to get recent blockhash: " + e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLatestBlockhashAndContext",
            value: /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ function getLatestBlockhashAndContext(commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getLatestBlockhash", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetLatestBlockhashRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isBlockhashValid",
            value: /**
   * Returns whether a blockhash is still valid or not
   */ function isBlockhashValid(blockhash, rawConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    blockhash
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("isBlockhashValid", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$IsBlockhashValidRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVersion",
            value: /**
   * Fetch the node version
   */ function getVersion() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getVersion", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult($275f7bb2bb263073$var$VersionResult));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGenesisHash",
            value: /**
   * Fetch the genesis hash
   */ function getGenesisHash() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getGenesisHash", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.string)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            function getBlock(slot, rawConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res, res1, res2, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                try {
                                    switch(config === null || config === void 0 ? void 0 : config.transactionDetails){
                                        case "accounts":
                                            {
                                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetAccountsModeBlockRpcResult);
                                                if ("error" in res) throw res.error;
                                                return [
                                                    2,
                                                    res.result
                                                ];
                                            }
                                        case "none":
                                            {
                                                res1 = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetNoneModeBlockRpcResult);
                                                if ("error" in res1) throw res1.error;
                                                return [
                                                    2,
                                                    res1.result
                                                ];
                                            }
                                        default:
                                            {
                                                res2 = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetBlockRpcResult);
                                                if ("error" in res2) throw res2.error;
                                                result = res2.result;
                                                return [
                                                    2,
                                                    result ? (0, $gddcW._)((0, $4JCw4._)({}, result), {
                                                        transactions: result.transactions.map(function(param) {
                                                            var transaction = param.transaction, meta = param.meta, version = param.version;
                                                            return {
                                                                meta: meta,
                                                                transaction: (0, $gddcW._)((0, $4JCw4._)({}, transaction), {
                                                                    message: $275f7bb2bb263073$var$versionedMessageFromResponse(version, transaction.message)
                                                                }),
                                                                version: version
                                                            };
                                                        })
                                                    }) : null
                                                ];
                                            }
                                    }
                                } catch (e) {
                                    throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedBlock",
            value: /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            function getParsedBlock(slot, rawConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res, res1, res2;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                try {
                                    switch(config === null || config === void 0 ? void 0 : config.transactionDetails){
                                        case "accounts":
                                            {
                                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedAccountsModeBlockRpcResult);
                                                if ("error" in res) throw res.error;
                                                return [
                                                    2,
                                                    res.result
                                                ];
                                            }
                                        case "none":
                                            {
                                                res1 = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedNoneModeBlockRpcResult);
                                                if ("error" in res1) throw res1.error;
                                                return [
                                                    2,
                                                    res1.result
                                                ];
                                            }
                                        default:
                                            {
                                                res2 = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedBlockRpcResult);
                                                if ("error" in res2) throw res2.error;
                                                return [
                                                    2,
                                                    res2.result
                                                ];
                                            }
                                    }
                                } catch (e) {
                                    throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(e, "failed to get block");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockProduction",
            value: /*
   * Returns recent block production information from the current or previous epoch
   */ function getBlockProduction(configOrCommitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var extra, commitment, c, rest, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof configOrCommitment === "string") commitment = configOrCommitment;
                                else if (configOrCommitment) {
                                    c = configOrCommitment.commitment, rest = (0, $bL8uU._)(configOrCommitment, [
                                        "commitment"
                                    ]);
                                    commitment = c;
                                    extra = rest;
                                }
                                args = _this._buildArgs([], commitment, "base64", extra);
                                return [
                                    4,
                                    _this._rpcRequest("getBlockProduction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$BlockProductionResponseStruct);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            function getTransaction(signature, rawConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetTransactionRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
                                result = res.result;
                                if (!result) return [
                                    2,
                                    result
                                ];
                                return [
                                    2,
                                    (0, $gddcW._)((0, $4JCw4._)({}, result), {
                                        transaction: (0, $gddcW._)((0, $4JCw4._)({}, result.transaction), {
                                            message: $275f7bb2bb263073$var$versionedMessageFromResponse(result.version, result.transaction.message)
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedTransaction",
            value: /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ function getParsedTransaction(signature, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedTransactionRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedTransactions",
            value: /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ function getParsedTransactions(signatures, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, batch, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                batch = signatures.map(function(signature) {
                                    var args = _this._buildArgsAtLeastConfirmed([
                                        signature
                                    ], commitment, "jsonParsed", config);
                                    return {
                                        methodName: "getTransaction",
                                        args: args
                                    };
                                });
                                return [
                                    4,
                                    _this._rpcBatchRequest(batch)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = unsafeRes.map(function(unsafeRes) {
                                    var res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedTransactionRpcResult);
                                    if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
                                    return res.result;
                                });
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactions",
            value: /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
            function getTransactions(signatures, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, batch, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                batch = signatures.map(function(signature) {
                                    var args = _this._buildArgsAtLeastConfirmed([
                                        signature
                                    ], commitment, undefined /* encoding */ , config);
                                    return {
                                        methodName: "getTransaction",
                                        args: args
                                    };
                                });
                                return [
                                    4,
                                    _this._rpcBatchRequest(batch)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = unsafeRes.map(function(unsafeRes) {
                                    var res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetTransactionRpcResult);
                                    if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
                                    var result = res.result;
                                    if (!result) return result;
                                    return (0, $gddcW._)((0, $4JCw4._)({}, result), {
                                        transaction: (0, $gddcW._)((0, $4JCw4._)({}, result.transaction), {
                                            message: $275f7bb2bb263073$var$versionedMessageFromResponse(result.version, result.transaction.message)
                                        })
                                    });
                                });
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedBlock",
            value: /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */ function getConfirmedBlock(slot, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res, result, block;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetConfirmedBlockRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
                                result = res.result;
                                if (!result) throw new Error("Confirmed block " + slot + " not found");
                                block = (0, $gddcW._)((0, $4JCw4._)({}, result), {
                                    transactions: result.transactions.map(function(param) {
                                        var transaction = param.transaction, meta = param.meta;
                                        var message = new $275f7bb2bb263073$export$f69c19e57285b83a(transaction.message);
                                        return {
                                            meta: meta,
                                            transaction: (0, $gddcW._)((0, $4JCw4._)({}, transaction), {
                                                message: message
                                            })
                                        };
                                    })
                                });
                                return [
                                    2,
                                    (0, $gddcW._)((0, $4JCw4._)({}, block), {
                                        transactions: block.transactions.map(function(param) {
                                            var transaction = param.transaction, meta = param.meta;
                                            return {
                                                meta: meta,
                                                transaction: $275f7bb2bb263073$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                                            };
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlocks",
            value: /**
   * Fetch confirmed blocks between two slots
   */ function getBlocks(startSlot, endSlot, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
                                    startSlot,
                                    endSlot
                                ] : [
                                    startSlot
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getBlocks", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResult((0, $91bj2.array)((0, $91bj2.number)())));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockSignatures",
            value: /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ function getBlockSignatures(slot, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, undefined, {
                                    transactionDetails: "signatures",
                                    rewards: false
                                });
                                return [
                                    4,
                                    _this._rpcRequest("getBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetBlockSignaturesRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
                                result = res.result;
                                if (!result) throw new Error("Block " + slot + " not found");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedBlockSignatures",
            value: /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */ function getConfirmedBlockSignatures(slot, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, undefined, {
                                    transactionDetails: "signatures",
                                    rewards: false
                                });
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetBlockSignaturesRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
                                result = res.result;
                                if (!result) throw new Error("Confirmed block " + slot + " not found");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedTransaction",
            value: /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */ function getConfirmedTransaction(signature, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res, result, message, signatures;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetTransactionRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
                                result = res.result;
                                if (!result) return [
                                    2,
                                    result
                                ];
                                message = new $275f7bb2bb263073$export$f69c19e57285b83a(result.transaction.message);
                                signatures = result.transaction.signatures;
                                return [
                                    2,
                                    (0, $gddcW._)((0, $4JCw4._)({}, result), {
                                        transaction: $275f7bb2bb263073$export$febc5573c75cefb0.populate(message, signatures)
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedConfirmedTransaction",
            value: /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */ function getParsedConfirmedTransaction(signature, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment, "jsonParsed");
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedTransactionRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedConfirmedTransactions",
            value: /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */ function getParsedConfirmedTransactions(signatures, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var batch, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                batch = signatures.map(function(signature) {
                                    var args = _this._buildArgsAtLeastConfirmed([
                                        signature
                                    ], commitment, "jsonParsed");
                                    return {
                                        methodName: "getConfirmedTransaction",
                                        args: args
                                    };
                                });
                                return [
                                    4,
                                    _this._rpcBatchRequest(batch)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = unsafeRes.map(function(unsafeRes) {
                                    var res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetParsedTransactionRpcResult);
                                    if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
                                    return res.result;
                                });
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedSignaturesForAddress",
            value: /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ function getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var options, firstAvailableBlock, block, err, highestConfirmedRoot, block1, err1, confirmedSignatureInfo;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = {};
                                return [
                                    4,
                                    _this.getFirstAvailableBlock()
                                ];
                            case 1:
                                firstAvailableBlock = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!!("until" in options)) return [
                                    3,
                                    7
                                ];
                                startSlot--;
                                if (startSlot <= 0 || startSlot < firstAvailableBlock) return [
                                    3,
                                    7
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.getConfirmedBlockSignatures(startSlot, "finalized")
                                ];
                            case 4:
                                block = _state.sent();
                                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                err = _state.sent();
                                if (err instanceof Error && err.message.includes("skipped")) return [
                                    3,
                                    2
                                ];
                                else throw err;
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.getSlot("finalized")
                                ];
                            case 8:
                                highestConfirmedRoot = _state.sent();
                                _state.label = 9;
                            case 9:
                                if (!!("before" in options)) return [
                                    3,
                                    14
                                ];
                                endSlot++;
                                if (endSlot > highestConfirmedRoot) return [
                                    3,
                                    14
                                ];
                                _state.label = 10;
                            case 10:
                                _state.trys.push([
                                    10,
                                    12,
                                    ,
                                    13
                                ]);
                                return [
                                    4,
                                    _this.getConfirmedBlockSignatures(endSlot)
                                ];
                            case 11:
                                block1 = _state.sent();
                                if (block1.signatures.length > 0) options.before = block1.signatures[block1.signatures.length - 1].toString();
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                err1 = _state.sent();
                                if (err1 instanceof Error && err1.message.includes("skipped")) return [
                                    3,
                                    9
                                ];
                                else throw err1;
                                return [
                                    3,
                                    13
                                ];
                            case 13:
                                return [
                                    3,
                                    9
                                ];
                            case 14:
                                return [
                                    4,
                                    _this.getConfirmedSignaturesForAddress2(address, options)
                                ];
                            case 15:
                                confirmedSignatureInfo = _state.sent();
                                return [
                                    2,
                                    confirmedSignatureInfo.map(function(info) {
                                        return info.signature;
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedSignaturesForAddress2",
            value: /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */ function getConfirmedSignaturesForAddress2(address, options, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    address.toBase58()
                                ], commitment, undefined, options);
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedSignaturesForAddress2", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetConfirmedSignaturesForAddress2RpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignaturesForAddress",
            value: /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ function getSignaturesForAddress(address, options, commitment) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    address.toBase58()
                                ], commitment, undefined, options);
                                return [
                                    4,
                                    _this._rpcRequest("getSignaturesForAddress", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$GetSignaturesForAddressRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAddressLookupTable",
            value: function getAddressLookupTable(accountKey, config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, context, accountInfo, value;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountInfoAndContext(accountKey, config)
                                ];
                            case 1:
                                _ref = _state.sent(), context = _ref.context, accountInfo = _ref.value;
                                value = null;
                                if (accountInfo !== null) value = new $275f7bb2bb263073$export$5b2310da10e607da({
                                    key: accountKey,
                                    state: $275f7bb2bb263073$export$5b2310da10e607da.deserialize(accountInfo.data)
                                });
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNonceAndContext",
            value: /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ function getNonceAndContext(nonceAccount, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _ref, context, accountInfo, value;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig)
                                ];
                            case 1:
                                _ref = _state.sent(), context = _ref.context, accountInfo = _ref.value;
                                value = null;
                                if (accountInfo !== null) value = $275f7bb2bb263073$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNonce",
            value: /**
   * Fetch the contents of a Nonce account from the cluster
   */ function getNonce(nonceAccount, commitmentOrConfig) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getNonceAndContext(nonceAccount, commitmentOrConfig).then(function(x) {
                                        return x.value;
                                    }).catch(function(e) {
                                        throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestAirdrop",
            value: /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ function requestAirdrop(to, lamports) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("requestAirdrop", [
                                        to.toBase58(),
                                        lamports
                                    ])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$RequestAirdropRpcResult);
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "airdrop to ".concat(to.toBase58(), " failed"));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_blockhashWithExpiryBlockHeight",
            value: /**
   * @internal
   */ function _blockhashWithExpiryBlockHeight(disableCache) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var timeSinceFetch, expired;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!disableCache) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                if (!_this._pollingBlockhash) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $275f7bb2bb263073$var$sleep(100)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                timeSinceFetch = Date.now() - _this._blockhashInfo.lastFetch;
                                expired = timeSinceFetch >= $275f7bb2bb263073$export$fcb705732fb5c597;
                                if (_this._blockhashInfo.latestBlockhash !== null && !expired) return [
                                    2,
                                    _this._blockhashInfo.latestBlockhash
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this._pollNewBlockhash()
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_pollNewBlockhash",
            value: /**
   * @internal
   */ function _pollNewBlockhash() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var startTime, cachedLatestBlockhash, cachedBlockhash, i, latestBlockhash;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._pollingBlockhash = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    7,
                                    8
                                ]);
                                startTime = Date.now();
                                cachedLatestBlockhash = _this._blockhashInfo.latestBlockhash;
                                cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
                                i = 0;
                                _state.label = 2;
                            case 2:
                                if (!(i < 50)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this.getLatestBlockhash("finalized")
                                ];
                            case 3:
                                latestBlockhash = _state.sent();
                                if (cachedBlockhash !== latestBlockhash.blockhash) {
                                    _this._blockhashInfo = {
                                        latestBlockhash: latestBlockhash,
                                        lastFetch: Date.now(),
                                        transactionSignatures: [],
                                        simulatedSignatures: []
                                    };
                                    return [
                                        2,
                                        latestBlockhash
                                    ];
                                }
                                // Sleep for approximately half a slot
                                return [
                                    4,
                                    $275f7bb2bb263073$var$sleep($275f7bb2bb263073$var$MS_PER_SLOT / 2)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                i++;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                throw new Error("Unable to obtain a new blockhash after ".concat(Date.now() - startTime, "ms"));
                            case 7:
                                _this._pollingBlockhash = false;
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStakeMinimumDelegation",
            value: /**
   * get the stake minimum delegation
   */ function getStakeMinimumDelegation(config) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _extractCommitmentFromConfig, commitment, configArg, args, unsafeRes, res;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(config), commitment = _extractCommitmentFromConfig.commitment, configArg = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, "base64", configArg);
                                return [
                                    4,
                                    _this._rpcRequest("getStakeMinimumDelegation", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$jsonRpcResultAndContext((0, $91bj2.number)()));
                                if ("error" in res) throw new $275f7bb2bb263073$export$ea1b1a1bba5c14ad(res.error, "failed to get stake minimum delegation");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "simulateTransaction",
            value: /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
            function simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _transaction, versionedTx, wireTransaction, encodedTransaction, config, args, unsafeRes, res, transaction, originalTx, signers, disableCache, _transaction1, latestBlockhash, signature, message, signData, wireTransaction1, encodedTransaction1, config1, addresses, args1, unsafeRes1, res1, logs, traceIndent, logTrace;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!("message" in transactionOrMessage)) return [
                                    3,
                                    2
                                ];
                                versionedTx = transactionOrMessage;
                                wireTransaction = versionedTx.serialize();
                                encodedTransaction = (0, $ilnag.Buffer).from(wireTransaction).toString("base64");
                                if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
                                config = configOrSigners || {};
                                config.encoding = "base64";
                                if (!("commitment" in config)) config.commitment = _this.commitment;
                                if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
                                args = [
                                    encodedTransaction,
                                    config
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("simulateTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$SimulatedTransactionResponseStruct);
                                if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
                                return [
                                    2,
                                    res.result
                                ];
                            case 2:
                                if (transactionOrMessage instanceof $275f7bb2bb263073$export$febc5573c75cefb0) {
                                    originalTx = transactionOrMessage;
                                    transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                                    transaction.feePayer = originalTx.feePayer;
                                    transaction.instructions = transactionOrMessage.instructions;
                                    transaction.nonceInfo = originalTx.nonceInfo;
                                    transaction.signatures = originalTx.signatures;
                                } else {
                                    transaction = $275f7bb2bb263073$export$febc5573c75cefb0.populate(transactionOrMessage);
                                    // HACK: this function relies on mutating the populated transaction
                                    transaction._message = transaction._json = undefined;
                                }
                                if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
                                signers = configOrSigners;
                                if (!(transaction.nonceInfo && signers)) return [
                                    3,
                                    3
                                ];
                                (_transaction = transaction).sign.apply(_transaction, (0, $gF0bR._)(signers));
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                disableCache = _this._disableBlockhashCaching;
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this._blockhashWithExpiryBlockHeight(disableCache)
                                ];
                            case 5:
                                latestBlockhash = _state.sent();
                                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                                transaction.recentBlockhash = latestBlockhash.blockhash;
                                if (!signers) return [
                                    3,
                                    7
                                ];
                                (_transaction1 = transaction).sign.apply(_transaction1, (0, $gF0bR._)(signers));
                                if (!transaction.signature) throw new Error("!signature"); // should never happen
                                signature = transaction.signature.toString("base64");
                                if (!_this._blockhashInfo.simulatedSignatures.includes(signature) && !_this._blockhashInfo.transactionSignatures.includes(signature)) {
                                    // The signature of this transaction has not been seen before with the
                                    // current recentBlockhash, all done. Let's break
                                    _this._blockhashInfo.simulatedSignatures.push(signature);
                                    return [
                                        3,
                                        7
                                    ];
                                } else // This transaction would be treated as duplicate (its derived signature
                                // matched to one of already recorded signatures).
                                // So, we must fetch a new blockhash for a different signature by disabling
                                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                                disableCache = true;
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                message = transaction._compile();
                                signData = message.serialize();
                                wireTransaction1 = transaction._serialize(signData);
                                encodedTransaction1 = wireTransaction1.toString("base64");
                                config1 = {
                                    encoding: "base64",
                                    commitment: _this.commitment
                                };
                                if (includeAccounts) {
                                    addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map(function(key) {
                                        return key.toBase58();
                                    });
                                    config1["accounts"] = {
                                        encoding: "base64",
                                        addresses: addresses
                                    };
                                }
                                if (signers) config1.sigVerify = true;
                                if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config1.innerInstructions = configOrSigners.innerInstructions;
                                args1 = [
                                    encodedTransaction1,
                                    config1
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("simulateTransaction", args1)
                                ];
                            case 8:
                                unsafeRes1 = _state.sent();
                                res1 = (0, $91bj2.create)(unsafeRes1, $275f7bb2bb263073$var$SimulatedTransactionResponseStruct);
                                if ("error" in res1) {
                                    ;
                                    if ("data" in res1.error) {
                                        logs = res1.error.data.logs;
                                        if (logs && Array.isArray(logs)) {
                                            traceIndent = "\n    ";
                                            logTrace = traceIndent + logs.join(traceIndent);
                                            console.error(res1.error.message, logTrace);
                                        }
                                    }
                                    throw new $275f7bb2bb263073$export$121e803f723b3045({
                                        action: "simulate",
                                        signature: "",
                                        transactionMessage: res1.error.message,
                                        logs: logs
                                    });
                                }
                                return [
                                    2,
                                    res1.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
            function sendTransaction(transaction, signersOrOptions, options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _transaction, wireTransaction, signers, disableCache, _transaction1, latestBlockhash, signature, wireTransaction1;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!("version" in transaction)) return [
                                    3,
                                    2
                                ];
                                if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
                                wireTransaction = transaction.serialize();
                                return [
                                    4,
                                    _this.sendRawTransaction(wireTransaction, signersOrOptions)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
                                signers = signersOrOptions;
                                if (!transaction.nonceInfo) return [
                                    3,
                                    3
                                ];
                                (_transaction = transaction).sign.apply(_transaction, (0, $gF0bR._)(signers));
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                disableCache = _this._disableBlockhashCaching;
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this._blockhashWithExpiryBlockHeight(disableCache)
                                ];
                            case 5:
                                latestBlockhash = _state.sent();
                                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                                transaction.recentBlockhash = latestBlockhash.blockhash;
                                (_transaction1 = transaction).sign.apply(_transaction1, (0, $gF0bR._)(signers));
                                if (!transaction.signature) throw new Error("!signature"); // should never happen
                                signature = transaction.signature.toString("base64");
                                if (!_this._blockhashInfo.transactionSignatures.includes(signature)) {
                                    // The signature of this transaction has not been seen before with the
                                    // current recentBlockhash, all done. Let's break
                                    _this._blockhashInfo.transactionSignatures.push(signature);
                                    return [
                                        3,
                                        7
                                    ];
                                } else // This transaction would be treated as duplicate (its derived signature
                                // matched to one of already recorded signatures).
                                // So, we must fetch a new blockhash for a different signature by disabling
                                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                                disableCache = true;
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                wireTransaction1 = transaction.serialize();
                                return [
                                    4,
                                    _this.sendRawTransaction(wireTransaction1, options)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendRawTransaction",
            value: /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ function sendRawTransaction(rawTransaction, options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var encodedTransaction, result;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                encodedTransaction = $275f7bb2bb263073$var$toBuffer(rawTransaction).toString("base64");
                                return [
                                    4,
                                    _this.sendEncodedTransaction(encodedTransaction, options)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendEncodedTransaction",
            value: /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ function sendEncodedTransaction(encodedTransaction, options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var config, skipPreflight, preflightCommitment, args, unsafeRes, res, logs;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                config = {
                                    encoding: "base64"
                                };
                                skipPreflight = options && options.skipPreflight;
                                preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
                                 : options && options.preflightCommitment || _this.commitment;
                                if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
                                if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
                                if (skipPreflight) config.skipPreflight = skipPreflight;
                                if (preflightCommitment) config.preflightCommitment = preflightCommitment;
                                args = [
                                    encodedTransaction,
                                    config
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("sendTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $91bj2.create)(unsafeRes, $275f7bb2bb263073$var$SendTransactionRpcResult);
                                if ("error" in res) {
                                    logs = undefined;
                                    if ("data" in res.error) logs = res.error.data.logs;
                                    throw new $275f7bb2bb263073$export$121e803f723b3045({
                                        action: skipPreflight ? "send" : "simulate",
                                        signature: "",
                                        transactionMessage: res.error.message,
                                        logs: logs
                                    });
                                }
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnOpen",
            value: function _wsOnOpen() {
                var _this = this;
                this._rpcWebSocketConnected = true;
                this._rpcWebSocketHeartbeat = setInterval(function() {
                    var _this1 = _this;
                    // Ping server every 5s to prevent idle timeouts
                    (0, $6rBFC._)(function() {
                        var e;
                        return (0, $6qu4b.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        _this1._rpcWebSocket.notify("ping")
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }, 5000);
                this._updateSubscriptions();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnError",
            value: function _wsOnError(err) {
                this._rpcWebSocketConnected = false;
                console.error("ws error:", err.message);
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnClose",
            value: function _wsOnClose(code) {
                var _this = this;
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
                if (this._rpcWebSocketIdleTimeout) {
                    clearTimeout(this._rpcWebSocketIdleTimeout);
                    this._rpcWebSocketIdleTimeout = null;
                }
                if (this._rpcWebSocketHeartbeat) {
                    clearInterval(this._rpcWebSocketHeartbeat);
                    this._rpcWebSocketHeartbeat = null;
                }
                if (code === 1000) {
                    // explicit close, check if any subscriptions have been made since close
                    this._updateSubscriptions();
                    return;
                }
                // implicit close, prepare subscriptions for auto-reconnect
                this._subscriptionCallbacksByServerSubscriptionId = {};
                Object.entries(this._subscriptionsByHash).forEach(function(param) {
                    var _param = (0, $5OlIx._)(param, 2), hash = _param[0], subscription = _param[1];
                    _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                        state: "pending"
                    }));
                });
            }
        },
        {
            /**
   * @internal
   */ key: "_setSubscription",
            value: function _setSubscription(hash, nextSubscription) {
                var _this__subscriptionsByHash_hash;
                var prevState = (_this__subscriptionsByHash_hash = this._subscriptionsByHash[hash]) === null || _this__subscriptionsByHash_hash === void 0 ? void 0 : _this__subscriptionsByHash_hash.state;
                this._subscriptionsByHash[hash] = nextSubscription;
                if (prevState !== nextSubscription.state) {
                    var stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
                    if (stateChangeCallbacks) stateChangeCallbacks.forEach(function(cb) {
                        try {
                            cb(nextSubscription.state);
                        // eslint-disable-next-line no-empty
                        } catch (e) {}
                    });
                }
            }
        },
        {
            /**
   * @internal
   */ key: "_onSubscriptionStateChange",
            value: function _onSubscriptionStateChange(clientSubscriptionId, callback) {
                var _this = this;
                var _this__subscriptionStateChangeCallbacksByHash, _hash;
                var hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
                if (hash == null) return function() {};
                var stateChangeCallbacks = (_this__subscriptionStateChangeCallbacksByHash = this._subscriptionStateChangeCallbacksByHash)[_hash = hash] || (_this__subscriptionStateChangeCallbacksByHash[_hash] = new Set());
                stateChangeCallbacks.add(callback);
                return function() {
                    stateChangeCallbacks.delete(callback);
                    if (stateChangeCallbacks.size === 0) delete _this._subscriptionStateChangeCallbacksByHash[hash];
                };
            }
        },
        {
            key: "_updateSubscriptions",
            value: /**
   * @internal
   */ function _updateSubscriptions() {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var activeWebSocketGeneration, isCurrentConnectionStillActive;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (Object.keys(_this._subscriptionsByHash).length === 0) {
                                    if (_this._rpcWebSocketConnected) {
                                        _this._rpcWebSocketConnected = false;
                                        _this._rpcWebSocketIdleTimeout = setTimeout(function() {
                                            _this._rpcWebSocketIdleTimeout = null;
                                            try {
                                                _this._rpcWebSocket.close();
                                            } catch (err) {
                                                // swallow error if socket has already been closed.
                                                if (err instanceof Error) console.log("Error when closing socket connection: ".concat(err.message));
                                            }
                                        }, 500);
                                    }
                                    return [
                                        2
                                    ];
                                }
                                if (_this._rpcWebSocketIdleTimeout !== null) {
                                    clearTimeout(_this._rpcWebSocketIdleTimeout);
                                    _this._rpcWebSocketIdleTimeout = null;
                                    _this._rpcWebSocketConnected = true;
                                }
                                if (!_this._rpcWebSocketConnected) {
                                    _this._rpcWebSocket.connect();
                                    return [
                                        2
                                    ];
                                }
                                activeWebSocketGeneration = _this._rpcWebSocketGeneration;
                                isCurrentConnectionStillActive = function() {
                                    return activeWebSocketGeneration === _this._rpcWebSocketGeneration;
                                };
                                return [
                                    4,
                                    Promise.all(// Don't be tempted to change this to `Object.entries`. We call
                                    // `_updateSubscriptions` recursively when processing the state,
                                    // so it's important that we look up the *current* version of
                                    // each subscription, every time we process a hash.
                                    Object.keys(_this._subscriptionsByHash).map(function() {
                                        var _ref = (0, $6rBFC._)(function(hash) {
                                            var subscription, _;
                                            return (0, $6qu4b.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        subscription = _this._subscriptionsByHash[hash];
                                                        if (subscription === undefined) // This entry has since been deleted. Skip.
                                                        return [
                                                            2
                                                        ];
                                                        _ = subscription.state;
                                                        switch(_){
                                                            case "pending":
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case "unsubscribed":
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case "subscribed":
                                                                return [
                                                                    3,
                                                                    5
                                                                ];
                                                        }
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 1:
                                                        if (!(subscription.callbacks.size === 0)) return [
                                                            3,
                                                            3
                                                        ];
                                                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete _this._subscriptionsByHash[hash];
                                                        if (subscription.state === "unsubscribed") delete _this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                                                        return [
                                                            4,
                                                            _this._updateSubscriptions()
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                    case 3:
                                                        return [
                                                            4,
                                                            (0, $6rBFC._)(function() {
                                                                var args, method, serverSubscriptionId, e;
                                                                return (0, $6qu4b.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            args = subscription.args, method = subscription.method;
                                                                            _state.label = 1;
                                                                        case 1:
                                                                            _state.trys.push([
                                                                                1,
                                                                                4,
                                                                                ,
                                                                                6
                                                                            ]);
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                state: "subscribing"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._rpcWebSocket.call(method, args)
                                                                            ];
                                                                        case 2:
                                                                            serverSubscriptionId = _state.sent();
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                serverSubscriptionId: serverSubscriptionId,
                                                                                state: "subscribed"
                                                                            }));
                                                                            _this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 3:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 4:
                                                                            e = _state.sent();
                                                                            console.error("Received ".concat(e instanceof Error ? "" : "JSON-RPC ", "error calling `").concat(method, "`"), {
                                                                                args: args,
                                                                                error: e
                                                                            });
                                                                            if (!isCurrentConnectionStillActive()) return [
                                                                                2
                                                                            ];
                                                                            // TODO: Maybe add an 'errored' state or a retry limit?
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                state: "pending"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 5:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 6:
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            })()
                                                        ];
                                                    case 4:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 5:
                                                        if (!(subscription.callbacks.size === 0)) return [
                                                            3,
                                                            7
                                                        ];
                                                        // By the time we successfully set up a subscription
                                                        // with the server, the client stopped caring about it.
                                                        // Tear it down now.
                                                        return [
                                                            4,
                                                            (0, $6rBFC._)(function() {
                                                                var serverSubscriptionId, unsubscribeMethod, e;
                                                                return (0, $6qu4b.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            serverSubscriptionId = subscription.serverSubscriptionId, unsubscribeMethod = subscription.unsubscribeMethod;
                                                                            if (!_this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) return [
                                                                                3,
                                                                                1
                                                                            ];
                                                                            /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ _this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 1:
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                state: "unsubscribing"
                                                                            }));
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                state: "unsubscribing"
                                                                            }));
                                                                            _state.label = 2;
                                                                        case 2:
                                                                            _state.trys.push([
                                                                                2,
                                                                                4,
                                                                                ,
                                                                                6
                                                                            ]);
                                                                            return [
                                                                                4,
                                                                                _this._rpcWebSocket.call(unsubscribeMethod, [
                                                                                    serverSubscriptionId
                                                                                ])
                                                                            ];
                                                                        case 3:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 4:
                                                                            e = _state.sent();
                                                                            if (e instanceof Error) console.error("".concat(unsubscribeMethod, " error:"), e.message);
                                                                            if (!isCurrentConnectionStillActive()) return [
                                                                                2
                                                                            ];
                                                                            // TODO: Maybe add an 'errored' state or a retry limit?
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                state: "subscribed"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 5:
                                                                            _state.sent();
                                                                            return [
                                                                                2
                                                                            ];
                                                                        case 6:
                                                                            _this._setSubscription(hash, (0, $gddcW._)((0, $4JCw4._)({}, subscription), {
                                                                                state: "unsubscribed"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 7:
                                                                            _state.sent();
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            })()
                                                        ];
                                                    case 6:
                                                        _state.sent();
                                                        _state.label = 7;
                                                    case 7:
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 8:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(hash) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_handleServerNotification",
            value: function _handleServerNotification(serverSubscriptionId, callbackArgs) {
                var callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
                if (callbacks === undefined) return;
                callbacks.forEach(function(cb) {
                    try {
                        cb.apply(void 0, // I failed to find a way to convince TypeScript that `cb` is of type
                        // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                        // See https://github.com/microsoft/TypeScript/issues/47615
                        // @ts-ignore
                        (0, $gF0bR._)(callbackArgs));
                    } catch (e) {
                        console.error(e);
                    }
                });
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnAccountNotification",
            value: function _wsOnAccountNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$AccountNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result.value,
                    result.context
                ]);
            }
        },
        {
            /**
   * @internal
   */ key: "_makeSubscription",
            value: function _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
                var clientSubscriptionId = this._nextClientSubscriptionId++;
                var hash = $275f7bb2bb263073$var$fastStableStringify([
                    subscriptionConfig.method,
                    args
                ]);
                var existingSubscription = this._subscriptionsByHash[hash];
                if (existingSubscription === undefined) this._subscriptionsByHash[hash] = (0, $gddcW._)((0, $4JCw4._)({}, subscriptionConfig), {
                    args: args,
                    callbacks: new Set([
                        subscriptionConfig.callback
                    ]),
                    state: "pending"
                });
                else existingSubscription.callbacks.add(subscriptionConfig.callback);
                this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
                var _this = this;
                this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = /*#__PURE__*/ (0, $6rBFC._)(function() {
                    var subscription;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                delete _this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
                                delete _this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
                                subscription = _this._subscriptionsByHash[hash];
                                $275f7bb2bb263073$var$assert(subscription !== undefined, "Could not find a `Subscription` when tearing down client subscription #".concat(clientSubscriptionId));
                                subscription.callbacks.delete(subscriptionConfig.callback);
                                return [
                                    4,
                                    _this._updateSubscriptions()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                this._updateSubscriptions();
                return clientSubscriptionId;
            }
        },
        {
            /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            key: "onAccountChange",
            value: function onAccountChange(publicKey, callback, commitmentOrConfig) {
                var _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                var args = this._buildArgs([
                    publicKey.toBase58()
                ], commitment || this._commitment || "finalized", // Apply connection/server default.
                "base64", config);
                return this._makeSubscription({
                    callback: callback,
                    method: "accountSubscribe",
                    unsubscribeMethod: "accountUnsubscribe"
                }, args);
            }
        },
        {
            key: "removeAccountChangeListener",
            value: /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeAccountChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "account change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnProgramAccountNotification",
            value: function _wsOnProgramAccountNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$ProgramAccountNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    {
                        accountId: result.value.pubkey,
                        accountInfo: result.value.account
                    },
                    result.context
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            key: "onProgramAccountChange",
            value: function onProgramAccountChange(programId, callback, commitmentOrConfig, maybeFilters) {
                var _extractCommitmentFromConfig = $275f7bb2bb263073$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                var args = this._buildArgs([
                    programId.toBase58()
                ], commitment || this._commitment || "finalized", // Apply connection/server default.
                "base64" /* encoding */ , config ? config : maybeFilters ? {
                    filters: $275f7bb2bb263073$var$applyDefaultMemcmpEncodingToFilters(maybeFilters)
                } : undefined /* extra */ );
                return this._makeSubscription({
                    callback: callback,
                    method: "programSubscribe",
                    unsubscribeMethod: "programUnsubscribe"
                }, args);
            }
        },
        {
            key: "removeProgramAccountChangeListener",
            value: /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeProgramAccountChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "program account change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ key: "onLogs",
            value: function onLogs(filter, callback, commitment) {
                var args = this._buildArgs([
                    typeof filter === "object" ? {
                        mentions: [
                            filter.toString()
                        ]
                    } : filter
                ], commitment || this._commitment || "finalized" // Apply connection/server default.
                );
                return this._makeSubscription({
                    callback: callback,
                    method: "logsSubscribe",
                    unsubscribeMethod: "logsUnsubscribe"
                }, args);
            }
        },
        {
            key: "removeOnLogsListener",
            value: /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ function removeOnLogsListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "logs")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnLogsNotification",
            value: function _wsOnLogsNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$LogsNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result.value,
                    result.context
                ]);
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnSlotNotification",
            value: function _wsOnSlotNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$SlotNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ key: "onSlotChange",
            value: function onSlotChange(callback) {
                return this._makeSubscription({
                    callback: callback,
                    method: "slotSubscribe",
                    unsubscribeMethod: "slotUnsubscribe"
                }, []);
            }
        },
        {
            key: "removeSlotChangeListener",
            value: /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeSlotChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "slot change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnSlotUpdatesNotification",
            value: function _wsOnSlotUpdatesNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$SlotUpdateNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ key: "onSlotUpdate",
            value: function onSlotUpdate(callback) {
                return this._makeSubscription({
                    callback: callback,
                    method: "slotsUpdatesSubscribe",
                    unsubscribeMethod: "slotsUpdatesUnsubscribe"
                }, []);
            }
        },
        {
            key: "removeSlotUpdateListener",
            value: /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeSlotUpdateListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "slot update")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_unsubscribeClientSubscription",
            value: /**
   * @internal
   */ function _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var dispose;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dispose = _this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
                                if (!dispose) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    dispose()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                console.warn("Ignored unsubscribe request because an active subscription with id " + "`".concat(clientSubscriptionId, "` for '").concat(subscriptionName, "' events ") + "could not be found.");
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_buildArgs",
            value: function _buildArgs(args, override, encoding, extra) {
                var commitment = override || this._commitment;
                if (commitment || encoding || extra) {
                    var options = {};
                    if (encoding) options.encoding = encoding;
                    if (commitment) options.commitment = commitment;
                    if (extra) options = Object.assign(options, extra);
                    args.push(options);
                }
                return args;
            }
        },
        {
            /**
   * @internal
   */ key: "_buildArgsAtLeastConfirmed",
            value: function _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
                var commitment = override || this._commitment;
                if (commitment && ![
                    "confirmed",
                    "finalized"
                ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
                return this._buildArgs(args, override, encoding, extra);
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnSignatureNotification",
            value: function _wsOnSignatureNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$SignatureNotificationResult), result = _create.result, subscription = _create.subscription;
                if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
                this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
                    {
                        type: "received"
                    },
                    result.context
                ] : [
                    {
                        type: "status",
                        result: result.value
                    },
                    result.context
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ key: "onSignature",
            value: function onSignature(signature, callback, commitment) {
                var _this = this;
                var args = this._buildArgs([
                    signature
                ], commitment || this._commitment || "finalized" // Apply connection/server default.
                );
                var clientSubscriptionId = this._makeSubscription({
                    callback: function(notification, context) {
                        if (notification.type === "status") {
                            callback(notification.result, context);
                            // Signatures subscriptions are auto-removed by the RPC service
                            // so no need to explicitly send an unsubscribe message.
                            try {
                                _this.removeSignatureListener(clientSubscriptionId);
                            // eslint-disable-next-line no-empty
                            } catch (_err) {
                            // Already removed.
                            }
                        }
                    },
                    method: "signatureSubscribe",
                    unsubscribeMethod: "signatureUnsubscribe"
                }, args);
                return clientSubscriptionId;
            }
        },
        {
            /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ key: "onSignatureWithOptions",
            value: function onSignatureWithOptions(signature, callback, options) {
                var _this = this;
                var _ref = (0, $gddcW._)((0, $4JCw4._)({}, options), {
                    commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
                }), commitment = _ref.commitment, extra = (0, $bL8uU._)(_ref, [
                    "commitment"
                ]);
                var args = this._buildArgs([
                    signature
                ], commitment, undefined /* encoding */ , extra);
                var clientSubscriptionId = this._makeSubscription({
                    callback: function(notification, context) {
                        callback(notification, context);
                        // Signatures subscriptions are auto-removed by the RPC service
                        // so no need to explicitly send an unsubscribe message.
                        try {
                            _this.removeSignatureListener(clientSubscriptionId);
                        // eslint-disable-next-line no-empty
                        } catch (_err) {
                        // Already removed.
                        }
                    },
                    method: "signatureSubscribe",
                    unsubscribeMethod: "signatureUnsubscribe"
                }, args);
                return clientSubscriptionId;
            }
        },
        {
            key: "removeSignatureListener",
            value: /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeSignatureListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "signature result")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnRootNotification",
            value: function _wsOnRootNotification(notification) {
                var _create = (0, $91bj2.create)(notification, $275f7bb2bb263073$var$RootNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ key: "onRootChange",
            value: function onRootChange(callback) {
                return this._makeSubscription({
                    callback: callback,
                    method: "rootSubscribe",
                    unsubscribeMethod: "rootUnsubscribe"
                }, []);
            }
        },
        {
            key: "removeRootChangeListener",
            value: /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeRootChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "root change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Connection;
}();
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ var $275f7bb2bb263073$export$c53bca448cf33676 = /*#__PURE__*/ function() {
    "use strict";
    function Keypair(keypair) {
        (0, $7dKN1._)(this, Keypair);
        this._keypair = void 0;
        this._keypair = keypair !== null && keypair !== void 0 ? keypair : $275f7bb2bb263073$var$generateKeypair();
    }
    (0, $eW5pA._)(Keypair, [
        {
            key: "publicKey",
            get: /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ function get() {
                return new $275f7bb2bb263073$export$ca8b6604d6ce14de(this._keypair.publicKey);
            }
        },
        {
            key: "secretKey",
            get: /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ function get() {
                return new Uint8Array(this._keypair.secretKey);
            }
        }
    ], [
        {
            key: "generate",
            value: /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ function generate() {
                return new Keypair($275f7bb2bb263073$var$generateKeypair());
            }
        },
        {
            key: "fromSecretKey",
            value: /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ function fromSecretKey(secretKey, options) {
                if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
                var publicKey = secretKey.slice(32, 64);
                if (!options || !options.skipValidation) {
                    var privateScalar = secretKey.slice(0, 32);
                    var computedPublicKey = $275f7bb2bb263073$var$getPublicKey(privateScalar);
                    for(var ii = 0; ii < 32; ii++){
                        if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
                    }
                }
                return new Keypair({
                    publicKey: publicKey,
                    secretKey: secretKey
                });
            }
        },
        {
            key: "fromSeed",
            value: /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ function fromSeed(seed) {
                var publicKey = $275f7bb2bb263073$var$getPublicKey(seed);
                var secretKey = new Uint8Array(64);
                secretKey.set(seed);
                secretKey.set(publicKey, 32);
                return new Keypair({
                    publicKey: publicKey,
                    secretKey: secretKey
                });
            }
        }
    ]);
    return Keypair;
}();
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ var $275f7bb2bb263073$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$u64("recentSlot"),
            $i4x6j.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$u64(),
            $i4x6j.seq($275f7bb2bb263073$var$publicKey(), $i4x6j.offset($i4x6j.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    }
});
var $275f7bb2bb263073$export$3ab2b24d551f0dc2 = /*#__PURE__*/ function() {
    "use strict";
    function AddressLookupTableInstruction() {
        (0, $7dKN1._)(this, AddressLookupTableInstruction);
    }
    (0, $eW5pA._)(AddressLookupTableInstruction, null, [
        {
            key: "decodeInstructionType",
            value: function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $i4x6j.u32("instruction");
                var index = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($275f7bb2bb263073$export$7d102200c3a357d6)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), layoutType = _step_value[0], layout = _step_value[1];
                        if (layout.index == index) {
                            _$type = layoutType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
                return _$type;
            }
        },
        {
            key: "decodeCreateLookupTable",
            value: function decodeCreateLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 4);
                var recentSlot = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$7d102200c3a357d6.CreateLookupTable, instruction.data).recentSlot;
                return {
                    authority: instruction.keys[1].pubkey,
                    payer: instruction.keys[2].pubkey,
                    recentSlot: Number(recentSlot)
                };
            }
        },
        {
            key: "decodeExtendLookupTable",
            value: function decodeExtendLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                if (instruction.keys.length < 2) throw new Error("invalid instruction; found ".concat(instruction.keys.length, " keys, expected at least 2"));
                var addresses = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$7d102200c3a357d6.ExtendLookupTable, instruction.data).addresses;
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey,
                    payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
                    addresses: addresses.map(function(buffer) {
                        return new $275f7bb2bb263073$export$ca8b6604d6ce14de(buffer);
                    })
                };
            }
        },
        {
            key: "decodeCloseLookupTable",
            value: function decodeCloseLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 3);
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey,
                    recipient: instruction.keys[2].pubkey
                };
            }
        },
        {
            key: "decodeFreezeLookupTable",
            value: function decodeFreezeLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 2);
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey
                };
            }
        },
        {
            key: "decodeDeactivateLookupTable",
            value: function decodeDeactivateLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 2);
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($275f7bb2bb263073$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
            }
        },
        {
            key: "checkKeysLength",
            value: /**
   * @internal
   */ function checkKeysLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return AddressLookupTableInstruction;
}();
var $275f7bb2bb263073$export$5147a345798de168 = /*#__PURE__*/ function() {
    "use strict";
    function AddressLookupTableProgram() {
        (0, $7dKN1._)(this, AddressLookupTableProgram);
    }
    (0, $eW5pA._)(AddressLookupTableProgram, null, [
        {
            key: "createLookupTable",
            value: function createLookupTable(params) {
                var _PublicKey_findProgramAddressSync = (0, $5OlIx._)($275f7bb2bb263073$export$ca8b6604d6ce14de.findProgramAddressSync([
                    params.authority.toBuffer(),
                    (0, $cf4fc149d7ee5705$exports.toBufferLE)(BigInt(params.recentSlot), 8)
                ], this.programId), 2), lookupTableAddress = _PublicKey_findProgramAddressSync[0], bumpSeed = _PublicKey_findProgramAddressSync[1];
                var _$type = $275f7bb2bb263073$export$7d102200c3a357d6.CreateLookupTable;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    recentSlot: BigInt(params.recentSlot),
                    bumpSeed: bumpSeed
                });
                var keys = [
                    {
                        pubkey: lookupTableAddress,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: params.payer,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$d8c4e17726848113.programId,
                        isSigner: false,
                        isWritable: false
                    }
                ];
                return [
                    new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                        programId: this.programId,
                        keys: keys,
                        data: data
                    }),
                    lookupTableAddress
                ];
            }
        },
        {
            key: "freezeLookupTable",
            value: function freezeLookupTable(params) {
                var _$type = $275f7bb2bb263073$export$7d102200c3a357d6.FreezeLookupTable;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        },
        {
            key: "extendLookupTable",
            value: function extendLookupTable(params) {
                var _$type = $275f7bb2bb263073$export$7d102200c3a357d6.ExtendLookupTable;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    addresses: params.addresses.map(function(addr) {
                        return addr.toBytes();
                    })
                });
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                if (params.payer) keys.push({
                    pubkey: params.payer,
                    isSigner: true,
                    isWritable: true
                }, {
                    pubkey: $275f7bb2bb263073$export$d8c4e17726848113.programId,
                    isSigner: false,
                    isWritable: false
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        },
        {
            key: "deactivateLookupTable",
            value: function deactivateLookupTable(params) {
                var _$type = $275f7bb2bb263073$export$7d102200c3a357d6.DeactivateLookupTable;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        },
        {
            key: "closeLookupTable",
            value: function closeLookupTable(params) {
                var _$type = $275f7bb2bb263073$export$7d102200c3a357d6.CloseLookupTable;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: params.recipient,
                        isSigner: false,
                        isWritable: true
                    }
                ];
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        }
    ]);
    return AddressLookupTableProgram;
}();
$275f7bb2bb263073$export$5147a345798de168.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ var $275f7bb2bb263073$export$bc4776847c641a67 = /*#__PURE__*/ function() {
    "use strict";
    function ComputeBudgetInstruction() {
        (0, $7dKN1._)(this, ComputeBudgetInstruction);
    }
    (0, $eW5pA._)(ComputeBudgetInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $i4x6j.u8("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($275f7bb2bb263073$export$b7c79c50764da3d6)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
                return _$type;
            }
        },
        {
            key: "decodeRequestUnits",
            value: /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ function decodeRequestUnits(instruction) {
                this.checkProgramId(instruction.programId);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$b7c79c50764da3d6.RequestUnits, instruction.data), units = _decodeData$1.units, additionalFee = _decodeData$1.additionalFee;
                return {
                    units: units,
                    additionalFee: additionalFee
                };
            }
        },
        {
            key: "decodeRequestHeapFrame",
            value: /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ function decodeRequestHeapFrame(instruction) {
                this.checkProgramId(instruction.programId);
                var bytes = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data).bytes;
                return {
                    bytes: bytes
                };
            }
        },
        {
            key: "decodeSetComputeUnitLimit",
            value: /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ function decodeSetComputeUnitLimit(instruction) {
                this.checkProgramId(instruction.programId);
                var units = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data).units;
                return {
                    units: units
                };
            }
        },
        {
            key: "decodeSetComputeUnitPrice",
            value: /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ function decodeSetComputeUnitPrice(instruction) {
                this.checkProgramId(instruction.programId);
                var microLamports = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data).microLamports;
                return {
                    microLamports: microLamports
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($275f7bb2bb263073$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
            }
        }
    ]);
    return ComputeBudgetInstruction;
}();
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ var $275f7bb2bb263073$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $i4x6j.struct([
            $i4x6j.u8("instruction"),
            $i4x6j.u32("units"),
            $i4x6j.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $i4x6j.struct([
            $i4x6j.u8("instruction"),
            $i4x6j.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $i4x6j.struct([
            $i4x6j.u8("instruction"),
            $i4x6j.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $i4x6j.struct([
            $i4x6j.u8("instruction"),
            $275f7bb2bb263073$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ var $275f7bb2bb263073$export$11585db5942bcdb7 = /*#__PURE__*/ function() {
    "use strict";
    function ComputeBudgetProgram() {
        (0, $7dKN1._)(this, ComputeBudgetProgram);
    }
    (0, $eW5pA._)(ComputeBudgetProgram, null, [
        {
            key: "requestUnits",
            value: /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ function requestUnits(params) {
                var _$type = $275f7bb2bb263073$export$b7c79c50764da3d6.RequestUnits;
                var data = $275f7bb2bb263073$var$encodeData(_$type, params);
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "requestHeapFrame",
            value: function requestHeapFrame(params) {
                var _$type = $275f7bb2bb263073$export$b7c79c50764da3d6.RequestHeapFrame;
                var data = $275f7bb2bb263073$var$encodeData(_$type, params);
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "setComputeUnitLimit",
            value: function setComputeUnitLimit(params) {
                var _$type = $275f7bb2bb263073$export$b7c79c50764da3d6.SetComputeUnitLimit;
                var data = $275f7bb2bb263073$var$encodeData(_$type, params);
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "setComputeUnitPrice",
            value: function setComputeUnitPrice(params) {
                var _$type = $275f7bb2bb263073$export$b7c79c50764da3d6.SetComputeUnitPrice;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    microLamports: BigInt(params.microLamports)
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return ComputeBudgetProgram;
}();
$275f7bb2bb263073$export$11585db5942bcdb7.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
var $275f7bb2bb263073$var$PRIVATE_KEY_BYTES$1 = 64;
var $275f7bb2bb263073$var$PUBLIC_KEY_BYTES$1 = 32;
var $275f7bb2bb263073$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ var $275f7bb2bb263073$var$ED25519_INSTRUCTION_LAYOUT = $i4x6j.struct([
    $i4x6j.u8("numSignatures"),
    $i4x6j.u8("padding"),
    $i4x6j.u16("signatureOffset"),
    $i4x6j.u16("signatureInstructionIndex"),
    $i4x6j.u16("publicKeyOffset"),
    $i4x6j.u16("publicKeyInstructionIndex"),
    $i4x6j.u16("messageDataOffset"),
    $i4x6j.u16("messageDataSize"),
    $i4x6j.u16("messageInstructionIndex")
]);
var $275f7bb2bb263073$export$e5087aea02631e = /*#__PURE__*/ function() {
    "use strict";
    function Ed25519Program() {
        (0, $7dKN1._)(this, Ed25519Program);
    }
    (0, $eW5pA._)(Ed25519Program, null, [
        {
            key: "createInstructionWithPublicKey",
            value: /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ function createInstructionWithPublicKey(params) {
                var publicKey = params.publicKey, message = params.message, signature = params.signature, instructionIndex = params.instructionIndex;
                $275f7bb2bb263073$var$assert(publicKey.length === $275f7bb2bb263073$var$PUBLIC_KEY_BYTES$1, "Public Key must be ".concat($275f7bb2bb263073$var$PUBLIC_KEY_BYTES$1, " bytes but received ").concat(publicKey.length, " bytes"));
                $275f7bb2bb263073$var$assert(signature.length === $275f7bb2bb263073$var$SIGNATURE_BYTES, "Signature must be ".concat($275f7bb2bb263073$var$SIGNATURE_BYTES, " bytes but received ").concat(signature.length, " bytes"));
                var publicKeyOffset = $275f7bb2bb263073$var$ED25519_INSTRUCTION_LAYOUT.span;
                var signatureOffset = publicKeyOffset + publicKey.length;
                var messageDataOffset = signatureOffset + signature.length;
                var numSignatures = 1;
                var instructionData = (0, $ilnag.Buffer).alloc(messageDataOffset + message.length);
                var index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
                 : instructionIndex;
                $275f7bb2bb263073$var$ED25519_INSTRUCTION_LAYOUT.encode({
                    numSignatures: numSignatures,
                    padding: 0,
                    signatureOffset: signatureOffset,
                    signatureInstructionIndex: index,
                    publicKeyOffset: publicKeyOffset,
                    publicKeyInstructionIndex: index,
                    messageDataOffset: messageDataOffset,
                    messageDataSize: message.length,
                    messageInstructionIndex: index
                }, instructionData);
                instructionData.fill(publicKey, publicKeyOffset);
                instructionData.fill(signature, signatureOffset);
                instructionData.fill(message, messageDataOffset);
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: Ed25519Program.programId,
                    data: instructionData
                });
            }
        },
        {
            key: "createInstructionWithPrivateKey",
            value: /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ function createInstructionWithPrivateKey(params) {
                var privateKey = params.privateKey, message = params.message, instructionIndex = params.instructionIndex;
                $275f7bb2bb263073$var$assert(privateKey.length === $275f7bb2bb263073$var$PRIVATE_KEY_BYTES$1, "Private key must be ".concat($275f7bb2bb263073$var$PRIVATE_KEY_BYTES$1, " bytes but received ").concat(privateKey.length, " bytes"));
                try {
                    var keypair = $275f7bb2bb263073$export$c53bca448cf33676.fromSecretKey(privateKey);
                    var publicKey = keypair.publicKey.toBytes();
                    var signature = $275f7bb2bb263073$var$sign(message, keypair.secretKey);
                    return this.createInstructionWithPublicKey({
                        publicKey: publicKey,
                        message: message,
                        signature: signature,
                        instructionIndex: instructionIndex
                    });
                } catch (error) {
                    throw new Error("Error creating instruction; ".concat(error));
                }
            }
        }
    ]);
    return Ed25519Program;
}();
$275f7bb2bb263073$export$e5087aea02631e.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
var $275f7bb2bb263073$var$ecdsaSign = function(msgHash, privKey) {
    var signature = (0, $a492fc3495682ad4$exports.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $a492fc3495682ad4$exports.secp256k1).utils.isValidPrivateKey;
var $275f7bb2bb263073$var$publicKeyCreate = (0, $a492fc3495682ad4$exports.secp256k1).getPublicKey;
var $275f7bb2bb263073$var$PRIVATE_KEY_BYTES = 32;
var $275f7bb2bb263073$var$ETHEREUM_ADDRESS_BYTES = 20;
var $275f7bb2bb263073$var$PUBLIC_KEY_BYTES = 64;
var $275f7bb2bb263073$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ var $275f7bb2bb263073$var$SECP256K1_INSTRUCTION_LAYOUT = $i4x6j.struct([
    $i4x6j.u8("numSignatures"),
    $i4x6j.u16("signatureOffset"),
    $i4x6j.u8("signatureInstructionIndex"),
    $i4x6j.u16("ethAddressOffset"),
    $i4x6j.u8("ethAddressInstructionIndex"),
    $i4x6j.u16("messageDataOffset"),
    $i4x6j.u16("messageDataSize"),
    $i4x6j.u8("messageInstructionIndex"),
    $i4x6j.blob(20, "ethAddress"),
    $i4x6j.blob(64, "signature"),
    $i4x6j.u8("recoveryId")
]);
var $275f7bb2bb263073$export$d85dd4c1161d13c9 = /*#__PURE__*/ function() {
    "use strict";
    function Secp256k1Program() {
        (0, $7dKN1._)(this, Secp256k1Program);
    }
    (0, $eW5pA._)(Secp256k1Program, null, [
        {
            key: "publicKeyToEthAddress",
            value: /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ function publicKeyToEthAddress(publicKey) {
                $275f7bb2bb263073$var$assert(publicKey.length === $275f7bb2bb263073$var$PUBLIC_KEY_BYTES, "Public key must be ".concat($275f7bb2bb263073$var$PUBLIC_KEY_BYTES, " bytes but received ").concat(publicKey.length, " bytes"));
                try {
                    return (0, $ilnag.Buffer).from((0, $7db8000d9da7abf9$exports.keccak_256)($275f7bb2bb263073$var$toBuffer(publicKey))).slice(-$275f7bb2bb263073$var$ETHEREUM_ADDRESS_BYTES);
                } catch (error) {
                    throw new Error("Error constructing Ethereum address: ".concat(error));
                }
            }
        },
        {
            key: "createInstructionWithPublicKey",
            value: /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ function createInstructionWithPublicKey(params) {
                var publicKey = params.publicKey, message = params.message, signature = params.signature, recoveryId = params.recoveryId, instructionIndex = params.instructionIndex;
                return Secp256k1Program.createInstructionWithEthAddress({
                    ethAddress: Secp256k1Program.publicKeyToEthAddress(publicKey),
                    message: message,
                    signature: signature,
                    recoveryId: recoveryId,
                    instructionIndex: instructionIndex
                });
            }
        },
        {
            key: "createInstructionWithEthAddress",
            value: /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ function createInstructionWithEthAddress(params) {
                var rawAddress = params.ethAddress, message = params.message, signature = params.signature, recoveryId = params.recoveryId, _params_instructionIndex = params.instructionIndex, instructionIndex = _params_instructionIndex === void 0 ? 0 : _params_instructionIndex;
                var ethAddress;
                if (typeof rawAddress === "string") {
                    if (rawAddress.startsWith("0x")) ethAddress = (0, $ilnag.Buffer).from(rawAddress.substr(2), "hex");
                    else ethAddress = (0, $ilnag.Buffer).from(rawAddress, "hex");
                } else ethAddress = rawAddress;
                $275f7bb2bb263073$var$assert(ethAddress.length === $275f7bb2bb263073$var$ETHEREUM_ADDRESS_BYTES, "Address must be ".concat($275f7bb2bb263073$var$ETHEREUM_ADDRESS_BYTES, " bytes but received ").concat(ethAddress.length, " bytes"));
                var dataStart = 1 + $275f7bb2bb263073$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
                var ethAddressOffset = dataStart;
                var signatureOffset = dataStart + ethAddress.length;
                var messageDataOffset = signatureOffset + signature.length + 1;
                var numSignatures = 1;
                var instructionData = (0, $ilnag.Buffer).alloc($275f7bb2bb263073$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
                $275f7bb2bb263073$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
                    numSignatures: numSignatures,
                    signatureOffset: signatureOffset,
                    signatureInstructionIndex: instructionIndex,
                    ethAddressOffset: ethAddressOffset,
                    ethAddressInstructionIndex: instructionIndex,
                    messageDataOffset: messageDataOffset,
                    messageDataSize: message.length,
                    messageInstructionIndex: instructionIndex,
                    signature: $275f7bb2bb263073$var$toBuffer(signature),
                    ethAddress: $275f7bb2bb263073$var$toBuffer(ethAddress),
                    recoveryId: recoveryId
                }, instructionData);
                instructionData.fill($275f7bb2bb263073$var$toBuffer(message), $275f7bb2bb263073$var$SECP256K1_INSTRUCTION_LAYOUT.span);
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: Secp256k1Program.programId,
                    data: instructionData
                });
            }
        },
        {
            key: "createInstructionWithPrivateKey",
            value: /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ function createInstructionWithPrivateKey(params) {
                var pkey = params.privateKey, message = params.message, instructionIndex = params.instructionIndex;
                $275f7bb2bb263073$var$assert(pkey.length === $275f7bb2bb263073$var$PRIVATE_KEY_BYTES, "Private key must be ".concat($275f7bb2bb263073$var$PRIVATE_KEY_BYTES, " bytes but received ").concat(pkey.length, " bytes"));
                try {
                    var privateKey = $275f7bb2bb263073$var$toBuffer(pkey);
                    var publicKey = $275f7bb2bb263073$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
                    var messageHash = (0, $ilnag.Buffer).from((0, $7db8000d9da7abf9$exports.keccak_256)($275f7bb2bb263073$var$toBuffer(message)));
                    var _ecdsaSign = (0, $5OlIx._)($275f7bb2bb263073$var$ecdsaSign(messageHash, privateKey), 2), signature = _ecdsaSign[0], recoveryId = _ecdsaSign[1];
                    return this.createInstructionWithPublicKey({
                        publicKey: publicKey,
                        message: message,
                        signature: signature,
                        recoveryId: recoveryId,
                        instructionIndex: instructionIndex
                    });
                } catch (error) {
                    throw new Error("Error creating instruction; ".concat(error));
                }
            }
        }
    ]);
    return Secp256k1Program;
}();
$275f7bb2bb263073$export$d85dd4c1161d13c9.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $275f7bb2bb263073$var$_Lockup;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ var $275f7bb2bb263073$export$18aac71979bdd08f = new $275f7bb2bb263073$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ var $275f7bb2bb263073$export$9ac74ae66932a145 = function Authorized(staker, withdrawer) {
    "use strict";
    (0, $7dKN1._)(this, Authorized);
    /** stake authority */ this.staker = void 0;
    /** withdraw authority */ this.withdrawer = void 0;
    this.staker = staker;
    this.withdrawer = withdrawer;
};
/**
 * Stake account lockup info
 */ var $275f7bb2bb263073$export$e7f3941ade35598c = function Lockup(unixTimestamp, epoch, custodian) {
    "use strict";
    (0, $7dKN1._)(this, Lockup);
    /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
    /** Epoch of lockup expiration */ this.epoch = void 0;
    /** Lockup custodian authority */ this.custodian = void 0;
    this.unixTimestamp = unixTimestamp;
    this.epoch = epoch;
    this.custodian = custodian;
};
$275f7bb2bb263073$var$_Lockup = $275f7bb2bb263073$export$e7f3941ade35598c;
$275f7bb2bb263073$export$e7f3941ade35598c.default = new $275f7bb2bb263073$var$_Lockup(0, 0, $275f7bb2bb263073$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ var $275f7bb2bb263073$export$aded313c3a4800f9 = /*#__PURE__*/ function() {
    "use strict";
    function StakeInstruction() {
        (0, $7dKN1._)(this, StakeInstruction);
    }
    (0, $eW5pA._)(StakeInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a stake instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $i4x6j.u32("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($275f7bb2bb263073$export$c89793bd2bba8b2e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a StakeInstruction");
                return _$type;
            }
        },
        {
            key: "decodeInitialize",
            value: /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ function decodeInitialize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Initialize, instruction.data), authorized = _decodeData$1.authorized, lockup = _decodeData$1.lockup;
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorized: new $275f7bb2bb263073$export$9ac74ae66932a145(new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorized.staker), new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorized.withdrawer)),
                    lockup: new $275f7bb2bb263073$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $275f7bb2bb263073$export$ca8b6604d6ce14de(lockup.custodian))
                };
            }
        },
        {
            key: "decodeDelegate",
            value: /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ function decodeDelegate(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 6);
                $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Delegate, instruction.data);
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    votePubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[5].pubkey
                };
            }
        },
        {
            key: "decodeAuthorize",
            value: /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ function decodeAuthorize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Authorize, instruction.data), newAuthorized = _decodeData$1.newAuthorized, stakeAuthorizationType = _decodeData$1.stakeAuthorizationType;
                var o = {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey,
                    newAuthorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(newAuthorized),
                    stakeAuthorizationType: {
                        index: stakeAuthorizationType
                    }
                };
                if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
                return o;
            }
        },
        {
            key: "decodeAuthorizeWithSeed",
            value: /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ function decodeAuthorizeWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data), newAuthorized = _decodeData$1.newAuthorized, stakeAuthorizationType = _decodeData$1.stakeAuthorizationType, authoritySeed = _decodeData$1.authoritySeed, authorityOwner = _decodeData$1.authorityOwner;
                var o = {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorityBase: instruction.keys[1].pubkey,
                    authoritySeed: authoritySeed,
                    authorityOwner: new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorityOwner),
                    newAuthorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(newAuthorized),
                    stakeAuthorizationType: {
                        index: stakeAuthorizationType
                    }
                };
                if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
                return o;
            }
        },
        {
            key: "decodeSplit",
            value: /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ function decodeSplit(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var lamports = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Split, instruction.data).lamports;
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    splitStakePubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey,
                    lamports: lamports
                };
            }
        },
        {
            key: "decodeMerge",
            value: /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ function decodeMerge(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Merge, instruction.data);
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    sourceStakePubKey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[4].pubkey
                };
            }
        },
        {
            key: "decodeWithdraw",
            value: /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ function decodeWithdraw(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 5);
                var lamports = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Withdraw, instruction.data).lamports;
                var o = {
                    stakePubkey: instruction.keys[0].pubkey,
                    toPubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[4].pubkey,
                    lamports: lamports
                };
                if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
                return o;
            }
        },
        {
            key: "decodeDeactivate",
            value: /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ function decodeDeactivate(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$export$c89793bd2bba8b2e.Deactivate, instruction.data);
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($275f7bb2bb263073$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
            }
        },
        {
            key: "checkKeyLength",
            value: /**
   * @internal
   */ function checkKeyLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return StakeInstruction;
}();
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ var $275f7bb2bb263073$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$authorized(),
            $275f7bb2bb263073$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("newAuthorized"),
            $i4x6j.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $i4x6j.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $i4x6j.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("newAuthorized"),
            $i4x6j.u32("stakeAuthorizationType"),
            $275f7bb2bb263073$var$rustString("authoritySeed"),
            $275f7bb2bb263073$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ var $275f7bb2bb263073$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ var $275f7bb2bb263073$export$df86f933e9f8fb15 = /*#__PURE__*/ function() {
    "use strict";
    function StakeProgram() {
        (0, $7dKN1._)(this, StakeProgram);
    }
    (0, $eW5pA._)(StakeProgram, null, [
        {
            key: "initialize",
            value: /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ function initialize(params) {
                var stakePubkey = params.stakePubkey, authorized = params.authorized, maybeLockup = params.lockup;
                var lockup = maybeLockup || $275f7bb2bb263073$export$e7f3941ade35598c.default;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Initialize;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    authorized: {
                        staker: $275f7bb2bb263073$var$toBuffer(authorized.staker.toBuffer()),
                        withdrawer: $275f7bb2bb263073$var$toBuffer(authorized.withdrawer.toBuffer())
                    },
                    lockup: {
                        unixTimestamp: lockup.unixTimestamp,
                        epoch: lockup.epoch,
                        custodian: $275f7bb2bb263073$var$toBuffer(lockup.custodian.toBuffer())
                    }
                });
                var instructionData = {
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "createAccountWithSeed",
            value: /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ function createAccountWithSeed(params) {
                var transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                transaction.add($275f7bb2bb263073$export$d8c4e17726848113.createAccountWithSeed({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.stakePubkey,
                    basePubkey: params.basePubkey,
                    seed: params.seed,
                    lamports: params.lamports,
                    space: this.space,
                    programId: this.programId
                }));
                var stakePubkey = params.stakePubkey, authorized = params.authorized, lockup = params.lockup;
                return transaction.add(this.initialize({
                    stakePubkey: stakePubkey,
                    authorized: authorized,
                    lockup: lockup
                }));
            }
        },
        {
            key: "createAccount",
            value: /**
   * Generate a Transaction that creates a new Stake account
   */ function createAccount(params) {
                var transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                transaction.add($275f7bb2bb263073$export$d8c4e17726848113.createAccount({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.stakePubkey,
                    lamports: params.lamports,
                    space: this.space,
                    programId: this.programId
                }));
                var stakePubkey = params.stakePubkey, authorized = params.authorized, lockup = params.lockup;
                return transaction.add(this.initialize({
                    stakePubkey: stakePubkey,
                    authorized: authorized,
                    lockup: lockup
                }));
            }
        },
        {
            key: "delegate",
            value: /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ function delegate(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, votePubkey = params.votePubkey;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Delegate;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: votePubkey,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$ca994171317280ea,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$18aac71979bdd08f,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "authorize",
            value: /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ function authorize(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, newAuthorizedPubkey = params.newAuthorizedPubkey, stakeAuthorizationType = params.stakeAuthorizationType, custodianPubkey = params.custodianPubkey;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Authorize;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    newAuthorized: $275f7bb2bb263073$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                    stakeAuthorizationType: stakeAuthorizationType.index
                });
                var keys = [
                    {
                        pubkey: stakePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: authorizedPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                if (custodianPubkey) keys.push({
                    pubkey: custodianPubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "authorizeWithSeed",
            value: /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ function authorizeWithSeed(params) {
                var stakePubkey = params.stakePubkey, authorityBase = params.authorityBase, authoritySeed = params.authoritySeed, authorityOwner = params.authorityOwner, newAuthorizedPubkey = params.newAuthorizedPubkey, stakeAuthorizationType = params.stakeAuthorizationType, custodianPubkey = params.custodianPubkey;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.AuthorizeWithSeed;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    newAuthorized: $275f7bb2bb263073$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                    stakeAuthorizationType: stakeAuthorizationType.index,
                    authoritySeed: authoritySeed,
                    authorityOwner: $275f7bb2bb263073$var$toBuffer(authorityOwner.toBuffer())
                });
                var keys = [
                    {
                        pubkey: stakePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: authorityBase,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    }
                ];
                if (custodianPubkey) keys.push({
                    pubkey: custodianPubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "splitInstruction",
            value: /**
   * @internal
   */ function splitInstruction(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, splitStakePubkey = params.splitStakePubkey, lamports = params.lamports;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Split;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    lamports: lamports
                });
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: splitStakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "split",
            value: /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ function split(params, // Compute the cost of allocating the new stake account in lamports
            rentExemptReserve) {
                var transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                transaction.add($275f7bb2bb263073$export$d8c4e17726848113.createAccount({
                    fromPubkey: params.authorizedPubkey,
                    newAccountPubkey: params.splitStakePubkey,
                    lamports: rentExemptReserve,
                    space: this.space,
                    programId: this.programId
                }));
                return transaction.add(this.splitInstruction(params));
            }
        },
        {
            key: "splitWithSeed",
            value: /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ function splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
            rentExemptReserve) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, splitStakePubkey = params.splitStakePubkey, basePubkey = params.basePubkey, seed = params.seed, lamports = params.lamports;
                var transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                transaction.add($275f7bb2bb263073$export$d8c4e17726848113.allocate({
                    accountPubkey: splitStakePubkey,
                    basePubkey: basePubkey,
                    seed: seed,
                    space: this.space,
                    programId: this.programId
                }));
                if (rentExemptReserve && rentExemptReserve > 0) transaction.add($275f7bb2bb263073$export$d8c4e17726848113.transfer({
                    fromPubkey: params.authorizedPubkey,
                    toPubkey: splitStakePubkey,
                    lamports: rentExemptReserve
                }));
                return transaction.add(this.splitInstruction({
                    stakePubkey: stakePubkey,
                    authorizedPubkey: authorizedPubkey,
                    splitStakePubkey: splitStakePubkey,
                    lamports: lamports
                }));
            }
        },
        {
            key: "merge",
            value: /**
   * Generate a Transaction that merges Stake accounts.
   */ function merge(params) {
                var stakePubkey = params.stakePubkey, sourceStakePubKey = params.sourceStakePubKey, authorizedPubkey = params.authorizedPubkey;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Merge;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: sourceStakePubKey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$ca994171317280ea,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "withdraw",
            value: /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ function withdraw(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, toPubkey = params.toPubkey, lamports = params.lamports, custodianPubkey = params.custodianPubkey;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Withdraw;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    lamports: lamports
                });
                var keys = [
                    {
                        pubkey: stakePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: toPubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$ca994171317280ea,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: authorizedPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                if (custodianPubkey) keys.push({
                    pubkey: custodianPubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "deactivate",
            value: /**
   * Generate a Transaction that deactivates Stake tokens.
   */ function deactivate(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey;
                var _$type = $275f7bb2bb263073$export$c89793bd2bba8b2e.Deactivate;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return StakeProgram;
}();
$275f7bb2bb263073$export$df86f933e9f8fb15.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $275f7bb2bb263073$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ var $275f7bb2bb263073$export$3f9d1b16ff840d7 = function VoteInit(nodePubkey, authorizedVoter, authorizedWithdrawer, commission) {
    "use strict";
    (0, $7dKN1._)(this, VoteInit);
    this.nodePubkey = void 0;
    this.authorizedVoter = void 0;
    this.authorizedWithdrawer = void 0;
    this.commission = void 0;
    this.nodePubkey = nodePubkey;
    this.authorizedVoter = authorizedVoter;
    this.authorizedWithdrawer = authorizedWithdrawer;
    this.commission = commission;
};
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ var $275f7bb2bb263073$export$af8300401fc56047 = /*#__PURE__*/ function() {
    "use strict";
    function VoteInstruction() {
        (0, $7dKN1._)(this, VoteInstruction);
    }
    (0, $eW5pA._)(VoteInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a vote instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $i4x6j.u32("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a VoteInstruction");
                return _$type;
            }
        },
        {
            key: "decodeInitializeAccount",
            value: /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ function decodeInitializeAccount(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 4);
                var voteInit = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data).voteInit;
                return {
                    votePubkey: instruction.keys[0].pubkey,
                    nodePubkey: instruction.keys[3].pubkey,
                    voteInit: new $275f7bb2bb263073$export$3f9d1b16ff840d7(new $275f7bb2bb263073$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $275f7bb2bb263073$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $275f7bb2bb263073$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
                };
            }
        },
        {
            key: "decodeAuthorize",
            value: /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ function decodeAuthorize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data), newAuthorized = _decodeData$1.newAuthorized, voteAuthorizationType = _decodeData$1.voteAuthorizationType;
                return {
                    votePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey,
                    newAuthorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(newAuthorized),
                    voteAuthorizationType: {
                        index: voteAuthorizationType
                    }
                };
            }
        },
        {
            key: "decodeAuthorizeWithSeed",
            value: /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ function decodeAuthorizeWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data), _decodeData$1_voteAuthorizeWithSeedArgs = _decodeData$1.voteAuthorizeWithSeedArgs, currentAuthorityDerivedKeyOwnerPubkey = _decodeData$1_voteAuthorizeWithSeedArgs.currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed = _decodeData$1_voteAuthorizeWithSeedArgs.currentAuthorityDerivedKeySeed, newAuthorized = _decodeData$1_voteAuthorizeWithSeedArgs.newAuthorized, voteAuthorizationType = _decodeData$1_voteAuthorizeWithSeedArgs.voteAuthorizationType;
                return {
                    currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
                    currentAuthorityDerivedKeyOwnerPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
                    currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                    newAuthorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(newAuthorized),
                    voteAuthorizationType: {
                        index: voteAuthorizationType
                    },
                    votePubkey: instruction.keys[0].pubkey
                };
            }
        },
        {
            key: "decodeWithdraw",
            value: /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ function decodeWithdraw(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var lamports = $275f7bb2bb263073$var$decodeData$1($275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data).lamports;
                return {
                    votePubkey: instruction.keys[0].pubkey,
                    authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
                    lamports: lamports,
                    toPubkey: instruction.keys[1].pubkey
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($275f7bb2bb263073$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
            }
        },
        {
            key: "checkKeyLength",
            value: /**
   * @internal
   */ function checkKeyLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return VoteInstruction;
}();
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ var $275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$publicKey("newAuthorized"),
            $i4x6j.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $i4x6j.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $i4x6j.struct([
            $i4x6j.u32("instruction"),
            $275f7bb2bb263073$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ var $275f7bb2bb263073$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ var $275f7bb2bb263073$export$83db2bc702bee1eb = /*#__PURE__*/ function() {
    "use strict";
    function VoteProgram() {
        (0, $7dKN1._)(this, VoteProgram);
    }
    (0, $eW5pA._)(VoteProgram, null, [
        {
            key: "initializeAccount",
            value: /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ function initializeAccount(params) {
                var votePubkey = params.votePubkey, nodePubkey = params.nodePubkey, voteInit = params.voteInit;
                var _$type = $275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    voteInit: {
                        nodePubkey: $275f7bb2bb263073$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                        authorizedVoter: $275f7bb2bb263073$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                        authorizedWithdrawer: $275f7bb2bb263073$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                        commission: voteInit.commission
                    }
                });
                var instructionData = {
                    keys: [
                        {
                            pubkey: votePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: nodePubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $275f7bb2bb263073$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "createAccount",
            value: /**
   * Generate a transaction that creates a new Vote account.
   */ function createAccount(params) {
                var transaction = new $275f7bb2bb263073$export$febc5573c75cefb0();
                transaction.add($275f7bb2bb263073$export$d8c4e17726848113.createAccount({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.votePubkey,
                    lamports: params.lamports,
                    space: this.space,
                    programId: this.programId
                }));
                return transaction.add(this.initializeAccount({
                    votePubkey: params.votePubkey,
                    nodePubkey: params.voteInit.nodePubkey,
                    voteInit: params.voteInit
                }));
            }
        },
        {
            key: "authorize",
            value: /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ function authorize(params) {
                var votePubkey = params.votePubkey, authorizedPubkey = params.authorizedPubkey, newAuthorizedPubkey = params.newAuthorizedPubkey, voteAuthorizationType = params.voteAuthorizationType;
                var _$type = $275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    newAuthorized: $275f7bb2bb263073$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                    voteAuthorizationType: voteAuthorizationType.index
                });
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: authorizedPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "authorizeWithSeed",
            value: /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ function authorizeWithSeed(params) {
                var currentAuthorityDerivedKeyBasePubkey = params.currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey = params.currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed = params.currentAuthorityDerivedKeySeed, newAuthorizedPubkey = params.newAuthorizedPubkey, voteAuthorizationType = params.voteAuthorizationType, votePubkey = params.votePubkey;
                var _$type = $275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    voteAuthorizeWithSeedArgs: {
                        currentAuthorityDerivedKeyOwnerPubkey: $275f7bb2bb263073$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                        currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                        newAuthorized: $275f7bb2bb263073$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                        voteAuthorizationType: voteAuthorizationType.index
                    }
                });
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $275f7bb2bb263073$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: currentAuthorityDerivedKeyBasePubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "withdraw",
            value: /**
   * Generate a transaction to withdraw from a Vote account.
   */ function withdraw(params) {
                var votePubkey = params.votePubkey, authorizedWithdrawerPubkey = params.authorizedWithdrawerPubkey, lamports = params.lamports, toPubkey = params.toPubkey;
                var _$type = $275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
                var data = $275f7bb2bb263073$var$encodeData(_$type, {
                    lamports: lamports
                });
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: toPubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: authorizedWithdrawerPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "safeWithdraw",
            value: /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ function safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
                if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
                return VoteProgram.withdraw(params);
            }
        },
        {
            key: "updateValidatorIdentity",
            value: /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ function updateValidatorIdentity(params) {
                var votePubkey = params.votePubkey, authorizedWithdrawerPubkey = params.authorizedWithdrawerPubkey, nodePubkey = params.nodePubkey;
                var _$type = $275f7bb2bb263073$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
                var data = $275f7bb2bb263073$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: nodePubkey,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: authorizedWithdrawerPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $275f7bb2bb263073$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return VoteProgram;
}();
$275f7bb2bb263073$export$83db2bc702bee1eb.programId = new $275f7bb2bb263073$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $275f7bb2bb263073$export$83db2bc702bee1eb.space = 3762;
var $275f7bb2bb263073$export$afdb09d3afdde87c = new $275f7bb2bb263073$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ var $275f7bb2bb263073$var$InfoString = (0, $91bj2.type)({
    name: (0, $91bj2.string)(),
    website: (0, $91bj2.optional)((0, $91bj2.string)()),
    details: (0, $91bj2.optional)((0, $91bj2.string)()),
    iconUrl: (0, $91bj2.optional)((0, $91bj2.string)()),
    keybaseUsername: (0, $91bj2.optional)((0, $91bj2.string)())
});
/**
 * ValidatorInfo class
 */ var $275f7bb2bb263073$export$152d279cf067309b = /*#__PURE__*/ function() {
    "use strict";
    function ValidatorInfo(key, info) {
        (0, $7dKN1._)(this, ValidatorInfo);
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    (0, $eW5pA._)(ValidatorInfo, null, [
        {
            key: "fromConfigData",
            value: /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ function fromConfigData(buffer) {
                var byteArray = (0, $gF0bR._)(buffer);
                var configKeyCount = $275f7bb2bb263073$var$decodeLength(byteArray);
                if (configKeyCount !== 2) return null;
                var configKeys = [];
                for(var i = 0; i < 2; i++){
                    var publicKey = new $275f7bb2bb263073$export$ca8b6604d6ce14de($275f7bb2bb263073$var$guardedSplice(byteArray, 0, $275f7bb2bb263073$export$84fc0a248cc54343));
                    var isSigner = $275f7bb2bb263073$var$guardedShift(byteArray) === 1;
                    configKeys.push({
                        publicKey: publicKey,
                        isSigner: isSigner
                    });
                }
                if (configKeys[0].publicKey.equals($275f7bb2bb263073$export$afdb09d3afdde87c)) {
                    if (configKeys[1].isSigner) {
                        var rawInfo = $275f7bb2bb263073$var$rustString().decode((0, $ilnag.Buffer).from(byteArray));
                        var info = JSON.parse(rawInfo);
                        (0, $91bj2.assert)(info, $275f7bb2bb263073$var$InfoString);
                        return new ValidatorInfo(configKeys[1].publicKey, info);
                    }
                }
                return null;
            }
        }
    ]);
    return ValidatorInfo;
}();
var $275f7bb2bb263073$export$90bca02a3aea0768 = new $275f7bb2bb263073$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ var $275f7bb2bb263073$var$VoteAccountLayout = $i4x6j.struct([
    $275f7bb2bb263073$var$publicKey("nodePubkey"),
    $275f7bb2bb263073$var$publicKey("authorizedWithdrawer"),
    $i4x6j.u8("commission"),
    $i4x6j.nu64(),
    // votes.length
    $i4x6j.seq($i4x6j.struct([
        $i4x6j.nu64("slot"),
        $i4x6j.u32("confirmationCount")
    ]), $i4x6j.offset($i4x6j.u32(), -8), "votes"),
    $i4x6j.u8("rootSlotValid"),
    $i4x6j.nu64("rootSlot"),
    $i4x6j.nu64(),
    // authorizedVoters.length
    $i4x6j.seq($i4x6j.struct([
        $i4x6j.nu64("epoch"),
        $275f7bb2bb263073$var$publicKey("authorizedVoter")
    ]), $i4x6j.offset($i4x6j.u32(), -8), "authorizedVoters"),
    $i4x6j.struct([
        $i4x6j.seq($i4x6j.struct([
            $275f7bb2bb263073$var$publicKey("authorizedPubkey"),
            $i4x6j.nu64("epochOfLastAuthorizedSwitch"),
            $i4x6j.nu64("targetEpoch")
        ]), 32, "buf"),
        $i4x6j.nu64("idx"),
        $i4x6j.u8("isEmpty")
    ], "priorVoters"),
    $i4x6j.nu64(),
    // epochCredits.length
    $i4x6j.seq($i4x6j.struct([
        $i4x6j.nu64("epoch"),
        $i4x6j.nu64("credits"),
        $i4x6j.nu64("prevCredits")
    ]), $i4x6j.offset($i4x6j.u32(), -8), "epochCredits"),
    $i4x6j.struct([
        $i4x6j.nu64("slot"),
        $i4x6j.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ var $275f7bb2bb263073$export$89ef186f708d638b = /*#__PURE__*/ function() {
    "use strict";
    function VoteAccount(args) {
        (0, $7dKN1._)(this, VoteAccount);
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    (0, $eW5pA._)(VoteAccount, null, [
        {
            key: "fromAccountData",
            value: /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ function fromAccountData(buffer) {
                var versionOffset = 4;
                var va = $275f7bb2bb263073$var$VoteAccountLayout.decode($275f7bb2bb263073$var$toBuffer(buffer), versionOffset);
                var rootSlot = va.rootSlot;
                if (!va.rootSlotValid) rootSlot = null;
                return new VoteAccount({
                    nodePubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(va.nodePubkey),
                    authorizedWithdrawer: new $275f7bb2bb263073$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
                    commission: va.commission,
                    votes: va.votes,
                    rootSlot: rootSlot,
                    authorizedVoters: va.authorizedVoters.map($275f7bb2bb263073$var$parseAuthorizedVoter),
                    priorVoters: $275f7bb2bb263073$var$getPriorVoters(va.priorVoters),
                    epochCredits: va.epochCredits,
                    lastTimestamp: va.lastTimestamp
                });
            }
        }
    ]);
    return VoteAccount;
}();
function $275f7bb2bb263073$var$parseAuthorizedVoter(param) {
    var authorizedVoter = param.authorizedVoter, epoch = param.epoch;
    return {
        epoch: epoch,
        authorizedVoter: new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $275f7bb2bb263073$var$parsePriorVoters(param) {
    var authorizedPubkey = param.authorizedPubkey, epochOfLastAuthorizedSwitch = param.epochOfLastAuthorizedSwitch, targetEpoch = param.targetEpoch;
    return {
        authorizedPubkey: new $275f7bb2bb263073$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $275f7bb2bb263073$var$getPriorVoters(param) {
    var buf = param.buf, idx = param.idx, isEmpty = param.isEmpty;
    if (isEmpty) return [];
    return (0, $gF0bR._)(buf.slice(idx + 1).map($275f7bb2bb263073$var$parsePriorVoters)).concat((0, $gF0bR._)(buf.slice(0, idx).map($275f7bb2bb263073$var$parsePriorVoters)));
}
var $275f7bb2bb263073$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $275f7bb2bb263073$export$11656287b4eb76ff(cluster, tls) {
    var key = tls === false ? "http" : "https";
    if (!cluster) return $275f7bb2bb263073$var$endpoint[key]["devnet"];
    var url = $275f7bb2bb263073$var$endpoint[key][cluster];
    if (!url) throw new Error("Unknown ".concat(key, " cluster: ").concat(cluster));
    return url;
}
function $275f7bb2bb263073$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    return $275f7bb2bb263073$var$_sendAndConfirmRawTransaction.apply(this, arguments);
}
function $275f7bb2bb263073$var$_sendAndConfirmRawTransaction() {
    $275f7bb2bb263073$var$_sendAndConfirmRawTransaction = /**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
    // eslint-disable-next-line no-redeclare
    (0, $6rBFC._)(function(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
        var confirmationStrategy, options, sendOptions, signature, commitment, confirmationPromise, status;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
                        confirmationStrategy = confirmationStrategyOrConfirmOptions;
                        options = maybeConfirmOptions;
                    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
                        confirmationStrategy = confirmationStrategyOrConfirmOptions;
                        options = maybeConfirmOptions;
                    } else options = confirmationStrategyOrConfirmOptions;
                    sendOptions = options && {
                        skipPreflight: options.skipPreflight,
                        preflightCommitment: options.preflightCommitment || options.commitment,
                        minContextSlot: options.minContextSlot
                    };
                    return [
                        4,
                        connection.sendRawTransaction(rawTransaction, sendOptions)
                    ];
                case 1:
                    signature = _state.sent();
                    commitment = options && options.commitment;
                    confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
                    return [
                        4,
                        confirmationPromise
                    ];
                case 2:
                    status = _state.sent().value;
                    if (status.err) {
                        if (signature != null) throw new $275f7bb2bb263073$export$121e803f723b3045({
                            action: (sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions.skipPreflight) ? "send" : "simulate",
                            signature: signature,
                            transactionMessage: "Status: (".concat(JSON.stringify(status), ")")
                        });
                        throw new Error("Raw transaction ".concat(signature, " failed (").concat(JSON.stringify(status), ")"));
                    }
                    return [
                        2,
                        signature
                    ];
            }
        });
    });
    return $275f7bb2bb263073$var$_sendAndConfirmRawTransaction.apply(this, arguments);
}
/**
 * There are 1-billion lamports in one SOL
 */ var $275f7bb2bb263073$export$5f6a2f2669741bbe = 1000000000;



var $7dKN1 = parcelRequire("7dKN1");

var $eW5pA = parcelRequire("eW5pA");

var $5OlIx = parcelRequire("5OlIx");

var $6qu4b = parcelRequire("6qu4b");

var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $7ZqEM = parcelRequire("7ZqEM");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ 
var $b9zO9 = parcelRequire("b9zO9");

var $7dKN1 = parcelRequire("7dKN1");

var $cgJ2Y = parcelRequire("cgJ2Y");

var $jShW9 = parcelRequire("jShW9");

var $hKD8n = parcelRequire("hKD8n");
var $b042d11338a966db$var$errorClasses = {};
var $b042d11338a966db$var$deserializers = {};
var $b042d11338a966db$export$ff6248acd0c27a3f = function(name, deserializer) {
    $b042d11338a966db$var$deserializers[name] = deserializer;
};
var $b042d11338a966db$export$94baff7bf5134824 = function(name) {
    var CustomErrorClass = /*#__PURE__*/ function(Error1) {
        "use strict";
        (0, $cgJ2Y._)(CustomErrorClass, Error1);
        var _super = (0, $hKD8n._)(CustomErrorClass);
        function CustomErrorClass(message, fields, options) {
            (0, $7dKN1._)(this, CustomErrorClass);
            var _this;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            _this = _super.call(this, message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf((0, $b9zO9._)(_this), CustomErrorClass.prototype);
            _this.name = name;
            if (fields) for(var k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            _this[k] = fields[k];
            if (options && $b042d11338a966db$var$isObject(options) && "cause" in options && !("cause" in (0, $b9zO9._)(_this))) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                var cause = options.cause;
                _this.cause = cause;
                if ("stack" in cause) _this.stack = _this.stack + "\nCAUSE: " + cause.stack;
            }
            return _this;
        }
        return CustomErrorClass;
    }((0, $jShW9._)(Error));
    $b042d11338a966db$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $b042d11338a966db$var$isObject(value) {
    return typeof value === "object";
}
var $b042d11338a966db$export$64cddc1e268e9046 = function(object) {
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                var msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        var error;
        if (typeof object.name === "string") {
            var name = object.name;
            var des = $b042d11338a966db$var$deserializers[name];
            if (des) error = des(object);
            else {
                var constructor = name === "Error" ? Error : $b042d11338a966db$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $b042d11338a966db$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(var prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $b042d11338a966db$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
var $b042d11338a966db$export$46ff38bc6bdea8fb = function(value) {
    if (!value) return value;
    if (typeof value === "object") return $b042d11338a966db$var$destroyCircular(value, []);
    if (typeof value === "function") return "[Function: ".concat(value.name || "anonymous", "]");
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $b042d11338a966db$var$destroyCircular(from, seen) {
    var to = {};
    seen.push(from);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = from[key];
            if (typeof value === "function") continue;
            if (!value || typeof value !== "object") {
                to[key] = value;
                continue;
            }
            if (seen.indexOf(from[key]) === -1) {
                to[key] = $b042d11338a966db$var$destroyCircular(from[key], seen.slice(0));
                continue;
            }
            to[key] = "[Circular]";
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}


var $d0b59725680dc68c$export$d7dd32b41fc9c3a0 = (0, $b042d11338a966db$export$94baff7bf5134824)("AccountNameRequired");
var $d0b59725680dc68c$export$fb9db505804530ec = (0, $b042d11338a966db$export$94baff7bf5134824)("AccountNotSupported");
var $d0b59725680dc68c$export$75c97521b0dae2d6 = (0, $b042d11338a966db$export$94baff7bf5134824)("AccountAwaitingSendPendingOperations");
var $d0b59725680dc68c$export$c9d6bf2b06944665 = (0, $b042d11338a966db$export$94baff7bf5134824)("AmountRequired");
var $d0b59725680dc68c$export$2628fce2396c23c2 = (0, $b042d11338a966db$export$94baff7bf5134824)("BluetoothRequired");
var $d0b59725680dc68c$export$75f8b0767ef406f1 = (0, $b042d11338a966db$export$94baff7bf5134824)("BtcUnmatchedApp");
var $d0b59725680dc68c$export$f60aa84fd00bc3ee = (0, $b042d11338a966db$export$94baff7bf5134824)("CantOpenDevice");
var $d0b59725680dc68c$export$fc0260506e4022ab = (0, $b042d11338a966db$export$94baff7bf5134824)("CashAddrNotSupported");
var $d0b59725680dc68c$export$1e9e90415b859c28 = (0, $b042d11338a966db$export$94baff7bf5134824)("ClaimRewardsFeesWarning");
var $d0b59725680dc68c$export$e0b1ec53ba36e221 = (0, $b042d11338a966db$export$94baff7bf5134824)("CurrencyNotSupported");
var $d0b59725680dc68c$export$fa9aacd48d3a45c2 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceAppVerifyNotSupported");
var $d0b59725680dc68c$export$f21ce806524ab8d4 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceGenuineSocketEarlyClose");
var $d0b59725680dc68c$export$9c30dc6872fcd74c = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceNotGenuine");
var $d0b59725680dc68c$export$1d5ae41b109edf1f = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceOnDashboardExpected");
var $d0b59725680dc68c$export$8eecf64ec9a8cfd7 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceOnDashboardUnexpected");
var $d0b59725680dc68c$export$a5e2071f1ac48fdd = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceInOSUExpected");
var $d0b59725680dc68c$export$3be6e7231165f4ac = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceHalted");
var $d0b59725680dc68c$export$fa7bfae6dce03474 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceNameInvalid");
var $d0b59725680dc68c$export$bcce4e5aded80ca0 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceSocketFail");
var $d0b59725680dc68c$export$944a0f9a7cc1e03a = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
var $d0b59725680dc68c$export$612d1f6d08d4cfb = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
var $d0b59725680dc68c$export$5f6bf7cdd5818529 = (0, $b042d11338a966db$export$94baff7bf5134824)("UnresponsiveDeviceError");
var $d0b59725680dc68c$export$1e42f3936938e063 = (0, $b042d11338a966db$export$94baff7bf5134824)("DisconnectedDevice");
var $d0b59725680dc68c$export$2a60f41a2ed2742 = (0, $b042d11338a966db$export$94baff7bf5134824)("DisconnectedDeviceDuringOperation");
var $d0b59725680dc68c$export$93e2040d8e24d646 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceExtractOnboardingStateError");
var $d0b59725680dc68c$export$e6aaf90bcb4b2013 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceOnboardingStatePollingError");
var $d0b59725680dc68c$export$cfbd0adf8f9fdaf9 = (0, $b042d11338a966db$export$94baff7bf5134824)("EnpointConfig");
var $d0b59725680dc68c$export$96d8d3c501f1625 = (0, $b042d11338a966db$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
var $d0b59725680dc68c$export$37b49553b7172cb1 = (0, $b042d11338a966db$export$94baff7bf5134824)("FeeEstimationFailed");
var $d0b59725680dc68c$export$d00fd6c398a70fd9 = (0, $b042d11338a966db$export$94baff7bf5134824)("FirmwareNotRecognized");
var $d0b59725680dc68c$export$3dc3bbf8c134219c = (0, $b042d11338a966db$export$94baff7bf5134824)("HardResetFail");
var $d0b59725680dc68c$export$5e8f7ae1054a2777 = (0, $b042d11338a966db$export$94baff7bf5134824)("InvalidXRPTag");
var $d0b59725680dc68c$export$953b602d2269ceba = (0, $b042d11338a966db$export$94baff7bf5134824)("InvalidAddress");
var $d0b59725680dc68c$export$61e75f453df94067 = (0, $b042d11338a966db$export$94baff7bf5134824)("InvalidNonce");
var $d0b59725680dc68c$export$bbdaf7c77a7508eb = (0, $b042d11338a966db$export$94baff7bf5134824)("InvalidAddressBecauseDestinationIsAlsoSource");
var $d0b59725680dc68c$export$882967e2980534f9 = (0, $b042d11338a966db$export$94baff7bf5134824)("LatestMCUInstalledError");
var $d0b59725680dc68c$export$59772a13ac97df0e = (0, $b042d11338a966db$export$94baff7bf5134824)("UnknownMCU");
var $d0b59725680dc68c$export$26bf4f7c63d50901 = (0, $b042d11338a966db$export$94baff7bf5134824)("LedgerAPIError");
var $d0b59725680dc68c$export$fdab6afd1b1820af = (0, $b042d11338a966db$export$94baff7bf5134824)("LedgerAPIErrorWithMessage");
var $d0b59725680dc68c$export$c2996b38942cf758 = (0, $b042d11338a966db$export$94baff7bf5134824)("LedgerAPINotAvailable");
var $d0b59725680dc68c$export$3d81abcc61613a27 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerAppAlreadyInstalled");
var $d0b59725680dc68c$export$87a9bff9fff141e2 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerAppRelyOnBTC");
var $d0b59725680dc68c$export$86581a722c4238c0 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerAppDepInstallRequired");
var $d0b59725680dc68c$export$267a8476044885dd = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerAppDepUninstallRequired");
var $d0b59725680dc68c$export$bb771ca417eca344 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerDeviceLocked");
var $d0b59725680dc68c$export$b634ce25e3ff5229 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerFirmwareNotEnoughSpace");
var $d0b59725680dc68c$export$2d26f4eadfe37285 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerNotEnoughSpace");
var $d0b59725680dc68c$export$ceb7f9bef5a1e481 = (0, $b042d11338a966db$export$94baff7bf5134824)("ManagerUninstallBTCDep");
var $d0b59725680dc68c$export$baadb6886fde1621 = (0, $b042d11338a966db$export$94baff7bf5134824)("NetworkDown");
var $d0b59725680dc68c$export$bae979e68e4dc802 = (0, $b042d11338a966db$export$94baff7bf5134824)("NetworkError");
var $d0b59725680dc68c$export$5cbfa0659f97216a = (0, $b042d11338a966db$export$94baff7bf5134824)("NoAddressesFound");
var $d0b59725680dc68c$export$9e00aead3515e5c9 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughBalance");
var $d0b59725680dc68c$export$c7a9d36aa9527144 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughBalanceSwap");
var $d0b59725680dc68c$export$5ed90e0e011f4857 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughBalanceToDelegate");
var $d0b59725680dc68c$export$75178c95e66d9630 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughBalanceInParentAccount");
var $d0b59725680dc68c$export$e3e2865b29f7e0b0 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughSpendableBalance");
var $d0b59725680dc68c$export$a84b3634866707ea = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughBalanceBecauseDestinationNotCreated");
var $d0b59725680dc68c$export$a282f858b69a7326 = (0, $b042d11338a966db$export$94baff7bf5134824)("NoAccessToCamera");
var $d0b59725680dc68c$export$5111c405c5cacc97 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughGas");
var $d0b59725680dc68c$export$1cb5c4489aaca4d6 = (0, $b042d11338a966db$export$94baff7bf5134824)("NotEnoughGasSwap");
var $d0b59725680dc68c$export$8e08d9056f116258 = (0, $b042d11338a966db$export$94baff7bf5134824)("TronEmptyAccount");
var $d0b59725680dc68c$export$213047d20fb2fead = (0, $b042d11338a966db$export$94baff7bf5134824)("MaybeKeepTronAccountAlive");
var $d0b59725680dc68c$export$626e1fd20d22139c = (0, $b042d11338a966db$export$94baff7bf5134824)("NotSupportedLegacyAddress");
var $d0b59725680dc68c$export$f919e2c9c746346b = (0, $b042d11338a966db$export$94baff7bf5134824)("GasLessThanEstimate");
var $d0b59725680dc68c$export$cc562f3706902d22 = (0, $b042d11338a966db$export$94baff7bf5134824)("PriorityFeeTooLow");
var $d0b59725680dc68c$export$ee14d05cd43eb762 = (0, $b042d11338a966db$export$94baff7bf5134824)("PriorityFeeTooHigh");
var $d0b59725680dc68c$export$931458f4b7d53154 = (0, $b042d11338a966db$export$94baff7bf5134824)("PriorityFeeHigherThanMaxFee");
var $d0b59725680dc68c$export$c0ce9cadb94c6b86 = (0, $b042d11338a966db$export$94baff7bf5134824)("MaxFeeTooLow");
var $d0b59725680dc68c$export$22c5aa8937c5b423 = (0, $b042d11338a966db$export$94baff7bf5134824)("PasswordsDontMatch");
var $d0b59725680dc68c$export$f57670cd1aaf386 = (0, $b042d11338a966db$export$94baff7bf5134824)("PasswordIncorrect");
var $d0b59725680dc68c$export$3ba22bf10deb1448 = (0, $b042d11338a966db$export$94baff7bf5134824)("RecommendSubAccountsToEmpty");
var $d0b59725680dc68c$export$33f73085e1b7871b = (0, $b042d11338a966db$export$94baff7bf5134824)("RecommendUndelegation");
var $d0b59725680dc68c$export$cd4d967a66d81060 = (0, $b042d11338a966db$export$94baff7bf5134824)("TimeoutTagged");
var $d0b59725680dc68c$export$9375635756d6156e = (0, $b042d11338a966db$export$94baff7bf5134824)("UnexpectedBootloader");
var $d0b59725680dc68c$export$90478a5d08d6c2d7 = (0, $b042d11338a966db$export$94baff7bf5134824)("MCUNotGenuineToDashboard");
var $d0b59725680dc68c$export$132f0197eaa65535 = (0, $b042d11338a966db$export$94baff7bf5134824)("RecipientRequired");
var $d0b59725680dc68c$export$7aee729193ab77ba = (0, $b042d11338a966db$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountReceive");
var $d0b59725680dc68c$export$4ec11dc947a3c9d6 = (0, $b042d11338a966db$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountSend");
var $d0b59725680dc68c$export$5e3ed85b946872a1 = (0, $b042d11338a966db$export$94baff7bf5134824)("UpdateFetchFileFail");
var $d0b59725680dc68c$export$5db6383ad081f01e = (0, $b042d11338a966db$export$94baff7bf5134824)("UpdateIncorrectHash");
var $d0b59725680dc68c$export$92c199eb837d8df8 = (0, $b042d11338a966db$export$94baff7bf5134824)("UpdateIncorrectSig");
var $d0b59725680dc68c$export$85e0c017833c894c = (0, $b042d11338a966db$export$94baff7bf5134824)("UpdateYourApp");
var $d0b59725680dc68c$export$84115f1b54c874b3 = (0, $b042d11338a966db$export$94baff7bf5134824)("UserRefusedDeviceNameChange");
var $d0b59725680dc68c$export$3f4864efb1638333 = (0, $b042d11338a966db$export$94baff7bf5134824)("UserRefusedAddress");
var $d0b59725680dc68c$export$d777e0ef77faca34 = (0, $b042d11338a966db$export$94baff7bf5134824)("UserRefusedFirmwareUpdate");
var $d0b59725680dc68c$export$3d8a4f08cd3eb133 = (0, $b042d11338a966db$export$94baff7bf5134824)("UserRefusedAllowManager");
var $d0b59725680dc68c$export$db9b724c3524b5d6 = (0, $b042d11338a966db$export$94baff7bf5134824)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
var $d0b59725680dc68c$export$220d77a66e32ad23 = (0, $b042d11338a966db$export$94baff7bf5134824)("PinNotSet");
var $d0b59725680dc68c$export$65df6bdf4eb29653 = (0, $b042d11338a966db$export$94baff7bf5134824)("ExpertModeRequired");
var $d0b59725680dc68c$export$9642f061c2494239 = (0, $b042d11338a966db$export$94baff7bf5134824)("TransportOpenUserCancelled");
var $d0b59725680dc68c$export$fd71e3a51c4bf0ae = (0, $b042d11338a966db$export$94baff7bf5134824)("TransportInterfaceNotAvailable");
var $d0b59725680dc68c$export$d6cb63cda2c2b2a4 = (0, $b042d11338a966db$export$94baff7bf5134824)("TransportRaceCondition");
var $d0b59725680dc68c$export$c0ffbdd94649bd06 = (0, $b042d11338a966db$export$94baff7bf5134824)("TransportWebUSBGestureRequired");
var $d0b59725680dc68c$export$28149f687a2e30c9 = (0, $b042d11338a966db$export$94baff7bf5134824)("TransactionHasBeenValidatedError");
var $d0b59725680dc68c$export$448663d307bde953 = (0, $b042d11338a966db$export$94baff7bf5134824)("TransportExchangeTimeoutError");
var $d0b59725680dc68c$export$4800af3cc6204928 = (0, $b042d11338a966db$export$94baff7bf5134824)("DeviceShouldStayInApp");
var $d0b59725680dc68c$export$101490ec073327e1 = (0, $b042d11338a966db$export$94baff7bf5134824)("WebsocketConnectionError");
var $d0b59725680dc68c$export$219228963d86b069 = (0, $b042d11338a966db$export$94baff7bf5134824)("WebsocketConnectionFailed");
var $d0b59725680dc68c$export$25b49ca0efdfe5d1 = (0, $b042d11338a966db$export$94baff7bf5134824)("WrongDeviceForAccount");
var $d0b59725680dc68c$export$4de3709f8e2844ca = (0, $b042d11338a966db$export$94baff7bf5134824)("WrongDeviceForAccountPayout");
var $d0b59725680dc68c$export$b7651c38a977157 = (0, $b042d11338a966db$export$94baff7bf5134824)("WrongDeviceForAccountRefund");
var $d0b59725680dc68c$export$63498b46122d8a23 = (0, $b042d11338a966db$export$94baff7bf5134824)("WrongAppForCurrency");
var $d0b59725680dc68c$export$707f317a4761c46d = (0, $b042d11338a966db$export$94baff7bf5134824)("ETHAddressNonEIP");
var $d0b59725680dc68c$export$a5d8da2f27618c16 = (0, $b042d11338a966db$export$94baff7bf5134824)("CantScanQRCode");
var $d0b59725680dc68c$export$3f2d8a7775aab6cc = (0, $b042d11338a966db$export$94baff7bf5134824)("FeeNotLoaded");
var $d0b59725680dc68c$export$3ae46f8c8f45dbe7 = (0, $b042d11338a966db$export$94baff7bf5134824)("FeeNotLoadedSwap");
var $d0b59725680dc68c$export$ffbf6641e9ab88d3 = (0, $b042d11338a966db$export$94baff7bf5134824)("FeeRequired");
var $d0b59725680dc68c$export$53e797c2fa09aff3 = (0, $b042d11338a966db$export$94baff7bf5134824)("FeeTooHigh");
var $d0b59725680dc68c$export$cb0b645e3d7170ab = (0, $b042d11338a966db$export$94baff7bf5134824)("PendingOperation");
var $d0b59725680dc68c$export$2aca4567d80fd933 = (0, $b042d11338a966db$export$94baff7bf5134824)("SyncError");
var $d0b59725680dc68c$export$a2d6658d365c43df = (0, $b042d11338a966db$export$94baff7bf5134824)("PairingFailed");
var $d0b59725680dc68c$export$4400fa093e7d20ad = (0, $b042d11338a966db$export$94baff7bf5134824)("PeerRemovedPairing");
var $d0b59725680dc68c$export$3f7ba18f3c84cced = (0, $b042d11338a966db$export$94baff7bf5134824)("GenuineCheckFailed");
var $d0b59725680dc68c$export$437e6aac14cab3d9 = (0, $b042d11338a966db$export$94baff7bf5134824)("LedgerAPI4xx");
var $d0b59725680dc68c$export$309835543e52bf92 = (0, $b042d11338a966db$export$94baff7bf5134824)("LedgerAPI5xx");
var $d0b59725680dc68c$export$c282cdb2f7fdc27a = (0, $b042d11338a966db$export$94baff7bf5134824)("FirmwareOrAppUpdateRequired");
var $d0b59725680dc68c$export$aba9024c0d586a15 = (0, $b042d11338a966db$export$94baff7bf5134824)("ReplacementTransactionUnderpriced");
var $d0b59725680dc68c$export$51a1e1b4f21df9f4 = (0, $b042d11338a966db$export$94baff7bf5134824)("OpReturnSizeLimit");
var $d0b59725680dc68c$export$1d49177380419e3d = (0, $b042d11338a966db$export$94baff7bf5134824)("DustLimit");
var $d0b59725680dc68c$export$28f62a162580c9c2 = (0, $b042d11338a966db$export$94baff7bf5134824)("LanguageNotFound");
var $d0b59725680dc68c$export$d3cadb9f4e1fa40d = (0, $b042d11338a966db$export$94baff7bf5134824)("NoDBPathGiven");
var $d0b59725680dc68c$export$de46c919e379f03f = (0, $b042d11338a966db$export$94baff7bf5134824)("DBWrongPassword");
var $d0b59725680dc68c$export$e1c94c135b0a553e = (0, $b042d11338a966db$export$94baff7bf5134824)("DBNotReset");
var $d0b59725680dc68c$export$35de8a1f557fb8bb = (0, $b042d11338a966db$export$94baff7bf5134824)("SequenceNumberError");
var $d0b59725680dc68c$export$df2168717eaf23c6 = (0, $b042d11338a966db$export$94baff7bf5134824)("DisabledTransactionBroadcastError");
var $d0b59725680dc68c$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($d0b59725680dc68c$export$62e86095f76df800 || ($d0b59725680dc68c$export$62e86095f76df800 = {}));
var $d0b59725680dc68c$export$ef5ffbe444ecd147 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(HwTransportError, Error1);
    var _super = (0, $hKD8n._)(HwTransportError);
    function HwTransportError(type, message) {
        (0, $7dKN1._)(this, HwTransportError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "HwTransportError";
        _this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf((0, $b9zO9._)(_this), HwTransportError.prototype);
        return _this;
    }
    return HwTransportError;
}((0, $jShW9._)(Error));
var $d0b59725680dc68c$export$8e68de6fb26f2236 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(TransportError, Error1);
    var _super = (0, $hKD8n._)(TransportError);
    function TransportError(message, id) {
        (0, $7dKN1._)(this, TransportError);
        var _this;
        var name = "TransportError";
        _this = _super.call(this, message || name);
        _this.name = name;
        _this.message = message;
        _this.stack = new Error(message).stack;
        _this.id = id;
        return _this;
    }
    return TransportError;
}((0, $jShW9._)(Error));
(0, $b042d11338a966db$export$ff6248acd0c27a3f)("TransportError", function(e) {
    return new $d0b59725680dc68c$export$8e68de6fb26f2236(e.message, e.id);
});
var $d0b59725680dc68c$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    DEVICE_IN_RECOVERY_MODE: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102,
    APP_NOT_FOUND_OR_INVALID_CONTEXT: 0x5123,
    INVALID_APP_NAME_LENGTH: 0x670a,
    GEN_AES_KEY_FAILED: 0x5419,
    INTERNAL_CRYPTO_OPERATION_FAILED: 0x541a,
    INTERNAL_COMPUTE_AES_CMAC_FAILED: 0x541b,
    ENCRYPT_APP_STORAGE_FAILED: 0x541c,
    INVALID_BACKUP_STATE: 0x6642,
    PIN_NOT_SET: 0x5502,
    INVALID_BACKUP_LENGTH: 0x6733,
    INVALID_RESTORE_STATE: 0x6643,
    INVALID_CHUNK_LENGTH: 0x6734,
    INVALID_BACKUP_HEADER: 0x684a,
    // Not documented:
    TRUSTCHAIN_WRONG_SEED: 0xb007
};
function $d0b59725680dc68c$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
var $d0b59725680dc68c$export$78917f4716d96cfe = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $cgJ2Y._)(TransportStatusError, Error1);
    var _super = (0, $hKD8n._)(TransportStatusError);
    function TransportStatusError(statusCode) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_canBeMappedToChildError = _ref.canBeMappedToChildError, canBeMappedToChildError = _ref_canBeMappedToChildError === void 0 ? true : _ref_canBeMappedToChildError;
        (0, $7dKN1._)(this, TransportStatusError);
        var _this;
        var statusText = Object.keys($d0b59725680dc68c$export$efd5569f873811b1).find(function(k) {
            return $d0b59725680dc68c$export$efd5569f873811b1[k] === statusCode;
        }) || "UNKNOWN_ERROR";
        var smsg = $d0b59725680dc68c$export$799566c03457ebd5(statusCode) || statusText;
        var statusCodeStr = statusCode.toString(16);
        var message = "Ledger device: ".concat(smsg, " (0x").concat(statusCodeStr, ")");
        _this = _super.call(this, message);
        _this.name = "TransportStatusError";
        _this.statusCode = statusCode;
        _this.statusText = statusText;
        Object.setPrototypeOf((0, $b9zO9._)(_this), TransportStatusError.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $d0b59725680dc68c$export$efd5569f873811b1.LOCKED_DEVICE) return (0, $7ZqEM._)(_this, new $d0b59725680dc68c$export$1fb6667702a70644(message));
        return _this;
    }
    return TransportStatusError;
}((0, $jShW9._)(Error));
var $d0b59725680dc68c$export$1fb6667702a70644 = /*#__PURE__*/ function(TransportStatusError) {
    "use strict";
    (0, $cgJ2Y._)(LockedDeviceError, TransportStatusError);
    var _super = (0, $hKD8n._)(LockedDeviceError);
    function LockedDeviceError(message) {
        (0, $7dKN1._)(this, LockedDeviceError);
        var _this;
        _this = _super.call(this, $d0b59725680dc68c$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) _this.message = message;
        _this.name = "LockedDeviceError";
        Object.setPrototypeOf((0, $b9zO9._)(_this), LockedDeviceError.prototype);
        return _this;
    }
    return LockedDeviceError;
}($d0b59725680dc68c$export$78917f4716d96cfe);
(0, $b042d11338a966db$export$ff6248acd0c27a3f)("TransportStatusError", function(e) {
    return new $d0b59725680dc68c$export$78917f4716d96cfe(e.statusCode);
});




var $ilnag = parcelRequire("ilnag");
var $b3c79f9dc2f6dd33$require$Buffer = $ilnag.Buffer;
var $b3c79f9dc2f6dd33$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b3c79f9dc2f6dd33$var$P1_NON_CONFIRM = 0x00;
var $b3c79f9dc2f6dd33$var$P1_CONFIRM = 0x01;
var $b3c79f9dc2f6dd33$var$P2_EXTEND = 0x01;
var $b3c79f9dc2f6dd33$var$P2_MORE = 0x02;
var $b3c79f9dc2f6dd33$var$MAX_PAYLOAD = 255;
var $b3c79f9dc2f6dd33$var$LEDGER_CLA = 0xe0;
var $b3c79f9dc2f6dd33$var$INS = {
    GET_VERSION: 0x04,
    GET_ADDR: 0x05,
    SIGN: 0x06,
    SIGN_OFFCHAIN: 0x07
};
var $b3c79f9dc2f6dd33$var$EXTRA_STATUS_CODES;
(function(EXTRA_STATUS_CODES) {
    EXTRA_STATUS_CODES[EXTRA_STATUS_CODES["BLIND_SIGNATURE_REQUIRED"] = 26632] = "BLIND_SIGNATURE_REQUIRED";
})($b3c79f9dc2f6dd33$var$EXTRA_STATUS_CODES || ($b3c79f9dc2f6dd33$var$EXTRA_STATUS_CODES = {}));
var $b3c79f9dc2f6dd33$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Solana(transport) {
        var // the type annotation is needed for doc generator
        // eslint-disable-next-line @typescript-eslint/no-inferrable-types
        scrambleKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "solana_default_scramble_key";
        (0, $7dKN1._)(this, Solana);
        this.transport = transport;
        this.transport.decorateAppAPIMethods(this, [
            "getAddress",
            "signTransaction",
            "getAppConfiguration"
        ], scrambleKey);
    }
    (0, $eW5pA._)(Solana, [
        {
            /**
     * Get Solana address (public key) for a BIP32 path.
     *
     * Because Solana uses Ed25519 keypairs, as per SLIP-0010
     * all derivation-path indexes will be promoted to hardened indexes.
     *
     * @param path a BIP32 path
     * @param display flag to show display
     * @returns an object with the address field
     *
     * @example
     * solana.getAddress("44'/501'/0'").then(r => r.address)
     */ key: "getAddress",
            value: function getAddress(path_1) {
                return $b3c79f9dc2f6dd33$var$__awaiter(this, arguments, void 0, function(path) {
                    var // the type annotation is needed for doc generator
                    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
                    display, pathBuffer, addressBuffer;
                    var _arguments = arguments;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                display = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                                pathBuffer = this.pathToBuffer(path);
                                return [
                                    4,
                                    this.sendToDevice($b3c79f9dc2f6dd33$var$INS.GET_ADDR, display ? $b3c79f9dc2f6dd33$var$P1_CONFIRM : $b3c79f9dc2f6dd33$var$P1_NON_CONFIRM, pathBuffer)
                                ];
                            case 1:
                                addressBuffer = _state.sent();
                                return [
                                    2,
                                    {
                                        address: addressBuffer
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Sign a Solana transaction.
     *
     * @param path a BIP32 path
     * @param txBuffer serialized transaction
     *
     * @returns an object with the signature field
     *
     * @example
     * solana.signTransaction("44'/501'/0'", txBuffer).then(r => r.signature)
     */ key: "signTransaction",
            value: function signTransaction(path, txBuffer) {
                return $b3c79f9dc2f6dd33$var$__awaiter(this, void 0, void 0, function() {
                    var pathBuffer, pathsCountBuffer, payload, signatureBuffer;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                pathBuffer = this.pathToBuffer(path);
                                // Ledger app supports only a single derivation path per call ATM
                                pathsCountBuffer = $b3c79f9dc2f6dd33$require$Buffer.alloc(1);
                                pathsCountBuffer.writeUInt8(1, 0);
                                payload = $b3c79f9dc2f6dd33$require$Buffer.concat([
                                    pathsCountBuffer,
                                    pathBuffer,
                                    txBuffer
                                ]);
                                return [
                                    4,
                                    this.sendToDevice($b3c79f9dc2f6dd33$var$INS.SIGN, $b3c79f9dc2f6dd33$var$P1_CONFIRM, payload)
                                ];
                            case 1:
                                signatureBuffer = _state.sent();
                                return [
                                    2,
                                    {
                                        signature: signatureBuffer
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Sign a Solana off-chain message.
     *
     * @param path a BIP32 path
     * @param msgBuffer serialized off-chain message
     *
     * @returns an object with the signature field
     *
     * @example
     * solana.signOffchainMessage("44'/501'/0'", msgBuffer).then(r => r.signature)
     */ key: "signOffchainMessage",
            value: function signOffchainMessage(path, msgBuffer) {
                return $b3c79f9dc2f6dd33$var$__awaiter(this, void 0, void 0, function() {
                    var pathBuffer, pathsCountBuffer, payload, signatureBuffer;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                pathBuffer = this.pathToBuffer(path);
                                // Ledger app supports only a single derivation path per call ATM
                                pathsCountBuffer = $b3c79f9dc2f6dd33$require$Buffer.alloc(1);
                                pathsCountBuffer.writeUInt8(1, 0);
                                payload = $b3c79f9dc2f6dd33$require$Buffer.concat([
                                    pathsCountBuffer,
                                    pathBuffer,
                                    msgBuffer
                                ]);
                                return [
                                    4,
                                    this.sendToDevice($b3c79f9dc2f6dd33$var$INS.SIGN_OFFCHAIN, $b3c79f9dc2f6dd33$var$P1_CONFIRM, payload)
                                ];
                            case 1:
                                signatureBuffer = _state.sent();
                                return [
                                    2,
                                    {
                                        signature: signatureBuffer
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Get application configuration.
     *
     * @returns application config object
     *
     * @example
     * solana.getAppConfiguration().then(r => r.version)
     */ key: "getAppConfiguration",
            value: function getAppConfiguration() {
                return $b3c79f9dc2f6dd33$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, blindSigningEnabled, pubKeyDisplayMode, major, minor, patch;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.sendToDevice($b3c79f9dc2f6dd33$var$INS.GET_VERSION, $b3c79f9dc2f6dd33$var$P1_NON_CONFIRM, $b3c79f9dc2f6dd33$require$Buffer.alloc(0))
                                ];
                            case 1:
                                _ref = (0, $5OlIx._).apply(void 0, [
                                    _state.sent(),
                                    5
                                ]), blindSigningEnabled = _ref[0], pubKeyDisplayMode = _ref[1], major = _ref[2], minor = _ref[3], patch = _ref[4];
                                return [
                                    2,
                                    {
                                        blindSigningEnabled: Boolean(blindSigningEnabled),
                                        pubKeyDisplayMode: pubKeyDisplayMode,
                                        version: "".concat(major, ".").concat(minor, ".").concat(patch)
                                    }
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "pathToBuffer",
            value: function pathToBuffer(originalPath) {
                var path = originalPath.split("/").map(function(value) {
                    return value.endsWith("'") || value.endsWith("h") ? value : value + "'";
                }).join("/");
                var pathNums = (0, (/*@__PURE__*/$parcel$interopDefault($4f3a21d3ef79f6d4$exports))).fromString(path).toPathArray();
                return this.serializePath(pathNums);
            }
        },
        {
            key: "serializePath",
            value: function serializePath(path) {
                var buf = $b3c79f9dc2f6dd33$require$Buffer.alloc(1 + path.length * 4);
                buf.writeUInt8(path.length, 0);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = path.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $5OlIx._)(_step.value, 2), i = _step_value[0], num = _step_value[1];
                        buf.writeUInt32BE(num, 1 + i * 4);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return buf;
            }
        },
        {
            // send chunked if payload size exceeds maximum for a call
            key: "sendToDevice",
            value: function sendToDevice(instruction, p1, payload) {
                return $b3c79f9dc2f6dd33$var$__awaiter(this, void 0, void 0, function() {
                    var acceptStatusList, p2, payload_offset, buf, reply, buf1, reply1;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                /*
             * By default transport will throw if status code is not OK.
             * For some pyaloads we need to enable blind sign in the app settings
             * and this is reported with StatusCodes.MISSING_CRITICAL_PARAMETER first byte prefix
             * so we handle it and show a user friendly error message.
             */ acceptStatusList = [
                                    (0, $d0b59725680dc68c$export$efd5569f873811b1).OK,
                                    $b3c79f9dc2f6dd33$var$EXTRA_STATUS_CODES.BLIND_SIGNATURE_REQUIRED
                                ];
                                p2 = 0;
                                payload_offset = 0;
                                if (!(payload.length > $b3c79f9dc2f6dd33$var$MAX_PAYLOAD)) return [
                                    3,
                                    3
                                ];
                                _state.label = 1;
                            case 1:
                                if (!(payload.length - payload_offset > $b3c79f9dc2f6dd33$var$MAX_PAYLOAD)) return [
                                    3,
                                    3
                                ];
                                buf = payload.slice(payload_offset, payload_offset + $b3c79f9dc2f6dd33$var$MAX_PAYLOAD);
                                payload_offset += $b3c79f9dc2f6dd33$var$MAX_PAYLOAD;
                                return [
                                    4,
                                    this.transport.send($b3c79f9dc2f6dd33$var$LEDGER_CLA, instruction, p1, p2 | $b3c79f9dc2f6dd33$var$P2_MORE, buf, acceptStatusList)
                                ];
                            case 2:
                                reply = _state.sent();
                                this.throwOnFailure(reply);
                                p2 |= $b3c79f9dc2f6dd33$var$P2_EXTEND;
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                buf1 = payload.slice(payload_offset);
                                return [
                                    4,
                                    this.transport.send($b3c79f9dc2f6dd33$var$LEDGER_CLA, instruction, p1, p2, buf1, acceptStatusList)
                                ];
                            case 4:
                                reply1 = _state.sent();
                                this.throwOnFailure(reply1);
                                return [
                                    2,
                                    reply1.slice(0, reply1.length - 2)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "throwOnFailure",
            value: function throwOnFailure(reply) {
                // transport makes sure reply has a valid length
                var status = reply.readUInt16BE(reply.length - 2);
                switch(status){
                    case $b3c79f9dc2f6dd33$var$EXTRA_STATUS_CODES.BLIND_SIGNATURE_REQUIRED:
                        throw new Error("Missing a parameter. Try enabling blind signature in the app");
                    default:
                        return;
                }
            }
        }
    ]);
    return Solana;
}();
var $b3c79f9dc2f6dd33$var$PubKeyDisplayMode;
(function(PubKeyDisplayMode) {
    PubKeyDisplayMode[PubKeyDisplayMode["LONG"] = 0] = "LONG";
    PubKeyDisplayMode[PubKeyDisplayMode["SHORT"] = 1] = "SHORT";
})($b3c79f9dc2f6dd33$var$PubKeyDisplayMode || ($b3c79f9dc2f6dd33$var$PubKeyDisplayMode = {}));



var $ilnag = parcelRequire("ilnag");
var $8bb522a9558f44ed$require$Buffer = $ilnag.Buffer;
var $8bb522a9558f44ed$export$25e3fec1e3159119;
(function(AppType) {
    AppType["ETH"] = "ETH";
    AppType["ICX"] = "ICX";
    AppType["DOT"] = "DOT";
    AppType["KSM"] = "KSM";
    AppType["WND"] = "WND";
    AppType["ATOM"] = "ATOM";
    AppType["XLM"] = "XLM";
    AppType["SUI"] = "SUI";
    AppType["SOL"] = "SOL";
    AppType["BTC"] = "BTC";
})($8bb522a9558f44ed$export$25e3fec1e3159119 || ($8bb522a9558f44ed$export$25e3fec1e3159119 = {}));
var $8bb522a9558f44ed$export$13a4670d127844b0;
(function(LedgerErrors) {
    LedgerErrors["NotSupported"] = "NotSupported";
    LedgerErrors["NotConnected"] = "NotConnected";
    LedgerErrors["NoAddress"] = "NoAddress";
    LedgerErrors["IncorrectDevice"] = "IncorrectDevice";
})($8bb522a9558f44ed$export$13a4670d127844b0 || ($8bb522a9558f44ed$export$13a4670d127844b0 = {}));
var $8bb522a9558f44ed$export$6a44375b98115fb9;
(function(BasePathType) {
    BasePathType["BIP44"] = "BIP44";
    BasePathType["LEDGER_LIVE"] = "LEDGER_LIVE";
    BasePathType["MEW"] = "MEW";
})($8bb522a9558f44ed$export$6a44375b98115fb9 || ($8bb522a9558f44ed$export$6a44375b98115fb9 = {}));
var $8bb522a9558f44ed$var$BASE_PATHS = {
    ETH_BIP44: "44'/60'/0'/0",
    ETH_LEDGER_LIVE: "44'/60'",
    ETH_MEW: "44'/60'/0'",
    ICX: "44'/4801368'/0'/0'",
    DOT: "44'/354'/0'/0'/0'",
    KSM: "44'/434'/0'/0'/0'",
    WND: "44'/354'/0'/0'/0'",
    ATOM: "44'/118'/0'/0'",
    XLM: "44'/148'",
    SUI: "44'/784''",
    SOL: "44'/501'",
    BTC: "84'/0'/0'/0"
};
var $8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS = {
    ACCOUNT: 0x80000000,
    CHANGE: 0x80000000,
    INDEX: 0x80000000
};
var $8bb522a9558f44ed$var$WND_SS58_DECIMAL = 42; // For encoding address
var $8bb522a9558f44ed$var$U2F_ADDRESS_TIMEOUT = 2000;
function $8bb522a9558f44ed$export$a152966866d4b2d1(prefix, index) {
    return $8bb522a9558f44ed$var$_getCosmosLedgerSigner.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getCosmosLedgerSigner() {
    $8bb522a9558f44ed$var$_getCosmosLedgerSigner = (0, $6rBFC._)(function(prefix, index) {
        var _ref, isSupportedWebHID, isSupportedWebUSB, isSupportedU2F, transport, error, error1, hdPaths;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            (0, $fa5311e106947240$export$2e2bcd8739ae039).isSupported(),
                            (0, $8586421fc21d55d0$export$2e2bcd8739ae039).isSupported(),
                            (0, $6878a85554e577b6$export$2e2bcd8739ae039).isSupported()
                        ])
                    ];
                case 1:
                    _ref = (0, $5OlIx._).apply(void 0, [
                        _state.sent(),
                        3
                    ]), isSupportedWebHID = _ref[0], isSupportedWebUSB = _ref[1], isSupportedU2F = _ref[2];
                    if (!(isSupportedWebHID || isSupportedWebUSB || isSupportedU2F)) throw new Error("NotSupported");
                    transport = null;
                    if (!((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(transport) && isSupportedWebHID)) return [
                        3,
                        5
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $8bb522a9558f44ed$var$getTransportWebHID()
                    ];
                case 3:
                    transport = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    if (!((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(transport) && isSupportedU2F)) return [
                        3,
                        9
                    ];
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        $8bb522a9558f44ed$var$getTransportU2F()
                    ];
                case 7:
                    transport = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    error1 = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 9:
                    if ((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(transport)) throw new Error("NotConnected");
                    hdPaths = index ? [
                        (0, $3e8bd88d734bad5a$exports.makeCosmoshubPath)(index)
                    ] : undefined;
                    return [
                        2,
                        new (0, $43a17493f975232b$exports.LedgerSigner)(transport, {
                            prefix: prefix,
                            hdPaths: hdPaths
                        })
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getCosmosLedgerSigner.apply(this, arguments);
}
function $8bb522a9558f44ed$export$acf12c24b766389a(appType) {
    return $8bb522a9558f44ed$var$_getLedgerApp.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getLedgerApp() {
    $8bb522a9558f44ed$var$_getLedgerApp = (0, $6rBFC._)(function(appType) {
        var _ref, isSupportedWebHID, isSupportedWebUSB, isSupportedU2F, transport, error, error1;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            (0, $fa5311e106947240$export$2e2bcd8739ae039).isSupported(),
                            (0, $8586421fc21d55d0$export$2e2bcd8739ae039).isSupported(),
                            (0, $6878a85554e577b6$export$2e2bcd8739ae039).isSupported()
                        ])
                    ];
                case 1:
                    _ref = (0, $5OlIx._).apply(void 0, [
                        _state.sent(),
                        3
                    ]), isSupportedWebHID = _ref[0], isSupportedWebUSB = _ref[1], isSupportedU2F = _ref[2];
                    if (!(isSupportedWebHID || isSupportedWebUSB || isSupportedU2F)) throw new Error("NotSupported");
                    transport = null;
                    if (!((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(transport) && isSupportedWebHID)) return [
                        3,
                        5
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $8bb522a9558f44ed$var$getTransportWebHID()
                    ];
                case 3:
                    transport = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    if (!((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(transport) && isSupportedU2F)) return [
                        3,
                        9
                    ];
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        $8bb522a9558f44ed$var$getTransportU2F()
                    ];
                case 7:
                    transport = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    error1 = _state.sent();
                    return [
                        3,
                        9
                    ];
                case 9:
                    if ((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(transport)) throw new Error("NotConnected");
                    switch(appType){
                        case "ETH":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppEth(transport)
                            ];
                        case "ICX":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppIcx(transport)
                            ];
                        case "DOT":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppDot(transport)
                            ];
                        case "KSM":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppKsm(transport)
                            ];
                        case "WND":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppWnd(transport)
                            ];
                        case "ATOM":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppAtom(transport)
                            ];
                        case "XLM":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppStr(transport)
                            ];
                        case "SUI":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppSui(transport)
                            ];
                        case "SOL":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppSol(transport)
                            ];
                        case "BTC":
                            return [
                                2,
                                $8bb522a9558f44ed$var$getAppBtc(transport)
                            ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getLedgerApp.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getTransportWebUSB() {
    return $8bb522a9558f44ed$var$_getTransportWebUSB.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getTransportWebUSB() {
    $8bb522a9558f44ed$var$_getTransportWebUSB = (0, $6rBFC._)(function() {
        var devices, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $8586421fc21d55d0$export$2e2bcd8739ae039).list()
                    ];
                case 1:
                    devices = _state.sent();
                    if (!(0, $8c2bc561ca8daee1$export$2e2bcd8739ae039)(devices)) return [
                        3,
                        5
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0, $8586421fc21d55d0$export$2e2bcd8739ae039).request()
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed requesting WebUSB device access.", error);
                    throw new Error("NotConnected");
                case 5:
                    return [
                        2,
                        (0, $8586421fc21d55d0$export$2e2bcd8739ae039).create()
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getTransportWebUSB.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getTransportWebHID() {
    return $8bb522a9558f44ed$var$_getTransportWebHID.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getTransportWebHID() {
    $8bb522a9558f44ed$var$_getTransportWebHID = (0, $6rBFC._)(function() {
        var devices, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $fa5311e106947240$export$2e2bcd8739ae039).list()
                    ];
                case 1:
                    devices = _state.sent();
                    if (!(0, $8c2bc561ca8daee1$export$2e2bcd8739ae039)(devices)) return [
                        3,
                        5
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0, $fa5311e106947240$export$2e2bcd8739ae039).request()
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed requesting WebHID device access.", error);
                    throw new Error("NotConnected");
                case 5:
                    return [
                        2,
                        (0, $fa5311e106947240$export$2e2bcd8739ae039).create()
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getTransportWebHID.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getTransportU2F() {
    return $8bb522a9558f44ed$var$_getTransportU2F.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getTransportU2F() {
    $8bb522a9558f44ed$var$_getTransportU2F = (0, $6rBFC._)(function() {
        return (0, $6qu4b.__generator)(this, function(_state) {
            return [
                2,
                (0, $6878a85554e577b6$export$2e2bcd8739ae039).create()
            ];
        });
    });
    return $8bb522a9558f44ed$var$_getTransportU2F.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppEth(transport) {
    return $8bb522a9558f44ed$var$_getAppEth.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppEth() {
    $8bb522a9558f44ed$var$_getAppEth = (0, $6rBFC._)(function(transport) {
        var app, response, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = new (0, $342c61efd3810a3d$export$2e2bcd8739ae039)(transport);
                    return [
                        4,
                        Promise.race([
                            $8bb522a9558f44ed$export$bd7a06763620ade5(app, "ETH", 0),
                            (0, $7bb7588d65550050$export$5c069c93d2b7493f)($8bb522a9558f44ed$var$U2F_ADDRESS_TIMEOUT)
                        ])
                    ];
                case 1:
                    response = _state.sent();
                    if ((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(response)) throw new Error("Timed out getting address from ETH app.");
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating ETH app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppEth.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppIcx(transport) {
    return $8bb522a9558f44ed$var$_getAppIcx.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppIcx() {
    $8bb522a9558f44ed$var$_getAppIcx = (0, $6rBFC._)(function(transport) {
        var app, response, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = new (0, $11ba9be4553419b5$export$2e2bcd8739ae039)(transport);
                    return [
                        4,
                        Promise.race([
                            $8bb522a9558f44ed$export$bd7a06763620ade5(app, "ICX", 0),
                            (0, $7bb7588d65550050$export$5c069c93d2b7493f)($8bb522a9558f44ed$var$U2F_ADDRESS_TIMEOUT)
                        ])
                    ];
                case 1:
                    response = _state.sent();
                    if ((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(response)) throw new Error("Timed out getting address from ICX app.");
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating ICX app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppIcx.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppDot(transport) {
    return $8bb522a9558f44ed$var$_getAppDot.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppDot() {
    $8bb522a9558f44ed$var$_getAppDot = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = (0, $b6ea585a3a423ae0$exports.newPolkadotApp)(transport);
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "DOT", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating DOT app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppDot.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppKsm(transport) {
    return $8bb522a9558f44ed$var$_getAppKsm.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppKsm() {
    $8bb522a9558f44ed$var$_getAppKsm = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = (0, $b6ea585a3a423ae0$exports.newKusamaApp)(transport);
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "KSM", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating KSM app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppKsm.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppWnd(transport) {
    return $8bb522a9558f44ed$var$_getAppWnd.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppWnd() {
    $8bb522a9558f44ed$var$_getAppWnd = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = (0, $b6ea585a3a423ae0$exports.newKusamaApp)(transport);
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "WND", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating WND app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppWnd.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppAtom(transport) {
    return $8bb522a9558f44ed$var$_getAppAtom.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppAtom() {
    $8bb522a9558f44ed$var$_getAppAtom = (0, $6rBFC._)(function(transport) {
        var app;
        return (0, $6qu4b.__generator)(this, function(_state) {
            try {
                app = new (0, $e9a503bce58fac65$exports.CosmosApp)(transport);
                // await getLedgerAddress(app, AppType.ATOM, 0);
                return [
                    2,
                    app
                ];
            } catch (error) {
                console.warn("Hana LedgerBridge", "Failed creating ATOM app.", error);
                throw new Error("NoAddress");
            }
            return [
                2
            ];
        });
    });
    return $8bb522a9558f44ed$var$_getAppAtom.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppStr(transport) {
    return $8bb522a9558f44ed$var$_getAppStr.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppStr() {
    $8bb522a9558f44ed$var$_getAppStr = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = new (0, $d44be13057c2c607$export$2e2bcd8739ae039)(transport);
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "XLM", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating XLM app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppStr.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppSui(transport) {
    return $8bb522a9558f44ed$var$_getAppSui.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppSui() {
    $8bb522a9558f44ed$var$_getAppSui = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = new (0, $9b6e4442a77ba03d$export$2e2bcd8739ae039)(transport);
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "SUI", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating SUI app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppSui.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppSol(transport) {
    return $8bb522a9558f44ed$var$_getAppSol.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppSol() {
    $8bb522a9558f44ed$var$_getAppSol = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = new (0, $b3c79f9dc2f6dd33$export$2e2bcd8739ae039)(transport);
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "SOL", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating SOL app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppSol.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAppBtc(transport) {
    return $8bb522a9558f44ed$var$_getAppBtc.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getAppBtc() {
    $8bb522a9558f44ed$var$_getAppBtc = (0, $6rBFC._)(function(transport) {
        var app, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    app = new (0, $6c687ba53a124d05$export$2e2bcd8739ae039)({
                        transport: transport
                    });
                    return [
                        4,
                        $8bb522a9558f44ed$export$bd7a06763620ade5(app, "BTC", 0)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        app
                    ];
                case 2:
                    error = _state.sent();
                    console.warn("Hana LedgerBridge", "Failed creating BTC app.", error);
                    throw new Error("NoAddress");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getAppBtc.apply(this, arguments);
}
function $8bb522a9558f44ed$var$isEIP712Data(message) {
    try {
        var data = JSON.parse(message);
        if (typeof data !== "object" || data === null) return false;
        var hasDomain = data.domain && typeof data.domain === "object";
        var hasMessage = data.message && typeof data.message === "object";
        var hasTypes = data.types && typeof data.types === "object" && "EIP712Domain" in data.types;
        return hasDomain && hasMessage && hasTypes;
    } catch (error) {
        return false;
    }
}
function $8bb522a9558f44ed$var$eip712RemoveUnusedTypes(primaryType, types) {
    var usedTypes = {};
    function findUsedTypes(currentType) {
        if (usedTypes[currentType]) // Already processed this type
        return;
        var fields = types[currentType];
        if (!fields) throw new Error("Type ".concat(currentType, " is not defined"));
        usedTypes[currentType] = fields;
        fields.forEach(function(field) {
            if (types[field.type]) // This type is a custom type, delve deeper
            findUsedTypes(field.type);
        });
    }
    findUsedTypes(primaryType);
    return usedTypes;
}
function $8bb522a9558f44ed$export$1d9a7a8a40780de(app, appType, hdPath, message) {
    return $8bb522a9558f44ed$var$_signMessage.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_signMessage() {
    $8bb522a9558f44ed$var$_signMessage = (0, $6rBFC._)(function(app, appType, hdPath, message) {
        var txBuffer, _ref, signatureBuffer, publicKey, messageBuffer, signature, messageBuffer1, signature1, isEip712, result, data, domainSeparator, hashStructMessage, v, vString, signature2;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (appType === "ICX") throw new Error("Cannot sign with Ledger ICON wallet");
                    else if (appType === "DOT" || appType === "KSM" || appType === "WND") throw new Error("Cannot sign with Ledger DOT wallet");
                    if (!(appType === "SUI")) return [
                        3,
                        3
                    ];
                    txBuffer = $8bb522a9558f44ed$require$Buffer.from(message, "base64");
                    return [
                        4,
                        app.signTransaction(hdPath, (0, $23fa097f73defb11$exports.messageWithIntent)("PersonalMessage", txBuffer))
                    ];
                case 1:
                    _ref = _state.sent(), signatureBuffer = _ref.signature;
                    return [
                        4,
                        app.getPublicKey(hdPath)
                    ];
                case 2:
                    publicKey = _state.sent().publicKey;
                    return [
                        2,
                        (0, $23fa097f73defb11$exports.toSerializedSignature)({
                            signature: signatureBuffer,
                            signatureScheme: "ED25519",
                            publicKey: new (0, $bef2e912dc82ffc5$exports.Ed25519PublicKey)(publicKey)
                        })
                    ];
                case 3:
                    if (!(appType === "SOL")) return [
                        3,
                        5
                    ];
                    messageBuffer = $8bb522a9558f44ed$require$Buffer.from(message, "base64");
                    return [
                        4,
                        app.signOffchainMessage(hdPath, messageBuffer)
                    ];
                case 4:
                    signature = _state.sent().signature;
                    return [
                        2,
                        $8bb522a9558f44ed$require$Buffer.from(signature).toString("base64")
                    ];
                case 5:
                    if (!(appType === "XLM")) return [
                        3,
                        7
                    ];
                    messageBuffer1 = $8bb522a9558f44ed$require$Buffer.from(message);
                    return [
                        4,
                        app.signHash(hdPath, messageBuffer1)
                    ];
                case 6:
                    signature1 = _state.sent();
                    return [
                        2,
                        signature1.signature.toString("hex")
                    ];
                case 7:
                    if (/^0x/.test(message)) message = message.slice(2);
                    isEip712 = $8bb522a9558f44ed$var$isEIP712Data(message);
                    if (!isEip712) return [
                        3,
                        9
                    ];
                    data = JSON.parse(message);
                    domainSeparator = (0, $7c9fa484a0263d49$exports).utils._TypedDataEncoder.hashDomain(data.domain);
                    // Remove EIP712Domain from types
                    delete data.types.EIP712Domain;
                    // Remove unused types
                    data.types = $8bb522a9558f44ed$var$eip712RemoveUnusedTypes(data.primaryType, data.types);
                    hashStructMessage = (0, $7c9fa484a0263d49$exports).utils._TypedDataEncoder.hashStruct(data.primaryType, data.types, data.message);
                    console.debug("hashStructMessage: ", hashStructMessage);
                    return [
                        4,
                        app.signEIP712HashedMessage(hdPath, domainSeparator, hashStructMessage)
                    ];
                case 8:
                    result = _state.sent();
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        app.signPersonalMessage(hdPath, message)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    v = result["v"] - 27;
                    vString = v.toString(16);
                    if (vString.length < 2) vString = "0" + v;
                    signature2 = "0x".concat(result.r).concat(result.s).concat(vString);
                    return [
                        2,
                        signature2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_signMessage.apply(this, arguments);
}
function $8bb522a9558f44ed$export$6ad02cc4966b42ab(app, appType, fromAddress, serializedTx, options) {
    return $8bb522a9558f44ed$var$_signTransaction.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_signTransaction() {
    $8bb522a9558f44ed$var$_signTransaction = (0, $6rBFC._)(function(app, appType, fromAddress, serializedTx, options) {
        var hdPath, index, ethResolution, ethResponse, icxResponse, dotResponse, stdSignDoc, msgs, updatedMsgs, response, transaction, xlmResponse, signatureBuffer, signature, txBuffer, _ref, signatureBuffer1, publicKey, txBuffer1, _ref1, solSignature, psbtTxn, unsignedTxBuffer, inLedgerTx, inputs, outputScriptHex;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hdPath = fromAddress.hdPath, index = fromAddress.index;
                    switch(appType){
                        case "ETH":
                            return [
                                3,
                                1
                            ];
                        case "ICX":
                            return [
                                3,
                                4
                            ];
                        case "DOT":
                            return [
                                3,
                                6
                            ];
                        case "KSM":
                            return [
                                3,
                                6
                            ];
                        case "WND":
                            return [
                                3,
                                6
                            ];
                        case "ATOM":
                            return [
                                3,
                                8
                            ];
                        case "XLM":
                            return [
                                3,
                                10
                            ];
                        case "SUI":
                            return [
                                3,
                                12
                            ];
                        case "SOL":
                            return [
                                3,
                                15
                            ];
                        case "BTC":
                            return [
                                3,
                                17
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 1:
                    return [
                        4,
                        (0, $fd117c956f2ba52b$export$2e2bcd8739ae039).resolveTransaction(serializedTx, {}, {})
                    ];
                case 2:
                    ethResolution = _state.sent();
                    return [
                        4,
                        app.signTransaction(hdPath, serializedTx, ethResolution)
                    ];
                case 3:
                    ethResponse = _state.sent();
                    console.log("LedgerBridge.signTransaction", "got signature?", ethResponse);
                    return [
                        2,
                        {
                            v: "0x".concat(ethResponse.v),
                            r: "0x".concat(ethResponse.r),
                            s: "0x".concat(ethResponse.s)
                        }
                    ];
                case 4:
                    return [
                        4,
                        app.signTransaction(hdPath, serializedTx)
                    ];
                case 5:
                    icxResponse = _state.sent();
                    return [
                        2,
                        icxResponse.signedRawTxBase64
                    ];
                case 6:
                    return [
                        4,
                        app.sign($8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS.ACCOUNT, $8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS.CHANGE, $8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS.INDEX + index, $8bb522a9558f44ed$require$Buffer.from(serializedTx, "hex"))
                    ];
                case 7:
                    dotResponse = _state.sent();
                    if ((0, $f59e127e73eaefde$export$2e2bcd8739ae039)(dotResponse.signature)) throw new Error("".concat(dotResponse.error_message, " (code: ").concat(dotResponse.return_code, ")"));
                    return [
                        2,
                        dotResponse.signature.toString("hex")
                    ];
                case 8:
                    stdSignDoc = JSON.parse(serializedTx);
                    // Convert msgs.value.data to Uint8Array if needed
                    msgs = stdSignDoc.msgs;
                    updatedMsgs = msgs;
                    updatedMsgs.forEach(function(msg) {
                        var data = msg.value.data;
                        if (data) {
                            var isArray = Array.isArray(data);
                            if (isArray) {
                                var uint8Array = new Uint8Array(data);
                                msg.value.data = uint8Array;
                            }
                        }
                    });
                    stdSignDoc = (0, $gddcW._)((0, $4JCw4._)({}, stdSignDoc), {
                        msgs: updatedMsgs
                    });
                    return [
                        4,
                        app.signAmino(fromAddress.address, stdSignDoc)
                    ];
                case 9:
                    response = _state.sent();
                    return [
                        2,
                        JSON.stringify(response)
                    ];
                case 10:
                    transaction = $8bb522a9558f44ed$require$Buffer.from(serializedTx, "base64");
                    return [
                        4,
                        app.signTransaction(hdPath, transaction)
                    ];
                case 11:
                    xlmResponse = _state.sent();
                    signatureBuffer = xlmResponse.signature;
                    signature = signatureBuffer.toString("base64");
                    return [
                        2,
                        signature
                    ];
                case 12:
                    txBuffer = $8bb522a9558f44ed$require$Buffer.from(serializedTx, "base64");
                    return [
                        4,
                        app.signTransaction(hdPath, (0, $23fa097f73defb11$exports.messageWithIntent)("TransactionData", txBuffer))
                    ];
                case 13:
                    _ref = _state.sent(), signatureBuffer1 = _ref.signature;
                    return [
                        4,
                        app.getPublicKey(hdPath)
                    ];
                case 14:
                    publicKey = _state.sent().publicKey;
                    return [
                        2,
                        (0, $23fa097f73defb11$exports.toSerializedSignature)({
                            signature: signatureBuffer1,
                            signatureScheme: "ED25519",
                            publicKey: new (0, $bef2e912dc82ffc5$exports.Ed25519PublicKey)(publicKey)
                        })
                    ];
                case 15:
                    txBuffer1 = $8bb522a9558f44ed$require$Buffer.from(serializedTx, "base64");
                    return [
                        4,
                        app.signTransaction(hdPath, txBuffer1)
                    ];
                case 16:
                    _ref1 = _state.sent(), solSignature = _ref1.signature;
                    return [
                        2,
                        $8bb522a9558f44ed$require$Buffer.from(solSignature).toString("base64")
                    ];
                case 17:
                    psbtTxn = (0, $881b6534ce6ec462$exports.Psbt).fromBase64(serializedTx);
                    unsignedTxBuffer = psbtTxn.data.globalMap.unsignedTx.toBuffer();
                    inLedgerTx = app.splitTransaction(unsignedTxBuffer.toString("hex"), true);
                    inputs = psbtTxn.txInputs.map(function(utxo, index) {
                        if (!(options === null || options === void 0 ? void 0 : options.rawBtcInputsHex)) throw new Error("BTC input hex is required!");
                        var rawHex = options.rawBtcInputsHex[index];
                        var inputTxn = app.splitTransaction(rawHex, true);
                        return [
                            inputTxn,
                            utxo.index,
                            undefined,
                            0
                        ];
                    });
                    outputScriptHex = app.serializeTransactionOutputs(inLedgerTx).toString("hex");
                    return [
                        2,
                        app.createPaymentTransaction({
                            inputs: inputs,
                            associatedKeysets: Array(inputs.length).fill(hdPath),
                            outputScriptHex: outputScriptHex,
                            additionals: [
                                "bech32"
                            ]
                        })
                    ];
                case 18:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_signTransaction.apply(this, arguments);
}
function $8bb522a9558f44ed$export$bd7a06763620ade5(app, appType, index, options) {
    return $8bb522a9558f44ed$var$_getLedgerAddress.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getLedgerAddress() {
    $8bb522a9558f44ed$var$_getLedgerAddress = (0, $6rBFC._)(function(app, appType, index, options) {
        var hdPath, _ref, ethAddress, _ref1, icxAddress, _ref2, dotAddress, accounts, account, address, pubkey, algo, addressSerialized, pubkeySerialized, key, _ref3, xlmAddress, pubKey, _ref4, publicKey, _ref5, bitcoinAddress, publicKey1;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hdPath = $8bb522a9558f44ed$var$getAddressPath(appType, index, options === null || options === void 0 ? void 0 : options.basePathType);
                    switch(appType){
                        case "ETH":
                            return [
                                3,
                                1
                            ];
                        case "ICX":
                            return [
                                3,
                                3
                            ];
                        case "DOT":
                            return [
                                3,
                                5
                            ];
                        case "KSM":
                            return [
                                3,
                                5
                            ];
                        case "WND":
                            return [
                                3,
                                5
                            ];
                        case "ATOM":
                            return [
                                3,
                                7
                            ];
                        case "XLM":
                            return [
                                3,
                                9
                            ];
                        case "SUI":
                            return [
                                3,
                                11
                            ];
                        case "SOL":
                            return [
                                3,
                                13
                            ];
                        case "BTC":
                            return [
                                3,
                                15
                            ];
                    }
                    return [
                        3,
                        17
                    ];
                case 1:
                    return [
                        4,
                        app.getAddress(hdPath, false, true)
                    ];
                case 2:
                    _ref = _state.sent(), ethAddress = _ref.address;
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: ethAddress
                        }
                    ];
                case 3:
                    return [
                        4,
                        app.getAddress(hdPath, false, true)
                    ];
                case 4:
                    _ref1 = _state.sent(), icxAddress = _ref1.address;
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: icxAddress.toString()
                        }
                    ];
                case 5:
                    return [
                        4,
                        app.getAddress($8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS.ACCOUNT, $8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS.CHANGE, $8bb522a9558f44ed$var$DOT_ADDRESS_DEFAULTS.INDEX + index)
                    ];
                case 6:
                    _ref2 = _state.sent(), dotAddress = _ref2.address;
                    if (appType === "WND") dotAddress = (0, $37db50d48c8e4e6d$export$b149ba8ff44e4e70)(dotAddress, $8bb522a9558f44ed$var$WND_SS58_DECIMAL);
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: dotAddress
                        }
                    ];
                case 7:
                    return [
                        4,
                        app.getAccounts()
                    ];
                case 8:
                    accounts = _state.sent();
                    account = accounts[0];
                    address = account.address, pubkey = account.pubkey, algo = account.algo;
                    console.debug("account: ", account);
                    addressSerialized = JSON.stringify(Array.from((0, $c9b9a1a428003423$exports.rawSecp256k1PubkeyToRawAddress)(pubkey)));
                    pubkeySerialized = JSON.stringify(Array.from(pubkey));
                    key = {
                        address: addressSerialized,
                        algo: algo,
                        isKeystone: false,
                        isNanoLedger: true,
                        name: "",
                        bech32Address: address,
                        pubKey: pubkeySerialized
                    };
                    console.debug("key: ", key);
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: address,
                            cosmosPubKey: JSON.stringify(key)
                        }
                    ];
                case 9:
                    return [
                        4,
                        app.getPublicKey(hdPath)
                    ];
                case 10:
                    _ref3 = _state.sent(), xlmAddress = _ref3.publicKey;
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: xlmAddress
                        }
                    ];
                case 11:
                    return [
                        4,
                        app.getPublicKey(hdPath)
                    ];
                case 12:
                    pubKey = _state.sent();
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: "0x".concat($8bb522a9558f44ed$require$Buffer.from(pubKey.address).toString("hex")),
                            suiPubKey: "0x".concat($8bb522a9558f44ed$require$Buffer.from(pubKey.publicKey).toString("hex"))
                        }
                    ];
                case 13:
                    return [
                        4,
                        app.getAddress(hdPath)
                    ];
                case 14:
                    _ref4 = _state.sent(), publicKey = _ref4.address;
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: new (0, $275f7bb2bb263073$export$ca8b6604d6ce14de)(publicKey).toBase58(),
                            solanaPubKey: new (0, $275f7bb2bb263073$export$ca8b6604d6ce14de)(publicKey).toBase58()
                        }
                    ];
                case 15:
                    return [
                        4,
                        app.getWalletPublicKey(hdPath, {
                            format: "bech32"
                        })
                    ];
                case 16:
                    _ref5 = _state.sent(), bitcoinAddress = _ref5.bitcoinAddress, publicKey1 = _ref5.publicKey;
                    return [
                        2,
                        {
                            index: index,
                            hdPath: hdPath,
                            address: bitcoinAddress
                        }
                    ];
                case 17:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getLedgerAddress.apply(this, arguments);
}
function $8bb522a9558f44ed$export$ba98d8cf93523b51(app, params) {
    return $8bb522a9558f44ed$var$_estimateCosmosTransaction.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_estimateCosmosTransaction() {
    $8bb522a9558f44ed$var$_estimateCosmosTransaction = (0, $6rBFC._)(function(app, params) {
        var rpcUrl, fromAddress, messages, _gasPrice, gasPriceMultiplier, client, gasUsed, gasUsedAdjusted, price, gasPrice;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    rpcUrl = params.rpcUrl, fromAddress = params.fromAddress, messages = params.messages, _gasPrice = params.gasPrice, gasPriceMultiplier = params.gasPriceMultiplier;
                    return [
                        4,
                        (0, $3e8bd88d734bad5a$exports.SigningStargateClient).connectWithSigner(rpcUrl, app)
                    ];
                case 1:
                    client = _state.sent();
                    return [
                        4,
                        client.simulate(fromAddress.address, messages, "Optional memo")
                    ];
                case 2:
                    gasUsed = _state.sent();
                    gasUsedAdjusted = gasUsed * (gasPriceMultiplier || 1.5);
                    price = parseInt(Math.ceil(gasUsedAdjusted).toString());
                    gasPrice = _gasPrice || 0.025;
                    return [
                        2,
                        {
                            amount: gasPrice,
                            price: price
                        }
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_estimateCosmosTransaction.apply(this, arguments);
}
function $8bb522a9558f44ed$export$19333539a236307f(app, params) {
    return $8bb522a9558f44ed$var$_sendCosmosTokens.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_sendCosmosTokens() {
    $8bb522a9558f44ed$var$_sendCosmosTokens = (0, $6rBFC._)(function(app, params) {
        var rpcUrl, prefix, index, fromAddress, toAddress, txAmount, denom, contract, feeDenom, memo, estimate, _gasPrice, gasPriceMultiplier, client, transferMsg, executeMsg, gasUsed, gasUsedAdjusted, price, gasPrice, feeAmount, fee, hash, client1, amount, message, gasUsed1, gasUsedAdjusted1, price1, gasPrice1, feeAmount1, fee1, hash1;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // console.debug('Ledger bridge sendCosmosTokens: ', {
                    //   app,
                    //   params,
                    // });
                    rpcUrl = params.rpcUrl, prefix = params.prefix, index = params.index, fromAddress = params.fromAddress, toAddress = params.toAddress, txAmount = params.txAmount, denom = params.denom, contract = params.contract, feeDenom = params.feeDenom, memo = params.memo, estimate = params.estimate, _gasPrice = params.gasPrice, gasPriceMultiplier = params.gasPriceMultiplier;
                    if (!!(0, $f59e127e73eaefde$export$2e2bcd8739ae039)(contract)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $5806cdd0880cf151$exports.SigningCosmWasmClient).connectWithSigner(rpcUrl, app)
                    ];
                case 1:
                    client = _state.sent();
                    // Construct the transfer message for the CW20 token contract
                    transferMsg = {
                        transfer: {
                            recipient: toAddress,
                            amount: txAmount
                        }
                    };
                    // The execute message must be wrapped properly for simulation
                    executeMsg = {
                        typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
                        value: (0, $a3e3198abc37a385$exports.MsgExecuteContract).fromPartial({
                            sender: fromAddress.address,
                            contract: contract,
                            msg: $8bb522a9558f44ed$require$Buffer.from(JSON.stringify(transferMsg)),
                            funds: []
                        })
                    };
                    return [
                        4,
                        client.simulate(fromAddress.address, [
                            executeMsg
                        ], memo)
                    ];
                case 2:
                    gasUsed = _state.sent();
                    gasUsedAdjusted = gasUsed * (gasPriceMultiplier || 1.5);
                    price = parseInt(Math.ceil(gasUsedAdjusted).toString());
                    gasPrice = _gasPrice || 0.025;
                    if (!(estimate === true)) return [
                        3,
                        3
                    ];
                    return [
                        2,
                        {
                            amount: gasPrice,
                            price: price
                        }
                    ];
                case 3:
                    feeAmount = Math.ceil(gasPrice * price);
                    fee = {
                        amount: (0, $3e8bd88d734bad5a$exports.coins)(feeAmount.toString(), feeDenom),
                        gas: Math.ceil(price * 1.3).toString()
                    };
                    return [
                        4,
                        client.signAndBroadcastSync(fromAddress.address, [
                            executeMsg
                        ], fee, memo)
                    ];
                case 4:
                    hash = _state.sent();
                    return [
                        2,
                        hash
                    ];
                case 5:
                    if (!!(0, $f59e127e73eaefde$export$2e2bcd8739ae039)(denom)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $3e8bd88d734bad5a$exports.SigningStargateClient).connectWithSigner(rpcUrl, app)
                    ];
                case 6:
                    client1 = _state.sent();
                    amount = (0, $3e8bd88d734bad5a$exports.coins)(txAmount, denom);
                    message = {
                        typeUrl: "/cosmos.bank.v1beta1.MsgSend",
                        value: {
                            fromAddress: fromAddress.address,
                            toAddress: toAddress,
                            amount: amount
                        }
                    };
                    return [
                        4,
                        client1.simulate(fromAddress.address, [
                            message
                        ], memo)
                    ];
                case 7:
                    gasUsed1 = _state.sent();
                    gasUsedAdjusted1 = gasUsed1 * (gasPriceMultiplier || 1.5);
                    price1 = parseInt(Math.ceil(gasUsedAdjusted1).toString());
                    gasPrice1 = _gasPrice || 0.025;
                    if (!(estimate === true)) return [
                        3,
                        8
                    ];
                    return [
                        2,
                        {
                            amount: gasPrice1,
                            price: price1
                        }
                    ];
                case 8:
                    feeAmount1 = Math.ceil(gasPrice1 * price1);
                    fee1 = {
                        amount: (0, $3e8bd88d734bad5a$exports.coins)(feeAmount1.toString(), feeDenom),
                        gas: Math.ceil(price1 * 1.3).toString()
                    };
                    return [
                        4,
                        client1.signAndBroadcastSync(fromAddress.address, [
                            message
                        ], fee1, memo)
                    ];
                case 9:
                    hash1 = _state.sent();
                    return [
                        2,
                        hash1
                    ];
                case 10:
                    throw new Error("Invalid token");
            }
        });
    });
    return $8bb522a9558f44ed$var$_sendCosmosTokens.apply(this, arguments);
}
function $8bb522a9558f44ed$export$4e7a4b992ea8deaf(app) {
    return $8bb522a9558f44ed$var$_getCosmosPublicKey.apply(this, arguments);
}
function $8bb522a9558f44ed$var$_getCosmosPublicKey() {
    $8bb522a9558f44ed$var$_getCosmosPublicKey = (0, $6rBFC._)(function(app) {
        var accounts, account, algo, address, pubkey, addressSerialized, pubkeySerialized, key, error;
        return (0, $6qu4b.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        app.getAccounts()
                    ];
                case 1:
                    accounts = _state.sent();
                    account = accounts[0];
                    algo = account.algo, address = account.address, pubkey = account.pubkey;
                    addressSerialized = JSON.stringify(Array.from((0, $c9b9a1a428003423$exports.rawSecp256k1PubkeyToRawAddress)(pubkey)));
                    pubkeySerialized = JSON.stringify(Array.from(pubkey));
                    key = {
                        address: addressSerialized,
                        algo: algo,
                        isKeystone: false,
                        isNanoLedger: true,
                        name: "",
                        bech32Address: address,
                        pubKey: pubkeySerialized
                    };
                    console.debug("getCosmosPublicKey key: ", key);
                    return [
                        2,
                        key
                    ];
                case 2:
                    error = _state.sent();
                    console.debug("getCosmosPublicKey error: ", error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $8bb522a9558f44ed$var$_getCosmosPublicKey.apply(this, arguments);
}
function $8bb522a9558f44ed$var$getAddressPath(appType, index, basePathType) {
    var selectedBasePath = $8bb522a9558f44ed$var$getBasePath(appType, basePathType);
    if (appType === "ETH") switch(selectedBasePath){
        case $8bb522a9558f44ed$var$BASE_PATHS.ETH_LEDGER_LIVE:
            return "".concat(selectedBasePath, "/").concat(index, "'/0/0");
        case $8bb522a9558f44ed$var$BASE_PATHS.ETH_MEW:
            return "".concat(selectedBasePath, "/").concat(index);
        default:
            return "".concat(selectedBasePath, "/").concat(index);
    }
    var addressPath = "".concat(selectedBasePath, "/").concat(index);
    if (appType === "ICX" || appType === "XLM") addressPath += "'";
    else if (appType === "SUI") addressPath += "'/0'/0'";
    else if (appType === "SOL") addressPath += "'/0'";
    return addressPath;
}
function $8bb522a9558f44ed$var$getBasePath(appType, basePathType) {
    switch(appType){
        case "ETH":
            if (basePathType === "LEDGER_LIVE") return $8bb522a9558f44ed$var$BASE_PATHS.ETH_LEDGER_LIVE;
            else if (basePathType === "MEW") return $8bb522a9558f44ed$var$BASE_PATHS.ETH_MEW;
            return $8bb522a9558f44ed$var$BASE_PATHS.ETH_BIP44; // Default to BIP44 path
        case "ICX":
            return $8bb522a9558f44ed$var$BASE_PATHS.ICX;
        case "DOT":
        case "WND":
            return $8bb522a9558f44ed$var$BASE_PATHS.DOT;
        case "KSM":
            return $8bb522a9558f44ed$var$BASE_PATHS.KSM;
        case "ATOM":
            return $8bb522a9558f44ed$var$BASE_PATHS.ATOM;
        case "XLM":
            return $8bb522a9558f44ed$var$BASE_PATHS.XLM;
        case "SUI":
            return $8bb522a9558f44ed$var$BASE_PATHS.SUI;
        case "SOL":
            return $8bb522a9558f44ed$var$BASE_PATHS.SOL;
        case "BTC":
            return $8bb522a9558f44ed$var$BASE_PATHS.BTC;
    }
}


var $a6f2e54b9428455f$export$ba5e68c585df8eb6 = "HANA_LEDGER_BRIDGE";
var $a6f2e54b9428455f$export$24e6ff1ee090b133;
(function(MESSAGE_ACTION) {
    MESSAGE_ACTION["INIT"] = "LedgerBridgeInit";
    MESSAGE_ACTION["READY"] = "LedgerBridgeReady";
    MESSAGE_ACTION["GET_ADDRESSES"] = "LedgerBridgeGetAddresses";
    MESSAGE_ACTION["ADDRESSES"] = "LedgerBridgeAddresses";
    MESSAGE_ACTION["SIGN_MESSAGE"] = "LedgerBridgeSignMessage";
    MESSAGE_ACTION["SIGN_TRANSACTION"] = "LedgerBridgeSignTransaction";
    MESSAGE_ACTION["SIGNATURE"] = "LedgerBridgeSignature";
    MESSAGE_ACTION["COSMOS_SEND_TOKENS"] = "LedgerBridgeCosmosSendTokens";
    MESSAGE_ACTION["COSMOS_SEND_TOKENS_RESPONSE"] = "LedgerBridgeCosmosSendTokensResponse";
    MESSAGE_ACTION["COSMOS_GET_PUBLIC_KEY"] = "LedgerBridgeCosmosGetPublicKey";
    MESSAGE_ACTION["COSMOS_GET_PUBLIC_KEY_RESPONSE"] = "LedgerBridgeCosmosGetPublicKeyResponse";
    MESSAGE_ACTION["COSMOS_ESTIMATE_TX"] = "LedgerBridgeCosmosEstimateTx";
    MESSAGE_ACTION["COSMOS_ESTIMATE_TX_RESPONSE"] = "LedgerBridgeCosmosEstimateTxResponse";
})($a6f2e54b9428455f$export$24e6ff1ee090b133 || ($a6f2e54b9428455f$export$24e6ff1ee090b133 = {}));




var $aVMuR = parcelRequire("aVMuR");


var $aVMuR = parcelRequire("aVMuR");


/** `Object#toString` result references. */ var $c7e3abefa1453445$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c7e3abefa1453445$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value)) == "symbol" || (0, $3c1f5d97959b9e85$export$2e2bcd8739ae039)(value) && (0, $2388b19ca55899d6$export$2e2bcd8739ae039)(value) == $c7e3abefa1453445$var$symbolTag;
}
var $c7e3abefa1453445$export$2e2bcd8739ae039 = $c7e3abefa1453445$var$isSymbol;


/** Used to match property names within property paths. */ var $735222ea76668480$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $735222ea76668480$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $735222ea76668480$var$isKey(value, object) {
    if ((0, $a9aed815ffcf4575$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value);
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $c7e3abefa1453445$export$2e2bcd8739ae039)(value)) return true;
    return $735222ea76668480$var$reIsPlainProp.test(value) || !$735222ea76668480$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $735222ea76668480$export$2e2bcd8739ae039 = $735222ea76668480$var$isKey;



/* Built-in method references that are verified to be native. */ var $0632ea9ce37f03a5$var$nativeCreate = (0, $19388d40beae88b9$export$2e2bcd8739ae039)(Object, "create");
var $0632ea9ce37f03a5$export$2e2bcd8739ae039 = $0632ea9ce37f03a5$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $610af551a9cc3a84$var$hashClear() {
    this.__data__ = (0, $0632ea9ce37f03a5$export$2e2bcd8739ae039) ? (0, $0632ea9ce37f03a5$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $610af551a9cc3a84$export$2e2bcd8739ae039 = $610af551a9cc3a84$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4eabee078bfc675a$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $4eabee078bfc675a$export$2e2bcd8739ae039 = $4eabee078bfc675a$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $87ea3307592f0006$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $87ea3307592f0006$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $87ea3307592f0006$var$hasOwnProperty = $87ea3307592f0006$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $87ea3307592f0006$var$hashGet(key) {
    var data = this.__data__;
    if (0, $0632ea9ce37f03a5$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $87ea3307592f0006$var$HASH_UNDEFINED ? undefined : result;
    }
    return $87ea3307592f0006$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $87ea3307592f0006$export$2e2bcd8739ae039 = $87ea3307592f0006$var$hashGet;



/** Used for built-in method references. */ var $a70be7d6aba0d144$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a70be7d6aba0d144$var$hasOwnProperty = $a70be7d6aba0d144$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a70be7d6aba0d144$var$hashHas(key) {
    var data = this.__data__;
    return (0, $0632ea9ce37f03a5$export$2e2bcd8739ae039) ? data[key] !== undefined : $a70be7d6aba0d144$var$hasOwnProperty.call(data, key);
}
var $a70be7d6aba0d144$export$2e2bcd8739ae039 = $a70be7d6aba0d144$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $b7243268a078f7d4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $b7243268a078f7d4$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $0632ea9ce37f03a5$export$2e2bcd8739ae039) && value === undefined ? $b7243268a078f7d4$var$HASH_UNDEFINED : value;
    return this;
}
var $b7243268a078f7d4$export$2e2bcd8739ae039 = $b7243268a078f7d4$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d7777aa118ae943c$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$d7777aa118ae943c$var$Hash.prototype.clear = (0, $610af551a9cc3a84$export$2e2bcd8739ae039);
$d7777aa118ae943c$var$Hash.prototype["delete"] = (0, $4eabee078bfc675a$export$2e2bcd8739ae039);
$d7777aa118ae943c$var$Hash.prototype.get = (0, $87ea3307592f0006$export$2e2bcd8739ae039);
$d7777aa118ae943c$var$Hash.prototype.has = (0, $a70be7d6aba0d144$export$2e2bcd8739ae039);
$d7777aa118ae943c$var$Hash.prototype.set = (0, $b7243268a078f7d4$export$2e2bcd8739ae039);
var $d7777aa118ae943c$export$2e2bcd8739ae039 = $d7777aa118ae943c$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $01f317d4310ddb76$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $01f317d4310ddb76$export$2e2bcd8739ae039 = $01f317d4310ddb76$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $eed7864921d1fef6$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $eed7864921d1fef6$export$2e2bcd8739ae039 = $eed7864921d1fef6$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $782b6187d3575def$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $eed7864921d1fef6$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $782b6187d3575def$export$2e2bcd8739ae039 = $782b6187d3575def$var$assocIndexOf;


/** Used for built-in method references. */ var $10ff267fd9e30470$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $10ff267fd9e30470$var$splice = $10ff267fd9e30470$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $10ff267fd9e30470$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $782b6187d3575def$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $10ff267fd9e30470$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $10ff267fd9e30470$export$2e2bcd8739ae039 = $10ff267fd9e30470$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f3bb11de783caa07$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $782b6187d3575def$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $f3bb11de783caa07$export$2e2bcd8739ae039 = $f3bb11de783caa07$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $57fadd5bf1eadb35$var$listCacheHas(key) {
    return (0, $782b6187d3575def$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $57fadd5bf1eadb35$export$2e2bcd8739ae039 = $57fadd5bf1eadb35$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $f9685cfa9ef8aa87$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $782b6187d3575def$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $f9685cfa9ef8aa87$export$2e2bcd8739ae039 = $f9685cfa9ef8aa87$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0460399f01de1569$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0460399f01de1569$var$ListCache.prototype.clear = (0, $01f317d4310ddb76$export$2e2bcd8739ae039);
$0460399f01de1569$var$ListCache.prototype["delete"] = (0, $10ff267fd9e30470$export$2e2bcd8739ae039);
$0460399f01de1569$var$ListCache.prototype.get = (0, $f3bb11de783caa07$export$2e2bcd8739ae039);
$0460399f01de1569$var$ListCache.prototype.has = (0, $57fadd5bf1eadb35$export$2e2bcd8739ae039);
$0460399f01de1569$var$ListCache.prototype.set = (0, $f9685cfa9ef8aa87$export$2e2bcd8739ae039);
var $0460399f01de1569$export$2e2bcd8739ae039 = $0460399f01de1569$var$ListCache;



/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $173b5448264dee03$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $d7777aa118ae943c$export$2e2bcd8739ae039),
        "map": new ((0, $4256cc9d4cdece94$export$2e2bcd8739ae039) || (0, $0460399f01de1569$export$2e2bcd8739ae039)),
        "string": new (0, $d7777aa118ae943c$export$2e2bcd8739ae039)
    };
}
var $173b5448264dee03$export$2e2bcd8739ae039 = $173b5448264dee03$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $aVMuR = parcelRequire("aVMuR");
function $616d13ca100b1d28$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $aVMuR._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $616d13ca100b1d28$export$2e2bcd8739ae039 = $616d13ca100b1d28$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $308f1f80f9a5a2cd$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $616d13ca100b1d28$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $308f1f80f9a5a2cd$export$2e2bcd8739ae039 = $308f1f80f9a5a2cd$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d3ca6af6c4deaf86$var$mapCacheDelete(key) {
    var result = (0, $308f1f80f9a5a2cd$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $d3ca6af6c4deaf86$export$2e2bcd8739ae039 = $d3ca6af6c4deaf86$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5de6bcf718e55d41$var$mapCacheGet(key) {
    return (0, $308f1f80f9a5a2cd$export$2e2bcd8739ae039)(this, key).get(key);
}
var $5de6bcf718e55d41$export$2e2bcd8739ae039 = $5de6bcf718e55d41$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b1ffd7f5110e633c$var$mapCacheHas(key) {
    return (0, $308f1f80f9a5a2cd$export$2e2bcd8739ae039)(this, key).has(key);
}
var $b1ffd7f5110e633c$export$2e2bcd8739ae039 = $b1ffd7f5110e633c$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ec52bde202814dc8$var$mapCacheSet(key, value) {
    var data = (0, $308f1f80f9a5a2cd$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $ec52bde202814dc8$export$2e2bcd8739ae039 = $ec52bde202814dc8$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5eb3dd6229d15be3$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$5eb3dd6229d15be3$var$MapCache.prototype.clear = (0, $173b5448264dee03$export$2e2bcd8739ae039);
$5eb3dd6229d15be3$var$MapCache.prototype["delete"] = (0, $d3ca6af6c4deaf86$export$2e2bcd8739ae039);
$5eb3dd6229d15be3$var$MapCache.prototype.get = (0, $5de6bcf718e55d41$export$2e2bcd8739ae039);
$5eb3dd6229d15be3$var$MapCache.prototype.has = (0, $b1ffd7f5110e633c$export$2e2bcd8739ae039);
$5eb3dd6229d15be3$var$MapCache.prototype.set = (0, $ec52bde202814dc8$export$2e2bcd8739ae039);
var $5eb3dd6229d15be3$export$2e2bcd8739ae039 = $5eb3dd6229d15be3$var$MapCache;


/** Error message constants. */ var $6ed5d13877b63246$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $6ed5d13877b63246$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($6ed5d13877b63246$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($6ed5d13877b63246$var$memoize.Cache || (0, $5eb3dd6229d15be3$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$6ed5d13877b63246$var$memoize.Cache = (0, $5eb3dd6229d15be3$export$2e2bcd8739ae039);
var $6ed5d13877b63246$export$2e2bcd8739ae039 = $6ed5d13877b63246$var$memoize;


/** Used as the maximum memoize cache size. */ var $0222e0c193dc36c3$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $0222e0c193dc36c3$var$memoizeCapped(func) {
    var result = (0, $6ed5d13877b63246$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $0222e0c193dc36c3$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $0222e0c193dc36c3$export$2e2bcd8739ae039 = $0222e0c193dc36c3$var$memoizeCapped;


/** Used to match property names within property paths. */ var $0171a77700ad28fe$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $0171a77700ad28fe$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $0171a77700ad28fe$var$stringToPath = (0, $0222e0c193dc36c3$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($0171a77700ad28fe$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($0171a77700ad28fe$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $0171a77700ad28fe$export$2e2bcd8739ae039 = $0171a77700ad28fe$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $fdc8e31a038ed664$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $fdc8e31a038ed664$export$2e2bcd8739ae039 = $fdc8e31a038ed664$var$arrayMap;




/** Used as references for various `Number` constants. */ var $02614b8eef10c898$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $02614b8eef10c898$var$symbolProto = (0, $4e6c8393525faf38$export$2e2bcd8739ae039) ? (0, $4e6c8393525faf38$export$2e2bcd8739ae039).prototype : undefined, $02614b8eef10c898$var$symbolToString = $02614b8eef10c898$var$symbolProto ? $02614b8eef10c898$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $02614b8eef10c898$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $a9aed815ffcf4575$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $fdc8e31a038ed664$export$2e2bcd8739ae039)(value, $02614b8eef10c898$var$baseToString) + "";
    if ((0, $c7e3abefa1453445$export$2e2bcd8739ae039)(value)) return $02614b8eef10c898$var$symbolToString ? $02614b8eef10c898$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$02614b8eef10c898$var$INFINITY ? "-0" : result;
}
var $02614b8eef10c898$export$2e2bcd8739ae039 = $02614b8eef10c898$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $de44a95d6b0b04f9$var$toString(value) {
    return value == null ? "" : (0, $02614b8eef10c898$export$2e2bcd8739ae039)(value);
}
var $de44a95d6b0b04f9$export$2e2bcd8739ae039 = $de44a95d6b0b04f9$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4f870c9ac183a5f5$var$castPath(value, object) {
    if ((0, $a9aed815ffcf4575$export$2e2bcd8739ae039)(value)) return value;
    return (0, $735222ea76668480$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $0171a77700ad28fe$export$2e2bcd8739ae039)((0, $de44a95d6b0b04f9$export$2e2bcd8739ae039)(value));
}
var $4f870c9ac183a5f5$export$2e2bcd8739ae039 = $4f870c9ac183a5f5$var$castPath;



/** Used as references for various `Number` constants. */ var $d3056694d0200346$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $d3056694d0200346$var$toKey(value) {
    if (typeof value == "string" || (0, $c7e3abefa1453445$export$2e2bcd8739ae039)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$d3056694d0200346$var$INFINITY ? "-0" : result;
}
var $d3056694d0200346$export$2e2bcd8739ae039 = $d3056694d0200346$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ecfef6464ed5dda9$var$baseGet(object, path) {
    path = (0, $4f870c9ac183a5f5$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $d3056694d0200346$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $ecfef6464ed5dda9$export$2e2bcd8739ae039 = $ecfef6464ed5dda9$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $60e0bed0e769a9ac$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $ecfef6464ed5dda9$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $60e0bed0e769a9ac$export$2e2bcd8739ae039 = $60e0bed0e769a9ac$var$get;


var $f51a9bb25dd4376b$export$df222072c8a3b620 = /*#__PURE__*/ function() {
    "use strict";
    function LedgerBridge() {
        (0, $7dKN1._)(this, LedgerBridge);
        this._port = null;
        this._debug = false;
        window.addEventListener("message", this.handleInitMessage.bind(this));
    }
    (0, $eW5pA._)(LedgerBridge, [
        {
            key: "handleInitMessage",
            value: function handleInitMessage(param) {
                var data = param.data, ports = param.ports;
                if (data.action !== (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).INIT || data.target !== (0, $a6f2e54b9428455f$export$ba5e68c585df8eb6)) return;
                if (data.debug === true) this._debug = true;
                this.log("init");
                this._port = ports[0];
                this._port.addEventListener("message", this.handleBridgeMessage.bind(this));
                this._port.start();
                var message = {
                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).READY
                };
                this._port.postMessage(message);
            }
        },
        {
            key: "handleBridgeMessage",
            value: function handleBridgeMessage(param) {
                var data = param.data;
                this.log("handleBridgeMessage", data);
                switch(data.action){
                    case (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).GET_ADDRESSES:
                        return this.handleGetAddresses(data.appType, data.take, data.skip, data.options);
                    case (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).SIGN_MESSAGE:
                        return this.handleSignMessage(data.appType, data.fromAddress, data.message);
                    case (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).SIGN_TRANSACTION:
                        return this.handleSignTransaction(data.appType, data.fromAddress, data.serializedTx, data.options);
                    case (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).COSMOS_SEND_TOKENS:
                        return this.handleSendCosmosTokens(data.params);
                    case (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).COSMOS_ESTIMATE_TX:
                        return this.handleEstimateCosmosTx(data.params);
                    case (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).COSMOS_GET_PUBLIC_KEY:
                        return this.handleGetCosmosPublicKey(data.prefix, data.address);
                }
            }
        },
        {
            key: "closeTransport",
            value: // Note: 'transport' exists in SubstrateApp but isn't exposed in its TS definition
            function closeTransport(app) {
                return (0, $6rBFC._)(function() {
                    var transport, _tmp;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!(0, $f59e127e73eaefde$export$2e2bcd8739ae039)(app)) return [
                                    3,
                                    3
                                ];
                                if (app.signAmino) transport = (0, $60e0bed0e769a9ac$export$2e2bcd8739ae039)(app, "connector.app.transport");
                                else transport = (0, $60e0bed0e769a9ac$export$2e2bcd8739ae039)(app, "transport");
                                _tmp = transport;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    transport.close()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleGetAddresses",
            value: function handleGetAddresses(appType, take, skip, options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _this__port, message, app, addresses, i, n, _, addresses1, i1, n1, _1, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = {
                                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).ADDRESSES
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    14,
                                    ,
                                    15
                                ]);
                                if (!(appType === (0, $8bb522a9558f44ed$export$25e3fec1e3159119).ATOM)) return [
                                    3,
                                    7
                                ];
                                if (!(options === null || options === void 0 ? void 0 : options.cosmosHrp)) throw new Error("Missing cosmosHrp");
                                addresses = [];
                                i = skip, n = take + skip;
                                _state.label = 2;
                            case 2:
                                if (!(i < n)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$a152966866d4b2d1)(options.cosmosHrp, i)
                                ];
                            case 3:
                                app = _state.sent();
                                _ = addresses.push;
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$bd7a06763620ade5)(app, appType, i, options)
                                ];
                            case 4:
                                _.apply(addresses, [
                                    _state.sent()
                                ]);
                                _this.closeTransport(app);
                                _state.label = 5;
                            case 5:
                                i++;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                message.addresses = addresses;
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$acf12c24b766389a)(appType)
                                ];
                            case 8:
                                app = _state.sent();
                                addresses1 = [];
                                i1 = skip, n1 = take + skip;
                                _state.label = 9;
                            case 9:
                                if (!(i1 < n1)) return [
                                    3,
                                    12
                                ];
                                _1 = addresses1.push;
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$bd7a06763620ade5)(app, appType, i1, options)
                                ];
                            case 10:
                                _1.apply(addresses1, [
                                    _state.sent()
                                ]);
                                _state.label = 11;
                            case 11:
                                i1++;
                                return [
                                    3,
                                    9
                                ];
                            case 12:
                                message.addresses = addresses1;
                                _this.closeTransport(app);
                                _state.label = 13;
                            case 13:
                                return [
                                    3,
                                    15
                                ];
                            case 14:
                                error = _state.sent();
                                message.error = {
                                    message: error.message
                                };
                                return [
                                    3,
                                    15
                                ];
                            case 15:
                                _this.log("handleGetAddresses", message);
                                (_this__port = _this._port) === null || _this__port === void 0 ? void 0 : _this__port.postMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleSignMessage",
            value: function handleSignMessage(appType, fromAddress, messageToSign) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _this__port, message, app, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = {
                                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).SIGNATURE
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    5,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$acf12c24b766389a)(appType)
                                ];
                            case 2:
                                app = _state.sent();
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$1d9a7a8a40780de)(app, appType, fromAddress.hdPath, messageToSign)
                                ];
                            case 3:
                                message.signature = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                message.error = {
                                    message: error.message
                                };
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.closeTransport(app);
                                return [
                                    7
                                ];
                            case 6:
                                _this.log("handleSignMessage", message);
                                (_this__port = _this._port) === null || _this__port === void 0 ? void 0 : _this__port.postMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleSignTransaction",
            value: function handleSignTransaction(appType, fromAddress, serializedTx, options) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _this__port, message, app, cosmosHrp, cosmosApp, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = {
                                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).SIGNATURE
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    9,
                                    10,
                                    11
                                ]);
                                if (!(appType === (0, $8bb522a9558f44ed$export$25e3fec1e3159119).ATOM)) return [
                                    3,
                                    5
                                ];
                                cosmosHrp = (options || {}).cosmosHrp;
                                if (!cosmosHrp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$a152966866d4b2d1)(cosmosHrp, fromAddress.index)
                                ];
                            case 2:
                                cosmosApp = _state.sent();
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$6ad02cc4966b42ab)(cosmosApp, appType, fromAddress, serializedTx, options)
                                ];
                            case 3:
                                message.signature = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$acf12c24b766389a)(appType)
                                ];
                            case 6:
                                app = _state.sent();
                                if (!app) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$6ad02cc4966b42ab)(app, appType, fromAddress, serializedTx, options)
                                ];
                            case 7:
                                message.signature = _state.sent();
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                error = _state.sent();
                                message.error = {
                                    message: error.message
                                };
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                _this.closeTransport(app);
                                return [
                                    7
                                ];
                            case 11:
                                _this.log("handleSignTransaction", message);
                                (_this__port = _this._port) === null || _this__port === void 0 ? void 0 : _this__port.postMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleSendCosmosTokens",
            value: function handleSendCosmosTokens(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _this__port, message, prefix, index, app, response, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = {
                                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).COSMOS_SEND_TOKENS_RESPONSE
                                };
                                prefix = params.prefix, index = params.index;
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$a152966866d4b2d1)(prefix, index)
                                ];
                            case 1:
                                app = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    5,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$19333539a236307f)(app, params)
                                ];
                            case 3:
                                response = _state.sent();
                                if (typeof response === "string") message.hash = response;
                                else message.fee = {
                                    amount: response.amount,
                                    price: response.price
                                };
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                message.error = {
                                    message: error.message
                                };
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.closeTransport(app);
                                return [
                                    7
                                ];
                            case 6:
                                _this.log("handleSendCosmosTokens", message);
                                (_this__port = _this._port) === null || _this__port === void 0 ? void 0 : _this__port.postMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleEstimateCosmosTx",
            value: function handleEstimateCosmosTx(params) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _this__port, message, fromAddress, prefix, app, response, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = {
                                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).COSMOS_ESTIMATE_TX_RESPONSE
                                };
                                fromAddress = params.fromAddress, prefix = params.prefix;
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$a152966866d4b2d1)(prefix, fromAddress.index)
                                ];
                            case 1:
                                app = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    5,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$ba98d8cf93523b51)(app, params)
                                ];
                            case 3:
                                response = _state.sent();
                                message.fee = {
                                    amount: response.amount,
                                    price: response.price
                                };
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                message.error = {
                                    message: error.message
                                };
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.closeTransport(app);
                                return [
                                    7
                                ];
                            case 6:
                                _this.log("handleEstimateCosmosTx", message);
                                (_this__port = _this._port) === null || _this__port === void 0 ? void 0 : _this__port.postMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleGetCosmosPublicKey",
            value: function handleGetCosmosPublicKey(prefix, address) {
                var _this = this;
                return (0, $6rBFC._)(function() {
                    var _this__port, message, hdPath, index, app, key, error;
                    return (0, $6qu4b.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = {
                                    action: (0, $a6f2e54b9428455f$export$24e6ff1ee090b133).COSMOS_GET_PUBLIC_KEY_RESPONSE
                                };
                                hdPath = address.hdPath, index = address.index;
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$a152966866d4b2d1)(prefix, index)
                                ];
                            case 1:
                                app = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    5,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $8bb522a9558f44ed$export$4e7a4b992ea8deaf)(app)
                                ];
                            case 3:
                                key = _state.sent();
                                message.key = key;
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                console.error("error: ", error);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.closeTransport(app);
                                return [
                                    7
                                ];
                            case 6:
                                _this.log("handleGetCosmosPublicKey with message", message);
                                (_this__port = _this._port) === null || _this__port === void 0 ? void 0 : _this__port.postMessage(message);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "log",
            value: function log(label, data) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info";
                var _console;
                if (!this._debug) return;
                var args = [
                    "Hana LedgerBridge",
                    label
                ];
                if (!(0, $f59e127e73eaefde$export$2e2bcd8739ae039)(data)) args.push(data);
                (_console = console)[type].apply(_console, (0, $gF0bR._)(args));
            }
        }
    ]);
    return LedgerBridge;
}();


(0, $6rBFC._)(function() {
    return (0, $6qu4b.__generator)(this, function(_state) {
        new (0, $f51a9bb25dd4376b$export$df222072c8a3b620)();
        return [
            2
        ];
    });
})();

})();
//# sourceMappingURL=index.8795bb79.js.map
